/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 377);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(384);
} else {
  module.exports = require('./cjs/react.development.js');
}


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (false) {
  var ReactIs = require('react-is');

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(390)();
}


/***/ }),
/* 2 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export fetchJson */
/* unused harmony export sendEmail */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return assetsPath; });
/* unused harmony export getParameterByName */
/* unused harmony export objectToParameter */
/* unused harmony export parameterToObject */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return parseQueryString; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return getOrdinalSuffixWithElement; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_toNumber__ = __webpack_require__(160);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_toNumber___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_toNumber__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_split__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_split___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_split__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_get__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
var fetchJson=function fetchJson(url){var options=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return fetch(url,options).then(function(response){return response.json();});};var sendEmail=function sendEmail(data){var formId=arguments.length>1&&arguments[1]!==undefined?arguments[1]:Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_WEBSITE_NAME":"Laguna","REACT_APP_SERVICE":"https://api.lagunaproperty.com","REACT_APP_LAGUNA_PROPERTY_URL":"https://lagunaproperty.com","REACT_APP_LAGUNA_PROPERTY_BINTAN_URL":"http://bintan.lagunaproperty.com","REACT_APP_LAGUNA_PROPERTY_PHUKET_URL":"https://lagunaproperty.com","REACT_APP_LAGUNA_PROPERTY_LANGCO_URL":"http://www.lagunalangco.com","REACT_APP_CLOUDFRONT":"https://d3vqeivyse4uh3.cloudfront.net/www/lagunaproperty","REACT_APP_CLOUDFRONT_ASSET":"assets","REACT_APP_CLOUDFRONT_PREVIEW_TRIP":"preview-trip/assets","REACT_APP_CLOUDFRONT_PHUKET_LAGUNA_VILLAGE_RESIDENCES":"location/phuket/laguna-village-residences/assets","REACT_APP_CLOUDFRONT_PHUKET_LAGUNA_PARK2":"location/phuket/laguna-park-2/assets","REACT_APP_CLOUDFRONT_PHUKET_DUSIT_DELUXE_POOL_VILLA":"location/phuket/dusit-deluxe-pool-villa/assets","REACT_APP_CLOUDFRONT_PHUKET_SKYPARK":"location/phuket/skypark/assets","REACT_APP_CLOUDFRONT_LAGUNA_BEACHSIDE":"location/phuket/laguna-beachside/assets","REACT_APP_CLOUDFRONT_LAGUNA_SEASIDE_RESIDENCES":"location/phuket/laguna-seaside-residences/assets","REACT_APP_GOOGLE_RECAPTCHA":"6LcABWUUAAAAADKAjhB-QnE0hEQb39ZR9Aknbjy7"}).REACT_APP_FORVIZ_FORM_ID;var url=Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_WEBSITE_NAME":"Laguna","REACT_APP_SERVICE":"https://api.lagunaproperty.com","REACT_APP_LAGUNA_PROPERTY_URL":"https://lagunaproperty.com","REACT_APP_LAGUNA_PROPERTY_BINTAN_URL":"http://bintan.lagunaproperty.com","REACT_APP_LAGUNA_PROPERTY_PHUKET_URL":"https://lagunaproperty.com","REACT_APP_LAGUNA_PROPERTY_LANGCO_URL":"http://www.lagunalangco.com","REACT_APP_CLOUDFRONT":"https://d3vqeivyse4uh3.cloudfront.net/www/lagunaproperty","REACT_APP_CLOUDFRONT_ASSET":"assets","REACT_APP_CLOUDFRONT_PREVIEW_TRIP":"preview-trip/assets","REACT_APP_CLOUDFRONT_PHUKET_LAGUNA_VILLAGE_RESIDENCES":"location/phuket/laguna-village-residences/assets","REACT_APP_CLOUDFRONT_PHUKET_LAGUNA_PARK2":"location/phuket/laguna-park-2/assets","REACT_APP_CLOUDFRONT_PHUKET_DUSIT_DELUXE_POOL_VILLA":"location/phuket/dusit-deluxe-pool-villa/assets","REACT_APP_CLOUDFRONT_PHUKET_SKYPARK":"location/phuket/skypark/assets","REACT_APP_CLOUDFRONT_LAGUNA_BEACHSIDE":"location/phuket/laguna-beachside/assets","REACT_APP_CLOUDFRONT_LAGUNA_SEASIDE_RESIDENCES":"location/phuket/laguna-seaside-residences/assets","REACT_APP_GOOGLE_RECAPTCHA":"6LcABWUUAAAAADKAjhB-QnE0hEQb39ZR9Aknbjy7"}).REACT_APP_FORVIZ_FORM_HOST+"/forms/"+formId;var options={method:"POST",headers:{"Content-Type":"application/json"},body:JSON.stringify(data)};return fetchJson(url,options).then(function(res){console.log("sendEmail",res);if(__WEBPACK_IMPORTED_MODULE_3_lodash_get___default()(res,"data")==="success"){return true;}return false;});};var assetsPath=function assetsPath(key){var url="https://d3vqeivyse4uh3.cloudfront.net/www/lagunaproperty";if(key==="preview-trip"){return url+"/"+"preview-trip/assets";}if(key==="phuket-laguna-village-residences"){return url+"/"+"location/phuket/laguna-village-residences/assets";}if(key==="phuket-laguna-village-residences-dev"){return"/location/phuket/phuket-laguna-village-residences/assets";}if(key==="phuket-laguna-park-2"){return url+"/"+"location/phuket/laguna-park-2/assets";}if(key==="phuket-laguna-park-2-dev"){return url+"/location/phuket/laguna-park-2-dev/assets";}if(key==="laguna-beachside"){return url+"/"+"location/phuket/laguna-beachside/assets";}if(key==="laguna-beachside-dev"){return"/location/phuket/laguna-beachside/assets";}if(key==="laguna-seaside-residences"){return url+"/"+"location/phuket/laguna-seaside-residences/assets";}if(key==="laguna-seaside-residences-dev"){return"/location/phuket/laguna-seaside-residences/assets";}if(key==="phuket-skypark"){return url+"/"+"location/phuket/skypark/assets";}if(key==="phuket-skypark-dev"){return"/location/phuket/skypark/assets";}if(key==="phuket-dusit-deluxe-pool-villa"){return url+"/"+"location/phuket/dusit-deluxe-pool-villa/assets";}return url+"/"+"assets";};var getParameterByName=function getParameterByName(name){var url=arguments.length>1&&arguments[1]!==undefined?arguments[1]:"";if(!url)url=window.location.href;name=name.replace(/[[\]]/g,"\\$&");var regex=new RegExp("[?&]"+name+"(=([^&#]*)|&|#|$)"),results=regex.exec(url);if(!results)return null;if(!results[2])return"";return decodeURIComponent(results[2].replace(/\+/g," "));};var objectToParameter=function objectToParameter(obj){var str="";for(var key in obj){if(str!==""){str+="&";}str+=key+"="+encodeURIComponent(obj[key]);}return str;};var parameterToObject=function parameterToObject(){var search=window.location.search.substring(1);if(!search)return{};return JSON.parse('{"'+decodeURI(search).replace(/"/g,'\\"').replace(/&/g,'","').replace(/=/g,'":"')+'"}');};var parseQueryString=function parseQueryString(){var query=arguments.length>0&&arguments[0]!==undefined?arguments[0]:window.location.search.substring(1);var vars=query.split("&");var qs={};for(var i=0;i<vars.length;i+=1){var pair=vars[i].split("=");var key=decodeURIComponent(pair[0]);var value=decodeURIComponent(pair[1]);// If first entry with this name
if(typeof qs[key]==="undefined"){qs[key]=decodeURIComponent(value);// If second entry with this name
}else if(typeof qs[key]==="string"){var arr=[qs[key],decodeURIComponent(value)];qs[key]=arr;// If third or later entry with this name
}else{qs[key].push(decodeURIComponent(value));}}return qs;};var getOrdinalSuffixWithElement=function getOrdinalSuffixWithElement(txt){var splitTxt=__WEBPACK_IMPORTED_MODULE_2_lodash_split___default()(txt," ");var number=__WEBPACK_IMPORTED_MODULE_1_lodash_toNumber___default()(splitTxt[0]);console.log("getOrdinalSuffix",splitTxt);if(!/[0-9]/.test(number))return txt;var j=number%10;var k=number%100;var ordinal="th";if(j===1&&k!==11){ordinal="st";}if(j===2&&k!==12){ordinal="nd";}if(j===3&&k!==13){ordinal="rd";}// return `${num} ${ordinal} ${str}`;
// console.log("splitTxt", splitTxt);
return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",{style:{display:"flex",flexDirection:"row",justifyContent:"center"}},number,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("sup",{style:{fontSize:"10px",textTransform:"none"}},""+ordinal),"\xA0",__WEBPACK_IMPORTED_MODULE_0_lodash_map___default()(splitTxt,function(i,k){if(k>=2){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span",null,""+i,"\xA0");}return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("span",null);}));};// const withOrdinalSuffix = (num) => {
//   const number = _.toNumber(num);
//   if (!/[0-9]/.test(number)) return num;
//   const j = number % 10;
//   const k = number % 100;
//   if (j === 1 && k !== 11) {
//     return `${number}st`;
//   }
//   if (j === 2 && k !== 12) {
//     return `${number}nd`;
//   }
//   if (j === 3 && k !== 13) {
//     return `${number}rd`;
//   }
//   return `${number}th`;
// };


/***/ }),
/* 3 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__withRedux__ = __webpack_require__(491);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_0__withRedux__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__multiLanguage__ = __webpack_require__(492);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__multiLanguage__["a"]; });


/***/ }),
/* 4 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Concept__ = __webpack_require__(790);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__Concept__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Destination__ = __webpack_require__(791);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_1__Destination__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Ebrochure__ = __webpack_require__(822);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_2__Ebrochure__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Faq__ = __webpack_require__(823);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__Faq__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Gallery__ = __webpack_require__(824);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_4__Gallery__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Residences__ = __webpack_require__(850);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_5__Residences__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__TheSanctuaryclub__ = __webpack_require__(851);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_6__TheSanctuaryclub__["a"]; });
// export { default as Masterplan } from "./Masterplan";
// export { default as Siteplan } from "./Siteplan";


/***/ }),
/* 5 */
/***/ (function(module, exports) {

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}
module.exports = _interopRequireDefault, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 6 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ScrollToTop__ = __webpack_require__(428);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "o", function() { return __WEBPACK_IMPORTED_MODULE_0__ScrollToTop__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Image__ = __webpack_require__(230);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_1__Image__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Logo__ = __webpack_require__(490);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_2__Logo__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__LanguageSwitcher__ = __webpack_require__(252);
/* unused harmony reexport LanguageSwitcher */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Modal__ = __webpack_require__(500);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_4__Modal__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Slider__ = __webpack_require__(267);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "p", function() { return __WEBPACK_IMPORTED_MODULE_5__Slider__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Footer__ = __webpack_require__(535);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_6__Footer__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Header__ = __webpack_require__(720);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_7__Header__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Button__ = __webpack_require__(76);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_8__Button__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__BackgroundImage__ = __webpack_require__(314);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_9__BackgroundImage__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__ButtonGroup__ = __webpack_require__(199);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_10__ButtonGroup__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__LoadingSlider__ = __webpack_require__(734);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_11__LoadingSlider__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__SliderWithLoading__ = __webpack_require__(735);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "q", function() { return __WEBPACK_IMPORTED_MODULE_12__SliderWithLoading__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ButtonScrollToSection__ = __webpack_require__(736);
/* unused harmony reexport ButtonScrollToSection */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__NewsArticleCard__ = __webpack_require__(738);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_14__NewsArticleCard__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__NewsArticleSummary__ = __webpack_require__(318);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_15__NewsArticleSummary__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__GradientPage__ = __webpack_require__(739);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_16__GradientPage__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__InputField__ = __webpack_require__(743);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_17__InputField__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__PrivacyPolicy__ = __webpack_require__(746);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_18__PrivacyPolicy__["a"]; });


/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(96);

/**
 * Gets the value at `path` of `object`. If the resolved value is
 * `undefined`, the `defaultValue` is returned in its place.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @param {*} [defaultValue] The value returned for `undefined` resolved values.
 * @returns {*} Returns the resolved value.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.get(object, 'a[0].b.c');
 * // => 3
 *
 * _.get(object, ['a', '0', 'b', 'c']);
 * // => 3
 *
 * _.get(object, 'a.b.c', 'default');
 * // => 'default'
 */
function get(object, path, defaultValue) {
  var result = object == null ? undefined : baseGet(object, path);
  return result === undefined ? defaultValue : result;
}

module.exports = get;


/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(69),
    baseIteratee = __webpack_require__(36),
    baseMap = __webpack_require__(249),
    isArray = __webpack_require__(13);

/**
 * Creates an array of values by running each element in `collection` thru
 * `iteratee`. The iteratee is invoked with three arguments:
 * (value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
 *
 * The guarded methods are:
 * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
 * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
 * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
 * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * _.map([4, 8], square);
 * // => [16, 64]
 *
 * _.map({ 'a': 4, 'b': 8 }, square);
 * // => [16, 64] (iteration order is not guaranteed)
 *
 * var users = [
 *   { 'user': 'barney' },
 *   { 'user': 'fred' }
 * ];
 *
 * // The `_.property` iteratee shorthand.
 * _.map(users, 'user');
 * // => ['barney', 'fred']
 */
function map(collection, iteratee) {
  var func = isArray(collection) ? arrayMap : baseMap;
  return func(collection, baseIteratee(iteratee, 3));
}

module.exports = map;


/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 10 */
/***/ (function(module, exports) {

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}
module.exports = _classCallCheck, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

var toPropertyKey = __webpack_require__(336);
function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, toPropertyKey(descriptor.key), descriptor);
  }
}
function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  Object.defineProperty(Constructor, "prototype", {
    writable: false
  });
  return Constructor;
}
module.exports = _createClass, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(136)["default"];
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
module.exports = _interopRequireWildcard, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 13 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is classified as an `Array` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array, else `false`.
 * @example
 *
 * _.isArray([1, 2, 3]);
 * // => true
 *
 * _.isArray(document.body.children);
 * // => false
 *
 * _.isArray('abc');
 * // => false
 *
 * _.isArray(_.noop);
 * // => false
 */
var isArray = Array.isArray;

module.exports = isArray;


/***/ }),
/* 14 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(136)["default"];
var assertThisInitialized = __webpack_require__(15);
function _possibleConstructorReturn(self, call) {
  if (call && (_typeof(call) === "object" || typeof call === "function")) {
    return call;
  } else if (call !== void 0) {
    throw new TypeError("Derived constructors may only return object or undefined");
  }
  return assertThisInitialized(self);
}
module.exports = _possibleConstructorReturn, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 15 */
/***/ (function(module, exports) {

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}
module.exports = _assertThisInitialized, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 16 */
/***/ (function(module, exports) {

function _getPrototypeOf(o) {
  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _getPrototypeOf(o);
}
module.exports = _getPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

var setPrototypeOf = __webpack_require__(833);
function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }
  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  Object.defineProperty(subClass, "prototype", {
    writable: false
  });
  if (superClass) setPrototypeOf(subClass, superClass);
}
module.exports = _inherits, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 18 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return SWITCH_LANGUAGE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return SWITCH_LOCATION; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHECK_MOBILE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return RECEIVE_LAGUNA_BEACHSIDE; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return RECEIVE_LAGUNA_SEASIDE_RESIDENCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return RECEIVE_PHUKET_SKYPARK; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return RECEIVE_PHUKET_LAGUNA_PARK_2; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return RECEIVE_PHUKET_LAGUNA_VILLAGE_RESIDENCES; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return RECEIVE_PHUKET_DUSIT_DELUXE_POOL_VILLA; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return RECEIVE_PREVIEW_TRIP; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RECEIVE_HOME; });
var SWITCH_LANGUAGE="SWITCH_LANGUAGE";var SWITCH_LOCATION="SWITCH_LOCATION";var CHECK_MOBILE="CHECK_MOBILE";var RECEIVE_LAGUNA_BEACHSIDE="RECEIVE_LAGUNA_BEACHSIDE";var RECEIVE_LAGUNA_SEASIDE_RESIDENCES="RECEIVE_LAGUNA_SEASIDE_RESIDENCES";var RECEIVE_PHUKET_SKYPARK="RECEIVE_PHUKET_SKYPARK";var RECEIVE_PHUKET_LAGUNA_PARK_2="RECEIVE_PHUKET_LAGUNA_PARK_2";var RECEIVE_PHUKET_LAGUNA_VILLAGE_RESIDENCES="RECEIVE_PHUKET_LAGUNA_VILLAGE_RESIDENCES";var RECEIVE_PHUKET_DUSIT_DELUXE_POOL_VILLA="RECEIVE_PHUKET_DUSIT_DELUXE_POOL_VILLA";var RECEIVE_PREVIEW_TRIP="RECEIVE_PREVIEW_TRIP";var RECEIVE_HOME="RECEIVE_HOME";

/***/ }),
/* 19 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

exports.convertFieldsError = convertFieldsError;
exports.format = format;
exports.isEmptyValue = isEmptyValue;
exports.isEmptyObject = isEmptyObject;
exports.asyncMap = asyncMap;
exports.complementError = complementError;
exports.deepMerge = deepMerge;
/* eslint no-console:0 */

var formatRegExp = /%[sdj%]/g;

var warning = exports.warning = function warning() {};

// don't print warning message when in production env or node runtime
if (false) {
  exports.warning = warning = function warning(type, errors) {
    if (typeof console !== 'undefined' && console.warn) {
      if (errors.every(function (e) {
        return typeof e === 'string';
      })) {
        console.warn(type, errors);
      }
    }
  };
}

function convertFieldsError(errors) {
  if (!errors || !errors.length) return null;
  var fields = {};
  errors.forEach(function (error) {
    var field = error.field;
    fields[field] = fields[field] || [];
    fields[field].push(error);
  });
  return fields;
}

function format() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var i = 1;
  var f = args[0];
  var len = args.length;
  if (typeof f === 'function') {
    return f.apply(null, args.slice(1));
  }
  if (typeof f === 'string') {
    var str = String(f).replace(formatRegExp, function (x) {
      if (x === '%%') {
        return '%';
      }
      if (i >= len) {
        return x;
      }
      switch (x) {
        case '%s':
          return String(args[i++]);
        case '%d':
          return Number(args[i++]);
        case '%j':
          try {
            return JSON.stringify(args[i++]);
          } catch (_) {
            return '[Circular]';
          }
          break;
        default:
          return x;
      }
    });
    for (var arg = args[i]; i < len; arg = args[++i]) {
      str += ' ' + arg;
    }
    return str;
  }
  return f;
}

function isNativeStringType(type) {
  return type === 'string' || type === 'url' || type === 'hex' || type === 'email' || type === 'pattern';
}

function isEmptyValue(value, type) {
  if (value === undefined || value === null) {
    return true;
  }
  if (type === 'array' && Array.isArray(value) && !value.length) {
    return true;
  }
  if (isNativeStringType(type) && typeof value === 'string' && !value) {
    return true;
  }
  return false;
}

function isEmptyObject(obj) {
  return Object.keys(obj).length === 0;
}

function asyncParallelArray(arr, func, callback) {
  var results = [];
  var total = 0;
  var arrLength = arr.length;

  function count(errors) {
    results.push.apply(results, errors);
    total++;
    if (total === arrLength) {
      callback(results);
    }
  }

  arr.forEach(function (a) {
    func(a, count);
  });
}

function asyncSerialArray(arr, func, callback) {
  var index = 0;
  var arrLength = arr.length;

  function next(errors) {
    if (errors && errors.length) {
      callback(errors);
      return;
    }
    var original = index;
    index = index + 1;
    if (original < arrLength) {
      func(arr[original], next);
    } else {
      callback([]);
    }
  }

  next([]);
}

function flattenObjArr(objArr) {
  var ret = [];
  Object.keys(objArr).forEach(function (k) {
    ret.push.apply(ret, objArr[k]);
  });
  return ret;
}

function asyncMap(objArr, option, func, callback) {
  if (option.first) {
    var flattenArr = flattenObjArr(objArr);
    return asyncSerialArray(flattenArr, func, callback);
  }
  var firstFields = option.firstFields || [];
  if (firstFields === true) {
    firstFields = Object.keys(objArr);
  }
  var objArrKeys = Object.keys(objArr);
  var objArrLength = objArrKeys.length;
  var total = 0;
  var results = [];
  var pending = new Promise(function (resolve, reject) {
    var next = function next(errors) {
      results.push.apply(results, errors);
      total++;
      if (total === objArrLength) {
        callback(results);
        return results.length ? reject({ errors: results, fields: convertFieldsError(results) }) : resolve();
      }
    };
    objArrKeys.forEach(function (key) {
      var arr = objArr[key];
      if (firstFields.indexOf(key) !== -1) {
        asyncSerialArray(arr, func, next);
      } else {
        asyncParallelArray(arr, func, next);
      }
    });
  });
  pending['catch'](function (e) {
    return e;
  });
  return pending;
}

function complementError(rule) {
  return function (oe) {
    if (oe && oe.message) {
      oe.field = oe.field || rule.fullField;
      return oe;
    }
    return {
      message: typeof oe === 'function' ? oe() : oe,
      field: oe.field || rule.fullField
    };
  };
}

function deepMerge(target, source) {
  if (source) {
    for (var s in source) {
      if (source.hasOwnProperty(s)) {
        var value = source[s];
        if ((typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && _typeof(target[s]) === 'object') {
          target[s] = _extends({}, target[s], value);
        } else {
          target[s] = value;
        }
      }
    }
  }
  return target;
}

/***/ }),
/* 20 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _ParallaxProvider = __webpack_require__(740);

Object.defineProperty(exports, 'ParallaxProvider', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_ParallaxProvider).default;
  }
});

var _Parallax = __webpack_require__(742);

Object.defineProperty(exports, 'Parallax', {
  enumerable: true,
  get: function get() {
    return _interopRequireDefault(_Parallax).default;
  }
});

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ }),
/* 21 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = "production" !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  }

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

module.exports = warning;


/***/ }),
/* 22 */
/***/ (function(module, exports, __webpack_require__) {

var createFind = __webpack_require__(493),
    findIndex = __webpack_require__(100);

/**
 * Iterates over elements of `collection`, returning the first element
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {*} Returns the matched element, else `undefined`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36, 'active': true },
 *   { 'user': 'fred',    'age': 40, 'active': false },
 *   { 'user': 'pebbles', 'age': 1,  'active': true }
 * ];
 *
 * _.find(users, function(o) { return o.age < 40; });
 * // => object for 'barney'
 *
 * // The `_.matches` iteratee shorthand.
 * _.find(users, { 'age': 1, 'active': true });
 * // => object for 'pebbles'
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.find(users, ['active', false]);
 * // => object for 'fred'
 *
 * // The `_.property` iteratee shorthand.
 * _.find(users, 'active');
 * // => object for 'barney'
 */
var find = createFind(findIndex);

module.exports = find;


/***/ }),
/* 23 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.Helpers = exports.ScrollElement = exports.ScrollLink = exports.animateScroll = exports.scrollSpy = exports.Events = exports.scroller = exports.Element = exports.Button = exports.Link = undefined;

var _Link = __webpack_require__(725);

var _Link2 = _interopRequireDefault(_Link);

var _Button = __webpack_require__(729);

var _Button2 = _interopRequireDefault(_Button);

var _Element = __webpack_require__(730);

var _Element2 = _interopRequireDefault(_Element);

var _scroller = __webpack_require__(134);

var _scroller2 = _interopRequireDefault(_scroller);

var _scrollEvents = __webpack_require__(197);

var _scrollEvents2 = _interopRequireDefault(_scrollEvents);

var _scrollSpy = __webpack_require__(195);

var _scrollSpy2 = _interopRequireDefault(_scrollSpy);

var _animateScroll = __webpack_require__(310);

var _animateScroll2 = _interopRequireDefault(_animateScroll);

var _scrollLink = __webpack_require__(194);

var _scrollLink2 = _interopRequireDefault(_scrollLink);

var _scrollElement = __webpack_require__(312);

var _scrollElement2 = _interopRequireDefault(_scrollElement);

var _Helpers = __webpack_require__(731);

var _Helpers2 = _interopRequireDefault(_Helpers);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.Link = _Link2.default;
exports.Button = _Button2.default;
exports.Element = _Element2.default;
exports.scroller = _scroller2.default;
exports.Events = _scrollEvents2.default;
exports.scrollSpy = _scrollSpy2.default;
exports.animateScroll = _animateScroll2.default;
exports.ScrollLink = _scrollLink2.default;
exports.ScrollElement = _scrollElement2.default;
exports.Helpers = _Helpers2.default;
exports.default = { Link: _Link2.default, Button: _Button2.default, Element: _Element2.default, scroller: _scroller2.default, Events: _scrollEvents2.default, scrollSpy: _scrollSpy2.default, animateScroll: _animateScroll2.default, ScrollLink: _scrollLink2.default, ScrollElement: _scrollElement2.default, Helpers: _Helpers2.default };

/***/ }),
/* 24 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
  Copyright (c) 2017 Jed Watson.
  Licensed under the MIT License (MIT), see
  http://jedwatson.github.io/classnames
*/
/* global define */

(function () {
	'use strict';

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = [];

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (!arg) continue;

			var argType = typeof arg;

			if (argType === 'string' || argType === 'number') {
				classes.push(arg);
			} else if (Array.isArray(arg) && arg.length) {
				var inner = classNames.apply(null, arg);
				if (inner) {
					classes.push(inner);
				}
			} else if (argType === 'object') {
				for (var key in arg) {
					if (hasOwn.call(arg, key) && arg[key]) {
						classes.push(key);
					}
				}
			}
		}

		return classes.join(' ');
	}

	if (typeof module !== 'undefined' && module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else if (true) {
		// register as 'classnames', consistent with npm package name
		!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
			return classNames;
		}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
	} else {
		window.classNames = classNames;
	}
}());


/***/ }),
/* 25 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _required = __webpack_require__(300);

var _required2 = _interopRequireDefault(_required);

var _whitespace = __webpack_require__(666);

var _whitespace2 = _interopRequireDefault(_whitespace);

var _type = __webpack_require__(667);

var _type2 = _interopRequireDefault(_type);

var _range = __webpack_require__(668);

var _range2 = _interopRequireDefault(_range);

var _enum = __webpack_require__(669);

var _enum2 = _interopRequireDefault(_enum);

var _pattern = __webpack_require__(670);

var _pattern2 = _interopRequireDefault(_pattern);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  required: _required2['default'],
  whitespace: _whitespace2['default'],
  type: _type2['default'],
  range: _range2['default'],
  'enum': _enum2['default'],
  pattern: _pattern2['default']
};

/***/ }),
/* 26 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return value != null && typeof value == 'object';
}

module.exports = isObjectLike;


/***/ }),
/* 27 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process, module) {/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return css; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return keyframes; });
/* unused harmony export injectGlobal */
/* unused harmony export isStyledComponent */
/* unused harmony export consolidateStreamedStyles */
/* unused harmony export ThemeProvider */
/* unused harmony export withTheme */
/* unused harmony export ServerStyleSheet */
/* unused harmony export StyleSheetManager */
/* unused harmony export __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_hyphenateStyleName__ = __webpack_require__(517);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_hyphenateStyleName___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_fbjs_lib_hyphenateStyleName__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stylis__ = __webpack_require__(519);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_stylis___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_stylis__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_stylis_rule_sheet__ = __webpack_require__(520);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_stylis_rule_sheet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_stylis_rule_sheet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_is__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_is__);








var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
  return typeof obj;
} : function (obj) {
  return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
};

var classCallCheck = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

var createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _extends = Object.assign || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

var inherits = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
};

var objectWithoutProperties = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

var possibleConstructorReturn = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
};

// 
var isPlainObject = (function (x) {
  return (typeof x === 'undefined' ? 'undefined' : _typeof(x)) === 'object' && x.constructor === Object;
});

// 


/**
 * Parse errors.md and turn it into a simple hash of code: message
 */
var ERRORS =  false ? {
  "1": "Cannot create styled-component for component: %s.\n\n",
  "2": "Can't collect styles once you've consumed a `ServerStyleSheet`'s styles! `ServerStyleSheet` is a one off instance for each server-side render cycle.\n\n* Are you trying to reuse it across renders?\n* Are you accidentally calling collectStyles twice?\n\n",
  "3": "Streaming SSR is only supported in a Node.js environment; Please do not try to call this method in the browser.\n\n",
  "4": "The `StyleSheetManager` expects a valid target or sheet prop!\n\n* Does this error occur on the client and is your target falsy?\n* Does this error occur on the server and is the sheet falsy?\n\n",
  "5": "The clone method cannot be used on the client!\n\n* Are you running in a client-like environment on the server?\n* Are you trying to run SSR on the client?\n\n",
  "6": "Trying to insert a new style tag, but the given Node is unmounted!\n\n* Are you using a custom target that isn't mounted?\n* Does your document not have a valid head element?\n* Have you accidentally removed a style tag manually?\n\n",
  "7": "ThemeProvider: Please return an object from your \"theme\" prop function, e.g.\n\n```js\ntheme={() => ({})}\n```\n\n",
  "8": "ThemeProvider: Please make your \"theme\" prop an object.\n\n",
  "9": "Missing document `<head>`\n\n",
  "10": "Cannot find a StyleSheet instance. Usually this happens if there are multiple copies of styled-components loaded at once. Check out this issue for how to troubleshoot and fix the common cases where this situation can happen: https://github.com/styled-components/styled-components/issues/1941#issuecomment-417862021\n\n",
  "11": "A plain React class (%s) has been interpolated into styles, probably as a component selector (https://www.styled-components.com/docs/advanced#referring-to-other-components). Only styled-component classes can be targeted in this fashion."
} : {};

/**
 * super basic version of sprintf
 */
function format() {
  for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var a = args[0];
  var b = [];
  var c = void 0;

  for (c = 1; c < args.length; c += 1) {
    b.push(args[c]);
  }

  b.forEach(function (d) {
    a = a.replace(/%[a-z]/, d);
  });

  return a;
}

/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 */

var StyledComponentsError = function (_Error) {
  inherits(StyledComponentsError, _Error);

  function StyledComponentsError(code) {
    classCallCheck(this, StyledComponentsError);

    for (var _len2 = arguments.length, interpolations = Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      interpolations[_key2 - 1] = arguments[_key2];
    }

    if (true) {
      var _this = possibleConstructorReturn(this, _Error.call(this, 'An error occurred. See https://github.com/styled-components/styled-components/blob/master/src/utils/errors.md#' + code + ' for more information. ' + (interpolations ? 'Additional arguments: ' + interpolations.join(', ') : '')));
    } else {
      var _this = possibleConstructorReturn(this, _Error.call(this, format.apply(undefined, [ERRORS[code]].concat(interpolations))));
    }
    return possibleConstructorReturn(_this);
  }

  return StyledComponentsError;
}(Error);

// 

var objToCss = function objToCss(obj, prevKey) {
  var css = Object.keys(obj).filter(function (key) {
    var chunk = obj[key];
    return chunk !== undefined && chunk !== null && chunk !== false && chunk !== '';
  }).map(function (key) {
    if (isPlainObject(obj[key])) return objToCss(obj[key], key);
    return __WEBPACK_IMPORTED_MODULE_0_fbjs_lib_hyphenateStyleName___default()(key) + ': ' + obj[key] + ';';
  }).join(' ');
  return prevKey ? prevKey + ' {\n  ' + css + '\n}' : css;
};

var flatten = function flatten(chunks, executionContext) {
  return chunks.reduce(function (ruleSet, chunk) {
    /* Remove falsey values */
    if (chunk === undefined || chunk === null || chunk === false || chunk === '') {
      return ruleSet;
    }

    /* Flatten ruleSet */
    if (Array.isArray(chunk)) {
      ruleSet.push.apply(ruleSet, flatten(chunk, executionContext));
      return ruleSet;
    }

    /* Handle other components */
    if (chunk.hasOwnProperty('styledComponentId')) {
      // $FlowFixMe not sure how to make this pass
      ruleSet.push('.' + chunk.styledComponentId);
      return ruleSet;
    }

    /* Either execute or defer the function */
    if (typeof chunk === 'function') {
      if (executionContext) {
        var nextChunk = chunk(executionContext);
        /* Throw if a React Element was given styles */
        if (__WEBPACK_IMPORTED_MODULE_1_react___default.a.isValidElement(nextChunk)) {
          var elementName = chunk.displayName || chunk.name;
          throw new StyledComponentsError(11, elementName);
        }
        ruleSet.push.apply(ruleSet, flatten([nextChunk], executionContext));
      } else ruleSet.push(chunk);

      return ruleSet;
    }

    /* Handle objects */
    ruleSet.push(
    // $FlowFixMe have to add %checks somehow to isPlainObject
    isPlainObject(chunk) ? objToCss(chunk) : chunk.toString());

    return ruleSet;
  }, []);
};

// 

var COMMENT_REGEX = /^\s*\/\/.*$/gm;

// NOTE: This stylis instance is only used to split rules from SSR'd style tags
var stylisSplitter = new __WEBPACK_IMPORTED_MODULE_2_stylis___default.a({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: false,
  compress: false,
  semicolon: true
});

var stylis = new __WEBPACK_IMPORTED_MODULE_2_stylis___default.a({
  global: false,
  cascade: true,
  keyframe: false,
  prefix: true,
  compress: false,
  semicolon: false // NOTE: This means "autocomplete missing semicolons"
});

// Wrap `insertRulePlugin to build a list of rules,
// and then make our own plugin to return the rules. This
// makes it easier to hook into the existing SSR architecture

var parsingRules = [];
// eslint-disable-next-line consistent-return
var returnRulesPlugin = function returnRulesPlugin(context) {
  if (context === -2) {
    var parsedRules = parsingRules;
    parsingRules = [];
    return parsedRules;
  }
};

var parseRulesPlugin = __WEBPACK_IMPORTED_MODULE_3_stylis_rule_sheet___default()(function (rule) {
  parsingRules.push(rule);
});

stylis.use([parseRulesPlugin, returnRulesPlugin]);
stylisSplitter.use([parseRulesPlugin, returnRulesPlugin]);

var stringifyRules = function stringifyRules(rules, selector, prefix) {
  var flatCSS = rules.join('').replace(COMMENT_REGEX, ''); // replace JS comments

  var cssStr = selector && prefix ? prefix + ' ' + selector + ' { ' + flatCSS + ' }' : flatCSS;

  return stylis(prefix || !selector ? '' : selector, cssStr);
};

var splitByRules = function splitByRules(css) {
  return stylisSplitter('', css);
};

// 

function isStyledComponent(target) /* : %checks */{
  return (
    // $FlowFixMe TODO: flow for styledComponentId
    typeof target === 'function' && typeof target.styledComponentId === 'string'
  );
}

// 

/* This function is DEPRECATED and will be removed on the next major version release.
 * It was needed to rehydrate all style blocks prepended to chunks before React
 * tries to rehydrate its HTML stream. Since the master StyleSheet will now detect
 * the use of streamed style tags and will perform the rehydration earlier when needed
 * this function will not be needed anymore */
function consolidateStreamedStyles() {
  if (false) {
    // eslint-disable-next-line no-console
    console.warn('styled-components automatically does streaming SSR rehydration now.\n' + 'Calling consolidateStreamedStyles manually is no longer necessary and a noop now.\n' + '- Please remove the consolidateStreamedStyles call from your client.');
  }
}

// 
/* eslint-disable no-bitwise */

/* This is the "capacity" of our alphabet i.e. 2x26 for all letters plus their capitalised
 * counterparts */
var charsLength = 52;

/* start at 75 for 'a' until 'z' (25) and then start at 65 for capitalised letters */
var getAlphabeticChar = function getAlphabeticChar(code) {
  return String.fromCharCode(code + (code > 25 ? 39 : 97));
};

/* input a number, usually a hash and convert it to base-52 */
var generateAlphabeticName = function generateAlphabeticName(code) {
  var name = '';
  var x = void 0;

  /* get a char and divide by alphabet-length */
  for (x = code; x > charsLength; x = Math.floor(x / charsLength)) {
    name = getAlphabeticChar(x % charsLength) + name;
  }

  return getAlphabeticChar(x % charsLength) + name;
};

// 

var interleave = (function (strings, interpolations) {
  var result = [strings[0]];

  for (var i = 0, len = interpolations.length; i < len; i += 1) {
    result.push(interpolations[i], strings[i + 1]);
  }

  return result;
});

// 
var EMPTY_ARRAY = Object.freeze([]);
var EMPTY_OBJECT = Object.freeze({});

// 

var css = (function (styles) {
  for (var _len = arguments.length, interpolations = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    interpolations[_key - 1] = arguments[_key];
  }

  if (typeof styles === 'function' || isPlainObject(styles)) {
    // $FlowFixMe
    return flatten(interleave(EMPTY_ARRAY, [styles].concat(interpolations)));
  }

  // $FlowFixMe
  return flatten(interleave(styles, interpolations));
});

// 


var SC_ATTR = typeof process !== 'undefined' && Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_WEBSITE_NAME":"Laguna","REACT_APP_SERVICE":"https://api.lagunaproperty.com","REACT_APP_LAGUNA_PROPERTY_URL":"https://lagunaproperty.com","REACT_APP_LAGUNA_PROPERTY_BINTAN_URL":"http://bintan.lagunaproperty.com","REACT_APP_LAGUNA_PROPERTY_PHUKET_URL":"https://lagunaproperty.com","REACT_APP_LAGUNA_PROPERTY_LANGCO_URL":"http://www.lagunalangco.com","REACT_APP_CLOUDFRONT":"https://d3vqeivyse4uh3.cloudfront.net/www/lagunaproperty","REACT_APP_CLOUDFRONT_ASSET":"assets","REACT_APP_CLOUDFRONT_PREVIEW_TRIP":"preview-trip/assets","REACT_APP_CLOUDFRONT_PHUKET_LAGUNA_VILLAGE_RESIDENCES":"location/phuket/laguna-village-residences/assets","REACT_APP_CLOUDFRONT_PHUKET_LAGUNA_PARK2":"location/phuket/laguna-park-2/assets","REACT_APP_CLOUDFRONT_PHUKET_DUSIT_DELUXE_POOL_VILLA":"location/phuket/dusit-deluxe-pool-villa/assets","REACT_APP_CLOUDFRONT_PHUKET_SKYPARK":"location/phuket/skypark/assets","REACT_APP_CLOUDFRONT_LAGUNA_BEACHSIDE":"location/phuket/laguna-beachside/assets","REACT_APP_CLOUDFRONT_LAGUNA_SEASIDE_RESIDENCES":"location/phuket/laguna-seaside-residences/assets","REACT_APP_GOOGLE_RECAPTCHA":"6LcABWUUAAAAADKAjhB-QnE0hEQb39ZR9Aknbjy7"}).SC_ATTR || 'data-styled-components';
var SC_STREAM_ATTR = 'data-styled-streamed';
var CONTEXT_KEY = '__styled-components-stylesheet__';

var IS_BROWSER = typeof window !== 'undefined' && 'HTMLElement' in window;

var DISABLE_SPEEDY = "production" !== 'production';

// 
var SC_COMPONENT_ID = /^[^\S\n]*?\/\* sc-component-id:\s*(\S+)\s+\*\//gm;

var extractComps = (function (maybeCSS) {
  var css = '' + (maybeCSS || ''); // Definitely a string, and a clone
  var existingComponents = [];
  css.replace(SC_COMPONENT_ID, function (match, componentId, matchIndex) {
    existingComponents.push({ componentId: componentId, matchIndex: matchIndex });
    return match;
  });
  return existingComponents.map(function (_ref, i) {
    var componentId = _ref.componentId,
        matchIndex = _ref.matchIndex;

    var nextComp = existingComponents[i + 1];
    var cssFromDOM = nextComp ? css.slice(matchIndex, nextComp.matchIndex) : css.slice(matchIndex);
    return { componentId: componentId, cssFromDOM: cssFromDOM };
  });
});

// 
/* eslint-disable camelcase, no-undef */

var getNonce = (function () {
  return  true ? __webpack_require__.nc : null;
});

// 
// Helper to call a given function, only once
var once = (function (cb) {
  var called = false;

  return function () {
    if (!called) {
      called = true;
      cb();
    }
  };
});

// 
/* These are helpers for the StyleTags to keep track of the injected
 * rule names for each (component) ID that they're keeping track of.
 * They're crucial for detecting whether a name has already been
 * injected.
 * (This excludes rehydrated names) */

/* adds a new ID:name pairing to a names dictionary */
var addNameForId = function addNameForId(names, id, name) {
  if (name) {
    // eslint-disable-next-line no-param-reassign
    var namesForId = names[id] || (names[id] = Object.create(null));
    namesForId[name] = true;
  }
};

/* resets an ID entirely by overwriting it in the dictionary */
var resetIdNames = function resetIdNames(names, id) {
  // eslint-disable-next-line no-param-reassign
  names[id] = Object.create(null);
};

/* factory for a names dictionary checking the existance of an ID:name pairing */
var hasNameForId = function hasNameForId(names) {
  return function (id, name) {
    return names[id] !== undefined && names[id][name];
  };
};

/* stringifies names for the html/element output */
var stringifyNames = function stringifyNames(names) {
  var str = '';
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    str += Object.keys(names[id]).join(' ') + ' ';
  }
  return str.trim();
};

/* clones the nested names dictionary */
var cloneNames = function cloneNames(names) {
  var clone = Object.create(null);
  // eslint-disable-next-line guard-for-in
  for (var id in names) {
    clone[id] = _extends({}, names[id]);
  }
  return clone;
};

// 

/* These are helpers that deal with the insertRule (aka speedy) API
 * They are used in the StyleTags and specifically the speedy tag
 */

/* retrieve a sheet for a given style tag */
var sheetForTag = function sheetForTag(tag) {
  // $FlowFixMe
  if (tag.sheet) return tag.sheet;

  /* Firefox quirk requires us to step through all stylesheets to find one owned by the given tag */
  var size = document.styleSheets.length;
  for (var i = 0; i < size; i += 1) {
    var sheet = document.styleSheets[i];
    // $FlowFixMe
    if (sheet.ownerNode === tag) return sheet;
  }

  /* we should always be able to find a tag */
  throw new StyledComponentsError(10);
};

/* insert a rule safely and return whether it was actually injected */
var safeInsertRule = function safeInsertRule(sheet, cssRule, index) {
  /* abort early if cssRule string is falsy */
  if (!cssRule) return false;

  var maxIndex = sheet.cssRules.length;

  try {
    /* use insertRule and cap passed index with maxIndex (no of cssRules) */
    sheet.insertRule(cssRule, index <= maxIndex ? index : maxIndex);
  } catch (err) {
    /* any error indicates an invalid rule */
    return false;
  }

  return true;
};

/* deletes `size` rules starting from `removalIndex` */
var deleteRules = function deleteRules(sheet, removalIndex, size) {
  var lowerBound = removalIndex - size;
  for (var i = removalIndex; i > lowerBound; i -= 1) {
    sheet.deleteRule(i);
  }
};

// 

/* this marker separates component styles and is important for rehydration */
var makeTextMarker = function makeTextMarker(id) {
  return '\n/* sc-component-id: ' + id + ' */\n';
};

/* add up all numbers in array up until and including the index */
var addUpUntilIndex = function addUpUntilIndex(sizes, index) {
  var totalUpToIndex = 0;
  for (var i = 0; i <= index; i += 1) {
    totalUpToIndex += sizes[i];
  }

  return totalUpToIndex;
};

/* create a new style tag after lastEl */
var makeStyleTag = function makeStyleTag(target, tagEl, insertBefore) {
  var el = document.createElement('style');
  el.setAttribute(SC_ATTR, '');

  var nonce = getNonce();
  if (nonce) {
    el.setAttribute('nonce', nonce);
  }

  /* Work around insertRule quirk in EdgeHTML */
  el.appendChild(document.createTextNode(''));

  if (target && !tagEl) {
    /* Append to target when no previous element was passed */
    target.appendChild(el);
  } else {
    if (!tagEl || !target || !tagEl.parentNode) {
      throw new StyledComponentsError(6);
    }

    /* Insert new style tag after the previous one */
    tagEl.parentNode.insertBefore(el, insertBefore ? tagEl : tagEl.nextSibling);
  }

  return el;
};

/* takes a css factory function and outputs an html styled tag factory */
var wrapAsHtmlTag = function wrapAsHtmlTag(css, names) {
  return function (additionalAttrs) {
    var nonce = getNonce();
    var attrs = [nonce && 'nonce="' + nonce + '"', SC_ATTR + '="' + stringifyNames(names) + '"', additionalAttrs];

    var htmlAttr = attrs.filter(Boolean).join(' ');
    return '<style ' + htmlAttr + '>' + css() + '</style>';
  };
};

/* takes a css factory function and outputs an element factory */
var wrapAsElement = function wrapAsElement(css, names) {
  return function () {
    var _props;

    var props = (_props = {}, _props[SC_ATTR] = stringifyNames(names), _props);

    var nonce = getNonce();
    if (nonce) {
      // $FlowFixMe
      props.nonce = nonce;
    }

    // eslint-disable-next-line react/no-danger
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('style', _extends({}, props, { dangerouslySetInnerHTML: { __html: css() } }));
  };
};

var getIdsFromMarkersFactory = function getIdsFromMarkersFactory(markers) {
  return function () {
    return Object.keys(markers);
  };
};

/* speedy tags utilise insertRule */
var makeSpeedyTag = function makeSpeedyTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);
  var sizes = [];

  var extractImport = getImportRuleTag !== undefined;
  /* indicates whther getImportRuleTag was called */
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    markers[id] = sizes.length;
    sizes.push(0);
    resetIdNames(names, id);

    return markers[id];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var sheet = sheetForTag(el);
    var insertIndex = addUpUntilIndex(sizes, marker);

    var injectedRules = 0;
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var cssRule = cssRules[i];
      var mayHaveImport = extractImport; /* @import rules are reordered to appear first */
      if (mayHaveImport && cssRule.indexOf('@import') !== -1) {
        importRules.push(cssRule);
      } else if (safeInsertRule(sheet, cssRule, insertIndex + injectedRules)) {
        mayHaveImport = false;
        injectedRules += 1;
      }
    }

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }

    sizes[marker] += injectedRules; /* add up no of injected rules */
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;

    var size = sizes[marker];
    var sheet = sheetForTag(el);
    var removalIndex = addUpUntilIndex(sizes, marker);
    deleteRules(sheet, removalIndex, size);
    sizes[marker] = 0;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var _sheetForTag = sheetForTag(el),
        cssRules = _sheetForTag.cssRules;

    var str = '';

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += makeTextMarker(id);
      var marker = markers[id];
      var end = addUpUntilIndex(sizes, marker);
      var size = sizes[marker];
      for (var i = end - size; i < end; i += 1) {
        var rule = cssRules[i];
        if (rule !== undefined) {
          str += rule.cssText;
        }
      }
    }

    return str;
  };

  return {
    clone: function clone() {
      throw new StyledComponentsError(5);
    },

    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: el,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };
};

var makeTextNode = function makeTextNode(id) {
  return document.createTextNode(makeTextMarker(id));
};

var makeBrowserTag = function makeBrowserTag(el, getImportRuleTag) {
  var names = Object.create(null);
  var markers = Object.create(null);

  var extractImport = getImportRuleTag !== undefined;

  /* indicates whther getImportRuleTag was called */
  var usedImportRuleTag = false;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    markers[id] = makeTextNode(id);
    el.appendChild(markers[id]);
    names[id] = Object.create(null);

    return markers[id];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    var importRules = [];
    var cssRulesSize = cssRules.length;

    for (var i = 0; i < cssRulesSize; i += 1) {
      var rule = cssRules[i];
      var mayHaveImport = extractImport;
      if (mayHaveImport && rule.indexOf('@import') !== -1) {
        importRules.push(rule);
      } else {
        mayHaveImport = false;
        var separator = i === cssRulesSize - 1 ? '' : ' ';
        marker.appendData('' + rule + separator);
      }
    }

    addNameForId(names, id, name);

    if (extractImport && importRules.length > 0) {
      usedImportRuleTag = true;
      // $FlowFixMe
      getImportRuleTag().insertRules(id + '-import', importRules);
    }
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;

    /* create new empty text node and replace the current one */
    var newMarker = makeTextNode(id);
    el.replaceChild(newMarker, marker);
    markers[id] = newMarker;
    resetIdNames(names, id);

    if (extractImport && usedImportRuleTag) {
      // $FlowFixMe
      getImportRuleTag().removeRules(id + '-import');
    }
  };

  var css = function css() {
    var str = '';
    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      str += markers[id].data;
    }
    return str;
  };

  return {
    clone: function clone() {
      throw new StyledComponentsError(5);
    },

    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: el,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };
};

var makeServerTagInternal = function makeServerTagInternal(namesArg, markersArg) {
  var names = namesArg === undefined ? Object.create(null) : namesArg;
  var markers = markersArg === undefined ? Object.create(null) : markersArg;

  var insertMarker = function insertMarker(id) {
    var prev = markers[id];
    if (prev !== undefined) {
      return prev;
    }

    return markers[id] = [''];
  };

  var insertRules = function insertRules(id, cssRules, name) {
    var marker = insertMarker(id);
    marker[0] += cssRules.join(' ');
    addNameForId(names, id, name);
  };

  var removeRules = function removeRules(id) {
    var marker = markers[id];
    if (marker === undefined) return;
    marker[0] = '';
    resetIdNames(names, id);
  };

  var css = function css() {
    var str = '';
    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      var cssForId = markers[id][0];
      if (cssForId) {
        str += makeTextMarker(id) + cssForId;
      }
    }
    return str;
  };

  var clone = function clone() {
    var namesClone = cloneNames(names);
    var markersClone = Object.create(null);

    // eslint-disable-next-line guard-for-in
    for (var id in markers) {
      markersClone[id] = [markers[id][0]];
    }

    return makeServerTagInternal(namesClone, markersClone);
  };

  var tag = {
    clone: clone,
    css: css,
    getIds: getIdsFromMarkersFactory(markers),
    hasNameForId: hasNameForId(names),
    insertMarker: insertMarker,
    insertRules: insertRules,
    removeRules: removeRules,
    sealed: false,
    styleTag: null,
    toElement: wrapAsElement(css, names),
    toHTML: wrapAsHtmlTag(css, names)
  };

  return tag;
};

var makeServerTag = function makeServerTag() {
  return makeServerTagInternal();
};

var makeTag = function makeTag(target, tagEl, forceServer, insertBefore, getImportRuleTag) {
  if (IS_BROWSER && !forceServer) {
    var el = makeStyleTag(target, tagEl, insertBefore);

    if (DISABLE_SPEEDY) {
      return makeBrowserTag(el, getImportRuleTag);
    } else {
      return makeSpeedyTag(el, getImportRuleTag);
    }
  }

  return makeServerTag();
};

/* wraps a given tag so that rehydration is performed once when necessary */
var makeRehydrationTag = function makeRehydrationTag(tag, els, extracted, immediateRehydration) {
  /* rehydration function that adds all rules to the new tag */
  var rehydrate = once(function () {
    /* add all extracted components to the new tag */
    for (var i = 0, len = extracted.length; i < len; i += 1) {
      var _extracted$i = extracted[i],
          componentId = _extracted$i.componentId,
          cssFromDOM = _extracted$i.cssFromDOM;

      var cssRules = splitByRules(cssFromDOM);
      tag.insertRules(componentId, cssRules);
    }

    /* remove old HTMLStyleElements, since they have been rehydrated */
    for (var _i = 0, _len = els.length; _i < _len; _i += 1) {
      var el = els[_i];
      if (el.parentNode) {
        el.parentNode.removeChild(el);
      }
    }
  });

  if (immediateRehydration) rehydrate();

  return _extends({}, tag, {
    /* add rehydration hook to insertion methods */
    insertMarker: function insertMarker(id) {
      rehydrate();
      return tag.insertMarker(id);
    },
    insertRules: function insertRules(id, cssRules, name) {
      rehydrate();
      return tag.insertRules(id, cssRules, name);
    }
  });
};

// 

var SPLIT_REGEX = /\s+/;

/* determine the maximum number of components before tags are sharded */
var MAX_SIZE = void 0;
if (IS_BROWSER) {
  /* in speedy mode we can keep a lot more rules in a sheet before a slowdown can be expected */
  MAX_SIZE = DISABLE_SPEEDY ? 40 : 1000;
} else {
  /* for servers we do not need to shard at all */
  MAX_SIZE = -1;
}

var sheetRunningId = 0;
var master = void 0;

var StyleSheet = function () {
  /* a map from ids to tags */
  /* deferred rules for a given id */
  /* this is used for not reinjecting rules via hasNameForId() */
  /* when rules for an id are removed using remove() we have to ignore rehydratedNames for it */
  /* a list of tags belonging to this StyleSheet */
  /* a tag for import rules */
  /* current capacity until a new tag must be created */
  /* children (aka clones) of this StyleSheet inheriting all and future injections */

  function StyleSheet() {
    var _this = this;

    var target = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : IS_BROWSER ? document.head : null;
    var forceServer = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    classCallCheck(this, StyleSheet);

    this.getImportRuleTag = function () {
      var importRuleTag = _this.importRuleTag;

      if (importRuleTag !== undefined) {
        return importRuleTag;
      }

      var firstTag = _this.tags[0];
      var insertBefore = true;

      return _this.importRuleTag = makeTag(_this.target, firstTag ? firstTag.styleTag : null, _this.forceServer, insertBefore);
    };

    sheetRunningId += 1;
    this.id = sheetRunningId;
    this.forceServer = forceServer;
    this.target = forceServer ? null : target;
    this.tagMap = {};
    this.deferred = {};
    this.rehydratedNames = {};
    this.ignoreRehydratedNames = {};
    this.tags = [];
    this.capacity = 1;
    this.clones = [];
  }

  /* rehydrate all SSR'd style tags */


  StyleSheet.prototype.rehydrate = function rehydrate() {
    if (!IS_BROWSER || this.forceServer) {
      return this;
    }

    var els = [];
    var extracted = [];
    var isStreamed = false;

    /* retrieve all of our SSR style elements from the DOM */
    var nodes = document.querySelectorAll('style[' + SC_ATTR + ']');
    var nodesSize = nodes.length;

    /* abort rehydration if no previous style tags were found */
    if (nodesSize === 0) {
      return this;
    }

    for (var i = 0; i < nodesSize; i += 1) {
      // $FlowFixMe: We can trust that all elements in this query are style elements
      var el = nodes[i];

      /* check if style tag is a streamed tag */
      if (!isStreamed) isStreamed = !!el.getAttribute(SC_STREAM_ATTR);

      /* retrieve all component names */
      var elNames = (el.getAttribute(SC_ATTR) || '').trim().split(SPLIT_REGEX);
      var elNamesSize = elNames.length;
      for (var j = 0; j < elNamesSize; j += 1) {
        var name = elNames[j];
        /* add rehydrated name to sheet to avoid readding styles */
        this.rehydratedNames[name] = true;
      }

      /* extract all components and their CSS */
      extracted.push.apply(extracted, extractComps(el.textContent));

      /* store original HTMLStyleElement */
      els.push(el);
    }

    /* abort rehydration if nothing was extracted */
    var extractedSize = extracted.length;
    if (extractedSize === 0) {
      return this;
    }

    /* create a tag to be used for rehydration */
    var tag = this.makeTag(null);
    var rehydrationTag = makeRehydrationTag(tag, els, extracted, isStreamed);

    /* reset capacity and adjust MAX_SIZE by the initial size of the rehydration */
    this.capacity = Math.max(1, MAX_SIZE - extractedSize);
    this.tags.push(rehydrationTag);

    /* retrieve all component ids */
    for (var _j = 0; _j < extractedSize; _j += 1) {
      this.tagMap[extracted[_j].componentId] = rehydrationTag;
    }

    return this;
  };

  /* retrieve a "master" instance of StyleSheet which is typically used when no other is available
   * The master StyleSheet is targeted by injectGlobal, keyframes, and components outside of any
    * StyleSheetManager's context */


  /* reset the internal "master" instance */
  StyleSheet.reset = function reset() {
    var forceServer = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;

    master = new StyleSheet(undefined, forceServer).rehydrate();
  };

  /* adds "children" to the StyleSheet that inherit all of the parents' rules
   * while their own rules do not affect the parent */


  StyleSheet.prototype.clone = function clone() {
    var sheet = new StyleSheet(this.target, this.forceServer);

    /* add to clone array */
    this.clones.push(sheet);

    /* clone all tags */
    sheet.tags = this.tags.map(function (tag) {
      var ids = tag.getIds();
      var newTag = tag.clone();

      /* reconstruct tagMap */
      for (var i = 0; i < ids.length; i += 1) {
        sheet.tagMap[ids[i]] = newTag;
      }

      return newTag;
    });

    /* clone other maps */
    sheet.rehydratedNames = _extends({}, this.rehydratedNames);
    sheet.deferred = _extends({}, this.deferred);

    return sheet;
  };

  /* force StyleSheet to create a new tag on the next injection */


  StyleSheet.prototype.sealAllTags = function sealAllTags() {
    this.capacity = 1;

    this.tags.forEach(function (tag) {
      // eslint-disable-next-line no-param-reassign
      tag.sealed = true;
    });
  };

  StyleSheet.prototype.makeTag = function makeTag$$1(tag) {
    var lastEl = tag ? tag.styleTag : null;
    var insertBefore = false;

    return makeTag(this.target, lastEl, this.forceServer, insertBefore, this.getImportRuleTag);
  };

  /* get a tag for a given componentId, assign the componentId to one, or shard */
  StyleSheet.prototype.getTagForId = function getTagForId(id) {
    /* simply return a tag, when the componentId was already assigned one */
    var prev = this.tagMap[id];
    if (prev !== undefined && !prev.sealed) {
      return prev;
    }

    var tag = this.tags[this.tags.length - 1];

    /* shard (create a new tag) if the tag is exhausted (See MAX_SIZE) */
    this.capacity -= 1;

    if (this.capacity === 0) {
      this.capacity = MAX_SIZE;
      tag = this.makeTag(tag);
      this.tags.push(tag);
    }

    return this.tagMap[id] = tag;
  };

  /* mainly for injectGlobal to check for its id */


  StyleSheet.prototype.hasId = function hasId(id) {
    return this.tagMap[id] !== undefined;
  };

  /* caching layer checking id+name to already have a corresponding tag and injected rules */


  StyleSheet.prototype.hasNameForId = function hasNameForId(id, name) {
    /* exception for rehydrated names which are checked separately */
    if (this.ignoreRehydratedNames[id] === undefined && this.rehydratedNames[name]) {
      return true;
    }

    var tag = this.tagMap[id];
    return tag !== undefined && tag.hasNameForId(id, name);
  };

  /* registers a componentId and registers it on its tag */


  StyleSheet.prototype.deferredInject = function deferredInject(id, cssRules) {
    /* don't inject when the id is already registered */
    if (this.tagMap[id] !== undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].deferredInject(id, cssRules);
    }

    this.getTagForId(id).insertMarker(id);
    this.deferred[id] = cssRules;
  };

  /* injects rules for a given id with a name that will need to be cached */


  StyleSheet.prototype.inject = function inject(id, cssRules, name) {
    var clones = this.clones;


    for (var i = 0; i < clones.length; i += 1) {
      clones[i].inject(id, cssRules, name);
    }

    var tag = this.getTagForId(id);

    /* add deferred rules for component */
    if (this.deferred[id] !== undefined) {
      // Combine passed cssRules with previously deferred CSS rules
      // NOTE: We cannot mutate the deferred array itself as all clones
      // do the same (see clones[i].inject)
      var rules = this.deferred[id].concat(cssRules);
      tag.insertRules(id, rules, name);

      this.deferred[id] = undefined;
    } else {
      tag.insertRules(id, cssRules, name);
    }
  };

  /* removes all rules for a given id, which doesn't remove its marker but resets it */


  StyleSheet.prototype.remove = function remove(id) {
    var tag = this.tagMap[id];
    if (tag === undefined) return;

    var clones = this.clones;

    for (var i = 0; i < clones.length; i += 1) {
      clones[i].remove(id);
    }

    /* remove all rules from the tag */
    tag.removeRules(id);
    /* ignore possible rehydrated names */
    this.ignoreRehydratedNames[id] = true;
    /* delete possible deferred rules */
    this.deferred[id] = undefined;
  };

  StyleSheet.prototype.toHTML = function toHTML() {
    return this.tags.map(function (tag) {
      return tag.toHTML();
    }).join('');
  };

  StyleSheet.prototype.toReactElements = function toReactElements() {
    var id = this.id;


    return this.tags.map(function (tag, i) {
      var key = 'sc-' + id + '-' + i;
      return Object(__WEBPACK_IMPORTED_MODULE_1_react__["cloneElement"])(tag.toElement(), { key: key });
    });
  };

  createClass(StyleSheet, null, [{
    key: 'master',
    get: function get$$1() {
      return master || (master = new StyleSheet().rehydrate());
    }

    /* NOTE: This is just for backwards-compatibility with jest-styled-components */

  }, {
    key: 'instance',
    get: function get$$1() {
      return StyleSheet.master;
    }
  }]);
  return StyleSheet;
}();

var _StyleSheetManager$ch;

var StyleSheetManager = function (_Component) {
  inherits(StyleSheetManager, _Component);

  function StyleSheetManager() {
    classCallCheck(this, StyleSheetManager);
    return possibleConstructorReturn(this, _Component.apply(this, arguments));
  }

  StyleSheetManager.prototype.getChildContext = function getChildContext() {
    var _ref;

    return _ref = {}, _ref[CONTEXT_KEY] = this.sheetInstance, _ref;
  };

  StyleSheetManager.prototype.componentWillMount = function componentWillMount() {
    if (this.props.sheet) {
      this.sheetInstance = this.props.sheet;
    } else if (this.props.target) {
      this.sheetInstance = new StyleSheet(this.props.target);
    } else {
      throw new StyledComponentsError(4);
    }
  };

  StyleSheetManager.prototype.render = function render() {
    /* eslint-disable react/prop-types */
    // Flow v0.43.1 will report an error accessing the `children` property,
    // but v0.47.0 will not. It is necessary to use a type cast instead of
    // a "fixme" comment to satisfy both Flow versions.
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.only(this.props.children);
  };

  return StyleSheetManager;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

StyleSheetManager.childContextTypes = (_StyleSheetManager$ch = {}, _StyleSheetManager$ch[CONTEXT_KEY] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(StyleSheet), __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(ServerStyleSheet)]).isRequired, _StyleSheetManager$ch);
 false ? StyleSheetManager.propTypes = {
  sheet: PropTypes.oneOfType([PropTypes.instanceOf(StyleSheet), PropTypes.instanceOf(ServerStyleSheet)]),
  target: PropTypes.shape({
    appendChild: PropTypes.func.isRequired
  })
} : void 0;

// 

var ServerStyleSheet = function () {
  function ServerStyleSheet() {
    classCallCheck(this, ServerStyleSheet);

    /* The master sheet might be reset, so keep a reference here */
    this.masterSheet = StyleSheet.master;
    this.instance = this.masterSheet.clone();
    this.closed = false;
  }

  ServerStyleSheet.prototype.complete = function complete() {
    if (!this.closed) {
      /* Remove closed StyleSheets from the master sheet */
      var index = this.masterSheet.clones.indexOf(this.instance);
      this.masterSheet.clones.splice(index, 1);
      this.closed = true;
    }
  };

  ServerStyleSheet.prototype.collectStyles = function collectStyles(children) {
    if (this.closed) {
      throw new StyledComponentsError(2);
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(
      StyleSheetManager,
      { sheet: this.instance },
      children
    );
  };

  ServerStyleSheet.prototype.getStyleTags = function getStyleTags() {
    this.complete();
    return this.instance.toHTML();
  };

  ServerStyleSheet.prototype.getStyleElement = function getStyleElement() {
    this.complete();
    return this.instance.toReactElements();
  };

  ServerStyleSheet.prototype.interleaveWithNodeStream = function interleaveWithNodeStream(readableStream) {
    var _this = this;

    {
      throw new StyledComponentsError(3);
    }

    /* the tag index keeps track of which tags have already been emitted */
    var instance = this.instance;

    var instanceTagIndex = 0;

    var streamAttr = SC_STREAM_ATTR + '="true"';

    var transformer = new stream.Transform({
      transform: function appendStyleChunks(chunk, /* encoding */_, callback) {
        var tags = instance.tags;

        var html = '';

        /* retrieve html for each new style tag */
        for (; instanceTagIndex < tags.length; instanceTagIndex += 1) {
          var tag = tags[instanceTagIndex];
          html += tag.toHTML(streamAttr);
        }

        /* force our StyleSheets to emit entirely new tags */
        instance.sealAllTags();

        /* prepend style html to chunk */
        this.push(html + chunk);
        callback();
      }
    });

    readableStream.on('end', function () {
      return _this.complete();
    });
    readableStream.on('error', function (err) {
      _this.complete();

      // forward the error to the transform stream
      transformer.emit('error', err);
    });

    return readableStream.pipe(transformer);
  };

  return ServerStyleSheet;
}();

// 

var LIMIT = 200;

var createWarnTooManyClasses = (function (displayName) {
  var generatedClasses = {};
  var warningSeen = false;

  return function (className) {
    if (!warningSeen) {
      generatedClasses[className] = true;
      if (Object.keys(generatedClasses).length >= LIMIT) {
        // Unable to find latestRule in test environment.
        /* eslint-disable no-console, prefer-template */
        console.warn('Over ' + LIMIT + ' classes were generated for component ' + displayName + '. \n' + 'Consider using the attrs method, together with a style object for frequently changed styles.\n' + 'Example:\n' + '  const Component = styled.div.attrs({\n' + '    style: ({ background }) => ({\n' + '      background,\n' + '    }),\n' + '  })`width: 100%;`\n\n' + '  <Component />');
        warningSeen = true;
        generatedClasses = {};
      }
    }
  };
});

// 

var determineTheme = (function (props, fallbackTheme, defaultProps) {
  // Props should take precedence over ThemeProvider, which should take precedence over
  // defaultProps, but React automatically puts defaultProps on props.

  /* eslint-disable react/prop-types */
  var isDefaultTheme = defaultProps && props.theme === defaultProps.theme;
  var theme = props.theme && !isDefaultTheme ? props.theme : fallbackTheme;
  /* eslint-enable */

  return theme;
});

// 
var escapeRegex = /[[\].#*$><+~=|^:(),"'`-]+/g;
var dashesAtEnds = /(^-|-$)/g;

/**
 * TODO: Explore using CSS.escape when it becomes more available
 * in evergreen browsers.
 */
function escape(str) {
  return str
  // Replace all possible CSS selectors
  .replace(escapeRegex, '-')

  // Remove extraneous hyphens at the start and end
  .replace(dashesAtEnds, '');
}

// 

function getComponentName(target) {
  return target.displayName || target.name || 'Component';
}

// 

function isTag(target) /* : %checks */{
  return typeof target === 'string';
}

// 

function generateDisplayName(target) {
  return isTag(target) ? 'styled.' + target : 'Styled(' + getComponentName(target) + ')';
}

// 
/* eslint-disable max-len */
/**
 * Trying to avoid the unknown-prop errors on styled components by filtering by
 * React's attribute whitelist.
 *
 * To regenerate this regex:
 *
 * 1. `npm i -g regexgen` (https://github.com/devongovett/regexgen)
 * 2. Run `regexgen` with the list of space-separated words below as input
 * 3. Surround the emitted regex with this: `/^(GENERATED_REGEX)$/` -- this will ensure a full string match
 *    and no false positives from partials
 * */
/*
children dangerouslySetInnerHTML key ref autoFocus defaultValue valueLink defaultChecked checkedLink innerHTML suppressContentEditableWarning onFocusIn onFocusOut className onCopy onCut onPaste onCompositionEnd onCompositionStart onCompositionUpdate onKeyDown onKeyPress onKeyUp onFocus onBlur onChange onInput onInvalid onSubmit onReset onClick onContextMenu onDoubleClick onDrag onDragEnd onDragEnter onDragExit onDragLeave onDragOver onDragStart onDrop onMouseDown onMouseEnter onMouseLeave onMouseMove onMouseOut onMouseOver onMouseUp onSelect onTouchCancel onTouchEnd onTouchMove onTouchStart onScroll onWheel onAbort onCanPlay onCanPlayThrough onDurationChange onEmptied onEncrypted onEnded onError onLoadedData onLoadedMetadata onLoadStart onPause onPlay onPlaying onProgress onRateChange onSeeked onSeeking onStalled onSuspend onTimeUpdate onVolumeChange onWaiting onLoad onAnimationStart onAnimationEnd onAnimationIteration onTransitionEnd onCopyCapture onCutCapture onPasteCapture onCompositionEndCapture onCompositionStartCapture onCompositionUpdateCapture onKeyDownCapture onKeyPressCapture onKeyUpCapture onFocusCapture onBlurCapture onChangeCapture onInputCapture onSubmitCapture onResetCapture onClickCapture onContextMenuCapture onDoubleClickCapture onDragCapture onDragEndCapture onDragEnterCapture onDragExitCapture onDragLeaveCapture onDragOverCapture onDragStartCapture onDropCapture onMouseDownCapture onMouseEnterCapture onMouseLeaveCapture onMouseMoveCapture onMouseOutCapture onMouseOverCapture onMouseUpCapture onSelectCapture onTouchCancelCapture onTouchEndCapture onTouchMoveCapture onTouchStartCapture onScrollCapture onWheelCapture onAbortCapture onCanPlayCapture onCanPlayThroughCapture onDurationChangeCapture onEmptiedCapture onEncryptedCapture onEndedCapture onErrorCapture onLoadedDataCapture onLoadedMetadataCapture onLoadStartCapture onPauseCapture onPlayCapture onPlayingCapture onProgressCapture onRateChangeCapture onSeekedCapture onSeekingCapture onStalledCapture onSuspendCapture onTimeUpdateCapture onVolumeChangeCapture onWaitingCapture onLoadCapture onAnimationStartCapture onAnimationEndCapture onAnimationIterationCapture onTransitionEndCapture accept acceptCharset accessKey action allowFullScreen allowTransparency alt as async autoComplete autoPlay capture cellPadding cellSpacing charSet challenge checked cite classID className cols colSpan content contentEditable contextMenu controlsList controls coords crossOrigin data dateTime default defer dir disabled download draggable encType form formAction formEncType formMethod formNoValidate formTarget frameBorder headers height hidden high href hrefLang htmlFor httpEquiv icon id inputMode integrity is keyParams keyType kind label lang list loop low manifest marginHeight marginWidth max maxLength media mediaGroup method min minLength multiple muted name nonce noValidate open optimum pattern placeholder playsInline poster preload profile radioGroup readOnly referrerPolicy rel required reversed role rows rowSpan sandbox scope scoped scrolling seamless selected shape size sizes span spellCheck src srcDoc srcLang srcSet start step style summary tabIndex target title type useMap value width wmode wrap about datatype inlist prefix property resource typeof vocab autoCapitalize autoCorrect autoSave color itemProp itemScope itemType itemID itemRef results security unselectable accentHeight accumulate additive alignmentBaseline allowReorder alphabetic amplitude arabicForm ascent attributeName attributeType autoReverse azimuth baseFrequency baseProfile baselineShift bbox begin bias by calcMode capHeight clip clipPath clipRule clipPathUnits colorInterpolation colorInterpolationFilters colorProfile colorRendering contentScriptType contentStyleType cursor cx cy d decelerate descent diffuseConstant direction display divisor dominantBaseline dur dx dy edgeMode elevation enableBackground end exponent externalResourcesRequired fill fillOpacity fillRule filter filterRes filterUnits floodColor floodOpacity focusable fontFamily fontSize fontSizeAdjust fontStretch fontStyle fontVariant fontWeight format from fx fy g1 g2 glyphName glyphOrientationHorizontal glyphOrientationVertical glyphRef gradientTransform gradientUnits hanging horizAdvX horizOriginX ideographic imageRendering in in2 intercept k k1 k2 k3 k4 kernelMatrix kernelUnitLength kerning keyPoints keySplines keyTimes lengthAdjust letterSpacing lightingColor limitingConeAngle local markerEnd markerMid markerStart markerHeight markerUnits markerWidth mask maskContentUnits maskUnits mathematical mode numOctaves offset opacity operator order orient orientation origin overflow overlinePosition overlineThickness paintOrder panose1 pathLength patternContentUnits patternTransform patternUnits pointerEvents points pointsAtX pointsAtY pointsAtZ preserveAlpha preserveAspectRatio primitiveUnits r radius refX refY renderingIntent repeatCount repeatDur requiredExtensions requiredFeatures restart result rotate rx ry scale seed shapeRendering slope spacing specularConstant specularExponent speed spreadMethod startOffset stdDeviation stemh stemv stitchTiles stopColor stopOpacity strikethroughPosition strikethroughThickness string stroke strokeDasharray strokeDashoffset strokeLinecap strokeLinejoin strokeMiterlimit strokeOpacity strokeWidth surfaceScale systemLanguage tableValues targetX targetY textAnchor textDecoration textRendering textLength to transform u1 u2 underlinePosition underlineThickness unicode unicodeBidi unicodeRange unitsPerEm vAlphabetic vHanging vIdeographic vMathematical values vectorEffect version vertAdvY vertOriginX vertOriginY viewBox viewTarget visibility widths wordSpacing writingMode x xHeight x1 x2 xChannelSelector xlinkActuate xlinkArcrole xlinkHref xlinkRole xlinkShow xlinkTitle xlinkType xmlBase xmlns xmlnsXlink xmlLang xmlSpace y y1 y2 yChannelSelector z zoomAndPan onPointerDown onPointerMove onPointerUp onPointerCancel onGotPointerCapture onLostPointerCapture onPointerEnter onPointerLeave onPointerOver onPointerOut class for autofocus allow allowUserMedia allowPaymentRequest
*/
/* eslint-enable max-len */

var ATTRIBUTE_REGEX = /^((?:s(?:uppressContentEditableWarn|croll|pac)|(?:shape|image|text)Render|(?:letter|word)Spac|vHang|hang)ing|(?:on(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:Animation|Touch|Load|Drag)Start|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|Lo(?:stPointer|ad)|TimeUpdate|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|GotPointer|MouseDown|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|KeyPress|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|P(?:rogress|laying)|DragEnd|Key(?:Down|Up)|(?:MouseU|Dro)p|(?:Wait|Seek)ing|Scroll|Focus|Paste|Abort|Drag|Play|Blur)Captur|alignmentBaselin|(?:limitingConeAng|xlink(?:(?:Arcr|R)o|Tit)|s(?:urfaceSca|ty|ca)|unselectab|baseProfi|fontSty|(?:focus|dragg)ab|multip|profi|tit)l|d(?:ominantBaselin|efaultValu)|onPointerLeav|a(?:uto(?:Capitaliz|Revers|Sav)|dditiv)|(?:(?:formNoValid|xlinkActu|noValid|accumul|rot)a|autoComple|decelera)t|(?:(?:attribute|item)T|datat)yp|onPointerMov|(?:attribute|glyph)Nam|playsInlin|(?:writing|input|edge)Mod|(?:formE|e)ncTyp|(?:amplitu|mo)d|(?:xlinkTy|itemSco|keyTy|slo)p|(?:xmlSpa|non)c|fillRul|(?:dateTi|na)m|r(?:esourc|ol)|xmlBas|wmod)e|(?:glyphOrientationHorizont|loc)al|(?:externalResourcesRequir|select|revers|mut)ed|c(?:o(?:lorInterpolationFilter|ord)s|o(?:lor(?:Interpolation)?|nt(?:rols|ent))|(?:ontentS(?:cript|tyle)Typ|o(?:ntentEditab|lorProfi)l|l(?:assNam|ipRul)|a(?:lcMod|ptur)|it)e|olorRendering|l(?:ipPathUnits|assID)|(?:ontrolsLis|apHeigh)t|h(?:eckedLink|a(?:llenge|rSet)|ildren|ecked)|ell(?:Spac|Padd)ing|o(?:ntextMenu|ls)|(?:rossOrigi|olSpa)n|l(?:ip(?:Path)?|ass)|ursor|[xy])|glyphOrientationVertical|d(?:angerouslySetInnerHTML|efaultChecked|ownload|isabled|isplay|[xy])|(?:s(?:trikethroughThickn|eaml)es|(?:und|ov)erlineThicknes|r(?:equiredExtension|adiu)|(?:requiredFeatur|tableValu|stitchTil|numOctav|filterR)e|key(?:(?:Splin|Tim)e|Param)|auto[Ff]ocu|header|bia)s|(?:(?:st(?:rikethroughPosi|dDevia)|(?:und|ov)erlinePosi|(?:textDecor|elev)a|orienta)tio|(?:strokeLinejo|orig)i|on(?:PointerDow|FocusI)|formActio|zoomAndPa|directio|(?:vers|act)io|rowSpa|begi|ico)n|o(?:n(?:AnimationIteration|C(?:o(?:mposition(?:Update|Start|End)|ntextMenu|py)|anPlayThrough|anPlay|hange|lick|ut)|(?:(?:Duration|Volume|Rate)Chang|(?:MouseLea|(?:Touch|Mouse)Mo|DragLea)v|Paus)e|Loaded(?:Metad|D)ata|(?:Animation|Touch|Load|Drag)Start|(?:(?:T(?:ransition|ouch)|Animation)E|Suspe)nd|DoubleClick|(?:TouchCanc|Whe)el|(?:Mouse(?:Ent|Ov)e|Drag(?:Ent|Ov)e|Erro)r|TimeUpdate|(?:E(?:n(?:crypt|d)|mpti)|S(?:tall|eek))ed|MouseDown|P(?:rogress|laying)|(?:MouseOu|DragExi|S(?:elec|ubmi)|Rese|Inpu)t|KeyPress|DragEnd|Key(?:Down|Up)|(?:Wait|Seek)ing|(?:MouseU|Dro)p|Scroll|Paste|Focus|Abort|Drag|Play|Load|Blur)|rient)|p(?:reserveAspectRatio|ointsAt[X-Z]|anose1)|(?:(?:allowPaymentReque|(?:fontSize|length)Adju|manife)s|strokeMiterlimi|(?:(?:specularE|e)xpon|renderingInt|asc)en|(?:specularConsta|repeatCou|fontVaria)n|d(?:iffuseConsta|esce)n|baselineShif|vectorEffec|onPointerOu|(?:(?:mar(?:ker|gin)|x)H|accentH|fontW)eigh|markerStar|a(?:utoCorrec|bou)|onFocusOu|intercep|restar|forma|inlis|heigh|lis)t|(?:patternContent|ma(?:sk(?:Content)?|rker)|primitive|gradient|pattern|filter)Units|(?:(?:allowTranspar|baseFrequ)enc|re(?:ferrerPolic|adOnl)|(?:(?:st(?:roke|op)O|floodO|fillO|o)pac|integr|secur)it|visibilit|fontFamil|accessKe|propert|summar)y|(?:gradientT|patternT|t)ransform|(?:(?:st(?:rokeDasho|artO)|o)ffs|acceptChars|formTarg|viewTarg|srcS)et|(?:[xy]ChannelSelect|lightingCol|textAnch|floodCol|stopCol|operat|htmlF)or|(?:(?:enableBackgrou|markerE)n|s(?:p(?:readMetho|ee)|ee)|formMetho|(?:markerM|onInval)i|preloa|metho|kin)d|k(?:ernel(?:UnitLength|Matrix)|[1-4])|strokeDasharray|(?:onPointerCanc|lab)el|(?:allowFullScre|hidd)en|a(?:l(?:lowUserMedia|phabetic|t)|rabicForm|sync)|systemLanguage|(?:(?:o(?:nPointer(?:Ent|Ov)|rd)|allowReord|placehold|frameBord|paintOrd|post)e|repeatDu|d(?:efe|u))r|(?:pointerEve|keyPoi)nts|preserveAlpha|(?:strokeLineca|onPointerU|itemPro|useMa|wra|loo)p|v(?:Mathematical|ert(?:Origin[XY]|AdvY)|alues|ocab)|unicodeRange|h(?:oriz(?:Origin|Adv)X|ttpEquiv)|(?:vI|i)deographic|mathematical|u(?:nicodeBidi|[12])|(?:fontStretc|hig)h|vAlphabetic|(?:(?:mar(?:ker|gin)W|strokeW)id|azimu)th|(?:xmlnsXl|valueL)ink|mediaGroup|spellCheck|(?:text|m(?:in|ax))Length|(?:unitsPerE|optimu|fro)m|r(?:adioGroup|e(?:sults|f[XY]|l)|ows|[xy])|pathLength|(?:xlinkHr|glyphR)ef|innerHTML|xlinkShow|f(?:o(?:ntSize|rm?)|il(?:ter|l))|(?:tabInde|(?:sand|b)bo|viewBo)x|autoPlay|r(?:e(?:quired|sult|f))?|(?:(?:href|xml|src)La|kerni)ng|o(?:verflow|pen)|i(?:temRef|n2|s)|p(?:attern|oints)|unicode|d(?:efault|ata|ir)?|divisor|t(?:arget[XY]|o)|(?:stri|la)ng|(?:width|size)s|prefix|typeof|srcDoc|s(?:coped|te(?:m[hv]|p)|pan)|s(?:t(?:roke|art)|hape|cope|rc)|a(?:ccept|llow|s)|itemID|t(?:arget|ype)|m(?:edia|a(?:sk|x)|in)|value|width|x(?:mlns)?|size|href|k(?:ey)?|end|low|by|x[12]|y[12]|g[12]|i[dn]|f[xy]|[yz])$/;
/* From DOMProperty */
var ATTRIBUTE_NAME_START_CHAR = ':A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD';
var ATTRIBUTE_NAME_CHAR = ATTRIBUTE_NAME_START_CHAR + '\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040';
var isCustomAttribute = RegExp.prototype.test.bind(new RegExp('^(x|data|aria)-[' + ATTRIBUTE_NAME_CHAR + ']*$'));

var validAttr = (function (name) {
  return ATTRIBUTE_REGEX.test(name) || isCustomAttribute(name.toLowerCase());
});

// 

function hasInInheritanceChain(child, parent) {
  var target = child;

  while (target) {
    target = Object.getPrototypeOf(target);

    if (target && target === parent) {
      return true;
    }
  }

  return false;
}

// 
/**
 * Creates a broadcast that can be listened to, i.e. simple event emitter
 *
 * @see https://github.com/ReactTraining/react-broadcast
 */

var createBroadcast = function createBroadcast(initialState) {
  var listeners = {};
  var id = 0;
  var state = initialState;

  function publish(nextState) {
    state = nextState;

    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (var key in listeners) {
      var listener = listeners[key];
      if (listener === undefined) {
        // eslint-disable-next-line no-continue
        continue;
      }

      listener(state);
    }
  }

  function subscribe(listener) {
    var currentId = id;
    listeners[currentId] = listener;
    id += 1;
    listener(state);
    return currentId;
  }

  function unsubscribe(unsubID) {
    listeners[unsubID] = undefined;
  }

  return { publish: publish, subscribe: subscribe, unsubscribe: unsubscribe };
};

var _contextShape, _ThemeProvider$contex;

// NOTE: DO NOT CHANGE, changing this is a semver major change!
var CHANNEL = '__styled-components__';
var CHANNEL_NEXT = CHANNEL + 'next__';

var CONTEXT_CHANNEL_SHAPE = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape({
  getTheme: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  subscribe: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,
  unsubscribe: __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func
});

var contextShape = (_contextShape = {}, _contextShape[CHANNEL] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func, _contextShape[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _contextShape);

var warnChannelDeprecated = void 0;
if (false) {
  warnChannelDeprecated = once(function () {
    // eslint-disable-next-line no-console
    console.warn('Warning: Usage of `context.' + CHANNEL + '` as a function is deprecated. It will be replaced with the object on `.context.' + CHANNEL_NEXT + '` in a future version.');
  });
}

var isFunction = function isFunction(test) {
  return typeof test === 'function';
};

/**
 * Provide a theme to an entire react component tree via context and event listeners (have to do
 * both context and event emitter as pure components block context updates)
 */

var ThemeProvider = function (_Component) {
  inherits(ThemeProvider, _Component);

  function ThemeProvider() {
    classCallCheck(this, ThemeProvider);

    var _this = possibleConstructorReturn(this, _Component.call(this));

    _this.unsubscribeToOuterId = -1;

    _this.getTheme = _this.getTheme.bind(_this);
    return _this;
  }

  ThemeProvider.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    // If there is a ThemeProvider wrapper anywhere around this theme provider, merge this theme
    // with the outer theme
    var outerContext = this.context[CHANNEL_NEXT];
    if (outerContext !== undefined) {
      this.unsubscribeToOuterId = outerContext.subscribe(function (theme) {
        _this2.outerTheme = theme;

        if (_this2.broadcast !== undefined) {
          _this2.publish(_this2.props.theme);
        }
      });
    }

    this.broadcast = createBroadcast(this.getTheme());
  };

  ThemeProvider.prototype.getChildContext = function getChildContext() {
    var _this3 = this,
        _babelHelpers$extends;

    return _extends({}, this.context, (_babelHelpers$extends = {}, _babelHelpers$extends[CHANNEL_NEXT] = {
      getTheme: this.getTheme,
      subscribe: this.broadcast.subscribe,
      unsubscribe: this.broadcast.unsubscribe
    }, _babelHelpers$extends[CHANNEL] = function (subscriber) {
      if (false) {
        warnChannelDeprecated();
      }

      // Patch the old `subscribe` provide via `CHANNEL` for older clients.
      var unsubscribeId = _this3.broadcast.subscribe(subscriber);
      return function () {
        return _this3.broadcast.unsubscribe(unsubscribeId);
      };
    }, _babelHelpers$extends));
  };

  ThemeProvider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (this.props.theme !== nextProps.theme) {
      this.publish(nextProps.theme);
    }
  };

  ThemeProvider.prototype.componentWillUnmount = function componentWillUnmount() {
    if (this.unsubscribeToOuterId !== -1) {
      this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeToOuterId);
    }
  };

  // Get the theme from the props, supporting both (outerTheme) => {} as well as object notation


  ThemeProvider.prototype.getTheme = function getTheme(passedTheme) {
    var theme = passedTheme || this.props.theme;

    if (isFunction(theme)) {
      var mergedTheme = theme(this.outerTheme);

      if (false) {
        throw new StyledComponentsError(7);
      }

      return mergedTheme;
    }

    if (theme === null || Array.isArray(theme) || (typeof theme === 'undefined' ? 'undefined' : _typeof(theme)) !== 'object') {
      throw new StyledComponentsError(8);
    }

    return _extends({}, this.outerTheme, theme);
  };

  ThemeProvider.prototype.publish = function publish(theme) {
    this.broadcast.publish(this.getTheme(theme));
  };

  ThemeProvider.prototype.render = function render() {
    if (!this.props.children) {
      return null;
    }

    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.Children.only(this.props.children);
  };

  return ThemeProvider;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

ThemeProvider.childContextTypes = contextShape;
ThemeProvider.contextTypes = (_ThemeProvider$contex = {}, _ThemeProvider$contex[CHANNEL_NEXT] = CONTEXT_CHANNEL_SHAPE, _ThemeProvider$contex);

var _babelHelpers$extends;

// HACK for generating all static styles without needing to allocate
// an empty execution context every single time...
var STATIC_EXECUTION_CONTEXT = {};

var modifiedContextShape = _extends({}, contextShape, (_babelHelpers$extends = {}, _babelHelpers$extends[CONTEXT_KEY] = __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(StyleSheet), __WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.instanceOf(ServerStyleSheet)]), _babelHelpers$extends));

var identifiers = {};

/* We depend on components having unique IDs */
var generateId = function generateId(ComponentStyle, _displayName, parentComponentId) {
  var displayName = typeof _displayName !== 'string' ? 'sc' : escape(_displayName);

  /**
   * This ensures uniqueness if two components happen to share
   * the same displayName.
   */
  var nr = (identifiers[displayName] || 0) + 1;
  identifiers[displayName] = nr;

  var componentId = displayName + '-' + ComponentStyle.generateName(displayName + nr);

  return parentComponentId !== undefined ? parentComponentId + '-' + componentId : componentId;
};

var warnExtendDeprecated = function warnExtendDeprecated() {};
if (false) {
  warnExtendDeprecated = once(function () {
    // eslint-disable-next-line no-console
    console.warn('Warning: The "extend" API will be removed in the upcoming v4.0 release. Use styled(StyledComponent) instead. You can find more information here: https://github.com/styled-components/styled-components/issues/1546');
  });
}

// $FlowFixMe

var BaseStyledComponent = function (_Component) {
  inherits(BaseStyledComponent, _Component);

  function BaseStyledComponent() {
    var _temp, _this, _ret;

    classCallCheck(this, BaseStyledComponent);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.attrs = {}, _this.state = {
      theme: null,
      generatedClassName: ''
    }, _this.unsubscribeId = -1, _temp), possibleConstructorReturn(_this, _ret);
  }

  BaseStyledComponent.prototype.unsubscribeFromContext = function unsubscribeFromContext() {
    if (this.unsubscribeId !== -1) {
      this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
    }
  };

  BaseStyledComponent.prototype.buildExecutionContext = function buildExecutionContext(theme, props) {
    var attrs = this.constructor.attrs;

    var context = _extends({}, props, { theme: theme });
    if (attrs === undefined) {
      return context;
    }

    this.attrs = Object.keys(attrs).reduce(function (acc, key) {
      var attr = attrs[key];

      // eslint-disable-next-line no-param-reassign
      acc[key] = typeof attr === 'function' && !hasInInheritanceChain(attr, __WEBPACK_IMPORTED_MODULE_1_react__["Component"]) ? attr(context) : attr;
      return acc;
    }, {});

    return _extends({}, context, this.attrs);
  };

  BaseStyledComponent.prototype.generateAndInjectStyles = function generateAndInjectStyles(theme, props) {
    var _constructor = this.constructor,
        attrs = _constructor.attrs,
        componentStyle = _constructor.componentStyle,
        warnTooManyClasses = _constructor.warnTooManyClasses;

    var styleSheet = this.context[CONTEXT_KEY] || StyleSheet.master;

    // statically styled-components don't need to build an execution context object,
    // and shouldn't be increasing the number of class names
    if (componentStyle.isStatic && attrs === undefined) {
      return componentStyle.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, styleSheet);
    } else {
      var executionContext = this.buildExecutionContext(theme, props);
      var className = componentStyle.generateAndInjectStyles(executionContext, styleSheet);

      if (false) {
        warnTooManyClasses(className);
      }

      return className;
    }
  };

  BaseStyledComponent.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var componentStyle = this.constructor.componentStyle;

    var styledContext = this.context[CHANNEL_NEXT];

    // If this is a statically-styled component, we don't need to the theme
    // to generate or build styles.
    if (componentStyle.isStatic) {
      var generatedClassName = this.generateAndInjectStyles(STATIC_EXECUTION_CONTEXT, this.props);
      this.setState({ generatedClassName: generatedClassName });
      // If there is a theme in the context, subscribe to the event emitter. This
      // is necessary due to pure components blocking context updates, this circumvents
      // that by updating when an event is emitted
    } else if (styledContext !== undefined) {
      var subscribe = styledContext.subscribe;

      this.unsubscribeId = subscribe(function (nextTheme) {
        // This will be called once immediately
        var theme = determineTheme(_this2.props, nextTheme, _this2.constructor.defaultProps);

        var generatedClassName = _this2.generateAndInjectStyles(theme, _this2.props);

        _this2.setState({ theme: theme, generatedClassName: generatedClassName });
      });
    } else {
      // eslint-disable-next-line react/prop-types
      var theme = this.props.theme || EMPTY_OBJECT;
      var _generatedClassName = this.generateAndInjectStyles(theme, this.props);
      this.setState({ theme: theme, generatedClassName: _generatedClassName });
    }
  };

  BaseStyledComponent.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    var _this3 = this;

    // If this is a statically-styled component, we don't need to listen to
    // props changes to update styles
    var componentStyle = this.constructor.componentStyle;

    if (componentStyle.isStatic) {
      return;
    }

    this.setState(function (prevState) {
      var theme = determineTheme(nextProps, prevState.theme, _this3.constructor.defaultProps);
      var generatedClassName = _this3.generateAndInjectStyles(theme, nextProps);

      return { theme: theme, generatedClassName: generatedClassName };
    });
  };

  BaseStyledComponent.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unsubscribeFromContext();
  };

  BaseStyledComponent.prototype.render = function render() {
    // eslint-disable-next-line react/prop-types
    var innerRef = this.props.innerRef;
    var generatedClassName = this.state.generatedClassName;
    var _constructor2 = this.constructor,
        styledComponentId = _constructor2.styledComponentId,
        target = _constructor2.target;


    var isTargetTag = isTag(target);

    var className = [
    // eslint-disable-next-line react/prop-types
    this.props.className, styledComponentId, this.attrs.className, generatedClassName].filter(Boolean).join(' ');

    var baseProps = _extends({}, this.attrs, {
      className: className
    });

    if (isStyledComponent(target)) {
      baseProps.innerRef = innerRef;
    } else {
      baseProps.ref = innerRef;
    }

    var propsForElement = baseProps;
    var key = void 0;

    for (key in this.props) {
      // Don't pass through non HTML tags through to HTML elements
      // always omit innerRef
      if (key !== 'innerRef' && key !== 'className' && (!isTargetTag || validAttr(key))) {
        propsForElement[key] = key === 'style' && key in this.attrs ? _extends({}, this.attrs[key], this.props[key]) : this.props[key];
      }
    }

    return Object(__WEBPACK_IMPORTED_MODULE_1_react__["createElement"])(target, propsForElement);
  };

  return BaseStyledComponent;
}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

var _StyledComponent = (function (ComponentStyle, constructWithOptions) {
  var createStyledComponent = function createStyledComponent(target, options, rules) {
    var _options$isClass = options.isClass,
        isClass = _options$isClass === undefined ? !isTag(target) : _options$isClass,
        _options$displayName = options.displayName,
        displayName = _options$displayName === undefined ? generateDisplayName(target) : _options$displayName,
        _options$componentId = options.componentId,
        componentId = _options$componentId === undefined ? generateId(ComponentStyle, options.displayName, options.parentComponentId) : _options$componentId,
        _options$ParentCompon = options.ParentComponent,
        ParentComponent = _options$ParentCompon === undefined ? BaseStyledComponent : _options$ParentCompon,
        extendingRules = options.rules,
        attrs = options.attrs;


    var styledComponentId = options.displayName && options.componentId ? escape(options.displayName) + '-' + options.componentId : options.componentId || componentId;

    var componentStyle = new ComponentStyle(extendingRules === undefined ? rules : extendingRules.concat(rules), attrs, styledComponentId);

    var StyledComponent = function (_ParentComponent) {
      inherits(StyledComponent, _ParentComponent);

      function StyledComponent() {
        classCallCheck(this, StyledComponent);
        return possibleConstructorReturn(this, _ParentComponent.apply(this, arguments));
      }

      StyledComponent.withComponent = function withComponent(tag) {
        var previousComponentId = options.componentId,
            optionsToCopy = objectWithoutProperties(options, ['componentId']);


        var newComponentId = previousComponentId && previousComponentId + '-' + (isTag(tag) ? tag : escape(getComponentName(tag)));

        var newOptions = _extends({}, optionsToCopy, {
          componentId: newComponentId,
          ParentComponent: StyledComponent
        });

        return createStyledComponent(tag, newOptions, rules);
      };

      createClass(StyledComponent, null, [{
        key: 'extend',
        get: function get$$1() {
          var rulesFromOptions = options.rules,
              parentComponentId = options.componentId,
              optionsToCopy = objectWithoutProperties(options, ['rules', 'componentId']);


          var newRules = rulesFromOptions === undefined ? rules : rulesFromOptions.concat(rules);

          var newOptions = _extends({}, optionsToCopy, {
            rules: newRules,
            parentComponentId: parentComponentId,
            ParentComponent: StyledComponent
          });

          warnExtendDeprecated();

          return constructWithOptions(createStyledComponent, target, newOptions);
        }
      }]);
      return StyledComponent;
    }(ParentComponent);

    StyledComponent.attrs = attrs;
    StyledComponent.componentStyle = componentStyle;
    StyledComponent.contextTypes = modifiedContextShape;
    StyledComponent.displayName = displayName;
    StyledComponent.styledComponentId = styledComponentId;
    StyledComponent.target = target;


    if (false) {
      StyledComponent.warnTooManyClasses = createWarnTooManyClasses(displayName);
    }

    if (isClass) {
      __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default()(StyledComponent, target, {
        // all SC-specific things should not be hoisted
        attrs: true,
        componentStyle: true,
        displayName: true,
        extend: true,
        styledComponentId: true,
        target: true,
        warnTooManyClasses: true,
        withComponent: true
      });
    }

    return StyledComponent;
  };

  return createStyledComponent;
});

// Source: https://github.com/garycourt/murmurhash-js/blob/master/murmurhash2_gc.js
function murmurhash(str) {
  var l = str.length | 0,
      h = l | 0,
      i = 0,
      k;

  while (l >= 4) {
    k = str.charCodeAt(i) & 0xff | (str.charCodeAt(++i) & 0xff) << 8 | (str.charCodeAt(++i) & 0xff) << 16 | (str.charCodeAt(++i) & 0xff) << 24;

    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);
    k ^= k >>> 24;
    k = (k & 0xffff) * 0x5bd1e995 + (((k >>> 16) * 0x5bd1e995 & 0xffff) << 16);

    h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16) ^ k;

    l -= 4;
    ++i;
  }

  switch (l) {
    case 3:
      h ^= (str.charCodeAt(i + 2) & 0xff) << 16;
    case 2:
      h ^= (str.charCodeAt(i + 1) & 0xff) << 8;
    case 1:
      h ^= str.charCodeAt(i) & 0xff;
      h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  }

  h ^= h >>> 13;
  h = (h & 0xffff) * 0x5bd1e995 + (((h >>> 16) * 0x5bd1e995 & 0xffff) << 16);
  h ^= h >>> 15;

  return h >>> 0;
}

// 

var areStylesCacheable = IS_BROWSER;

var isStaticRules = function isStaticRules(rules, attrs) {
  for (var i = 0, len = rules.length; i < len; i += 1) {
    var rule = rules[i];

    // recursive case
    if (Array.isArray(rule) && !isStaticRules(rule)) {
      return false;
    } else if (typeof rule === 'function' && !isStyledComponent(rule)) {
      // functions are allowed to be static if they're just being
      // used to get the classname of a nested styled component
      return false;
    }
  }

  if (attrs !== undefined) {
    // eslint-disable-next-line guard-for-in, no-restricted-syntax
    for (var key in attrs) {
      if (typeof attrs[key] === 'function') {
        return false;
      }
    }
  }

  return true;
};

var isHMREnabled = typeof module !== 'undefined' && module.hot && "production" !== 'production';

/*
 ComponentStyle is all the CSS-specific stuff, not
 the React-specific stuff.
 */
var _ComponentStyle = (function (nameGenerator, flatten, stringifyRules) {
  /* combines hashStr (murmurhash) and nameGenerator for convenience */
  var generateRuleHash = function generateRuleHash(str) {
    return nameGenerator(murmurhash(str));
  };

  var ComponentStyle = function () {
    function ComponentStyle(rules, attrs, componentId) {
      classCallCheck(this, ComponentStyle);

      this.rules = rules;
      this.isStatic = !isHMREnabled && isStaticRules(rules, attrs);
      this.componentId = componentId;

      if (!StyleSheet.master.hasId(componentId)) {
        var placeholder =  false ? ['.' + componentId + ' {}'] : [];

        StyleSheet.master.deferredInject(componentId, placeholder);
      }
    }

    /*
     * Flattens a rule set into valid CSS
     * Hashes it, wraps the whole chunk in a .hash1234 {}
     * Returns the hash to be injected on render()
     * */


    ComponentStyle.prototype.generateAndInjectStyles = function generateAndInjectStyles(executionContext, styleSheet) {
      var isStatic = this.isStatic,
          componentId = this.componentId,
          lastClassName = this.lastClassName;

      if (areStylesCacheable && isStatic && lastClassName !== undefined && styleSheet.hasNameForId(componentId, lastClassName)) {
        return lastClassName;
      }

      var flatCSS = flatten(this.rules, executionContext);
      var name = generateRuleHash(this.componentId + flatCSS.join(''));

      if (!styleSheet.hasNameForId(componentId, name)) {
        styleSheet.inject(this.componentId, stringifyRules(flatCSS, '.' + name), name);
      }

      this.lastClassName = name;
      return name;
    };

    ComponentStyle.generateName = function generateName(str) {
      return generateRuleHash(str);
    };

    return ComponentStyle;
  }();

  return ComponentStyle;
});

// 
// Thanks to ReactDOMFactories for this handy list!

var domElements = ['a', 'abbr', 'address', 'area', 'article', 'aside', 'audio', 'b', 'base', 'bdi', 'bdo', 'big', 'blockquote', 'body', 'br', 'button', 'canvas', 'caption', 'cite', 'code', 'col', 'colgroup', 'data', 'datalist', 'dd', 'del', 'details', 'dfn', 'dialog', 'div', 'dl', 'dt', 'em', 'embed', 'fieldset', 'figcaption', 'figure', 'footer', 'form', 'h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'head', 'header', 'hgroup', 'hr', 'html', 'i', 'iframe', 'img', 'input', 'ins', 'kbd', 'keygen', 'label', 'legend', 'li', 'link', 'main', 'map', 'mark', 'marquee', 'menu', 'menuitem', 'meta', 'meter', 'nav', 'noscript', 'object', 'ol', 'optgroup', 'option', 'output', 'p', 'param', 'picture', 'pre', 'progress', 'q', 'rp', 'rt', 'ruby', 's', 'samp', 'script', 'section', 'select', 'small', 'source', 'span', 'strong', 'style', 'sub', 'summary', 'sup', 'table', 'tbody', 'td', 'textarea', 'tfoot', 'th', 'thead', 'time', 'title', 'tr', 'track', 'u', 'ul', 'var', 'video', 'wbr',

// SVG
'circle', 'clipPath', 'defs', 'ellipse', 'foreignObject', 'g', 'image', 'line', 'linearGradient', 'mask', 'path', 'pattern', 'polygon', 'polyline', 'radialGradient', 'rect', 'stop', 'svg', 'text', 'tspan'];

// 

var _styled = (function (styledComponent, constructWithOptions) {
  var styled = function styled(tag) {
    return constructWithOptions(styledComponent, tag);
  };

  // Shorthands for all valid HTML Elements
  domElements.forEach(function (domElement) {
    styled[domElement] = styled(domElement);
  });

  return styled;
});

// 

var replaceWhitespace = function replaceWhitespace(str) {
  return str.replace(/\s|\\n/g, '');
};

var _keyframes = (function (nameGenerator, stringifyRules, css) {
  return function () {
    var styleSheet = StyleSheet.master;
    var rules = css.apply(undefined, arguments);
    var name = nameGenerator(murmurhash(replaceWhitespace(JSON.stringify(rules))));
    var id = 'sc-keyframes-' + name;

    if (!styleSheet.hasNameForId(id, name)) {
      styleSheet.inject(id, stringifyRules(rules, name, '@keyframes'), name);
    }

    return name;
  };
});

// 

var _injectGlobal = (function (stringifyRules, css) {
  var injectGlobal = function injectGlobal() {
    var styleSheet = StyleSheet.master;
    var rules = css.apply(undefined, arguments);
    var hash = murmurhash(JSON.stringify(rules));
    var id = 'sc-global-' + hash;

    if (!styleSheet.hasId(id)) {
      styleSheet.inject(id, stringifyRules(rules));
    }
  };

  return injectGlobal;
});

// 

var _constructWithOptions = (function (css) {
  var constructWithOptions = function constructWithOptions(componentConstructor, tag) {
    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : EMPTY_OBJECT;

    if (!Object(__WEBPACK_IMPORTED_MODULE_6_react_is__["isValidElementType"])(tag)) {
      throw new StyledComponentsError(1, String(tag));
    }

    /* This is callable directly as a template function */
    // $FlowFixMe: Not typed to avoid destructuring arguments
    var templateFunction = function templateFunction() {
      return componentConstructor(tag, options, css.apply(undefined, arguments));
    };

    /* If config methods are called, wrap up a new template function and merge options */
    templateFunction.withConfig = function (config) {
      return constructWithOptions(componentConstructor, tag, _extends({}, options, config));
    };
    templateFunction.attrs = function (attrs) {
      return constructWithOptions(componentConstructor, tag, _extends({}, options, {
        attrs: _extends({}, options.attrs || EMPTY_OBJECT, attrs)
      }));
    };

    return templateFunction;
  };

  return constructWithOptions;
});

// 

var withTheme = (function (Component$$1) {
  var isStatelessFunctionalComponent = typeof Component$$1 === 'function' &&
  // $FlowFixMe TODO: flow for prototype
  !(Component$$1.prototype && 'isReactComponent' in Component$$1.prototype);

  // NOTE: We can't pass a ref to a stateless functional component
  var shouldSetInnerRef = isStyledComponent(Component$$1) || isStatelessFunctionalComponent;

  var WithTheme = function (_React$Component) {
    inherits(WithTheme, _React$Component);

    function WithTheme() {
      var _temp, _this, _ret;

      classCallCheck(this, WithTheme);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = EMPTY_OBJECT, _this.unsubscribeId = -1, _temp), possibleConstructorReturn(_this, _ret);
    }

    // NOTE: This is so that isStyledComponent passes for the innerRef unwrapping


    WithTheme.prototype.componentWillMount = function componentWillMount() {
      var _this2 = this;

      var defaultProps = this.constructor.defaultProps;

      var styledContext = this.context[CHANNEL_NEXT];
      var themeProp = determineTheme(this.props, undefined, defaultProps);
      if (styledContext === undefined && themeProp === undefined && "production" !== 'production') {
        // eslint-disable-next-line no-console
        console.warn('[withTheme] You are not using a ThemeProvider nor passing a theme prop or a theme in defaultProps');
      } else if (styledContext === undefined && themeProp !== undefined) {
        this.setState({ theme: themeProp });
      } else {
        var subscribe = styledContext.subscribe;

        this.unsubscribeId = subscribe(function (nextTheme) {
          var theme = determineTheme(_this2.props, nextTheme, defaultProps);
          _this2.setState({ theme: theme });
        });
      }
    };

    WithTheme.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var defaultProps = this.constructor.defaultProps;

      this.setState(function (oldState) {
        var theme = determineTheme(nextProps, oldState.theme, defaultProps);

        return { theme: theme };
      });
    };

    WithTheme.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.unsubscribeId !== -1) {
        this.context[CHANNEL_NEXT].unsubscribe(this.unsubscribeId);
      }
    };

    WithTheme.prototype.render = function render() {
      var props = _extends({
        theme: this.state.theme
      }, this.props);

      if (!shouldSetInnerRef) {
        props.ref = props.innerRef;
        delete props.innerRef;
      }

      return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Component$$1, props);
    };

    return WithTheme;
  }(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

  WithTheme.contextTypes = contextShape;
  WithTheme.displayName = 'WithTheme(' + getComponentName(Component$$1) + ')';
  WithTheme.styledComponentId = 'withTheme';


  return __WEBPACK_IMPORTED_MODULE_5_hoist_non_react_statics___default()(WithTheme, Component$$1);
});

// 

/* eslint-disable */
var __DO_NOT_USE_OR_YOU_WILL_BE_HAUNTED_BY_SPOOKY_GHOSTS = {
  StyleSheet: StyleSheet
};

// 

/* Warning if you've imported this file on React Native */
if (false) {
  // eslint-disable-next-line no-console
  console.warn("It looks like you've imported 'styled-components' on React Native.\n" + "Perhaps you're looking to import 'styled-components/native'?\n" + 'Read more about this at https://www.styled-components.com/docs/basics#react-native');
}

/* Warning if there are several instances of styled-components */
if (false) {
  window['__styled-components-init__'] = window['__styled-components-init__'] || 0;

  if (window['__styled-components-init__'] === 1) {
    // eslint-disable-next-line no-console
    console.warn("It looks like there are several instances of 'styled-components' initialized in this application. " + 'This may cause dynamic styles not rendering properly, errors happening during rehydration process ' + 'and makes your application bigger without a good reason.\n\n' + 'See https://s-c.sh/2BAXzed for more info.');
  }

  window['__styled-components-init__'] += 1;
}

/* Instantiate singletons */
var ComponentStyle = _ComponentStyle(generateAlphabeticName, flatten, stringifyRules);
var constructWithOptions = _constructWithOptions(css);
var StyledComponent = _StyledComponent(ComponentStyle, constructWithOptions);

/* Instantiate exported singletons */
var keyframes = _keyframes(generateAlphabeticName, stringifyRules, css);
var injectGlobal = _injectGlobal(stringifyRules, css);
var styled = _styled(StyledComponent, constructWithOptions);

/* harmony default export */ __webpack_exports__["b"] = (styled);

//# sourceMappingURL=styled-components.browser.esm.js.map

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(171), __webpack_require__(516)(module)))

/***/ }),
/* 28 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "ConfigConsumer", {
  enumerable: true,
  get: function get() {
    return _context.ConfigConsumer;
  }
});
exports["default"] = exports.configConsumerProps = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _localeProvider = _interopRequireWildcard(__webpack_require__(611));

var _LocaleReceiver = _interopRequireDefault(__webpack_require__(186));

var _context = __webpack_require__(614);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var configConsumerProps = ['getPopupContainer', 'rootPrefixCls', 'getPrefixCls', 'renderEmpty', 'csp', 'autoInsertSpaceInButton', 'locale', 'pageHeader'];
exports.configConsumerProps = configConsumerProps;

var ConfigProvider = /*#__PURE__*/function (_React$Component) {
  _inherits(ConfigProvider, _React$Component);

  var _super = _createSuper(ConfigProvider);

  function ConfigProvider() {
    var _this;

    _classCallCheck(this, ConfigProvider);

    _this = _super.apply(this, arguments);

    _this.getPrefixCls = function (suffixCls, customizePrefixCls) {
      var _this$props$prefixCls = _this.props.prefixCls,
          prefixCls = _this$props$prefixCls === void 0 ? 'ant' : _this$props$prefixCls;
      if (customizePrefixCls) return customizePrefixCls;
      return suffixCls ? "".concat(prefixCls, "-").concat(suffixCls) : prefixCls;
    };

    _this.renderProvider = function (context, legacyLocale) {
      var _this$props = _this.props,
          children = _this$props.children,
          getPopupContainer = _this$props.getPopupContainer,
          renderEmpty = _this$props.renderEmpty,
          csp = _this$props.csp,
          autoInsertSpaceInButton = _this$props.autoInsertSpaceInButton,
          locale = _this$props.locale,
          pageHeader = _this$props.pageHeader;

      var config = _extends(_extends({}, context), {
        getPrefixCls: _this.getPrefixCls,
        csp: csp,
        autoInsertSpaceInButton: autoInsertSpaceInButton
      });

      if (getPopupContainer) {
        config.getPopupContainer = getPopupContainer;
      }

      if (renderEmpty) {
        config.renderEmpty = renderEmpty;
      }

      if (pageHeader) {
        config.pageHeader = pageHeader;
      }

      return /*#__PURE__*/React.createElement(_context.ConfigContext.Provider, {
        value: config
      }, /*#__PURE__*/React.createElement(_localeProvider["default"], {
        locale: locale || legacyLocale,
        _ANT_MARK__: _localeProvider.ANT_MARK
      }, children));
    };

    return _this;
  }

  _createClass(ConfigProvider, [{
    key: "render",
    value: function render() {
      var _this2 = this;

      return /*#__PURE__*/React.createElement(_LocaleReceiver["default"], null, function (_, __, legacyLocale) {
        return /*#__PURE__*/React.createElement(_context.ConfigConsumer, null, function (context) {
          return _this2.renderProvider(context, legacyLocale);
        });
      });
    }
  }]);

  return ConfigProvider;
}(React.Component);

var _default = ConfigProvider;
exports["default"] = _default;

/***/ }),
/* 29 */
/***/ (function(module, exports) {

var g;

// This works in non-strict mode
g = (function() {
	return this;
})();

try {
	// This works if eval is allowed (see CSP)
	g = g || Function("return this")() || (1,eval)("this");
} catch(e) {
	// This works if the window reference is available
	if(typeof window === "object")
		g = window;
}

// g can still be undefined, but nothing to do about it...
// We return undefined, instead of nothing here, so it's
// easier to handle this case. if(!global) { ...}

module.exports = g;


/***/ }),
/* 30 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function checkDCE() {
  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
  if (
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
  ) {
    return;
  }
  if (false) {
    // This branch is unreachable because this function is only called
    // in production, but the condition is true only in development.
    // Therefore if the branch is still here, dead code elimination wasn't
    // properly applied.
    // Don't change the message. React DevTools relies on it. Also make sure
    // this message doesn't occur elsewhere in this function, or it will cause
    // a false positive.
    throw new Error('^_^');
  }
  try {
    // Verify that the code above has been dead code eliminated (DCE'd).
    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
  } catch (err) {
    // DevTools shouldn't crash React, no matter what.
    // We should still report in case we break this code.
    console.error(err);
  }
}

if (true) {
  // DCE check should happen before ReactDOM bundle executes so that
  // DevTools can report bad minification during injection.
  checkDCE();
  module.exports = __webpack_require__(385);
} else {
  module.exports = require('./cjs/react-dom.development.js');
}


/***/ }),
/* 31 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return value != null && (type == 'object' || type == 'function');
}

module.exports = isObject;


/***/ }),
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(155),
    baseFilter = __webpack_require__(271),
    baseIteratee = __webpack_require__(36),
    isArray = __webpack_require__(13);

/**
 * Iterates over elements of `collection`, returning an array of all elements
 * `predicate` returns truthy for. The predicate is invoked with three
 * arguments: (value, index|key, collection).
 *
 * **Note:** Unlike `_.remove`, this method returns a new array.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.reject
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': true },
 *   { 'user': 'fred',   'age': 40, 'active': false }
 * ];
 *
 * _.filter(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.filter(users, { 'age': 36, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.filter(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.filter(users, 'active');
 * // => objects for ['barney']
 *
 * // Combining several predicates using `_.overEvery` or `_.overSome`.
 * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
 * // => objects for ['fred', 'barney']
 */
function filter(collection, predicate) {
  var func = isArray(collection) ? arrayFilter : baseFilter;
  return func(collection, baseIteratee(predicate, 3));
}

module.exports = filter;


/***/ }),
/* 33 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*
 2017 Julian Garnier
 Released under the MIT license
*/
var $jscomp={scope:{}};$jscomp.defineProperty="function"==typeof Object.defineProperties?Object.defineProperty:function(e,r,p){if(p.get||p.set)throw new TypeError("ES3 does not support getters and setters.");e!=Array.prototype&&e!=Object.prototype&&(e[r]=p.value)};$jscomp.getGlobal=function(e){return"undefined"!=typeof window&&window===e?e:"undefined"!=typeof global&&null!=global?global:e};$jscomp.global=$jscomp.getGlobal(this);$jscomp.SYMBOL_PREFIX="jscomp_symbol_";
$jscomp.initSymbol=function(){$jscomp.initSymbol=function(){};$jscomp.global.Symbol||($jscomp.global.Symbol=$jscomp.Symbol)};$jscomp.symbolCounter_=0;$jscomp.Symbol=function(e){return $jscomp.SYMBOL_PREFIX+(e||"")+$jscomp.symbolCounter_++};
$jscomp.initSymbolIterator=function(){$jscomp.initSymbol();var e=$jscomp.global.Symbol.iterator;e||(e=$jscomp.global.Symbol.iterator=$jscomp.global.Symbol("iterator"));"function"!=typeof Array.prototype[e]&&$jscomp.defineProperty(Array.prototype,e,{configurable:!0,writable:!0,value:function(){return $jscomp.arrayIterator(this)}});$jscomp.initSymbolIterator=function(){}};$jscomp.arrayIterator=function(e){var r=0;return $jscomp.iteratorPrototype(function(){return r<e.length?{done:!1,value:e[r++]}:{done:!0}})};
$jscomp.iteratorPrototype=function(e){$jscomp.initSymbolIterator();e={next:e};e[$jscomp.global.Symbol.iterator]=function(){return this};return e};$jscomp.array=$jscomp.array||{};$jscomp.iteratorFromArray=function(e,r){$jscomp.initSymbolIterator();e instanceof String&&(e+="");var p=0,m={next:function(){if(p<e.length){var u=p++;return{value:r(u,e[u]),done:!1}}m.next=function(){return{done:!0,value:void 0}};return m.next()}};m[Symbol.iterator]=function(){return m};return m};
$jscomp.polyfill=function(e,r,p,m){if(r){p=$jscomp.global;e=e.split(".");for(m=0;m<e.length-1;m++){var u=e[m];u in p||(p[u]={});p=p[u]}e=e[e.length-1];m=p[e];r=r(m);r!=m&&null!=r&&$jscomp.defineProperty(p,e,{configurable:!0,writable:!0,value:r})}};$jscomp.polyfill("Array.prototype.keys",function(e){return e?e:function(){return $jscomp.iteratorFromArray(this,function(e){return e})}},"es6-impl","es3");var $jscomp$this=this;
(function(e,r){ true?!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_FACTORY__ = (r),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__)) : __WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"===typeof module&&module.exports?module.exports=r():e.anime=r()})(this,function(){function e(a){if(!h.col(a))try{return document.querySelectorAll(a)}catch(c){}}function r(a,c){for(var d=a.length,b=2<=arguments.length?arguments[1]:void 0,f=[],n=0;n<d;n++)if(n in a){var k=a[n];c.call(b,k,n,a)&&f.push(k)}return f}function p(a){return a.reduce(function(a,d){return a.concat(h.arr(d)?p(d):d)},[])}function m(a){if(h.arr(a))return a;
h.str(a)&&(a=e(a)||a);return a instanceof NodeList||a instanceof HTMLCollection?[].slice.call(a):[a]}function u(a,c){return a.some(function(a){return a===c})}function C(a){var c={},d;for(d in a)c[d]=a[d];return c}function D(a,c){var d=C(a),b;for(b in a)d[b]=c.hasOwnProperty(b)?c[b]:a[b];return d}function z(a,c){var d=C(a),b;for(b in c)d[b]=h.und(a[b])?c[b]:a[b];return d}function T(a){a=a.replace(/^#?([a-f\d])([a-f\d])([a-f\d])$/i,function(a,c,d,k){return c+c+d+d+k+k});var c=/^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(a);
a=parseInt(c[1],16);var d=parseInt(c[2],16),c=parseInt(c[3],16);return"rgba("+a+","+d+","+c+",1)"}function U(a){function c(a,c,b){0>b&&(b+=1);1<b&&--b;return b<1/6?a+6*(c-a)*b:.5>b?c:b<2/3?a+(c-a)*(2/3-b)*6:a}var d=/hsl\((\d+),\s*([\d.]+)%,\s*([\d.]+)%\)/g.exec(a)||/hsla\((\d+),\s*([\d.]+)%,\s*([\d.]+)%,\s*([\d.]+)\)/g.exec(a);a=parseInt(d[1])/360;var b=parseInt(d[2])/100,f=parseInt(d[3])/100,d=d[4]||1;if(0==b)f=b=a=f;else{var n=.5>f?f*(1+b):f+b-f*b,k=2*f-n,f=c(k,n,a+1/3),b=c(k,n,a);a=c(k,n,a-1/3)}return"rgba("+
255*f+","+255*b+","+255*a+","+d+")"}function y(a){if(a=/([\+\-]?[0-9#\.]+)(%|px|pt|em|rem|in|cm|mm|ex|ch|pc|vw|vh|vmin|vmax|deg|rad|turn)?$/.exec(a))return a[2]}function V(a){if(-1<a.indexOf("translate")||"perspective"===a)return"px";if(-1<a.indexOf("rotate")||-1<a.indexOf("skew"))return"deg"}function I(a,c){return h.fnc(a)?a(c.target,c.id,c.total):a}function E(a,c){if(c in a.style)return getComputedStyle(a).getPropertyValue(c.replace(/([a-z])([A-Z])/g,"$1-$2").toLowerCase())||"0"}function J(a,c){if(h.dom(a)&&
u(W,c))return"transform";if(h.dom(a)&&(a.getAttribute(c)||h.svg(a)&&a[c]))return"attribute";if(h.dom(a)&&"transform"!==c&&E(a,c))return"css";if(null!=a[c])return"object"}function X(a,c){var d=V(c),d=-1<c.indexOf("scale")?1:0+d;a=a.style.transform;if(!a)return d;for(var b=[],f=[],n=[],k=/(\w+)\((.+?)\)/g;b=k.exec(a);)f.push(b[1]),n.push(b[2]);a=r(n,function(a,b){return f[b]===c});return a.length?a[0]:d}function K(a,c){switch(J(a,c)){case "transform":return X(a,c);case "css":return E(a,c);case "attribute":return a.getAttribute(c)}return a[c]||
0}function L(a,c){var d=/^(\*=|\+=|-=)/.exec(a);if(!d)return a;var b=y(a)||0;c=parseFloat(c);a=parseFloat(a.replace(d[0],""));switch(d[0][0]){case "+":return c+a+b;case "-":return c-a+b;case "*":return c*a+b}}function F(a,c){return Math.sqrt(Math.pow(c.x-a.x,2)+Math.pow(c.y-a.y,2))}function M(a){a=a.points;for(var c=0,d,b=0;b<a.numberOfItems;b++){var f=a.getItem(b);0<b&&(c+=F(d,f));d=f}return c}function N(a){if(a.getTotalLength)return a.getTotalLength();switch(a.tagName.toLowerCase()){case "circle":return 2*
Math.PI*a.getAttribute("r");case "rect":return 2*a.getAttribute("width")+2*a.getAttribute("height");case "line":return F({x:a.getAttribute("x1"),y:a.getAttribute("y1")},{x:a.getAttribute("x2"),y:a.getAttribute("y2")});case "polyline":return M(a);case "polygon":var c=a.points;return M(a)+F(c.getItem(c.numberOfItems-1),c.getItem(0))}}function Y(a,c){function d(b){b=void 0===b?0:b;return a.el.getPointAtLength(1<=c+b?c+b:0)}var b=d(),f=d(-1),n=d(1);switch(a.property){case "x":return b.x;case "y":return b.y;
case "angle":return 180*Math.atan2(n.y-f.y,n.x-f.x)/Math.PI}}function O(a,c){var d=/-?\d*\.?\d+/g,b;b=h.pth(a)?a.totalLength:a;if(h.col(b))if(h.rgb(b)){var f=/rgb\((\d+,\s*[\d]+,\s*[\d]+)\)/g.exec(b);b=f?"rgba("+f[1]+",1)":b}else b=h.hex(b)?T(b):h.hsl(b)?U(b):void 0;else f=(f=y(b))?b.substr(0,b.length-f.length):b,b=c&&!/\s/g.test(b)?f+c:f;b+="";return{original:b,numbers:b.match(d)?b.match(d).map(Number):[0],strings:h.str(a)||c?b.split(d):[]}}function P(a){a=a?p(h.arr(a)?a.map(m):m(a)):[];return r(a,
function(a,d,b){return b.indexOf(a)===d})}function Z(a){var c=P(a);return c.map(function(a,b){return{target:a,id:b,total:c.length}})}function aa(a,c){var d=C(c);if(h.arr(a)){var b=a.length;2!==b||h.obj(a[0])?h.fnc(c.duration)||(d.duration=c.duration/b):a={value:a}}return m(a).map(function(a,b){b=b?0:c.delay;a=h.obj(a)&&!h.pth(a)?a:{value:a};h.und(a.delay)&&(a.delay=b);return a}).map(function(a){return z(a,d)})}function ba(a,c){var d={},b;for(b in a){var f=I(a[b],c);h.arr(f)&&(f=f.map(function(a){return I(a,
c)}),1===f.length&&(f=f[0]));d[b]=f}d.duration=parseFloat(d.duration);d.delay=parseFloat(d.delay);return d}function ca(a){return h.arr(a)?A.apply(this,a):Q[a]}function da(a,c){var d;return a.tweens.map(function(b){b=ba(b,c);var f=b.value,e=K(c.target,a.name),k=d?d.to.original:e,k=h.arr(f)?f[0]:k,w=L(h.arr(f)?f[1]:f,k),e=y(w)||y(k)||y(e);b.from=O(k,e);b.to=O(w,e);b.start=d?d.end:a.offset;b.end=b.start+b.delay+b.duration;b.easing=ca(b.easing);b.elasticity=(1E3-Math.min(Math.max(b.elasticity,1),999))/
1E3;b.isPath=h.pth(f);b.isColor=h.col(b.from.original);b.isColor&&(b.round=1);return d=b})}function ea(a,c){return r(p(a.map(function(a){return c.map(function(b){var c=J(a.target,b.name);if(c){var d=da(b,a);b={type:c,property:b.name,animatable:a,tweens:d,duration:d[d.length-1].end,delay:d[0].delay}}else b=void 0;return b})})),function(a){return!h.und(a)})}function R(a,c,d,b){var f="delay"===a;return c.length?(f?Math.min:Math.max).apply(Math,c.map(function(b){return b[a]})):f?b.delay:d.offset+b.delay+
b.duration}function fa(a){var c=D(ga,a),d=D(S,a),b=Z(a.targets),f=[],e=z(c,d),k;for(k in a)e.hasOwnProperty(k)||"targets"===k||f.push({name:k,offset:e.offset,tweens:aa(a[k],d)});a=ea(b,f);return z(c,{children:[],animatables:b,animations:a,duration:R("duration",a,c,d),delay:R("delay",a,c,d)})}function q(a){function c(){return window.Promise&&new Promise(function(a){return p=a})}function d(a){return g.reversed?g.duration-a:a}function b(a){for(var b=0,c={},d=g.animations,f=d.length;b<f;){var e=d[b],
k=e.animatable,h=e.tweens,n=h.length-1,l=h[n];n&&(l=r(h,function(b){return a<b.end})[0]||l);for(var h=Math.min(Math.max(a-l.start-l.delay,0),l.duration)/l.duration,w=isNaN(h)?1:l.easing(h,l.elasticity),h=l.to.strings,p=l.round,n=[],m=void 0,m=l.to.numbers.length,t=0;t<m;t++){var x=void 0,x=l.to.numbers[t],q=l.from.numbers[t],x=l.isPath?Y(l.value,w*x):q+w*(x-q);p&&(l.isColor&&2<t||(x=Math.round(x*p)/p));n.push(x)}if(l=h.length)for(m=h[0],w=0;w<l;w++)p=h[w+1],t=n[w],isNaN(t)||(m=p?m+(t+p):m+(t+" "));
else m=n[0];ha[e.type](k.target,e.property,m,c,k.id);e.currentValue=m;b++}if(b=Object.keys(c).length)for(d=0;d<b;d++)H||(H=E(document.body,"transform")?"transform":"-webkit-transform"),g.animatables[d].target.style[H]=c[d].join(" ");g.currentTime=a;g.progress=a/g.duration*100}function f(a){if(g[a])g[a](g)}function e(){g.remaining&&!0!==g.remaining&&g.remaining--}function k(a){var k=g.duration,n=g.offset,w=n+g.delay,r=g.currentTime,x=g.reversed,q=d(a);if(g.children.length){var u=g.children,v=u.length;
if(q>=g.currentTime)for(var G=0;G<v;G++)u[G].seek(q);else for(;v--;)u[v].seek(q)}if(q>=w||!k)g.began||(g.began=!0,f("begin")),f("run");if(q>n&&q<k)b(q);else if(q<=n&&0!==r&&(b(0),x&&e()),q>=k&&r!==k||!k)b(k),x||e();f("update");a>=k&&(g.remaining?(t=h,"alternate"===g.direction&&(g.reversed=!g.reversed)):(g.pause(),g.completed||(g.completed=!0,f("complete"),"Promise"in window&&(p(),m=c()))),l=0)}a=void 0===a?{}:a;var h,t,l=0,p=null,m=c(),g=fa(a);g.reset=function(){var a=g.direction,c=g.loop;g.currentTime=
0;g.progress=0;g.paused=!0;g.began=!1;g.completed=!1;g.reversed="reverse"===a;g.remaining="alternate"===a&&1===c?2:c;b(0);for(a=g.children.length;a--;)g.children[a].reset()};g.tick=function(a){h=a;t||(t=h);k((l+h-t)*q.speed)};g.seek=function(a){k(d(a))};g.pause=function(){var a=v.indexOf(g);-1<a&&v.splice(a,1);g.paused=!0};g.play=function(){g.paused&&(g.paused=!1,t=0,l=d(g.currentTime),v.push(g),B||ia())};g.reverse=function(){g.reversed=!g.reversed;t=0;l=d(g.currentTime)};g.restart=function(){g.pause();
g.reset();g.play()};g.finished=m;g.reset();g.autoplay&&g.play();return g}var ga={update:void 0,begin:void 0,run:void 0,complete:void 0,loop:1,direction:"normal",autoplay:!0,offset:0},S={duration:1E3,delay:0,easing:"easeOutElastic",elasticity:500,round:0},W="translateX translateY translateZ rotate rotateX rotateY rotateZ scale scaleX scaleY scaleZ skewX skewY perspective".split(" "),H,h={arr:function(a){return Array.isArray(a)},obj:function(a){return-1<Object.prototype.toString.call(a).indexOf("Object")},
pth:function(a){return h.obj(a)&&a.hasOwnProperty("totalLength")},svg:function(a){return a instanceof SVGElement},dom:function(a){return a.nodeType||h.svg(a)},str:function(a){return"string"===typeof a},fnc:function(a){return"function"===typeof a},und:function(a){return"undefined"===typeof a},hex:function(a){return/(^#[0-9A-F]{6}$)|(^#[0-9A-F]{3}$)/i.test(a)},rgb:function(a){return/^rgb/.test(a)},hsl:function(a){return/^hsl/.test(a)},col:function(a){return h.hex(a)||h.rgb(a)||h.hsl(a)}},A=function(){function a(a,
d,b){return(((1-3*b+3*d)*a+(3*b-6*d))*a+3*d)*a}return function(c,d,b,f){if(0<=c&&1>=c&&0<=b&&1>=b){var e=new Float32Array(11);if(c!==d||b!==f)for(var k=0;11>k;++k)e[k]=a(.1*k,c,b);return function(k){if(c===d&&b===f)return k;if(0===k)return 0;if(1===k)return 1;for(var h=0,l=1;10!==l&&e[l]<=k;++l)h+=.1;--l;var l=h+(k-e[l])/(e[l+1]-e[l])*.1,n=3*(1-3*b+3*c)*l*l+2*(3*b-6*c)*l+3*c;if(.001<=n){for(h=0;4>h;++h){n=3*(1-3*b+3*c)*l*l+2*(3*b-6*c)*l+3*c;if(0===n)break;var m=a(l,c,b)-k,l=l-m/n}k=l}else if(0===
n)k=l;else{var l=h,h=h+.1,g=0;do m=l+(h-l)/2,n=a(m,c,b)-k,0<n?h=m:l=m;while(1e-7<Math.abs(n)&&10>++g);k=m}return a(k,d,f)}}}}(),Q=function(){function a(a,b){return 0===a||1===a?a:-Math.pow(2,10*(a-1))*Math.sin(2*(a-1-b/(2*Math.PI)*Math.asin(1))*Math.PI/b)}var c="Quad Cubic Quart Quint Sine Expo Circ Back Elastic".split(" "),d={In:[[.55,.085,.68,.53],[.55,.055,.675,.19],[.895,.03,.685,.22],[.755,.05,.855,.06],[.47,0,.745,.715],[.95,.05,.795,.035],[.6,.04,.98,.335],[.6,-.28,.735,.045],a],Out:[[.25,
.46,.45,.94],[.215,.61,.355,1],[.165,.84,.44,1],[.23,1,.32,1],[.39,.575,.565,1],[.19,1,.22,1],[.075,.82,.165,1],[.175,.885,.32,1.275],function(b,c){return 1-a(1-b,c)}],InOut:[[.455,.03,.515,.955],[.645,.045,.355,1],[.77,0,.175,1],[.86,0,.07,1],[.445,.05,.55,.95],[1,0,0,1],[.785,.135,.15,.86],[.68,-.55,.265,1.55],function(b,c){return.5>b?a(2*b,c)/2:1-a(-2*b+2,c)/2}]},b={linear:A(.25,.25,.75,.75)},f={},e;for(e in d)f.type=e,d[f.type].forEach(function(a){return function(d,f){b["ease"+a.type+c[f]]=h.fnc(d)?
d:A.apply($jscomp$this,d)}}(f)),f={type:f.type};return b}(),ha={css:function(a,c,d){return a.style[c]=d},attribute:function(a,c,d){return a.setAttribute(c,d)},object:function(a,c,d){return a[c]=d},transform:function(a,c,d,b,f){b[f]||(b[f]=[]);b[f].push(c+"("+d+")")}},v=[],B=0,ia=function(){function a(){B=requestAnimationFrame(c)}function c(c){var b=v.length;if(b){for(var d=0;d<b;)v[d]&&v[d].tick(c),d++;a()}else cancelAnimationFrame(B),B=0}return a}();q.version="2.2.0";q.speed=1;q.running=v;q.remove=
function(a){a=P(a);for(var c=v.length;c--;)for(var d=v[c],b=d.animations,f=b.length;f--;)u(a,b[f].animatable.target)&&(b.splice(f,1),b.length||d.pause())};q.getValue=K;q.path=function(a,c){var d=h.str(a)?e(a)[0]:a,b=c||100;return function(a){return{el:d,property:a,totalLength:N(d)*(b/100)}}};q.setDashoffset=function(a){var c=N(a);a.setAttribute("stroke-dasharray",c);return c};q.bezier=A;q.easings=Q;q.timeline=function(a){var c=q(a);c.pause();c.duration=0;c.add=function(d){c.children.forEach(function(a){a.began=
!0;a.completed=!0});m(d).forEach(function(b){var d=z(b,D(S,a||{}));d.targets=d.targets||a.targets;b=c.duration;var e=d.offset;d.autoplay=!1;d.direction=c.direction;d.offset=h.und(e)?b:L(e,b);c.began=!0;c.completed=!0;c.seek(d.offset);d=q(d);d.began=!0;d.completed=!0;d.duration>b&&(c.duration=d.duration);c.children.push(d)});c.seek(0);c.reset();c.autoplay&&c.restart();return c};return c};q.random=function(a,c){return Math.floor(Math.random()*(c-a+1))+a};return q});
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29)))

/***/ }),
/* 34 */
/***/ (function(module, exports, __webpack_require__) {

exports.__esModule = true;
exports.Helmet = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _reactSideEffect = __webpack_require__(766);

var _reactSideEffect2 = _interopRequireDefault(_reactSideEffect);

var _reactFastCompare = __webpack_require__(768);

var _reactFastCompare2 = _interopRequireDefault(_reactFastCompare);

var _HelmetUtils = __webpack_require__(769);

var _HelmetConstants = __webpack_require__(319);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Helmet = function Helmet(Component) {
    var _class, _temp;

    return _temp = _class = function (_React$Component) {
        _inherits(HelmetWrapper, _React$Component);

        function HelmetWrapper() {
            _classCallCheck(this, HelmetWrapper);

            return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
        }

        HelmetWrapper.prototype.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
            return !(0, _reactFastCompare2.default)(this.props, nextProps);
        };

        HelmetWrapper.prototype.mapNestedChildrenToProps = function mapNestedChildrenToProps(child, nestedChildren) {
            if (!nestedChildren) {
                return null;
            }

            switch (child.type) {
                case _HelmetConstants.TAG_NAMES.SCRIPT:
                case _HelmetConstants.TAG_NAMES.NOSCRIPT:
                    return {
                        innerHTML: nestedChildren
                    };

                case _HelmetConstants.TAG_NAMES.STYLE:
                    return {
                        cssText: nestedChildren
                    };
            }

            throw new Error("<" + child.type + " /> elements are self-closing and can not contain children. Refer to our API for more information.");
        };

        HelmetWrapper.prototype.flattenArrayTypeChildren = function flattenArrayTypeChildren(_ref) {
            var _extends2;

            var child = _ref.child,
                arrayTypeChildren = _ref.arrayTypeChildren,
                newChildProps = _ref.newChildProps,
                nestedChildren = _ref.nestedChildren;

            return _extends({}, arrayTypeChildren, (_extends2 = {}, _extends2[child.type] = [].concat(arrayTypeChildren[child.type] || [], [_extends({}, newChildProps, this.mapNestedChildrenToProps(child, nestedChildren))]), _extends2));
        };

        HelmetWrapper.prototype.mapObjectTypeChildren = function mapObjectTypeChildren(_ref2) {
            var _extends3, _extends4;

            var child = _ref2.child,
                newProps = _ref2.newProps,
                newChildProps = _ref2.newChildProps,
                nestedChildren = _ref2.nestedChildren;

            switch (child.type) {
                case _HelmetConstants.TAG_NAMES.TITLE:
                    return _extends({}, newProps, (_extends3 = {}, _extends3[child.type] = nestedChildren, _extends3.titleAttributes = _extends({}, newChildProps), _extends3));

                case _HelmetConstants.TAG_NAMES.BODY:
                    return _extends({}, newProps, {
                        bodyAttributes: _extends({}, newChildProps)
                    });

                case _HelmetConstants.TAG_NAMES.HTML:
                    return _extends({}, newProps, {
                        htmlAttributes: _extends({}, newChildProps)
                    });
            }

            return _extends({}, newProps, (_extends4 = {}, _extends4[child.type] = _extends({}, newChildProps), _extends4));
        };

        HelmetWrapper.prototype.mapArrayTypeChildrenToProps = function mapArrayTypeChildrenToProps(arrayTypeChildren, newProps) {
            var newFlattenedProps = _extends({}, newProps);

            Object.keys(arrayTypeChildren).forEach(function (arrayChildName) {
                var _extends5;

                newFlattenedProps = _extends({}, newFlattenedProps, (_extends5 = {}, _extends5[arrayChildName] = arrayTypeChildren[arrayChildName], _extends5));
            });

            return newFlattenedProps;
        };

        HelmetWrapper.prototype.warnOnInvalidChildren = function warnOnInvalidChildren(child, nestedChildren) {
            if (false) {
                if (!_HelmetConstants.VALID_TAG_NAMES.some(function (name) {
                    return child.type === name;
                })) {
                    if (typeof child.type === "function") {
                        return (0, _HelmetUtils.warn)("You may be attempting to nest <Helmet> components within each other, which is not allowed. Refer to our API for more information.");
                    }

                    return (0, _HelmetUtils.warn)("Only elements types " + _HelmetConstants.VALID_TAG_NAMES.join(", ") + " are allowed. Helmet does not support rendering <" + child.type + "> elements. Refer to our API for more information.");
                }

                if (nestedChildren && typeof nestedChildren !== "string" && (!Array.isArray(nestedChildren) || nestedChildren.some(function (nestedChild) {
                    return typeof nestedChild !== "string";
                }))) {
                    throw new Error("Helmet expects a string as a child of <" + child.type + ">. Did you forget to wrap your children in braces? ( <" + child.type + ">{``}</" + child.type + "> ) Refer to our API for more information.");
                }
            }

            return true;
        };

        HelmetWrapper.prototype.mapChildrenToProps = function mapChildrenToProps(children, newProps) {
            var _this2 = this;

            var arrayTypeChildren = {};

            _react2.default.Children.forEach(children, function (child) {
                if (!child || !child.props) {
                    return;
                }

                var _child$props = child.props,
                    nestedChildren = _child$props.children,
                    childProps = _objectWithoutProperties(_child$props, ["children"]);

                var newChildProps = (0, _HelmetUtils.convertReactPropstoHtmlAttributes)(childProps);

                _this2.warnOnInvalidChildren(child, nestedChildren);

                switch (child.type) {
                    case _HelmetConstants.TAG_NAMES.LINK:
                    case _HelmetConstants.TAG_NAMES.META:
                    case _HelmetConstants.TAG_NAMES.NOSCRIPT:
                    case _HelmetConstants.TAG_NAMES.SCRIPT:
                    case _HelmetConstants.TAG_NAMES.STYLE:
                        arrayTypeChildren = _this2.flattenArrayTypeChildren({
                            child: child,
                            arrayTypeChildren: arrayTypeChildren,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;

                    default:
                        newProps = _this2.mapObjectTypeChildren({
                            child: child,
                            newProps: newProps,
                            newChildProps: newChildProps,
                            nestedChildren: nestedChildren
                        });
                        break;
                }
            });

            newProps = this.mapArrayTypeChildrenToProps(arrayTypeChildren, newProps);
            return newProps;
        };

        HelmetWrapper.prototype.render = function render() {
            var _props = this.props,
                children = _props.children,
                props = _objectWithoutProperties(_props, ["children"]);

            var newProps = _extends({}, props);

            if (children) {
                newProps = this.mapChildrenToProps(children, newProps);
            }

            return _react2.default.createElement(Component, newProps);
        };

        _createClass(HelmetWrapper, null, [{
            key: "canUseDOM",


            // Component.peek comes from react-side-effect:
            // For testing, you may use a static peek() method available on the returned component.
            // It lets you get the current state without resetting the mounted instance stack.
            // Don’t use it for anything other than testing.

            /**
             * @param {Object} base: {"target": "_blank", "href": "http://mysite.com/"}
             * @param {Object} bodyAttributes: {"className": "root"}
             * @param {String} defaultTitle: "Default Title"
             * @param {Boolean} defer: true
             * @param {Boolean} encodeSpecialCharacters: true
             * @param {Object} htmlAttributes: {"lang": "en", "amp": undefined}
             * @param {Array} link: [{"rel": "canonical", "href": "http://mysite.com/example"}]
             * @param {Array} meta: [{"name": "description", "content": "Test description"}]
             * @param {Array} noscript: [{"innerHTML": "<img src='http://mysite.com/js/test.js'"}]
             * @param {Function} onChangeClientState: "(newState) => console.log(newState)"
             * @param {Array} script: [{"type": "text/javascript", "src": "http://mysite.com/js/test.js"}]
             * @param {Array} style: [{"type": "text/css", "cssText": "div { display: block; color: blue; }"}]
             * @param {String} title: "Title"
             * @param {Object} titleAttributes: {"itemprop": "name"}
             * @param {String} titleTemplate: "MySite.com - %s"
             */
            set: function set(canUseDOM) {
                Component.canUseDOM = canUseDOM;
            }
        }]);

        return HelmetWrapper;
    }(_react2.default.Component), _class.propTypes = {
        base: _propTypes2.default.object,
        bodyAttributes: _propTypes2.default.object,
        children: _propTypes2.default.oneOfType([_propTypes2.default.arrayOf(_propTypes2.default.node), _propTypes2.default.node]),
        defaultTitle: _propTypes2.default.string,
        defer: _propTypes2.default.bool,
        encodeSpecialCharacters: _propTypes2.default.bool,
        htmlAttributes: _propTypes2.default.object,
        link: _propTypes2.default.arrayOf(_propTypes2.default.object),
        meta: _propTypes2.default.arrayOf(_propTypes2.default.object),
        noscript: _propTypes2.default.arrayOf(_propTypes2.default.object),
        onChangeClientState: _propTypes2.default.func,
        script: _propTypes2.default.arrayOf(_propTypes2.default.object),
        style: _propTypes2.default.arrayOf(_propTypes2.default.object),
        title: _propTypes2.default.string,
        titleAttributes: _propTypes2.default.object,
        titleTemplate: _propTypes2.default.string
    }, _class.defaultProps = {
        defer: true,
        encodeSpecialCharacters: true
    }, _class.peek = Component.peek, _class.rewind = function () {
        var mappedState = Component.rewind();
        if (!mappedState) {
            // provide fallback if mappedState is undefined
            mappedState = (0, _HelmetUtils.mapStateOnServer)({
                baseTag: [],
                bodyAttributes: {},
                encodeSpecialCharacters: true,
                htmlAttributes: {},
                linkTags: [],
                metaTags: [],
                noscriptTags: [],
                scriptTags: [],
                styleTags: [],
                title: "",
                titleAttributes: {}
            });
        }

        return mappedState;
    }, _temp;
};

var NullComponent = function NullComponent() {
    return null;
};

var HelmetSideEffects = (0, _reactSideEffect2.default)(_HelmetUtils.reducePropsToState, _HelmetUtils.handleClientStateChange, _HelmetUtils.mapStateOnServer)(NullComponent);

var HelmetExport = Helmet(HelmetSideEffects);
HelmetExport.renderStatic = HelmetExport.rewind;

exports.Helmet = HelmetExport;
exports.default = HelmetExport;

/***/ }),
/* 35 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var invariant = function(condition, format, a, b, c, d, e, f) {
  if (false) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  }

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error(
        'Minified exception occurred; use the non-minified dev environment ' +
        'for the full error message and additional helpful warnings.'
      );
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(
        format.replace(/%s/g, function() { return args[argIndex++]; })
      );
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
};

module.exports = invariant;


/***/ }),
/* 36 */
/***/ (function(module, exports, __webpack_require__) {

var baseMatches = __webpack_require__(429),
    baseMatchesProperty = __webpack_require__(475),
    identity = __webpack_require__(98),
    isArray = __webpack_require__(13),
    property = __webpack_require__(479);

/**
 * The base implementation of `_.iteratee`.
 *
 * @private
 * @param {*} [value=_.identity] The value to convert to an iteratee.
 * @returns {Function} Returns the iteratee.
 */
function baseIteratee(value) {
  // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
  // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
  if (typeof value == 'function') {
    return value;
  }
  if (value == null) {
    return identity;
  }
  if (typeof value == 'object') {
    return isArray(value)
      ? baseMatchesProperty(value[0], value[1])
      : baseMatches(value);
  }
  return property(value);
}

module.exports = baseIteratee;


/***/ }),
/* 37 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(639);


/***/ }),
/* 38 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return switchLanguage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionType__ = __webpack_require__(18);
var switchLanguage=function switchLanguage(language){return function(dispatch,getState){var currentActive=getState().language.currentActive;if(currentActive!==language){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__actionType__["j" /* SWITCH_LANGUAGE */],language:language});}};};

/***/ }),
/* 39 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__ = __webpack_require__(407);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__BrowserRouter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__HashRouter__ = __webpack_require__(412);
/* unused harmony reexport HashRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Link__ = __webpack_require__(220);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__Link__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__MemoryRouter__ = __webpack_require__(413);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__NavLink__ = __webpack_require__(414);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_4__NavLink__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Prompt__ = __webpack_require__(416);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Redirect__ = __webpack_require__(417);
/* unused harmony reexport Redirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Route__ = __webpack_require__(222);
/* unused harmony reexport Route */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Router__ = __webpack_require__(143);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__StaticRouter__ = __webpack_require__(418);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Switch__ = __webpack_require__(419);
/* unused harmony reexport Switch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__generatePath__ = __webpack_require__(420);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__matchPath__ = __webpack_require__(421);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__withRouter__ = __webpack_require__(422);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_13__withRouter__["a"]; });





























/***/ }),
/* 40 */
/***/ (function(module, exports, __webpack_require__) {

var freeGlobal = __webpack_require__(231);

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

module.exports = root;


/***/ }),
/* 41 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(149),
    isLength = __webpack_require__(156);

/**
 * Checks if `value` is array-like. A value is considered array-like if it's
 * not a function and has a `value.length` that's an integer greater than or
 * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
 * @example
 *
 * _.isArrayLike([1, 2, 3]);
 * // => true
 *
 * _.isArrayLike(document.body.children);
 * // => true
 *
 * _.isArrayLike('abc');
 * // => true
 *
 * _.isArrayLike(_.noop);
 * // => false
 */
function isArrayLike(value) {
  return value != null && isLength(value.length) && !isFunction(value);
}

module.exports = isArrayLike;


/***/ }),
/* 42 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(257),
    isArrayLike = __webpack_require__(41),
    isString = __webpack_require__(258),
    toInteger = __webpack_require__(165),
    values = __webpack_require__(506);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * Checks if `value` is in `collection`. If `collection` is a string, it's
 * checked for a substring of `value`, otherwise
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * is used for equality comparisons. If `fromIndex` is negative, it's used as
 * the offset from the end of `collection`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @param {*} value The value to search for.
 * @param {number} [fromIndex=0] The index to search from.
 * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
 * @returns {boolean} Returns `true` if `value` is found, else `false`.
 * @example
 *
 * _.includes([1, 2, 3], 1);
 * // => true
 *
 * _.includes([1, 2, 3], 1, 2);
 * // => false
 *
 * _.includes({ 'a': 1, 'b': 2 }, 1);
 * // => true
 *
 * _.includes('abcd', 'bc');
 * // => true
 */
function includes(collection, value, fromIndex, guard) {
  collection = isArrayLike(collection) ? collection : values(collection);
  fromIndex = (fromIndex && !guard) ? toInteger(fromIndex) : 0;

  var length = collection.length;
  if (fromIndex < 0) {
    fromIndex = nativeMax(length + fromIndex, 0);
  }
  return isString(collection)
    ? (fromIndex <= length && collection.indexOf(value, fromIndex) > -1)
    : (!!length && baseIndexOf(collection, value, fromIndex) > -1);
}

module.exports = includes;


/***/ }),
/* 43 */
/***/ (function(module, exports) {

var core = module.exports = { version: '2.6.12' };
if (typeof __e == 'number') __e = core; // eslint-disable-line no-undef


/***/ }),
/* 44 */
/***/ (function(module, exports, __webpack_require__) {

var store = __webpack_require__(178)('wks');
var uid = __webpack_require__(129);
var Symbol = __webpack_require__(52).Symbol;
var USE_SYMBOL = typeof Symbol == 'function';

var $exports = module.exports = function (name) {
  return store[name] || (store[name] =
    USE_SYMBOL && Symbol[name] || (USE_SYMBOL ? Symbol : uid)('Symbol.' + name));
};

$exports.store = store;


/***/ }),
/* 45 */
/***/ (function(module, exports, __webpack_require__) {

var arrayReduce = __webpack_require__(772),
    baseEach = __webpack_require__(123),
    baseIteratee = __webpack_require__(36),
    baseReduce = __webpack_require__(773),
    isArray = __webpack_require__(13);

/**
 * Reduces `collection` to a value which is the accumulated result of running
 * each element in `collection` thru `iteratee`, where each successive
 * invocation is supplied the return value of the previous. If `accumulator`
 * is not given, the first element of `collection` is used as the initial
 * value. The iteratee is invoked with four arguments:
 * (accumulator, value, index|key, collection).
 *
 * Many lodash methods are guarded to work as iteratees for methods like
 * `_.reduce`, `_.reduceRight`, and `_.transform`.
 *
 * The guarded methods are:
 * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
 * and `sortBy`
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @returns {*} Returns the accumulated value.
 * @see _.reduceRight
 * @example
 *
 * _.reduce([1, 2], function(sum, n) {
 *   return sum + n;
 * }, 0);
 * // => 3
 *
 * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
 *   (result[value] || (result[value] = [])).push(key);
 *   return result;
 * }, {});
 * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
 */
function reduce(collection, iteratee, accumulator) {
  var func = isArray(collection) ? arrayReduce : baseReduce,
      initAccum = arguments.length < 3;

  return func(collection, baseIteratee(iteratee, 4), accumulator, initAccum, baseEach);
}

module.exports = reduce;


/***/ }),
/* 46 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.formatTime = formatTime;
exports.isVideoChild = isVideoChild;
exports.mergeAndSortChildren = mergeAndSortChildren;
exports.deprecatedWarning = deprecatedWarning;
exports.throttle = throttle;
exports.mediaProperties = void 0;

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(343));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(57));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(206));

var _react = _interopRequireDefault(__webpack_require__(0));

// NaN is the only value in javascript which is not equal to itself.
// eslint-disable-next-line no-self-compare
var isNaN = Number.isNaN || function (value) {
  return value !== value;
};
/**
 * @file format-time.js
 *
 * Format seconds as a time string, H:MM:SS or M:SS
 * Supplying a guide (in seconds) will force a number of leading zeros
 * to cover the length of the guide
 *
 * @param  {Number} seconds Number of seconds to be turned into a string
 * @param  {Number} guide   Number (in seconds) to model the string after
 * @return {String}         Time formatted as H:MM:SS or M:SS
 * @private
 * @function formatTime
 */


function formatTime() {
  var seconds = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  var guide = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : seconds;
  var s = Math.floor(seconds % 60);
  var m = Math.floor(seconds / 60 % 60);
  var h = Math.floor(seconds / 3600);
  var gm = Math.floor(guide / 60 % 60);
  var gh = Math.floor(guide / 3600); // handle invalid times

  if (isNaN(seconds) || seconds === Infinity) {
    // '-' is false for all relational operators (e.g. <, >=) so this setting
    // will add the minimum number of fields specified by the guide
    h = '-';
    m = '-';
    s = '-';
  } // Check if we need to show hours


  h = h > 0 || gh > 0 ? "".concat(h, ":") : ''; // If hours are showing, we may need to add a leading zero.
  // Always show at least one digit of minutes.

  m = "".concat((h || gm >= 10) && m < 10 ? "0".concat(m) : m, ":"); // Check if leading zero is need for seconds

  s = s < 10 ? "0".concat(s) : s;
  return h + m + s;
} // Check if the element belongs to a video element
// only accept <source />, <track />,
// <MyComponent isVideoChild />
// elements


function isVideoChild(c) {
  if (c.props && c.props.isVideoChild) {
    return true;
  }

  return c.type === 'source' || c.type === 'track';
}

var find = function find(elements, func) {
  return elements.filter(func)[0];
}; // check if two components are the same type


var isTypeEqual = function isTypeEqual(component1, component2) {
  var type1 = component1.type;
  var type2 = component2.type;

  if (typeof type1 === 'string' || typeof type2 === 'string') {
    return type1 === type2;
  }

  if (typeof type1 === 'function' && typeof type2 === 'function') {
    return type1.displayName === type2.displayName;
  }

  return false;
}; // merge default children
// sort them by `order` property
// filter them by `disabled` property


function mergeAndSortChildren(defaultChildren, _children, _parentProps) {
  var defaultOrder = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 1;

  var children = _react["default"].Children.toArray(_children);

  var order = _parentProps.order,
      parentProps = (0, _objectWithoutProperties2["default"])(_parentProps, ["order"]); // ignore order from parent

  return children.filter(function (e) {
    return !e.props.disabled;
  }) // filter the disabled components
  .concat(defaultChildren.filter(function (c) {
    return !find(children, function (component) {
      return isTypeEqual(component, c);
    });
  })).map(function (element) {
    var defaultComponent = find(defaultChildren, function (c) {
      return isTypeEqual(c, element);
    });
    var defaultProps = defaultComponent ? defaultComponent.props : {};
    var props = (0, _objectSpread2["default"])({}, parentProps, defaultProps, element.props);

    var e = _react["default"].cloneElement(element, props, element.props.children);

    return e;
  }).sort(function (a, b) {
    return (a.props.order || defaultOrder) - (b.props.order || defaultOrder);
  });
}
/**
 * Temporary utility for generating the warnings
 */


function deprecatedWarning(oldMethodCall, newMethodCall) {
  // eslint-disable-next-line no-console
  console.warn("WARNING: ".concat(oldMethodCall, " will be deprecated soon! Please use ").concat(newMethodCall, " instead."));
}

function throttle(callback, limit) {
  var _arguments = arguments;
  var wait = false;
  return function () {
    if (!wait) {
      // eslint-disable-next-line prefer-rest-params
      callback.apply(void 0, (0, _toConsumableArray2["default"])(_arguments));
      wait = true;
      setTimeout(function () {
        wait = false;
      }, limit);
    }
  };
}

var mediaProperties = ['error', 'src', 'srcObject', 'currentSrc', 'crossOrigin', 'networkState', 'preload', 'buffered', 'readyState', 'seeking', 'currentTime', 'duration', 'paused', 'defaultPlaybackRate', 'playbackRate', 'played', 'seekable', 'ended', 'autoplay', 'loop', 'mediaGroup', 'controller', 'controls', 'volume', 'muted', 'defaultMuted', 'audioTracks', 'videoTracks', 'textTracks', 'width', 'height', 'videoWidth', 'videoHeight', 'poster'];
exports.mediaProperties = mediaProperties;

/***/ }),
/* 47 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 48 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(71),
    getRawTag = __webpack_require__(442),
    objectToString = __webpack_require__(443);

/** `Object#toString` result references. */
var nullTag = '[object Null]',
    undefinedTag = '[object Undefined]';

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * The base implementation of `getTag` without fallbacks for buggy environments.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
function baseGetTag(value) {
  if (value == null) {
    return value === undefined ? undefinedTag : nullTag;
  }
  return (symToStringTag && symToStringTag in Object(value))
    ? getRawTag(value)
    : objectToString(value);
}

module.exports = baseGetTag;


/***/ }),
/* 49 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _assign = __webpack_require__(562);

var _assign2 = _interopRequireDefault(_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _assign2.default || function (target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i];

    for (var key in source) {
      if (Object.prototype.hasOwnProperty.call(source, key)) {
        target[key] = source[key];
      }
    }
  }

  return target;
};

/***/ }),
/* 50 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(393);
} else {
  module.exports = require('./cjs/react-is.development.js');
}


/***/ }),
/* 51 */
/***/ (function(module, exports, __webpack_require__) {

var baseKeys = __webpack_require__(157),
    getTag = __webpack_require__(72),
    isArguments = __webpack_require__(92),
    isArray = __webpack_require__(13),
    isArrayLike = __webpack_require__(41),
    isBuffer = __webpack_require__(93),
    isPrototype = __webpack_require__(122),
    isTypedArray = __webpack_require__(120);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if `value` is an empty object, collection, map, or set.
 *
 * Objects are considered empty if they have no own enumerable string keyed
 * properties.
 *
 * Array-like values such as `arguments` objects, arrays, buffers, strings, or
 * jQuery-like collections are considered empty if they have a `length` of `0`.
 * Similarly, maps and sets are considered empty if they have a `size` of `0`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is empty, else `false`.
 * @example
 *
 * _.isEmpty(null);
 * // => true
 *
 * _.isEmpty(true);
 * // => true
 *
 * _.isEmpty(1);
 * // => true
 *
 * _.isEmpty([1, 2, 3]);
 * // => false
 *
 * _.isEmpty({ 'a': 1 });
 * // => false
 */
function isEmpty(value) {
  if (value == null) {
    return true;
  }
  if (isArrayLike(value) &&
      (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' ||
        isBuffer(value) || isTypedArray(value) || isArguments(value))) {
    return !value.length;
  }
  var tag = getTag(value);
  if (tag == mapTag || tag == setTag) {
    return !value.size;
  }
  if (isPrototype(value)) {
    return !baseKeys(value).length;
  }
  for (var key in value) {
    if (hasOwnProperty.call(value, key)) {
      return false;
    }
  }
  return true;
}

module.exports = isEmpty;


/***/ }),
/* 52 */
/***/ (function(module, exports) {

// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
var global = module.exports = typeof window != 'undefined' && window.Math == Math
  ? window : typeof self != 'undefined' && self.Math == Math ? self
  // eslint-disable-next-line no-new-func
  : Function('return this')();
if (typeof __g == 'number') __g = global; // eslint-disable-line no-undef


/***/ }),
/* 53 */
/***/ (function(module, exports, __webpack_require__) {

var anObject = __webpack_require__(78);
var IE8_DOM_DEFINE = __webpack_require__(275);
var toPrimitive = __webpack_require__(173);
var dP = Object.defineProperty;

exports.f = __webpack_require__(54) ? Object.defineProperty : function defineProperty(O, P, Attributes) {
  anObject(O);
  P = toPrimitive(P, true);
  anObject(Attributes);
  if (IE8_DOM_DEFINE) try {
    return dP(O, P, Attributes);
  } catch (e) { /* empty */ }
  if ('get' in Attributes || 'set' in Attributes) throw TypeError('Accessors not supported!');
  if ('value' in Attributes) O[P] = Attributes.value;
  return O;
};


/***/ }),
/* 54 */
/***/ (function(module, exports, __webpack_require__) {

// Thank's IE8 for his funny defineProperty
module.exports = !__webpack_require__(105)(function () {
  return Object.defineProperty({}, 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 55 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return switchLocation; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actionType__ = __webpack_require__(18);
var switchLocation=function switchLocation(location){return function(dispatch,getState){var currentActive=getState().location.currentActive;if(currentActive!==location){dispatch({type:__WEBPACK_IMPORTED_MODULE_0__actionType__["k" /* SWITCH_LOCATION */],location:location});}};};

/***/ }),
/* 56 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return isIE; });
var isIE=/*@cc_on!@*/false||!!document.documentMode;// export const isSafari = /constructor/i.test(window.HTMLElement) || (function (p) { return p.toString() === "[object SafariRemoteNotification]"; })(!window['safari'] || (typeof safari !== 'undefined' && safari.pushNotification));

/***/ }),
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(205);
function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? Object(arguments[i]) : {};
    var ownKeys = Object.keys(source);
    if (typeof Object.getOwnPropertySymbols === 'function') {
      ownKeys.push.apply(ownKeys, Object.getOwnPropertySymbols(source).filter(function (sym) {
        return Object.getOwnPropertyDescriptor(source, sym).enumerable;
      }));
    }
    ownKeys.forEach(function (key) {
      defineProperty(target, key, source[key]);
    });
  }
  return target;
}
module.exports = _objectSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 58 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsNative = __webpack_require__(441),
    getValue = __webpack_require__(446);

/**
 * Gets the native function at `key` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the method to get.
 * @returns {*} Returns the function if it's native, else `undefined`.
 */
function getNative(object, key) {
  var value = getValue(object, key);
  return baseIsNative(value) ? value : undefined;
}

module.exports = getNative;


/***/ }),
/* 59 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(240),
    baseKeys = __webpack_require__(157),
    isArrayLike = __webpack_require__(41);

/**
 * Creates an array of the own enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects. See the
 * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * for more details.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keys(new Foo);
 * // => ['a', 'b'] (iteration order is not guaranteed)
 *
 * _.keys('hi');
 * // => ['0', '1']
 */
function keys(object) {
  return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
}

module.exports = keys;


/***/ }),
/* 60 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(24));

var allIcons = _interopRequireWildcard(__webpack_require__(557));

var _iconsReact = _interopRequireDefault(__webpack_require__(273));

var _IconFont = _interopRequireDefault(__webpack_require__(600));

var _utils = __webpack_require__(601);

var _warning = _interopRequireDefault(__webpack_require__(64));

var _LocaleReceiver = _interopRequireDefault(__webpack_require__(186));

var _twoTonePrimaryColor = __webpack_require__(606);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
/* eslint-disable camelcase */


// Initial setting
_iconsReact["default"].add.apply(_iconsReact["default"], _toConsumableArray(Object.keys(allIcons).map(function (key) {
  return allIcons[key];
})));

(0, _twoTonePrimaryColor.setTwoToneColor)('#1890ff');
var defaultTheme = 'outlined';
var dangerousTheme;

function unstable_ChangeThemeOfIconsDangerously(theme) {
  (0, _warning["default"])(false, 'Icon', "You are using the unstable method 'Icon.unstable_ChangeThemeOfAllIconsDangerously', " + "make sure that all the icons with theme '".concat(theme, "' display correctly."));
  dangerousTheme = theme;
}

function unstable_ChangeDefaultThemeOfIcons(theme) {
  (0, _warning["default"])(false, 'Icon', "You are using the unstable method 'Icon.unstable_ChangeDefaultThemeOfIcons', " + "make sure that all the icons with theme '".concat(theme, "' display correctly."));
  defaultTheme = theme;
}

var Icon = function Icon(props) {
  var _classNames;

  var className = props.className,
      type = props.type,
      Component = props.component,
      viewBox = props.viewBox,
      spin = props.spin,
      rotate = props.rotate,
      tabIndex = props.tabIndex,
      onClick = props.onClick,
      children = props.children,
      theme = props.theme,
      twoToneColor = props.twoToneColor,
      restProps = __rest(props, ["className", "type", "component", "viewBox", "spin", "rotate", "tabIndex", "onClick", "children", "theme", "twoToneColor"]);

  (0, _warning["default"])(Boolean(type || Component || children), 'Icon', 'Should have `type` prop or `component` prop or `children`.');
  var classString = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "anticon", true), _defineProperty(_classNames, "anticon-".concat(type), Boolean(type)), _classNames), className);
  var svgClassString = (0, _classnames["default"])(_defineProperty({}, "anticon-spin", !!spin || type === 'loading'));
  var svgStyle = rotate ? {
    msTransform: "rotate(".concat(rotate, "deg)"),
    transform: "rotate(".concat(rotate, "deg)")
  } : undefined;

  var innerSvgProps = _extends(_extends({}, _utils.svgBaseProps), {
    className: svgClassString,
    style: svgStyle,
    viewBox: viewBox
  });

  if (!viewBox) {
    delete innerSvgProps.viewBox;
  }

  var renderInnerNode = function renderInnerNode() {
    // component > children > type
    if (Component) {
      return /*#__PURE__*/React.createElement(Component, innerSvgProps, children);
    }

    if (children) {
      (0, _warning["default"])(Boolean(viewBox) || React.Children.count(children) === 1 && /*#__PURE__*/React.isValidElement(children) && React.Children.only(children).type === 'use', 'Icon', 'Make sure that you provide correct `viewBox`' + ' prop (default `0 0 1024 1024`) to the icon.');
      return /*#__PURE__*/React.createElement("svg", _extends({}, innerSvgProps, {
        viewBox: viewBox
      }), children);
    }

    if (typeof type === 'string') {
      var computedType = type;

      if (theme) {
        var themeInName = (0, _utils.getThemeFromTypeName)(type);
        (0, _warning["default"])(!themeInName || theme === themeInName, 'Icon', "The icon name '".concat(type, "' already specify a theme '").concat(themeInName, "',") + " the 'theme' prop '".concat(theme, "' will be ignored."));
      }

      computedType = (0, _utils.withThemeSuffix)((0, _utils.removeTypeTheme)((0, _utils.alias)(computedType)), dangerousTheme || theme || defaultTheme);
      return /*#__PURE__*/React.createElement(_iconsReact["default"], {
        className: svgClassString,
        type: computedType,
        primaryColor: twoToneColor,
        style: svgStyle
      });
    }
  };

  var iconTabIndex = tabIndex;

  if (iconTabIndex === undefined && onClick) {
    iconTabIndex = -1;
  }

  return /*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
    componentName: "Icon"
  }, function (locale) {
    return /*#__PURE__*/React.createElement("i", _extends({
      "aria-label": type && "".concat(locale.icon, ": ").concat(type)
    }, restProps, {
      tabIndex: iconTabIndex,
      onClick: onClick,
      className: classString
    }), renderInnerNode());
  });
};

Icon.createFromIconfontCN = _IconFont["default"];
Icon.getTwoToneColor = _twoTonePrimaryColor.getTwoToneColor;
Icon.setTwoToneColor = _twoTonePrimaryColor.setTwoToneColor;
var _default = Icon;
exports["default"] = _default;

/***/ }),
/* 61 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(52);
var core = __webpack_require__(43);
var ctx = __webpack_require__(172);
var hide = __webpack_require__(77);
var has = __webpack_require__(62);
var PROTOTYPE = 'prototype';

var $export = function (type, name, source) {
  var IS_FORCED = type & $export.F;
  var IS_GLOBAL = type & $export.G;
  var IS_STATIC = type & $export.S;
  var IS_PROTO = type & $export.P;
  var IS_BIND = type & $export.B;
  var IS_WRAP = type & $export.W;
  var exports = IS_GLOBAL ? core : core[name] || (core[name] = {});
  var expProto = exports[PROTOTYPE];
  var target = IS_GLOBAL ? global : IS_STATIC ? global[name] : (global[name] || {})[PROTOTYPE];
  var key, own, out;
  if (IS_GLOBAL) source = name;
  for (key in source) {
    // contains in native
    own = !IS_FORCED && target && target[key] !== undefined;
    if (own && has(exports, key)) continue;
    // export native or passed
    out = own ? target[key] : source[key];
    // prevent global pollution for namespaces
    exports[key] = IS_GLOBAL && typeof target[key] != 'function' ? source[key]
    // bind timers to global for call from export context
    : IS_BIND && own ? ctx(out, global)
    // wrap global constructors for prevent change them in library
    : IS_WRAP && target[key] == out ? (function (C) {
      var F = function (a, b, c) {
        if (this instanceof C) {
          switch (arguments.length) {
            case 0: return new C();
            case 1: return new C(a);
            case 2: return new C(a, b);
          } return new C(a, b, c);
        } return C.apply(this, arguments);
      };
      F[PROTOTYPE] = C[PROTOTYPE];
      return F;
    // make static versions for prototype methods
    })(out) : IS_PROTO && typeof out == 'function' ? ctx(Function.call, out) : out;
    // export proto methods to core.%CONSTRUCTOR%.methods.%NAME%
    if (IS_PROTO) {
      (exports.virtual || (exports.virtual = {}))[key] = out;
      // export proto methods to core.%CONSTRUCTOR%.prototype.%NAME%
      if (type & $export.R && expProto && !expProto[key]) hide(expProto, key, out);
    }
  }
};
// type bitmap
$export.F = 1;   // forced
$export.G = 2;   // global
$export.S = 4;   // static
$export.P = 8;   // proto
$export.B = 16;  // bind
$export.W = 32;  // wrap
$export.U = 64;  // safe
$export.R = 128; // real proto method for `library`
module.exports = $export;


/***/ }),
/* 62 */
/***/ (function(module, exports) {

var hasOwnProperty = {}.hasOwnProperty;
module.exports = function (it, key) {
  return hasOwnProperty.call(it, key);
};


/***/ }),
/* 63 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
};

/***/ }),
/* 64 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "resetWarned", {
  enumerable: true,
  get: function get() {
    return _warning.resetWarned;
  }
});
exports["default"] = void 0;

var _warning = _interopRequireWildcard(__webpack_require__(286));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var _default = function _default(valid, component, message) {
  (0, _warning["default"])(valid, "[antd: ".concat(component, "] ").concat(message));
};

exports["default"] = _default;

/***/ }),
/* 65 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return getHeaderHeight; });
var getHeaderHeight=function getHeaderHeight(){var header=document.getElementsByTagName('header')[0];var headerHeight=header.offsetHeight;// Prevent calculate headerheight wrong, due to shrink animation
if(window.innerWidth>1200&&document.documentElement.scrollTop<100)headerHeight=86;return headerHeight;};

/***/ }),
/* 66 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(2);
var path=Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])();/* harmony default export */ __webpack_exports__["a"] = ([{x:560,y:290,width:40,path:path+"/images/partner-logo/logo-angsana-oceanview-residences.svg"},{x:665,y:155,width:80,path:path+"/images/partner-logo/logo-angsana-beachfront-residences.svg"},{x:1065,y:317,width:80,path:path+"/images/partner-logo/logo-banyantree-residences-phuket.svg"},{x:1115,y:213,width:89,path:path+"/images/partner-logo/logo-banyantree-grand-residences.svg"},{x:360,y:230,width:80,path:path+"/images/partner-logo/cassia-phuket.svg"},{x:320,y:300,width:70,path:path+"/images/partner-logo/cassia-residences-phuket.svg"},{x:200,y:370,width:110,path:path+"/images/partner-logo/dhawa-phuket.svg"},{x:935,y:545,width:80,key:"laguna-village-residences",path:path+"/images/partner-logo/laguna-village-residences.svg"},{x:510,y:460,width:80,path:path+"/images/partner-logo/laguna-park.svg"},{x:1205,y:620,width:100,path:path+"/images/partner-logo/loft.svg"},{x:1360,y:810,width:90,height:90,key:"laguna-park2",path:path+"/images/partner-logo/lagunaPark2.svg"},{x:475,y:415,width:40,key:"phuket-skypark",path:path+"/images/partner-logo/phuket-skypark.svg"}]);

/***/ }),
/* 67 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _extends;
function _extends() {
  _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  };
  return _extends.apply(this, arguments);
}

/***/ }),
/* 68 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return createBrowserHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return createHashHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return createMemoryHistory; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createLocation; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return locationsAreEqual; });
/* unused harmony export parsePath */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return createPath; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_resolve_pathname__ = __webpack_require__(408);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_value_equal__ = __webpack_require__(409);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_tiny_warning__ = __webpack_require__(410);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_tiny_invariant__ = __webpack_require__(411);






function addLeadingSlash(path) {
  return path.charAt(0) === '/' ? path : '/' + path;
}
function stripLeadingSlash(path) {
  return path.charAt(0) === '/' ? path.substr(1) : path;
}
function hasBasename(path, prefix) {
  return path.toLowerCase().indexOf(prefix.toLowerCase()) === 0 && '/?#'.indexOf(path.charAt(prefix.length)) !== -1;
}
function stripBasename(path, prefix) {
  return hasBasename(path, prefix) ? path.substr(prefix.length) : path;
}
function stripTrailingSlash(path) {
  return path.charAt(path.length - 1) === '/' ? path.slice(0, -1) : path;
}
function parsePath(path) {
  var pathname = path || '/';
  var search = '';
  var hash = '';
  var hashIndex = pathname.indexOf('#');

  if (hashIndex !== -1) {
    hash = pathname.substr(hashIndex);
    pathname = pathname.substr(0, hashIndex);
  }

  var searchIndex = pathname.indexOf('?');

  if (searchIndex !== -1) {
    search = pathname.substr(searchIndex);
    pathname = pathname.substr(0, searchIndex);
  }

  return {
    pathname: pathname,
    search: search === '?' ? '' : search,
    hash: hash === '#' ? '' : hash
  };
}
function createPath(location) {
  var pathname = location.pathname,
      search = location.search,
      hash = location.hash;
  var path = pathname || '/';
  if (search && search !== '?') path += search.charAt(0) === '?' ? search : "?" + search;
  if (hash && hash !== '#') path += hash.charAt(0) === '#' ? hash : "#" + hash;
  return path;
}

function createLocation(path, state, key, currentLocation) {
  var location;

  if (typeof path === 'string') {
    // Two-arg form: push(path, state)
    location = parsePath(path);
    location.state = state;
  } else {
    // One-arg form: push(location)
    location = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, path);
    if (location.pathname === undefined) location.pathname = '';

    if (location.search) {
      if (location.search.charAt(0) !== '?') location.search = '?' + location.search;
    } else {
      location.search = '';
    }

    if (location.hash) {
      if (location.hash.charAt(0) !== '#') location.hash = '#' + location.hash;
    } else {
      location.hash = '';
    }

    if (state !== undefined && location.state === undefined) location.state = state;
  }

  try {
    location.pathname = decodeURI(location.pathname);
  } catch (e) {
    if (e instanceof URIError) {
      throw new URIError('Pathname "' + location.pathname + '" could not be decoded. ' + 'This is likely caused by an invalid percent-encoding.');
    } else {
      throw e;
    }
  }

  if (key) location.key = key;

  if (currentLocation) {
    // Resolve incomplete/relative pathname relative to current location.
    if (!location.pathname) {
      location.pathname = currentLocation.pathname;
    } else if (location.pathname.charAt(0) !== '/') {
      location.pathname = Object(__WEBPACK_IMPORTED_MODULE_1_resolve_pathname__["a" /* default */])(location.pathname, currentLocation.pathname);
    }
  } else {
    // When there is no prior location and pathname is empty, set it to /
    if (!location.pathname) {
      location.pathname = '/';
    }
  }

  return location;
}
function locationsAreEqual(a, b) {
  return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash && a.key === b.key && Object(__WEBPACK_IMPORTED_MODULE_2_value_equal__["a" /* default */])(a.state, b.state);
}

function createTransitionManager() {
  var prompt = null;

  function setPrompt(nextPrompt) {
     false ? warning(prompt == null, 'A history supports only one prompt at a time') : void 0;
    prompt = nextPrompt;
    return function () {
      if (prompt === nextPrompt) prompt = null;
    };
  }

  function confirmTransitionTo(location, action, getUserConfirmation, callback) {
    // TODO: If another transition starts while we're still confirming
    // the previous one, we may end up in a weird state. Figure out the
    // best way to handle this.
    if (prompt != null) {
      var result = typeof prompt === 'function' ? prompt(location, action) : prompt;

      if (typeof result === 'string') {
        if (typeof getUserConfirmation === 'function') {
          getUserConfirmation(result, callback);
        } else {
           false ? warning(false, 'A history needs a getUserConfirmation function in order to use a prompt message') : void 0;
          callback(true);
        }
      } else {
        // Return false from a transition hook to cancel the transition.
        callback(result !== false);
      }
    } else {
      callback(true);
    }
  }

  var listeners = [];

  function appendListener(fn) {
    var isActive = true;

    function listener() {
      if (isActive) fn.apply(void 0, arguments);
    }

    listeners.push(listener);
    return function () {
      isActive = false;
      listeners = listeners.filter(function (item) {
        return item !== listener;
      });
    };
  }

  function notifyListeners() {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    listeners.forEach(function (listener) {
      return listener.apply(void 0, args);
    });
  }

  return {
    setPrompt: setPrompt,
    confirmTransitionTo: confirmTransitionTo,
    appendListener: appendListener,
    notifyListeners: notifyListeners
  };
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function getConfirmation(message, callback) {
  callback(window.confirm(message)); // eslint-disable-line no-alert
}
/**
 * Returns true if the HTML5 history API is supported. Taken from Modernizr.
 *
 * https://github.com/Modernizr/Modernizr/blob/master/LICENSE
 * https://github.com/Modernizr/Modernizr/blob/master/feature-detects/history.js
 * changed to avoid false negatives for Windows Phones: https://github.com/reactjs/react-router/issues/586
 */

function supportsHistory() {
  var ua = window.navigator.userAgent;
  if ((ua.indexOf('Android 2.') !== -1 || ua.indexOf('Android 4.0') !== -1) && ua.indexOf('Mobile Safari') !== -1 && ua.indexOf('Chrome') === -1 && ua.indexOf('Windows Phone') === -1) return false;
  return window.history && 'pushState' in window.history;
}
/**
 * Returns true if browser fires popstate on hash change.
 * IE10 and IE11 do not.
 */

function supportsPopStateOnHashChange() {
  return window.navigator.userAgent.indexOf('Trident') === -1;
}
/**
 * Returns false if using go(n) with hash history causes a full page reload.
 */

function supportsGoWithoutReloadUsingHash() {
  return window.navigator.userAgent.indexOf('Firefox') === -1;
}
/**
 * Returns true if a given popstate event is an extraneous WebKit event.
 * Accounts for the fact that Chrome on iOS fires real popstate events
 * containing undefined state when pressing the back button.
 */

function isExtraneousPopstateEvent(event) {
  return event.state === undefined && navigator.userAgent.indexOf('CriOS') === -1;
}

var PopStateEvent = 'popstate';
var HashChangeEvent = 'hashchange';

function getHistoryState() {
  try {
    return window.history.state || {};
  } catch (e) {
    // IE 11 sometimes throws when accessing window.history.state
    // See https://github.com/ReactTraining/history/pull/289
    return {};
  }
}
/**
 * Creates a history object that uses the HTML5 history API including
 * pushState, replaceState, and the popstate event.
 */


function createBrowserHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Browser history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canUseHistory = supportsHistory();
  var needsHashChangeListener = !supportsPopStateOnHashChange();
  var _props = props,
      _props$forceRefresh = _props.forceRefresh,
      forceRefresh = _props$forceRefresh === void 0 ? false : _props$forceRefresh,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';

  function getDOMLocation(historyState) {
    var _ref = historyState || {},
        key = _ref.key,
        state = _ref.state;

    var _window$location = window.location,
        pathname = _window$location.pathname,
        search = _window$location.search,
        hash = _window$location.hash;
    var path = pathname + search + hash;
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path, state, key);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function handlePopState(event) {
    // Ignore extraneous popstate events in WebKit.
    if (isExtraneousPopstateEvent(event)) return;
    handlePop(getDOMLocation(event.state));
  }

  function handleHashChange() {
    handlePop(getDOMLocation(getHistoryState()));
  }

  var forceNextPop = false;

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of keys we've seen in sessionStorage.
    // Instead, we just default to 0 for keys we don't know.

    var toIndex = allKeys.indexOf(toLocation.key);
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allKeys.indexOf(fromLocation.key);
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  }

  var initialLocation = getDOMLocation(getHistoryState());
  var allKeys = [initialLocation.key]; // Public interface

  function createHref(location) {
    return basename + createPath(location);
  }

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.pushState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.href = href;
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          var nextKeys = allKeys.slice(0, prevIndex + 1);
          nextKeys.push(location.key);
          allKeys = nextKeys;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot push state in browsers that do not support HTML5 history') : void 0;
        window.location.href = href;
      }
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var href = createHref(location);
      var key = location.key,
          state = location.state;

      if (canUseHistory) {
        globalHistory.replaceState({
          key: key,
          state: state
        }, null, href);

        if (forceRefresh) {
          window.location.replace(href);
        } else {
          var prevIndex = allKeys.indexOf(history.location.key);
          if (prevIndex !== -1) allKeys[prevIndex] = location.key;
          setState({
            action: action,
            location: location
          });
        }
      } else {
         false ? warning(state === undefined, 'Browser history cannot replace state in browsers that do not support HTML5 history') : void 0;
        window.location.replace(href);
      }
    });
  }

  function go(n) {
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.addEventListener(HashChangeEvent, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(PopStateEvent, handlePopState);
      if (needsHashChangeListener) window.removeEventListener(HashChangeEvent, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

var HashChangeEvent$1 = 'hashchange';
var HashPathCoders = {
  hashbang: {
    encodePath: function encodePath(path) {
      return path.charAt(0) === '!' ? path : '!/' + stripLeadingSlash(path);
    },
    decodePath: function decodePath(path) {
      return path.charAt(0) === '!' ? path.substr(1) : path;
    }
  },
  noslash: {
    encodePath: stripLeadingSlash,
    decodePath: addLeadingSlash
  },
  slash: {
    encodePath: addLeadingSlash,
    decodePath: addLeadingSlash
  }
};

function stripHash(url) {
  var hashIndex = url.indexOf('#');
  return hashIndex === -1 ? url : url.slice(0, hashIndex);
}

function getHashPath() {
  // We can't use window.location.hash here because it's not
  // consistent across browsers - Firefox will pre-decode it!
  var href = window.location.href;
  var hashIndex = href.indexOf('#');
  return hashIndex === -1 ? '' : href.substring(hashIndex + 1);
}

function pushHashPath(path) {
  window.location.hash = path;
}

function replaceHashPath(path) {
  window.location.replace(stripHash(window.location.href) + '#' + path);
}

function createHashHistory(props) {
  if (props === void 0) {
    props = {};
  }

  !canUseDOM ?  false ? invariant(false, 'Hash history needs a DOM') : Object(__WEBPACK_IMPORTED_MODULE_4_tiny_invariant__["a" /* default */])(false) : void 0;
  var globalHistory = window.history;
  var canGoWithoutReload = supportsGoWithoutReloadUsingHash();
  var _props = props,
      _props$getUserConfirm = _props.getUserConfirmation,
      getUserConfirmation = _props$getUserConfirm === void 0 ? getConfirmation : _props$getUserConfirm,
      _props$hashType = _props.hashType,
      hashType = _props$hashType === void 0 ? 'slash' : _props$hashType;
  var basename = props.basename ? stripTrailingSlash(addLeadingSlash(props.basename)) : '';
  var _HashPathCoders$hashT = HashPathCoders[hashType],
      encodePath = _HashPathCoders$hashT.encodePath,
      decodePath = _HashPathCoders$hashT.decodePath;

  function getDOMLocation() {
    var path = decodePath(getHashPath());
     false ? warning(!basename || hasBasename(path, basename), 'You are attempting to use a basename on a page whose URL path does not begin ' + 'with the basename. Expected path "' + path + '" to begin with "' + basename + '".') : void 0;
    if (basename) path = stripBasename(path, basename);
    return createLocation(path);
  }

  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = globalHistory.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  var forceNextPop = false;
  var ignorePath = null;

  function locationsAreEqual$$1(a, b) {
    return a.pathname === b.pathname && a.search === b.search && a.hash === b.hash;
  }

  function handleHashChange() {
    var path = getHashPath();
    var encodedPath = encodePath(path);

    if (path !== encodedPath) {
      // Ensure we always have a properly-encoded hash.
      replaceHashPath(encodedPath);
    } else {
      var location = getDOMLocation();
      var prevLocation = history.location;
      if (!forceNextPop && locationsAreEqual$$1(prevLocation, location)) return; // A hashchange doesn't always == location change.

      if (ignorePath === createPath(location)) return; // Ignore this change; we already setState in push/replace.

      ignorePath = null;
      handlePop(location);
    }
  }

  function handlePop(location) {
    if (forceNextPop) {
      forceNextPop = false;
      setState();
    } else {
      var action = 'POP';
      transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
        if (ok) {
          setState({
            action: action,
            location: location
          });
        } else {
          revertPop(location);
        }
      });
    }
  }

  function revertPop(fromLocation) {
    var toLocation = history.location; // TODO: We could probably make this more reliable by
    // keeping a list of paths we've seen in sessionStorage.
    // Instead, we just default to 0 for paths we don't know.

    var toIndex = allPaths.lastIndexOf(createPath(toLocation));
    if (toIndex === -1) toIndex = 0;
    var fromIndex = allPaths.lastIndexOf(createPath(fromLocation));
    if (fromIndex === -1) fromIndex = 0;
    var delta = toIndex - fromIndex;

    if (delta) {
      forceNextPop = true;
      go(delta);
    }
  } // Ensure the hash is encoded properly before doing anything else.


  var path = getHashPath();
  var encodedPath = encodePath(path);
  if (path !== encodedPath) replaceHashPath(encodedPath);
  var initialLocation = getDOMLocation();
  var allPaths = [createPath(initialLocation)]; // Public interface

  function createHref(location) {
    var baseTag = document.querySelector('base');
    var href = '';

    if (baseTag && baseTag.getAttribute('href')) {
      href = stripHash(window.location.href);
    }

    return href + '#' + encodePath(basename + createPath(location));
  }

  function push(path, state) {
     false ? warning(state === undefined, 'Hash history cannot push state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a PUSH, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        pushHashPath(encodedPath);
        var prevIndex = allPaths.lastIndexOf(createPath(history.location));
        var nextPaths = allPaths.slice(0, prevIndex + 1);
        nextPaths.push(path);
        allPaths = nextPaths;
        setState({
          action: action,
          location: location
        });
      } else {
         false ? warning(false, 'Hash history cannot PUSH the same path; a new entry will not be added to the history stack') : void 0;
        setState();
      }
    });
  }

  function replace(path, state) {
     false ? warning(state === undefined, 'Hash history cannot replace state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, undefined, undefined, history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var path = createPath(location);
      var encodedPath = encodePath(basename + path);
      var hashChanged = getHashPath() !== encodedPath;

      if (hashChanged) {
        // We cannot tell if a hashchange was caused by a REPLACE, so we'd
        // rather setState here and ignore the hashchange. The caveat here
        // is that other hash histories in the page will consider it a POP.
        ignorePath = path;
        replaceHashPath(encodedPath);
      }

      var prevIndex = allPaths.indexOf(createPath(history.location));
      if (prevIndex !== -1) allPaths[prevIndex] = path;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
     false ? warning(canGoWithoutReload, 'Hash history go(n) causes a full page reload in this browser') : void 0;
    globalHistory.go(n);
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  var listenerCount = 0;

  function checkDOMListeners(delta) {
    listenerCount += delta;

    if (listenerCount === 1 && delta === 1) {
      window.addEventListener(HashChangeEvent$1, handleHashChange);
    } else if (listenerCount === 0) {
      window.removeEventListener(HashChangeEvent$1, handleHashChange);
    }
  }

  var isBlocked = false;

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    var unblock = transitionManager.setPrompt(prompt);

    if (!isBlocked) {
      checkDOMListeners(1);
      isBlocked = true;
    }

    return function () {
      if (isBlocked) {
        isBlocked = false;
        checkDOMListeners(-1);
      }

      return unblock();
    };
  }

  function listen(listener) {
    var unlisten = transitionManager.appendListener(listener);
    checkDOMListeners(1);
    return function () {
      checkDOMListeners(-1);
      unlisten();
    };
  }

  var history = {
    length: globalHistory.length,
    action: 'POP',
    location: initialLocation,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    block: block,
    listen: listen
  };
  return history;
}

function clamp(n, lowerBound, upperBound) {
  return Math.min(Math.max(n, lowerBound), upperBound);
}
/**
 * Creates a history object that stores locations in memory.
 */


function createMemoryHistory(props) {
  if (props === void 0) {
    props = {};
  }

  var _props = props,
      getUserConfirmation = _props.getUserConfirmation,
      _props$initialEntries = _props.initialEntries,
      initialEntries = _props$initialEntries === void 0 ? ['/'] : _props$initialEntries,
      _props$initialIndex = _props.initialIndex,
      initialIndex = _props$initialIndex === void 0 ? 0 : _props$initialIndex,
      _props$keyLength = _props.keyLength,
      keyLength = _props$keyLength === void 0 ? 6 : _props$keyLength;
  var transitionManager = createTransitionManager();

  function setState(nextState) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])(history, nextState);

    history.length = history.entries.length;
    transitionManager.notifyListeners(history.location, history.action);
  }

  function createKey() {
    return Math.random().toString(36).substr(2, keyLength);
  }

  var index = clamp(initialIndex, 0, initialEntries.length - 1);
  var entries = initialEntries.map(function (entry) {
    return typeof entry === 'string' ? createLocation(entry, undefined, createKey()) : createLocation(entry, undefined, entry.key || createKey());
  }); // Public interface

  var createHref = createPath;

  function push(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to push when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'PUSH';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      var prevIndex = history.index;
      var nextIndex = prevIndex + 1;
      var nextEntries = history.entries.slice(0);

      if (nextEntries.length > nextIndex) {
        nextEntries.splice(nextIndex, nextEntries.length - nextIndex, location);
      } else {
        nextEntries.push(location);
      }

      setState({
        action: action,
        location: location,
        index: nextIndex,
        entries: nextEntries
      });
    });
  }

  function replace(path, state) {
     false ? warning(!(typeof path === 'object' && path.state !== undefined && state !== undefined), 'You should avoid providing a 2nd state argument to replace when the 1st ' + 'argument is a location-like object that already has state; it is ignored') : void 0;
    var action = 'REPLACE';
    var location = createLocation(path, state, createKey(), history.location);
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (!ok) return;
      history.entries[history.index] = location;
      setState({
        action: action,
        location: location
      });
    });
  }

  function go(n) {
    var nextIndex = clamp(history.index + n, 0, history.entries.length - 1);
    var action = 'POP';
    var location = history.entries[nextIndex];
    transitionManager.confirmTransitionTo(location, action, getUserConfirmation, function (ok) {
      if (ok) {
        setState({
          action: action,
          location: location,
          index: nextIndex
        });
      } else {
        // Mimic the behavior of DOM histories by
        // causing a render after a cancelled POP.
        setState();
      }
    });
  }

  function goBack() {
    go(-1);
  }

  function goForward() {
    go(1);
  }

  function canGo(n) {
    var nextIndex = history.index + n;
    return nextIndex >= 0 && nextIndex < history.entries.length;
  }

  function block(prompt) {
    if (prompt === void 0) {
      prompt = false;
    }

    return transitionManager.setPrompt(prompt);
  }

  function listen(listener) {
    return transitionManager.appendListener(listener);
  }

  var history = {
    length: entries.length,
    action: 'POP',
    location: entries[index],
    index: index,
    entries: entries,
    createHref: createHref,
    push: push,
    replace: replace,
    go: go,
    goBack: goBack,
    goForward: goForward,
    canGo: canGo,
    block: block,
    listen: listen
  };
  return history;
}




/***/ }),
/* 69 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.map` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function arrayMap(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);

  while (++index < length) {
    result[index] = iteratee(array[index], index, array);
  }
  return result;
}

module.exports = arrayMap;


/***/ }),
/* 70 */
/***/ (function(module, exports) {

/**
 * Performs a
 * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * comparison between two values to determine if they are equivalent.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.eq(object, object);
 * // => true
 *
 * _.eq(object, other);
 * // => false
 *
 * _.eq('a', 'a');
 * // => true
 *
 * _.eq('a', Object('a'));
 * // => false
 *
 * _.eq(NaN, NaN);
 * // => true
 */
function eq(value, other) {
  return value === other || (value !== value && other !== other);
}

module.exports = eq;


/***/ }),
/* 71 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(40);

/** Built-in value references. */
var Symbol = root.Symbol;

module.exports = Symbol;


/***/ }),
/* 72 */
/***/ (function(module, exports, __webpack_require__) {

var DataView = __webpack_require__(471),
    Map = __webpack_require__(148),
    Promise = __webpack_require__(472),
    Set = __webpack_require__(242),
    WeakMap = __webpack_require__(473),
    baseGetTag = __webpack_require__(48),
    toSource = __webpack_require__(232);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    setTag = '[object Set]',
    weakMapTag = '[object WeakMap]';

var dataViewTag = '[object DataView]';

/** Used to detect maps, sets, and weakmaps. */
var dataViewCtorString = toSource(DataView),
    mapCtorString = toSource(Map),
    promiseCtorString = toSource(Promise),
    setCtorString = toSource(Set),
    weakMapCtorString = toSource(WeakMap);

/**
 * Gets the `toStringTag` of `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the `toStringTag`.
 */
var getTag = baseGetTag;

// Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
if ((DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag) ||
    (Map && getTag(new Map) != mapTag) ||
    (Promise && getTag(Promise.resolve()) != promiseTag) ||
    (Set && getTag(new Set) != setTag) ||
    (WeakMap && getTag(new WeakMap) != weakMapTag)) {
  getTag = function(value) {
    var result = baseGetTag(value),
        Ctor = result == objectTag ? value.constructor : undefined,
        ctorString = Ctor ? toSource(Ctor) : '';

    if (ctorString) {
      switch (ctorString) {
        case dataViewCtorString: return dataViewTag;
        case mapCtorString: return mapTag;
        case promiseCtorString: return promiseTag;
        case setCtorString: return setTag;
        case weakMapCtorString: return weakMapTag;
      }
    }
    return result;
  };
}

module.exports = getTag;


/***/ }),
/* 73 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(13),
    isKey = __webpack_require__(158),
    stringToPath = __webpack_require__(476),
    toString = __webpack_require__(74);

/**
 * Casts `value` to a path array if it's not one.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {Object} [object] The object to query keys on.
 * @returns {Array} Returns the cast property path array.
 */
function castPath(value, object) {
  if (isArray(value)) {
    return value;
  }
  return isKey(value, object) ? [value] : stringToPath(toString(value));
}

module.exports = castPath;


/***/ }),
/* 74 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(159);

/**
 * Converts `value` to a string. An empty string is returned for `null`
 * and `undefined` values. The sign of `-0` is preserved.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.toString(null);
 * // => ''
 *
 * _.toString(-0);
 * // => '-0'
 *
 * _.toString([1, 2, 3]);
 * // => '1,2,3'
 */
function toString(value) {
  return value == null ? '' : baseToString(value);
}

module.exports = toString;


/***/ }),
/* 75 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(97);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Converts `value` to a string key if it's not a string or symbol.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {string|symbol} Returns the key.
 */
function toKey(value) {
  if (typeof value == 'string' || isSymbol(value)) {
    return value;
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = toKey;


/***/ }),
/* 76 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_pick__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styled_components__ = __webpack_require__(27);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;var _templateObject=_taggedTemplateLiteral(["\n  outline: none;\n  border: none;\n  margin: 0;\n  padding: 0;\n  width: auto;\n  overflow: visible;\n  cursor: pointer;\n  text-align: center;\n  font-weight: bold;\n  text-transform: uppercase;\n  transition: 0.5s;\n\n  ","\n\n  ","\n\n  ","\n\n  ","\n\n  ","\n\n  ","\n\n"],["\n  outline: none;\n  border: none;\n  margin: 0;\n  padding: 0;\n  width: auto;\n  overflow: visible;\n  cursor: pointer;\n  text-align: center;\n  font-weight: bold;\n  text-transform: uppercase;\n  transition: 0.5s;\n\n  ","\n\n  ","\n\n  ","\n\n  ","\n\n  ","\n\n  ","\n\n"]),_templateObject2=_taggedTemplateLiteral(["\n      background-color: #04a8a6;\n      font-size: 11px;\n      letter-spacing: 2px;\n      line-height: 35px;\n      color: #ffffff;\n      padding: 0 25px;\n      &:hover {\n        ",";\n      }\n    "],["\n      background-color: #04a8a6;\n      font-size: 11px;\n      letter-spacing: 2px;\n      line-height: 35px;\n      color: #ffffff;\n      padding: 0 25px;\n      &:hover {\n        ",";\n      }\n    "]),_templateObject3=_taggedTemplateLiteral(["\n      background-color: transparent;\n      font-size: 11px;\n      letter-spacing: 2px;\n      line-height: 28px;\n      color: #ffffff;\n      border: 1px solid #ffffff;\n      padding: 2px 20px;\n      &:hover {\n        ",";\n      }\n    "],["\n      background-color: transparent;\n      font-size: 11px;\n      letter-spacing: 2px;\n      line-height: 28px;\n      color: #ffffff;\n      border: 1px solid #ffffff;\n      padding: 2px 20px;\n      &:hover {\n        ",";\n      }\n    "]),_templateObject4=_taggedTemplateLiteral(["\n      background-color: #3d3e3d;\n      font-size: 15px;\n      color: #ffffff;\n      padding: 10px 15px;\n      font-weight: bold;\n      &:hover {\n        ",";\n      }\n      /* @media (max-width: 1290px) {\n        ","\n      }\n      @media (max-width: 1000px) {\n        ","\n      } */\n    "],["\n      background-color: #3d3e3d;\n      font-size: 15px;\n      color: #ffffff;\n      padding: 10px 15px;\n      font-weight: bold;\n      &:hover {\n        ",";\n      }\n      /* @media (max-width: 1290px) {\n        ","\n      }\n      @media (max-width: 1000px) {\n        ","\n      } */\n    "]),_templateObject5=_taggedTemplateLiteral(["\n      color: #000;\n      text-transform: uppercase;\n      display: block;\n      text-align: left;\n      font-size: 11px;\n      background-color: #dbdbdb;\n      padding: 2px 5px 2px 0;\n      font-family: \"MS Sans Serif\", Helvetica, sans-serif;\n      line-height: 30px;\n      font-weight: bold;\n      width: 100%;\n      margin-right: 10px;\n      margin-left: 0;\n      margin-bottom: 3px;\n      transform: color 0.5s, background-color 0.5s;\n      display: flex;\n      align-items: center;\n      &:hover {\n        background-color: white;\n      }\n    "],["\n      color: #000;\n      text-transform: uppercase;\n      display: block;\n      text-align: left;\n      font-size: 11px;\n      background-color: #dbdbdb;\n      padding: 2px 5px 2px 0;\n      font-family: \"MS Sans Serif\", Helvetica, sans-serif;\n      line-height: 30px;\n      font-weight: bold;\n      width: 100%;\n      margin-right: 10px;\n      margin-left: 0;\n      margin-bottom: 3px;\n      transform: color 0.5s, background-color 0.5s;\n      display: flex;\n      align-items: center;\n      &:hover {\n        background-color: white;\n      }\n    "]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var MyButton=__WEBPACK_IMPORTED_MODULE_4_styled_components__["b" /* default */].button(_templateObject,function(props){return props.type==="default"&&Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["a" /* css */])(_templateObject2,props.hoverStyle);},function(props){return props.type==="primary"&&Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["a" /* css */])(_templateObject3,props.hoverStyle);},function(props){return props.type==="secondary"&&Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["a" /* css */])(_templateObject4,props.hoverStyle,props.page==="residence"?"font-size: 5px":"",props.page==="residence"?"padding: 0px":"");},function(props){return props.type==="groupVerticle"&&Object(__WEBPACK_IMPORTED_MODULE_4_styled_components__["a" /* css */])(_templateObject5);},function(props){return props.defaultStyle;},function(props){return props.isActive===true?props.activeStyle:{};});var Button=(_temp=_class=function(_Component){_inherits(Button,_Component);function Button(){_classCallCheck(this,Button);return _possibleConstructorReturn(this,(Button.__proto__||Object.getPrototypeOf(Button)).apply(this,arguments));}_createClass(Button,[{key:"shouldComponentUpdate",value:function shouldComponentUpdate(nextProps){var fieldToCheck=["active","activeStyle","children","defaultStyle","hoverStyle","page","type"];var _nextProps=__WEBPACK_IMPORTED_MODULE_1_lodash_pick___default()(nextProps,fieldToCheck);var _thisProps=__WEBPACK_IMPORTED_MODULE_1_lodash_pick___default()(this.props,fieldToCheck);return!__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(_nextProps,_thisProps);}// state = {
//   isActive: this.props.active
// };
// handleClickButton = () => {
//   // const { isActive } = this.state;
//   this.setState({ isActive: true });
// };
},{key:"render",value:function render(){var _props=this.props,className=_props.className,type=_props.type,activeStyle=_props.activeStyle,hoverStyle=_props.hoverStyle,defaultStyle=_props.defaultStyle,active=_props.active,onClick=_props.onClick,page=_props.page;// const { isActive } = this.state;
return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(MyButton,{className:className,page:page,type:type,isActive:active,hoverStyle:hoverStyle,activeStyle:activeStyle,defaultStyle:defaultStyle,onClick:onClick// onClick={this.handleClickButton}
},this.props.children);}}]);return Button;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]),_class.propTypes={className:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,type:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,active:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,activeStyle:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape(),hoverStyle:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape(),defaultStyle:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape(),page:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string},_class.defaultProps={className:"",type:"default",active:false,activeStyle:{},hoverStyle:{},defaultStyle:{},page:""},_temp);/* harmony default export */ __webpack_exports__["a"] = (Button);

/***/ }),
/* 77 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(53);
var createDesc = __webpack_require__(106);
module.exports = __webpack_require__(54) ? function (object, key, value) {
  return dP.f(object, key, createDesc(1, value));
} : function (object, key, value) {
  object[key] = value;
  return object;
};


/***/ }),
/* 78 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(79);
module.exports = function (it) {
  if (!isObject(it)) throw TypeError(it + ' is not an object!');
  return it;
};


/***/ }),
/* 79 */
/***/ (function(module, exports) {

module.exports = function (it) {
  return typeof it === 'object' ? it !== null : typeof it === 'function';
};


/***/ }),
/* 80 */
/***/ (function(module, exports, __webpack_require__) {

// to indexed object, toObject with fallback for non-array-like ES3 strings
var IObject = __webpack_require__(278);
var defined = __webpack_require__(175);
module.exports = function (it) {
  return IObject(defined(it));
};


/***/ }),
/* 81 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(274);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      (0, _defineProperty2.default)(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

/***/ }),
/* 82 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Form_Newsletter__ = __webpack_require__(608);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_0__Form_Newsletter__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Form_Ebrochure__ = __webpack_require__(700);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_1__Form_Ebrochure__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ComingSoon__ = __webpack_require__(701);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_2__ComingSoon__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__GalleryImages__ = __webpack_require__(702);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_3__GalleryImages__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__TypeResidences__ = __webpack_require__(712);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_4__TypeResidences__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__TypeResidenceVirtual__ = __webpack_require__(713);
/* unused harmony reexport TypeResidenceVirtual */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__EbrochureDownload__ = __webpack_require__(714);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_6__EbrochureDownload__["a"]; });


/***/ }),
/* 83 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "polyfill", function() { return polyfill; });
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

function componentWillMount() {
  // Call this.constructor.gDSFP to support sub-classes.
  var state = this.constructor.getDerivedStateFromProps(this.props, this.state);
  if (state !== null && state !== undefined) {
    this.setState(state);
  }
}

function componentWillReceiveProps(nextProps) {
  // Call this.constructor.gDSFP to support sub-classes.
  // Use the setState() updater to ensure state isn't stale in certain edge cases.
  function updater(prevState) {
    var state = this.constructor.getDerivedStateFromProps(nextProps, prevState);
    return state !== null && state !== undefined ? state : null;
  }
  // Binding "this" is important for shallow renderer support.
  this.setState(updater.bind(this));
}

function componentWillUpdate(nextProps, nextState) {
  try {
    var prevProps = this.props;
    var prevState = this.state;
    this.props = nextProps;
    this.state = nextState;
    this.__reactInternalSnapshotFlag = true;
    this.__reactInternalSnapshot = this.getSnapshotBeforeUpdate(
      prevProps,
      prevState
    );
  } finally {
    this.props = prevProps;
    this.state = prevState;
  }
}

// React may warn about cWM/cWRP/cWU methods being deprecated.
// Add a flag to suppress these warnings for this special case.
componentWillMount.__suppressDeprecationWarning = true;
componentWillReceiveProps.__suppressDeprecationWarning = true;
componentWillUpdate.__suppressDeprecationWarning = true;

function polyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  }

  if (
    typeof Component.getDerivedStateFromProps !== 'function' &&
    typeof prototype.getSnapshotBeforeUpdate !== 'function'
  ) {
    return Component;
  }

  // If new component APIs are defined, "unsafe" lifecycles won't be called.
  // Error if any of these lifecycles are present,
  // Because they would work differently between older and newer (16.3+) versions of React.
  var foundWillMountName = null;
  var foundWillReceivePropsName = null;
  var foundWillUpdateName = null;
  if (typeof prototype.componentWillMount === 'function') {
    foundWillMountName = 'componentWillMount';
  } else if (typeof prototype.UNSAFE_componentWillMount === 'function') {
    foundWillMountName = 'UNSAFE_componentWillMount';
  }
  if (typeof prototype.componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'componentWillReceiveProps';
  } else if (typeof prototype.UNSAFE_componentWillReceiveProps === 'function') {
    foundWillReceivePropsName = 'UNSAFE_componentWillReceiveProps';
  }
  if (typeof prototype.componentWillUpdate === 'function') {
    foundWillUpdateName = 'componentWillUpdate';
  } else if (typeof prototype.UNSAFE_componentWillUpdate === 'function') {
    foundWillUpdateName = 'UNSAFE_componentWillUpdate';
  }
  if (
    foundWillMountName !== null ||
    foundWillReceivePropsName !== null ||
    foundWillUpdateName !== null
  ) {
    var componentName = Component.displayName || Component.name;
    var newApiName =
      typeof Component.getDerivedStateFromProps === 'function'
        ? 'getDerivedStateFromProps()'
        : 'getSnapshotBeforeUpdate()';

    throw Error(
      'Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n' +
        componentName +
        ' uses ' +
        newApiName +
        ' but also contains the following legacy lifecycles:' +
        (foundWillMountName !== null ? '\n  ' + foundWillMountName : '') +
        (foundWillReceivePropsName !== null
          ? '\n  ' + foundWillReceivePropsName
          : '') +
        (foundWillUpdateName !== null ? '\n  ' + foundWillUpdateName : '') +
        '\n\nThe above lifecycles should be removed. Learn more about this warning here:\n' +
        'https://fb.me/react-async-component-lifecycle-hooks'
    );
  }

  // React <= 16.2 does not support static getDerivedStateFromProps.
  // As a workaround, use cWM and cWRP to invoke the new static lifecycle.
  // Newer versions of React will ignore these lifecycles if gDSFP exists.
  if (typeof Component.getDerivedStateFromProps === 'function') {
    prototype.componentWillMount = componentWillMount;
    prototype.componentWillReceiveProps = componentWillReceiveProps;
  }

  // React <= 16.2 does not support getSnapshotBeforeUpdate.
  // As a workaround, use cWU to invoke the new lifecycle.
  // Newer versions of React will ignore that lifecycle if gSBU exists.
  if (typeof prototype.getSnapshotBeforeUpdate === 'function') {
    if (typeof prototype.componentDidUpdate !== 'function') {
      throw new Error(
        'Cannot polyfill getSnapshotBeforeUpdate() for components that do not define componentDidUpdate() on the prototype'
      );
    }

    prototype.componentWillUpdate = componentWillUpdate;

    var componentDidUpdate = prototype.componentDidUpdate;

    prototype.componentDidUpdate = function componentDidUpdatePolyfill(
      prevProps,
      prevState,
      maybeSnapshot
    ) {
      // 16.3+ will not execute our will-update method;
      // It will pass a snapshot value to did-update though.
      // Older versions will require our polyfilled will-update value.
      // We need to handle both cases, but can't just check for the presence of "maybeSnapshot",
      // Because for <= 15.x versions this might be a "prevContext" object.
      // We also can't just check "__reactInternalSnapshot",
      // Because get-snapshot might return a falsy value.
      // So check for the explicit __reactInternalSnapshotFlag flag to determine behavior.
      var snapshot = this.__reactInternalSnapshotFlag
        ? this.__reactInternalSnapshot
        : maybeSnapshot;

      componentDidUpdate.call(this, prevProps, prevState, snapshot);
    };
  }

  return Component;
}




/***/ }),
/* 84 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);

function omit(obj, fields) {
  var shallowCopy = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({}, obj);
  for (var i = 0; i < fields.length; i++) {
    var key = fields[i];
    delete shallowCopy[key];
  }
  return shallowCopy;
}

/* harmony default export */ __webpack_exports__["default"] = (omit);

/***/ }),
/* 85 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.tupleNum = exports.tuple = void 0;

// https://stackoverflow.com/questions/46176165/ways-to-get-string-literal-type-of-array-values-without-enum-overhead
var tuple = function tuple() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return args;
};

exports.tuple = tuple;

var tupleNum = function tupleNum() {
  for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
    args[_key2] = arguments[_key2];
  }

  return args;
};

exports.tupleNum = tupleNum;

/***/ }),
/* 86 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(169),
    baseAssignValue = __webpack_require__(170);

/**
 * Copies properties of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy properties from.
 * @param {Array} props The property identifiers to copy.
 * @param {Object} [object={}] The object to copy properties to.
 * @param {Function} [customizer] The function to customize copied values.
 * @returns {Object} Returns `object`.
 */
function copyObject(source, props, object, customizer) {
  var isNew = !object;
  object || (object = {});

  var index = -1,
      length = props.length;

  while (++index < length) {
    var key = props[index];

    var newValue = customizer
      ? customizer(object[key], source[key], key, object, source)
      : undefined;

    if (newValue === undefined) {
      newValue = source[key];
    }
    if (isNew) {
      baseAssignValue(object, key, newValue);
    } else {
      assignValue(object, key, newValue);
    }
  }
  return object;
}

module.exports = copyObject;


/***/ }),
/* 87 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(155),
    baseFilter = __webpack_require__(271),
    baseIteratee = __webpack_require__(36),
    isArray = __webpack_require__(13),
    negate = __webpack_require__(308);

/**
 * The opposite of `_.filter`; this method returns the elements of `collection`
 * that `predicate` does **not** return truthy for.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 * @see _.filter
 * @example
 *
 * var users = [
 *   { 'user': 'barney', 'age': 36, 'active': false },
 *   { 'user': 'fred',   'age': 40, 'active': true }
 * ];
 *
 * _.reject(users, function(o) { return !o.active; });
 * // => objects for ['fred']
 *
 * // The `_.matches` iteratee shorthand.
 * _.reject(users, { 'age': 40, 'active': true });
 * // => objects for ['barney']
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.reject(users, ['active', false]);
 * // => objects for ['fred']
 *
 * // The `_.property` iteratee shorthand.
 * _.reject(users, 'active');
 * // => objects for ['barney']
 */
function reject(collection, predicate) {
  var func = isArray(collection) ? arrayFilter : baseFilter;
  return func(collection, negate(baseIteratee(predicate, 3)));
}

module.exports = reject;


/***/ }),
/* 88 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_deepmerge__ = __webpack_require__(859);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_cloneDeep__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils__ = __webpack_require__(2);
// import Compass from "./components/Compass";
// import MultiLineText from "../../components/svg/MultiLineText";
var overwriteMerge=function overwriteMerge(destinationArray,sourceArray,options){var destination=destinationArray.slice();sourceArray.forEach(function(e,i){Object.keys(e).forEach(function(key){// console.log(destination[0][key])
destination[i][key]=sourceArray[i][key];});});return destination;};var switchLanguage=function switchLanguage(activeLanguage){switch(activeLanguage){case"cn":return __WEBPACK_IMPORTED_MODULE_1__common__["a" /* CHtexts */];case"ru":return __WEBPACK_IMPORTED_MODULE_1__common__["b" /* RUtexts */];default:return __WEBPACK_IMPORTED_MODULE_1__common__["c" /* texts */];}};/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var _ref$x=_ref.x,x=_ref$x===undefined?0:_ref$x,_ref$y=_ref.y,y=_ref$y===undefined?0:_ref$y,_ref$width=_ref.width,width=_ref$width===undefined?"100%":_ref$width,height=_ref.height,children=_ref.children,activeLanguage=_ref.activeLanguage,filterTexts=_ref.filterTexts,_ref$project=_ref.project,project=_ref$project===undefined?"laguna-seaside-residences":_ref$project;var selActiveLanguage=switchLanguage(activeLanguage);var mergedTexts=Object(__WEBPACK_IMPORTED_MODULE_2_deepmerge__["a" /* default */])(__WEBPACK_IMPORTED_MODULE_3_lodash_cloneDeep___default()(__WEBPACK_IMPORTED_MODULE_1__common__["c" /* texts */]),selActiveLanguage,{arrayMerge:overwriteMerge});var textForRender=typeof filterTexts==="function"?filterTexts(mergedTexts):mergedTexts;// // const baseAssetUrl = assetsPath("phuket-laguna-park-2");
// const baseAssetUrl = assetsPath("phuket-skypark");
var baseAssetUrl=Object(__WEBPACK_IMPORTED_MODULE_4__utils__["a" /* assetsPath */])(project);var bg=baseAssetUrl+"/images/project-map/phuket-masterplan-"+activeLanguage+".png";console.log("masterplan >>>> ",project);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{// className="project-map"
className:"project-masterplan",viewBox:"0 0 1630 1080",x:x,y:y,width:width,heigth:height},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("image",{xlinkHref:bg,width:1630,height:1080}),children);});

/***/ }),
/* 89 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(47);

var ReactCurrentOwner = __webpack_require__(374);

var warning = __webpack_require__(211);
var canDefineProperty = __webpack_require__(373);
var hasOwnProperty = Object.prototype.hasOwnProperty;

var REACT_ELEMENT_TYPE = __webpack_require__(375);

var RESERVED_PROPS = {
  key: true,
  ref: true,
  __self: true,
  __source: true
};

var specialPropKeyWarningShown, specialPropRefWarningShown;

function hasValidRef(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'ref')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'ref').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.ref !== undefined;
}

function hasValidKey(config) {
  if (false) {
    if (hasOwnProperty.call(config, 'key')) {
      var getter = Object.getOwnPropertyDescriptor(config, 'key').get;
      if (getter && getter.isReactWarning) {
        return false;
      }
    }
  }
  return config.key !== undefined;
}

function defineKeyPropWarningGetter(props, displayName) {
  var warnAboutAccessingKey = function () {
    if (!specialPropKeyWarningShown) {
      specialPropKeyWarningShown = true;
       false ? warning(false, '%s: `key` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingKey.isReactWarning = true;
  Object.defineProperty(props, 'key', {
    get: warnAboutAccessingKey,
    configurable: true
  });
}

function defineRefPropWarningGetter(props, displayName) {
  var warnAboutAccessingRef = function () {
    if (!specialPropRefWarningShown) {
      specialPropRefWarningShown = true;
       false ? warning(false, '%s: `ref` is not a prop. Trying to access it will result ' + 'in `undefined` being returned. If you need to access the same ' + 'value within the child component, you should pass it as a different ' + 'prop. (https://fb.me/react-special-props)', displayName) : void 0;
    }
  };
  warnAboutAccessingRef.isReactWarning = true;
  Object.defineProperty(props, 'ref', {
    get: warnAboutAccessingRef,
    configurable: true
  });
}

/**
 * Factory method to create a new React element. This no longer adheres to
 * the class pattern, so do not use new to call it. Also, no instanceof check
 * will work. Instead test $$typeof field against Symbol.for('react.element') to check
 * if something is a React Element.
 *
 * @param {*} type
 * @param {*} key
 * @param {string|object} ref
 * @param {*} self A *temporary* helper to detect places where `this` is
 * different from the `owner` when React.createElement is called, so that we
 * can warn. We want to get rid of owner and replace string `ref`s with arrow
 * functions, and as long as `this` and owner are the same, there will be no
 * change in behavior.
 * @param {*} source An annotation object (added by a transpiler or otherwise)
 * indicating filename, line number, and/or other information.
 * @param {*} owner
 * @param {*} props
 * @internal
 */
var ReactElement = function (type, key, ref, self, source, owner, props) {
  var element = {
    // This tag allow us to uniquely identify this as a React Element
    $$typeof: REACT_ELEMENT_TYPE,

    // Built-in properties that belong on the element
    type: type,
    key: key,
    ref: ref,
    props: props,

    // Record the component responsible for creating this element.
    _owner: owner
  };

  if (false) {
    // The validation flag is currently mutative. We put it on
    // an external backing store so that we can freeze the whole object.
    // This can be replaced with a WeakMap once they are implemented in
    // commonly used development environments.
    element._store = {};

    // To make comparing ReactElements easier for testing purposes, we make
    // the validation flag non-enumerable (where possible, which should
    // include every environment we run tests in), so the test framework
    // ignores it.
    if (canDefineProperty) {
      Object.defineProperty(element._store, 'validated', {
        configurable: false,
        enumerable: false,
        writable: true,
        value: false
      });
      // self and source are DEV only properties.
      Object.defineProperty(element, '_self', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: self
      });
      // Two elements created in two different places should be considered
      // equal for testing purposes and therefore we hide it from enumeration.
      Object.defineProperty(element, '_source', {
        configurable: false,
        enumerable: false,
        writable: false,
        value: source
      });
    } else {
      element._store.validated = false;
      element._self = self;
      element._source = source;
    }
    if (Object.freeze) {
      Object.freeze(element.props);
      Object.freeze(element);
    }
  }

  return element;
};

/**
 * Create and return a new ReactElement of the given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createelement
 */
ReactElement.createElement = function (type, config, children) {
  var propName;

  // Reserved names are extracted
  var props = {};

  var key = null;
  var ref = null;
  var self = null;
  var source = null;

  if (config != null) {
    if (hasValidRef(config)) {
      ref = config.ref;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    self = config.__self === undefined ? null : config.__self;
    source = config.__source === undefined ? null : config.__source;
    // Remaining properties are added to a new props object
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        props[propName] = config[propName];
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    if (false) {
      if (Object.freeze) {
        Object.freeze(childArray);
      }
    }
    props.children = childArray;
  }

  // Resolve default props
  if (type && type.defaultProps) {
    var defaultProps = type.defaultProps;
    for (propName in defaultProps) {
      if (props[propName] === undefined) {
        props[propName] = defaultProps[propName];
      }
    }
  }
  if (false) {
    if (key || ref) {
      if (typeof props.$$typeof === 'undefined' || props.$$typeof !== REACT_ELEMENT_TYPE) {
        var displayName = typeof type === 'function' ? type.displayName || type.name || 'Unknown' : type;
        if (key) {
          defineKeyPropWarningGetter(props, displayName);
        }
        if (ref) {
          defineRefPropWarningGetter(props, displayName);
        }
      }
    }
  }
  return ReactElement(type, key, ref, self, source, ReactCurrentOwner.current, props);
};

/**
 * Return a function that produces ReactElements of a given type.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.createfactory
 */
ReactElement.createFactory = function (type) {
  var factory = ReactElement.createElement.bind(null, type);
  // Expose the type on the factory and the prototype so that it can be
  // easily accessed on elements. E.g. `<Foo />.type === Foo`.
  // This should not be named `constructor` since this may not be the function
  // that created the element, and it may not even be a constructor.
  // Legacy hook TODO: Warn if this is accessed
  factory.type = type;
  return factory;
};

ReactElement.cloneAndReplaceKey = function (oldElement, newKey) {
  var newElement = ReactElement(oldElement.type, newKey, oldElement.ref, oldElement._self, oldElement._source, oldElement._owner, oldElement.props);

  return newElement;
};

/**
 * Clone and return a new ReactElement using element as the starting point.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.cloneelement
 */
ReactElement.cloneElement = function (element, config, children) {
  var propName;

  // Original props are copied
  var props = _assign({}, element.props);

  // Reserved names are extracted
  var key = element.key;
  var ref = element.ref;
  // Self is preserved since the owner is preserved.
  var self = element._self;
  // Source is preserved since cloneElement is unlikely to be targeted by a
  // transpiler, and the original source is probably a better indicator of the
  // true owner.
  var source = element._source;

  // Owner will be preserved, unless ref is overridden
  var owner = element._owner;

  if (config != null) {
    if (hasValidRef(config)) {
      // Silently steal the ref from the parent.
      ref = config.ref;
      owner = ReactCurrentOwner.current;
    }
    if (hasValidKey(config)) {
      key = '' + config.key;
    }

    // Remaining properties override existing props
    var defaultProps;
    if (element.type && element.type.defaultProps) {
      defaultProps = element.type.defaultProps;
    }
    for (propName in config) {
      if (hasOwnProperty.call(config, propName) && !RESERVED_PROPS.hasOwnProperty(propName)) {
        if (config[propName] === undefined && defaultProps !== undefined) {
          // Resolve default props
          props[propName] = defaultProps[propName];
        } else {
          props[propName] = config[propName];
        }
      }
    }
  }

  // Children can be more than one argument, and those are transferred onto
  // the newly allocated props object.
  var childrenLength = arguments.length - 2;
  if (childrenLength === 1) {
    props.children = children;
  } else if (childrenLength > 1) {
    var childArray = Array(childrenLength);
    for (var i = 0; i < childrenLength; i++) {
      childArray[i] = arguments[i + 2];
    }
    props.children = childArray;
  }

  return ReactElement(element.type, key, ref, self, source, owner, props);
};

/**
 * Verifies the object is a ReactElement.
 * See https://facebook.github.io/react/docs/top-level-api.html#react.isvalidelement
 * @param {?object} object
 * @return {boolean} True if `object` is a valid component.
 * @final
 */
ReactElement.isValidElement = function (object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
};

module.exports = ReactElement;

/***/ }),
/* 90 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectWithoutPropertiesLoose;
function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

/***/ }),
/* 91 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "__DO_NOT_USE__ActionTypes", function() { return ActionTypes; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "applyMiddleware", function() { return applyMiddleware; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "bindActionCreators", function() { return bindActionCreators; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "combineReducers", function() { return combineReducers; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "compose", function() { return compose; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "createStore", function() { return createStore; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "legacy_createStore", function() { return legacy_createStore; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__ = __webpack_require__(398);


/**
 * Adapted from React: https://github.com/facebook/react/blob/master/packages/shared/formatProdErrorMessage.js
 *
 * Do not require this module directly! Use normal throw error calls. These messages will be replaced with error codes
 * during build.
 * @param {number} code
 */
function formatProdErrorMessage(code) {
  return "Minified Redux error #" + code + "; visit https://redux.js.org/Errors?code=" + code + " for the full message or " + 'use the non-minified dev environment for full errors. ';
}

// Inlined version of the `symbol-observable` polyfill
var $$observable = (function () {
  return typeof Symbol === 'function' && Symbol.observable || '@@observable';
})();

/**
 * These are private action types reserved by Redux.
 * For any unknown actions, you must return the current state.
 * If the current state is undefined, you must return the initial state.
 * Do not reference these action types directly in your code.
 */
var randomString = function randomString() {
  return Math.random().toString(36).substring(7).split('').join('.');
};

var ActionTypes = {
  INIT: "@@redux/INIT" + randomString(),
  REPLACE: "@@redux/REPLACE" + randomString(),
  PROBE_UNKNOWN_ACTION: function PROBE_UNKNOWN_ACTION() {
    return "@@redux/PROBE_UNKNOWN_ACTION" + randomString();
  }
};

/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = obj;

  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }

  return Object.getPrototypeOf(obj) === proto;
}

// Inlined / shortened version of `kindOf` from https://github.com/jonschlinkert/kind-of
function miniKindOf(val) {
  if (val === void 0) return 'undefined';
  if (val === null) return 'null';
  var type = typeof val;

  switch (type) {
    case 'boolean':
    case 'string':
    case 'number':
    case 'symbol':
    case 'function':
      {
        return type;
      }
  }

  if (Array.isArray(val)) return 'array';
  if (isDate(val)) return 'date';
  if (isError(val)) return 'error';
  var constructorName = ctorName(val);

  switch (constructorName) {
    case 'Symbol':
    case 'Promise':
    case 'WeakMap':
    case 'WeakSet':
    case 'Map':
    case 'Set':
      return constructorName;
  } // other


  return type.slice(8, -1).toLowerCase().replace(/\s/g, '');
}

function ctorName(val) {
  return typeof val.constructor === 'function' ? val.constructor.name : null;
}

function isError(val) {
  return val instanceof Error || typeof val.message === 'string' && val.constructor && typeof val.constructor.stackTraceLimit === 'number';
}

function isDate(val) {
  if (val instanceof Date) return true;
  return typeof val.toDateString === 'function' && typeof val.getDate === 'function' && typeof val.setDate === 'function';
}

function kindOf(val) {
  var typeOfVal = typeof val;

  if (false) {
    typeOfVal = miniKindOf(val);
  }

  return typeOfVal;
}

/**
 * @deprecated
 *
 * **We recommend using the `configureStore` method
 * of the `@reduxjs/toolkit` package**, which replaces `createStore`.
 *
 * Redux Toolkit is our recommended approach for writing Redux logic today,
 * including store setup, reducers, data fetching, and more.
 *
 * **For more details, please read this Redux docs page:**
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * `configureStore` from Redux Toolkit is an improved version of `createStore` that
 * simplifies setup and helps avoid common bugs.
 *
 * You should not be using the `redux` core package by itself today, except for learning purposes.
 * The `createStore` method from the core `redux` package will not be removed, but we encourage
 * all users to migrate to using Redux Toolkit for all Redux code.
 *
 * If you want to use `createStore` without this visual deprecation warning, use
 * the `legacy_createStore` import instead:
 *
 * `import { legacy_createStore as createStore} from 'redux'`
 *
 */

function createStore(reducer, preloadedState, enhancer) {
  var _ref2;

  if (typeof preloadedState === 'function' && typeof enhancer === 'function' || typeof enhancer === 'function' && typeof arguments[3] === 'function') {
    throw new Error( true ? formatProdErrorMessage(0) : 'It looks like you are passing several store enhancers to ' + 'createStore(). This is not supported. Instead, compose them ' + 'together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.');
  }

  if (typeof preloadedState === 'function' && typeof enhancer === 'undefined') {
    enhancer = preloadedState;
    preloadedState = undefined;
  }

  if (typeof enhancer !== 'undefined') {
    if (typeof enhancer !== 'function') {
      throw new Error( true ? formatProdErrorMessage(1) : "Expected the enhancer to be a function. Instead, received: '" + kindOf(enhancer) + "'");
    }

    return enhancer(createStore)(reducer, preloadedState);
  }

  if (typeof reducer !== 'function') {
    throw new Error( true ? formatProdErrorMessage(2) : "Expected the root reducer to be a function. Instead, received: '" + kindOf(reducer) + "'");
  }

  var currentReducer = reducer;
  var currentState = preloadedState;
  var currentListeners = [];
  var nextListeners = currentListeners;
  var isDispatching = false;
  /**
   * This makes a shallow copy of currentListeners so we can use
   * nextListeners as a temporary list while dispatching.
   *
   * This prevents any bugs around consumers calling
   * subscribe/unsubscribe in the middle of a dispatch.
   */

  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = currentListeners.slice();
    }
  }
  /**
   * Reads the state tree managed by the store.
   *
   * @returns {any} The current state tree of your application.
   */


  function getState() {
    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(3) : 'You may not call store.getState() while the reducer is executing. ' + 'The reducer has already received the state as an argument. ' + 'Pass it down from the top reducer instead of reading it from the store.');
    }

    return currentState;
  }
  /**
   * Adds a change listener. It will be called any time an action is dispatched,
   * and some part of the state tree may potentially have changed. You may then
   * call `getState()` to read the current state tree inside the callback.
   *
   * You may call `dispatch()` from a change listener, with the following
   * caveats:
   *
   * 1. The subscriptions are snapshotted just before every `dispatch()` call.
   * If you subscribe or unsubscribe while the listeners are being invoked, this
   * will not have any effect on the `dispatch()` that is currently in progress.
   * However, the next `dispatch()` call, whether nested or not, will use a more
   * recent snapshot of the subscription list.
   *
   * 2. The listener should not expect to see all state changes, as the state
   * might have been updated multiple times during a nested `dispatch()` before
   * the listener is called. It is, however, guaranteed that all subscribers
   * registered before the `dispatch()` started will be called with the latest
   * state by the time it exits.
   *
   * @param {Function} listener A callback to be invoked on every dispatch.
   * @returns {Function} A function to remove this change listener.
   */


  function subscribe(listener) {
    if (typeof listener !== 'function') {
      throw new Error( true ? formatProdErrorMessage(4) : "Expected the listener to be a function. Instead, received: '" + kindOf(listener) + "'");
    }

    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(5) : 'You may not call store.subscribe() while the reducer is executing. ' + 'If you would like to be notified after the store has been updated, subscribe from a ' + 'component and invoke store.getState() in the callback to access the latest state. ' + 'See https://redux.js.org/api/store#subscribelistener for more details.');
    }

    var isSubscribed = true;
    ensureCanMutateNextListeners();
    nextListeners.push(listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      if (isDispatching) {
        throw new Error( true ? formatProdErrorMessage(6) : 'You may not unsubscribe from a store listener while the reducer is executing. ' + 'See https://redux.js.org/api/store#subscribelistener for more details.');
      }

      isSubscribed = false;
      ensureCanMutateNextListeners();
      var index = nextListeners.indexOf(listener);
      nextListeners.splice(index, 1);
      currentListeners = null;
    };
  }
  /**
   * Dispatches an action. It is the only way to trigger a state change.
   *
   * The `reducer` function, used to create the store, will be called with the
   * current state tree and the given `action`. Its return value will
   * be considered the **next** state of the tree, and the change listeners
   * will be notified.
   *
   * The base implementation only supports plain object actions. If you want to
   * dispatch a Promise, an Observable, a thunk, or something else, you need to
   * wrap your store creating function into the corresponding middleware. For
   * example, see the documentation for the `redux-thunk` package. Even the
   * middleware will eventually dispatch plain object actions using this method.
   *
   * @param {Object} action A plain object representing “what changed”. It is
   * a good idea to keep actions serializable so you can record and replay user
   * sessions, or use the time travelling `redux-devtools`. An action must have
   * a `type` property which may not be `undefined`. It is a good idea to use
   * string constants for action types.
   *
   * @returns {Object} For convenience, the same action object you dispatched.
   *
   * Note that, if you use a custom middleware, it may wrap `dispatch()` to
   * return something else (for example, a Promise you can await).
   */


  function dispatch(action) {
    if (!isPlainObject(action)) {
      throw new Error( true ? formatProdErrorMessage(7) : "Actions must be plain objects. Instead, the actual type was: '" + kindOf(action) + "'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.");
    }

    if (typeof action.type === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    }

    if (isDispatching) {
      throw new Error( true ? formatProdErrorMessage(9) : 'Reducers may not dispatch actions.');
    }

    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }

    var listeners = currentListeners = nextListeners;

    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      listener();
    }

    return action;
  }
  /**
   * Replaces the reducer currently used by the store to calculate the state.
   *
   * You might need this if your app implements code splitting and you want to
   * load some of the reducers dynamically. You might also need this if you
   * implement a hot reloading mechanism for Redux.
   *
   * @param {Function} nextReducer The reducer for the store to use instead.
   * @returns {void}
   */


  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== 'function') {
      throw new Error( true ? formatProdErrorMessage(10) : "Expected the nextReducer to be a function. Instead, received: '" + kindOf(nextReducer));
    }

    currentReducer = nextReducer; // This action has a similiar effect to ActionTypes.INIT.
    // Any reducers that existed in both the new and old rootReducer
    // will receive the previous state. This effectively populates
    // the new state tree with any relevant data from the old one.

    dispatch({
      type: ActionTypes.REPLACE
    });
  }
  /**
   * Interoperability point for observable/reactive libraries.
   * @returns {observable} A minimal observable of state changes.
   * For more information, see the observable proposal:
   * https://github.com/tc39/proposal-observable
   */


  function observable() {
    var _ref;

    var outerSubscribe = subscribe;
    return _ref = {
      /**
       * The minimal observable subscription method.
       * @param {Object} observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns {subscription} An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe: function subscribe(observer) {
        if (typeof observer !== 'object' || observer === null) {
          throw new Error( true ? formatProdErrorMessage(11) : "Expected the observer to be an object. Instead, received: '" + kindOf(observer) + "'");
        }

        function observeState() {
          if (observer.next) {
            observer.next(getState());
          }
        }

        observeState();
        var unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe: unsubscribe
        };
      }
    }, _ref[$$observable] = function () {
      return this;
    }, _ref;
  } // When a store is created, an "INIT" action is dispatched so that every
  // reducer returns their initial state. This effectively populates
  // the initial state tree.


  dispatch({
    type: ActionTypes.INIT
  });
  return _ref2 = {
    dispatch: dispatch,
    subscribe: subscribe,
    getState: getState,
    replaceReducer: replaceReducer
  }, _ref2[$$observable] = observable, _ref2;
}
/**
 * Creates a Redux store that holds the state tree.
 *
 * **We recommend using `configureStore` from the
 * `@reduxjs/toolkit` package**, which replaces `createStore`:
 * **https://redux.js.org/introduction/why-rtk-is-redux-today**
 *
 * The only way to change the data in the store is to call `dispatch()` on it.
 *
 * There should only be a single store in your app. To specify how different
 * parts of the state tree respond to actions, you may combine several reducers
 * into a single reducer function by using `combineReducers`.
 *
 * @param {Function} reducer A function that returns the next state tree, given
 * the current state tree and the action to handle.
 *
 * @param {any} [preloadedState] The initial state. You may optionally specify it
 * to hydrate the state from the server in universal apps, or to restore a
 * previously serialized user session.
 * If you use `combineReducers` to produce the root reducer function, this must be
 * an object with the same shape as `combineReducers` keys.
 *
 * @param {Function} [enhancer] The store enhancer. You may optionally specify it
 * to enhance the store with third-party capabilities such as middleware,
 * time travel, persistence, etc. The only store enhancer that ships with Redux
 * is `applyMiddleware()`.
 *
 * @returns {Store} A Redux store that lets you read the state, dispatch actions
 * and subscribe to changes.
 */

var legacy_createStore = createStore;

/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
  } catch (e) {} // eslint-disable-line no-empty

}

function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  var reducerKeys = Object.keys(reducers);
  var argumentName = action && action.type === ActionTypes.INIT ? 'preloadedState argument passed to createStore' : 'previous state received by the reducer';

  if (reducerKeys.length === 0) {
    return 'Store does not have a valid reducer. Make sure the argument passed ' + 'to combineReducers is an object whose values are reducers.';
  }

  if (!isPlainObject(inputState)) {
    return "The " + argumentName + " has unexpected type of \"" + kindOf(inputState) + "\". Expected argument to be an object with the following " + ("keys: \"" + reducerKeys.join('", "') + "\"");
  }

  var unexpectedKeys = Object.keys(inputState).filter(function (key) {
    return !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key];
  });
  unexpectedKeys.forEach(function (key) {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === ActionTypes.REPLACE) return;

  if (unexpectedKeys.length > 0) {
    return "Unexpected " + (unexpectedKeys.length > 1 ? 'keys' : 'key') + " " + ("\"" + unexpectedKeys.join('", "') + "\" found in " + argumentName + ". ") + "Expected to find one of the known reducer keys instead: " + ("\"" + reducerKeys.join('", "') + "\". Unexpected keys will be ignored.");
  }
}

function assertReducerShape(reducers) {
  Object.keys(reducers).forEach(function (key) {
    var reducer = reducers[key];
    var initialState = reducer(undefined, {
      type: ActionTypes.INIT
    });

    if (typeof initialState === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(12) : "The slice reducer for key \"" + key + "\" returned undefined during initialization. " + "If the state passed to the reducer is undefined, you must " + "explicitly return the initial state. The initial state may " + "not be undefined. If you don't want to set a value for this reducer, " + "you can use null instead of undefined.");
    }

    if (typeof reducer(undefined, {
      type: ActionTypes.PROBE_UNKNOWN_ACTION()
    }) === 'undefined') {
      throw new Error( true ? formatProdErrorMessage(13) : "The slice reducer for key \"" + key + "\" returned undefined when probed with a random type. " + ("Don't try to handle '" + ActionTypes.INIT + "' or other actions in \"redux/*\" ") + "namespace. They are considered private. Instead, you must return the " + "current state for any unknown actions, unless it is undefined, " + "in which case you must return the initial state, regardless of the " + "action type. The initial state may not be undefined, but can be null.");
    }
  });
}
/**
 * Turns an object whose values are different reducer functions, into a single
 * reducer function. It will call every child reducer, and gather their results
 * into a single state object, whose keys correspond to the keys of the passed
 * reducer functions.
 *
 * @param {Object} reducers An object whose values correspond to different
 * reducer functions that need to be combined into one. One handy way to obtain
 * it is to use ES6 `import * as reducers` syntax. The reducers may never return
 * undefined for any action. Instead, they should return their initial state
 * if the state passed to them was undefined, and the current state for any
 * unrecognized action.
 *
 * @returns {Function} A reducer function that invokes every reducer inside the
 * passed object, and builds a state object with the same shape.
 */


function combineReducers(reducers) {
  var reducerKeys = Object.keys(reducers);
  var finalReducers = {};

  for (var i = 0; i < reducerKeys.length; i++) {
    var key = reducerKeys[i];

    if (false) {
      if (typeof reducers[key] === 'undefined') {
        warning("No reducer provided for key \"" + key + "\"");
      }
    }

    if (typeof reducers[key] === 'function') {
      finalReducers[key] = reducers[key];
    }
  }

  var finalReducerKeys = Object.keys(finalReducers); // This is used to make sure we don't warn about the same
  // keys multiple times.

  var unexpectedKeyCache;

  if (false) {
    unexpectedKeyCache = {};
  }

  var shapeAssertionError;

  try {
    assertReducerShape(finalReducers);
  } catch (e) {
    shapeAssertionError = e;
  }

  return function combination(state, action) {
    if (state === void 0) {
      state = {};
    }

    if (shapeAssertionError) {
      throw shapeAssertionError;
    }

    if (false) {
      var warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);

      if (warningMessage) {
        warning(warningMessage);
      }
    }

    var hasChanged = false;
    var nextState = {};

    for (var _i = 0; _i < finalReducerKeys.length; _i++) {
      var _key = finalReducerKeys[_i];
      var reducer = finalReducers[_key];
      var previousStateForKey = state[_key];
      var nextStateForKey = reducer(previousStateForKey, action);

      if (typeof nextStateForKey === 'undefined') {
        var actionType = action && action.type;
        throw new Error( true ? formatProdErrorMessage(14) : "When called with an action of type " + (actionType ? "\"" + String(actionType) + "\"" : '(unknown type)') + ", the slice reducer for key \"" + _key + "\" returned undefined. " + "To ignore an action, you must explicitly return the previous state. " + "If you want this reducer to hold no value, you can return null instead of undefined.");
      }

      nextState[_key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }

    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
    return hasChanged ? nextState : state;
  };
}

function bindActionCreator(actionCreator, dispatch) {
  return function () {
    return dispatch(actionCreator.apply(this, arguments));
  };
}
/**
 * Turns an object whose values are action creators, into an object with the
 * same keys, but with every function wrapped into a `dispatch` call so they
 * may be invoked directly. This is just a convenience method, as you can call
 * `store.dispatch(MyActionCreators.doSomething())` yourself just fine.
 *
 * For convenience, you can also pass an action creator as the first argument,
 * and get a dispatch wrapped function in return.
 *
 * @param {Function|Object} actionCreators An object whose values are action
 * creator functions. One handy way to obtain it is to use ES6 `import * as`
 * syntax. You may also pass a single function.
 *
 * @param {Function} dispatch The `dispatch` function available on your Redux
 * store.
 *
 * @returns {Function|Object} The object mimicking the original object, but with
 * every action creator wrapped into the `dispatch` call. If you passed a
 * function as `actionCreators`, the return value will also be a single
 * function.
 */


function bindActionCreators(actionCreators, dispatch) {
  if (typeof actionCreators === 'function') {
    return bindActionCreator(actionCreators, dispatch);
  }

  if (typeof actionCreators !== 'object' || actionCreators === null) {
    throw new Error( true ? formatProdErrorMessage(16) : "bindActionCreators expected an object or a function, but instead received: '" + kindOf(actionCreators) + "'. " + "Did you write \"import ActionCreators from\" instead of \"import * as ActionCreators from\"?");
  }

  var boundActionCreators = {};

  for (var key in actionCreators) {
    var actionCreator = actionCreators[key];

    if (typeof actionCreator === 'function') {
      boundActionCreators[key] = bindActionCreator(actionCreator, dispatch);
    }
  }

  return boundActionCreators;
}

/**
 * Composes single-argument functions from right to left. The rightmost
 * function can take multiple arguments as it provides the signature for
 * the resulting composite function.
 *
 * @param {...Function} funcs The functions to compose.
 * @returns {Function} A function obtained by composing the argument functions
 * from right to left. For example, compose(f, g, h) is identical to doing
 * (...args) => f(g(h(...args))).
 */
function compose() {
  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
    funcs[_key] = arguments[_key];
  }

  if (funcs.length === 0) {
    return function (arg) {
      return arg;
    };
  }

  if (funcs.length === 1) {
    return funcs[0];
  }

  return funcs.reduce(function (a, b) {
    return function () {
      return a(b.apply(void 0, arguments));
    };
  });
}

/**
 * Creates a store enhancer that applies middleware to the dispatch method
 * of the Redux store. This is handy for a variety of tasks, such as expressing
 * asynchronous actions in a concise manner, or logging every action payload.
 *
 * See `redux-thunk` package as an example of the Redux middleware.
 *
 * Because middleware is potentially asynchronous, this should be the first
 * store enhancer in the composition chain.
 *
 * Note that each middleware will be given the `dispatch` and `getState` functions
 * as named arguments.
 *
 * @param {...Function} middlewares The middleware chain to be applied.
 * @returns {Function} A store enhancer applying the middleware.
 */

function applyMiddleware() {
  for (var _len = arguments.length, middlewares = new Array(_len), _key = 0; _key < _len; _key++) {
    middlewares[_key] = arguments[_key];
  }

  return function (createStore) {
    return function () {
      var store = createStore.apply(void 0, arguments);

      var _dispatch = function dispatch() {
        throw new Error( true ? formatProdErrorMessage(15) : 'Dispatching while constructing your middleware is not allowed. ' + 'Other middleware would not be applied to this dispatch.');
      };

      var middlewareAPI = {
        getState: store.getState,
        dispatch: function dispatch() {
          return _dispatch.apply(void 0, arguments);
        }
      };
      var chain = middlewares.map(function (middleware) {
        return middleware(middlewareAPI);
      });
      _dispatch = compose.apply(void 0, chain)(store.dispatch);
      return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectSpread2__["a" /* default */])({}, store), {}, {
        dispatch: _dispatch
      });
    };
  };
}




/***/ }),
/* 92 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsArguments = __webpack_require__(467),
    isObjectLike = __webpack_require__(26);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/**
 * Checks if `value` is likely an `arguments` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 *  else `false`.
 * @example
 *
 * _.isArguments(function() { return arguments; }());
 * // => true
 *
 * _.isArguments([1, 2, 3]);
 * // => false
 */
var isArguments = baseIsArguments(function() { return arguments; }()) ? baseIsArguments : function(value) {
  return isObjectLike(value) && hasOwnProperty.call(value, 'callee') &&
    !propertyIsEnumerable.call(value, 'callee');
};

module.exports = isArguments;


/***/ }),
/* 93 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(40),
    stubFalse = __webpack_require__(468);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined;

/**
 * Checks if `value` is a buffer.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
 * @example
 *
 * _.isBuffer(new Buffer(2));
 * // => true
 *
 * _.isBuffer(new Uint8Array(2));
 * // => false
 */
var isBuffer = nativeIsBuffer || stubFalse;

module.exports = isBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(119)(module)))

/***/ }),
/* 94 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/** Used to detect unsigned integer values. */
var reIsUint = /^(?:0|[1-9]\d*)$/;

/**
 * Checks if `value` is a valid array-like index.
 *
 * @private
 * @param {*} value The value to check.
 * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
 * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
 */
function isIndex(value, length) {
  var type = typeof value;
  length = length == null ? MAX_SAFE_INTEGER : length;

  return !!length &&
    (type == 'number' ||
      (type != 'symbol' && reIsUint.test(value))) &&
        (value > -1 && value % 1 == 0 && value < length);
}

module.exports = isIndex;


/***/ }),
/* 95 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.unary` without support for storing metadata.
 *
 * @private
 * @param {Function} func The function to cap arguments for.
 * @returns {Function} Returns the new capped function.
 */
function baseUnary(func) {
  return function(value) {
    return func(value);
  };
}

module.exports = baseUnary;


/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(73),
    toKey = __webpack_require__(75);

/**
 * The base implementation of `_.get` without support for default values.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path of the property to get.
 * @returns {*} Returns the resolved value.
 */
function baseGet(object, path) {
  path = castPath(path, object);

  var index = 0,
      length = path.length;

  while (object != null && index < length) {
    object = object[toKey(path[index++])];
  }
  return (index && index == length) ? object : undefined;
}

module.exports = baseGet;


/***/ }),
/* 97 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(48),
    isObjectLike = __webpack_require__(26);

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && baseGetTag(value) == symbolTag);
}

module.exports = isSymbol;


/***/ }),
/* 98 */
/***/ (function(module, exports) {

/**
 * This method returns the first argument it receives.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {*} value Any value.
 * @returns {*} Returns `value`.
 * @example
 *
 * var object = { 'a': 1 };
 *
 * console.log(_.identity(object) === object);
 * // => true
 */
function identity(value) {
  return value;
}

module.exports = identity;


/***/ }),
/* 99 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsZWJ = '\\u200d';

/** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange  + rsComboRange + rsVarRange + ']');

/**
 * Checks if `string` contains Unicode symbols.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {boolean} Returns `true` if a symbol is found, else `false`.
 */
function hasUnicode(string) {
  return reHasUnicode.test(string);
}

module.exports = hasUnicode;


/***/ }),
/* 100 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(253),
    baseIteratee = __webpack_require__(36),
    toInteger = __webpack_require__(165);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * This method is like `_.find` except that it returns the index of the first
 * element `predicate` returns truthy for instead of the element itself.
 *
 * @static
 * @memberOf _
 * @since 1.1.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @param {number} [fromIndex=0] The index to search from.
 * @returns {number} Returns the index of the found element, else `-1`.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'active': false },
 *   { 'user': 'fred',    'active': false },
 *   { 'user': 'pebbles', 'active': true }
 * ];
 *
 * _.findIndex(users, function(o) { return o.user == 'barney'; });
 * // => 0
 *
 * // The `_.matches` iteratee shorthand.
 * _.findIndex(users, { 'user': 'fred', 'active': false });
 * // => 1
 *
 * // The `_.matchesProperty` iteratee shorthand.
 * _.findIndex(users, ['active', false]);
 * // => 0
 *
 * // The `_.property` iteratee shorthand.
 * _.findIndex(users, 'active');
 * // => 2
 */
function findIndex(array, predicate, fromIndex) {
  var length = array == null ? 0 : array.length;
  if (!length) {
    return -1;
  }
  var index = fromIndex == null ? 0 : toInteger(fromIndex);
  if (index < 0) {
    index = nativeMax(length + index, 0);
  }
  return baseFindIndex(array, baseIteratee(predicate, 3), index);
}

module.exports = findIndex;


/***/ }),
/* 101 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var fill=_ref.fill,_ref$width=_ref.width,width=_ref$width===undefined?'100%':_ref$width,_ref$height=_ref.height,height=_ref$height===undefined?'100%':_ref$height;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{fill:fill,x:'0px',y:'0px',width:width,height:height,viewBox:'0 0 512 512',xmlSpace:'preserve'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{x:'247.8',y:'-78.4',transform:'matrix(0.7071 -0.7071 0.7071 0.7071 -105.6697 253.2243)',width:'10',height:'665.2'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{x:'-79.7',y:'249.2',transform:'matrix(0.7071 -0.7072 0.7072 0.7071 -105.6698 253.2485)',width:'665.2',height:'10'}));});

/***/ }),
/* 102 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var width=_ref.width,height=_ref.height,_ref$fill=_ref.fill,fill=_ref$fill===undefined?'black':_ref$fill,_ref$strokeWidth=_ref.strokeWidth,strokeWidth=_ref$strokeWidth===undefined?"20":_ref$strokeWidth;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{fill:fill,version:'1.1',x:'0px',y:'0px',width:width,height:height,viewBox:'0 0 512 512',xmlSpace:'preserve'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{transform:'translate(-150 0)'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{fill:'none',stroke:fill,strokeWidth:strokeWidth,x1:'494.3',y1:'19',x2:'256',y2:'256'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('line',{fill:'none',stroke:fill,strokeWidth:strokeWidth,x1:'256',y1:'256',x2:'494.3',y2:'489.3'})));});

/***/ }),
/* 103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var width=_ref.width,height=_ref.height,fill=_ref.fill;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{fill:fill,version:"1.1",x:"0px",y:"0px",width:width,height:height,viewBox:"0 0 512 512",xmlSpace:"preserve"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(150 0)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("line",{fill:"none",stroke:fill,strokeWidth:"20",x1:"17.7",y1:"19",x2:"256",y2:"256"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("line",{fill:"none",stroke:fill,strokeWidth:"20",x1:"256",y1:"256",x2:"17.7",y2:"489.3"})));});

/***/ }),
/* 104 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 105 */
/***/ (function(module, exports) {

module.exports = function (exec) {
  try {
    return !!exec();
  } catch (e) {
    return true;
  }
};


/***/ }),
/* 106 */
/***/ (function(module, exports) {

module.exports = function (bitmap, value) {
  return {
    enumerable: !(bitmap & 1),
    configurable: !(bitmap & 2),
    writable: !(bitmap & 4),
    value: value
  };
};


/***/ }),
/* 107 */
/***/ (function(module, exports) {

module.exports = {};


/***/ }),
/* 108 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fixControlledValue = fixControlledValue;
exports.resolveOnChange = resolveOnChange;
exports.getInputClassName = getInputClassName;
exports["default"] = exports.InputSizes = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(1));

var _reactLifecyclesCompat = __webpack_require__(83);

var _classnames = _interopRequireDefault(__webpack_require__(24));

var _omit = _interopRequireDefault(__webpack_require__(84));

var _type = __webpack_require__(85);

var _ClearableLabeledInput = _interopRequireWildcard(__webpack_require__(293));

var _configProvider = __webpack_require__(28);

var _warning = _interopRequireDefault(__webpack_require__(64));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var InputSizes = (0, _type.tuple)('small', 'default', 'large');
exports.InputSizes = InputSizes;

function fixControlledValue(value) {
  if (typeof value === 'undefined' || value === null) {
    return '';
  }

  return value;
}

function resolveOnChange(target, e, onChange) {
  if (onChange) {
    var event = e;

    if (e.type === 'click') {
      // click clear icon
      event = Object.create(e);
      event.target = target;
      event.currentTarget = target;
      var originalInputValue = target.value; // change target ref value cause e.target.value should be '' when clear input

      target.value = '';
      onChange(event); // reset target ref value

      target.value = originalInputValue;
      return;
    }

    onChange(event);
  }
}

function getInputClassName(prefixCls, size, disabled) {
  var _classNames;

  return (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-sm"), size === 'small'), _defineProperty(_classNames, "".concat(prefixCls, "-lg"), size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-disabled"), disabled), _classNames));
}

var Input = /*#__PURE__*/function (_React$Component) {
  _inherits(Input, _React$Component);

  var _super = _createSuper(Input);

  function Input(props) {
    var _this;

    _classCallCheck(this, Input);

    _this = _super.call(this, props);

    _this.saveClearableInput = function (input) {
      _this.clearableInput = input;
    };

    _this.saveInput = function (input) {
      _this.input = input;
    };

    _this.handleReset = function (e) {
      _this.setValue('', function () {
        _this.focus();
      });

      resolveOnChange(_this.input, e, _this.props.onChange);
    };

    _this.renderInput = function (prefixCls) {
      var _this$props = _this.props,
          className = _this$props.className,
          addonBefore = _this$props.addonBefore,
          addonAfter = _this$props.addonAfter,
          size = _this$props.size,
          disabled = _this$props.disabled; // Fix https://fb.me/react-unknown-prop

      var otherProps = (0, _omit["default"])(_this.props, ['prefixCls', 'onPressEnter', 'addonBefore', 'addonAfter', 'prefix', 'suffix', 'allowClear', // Input elements must be either controlled or uncontrolled,
      // specify either the value prop, or the defaultValue prop, but not both.
      'defaultValue', 'size', 'inputType']);
      return /*#__PURE__*/React.createElement("input", _extends({}, otherProps, {
        onChange: _this.handleChange,
        onKeyDown: _this.handleKeyDown,
        className: (0, _classnames["default"])(getInputClassName(prefixCls, size, disabled), _defineProperty({}, className, className && !addonBefore && !addonAfter)),
        ref: _this.saveInput
      }));
    };

    _this.clearPasswordValueAttribute = function () {
      // https://github.com/ant-design/ant-design/issues/20541
      _this.removePasswordTimeout = setTimeout(function () {
        if (_this.input && _this.input.getAttribute('type') === 'password' && _this.input.hasAttribute('value')) {
          _this.input.removeAttribute('value');
        }
      });
    };

    _this.handleChange = function (e) {
      _this.setValue(e.target.value, _this.clearPasswordValueAttribute);

      resolveOnChange(_this.input, e, _this.props.onChange);
    };

    _this.handleKeyDown = function (e) {
      var _this$props2 = _this.props,
          onPressEnter = _this$props2.onPressEnter,
          onKeyDown = _this$props2.onKeyDown;

      if (e.keyCode === 13 && onPressEnter) {
        onPressEnter(e);
      }

      if (onKeyDown) {
        onKeyDown(e);
      }
    };

    _this.renderComponent = function (_ref) {
      var getPrefixCls = _ref.getPrefixCls;
      var value = _this.state.value;
      var customizePrefixCls = _this.props.prefixCls;
      var prefixCls = getPrefixCls('input', customizePrefixCls);
      return /*#__PURE__*/React.createElement(_ClearableLabeledInput["default"], _extends({}, _this.props, {
        prefixCls: prefixCls,
        inputType: "input",
        value: fixControlledValue(value),
        element: _this.renderInput(prefixCls),
        handleReset: _this.handleReset,
        ref: _this.saveClearableInput
      }));
    };

    var value = typeof props.value === 'undefined' ? props.defaultValue : props.value;
    _this.state = {
      value: value
    };
    return _this;
  }

  _createClass(Input, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.clearPasswordValueAttribute();
    } // Since polyfill `getSnapshotBeforeUpdate` need work with `componentDidUpdate`.
    // We keep an empty function here.

  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {}
  }, {
    key: "getSnapshotBeforeUpdate",
    value: function getSnapshotBeforeUpdate(prevProps) {
      if ((0, _ClearableLabeledInput.hasPrefixSuffix)(prevProps) !== (0, _ClearableLabeledInput.hasPrefixSuffix)(this.props)) {
        (0, _warning["default"])(this.input !== document.activeElement, 'Input', "When Input is focused, dynamic add or remove prefix / suffix will make it lose focus caused by dom structure change. Read more: https://ant.design/components/input/#FAQ");
      }

      return null;
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.removePasswordTimeout) {
        clearTimeout(this.removePasswordTimeout);
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      this.input.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.input.blur();
    }
  }, {
    key: "select",
    value: function select() {
      this.input.select();
    }
  }, {
    key: "setValue",
    value: function setValue(value, callback) {
      if (!('value' in this.props)) {
        this.setState({
          value: value
        }, callback);
      }
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderComponent);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if ('value' in nextProps) {
        return {
          value: nextProps.value
        };
      }

      return null;
    }
  }]);

  return Input;
}(React.Component);

Input.defaultProps = {
  type: 'text'
};
Input.propTypes = {
  type: PropTypes.string,
  id: PropTypes.string,
  size: PropTypes.oneOf(InputSizes),
  maxLength: PropTypes.number,
  disabled: PropTypes.bool,
  value: PropTypes.any,
  defaultValue: PropTypes.any,
  className: PropTypes.string,
  addonBefore: PropTypes.node,
  addonAfter: PropTypes.node,
  prefixCls: PropTypes.string,
  onPressEnter: PropTypes.func,
  onKeyDown: PropTypes.func,
  onKeyUp: PropTypes.func,
  onFocus: PropTypes.func,
  onBlur: PropTypes.func,
  prefix: PropTypes.node,
  suffix: PropTypes.node,
  allowClear: PropTypes.bool
};
(0, _reactLifecyclesCompat.polyfill)(Input);
var _default = Input;
exports["default"] = _default;

/***/ }),
/* 109 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeKeys = __webpack_require__(240),
    baseKeysIn = __webpack_require__(705),
    isArrayLike = __webpack_require__(41);

/**
 * Creates an array of the own and inherited enumerable property names of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.keysIn(new Foo);
 * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
 */
function keysIn(object) {
  return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
}

module.exports = keysIn;


/***/ }),
/* 110 */
/***/ (function(module, exports, __webpack_require__) {

var baseKeys = __webpack_require__(157),
    getTag = __webpack_require__(72),
    isArrayLike = __webpack_require__(41),
    isString = __webpack_require__(258),
    stringSize = __webpack_require__(193);

/** `Object#toString` result references. */
var mapTag = '[object Map]',
    setTag = '[object Set]';

/**
 * Gets the size of `collection` by returning its length for array-like
 * values or the number of own enumerable string keyed properties for objects.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object|string} collection The collection to inspect.
 * @returns {number} Returns the collection size.
 * @example
 *
 * _.size([1, 2, 3]);
 * // => 3
 *
 * _.size({ 'a': 1, 'b': 2 });
 * // => 2
 *
 * _.size('pebbles');
 * // => 7
 */
function size(collection) {
  if (collection == null) {
    return 0;
  }
  if (isArrayLike(collection)) {
    return isString(collection) ? stringSize(collection) : collection.length;
  }
  var tag = getTag(collection);
  if (tag == mapTag || tag == setTag) {
    return collection.size;
  }
  return baseKeys(collection).length;
}

module.exports = size;


/***/ }),
/* 111 */
/***/ (function(module, exports) {

function _extends() {
  module.exports = _extends = Object.assign ? Object.assign.bind() : function (target) {
    for (var i = 1; i < arguments.length; i++) {
      var source = arguments[i];
      for (var key in source) {
        if (Object.prototype.hasOwnProperty.call(source, key)) {
          target[key] = source[key];
        }
      }
    }
    return target;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _extends.apply(this, arguments);
}
module.exports = _extends, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






/**
 * The public API for putting history on context.
 */

var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(children == null || __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children) : null;
  };

  return Router;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Router.propTypes = {
  history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node
};
Router.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Router.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Router);

/***/ }),
/* 113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default()(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

/* harmony default export */ __webpack_exports__["a"] = (matchPath);

/***/ }),
/* 114 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(115),
    stackClear = __webpack_require__(436),
    stackDelete = __webpack_require__(437),
    stackGet = __webpack_require__(438),
    stackHas = __webpack_require__(439),
    stackSet = __webpack_require__(440);

/**
 * Creates a stack cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Stack(entries) {
  var data = this.__data__ = new ListCache(entries);
  this.size = data.size;
}

// Add methods to `Stack`.
Stack.prototype.clear = stackClear;
Stack.prototype['delete'] = stackDelete;
Stack.prototype.get = stackGet;
Stack.prototype.has = stackHas;
Stack.prototype.set = stackSet;

module.exports = Stack;


/***/ }),
/* 115 */
/***/ (function(module, exports, __webpack_require__) {

var listCacheClear = __webpack_require__(431),
    listCacheDelete = __webpack_require__(432),
    listCacheGet = __webpack_require__(433),
    listCacheHas = __webpack_require__(434),
    listCacheSet = __webpack_require__(435);

/**
 * Creates an list cache object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function ListCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `ListCache`.
ListCache.prototype.clear = listCacheClear;
ListCache.prototype['delete'] = listCacheDelete;
ListCache.prototype.get = listCacheGet;
ListCache.prototype.has = listCacheHas;
ListCache.prototype.set = listCacheSet;

module.exports = ListCache;


/***/ }),
/* 116 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(70);

/**
 * Gets the index at which the `key` is found in `array` of key-value pairs.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} key The key to search for.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function assocIndexOf(array, key) {
  var length = array.length;
  while (length--) {
    if (eq(array[length][0], key)) {
      return length;
    }
  }
  return -1;
}

module.exports = assocIndexOf;


/***/ }),
/* 117 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(58);

/* Built-in method references that are verified to be native. */
var nativeCreate = getNative(Object, 'create');

module.exports = nativeCreate;


/***/ }),
/* 118 */
/***/ (function(module, exports, __webpack_require__) {

var isKeyable = __webpack_require__(455);

/**
 * Gets the data for `map`.
 *
 * @private
 * @param {Object} map The map to query.
 * @param {string} key The reference key.
 * @returns {*} Returns the map data.
 */
function getMapData(map, key) {
  var data = map.__data__;
  return isKeyable(key)
    ? data[typeof key == 'string' ? 'string' : 'hash']
    : data.map;
}

module.exports = getMapData;


/***/ }),
/* 119 */
/***/ (function(module, exports) {

module.exports = function(module) {
	if(!module.webpackPolyfill) {
		module.deprecate = function() {};
		module.paths = [];
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 120 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsTypedArray = __webpack_require__(469),
    baseUnary = __webpack_require__(95),
    nodeUtil = __webpack_require__(121);

/* Node.js helper references. */
var nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

/**
 * Checks if `value` is classified as a typed array.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 * @example
 *
 * _.isTypedArray(new Uint8Array);
 * // => true
 *
 * _.isTypedArray([]);
 * // => false
 */
var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

module.exports = isTypedArray;


/***/ }),
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var freeGlobal = __webpack_require__(231);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Detect free variable `process` from Node.js. */
var freeProcess = moduleExports && freeGlobal.process;

/** Used to access faster Node.js helpers. */
var nodeUtil = (function() {
  try {
    // Use `util.types` for Node.js 10+.
    var types = freeModule && freeModule.require && freeModule.require('util').types;

    if (types) {
      return types;
    }

    // Legacy `process.binding('util')` for Node.js < 10.
    return freeProcess && freeProcess.binding && freeProcess.binding('util');
  } catch (e) {}
}());

module.exports = nodeUtil;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(119)(module)))

/***/ }),
/* 122 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Checks if `value` is likely a prototype object.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
 */
function isPrototype(value) {
  var Ctor = value && value.constructor,
      proto = (typeof Ctor == 'function' && Ctor.prototype) || objectProto;

  return value === proto;
}

module.exports = isPrototype;


/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

var baseForOwn = __webpack_require__(481),
    createBaseEach = __webpack_require__(483);

/**
 * The base implementation of `_.forEach` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 */
var baseEach = createBaseEach(baseForOwn);

module.exports = baseEach;


/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

var eq = __webpack_require__(70),
    isArrayLike = __webpack_require__(41),
    isIndex = __webpack_require__(94),
    isObject = __webpack_require__(31);

/**
 * Checks if the given arguments are from an iteratee call.
 *
 * @private
 * @param {*} value The potential iteratee value argument.
 * @param {*} index The potential iteratee index or key argument.
 * @param {*} object The potential iteratee object argument.
 * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
 *  else `false`.
 */
function isIterateeCall(value, index, object) {
  if (!isObject(object)) {
    return false;
  }
  var type = typeof index;
  if (type == 'number'
        ? (isArrayLike(object) && isIndex(index, object.length))
        : (type == 'string' && index in object)
      ) {
    return eq(object[index], value);
  }
  return false;
}

module.exports = isIterateeCall;


/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.canUseDOM = exports.slidesOnLeft = exports.slidesOnRight = exports.siblingDirection = exports.getTotalSlides = exports.getPostClones = exports.getPreClones = exports.getTrackLeft = exports.getTrackAnimateCSS = exports.getTrackCSS = exports.checkSpecKeys = exports.getSlideCount = exports.checkNavigable = exports.getNavigableIndexes = exports.swipeEnd = exports.swipeMove = exports.swipeStart = exports.keyHandler = exports.changeSlide = exports.slideHandler = exports.initializedState = exports.extractObject = exports.canGoNext = exports.getSwipeDirection = exports.getHeight = exports.getWidth = exports.lazySlidesOnRight = exports.lazySlidesOnLeft = exports.lazyEndIndex = exports.lazyStartIndex = exports.getRequiredLazySlides = exports.getOnDemandLazySlides = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(30);

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var getOnDemandLazySlides = exports.getOnDemandLazySlides = function getOnDemandLazySlides(spec) {
  var onDemandSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);
  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    if (spec.lazyLoadedList.indexOf(slideIndex) < 0) {
      onDemandSlides.push(slideIndex);
    }
  }
  return onDemandSlides;
};

// return list of slides that need to be present
var getRequiredLazySlides = exports.getRequiredLazySlides = function getRequiredLazySlides(spec) {
  var requiredSlides = [];
  var startIndex = lazyStartIndex(spec);
  var endIndex = lazyEndIndex(spec);
  for (var slideIndex = startIndex; slideIndex < endIndex; slideIndex++) {
    requiredSlides.push(slideIndex);
  }
  return requiredSlides;
};

// startIndex that needs to be present
var lazyStartIndex = exports.lazyStartIndex = function lazyStartIndex(spec) {
  return spec.currentSlide - lazySlidesOnLeft(spec);
};
var lazyEndIndex = exports.lazyEndIndex = function lazyEndIndex(spec) {
  return spec.currentSlide + lazySlidesOnRight(spec);
};
var lazySlidesOnLeft = exports.lazySlidesOnLeft = function lazySlidesOnLeft(spec) {
  return spec.centerMode ? Math.floor(spec.slidesToShow / 2) + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : 0;
};
var lazySlidesOnRight = exports.lazySlidesOnRight = function lazySlidesOnRight(spec) {
  return spec.centerMode ? Math.floor((spec.slidesToShow - 1) / 2) + 1 + (parseInt(spec.centerPadding) > 0 ? 1 : 0) : spec.slidesToShow;
};

// get width of an element
var getWidth = exports.getWidth = function getWidth(elem) {
  return elem && elem.offsetWidth || 0;
};
var getHeight = exports.getHeight = function getHeight(elem) {
  return elem && elem.offsetHeight || 0;
};
var getSwipeDirection = exports.getSwipeDirection = function getSwipeDirection(touchObject) {
  var verticalSwiping = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

  var xDist, yDist, r, swipeAngle;
  xDist = touchObject.startX - touchObject.curX;
  yDist = touchObject.startY - touchObject.curY;
  r = Math.atan2(yDist, xDist);
  swipeAngle = Math.round(r * 180 / Math.PI);
  if (swipeAngle < 0) {
    swipeAngle = 360 - Math.abs(swipeAngle);
  }
  if (swipeAngle <= 45 && swipeAngle >= 0 || swipeAngle <= 360 && swipeAngle >= 315) {
    return "left";
  }
  if (swipeAngle >= 135 && swipeAngle <= 225) {
    return "right";
  }
  if (verticalSwiping === true) {
    if (swipeAngle >= 35 && swipeAngle <= 135) {
      return "up";
    } else {
      return "down";
    }
  }

  return "vertical";
};

// whether or not we can go next
var canGoNext = exports.canGoNext = function canGoNext(spec) {
  var canGo = true;
  if (!spec.infinite) {
    if (spec.centerMode && spec.currentSlide >= spec.slideCount - 1) {
      canGo = false;
    } else if (spec.slideCount <= spec.slidesToShow || spec.currentSlide >= spec.slideCount - spec.slidesToShow) {
      canGo = false;
    }
  }
  return canGo;
};

// given an object and a list of keys, return new object with given keys
var extractObject = exports.extractObject = function extractObject(spec, keys) {
  var newObject = {};
  keys.forEach(function (key) {
    return newObject[key] = spec[key];
  });
  return newObject;
};

// get initialized state
var initializedState = exports.initializedState = function initializedState(spec) {
  // spec also contains listRef, trackRef
  var slideCount = _react2.default.Children.count(spec.children);
  var listWidth = Math.ceil(getWidth(_reactDom2.default.findDOMNode(spec.listRef)));
  var trackWidth = Math.ceil(getWidth(_reactDom2.default.findDOMNode(spec.trackRef)));
  var slideWidth = void 0;
  if (!spec.vertical) {
    var centerPaddingAdj = spec.centerMode && parseInt(spec.centerPadding) * 2;
    if (typeof spec.centerPadding === "string" && spec.centerPadding.slice(-1) === "%") {
      centerPaddingAdj *= listWidth / 100;
    }
    slideWidth = Math.ceil((listWidth - centerPaddingAdj) / spec.slidesToShow);
  } else {
    slideWidth = listWidth;
  }
  var slideHeight = _reactDom2.default.findDOMNode(spec.listRef) && getHeight(_reactDom2.default.findDOMNode(spec.listRef).querySelector('[data-index="0"]'));
  var listHeight = slideHeight * spec.slidesToShow;
  var currentSlide = spec.currentSlide === undefined ? spec.initialSlide : spec.currentSlide;
  if (spec.rtl && spec.currentSlide === undefined) {
    currentSlide = slideCount - 1 - spec.initialSlide;
  }
  var lazyLoadedList = spec.lazyLoadedList || [];
  var slidesToLoad = getOnDemandLazySlides({ currentSlide: currentSlide, lazyLoadedList: lazyLoadedList }, spec);
  lazyLoadedList.concat(slidesToLoad);

  var state = {
    slideCount: slideCount,
    slideWidth: slideWidth,
    listWidth: listWidth,
    trackWidth: trackWidth,
    currentSlide: currentSlide,
    slideHeight: slideHeight,
    listHeight: listHeight,
    lazyLoadedList: lazyLoadedList
  };

  if (spec.autoplaying === null && spec.autoplay) {
    state["autoplaying"] = "playing";
  }

  return state;
};

var slideHandler = exports.slideHandler = function slideHandler(spec) {
  var waitForAnimate = spec.waitForAnimate,
      animating = spec.animating,
      fade = spec.fade,
      infinite = spec.infinite,
      index = spec.index,
      slideCount = spec.slideCount,
      lazyLoadedList = spec.lazyLoadedList,
      lazyLoad = spec.lazyLoad,
      currentSlide = spec.currentSlide,
      centerMode = spec.centerMode,
      slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      useCSS = spec.useCSS;

  if (waitForAnimate && animating) return {};
  var animationSlide = index,
      finalSlide = void 0,
      animationLeft = void 0,
      finalLeft = void 0;
  var state = {},
      nextState = {};
  if (fade) {
    if (!infinite && (index < 0 || index >= slideCount)) return {};
    if (index < 0) {
      animationSlide = index + slideCount;
    } else if (index >= slideCount) {
      animationSlide = index - slideCount;
    }
    if (lazyLoad && lazyLoadedList.indexOf(animationSlide) < 0) {
      lazyLoadedList.push(animationSlide);
    }
    state = {
      animating: true,
      currentSlide: animationSlide,
      lazyLoadedList: lazyLoadedList
    };
    nextState = { animating: false };
  } else {
    finalSlide = animationSlide;
    if (animationSlide < 0) {
      finalSlide = animationSlide + slideCount;
      if (!infinite) finalSlide = 0;else if (slideCount % slidesToScroll !== 0) finalSlide = slideCount - slideCount % slidesToScroll;
    } else if (!canGoNext(spec) && animationSlide > currentSlide) {
      animationSlide = finalSlide = currentSlide;
    } else if (centerMode && animationSlide >= slideCount) {
      animationSlide = infinite ? slideCount : slideCount - 1;
      finalSlide = infinite ? 0 : slideCount - 1;
    } else if (animationSlide >= slideCount) {
      finalSlide = animationSlide - slideCount;
      if (!infinite) finalSlide = slideCount - slidesToShow;else if (slideCount % slidesToScroll !== 0) finalSlide = 0;
    }
    animationLeft = getTrackLeft(_extends({}, spec, { slideIndex: animationSlide }));
    finalLeft = getTrackLeft(_extends({}, spec, { slideIndex: finalSlide }));
    if (!infinite) {
      if (animationLeft === finalLeft) animationSlide = finalSlide;
      animationLeft = finalLeft;
    }
    lazyLoad && lazyLoadedList.concat(getOnDemandLazySlides(_extends({}, spec, { currentSlide: animationSlide })));
    if (!useCSS) {
      state = {
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_extends({}, spec, { left: finalLeft })),
        lazyLoadedList: lazyLoadedList
      };
    } else {
      state = {
        animating: true,
        currentSlide: finalSlide,
        trackStyle: getTrackAnimateCSS(_extends({}, spec, { left: animationLeft })),
        lazyLoadedList: lazyLoadedList
      };
      nextState = {
        animating: false,
        currentSlide: finalSlide,
        trackStyle: getTrackCSS(_extends({}, spec, { left: finalLeft })),
        swipeLeft: null
      };
    }
  }
  return { state: state, nextState: nextState };
};

var changeSlide = exports.changeSlide = function changeSlide(spec, options) {
  var indexOffset, previousInt, slideOffset, unevenOffset, targetSlide;
  var slidesToScroll = spec.slidesToScroll,
      slidesToShow = spec.slidesToShow,
      slideCount = spec.slideCount,
      currentSlide = spec.currentSlide,
      lazyLoad = spec.lazyLoad,
      infinite = spec.infinite;

  unevenOffset = slideCount % slidesToScroll !== 0;
  indexOffset = unevenOffset ? 0 : (slideCount - currentSlide) % slidesToScroll;

  if (options.message === "previous") {
    slideOffset = indexOffset === 0 ? slidesToScroll : slidesToShow - indexOffset;
    targetSlide = currentSlide - slideOffset;
    if (lazyLoad && !infinite) {
      previousInt = currentSlide - slideOffset;
      targetSlide = previousInt === -1 ? slideCount - 1 : previousInt;
    }
  } else if (options.message === "next") {
    slideOffset = indexOffset === 0 ? slidesToScroll : indexOffset;
    targetSlide = currentSlide + slideOffset;
    if (lazyLoad && !infinite) {
      targetSlide = (currentSlide + slidesToScroll) % slideCount + indexOffset;
    }
  } else if (options.message === "dots") {
    // Click on dots
    targetSlide = options.index * options.slidesToScroll;
    if (targetSlide === options.currentSlide) {
      return null;
    }
  } else if (options.message === "children") {
    // Click on the slides
    targetSlide = options.index;
    if (targetSlide === options.currentSlide) {
      return null;
    }
    if (infinite) {
      var direction = siblingDirection(_extends({}, spec, { targetSlide: targetSlide }));
      if (targetSlide > options.currentSlide && direction === "left") {
        targetSlide = targetSlide - slideCount;
      } else if (targetSlide < options.currentSlide && direction === "right") {
        targetSlide = targetSlide + slideCount;
      }
    }
  } else if (options.message === "index") {
    targetSlide = Number(options.index);
    if (targetSlide === options.currentSlide) {
      return null;
    }
  }
  return targetSlide;
};
var keyHandler = exports.keyHandler = function keyHandler(e, accessibility, rtl) {
  if (e.target.tagName.match("TEXTAREA|INPUT|SELECT") || !accessibility) return "";
  if (e.keyCode === 37) return rtl ? "next" : "previous";
  if (e.keyCode === 39) return rtl ? "previous" : "next";
  return "";
};

var swipeStart = exports.swipeStart = function swipeStart(e, swipe, draggable) {
  e.target.tagName === "IMG" && e.preventDefault();
  if (!swipe || !draggable && e.type.indexOf("mouse") !== -1) return "";
  return {
    dragging: true,
    touchObject: {
      startX: e.touches ? e.touches[0].pageX : e.clientX,
      startY: e.touches ? e.touches[0].pageY : e.clientY,
      curX: e.touches ? e.touches[0].pageX : e.clientX,
      curY: e.touches ? e.touches[0].pageY : e.clientY
    }
  };
};
var swipeMove = exports.swipeMove = function swipeMove(e, spec) {
  // spec also contains, trackRef and slideIndex
  var scrolling = spec.scrolling,
      animating = spec.animating,
      vertical = spec.vertical,
      swipeToSlide = spec.swipeToSlide,
      verticalSwiping = spec.verticalSwiping,
      rtl = spec.rtl,
      currentSlide = spec.currentSlide,
      edgeFriction = spec.edgeFriction,
      edgeDragged = spec.edgeDragged,
      onEdge = spec.onEdge,
      swiped = spec.swiped,
      swiping = spec.swiping,
      slideCount = spec.slideCount,
      slidesToScroll = spec.slidesToScroll,
      infinite = spec.infinite,
      touchObject = spec.touchObject,
      swipeEvent = spec.swipeEvent,
      listHeight = spec.listHeight,
      listWidth = spec.listWidth;

  if (scrolling) return;
  if (animating) return e.preventDefault();
  if (vertical && swipeToSlide && verticalSwiping) e.preventDefault();
  var swipeLeft = void 0,
      state = {};
  var curLeft = getTrackLeft(spec);
  touchObject.curX = e.touches ? e.touches[0].pageX : e.clientX;
  touchObject.curY = e.touches ? e.touches[0].pageY : e.clientY;
  touchObject.swipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curX - touchObject.startX, 2)));
  var verticalSwipeLength = Math.round(Math.sqrt(Math.pow(touchObject.curY - touchObject.startY, 2)));
  if (!verticalSwiping && !swiping && verticalSwipeLength > 10) {
    return { scrolling: true };
  }
  if (verticalSwiping) touchObject.swipeLength = verticalSwipeLength;
  var positionOffset = (!rtl ? 1 : -1) * (touchObject.curX > touchObject.startX ? 1 : -1);
  if (verticalSwiping) positionOffset = touchObject.curY > touchObject.startY ? 1 : -1;

  var dotCount = Math.ceil(slideCount / slidesToScroll);
  var swipeDirection = getSwipeDirection(spec.touchObject, verticalSwiping);
  var touchSwipeLength = touchObject.swipeLength;
  if (!infinite) {
    if (currentSlide === 0 && swipeDirection === "right" || currentSlide + 1 >= dotCount && swipeDirection === "left" || !canGoNext(spec) && swipeDirection === "left") {
      touchSwipeLength = touchObject.swipeLength * edgeFriction;
      if (edgeDragged === false && onEdge) {
        onEdge(swipeDirection);
        state["edgeDragged"] = true;
      }
    }
  }
  if (!swiped && swipeEvent) {
    swipeEvent(swipeDirection);
    state["swiped"] = true;
  }
  if (!vertical) {
    if (!rtl) {
      swipeLeft = curLeft + touchSwipeLength * positionOffset;
    } else {
      swipeLeft = curLeft - touchSwipeLength * positionOffset;
    }
  } else {
    swipeLeft = curLeft + touchSwipeLength * (listHeight / listWidth) * positionOffset;
  }
  if (verticalSwiping) {
    swipeLeft = curLeft + touchSwipeLength * positionOffset;
  }
  state = _extends({}, state, {
    touchObject: touchObject,
    swipeLeft: swipeLeft,
    trackStyle: getTrackCSS(_extends({}, spec, { left: swipeLeft }))
  });
  if (Math.abs(touchObject.curX - touchObject.startX) < Math.abs(touchObject.curY - touchObject.startY) * 0.8) {
    return state;
  }
  if (touchObject.swipeLength > 10) {
    state["swiping"] = true;
    e.preventDefault();
  }
  return state;
};
var swipeEnd = exports.swipeEnd = function swipeEnd(e, spec) {
  var dragging = spec.dragging,
      swipe = spec.swipe,
      touchObject = spec.touchObject,
      listWidth = spec.listWidth,
      touchThreshold = spec.touchThreshold,
      verticalSwiping = spec.verticalSwiping,
      listHeight = spec.listHeight,
      currentSlide = spec.currentSlide,
      swipeToSlide = spec.swipeToSlide,
      scrolling = spec.scrolling,
      onSwipe = spec.onSwipe;

  if (!dragging) {
    if (swipe) e.preventDefault();
    return {};
  }
  var minSwipe = verticalSwiping ? listHeight / touchThreshold : listWidth / touchThreshold;
  var swipeDirection = getSwipeDirection(touchObject, verticalSwiping);
  // reset the state of touch related state variables.
  var state = {
    dragging: false,
    edgeDragged: false,
    scrolling: false,
    swiping: false,
    swiped: false,
    swipeLeft: null,
    touchObject: {}
  };
  if (scrolling) {
    return state;
  }
  if (!touchObject.swipeLength) {
    return state;
  }
  if (touchObject.swipeLength > minSwipe) {
    e.preventDefault();
    if (onSwipe) {
      onSwipe(swipeDirection);
    }
    var slideCount = void 0,
        newSlide = void 0;
    switch (swipeDirection) {
      case "left":
      case "up":
        newSlide = currentSlide + getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 0;
        break;
      case "right":
      case "down":
        newSlide = currentSlide - getSlideCount(spec);
        slideCount = swipeToSlide ? checkNavigable(spec, newSlide) : newSlide;
        state["currentDirection"] = 1;
        break;
      default:
        slideCount = currentSlide;
    }
    state["triggerSlideHandler"] = slideCount;
  } else {
    // Adjust the track back to it's original position.
    var currentLeft = getTrackLeft(spec);
    state["trackStyle"] = getTrackAnimateCSS(_extends({}, spec, { left: currentLeft }));
  }
  return state;
};
var getNavigableIndexes = exports.getNavigableIndexes = function getNavigableIndexes(spec) {
  var max = spec.infinite ? spec.slideCount * 2 : spec.slideCount;
  var breakpoint = spec.infinite ? spec.slidesToShow * -1 : 0;
  var counter = spec.infinite ? spec.slidesToShow * -1 : 0;
  var indexes = [];
  while (breakpoint < max) {
    indexes.push(breakpoint);
    breakpoint = counter + spec.slidesToScroll;
    counter += Math.min(spec.slidesToScroll, spec.slidesToShow);
  }
  return indexes;
};
var checkNavigable = exports.checkNavigable = function checkNavigable(spec, index) {
  var navigables = getNavigableIndexes(spec);
  var prevNavigable = 0;
  if (index > navigables[navigables.length - 1]) {
    index = navigables[navigables.length - 1];
  } else {
    for (var n in navigables) {
      if (index < navigables[n]) {
        index = prevNavigable;
        break;
      }
      prevNavigable = navigables[n];
    }
  }
  return index;
};
var getSlideCount = exports.getSlideCount = function getSlideCount(spec) {
  var centerOffset = spec.centerMode ? spec.slideWidth * Math.floor(spec.slidesToShow / 2) : 0;
  if (spec.swipeToSlide) {
    var swipedSlide = void 0;
    var slickList = _reactDom2.default.findDOMNode(spec.listRef);
    var slides = slickList.querySelectorAll(".slick-slide");
    Array.from(slides).every(function (slide) {
      if (!spec.vertical) {
        if (slide.offsetLeft - centerOffset + getWidth(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      } else {
        if (slide.offsetTop + getHeight(slide) / 2 > spec.swipeLeft * -1) {
          swipedSlide = slide;
          return false;
        }
      }

      return true;
    });

    if (!swipedSlide) {
      return 0;
    }
    var currentIndex = spec.rtl === true ? spec.slideCount - spec.currentSlide : spec.currentSlide;
    var slidesTraversed = Math.abs(swipedSlide.dataset.index - currentIndex) || 1;
    return slidesTraversed;
  } else {
    return spec.slidesToScroll;
  }
};

var checkSpecKeys = exports.checkSpecKeys = function checkSpecKeys(spec, keysArray) {
  return keysArray.reduce(function (value, key) {
    return value && spec.hasOwnProperty(key);
  }, true) ? null : console.error("Keys Missing:", spec);
};

var getTrackCSS = exports.getTrackCSS = function getTrackCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth"]);
  var trackWidth = void 0,
      trackHeight = void 0;
  var trackChildren = spec.slideCount + 2 * spec.slidesToShow;
  if (!spec.vertical) {
    trackWidth = getTotalSlides(spec) * spec.slideWidth;
  } else {
    trackHeight = trackChildren * spec.slideHeight;
  }
  var style = {
    opacity: 1,
    transition: "",
    WebkitTransition: ""
  };
  if (spec.useTransform) {
    var WebkitTransform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var transform = !spec.vertical ? "translate3d(" + spec.left + "px, 0px, 0px)" : "translate3d(0px, " + spec.left + "px, 0px)";
    var msTransform = !spec.vertical ? "translateX(" + spec.left + "px)" : "translateY(" + spec.left + "px)";
    style = _extends({}, style, {
      WebkitTransform: WebkitTransform,
      transform: transform,
      msTransform: msTransform
    });
  } else {
    if (spec.vertical) {
      style["top"] = spec.left;
    } else {
      style["left"] = spec.left;
    }
  }
  if (spec.fade) style = { opacity: 1 };
  if (trackWidth) style.width = trackWidth;
  if (trackHeight) style.height = trackHeight;

  // Fallback for IE8
  if (window && !window.addEventListener && window.attachEvent) {
    if (!spec.vertical) {
      style.marginLeft = spec.left + "px";
    } else {
      style.marginTop = spec.left + "px";
    }
  }

  return style;
};
var getTrackAnimateCSS = exports.getTrackAnimateCSS = function getTrackAnimateCSS(spec) {
  checkSpecKeys(spec, ["left", "variableWidth", "slideCount", "slidesToShow", "slideWidth", "speed", "cssEase"]);
  var style = getTrackCSS(spec);
  // useCSS is true by default so it can be undefined
  if (spec.useTransform) {
    style.WebkitTransition = "-webkit-transform " + spec.speed + "ms " + spec.cssEase;
    style.transition = "transform " + spec.speed + "ms " + spec.cssEase;
  } else {
    if (spec.vertical) {
      style.transition = "top " + spec.speed + "ms " + spec.cssEase;
    } else {
      style.transition = "left " + spec.speed + "ms " + spec.cssEase;
    }
  }
  return style;
};
var getTrackLeft = exports.getTrackLeft = function getTrackLeft(spec) {
  if (spec.unslick) {
    return 0;
  }

  checkSpecKeys(spec, ["slideIndex", "trackRef", "infinite", "centerMode", "slideCount", "slidesToShow", "slidesToScroll", "slideWidth", "listWidth", "variableWidth", "slideHeight"]);

  var slideIndex = spec.slideIndex,
      trackRef = spec.trackRef,
      infinite = spec.infinite,
      centerMode = spec.centerMode,
      slideCount = spec.slideCount,
      slidesToShow = spec.slidesToShow,
      slidesToScroll = spec.slidesToScroll,
      slideWidth = spec.slideWidth,
      listWidth = spec.listWidth,
      variableWidth = spec.variableWidth,
      slideHeight = spec.slideHeight,
      fade = spec.fade,
      vertical = spec.vertical;


  var slideOffset = 0;
  var targetLeft;
  var targetSlide;
  var verticalOffset = 0;

  if (fade || spec.slideCount === 1) {
    return 0;
  }

  var slidesToOffset = 0;
  if (infinite) {
    slidesToOffset = -getPreClones(spec); // bring active slide to the beginning of visual area
    // if next scroll doesn't have enough children, just reach till the end of original slides instead of shifting slidesToScroll children
    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = -(slideIndex > slideCount ? slidesToShow - (slideIndex - slideCount) : slideCount % slidesToScroll);
    }
    // shift current slide to center of the frame
    if (centerMode) {
      slidesToOffset += parseInt(slidesToShow / 2);
    }
  } else {
    if (slideCount % slidesToScroll !== 0 && slideIndex + slidesToScroll > slideCount) {
      slidesToOffset = slidesToShow - slideCount % slidesToScroll;
    }
    if (centerMode) {
      slidesToOffset = parseInt(slidesToShow / 2);
    }
  }
  slideOffset = slidesToOffset * slideWidth;
  verticalOffset = slidesToOffset * slideHeight;

  if (!vertical) {
    targetLeft = slideIndex * slideWidth * -1 + slideOffset;
  } else {
    targetLeft = slideIndex * slideHeight * -1 + verticalOffset;
  }

  if (variableWidth === true) {
    var targetSlideIndex;
    var trackElem = _reactDom2.default.findDOMNode(trackRef);
    targetSlideIndex = slideIndex + getPreClones(spec);
    targetSlide = trackElem && trackElem.childNodes[targetSlideIndex];
    targetLeft = targetSlide ? targetSlide.offsetLeft * -1 : 0;
    if (centerMode === true) {
      targetSlideIndex = infinite ? slideIndex + getPreClones(spec) : slideIndex;
      targetSlide = trackElem && trackElem.children[targetSlideIndex];
      targetLeft = 0;
      for (var slide = 0; slide < targetSlideIndex; slide++) {
        targetLeft -= trackElem && trackElem.children[slide] && trackElem.children[slide].offsetWidth;
      }
      targetLeft -= parseInt(spec.centerPadding);
      targetLeft += targetSlide && (listWidth - targetSlide.offsetWidth) / 2;
    }
  }

  return targetLeft;
};

var getPreClones = exports.getPreClones = function getPreClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }
  if (spec.variableWidth) {
    return spec.slideCount;
  }
  return spec.slidesToShow + (spec.centerMode ? 1 : 0);
};

var getPostClones = exports.getPostClones = function getPostClones(spec) {
  if (spec.unslick || !spec.infinite) {
    return 0;
  }
  return spec.slideCount;
};

var getTotalSlides = exports.getTotalSlides = function getTotalSlides(spec) {
  return spec.slideCount === 1 ? 1 : getPreClones(spec) + spec.slideCount + getPostClones(spec);
};
var siblingDirection = exports.siblingDirection = function siblingDirection(spec) {
  if (spec.targetSlide > spec.currentSlide) {
    if (spec.targetSlide > spec.currentSlide + slidesOnRight(spec)) {
      return "left";
    }
    return "right";
  } else {
    if (spec.targetSlide < spec.currentSlide - slidesOnLeft(spec)) {
      return "right";
    }
    return "left";
  }
};

var slidesOnRight = exports.slidesOnRight = function slidesOnRight(_ref) {
  var slidesToShow = _ref.slidesToShow,
      centerMode = _ref.centerMode,
      rtl = _ref.rtl,
      centerPadding = _ref.centerPadding;

  // returns no of slides on the right of active slide
  if (centerMode) {
    var right = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) right += 1;
    if (rtl && slidesToShow % 2 === 0) right += 1;
    return right;
  }
  if (rtl) {
    return 0;
  }
  return slidesToShow - 1;
};

var slidesOnLeft = exports.slidesOnLeft = function slidesOnLeft(_ref2) {
  var slidesToShow = _ref2.slidesToShow,
      centerMode = _ref2.centerMode,
      rtl = _ref2.rtl,
      centerPadding = _ref2.centerPadding;

  // returns no of slides on the left of active slide
  if (centerMode) {
    var left = (slidesToShow - 1) / 2 + 1;
    if (parseInt(centerPadding) > 0) left += 1;
    if (!rtl && slidesToShow % 2 === 0) left += 1;
    return left;
  }
  if (rtl) {
    return slidesToShow - 1;
  }
  return 0;
};

var canUseDOM = exports.canUseDOM = function canUseDOM() {
  return !!(typeof window !== "undefined" && window.document && window.document.createElement);
};

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _defineProperty = __webpack_require__(274);

var _defineProperty2 = _interopRequireDefault(_defineProperty);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (obj, key, value) {
  if (key in obj) {
    (0, _defineProperty2.default)(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
};

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.14 / 15.2.3.14 Object.keys(O)
var $keys = __webpack_require__(277);
var enumBugKeys = __webpack_require__(179);

module.exports = Object.keys || function keys(O) {
  return $keys(O, enumBugKeys);
};


/***/ }),
/* 128 */
/***/ (function(module, exports) {

module.exports = true;


/***/ }),
/* 129 */
/***/ (function(module, exports) {

var id = 0;
var px = Math.random();
module.exports = function (key) {
  return 'Symbol('.concat(key === undefined ? '' : key, ')_', (++id + px).toString(36));
};


/***/ }),
/* 130 */
/***/ (function(module, exports) {

exports.f = {}.propertyIsEnumerable;


/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.13 ToObject(argument)
var defined = __webpack_require__(175);
module.exports = function (it) {
  return Object(defined(it));
};


/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _typeof2 = __webpack_require__(181);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && ((typeof call === "undefined" ? "undefined" : (0, _typeof3.default)(call)) === "object" || typeof call === "function") ? call : self;
};

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _setPrototypeOf = __webpack_require__(589);

var _setPrototypeOf2 = _interopRequireDefault(_setPrototypeOf);

var _create = __webpack_require__(593);

var _create2 = _interopRequireDefault(_create);

var _typeof2 = __webpack_require__(181);

var _typeof3 = _interopRequireDefault(_typeof2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + (typeof superClass === "undefined" ? "undefined" : (0, _typeof3.default)(superClass)));
  }

  subClass.prototype = (0, _create2.default)(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf2.default ? (0, _setPrototypeOf2.default)(subClass, superClass) : subClass.__proto__ = superClass;
};

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(135);

var _utils2 = _interopRequireDefault(_utils);

var _animateScroll = __webpack_require__(310);

var _animateScroll2 = _interopRequireDefault(_animateScroll);

var _scrollEvents = __webpack_require__(197);

var _scrollEvents2 = _interopRequireDefault(_scrollEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var __mapped = {};
var __activeLink = void 0;

exports.default = {

  unmount: function unmount() {
    __mapped = {};
  },

  register: function register(name, element) {
    __mapped[name] = element;
  },

  unregister: function unregister(name) {
    delete __mapped[name];
  },

  get: function get(name) {
    return __mapped[name] || document.getElementById(name) || document.getElementsByName(name)[0] || document.getElementsByClassName(name)[0];
  },

  setActiveLink: function setActiveLink(link) {
    return __activeLink = link;
  },

  getActiveLink: function getActiveLink() {
    return __activeLink;
  },

  scrollTo: function scrollTo(to, props) {

    var target = this.get(to);

    if (!target) {
      console.warn("target Element not found");
      return;
    }

    props = _extends({}, props, { absolute: false });

    var containerId = props.containerId;
    var container = props.container;

    var containerElement = void 0;
    if (containerId) {
      containerElement = document.getElementById(containerId);
    } else if (container && container.nodeType) {
      containerElement = container;
    } else {
      containerElement = document;
    }

    props.absolute = true;

    var horizontal = props.horizontal;
    var scrollOffset = _utils2.default.scrollOffset(containerElement, target, horizontal) + (props.offset || 0);

    /*
     * if animate is not provided just scroll into the view
     */
    if (!props.smooth) {
      if (_scrollEvents2.default.registered['begin']) {
        _scrollEvents2.default.registered['begin'](to, target);
      }

      if (containerElement === document) {
        if (props.horizontal) {
          window.scrollTo(scrollOffset, 0);
        } else {
          window.scrollTo(0, scrollOffset);
        }
      } else {
        containerElement.scrollTop = scrollOffset;
      }

      if (_scrollEvents2.default.registered['end']) {
        _scrollEvents2.default.registered['end'](to, target);
      }

      return;
    }

    /*
     * Animate scrolling
     */

    _animateScroll2.default.animateTopScroll(scrollOffset, props, to, target);
  }
};

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var updateHash = function updateHash(hash, historyUpdate) {
  var hashVal = hash.indexOf("#") === 0 ? hash.substring(1) : hash;
  var hashToUpdate = hashVal ? "#" + hashVal : "";
  var curLoc = window && window.location;
  var urlToPush = hashToUpdate ? curLoc.pathname + curLoc.search + hashToUpdate : curLoc.pathname + curLoc.search;
  historyUpdate ? history.pushState(history.state, "", urlToPush) : history.replaceState(history.state, "", urlToPush);
};

var getHash = function getHash() {
  return window.location.hash.replace(/^#/, "");
};

var filterElementInContainer = function filterElementInContainer(container) {
  return function (element) {
    return container.contains ? container != element && container.contains(element) : !!(container.compareDocumentPosition(element) & 16);
  };
};

var isPositioned = function isPositioned(element) {
  return getComputedStyle(element).position !== "static";
};

var getElementOffsetInfoUntil = function getElementOffsetInfoUntil(element, predicate) {
  var offsetTop = element.offsetTop;
  var currentOffsetParent = element.offsetParent;

  while (currentOffsetParent && !predicate(currentOffsetParent)) {
    offsetTop += currentOffsetParent.offsetTop;
    currentOffsetParent = currentOffsetParent.offsetParent;
  }

  return { offsetTop: offsetTop, offsetParent: currentOffsetParent };
};

var scrollOffset = function scrollOffset(c, t, horizontal) {
  if (horizontal) {
    return c === document ? t.getBoundingClientRect().left + (window.scrollX || window.pageXOffset) : getComputedStyle(c).position !== "static" ? t.offsetLeft : t.offsetLeft - c.offsetLeft;
  } else {
    if (c === document) {
      return t.getBoundingClientRect().top + (window.scrollY || window.pageYOffset);
    }

    // The offsetParent of an element, according to MDN, is its nearest positioned
    // (an element whose position is anything other than static) ancestor. The offsetTop
    // of an element is taken with respect to its offsetParent which may not neccessarily
    // be its parentElement except the parent itself is positioned.

    // So if containerElement is positioned, then it must be an offsetParent somewhere
    // If it happens that targetElement is a descendant of the containerElement, and there
    // is not intermediate positioned element between the two of them, i.e.
    // targetElement"s offsetParent is the same as the containerElement, then the
    // distance between the two will be the offsetTop of the targetElement.
    // If, on the other hand, there are intermediate positioned elements between the
    // two entities, the distance between the targetElement and the containerElement
    // will be the accumulation of the offsetTop of the element and that of its
    // subsequent offsetParent until the containerElement is reached, since it
    // will also be an offsetParent at some point due to the fact that it is positioned.

    // If the containerElement is not positioned, then it can"t be an offsetParent,
    // which means that the offsetTop of the targetElement would not be with respect to it.
    // However, if the two of them happen to have the same offsetParent, then
    // the distance between them will be the difference between their offsetTop
    // since they are both taken with respect to the same entity.
    // The last resort would be to accumulate their offsetTop until a common
    // offsetParent is reached (usually the document) and taking the difference
    // between the accumulated offsetTops

    if (isPositioned(c)) {
      if (t.offsetParent !== c) {
        var isContainerElementOrDocument = function isContainerElementOrDocument(e) {
          return e === c || e === document;
        };

        var _getElementOffsetInfo = getElementOffsetInfoUntil(t, isContainerElementOrDocument),
            offsetTop = _getElementOffsetInfo.offsetTop,
            offsetParent = _getElementOffsetInfo.offsetParent;

        if (offsetParent !== c) {
          throw new Error("Seems containerElement is not an ancestor of the Element");
        }

        return offsetTop;
      }

      return t.offsetTop;
    }

    if (t.offsetParent === c.offsetParent) {
      return t.offsetTop - c.offsetTop;
    }

    var isDocument = function isDocument(e) {
      return e === document;
    };
    return getElementOffsetInfoUntil(t, isDocument).offsetTop - getElementOffsetInfoUntil(c, isDocument).offsetTop;
  }
};

exports.default = {
  updateHash: updateHash,
  getHash: getHash,
  filterElementInContainer: filterElementInContainer,
  scrollOffset: scrollOffset
};

/***/ }),
/* 136 */
/***/ (function(module, exports) {

function _typeof(o) {
  "@babel/helpers - typeof";

  return (module.exports = _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports), _typeof(o);
}
module.exports = _typeof, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleFullscreenChange = handleFullscreenChange;
exports.activate = activate;
exports.userActivate = userActivate;
exports.play = play;
exports.pause = pause;
exports.togglePlay = togglePlay;
exports.seek = seek;
exports.forward = forward;
exports.replay = replay;
exports.changeRate = changeRate;
exports.changeVolume = changeVolume;
exports.mute = mute;
exports.toggleFullscreen = toggleFullscreen;
exports.USER_ACTIVATE = exports.PLAYER_ACTIVATE = exports.FULLSCREEN_CHANGE = exports.OPERATE = void 0;

var _fullscreen = _interopRequireDefault(__webpack_require__(338));

var OPERATE = 'video-react/OPERATE';
exports.OPERATE = OPERATE;
var FULLSCREEN_CHANGE = 'video-react/FULLSCREEN_CHANGE';
exports.FULLSCREEN_CHANGE = FULLSCREEN_CHANGE;
var PLAYER_ACTIVATE = 'video-react/PLAYER_ACTIVATE';
exports.PLAYER_ACTIVATE = PLAYER_ACTIVATE;
var USER_ACTIVATE = 'video-react/USER_ACTIVATE';
exports.USER_ACTIVATE = USER_ACTIVATE;

function handleFullscreenChange(isFullscreen) {
  return {
    type: FULLSCREEN_CHANGE,
    isFullscreen: isFullscreen
  };
}

function activate(activity) {
  return {
    type: PLAYER_ACTIVATE,
    activity: activity
  };
}

function userActivate(activity) {
  return {
    type: USER_ACTIVATE,
    activity: activity
  };
}

function play() {
  var operation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    action: 'play',
    source: ''
  };
  this.video.play();
  return {
    type: OPERATE,
    operation: operation
  };
}

function pause() {
  var operation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    action: 'pause',
    source: ''
  };
  this.video.pause();
  return {
    type: OPERATE,
    operation: operation
  };
}

function togglePlay() {
  var operation = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {
    action: 'toggle-play',
    source: ''
  };
  this.video.togglePlay();
  return {
    type: OPERATE,
    operation: operation
  };
} // seek video by time


function seek(time) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    action: 'seek',
    source: ''
  };
  this.video.seek(time);
  return {
    type: OPERATE,
    operation: operation
  };
} // jump forward x seconds


function forward(seconds) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    action: "forward-".concat(seconds),
    source: ''
  };
  this.video.forward(seconds);
  return {
    type: OPERATE,
    operation: operation
  };
} // jump back x seconds


function replay(seconds) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    action: "replay-".concat(seconds),
    source: ''
  };
  this.video.replay(seconds);
  return {
    type: OPERATE,
    operation: operation
  };
}

function changeRate(rate) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    action: 'change-rate',
    source: ''
  };
  this.video.playbackRate = rate;
  return {
    type: OPERATE,
    operation: operation
  };
}

function changeVolume(volume) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    action: 'change-volume',
    source: ''
  };
  var v = volume;

  if (volume < 0) {
    v = 0;
  }

  if (volume > 1) {
    v = 1;
  }

  this.video.volume = v;
  return {
    type: OPERATE,
    operation: operation
  };
}

function mute(muted) {
  var operation = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
    action: muted ? 'muted' : 'unmuted',
    source: ''
  };
  this.video.muted = muted;
  return {
    type: OPERATE,
    operation: operation
  };
}

function toggleFullscreen(player) {
  if (_fullscreen["default"].enabled) {
    if (_fullscreen["default"].isFullscreen) {
      _fullscreen["default"].exit();
    } else {
      _fullscreen["default"].request(this.rootElement);
    }

    return {
      type: OPERATE,
      operation: {
        action: 'toggle-fullscreen',
        source: ''
      }
    };
  }

  return {
    type: FULLSCREEN_CHANGE,
    isFullscreen: !player.isFullscreen
  };
}

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.findElPosition = findElPosition;
exports.getPointerPosition = getPointerPosition;
exports.blurNode = blurNode;
exports.focusNode = focusNode;
exports.hasClass = hasClass;

/**
 * Offset Left
 * getBoundingClientRect technique from
 * John Resig http://ejohn.org/blog/getboundingclientrect-is-awesome/
 *
 * @function findElPosition
 * @param {ReactNodeRef} el React Node ref from which to get offset
 * @return {Object}
 */
function findElPosition(el) {
  var box;

  if (el.getBoundingClientRect && el.parentNode) {
    box = el.getBoundingClientRect();
  }

  if (!box) {
    return {
      left: 0,
      top: 0
    };
  }

  var _document = document,
      body = _document.body,
      docEl = _document.documentElement;
  var clientLeft = docEl.clientLeft || body.clientLeft || 0;
  var scrollLeft = window.pageXOffset || body.scrollLeft;
  var left = box.left + scrollLeft - clientLeft;
  var clientTop = docEl.clientTop || body.clientTop || 0;
  var scrollTop = window.pageYOffset || body.scrollTop;
  var top = box.top + scrollTop - clientTop; // Android sometimes returns slightly off decimal values, so need to round

  return {
    left: Math.round(left),
    top: Math.round(top)
  };
}
/**
 * Get pointer position in a React Node ref
 * Returns an object with x and y coordinates.
 * The base on the coordinates are the bottom left of the element.
 *
 * @function getPointerPosition
 * @param {ReactNodeRef} el React Node ref on which to get the pointer position on
 * @param {Event} event Event object
 * @return {Object} This object will have x and y coordinates corresponding to the mouse position
 */


function getPointerPosition(el, event) {
  var position = {};
  var box = findElPosition(el);
  var boxW = el.offsetWidth;
  var boxH = el.offsetHeight;
  var boxY = box.top;
  var boxX = box.left;
  var evtPageY = event.pageY;
  var evtPageX = event.pageX;

  if (event.changedTouches) {
    evtPageX = event.changedTouches[0].pageX;
    evtPageY = event.changedTouches[0].pageY;
  }

  position.y = Math.max(0, Math.min(1, (boxY - evtPageY + boxH) / boxH));
  position.x = Math.max(0, Math.min(1, (evtPageX - boxX) / boxW));
  return position;
} // blur an element


function blurNode(reactNode) {
  if (reactNode && reactNode.blur) {
    reactNode.blur();
  }
} // focus an element


function focusNode(reactNode) {
  if (reactNode && reactNode.focus) {
    reactNode.focus();
  }
} // check if an element has a class name


function hasClass(elm, cls) {
  var classes = elm.className.split(' ');

  for (var i = 0; i < classes.length; i++) {
    if (classes[i].toLowerCase() === cls.toLowerCase()) {
      return true;
    }
  }

  return false;
}

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */


/**
 * WARNING: DO NOT manually require this module.
 * This is a replacement for `invariant(...)` used by the error code system
 * and will _only_ be required by the corresponding babel pass.
 * It always throws.
 */

function reactProdInvariant(code) {
  var argCount = arguments.length - 1;

  var message = 'Minified React error #' + code + '; visit ' + 'http://facebook.github.io/react/docs/error-decoder.html?invariant=' + code;

  for (var argIdx = 0; argIdx < argCount; argIdx++) {
    message += '&args[]=' + encodeURIComponent(arguments[argIdx + 1]);
  }

  message += ' for the full message or use the non-minified dev environment' + ' for full errors and additional helpful warnings.';

  var error = new Error(message);
  error.name = 'Invariant Violation';
  error.framesToPop = 1; // we don't care about reactProdInvariant's own frame

  throw error;
}

module.exports = reactProdInvariant;

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;

/***/ }),
/* 141 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _inheritsLoose;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__ = __webpack_require__(389);

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  Object(__WEBPACK_IMPORTED_MODULE_0__setPrototypeOf_js__["a" /* default */])(subClass, superClass);
}

/***/ }),
/* 142 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = warning;
/**
 * Prints a warning in the console if it exists.
 *
 * @param {String} message The warning message.
 * @returns {void}
 */
function warning(message) {
  /* eslint-disable no-console */
  if (typeof console !== 'undefined' && typeof console.error === 'function') {
    console.error(message);
  }
  /* eslint-enable no-console */


  try {
    // This error was thrown as a convenience so that if you enable
    // "break on all exceptions" in your console,
    // it would pause the execution at this line.
    throw new Error(message);
    /* eslint-disable no-empty */
  } catch (e) {}
  /* eslint-enable no-empty */

}

/***/ }),
/* 143 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__ = __webpack_require__(112);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Router__["a" /* default */]);

/***/ }),
/* 144 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(113);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







var isEmptyChildren = function isEmptyChildren(children) {
  return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return __WEBPACK_IMPORTED_MODULE_2_react___default.a.Children.only(children);

    return null;
  };

  return Route;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

Route.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object, // private, from <Switch>
  path: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  exact: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  sensitive: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.bool,
  component: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  render: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func,
  children: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node]),
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
};
Route.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    route: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object
  })
};
Route.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Route);

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

var isarray = __webpack_require__(415)

/**
 * Expose `pathToRegexp`.
 */
module.exports = pathToRegexp
module.exports.parse = parse
module.exports.compile = compile
module.exports.tokensToFunction = tokensToFunction
module.exports.tokensToRegExp = tokensToRegExp

/**
 * The main path matching regexp utility.
 *
 * @type {RegExp}
 */
var PATH_REGEXP = new RegExp([
  // Match escaped characters that would otherwise appear in future matches.
  // This allows the user to escape special characters that won't transform.
  '(\\\\.)',
  // Match Express-style parameters and un-named parameters with a prefix
  // and optional suffixes. Matches appear as:
  //
  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
].join('|'), 'g')

/**
 * Parse a string for the raw tokens.
 *
 * @param  {string}  str
 * @param  {Object=} options
 * @return {!Array}
 */
function parse (str, options) {
  var tokens = []
  var key = 0
  var index = 0
  var path = ''
  var defaultDelimiter = options && options.delimiter || '/'
  var res

  while ((res = PATH_REGEXP.exec(str)) != null) {
    var m = res[0]
    var escaped = res[1]
    var offset = res.index
    path += str.slice(index, offset)
    index = offset + m.length

    // Ignore already escaped sequences.
    if (escaped) {
      path += escaped[1]
      continue
    }

    var next = str[index]
    var prefix = res[2]
    var name = res[3]
    var capture = res[4]
    var group = res[5]
    var modifier = res[6]
    var asterisk = res[7]

    // Push the current path onto the tokens.
    if (path) {
      tokens.push(path)
      path = ''
    }

    var partial = prefix != null && next != null && next !== prefix
    var repeat = modifier === '+' || modifier === '*'
    var optional = modifier === '?' || modifier === '*'
    var delimiter = res[2] || defaultDelimiter
    var pattern = capture || group

    tokens.push({
      name: name || key++,
      prefix: prefix || '',
      delimiter: delimiter,
      optional: optional,
      repeat: repeat,
      partial: partial,
      asterisk: !!asterisk,
      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
    })
  }

  // Match any characters still remaining.
  if (index < str.length) {
    path += str.substr(index)
  }

  // If the path exists, push it onto the end.
  if (path) {
    tokens.push(path)
  }

  return tokens
}

/**
 * Compile a string to a template function for the path.
 *
 * @param  {string}             str
 * @param  {Object=}            options
 * @return {!function(Object=, Object=)}
 */
function compile (str, options) {
  return tokensToFunction(parse(str, options), options)
}

/**
 * Prettier encoding of URI path segments.
 *
 * @param  {string}
 * @return {string}
 */
function encodeURIComponentPretty (str) {
  return encodeURI(str).replace(/[\/?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
 *
 * @param  {string}
 * @return {string}
 */
function encodeAsterisk (str) {
  return encodeURI(str).replace(/[?#]/g, function (c) {
    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
  })
}

/**
 * Expose a method for transforming tokens into the path function.
 */
function tokensToFunction (tokens, options) {
  // Compile all the tokens into regexps.
  var matches = new Array(tokens.length)

  // Compile all the patterns before compilation.
  for (var i = 0; i < tokens.length; i++) {
    if (typeof tokens[i] === 'object') {
      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
    }
  }

  return function (obj, opts) {
    var path = ''
    var data = obj || {}
    var options = opts || {}
    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent

    for (var i = 0; i < tokens.length; i++) {
      var token = tokens[i]

      if (typeof token === 'string') {
        path += token

        continue
      }

      var value = data[token.name]
      var segment

      if (value == null) {
        if (token.optional) {
          // Prepend partial segment prefixes.
          if (token.partial) {
            path += token.prefix
          }

          continue
        } else {
          throw new TypeError('Expected "' + token.name + '" to be defined')
        }
      }

      if (isarray(value)) {
        if (!token.repeat) {
          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
        }

        if (value.length === 0) {
          if (token.optional) {
            continue
          } else {
            throw new TypeError('Expected "' + token.name + '" to not be empty')
          }
        }

        for (var j = 0; j < value.length; j++) {
          segment = encode(value[j])

          if (!matches[i].test(segment)) {
            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
          }

          path += (j === 0 ? token.prefix : token.delimiter) + segment
        }

        continue
      }

      segment = token.asterisk ? encodeAsterisk(value) : encode(value)

      if (!matches[i].test(segment)) {
        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
      }

      path += token.prefix + segment
    }

    return path
  }
}

/**
 * Escape a regular expression string.
 *
 * @param  {string} str
 * @return {string}
 */
function escapeString (str) {
  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
}

/**
 * Escape the capturing group by escaping special characters and meaning.
 *
 * @param  {string} group
 * @return {string}
 */
function escapeGroup (group) {
  return group.replace(/([=!:$\/()])/g, '\\$1')
}

/**
 * Attach the keys as a property of the regexp.
 *
 * @param  {!RegExp} re
 * @param  {Array}   keys
 * @return {!RegExp}
 */
function attachKeys (re, keys) {
  re.keys = keys
  return re
}

/**
 * Get the flags for a regexp from the options.
 *
 * @param  {Object} options
 * @return {string}
 */
function flags (options) {
  return options && options.sensitive ? '' : 'i'
}

/**
 * Pull out keys from a regexp.
 *
 * @param  {!RegExp} path
 * @param  {!Array}  keys
 * @return {!RegExp}
 */
function regexpToRegexp (path, keys) {
  // Use a negative lookahead to match only capturing groups.
  var groups = path.source.match(/\((?!\?)/g)

  if (groups) {
    for (var i = 0; i < groups.length; i++) {
      keys.push({
        name: i,
        prefix: null,
        delimiter: null,
        optional: false,
        repeat: false,
        partial: false,
        asterisk: false,
        pattern: null
      })
    }
  }

  return attachKeys(path, keys)
}

/**
 * Transform an array into a regexp.
 *
 * @param  {!Array}  path
 * @param  {Array}   keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function arrayToRegexp (path, keys, options) {
  var parts = []

  for (var i = 0; i < path.length; i++) {
    parts.push(pathToRegexp(path[i], keys, options).source)
  }

  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))

  return attachKeys(regexp, keys)
}

/**
 * Create a path regexp from string input.
 *
 * @param  {string}  path
 * @param  {!Array}  keys
 * @param  {!Object} options
 * @return {!RegExp}
 */
function stringToRegexp (path, keys, options) {
  return tokensToRegExp(parse(path, options), keys, options)
}

/**
 * Expose a function for taking tokens and returning a RegExp.
 *
 * @param  {!Array}          tokens
 * @param  {(Array|Object)=} keys
 * @param  {Object=}         options
 * @return {!RegExp}
 */
function tokensToRegExp (tokens, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  var strict = options.strict
  var end = options.end !== false
  var route = ''

  // Iterate over the tokens and create our regexp string.
  for (var i = 0; i < tokens.length; i++) {
    var token = tokens[i]

    if (typeof token === 'string') {
      route += escapeString(token)
    } else {
      var prefix = escapeString(token.prefix)
      var capture = '(?:' + token.pattern + ')'

      keys.push(token)

      if (token.repeat) {
        capture += '(?:' + prefix + capture + ')*'
      }

      if (token.optional) {
        if (!token.partial) {
          capture = '(?:' + prefix + '(' + capture + '))?'
        } else {
          capture = prefix + '(' + capture + ')?'
        }
      } else {
        capture = prefix + '(' + capture + ')'
      }

      route += capture
    }
  }

  var delimiter = escapeString(options.delimiter || '/')
  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter

  // In non-strict mode we allow a slash at the end of match. If the path to
  // match already ends with a slash, we remove it for consistency. The slash
  // is valid at the end of a path match, not in the middle. This is important
  // in non-ending mode, where "/test/" shouldn't match "/test//route".
  if (!strict) {
    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
  }

  if (end) {
    route += '$'
  } else {
    // In non-ending mode, we need the capturing groups to match as much as
    // possible by using a positive lookahead to the end or next path segment.
    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
  }

  return attachKeys(new RegExp('^' + route, flags(options)), keys)
}

/**
 * Normalize the given path string, returning a regular expression.
 *
 * An empty array can be passed in for the keys, which will hold the
 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
 *
 * @param  {(string|RegExp|Array)} path
 * @param  {(Array|Object)=}       keys
 * @param  {Object=}               options
 * @return {!RegExp}
 */
function pathToRegexp (path, keys, options) {
  if (!isarray(keys)) {
    options = /** @type {!Object} */ (keys || options)
    keys = []
  }

  options = options || {}

  if (path instanceof RegExp) {
    return regexpToRegexp(path, /** @type {!Array} */ (keys))
  }

  if (isarray(path)) {
    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
  }

  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
}


/***/ }),
/* 146 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp__ = __webpack_require__(145);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_path_to_regexp__);


var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compileGenerator = function compileGenerator(pattern) {
  var cacheKey = pattern;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var compiledGenerator = __WEBPACK_IMPORTED_MODULE_0_path_to_regexp___default.a.compile(pattern);

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledGenerator;
    cacheCount++;
  }

  return compiledGenerator;
};

/**
 * Public API for generating a URL pathname from a pattern and parameters.
 */
var generatePath = function generatePath() {
  var pattern = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "/";
  var params = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

  if (pattern === "/") {
    return pattern;
  }
  var generator = compileGenerator(pattern);
  return generator(params, { pretty: true });
};

/* harmony default export */ __webpack_exports__["a"] = (generatePath);

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _pathToRegexp = __webpack_require__(145);

var _pathToRegexp2 = _interopRequireDefault(_pathToRegexp);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var patternCache = {};
var cacheLimit = 10000;
var cacheCount = 0;

var compilePath = function compilePath(pattern, options) {
  var cacheKey = "" + options.end + options.strict + options.sensitive;
  var cache = patternCache[cacheKey] || (patternCache[cacheKey] = {});

  if (cache[pattern]) return cache[pattern];

  var keys = [];
  var re = (0, _pathToRegexp2.default)(pattern, keys, options);
  var compiledPattern = { re: re, keys: keys };

  if (cacheCount < cacheLimit) {
    cache[pattern] = compiledPattern;
    cacheCount++;
  }

  return compiledPattern;
};

/**
 * Public API for matching a URL pathname to a path pattern.
 */
var matchPath = function matchPath(pathname) {
  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  var parent = arguments[2];

  if (typeof options === "string") options = { path: options };

  var _options = options,
      path = _options.path,
      _options$exact = _options.exact,
      exact = _options$exact === undefined ? false : _options$exact,
      _options$strict = _options.strict,
      strict = _options$strict === undefined ? false : _options$strict,
      _options$sensitive = _options.sensitive,
      sensitive = _options$sensitive === undefined ? false : _options$sensitive;


  if (path == null) return parent;

  var _compilePath = compilePath(path, { end: exact, strict: strict, sensitive: sensitive }),
      re = _compilePath.re,
      keys = _compilePath.keys;

  var match = re.exec(pathname);

  if (!match) return null;

  var url = match[0],
      values = match.slice(1);

  var isExact = pathname === url;

  if (exact && !isExact) return null;

  return {
    path: path, // the path pattern used to match
    url: path === "/" && url === "" ? "/" : url, // the matched portion of the URL
    isExact: isExact, // whether or not we matched exactly
    params: keys.reduce(function (memo, key, index) {
      memo[key.name] = values[index];
      return memo;
    }, {})
  };
};

exports.default = matchPath;

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(58),
    root = __webpack_require__(40);

/* Built-in method references that are verified to be native. */
var Map = getNative(root, 'Map');

module.exports = Map;


/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(48),
    isObject = __webpack_require__(31);

/** `Object#toString` result references. */
var asyncTag = '[object AsyncFunction]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    proxyTag = '[object Proxy]';

/**
 * Checks if `value` is classified as a `Function` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a function, else `false`.
 * @example
 *
 * _.isFunction(_);
 * // => true
 *
 * _.isFunction(/abc/);
 * // => false
 */
function isFunction(value) {
  if (!isObject(value)) {
    return false;
  }
  // The use of `Object#toString` avoids issues with the `typeof` operator
  // in Safari 9 which returns 'object' for typed arrays and other constructors.
  var tag = baseGetTag(value);
  return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
}

module.exports = isFunction;


/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

var mapCacheClear = __webpack_require__(447),
    mapCacheDelete = __webpack_require__(454),
    mapCacheGet = __webpack_require__(456),
    mapCacheHas = __webpack_require__(457),
    mapCacheSet = __webpack_require__(458);

/**
 * Creates a map cache object to store key-value pairs.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function MapCache(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `MapCache`.
MapCache.prototype.clear = mapCacheClear;
MapCache.prototype['delete'] = mapCacheDelete;
MapCache.prototype.get = mapCacheGet;
MapCache.prototype.has = mapCacheHas;
MapCache.prototype.set = mapCacheSet;

module.exports = MapCache;


/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqualDeep = __webpack_require__(459),
    isObjectLike = __webpack_require__(26);

/**
 * The base implementation of `_.isEqual` which supports partial comparisons
 * and tracks traversed objects.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Unordered comparison
 *  2 - Partial comparison
 * @param {Function} [customizer] The function to customize comparisons.
 * @param {Object} [stack] Tracks traversed `value` and `other` objects.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 */
function baseIsEqual(value, other, bitmask, customizer, stack) {
  if (value === other) {
    return true;
  }
  if (value == null || other == null || (!isObjectLike(value) && !isObjectLike(other))) {
    return value !== value && other !== other;
  }
  return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
}

module.exports = baseIsEqual;


/***/ }),
/* 152 */
/***/ (function(module, exports) {

/**
 * Converts `set` to an array of its values.
 *
 * @private
 * @param {Object} set The set to convert.
 * @returns {Array} Returns the values.
 */
function setToArray(set) {
  var index = -1,
      result = Array(set.size);

  set.forEach(function(value) {
    result[++index] = value;
  });
  return result;
}

module.exports = setToArray;


/***/ }),
/* 153 */
/***/ (function(module, exports) {

/**
 * Appends the elements of `values` to `array`.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {Array} values The values to append.
 * @returns {Array} Returns `array`.
 */
function arrayPush(array, values) {
  var index = -1,
      length = values.length,
      offset = array.length;

  while (++index < length) {
    array[offset + index] = values[index];
  }
  return array;
}

module.exports = arrayPush;


/***/ }),
/* 154 */
/***/ (function(module, exports, __webpack_require__) {

var arrayFilter = __webpack_require__(155),
    stubArray = __webpack_require__(239);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Built-in value references. */
var propertyIsEnumerable = objectProto.propertyIsEnumerable;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbols = !nativeGetSymbols ? stubArray : function(object) {
  if (object == null) {
    return [];
  }
  object = Object(object);
  return arrayFilter(nativeGetSymbols(object), function(symbol) {
    return propertyIsEnumerable.call(object, symbol);
  });
};

module.exports = getSymbols;


/***/ }),
/* 155 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.filter` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function arrayFilter(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];

  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result[resIndex++] = value;
    }
  }
  return result;
}

module.exports = arrayFilter;


/***/ }),
/* 156 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/**
 * Checks if `value` is a valid array-like length.
 *
 * **Note:** This method is loosely based on
 * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
 * @example
 *
 * _.isLength(3);
 * // => true
 *
 * _.isLength(Number.MIN_VALUE);
 * // => false
 *
 * _.isLength(Infinity);
 * // => false
 *
 * _.isLength('3');
 * // => false
 */
function isLength(value) {
  return typeof value == 'number' &&
    value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
}

module.exports = isLength;


/***/ }),
/* 157 */
/***/ (function(module, exports, __webpack_require__) {

var isPrototype = __webpack_require__(122),
    nativeKeys = __webpack_require__(470);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeys(object) {
  if (!isPrototype(object)) {
    return nativeKeys(object);
  }
  var result = [];
  for (var key in Object(object)) {
    if (hasOwnProperty.call(object, key) && key != 'constructor') {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeys;


/***/ }),
/* 158 */
/***/ (function(module, exports, __webpack_require__) {

var isArray = __webpack_require__(13),
    isSymbol = __webpack_require__(97);

/** Used to match property names within property paths. */
var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/;

/**
 * Checks if `value` is a property name and not a property path.
 *
 * @private
 * @param {*} value The value to check.
 * @param {Object} [object] The object to query keys on.
 * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
 */
function isKey(value, object) {
  if (isArray(value)) {
    return false;
  }
  var type = typeof value;
  if (type == 'number' || type == 'symbol' || type == 'boolean' ||
      value == null || isSymbol(value)) {
    return true;
  }
  return reIsPlainProp.test(value) || !reIsDeepProp.test(value) ||
    (object != null && value in Object(object));
}

module.exports = isKey;


/***/ }),
/* 159 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(71),
    arrayMap = __webpack_require__(69),
    isArray = __webpack_require__(13),
    isSymbol = __webpack_require__(97);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolToString = symbolProto ? symbolProto.toString : undefined;

/**
 * The base implementation of `_.toString` which doesn't convert nullish
 * values to empty strings.
 *
 * @private
 * @param {*} value The value to process.
 * @returns {string} Returns the string.
 */
function baseToString(value) {
  // Exit early for strings to avoid a performance hit in some environments.
  if (typeof value == 'string') {
    return value;
  }
  if (isArray(value)) {
    // Recursively convert values (susceptible to call stack limits).
    return arrayMap(value, baseToString) + '';
  }
  if (isSymbol(value)) {
    return symbolToString ? symbolToString.call(value) : '';
  }
  var result = (value + '');
  return (result == '0' && (1 / value) == -INFINITY) ? '-0' : result;
}

module.exports = baseToString;


/***/ }),
/* 160 */
/***/ (function(module, exports, __webpack_require__) {

var baseTrim = __webpack_require__(484),
    isObject = __webpack_require__(31),
    isSymbol = __webpack_require__(97);

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = baseTrim(value);
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = toNumber;


/***/ }),
/* 161 */
/***/ (function(module, exports, __webpack_require__) {

var baseToString = __webpack_require__(159),
    castSlice = __webpack_require__(162),
    hasUnicode = __webpack_require__(99),
    isIterateeCall = __webpack_require__(124),
    isRegExp = __webpack_require__(486),
    stringToArray = __webpack_require__(163),
    toString = __webpack_require__(74);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Splits `string` by `separator`.
 *
 * **Note:** This method is based on
 * [`String#split`](https://mdn.io/String/split).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to split.
 * @param {RegExp|string} separator The separator pattern to split by.
 * @param {number} [limit] The length to truncate results to.
 * @returns {Array} Returns the string segments.
 * @example
 *
 * _.split('a-b-c', '-', 2);
 * // => ['a', 'b']
 */
function split(string, separator, limit) {
  if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
    separator = limit = undefined;
  }
  limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
  if (!limit) {
    return [];
  }
  string = toString(string);
  if (string && (
        typeof separator == 'string' ||
        (separator != null && !isRegExp(separator))
      )) {
    separator = baseToString(separator);
    if (!separator && hasUnicode(string)) {
      return castSlice(stringToArray(string), 0, limit);
    }
  }
  return string.split(separator, limit);
}

module.exports = split;


/***/ }),
/* 162 */
/***/ (function(module, exports, __webpack_require__) {

var baseSlice = __webpack_require__(251);

/**
 * Casts `array` to a slice if it's needed.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {number} start The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the cast slice.
 */
function castSlice(array, start, end) {
  var length = array.length;
  end = end === undefined ? length : end;
  return (!start && end >= length) ? array : baseSlice(array, start, end);
}

module.exports = castSlice;


/***/ }),
/* 163 */
/***/ (function(module, exports, __webpack_require__) {

var asciiToArray = __webpack_require__(488),
    hasUnicode = __webpack_require__(99),
    unicodeToArray = __webpack_require__(489);

/**
 * Converts `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function stringToArray(string) {
  return hasUnicode(string)
    ? unicodeToArray(string)
    : asciiToArray(string);
}

module.exports = stringToArray;


/***/ }),
/* 164 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(74);

/**
 * Replaces matches for `pattern` in `string` with `replacement`.
 *
 * **Note:** This method is based on
 * [`String#replace`](https://mdn.io/String/replace).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to modify.
 * @param {RegExp|string} pattern The pattern to replace.
 * @param {Function|string} replacement The match replacement.
 * @returns {string} Returns the modified string.
 * @example
 *
 * _.replace('Hi Fred', 'Fred', 'Barney');
 * // => 'Hi Barney'
 */
function replace() {
  var args = arguments,
      string = toString(args[0]);

  return args.length < 3 ? string : string.replace(args[1], args[2]);
}

module.exports = replace;


/***/ }),
/* 165 */
/***/ (function(module, exports, __webpack_require__) {

var toFinite = __webpack_require__(254);

/**
 * Converts `value` to an integer.
 *
 * **Note:** This method is loosely based on
 * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted integer.
 * @example
 *
 * _.toInteger(3.2);
 * // => 3
 *
 * _.toInteger(Number.MIN_VALUE);
 * // => 0
 *
 * _.toInteger(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toInteger('3.2');
 * // => 3
 */
function toInteger(value) {
  var result = toFinite(value),
      remainder = result % 1;

  return result === result ? (remainder ? result - remainder : result) : 0;
}

module.exports = toInteger;


/***/ }),
/* 166 */
/***/ (function(module, exports) {

/**
 * Gets the last element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the last element of `array`.
 * @example
 *
 * _.last([1, 2, 3]);
 * // => 3
 */
function last(array) {
  var length = array == null ? 0 : array.length;
  return length ? array[length - 1] : undefined;
}

module.exports = last;


/***/ }),
/* 167 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeJoin = arrayProto.join;

/**
 * Converts all elements in `array` into a string separated by `separator`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to convert.
 * @param {string} [separator=','] The element separator.
 * @returns {string} Returns the joined string.
 * @example
 *
 * _.join(['a', 'b', 'c'], '~');
 * // => 'a~b~c'
 */
function join(array, separator) {
  return array == null ? '' : nativeJoin.call(array, separator);
}

module.exports = join;


/***/ }),
/* 168 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(151);

/**
 * Performs a deep comparison between two values to determine if they are
 * equivalent.
 *
 * **Note:** This method supports comparing arrays, array buffers, booleans,
 * date objects, error objects, maps, numbers, `Object` objects, regexes,
 * sets, strings, symbols, and typed arrays. `Object` objects are compared
 * by their own, not inherited, enumerable properties. Functions and DOM
 * nodes are compared by strict equality, i.e. `===`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
 * @example
 *
 * var object = { 'a': 1 };
 * var other = { 'a': 1 };
 *
 * _.isEqual(object, other);
 * // => true
 *
 * object === other;
 * // => false
 */
function isEqual(value, other) {
  return baseIsEqual(value, other);
}

module.exports = isEqual;


/***/ }),
/* 169 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(170),
    eq = __webpack_require__(70);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Assigns `value` to `key` of `object` if the existing value is not equivalent
 * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
 * for equality comparisons.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignValue(object, key, value) {
  var objValue = object[key];
  if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignValue;


/***/ }),
/* 170 */
/***/ (function(module, exports, __webpack_require__) {

var defineProperty = __webpack_require__(262);

/**
 * The base implementation of `assignValue` and `assignMergeValue` without
 * value checks.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function baseAssignValue(object, key, value) {
  if (key == '__proto__' && defineProperty) {
    defineProperty(object, key, {
      'configurable': true,
      'enumerable': true,
      'value': value,
      'writable': true
    });
  } else {
    object[key] = value;
  }
}

module.exports = baseAssignValue;


/***/ }),
/* 171 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 172 */
/***/ (function(module, exports, __webpack_require__) {

// optional / simple context binding
var aFunction = __webpack_require__(561);
module.exports = function (fn, that, length) {
  aFunction(fn);
  if (that === undefined) return fn;
  switch (length) {
    case 1: return function (a) {
      return fn.call(that, a);
    };
    case 2: return function (a, b) {
      return fn.call(that, a, b);
    };
    case 3: return function (a, b, c) {
      return fn.call(that, a, b, c);
    };
  }
  return function (/* ...args */) {
    return fn.apply(that, arguments);
  };
};


/***/ }),
/* 173 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.1 ToPrimitive(input [, PreferredType])
var isObject = __webpack_require__(79);
// instead of the ES6 spec version, we didn't implement @@toPrimitive case
// and the second argument - flag - preferred type is a string
module.exports = function (it, S) {
  if (!isObject(it)) return it;
  var fn, val;
  if (S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  if (typeof (fn = it.valueOf) == 'function' && !isObject(val = fn.call(it))) return val;
  if (!S && typeof (fn = it.toString) == 'function' && !isObject(val = fn.call(it))) return val;
  throw TypeError("Can't convert object to primitive value");
};


/***/ }),
/* 174 */
/***/ (function(module, exports) {

var toString = {}.toString;

module.exports = function (it) {
  return toString.call(it).slice(8, -1);
};


/***/ }),
/* 175 */
/***/ (function(module, exports) {

// 7.2.1 RequireObjectCoercible(argument)
module.exports = function (it) {
  if (it == undefined) throw TypeError("Can't call method on  " + it);
  return it;
};


/***/ }),
/* 176 */
/***/ (function(module, exports) {

// 7.1.4 ToInteger
var ceil = Math.ceil;
var floor = Math.floor;
module.exports = function (it) {
  return isNaN(it = +it) ? 0 : (it > 0 ? floor : ceil)(it);
};


/***/ }),
/* 177 */
/***/ (function(module, exports, __webpack_require__) {

var shared = __webpack_require__(178)('keys');
var uid = __webpack_require__(129);
module.exports = function (key) {
  return shared[key] || (shared[key] = uid(key));
};


/***/ }),
/* 178 */
/***/ (function(module, exports, __webpack_require__) {

var core = __webpack_require__(43);
var global = __webpack_require__(52);
var SHARED = '__core-js_shared__';
var store = global[SHARED] || (global[SHARED] = {});

(module.exports = function (key, value) {
  return store[key] || (store[key] = value !== undefined ? value : {});
})('versions', []).push({
  version: core.version,
  mode: __webpack_require__(128) ? 'pure' : 'global',
  copyright: '© 2020 Denis Pushkarev (zloirock.ru)'
});


/***/ }),
/* 179 */
/***/ (function(module, exports) {

// IE 8- don't enum bug keys
module.exports = (
  'constructor,hasOwnProperty,isPrototypeOf,propertyIsEnumerable,toLocaleString,toString,valueOf'
).split(',');


/***/ }),
/* 180 */
/***/ (function(module, exports) {

exports.f = Object.getOwnPropertySymbols;


/***/ }),
/* 181 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _iterator = __webpack_require__(568);

var _iterator2 = _interopRequireDefault(_iterator);

var _symbol = __webpack_require__(579);

var _symbol2 = _interopRequireDefault(_symbol);

var _typeof = typeof _symbol2.default === "function" && typeof _iterator2.default === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj; };

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = typeof _symbol2.default === "function" && _typeof(_iterator2.default) === "symbol" ? function (obj) {
  return typeof obj === "undefined" ? "undefined" : _typeof(obj);
} : function (obj) {
  return obj && typeof _symbol2.default === "function" && obj.constructor === _symbol2.default && obj !== _symbol2.default.prototype ? "symbol" : typeof obj === "undefined" ? "undefined" : _typeof(obj);
};

/***/ }),
/* 182 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
var anObject = __webpack_require__(78);
var dPs = __webpack_require__(572);
var enumBugKeys = __webpack_require__(179);
var IE_PROTO = __webpack_require__(177)('IE_PROTO');
var Empty = function () { /* empty */ };
var PROTOTYPE = 'prototype';

// Create object with fake `null` prototype: use iframe Object with cleared prototype
var createDict = function () {
  // Thrash, waste and sodomy: IE GC bug
  var iframe = __webpack_require__(276)('iframe');
  var i = enumBugKeys.length;
  var lt = '<';
  var gt = '>';
  var iframeDocument;
  iframe.style.display = 'none';
  __webpack_require__(573).appendChild(iframe);
  iframe.src = 'javascript:'; // eslint-disable-line no-script-url
  // createDict = iframe.contentWindow.Object;
  // html.removeChild(iframe);
  iframeDocument = iframe.contentWindow.document;
  iframeDocument.open();
  iframeDocument.write(lt + 'script' + gt + 'document.F=Object' + lt + '/script' + gt);
  iframeDocument.close();
  createDict = iframeDocument.F;
  while (i--) delete createDict[PROTOTYPE][enumBugKeys[i]];
  return createDict();
};

module.exports = Object.create || function create(O, Properties) {
  var result;
  if (O !== null) {
    Empty[PROTOTYPE] = anObject(O);
    result = new Empty();
    Empty[PROTOTYPE] = null;
    // add "__proto__" for Object.getPrototypeOf polyfill
    result[IE_PROTO] = O;
  } else result = createDict();
  return Properties === undefined ? result : dPs(result, Properties);
};


/***/ }),
/* 183 */
/***/ (function(module, exports, __webpack_require__) {

var def = __webpack_require__(53).f;
var has = __webpack_require__(62);
var TAG = __webpack_require__(44)('toStringTag');

module.exports = function (it, tag, stat) {
  if (it && !has(it = stat ? it : it.prototype, TAG)) def(it, TAG, { configurable: true, value: tag });
};


/***/ }),
/* 184 */
/***/ (function(module, exports, __webpack_require__) {

exports.f = __webpack_require__(44);


/***/ }),
/* 185 */
/***/ (function(module, exports, __webpack_require__) {

var global = __webpack_require__(52);
var core = __webpack_require__(43);
var LIBRARY = __webpack_require__(128);
var wksExt = __webpack_require__(184);
var defineProperty = __webpack_require__(53).f;
module.exports = function (name) {
  var $Symbol = core.Symbol || (core.Symbol = LIBRARY ? {} : global.Symbol || {});
  if (name.charAt(0) != '_' && !(name in $Symbol)) defineProperty($Symbol, name, { value: wksExt.f(name) });
};


/***/ }),
/* 186 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(1));

var _default = _interopRequireDefault(__webpack_require__(602));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var LocaleReceiver = /*#__PURE__*/function (_React$Component) {
  _inherits(LocaleReceiver, _React$Component);

  var _super = _createSuper(LocaleReceiver);

  function LocaleReceiver() {
    _classCallCheck(this, LocaleReceiver);

    return _super.apply(this, arguments);
  }

  _createClass(LocaleReceiver, [{
    key: "getLocale",
    value: function getLocale() {
      var _this$props = this.props,
          componentName = _this$props.componentName,
          defaultLocale = _this$props.defaultLocale;
      var locale = defaultLocale || _default["default"][componentName || 'global'];
      var antLocale = this.context.antLocale;
      var localeFromContext = componentName && antLocale ? antLocale[componentName] : {};
      return _extends(_extends({}, typeof locale === 'function' ? locale() : locale), localeFromContext || {});
    }
  }, {
    key: "getLocaleCode",
    value: function getLocaleCode() {
      var antLocale = this.context.antLocale;
      var localeCode = antLocale && antLocale.locale; // Had use LocaleProvide but didn't set locale

      if (antLocale && antLocale.exist && !localeCode) {
        return _default["default"].locale;
      }

      return localeCode;
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children(this.getLocale(), this.getLocaleCode(), this.context.antLocale);
    }
  }]);

  return LocaleReceiver;
}(React.Component);

exports["default"] = LocaleReceiver;
LocaleReceiver.defaultProps = {
  componentName: 'global'
};
LocaleReceiver.contextTypes = {
  antLocale: PropTypes.object
};

/***/ }),
/* 187 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var require;//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;(function (global, factory) {
     true ? module.exports = factory() :
    typeof define === 'function' && define.amd ? define(factory) :
    global.moment = factory()
}(this, (function () { 'use strict';

    var hookCallback;

    function hooks() {
        return hookCallback.apply(null, arguments);
    }

    // This is done to register the method called with moment()
    // without creating circular dependencies.
    function setHookCallback(callback) {
        hookCallback = callback;
    }

    function isArray(input) {
        return (
            input instanceof Array ||
            Object.prototype.toString.call(input) === '[object Array]'
        );
    }

    function isObject(input) {
        // IE8 will treat undefined and null as object if it wasn't for
        // input != null
        return (
            input != null &&
            Object.prototype.toString.call(input) === '[object Object]'
        );
    }

    function hasOwnProp(a, b) {
        return Object.prototype.hasOwnProperty.call(a, b);
    }

    function isObjectEmpty(obj) {
        if (Object.getOwnPropertyNames) {
            return Object.getOwnPropertyNames(obj).length === 0;
        } else {
            var k;
            for (k in obj) {
                if (hasOwnProp(obj, k)) {
                    return false;
                }
            }
            return true;
        }
    }

    function isUndefined(input) {
        return input === void 0;
    }

    function isNumber(input) {
        return (
            typeof input === 'number' ||
            Object.prototype.toString.call(input) === '[object Number]'
        );
    }

    function isDate(input) {
        return (
            input instanceof Date ||
            Object.prototype.toString.call(input) === '[object Date]'
        );
    }

    function map(arr, fn) {
        var res = [],
            i,
            arrLen = arr.length;
        for (i = 0; i < arrLen; ++i) {
            res.push(fn(arr[i], i));
        }
        return res;
    }

    function extend(a, b) {
        for (var i in b) {
            if (hasOwnProp(b, i)) {
                a[i] = b[i];
            }
        }

        if (hasOwnProp(b, 'toString')) {
            a.toString = b.toString;
        }

        if (hasOwnProp(b, 'valueOf')) {
            a.valueOf = b.valueOf;
        }

        return a;
    }

    function createUTC(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, true).utc();
    }

    function defaultParsingFlags() {
        // We need to deep clone this object.
        return {
            empty: false,
            unusedTokens: [],
            unusedInput: [],
            overflow: -2,
            charsLeftOver: 0,
            nullInput: false,
            invalidEra: null,
            invalidMonth: null,
            invalidFormat: false,
            userInvalidated: false,
            iso: false,
            parsedDateParts: [],
            era: null,
            meridiem: null,
            rfc2822: false,
            weekdayMismatch: false,
        };
    }

    function getParsingFlags(m) {
        if (m._pf == null) {
            m._pf = defaultParsingFlags();
        }
        return m._pf;
    }

    var some;
    if (Array.prototype.some) {
        some = Array.prototype.some;
    } else {
        some = function (fun) {
            var t = Object(this),
                len = t.length >>> 0,
                i;

            for (i = 0; i < len; i++) {
                if (i in t && fun.call(this, t[i], i, t)) {
                    return true;
                }
            }

            return false;
        };
    }

    function isValid(m) {
        var flags = null,
            parsedParts = false,
            isNowValid = m._d && !isNaN(m._d.getTime());
        if (isNowValid) {
            flags = getParsingFlags(m);
            parsedParts = some.call(flags.parsedDateParts, function (i) {
                return i != null;
            });
            isNowValid =
                flags.overflow < 0 &&
                !flags.empty &&
                !flags.invalidEra &&
                !flags.invalidMonth &&
                !flags.invalidWeekday &&
                !flags.weekdayMismatch &&
                !flags.nullInput &&
                !flags.invalidFormat &&
                !flags.userInvalidated &&
                (!flags.meridiem || (flags.meridiem && parsedParts));
            if (m._strict) {
                isNowValid =
                    isNowValid &&
                    flags.charsLeftOver === 0 &&
                    flags.unusedTokens.length === 0 &&
                    flags.bigHour === undefined;
            }
        }
        if (Object.isFrozen == null || !Object.isFrozen(m)) {
            m._isValid = isNowValid;
        } else {
            return isNowValid;
        }
        return m._isValid;
    }

    function createInvalid(flags) {
        var m = createUTC(NaN);
        if (flags != null) {
            extend(getParsingFlags(m), flags);
        } else {
            getParsingFlags(m).userInvalidated = true;
        }

        return m;
    }

    // Plugins that add properties should also add the key here (null value),
    // so we can properly clone ourselves.
    var momentProperties = (hooks.momentProperties = []),
        updateInProgress = false;

    function copyConfig(to, from) {
        var i,
            prop,
            val,
            momentPropertiesLen = momentProperties.length;

        if (!isUndefined(from._isAMomentObject)) {
            to._isAMomentObject = from._isAMomentObject;
        }
        if (!isUndefined(from._i)) {
            to._i = from._i;
        }
        if (!isUndefined(from._f)) {
            to._f = from._f;
        }
        if (!isUndefined(from._l)) {
            to._l = from._l;
        }
        if (!isUndefined(from._strict)) {
            to._strict = from._strict;
        }
        if (!isUndefined(from._tzm)) {
            to._tzm = from._tzm;
        }
        if (!isUndefined(from._isUTC)) {
            to._isUTC = from._isUTC;
        }
        if (!isUndefined(from._offset)) {
            to._offset = from._offset;
        }
        if (!isUndefined(from._pf)) {
            to._pf = getParsingFlags(from);
        }
        if (!isUndefined(from._locale)) {
            to._locale = from._locale;
        }

        if (momentPropertiesLen > 0) {
            for (i = 0; i < momentPropertiesLen; i++) {
                prop = momentProperties[i];
                val = from[prop];
                if (!isUndefined(val)) {
                    to[prop] = val;
                }
            }
        }

        return to;
    }

    // Moment prototype object
    function Moment(config) {
        copyConfig(this, config);
        this._d = new Date(config._d != null ? config._d.getTime() : NaN);
        if (!this.isValid()) {
            this._d = new Date(NaN);
        }
        // Prevent infinite loop in case updateOffset creates new moment
        // objects.
        if (updateInProgress === false) {
            updateInProgress = true;
            hooks.updateOffset(this);
            updateInProgress = false;
        }
    }

    function isMoment(obj) {
        return (
            obj instanceof Moment || (obj != null && obj._isAMomentObject != null)
        );
    }

    function warn(msg) {
        if (
            hooks.suppressDeprecationWarnings === false &&
            typeof console !== 'undefined' &&
            console.warn
        ) {
            console.warn('Deprecation warning: ' + msg);
        }
    }

    function deprecate(msg, fn) {
        var firstTime = true;

        return extend(function () {
            if (hooks.deprecationHandler != null) {
                hooks.deprecationHandler(null, msg);
            }
            if (firstTime) {
                var args = [],
                    arg,
                    i,
                    key,
                    argLen = arguments.length;
                for (i = 0; i < argLen; i++) {
                    arg = '';
                    if (typeof arguments[i] === 'object') {
                        arg += '\n[' + i + '] ';
                        for (key in arguments[0]) {
                            if (hasOwnProp(arguments[0], key)) {
                                arg += key + ': ' + arguments[0][key] + ', ';
                            }
                        }
                        arg = arg.slice(0, -2); // Remove trailing comma and space
                    } else {
                        arg = arguments[i];
                    }
                    args.push(arg);
                }
                warn(
                    msg +
                        '\nArguments: ' +
                        Array.prototype.slice.call(args).join('') +
                        '\n' +
                        new Error().stack
                );
                firstTime = false;
            }
            return fn.apply(this, arguments);
        }, fn);
    }

    var deprecations = {};

    function deprecateSimple(name, msg) {
        if (hooks.deprecationHandler != null) {
            hooks.deprecationHandler(name, msg);
        }
        if (!deprecations[name]) {
            warn(msg);
            deprecations[name] = true;
        }
    }

    hooks.suppressDeprecationWarnings = false;
    hooks.deprecationHandler = null;

    function isFunction(input) {
        return (
            (typeof Function !== 'undefined' && input instanceof Function) ||
            Object.prototype.toString.call(input) === '[object Function]'
        );
    }

    function set(config) {
        var prop, i;
        for (i in config) {
            if (hasOwnProp(config, i)) {
                prop = config[i];
                if (isFunction(prop)) {
                    this[i] = prop;
                } else {
                    this['_' + i] = prop;
                }
            }
        }
        this._config = config;
        // Lenient ordinal parsing accepts just a number in addition to
        // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
        // TODO: Remove "ordinalParse" fallback in next major release.
        this._dayOfMonthOrdinalParseLenient = new RegExp(
            (this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) +
                '|' +
                /\d{1,2}/.source
        );
    }

    function mergeConfigs(parentConfig, childConfig) {
        var res = extend({}, parentConfig),
            prop;
        for (prop in childConfig) {
            if (hasOwnProp(childConfig, prop)) {
                if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
                    res[prop] = {};
                    extend(res[prop], parentConfig[prop]);
                    extend(res[prop], childConfig[prop]);
                } else if (childConfig[prop] != null) {
                    res[prop] = childConfig[prop];
                } else {
                    delete res[prop];
                }
            }
        }
        for (prop in parentConfig) {
            if (
                hasOwnProp(parentConfig, prop) &&
                !hasOwnProp(childConfig, prop) &&
                isObject(parentConfig[prop])
            ) {
                // make sure changes to properties don't modify parent config
                res[prop] = extend({}, res[prop]);
            }
        }
        return res;
    }

    function Locale(config) {
        if (config != null) {
            this.set(config);
        }
    }

    var keys;

    if (Object.keys) {
        keys = Object.keys;
    } else {
        keys = function (obj) {
            var i,
                res = [];
            for (i in obj) {
                if (hasOwnProp(obj, i)) {
                    res.push(i);
                }
            }
            return res;
        };
    }

    var defaultCalendar = {
        sameDay: '[Today at] LT',
        nextDay: '[Tomorrow at] LT',
        nextWeek: 'dddd [at] LT',
        lastDay: '[Yesterday at] LT',
        lastWeek: '[Last] dddd [at] LT',
        sameElse: 'L',
    };

    function calendar(key, mom, now) {
        var output = this._calendar[key] || this._calendar['sameElse'];
        return isFunction(output) ? output.call(mom, now) : output;
    }

    function zeroFill(number, targetLength, forceSign) {
        var absNumber = '' + Math.abs(number),
            zerosToFill = targetLength - absNumber.length,
            sign = number >= 0;
        return (
            (sign ? (forceSign ? '+' : '') : '-') +
            Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) +
            absNumber
        );
    }

    var formattingTokens =
            /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
        localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
        formatFunctions = {},
        formatTokenFunctions = {};

    // token:    'M'
    // padded:   ['MM', 2]
    // ordinal:  'Mo'
    // callback: function () { this.month() + 1 }
    function addFormatToken(token, padded, ordinal, callback) {
        var func = callback;
        if (typeof callback === 'string') {
            func = function () {
                return this[callback]();
            };
        }
        if (token) {
            formatTokenFunctions[token] = func;
        }
        if (padded) {
            formatTokenFunctions[padded[0]] = function () {
                return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
            };
        }
        if (ordinal) {
            formatTokenFunctions[ordinal] = function () {
                return this.localeData().ordinal(
                    func.apply(this, arguments),
                    token
                );
            };
        }
    }

    function removeFormattingTokens(input) {
        if (input.match(/\[[\s\S]/)) {
            return input.replace(/^\[|\]$/g, '');
        }
        return input.replace(/\\/g, '');
    }

    function makeFormatFunction(format) {
        var array = format.match(formattingTokens),
            i,
            length;

        for (i = 0, length = array.length; i < length; i++) {
            if (formatTokenFunctions[array[i]]) {
                array[i] = formatTokenFunctions[array[i]];
            } else {
                array[i] = removeFormattingTokens(array[i]);
            }
        }

        return function (mom) {
            var output = '',
                i;
            for (i = 0; i < length; i++) {
                output += isFunction(array[i])
                    ? array[i].call(mom, format)
                    : array[i];
            }
            return output;
        };
    }

    // format date using native date object
    function formatMoment(m, format) {
        if (!m.isValid()) {
            return m.localeData().invalidDate();
        }

        format = expandFormat(format, m.localeData());
        formatFunctions[format] =
            formatFunctions[format] || makeFormatFunction(format);

        return formatFunctions[format](m);
    }

    function expandFormat(format, locale) {
        var i = 5;

        function replaceLongDateFormatTokens(input) {
            return locale.longDateFormat(input) || input;
        }

        localFormattingTokens.lastIndex = 0;
        while (i >= 0 && localFormattingTokens.test(format)) {
            format = format.replace(
                localFormattingTokens,
                replaceLongDateFormatTokens
            );
            localFormattingTokens.lastIndex = 0;
            i -= 1;
        }

        return format;
    }

    var defaultLongDateFormat = {
        LTS: 'h:mm:ss A',
        LT: 'h:mm A',
        L: 'MM/DD/YYYY',
        LL: 'MMMM D, YYYY',
        LLL: 'MMMM D, YYYY h:mm A',
        LLLL: 'dddd, MMMM D, YYYY h:mm A',
    };

    function longDateFormat(key) {
        var format = this._longDateFormat[key],
            formatUpper = this._longDateFormat[key.toUpperCase()];

        if (format || !formatUpper) {
            return format;
        }

        this._longDateFormat[key] = formatUpper
            .match(formattingTokens)
            .map(function (tok) {
                if (
                    tok === 'MMMM' ||
                    tok === 'MM' ||
                    tok === 'DD' ||
                    tok === 'dddd'
                ) {
                    return tok.slice(1);
                }
                return tok;
            })
            .join('');

        return this._longDateFormat[key];
    }

    var defaultInvalidDate = 'Invalid date';

    function invalidDate() {
        return this._invalidDate;
    }

    var defaultOrdinal = '%d',
        defaultDayOfMonthOrdinalParse = /\d{1,2}/;

    function ordinal(number) {
        return this._ordinal.replace('%d', number);
    }

    var defaultRelativeTime = {
        future: 'in %s',
        past: '%s ago',
        s: 'a few seconds',
        ss: '%d seconds',
        m: 'a minute',
        mm: '%d minutes',
        h: 'an hour',
        hh: '%d hours',
        d: 'a day',
        dd: '%d days',
        w: 'a week',
        ww: '%d weeks',
        M: 'a month',
        MM: '%d months',
        y: 'a year',
        yy: '%d years',
    };

    function relativeTime(number, withoutSuffix, string, isFuture) {
        var output = this._relativeTime[string];
        return isFunction(output)
            ? output(number, withoutSuffix, string, isFuture)
            : output.replace(/%d/i, number);
    }

    function pastFuture(diff, output) {
        var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
        return isFunction(format) ? format(output) : format.replace(/%s/i, output);
    }

    var aliases = {
        D: 'date',
        dates: 'date',
        date: 'date',
        d: 'day',
        days: 'day',
        day: 'day',
        e: 'weekday',
        weekdays: 'weekday',
        weekday: 'weekday',
        E: 'isoWeekday',
        isoweekdays: 'isoWeekday',
        isoweekday: 'isoWeekday',
        DDD: 'dayOfYear',
        dayofyears: 'dayOfYear',
        dayofyear: 'dayOfYear',
        h: 'hour',
        hours: 'hour',
        hour: 'hour',
        ms: 'millisecond',
        milliseconds: 'millisecond',
        millisecond: 'millisecond',
        m: 'minute',
        minutes: 'minute',
        minute: 'minute',
        M: 'month',
        months: 'month',
        month: 'month',
        Q: 'quarter',
        quarters: 'quarter',
        quarter: 'quarter',
        s: 'second',
        seconds: 'second',
        second: 'second',
        gg: 'weekYear',
        weekyears: 'weekYear',
        weekyear: 'weekYear',
        GG: 'isoWeekYear',
        isoweekyears: 'isoWeekYear',
        isoweekyear: 'isoWeekYear',
        w: 'week',
        weeks: 'week',
        week: 'week',
        W: 'isoWeek',
        isoweeks: 'isoWeek',
        isoweek: 'isoWeek',
        y: 'year',
        years: 'year',
        year: 'year',
    };

    function normalizeUnits(units) {
        return typeof units === 'string'
            ? aliases[units] || aliases[units.toLowerCase()]
            : undefined;
    }

    function normalizeObjectUnits(inputObject) {
        var normalizedInput = {},
            normalizedProp,
            prop;

        for (prop in inputObject) {
            if (hasOwnProp(inputObject, prop)) {
                normalizedProp = normalizeUnits(prop);
                if (normalizedProp) {
                    normalizedInput[normalizedProp] = inputObject[prop];
                }
            }
        }

        return normalizedInput;
    }

    var priorities = {
        date: 9,
        day: 11,
        weekday: 11,
        isoWeekday: 11,
        dayOfYear: 4,
        hour: 13,
        millisecond: 16,
        minute: 14,
        month: 8,
        quarter: 7,
        second: 15,
        weekYear: 1,
        isoWeekYear: 1,
        week: 5,
        isoWeek: 5,
        year: 1,
    };

    function getPrioritizedUnits(unitsObj) {
        var units = [],
            u;
        for (u in unitsObj) {
            if (hasOwnProp(unitsObj, u)) {
                units.push({ unit: u, priority: priorities[u] });
            }
        }
        units.sort(function (a, b) {
            return a.priority - b.priority;
        });
        return units;
    }

    var match1 = /\d/, //       0 - 9
        match2 = /\d\d/, //      00 - 99
        match3 = /\d{3}/, //     000 - 999
        match4 = /\d{4}/, //    0000 - 9999
        match6 = /[+-]?\d{6}/, // -999999 - 999999
        match1to2 = /\d\d?/, //       0 - 99
        match3to4 = /\d\d\d\d?/, //     999 - 9999
        match5to6 = /\d\d\d\d\d\d?/, //   99999 - 999999
        match1to3 = /\d{1,3}/, //       0 - 999
        match1to4 = /\d{1,4}/, //       0 - 9999
        match1to6 = /[+-]?\d{1,6}/, // -999999 - 999999
        matchUnsigned = /\d+/, //       0 - inf
        matchSigned = /[+-]?\d+/, //    -inf - inf
        matchOffset = /Z|[+-]\d\d:?\d\d/gi, // +00:00 -00:00 +0000 -0000 or Z
        matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi, // +00 -00 +00:00 -00:00 +0000 -0000 or Z
        matchTimestamp = /[+-]?\d+(\.\d{1,3})?/, // 123456789 123456789.123
        // any word (or two) characters or numbers including two/three word month in arabic.
        // includes scottish gaelic two word and hyphenated months
        matchWord =
            /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
        match1to2NoLeadingZero = /^[1-9]\d?/, //         1-99
        match1to2HasZero = /^([1-9]\d|\d)/, //           0-99
        regexes;

    regexes = {};

    function addRegexToken(token, regex, strictRegex) {
        regexes[token] = isFunction(regex)
            ? regex
            : function (isStrict, localeData) {
                  return isStrict && strictRegex ? strictRegex : regex;
              };
    }

    function getParseRegexForToken(token, config) {
        if (!hasOwnProp(regexes, token)) {
            return new RegExp(unescapeFormat(token));
        }

        return regexes[token](config._strict, config._locale);
    }

    // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
    function unescapeFormat(s) {
        return regexEscape(
            s
                .replace('\\', '')
                .replace(
                    /\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g,
                    function (matched, p1, p2, p3, p4) {
                        return p1 || p2 || p3 || p4;
                    }
                )
        );
    }

    function regexEscape(s) {
        return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
    }

    function absFloor(number) {
        if (number < 0) {
            // -0 -> 0
            return Math.ceil(number) || 0;
        } else {
            return Math.floor(number);
        }
    }

    function toInt(argumentForCoercion) {
        var coercedNumber = +argumentForCoercion,
            value = 0;

        if (coercedNumber !== 0 && isFinite(coercedNumber)) {
            value = absFloor(coercedNumber);
        }

        return value;
    }

    var tokens = {};

    function addParseToken(token, callback) {
        var i,
            func = callback,
            tokenLen;
        if (typeof token === 'string') {
            token = [token];
        }
        if (isNumber(callback)) {
            func = function (input, array) {
                array[callback] = toInt(input);
            };
        }
        tokenLen = token.length;
        for (i = 0; i < tokenLen; i++) {
            tokens[token[i]] = func;
        }
    }

    function addWeekParseToken(token, callback) {
        addParseToken(token, function (input, array, config, token) {
            config._w = config._w || {};
            callback(input, config._w, config, token);
        });
    }

    function addTimeToArrayFromToken(token, input, config) {
        if (input != null && hasOwnProp(tokens, token)) {
            tokens[token](input, config._a, config, token);
        }
    }

    function isLeapYear(year) {
        return (year % 4 === 0 && year % 100 !== 0) || year % 400 === 0;
    }

    var YEAR = 0,
        MONTH = 1,
        DATE = 2,
        HOUR = 3,
        MINUTE = 4,
        SECOND = 5,
        MILLISECOND = 6,
        WEEK = 7,
        WEEKDAY = 8;

    // FORMATTING

    addFormatToken('Y', 0, 0, function () {
        var y = this.year();
        return y <= 9999 ? zeroFill(y, 4) : '+' + y;
    });

    addFormatToken(0, ['YY', 2], 0, function () {
        return this.year() % 100;
    });

    addFormatToken(0, ['YYYY', 4], 0, 'year');
    addFormatToken(0, ['YYYYY', 5], 0, 'year');
    addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

    // PARSING

    addRegexToken('Y', matchSigned);
    addRegexToken('YY', match1to2, match2);
    addRegexToken('YYYY', match1to4, match4);
    addRegexToken('YYYYY', match1to6, match6);
    addRegexToken('YYYYYY', match1to6, match6);

    addParseToken(['YYYYY', 'YYYYYY'], YEAR);
    addParseToken('YYYY', function (input, array) {
        array[YEAR] =
            input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
    });
    addParseToken('YY', function (input, array) {
        array[YEAR] = hooks.parseTwoDigitYear(input);
    });
    addParseToken('Y', function (input, array) {
        array[YEAR] = parseInt(input, 10);
    });

    // HELPERS

    function daysInYear(year) {
        return isLeapYear(year) ? 366 : 365;
    }

    // HOOKS

    hooks.parseTwoDigitYear = function (input) {
        return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
    };

    // MOMENTS

    var getSetYear = makeGetSet('FullYear', true);

    function getIsLeapYear() {
        return isLeapYear(this.year());
    }

    function makeGetSet(unit, keepTime) {
        return function (value) {
            if (value != null) {
                set$1(this, unit, value);
                hooks.updateOffset(this, keepTime);
                return this;
            } else {
                return get(this, unit);
            }
        };
    }

    function get(mom, unit) {
        if (!mom.isValid()) {
            return NaN;
        }

        var d = mom._d,
            isUTC = mom._isUTC;

        switch (unit) {
            case 'Milliseconds':
                return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
            case 'Seconds':
                return isUTC ? d.getUTCSeconds() : d.getSeconds();
            case 'Minutes':
                return isUTC ? d.getUTCMinutes() : d.getMinutes();
            case 'Hours':
                return isUTC ? d.getUTCHours() : d.getHours();
            case 'Date':
                return isUTC ? d.getUTCDate() : d.getDate();
            case 'Day':
                return isUTC ? d.getUTCDay() : d.getDay();
            case 'Month':
                return isUTC ? d.getUTCMonth() : d.getMonth();
            case 'FullYear':
                return isUTC ? d.getUTCFullYear() : d.getFullYear();
            default:
                return NaN; // Just in case
        }
    }

    function set$1(mom, unit, value) {
        var d, isUTC, year, month, date;

        if (!mom.isValid() || isNaN(value)) {
            return;
        }

        d = mom._d;
        isUTC = mom._isUTC;

        switch (unit) {
            case 'Milliseconds':
                return void (isUTC
                    ? d.setUTCMilliseconds(value)
                    : d.setMilliseconds(value));
            case 'Seconds':
                return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
            case 'Minutes':
                return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
            case 'Hours':
                return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
            case 'Date':
                return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
            // case 'Day': // Not real
            //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
            // case 'Month': // Not used because we need to pass two variables
            //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
            case 'FullYear':
                break; // See below ...
            default:
                return; // Just in case
        }

        year = value;
        month = mom.month();
        date = mom.date();
        date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
        void (isUTC
            ? d.setUTCFullYear(year, month, date)
            : d.setFullYear(year, month, date));
    }

    // MOMENTS

    function stringGet(units) {
        units = normalizeUnits(units);
        if (isFunction(this[units])) {
            return this[units]();
        }
        return this;
    }

    function stringSet(units, value) {
        if (typeof units === 'object') {
            units = normalizeObjectUnits(units);
            var prioritized = getPrioritizedUnits(units),
                i,
                prioritizedLen = prioritized.length;
            for (i = 0; i < prioritizedLen; i++) {
                this[prioritized[i].unit](units[prioritized[i].unit]);
            }
        } else {
            units = normalizeUnits(units);
            if (isFunction(this[units])) {
                return this[units](value);
            }
        }
        return this;
    }

    function mod(n, x) {
        return ((n % x) + x) % x;
    }

    var indexOf;

    if (Array.prototype.indexOf) {
        indexOf = Array.prototype.indexOf;
    } else {
        indexOf = function (o) {
            // I know
            var i;
            for (i = 0; i < this.length; ++i) {
                if (this[i] === o) {
                    return i;
                }
            }
            return -1;
        };
    }

    function daysInMonth(year, month) {
        if (isNaN(year) || isNaN(month)) {
            return NaN;
        }
        var modMonth = mod(month, 12);
        year += (month - modMonth) / 12;
        return modMonth === 1
            ? isLeapYear(year)
                ? 29
                : 28
            : 31 - ((modMonth % 7) % 2);
    }

    // FORMATTING

    addFormatToken('M', ['MM', 2], 'Mo', function () {
        return this.month() + 1;
    });

    addFormatToken('MMM', 0, 0, function (format) {
        return this.localeData().monthsShort(this, format);
    });

    addFormatToken('MMMM', 0, 0, function (format) {
        return this.localeData().months(this, format);
    });

    // PARSING

    addRegexToken('M', match1to2, match1to2NoLeadingZero);
    addRegexToken('MM', match1to2, match2);
    addRegexToken('MMM', function (isStrict, locale) {
        return locale.monthsShortRegex(isStrict);
    });
    addRegexToken('MMMM', function (isStrict, locale) {
        return locale.monthsRegex(isStrict);
    });

    addParseToken(['M', 'MM'], function (input, array) {
        array[MONTH] = toInt(input) - 1;
    });

    addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
        var month = config._locale.monthsParse(input, token, config._strict);
        // if we didn't find a month name, mark the date as invalid.
        if (month != null) {
            array[MONTH] = month;
        } else {
            getParsingFlags(config).invalidMonth = input;
        }
    });

    // LOCALES

    var defaultLocaleMonths =
            'January_February_March_April_May_June_July_August_September_October_November_December'.split(
                '_'
            ),
        defaultLocaleMonthsShort =
            'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
        MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
        defaultMonthsShortRegex = matchWord,
        defaultMonthsRegex = matchWord;

    function localeMonths(m, format) {
        if (!m) {
            return isArray(this._months)
                ? this._months
                : this._months['standalone'];
        }
        return isArray(this._months)
            ? this._months[m.month()]
            : this._months[
                  (this._months.isFormat || MONTHS_IN_FORMAT).test(format)
                      ? 'format'
                      : 'standalone'
              ][m.month()];
    }

    function localeMonthsShort(m, format) {
        if (!m) {
            return isArray(this._monthsShort)
                ? this._monthsShort
                : this._monthsShort['standalone'];
        }
        return isArray(this._monthsShort)
            ? this._monthsShort[m.month()]
            : this._monthsShort[
                  MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'
              ][m.month()];
    }

    function handleStrictParse(monthName, format, strict) {
        var i,
            ii,
            mom,
            llc = monthName.toLocaleLowerCase();
        if (!this._monthsParse) {
            // this is not used
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
            for (i = 0; i < 12; ++i) {
                mom = createUTC([2000, i]);
                this._shortMonthsParse[i] = this.monthsShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'MMM') {
                ii = indexOf.call(this._shortMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._longMonthsParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._longMonthsParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortMonthsParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeMonthsParse(monthName, format, strict) {
        var i, mom, regex;

        if (this._monthsParseExact) {
            return handleStrictParse.call(this, monthName, format, strict);
        }

        if (!this._monthsParse) {
            this._monthsParse = [];
            this._longMonthsParse = [];
            this._shortMonthsParse = [];
        }

        // TODO: add sorting
        // Sorting makes sure if one month (or abbr) is a prefix of another
        // see sorting in computeMonthsParse
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            if (strict && !this._longMonthsParse[i]) {
                this._longMonthsParse[i] = new RegExp(
                    '^' + this.months(mom, '').replace('.', '') + '$',
                    'i'
                );
                this._shortMonthsParse[i] = new RegExp(
                    '^' + this.monthsShort(mom, '').replace('.', '') + '$',
                    'i'
                );
            }
            if (!strict && !this._monthsParse[i]) {
                regex =
                    '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
                this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'MMMM' &&
                this._longMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'MMM' &&
                this._shortMonthsParse[i].test(monthName)
            ) {
                return i;
            } else if (!strict && this._monthsParse[i].test(monthName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function setMonth(mom, value) {
        if (!mom.isValid()) {
            // No op
            return mom;
        }

        if (typeof value === 'string') {
            if (/^\d+$/.test(value)) {
                value = toInt(value);
            } else {
                value = mom.localeData().monthsParse(value);
                // TODO: Another silent failure?
                if (!isNumber(value)) {
                    return mom;
                }
            }
        }

        var month = value,
            date = mom.date();

        date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
        void (mom._isUTC
            ? mom._d.setUTCMonth(month, date)
            : mom._d.setMonth(month, date));
        return mom;
    }

    function getSetMonth(value) {
        if (value != null) {
            setMonth(this, value);
            hooks.updateOffset(this, true);
            return this;
        } else {
            return get(this, 'Month');
        }
    }

    function getDaysInMonth() {
        return daysInMonth(this.year(), this.month());
    }

    function monthsShortRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsShortStrictRegex;
            } else {
                return this._monthsShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsShortRegex')) {
                this._monthsShortRegex = defaultMonthsShortRegex;
            }
            return this._monthsShortStrictRegex && isStrict
                ? this._monthsShortStrictRegex
                : this._monthsShortRegex;
        }
    }

    function monthsRegex(isStrict) {
        if (this._monthsParseExact) {
            if (!hasOwnProp(this, '_monthsRegex')) {
                computeMonthsParse.call(this);
            }
            if (isStrict) {
                return this._monthsStrictRegex;
            } else {
                return this._monthsRegex;
            }
        } else {
            if (!hasOwnProp(this, '_monthsRegex')) {
                this._monthsRegex = defaultMonthsRegex;
            }
            return this._monthsStrictRegex && isStrict
                ? this._monthsStrictRegex
                : this._monthsRegex;
        }
    }

    function computeMonthsParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            shortP,
            longP;
        for (i = 0; i < 12; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, i]);
            shortP = regexEscape(this.monthsShort(mom, ''));
            longP = regexEscape(this.months(mom, ''));
            shortPieces.push(shortP);
            longPieces.push(longP);
            mixedPieces.push(longP);
            mixedPieces.push(shortP);
        }
        // Sorting makes sure if one month (or abbr) is a prefix of another it
        // will match the longer piece.
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._monthsShortRegex = this._monthsRegex;
        this._monthsStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._monthsShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
    }

    function createDate(y, m, d, h, M, s, ms) {
        // can't just apply() to create a date:
        // https://stackoverflow.com/q/181348
        var date;
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            date = new Date(y + 400, m, d, h, M, s, ms);
            if (isFinite(date.getFullYear())) {
                date.setFullYear(y);
            }
        } else {
            date = new Date(y, m, d, h, M, s, ms);
        }

        return date;
    }

    function createUTCDate(y) {
        var date, args;
        // the Date.UTC function remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            args = Array.prototype.slice.call(arguments);
            // preserve leap years using a full 400 year cycle, then reset
            args[0] = y + 400;
            date = new Date(Date.UTC.apply(null, args));
            if (isFinite(date.getUTCFullYear())) {
                date.setUTCFullYear(y);
            }
        } else {
            date = new Date(Date.UTC.apply(null, arguments));
        }

        return date;
    }

    // start-of-first-week - start-of-year
    function firstWeekOffset(year, dow, doy) {
        var // first-week day -- which january is always in the first week (4 for iso, 1 for other)
            fwd = 7 + dow - doy,
            // first-week day local weekday -- which local weekday is fwd
            fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;

        return -fwdlw + fwd - 1;
    }

    // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
    function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
        var localWeekday = (7 + weekday - dow) % 7,
            weekOffset = firstWeekOffset(year, dow, doy),
            dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
            resYear,
            resDayOfYear;

        if (dayOfYear <= 0) {
            resYear = year - 1;
            resDayOfYear = daysInYear(resYear) + dayOfYear;
        } else if (dayOfYear > daysInYear(year)) {
            resYear = year + 1;
            resDayOfYear = dayOfYear - daysInYear(year);
        } else {
            resYear = year;
            resDayOfYear = dayOfYear;
        }

        return {
            year: resYear,
            dayOfYear: resDayOfYear,
        };
    }

    function weekOfYear(mom, dow, doy) {
        var weekOffset = firstWeekOffset(mom.year(), dow, doy),
            week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
            resWeek,
            resYear;

        if (week < 1) {
            resYear = mom.year() - 1;
            resWeek = week + weeksInYear(resYear, dow, doy);
        } else if (week > weeksInYear(mom.year(), dow, doy)) {
            resWeek = week - weeksInYear(mom.year(), dow, doy);
            resYear = mom.year() + 1;
        } else {
            resYear = mom.year();
            resWeek = week;
        }

        return {
            week: resWeek,
            year: resYear,
        };
    }

    function weeksInYear(year, dow, doy) {
        var weekOffset = firstWeekOffset(year, dow, doy),
            weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
        return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
    }

    // FORMATTING

    addFormatToken('w', ['ww', 2], 'wo', 'week');
    addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

    // PARSING

    addRegexToken('w', match1to2, match1to2NoLeadingZero);
    addRegexToken('ww', match1to2, match2);
    addRegexToken('W', match1to2, match1to2NoLeadingZero);
    addRegexToken('WW', match1to2, match2);

    addWeekParseToken(
        ['w', 'ww', 'W', 'WW'],
        function (input, week, config, token) {
            week[token.substr(0, 1)] = toInt(input);
        }
    );

    // HELPERS

    // LOCALES

    function localeWeek(mom) {
        return weekOfYear(mom, this._week.dow, this._week.doy).week;
    }

    var defaultLocaleWeek = {
        dow: 0, // Sunday is the first day of the week.
        doy: 6, // The week that contains Jan 6th is the first week of the year.
    };

    function localeFirstDayOfWeek() {
        return this._week.dow;
    }

    function localeFirstDayOfYear() {
        return this._week.doy;
    }

    // MOMENTS

    function getSetWeek(input) {
        var week = this.localeData().week(this);
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    function getSetISOWeek(input) {
        var week = weekOfYear(this, 1, 4).week;
        return input == null ? week : this.add((input - week) * 7, 'd');
    }

    // FORMATTING

    addFormatToken('d', 0, 'do', 'day');

    addFormatToken('dd', 0, 0, function (format) {
        return this.localeData().weekdaysMin(this, format);
    });

    addFormatToken('ddd', 0, 0, function (format) {
        return this.localeData().weekdaysShort(this, format);
    });

    addFormatToken('dddd', 0, 0, function (format) {
        return this.localeData().weekdays(this, format);
    });

    addFormatToken('e', 0, 0, 'weekday');
    addFormatToken('E', 0, 0, 'isoWeekday');

    // PARSING

    addRegexToken('d', match1to2);
    addRegexToken('e', match1to2);
    addRegexToken('E', match1to2);
    addRegexToken('dd', function (isStrict, locale) {
        return locale.weekdaysMinRegex(isStrict);
    });
    addRegexToken('ddd', function (isStrict, locale) {
        return locale.weekdaysShortRegex(isStrict);
    });
    addRegexToken('dddd', function (isStrict, locale) {
        return locale.weekdaysRegex(isStrict);
    });

    addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
        var weekday = config._locale.weekdaysParse(input, token, config._strict);
        // if we didn't get a weekday name, mark the date as invalid
        if (weekday != null) {
            week.d = weekday;
        } else {
            getParsingFlags(config).invalidWeekday = input;
        }
    });

    addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
        week[token] = toInt(input);
    });

    // HELPERS

    function parseWeekday(input, locale) {
        if (typeof input !== 'string') {
            return input;
        }

        if (!isNaN(input)) {
            return parseInt(input, 10);
        }

        input = locale.weekdaysParse(input);
        if (typeof input === 'number') {
            return input;
        }

        return null;
    }

    function parseIsoWeekday(input, locale) {
        if (typeof input === 'string') {
            return locale.weekdaysParse(input) % 7 || 7;
        }
        return isNaN(input) ? null : input;
    }

    // LOCALES
    function shiftWeekdays(ws, n) {
        return ws.slice(n, 7).concat(ws.slice(0, n));
    }

    var defaultLocaleWeekdays =
            'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
        defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
        defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
        defaultWeekdaysRegex = matchWord,
        defaultWeekdaysShortRegex = matchWord,
        defaultWeekdaysMinRegex = matchWord;

    function localeWeekdays(m, format) {
        var weekdays = isArray(this._weekdays)
            ? this._weekdays
            : this._weekdays[
                  m && m !== true && this._weekdays.isFormat.test(format)
                      ? 'format'
                      : 'standalone'
              ];
        return m === true
            ? shiftWeekdays(weekdays, this._week.dow)
            : m
              ? weekdays[m.day()]
              : weekdays;
    }

    function localeWeekdaysShort(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysShort, this._week.dow)
            : m
              ? this._weekdaysShort[m.day()]
              : this._weekdaysShort;
    }

    function localeWeekdaysMin(m) {
        return m === true
            ? shiftWeekdays(this._weekdaysMin, this._week.dow)
            : m
              ? this._weekdaysMin[m.day()]
              : this._weekdaysMin;
    }

    function handleStrictParse$1(weekdayName, format, strict) {
        var i,
            ii,
            mom,
            llc = weekdayName.toLocaleLowerCase();
        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._minWeekdaysParse = [];

            for (i = 0; i < 7; ++i) {
                mom = createUTC([2000, 1]).day(i);
                this._minWeekdaysParse[i] = this.weekdaysMin(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._shortWeekdaysParse[i] = this.weekdaysShort(
                    mom,
                    ''
                ).toLocaleLowerCase();
                this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
            }
        }

        if (strict) {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        } else {
            if (format === 'dddd') {
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else if (format === 'ddd') {
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._minWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            } else {
                ii = indexOf.call(this._minWeekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._weekdaysParse, llc);
                if (ii !== -1) {
                    return ii;
                }
                ii = indexOf.call(this._shortWeekdaysParse, llc);
                return ii !== -1 ? ii : null;
            }
        }
    }

    function localeWeekdaysParse(weekdayName, format, strict) {
        var i, mom, regex;

        if (this._weekdaysParseExact) {
            return handleStrictParse$1.call(this, weekdayName, format, strict);
        }

        if (!this._weekdaysParse) {
            this._weekdaysParse = [];
            this._minWeekdaysParse = [];
            this._shortWeekdaysParse = [];
            this._fullWeekdaysParse = [];
        }

        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already

            mom = createUTC([2000, 1]).day(i);
            if (strict && !this._fullWeekdaysParse[i]) {
                this._fullWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdays(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._shortWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
                this._minWeekdaysParse[i] = new RegExp(
                    '^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$',
                    'i'
                );
            }
            if (!this._weekdaysParse[i]) {
                regex =
                    '^' +
                    this.weekdays(mom, '') +
                    '|^' +
                    this.weekdaysShort(mom, '') +
                    '|^' +
                    this.weekdaysMin(mom, '');
                this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
            }
            // test the regex
            if (
                strict &&
                format === 'dddd' &&
                this._fullWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'ddd' &&
                this._shortWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (
                strict &&
                format === 'dd' &&
                this._minWeekdaysParse[i].test(weekdayName)
            ) {
                return i;
            } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
                return i;
            }
        }
    }

    // MOMENTS

    function getSetDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        var day = get(this, 'Day');
        if (input != null) {
            input = parseWeekday(input, this.localeData());
            return this.add(input - day, 'd');
        } else {
            return day;
        }
    }

    function getSetLocaleDayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
        return input == null ? weekday : this.add(input - weekday, 'd');
    }

    function getSetISODayOfWeek(input) {
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }

        // behaves the same as moment#day except
        // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
        // as a setter, sunday should belong to the previous week.

        if (input != null) {
            var weekday = parseIsoWeekday(input, this.localeData());
            return this.day(this.day() % 7 ? weekday : weekday - 7);
        } else {
            return this.day() || 7;
        }
    }

    function weekdaysRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysStrictRegex;
            } else {
                return this._weekdaysRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                this._weekdaysRegex = defaultWeekdaysRegex;
            }
            return this._weekdaysStrictRegex && isStrict
                ? this._weekdaysStrictRegex
                : this._weekdaysRegex;
        }
    }

    function weekdaysShortRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysShortStrictRegex;
            } else {
                return this._weekdaysShortRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysShortRegex')) {
                this._weekdaysShortRegex = defaultWeekdaysShortRegex;
            }
            return this._weekdaysShortStrictRegex && isStrict
                ? this._weekdaysShortStrictRegex
                : this._weekdaysShortRegex;
        }
    }

    function weekdaysMinRegex(isStrict) {
        if (this._weekdaysParseExact) {
            if (!hasOwnProp(this, '_weekdaysRegex')) {
                computeWeekdaysParse.call(this);
            }
            if (isStrict) {
                return this._weekdaysMinStrictRegex;
            } else {
                return this._weekdaysMinRegex;
            }
        } else {
            if (!hasOwnProp(this, '_weekdaysMinRegex')) {
                this._weekdaysMinRegex = defaultWeekdaysMinRegex;
            }
            return this._weekdaysMinStrictRegex && isStrict
                ? this._weekdaysMinStrictRegex
                : this._weekdaysMinRegex;
        }
    }

    function computeWeekdaysParse() {
        function cmpLenRev(a, b) {
            return b.length - a.length;
        }

        var minPieces = [],
            shortPieces = [],
            longPieces = [],
            mixedPieces = [],
            i,
            mom,
            minp,
            shortp,
            longp;
        for (i = 0; i < 7; i++) {
            // make the regex if we don't have it already
            mom = createUTC([2000, 1]).day(i);
            minp = regexEscape(this.weekdaysMin(mom, ''));
            shortp = regexEscape(this.weekdaysShort(mom, ''));
            longp = regexEscape(this.weekdays(mom, ''));
            minPieces.push(minp);
            shortPieces.push(shortp);
            longPieces.push(longp);
            mixedPieces.push(minp);
            mixedPieces.push(shortp);
            mixedPieces.push(longp);
        }
        // Sorting makes sure if one weekday (or abbr) is a prefix of another it
        // will match the longer piece.
        minPieces.sort(cmpLenRev);
        shortPieces.sort(cmpLenRev);
        longPieces.sort(cmpLenRev);
        mixedPieces.sort(cmpLenRev);

        this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._weekdaysShortRegex = this._weekdaysRegex;
        this._weekdaysMinRegex = this._weekdaysRegex;

        this._weekdaysStrictRegex = new RegExp(
            '^(' + longPieces.join('|') + ')',
            'i'
        );
        this._weekdaysShortStrictRegex = new RegExp(
            '^(' + shortPieces.join('|') + ')',
            'i'
        );
        this._weekdaysMinStrictRegex = new RegExp(
            '^(' + minPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    function hFormat() {
        return this.hours() % 12 || 12;
    }

    function kFormat() {
        return this.hours() || 24;
    }

    addFormatToken('H', ['HH', 2], 0, 'hour');
    addFormatToken('h', ['hh', 2], 0, hFormat);
    addFormatToken('k', ['kk', 2], 0, kFormat);

    addFormatToken('hmm', 0, 0, function () {
        return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
    });

    addFormatToken('hmmss', 0, 0, function () {
        return (
            '' +
            hFormat.apply(this) +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    addFormatToken('Hmm', 0, 0, function () {
        return '' + this.hours() + zeroFill(this.minutes(), 2);
    });

    addFormatToken('Hmmss', 0, 0, function () {
        return (
            '' +
            this.hours() +
            zeroFill(this.minutes(), 2) +
            zeroFill(this.seconds(), 2)
        );
    });

    function meridiem(token, lowercase) {
        addFormatToken(token, 0, 0, function () {
            return this.localeData().meridiem(
                this.hours(),
                this.minutes(),
                lowercase
            );
        });
    }

    meridiem('a', true);
    meridiem('A', false);

    // PARSING

    function matchMeridiem(isStrict, locale) {
        return locale._meridiemParse;
    }

    addRegexToken('a', matchMeridiem);
    addRegexToken('A', matchMeridiem);
    addRegexToken('H', match1to2, match1to2HasZero);
    addRegexToken('h', match1to2, match1to2NoLeadingZero);
    addRegexToken('k', match1to2, match1to2NoLeadingZero);
    addRegexToken('HH', match1to2, match2);
    addRegexToken('hh', match1to2, match2);
    addRegexToken('kk', match1to2, match2);

    addRegexToken('hmm', match3to4);
    addRegexToken('hmmss', match5to6);
    addRegexToken('Hmm', match3to4);
    addRegexToken('Hmmss', match5to6);

    addParseToken(['H', 'HH'], HOUR);
    addParseToken(['k', 'kk'], function (input, array, config) {
        var kInput = toInt(input);
        array[HOUR] = kInput === 24 ? 0 : kInput;
    });
    addParseToken(['a', 'A'], function (input, array, config) {
        config._isPm = config._locale.isPM(input);
        config._meridiem = input;
    });
    addParseToken(['h', 'hh'], function (input, array, config) {
        array[HOUR] = toInt(input);
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
        getParsingFlags(config).bigHour = true;
    });
    addParseToken('Hmm', function (input, array, config) {
        var pos = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos));
        array[MINUTE] = toInt(input.substr(pos));
    });
    addParseToken('Hmmss', function (input, array, config) {
        var pos1 = input.length - 4,
            pos2 = input.length - 2;
        array[HOUR] = toInt(input.substr(0, pos1));
        array[MINUTE] = toInt(input.substr(pos1, 2));
        array[SECOND] = toInt(input.substr(pos2));
    });

    // LOCALES

    function localeIsPM(input) {
        // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
        // Using charAt should be more compatible.
        return (input + '').toLowerCase().charAt(0) === 'p';
    }

    var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
        // Setting the hour should keep the time, because the user explicitly
        // specified which hour they want. So trying to maintain the same hour (in
        // a new timezone) makes sense. Adding/subtracting hours does not follow
        // this rule.
        getSetHour = makeGetSet('Hours', true);

    function localeMeridiem(hours, minutes, isLower) {
        if (hours > 11) {
            return isLower ? 'pm' : 'PM';
        } else {
            return isLower ? 'am' : 'AM';
        }
    }

    var baseConfig = {
        calendar: defaultCalendar,
        longDateFormat: defaultLongDateFormat,
        invalidDate: defaultInvalidDate,
        ordinal: defaultOrdinal,
        dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
        relativeTime: defaultRelativeTime,

        months: defaultLocaleMonths,
        monthsShort: defaultLocaleMonthsShort,

        week: defaultLocaleWeek,

        weekdays: defaultLocaleWeekdays,
        weekdaysMin: defaultLocaleWeekdaysMin,
        weekdaysShort: defaultLocaleWeekdaysShort,

        meridiemParse: defaultLocaleMeridiemParse,
    };

    // internal storage for locale config files
    var locales = {},
        localeFamilies = {},
        globalLocale;

    function commonPrefix(arr1, arr2) {
        var i,
            minl = Math.min(arr1.length, arr2.length);
        for (i = 0; i < minl; i += 1) {
            if (arr1[i] !== arr2[i]) {
                return i;
            }
        }
        return minl;
    }

    function normalizeLocale(key) {
        return key ? key.toLowerCase().replace('_', '-') : key;
    }

    // pick the locale from the array
    // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
    // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
    function chooseLocale(names) {
        var i = 0,
            j,
            next,
            locale,
            split;

        while (i < names.length) {
            split = normalizeLocale(names[i]).split('-');
            j = split.length;
            next = normalizeLocale(names[i + 1]);
            next = next ? next.split('-') : null;
            while (j > 0) {
                locale = loadLocale(split.slice(0, j).join('-'));
                if (locale) {
                    return locale;
                }
                if (
                    next &&
                    next.length >= j &&
                    commonPrefix(split, next) >= j - 1
                ) {
                    //the next array item is better than a shallower substring of this one
                    break;
                }
                j--;
            }
            i++;
        }
        return globalLocale;
    }

    function isLocaleNameSane(name) {
        // Prevent names that look like filesystem paths, i.e contain '/' or '\'
        // Ensure name is available and function returns boolean
        return !!(name && name.match('^[^/\\\\]*$'));
    }

    function loadLocale(name) {
        var oldLocale = null,
            aliasedRequire;
        // TODO: Find a better way to register and load all the locales in Node
        if (
            locales[name] === undefined &&
            typeof module !== 'undefined' &&
            module &&
            module.exports &&
            isLocaleNameSane(name)
        ) {
            try {
                oldLocale = globalLocale._abbr;
                aliasedRequire = require;
                !(function webpackMissingModule() { var e = new Error("Cannot find module \"./locale\""); e.code = 'MODULE_NOT_FOUND'; throw e; }());
                getSetGlobalLocale(oldLocale);
            } catch (e) {
                // mark as not found to avoid repeating expensive file require call causing high CPU
                // when trying to find en-US, en_US, en-us for every format call
                locales[name] = null; // null means not found
            }
        }
        return locales[name];
    }

    // This function will load locale and then set the global locale.  If
    // no arguments are passed in, it will simply return the current global
    // locale key.
    function getSetGlobalLocale(key, values) {
        var data;
        if (key) {
            if (isUndefined(values)) {
                data = getLocale(key);
            } else {
                data = defineLocale(key, values);
            }

            if (data) {
                // moment.duration._locale = moment._locale = data;
                globalLocale = data;
            } else {
                if (typeof console !== 'undefined' && console.warn) {
                    //warn user if arguments are passed but the locale could not be set
                    console.warn(
                        'Locale ' + key + ' not found. Did you forget to load it?'
                    );
                }
            }
        }

        return globalLocale._abbr;
    }

    function defineLocale(name, config) {
        if (config !== null) {
            var locale,
                parentConfig = baseConfig;
            config.abbr = name;
            if (locales[name] != null) {
                deprecateSimple(
                    'defineLocaleOverride',
                    'use moment.updateLocale(localeName, config) to change ' +
                        'an existing locale. moment.defineLocale(localeName, ' +
                        'config) should only be used for creating a new locale ' +
                        'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.'
                );
                parentConfig = locales[name]._config;
            } else if (config.parentLocale != null) {
                if (locales[config.parentLocale] != null) {
                    parentConfig = locales[config.parentLocale]._config;
                } else {
                    locale = loadLocale(config.parentLocale);
                    if (locale != null) {
                        parentConfig = locale._config;
                    } else {
                        if (!localeFamilies[config.parentLocale]) {
                            localeFamilies[config.parentLocale] = [];
                        }
                        localeFamilies[config.parentLocale].push({
                            name: name,
                            config: config,
                        });
                        return null;
                    }
                }
            }
            locales[name] = new Locale(mergeConfigs(parentConfig, config));

            if (localeFamilies[name]) {
                localeFamilies[name].forEach(function (x) {
                    defineLocale(x.name, x.config);
                });
            }

            // backwards compat for now: also set the locale
            // make sure we set the locale AFTER all child locales have been
            // created, so we won't end up with the child locale set.
            getSetGlobalLocale(name);

            return locales[name];
        } else {
            // useful for testing
            delete locales[name];
            return null;
        }
    }

    function updateLocale(name, config) {
        if (config != null) {
            var locale,
                tmpLocale,
                parentConfig = baseConfig;

            if (locales[name] != null && locales[name].parentLocale != null) {
                // Update existing child locale in-place to avoid memory-leaks
                locales[name].set(mergeConfigs(locales[name]._config, config));
            } else {
                // MERGE
                tmpLocale = loadLocale(name);
                if (tmpLocale != null) {
                    parentConfig = tmpLocale._config;
                }
                config = mergeConfigs(parentConfig, config);
                if (tmpLocale == null) {
                    // updateLocale is called for creating a new locale
                    // Set abbr so it will have a name (getters return
                    // undefined otherwise).
                    config.abbr = name;
                }
                locale = new Locale(config);
                locale.parentLocale = locales[name];
                locales[name] = locale;
            }

            // backwards compat for now: also set the locale
            getSetGlobalLocale(name);
        } else {
            // pass null for config to unupdate, useful for tests
            if (locales[name] != null) {
                if (locales[name].parentLocale != null) {
                    locales[name] = locales[name].parentLocale;
                    if (name === getSetGlobalLocale()) {
                        getSetGlobalLocale(name);
                    }
                } else if (locales[name] != null) {
                    delete locales[name];
                }
            }
        }
        return locales[name];
    }

    // returns locale data
    function getLocale(key) {
        var locale;

        if (key && key._locale && key._locale._abbr) {
            key = key._locale._abbr;
        }

        if (!key) {
            return globalLocale;
        }

        if (!isArray(key)) {
            //short-circuit everything else
            locale = loadLocale(key);
            if (locale) {
                return locale;
            }
            key = [key];
        }

        return chooseLocale(key);
    }

    function listLocales() {
        return keys(locales);
    }

    function checkOverflow(m) {
        var overflow,
            a = m._a;

        if (a && getParsingFlags(m).overflow === -2) {
            overflow =
                a[MONTH] < 0 || a[MONTH] > 11
                    ? MONTH
                    : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH])
                      ? DATE
                      : a[HOUR] < 0 ||
                          a[HOUR] > 24 ||
                          (a[HOUR] === 24 &&
                              (a[MINUTE] !== 0 ||
                                  a[SECOND] !== 0 ||
                                  a[MILLISECOND] !== 0))
                        ? HOUR
                        : a[MINUTE] < 0 || a[MINUTE] > 59
                          ? MINUTE
                          : a[SECOND] < 0 || a[SECOND] > 59
                            ? SECOND
                            : a[MILLISECOND] < 0 || a[MILLISECOND] > 999
                              ? MILLISECOND
                              : -1;

            if (
                getParsingFlags(m)._overflowDayOfYear &&
                (overflow < YEAR || overflow > DATE)
            ) {
                overflow = DATE;
            }
            if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
                overflow = WEEK;
            }
            if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
                overflow = WEEKDAY;
            }

            getParsingFlags(m).overflow = overflow;
        }

        return m;
    }

    // iso 8601 regex
    // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
    var extendedIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        basicIsoRegex =
            /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
        tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
        isoDates = [
            ['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/],
            ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/],
            ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/],
            ['GGGG-[W]WW', /\d{4}-W\d\d/, false],
            ['YYYY-DDD', /\d{4}-\d{3}/],
            ['YYYY-MM', /\d{4}-\d\d/, false],
            ['YYYYYYMMDD', /[+-]\d{10}/],
            ['YYYYMMDD', /\d{8}/],
            ['GGGG[W]WWE', /\d{4}W\d{3}/],
            ['GGGG[W]WW', /\d{4}W\d{2}/, false],
            ['YYYYDDD', /\d{7}/],
            ['YYYYMM', /\d{6}/, false],
            ['YYYY', /\d{4}/, false],
        ],
        // iso time formats and regexes
        isoTimes = [
            ['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/],
            ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/],
            ['HH:mm:ss', /\d\d:\d\d:\d\d/],
            ['HH:mm', /\d\d:\d\d/],
            ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/],
            ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/],
            ['HHmmss', /\d\d\d\d\d\d/],
            ['HHmm', /\d\d\d\d/],
            ['HH', /\d\d/],
        ],
        aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
        // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
        rfc2822 =
            /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
        obsOffsets = {
            UT: 0,
            GMT: 0,
            EDT: -4 * 60,
            EST: -5 * 60,
            CDT: -5 * 60,
            CST: -6 * 60,
            MDT: -6 * 60,
            MST: -7 * 60,
            PDT: -7 * 60,
            PST: -8 * 60,
        };

    // date from iso format
    function configFromISO(config) {
        var i,
            l,
            string = config._i,
            match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
            allowTime,
            dateFormat,
            timeFormat,
            tzFormat,
            isoDatesLen = isoDates.length,
            isoTimesLen = isoTimes.length;

        if (match) {
            getParsingFlags(config).iso = true;
            for (i = 0, l = isoDatesLen; i < l; i++) {
                if (isoDates[i][1].exec(match[1])) {
                    dateFormat = isoDates[i][0];
                    allowTime = isoDates[i][2] !== false;
                    break;
                }
            }
            if (dateFormat == null) {
                config._isValid = false;
                return;
            }
            if (match[3]) {
                for (i = 0, l = isoTimesLen; i < l; i++) {
                    if (isoTimes[i][1].exec(match[3])) {
                        // match[2] should be 'T' or space
                        timeFormat = (match[2] || ' ') + isoTimes[i][0];
                        break;
                    }
                }
                if (timeFormat == null) {
                    config._isValid = false;
                    return;
                }
            }
            if (!allowTime && timeFormat != null) {
                config._isValid = false;
                return;
            }
            if (match[4]) {
                if (tzRegex.exec(match[4])) {
                    tzFormat = 'Z';
                } else {
                    config._isValid = false;
                    return;
                }
            }
            config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
            configFromStringAndFormat(config);
        } else {
            config._isValid = false;
        }
    }

    function extractFromRFC2822Strings(
        yearStr,
        monthStr,
        dayStr,
        hourStr,
        minuteStr,
        secondStr
    ) {
        var result = [
            untruncateYear(yearStr),
            defaultLocaleMonthsShort.indexOf(monthStr),
            parseInt(dayStr, 10),
            parseInt(hourStr, 10),
            parseInt(minuteStr, 10),
        ];

        if (secondStr) {
            result.push(parseInt(secondStr, 10));
        }

        return result;
    }

    function untruncateYear(yearStr) {
        var year = parseInt(yearStr, 10);
        if (year <= 49) {
            return 2000 + year;
        } else if (year <= 999) {
            return 1900 + year;
        }
        return year;
    }

    function preprocessRFC2822(s) {
        // Remove comments and folding whitespace and replace multiple-spaces with a single space
        return s
            .replace(/\([^()]*\)|[\n\t]/g, ' ')
            .replace(/(\s\s+)/g, ' ')
            .replace(/^\s\s*/, '')
            .replace(/\s\s*$/, '');
    }

    function checkWeekday(weekdayStr, parsedInput, config) {
        if (weekdayStr) {
            // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
            var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
                weekdayActual = new Date(
                    parsedInput[0],
                    parsedInput[1],
                    parsedInput[2]
                ).getDay();
            if (weekdayProvided !== weekdayActual) {
                getParsingFlags(config).weekdayMismatch = true;
                config._isValid = false;
                return false;
            }
        }
        return true;
    }

    function calculateOffset(obsOffset, militaryOffset, numOffset) {
        if (obsOffset) {
            return obsOffsets[obsOffset];
        } else if (militaryOffset) {
            // the only allowed military tz is Z
            return 0;
        } else {
            var hm = parseInt(numOffset, 10),
                m = hm % 100,
                h = (hm - m) / 100;
            return h * 60 + m;
        }
    }

    // date and time from ref 2822 format
    function configFromRFC2822(config) {
        var match = rfc2822.exec(preprocessRFC2822(config._i)),
            parsedArray;
        if (match) {
            parsedArray = extractFromRFC2822Strings(
                match[4],
                match[3],
                match[2],
                match[5],
                match[6],
                match[7]
            );
            if (!checkWeekday(match[1], parsedArray, config)) {
                return;
            }

            config._a = parsedArray;
            config._tzm = calculateOffset(match[8], match[9], match[10]);

            config._d = createUTCDate.apply(null, config._a);
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);

            getParsingFlags(config).rfc2822 = true;
        } else {
            config._isValid = false;
        }
    }

    // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
    function configFromString(config) {
        var matched = aspNetJsonRegex.exec(config._i);
        if (matched !== null) {
            config._d = new Date(+matched[1]);
            return;
        }

        configFromISO(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        configFromRFC2822(config);
        if (config._isValid === false) {
            delete config._isValid;
        } else {
            return;
        }

        if (config._strict) {
            config._isValid = false;
        } else {
            // Final attempt, use Input Fallback
            hooks.createFromInputFallback(config);
        }
    }

    hooks.createFromInputFallback = deprecate(
        'value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' +
            'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' +
            'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.',
        function (config) {
            config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
        }
    );

    // Pick the first defined of two or three arguments.
    function defaults(a, b, c) {
        if (a != null) {
            return a;
        }
        if (b != null) {
            return b;
        }
        return c;
    }

    function currentDateArray(config) {
        // hooks is actually the exported moment object
        var nowValue = new Date(hooks.now());
        if (config._useUTC) {
            return [
                nowValue.getUTCFullYear(),
                nowValue.getUTCMonth(),
                nowValue.getUTCDate(),
            ];
        }
        return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
    }

    // convert an array to a date.
    // the array should mirror the parameters below
    // note: all values past the year are optional and will default to the lowest possible value.
    // [year, month, day , hour, minute, second, millisecond]
    function configFromArray(config) {
        var i,
            date,
            input = [],
            currentDate,
            expectedWeekday,
            yearToUse;

        if (config._d) {
            return;
        }

        currentDate = currentDateArray(config);

        //compute day of the year from weeks and weekdays
        if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
            dayOfYearFromWeekInfo(config);
        }

        //if the day of the year is set, figure out what it is
        if (config._dayOfYear != null) {
            yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);

            if (
                config._dayOfYear > daysInYear(yearToUse) ||
                config._dayOfYear === 0
            ) {
                getParsingFlags(config)._overflowDayOfYear = true;
            }

            date = createUTCDate(yearToUse, 0, config._dayOfYear);
            config._a[MONTH] = date.getUTCMonth();
            config._a[DATE] = date.getUTCDate();
        }

        // Default to current date.
        // * if no year, month, day of month are given, default to today
        // * if day of month is given, default month and year
        // * if month is given, default only year
        // * if year is given, don't default anything
        for (i = 0; i < 3 && config._a[i] == null; ++i) {
            config._a[i] = input[i] = currentDate[i];
        }

        // Zero out whatever was not defaulted, including time
        for (; i < 7; i++) {
            config._a[i] = input[i] =
                config._a[i] == null ? (i === 2 ? 1 : 0) : config._a[i];
        }

        // Check for 24:00:00.000
        if (
            config._a[HOUR] === 24 &&
            config._a[MINUTE] === 0 &&
            config._a[SECOND] === 0 &&
            config._a[MILLISECOND] === 0
        ) {
            config._nextDay = true;
            config._a[HOUR] = 0;
        }

        config._d = (config._useUTC ? createUTCDate : createDate).apply(
            null,
            input
        );
        expectedWeekday = config._useUTC
            ? config._d.getUTCDay()
            : config._d.getDay();

        // Apply timezone offset from input. The actual utcOffset can be changed
        // with parseZone.
        if (config._tzm != null) {
            config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
        }

        if (config._nextDay) {
            config._a[HOUR] = 24;
        }

        // check for mismatching day of week
        if (
            config._w &&
            typeof config._w.d !== 'undefined' &&
            config._w.d !== expectedWeekday
        ) {
            getParsingFlags(config).weekdayMismatch = true;
        }
    }

    function dayOfYearFromWeekInfo(config) {
        var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;

        w = config._w;
        if (w.GG != null || w.W != null || w.E != null) {
            dow = 1;
            doy = 4;

            // TODO: We need to take the current isoWeekYear, but that depends on
            // how we interpret now (local, utc, fixed offset). So create
            // a now version of current config (take local/utc/offset flags, and
            // create now).
            weekYear = defaults(
                w.GG,
                config._a[YEAR],
                weekOfYear(createLocal(), 1, 4).year
            );
            week = defaults(w.W, 1);
            weekday = defaults(w.E, 1);
            if (weekday < 1 || weekday > 7) {
                weekdayOverflow = true;
            }
        } else {
            dow = config._locale._week.dow;
            doy = config._locale._week.doy;

            curWeek = weekOfYear(createLocal(), dow, doy);

            weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

            // Default to current week.
            week = defaults(w.w, curWeek.week);

            if (w.d != null) {
                // weekday -- low day numbers are considered next week
                weekday = w.d;
                if (weekday < 0 || weekday > 6) {
                    weekdayOverflow = true;
                }
            } else if (w.e != null) {
                // local weekday -- counting starts from beginning of week
                weekday = w.e + dow;
                if (w.e < 0 || w.e > 6) {
                    weekdayOverflow = true;
                }
            } else {
                // default to beginning of week
                weekday = dow;
            }
        }
        if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
            getParsingFlags(config)._overflowWeeks = true;
        } else if (weekdayOverflow != null) {
            getParsingFlags(config)._overflowWeekday = true;
        } else {
            temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
            config._a[YEAR] = temp.year;
            config._dayOfYear = temp.dayOfYear;
        }
    }

    // constant that refers to the ISO standard
    hooks.ISO_8601 = function () {};

    // constant that refers to the RFC 2822 form
    hooks.RFC_2822 = function () {};

    // date from string and format string
    function configFromStringAndFormat(config) {
        // TODO: Move this to another part of the creation flow to prevent circular deps
        if (config._f === hooks.ISO_8601) {
            configFromISO(config);
            return;
        }
        if (config._f === hooks.RFC_2822) {
            configFromRFC2822(config);
            return;
        }
        config._a = [];
        getParsingFlags(config).empty = true;

        // This array is used to make a Date, either with `new Date` or `Date.UTC`
        var string = '' + config._i,
            i,
            parsedInput,
            tokens,
            token,
            skipped,
            stringLength = string.length,
            totalParsedInputLength = 0,
            era,
            tokenLen;

        tokens =
            expandFormat(config._f, config._locale).match(formattingTokens) || [];
        tokenLen = tokens.length;
        for (i = 0; i < tokenLen; i++) {
            token = tokens[i];
            parsedInput = (string.match(getParseRegexForToken(token, config)) ||
                [])[0];
            if (parsedInput) {
                skipped = string.substr(0, string.indexOf(parsedInput));
                if (skipped.length > 0) {
                    getParsingFlags(config).unusedInput.push(skipped);
                }
                string = string.slice(
                    string.indexOf(parsedInput) + parsedInput.length
                );
                totalParsedInputLength += parsedInput.length;
            }
            // don't parse if it's not a known token
            if (formatTokenFunctions[token]) {
                if (parsedInput) {
                    getParsingFlags(config).empty = false;
                } else {
                    getParsingFlags(config).unusedTokens.push(token);
                }
                addTimeToArrayFromToken(token, parsedInput, config);
            } else if (config._strict && !parsedInput) {
                getParsingFlags(config).unusedTokens.push(token);
            }
        }

        // add remaining unparsed input length to the string
        getParsingFlags(config).charsLeftOver =
            stringLength - totalParsedInputLength;
        if (string.length > 0) {
            getParsingFlags(config).unusedInput.push(string);
        }

        // clear _12h flag if hour is <= 12
        if (
            config._a[HOUR] <= 12 &&
            getParsingFlags(config).bigHour === true &&
            config._a[HOUR] > 0
        ) {
            getParsingFlags(config).bigHour = undefined;
        }

        getParsingFlags(config).parsedDateParts = config._a.slice(0);
        getParsingFlags(config).meridiem = config._meridiem;
        // handle meridiem
        config._a[HOUR] = meridiemFixWrap(
            config._locale,
            config._a[HOUR],
            config._meridiem
        );

        // handle era
        era = getParsingFlags(config).era;
        if (era !== null) {
            config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
        }

        configFromArray(config);
        checkOverflow(config);
    }

    function meridiemFixWrap(locale, hour, meridiem) {
        var isPm;

        if (meridiem == null) {
            // nothing to do
            return hour;
        }
        if (locale.meridiemHour != null) {
            return locale.meridiemHour(hour, meridiem);
        } else if (locale.isPM != null) {
            // Fallback
            isPm = locale.isPM(meridiem);
            if (isPm && hour < 12) {
                hour += 12;
            }
            if (!isPm && hour === 12) {
                hour = 0;
            }
            return hour;
        } else {
            // this is not supposed to happen
            return hour;
        }
    }

    // date from string and array of format strings
    function configFromStringAndArray(config) {
        var tempConfig,
            bestMoment,
            scoreToBeat,
            i,
            currentScore,
            validFormatFound,
            bestFormatIsValid = false,
            configfLen = config._f.length;

        if (configfLen === 0) {
            getParsingFlags(config).invalidFormat = true;
            config._d = new Date(NaN);
            return;
        }

        for (i = 0; i < configfLen; i++) {
            currentScore = 0;
            validFormatFound = false;
            tempConfig = copyConfig({}, config);
            if (config._useUTC != null) {
                tempConfig._useUTC = config._useUTC;
            }
            tempConfig._f = config._f[i];
            configFromStringAndFormat(tempConfig);

            if (isValid(tempConfig)) {
                validFormatFound = true;
            }

            // if there is any input that was not parsed add a penalty for that format
            currentScore += getParsingFlags(tempConfig).charsLeftOver;

            //or tokens
            currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;

            getParsingFlags(tempConfig).score = currentScore;

            if (!bestFormatIsValid) {
                if (
                    scoreToBeat == null ||
                    currentScore < scoreToBeat ||
                    validFormatFound
                ) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                    if (validFormatFound) {
                        bestFormatIsValid = true;
                    }
                }
            } else {
                if (currentScore < scoreToBeat) {
                    scoreToBeat = currentScore;
                    bestMoment = tempConfig;
                }
            }
        }

        extend(config, bestMoment || tempConfig);
    }

    function configFromObject(config) {
        if (config._d) {
            return;
        }

        var i = normalizeObjectUnits(config._i),
            dayOrDate = i.day === undefined ? i.date : i.day;
        config._a = map(
            [i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond],
            function (obj) {
                return obj && parseInt(obj, 10);
            }
        );

        configFromArray(config);
    }

    function createFromConfig(config) {
        var res = new Moment(checkOverflow(prepareConfig(config)));
        if (res._nextDay) {
            // Adding is smart enough around DST
            res.add(1, 'd');
            res._nextDay = undefined;
        }

        return res;
    }

    function prepareConfig(config) {
        var input = config._i,
            format = config._f;

        config._locale = config._locale || getLocale(config._l);

        if (input === null || (format === undefined && input === '')) {
            return createInvalid({ nullInput: true });
        }

        if (typeof input === 'string') {
            config._i = input = config._locale.preparse(input);
        }

        if (isMoment(input)) {
            return new Moment(checkOverflow(input));
        } else if (isDate(input)) {
            config._d = input;
        } else if (isArray(format)) {
            configFromStringAndArray(config);
        } else if (format) {
            configFromStringAndFormat(config);
        } else {
            configFromInput(config);
        }

        if (!isValid(config)) {
            config._d = null;
        }

        return config;
    }

    function configFromInput(config) {
        var input = config._i;
        if (isUndefined(input)) {
            config._d = new Date(hooks.now());
        } else if (isDate(input)) {
            config._d = new Date(input.valueOf());
        } else if (typeof input === 'string') {
            configFromString(config);
        } else if (isArray(input)) {
            config._a = map(input.slice(0), function (obj) {
                return parseInt(obj, 10);
            });
            configFromArray(config);
        } else if (isObject(input)) {
            configFromObject(config);
        } else if (isNumber(input)) {
            // from milliseconds
            config._d = new Date(input);
        } else {
            hooks.createFromInputFallback(config);
        }
    }

    function createLocalOrUTC(input, format, locale, strict, isUTC) {
        var c = {};

        if (format === true || format === false) {
            strict = format;
            format = undefined;
        }

        if (locale === true || locale === false) {
            strict = locale;
            locale = undefined;
        }

        if (
            (isObject(input) && isObjectEmpty(input)) ||
            (isArray(input) && input.length === 0)
        ) {
            input = undefined;
        }
        // object construction must be done this way.
        // https://github.com/moment/moment/issues/1423
        c._isAMomentObject = true;
        c._useUTC = c._isUTC = isUTC;
        c._l = locale;
        c._i = input;
        c._f = format;
        c._strict = strict;

        return createFromConfig(c);
    }

    function createLocal(input, format, locale, strict) {
        return createLocalOrUTC(input, format, locale, strict, false);
    }

    var prototypeMin = deprecate(
            'moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other < this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        ),
        prototypeMax = deprecate(
            'moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/',
            function () {
                var other = createLocal.apply(null, arguments);
                if (this.isValid() && other.isValid()) {
                    return other > this ? this : other;
                } else {
                    return createInvalid();
                }
            }
        );

    // Pick a moment m from moments so that m[fn](other) is true for all
    // other. This relies on the function fn to be transitive.
    //
    // moments should either be an array of moment objects or an array, whose
    // first element is an array of moment objects.
    function pickBy(fn, moments) {
        var res, i;
        if (moments.length === 1 && isArray(moments[0])) {
            moments = moments[0];
        }
        if (!moments.length) {
            return createLocal();
        }
        res = moments[0];
        for (i = 1; i < moments.length; ++i) {
            if (!moments[i].isValid() || moments[i][fn](res)) {
                res = moments[i];
            }
        }
        return res;
    }

    // TODO: Use [].sort instead?
    function min() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isBefore', args);
    }

    function max() {
        var args = [].slice.call(arguments, 0);

        return pickBy('isAfter', args);
    }

    var now = function () {
        return Date.now ? Date.now() : +new Date();
    };

    var ordering = [
        'year',
        'quarter',
        'month',
        'week',
        'day',
        'hour',
        'minute',
        'second',
        'millisecond',
    ];

    function isDurationValid(m) {
        var key,
            unitHasDecimal = false,
            i,
            orderLen = ordering.length;
        for (key in m) {
            if (
                hasOwnProp(m, key) &&
                !(
                    indexOf.call(ordering, key) !== -1 &&
                    (m[key] == null || !isNaN(m[key]))
                )
            ) {
                return false;
            }
        }

        for (i = 0; i < orderLen; ++i) {
            if (m[ordering[i]]) {
                if (unitHasDecimal) {
                    return false; // only allow non-integers for smallest unit
                }
                if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
                    unitHasDecimal = true;
                }
            }
        }

        return true;
    }

    function isValid$1() {
        return this._isValid;
    }

    function createInvalid$1() {
        return createDuration(NaN);
    }

    function Duration(duration) {
        var normalizedInput = normalizeObjectUnits(duration),
            years = normalizedInput.year || 0,
            quarters = normalizedInput.quarter || 0,
            months = normalizedInput.month || 0,
            weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
            days = normalizedInput.day || 0,
            hours = normalizedInput.hour || 0,
            minutes = normalizedInput.minute || 0,
            seconds = normalizedInput.second || 0,
            milliseconds = normalizedInput.millisecond || 0;

        this._isValid = isDurationValid(normalizedInput);

        // representation for dateAddRemove
        this._milliseconds =
            +milliseconds +
            seconds * 1e3 + // 1000
            minutes * 6e4 + // 1000 * 60
            hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
        // Because of dateAddRemove treats 24 hours as different from a
        // day when working around DST, we need to store them separately
        this._days = +days + weeks * 7;
        // It is impossible to translate months into days without knowing
        // which months you are are talking about, so we have to store
        // it separately.
        this._months = +months + quarters * 3 + years * 12;

        this._data = {};

        this._locale = getLocale();

        this._bubble();
    }

    function isDuration(obj) {
        return obj instanceof Duration;
    }

    function absRound(number) {
        if (number < 0) {
            return Math.round(-1 * number) * -1;
        } else {
            return Math.round(number);
        }
    }

    // compare two arrays, return the number of differences
    function compareArrays(array1, array2, dontConvert) {
        var len = Math.min(array1.length, array2.length),
            lengthDiff = Math.abs(array1.length - array2.length),
            diffs = 0,
            i;
        for (i = 0; i < len; i++) {
            if (
                (dontConvert && array1[i] !== array2[i]) ||
                (!dontConvert && toInt(array1[i]) !== toInt(array2[i]))
            ) {
                diffs++;
            }
        }
        return diffs + lengthDiff;
    }

    // FORMATTING

    function offset(token, separator) {
        addFormatToken(token, 0, 0, function () {
            var offset = this.utcOffset(),
                sign = '+';
            if (offset < 0) {
                offset = -offset;
                sign = '-';
            }
            return (
                sign +
                zeroFill(~~(offset / 60), 2) +
                separator +
                zeroFill(~~offset % 60, 2)
            );
        });
    }

    offset('Z', ':');
    offset('ZZ', '');

    // PARSING

    addRegexToken('Z', matchShortOffset);
    addRegexToken('ZZ', matchShortOffset);
    addParseToken(['Z', 'ZZ'], function (input, array, config) {
        config._useUTC = true;
        config._tzm = offsetFromString(matchShortOffset, input);
    });

    // HELPERS

    // timezone chunker
    // '+10:00' > ['10',  '00']
    // '-1530'  > ['-15', '30']
    var chunkOffset = /([\+\-]|\d\d)/gi;

    function offsetFromString(matcher, string) {
        var matches = (string || '').match(matcher),
            chunk,
            parts,
            minutes;

        if (matches === null) {
            return null;
        }

        chunk = matches[matches.length - 1] || [];
        parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
        minutes = +(parts[1] * 60) + toInt(parts[2]);

        return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
    }

    // Return a moment from input, that is local/utc/zone equivalent to model.
    function cloneWithOffset(input, model) {
        var res, diff;
        if (model._isUTC) {
            res = model.clone();
            diff =
                (isMoment(input) || isDate(input)
                    ? input.valueOf()
                    : createLocal(input).valueOf()) - res.valueOf();
            // Use low-level api, because this fn is low-level api.
            res._d.setTime(res._d.valueOf() + diff);
            hooks.updateOffset(res, false);
            return res;
        } else {
            return createLocal(input).local();
        }
    }

    function getDateOffset(m) {
        // On Firefox.24 Date#getTimezoneOffset returns a floating point.
        // https://github.com/moment/moment/pull/1871
        return -Math.round(m._d.getTimezoneOffset());
    }

    // HOOKS

    // This function will be called whenever a moment is mutated.
    // It is intended to keep the offset in sync with the timezone.
    hooks.updateOffset = function () {};

    // MOMENTS

    // keepLocalTime = true means only change the timezone, without
    // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
    // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
    // +0200, so we adjust the time as needed, to be valid.
    //
    // Keeping the time actually adds/subtracts (one hour)
    // from the actual represented time. That is why we call updateOffset
    // a second time. In case it wants us to change the offset again
    // _changeInProgress == true case, then we have to adjust, because
    // there is no such time in the given timezone.
    function getSetOffset(input, keepLocalTime, keepMinutes) {
        var offset = this._offset || 0,
            localAdjust;
        if (!this.isValid()) {
            return input != null ? this : NaN;
        }
        if (input != null) {
            if (typeof input === 'string') {
                input = offsetFromString(matchShortOffset, input);
                if (input === null) {
                    return this;
                }
            } else if (Math.abs(input) < 16 && !keepMinutes) {
                input = input * 60;
            }
            if (!this._isUTC && keepLocalTime) {
                localAdjust = getDateOffset(this);
            }
            this._offset = input;
            this._isUTC = true;
            if (localAdjust != null) {
                this.add(localAdjust, 'm');
            }
            if (offset !== input) {
                if (!keepLocalTime || this._changeInProgress) {
                    addSubtract(
                        this,
                        createDuration(input - offset, 'm'),
                        1,
                        false
                    );
                } else if (!this._changeInProgress) {
                    this._changeInProgress = true;
                    hooks.updateOffset(this, true);
                    this._changeInProgress = null;
                }
            }
            return this;
        } else {
            return this._isUTC ? offset : getDateOffset(this);
        }
    }

    function getSetZone(input, keepLocalTime) {
        if (input != null) {
            if (typeof input !== 'string') {
                input = -input;
            }

            this.utcOffset(input, keepLocalTime);

            return this;
        } else {
            return -this.utcOffset();
        }
    }

    function setOffsetToUTC(keepLocalTime) {
        return this.utcOffset(0, keepLocalTime);
    }

    function setOffsetToLocal(keepLocalTime) {
        if (this._isUTC) {
            this.utcOffset(0, keepLocalTime);
            this._isUTC = false;

            if (keepLocalTime) {
                this.subtract(getDateOffset(this), 'm');
            }
        }
        return this;
    }

    function setOffsetToParsedOffset() {
        if (this._tzm != null) {
            this.utcOffset(this._tzm, false, true);
        } else if (typeof this._i === 'string') {
            var tZone = offsetFromString(matchOffset, this._i);
            if (tZone != null) {
                this.utcOffset(tZone);
            } else {
                this.utcOffset(0, true);
            }
        }
        return this;
    }

    function hasAlignedHourOffset(input) {
        if (!this.isValid()) {
            return false;
        }
        input = input ? createLocal(input).utcOffset() : 0;

        return (this.utcOffset() - input) % 60 === 0;
    }

    function isDaylightSavingTime() {
        return (
            this.utcOffset() > this.clone().month(0).utcOffset() ||
            this.utcOffset() > this.clone().month(5).utcOffset()
        );
    }

    function isDaylightSavingTimeShifted() {
        if (!isUndefined(this._isDSTShifted)) {
            return this._isDSTShifted;
        }

        var c = {},
            other;

        copyConfig(c, this);
        c = prepareConfig(c);

        if (c._a) {
            other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
            this._isDSTShifted =
                this.isValid() && compareArrays(c._a, other.toArray()) > 0;
        } else {
            this._isDSTShifted = false;
        }

        return this._isDSTShifted;
    }

    function isLocal() {
        return this.isValid() ? !this._isUTC : false;
    }

    function isUtcOffset() {
        return this.isValid() ? this._isUTC : false;
    }

    function isUtc() {
        return this.isValid() ? this._isUTC && this._offset === 0 : false;
    }

    // ASP.NET json date format regex
    var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
        // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
        // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
        // and further modified to allow for strings containing both week and day
        isoRegex =
            /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;

    function createDuration(input, key) {
        var duration = input,
            // matching against regexp is expensive, do it on demand
            match = null,
            sign,
            ret,
            diffRes;

        if (isDuration(input)) {
            duration = {
                ms: input._milliseconds,
                d: input._days,
                M: input._months,
            };
        } else if (isNumber(input) || !isNaN(+input)) {
            duration = {};
            if (key) {
                duration[key] = +input;
            } else {
                duration.milliseconds = +input;
            }
        } else if ((match = aspNetRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: 0,
                d: toInt(match[DATE]) * sign,
                h: toInt(match[HOUR]) * sign,
                m: toInt(match[MINUTE]) * sign,
                s: toInt(match[SECOND]) * sign,
                ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign, // the millisecond decimal point is included in the match
            };
        } else if ((match = isoRegex.exec(input))) {
            sign = match[1] === '-' ? -1 : 1;
            duration = {
                y: parseIso(match[2], sign),
                M: parseIso(match[3], sign),
                w: parseIso(match[4], sign),
                d: parseIso(match[5], sign),
                h: parseIso(match[6], sign),
                m: parseIso(match[7], sign),
                s: parseIso(match[8], sign),
            };
        } else if (duration == null) {
            // checks for null or undefined
            duration = {};
        } else if (
            typeof duration === 'object' &&
            ('from' in duration || 'to' in duration)
        ) {
            diffRes = momentsDifference(
                createLocal(duration.from),
                createLocal(duration.to)
            );

            duration = {};
            duration.ms = diffRes.milliseconds;
            duration.M = diffRes.months;
        }

        ret = new Duration(duration);

        if (isDuration(input) && hasOwnProp(input, '_locale')) {
            ret._locale = input._locale;
        }

        if (isDuration(input) && hasOwnProp(input, '_isValid')) {
            ret._isValid = input._isValid;
        }

        return ret;
    }

    createDuration.fn = Duration.prototype;
    createDuration.invalid = createInvalid$1;

    function parseIso(inp, sign) {
        // We'd normally use ~~inp for this, but unfortunately it also
        // converts floats to ints.
        // inp may be undefined, so careful calling replace on it.
        var res = inp && parseFloat(inp.replace(',', '.'));
        // apply sign while we're at it
        return (isNaN(res) ? 0 : res) * sign;
    }

    function positiveMomentsDifference(base, other) {
        var res = {};

        res.months =
            other.month() - base.month() + (other.year() - base.year()) * 12;
        if (base.clone().add(res.months, 'M').isAfter(other)) {
            --res.months;
        }

        res.milliseconds = +other - +base.clone().add(res.months, 'M');

        return res;
    }

    function momentsDifference(base, other) {
        var res;
        if (!(base.isValid() && other.isValid())) {
            return { milliseconds: 0, months: 0 };
        }

        other = cloneWithOffset(other, base);
        if (base.isBefore(other)) {
            res = positiveMomentsDifference(base, other);
        } else {
            res = positiveMomentsDifference(other, base);
            res.milliseconds = -res.milliseconds;
            res.months = -res.months;
        }

        return res;
    }

    // TODO: remove 'name' arg after deprecation is removed
    function createAdder(direction, name) {
        return function (val, period) {
            var dur, tmp;
            //invert the arguments, but complain about it
            if (period !== null && !isNaN(+period)) {
                deprecateSimple(
                    name,
                    'moment().' +
                        name +
                        '(period, number) is deprecated. Please use moment().' +
                        name +
                        '(number, period). ' +
                        'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.'
                );
                tmp = val;
                val = period;
                period = tmp;
            }

            dur = createDuration(val, period);
            addSubtract(this, dur, direction);
            return this;
        };
    }

    function addSubtract(mom, duration, isAdding, updateOffset) {
        var milliseconds = duration._milliseconds,
            days = absRound(duration._days),
            months = absRound(duration._months);

        if (!mom.isValid()) {
            // No op
            return;
        }

        updateOffset = updateOffset == null ? true : updateOffset;

        if (months) {
            setMonth(mom, get(mom, 'Month') + months * isAdding);
        }
        if (days) {
            set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
        }
        if (milliseconds) {
            mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
        }
        if (updateOffset) {
            hooks.updateOffset(mom, days || months);
        }
    }

    var add = createAdder(1, 'add'),
        subtract = createAdder(-1, 'subtract');

    function isString(input) {
        return typeof input === 'string' || input instanceof String;
    }

    // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
    function isMomentInput(input) {
        return (
            isMoment(input) ||
            isDate(input) ||
            isString(input) ||
            isNumber(input) ||
            isNumberOrStringArray(input) ||
            isMomentInputObject(input) ||
            input === null ||
            input === undefined
        );
    }

    function isMomentInputObject(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'years',
                'year',
                'y',
                'months',
                'month',
                'M',
                'days',
                'day',
                'd',
                'dates',
                'date',
                'D',
                'hours',
                'hour',
                'h',
                'minutes',
                'minute',
                'm',
                'seconds',
                'second',
                's',
                'milliseconds',
                'millisecond',
                'ms',
            ],
            i,
            property,
            propertyLen = properties.length;

        for (i = 0; i < propertyLen; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function isNumberOrStringArray(input) {
        var arrayTest = isArray(input),
            dataTypeTest = false;
        if (arrayTest) {
            dataTypeTest =
                input.filter(function (item) {
                    return !isNumber(item) && isString(input);
                }).length === 0;
        }
        return arrayTest && dataTypeTest;
    }

    function isCalendarSpec(input) {
        var objectTest = isObject(input) && !isObjectEmpty(input),
            propertyTest = false,
            properties = [
                'sameDay',
                'nextDay',
                'lastDay',
                'nextWeek',
                'lastWeek',
                'sameElse',
            ],
            i,
            property;

        for (i = 0; i < properties.length; i += 1) {
            property = properties[i];
            propertyTest = propertyTest || hasOwnProp(input, property);
        }

        return objectTest && propertyTest;
    }

    function getCalendarFormat(myMoment, now) {
        var diff = myMoment.diff(now, 'days', true);
        return diff < -6
            ? 'sameElse'
            : diff < -1
              ? 'lastWeek'
              : diff < 0
                ? 'lastDay'
                : diff < 1
                  ? 'sameDay'
                  : diff < 2
                    ? 'nextDay'
                    : diff < 7
                      ? 'nextWeek'
                      : 'sameElse';
    }

    function calendar$1(time, formats) {
        // Support for single parameter, formats only overload to the calendar function
        if (arguments.length === 1) {
            if (!arguments[0]) {
                time = undefined;
                formats = undefined;
            } else if (isMomentInput(arguments[0])) {
                time = arguments[0];
                formats = undefined;
            } else if (isCalendarSpec(arguments[0])) {
                formats = arguments[0];
                time = undefined;
            }
        }
        // We want to compare the start of today, vs this.
        // Getting start-of-today depends on whether we're local/utc/offset or not.
        var now = time || createLocal(),
            sod = cloneWithOffset(now, this).startOf('day'),
            format = hooks.calendarFormat(this, sod) || 'sameElse',
            output =
                formats &&
                (isFunction(formats[format])
                    ? formats[format].call(this, now)
                    : formats[format]);

        return this.format(
            output || this.localeData().calendar(format, this, createLocal(now))
        );
    }

    function clone() {
        return new Moment(this);
    }

    function isAfter(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() > localInput.valueOf();
        } else {
            return localInput.valueOf() < this.clone().startOf(units).valueOf();
        }
    }

    function isBefore(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input);
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() < localInput.valueOf();
        } else {
            return this.clone().endOf(units).valueOf() < localInput.valueOf();
        }
    }

    function isBetween(from, to, units, inclusivity) {
        var localFrom = isMoment(from) ? from : createLocal(from),
            localTo = isMoment(to) ? to : createLocal(to);
        if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
            return false;
        }
        inclusivity = inclusivity || '()';
        return (
            (inclusivity[0] === '('
                ? this.isAfter(localFrom, units)
                : !this.isBefore(localFrom, units)) &&
            (inclusivity[1] === ')'
                ? this.isBefore(localTo, units)
                : !this.isAfter(localTo, units))
        );
    }

    function isSame(input, units) {
        var localInput = isMoment(input) ? input : createLocal(input),
            inputMs;
        if (!(this.isValid() && localInput.isValid())) {
            return false;
        }
        units = normalizeUnits(units) || 'millisecond';
        if (units === 'millisecond') {
            return this.valueOf() === localInput.valueOf();
        } else {
            inputMs = localInput.valueOf();
            return (
                this.clone().startOf(units).valueOf() <= inputMs &&
                inputMs <= this.clone().endOf(units).valueOf()
            );
        }
    }

    function isSameOrAfter(input, units) {
        return this.isSame(input, units) || this.isAfter(input, units);
    }

    function isSameOrBefore(input, units) {
        return this.isSame(input, units) || this.isBefore(input, units);
    }

    function diff(input, units, asFloat) {
        var that, zoneDelta, output;

        if (!this.isValid()) {
            return NaN;
        }

        that = cloneWithOffset(input, this);

        if (!that.isValid()) {
            return NaN;
        }

        zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;

        units = normalizeUnits(units);

        switch (units) {
            case 'year':
                output = monthDiff(this, that) / 12;
                break;
            case 'month':
                output = monthDiff(this, that);
                break;
            case 'quarter':
                output = monthDiff(this, that) / 3;
                break;
            case 'second':
                output = (this - that) / 1e3;
                break; // 1000
            case 'minute':
                output = (this - that) / 6e4;
                break; // 1000 * 60
            case 'hour':
                output = (this - that) / 36e5;
                break; // 1000 * 60 * 60
            case 'day':
                output = (this - that - zoneDelta) / 864e5;
                break; // 1000 * 60 * 60 * 24, negate dst
            case 'week':
                output = (this - that - zoneDelta) / 6048e5;
                break; // 1000 * 60 * 60 * 24 * 7, negate dst
            default:
                output = this - that;
        }

        return asFloat ? output : absFloor(output);
    }

    function monthDiff(a, b) {
        if (a.date() < b.date()) {
            // end-of-month calculations work correct when the start month has more
            // days than the end month.
            return -monthDiff(b, a);
        }
        // difference in months
        var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
            // b is in (anchor - 1 month, anchor + 1 month)
            anchor = a.clone().add(wholeMonthDiff, 'months'),
            anchor2,
            adjust;

        if (b - anchor < 0) {
            anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor - anchor2);
        } else {
            anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
            // linear across the month
            adjust = (b - anchor) / (anchor2 - anchor);
        }

        //check for negative zero, return zero if negative zero
        return -(wholeMonthDiff + adjust) || 0;
    }

    hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
    hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';

    function toString() {
        return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
    }

    function toISOString(keepOffset) {
        if (!this.isValid()) {
            return null;
        }
        var utc = keepOffset !== true,
            m = utc ? this.clone().utc() : this;
        if (m.year() < 0 || m.year() > 9999) {
            return formatMoment(
                m,
                utc
                    ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]'
                    : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ'
            );
        }
        if (isFunction(Date.prototype.toISOString)) {
            // native implementation is ~50x faster, use it when we can
            if (utc) {
                return this.toDate().toISOString();
            } else {
                return new Date(this.valueOf() + this.utcOffset() * 60 * 1000)
                    .toISOString()
                    .replace('Z', formatMoment(m, 'Z'));
            }
        }
        return formatMoment(
            m,
            utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ'
        );
    }

    /**
     * Return a human readable representation of a moment that can
     * also be evaluated to get a new moment which is the same
     *
     * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
     */
    function inspect() {
        if (!this.isValid()) {
            return 'moment.invalid(/* ' + this._i + ' */)';
        }
        var func = 'moment',
            zone = '',
            prefix,
            year,
            datetime,
            suffix;
        if (!this.isLocal()) {
            func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
            zone = 'Z';
        }
        prefix = '[' + func + '("]';
        year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
        datetime = '-MM-DD[T]HH:mm:ss.SSS';
        suffix = zone + '[")]';

        return this.format(prefix + year + datetime + suffix);
    }

    function format(inputString) {
        if (!inputString) {
            inputString = this.isUtc()
                ? hooks.defaultFormatUtc
                : hooks.defaultFormat;
        }
        var output = formatMoment(this, inputString);
        return this.localeData().postformat(output);
    }

    function from(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ to: this, from: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function fromNow(withoutSuffix) {
        return this.from(createLocal(), withoutSuffix);
    }

    function to(time, withoutSuffix) {
        if (
            this.isValid() &&
            ((isMoment(time) && time.isValid()) || createLocal(time).isValid())
        ) {
            return createDuration({ from: this, to: time })
                .locale(this.locale())
                .humanize(!withoutSuffix);
        } else {
            return this.localeData().invalidDate();
        }
    }

    function toNow(withoutSuffix) {
        return this.to(createLocal(), withoutSuffix);
    }

    // If passed a locale key, it will set the locale for this
    // instance.  Otherwise, it will return the locale configuration
    // variables for this instance.
    function locale(key) {
        var newLocaleData;

        if (key === undefined) {
            return this._locale._abbr;
        } else {
            newLocaleData = getLocale(key);
            if (newLocaleData != null) {
                this._locale = newLocaleData;
            }
            return this;
        }
    }

    var lang = deprecate(
        'moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.',
        function (key) {
            if (key === undefined) {
                return this.localeData();
            } else {
                return this.locale(key);
            }
        }
    );

    function localeData() {
        return this._locale;
    }

    var MS_PER_SECOND = 1000,
        MS_PER_MINUTE = 60 * MS_PER_SECOND,
        MS_PER_HOUR = 60 * MS_PER_MINUTE,
        MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

    // actual modulo - handles negative numbers (for dates before 1970):
    function mod$1(dividend, divisor) {
        return ((dividend % divisor) + divisor) % divisor;
    }

    function localStartOfDate(y, m, d) {
        // the date constructor remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return new Date(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return new Date(y, m, d).valueOf();
        }
    }

    function utcStartOfDate(y, m, d) {
        // Date.UTC remaps years 0-99 to 1900-1999
        if (y < 100 && y >= 0) {
            // preserve leap years using a full 400 year cycle, then reset
            return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
        } else {
            return Date.UTC(y, m, d);
        }
    }

    function startOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year(), 0, 1);
                break;
            case 'quarter':
                time = startOfDate(
                    this.year(),
                    this.month() - (this.month() % 3),
                    1
                );
                break;
            case 'month':
                time = startOfDate(this.year(), this.month(), 1);
                break;
            case 'week':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - this.weekday()
                );
                break;
            case 'isoWeek':
                time = startOfDate(
                    this.year(),
                    this.month(),
                    this.date() - (this.isoWeekday() - 1)
                );
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date());
                break;
            case 'hour':
                time = this._d.valueOf();
                time -= mod$1(
                    time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                    MS_PER_HOUR
                );
                break;
            case 'minute':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_MINUTE);
                break;
            case 'second':
                time = this._d.valueOf();
                time -= mod$1(time, MS_PER_SECOND);
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function endOf(units) {
        var time, startOfDate;
        units = normalizeUnits(units);
        if (units === undefined || units === 'millisecond' || !this.isValid()) {
            return this;
        }

        startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;

        switch (units) {
            case 'year':
                time = startOfDate(this.year() + 1, 0, 1) - 1;
                break;
            case 'quarter':
                time =
                    startOfDate(
                        this.year(),
                        this.month() - (this.month() % 3) + 3,
                        1
                    ) - 1;
                break;
            case 'month':
                time = startOfDate(this.year(), this.month() + 1, 1) - 1;
                break;
            case 'week':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - this.weekday() + 7
                    ) - 1;
                break;
            case 'isoWeek':
                time =
                    startOfDate(
                        this.year(),
                        this.month(),
                        this.date() - (this.isoWeekday() - 1) + 7
                    ) - 1;
                break;
            case 'day':
            case 'date':
                time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
                break;
            case 'hour':
                time = this._d.valueOf();
                time +=
                    MS_PER_HOUR -
                    mod$1(
                        time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE),
                        MS_PER_HOUR
                    ) -
                    1;
                break;
            case 'minute':
                time = this._d.valueOf();
                time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
                break;
            case 'second':
                time = this._d.valueOf();
                time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
                break;
        }

        this._d.setTime(time);
        hooks.updateOffset(this, true);
        return this;
    }

    function valueOf() {
        return this._d.valueOf() - (this._offset || 0) * 60000;
    }

    function unix() {
        return Math.floor(this.valueOf() / 1000);
    }

    function toDate() {
        return new Date(this.valueOf());
    }

    function toArray() {
        var m = this;
        return [
            m.year(),
            m.month(),
            m.date(),
            m.hour(),
            m.minute(),
            m.second(),
            m.millisecond(),
        ];
    }

    function toObject() {
        var m = this;
        return {
            years: m.year(),
            months: m.month(),
            date: m.date(),
            hours: m.hours(),
            minutes: m.minutes(),
            seconds: m.seconds(),
            milliseconds: m.milliseconds(),
        };
    }

    function toJSON() {
        // new Date(NaN).toJSON() === null
        return this.isValid() ? this.toISOString() : null;
    }

    function isValid$2() {
        return isValid(this);
    }

    function parsingFlags() {
        return extend({}, getParsingFlags(this));
    }

    function invalidAt() {
        return getParsingFlags(this).overflow;
    }

    function creationData() {
        return {
            input: this._i,
            format: this._f,
            locale: this._locale,
            isUTC: this._isUTC,
            strict: this._strict,
        };
    }

    addFormatToken('N', 0, 0, 'eraAbbr');
    addFormatToken('NN', 0, 0, 'eraAbbr');
    addFormatToken('NNN', 0, 0, 'eraAbbr');
    addFormatToken('NNNN', 0, 0, 'eraName');
    addFormatToken('NNNNN', 0, 0, 'eraNarrow');

    addFormatToken('y', ['y', 1], 'yo', 'eraYear');
    addFormatToken('y', ['yy', 2], 0, 'eraYear');
    addFormatToken('y', ['yyy', 3], 0, 'eraYear');
    addFormatToken('y', ['yyyy', 4], 0, 'eraYear');

    addRegexToken('N', matchEraAbbr);
    addRegexToken('NN', matchEraAbbr);
    addRegexToken('NNN', matchEraAbbr);
    addRegexToken('NNNN', matchEraName);
    addRegexToken('NNNNN', matchEraNarrow);

    addParseToken(
        ['N', 'NN', 'NNN', 'NNNN', 'NNNNN'],
        function (input, array, config, token) {
            var era = config._locale.erasParse(input, token, config._strict);
            if (era) {
                getParsingFlags(config).era = era;
            } else {
                getParsingFlags(config).invalidEra = input;
            }
        }
    );

    addRegexToken('y', matchUnsigned);
    addRegexToken('yy', matchUnsigned);
    addRegexToken('yyy', matchUnsigned);
    addRegexToken('yyyy', matchUnsigned);
    addRegexToken('yo', matchEraYearOrdinal);

    addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
    addParseToken(['yo'], function (input, array, config, token) {
        var match;
        if (config._locale._eraYearOrdinalRegex) {
            match = input.match(config._locale._eraYearOrdinalRegex);
        }

        if (config._locale.eraYearOrdinalParse) {
            array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
        } else {
            array[YEAR] = parseInt(input, 10);
        }
    });

    function localeEras(m, format) {
        var i,
            l,
            date,
            eras = this._eras || getLocale('en')._eras;
        for (i = 0, l = eras.length; i < l; ++i) {
            switch (typeof eras[i].since) {
                case 'string':
                    // truncate time
                    date = hooks(eras[i].since).startOf('day');
                    eras[i].since = date.valueOf();
                    break;
            }

            switch (typeof eras[i].until) {
                case 'undefined':
                    eras[i].until = +Infinity;
                    break;
                case 'string':
                    // truncate time
                    date = hooks(eras[i].until).startOf('day').valueOf();
                    eras[i].until = date.valueOf();
                    break;
            }
        }
        return eras;
    }

    function localeErasParse(eraName, format, strict) {
        var i,
            l,
            eras = this.eras(),
            name,
            abbr,
            narrow;
        eraName = eraName.toUpperCase();

        for (i = 0, l = eras.length; i < l; ++i) {
            name = eras[i].name.toUpperCase();
            abbr = eras[i].abbr.toUpperCase();
            narrow = eras[i].narrow.toUpperCase();

            if (strict) {
                switch (format) {
                    case 'N':
                    case 'NN':
                    case 'NNN':
                        if (abbr === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNN':
                        if (name === eraName) {
                            return eras[i];
                        }
                        break;

                    case 'NNNNN':
                        if (narrow === eraName) {
                            return eras[i];
                        }
                        break;
                }
            } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
                return eras[i];
            }
        }
    }

    function localeErasConvertYear(era, year) {
        var dir = era.since <= era.until ? +1 : -1;
        if (year === undefined) {
            return hooks(era.since).year();
        } else {
            return hooks(era.since).year() + (year - era.offset) * dir;
        }
    }

    function getEraName() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].name;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].name;
            }
        }

        return '';
    }

    function getEraNarrow() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].narrow;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].narrow;
            }
        }

        return '';
    }

    function getEraAbbr() {
        var i,
            l,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (eras[i].since <= val && val <= eras[i].until) {
                return eras[i].abbr;
            }
            if (eras[i].until <= val && val <= eras[i].since) {
                return eras[i].abbr;
            }
        }

        return '';
    }

    function getEraYear() {
        var i,
            l,
            dir,
            val,
            eras = this.localeData().eras();
        for (i = 0, l = eras.length; i < l; ++i) {
            dir = eras[i].since <= eras[i].until ? +1 : -1;

            // truncate time
            val = this.clone().startOf('day').valueOf();

            if (
                (eras[i].since <= val && val <= eras[i].until) ||
                (eras[i].until <= val && val <= eras[i].since)
            ) {
                return (
                    (this.year() - hooks(eras[i].since).year()) * dir +
                    eras[i].offset
                );
            }
        }

        return this.year();
    }

    function erasNameRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNameRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNameRegex : this._erasRegex;
    }

    function erasAbbrRegex(isStrict) {
        if (!hasOwnProp(this, '_erasAbbrRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasAbbrRegex : this._erasRegex;
    }

    function erasNarrowRegex(isStrict) {
        if (!hasOwnProp(this, '_erasNarrowRegex')) {
            computeErasParse.call(this);
        }
        return isStrict ? this._erasNarrowRegex : this._erasRegex;
    }

    function matchEraAbbr(isStrict, locale) {
        return locale.erasAbbrRegex(isStrict);
    }

    function matchEraName(isStrict, locale) {
        return locale.erasNameRegex(isStrict);
    }

    function matchEraNarrow(isStrict, locale) {
        return locale.erasNarrowRegex(isStrict);
    }

    function matchEraYearOrdinal(isStrict, locale) {
        return locale._eraYearOrdinalRegex || matchUnsigned;
    }

    function computeErasParse() {
        var abbrPieces = [],
            namePieces = [],
            narrowPieces = [],
            mixedPieces = [],
            i,
            l,
            erasName,
            erasAbbr,
            erasNarrow,
            eras = this.eras();

        for (i = 0, l = eras.length; i < l; ++i) {
            erasName = regexEscape(eras[i].name);
            erasAbbr = regexEscape(eras[i].abbr);
            erasNarrow = regexEscape(eras[i].narrow);

            namePieces.push(erasName);
            abbrPieces.push(erasAbbr);
            narrowPieces.push(erasNarrow);
            mixedPieces.push(erasName);
            mixedPieces.push(erasAbbr);
            mixedPieces.push(erasNarrow);
        }

        this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
        this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
        this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
        this._erasNarrowRegex = new RegExp(
            '^(' + narrowPieces.join('|') + ')',
            'i'
        );
    }

    // FORMATTING

    addFormatToken(0, ['gg', 2], 0, function () {
        return this.weekYear() % 100;
    });

    addFormatToken(0, ['GG', 2], 0, function () {
        return this.isoWeekYear() % 100;
    });

    function addWeekYearFormatToken(token, getter) {
        addFormatToken(0, [token, token.length], 0, getter);
    }

    addWeekYearFormatToken('gggg', 'weekYear');
    addWeekYearFormatToken('ggggg', 'weekYear');
    addWeekYearFormatToken('GGGG', 'isoWeekYear');
    addWeekYearFormatToken('GGGGG', 'isoWeekYear');

    // ALIASES

    // PARSING

    addRegexToken('G', matchSigned);
    addRegexToken('g', matchSigned);
    addRegexToken('GG', match1to2, match2);
    addRegexToken('gg', match1to2, match2);
    addRegexToken('GGGG', match1to4, match4);
    addRegexToken('gggg', match1to4, match4);
    addRegexToken('GGGGG', match1to6, match6);
    addRegexToken('ggggg', match1to6, match6);

    addWeekParseToken(
        ['gggg', 'ggggg', 'GGGG', 'GGGGG'],
        function (input, week, config, token) {
            week[token.substr(0, 2)] = toInt(input);
        }
    );

    addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
        week[token] = hooks.parseTwoDigitYear(input);
    });

    // MOMENTS

    function getSetWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.week(),
            this.weekday() + this.localeData()._week.dow,
            this.localeData()._week.dow,
            this.localeData()._week.doy
        );
    }

    function getSetISOWeekYear(input) {
        return getSetWeekYearHelper.call(
            this,
            input,
            this.isoWeek(),
            this.isoWeekday(),
            1,
            4
        );
    }

    function getISOWeeksInYear() {
        return weeksInYear(this.year(), 1, 4);
    }

    function getISOWeeksInISOWeekYear() {
        return weeksInYear(this.isoWeekYear(), 1, 4);
    }

    function getWeeksInYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
    }

    function getWeeksInWeekYear() {
        var weekInfo = this.localeData()._week;
        return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
    }

    function getSetWeekYearHelper(input, week, weekday, dow, doy) {
        var weeksTarget;
        if (input == null) {
            return weekOfYear(this, dow, doy).year;
        } else {
            weeksTarget = weeksInYear(input, dow, doy);
            if (week > weeksTarget) {
                week = weeksTarget;
            }
            return setWeekAll.call(this, input, week, weekday, dow, doy);
        }
    }

    function setWeekAll(weekYear, week, weekday, dow, doy) {
        var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
            date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);

        this.year(date.getUTCFullYear());
        this.month(date.getUTCMonth());
        this.date(date.getUTCDate());
        return this;
    }

    // FORMATTING

    addFormatToken('Q', 0, 'Qo', 'quarter');

    // PARSING

    addRegexToken('Q', match1);
    addParseToken('Q', function (input, array) {
        array[MONTH] = (toInt(input) - 1) * 3;
    });

    // MOMENTS

    function getSetQuarter(input) {
        return input == null
            ? Math.ceil((this.month() + 1) / 3)
            : this.month((input - 1) * 3 + (this.month() % 3));
    }

    // FORMATTING

    addFormatToken('D', ['DD', 2], 'Do', 'date');

    // PARSING

    addRegexToken('D', match1to2, match1to2NoLeadingZero);
    addRegexToken('DD', match1to2, match2);
    addRegexToken('Do', function (isStrict, locale) {
        // TODO: Remove "ordinalParse" fallback in next major release.
        return isStrict
            ? locale._dayOfMonthOrdinalParse || locale._ordinalParse
            : locale._dayOfMonthOrdinalParseLenient;
    });

    addParseToken(['D', 'DD'], DATE);
    addParseToken('Do', function (input, array) {
        array[DATE] = toInt(input.match(match1to2)[0]);
    });

    // MOMENTS

    var getSetDayOfMonth = makeGetSet('Date', true);

    // FORMATTING

    addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

    // PARSING

    addRegexToken('DDD', match1to3);
    addRegexToken('DDDD', match3);
    addParseToken(['DDD', 'DDDD'], function (input, array, config) {
        config._dayOfYear = toInt(input);
    });

    // HELPERS

    // MOMENTS

    function getSetDayOfYear(input) {
        var dayOfYear =
            Math.round(
                (this.clone().startOf('day') - this.clone().startOf('year')) / 864e5
            ) + 1;
        return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
    }

    // FORMATTING

    addFormatToken('m', ['mm', 2], 0, 'minute');

    // PARSING

    addRegexToken('m', match1to2, match1to2HasZero);
    addRegexToken('mm', match1to2, match2);
    addParseToken(['m', 'mm'], MINUTE);

    // MOMENTS

    var getSetMinute = makeGetSet('Minutes', false);

    // FORMATTING

    addFormatToken('s', ['ss', 2], 0, 'second');

    // PARSING

    addRegexToken('s', match1to2, match1to2HasZero);
    addRegexToken('ss', match1to2, match2);
    addParseToken(['s', 'ss'], SECOND);

    // MOMENTS

    var getSetSecond = makeGetSet('Seconds', false);

    // FORMATTING

    addFormatToken('S', 0, 0, function () {
        return ~~(this.millisecond() / 100);
    });

    addFormatToken(0, ['SS', 2], 0, function () {
        return ~~(this.millisecond() / 10);
    });

    addFormatToken(0, ['SSS', 3], 0, 'millisecond');
    addFormatToken(0, ['SSSS', 4], 0, function () {
        return this.millisecond() * 10;
    });
    addFormatToken(0, ['SSSSS', 5], 0, function () {
        return this.millisecond() * 100;
    });
    addFormatToken(0, ['SSSSSS', 6], 0, function () {
        return this.millisecond() * 1000;
    });
    addFormatToken(0, ['SSSSSSS', 7], 0, function () {
        return this.millisecond() * 10000;
    });
    addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
        return this.millisecond() * 100000;
    });
    addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
        return this.millisecond() * 1000000;
    });

    // PARSING

    addRegexToken('S', match1to3, match1);
    addRegexToken('SS', match1to3, match2);
    addRegexToken('SSS', match1to3, match3);

    var token, getSetMillisecond;
    for (token = 'SSSS'; token.length <= 9; token += 'S') {
        addRegexToken(token, matchUnsigned);
    }

    function parseMs(input, array) {
        array[MILLISECOND] = toInt(('0.' + input) * 1000);
    }

    for (token = 'S'; token.length <= 9; token += 'S') {
        addParseToken(token, parseMs);
    }

    getSetMillisecond = makeGetSet('Milliseconds', false);

    // FORMATTING

    addFormatToken('z', 0, 0, 'zoneAbbr');
    addFormatToken('zz', 0, 0, 'zoneName');

    // MOMENTS

    function getZoneAbbr() {
        return this._isUTC ? 'UTC' : '';
    }

    function getZoneName() {
        return this._isUTC ? 'Coordinated Universal Time' : '';
    }

    var proto = Moment.prototype;

    proto.add = add;
    proto.calendar = calendar$1;
    proto.clone = clone;
    proto.diff = diff;
    proto.endOf = endOf;
    proto.format = format;
    proto.from = from;
    proto.fromNow = fromNow;
    proto.to = to;
    proto.toNow = toNow;
    proto.get = stringGet;
    proto.invalidAt = invalidAt;
    proto.isAfter = isAfter;
    proto.isBefore = isBefore;
    proto.isBetween = isBetween;
    proto.isSame = isSame;
    proto.isSameOrAfter = isSameOrAfter;
    proto.isSameOrBefore = isSameOrBefore;
    proto.isValid = isValid$2;
    proto.lang = lang;
    proto.locale = locale;
    proto.localeData = localeData;
    proto.max = prototypeMax;
    proto.min = prototypeMin;
    proto.parsingFlags = parsingFlags;
    proto.set = stringSet;
    proto.startOf = startOf;
    proto.subtract = subtract;
    proto.toArray = toArray;
    proto.toObject = toObject;
    proto.toDate = toDate;
    proto.toISOString = toISOString;
    proto.inspect = inspect;
    if (typeof Symbol !== 'undefined' && Symbol.for != null) {
        proto[Symbol.for('nodejs.util.inspect.custom')] = function () {
            return 'Moment<' + this.format() + '>';
        };
    }
    proto.toJSON = toJSON;
    proto.toString = toString;
    proto.unix = unix;
    proto.valueOf = valueOf;
    proto.creationData = creationData;
    proto.eraName = getEraName;
    proto.eraNarrow = getEraNarrow;
    proto.eraAbbr = getEraAbbr;
    proto.eraYear = getEraYear;
    proto.year = getSetYear;
    proto.isLeapYear = getIsLeapYear;
    proto.weekYear = getSetWeekYear;
    proto.isoWeekYear = getSetISOWeekYear;
    proto.quarter = proto.quarters = getSetQuarter;
    proto.month = getSetMonth;
    proto.daysInMonth = getDaysInMonth;
    proto.week = proto.weeks = getSetWeek;
    proto.isoWeek = proto.isoWeeks = getSetISOWeek;
    proto.weeksInYear = getWeeksInYear;
    proto.weeksInWeekYear = getWeeksInWeekYear;
    proto.isoWeeksInYear = getISOWeeksInYear;
    proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
    proto.date = getSetDayOfMonth;
    proto.day = proto.days = getSetDayOfWeek;
    proto.weekday = getSetLocaleDayOfWeek;
    proto.isoWeekday = getSetISODayOfWeek;
    proto.dayOfYear = getSetDayOfYear;
    proto.hour = proto.hours = getSetHour;
    proto.minute = proto.minutes = getSetMinute;
    proto.second = proto.seconds = getSetSecond;
    proto.millisecond = proto.milliseconds = getSetMillisecond;
    proto.utcOffset = getSetOffset;
    proto.utc = setOffsetToUTC;
    proto.local = setOffsetToLocal;
    proto.parseZone = setOffsetToParsedOffset;
    proto.hasAlignedHourOffset = hasAlignedHourOffset;
    proto.isDST = isDaylightSavingTime;
    proto.isLocal = isLocal;
    proto.isUtcOffset = isUtcOffset;
    proto.isUtc = isUtc;
    proto.isUTC = isUtc;
    proto.zoneAbbr = getZoneAbbr;
    proto.zoneName = getZoneName;
    proto.dates = deprecate(
        'dates accessor is deprecated. Use date instead.',
        getSetDayOfMonth
    );
    proto.months = deprecate(
        'months accessor is deprecated. Use month instead',
        getSetMonth
    );
    proto.years = deprecate(
        'years accessor is deprecated. Use year instead',
        getSetYear
    );
    proto.zone = deprecate(
        'moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/',
        getSetZone
    );
    proto.isDSTShifted = deprecate(
        'isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information',
        isDaylightSavingTimeShifted
    );

    function createUnix(input) {
        return createLocal(input * 1000);
    }

    function createInZone() {
        return createLocal.apply(null, arguments).parseZone();
    }

    function preParsePostFormat(string) {
        return string;
    }

    var proto$1 = Locale.prototype;

    proto$1.calendar = calendar;
    proto$1.longDateFormat = longDateFormat;
    proto$1.invalidDate = invalidDate;
    proto$1.ordinal = ordinal;
    proto$1.preparse = preParsePostFormat;
    proto$1.postformat = preParsePostFormat;
    proto$1.relativeTime = relativeTime;
    proto$1.pastFuture = pastFuture;
    proto$1.set = set;
    proto$1.eras = localeEras;
    proto$1.erasParse = localeErasParse;
    proto$1.erasConvertYear = localeErasConvertYear;
    proto$1.erasAbbrRegex = erasAbbrRegex;
    proto$1.erasNameRegex = erasNameRegex;
    proto$1.erasNarrowRegex = erasNarrowRegex;

    proto$1.months = localeMonths;
    proto$1.monthsShort = localeMonthsShort;
    proto$1.monthsParse = localeMonthsParse;
    proto$1.monthsRegex = monthsRegex;
    proto$1.monthsShortRegex = monthsShortRegex;
    proto$1.week = localeWeek;
    proto$1.firstDayOfYear = localeFirstDayOfYear;
    proto$1.firstDayOfWeek = localeFirstDayOfWeek;

    proto$1.weekdays = localeWeekdays;
    proto$1.weekdaysMin = localeWeekdaysMin;
    proto$1.weekdaysShort = localeWeekdaysShort;
    proto$1.weekdaysParse = localeWeekdaysParse;

    proto$1.weekdaysRegex = weekdaysRegex;
    proto$1.weekdaysShortRegex = weekdaysShortRegex;
    proto$1.weekdaysMinRegex = weekdaysMinRegex;

    proto$1.isPM = localeIsPM;
    proto$1.meridiem = localeMeridiem;

    function get$1(format, index, field, setter) {
        var locale = getLocale(),
            utc = createUTC().set(setter, index);
        return locale[field](utc, format);
    }

    function listMonthsImpl(format, index, field) {
        if (isNumber(format)) {
            index = format;
            format = undefined;
        }

        format = format || '';

        if (index != null) {
            return get$1(format, index, field, 'month');
        }

        var i,
            out = [];
        for (i = 0; i < 12; i++) {
            out[i] = get$1(format, i, field, 'month');
        }
        return out;
    }

    // ()
    // (5)
    // (fmt, 5)
    // (fmt)
    // (true)
    // (true, 5)
    // (true, fmt, 5)
    // (true, fmt)
    function listWeekdaysImpl(localeSorted, format, index, field) {
        if (typeof localeSorted === 'boolean') {
            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        } else {
            format = localeSorted;
            index = format;
            localeSorted = false;

            if (isNumber(format)) {
                index = format;
                format = undefined;
            }

            format = format || '';
        }

        var locale = getLocale(),
            shift = localeSorted ? locale._week.dow : 0,
            i,
            out = [];

        if (index != null) {
            return get$1(format, (index + shift) % 7, field, 'day');
        }

        for (i = 0; i < 7; i++) {
            out[i] = get$1(format, (i + shift) % 7, field, 'day');
        }
        return out;
    }

    function listMonths(format, index) {
        return listMonthsImpl(format, index, 'months');
    }

    function listMonthsShort(format, index) {
        return listMonthsImpl(format, index, 'monthsShort');
    }

    function listWeekdays(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
    }

    function listWeekdaysShort(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
    }

    function listWeekdaysMin(localeSorted, format, index) {
        return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
    }

    getSetGlobalLocale('en', {
        eras: [
            {
                since: '0001-01-01',
                until: +Infinity,
                offset: 1,
                name: 'Anno Domini',
                narrow: 'AD',
                abbr: 'AD',
            },
            {
                since: '0000-12-31',
                until: -Infinity,
                offset: 1,
                name: 'Before Christ',
                narrow: 'BC',
                abbr: 'BC',
            },
        ],
        dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
        ordinal: function (number) {
            var b = number % 10,
                output =
                    toInt((number % 100) / 10) === 1
                        ? 'th'
                        : b === 1
                          ? 'st'
                          : b === 2
                            ? 'nd'
                            : b === 3
                              ? 'rd'
                              : 'th';
            return number + output;
        },
    });

    // Side effect imports

    hooks.lang = deprecate(
        'moment.lang is deprecated. Use moment.locale instead.',
        getSetGlobalLocale
    );
    hooks.langData = deprecate(
        'moment.langData is deprecated. Use moment.localeData instead.',
        getLocale
    );

    var mathAbs = Math.abs;

    function abs() {
        var data = this._data;

        this._milliseconds = mathAbs(this._milliseconds);
        this._days = mathAbs(this._days);
        this._months = mathAbs(this._months);

        data.milliseconds = mathAbs(data.milliseconds);
        data.seconds = mathAbs(data.seconds);
        data.minutes = mathAbs(data.minutes);
        data.hours = mathAbs(data.hours);
        data.months = mathAbs(data.months);
        data.years = mathAbs(data.years);

        return this;
    }

    function addSubtract$1(duration, input, value, direction) {
        var other = createDuration(input, value);

        duration._milliseconds += direction * other._milliseconds;
        duration._days += direction * other._days;
        duration._months += direction * other._months;

        return duration._bubble();
    }

    // supports only 2.0-style add(1, 's') or add(duration)
    function add$1(input, value) {
        return addSubtract$1(this, input, value, 1);
    }

    // supports only 2.0-style subtract(1, 's') or subtract(duration)
    function subtract$1(input, value) {
        return addSubtract$1(this, input, value, -1);
    }

    function absCeil(number) {
        if (number < 0) {
            return Math.floor(number);
        } else {
            return Math.ceil(number);
        }
    }

    function bubble() {
        var milliseconds = this._milliseconds,
            days = this._days,
            months = this._months,
            data = this._data,
            seconds,
            minutes,
            hours,
            years,
            monthsFromDays;

        // if we have a mix of positive and negative values, bubble down first
        // check: https://github.com/moment/moment/issues/2166
        if (
            !(
                (milliseconds >= 0 && days >= 0 && months >= 0) ||
                (milliseconds <= 0 && days <= 0 && months <= 0)
            )
        ) {
            milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
            days = 0;
            months = 0;
        }

        // The following code bubbles up values, see the tests for
        // examples of what that means.
        data.milliseconds = milliseconds % 1000;

        seconds = absFloor(milliseconds / 1000);
        data.seconds = seconds % 60;

        minutes = absFloor(seconds / 60);
        data.minutes = minutes % 60;

        hours = absFloor(minutes / 60);
        data.hours = hours % 24;

        days += absFloor(hours / 24);

        // convert days to months
        monthsFromDays = absFloor(daysToMonths(days));
        months += monthsFromDays;
        days -= absCeil(monthsToDays(monthsFromDays));

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        data.days = days;
        data.months = months;
        data.years = years;

        return this;
    }

    function daysToMonths(days) {
        // 400 years have 146097 days (taking into account leap year rules)
        // 400 years have 12 months === 4800
        return (days * 4800) / 146097;
    }

    function monthsToDays(months) {
        // the reverse of daysToMonths
        return (months * 146097) / 4800;
    }

    function as(units) {
        if (!this.isValid()) {
            return NaN;
        }
        var days,
            months,
            milliseconds = this._milliseconds;

        units = normalizeUnits(units);

        if (units === 'month' || units === 'quarter' || units === 'year') {
            days = this._days + milliseconds / 864e5;
            months = this._months + daysToMonths(days);
            switch (units) {
                case 'month':
                    return months;
                case 'quarter':
                    return months / 3;
                case 'year':
                    return months / 12;
            }
        } else {
            // handle milliseconds separately because of floating point math errors (issue #1867)
            days = this._days + Math.round(monthsToDays(this._months));
            switch (units) {
                case 'week':
                    return days / 7 + milliseconds / 6048e5;
                case 'day':
                    return days + milliseconds / 864e5;
                case 'hour':
                    return days * 24 + milliseconds / 36e5;
                case 'minute':
                    return days * 1440 + milliseconds / 6e4;
                case 'second':
                    return days * 86400 + milliseconds / 1000;
                // Math.floor prevents floating point math errors here
                case 'millisecond':
                    return Math.floor(days * 864e5) + milliseconds;
                default:
                    throw new Error('Unknown unit ' + units);
            }
        }
    }

    function makeAs(alias) {
        return function () {
            return this.as(alias);
        };
    }

    var asMilliseconds = makeAs('ms'),
        asSeconds = makeAs('s'),
        asMinutes = makeAs('m'),
        asHours = makeAs('h'),
        asDays = makeAs('d'),
        asWeeks = makeAs('w'),
        asMonths = makeAs('M'),
        asQuarters = makeAs('Q'),
        asYears = makeAs('y'),
        valueOf$1 = asMilliseconds;

    function clone$1() {
        return createDuration(this);
    }

    function get$2(units) {
        units = normalizeUnits(units);
        return this.isValid() ? this[units + 's']() : NaN;
    }

    function makeGetter(name) {
        return function () {
            return this.isValid() ? this._data[name] : NaN;
        };
    }

    var milliseconds = makeGetter('milliseconds'),
        seconds = makeGetter('seconds'),
        minutes = makeGetter('minutes'),
        hours = makeGetter('hours'),
        days = makeGetter('days'),
        months = makeGetter('months'),
        years = makeGetter('years');

    function weeks() {
        return absFloor(this.days() / 7);
    }

    var round = Math.round,
        thresholds = {
            ss: 44, // a few seconds to seconds
            s: 45, // seconds to minute
            m: 45, // minutes to hour
            h: 22, // hours to day
            d: 26, // days to month/week
            w: null, // weeks to month
            M: 11, // months to year
        };

    // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
    function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
        return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
    }

    function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
        var duration = createDuration(posNegDuration).abs(),
            seconds = round(duration.as('s')),
            minutes = round(duration.as('m')),
            hours = round(duration.as('h')),
            days = round(duration.as('d')),
            months = round(duration.as('M')),
            weeks = round(duration.as('w')),
            years = round(duration.as('y')),
            a =
                (seconds <= thresholds.ss && ['s', seconds]) ||
                (seconds < thresholds.s && ['ss', seconds]) ||
                (minutes <= 1 && ['m']) ||
                (minutes < thresholds.m && ['mm', minutes]) ||
                (hours <= 1 && ['h']) ||
                (hours < thresholds.h && ['hh', hours]) ||
                (days <= 1 && ['d']) ||
                (days < thresholds.d && ['dd', days]);

        if (thresholds.w != null) {
            a =
                a ||
                (weeks <= 1 && ['w']) ||
                (weeks < thresholds.w && ['ww', weeks]);
        }
        a = a ||
            (months <= 1 && ['M']) ||
            (months < thresholds.M && ['MM', months]) ||
            (years <= 1 && ['y']) || ['yy', years];

        a[2] = withoutSuffix;
        a[3] = +posNegDuration > 0;
        a[4] = locale;
        return substituteTimeAgo.apply(null, a);
    }

    // This function allows you to set the rounding function for relative time strings
    function getSetRelativeTimeRounding(roundingFunction) {
        if (roundingFunction === undefined) {
            return round;
        }
        if (typeof roundingFunction === 'function') {
            round = roundingFunction;
            return true;
        }
        return false;
    }

    // This function allows you to set a threshold for relative time strings
    function getSetRelativeTimeThreshold(threshold, limit) {
        if (thresholds[threshold] === undefined) {
            return false;
        }
        if (limit === undefined) {
            return thresholds[threshold];
        }
        thresholds[threshold] = limit;
        if (threshold === 's') {
            thresholds.ss = limit - 1;
        }
        return true;
    }

    function humanize(argWithSuffix, argThresholds) {
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var withSuffix = false,
            th = thresholds,
            locale,
            output;

        if (typeof argWithSuffix === 'object') {
            argThresholds = argWithSuffix;
            argWithSuffix = false;
        }
        if (typeof argWithSuffix === 'boolean') {
            withSuffix = argWithSuffix;
        }
        if (typeof argThresholds === 'object') {
            th = Object.assign({}, thresholds, argThresholds);
            if (argThresholds.s != null && argThresholds.ss == null) {
                th.ss = argThresholds.s - 1;
            }
        }

        locale = this.localeData();
        output = relativeTime$1(this, !withSuffix, th, locale);

        if (withSuffix) {
            output = locale.pastFuture(+this, output);
        }

        return locale.postformat(output);
    }

    var abs$1 = Math.abs;

    function sign(x) {
        return (x > 0) - (x < 0) || +x;
    }

    function toISOString$1() {
        // for ISO strings we do not use the normal bubbling rules:
        //  * milliseconds bubble up until they become hours
        //  * days do not bubble at all
        //  * months bubble up until they become years
        // This is because there is no context-free conversion between hours and days
        // (think of clock changes)
        // and also not between days and months (28-31 days per month)
        if (!this.isValid()) {
            return this.localeData().invalidDate();
        }

        var seconds = abs$1(this._milliseconds) / 1000,
            days = abs$1(this._days),
            months = abs$1(this._months),
            minutes,
            hours,
            years,
            s,
            total = this.asSeconds(),
            totalSign,
            ymSign,
            daysSign,
            hmsSign;

        if (!total) {
            // this is the same as C#'s (Noda) and python (isodate)...
            // but not other JS (goog.date)
            return 'P0D';
        }

        // 3600 seconds -> 60 minutes -> 1 hour
        minutes = absFloor(seconds / 60);
        hours = absFloor(minutes / 60);
        seconds %= 60;
        minutes %= 60;

        // 12 months -> 1 year
        years = absFloor(months / 12);
        months %= 12;

        // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
        s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';

        totalSign = total < 0 ? '-' : '';
        ymSign = sign(this._months) !== sign(total) ? '-' : '';
        daysSign = sign(this._days) !== sign(total) ? '-' : '';
        hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';

        return (
            totalSign +
            'P' +
            (years ? ymSign + years + 'Y' : '') +
            (months ? ymSign + months + 'M' : '') +
            (days ? daysSign + days + 'D' : '') +
            (hours || minutes || seconds ? 'T' : '') +
            (hours ? hmsSign + hours + 'H' : '') +
            (minutes ? hmsSign + minutes + 'M' : '') +
            (seconds ? hmsSign + s + 'S' : '')
        );
    }

    var proto$2 = Duration.prototype;

    proto$2.isValid = isValid$1;
    proto$2.abs = abs;
    proto$2.add = add$1;
    proto$2.subtract = subtract$1;
    proto$2.as = as;
    proto$2.asMilliseconds = asMilliseconds;
    proto$2.asSeconds = asSeconds;
    proto$2.asMinutes = asMinutes;
    proto$2.asHours = asHours;
    proto$2.asDays = asDays;
    proto$2.asWeeks = asWeeks;
    proto$2.asMonths = asMonths;
    proto$2.asQuarters = asQuarters;
    proto$2.asYears = asYears;
    proto$2.valueOf = valueOf$1;
    proto$2._bubble = bubble;
    proto$2.clone = clone$1;
    proto$2.get = get$2;
    proto$2.milliseconds = milliseconds;
    proto$2.seconds = seconds;
    proto$2.minutes = minutes;
    proto$2.hours = hours;
    proto$2.days = days;
    proto$2.weeks = weeks;
    proto$2.months = months;
    proto$2.years = years;
    proto$2.humanize = humanize;
    proto$2.toISOString = toISOString$1;
    proto$2.toString = toISOString$1;
    proto$2.toJSON = toISOString$1;
    proto$2.locale = locale;
    proto$2.localeData = localeData;

    proto$2.toIsoString = deprecate(
        'toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)',
        toISOString$1
    );
    proto$2.lang = lang;

    // FORMATTING

    addFormatToken('X', 0, 0, 'unix');
    addFormatToken('x', 0, 0, 'valueOf');

    // PARSING

    addRegexToken('x', matchSigned);
    addRegexToken('X', matchTimestamp);
    addParseToken('X', function (input, array, config) {
        config._d = new Date(parseFloat(input) * 1000);
    });
    addParseToken('x', function (input, array, config) {
        config._d = new Date(toInt(input));
    });

    //! moment.js

    hooks.version = '2.30.1';

    setHookCallback(createLocal);

    hooks.fn = proto;
    hooks.min = min;
    hooks.max = max;
    hooks.now = now;
    hooks.utc = createUTC;
    hooks.unix = createUnix;
    hooks.months = listMonths;
    hooks.isDate = isDate;
    hooks.locale = getSetGlobalLocale;
    hooks.invalid = createInvalid;
    hooks.duration = createDuration;
    hooks.isMoment = isMoment;
    hooks.weekdays = listWeekdays;
    hooks.parseZone = createInZone;
    hooks.localeData = getLocale;
    hooks.isDuration = isDuration;
    hooks.monthsShort = listMonthsShort;
    hooks.weekdaysMin = listWeekdaysMin;
    hooks.defineLocale = defineLocale;
    hooks.updateLocale = updateLocale;
    hooks.locales = listLocales;
    hooks.weekdaysShort = listWeekdaysShort;
    hooks.normalizeUnits = normalizeUnits;
    hooks.relativeTimeRounding = getSetRelativeTimeRounding;
    hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
    hooks.calendarFormat = getCalendarFormat;
    hooks.prototype = proto;

    // currently HTML5 input type only supports 24-hour formats
    hooks.HTML5_FMT = {
        DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm', // <input type="datetime-local" />
        DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss', // <input type="datetime-local" step="1" />
        DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS', // <input type="datetime-local" step="0.001" />
        DATE: 'YYYY-MM-DD', // <input type="date" />
        TIME: 'HH:mm', // <input type="time" />
        TIME_SECONDS: 'HH:mm:ss', // <input type="time" step="1" />
        TIME_MS: 'HH:mm:ss.SSS', // <input type="time" step="0.001" />
        WEEK: 'GGGG-[W]WW', // <input type="week" />
        MONTH: 'YYYY-MM', // <input type="month" />
    };

    return hooks;

})));

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(119)(module)))

/***/ }),
/* 188 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _implementation = __webpack_require__(615);

var _implementation2 = _interopRequireDefault(_implementation);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _react2.default.createContext || _implementation2.default;
module.exports = exports['default'];

/***/ }),
/* 189 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(49);

var _extends3 = _interopRequireDefault(_extends2);

exports.argumentContainer = argumentContainer;
exports.identity = identity;
exports.flattenArray = flattenArray;
exports.treeTraverse = treeTraverse;
exports.flattenFields = flattenFields;
exports.normalizeValidateRules = normalizeValidateRules;
exports.getValidateTriggers = getValidateTriggers;
exports.getValueFromEvent = getValueFromEvent;
exports.getErrorStrs = getErrorStrs;
exports.getParams = getParams;
exports.isEmptyObject = isEmptyObject;
exports.hasRules = hasRules;
exports.startsWith = startsWith;
exports.supportRef = supportRef;

var _hoistNonReactStatics = __webpack_require__(686);

var _hoistNonReactStatics2 = _interopRequireDefault(_hoistNonReactStatics);

var _warning = __webpack_require__(21);

var _warning2 = _interopRequireDefault(_warning);

var _reactIs = __webpack_require__(50);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function getDisplayName(WrappedComponent) {
  return WrappedComponent.displayName || WrappedComponent.name || 'WrappedComponent';
}

function argumentContainer(Container, WrappedComponent) {
  /* eslint no-param-reassign:0 */
  Container.displayName = 'Form(' + getDisplayName(WrappedComponent) + ')';
  Container.WrappedComponent = WrappedComponent;
  return (0, _hoistNonReactStatics2['default'])(Container, WrappedComponent);
}

function identity(obj) {
  return obj;
}

function flattenArray(arr) {
  return Array.prototype.concat.apply([], arr);
}

function treeTraverse() {
  var path = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  var tree = arguments[1];
  var isLeafNode = arguments[2];
  var errorMessage = arguments[3];
  var callback = arguments[4];

  if (isLeafNode(path, tree)) {
    callback(path, tree);
  } else if (tree === undefined || tree === null) {
    // Do nothing
  } else if (Array.isArray(tree)) {
    tree.forEach(function (subTree, index) {
      return treeTraverse(path + '[' + index + ']', subTree, isLeafNode, errorMessage, callback);
    });
  } else {
    // It's object and not a leaf node
    if (typeof tree !== 'object') {
      (0, _warning2['default'])(false, errorMessage);
      return;
    }
    Object.keys(tree).forEach(function (subTreeKey) {
      var subTree = tree[subTreeKey];
      treeTraverse('' + path + (path ? '.' : '') + subTreeKey, subTree, isLeafNode, errorMessage, callback);
    });
  }
}

function flattenFields(maybeNestedFields, isLeafNode, errorMessage) {
  var fields = {};
  treeTraverse(undefined, maybeNestedFields, isLeafNode, errorMessage, function (path, node) {
    fields[path] = node;
  });
  return fields;
}

function normalizeValidateRules(validate, rules, validateTrigger) {
  var validateRules = validate.map(function (item) {
    var newItem = (0, _extends3['default'])({}, item, {
      trigger: item.trigger || []
    });
    if (typeof newItem.trigger === 'string') {
      newItem.trigger = [newItem.trigger];
    }
    return newItem;
  });
  if (rules) {
    validateRules.push({
      trigger: validateTrigger ? [].concat(validateTrigger) : [],
      rules: rules
    });
  }
  return validateRules;
}

function getValidateTriggers(validateRules) {
  return validateRules.filter(function (item) {
    return !!item.rules && item.rules.length;
  }).map(function (item) {
    return item.trigger;
  }).reduce(function (pre, curr) {
    return pre.concat(curr);
  }, []);
}

function getValueFromEvent(e) {
  // To support custom element
  if (!e || !e.target) {
    return e;
  }
  var target = e.target;

  return target.type === 'checkbox' ? target.checked : target.value;
}

function getErrorStrs(errors) {
  if (errors) {
    return errors.map(function (e) {
      if (e && e.message) {
        return e.message;
      }
      return e;
    });
  }
  return errors;
}

function getParams(ns, opt, cb) {
  var names = ns;
  var options = opt;
  var callback = cb;
  if (cb === undefined) {
    if (typeof names === 'function') {
      callback = names;
      options = {};
      names = undefined;
    } else if (Array.isArray(names)) {
      if (typeof options === 'function') {
        callback = options;
        options = {};
      } else {
        options = options || {};
      }
    } else {
      callback = options;
      options = names || {};
      names = undefined;
    }
  }
  return {
    names: names,
    options: options,
    callback: callback
  };
}

function isEmptyObject(obj) {
  return Object.keys(obj).length === 0;
}

function hasRules(validate) {
  if (validate) {
    return validate.some(function (item) {
      return item.rules && item.rules.length;
    });
  }
  return false;
}

function startsWith(str, prefix) {
  return str.lastIndexOf(prefix, 0) === 0;
}

function supportRef(nodeOrComponent) {
  var type = (0, _reactIs.isMemo)(nodeOrComponent) ? nodeOrComponent.type.type : nodeOrComponent.type;

  // Function component node
  if (typeof type === 'function' && !(type.prototype && type.prototype.render)) {
    return false;
  }

  // Class component
  if (typeof nodeOrComponent === 'function' && !(nodeOrComponent.prototype && nodeOrComponent.prototype.render)) {
    return false;
  }

  return true;
}

/***/ }),
/* 190 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(238),
    getSymbolsIn = __webpack_require__(309),
    keysIn = __webpack_require__(109);

/**
 * Creates an array of own and inherited enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeysIn(object) {
  return baseGetAllKeys(object, keysIn, getSymbolsIn);
}

module.exports = getAllKeysIn;


/***/ }),
/* 191 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(241);

/** Built-in value references. */
var getPrototype = overArg(Object.getPrototypeOf, Object);

module.exports = getPrototype;


/***/ }),
/* 192 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _default; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_clamp__ = __webpack_require__(707);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_clamp___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_clamp__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_size__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_size___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_size__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Slider__ = __webpack_require__(267);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__icons_ArrowLeft__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__icons_ArrowRight__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Thumbnail__ = __webpack_require__(711);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var createArrowButton=function createArrowButton(direction){return function(props){var _props$color=props.color,color=_props$color===undefined?'#00a9a7':_props$color,className=props.className,style=props.style,onClick=props.onClick;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('button',{className:className,style:style,onClick:onClick},direction==='left'?__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__icons_ArrowLeft__["a" /* default */],{width:30,fill:color}):__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__icons_ArrowRight__["a" /* default */],{width:30,fill:color}));};};var NextButton=createArrowButton('right');var PrevButton=createArrowButton('left');var _default=(_temp=_class=function(_React$Component){_inherits(_default,_React$Component);function _default(props){_classCallCheck(this,_default);var _this=_possibleConstructorReturn(this,(_default.__proto__||Object.getPrototypeOf(_default)).call(this,props));_this.componentWillReceiveProps=function(nextProps){if(_this.props.currentImage!==nextProps.currentImage){_this.setState({offset:0});if(_this.sliderRef&&_this.sliderRef.current)_this.sliderRef.current.slickGoTo(nextProps.currentImage,true);}};_this.gotoNext=function(){return _this.props.onClickNext();};_this.gotoPrev=function(){return _this.props.onClickPrev();};_this.moveThumbnailBackward=function(){return _this.setState({offset:_this.state.offset-3});};_this.moveThumbnailForward=function(){return _this.setState({offset:_this.state.offset+3});};_this.handleClickThumbnail=function(index){_this.setState({offset:0});_this.props.onClickThumbnail(index);};_this.renderCaptionBar=function(){var _this$props=_this.props,currentImage=_this$props.currentImage,images=_this$props.images;var image=images[currentImage];if(image){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'gallery-lightbox-captionbar'},image.caption!==""&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'container-caption'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'caption'},image.caption)),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'count'},currentImage+1,' / ',__WEBPACK_IMPORTED_MODULE_2_lodash_size___default()(images)));}};_this.renderThumbnails=function(){var _this$props2=_this.props,images=_this$props2.images,currentImage=_this$props2.currentImage;var thumbnails=images;var arrowWidth=40;var thumbWidth=120;var thumbnailsWidth=window.innerWidth-2*arrowWidth;var moverWidth=__WEBPACK_IMPORTED_MODULE_2_lodash_size___default()(images)*thumbWidth;var posX=.5*window.innerWidth-arrowWidth+(-_this.state.offset-currentImage-0.5)*thumbWidth;var clampedPosX=__WEBPACK_IMPORTED_MODULE_1_lodash_clamp___default()(posX,thumbnailsWidth-moverWidth,0);if(thumbnailsWidth>moverWidth)clampedPosX=0.5*(thumbnailsWidth-moverWidth);var isShowArr=window.innerWidth>moverWidth?false:true;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'thumbnails'},isShowArr&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'thumb-arrow',style:{width:arrowWidth}},posX<0&&_this.renderThumbArrowPrev()),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{style:{width:'calc(100vw - '+2*arrowWidth+'px)',overflow:'hidden'}},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'mover',style:{transition:'transform .3s ease-out',transform:'translateX('+clampedPosX+'px)'}},thumbnails.map(function(img,idx){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Thumbnail__["a" /* default */],Object.assign({key:idx},img,{index:idx,onClick:_this.handleClickThumbnail,active:idx===currentImage}));}))),isShowArr&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'thumb-arrow',style:{width:arrowWidth}},thumbnailsWidth-posX<moverWidth&&_this.renderThumbArrowNext()));};_this.sliderRef=__WEBPACK_IMPORTED_MODULE_3_react___default.a.createRef();_this.state={offset:0};return _this;}_createClass(_default,[{key:'renderArrowPrev',value:function renderArrowPrev(){if(this.props.currentImage<=0)return null;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(PrevButton,{color:'#00a9a7',onClick:this.gotoPrev});}},{key:'renderArrowNext',value:function renderArrowNext(){if(this.props.currentImage+1===__WEBPACK_IMPORTED_MODULE_2_lodash_size___default()(this.props.images))return null;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(NextButton,{color:'#00a9a7',onClick:this.gotoNext});}},{key:'renderThumbArrowPrev',value:function renderThumbArrowPrev(){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(PrevButton,{color:'#666',onClick:this.moveThumbnailBackward});}},{key:'renderThumbArrowNext',value:function renderThumbArrowNext(){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(NextButton,{color:'#666',onClick:this.moveThumbnailForward});}},{key:'render',value:function render(){var _props=this.props,currentImage=_props.currentImage,images=_props.images;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'gallery-lightbox'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'content'},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Slider__["a" /* default */],{sliderRef:this.sliderRef,settings:{initialSlide:currentImage,dots:false,autoplay:false,speed:300,arrows:false},items:images,uiRenderer:function uiRenderer(image){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{key:image.src,style:{width:'100%',height:'100%',display:'flex',justifyContent:'center',alignItems:'center'}},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(image,"src"),alt:''}));}}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'btn-arrow btn-prev'},this.renderArrowPrev()),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'btn-arrow btn-next'},this.renderArrowNext())),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement('div',{className:'gallery-lightbox-footer'},this.renderCaptionBar(),this.renderThumbnails()));}}]);return _default;}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component),_class.defaultProps={currentImage:0,images:[]},_temp);

/***/ }),
/* 193 */
/***/ (function(module, exports, __webpack_require__) {

var asciiSize = __webpack_require__(709),
    hasUnicode = __webpack_require__(99),
    unicodeSize = __webpack_require__(710);

/**
 * Gets the number of symbols in `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the string size.
 */
function stringSize(string) {
  return hasUnicode(string)
    ? unicodeSize(string)
    : asciiSize(string);
}

module.exports = stringSize;


/***/ }),
/* 194 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _scrollSpy = __webpack_require__(195);

var _scrollSpy2 = _interopRequireDefault(_scrollSpy);

var _scroller = __webpack_require__(134);

var _scroller2 = _interopRequireDefault(_scroller);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _scrollHash = __webpack_require__(311);

var _scrollHash2 = _interopRequireDefault(_scrollHash);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var protoTypes = {
  to: _propTypes2.default.string.isRequired,
  containerId: _propTypes2.default.string,
  container: _propTypes2.default.object,
  activeClass: _propTypes2.default.string,
  activeStyle: _propTypes2.default.object,
  spy: _propTypes2.default.bool,
  horizontal: _propTypes2.default.bool,
  smooth: _propTypes2.default.oneOfType([_propTypes2.default.bool, _propTypes2.default.string]),
  offset: _propTypes2.default.number,
  delay: _propTypes2.default.number,
  isDynamic: _propTypes2.default.bool,
  onClick: _propTypes2.default.func,
  duration: _propTypes2.default.oneOfType([_propTypes2.default.number, _propTypes2.default.func]),
  absolute: _propTypes2.default.bool,
  onSetActive: _propTypes2.default.func,
  onSetInactive: _propTypes2.default.func,
  ignoreCancelEvents: _propTypes2.default.bool,
  hashSpy: _propTypes2.default.bool,
  saveHashHistory: _propTypes2.default.bool,
  spyThrottle: _propTypes2.default.number
};

exports.default = function (Component, customScroller) {

  var scroller = customScroller || _scroller2.default;

  var Link = function (_React$PureComponent) {
    _inherits(Link, _React$PureComponent);

    function Link(props) {
      _classCallCheck(this, Link);

      var _this = _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).call(this, props));

      _initialiseProps.call(_this);

      _this.state = {
        active: false
      };
      return _this;
    }

    _createClass(Link, [{
      key: 'getScrollSpyContainer',
      value: function getScrollSpyContainer() {
        var containerId = this.props.containerId;
        var container = this.props.container;

        if (containerId && !container) {
          return document.getElementById(containerId);
        }

        if (container && container.nodeType) {
          return container;
        }

        return document;
      }
    }, {
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (this.props.spy || this.props.hashSpy) {
          var scrollSpyContainer = this.getScrollSpyContainer();

          if (!_scrollSpy2.default.isMounted(scrollSpyContainer)) {
            _scrollSpy2.default.mount(scrollSpyContainer, this.props.spyThrottle);
          }

          if (this.props.hashSpy) {
            if (!_scrollHash2.default.isMounted()) {
              _scrollHash2.default.mount(scroller);
            }
            _scrollHash2.default.mapContainer(this.props.to, scrollSpyContainer);
          }

          _scrollSpy2.default.addSpyHandler(this.spyHandler, scrollSpyContainer);

          this.setState({
            container: scrollSpyContainer
          });
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        _scrollSpy2.default.unmount(this.stateHandler, this.spyHandler);
      }
    }, {
      key: 'render',
      value: function render() {
        var className = "";

        if (this.state && this.state.active) {
          className = ((this.props.className || "") + " " + (this.props.activeClass || "active")).trim();
        } else {
          className = this.props.className;
        }

        var style = {};

        if (this.state && this.state.active) {
          style = _extends({}, this.props.style, this.props.activeStyle);
        } else {
          style = _extends({}, this.props.style);
        }

        var props = _extends({}, this.props);

        for (var prop in protoTypes) {
          if (props.hasOwnProperty(prop)) {
            delete props[prop];
          }
        }

        props.className = className;
        props.style = style;
        props.onClick = this.handleClick;

        return _react2.default.createElement(Component, props);
      }
    }]);

    return Link;
  }(_react2.default.PureComponent);

  var _initialiseProps = function _initialiseProps() {
    var _this2 = this;

    this.scrollTo = function (to, props) {
      scroller.scrollTo(to, _extends({}, _this2.state, props));
    };

    this.handleClick = function (event) {

      /*
       * give the posibility to override onClick
       */

      if (_this2.props.onClick) {
        _this2.props.onClick(event);
      }

      /*
       * dont bubble the navigation
       */

      if (event.stopPropagation) event.stopPropagation();
      if (event.preventDefault) event.preventDefault();

      /*
       * do the magic!
       */
      _this2.scrollTo(_this2.props.to, _this2.props);
    };

    this.spyHandler = function (x, y) {
      var scrollSpyContainer = _this2.getScrollSpyContainer();

      if (_scrollHash2.default.isMounted() && !_scrollHash2.default.isInitialized()) {
        return;
      }

      var horizontal = _this2.props.horizontal;

      var to = _this2.props.to;
      var element = null;
      var isInside = void 0;
      var isOutside = void 0;

      if (horizontal) {
        var elemLeftBound = 0;
        var elemRightBound = 0;
        var containerLeft = 0;

        if (scrollSpyContainer.getBoundingClientRect) {
          var containerCords = scrollSpyContainer.getBoundingClientRect();
          containerLeft = containerCords.left;
        }

        if (!element || _this2.props.isDynamic) {
          element = scroller.get(to);
          if (!element) {
            return;
          }

          var cords = element.getBoundingClientRect();
          elemLeftBound = cords.left - containerLeft + x;
          elemRightBound = elemLeftBound + cords.width;
        }

        var offsetX = x - _this2.props.offset;
        isInside = offsetX >= Math.floor(elemLeftBound) && offsetX < Math.floor(elemRightBound);
        isOutside = offsetX < Math.floor(elemLeftBound) || offsetX >= Math.floor(elemRightBound);
      } else {
        var elemTopBound = 0;
        var elemBottomBound = 0;
        var containerTop = 0;

        if (scrollSpyContainer.getBoundingClientRect) {
          var _containerCords = scrollSpyContainer.getBoundingClientRect();
          containerTop = _containerCords.top;
        }

        if (!element || _this2.props.isDynamic) {
          element = scroller.get(to);
          if (!element) {
            return;
          }

          var _cords = element.getBoundingClientRect();
          elemTopBound = _cords.top - containerTop + y;
          elemBottomBound = elemTopBound + _cords.height;
        }

        var offsetY = y - _this2.props.offset;
        isInside = offsetY >= Math.floor(elemTopBound) && offsetY < Math.floor(elemBottomBound);
        isOutside = offsetY < Math.floor(elemTopBound) || offsetY >= Math.floor(elemBottomBound);
      }

      var activeLink = scroller.getActiveLink();

      if (isOutside) {
        if (to === activeLink) {
          scroller.setActiveLink(void 0);
        }

        if (_this2.props.hashSpy && _scrollHash2.default.getHash() === to) {
          var _props$saveHashHistor = _this2.props.saveHashHistory,
              saveHashHistory = _props$saveHashHistor === undefined ? false : _props$saveHashHistor;

          _scrollHash2.default.changeHash("", saveHashHistory);
        }

        if (_this2.props.spy && _this2.state.active) {
          _this2.setState({ active: false });
          _this2.props.onSetInactive && _this2.props.onSetInactive(to, element);
        }
      }

      if (isInside && (activeLink !== to || _this2.state.active === false)) {
        scroller.setActiveLink(to);

        var _props$saveHashHistor2 = _this2.props.saveHashHistory,
            _saveHashHistory = _props$saveHashHistor2 === undefined ? false : _props$saveHashHistor2;

        _this2.props.hashSpy && _scrollHash2.default.changeHash(to, _saveHashHistory);

        if (_this2.props.spy) {
          _this2.setState({ active: true });
          _this2.props.onSetActive && _this2.props.onSetActive(to, element);
        }
      }
    };
  };

  ;

  Link.propTypes = protoTypes;

  Link.defaultProps = { offset: 0 };

  return Link;
};

/***/ }),
/* 195 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _lodash = __webpack_require__(726);

var _lodash2 = _interopRequireDefault(_lodash);

var _passiveEventListeners = __webpack_require__(196);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

// The eventHandler will execute at a rate of 15fps by default
var eventThrottler = function eventThrottler(eventHandler) {
  var throttleAmount = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 66;
  return (0, _lodash2.default)(eventHandler, throttleAmount);
};

var scrollSpy = {

  spyCallbacks: [],
  spySetState: [],
  scrollSpyContainers: [],

  mount: function mount(scrollSpyContainer, throttle) {
    if (scrollSpyContainer) {
      var eventHandler = eventThrottler(function (event) {
        scrollSpy.scrollHandler(scrollSpyContainer);
      }, throttle);
      scrollSpy.scrollSpyContainers.push(scrollSpyContainer);
      (0, _passiveEventListeners.addPassiveEventListener)(scrollSpyContainer, 'scroll', eventHandler);
    }
  },
  isMounted: function isMounted(scrollSpyContainer) {
    return scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer) !== -1;
  },
  currentPositionX: function currentPositionX(scrollSpyContainer) {
    if (scrollSpyContainer === document) {
      var supportPageOffset = window.pageYOffset !== undefined;
      var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
      return supportPageOffset ? window.pageXOffset : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft;
    } else {
      return scrollSpyContainer.scrollLeft;
    }
  },
  currentPositionY: function currentPositionY(scrollSpyContainer) {
    if (scrollSpyContainer === document) {
      var supportPageOffset = window.pageXOffset !== undefined;
      var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
      return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
    } else {
      return scrollSpyContainer.scrollTop;
    }
  },
  scrollHandler: function scrollHandler(scrollSpyContainer) {
    var callbacks = scrollSpy.scrollSpyContainers[scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer)].spyCallbacks || [];
    callbacks.forEach(function (c) {
      return c(scrollSpy.currentPositionX(scrollSpyContainer), scrollSpy.currentPositionY(scrollSpyContainer));
    });
  },
  addStateHandler: function addStateHandler(handler) {
    scrollSpy.spySetState.push(handler);
  },
  addSpyHandler: function addSpyHandler(handler, scrollSpyContainer) {
    var container = scrollSpy.scrollSpyContainers[scrollSpy.scrollSpyContainers.indexOf(scrollSpyContainer)];

    if (!container.spyCallbacks) {
      container.spyCallbacks = [];
    }

    container.spyCallbacks.push(handler);

    handler(scrollSpy.currentPositionX(scrollSpyContainer), scrollSpy.currentPositionY(scrollSpyContainer));
  },
  updateStates: function updateStates() {
    scrollSpy.spySetState.forEach(function (s) {
      return s();
    });
  },
  unmount: function unmount(stateHandler, spyHandler) {
    scrollSpy.scrollSpyContainers.forEach(function (c) {
      return c.spyCallbacks && c.spyCallbacks.length && c.spyCallbacks.indexOf(spyHandler) > -1 && c.spyCallbacks.splice(c.spyCallbacks.indexOf(spyHandler), 1);
    });

    if (scrollSpy.spySetState && scrollSpy.spySetState.length && scrollSpy.spySetState.indexOf(stateHandler) > -1) {
      scrollSpy.spySetState.splice(scrollSpy.spySetState.indexOf(stateHandler), 1);
    }

    document.removeEventListener('scroll', scrollSpy.scrollHandler);
  },


  update: function update() {
    return scrollSpy.scrollSpyContainers.forEach(function (c) {
      return scrollSpy.scrollHandler(c);
    });
  }
};

exports.default = scrollSpy;

/***/ }),
/* 196 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
/*
 * Tell the browser that the event listener won't prevent a scroll.
 * Allowing the browser to continue scrolling without having to
 * to wait for the listener to return.
 */
var addPassiveEventListener = exports.addPassiveEventListener = function addPassiveEventListener(target, eventName, listener) {
  var listenerName = listener.name;
  if (!listenerName) {
    listenerName = eventName;
    console.warn('Listener must be a named function.');
  }

  if (!attachedListeners.has(eventName)) attachedListeners.set(eventName, new Set());
  var listeners = attachedListeners.get(eventName);
  if (listeners.has(listenerName)) return;

  var supportsPassiveOption = function () {
    var supportsPassiveOption = false;
    try {
      var opts = Object.defineProperty({}, 'passive', {
        get: function get() {
          supportsPassiveOption = true;
        }
      });
      window.addEventListener('test', null, opts);
    } catch (e) {}
    return supportsPassiveOption;
  }();
  target.addEventListener(eventName, listener, supportsPassiveOption ? { passive: true } : false);
  listeners.add(listenerName);
};

var removePassiveEventListener = exports.removePassiveEventListener = function removePassiveEventListener(target, eventName, listener) {
  target.removeEventListener(eventName, listener);
  attachedListeners.get(eventName).delete(listener.name || eventName);
};

var attachedListeners = new Map();

/***/ }),
/* 197 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
	value: true
});

var Events = {
	registered: {},
	scrollEvent: {
		register: function register(evtName, callback) {
			Events.registered[evtName] = callback;
		},
		remove: function remove(evtName) {
			Events.registered[evtName] = null;
		}
	}
};

exports.default = Events;

/***/ }),
/* 198 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var width=_ref.width,height=_ref.height,fill=_ref.fill;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{fill:fill,version:"1.1",x:"0px",y:"0px",width:width,height:height,viewBox:"0 0 512 512",xmlSpace:"preserve"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(0 150)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("line",{fill:"none",stroke:fill,strokeWidth:"20",x1:"19",y1:"17.7",x2:"256",y2:"256"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("line",{fill:"none",stroke:fill,strokeWidth:"20",x1:"256",y1:"256",x2:"489.3",y2:"17.7"})));});

/***/ }),
/* 199 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_Button__ = __webpack_require__(76);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;var _templateObject=_taggedTemplateLiteral(["\n  display: flex;\n  ","\n  button {\n    margin-bottom: 10px;\n  }\n"],["\n  display: flex;\n  ","\n  button {\n    margin-bottom: 10px;\n  }\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var ContainerButtonGroup=__WEBPACK_IMPORTED_MODULE_3_styled_components__["b" /* default */].div(_templateObject,function(_ref){var direction=_ref.direction;if(direction==='horizontal'){return"\n        flex-direction: row;\n        flex-wrap: wrap;\n        align-items: center;\n        justify-content: center;\n      ";}else{return"\n        flex-direction: column;\n      ";}});var ButtonGroup=(_temp=_class=function(_Component){_inherits(ButtonGroup,_Component);function ButtonGroup(){_classCallCheck(this,ButtonGroup);return _possibleConstructorReturn(this,(ButtonGroup.__proto__||Object.getPrototypeOf(ButtonGroup)).apply(this,arguments));}_createClass(ButtonGroup,[{key:"render",value:function render(){var _this2=this;var _props=this.props,items=_props.items,direction=_props.direction;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(ContainerButtonGroup,{direction:direction},__WEBPACK_IMPORTED_MODULE_0_lodash_map___default()(items,function(item,key){return _this2.props.renderItem(Object.assign({},item,{key:key,active:_this2.props.value===item.value,onClick:function onClick(){_this2.props.onChange(item.value);}}));}));}}]);return ButtonGroup;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]),_class.propTypes={items:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape()),type:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,direction:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string},_class.defaultProps={value:"item2",items:[{value:"item1",label:"Item 1"},{value:"item2",label:"Item 2"},{value:"item3",label:"Item 3"}],direction:"horizontal",renderItem:function renderItem(_ref2){var value=_ref2.value,label=_ref2.label,active=_ref2.active,type=_ref2.type,key=_ref2.key,onClick=_ref2.onClick;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_Button__["a" /* default */],{key:key,type:"primary",active:active,activeStyle:{backgroundColor:"#ffffff",color:"black"},hoverStyle:{backgroundColor:"#ffffff",color:"black"},defaultStyle:{marginRight:"3px",backgroundColor:"#dbdbdb"},onClick:onClick},label," ",active?"active":"");}},_temp);/* harmony default export */ __webpack_exports__["a"] = (ButtonGroup);

/***/ }),
/* 200 */
/***/ (function(module, exports, __webpack_require__) {

var baseClone = __webpack_require__(321);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * This method is like `_.clone` except that it recursively clones `value`.
 *
 * @static
 * @memberOf _
 * @since 1.0.0
 * @category Lang
 * @param {*} value The value to recursively clone.
 * @returns {*} Returns the deep cloned value.
 * @see _.clone
 * @example
 *
 * var objects = [{ 'a': 1 }, { 'b': 2 }];
 *
 * var deep = _.cloneDeep(objects);
 * console.log(deep[0] === objects[0]);
 * // => false
 */
function cloneDeep(value) {
  return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
}

module.exports = cloneDeep;


/***/ }),
/* 201 */
/***/ (function(module, exports) {

/**
 * Copies the values of `source` to `array`.
 *
 * @private
 * @param {Array} source The array to copy values from.
 * @param {Array} [array=[]] The array to copy values to.
 * @returns {Array} Returns `array`.
 */
function copyArray(source, array) {
  var index = -1,
      length = source.length;

  array || (array = Array(length));
  while (++index < length) {
    array[index] = source[index];
  }
  return array;
}

module.exports = copyArray;


/***/ }),
/* 202 */
/***/ (function(module, exports, __webpack_require__) {

var Uint8Array = __webpack_require__(236);

/**
 * Creates a clone of `arrayBuffer`.
 *
 * @private
 * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
 * @returns {ArrayBuffer} Returns the cloned array buffer.
 */
function cloneArrayBuffer(arrayBuffer) {
  var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
  new Uint8Array(result).set(new Uint8Array(arrayBuffer));
  return result;
}

module.exports = cloneArrayBuffer;


/***/ }),
/* 203 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(31);

/** Built-in value references. */
var objectCreate = Object.create;

/**
 * The base implementation of `_.create` without support for assigning
 * properties to the created object.
 *
 * @private
 * @param {Object} proto The object to inherit from.
 * @returns {Object} Returns the new object.
 */
var baseCreate = (function() {
  function object() {}
  return function(proto) {
    if (!isObject(proto)) {
      return {};
    }
    if (objectCreate) {
      return objectCreate(proto);
    }
    object.prototype = proto;
    var result = new object;
    object.prototype = undefined;
    return result;
  };
}());

module.exports = baseCreate;


/***/ }),
/* 204 */
/***/ (function(module, exports) {

/**
 * The function whose prototype chain sequence wrappers inherit from.
 *
 * @private
 */
function baseLodash() {
  // No operation performed.
}

module.exports = baseLodash;


/***/ }),
/* 205 */
/***/ (function(module, exports, __webpack_require__) {

var toPropertyKey = __webpack_require__(336);
function _defineProperty(obj, key, value) {
  key = toPropertyKey(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}
module.exports = _defineProperty, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 206 */
/***/ (function(module, exports, __webpack_require__) {

var objectWithoutPropertiesLoose = __webpack_require__(832);
function _objectWithoutProperties(source, excluded) {
  if (source == null) return {};
  var target = objectWithoutPropertiesLoose(source, excluded);
  var key, i;
  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }
  return target;
}
module.exports = _objectWithoutProperties, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 207 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.handleLoadStart = handleLoadStart;
exports.handleCanPlay = handleCanPlay;
exports.handleWaiting = handleWaiting;
exports.handleCanPlayThrough = handleCanPlayThrough;
exports.handlePlaying = handlePlaying;
exports.handlePlay = handlePlay;
exports.handlePause = handlePause;
exports.handleEnd = handleEnd;
exports.handleSeeking = handleSeeking;
exports.handleSeeked = handleSeeked;
exports.handleDurationChange = handleDurationChange;
exports.handleTimeUpdate = handleTimeUpdate;
exports.handleVolumeChange = handleVolumeChange;
exports.handleProgressChange = handleProgressChange;
exports.handleRateChange = handleRateChange;
exports.handleSuspend = handleSuspend;
exports.handleAbort = handleAbort;
exports.handleEmptied = handleEmptied;
exports.handleStalled = handleStalled;
exports.handleLoadedMetaData = handleLoadedMetaData;
exports.handleLoadedData = handleLoadedData;
exports.handleResize = handleResize;
exports.handleError = handleError;
exports.handleSeekingTime = handleSeekingTime;
exports.handleEndSeeking = handleEndSeeking;
exports.activateTextTrack = activateTextTrack;
exports.ACTIVATE_TEXT_TRACK = exports.ERROR = exports.RESIZE = exports.LOADED_DATA = exports.LOADED_META_DATA = exports.STALLED = exports.EMPTIED = exports.ABORT = exports.SUSPEND = exports.RATE_CHANGE = exports.PROGRESS_CHANGE = exports.VOLUME_CHANGE = exports.TIME_UPDATE = exports.DURATION_CHANGE = exports.END_SEEKING = exports.SEEKING_TIME = exports.SEEKED = exports.SEEKING = exports.END = exports.PAUSE = exports.PLAY = exports.PLAYING = exports.CAN_PLAY_THROUGH = exports.WAITING = exports.CAN_PLAY = exports.LOAD_START = void 0;
var LOAD_START = 'video-react/LOAD_START';
exports.LOAD_START = LOAD_START;
var CAN_PLAY = 'video-react/CAN_PLAY';
exports.CAN_PLAY = CAN_PLAY;
var WAITING = 'video-react/WAITING';
exports.WAITING = WAITING;
var CAN_PLAY_THROUGH = 'video-react/CAN_PLAY_THROUGH';
exports.CAN_PLAY_THROUGH = CAN_PLAY_THROUGH;
var PLAYING = 'video-react/PLAYING';
exports.PLAYING = PLAYING;
var PLAY = 'video-react/PLAY';
exports.PLAY = PLAY;
var PAUSE = 'video-react/PAUSE';
exports.PAUSE = PAUSE;
var END = 'video-react/END';
exports.END = END;
var SEEKING = 'video-react/SEEKING';
exports.SEEKING = SEEKING;
var SEEKED = 'video-react/SEEKED';
exports.SEEKED = SEEKED;
var SEEKING_TIME = 'video-react/SEEKING_TIME';
exports.SEEKING_TIME = SEEKING_TIME;
var END_SEEKING = 'video-react/END_SEEKING';
exports.END_SEEKING = END_SEEKING;
var DURATION_CHANGE = 'video-react/DURATION_CHANGE';
exports.DURATION_CHANGE = DURATION_CHANGE;
var TIME_UPDATE = 'video-react/TIME_UPDATE';
exports.TIME_UPDATE = TIME_UPDATE;
var VOLUME_CHANGE = 'video-react/VOLUME_CHANGE';
exports.VOLUME_CHANGE = VOLUME_CHANGE;
var PROGRESS_CHANGE = 'video-react/PROGRESS_CHANGE';
exports.PROGRESS_CHANGE = PROGRESS_CHANGE;
var RATE_CHANGE = 'video-react/RATE_CHANGE';
exports.RATE_CHANGE = RATE_CHANGE;
var SUSPEND = 'video-react/SUSPEND';
exports.SUSPEND = SUSPEND;
var ABORT = 'video-react/ABORT';
exports.ABORT = ABORT;
var EMPTIED = 'video-react/EMPTIED';
exports.EMPTIED = EMPTIED;
var STALLED = 'video-react/STALLED';
exports.STALLED = STALLED;
var LOADED_META_DATA = 'video-react/LOADED_META_DATA';
exports.LOADED_META_DATA = LOADED_META_DATA;
var LOADED_DATA = 'video-react/LOADED_DATA';
exports.LOADED_DATA = LOADED_DATA;
var RESIZE = 'video-react/RESIZE';
exports.RESIZE = RESIZE;
var ERROR = 'video-react/ERROR';
exports.ERROR = ERROR;
var ACTIVATE_TEXT_TRACK = 'video-react/ACTIVATE_TEXT_TRACK';
exports.ACTIVATE_TEXT_TRACK = ACTIVATE_TEXT_TRACK;

function handleLoadStart(videoProps) {
  return {
    type: LOAD_START,
    videoProps: videoProps
  };
}

function handleCanPlay(videoProps) {
  return {
    type: CAN_PLAY,
    videoProps: videoProps
  };
}

function handleWaiting(videoProps) {
  return {
    type: WAITING,
    videoProps: videoProps
  };
}

function handleCanPlayThrough(videoProps) {
  return {
    type: CAN_PLAY_THROUGH,
    videoProps: videoProps
  };
}

function handlePlaying(videoProps) {
  return {
    type: PLAYING,
    videoProps: videoProps
  };
}

function handlePlay(videoProps) {
  return {
    type: PLAY,
    videoProps: videoProps
  };
}

function handlePause(videoProps) {
  return {
    type: PAUSE,
    videoProps: videoProps
  };
}

function handleEnd(videoProps) {
  return {
    type: END,
    videoProps: videoProps
  };
}

function handleSeeking(videoProps) {
  return {
    type: SEEKING,
    videoProps: videoProps
  };
}

function handleSeeked(videoProps) {
  return {
    type: SEEKED,
    videoProps: videoProps
  };
}

function handleDurationChange(videoProps) {
  return {
    type: DURATION_CHANGE,
    videoProps: videoProps
  };
}

function handleTimeUpdate(videoProps) {
  return {
    type: TIME_UPDATE,
    videoProps: videoProps
  };
}

function handleVolumeChange(videoProps) {
  return {
    type: VOLUME_CHANGE,
    videoProps: videoProps
  };
}

function handleProgressChange(videoProps) {
  return {
    type: PROGRESS_CHANGE,
    videoProps: videoProps
  };
}

function handleRateChange(videoProps) {
  return {
    type: RATE_CHANGE,
    videoProps: videoProps
  };
}

function handleSuspend(videoProps) {
  return {
    type: SUSPEND,
    videoProps: videoProps
  };
}

function handleAbort(videoProps) {
  return {
    type: ABORT,
    videoProps: videoProps
  };
}

function handleEmptied(videoProps) {
  return {
    type: EMPTIED,
    videoProps: videoProps
  };
}

function handleStalled(videoProps) {
  return {
    type: STALLED,
    videoProps: videoProps
  };
}

function handleLoadedMetaData(videoProps) {
  return {
    type: LOADED_META_DATA,
    videoProps: videoProps
  };
}

function handleLoadedData(videoProps) {
  return {
    type: LOADED_DATA,
    videoProps: videoProps
  };
}

function handleResize(videoProps) {
  return {
    type: RESIZE,
    videoProps: videoProps
  };
}

function handleError(videoProps) {
  return {
    type: ERROR,
    videoProps: videoProps
  };
}

function handleSeekingTime(time) {
  return {
    type: SEEKING_TIME,
    time: time
  };
}

function handleEndSeeking(time) {
  return {
    type: END_SEEKING,
    time: time
  };
}

function activateTextTrack(textTrack) {
  return {
    type: ACTIVATE_TEXT_TRACK,
    textTrack: textTrack
  };
}

/***/ }),
/* 208 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(12);

var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(10));

var _createClass2 = _interopRequireDefault(__webpack_require__(11));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(16));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(15));

var _inherits2 = _interopRequireDefault(__webpack_require__(17));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(9));

var Dom = _interopRequireWildcard(__webpack_require__(138));

var propTypes = {
  className: _propTypes["default"].string,
  onMouseDown: _propTypes["default"].func,
  onMouseMove: _propTypes["default"].func,
  stepForward: _propTypes["default"].func,
  stepBack: _propTypes["default"].func,
  sliderActive: _propTypes["default"].func,
  sliderInactive: _propTypes["default"].func,
  onMouseUp: _propTypes["default"].func,
  onFocus: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  onClick: _propTypes["default"].func,
  getPercent: _propTypes["default"].func,
  vertical: _propTypes["default"].bool,
  children: _propTypes["default"].node,
  label: _propTypes["default"].string,
  valuenow: _propTypes["default"].string,
  valuetext: _propTypes["default"].string
};

var Slider =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Slider, _Component);

  function Slider(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, Slider);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Slider).call(this, props, context));
    _this.handleMouseDown = _this.handleMouseDown.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleMouseMove = _this.handleMouseMove.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleMouseUp = _this.handleMouseUp.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleKeyPress = _this.handleKeyPress.bind((0, _assertThisInitialized2["default"])(_this));
    _this.stepForward = _this.stepForward.bind((0, _assertThisInitialized2["default"])(_this));
    _this.stepBack = _this.stepBack.bind((0, _assertThisInitialized2["default"])(_this));
    _this.calculateDistance = _this.calculateDistance.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getProgress = _this.getProgress.bind((0, _assertThisInitialized2["default"])(_this));
    _this.renderChildren = _this.renderChildren.bind((0, _assertThisInitialized2["default"])(_this));
    _this.state = {
      active: false
    };
    return _this;
  }

  (0, _createClass2["default"])(Slider, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('mousemove', this.handleMouseMove, true);
      document.removeEventListener('mouseup', this.handleMouseUp, true);
      document.removeEventListener('touchmove', this.handleMouseMove, true);
      document.removeEventListener('touchend', this.handleMouseUp, true);
      document.removeEventListener('keydown', this.handleKeyPress, true);
    }
  }, {
    key: "getProgress",
    value: function getProgress() {
      var getPercent = this.props.getPercent;

      if (!getPercent) {
        return 0;
      }

      var progress = getPercent(); // Protect against no duration and other division issues

      if (typeof progress !== 'number' || progress < 0 || progress === Infinity) {
        progress = 0;
      }

      return progress;
    }
  }, {
    key: "handleMouseDown",
    value: function handleMouseDown(event) {
      var onMouseDown = this.props.onMouseDown; // event.preventDefault();
      // event.stopPropagation();

      document.addEventListener('mousemove', this.handleMouseMove, true);
      document.addEventListener('mouseup', this.handleMouseUp, true);
      document.addEventListener('touchmove', this.handleMouseMove, true);
      document.addEventListener('touchend', this.handleMouseUp, true);
      this.setState({
        active: true
      });

      if (this.props.sliderActive) {
        this.props.sliderActive(event);
      }

      this.handleMouseMove(event);

      if (onMouseDown) {
        onMouseDown(event);
      }
    }
  }, {
    key: "handleMouseMove",
    value: function handleMouseMove(event) {
      var onMouseMove = this.props.onMouseMove;

      if (onMouseMove) {
        onMouseMove(event);
      }
    }
  }, {
    key: "handleMouseUp",
    value: function handleMouseUp(event) {
      // On iOS safari, a subsequent mouseup event will be fired after touchend.
      // Its weird event positions make the player seek a wrong time.
      // calling preventDefault (at touchend phase) will prevent the mouseup event
      event.preventDefault();
      var onMouseUp = this.props.onMouseUp;
      document.removeEventListener('mousemove', this.handleMouseMove, true);
      document.removeEventListener('mouseup', this.handleMouseUp, true);
      document.removeEventListener('touchmove', this.handleMouseMove, true);
      document.removeEventListener('touchend', this.handleMouseUp, true);
      this.setState({
        active: false
      });

      if (this.props.sliderInactive) {
        this.props.sliderInactive(event);
      }

      if (onMouseUp) {
        onMouseUp(event);
      }
    }
  }, {
    key: "handleFocus",
    value: function handleFocus(e) {
      document.addEventListener('keydown', this.handleKeyPress, true);

      if (this.props.onFocus) {
        this.props.onFocus(e);
      }
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(e) {
      document.removeEventListener('keydown', this.handleKeyPress, true);

      if (this.props.onBlur) {
        this.props.onBlur(e);
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick(event) {
      event.preventDefault(); // event.stopPropagation();

      if (this.props.onClick) {
        this.props.onClick(event);
      }
    }
  }, {
    key: "handleKeyPress",
    value: function handleKeyPress(event) {
      if (event.which === 37 || event.which === 40) {
        // Left and Down Arrows
        event.preventDefault();
        event.stopPropagation();
        this.stepBack();
      } else if (event.which === 38 || event.which === 39) {
        // Up and Right Arrows
        event.preventDefault();
        event.stopPropagation();
        this.stepForward();
      }
    }
  }, {
    key: "stepForward",
    value: function stepForward() {
      if (this.props.stepForward) {
        this.props.stepForward();
      }
    }
  }, {
    key: "stepBack",
    value: function stepBack() {
      if (this.props.stepBack) {
        this.props.stepBack();
      }
    }
  }, {
    key: "calculateDistance",
    value: function calculateDistance(event) {
      var node = this.slider;
      var position = Dom.getPointerPosition(node, event);

      if (this.props.vertical) {
        return position.y;
      }

      return position.x;
    }
  }, {
    key: "renderChildren",
    value: function renderChildren() {
      var progress = this.getProgress();
      var percentage = "".concat((progress * 100).toFixed(2), "%");
      return _react["default"].Children.map(this.props.children, function (child) {
        return _react["default"].cloneElement(child, {
          progress: progress,
          percentage: percentage
        });
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          vertical = _this$props.vertical,
          label = _this$props.label,
          valuenow = _this$props.valuenow,
          valuetext = _this$props.valuetext;
      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])(this.props.className, {
          'video-react-slider-vertical': vertical,
          'video-react-slider-horizontal': !vertical,
          'video-react-sliding': this.state.active
        }, 'video-react-slider'),
        ref: function ref(c) {
          _this2.slider = c;
        },
        tabIndex: "0",
        role: "slider",
        onMouseDown: this.handleMouseDown,
        onTouchStart: this.handleMouseDown,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onClick: this.handleClick,
        "aria-label": label || '',
        "aria-valuenow": valuenow || '',
        "aria-valuetext": valuetext || '',
        "aria-valuemin": 0,
        "aria-valuemax": 100
      }, this.renderChildren());
    }
  }]);
  return Slider;
}(_react.Component);

exports["default"] = Slider;
Slider.propTypes = propTypes;
Slider.displayName = 'Slider';

/***/ }),
/* 209 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(12);

var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(10));

var _createClass2 = _interopRequireDefault(__webpack_require__(11));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(16));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(15));

var _inherits2 = _interopRequireDefault(__webpack_require__(17));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(9));

var _MenuButton = _interopRequireDefault(__webpack_require__(210));

var propTypes = {
  player: _propTypes["default"].object,
  actions: _propTypes["default"].object,
  rates: _propTypes["default"].array,
  className: _propTypes["default"].string
};
var defaultProps = {
  rates: [2, 1.5, 1.25, 1, 0.5, 0.25]
};

var PlaybackRateMenuButton =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(PlaybackRateMenuButton, _Component);

  function PlaybackRateMenuButton(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, PlaybackRateMenuButton);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(PlaybackRateMenuButton).call(this, props, context));
    _this.handleSelectItem = _this.handleSelectItem.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(PlaybackRateMenuButton, [{
    key: "handleSelectItem",
    value: function handleSelectItem(index) {
      var _this$props = this.props,
          rates = _this$props.rates,
          actions = _this$props.actions;

      if (index >= 0 && index < rates.length) {
        actions.changeRate(rates[index]);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          rates = _this$props2.rates,
          player = _this$props2.player;
      var items = rates.map(function (rate) {
        return {
          label: "".concat(rate, "x"),
          value: rate
        };
      });
      var selectedIndex = rates.indexOf(player.playbackRate) || 0;
      return _react["default"].createElement(_MenuButton["default"], {
        className: (0, _classnames["default"])('video-react-playback-rate', this.props.className),
        onSelectItem: this.handleSelectItem,
        items: items,
        selectedIndex: selectedIndex
      }, _react["default"].createElement("span", {
        className: "video-react-control-text"
      }, "Playback Rate"), _react["default"].createElement("div", {
        className: "video-react-playback-rate-value"
      }, "".concat(player.playbackRate.toFixed(2), "x")));
    }
  }]);
  return PlaybackRateMenuButton;
}(_react.Component);

PlaybackRateMenuButton.propTypes = propTypes;
PlaybackRateMenuButton.defaultProps = defaultProps;
PlaybackRateMenuButton.displayName = 'PlaybackRateMenuButton';
var _default = PlaybackRateMenuButton;
exports["default"] = _default;

/***/ }),
/* 210 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(12);

var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(10));

var _createClass2 = _interopRequireDefault(__webpack_require__(11));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(16));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(15));

var _inherits2 = _interopRequireDefault(__webpack_require__(17));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(9));

var _Menu = _interopRequireDefault(__webpack_require__(845));

var _MenuItem = _interopRequireDefault(__webpack_require__(846));

var _ClickableComponent = _interopRequireDefault(__webpack_require__(363));

var propTypes = {
  inline: _propTypes["default"].bool,
  items: _propTypes["default"].array,
  className: _propTypes["default"].string,
  onSelectItem: _propTypes["default"].func,
  children: _propTypes["default"].any,
  selectedIndex: _propTypes["default"].number
};

var MenuButton =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(MenuButton, _Component);

  function MenuButton(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, MenuButton);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(MenuButton).call(this, props, context));
    _this.state = {
      active: false,
      activateIndex: props.selectedIndex || 0
    };
    _this.commitSelection = _this.commitSelection.bind((0, _assertThisInitialized2["default"])(_this));
    _this.activateMenuItem = _this.activateMenuItem.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.renderMenu = _this.renderMenu.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleUpArrow = _this.handleUpArrow.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleDownArrow = _this.handleDownArrow.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleEscape = _this.handleEscape.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleReturn = _this.handleReturn.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleTab = _this.handleTab.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleKeyPress = _this.handleKeyPress.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleSelectItem = _this.handleSelectItem.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleIndexChange = _this.handleIndexChange.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(MenuButton, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.selectedIndex !== this.props.selectedIndex) {
        this.activateMenuItem(this.props.selectedIndex);
      }
    }
  }, {
    key: "commitSelection",
    value: function commitSelection(index) {
      this.setState({
        activateIndex: index
      });
      this.handleIndexChange(index);
    }
  }, {
    key: "activateMenuItem",
    value: function activateMenuItem(index) {
      this.setState({
        activateIndex: index
      });
      this.handleIndexChange(index);
    }
  }, {
    key: "handleIndexChange",
    value: function handleIndexChange(index) {
      var onSelectItem = this.props.onSelectItem;
      onSelectItem(index);
    }
  }, {
    key: "handleClick",
    value: function handleClick() {
      this.setState(function (prevState) {
        return {
          active: !prevState.active
        };
      });
    }
  }, {
    key: "handleFocus",
    value: function handleFocus() {
      document.addEventListener('keydown', this.handleKeyPress);
    }
  }, {
    key: "handleBlur",
    value: function handleBlur() {
      this.setState({
        active: false
      });
      document.removeEventListener('keydown', this.handleKeyPress);
    }
  }, {
    key: "handleUpArrow",
    value: function handleUpArrow(e) {
      var items = this.props.items;

      if (this.state.active) {
        e.preventDefault();
        var newIndex = this.state.activateIndex - 1;

        if (newIndex < 0) {
          newIndex = items.length ? items.length - 1 : 0;
        }

        this.activateMenuItem(newIndex);
      }
    }
  }, {
    key: "handleDownArrow",
    value: function handleDownArrow(e) {
      var items = this.props.items;

      if (this.state.active) {
        e.preventDefault();
        var newIndex = this.state.activateIndex + 1;

        if (newIndex >= items.length) {
          newIndex = 0;
        }

        this.activateMenuItem(newIndex);
      }
    }
  }, {
    key: "handleTab",
    value: function handleTab(e) {
      if (this.state.active) {
        e.preventDefault();
        this.commitSelection(this.state.activateIndex);
      }
    }
  }, {
    key: "handleReturn",
    value: function handleReturn(e) {
      e.preventDefault();

      if (this.state.active) {
        this.commitSelection(this.state.activateIndex);
      } else {
        this.setState({
          active: true
        });
      }
    }
  }, {
    key: "handleEscape",
    value: function handleEscape() {
      this.setState({
        active: false,
        activateIndex: 0
      });
    }
  }, {
    key: "handleKeyPress",
    value: function handleKeyPress(event) {
      // Escape (27) key
      if (event.which === 27) {
        this.handleEscape(event);
      } else if (event.which === 9) {
        // Tab (9) key
        this.handleTab(event);
      } else if (event.which === 13) {
        // Enter (13) key
        this.handleReturn(event);
      } else if (event.which === 38) {
        // Up (38) key
        this.handleUpArrow(event);
      } else if (event.which === 40) {
        // Down (40) key press
        this.handleDownArrow(event);
      }
    }
  }, {
    key: "handleSelectItem",
    value: function handleSelectItem(i) {
      this.commitSelection(i);
    }
  }, {
    key: "renderMenu",
    value: function renderMenu() {
      var _this2 = this;

      if (!this.state.active) {
        return null;
      }

      var items = this.props.items;
      return _react["default"].createElement(_Menu["default"], null, items.map(function (item, i) {
        return _react["default"].createElement(_MenuItem["default"], {
          item: item,
          index: i,
          onSelectItem: _this2.handleSelectItem,
          activateIndex: _this2.state.activateIndex,
          key: "item-".concat(i++)
        });
      }));
    }
  }, {
    key: "render",
    value: function render() {
      var _this3 = this;

      var _this$props = this.props,
          inline = _this$props.inline,
          className = _this$props.className;
      return _react["default"].createElement(_ClickableComponent["default"], {
        className: (0, _classnames["default"])(className, {
          'video-react-menu-button-inline': !!inline,
          'video-react-menu-button-popup': !inline,
          'video-react-menu-button-active': this.state.active
        }, 'video-react-control video-react-button video-react-menu-button'),
        role: "button",
        tabIndex: "0",
        ref: function ref(c) {
          _this3.menuButton = c;
        },
        onClick: this.handleClick,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur
      }, this.props.children, this.renderMenu());
    }
  }]);
  return MenuButton;
}(_react.Component);

exports["default"] = MenuButton;
MenuButton.propTypes = propTypes;
MenuButton.displayName = 'MenuButton';

/***/ }),
/* 211 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(372);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;

/***/ }),
/* 212 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var asap = __webpack_require__(380);

function noop() {}

// States:
//
// 0 - pending
// 1 - fulfilled with _value
// 2 - rejected with _value
// 3 - adopted the state of another promise, _value
//
// once the state is no longer pending (0) it is immutable

// All `_` prefixed properties will be reduced to `_{random number}`
// at build time to obfuscate them and discourage their use.
// We don't use symbols or Object.defineProperty to fully hide them
// because the performance isn't good enough.


// to avoid using try/catch inside critical functions, we
// extract them to here.
var LAST_ERROR = null;
var IS_ERROR = {};
function getThen(obj) {
  try {
    return obj.then;
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

function tryCallOne(fn, a) {
  try {
    return fn(a);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}
function tryCallTwo(fn, a, b) {
  try {
    fn(a, b);
  } catch (ex) {
    LAST_ERROR = ex;
    return IS_ERROR;
  }
}

module.exports = Promise;

function Promise(fn) {
  if (typeof this !== 'object') {
    throw new TypeError('Promises must be constructed via new');
  }
  if (typeof fn !== 'function') {
    throw new TypeError('Promise constructor\'s argument is not a function');
  }
  this._75 = 0;
  this._83 = 0;
  this._18 = null;
  this._38 = null;
  if (fn === noop) return;
  doResolve(fn, this);
}
Promise._47 = null;
Promise._71 = null;
Promise._44 = noop;

Promise.prototype.then = function(onFulfilled, onRejected) {
  if (this.constructor !== Promise) {
    return safeThen(this, onFulfilled, onRejected);
  }
  var res = new Promise(noop);
  handle(this, new Handler(onFulfilled, onRejected, res));
  return res;
};

function safeThen(self, onFulfilled, onRejected) {
  return new self.constructor(function (resolve, reject) {
    var res = new Promise(noop);
    res.then(resolve, reject);
    handle(self, new Handler(onFulfilled, onRejected, res));
  });
}
function handle(self, deferred) {
  while (self._83 === 3) {
    self = self._18;
  }
  if (Promise._47) {
    Promise._47(self);
  }
  if (self._83 === 0) {
    if (self._75 === 0) {
      self._75 = 1;
      self._38 = deferred;
      return;
    }
    if (self._75 === 1) {
      self._75 = 2;
      self._38 = [self._38, deferred];
      return;
    }
    self._38.push(deferred);
    return;
  }
  handleResolved(self, deferred);
}

function handleResolved(self, deferred) {
  asap(function() {
    var cb = self._83 === 1 ? deferred.onFulfilled : deferred.onRejected;
    if (cb === null) {
      if (self._83 === 1) {
        resolve(deferred.promise, self._18);
      } else {
        reject(deferred.promise, self._18);
      }
      return;
    }
    var ret = tryCallOne(cb, self._18);
    if (ret === IS_ERROR) {
      reject(deferred.promise, LAST_ERROR);
    } else {
      resolve(deferred.promise, ret);
    }
  });
}
function resolve(self, newValue) {
  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
  if (newValue === self) {
    return reject(
      self,
      new TypeError('A promise cannot be resolved with itself.')
    );
  }
  if (
    newValue &&
    (typeof newValue === 'object' || typeof newValue === 'function')
  ) {
    var then = getThen(newValue);
    if (then === IS_ERROR) {
      return reject(self, LAST_ERROR);
    }
    if (
      then === self.then &&
      newValue instanceof Promise
    ) {
      self._83 = 3;
      self._18 = newValue;
      finale(self);
      return;
    } else if (typeof then === 'function') {
      doResolve(then.bind(newValue), self);
      return;
    }
  }
  self._83 = 1;
  self._18 = newValue;
  finale(self);
}

function reject(self, newValue) {
  self._83 = 2;
  self._18 = newValue;
  if (Promise._71) {
    Promise._71(self, newValue);
  }
  finale(self);
}
function finale(self) {
  if (self._75 === 1) {
    handle(self, self._38);
    self._38 = null;
  }
  if (self._75 === 2) {
    for (var i = 0; i < self._38.length; i++) {
      handle(self, self._38[i]);
    }
    self._38 = null;
  }
}

function Handler(onFulfilled, onRejected, promise){
  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
  this.promise = promise;
}

/**
 * Take a potentially misbehaving resolver function and make sure
 * onFulfilled and onRejected are only called once.
 *
 * Makes no guarantees about asynchrony.
 */
function doResolve(fn, promise) {
  var done = false;
  var res = tryCallTwo(fn, function (value) {
    if (done) return;
    done = true;
    resolve(promise, value);
  }, function (reason) {
    if (done) return;
    done = true;
    reject(promise, reason);
  });
  if (!done && res === IS_ERROR) {
    done = true;
    reject(promise, LAST_ERROR);
  }
}


/***/ }),
/* 213 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Provider__ = __webpack_require__(388);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_connectAdvanced__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__connect_connect__ = __webpack_require__(395);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Provider__["a"]; });
/* unused harmony reexport createProvider */
/* unused harmony reexport connectAdvanced */
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_2__connect_connect__["a"]; });





/***/ }),
/* 214 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 215 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return subscriptionShape; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return storeShape; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_prop_types__);

var subscriptionShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  trySubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  tryUnsubscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  notifyNestedSubs: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  isSubscribed: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});
var storeShape = __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.shape({
  subscribe: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  dispatch: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired,
  getState: __WEBPACK_IMPORTED_MODULE_0_prop_types___default.a.func.isRequired
});

/***/ }),
/* 216 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = connectAdvanced;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__ = __webpack_require__(391);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__ = __webpack_require__(392);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react_is__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__ = __webpack_require__(394);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__ = __webpack_require__(215);










var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_6_react___default.a.forwardRef !== "undefined";
var hotReloadingVersion = 0;
var dummyState = {};

function noop() {}

function makeSelectorStateful(sourceSelector, store) {
  // wrap the selector in an object that tracks its results between runs.
  var selector = {
    run: function runComponentSelector(props) {
      try {
        var nextProps = sourceSelector(store.getState(), props);

        if (nextProps !== selector.props || selector.error) {
          selector.shouldComponentUpdate = true;
          selector.props = nextProps;
          selector.error = null;
        }
      } catch (error) {
        selector.shouldComponentUpdate = true;
        selector.error = error;
      }
    }
  };
  return selector;
}

function connectAdvanced(
/*
  selectorFactory is a func that is responsible for returning the selector function used to
  compute new props from state, props, and dispatch. For example:
     export default connectAdvanced((dispatch, options) => (state, props) => ({
      thing: state.things[props.thingId],
      saveThing: fields => dispatch(actionCreators.saveThing(props.thingId, fields)),
    }))(YourComponent)
   Access to dispatch is provided to the factory so selectorFactories can bind actionCreators
  outside of their selector as an optimization. Options passed to connectAdvanced are passed to
  the selectorFactory, along with displayName and WrappedComponent, as the second argument.
   Note that selectorFactory is responsible for all caching/memoization of inbound and outbound
  props. Do not use connectAdvanced directly without memoizing results between calls to your
  selector, otherwise the Connect component will re-render on every state or props change.
*/
selectorFactory, // options object:
_ref) {
  var _contextTypes, _childContextTypes;

  if (_ref === void 0) {
    _ref = {};
  }

  var _ref2 = _ref,
      _ref2$getDisplayName = _ref2.getDisplayName,
      getDisplayName = _ref2$getDisplayName === void 0 ? function (name) {
    return "ConnectAdvanced(" + name + ")";
  } : _ref2$getDisplayName,
      _ref2$methodName = _ref2.methodName,
      methodName = _ref2$methodName === void 0 ? 'connectAdvanced' : _ref2$methodName,
      _ref2$renderCountProp = _ref2.renderCountProp,
      renderCountProp = _ref2$renderCountProp === void 0 ? undefined : _ref2$renderCountProp,
      _ref2$shouldHandleSta = _ref2.shouldHandleStateChanges,
      shouldHandleStateChanges = _ref2$shouldHandleSta === void 0 ? true : _ref2$shouldHandleSta,
      _ref2$storeKey = _ref2.storeKey,
      storeKey = _ref2$storeKey === void 0 ? 'store' : _ref2$storeKey,
      _ref2$withRef = _ref2.withRef,
      withRef = _ref2$withRef === void 0 ? false : _ref2$withRef,
      connectOptions = Object(__WEBPACK_IMPORTED_MODULE_3__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["getDisplayName", "methodName", "renderCountProp", "shouldHandleStateChanges", "storeKey", "withRef"]);

  var subscriptionKey = storeKey + 'Subscription';
  var version = hotReloadingVersion++;
  var contextTypes = (_contextTypes = {}, _contextTypes[storeKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["a" /* storeShape */], _contextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _contextTypes);
  var childContextTypes = (_childContextTypes = {}, _childContextTypes[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_9__utils_PropTypes__["b" /* subscriptionShape */], _childContextTypes);
  return function wrapWithConnect(WrappedComponent) {
    __WEBPACK_IMPORTED_MODULE_5_invariant___default()(Object(__WEBPACK_IMPORTED_MODULE_7_react_is__["isValidElementType"])(WrappedComponent), "You must pass a component to the function returned by " + (methodName + ". Instead received " + JSON.stringify(WrappedComponent)));
    var wrappedComponentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
    var displayName = getDisplayName(wrappedComponentName);

    var selectorFactoryOptions = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, connectOptions, {
      getDisplayName: getDisplayName,
      methodName: methodName,
      renderCountProp: renderCountProp,
      shouldHandleStateChanges: shouldHandleStateChanges,
      storeKey: storeKey,
      withRef: withRef,
      displayName: displayName,
      wrappedComponentName: wrappedComponentName,
      WrappedComponent: WrappedComponent // TODO Actually fix our use of componentWillReceiveProps

      /* eslint-disable react/no-deprecated */

    });

    var Connect =
    /*#__PURE__*/
    function (_Component) {
      Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Connect, _Component);

      function Connect(props, context) {
        var _this;

        _this = _Component.call(this, props, context) || this;
        _this.version = version;
        _this.state = {};
        _this.renderCount = 0;
        _this.store = props[storeKey] || context[storeKey];
        _this.propsMode = Boolean(props[storeKey]);
        _this.setWrappedInstance = _this.setWrappedInstance.bind(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_assertThisInitialized__["a" /* default */])(_this)));
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(_this.store, "Could not find \"" + storeKey + "\" in either the context or props of " + ("\"" + displayName + "\". Either wrap the root component in a <Provider>, ") + ("or explicitly pass \"" + storeKey + "\" as a prop to \"" + displayName + "\"."));

        _this.initSelector();

        _this.initSubscription();

        return _this;
      }

      var _proto = Connect.prototype;

      _proto.getChildContext = function getChildContext() {
        var _ref3;

        // If this component received store from props, its subscription should be transparent
        // to any descendants receiving store+subscription from context; it passes along
        // subscription passed to it. Otherwise, it shadows the parent subscription, which allows
        // Connect to control ordering of notifications to flow top-down.
        var subscription = this.propsMode ? null : this.subscription;
        return _ref3 = {}, _ref3[subscriptionKey] = subscription || this.context[subscriptionKey], _ref3;
      };

      _proto.componentDidMount = function componentDidMount() {
        if (!shouldHandleStateChanges) return; // componentWillMount fires during server side rendering, but componentDidMount and
        // componentWillUnmount do not. Because of this, trySubscribe happens during ...didMount.
        // Otherwise, unsubscription would never take place during SSR, causing a memory leak.
        // To handle the case where a child component may have triggered a state change by
        // dispatching an action in its componentWillMount, we have to re-run the select and maybe
        // re-render.

        this.subscription.trySubscribe();
        this.selector.run(this.props);
        if (this.selector.shouldComponentUpdate) this.forceUpdate();
      }; // Note: this is renamed below to the UNSAFE_ version in React >=16.3.0


      _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
        this.selector.run(nextProps);
      };

      _proto.shouldComponentUpdate = function shouldComponentUpdate() {
        return this.selector.shouldComponentUpdate;
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        if (this.subscription) this.subscription.tryUnsubscribe();
        this.subscription = null;
        this.notifyNestedSubs = noop;
        this.store = null;
        this.selector.run = noop;
        this.selector.shouldComponentUpdate = false;
      };

      _proto.getWrappedInstance = function getWrappedInstance() {
        __WEBPACK_IMPORTED_MODULE_5_invariant___default()(withRef, "To access the wrapped instance, you need to specify " + ("{ withRef: true } in the options argument of the " + methodName + "() call."));
        return this.wrappedInstance;
      };

      _proto.setWrappedInstance = function setWrappedInstance(ref) {
        this.wrappedInstance = ref;
      };

      _proto.initSelector = function initSelector() {
        var sourceSelector = selectorFactory(this.store.dispatch, selectorFactoryOptions);
        this.selector = makeSelectorStateful(sourceSelector, this.store);
        this.selector.run(this.props);
      };

      _proto.initSubscription = function initSubscription() {
        if (!shouldHandleStateChanges) return; // parentSub's source should match where store came from: props vs. context. A component
        // connected to the store via props shouldn't use subscription from context, or vice versa.

        var parentSub = (this.propsMode ? this.props : this.context)[subscriptionKey];
        this.subscription = new __WEBPACK_IMPORTED_MODULE_8__utils_Subscription__["a" /* default */](this.store, parentSub, this.onStateChange.bind(this)); // `notifyNestedSubs` is duplicated to handle the case where the component is unmounted in
        // the middle of the notification loop, where `this.subscription` will then be null. An
        // extra null check every change can be avoided by copying the method onto `this` and then
        // replacing it with a no-op on unmount. This can probably be avoided if Subscription's
        // listeners logic is changed to not call listeners that have been unsubscribed in the
        // middle of the notification loop.

        this.notifyNestedSubs = this.subscription.notifyNestedSubs.bind(this.subscription);
      };

      _proto.onStateChange = function onStateChange() {
        this.selector.run(this.props);

        if (!this.selector.shouldComponentUpdate) {
          this.notifyNestedSubs();
        } else {
          this.componentDidUpdate = this.notifyNestedSubsOnComponentDidUpdate;
          this.setState(dummyState);
        }
      };

      _proto.notifyNestedSubsOnComponentDidUpdate = function notifyNestedSubsOnComponentDidUpdate() {
        // `componentDidUpdate` is conditionally implemented when `onStateChange` determines it
        // needs to notify nested subs. Once called, it unimplements itself until further state
        // changes occur. Doing it this way vs having a permanent `componentDidUpdate` that does
        // a boolean check every time avoids an extra method call most of the time, resulting
        // in some perf boost.
        this.componentDidUpdate = undefined;
        this.notifyNestedSubs();
      };

      _proto.isSubscribed = function isSubscribed() {
        return Boolean(this.subscription) && this.subscription.isSubscribed();
      };

      _proto.addExtraProps = function addExtraProps(props) {
        if (!withRef && !renderCountProp && !(this.propsMode && this.subscription)) return props; // make a shallow copy so that fields added don't leak to the original selector.
        // this is especially important for 'ref' since that's a reference back to the component
        // instance. a singleton memoized selector would then be holding a reference to the
        // instance, preventing the instance from being garbage collected, and that would be bad

        var withExtras = Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props);

        if (withRef) withExtras.ref = this.setWrappedInstance;
        if (renderCountProp) withExtras[renderCountProp] = this.renderCount++;
        if (this.propsMode && this.subscription) withExtras[subscriptionKey] = this.subscription;
        return withExtras;
      };

      _proto.render = function render() {
        var selector = this.selector;
        selector.shouldComponentUpdate = false;

        if (selector.error) {
          throw selector.error;
        } else {
          return Object(__WEBPACK_IMPORTED_MODULE_6_react__["createElement"])(WrappedComponent, this.addExtraProps(selector.props));
        }
      };

      return Connect;
    }(__WEBPACK_IMPORTED_MODULE_6_react__["Component"]);

    if (prefixUnsafeLifecycleMethods) {
      // Use UNSAFE_ event name where supported
      Connect.prototype.UNSAFE_componentWillReceiveProps = Connect.prototype.componentWillReceiveProps;
      delete Connect.prototype.componentWillReceiveProps;
    }
    /* eslint-enable react/no-deprecated */


    Connect.WrappedComponent = WrappedComponent;
    Connect.displayName = displayName;
    Connect.childContextTypes = childContextTypes;
    Connect.contextTypes = contextTypes;
    Connect.propTypes = contextTypes;

    if (false) {
      // Use UNSAFE_ event name where supported
      var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillUpdate' : 'componentWillUpdate';

      Connect.prototype[eventName] = function componentWillUpdate() {
        var _this2 = this;

        // We are hot reloading!
        if (this.version !== version) {
          this.version = version;
          this.initSelector(); // If any connected descendants don't hot reload (and resubscribe in the process), their
          // listeners will be lost when we unsubscribe. Unfortunately, by copying over all
          // listeners, this does mean that the old versions of connected descendants will still be
          // notified of state changes; however, their onStateChange function is a no-op so this
          // isn't a huge deal.

          var oldListeners = [];

          if (this.subscription) {
            oldListeners = this.subscription.listeners.get();
            this.subscription.tryUnsubscribe();
          }

          this.initSubscription();

          if (shouldHandleStateChanges) {
            this.subscription.trySubscribe();
            oldListeners.forEach(function (listener) {
              return _this2.subscription.listeners.subscribe(listener);
            });
          }
        }
      };
    }

    return __WEBPACK_IMPORTED_MODULE_4_hoist_non_react_statics___default()(Connect, WrappedComponent);
  };
}

/***/ }),
/* 217 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _typeof;
function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

/***/ }),
/* 218 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = wrapMapToPropsConstant;
/* unused harmony export getDependsOnOwnProps */
/* harmony export (immutable) */ __webpack_exports__["b"] = wrapMapToPropsFunc;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_verifyPlainObject__ = __webpack_require__(219);

function wrapMapToPropsConstant(getConstant) {
  return function initConstantSelector(dispatch, options) {
    var constant = getConstant(dispatch, options);

    function constantSelector() {
      return constant;
    }

    constantSelector.dependsOnOwnProps = false;
    return constantSelector;
  };
} // dependsOnOwnProps is used by createMapToPropsProxy to determine whether to pass props as args
// to the mapToProps function being wrapped. It is also used by makePurePropsSelector to determine
// whether mapToProps needs to be invoked when props have changed.
// 
// A length of one signals that mapToProps does not depend on props from the parent component.
// A length of zero is assumed to mean mapToProps is getting args via arguments or ...args and
// therefore not reporting its length accurately..

function getDependsOnOwnProps(mapToProps) {
  return mapToProps.dependsOnOwnProps !== null && mapToProps.dependsOnOwnProps !== undefined ? Boolean(mapToProps.dependsOnOwnProps) : mapToProps.length !== 1;
} // Used by whenMapStateToPropsIsFunction and whenMapDispatchToPropsIsFunction,
// this function wraps mapToProps in a proxy function which does several things:
// 
//  * Detects whether the mapToProps function being called depends on props, which
//    is used by selectorFactory to decide if it should reinvoke on props changes.
//    
//  * On first call, handles mapToProps if returns another function, and treats that
//    new function as the true mapToProps for subsequent calls.
//    
//  * On first call, verifies the first result is a plain object, in order to warn
//    the developer that their mapToProps function is not returning a valid result.
//    

function wrapMapToPropsFunc(mapToProps, methodName) {
  return function initProxySelector(dispatch, _ref) {
    var displayName = _ref.displayName;

    var proxy = function mapToPropsProxy(stateOrDispatch, ownProps) {
      return proxy.dependsOnOwnProps ? proxy.mapToProps(stateOrDispatch, ownProps) : proxy.mapToProps(stateOrDispatch);
    }; // allow detectFactoryAndVerify to get ownProps


    proxy.dependsOnOwnProps = true;

    proxy.mapToProps = function detectFactoryAndVerify(stateOrDispatch, ownProps) {
      proxy.mapToProps = mapToProps;
      proxy.dependsOnOwnProps = getDependsOnOwnProps(mapToProps);
      var props = proxy(stateOrDispatch, ownProps);

      if (typeof props === 'function') {
        proxy.mapToProps = props;
        proxy.dependsOnOwnProps = getDependsOnOwnProps(props);
        props = proxy(stateOrDispatch, ownProps);
      }

      if (false) verifyPlainObject(props, displayName, methodName);
      return props;
    };

    return proxy;
  };
}

/***/ }),
/* 219 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__isPlainObject__ = __webpack_require__(402);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__warning__ = __webpack_require__(142);


function verifyPlainObject(value, displayName, methodName) {
  if (!Object(__WEBPACK_IMPORTED_MODULE_0__isPlainObject__["a" /* default */])(value)) {
    Object(__WEBPACK_IMPORTED_MODULE_1__warning__["a" /* default */])(methodName + "() in " + displayName + " must return a plain object. Instead received " + value + ".");
  }
}

/***/ }),
/* 220 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(68);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }






var isModifiedEvent = function isModifiedEvent(event) {
  return !!(event.metaKey || event.altKey || event.ctrlKey || event.shiftKey);
};

/**
 * The public API for rendering a history-aware <a>.
 */

var Link = function (_React$Component) {
  _inherits(Link, _React$Component);

  function Link() {
    var _temp, _this, _ret;

    _classCallCheck(this, Link);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.handleClick = function (event) {
      if (_this.props.onClick) _this.props.onClick(event);

      if (!event.defaultPrevented && // onClick prevented default
      event.button === 0 && // ignore everything but left clicks
      !_this.props.target && // let browser handle "target=_blank" etc.
      !isModifiedEvent(event) // ignore clicks with modifier keys
      ) {
          event.preventDefault();

          var history = _this.context.router.history;
          var _this$props = _this.props,
              replace = _this$props.replace,
              to = _this$props.to;


          if (replace) {
            history.replace(to);
          } else {
            history.push(to);
          }
        }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Link.prototype.render = function render() {
    var _props = this.props,
        replace = _props.replace,
        to = _props.to,
        innerRef = _props.innerRef,
        props = _objectWithoutProperties(_props, ["replace", "to", "innerRef"]); // eslint-disable-line no-unused-vars

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Link> outside a <Router>");

    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(to !== undefined, 'You must specify the "to" property');

    var history = this.context.router.history;

    var location = typeof to === "string" ? Object(__WEBPACK_IMPORTED_MODULE_3_history__["c" /* createLocation */])(to, null, null, history.location) : to;

    var href = history.createHref(location);
    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a", _extends({}, props, { onClick: this.handleClick, href: href, ref: innerRef }));
  };

  return Link;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Link.propTypes = {
  onClick: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  target: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired,
  innerRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func])
};
Link.defaultProps = {
  replace: false
};
Link.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      createHref: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Link);

/***/ }),
/* 221 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(112);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that stores location in memory.
 */

var MemoryRouter = function (_React$Component) {
  _inherits(MemoryRouter, _React$Component);

  function MemoryRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, MemoryRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["d" /* createMemoryHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  MemoryRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<MemoryRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { MemoryRouter as Router }`.");
  };

  MemoryRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return MemoryRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

MemoryRouter.propTypes = {
  initialEntries: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,
  initialIndex: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (MemoryRouter);

/***/ }),
/* 222 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__ = __webpack_require__(144);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Route__["a" /* default */]);

/***/ }),
/* 223 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_invariant__);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }





/**
 * The public API for prompting the user before navigating away
 * from a screen with a component.
 */

var Prompt = function (_React$Component) {
  _inherits(Prompt, _React$Component);

  function Prompt() {
    _classCallCheck(this, Prompt);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Prompt.prototype.enable = function enable(message) {
    if (this.unblock) this.unblock();

    this.unblock = this.context.router.history.block(message);
  };

  Prompt.prototype.disable = function disable() {
    if (this.unblock) {
      this.unblock();
      this.unblock = null;
    }
  };

  Prompt.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_2_invariant___default()(this.context.router, "You should not use <Prompt> outside a <Router>");

    if (this.props.when) this.enable(this.props.message);
  };

  Prompt.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    if (nextProps.when) {
      if (!this.props.when || this.props.message !== nextProps.message) this.enable(nextProps.message);
    } else {
      this.disable();
    }
  };

  Prompt.prototype.componentWillUnmount = function componentWillUnmount() {
    this.disable();
  };

  Prompt.prototype.render = function render() {
    return null;
  };

  return Prompt;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Prompt.propTypes = {
  when: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  message: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string]).isRequired
};
Prompt.defaultProps = {
  when: true
};
Prompt.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      block: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Prompt);

/***/ }),
/* 224 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__generatePath__ = __webpack_require__(146);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








/**
 * The public API for updating the location programmatically
 * with a component.
 */

var Redirect = function (_React$Component) {
  _inherits(Redirect, _React$Component);

  function Redirect() {
    _classCallCheck(this, Redirect);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Redirect.prototype.isStatic = function isStatic() {
    return this.context.router && this.context.router.staticContext;
  };

  Redirect.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Redirect> outside a <Router>");

    if (this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidMount = function componentDidMount() {
    if (!this.isStatic()) this.perform();
  };

  Redirect.prototype.componentDidUpdate = function componentDidUpdate(prevProps) {
    var prevTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(prevProps.to);
    var nextTo = Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(this.props.to);

    if (Object(__WEBPACK_IMPORTED_MODULE_4_history__["f" /* locationsAreEqual */])(prevTo, nextTo)) {
      __WEBPACK_IMPORTED_MODULE_2_warning___default()(false, "You tried to redirect to the same route you're currently on: " + ("\"" + nextTo.pathname + nextTo.search + "\""));
      return;
    }

    this.perform();
  };

  Redirect.prototype.computeTo = function computeTo(_ref) {
    var computedMatch = _ref.computedMatch,
        to = _ref.to;

    if (computedMatch) {
      if (typeof to === "string") {
        return Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to, computedMatch.params);
      } else {
        return _extends({}, to, {
          pathname: Object(__WEBPACK_IMPORTED_MODULE_5__generatePath__["a" /* default */])(to.pathname, computedMatch.params)
        });
      }
    }

    return to;
  };

  Redirect.prototype.perform = function perform() {
    var history = this.context.router.history;
    var push = this.props.push;

    var to = this.computeTo(this.props);

    if (push) {
      history.push(to);
    } else {
      history.replace(to);
    }
  };

  Redirect.prototype.render = function render() {
    return null;
  };

  return Redirect;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Redirect.propTypes = {
  computedMatch: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object, // private, from <Switch>
  push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  from: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  to: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object]).isRequired
};
Redirect.defaultProps = {
  push: false
};
Redirect.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    history: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
      push: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired,
      replace: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired
    }).isRequired,
    staticContext: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
  }).isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (Redirect);

/***/ }),
/* 225 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_history__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__Router__ = __webpack_require__(112);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }








var addLeadingSlash = function addLeadingSlash(path) {
  return path.charAt(0) === "/" ? path : "/" + path;
};

var addBasename = function addBasename(basename, location) {
  if (!basename) return location;

  return _extends({}, location, {
    pathname: addLeadingSlash(basename) + location.pathname
  });
};

var stripBasename = function stripBasename(basename, location) {
  if (!basename) return location;

  var base = addLeadingSlash(basename);

  if (location.pathname.indexOf(base) !== 0) return location;

  return _extends({}, location, {
    pathname: location.pathname.substr(base.length)
  });
};

var createURL = function createURL(location) {
  return typeof location === "string" ? location : Object(__WEBPACK_IMPORTED_MODULE_4_history__["e" /* createPath */])(location);
};

var staticHandler = function staticHandler(methodName) {
  return function () {
    __WEBPACK_IMPORTED_MODULE_1_invariant___default()(false, "You cannot %s with <StaticRouter>", methodName);
  };
};

var noop = function noop() {};

/**
 * The public top-level API for a "static" <Router>, so-called because it
 * can't actually change the current location. Instead, it just records
 * location changes in a context object. Useful mainly in testing and
 * server-rendering scenarios.
 */

var StaticRouter = function (_React$Component) {
  _inherits(StaticRouter, _React$Component);

  function StaticRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, StaticRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.createHref = function (path) {
      return addLeadingSlash(_this.props.basename + createURL(path));
    }, _this.handlePush = function (location) {
      var _this$props = _this.props,
          basename = _this$props.basename,
          context = _this$props.context;

      context.action = "PUSH";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleReplace = function (location) {
      var _this$props2 = _this.props,
          basename = _this$props2.basename,
          context = _this$props2.context;

      context.action = "REPLACE";
      context.location = addBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location));
      context.url = createURL(context.location);
    }, _this.handleListen = function () {
      return noop;
    }, _this.handleBlock = function () {
      return noop;
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  StaticRouter.prototype.getChildContext = function getChildContext() {
    return {
      router: {
        staticContext: this.props.context
      }
    };
  };

  StaticRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<StaticRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { StaticRouter as Router }`.");
  };

  StaticRouter.prototype.render = function render() {
    var _props = this.props,
        basename = _props.basename,
        context = _props.context,
        location = _props.location,
        props = _objectWithoutProperties(_props, ["basename", "context", "location"]);

    var history = {
      createHref: this.createHref,
      action: "POP",
      location: stripBasename(basename, Object(__WEBPACK_IMPORTED_MODULE_4_history__["c" /* createLocation */])(location)),
      push: this.handlePush,
      replace: this.handleReplace,
      go: staticHandler("go"),
      goBack: staticHandler("goBack"),
      goForward: staticHandler("goForward"),
      listen: this.handleListen,
      block: this.handleBlock
    };

    return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__Router__["a" /* default */], _extends({}, props, { history: history }));
  };

  return StaticRouter;
}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component);

StaticRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,
  context: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired,
  location: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object])
};
StaticRouter.defaultProps = {
  basename: "",
  location: "/"
};
StaticRouter.childContextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.object.isRequired
};


/* harmony default export */ __webpack_exports__["a"] = (StaticRouter);

/***/ }),
/* 226 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant__ = __webpack_require__(35);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_invariant___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_invariant__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__matchPath__ = __webpack_require__(113);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for rendering the first <Route> that matches.
 */

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_3_invariant___default()(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    __WEBPACK_IMPORTED_MODULE_2_warning___default()(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (element) {
      if (match == null && __WEBPACK_IMPORTED_MODULE_0_react___default.a.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = Object(__WEBPACK_IMPORTED_MODULE_4__matchPath__["a" /* default */])(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

Switch.contextTypes = {
  router: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.shape({
    route: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.node,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object
};


/* harmony default export */ __webpack_exports__["a"] = (Switch);

/***/ }),
/* 227 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__ = __webpack_require__(228);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(144);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A public higher-order component to access the imperative API
 */
var withRouter = function withRouter(Component) {
  var C = function C(props) {
    var wrappedComponentRef = props.wrappedComponentRef,
        remainingProps = _objectWithoutProperties(props, ["wrappedComponentRef"]);

    return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Route__["a" /* default */], {
      children: function children(routeComponentProps) {
        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component, _extends({}, remainingProps, routeComponentProps, {
          ref: wrappedComponentRef
        }));
      }
    });
  };

  C.displayName = "withRouter(" + (Component.displayName || Component.name) + ")";
  C.WrappedComponent = Component;
  C.propTypes = {
    wrappedComponentRef: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func
  };

  return __WEBPACK_IMPORTED_MODULE_2_hoist_non_react_statics___default()(C, Component);
};

/* harmony default export */ __webpack_exports__["a"] = (withRouter);

/***/ }),
/* 228 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
    childContextTypes: true,
    contextTypes: true,
    defaultProps: true,
    displayName: true,
    getDefaultProps: true,
    getDerivedStateFromProps: true,
    mixins: true,
    propTypes: true,
    type: true
};

var KNOWN_STATICS = {
    name: true,
    length: true,
    prototype: true,
    caller: true,
    callee: true,
    arguments: true,
    arity: true
};

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = getPrototypeOf && getPrototypeOf(Object);

function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
    if (typeof sourceComponent !== 'string') { // don't hoist over string (html) components

        if (objectPrototype) {
            var inheritedComponent = getPrototypeOf(sourceComponent);
            if (inheritedComponent && inheritedComponent !== objectPrototype) {
                hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
            }
        }

        var keys = getOwnPropertyNames(sourceComponent);

        if (getOwnPropertySymbols) {
            keys = keys.concat(getOwnPropertySymbols(sourceComponent));
        }

        for (var i = 0; i < keys.length; ++i) {
            var key = keys[i];
            if (!REACT_STATICS[key] && !KNOWN_STATICS[key] && (!blacklist || !blacklist[key])) {
                var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
                try { // Avoid failures from read-only properties
                    defineProperty(targetComponent, key, descriptor);
                } catch (e) {}
            }
        }

        return targetComponent;
    }

    return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 229 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__matchRoutes__ = __webpack_require__(423);
/* unused harmony reexport matchRoutes */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__renderRoutes__ = __webpack_require__(425);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_1__renderRoutes__["a"]; });





/***/ }),
/* 230 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Image; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp2;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var noImageAvailable=Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* assetsPath */])("phuket-laguna-village-residences")+"/images/No_Image_Available.jpg";var Image=(_temp2=_class=function(_PureComponent){_inherits(Image,_PureComponent);function Image(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Image);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Image.__proto__||Object.getPrototypeOf(Image)).call.apply(_ref,[this].concat(args))),_this),_this.state={src:noImageAvailable},_this.handleError=function(){_this.setState({src:noImageAvailable});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Image,[{key:"componentWillMount",value:function componentWillMount(){this.setState({src:this.props.src||noImageAvailable});}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){if(this.props.src!==nextProps.src){this.setState({src:nextProps.src||noImageAvailable});}}},{key:"render",value:function render(){var src=this.state.src;var alt=this.props.alt;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",Object.assign({},this.props,{src:src,alt:alt,onError:this.handleError}));}}]);return Image;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]),_class.propTypes={src:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,alt:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string},_class.defaultProps={src:noImageAvailable,alt:"Laguna"},_temp2);

/***/ }),
/* 231 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

module.exports = freeGlobal;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29)))

/***/ }),
/* 232 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var funcProto = Function.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/**
 * Converts `func` to its source code.
 *
 * @private
 * @param {Function} func The function to convert.
 * @returns {string} Returns the source code.
 */
function toSource(func) {
  if (func != null) {
    try {
      return funcToString.call(func);
    } catch (e) {}
    try {
      return (func + '');
    } catch (e) {}
  }
  return '';
}

module.exports = toSource;


/***/ }),
/* 233 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(234),
    arraySome = __webpack_require__(462),
    cacheHas = __webpack_require__(235);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * A specialized version of `baseIsEqualDeep` for arrays with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Array} array The array to compare.
 * @param {Array} other The other array to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `array` and `other` objects.
 * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
 */
function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      arrLength = array.length,
      othLength = other.length;

  if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
    return false;
  }
  // Check that cyclic values are equal.
  var arrStacked = stack.get(array);
  var othStacked = stack.get(other);
  if (arrStacked && othStacked) {
    return arrStacked == other && othStacked == array;
  }
  var index = -1,
      result = true,
      seen = (bitmask & COMPARE_UNORDERED_FLAG) ? new SetCache : undefined;

  stack.set(array, other);
  stack.set(other, array);

  // Ignore non-index properties.
  while (++index < arrLength) {
    var arrValue = array[index],
        othValue = other[index];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, arrValue, index, other, array, stack)
        : customizer(arrValue, othValue, index, array, other, stack);
    }
    if (compared !== undefined) {
      if (compared) {
        continue;
      }
      result = false;
      break;
    }
    // Recursively compare arrays (susceptible to call stack limits).
    if (seen) {
      if (!arraySome(other, function(othValue, othIndex) {
            if (!cacheHas(seen, othIndex) &&
                (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
        result = false;
        break;
      }
    } else if (!(
          arrValue === othValue ||
            equalFunc(arrValue, othValue, bitmask, customizer, stack)
        )) {
      result = false;
      break;
    }
  }
  stack['delete'](array);
  stack['delete'](other);
  return result;
}

module.exports = equalArrays;


/***/ }),
/* 234 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(150),
    setCacheAdd = __webpack_require__(460),
    setCacheHas = __webpack_require__(461);

/**
 *
 * Creates an array cache object to store unique values.
 *
 * @private
 * @constructor
 * @param {Array} [values] The values to cache.
 */
function SetCache(values) {
  var index = -1,
      length = values == null ? 0 : values.length;

  this.__data__ = new MapCache;
  while (++index < length) {
    this.add(values[index]);
  }
}

// Add methods to `SetCache`.
SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
SetCache.prototype.has = setCacheHas;

module.exports = SetCache;


/***/ }),
/* 235 */
/***/ (function(module, exports) {

/**
 * Checks if a `cache` value for `key` exists.
 *
 * @private
 * @param {Object} cache The cache to query.
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function cacheHas(cache, key) {
  return cache.has(key);
}

module.exports = cacheHas;


/***/ }),
/* 236 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(40);

/** Built-in value references. */
var Uint8Array = root.Uint8Array;

module.exports = Uint8Array;


/***/ }),
/* 237 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetAllKeys = __webpack_require__(238),
    getSymbols = __webpack_require__(154),
    keys = __webpack_require__(59);

/**
 * Creates an array of own enumerable property names and symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names and symbols.
 */
function getAllKeys(object) {
  return baseGetAllKeys(object, keys, getSymbols);
}

module.exports = getAllKeys;


/***/ }),
/* 238 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(153),
    isArray = __webpack_require__(13);

/**
 * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
 * `keysFunc` and `symbolsFunc` to get the enumerable property names and
 * symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @param {Function} symbolsFunc The function to get the symbols of `object`.
 * @returns {Array} Returns the array of property names and symbols.
 */
function baseGetAllKeys(object, keysFunc, symbolsFunc) {
  var result = keysFunc(object);
  return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
}

module.exports = baseGetAllKeys;


/***/ }),
/* 239 */
/***/ (function(module, exports) {

/**
 * This method returns a new empty array.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {Array} Returns the new empty array.
 * @example
 *
 * var arrays = _.times(2, _.stubArray);
 *
 * console.log(arrays);
 * // => [[], []]
 *
 * console.log(arrays[0] === arrays[1]);
 * // => false
 */
function stubArray() {
  return [];
}

module.exports = stubArray;


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {

var baseTimes = __webpack_require__(466),
    isArguments = __webpack_require__(92),
    isArray = __webpack_require__(13),
    isBuffer = __webpack_require__(93),
    isIndex = __webpack_require__(94),
    isTypedArray = __webpack_require__(120);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates an array of the enumerable property names of the array-like `value`.
 *
 * @private
 * @param {*} value The value to query.
 * @param {boolean} inherited Specify returning inherited property names.
 * @returns {Array} Returns the array of property names.
 */
function arrayLikeKeys(value, inherited) {
  var isArr = isArray(value),
      isArg = !isArr && isArguments(value),
      isBuff = !isArr && !isArg && isBuffer(value),
      isType = !isArr && !isArg && !isBuff && isTypedArray(value),
      skipIndexes = isArr || isArg || isBuff || isType,
      result = skipIndexes ? baseTimes(value.length, String) : [],
      length = result.length;

  for (var key in value) {
    if ((inherited || hasOwnProperty.call(value, key)) &&
        !(skipIndexes && (
           // Safari 9 has enumerable `arguments.length` in strict mode.
           key == 'length' ||
           // Node.js 0.10 has enumerable non-index properties on buffers.
           (isBuff && (key == 'offset' || key == 'parent')) ||
           // PhantomJS 2 has enumerable non-index properties on typed arrays.
           (isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset')) ||
           // Skip index properties.
           isIndex(key, length)
        ))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = arrayLikeKeys;


/***/ }),
/* 241 */
/***/ (function(module, exports) {

/**
 * Creates a unary function that invokes `func` with its argument transformed.
 *
 * @private
 * @param {Function} func The function to wrap.
 * @param {Function} transform The argument transform.
 * @returns {Function} Returns the new function.
 */
function overArg(func, transform) {
  return function(arg) {
    return func(transform(arg));
  };
}

module.exports = overArg;


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(58),
    root = __webpack_require__(40);

/* Built-in method references that are verified to be native. */
var Set = getNative(root, 'Set');

module.exports = Set;


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(31);

/**
 * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` if suitable for strict
 *  equality comparisons, else `false`.
 */
function isStrictComparable(value) {
  return value === value && !isObject(value);
}

module.exports = isStrictComparable;


/***/ }),
/* 244 */
/***/ (function(module, exports) {

/**
 * A specialized version of `matchesProperty` for source values suitable
 * for strict equality comparisons, i.e. `===`.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function matchesStrictComparable(key, srcValue) {
  return function(object) {
    if (object == null) {
      return false;
    }
    return object[key] === srcValue &&
      (srcValue !== undefined || (key in Object(object)));
  };
}

module.exports = matchesStrictComparable;


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {

var MapCache = __webpack_require__(150);

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that memoizes the result of `func`. If `resolver` is
 * provided, it determines the cache key for storing the result based on the
 * arguments provided to the memoized function. By default, the first argument
 * provided to the memoized function is used as the map cache key. The `func`
 * is invoked with the `this` binding of the memoized function.
 *
 * **Note:** The cache is exposed as the `cache` property on the memoized
 * function. Its creation may be customized by replacing the `_.memoize.Cache`
 * constructor with one whose instances implement the
 * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
 * method interface of `clear`, `delete`, `get`, `has`, and `set`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to have its output memoized.
 * @param {Function} [resolver] The function to resolve the cache key.
 * @returns {Function} Returns the new memoized function.
 * @example
 *
 * var object = { 'a': 1, 'b': 2 };
 * var other = { 'c': 3, 'd': 4 };
 *
 * var values = _.memoize(_.values);
 * values(object);
 * // => [1, 2]
 *
 * values(other);
 * // => [3, 4]
 *
 * object.a = 2;
 * values(object);
 * // => [1, 2]
 *
 * // Modify the result cache.
 * values.cache.set(object, ['a', 'b']);
 * values(object);
 * // => ['a', 'b']
 *
 * // Replace `_.memoize.Cache`.
 * _.memoize.Cache = WeakMap;
 */
function memoize(func, resolver) {
  if (typeof func != 'function' || (resolver != null && typeof resolver != 'function')) {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  var memoized = function() {
    var args = arguments,
        key = resolver ? resolver.apply(this, args) : args[0],
        cache = memoized.cache;

    if (cache.has(key)) {
      return cache.get(key);
    }
    var result = func.apply(this, args);
    memoized.cache = cache.set(key, result) || cache;
    return result;
  };
  memoized.cache = new (memoize.Cache || MapCache);
  return memoized;
}

// Expose `MapCache`.
memoize.Cache = MapCache;

module.exports = memoize;


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {

var baseHasIn = __webpack_require__(478),
    hasPath = __webpack_require__(247);

/**
 * Checks if `path` is a direct or inherited property of `object`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.hasIn(object, 'a');
 * // => true
 *
 * _.hasIn(object, 'a.b');
 * // => true
 *
 * _.hasIn(object, ['a', 'b']);
 * // => true
 *
 * _.hasIn(object, 'b');
 * // => false
 */
function hasIn(object, path) {
  return object != null && hasPath(object, path, baseHasIn);
}

module.exports = hasIn;


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(73),
    isArguments = __webpack_require__(92),
    isArray = __webpack_require__(13),
    isIndex = __webpack_require__(94),
    isLength = __webpack_require__(156),
    toKey = __webpack_require__(75);

/**
 * Checks if `path` exists on `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @param {Function} hasFunc The function to check properties.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 */
function hasPath(object, path, hasFunc) {
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      result = false;

  while (++index < length) {
    var key = toKey(path[index]);
    if (!(result = object != null && hasFunc(object, key))) {
      break;
    }
    object = object[key];
  }
  if (result || ++index != length) {
    return result;
  }
  length = object == null ? 0 : object.length;
  return !!length && isLength(length) && isIndex(key, length) &&
    (isArray(object) || isArguments(object));
}

module.exports = hasPath;


/***/ }),
/* 248 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.property` without support for deep paths.
 *
 * @private
 * @param {string} key The key of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function baseProperty(key) {
  return function(object) {
    return object == null ? undefined : object[key];
  };
}

module.exports = baseProperty;


/***/ }),
/* 249 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(123),
    isArrayLike = __webpack_require__(41);

/**
 * The base implementation of `_.map` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the new mapped array.
 */
function baseMap(collection, iteratee) {
  var index = -1,
      result = isArrayLike(collection) ? Array(collection.length) : [];

  baseEach(collection, function(value, key, collection) {
    result[++index] = iteratee(value, key, collection);
  });
  return result;
}

module.exports = baseMap;


/***/ }),
/* 250 */
/***/ (function(module, exports, __webpack_require__) {

var createBaseFor = __webpack_require__(482);

/**
 * The base implementation of `baseForOwn` which iterates over `object`
 * properties returned by `keysFunc` and invokes `iteratee` for each property.
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {Function} keysFunc The function to get the keys of `object`.
 * @returns {Object} Returns `object`.
 */
var baseFor = createBaseFor();

module.exports = baseFor;


/***/ }),
/* 251 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.slice` without an iteratee call guard.
 *
 * @private
 * @param {Array} array The array to slice.
 * @param {number} [start=0] The start position.
 * @param {number} [end=array.length] The end position.
 * @returns {Array} Returns the slice of `array`.
 */
function baseSlice(array, start, end) {
  var index = -1,
      length = array.length;

  if (start < 0) {
    start = -start > length ? 0 : (length + start);
  }
  end = end > length ? length : end;
  if (end < 0) {
    end += length;
  }
  length = start > end ? 0 : ((end - start) >>> 0);
  start >>>= 0;

  var result = Array(length);
  while (++index < length) {
    result[index] = array[index + start];
  }
  return result;
}

module.exports = baseSlice;


/***/ }),
/* 252 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LanguageSwitcher; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_replace__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_replace___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_replace__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_dom__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hoc__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_class2,_temp2;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var mapStateToProps=function mapStateToProps(_ref){var language=_ref.language;return{currentLanguage:language.currentActive,languages:language.languages};};var actionToProps={};var LanguageSwitcher=(_dec=Object(__WEBPACK_IMPORTED_MODULE_5__hoc__["b" /* withRedux */])(mapStateToProps,actionToProps),Object(__WEBPACK_IMPORTED_MODULE_4_react_router_dom__["d" /* withRouter */])(_class=_dec(_class=(_temp2=_class2=function(_React$Component){_inherits(LanguageSwitcher,_React$Component);function LanguageSwitcher(){var _ref2;var _temp,_this,_ret;_classCallCheck(this,LanguageSwitcher);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref2=LanguageSwitcher.__proto__||Object.getPrototypeOf(LanguageSwitcher)).call.apply(_ref2,[this].concat(args))),_this),_this.switchLanguage=function(language){var currentLanguage=_this.props.currentLanguage;var pathname=_this.props.location.pathname;var nextUrl=__WEBPACK_IMPORTED_MODULE_1_lodash_replace___default()(pathname,"/"+currentLanguage+"/","/"+language+"/");_this.props.history.push(nextUrl);},_this.handleSwitchLanguage=function(language){var currentLanguage=_this.props.currentLanguage;if(currentLanguage!==language){_this.switchLanguage(language);}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(LanguageSwitcher,[{key:"render",value:function render(){var _this2=this;var _props=this.props,languages=_props.languages,currentLanguage=_props.currentLanguage;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_lodash_map___default()(languages,function(language,key){if(language.key===currentLanguage){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{className:"contaienr-language-switcher",key:key},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("a",{className:"language-text"},language.name,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("img",{className:"language-icon-img",src:language.icon,alt:language.key})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("ul",{className:"language-switcher-mobile"},__WEBPACK_IMPORTED_MODULE_0_lodash_map___default()(languages,function(language){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("li",{key:language.key,onClick:function onClick(){return _this2.handleSwitchLanguage(language.key);}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("img",{className:"language-icon-img",src:language.icon,alt:language.key}));})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("ul",{className:"language-switcher"},__WEBPACK_IMPORTED_MODULE_0_lodash_map___default()(languages,function(language){var languageActive=language.key===currentLanguage?"active":"";return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("li",{key:language.key,className:"item "+languageActive},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("a",{className:"language-switcher-text",role:"button",tabIndex:"0",onClick:function onClick(){return _this2.handleSwitchLanguage(language.key);},onKeyPress:function onKeyPress(){return _this2.handleSwitchLanguage(language.key);}},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("img",{className:"language-icon-img",src:language.icon,alt:language.key}),language.name));})));}}));}}]);return LanguageSwitcher;}(__WEBPACK_IMPORTED_MODULE_2_react___default.a.Component),_class2.propTypes={languages:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape({key:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,name:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired})).isRequired,currentLanguage:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string.isRequired,actions:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.shape().isRequired},_temp2))||_class)||_class);

/***/ }),
/* 253 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.findIndex` and `_.findLastIndex` without
 * support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} predicate The function invoked per iteration.
 * @param {number} fromIndex The index to search from.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseFindIndex(array, predicate, fromIndex, fromRight) {
  var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);

  while ((fromRight ? index-- : ++index < length)) {
    if (predicate(array[index], index, array)) {
      return index;
    }
  }
  return -1;
}

module.exports = baseFindIndex;


/***/ }),
/* 254 */
/***/ (function(module, exports, __webpack_require__) {

var toNumber = __webpack_require__(160);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0,
    MAX_INTEGER = 1.7976931348623157e+308;

/**
 * Converts `value` to a finite number.
 *
 * @static
 * @memberOf _
 * @since 4.12.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {number} Returns the converted number.
 * @example
 *
 * _.toFinite(3.2);
 * // => 3.2
 *
 * _.toFinite(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toFinite(Infinity);
 * // => 1.7976931348623157e+308
 *
 * _.toFinite('3.2');
 * // => 3.2
 */
function toFinite(value) {
  if (!value) {
    return value === 0 ? value : 0;
  }
  value = toNumber(value);
  if (value === INFINITY || value === -INFINITY) {
    var sign = (value < 0 ? -1 : 1);
    return sign * MAX_INTEGER;
  }
  return value === value ? value : 0;
}

module.exports = toFinite;


/***/ }),
/* 255 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__en_default_json__ = __webpack_require__(494);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__en_default_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__en_default_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cn_default_json__ = __webpack_require__(495);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__cn_default_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__cn_default_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ru_default_json__ = __webpack_require__(496);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__ru_default_json___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__ru_default_json__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_images_language_en_png__ = __webpack_require__(497);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_images_language_en_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_images_language_en_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_images_language_cn_png__ = __webpack_require__(498);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_images_language_cn_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_images_language_cn_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_images_language_ru_png__ = __webpack_require__(499);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_images_language_ru_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_images_language_ru_png__);
var locales={defaultLanguage:"en",languages:[{key:"en",icon:__WEBPACK_IMPORTED_MODULE_3__components_images_language_en_png___default.a,name:"English",data:__WEBPACK_IMPORTED_MODULE_0__en_default_json___default.a},{key:"cn",icon:__WEBPACK_IMPORTED_MODULE_4__components_images_language_cn_png___default.a,name:"中文",data:__WEBPACK_IMPORTED_MODULE_1__cn_default_json___default.a},{key:"ru",icon:__WEBPACK_IMPORTED_MODULE_5__components_images_language_ru_png___default.a,name:"РУССКИЙ",data:__WEBPACK_IMPORTED_MODULE_2__ru_default_json___default.a}]};/* harmony default export */ __webpack_exports__["a"] = (locales);

/***/ }),
/* 256 */
/***/ (function(module, exports, __webpack_require__) {

var castPath = __webpack_require__(73),
    last = __webpack_require__(166),
    parent = __webpack_require__(503),
    toKey = __webpack_require__(75);

/**
 * The base implementation of `_.unset`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The property path to unset.
 * @returns {boolean} Returns `true` if the property is deleted, else `false`.
 */
function baseUnset(object, path) {
  path = castPath(path, object);
  object = parent(object, path);
  return object == null || delete object[toKey(last(path))];
}

module.exports = baseUnset;


/***/ }),
/* 257 */
/***/ (function(module, exports, __webpack_require__) {

var baseFindIndex = __webpack_require__(253),
    baseIsNaN = __webpack_require__(504),
    strictIndexOf = __webpack_require__(505);

/**
 * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function baseIndexOf(array, value, fromIndex) {
  return value === value
    ? strictIndexOf(array, value, fromIndex)
    : baseFindIndex(array, baseIsNaN, fromIndex);
}

module.exports = baseIndexOf;


/***/ }),
/* 258 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(48),
    isArray = __webpack_require__(13),
    isObjectLike = __webpack_require__(26);

/** `Object#toString` result references. */
var stringTag = '[object String]';

/**
 * Checks if `value` is classified as a `String` primitive or object.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a string, else `false`.
 * @example
 *
 * _.isString('abc');
 * // => true
 *
 * _.isString(1);
 * // => false
 */
function isString(value) {
  return typeof value == 'string' ||
    (!isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag);
}

module.exports = isString;


/***/ }),
/* 259 */
/***/ (function(module, exports, __webpack_require__) {

var basePick = __webpack_require__(509),
    flatRest = __webpack_require__(263);

/**
 * Creates an object composed of the picked `object` properties.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to pick.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pick(object, ['a', 'c']);
 * // => { 'a': 1, 'c': 3 }
 */
var pick = flatRest(function(object, paths) {
  return object == null ? {} : basePick(object, paths);
});

module.exports = pick;


/***/ }),
/* 260 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(96),
    baseSet = __webpack_require__(261),
    castPath = __webpack_require__(73);

/**
 * The base implementation of  `_.pickBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @param {Function} predicate The function invoked per property.
 * @returns {Object} Returns the new object.
 */
function basePickBy(object, paths, predicate) {
  var index = -1,
      length = paths.length,
      result = {};

  while (++index < length) {
    var path = paths[index],
        value = baseGet(object, path);

    if (predicate(value, path)) {
      baseSet(result, castPath(path, object), value);
    }
  }
  return result;
}

module.exports = basePickBy;


/***/ }),
/* 261 */
/***/ (function(module, exports, __webpack_require__) {

var assignValue = __webpack_require__(169),
    castPath = __webpack_require__(73),
    isIndex = __webpack_require__(94),
    isObject = __webpack_require__(31),
    toKey = __webpack_require__(75);

/**
 * The base implementation of `_.set`.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @param {Function} [customizer] The function to customize path creation.
 * @returns {Object} Returns `object`.
 */
function baseSet(object, path, value, customizer) {
  if (!isObject(object)) {
    return object;
  }
  path = castPath(path, object);

  var index = -1,
      length = path.length,
      lastIndex = length - 1,
      nested = object;

  while (nested != null && ++index < length) {
    var key = toKey(path[index]),
        newValue = value;

    if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
      return object;
    }

    if (index != lastIndex) {
      var objValue = nested[key];
      newValue = customizer ? customizer(objValue, key, nested) : undefined;
      if (newValue === undefined) {
        newValue = isObject(objValue)
          ? objValue
          : (isIndex(path[index + 1]) ? [] : {});
      }
    }
    assignValue(nested, key, newValue);
    nested = nested[key];
  }
  return object;
}

module.exports = baseSet;


/***/ }),
/* 262 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(58);

var defineProperty = (function() {
  try {
    var func = getNative(Object, 'defineProperty');
    func({}, '', {});
    return func;
  } catch (e) {}
}());

module.exports = defineProperty;


/***/ }),
/* 263 */
/***/ (function(module, exports, __webpack_require__) {

var flatten = __webpack_require__(510),
    overRest = __webpack_require__(265),
    setToString = __webpack_require__(266);

/**
 * A specialized version of `baseRest` which flattens the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @returns {Function} Returns the new function.
 */
function flatRest(func) {
  return setToString(overRest(func, undefined, flatten), func + '');
}

module.exports = flatRest;


/***/ }),
/* 264 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(153),
    isFlattenable = __webpack_require__(511);

/**
 * The base implementation of `_.flatten` with support for restricting flattening.
 *
 * @private
 * @param {Array} array The array to flatten.
 * @param {number} depth The maximum recursion depth.
 * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
 * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
 * @param {Array} [result=[]] The initial result value.
 * @returns {Array} Returns the new flattened array.
 */
function baseFlatten(array, depth, predicate, isStrict, result) {
  var index = -1,
      length = array.length;

  predicate || (predicate = isFlattenable);
  result || (result = []);

  while (++index < length) {
    var value = array[index];
    if (depth > 0 && predicate(value)) {
      if (depth > 1) {
        // Recursively flatten arrays (susceptible to call stack limits).
        baseFlatten(value, depth - 1, predicate, isStrict, result);
      } else {
        arrayPush(result, value);
      }
    } else if (!isStrict) {
      result[result.length] = value;
    }
  }
  return result;
}

module.exports = baseFlatten;


/***/ }),
/* 265 */
/***/ (function(module, exports, __webpack_require__) {

var apply = __webpack_require__(512);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max;

/**
 * A specialized version of `baseRest` which transforms the rest array.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @param {Function} transform The rest array transform.
 * @returns {Function} Returns the new function.
 */
function overRest(func, start, transform) {
  start = nativeMax(start === undefined ? (func.length - 1) : start, 0);
  return function() {
    var args = arguments,
        index = -1,
        length = nativeMax(args.length - start, 0),
        array = Array(length);

    while (++index < length) {
      array[index] = args[start + index];
    }
    index = -1;
    var otherArgs = Array(start + 1);
    while (++index < start) {
      otherArgs[index] = args[index];
    }
    otherArgs[start] = transform(array);
    return apply(func, this, otherArgs);
  };
}

module.exports = overRest;


/***/ }),
/* 266 */
/***/ (function(module, exports, __webpack_require__) {

var baseSetToString = __webpack_require__(513),
    shortOut = __webpack_require__(515);

/**
 * Sets the `toString` method of `func` to return `string`.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var setToString = shortOut(baseSetToString);

module.exports = setToString;


/***/ }),
/* 267 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MySlider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isEmpty__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_slick__ = __webpack_require__(521);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_slick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_slick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_icons_ArrowLeft__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_icons_ArrowRight__ = __webpack_require__(103);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var createArrowButton=function createArrowButton(direction){return function(props){var className=props.className,style=props.style,onClick=props.onClick;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("button",{className:className,style:style,onClick:onClick},direction==='left'?__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_icons_ArrowLeft__["a" /* default */],{width:50,fill:"white"}):__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_icons_ArrowRight__["a" /* default */],{width:50,fill:"white"}));};};var NextButton=createArrowButton('right');var PrevButton=createArrowButton('left');var MySlider=(_temp=_class=function(_PureComponent){_inherits(MySlider,_PureComponent);function MySlider(){_classCallCheck(this,MySlider);return _possibleConstructorReturn(this,(MySlider.__proto__||Object.getPrototypeOf(MySlider)).apply(this,arguments));}_createClass(MySlider,[{key:"render",value:function render(){var _props=this.props,sliderRef=_props.sliderRef,items=_props.items,uiRenderer=_props.uiRenderer,settings=_props.settings,type=_props.type;var options=Object.assign({autoplay:true,autoplaySpeed:5000,speed:2000,dots:false,infinite:true,arrows:true,nextArrow:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(NextButton,null),prevArrow:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(PrevButton,null),fade:true,pauseOnHover:false},settings);if(__WEBPACK_IMPORTED_MODULE_1_lodash_isEmpty___default()(items))return null;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_slick___default.a,Object.assign({ref:sliderRef},options,{className:type}),__WEBPACK_IMPORTED_MODULE_0_lodash_map___default()(items,function(item,index){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{key:index},uiRenderer(item,index));}));}}]);return MySlider;}(__WEBPACK_IMPORTED_MODULE_2_react__["PureComponent"]),_class.propTypes={type:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string},_class.defaultProps={type:""},_temp);

/***/ }),
/* 268 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/**
 * A collection of shims that provide minimal functionality of the ES6 collections.
 *
 * These implementations are not meant to be used outside of the ResizeObserver
 * modules as they cover only a limited range of use cases.
 */
/* eslint-disable require-jsdoc, valid-jsdoc */
var MapShim = (function () {
    if (typeof Map !== 'undefined') {
        return Map;
    }
    /**
     * Returns index in provided array that matches the specified key.
     *
     * @param {Array<Array>} arr
     * @param {*} key
     * @returns {number}
     */
    function getIndex(arr, key) {
        var result = -1;
        arr.some(function (entry, index) {
            if (entry[0] === key) {
                result = index;
                return true;
            }
            return false;
        });
        return result;
    }
    return /** @class */ (function () {
        function class_1() {
            this.__entries__ = [];
        }
        Object.defineProperty(class_1.prototype, "size", {
            /**
             * @returns {boolean}
             */
            get: function () {
                return this.__entries__.length;
            },
            enumerable: true,
            configurable: true
        });
        /**
         * @param {*} key
         * @returns {*}
         */
        class_1.prototype.get = function (key) {
            var index = getIndex(this.__entries__, key);
            var entry = this.__entries__[index];
            return entry && entry[1];
        };
        /**
         * @param {*} key
         * @param {*} value
         * @returns {void}
         */
        class_1.prototype.set = function (key, value) {
            var index = getIndex(this.__entries__, key);
            if (~index) {
                this.__entries__[index][1] = value;
            }
            else {
                this.__entries__.push([key, value]);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.delete = function (key) {
            var entries = this.__entries__;
            var index = getIndex(entries, key);
            if (~index) {
                entries.splice(index, 1);
            }
        };
        /**
         * @param {*} key
         * @returns {void}
         */
        class_1.prototype.has = function (key) {
            return !!~getIndex(this.__entries__, key);
        };
        /**
         * @returns {void}
         */
        class_1.prototype.clear = function () {
            this.__entries__.splice(0);
        };
        /**
         * @param {Function} callback
         * @param {*} [ctx=null]
         * @returns {void}
         */
        class_1.prototype.forEach = function (callback, ctx) {
            if (ctx === void 0) { ctx = null; }
            for (var _i = 0, _a = this.__entries__; _i < _a.length; _i++) {
                var entry = _a[_i];
                callback.call(ctx, entry[1], entry[0]);
            }
        };
        return class_1;
    }());
})();

/**
 * Detects whether window and document objects are available in current environment.
 */
var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && window.document === document;

// Returns global object of a current environment.
var global$1 = (function () {
    if (typeof global !== 'undefined' && global.Math === Math) {
        return global;
    }
    if (typeof self !== 'undefined' && self.Math === Math) {
        return self;
    }
    if (typeof window !== 'undefined' && window.Math === Math) {
        return window;
    }
    // eslint-disable-next-line no-new-func
    return Function('return this')();
})();

/**
 * A shim for the requestAnimationFrame which falls back to the setTimeout if
 * first one is not supported.
 *
 * @returns {number} Requests' identifier.
 */
var requestAnimationFrame$1 = (function () {
    if (typeof requestAnimationFrame === 'function') {
        // It's required to use a bounded function because IE sometimes throws
        // an "Invalid calling object" error if rAF is invoked without the global
        // object on the left hand side.
        return requestAnimationFrame.bind(global$1);
    }
    return function (callback) { return setTimeout(function () { return callback(Date.now()); }, 1000 / 60); };
})();

// Defines minimum timeout before adding a trailing call.
var trailingTimeout = 2;
/**
 * Creates a wrapper function which ensures that provided callback will be
 * invoked only once during the specified delay period.
 *
 * @param {Function} callback - Function to be invoked after the delay period.
 * @param {number} delay - Delay after which to invoke callback.
 * @returns {Function}
 */
function throttle (callback, delay) {
    var leadingCall = false, trailingCall = false, lastCallTime = 0;
    /**
     * Invokes the original callback function and schedules new invocation if
     * the "proxy" was called during current request.
     *
     * @returns {void}
     */
    function resolvePending() {
        if (leadingCall) {
            leadingCall = false;
            callback();
        }
        if (trailingCall) {
            proxy();
        }
    }
    /**
     * Callback invoked after the specified delay. It will further postpone
     * invocation of the original function delegating it to the
     * requestAnimationFrame.
     *
     * @returns {void}
     */
    function timeoutCallback() {
        requestAnimationFrame$1(resolvePending);
    }
    /**
     * Schedules invocation of the original function.
     *
     * @returns {void}
     */
    function proxy() {
        var timeStamp = Date.now();
        if (leadingCall) {
            // Reject immediately following calls.
            if (timeStamp - lastCallTime < trailingTimeout) {
                return;
            }
            // Schedule new call to be in invoked when the pending one is resolved.
            // This is important for "transitions" which never actually start
            // immediately so there is a chance that we might miss one if change
            // happens amids the pending invocation.
            trailingCall = true;
        }
        else {
            leadingCall = true;
            trailingCall = false;
            setTimeout(timeoutCallback, delay);
        }
        lastCallTime = timeStamp;
    }
    return proxy;
}

// Minimum delay before invoking the update of observers.
var REFRESH_DELAY = 20;
// A list of substrings of CSS properties used to find transition events that
// might affect dimensions of observed elements.
var transitionKeys = ['top', 'right', 'bottom', 'left', 'width', 'height', 'size', 'weight'];
// Check if MutationObserver is available.
var mutationObserverSupported = typeof MutationObserver !== 'undefined';
/**
 * Singleton controller class which handles updates of ResizeObserver instances.
 */
var ResizeObserverController = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserverController.
     *
     * @private
     */
    function ResizeObserverController() {
        /**
         * Indicates whether DOM listeners have been added.
         *
         * @private {boolean}
         */
        this.connected_ = false;
        /**
         * Tells that controller has subscribed for Mutation Events.
         *
         * @private {boolean}
         */
        this.mutationEventsAdded_ = false;
        /**
         * Keeps reference to the instance of MutationObserver.
         *
         * @private {MutationObserver}
         */
        this.mutationsObserver_ = null;
        /**
         * A list of connected observers.
         *
         * @private {Array<ResizeObserverSPI>}
         */
        this.observers_ = [];
        this.onTransitionEnd_ = this.onTransitionEnd_.bind(this);
        this.refresh = throttle(this.refresh.bind(this), REFRESH_DELAY);
    }
    /**
     * Adds observer to observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be added.
     * @returns {void}
     */
    ResizeObserverController.prototype.addObserver = function (observer) {
        if (!~this.observers_.indexOf(observer)) {
            this.observers_.push(observer);
        }
        // Add listeners if they haven't been added yet.
        if (!this.connected_) {
            this.connect_();
        }
    };
    /**
     * Removes observer from observers list.
     *
     * @param {ResizeObserverSPI} observer - Observer to be removed.
     * @returns {void}
     */
    ResizeObserverController.prototype.removeObserver = function (observer) {
        var observers = this.observers_;
        var index = observers.indexOf(observer);
        // Remove observer if it's present in registry.
        if (~index) {
            observers.splice(index, 1);
        }
        // Remove listeners if controller has no connected observers.
        if (!observers.length && this.connected_) {
            this.disconnect_();
        }
    };
    /**
     * Invokes the update of observers. It will continue running updates insofar
     * it detects changes.
     *
     * @returns {void}
     */
    ResizeObserverController.prototype.refresh = function () {
        var changesDetected = this.updateObservers_();
        // Continue running updates if changes have been detected as there might
        // be future ones caused by CSS transitions.
        if (changesDetected) {
            this.refresh();
        }
    };
    /**
     * Updates every observer from observers list and notifies them of queued
     * entries.
     *
     * @private
     * @returns {boolean} Returns "true" if any observer has detected changes in
     *      dimensions of it's elements.
     */
    ResizeObserverController.prototype.updateObservers_ = function () {
        // Collect observers that have active observations.
        var activeObservers = this.observers_.filter(function (observer) {
            return observer.gatherActive(), observer.hasActive();
        });
        // Deliver notifications in a separate cycle in order to avoid any
        // collisions between observers, e.g. when multiple instances of
        // ResizeObserver are tracking the same element and the callback of one
        // of them changes content dimensions of the observed target. Sometimes
        // this may result in notifications being blocked for the rest of observers.
        activeObservers.forEach(function (observer) { return observer.broadcastActive(); });
        return activeObservers.length > 0;
    };
    /**
     * Initializes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.connect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already added.
        if (!isBrowser || this.connected_) {
            return;
        }
        // Subscription to the "Transitionend" event is used as a workaround for
        // delayed transitions. This way it's possible to capture at least the
        // final state of an element.
        document.addEventListener('transitionend', this.onTransitionEnd_);
        window.addEventListener('resize', this.refresh);
        if (mutationObserverSupported) {
            this.mutationsObserver_ = new MutationObserver(this.refresh);
            this.mutationsObserver_.observe(document, {
                attributes: true,
                childList: true,
                characterData: true,
                subtree: true
            });
        }
        else {
            document.addEventListener('DOMSubtreeModified', this.refresh);
            this.mutationEventsAdded_ = true;
        }
        this.connected_ = true;
    };
    /**
     * Removes DOM listeners.
     *
     * @private
     * @returns {void}
     */
    ResizeObserverController.prototype.disconnect_ = function () {
        // Do nothing if running in a non-browser environment or if listeners
        // have been already removed.
        if (!isBrowser || !this.connected_) {
            return;
        }
        document.removeEventListener('transitionend', this.onTransitionEnd_);
        window.removeEventListener('resize', this.refresh);
        if (this.mutationsObserver_) {
            this.mutationsObserver_.disconnect();
        }
        if (this.mutationEventsAdded_) {
            document.removeEventListener('DOMSubtreeModified', this.refresh);
        }
        this.mutationsObserver_ = null;
        this.mutationEventsAdded_ = false;
        this.connected_ = false;
    };
    /**
     * "Transitionend" event handler.
     *
     * @private
     * @param {TransitionEvent} event
     * @returns {void}
     */
    ResizeObserverController.prototype.onTransitionEnd_ = function (_a) {
        var _b = _a.propertyName, propertyName = _b === void 0 ? '' : _b;
        // Detect whether transition may affect dimensions of an element.
        var isReflowProperty = transitionKeys.some(function (key) {
            return !!~propertyName.indexOf(key);
        });
        if (isReflowProperty) {
            this.refresh();
        }
    };
    /**
     * Returns instance of the ResizeObserverController.
     *
     * @returns {ResizeObserverController}
     */
    ResizeObserverController.getInstance = function () {
        if (!this.instance_) {
            this.instance_ = new ResizeObserverController();
        }
        return this.instance_;
    };
    /**
     * Holds reference to the controller's instance.
     *
     * @private {ResizeObserverController}
     */
    ResizeObserverController.instance_ = null;
    return ResizeObserverController;
}());

/**
 * Defines non-writable/enumerable properties of the provided target object.
 *
 * @param {Object} target - Object for which to define properties.
 * @param {Object} props - Properties to be defined.
 * @returns {Object} Target object.
 */
var defineConfigurable = (function (target, props) {
    for (var _i = 0, _a = Object.keys(props); _i < _a.length; _i++) {
        var key = _a[_i];
        Object.defineProperty(target, key, {
            value: props[key],
            enumerable: false,
            writable: false,
            configurable: true
        });
    }
    return target;
});

/**
 * Returns the global object associated with provided element.
 *
 * @param {Object} target
 * @returns {Object}
 */
var getWindowOf = (function (target) {
    // Assume that the element is an instance of Node, which means that it
    // has the "ownerDocument" property from which we can retrieve a
    // corresponding global object.
    var ownerGlobal = target && target.ownerDocument && target.ownerDocument.defaultView;
    // Return the local global object if it's not possible extract one from
    // provided element.
    return ownerGlobal || global$1;
});

// Placeholder of an empty content rectangle.
var emptyRect = createRectInit(0, 0, 0, 0);
/**
 * Converts provided string to a number.
 *
 * @param {number|string} value
 * @returns {number}
 */
function toFloat(value) {
    return parseFloat(value) || 0;
}
/**
 * Extracts borders size from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @param {...string} positions - Borders positions (top, right, ...)
 * @returns {number}
 */
function getBordersSize(styles) {
    var positions = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        positions[_i - 1] = arguments[_i];
    }
    return positions.reduce(function (size, position) {
        var value = styles['border-' + position + '-width'];
        return size + toFloat(value);
    }, 0);
}
/**
 * Extracts paddings sizes from provided styles.
 *
 * @param {CSSStyleDeclaration} styles
 * @returns {Object} Paddings box.
 */
function getPaddings(styles) {
    var positions = ['top', 'right', 'bottom', 'left'];
    var paddings = {};
    for (var _i = 0, positions_1 = positions; _i < positions_1.length; _i++) {
        var position = positions_1[_i];
        var value = styles['padding-' + position];
        paddings[position] = toFloat(value);
    }
    return paddings;
}
/**
 * Calculates content rectangle of provided SVG element.
 *
 * @param {SVGGraphicsElement} target - Element content rectangle of which needs
 *      to be calculated.
 * @returns {DOMRectInit}
 */
function getSVGContentRect(target) {
    var bbox = target.getBBox();
    return createRectInit(0, 0, bbox.width, bbox.height);
}
/**
 * Calculates content rectangle of provided HTMLElement.
 *
 * @param {HTMLElement} target - Element for which to calculate the content rectangle.
 * @returns {DOMRectInit}
 */
function getHTMLElementContentRect(target) {
    // Client width & height properties can't be
    // used exclusively as they provide rounded values.
    var clientWidth = target.clientWidth, clientHeight = target.clientHeight;
    // By this condition we can catch all non-replaced inline, hidden and
    // detached elements. Though elements with width & height properties less
    // than 0.5 will be discarded as well.
    //
    // Without it we would need to implement separate methods for each of
    // those cases and it's not possible to perform a precise and performance
    // effective test for hidden elements. E.g. even jQuery's ':visible' filter
    // gives wrong results for elements with width & height less than 0.5.
    if (!clientWidth && !clientHeight) {
        return emptyRect;
    }
    var styles = getWindowOf(target).getComputedStyle(target);
    var paddings = getPaddings(styles);
    var horizPad = paddings.left + paddings.right;
    var vertPad = paddings.top + paddings.bottom;
    // Computed styles of width & height are being used because they are the
    // only dimensions available to JS that contain non-rounded values. It could
    // be possible to utilize the getBoundingClientRect if only it's data wasn't
    // affected by CSS transformations let alone paddings, borders and scroll bars.
    var width = toFloat(styles.width), height = toFloat(styles.height);
    // Width & height include paddings and borders when the 'border-box' box
    // model is applied (except for IE).
    if (styles.boxSizing === 'border-box') {
        // Following conditions are required to handle Internet Explorer which
        // doesn't include paddings and borders to computed CSS dimensions.
        //
        // We can say that if CSS dimensions + paddings are equal to the "client"
        // properties then it's either IE, and thus we don't need to subtract
        // anything, or an element merely doesn't have paddings/borders styles.
        if (Math.round(width + horizPad) !== clientWidth) {
            width -= getBordersSize(styles, 'left', 'right') + horizPad;
        }
        if (Math.round(height + vertPad) !== clientHeight) {
            height -= getBordersSize(styles, 'top', 'bottom') + vertPad;
        }
    }
    // Following steps can't be applied to the document's root element as its
    // client[Width/Height] properties represent viewport area of the window.
    // Besides, it's as well not necessary as the <html> itself neither has
    // rendered scroll bars nor it can be clipped.
    if (!isDocumentElement(target)) {
        // In some browsers (only in Firefox, actually) CSS width & height
        // include scroll bars size which can be removed at this step as scroll
        // bars are the only difference between rounded dimensions + paddings
        // and "client" properties, though that is not always true in Chrome.
        var vertScrollbar = Math.round(width + horizPad) - clientWidth;
        var horizScrollbar = Math.round(height + vertPad) - clientHeight;
        // Chrome has a rather weird rounding of "client" properties.
        // E.g. for an element with content width of 314.2px it sometimes gives
        // the client width of 315px and for the width of 314.7px it may give
        // 314px. And it doesn't happen all the time. So just ignore this delta
        // as a non-relevant.
        if (Math.abs(vertScrollbar) !== 1) {
            width -= vertScrollbar;
        }
        if (Math.abs(horizScrollbar) !== 1) {
            height -= horizScrollbar;
        }
    }
    return createRectInit(paddings.left, paddings.top, width, height);
}
/**
 * Checks whether provided element is an instance of the SVGGraphicsElement.
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
var isSVGGraphicsElement = (function () {
    // Some browsers, namely IE and Edge, don't have the SVGGraphicsElement
    // interface.
    if (typeof SVGGraphicsElement !== 'undefined') {
        return function (target) { return target instanceof getWindowOf(target).SVGGraphicsElement; };
    }
    // If it's so, then check that element is at least an instance of the
    // SVGElement and that it has the "getBBox" method.
    // eslint-disable-next-line no-extra-parens
    return function (target) { return (target instanceof getWindowOf(target).SVGElement &&
        typeof target.getBBox === 'function'); };
})();
/**
 * Checks whether provided element is a document element (<html>).
 *
 * @param {Element} target - Element to be checked.
 * @returns {boolean}
 */
function isDocumentElement(target) {
    return target === getWindowOf(target).document.documentElement;
}
/**
 * Calculates an appropriate content rectangle for provided html or svg element.
 *
 * @param {Element} target - Element content rectangle of which needs to be calculated.
 * @returns {DOMRectInit}
 */
function getContentRect(target) {
    if (!isBrowser) {
        return emptyRect;
    }
    if (isSVGGraphicsElement(target)) {
        return getSVGContentRect(target);
    }
    return getHTMLElementContentRect(target);
}
/**
 * Creates rectangle with an interface of the DOMRectReadOnly.
 * Spec: https://drafts.fxtf.org/geometry/#domrectreadonly
 *
 * @param {DOMRectInit} rectInit - Object with rectangle's x/y coordinates and dimensions.
 * @returns {DOMRectReadOnly}
 */
function createReadOnlyRect(_a) {
    var x = _a.x, y = _a.y, width = _a.width, height = _a.height;
    // If DOMRectReadOnly is available use it as a prototype for the rectangle.
    var Constr = typeof DOMRectReadOnly !== 'undefined' ? DOMRectReadOnly : Object;
    var rect = Object.create(Constr.prototype);
    // Rectangle's properties are not writable and non-enumerable.
    defineConfigurable(rect, {
        x: x, y: y, width: width, height: height,
        top: y,
        right: x + width,
        bottom: height + y,
        left: x
    });
    return rect;
}
/**
 * Creates DOMRectInit object based on the provided dimensions and the x/y coordinates.
 * Spec: https://drafts.fxtf.org/geometry/#dictdef-domrectinit
 *
 * @param {number} x - X coordinate.
 * @param {number} y - Y coordinate.
 * @param {number} width - Rectangle's width.
 * @param {number} height - Rectangle's height.
 * @returns {DOMRectInit}
 */
function createRectInit(x, y, width, height) {
    return { x: x, y: y, width: width, height: height };
}

/**
 * Class that is responsible for computations of the content rectangle of
 * provided DOM element and for keeping track of it's changes.
 */
var ResizeObservation = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObservation.
     *
     * @param {Element} target - Element to be observed.
     */
    function ResizeObservation(target) {
        /**
         * Broadcasted width of content rectangle.
         *
         * @type {number}
         */
        this.broadcastWidth = 0;
        /**
         * Broadcasted height of content rectangle.
         *
         * @type {number}
         */
        this.broadcastHeight = 0;
        /**
         * Reference to the last observed content rectangle.
         *
         * @private {DOMRectInit}
         */
        this.contentRect_ = createRectInit(0, 0, 0, 0);
        this.target = target;
    }
    /**
     * Updates content rectangle and tells whether it's width or height properties
     * have changed since the last broadcast.
     *
     * @returns {boolean}
     */
    ResizeObservation.prototype.isActive = function () {
        var rect = getContentRect(this.target);
        this.contentRect_ = rect;
        return (rect.width !== this.broadcastWidth ||
            rect.height !== this.broadcastHeight);
    };
    /**
     * Updates 'broadcastWidth' and 'broadcastHeight' properties with a data
     * from the corresponding properties of the last observed content rectangle.
     *
     * @returns {DOMRectInit} Last observed content rectangle.
     */
    ResizeObservation.prototype.broadcastRect = function () {
        var rect = this.contentRect_;
        this.broadcastWidth = rect.width;
        this.broadcastHeight = rect.height;
        return rect;
    };
    return ResizeObservation;
}());

var ResizeObserverEntry = /** @class */ (function () {
    /**
     * Creates an instance of ResizeObserverEntry.
     *
     * @param {Element} target - Element that is being observed.
     * @param {DOMRectInit} rectInit - Data of the element's content rectangle.
     */
    function ResizeObserverEntry(target, rectInit) {
        var contentRect = createReadOnlyRect(rectInit);
        // According to the specification following properties are not writable
        // and are also not enumerable in the native implementation.
        //
        // Property accessors are not being used as they'd require to define a
        // private WeakMap storage which may cause memory leaks in browsers that
        // don't support this type of collections.
        defineConfigurable(this, { target: target, contentRect: contentRect });
    }
    return ResizeObserverEntry;
}());

var ResizeObserverSPI = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback function that is invoked
     *      when one of the observed elements changes it's content dimensions.
     * @param {ResizeObserverController} controller - Controller instance which
     *      is responsible for the updates of observer.
     * @param {ResizeObserver} callbackCtx - Reference to the public
     *      ResizeObserver instance which will be passed to callback function.
     */
    function ResizeObserverSPI(callback, controller, callbackCtx) {
        /**
         * Collection of resize observations that have detected changes in dimensions
         * of elements.
         *
         * @private {Array<ResizeObservation>}
         */
        this.activeObservations_ = [];
        /**
         * Registry of the ResizeObservation instances.
         *
         * @private {Map<Element, ResizeObservation>}
         */
        this.observations_ = new MapShim();
        if (typeof callback !== 'function') {
            throw new TypeError('The callback provided as parameter 1 is not a function.');
        }
        this.callback_ = callback;
        this.controller_ = controller;
        this.callbackCtx_ = callbackCtx;
    }
    /**
     * Starts observing provided element.
     *
     * @param {Element} target - Element to be observed.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.observe = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is already being observed.
        if (observations.has(target)) {
            return;
        }
        observations.set(target, new ResizeObservation(target));
        this.controller_.addObserver(this);
        // Force the update of observations.
        this.controller_.refresh();
    };
    /**
     * Stops observing provided element.
     *
     * @param {Element} target - Element to stop observing.
     * @returns {void}
     */
    ResizeObserverSPI.prototype.unobserve = function (target) {
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        // Do nothing if current environment doesn't have the Element interface.
        if (typeof Element === 'undefined' || !(Element instanceof Object)) {
            return;
        }
        if (!(target instanceof getWindowOf(target).Element)) {
            throw new TypeError('parameter 1 is not of type "Element".');
        }
        var observations = this.observations_;
        // Do nothing if element is not being observed.
        if (!observations.has(target)) {
            return;
        }
        observations.delete(target);
        if (!observations.size) {
            this.controller_.removeObserver(this);
        }
    };
    /**
     * Stops observing all elements.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.disconnect = function () {
        this.clearActive();
        this.observations_.clear();
        this.controller_.removeObserver(this);
    };
    /**
     * Collects observation instances the associated element of which has changed
     * it's content rectangle.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.gatherActive = function () {
        var _this = this;
        this.clearActive();
        this.observations_.forEach(function (observation) {
            if (observation.isActive()) {
                _this.activeObservations_.push(observation);
            }
        });
    };
    /**
     * Invokes initial callback function with a list of ResizeObserverEntry
     * instances collected from active resize observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.broadcastActive = function () {
        // Do nothing if observer doesn't have active observations.
        if (!this.hasActive()) {
            return;
        }
        var ctx = this.callbackCtx_;
        // Create ResizeObserverEntry instance for every active observation.
        var entries = this.activeObservations_.map(function (observation) {
            return new ResizeObserverEntry(observation.target, observation.broadcastRect());
        });
        this.callback_.call(ctx, entries, ctx);
        this.clearActive();
    };
    /**
     * Clears the collection of active observations.
     *
     * @returns {void}
     */
    ResizeObserverSPI.prototype.clearActive = function () {
        this.activeObservations_.splice(0);
    };
    /**
     * Tells whether observer has active observations.
     *
     * @returns {boolean}
     */
    ResizeObserverSPI.prototype.hasActive = function () {
        return this.activeObservations_.length > 0;
    };
    return ResizeObserverSPI;
}());

// Registry of internal observers. If WeakMap is not available use current shim
// for the Map collection as it has all required methods and because WeakMap
// can't be fully polyfilled anyway.
var observers = typeof WeakMap !== 'undefined' ? new WeakMap() : new MapShim();
/**
 * ResizeObserver API. Encapsulates the ResizeObserver SPI implementation
 * exposing only those methods and properties that are defined in the spec.
 */
var ResizeObserver = /** @class */ (function () {
    /**
     * Creates a new instance of ResizeObserver.
     *
     * @param {ResizeObserverCallback} callback - Callback that is invoked when
     *      dimensions of the observed elements change.
     */
    function ResizeObserver(callback) {
        if (!(this instanceof ResizeObserver)) {
            throw new TypeError('Cannot call a class as a function.');
        }
        if (!arguments.length) {
            throw new TypeError('1 argument required, but only 0 present.');
        }
        var controller = ResizeObserverController.getInstance();
        var observer = new ResizeObserverSPI(callback, controller, this);
        observers.set(this, observer);
    }
    return ResizeObserver;
}());
// Expose public methods of ResizeObserver.
[
    'observe',
    'unobserve',
    'disconnect'
].forEach(function (method) {
    ResizeObserver.prototype[method] = function () {
        var _a;
        return (_a = observers.get(this))[method].apply(_a, arguments);
    };
});

var index = (function () {
    // Export existing implementation if available.
    if (typeof global$1.ResizeObserver !== 'undefined') {
        return global$1.ResizeObserver;
    }
    return ResizeObserver;
})();

/* harmony default export */ __webpack_exports__["default"] = (index);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(29)))

/***/ }),
/* 269 */
/***/ (function(module, exports, __webpack_require__) {

var MediaQueryDispatch = __webpack_require__(532);
module.exports = new MediaQueryDispatch();


/***/ }),
/* 270 */
/***/ (function(module, exports) {

/**
 * Helper function for iterating over a collection
 *
 * @param collection
 * @param fn
 */
function each(collection, fn) {
    var i      = 0,
        length = collection.length,
        cont;

    for(i; i < length; i++) {
        cont = fn(collection[i], i);
        if(cont === false) {
            break; //allow early exit
        }
    }
}

/**
 * Helper function for determining whether target object is an array
 *
 * @param target the object under test
 * @return {Boolean} true if array, false otherwise
 */
function isArray(target) {
    return Object.prototype.toString.apply(target) === '[object Array]';
}

/**
 * Helper function for determining whether target object is a function
 *
 * @param target the object under test
 * @return {Boolean} true if function, false otherwise
 */
function isFunction(target) {
    return typeof target === 'function';
}

module.exports = {
    isFunction : isFunction,
    isArray : isArray,
    each : each
};


/***/ }),
/* 271 */
/***/ (function(module, exports, __webpack_require__) {

var baseEach = __webpack_require__(123);

/**
 * The base implementation of `_.filter` without support for iteratee shorthands.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {Array} Returns the new filtered array.
 */
function baseFilter(collection, predicate) {
  var result = [];
  baseEach(collection, function(value, index, collection) {
    if (predicate(value, index, collection)) {
      result.push(value);
    }
  });
  return result;
}

module.exports = baseFilter;


/***/ }),
/* 272 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return parterLogo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_images_partnerLogo_flogo_02_svg__ = __webpack_require__(537);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_images_partnerLogo_flogo_02_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0__components_images_partnerLogo_flogo_02_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_images_partnerLogo_flogo_03_svg__ = __webpack_require__(538);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_images_partnerLogo_flogo_03_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__components_images_partnerLogo_flogo_03_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_images_partnerLogo_flogo_04_svg__ = __webpack_require__(539);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_images_partnerLogo_flogo_04_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__components_images_partnerLogo_flogo_04_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_images_partnerLogo_flogo_05_svg__ = __webpack_require__(540);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_images_partnerLogo_flogo_05_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__components_images_partnerLogo_flogo_05_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_images_partnerLogo_flogo_06_svg__ = __webpack_require__(541);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_images_partnerLogo_flogo_06_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_images_partnerLogo_flogo_06_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_images_partnerLogo_flogo_07_svg__ = __webpack_require__(542);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_images_partnerLogo_flogo_07_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_images_partnerLogo_flogo_07_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_images_partnerLogo_flogo_08_svg__ = __webpack_require__(543);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_images_partnerLogo_flogo_08_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__components_images_partnerLogo_flogo_08_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_images_partnerLogo_flogo_09_svg__ = __webpack_require__(544);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_images_partnerLogo_flogo_09_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7__components_images_partnerLogo_flogo_09_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_images_partnerLogo_flogo_10_svg__ = __webpack_require__(545);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_images_partnerLogo_flogo_10_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__components_images_partnerLogo_flogo_10_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_images_partnerLogo_flogo_11_svg__ = __webpack_require__(546);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_images_partnerLogo_flogo_11_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9__components_images_partnerLogo_flogo_11_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_images_partnerLogo_flogo_12_svg__ = __webpack_require__(547);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_images_partnerLogo_flogo_12_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10__components_images_partnerLogo_flogo_12_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_images_partnerLogo_flogo_13_svg__ = __webpack_require__(548);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_images_partnerLogo_flogo_13_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11__components_images_partnerLogo_flogo_13_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_images_partnerLogo_flogo_14_svg__ = __webpack_require__(549);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_images_partnerLogo_flogo_14_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12__components_images_partnerLogo_flogo_14_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_images_partnerLogo_flogo_15_svg__ = __webpack_require__(550);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_images_partnerLogo_flogo_15_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13__components_images_partnerLogo_flogo_15_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_images_partnerLogo_flogo_16_svg__ = __webpack_require__(551);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_images_partnerLogo_flogo_16_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14__components_images_partnerLogo_flogo_16_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_images_partnerLogo_dhawa_phuket_svg__ = __webpack_require__(552);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_images_partnerLogo_dhawa_phuket_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15__components_images_partnerLogo_dhawa_phuket_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_images_partnerLogo_skypark_png__ = __webpack_require__(553);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_images_partnerLogo_skypark_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16__components_images_partnerLogo_skypark_png__);
var parterLogo=[{logoImg:__WEBPACK_IMPORTED_MODULE_0__components_images_partnerLogo_flogo_02_svg___default.a,link:"http://www.angsanaresidences.com",name:"ANGSANA RESIDENCES",property:true,showLogo:true},// {
//   logoImg: flogo03,
//   link: "http://www.angsanatelukbahang.com/",
//   name: "ANGSANA PENANG",
//   property: true,
//   showLogo: true,
// },
{logoImg:__WEBPACK_IMPORTED_MODULE_2__components_images_partnerLogo_flogo_04_svg___default.a,link:"http://www.banyantreeresidences.com/en",name:"BANYAN TREE RESIDENCES",property:true,showLogo:true},{logoImg:__WEBPACK_IMPORTED_MODULE_3__components_images_partnerLogo_flogo_05_svg___default.a,link:"https://cassiaresidences.com/",name:"CASSIA RESIDENCES",property:true,showLogo:true},{logoImg:__WEBPACK_IMPORTED_MODULE_15__components_images_partnerLogo_dhawa_phuket_svg___default.a,link:"http://www.dhawaresidences.com/",name:"DHAWA RESIDENCES",property:true,showLogo:true},{logoImg:__WEBPACK_IMPORTED_MODULE_4__components_images_partnerLogo_flogo_06_svg___default.a,link:"http://www.lagunalangco.com/",name:"LAGUNA LĂNG CÔ",property:true,showLogo:true},//  {
//    logoImg: flogo07,
//    link: "http://www.lagunalifestylehub.com/",
//    name: "LAGUNA LIFESTYLE HUB",
//    property: true,
//    showLogo: true,
//  },
{logoImg:__WEBPACK_IMPORTED_MODULE_16__components_images_partnerLogo_skypark_png___default.a,link:"https://www.lagunaproperty.com/en/projects/phuket/skypark",name:"SKY PARK",property:true,showLogo:true},{logoImg:__WEBPACK_IMPORTED_MODULE_6__components_images_partnerLogo_flogo_08_svg___default.a,link:"http://sanctuaryclub.com/",name:"The Santuary Club",property:true,showLogo:true},{logoImg:__WEBPACK_IMPORTED_MODULE_7__components_images_partnerLogo_flogo_09_svg___default.a,link:"http://www.banyantree.com/",name:"BANYAN TREE",property:false,showLogo:true,row:2},{logoImg:__WEBPACK_IMPORTED_MODULE_8__components_images_partnerLogo_flogo_10_svg___default.a,link:"http://www.angsana.com/",name:"ANGSANA",property:false,showLogo:true,class:"angsana",row:2},{logoImg:__WEBPACK_IMPORTED_MODULE_9__components_images_partnerLogo_flogo_11_svg___default.a,link:"http://www.banyantreespa.com/",name:"BANYAN TREE SPA",property:false,showLogo:true,row:2},{logoImg:__WEBPACK_IMPORTED_MODULE_10__components_images_partnerLogo_flogo_12_svg___default.a,link:"http://www.angsanaspa.com/",name:"ANGSANA SPA",property:false,showLogo:true,class:"angsana",row:2},{logoImg:__WEBPACK_IMPORTED_MODULE_11__components_images_partnerLogo_flogo_13_svg___default.a,link:"https://essentials.banyantree.com/",name:"BANYAN TREE GALLERY",property:false,showLogo:true,row:2},{logoImg:__WEBPACK_IMPORTED_MODULE_12__components_images_partnerLogo_flogo_14_svg___default.a,link:"http://www.cassia.com/",name:"CASSIA",property:false,showLogo:true,row:2},{logoImg:__WEBPACK_IMPORTED_MODULE_13__components_images_partnerLogo_flogo_15_svg___default.a,link:"http://www.dhawa.com/",name:"DHAWA",property:false,showLogo:true,row:2},{logoImg:__WEBPACK_IMPORTED_MODULE_14__components_images_partnerLogo_flogo_16_svg___default.a,link:"http://www.lagunaphuket.com/",name:"LAGUNA PHUKET",property:false,showLogo:true,row:2}];

/***/ }),
/* 273 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__components_Icon__ = __webpack_require__(558);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "default", function() { return __WEBPACK_IMPORTED_MODULE_0__components_Icon__["a"]; });


/***/ }),
/* 274 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(559), __esModule: true };

/***/ }),
/* 275 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = !__webpack_require__(54) && !__webpack_require__(105)(function () {
  return Object.defineProperty(__webpack_require__(276)('div'), 'a', { get: function () { return 7; } }).a != 7;
});


/***/ }),
/* 276 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(79);
var document = __webpack_require__(52).document;
// typeof document.createElement is 'object' in old IE
var is = isObject(document) && isObject(document.createElement);
module.exports = function (it) {
  return is ? document.createElement(it) : {};
};


/***/ }),
/* 277 */
/***/ (function(module, exports, __webpack_require__) {

var has = __webpack_require__(62);
var toIObject = __webpack_require__(80);
var arrayIndexOf = __webpack_require__(566)(false);
var IE_PROTO = __webpack_require__(177)('IE_PROTO');

module.exports = function (object, names) {
  var O = toIObject(object);
  var i = 0;
  var result = [];
  var key;
  for (key in O) if (key != IE_PROTO) has(O, key) && result.push(key);
  // Don't enum bug & hidden keys
  while (names.length > i) if (has(O, key = names[i++])) {
    ~arrayIndexOf(result, key) || result.push(key);
  }
  return result;
};


/***/ }),
/* 278 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for non-array-like ES3 and non-enumerable old V8 strings
var cof = __webpack_require__(174);
// eslint-disable-next-line no-prototype-builtins
module.exports = Object('z').propertyIsEnumerable(0) ? Object : function (it) {
  return cof(it) == 'String' ? it.split('') : Object(it);
};


/***/ }),
/* 279 */
/***/ (function(module, exports, __webpack_require__) {

// 7.1.15 ToLength
var toInteger = __webpack_require__(176);
var min = Math.min;
module.exports = function (it) {
  return it > 0 ? min(toInteger(it), 0x1fffffffffffff) : 0; // pow(2, 53) - 1 == 9007199254740991
};


/***/ }),
/* 280 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

exports.default = function (obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
};

/***/ }),
/* 281 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $at = __webpack_require__(570)(true);

// 21.1.3.27 String.prototype[@@iterator]()
__webpack_require__(282)(String, 'String', function (iterated) {
  this._t = String(iterated); // target
  this._i = 0;                // next index
// 21.1.5.2.1 %StringIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var index = this._i;
  var point;
  if (index >= O.length) return { value: undefined, done: true };
  point = $at(O, index);
  this._i += point.length;
  return { value: point, done: false };
});


/***/ }),
/* 282 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var LIBRARY = __webpack_require__(128);
var $export = __webpack_require__(61);
var redefine = __webpack_require__(283);
var hide = __webpack_require__(77);
var Iterators = __webpack_require__(107);
var $iterCreate = __webpack_require__(571);
var setToStringTag = __webpack_require__(183);
var getPrototypeOf = __webpack_require__(574);
var ITERATOR = __webpack_require__(44)('iterator');
var BUGGY = !([].keys && 'next' in [].keys()); // Safari has buggy iterators w/o `next`
var FF_ITERATOR = '@@iterator';
var KEYS = 'keys';
var VALUES = 'values';

var returnThis = function () { return this; };

module.exports = function (Base, NAME, Constructor, next, DEFAULT, IS_SET, FORCED) {
  $iterCreate(Constructor, NAME, next);
  var getMethod = function (kind) {
    if (!BUGGY && kind in proto) return proto[kind];
    switch (kind) {
      case KEYS: return function keys() { return new Constructor(this, kind); };
      case VALUES: return function values() { return new Constructor(this, kind); };
    } return function entries() { return new Constructor(this, kind); };
  };
  var TAG = NAME + ' Iterator';
  var DEF_VALUES = DEFAULT == VALUES;
  var VALUES_BUG = false;
  var proto = Base.prototype;
  var $native = proto[ITERATOR] || proto[FF_ITERATOR] || DEFAULT && proto[DEFAULT];
  var $default = $native || getMethod(DEFAULT);
  var $entries = DEFAULT ? !DEF_VALUES ? $default : getMethod('entries') : undefined;
  var $anyNative = NAME == 'Array' ? proto.entries || $native : $native;
  var methods, key, IteratorPrototype;
  // Fix native
  if ($anyNative) {
    IteratorPrototype = getPrototypeOf($anyNative.call(new Base()));
    if (IteratorPrototype !== Object.prototype && IteratorPrototype.next) {
      // Set @@toStringTag to native iterators
      setToStringTag(IteratorPrototype, TAG, true);
      // fix for some old engines
      if (!LIBRARY && typeof IteratorPrototype[ITERATOR] != 'function') hide(IteratorPrototype, ITERATOR, returnThis);
    }
  }
  // fix Array#{values, @@iterator}.name in V8 / FF
  if (DEF_VALUES && $native && $native.name !== VALUES) {
    VALUES_BUG = true;
    $default = function values() { return $native.call(this); };
  }
  // Define iterator
  if ((!LIBRARY || FORCED) && (BUGGY || VALUES_BUG || !proto[ITERATOR])) {
    hide(proto, ITERATOR, $default);
  }
  // Plug for library
  Iterators[NAME] = $default;
  Iterators[TAG] = returnThis;
  if (DEFAULT) {
    methods = {
      values: DEF_VALUES ? $default : getMethod(VALUES),
      keys: IS_SET ? $default : getMethod(KEYS),
      entries: $entries
    };
    if (FORCED) for (key in methods) {
      if (!(key in proto)) redefine(proto, key, methods[key]);
    } else $export($export.P + $export.F * (BUGGY || VALUES_BUG), NAME, methods);
  }
  return methods;
};


/***/ }),
/* 283 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__(77);


/***/ }),
/* 284 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.7 / 15.2.3.4 Object.getOwnPropertyNames(O)
var $keys = __webpack_require__(277);
var hiddenKeys = __webpack_require__(179).concat('length', 'prototype');

exports.f = Object.getOwnPropertyNames || function getOwnPropertyNames(O) {
  return $keys(O, hiddenKeys);
};


/***/ }),
/* 285 */
/***/ (function(module, exports, __webpack_require__) {

var pIE = __webpack_require__(130);
var createDesc = __webpack_require__(106);
var toIObject = __webpack_require__(80);
var toPrimitive = __webpack_require__(173);
var has = __webpack_require__(62);
var IE8_DOM_DEFINE = __webpack_require__(275);
var gOPD = Object.getOwnPropertyDescriptor;

exports.f = __webpack_require__(54) ? gOPD : function getOwnPropertyDescriptor(O, P) {
  O = toIObject(O);
  P = toPrimitive(P, true);
  if (IE8_DOM_DEFINE) try {
    return gOPD(O, P);
  } catch (e) { /* empty */ }
  if (has(O, P)) return createDesc(!pIE.f.call(O, P), O[P]);
};


/***/ }),
/* 286 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.warning = warning;
exports.note = note;
exports.resetWarned = resetWarned;
exports.call = call;
exports.warningOnce = warningOnce;
exports.noteOnce = noteOnce;
exports.default = void 0;

/* eslint-disable no-console */
var warned = {};

function warning(valid, message) {
  // Support uglify
  if (false) {
    console.error("Warning: ".concat(message));
  }
}

function note(valid, message) {
  // Support uglify
  if (false) {
    console.warn("Note: ".concat(message));
  }
}

function resetWarned() {
  warned = {};
}

function call(method, valid, message) {
  if (!valid && !warned[message]) {
    method(false, message);
    warned[message] = true;
  }
}

function warningOnce(valid, message) {
  call(warning, valid, message);
}

function noteOnce(valid, message) {
  call(note, valid, message);
}

var _default = warningOnce;
/* eslint-enable */

exports.default = _default;

/***/ }),
/* 287 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _en_US = _interopRequireDefault(__webpack_require__(603));

var _en_US2 = _interopRequireDefault(__webpack_require__(288));

var _en_US3 = _interopRequireDefault(__webpack_require__(289));

var _en_US4 = _interopRequireDefault(__webpack_require__(605));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = {
  locale: 'en',
  Pagination: _en_US["default"],
  DatePicker: _en_US2["default"],
  TimePicker: _en_US3["default"],
  Calendar: _en_US4["default"],
  global: {
    placeholder: 'Please select'
  },
  Table: {
    filterTitle: 'Filter menu',
    filterConfirm: 'OK',
    filterReset: 'Reset',
    selectAll: 'Select current page',
    selectInvert: 'Invert current page',
    sortTitle: 'Sort',
    expand: 'Expand row',
    collapse: 'Collapse row'
  },
  Modal: {
    okText: 'OK',
    cancelText: 'Cancel',
    justOkText: 'OK'
  },
  Popconfirm: {
    okText: 'OK',
    cancelText: 'Cancel'
  },
  Transfer: {
    titles: ['', ''],
    searchPlaceholder: 'Search here',
    itemUnit: 'item',
    itemsUnit: 'items'
  },
  Upload: {
    uploading: 'Uploading...',
    removeFile: 'Remove file',
    uploadError: 'Upload error',
    previewFile: 'Preview file',
    downloadFile: 'Download file'
  },
  Empty: {
    description: 'No Data'
  },
  Icon: {
    icon: 'icon'
  },
  Text: {
    edit: 'Edit',
    copy: 'Copy',
    copied: 'Copied',
    expand: 'Expand'
  },
  PageHeader: {
    back: 'Back'
  }
};
exports["default"] = _default;

/***/ }),
/* 288 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _en_US = _interopRequireDefault(__webpack_require__(604));

var _en_US2 = _interopRequireDefault(__webpack_require__(289));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// Merge into a locale object
var locale = {
  lang: _extends({
    placeholder: 'Select date',
    rangePlaceholder: ['Start date', 'End date']
  }, _en_US["default"]),
  timePickerLocale: _extends({}, _en_US2["default"])
}; // All settings at:
// https://github.com/ant-design/ant-design/blob/master/components/date-picker/locale/example.json

var _default = locale;
exports["default"] = _default;

/***/ }),
/* 289 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var locale = {
  placeholder: 'Select time'
};
var _default = locale;
exports["default"] = _default;

/***/ }),
/* 290 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(104);

__webpack_require__(609);

__webpack_require__(291);

/***/ }),
/* 291 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(104);

__webpack_require__(610);

/***/ }),
/* 292 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Input = _interopRequireDefault(__webpack_require__(108));

var _Group = _interopRequireDefault(__webpack_require__(621));

var _Search = _interopRequireDefault(__webpack_require__(622));

var _TextArea = _interopRequireDefault(__webpack_require__(630));

var _Password = _interopRequireDefault(__webpack_require__(638));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

_Input["default"].Group = _Group["default"];
_Input["default"].Search = _Search["default"];
_Input["default"].TextArea = _TextArea["default"];
_Input["default"].Password = _Password["default"];
var _default = _Input["default"];
exports["default"] = _default;

/***/ }),
/* 293 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.hasPrefixSuffix = hasPrefixSuffix;
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _reactLifecyclesCompat = __webpack_require__(83);

var _classnames = _interopRequireDefault(__webpack_require__(24));

var _icon = _interopRequireDefault(__webpack_require__(60));

var _type = __webpack_require__(85);

var _Input = __webpack_require__(108);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var ClearableInputType = (0, _type.tuple)('text', 'input');

function hasPrefixSuffix(props) {
  return !!(props.prefix || props.suffix || props.allowClear);
}

var ClearableLabeledInput = /*#__PURE__*/function (_React$Component) {
  _inherits(ClearableLabeledInput, _React$Component);

  var _super = _createSuper(ClearableLabeledInput);

  function ClearableLabeledInput() {
    _classCallCheck(this, ClearableLabeledInput);

    return _super.apply(this, arguments);
  }

  _createClass(ClearableLabeledInput, [{
    key: "renderClearIcon",
    value: function renderClearIcon(prefixCls) {
      var _this$props = this.props,
          allowClear = _this$props.allowClear,
          value = _this$props.value,
          disabled = _this$props.disabled,
          readOnly = _this$props.readOnly,
          inputType = _this$props.inputType,
          handleReset = _this$props.handleReset;

      if (!allowClear || disabled || readOnly || value === undefined || value === null || value === '') {
        return null;
      }

      var className = inputType === ClearableInputType[0] ? "".concat(prefixCls, "-textarea-clear-icon") : "".concat(prefixCls, "-clear-icon");
      return /*#__PURE__*/React.createElement(_icon["default"], {
        type: "close-circle",
        theme: "filled",
        onClick: handleReset,
        className: className,
        role: "button"
      });
    }
  }, {
    key: "renderSuffix",
    value: function renderSuffix(prefixCls) {
      var _this$props2 = this.props,
          suffix = _this$props2.suffix,
          allowClear = _this$props2.allowClear;

      if (suffix || allowClear) {
        return /*#__PURE__*/React.createElement("span", {
          className: "".concat(prefixCls, "-suffix")
        }, this.renderClearIcon(prefixCls), suffix);
      }

      return null;
    }
  }, {
    key: "renderLabeledIcon",
    value: function renderLabeledIcon(prefixCls, element) {
      var _classNames;

      var props = this.props;
      var suffix = this.renderSuffix(prefixCls);

      if (!hasPrefixSuffix(props)) {
        return /*#__PURE__*/React.cloneElement(element, {
          value: props.value
        });
      }

      var prefix = props.prefix ? /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefixCls, "-prefix")
      }, props.prefix) : null;
      var affixWrapperCls = (0, _classnames["default"])(props.className, "".concat(prefixCls, "-affix-wrapper"), (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-affix-wrapper-sm"), props.size === 'small'), _defineProperty(_classNames, "".concat(prefixCls, "-affix-wrapper-lg"), props.size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-affix-wrapper-input-with-clear-btn"), props.suffix && props.allowClear && this.props.value), _classNames));
      return /*#__PURE__*/React.createElement("span", {
        className: affixWrapperCls,
        style: props.style
      }, prefix, /*#__PURE__*/React.cloneElement(element, {
        style: null,
        value: props.value,
        className: (0, _Input.getInputClassName)(prefixCls, props.size, props.disabled)
      }), suffix);
    }
  }, {
    key: "renderInputWithLabel",
    value: function renderInputWithLabel(prefixCls, labeledElement) {
      var _classNames3;

      var _this$props3 = this.props,
          addonBefore = _this$props3.addonBefore,
          addonAfter = _this$props3.addonAfter,
          style = _this$props3.style,
          size = _this$props3.size,
          className = _this$props3.className; // Not wrap when there is not addons

      if (!addonBefore && !addonAfter) {
        return labeledElement;
      }

      var wrapperClassName = "".concat(prefixCls, "-group");
      var addonClassName = "".concat(wrapperClassName, "-addon");
      var addonBeforeNode = addonBefore ? /*#__PURE__*/React.createElement("span", {
        className: addonClassName
      }, addonBefore) : null;
      var addonAfterNode = addonAfter ? /*#__PURE__*/React.createElement("span", {
        className: addonClassName
      }, addonAfter) : null;
      var mergedWrapperClassName = (0, _classnames["default"])("".concat(prefixCls, "-wrapper"), _defineProperty({}, wrapperClassName, addonBefore || addonAfter));
      var mergedGroupClassName = (0, _classnames["default"])(className, "".concat(prefixCls, "-group-wrapper"), (_classNames3 = {}, _defineProperty(_classNames3, "".concat(prefixCls, "-group-wrapper-sm"), size === 'small'), _defineProperty(_classNames3, "".concat(prefixCls, "-group-wrapper-lg"), size === 'large'), _classNames3)); // Need another wrapper for changing display:table to display:inline-block
      // and put style prop in wrapper

      return /*#__PURE__*/React.createElement("span", {
        className: mergedGroupClassName,
        style: style
      }, /*#__PURE__*/React.createElement("span", {
        className: mergedWrapperClassName
      }, addonBeforeNode, /*#__PURE__*/React.cloneElement(labeledElement, {
        style: null
      }), addonAfterNode));
    }
  }, {
    key: "renderTextAreaWithClearIcon",
    value: function renderTextAreaWithClearIcon(prefixCls, element) {
      var _this$props4 = this.props,
          value = _this$props4.value,
          allowClear = _this$props4.allowClear,
          className = _this$props4.className,
          style = _this$props4.style;

      if (!allowClear) {
        return /*#__PURE__*/React.cloneElement(element, {
          value: value
        });
      }

      var affixWrapperCls = (0, _classnames["default"])(className, "".concat(prefixCls, "-affix-wrapper"), "".concat(prefixCls, "-affix-wrapper-textarea-with-clear-btn"));
      return /*#__PURE__*/React.createElement("span", {
        className: affixWrapperCls,
        style: style
      }, /*#__PURE__*/React.cloneElement(element, {
        style: null,
        value: value
      }), this.renderClearIcon(prefixCls));
    }
  }, {
    key: "renderClearableLabeledInput",
    value: function renderClearableLabeledInput() {
      var _this$props5 = this.props,
          prefixCls = _this$props5.prefixCls,
          inputType = _this$props5.inputType,
          element = _this$props5.element;

      if (inputType === ClearableInputType[0]) {
        return this.renderTextAreaWithClearIcon(prefixCls, element);
      }

      return this.renderInputWithLabel(prefixCls, this.renderLabeledIcon(prefixCls, element));
    }
  }, {
    key: "render",
    value: function render() {
      return this.renderClearableLabeledInput();
    }
  }]);

  return ClearableLabeledInput;
}(React.Component);

(0, _reactLifecyclesCompat.polyfill)(ClearableLabeledInput);
var _default = ClearableLabeledInput;
exports["default"] = _default;

/***/ }),
/* 294 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _button = _interopRequireDefault(__webpack_require__(624));

var _buttonGroup = _interopRequireDefault(__webpack_require__(629));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

_button["default"].Group = _buttonGroup["default"];
var _default = _button["default"];
exports["default"] = _default;

/***/ }),
/* 295 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = wrapperRaf;

var _raf = _interopRequireDefault(__webpack_require__(627));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var id = 0;
var ids = {}; // Support call raf with delay specified frame

function wrapperRaf(callback) {
  var delayFrames = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
  var myId = id++;
  var restFrames = delayFrames;

  function internalCallback() {
    restFrames -= 1;

    if (restFrames <= 0) {
      callback();
      delete ids[myId];
    } else {
      ids[myId] = (0, _raf["default"])(internalCallback);
    }
  }

  ids[myId] = (0, _raf["default"])(internalCallback);
  return myId;
}

wrapperRaf.cancel = function cancel(pid) {
  if (pid === undefined) return;

  _raf["default"].cancel(ids[pid]);

  delete ids[pid];
};

wrapperRaf.ids = ids; // export this for test usage

/***/ }),
/* 296 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(104);

__webpack_require__(641);

__webpack_require__(642);

/***/ }),
/* 297 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _Form = _interopRequireDefault(__webpack_require__(644));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _Form["default"];
exports["default"] = _default;

/***/ }),
/* 298 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _objectWithoutProperties2 = __webpack_require__(280);

var _objectWithoutProperties3 = _interopRequireDefault(_objectWithoutProperties2);

var _defineProperty2 = __webpack_require__(126);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends5 = __webpack_require__(49);

var _extends6 = _interopRequireDefault(_extends5);

var _toConsumableArray2 = __webpack_require__(651);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _createReactClass = __webpack_require__(661);

var _createReactClass2 = _interopRequireDefault(_createReactClass);

var _unsafeLifecyclesPolyfill = __webpack_require__(662);

var _unsafeLifecyclesPolyfill2 = _interopRequireDefault(_unsafeLifecyclesPolyfill);

var _asyncValidator = __webpack_require__(663);

var _asyncValidator2 = _interopRequireDefault(_asyncValidator);

var _warning = __webpack_require__(21);

var _warning2 = _interopRequireDefault(_warning);

var _get = __webpack_require__(7);

var _get2 = _interopRequireDefault(_get);

var _set = __webpack_require__(301);

var _set2 = _interopRequireDefault(_set);

var _eq = __webpack_require__(70);

var _eq2 = _interopRequireDefault(_eq);

var _createFieldsStore = __webpack_require__(685);

var _createFieldsStore2 = _interopRequireDefault(_createFieldsStore);

var _utils = __webpack_require__(189);

var _FieldElemWrapper = __webpack_require__(687);

var _FieldElemWrapper2 = _interopRequireDefault(_FieldElemWrapper);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var DEFAULT_TRIGGER = 'onChange'; /* eslint-disable react/prefer-es6-class */
/* eslint-disable prefer-promise-reject-errors */

function createBaseForm() {
  var option = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var mixins = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : [];
  var validateMessages = option.validateMessages,
      onFieldsChange = option.onFieldsChange,
      onValuesChange = option.onValuesChange,
      _option$mapProps = option.mapProps,
      mapProps = _option$mapProps === undefined ? _utils.identity : _option$mapProps,
      mapPropsToFields = option.mapPropsToFields,
      fieldNameProp = option.fieldNameProp,
      fieldMetaProp = option.fieldMetaProp,
      fieldDataProp = option.fieldDataProp,
      _option$formPropName = option.formPropName,
      formPropName = _option$formPropName === undefined ? 'form' : _option$formPropName,
      formName = option.name,
      withRef = option.withRef;


  return function decorate(WrappedComponent) {
    var Form = (0, _createReactClass2['default'])({
      displayName: 'Form',

      mixins: mixins,

      getInitialState: function getInitialState() {
        var _this = this;

        var fields = mapPropsToFields && mapPropsToFields(this.props);
        this.fieldsStore = (0, _createFieldsStore2['default'])(fields || {});

        this.instances = {};
        this.cachedBind = {};
        this.clearedFieldMetaCache = {};

        this.renderFields = {};
        this.domFields = {};

        // HACK: https://github.com/ant-design/ant-design/issues/6406
        ['getFieldsValue', 'getFieldValue', 'setFieldsInitialValue', 'getFieldsError', 'getFieldError', 'isFieldValidating', 'isFieldsValidating', 'isFieldsTouched', 'isFieldTouched'].forEach(function (key) {
          _this[key] = function () {
            var _fieldsStore;

            if (false) {
              (0, _warning2['default'])(false, 'you should not use `ref` on enhanced form, please use `wrappedComponentRef`. ' + 'See: https://github.com/react-component/form#note-use-wrappedcomponentref-instead-of-withref-after-rc-form140');
            }
            return (_fieldsStore = _this.fieldsStore)[key].apply(_fieldsStore, arguments);
          };
        });

        return {
          submitting: false
        };
      },
      componentDidMount: function componentDidMount() {
        this.cleanUpUselessFields();
      },
      componentWillReceiveProps: function componentWillReceiveProps(nextProps) {
        if (mapPropsToFields) {
          this.fieldsStore.updateFields(mapPropsToFields(nextProps));
        }
      },
      componentDidUpdate: function componentDidUpdate() {
        this.cleanUpUselessFields();
      },
      onCollectCommon: function onCollectCommon(name, action, args) {
        var fieldMeta = this.fieldsStore.getFieldMeta(name);
        if (fieldMeta[action]) {
          fieldMeta[action].apply(fieldMeta, (0, _toConsumableArray3['default'])(args));
        } else if (fieldMeta.originalProps && fieldMeta.originalProps[action]) {
          var _fieldMeta$originalPr;

          (_fieldMeta$originalPr = fieldMeta.originalProps)[action].apply(_fieldMeta$originalPr, (0, _toConsumableArray3['default'])(args));
        }
        var value = fieldMeta.getValueFromEvent ? fieldMeta.getValueFromEvent.apply(fieldMeta, (0, _toConsumableArray3['default'])(args)) : _utils.getValueFromEvent.apply(undefined, (0, _toConsumableArray3['default'])(args));
        if (onValuesChange && value !== this.fieldsStore.getFieldValue(name)) {
          var valuesAll = this.fieldsStore.getAllValues();
          var valuesAllSet = {};
          valuesAll[name] = value;
          Object.keys(valuesAll).forEach(function (key) {
            return (0, _set2['default'])(valuesAllSet, key, valuesAll[key]);
          });
          onValuesChange((0, _extends6['default'])((0, _defineProperty3['default'])({}, formPropName, this.getForm()), this.props), (0, _set2['default'])({}, name, value), valuesAllSet);
        }
        var field = this.fieldsStore.getField(name);
        return { name: name, field: (0, _extends6['default'])({}, field, { value: value, touched: true }), fieldMeta: fieldMeta };
      },
      onCollect: function onCollect(name_, action) {
        for (var _len = arguments.length, args = Array(_len > 2 ? _len - 2 : 0), _key = 2; _key < _len; _key++) {
          args[_key - 2] = arguments[_key];
        }

        var _onCollectCommon = this.onCollectCommon(name_, action, args),
            name = _onCollectCommon.name,
            field = _onCollectCommon.field,
            fieldMeta = _onCollectCommon.fieldMeta;

        var validate = fieldMeta.validate;


        this.fieldsStore.setFieldsAsDirty();

        var newField = (0, _extends6['default'])({}, field, {
          dirty: (0, _utils.hasRules)(validate)
        });
        this.setFields((0, _defineProperty3['default'])({}, name, newField));
      },
      onCollectValidate: function onCollectValidate(name_, action) {
        for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
          args[_key2 - 2] = arguments[_key2];
        }

        var _onCollectCommon2 = this.onCollectCommon(name_, action, args),
            field = _onCollectCommon2.field,
            fieldMeta = _onCollectCommon2.fieldMeta;

        var newField = (0, _extends6['default'])({}, field, {
          dirty: true
        });

        this.fieldsStore.setFieldsAsDirty();

        this.validateFieldsInternal([newField], {
          action: action,
          options: {
            firstFields: !!fieldMeta.validateFirst
          }
        });
      },
      getCacheBind: function getCacheBind(name, action, fn) {
        if (!this.cachedBind[name]) {
          this.cachedBind[name] = {};
        }
        var cache = this.cachedBind[name];
        if (!cache[action] || cache[action].oriFn !== fn) {
          cache[action] = {
            fn: fn.bind(this, name, action),
            oriFn: fn
          };
        }
        return cache[action].fn;
      },
      getFieldDecorator: function getFieldDecorator(name, fieldOption) {
        var _this2 = this;

        var props = this.getFieldProps(name, fieldOption);
        return function (fieldElem) {
          // We should put field in record if it is rendered
          _this2.renderFields[name] = true;

          var fieldMeta = _this2.fieldsStore.getFieldMeta(name);
          var originalProps = fieldElem.props;
          if (false) {
            var valuePropName = fieldMeta.valuePropName;
            (0, _warning2['default'])(!(valuePropName in originalProps), '`getFieldDecorator` will override `' + valuePropName + '`, ' + ('so please don\'t set `' + valuePropName + '` directly ') + 'and use `setFieldsValue` to set it.');
            var defaultValuePropName = 'default' + valuePropName[0].toUpperCase() + valuePropName.slice(1);
            (0, _warning2['default'])(!(defaultValuePropName in originalProps), '`' + defaultValuePropName + '` is invalid ' + ('for `getFieldDecorator` will set `' + valuePropName + '`,') + ' please use `option.initialValue` instead.');
          }
          fieldMeta.originalProps = originalProps;
          fieldMeta.ref = fieldElem.ref;
          var decoratedFieldElem = _react2['default'].cloneElement(fieldElem, (0, _extends6['default'])({}, props, _this2.fieldsStore.getFieldValuePropValue(fieldMeta)));
          return (0, _utils.supportRef)(fieldElem) ? decoratedFieldElem : _react2['default'].createElement(
            _FieldElemWrapper2['default'],
            { name: name, form: _this2 },
            decoratedFieldElem
          );
        };
      },
      getFieldProps: function getFieldProps(name) {
        var _this3 = this;

        var usersFieldOption = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

        if (!name) {
          throw new Error('Must call `getFieldProps` with valid name string!');
        }
        if (false) {
          (0, _warning2['default'])(this.fieldsStore.isValidNestedFieldName(name), 'One field name cannot be part of another, e.g. `a` and `a.b`. Check field: ' + name);
          (0, _warning2['default'])(!('exclusive' in usersFieldOption), '`option.exclusive` of `getFieldProps`|`getFieldDecorator` had been remove.');
        }

        delete this.clearedFieldMetaCache[name];

        var fieldOption = (0, _extends6['default'])({
          name: name,
          trigger: DEFAULT_TRIGGER,
          valuePropName: 'value',
          validate: []
        }, usersFieldOption);

        var rules = fieldOption.rules,
            trigger = fieldOption.trigger,
            _fieldOption$validate = fieldOption.validateTrigger,
            validateTrigger = _fieldOption$validate === undefined ? trigger : _fieldOption$validate,
            validate = fieldOption.validate;


        var fieldMeta = this.fieldsStore.getFieldMeta(name);
        if ('initialValue' in fieldOption) {
          fieldMeta.initialValue = fieldOption.initialValue;
        }

        var inputProps = (0, _extends6['default'])({}, this.fieldsStore.getFieldValuePropValue(fieldOption), {
          ref: this.getCacheBind(name, name + '__ref', this.saveRef)
        });
        if (fieldNameProp) {
          inputProps[fieldNameProp] = formName ? formName + '_' + name : name;
        }

        var validateRules = (0, _utils.normalizeValidateRules)(validate, rules, validateTrigger);
        var validateTriggers = (0, _utils.getValidateTriggers)(validateRules);
        validateTriggers.forEach(function (action) {
          if (inputProps[action]) return;
          inputProps[action] = _this3.getCacheBind(name, action, _this3.onCollectValidate);
        });

        // make sure that the value will be collect
        if (trigger && validateTriggers.indexOf(trigger) === -1) {
          inputProps[trigger] = this.getCacheBind(name, trigger, this.onCollect);
        }

        var meta = (0, _extends6['default'])({}, fieldMeta, fieldOption, {
          validate: validateRules
        });
        this.fieldsStore.setFieldMeta(name, meta);
        if (fieldMetaProp) {
          inputProps[fieldMetaProp] = meta;
        }

        if (fieldDataProp) {
          inputProps[fieldDataProp] = this.fieldsStore.getField(name);
        }

        // This field is rendered, record it
        this.renderFields[name] = true;

        return inputProps;
      },
      getFieldInstance: function getFieldInstance(name) {
        return this.instances[name];
      },
      getRules: function getRules(fieldMeta, action) {
        var actionRules = fieldMeta.validate.filter(function (item) {
          return !action || item.trigger.indexOf(action) >= 0;
        }).map(function (item) {
          return item.rules;
        });
        return (0, _utils.flattenArray)(actionRules);
      },
      setFields: function setFields(maybeNestedFields, callback) {
        var _this4 = this;

        var fields = this.fieldsStore.flattenRegisteredFields(maybeNestedFields);
        this.fieldsStore.setFields(fields);
        if (onFieldsChange) {
          var changedFields = Object.keys(fields).reduce(function (acc, name) {
            return (0, _set2['default'])(acc, name, _this4.fieldsStore.getField(name));
          }, {});
          onFieldsChange((0, _extends6['default'])((0, _defineProperty3['default'])({}, formPropName, this.getForm()), this.props), changedFields, this.fieldsStore.getNestedAllFields());
        }
        this.forceUpdate(callback);
      },
      setFieldsValue: function setFieldsValue(changedValues, callback) {
        var fieldsMeta = this.fieldsStore.fieldsMeta;

        var values = this.fieldsStore.flattenRegisteredFields(changedValues);
        var newFields = Object.keys(values).reduce(function (acc, name) {
          var isRegistered = fieldsMeta[name];
          if (false) {
            (0, _warning2['default'])(isRegistered, 'Cannot use `setFieldsValue` until ' + 'you use `getFieldDecorator` or `getFieldProps` to register it.');
          }
          if (isRegistered) {
            var value = values[name];
            acc[name] = {
              value: value
            };
          }
          return acc;
        }, {});
        this.setFields(newFields, callback);
        if (onValuesChange) {
          var allValues = this.fieldsStore.getAllValues();
          onValuesChange((0, _extends6['default'])((0, _defineProperty3['default'])({}, formPropName, this.getForm()), this.props), changedValues, allValues);
        }
      },
      saveRef: function saveRef(name, _, component) {
        if (!component) {
          var _fieldMeta = this.fieldsStore.getFieldMeta(name);
          if (!_fieldMeta.preserve) {
            // after destroy, delete data
            this.clearedFieldMetaCache[name] = {
              field: this.fieldsStore.getField(name),
              meta: _fieldMeta
            };
            this.clearField(name);
          }
          delete this.domFields[name];
          return;
        }
        this.domFields[name] = true;
        this.recoverClearedField(name);
        var fieldMeta = this.fieldsStore.getFieldMeta(name);
        if (fieldMeta) {
          var ref = fieldMeta.ref;
          if (ref) {
            if (typeof ref === 'string') {
              throw new Error('can not set ref string for ' + name);
            } else if (typeof ref === 'function') {
              ref(component);
            } else if (Object.prototype.hasOwnProperty.call(ref, 'current')) {
              ref.current = component;
            }
          }
        }
        this.instances[name] = component;
      },
      cleanUpUselessFields: function cleanUpUselessFields() {
        var _this5 = this;

        var fieldList = this.fieldsStore.getAllFieldsName();
        var removedList = fieldList.filter(function (field) {
          var fieldMeta = _this5.fieldsStore.getFieldMeta(field);
          return !_this5.renderFields[field] && !_this5.domFields[field] && !fieldMeta.preserve;
        });
        if (removedList.length) {
          removedList.forEach(this.clearField);
        }
        this.renderFields = {};
      },
      clearField: function clearField(name) {
        this.fieldsStore.clearField(name);
        delete this.instances[name];
        delete this.cachedBind[name];
      },
      resetFields: function resetFields(ns) {
        var _this6 = this;

        var newFields = this.fieldsStore.resetFields(ns);
        if (Object.keys(newFields).length > 0) {
          this.setFields(newFields);
        }
        if (ns) {
          var names = Array.isArray(ns) ? ns : [ns];
          names.forEach(function (name) {
            return delete _this6.clearedFieldMetaCache[name];
          });
        } else {
          this.clearedFieldMetaCache = {};
        }
      },
      recoverClearedField: function recoverClearedField(name) {
        if (this.clearedFieldMetaCache[name]) {
          this.fieldsStore.setFields((0, _defineProperty3['default'])({}, name, this.clearedFieldMetaCache[name].field));
          this.fieldsStore.setFieldMeta(name, this.clearedFieldMetaCache[name].meta);
          delete this.clearedFieldMetaCache[name];
        }
      },
      validateFieldsInternal: function validateFieldsInternal(fields, _ref, callback) {
        var _this7 = this;

        var fieldNames = _ref.fieldNames,
            action = _ref.action,
            _ref$options = _ref.options,
            options = _ref$options === undefined ? {} : _ref$options;

        var allRules = {};
        var allValues = {};
        var allFields = {};
        var alreadyErrors = {};
        fields.forEach(function (field) {
          var name = field.name;
          if (options.force !== true && field.dirty === false) {
            if (field.errors) {
              (0, _set2['default'])(alreadyErrors, name, { errors: field.errors });
            }
            return;
          }
          var fieldMeta = _this7.fieldsStore.getFieldMeta(name);
          var newField = (0, _extends6['default'])({}, field);
          newField.errors = undefined;
          newField.validating = true;
          newField.dirty = true;
          allRules[name] = _this7.getRules(fieldMeta, action);
          allValues[name] = newField.value;
          allFields[name] = newField;
        });
        this.setFields(allFields);
        // in case normalize
        Object.keys(allValues).forEach(function (f) {
          allValues[f] = _this7.fieldsStore.getFieldValue(f);
        });
        if (callback && (0, _utils.isEmptyObject)(allFields)) {
          callback((0, _utils.isEmptyObject)(alreadyErrors) ? null : alreadyErrors, this.fieldsStore.getFieldsValue(fieldNames));
          return;
        }
        var validator = new _asyncValidator2['default'](allRules);
        if (validateMessages) {
          validator.messages(validateMessages);
        }
        validator.validate(allValues, options, function (errors) {
          var errorsGroup = (0, _extends6['default'])({}, alreadyErrors);
          if (errors && errors.length) {
            errors.forEach(function (e) {
              var errorFieldName = e.field;
              var fieldName = errorFieldName;

              // Handle using array validation rule.
              // ref: https://github.com/ant-design/ant-design/issues/14275
              Object.keys(allRules).some(function (ruleFieldName) {
                var rules = allRules[ruleFieldName] || [];

                // Exist if match rule
                if (ruleFieldName === errorFieldName) {
                  fieldName = ruleFieldName;
                  return true;
                }

                // Skip if not match array type
                if (rules.every(function (_ref2) {
                  var type = _ref2.type;
                  return type !== 'array';
                }) || errorFieldName.indexOf(ruleFieldName + '.') !== 0) {
                  return false;
                }

                // Exist if match the field name
                var restPath = errorFieldName.slice(ruleFieldName.length + 1);
                if (/^\d+$/.test(restPath)) {
                  fieldName = ruleFieldName;
                  return true;
                }

                return false;
              });

              var field = (0, _get2['default'])(errorsGroup, fieldName);
              if (typeof field !== 'object' || Array.isArray(field)) {
                (0, _set2['default'])(errorsGroup, fieldName, { errors: [] });
              }
              var fieldErrors = (0, _get2['default'])(errorsGroup, fieldName.concat('.errors'));
              fieldErrors.push(e);
            });
          }
          var expired = [];
          var nowAllFields = {};
          Object.keys(allRules).forEach(function (name) {
            var fieldErrors = (0, _get2['default'])(errorsGroup, name);
            var nowField = _this7.fieldsStore.getField(name);
            // avoid concurrency problems
            if (!(0, _eq2['default'])(nowField.value, allValues[name])) {
              expired.push({
                name: name
              });
            } else {
              nowField.errors = fieldErrors && fieldErrors.errors;
              nowField.value = allValues[name];
              nowField.validating = false;
              nowField.dirty = false;
              nowAllFields[name] = nowField;
            }
          });
          _this7.setFields(nowAllFields);
          if (callback) {
            if (expired.length) {
              expired.forEach(function (_ref3) {
                var name = _ref3.name;

                var fieldErrors = [{
                  message: name + ' need to revalidate',
                  field: name
                }];
                (0, _set2['default'])(errorsGroup, name, {
                  expired: true,
                  errors: fieldErrors
                });
              });
            }

            callback((0, _utils.isEmptyObject)(errorsGroup) ? null : errorsGroup, _this7.fieldsStore.getFieldsValue(fieldNames));
          }
        });
      },
      validateFields: function validateFields(ns, opt, cb) {
        var _this8 = this;

        var pending = new Promise(function (resolve, reject) {
          var _getParams = (0, _utils.getParams)(ns, opt, cb),
              names = _getParams.names,
              options = _getParams.options;

          var _getParams2 = (0, _utils.getParams)(ns, opt, cb),
              callback = _getParams2.callback;

          if (!callback || typeof callback === 'function') {
            var oldCb = callback;
            callback = function callback(errors, values) {
              if (oldCb) {
                oldCb(errors, values);
              }
              if (errors) {
                reject({ errors: errors, values: values });
              } else {
                resolve(values);
              }
            };
          }
          var fieldNames = names ? _this8.fieldsStore.getValidFieldsFullName(names) : _this8.fieldsStore.getValidFieldsName();
          var fields = fieldNames.filter(function (name) {
            var fieldMeta = _this8.fieldsStore.getFieldMeta(name);
            return (0, _utils.hasRules)(fieldMeta.validate);
          }).map(function (name) {
            var field = _this8.fieldsStore.getField(name);
            field.value = _this8.fieldsStore.getFieldValue(name);
            return field;
          });
          if (!fields.length) {
            callback(null, _this8.fieldsStore.getFieldsValue(fieldNames));
            return;
          }
          if (!('firstFields' in options)) {
            options.firstFields = fieldNames.filter(function (name) {
              var fieldMeta = _this8.fieldsStore.getFieldMeta(name);
              return !!fieldMeta.validateFirst;
            });
          }
          _this8.validateFieldsInternal(fields, {
            fieldNames: fieldNames,
            options: options
          }, callback);
        });
        pending['catch'](function (e) {
          // eslint-disable-next-line no-console
          if (console.error && "production" !== 'production') {
            // eslint-disable-next-line no-console
            console.error(e);
          }
          return e;
        });
        return pending;
      },
      isSubmitting: function isSubmitting() {
        if (false) {
          (0, _warning2['default'])(false, '`isSubmitting` is deprecated. ' + "Actually, it's more convenient to handle submitting status by yourself.");
        }
        return this.state.submitting;
      },
      submit: function submit(callback) {
        var _this9 = this;

        if (false) {
          (0, _warning2['default'])(false, '`submit` is deprecated. ' + "Actually, it's more convenient to handle submitting status by yourself.");
        }
        var fn = function fn() {
          _this9.setState({
            submitting: false
          });
        };
        this.setState({
          submitting: true
        });
        callback(fn);
      },
      render: function render() {
        var _props = this.props,
            wrappedComponentRef = _props.wrappedComponentRef,
            restProps = (0, _objectWithoutProperties3['default'])(_props, ['wrappedComponentRef']); // eslint-disable-line

        var formProps = (0, _defineProperty3['default'])({}, formPropName, this.getForm());
        if (withRef) {
          if (false) {
            (0, _warning2['default'])(false, '`withRef` is deprecated, please use `wrappedComponentRef` instead. ' + 'See: https://github.com/react-component/form#note-use-wrappedcomponentref-instead-of-withref-after-rc-form140');
          }
          formProps.ref = 'wrappedComponent';
        } else if (wrappedComponentRef) {
          formProps.ref = wrappedComponentRef;
        }
        var props = mapProps.call(this, (0, _extends6['default'])({}, formProps, restProps));
        return _react2['default'].createElement(WrappedComponent, props);
      }
    });

    return (0, _utils.argumentContainer)((0, _unsafeLifecyclesPolyfill2['default'])(Form), WrappedComponent);
  };
}

exports['default'] = createBaseForm;
module.exports = exports['default'];

/***/ }),
/* 299 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(47);

// -- Inlined from fbjs --

var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

var validateFormat = function validateFormat(format) {};

if (false) {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function _invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

var warning = function(){};

if (false) {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

// /-- Inlined from fbjs --

var MIXINS_KEY = 'mixins';

// Helper function to allow the creation of anonymous functions which do not
// have .name set to the name of the variable being assigned to.
function identity(fn) {
  return fn;
}

var ReactPropTypeLocationNames;
if (false) {
  ReactPropTypeLocationNames = {
    prop: 'prop',
    context: 'context',
    childContext: 'child context'
  };
} else {
  ReactPropTypeLocationNames = {};
}

function factory(ReactComponent, isValidElement, ReactNoopUpdateQueue) {
  /**
   * Policies that describe methods in `ReactClassInterface`.
   */

  var injectedMixins = [];

  /**
   * Composite components are higher-level components that compose other composite
   * or host components.
   *
   * To create a new type of `ReactClass`, pass a specification of
   * your new class to `React.createClass`. The only requirement of your class
   * specification is that you implement a `render` method.
   *
   *   var MyComponent = React.createClass({
   *     render: function() {
   *       return <div>Hello World</div>;
   *     }
   *   });
   *
   * The class specification supports a specific protocol of methods that have
   * special meaning (e.g. `render`). See `ReactClassInterface` for
   * more the comprehensive protocol. Any other properties and methods in the
   * class specification will be available on the prototype.
   *
   * @interface ReactClassInterface
   * @internal
   */
  var ReactClassInterface = {
    /**
     * An array of Mixin objects to include when defining your component.
     *
     * @type {array}
     * @optional
     */
    mixins: 'DEFINE_MANY',

    /**
     * An object containing properties and methods that should be defined on
     * the component's constructor instead of its prototype (static methods).
     *
     * @type {object}
     * @optional
     */
    statics: 'DEFINE_MANY',

    /**
     * Definition of prop types for this component.
     *
     * @type {object}
     * @optional
     */
    propTypes: 'DEFINE_MANY',

    /**
     * Definition of context types for this component.
     *
     * @type {object}
     * @optional
     */
    contextTypes: 'DEFINE_MANY',

    /**
     * Definition of context types this component sets for its children.
     *
     * @type {object}
     * @optional
     */
    childContextTypes: 'DEFINE_MANY',

    // ==== Definition methods ====

    /**
     * Invoked when the component is mounted. Values in the mapping will be set on
     * `this.props` if that prop is not specified (i.e. using an `in` check).
     *
     * This method is invoked before `getInitialState` and therefore cannot rely
     * on `this.state` or use `this.setState`.
     *
     * @return {object}
     * @optional
     */
    getDefaultProps: 'DEFINE_MANY_MERGED',

    /**
     * Invoked once before the component is mounted. The return value will be used
     * as the initial value of `this.state`.
     *
     *   getInitialState: function() {
     *     return {
     *       isOn: false,
     *       fooBaz: new BazFoo()
     *     }
     *   }
     *
     * @return {object}
     * @optional
     */
    getInitialState: 'DEFINE_MANY_MERGED',

    /**
     * @return {object}
     * @optional
     */
    getChildContext: 'DEFINE_MANY_MERGED',

    /**
     * Uses props from `this.props` and state from `this.state` to render the
     * structure of the component.
     *
     * No guarantees are made about when or how often this method is invoked, so
     * it must not have side effects.
     *
     *   render: function() {
     *     var name = this.props.name;
     *     return <div>Hello, {name}!</div>;
     *   }
     *
     * @return {ReactComponent}
     * @required
     */
    render: 'DEFINE_ONCE',

    // ==== Delegate methods ====

    /**
     * Invoked when the component is initially created and about to be mounted.
     * This may have side effects, but any external subscriptions or data created
     * by this method must be cleaned up in `componentWillUnmount`.
     *
     * @optional
     */
    componentWillMount: 'DEFINE_MANY',

    /**
     * Invoked when the component has been mounted and has a DOM representation.
     * However, there is no guarantee that the DOM node is in the document.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been mounted (initialized and rendered) for the first time.
     *
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidMount: 'DEFINE_MANY',

    /**
     * Invoked before the component receives new props.
     *
     * Use this as an opportunity to react to a prop transition by updating the
     * state using `this.setState`. Current props are accessed via `this.props`.
     *
     *   componentWillReceiveProps: function(nextProps, nextContext) {
     *     this.setState({
     *       likesIncreasing: nextProps.likeCount > this.props.likeCount
     *     });
     *   }
     *
     * NOTE: There is no equivalent `componentWillReceiveState`. An incoming prop
     * transition may cause a state change, but the opposite is not true. If you
     * need it, you are probably looking for `componentWillUpdate`.
     *
     * @param {object} nextProps
     * @optional
     */
    componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Invoked while deciding if the component should be updated as a result of
     * receiving new props, state and/or context.
     *
     * Use this as an opportunity to `return false` when you're certain that the
     * transition to the new props/state/context will not require a component
     * update.
     *
     *   shouldComponentUpdate: function(nextProps, nextState, nextContext) {
     *     return !equal(nextProps, this.props) ||
     *       !equal(nextState, this.state) ||
     *       !equal(nextContext, this.context);
     *   }
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @return {boolean} True if the component should update.
     * @optional
     */
    shouldComponentUpdate: 'DEFINE_ONCE',

    /**
     * Invoked when the component is about to update due to a transition from
     * `this.props`, `this.state` and `this.context` to `nextProps`, `nextState`
     * and `nextContext`.
     *
     * Use this as an opportunity to perform preparation before an update occurs.
     *
     * NOTE: You **cannot** use `this.setState()` in this method.
     *
     * @param {object} nextProps
     * @param {?object} nextState
     * @param {?object} nextContext
     * @param {ReactReconcileTransaction} transaction
     * @optional
     */
    componentWillUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component's DOM representation has been updated.
     *
     * Use this as an opportunity to operate on the DOM when the component has
     * been updated.
     *
     * @param {object} prevProps
     * @param {?object} prevState
     * @param {?object} prevContext
     * @param {DOMElement} rootNode DOM element representing the component.
     * @optional
     */
    componentDidUpdate: 'DEFINE_MANY',

    /**
     * Invoked when the component is about to be removed from its parent and have
     * its DOM representation destroyed.
     *
     * Use this as an opportunity to deallocate any external resources.
     *
     * NOTE: There is no `componentDidUnmount` since your component will have been
     * destroyed by that point.
     *
     * @optional
     */
    componentWillUnmount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillMount`.
     *
     * @optional
     */
    UNSAFE_componentWillMount: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillReceiveProps`.
     *
     * @optional
     */
    UNSAFE_componentWillReceiveProps: 'DEFINE_MANY',

    /**
     * Replacement for (deprecated) `componentWillUpdate`.
     *
     * @optional
     */
    UNSAFE_componentWillUpdate: 'DEFINE_MANY',

    // ==== Advanced methods ====

    /**
     * Updates the component's currently mounted DOM representation.
     *
     * By default, this implements React's rendering and reconciliation algorithm.
     * Sophisticated clients may wish to override this.
     *
     * @param {ReactReconcileTransaction} transaction
     * @internal
     * @overridable
     */
    updateComponent: 'OVERRIDE_BASE'
  };

  /**
   * Similar to ReactClassInterface but for static methods.
   */
  var ReactClassStaticInterface = {
    /**
     * This method is invoked after a component is instantiated and when it
     * receives new props. Return an object to update state in response to
     * prop changes. Return null to indicate no change to state.
     *
     * If an object is returned, its keys will be merged into the existing state.
     *
     * @return {object || null}
     * @optional
     */
    getDerivedStateFromProps: 'DEFINE_MANY_MERGED'
  };

  /**
   * Mapping from class specification keys to special processing functions.
   *
   * Although these are declared like instance properties in the specification
   * when defining classes using `React.createClass`, they are actually static
   * and are accessible on the constructor instead of the prototype. Despite
   * being static, they must be defined outside of the "statics" key under
   * which all other static methods are defined.
   */
  var RESERVED_SPEC_KEYS = {
    displayName: function(Constructor, displayName) {
      Constructor.displayName = displayName;
    },
    mixins: function(Constructor, mixins) {
      if (mixins) {
        for (var i = 0; i < mixins.length; i++) {
          mixSpecIntoComponent(Constructor, mixins[i]);
        }
      }
    },
    childContextTypes: function(Constructor, childContextTypes) {
      if (false) {
        validateTypeDef(Constructor, childContextTypes, 'childContext');
      }
      Constructor.childContextTypes = _assign(
        {},
        Constructor.childContextTypes,
        childContextTypes
      );
    },
    contextTypes: function(Constructor, contextTypes) {
      if (false) {
        validateTypeDef(Constructor, contextTypes, 'context');
      }
      Constructor.contextTypes = _assign(
        {},
        Constructor.contextTypes,
        contextTypes
      );
    },
    /**
     * Special case getDefaultProps which should move into statics but requires
     * automatic merging.
     */
    getDefaultProps: function(Constructor, getDefaultProps) {
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps = createMergedResultFunction(
          Constructor.getDefaultProps,
          getDefaultProps
        );
      } else {
        Constructor.getDefaultProps = getDefaultProps;
      }
    },
    propTypes: function(Constructor, propTypes) {
      if (false) {
        validateTypeDef(Constructor, propTypes, 'prop');
      }
      Constructor.propTypes = _assign({}, Constructor.propTypes, propTypes);
    },
    statics: function(Constructor, statics) {
      mixStaticSpecIntoComponent(Constructor, statics);
    },
    autobind: function() {}
  };

  function validateTypeDef(Constructor, typeDef, location) {
    for (var propName in typeDef) {
      if (typeDef.hasOwnProperty(propName)) {
        // use a warning instead of an _invariant so components
        // don't show up in prod but only in __DEV__
        if (false) {
          warning(
            typeof typeDef[propName] === 'function',
            '%s: %s type `%s` is invalid; it must be a function, usually from ' +
              'React.PropTypes.',
            Constructor.displayName || 'ReactClass',
            ReactPropTypeLocationNames[location],
            propName
          );
        }
      }
    }
  }

  function validateMethodOverride(isAlreadyDefined, name) {
    var specPolicy = ReactClassInterface.hasOwnProperty(name)
      ? ReactClassInterface[name]
      : null;

    // Disallow overriding of base class methods unless explicitly allowed.
    if (ReactClassMixin.hasOwnProperty(name)) {
      _invariant(
        specPolicy === 'OVERRIDE_BASE',
        'ReactClassInterface: You are attempting to override ' +
          '`%s` from your class specification. Ensure that your method names ' +
          'do not overlap with React methods.',
        name
      );
    }

    // Disallow defining methods more than once unless explicitly allowed.
    if (isAlreadyDefined) {
      _invariant(
        specPolicy === 'DEFINE_MANY' || specPolicy === 'DEFINE_MANY_MERGED',
        'ReactClassInterface: You are attempting to define ' +
          '`%s` on your component more than once. This conflict may be due ' +
          'to a mixin.',
        name
      );
    }
  }

  /**
   * Mixin helper which handles policy validation and reserved
   * specification keys when building React classes.
   */
  function mixSpecIntoComponent(Constructor, spec) {
    if (!spec) {
      if (false) {
        var typeofSpec = typeof spec;
        var isMixinValid = typeofSpec === 'object' && spec !== null;

        if (process.env.NODE_ENV !== 'production') {
          warning(
            isMixinValid,
            "%s: You're attempting to include a mixin that is either null " +
              'or not an object. Check the mixins included by the component, ' +
              'as well as any mixins they include themselves. ' +
              'Expected object but got %s.',
            Constructor.displayName || 'ReactClass',
            spec === null ? null : typeofSpec
          );
        }
      }

      return;
    }

    _invariant(
      typeof spec !== 'function',
      "ReactClass: You're attempting to " +
        'use a component class or function as a mixin. Instead, just use a ' +
        'regular object.'
    );
    _invariant(
      !isValidElement(spec),
      "ReactClass: You're attempting to " +
        'use a component as a mixin. Instead, just use a regular object.'
    );

    var proto = Constructor.prototype;
    var autoBindPairs = proto.__reactAutoBindPairs;

    // By handling mixins before any other properties, we ensure the same
    // chaining order is applied to methods with DEFINE_MANY policy, whether
    // mixins are listed before or after these methods in the spec.
    if (spec.hasOwnProperty(MIXINS_KEY)) {
      RESERVED_SPEC_KEYS.mixins(Constructor, spec.mixins);
    }

    for (var name in spec) {
      if (!spec.hasOwnProperty(name)) {
        continue;
      }

      if (name === MIXINS_KEY) {
        // We have already handled mixins in a special case above.
        continue;
      }

      var property = spec[name];
      var isAlreadyDefined = proto.hasOwnProperty(name);
      validateMethodOverride(isAlreadyDefined, name);

      if (RESERVED_SPEC_KEYS.hasOwnProperty(name)) {
        RESERVED_SPEC_KEYS[name](Constructor, property);
      } else {
        // Setup methods on prototype:
        // The following member methods should not be automatically bound:
        // 1. Expected ReactClass methods (in the "interface").
        // 2. Overridden methods (that were mixed in).
        var isReactClassMethod = ReactClassInterface.hasOwnProperty(name);
        var isFunction = typeof property === 'function';
        var shouldAutoBind =
          isFunction &&
          !isReactClassMethod &&
          !isAlreadyDefined &&
          spec.autobind !== false;

        if (shouldAutoBind) {
          autoBindPairs.push(name, property);
          proto[name] = property;
        } else {
          if (isAlreadyDefined) {
            var specPolicy = ReactClassInterface[name];

            // These cases should already be caught by validateMethodOverride.
            _invariant(
              isReactClassMethod &&
                (specPolicy === 'DEFINE_MANY_MERGED' ||
                  specPolicy === 'DEFINE_MANY'),
              'ReactClass: Unexpected spec policy %s for key %s ' +
                'when mixing in component specs.',
              specPolicy,
              name
            );

            // For methods which are defined more than once, call the existing
            // methods before calling the new property, merging if appropriate.
            if (specPolicy === 'DEFINE_MANY_MERGED') {
              proto[name] = createMergedResultFunction(proto[name], property);
            } else if (specPolicy === 'DEFINE_MANY') {
              proto[name] = createChainedFunction(proto[name], property);
            }
          } else {
            proto[name] = property;
            if (false) {
              // Add verbose displayName to the function, which helps when looking
              // at profiling tools.
              if (typeof property === 'function' && spec.displayName) {
                proto[name].displayName = spec.displayName + '_' + name;
              }
            }
          }
        }
      }
    }
  }

  function mixStaticSpecIntoComponent(Constructor, statics) {
    if (!statics) {
      return;
    }

    for (var name in statics) {
      var property = statics[name];
      if (!statics.hasOwnProperty(name)) {
        continue;
      }

      var isReserved = name in RESERVED_SPEC_KEYS;
      _invariant(
        !isReserved,
        'ReactClass: You are attempting to define a reserved ' +
          'property, `%s`, that shouldn\'t be on the "statics" key. Define it ' +
          'as an instance property instead; it will still be accessible on the ' +
          'constructor.',
        name
      );

      var isAlreadyDefined = name in Constructor;
      if (isAlreadyDefined) {
        var specPolicy = ReactClassStaticInterface.hasOwnProperty(name)
          ? ReactClassStaticInterface[name]
          : null;

        _invariant(
          specPolicy === 'DEFINE_MANY_MERGED',
          'ReactClass: You are attempting to define ' +
            '`%s` on your component more than once. This conflict may be ' +
            'due to a mixin.',
          name
        );

        Constructor[name] = createMergedResultFunction(Constructor[name], property);

        return;
      }

      Constructor[name] = property;
    }
  }

  /**
   * Merge two objects, but throw if both contain the same key.
   *
   * @param {object} one The first object, which is mutated.
   * @param {object} two The second object
   * @return {object} one after it has been mutated to contain everything in two.
   */
  function mergeIntoWithNoDuplicateKeys(one, two) {
    _invariant(
      one && two && typeof one === 'object' && typeof two === 'object',
      'mergeIntoWithNoDuplicateKeys(): Cannot merge non-objects.'
    );

    for (var key in two) {
      if (two.hasOwnProperty(key)) {
        _invariant(
          one[key] === undefined,
          'mergeIntoWithNoDuplicateKeys(): ' +
            'Tried to merge two objects with the same key: `%s`. This conflict ' +
            'may be due to a mixin; in particular, this may be caused by two ' +
            'getInitialState() or getDefaultProps() methods returning objects ' +
            'with clashing keys.',
          key
        );
        one[key] = two[key];
      }
    }
    return one;
  }

  /**
   * Creates a function that invokes two functions and merges their return values.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createMergedResultFunction(one, two) {
    return function mergedResult() {
      var a = one.apply(this, arguments);
      var b = two.apply(this, arguments);
      if (a == null) {
        return b;
      } else if (b == null) {
        return a;
      }
      var c = {};
      mergeIntoWithNoDuplicateKeys(c, a);
      mergeIntoWithNoDuplicateKeys(c, b);
      return c;
    };
  }

  /**
   * Creates a function that invokes two functions and ignores their return vales.
   *
   * @param {function} one Function to invoke first.
   * @param {function} two Function to invoke second.
   * @return {function} Function that invokes the two argument functions.
   * @private
   */
  function createChainedFunction(one, two) {
    return function chainedFunction() {
      one.apply(this, arguments);
      two.apply(this, arguments);
    };
  }

  /**
   * Binds a method to the component.
   *
   * @param {object} component Component whose method is going to be bound.
   * @param {function} method Method to be bound.
   * @return {function} The bound method.
   */
  function bindAutoBindMethod(component, method) {
    var boundMethod = method.bind(component);
    if (false) {
      boundMethod.__reactBoundContext = component;
      boundMethod.__reactBoundMethod = method;
      boundMethod.__reactBoundArguments = null;
      var componentName = component.constructor.displayName;
      var _bind = boundMethod.bind;
      boundMethod.bind = function(newThis) {
        for (
          var _len = arguments.length,
            args = Array(_len > 1 ? _len - 1 : 0),
            _key = 1;
          _key < _len;
          _key++
        ) {
          args[_key - 1] = arguments[_key];
        }

        // User is trying to bind() an autobound method; we effectively will
        // ignore the value of "this" that the user is trying to use, so
        // let's warn.
        if (newThis !== component && newThis !== null) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): React component methods may only be bound to the ' +
                'component instance. See %s',
              componentName
            );
          }
        } else if (!args.length) {
          if (process.env.NODE_ENV !== 'production') {
            warning(
              false,
              'bind(): You are binding a component method to the component. ' +
                'React does this for you automatically in a high-performance ' +
                'way, so you can safely remove this call. See %s',
              componentName
            );
          }
          return boundMethod;
        }
        var reboundMethod = _bind.apply(boundMethod, arguments);
        reboundMethod.__reactBoundContext = component;
        reboundMethod.__reactBoundMethod = method;
        reboundMethod.__reactBoundArguments = args;
        return reboundMethod;
      };
    }
    return boundMethod;
  }

  /**
   * Binds all auto-bound methods in a component.
   *
   * @param {object} component Component whose method is going to be bound.
   */
  function bindAutoBindMethods(component) {
    var pairs = component.__reactAutoBindPairs;
    for (var i = 0; i < pairs.length; i += 2) {
      var autoBindKey = pairs[i];
      var method = pairs[i + 1];
      component[autoBindKey] = bindAutoBindMethod(component, method);
    }
  }

  var IsMountedPreMixin = {
    componentDidMount: function() {
      this.__isMounted = true;
    }
  };

  var IsMountedPostMixin = {
    componentWillUnmount: function() {
      this.__isMounted = false;
    }
  };

  /**
   * Add more to the ReactClass base class. These are all legacy features and
   * therefore not already part of the modern ReactComponent.
   */
  var ReactClassMixin = {
    /**
     * TODO: This will be deprecated because state should always keep a consistent
     * type signature and the only use case for this, is to avoid that.
     */
    replaceState: function(newState, callback) {
      this.updater.enqueueReplaceState(this, newState, callback);
    },

    /**
     * Checks whether or not this composite component is mounted.
     * @return {boolean} True if mounted, false otherwise.
     * @protected
     * @final
     */
    isMounted: function() {
      if (false) {
        warning(
          this.__didWarnIsMounted,
          '%s: isMounted is deprecated. Instead, make sure to clean up ' +
            'subscriptions and pending requests in componentWillUnmount to ' +
            'prevent memory leaks.',
          (this.constructor && this.constructor.displayName) ||
            this.name ||
            'Component'
        );
        this.__didWarnIsMounted = true;
      }
      return !!this.__isMounted;
    }
  };

  var ReactClassComponent = function() {};
  _assign(
    ReactClassComponent.prototype,
    ReactComponent.prototype,
    ReactClassMixin
  );

  /**
   * Creates a composite component class given a class specification.
   * See https://facebook.github.io/react/docs/top-level-api.html#react.createclass
   *
   * @param {object} spec Class specification (which must define `render`).
   * @return {function} Component constructor function.
   * @public
   */
  function createClass(spec) {
    // To keep our warnings more understandable, we'll use a little hack here to
    // ensure that Constructor.name !== 'Constructor'. This makes sure we don't
    // unnecessarily identify a class without displayName as 'Constructor'.
    var Constructor = identity(function(props, context, updater) {
      // This constructor gets overridden by mocks. The argument is used
      // by mocks to assert on what gets mounted.

      if (false) {
        warning(
          this instanceof Constructor,
          'Something is calling a React component directly. Use a factory or ' +
            'JSX instead. See: https://fb.me/react-legacyfactory'
        );
      }

      // Wire up auto-binding
      if (this.__reactAutoBindPairs.length) {
        bindAutoBindMethods(this);
      }

      this.props = props;
      this.context = context;
      this.refs = emptyObject;
      this.updater = updater || ReactNoopUpdateQueue;

      this.state = null;

      // ReactClasses doesn't have constructors. Instead, they use the
      // getInitialState and componentWillMount methods for initialization.

      var initialState = this.getInitialState ? this.getInitialState() : null;
      if (false) {
        // We allow auto-mocks to proceed as if they're returning null.
        if (
          initialState === undefined &&
          this.getInitialState._isMockFunction
        ) {
          // This is probably bad practice. Consider warning here and
          // deprecating this convenience.
          initialState = null;
        }
      }
      _invariant(
        typeof initialState === 'object' && !Array.isArray(initialState),
        '%s.getInitialState(): must return an object or null',
        Constructor.displayName || 'ReactCompositeComponent'
      );

      this.state = initialState;
    });
    Constructor.prototype = new ReactClassComponent();
    Constructor.prototype.constructor = Constructor;
    Constructor.prototype.__reactAutoBindPairs = [];

    injectedMixins.forEach(mixSpecIntoComponent.bind(null, Constructor));

    mixSpecIntoComponent(Constructor, IsMountedPreMixin);
    mixSpecIntoComponent(Constructor, spec);
    mixSpecIntoComponent(Constructor, IsMountedPostMixin);

    // Initialize the defaultProps property after all mixins have been merged.
    if (Constructor.getDefaultProps) {
      Constructor.defaultProps = Constructor.getDefaultProps();
    }

    if (false) {
      // This is a tag to indicate that the use of these method names is ok,
      // since it's used with createClass. If it's not, then it's likely a
      // mistake so we'll warn you to use the static property, property
      // initializer or constructor respectively.
      if (Constructor.getDefaultProps) {
        Constructor.getDefaultProps.isReactClassApproved = {};
      }
      if (Constructor.prototype.getInitialState) {
        Constructor.prototype.getInitialState.isReactClassApproved = {};
      }
    }

    _invariant(
      Constructor.prototype.render,
      'createClass(...): Class specification must implement a `render` method.'
    );

    if (false) {
      warning(
        !Constructor.prototype.componentShouldUpdate,
        '%s has a method called ' +
          'componentShouldUpdate(). Did you mean shouldComponentUpdate()? ' +
          'The name is phrased as a question because the function is ' +
          'expected to return a value.',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.componentWillRecieveProps,
        '%s has a method called ' +
          'componentWillRecieveProps(). Did you mean componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
      warning(
        !Constructor.prototype.UNSAFE_componentWillRecieveProps,
        '%s has a method called UNSAFE_componentWillRecieveProps(). ' +
          'Did you mean UNSAFE_componentWillReceiveProps()?',
        spec.displayName || 'A component'
      );
    }

    // Reduce time spent doing lookups by setting these on the prototype.
    for (var methodName in ReactClassInterface) {
      if (!Constructor.prototype[methodName]) {
        Constructor.prototype[methodName] = null;
      }
    }

    return Constructor;
  }

  return createClass;
}

module.exports = factory;


/***/ }),
/* 300 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__(19);

var util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

/**
 *  Rule for validating required fields.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function required(rule, value, source, errors, options, type) {
  if (rule.required && (!source.hasOwnProperty(rule.field) || util.isEmptyValue(value, type || rule.type))) {
    errors.push(util.format(options.messages.required, rule.fullField));
  }
}

exports['default'] = required;

/***/ }),
/* 301 */
/***/ (function(module, exports, __webpack_require__) {

var baseSet = __webpack_require__(261);

/**
 * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
 * it's created. Arrays are created for missing index properties while objects
 * are created for all other missing properties. Use `_.setWith` to customize
 * `path` creation.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 3.7.0
 * @category Object
 * @param {Object} object The object to modify.
 * @param {Array|string} path The path of the property to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = { 'a': [{ 'b': { 'c': 3 } }] };
 *
 * _.set(object, 'a[0].b.c', 4);
 * console.log(object.a[0].b.c);
 * // => 4
 *
 * _.set(object, ['x', '0', 'y', 'z'], 5);
 * console.log(object.x[0].y.z);
 * // => 5
 */
function set(object, path, value) {
  return object == null ? object : baseSet(object, path, value);
}

module.exports = set;


/***/ }),
/* 302 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(49);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(63);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

exports.isFormField = isFormField;
exports["default"] = createFormField;

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var Field = function Field(fields) {
  (0, _classCallCheck3["default"])(this, Field);

  (0, _extends3["default"])(this, fields);
};

function isFormField(obj) {
  return obj instanceof Field;
}

function createFormField(field) {
  if (isFormField(field)) {
    return field;
  }
  return new Field(field);
}

/***/ }),
/* 303 */
/***/ (function(module, exports) {

module.exports = function(arr, obj){
  if (arr.indexOf) return arr.indexOf(obj);
  for (var i = 0; i < arr.length; ++i) {
    if (arr[i] === obj) return i;
  }
  return -1;
};

/***/ }),
/* 304 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var util = {
  isAppearSupported: function isAppearSupported(props) {
    return props.transitionName && props.transitionAppear || props.animation.appear;
  },
  isEnterSupported: function isEnterSupported(props) {
    return props.transitionName && props.transitionEnter || props.animation.enter;
  },
  isLeaveSupported: function isLeaveSupported(props) {
    return props.transitionName && props.transitionLeave || props.animation.leave;
  },
  allowAppearCallback: function allowAppearCallback(props) {
    return props.transitionAppear || props.animation.appear;
  },
  allowEnterCallback: function allowEnterCallback(props) {
    return props.transitionEnter || props.animation.enter;
  },
  allowLeaveCallback: function allowLeaveCallback(props) {
    return props.transitionLeave || props.animation.leave;
  }
};
/* harmony default export */ __webpack_exports__["a"] = (util);

/***/ }),
/* 305 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createReactContext = _interopRequireDefault(__webpack_require__(188));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var RowContext = (0, _createReactContext["default"])({});
var _default = RowContext;
exports["default"] = _default;

/***/ }),
/* 306 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.FIELD_DATA_PROP = exports.FIELD_META_PROP = void 0;
var FIELD_META_PROP = 'data-__meta';
exports.FIELD_META_PROP = FIELD_META_PROP;
var FIELD_DATA_PROP = 'data-__field';
exports.FIELD_DATA_PROP = FIELD_DATA_PROP;

/***/ }),
/* 307 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _createReactContext = _interopRequireDefault(__webpack_require__(188));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var FormContext = (0, _createReactContext["default"])({
  labelAlign: 'right',
  vertical: false
});
var _default = FormContext;
exports["default"] = _default;

/***/ }),
/* 308 */
/***/ (function(module, exports) {

/** Error message constants. */
var FUNC_ERROR_TEXT = 'Expected a function';

/**
 * Creates a function that negates the result of the predicate `func`. The
 * `func` predicate is invoked with the `this` binding and arguments of the
 * created function.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Function
 * @param {Function} predicate The predicate to negate.
 * @returns {Function} Returns the new negated function.
 * @example
 *
 * function isEven(n) {
 *   return n % 2 == 0;
 * }
 *
 * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
 * // => [1, 3, 5]
 */
function negate(predicate) {
  if (typeof predicate != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  return function() {
    var args = arguments;
    switch (args.length) {
      case 0: return !predicate.call(this);
      case 1: return !predicate.call(this, args[0]);
      case 2: return !predicate.call(this, args[0], args[1]);
      case 3: return !predicate.call(this, args[0], args[1], args[2]);
    }
    return !predicate.apply(this, args);
  };
}

module.exports = negate;


/***/ }),
/* 309 */
/***/ (function(module, exports, __webpack_require__) {

var arrayPush = __webpack_require__(153),
    getPrototype = __webpack_require__(191),
    getSymbols = __webpack_require__(154),
    stubArray = __webpack_require__(239);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeGetSymbols = Object.getOwnPropertySymbols;

/**
 * Creates an array of the own and inherited enumerable symbols of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of symbols.
 */
var getSymbolsIn = !nativeGetSymbols ? stubArray : function(object) {
  var result = [];
  while (object) {
    arrayPush(result, getSymbols(object));
    object = getPrototype(object);
  }
  return result;
};

module.exports = getSymbolsIn;


/***/ }),
/* 310 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _utils = __webpack_require__(135);

var _utils2 = _interopRequireDefault(_utils);

var _smooth = __webpack_require__(727);

var _smooth2 = _interopRequireDefault(_smooth);

var _cancelEvents = __webpack_require__(728);

var _cancelEvents2 = _interopRequireDefault(_cancelEvents);

var _scrollEvents = __webpack_require__(197);

var _scrollEvents2 = _interopRequireDefault(_scrollEvents);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/*
 * Gets the easing type from the smooth prop within options.
 */
var getAnimationType = function getAnimationType(options) {
  return _smooth2.default[options.smooth] || _smooth2.default.defaultEasing;
};
/*
 * Function helper
 */
var functionWrapper = function functionWrapper(value) {
  return typeof value === 'function' ? value : function () {
    return value;
  };
};
/*
 * Wraps window properties to allow server side rendering
 */
var currentWindowProperties = function currentWindowProperties() {
  if (typeof window !== 'undefined') {
    return window.requestAnimationFrame || window.webkitRequestAnimationFrame;
  }
};

/*
 * Helper function to never extend 60fps on the webpage.
 */
var requestAnimationFrameHelper = function () {
  return currentWindowProperties() || function (callback, element, delay) {
    window.setTimeout(callback, delay || 1000 / 60, new Date().getTime());
  };
}();

var makeData = function makeData() {
  return {
    currentPosition: 0,
    startPosition: 0,
    targetPosition: 0,
    progress: 0,
    duration: 0,
    cancel: false,

    target: null,
    containerElement: null,
    to: null,
    start: null,
    delta: null,
    percent: null,
    delayTimeout: null
  };
};

var currentPositionX = function currentPositionX(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollLeft;
  } else {
    var supportPageOffset = window.pageXOffset !== undefined;
    var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
    return supportPageOffset ? window.pageXOffset : isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft;
  }
};

var currentPositionY = function currentPositionY(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollTop;
  } else {
    var supportPageOffset = window.pageXOffset !== undefined;
    var isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
    return supportPageOffset ? window.pageYOffset : isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop;
  }
};

var scrollContainerWidth = function scrollContainerWidth(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollWidth - containerElement.offsetWidth;
  } else {
    var body = document.body;
    var html = document.documentElement;

    return Math.max(body.scrollWidth, body.offsetWidth, html.clientWidth, html.scrollWidth, html.offsetWidth);
  }
};

var scrollContainerHeight = function scrollContainerHeight(options) {
  var containerElement = options.data.containerElement;
  if (containerElement && containerElement !== document && containerElement !== document.body) {
    return containerElement.scrollHeight - containerElement.offsetHeight;
  } else {
    var body = document.body;
    var html = document.documentElement;

    return Math.max(body.scrollHeight, body.offsetHeight, html.clientHeight, html.scrollHeight, html.offsetHeight);
  }
};

var animateScroll = function animateScroll(easing, options, timestamp) {
  var data = options.data;

  // Cancel on specific events
  if (!options.ignoreCancelEvents && data.cancel) {
    if (_scrollEvents2.default.registered['end']) {
      _scrollEvents2.default.registered['end'](data.to, data.target, data.currentPositionY);
    }
    return;
  };

  data.delta = Math.round(data.targetPosition - data.startPosition);

  if (data.start === null) {
    data.start = timestamp;
  }

  data.progress = timestamp - data.start;

  data.percent = data.progress >= data.duration ? 1 : easing(data.progress / data.duration);

  data.currentPosition = data.startPosition + Math.ceil(data.delta * data.percent);

  if (data.containerElement && data.containerElement !== document && data.containerElement !== document.body) {
    if (options.horizontal) {
      data.containerElement.scrollLeft = data.currentPosition;
    } else {
      data.containerElement.scrollTop = data.currentPosition;
    }
  } else {
    if (options.horizontal) {
      window.scrollTo(data.currentPosition, 0);
    } else {
      window.scrollTo(0, data.currentPosition);
    }
  }

  if (data.percent < 1) {
    var easedAnimate = animateScroll.bind(null, easing, options);
    requestAnimationFrameHelper.call(window, easedAnimate);
    return;
  }

  if (_scrollEvents2.default.registered['end']) {
    _scrollEvents2.default.registered['end'](data.to, data.target, data.currentPosition);
  }
};

var setContainer = function setContainer(options) {
  options.data.containerElement = !options ? null : options.containerId ? document.getElementById(options.containerId) : options.container && options.container.nodeType ? options.container : document;
};

var animateTopScroll = function animateTopScroll(scrollOffset, options, to, target) {
  options.data = options.data || makeData();

  window.clearTimeout(options.data.delayTimeout);

  var setCancel = function setCancel() {
    options.data.cancel = true;
  };
  _cancelEvents2.default.subscribe(setCancel);

  setContainer(options);

  options.data.start = null;
  options.data.cancel = false;
  options.data.startPosition = options.horizontal ? currentPositionX(options) : currentPositionY(options);
  options.data.targetPosition = options.absolute ? scrollOffset : scrollOffset + options.data.startPosition;

  if (options.data.startPosition === options.data.targetPosition) {
    if (_scrollEvents2.default.registered['end']) {
      _scrollEvents2.default.registered['end'](options.data.to, options.data.target, options.data.currentPosition);
    }
    return;
  }

  options.data.delta = Math.round(options.data.targetPosition - options.data.startPosition);

  options.data.duration = functionWrapper(options.duration)(options.data.delta);
  options.data.duration = isNaN(parseFloat(options.data.duration)) ? 1000 : parseFloat(options.data.duration);
  options.data.to = to;
  options.data.target = target;

  var easing = getAnimationType(options);
  var easedAnimate = animateScroll.bind(null, easing, options);

  if (options && options.delay > 0) {
    options.data.delayTimeout = window.setTimeout(function () {
      if (_scrollEvents2.default.registered['begin']) {
        _scrollEvents2.default.registered['begin'](options.data.to, options.data.target);
      }
      requestAnimationFrameHelper.call(window, easedAnimate);
    }, options.delay);
    return;
  }

  if (_scrollEvents2.default.registered['begin']) {
    _scrollEvents2.default.registered['begin'](options.data.to, options.data.target);
  }
  requestAnimationFrameHelper.call(window, easedAnimate);
};

var proceedOptions = function proceedOptions(options) {
  options = _extends({}, options);
  options.data = options.data || makeData();
  options.absolute = true;
  return options;
};

var scrollToTop = function scrollToTop(options) {
  animateTopScroll(0, proceedOptions(options));
};

var scrollTo = function scrollTo(toPosition, options) {
  animateTopScroll(toPosition, proceedOptions(options));
};

var scrollToBottom = function scrollToBottom(options) {
  options = proceedOptions(options);
  setContainer(options);
  animateTopScroll(options.horizontal ? scrollContainerWidth(options) : scrollContainerHeight(options), options);
};

var scrollMore = function scrollMore(toPosition, options) {
  options = proceedOptions(options);
  setContainer(options);
  var currentPosition = options.horizontal ? currentPositionX(options) : currentPositionY(options);
  animateTopScroll(toPosition + currentPosition, options);
};

exports.default = {
  animateTopScroll: animateTopScroll,
  getAnimationType: getAnimationType,
  scrollToTop: scrollToTop,
  scrollToBottom: scrollToBottom,
  scrollTo: scrollTo,
  scrollMore: scrollMore
};

/***/ }),
/* 311 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _passiveEventListeners = __webpack_require__(196);

var _utils = __webpack_require__(135);

var _utils2 = _interopRequireDefault(_utils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var scrollHash = {
  mountFlag: false,
  initialized: false,
  scroller: null,
  containers: {},

  mount: function mount(scroller) {
    this.scroller = scroller;

    this.handleHashChange = this.handleHashChange.bind(this);
    window.addEventListener('hashchange', this.handleHashChange);

    this.initStateFromHash();
    this.mountFlag = true;
  },
  mapContainer: function mapContainer(to, container) {
    this.containers[to] = container;
  },
  isMounted: function isMounted() {
    return this.mountFlag;
  },
  isInitialized: function isInitialized() {
    return this.initialized;
  },
  initStateFromHash: function initStateFromHash() {
    var _this = this;

    var hash = this.getHash();
    if (hash) {
      window.setTimeout(function () {
        _this.scrollTo(hash, true);
        _this.initialized = true;
      }, 10);
    } else {
      this.initialized = true;
    }
  },
  scrollTo: function scrollTo(to, isInit) {
    var scroller = this.scroller;
    var element = scroller.get(to);
    if (element && (isInit || to !== scroller.getActiveLink())) {
      var container = this.containers[to] || document;
      scroller.scrollTo(to, { container: container });
    }
  },
  getHash: function getHash() {
    return _utils2.default.getHash();
  },
  changeHash: function changeHash(to, saveHashHistory) {
    if (this.isInitialized() && _utils2.default.getHash() !== to) {
      _utils2.default.updateHash(to, saveHashHistory);
    }
  },
  handleHashChange: function handleHashChange() {
    this.scrollTo(this.getHash());
  },
  unmount: function unmount() {
    this.scroller = null;
    this.containers = null;
    window.removeEventListener('hashchange', this.handleHashChange);
  }
};

exports.default = scrollHash;

/***/ }),
/* 312 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(30);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _scroller = __webpack_require__(134);

var _scroller2 = _interopRequireDefault(_scroller);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

exports.default = function (Component) {
  var Element = function (_React$Component) {
    _inherits(Element, _React$Component);

    function Element(props) {
      _classCallCheck(this, Element);

      var _this = _possibleConstructorReturn(this, (Element.__proto__ || Object.getPrototypeOf(Element)).call(this, props));

      _this.childBindings = {
        domNode: null
      };
      return _this;
    }

    _createClass(Element, [{
      key: 'componentDidMount',
      value: function componentDidMount() {
        if (typeof window === 'undefined') {
          return false;
        }
        this.registerElems(this.props.name);
      }
    }, {
      key: 'componentDidUpdate',
      value: function componentDidUpdate(prevProps) {
        if (this.props.name !== prevProps.name) {
          this.registerElems(this.props.name);
        }
      }
    }, {
      key: 'componentWillUnmount',
      value: function componentWillUnmount() {
        if (typeof window === 'undefined') {
          return false;
        }
        _scroller2.default.unregister(this.props.name);
      }
    }, {
      key: 'registerElems',
      value: function registerElems(name) {
        _scroller2.default.register(name, this.childBindings.domNode);
      }
    }, {
      key: 'render',
      value: function render() {
        return _react2.default.createElement(Component, _extends({}, this.props, { parentBindings: this.childBindings }));
      }
    }]);

    return Element;
  }(_react2.default.Component);

  ;

  Element.propTypes = {
    name: _propTypes2.default.string,
    id: _propTypes2.default.string
  };

  return Element;
};

/***/ }),
/* 313 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var width=_ref.width,height=_ref.height,fill=_ref.fill;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{fill:fill,version:"1.1",x:"0px",y:"0px",width:width,height:height,viewBox:"0 0 512 512",xmlSpace:"preserve"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(0 -150)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("line",{fill:"none",stroke:fill,strokeWidth:"20",x1:"17.7",y1:"489.3",x2:"256",y2:"256"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("line",{fill:"none",stroke:fill,strokeWidth:"20",x1:"256",y1:"256",x2:"489.3",y2:"489.3"})));});

/***/ }),
/* 314 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return BackgroundImage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_pick__ = __webpack_require__(259);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_pick___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_pick__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_styled_components__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;var _templateObject=_taggedTemplateLiteral(["\n  height: 100%;\n  background-position: ",";\n  background-repeat: ",";\n  background-size: ",";\n  ",";\n"],["\n  height: 100%;\n  background-position: ",";\n  background-repeat: ",";\n  background-size: ",";\n  ",";\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var noImage=Object(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* assetsPath */])("phuket-laguna-village-residences")+"/images/No_Image_Available.jpg";var BackgroundImageStyle=__WEBPACK_IMPORTED_MODULE_4_styled_components__["b" /* default */].div(_templateObject,function(props){return props.position;},function(props){return props.repeat;},function(props){return props.size;},function(props){if(props.responsive){if(props.sm){return"\n          @media (max-width: 540px) {\n            background-image: url('"+props.sm+"');\n          }\n        ";}if(props.md){return"\n          @media (min-width: 541px) and (max-width: 720px) {\n            background-image: url('"+props.md+"');\n          }\n        ";}if(props.lg){return"\n          @media (min-width: 721px) and (max-width: 960px) {\n            background-image: url('"+props.md+"');\n          }\n        ";}if(props.xl){return"\n          @media (min-width: 961px) and (max-width: 1326px) {\n            background-image: url('"+props.md+"');\n          }\n        ";}if(!props.sm&&!props.md&&!props.lg&&!props.xl){return"\n          background-image: url('"+props.image+"');\n        ";}else{return"\n          @media (min-width: 1327px) {\n            background-image: url('"+props.image+"');\n          }\n        ";}}else{return"\n        background-image: url('"+props.image+"');\n      ";}});var BackgroundImage=(_temp=_class=function(_Component){_inherits(BackgroundImage,_Component);function BackgroundImage(){_classCallCheck(this,BackgroundImage);return _possibleConstructorReturn(this,(BackgroundImage.__proto__||Object.getPrototypeOf(BackgroundImage)).apply(this,arguments));}_createClass(BackgroundImage,[{key:"shouldComponentUpdate",value:function shouldComponentUpdate(nextProps){var fieldToCheck=["className","image","position","repeat","size","style","children"];var _nextProps=__WEBPACK_IMPORTED_MODULE_1_lodash_pick___default()(nextProps,fieldToCheck);var _thisProps=__WEBPACK_IMPORTED_MODULE_1_lodash_pick___default()(this.props,fieldToCheck);return!__WEBPACK_IMPORTED_MODULE_0_lodash_isEqual___default()(_nextProps,_thisProps);}},{key:"render",value:function render(){var _props=this.props,image=_props.image,children=_props.children;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(BackgroundImageStyle,Object.assign({},this.props,{image:image||noImage}),children);}}]);return BackgroundImage;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]),_class.propTypes={className:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,image:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,position:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,repeat:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,size:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.string,children:__WEBPACK_IMPORTED_MODULE_3_prop_types___default.a.node},_class.defaultProps={className:"",image:noImage,position:"center",repeat:"no-repeat",size:"cover",children:null},_temp);

/***/ }),
/* 315 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _default; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_animejs__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_animejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_animejs__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var defaultStyle={opacity:0,transform:'translateY(20px)'};var _default=(_temp=_class=function(_React$Component){_inherits(_default,_React$Component);function _default(props){_classCallCheck(this,_default);var _this=_possibleConstructorReturn(this,(_default.__proto__||Object.getPrototypeOf(_default)).call(this,props));_this.componentDidUpdate=function(prevProps){if(prevProps.animState!==_this.props.animState){if(_this.props.animState==='entering'){var _this$props=_this.props,transitionDuration=_this$props.transitionDuration,transitionInDelay=_this$props.transitionInDelay;__WEBPACK_IMPORTED_MODULE_1_animejs___default()({targets:'.animated-item',translateY:0,translateZ:1,opacity:1,elasticity:100,duration:transitionDuration,delay:function delay(el,i,l){return transitionInDelay+i*100;}});}else if(_this.props.animState==='exiting'){__WEBPACK_IMPORTED_MODULE_1_animejs___default()({targets:'.animated-item',translateY:20,translateZ:1,opacity:0,elasticity:100,duration:1000,delay:function delay(el,i,l){return(l-i-1)*100;}});}}};_this.listRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();return _this;}_createClass(_default,[{key:'componentDidMount',value:function componentDidMount(){var _props=this.props,transitionDuration=_props.transitionDuration,transitionInDelay=_props.transitionInDelay;__WEBPACK_IMPORTED_MODULE_1_animejs___default()({targets:'.animated-item',translateY:0,translateZ:1,opacity:1,elasticity:100,duration:transitionDuration,delay:function delay(el,i,l){return transitionInDelay+i*100;}});}},{key:'render',value:function render(){var children=this.props.children;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('nav',{className:'list',ref:this.listRef},__WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.map(children,function(child,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'animated-item',style:defaultStyle,key:'subitem-'+index},child);}));}}]);return _default;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component),_class.defaultProps={transitionInDelay:0,transitionDuration:1500,animState:'entering'},_temp);

/***/ }),
/* 316 */
/***/ (function(module, exports, __webpack_require__) {

var arrayEach = __webpack_require__(317),
    baseEach = __webpack_require__(123),
    castFunction = __webpack_require__(737),
    isArray = __webpack_require__(13);

/**
 * Iterates over elements of `collection` and invokes `iteratee` for each element.
 * The iteratee is invoked with three arguments: (value, index|key, collection).
 * Iteratee functions may exit iteration early by explicitly returning `false`.
 *
 * **Note:** As with other "Collections" methods, objects with a "length"
 * property are iterated like arrays. To avoid this behavior use `_.forIn`
 * or `_.forOwn` for object iteration.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias each
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} [iteratee=_.identity] The function invoked per iteration.
 * @returns {Array|Object} Returns `collection`.
 * @see _.forEachRight
 * @example
 *
 * _.forEach([1, 2], function(value) {
 *   console.log(value);
 * });
 * // => Logs `1` then `2`.
 *
 * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
 *   console.log(key);
 * });
 * // => Logs 'a' then 'b' (iteration order is not guaranteed).
 */
function forEach(collection, iteratee) {
  var func = isArray(collection) ? arrayEach : baseEach;
  return func(collection, castFunction(iteratee));
}

module.exports = forEach;


/***/ }),
/* 317 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.forEach` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns `array`.
 */
function arrayEach(array, iteratee) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (iteratee(array[index], index, array) === false) {
      break;
    }
  }
  return array;
}

module.exports = arrayEach;


/***/ }),
/* 318 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NewsArticleSummary=(_temp=_class=function(_Component){_inherits(NewsArticleSummary,_Component);function NewsArticleSummary(){_classCallCheck(this,NewsArticleSummary);return _possibleConstructorReturn(this,(NewsArticleSummary.__proto__||Object.getPrototypeOf(NewsArticleSummary)).apply(this,arguments));}_createClass(NewsArticleSummary,[{key:'render',value:function render(){var _props=this.props,title=_props.title,dateString=_props.dateString,to=_props.to,excerpt=_props.excerpt;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'article-title'},title),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'article-date'},dateString),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'article-desc'},excerpt),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["b" /* Link */],{to:to,className:'read-more'},'Read more >'));}}]);return NewsArticleSummary;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.propTypes={title:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,dateString:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,to:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,excerpt:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string},_class.defaultProps={title:"title",dateString:"dateString",to:"/",excerpt:"excerpt"},_temp);/* harmony default export */ __webpack_exports__["a"] = (NewsArticleSummary);

/***/ }),
/* 319 */
/***/ (function(module, exports) {

exports.__esModule = true;
var ATTRIBUTE_NAMES = exports.ATTRIBUTE_NAMES = {
    BODY: "bodyAttributes",
    HTML: "htmlAttributes",
    TITLE: "titleAttributes"
};

var TAG_NAMES = exports.TAG_NAMES = {
    BASE: "base",
    BODY: "body",
    HEAD: "head",
    HTML: "html",
    LINK: "link",
    META: "meta",
    NOSCRIPT: "noscript",
    SCRIPT: "script",
    STYLE: "style",
    TITLE: "title"
};

var VALID_TAG_NAMES = exports.VALID_TAG_NAMES = Object.keys(TAG_NAMES).map(function (name) {
    return TAG_NAMES[name];
});

var TAG_PROPERTIES = exports.TAG_PROPERTIES = {
    CHARSET: "charset",
    CSS_TEXT: "cssText",
    HREF: "href",
    HTTPEQUIV: "http-equiv",
    INNER_HTML: "innerHTML",
    ITEM_PROP: "itemprop",
    NAME: "name",
    PROPERTY: "property",
    REL: "rel",
    SRC: "src"
};

var REACT_TAG_MAP = exports.REACT_TAG_MAP = {
    accesskey: "accessKey",
    charset: "charSet",
    class: "className",
    contenteditable: "contentEditable",
    contextmenu: "contextMenu",
    "http-equiv": "httpEquiv",
    itemprop: "itemProp",
    tabindex: "tabIndex"
};

var HELMET_PROPS = exports.HELMET_PROPS = {
    DEFAULT_TITLE: "defaultTitle",
    DEFER: "defer",
    ENCODE_SPECIAL_CHARACTERS: "encodeSpecialCharacters",
    ON_CHANGE_CLIENT_STATE: "onChangeClientState",
    TITLE_TEMPLATE: "titleTemplate"
};

var HTML_TAG_MAP = exports.HTML_TAG_MAP = Object.keys(REACT_TAG_MAP).reduce(function (obj, key) {
    obj[REACT_TAG_MAP[key]] = key;
    return obj;
}, {});

var SELF_CLOSING_TAGS = exports.SELF_CLOSING_TAGS = [TAG_NAMES.NOSCRIPT, TAG_NAMES.SCRIPT, TAG_NAMES.STYLE];

var HELMET_ATTRIBUTE = exports.HELMET_ATTRIBUTE = "data-react-helmet";

/***/ }),
/* 320 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(27);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-transform: uppercase;\n  font-size: 30px;\n"],["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-transform: uppercase;\n  font-size: 30px;\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Div=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject);var ComingSoon=function(_Component){_inherits(ComingSoon,_Component);function ComingSoon(){_classCallCheck(this,ComingSoon);return _possibleConstructorReturn(this,(ComingSoon.__proto__||Object.getPrototypeOf(ComingSoon)).apply(this,arguments));}_createClass(ComingSoon,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Div,null,"Coming Soon");}}]);return ComingSoon;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* unused harmony default export */ var _unused_webpack_default_export = (ComingSoon);

/***/ }),
/* 321 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(114),
    arrayEach = __webpack_require__(317),
    assignValue = __webpack_require__(169),
    baseAssign = __webpack_require__(794),
    baseAssignIn = __webpack_require__(795),
    cloneBuffer = __webpack_require__(322),
    copyArray = __webpack_require__(201),
    copySymbols = __webpack_require__(796),
    copySymbolsIn = __webpack_require__(797),
    getAllKeys = __webpack_require__(237),
    getAllKeysIn = __webpack_require__(190),
    getTag = __webpack_require__(72),
    initCloneArray = __webpack_require__(798),
    initCloneByTag = __webpack_require__(799),
    initCloneObject = __webpack_require__(324),
    isArray = __webpack_require__(13),
    isBuffer = __webpack_require__(93),
    isMap = __webpack_require__(803),
    isObject = __webpack_require__(31),
    isSet = __webpack_require__(805),
    keys = __webpack_require__(59),
    keysIn = __webpack_require__(109);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values supported by `_.clone`. */
var cloneableTags = {};
cloneableTags[argsTag] = cloneableTags[arrayTag] =
cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] =
cloneableTags[boolTag] = cloneableTags[dateTag] =
cloneableTags[float32Tag] = cloneableTags[float64Tag] =
cloneableTags[int8Tag] = cloneableTags[int16Tag] =
cloneableTags[int32Tag] = cloneableTags[mapTag] =
cloneableTags[numberTag] = cloneableTags[objectTag] =
cloneableTags[regexpTag] = cloneableTags[setTag] =
cloneableTags[stringTag] = cloneableTags[symbolTag] =
cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] =
cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
cloneableTags[errorTag] = cloneableTags[funcTag] =
cloneableTags[weakMapTag] = false;

/**
 * The base implementation of `_.clone` and `_.cloneDeep` which tracks
 * traversed objects.
 *
 * @private
 * @param {*} value The value to clone.
 * @param {boolean} bitmask The bitmask flags.
 *  1 - Deep clone
 *  2 - Flatten inherited properties
 *  4 - Clone symbols
 * @param {Function} [customizer] The function to customize cloning.
 * @param {string} [key] The key of `value`.
 * @param {Object} [object] The parent object of `value`.
 * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
 * @returns {*} Returns the cloned value.
 */
function baseClone(value, bitmask, customizer, key, object, stack) {
  var result,
      isDeep = bitmask & CLONE_DEEP_FLAG,
      isFlat = bitmask & CLONE_FLAT_FLAG,
      isFull = bitmask & CLONE_SYMBOLS_FLAG;

  if (customizer) {
    result = object ? customizer(value, key, object, stack) : customizer(value);
  }
  if (result !== undefined) {
    return result;
  }
  if (!isObject(value)) {
    return value;
  }
  var isArr = isArray(value);
  if (isArr) {
    result = initCloneArray(value);
    if (!isDeep) {
      return copyArray(value, result);
    }
  } else {
    var tag = getTag(value),
        isFunc = tag == funcTag || tag == genTag;

    if (isBuffer(value)) {
      return cloneBuffer(value, isDeep);
    }
    if (tag == objectTag || tag == argsTag || (isFunc && !object)) {
      result = (isFlat || isFunc) ? {} : initCloneObject(value);
      if (!isDeep) {
        return isFlat
          ? copySymbolsIn(value, baseAssignIn(result, value))
          : copySymbols(value, baseAssign(result, value));
      }
    } else {
      if (!cloneableTags[tag]) {
        return object ? value : {};
      }
      result = initCloneByTag(value, tag, isDeep);
    }
  }
  // Check for circular references and return its corresponding clone.
  stack || (stack = new Stack);
  var stacked = stack.get(value);
  if (stacked) {
    return stacked;
  }
  stack.set(value, result);

  if (isSet(value)) {
    value.forEach(function(subValue) {
      result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
    });
  } else if (isMap(value)) {
    value.forEach(function(subValue, key) {
      result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
    });
  }

  var keysFunc = isFull
    ? (isFlat ? getAllKeysIn : getAllKeys)
    : (isFlat ? keysIn : keys);

  var props = isArr ? undefined : keysFunc(value);
  arrayEach(props || value, function(subValue, key) {
    if (props) {
      key = subValue;
      subValue = value[key];
    }
    // Recursively populate clone (susceptible to call stack limits).
    assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
  });
  return result;
}

module.exports = baseClone;


/***/ }),
/* 322 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(module) {var root = __webpack_require__(40);

/** Detect free variable `exports`. */
var freeExports = typeof exports == 'object' && exports && !exports.nodeType && exports;

/** Detect free variable `module`. */
var freeModule = freeExports && typeof module == 'object' && module && !module.nodeType && module;

/** Detect the popular CommonJS extension `module.exports`. */
var moduleExports = freeModule && freeModule.exports === freeExports;

/** Built-in value references. */
var Buffer = moduleExports ? root.Buffer : undefined,
    allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined;

/**
 * Creates a clone of  `buffer`.
 *
 * @private
 * @param {Buffer} buffer The buffer to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Buffer} Returns the cloned buffer.
 */
function cloneBuffer(buffer, isDeep) {
  if (isDeep) {
    return buffer.slice();
  }
  var length = buffer.length,
      result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);

  buffer.copy(result);
  return result;
}

module.exports = cloneBuffer;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(119)(module)))

/***/ }),
/* 323 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(202);

/**
 * Creates a clone of `typedArray`.
 *
 * @private
 * @param {Object} typedArray The typed array to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned typed array.
 */
function cloneTypedArray(typedArray, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
  return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
}

module.exports = cloneTypedArray;


/***/ }),
/* 324 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(203),
    getPrototype = __webpack_require__(191),
    isPrototype = __webpack_require__(122);

/**
 * Initializes an object clone.
 *
 * @private
 * @param {Object} object The object to clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneObject(object) {
  return (typeof object.constructor == 'function' && !isPrototype(object))
    ? baseCreate(getPrototype(object))
    : {};
}

module.exports = initCloneObject;


/***/ }),
/* 325 */
/***/ (function(module, exports, __webpack_require__) {

var baseMerge = __webpack_require__(807),
    createAssigner = __webpack_require__(811);

/**
 * This method is like `_.assign` except that it recursively merges own and
 * inherited enumerable string keyed properties of source objects into the
 * destination object. Source properties that resolve to `undefined` are
 * skipped if a destination value exists. Array and plain object properties
 * are merged recursively. Other objects and value types are overridden by
 * assignment. Source objects are applied from left to right. Subsequent
 * sources overwrite property assignments of previous sources.
 *
 * **Note:** This method mutates `object`.
 *
 * @static
 * @memberOf _
 * @since 0.5.0
 * @category Object
 * @param {Object} object The destination object.
 * @param {...Object} [sources] The source objects.
 * @returns {Object} Returns `object`.
 * @example
 *
 * var object = {
 *   'a': [{ 'b': 2 }, { 'd': 4 }]
 * };
 *
 * var other = {
 *   'a': [{ 'c': 3 }, { 'e': 5 }]
 * };
 *
 * _.merge(object, other);
 * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
 */
var merge = createAssigner(function(object, source, srcIndex) {
  baseMerge(object, source, srcIndex);
});

module.exports = merge;


/***/ }),
/* 326 */
/***/ (function(module, exports, __webpack_require__) {

var baseAssignValue = __webpack_require__(170),
    eq = __webpack_require__(70);

/**
 * This function is like `assignValue` except that it doesn't assign
 * `undefined` values.
 *
 * @private
 * @param {Object} object The object to modify.
 * @param {string} key The key of the property to assign.
 * @param {*} value The value to assign.
 */
function assignMergeValue(object, key, value) {
  if ((value !== undefined && !eq(object[key], value)) ||
      (value === undefined && !(key in object))) {
    baseAssignValue(object, key, value);
  }
}

module.exports = assignMergeValue;


/***/ }),
/* 327 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(48),
    getPrototype = __webpack_require__(191),
    isObjectLike = __webpack_require__(26);

/** `Object#toString` result references. */
var objectTag = '[object Object]';

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to infer the `Object` constructor. */
var objectCtorString = funcToString.call(Object);

/**
 * Checks if `value` is a plain object, that is, an object created by the
 * `Object` constructor or one with a `[[Prototype]]` of `null`.
 *
 * @static
 * @memberOf _
 * @since 0.8.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 * }
 *
 * _.isPlainObject(new Foo);
 * // => false
 *
 * _.isPlainObject([1, 2, 3]);
 * // => false
 *
 * _.isPlainObject({ 'x': 0, 'y': 0 });
 * // => true
 *
 * _.isPlainObject(Object.create(null));
 * // => true
 */
function isPlainObject(value) {
  if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
    return false;
  }
  var proto = getPrototype(value);
  if (proto === null) {
    return true;
  }
  var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
  return typeof Ctor == 'function' && Ctor instanceof Ctor &&
    funcToString.call(Ctor) == objectCtorString;
}

module.exports = isPlainObject;


/***/ }),
/* 328 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
 *
 * @private
 * @param {Object} object The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function safeGet(object, key) {
  if (key === 'constructor' && typeof object[key] === 'function') {
    return;
  }

  if (key == '__proto__') {
    return;
  }

  return object[key];
}

module.exports = safeGet;


/***/ }),
/* 329 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(98),
    overRest = __webpack_require__(265),
    setToString = __webpack_require__(266);

/**
 * The base implementation of `_.rest` which doesn't validate or coerce arguments.
 *
 * @private
 * @param {Function} func The function to apply a rest parameter to.
 * @param {number} [start=func.length-1] The start position of the rest parameter.
 * @returns {Function} Returns the new function.
 */
function baseRest(func, start) {
  return setToString(overRest(func, start, identity), func + '');
}

module.exports = baseRest;


/***/ }),
/* 330 */
/***/ (function(module, exports, __webpack_require__) {

!function(root, factory) {
     true ? module.exports = factory(__webpack_require__(0)) : "function" == typeof define && define.amd ? define([ "react" ], factory) : "object" == typeof exports ? exports.MediaQuery = factory(require("react")) : root.MediaQuery = factory(root.react);
}("undefined" != typeof self ? self : this, function(__WEBPACK_EXTERNAL_MODULE_5__) {
    return function(modules) {
        function __webpack_require__(moduleId) {
            if (installedModules[moduleId]) return installedModules[moduleId].exports;
            var module = installedModules[moduleId] = {
                i: moduleId,
                l: !1,
                exports: {}
            };
            return modules[moduleId].call(module.exports, module, module.exports, __webpack_require__), 
            module.l = !0, module.exports;
        }
        var installedModules = {};
        return __webpack_require__.m = modules, __webpack_require__.c = installedModules, 
        __webpack_require__.d = function(exports, name, getter) {
            __webpack_require__.o(exports, name) || Object.defineProperty(exports, name, {
                configurable: !1,
                enumerable: !0,
                get: getter
            });
        }, __webpack_require__.n = function(module) {
            var getter = module && module.__esModule ? function() {
                return module.default;
            } : function() {
                return module;
            };
            return __webpack_require__.d(getter, "a", getter), getter;
        }, __webpack_require__.o = function(object, property) {
            return Object.prototype.hasOwnProperty.call(object, property);
        }, __webpack_require__.p = "", __webpack_require__(__webpack_require__.s = 4);
    }([ function(module, exports, __webpack_require__) {
        var REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103, isValidElement = function(object) {
            return "object" == typeof object && null !== object && object.$$typeof === REACT_ELEMENT_TYPE;
        };
        module.exports = __webpack_require__(6)(isValidElement, !0);
    }, function(module, exports, __webpack_require__) {
        "use strict";
        module.exports = "SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED";
    }, function(module, exports, __webpack_require__) {
        "use strict";
        function hyphenateStyleName(string) {
            return string in cache ? cache[string] : cache[string] = string.replace(uppercasePattern, "-$&").toLowerCase().replace(msPattern, "-ms-");
        }
        var uppercasePattern = /[A-Z]/g, msPattern = /^ms-/, cache = {};
        module.exports = hyphenateStyleName;
    }, function(module, exports, __webpack_require__) {
        "use strict";
        Object.defineProperty(exports, "__esModule", {
            value: !0
        });
        var _extends = Object.assign || function(target) {
            for (var i = 1; i < arguments.length; i++) {
                var source = arguments[i];
                for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
            }
            return target;
        }, _propTypes = __webpack_require__(0), _propTypes2 = function(obj) {
            return obj && obj.__esModule ? obj : {
                default: obj
            };
        }(_propTypes), stringOrNumber = _propTypes2.default.oneOfType([ _propTypes2.default.string, _propTypes2.default.number ]), matchers = {
            orientation: _propTypes2.default.oneOf([ "portrait", "landscape" ]),
            scan: _propTypes2.default.oneOf([ "progressive", "interlace" ]),
            aspectRatio: _propTypes2.default.string,
            deviceAspectRatio: _propTypes2.default.string,
            height: stringOrNumber,
            deviceHeight: stringOrNumber,
            width: stringOrNumber,
            deviceWidth: stringOrNumber,
            color: _propTypes2.default.bool,
            colorIndex: _propTypes2.default.bool,
            monochrome: _propTypes2.default.bool,
            resolution: stringOrNumber
        }, features = _extends({
            minAspectRatio: _propTypes2.default.string,
            maxAspectRatio: _propTypes2.default.string,
            minDeviceAspectRatio: _propTypes2.default.string,
            maxDeviceAspectRatio: _propTypes2.default.string,
            minHeight: stringOrNumber,
            maxHeight: stringOrNumber,
            minDeviceHeight: stringOrNumber,
            maxDeviceHeight: stringOrNumber,
            minWidth: stringOrNumber,
            maxWidth: stringOrNumber,
            minDeviceWidth: stringOrNumber,
            maxDeviceWidth: stringOrNumber,
            minColor: _propTypes2.default.number,
            maxColor: _propTypes2.default.number,
            minColorIndex: _propTypes2.default.number,
            maxColorIndex: _propTypes2.default.number,
            minMonochrome: _propTypes2.default.number,
            maxMonochrome: _propTypes2.default.number,
            minResolution: stringOrNumber,
            maxResolution: stringOrNumber
        }, matchers), types = {
            all: _propTypes2.default.bool,
            grid: _propTypes2.default.bool,
            aural: _propTypes2.default.bool,
            braille: _propTypes2.default.bool,
            handheld: _propTypes2.default.bool,
            print: _propTypes2.default.bool,
            projection: _propTypes2.default.bool,
            screen: _propTypes2.default.bool,
            tty: _propTypes2.default.bool,
            tv: _propTypes2.default.bool,
            embossed: _propTypes2.default.bool
        }, all = _extends({}, types, features);
        matchers.type = Object.keys(types), exports.default = {
            all: all,
            types: types,
            matchers: matchers,
            features: features
        }, module.exports = exports.default;
    }, function(module, exports, __webpack_require__) {
        "use strict";
        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                default: obj
            };
        }
        function _classCallCheck(instance, Constructor) {
            if (!(instance instanceof Constructor)) throw new TypeError("Cannot call a class as a function");
        }
        function _possibleConstructorReturn(self, call) {
            if (!self) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
            return !call || "object" != typeof call && "function" != typeof call ? self : call;
        }
        function _inherits(subClass, superClass) {
            if ("function" != typeof superClass && null !== superClass) throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
            subClass.prototype = Object.create(superClass && superClass.prototype, {
                constructor: {
                    value: subClass,
                    enumerable: !1,
                    writable: !0,
                    configurable: !0
                }
            }), superClass && (Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass);
        }
        function omit(object, keys) {
            var newObject = _extends({}, object);
            return keys.forEach(function(key) {
                return delete newObject[key];
            }), newObject;
        }
        Object.defineProperty(exports, "__esModule", {
            value: !0
        }), exports.toQuery = exports.default = void 0;
        var _createClass = function() {
            function defineProperties(target, props) {
                for (var i = 0; i < props.length; i++) {
                    var descriptor = props[i];
                    descriptor.enumerable = descriptor.enumerable || !1, descriptor.configurable = !0, 
                    "value" in descriptor && (descriptor.writable = !0), Object.defineProperty(target, descriptor.key, descriptor);
                }
            }
            return function(Constructor, protoProps, staticProps) {
                return protoProps && defineProperties(Constructor.prototype, protoProps), staticProps && defineProperties(Constructor, staticProps), 
                Constructor;
            };
        }(), _extends = Object.assign || function(target) {
            for (var i = 1; i < arguments.length; i++) {
                var source = arguments[i];
                for (var key in source) Object.prototype.hasOwnProperty.call(source, key) && (target[key] = source[key]);
            }
            return target;
        }, _react = __webpack_require__(5), _react2 = _interopRequireDefault(_react), _propTypes = __webpack_require__(0), _propTypes2 = _interopRequireDefault(_propTypes), _matchmediaquery = __webpack_require__(9), _matchmediaquery2 = _interopRequireDefault(_matchmediaquery), _hyphenateStyleName = __webpack_require__(2), _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName), _mediaQuery = __webpack_require__(3), _mediaQuery2 = _interopRequireDefault(_mediaQuery), _toQuery = __webpack_require__(11), _toQuery2 = _interopRequireDefault(_toQuery), defaultTypes = {
            component: _propTypes2.default.node,
            query: _propTypes2.default.string,
            values: _propTypes2.default.shape(_mediaQuery2.default.matchers),
            children: _propTypes2.default.oneOfType([ _propTypes2.default.node, _propTypes2.default.func ]),
            onChange: _propTypes2.default.func,
            onBeforeChange: _propTypes2.default.func
        }, mediaKeys = Object.keys(_mediaQuery2.default.all), excludedQueryKeys = Object.keys(defaultTypes), excludedPropKeys = excludedQueryKeys.concat(mediaKeys), MediaQuery = function(_React$Component) {
            function MediaQuery() {
                var _ref, _temp, _this, _ret;
                _classCallCheck(this, MediaQuery);
                for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) args[_key] = arguments[_key];
                return _temp = _this = _possibleConstructorReturn(this, (_ref = MediaQuery.__proto__ || Object.getPrototypeOf(MediaQuery)).call.apply(_ref, [ this ].concat(args))), 
                _this.state = {
                    matches: !1
                }, _this.updateMatches = function() {
                    _this._mql.matches !== _this.state.matches && _this.setState({
                        matches: _this._mql.matches
                    });
                }, _this.removeMql = function() {
                    _this._mql && (_this._mql.removeListener(_this.updateMatches), _this._mql.dispose());
                }, _ret = _temp, _possibleConstructorReturn(_this, _ret);
            }
            return _inherits(MediaQuery, _React$Component), _createClass(MediaQuery, [ {
                key: "componentWillMount",
                value: function() {
                    this.updateQuery(this.props);
                }
            }, {
                key: "componentWillReceiveProps",
                value: function(nextProps) {
                    this.updateQuery(nextProps);
                }
            }, {
                key: "updateQuery",
                value: function(props) {
                    var values = void 0, forceStatic = !1;
                    if (props.query ? this.query = props.query : this.query = (0, _toQuery2.default)(omit(props, excludedQueryKeys)), 
                    !this.query) throw new Error("Invalid or missing MediaQuery!");
                    props.values && (values = Object.keys(props.values).reduce(function(result, key) {
                        return result[(0, _hyphenateStyleName2.default)(key)] = props.values[key], result;
                    }, {}), 0 !== Object.keys(values).length && (forceStatic = !0)), this.removeMql(), 
                    this._mql = (0, _matchmediaquery2.default)(this.query, values, forceStatic), this._mql.addListener(this.updateMatches), 
                    this.updateMatches();
                }
            }, {
                key: "componentWillUpdate",
                value: function(_, nextState) {
                    this.props.onBeforeChange && this.state.matches !== nextState.matches && this.props.onBeforeChange(this.state.matches);
                }
            }, {
                key: "componentDidUpdate",
                value: function(_, prevState) {
                    this.props.onChange && prevState.matches !== this.state.matches && this.props.onChange(this.state.matches);
                }
            }, {
                key: "componentWillUnmount",
                value: function() {
                    this.removeMql();
                }
            }, {
                key: "render",
                value: function() {
                    if ("function" == typeof this.props.children) return this.props.children(this.state.matches);
                    if (!1 === this.state.matches) return null;
                    var props = omit(this.props, excludedPropKeys), hasMergeProps = Object.keys(props).length > 0, childrenCount = _react2.default.Children.count(this.props.children);
                    return this.props.component || null == this.props.children || hasMergeProps && childrenCount > 1 ? _react2.default.createElement(this.props.component || "div", props, this.props.children) : hasMergeProps ? _react2.default.cloneElement(this.props.children, props) : childrenCount ? this.props.children : null;
                }
            } ]), MediaQuery;
        }(_react2.default.Component);
        MediaQuery.displayName = "MediaQuery", MediaQuery.defaultProps = {
            values: {}
        }, exports.default = MediaQuery, exports.toQuery = _toQuery2.default;
    }, function(module, exports) {
        module.exports = __WEBPACK_EXTERNAL_MODULE_5__;
    }, function(module, exports, __webpack_require__) {
        "use strict";
        function emptyFunctionThatReturnsNull() {
            return null;
        }
        var assign = __webpack_require__(7), ReactPropTypesSecret = __webpack_require__(1), checkPropTypes = __webpack_require__(8), printWarning = function() {};
        printWarning = function(text) {
            var message = "Warning: " + text;
            "undefined" != typeof console && console.error(message);
            try {
                throw new Error(message);
            } catch (x) {}
        }, module.exports = function(isValidElement, throwOnDirectAccess) {
            function getIteratorFn(maybeIterable) {
                var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
                if ("function" == typeof iteratorFn) return iteratorFn;
            }
            function is(x, y) {
                return x === y ? 0 !== x || 1 / x == 1 / y : x !== x && y !== y;
            }
            function PropTypeError(message) {
                this.message = message, this.stack = "";
            }
            function createChainableTypeChecker(validate) {
                function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
                    if (componentName = componentName || ANONYMOUS, propFullName = propFullName || propName, 
                    secret !== ReactPropTypesSecret) {
                        if (throwOnDirectAccess) {
                            var err = new Error("Calling PropTypes validators directly is not supported by the `prop-types` package. Use `PropTypes.checkPropTypes()` to call them. Read more at http://fb.me/use-check-prop-types");
                            throw err.name = "Invariant Violation", err;
                        }
                        if ("undefined" != typeof console) {
                            var cacheKey = componentName + ":" + propName;
                            !manualPropTypeCallCache[cacheKey] && manualPropTypeWarningCount < 3 && (printWarning("You are manually calling a React.PropTypes validation function for the `" + propFullName + "` prop on `" + componentName + "`. This is deprecated and will throw in the standalone `prop-types` package. You may be seeing this warning due to a third-party PropTypes library. See https://fb.me/react-warning-dont-call-proptypes for details."), 
                            manualPropTypeCallCache[cacheKey] = !0, manualPropTypeWarningCount++);
                        }
                    }
                    return null == props[propName] ? isRequired ? new PropTypeError(null === props[propName] ? "The " + location + " `" + propFullName + "` is marked as required in `" + componentName + "`, but its value is `null`." : "The " + location + " `" + propFullName + "` is marked as required in `" + componentName + "`, but its value is `undefined`.") : null : validate(props, propName, componentName, location, propFullName);
                }
                var manualPropTypeCallCache = {}, manualPropTypeWarningCount = 0, chainedCheckType = checkType.bind(null, !1);
                return chainedCheckType.isRequired = checkType.bind(null, !0), chainedCheckType;
            }
            function createPrimitiveTypeChecker(expectedType) {
                function validate(props, propName, componentName, location, propFullName, secret) {
                    var propValue = props[propName];
                    if (getPropType(propValue) !== expectedType) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getPreciseType(propValue) + "` supplied to `" + componentName + "`, expected `" + expectedType + "`.");
                    return null;
                }
                return createChainableTypeChecker(validate);
            }
            function createArrayOfTypeChecker(typeChecker) {
                function validate(props, propName, componentName, location, propFullName) {
                    if ("function" != typeof typeChecker) return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside arrayOf.");
                    var propValue = props[propName];
                    if (!Array.isArray(propValue)) {
                        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getPropType(propValue) + "` supplied to `" + componentName + "`, expected an array.");
                    }
                    for (var i = 0; i < propValue.length; i++) {
                        var error = typeChecker(propValue, i, componentName, location, propFullName + "[" + i + "]", ReactPropTypesSecret);
                        if (error instanceof Error) return error;
                    }
                    return null;
                }
                return createChainableTypeChecker(validate);
            }
            function createInstanceTypeChecker(expectedClass) {
                function validate(props, propName, componentName, location, propFullName) {
                    if (!(props[propName] instanceof expectedClass)) {
                        var expectedClassName = expectedClass.name || ANONYMOUS;
                        return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getClassName(props[propName]) + "` supplied to `" + componentName + "`, expected instance of `" + expectedClassName + "`.");
                    }
                    return null;
                }
                return createChainableTypeChecker(validate);
            }
            function createEnumTypeChecker(expectedValues) {
                function validate(props, propName, componentName, location, propFullName) {
                    for (var propValue = props[propName], i = 0; i < expectedValues.length; i++) if (is(propValue, expectedValues[i])) return null;
                    return new PropTypeError("Invalid " + location + " `" + propFullName + "` of value `" + propValue + "` supplied to `" + componentName + "`, expected one of " + JSON.stringify(expectedValues) + ".");
                }
                return Array.isArray(expectedValues) ? createChainableTypeChecker(validate) : (printWarning("Invalid argument supplied to oneOf, expected an instance of array."), 
                emptyFunctionThatReturnsNull);
            }
            function createObjectOfTypeChecker(typeChecker) {
                function validate(props, propName, componentName, location, propFullName) {
                    if ("function" != typeof typeChecker) return new PropTypeError("Property `" + propFullName + "` of component `" + componentName + "` has invalid PropType notation inside objectOf.");
                    var propValue = props[propName], propType = getPropType(propValue);
                    if ("object" !== propType) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` supplied to `" + componentName + "`, expected an object.");
                    for (var key in propValue) if (propValue.hasOwnProperty(key)) {
                        var error = typeChecker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
                        if (error instanceof Error) return error;
                    }
                    return null;
                }
                return createChainableTypeChecker(validate);
            }
            function createUnionTypeChecker(arrayOfTypeCheckers) {
                function validate(props, propName, componentName, location, propFullName) {
                    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
                        if (null == (0, arrayOfTypeCheckers[i])(props, propName, componentName, location, propFullName, ReactPropTypesSecret)) return null;
                    }
                    return new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to `" + componentName + "`.");
                }
                if (!Array.isArray(arrayOfTypeCheckers)) return printWarning("Invalid argument supplied to oneOfType, expected an instance of array."), 
                emptyFunctionThatReturnsNull;
                for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
                    var checker = arrayOfTypeCheckers[i];
                    if ("function" != typeof checker) return printWarning("Invalid argument supplied to oneOfType. Expected an array of check functions, but received " + getPostfixForTypeWarning(checker) + " at index " + i + "."), 
                    emptyFunctionThatReturnsNull;
                }
                return createChainableTypeChecker(validate);
            }
            function createShapeTypeChecker(shapeTypes) {
                function validate(props, propName, componentName, location, propFullName) {
                    var propValue = props[propName], propType = getPropType(propValue);
                    if ("object" !== propType) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` supplied to `" + componentName + "`, expected `object`.");
                    for (var key in shapeTypes) {
                        var checker = shapeTypes[key];
                        if (checker) {
                            var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
                            if (error) return error;
                        }
                    }
                    return null;
                }
                return createChainableTypeChecker(validate);
            }
            function createStrictShapeTypeChecker(shapeTypes) {
                function validate(props, propName, componentName, location, propFullName) {
                    var propValue = props[propName], propType = getPropType(propValue);
                    if ("object" !== propType) return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + propType + "` supplied to `" + componentName + "`, expected `object`.");
                    var allKeys = assign({}, props[propName], shapeTypes);
                    for (var key in allKeys) {
                        var checker = shapeTypes[key];
                        if (!checker) return new PropTypeError("Invalid " + location + " `" + propFullName + "` key `" + key + "` supplied to `" + componentName + "`.\nBad object: " + JSON.stringify(props[propName], null, "  ") + "\nValid keys: " + JSON.stringify(Object.keys(shapeTypes), null, "  "));
                        var error = checker(propValue, key, componentName, location, propFullName + "." + key, ReactPropTypesSecret);
                        if (error) return error;
                    }
                    return null;
                }
                return createChainableTypeChecker(validate);
            }
            function isNode(propValue) {
                switch (typeof propValue) {
                  case "number":
                  case "string":
                  case "undefined":
                    return !0;

                  case "boolean":
                    return !propValue;

                  case "object":
                    if (Array.isArray(propValue)) return propValue.every(isNode);
                    if (null === propValue || isValidElement(propValue)) return !0;
                    var iteratorFn = getIteratorFn(propValue);
                    if (!iteratorFn) return !1;
                    var step, iterator = iteratorFn.call(propValue);
                    if (iteratorFn !== propValue.entries) {
                        for (;!(step = iterator.next()).done; ) if (!isNode(step.value)) return !1;
                    } else for (;!(step = iterator.next()).done; ) {
                        var entry = step.value;
                        if (entry && !isNode(entry[1])) return !1;
                    }
                    return !0;

                  default:
                    return !1;
                }
            }
            function isSymbol(propType, propValue) {
                return "symbol" === propType || ("Symbol" === propValue["@@toStringTag"] || "function" == typeof Symbol && propValue instanceof Symbol);
            }
            function getPropType(propValue) {
                var propType = typeof propValue;
                return Array.isArray(propValue) ? "array" : propValue instanceof RegExp ? "object" : isSymbol(propType, propValue) ? "symbol" : propType;
            }
            function getPreciseType(propValue) {
                if (void 0 === propValue || null === propValue) return "" + propValue;
                var propType = getPropType(propValue);
                if ("object" === propType) {
                    if (propValue instanceof Date) return "date";
                    if (propValue instanceof RegExp) return "regexp";
                }
                return propType;
            }
            function getPostfixForTypeWarning(value) {
                var type = getPreciseType(value);
                switch (type) {
                  case "array":
                  case "object":
                    return "an " + type;

                  case "boolean":
                  case "date":
                  case "regexp":
                    return "a " + type;

                  default:
                    return type;
                }
            }
            function getClassName(propValue) {
                return propValue.constructor && propValue.constructor.name ? propValue.constructor.name : ANONYMOUS;
            }
            var ITERATOR_SYMBOL = "function" == typeof Symbol && Symbol.iterator, FAUX_ITERATOR_SYMBOL = "@@iterator", ANONYMOUS = "<<anonymous>>", ReactPropTypes = {
                array: createPrimitiveTypeChecker("array"),
                bool: createPrimitiveTypeChecker("boolean"),
                func: createPrimitiveTypeChecker("function"),
                number: createPrimitiveTypeChecker("number"),
                object: createPrimitiveTypeChecker("object"),
                string: createPrimitiveTypeChecker("string"),
                symbol: createPrimitiveTypeChecker("symbol"),
                any: function() {
                    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
                }(),
                arrayOf: createArrayOfTypeChecker,
                element: function() {
                    function validate(props, propName, componentName, location, propFullName) {
                        var propValue = props[propName];
                        if (!isValidElement(propValue)) {
                            return new PropTypeError("Invalid " + location + " `" + propFullName + "` of type `" + getPropType(propValue) + "` supplied to `" + componentName + "`, expected a single ReactElement.");
                        }
                        return null;
                    }
                    return createChainableTypeChecker(validate);
                }(),
                instanceOf: createInstanceTypeChecker,
                node: function() {
                    function validate(props, propName, componentName, location, propFullName) {
                        return isNode(props[propName]) ? null : new PropTypeError("Invalid " + location + " `" + propFullName + "` supplied to `" + componentName + "`, expected a ReactNode.");
                    }
                    return createChainableTypeChecker(validate);
                }(),
                objectOf: createObjectOfTypeChecker,
                oneOf: createEnumTypeChecker,
                oneOfType: createUnionTypeChecker,
                shape: createShapeTypeChecker,
                exact: createStrictShapeTypeChecker
            };
            return PropTypeError.prototype = Error.prototype, ReactPropTypes.checkPropTypes = checkPropTypes, 
            ReactPropTypes.PropTypes = ReactPropTypes, ReactPropTypes;
        };
    }, function(module, exports, __webpack_require__) {
        "use strict";
        function toObject(val) {
            if (null === val || void 0 === val) throw new TypeError("Object.assign cannot be called with null or undefined");
            return Object(val);
        }
        /*
object-assign
(c) Sindre Sorhus
@license MIT
*/
        var getOwnPropertySymbols = Object.getOwnPropertySymbols, hasOwnProperty = Object.prototype.hasOwnProperty, propIsEnumerable = Object.prototype.propertyIsEnumerable;
        module.exports = function() {
            try {
                if (!Object.assign) return !1;
                var test1 = new String("abc");
                if (test1[5] = "de", "5" === Object.getOwnPropertyNames(test1)[0]) return !1;
                for (var test2 = {}, i = 0; i < 10; i++) test2["_" + String.fromCharCode(i)] = i;
                if ("0123456789" !== Object.getOwnPropertyNames(test2).map(function(n) {
                    return test2[n];
                }).join("")) return !1;
                var test3 = {};
                return "abcdefghijklmnopqrst".split("").forEach(function(letter) {
                    test3[letter] = letter;
                }), "abcdefghijklmnopqrst" === Object.keys(Object.assign({}, test3)).join("");
            } catch (err) {
                return !1;
            }
        }() ? Object.assign : function(target, source) {
            for (var from, symbols, to = toObject(target), s = 1; s < arguments.length; s++) {
                from = Object(arguments[s]);
                for (var key in from) hasOwnProperty.call(from, key) && (to[key] = from[key]);
                if (getOwnPropertySymbols) {
                    symbols = getOwnPropertySymbols(from);
                    for (var i = 0; i < symbols.length; i++) propIsEnumerable.call(from, symbols[i]) && (to[symbols[i]] = from[symbols[i]]);
                }
            }
            return to;
        };
    }, function(module, exports, __webpack_require__) {
        "use strict";
        function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
            for (var typeSpecName in typeSpecs) if (typeSpecs.hasOwnProperty(typeSpecName)) {
                var error;
                try {
                    if ("function" != typeof typeSpecs[typeSpecName]) {
                        var err = Error((componentName || "React class") + ": " + location + " type `" + typeSpecName + "` is invalid; it must be a function, usually from the `prop-types` package, but received `" + typeof typeSpecs[typeSpecName] + "`.");
                        throw err.name = "Invariant Violation", err;
                    }
                    error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
                } catch (ex) {
                    error = ex;
                }
                if (!error || error instanceof Error || printWarning((componentName || "React class") + ": type specification of " + location + " `" + typeSpecName + "` is invalid; the type checker function must return `null` or an `Error` but returned a " + typeof error + ". You may have forgotten to pass an argument to the type checker creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and shape all require an argument)."), 
                error instanceof Error && !(error.message in loggedTypeFailures)) {
                    loggedTypeFailures[error.message] = !0;
                    var stack = getStack ? getStack() : "";
                    printWarning("Failed " + location + " type: " + error.message + (null != stack ? stack : ""));
                }
            }
        }
        var printWarning = function() {}, ReactPropTypesSecret = __webpack_require__(1), loggedTypeFailures = {};
        printWarning = function(text) {
            var message = "Warning: " + text;
            "undefined" != typeof console && console.error(message);
            try {
                throw new Error(message);
            } catch (x) {}
        }, module.exports = checkPropTypes;
    }, function(module, exports, __webpack_require__) {
        "use strict";
        function Mql(query, values, forceStatic) {
            function addListener(listener) {
                mql && mql.addListener(listener);
            }
            function removeListener(listener) {
                mql && mql.removeListener(listener);
            }
            function update(evt) {
                self.matches = evt.matches, self.media = evt.media;
            }
            function dispose() {
                mql && mql.removeListener(update);
            }
            var self = this;
            if (dynamicMatch && !forceStatic) {
                var mql = dynamicMatch.call(window, query);
                this.matches = mql.matches, this.media = mql.media, mql.addListener(update);
            } else this.matches = staticMatch(query, values), this.media = query;
            this.addListener = addListener, this.removeListener = removeListener, this.dispose = dispose;
        }
        function matchMedia(query, values, forceStatic) {
            return new Mql(query, values, forceStatic);
        }
        var staticMatch = __webpack_require__(10).match, dynamicMatch = "undefined" != typeof window ? window.matchMedia : null;
        module.exports = matchMedia;
    }, function(module, exports, __webpack_require__) {
        "use strict";
        function matchQuery(mediaQuery, values) {
            return parseQuery(mediaQuery).some(function(query) {
                var inverse = query.inverse, typeMatch = "all" === query.type || values.type === query.type;
                if (typeMatch && inverse || !typeMatch && !inverse) return !1;
                var expressionsMatch = query.expressions.every(function(expression) {
                    var feature = expression.feature, modifier = expression.modifier, expValue = expression.value, value = values[feature];
                    if (!value) return !1;
                    switch (feature) {
                      case "orientation":
                      case "scan":
                        return value.toLowerCase() === expValue.toLowerCase();

                      case "width":
                      case "height":
                      case "device-width":
                      case "device-height":
                        expValue = toPx(expValue), value = toPx(value);
                        break;

                      case "resolution":
                        expValue = toDpi(expValue), value = toDpi(value);
                        break;

                      case "aspect-ratio":
                      case "device-aspect-ratio":
                      case "device-pixel-ratio":
                        expValue = toDecimal(expValue), value = toDecimal(value);
                        break;

                      case "grid":
                      case "color":
                      case "color-index":
                      case "monochrome":
                        expValue = parseInt(expValue, 10) || 1, value = parseInt(value, 10) || 0;
                    }
                    switch (modifier) {
                      case "min":
                        return value >= expValue;

                      case "max":
                        return value <= expValue;

                      default:
                        return value === expValue;
                    }
                });
                return expressionsMatch && !inverse || !expressionsMatch && inverse;
            });
        }
        function parseQuery(mediaQuery) {
            return mediaQuery.split(",").map(function(query) {
                query = query.trim();
                var captures = query.match(RE_MEDIA_QUERY), modifier = captures[1], type = captures[2], expressions = captures[3] || "", parsed = {};
                return parsed.inverse = !!modifier && "not" === modifier.toLowerCase(), parsed.type = type ? type.toLowerCase() : "all", 
                expressions = expressions.match(/\([^\)]+\)/g) || [], parsed.expressions = expressions.map(function(expression) {
                    var captures = expression.match(RE_MQ_EXPRESSION), feature = captures[1].toLowerCase().match(RE_MQ_FEATURE);
                    return {
                        modifier: feature[1],
                        feature: feature[2],
                        value: captures[2]
                    };
                }), parsed;
            });
        }
        function toDecimal(ratio) {
            var numbers, decimal = Number(ratio);
            return decimal || (numbers = ratio.match(/^(\d+)\s*\/\s*(\d+)$/), decimal = numbers[1] / numbers[2]), 
            decimal;
        }
        function toDpi(resolution) {
            var value = parseFloat(resolution);
            switch (String(resolution).match(RE_RESOLUTION_UNIT)[1]) {
              case "dpcm":
                return value / 2.54;

              case "dppx":
                return 96 * value;

              default:
                return value;
            }
        }
        function toPx(length) {
            var value = parseFloat(length);
            switch (String(length).match(RE_LENGTH_UNIT)[1]) {
              case "em":
              case "rem":
                return 16 * value;

              case "cm":
                return 96 * value / 2.54;

              case "mm":
                return 96 * value / 2.54 / 10;

              case "in":
                return 96 * value;

              case "pt":
                return 72 * value;

              case "pc":
                return 72 * value / 12;

              default:
                return value;
            }
        }
        exports.match = matchQuery, exports.parse = parseQuery;
        var RE_MEDIA_QUERY = /(?:(only|not)?\s*([^\s\(\)]+)(?:\s*and)?\s*)?(.+)?/i, RE_MQ_EXPRESSION = /\(\s*([^\s\:\)]+)\s*(?:\:\s*([^\s\)]+))?\s*\)/, RE_MQ_FEATURE = /^(?:(min|max)-)?(.+)/, RE_LENGTH_UNIT = /(em|rem|px|cm|mm|in|pt|pc)?$/, RE_RESOLUTION_UNIT = /(dpi|dpcm|dppx)?$/;
    }, function(module, exports, __webpack_require__) {
        "use strict";
        function _interopRequireDefault(obj) {
            return obj && obj.__esModule ? obj : {
                default: obj
            };
        }
        function keyVal(k, v) {
            var realKey = (0, _hyphenateStyleName2.default)(k);
            return "number" == typeof v && (v += "px"), !0 === v ? k : !1 === v ? negate(k) : "(" + realKey + ": " + v + ")";
        }
        function join(conds) {
            return conds.join(" and ");
        }
        Object.defineProperty(exports, "__esModule", {
            value: !0
        }), exports.default = function(obj) {
            var rules = [];
            return Object.keys(_mediaQuery2.default.all).forEach(function(k) {
                var v = obj[k];
                null != v && rules.push(keyVal(k, v));
            }), join(rules);
        };
        var _hyphenateStyleName = __webpack_require__(2), _hyphenateStyleName2 = _interopRequireDefault(_hyphenateStyleName), _mediaQuery = __webpack_require__(3), _mediaQuery2 = _interopRequireDefault(_mediaQuery), negate = function(cond) {
            return "not " + cond;
        };
        module.exports = exports.default;
    } ]);
});
//# sourceMappingURL=react-responsive.js.map

/***/ }),
/* 331 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _default; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_omit__ = __webpack_require__(814);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_omit___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_omit__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_animejs__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_animejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_animejs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_detector__ = __webpack_require__(56);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  transition: all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n  transform-origin: 50% 100%;\n"],["\n  transition: all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n  transform-origin: 50% 100%;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  transition: all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n"],["\n  transition: all 0.5s cubic-bezier(0.175, 0.885, 0.32, 1.275);\n"]),_templateObject3=_taggedTemplateLiteral([""],[""]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// const bounce = keyframes`
//   0% {
//     transform: translateY(0);
//   }
//   100% {
//     transform: translateY(-5px);
//   }
// `;
// const AnimatedPin = styled.g`
//   ${props => props.animated && css`animation: ${bounce} 0.4s infinite ease alternate;`}
//   animation-delay: ${Math.random}s;
// `;
var AnimatedScaledG=__WEBPACK_IMPORTED_MODULE_3_styled_components__["b" /* default */].g(_templateObject);var AnimatedBubble=__WEBPACK_IMPORTED_MODULE_3_styled_components__["b" /* default */].g(_templateObject2);var Bubble=__WEBPACK_IMPORTED_MODULE_3_styled_components__["b" /* default */].image.attrs({x:10,y:4,height:40})(_templateObject3);var fixIETransform=function fixIETransform(el){return function(anim){if(el){var transform=getComputedStyle(el).getPropertyValue("transform");el.setAttribute("transform",transform);}};};var Marker=function(_React$Component){_inherits(Marker,_React$Component);function Marker(){_classCallCheck(this,Marker);return _possibleConstructorReturn(this,(Marker.__proto__||Object.getPrototypeOf(Marker)).apply(this,arguments));}_createClass(Marker,[{key:"render",value:function render(){var _props=this.props,width=_props.width,label=_props.label,color=_props.color,visible=_props.visible;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",{viewBox:"0 0 81 109",x:-0.5*width,y:-1.5*width,width:width,height:1.5*width},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(AnimatedScaledG,{transform:"scale("+(visible?1:0)+")"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{fill:color,d:"M81,40.5C81,72,40.83,109,40.83,109S0,71,0,40.5a40.5,40.5,0,0,1,81,0Z"}),label&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{x:40,y:60,textAnchor:"middle",fill:"white",style:{fontSize:40}},label)));}}]);return Marker;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);var _default=function(_React$PureComponent){_inherits(_default,_React$PureComponent);function _default(props){_classCallCheck(this,_default);var _this2=_possibleConstructorReturn(this,(_default.__proto__||Object.getPrototypeOf(_default)).call(this,props));_this2.gref=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createRef();return _this2;}_createClass(_default,[{key:"componentDidMount",value:function componentDidMount(){if(this.props.animated){__WEBPACK_IMPORTED_MODULE_2_animejs___default()({targets:this.gref.current,translateY:[0,-5],loop:true,// delay: (el, i, l) => {
//   return Math.random() * 1000;
// },
direction:"alternate",duration:1600,ease:"easeOutExpo",update:__WEBPACK_IMPORTED_MODULE_4__utils_detector__["a" /* isIE */]?fixIETransform(this.gref.current):null});}}// componentWillUnmount() {
//   this.bouncingTween.kill();
// }
},{key:"render",value:function render(){var _this3=this;var _props2=this.props,x=_props2.x,y=_props2.y,label=_props2.label,color=_props2.color,bubble=_props2.bubble,renderPin=_props2.renderPin,_onClick=_props2.onClick,_props2$showDot=_props2.showDot,showDot=_props2$showDot===undefined?false:_props2$showDot,_props2$visible=_props2.visible,visible=_props2$visible===undefined?true:_props2$visible,_props2$markerWidth=_props2.markerWidth,markerWidth=_props2$markerWidth===undefined?20:_props2$markerWidth;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g",{transform:"translate("+x+" "+y+")",style:{cursor:"pointer"},onClick:function onClick(e){return _onClick(_this3.props);}},showDot&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("circle",{cx:0,cy:0,r:5,fill:"red"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g",{ref:this.gref,transform:"translate(0, 0)"},typeof renderPin==="function"?renderPin(this.props):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Marker,{width:markerWidth,label:label,color:color,visible:visible})),bubble&&__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(AnimatedBubble,{transform:"translate("+(bubble.x!==undefined?bubble.x:14)+" "+(bubble.y!==undefined?bubble.y:-55)+") scale("+(visible?1:0)+")"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{className:"bubble-logo",x:0,y:0,width:20+32*bubble.width/bubble.height,height:40,rx:20,ry:20,fill:color}),typeof bubble.render==="function"?bubble.render(__WEBPACK_IMPORTED_MODULE_0_lodash_omit___default()(bubble,["render"]),this.props):__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Bubble,{xlinkHref:bubble.url,width:32*bubble.width/bubble.height,height:32})));}}]);return _default;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.PureComponent);

/***/ }),
/* 332 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var x=_ref.x,y=_ref.y,_ref$text=_ref.text,text=_ref$text===undefined?[]:_ref$text,_ref$textAnchor=_ref.textAnchor,textAnchor=_ref$textAnchor===undefined?"middle":_ref$textAnchor,_ref$style=_ref.style,style=_ref$style===undefined?{fill:'#8d8f90'}:_ref$style,_ref$showDot=_ref.showDot,showDot=_ref$showDot===undefined?false:_ref$showDot;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',null,showDot&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('circle',{cx:x,cy:y,r:2,fill:'red'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{textAnchor:textAnchor,x:x,y:y,height:'auto',style:Object.assign({fill:'#8d8f90'},style)},text.map(function(t,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tspan',{key:'text-'+i,x:x,dy:'1.1em'},t);})));});

/***/ }),
/* 333 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return texts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CHtexts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RUtexts; });
var texts=[// Properties
{id:1,type:"MultiLineText",group:"property",x:480,y:160,text:["Dusit Thani","Laguna Phuket"],style:{fontSize:11},options:{excludes:["project-map/hotel","project-map/restaurant"]}},{id:2,type:"MultiLineText",group:"property",x:332,y:321,text:["Cassia","Residences","Phuket"],options:{excludes:["masterplan"]}},{id:3,type:"MultiLineText",group:"property",x:212,y:441,text:["Dhawa","Phuket"],options:{excludes:["masterplan"]}},{id:4,type:"MultiLineText",group:"property",x:547,y:535,text:["Laguna Park","Phuket"],options:{excludes:["masterplan"]}},{id:5,type:"MultiLineText",group:"property",x:485,y:456,text:["Laguna Phuket","Skypark"],options:{excludes:["masterplan"]}},{id:6,type:"MultiLineText",group:"property",x:1400,y:830,text:["Laguna Park","Phuket 2"],options:{excludes:["masterplan"]}},{id:7,type:"MultiLineText",group:"property",x:570,y:300,text:["Angsana","Oceanview","Residences"],style:{fill:"white"},options:{excludes:["masterplan","project-map/mobile"]}},{id:8,type:"MultiLineText",group:"property",x:950,y:340,style:{fontSize:11},text:["Banyan Tree","3 Bedroom","Pool Villas"]},{id:9,type:"MultiLineText",group:"property",x:1107,y:185,text:["Banyan Tree","Grand Residences"],options:{excludes:["masterplan"]}},{id:10,type:"MultiLineText",group:"property",x:1150,y:340,text:["Banyan Tree","Residences"],options:{excludes:["masterplan"]}},{id:11,type:"MultiLineText",group:"property",x:1020,y:610,text:["Laguna Village","Residences"],options:{excludes:["masterplan","project-map/project/laguna-village-residences"]}},{id:12,type:"MultiLineText",group:"property",x:1330,y:670,text:["The Lofts","at Laguna Village"],options:{excludes:["masterplan"]}},// Hotels
{id:13,type:"MultiLineText",group:"hotel",x:230,y:130,text:["SAii","Laguna Phuket"],options:{excludes:["project-map/hotel","project-map/restaurant"]}},{id:14,type:"MultiLineText",group:"hotel",x:475,y:155,text:["",""]},{id:15,type:"MultiLineText",group:"hotel",x:580,y:215,text:["Angsana","Laguna Phuket"],style:{fontSize:11,fill:"white"},options:{excludes:["project-map/hotel"]}},{id:16,type:"MultiLineText",group:"hotel",x:730,y:250,text:["Banyan Tree","Spa Sanctuary"],style:{fill:"white"},options:{// excludes: ['project-map/hotel',]
}},{id:17,type:"MultiLineText",group:"hotel",x:900,y:237,text:["Banyan Tree","Phuket"],style:{fill:"white",fontSize:10},options:{excludes:["project-map/hotel"]}},{id:18,type:"MultiLineText",group:"hotel",x:374,y:275,text:["Cassia Phuket"],style:{fill:"white"},options:{excludes:["project-map/hotel","project-map/restaurant","masterplan"]}},// {
//   type: "MultiLineText",
//   group: "hotel",
//   x: 360,
//   y: 230,
//   text: ["Dusit Laguna Resort", "Villas Phuket"],
//   style: { fill: "white" },
//   options: {
//     excludes: [],
//     // excludes: ['project-map/hotel', 'project-map/restaurant', 'masterplan'],
//   },
// },
// {
//   type: "MultiLineText",
//   group: "hotel",
//   x: 730,
//   y: 155,
//   text: ["Angsana Beachfront", "Residences"],
//   style: { fontSize: 12 },
//   options: {
//     // excludes: ['project-map/hotel',]
//   }
// },
{id:19,type:"MultiLineText",group:"hotel",x:340,y:540,text:["Laguna","Main Entrance"]},{id:20,type:"MultiLineText",group:"hotel",x:489,y:390,text:["Laguna Holidays Club","Phuket Resort"],style:{fontSize:8},options:{excludes:["project-map/hotel"]}},{id:21,type:"MultiLineText",group:"hotel",x:740,y:400,style:{fontSize:10},text:["Allamanda","Laguna Phuket"]},{id:22,type:"MultiLineText",group:"hotel",x:1310,y:960,text:["Laguna Park 2","Main Entrance"]},{id:23,type:"MultiLineText",group:"hotel",x:1330,y:570,text:["Angsana","Villas Resort","Phuket "],options:{excludes:["project-map/hotel","project-map/restaurant"]}},// Facilities
{id:24,type:"MultiLineText",group:"facility",x:620,y:180,style:{fontSize:11},text:["XANA","Beach Club"]},{id:25,type:"MultiLineText",group:"facility",x:870,y:330,style:{fontSize:11},text:["Laguna Golf","Phuket"]},{id:26,type:"MultiLineText",group:"facility",x:445,y:270,text:["Latitude","Marquee"],style:{fontSize:8}},{id:27,type:"MultiLineText",group:"facility",x:555,y:252,text:["Canal Village","Shopping"],style:{fontSize:8,fill:"white"}},{id:28,type:"MultiLineText",group:"facility",x:469,y:318,text:["The Laguna","Lifestyle Hub"],style:{fontSize:8}},{id:29,type:"MultiLineText",group:"facility",x:510,y:348,text:["Angsana","Wedding","Chapel"],style:{fontSize:9,fill:"white"}},{id:30,type:"MultiLineText",group:"facility",x:770,y:55,text:["Bang Tao Beach"],style:{fontSize:22,fill:"white"}},// Arrow Text
{id:31,type:"MultiLineText",group:"map",x:85,y:785,textAnchor:"left",text:["Cherngtalay"]},{id:32,type:"MultiLineText",group:"map",x:85,y:855,textAnchor:"left",text:["(Half Hour Drive)","Phuket Town"]},{id:33,type:"MultiLineText",group:"map",x:1430,y:165,textAnchor:"end",text:["Nai Thon Beach"]},{id:34,type:"MultiLineText",group:"map",x:1545,y:970,textAnchor:"end",text:["(20-Minute)","Phuket International Airport"]},{id:35,type:"MultiLineText",group:"map",x:1160,y:825,textAnchor:"end",text:["Ban Don"]},{id:36,type:"MultiLineText",x:670,y:330,text:["Angsana","Convention","and Exhibition","Space"],textAnchor:"middle",style:{fontSize:8,fill:"black"}},{id:37,type:"MultiLineText",x:230,y:595,textAnchor:"end",text:["Villa Market"]},{id:38,type:"MultiLineText",x:170,y:630,text:["Boat","Avenue"]},{id:39,type:"MultiLineText",x:125,y:650,textAnchor:"end",text:["Porto de Phuket"]}];var CHtexts=[// Properties
{id:1,text:["",""]},{id:2,text:["","",""]},{id:3,text:["",""]},{id:4,text:["",""]},{id:5,text:["","",""]},{id:6,style:{fontSize:10},text:["普吉岛悦榕轩","三卧室泳池别墅",""]},{text:["",""]},{id:7,text:["",""]},{id:8,text:["",""]},{id:9,text:["",""]},{id:10,text:["",""]},{id:10,text:["",""]},// Hotels
{id:11,text:["SAii","Laguna Phuket",""],y:125},{id:12,text:["普吉岛乐古浪都","喜天阙酒店"],y:153},{id:13,text:["普吉岛乐古浪","悦椿酒店"],y:225,style:{fontSize:11,fill:"white"}},{id:14,style:{fontSize:10,fill:"white"},text:["悦榕庄心静轩"]},{id:15,y:242,text:["普吉岛悦榕"]},// Spa
{id:16,text:[""],bubble:{text:["普吉岛乐古浪都","喜天阙酒店悦椿Spa"]}},{id:17,text:["Laguna","主入口"],bubble:{text:["悦椿SPA","LAGUNA PHUKET"]}},{id:18,text:["普吉岛乐古浪","假日俱乐部酒店"],bubble:{text:["悦榕Spa"]}},{id:19,text:["普吉岛乐古浪","阿拉曼达饭店"]},{id:20,text:["乐古浪熙园 2","主入口"]},{id:21,text:["悦椿别墅度假村","",""]},// Facilities
{id:22,x:620,y:170,style:{fontSize:11,fontColor:"#9e9e9e"},text:["XANA","海滩俱乐部"]},{id:23,text:["普吉岛乐古浪","高尔夫俱乐部"]},{id:24,text:["Latitude","华盖"]},{id:25,text:["运河村购物中心",""],x:557,y:258,style:{fontSize:7,fill:"white"}},{id:26,text:["",""]},{id:27,text:["悦椿婚","礼教堂"]},{id:28,text:["邦涛海滩"],x:730,y:55},// Arrow Text
{id:29,type:"MultiLineText",group:"map",x:85,y:785,textAnchor:"left",text:["呈塔累"]},{id:30,type:"MultiLineText",group:"map",x:85,y:855,textAnchor:"left",text:["(30分钟车程)","普吉镇"]},{id:31,type:"MultiLineText",group:"map",x:1425,y:165,textAnchor:"end",text:["直通奈通海滩"]},{id:32,type:"MultiLineText",group:"map",x:1540,y:970,textAnchor:"end",text:["(20分钟车程)","普吉岛国际机场"]},{id:33,type:"MultiLineText",group:"map",x:1145,y:825,textAnchor:"end",text:["班顿"]},{id:34,type:"MultiLineText",x:670,y:330,text:["Angsana","Convention","and Exhibition","Space"],textAnchor:"middle",style:{fontSize:8,fill:"black"}},{id:35,type:"MultiLineText",x:230,y:595,textAnchor:"end"// text: ["Вилла Маркет"],
},{id:36,type:"MultiLineText",x:170,y:630// text: ["Боат", "Авеню"],
},{id:37,type:"MultiLineText",x:125,y:650,textAnchor:"end"// text: ["Порто де Пхукет"],
}];var RUtexts=[// Properties
{id:1,type:"MultiLineText",group:"property",x:370,y:220,text:[""],style:{fill:"white"}},{id:2,type:"MultiLineText",group:"property",x:332,y:321,text:[""]},{id:3,type:"MultiLineText",group:"property",x:212,y:441,text:["",""]},{id:4,type:"MultiLineText",group:"property",x:467,y:456,text:["",""]},{id:5,type:"MultiLineText",group:"property",x:570,y:300,text:["","",""],style:{fill:"white"}},{id:6,type:"MultiLineText",group:"property",x:950,y:340,style:{fontSize:10},text:["Виллы Banyan Tree","с бассейном и","3-мя спальнями"]},{id:7,type:"MultiLineText",group:"property",x:1107,y:185,text:[""]},{id:8,type:"MultiLineText",group:"property",x:1150,y:340,text:[""]},{id:9,type:"MultiLineText",group:"property",x:1020,y:610,text:[""]},{id:10,type:"MultiLineText",group:"property",x:1330,y:670,text:[""]},{id:11,type:"MultiLineText",group:"property",x:1400,y:840,text:[""]},{id:11,type:"MultiLineText",group:"property",x:1400,y:840,text:[""]},// Hotels
{id:12,type:"MultiLineText",group:"hotel",x:230,y:130,text:["Отель SAii","Laguna Phuket"]},{id:13,type:"MultiLineText",group:"hotel",x:470,y:160,text:["Отель Dusit Thani","Laguna Phuket"]},{id:14,type:"MultiLineText",group:"hotel",x:580,y:215,style:{fill:"white",fontSize:10},text:["Отель Angsana","Laguna Phuket"]},{id:15,type:"MultiLineText",group:"hotel",x:730,y:250,text:["Banyan Tree","Spa Sanctuary"],style:{fill:"white"}},{id:16,type:"MultiLineText",group:"hotel",x:900,y:235,text:["Отель","Banyan Tree","Phuket"],style:{fill:"white",fontSize:7}},{id:17,type:"MultiLineText",group:"hotel",x:374,y:275,text:[""],style:{fill:"white"}},{id:18,type:"MultiLineText",group:"hotel",x:335,y:540,text:["Laguna","Главный въезд"]},{id:19,type:"MultiLineText",group:"hotel",x:495,y:395,text:["Отель","Laguna Holidays Club","Phuket Resort"],style:{fontSize:7}},{id:20,type:"MultiLineText",group:"hotel",x:740,y:400,text:["Отель","Allamanda","Laguna Phuket"]},{id:21,type:"MultiLineText",group:"hotel",x:1310,y:960,text:["Laguna Park 2","Главный въезд"]},{id:22,type:"MultiLineText",group:"hotel",x:1350,y:570,text:["Отель Angsana Villas","Resort Phuket"]},// Facilities
{id:23,type:"MultiLineText",group:"facility",x:620,y:170,style:{fontSize:11,fontColor:"#9e9e9e"},text:["XANA","Beach Club"]},{id:24,type:"MultiLineText",group:"facility",x:850,y:330,style:{fontSize:10},text:["Лагуна Гольф Пхукет,","Таиланд"]},{id:25,type:"MultiLineText",group:"facility",x:445,y:275,text:["Место проведения","мероприятий","Lattitude Marque"],style:{fontSize:7}},{id:26,type:"MultiLineText",group:"facility",x:555,y:252,style:{fontSize:7,fill:"white"},text:["Шопинг-центр","Canal Village"]},{id:27,type:"MultiLineText",group:"facility",x:469,y:318,text:["The Laguna","Lifestyle Hub"],style:{fontSize:9}},{id:28,type:"MultiLineText",group:"facility",x:505,y:350,text:["Свадебная","часовня","Angsana"],style:{fontSize:9,fill:"white"}},{id:29,type:"MultiLineText",group:"facility",x:770,y:55,text:["Пляж Банг Тао (Bang Tao Beach)"],style:{fontSize:22,fill:"white"}},// Arrow Text
{id:30,type:"MultiLineText",group:"map",x:85,y:785,textAnchor:"left",text:["РАЙОН  Cherngtalay"],style:{fontSize:12}},{id:31,type:"MultiLineText",group:"map",x:85,y:855,textAnchor:"left",text:["ИСТОРИЧЕСКИЙ  ЦЕНТР","Phuket  Town  (в  получасе  езды)"]},{id:32,type:"MultiLineText",group:"map",x:1425,y:160,textAnchor:"end",text:["ПЛЯЖ  НАЙТОН","(Nai  Thon  Beach)"]},{id:33,type:"MultiLineText",group:"map",x:1540,y:960,textAnchor:"end",text:["МЕЖДУНАРОДНЫЙ","АЭРОПОРТ  ПХУКЕТА","(20  МИНУТ  ЕЗДЫ"]},{id:34,type:"MultiLineText",group:"map",x:1160,y:825,textAnchor:"end",text:["ХРАМ BAN DON"]},{id:35,type:"MultiLineText",x:670,y:330,text:["Angsana","Convention","and Exhibition","Space"],textAnchor:"middle",style:{fontSize:8,fill:"black"}},{id:36,type:"MultiLineText",x:230,y:595,textAnchor:"end",text:["Вилла Маркет"]},{id:37,type:"MultiLineText",x:170,y:630,text:["Боат","Авеню"]},{id:38,type:"MultiLineText",x:125,y:650,textAnchor:"end",text:["Порто де Пхукет"]}];

/***/ }),
/* 334 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(203),
    baseLodash = __webpack_require__(204);

/** Used as references for the maximum length and index of an array. */
var MAX_ARRAY_LENGTH = 4294967295;

/**
 * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
 *
 * @private
 * @constructor
 * @param {*} value The value to wrap.
 */
function LazyWrapper(value) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__dir__ = 1;
  this.__filtered__ = false;
  this.__iteratees__ = [];
  this.__takeCount__ = MAX_ARRAY_LENGTH;
  this.__views__ = [];
}

// Ensure `LazyWrapper` is an instance of `baseLodash`.
LazyWrapper.prototype = baseCreate(baseLodash.prototype);
LazyWrapper.prototype.constructor = LazyWrapper;

module.exports = LazyWrapper;


/***/ }),
/* 335 */
/***/ (function(module, exports, __webpack_require__) {

var baseCreate = __webpack_require__(203),
    baseLodash = __webpack_require__(204);

/**
 * The base constructor for creating `lodash` wrapper objects.
 *
 * @private
 * @param {*} value The value to wrap.
 * @param {boolean} [chainAll] Enable explicit method chain sequences.
 */
function LodashWrapper(value, chainAll) {
  this.__wrapped__ = value;
  this.__actions__ = [];
  this.__chain__ = !!chainAll;
  this.__index__ = 0;
  this.__values__ = undefined;
}

LodashWrapper.prototype = baseCreate(baseLodash.prototype);
LodashWrapper.prototype.constructor = LodashWrapper;

module.exports = LodashWrapper;


/***/ }),
/* 336 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(136)["default"];
var toPrimitive = __webpack_require__(831);
function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : String(i);
}
module.exports = toPropertyKey, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 337 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = _default;
exports.operationReducer = exports.playerReducer = void 0;

var _player = _interopRequireDefault(__webpack_require__(835));

var _operation = _interopRequireDefault(__webpack_require__(836));

function _default() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var action = arguments.length > 1 ? arguments[1] : undefined;
  return {
    player: (0, _player["default"])(state.player, action),
    operation: (0, _operation["default"])(state.operation, action)
  };
}

var playerReducer = _player["default"];
exports.playerReducer = playerReducer;
var operationReducer = _operation["default"];
exports.operationReducer = operationReducer;

/***/ }),
/* 338 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(10));

var _createClass2 = _interopRequireDefault(__webpack_require__(11));

var Fullscreen =
/*#__PURE__*/
function () {
  function Fullscreen() {
    (0, _classCallCheck2["default"])(this, Fullscreen);
  }

  (0, _createClass2["default"])(Fullscreen, [{
    key: "request",
    value: function request(elm) {
      if (elm.requestFullscreen) {
        elm.requestFullscreen();
      } else if (elm.webkitRequestFullscreen) {
        elm.webkitRequestFullscreen();
      } else if (elm.mozRequestFullScreen) {
        elm.mozRequestFullScreen();
      } else if (elm.msRequestFullscreen) {
        elm.msRequestFullscreen();
      }
    }
  }, {
    key: "exit",
    value: function exit() {
      if (document.exitFullscreen) {
        document.exitFullscreen();
      } else if (document.webkitExitFullscreen) {
        document.webkitExitFullscreen();
      } else if (document.mozCancelFullScreen) {
        document.mozCancelFullScreen();
      } else if (document.msExitFullscreen) {
        document.msExitFullscreen();
      }
    }
  }, {
    key: "addEventListener",
    value: function addEventListener(handler) {
      document.addEventListener('fullscreenchange', handler);
      document.addEventListener('webkitfullscreenchange', handler);
      document.addEventListener('mozfullscreenchange', handler);
      document.addEventListener('MSFullscreenChange', handler);
    }
  }, {
    key: "removeEventListener",
    value: function removeEventListener(handler) {
      document.removeEventListener('fullscreenchange', handler);
      document.removeEventListener('webkitfullscreenchange', handler);
      document.removeEventListener('mozfullscreenchange', handler);
      document.removeEventListener('MSFullscreenChange', handler);
    }
  }, {
    key: "isFullscreen",
    get: function get() {
      return document.fullscreenElement || document.webkitFullscreenElement || document.mozFullScreenElement || document.msFullscreenElement;
    }
  }, {
    key: "enabled",
    get: function get() {
      return document.fullscreenEnabled || document.webkitFullscreenEnabled || document.mozFullScreenEnabled || document.msFullscreenEnabled;
    }
  }]);
  return Fullscreen;
}();

var _default = new Fullscreen();

exports["default"] = _default;

/***/ }),
/* 339 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(12);

var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(10));

var _createClass2 = _interopRequireDefault(__webpack_require__(11));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(16));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(15));

var _inherits2 = _interopRequireDefault(__webpack_require__(17));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(9));

var propTypes = {
  actions: _propTypes["default"].object,
  player: _propTypes["default"].object,
  position: _propTypes["default"].string,
  className: _propTypes["default"].string
};
var defaultProps = {
  position: 'left'
};

var BigPlayButton =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(BigPlayButton, _Component);

  function BigPlayButton(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, BigPlayButton);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(BigPlayButton).call(this, props, context));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(BigPlayButton, [{
    key: "componentDidMount",
    value: function componentDidMount() {}
  }, {
    key: "handleClick",
    value: function handleClick() {
      var actions = this.props.actions;
      actions.play();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          player = _this$props.player,
          position = _this$props.position;
      return _react["default"].createElement("button", {
        className: (0, _classnames["default"])('video-react-button', 'video-react-big-play-button', "video-react-big-play-button-".concat(position), this.props.className, {
          'big-play-button-hide': player.hasStarted || !player.currentSrc
        }),
        type: "button",
        "aria-live": "polite",
        tabIndex: "0",
        onClick: this.handleClick
      }, _react["default"].createElement("span", {
        className: "video-react-control-text"
      }, "Play Video"));
    }
  }]);
  return BigPlayButton;
}(_react.Component);

exports["default"] = BigPlayButton;
BigPlayButton.propTypes = propTypes;
BigPlayButton.defaultProps = defaultProps;
BigPlayButton.displayName = 'BigPlayButton';

/***/ }),
/* 340 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = LoadingSpinner;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(9));

var propTypes = {
  player: _propTypes["default"].object,
  className: _propTypes["default"].string
};

function LoadingSpinner(_ref) {
  var player = _ref.player,
      className = _ref.className;

  if (player.error) {
    return null;
  }

  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])('video-react-loading-spinner', className)
  });
}

LoadingSpinner.propTypes = propTypes;
LoadingSpinner.displayName = 'LoadingSpinner';

/***/ }),
/* 341 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(9));

var propTypes = {
  poster: _propTypes["default"].string,
  player: _propTypes["default"].object,
  actions: _propTypes["default"].object,
  className: _propTypes["default"].string
};

function PosterImage(_ref) {
  var poster = _ref.poster,
      player = _ref.player,
      actions = _ref.actions,
      className = _ref.className;

  if (!poster || player.hasStarted) {
    return null;
  }

  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])('video-react-poster', className),
    style: {
      backgroundImage: "url(\"".concat(poster, "\")")
    },
    onClick: function onClick() {
      if (player.paused) {
        actions.play();
      }
    }
  });
}

PosterImage.propTypes = propTypes;
PosterImage.displayName = 'PosterImage';
var _default = PosterImage;
exports["default"] = _default;

/***/ }),
/* 342 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(12);

var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(57));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(10));

var _createClass2 = _interopRequireDefault(__webpack_require__(11));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(16));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(15));

var _inherits2 = _interopRequireDefault(__webpack_require__(17));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(9));

var _utils = __webpack_require__(46);

var propTypes = {
  actions: _propTypes["default"].object,
  player: _propTypes["default"].object,
  children: _propTypes["default"].any,
  startTime: _propTypes["default"].number,
  loop: _propTypes["default"].bool,
  muted: _propTypes["default"].bool,
  autoPlay: _propTypes["default"].bool,
  playsInline: _propTypes["default"].bool,
  src: _propTypes["default"].string,
  poster: _propTypes["default"].string,
  className: _propTypes["default"].string,
  preload: _propTypes["default"].oneOf(['auto', 'metadata', 'none']),
  crossOrigin: _propTypes["default"].string,
  onLoadStart: _propTypes["default"].func,
  onWaiting: _propTypes["default"].func,
  onCanPlay: _propTypes["default"].func,
  onCanPlayThrough: _propTypes["default"].func,
  onPlaying: _propTypes["default"].func,
  onEnded: _propTypes["default"].func,
  onSeeking: _propTypes["default"].func,
  onSeeked: _propTypes["default"].func,
  onPlay: _propTypes["default"].func,
  onPause: _propTypes["default"].func,
  onProgress: _propTypes["default"].func,
  onDurationChange: _propTypes["default"].func,
  onError: _propTypes["default"].func,
  onSuspend: _propTypes["default"].func,
  onAbort: _propTypes["default"].func,
  onEmptied: _propTypes["default"].func,
  onStalled: _propTypes["default"].func,
  onLoadedMetadata: _propTypes["default"].func,
  onLoadedData: _propTypes["default"].func,
  onTimeUpdate: _propTypes["default"].func,
  onRateChange: _propTypes["default"].func,
  onVolumeChange: _propTypes["default"].func,
  onResize: _propTypes["default"].func
};

var Video =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Video, _Component);

  function Video(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Video);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Video).call(this, props));
    _this.video = null; // the html5 video

    _this.play = _this.play.bind((0, _assertThisInitialized2["default"])(_this));
    _this.pause = _this.pause.bind((0, _assertThisInitialized2["default"])(_this));
    _this.seek = _this.seek.bind((0, _assertThisInitialized2["default"])(_this));
    _this.forward = _this.forward.bind((0, _assertThisInitialized2["default"])(_this));
    _this.replay = _this.replay.bind((0, _assertThisInitialized2["default"])(_this));
    _this.toggleFullscreen = _this.toggleFullscreen.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getProperties = _this.getProperties.bind((0, _assertThisInitialized2["default"])(_this));
    _this.renderChildren = _this.renderChildren.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleLoadStart = _this.handleLoadStart.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleCanPlay = _this.handleCanPlay.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleCanPlayThrough = _this.handleCanPlayThrough.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handlePlay = _this.handlePlay.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handlePlaying = _this.handlePlaying.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handlePause = _this.handlePause.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleEnded = _this.handleEnded.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleWaiting = _this.handleWaiting.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleSeeking = _this.handleSeeking.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleSeeked = _this.handleSeeked.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleFullscreenChange = _this.handleFullscreenChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleError = _this.handleError.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleSuspend = _this.handleSuspend.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleAbort = _this.handleAbort.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleEmptied = _this.handleEmptied.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleStalled = _this.handleStalled.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleLoadedMetaData = _this.handleLoadedMetaData.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleLoadedData = _this.handleLoadedData.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleTimeUpdate = _this.handleTimeUpdate.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleRateChange = _this.handleRateChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleVolumeChange = _this.handleVolumeChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleDurationChange = _this.handleDurationChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleProgress = (0, _utils.throttle)(_this.handleProgress.bind((0, _assertThisInitialized2["default"])(_this)), 250);
    _this.handleKeypress = _this.handleKeypress.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleTextTrackChange = _this.handleTextTrackChange.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(Video, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.forceUpdate(); // make sure the children can get the video property

      if (this.video && this.video.textTracks) {
        this.video.textTracks.onaddtrack = this.handleTextTrackChange;
        this.video.textTracks.onremovetrack = this.handleTextTrackChange;
      }
    } // get all video properties

  }, {
    key: "getProperties",
    value: function getProperties() {
      var _this2 = this;

      if (!this.video) {
        return null;
      }

      return _utils.mediaProperties.reduce(function (properties, key) {
        properties[key] = _this2.video[key];
        return properties;
      }, {});
    } // get playback rate

  }, {
    key: "handleTextTrackChange",
    value: function handleTextTrackChange() {
      var _this$props = this.props,
          actions = _this$props.actions,
          player = _this$props.player;

      if (this.video && this.video.textTracks) {
        var activeTextTrack = Array.from(this.video.textTracks).find(function (textTrack) {
          return textTrack.mode === 'showing';
        });

        if (activeTextTrack !== player.activeTextTrack) {
          actions.activateTextTrack(activeTextTrack);
        }
      }
    } // play the video

  }, {
    key: "play",
    value: function play() {
      var promise = this.video.play();

      if (promise !== undefined) {
        promise["catch"](function () {}).then(function () {});
      }
    } // pause the video

  }, {
    key: "pause",
    value: function pause() {
      var promise = this.video.pause();

      if (promise !== undefined) {
        promise["catch"](function () {}).then(function () {});
      }
    } // Change the video source and re-load the video:

  }, {
    key: "load",
    value: function load() {
      this.video.load();
    } // Add a new text track to the video

  }, {
    key: "addTextTrack",
    value: function addTextTrack() {
      var _this$video;

      (_this$video = this.video).addTextTrack.apply(_this$video, arguments);
    } // Check if your browser can play different types of video:

  }, {
    key: "canPlayType",
    value: function canPlayType() {
      var _this$video2;

      (_this$video2 = this.video).canPlayType.apply(_this$video2, arguments);
    } // toggle play

  }, {
    key: "togglePlay",
    value: function togglePlay() {
      if (this.video.paused) {
        this.play();
      } else {
        this.pause();
      }
    } // seek video by time

  }, {
    key: "seek",
    value: function seek(time) {
      try {
        this.video.currentTime = time;
      } catch (e) {// console.log(e, 'Video is not ready.')
      }
    } // jump forward x seconds

  }, {
    key: "forward",
    value: function forward(seconds) {
      this.seek(this.video.currentTime + seconds);
    } // jump back x seconds

  }, {
    key: "replay",
    value: function replay(seconds) {
      this.forward(-seconds);
    } // enter or exist full screen

  }, {
    key: "toggleFullscreen",
    value: function toggleFullscreen() {
      var _this$props2 = this.props,
          player = _this$props2.player,
          actions = _this$props2.actions;
      actions.toggleFullscreen(player);
    } // Fired when the user agent
    // begins looking for media data

  }, {
    key: "handleLoadStart",
    value: function handleLoadStart() {
      var _this$props3 = this.props,
          actions = _this$props3.actions,
          onLoadStart = _this$props3.onLoadStart;
      actions.handleLoadStart(this.getProperties());

      if (onLoadStart) {
        onLoadStart.apply(void 0, arguments);
      }
    } // A handler for events that
    // signal that waiting has ended

  }, {
    key: "handleCanPlay",
    value: function handleCanPlay() {
      var _this$props4 = this.props,
          actions = _this$props4.actions,
          onCanPlay = _this$props4.onCanPlay;
      actions.handleCanPlay(this.getProperties());

      if (onCanPlay) {
        onCanPlay.apply(void 0, arguments);
      }
    } // A handler for events that
    // signal that waiting has ended

  }, {
    key: "handleCanPlayThrough",
    value: function handleCanPlayThrough() {
      var _this$props5 = this.props,
          actions = _this$props5.actions,
          onCanPlayThrough = _this$props5.onCanPlayThrough;
      actions.handleCanPlayThrough(this.getProperties());

      if (onCanPlayThrough) {
        onCanPlayThrough.apply(void 0, arguments);
      }
    } // A handler for events that
    // signal that waiting has ended

  }, {
    key: "handlePlaying",
    value: function handlePlaying() {
      var _this$props6 = this.props,
          actions = _this$props6.actions,
          onPlaying = _this$props6.onPlaying;
      actions.handlePlaying(this.getProperties());

      if (onPlaying) {
        onPlaying.apply(void 0, arguments);
      }
    } // Fired whenever the media has been started

  }, {
    key: "handlePlay",
    value: function handlePlay() {
      var _this$props7 = this.props,
          actions = _this$props7.actions,
          onPlay = _this$props7.onPlay;
      actions.handlePlay(this.getProperties());

      if (onPlay) {
        onPlay.apply(void 0, arguments);
      }
    } // Fired whenever the media has been paused

  }, {
    key: "handlePause",
    value: function handlePause() {
      var _this$props8 = this.props,
          actions = _this$props8.actions,
          onPause = _this$props8.onPause;
      actions.handlePause(this.getProperties());

      if (onPause) {
        onPause.apply(void 0, arguments);
      }
    } // Fired when the duration of
    // the media resource is first known or changed

  }, {
    key: "handleDurationChange",
    value: function handleDurationChange() {
      var _this$props9 = this.props,
          actions = _this$props9.actions,
          onDurationChange = _this$props9.onDurationChange;
      actions.handleDurationChange(this.getProperties());

      if (onDurationChange) {
        onDurationChange.apply(void 0, arguments);
      }
    } // Fired while the user agent
    // is downloading media data

  }, {
    key: "handleProgress",
    value: function handleProgress() {
      var _this$props10 = this.props,
          actions = _this$props10.actions,
          onProgress = _this$props10.onProgress;

      if (this.video) {
        actions.handleProgressChange(this.getProperties());
      }

      if (onProgress) {
        onProgress.apply(void 0, arguments);
      }
    } // Fired when the end of the media resource
    // is reached (currentTime == duration)

  }, {
    key: "handleEnded",
    value: function handleEnded() {
      var _this$props11 = this.props,
          loop = _this$props11.loop,
          player = _this$props11.player,
          actions = _this$props11.actions,
          onEnded = _this$props11.onEnded;

      if (loop) {
        this.seek(0);
        this.play();
      } else if (!player.paused) {
        this.pause();
      }

      actions.handleEnd(this.getProperties());

      if (onEnded) {
        onEnded.apply(void 0, arguments);
      }
    } // Fired whenever the media begins waiting

  }, {
    key: "handleWaiting",
    value: function handleWaiting() {
      var _this$props12 = this.props,
          actions = _this$props12.actions,
          onWaiting = _this$props12.onWaiting;
      actions.handleWaiting(this.getProperties());

      if (onWaiting) {
        onWaiting.apply(void 0, arguments);
      }
    } // Fired whenever the player
    // is jumping to a new time

  }, {
    key: "handleSeeking",
    value: function handleSeeking() {
      var _this$props13 = this.props,
          actions = _this$props13.actions,
          onSeeking = _this$props13.onSeeking;
      actions.handleSeeking(this.getProperties());

      if (onSeeking) {
        onSeeking.apply(void 0, arguments);
      }
    } // Fired when the player has
    // finished jumping to a new time

  }, {
    key: "handleSeeked",
    value: function handleSeeked() {
      var _this$props14 = this.props,
          actions = _this$props14.actions,
          onSeeked = _this$props14.onSeeked;
      actions.handleSeeked(this.getProperties());

      if (onSeeked) {
        onSeeked.apply(void 0, arguments);
      }
    } // Handle Fullscreen Change

  }, {
    key: "handleFullscreenChange",
    value: function handleFullscreenChange() {} // Fires when the browser is
    // intentionally not getting media data

  }, {
    key: "handleSuspend",
    value: function handleSuspend() {
      var _this$props15 = this.props,
          actions = _this$props15.actions,
          onSuspend = _this$props15.onSuspend;
      actions.handleSuspend(this.getProperties());

      if (onSuspend) {
        onSuspend.apply(void 0, arguments);
      }
    } // Fires when the loading of an audio/video is aborted

  }, {
    key: "handleAbort",
    value: function handleAbort() {
      var _this$props16 = this.props,
          actions = _this$props16.actions,
          onAbort = _this$props16.onAbort;
      actions.handleAbort(this.getProperties());

      if (onAbort) {
        onAbort.apply(void 0, arguments);
      }
    } // Fires when the current playlist is empty

  }, {
    key: "handleEmptied",
    value: function handleEmptied() {
      var _this$props17 = this.props,
          actions = _this$props17.actions,
          onEmptied = _this$props17.onEmptied;
      actions.handleEmptied(this.getProperties());

      if (onEmptied) {
        onEmptied.apply(void 0, arguments);
      }
    } // Fires when the browser is trying to
    // get media data, but data is not available

  }, {
    key: "handleStalled",
    value: function handleStalled() {
      var _this$props18 = this.props,
          actions = _this$props18.actions,
          onStalled = _this$props18.onStalled;
      actions.handleStalled(this.getProperties());

      if (onStalled) {
        onStalled.apply(void 0, arguments);
      }
    } // Fires when the browser has loaded
    // meta data for the audio/video

  }, {
    key: "handleLoadedMetaData",
    value: function handleLoadedMetaData() {
      var _this$props19 = this.props,
          actions = _this$props19.actions,
          onLoadedMetadata = _this$props19.onLoadedMetadata,
          startTime = _this$props19.startTime;

      if (startTime && startTime > 0) {
        this.video.currentTime = startTime;
      }

      actions.handleLoadedMetaData(this.getProperties());

      if (onLoadedMetadata) {
        onLoadedMetadata.apply(void 0, arguments);
      }
    } // Fires when the browser has loaded
    // the current frame of the audio/video

  }, {
    key: "handleLoadedData",
    value: function handleLoadedData() {
      var _this$props20 = this.props,
          actions = _this$props20.actions,
          onLoadedData = _this$props20.onLoadedData;
      actions.handleLoadedData(this.getProperties());

      if (onLoadedData) {
        onLoadedData.apply(void 0, arguments);
      }
    } // Fires when the current
    // playback position has changed

  }, {
    key: "handleTimeUpdate",
    value: function handleTimeUpdate() {
      var _this$props21 = this.props,
          actions = _this$props21.actions,
          onTimeUpdate = _this$props21.onTimeUpdate;
      actions.handleTimeUpdate(this.getProperties());

      if (onTimeUpdate) {
        onTimeUpdate.apply(void 0, arguments);
      }
    }
    /**
     * Fires when the playing speed of the audio/video is changed
     */

  }, {
    key: "handleRateChange",
    value: function handleRateChange() {
      var _this$props22 = this.props,
          actions = _this$props22.actions,
          onRateChange = _this$props22.onRateChange;
      actions.handleRateChange(this.getProperties());

      if (onRateChange) {
        onRateChange.apply(void 0, arguments);
      }
    } // Fires when the volume has been changed

  }, {
    key: "handleVolumeChange",
    value: function handleVolumeChange() {
      var _this$props23 = this.props,
          actions = _this$props23.actions,
          onVolumeChange = _this$props23.onVolumeChange;
      actions.handleVolumeChange(this.getProperties());

      if (onVolumeChange) {
        onVolumeChange.apply(void 0, arguments);
      }
    } // Fires when an error occurred
    // during the loading of an audio/video

  }, {
    key: "handleError",
    value: function handleError() {
      var _this$props24 = this.props,
          actions = _this$props24.actions,
          onError = _this$props24.onError;
      actions.handleError(this.getProperties());

      if (onError) {
        onError.apply(void 0, arguments);
      }
    }
  }, {
    key: "handleResize",
    value: function handleResize() {
      var _this$props25 = this.props,
          actions = _this$props25.actions,
          onResize = _this$props25.onResize;
      actions.handleResize(this.getProperties());

      if (onResize) {
        onResize.apply(void 0, arguments);
      }
    }
  }, {
    key: "handleKeypress",
    value: function handleKeypress() {}
  }, {
    key: "renderChildren",
    value: function renderChildren() {
      var _this3 = this;

      var props = (0, _objectSpread2["default"])({}, this.props, {
        video: this.video
      }); // to make sure the children can get video property

      if (!this.video) {
        return null;
      } // only keep <source />, <track />, <MyComponent isVideoChild /> elements


      return _react["default"].Children.toArray(this.props.children).filter(_utils.isVideoChild).map(function (c) {
        var cprops;

        if (typeof c.type === 'string') {
          // add onError to <source />
          if (c.type === 'source') {
            cprops = (0, _objectSpread2["default"])({}, c.props);
            var preOnError = cprops.onError;

            cprops.onError = function () {
              if (preOnError) {
                preOnError.apply(void 0, arguments);
              }

              _this3.handleError.apply(_this3, arguments);
            };
          }
        } else {
          cprops = props;
        }

        return _react["default"].cloneElement(c, cprops);
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var _this$props26 = this.props,
          loop = _this$props26.loop,
          poster = _this$props26.poster,
          preload = _this$props26.preload,
          src = _this$props26.src,
          autoPlay = _this$props26.autoPlay,
          playsInline = _this$props26.playsInline,
          muted = _this$props26.muted,
          crossOrigin = _this$props26.crossOrigin,
          videoId = _this$props26.videoId;
      return _react["default"].createElement("video", {
        className: (0, _classnames["default"])('video-react-video', this.props.className),
        id: videoId,
        crossOrigin: crossOrigin,
        ref: function ref(c) {
          _this4.video = c;
        },
        muted: muted,
        preload: preload,
        loop: loop,
        playsInline: playsInline,
        autoPlay: autoPlay,
        poster: poster,
        src: src,
        onLoadStart: this.handleLoadStart,
        onWaiting: this.handleWaiting,
        onCanPlay: this.handleCanPlay,
        onCanPlayThrough: this.handleCanPlayThrough,
        onPlaying: this.handlePlaying,
        onEnded: this.handleEnded,
        onSeeking: this.handleSeeking,
        onSeeked: this.handleSeeked,
        onPlay: this.handlePlay,
        onPause: this.handlePause,
        onProgress: this.handleProgress,
        onDurationChange: this.handleDurationChange,
        onError: this.handleError,
        onSuspend: this.handleSuspend,
        onAbort: this.handleAbort,
        onEmptied: this.handleEmptied,
        onStalled: this.handleStalled,
        onLoadedMetadata: this.handleLoadedMetaData,
        onLoadedData: this.handleLoadedData,
        onTimeUpdate: this.handleTimeUpdate,
        onRateChange: this.handleRateChange,
        onVolumeChange: this.handleVolumeChange,
        tabIndex: "-1"
      }, this.renderChildren());
    }
  }, {
    key: "playbackRate",
    get: function get() {
      return this.video.playbackRate;
    } // set playback rate
    // speed of video
    ,
    set: function set(rate) {
      this.video.playbackRate = rate;
    }
  }, {
    key: "muted",
    get: function get() {
      return this.video.muted;
    },
    set: function set(val) {
      this.video.muted = val;
    }
  }, {
    key: "volume",
    get: function get() {
      return this.video.volume;
    },
    set: function set(val) {
      if (val > 1) {
        val = 1;
      }

      if (val < 0) {
        val = 0;
      }

      this.video.volume = val;
    } // video width

  }, {
    key: "videoWidth",
    get: function get() {
      return this.video.videoWidth;
    } // video height

  }, {
    key: "videoHeight",
    get: function get() {
      return this.video.videoHeight;
    }
  }]);
  return Video;
}(_react.Component);

exports["default"] = Video;
Video.propTypes = propTypes;
Video.displayName = 'Video';

/***/ }),
/* 343 */
/***/ (function(module, exports, __webpack_require__) {

var arrayWithoutHoles = __webpack_require__(837);
var iterableToArray = __webpack_require__(838);
var unsupportedIterableToArray = __webpack_require__(839);
var nonIterableSpread = __webpack_require__(840);
function _toConsumableArray(arr) {
  return arrayWithoutHoles(arr) || iterableToArray(arr) || unsupportedIterableToArray(arr) || nonIterableSpread();
}
module.exports = _toConsumableArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 344 */
/***/ (function(module, exports) {

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;
  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];
  return arr2;
}
module.exports = _arrayLikeToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 345 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(12);

var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(10));

var _createClass2 = _interopRequireDefault(__webpack_require__(11));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(16));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(15));

var _inherits2 = _interopRequireDefault(__webpack_require__(17));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(9));

var propTypes = {
  manager: _propTypes["default"].object,
  className: _propTypes["default"].string
};

var Bezel =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Bezel, _Component);

  function Bezel(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, Bezel);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Bezel).call(this, props, context));
    _this.timer = null;
    props.manager.subscribeToOperationStateChange(_this.handleStateChange.bind((0, _assertThisInitialized2["default"])(_this)));
    _this.state = {
      hidden: true,
      operation: {}
    };
    return _this;
  }

  (0, _createClass2["default"])(Bezel, [{
    key: "handleStateChange",
    value: function handleStateChange(state, prevState) {
      var _this2 = this;

      if (state.count !== prevState.count && state.operation.source === 'shortcut') {
        if (this.timer) {
          // previous animation is not finished
          clearTimeout(this.timer); // cancel it

          this.timer = null;
        } // show it
        // update operation


        this.setState({
          hidden: false,
          count: state.count,
          operation: state.operation
        }); // hide it after 0.5s

        this.timer = setTimeout(function () {
          _this2.setState({
            hidden: true
          });

          _this2.timer = null;
        }, 500);
      }
    }
  }, {
    key: "render",
    value: function render() {
      // only displays for shortcut so far
      if (this.state.operation.source !== 'shortcut') {
        return null;
      }

      var style = this.state.hidden ? {
        display: 'none'
      } : null;
      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])({
          'video-react-bezel': true,
          'video-react-bezel-animation': this.state.count % 2 === 0,
          'video-react-bezel-animation-alt': this.state.count % 2 === 1
        }, this.props.className),
        style: style,
        role: "status",
        "aria-label": this.state.operation.action
      }, _react["default"].createElement("div", {
        className: (0, _classnames["default"])('video-react-bezel-icon', "video-react-bezel-icon-".concat(this.state.operation.action))
      }));
    }
  }]);
  return Bezel;
}(_react.Component);

exports["default"] = Bezel;
Bezel.propTypes = propTypes;
Bezel.displayName = 'Bezel';

/***/ }),
/* 346 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _defineProperty2 = _interopRequireDefault(__webpack_require__(205));

var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(343));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(10));

var _createClass2 = _interopRequireDefault(__webpack_require__(11));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(16));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(15));

var _inherits2 = _interopRequireDefault(__webpack_require__(17));

var _react = __webpack_require__(0);

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _dom = __webpack_require__(138);

var propTypes = {
  clickable: _propTypes["default"].bool,
  dblclickable: _propTypes["default"].bool,
  manager: _propTypes["default"].object,
  actions: _propTypes["default"].object,
  player: _propTypes["default"].object,
  shortcuts: _propTypes["default"].array
};
var defaultProps = {
  clickable: true,
  dblclickable: true
};

var Shortcut =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Shortcut, _Component);

  function Shortcut(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, Shortcut);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Shortcut).call(this, props, context));
    _this.defaultShortcuts = [{
      keyCode: 32,
      // spacebar
      handle: _this.togglePlay
    }, {
      keyCode: 75,
      // k
      handle: _this.togglePlay
    }, {
      keyCode: 70,
      // f
      handle: _this.toggleFullscreen
    }, {
      keyCode: 37,
      // Left arrow
      handle: function handle(player, actions) {
        if (!player.hasStarted) {
          return;
        }

        actions.replay(5, {
          action: 'replay-5',
          source: 'shortcut'
        }); // Go back 5 seconds
      }
    }, {
      keyCode: 74,
      // j
      handle: function handle(player, actions) {
        if (!player.hasStarted) {
          return;
        }

        actions.replay(10, {
          action: 'replay-10',
          source: 'shortcut'
        }); // Go back 10 seconds
      }
    }, {
      keyCode: 39,
      // Right arrow
      handle: function handle(player, actions) {
        if (!player.hasStarted) {
          return;
        }

        actions.forward(5, {
          action: 'forward-5',
          source: 'shortcut'
        }); // Go forward 5 seconds
      }
    }, {
      keyCode: 76,
      // l
      handle: function handle(player, actions) {
        if (!player.hasStarted) {
          return;
        }

        actions.forward(10, {
          action: 'forward-10',
          source: 'shortcut'
        }); // Go forward 10 seconds
      }
    }, {
      keyCode: 36,
      // Home
      handle: function handle(player, actions) {
        if (!player.hasStarted) {
          return;
        }

        actions.seek(0); // Go to beginning of video
      }
    }, {
      keyCode: 35,
      // End
      handle: function handle(player, actions) {
        if (!player.hasStarted) {
          return;
        } // Go to end of video


        actions.seek(player.duration);
      }
    }, {
      keyCode: 38,
      // Up arrow
      handle: function handle(player, actions) {
        // Increase volume 5%
        var v = player.volume + 0.05;

        if (v > 1) {
          v = 1;
        }

        actions.changeVolume(v, {
          action: 'volume-up',
          source: 'shortcut'
        });
      }
    }, {
      keyCode: 40,
      // Down arrow
      handle: function handle(player, actions) {
        // Decrease volume 5%
        var v = player.volume - 0.05;

        if (v < 0) {
          v = 0;
        }

        var action = v > 0 ? 'volume-down' : 'volume-off';
        actions.changeVolume(v, {
          action: action,
          source: 'shortcut'
        });
      }
    }, {
      keyCode: 190,
      // Shift + >
      shift: true,
      handle: function handle(player, actions) {
        // Increase speed
        var playbackRate = player.playbackRate;

        if (playbackRate >= 1.5) {
          playbackRate = 2;
        } else if (playbackRate >= 1.25) {
          playbackRate = 1.5;
        } else if (playbackRate >= 1.0) {
          playbackRate = 1.25;
        } else if (playbackRate >= 0.5) {
          playbackRate = 1.0;
        } else if (playbackRate >= 0.25) {
          playbackRate = 0.5;
        } else if (playbackRate >= 0) {
          playbackRate = 0.25;
        }

        actions.changeRate(playbackRate, {
          action: 'fast-forward',
          source: 'shortcut'
        });
      }
    }, {
      keyCode: 188,
      // Shift + <
      shift: true,
      handle: function handle(player, actions) {
        // Decrease speed
        var playbackRate = player.playbackRate;

        if (playbackRate <= 0.5) {
          playbackRate = 0.25;
        } else if (playbackRate <= 1.0) {
          playbackRate = 0.5;
        } else if (playbackRate <= 1.25) {
          playbackRate = 1.0;
        } else if (playbackRate <= 1.5) {
          playbackRate = 1.25;
        } else if (playbackRate <= 2) {
          playbackRate = 1.5;
        }

        actions.changeRate(playbackRate, {
          action: 'fast-rewind',
          source: 'shortcut'
        });
      }
    }];
    _this.shortcuts = (0, _toConsumableArray2["default"])(_this.defaultShortcuts);
    _this.mergeShortcuts = _this.mergeShortcuts.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleKeyPress = _this.handleKeyPress.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleDoubleClick = _this.handleDoubleClick.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(Shortcut, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.mergeShortcuts();
      document.addEventListener('keydown', this.handleKeyPress);
      document.addEventListener('click', this.handleClick);
      document.addEventListener('dblclick', this.handleDoubleClick);
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      if (prevProps.shortcuts !== this.props.shortcuts) {
        this.mergeShortcuts();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      document.removeEventListener('keydown', this.handleKeyPress);
      document.removeEventListener('click', this.handleClick);
      document.removeEventListener('dblclick', this.handleDoubleClick);
    } // merge the shortcuts from props

  }, {
    key: "mergeShortcuts",
    value: function mergeShortcuts() {
      var getShortcutKey = function getShortcutKey(_ref) {
        var _ref$keyCode = _ref.keyCode,
            keyCode = _ref$keyCode === void 0 ? 0 : _ref$keyCode,
            _ref$ctrl = _ref.ctrl,
            ctrl = _ref$ctrl === void 0 ? false : _ref$ctrl,
            _ref$shift = _ref.shift,
            shift = _ref$shift === void 0 ? false : _ref$shift,
            _ref$alt = _ref.alt,
            alt = _ref$alt === void 0 ? false : _ref$alt;
        return "".concat(keyCode, ":").concat(ctrl, ":").concat(shift, ":").concat(alt);
      };

      var defaultShortcuts = this.defaultShortcuts.reduce(function (shortcuts, shortcut) {
        return Object.assign(shortcuts, (0, _defineProperty2["default"])({}, getShortcutKey(shortcut), shortcut));
      }, {});
      var mergedShortcuts = (this.props.shortcuts || []).reduce(function (shortcuts, shortcut) {
        var keyCode = shortcut.keyCode,
            handle = shortcut.handle;

        if (keyCode && typeof handle === 'function') {
          return Object.assign(shortcuts, (0, _defineProperty2["default"])({}, getShortcutKey(shortcut), shortcut));
        }

        return shortcuts;
      }, defaultShortcuts);

      var gradeShortcut = function gradeShortcut(s) {
        var score = 0;
        var ps = ['ctrl', 'shift', 'alt'];
        ps.forEach(function (key) {
          if (s[key]) {
            score++;
          }
        });
        return score;
      };

      this.shortcuts = Object.keys(mergedShortcuts).map(function (key) {
        return mergedShortcuts[key];
      }).sort(function (a, b) {
        return gradeShortcut(b) - gradeShortcut(a);
      });
    }
  }, {
    key: "togglePlay",
    value: function togglePlay(player, actions) {
      if (player.paused) {
        actions.play({
          action: 'play',
          source: 'shortcut'
        });
      } else {
        actions.pause({
          action: 'pause',
          source: 'shortcut'
        });
      }
    }
  }, {
    key: "toggleFullscreen",
    value: function toggleFullscreen(player, actions) {
      actions.toggleFullscreen(player);
    }
  }, {
    key: "handleKeyPress",
    value: function handleKeyPress(e) {
      var _this$props = this.props,
          player = _this$props.player,
          actions = _this$props.actions;

      if (!player.isActive) {
        return;
      }

      if (document.activeElement && ((0, _dom.hasClass)(document.activeElement, 'video-react-control') || (0, _dom.hasClass)(document.activeElement, 'video-react-menu-button-active') // || hasClass(document.activeElement, 'video-react-slider')
      || (0, _dom.hasClass)(document.activeElement, 'video-react-big-play-button'))) {
        return;
      }

      var keyCode = e.keyCode || e.which;
      var ctrl = e.ctrlKey || e.metaKey;
      var shift = e.shiftKey;
      var alt = e.altKey;
      var shortcut = this.shortcuts.filter(function (s) {
        if (!s.keyCode || s.keyCode - keyCode !== 0) {
          return false;
        }

        if (s.ctrl !== undefined && s.ctrl !== ctrl || s.shift !== undefined && s.shift !== shift || s.alt !== undefined && s.alt !== alt) {
          return false;
        }

        return true;
      })[0];

      if (shortcut) {
        shortcut.handle(player, actions);
        e.preventDefault();
      }
    } // only if player is active and player is ready

  }, {
    key: "canBeClicked",
    value: function canBeClicked(player, e) {
      if (!player.isActive || e.target.nodeName !== 'VIDEO' || player.readyState !== 4) {
        return false;
      }

      return true;
    }
  }, {
    key: "handleClick",
    value: function handleClick(e) {
      var _this$props2 = this.props,
          player = _this$props2.player,
          actions = _this$props2.actions,
          clickable = _this$props2.clickable;

      if (!this.canBeClicked(player, e) || !clickable) {
        return;
      }

      this.togglePlay(player, actions); // e.preventDefault();
    }
  }, {
    key: "handleDoubleClick",
    value: function handleDoubleClick(e) {
      var _this$props3 = this.props,
          player = _this$props3.player,
          actions = _this$props3.actions,
          dblclickable = _this$props3.dblclickable;

      if (!this.canBeClicked(player, e) || !dblclickable) {
        return;
      }

      this.toggleFullscreen(player, actions); // e.preventDefault();
    } // this component dose not render anything
    // it's just for the key down event

  }, {
    key: "render",
    value: function render() {
      return null;
    }
  }]);
  return Shortcut;
}(_react.Component);

exports["default"] = Shortcut;
Shortcut.propTypes = propTypes;
Shortcut.defaultProps = defaultProps;
Shortcut.displayName = 'Shortcut';

/***/ }),
/* 347 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(12);

var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(206));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(10));

var _createClass2 = _interopRequireDefault(__webpack_require__(11));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(16));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(15));

var _inherits2 = _interopRequireDefault(__webpack_require__(17));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(9));

var _ProgressControl = _interopRequireDefault(__webpack_require__(348));

var _PlayToggle = _interopRequireDefault(__webpack_require__(353));

var _ForwardControl = _interopRequireDefault(__webpack_require__(354));

var _ReplayControl = _interopRequireDefault(__webpack_require__(356));

var _FullscreenToggle = _interopRequireDefault(__webpack_require__(357));

var _RemainingTimeDisplay = _interopRequireDefault(__webpack_require__(358));

var _CurrentTimeDisplay = _interopRequireDefault(__webpack_require__(359));

var _DurationDisplay = _interopRequireDefault(__webpack_require__(360));

var _TimeDivider = _interopRequireDefault(__webpack_require__(361));

var _VolumeMenuButton = _interopRequireDefault(__webpack_require__(362));

var _PlaybackRateMenuButton = _interopRequireDefault(__webpack_require__(209));

var _utils = __webpack_require__(46);

var propTypes = {
  children: _propTypes["default"].any,
  autoHide: _propTypes["default"].bool,
  autoHideTime: _propTypes["default"].number,
  // used in Player
  disableDefaultControls: _propTypes["default"].bool,
  disableCompletely: _propTypes["default"].bool,
  className: _propTypes["default"].string
};
var defaultProps = {
  autoHide: true,
  disableCompletely: false
};

var ControlBar =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(ControlBar, _Component);

  function ControlBar(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, ControlBar);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ControlBar).call(this, props));
    _this.getDefaultChildren = _this.getDefaultChildren.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getFullChildren = _this.getFullChildren.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(ControlBar, [{
    key: "getDefaultChildren",
    value: function getDefaultChildren() {
      return [_react["default"].createElement(_PlayToggle["default"], {
        key: "play-toggle",
        order: 1
      }), _react["default"].createElement(_VolumeMenuButton["default"], {
        key: "volume-menu-button",
        order: 4
      }), _react["default"].createElement(_CurrentTimeDisplay["default"], {
        key: "current-time-display",
        order: 5.1
      }), _react["default"].createElement(_TimeDivider["default"], {
        key: "time-divider",
        order: 5.2
      }), _react["default"].createElement(_DurationDisplay["default"], {
        key: "duration-display",
        order: 5.3
      }), _react["default"].createElement(_ProgressControl["default"], {
        key: "progress-control",
        order: 6
      }), _react["default"].createElement(_FullscreenToggle["default"], {
        key: "fullscreen-toggle",
        order: 8
      })];
    }
  }, {
    key: "getFullChildren",
    value: function getFullChildren() {
      return [_react["default"].createElement(_PlayToggle["default"], {
        key: "play-toggle",
        order: 1
      }), _react["default"].createElement(_ReplayControl["default"], {
        key: "replay-control",
        order: 2
      }), _react["default"].createElement(_ForwardControl["default"], {
        key: "forward-control",
        order: 3
      }), _react["default"].createElement(_VolumeMenuButton["default"], {
        key: "volume-menu-button",
        order: 4
      }), _react["default"].createElement(_CurrentTimeDisplay["default"], {
        key: "current-time-display",
        order: 5
      }), _react["default"].createElement(_TimeDivider["default"], {
        key: "time-divider",
        order: 6
      }), _react["default"].createElement(_DurationDisplay["default"], {
        key: "duration-display",
        order: 7
      }), _react["default"].createElement(_ProgressControl["default"], {
        key: "progress-control",
        order: 8
      }), _react["default"].createElement(_RemainingTimeDisplay["default"], {
        key: "remaining-time-display",
        order: 9
      }), _react["default"].createElement(_PlaybackRateMenuButton["default"], {
        rates: [1, 1.25, 1.5, 2],
        key: "playback-rate",
        order: 10
      }), _react["default"].createElement(_FullscreenToggle["default"], {
        key: "fullscreen-toggle",
        order: 11
      })];
    }
  }, {
    key: "getChildren",
    value: function getChildren() {
      var children = _react["default"].Children.toArray(this.props.children);

      var defaultChildren = this.props.disableDefaultControls ? [] : this.getDefaultChildren();
      var _this$props = this.props,
          className = _this$props.className,
          parentProps = (0, _objectWithoutProperties2["default"])(_this$props, ["className"]); // remove className

      return (0, _utils.mergeAndSortChildren)(defaultChildren, children, parentProps);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          autoHide = _this$props2.autoHide,
          className = _this$props2.className,
          disableCompletely = _this$props2.disableCompletely;
      var children = this.getChildren();
      return disableCompletely ? null : _react["default"].createElement("div", {
        className: (0, _classnames["default"])('video-react-control-bar', {
          'video-react-control-bar-auto-hide': autoHide
        }, className)
      }, children);
    }
  }]);
  return ControlBar;
}(_react.Component);

exports["default"] = ControlBar;
ControlBar.propTypes = propTypes;
ControlBar.defaultProps = defaultProps;
ControlBar.displayName = 'ControlBar';

/***/ }),
/* 348 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(12);

var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(111));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(10));

var _createClass2 = _interopRequireDefault(__webpack_require__(11));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(16));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(15));

var _inherits2 = _interopRequireDefault(__webpack_require__(17));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(9));

var Dom = _interopRequireWildcard(__webpack_require__(138));

var _SeekBar = _interopRequireDefault(__webpack_require__(349));

var propTypes = {
  player: _propTypes["default"].object,
  className: _propTypes["default"].string
};

var ProgressControl =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(ProgressControl, _Component);

  function ProgressControl(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, ProgressControl);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ProgressControl).call(this, props, context));
    _this.state = {
      mouseTime: {
        time: null,
        position: 0
      }
    };
    _this.handleMouseMoveThrottle = _this.handleMouseMove.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(ProgressControl, [{
    key: "handleMouseMove",
    value: function handleMouseMove(event) {
      if (!event.pageX) {
        return;
      }

      var duration = this.props.player.duration;
      var node = this.seekBar;
      var newTime = Dom.getPointerPosition(node, event).x * duration;
      var position = event.pageX - Dom.findElPosition(node).left;
      this.setState({
        mouseTime: {
          time: newTime,
          position: position
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var className = this.props.className;
      return _react["default"].createElement("div", {
        onMouseMove: this.handleMouseMoveThrottle,
        className: (0, _classnames["default"])('video-react-progress-control video-react-control', className)
      }, _react["default"].createElement(_SeekBar["default"], (0, _extends2["default"])({
        mouseTime: this.state.mouseTime,
        ref: function ref(c) {
          _this2.seekBar = c;
        }
      }, this.props)));
    }
  }]);
  return ProgressControl;
}(_react.Component);

exports["default"] = ProgressControl;
ProgressControl.propTypes = propTypes;
ProgressControl.displayName = 'ProgressControl';

/***/ }),
/* 349 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(12);

var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(10));

var _createClass2 = _interopRequireDefault(__webpack_require__(11));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(16));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(15));

var _inherits2 = _interopRequireDefault(__webpack_require__(17));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(9));

var _Slider = _interopRequireDefault(__webpack_require__(208));

var _PlayProgressBar = _interopRequireDefault(__webpack_require__(350));

var _LoadProgressBar = _interopRequireDefault(__webpack_require__(351));

var _MouseTimeDisplay = _interopRequireDefault(__webpack_require__(352));

var _utils = __webpack_require__(46);

var propTypes = {
  player: _propTypes["default"].object,
  mouseTime: _propTypes["default"].object,
  actions: _propTypes["default"].object,
  className: _propTypes["default"].string
};

var SeekBar =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(SeekBar, _Component);

  function SeekBar(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, SeekBar);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(SeekBar).call(this, props, context));
    _this.getPercent = _this.getPercent.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getNewTime = _this.getNewTime.bind((0, _assertThisInitialized2["default"])(_this));
    _this.stepForward = _this.stepForward.bind((0, _assertThisInitialized2["default"])(_this));
    _this.stepBack = _this.stepBack.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleMouseDown = _this.handleMouseDown.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleMouseMove = _this.handleMouseMove.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleMouseUp = _this.handleMouseUp.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(SeekBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {}
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {}
    /**
     * Get percentage of video played
     *
     * @return {Number} Percentage played
     * @method getPercent
     */

  }, {
    key: "getPercent",
    value: function getPercent() {
      var _this$props$player = this.props.player,
          currentTime = _this$props$player.currentTime,
          seekingTime = _this$props$player.seekingTime,
          duration = _this$props$player.duration;
      var time = seekingTime || currentTime;
      var percent = time / duration;
      return percent >= 1 ? 1 : percent;
    }
  }, {
    key: "getNewTime",
    value: function getNewTime(event) {
      var duration = this.props.player.duration;
      var distance = this.slider.calculateDistance(event);
      var newTime = distance * duration; // Don't let video end while scrubbing.

      return newTime === duration ? newTime - 0.1 : newTime;
    }
  }, {
    key: "handleMouseDown",
    value: function handleMouseDown() {}
  }, {
    key: "handleMouseUp",
    value: function handleMouseUp(event) {
      var actions = this.props.actions;
      var newTime = this.getNewTime(event); // Set new time (tell video to seek to new time)

      actions.seek(newTime);
      actions.handleEndSeeking(newTime);
    }
  }, {
    key: "handleMouseMove",
    value: function handleMouseMove(event) {
      var actions = this.props.actions;
      var newTime = this.getNewTime(event);
      actions.handleSeekingTime(newTime);
    }
  }, {
    key: "stepForward",
    value: function stepForward() {
      var actions = this.props.actions;
      actions.forward(5);
    }
  }, {
    key: "stepBack",
    value: function stepBack() {
      var actions = this.props.actions;
      actions.replay(5);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props = this.props,
          _this$props$player2 = _this$props.player,
          currentTime = _this$props$player2.currentTime,
          seekingTime = _this$props$player2.seekingTime,
          duration = _this$props$player2.duration,
          buffered = _this$props$player2.buffered,
          mouseTime = _this$props.mouseTime;
      var time = seekingTime || currentTime;
      return _react["default"].createElement(_Slider["default"], {
        ref: function ref(input) {
          _this2.slider = input;
        },
        label: "video progress bar",
        className: (0, _classnames["default"])('video-react-progress-holder', this.props.className),
        valuenow: (this.getPercent() * 100).toFixed(2),
        valuetext: (0, _utils.formatTime)(time, duration),
        onMouseDown: this.handleMouseDown,
        onMouseMove: this.handleMouseMove,
        onMouseUp: this.handleMouseUp,
        getPercent: this.getPercent,
        stepForward: this.stepForward,
        stepBack: this.stepBack
      }, _react["default"].createElement(_LoadProgressBar["default"], {
        buffered: buffered,
        currentTime: time,
        duration: duration
      }), _react["default"].createElement(_MouseTimeDisplay["default"], {
        duration: duration,
        mouseTime: mouseTime
      }), _react["default"].createElement(_PlayProgressBar["default"], {
        currentTime: time,
        duration: duration
      }));
    }
  }]);
  return SeekBar;
}(_react.Component);

exports["default"] = SeekBar;
SeekBar.propTypes = propTypes;
SeekBar.displayName = 'SeekBar';

/***/ }),
/* 350 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = PlayProgressBar;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(9));

var _utils = __webpack_require__(46);

var propTypes = {
  currentTime: _propTypes["default"].number,
  duration: _propTypes["default"].number,
  percentage: _propTypes["default"].string,
  className: _propTypes["default"].string
}; // Shows play progress

function PlayProgressBar(_ref) {
  var currentTime = _ref.currentTime,
      duration = _ref.duration,
      percentage = _ref.percentage,
      className = _ref.className;
  return _react["default"].createElement("div", {
    "data-current-time": (0, _utils.formatTime)(currentTime, duration),
    className: (0, _classnames["default"])('video-react-play-progress video-react-slider-bar', className),
    style: {
      width: percentage
    }
  }, _react["default"].createElement("span", {
    className: "video-react-control-text"
  }, "Progress: ".concat(percentage)));
}

PlayProgressBar.propTypes = propTypes;
PlayProgressBar.displayName = 'PlayProgressBar';

/***/ }),
/* 351 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = LoadProgressBar;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(9));

var propTypes = {
  duration: _propTypes["default"].number,
  buffered: _propTypes["default"].object,
  className: _propTypes["default"].string
}; // Shows load progress

function LoadProgressBar(_ref) {
  var buffered = _ref.buffered,
      duration = _ref.duration,
      className = _ref.className;

  if (!buffered || !buffered.length) {
    return null;
  }

  var bufferedEnd = buffered.end(buffered.length - 1);
  var style = {};

  if (bufferedEnd > duration) {
    bufferedEnd = duration;
  } // get the percent width of a time compared to the total end


  function percentify(time, end) {
    var percent = time / end || 0; // no NaN

    return "".concat((percent >= 1 ? 1 : percent) * 100, "%");
  } // the width of the progress bar


  style.width = percentify(bufferedEnd, duration);
  var parts = []; // add child elements to represent the individual buffered time ranges

  for (var i = 0; i < buffered.length; i++) {
    var start = buffered.start(i);
    var end = buffered.end(i); // set the percent based on the width of the progress bar (bufferedEnd)

    var part = _react["default"].createElement("div", {
      style: {
        left: percentify(start, bufferedEnd),
        width: percentify(end - start, bufferedEnd)
      },
      key: "part-".concat(i)
    });

    parts.push(part);
  }

  if (parts.length === 0) {
    parts = null;
  }

  return _react["default"].createElement("div", {
    style: style,
    className: (0, _classnames["default"])('video-react-load-progress', className)
  }, _react["default"].createElement("span", {
    className: "video-react-control-text"
  }, "Loaded: 0%"), parts);
}

LoadProgressBar.propTypes = propTypes;
LoadProgressBar.displayName = 'LoadProgressBar';

/***/ }),
/* 352 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(9));

var _utils = __webpack_require__(46);

function MouseTimeDisplay(_ref) {
  var duration = _ref.duration,
      mouseTime = _ref.mouseTime,
      className = _ref.className,
      text = _ref.text;

  if (!mouseTime.time) {
    return null;
  }

  var time = text || (0, _utils.formatTime)(mouseTime.time, duration);
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])('video-react-mouse-display', className),
    style: {
      left: "".concat(mouseTime.position, "px")
    },
    "data-current-time": time
  });
}

MouseTimeDisplay.propTypes = {
  duration: _propTypes["default"].number,
  mouseTime: _propTypes["default"].object,
  className: _propTypes["default"].string
};
MouseTimeDisplay.displayName = 'MouseTimeDisplay';
var _default = MouseTimeDisplay;
exports["default"] = _default;

/***/ }),
/* 353 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(12);

var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(10));

var _createClass2 = _interopRequireDefault(__webpack_require__(11));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(16));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(15));

var _inherits2 = _interopRequireDefault(__webpack_require__(17));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(9));

var propTypes = {
  actions: _propTypes["default"].object,
  player: _propTypes["default"].object,
  className: _propTypes["default"].string
};

var PlayToggle =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(PlayToggle, _Component);

  function PlayToggle(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, PlayToggle);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(PlayToggle).call(this, props, context));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(PlayToggle, [{
    key: "handleClick",
    value: function handleClick() {
      var _this$props = this.props,
          actions = _this$props.actions,
          player = _this$props.player;

      if (player.paused) {
        actions.play();
      } else {
        actions.pause();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          player = _this$props2.player,
          className = _this$props2.className;
      var controlText = player.paused ? 'Play' : 'Pause';
      return _react["default"].createElement("button", {
        ref: function ref(c) {
          _this2.button = c;
        },
        className: (0, _classnames["default"])(className, {
          'video-react-play-control': true,
          'video-react-control': true,
          'video-react-button': true,
          'video-react-paused': player.paused,
          'video-react-playing': !player.paused
        }),
        type: "button",
        tabIndex: "0",
        onClick: this.handleClick
      }, _react["default"].createElement("span", {
        className: "video-react-control-text"
      }, controlText));
    }
  }]);
  return PlayToggle;
}(_react.Component);

exports["default"] = PlayToggle;
PlayToggle.propTypes = propTypes;
PlayToggle.displayName = 'PlayToggle';

/***/ }),
/* 354 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ForwardReplayControl = _interopRequireDefault(__webpack_require__(355));

// Pass mode into parent function
var ForwardControl = (0, _ForwardReplayControl["default"])('forward');
ForwardControl.displayName = 'ForwardControl';
var _default = ForwardControl;
exports["default"] = _default;

/***/ }),
/* 355 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(12);

var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(10));

var _createClass2 = _interopRequireDefault(__webpack_require__(11));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(16));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(15));

var _inherits2 = _interopRequireDefault(__webpack_require__(17));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireWildcard(__webpack_require__(0));

var propTypes = {
  actions: _propTypes["default"].object,
  className: _propTypes["default"].string,
  seconds: _propTypes["default"].oneOf([5, 10, 30])
};
var defaultProps = {
  seconds: 10
};

var _default = function _default(mode) {
  var ForwardReplayControl =
  /*#__PURE__*/
  function (_Component) {
    (0, _inherits2["default"])(ForwardReplayControl, _Component);

    function ForwardReplayControl(props, context) {
      var _this;

      (0, _classCallCheck2["default"])(this, ForwardReplayControl);
      _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ForwardReplayControl).call(this, props, context));
      _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
      return _this;
    }

    (0, _createClass2["default"])(ForwardReplayControl, [{
      key: "handleClick",
      value: function handleClick() {
        var _this$props = this.props,
            actions = _this$props.actions,
            seconds = _this$props.seconds; // Depends mode to implement different actions

        if (mode === 'forward') {
          actions.forward(seconds);
        } else {
          actions.replay(seconds);
        }
      }
    }, {
      key: "render",
      value: function render() {
        var _this2 = this;

        var _this$props2 = this.props,
            seconds = _this$props2.seconds,
            className = _this$props2.className;
        var classNames = ['video-react-control', 'video-react-button', 'video-react-icon'];
        classNames.push("video-react-icon-".concat(mode, "-").concat(seconds), "video-react-".concat(mode, "-control"));

        if (className) {
          classNames.push(className);
        }

        return _react["default"].createElement("button", {
          ref: function ref(c) {
            _this2.button = c;
          },
          className: classNames.join(' '),
          type: "button",
          onClick: this.handleClick
        }, _react["default"].createElement("span", {
          className: "video-react-control-text"
        }, "".concat(mode, " ").concat(seconds, " seconds")));
      }
    }]);
    return ForwardReplayControl;
  }(_react.Component);

  ForwardReplayControl.propTypes = propTypes;
  ForwardReplayControl.defaultProps = defaultProps;
  return ForwardReplayControl;
};

exports["default"] = _default;

/***/ }),
/* 356 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _ForwardReplayControl = _interopRequireDefault(__webpack_require__(355));

// Pass mode into parent function
var ReplayControl = (0, _ForwardReplayControl["default"])('replay');
ReplayControl.displayName = 'ReplayControl';
var _default = ReplayControl;
exports["default"] = _default;

/***/ }),
/* 357 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(12);

var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(10));

var _createClass2 = _interopRequireDefault(__webpack_require__(11));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(16));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(15));

var _inherits2 = _interopRequireDefault(__webpack_require__(17));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(9));

var propTypes = {
  actions: _propTypes["default"].object,
  player: _propTypes["default"].object,
  className: _propTypes["default"].string
};

var FullscreenToggle =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(FullscreenToggle, _Component);

  function FullscreenToggle(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, FullscreenToggle);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(FullscreenToggle).call(this, props, context));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(FullscreenToggle, [{
    key: "handleClick",
    value: function handleClick() {
      var _this$props = this.props,
          player = _this$props.player,
          actions = _this$props.actions;
      actions.toggleFullscreen(player);
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props2 = this.props,
          player = _this$props2.player,
          className = _this$props2.className;
      return _react["default"].createElement("button", {
        className: (0, _classnames["default"])(className, {
          'video-react-icon-fullscreen-exit': player.isFullscreen,
          'video-react-icon-fullscreen': !player.isFullscreen
        }, 'video-react-fullscreen-control video-react-control video-react-button video-react-icon'),
        ref: function ref(c) {
          _this2.button = c;
        },
        type: "button",
        tabIndex: "0",
        onClick: this.handleClick
      }, _react["default"].createElement("span", {
        className: "video-react-control-text"
      }, "Non-Fullscreen"));
    }
  }]);
  return FullscreenToggle;
}(_react.Component);

exports["default"] = FullscreenToggle;
FullscreenToggle.propTypes = propTypes;
FullscreenToggle.displayName = 'FullscreenToggle';

/***/ }),
/* 358 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(9));

var _utils = __webpack_require__(46);

var propTypes = {
  player: _propTypes["default"].object,
  className: _propTypes["default"].string
};

function RemainingTimeDisplay(_ref) {
  var _ref$player = _ref.player,
      currentTime = _ref$player.currentTime,
      duration = _ref$player.duration,
      className = _ref.className;
  var remainingTime = duration - currentTime;
  var formattedTime = (0, _utils.formatTime)(remainingTime);
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])('video-react-remaining-time video-react-time-control video-react-control', className)
  }, _react["default"].createElement("div", {
    className: "video-react-remaining-time-display",
    "aria-live": "off"
  }, _react["default"].createElement("span", {
    className: "video-react-control-text"
  }, "Remaining Time "), "-".concat(formattedTime)));
}

RemainingTimeDisplay.propTypes = propTypes;
RemainingTimeDisplay.displayName = 'RemainingTimeDisplay';
var _default = RemainingTimeDisplay;
exports["default"] = _default;

/***/ }),
/* 359 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(9));

var _utils = __webpack_require__(46);

var propTypes = {
  player: _propTypes["default"].object,
  className: _propTypes["default"].string
};

function CurrentTimeDisplay(_ref) {
  var _ref$player = _ref.player,
      currentTime = _ref$player.currentTime,
      duration = _ref$player.duration,
      className = _ref.className;
  var formattedTime = (0, _utils.formatTime)(currentTime, duration);
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])('video-react-current-time video-react-time-control video-react-control', className)
  }, _react["default"].createElement("div", {
    className: "video-react-current-time-display",
    "aria-live": "off"
  }, _react["default"].createElement("span", {
    className: "video-react-control-text"
  }, "Current Time "), formattedTime));
}

CurrentTimeDisplay.propTypes = propTypes;
CurrentTimeDisplay.displayName = 'CurrentTimeDisplay';
var _default = CurrentTimeDisplay;
exports["default"] = _default;

/***/ }),
/* 360 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(9));

var _utils = __webpack_require__(46);

var propTypes = {
  player: _propTypes["default"].object,
  className: _propTypes["default"].string
};

function DurationDisplay(_ref) {
  var duration = _ref.player.duration,
      className = _ref.className;
  var formattedTime = (0, _utils.formatTime)(duration);
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])(className, 'video-react-duration video-react-time-control video-react-control')
  }, _react["default"].createElement("div", {
    className: "video-react-duration-display",
    "aria-live": "off"
  }, _react["default"].createElement("span", {
    className: "video-react-control-text"
  }, "Duration Time "), formattedTime));
}

DurationDisplay.propTypes = propTypes;
DurationDisplay.displayName = 'DurationDisplay';
var _default = DurationDisplay;
exports["default"] = _default;

/***/ }),
/* 361 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = TimeDivider;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(9));

var propTypes = {
  separator: _propTypes["default"].string,
  className: _propTypes["default"].string
};

function TimeDivider(_ref) {
  var separator = _ref.separator,
      className = _ref.className;
  var separatorText = separator || '/';
  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])('video-react-time-control video-react-time-divider', className),
    dir: "ltr"
  }, _react["default"].createElement("div", null, _react["default"].createElement("span", null, separatorText)));
}

TimeDivider.propTypes = propTypes;
TimeDivider.displayName = 'TimeDivider';

/***/ }),
/* 362 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(12);

var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(111));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(10));

var _createClass2 = _interopRequireDefault(__webpack_require__(11));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(16));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(15));

var _inherits2 = _interopRequireDefault(__webpack_require__(17));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(9));

var _PopupButton = _interopRequireDefault(__webpack_require__(841));

var _VolumeBar = _interopRequireDefault(__webpack_require__(843));

var propTypes = {
  player: _propTypes["default"].object,
  actions: _propTypes["default"].object,
  vertical: _propTypes["default"].bool,
  className: _propTypes["default"].string,
  alwaysShowVolume: _propTypes["default"].bool
};
var defaultProps = {
  vertical: false
};

var VolumeMenuButton =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(VolumeMenuButton, _Component);

  function VolumeMenuButton(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, VolumeMenuButton);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(VolumeMenuButton).call(this, props, context));
    _this.state = {
      active: false
    };
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(VolumeMenuButton, [{
    key: "handleClick",
    value: function handleClick() {
      var _this$props = this.props,
          player = _this$props.player,
          actions = _this$props.actions;
      actions.mute(!player.muted);
    }
  }, {
    key: "handleFocus",
    value: function handleFocus() {
      this.setState({
        active: true
      });
    }
  }, {
    key: "handleBlur",
    value: function handleBlur() {
      this.setState({
        active: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          vertical = _this$props2.vertical,
          player = _this$props2.player,
          className = _this$props2.className;
      var inline = !vertical;
      var level = this.volumeLevel;
      return _react["default"].createElement(_PopupButton["default"], {
        className: (0, _classnames["default"])(className, {
          'video-react-volume-menu-button-vertical': vertical,
          'video-react-volume-menu-button-horizontal': !vertical,
          'video-react-vol-muted': player.muted,
          'video-react-vol-0': level === 0 && !player.muted,
          'video-react-vol-1': level === 1,
          'video-react-vol-2': level === 2,
          'video-react-vol-3': level === 3,
          'video-react-slider-active': this.props.alwaysShowVolume || this.state.active,
          'video-react-lock-showing': this.props.alwaysShowVolume || this.state.active
        }, 'video-react-volume-menu-button'),
        onClick: this.handleClick,
        inline: inline
      }, _react["default"].createElement(_VolumeBar["default"], (0, _extends2["default"])({
        onFocus: this.handleFocus,
        onBlur: this.handleBlur
      }, this.props)));
    }
  }, {
    key: "volumeLevel",
    get: function get() {
      var _this$props$player = this.props.player,
          volume = _this$props$player.volume,
          muted = _this$props$player.muted;
      var level = 3;

      if (volume === 0 || muted) {
        level = 0;
      } else if (volume < 0.33) {
        level = 1;
      } else if (volume < 0.67) {
        level = 2;
      }

      return level;
    }
  }]);
  return VolumeMenuButton;
}(_react.Component);

VolumeMenuButton.propTypes = propTypes;
VolumeMenuButton.defaultProps = defaultProps;
VolumeMenuButton.displayName = 'VolumeMenuButton';
var _default = VolumeMenuButton;
exports["default"] = _default;

/***/ }),
/* 363 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(12);

var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(111));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(57));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(10));

var _createClass2 = _interopRequireDefault(__webpack_require__(11));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(16));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(15));

var _inherits2 = _interopRequireDefault(__webpack_require__(17));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(9));

var propTypes = {
  tagName: _propTypes["default"].string,
  onClick: _propTypes["default"].func.isRequired,
  onFocus: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  className: _propTypes["default"].string
};
var defaultProps = {
  tagName: 'div'
};

var ClickableComponent =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(ClickableComponent, _Component);

  function ClickableComponent(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, ClickableComponent);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ClickableComponent).call(this, props, context));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleKeypress = _this.handleKeypress.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(ClickableComponent, [{
    key: "componentWillUnmount",
    value: function componentWillUnmount(e) {
      this.handleBlur(e);
    }
  }, {
    key: "handleKeypress",
    value: function handleKeypress(event) {
      // Support Space (32) or Enter (13) key operation to fire a click event
      if (event.which === 32 || event.which === 13) {
        event.preventDefault();
        this.handleClick(event);
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick(event) {
      var onClick = this.props.onClick;
      onClick(event);
    }
  }, {
    key: "handleFocus",
    value: function handleFocus(e) {
      document.addEventListener('keydown', this.handleKeypress);

      if (this.props.onFocus) {
        this.props.onFocus(e);
      }
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(e) {
      document.removeEventListener('keydown', this.handleKeypress);

      if (this.props.onBlur) {
        this.props.onBlur(e);
      }
    }
  }, {
    key: "render",
    value: function render() {
      var Tag = this.props.tagName;
      var props = (0, _objectSpread2["default"])({}, this.props);
      delete props.tagName;
      delete props.className;
      return _react["default"].createElement(Tag, (0, _extends2["default"])({
        className: (0, _classnames["default"])(this.props.className),
        role: "button",
        tabIndex: "0",
        onClick: this.handleClick,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur
      }, props));
    }
  }]);
  return ClickableComponent;
}(_react.Component);

exports["default"] = ClickableComponent;
ClickableComponent.propTypes = propTypes;
ClickableComponent.defaultProps = defaultProps;
ClickableComponent.displayName = 'ClickableComponent';

/***/ }),
/* 364 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(2);
var path=Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* assetsPath */])();/* harmony default export */ __webpack_exports__["a"] = (function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{viewBox:"0 0 512 512",width:150,height:150,x:-150,y:0},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("image",{xlinkHref:path+"/images/project-map/laguna-beachside-bubble.svg",width:512,height:512}));});

/***/ }),
/* 365 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(2);
var path=Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* assetsPath */])();/* harmony default export */ __webpack_exports__["a"] = (function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{viewBox:"0 0 512 512",width:150,height:150,x:-175,y:-55},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("image",{xlinkHref:path+"/images/project-map/laguna-seaside-residences-bubble.svg",width:512,height:512}));});

/***/ }),
/* 366 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",Object.assign({viewBox:"0 0 962.8 988.1",enableBackground:"new 0 0 962.8 988.1",xmlSpace:"preserve"},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("linearGradient",{id:"SVGID_1_",gradientUnits:"userSpaceOnUse",x1:"3196.448",y1:"1824.5952",x2:"4126.0854",y2:"1824.5952",gradientTransform:"matrix(0.1351 -0.9908 0.9908 0.1351 -1862.3046 3869.717)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("stop",{offset:"0",stopColor:"#FFFFFF"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("stop",{offset:"1",stopColor:"#D9D8D6"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"url(#SVGID_1_)",d:"M828.8,606.2c-7.3,53.6-24.9,104.2-52.3,150.3c-26.5,44.6-60.9,83.1-102.3,114.6 c-41.4,31.5-87.8,54.3-137.8,67.9c-51.8,14-105.2,17.4-158.8,10.1s-104.2-24.9-150.3-52.3C182.6,870.4,144,836,112.6,794.5 c-31.5-41.4-54.3-87.8-67.9-137.8c-14-51.8-17.4-105.2-10.1-158.8c7.3-53.6,24.9-104.2,52.3-150.3 c26.5-44.6,60.9-83.1,102.3-114.6C230.6,201.4,277,178.6,327,165c51.8-14,105.2-17.4,158.8-10.1c53.6,7.3,104.1,25.1,150.3,52.3 c42.6,25,245.4-127.5,245.4-127.5S726.7,278.1,750.8,309.5c31.7,41.3,54.3,87.8,67.9,137.8C832.7,499.1,836.1,552.6,828.8,606.2z "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("linearGradient",{id:"SVGID_2_",gradientUnits:"userSpaceOnUse",x1:"140.438",y1:"843.2526",x2:"952.0792",y2:"31.6114"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("stop",{offset:"0",stopColor:"#00A39A"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("stop",{offset:"1",stopColor:"#EC008C"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"url(#SVGID_2_)",d:"M881.6,79.7c0,0-154.9,198.5-130.8,229.9c31.7,41.3,54.3,87.8,67.9,137.8 c14,51.8,17.4,105.2,10.1,158.8c-7.3,53.6-24.9,104.2-52.3,150.3c-26.5,44.6-60.9,83.1-102.3,114.6 c-41.4,31.5-87.8,54.3-137.8,67.9c-34.1,9.2-68.9,13.9-104,13.9c-18.2,0-36.5-1.2-54.8-3.7c-53.6-7.3-104.2-24.9-150.3-52.3 C182.6,870.4,144,836,112.6,794.5c-31.5-41.4-54.3-87.8-67.9-137.8c-14-51.8-17.4-105.2-10.1-158.8 c7.3-53.6,24.9-104.2,52.3-150.3c26.5-44.6,60.9-83.1,102.3-114.6C230.6,201.4,277,178.6,327,165c34.1-9.2,68.9-13.9,104-13.9 c18.2,0,36.5,1.2,54.8,3.7c53.6,7.3,104.1,25.1,150.3,52.3c3.2,1.9,7.4,2.8,12.3,2.8C708.3,210,881.6,79.7,881.6,79.7 M941.4,20.9L875,70.9c-0.4,0.3-43.7,32.8-93.6,64.8c-63.7,40.9-110.9,63.3-133,63.3c-4,0-5.9-0.8-6.7-1.3 c-48-28.2-100-46.3-154.4-53.7c-18.7-2.6-37.6-3.8-56.3-3.8c-36,0-72,4.8-106.9,14.3c-51.4,13.9-99,37.4-141.6,69.7 c-42.6,32.4-77.9,72-105.1,117.8c-28.1,47.4-46.2,99.4-53.7,154.5s-4,110,10.4,163.2c13.9,51.4,37.4,99,69.7,141.6 c32.4,42.6,72,77.9,117.8,105.1c47.4,28.1,99.4,46.2,154.5,53.7c18.7,2.6,37.6,3.8,56.3,3.8c36,0,72-4.8,106.9-14.3 c51.4-13.9,99-37.4,141.6-69.7c42.6-32.4,77.9-72,105.1-117.8c28.1-47.4,46.2-99.4,53.7-154.5c7.5-55.1,4-110-10.4-163.2 c-14.1-52-37.5-99.6-69.7-141.6c-0.2-0.6-3-8.9,12.9-40.8c10-20,25.3-45.4,45.5-75.6c34.6-51.7,72-99.6,72.3-100.1L941.4,20.9 L941.4,20.9z M881.6,90.7L881.6,90.7L881.6,90.7L881.6,90.7z"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"Artwork_1_1_"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#00A19B",d:"M243,576.6c-19.4,0-31.9-10.6-31.9-26.9c0-18.3,21.1-27,38.2-34c2.5-1,4.9-2,7.1-3 c3.7-1.6,6.5-2.7,8.9-3.5c8.1-3,8.1-3,8.1-14c0-11-4.4-14.9-17.3-15.2c-0.3,0-0.7,0-0.9,0c-12.2,0-21.3,6.6-24.3,8.8l-0.4,0.3 c-1.7,1.2-3.1,1.8-4.3,1.8c-0.9,0-1.8-0.4-2.5-1c-0.6-0.6-0.8-1.3-0.8-2.1c0.1-1.8,1.6-3.9,4.5-6.4c11.9-10,26.7-11.5,34.5-11.5 c13.8,0,32.1,2.1,32.1,19.9v44.6c0,1.8,0,3.5,0,5c0,11-0.1,16.6,3.1,24.6c1.3,2.6,3,5.1,6.3,5.1c2.9,0,4.5,0.9,4.7,2.6 c0.3,2.6-2.2,3.1-3.5,3.4c-2.2,0.4-4.8,0.7-7.3,0.7c-2.9,0-5.4-0.3-7.5-0.9l-0.2,0c-12-3.3-13.4-7.8-14.4-10.7 c-0.1-0.3-0.2-0.6-0.3-0.8c-0.5-1.3-0.8-1.9-1.4-1.9c-0.3,0-0.4,0-0.5,0.2l-0.1,0.1l-0.2,0.3C266.4,570.7,260.9,576.6,243,576.6 M273.4,515.1l-11.8,5.5c-17.6,8.3-27.4,12.8-27.4,25.4c0,9.8,6.5,15.3,17.9,15.3c14.6,0,21.2-12.4,21.2-24.6V515.1z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#00A19B",d:"M692.5,576.6c-19.4,0-31.9-10.6-31.9-26.9c0-18.3,21.2-27,38.2-34c2.5-1,4.9-2,7.1-3 c3.7-1.6,6.5-2.7,8.9-3.5c8.1-3,8.1-3,8.1-14c0-11-4.4-14.9-17.3-15.2c-0.3,0-0.7,0-0.9,0c-12.2,0-21.3,6.6-24.3,8.8l-0.4,0.3 c-1.7,1.2-3.1,1.8-4.3,1.8c-0.9,0-1.8-0.4-2.5-1c-0.5-0.6-0.8-1.3-0.8-2.1c0.1-1.8,1.6-3.9,4.5-6.4c11.9-10,26.7-11.5,34.5-11.5 c13.8,0,32.1,2.1,32.1,19.9v44.6c0,1.8,0,3.5,0,5.1c0,11-0.1,15.1,3.1,23.1c1.3,2.6,3,5.1,6.3,5.1c2.9,0,4.5,0.9,4.7,2.6 c0.3,2.6-2.2,3.1-3.5,3.4c-2.1,0.4-4.8,0.6-7.3,0.6c-2.9,0-5.4-0.3-7.5-0.9l-0.2-0.1c-12-3.3-13.4-7.7-14.3-10.7 c-0.1-0.3-0.2-0.5-0.3-0.8c-0.5-1.3-0.8-1.9-1.4-1.9c-0.3,0-0.4,0-0.5,0.2l-0.1,0.1l-0.2,0.2 C715.8,569.2,710.4,576.6,692.5,576.6 M722.8,515.1l-11.8,5.5c-17.6,8.3-27.4,12.8-27.4,25.4c0,9.8,6.5,15.3,17.9,15.3 c14.6,0,21.2-12.4,21.2-24.6V515.1z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#00A19B",d:"M470.2,576.6c-19,0-31.4-12.7-31.4-32.2c0,0-0.1-61.3-0.1-62.2c0-2.8-1.7-4.3-4.9-4.3h-2.2 c-3.1,0-6.6,0-6.6-2.9c0-3,3.1-3.3,5.9-3.5l0.9-0.1c4.2-0.4,7.8-0.8,12.7-0.8c7.4,0,14.8,3,14.8,9.9v51.3c0,15.6,2.5,30,20.9,30 c20.4,0,22.2-19.5,22.2-37.9v-41.8c0-1,0-4.1-4.9-4.2l-0.7,0c-0.6,0-1.2,0-1.8,0c-0.5,0-1,0-1.4,0c-1.8,0-4.9,0-4.9-3 c0-3,3-3.2,5.9-3.5l0.7-0.1c4.3-0.4,7.9-0.8,13-0.8c7.4,0,14.8,3,14.8,9.9c0,3.4,0,22.6-0.1,39.5c0,13.2,0,25,0,26.6 c0,8.1,1.1,13.1,2.7,17.4c1.2,2.4,2.9,4.9,6.3,5.1h0.2c1.7,0.1,4.8,0.2,4.8,2.8c0,0.6-0.3,2.5-3.5,3.2c-2,0.4-4.6,0.7-7.2,0.7 c-2.1,0-4.1-0.2-5.9-0.5c-0.8-0.1-1.5-0.3-2.1-0.5l-0.4-0.1c-4.3-1.2-7.5-2.7-9.9-4.5c-3.1-2.4-3.7-5-4.1-6.5l-0.1-0.5 c-0.1-0.2-0.1-0.4-0.1-0.7c0-0.2-0.1-0.5-0.2-0.8c-0.6,0.7-1,1.2-1.4,1.8c-0.6,0.9-1.3,1.8-2,2.4 C497.9,568.6,485.4,576.6,470.2,576.6"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#00A19B",d:"M609.3,469.1c19.1,0,31.4,12.7,31.4,32.2c0,0,0.1,62.8,0.1,63.7c0,2.8,1.7,4.2,4.9,4.2h2.2 c3.1,0,6.6,0,6.6,2.9c0,3-3.2,3.3-5.9,3.5l-0.9,0.1c-4.2,0.4-7.8,0.8-12.7,0.8c-7.4,0-14.8-3-14.8-9.9v-52.9 c0-15.6-2.5-30-20.9-30c-20.5,0-22.2,19.5-22.2,37.9v43.3c0,1,0,4.1,4.9,4.2l0.7,0c0.6,0,1.2,0,1.8,0c0.5,0,1,0,1.4,0 c1.8,0,4.9,0,4.9,2.9c0,3-3,3.3-5.9,3.5l-0.7,0.1c-4.3,0.4-7.9,0.8-13,0.8c-7.4,0-14.9-3-14.9-9.9c0-3.4,0-24.2,0-41 c0-13.2,0-25,0-26.6c0-8.1-1.1-11.5-2.8-15.9c-1.2-2.4-2.9-4.9-6.3-5.1l-0.2,0c-1.7-0.1-4.8-0.2-4.8-2.8c0-0.6,0.3-2.5,3.5-3.2 c2-0.4,4.6-0.7,7.2-0.7h0c2.1,0,4.1,0.2,5.9,0.5c0.8,0.1,1.5,0.3,2.1,0.5l0.4,0.1c4.3,1.2,7.5,2.6,9.9,4.5 c3.1,2.4,3.7,5,4.1,6.5l0.1,0.5c0.1,0.2,0.1,0.4,0.2,0.7c0,0.2,0.1,0.5,0.2,0.7c0.4-0.4,1-1.2,1.4-1.8c0.6-0.9,1.3-1.8,2-2.4 C581.6,478.7,594.1,469.1,609.3,469.1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#00A19B",d:"M376.5,577.2c-39.6,0-60.6-18-60.6-52c0-17.1,6.9-31,20-43.5c15.4-14.7,37.8-11,41.8-10.5 c3.6,0.5,6.9,0.9,9.9,0.9c3.3,0,5.7-0.5,7.8-1.6l2.2-1.2c4.6-2.6,6.9-3.9,8.8-3.9c1,0,1.8,0.4,2.6,1.1c2.5,2.6-0.5,5.9-1.6,7 c-0.2,0.2-0.5,0.5-0.8,0.9c-4.6,5.1-9.5,9.8-13.7,10.6c-10.7,1.9-19-4.7-26.9-4.7c-22.1,0-28.1,25.4-28.1,40.1 c0,20.7,7.6,45.3,43.9,45.3c0.6,0,1.2,0,1.8,0l0,0c0.1,0,0.1,0,0.2,0c0.8-0.1,2.1-0.2,4.2-0.3c0.4,0,0.9-0.1,1.3-0.1 c3.6-0.7,4-3.3,4-3.8l-0.2-33.6c0-1.9-0.8-2.3-1.6-2.6c0,0-0.3,0-0.8,0c-1.3,0-3.7,0-6.9,0.1c-3.8,0.1-8.6,0.2-13.9,0.2 c-6.7,0.1-9.3-0.3-10.7-1.7c-0.7-0.7-0.9-1.7-0.9-2.9c0.2-3.6,4.3-4,9.6-4.1c1.1,0,4.3-0.1,8.1-0.2c8.1-0.2,19.3-0.6,22.5-0.6 c7.1,0,14.2,3.1,14.2,10l0,12.8c-0.1,1.7-0.1,3.2-0.1,4.4v15.6c0,10.5-9.8,16.6-29.3,18.3l-0.8,0.1 C380.6,577.2,378.5,577.2,376.5,577.2"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#00A19B",d:"M164,576.6c-18.3,0-25-5.8-25-21.3l-0.1-51.8v-53.7h0.9v0h-0.9v-5c0-1.8-0.5-4.1-5-4.2l-1.4,0 c-4.3-0.1-7.4-0.2-7.4-3.1c0-3.1,3.3-3.2,6.3-3.4l0.2,0c1.6-0.1,3.2-0.2,4.7-0.4c2.6-0.2,5.2-0.5,8.4-0.5 c7.4,0,14.8,3.1,14.8,9.9l0,110.8c0,4.5,0,8.3,2.1,10.5c1.5,1.5,4.1,2.3,8,2.3c5.8,0,14.9-1.6,25.5-9l0.1-0.1 c2.8-1.9,5.3-2.2,6.7-0.9c0.7,0.7,1,1.5,1,2.3c-0.1,1.7-1.5,3.6-4.6,6.2C186.6,575.1,171.8,576.6,164,576.6"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#0694A3",d:"M326.4,442.2c-0.5-0.2-0.5-1.1,0.3-3.3c0.9-2.4,6.3-12.3,15.9-19.1c11.2-7.9,21.3-11.5,28.8-16.8 c7-5,10-9.9,10.9-12.8c0.2-0.6,0.4-1.3,0.6-1.3c0.4-0.1,0.6,0.6,0.7,1.7c0.4,2.5,0,13.4-8.8,23.5c-7,8-17.5,12.7-25.2,16.4 c-7.1,3.4-11.5,5.5-17.4,8.8C330.6,440.1,327.3,442.5,326.4,442.2"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#EC008C",d:"M383.4,404.9c0.5,1.6,3.7,14.1-6.5,26.8c-11,13.6-25,15.3-36.8,19.8c-9.6,3.7-18.4,7.5-23.2,16 c-0.7,1.2-0.8,3.1-2.2,3.4c-1.8,0.4-1.8-1.9-1.9-3.1c-0.1-1.3-0.9-12.8,9.6-22.4c11.5-10.6,22.3-13.4,39.7-22.7 c12.8-6.9,17.3-16.1,18.3-18c0.4-0.7,1.2-2.2,1.5-3C382.3,400.9,383,403.5,383.4,404.9"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#6D6E71",d:"M293.7,622.4l16.9,40.9h0.1l16.7-40.9h5.2l-19.3,45.7h-5.7l-19.2-45.7H293.7z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#6D6E71",d:"M346.2,622.4v45.7h-4.9v-45.7H346.2z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#6D6E71",d:"M365.5,622.4v42h29.1v3.7h-34v-45.7H365.5z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#6D6E71",d:"M408.2,622.4v42h29.1v3.7h-34v-45.7H408.2z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#6D6E71",d:"M466.6,622.4l20.3,45.7h-5.3l-6.3-14.2h-23.6l-6.2,14.2h-5.2l20.9-45.7H466.6z M473.6,650.1l-10-23.4 l-10.4,23.4H473.6z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#6D6E71",d:"M536.1,668.1l-0.7-8.3h-0.1c-0.9,1.6-1.9,3-3.2,4.2c-1.3,1.2-2.7,2.1-4.2,2.9c-1.6,0.7-3.2,1.3-5,1.6 c-1.8,0.3-3.6,0.5-5.5,0.5c-4.1,0-7.6-0.7-10.7-2c-3.1-1.3-5.6-3-7.7-5.2c-2-2.2-3.6-4.7-4.6-7.5c-1-2.9-1.5-5.9-1.5-9 c0-3.2,0.5-6.2,1.5-9c1-2.9,2.5-5.4,4.6-7.6c2-2.2,4.6-3.9,7.7-5.2c3.1-1.3,6.6-2,10.7-2c2.7,0,5.3,0.3,7.7,1 c2.4,0.6,4.6,1.6,6.5,2.9c1.9,1.3,3.5,2.9,4.8,4.7c1.3,1.9,2.2,4.1,2.7,6.6H534c-0.1-1.3-0.6-2.7-1.5-4c-0.8-1.3-2-2.6-3.4-3.7 c-1.4-1.1-3.1-2-5.1-2.7s-4.2-1.1-6.7-1.1c-3.4,0-6.4,0.6-8.9,1.7c-2.5,1.2-4.5,2.7-6.1,4.6c-1.6,1.9-2.7,4-3.5,6.4 c-0.8,2.4-1.1,4.8-1.1,7.4c0,2.5,0.4,4.9,1.1,7.3c0.7,2.4,1.9,4.6,3.5,6.5c1.6,1.9,3.6,3.4,6.1,4.6c2.5,1.2,5.4,1.7,8.9,1.7 c2.9,0,5.4-0.4,7.7-1.2s4.2-2,5.7-3.5c1.6-1.5,2.7-3.3,3.5-5.3c0.8-2,1.1-4.3,1.1-6.7h-17.7v-3.7h22v23.2H536.1z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#6D6E71",d:"M588.6,622.4v3.7h-30.9v16.5h28.9v3.7h-28.9v18h31.2v3.7h-36.2v-45.7H588.6z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#6D6E71",d:"M223.3,691c2.2,0,4.4,0.2,6.4,0.7c2,0.5,3.8,1.2,5.3,2.3c1.5,1,2.7,2.3,3.6,3.9c0.9,1.6,1.3,3.5,1.3,5.6 c0,3-0.9,5.7-2.7,7.9c-1.8,2.2-4.4,3.7-7.9,4.3v0.1c1.8,0.2,3.3,0.6,4.4,1.2c1.2,0.6,2.1,1.4,2.9,2.3c0.7,0.9,1.3,2,1.6,3.3 c0.3,1.2,0.5,2.6,0.6,4c0,0.8,0.1,1.8,0.2,3c0,1.2,0.2,2.3,0.3,3.5c0.2,1.2,0.4,2.3,0.7,3.4c0.3,1.1,0.8,1.9,1.3,2.5h-5.7 c-0.3-0.4-0.5-1-0.7-1.6c-0.2-0.6-0.3-1.3-0.4-2s-0.1-1.4-0.2-2.1c-0.1-0.7-0.1-1.3-0.2-1.7c-0.1-1.7-0.3-3.4-0.5-5.1 c-0.2-1.7-0.7-3.2-1.4-4.5c-0.7-1.3-1.8-2.4-3.2-3.2c-1.4-0.8-3.3-1.2-5.8-1.1h-19.7V739h-5.2v-48H223.3z M223,713.8 c1.6,0,3.1-0.2,4.5-0.6c1.4-0.4,2.7-1,3.7-1.9c1.1-0.8,1.9-1.8,2.6-2.9c0.6-1.1,1-2.5,1-3.9c0-3-1-5.3-2.9-7 c-1.9-1.7-4.9-2.6-8.9-2.6h-19.4v18.9H223z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#6D6E71",d:"M290.8,691v3.9h-32.5v17.3h30.4v3.9h-30.4v19h32.8v3.9h-38v-48H290.8z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#6D6E71",d:"M306,729.4c0.9,1.7,2.2,3,3.8,4c1.6,1,3.5,1.7,5.7,2.1c2.2,0.4,4.5,0.6,7,0.6c1.4,0,3-0.2,4.7-0.5 c1.7-0.4,3.2-0.9,4.7-1.7c1.5-0.8,2.7-1.8,3.6-3c1-1.2,1.5-2.7,1.5-4.5c0-1.3-0.3-2.5-1-3.5c-0.7-1-1.6-1.8-2.7-2.5 c-1.1-0.7-2.3-1.2-3.6-1.6c-1.3-0.4-2.6-0.8-3.9-1l-12.1-2.6c-1.6-0.4-3.1-0.8-4.6-1.3c-1.5-0.5-2.8-1.3-3.9-2.2 c-1.1-0.9-2-2-2.7-3.3c-0.7-1.3-1-2.9-1-4.8c0-1.2,0.3-2.5,0.8-4.1c0.5-1.6,1.5-3,2.9-4.4c1.4-1.4,3.3-2.6,5.8-3.5 c2.4-1,5.6-1.4,9.4-1.4c2.7,0,5.3,0.3,7.7,0.9c2.4,0.6,4.6,1.6,6.4,2.8s3.3,2.8,4.4,4.7c1.1,1.9,1.6,4,1.6,6.5H335 c-0.1-1.8-0.6-3.4-1.4-4.8c-0.8-1.4-1.9-2.5-3.3-3.4c-1.4-0.9-2.9-1.6-4.7-2.1c-1.8-0.5-3.6-0.7-5.5-0.7c-1.8,0-3.5,0.2-5.2,0.5 c-1.7,0.3-3.1,0.9-4.4,1.6c-1.2,0.7-2.3,1.7-3,2.9c-0.8,1.2-1.1,2.7-1.1,4.5c0,1.1,0.2,2.1,0.7,2.9c0.4,0.8,1,1.5,1.8,2.1 c0.8,0.6,1.6,1.1,2.6,1.4c1,0.4,2,0.6,3.2,0.9l13.3,2.9c1.9,0.5,3.8,1,5.5,1.6c1.7,0.7,3.2,1.5,4.5,2.4c1.3,1,2.3,2.1,3.1,3.5 c0.7,1.4,1.1,3.1,1.1,5c0,0.5-0.1,1.3-0.2,2.2c-0.1,0.9-0.4,1.8-0.9,2.9c-0.5,1-1.2,2-2.1,3.1c-0.9,1-2.1,2-3.7,2.8 c-1.6,0.8-3.5,1.5-5.8,2c-2.3,0.5-5,0.8-8.2,0.8s-6.2-0.3-8.9-1c-2.7-0.6-5.1-1.6-7-3c-1.9-1.3-3.4-3.1-4.5-5.2 s-1.5-4.6-1.3-7.6h5.2C304.6,725.7,305.1,727.8,306,729.4z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#6D6E71",d:"M359.8,691v48h-5.2v-48H359.8z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#6D6E71",d:"M393.8,691c8.3,0.2,14.5,2.2,18.8,6.2c4.2,3.9,6.3,9.9,6.3,17.9s-2.1,13.9-6.3,17.9 c-4.2,3.9-10.5,6-18.8,6.2h-18.9v-48H393.8z M391.2,735.1c3.9,0,7.3-0.4,10.1-1.1c2.8-0.7,5.2-1.9,7-3.5c1.8-1.6,3.2-3.7,4-6.3 c0.9-2.6,1.3-5.6,1.3-9.2s-0.4-6.7-1.3-9.2c-0.9-2.6-2.2-4.6-4-6.3c-1.8-1.6-4.2-2.8-7-3.5c-2.8-0.7-6.2-1.1-10.1-1.1h-11.1 v40.2H391.2z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#6D6E71",d:"M468.7,691v3.9h-32.5v17.3h30.4v3.9h-30.4v19h32.8v3.9h-38v-48H468.7z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#6D6E71",d:"M485.9,691l31.8,40.6h0.2V691h5.2v48h-5.8l-31.8-40.6h-0.2V739h-5.2v-48H485.9z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#6D6E71",d:"M575.4,700.6c-1-1.5-2.3-2.7-3.8-3.7c-1.5-1-3.2-1.7-5-2.3c-1.8-0.5-3.7-0.8-5.7-0.8 c-3.6,0-6.7,0.6-9.3,1.8s-4.7,2.8-6.4,4.8c-1.7,2-2.9,4.2-3.7,6.8c-0.8,2.5-1.2,5.1-1.2,7.7c0,2.6,0.4,5.2,1.2,7.7 c0.8,2.5,2,4.8,3.7,6.8c1.7,2,3.8,3.6,6.4,4.8c2.6,1.2,5.7,1.8,9.3,1.8c2.5,0,4.8-0.4,6.9-1.2c2-0.8,3.8-1.9,5.3-3.3 c1.5-1.4,2.7-3,3.6-4.9c0.9-1.9,1.5-3.9,1.8-6h5.2c-0.4,3-1.1,5.6-2.4,8c-1.2,2.4-2.8,4.4-4.7,6.1c-1.9,1.7-4.2,2.9-6.8,3.8 c-2.6,0.9-5.5,1.3-8.7,1.3c-4.3,0-8-0.7-11.3-2.1c-3.2-1.4-5.9-3.2-8.1-5.5c-2.1-2.3-3.7-4.9-4.8-7.9c-1.1-3-1.6-6.2-1.6-9.5 c0-3.3,0.5-6.5,1.6-9.5c1.1-3,2.7-5.7,4.8-8c2.1-2.3,4.8-4.1,8.1-5.5c3.2-1.4,7-2.1,11.3-2.1c2.6,0,5.1,0.3,7.6,1 c2.5,0.7,4.7,1.7,6.7,3c2,1.3,3.7,2.9,5,4.9c1.3,1.9,2.2,4.1,2.6,6.7h-5.2C577.2,703.7,576.4,702.1,575.4,700.6z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#6D6E71",d:"M633,691v3.9h-32.5v17.3H631v3.9h-30.4v19h32.8v3.9h-38v-48H633z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#6D6E71",d:"M648.2,729.4c0.9,1.7,2.2,3,3.8,4c1.6,1,3.5,1.7,5.7,2.1c2.2,0.4,4.5,0.6,7,0.6c1.4,0,3-0.2,4.7-0.5 c1.7-0.4,3.2-0.9,4.7-1.7c1.5-0.8,2.7-1.8,3.6-3c1-1.2,1.5-2.7,1.5-4.5c0-1.3-0.3-2.5-1-3.5c-0.7-1-1.6-1.8-2.7-2.5 c-1.1-0.7-2.3-1.2-3.6-1.6c-1.3-0.4-2.6-0.8-3.9-1l-12.1-2.6c-1.6-0.4-3.1-0.8-4.6-1.3c-1.5-0.5-2.8-1.3-3.9-2.2 c-1.1-0.9-2-2-2.7-3.3c-0.7-1.3-1-2.9-1-4.8c0-1.2,0.3-2.5,0.8-4.1c0.5-1.6,1.5-3,2.9-4.4c1.4-1.4,3.3-2.6,5.8-3.5 c2.4-1,5.6-1.4,9.4-1.4c2.7,0,5.3,0.3,7.7,0.9c2.4,0.6,4.6,1.6,6.4,2.8c1.8,1.3,3.3,2.8,4.4,4.7c1.1,1.9,1.6,4,1.6,6.5h-5.2 c-0.1-1.8-0.6-3.4-1.4-4.8c-0.8-1.4-1.9-2.5-3.3-3.4c-1.4-0.9-2.9-1.6-4.7-2.1c-1.8-0.5-3.6-0.7-5.5-0.7c-1.8,0-3.5,0.2-5.2,0.5 c-1.7,0.3-3.1,0.9-4.4,1.6c-1.2,0.7-2.3,1.7-3,2.9c-0.8,1.2-1.1,2.7-1.1,4.5c0,1.1,0.2,2.1,0.7,2.9c0.4,0.8,1,1.5,1.8,2.1 c0.8,0.6,1.6,1.1,2.6,1.4c1,0.4,2,0.6,3.2,0.9l13.3,2.9c1.9,0.5,3.8,1,5.5,1.6c1.7,0.7,3.2,1.5,4.5,2.4c1.3,1,2.3,2.1,3.1,3.5 c0.7,1.4,1.1,3.1,1.1,5c0,0.5-0.1,1.3-0.2,2.2c-0.1,0.9-0.4,1.8-0.9,2.9c-0.5,1-1.2,2-2.1,3.1c-0.9,1-2.1,2-3.7,2.8 c-1.6,0.8-3.5,1.5-5.8,2c-2.3,0.5-5,0.8-8.2,0.8c-3.2,0-6.2-0.3-8.9-1c-2.7-0.6-5.1-1.6-7-3c-1.9-1.3-3.4-3.1-4.5-5.2 s-1.5-4.6-1.3-7.6h5.2C646.9,725.7,647.3,727.8,648.2,729.4z"}))))));});

/***/ }),
/* 367 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(2);
var path=Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* assetsPath */])();/* harmony default export */ __webpack_exports__["a"] = (function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{viewBox:"0 0 512 512",width:150,height:150,y:-150},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("image",{xlinkHref:path+"/images/project-map/laguna-park-2-bubble.svg",width:512,height:512}));});

/***/ }),
/* 368 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(2);
var path=Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* assetsPath */])();/* harmony default export */ __webpack_exports__["a"] = (function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{viewBox:"0 0 512 512",width:150,height:150,y:-50},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("image",{xlinkHref:path+"/images/project-map/new-skypark-bubble.svg",width:512,height:512}));});

/***/ }),
/* 369 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export ARRAY_ERROR */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return FORM_ERROR; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return configOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return createForm; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fieldSubscriptionItems; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return formSubscriptionItems; });
/* unused harmony export getIn */
/* unused harmony export setIn */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return version; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(90);



//      

var charCodeOfDot = ".".charCodeAt(0);
var reEscapeChar = /\\(\\)?/g;
var rePropName = RegExp(
// Match anything that isn't a dot or bracket.
"[^.[\\]]+" + "|" +
// Or match property names within brackets.
"\\[(?:" +
// Match a non-string expression.
"([^\"'][^[]*)" + "|" +
// Or match strings (supports escaping characters).
"([\"'])((?:(?!\\2)[^\\\\]|\\\\.)*?)\\2" + ")\\]" + "|" +
// Or match "" as the space between consecutive dots or empty brackets.
"(?=(?:\\.|\\[\\])(?:\\.|\\[\\]|$))", "g");

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = function stringToPath(string) {
  var result = [];
  if (string.charCodeAt(0) === charCodeOfDot) {
    result.push("");
  }
  string.replace(rePropName, function (match, expression, quote, subString) {
    var key = match;
    if (quote) {
      key = subString.replace(reEscapeChar, "$1");
    } else if (expression) {
      key = expression.trim();
    }
    result.push(key);
  });
  return result;
};
var keysCache = {};
var keysRegex = /[.[\]]+/;
var toPath = function toPath(key) {
  if (key === null || key === undefined || !key.length) {
    return [];
  }
  if (typeof key !== "string") {
    throw new Error("toPath() expects a string");
  }
  if (keysCache[key] == null) {
    /**
     * The following patch fixes issue 456, introduced since v4.20.3:
     *
     * Before v4.20.3, i.e. in v4.20.2, a `key` like 'choices[]' would map to ['choices']
     * (e.g. an array of choices used where 'choices[]' is name attribute of an input of type checkbox).
     *
     * Since v4.20.3, a `key` like 'choices[]' would map to ['choices', ''] which is wrong and breaks
     * this kind of inputs e.g. in React.
     *
     * v4.20.3 introduced an unwanted breaking change, this patch fixes it, see the issue at the link below.
     *
     * @see https://github.com/final-form/final-form/issues/456
     */
    if (key.endsWith("[]")) {
      // v4.20.2 (a `key` like 'choices[]' should map to ['choices'], which is fine).
      keysCache[key] = key.split(keysRegex).filter(Boolean);
    } else {
      // v4.20.3 (a `key` like 'choices[]' maps to ['choices', ''], which breaks applications relying on inputs like `<input type="checkbox" name="choices[]" />`).
      keysCache[key] = stringToPath(key);
    }
  }
  return keysCache[key];
};

//      
var getIn = function getIn(state, complexKey) {
  // Intentionally using iteration rather than recursion
  var path = toPath(complexKey);
  var current = state;
  for (var i = 0; i < path.length; i++) {
    var key = path[i];
    if (current === undefined || current === null || typeof current !== "object" || Array.isArray(current) && isNaN(key)) {
      return undefined;
    }
    current = current[key];
  }
  return current;
};

function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var setInRecursor = function setInRecursor(current, index, path, value, destroyArrays) {
  if (index >= path.length) {
    // end of recursion
    return value;
  }
  var key = path[index];

  // determine type of key
  if (isNaN(key)) {
    var _extends2;
    // object set
    if (current === undefined || current === null) {
      var _ref;
      // recurse
      var _result = setInRecursor(undefined, index + 1, path, value, destroyArrays);

      // delete or create an object
      return _result === undefined ? undefined : (_ref = {}, _ref[key] = _result, _ref);
    }
    if (Array.isArray(current)) {
      throw new Error("Cannot set a non-numeric property on an array");
    }
    // current exists, so make a copy of all its values, and add/update the new one
    var _result2 = setInRecursor(current[key], index + 1, path, value, destroyArrays);
    if (_result2 === undefined) {
      var numKeys = Object.keys(current).length;
      if (current[key] === undefined && numKeys === 0) {
        // object was already empty
        return undefined;
      }
      if (current[key] !== undefined && numKeys <= 1) {
        // only key we had was the one we are deleting
        if (!isNaN(path[index - 1]) && !destroyArrays) {
          // we are in an array, so return an empty object
          return {};
        } else {
          return undefined;
        }
      }
      current[key];
        var _final = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(current, [key].map(_toPropertyKey));
      return _final;
    }
    // set result in key
    return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, current, (_extends2 = {}, _extends2[key] = _result2, _extends2));
  }
  // array set
  var numericKey = Number(key);
  if (current === undefined || current === null) {
    // recurse
    var _result3 = setInRecursor(undefined, index + 1, path, value, destroyArrays);

    // if nothing returned, delete it
    if (_result3 === undefined) {
      return undefined;
    }

    // create an array
    var _array = [];
    _array[numericKey] = _result3;
    return _array;
  }
  if (!Array.isArray(current)) {
    throw new Error("Cannot set a numeric property on an object");
  }
  // recurse
  var existingValue = current[numericKey];
  var result = setInRecursor(existingValue, index + 1, path, value, destroyArrays);

  // current exists, so make a copy of all its values, and add/update the new one
  var array = [].concat(current);
  if (destroyArrays && result === undefined) {
    array.splice(numericKey, 1);
    if (array.length === 0) {
      return undefined;
    }
  } else {
    array[numericKey] = result;
  }
  return array;
};
var setIn = function setIn(state, key, value, destroyArrays) {
  if (destroyArrays === void 0) {
    destroyArrays = false;
  }
  if (state === undefined || state === null) {
    throw new Error("Cannot call setIn() with " + String(state) + " state");
  }
  if (key === undefined || key === null) {
    throw new Error("Cannot call setIn() with " + String(key) + " key");
  }
  // Recursive function needs to accept and return State, but public API should
  // only deal with Objects
  return setInRecursor(state, 0, toPath(key), value, destroyArrays);
};

var FORM_ERROR = "FINAL_FORM/form-error";
var ARRAY_ERROR = "FINAL_FORM/array-error";

//      


/**
 * Converts internal field state to published field state
 */
function publishFieldState(formState, field) {
  var errors = formState.errors,
    initialValues = formState.initialValues,
    lastSubmittedValues = formState.lastSubmittedValues,
    submitErrors = formState.submitErrors,
    submitFailed = formState.submitFailed,
    submitSucceeded = formState.submitSucceeded,
    submitting = formState.submitting,
    values = formState.values;
  var active = field.active,
    blur = field.blur,
    change = field.change,
    data = field.data,
    focus = field.focus,
    modified = field.modified,
    modifiedSinceLastSubmit = field.modifiedSinceLastSubmit,
    name = field.name,
    touched = field.touched,
    validating = field.validating,
    visited = field.visited;
  var value = getIn(values, name);
  var error = getIn(errors, name);
  if (error && error[ARRAY_ERROR]) {
    error = error[ARRAY_ERROR];
  }
  var submitError = submitErrors && getIn(submitErrors, name);
  var initial = initialValues && getIn(initialValues, name);
  var pristine = field.isEqual(initial, value);
  var dirtySinceLastSubmit = !!(lastSubmittedValues && !field.isEqual(getIn(lastSubmittedValues, name), value));
  var valid = !error && !submitError;
  return {
    active: active,
    blur: blur,
    change: change,
    data: data,
    dirty: !pristine,
    dirtySinceLastSubmit: dirtySinceLastSubmit,
    error: error,
    focus: focus,
    initial: initial,
    invalid: !valid,
    length: Array.isArray(value) ? value.length : undefined,
    modified: modified,
    modifiedSinceLastSubmit: modifiedSinceLastSubmit,
    name: name,
    pristine: pristine,
    submitError: submitError,
    submitFailed: submitFailed,
    submitSucceeded: submitSucceeded,
    submitting: submitting,
    touched: touched,
    valid: valid,
    value: value,
    visited: visited,
    validating: validating
  };
}

//      
var fieldSubscriptionItems = ["active", "data", "dirty", "dirtySinceLastSubmit", "error", "initial", "invalid", "length", "modified", "modifiedSinceLastSubmit", "pristine", "submitError", "submitFailed", "submitSucceeded", "submitting", "touched", "valid", "value", "visited", "validating"];

//      

var shallowEqual = function shallowEqual(a, b) {
  if (a === b) {
    return true;
  }
  if (typeof a !== "object" || !a || typeof b !== "object" || !b) {
    return false;
  }
  var keysA = Object.keys(a);
  var keysB = Object.keys(b);
  if (keysA.length !== keysB.length) {
    return false;
  }
  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];
    if (!bHasOwnProperty(key) || a[key] !== b[key]) {
      return false;
    }
  }
  return true;
};

//      
function subscriptionFilter (dest, src, previous, subscription, keys, shallowEqualKeys) {
  var different = false;
  keys.forEach(function (key) {
    if (subscription[key]) {
      dest[key] = src[key];
      if (!previous || (~shallowEqualKeys.indexOf(key) ? !shallowEqual(src[key], previous[key]) : src[key] !== previous[key])) {
        different = true;
      }
    }
  });
  return different;
}

//      
var shallowEqualKeys$1 = ["data"];

/**
 * Filters items in a FieldState based on a FieldSubscription
 */
var filterFieldState = function filterFieldState(state, previousState, subscription, force) {
  var result = {
    blur: state.blur,
    change: state.change,
    focus: state.focus,
    name: state.name
  };
  var different = subscriptionFilter(result, state, previousState, subscription, fieldSubscriptionItems, shallowEqualKeys$1) || !previousState;
  return different || force ? result : undefined;
};

//      
var formSubscriptionItems = ["active", "dirty", "dirtyFields", "dirtyFieldsSinceLastSubmit", "dirtySinceLastSubmit", "error", "errors", "hasSubmitErrors", "hasValidationErrors", "initialValues", "invalid", "modified", "modifiedSinceLastSubmit", "pristine", "submitting", "submitError", "submitErrors", "submitFailed", "submitSucceeded", "touched", "valid", "validating", "values", "visited"];

//      
var shallowEqualKeys = ["touched", "visited"];

/**
 * Filters items in a FormState based on a FormSubscription
 */
function filterFormState(state, previousState, subscription, force) {
  var result = {};
  var different = subscriptionFilter(result, state, previousState, subscription, formSubscriptionItems, shallowEqualKeys) || !previousState;
  return different || force ? result : undefined;
}

//      
var memoize = function memoize(fn) {
  var lastArgs;
  var lastResult;
  return function () {
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    if (!lastArgs || args.length !== lastArgs.length || args.some(function (arg, index) {
      return !shallowEqual(lastArgs[index], arg);
    })) {
      lastArgs = args;
      lastResult = fn.apply(void 0, args);
    }
    return lastResult;
  };
};

var isPromise = (function (obj) {
  return !!obj && (typeof obj === "object" || typeof obj === "function") && typeof obj.then === "function";
});

var version = "4.20.10";

var configOptions = ["debug", "initialValues", "keepDirtyOnReinitialize", "mutators", "onSubmit", "validate", "validateOnBlur"];
var tripleEquals = function tripleEquals(a, b) {
  return a === b;
};
var hasAnyError = function hasAnyError(errors) {
  return Object.keys(errors).some(function (key) {
    var value = errors[key];
    if (value && typeof value === "object" && !(value instanceof Error)) {
      return hasAnyError(value);
    }
    return typeof value !== "undefined";
  });
};
function convertToExternalFormState(_ref) {
  var active = _ref.active,
    dirtySinceLastSubmit = _ref.dirtySinceLastSubmit,
    modifiedSinceLastSubmit = _ref.modifiedSinceLastSubmit,
    error = _ref.error,
    errors = _ref.errors,
    initialValues = _ref.initialValues,
    pristine = _ref.pristine,
    submitting = _ref.submitting,
    submitFailed = _ref.submitFailed,
    submitSucceeded = _ref.submitSucceeded,
    submitError = _ref.submitError,
    submitErrors = _ref.submitErrors,
    valid = _ref.valid,
    validating = _ref.validating,
    values = _ref.values;
  return {
    active: active,
    dirty: !pristine,
    dirtySinceLastSubmit: dirtySinceLastSubmit,
    modifiedSinceLastSubmit: modifiedSinceLastSubmit,
    error: error,
    errors: errors,
    hasSubmitErrors: !!(submitError || submitErrors && hasAnyError(submitErrors)),
    hasValidationErrors: !!(error || hasAnyError(errors)),
    invalid: !valid,
    initialValues: initialValues,
    pristine: pristine,
    submitting: submitting,
    submitFailed: submitFailed,
    submitSucceeded: submitSucceeded,
    submitError: submitError,
    submitErrors: submitErrors,
    valid: valid,
    validating: validating > 0,
    values: values
  };
}
function notifySubscriber(subscriber, subscription, state, lastState, filter, force) {
  var notification = filter(state, lastState, subscription, force);
  if (notification) {
    subscriber(notification);
    return true;
  }
  return false;
}
function notify(_ref2, state, lastState, filter, force) {
  var entries = _ref2.entries;
  Object.keys(entries).forEach(function (key) {
    var entry = entries[Number(key)];
    // istanbul ignore next
    if (entry) {
      var subscription = entry.subscription,
        subscriber = entry.subscriber,
        notified = entry.notified;
      if (notifySubscriber(subscriber, subscription, state, lastState, filter, force || !notified)) {
        entry.notified = true;
      }
    }
  });
}
function createForm(config) {
  if (!config) {
    throw new Error("No config specified");
  }
  var debug = config.debug,
    destroyOnUnregister = config.destroyOnUnregister,
    keepDirtyOnReinitialize = config.keepDirtyOnReinitialize,
    initialValues = config.initialValues,
    mutators = config.mutators,
    onSubmit = config.onSubmit,
    validate = config.validate,
    validateOnBlur = config.validateOnBlur;
  if (!onSubmit) {
    throw new Error("No onSubmit function specified");
  }
  var state = {
    subscribers: {
      index: 0,
      entries: {}
    },
    fieldSubscribers: {},
    fields: {},
    formState: {
      asyncErrors: {},
      dirtySinceLastSubmit: false,
      modifiedSinceLastSubmit: false,
      errors: {},
      initialValues: initialValues && Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, initialValues),
      invalid: false,
      pristine: true,
      submitting: false,
      submitFailed: false,
      submitSucceeded: false,
      resetWhileSubmitting: false,
      valid: true,
      validating: 0,
      values: initialValues ? Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, initialValues) : {}
    },
    lastFormState: undefined
  };
  var inBatch = 0;
  var validationPaused = false;
  var validationBlocked = false;
  var preventNotificationWhileValidationPaused = false;
  var nextAsyncValidationKey = 0;
  var asyncValidationPromises = {};
  var clearAsyncValidationPromise = function clearAsyncValidationPromise(key) {
    return function (result) {
      delete asyncValidationPromises[key];
      return result;
    };
  };
  var changeValue = function changeValue(state, name, mutate) {
    var before = getIn(state.formState.values, name);
    var after = mutate(before);
    state.formState.values = setIn(state.formState.values, name, after) || {};
  };
  var renameField = function renameField(state, from, to) {
    if (state.fields[from]) {
      var _extends2, _extends3;
      state.fields = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, state.fields, (_extends2 = {}, _extends2[to] = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, state.fields[from], {
        name: to,
        // rebind event handlers
        blur: function blur() {
          return api.blur(to);
        },
        change: function change(value) {
          return api.change(to, value);
        },
        focus: function focus() {
          return api.focus(to);
        },
        lastFieldState: undefined
      }), _extends2));
      delete state.fields[from];
      state.fieldSubscribers = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, state.fieldSubscribers, (_extends3 = {}, _extends3[to] = state.fieldSubscribers[from], _extends3));
      delete state.fieldSubscribers[from];
      var value = getIn(state.formState.values, from);
      state.formState.values = setIn(state.formState.values, from, undefined) || {};
      state.formState.values = setIn(state.formState.values, to, value);
      delete state.lastFormState;
    }
  };

  // bind state to mutators
  var getMutatorApi = function getMutatorApi(key) {
    return function () {
      // istanbul ignore next
      if (mutators) {
        // ^^ causes branch coverage warning, but needed to appease the Flow gods
        var mutatableState = {
          formState: state.formState,
          fields: state.fields,
          fieldSubscribers: state.fieldSubscribers,
          lastFormState: state.lastFormState
        };
        for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
          args[_key] = arguments[_key];
        }
        var returnValue = mutators[key](args, mutatableState, {
          changeValue: changeValue,
          getIn: getIn,
          renameField: renameField,
          resetFieldState: api.resetFieldState,
          setIn: setIn,
          shallowEqual: shallowEqual
        });
        state.formState = mutatableState.formState;
        state.fields = mutatableState.fields;
        state.fieldSubscribers = mutatableState.fieldSubscribers;
        state.lastFormState = mutatableState.lastFormState;
        runValidation(undefined, function () {
          notifyFieldListeners();
          notifyFormListeners();
        });
        return returnValue;
      }
    };
  };
  var mutatorsApi = mutators ? Object.keys(mutators).reduce(function (result, key) {
    result[key] = getMutatorApi(key);
    return result;
  }, {}) : {};
  var runRecordLevelValidation = function runRecordLevelValidation(setErrors) {
    var promises = [];
    if (validate) {
      var errorsOrPromise = validate(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, state.formState.values)); // clone to avoid writing
      if (isPromise(errorsOrPromise)) {
        promises.push(errorsOrPromise.then(function (errors) {
          return setErrors(errors, true);
        }));
      } else {
        setErrors(errorsOrPromise, false);
      }
    }
    return promises;
  };
  var getValidators = function getValidators(field) {
    return Object.keys(field.validators).reduce(function (result, index) {
      var validator = field.validators[Number(index)]();
      if (validator) {
        result.push(validator);
      }
      return result;
    }, []);
  };
  var runFieldLevelValidation = function runFieldLevelValidation(field, setError) {
    var promises = [];
    var validators = getValidators(field);
    if (validators.length) {
      var error;
      validators.forEach(function (validator) {
        var errorOrPromise = validator(getIn(state.formState.values, field.name), state.formState.values, validator.length === 0 || validator.length === 3 ? publishFieldState(state.formState, state.fields[field.name]) : undefined);
        if (errorOrPromise && isPromise(errorOrPromise)) {
          field.validating = true;
          var promise = errorOrPromise.then(function (error) {
            if (state.fields[field.name]) {
              state.fields[field.name].validating = false;
              setError(error);
            }
          }); // errors must be resolved, not rejected
          promises.push(promise);
        } else if (!error) {
          // first registered validator wins
          error = errorOrPromise;
        }
      });
      setError(error);
    }
    return promises;
  };
  var runValidation = function runValidation(fieldChanged, callback) {
    if (validationPaused) {
      validationBlocked = true;
      callback();
      return;
    }
    var fields = state.fields,
      formState = state.formState;
    var safeFields = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, fields);
    var fieldKeys = Object.keys(safeFields);
    if (!validate && !fieldKeys.some(function (key) {
      return getValidators(safeFields[key]).length;
    })) {
      callback();
      return; // no validation rules
    }

    // pare down field keys to actually validate
    var limitedFieldLevelValidation = false;
    if (fieldChanged) {
      var changedField = safeFields[fieldChanged];
      if (changedField) {
        var validateFields = changedField.validateFields;
        if (validateFields) {
          limitedFieldLevelValidation = true;
          fieldKeys = validateFields.length ? validateFields.concat(fieldChanged) : [fieldChanged];
        }
      }
    }
    var recordLevelErrors = {};
    var asyncRecordLevelErrors = {};
    var fieldLevelErrors = {};
    var promises = [].concat(runRecordLevelValidation(function (errors, wasAsync) {
      if (wasAsync) {
        asyncRecordLevelErrors = errors || {};
      } else {
        recordLevelErrors = errors || {};
      }
    }), fieldKeys.reduce(function (result, name) {
      return result.concat(runFieldLevelValidation(fields[name], function (error) {
        fieldLevelErrors[name] = error;
      }));
    }, []));
    var hasAsyncValidations = promises.length > 0;
    var asyncValidationPromiseKey = ++nextAsyncValidationKey;
    var promise = Promise.all(promises).then(clearAsyncValidationPromise(asyncValidationPromiseKey));

    // backwards-compat: add promise to submit-blocking promises iff there are any promises to await
    if (hasAsyncValidations) {
      asyncValidationPromises[asyncValidationPromiseKey] = promise;
    }
    var processErrors = function processErrors(afterAsync) {
      var merged = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, limitedFieldLevelValidation ? formState.errors : {}, recordLevelErrors, afterAsync ? asyncRecordLevelErrors // new async errors
      : formState.asyncErrors);
      var forEachError = function forEachError(fn) {
        fieldKeys.forEach(function (name) {
          if (fields[name]) {
            // make sure field is still registered
            // field-level errors take precedent over record-level errors
            var recordLevelError = getIn(recordLevelErrors, name);
            var errorFromParent = getIn(merged, name);
            var hasFieldLevelValidation = getValidators(safeFields[name]).length;
            var fieldLevelError = fieldLevelErrors[name];
            fn(name, hasFieldLevelValidation && fieldLevelError || validate && recordLevelError || (!recordLevelError && !limitedFieldLevelValidation ? errorFromParent : undefined));
          }
        });
      };
      forEachError(function (name, error) {
        merged = setIn(merged, name, error) || {};
      });
      forEachError(function (name, error) {
        if (error && error[ARRAY_ERROR]) {
          var existing = getIn(merged, name);
          var copy = [].concat(existing);
          copy[ARRAY_ERROR] = error[ARRAY_ERROR];
          merged = setIn(merged, name, copy);
        }
      });
      if (!shallowEqual(formState.errors, merged)) {
        formState.errors = merged;
      }
      if (afterAsync) {
        formState.asyncErrors = asyncRecordLevelErrors;
      }
      formState.error = recordLevelErrors[FORM_ERROR];
    };
    if (hasAsyncValidations) {
      // async validations are running, ensure validating is true before notifying
      state.formState.validating++;
      callback();
    }

    // process sync errors
    processErrors(false);
    // sync errors have been set. notify listeners while we wait for others
    callback();
    if (hasAsyncValidations) {
      var afterPromise = function afterPromise() {
        state.formState.validating--;
        callback();
        // field async validation may affect formState validating
        // so force notifyFormListeners if validating is still 0 after callback finished
        // and lastFormState validating is true
        if (state.formState.validating === 0 && state.lastFormState.validating) {
          notifyFormListeners();
        }
      };
      promise.then(function () {
        if (nextAsyncValidationKey > asyncValidationPromiseKey) {
          // if this async validator has been superseded by another, ignore its results
          return;
        }
        processErrors(true);
      }).then(afterPromise, afterPromise);
    }
  };
  var notifyFieldListeners = function notifyFieldListeners(name) {
    if (inBatch) {
      return;
    }
    var fields = state.fields,
      fieldSubscribers = state.fieldSubscribers,
      formState = state.formState;
    var safeFields = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, fields);
    var notifyField = function notifyField(name) {
      var field = safeFields[name];
      var fieldState = publishFieldState(formState, field);
      var lastFieldState = field.lastFieldState;
      field.lastFieldState = fieldState;
      var fieldSubscriber = fieldSubscribers[name];
      if (fieldSubscriber) {
        notify(fieldSubscriber, fieldState, lastFieldState, filterFieldState, lastFieldState === undefined);
      }
    };
    if (name) {
      notifyField(name);
    } else {
      Object.keys(safeFields).forEach(notifyField);
    }
  };
  var markAllFieldsTouched = function markAllFieldsTouched() {
    Object.keys(state.fields).forEach(function (key) {
      state.fields[key].touched = true;
    });
  };
  var hasSyncErrors = function hasSyncErrors() {
    return !!(state.formState.error || hasAnyError(state.formState.errors));
  };
  var calculateNextFormState = function calculateNextFormState() {
    var fields = state.fields,
      formState = state.formState,
      lastFormState = state.lastFormState;
    var safeFields = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, fields);
    var safeFieldKeys = Object.keys(safeFields);

    // calculate dirty/pristine
    var foundDirty = false;
    var dirtyFields = safeFieldKeys.reduce(function (result, key) {
      var dirty = !safeFields[key].isEqual(getIn(formState.values, key), getIn(formState.initialValues || {}, key));
      if (dirty) {
        foundDirty = true;
        result[key] = true;
      }
      return result;
    }, {});
    var dirtyFieldsSinceLastSubmit = safeFieldKeys.reduce(function (result, key) {
      // istanbul ignore next
      var nonNullLastSubmittedValues = formState.lastSubmittedValues || {}; // || {} is for flow, but causes branch coverage complaint
      if (!safeFields[key].isEqual(getIn(formState.values, key), getIn(nonNullLastSubmittedValues, key))) {
        result[key] = true;
      }
      return result;
    }, {});
    formState.pristine = !foundDirty;
    formState.dirtySinceLastSubmit = !!(formState.lastSubmittedValues && Object.values(dirtyFieldsSinceLastSubmit).some(function (value) {
      return value;
    }));
    formState.modifiedSinceLastSubmit = !!(formState.lastSubmittedValues &&
    // Object.values would treat values as mixed (facebook/flow#2221)
    Object.keys(safeFields).some(function (value) {
      return safeFields[value].modifiedSinceLastSubmit;
    }));
    formState.valid = !formState.error && !formState.submitError && !hasAnyError(formState.errors) && !(formState.submitErrors && hasAnyError(formState.submitErrors));
    var nextFormState = convertToExternalFormState(formState);
    var _safeFieldKeys$reduce = safeFieldKeys.reduce(function (result, key) {
        result.modified[key] = safeFields[key].modified;
        result.touched[key] = safeFields[key].touched;
        result.visited[key] = safeFields[key].visited;
        return result;
      }, {
        modified: {},
        touched: {},
        visited: {}
      }),
      modified = _safeFieldKeys$reduce.modified,
      touched = _safeFieldKeys$reduce.touched,
      visited = _safeFieldKeys$reduce.visited;
    nextFormState.dirtyFields = lastFormState && shallowEqual(lastFormState.dirtyFields, dirtyFields) ? lastFormState.dirtyFields : dirtyFields;
    nextFormState.dirtyFieldsSinceLastSubmit = lastFormState && shallowEqual(lastFormState.dirtyFieldsSinceLastSubmit, dirtyFieldsSinceLastSubmit) ? lastFormState.dirtyFieldsSinceLastSubmit : dirtyFieldsSinceLastSubmit;
    nextFormState.modified = lastFormState && shallowEqual(lastFormState.modified, modified) ? lastFormState.modified : modified;
    nextFormState.touched = lastFormState && shallowEqual(lastFormState.touched, touched) ? lastFormState.touched : touched;
    nextFormState.visited = lastFormState && shallowEqual(lastFormState.visited, visited) ? lastFormState.visited : visited;
    return lastFormState && shallowEqual(lastFormState, nextFormState) ? lastFormState : nextFormState;
  };
  var callDebug = function callDebug() {
    return debug && "development" !== "production" && debug(calculateNextFormState(), Object.keys(state.fields).reduce(function (result, key) {
      result[key] = state.fields[key];
      return result;
    }, {}));
  };
  var notifying = false;
  var scheduleNotification = false;
  var notifyFormListeners = function notifyFormListeners() {
    if (notifying) {
      scheduleNotification = true;
    } else {
      notifying = true;
      callDebug();
      if (!inBatch && !(validationPaused && preventNotificationWhileValidationPaused)) {
        var lastFormState = state.lastFormState;
        var nextFormState = calculateNextFormState();
        if (nextFormState !== lastFormState) {
          state.lastFormState = nextFormState;
          notify(state.subscribers, nextFormState, lastFormState, filterFormState);
        }
      }
      notifying = false;
      if (scheduleNotification) {
        scheduleNotification = false;
        notifyFormListeners();
      }
    }
  };
  var beforeSubmit = function beforeSubmit() {
    return Object.keys(state.fields).some(function (name) {
      return state.fields[name].beforeSubmit && state.fields[name].beforeSubmit() === false;
    });
  };
  var afterSubmit = function afterSubmit() {
    return Object.keys(state.fields).forEach(function (name) {
      return state.fields[name].afterSubmit && state.fields[name].afterSubmit();
    });
  };
  var resetModifiedAfterSubmit = function resetModifiedAfterSubmit() {
    return Object.keys(state.fields).forEach(function (key) {
      return state.fields[key].modifiedSinceLastSubmit = false;
    });
  };

  // generate initial errors
  runValidation(undefined, function () {
    notifyFormListeners();
  });
  var api = {
    batch: function batch(fn) {
      inBatch++;
      fn();
      inBatch--;
      notifyFieldListeners();
      notifyFormListeners();
    },
    blur: function blur(name) {
      var fields = state.fields,
        formState = state.formState;
      var previous = fields[name];
      if (previous) {
        // can only blur registered fields
        delete formState.active;
        fields[name] = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, previous, {
          active: false,
          touched: true
        });
        if (validateOnBlur) {
          runValidation(name, function () {
            notifyFieldListeners();
            notifyFormListeners();
          });
        } else {
          notifyFieldListeners();
          notifyFormListeners();
        }
      }
    },
    change: function change(name, value) {
      var fields = state.fields,
        formState = state.formState;
      if (getIn(formState.values, name) !== value) {
        changeValue(state, name, function () {
          return value;
        });
        var previous = fields[name];
        if (previous) {
          // only track modified for registered fields
          fields[name] = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, previous, {
            modified: true,
            modifiedSinceLastSubmit: !!formState.lastSubmittedValues
          });
        }
        if (validateOnBlur) {
          notifyFieldListeners();
          notifyFormListeners();
        } else {
          runValidation(name, function () {
            notifyFieldListeners();
            notifyFormListeners();
          });
        }
      }
    },
    get destroyOnUnregister() {
      return !!destroyOnUnregister;
    },
    set destroyOnUnregister(value) {
      destroyOnUnregister = value;
    },
    focus: function focus(name) {
      var field = state.fields[name];
      if (field && !field.active) {
        state.formState.active = name;
        field.active = true;
        field.visited = true;
        notifyFieldListeners();
        notifyFormListeners();
      }
    },
    mutators: mutatorsApi,
    getFieldState: function getFieldState(name) {
      var field = state.fields[name];
      return field && field.lastFieldState;
    },
    getRegisteredFields: function getRegisteredFields() {
      return Object.keys(state.fields);
    },
    getState: function getState() {
      return calculateNextFormState();
    },
    initialize: function initialize(data) {
      var fields = state.fields,
        formState = state.formState;
      var safeFields = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, fields);
      var values = typeof data === "function" ? data(formState.values) : data;
      if (!keepDirtyOnReinitialize) {
        formState.values = values;
      }
      /**
       * Hello, inquisitive code reader! Thanks for taking the time to dig in!
       *
       * The following code is the way it is to allow for non-registered deep
       * field values to be set via initialize()
       */

      // save dirty values
      var savedDirtyValues = keepDirtyOnReinitialize ? Object.keys(safeFields).reduce(function (result, key) {
        var field = safeFields[key];
        var pristine = field.isEqual(getIn(formState.values, key), getIn(formState.initialValues || {}, key));
        if (!pristine) {
          result[key] = getIn(formState.values, key);
        }
        return result;
      }, {}) : {};
      // update initalValues and values
      formState.initialValues = values;
      formState.values = values;
      // restore the dirty values
      Object.keys(savedDirtyValues).forEach(function (key) {
        formState.values = setIn(formState.values, key, savedDirtyValues[key]) || {};
      });
      runValidation(undefined, function () {
        notifyFieldListeners();
        notifyFormListeners();
      });
    },
    isValidationPaused: function isValidationPaused() {
      return validationPaused;
    },
    pauseValidation: function pauseValidation(preventNotification) {
      if (preventNotification === void 0) {
        preventNotification = true;
      }
      validationPaused = true;
      preventNotificationWhileValidationPaused = preventNotification;
    },
    registerField: function registerField(name, subscriber, subscription, fieldConfig) {
      if (subscription === void 0) {
        subscription = {};
      }
      if (!state.fieldSubscribers[name]) {
        state.fieldSubscribers[name] = {
          index: 0,
          entries: {}
        };
      }
      var index = state.fieldSubscribers[name].index++;

      // save field subscriber callback
      state.fieldSubscribers[name].entries[index] = {
        subscriber: memoize(subscriber),
        subscription: subscription,
        notified: false
      };

      // create initial field state if not exists
      var field = state.fields[name] || {
        active: false,
        afterSubmit: fieldConfig && fieldConfig.afterSubmit,
        beforeSubmit: fieldConfig && fieldConfig.beforeSubmit,
        data: fieldConfig && fieldConfig.data || {},
        isEqual: fieldConfig && fieldConfig.isEqual || tripleEquals,
        lastFieldState: undefined,
        modified: false,
        modifiedSinceLastSubmit: false,
        name: name,
        touched: false,
        valid: true,
        validateFields: fieldConfig && fieldConfig.validateFields,
        validators: {},
        validating: false,
        visited: false
      };
      // Mutators can create a field in order to keep the field states
      // We must update this field when registerField is called afterwards
      field.blur = field.blur || function () {
        return api.blur(name);
      };
      field.change = field.change || function (value) {
        return api.change(name, value);
      };
      field.focus = field.focus || function () {
        return api.focus(name);
      };
      state.fields[name] = field;
      var haveValidator = false;
      var silent = fieldConfig && fieldConfig.silent;
      var notify = function notify() {
        if (silent && state.fields[name]) {
          notifyFieldListeners(name);
        } else {
          notifyFormListeners();
          notifyFieldListeners();
        }
      };
      if (fieldConfig) {
        haveValidator = !!(fieldConfig.getValidator && fieldConfig.getValidator());
        if (fieldConfig.getValidator) {
          state.fields[name].validators[index] = fieldConfig.getValidator;
        }
        var noValueInFormState = getIn(state.formState.values, name) === undefined;
        if (fieldConfig.initialValue !== undefined && (noValueInFormState || getIn(state.formState.values, name) === getIn(state.formState.initialValues, name))
        // only initialize if we don't yet have any value for this field
        ) {
          state.formState.initialValues = setIn(state.formState.initialValues || {}, name, fieldConfig.initialValue);
          state.formState.values = setIn(state.formState.values, name, fieldConfig.initialValue);
          runValidation(undefined, notify);
        }

        // only use defaultValue if we don't yet have any value for this field
        if (fieldConfig.defaultValue !== undefined && fieldConfig.initialValue === undefined && getIn(state.formState.initialValues, name) === undefined && noValueInFormState) {
          state.formState.values = setIn(state.formState.values, name, fieldConfig.defaultValue);
        }
      }
      if (haveValidator) {
        runValidation(undefined, notify);
      } else {
        notify();
      }
      return function () {
        var validatorRemoved = false;
        // istanbul ignore next
        if (state.fields[name]) {
          // state.fields[name] may have been removed by a mutator
          validatorRemoved = !!(state.fields[name].validators[index] && state.fields[name].validators[index]());
          delete state.fields[name].validators[index];
        }
        var hasFieldSubscribers = !!state.fieldSubscribers[name];
        if (hasFieldSubscribers) {
          // state.fieldSubscribers[name] may have been removed by a mutator
          delete state.fieldSubscribers[name].entries[index];
        }
        var lastOne = hasFieldSubscribers && !Object.keys(state.fieldSubscribers[name].entries).length;
        if (lastOne) {
          delete state.fieldSubscribers[name];
          delete state.fields[name];
          if (validatorRemoved) {
            state.formState.errors = setIn(state.formState.errors, name, undefined) || {};
          }
          if (destroyOnUnregister) {
            state.formState.values = setIn(state.formState.values, name, undefined, true) || {};
          }
        }
        if (!silent) {
          if (validatorRemoved) {
            runValidation(undefined, function () {
              notifyFormListeners();
              notifyFieldListeners();
            });
          } else if (lastOne) {
            // values or errors may have changed
            notifyFormListeners();
          }
        }
      };
    },
    reset: function reset(initialValues) {
      if (initialValues === void 0) {
        initialValues = state.formState.initialValues;
      }
      if (state.formState.submitting) {
        state.formState.resetWhileSubmitting = true;
      }
      state.formState.submitFailed = false;
      state.formState.submitSucceeded = false;
      delete state.formState.submitError;
      delete state.formState.submitErrors;
      delete state.formState.lastSubmittedValues;
      api.initialize(initialValues || {});
    },
    /**
     * Resets all field flags (e.g. touched, visited, etc.) to their initial state
     */
    resetFieldState: function resetFieldState(name) {
      state.fields[name] = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, state.fields[name], {
        active: false,
        lastFieldState: undefined,
        modified: false,
        touched: false,
        valid: true,
        validating: false,
        visited: false
      });
      runValidation(undefined, function () {
        notifyFieldListeners();
        notifyFormListeners();
      });
    },
    /**
     * Returns the form to a clean slate; that is:
     * - Clear all values
     * - Resets all fields to their initial state
     */
    restart: function restart(initialValues) {
      if (initialValues === void 0) {
        initialValues = state.formState.initialValues;
      }
      api.batch(function () {
        for (var name in state.fields) {
          api.resetFieldState(name);
          state.fields[name] = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, state.fields[name], {
            active: false,
            lastFieldState: undefined,
            modified: false,
            modifiedSinceLastSubmit: false,
            touched: false,
            valid: true,
            validating: false,
            visited: false
          });
        }
        api.reset(initialValues);
      });
    },
    resumeValidation: function resumeValidation() {
      validationPaused = false;
      preventNotificationWhileValidationPaused = false;
      if (validationBlocked) {
        // validation was attempted while it was paused, so run it now
        runValidation(undefined, function () {
          notifyFieldListeners();
          notifyFormListeners();
        });
      }
      validationBlocked = false;
    },
    setConfig: function setConfig(name, value) {
      switch (name) {
        case "debug":
          debug = value;
          break;
        case "destroyOnUnregister":
          destroyOnUnregister = value;
          break;
        case "initialValues":
          api.initialize(value);
          break;
        case "keepDirtyOnReinitialize":
          keepDirtyOnReinitialize = value;
          break;
        case "mutators":
          mutators = value;
          if (value) {
            Object.keys(mutatorsApi).forEach(function (key) {
              if (!(key in value)) {
                delete mutatorsApi[key];
              }
            });
            Object.keys(value).forEach(function (key) {
              mutatorsApi[key] = getMutatorApi(key);
            });
          } else {
            Object.keys(mutatorsApi).forEach(function (key) {
              delete mutatorsApi[key];
            });
          }
          break;
        case "onSubmit":
          onSubmit = value;
          break;
        case "validate":
          validate = value;
          runValidation(undefined, function () {
            notifyFieldListeners();
            notifyFormListeners();
          });
          break;
        case "validateOnBlur":
          validateOnBlur = value;
          break;
        default:
          throw new Error("Unrecognised option " + name);
      }
    },
    submit: function submit() {
      var formState = state.formState;
      if (formState.submitting) {
        return;
      }
      delete formState.submitErrors;
      delete formState.submitError;
      formState.lastSubmittedValues = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, formState.values);
      if (hasSyncErrors()) {
        markAllFieldsTouched();
        resetModifiedAfterSubmit();
        state.formState.submitFailed = true;
        notifyFormListeners();
        notifyFieldListeners();
        return; // no submit for you!!
      }

      var asyncValidationPromisesKeys = Object.keys(asyncValidationPromises);
      if (asyncValidationPromisesKeys.length) {
        // still waiting on async validation to complete...
        Promise.all(asyncValidationPromisesKeys.map(function (key) {
          return asyncValidationPromises[Number(key)];
        })).then(api.submit, console.error);
        return;
      }
      var submitIsBlocked = beforeSubmit();
      if (submitIsBlocked) {
        return;
      }
      var resolvePromise;
      var completeCalled = false;
      var complete = function complete(errors) {
        formState.submitting = false;
        var resetWhileSubmitting = formState.resetWhileSubmitting;
        if (resetWhileSubmitting) {
          formState.resetWhileSubmitting = false;
        }
        if (errors && hasAnyError(errors)) {
          formState.submitFailed = true;
          formState.submitSucceeded = false;
          formState.submitErrors = errors;
          formState.submitError = errors[FORM_ERROR];
          markAllFieldsTouched();
        } else {
          if (!resetWhileSubmitting) {
            formState.submitFailed = false;
            formState.submitSucceeded = true;
          }
          afterSubmit();
        }
        notifyFormListeners();
        notifyFieldListeners();
        completeCalled = true;
        if (resolvePromise) {
          resolvePromise(errors);
        }
        return errors;
      };
      formState.submitting = true;
      formState.submitFailed = false;
      formState.submitSucceeded = false;
      formState.lastSubmittedValues = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, formState.values);
      resetModifiedAfterSubmit();

      // onSubmit is either sync, callback or async with a Promise
      var result = onSubmit(formState.values, api, complete);
      if (!completeCalled) {
        if (result && isPromise(result)) {
          // onSubmit is async with a Promise
          notifyFormListeners(); // let everyone know we are submitting
          notifyFieldListeners(); // notify fields also
          return result.then(complete, function (error) {
            complete();
            throw error;
          });
        } else if (onSubmit.length >= 3) {
          // must be async, so we should return a Promise
          notifyFormListeners(); // let everyone know we are submitting
          notifyFieldListeners(); // notify fields also
          return new Promise(function (resolve) {
            resolvePromise = resolve;
          });
        } else {
          // onSubmit is sync
          complete(result);
        }
      }
    },
    subscribe: function subscribe(subscriber, subscription) {
      if (!subscriber) {
        throw new Error("No callback given.");
      }
      if (!subscription) {
        throw new Error("No subscription provided. What values do you want to listen to?");
      }
      var memoized = memoize(subscriber);
      var subscribers = state.subscribers;
      var index = subscribers.index++;
      subscribers.entries[index] = {
        subscriber: memoized,
        subscription: subscription,
        notified: false
      };
      var nextFormState = calculateNextFormState();
      notifySubscriber(memoized, subscription, nextFormState, nextFormState, filterFormState, true);
      return function () {
        delete subscribers.entries[index];
      };
    }
  };
  return api;
}




/***/ }),
/* 370 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(139),
    _assign = __webpack_require__(47);

var ReactNoopUpdateQueue = __webpack_require__(371);

var canDefineProperty = __webpack_require__(373);
var emptyObject = __webpack_require__(1050);
var invariant = __webpack_require__(140);
var lowPriorityWarning = __webpack_require__(1051);

/**
 * Base class helpers for the updating state of a component.
 */
function ReactComponent(props, context, updater) {
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

ReactComponent.prototype.isReactComponent = {};

/**
 * Sets a subset of the state. Always use this to mutate
 * state. You should treat `this.state` as immutable.
 *
 * There is no guarantee that `this.state` will be immediately updated, so
 * accessing `this.state` after calling this method may return the old value.
 *
 * There is no guarantee that calls to `setState` will run synchronously,
 * as they may eventually be batched together.  You can provide an optional
 * callback that will be executed when the call to setState is actually
 * completed.
 *
 * When a function is provided to setState, it will be called at some point in
 * the future (not synchronously). It will be called with the up to date
 * component arguments (state, props, context). These values can be different
 * from this.* because your function may be called after receiveProps but before
 * shouldComponentUpdate, and this new state, props, and context will not yet be
 * assigned to this.
 *
 * @param {object|function} partialState Next partial state or function to
 *        produce next partial state to be merged with current state.
 * @param {?function} callback Called after state is updated.
 * @final
 * @protected
 */
ReactComponent.prototype.setState = function (partialState, callback) {
  !(typeof partialState === 'object' || typeof partialState === 'function' || partialState == null) ?  false ? invariant(false, 'setState(...): takes an object of state variables to update or a function which returns an object of state variables.') : _prodInvariant('85') : void 0;
  this.updater.enqueueSetState(this, partialState);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'setState');
  }
};

/**
 * Forces an update. This should only be invoked when it is known with
 * certainty that we are **not** in a DOM transaction.
 *
 * You may want to call this when you know that some deeper aspect of the
 * component's state has changed but `setState` was not called.
 *
 * This will not invoke `shouldComponentUpdate`, but it will invoke
 * `componentWillUpdate` and `componentDidUpdate`.
 *
 * @param {?function} callback Called after update is complete.
 * @final
 * @protected
 */
ReactComponent.prototype.forceUpdate = function (callback) {
  this.updater.enqueueForceUpdate(this);
  if (callback) {
    this.updater.enqueueCallback(this, callback, 'forceUpdate');
  }
};

/**
 * Deprecated APIs. These APIs used to exist on classic React classes but since
 * we would like to deprecate them, we're not going to move them over to this
 * modern base class. Instead, we define a getter that warns if it's accessed.
 */
if (false) {
  var deprecatedAPIs = {
    isMounted: ['isMounted', 'Instead, make sure to clean up subscriptions and pending requests in ' + 'componentWillUnmount to prevent memory leaks.'],
    replaceState: ['replaceState', 'Refactor your code to use setState instead (see ' + 'https://github.com/facebook/react/issues/3236).']
  };
  var defineDeprecationWarning = function (methodName, info) {
    if (canDefineProperty) {
      Object.defineProperty(ReactComponent.prototype, methodName, {
        get: function () {
          lowPriorityWarning(false, '%s(...) is deprecated in plain JavaScript React classes. %s', info[0], info[1]);
          return undefined;
        }
      });
    }
  };
  for (var fnName in deprecatedAPIs) {
    if (deprecatedAPIs.hasOwnProperty(fnName)) {
      defineDeprecationWarning(fnName, deprecatedAPIs[fnName]);
    }
  }
}

/**
 * Base class helpers for the updating state of a component.
 */
function ReactPureComponent(props, context, updater) {
  // Duplicated from ReactComponent.
  this.props = props;
  this.context = context;
  this.refs = emptyObject;
  // We initialize the default updater but the real one gets injected by the
  // renderer.
  this.updater = updater || ReactNoopUpdateQueue;
}

function ComponentDummy() {}
ComponentDummy.prototype = ReactComponent.prototype;
ReactPureComponent.prototype = new ComponentDummy();
ReactPureComponent.prototype.constructor = ReactPureComponent;
// Avoid an extra prototype jump for these methods.
_assign(ReactPureComponent.prototype, ReactComponent.prototype);
ReactPureComponent.prototype.isPureReactComponent = true;

module.exports = {
  Component: ReactComponent,
  PureComponent: ReactPureComponent
};

/***/ }),
/* 371 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var warning = __webpack_require__(211);

function warnNoop(publicInstance, callerName) {
  if (false) {
    var constructor = publicInstance.constructor;
    process.env.NODE_ENV !== 'production' ? warning(false, '%s(...): Can only update a mounted or mounting component. ' + 'This usually means you called %s() on an unmounted component. ' + 'This is a no-op. Please check the code for the %s component.', callerName, callerName, constructor && (constructor.displayName || constructor.name) || 'ReactClass') : void 0;
  }
}

/**
 * This is the abstract API for an update queue.
 */
var ReactNoopUpdateQueue = {
  /**
   * Checks whether or not this composite component is mounted.
   * @param {ReactClass} publicInstance The instance we want to test.
   * @return {boolean} True if mounted, false otherwise.
   * @protected
   * @final
   */
  isMounted: function (publicInstance) {
    return false;
  },

  /**
   * Enqueue a callback that will be executed after all the pending updates
   * have processed.
   *
   * @param {ReactClass} publicInstance The instance to use as `this` context.
   * @param {?function} callback Called after state is updated.
   * @internal
   */
  enqueueCallback: function (publicInstance, callback) {},

  /**
   * Forces an update. This should only be invoked when it is known with
   * certainty that we are **not** in a DOM transaction.
   *
   * You may want to call this when you know that some deeper aspect of the
   * component's state has changed but `setState` was not called.
   *
   * This will not invoke `shouldComponentUpdate`, but it will invoke
   * `componentWillUpdate` and `componentDidUpdate`.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @internal
   */
  enqueueForceUpdate: function (publicInstance) {
    warnNoop(publicInstance, 'forceUpdate');
  },

  /**
   * Replaces all of the state. Always use this or `setState` to mutate state.
   * You should treat `this.state` as immutable.
   *
   * There is no guarantee that `this.state` will be immediately updated, so
   * accessing `this.state` after calling this method may return the old value.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} completeState Next state.
   * @internal
   */
  enqueueReplaceState: function (publicInstance, completeState) {
    warnNoop(publicInstance, 'replaceState');
  },

  /**
   * Sets a subset of the state. This only exists because _pendingState is
   * internal. This provides a merging strategy that is not available to deep
   * properties which is confusing. TODO: Expose pendingState or don't use it
   * during the merge.
   *
   * @param {ReactClass} publicInstance The instance that should rerender.
   * @param {object} partialState Next partial state to be merged with state.
   * @internal
   */
  enqueueSetState: function (publicInstance, partialState) {
    warnNoop(publicInstance, 'setState');
  }
};

module.exports = ReactNoopUpdateQueue;

/***/ }),
/* 372 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 373 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var canDefineProperty = false;
if (false) {
  try {
    // $FlowFixMe https://github.com/facebook/flow/issues/285
    Object.defineProperty({}, 'x', { get: function () {} });
    canDefineProperty = true;
  } catch (x) {
    // IE will fail on defineProperty
  }
}

module.exports = canDefineProperty;

/***/ }),
/* 374 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Keeps track of the current owner.
 *
 * The current owner is the component who should own any components that are
 * currently being constructed.
 */
var ReactCurrentOwner = {
  /**
   * @internal
   * @type {ReactComponent}
   */
  current: null
};

module.exports = ReactCurrentOwner;

/***/ }),
/* 375 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



// The Symbol used to tag the ReactElement type. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.

var REACT_ELEMENT_TYPE = typeof Symbol === 'function' && Symbol['for'] && Symbol['for']('react.element') || 0xeac7;

module.exports = REACT_ELEMENT_TYPE;

/***/ }),
/* 376 */
/***/ (function(module, exports, __webpack_require__) {

// the whatwg-fetch polyfill installs the fetch() function
// on the global object (window or self)
//
// Return that as the export for use in Webpack, Browserify etc.
__webpack_require__(1068);
module.exports = self.fetch.bind(self);


/***/ }),
/* 377 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(378);
module.exports = __webpack_require__(383);


/***/ }),
/* 378 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
// @remove-on-eject-begin
/**
 * Copyright (c) 2015-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// @remove-on-eject-end


if (typeof Promise === 'undefined') {
  // Rejection tracking prevents a common issue where React gets into an
  // inconsistent state due to an error, but it gets swallowed by a Promise,
  // and the user has no idea what causes React's erratic future behavior.
  __webpack_require__(379).enable();
  window.Promise = __webpack_require__(381);
}

// fetch() polyfill for making API calls.
__webpack_require__(382);

// Object.assign() is commonly used with React.
// It will use the native implementation if it's present and isn't buggy.
Object.assign = __webpack_require__(47);

// In tests, polyfill requestAnimationFrame since jsdom doesn't provide it yet.
// We don't polyfill it in the browser--this is user's responsibility.
if (false) {
  require('raf').polyfill(global);
}


/***/ }),
/* 379 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var Promise = __webpack_require__(212);

var DEFAULT_WHITELIST = [
  ReferenceError,
  TypeError,
  RangeError
];

var enabled = false;
exports.disable = disable;
function disable() {
  enabled = false;
  Promise._47 = null;
  Promise._71 = null;
}

exports.enable = enable;
function enable(options) {
  options = options || {};
  if (enabled) disable();
  enabled = true;
  var id = 0;
  var displayId = 0;
  var rejections = {};
  Promise._47 = function (promise) {
    if (
      promise._83 === 2 && // IS REJECTED
      rejections[promise._56]
    ) {
      if (rejections[promise._56].logged) {
        onHandled(promise._56);
      } else {
        clearTimeout(rejections[promise._56].timeout);
      }
      delete rejections[promise._56];
    }
  };
  Promise._71 = function (promise, err) {
    if (promise._75 === 0) { // not yet handled
      promise._56 = id++;
      rejections[promise._56] = {
        displayId: null,
        error: err,
        timeout: setTimeout(
          onUnhandled.bind(null, promise._56),
          // For reference errors and type errors, this almost always
          // means the programmer made a mistake, so log them after just
          // 100ms
          // otherwise, wait 2 seconds to see if they get handled
          matchWhitelist(err, DEFAULT_WHITELIST)
            ? 100
            : 2000
        ),
        logged: false
      };
    }
  };
  function onUnhandled(id) {
    if (
      options.allRejections ||
      matchWhitelist(
        rejections[id].error,
        options.whitelist || DEFAULT_WHITELIST
      )
    ) {
      rejections[id].displayId = displayId++;
      if (options.onUnhandled) {
        rejections[id].logged = true;
        options.onUnhandled(
          rejections[id].displayId,
          rejections[id].error
        );
      } else {
        rejections[id].logged = true;
        logError(
          rejections[id].displayId,
          rejections[id].error
        );
      }
    }
  }
  function onHandled(id) {
    if (rejections[id].logged) {
      if (options.onHandled) {
        options.onHandled(rejections[id].displayId, rejections[id].error);
      } else if (!rejections[id].onUnhandled) {
        console.warn(
          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
        );
        console.warn(
          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
          rejections[id].displayId + '.'
        );
      }
    }
  }
}

function logError(id, error) {
  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
  var errStr = (error && (error.stack || error)) + '';
  errStr.split('\n').forEach(function (line) {
    console.warn('  ' + line);
  });
}

function matchWhitelist(error, list) {
  return list.some(function (cls) {
    return error instanceof cls;
  });
}

/***/ }),
/* 380 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {

// Use the fastest means possible to execute a task in its own turn, with
// priority over other events including IO, animation, reflow, and redraw
// events in browsers.
//
// An exception thrown by a task will permanently interrupt the processing of
// subsequent tasks. The higher level `asap` function ensures that if an
// exception is thrown by a task, that the task queue will continue flushing as
// soon as possible, but if you use `rawAsap` directly, you are responsible to
// either ensure that no exceptions are thrown from your task, or to manually
// call `rawAsap.requestFlush` if an exception is thrown.
module.exports = rawAsap;
function rawAsap(task) {
    if (!queue.length) {
        requestFlush();
        flushing = true;
    }
    // Equivalent to push, but avoids a function call.
    queue[queue.length] = task;
}

var queue = [];
// Once a flush has been requested, no further calls to `requestFlush` are
// necessary until the next `flush` completes.
var flushing = false;
// `requestFlush` is an implementation-specific method that attempts to kick
// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
// the event queue before yielding to the browser's own event loop.
var requestFlush;
// The position of the next task to execute in the task queue. This is
// preserved between calls to `flush` so that it can be resumed if
// a task throws an exception.
var index = 0;
// If a task schedules additional tasks recursively, the task queue can grow
// unbounded. To prevent memory exhaustion, the task queue will periodically
// truncate already-completed tasks.
var capacity = 1024;

// The flush function processes all tasks that have been scheduled with
// `rawAsap` unless and until one of those tasks throws an exception.
// If a task throws an exception, `flush` ensures that its state will remain
// consistent and will resume where it left off when called again.
// However, `flush` does not make any arrangements to be called again if an
// exception is thrown.
function flush() {
    while (index < queue.length) {
        var currentIndex = index;
        // Advance the index before calling the task. This ensures that we will
        // begin flushing on the next task the task throws an error.
        index = index + 1;
        queue[currentIndex].call();
        // Prevent leaking memory for long chains of recursive calls to `asap`.
        // If we call `asap` within tasks scheduled by `asap`, the queue will
        // grow, but to avoid an O(n) walk for every task we execute, we don't
        // shift tasks off the queue after they have been executed.
        // Instead, we periodically shift 1024 tasks off the queue.
        if (index > capacity) {
            // Manually shift all values starting at the index back to the
            // beginning of the queue.
            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
                queue[scan] = queue[scan + index];
            }
            queue.length -= index;
            index = 0;
        }
    }
    queue.length = 0;
    index = 0;
    flushing = false;
}

// `requestFlush` is implemented using a strategy based on data collected from
// every available SauceLabs Selenium web driver worker at time of writing.
// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593

// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
// have WebKitMutationObserver but not un-prefixed MutationObserver.
// Must use `global` or `self` instead of `window` to work in both frames and web
// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.

/* globals self */
var scope = typeof global !== "undefined" ? global : self;
var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;

// MutationObservers are desirable because they have high priority and work
// reliably everywhere they are implemented.
// They are implemented in all modern browsers.
//
// - Android 4-4.3
// - Chrome 26-34
// - Firefox 14-29
// - Internet Explorer 11
// - iPad Safari 6-7.1
// - iPhone Safari 7-7.1
// - Safari 6-7
if (typeof BrowserMutationObserver === "function") {
    requestFlush = makeRequestCallFromMutationObserver(flush);

// MessageChannels are desirable because they give direct access to the HTML
// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
// 11-12, and in web workers in many engines.
// Although message channels yield to any queued rendering and IO tasks, they
// would be better than imposing the 4ms delay of timers.
// However, they do not work reliably in Internet Explorer or Safari.

// Internet Explorer 10 is the only browser that has setImmediate but does
// not have MutationObservers.
// Although setImmediate yields to the browser's renderer, it would be
// preferrable to falling back to setTimeout since it does not have
// the minimum 4ms penalty.
// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
// Desktop to a lesser extent) that renders both setImmediate and
// MessageChannel useless for the purposes of ASAP.
// https://github.com/kriskowal/q/issues/396

// Timers are implemented universally.
// We fall back to timers in workers in most engines, and in foreground
// contexts in the following browsers.
// However, note that even this simple case requires nuances to operate in a
// broad spectrum of browsers.
//
// - Firefox 3-13
// - Internet Explorer 6-9
// - iPad Safari 4.3
// - Lynx 2.8.7
} else {
    requestFlush = makeRequestCallFromTimer(flush);
}

// `requestFlush` requests that the high priority event queue be flushed as
// soon as possible.
// This is useful to prevent an error thrown in a task from stalling the event
// queue if the exception handled by Node.js’s
// `process.on("uncaughtException")` or by a domain.
rawAsap.requestFlush = requestFlush;

// To request a high priority event, we induce a mutation observer by toggling
// the text of a text node between "1" and "-1".
function makeRequestCallFromMutationObserver(callback) {
    var toggle = 1;
    var observer = new BrowserMutationObserver(callback);
    var node = document.createTextNode("");
    observer.observe(node, {characterData: true});
    return function requestCall() {
        toggle = -toggle;
        node.data = toggle;
    };
}

// The message channel technique was discovered by Malte Ubl and was the
// original foundation for this library.
// http://www.nonblocking.io/2011/06/windownexttick.html

// Safari 6.0.5 (at least) intermittently fails to create message ports on a
// page's first load. Thankfully, this version of Safari supports
// MutationObservers, so we don't need to fall back in that case.

// function makeRequestCallFromMessageChannel(callback) {
//     var channel = new MessageChannel();
//     channel.port1.onmessage = callback;
//     return function requestCall() {
//         channel.port2.postMessage(0);
//     };
// }

// For reasons explained above, we are also unable to use `setImmediate`
// under any circumstances.
// Even if we were, there is another bug in Internet Explorer 10.
// It is not sufficient to assign `setImmediate` to `requestFlush` because
// `setImmediate` must be called *by name* and therefore must be wrapped in a
// closure.
// Never forget.

// function makeRequestCallFromSetImmediate(callback) {
//     return function requestCall() {
//         setImmediate(callback);
//     };
// }

// Safari 6.0 has a problem where timers will get lost while the user is
// scrolling. This problem does not impact ASAP because Safari 6.0 supports
// mutation observers, so that implementation is used instead.
// However, if we ever elect to use timers in Safari, the prevalent work-around
// is to add a scroll event listener that calls for a flush.

// `setTimeout` does not call the passed callback if the delay is less than
// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
// even then.

function makeRequestCallFromTimer(callback) {
    return function requestCall() {
        // We dispatch a timeout with a specified delay of 0 for engines that
        // can reliably accommodate that request. This will usually be snapped
        // to a 4 milisecond delay, but once we're flushing, there's no delay
        // between events.
        var timeoutHandle = setTimeout(handleTimer, 0);
        // However, since this timer gets frequently dropped in Firefox
        // workers, we enlist an interval handle that will try to fire
        // an event 20 times per second until it succeeds.
        var intervalHandle = setInterval(handleTimer, 50);

        function handleTimer() {
            // Whichever timer succeeds will cancel both timers and
            // execute the callback.
            clearTimeout(timeoutHandle);
            clearInterval(intervalHandle);
            callback();
        }
    };
}

// This is for `asap.js` only.
// Its name will be periodically randomized to break any code that depends on
// its existence.
rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;

// ASAP was originally a nextTick shim included in Q. This was factored out
// into this ASAP package. It was later adapted to RSVP which made further
// amendments. These decisions, particularly to marginalize MessageChannel and
// to capture the MutationObserver implementation in a closure, were integrated
// back into ASAP proper.
// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29)))

/***/ }),
/* 381 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


//This file contains the ES6 extensions to the core Promises/A+ API

var Promise = __webpack_require__(212);

module.exports = Promise;

/* Static Functions */

var TRUE = valuePromise(true);
var FALSE = valuePromise(false);
var NULL = valuePromise(null);
var UNDEFINED = valuePromise(undefined);
var ZERO = valuePromise(0);
var EMPTYSTRING = valuePromise('');

function valuePromise(value) {
  var p = new Promise(Promise._44);
  p._83 = 1;
  p._18 = value;
  return p;
}
Promise.resolve = function (value) {
  if (value instanceof Promise) return value;

  if (value === null) return NULL;
  if (value === undefined) return UNDEFINED;
  if (value === true) return TRUE;
  if (value === false) return FALSE;
  if (value === 0) return ZERO;
  if (value === '') return EMPTYSTRING;

  if (typeof value === 'object' || typeof value === 'function') {
    try {
      var then = value.then;
      if (typeof then === 'function') {
        return new Promise(then.bind(value));
      }
    } catch (ex) {
      return new Promise(function (resolve, reject) {
        reject(ex);
      });
    }
  }
  return valuePromise(value);
};

Promise.all = function (arr) {
  var args = Array.prototype.slice.call(arr);

  return new Promise(function (resolve, reject) {
    if (args.length === 0) return resolve([]);
    var remaining = args.length;
    function res(i, val) {
      if (val && (typeof val === 'object' || typeof val === 'function')) {
        if (val instanceof Promise && val.then === Promise.prototype.then) {
          while (val._83 === 3) {
            val = val._18;
          }
          if (val._83 === 1) return res(i, val._18);
          if (val._83 === 2) reject(val._18);
          val.then(function (val) {
            res(i, val);
          }, reject);
          return;
        } else {
          var then = val.then;
          if (typeof then === 'function') {
            var p = new Promise(then.bind(val));
            p.then(function (val) {
              res(i, val);
            }, reject);
            return;
          }
        }
      }
      args[i] = val;
      if (--remaining === 0) {
        resolve(args);
      }
    }
    for (var i = 0; i < args.length; i++) {
      res(i, args[i]);
    }
  });
};

Promise.reject = function (value) {
  return new Promise(function (resolve, reject) {
    reject(value);
  });
};

Promise.race = function (values) {
  return new Promise(function (resolve, reject) {
    values.forEach(function(value){
      Promise.resolve(value).then(resolve, reject);
    });
  });
};

/* Prototype Methods */

Promise.prototype['catch'] = function (onRejected) {
  return this.then(null, onRejected);
};


/***/ }),
/* 382 */
/***/ (function(module, exports) {

(function(self) {
  'use strict';

  if (self.fetch) {
    return
  }

  var support = {
    searchParams: 'URLSearchParams' in self,
    iterable: 'Symbol' in self && 'iterator' in Symbol,
    blob: 'FileReader' in self && 'Blob' in self && (function() {
      try {
        new Blob()
        return true
      } catch(e) {
        return false
      }
    })(),
    formData: 'FormData' in self,
    arrayBuffer: 'ArrayBuffer' in self
  }

  if (support.arrayBuffer) {
    var viewClasses = [
      '[object Int8Array]',
      '[object Uint8Array]',
      '[object Uint8ClampedArray]',
      '[object Int16Array]',
      '[object Uint16Array]',
      '[object Int32Array]',
      '[object Uint32Array]',
      '[object Float32Array]',
      '[object Float64Array]'
    ]

    var isDataView = function(obj) {
      return obj && DataView.prototype.isPrototypeOf(obj)
    }

    var isArrayBufferView = ArrayBuffer.isView || function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
  }

  function normalizeName(name) {
    if (typeof name !== 'string') {
      name = String(name)
    }
    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
      throw new TypeError('Invalid character in header field name')
    }
    return name.toLowerCase()
  }

  function normalizeValue(value) {
    if (typeof value !== 'string') {
      value = String(value)
    }
    return value
  }

  // Build a destructive iterator for the value list
  function iteratorFor(items) {
    var iterator = {
      next: function() {
        var value = items.shift()
        return {done: value === undefined, value: value}
      }
    }

    if (support.iterable) {
      iterator[Symbol.iterator] = function() {
        return iterator
      }
    }

    return iterator
  }

  function Headers(headers) {
    this.map = {}

    if (headers instanceof Headers) {
      headers.forEach(function(value, name) {
        this.append(name, value)
      }, this)
    } else if (Array.isArray(headers)) {
      headers.forEach(function(header) {
        this.append(header[0], header[1])
      }, this)
    } else if (headers) {
      Object.getOwnPropertyNames(headers).forEach(function(name) {
        this.append(name, headers[name])
      }, this)
    }
  }

  Headers.prototype.append = function(name, value) {
    name = normalizeName(name)
    value = normalizeValue(value)
    var oldValue = this.map[name]
    this.map[name] = oldValue ? oldValue+','+value : value
  }

  Headers.prototype['delete'] = function(name) {
    delete this.map[normalizeName(name)]
  }

  Headers.prototype.get = function(name) {
    name = normalizeName(name)
    return this.has(name) ? this.map[name] : null
  }

  Headers.prototype.has = function(name) {
    return this.map.hasOwnProperty(normalizeName(name))
  }

  Headers.prototype.set = function(name, value) {
    this.map[normalizeName(name)] = normalizeValue(value)
  }

  Headers.prototype.forEach = function(callback, thisArg) {
    for (var name in this.map) {
      if (this.map.hasOwnProperty(name)) {
        callback.call(thisArg, this.map[name], name, this)
      }
    }
  }

  Headers.prototype.keys = function() {
    var items = []
    this.forEach(function(value, name) { items.push(name) })
    return iteratorFor(items)
  }

  Headers.prototype.values = function() {
    var items = []
    this.forEach(function(value) { items.push(value) })
    return iteratorFor(items)
  }

  Headers.prototype.entries = function() {
    var items = []
    this.forEach(function(value, name) { items.push([name, value]) })
    return iteratorFor(items)
  }

  if (support.iterable) {
    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
  }

  function consumed(body) {
    if (body.bodyUsed) {
      return Promise.reject(new TypeError('Already read'))
    }
    body.bodyUsed = true
  }

  function fileReaderReady(reader) {
    return new Promise(function(resolve, reject) {
      reader.onload = function() {
        resolve(reader.result)
      }
      reader.onerror = function() {
        reject(reader.error)
      }
    })
  }

  function readBlobAsArrayBuffer(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsArrayBuffer(blob)
    return promise
  }

  function readBlobAsText(blob) {
    var reader = new FileReader()
    var promise = fileReaderReady(reader)
    reader.readAsText(blob)
    return promise
  }

  function readArrayBufferAsText(buf) {
    var view = new Uint8Array(buf)
    var chars = new Array(view.length)

    for (var i = 0; i < view.length; i++) {
      chars[i] = String.fromCharCode(view[i])
    }
    return chars.join('')
  }

  function bufferClone(buf) {
    if (buf.slice) {
      return buf.slice(0)
    } else {
      var view = new Uint8Array(buf.byteLength)
      view.set(new Uint8Array(buf))
      return view.buffer
    }
  }

  function Body() {
    this.bodyUsed = false

    this._initBody = function(body) {
      this._bodyInit = body
      if (!body) {
        this._bodyText = ''
      } else if (typeof body === 'string') {
        this._bodyText = body
      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
        this._bodyBlob = body
      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
        this._bodyFormData = body
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this._bodyText = body.toString()
      } else if (support.arrayBuffer && support.blob && isDataView(body)) {
        this._bodyArrayBuffer = bufferClone(body.buffer)
        // IE 10-11 can't handle a DataView body.
        this._bodyInit = new Blob([this._bodyArrayBuffer])
      } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
        this._bodyArrayBuffer = bufferClone(body)
      } else {
        throw new Error('unsupported BodyInit type')
      }

      if (!this.headers.get('content-type')) {
        if (typeof body === 'string') {
          this.headers.set('content-type', 'text/plain;charset=UTF-8')
        } else if (this._bodyBlob && this._bodyBlob.type) {
          this.headers.set('content-type', this._bodyBlob.type)
        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
        }
      }
    }

    if (support.blob) {
      this.blob = function() {
        var rejected = consumed(this)
        if (rejected) {
          return rejected
        }

        if (this._bodyBlob) {
          return Promise.resolve(this._bodyBlob)
        } else if (this._bodyArrayBuffer) {
          return Promise.resolve(new Blob([this._bodyArrayBuffer]))
        } else if (this._bodyFormData) {
          throw new Error('could not read FormData body as blob')
        } else {
          return Promise.resolve(new Blob([this._bodyText]))
        }
      }

      this.arrayBuffer = function() {
        if (this._bodyArrayBuffer) {
          return consumed(this) || Promise.resolve(this._bodyArrayBuffer)
        } else {
          return this.blob().then(readBlobAsArrayBuffer)
        }
      }
    }

    this.text = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return readBlobAsText(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as text')
      } else {
        return Promise.resolve(this._bodyText)
      }
    }

    if (support.formData) {
      this.formData = function() {
        return this.text().then(decode)
      }
    }

    this.json = function() {
      return this.text().then(JSON.parse)
    }

    return this
  }

  // HTTP methods whose capitalization should be normalized
  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']

  function normalizeMethod(method) {
    var upcased = method.toUpperCase()
    return (methods.indexOf(upcased) > -1) ? upcased : method
  }

  function Request(input, options) {
    options = options || {}
    var body = options.body

    if (input instanceof Request) {
      if (input.bodyUsed) {
        throw new TypeError('Already read')
      }
      this.url = input.url
      this.credentials = input.credentials
      if (!options.headers) {
        this.headers = new Headers(input.headers)
      }
      this.method = input.method
      this.mode = input.mode
      if (!body && input._bodyInit != null) {
        body = input._bodyInit
        input.bodyUsed = true
      }
    } else {
      this.url = String(input)
    }

    this.credentials = options.credentials || this.credentials || 'omit'
    if (options.headers || !this.headers) {
      this.headers = new Headers(options.headers)
    }
    this.method = normalizeMethod(options.method || this.method || 'GET')
    this.mode = options.mode || this.mode || null
    this.referrer = null

    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
      throw new TypeError('Body not allowed for GET or HEAD requests')
    }
    this._initBody(body)
  }

  Request.prototype.clone = function() {
    return new Request(this, { body: this._bodyInit })
  }

  function decode(body) {
    var form = new FormData()
    body.trim().split('&').forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
    return form
  }

  function parseHeaders(rawHeaders) {
    var headers = new Headers()
    rawHeaders.split(/\r?\n/).forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        headers.append(key, value)
      }
    })
    return headers
  }

  Body.call(Request.prototype)

  function Response(bodyInit, options) {
    if (!options) {
      options = {}
    }

    this.type = 'default'
    this.status = 'status' in options ? options.status : 200
    this.ok = this.status >= 200 && this.status < 300
    this.statusText = 'statusText' in options ? options.statusText : 'OK'
    this.headers = new Headers(options.headers)
    this.url = options.url || ''
    this._initBody(bodyInit)
  }

  Body.call(Response.prototype)

  Response.prototype.clone = function() {
    return new Response(this._bodyInit, {
      status: this.status,
      statusText: this.statusText,
      headers: new Headers(this.headers),
      url: this.url
    })
  }

  Response.error = function() {
    var response = new Response(null, {status: 0, statusText: ''})
    response.type = 'error'
    return response
  }

  var redirectStatuses = [301, 302, 303, 307, 308]

  Response.redirect = function(url, status) {
    if (redirectStatuses.indexOf(status) === -1) {
      throw new RangeError('Invalid status code')
    }

    return new Response(null, {status: status, headers: {location: url}})
  }

  self.Headers = Headers
  self.Request = Request
  self.Response = Response

  self.fetch = function(input, init) {
    return new Promise(function(resolve, reject) {
      var request = new Request(input, init)
      var xhr = new XMLHttpRequest()

      xhr.onload = function() {
        var options = {
          status: xhr.status,
          statusText: xhr.statusText,
          headers: parseHeaders(xhr.getAllResponseHeaders() || '')
        }
        options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
        var body = 'response' in xhr ? xhr.response : xhr.responseText
        resolve(new Response(body, options))
      }

      xhr.onerror = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.ontimeout = function() {
        reject(new TypeError('Network request failed'))
      }

      xhr.open(request.method, request.url, true)

      if (request.credentials === 'include') {
        xhr.withCredentials = true
      }

      if ('responseType' in xhr && support.blob) {
        xhr.responseType = 'blob'
      }

      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })

      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
    })
  }
  self.fetch.polyfill = true
})(typeof self !== 'undefined' ? self : this);


/***/ }),
/* 383 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(213);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_router_config__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__store_configureStore__ = __webpack_require__(748);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__routes__ = __webpack_require__(763);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__css_index_scss__ = __webpack_require__(1124);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__css_index_scss___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8__css_index_scss__);
var store=Object(__WEBPACK_IMPORTED_MODULE_6__store_configureStore__["a" /* default */])();__WEBPACK_IMPORTED_MODULE_1_react_dom___default.a.render(__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_redux__["a" /* Provider */],{store:store,key:"provider"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["a" /* BrowserRouter */],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components__["o" /* ScrollToTop */],null,Object(__WEBPACK_IMPORTED_MODULE_4_react_router_config__["a" /* renderRoutes */])(__WEBPACK_IMPORTED_MODULE_7__routes__["a" /* default */])))),document.getElementById("root"));

/***/ }),
/* 384 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var l=__webpack_require__(47),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.forward_ref"):60112,y=n?Symbol.for("react.suspense"):60113,z=n?Symbol.for("react.memo"):60115,A=n?Symbol.for("react.lazy"):
60116,B="function"===typeof Symbol&&Symbol.iterator;function C(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}
var D={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},E={};function F(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}F.prototype.isReactComponent={};F.prototype.setState=function(a,b){if("object"!==typeof a&&"function"!==typeof a&&null!=a)throw Error(C(85));this.updater.enqueueSetState(this,a,b,"setState")};F.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};
function G(){}G.prototype=F.prototype;function H(a,b,c){this.props=a;this.context=b;this.refs=E;this.updater=c||D}var I=H.prototype=new G;I.constructor=H;l(I,F.prototype);I.isPureReactComponent=!0;var J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
function M(a,b,c){var e,d={},g=null,k=null;if(null!=b)for(e in void 0!==b.ref&&(k=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,e)&&!L.hasOwnProperty(e)&&(d[e]=b[e]);var f=arguments.length-2;if(1===f)d.children=c;else if(1<f){for(var h=Array(f),m=0;m<f;m++)h[m]=arguments[m+2];d.children=h}if(a&&a.defaultProps)for(e in f=a.defaultProps,f)void 0===d[e]&&(d[e]=f[e]);return{$$typeof:p,type:a,key:g,ref:k,props:d,_owner:J.current}}
function N(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function O(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var P=/\/+/g,Q=[];function R(a,b,c,e){if(Q.length){var d=Q.pop();d.result=a;d.keyPrefix=b;d.func=c;d.context=e;d.count=0;return d}return{result:a,keyPrefix:b,func:c,context:e,count:0}}
function S(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>Q.length&&Q.push(a)}
function T(a,b,c,e){var d=typeof a;if("undefined"===d||"boolean"===d)a=null;var g=!1;if(null===a)g=!0;else switch(d){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return c(e,a,""===b?"."+U(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var k=0;k<a.length;k++){d=a[k];var f=b+U(d,k);g+=T(d,f,c,e)}else if(null===a||"object"!==typeof a?f=null:(f=B&&a[B]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),k=
0;!(d=a.next()).done;)d=d.value,f=b+U(d,k++),g+=T(d,f,c,e);else if("object"===d)throw c=""+a,Error(C(31,"[object Object]"===c?"object with keys {"+Object.keys(a).join(", ")+"}":c,""));return g}function V(a,b,c){return null==a?0:T(a,"",b,c)}function U(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function W(a,b){a.func.call(a.context,b,a.count++)}
function aa(a,b,c){var e=a.result,d=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?X(a,e,c,function(a){return a}):null!=a&&(O(a)&&(a=N(a,d+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(P,"$&/")+"/")+c)),e.push(a))}function X(a,b,c,e,d){var g="";null!=c&&(g=(""+c).replace(P,"$&/")+"/");b=R(b,g,e,d);V(a,aa,b);S(b)}var Y={current:null};function Z(){var a=Y.current;if(null===a)throw Error(C(321));return a}
var ba={ReactCurrentDispatcher:Y,ReactCurrentBatchConfig:{suspense:null},ReactCurrentOwner:J,IsSomeRendererActing:{current:!1},assign:l};exports.Children={map:function(a,b,c){if(null==a)return a;var e=[];X(a,e,null,b,c);return e},forEach:function(a,b,c){if(null==a)return a;b=R(null,null,b,c);V(a,W,b);S(b)},count:function(a){return V(a,function(){return null},null)},toArray:function(a){var b=[];X(a,b,null,function(a){return a});return b},only:function(a){if(!O(a))throw Error(C(143));return a}};
exports.Component=F;exports.Fragment=r;exports.Profiler=u;exports.PureComponent=H;exports.StrictMode=t;exports.Suspense=y;exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=ba;
exports.cloneElement=function(a,b,c){if(null===a||void 0===a)throw Error(C(267,a));var e=l({},a.props),d=a.key,g=a.ref,k=a._owner;if(null!=b){void 0!==b.ref&&(g=b.ref,k=J.current);void 0!==b.key&&(d=""+b.key);if(a.type&&a.type.defaultProps)var f=a.type.defaultProps;for(h in b)K.call(b,h)&&!L.hasOwnProperty(h)&&(e[h]=void 0===b[h]&&void 0!==f?f[h]:b[h])}var h=arguments.length-2;if(1===h)e.children=c;else if(1<h){f=Array(h);for(var m=0;m<h;m++)f[m]=arguments[m+2];e.children=f}return{$$typeof:p,type:a.type,
key:d,ref:g,props:e,_owner:k}};exports.createContext=function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a};exports.createElement=M;exports.createFactory=function(a){var b=M.bind(null,a);b.type=a;return b};exports.createRef=function(){return{current:null}};exports.forwardRef=function(a){return{$$typeof:x,render:a}};exports.isValidElement=O;
exports.lazy=function(a){return{$$typeof:A,_ctor:a,_status:-1,_result:null}};exports.memo=function(a,b){return{$$typeof:z,type:a,compare:void 0===b?null:b}};exports.useCallback=function(a,b){return Z().useCallback(a,b)};exports.useContext=function(a,b){return Z().useContext(a,b)};exports.useDebugValue=function(){};exports.useEffect=function(a,b){return Z().useEffect(a,b)};exports.useImperativeHandle=function(a,b,c){return Z().useImperativeHandle(a,b,c)};
exports.useLayoutEffect=function(a,b){return Z().useLayoutEffect(a,b)};exports.useMemo=function(a,b){return Z().useMemo(a,b)};exports.useReducer=function(a,b,c){return Z().useReducer(a,b,c)};exports.useRef=function(a){return Z().useRef(a)};exports.useState=function(a){return Z().useState(a)};exports.version="16.14.0";


/***/ }),
/* 385 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.14.0
 * react-dom.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/*
 Modernizr 3.0.0pre (Custom Build) | MIT
*/
var aa=__webpack_require__(0),n=__webpack_require__(47),r=__webpack_require__(386);function u(a){for(var b="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=1;c<arguments.length;c++)b+="&args[]="+encodeURIComponent(arguments[c]);return"Minified React error #"+a+"; visit "+b+" for the full message or use the non-minified dev environment for full errors and additional helpful warnings."}if(!aa)throw Error(u(227));
function ba(a,b,c,d,e,f,g,h,k){var l=Array.prototype.slice.call(arguments,3);try{b.apply(c,l)}catch(m){this.onError(m)}}var da=!1,ea=null,fa=!1,ha=null,ia={onError:function(a){da=!0;ea=a}};function ja(a,b,c,d,e,f,g,h,k){da=!1;ea=null;ba.apply(ia,arguments)}function ka(a,b,c,d,e,f,g,h,k){ja.apply(this,arguments);if(da){if(da){var l=ea;da=!1;ea=null}else throw Error(u(198));fa||(fa=!0,ha=l)}}var la=null,ma=null,na=null;
function oa(a,b,c){var d=a.type||"unknown-event";a.currentTarget=na(c);ka(d,b,void 0,a);a.currentTarget=null}var pa=null,qa={};
function ra(){if(pa)for(var a in qa){var b=qa[a],c=pa.indexOf(a);if(!(-1<c))throw Error(u(96,a));if(!sa[c]){if(!b.extractEvents)throw Error(u(97,a));sa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;if(ta.hasOwnProperty(h))throw Error(u(99,h));ta[h]=f;var k=f.phasedRegistrationNames;if(k){for(e in k)k.hasOwnProperty(e)&&ua(k[e],g,h);e=!0}else f.registrationName?(ua(f.registrationName,g,h),e=!0):e=!1;if(!e)throw Error(u(98,d,a));}}}}
function ua(a,b,c){if(va[a])throw Error(u(100,a));va[a]=b;wa[a]=b.eventTypes[c].dependencies}var sa=[],ta={},va={},wa={};function xa(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];if(!qa.hasOwnProperty(c)||qa[c]!==d){if(qa[c])throw Error(u(102,c));qa[c]=d;b=!0}}b&&ra()}var ya=!("undefined"===typeof window||"undefined"===typeof window.document||"undefined"===typeof window.document.createElement),za=null,Aa=null,Ba=null;
function Ca(a){if(a=ma(a)){if("function"!==typeof za)throw Error(u(280));var b=a.stateNode;b&&(b=la(b),za(a.stateNode,a.type,b))}}function Da(a){Aa?Ba?Ba.push(a):Ba=[a]:Aa=a}function Ea(){if(Aa){var a=Aa,b=Ba;Ba=Aa=null;Ca(a);if(b)for(a=0;a<b.length;a++)Ca(b[a])}}function Fa(a,b){return a(b)}function Ga(a,b,c,d,e){return a(b,c,d,e)}function Ha(){}var Ia=Fa,Ja=!1,Ka=!1;function La(){if(null!==Aa||null!==Ba)Ha(),Ea()}
function Ma(a,b,c){if(Ka)return a(b,c);Ka=!0;try{return Ia(a,b,c)}finally{Ka=!1,La()}}var Na=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,Oa=Object.prototype.hasOwnProperty,Pa={},Qa={};
function Ra(a){if(Oa.call(Qa,a))return!0;if(Oa.call(Pa,a))return!1;if(Na.test(a))return Qa[a]=!0;Pa[a]=!0;return!1}function Sa(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
function Ta(a,b,c,d){if(null===b||"undefined"===typeof b||Sa(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function v(a,b,c,d,e,f){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b;this.sanitizeURL=f}var C={};
"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){C[a]=new v(a,0,!1,a,null,!1)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];C[b]=new v(b,1,!1,a[1],null,!1)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){C[a]=new v(a,2,!1,a.toLowerCase(),null,!1)});
["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){C[a]=new v(a,2,!1,a,null,!1)});"allowFullScreen async autoFocus autoPlay controls default defer disabled disablePictureInPicture formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){C[a]=new v(a,3,!1,a.toLowerCase(),null,!1)});
["checked","multiple","muted","selected"].forEach(function(a){C[a]=new v(a,3,!0,a,null,!1)});["capture","download"].forEach(function(a){C[a]=new v(a,4,!1,a,null,!1)});["cols","rows","size","span"].forEach(function(a){C[a]=new v(a,6,!1,a,null,!1)});["rowSpan","start"].forEach(function(a){C[a]=new v(a,5,!1,a.toLowerCase(),null,!1)});var Ua=/[\-:]([a-z])/g;function Va(a){return a[1].toUpperCase()}
"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(Ua,
Va);C[b]=new v(b,1,!1,a,null,!1)});"xlink:actuate xlink:arcrole xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/1999/xlink",!1)});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(Ua,Va);C[b]=new v(b,1,!1,a,"http://www.w3.org/XML/1998/namespace",!1)});["tabIndex","crossOrigin"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!1)});
C.xlinkHref=new v("xlinkHref",1,!1,"xlink:href","http://www.w3.org/1999/xlink",!0);["src","href","action","formAction"].forEach(function(a){C[a]=new v(a,1,!1,a.toLowerCase(),null,!0)});var Wa=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED;Wa.hasOwnProperty("ReactCurrentDispatcher")||(Wa.ReactCurrentDispatcher={current:null});Wa.hasOwnProperty("ReactCurrentBatchConfig")||(Wa.ReactCurrentBatchConfig={suspense:null});
function Xa(a,b,c,d){var e=C.hasOwnProperty(b)?C[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(Ta(b,c,e,d)&&(c=null),d||null===e?Ra(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
var Ya=/^(.*)[\\\/]/,E="function"===typeof Symbol&&Symbol.for,Za=E?Symbol.for("react.element"):60103,$a=E?Symbol.for("react.portal"):60106,ab=E?Symbol.for("react.fragment"):60107,bb=E?Symbol.for("react.strict_mode"):60108,cb=E?Symbol.for("react.profiler"):60114,db=E?Symbol.for("react.provider"):60109,eb=E?Symbol.for("react.context"):60110,fb=E?Symbol.for("react.concurrent_mode"):60111,gb=E?Symbol.for("react.forward_ref"):60112,hb=E?Symbol.for("react.suspense"):60113,ib=E?Symbol.for("react.suspense_list"):
60120,jb=E?Symbol.for("react.memo"):60115,kb=E?Symbol.for("react.lazy"):60116,lb=E?Symbol.for("react.block"):60121,mb="function"===typeof Symbol&&Symbol.iterator;function nb(a){if(null===a||"object"!==typeof a)return null;a=mb&&a[mb]||a["@@iterator"];return"function"===typeof a?a:null}function ob(a){if(-1===a._status){a._status=0;var b=a._ctor;b=b();a._result=b;b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)})}}
function pb(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case ab:return"Fragment";case $a:return"Portal";case cb:return"Profiler";case bb:return"StrictMode";case hb:return"Suspense";case ib:return"SuspenseList"}if("object"===typeof a)switch(a.$$typeof){case eb:return"Context.Consumer";case db:return"Context.Provider";case gb:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+")":
"ForwardRef");case jb:return pb(a.type);case lb:return pb(a.render);case kb:if(a=1===a._status?a._result:null)return pb(a)}return null}function qb(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=pb(a.type);c=null;d&&(c=pb(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Ya,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
function rb(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function sb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
function tb(a){var b=sb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
null;delete a[b]}}}}function xb(a){a._valueTracker||(a._valueTracker=tb(a))}function yb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=sb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}function zb(a,b){var c=b.checked;return n({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
function Ab(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=rb(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bb(a,b){b=b.checked;null!=b&&Xa(a,"checked",b,!1)}
function Cb(a,b){Bb(a,b);var c=rb(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Db(a,b.type,c):b.hasOwnProperty("defaultValue")&&Db(a,b.type,rb(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
function Eb(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
function Db(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}function Fb(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}function Gb(a,b){a=n({children:void 0},b);if(b=Fb(b.children))a.children=b;return a}
function Hb(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+rb(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
function Ib(a,b){if(null!=b.dangerouslySetInnerHTML)throw Error(u(91));return n({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function Jb(a,b){var c=b.value;if(null==c){c=b.children;b=b.defaultValue;if(null!=c){if(null!=b)throw Error(u(92));if(Array.isArray(c)){if(!(1>=c.length))throw Error(u(93));c=c[0]}b=c}null==b&&(b="");c=b}a._wrapperState={initialValue:rb(c)}}
function Kb(a,b){var c=rb(b.value),d=rb(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function Lb(a){var b=a.textContent;b===a._wrapperState.initialValue&&""!==b&&null!==b&&(a.value=b)}var Mb={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
function Nb(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function Ob(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?Nb(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
var Pb,Qb=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==Mb.svg||"innerHTML"in a)a.innerHTML=b;else{Pb=Pb||document.createElement("div");Pb.innerHTML="<svg>"+b.valueOf().toString()+"</svg>";for(b=Pb.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
function Rb(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}function Sb(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Tb={animationend:Sb("Animation","AnimationEnd"),animationiteration:Sb("Animation","AnimationIteration"),animationstart:Sb("Animation","AnimationStart"),transitionend:Sb("Transition","TransitionEnd")},Ub={},Vb={};
ya&&(Vb=document.createElement("div").style,"AnimationEvent"in window||(delete Tb.animationend.animation,delete Tb.animationiteration.animation,delete Tb.animationstart.animation),"TransitionEvent"in window||delete Tb.transitionend.transition);function Wb(a){if(Ub[a])return Ub[a];if(!Tb[a])return a;var b=Tb[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Vb)return Ub[a]=b[c];return a}
var Xb=Wb("animationend"),Yb=Wb("animationiteration"),Zb=Wb("animationstart"),$b=Wb("transitionend"),ac="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),bc=new ("function"===typeof WeakMap?WeakMap:Map);function cc(a){var b=bc.get(a);void 0===b&&(b=new Map,bc.set(a,b));return b}
function dc(a){var b=a,c=a;if(a.alternate)for(;b.return;)b=b.return;else{a=b;do b=a,0!==(b.effectTag&1026)&&(c=b.return),a=b.return;while(a)}return 3===b.tag?c:null}function ec(a){if(13===a.tag){var b=a.memoizedState;null===b&&(a=a.alternate,null!==a&&(b=a.memoizedState));if(null!==b)return b.dehydrated}return null}function fc(a){if(dc(a)!==a)throw Error(u(188));}
function gc(a){var b=a.alternate;if(!b){b=dc(a);if(null===b)throw Error(u(188));return b!==a?null:a}for(var c=a,d=b;;){var e=c.return;if(null===e)break;var f=e.alternate;if(null===f){d=e.return;if(null!==d){c=d;continue}break}if(e.child===f.child){for(f=e.child;f;){if(f===c)return fc(e),a;if(f===d)return fc(e),b;f=f.sibling}throw Error(u(188));}if(c.return!==d.return)c=e,d=f;else{for(var g=!1,h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===
c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}if(!g)throw Error(u(189));}}if(c.alternate!==d)throw Error(u(190));}if(3!==c.tag)throw Error(u(188));return c.stateNode.current===c?a:b}function hc(a){a=gc(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
function ic(a,b){if(null==b)throw Error(u(30));if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}function jc(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var kc=null;
function lc(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)oa(a,b[d],c[d]);else b&&oa(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}function mc(a){null!==a&&(kc=ic(kc,a));a=kc;kc=null;if(a){jc(a,lc);if(kc)throw Error(u(95));if(fa)throw a=ha,fa=!1,ha=null,a;}}
function nc(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function oc(a){if(!ya)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}var pc=[];function qc(a){a.topLevelType=null;a.nativeEvent=null;a.targetInst=null;a.ancestors.length=0;10>pc.length&&pc.push(a)}
function rc(a,b,c,d){if(pc.length){var e=pc.pop();e.topLevelType=a;e.eventSystemFlags=d;e.nativeEvent=b;e.targetInst=c;return e}return{topLevelType:a,eventSystemFlags:d,nativeEvent:b,targetInst:c,ancestors:[]}}
function sc(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d=c;if(3===d.tag)d=d.stateNode.containerInfo;else{for(;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo}if(!d)break;b=c.tag;5!==b&&6!==b||a.ancestors.push(c);c=tc(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=nc(a.nativeEvent);d=a.topLevelType;var f=a.nativeEvent,g=a.eventSystemFlags;0===c&&(g|=64);for(var h=null,k=0;k<sa.length;k++){var l=sa[k];l&&(l=l.extractEvents(d,b,f,e,g))&&(h=
ic(h,l))}mc(h)}}function uc(a,b,c){if(!c.has(a)){switch(a){case "scroll":vc(b,"scroll",!0);break;case "focus":case "blur":vc(b,"focus",!0);vc(b,"blur",!0);c.set("blur",null);c.set("focus",null);break;case "cancel":case "close":oc(a)&&vc(b,a,!0);break;case "invalid":case "submit":case "reset":break;default:-1===ac.indexOf(a)&&F(a,b)}c.set(a,null)}}
var wc,xc,yc,zc=!1,Ac=[],Bc=null,Cc=null,Dc=null,Ec=new Map,Fc=new Map,Gc=[],Hc="mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput close cancel copy cut paste click change contextmenu reset submit".split(" "),Ic="focus blur dragenter dragleave mouseover mouseout pointerover pointerout gotpointercapture lostpointercapture".split(" ");
function Jc(a,b){var c=cc(b);Hc.forEach(function(a){uc(a,b,c)});Ic.forEach(function(a){uc(a,b,c)})}function Kc(a,b,c,d,e){return{blockedOn:a,topLevelType:b,eventSystemFlags:c|32,nativeEvent:e,container:d}}
function Lc(a,b){switch(a){case "focus":case "blur":Bc=null;break;case "dragenter":case "dragleave":Cc=null;break;case "mouseover":case "mouseout":Dc=null;break;case "pointerover":case "pointerout":Ec.delete(b.pointerId);break;case "gotpointercapture":case "lostpointercapture":Fc.delete(b.pointerId)}}function Mc(a,b,c,d,e,f){if(null===a||a.nativeEvent!==f)return a=Kc(b,c,d,e,f),null!==b&&(b=Nc(b),null!==b&&xc(b)),a;a.eventSystemFlags|=d;return a}
function Oc(a,b,c,d,e){switch(b){case "focus":return Bc=Mc(Bc,a,b,c,d,e),!0;case "dragenter":return Cc=Mc(Cc,a,b,c,d,e),!0;case "mouseover":return Dc=Mc(Dc,a,b,c,d,e),!0;case "pointerover":var f=e.pointerId;Ec.set(f,Mc(Ec.get(f)||null,a,b,c,d,e));return!0;case "gotpointercapture":return f=e.pointerId,Fc.set(f,Mc(Fc.get(f)||null,a,b,c,d,e)),!0}return!1}
function Pc(a){var b=tc(a.target);if(null!==b){var c=dc(b);if(null!==c)if(b=c.tag,13===b){if(b=ec(c),null!==b){a.blockedOn=b;r.unstable_runWithPriority(a.priority,function(){yc(c)});return}}else if(3===b&&c.stateNode.hydrate){a.blockedOn=3===c.tag?c.stateNode.containerInfo:null;return}}a.blockedOn=null}function Qc(a){if(null!==a.blockedOn)return!1;var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);if(null!==b){var c=Nc(b);null!==c&&xc(c);a.blockedOn=b;return!1}return!0}
function Sc(a,b,c){Qc(a)&&c.delete(b)}function Tc(){for(zc=!1;0<Ac.length;){var a=Ac[0];if(null!==a.blockedOn){a=Nc(a.blockedOn);null!==a&&wc(a);break}var b=Rc(a.topLevelType,a.eventSystemFlags,a.container,a.nativeEvent);null!==b?a.blockedOn=b:Ac.shift()}null!==Bc&&Qc(Bc)&&(Bc=null);null!==Cc&&Qc(Cc)&&(Cc=null);null!==Dc&&Qc(Dc)&&(Dc=null);Ec.forEach(Sc);Fc.forEach(Sc)}function Uc(a,b){a.blockedOn===b&&(a.blockedOn=null,zc||(zc=!0,r.unstable_scheduleCallback(r.unstable_NormalPriority,Tc)))}
function Vc(a){function b(b){return Uc(b,a)}if(0<Ac.length){Uc(Ac[0],a);for(var c=1;c<Ac.length;c++){var d=Ac[c];d.blockedOn===a&&(d.blockedOn=null)}}null!==Bc&&Uc(Bc,a);null!==Cc&&Uc(Cc,a);null!==Dc&&Uc(Dc,a);Ec.forEach(b);Fc.forEach(b);for(c=0;c<Gc.length;c++)d=Gc[c],d.blockedOn===a&&(d.blockedOn=null);for(;0<Gc.length&&(c=Gc[0],null===c.blockedOn);)Pc(c),null===c.blockedOn&&Gc.shift()}
var Wc={},Yc=new Map,Zc=new Map,$c=["abort","abort",Xb,"animationEnd",Yb,"animationIteration",Zb,"animationStart","canplay","canPlay","canplaythrough","canPlayThrough","durationchange","durationChange","emptied","emptied","encrypted","encrypted","ended","ended","error","error","gotpointercapture","gotPointerCapture","load","load","loadeddata","loadedData","loadedmetadata","loadedMetadata","loadstart","loadStart","lostpointercapture","lostPointerCapture","playing","playing","progress","progress","seeking",
"seeking","stalled","stalled","suspend","suspend","timeupdate","timeUpdate",$b,"transitionEnd","waiting","waiting"];function ad(a,b){for(var c=0;c<a.length;c+=2){var d=a[c],e=a[c+1],f="on"+(e[0].toUpperCase()+e.slice(1));f={phasedRegistrationNames:{bubbled:f,captured:f+"Capture"},dependencies:[d],eventPriority:b};Zc.set(d,b);Yc.set(d,f);Wc[e]=f}}
ad("blur blur cancel cancel click click close close contextmenu contextMenu copy copy cut cut auxclick auxClick dblclick doubleClick dragend dragEnd dragstart dragStart drop drop focus focus input input invalid invalid keydown keyDown keypress keyPress keyup keyUp mousedown mouseDown mouseup mouseUp paste paste pause pause play play pointercancel pointerCancel pointerdown pointerDown pointerup pointerUp ratechange rateChange reset reset seeked seeked submit submit touchcancel touchCancel touchend touchEnd touchstart touchStart volumechange volumeChange".split(" "),0);
ad("drag drag dragenter dragEnter dragexit dragExit dragleave dragLeave dragover dragOver mousemove mouseMove mouseout mouseOut mouseover mouseOver pointermove pointerMove pointerout pointerOut pointerover pointerOver scroll scroll toggle toggle touchmove touchMove wheel wheel".split(" "),1);ad($c,2);for(var bd="change selectionchange textInput compositionstart compositionend compositionupdate".split(" "),cd=0;cd<bd.length;cd++)Zc.set(bd[cd],0);
var dd=r.unstable_UserBlockingPriority,ed=r.unstable_runWithPriority,fd=!0;function F(a,b){vc(b,a,!1)}function vc(a,b,c){var d=Zc.get(b);switch(void 0===d?2:d){case 0:d=gd.bind(null,b,1,a);break;case 1:d=hd.bind(null,b,1,a);break;default:d=id.bind(null,b,1,a)}c?a.addEventListener(b,d,!0):a.addEventListener(b,d,!1)}function gd(a,b,c,d){Ja||Ha();var e=id,f=Ja;Ja=!0;try{Ga(e,a,b,c,d)}finally{(Ja=f)||La()}}function hd(a,b,c,d){ed(dd,id.bind(null,a,b,c,d))}
function id(a,b,c,d){if(fd)if(0<Ac.length&&-1<Hc.indexOf(a))a=Kc(null,a,b,c,d),Ac.push(a);else{var e=Rc(a,b,c,d);if(null===e)Lc(a,d);else if(-1<Hc.indexOf(a))a=Kc(e,a,b,c,d),Ac.push(a);else if(!Oc(e,a,b,c,d)){Lc(a,d);a=rc(a,d,null,b);try{Ma(sc,a)}finally{qc(a)}}}}
function Rc(a,b,c,d){c=nc(d);c=tc(c);if(null!==c){var e=dc(c);if(null===e)c=null;else{var f=e.tag;if(13===f){c=ec(e);if(null!==c)return c;c=null}else if(3===f){if(e.stateNode.hydrate)return 3===e.tag?e.stateNode.containerInfo:null;c=null}else e!==c&&(c=null)}}a=rc(a,d,c,b);try{Ma(sc,a)}finally{qc(a)}return null}
var jd={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},kd=["Webkit","ms","Moz","O"];Object.keys(jd).forEach(function(a){kd.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);jd[b]=jd[a]})});function ld(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||jd.hasOwnProperty(a)&&jd[a]?(""+b).trim():b+"px"}
function md(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=ld(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var nd=n({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
function od(a,b){if(b){if(nd[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML))throw Error(u(137,a,""));if(null!=b.dangerouslySetInnerHTML){if(null!=b.children)throw Error(u(60));if(!("object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML))throw Error(u(61));}if(null!=b.style&&"object"!==typeof b.style)throw Error(u(62,""));}}
function pd(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}var qd=Mb.html;function rd(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=cc(a);b=wa[b];for(var d=0;d<b.length;d++)uc(b[d],a,c)}function sd(){}
function td(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function ud(a){for(;a&&a.firstChild;)a=a.firstChild;return a}function vd(a,b){var c=ud(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=ud(c)}}
function wd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?wd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}function xd(){for(var a=window,b=td();b instanceof a.HTMLIFrameElement;){try{var c="string"===typeof b.contentWindow.location.href}catch(d){c=!1}if(c)a=b.contentWindow;else break;b=td(a.document)}return b}
function yd(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}var zd="$",Ad="/$",Bd="$?",Cd="$!",Dd=null,Ed=null;function Fd(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}
function Gd(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}var Hd="function"===typeof setTimeout?setTimeout:void 0,Id="function"===typeof clearTimeout?clearTimeout:void 0;function Jd(a){for(;null!=a;a=a.nextSibling){var b=a.nodeType;if(1===b||3===b)break}return a}
function Kd(a){a=a.previousSibling;for(var b=0;a;){if(8===a.nodeType){var c=a.data;if(c===zd||c===Cd||c===Bd){if(0===b)return a;b--}else c===Ad&&b++}a=a.previousSibling}return null}var Ld=Math.random().toString(36).slice(2),Md="__reactInternalInstance$"+Ld,Nd="__reactEventHandlers$"+Ld,Od="__reactContainere$"+Ld;
function tc(a){var b=a[Md];if(b)return b;for(var c=a.parentNode;c;){if(b=c[Od]||c[Md]){c=b.alternate;if(null!==b.child||null!==c&&null!==c.child)for(a=Kd(a);null!==a;){if(c=a[Md])return c;a=Kd(a)}return b}a=c;c=a.parentNode}return null}function Nc(a){a=a[Md]||a[Od];return!a||5!==a.tag&&6!==a.tag&&13!==a.tag&&3!==a.tag?null:a}function Pd(a){if(5===a.tag||6===a.tag)return a.stateNode;throw Error(u(33));}function Qd(a){return a[Nd]||null}
function Rd(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}
function Sd(a,b){var c=a.stateNode;if(!c)return null;var d=la(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":case "onMouseEnter":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;if(c&&"function"!==typeof c)throw Error(u(231,
b,typeof c));return c}function Td(a,b,c){if(b=Sd(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a)}function Ud(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Rd(b);for(b=c.length;0<b--;)Td(c[b],"captured",a);for(b=0;b<c.length;b++)Td(c[b],"bubbled",a)}}
function Vd(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Sd(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=ic(c._dispatchListeners,b),c._dispatchInstances=ic(c._dispatchInstances,a))}function Wd(a){a&&a.dispatchConfig.registrationName&&Vd(a._targetInst,null,a)}function Xd(a){jc(a,Ud)}var Yd=null,Zd=null,$d=null;
function ae(){if($d)return $d;var a,b=Zd,c=b.length,d,e="value"in Yd?Yd.value:Yd.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return $d=e.slice(a,1<d?1-d:void 0)}function be(){return!0}function ce(){return!1}
function G(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?be:ce;this.isPropagationStopped=ce;return this}
n(G.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=be)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=be)},persist:function(){this.isPersistent=be},isPersistent:ce,destructor:function(){var a=this.constructor.Interface,
b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ce;this._dispatchInstances=this._dispatchListeners=null}});G.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
G.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;n(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=n({},d.Interface,a);c.extend=d.extend;de(c);return c};de(G);function ee(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}
function fe(a){if(!(a instanceof this))throw Error(u(279));a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}function de(a){a.eventPool=[];a.getPooled=ee;a.release=fe}var ge=G.extend({data:null}),he=G.extend({data:null}),ie=[9,13,27,32],je=ya&&"CompositionEvent"in window,ke=null;ya&&"documentMode"in document&&(ke=document.documentMode);
var le=ya&&"TextEvent"in window&&!ke,me=ya&&(!je||ke&&8<ke&&11>=ke),ne=String.fromCharCode(32),oe={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},pe=!1;
function qe(a,b){switch(a){case "keyup":return-1!==ie.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function re(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var se=!1;function te(a,b){switch(a){case "compositionend":return re(b);case "keypress":if(32!==b.which)return null;pe=!0;return ne;case "textInput":return a=b.data,a===ne&&pe?null:a;default:return null}}
function ue(a,b){if(se)return"compositionend"===a||!je&&qe(a,b)?(a=ae(),$d=Zd=Yd=null,se=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return me&&"ko"!==b.locale?null:b.data;default:return null}}
var ve={eventTypes:oe,extractEvents:function(a,b,c,d){var e;if(je)b:{switch(a){case "compositionstart":var f=oe.compositionStart;break b;case "compositionend":f=oe.compositionEnd;break b;case "compositionupdate":f=oe.compositionUpdate;break b}f=void 0}else se?qe(a,c)&&(f=oe.compositionEnd):"keydown"===a&&229===c.keyCode&&(f=oe.compositionStart);f?(me&&"ko"!==c.locale&&(se||f!==oe.compositionStart?f===oe.compositionEnd&&se&&(e=ae()):(Yd=d,Zd="value"in Yd?Yd.value:Yd.textContent,se=!0)),f=ge.getPooled(f,
b,c,d),e?f.data=e:(e=re(c),null!==e&&(f.data=e)),Xd(f),e=f):e=null;(a=le?te(a,c):ue(a,c))?(b=he.getPooled(oe.beforeInput,b,c,d),b.data=a,Xd(b)):b=null;return null===e?b:null===b?e:[e,b]}},we={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function xe(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!we[a.type]:"textarea"===b?!0:!1}
var ye={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function ze(a,b,c){a=G.getPooled(ye.change,a,b,c);a.type="change";Da(c);Xd(a);return a}var Ae=null,Be=null;function Ce(a){mc(a)}function De(a){var b=Pd(a);if(yb(b))return a}function Ee(a,b){if("change"===a)return b}var Fe=!1;ya&&(Fe=oc("input")&&(!document.documentMode||9<document.documentMode));
function Ge(){Ae&&(Ae.detachEvent("onpropertychange",He),Be=Ae=null)}function He(a){if("value"===a.propertyName&&De(Be))if(a=ze(Be,a,nc(a)),Ja)mc(a);else{Ja=!0;try{Fa(Ce,a)}finally{Ja=!1,La()}}}function Ie(a,b,c){"focus"===a?(Ge(),Ae=b,Be=c,Ae.attachEvent("onpropertychange",He)):"blur"===a&&Ge()}function Je(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return De(Be)}function Ke(a,b){if("click"===a)return De(b)}function Le(a,b){if("input"===a||"change"===a)return De(b)}
var Me={eventTypes:ye,_isInputEventSupported:Fe,extractEvents:function(a,b,c,d){var e=b?Pd(b):window,f=e.nodeName&&e.nodeName.toLowerCase();if("select"===f||"input"===f&&"file"===e.type)var g=Ee;else if(xe(e))if(Fe)g=Le;else{g=Je;var h=Ie}else(f=e.nodeName)&&"input"===f.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(g=Ke);if(g&&(g=g(a,b)))return ze(g,c,d);h&&h(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Db(e,"number",e.value)}},Ne=G.extend({view:null,detail:null}),
Oe={Alt:"altKey",Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Pe(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Oe[a])?!!b[a]:!1}function Qe(){return Pe}
var Re=0,Se=0,Te=!1,Ue=!1,Ve=Ne.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Qe,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Re;Re=a.screenX;return Te?"mousemove"===a.type?a.screenX-b:0:(Te=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
var b=Se;Se=a.screenY;return Ue?"mousemove"===a.type?a.screenY-b:0:(Ue=!0,0)}}),We=Ve.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),Xe={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
dependencies:["pointerout","pointerover"]}},Ye={eventTypes:Xe,extractEvents:function(a,b,c,d,e){var f="mouseover"===a||"pointerover"===a,g="mouseout"===a||"pointerout"===a;if(f&&0===(e&32)&&(c.relatedTarget||c.fromElement)||!g&&!f)return null;f=d.window===d?d:(f=d.ownerDocument)?f.defaultView||f.parentWindow:window;if(g){if(g=b,b=(b=c.relatedTarget||c.toElement)?tc(b):null,null!==b){var h=dc(b);if(b!==h||5!==b.tag&&6!==b.tag)b=null}}else g=null;if(g===b)return null;if("mouseout"===a||"mouseover"===
a){var k=Ve;var l=Xe.mouseLeave;var m=Xe.mouseEnter;var p="mouse"}else if("pointerout"===a||"pointerover"===a)k=We,l=Xe.pointerLeave,m=Xe.pointerEnter,p="pointer";a=null==g?f:Pd(g);f=null==b?f:Pd(b);l=k.getPooled(l,g,c,d);l.type=p+"leave";l.target=a;l.relatedTarget=f;c=k.getPooled(m,b,c,d);c.type=p+"enter";c.target=f;c.relatedTarget=a;d=g;p=b;if(d&&p)a:{k=d;m=p;g=0;for(a=k;a;a=Rd(a))g++;a=0;for(b=m;b;b=Rd(b))a++;for(;0<g-a;)k=Rd(k),g--;for(;0<a-g;)m=Rd(m),a--;for(;g--;){if(k===m||k===m.alternate)break a;
k=Rd(k);m=Rd(m)}k=null}else k=null;m=k;for(k=[];d&&d!==m;){g=d.alternate;if(null!==g&&g===m)break;k.push(d);d=Rd(d)}for(d=[];p&&p!==m;){g=p.alternate;if(null!==g&&g===m)break;d.push(p);p=Rd(p)}for(p=0;p<k.length;p++)Vd(k[p],"bubbled",l);for(p=d.length;0<p--;)Vd(d[p],"captured",c);return 0===(e&64)?[l]:[l,c]}};function Ze(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var $e="function"===typeof Object.is?Object.is:Ze,af=Object.prototype.hasOwnProperty;
function bf(a,b){if($e(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!af.call(b,c[d])||!$e(a[c[d]],b[c[d]]))return!1;return!0}
var cf=ya&&"documentMode"in document&&11>=document.documentMode,df={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},ef=null,ff=null,gf=null,hf=!1;
function jf(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if(hf||null==ef||ef!==td(c))return null;c=ef;"selectionStart"in c&&yd(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return gf&&bf(gf,c)?null:(gf=c,a=G.getPooled(df.select,ff,a,b),a.type="select",a.target=ef,Xd(a),a)}
var kf={eventTypes:df,extractEvents:function(a,b,c,d,e,f){e=f||(d.window===d?d.document:9===d.nodeType?d:d.ownerDocument);if(!(f=!e)){a:{e=cc(e);f=wa.onSelect;for(var g=0;g<f.length;g++)if(!e.has(f[g])){e=!1;break a}e=!0}f=!e}if(f)return null;e=b?Pd(b):window;switch(a){case "focus":if(xe(e)||"true"===e.contentEditable)ef=e,ff=b,gf=null;break;case "blur":gf=ff=ef=null;break;case "mousedown":hf=!0;break;case "contextmenu":case "mouseup":case "dragend":return hf=!1,jf(c,d);case "selectionchange":if(cf)break;
case "keydown":case "keyup":return jf(c,d)}return null}},lf=G.extend({animationName:null,elapsedTime:null,pseudoElement:null}),mf=G.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),nf=Ne.extend({relatedTarget:null});function of(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
var pf={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},qf={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},rf=Ne.extend({key:function(a){if(a.key){var b=pf[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=of(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?qf[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Qe,charCode:function(a){return"keypress"===
a.type?of(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?of(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),sf=Ve.extend({dataTransfer:null}),tf=Ne.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Qe}),uf=G.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),vf=Ve.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),wf={eventTypes:Wc,extractEvents:function(a,b,c,d){var e=Yc.get(a);if(!e)return null;switch(a){case "keypress":if(0===of(c))return null;case "keydown":case "keyup":a=rf;break;case "blur":case "focus":a=nf;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=
Ve;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=sf;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=tf;break;case Xb:case Yb:case Zb:a=lf;break;case $b:a=uf;break;case "scroll":a=Ne;break;case "wheel":a=vf;break;case "copy":case "cut":case "paste":a=mf;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=
We;break;default:a=G}b=a.getPooled(e,b,c,d);Xd(b);return b}};if(pa)throw Error(u(101));pa=Array.prototype.slice.call("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));ra();var xf=Nc;la=Qd;ma=xf;na=Pd;xa({SimpleEventPlugin:wf,EnterLeaveEventPlugin:Ye,ChangeEventPlugin:Me,SelectEventPlugin:kf,BeforeInputEventPlugin:ve});var yf=[],zf=-1;function H(a){0>zf||(a.current=yf[zf],yf[zf]=null,zf--)}
function I(a,b){zf++;yf[zf]=a.current;a.current=b}var Af={},J={current:Af},K={current:!1},Bf=Af;function Cf(a,b){var c=a.type.contextTypes;if(!c)return Af;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function L(a){a=a.childContextTypes;return null!==a&&void 0!==a}
function Df(){H(K);H(J)}function Ef(a,b,c){if(J.current!==Af)throw Error(u(168));I(J,b);I(K,c)}function Ff(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)if(!(e in a))throw Error(u(108,pb(b)||"Unknown",e));return n({},c,{},d)}function Gf(a){a=(a=a.stateNode)&&a.__reactInternalMemoizedMergedChildContext||Af;Bf=J.current;I(J,a);I(K,K.current);return!0}
function Hf(a,b,c){var d=a.stateNode;if(!d)throw Error(u(169));c?(a=Ff(a,b,Bf),d.__reactInternalMemoizedMergedChildContext=a,H(K),H(J),I(J,a)):H(K);I(K,c)}
var If=r.unstable_runWithPriority,Jf=r.unstable_scheduleCallback,Kf=r.unstable_cancelCallback,Lf=r.unstable_requestPaint,Mf=r.unstable_now,Nf=r.unstable_getCurrentPriorityLevel,Of=r.unstable_ImmediatePriority,Pf=r.unstable_UserBlockingPriority,Qf=r.unstable_NormalPriority,Rf=r.unstable_LowPriority,Sf=r.unstable_IdlePriority,Tf={},Uf=r.unstable_shouldYield,Vf=void 0!==Lf?Lf:function(){},Wf=null,Xf=null,Yf=!1,Zf=Mf(),$f=1E4>Zf?Mf:function(){return Mf()-Zf};
function ag(){switch(Nf()){case Of:return 99;case Pf:return 98;case Qf:return 97;case Rf:return 96;case Sf:return 95;default:throw Error(u(332));}}function bg(a){switch(a){case 99:return Of;case 98:return Pf;case 97:return Qf;case 96:return Rf;case 95:return Sf;default:throw Error(u(332));}}function cg(a,b){a=bg(a);return If(a,b)}function dg(a,b,c){a=bg(a);return Jf(a,b,c)}function eg(a){null===Wf?(Wf=[a],Xf=Jf(Of,fg)):Wf.push(a);return Tf}function gg(){if(null!==Xf){var a=Xf;Xf=null;Kf(a)}fg()}
function fg(){if(!Yf&&null!==Wf){Yf=!0;var a=0;try{var b=Wf;cg(99,function(){for(;a<b.length;a++){var c=b[a];do c=c(!0);while(null!==c)}});Wf=null}catch(c){throw null!==Wf&&(Wf=Wf.slice(a+1)),Jf(Of,gg),c;}finally{Yf=!1}}}function hg(a,b,c){c/=10;return 1073741821-(((1073741821-a+b/10)/c|0)+1)*c}function ig(a,b){if(a&&a.defaultProps){b=n({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}var jg={current:null},kg=null,lg=null,mg=null;function ng(){mg=lg=kg=null}
function og(a){var b=jg.current;H(jg);a.type._context._currentValue=b}function pg(a,b){for(;null!==a;){var c=a.alternate;if(a.childExpirationTime<b)a.childExpirationTime=b,null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);else if(null!==c&&c.childExpirationTime<b)c.childExpirationTime=b;else break;a=a.return}}function qg(a,b){kg=a;mg=lg=null;a=a.dependencies;null!==a&&null!==a.firstContext&&(a.expirationTime>=b&&(rg=!0),a.firstContext=null)}
function sg(a,b){if(mg!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)mg=a,b=1073741823;b={context:a,observedBits:b,next:null};if(null===lg){if(null===kg)throw Error(u(308));lg=b;kg.dependencies={expirationTime:0,firstContext:b,responders:null}}else lg=lg.next=b}return a._currentValue}var tg=!1;function ug(a){a.updateQueue={baseState:a.memoizedState,baseQueue:null,shared:{pending:null},effects:null}}
function vg(a,b){a=a.updateQueue;b.updateQueue===a&&(b.updateQueue={baseState:a.baseState,baseQueue:a.baseQueue,shared:a.shared,effects:a.effects})}function wg(a,b){a={expirationTime:a,suspenseConfig:b,tag:0,payload:null,callback:null,next:null};return a.next=a}function xg(a,b){a=a.updateQueue;if(null!==a){a=a.shared;var c=a.pending;null===c?b.next=b:(b.next=c.next,c.next=b);a.pending=b}}
function yg(a,b){var c=a.alternate;null!==c&&vg(c,a);a=a.updateQueue;c=a.baseQueue;null===c?(a.baseQueue=b.next=b,b.next=b):(b.next=c.next,c.next=b)}
function zg(a,b,c,d){var e=a.updateQueue;tg=!1;var f=e.baseQueue,g=e.shared.pending;if(null!==g){if(null!==f){var h=f.next;f.next=g.next;g.next=h}f=g;e.shared.pending=null;h=a.alternate;null!==h&&(h=h.updateQueue,null!==h&&(h.baseQueue=g))}if(null!==f){h=f.next;var k=e.baseState,l=0,m=null,p=null,x=null;if(null!==h){var z=h;do{g=z.expirationTime;if(g<d){var ca={expirationTime:z.expirationTime,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null};null===x?(p=x=
ca,m=k):x=x.next=ca;g>l&&(l=g)}else{null!==x&&(x=x.next={expirationTime:1073741823,suspenseConfig:z.suspenseConfig,tag:z.tag,payload:z.payload,callback:z.callback,next:null});Ag(g,z.suspenseConfig);a:{var D=a,t=z;g=b;ca=c;switch(t.tag){case 1:D=t.payload;if("function"===typeof D){k=D.call(ca,k,g);break a}k=D;break a;case 3:D.effectTag=D.effectTag&-4097|64;case 0:D=t.payload;g="function"===typeof D?D.call(ca,k,g):D;if(null===g||void 0===g)break a;k=n({},k,g);break a;case 2:tg=!0}}null!==z.callback&&
(a.effectTag|=32,g=e.effects,null===g?e.effects=[z]:g.push(z))}z=z.next;if(null===z||z===h)if(g=e.shared.pending,null===g)break;else z=f.next=g.next,g.next=h,e.baseQueue=f=g,e.shared.pending=null}while(1)}null===x?m=k:x.next=p;e.baseState=m;e.baseQueue=x;Bg(l);a.expirationTime=l;a.memoizedState=k}}
function Cg(a,b,c){a=b.effects;b.effects=null;if(null!==a)for(b=0;b<a.length;b++){var d=a[b],e=d.callback;if(null!==e){d.callback=null;d=e;e=c;if("function"!==typeof d)throw Error(u(191,d));d.call(e)}}}var Dg=Wa.ReactCurrentBatchConfig,Eg=(new aa.Component).refs;function Fg(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:n({},b,c);a.memoizedState=c;0===a.expirationTime&&(a.updateQueue.baseState=c)}
var Jg={isMounted:function(a){return(a=a._reactInternalFiber)?dc(a)===a:!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e=wg(d,e);e.tag=1;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);xg(a,e);Ig(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=Gg(),d=Dg.suspense;
c=Hg(c,a,d);d=wg(c,d);d.tag=2;void 0!==b&&null!==b&&(d.callback=b);xg(a,d);Ig(a,c)}};function Kg(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!bf(c,d)||!bf(e,f):!0}
function Lg(a,b,c){var d=!1,e=Af;var f=b.contextType;"object"===typeof f&&null!==f?f=sg(f):(e=L(b)?Bf:J.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Cf(a,e):Af);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=Jg;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
function Mg(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&Jg.enqueueReplaceState(b,b.state,null)}
function Ng(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=Eg;ug(a);var f=b.contextType;"object"===typeof f&&null!==f?e.context=sg(f):(f=L(b)?Bf:J.current,e.context=Cf(a,f));zg(a,c,e,d);e.state=a.memoizedState;f=b.getDerivedStateFromProps;"function"===typeof f&&(Fg(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==typeof e.componentWillMount||
(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&Jg.enqueueReplaceState(e,e.state,null),zg(a,c,e,d),e.state=a.memoizedState);"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Og=Array.isArray;
function Pg(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;if(c){if(1!==c.tag)throw Error(u(309));var d=c.stateNode}if(!d)throw Error(u(147,a));var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===Eg&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}if("string"!==typeof a)throw Error(u(284));if(!c._owner)throw Error(u(290,a));}return a}
function Qg(a,b){if("textarea"!==a.type)throw Error(u(31,"[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,""));}
function Rg(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b){a=Sg(a,b);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=Tg(c,a.mode,d),b.return=a,b;b=e(b,c);b.return=a;return b}function k(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props),d.ref=Pg(a,b,c),d.return=a,d;d=Ug(c.type,c.key,c.props,null,a.mode,d);d.ref=Pg(a,b,c);d.return=a;return d}function l(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
c.implementation)return b=Vg(c,a.mode,d),b.return=a,b;b=e(b,c.children||[]);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=Wg(c,a.mode,d,f),b.return=a,b;b=e(b,c);b.return=a;return b}function p(a,b,c){if("string"===typeof b||"number"===typeof b)return b=Tg(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Za:return c=Ug(b.type,b.key,b.props,null,a.mode,c),c.ref=Pg(a,null,b),c.return=a,c;case $a:return b=Vg(b,a.mode,c),b.return=a,b}if(Og(b)||
nb(b))return b=Wg(b,a.mode,c,null),b.return=a,b;Qg(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Za:return c.key===e?c.type===ab?m(a,b,c.props.children,d,e):k(a,b,c,d):null;case $a:return c.key===e?l(a,b,c,d):null}if(Og(c)||nb(c))return null!==e?null:m(a,b,c,d,null);Qg(a,c)}return null}function z(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Za:return a=a.get(null===d.key?c:d.key)||null,d.type===ab?m(b,a,d.props.children,e,d.key):k(b,a,d,e);case $a:return a=a.get(null===d.key?c:d.key)||null,l(b,a,d,e)}if(Og(d)||nb(d))return a=a.get(c)||null,m(b,a,d,e,null);Qg(b,d)}return null}function ca(e,g,h,k){for(var l=null,t=null,m=g,y=g=0,A=null;null!==m&&y<h.length;y++){m.index>y?(A=m,m=null):A=m.sibling;var q=x(e,m,h[y],k);if(null===q){null===m&&(m=A);break}a&&
m&&null===q.alternate&&b(e,m);g=f(q,g,y);null===t?l=q:t.sibling=q;t=q;m=A}if(y===h.length)return c(e,m),l;if(null===m){for(;y<h.length;y++)m=p(e,h[y],k),null!==m&&(g=f(m,g,y),null===t?l=m:t.sibling=m,t=m);return l}for(m=d(e,m);y<h.length;y++)A=z(m,e,y,h[y],k),null!==A&&(a&&null!==A.alternate&&m.delete(null===A.key?y:A.key),g=f(A,g,y),null===t?l=A:t.sibling=A,t=A);a&&m.forEach(function(a){return b(e,a)});return l}function D(e,g,h,l){var k=nb(h);if("function"!==typeof k)throw Error(u(150));h=k.call(h);
if(null==h)throw Error(u(151));for(var m=k=null,t=g,y=g=0,A=null,q=h.next();null!==t&&!q.done;y++,q=h.next()){t.index>y?(A=t,t=null):A=t.sibling;var D=x(e,t,q.value,l);if(null===D){null===t&&(t=A);break}a&&t&&null===D.alternate&&b(e,t);g=f(D,g,y);null===m?k=D:m.sibling=D;m=D;t=A}if(q.done)return c(e,t),k;if(null===t){for(;!q.done;y++,q=h.next())q=p(e,q.value,l),null!==q&&(g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);return k}for(t=d(e,t);!q.done;y++,q=h.next())q=z(t,e,y,q.value,l),null!==q&&(a&&null!==
q.alternate&&t.delete(null===q.key?y:q.key),g=f(q,g,y),null===m?k=q:m.sibling=q,m=q);a&&t.forEach(function(a){return b(e,a)});return k}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ab&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Za:a:{l=f.key;for(k=d;null!==k;){if(k.key===l){switch(k.tag){case 7:if(f.type===ab){c(a,k.sibling);d=e(k,f.props.children);d.return=a;a=d;break a}break;default:if(k.elementType===f.type){c(a,
k.sibling);d=e(k,f.props);d.ref=Pg(a,k,f);d.return=a;a=d;break a}}c(a,k);break}else b(a,k);k=k.sibling}f.type===ab?(d=Wg(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=Ug(f.type,f.key,f.props,null,a.mode,h),h.ref=Pg(a,d,f),h.return=a,a=h)}return g(a);case $a:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[]);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=
d.sibling}d=Vg(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f),d.return=a,a=d):(c(a,d),d=Tg(f,a.mode,h),d.return=a,a=d),g(a);if(Og(f))return ca(a,d,f,h);if(nb(f))return D(a,d,f,h);l&&Qg(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:throw a=a.type,Error(u(152,a.displayName||a.name||"Component"));}return c(a,d)}}var Xg=Rg(!0),Yg=Rg(!1),Zg={},$g={current:Zg},ah={current:Zg},bh={current:Zg};
function ch(a){if(a===Zg)throw Error(u(174));return a}function dh(a,b){I(bh,b);I(ah,a);I($g,Zg);a=b.nodeType;switch(a){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:Ob(null,"");break;default:a=8===a?b.parentNode:b,b=a.namespaceURI||null,a=a.tagName,b=Ob(b,a)}H($g);I($g,b)}function eh(){H($g);H(ah);H(bh)}function fh(a){ch(bh.current);var b=ch($g.current);var c=Ob(b,a.type);b!==c&&(I(ah,a),I($g,c))}function gh(a){ah.current===a&&(H($g),H(ah))}var M={current:0};
function hh(a){for(var b=a;null!==b;){if(13===b.tag){var c=b.memoizedState;if(null!==c&&(c=c.dehydrated,null===c||c.data===Bd||c.data===Cd))return b}else if(19===b.tag&&void 0!==b.memoizedProps.revealOrder){if(0!==(b.effectTag&64))return b}else if(null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}return null}function ih(a,b){return{responder:a,props:b}}
var jh=Wa.ReactCurrentDispatcher,kh=Wa.ReactCurrentBatchConfig,lh=0,N=null,O=null,P=null,mh=!1;function Q(){throw Error(u(321));}function nh(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!$e(a[c],b[c]))return!1;return!0}
function oh(a,b,c,d,e,f){lh=f;N=b;b.memoizedState=null;b.updateQueue=null;b.expirationTime=0;jh.current=null===a||null===a.memoizedState?ph:qh;a=c(d,e);if(b.expirationTime===lh){f=0;do{b.expirationTime=0;if(!(25>f))throw Error(u(301));f+=1;P=O=null;b.updateQueue=null;jh.current=rh;a=c(d,e)}while(b.expirationTime===lh)}jh.current=sh;b=null!==O&&null!==O.next;lh=0;P=O=N=null;mh=!1;if(b)throw Error(u(300));return a}
function th(){var a={memoizedState:null,baseState:null,baseQueue:null,queue:null,next:null};null===P?N.memoizedState=P=a:P=P.next=a;return P}function uh(){if(null===O){var a=N.alternate;a=null!==a?a.memoizedState:null}else a=O.next;var b=null===P?N.memoizedState:P.next;if(null!==b)P=b,O=a;else{if(null===a)throw Error(u(310));O=a;a={memoizedState:O.memoizedState,baseState:O.baseState,baseQueue:O.baseQueue,queue:O.queue,next:null};null===P?N.memoizedState=P=a:P=P.next=a}return P}
function vh(a,b){return"function"===typeof b?b(a):b}
function wh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=O,e=d.baseQueue,f=c.pending;if(null!==f){if(null!==e){var g=e.next;e.next=f.next;f.next=g}d.baseQueue=e=f;c.pending=null}if(null!==e){e=e.next;d=d.baseState;var h=g=f=null,k=e;do{var l=k.expirationTime;if(l<lh){var m={expirationTime:k.expirationTime,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null};null===h?(g=h=m,f=d):h=h.next=m;l>N.expirationTime&&
(N.expirationTime=l,Bg(l))}else null!==h&&(h=h.next={expirationTime:1073741823,suspenseConfig:k.suspenseConfig,action:k.action,eagerReducer:k.eagerReducer,eagerState:k.eagerState,next:null}),Ag(l,k.suspenseConfig),d=k.eagerReducer===a?k.eagerState:a(d,k.action);k=k.next}while(null!==k&&k!==e);null===h?f=d:h.next=g;$e(d,b.memoizedState)||(rg=!0);b.memoizedState=d;b.baseState=f;b.baseQueue=h;c.lastRenderedState=d}return[b.memoizedState,c.dispatch]}
function xh(a){var b=uh(),c=b.queue;if(null===c)throw Error(u(311));c.lastRenderedReducer=a;var d=c.dispatch,e=c.pending,f=b.memoizedState;if(null!==e){c.pending=null;var g=e=e.next;do f=a(f,g.action),g=g.next;while(g!==e);$e(f,b.memoizedState)||(rg=!0);b.memoizedState=f;null===b.baseQueue&&(b.baseState=f);c.lastRenderedState=f}return[f,d]}
function yh(a){var b=th();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={pending:null,dispatch:null,lastRenderedReducer:vh,lastRenderedState:a};a=a.dispatch=zh.bind(null,N,a);return[b.memoizedState,a]}function Ah(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};b=N.updateQueue;null===b?(b={lastEffect:null},N.updateQueue=b,b.lastEffect=a.next=a):(c=b.lastEffect,null===c?b.lastEffect=a.next=a:(d=c.next,c.next=a,a.next=d,b.lastEffect=a));return a}
function Bh(){return uh().memoizedState}function Ch(a,b,c,d){var e=th();N.effectTag|=a;e.memoizedState=Ah(1|b,c,void 0,void 0===d?null:d)}function Dh(a,b,c,d){var e=uh();d=void 0===d?null:d;var f=void 0;if(null!==O){var g=O.memoizedState;f=g.destroy;if(null!==d&&nh(d,g.deps)){Ah(b,c,f,d);return}}N.effectTag|=a;e.memoizedState=Ah(1|b,c,f,d)}function Eh(a,b){return Ch(516,4,a,b)}function Fh(a,b){return Dh(516,4,a,b)}function Gh(a,b){return Dh(4,2,a,b)}
function Hh(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Ih(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Dh(4,2,Hh.bind(null,b,a),c)}function Jh(){}function Kh(a,b){th().memoizedState=[a,void 0===b?null:b];return a}function Lh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];c.memoizedState=[a,b];return a}
function Mh(a,b){var c=uh();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&nh(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a}function Nh(a,b,c){var d=ag();cg(98>d?98:d,function(){a(!0)});cg(97<d?97:d,function(){var d=kh.suspense;kh.suspense=void 0===b?null:b;try{a(!1),c()}finally{kh.suspense=d}})}
function zh(a,b,c){var d=Gg(),e=Dg.suspense;d=Hg(d,a,e);e={expirationTime:d,suspenseConfig:e,action:c,eagerReducer:null,eagerState:null,next:null};var f=b.pending;null===f?e.next=e:(e.next=f.next,f.next=e);b.pending=e;f=a.alternate;if(a===N||null!==f&&f===N)mh=!0,e.expirationTime=lh,N.expirationTime=lh;else{if(0===a.expirationTime&&(null===f||0===f.expirationTime)&&(f=b.lastRenderedReducer,null!==f))try{var g=b.lastRenderedState,h=f(g,c);e.eagerReducer=f;e.eagerState=h;if($e(h,g))return}catch(k){}finally{}Ig(a,
d)}}
var sh={readContext:sg,useCallback:Q,useContext:Q,useEffect:Q,useImperativeHandle:Q,useLayoutEffect:Q,useMemo:Q,useReducer:Q,useRef:Q,useState:Q,useDebugValue:Q,useResponder:Q,useDeferredValue:Q,useTransition:Q},ph={readContext:sg,useCallback:Kh,useContext:sg,useEffect:Eh,useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):null;return Ch(4,2,Hh.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Ch(4,2,a,b)},useMemo:function(a,b){var c=th();b=void 0===b?null:b;a=a();c.memoizedState=[a,
b];return a},useReducer:function(a,b,c){var d=th();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={pending:null,dispatch:null,lastRenderedReducer:a,lastRenderedState:b};a=a.dispatch=zh.bind(null,N,a);return[d.memoizedState,a]},useRef:function(a){var b=th();a={current:a};return b.memoizedState=a},useState:yh,useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=yh(a),d=c[0],e=c[1];Eh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=
c}},[a,b]);return d},useTransition:function(a){var b=yh(!1),c=b[0];b=b[1];return[Kh(Nh.bind(null,b,a),[b,a]),c]}},qh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:wh,useRef:Bh,useState:function(){return wh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=wh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=
wh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,b,a),[b,a]),c]}},rh={readContext:sg,useCallback:Lh,useContext:sg,useEffect:Fh,useImperativeHandle:Ih,useLayoutEffect:Gh,useMemo:Mh,useReducer:xh,useRef:Bh,useState:function(){return xh(vh)},useDebugValue:Jh,useResponder:ih,useDeferredValue:function(a,b){var c=xh(vh),d=c[0],e=c[1];Fh(function(){var c=kh.suspense;kh.suspense=void 0===b?null:b;try{e(a)}finally{kh.suspense=c}},[a,b]);return d},useTransition:function(a){var b=xh(vh),c=b[0];b=b[1];return[Lh(Nh.bind(null,
b,a),[b,a]),c]}},Oh=null,Ph=null,Qh=!1;function Rh(a,b){var c=Sh(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}
function Th(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;case 13:return!1;default:return!1}}
function Uh(a){if(Qh){var b=Ph;if(b){var c=b;if(!Th(a,b)){b=Jd(c.nextSibling);if(!b||!Th(a,b)){a.effectTag=a.effectTag&-1025|2;Qh=!1;Oh=a;return}Rh(Oh,c)}Oh=a;Ph=Jd(b.firstChild)}else a.effectTag=a.effectTag&-1025|2,Qh=!1,Oh=a}}function Vh(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag&&13!==a.tag;)a=a.return;Oh=a}
function Wh(a){if(a!==Oh)return!1;if(!Qh)return Vh(a),Qh=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Gd(b,a.memoizedProps))for(b=Ph;b;)Rh(a,b),b=Jd(b.nextSibling);Vh(a);if(13===a.tag){a=a.memoizedState;a=null!==a?a.dehydrated:null;if(!a)throw Error(u(317));a:{a=a.nextSibling;for(b=0;a;){if(8===a.nodeType){var c=a.data;if(c===Ad){if(0===b){Ph=Jd(a.nextSibling);break a}b--}else c!==zd&&c!==Cd&&c!==Bd||b++}a=a.nextSibling}Ph=null}}else Ph=Oh?Jd(a.stateNode.nextSibling):null;return!0}
function Xh(){Ph=Oh=null;Qh=!1}var Yh=Wa.ReactCurrentOwner,rg=!1;function R(a,b,c,d){b.child=null===a?Yg(b,null,c,d):Xg(b,a.child,c,d)}function Zh(a,b,c,d,e){c=c.render;var f=b.ref;qg(b,e);d=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,d,e);return b.child}
function ai(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!bi(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,ci(a,b,g,d,e,f);a=Ug(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:bf,c(e,d)&&a.ref===b.ref))return $h(a,b,f);b.effectTag|=1;a=Sg(g,d);a.ref=b.ref;a.return=b;return b.child=a}
function ci(a,b,c,d,e,f){return null!==a&&bf(a.memoizedProps,d)&&a.ref===b.ref&&(rg=!1,e<f)?(b.expirationTime=a.expirationTime,$h(a,b,f)):di(a,b,c,d,f)}function ei(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function di(a,b,c,d,e){var f=L(c)?Bf:J.current;f=Cf(b,f);qg(b,e);c=oh(a,b,c,d,f,e);if(null!==a&&!rg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),$h(a,b,e);b.effectTag|=1;R(a,b,c,e);return b.child}
function fi(a,b,c,d,e){if(L(c)){var f=!0;Gf(b)}else f=!1;qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),Lg(b,c,d),Ng(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var k=g.context,l=c.contextType;"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l));var m=c.getDerivedStateFromProps,p="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;p||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l);tg=!1;var x=b.memoizedState;g.state=x;zg(b,d,g,e);k=b.memoizedState;h!==d||x!==k||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),k=b.memoizedState),(h=tg||Kg(b,c,h,d,x,k,l))?(p||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&g.UNSAFE_componentWillMount()),"function"===
typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=k),g.props=d,g.state=k,g.context=l,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,vg(a,b),h=b.memoizedProps,g.props=b.type===b.elementType?h:ig(b.type,h),k=g.context,l=c.contextType,"object"===typeof l&&null!==l?l=sg(l):(l=L(c)?Bf:J.current,l=Cf(b,l)),m=c.getDerivedStateFromProps,(p="function"===typeof m||"function"===
typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||k!==l)&&Mg(b,g,d,l),tg=!1,k=b.memoizedState,g.state=k,zg(b,d,g,e),x=b.memoizedState,h!==d||k!==x||K.current||tg?("function"===typeof m&&(Fg(b,c,m,d),x=b.memoizedState),(m=tg||Kg(b,c,h,d,k,x,l))?(p||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===typeof g.componentWillUpdate&&g.componentWillUpdate(d,
x,l),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,l)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=x),g.props=d,g.state=x,g.context=l,d=m):
("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&k===a.memoizedState||(b.effectTag|=256),d=!1);return gi(a,b,c,d,f,e)}
function gi(a,b,c,d,e,f){ei(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Hf(b,c,!1),$h(a,b,f);d=b.stateNode;Yh.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=Xg(b,a.child,null,f),b.child=Xg(b,null,h,f)):R(a,b,h,f);b.memoizedState=d.state;e&&Hf(b,c,!0);return b.child}function hi(a){var b=a.stateNode;b.pendingContext?Ef(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Ef(a,b.context,!1);dh(a,b.containerInfo)}
var ii={dehydrated:null,retryTime:0};
function ji(a,b,c){var d=b.mode,e=b.pendingProps,f=M.current,g=!1,h;(h=0!==(b.effectTag&64))||(h=0!==(f&2)&&(null===a||null!==a.memoizedState));h?(g=!0,b.effectTag&=-65):null!==a&&null===a.memoizedState||void 0===e.fallback||!0===e.unstable_avoidThisFallback||(f|=1);I(M,f&1);if(null===a){void 0!==e.fallback&&Uh(b);if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=
b;e.sibling=c;b.memoizedState=ii;b.child=e;return c}d=e.children;b.memoizedState=null;return b.child=Yg(b,null,d,c)}if(null!==a.memoizedState){a=a.child;d=a.sibling;if(g){e=e.fallback;c=Sg(a,a.pendingProps);c.return=b;if(0===(b.mode&2)&&(g=null!==b.memoizedState?b.child.child:b.child,g!==a.child))for(c.child=g;null!==g;)g.return=c,g=g.sibling;d=Sg(d,e);d.return=b;c.sibling=d;c.childExpirationTime=0;b.memoizedState=ii;b.child=c;return d}c=Xg(b,a.child,e.children,c);b.memoizedState=null;return b.child=
c}a=a.child;if(g){g=e.fallback;e=Wg(null,d,0,null);e.return=b;e.child=a;null!==a&&(a.return=e);if(0===(b.mode&2))for(a=null!==b.memoizedState?b.child.child:b.child,e.child=a;null!==a;)a.return=e,a=a.sibling;c=Wg(g,d,c,null);c.return=b;e.sibling=c;c.effectTag|=2;e.childExpirationTime=0;b.memoizedState=ii;b.child=e;return c}b.memoizedState=null;return b.child=Xg(b,a,e.children,c)}
function ki(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);pg(a.return,b)}function li(a,b,c,d,e,f){var g=a.memoizedState;null===g?a.memoizedState={isBackwards:b,rendering:null,renderingStartTime:0,last:d,tail:c,tailExpiration:0,tailMode:e,lastEffect:f}:(g.isBackwards=b,g.rendering=null,g.renderingStartTime=0,g.last=d,g.tail=c,g.tailExpiration=0,g.tailMode=e,g.lastEffect=f)}
function mi(a,b,c){var d=b.pendingProps,e=d.revealOrder,f=d.tail;R(a,b,d.children,c);d=M.current;if(0!==(d&2))d=d&1|2,b.effectTag|=64;else{if(null!==a&&0!==(a.effectTag&64))a:for(a=b.child;null!==a;){if(13===a.tag)null!==a.memoizedState&&ki(a,c);else if(19===a.tag)ki(a,c);else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===b)break a;for(;null===a.sibling;){if(null===a.return||a.return===b)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}d&=1}I(M,d);if(0===(b.mode&2))b.memoizedState=
null;else switch(e){case "forwards":c=b.child;for(e=null;null!==c;)a=c.alternate,null!==a&&null===hh(a)&&(e=c),c=c.sibling;c=e;null===c?(e=b.child,b.child=null):(e=c.sibling,c.sibling=null);li(b,!1,e,c,f,b.lastEffect);break;case "backwards":c=null;e=b.child;for(b.child=null;null!==e;){a=e.alternate;if(null!==a&&null===hh(a)){b.child=e;break}a=e.sibling;e.sibling=c;c=e;e=a}li(b,!0,c,null,f,b.lastEffect);break;case "together":li(b,!1,null,null,void 0,b.lastEffect);break;default:b.memoizedState=null}return b.child}
function $h(a,b,c){null!==a&&(b.dependencies=a.dependencies);var d=b.expirationTime;0!==d&&Bg(d);if(b.childExpirationTime<c)return null;if(null!==a&&b.child!==a.child)throw Error(u(153));if(null!==b.child){a=b.child;c=Sg(a,a.pendingProps);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=Sg(a,a.pendingProps),c.return=b;c.sibling=null}return b.child}var ni,oi,pi,qi;
ni=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};oi=function(){};
pi=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;ch($g.current);a=null;switch(c){case "input":f=zb(g,f);d=zb(g,d);a=[];break;case "option":f=Gb(g,f);d=Gb(g,d);a=[];break;case "select":f=n({},f,{value:void 0});d=n({},d,{value:void 0});a=[];break;case "textarea":f=Ib(g,f);d=Ib(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=sd)}od(c,d);var h,k;c=null;for(h in f)if(!d.hasOwnProperty(h)&&f.hasOwnProperty(h)&&null!=f[h])if("style"===
h)for(k in g=f[h],g)g.hasOwnProperty(k)&&(c||(c={}),c[k]="");else"dangerouslySetInnerHTML"!==h&&"children"!==h&&"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&"autoFocus"!==h&&(va.hasOwnProperty(h)?a||(a=[]):(a=a||[]).push(h,null));for(h in d){var l=d[h];g=null!=f?f[h]:void 0;if(d.hasOwnProperty(h)&&l!==g&&(null!=l||null!=g))if("style"===h)if(g){for(k in g)!g.hasOwnProperty(k)||l&&l.hasOwnProperty(k)||(c||(c={}),c[k]="");for(k in l)l.hasOwnProperty(k)&&g[k]!==l[k]&&(c||(c={}),
c[k]=l[k])}else c||(a||(a=[]),a.push(h,c)),c=l;else"dangerouslySetInnerHTML"===h?(l=l?l.__html:void 0,g=g?g.__html:void 0,null!=l&&g!==l&&(a=a||[]).push(h,l)):"children"===h?g===l||"string"!==typeof l&&"number"!==typeof l||(a=a||[]).push(h,""+l):"suppressContentEditableWarning"!==h&&"suppressHydrationWarning"!==h&&(va.hasOwnProperty(h)?(null!=l&&rd(e,h),a||g===l||(a=[])):(a=a||[]).push(h,l))}c&&(a=a||[]).push("style",c);e=a;if(b.updateQueue=e)b.effectTag|=4}};
qi=function(a,b,c,d){c!==d&&(b.effectTag|=4)};function ri(a,b){switch(a.tailMode){case "hidden":b=a.tail;for(var c=null;null!==b;)null!==b.alternate&&(c=b),b=b.sibling;null===c?a.tail=null:c.sibling=null;break;case "collapsed":c=a.tail;for(var d=null;null!==c;)null!==c.alternate&&(d=c),c=c.sibling;null===d?b||null===a.tail?a.tail=null:a.tail.sibling=null:d.sibling=null}}
function si(a,b,c){var d=b.pendingProps;switch(b.tag){case 2:case 16:case 15:case 0:case 11:case 7:case 8:case 12:case 9:case 14:return null;case 1:return L(b.type)&&Df(),null;case 3:return eh(),H(K),H(J),c=b.stateNode,c.pendingContext&&(c.context=c.pendingContext,c.pendingContext=null),null!==a&&null!==a.child||!Wh(b)||(b.effectTag|=4),oi(b),null;case 5:gh(b);c=ch(bh.current);var e=b.type;if(null!==a&&null!=b.stateNode)pi(a,b,e,d,c),a.ref!==b.ref&&(b.effectTag|=128);else{if(!d){if(null===b.stateNode)throw Error(u(166));
return null}a=ch($g.current);if(Wh(b)){d=b.stateNode;e=b.type;var f=b.memoizedProps;d[Md]=b;d[Nd]=f;switch(e){case "iframe":case "object":case "embed":F("load",d);break;case "video":case "audio":for(a=0;a<ac.length;a++)F(ac[a],d);break;case "source":F("error",d);break;case "img":case "image":case "link":F("error",d);F("load",d);break;case "form":F("reset",d);F("submit",d);break;case "details":F("toggle",d);break;case "input":Ab(d,f);F("invalid",d);rd(c,"onChange");break;case "select":d._wrapperState=
{wasMultiple:!!f.multiple};F("invalid",d);rd(c,"onChange");break;case "textarea":Jb(d,f),F("invalid",d),rd(c,"onChange")}od(e,f);a=null;for(var g in f)if(f.hasOwnProperty(g)){var h=f[g];"children"===g?"string"===typeof h?d.textContent!==h&&(a=["children",h]):"number"===typeof h&&d.textContent!==""+h&&(a=["children",""+h]):va.hasOwnProperty(g)&&null!=h&&rd(c,g)}switch(e){case "input":xb(d);Eb(d,f,!0);break;case "textarea":xb(d);Lb(d);break;case "select":case "option":break;default:"function"===typeof f.onClick&&
(d.onclick=sd)}c=a;b.updateQueue=c;null!==c&&(b.effectTag|=4)}else{g=9===c.nodeType?c:c.ownerDocument;a===qd&&(a=Nb(e));a===qd?"script"===e?(a=g.createElement("div"),a.innerHTML="<script>\x3c/script>",a=a.removeChild(a.firstChild)):"string"===typeof d.is?a=g.createElement(e,{is:d.is}):(a=g.createElement(e),"select"===e&&(g=a,d.multiple?g.multiple=!0:d.size&&(g.size=d.size))):a=g.createElementNS(a,e);a[Md]=b;a[Nd]=d;ni(a,b,!1,!1);b.stateNode=a;g=pd(e,d);switch(e){case "iframe":case "object":case "embed":F("load",
a);h=d;break;case "video":case "audio":for(h=0;h<ac.length;h++)F(ac[h],a);h=d;break;case "source":F("error",a);h=d;break;case "img":case "image":case "link":F("error",a);F("load",a);h=d;break;case "form":F("reset",a);F("submit",a);h=d;break;case "details":F("toggle",a);h=d;break;case "input":Ab(a,d);h=zb(a,d);F("invalid",a);rd(c,"onChange");break;case "option":h=Gb(a,d);break;case "select":a._wrapperState={wasMultiple:!!d.multiple};h=n({},d,{value:void 0});F("invalid",a);rd(c,"onChange");break;case "textarea":Jb(a,
d);h=Ib(a,d);F("invalid",a);rd(c,"onChange");break;default:h=d}od(e,h);var k=h;for(f in k)if(k.hasOwnProperty(f)){var l=k[f];"style"===f?md(a,l):"dangerouslySetInnerHTML"===f?(l=l?l.__html:void 0,null!=l&&Qb(a,l)):"children"===f?"string"===typeof l?("textarea"!==e||""!==l)&&Rb(a,l):"number"===typeof l&&Rb(a,""+l):"suppressContentEditableWarning"!==f&&"suppressHydrationWarning"!==f&&"autoFocus"!==f&&(va.hasOwnProperty(f)?null!=l&&rd(c,f):null!=l&&Xa(a,f,l,g))}switch(e){case "input":xb(a);Eb(a,d,!1);
break;case "textarea":xb(a);Lb(a);break;case "option":null!=d.value&&a.setAttribute("value",""+rb(d.value));break;case "select":a.multiple=!!d.multiple;c=d.value;null!=c?Hb(a,!!d.multiple,c,!1):null!=d.defaultValue&&Hb(a,!!d.multiple,d.defaultValue,!0);break;default:"function"===typeof h.onClick&&(a.onclick=sd)}Fd(e,d)&&(b.effectTag|=4)}null!==b.ref&&(b.effectTag|=128)}return null;case 6:if(a&&null!=b.stateNode)qi(a,b,a.memoizedProps,d);else{if("string"!==typeof d&&null===b.stateNode)throw Error(u(166));
c=ch(bh.current);ch($g.current);Wh(b)?(c=b.stateNode,d=b.memoizedProps,c[Md]=b,c.nodeValue!==d&&(b.effectTag|=4)):(c=(9===c.nodeType?c:c.ownerDocument).createTextNode(d),c[Md]=b,b.stateNode=c)}return null;case 13:H(M);d=b.memoizedState;if(0!==(b.effectTag&64))return b.expirationTime=c,b;c=null!==d;d=!1;null===a?void 0!==b.memoizedProps.fallback&&Wh(b):(e=a.memoizedState,d=null!==e,c||null===e||(e=a.child.sibling,null!==e&&(f=b.firstEffect,null!==f?(b.firstEffect=e,e.nextEffect=f):(b.firstEffect=b.lastEffect=
e,e.nextEffect=null),e.effectTag=8)));if(c&&!d&&0!==(b.mode&2))if(null===a&&!0!==b.memoizedProps.unstable_avoidThisFallback||0!==(M.current&1))S===ti&&(S=ui);else{if(S===ti||S===ui)S=vi;0!==wi&&null!==T&&(xi(T,U),yi(T,wi))}if(c||d)b.effectTag|=4;return null;case 4:return eh(),oi(b),null;case 10:return og(b),null;case 17:return L(b.type)&&Df(),null;case 19:H(M);d=b.memoizedState;if(null===d)return null;e=0!==(b.effectTag&64);f=d.rendering;if(null===f)if(e)ri(d,!1);else{if(S!==ti||null!==a&&0!==(a.effectTag&
64))for(f=b.child;null!==f;){a=hh(f);if(null!==a){b.effectTag|=64;ri(d,!1);e=a.updateQueue;null!==e&&(b.updateQueue=e,b.effectTag|=4);null===d.lastEffect&&(b.firstEffect=null);b.lastEffect=d.lastEffect;for(d=b.child;null!==d;)e=d,f=c,e.effectTag&=2,e.nextEffect=null,e.firstEffect=null,e.lastEffect=null,a=e.alternate,null===a?(e.childExpirationTime=0,e.expirationTime=f,e.child=null,e.memoizedProps=null,e.memoizedState=null,e.updateQueue=null,e.dependencies=null):(e.childExpirationTime=a.childExpirationTime,
e.expirationTime=a.expirationTime,e.child=a.child,e.memoizedProps=a.memoizedProps,e.memoizedState=a.memoizedState,e.updateQueue=a.updateQueue,f=a.dependencies,e.dependencies=null===f?null:{expirationTime:f.expirationTime,firstContext:f.firstContext,responders:f.responders}),d=d.sibling;I(M,M.current&1|2);return b.child}f=f.sibling}}else{if(!e)if(a=hh(f),null!==a){if(b.effectTag|=64,e=!0,c=a.updateQueue,null!==c&&(b.updateQueue=c,b.effectTag|=4),ri(d,!0),null===d.tail&&"hidden"===d.tailMode&&!f.alternate)return b=
b.lastEffect=d.lastEffect,null!==b&&(b.nextEffect=null),null}else 2*$f()-d.renderingStartTime>d.tailExpiration&&1<c&&(b.effectTag|=64,e=!0,ri(d,!1),b.expirationTime=b.childExpirationTime=c-1);d.isBackwards?(f.sibling=b.child,b.child=f):(c=d.last,null!==c?c.sibling=f:b.child=f,d.last=f)}return null!==d.tail?(0===d.tailExpiration&&(d.tailExpiration=$f()+500),c=d.tail,d.rendering=c,d.tail=c.sibling,d.lastEffect=b.lastEffect,d.renderingStartTime=$f(),c.sibling=null,b=M.current,I(M,e?b&1|2:b&1),c):null}throw Error(u(156,
b.tag));}function zi(a){switch(a.tag){case 1:L(a.type)&&Df();var b=a.effectTag;return b&4096?(a.effectTag=b&-4097|64,a):null;case 3:eh();H(K);H(J);b=a.effectTag;if(0!==(b&64))throw Error(u(285));a.effectTag=b&-4097|64;return a;case 5:return gh(a),null;case 13:return H(M),b=a.effectTag,b&4096?(a.effectTag=b&-4097|64,a):null;case 19:return H(M),null;case 4:return eh(),null;case 10:return og(a),null;default:return null}}function Ai(a,b){return{value:a,source:b,stack:qb(b)}}
var Bi="function"===typeof WeakSet?WeakSet:Set;function Ci(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=qb(c));null!==c&&pb(c.type);b=b.value;null!==a&&1===a.tag&&pb(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Di(a,b){try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(c){Ei(a,c)}}function Fi(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Ei(a,c)}else b.current=null}
function Gi(a,b){switch(b.tag){case 0:case 11:case 15:case 22:return;case 1:if(b.effectTag&256&&null!==a){var c=a.memoizedProps,d=a.memoizedState;a=b.stateNode;b=a.getSnapshotBeforeUpdate(b.elementType===b.type?c:ig(b.type,c),d);a.__reactInternalSnapshotBeforeUpdate=b}return;case 3:case 5:case 6:case 4:case 17:return}throw Error(u(163));}
function Hi(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.destroy;c.destroy=void 0;void 0!==d&&d()}c=c.next}while(c!==b)}}function Ii(a,b){b=b.updateQueue;b=null!==b?b.lastEffect:null;if(null!==b){var c=b=b.next;do{if((c.tag&a)===a){var d=c.create;c.destroy=d()}c=c.next}while(c!==b)}}
function Ji(a,b,c){switch(c.tag){case 0:case 11:case 15:case 22:Ii(3,c);return;case 1:a=c.stateNode;if(c.effectTag&4)if(null===b)a.componentDidMount();else{var d=c.elementType===c.type?b.memoizedProps:ig(c.type,b.memoizedProps);a.componentDidUpdate(d,b.memoizedState,a.__reactInternalSnapshotBeforeUpdate)}b=c.updateQueue;null!==b&&Cg(c,b,a);return;case 3:b=c.updateQueue;if(null!==b){a=null;if(null!==c.child)switch(c.child.tag){case 5:a=c.child.stateNode;break;case 1:a=c.child.stateNode}Cg(c,b,a)}return;
case 5:a=c.stateNode;null===b&&c.effectTag&4&&Fd(c.type,c.memoizedProps)&&a.focus();return;case 6:return;case 4:return;case 12:return;case 13:null===c.memoizedState&&(c=c.alternate,null!==c&&(c=c.memoizedState,null!==c&&(c=c.dehydrated,null!==c&&Vc(c))));return;case 19:case 17:case 20:case 21:return}throw Error(u(163));}
function Ki(a,b,c){"function"===typeof Li&&Li(b);switch(b.tag){case 0:case 11:case 14:case 15:case 22:a=b.updateQueue;if(null!==a&&(a=a.lastEffect,null!==a)){var d=a.next;cg(97<c?97:c,function(){var a=d;do{var c=a.destroy;if(void 0!==c){var g=b;try{c()}catch(h){Ei(g,h)}}a=a.next}while(a!==d)})}break;case 1:Fi(b);c=b.stateNode;"function"===typeof c.componentWillUnmount&&Di(b,c);break;case 5:Fi(b);break;case 4:Mi(a,b,c)}}
function Ni(a){var b=a.alternate;a.return=null;a.child=null;a.memoizedState=null;a.updateQueue=null;a.dependencies=null;a.alternate=null;a.firstEffect=null;a.lastEffect=null;a.pendingProps=null;a.memoizedProps=null;a.stateNode=null;null!==b&&Ni(b)}function Oi(a){return 5===a.tag||3===a.tag||4===a.tag}
function Pi(a){a:{for(var b=a.return;null!==b;){if(Oi(b)){var c=b;break a}b=b.return}throw Error(u(160));}b=c.stateNode;switch(c.tag){case 5:var d=!1;break;case 3:b=b.containerInfo;d=!0;break;case 4:b=b.containerInfo;d=!0;break;default:throw Error(u(161));}c.effectTag&16&&(Rb(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Oi(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag&&18!==c.tag;){if(c.effectTag&2)continue b;
if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}d?Qi(a,c,b):Ri(a,c,b)}
function Qi(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?8===c.nodeType?c.parentNode.insertBefore(a,b):c.insertBefore(a,b):(8===c.nodeType?(b=c.parentNode,b.insertBefore(a,c)):(b=c,b.appendChild(a)),c=c._reactRootContainer,null!==c&&void 0!==c||null!==b.onclick||(b.onclick=sd));else if(4!==d&&(a=a.child,null!==a))for(Qi(a,b,c),a=a.sibling;null!==a;)Qi(a,b,c),a=a.sibling}
function Ri(a,b,c){var d=a.tag,e=5===d||6===d;if(e)a=e?a.stateNode:a.stateNode.instance,b?c.insertBefore(a,b):c.appendChild(a);else if(4!==d&&(a=a.child,null!==a))for(Ri(a,b,c),a=a.sibling;null!==a;)Ri(a,b,c),a=a.sibling}
function Mi(a,b,c){for(var d=b,e=!1,f,g;;){if(!e){e=d.return;a:for(;;){if(null===e)throw Error(u(160));f=e.stateNode;switch(e.tag){case 5:g=!1;break a;case 3:f=f.containerInfo;g=!0;break a;case 4:f=f.containerInfo;g=!0;break a}e=e.return}e=!0}if(5===d.tag||6===d.tag){a:for(var h=a,k=d,l=c,m=k;;)if(Ki(h,m,l),null!==m.child&&4!==m.tag)m.child.return=m,m=m.child;else{if(m===k)break a;for(;null===m.sibling;){if(null===m.return||m.return===k)break a;m=m.return}m.sibling.return=m.return;m=m.sibling}g?(h=
f,k=d.stateNode,8===h.nodeType?h.parentNode.removeChild(k):h.removeChild(k)):f.removeChild(d.stateNode)}else if(4===d.tag){if(null!==d.child){f=d.stateNode.containerInfo;g=!0;d.child.return=d;d=d.child;continue}}else if(Ki(a,d,c),null!==d.child){d.child.return=d;d=d.child;continue}if(d===b)break;for(;null===d.sibling;){if(null===d.return||d.return===b)return;d=d.return;4===d.tag&&(e=!1)}d.sibling.return=d.return;d=d.sibling}}
function Si(a,b){switch(b.tag){case 0:case 11:case 14:case 15:case 22:Hi(3,b);return;case 1:return;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps,e=null!==a?a.memoizedProps:d;a=b.type;var f=b.updateQueue;b.updateQueue=null;if(null!==f){c[Nd]=d;"input"===a&&"radio"===d.type&&null!=d.name&&Bb(c,d);pd(a,e);b=pd(a,d);for(e=0;e<f.length;e+=2){var g=f[e],h=f[e+1];"style"===g?md(c,h):"dangerouslySetInnerHTML"===g?Qb(c,h):"children"===g?Rb(c,h):Xa(c,g,h,b)}switch(a){case "input":Cb(c,d);break;
case "textarea":Kb(c,d);break;case "select":b=c._wrapperState.wasMultiple,c._wrapperState.wasMultiple=!!d.multiple,a=d.value,null!=a?Hb(c,!!d.multiple,a,!1):b!==!!d.multiple&&(null!=d.defaultValue?Hb(c,!!d.multiple,d.defaultValue,!0):Hb(c,!!d.multiple,d.multiple?[]:"",!1))}}}return;case 6:if(null===b.stateNode)throw Error(u(162));b.stateNode.nodeValue=b.memoizedProps;return;case 3:b=b.stateNode;b.hydrate&&(b.hydrate=!1,Vc(b.containerInfo));return;case 12:return;case 13:c=b;null===b.memoizedState?
d=!1:(d=!0,c=b.child,Ti=$f());if(null!==c)a:for(a=c;;){if(5===a.tag)f=a.stateNode,d?(f=f.style,"function"===typeof f.setProperty?f.setProperty("display","none","important"):f.display="none"):(f=a.stateNode,e=a.memoizedProps.style,e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null,f.style.display=ld("display",e));else if(6===a.tag)a.stateNode.nodeValue=d?"":a.memoizedProps;else if(13===a.tag&&null!==a.memoizedState&&null===a.memoizedState.dehydrated){f=a.child.sibling;f.return=a;a=
f;continue}else if(null!==a.child){a.child.return=a;a=a.child;continue}if(a===c)break;for(;null===a.sibling;){if(null===a.return||a.return===c)break a;a=a.return}a.sibling.return=a.return;a=a.sibling}Ui(b);return;case 19:Ui(b);return;case 17:return}throw Error(u(163));}function Ui(a){var b=a.updateQueue;if(null!==b){a.updateQueue=null;var c=a.stateNode;null===c&&(c=a.stateNode=new Bi);b.forEach(function(b){var d=Vi.bind(null,a,b);c.has(b)||(c.add(b),b.then(d,d))})}}
var Wi="function"===typeof WeakMap?WeakMap:Map;function Xi(a,b,c){c=wg(c,null);c.tag=3;c.payload={element:null};var d=b.value;c.callback=function(){Yi||(Yi=!0,Zi=d);Ci(a,b)};return c}
function $i(a,b,c){c=wg(c,null);c.tag=3;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){Ci(a,b);return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===aj?aj=new Set([this]):aj.add(this),Ci(a,b));var c=b.stack;this.componentDidCatch(b.value,{componentStack:null!==c?c:""})});return c}
var bj=Math.ceil,cj=Wa.ReactCurrentDispatcher,dj=Wa.ReactCurrentOwner,V=0,ej=8,fj=16,gj=32,ti=0,hj=1,ij=2,ui=3,vi=4,jj=5,W=V,T=null,X=null,U=0,S=ti,kj=null,lj=1073741823,mj=1073741823,nj=null,wi=0,oj=!1,Ti=0,pj=500,Y=null,Yi=!1,Zi=null,aj=null,qj=!1,rj=null,sj=90,tj=null,uj=0,vj=null,wj=0;function Gg(){return(W&(fj|gj))!==V?1073741821-($f()/10|0):0!==wj?wj:wj=1073741821-($f()/10|0)}
function Hg(a,b,c){b=b.mode;if(0===(b&2))return 1073741823;var d=ag();if(0===(b&4))return 99===d?1073741823:1073741822;if((W&fj)!==V)return U;if(null!==c)a=hg(a,c.timeoutMs|0||5E3,250);else switch(d){case 99:a=1073741823;break;case 98:a=hg(a,150,100);break;case 97:case 96:a=hg(a,5E3,250);break;case 95:a=2;break;default:throw Error(u(326));}null!==T&&a===U&&--a;return a}
function Ig(a,b){if(50<uj)throw uj=0,vj=null,Error(u(185));a=xj(a,b);if(null!==a){var c=ag();1073741823===b?(W&ej)!==V&&(W&(fj|gj))===V?yj(a):(Z(a),W===V&&gg()):Z(a);(W&4)===V||98!==c&&99!==c||(null===tj?tj=new Map([[a,b]]):(c=tj.get(a),(void 0===c||c>b)&&tj.set(a,b)))}}
function xj(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}null!==e&&(T===e&&(Bg(b),S===vi&&xi(e,U)),yi(e,b));return e}
function zj(a){var b=a.lastExpiredTime;if(0!==b)return b;b=a.firstPendingTime;if(!Aj(a,b))return b;var c=a.lastPingedTime;a=a.nextKnownPendingLevel;a=c>a?c:a;return 2>=a&&b!==a?0:a}
function Z(a){if(0!==a.lastExpiredTime)a.callbackExpirationTime=1073741823,a.callbackPriority=99,a.callbackNode=eg(yj.bind(null,a));else{var b=zj(a),c=a.callbackNode;if(0===b)null!==c&&(a.callbackNode=null,a.callbackExpirationTime=0,a.callbackPriority=90);else{var d=Gg();1073741823===b?d=99:1===b||2===b?d=95:(d=10*(1073741821-b)-10*(1073741821-d),d=0>=d?99:250>=d?98:5250>=d?97:95);if(null!==c){var e=a.callbackPriority;if(a.callbackExpirationTime===b&&e>=d)return;c!==Tf&&Kf(c)}a.callbackExpirationTime=
b;a.callbackPriority=d;b=1073741823===b?eg(yj.bind(null,a)):dg(d,Bj.bind(null,a),{timeout:10*(1073741821-b)-$f()});a.callbackNode=b}}}
function Bj(a,b){wj=0;if(b)return b=Gg(),Cj(a,b),Z(a),null;var c=zj(a);if(0!==c){b=a.callbackNode;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&c===U||Ej(a,c);if(null!==X){var d=W;W|=fj;var e=Fj();do try{Gj();break}catch(h){Hj(a,h)}while(1);ng();W=d;cj.current=e;if(S===hj)throw b=kj,Ej(a,c),xi(a,c),Z(a),b;if(null===X)switch(e=a.finishedWork=a.current.alternate,a.finishedExpirationTime=c,d=S,T=null,d){case ti:case hj:throw Error(u(345));case ij:Cj(a,2<c?2:c);break;case ui:xi(a,c);d=a.lastSuspendedTime;
c===d&&(a.nextKnownPendingLevel=Ij(e));if(1073741823===lj&&(e=Ti+pj-$f(),10<e)){if(oj){var f=a.lastPingedTime;if(0===f||f>=c){a.lastPingedTime=c;Ej(a,c);break}}f=zj(a);if(0!==f&&f!==c)break;if(0!==d&&d!==c){a.lastPingedTime=d;break}a.timeoutHandle=Hd(Jj.bind(null,a),e);break}Jj(a);break;case vi:xi(a,c);d=a.lastSuspendedTime;c===d&&(a.nextKnownPendingLevel=Ij(e));if(oj&&(e=a.lastPingedTime,0===e||e>=c)){a.lastPingedTime=c;Ej(a,c);break}e=zj(a);if(0!==e&&e!==c)break;if(0!==d&&d!==c){a.lastPingedTime=
d;break}1073741823!==mj?d=10*(1073741821-mj)-$f():1073741823===lj?d=0:(d=10*(1073741821-lj)-5E3,e=$f(),c=10*(1073741821-c)-e,d=e-d,0>d&&(d=0),d=(120>d?120:480>d?480:1080>d?1080:1920>d?1920:3E3>d?3E3:4320>d?4320:1960*bj(d/1960))-d,c<d&&(d=c));if(10<d){a.timeoutHandle=Hd(Jj.bind(null,a),d);break}Jj(a);break;case jj:if(1073741823!==lj&&null!==nj){f=lj;var g=nj;d=g.busyMinDurationMs|0;0>=d?d=0:(e=g.busyDelayMs|0,f=$f()-(10*(1073741821-f)-(g.timeoutMs|0||5E3)),d=f<=e?0:e+d-f);if(10<d){xi(a,c);a.timeoutHandle=
Hd(Jj.bind(null,a),d);break}}Jj(a);break;default:throw Error(u(329));}Z(a);if(a.callbackNode===b)return Bj.bind(null,a)}}return null}
function yj(a){var b=a.lastExpiredTime;b=0!==b?b:1073741823;if((W&(fj|gj))!==V)throw Error(u(327));Dj();a===T&&b===U||Ej(a,b);if(null!==X){var c=W;W|=fj;var d=Fj();do try{Kj();break}catch(e){Hj(a,e)}while(1);ng();W=c;cj.current=d;if(S===hj)throw c=kj,Ej(a,b),xi(a,b),Z(a),c;if(null!==X)throw Error(u(261));a.finishedWork=a.current.alternate;a.finishedExpirationTime=b;T=null;Jj(a);Z(a)}return null}function Lj(){if(null!==tj){var a=tj;tj=null;a.forEach(function(a,c){Cj(c,a);Z(c)});gg()}}
function Mj(a,b){var c=W;W|=1;try{return a(b)}finally{W=c,W===V&&gg()}}function Nj(a,b){var c=W;W&=-2;W|=ej;try{return a(b)}finally{W=c,W===V&&gg()}}
function Ej(a,b){a.finishedWork=null;a.finishedExpirationTime=0;var c=a.timeoutHandle;-1!==c&&(a.timeoutHandle=-1,Id(c));if(null!==X)for(c=X.return;null!==c;){var d=c;switch(d.tag){case 1:d=d.type.childContextTypes;null!==d&&void 0!==d&&Df();break;case 3:eh();H(K);H(J);break;case 5:gh(d);break;case 4:eh();break;case 13:H(M);break;case 19:H(M);break;case 10:og(d)}c=c.return}T=a;X=Sg(a.current,null);U=b;S=ti;kj=null;mj=lj=1073741823;nj=null;wi=0;oj=!1}
function Hj(a,b){do{try{ng();jh.current=sh;if(mh)for(var c=N.memoizedState;null!==c;){var d=c.queue;null!==d&&(d.pending=null);c=c.next}lh=0;P=O=N=null;mh=!1;if(null===X||null===X.return)return S=hj,kj=b,X=null;a:{var e=a,f=X.return,g=X,h=b;b=U;g.effectTag|=2048;g.firstEffect=g.lastEffect=null;if(null!==h&&"object"===typeof h&&"function"===typeof h.then){var k=h;if(0===(g.mode&2)){var l=g.alternate;l?(g.updateQueue=l.updateQueue,g.memoizedState=l.memoizedState,g.expirationTime=l.expirationTime):(g.updateQueue=
null,g.memoizedState=null)}var m=0!==(M.current&1),p=f;do{var x;if(x=13===p.tag){var z=p.memoizedState;if(null!==z)x=null!==z.dehydrated?!0:!1;else{var ca=p.memoizedProps;x=void 0===ca.fallback?!1:!0!==ca.unstable_avoidThisFallback?!0:m?!1:!0}}if(x){var D=p.updateQueue;if(null===D){var t=new Set;t.add(k);p.updateQueue=t}else D.add(k);if(0===(p.mode&2)){p.effectTag|=64;g.effectTag&=-2981;if(1===g.tag)if(null===g.alternate)g.tag=17;else{var y=wg(1073741823,null);y.tag=2;xg(g,y)}g.expirationTime=1073741823;
break a}h=void 0;g=b;var A=e.pingCache;null===A?(A=e.pingCache=new Wi,h=new Set,A.set(k,h)):(h=A.get(k),void 0===h&&(h=new Set,A.set(k,h)));if(!h.has(g)){h.add(g);var q=Oj.bind(null,e,k,g);k.then(q,q)}p.effectTag|=4096;p.expirationTime=b;break a}p=p.return}while(null!==p);h=Error((pb(g.type)||"A React component")+" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+qb(g))}S!==
jj&&(S=ij);h=Ai(h,g);p=f;do{switch(p.tag){case 3:k=h;p.effectTag|=4096;p.expirationTime=b;var B=Xi(p,k,b);yg(p,B);break a;case 1:k=h;var w=p.type,ub=p.stateNode;if(0===(p.effectTag&64)&&("function"===typeof w.getDerivedStateFromError||null!==ub&&"function"===typeof ub.componentDidCatch&&(null===aj||!aj.has(ub)))){p.effectTag|=4096;p.expirationTime=b;var vb=$i(p,k,b);yg(p,vb);break a}}p=p.return}while(null!==p)}X=Pj(X)}catch(Xc){b=Xc;continue}break}while(1)}
function Fj(){var a=cj.current;cj.current=sh;return null===a?sh:a}function Ag(a,b){a<lj&&2<a&&(lj=a);null!==b&&a<mj&&2<a&&(mj=a,nj=b)}function Bg(a){a>wi&&(wi=a)}function Kj(){for(;null!==X;)X=Qj(X)}function Gj(){for(;null!==X&&!Uf();)X=Qj(X)}function Qj(a){var b=Rj(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=Pj(a));dj.current=null;return b}
function Pj(a){X=a;do{var b=X.alternate;a=X.return;if(0===(X.effectTag&2048)){b=si(b,X,U);if(1===U||1!==X.childExpirationTime){for(var c=0,d=X.child;null!==d;){var e=d.expirationTime,f=d.childExpirationTime;e>c&&(c=e);f>c&&(c=f);d=d.sibling}X.childExpirationTime=c}if(null!==b)return b;null!==a&&0===(a.effectTag&2048)&&(null===a.firstEffect&&(a.firstEffect=X.firstEffect),null!==X.lastEffect&&(null!==a.lastEffect&&(a.lastEffect.nextEffect=X.firstEffect),a.lastEffect=X.lastEffect),1<X.effectTag&&(null!==
a.lastEffect?a.lastEffect.nextEffect=X:a.firstEffect=X,a.lastEffect=X))}else{b=zi(X);if(null!==b)return b.effectTag&=2047,b;null!==a&&(a.firstEffect=a.lastEffect=null,a.effectTag|=2048)}b=X.sibling;if(null!==b)return b;X=a}while(null!==X);S===ti&&(S=jj);return null}function Ij(a){var b=a.expirationTime;a=a.childExpirationTime;return b>a?b:a}function Jj(a){var b=ag();cg(99,Sj.bind(null,a,b));return null}
function Sj(a,b){do Dj();while(null!==rj);if((W&(fj|gj))!==V)throw Error(u(327));var c=a.finishedWork,d=a.finishedExpirationTime;if(null===c)return null;a.finishedWork=null;a.finishedExpirationTime=0;if(c===a.current)throw Error(u(177));a.callbackNode=null;a.callbackExpirationTime=0;a.callbackPriority=90;a.nextKnownPendingLevel=0;var e=Ij(c);a.firstPendingTime=e;d<=a.lastSuspendedTime?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:d<=a.firstSuspendedTime&&(a.firstSuspendedTime=
d-1);d<=a.lastPingedTime&&(a.lastPingedTime=0);d<=a.lastExpiredTime&&(a.lastExpiredTime=0);a===T&&(X=T=null,U=0);1<c.effectTag?null!==c.lastEffect?(c.lastEffect.nextEffect=c,e=c.firstEffect):e=c:e=c.firstEffect;if(null!==e){var f=W;W|=gj;dj.current=null;Dd=fd;var g=xd();if(yd(g)){if("selectionStart"in g)var h={start:g.selectionStart,end:g.selectionEnd};else a:{h=(h=g.ownerDocument)&&h.defaultView||window;var k=h.getSelection&&h.getSelection();if(k&&0!==k.rangeCount){h=k.anchorNode;var l=k.anchorOffset,
m=k.focusNode;k=k.focusOffset;try{h.nodeType,m.nodeType}catch(wb){h=null;break a}var p=0,x=-1,z=-1,ca=0,D=0,t=g,y=null;b:for(;;){for(var A;;){t!==h||0!==l&&3!==t.nodeType||(x=p+l);t!==m||0!==k&&3!==t.nodeType||(z=p+k);3===t.nodeType&&(p+=t.nodeValue.length);if(null===(A=t.firstChild))break;y=t;t=A}for(;;){if(t===g)break b;y===h&&++ca===l&&(x=p);y===m&&++D===k&&(z=p);if(null!==(A=t.nextSibling))break;t=y;y=t.parentNode}t=A}h=-1===x||-1===z?null:{start:x,end:z}}else h=null}h=h||{start:0,end:0}}else h=
null;Ed={activeElementDetached:null,focusedElem:g,selectionRange:h};fd=!1;Y=e;do try{Tj()}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=e;do try{for(g=a,h=b;null!==Y;){var q=Y.effectTag;q&16&&Rb(Y.stateNode,"");if(q&128){var B=Y.alternate;if(null!==B){var w=B.ref;null!==w&&("function"===typeof w?w(null):w.current=null)}}switch(q&1038){case 2:Pi(Y);Y.effectTag&=-3;break;case 6:Pi(Y);Y.effectTag&=-3;Si(Y.alternate,Y);break;case 1024:Y.effectTag&=-1025;break;case 1028:Y.effectTag&=
-1025;Si(Y.alternate,Y);break;case 4:Si(Y.alternate,Y);break;case 8:l=Y,Mi(g,l,h),Ni(l)}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);w=Ed;B=xd();q=w.focusedElem;h=w.selectionRange;if(B!==q&&q&&q.ownerDocument&&wd(q.ownerDocument.documentElement,q)){null!==h&&yd(q)&&(B=h.start,w=h.end,void 0===w&&(w=B),"selectionStart"in q?(q.selectionStart=B,q.selectionEnd=Math.min(w,q.value.length)):(w=(B=q.ownerDocument||document)&&B.defaultView||window,w.getSelection&&
(w=w.getSelection(),l=q.textContent.length,g=Math.min(h.start,l),h=void 0===h.end?g:Math.min(h.end,l),!w.extend&&g>h&&(l=h,h=g,g=l),l=vd(q,g),m=vd(q,h),l&&m&&(1!==w.rangeCount||w.anchorNode!==l.node||w.anchorOffset!==l.offset||w.focusNode!==m.node||w.focusOffset!==m.offset)&&(B=B.createRange(),B.setStart(l.node,l.offset),w.removeAllRanges(),g>h?(w.addRange(B),w.extend(m.node,m.offset)):(B.setEnd(m.node,m.offset),w.addRange(B))))));B=[];for(w=q;w=w.parentNode;)1===w.nodeType&&B.push({element:w,left:w.scrollLeft,
top:w.scrollTop});"function"===typeof q.focus&&q.focus();for(q=0;q<B.length;q++)w=B[q],w.element.scrollLeft=w.left,w.element.scrollTop=w.top}fd=!!Dd;Ed=Dd=null;a.current=c;Y=e;do try{for(q=a;null!==Y;){var ub=Y.effectTag;ub&36&&Ji(q,Y.alternate,Y);if(ub&128){B=void 0;var vb=Y.ref;if(null!==vb){var Xc=Y.stateNode;switch(Y.tag){case 5:B=Xc;break;default:B=Xc}"function"===typeof vb?vb(B):vb.current=B}}Y=Y.nextEffect}}catch(wb){if(null===Y)throw Error(u(330));Ei(Y,wb);Y=Y.nextEffect}while(null!==Y);Y=
null;Vf();W=f}else a.current=c;if(qj)qj=!1,rj=a,sj=b;else for(Y=e;null!==Y;)b=Y.nextEffect,Y.nextEffect=null,Y=b;b=a.firstPendingTime;0===b&&(aj=null);1073741823===b?a===vj?uj++:(uj=0,vj=a):uj=0;"function"===typeof Uj&&Uj(c.stateNode,d);Z(a);if(Yi)throw Yi=!1,a=Zi,Zi=null,a;if((W&ej)!==V)return null;gg();return null}function Tj(){for(;null!==Y;){var a=Y.effectTag;0!==(a&256)&&Gi(Y.alternate,Y);0===(a&512)||qj||(qj=!0,dg(97,function(){Dj();return null}));Y=Y.nextEffect}}
function Dj(){if(90!==sj){var a=97<sj?97:sj;sj=90;return cg(a,Vj)}}function Vj(){if(null===rj)return!1;var a=rj;rj=null;if((W&(fj|gj))!==V)throw Error(u(331));var b=W;W|=gj;for(a=a.current.firstEffect;null!==a;){try{var c=a;if(0!==(c.effectTag&512))switch(c.tag){case 0:case 11:case 15:case 22:Hi(5,c),Ii(5,c)}}catch(d){if(null===a)throw Error(u(330));Ei(a,d)}c=a.nextEffect;a.nextEffect=null;a=c}W=b;gg();return!0}
function Wj(a,b,c){b=Ai(c,b);b=Xi(a,b,1073741823);xg(a,b);a=xj(a,1073741823);null!==a&&Z(a)}function Ei(a,b){if(3===a.tag)Wj(a,a,b);else for(var c=a.return;null!==c;){if(3===c.tag){Wj(c,a,b);break}else if(1===c.tag){var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===aj||!aj.has(d))){a=Ai(b,a);a=$i(c,a,1073741823);xg(c,a);c=xj(c,1073741823);null!==c&&Z(c);break}}c=c.return}}
function Oj(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);T===a&&U===c?S===vi||S===ui&&1073741823===lj&&$f()-Ti<pj?Ej(a,U):oj=!0:Aj(a,c)&&(b=a.lastPingedTime,0!==b&&b<c||(a.lastPingedTime=c,Z(a)))}function Vi(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=0;0===b&&(b=Gg(),b=Hg(b,a,null));a=xj(a,b);null!==a&&Z(a)}var Rj;
Rj=function(a,b,c){var d=b.expirationTime;if(null!==a){var e=b.pendingProps;if(a.memoizedProps!==e||K.current)rg=!0;else{if(d<c){rg=!1;switch(b.tag){case 3:hi(b);Xh();break;case 5:fh(b);if(b.mode&4&&1!==c&&e.hidden)return b.expirationTime=b.childExpirationTime=1,null;break;case 1:L(b.type)&&Gf(b);break;case 4:dh(b,b.stateNode.containerInfo);break;case 10:d=b.memoizedProps.value;e=b.type._context;I(jg,e._currentValue);e._currentValue=d;break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;
if(0!==d&&d>=c)return ji(a,b,c);I(M,M.current&1);b=$h(a,b,c);return null!==b?b.sibling:null}I(M,M.current&1);break;case 19:d=b.childExpirationTime>=c;if(0!==(a.effectTag&64)){if(d)return mi(a,b,c);b.effectTag|=64}e=b.memoizedState;null!==e&&(e.rendering=null,e.tail=null);I(M,M.current);if(!d)return null}return $h(a,b,c)}rg=!1}}else rg=!1;b.expirationTime=0;switch(b.tag){case 2:d=b.type;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;e=Cf(b,J.current);qg(b,c);e=oh(null,
b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;b.memoizedState=null;b.updateQueue=null;if(L(d)){var f=!0;Gf(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;ug(b);var g=d.getDerivedStateFromProps;"function"===typeof g&&Fg(b,d,g,a);e.updater=Jg;b.stateNode=e;e._reactInternalFiber=b;Ng(b,d,a,c);b=gi(null,b,d,!0,f,c)}else b.tag=0,R(null,b,e,c),b=b.child;return b;case 16:a:{e=b.elementType;null!==a&&(a.alternate=
null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;ob(e);if(1!==e._status)throw e._result;e=e._result;b.type=e;f=b.tag=Xj(e);a=ig(e,a);switch(f){case 0:b=di(null,b,e,a,c);break a;case 1:b=fi(null,b,e,a,c);break a;case 11:b=Zh(null,b,e,a,c);break a;case 14:b=ai(null,b,e,ig(e.type,a),d,c);break a}throw Error(u(306,e,""));}return b;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),di(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),fi(a,b,d,e,c);
case 3:hi(b);d=b.updateQueue;if(null===a||null===d)throw Error(u(282));d=b.pendingProps;e=b.memoizedState;e=null!==e?e.element:null;vg(a,b);zg(b,d,null,c);d=b.memoizedState.element;if(d===e)Xh(),b=$h(a,b,c);else{if(e=b.stateNode.hydrate)Ph=Jd(b.stateNode.containerInfo.firstChild),Oh=b,e=Qh=!0;if(e)for(c=Yg(b,null,d,c),b.child=c;c;)c.effectTag=c.effectTag&-3|1024,c=c.sibling;else R(a,b,d,c),Xh();b=b.child}return b;case 5:return fh(b),null===a&&Uh(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:
null,g=e.children,Gd(d,e)?g=null:null!==f&&Gd(d,f)&&(b.effectTag|=16),ei(a,b),b.mode&4&&1!==c&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(R(a,b,g,c),b=b.child),b;case 6:return null===a&&Uh(b),null;case 13:return ji(a,b,c);case 4:return dh(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=Xg(b,null,d,c):R(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),Zh(a,b,d,e,c);case 7:return R(a,b,b.pendingProps,c),b.child;case 8:return R(a,
b,b.pendingProps.children,c),b.child;case 12:return R(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;var h=b.type._context;I(jg,h._currentValue);h._currentValue=f;if(null!==g)if(h=g.value,f=$e(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0,0===f){if(g.children===e.children&&!K.current){b=$h(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var k=h.dependencies;if(null!==
k){g=h.child;for(var l=k.firstContext;null!==l;){if(l.context===d&&0!==(l.observedBits&f)){1===h.tag&&(l=wg(c,null),l.tag=2,xg(h,l));h.expirationTime<c&&(h.expirationTime=c);l=h.alternate;null!==l&&l.expirationTime<c&&(l.expirationTime=c);pg(h.return,c);k.expirationTime<c&&(k.expirationTime=c);break}l=l.next}}else g=10===h.tag?h.type===b.type?null:h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=
g}R(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,qg(b,c),e=sg(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,R(a,b,d,c),b.child;case 14:return e=b.type,f=ig(e,b.pendingProps),f=ig(e.type,f),ai(a,b,e,f,d,c);case 15:return ci(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:ig(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,L(d)?(a=!0,Gf(b)):a=!1,qg(b,c),Lg(b,d,e),Ng(b,d,e,c),gi(null,
b,d,!0,a,c);case 19:return mi(a,b,c)}throw Error(u(156,b.tag));};var Uj=null,Li=null;function Yj(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Uj=function(a){try{b.onCommitFiberRoot(c,a,void 0,64===(a.current.effectTag&64))}catch(e){}};Li=function(a){try{b.onCommitFiberUnmount(c,a)}catch(e){}}}catch(d){}return!0}
function Zj(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.dependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function Sh(a,b,c,d){return new Zj(a,b,c,d)}
function bi(a){a=a.prototype;return!(!a||!a.isReactComponent)}function Xj(a){if("function"===typeof a)return bi(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gb)return 11;if(a===jb)return 14}return 2}
function Sg(a,b){var c=a.alternate;null===c?(c=Sh(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;b=a.dependencies;c.dependencies=null===b?null:{expirationTime:b.expirationTime,
firstContext:b.firstContext,responders:b.responders};c.sibling=a.sibling;c.index=a.index;c.ref=a.ref;return c}
function Ug(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)bi(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ab:return Wg(c.children,e,f,b);case fb:g=8;e|=7;break;case bb:g=8;e|=1;break;case cb:return a=Sh(12,c,b,e|8),a.elementType=cb,a.type=cb,a.expirationTime=f,a;case hb:return a=Sh(13,c,b,e),a.type=hb,a.elementType=hb,a.expirationTime=f,a;case ib:return a=Sh(19,c,b,e),a.elementType=ib,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case db:g=
10;break a;case eb:g=9;break a;case gb:g=11;break a;case jb:g=14;break a;case kb:g=16;d=null;break a;case lb:g=22;break a}throw Error(u(130,null==a?a:typeof a,""));}b=Sh(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function Wg(a,b,c,d){a=Sh(7,a,d,b);a.expirationTime=c;return a}function Tg(a,b,c){a=Sh(6,a,null,b);a.expirationTime=c;return a}
function Vg(a,b,c){b=Sh(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}
function ak(a,b,c){this.tag=b;this.current=null;this.containerInfo=a;this.pingCache=this.pendingChildren=null;this.finishedExpirationTime=0;this.finishedWork=null;this.timeoutHandle=-1;this.pendingContext=this.context=null;this.hydrate=c;this.callbackNode=null;this.callbackPriority=90;this.lastExpiredTime=this.lastPingedTime=this.nextKnownPendingLevel=this.lastSuspendedTime=this.firstSuspendedTime=this.firstPendingTime=0}
function Aj(a,b){var c=a.firstSuspendedTime;a=a.lastSuspendedTime;return 0!==c&&c>=b&&a<=b}function xi(a,b){var c=a.firstSuspendedTime,d=a.lastSuspendedTime;c<b&&(a.firstSuspendedTime=b);if(d>b||0===c)a.lastSuspendedTime=b;b<=a.lastPingedTime&&(a.lastPingedTime=0);b<=a.lastExpiredTime&&(a.lastExpiredTime=0)}
function yi(a,b){b>a.firstPendingTime&&(a.firstPendingTime=b);var c=a.firstSuspendedTime;0!==c&&(b>=c?a.firstSuspendedTime=a.lastSuspendedTime=a.nextKnownPendingLevel=0:b>=a.lastSuspendedTime&&(a.lastSuspendedTime=b+1),b>a.nextKnownPendingLevel&&(a.nextKnownPendingLevel=b))}function Cj(a,b){var c=a.lastExpiredTime;if(0===c||c>b)a.lastExpiredTime=b}
function bk(a,b,c,d){var e=b.current,f=Gg(),g=Dg.suspense;f=Hg(f,e,g);a:if(c){c=c._reactInternalFiber;b:{if(dc(c)!==c||1!==c.tag)throw Error(u(170));var h=c;do{switch(h.tag){case 3:h=h.stateNode.context;break b;case 1:if(L(h.type)){h=h.stateNode.__reactInternalMemoizedMergedChildContext;break b}}h=h.return}while(null!==h);throw Error(u(171));}if(1===c.tag){var k=c.type;if(L(k)){c=Ff(c,k,h);break a}}c=h}else c=Af;null===b.context?b.context=c:b.pendingContext=c;b=wg(f,g);b.payload={element:a};d=void 0===
d?null:d;null!==d&&(b.callback=d);xg(e,b);Ig(e,f);return f}function ck(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function dk(a,b){a=a.memoizedState;null!==a&&null!==a.dehydrated&&a.retryTime<b&&(a.retryTime=b)}function ek(a,b){dk(a,b);(a=a.alternate)&&dk(a,b)}
function fk(a,b,c){c=null!=c&&!0===c.hydrate;var d=new ak(a,b,c),e=Sh(3,null,null,2===b?7:1===b?3:0);d.current=e;e.stateNode=d;ug(e);a[Od]=d.current;c&&0!==b&&Jc(a,9===a.nodeType?a:a.ownerDocument);this._internalRoot=d}fk.prototype.render=function(a){bk(a,this._internalRoot,null,null)};fk.prototype.unmount=function(){var a=this._internalRoot,b=a.containerInfo;bk(null,a,null,function(){b[Od]=null})};
function gk(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}function hk(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new fk(a,0,b?{hydrate:!0}:void 0)}
function ik(a,b,c,d,e){var f=c._reactRootContainer;if(f){var g=f._internalRoot;if("function"===typeof e){var h=e;e=function(){var a=ck(g);h.call(a)}}bk(b,g,a,e)}else{f=c._reactRootContainer=hk(c,d);g=f._internalRoot;if("function"===typeof e){var k=e;e=function(){var a=ck(g);k.call(a)}}Nj(function(){bk(b,g,a,e)})}return ck(g)}function jk(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$a,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
wc=function(a){if(13===a.tag){var b=hg(Gg(),150,100);Ig(a,b);ek(a,b)}};xc=function(a){13===a.tag&&(Ig(a,3),ek(a,3))};yc=function(a){if(13===a.tag){var b=Gg();b=Hg(b,a,null);Ig(a,b);ek(a,b)}};
za=function(a,b,c){switch(b){case "input":Cb(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Qd(d);if(!e)throw Error(u(90));yb(d);Cb(d,e)}}}break;case "textarea":Kb(a,c);break;case "select":b=c.value,null!=b&&Hb(a,!!c.multiple,b,!1)}};Fa=Mj;
Ga=function(a,b,c,d,e){var f=W;W|=4;try{return cg(98,a.bind(null,b,c,d,e))}finally{W=f,W===V&&gg()}};Ha=function(){(W&(1|fj|gj))===V&&(Lj(),Dj())};Ia=function(a,b){var c=W;W|=2;try{return a(b)}finally{W=c,W===V&&gg()}};function kk(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;if(!gk(b))throw Error(u(200));return jk(a,b,null,c)}var lk={Events:[Nc,Pd,Qd,xa,ta,Xd,function(a){jc(a,Wd)},Da,Ea,id,mc,Dj,{current:!1}]};
(function(a){var b=a.findFiberByHostInstance;return Yj(n({},a,{overrideHookState:null,overrideProps:null,setSuspenseHandler:null,scheduleUpdate:null,currentDispatcherRef:Wa.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=hc(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null},findHostInstancesForRefresh:null,scheduleRefresh:null,scheduleRoot:null,setRefreshHandler:null,getCurrentFiber:null}))})({findFiberByHostInstance:tc,bundleType:0,version:"16.14.0",
rendererPackageName:"react-dom"});exports.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED=lk;exports.createPortal=kk;exports.findDOMNode=function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;if(void 0===b){if("function"===typeof a.render)throw Error(u(188));throw Error(u(268,Object.keys(a)));}a=hc(b);a=null===a?null:a.stateNode;return a};
exports.flushSync=function(a,b){if((W&(fj|gj))!==V)throw Error(u(187));var c=W;W|=1;try{return cg(99,a.bind(null,b))}finally{W=c,gg()}};exports.hydrate=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!0,c)};exports.render=function(a,b,c){if(!gk(b))throw Error(u(200));return ik(null,a,b,!1,c)};
exports.unmountComponentAtNode=function(a){if(!gk(a))throw Error(u(40));return a._reactRootContainer?(Nj(function(){ik(null,null,a,!1,function(){a._reactRootContainer=null;a[Od]=null})}),!0):!1};exports.unstable_batchedUpdates=Mj;exports.unstable_createPortal=function(a,b){return kk(a,b,2<arguments.length&&void 0!==arguments[2]?arguments[2]:null)};
exports.unstable_renderSubtreeIntoContainer=function(a,b,c,d){if(!gk(c))throw Error(u(200));if(null==a||void 0===a._reactInternalFiber)throw Error(u(38));return ik(a,b,c,!1,d)};exports.version="16.14.0";


/***/ }),
/* 386 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


if (true) {
  module.exports = __webpack_require__(387);
} else {
  module.exports = require('./cjs/scheduler.development.js');
}


/***/ }),
/* 387 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v0.19.1
 * scheduler.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var f,g,h,k,l;
if("undefined"===typeof window||"function"!==typeof MessageChannel){var p=null,q=null,t=function(){if(null!==p)try{var a=exports.unstable_now();p(!0,a);p=null}catch(b){throw setTimeout(t,0),b;}},u=Date.now();exports.unstable_now=function(){return Date.now()-u};f=function(a){null!==p?setTimeout(f,0,a):(p=a,setTimeout(t,0))};g=function(a,b){q=setTimeout(a,b)};h=function(){clearTimeout(q)};k=function(){return!1};l=exports.unstable_forceFrameRate=function(){}}else{var w=window.performance,x=window.Date,
y=window.setTimeout,z=window.clearTimeout;if("undefined"!==typeof console){var A=window.cancelAnimationFrame;"function"!==typeof window.requestAnimationFrame&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills");"function"!==typeof A&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills")}if("object"===
typeof w&&"function"===typeof w.now)exports.unstable_now=function(){return w.now()};else{var B=x.now();exports.unstable_now=function(){return x.now()-B}}var C=!1,D=null,E=-1,F=5,G=0;k=function(){return exports.unstable_now()>=G};l=function(){};exports.unstable_forceFrameRate=function(a){0>a||125<a?console.error("forceFrameRate takes a positive int between 0 and 125, forcing framerates higher than 125 fps is not unsupported"):F=0<a?Math.floor(1E3/a):5};var H=new MessageChannel,I=H.port2;H.port1.onmessage=
function(){if(null!==D){var a=exports.unstable_now();G=a+F;try{D(!0,a)?I.postMessage(null):(C=!1,D=null)}catch(b){throw I.postMessage(null),b;}}else C=!1};f=function(a){D=a;C||(C=!0,I.postMessage(null))};g=function(a,b){E=y(function(){a(exports.unstable_now())},b)};h=function(){z(E);E=-1}}function J(a,b){var c=a.length;a.push(b);a:for(;;){var d=c-1>>>1,e=a[d];if(void 0!==e&&0<K(e,b))a[d]=b,a[c]=e,c=d;else break a}}function L(a){a=a[0];return void 0===a?null:a}
function M(a){var b=a[0];if(void 0!==b){var c=a.pop();if(c!==b){a[0]=c;a:for(var d=0,e=a.length;d<e;){var m=2*(d+1)-1,n=a[m],v=m+1,r=a[v];if(void 0!==n&&0>K(n,c))void 0!==r&&0>K(r,n)?(a[d]=r,a[v]=c,d=v):(a[d]=n,a[m]=c,d=m);else if(void 0!==r&&0>K(r,c))a[d]=r,a[v]=c,d=v;else break a}}return b}return null}function K(a,b){var c=a.sortIndex-b.sortIndex;return 0!==c?c:a.id-b.id}var N=[],O=[],P=1,Q=null,R=3,S=!1,T=!1,U=!1;
function V(a){for(var b=L(O);null!==b;){if(null===b.callback)M(O);else if(b.startTime<=a)M(O),b.sortIndex=b.expirationTime,J(N,b);else break;b=L(O)}}function W(a){U=!1;V(a);if(!T)if(null!==L(N))T=!0,f(X);else{var b=L(O);null!==b&&g(W,b.startTime-a)}}
function X(a,b){T=!1;U&&(U=!1,h());S=!0;var c=R;try{V(b);for(Q=L(N);null!==Q&&(!(Q.expirationTime>b)||a&&!k());){var d=Q.callback;if(null!==d){Q.callback=null;R=Q.priorityLevel;var e=d(Q.expirationTime<=b);b=exports.unstable_now();"function"===typeof e?Q.callback=e:Q===L(N)&&M(N);V(b)}else M(N);Q=L(N)}if(null!==Q)var m=!0;else{var n=L(O);null!==n&&g(W,n.startTime-b);m=!1}return m}finally{Q=null,R=c,S=!1}}
function Y(a){switch(a){case 1:return-1;case 2:return 250;case 5:return 1073741823;case 4:return 1E4;default:return 5E3}}var Z=l;exports.unstable_IdlePriority=5;exports.unstable_ImmediatePriority=1;exports.unstable_LowPriority=4;exports.unstable_NormalPriority=3;exports.unstable_Profiling=null;exports.unstable_UserBlockingPriority=2;exports.unstable_cancelCallback=function(a){a.callback=null};exports.unstable_continueExecution=function(){T||S||(T=!0,f(X))};
exports.unstable_getCurrentPriorityLevel=function(){return R};exports.unstable_getFirstCallbackNode=function(){return L(N)};exports.unstable_next=function(a){switch(R){case 1:case 2:case 3:var b=3;break;default:b=R}var c=R;R=b;try{return a()}finally{R=c}};exports.unstable_pauseExecution=function(){};exports.unstable_requestPaint=Z;exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=R;R=a;try{return b()}finally{R=c}};
exports.unstable_scheduleCallback=function(a,b,c){var d=exports.unstable_now();if("object"===typeof c&&null!==c){var e=c.delay;e="number"===typeof e&&0<e?d+e:d;c="number"===typeof c.timeout?c.timeout:Y(a)}else c=Y(a),e=d;c=e+c;a={id:P++,callback:b,priorityLevel:a,startTime:e,expirationTime:c,sortIndex:-1};e>d?(a.sortIndex=e,J(O,a),null===L(N)&&a===L(O)&&(U?h():U=!0,g(W,e-d))):(a.sortIndex=c,J(N,a),T||S||(T=!0,f(X)));return a};
exports.unstable_shouldYield=function(){var a=exports.unstable_now();V(a);var b=L(N);return b!==Q&&null!==Q&&null!==b&&null!==b.callback&&b.startTime<=a&&b.expirationTime<Q.expirationTime||k()};exports.unstable_wrapCallback=function(a){var b=R;return function(){var c=R;R=b;try{return a.apply(this,arguments)}finally{R=c}}};


/***/ }),
/* 388 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createProvider */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__ = __webpack_require__(215);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__utils_warning__ = __webpack_require__(142);





var prefixUnsafeLifecycleMethods = typeof __WEBPACK_IMPORTED_MODULE_1_react___default.a.forwardRef !== "undefined";
var didWarnAboutReceivingStore = false;

function warnAboutReceivingStore() {
  if (didWarnAboutReceivingStore) {
    return;
  }

  didWarnAboutReceivingStore = true;
  Object(__WEBPACK_IMPORTED_MODULE_4__utils_warning__["a" /* default */])('<Provider> does not support changing `store` on the fly. ' + 'It is most likely that you see this error because you updated to ' + 'Redux 2.x and React Redux 2.x which no longer hot reload reducers ' + 'automatically. See https://github.com/reduxjs/react-redux/releases/' + 'tag/v2.0.0 for the migration instructions.');
}

function createProvider(storeKey) {
  var _Provider$childContex;

  if (storeKey === void 0) {
    storeKey = 'store';
  }

  var subscriptionKey = storeKey + "Subscription";

  var Provider =
  /*#__PURE__*/
  function (_Component) {
    Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Provider, _Component);

    var _proto = Provider.prototype;

    _proto.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[storeKey] = this[storeKey], _ref[subscriptionKey] = null, _ref;
    };

    function Provider(props, context) {
      var _this;

      _this = _Component.call(this, props, context) || this;
      _this[storeKey] = props.store;
      return _this;
    }

    _proto.render = function render() {
      return __WEBPACK_IMPORTED_MODULE_1_react__["Children"].only(this.props.children);
    };

    return Provider;
  }(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]);

  if (false) {
    // Use UNSAFE_ event name where supported
    var eventName = prefixUnsafeLifecycleMethods ? 'UNSAFE_componentWillReceiveProps' : 'componentWillReceiveProps';

    Provider.prototype[eventName] = function (nextProps) {
      if (this[storeKey] !== nextProps.store) {
        warnAboutReceivingStore();
      }
    };
  }

  Provider.propTypes = {
    store: __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired,
    children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.element.isRequired
  };
  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[storeKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["a" /* storeShape */].isRequired, _Provider$childContex[subscriptionKey] = __WEBPACK_IMPORTED_MODULE_3__utils_PropTypes__["b" /* subscriptionShape */], _Provider$childContex);
  return Provider;
}
/* harmony default export */ __webpack_exports__["a"] = (createProvider());

/***/ }),
/* 389 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _setPrototypeOf;
function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };
  return _setPrototypeOf(o, p);
}

/***/ }),
/* 390 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = __webpack_require__(214);

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 391 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _assertThisInitialized;
function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }
  return self;
}

/***/ }),
/* 392 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(50);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 393 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?
Symbol.for("react.suspense_list"):60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.block"):60121,w=b?Symbol.for("react.fundamental"):60117,x=b?Symbol.for("react.responder"):60118,y=b?Symbol.for("react.scope"):60119;
function z(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function A(a){return z(a)===m}exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;
exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;exports.isAsyncMode=function(a){return A(a)||z(a)===l};exports.isConcurrentMode=A;exports.isContextConsumer=function(a){return z(a)===k};exports.isContextProvider=function(a){return z(a)===h};exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return z(a)===n};exports.isFragment=function(a){return z(a)===e};exports.isLazy=function(a){return z(a)===t};
exports.isMemo=function(a){return z(a)===r};exports.isPortal=function(a){return z(a)===d};exports.isProfiler=function(a){return z(a)===g};exports.isStrictMode=function(a){return z(a)===f};exports.isSuspense=function(a){return z(a)===p};
exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===w||a.$$typeof===x||a.$$typeof===y||a.$$typeof===v)};exports.typeOf=z;


/***/ }),
/* 394 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Subscription; });
// encapsulates the subscription logic for connecting a component to the redux store, as
// well as nesting subscriptions of descendant components, so that we can ensure the
// ancestor components re-render before descendants
var CLEARED = null;
var nullListeners = {
  notify: function notify() {}
};

function createListenerCollection() {
  // the current/next pattern is copied from redux's createStore code.
  // TODO: refactor+expose that code to be reusable here?
  var current = [];
  var next = [];
  return {
    clear: function clear() {
      next = CLEARED;
      current = CLEARED;
    },
    notify: function notify() {
      var listeners = current = next;

      for (var i = 0; i < listeners.length; i++) {
        listeners[i]();
      }
    },
    get: function get() {
      return next;
    },
    subscribe: function subscribe(listener) {
      var isSubscribed = true;
      if (next === current) next = current.slice();
      next.push(listener);
      return function unsubscribe() {
        if (!isSubscribed || current === CLEARED) return;
        isSubscribed = false;
        if (next === current) next = current.slice();
        next.splice(next.indexOf(listener), 1);
      };
    }
  };
}

var Subscription =
/*#__PURE__*/
function () {
  function Subscription(store, parentSub, onStateChange) {
    this.store = store;
    this.parentSub = parentSub;
    this.onStateChange = onStateChange;
    this.unsubscribe = null;
    this.listeners = nullListeners;
  }

  var _proto = Subscription.prototype;

  _proto.addNestedSub = function addNestedSub(listener) {
    this.trySubscribe();
    return this.listeners.subscribe(listener);
  };

  _proto.notifyNestedSubs = function notifyNestedSubs() {
    this.listeners.notify();
  };

  _proto.isSubscribed = function isSubscribed() {
    return Boolean(this.unsubscribe);
  };

  _proto.trySubscribe = function trySubscribe() {
    if (!this.unsubscribe) {
      this.unsubscribe = this.parentSub ? this.parentSub.addNestedSub(this.onStateChange) : this.store.subscribe(this.onStateChange);
      this.listeners = createListenerCollection();
    }
  };

  _proto.tryUnsubscribe = function tryUnsubscribe() {
    if (this.unsubscribe) {
      this.unsubscribe();
      this.unsubscribe = null;
      this.listeners.clear();
      this.listeners = nullListeners;
    }
  };

  return Subscription;
}();



/***/ }),
/* 395 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export createConnect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__ = __webpack_require__(216);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__ = __webpack_require__(396);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__ = __webpack_require__(397);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__ = __webpack_require__(403);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__mergeProps__ = __webpack_require__(404);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__selectorFactory__ = __webpack_require__(405);








/*
  connect is a facade over connectAdvanced. It turns its args into a compatible
  selectorFactory, which has the signature:

    (dispatch, options) => (nextState, nextOwnProps) => nextFinalProps
  
  connect passes its args to connectAdvanced as options, which will in turn pass them to
  selectorFactory each time a Connect component instance is instantiated or hot reloaded.

  selectorFactory returns a final props selector from its mapStateToProps,
  mapStateToPropsFactories, mapDispatchToProps, mapDispatchToPropsFactories, mergeProps,
  mergePropsFactories, and pure args.

  The resulting final props selector is called by the Connect component instance whenever
  it receives new props or store state.
 */

function match(arg, factories, name) {
  for (var i = factories.length - 1; i >= 0; i--) {
    var result = factories[i](arg);
    if (result) return result;
  }

  return function (dispatch, options) {
    throw new Error("Invalid value of type " + typeof arg + " for " + name + " argument when connecting component " + options.wrappedComponentName + ".");
  };
}

function strictEqual(a, b) {
  return a === b;
} // createConnect with default args builds the 'official' connect behavior. Calling it with
// different options opens up some testing and extensibility scenarios


function createConnect(_temp) {
  var _ref = _temp === void 0 ? {} : _temp,
      _ref$connectHOC = _ref.connectHOC,
      connectHOC = _ref$connectHOC === void 0 ? __WEBPACK_IMPORTED_MODULE_2__components_connectAdvanced__["a" /* default */] : _ref$connectHOC,
      _ref$mapStateToPropsF = _ref.mapStateToPropsFactories,
      mapStateToPropsFactories = _ref$mapStateToPropsF === void 0 ? __WEBPACK_IMPORTED_MODULE_5__mapStateToProps__["a" /* default */] : _ref$mapStateToPropsF,
      _ref$mapDispatchToPro = _ref.mapDispatchToPropsFactories,
      mapDispatchToPropsFactories = _ref$mapDispatchToPro === void 0 ? __WEBPACK_IMPORTED_MODULE_4__mapDispatchToProps__["a" /* default */] : _ref$mapDispatchToPro,
      _ref$mergePropsFactor = _ref.mergePropsFactories,
      mergePropsFactories = _ref$mergePropsFactor === void 0 ? __WEBPACK_IMPORTED_MODULE_6__mergeProps__["a" /* default */] : _ref$mergePropsFactor,
      _ref$selectorFactory = _ref.selectorFactory,
      selectorFactory = _ref$selectorFactory === void 0 ? __WEBPACK_IMPORTED_MODULE_7__selectorFactory__["a" /* default */] : _ref$selectorFactory;

  return function connect(mapStateToProps, mapDispatchToProps, mergeProps, _ref2) {
    if (_ref2 === void 0) {
      _ref2 = {};
    }

    var _ref3 = _ref2,
        _ref3$pure = _ref3.pure,
        pure = _ref3$pure === void 0 ? true : _ref3$pure,
        _ref3$areStatesEqual = _ref3.areStatesEqual,
        areStatesEqual = _ref3$areStatesEqual === void 0 ? strictEqual : _ref3$areStatesEqual,
        _ref3$areOwnPropsEqua = _ref3.areOwnPropsEqual,
        areOwnPropsEqual = _ref3$areOwnPropsEqua === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areOwnPropsEqua,
        _ref3$areStatePropsEq = _ref3.areStatePropsEqual,
        areStatePropsEqual = _ref3$areStatePropsEq === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areStatePropsEq,
        _ref3$areMergedPropsE = _ref3.areMergedPropsEqual,
        areMergedPropsEqual = _ref3$areMergedPropsE === void 0 ? __WEBPACK_IMPORTED_MODULE_3__utils_shallowEqual__["a" /* default */] : _ref3$areMergedPropsE,
        extraOptions = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, ["pure", "areStatesEqual", "areOwnPropsEqual", "areStatePropsEqual", "areMergedPropsEqual"]);

    var initMapStateToProps = match(mapStateToProps, mapStateToPropsFactories, 'mapStateToProps');
    var initMapDispatchToProps = match(mapDispatchToProps, mapDispatchToPropsFactories, 'mapDispatchToProps');
    var initMergeProps = match(mergeProps, mergePropsFactories, 'mergeProps');
    return connectHOC(selectorFactory, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      // used in error messages
      methodName: 'connect',
      // used to compute Connect's displayName from the wrapped component's displayName.
      getDisplayName: function getDisplayName(name) {
        return "Connect(" + name + ")";
      },
      // if mapStateToProps is falsy, the Connect component doesn't subscribe to store state changes
      shouldHandleStateChanges: Boolean(mapStateToProps),
      // passed through to selectorFactory
      initMapStateToProps: initMapStateToProps,
      initMapDispatchToProps: initMapDispatchToProps,
      initMergeProps: initMergeProps,
      pure: pure,
      areStatesEqual: areStatesEqual,
      areOwnPropsEqual: areOwnPropsEqual,
      areStatePropsEqual: areStatePropsEqual,
      areMergedPropsEqual: areMergedPropsEqual
    }, extraOptions));
  };
}
/* harmony default export */ __webpack_exports__["a"] = (createConnect());

/***/ }),
/* 396 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = shallowEqual;
var hasOwn = Object.prototype.hasOwnProperty;

function is(x, y) {
  if (x === y) {
    return x !== 0 || y !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function shallowEqual(objA, objB) {
  if (is(objA, objB)) return true;

  if (typeof objA !== 'object' || objA === null || typeof objB !== 'object' || objB === null) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);
  if (keysA.length !== keysB.length) return false;

  for (var i = 0; i < keysA.length; i++) {
    if (!hasOwn.call(objB, keysA[i]) || !is(objA[keysA[i]], objB[keysA[i]])) {
      return false;
    }
  }

  return true;
}

/***/ }),
/* 397 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapDispatchToPropsIsFunction */
/* unused harmony export whenMapDispatchToPropsIsMissing */
/* unused harmony export whenMapDispatchToPropsIsObject */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__ = __webpack_require__(218);


function whenMapDispatchToPropsIsFunction(mapDispatchToProps) {
  return typeof mapDispatchToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapDispatchToProps, 'mapDispatchToProps') : undefined;
}
function whenMapDispatchToPropsIsMissing(mapDispatchToProps) {
  return !mapDispatchToProps ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return {
      dispatch: dispatch
    };
  }) : undefined;
}
function whenMapDispatchToPropsIsObject(mapDispatchToProps) {
  return mapDispatchToProps && typeof mapDispatchToProps === 'object' ? Object(__WEBPACK_IMPORTED_MODULE_1__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function (dispatch) {
    return Object(__WEBPACK_IMPORTED_MODULE_0_redux__["bindActionCreators"])(mapDispatchToProps, dispatch);
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapDispatchToPropsIsFunction, whenMapDispatchToPropsIsMissing, whenMapDispatchToPropsIsObject]);

/***/ }),
/* 398 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _objectSpread2;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__defineProperty_js__ = __webpack_require__(399);

function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread2(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      Object(__WEBPACK_IMPORTED_MODULE_0__defineProperty_js__["a" /* default */])(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}

/***/ }),
/* 399 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = _defineProperty;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__ = __webpack_require__(400);

function _defineProperty(obj, key, value) {
  key = Object(__WEBPACK_IMPORTED_MODULE_0__toPropertyKey_js__["a" /* default */])(key);
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }
  return obj;
}

/***/ }),
/* 400 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toPropertyKey;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(217);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__ = __webpack_require__(401);


function toPropertyKey(t) {
  var i = Object(__WEBPACK_IMPORTED_MODULE_1__toPrimitive_js__["a" /* default */])(t, "string");
  return "symbol" == Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(i) ? i : String(i);
}

/***/ }),
/* 401 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = toPrimitive;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__typeof_js__ = __webpack_require__(217);

function toPrimitive(t, r) {
  if ("object" != Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != Object(__WEBPACK_IMPORTED_MODULE_0__typeof_js__["a" /* default */])(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

/***/ }),
/* 402 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["a"] = isPlainObject;
/**
 * @param {any} obj The object to inspect.
 * @returns {boolean} True if the argument appears to be a plain object.
 */
function isPlainObject(obj) {
  if (typeof obj !== 'object' || obj === null) return false;
  var proto = Object.getPrototypeOf(obj);
  if (proto === null) return true;
  var baseProto = proto;

  while (Object.getPrototypeOf(baseProto) !== null) {
    baseProto = Object.getPrototypeOf(baseProto);
  }

  return proto === baseProto;
}

/***/ }),
/* 403 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export whenMapStateToPropsIsFunction */
/* unused harmony export whenMapStateToPropsIsMissing */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__ = __webpack_require__(218);

function whenMapStateToPropsIsFunction(mapStateToProps) {
  return typeof mapStateToProps === 'function' ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["b" /* wrapMapToPropsFunc */])(mapStateToProps, 'mapStateToProps') : undefined;
}
function whenMapStateToPropsIsMissing(mapStateToProps) {
  return !mapStateToProps ? Object(__WEBPACK_IMPORTED_MODULE_0__wrapMapToProps__["a" /* wrapMapToPropsConstant */])(function () {
    return {};
  }) : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMapStateToPropsIsFunction, whenMapStateToPropsIsMissing]);

/***/ }),
/* 404 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export defaultMergeProps */
/* unused harmony export wrapMergePropsFunc */
/* unused harmony export whenMergePropsIsFunction */
/* unused harmony export whenMergePropsIsOmitted */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils_verifyPlainObject__ = __webpack_require__(219);


function defaultMergeProps(stateProps, dispatchProps, ownProps) {
  return Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, ownProps, stateProps, dispatchProps);
}
function wrapMergePropsFunc(mergeProps) {
  return function initMergePropsProxy(dispatch, _ref) {
    var displayName = _ref.displayName,
        pure = _ref.pure,
        areMergedPropsEqual = _ref.areMergedPropsEqual;
    var hasRunOnce = false;
    var mergedProps;
    return function mergePropsProxy(stateProps, dispatchProps, ownProps) {
      var nextMergedProps = mergeProps(stateProps, dispatchProps, ownProps);

      if (hasRunOnce) {
        if (!pure || !areMergedPropsEqual(nextMergedProps, mergedProps)) mergedProps = nextMergedProps;
      } else {
        hasRunOnce = true;
        mergedProps = nextMergedProps;
        if (false) verifyPlainObject(mergedProps, displayName, 'mergeProps');
      }

      return mergedProps;
    };
  };
}
function whenMergePropsIsFunction(mergeProps) {
  return typeof mergeProps === 'function' ? wrapMergePropsFunc(mergeProps) : undefined;
}
function whenMergePropsIsOmitted(mergeProps) {
  return !mergeProps ? function () {
    return defaultMergeProps;
  } : undefined;
}
/* harmony default export */ __webpack_exports__["a"] = ([whenMergePropsIsFunction, whenMergePropsIsOmitted]);

/***/ }),
/* 405 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export impureFinalPropsSelectorFactory */
/* unused harmony export pureFinalPropsSelectorFactory */
/* harmony export (immutable) */ __webpack_exports__["a"] = finalPropsSelectorFactory;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__verifySubselectors__ = __webpack_require__(406);


function impureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch) {
  return function impureFinalPropsSelector(state, ownProps) {
    return mergeProps(mapStateToProps(state, ownProps), mapDispatchToProps(dispatch, ownProps), ownProps);
  };
}
function pureFinalPropsSelectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, _ref) {
  var areStatesEqual = _ref.areStatesEqual,
      areOwnPropsEqual = _ref.areOwnPropsEqual,
      areStatePropsEqual = _ref.areStatePropsEqual;
  var hasRunAtLeastOnce = false;
  var state;
  var ownProps;
  var stateProps;
  var dispatchProps;
  var mergedProps;

  function handleFirstCall(firstState, firstOwnProps) {
    state = firstState;
    ownProps = firstOwnProps;
    stateProps = mapStateToProps(state, ownProps);
    dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    hasRunAtLeastOnce = true;
    return mergedProps;
  }

  function handleNewPropsAndNewState() {
    stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewProps() {
    if (mapStateToProps.dependsOnOwnProps) stateProps = mapStateToProps(state, ownProps);
    if (mapDispatchToProps.dependsOnOwnProps) dispatchProps = mapDispatchToProps(dispatch, ownProps);
    mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleNewState() {
    var nextStateProps = mapStateToProps(state, ownProps);
    var statePropsChanged = !areStatePropsEqual(nextStateProps, stateProps);
    stateProps = nextStateProps;
    if (statePropsChanged) mergedProps = mergeProps(stateProps, dispatchProps, ownProps);
    return mergedProps;
  }

  function handleSubsequentCalls(nextState, nextOwnProps) {
    var propsChanged = !areOwnPropsEqual(nextOwnProps, ownProps);
    var stateChanged = !areStatesEqual(nextState, state);
    state = nextState;
    ownProps = nextOwnProps;
    if (propsChanged && stateChanged) return handleNewPropsAndNewState();
    if (propsChanged) return handleNewProps();
    if (stateChanged) return handleNewState();
    return mergedProps;
  }

  return function pureFinalPropsSelector(nextState, nextOwnProps) {
    return hasRunAtLeastOnce ? handleSubsequentCalls(nextState, nextOwnProps) : handleFirstCall(nextState, nextOwnProps);
  };
} // TODO: Add more comments
// If pure is true, the selector returned by selectorFactory will memoize its results,
// allowing connectAdvanced's shouldComponentUpdate to return false if final
// props have not changed. If false, the selector will always return a new
// object and shouldComponentUpdate will always return true.

function finalPropsSelectorFactory(dispatch, _ref2) {
  var initMapStateToProps = _ref2.initMapStateToProps,
      initMapDispatchToProps = _ref2.initMapDispatchToProps,
      initMergeProps = _ref2.initMergeProps,
      options = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref2, ["initMapStateToProps", "initMapDispatchToProps", "initMergeProps"]);

  var mapStateToProps = initMapStateToProps(dispatch, options);
  var mapDispatchToProps = initMapDispatchToProps(dispatch, options);
  var mergeProps = initMergeProps(dispatch, options);

  if (false) {
    verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, options.displayName);
  }

  var selectorFactory = options.pure ? pureFinalPropsSelectorFactory : impureFinalPropsSelectorFactory;
  return selectorFactory(mapStateToProps, mapDispatchToProps, mergeProps, dispatch, options);
}

/***/ }),
/* 406 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils_warning__ = __webpack_require__(142);


function verify(selector, methodName, displayName) {
  if (!selector) {
    throw new Error("Unexpected value for " + methodName + " in " + displayName + ".");
  } else if (methodName === 'mapStateToProps' || methodName === 'mapDispatchToProps') {
    if (!selector.hasOwnProperty('dependsOnOwnProps')) {
      Object(__WEBPACK_IMPORTED_MODULE_0__utils_warning__["a" /* default */])("The selector for " + methodName + " of " + displayName + " did not specify a value for dependsOnOwnProps.");
    }
  }
}

function verifySubselectors(mapStateToProps, mapDispatchToProps, mergeProps, displayName) {
  verify(mapStateToProps, 'mapStateToProps', displayName);
  verify(mapDispatchToProps, 'mapDispatchToProps', displayName);
  verify(mergeProps, 'mergeProps', displayName);
}

/***/ }),
/* 407 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(143);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses HTML5 history.
 */

var BrowserRouter = function (_React$Component) {
  _inherits(BrowserRouter, _React$Component);

  function BrowserRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, BrowserRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["a" /* createBrowserHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  BrowserRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<BrowserRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { BrowserRouter as Router }`.");
  };

  BrowserRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return BrowserRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

BrowserRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  forceRefresh: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  keyLength: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* harmony default export */ __webpack_exports__["a"] = (BrowserRouter);

/***/ }),
/* 408 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function isAbsolute(pathname) {
  return pathname.charAt(0) === '/';
}

// About 1.5x faster than the two-arg version of Array#splice()
function spliceOne(list, index) {
  for (var i = index, k = i + 1, n = list.length; k < n; i += 1, k += 1) {
    list[i] = list[k];
  }

  list.pop();
}

// This implementation is based heavily on node's url.parse
function resolvePathname(to, from) {
  if (from === undefined) from = '';

  var toParts = (to && to.split('/')) || [];
  var fromParts = (from && from.split('/')) || [];

  var isToAbs = to && isAbsolute(to);
  var isFromAbs = from && isAbsolute(from);
  var mustEndAbs = isToAbs || isFromAbs;

  if (to && isAbsolute(to)) {
    // to is absolute
    fromParts = toParts;
  } else if (toParts.length) {
    // to is relative, drop the filename
    fromParts.pop();
    fromParts = fromParts.concat(toParts);
  }

  if (!fromParts.length) return '/';

  var hasTrailingSlash;
  if (fromParts.length) {
    var last = fromParts[fromParts.length - 1];
    hasTrailingSlash = last === '.' || last === '..' || last === '';
  } else {
    hasTrailingSlash = false;
  }

  var up = 0;
  for (var i = fromParts.length; i >= 0; i--) {
    var part = fromParts[i];

    if (part === '.') {
      spliceOne(fromParts, i);
    } else if (part === '..') {
      spliceOne(fromParts, i);
      up++;
    } else if (up) {
      spliceOne(fromParts, i);
      up--;
    }
  }

  if (!mustEndAbs) for (; up--; up) fromParts.unshift('..');

  if (
    mustEndAbs &&
    fromParts[0] !== '' &&
    (!fromParts[0] || !isAbsolute(fromParts[0]))
  )
    fromParts.unshift('');

  var result = fromParts.join('/');

  if (hasTrailingSlash && result.substr(-1) !== '/') result += '/';

  return result;
}

/* harmony default export */ __webpack_exports__["a"] = (resolvePathname);


/***/ }),
/* 409 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
function valueOf(obj) {
  return obj.valueOf ? obj.valueOf() : Object.prototype.valueOf.call(obj);
}

function valueEqual(a, b) {
  // Test for strict equality first.
  if (a === b) return true;

  // Otherwise, if either of them == null they are not equal.
  if (a == null || b == null) return false;

  if (Array.isArray(a)) {
    return (
      Array.isArray(b) &&
      a.length === b.length &&
      a.every(function(item, index) {
        return valueEqual(item, b[index]);
      })
    );
  }

  if (typeof a === 'object' || typeof b === 'object') {
    var aValue = valueOf(a);
    var bValue = valueOf(b);

    if (aValue !== a || bValue !== b) return valueEqual(aValue, bValue);

    return Object.keys(Object.assign({}, a, b)).every(function(key) {
      return valueEqual(a[key], b[key]);
    });
  }

  return false;
}

/* harmony default export */ __webpack_exports__["a"] = (valueEqual);


/***/ }),
/* 410 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isProduction = "production" === 'production';
function warning(condition, message) {
  if (!isProduction) {
    if (condition) {
      return;
    }

    var text = "Warning: " + message;

    if (typeof console !== 'undefined') {
      console.warn(text);
    }

    try {
      throw Error(text);
    } catch (x) {}
  }
}

/* unused harmony default export */ var _unused_webpack_default_export = (warning);


/***/ }),
/* 411 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return invariant; });
var isProduction = "production" === 'production';
var prefix = 'Invariant failed';
function invariant(condition, message) {
    if (condition) {
        return;
    }
    if (isProduction) {
        throw new Error(prefix);
    }
    var provided = typeof message === 'function' ? message() : message;
    var value = provided ? "".concat(prefix, ": ").concat(provided) : prefix;
    throw new Error(value);
}




/***/ }),
/* 412 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning__ = __webpack_require__(21);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_warning___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_warning__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_history__ = __webpack_require__(68);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(143);
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }







/**
 * The public API for a <Router> that uses window.location.hash.
 */

var HashRouter = function (_React$Component) {
  _inherits(HashRouter, _React$Component);

  function HashRouter() {
    var _temp, _this, _ret;

    _classCallCheck(this, HashRouter);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.history = Object(__WEBPACK_IMPORTED_MODULE_3_history__["b" /* createHashHistory */])(_this.props), _temp), _possibleConstructorReturn(_this, _ret);
  }

  HashRouter.prototype.componentWillMount = function componentWillMount() {
    __WEBPACK_IMPORTED_MODULE_0_warning___default()(!this.props.history, "<HashRouter> ignores the history prop. To use a custom history, " + "use `import { Router }` instead of `import { HashRouter as Router }`.");
  };

  HashRouter.prototype.render = function render() {
    return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Router__["a" /* default */], { history: this.history, children: this.props.children });
  };

  return HashRouter;
}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);

HashRouter.propTypes = {
  basename: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,
  getUserConfirmation: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  hashType: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOf(["hashbang", "noslash", "slash"]),
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node
};


/* unused harmony default export */ var _unused_webpack_default_export = (HashRouter);

/***/ }),
/* 413 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__ = __webpack_require__(221);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_MemoryRouter__["a" /* default */]);

/***/ }),
/* 414 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Route__ = __webpack_require__(222);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Link__ = __webpack_require__(220);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }






/**
 * A <Link> wrapper that knows if it's "active" or not.
 */
var NavLink = function NavLink(_ref) {
  var to = _ref.to,
      exact = _ref.exact,
      strict = _ref.strict,
      location = _ref.location,
      activeClassName = _ref.activeClassName,
      className = _ref.className,
      activeStyle = _ref.activeStyle,
      style = _ref.style,
      getIsActive = _ref.isActive,
      ariaCurrent = _ref["aria-current"],
      rest = _objectWithoutProperties(_ref, ["to", "exact", "strict", "location", "activeClassName", "className", "activeStyle", "style", "isActive", "aria-current"]);

  var path = (typeof to === "undefined" ? "undefined" : _typeof(to)) === "object" ? to.pathname : to;

  // Regex taken from: https://github.com/pillarjs/path-to-regexp/blob/master/index.js#L202
  var escapedPath = path && path.replace(/([.+*?=^!:${}()[\]|/\\])/g, "\\$1");

  return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__Route__["a" /* default */], {
    path: escapedPath,
    exact: exact,
    strict: strict,
    location: location,
    children: function children(_ref2) {
      var location = _ref2.location,
          match = _ref2.match;

      var isActive = !!(getIsActive ? getIsActive(match, location) : match);

      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */], _extends({
        to: to,
        className: isActive ? [className, activeClassName].filter(function (i) {
          return i;
        }).join(" ") : className,
        style: isActive ? _extends({}, style, activeStyle) : style,
        "aria-current": isActive && ariaCurrent || null
      }, rest));
    }
  });
};

NavLink.propTypes = {
  to: __WEBPACK_IMPORTED_MODULE_3__Link__["a" /* default */].propTypes.to,
  exact: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  strict: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.bool,
  location: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  activeClassName: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  className: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,
  activeStyle: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  style: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.object,
  isActive: __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,
  "aria-current": __WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.oneOf(["page", "step", "location", "date", "time", "true"])
};

NavLink.defaultProps = {
  activeClassName: "active",
  "aria-current": "page"
};

/* harmony default export */ __webpack_exports__["a"] = (NavLink);

/***/ }),
/* 415 */
/***/ (function(module, exports) {

module.exports = Array.isArray || function (arr) {
  return Object.prototype.toString.call(arr) == '[object Array]';
};


/***/ }),
/* 416 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__ = __webpack_require__(223);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Prompt__["a" /* default */]);

/***/ }),
/* 417 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__ = __webpack_require__(224);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Redirect__["a" /* default */]);

/***/ }),
/* 418 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__ = __webpack_require__(225);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_StaticRouter__["a" /* default */]);

/***/ }),
/* 419 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__ = __webpack_require__(226);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_Switch__["a" /* default */]);

/***/ }),
/* 420 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__ = __webpack_require__(146);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_generatePath__["a" /* default */]);

/***/ }),
/* 421 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__ = __webpack_require__(113);
// Written in this round about way for babel-transform-imports


/* unused harmony default export */ var _unused_webpack_default_export = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_matchPath__["a" /* default */]);

/***/ }),
/* 422 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__ = __webpack_require__(227);
// Written in this round about way for babel-transform-imports


/* harmony default export */ __webpack_exports__["a"] = (__WEBPACK_IMPORTED_MODULE_0_react_router_es_withRouter__["a" /* default */]);

/***/ }),
/* 423 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_matchPath__ = __webpack_require__(147);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react_router_matchPath___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react_router_matchPath__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_Router__ = __webpack_require__(424);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_Router___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_router_Router__);



// ensure we're using the exact code for default root match
var computeMatch = __WEBPACK_IMPORTED_MODULE_1_react_router_Router___default.a.prototype.computeMatch;


var matchRoutes = function matchRoutes(routes, pathname) {
  var branch = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : [];

  routes.some(function (route) {
    var match = route.path ? __WEBPACK_IMPORTED_MODULE_0_react_router_matchPath___default()(pathname, route) : branch.length ? branch[branch.length - 1].match // use parent match
    : computeMatch(pathname); // use default "root" match

    if (match) {
      branch.push({ route: route, match: match });

      if (route.routes) {
        matchRoutes(route.routes, pathname, branch);
      }
    }

    return match;
  });

  return branch;
};

/* unused harmony default export */ var _unused_webpack_default_export = (matchRoutes);

/***/ }),
/* 424 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(21);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(35);

var _invariant2 = _interopRequireDefault(_invariant);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The public API for putting history on context.
 */
var Router = function (_React$Component) {
  _inherits(Router, _React$Component);

  function Router() {
    var _temp, _this, _ret;

    _classCallCheck(this, Router);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props.history.location.pathname)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Router.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        history: this.props.history,
        route: {
          location: this.props.history.location,
          match: this.state.match
        }
      })
    };
  };

  Router.prototype.computeMatch = function computeMatch(pathname) {
    return {
      path: "/",
      url: "/",
      params: {},
      isExact: pathname === "/"
    };
  };

  Router.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    var _props = this.props,
        children = _props.children,
        history = _props.history;


    (0, _invariant2.default)(children == null || _react2.default.Children.count(children) === 1, "A <Router> may have only one child element");

    // Do this here so we can setState when a <Redirect> changes the
    // location in componentWillMount. This happens e.g. when doing
    // server rendering using a <StaticRouter>.
    this.unlisten = history.listen(function () {
      _this2.setState({
        match: _this2.computeMatch(history.location.pathname)
      });
    });
  };

  Router.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    (0, _warning2.default)(this.props.history === nextProps.history, "You cannot change <Router history>");
  };

  Router.prototype.componentWillUnmount = function componentWillUnmount() {
    this.unlisten();
  };

  Router.prototype.render = function render() {
    var children = this.props.children;

    return children ? _react2.default.Children.only(children) : null;
  };

  return Router;
}(_react2.default.Component);

Router.propTypes = {
  history: _propTypes2.default.object.isRequired,
  children: _propTypes2.default.node
};
Router.contextTypes = {
  router: _propTypes2.default.object
};
Router.childContextTypes = {
  router: _propTypes2.default.object.isRequired
};
exports.default = Router;

/***/ }),
/* 425 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_Switch__ = __webpack_require__(426);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_Switch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_router_Switch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_Route__ = __webpack_require__(427);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_router_Route___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_router_Route__);
var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };





var renderRoutes = function renderRoutes(routes) {
  var extraProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  return routes ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(
    __WEBPACK_IMPORTED_MODULE_1_react_router_Switch___default.a,
    null,
    routes.map(function (route, i) {
      return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_router_Route___default.a, {
        key: route.key || i,
        path: route.path,
        exact: route.exact,
        strict: route.strict,
        render: function render(props) {
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(route.component, _extends({}, props, extraProps, { route: route }));
        }
      });
    })
  ) : null;
};

/* harmony default export */ __webpack_exports__["a"] = (renderRoutes);

/***/ }),
/* 426 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _warning = __webpack_require__(21);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(35);

var _invariant2 = _interopRequireDefault(_invariant);

var _matchPath = __webpack_require__(147);

var _matchPath2 = _interopRequireDefault(_matchPath);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

/**
 * The public API for rendering the first <Route> that matches.
 */
var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch() {
    _classCallCheck(this, Switch);

    return _possibleConstructorReturn(this, _React$Component.apply(this, arguments));
  }

  Switch.prototype.componentWillMount = function componentWillMount() {
    (0, _invariant2.default)(this.context.router, "You should not use <Switch> outside a <Router>");
  };

  Switch.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
    (0, _warning2.default)(!(nextProps.location && !this.props.location), '<Switch> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    (0, _warning2.default)(!(!nextProps.location && this.props.location), '<Switch> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');
  };

  Switch.prototype.render = function render() {
    var route = this.context.router.route;
    var children = this.props.children;

    var location = this.props.location || route.location;

    var match = void 0,
        child = void 0;
    _react2.default.Children.forEach(children, function (element) {
      if (match == null && _react2.default.isValidElement(element)) {
        var _element$props = element.props,
            pathProp = _element$props.path,
            exact = _element$props.exact,
            strict = _element$props.strict,
            sensitive = _element$props.sensitive,
            from = _element$props.from;

        var path = pathProp || from;

        child = element;
        match = (0, _matchPath2.default)(location.pathname, { path: path, exact: exact, strict: strict, sensitive: sensitive }, route.match);
      }
    });

    return match ? _react2.default.cloneElement(child, { location: location, computedMatch: match }) : null;
  };

  return Switch;
}(_react2.default.Component);

Switch.contextTypes = {
  router: _propTypes2.default.shape({
    route: _propTypes2.default.object.isRequired
  }).isRequired
};
Switch.propTypes = {
  children: _propTypes2.default.node,
  location: _propTypes2.default.object
};
exports.default = Switch;

/***/ }),
/* 427 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _warning = __webpack_require__(21);

var _warning2 = _interopRequireDefault(_warning);

var _invariant = __webpack_require__(35);

var _invariant2 = _interopRequireDefault(_invariant);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _matchPath = __webpack_require__(147);

var _matchPath2 = _interopRequireDefault(_matchPath);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var isEmptyChildren = function isEmptyChildren(children) {
  return _react2.default.Children.count(children) === 0;
};

/**
 * The public API for matching a single path and rendering.
 */

var Route = function (_React$Component) {
  _inherits(Route, _React$Component);

  function Route() {
    var _temp, _this, _ret;

    _classCallCheck(this, Route);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, _React$Component.call.apply(_React$Component, [this].concat(args))), _this), _this.state = {
      match: _this.computeMatch(_this.props, _this.context.router)
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  Route.prototype.getChildContext = function getChildContext() {
    return {
      router: _extends({}, this.context.router, {
        route: {
          location: this.props.location || this.context.router.route.location,
          match: this.state.match
        }
      })
    };
  };

  Route.prototype.computeMatch = function computeMatch(_ref, router) {
    var computedMatch = _ref.computedMatch,
        location = _ref.location,
        path = _ref.path,
        strict = _ref.strict,
        exact = _ref.exact,
        sensitive = _ref.sensitive;

    if (computedMatch) return computedMatch; // <Switch> already computed the match for us

    (0, _invariant2.default)(router, "You should not use <Route> or withRouter() outside a <Router>");

    var route = router.route;

    var pathname = (location || route.location).pathname;

    return (0, _matchPath2.default)(pathname, { path: path, strict: strict, exact: exact, sensitive: sensitive }, route.match);
  };

  Route.prototype.componentWillMount = function componentWillMount() {
    (0, _warning2.default)(!(this.props.component && this.props.render), "You should not use <Route component> and <Route render> in the same route; <Route render> will be ignored");

    (0, _warning2.default)(!(this.props.component && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route component> and <Route children> in the same route; <Route children> will be ignored");

    (0, _warning2.default)(!(this.props.render && this.props.children && !isEmptyChildren(this.props.children)), "You should not use <Route render> and <Route children> in the same route; <Route children> will be ignored");
  };

  Route.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps, nextContext) {
    (0, _warning2.default)(!(nextProps.location && !this.props.location), '<Route> elements should not change from uncontrolled to controlled (or vice versa). You initially used no "location" prop and then provided one on a subsequent render.');

    (0, _warning2.default)(!(!nextProps.location && this.props.location), '<Route> elements should not change from controlled to uncontrolled (or vice versa). You provided a "location" prop initially but omitted it on a subsequent render.');

    this.setState({
      match: this.computeMatch(nextProps, nextContext.router)
    });
  };

  Route.prototype.render = function render() {
    var match = this.state.match;
    var _props = this.props,
        children = _props.children,
        component = _props.component,
        render = _props.render;
    var _context$router = this.context.router,
        history = _context$router.history,
        route = _context$router.route,
        staticContext = _context$router.staticContext;

    var location = this.props.location || route.location;
    var props = { match: match, location: location, history: history, staticContext: staticContext };

    if (component) return match ? _react2.default.createElement(component, props) : null;

    if (render) return match ? render(props) : null;

    if (typeof children === "function") return children(props);

    if (children && !isEmptyChildren(children)) return _react2.default.Children.only(children);

    return null;
  };

  return Route;
}(_react2.default.Component);

Route.propTypes = {
  computedMatch: _propTypes2.default.object, // private, from <Switch>
  path: _propTypes2.default.string,
  exact: _propTypes2.default.bool,
  strict: _propTypes2.default.bool,
  sensitive: _propTypes2.default.bool,
  component: _propTypes2.default.func,
  render: _propTypes2.default.func,
  children: _propTypes2.default.oneOfType([_propTypes2.default.func, _propTypes2.default.node]),
  location: _propTypes2.default.object
};
Route.contextTypes = {
  router: _propTypes2.default.shape({
    history: _propTypes2.default.object.isRequired,
    route: _propTypes2.default.object.isRequired,
    staticContext: _propTypes2.default.object
  })
};
Route.childContextTypes = {
  router: _propTypes2.default.object.isRequired
};
exports.default = Route;

/***/ }),
/* 428 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ScrollToTop; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(39);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var ScrollToTop=Object(__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["d" /* withRouter */])(_class=function(_Component){_inherits(ScrollToTop,_Component);function ScrollToTop(){_classCallCheck(this,ScrollToTop);return _possibleConstructorReturn(this,(ScrollToTop.__proto__||Object.getPrototypeOf(ScrollToTop)).apply(this,arguments));}_createClass(ScrollToTop,[{key:"componentDidUpdate",value:function componentDidUpdate(prevProps){if(this.props.location.pathname!==prevProps.location.pathname){window.scrollTo(0,0);}}},{key:"render",value:function render(){return this.props.children;}}]);return ScrollToTop;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class;

/***/ }),
/* 429 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMatch = __webpack_require__(430),
    getMatchData = __webpack_require__(474),
    matchesStrictComparable = __webpack_require__(244);

/**
 * The base implementation of `_.matches` which doesn't clone `source`.
 *
 * @private
 * @param {Object} source The object of property values to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatches(source) {
  var matchData = getMatchData(source);
  if (matchData.length == 1 && matchData[0][2]) {
    return matchesStrictComparable(matchData[0][0], matchData[0][1]);
  }
  return function(object) {
    return object === source || baseIsMatch(object, source, matchData);
  };
}

module.exports = baseMatches;


/***/ }),
/* 430 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(114),
    baseIsEqual = __webpack_require__(151);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.isMatch` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to inspect.
 * @param {Object} source The object of property values to match.
 * @param {Array} matchData The property names, values, and compare flags to match.
 * @param {Function} [customizer] The function to customize comparisons.
 * @returns {boolean} Returns `true` if `object` is a match, else `false`.
 */
function baseIsMatch(object, source, matchData, customizer) {
  var index = matchData.length,
      length = index,
      noCustomizer = !customizer;

  if (object == null) {
    return !length;
  }
  object = Object(object);
  while (index--) {
    var data = matchData[index];
    if ((noCustomizer && data[2])
          ? data[1] !== object[data[0]]
          : !(data[0] in object)
        ) {
      return false;
    }
  }
  while (++index < length) {
    data = matchData[index];
    var key = data[0],
        objValue = object[key],
        srcValue = data[1];

    if (noCustomizer && data[2]) {
      if (objValue === undefined && !(key in object)) {
        return false;
      }
    } else {
      var stack = new Stack;
      if (customizer) {
        var result = customizer(objValue, srcValue, key, object, source, stack);
      }
      if (!(result === undefined
            ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack)
            : result
          )) {
        return false;
      }
    }
  }
  return true;
}

module.exports = baseIsMatch;


/***/ }),
/* 431 */
/***/ (function(module, exports) {

/**
 * Removes all key-value entries from the list cache.
 *
 * @private
 * @name clear
 * @memberOf ListCache
 */
function listCacheClear() {
  this.__data__ = [];
  this.size = 0;
}

module.exports = listCacheClear;


/***/ }),
/* 432 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(116);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * Removes `key` and its value from the list cache.
 *
 * @private
 * @name delete
 * @memberOf ListCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function listCacheDelete(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    return false;
  }
  var lastIndex = data.length - 1;
  if (index == lastIndex) {
    data.pop();
  } else {
    splice.call(data, index, 1);
  }
  --this.size;
  return true;
}

module.exports = listCacheDelete;


/***/ }),
/* 433 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(116);

/**
 * Gets the list cache value for `key`.
 *
 * @private
 * @name get
 * @memberOf ListCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function listCacheGet(key) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  return index < 0 ? undefined : data[index][1];
}

module.exports = listCacheGet;


/***/ }),
/* 434 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(116);

/**
 * Checks if a list cache value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf ListCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function listCacheHas(key) {
  return assocIndexOf(this.__data__, key) > -1;
}

module.exports = listCacheHas;


/***/ }),
/* 435 */
/***/ (function(module, exports, __webpack_require__) {

var assocIndexOf = __webpack_require__(116);

/**
 * Sets the list cache `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf ListCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the list cache instance.
 */
function listCacheSet(key, value) {
  var data = this.__data__,
      index = assocIndexOf(data, key);

  if (index < 0) {
    ++this.size;
    data.push([key, value]);
  } else {
    data[index][1] = value;
  }
  return this;
}

module.exports = listCacheSet;


/***/ }),
/* 436 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(115);

/**
 * Removes all key-value entries from the stack.
 *
 * @private
 * @name clear
 * @memberOf Stack
 */
function stackClear() {
  this.__data__ = new ListCache;
  this.size = 0;
}

module.exports = stackClear;


/***/ }),
/* 437 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the stack.
 *
 * @private
 * @name delete
 * @memberOf Stack
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function stackDelete(key) {
  var data = this.__data__,
      result = data['delete'](key);

  this.size = data.size;
  return result;
}

module.exports = stackDelete;


/***/ }),
/* 438 */
/***/ (function(module, exports) {

/**
 * Gets the stack value for `key`.
 *
 * @private
 * @name get
 * @memberOf Stack
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function stackGet(key) {
  return this.__data__.get(key);
}

module.exports = stackGet;


/***/ }),
/* 439 */
/***/ (function(module, exports) {

/**
 * Checks if a stack value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Stack
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function stackHas(key) {
  return this.__data__.has(key);
}

module.exports = stackHas;


/***/ }),
/* 440 */
/***/ (function(module, exports, __webpack_require__) {

var ListCache = __webpack_require__(115),
    Map = __webpack_require__(148),
    MapCache = __webpack_require__(150);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * Sets the stack `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Stack
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the stack cache instance.
 */
function stackSet(key, value) {
  var data = this.__data__;
  if (data instanceof ListCache) {
    var pairs = data.__data__;
    if (!Map || (pairs.length < LARGE_ARRAY_SIZE - 1)) {
      pairs.push([key, value]);
      this.size = ++data.size;
      return this;
    }
    data = this.__data__ = new MapCache(pairs);
  }
  data.set(key, value);
  this.size = data.size;
  return this;
}

module.exports = stackSet;


/***/ }),
/* 441 */
/***/ (function(module, exports, __webpack_require__) {

var isFunction = __webpack_require__(149),
    isMasked = __webpack_require__(444),
    isObject = __webpack_require__(31),
    toSource = __webpack_require__(232);

/**
 * Used to match `RegExp`
 * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
 */
var reRegExpChar = /[\\^$.*+?()[\]{}|]/g;

/** Used to detect host constructors (Safari). */
var reIsHostCtor = /^\[object .+?Constructor\]$/;

/** Used for built-in method references. */
var funcProto = Function.prototype,
    objectProto = Object.prototype;

/** Used to resolve the decompiled source of functions. */
var funcToString = funcProto.toString;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/** Used to detect if a method is native. */
var reIsNative = RegExp('^' +
  funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&')
  .replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$'
);

/**
 * The base implementation of `_.isNative` without bad shim checks.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a native function,
 *  else `false`.
 */
function baseIsNative(value) {
  if (!isObject(value) || isMasked(value)) {
    return false;
  }
  var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
  return pattern.test(toSource(value));
}

module.exports = baseIsNative;


/***/ }),
/* 442 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(71);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/** Built-in value references. */
var symToStringTag = Symbol ? Symbol.toStringTag : undefined;

/**
 * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
 *
 * @private
 * @param {*} value The value to query.
 * @returns {string} Returns the raw `toStringTag`.
 */
function getRawTag(value) {
  var isOwn = hasOwnProperty.call(value, symToStringTag),
      tag = value[symToStringTag];

  try {
    value[symToStringTag] = undefined;
    var unmasked = true;
  } catch (e) {}

  var result = nativeObjectToString.call(value);
  if (unmasked) {
    if (isOwn) {
      value[symToStringTag] = tag;
    } else {
      delete value[symToStringTag];
    }
  }
  return result;
}

module.exports = getRawTag;


/***/ }),
/* 443 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var nativeObjectToString = objectProto.toString;

/**
 * Converts `value` to a string using `Object.prototype.toString`.
 *
 * @private
 * @param {*} value The value to convert.
 * @returns {string} Returns the converted string.
 */
function objectToString(value) {
  return nativeObjectToString.call(value);
}

module.exports = objectToString;


/***/ }),
/* 444 */
/***/ (function(module, exports, __webpack_require__) {

var coreJsData = __webpack_require__(445);

/** Used to detect methods masquerading as native. */
var maskSrcKey = (function() {
  var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
  return uid ? ('Symbol(src)_1.' + uid) : '';
}());

/**
 * Checks if `func` has its source masked.
 *
 * @private
 * @param {Function} func The function to check.
 * @returns {boolean} Returns `true` if `func` is masked, else `false`.
 */
function isMasked(func) {
  return !!maskSrcKey && (maskSrcKey in func);
}

module.exports = isMasked;


/***/ }),
/* 445 */
/***/ (function(module, exports, __webpack_require__) {

var root = __webpack_require__(40);

/** Used to detect overreaching core-js shims. */
var coreJsData = root['__core-js_shared__'];

module.exports = coreJsData;


/***/ }),
/* 446 */
/***/ (function(module, exports) {

/**
 * Gets the value at `key` of `object`.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {string} key The key of the property to get.
 * @returns {*} Returns the property value.
 */
function getValue(object, key) {
  return object == null ? undefined : object[key];
}

module.exports = getValue;


/***/ }),
/* 447 */
/***/ (function(module, exports, __webpack_require__) {

var Hash = __webpack_require__(448),
    ListCache = __webpack_require__(115),
    Map = __webpack_require__(148);

/**
 * Removes all key-value entries from the map.
 *
 * @private
 * @name clear
 * @memberOf MapCache
 */
function mapCacheClear() {
  this.size = 0;
  this.__data__ = {
    'hash': new Hash,
    'map': new (Map || ListCache),
    'string': new Hash
  };
}

module.exports = mapCacheClear;


/***/ }),
/* 448 */
/***/ (function(module, exports, __webpack_require__) {

var hashClear = __webpack_require__(449),
    hashDelete = __webpack_require__(450),
    hashGet = __webpack_require__(451),
    hashHas = __webpack_require__(452),
    hashSet = __webpack_require__(453);

/**
 * Creates a hash object.
 *
 * @private
 * @constructor
 * @param {Array} [entries] The key-value pairs to cache.
 */
function Hash(entries) {
  var index = -1,
      length = entries == null ? 0 : entries.length;

  this.clear();
  while (++index < length) {
    var entry = entries[index];
    this.set(entry[0], entry[1]);
  }
}

// Add methods to `Hash`.
Hash.prototype.clear = hashClear;
Hash.prototype['delete'] = hashDelete;
Hash.prototype.get = hashGet;
Hash.prototype.has = hashHas;
Hash.prototype.set = hashSet;

module.exports = Hash;


/***/ }),
/* 449 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(117);

/**
 * Removes all key-value entries from the hash.
 *
 * @private
 * @name clear
 * @memberOf Hash
 */
function hashClear() {
  this.__data__ = nativeCreate ? nativeCreate(null) : {};
  this.size = 0;
}

module.exports = hashClear;


/***/ }),
/* 450 */
/***/ (function(module, exports) {

/**
 * Removes `key` and its value from the hash.
 *
 * @private
 * @name delete
 * @memberOf Hash
 * @param {Object} hash The hash to modify.
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function hashDelete(key) {
  var result = this.has(key) && delete this.__data__[key];
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = hashDelete;


/***/ }),
/* 451 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(117);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Gets the hash value for `key`.
 *
 * @private
 * @name get
 * @memberOf Hash
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function hashGet(key) {
  var data = this.__data__;
  if (nativeCreate) {
    var result = data[key];
    return result === HASH_UNDEFINED ? undefined : result;
  }
  return hasOwnProperty.call(data, key) ? data[key] : undefined;
}

module.exports = hashGet;


/***/ }),
/* 452 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(117);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Checks if a hash value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf Hash
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function hashHas(key) {
  var data = this.__data__;
  return nativeCreate ? (data[key] !== undefined) : hasOwnProperty.call(data, key);
}

module.exports = hashHas;


/***/ }),
/* 453 */
/***/ (function(module, exports, __webpack_require__) {

var nativeCreate = __webpack_require__(117);

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Sets the hash `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf Hash
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the hash instance.
 */
function hashSet(key, value) {
  var data = this.__data__;
  this.size += this.has(key) ? 0 : 1;
  data[key] = (nativeCreate && value === undefined) ? HASH_UNDEFINED : value;
  return this;
}

module.exports = hashSet;


/***/ }),
/* 454 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(118);

/**
 * Removes `key` and its value from the map.
 *
 * @private
 * @name delete
 * @memberOf MapCache
 * @param {string} key The key of the value to remove.
 * @returns {boolean} Returns `true` if the entry was removed, else `false`.
 */
function mapCacheDelete(key) {
  var result = getMapData(this, key)['delete'](key);
  this.size -= result ? 1 : 0;
  return result;
}

module.exports = mapCacheDelete;


/***/ }),
/* 455 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is suitable for use as unique object key.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
 */
function isKeyable(value) {
  var type = typeof value;
  return (type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean')
    ? (value !== '__proto__')
    : (value === null);
}

module.exports = isKeyable;


/***/ }),
/* 456 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(118);

/**
 * Gets the map value for `key`.
 *
 * @private
 * @name get
 * @memberOf MapCache
 * @param {string} key The key of the value to get.
 * @returns {*} Returns the entry value.
 */
function mapCacheGet(key) {
  return getMapData(this, key).get(key);
}

module.exports = mapCacheGet;


/***/ }),
/* 457 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(118);

/**
 * Checks if a map value for `key` exists.
 *
 * @private
 * @name has
 * @memberOf MapCache
 * @param {string} key The key of the entry to check.
 * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
 */
function mapCacheHas(key) {
  return getMapData(this, key).has(key);
}

module.exports = mapCacheHas;


/***/ }),
/* 458 */
/***/ (function(module, exports, __webpack_require__) {

var getMapData = __webpack_require__(118);

/**
 * Sets the map `key` to `value`.
 *
 * @private
 * @name set
 * @memberOf MapCache
 * @param {string} key The key of the value to set.
 * @param {*} value The value to set.
 * @returns {Object} Returns the map cache instance.
 */
function mapCacheSet(key, value) {
  var data = getMapData(this, key),
      size = data.size;

  data.set(key, value);
  this.size += data.size == size ? 0 : 1;
  return this;
}

module.exports = mapCacheSet;


/***/ }),
/* 459 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(114),
    equalArrays = __webpack_require__(233),
    equalByTag = __webpack_require__(463),
    equalObjects = __webpack_require__(465),
    getTag = __webpack_require__(72),
    isArray = __webpack_require__(13),
    isBuffer = __webpack_require__(93),
    isTypedArray = __webpack_require__(120);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    objectTag = '[object Object]';

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqual` for arrays and objects which performs
 * deep comparisons and tracks traversed objects enabling objects with circular
 * references to be compared.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} [stack] Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
  var objIsArr = isArray(object),
      othIsArr = isArray(other),
      objTag = objIsArr ? arrayTag : getTag(object),
      othTag = othIsArr ? arrayTag : getTag(other);

  objTag = objTag == argsTag ? objectTag : objTag;
  othTag = othTag == argsTag ? objectTag : othTag;

  var objIsObj = objTag == objectTag,
      othIsObj = othTag == objectTag,
      isSameTag = objTag == othTag;

  if (isSameTag && isBuffer(object)) {
    if (!isBuffer(other)) {
      return false;
    }
    objIsArr = true;
    objIsObj = false;
  }
  if (isSameTag && !objIsObj) {
    stack || (stack = new Stack);
    return (objIsArr || isTypedArray(object))
      ? equalArrays(object, other, bitmask, customizer, equalFunc, stack)
      : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
  }
  if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
    var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
        othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');

    if (objIsWrapped || othIsWrapped) {
      var objUnwrapped = objIsWrapped ? object.value() : object,
          othUnwrapped = othIsWrapped ? other.value() : other;

      stack || (stack = new Stack);
      return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
    }
  }
  if (!isSameTag) {
    return false;
  }
  stack || (stack = new Stack);
  return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
}

module.exports = baseIsEqualDeep;


/***/ }),
/* 460 */
/***/ (function(module, exports) {

/** Used to stand-in for `undefined` hash values. */
var HASH_UNDEFINED = '__lodash_hash_undefined__';

/**
 * Adds `value` to the array cache.
 *
 * @private
 * @name add
 * @memberOf SetCache
 * @alias push
 * @param {*} value The value to cache.
 * @returns {Object} Returns the cache instance.
 */
function setCacheAdd(value) {
  this.__data__.set(value, HASH_UNDEFINED);
  return this;
}

module.exports = setCacheAdd;


/***/ }),
/* 461 */
/***/ (function(module, exports) {

/**
 * Checks if `value` is in the array cache.
 *
 * @private
 * @name has
 * @memberOf SetCache
 * @param {*} value The value to search for.
 * @returns {number} Returns `true` if `value` is found, else `false`.
 */
function setCacheHas(value) {
  return this.__data__.has(value);
}

module.exports = setCacheHas;


/***/ }),
/* 462 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.some` for arrays without support for iteratee
 * shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} predicate The function invoked per iteration.
 * @returns {boolean} Returns `true` if any element passes the predicate check,
 *  else `false`.
 */
function arraySome(array, predicate) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (predicate(array[index], index, array)) {
      return true;
    }
  }
  return false;
}

module.exports = arraySome;


/***/ }),
/* 463 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(71),
    Uint8Array = __webpack_require__(236),
    eq = __webpack_require__(70),
    equalArrays = __webpack_require__(233),
    mapToArray = __webpack_require__(464),
    setToArray = __webpack_require__(152);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]';

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * A specialized version of `baseIsEqualDeep` for comparing objects of
 * the same `toStringTag`.
 *
 * **Note:** This function only supports comparing values with tags of
 * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {string} tag The `toStringTag` of the objects to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
  switch (tag) {
    case dataViewTag:
      if ((object.byteLength != other.byteLength) ||
          (object.byteOffset != other.byteOffset)) {
        return false;
      }
      object = object.buffer;
      other = other.buffer;

    case arrayBufferTag:
      if ((object.byteLength != other.byteLength) ||
          !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
        return false;
      }
      return true;

    case boolTag:
    case dateTag:
    case numberTag:
      // Coerce booleans to `1` or `0` and dates to milliseconds.
      // Invalid dates are coerced to `NaN`.
      return eq(+object, +other);

    case errorTag:
      return object.name == other.name && object.message == other.message;

    case regexpTag:
    case stringTag:
      // Coerce regexes to strings and treat strings, primitives and objects,
      // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
      // for more details.
      return object == (other + '');

    case mapTag:
      var convert = mapToArray;

    case setTag:
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
      convert || (convert = setToArray);

      if (object.size != other.size && !isPartial) {
        return false;
      }
      // Assume cyclic values are equal.
      var stacked = stack.get(object);
      if (stacked) {
        return stacked == other;
      }
      bitmask |= COMPARE_UNORDERED_FLAG;

      // Recursively compare objects (susceptible to call stack limits).
      stack.set(object, other);
      var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
      stack['delete'](object);
      return result;

    case symbolTag:
      if (symbolValueOf) {
        return symbolValueOf.call(object) == symbolValueOf.call(other);
      }
  }
  return false;
}

module.exports = equalByTag;


/***/ }),
/* 464 */
/***/ (function(module, exports) {

/**
 * Converts `map` to its key-value pairs.
 *
 * @private
 * @param {Object} map The map to convert.
 * @returns {Array} Returns the key-value pairs.
 */
function mapToArray(map) {
  var index = -1,
      result = Array(map.size);

  map.forEach(function(value, key) {
    result[++index] = [key, value];
  });
  return result;
}

module.exports = mapToArray;


/***/ }),
/* 465 */
/***/ (function(module, exports, __webpack_require__) {

var getAllKeys = __webpack_require__(237);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1;

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * A specialized version of `baseIsEqualDeep` for objects with support for
 * partial deep comparisons.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
 * @param {Function} customizer The function to customize comparisons.
 * @param {Function} equalFunc The function to determine equivalents of values.
 * @param {Object} stack Tracks traversed `object` and `other` objects.
 * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
 */
function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
  var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
      objProps = getAllKeys(object),
      objLength = objProps.length,
      othProps = getAllKeys(other),
      othLength = othProps.length;

  if (objLength != othLength && !isPartial) {
    return false;
  }
  var index = objLength;
  while (index--) {
    var key = objProps[index];
    if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
      return false;
    }
  }
  // Check that cyclic values are equal.
  var objStacked = stack.get(object);
  var othStacked = stack.get(other);
  if (objStacked && othStacked) {
    return objStacked == other && othStacked == object;
  }
  var result = true;
  stack.set(object, other);
  stack.set(other, object);

  var skipCtor = isPartial;
  while (++index < objLength) {
    key = objProps[index];
    var objValue = object[key],
        othValue = other[key];

    if (customizer) {
      var compared = isPartial
        ? customizer(othValue, objValue, key, other, object, stack)
        : customizer(objValue, othValue, key, object, other, stack);
    }
    // Recursively compare objects (susceptible to call stack limits).
    if (!(compared === undefined
          ? (objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack))
          : compared
        )) {
      result = false;
      break;
    }
    skipCtor || (skipCtor = key == 'constructor');
  }
  if (result && !skipCtor) {
    var objCtor = object.constructor,
        othCtor = other.constructor;

    // Non `Object` object instances with different constructors are not equal.
    if (objCtor != othCtor &&
        ('constructor' in object && 'constructor' in other) &&
        !(typeof objCtor == 'function' && objCtor instanceof objCtor &&
          typeof othCtor == 'function' && othCtor instanceof othCtor)) {
      result = false;
    }
  }
  stack['delete'](object);
  stack['delete'](other);
  return result;
}

module.exports = equalObjects;


/***/ }),
/* 466 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.times` without support for iteratee shorthands
 * or max array length checks.
 *
 * @private
 * @param {number} n The number of times to invoke `iteratee`.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Array} Returns the array of results.
 */
function baseTimes(n, iteratee) {
  var index = -1,
      result = Array(n);

  while (++index < n) {
    result[index] = iteratee(index);
  }
  return result;
}

module.exports = baseTimes;


/***/ }),
/* 467 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(48),
    isObjectLike = __webpack_require__(26);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]';

/**
 * The base implementation of `_.isArguments`.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an `arguments` object,
 */
function baseIsArguments(value) {
  return isObjectLike(value) && baseGetTag(value) == argsTag;
}

module.exports = baseIsArguments;


/***/ }),
/* 468 */
/***/ (function(module, exports) {

/**
 * This method returns `false`.
 *
 * @static
 * @memberOf _
 * @since 4.13.0
 * @category Util
 * @returns {boolean} Returns `false`.
 * @example
 *
 * _.times(2, _.stubFalse);
 * // => [false, false]
 */
function stubFalse() {
  return false;
}

module.exports = stubFalse;


/***/ }),
/* 469 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(48),
    isLength = __webpack_require__(156),
    isObjectLike = __webpack_require__(26);

/** `Object#toString` result references. */
var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    objectTag = '[object Object]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    weakMapTag = '[object WeakMap]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/** Used to identify `toStringTag` values of typed arrays. */
var typedArrayTags = {};
typedArrayTags[float32Tag] = typedArrayTags[float64Tag] =
typedArrayTags[int8Tag] = typedArrayTags[int16Tag] =
typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] =
typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] =
typedArrayTags[uint32Tag] = true;
typedArrayTags[argsTag] = typedArrayTags[arrayTag] =
typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] =
typedArrayTags[dataViewTag] = typedArrayTags[dateTag] =
typedArrayTags[errorTag] = typedArrayTags[funcTag] =
typedArrayTags[mapTag] = typedArrayTags[numberTag] =
typedArrayTags[objectTag] = typedArrayTags[regexpTag] =
typedArrayTags[setTag] = typedArrayTags[stringTag] =
typedArrayTags[weakMapTag] = false;

/**
 * The base implementation of `_.isTypedArray` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
 */
function baseIsTypedArray(value) {
  return isObjectLike(value) &&
    isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
}

module.exports = baseIsTypedArray;


/***/ }),
/* 470 */
/***/ (function(module, exports, __webpack_require__) {

var overArg = __webpack_require__(241);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeKeys = overArg(Object.keys, Object);

module.exports = nativeKeys;


/***/ }),
/* 471 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(58),
    root = __webpack_require__(40);

/* Built-in method references that are verified to be native. */
var DataView = getNative(root, 'DataView');

module.exports = DataView;


/***/ }),
/* 472 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(58),
    root = __webpack_require__(40);

/* Built-in method references that are verified to be native. */
var Promise = getNative(root, 'Promise');

module.exports = Promise;


/***/ }),
/* 473 */
/***/ (function(module, exports, __webpack_require__) {

var getNative = __webpack_require__(58),
    root = __webpack_require__(40);

/* Built-in method references that are verified to be native. */
var WeakMap = getNative(root, 'WeakMap');

module.exports = WeakMap;


/***/ }),
/* 474 */
/***/ (function(module, exports, __webpack_require__) {

var isStrictComparable = __webpack_require__(243),
    keys = __webpack_require__(59);

/**
 * Gets the property names, values, and compare flags of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the match data of `object`.
 */
function getMatchData(object) {
  var result = keys(object),
      length = result.length;

  while (length--) {
    var key = result[length],
        value = object[key];

    result[length] = [key, value, isStrictComparable(value)];
  }
  return result;
}

module.exports = getMatchData;


/***/ }),
/* 475 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsEqual = __webpack_require__(151),
    get = __webpack_require__(7),
    hasIn = __webpack_require__(246),
    isKey = __webpack_require__(158),
    isStrictComparable = __webpack_require__(243),
    matchesStrictComparable = __webpack_require__(244),
    toKey = __webpack_require__(75);

/** Used to compose bitmasks for value comparisons. */
var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

/**
 * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
 *
 * @private
 * @param {string} path The path of the property to get.
 * @param {*} srcValue The value to match.
 * @returns {Function} Returns the new spec function.
 */
function baseMatchesProperty(path, srcValue) {
  if (isKey(path) && isStrictComparable(srcValue)) {
    return matchesStrictComparable(toKey(path), srcValue);
  }
  return function(object) {
    var objValue = get(object, path);
    return (objValue === undefined && objValue === srcValue)
      ? hasIn(object, path)
      : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
  };
}

module.exports = baseMatchesProperty;


/***/ }),
/* 476 */
/***/ (function(module, exports, __webpack_require__) {

var memoizeCapped = __webpack_require__(477);

/** Used to match property names within property paths. */
var rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

/** Used to match backslashes in property paths. */
var reEscapeChar = /\\(\\)?/g;

/**
 * Converts `string` to a property path array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the property path array.
 */
var stringToPath = memoizeCapped(function(string) {
  var result = [];
  if (string.charCodeAt(0) === 46 /* . */) {
    result.push('');
  }
  string.replace(rePropName, function(match, number, quote, subString) {
    result.push(quote ? subString.replace(reEscapeChar, '$1') : (number || match));
  });
  return result;
});

module.exports = stringToPath;


/***/ }),
/* 477 */
/***/ (function(module, exports, __webpack_require__) {

var memoize = __webpack_require__(245);

/** Used as the maximum memoize cache size. */
var MAX_MEMOIZE_SIZE = 500;

/**
 * A specialized version of `_.memoize` which clears the memoized function's
 * cache when it exceeds `MAX_MEMOIZE_SIZE`.
 *
 * @private
 * @param {Function} func The function to have its output memoized.
 * @returns {Function} Returns the new memoized function.
 */
function memoizeCapped(func) {
  var result = memoize(func, function(key) {
    if (cache.size === MAX_MEMOIZE_SIZE) {
      cache.clear();
    }
    return key;
  });

  var cache = result.cache;
  return result;
}

module.exports = memoizeCapped;


/***/ }),
/* 478 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.hasIn` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHasIn(object, key) {
  return object != null && key in Object(object);
}

module.exports = baseHasIn;


/***/ }),
/* 479 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(248),
    basePropertyDeep = __webpack_require__(480),
    isKey = __webpack_require__(158),
    toKey = __webpack_require__(75);

/**
 * Creates a function that returns the value at `path` of a given object.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 * @example
 *
 * var objects = [
 *   { 'a': { 'b': 2 } },
 *   { 'a': { 'b': 1 } }
 * ];
 *
 * _.map(objects, _.property('a.b'));
 * // => [2, 1]
 *
 * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
 * // => [1, 2]
 */
function property(path) {
  return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
}

module.exports = property;


/***/ }),
/* 480 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(96);

/**
 * A specialized version of `baseProperty` which supports deep paths.
 *
 * @private
 * @param {Array|string} path The path of the property to get.
 * @returns {Function} Returns the new accessor function.
 */
function basePropertyDeep(path) {
  return function(object) {
    return baseGet(object, path);
  };
}

module.exports = basePropertyDeep;


/***/ }),
/* 481 */
/***/ (function(module, exports, __webpack_require__) {

var baseFor = __webpack_require__(250),
    keys = __webpack_require__(59);

/**
 * The base implementation of `_.forOwn` without support for iteratee shorthands.
 *
 * @private
 * @param {Object} object The object to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @returns {Object} Returns `object`.
 */
function baseForOwn(object, iteratee) {
  return object && baseFor(object, iteratee, keys);
}

module.exports = baseForOwn;


/***/ }),
/* 482 */
/***/ (function(module, exports) {

/**
 * Creates a base function for methods like `_.forIn` and `_.forOwn`.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseFor(fromRight) {
  return function(object, iteratee, keysFunc) {
    var index = -1,
        iterable = Object(object),
        props = keysFunc(object),
        length = props.length;

    while (length--) {
      var key = props[fromRight ? length : ++index];
      if (iteratee(iterable[key], key, iterable) === false) {
        break;
      }
    }
    return object;
  };
}

module.exports = createBaseFor;


/***/ }),
/* 483 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(41);

/**
 * Creates a `baseEach` or `baseEachRight` function.
 *
 * @private
 * @param {Function} eachFunc The function to iterate over a collection.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new base function.
 */
function createBaseEach(eachFunc, fromRight) {
  return function(collection, iteratee) {
    if (collection == null) {
      return collection;
    }
    if (!isArrayLike(collection)) {
      return eachFunc(collection, iteratee);
    }
    var length = collection.length,
        index = fromRight ? length : -1,
        iterable = Object(collection);

    while ((fromRight ? index-- : ++index < length)) {
      if (iteratee(iterable[index], index, iterable) === false) {
        break;
      }
    }
    return collection;
  };
}

module.exports = createBaseEach;


/***/ }),
/* 484 */
/***/ (function(module, exports, __webpack_require__) {

var trimmedEndIndex = __webpack_require__(485);

/** Used to match leading whitespace. */
var reTrimStart = /^\s+/;

/**
 * The base implementation of `_.trim`.
 *
 * @private
 * @param {string} string The string to trim.
 * @returns {string} Returns the trimmed string.
 */
function baseTrim(string) {
  return string
    ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '')
    : string;
}

module.exports = baseTrim;


/***/ }),
/* 485 */
/***/ (function(module, exports) {

/** Used to match a single whitespace character. */
var reWhitespace = /\s/;

/**
 * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
 * character of `string`.
 *
 * @private
 * @param {string} string The string to inspect.
 * @returns {number} Returns the index of the last non-whitespace character.
 */
function trimmedEndIndex(string) {
  var index = string.length;

  while (index-- && reWhitespace.test(string.charAt(index))) {}
  return index;
}

module.exports = trimmedEndIndex;


/***/ }),
/* 486 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsRegExp = __webpack_require__(487),
    baseUnary = __webpack_require__(95),
    nodeUtil = __webpack_require__(121);

/* Node.js helper references. */
var nodeIsRegExp = nodeUtil && nodeUtil.isRegExp;

/**
 * Checks if `value` is classified as a `RegExp` object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 * @example
 *
 * _.isRegExp(/abc/);
 * // => true
 *
 * _.isRegExp('/abc/');
 * // => false
 */
var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

module.exports = isRegExp;


/***/ }),
/* 487 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(48),
    isObjectLike = __webpack_require__(26);

/** `Object#toString` result references. */
var regexpTag = '[object RegExp]';

/**
 * The base implementation of `_.isRegExp` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
 */
function baseIsRegExp(value) {
  return isObjectLike(value) && baseGetTag(value) == regexpTag;
}

module.exports = baseIsRegExp;


/***/ }),
/* 488 */
/***/ (function(module, exports) {

/**
 * Converts an ASCII `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function asciiToArray(string) {
  return string.split('');
}

module.exports = asciiToArray;


/***/ }),
/* 489 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Converts a Unicode `string` to an array.
 *
 * @private
 * @param {string} string The string to convert.
 * @returns {Array} Returns the converted array.
 */
function unicodeToArray(string) {
  return string.match(reUnicode) || [];
}

module.exports = unicodeToArray;


/***/ }),
/* 490 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Logo; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1____ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Logo=(_temp=_class=function(_PureComponent){_inherits(Logo,_PureComponent);function Logo(){_classCallCheck(this,Logo);return _possibleConstructorReturn(this,(Logo.__proto__||Object.getPrototypeOf(Logo)).apply(this,arguments));}_createClass(Logo,[{key:"render",value:function render(){var src=this.props.src;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1____["g" /* Image */],{className:"logo-component",src:src,alt:"Laguna"});}}]);return Logo;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]),_class.propTypes={src:__WEBPACK_IMPORTED_MODULE_2_prop_types__["PropTypes"].string.isRequired},_temp);

/***/ }),
/* 491 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_redux__ = __webpack_require__(213);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var initialActions={};/* harmony default export */ __webpack_exports__["a"] = (function(mapStateToProps){var actions=arguments.length>1&&arguments[1]!==undefined?arguments[1]:{};return function(Component){var _dec,_class;var mapDispatchToProps=function mapDispatchToProps(dispatch){return{actions:Object(__WEBPACK_IMPORTED_MODULE_1_redux__["bindActionCreators"])(Object.assign({},initialActions,actions),dispatch)};};var WithRedux=(_dec=Object(__WEBPACK_IMPORTED_MODULE_2_react_redux__["b" /* connect */])(mapStateToProps,mapDispatchToProps),_dec(_class=function(_React$PureComponent){_inherits(WithRedux,_React$PureComponent);function WithRedux(){_classCallCheck(this,WithRedux);return _possibleConstructorReturn(this,(WithRedux.__proto__||Object.getPrototypeOf(WithRedux)).apply(this,arguments));}_createClass(WithRedux,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Component,this.props);}}]);return WithRedux;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent))||_class);return WithRedux;};});

/***/ }),
/* 492 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isObject__ = __webpack_require__(31);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isObject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isObject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isEmpty__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_find__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_map__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__locales__ = __webpack_require__(255);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var defaultLanguage=__WEBPACK_IMPORTED_MODULE_7__locales__["a" /* default */].defaultLanguage;// const defaultLanguage = locales.defaultLanguage;
var languages=__WEBPACK_IMPORTED_MODULE_4_lodash_map___default()(__WEBPACK_IMPORTED_MODULE_7__locales__["a" /* default */].languages,function(language){return language.key;});/* harmony default export */ __webpack_exports__["a"] = (function(){return function(Component){var _class,_temp2;var MultiLanguage=(_temp2=_class=function(_React$PureComponent){_inherits(MultiLanguage,_React$PureComponent);function MultiLanguage(){var _ref;var _temp,_this,_ret;_classCallCheck(this,MultiLanguage);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=MultiLanguage.__proto__||Object.getPrototypeOf(MultiLanguage)).call.apply(_ref,[this].concat(args))),_this),_this.state={language:defaultLanguage},_this.componentDidMount=function(){_this.init();},_this.init=function(){if(_this.context.store){var _this$context$store=_this.context.store,getState=_this$context$store.getState,subscribe=_this$context$store.subscribe;subscribe(function(){return _this.switchLanguage(getState().language.currentActive);});_this.switchLanguage(getState().language.currentActive);}},_this.getLangData=function(language){// console.log("getLangData", {
//   language,
//   locales,
//   data: _.find(locales.languages, { key: language }),
// });
// const langData = _.find(locales.languages, { key: language }).data;
var data=__WEBPACK_IMPORTED_MODULE_3_lodash_find___default()(__WEBPACK_IMPORTED_MODULE_7__locales__["a" /* default */].languages,{key:language});var langData=__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(data,"data");return langData;},_this.getAnyLanguage=function(content){var result=content;for(var index=0;index<languages.length;index+=1){var language=languages[index];// console.log("getLangData-getAnyLanguage", language);
var langData=_this.getLangData(language);var contentLang=__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(langData,content);if(contentLang){result=contentLang;break;}}return result;},_this.getDefaultLanguage=function(content){// console.log("getLangData-getDefaultLanguage", defaultLanguage);
var langData=_this.getLangData(defaultLanguage);var contentLang=__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(langData,content);if(!contentLang)return _this.getAnyLanguage(content);return contentLang;},_this.getDataFromString=function(content){var language=_this.state.language;// console.log("getLangData-getDataFromString", language);
var langData=_this.getLangData(language);// const langData = this.getLangData("en");
var contentLang=__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(langData,content);if(!contentLang)return _this.getDefaultLanguage(content);return contentLang;},_this.getDataFromObject=function(object){var language=_this.state.language;return __WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(object,language,__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(object,defaultLanguage));},_this.getDataWithLanguage=function(content){if(__WEBPACK_IMPORTED_MODULE_1_lodash_isEmpty___default()(content))return"";var string="";if(__WEBPACK_IMPORTED_MODULE_0_lodash_isObject___default()(content)){string=_this.getDataFromObject(content);}else{string=_this.getDataFromString(content);}return string;},_this.switchLanguage=function(language){// console.log("switchLanguage", language);
if(_this.state.language!=="language"){_this.setState({language:language});}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(MultiLanguage,[{key:"componentWillReceiveProps",value:function componentWillReceiveProps(){this.init();}},{key:"render",value:function render(){var _props=this.props,forwardedRef=_props.forwardedRef,rest=_objectWithoutProperties(_props,["forwardedRef"]);return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(Component,Object.assign({ref:forwardedRef},rest,{languages:__WEBPACK_IMPORTED_MODULE_7__locales__["a" /* default */].languages,currentLanguage:this.state.language,t:this.getDataWithLanguage}));}}]);return MultiLanguage;}(__WEBPACK_IMPORTED_MODULE_5_react___default.a.PureComponent),_class.contextTypes={store:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.object},_temp2);return __WEBPACK_IMPORTED_MODULE_5_react___default.a.forwardRef(function(props,ref){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(MultiLanguage,Object.assign({},props,{forwardedRef:ref}));});};});

/***/ }),
/* 493 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(36),
    isArrayLike = __webpack_require__(41),
    keys = __webpack_require__(59);

/**
 * Creates a `_.find` or `_.findLast` function.
 *
 * @private
 * @param {Function} findIndexFunc The function to find the collection index.
 * @returns {Function} Returns the new find function.
 */
function createFind(findIndexFunc) {
  return function(collection, predicate, fromIndex) {
    var iterable = Object(collection);
    if (!isArrayLike(collection)) {
      var iteratee = baseIteratee(predicate, 3);
      collection = keys(collection);
      predicate = function(key) { return iteratee(iterable[key], key, iterable); };
    }
    var index = findIndexFunc(collection, predicate, fromIndex);
    return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
  };
}

module.exports = createFind;


/***/ }),
/* 494 */
/***/ (function(module, exports) {

module.exports = {"Gallery":"Gallery","All Images":"All Images","Residences – Aerial":"Residences – Aerial","Residences – Exterior":"Residences – Exterior","Residences – Interior":"Residences – Interior","Residences – Lifestyle":"Residences – Lifestyle","Residences – Common Area":"Residences – Common Area","Destination Lifestyle":"Destination Lifestyle","Laguna Village Residences":"Laguna Village Residences","Laguna Village <strong>Residences</strong>":"Laguna Village <strong>Residences</strong>","Gallery-title-phuket-laguna-village-residences":"Welcome to Laguna Village Residences","Gallery-title-phuket-laguna-park-2":"Welcome to Laguna Park 2 ","Gallery-title-phuket-skypark":"<p style='margin-bottom: 15px;'>Skypark</p><p style='margin-bottom: 15px;'>Laguna’s Newest Beachfront Condo<p/><p>near Bang Tao Beach</p>","Gallery-title-laguna-beachside":"<p style='margin-bottom: 15px;'>LAGUNA BEACHSIDE</p><p style='margin-bottom: 15px;'>SPACIOUS 1, 2 AND 3 BEDROOM BEACH FACING</p><p>CONDOMINIUMS WITHIN LAGUNA PHUKET</p>","Gallery-title-laguna-seaside-residences":"<p style='margin-bottom: 15px;'>STUNNING FREEHOLD CONDOMINIUMS JUST METRES FROM THE BEACH</p>","Gallery-title-laguna-seaside-residences-dev":"<p style='margin-bottom: 15px;'>STUNNING FREEHOLD CONDOMINIUMS JUST METRES FROM THE BEACH</p>","Aerial - 1":"Aerial - 1","Aerial - 2":"Aerial - 2","Exterior":"Exterior","Exterior - 1":"Exterior - 1","Exterior - 2":"Exterior - 2","Exterior - 3":"Exterior - 3","Interiors":"Interiors","Master Bedroom":"Master Bedroom","Master Bathroom":"Master Bathroom","Living Room - 1":"Living Room - 1","Living Room - 2":"Living Room - 2","Dining Room":"Dining Room","Multipurpose Room":"Multipurpose Room","Video":"Videos","360° Virtual Tour":"360° Virtual Tour","Concept":"Concept","Phuket’s most desired residential neighbourhood":"Phuket’s most desired residential neighbourhood","Master Plan":"Master Plan","Site Plan":"Site Plan","Residences":"Residences","Lower Floor":"Lower Floor","Upper Floor":"Upper Floor","View Images":"View Images","Virtual Tour":"Virtual Tour","Milestones":"Milestones","Images":"Images","Tour":"Tour","Destination":"Destination","Country Map":"Country Map","City Map":"City Map","Project Map":"Project Map","The Santuary Club":"The Santuary Club","Experience ultimate lifestyle within worldwide network under the Banyan Tree Group. Membership is exclusively offered to the owners of Laguna, Banyan Tree, Angsana and Cassia properties only.":"Experience ultimate lifestyle within worldwide network under the Banyan Tree Group. Membership is exclusively offered to the owners of Laguna, Banyan Tree, Angsana and Cassia properties only.","View Benefits":"View Benefits","Locations":"Locations","Resales":"Resales","Rentals":"Rentals","News/Promotions":"News/Promotions","About us":"About us","Newsletter signup":"Newsletter signup","Bintan":"Bintan","Phuket":"Phuket","Lăng Cô":"Lăng Cô","About the Club":"About the Club","Exclusive Privileges":"Exclusive Privileges","Exchange Programme":"Exchange Programme","The Network":"The Network","Properties":"Properties","FAQ":"FAQ","Construction Progress":"Construction Progress","Our Mission":"Our Mission","Developer":"Developer","E-Brochure":"E-Brochure","Contact":"Contact","Menu":"Menu","Description":"Description","Site Map":"Site Map","Term of Use":"Term of Use","Privacy Policy":"Privacy Policy","Legal":"Legal","Construction":"Construction","Estate And Property Management":"Estate And Property Management","Rental Options":"Rental Options","Privileges":"Privileges","Financing":"Financing","Property Management":"Property Management","Infrastructure & Common Areas":"Infrastructure & Common Areas","What types of ownership are available?":"What types of ownership are available?","What are the costs associated with the lease / freehold registration?":"What are the costs associated with the lease / freehold registration?","Is leasehold land transferable?":"Is leasehold land transferable?","Can leasehold be upgraded to freehold title?":"Can leasehold be upgraded to freehold title?","Is leasehold land ownership secure?":"Is leasehold land ownership secure?","Should I appoint a lawyer to review the agreements?":"Should I appoint a lawyer to review the agreements?","What is the measurement of square wah?":"What is the measurement of square wah?","When will be the lease / house transfer registration take place?":"When will be the lease / house transfer registration take place?","What types of Long Term Visas are available for Foreigners?":"What types of Long Term Visas are available for Foreigners?","Types and number of properties for sale?":"Types and number of properties for sale?","How long does construction take?":"How long does construction take?","What is the warranty period offered?":"What is the warranty period offered?","Is customization of the units allowed?":"Is customization of the units allowed?","Is customization of the building allowed?":"Is customization of the building allowed?","Is there a rental program available and what are the potential returns?":"Is there a rental program available and what are the potential returns?","What are the taxes levied on the rental program that an owner will be subject to?":"What are the taxes levied on the rental program that an owner will be subject to?","Is there a rental program available?":"Is there a rental program available?","What types of property management services are offered and what is the approximate cost?":"What types of property management services are offered and what is the approximate cost?","What privileges will I receive as an owner of a Laguna Phuket property?":"What privileges will I receive as an owner of a Laguna Phuket property?","How does the rental program work?":"How does the rental program work?","How is my rental return paid?":"How is my rental return paid?","Can I rent my villa out on my own?":"Can I rent my villa out on my own?","Can I choose my own furniture?":"Can I choose my own furniture?","Can I stay at any time?":"Can I stay at any time?","How much advance notice is required for my stay?":"How much advance notice is required for my stay?","Can my friends use my owner’s entitlement?":"Can my friends use my owner’s entitlement?","What utilities do I have to pay?":"What utilities do I have to pay?","Who will be entitled to the Golf Club membership?":"Who will be entitled to the Golf Club membership?","What infrastructure facilities and services are provided?":"What infrastructure facilities and services are provided?","What are the estimated common area charges?":"What are the estimated common area charges?","What are the terms of payment?":"What are the terms of payment?","Airport":"Airport","Beaches":"Beaches","Islands":"Islands","Schools":"Schools","Tourist Attrachtions":"Tourist Attrachtions","Hotels & Resorts":"Hotels & Resorts","Restaurant":"Restaurant","Restaurants":"Restaurants","Spas":"Spas","Galleries & Shopping":"Galleries & Shopping","Shuttle Bus":"Shuttle Bus","Shuttle Boat":"Shuttle Boat","Your Email Address":"Your Email Address","Submit":"Submit","This field is required":"This field is required","View Online":"View Online","Download":"Download","Please provide your name & email address":"Please provide your name & email address","Name":"Name","Email address":"Email address","About The club":"About The club","Priority wait list on reservations":"Priority wait list on reservations","Learn more":"Learn more","Ground Floor":"Ground Floor","Ground Floor (Standard)":"Ground Floor (standard)","Ground Floor (Deluxe – Upgrade)":"Ground Floor (Deluxe – Upgrade)","2 nd Floor":"2 nd Floor","2 nd Floor (Standard)":"2 nd Floor (Standard)","2 nd Floor (Deluxe – Upgrade)":"2 nd Floor (Deluxe – Upgrade)","Townhomes":"Townhomes","Villas":"Villas","Semi-detached":"Semi-detached","When will the lease / house transfer registration take place?":"When will the lease / house transfer registration take place?","Types and number of units in this project?":"Types and number of units in this project?","Is a warranty period offered?":"Is a warranty period offered?","What is included in the property?":"What is included in the property?","Cost for water and electricity meter installation?":"Cost for water and electricity meter installation?","What are the taxes levied on the rental income?":"What are the taxes levied on the rental income?","Can I rent out the property by myself short term and/or long term?":"Can I rent out the property by myself short term and/or long term?","What privileges will I receive as an owner?":"What privileges will I receive as an owner?","Will the property come with a golf membership?":"Will the property come with a golf membership?","1 st Floor":"1 st Floor","Outrigger Hotel Phuket Beach Resort":"SAii Laguna Phuket","Cassia Beach":"Cassia Beach","Dusit Thani Laguna Phuket":"Dusit Thani Laguna Phuket","Cassia Hotel":"Cassia Hotel","Canal Village Shopping":"Canal Village Shopping","Xana Beach Club":"Xana Beach Club","Baan Talay Restaurant":"Baan Talay Restaurant","Angsana Poolside":"Angsana Poolside","Bodega Restaurant":"Bodega Restaurant","Angsana Lobby":"Angsana Lobby","Banyan Tree Spa":"Banyan Tree Spa","Banyan Tree Lobby":"Banyan Tree Lobby","Owner benefits":"Owner benefits","Skypark":"Skypark","Skypark (New project)":"Skypark (New project)","Laguna Park":"Laguna Parkside","Laguna Park 2":"Laguna Park2","Laguna Beachside":"Laguna Beachside","Laguna Lakeside Residences":"Laguna Lakeside Residences","Laguna Seaside Residences":"Laguna Seaside"}

/***/ }),
/* 495 */
/***/ (function(module, exports) {

module.exports = {"Gallery":"楼盘相册","All Images":"全部图片","Residences – Aerial":"寓所——航拍","Residences – Exterior":"寓所——外部","Residences – Interior":"寓所——内部","Residences – Lifestyle":"寓所——生活方式","Residences – Common Area":"寓所——公共區域","Destination Lifestyle":"度假胜地生活方式","Laguna Village Residences":"乐古浪乡村别墅","Laguna Village <strong>Residences</strong>":"<strong>乐古浪</strong>乡村别墅","Gallery-title-phuket-laguna-village-residences":"<strong>乐古浪</strong>乡村别墅","Gallery-title-phuket-laguna-park-2":"乐古浪熙园 2","Gallery-title-phuket-skypark":"海天苑","Gallery-title-laguna-beachside":"<p style='margin-bottom: 15px;'>悦海苑</p><p style='margin-bottom: 15px;'>位于普吉岛乐古浪全新宽敞的1、2和3卧海滨公寓</p>","Gallery-title-laguna-seaside-residences":"<p style='margin-bottom: 15px;'>宽敞的永久产权公寓 距离海滩仅数米之遥</p>","Gallery-title-laguna-seaside-residences-dev":"<p style='margin-bottom: 15px;'>宽敞的永久产权公寓 距离海滩仅数米之遥</p>","Aerial - 1":"航拍-1","Aerial - 2":"航拍-2","Exterior":"外观","Exterior - 1":"外观-1","Exterior - 2":"外观-2","Exterior - 3":"外观-3","Interiors":"内部","Master Bedroom":"主卧","Master Bathroom":"主浴室","Living Room - 1":"起居室-1","Living Room - 2":"起居室-2","Dining Room":"餐厅","Multipurpose Room":"多功能区","Video":"视频","360° Virtual Tour":"360°虚拟导览","Concept":"建筑概念","Phuket’s most desired residential neighbourhood":"普吉岛最受青睐的住宅区","Master Plan":"总平面图","Site Plan":"平面图","Residences":"寓所","Lower Floor":"下层","Upper Floor":"上层","View Images":"查看图片","Virtual Tour":"虚拟导览","Milestones":"发展历程","Images":"全部图片","Tour":"虚拟导览","Destination":"目的地","Country Map":"国家地图","City Map":"城市地图","Project Map":"项目地图","The Santuary Club":"榕源会","Experience ultimate lifestyle within worldwide network under the Banyan Tree Group. Membership is exclusively offered to the owners of Laguna, Banyan Tree, Angsana and Cassia properties only.":"体验悦榕集团全球网络内的精华生活方式。仅向乐古浪、悦榕庄、悦椿和悦梿物业的业主提供会员权益。","View Benefits":"查看利益","Locations":"地点","Resales":"转卖","Rentals":"租赁","News/Promotions":"新闻/推广","About us":"关于我们","Newsletter signup":"简讯","Bintan":"民丹岛","Phuket":"普吉岛","Lăng Cô":"兰珂","About the Club":"会所介绍","Exclusive Privileges":"专属特权","Exchange Programme":"交换项目","The Network":"网络","Properties":"物业","FAQ":"常见问题","Construction Progress":"施工进度","Our Mission":"我们的使命","Developer":"开发商","E-Brochure":"电子手册","Contact":"联系我们","Menu":"菜单","Description":"说明","Site Map":"网站导航","Term of Use":"使用条款","Privacy Policy":"隐私保护政策","Legal":"法务","Construction":"建筑施工","Estate And Property Management":"地产和物业管理","Rental Options":"出租方案","Privileges":"特权","Financing":"财务","Property Management":"物业管理","Infrastructure & Common Areas":"基础设施和公共区域","What types of ownership are available?":"有哪些类型的所有权？","What are the costs associated with the lease / freehold registration?":"租赁/永久产权的登记费用是多少？","Is leasehold land transferable?":"租赁土地是否可转让？","Can leasehold be upgraded to freehold title?":"租赁权是否可以升级为永久产权？","Is leasehold land ownership secure?":"租赁土地所有权是否有保障？","Should I appoint a lawyer to review the agreements?":"我是否应该委托律师审核协议？","What is the measurement of square wah?":"平方瓦（wah）是什么度量单位？","When will be the lease / house transfer registration take place?":"租赁/房屋转让登记将在何时进行？","What types of Long Term Visas are available for Foreigners?":"What types of Long Term Visas are available for Foreigners?","Types and number of properties for sale?":"出售的房地产类型和数量？","How long does construction take?":"施工需要多长时间？","What is the warranty period offered?":"提供的保修期有多长？","Is customization of the units allowed?":"是否允许对房产内物品进行定制？","Is customization of the building allowed?":"是否可以根据个人喜好或需要对房屋进行改建？","Is there a rental program available and what are the potential returns?":"贵方是否提供任何租赁计划？如果有，潜在回报是多少？","What are the taxes levied on the rental program that an owner will be subject to?":"对于租赁计划业主将被征收哪些税款？","Is there a rental program available?":"有租赁计划吗？","What types of property management services are offered and what is the approximate cost?":"提供哪些类型的物业管理服务，大概成本是多少？","What privileges will I receive as an owner of a Laguna Phuket property?":"作为普吉岛乐古浪房地产的业主，我将获得什么特权？","How does the rental program work?":"租赁计划的具体内容是？","How is my rental return paid?":"租金回报如何支付？","Can I rent my villa out on my own?":"我可以自行将我的别墅出租吗？","Can I choose my own furniture?":"我可以选择自己的家具吗？","Can I stay at any time?":"我可以随时入住吗？","How much advance notice is required for my stay?":"我需要提前多久发出入住通知？","Can my friends use my owner’s entitlement?":"我的朋友是否可以使用我的业主权利？","What utilities do I have to pay?":"我需要支付哪些公共事业费？","Who will be entitled to the Golf Club membership?":"哪些人有资格成为高尔夫俱乐部的会员？","What infrastructure facilities and services are provided?":"贵方提供哪些基础设施和服务？","What are the estimated common area charges?":"公共区域管理费预计是多少？","What are the terms of payment?":"付款方式是什么？","Airport":"机场","Beaches":"海滩","Islands":"岛","Schools":"学校","Tourist Attrachtions":"旅游景点","Hotels & Resorts":"酒店与度假村","Restaurant":"餐厅","Restaurants":"餐厅","Spas":"水疗中心","Galleries & Shopping":"精品和购物","Shuttle Bus":"班车","Shuttle Boat":"渡船","Your Email Address":"您的邮箱地址","Submit":"提交","This field is required":"此处为必填项","View Online":"下载手册","Download":"下载手册","Please provide your name & email address":"请填写您的姓名和邮箱","Name":"名","Email address":"电子邮件","About The club":"会所介绍","Priority wait list on reservations":"预订时享有优先权","Learn more":"更多信息","Ground Floor":"一楼","Ground Floor (Standard)":"底层标准","Ground Floor (Deluxe – Upgrade)":"底层升级版","2 nd Floor":"2楼","2 nd Floor (Standard)":"2楼","2 nd Floor (Deluxe – Upgrade)":"2楼升级版","Townhomes":"联排别墅","Villas":"独栋别墅","Semi-detached":"双拼别墅","When will the lease / house transfer registration take place?":"租赁/永久产权的登记费用是多少？","Types and number of units in this project?":"此项目有什么户型，分别有多少个单元？","Is a warranty period offered?":"保修期为多久？","What is included in the property?":"房产中包括哪些设施？","Cost for water and electricity meter installation?":"水表和电表的安装费用是多少？","What are the taxes levied on the rental income?":"出租物业的业主须缴纳哪些税费？","Can I rent out the property by myself short term and/or long term?":"我可以自己短期或长期出租物业吗？","What privileges will I receive as an owner?":"作为Laguna Park的业主，我将享有哪些优惠？","Will the property come with a golf membership?":"此物业业主可以获得高尔夫俱乐部的会员吗？","GROUND FLOOR":"底层","1 st Floor":"1楼","Outrigger Hotel Phuket Beach Resort":"SAii Laguna Phuket","Cassia Beach":"悦梿海滩","Dusit Thani Laguna Phuket":"普吉岛乐古浪都喜天阙酒店","Cassia Hotel":"悦梿酒店","Canal Village Shopping":"运河村购物中心","Xana Beach Club":"Xana海滩俱乐部","Baan Talay Restaurant":"Baan Talay餐厅","Angsana Poolside":"悦椿Pool Side","Bodega Restaurant":"Bodega餐厅","Angsana Lobby":"悦椿酒店大堂","Banyan Tree Spa":"悦榕Spa","Banyan Tree Lobby":"悦榕庄大堂","Estate and property management":"配套设施及物业管理","Owner benefits":"业主福利","Skypark":"海天苑","Skypark (New project)":"海天苑","Laguna Park":"乐古浪熙苑住宅","Laguna Park 2":"拉古纳公园 2","Laguna Beachside":"悦海苑","Laguna Lakeside Residences":"乐古浪湖滨住宅","Laguna Seaside Residences":"乐古浪海滨公寓"}

/***/ }),
/* 496 */
/***/ (function(module, exports) {

module.exports = {"Gallery":"ГАЛЕРЕЯ","All Images":"ВСЕ ИЗОБРАЖЕНИЯ","Residences – Aerial":"РЕЗИДЕНЦИИ – АЭРОФОТОСЪЕМКА","Residences – Exterior":"РЕЗИДЕНЦИИ – ЭКСТЕРЬЕР","Residences – Interior":"РЕЗИДЕНЦИИ – ИНТЕРЬЕР","Residences – Lifestyle":"РЕЗИДЕНЦИИ – СТИЛЬ ЖИЗНИ","Residences – Common Area":"РЕЗИДЕНЦИИ - ОБЩАЯ ОБЛАСТЬ","Destination Lifestyle":"НАПРАВЛЕНИЕ – СТИЛЬ ЖИЗНИ","Laguna Village Residences":"ВИЛЛЫ LAGUNA VILLAGE RESIDENCES","Laguna Village <strong>Residences</strong>":"Laguna Village <strong>Residences</strong>","Gallery-title-phuket-laguna-village-residences":"Laguna Village <strong>Residences</strong>","Gallery-title-phuket-laguna-park-2":"Laguna Park Фаза 2","Gallery-title-phuket-skypark":"SKYPARK","Gallery-title-laguna-beachside":"<p style='margin-bottom: 15px;'>LAGUNA BEACHSIDE</p><p style='margin-bottom: 15px;'>НОВЫЕ ПРОСТОРНЫЕ КВАРТИРЫ С 1, 2 И 3</p><p>СПАЛЬНЯМИ У САМОГО ПЛЯЖА В ЛАГУНА ПХУКЕТ</p>","Gallery-title-laguna-seaside-residences":"<p style='margin-bottom: 15px;'>ПРОСТОРНЫЕ КОНДОМИНИУМЫ С ПРАВОМ ПОЛНОГО ВЛАДЕНИЯ В НЕСКОЛЬКИХ МЕТРАХ ОТ ПЛЯЖА</p>","Gallery-title-laguna-seaside-residences-dev":"<p style='margin-bottom: 15px;'>ПРОСТОРНЫЕ КОНДОМИНИУМЫ С ПРАВОМ ПОЛНОГО ВЛАДЕНИЯ В НЕСКОЛЬКИХ МЕТРАХ ОТ ПЛЯЖА</p>","Aerial - 1":"АЭРОФОТОСЪЕМКА-1","Aerial - 2":"АЭРОФОТОСЪЕМКА-2","Exterior":"ЭКСТЕРЬЕР","Exterior - 1":"ЭКСТЕРЬЕР-1","Exterior - 2":"ЭКСТЕРЬЕР-2","Exterior - 3":"ЭКСТЕРЬЕР-3","Interiors":"ИНТЕРЬЕР","Master Bedroom":"ГЛАВНАЯ СПАЛЬНЯ","Master Bathroom":"ГЛАВНАЯ ВАННАЯ КОМНАТА","Living Room - 1":"ГОСТИНАЯ-1","Living Room - 2":"ГОСТИНАЯ-2","Dining Room":"СТОЛОВАЯ","Multipurpose Room":"МНОГОФУНКЦИОНАЛЬНАЯ ЗОНА","Video":"ВИДЕО","360° Virtual Tour":"ВИРТУАЛЬНЫЙ ТУР 360º","Concept":"КОНЦЕПТ","Phuket’s most desired residential neighbourhood":"Самый желанный жилой район на Пхукете","Master Plan":"ГЕНЕРАЛЬНЫЙ ПЛАН","Site Plan":"ПЛАН ТЕРРИТОРИИ","Residences":"РЕЗИДЕНЦИИ","Lower Floor":"НИЖНИЙ ЭТАЖ","Upper Floor":"ВЕРХНИЙ ЭТАЖ","View Images":"ПРОСМОТР ИЗОБРАЖЕНИЙ","Virtual Tour":"ВИРТУАЛЬНЫЙ ТУР","Milestones":"ИСТОРИЯ","Images":"ВСЕ ИЗОБРАЖЕНИЯ","Tour":"ВИРТУАЛЬНЫЙ ТУР 360º","Destination":"ПУНКТ НАЗНАЧЕНИЯ","Country Map":"КАРТА СТРАНЫ","City Map":"КАРТА ГОРОДА","Project Map":"КАРТА ПРОЕКТОВ","The Santuary Club":"ПРОГРАММА SANCTUARY CLUB","Experience ultimate lifestyle within worldwide network under the Banyan Tree Group. Membership is exclusively offered to the owners of Laguna, Banyan Tree, Angsana and Cassia properties only.":"Наслаждайтесь роскошным стилем жизни, пользуясь глобальной сетью группы Banyan Tree Group. Членство предлагается только владельцам собственности в рамках проектов Laguna, Banyan Tree, Angsana и Cassia.","View Benefits":"ПОКАЗАТЬ ПРЕИМУЩЕСТВА","Locations":"МЕСТОПОЛОЖЕНИЕ","Resales":"ПЕРЕПРОДАЖА","Rentals":"АРЕНДА","News/Promotions":"Новости/акции","About us":"О НАС","Newsletter signup":"ПОДПИСАТЬСЯ НА РАССЫЛКУ","Bintan":"Бинтан","Phuket":"Пхукет","Lăng Cô":"Ланг Ко","About the Club":"О программе","Exclusive Privileges":"Эксклюзивные привилегии","Exchange Programme":"Программа обмена","The Network":"Сеть","Properties":"Объекты недвижимости","FAQ":"Вопросы","Construction Progress":"Прогресс строительства","Our Mission":"Наша миссия","Developer":"Застройщик","E-Brochure":"ЭЛЕКТРОННАЯ БРОШЮРА","Contact":"КОНТАКТЫ","Menu":"МЕНЮ","Description":"ОПИСАНИЕ","Site Map":"Карта сайта","Term of Use":"Пользовательское соглашение","Privacy Policy":"Политика конфиденциальности","Legal":"ЮРИДИЧЕСКИЕ","Construction":"СТРОИТЕЛЬСТВО","Estate And Property Management":"УПРАВЛЕНИЕ НЕДВИЖИМОСТЬЮ","Rental Options":"СДАЧА В АРЕНДУ","Privileges":"ПРИВИЛЕГИИ","Financing":"ФИНАНСИРОВАНИЕ","Property Management":"УПРАВЛЕНИЕ НЕДВИЖИМОСТЬЮ","Infrastructure & Common Areas":"ИНФРАСТРУКТУРА И ТЕРРИТОРИИ ОБЩЕГО ПОЛЬЗОВАНИЯ","What types of ownership are available?":"Какие формы собственности существуют?","What are the costs associated with the lease / freehold registration?":"Каковы затраты, связанные с арендой / регистрацией собственности?","Is leasehold land transferable?":"Возможна ли передача прав аренды земельного участка?","Can leasehold be upgraded to freehold title?":"Можно ли преобразовать владение на правах аренды в полное бессрочное владение?","Is leasehold land ownership secure?":"Существует ли риск при владении земельным участком на правах аренды?","Should I appoint a lawyer to review the agreements?":"Требуется ли проверка соглашений юристом?","What is the measurement of square wah?":"Что такое квадратный ваа?","When will be the lease / house transfer registration take place?":"Когда происходит регистрация аренды земли / собственности?","What types of Long Term Visas are available for Foreigners?":"What types of Long Term Visas are available for Foreigners?","Types and number of properties for sale?":"Тип недвижимости и количество единиц в этом проекте?","How long does construction take?":"Как долго продлится строительство?","What is the warranty period offered?":"Каков предлагаемый гарантийный период?","Is customization of the units allowed?":"Допускается ли индивидуальная доработка помещений?","Is customization of the building allowed?":"Можно ли перестраивать или перепланировать объект?","Is there a rental program available and what are the potential returns?":"Существует ли программа аренды и насколько она прибыльная?","What are the taxes levied on the rental program that an owner will be subject to?":"Каковы налоги оплачивает владелец недвижимости при участии в программе аренды?","Is there a rental program available?":"Предусмотрена ли арендная программа?","What types of property management services are offered and what is the approximate cost?":"ККакие предоставляются услуги по управлению недвижимостью и какова их стоимость?","What privileges will I receive as an owner of a Laguna Phuket property?":"Какие привилегии я получаю как собственник недвижимости Laguna Phuket?","How does the rental program work?":"Как работает арендная программа?","How is my rental return paid?":"Как выплачиваются доходы от аренды?","Can I rent my villa out on my own?":"我可以自行将我的别墅出租吗？","Can I choose my own furniture?":"Могу ли я выбрать собственную мебель?","Can I stay at any time?":"Могу ли я останавливаться на своей вилле в любое время?","How much advance notice is required for my stay?":"За сколько дней я должен подать уведомление о проживании в апартаментах?","Can my friends use my owner’s entitlement?":"","What utilities do I have to pay?":"Какие коммунальные расходы мне необходимо оплачивать?","Who will be entitled to the Golf Club membership?":"Кто имеет  право на членство в гольф-клубе?","What infrastructure facilities and services are provided?":"К каким объектам инфраструктуры и услугам предоставляется доступ?","What are the estimated common area charges?":"Каков уровень платежей по уходу за общей территорией?","What are the terms of payment?":"Какие условия оплаты существуют?","Airport":"Аэропорт","Beaches":"Пляжи","Islands":"Острова","Schools":"Школы","Tourist Attrachtions":"Достопримечательности","Hotels & Resorts":"ОТЕЛИ И КУРОРТЫ","Restaurant":"Рестораны","Restaurants":"Рестораны","Spas":"СПА-ЦЕНТРЫ","Galleries & Shopping":"ТОРГОВЫЕ ГАЛЕРЕИ И ШОПИНГ","Shuttle Bus":"Маршрутный автобус","Shuttle Boat":"Речной трамвайчик","Your Email Address":"Ваш адрес электронной почты","Submit":"Отправить","This field is required":"Эта строка должна быть заполнена","View Online":"ПРОСМОТР ОНЛАЙН","Download":"СКАЧАТЬ БРОШЮРУ","Please provide your name & email address":"Укажите свое имя и эл. адрес","Name":"ИМЯ","Email address":"Адрес электронной почты","About The club":"О ПРОГРАММЕ","Priority wait list on reservations":"ПРИОРИТЕТНЫЙ СПИСОК ОЧЕРЕДНОСТИ ПРИ БРОНИРОВАНИИ","Learn more":"Узнать больше","Ground Floor":"Цокольный этаж","Ground Floor (Standard)":"Цокольный этаж (стандарт)","Ground Floor (Deluxe – Upgrade)":"Цокольный этаж (Делюкс)","2 nd Floor":"2-й этаж","2 nd Floor (Standard)":"2-й этаж (стандарт)","2 nd Floor (Deluxe – Upgrade)":"2-й этаж (Делюкс)","Townhomes":"Таунхаусы","Villas":"Виллы","Semi-detached":"Дуплекс","When will the lease / house transfer registration take place?":"When will the lease / house transfer registration take place?","Types and number of units in this project?":"Types and number of units in this project?","Is a warranty period offered?":"Is a warranty period offered?","What is included in the property?":"What is included in the property?","Cost for water and electricity meter installation?":"Cost for water and electricity meter installation?","What are the taxes levied on the rental income?":"What are the taxes levied on the rental income?","Can I rent out the property by myself short term and/or long term?":"Can I rent out the property by myself short term and/or long term?","What privileges will I receive as an owner?":"What privileges will I receive as an owner?","Will the property come with a golf membership?":"Предполагает ли наличие собственности членство в гольф-клубе?","GROUND FLOOR":"Цокольный этаж","1 st Floor":"1-й этаж","Outrigger Hotel Phuket Beach Resort":"Отель SAii Laguna Phuket","Cassia Beach":"Cassia Beach","Dusit Thani Laguna Phuket":"Отель Dusit Thani Laguna Phuket","Cassia Hotel":"Cassia Hotel","Canal Village Shopping":"Canal Village Shopping","Xana Beach Club":"Xana Beach Club","Baan Talay Restaurant":"Baan Talay Restaurant","Angsana Poolside":"Angsana Poolside","Bodega Restaurant":"Bodega Restaurant","Angsana Lobby":"Angsana Lobby","Banyan Tree Spa":"Banyan Tree Spa","Banyan Tree Lobby":"Banyan Tree Lobby","Owner benefits":"ПРЕИМУЩЕСТВА ДЛЯ ВЛАДЕЛЬЦЕВ","Skypark":"Skypark","Skypark (New project)":"Skypark (New project)","Laguna Park":"Laguna Parkside Residences","Laguna Park 2":"Laguna Park 2","Laguna Beachside":"Laguna Beachside","Laguna Lakeside Residences":"Laguna Lakeside Residences","Laguna Seaside Residences":"Laguna Seaside Residences"}

/***/ }),
/* 497 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 498 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABDBAMAAACYZb3pAAAAMFBMVEXvKQD//wD3IQD3KQD3UgD3YwDvIQD3WgD/9wD1pQD/7wD/3gD7tQD31gD3awDvSgBgWfT/AAAA9ElEQVRIx+3UT2oCMRzF8adplXaVNyIttItYoZtuYltwJf65gXgBwRN4BD2BeAKP4lE8igQmgqvkgQvBfBbDLOZLZpIfA4f71kT0Z+X2IzcZxRszp89LepO4CvfITA71zcrvMpONhYr6PtGqY/CsrdJg9JmbmEvTQi5XFzZ+2GyRSr7+GVQGNW6R8r0OST8OSptv6TcbXi3SnhokDUi+O0SvLnOfIZmzM6U4Ll2AHalhONBqKRRPVbhaHxf16eSlH+ZmfHlSHWrjB78QNUiv/tFYOYi6W7Vo+ZPHY2oavTlCP/mJmvQI1Y+FzOnJEkVRFMVNnAHdNxSE8kDWLAAAAABJRU5ErkJggg=="

/***/ }),
/* 499 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAGQAAABDBAMAAACYZb3pAAAAJFBMVEX/////AAAAAP9YWP9VAKr/////AAD/////AAAAAP9YWP9VAKo2nORAAAAAB3RSTlPy8vLy8uXlpW0SSwAAAFFJREFUSMdjCGAgEbAylJMMGNhJ1VEwqmVUy6iW4aDFahWJYDGD5kwSwaRRLaNaRrWMUC3eu0kEWxgkOkgEjaNaRrWMahkOWjpIBgyJgiQCMQA0NbY4NgXwIgAAAABJRU5ErkJggg=="

/***/ }),
/* 500 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Modal; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_remove__ = __webpack_require__(501);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_remove___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_remove__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_join__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_join___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_join__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_includes__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_split__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_split___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_split__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__IconButton__ = __webpack_require__(508);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__icons_Close__ = __webpack_require__(101);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp2;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import React, { PureComponent } from "react";
// import { withRouter } from "react-router-dom";
// import PropTypes from "prop-types";
// import _ from "lodash";
// import IconButton from "./IconButton";
// import Close from "./icons/Close";
// import {
//   getParameterByName,
//   parameterToObject,
//   objectToParameter
// } from "../utils";
// @withRouter
// export default class Modal extends PureComponent {
//   static propTypes = {
//     children: PropTypes.node,
//     visible: PropTypes.bool,
//     onCancel: PropTypes.func,
//     className: PropTypes.string,
//     name: PropTypes.string
//   };
//   static defaultProps = {
//     children: null,
//     visible: false,
//     onCancel: () => null,
//     className: "",
//     name: ""
//   };
//   constructor(props) {
//     super(props);
//     this._popup = React.createRef();
//     this.state = { visible: props.visible };
//   }
//   componentDidMount() {
//     this.init(this.props.visible);
//     // if (this._popup.current) {
//     //   this._popup.current.style.height = window.innerHeight + "px"; // Fix iOS, Android -> calculate real window height;
//     //   window.addEventListener("resize", this.onResize);
//     // }
//   }
//   componentWillReceiveProps(nextProps) {
//     if (!_.isEqual(this.props.visible, nextProps.visible)) {
//       this.init(nextProps.visible);
//     }
//   }
//   // onResize = () => {
//   //   this._popup.current.style.height = window.innerHeight + "px";
//   // };
//   // componentWillUnmount() {
//   //   window.removeEventListener("resize", this.onResize);
//   // }
//   setVisible = visible => {
//     if (this.state.visible !== visible) {
//       this.setState({ visible });
//     }
//   };
//   setUrl = () => {
//     const { name } = this.props;
//     const paramObj = parameterToObject();
//     paramObj.modal = name;
//     const param = objectToParameter(paramObj);
//     this.props.history.push(`?${param}`);
//   };
//   init = visible => {
//     const { name } = this.props;
//     const modalParam = getParameterByName("modal");
//     if (modalParam === name) {
//       this.setVisible(true);
//       document.body.style.overflow = "hidden";
//     } else {
//       this.setVisible(visible);
//       if (visible) {
//         this.setUrl();
//         document.body.style.overflow = "hidden";
//       }
//     }
//   };
//   handleClickClose = () => {
//     this.setVisible(false);
//     this.props.onCancel();
//     setTimeout(() => {
//       const modalComponents = document.querySelectorAll(".modal-component");
//       let hasModalShow = false;
//       for (let index = 0; index < modalComponents.length; index++) {
//         const modalComponent = modalComponents[index];
//         if (modalComponent.classList.contains("open")) {
//           hasModalShow = true;
//           break;
//         }
//       }
//       if (hasModalShow) {
//         document.body.style.overflow = "hidden";
//       } else {
//         document.body.style.overflow = "auto";
//       }
//     }, 100);
//     if (document.referrer) {
//       this.props.history.goBack();
//     } else {
//       this.props.history.push(this.props.location.pathname);
//     }
//   };
//   getHtml = () => {
//     return (
//       <React.Fragment>
//         <div className="icon-close">
//           <IconButton onClick={this.handleClickClose}>
//             <Close width={20} height={20} fill="white" />
//           </IconButton>
//         </div>
//         {this.props.children}
//       </React.Fragment>
//     );
//   };
//   render() {
//     const { className } = this.props;
//     const { visible } = this.state;
//     return (
//       <div
//         ref={this._popup}
//         className={`modal-component ${className} ${visible ? "open" : ""}`}
//       >
//         {this.getHtml()}
//       </div>
//     );
//   }
// }
// import {
//   getParameterByName,
//   parameterToObject,
//   objectToParameter
// } from "../utils";
var Modal=(_temp2=_class=function(_Component){_inherits(Modal,_Component);function Modal(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Modal);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Modal.__proto__||Object.getPrototypeOf(Modal)).call.apply(_ref,[this].concat(args))),_this),_this.state={// showModal: false
},_this.addClassName=function(element,name){var arr=__WEBPACK_IMPORTED_MODULE_3_lodash_split___default()(element.className," ");if(!__WEBPACK_IMPORTED_MODULE_2_lodash_includes___default()(arr,name)){arr.push(name);}element.className=__WEBPACK_IMPORTED_MODULE_1_lodash_join___default()(arr," ");},_this.removeClassName=function(element,name){var arr=__WEBPACK_IMPORTED_MODULE_3_lodash_split___default()(element.className," ");if(__WEBPACK_IMPORTED_MODULE_2_lodash_includes___default()(arr,name)){__WEBPACK_IMPORTED_MODULE_0_lodash_remove___default()(arr,function(value){return value===name;});}element.className=__WEBPACK_IMPORTED_MODULE_1_lodash_join___default()(arr," ");},_this.setOverflow=function(overflow){// document.documentElement.style.overflow = overflow; // this line cause hash to change
document.body.style.overflow=overflow;},_this.handleClickClose=function(){_this.removeClassName(_this._popup,"open");setTimeout(function(){_this.props.onCancel();var modalComponents=document.querySelectorAll(".modal-component");var hasModalShow=false;for(var index=0;index<modalComponents.length;index++){var modalComponent=modalComponents[index];if(modalComponent.classList.contains("open")){hasModalShow=true;break;}}if(hasModalShow){_this.setOverflow("hidden");}else{_this.setOverflow("inherit");}},300);// if (document.referrer) {
//   window.history.back();
// } else {
//   window.history.pushState({}, null, window.location.pathname);
// }
},_this.getHtml=function(){return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",{className:"icon-close"},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__IconButton__["a" /* default */],{onClick:_this.handleClickClose},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__icons_Close__["a" /* default */],{width:20,height:20,fill:"white"}))),_this.props.children);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Modal,[{key:"componentDidMount",value:function componentDidMount(){var className=this.props.className;// const modalParam = getParameterByName("modal");
// if (modalParam === name) this.setState({ showModal: true });
this._popup=document.createElement("div");this._popup.className="modal-component "+className;document.body.appendChild(this._popup);this._render();}},{key:"componentDidUpdate",value:function componentDidUpdate(){this._render();}},{key:"componentWillUnmount",value:function componentWillUnmount(){__WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.unmountComponentAtNode(this._popup);document.body.removeChild(this._popup);}// setUrl = () => {
//   const { name } = this.props;
//   const paramObj = parameterToObject();
//   paramObj.modal = name;
//   const param = objectToParameter(paramObj);
//   window.history.pushState({}, null, `?${param}`);
// };
},{key:"_render",value:function _render(){var _this2=this;this.setOverflow("hidden");__WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.render(this.getHtml(),this._popup);setTimeout(function(){_this2.addClassName(_this2._popup,"open");},200);}},{key:"render",value:function render(){return null;}}]);return Modal;}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]),_class.propTypes={children:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.node,onCancel:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func,className:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.string},_class.defaultProps={children:null,onCancel:function onCancel(){return null;},className:""},_temp2);

/***/ }),
/* 501 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(36),
    basePullAt = __webpack_require__(502);

/**
 * Removes all elements from `array` that `predicate` returns truthy for
 * and returns an array of the removed elements. The predicate is invoked
 * with three arguments: (value, index, array).
 *
 * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
 * to pull elements from an array by value.
 *
 * @static
 * @memberOf _
 * @since 2.0.0
 * @category Array
 * @param {Array} array The array to modify.
 * @param {Function} [predicate=_.identity] The function invoked per iteration.
 * @returns {Array} Returns the new array of removed elements.
 * @example
 *
 * var array = [1, 2, 3, 4];
 * var evens = _.remove(array, function(n) {
 *   return n % 2 == 0;
 * });
 *
 * console.log(array);
 * // => [1, 3]
 *
 * console.log(evens);
 * // => [2, 4]
 */
function remove(array, predicate) {
  var result = [];
  if (!(array && array.length)) {
    return result;
  }
  var index = -1,
      indexes = [],
      length = array.length;

  predicate = baseIteratee(predicate, 3);
  while (++index < length) {
    var value = array[index];
    if (predicate(value, index, array)) {
      result.push(value);
      indexes.push(index);
    }
  }
  basePullAt(array, indexes);
  return result;
}

module.exports = remove;


/***/ }),
/* 502 */
/***/ (function(module, exports, __webpack_require__) {

var baseUnset = __webpack_require__(256),
    isIndex = __webpack_require__(94);

/** Used for built-in method references. */
var arrayProto = Array.prototype;

/** Built-in value references. */
var splice = arrayProto.splice;

/**
 * The base implementation of `_.pullAt` without support for individual
 * indexes or capturing the removed elements.
 *
 * @private
 * @param {Array} array The array to modify.
 * @param {number[]} indexes The indexes of elements to remove.
 * @returns {Array} Returns `array`.
 */
function basePullAt(array, indexes) {
  var length = array ? indexes.length : 0,
      lastIndex = length - 1;

  while (length--) {
    var index = indexes[length];
    if (length == lastIndex || index !== previous) {
      var previous = index;
      if (isIndex(index)) {
        splice.call(array, index, 1);
      } else {
        baseUnset(array, index);
      }
    }
  }
  return array;
}

module.exports = basePullAt;


/***/ }),
/* 503 */
/***/ (function(module, exports, __webpack_require__) {

var baseGet = __webpack_require__(96),
    baseSlice = __webpack_require__(251);

/**
 * Gets the parent value at `path` of `object`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} path The path to get the parent value of.
 * @returns {*} Returns the parent value.
 */
function parent(object, path) {
  return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
}

module.exports = parent;


/***/ }),
/* 504 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.isNaN` without support for number objects.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
 */
function baseIsNaN(value) {
  return value !== value;
}

module.exports = baseIsNaN;


/***/ }),
/* 505 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.indexOf` which performs strict equality
 * comparisons of values, i.e. `===`.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {*} value The value to search for.
 * @param {number} fromIndex The index to search from.
 * @returns {number} Returns the index of the matched value, else `-1`.
 */
function strictIndexOf(array, value, fromIndex) {
  var index = fromIndex - 1,
      length = array.length;

  while (++index < length) {
    if (array[index] === value) {
      return index;
    }
  }
  return -1;
}

module.exports = strictIndexOf;


/***/ }),
/* 506 */
/***/ (function(module, exports, __webpack_require__) {

var baseValues = __webpack_require__(507),
    keys = __webpack_require__(59);

/**
 * Creates an array of the own enumerable string keyed property values of `object`.
 *
 * **Note:** Non-object values are coerced to objects.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property values.
 * @example
 *
 * function Foo() {
 *   this.a = 1;
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.values(new Foo);
 * // => [1, 2] (iteration order is not guaranteed)
 *
 * _.values('hi');
 * // => ['h', 'i']
 */
function values(object) {
  return object == null ? [] : baseValues(object, keys(object));
}

module.exports = values;


/***/ }),
/* 507 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(69);

/**
 * The base implementation of `_.values` and `_.valuesIn` which creates an
 * array of `object` property values corresponding to the property names
 * of `props`.
 *
 * @private
 * @param {Object} object The object to query.
 * @param {Array} props The property names to get values for.
 * @returns {Object} Returns the array of property values.
 */
function baseValues(object, props) {
  return arrayMap(props, function(key) {
    return object[key];
  });
}

module.exports = baseValues;


/***/ }),
/* 508 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Button__ = __webpack_require__(76);
/* harmony default export */ __webpack_exports__["a"] = (function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__Button__["a" /* default */],Object.assign({},props,{defaultStyle:{padding:'12px',paddingBottom:'6px',display:'block',lineHeight:'20px',background:'#363636',color:'white'},hoverStyle:{background:'#00a9a7'}}),props.children);});

/***/ }),
/* 509 */
/***/ (function(module, exports, __webpack_require__) {

var basePickBy = __webpack_require__(260),
    hasIn = __webpack_require__(246);

/**
 * The base implementation of `_.pick` without support for individual
 * property identifiers.
 *
 * @private
 * @param {Object} object The source object.
 * @param {string[]} paths The property paths to pick.
 * @returns {Object} Returns the new object.
 */
function basePick(object, paths) {
  return basePickBy(object, paths, function(value, path) {
    return hasIn(object, path);
  });
}

module.exports = basePick;


/***/ }),
/* 510 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(264);

/**
 * Flattens `array` a single level deep.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Array
 * @param {Array} array The array to flatten.
 * @returns {Array} Returns the new flattened array.
 * @example
 *
 * _.flatten([1, [2, [3, [4]], 5]]);
 * // => [1, 2, [3, [4]], 5]
 */
function flatten(array) {
  var length = array == null ? 0 : array.length;
  return length ? baseFlatten(array, 1) : [];
}

module.exports = flatten;


/***/ }),
/* 511 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(71),
    isArguments = __webpack_require__(92),
    isArray = __webpack_require__(13);

/** Built-in value references. */
var spreadableSymbol = Symbol ? Symbol.isConcatSpreadable : undefined;

/**
 * Checks if `value` is a flattenable `arguments` object or array.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
 */
function isFlattenable(value) {
  return isArray(value) || isArguments(value) ||
    !!(spreadableSymbol && value && value[spreadableSymbol]);
}

module.exports = isFlattenable;


/***/ }),
/* 512 */
/***/ (function(module, exports) {

/**
 * A faster alternative to `Function#apply`, this function invokes `func`
 * with the `this` binding of `thisArg` and the arguments of `args`.
 *
 * @private
 * @param {Function} func The function to invoke.
 * @param {*} thisArg The `this` binding of `func`.
 * @param {Array} args The arguments to invoke `func` with.
 * @returns {*} Returns the result of `func`.
 */
function apply(func, thisArg, args) {
  switch (args.length) {
    case 0: return func.call(thisArg);
    case 1: return func.call(thisArg, args[0]);
    case 2: return func.call(thisArg, args[0], args[1]);
    case 3: return func.call(thisArg, args[0], args[1], args[2]);
  }
  return func.apply(thisArg, args);
}

module.exports = apply;


/***/ }),
/* 513 */
/***/ (function(module, exports, __webpack_require__) {

var constant = __webpack_require__(514),
    defineProperty = __webpack_require__(262),
    identity = __webpack_require__(98);

/**
 * The base implementation of `setToString` without support for hot loop shorting.
 *
 * @private
 * @param {Function} func The function to modify.
 * @param {Function} string The `toString` result.
 * @returns {Function} Returns `func`.
 */
var baseSetToString = !defineProperty ? identity : function(func, string) {
  return defineProperty(func, 'toString', {
    'configurable': true,
    'enumerable': false,
    'value': constant(string),
    'writable': true
  });
};

module.exports = baseSetToString;


/***/ }),
/* 514 */
/***/ (function(module, exports) {

/**
 * Creates a function that returns `value`.
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Util
 * @param {*} value The value to return from the new function.
 * @returns {Function} Returns the new constant function.
 * @example
 *
 * var objects = _.times(2, _.constant({ 'a': 1 }));
 *
 * console.log(objects);
 * // => [{ 'a': 1 }, { 'a': 1 }]
 *
 * console.log(objects[0] === objects[1]);
 * // => true
 */
function constant(value) {
  return function() {
    return value;
  };
}

module.exports = constant;


/***/ }),
/* 515 */
/***/ (function(module, exports) {

/** Used to detect hot functions by number of calls within a span of milliseconds. */
var HOT_COUNT = 800,
    HOT_SPAN = 16;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeNow = Date.now;

/**
 * Creates a function that'll short out and invoke `identity` instead
 * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
 * milliseconds.
 *
 * @private
 * @param {Function} func The function to restrict.
 * @returns {Function} Returns the new shortable function.
 */
function shortOut(func) {
  var count = 0,
      lastCalled = 0;

  return function() {
    var stamp = nativeNow(),
        remaining = HOT_SPAN - (stamp - lastCalled);

    lastCalled = stamp;
    if (remaining > 0) {
      if (++count >= HOT_COUNT) {
        return arguments[0];
      }
    } else {
      count = 0;
    }
    return func.apply(undefined, arguments);
  };
}

module.exports = shortOut;


/***/ }),
/* 516 */
/***/ (function(module, exports) {

module.exports = function(originalModule) {
	if(!originalModule.webpackPolyfill) {
		var module = Object.create(originalModule);
		// module.parent = undefined by default
		if(!module.children) module.children = [];
		Object.defineProperty(module, "loaded", {
			enumerable: true,
			get: function() {
				return module.l;
			}
		});
		Object.defineProperty(module, "id", {
			enumerable: true,
			get: function() {
				return module.i;
			}
		});
		Object.defineProperty(module, "exports", {
			enumerable: true,
		});
		module.webpackPolyfill = 1;
	}
	return module;
};


/***/ }),
/* 517 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */



var hyphenate = __webpack_require__(518);

var msPattern = /^ms-/;

/**
 * Hyphenates a camelcased CSS property name, for example:
 *
 *   > hyphenateStyleName('backgroundColor')
 *   < "background-color"
 *   > hyphenateStyleName('MozTransition')
 *   < "-moz-transition"
 *   > hyphenateStyleName('msTransition')
 *   < "-ms-transition"
 *
 * As Modernizr suggests (http://modernizr.com/docs/#prefixed), an `ms` prefix
 * is converted to `-ms-`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenateStyleName(string) {
  return hyphenate(string).replace(msPattern, '-ms-');
}

module.exports = hyphenateStyleName;

/***/ }),
/* 518 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * @typechecks
 */

var _uppercasePattern = /([A-Z])/g;

/**
 * Hyphenates a camelcased string, for example:
 *
 *   > hyphenate('backgroundColor')
 *   < "background-color"
 *
 * For CSS style names, use `hyphenateStyleName` instead which works properly
 * with all vendor prefixes, including `ms`.
 *
 * @param {string} string
 * @return {string}
 */
function hyphenate(string) {
  return string.replace(_uppercasePattern, '-$1').toLowerCase();
}

module.exports = hyphenate;

/***/ }),
/* 519 */
/***/ (function(module, exports, __webpack_require__) {

/*
 *          __        ___
 *    _____/ /___  __/ (_)____
 *   / ___/ __/ / / / / / ___/
 *  (__  ) /_/ /_/ / / (__  )
 * /____/\__/\__, /_/_/____/
 *          /____/
 *
 * light - weight css preprocessor @licence MIT
 */
(function (factory) {/* eslint-disable */
	 true ? (module['exports'] = factory(null)) :
		typeof define === 'function' && define['amd'] ? define(factory(null)) :
			(window['stylis'] = factory(null))
}(/** @param {*=} options */function factory (options) {/* eslint-disable */

	'use strict'

	/**
	 * Notes
	 *
	 * The ['<method name>'] pattern is used to support closure compiler
	 * the jsdoc signatures are also used to the same effect
	 *
	 * ----
	 *
	 * int + int + int === n4 [faster]
	 *
	 * vs
	 *
	 * int === n1 && int === n2 && int === n3
	 *
	 * ----
	 *
	 * switch (int) { case ints...} [faster]
	 *
	 * vs
	 *
	 * if (int == 1 && int === 2 ...)
	 *
	 * ----
	 *
	 * The (first*n1 + second*n2 + third*n3) format used in the property parser
	 * is a simple way to hash the sequence of characters
	 * taking into account the index they occur in
	 * since any number of 3 character sequences could produce duplicates.
	 *
	 * On the other hand sequences that are directly tied to the index of the character
	 * resolve a far more accurate measure, it's also faster
	 * to evaluate one condition in a switch statement
	 * than three in an if statement regardless of the added math.
	 *
	 * This allows the vendor prefixer to be both small and fast.
	 */

	var nullptn = /^\0+/g /* matches leading null characters */
	var formatptn = /[\0\r\f]/g /* matches new line, null and formfeed characters */
	var colonptn = /: */g /* splits animation rules */
	var cursorptn = /zoo|gra/ /* assert cursor varient */
	var transformptn = /([,: ])(transform)/g /* vendor prefix transform, older webkit */
	var animationptn = /,+\s*(?![^(]*[)])/g /* splits multiple shorthand notation animations */
	var propertiesptn = / +\s*(?![^(]*[)])/g /* animation properties */
	var elementptn = / *[\0] */g /* selector elements */
	var selectorptn = /,\r+?/g /* splits selectors */
	var andptn = /([\t\r\n ])*\f?&/g /* match & */
	var escapeptn = /:global\(((?:[^\(\)\[\]]*|\[.*\]|\([^\(\)]*\))*)\)/g /* matches :global(.*) */
	var invalidptn = /\W+/g /* removes invalid characters from keyframes */
	var keyframeptn = /@(k\w+)\s*(\S*)\s*/ /* matches @keyframes $1 */
	var plcholdrptn = /::(place)/g /* match ::placeholder varient */
	var readonlyptn = /:(read-only)/g /* match :read-only varient */
	var beforeptn = /\s+(?=[{\];=:>])/g /* matches \s before ] ; = : */
	var afterptn = /([[}=:>])\s+/g /* matches \s after characters [ } = : */
	var tailptn = /(\{[^{]+?);(?=\})/g /* matches tail semi-colons ;} */
	var whiteptn = /\s{2,}/g /* matches repeating whitespace */
	var pseudoptn = /([^\(])(:+) */g /* pseudo element */
	var writingptn = /[svh]\w+-[tblr]{2}/ /* match writing mode property values */
	var gradientptn = /([\w-]+t\()/g /* match *gradient property */
	var supportsptn = /\(\s*(.*)\s*\)/g /* match supports (groups) */
	var propertyptn = /([\s\S]*?);/g /* match properties leading semicolon */
	var selfptn = /-self|flex-/g /* match flex- and -self in align-self: flex-*; */
	var pseudofmt = /[^]*?(:[rp][el]a[\w-]+)[^]*/ /* extrats :readonly or :placholder from selector */
	var trimptn = /[ \t]+$/ /* match tail whitspace */
	var dimensionptn = /stretch|:\s*\w+\-(?:conte|avail)/ /* match max/min/fit-content, fill-available */
	var imgsrcptn = /([^-])(image-set\()/

	/* vendors */
	var webkit = '-webkit-'
	var moz = '-moz-'
	var ms = '-ms-'

	/* character codes */
	var SEMICOLON = 59 /* ; */
	var CLOSEBRACES = 125 /* } */
	var OPENBRACES = 123 /* { */
	var OPENPARENTHESES = 40 /* ( */
	var CLOSEPARENTHESES = 41 /* ) */
	var OPENBRACKET = 91 /* [ */
	var CLOSEBRACKET = 93 /* ] */
	var NEWLINE = 10 /* \n */
	var CARRIAGE = 13 /* \r */
	var TAB = 9 /* \t */
	var AT = 64 /* @ */
	var SPACE = 32 /*   */
	var AND = 38 /* & */
	var DASH = 45 /* - */
	var UNDERSCORE = 95 /* _ */
	var STAR = 42 /* * */
	var COMMA = 44 /* , */
	var COLON = 58 /* : */
	var SINGLEQUOTE = 39 /* ' */
	var DOUBLEQUOTE = 34 /* " */
	var FOWARDSLASH = 47 /* / */
	var GREATERTHAN = 62 /* > */
	var PLUS = 43 /* + */
	var TILDE = 126 /* ~ */
	var NULL = 0 /* \0 */
	var FORMFEED = 12 /* \f */
	var VERTICALTAB = 11 /* \v */

	/* special identifiers */
	var KEYFRAME = 107 /* k */
	var MEDIA = 109 /* m */
	var SUPPORTS = 115 /* s */
	var PLACEHOLDER = 112 /* p */
	var READONLY = 111 /* o */
	var IMPORT = 105 /* <at>i */
	var CHARSET = 99 /* <at>c */
	var DOCUMENT = 100 /* <at>d */
	var PAGE = 112 /* <at>p */

	var column = 1 /* current column */
	var line = 1 /* current line numebr */
	var pattern = 0 /* :pattern */

	var cascade = 1 /* #id h1 h2 vs h1#id h2#id  */
	var prefix = 1 /* vendor prefix */
	var escape = 1 /* escape :global() pattern */
	var compress = 0 /* compress output */
	var semicolon = 0 /* no/semicolon option */
	var preserve = 0 /* preserve empty selectors */

	/* empty reference */
	var array = []

	/* plugins */
	var plugins = []
	var plugged = 0
	var should = null

	/* plugin context */
	var POSTS = -2
	var PREPS = -1
	var UNKWN = 0
	var PROPS = 1
	var BLCKS = 2
	var ATRUL = 3

	/* plugin newline context */
	var unkwn = 0

	/* keyframe animation */
	var keyed = 1
	var key = ''

	/* selector namespace */
	var nscopealt = ''
	var nscope = ''

	/**
	 * Compile
	 *
	 * @param {Array<string>} parent
	 * @param {Array<string>} current
	 * @param {string} body
	 * @param {number} id
	 * @param {number} depth
	 * @return {string}
	 */
	function compile (parent, current, body, id, depth) {
		var bracket = 0 /* brackets [] */
		var comment = 0 /* comments /* // or /* */
		var parentheses = 0 /* functions () */
		var quote = 0 /* quotes '', "" */

		var first = 0 /* first character code */
		var second = 0 /* second character code */
		var code = 0 /* current character code */
		var tail = 0 /* previous character code */
		var trail = 0 /* character before previous code */
		var peak = 0 /* previous non-whitespace code */

		var counter = 0 /* count sequence termination */
		var context = 0 /* track current context */
		var atrule = 0 /* track @at-rule context */
		var pseudo = 0 /* track pseudo token index */
		var caret = 0 /* current character index */
		var format = 0 /* control character formating context */
		var insert = 0 /* auto semicolon insertion */
		var invert = 0 /* inverted selector pattern */
		var length = 0 /* generic length address */
		var eof = body.length /* end of file(length) */
		var eol = eof - 1 /* end of file(characters) */

		var char = '' /* current character */
		var chars = '' /* current buffer of characters */
		var child = '' /* next buffer of characters */
		var out = '' /* compiled body */
		var children = '' /* compiled children */
		var flat = '' /* compiled leafs */
		var selector /* generic selector address */
		var result /* generic address */

		// ...build body
		while (caret < eof) {
			code = body.charCodeAt(caret)

			// eof varient
			if (caret === eol) {
				// last character + noop context, add synthetic padding for noop context to terminate
				if (comment + quote + parentheses + bracket !== 0) {
					if (comment !== 0) {
						code = comment === FOWARDSLASH ? NEWLINE : FOWARDSLASH
					}

					quote = parentheses = bracket = 0
					eof++
					eol++
				}
			}

			if (comment + quote + parentheses + bracket === 0) {
				// eof varient
				if (caret === eol) {
					if (format > 0) {
						chars = chars.replace(formatptn, '')
					}

					if (chars.trim().length > 0) {
						switch (code) {
							case SPACE:
							case TAB:
							case SEMICOLON:
							case CARRIAGE:
							case NEWLINE: {
								break
							}
							default: {
								chars += body.charAt(caret)
							}
						}

						code = SEMICOLON
					}
				}

				// auto semicolon insertion
				if (insert === 1) {
					switch (code) {
						// false flags
						case OPENBRACES:
						case CLOSEBRACES:
						case SEMICOLON:
						case DOUBLEQUOTE:
						case SINGLEQUOTE:
						case OPENPARENTHESES:
						case CLOSEPARENTHESES:
						case COMMA: {
							insert = 0
						}
						// ignore
						case TAB:
						case CARRIAGE:
						case NEWLINE:
						case SPACE: {
							break
						}
						// valid
						default: {
							insert = 0
							length = caret
							first = code
							caret--
							code = SEMICOLON

							while (length < eof) {
								switch (body.charCodeAt(length++)) {
									case NEWLINE:
									case CARRIAGE:
									case SEMICOLON: {
										++caret
										code = first
										length = eof
										break
									}
									case COLON: {
										if (format > 0) {
											++caret
											code = first
										}
									}
									case OPENBRACES: {
										length = eof
									}
								}
							}
						}
					}
				}

				// token varient
				switch (code) {
					case OPENBRACES: {
						chars = chars.trim()
						first = chars.charCodeAt(0)
						counter = 1
						length = ++caret

						while (caret < eof) {
							switch (code = body.charCodeAt(caret)) {
								case OPENBRACES: {
									counter++
									break
								}
								case CLOSEBRACES: {
									counter--
									break
								}
								case FOWARDSLASH: {
									switch (second = body.charCodeAt(caret + 1)) {
										// /*, //
										case STAR:
										case FOWARDSLASH: {
											caret = delimited(second, caret, eol, body)
										}
									}
									break
								}
								// given "[" === 91 & "]" === 93 hence forth 91 + 1 + 1 === 93
								case OPENBRACKET: {
									code++
								}
								// given "(" === 40 & ")" === 41 hence forth 40 + 1 === 41
								case OPENPARENTHESES: {
									code++
								}
								// quote tail delimiter is identical to the head delimiter hence noop,
								// fallthrough clauses have been shifted to the correct tail delimiter
								case DOUBLEQUOTE:
								case SINGLEQUOTE: {
									while (caret++ < eol) {
										if (body.charCodeAt(caret) === code) {
											break
										}
									}
								}
							}

							if (counter === 0) {
								break
							}

							caret++
						}

						child = body.substring(length, caret)

						if (first === NULL) {
							first = (chars = chars.replace(nullptn, '').trim()).charCodeAt(0)
						}

						switch (first) {
							// @at-rule
							case AT: {
								if (format > 0) {
									chars = chars.replace(formatptn, '')
								}

								second = chars.charCodeAt(1)

								switch (second) {
									case DOCUMENT:
									case MEDIA:
									case SUPPORTS:
									case DASH: {
										selector = current
										break
									}
									default: {
										selector = array
									}
								}

								child = compile(current, selector, child, second, depth+1)
								length = child.length

								// preserve empty @at-rule
								if (preserve > 0 && length === 0) {
									length = chars.length
								}

								// execute plugins, @at-rule context
								if (plugged > 0) {
									selector = select(array, chars, invert)
									result = proxy(ATRUL, child, selector, current, line, column, length, second, depth, id)
									chars = selector.join('')

									if (result !== void 0) {
										if ((length = (child = result.trim()).length) === 0) {
											second = 0
											child = ''
										}
									}
								}

								if (length > 0) {
									switch (second) {
										case SUPPORTS: {
											chars = chars.replace(supportsptn, supports)
										}
										case DOCUMENT:
										case MEDIA:
										case DASH: {
											child = chars + '{' + child + '}'
											break
										}
										case KEYFRAME: {
											chars = chars.replace(keyframeptn, '$1 $2' + (keyed > 0 ? key : ''))
											child = chars + '{' + child + '}'

											if (prefix === 1 || (prefix === 2 && vendor('@'+child, 3))) {
												child = '@' + webkit + child + '@' + child
											} else {
												child = '@' + child
											}
											break
										}
										default: {
											child = chars + child

											if (id === PAGE) {
												child = (out += child, '')
											}
										}
									}
								} else {
									child = ''
								}

								break
							}
							// selector
							default: {
								child = compile(current, select(current, chars, invert), child, id, depth+1)
							}
						}

						children += child

						// reset
						context = 0
						insert = 0
						pseudo = 0
						format = 0
						invert = 0
						atrule = 0
						chars = ''
						child = ''
						code = body.charCodeAt(++caret)
						break
					}
					case CLOSEBRACES:
					case SEMICOLON: {
						chars = (format > 0 ? chars.replace(formatptn, '') : chars).trim()

						if ((length = chars.length) > 1) {
							// monkey-patch missing colon
							if (pseudo === 0) {
								first = chars.charCodeAt(0)

								// first character is a letter or dash, buffer has a space character
								if ((first === DASH || first > 96 && first < 123)) {
									length = (chars = chars.replace(' ', ':')).length
								}
							}

							// execute plugins, property context
							if (plugged > 0) {
								if ((result = proxy(PROPS, chars, current, parent, line, column, out.length, id, depth, id)) !== void 0) {
									if ((length = (chars = result.trim()).length) === 0) {
										chars = '\0\0'
									}
								}
							}

							first = chars.charCodeAt(0)
							second = chars.charCodeAt(1)

							switch (first) {
								case NULL: {
									break
								}
								case AT: {
									if (second === IMPORT || second === CHARSET) {
										flat += chars + body.charAt(caret)
										break
									}
								}
								default: {
									if (chars.charCodeAt(length-1) === COLON) {
										break
									}

									out += property(chars, first, second, chars.charCodeAt(2))
								}
							}
						}

						// reset
						context = 0
						insert = 0
						pseudo = 0
						format = 0
						invert = 0
						chars = ''
						code = body.charCodeAt(++caret)
						break
					}
				}
			}

			// parse characters
			switch (code) {
				case CARRIAGE:
				case NEWLINE: {
					// auto insert semicolon
					if (comment + quote + parentheses + bracket + semicolon === 0) {
						// valid non-whitespace characters that
						// may precede a newline
						switch (peak) {
							case CLOSEPARENTHESES:
							case SINGLEQUOTE:
							case DOUBLEQUOTE:
							case AT:
							case TILDE:
							case GREATERTHAN:
							case STAR:
							case PLUS:
							case FOWARDSLASH:
							case DASH:
							case COLON:
							case COMMA:
							case SEMICOLON:
							case OPENBRACES:
							case CLOSEBRACES: {
								break
							}
							default: {
								// current buffer has a colon
								if (pseudo > 0) {
									insert = 1
								}
							}
						}
					}

					// terminate line comment
					if (comment === FOWARDSLASH) {
						comment = 0
					} else if (cascade + context === 0 && id !== KEYFRAME && chars.length > 0) {
						format = 1
						chars += '\0'
					}

					// execute plugins, newline context
					if (plugged * unkwn > 0) {
						proxy(UNKWN, chars, current, parent, line, column, out.length, id, depth, id)
					}

					// next line, reset column position
					column = 1
					line++
					break
				}
				case SEMICOLON:
				case CLOSEBRACES: {
					if (comment + quote + parentheses + bracket === 0) {
						column++
						break
					}
				}
				default: {
					// increment column position
					column++

					// current character
					char = body.charAt(caret)

					// remove comments, escape functions, strings, attributes and prepare selectors
					switch (code) {
						case TAB:
						case SPACE: {
							if (quote + bracket + comment === 0) {
								switch (tail) {
									case COMMA:
									case COLON:
									case TAB:
									case SPACE: {
										char = ''
										break
									}
									default: {
										if (code !== SPACE) {
											char = ' '
										}
									}
								}
							}
							break
						}
						// escape breaking control characters
						case NULL: {
							char = '\\0'
							break
						}
						case FORMFEED: {
							char = '\\f'
							break
						}
						case VERTICALTAB: {
							char = '\\v'
							break
						}
						// &
						case AND: {
							// inverted selector pattern i.e html &
							if (quote + comment + bracket === 0 && cascade > 0) {
								invert = 1
								format = 1
								char = '\f' + char
							}
							break
						}
						// ::p<l>aceholder, l
						// :read-on<l>y, l
						case 108: {
							if (quote + comment + bracket + pattern === 0 && pseudo > 0) {
								switch (caret - pseudo) {
									// ::placeholder
									case 2: {
										if (tail === PLACEHOLDER && body.charCodeAt(caret-3) === COLON) {
											pattern = tail
										}
									}
									// :read-only
									case 8: {
										if (trail === READONLY) {
											pattern = trail
										}
									}
								}
							}
							break
						}
						// :<pattern>
						case COLON: {
							if (quote + comment + bracket === 0) {
								pseudo = caret
							}
							break
						}
						// selectors
						case COMMA: {
							if (comment + parentheses + quote + bracket === 0) {
								format = 1
								char += '\r'
							}
							break
						}
						// quotes
						case DOUBLEQUOTE:
						case SINGLEQUOTE: {
							if (comment === 0) {
								quote = quote === code ? 0 : (quote === 0 ? code : quote)
							}
							break
						}
						// attributes
						case OPENBRACKET: {
							if (quote + comment + parentheses === 0) {
								bracket++
							}
							break
						}
						case CLOSEBRACKET: {
							if (quote + comment + parentheses === 0) {
								bracket--
							}
							break
						}
						// functions
						case CLOSEPARENTHESES: {
							if (quote + comment + bracket === 0) {
								parentheses--
							}
							break
						}
						case OPENPARENTHESES: {
							if (quote + comment + bracket === 0) {
								if (context === 0) {
									switch (tail*2 + trail*3) {
										// :matches
										case 533: {
											break
										}
										// :global, :not, :nth-child etc...
										default: {
											counter = 0
											context = 1
										}
									}
								}

								parentheses++
							}
							break
						}
						case AT: {
							if (comment + parentheses + quote + bracket + pseudo + atrule === 0) {
								atrule = 1
							}
							break
						}
						// block/line comments
						case STAR:
						case FOWARDSLASH: {
							if (quote + bracket + parentheses > 0) {
								break
							}

							switch (comment) {
								// initialize line/block comment context
								case 0: {
									switch (code*2 + body.charCodeAt(caret+1)*3) {
										// //
										case 235: {
											comment = FOWARDSLASH
											break
										}
										// /*
										case 220: {
											length = caret
											comment = STAR
											break
										}
									}
									break
								}
								// end block comment context
								case STAR: {
									if (code === FOWARDSLASH && tail === STAR && length + 2 !== caret) {
										// /*<!> ... */, !
										if (body.charCodeAt(length+2) === 33) {
											out += body.substring(length, caret+1)
										}
										char = ''
										comment = 0
									}
								}
							}
						}
					}

					// ignore comment blocks
					if (comment === 0) {
						// aggressive isolation mode, divide each individual selector
						// including selectors in :not function but excluding selectors in :global function
						if (cascade + quote + bracket + atrule === 0 && id !== KEYFRAME && code !== SEMICOLON) {
							switch (code) {
								case COMMA:
								case TILDE:
								case GREATERTHAN:
								case PLUS:
								case CLOSEPARENTHESES:
								case OPENPARENTHESES: {
									if (context === 0) {
										// outside of an isolated context i.e nth-child(<...>)
										switch (tail) {
											case TAB:
											case SPACE:
											case NEWLINE:
											case CARRIAGE: {
												char = char + '\0'
												break
											}
											default: {
												char = '\0' + char + (code === COMMA ? '' : '\0')
											}
										}
										format = 1
									} else {
										// within an isolated context, sleep untill it's terminated
										switch (code) {
											case OPENPARENTHESES: {
												// :globa<l>(
												if (pseudo + 7 === caret && tail === 108) {
													pseudo = 0
												}
												context = ++counter
												break
											}
											case CLOSEPARENTHESES: {
												if ((context = --counter) === 0) {
													format = 1
													char += '\0'
												}
												break
											}
										}
									}
									break
								}
								case TAB:
								case SPACE: {
									switch (tail) {
										case NULL:
										case OPENBRACES:
										case CLOSEBRACES:
										case SEMICOLON:
										case COMMA:
										case FORMFEED:
										case TAB:
										case SPACE:
										case NEWLINE:
										case CARRIAGE: {
											break
										}
										default: {
											// ignore in isolated contexts
											if (context === 0) {
												format = 1
												char += '\0'
											}
										}
									}
								}
							}
						}

						// concat buffer of characters
						chars += char

						// previous non-whitespace character code
						if (code !== SPACE && code !== TAB) {
							peak = code
						}
					}
				}
			}

			// tail character codes
			trail = tail
			tail = code

			// visit every character
			caret++
		}

		length = out.length

		// preserve empty selector
 		if (preserve > 0) {
 			if (length === 0 && children.length === 0 && (current[0].length === 0) === false) {
 				if (id !== MEDIA || (current.length === 1 && (cascade > 0 ? nscopealt : nscope) === current[0])) {
					length = current.join(',').length + 2
 				}
 			}
		}

		if (length > 0) {
			// cascade isolation mode?
			selector = cascade === 0 && id !== KEYFRAME ? isolate(current) : current

			// execute plugins, block context
			if (plugged > 0) {
				result = proxy(BLCKS, out, selector, parent, line, column, length, id, depth, id)

				if (result !== void 0 && (out = result).length === 0) {
					return flat + out + children
				}
			}

			out = selector.join(',') + '{' + out + '}'

			if (prefix*pattern !== 0) {
				if (prefix === 2 && !vendor(out, 2))
					pattern = 0

				switch (pattern) {
					// ::read-only
					case READONLY: {
						out = out.replace(readonlyptn, ':'+moz+'$1')+out
						break
					}
					// ::placeholder
					case PLACEHOLDER: {
						out = (
							out.replace(plcholdrptn, '::' + webkit + 'input-$1') +
							out.replace(plcholdrptn, '::' + moz + '$1') +
							out.replace(plcholdrptn, ':' + ms + 'input-$1') + out
						)
						break
					}
				}

				pattern = 0
			}
		}

		return flat + out + children
	}

	/**
	 * Select
	 *
	 * @param {Array<string>} parent
	 * @param {string} current
	 * @param {number} invert
	 * @return {Array<string>}
	 */
	function select (parent, current, invert) {
		var selectors = current.trim().split(selectorptn)
		var out = selectors

		var length = selectors.length
		var l = parent.length

		switch (l) {
			// 0-1 parent selectors
			case 0:
			case 1: {
				for (var i = 0, selector = l === 0 ? '' : parent[0] + ' '; i < length; ++i) {
					out[i] = scope(selector, out[i], invert, l).trim()
				}
				break
			}
			// >2 parent selectors, nested
			default: {
				for (var i = 0, j = 0, out = []; i < length; ++i) {
					for (var k = 0; k < l; ++k) {
						out[j++] = scope(parent[k] + ' ', selectors[i], invert, l).trim()
					}
				}
			}
		}

		return out
	}

	/**
	 * Scope
	 *
	 * @param {string} parent
	 * @param {string} current
	 * @param {number} invert
	 * @param {number} level
	 * @return {string}
	 */
	function scope (parent, current, invert, level) {
		var selector = current
		var code = selector.charCodeAt(0)

		// trim leading whitespace
		if (code < 33) {
			code = (selector = selector.trim()).charCodeAt(0)
		}

		switch (code) {
			// &
			case AND: {
				switch (cascade + level) {
					case 0:
					case 1: {
						if (parent.trim().length === 0) {
							break
						}
					}
					default: {
						return selector.replace(andptn, '$1'+parent.trim())
					}
				}
				break
			}
			// :
			case COLON: {
				switch (selector.charCodeAt(1)) {
					// g in :global
					case 103: {
						if (escape > 0 && cascade > 0) {
							return selector.replace(escapeptn, '$1').replace(andptn, '$1'+nscope)
						}
						break
					}
					default: {
						// :hover
						return parent.trim() + selector.replace(andptn, '$1'+parent.trim())
					}
				}
			}
			default: {
				// html &
				if (invert*cascade > 0 && selector.indexOf('\f') > 0) {
					return selector.replace(andptn, (parent.charCodeAt(0) === COLON ? '' : '$1')+parent.trim())
				}
			}
		}

		return parent + selector
	}

	/**
	 * Property
	 *
	 * @param {string} input
	 * @param {number} first
	 * @param {number} second
	 * @param {number} third
	 * @return {string}
	 */
	function property (input, first, second, third) {
		var index = 0
		var out = input + ';'
		var hash = (first*2) + (second*3) + (third*4)
		var cache

		// animation: a, n, i characters
		if (hash === 944) {
			return animation(out)
		} else if (prefix === 0 || (prefix === 2 && !vendor(out, 1))) {
			return out
		}

		// vendor prefix
		switch (hash) {
			// text-decoration/text-size-adjust/text-shadow/text-align/text-transform: t, e, x
			case 1015: {
				// text-shadow/text-align/text-transform, a
				return out.charCodeAt(10) === 97 ? webkit + out + out : out
			}
			// filter/fill f, i, l
			case 951: {
				// filter, t
				return out.charCodeAt(3) === 116 ? webkit + out + out : out
			}
			// color/column, c, o, l
			case 963: {
				// column, n
				return out.charCodeAt(5) === 110 ? webkit + out + out : out
			}
			// box-decoration-break, b, o, x
			case 1009: {
				if (out.charCodeAt(4) !== 100) {
					break
				}
			}
			// mask, m, a, s
			// clip-path, c, l, i
			case 969:
			case 942: {
				return webkit + out + out
			}
			// appearance: a, p, p
			case 978: {
				return webkit + out + moz + out + out
			}
			// hyphens: h, y, p
			// user-select: u, s, e
			case 1019:
			case 983: {
				return webkit + out + moz + out + ms + out + out
			}
			// background/backface-visibility, b, a, c
			case 883: {
				// backface-visibility, -
				if (out.charCodeAt(8) === DASH) {
					return webkit + out + out
				}

				// image-set(...)
				if (out.indexOf('image-set(', 11) > 0) {
					return out.replace(imgsrcptn, '$1'+webkit+'$2') + out
				}

				return out
			}
			// flex: f, l, e
			case 932: {
				if (out.charCodeAt(4) === DASH) {
					switch (out.charCodeAt(5)) {
						// flex-grow, g
						case 103: {
							return webkit + 'box-' + out.replace('-grow', '') + webkit + out + ms + out.replace('grow', 'positive') + out
						}
						// flex-shrink, s
						case 115: {
							return webkit + out + ms + out.replace('shrink', 'negative') + out
						}
						// flex-basis, b
						case 98: {
							return webkit + out + ms + out.replace('basis', 'preferred-size') + out
						}
					}
				}

				return webkit + out + ms + out + out
			}
			// order: o, r, d
			case 964: {
				return webkit + out + ms + 'flex' + '-' + out + out
			}
			// justify-items/justify-content, j, u, s
			case 1023: {
				// justify-content, c
				if (out.charCodeAt(8) !== 99) {
					break
				}

				cache = out.substring(out.indexOf(':', 15)).replace('flex-', '').replace('space-between', 'justify')
				return webkit + 'box-pack' + cache + webkit + out + ms + 'flex-pack' + cache + out
			}
			// cursor, c, u, r
			case 1005: {
				return cursorptn.test(out) ? out.replace(colonptn, ':' + webkit) + out.replace(colonptn, ':' + moz) + out : out
			}
			// writing-mode, w, r, i
			case 1000: {
				cache = out.substring(13).trim()
				index = cache.indexOf('-') + 1

				switch (cache.charCodeAt(0)+cache.charCodeAt(index)) {
					// vertical-lr
					case 226: {
						cache = out.replace(writingptn, 'tb')
						break
					}
					// vertical-rl
					case 232: {
						cache = out.replace(writingptn, 'tb-rl')
						break
					}
					// horizontal-tb
					case 220: {
						cache = out.replace(writingptn, 'lr')
						break
					}
					default: {
						return out
					}
				}

				return webkit + out + ms + cache + out
			}
			// position: sticky
			case 1017: {
				if (out.indexOf('sticky', 9) === -1) {
					return out
				}
			}
			// display(flex/inline-flex/inline-box): d, i, s
			case 975: {
				index = (out = input).length - 10
				cache = (out.charCodeAt(index) === 33 ? out.substring(0, index) : out).substring(input.indexOf(':', 7) + 1).trim()

				switch (hash = cache.charCodeAt(0) + (cache.charCodeAt(7)|0)) {
					// inline-
					case 203: {
						// inline-box
						if (cache.charCodeAt(8) < 111) {
							break
						}
					}
					// inline-box/sticky
					case 115: {
						out = out.replace(cache, webkit+cache)+';'+out
						break
					}
					// inline-flex
					// flex
					case 207:
					case 102: {
						out = (
							out.replace(cache, webkit+(hash > 102 ? 'inline-' : '')+'box')+';'+
							out.replace(cache, webkit+cache)+';'+
							out.replace(cache, ms+cache+'box')+';'+
							out
						)
					}
				}

				return out + ';'
			}
			// align-items, align-center, align-self: a, l, i, -
			case 938: {
				if (out.charCodeAt(5) === DASH) {
					switch (out.charCodeAt(6)) {
						// align-items, i
						case 105: {
							cache = out.replace('-items', '')
							return webkit + out + webkit + 'box-' + cache + ms + 'flex-' + cache + out
						}
						// align-self, s
						case 115: {
							return webkit + out + ms + 'flex-item-' + out.replace(selfptn, '') + out
						}
						// align-content
						default: {
							return webkit + out + ms + 'flex-line-pack' + out.replace('align-content', '').replace(selfptn, '') + out
						}
					}
				}
				break
			}
			// min/max
			case 973:
			case 989: {
				// min-/max- height/width/block-size/inline-size
				if (out.charCodeAt(3) !== DASH || out.charCodeAt(4) === 122) {
					break
				}
			}
			// height/width: min-content / width: max-content
			case 931:
			case 953: {
				if (dimensionptn.test(input) === true) {
					// stretch
					if ((cache = input.substring(input.indexOf(':') + 1)).charCodeAt(0) === 115)
						return property(input.replace('stretch', 'fill-available'), first, second, third).replace(':fill-available', ':stretch')
					else
						return out.replace(cache, webkit + cache) + out.replace(cache, moz + cache.replace('fill-', '')) + out
				}
				break
			}
			// transform, transition: t, r, a
			case 962: {
				out = webkit + out + (out.charCodeAt(5) === 102 ? ms + out : '') + out

				// transitions
				if (second + third === 211 && out.charCodeAt(13) === 105 && out.indexOf('transform', 10) > 0) {
					return out.substring(0, out.indexOf(';', 27) + 1).replace(transformptn, '$1' + webkit + '$2') + out
				}

				break
			}
		}

		return out
	}

	/**
	 * Vendor
	 *
	 * @param {string} content
	 * @param {number} context
	 * @return {boolean}
	 */
	function vendor (content, context) {
		var index = content.indexOf(context === 1 ? ':' : '{')
		var key = content.substring(0, context !== 3 ? index : 10)
		var value = content.substring(index + 1, content.length - 1)

		return should(context !== 2 ? key : key.replace(pseudofmt, '$1'), value, context)
	}

	/**
	 * Supports
	 *
	 * @param {string} match
	 * @param {string} group
	 * @return {string}
	 */
	function supports (match, group) {
		var out = property(group, group.charCodeAt(0), group.charCodeAt(1), group.charCodeAt(2))

		return out !== group+';' ? out.replace(propertyptn, ' or ($1)').substring(4) : '('+group+')'
	}

	/**
	 * Animation
	 *
	 * @param {string} input
	 * @return {string}
	 */
	function animation (input) {
		var length = input.length
		var index = input.indexOf(':', 9) + 1
		var declare = input.substring(0, index).trim()
		var out = input.substring(index, length-1).trim()

		switch (input.charCodeAt(9)*keyed) {
			case 0: {
				break
			}
			// animation-*, -
			case DASH: {
				// animation-name, n
				if (input.charCodeAt(10) !== 110) {
					break
				}
			}
			// animation/animation-name
			default: {
				// split in case of multiple animations
				var list = out.split((out = '', animationptn))

				for (var i = 0, index = 0, length = list.length; i < length; index = 0, ++i) {
					var value = list[i]
					var items = value.split(propertiesptn)

					while (value = items[index]) {
						var peak = value.charCodeAt(0)

						if (keyed === 1 && (
							// letters
							(peak > AT && peak < 90) || (peak > 96 && peak < 123) || peak === UNDERSCORE ||
							// dash but not in sequence i.e --
							(peak === DASH && value.charCodeAt(1) !== DASH)
						)) {
							// not a number/function
							switch (isNaN(parseFloat(value)) + (value.indexOf('(') !== -1)) {
								case 1: {
									switch (value) {
										// not a valid reserved keyword
										case 'infinite': case 'alternate': case 'backwards': case 'running':
										case 'normal': case 'forwards': case 'both': case 'none': case 'linear':
										case 'ease': case 'ease-in': case 'ease-out': case 'ease-in-out':
										case 'paused': case 'reverse': case 'alternate-reverse': case 'inherit':
										case 'initial': case 'unset': case 'step-start': case 'step-end': {
											break
										}
										default: {
											value += key
										}
									}
								}
							}
						}

						items[index++] = value
					}

					out += (i === 0 ? '' : ',') + items.join(' ')
				}
			}
		}

		out = declare + out + ';'

		if (prefix === 1 || (prefix === 2 && vendor(out, 1)))
			return webkit + out + out

		return out
	}

	/**
	 * Isolate
	 *
	 * @param {Array<string>} current
	 */
	function isolate (current) {
		for (var i = 0, length = current.length, selector = Array(length), padding, element; i < length; ++i) {
			// split individual elements in a selector i.e h1 h2 === [h1, h2]
			var elements = current[i].split(elementptn)
			var out = ''

			for (var j = 0, size = 0, tail = 0, code = 0, l = elements.length; j < l; ++j) {
				// empty element
				if ((size = (element = elements[j]).length) === 0 && l > 1) {
					continue
				}

				tail = out.charCodeAt(out.length-1)
				code = element.charCodeAt(0)
				padding = ''

				if (j !== 0) {
					// determine if we need padding
					switch (tail) {
						case STAR:
						case TILDE:
						case GREATERTHAN:
						case PLUS:
						case SPACE:
						case OPENPARENTHESES:  {
							break
						}
						default: {
							padding = ' '
						}
					}
				}

				switch (code) {
					case AND: {
						element = padding + nscopealt
					}
					case TILDE:
					case GREATERTHAN:
					case PLUS:
					case SPACE:
					case CLOSEPARENTHESES:
					case OPENPARENTHESES: {
						break
					}
					case OPENBRACKET: {
						element = padding + element + nscopealt
						break
					}
					case COLON: {
						switch (element.charCodeAt(1)*2 + element.charCodeAt(2)*3) {
							// :global
							case 530: {
								if (escape > 0) {
									element = padding + element.substring(8, size - 1)
									break
								}
							}
							// :hover, :nth-child(), ...
							default: {
								if (j < 1 || elements[j-1].length < 1) {
									element = padding + nscopealt + element
								}
							}
						}
						break
					}
					case COMMA: {
						padding = ''
					}
					default: {
						if (size > 1 && element.indexOf(':') > 0) {
							element = padding + element.replace(pseudoptn, '$1' + nscopealt + '$2')
						} else {
							element = padding + element + nscopealt
						}
					}
				}

				out += element
			}

			selector[i] = out.replace(formatptn, '').trim()
		}

		return selector
	}

	/**
	 * Proxy
	 *
	 * @param {number} context
	 * @param {string} content
	 * @param {Array<string>} selectors
	 * @param {Array<string>} parents
	 * @param {number} line
	 * @param {number} column
	 * @param {number} length
	 * @param {number} id
	 * @param {number} depth
	 * @param {number} at
	 * @return {(string|void|*)}
	 */
	function proxy (context, content, selectors, parents, line, column, length, id, depth, at) {
		for (var i = 0, out = content, next; i < plugged; ++i) {
			switch (next = plugins[i].call(stylis, context, out, selectors, parents, line, column, length, id, depth, at)) {
				case void 0:
				case false:
				case true:
				case null: {
					break
				}
				default: {
					out = next
				}
			}
		}
		if (out !== content) {
		  return out
		}
	}

	/**
	 * @param {number} code
	 * @param {number} index
	 * @param {number} length
	 * @param {string} body
	 * @return {number}
	 */
	function delimited (code, index, length, body) {
		for (var i = index + 1; i < length; ++i) {
			switch (body.charCodeAt(i)) {
				// /*
				case FOWARDSLASH: {
					if (code === STAR) {
						if (body.charCodeAt(i - 1) === STAR &&  index + 2 !== i) {
							return i + 1
						}
					}
					break
				}
				// //
				case NEWLINE: {
					if (code === FOWARDSLASH) {
						return i + 1
					}
				}
			}
		}

		return i
	}

	/**
	 * @param {number} type
	 * @param {number} index
	 * @param {number} length
	 * @param {number} find
	 * @param {string} body
	 * @return {number}
	 */
	function match (type, index, length, body) {
		for (var i = index + 1; i < length; ++i) {
			switch (body.charCodeAt(i)) {
				case type: {
					return i
				}
			}
		}

		return i
	}

	/**
	 * Minify
	 *
	 * @param {(string|*)} output
	 * @return {string}
	 */
	function minify (output) {
		return output
			.replace(formatptn, '')
			.replace(beforeptn, '')
			.replace(afterptn, '$1')
			.replace(tailptn, '$1')
			.replace(whiteptn, ' ')
	}

	/**
	 * Use
	 *
	 * @param {(Array<function(...?)>|function(...?)|number|void)?} plugin
	 */
	function use (plugin) {
		switch (plugin) {
			case void 0:
			case null: {
				plugged = plugins.length = 0
				break
			}
			default: {
				if (typeof plugin === 'function') {
					plugins[plugged++] = plugin
				}	else if (typeof plugin === 'object') {
					for (var i = 0, length = plugin.length; i < length; ++i) {
						use(plugin[i])
					}
				} else {
					unkwn = !!plugin|0
				}
			}
 		}

 		return use
	}

	/**
	 * Set
	 *
	 * @param {*} options
	 */
	function set (options) {
		for (var name in options) {
			var value = options[name]
			switch (name) {
				case 'keyframe': keyed = value|0; break
				case 'global': escape = value|0; break
				case 'cascade': cascade = value|0; break
				case 'compress': compress = value|0; break
				case 'semicolon': semicolon = value|0; break
				case 'preserve': preserve = value|0; break
				case 'prefix':
					should = null

					if (!value) {
						prefix = 0
					} else if (typeof value !== 'function') {
						prefix = 1
					} else {
						prefix = 2
						should = value
					}
			}
		}

		return set
	}

	/**
	 * Stylis
	 *
	 * @param {string} selector
	 * @param {string} input
	 * @return {*}
	 */
	function stylis (selector, input) {
		if (this !== void 0 && this.constructor === stylis) {
			return factory(selector)
		}

		// setup
		var ns = selector
		var code = ns.charCodeAt(0)

		// trim leading whitespace
		if (code < 33) {
			code = (ns = ns.trim()).charCodeAt(0)
		}

		// keyframe/animation namespace
		if (keyed > 0) {
			key = ns.replace(invalidptn, code === OPENBRACKET ? '' : '-')
		}

		// reset, used to assert if a plugin is moneky-patching the return value
		code = 1

		// cascade/isolate
		if (cascade === 1) {
			nscope = ns
		} else {
			nscopealt = ns
		}

		var selectors = [nscope]
		var result

		// execute plugins, pre-process context
		if (plugged > 0) {
			result = proxy(PREPS, input, selectors, selectors, line, column, 0, 0, 0, 0)

			if (result !== void 0 && typeof result === 'string') {
				input = result
			}
		}

		// build
		var output = compile(array, selectors, input, 0, 0)

		// execute plugins, post-process context
		if (plugged > 0) {
			result = proxy(POSTS, output, selectors, selectors, line, column, output.length, 0, 0, 0)

			// bypass minification
			if (result !== void 0 && typeof(output = result) !== 'string') {
				code = 0
			}
		}

		// reset
		key = ''
		nscope = ''
		nscopealt = ''
		pattern = 0
		line = 1
		column = 1

		return compress*code === 0 ? output : minify(output)
	}

	stylis['use'] = use
	stylis['set'] = set

	if (options !== void 0) {
		set(options)
	}

	return stylis
}));


/***/ }),
/* 520 */
/***/ (function(module, exports, __webpack_require__) {

(function (factory) {
	 true ? (module['exports'] = factory()) :
		typeof define === 'function' && define['amd'] ? define(factory()) :
			(window['stylisRuleSheet'] = factory())
}(function () {

	'use strict'

	return function (insertRule) {
		var delimiter = '/*|*/'
		var needle = delimiter+'}'

		function toSheet (block) {
			if (block)
				try {
					insertRule(block + '}')
				} catch (e) {}
		}

		return function ruleSheet (context, content, selectors, parents, line, column, length, ns, depth, at) {
			switch (context) {
				// property
				case 1:
					// @import
					if (depth === 0 && content.charCodeAt(0) === 64)
						return insertRule(content+';'), ''
					break
				// selector
				case 2:
					if (ns === 0)
						return content + delimiter
					break
				// at-rule
				case 3:
					switch (ns) {
						// @font-face, @page
						case 102:
						case 112:
							return insertRule(selectors[0]+content), ''
						default:
							return content + (at === 0 ? delimiter : '')
					}
				case -2:
					content.split(needle).forEach(toSheet)
			}
		}
	}
}))


/***/ }),
/* 521 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _slider = __webpack_require__(522);

var _slider2 = _interopRequireDefault(_slider);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _slider2.default;

/***/ }),
/* 522 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _innerSlider = __webpack_require__(523);

var _json2mq = __webpack_require__(529);

var _json2mq2 = _interopRequireDefault(_json2mq);

var _defaultProps = __webpack_require__(531);

var _defaultProps2 = _interopRequireDefault(_defaultProps);

var _innerSliderUtils = __webpack_require__(125);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var enquire = (0, _innerSliderUtils.canUseDOM)() && __webpack_require__(269);

var Slider = function (_React$Component) {
  _inherits(Slider, _React$Component);

  function Slider(props) {
    _classCallCheck(this, Slider);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.innerSliderRefHandler = function (ref) {
      return _this.innerSlider = ref;
    };

    _this.slickPrev = function () {
      return _this.innerSlider.slickPrev();
    };

    _this.slickNext = function () {
      return _this.innerSlider.slickNext();
    };

    _this.slickGoTo = function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      return _this.innerSlider.slickGoTo(slide, dontAnimate);
    };

    _this.slickPause = function () {
      return _this.innerSlider.pause("paused");
    };

    _this.slickPlay = function () {
      return _this.innerSlider.autoPlay("play");
    };

    _this.state = {
      breakpoint: null
    };
    _this._responsiveMediaHandlers = [];
    return _this;
  }

  Slider.prototype.media = function media(query, handler) {
    // javascript handler for  css media query
    enquire.register(query, handler);
    this._responsiveMediaHandlers.push({ query: query, handler: handler });
  };

  // handles responsive breakpoints


  Slider.prototype.componentWillMount = function componentWillMount() {
    var _this2 = this;

    // performance monitoring
    //if (process.env.NODE_ENV !== 'production') {
    //const { whyDidYouUpdate } = require('why-did-you-update')
    //whyDidYouUpdate(React)
    //}
    if (this.props.responsive) {
      var breakpoints = this.props.responsive.map(function (breakpt) {
        return breakpt.breakpoint;
      });
      // sort them in increasing order of their numerical value
      breakpoints.sort(function (x, y) {
        return x - y;
      });

      breakpoints.forEach(function (breakpoint, index) {
        // media query for each breakpoint
        var bQuery = void 0;
        if (index === 0) {
          bQuery = (0, _json2mq2.default)({ minWidth: 0, maxWidth: breakpoint });
        } else {
          bQuery = (0, _json2mq2.default)({
            minWidth: breakpoints[index - 1] + 1,
            maxWidth: breakpoint
          });
        }
        // when not using server side rendering
        (0, _innerSliderUtils.canUseDOM)() && _this2.media(bQuery, function () {
          _this2.setState({ breakpoint: breakpoint });
        });
      });

      // Register media query for full screen. Need to support resize from small to large
      // convert javascript object to media query string
      var query = (0, _json2mq2.default)({ minWidth: breakpoints.slice(-1)[0] });

      (0, _innerSliderUtils.canUseDOM)() && this.media(query, function () {
        _this2.setState({ breakpoint: null });
      });
    }
  };

  Slider.prototype.componentWillUnmount = function componentWillUnmount() {
    this._responsiveMediaHandlers.forEach(function (obj) {
      enquire.unregister(obj.query, obj.handler);
    });
  };

  Slider.prototype.render = function render() {
    var _this3 = this;

    var settings;
    var newProps;
    if (this.state.breakpoint) {
      newProps = this.props.responsive.filter(function (resp) {
        return resp.breakpoint === _this3.state.breakpoint;
      });
      settings = newProps[0].settings === "unslick" ? "unslick" : _extends({}, _defaultProps2.default, this.props, newProps[0].settings);
    } else {
      settings = _extends({}, _defaultProps2.default, this.props);
    }

    // force scrolling by one if centerMode is on
    if (settings.centerMode) {
      if (settings.slidesToScroll > 1 && "production" !== "production") {
        console.warn("slidesToScroll should be equal to 1 in centerMode, you are using " + settings.slidesToScroll);
      }
      settings.slidesToScroll = 1;
    }
    // force showing one slide and scrolling by one if the fade mode is on
    if (settings.fade) {
      if (settings.slidesToShow > 1 && "production" !== "production") {
        console.warn("slidesToShow should be equal to 1 when fade is true, you're using " + settings.slidesToShow);
      }
      if (settings.slidesToScroll > 1 && "production" !== "production") {
        console.warn("slidesToScroll should be equal to 1 when fade is true, you're using " + settings.slidesToScroll);
      }
      settings.slidesToShow = 1;
      settings.slidesToScroll = 1;
    }

    // makes sure that children is an array, even when there is only 1 child
    var children = _react2.default.Children.toArray(this.props.children);

    // Children may contain false or null, so we should filter them
    // children may also contain string filled with spaces (in certain cases where we use jsx strings)
    children = children.filter(function (child) {
      if (typeof child === "string") {
        return !!child.trim();
      }
      return !!child;
    });

    // rows and slidesPerRow logic is handled here
    if (settings.variableWidth && (settings.rows > 1 || settings.slidesPerRow > 1)) {
      console.warn("variableWidth is not supported in case of rows > 1 or slidesPerRow > 1");
      settings.variableWidth = false;
    }
    var newChildren = [];
    var currentWidth = null;
    for (var i = 0; i < children.length; i += settings.rows * settings.slidesPerRow) {
      var newSlide = [];
      for (var j = i; j < i + settings.rows * settings.slidesPerRow; j += settings.slidesPerRow) {
        var row = [];
        for (var k = j; k < j + settings.slidesPerRow; k += 1) {
          if (settings.variableWidth && children[k].props.style) {
            currentWidth = children[k].props.style.width;
          }
          if (k >= children.length) break;
          row.push(_react2.default.cloneElement(children[k], {
            key: 100 * i + 10 * j + k,
            tabIndex: -1,
            style: {
              width: 100 / settings.slidesPerRow + "%",
              display: "inline-block"
            }
          }));
        }
        newSlide.push(_react2.default.createElement(
          "div",
          { key: 10 * i + j },
          row
        ));
      }
      if (settings.variableWidth) {
        newChildren.push(_react2.default.createElement(
          "div",
          { key: i, style: { width: currentWidth } },
          newSlide
        ));
      } else {
        newChildren.push(_react2.default.createElement(
          "div",
          { key: i },
          newSlide
        ));
      }
    }

    if (settings === "unslick") {
      var className = "regular slider " + (this.props.className || "");
      return _react2.default.createElement(
        "div",
        { className: className },
        newChildren
      );
    } else if (newChildren.length <= settings.slidesToShow) {
      settings.unslick = true;
    }
    return _react2.default.createElement(
      _innerSlider.InnerSlider,
      _extends({ ref: this.innerSliderRefHandler }, settings),
      newChildren
    );
  };

  return Slider;
}(_react2.default.Component);

exports.default = Slider;

/***/ }),
/* 523 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.InnerSlider = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactDom = __webpack_require__(30);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _initialState = __webpack_require__(524);

var _initialState2 = _interopRequireDefault(_initialState);

var _lodash = __webpack_require__(525);

var _lodash2 = _interopRequireDefault(_lodash);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

var _innerSliderUtils = __webpack_require__(125);

var _track = __webpack_require__(526);

var _dots = __webpack_require__(527);

var _arrows = __webpack_require__(528);

var _resizeObserverPolyfill = __webpack_require__(268);

var _resizeObserverPolyfill2 = _interopRequireDefault(_resizeObserverPolyfill);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var InnerSlider = exports.InnerSlider = function (_React$Component) {
  _inherits(InnerSlider, _React$Component);

  function InnerSlider(props) {
    _classCallCheck(this, InnerSlider);

    var _this = _possibleConstructorReturn(this, _React$Component.call(this, props));

    _this.listRefHandler = function (ref) {
      return _this.list = ref;
    };

    _this.trackRefHandler = function (ref) {
      return _this.track = ref;
    };

    _this.adaptHeight = function () {
      if (_this.props.adaptiveHeight && _this.list) {
        var elem = _this.list.querySelector("[data-index=\"" + _this.state.currentSlide + "\"]");
        _this.list.style.height = (0, _innerSliderUtils.getHeight)(elem) + "px";
      }
    };

    _this.componentWillMount = function () {
      _this.ssrInit();
      _this.props.onInit && _this.props.onInit();
      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_extends({}, _this.props, _this.state));
        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });
          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      }
    };

    _this.componentDidMount = function () {
      var spec = _extends({ listRef: _this.list, trackRef: _this.track }, _this.props);
      _this.updateState(spec, true, function () {
        _this.adaptHeight();
        _this.props.autoplay && _this.autoPlay("update");
      });
      if (_this.props.lazyLoad === "progressive") {
        _this.lazyLoadTimer = setInterval(_this.progressiveLazyLoad, 1000);
      }
      _this.ro = new _resizeObserverPolyfill2.default(function () {
        if (_this.state.animating) {
          _this.onWindowResized(false); // don't set trackStyle hence don't break animation
          _this.callbackTimers.push(setTimeout(function () {
            return _this.onWindowResized();
          }, _this.props.speed));
        } else {
          _this.onWindowResized();
        }
      });
      _this.ro.observe(_this.list);
      Array.prototype.forEach.call(document.querySelectorAll(".slick-slide"), function (slide) {
        slide.onfocus = _this.props.pauseOnFocus ? _this.onSlideFocus : null;
        slide.onblur = _this.props.pauseOnFocus ? _this.onSlideBlur : null;
      });
      // To support server-side rendering
      if (!window) {
        return;
      }
      if (window.addEventListener) {
        window.addEventListener("resize", _this.onWindowResized);
      } else {
        window.attachEvent("onresize", _this.onWindowResized);
      }
    };

    _this.componentWillUnmount = function () {
      if (_this.animationEndCallback) {
        clearTimeout(_this.animationEndCallback);
      }
      if (_this.lazyLoadTimer) {
        clearInterval(_this.lazyLoadTimer);
      }
      if (_this.callbackTimers.length) {
        _this.callbackTimers.forEach(function (timer) {
          return clearTimeout(timer);
        });
        _this.callbackTimers = [];
      }
      if (window.addEventListener) {
        window.removeEventListener("resize", _this.onWindowResized);
      } else {
        window.detachEvent("onresize", _this.onWindowResized);
      }
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }
    };

    _this.componentWillReceiveProps = function (nextProps) {
      var spec = _extends({
        listRef: _this.list,
        trackRef: _this.track
      }, nextProps, _this.state);
      var setTrackStyle = false;
      for (var _iterator = Object.keys(_this.props), _isArray = Array.isArray(_iterator), _i = 0, _iterator = _isArray ? _iterator : _iterator[Symbol.iterator]();;) {
        var _ref;

        if (_isArray) {
          if (_i >= _iterator.length) break;
          _ref = _iterator[_i++];
        } else {
          _i = _iterator.next();
          if (_i.done) break;
          _ref = _i.value;
        }

        var key = _ref;

        if (!nextProps.hasOwnProperty(key)) {
          setTrackStyle = true;
          break;
        }
        if (_typeof(nextProps[key]) === "object" || typeof nextProps[key] === "function") {
          continue;
        }
        if (nextProps[key] !== _this.props[key]) {
          setTrackStyle = true;
          break;
        }
      }
      _this.updateState(spec, setTrackStyle, function () {
        if (_this.state.currentSlide >= _react2.default.Children.count(nextProps.children)) {
          _this.changeSlide({
            message: "index",
            index: _react2.default.Children.count(nextProps.children) - nextProps.slidesToShow,
            currentSlide: _this.state.currentSlide
          });
        }
        if (nextProps.autoplay) {
          _this.autoPlay("update");
        } else {
          _this.pause("paused");
        }
      });
    };

    _this.componentDidUpdate = function () {
      _this.checkImagesLoad();
      _this.props.onReInit && _this.props.onReInit();
      if (_this.props.lazyLoad) {
        var slidesToLoad = (0, _innerSliderUtils.getOnDemandLazySlides)(_extends({}, _this.props, _this.state));
        if (slidesToLoad.length > 0) {
          _this.setState(function (prevState) {
            return {
              lazyLoadedList: prevState.lazyLoadedList.concat(slidesToLoad)
            };
          });
          if (_this.props.onLazyLoad) {
            _this.props.onLazyLoad(slidesToLoad);
          }
        }
      }
      // if (this.props.onLazyLoad) {
      //   this.props.onLazyLoad([leftMostSlide])
      // }
      _this.adaptHeight();
    };

    _this.onWindowResized = function (setTrackStyle) {
      if (_this.debouncedResize) _this.debouncedResize.cancel();
      _this.debouncedResize = (0, _lodash2.default)(function () {
        return _this.resizeWindow(setTrackStyle);
      }, 50);
      _this.debouncedResize();
    };

    _this.resizeWindow = function () {
      var setTrackStyle = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;

      if (!_reactDom2.default.findDOMNode(_this.track)) return;
      var spec = _extends({
        listRef: _this.list,
        trackRef: _this.track
      }, _this.props, _this.state);
      _this.updateState(spec, setTrackStyle, function () {
        if (_this.props.autoplay) _this.autoPlay("update");else _this.pause("paused");
      });
      // animating state should be cleared while resizing, otherwise autoplay stops working
      _this.setState({
        animating: false
      });
      clearTimeout(_this.animationEndCallback);
      delete _this.animationEndCallback;
    };

    _this.updateState = function (spec, setTrackStyle, callback) {
      var updatedState = (0, _innerSliderUtils.initializedState)(spec);
      spec = _extends({}, spec, updatedState, { slideIndex: updatedState.currentSlide });
      var targetLeft = (0, _innerSliderUtils.getTrackLeft)(spec);
      spec = _extends({}, spec, { left: targetLeft });
      var trackStyle = (0, _innerSliderUtils.getTrackCSS)(spec);
      if (setTrackStyle || _react2.default.Children.count(_this.props.children) !== _react2.default.Children.count(spec.children)) {
        updatedState["trackStyle"] = trackStyle;
      }
      _this.setState(updatedState, callback);
    };

    _this.ssrInit = function () {
      if (_this.props.variableWidth) {
        var _trackWidth = 0,
            _trackLeft = 0;
        var childrenWidths = [];
        var preClones = (0, _innerSliderUtils.getPreClones)(_extends({}, _this.props, _this.state, {
          slideCount: _this.props.children.length
        }));
        var postClones = (0, _innerSliderUtils.getPostClones)(_extends({}, _this.props, _this.state, {
          slideCount: _this.props.children.length
        }));
        _this.props.children.forEach(function (child) {
          childrenWidths.push(child.props.style.width);
          _trackWidth += child.props.style.width;
        });
        for (var i = 0; i < preClones; i++) {
          _trackLeft += childrenWidths[childrenWidths.length - 1 - i];
          _trackWidth += childrenWidths[childrenWidths.length - 1 - i];
        }
        for (var _i2 = 0; _i2 < postClones; _i2++) {
          _trackWidth += childrenWidths[_i2];
        }
        for (var _i3 = 0; _i3 < _this.state.currentSlide; _i3++) {
          _trackLeft += childrenWidths[_i3];
        }
        var _trackStyle = {
          width: _trackWidth + "px",
          left: -_trackLeft + "px"
        };
        if (_this.props.centerMode) {
          var currentWidth = childrenWidths[_this.state.currentSlide] + "px";
          _trackStyle.left = "calc(" + _trackStyle.left + " + (100% - " + currentWidth + ") / 2 ) ";
        }
        _this.setState({
          trackStyle: _trackStyle
        });
        return;
      }
      var childrenCount = _react2.default.Children.count(_this.props.children);
      var spec = _extends({}, _this.props, _this.state, { slideCount: childrenCount });
      var slideCount = (0, _innerSliderUtils.getPreClones)(spec) + (0, _innerSliderUtils.getPostClones)(spec) + childrenCount;
      var trackWidth = 100 / _this.props.slidesToShow * slideCount;
      var slideWidth = 100 / slideCount;
      var trackLeft = -slideWidth * ((0, _innerSliderUtils.getPreClones)(spec) + _this.state.currentSlide) * trackWidth / 100;
      if (_this.props.centerMode) {
        trackLeft += (100 - slideWidth * trackWidth / 100) / 2;
      }
      var trackStyle = {
        width: trackWidth + "%",
        left: trackLeft + "%"
      };
      _this.setState({
        slideWidth: slideWidth + "%",
        trackStyle: trackStyle
      });
    };

    _this.checkImagesLoad = function () {
      var images = document.querySelectorAll(".slick-slide img");
      var imagesCount = images.length,
          loadedCount = 0;
      Array.prototype.forEach.call(images, function (image) {
        var handler = function handler() {
          return ++loadedCount && loadedCount >= imagesCount && _this.onWindowResized();
        };
        if (!image.onclick) {
          image.onclick = function () {
            return image.parentNode.focus();
          };
        } else {
          var prevClickHandler = image.onclick;
          image.onclick = function () {
            prevClickHandler();
            image.parentNode.focus();
          };
        }
        if (!image.onload) {
          if (_this.props.lazyLoad) {
            image.onload = function () {
              _this.adaptHeight();
              _this.callbackTimers.push(setTimeout(_this.onWindowResized, _this.props.speed));
            };
          } else {
            image.onload = handler;
            image.onerror = function () {
              handler();
              _this.props.onLazyLoadError && _this.props.onLazyLoadError();
            };
          }
        }
      });
    };

    _this.progressiveLazyLoad = function () {
      var slidesToLoad = [];
      var spec = _extends({}, _this.props, _this.state);
      for (var index = _this.state.currentSlide; index < _this.state.slideCount + (0, _innerSliderUtils.getPostClones)(spec); index++) {
        if (_this.state.lazyLoadedList.indexOf(index) < 0) {
          slidesToLoad.push(index);
          break;
        }
      }
      for (var _index = _this.state.currentSlide - 1; _index >= -(0, _innerSliderUtils.getPreClones)(spec); _index--) {
        if (_this.state.lazyLoadedList.indexOf(_index) < 0) {
          slidesToLoad.push(_index);
          break;
        }
      }
      if (slidesToLoad.length > 0) {
        _this.setState(function (state) {
          return {
            lazyLoadedList: state.lazyLoadedList.concat(slidesToLoad)
          };
        });
        if (_this.props.onLazyLoad) {
          _this.props.onLazyLoad(slidesToLoad);
        }
      } else {
        if (_this.lazyLoadTimer) {
          clearInterval(_this.lazyLoadTimer);
          delete _this.lazyLoadTimer;
        }
      }
    };

    _this.slideHandler = function (index) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
      var _this$props = _this.props,
          asNavFor = _this$props.asNavFor,
          beforeChange = _this$props.beforeChange,
          onLazyLoad = _this$props.onLazyLoad,
          speed = _this$props.speed,
          afterChange = _this$props.afterChange;
      // capture currentslide before state is updated

      var currentSlide = _this.state.currentSlide;

      var _slideHandler = (0, _innerSliderUtils.slideHandler)(_extends({
        index: index
      }, _this.props, _this.state, {
        trackRef: _this.track,
        useCSS: _this.props.useCSS && !dontAnimate
      })),
          state = _slideHandler.state,
          nextState = _slideHandler.nextState;

      if (!state) return;
      beforeChange && beforeChange(currentSlide, state.currentSlide);
      var slidesToLoad = state.lazyLoadedList.filter(function (value) {
        return _this.state.lazyLoadedList.indexOf(value) < 0;
      });
      onLazyLoad && slidesToLoad.length > 0 && onLazyLoad(slidesToLoad);
      _this.setState(state, function () {
        asNavFor && asNavFor.innerSlider.state.currentSlide !== currentSlide && asNavFor.innerSlider.slideHandler(index);
        if (!nextState) return;
        _this.animationEndCallback = setTimeout(function () {
          var animating = nextState.animating,
              firstBatch = _objectWithoutProperties(nextState, ["animating"]);

          _this.setState(firstBatch, function () {
            _this.callbackTimers.push(setTimeout(function () {
              return _this.setState({ animating: animating });
            }, 10));
            afterChange && afterChange(state.currentSlide);
            delete _this.animationEndCallback;
          });
        }, speed);
      });
    };

    _this.changeSlide = function (options) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      var spec = _extends({}, _this.props, _this.state);
      var targetSlide = (0, _innerSliderUtils.changeSlide)(spec, options);
      if (targetSlide !== 0 && !targetSlide) return;
      if (dontAnimate === true) {
        _this.slideHandler(targetSlide, dontAnimate);
      } else {
        _this.slideHandler(targetSlide);
      }
    };

    _this.clickHandler = function (e) {
      if (_this.clickable === false) {
        e.stopPropagation();
        e.preventDefault();
      }
      _this.clickable = true;
    };

    _this.keyHandler = function (e) {
      var dir = (0, _innerSliderUtils.keyHandler)(e, _this.props.accessibility, _this.props.rtl);
      dir !== "" && _this.changeSlide({ message: dir });
    };

    _this.selectHandler = function (options) {
      _this.changeSlide(options);
    };

    _this.disableBodyScroll = function () {
      var preventDefault = function preventDefault(e) {
        e = e || window.event;
        if (e.preventDefault) e.preventDefault();
        e.returnValue = false;
      };
      window.ontouchmove = preventDefault;
    };

    _this.enableBodyScroll = function () {
      window.ontouchmove = null;
    };

    _this.swipeStart = function (e) {
      if (_this.props.verticalSwiping) {
        _this.disableBodyScroll();
      }
      var state = (0, _innerSliderUtils.swipeStart)(e, _this.props.swipe, _this.props.draggable);
      state !== "" && _this.setState(state);
    };

    _this.swipeMove = function (e) {
      var state = (0, _innerSliderUtils.swipeMove)(e, _extends({}, _this.props, _this.state, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;
      if (state["swiping"]) {
        _this.clickable = false;
      }
      _this.setState(state);
    };

    _this.swipeEnd = function (e) {
      var state = (0, _innerSliderUtils.swipeEnd)(e, _extends({}, _this.props, _this.state, {
        trackRef: _this.track,
        listRef: _this.list,
        slideIndex: _this.state.currentSlide
      }));
      if (!state) return;
      var triggerSlideHandler = state["triggerSlideHandler"];
      delete state["triggerSlideHandler"];
      _this.setState(state);
      if (triggerSlideHandler === undefined) return;
      _this.slideHandler(triggerSlideHandler);
      if (_this.props.verticalSwiping) {
        _this.enableBodyScroll();
      }
    };

    _this.slickPrev = function () {
      // this and fellow methods are wrapped in setTimeout
      // to make sure initialize setState has happened before
      // any of such methods are called
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({ message: "previous" });
      }, 0));
    };

    _this.slickNext = function () {
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({ message: "next" });
      }, 0));
    };

    _this.slickGoTo = function (slide) {
      var dontAnimate = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;

      slide = Number(slide);
      if (isNaN(slide)) return "";
      _this.callbackTimers.push(setTimeout(function () {
        return _this.changeSlide({
          message: "index",
          index: slide,
          currentSlide: _this.state.currentSlide
        }, dontAnimate);
      }, 0));
    };

    _this.play = function () {
      var nextIndex;
      if (_this.props.rtl) {
        nextIndex = _this.state.currentSlide - _this.props.slidesToScroll;
      } else {
        if ((0, _innerSliderUtils.canGoNext)(_extends({}, _this.props, _this.state))) {
          nextIndex = _this.state.currentSlide + _this.props.slidesToScroll;
        } else {
          return false;
        }
      }

      _this.slideHandler(nextIndex);
    };

    _this.autoPlay = function (playType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
      }
      var autoplaying = _this.state.autoplaying;
      if (playType === "update") {
        if (autoplaying === "hovered" || autoplaying === "focused" || autoplaying === "paused") {
          return;
        }
      } else if (playType === "leave") {
        if (autoplaying === "paused" || autoplaying === "focused") {
          return;
        }
      } else if (playType === "blur") {
        if (autoplaying === "paused" || autoplaying === "hovered") {
          return;
        }
      }
      _this.autoplayTimer = setInterval(_this.play, _this.props.autoplaySpeed + 50);
      _this.setState({ autoplaying: "playing" });
    };

    _this.pause = function (pauseType) {
      if (_this.autoplayTimer) {
        clearInterval(_this.autoplayTimer);
        _this.autoplayTimer = null;
      }
      var autoplaying = _this.state.autoplaying;
      if (pauseType === "paused") {
        _this.setState({ autoplaying: "paused" });
      } else if (pauseType === "focused") {
        if (autoplaying === "hovered" || autoplaying === "playing") {
          _this.setState({ autoplaying: "focused" });
        }
      } else {
        // pauseType  is 'hovered'
        if (autoplaying === "playing") {
          _this.setState({ autoplaying: "hovered" });
        }
      }
    };

    _this.onDotsOver = function () {
      return _this.props.autoplay && _this.pause("hovered");
    };

    _this.onDotsLeave = function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    };

    _this.onTrackOver = function () {
      return _this.props.autoplay && _this.pause("hovered");
    };

    _this.onTrackLeave = function () {
      return _this.props.autoplay && _this.state.autoplaying === "hovered" && _this.autoPlay("leave");
    };

    _this.onSlideFocus = function () {
      return _this.props.autoplay && _this.pause("focused");
    };

    _this.onSlideBlur = function () {
      return _this.props.autoplay && _this.state.autoplaying === "focused" && _this.autoPlay("blur");
    };

    _this.render = function () {
      var className = (0, _classnames2.default)("slick-slider", _this.props.className, {
        "slick-vertical": _this.props.vertical,
        "slick-initialized": true
      });
      var spec = _extends({}, _this.props, _this.state);
      var trackProps = (0, _innerSliderUtils.extractObject)(spec, ["fade", "cssEase", "speed", "infinite", "centerMode", "focusOnSelect", "currentSlide", "lazyLoad", "lazyLoadedList", "rtl", "slideWidth", "slideHeight", "listHeight", "vertical", "slidesToShow", "slidesToScroll", "slideCount", "trackStyle", "variableWidth", "unslick", "centerPadding"]);
      var pauseOnHover = _this.props.pauseOnHover;

      trackProps = _extends({}, trackProps, {
        onMouseEnter: pauseOnHover ? _this.onTrackOver : null,
        onMouseLeave: pauseOnHover ? _this.onTrackLeave : null,
        onMouseOver: pauseOnHover ? _this.onTrackOver : null,
        focusOnSelect: _this.props.focusOnSelect ? _this.selectHandler : null
      });

      var dots;
      if (_this.props.dots === true && _this.state.slideCount >= _this.props.slidesToShow) {
        var dotProps = (0, _innerSliderUtils.extractObject)(spec, ["dotsClass", "slideCount", "slidesToShow", "currentSlide", "slidesToScroll", "clickHandler", "children", "customPaging", "infinite", "appendDots"]);
        var pauseOnDotsHover = _this.props.pauseOnDotsHover;

        dotProps = _extends({}, dotProps, {
          clickHandler: _this.changeSlide,
          onMouseEnter: pauseOnDotsHover ? _this.onDotsLeave : null,
          onMouseOver: pauseOnDotsHover ? _this.onDotsOver : null,
          onMouseLeave: pauseOnDotsHover ? _this.onDotsLeave : null
        });
        dots = _react2.default.createElement(_dots.Dots, dotProps);
      }

      var prevArrow, nextArrow;
      var arrowProps = (0, _innerSliderUtils.extractObject)(spec, ["infinite", "centerMode", "currentSlide", "slideCount", "slidesToShow", "prevArrow", "nextArrow"]);
      arrowProps.clickHandler = _this.changeSlide;

      if (_this.props.arrows) {
        prevArrow = _react2.default.createElement(_arrows.PrevArrow, arrowProps);
        nextArrow = _react2.default.createElement(_arrows.NextArrow, arrowProps);
      }

      var verticalHeightStyle = null;

      if (_this.props.vertical) {
        verticalHeightStyle = {
          height: _this.state.listHeight
        };
      }

      var centerPaddingStyle = null;

      if (_this.props.vertical === false) {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: "0px " + _this.props.centerPadding
          };
        }
      } else {
        if (_this.props.centerMode === true) {
          centerPaddingStyle = {
            padding: _this.props.centerPadding + " 0px"
          };
        }
      }

      var listStyle = _extends({}, verticalHeightStyle, centerPaddingStyle);
      var touchMove = _this.props.touchMove;
      var listProps = {
        className: "slick-list",
        style: listStyle,
        onClick: _this.clickHandler,
        onMouseDown: touchMove ? _this.swipeStart : null,
        onMouseMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onMouseUp: touchMove ? _this.swipeEnd : null,
        onMouseLeave: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onTouchStart: touchMove ? _this.swipeStart : null,
        onTouchMove: _this.state.dragging && touchMove ? _this.swipeMove : null,
        onTouchEnd: touchMove ? _this.swipeEnd : null,
        onTouchCancel: _this.state.dragging && touchMove ? _this.swipeEnd : null,
        onKeyDown: _this.props.accessibility ? _this.keyHandler : null
      };

      var innerSliderProps = {
        className: className,
        dir: "ltr"
      };

      if (_this.props.unslick) {
        listProps = { className: "slick-list" };
        innerSliderProps = { className: className };
      }
      return _react2.default.createElement(
        "div",
        innerSliderProps,
        !_this.props.unslick ? prevArrow : "",
        _react2.default.createElement(
          "div",
          _extends({ ref: _this.listRefHandler }, listProps),
          _react2.default.createElement(
            _track.Track,
            _extends({ ref: _this.trackRefHandler }, trackProps),
            _this.props.children
          )
        ),
        !_this.props.unslick ? nextArrow : "",
        !_this.props.unslick ? dots : ""
      );
    };

    _this.list = null;
    _this.track = null;
    _this.state = _extends({}, _initialState2.default, {
      currentSlide: _this.props.initialSlide,
      slideCount: _react2.default.Children.count(_this.props.children)
    });
    _this.callbackTimers = [];
    _this.clickable = true;
    _this.debouncedResize = null;
    return _this;
  }

  return InnerSlider;
}(_react2.default.Component);

/***/ }),
/* 524 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
var initialState = {
  animating: false,
  autoplaying: null,
  currentDirection: 0,
  currentLeft: null,
  currentSlide: 0,
  direction: 1,
  dragging: false,
  edgeDragged: false,
  initialized: false,
  lazyLoadedList: [],
  listHeight: null,
  listWidth: null,
  scrolling: false,
  slideCount: null,
  slideHeight: null,
  slideWidth: null,
  swipeLeft: null,
  swiped: false, // used by swipeEvent. differentites between touch and swipe.
  swiping: false,
  touchObject: { startX: 0, startY: 0, curX: 0, curY: 0 },
  trackStyle: {},
  trackWidth: 0
};

exports.default = initialState;

/***/ }),
/* 525 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = debounce;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29)))

/***/ }),
/* 526 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Track = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

var _innerSliderUtils = __webpack_require__(125);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

// given specifications/props for a slide, fetch all the classes that need to be applied to the slide
var getSlideClasses = function getSlideClasses(spec) {
  var slickActive, slickCenter, slickCloned;
  var centerOffset, index;

  if (spec.rtl) {
    index = spec.slideCount - 1 - spec.index;
  } else {
    index = spec.index;
  }
  slickCloned = index < 0 || index >= spec.slideCount;
  if (spec.centerMode) {
    centerOffset = Math.floor(spec.slidesToShow / 2);
    slickCenter = (index - spec.currentSlide) % spec.slideCount === 0;
    if (index > spec.currentSlide - centerOffset - 1 && index <= spec.currentSlide + centerOffset) {
      slickActive = true;
    }
  } else {
    slickActive = spec.currentSlide <= index && index < spec.currentSlide + spec.slidesToShow;
  }
  var slickCurrent = index === spec.currentSlide;
  return {
    "slick-slide": true,
    "slick-active": slickActive,
    "slick-center": slickCenter,
    "slick-cloned": slickCloned,
    "slick-current": slickCurrent // dubious in case of RTL
  };
};

var getSlideStyle = function getSlideStyle(spec) {
  var style = {};

  if (spec.variableWidth === undefined || spec.variableWidth === false) {
    style.width = spec.slideWidth;
  }

  if (spec.fade) {
    style.position = "relative";
    if (spec.vertical) {
      style.top = -spec.index * parseInt(spec.slideHeight);
    } else {
      style.left = -spec.index * parseInt(spec.slideWidth);
    }
    style.opacity = spec.currentSlide === spec.index ? 1 : 0;
    style.transition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
    style.WebkitTransition = "opacity " + spec.speed + "ms " + spec.cssEase + ", " + "visibility " + spec.speed + "ms " + spec.cssEase;
  }

  return style;
};

var getKey = function getKey(child, fallbackKey) {
  return child.key || fallbackKey;
};

var renderSlides = function renderSlides(spec) {
  var key;
  var slides = [];
  var preCloneSlides = [];
  var postCloneSlides = [];
  var childrenCount = _react2.default.Children.count(spec.children);
  var startIndex = (0, _innerSliderUtils.lazyStartIndex)(spec);
  var endIndex = (0, _innerSliderUtils.lazyEndIndex)(spec);

  _react2.default.Children.forEach(spec.children, function (elem, index) {
    var child = void 0;
    var childOnClickOptions = {
      message: "children",
      index: index,
      slidesToScroll: spec.slidesToScroll,
      currentSlide: spec.currentSlide
    };

    // in case of lazyLoad, whether or not we want to fetch the slide
    if (!spec.lazyLoad || spec.lazyLoad && spec.lazyLoadedList.indexOf(index) >= 0) {
      child = elem;
    } else {
      child = _react2.default.createElement("div", null);
    }
    var childStyle = getSlideStyle(_extends({}, spec, { index: index }));
    var slideClass = child.props.className || "";
    var slideClasses = getSlideClasses(_extends({}, spec, { index: index }));
    // push a cloned element of the desired slide
    slides.push(_react2.default.cloneElement(child, {
      key: "original" + getKey(child, index),
      "data-index": index,
      className: (0, _classnames2.default)(slideClasses, slideClass),
      tabIndex: "-1",
      "aria-hidden": !slideClasses["slick-active"],
      style: _extends({ outline: "none" }, child.props.style || {}, childStyle),
      onClick: function onClick(e) {
        child.props && child.props.onClick && child.props.onClick(e);
        if (spec.focusOnSelect) {
          spec.focusOnSelect(childOnClickOptions);
        }
      }
    }));

    // if slide needs to be precloned or postcloned
    if (spec.infinite && spec.fade === false) {
      var preCloneNo = childrenCount - index;
      if (preCloneNo <= (0, _innerSliderUtils.getPreClones)(spec) && childrenCount !== spec.slidesToShow) {
        key = -preCloneNo;
        if (key >= startIndex) {
          child = elem;
        }
        slideClasses = getSlideClasses(_extends({}, spec, { index: key }));
        preCloneSlides.push(_react2.default.cloneElement(child, {
          key: "precloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames2.default)(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _extends({}, child.props.style || {}, childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);
            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }

      if (childrenCount !== spec.slidesToShow) {
        key = childrenCount + index;
        if (key < endIndex) {
          child = elem;
        }
        slideClasses = getSlideClasses(_extends({}, spec, { index: key }));
        postCloneSlides.push(_react2.default.cloneElement(child, {
          key: "postcloned" + getKey(child, key),
          "data-index": key,
          tabIndex: "-1",
          className: (0, _classnames2.default)(slideClasses, slideClass),
          "aria-hidden": !slideClasses["slick-active"],
          style: _extends({}, child.props.style || {}, childStyle),
          onClick: function onClick(e) {
            child.props && child.props.onClick && child.props.onClick(e);
            if (spec.focusOnSelect) {
              spec.focusOnSelect(childOnClickOptions);
            }
          }
        }));
      }
    }
  });

  if (spec.rtl) {
    return preCloneSlides.concat(slides, postCloneSlides).reverse();
  } else {
    return preCloneSlides.concat(slides, postCloneSlides);
  }
};

var Track = exports.Track = function (_React$PureComponent) {
  _inherits(Track, _React$PureComponent);

  function Track() {
    _classCallCheck(this, Track);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  Track.prototype.render = function render() {
    var slides = renderSlides(this.props);
    var _props = this.props,
        onMouseEnter = _props.onMouseEnter,
        onMouseOver = _props.onMouseOver,
        onMouseLeave = _props.onMouseLeave;

    var mouseEvents = { onMouseEnter: onMouseEnter, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave };
    return _react2.default.createElement(
      "div",
      _extends({
        className: "slick-track",
        style: this.props.trackStyle
      }, mouseEvents),
      slides
    );
  };

  return Track;
}(_react2.default.PureComponent);

/***/ }),
/* 527 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.Dots = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var getDotCount = function getDotCount(spec) {
  var dots;

  if (spec.infinite) {
    dots = Math.ceil(spec.slideCount / spec.slidesToScroll);
  } else {
    dots = Math.ceil((spec.slideCount - spec.slidesToShow) / spec.slidesToScroll) + 1;
  }

  return dots;
};

var Dots = exports.Dots = function (_React$PureComponent) {
  _inherits(Dots, _React$PureComponent);

  function Dots() {
    _classCallCheck(this, Dots);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  Dots.prototype.clickHandler = function clickHandler(options, e) {
    // In Autoplay the focus stays on clicked button even after transition
    // to next slide. That only goes away by click somewhere outside
    e.preventDefault();
    this.props.clickHandler(options);
  };

  Dots.prototype.render = function render() {
    var _this2 = this;

    var dotCount = getDotCount({
      slideCount: this.props.slideCount,
      slidesToScroll: this.props.slidesToScroll,
      slidesToShow: this.props.slidesToShow,
      infinite: this.props.infinite
    });

    // Apply join & split to Array to pre-fill it for IE8
    //
    // Credit: http://stackoverflow.com/a/13735425/1849458
    var _props = this.props,
        onMouseEnter = _props.onMouseEnter,
        onMouseOver = _props.onMouseOver,
        onMouseLeave = _props.onMouseLeave;

    var mouseEvents = { onMouseEnter: onMouseEnter, onMouseOver: onMouseOver, onMouseLeave: onMouseLeave };
    var dots = Array.apply(null, Array(dotCount + 1).join("0").split("")).map(function (x, i) {
      var leftBound = i * _this2.props.slidesToScroll;
      var rightBound = i * _this2.props.slidesToScroll + (_this2.props.slidesToScroll - 1);
      var className = (0, _classnames2.default)({
        "slick-active": _this2.props.currentSlide >= leftBound && _this2.props.currentSlide <= rightBound
      });

      var dotOptions = {
        message: "dots",
        index: i,
        slidesToScroll: _this2.props.slidesToScroll,
        currentSlide: _this2.props.currentSlide
      };

      var onClick = _this2.clickHandler.bind(_this2, dotOptions);
      return _react2.default.createElement(
        "li",
        { key: i, className: className },
        _react2.default.cloneElement(_this2.props.customPaging(i), { onClick: onClick })
      );
    });

    return _react2.default.cloneElement(this.props.appendDots(dots), _extends({
      className: this.props.dotsClass
    }, mouseEvents));
  };

  return Dots;
}(_react2.default.PureComponent);

/***/ }),
/* 528 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.NextArrow = exports.PrevArrow = undefined;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _classnames = __webpack_require__(9);

var _classnames2 = _interopRequireDefault(_classnames);

var _innerSliderUtils = __webpack_require__(125);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var PrevArrow = exports.PrevArrow = function (_React$PureComponent) {
  _inherits(PrevArrow, _React$PureComponent);

  function PrevArrow() {
    _classCallCheck(this, PrevArrow);

    return _possibleConstructorReturn(this, _React$PureComponent.apply(this, arguments));
  }

  PrevArrow.prototype.clickHandler = function clickHandler(options, e) {
    if (e) {
      e.preventDefault();
    }
    this.props.clickHandler(options, e);
  };

  PrevArrow.prototype.render = function render() {
    var prevClasses = { "slick-arrow": true, "slick-prev": true };
    var prevHandler = this.clickHandler.bind(this, { message: "previous" });

    if (!this.props.infinite && (this.props.currentSlide === 0 || this.props.slideCount <= this.props.slidesToShow)) {
      prevClasses["slick-disabled"] = true;
      prevHandler = null;
    }

    var prevArrowProps = {
      key: "0",
      "data-role": "none",
      className: (0, _classnames2.default)(prevClasses),
      style: { display: "block" },
      onClick: prevHandler
    };
    var customProps = {
      currentSlide: this.props.currentSlide,
      slideCount: this.props.slideCount
    };
    var prevArrow = void 0;

    if (this.props.prevArrow) {
      prevArrow = _react2.default.cloneElement(this.props.prevArrow, _extends({}, prevArrowProps, customProps));
    } else {
      prevArrow = _react2.default.createElement(
        "button",
        _extends({ key: "0", type: "button" }, prevArrowProps),
        " ",
        "Previous"
      );
    }

    return prevArrow;
  };

  return PrevArrow;
}(_react2.default.PureComponent);

var NextArrow = exports.NextArrow = function (_React$PureComponent2) {
  _inherits(NextArrow, _React$PureComponent2);

  function NextArrow() {
    _classCallCheck(this, NextArrow);

    return _possibleConstructorReturn(this, _React$PureComponent2.apply(this, arguments));
  }

  NextArrow.prototype.clickHandler = function clickHandler(options, e) {
    if (e) {
      e.preventDefault();
    }
    this.props.clickHandler(options, e);
  };

  NextArrow.prototype.render = function render() {
    var nextClasses = { "slick-arrow": true, "slick-next": true };
    var nextHandler = this.clickHandler.bind(this, { message: "next" });

    if (!(0, _innerSliderUtils.canGoNext)(this.props)) {
      nextClasses["slick-disabled"] = true;
      nextHandler = null;
    }

    var nextArrowProps = {
      key: "1",
      "data-role": "none",
      className: (0, _classnames2.default)(nextClasses),
      style: { display: "block" },
      onClick: nextHandler
    };
    var customProps = {
      currentSlide: this.props.currentSlide,
      slideCount: this.props.slideCount
    };
    var nextArrow = void 0;

    if (this.props.nextArrow) {
      nextArrow = _react2.default.cloneElement(this.props.nextArrow, _extends({}, nextArrowProps, customProps));
    } else {
      nextArrow = _react2.default.createElement(
        "button",
        _extends({ key: "1", type: "button" }, nextArrowProps),
        " ",
        "Next"
      );
    }

    return nextArrow;
  };

  return NextArrow;
}(_react2.default.PureComponent);

/***/ }),
/* 529 */
/***/ (function(module, exports, __webpack_require__) {

var camel2hyphen = __webpack_require__(530);

var isDimension = function (feature) {
  var re = /[height|width]$/;
  return re.test(feature);
};

var obj2mq = function (obj) {
  var mq = '';
  var features = Object.keys(obj);
  features.forEach(function (feature, index) {
    var value = obj[feature];
    feature = camel2hyphen(feature);
    // Add px to dimension features
    if (isDimension(feature) && typeof value === 'number') {
      value = value + 'px';
    }
    if (value === true) {
      mq += feature;
    } else if (value === false) {
      mq += 'not ' + feature;
    } else {
      mq += '(' + feature + ': ' + value + ')';
    }
    if (index < features.length-1) {
      mq += ' and '
    }
  });
  return mq;
};

var json2mq = function (query) {
  var mq = '';
  if (typeof query === 'string') {
    return query;
  }
  // Handling array of media queries
  if (query instanceof Array) {
    query.forEach(function (q, index) {
      mq += obj2mq(q);
      if (index < query.length-1) {
        mq += ', '
      }
    });
    return mq;
  }
  // Handling single media query
  return obj2mq(query);
};

module.exports = json2mq;

/***/ }),
/* 530 */
/***/ (function(module, exports) {

var camel2hyphen = function (str) {
  return str
          .replace(/[A-Z]/g, function (match) {
            return '-' + match.toLowerCase();
          })
          .toLowerCase();
};

module.exports = camel2hyphen;

/***/ }),
/* 531 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var defaultProps = {
  accessibility: true,
  adaptiveHeight: false,
  afterChange: null,
  appendDots: function appendDots(dots) {
    return _react2.default.createElement(
      "ul",
      { style: { display: "block" } },
      dots
    );
  },
  arrows: true,
  autoplay: false,
  autoplaySpeed: 3000,
  beforeChange: null,
  centerMode: false,
  centerPadding: "50px",
  className: "",
  cssEase: "ease",
  customPaging: function customPaging(i) {
    return _react2.default.createElement(
      "button",
      null,
      i + 1
    );
  },
  dots: false,
  dotsClass: "slick-dots",
  draggable: true,
  easing: "linear",
  edgeFriction: 0.35,
  fade: false,
  focusOnSelect: false,
  infinite: true,
  initialSlide: 0,
  lazyLoad: null,
  nextArrow: null,
  onEdge: null,
  onInit: null,
  onLazyLoadError: null,
  onReInit: null,
  pauseOnDotsHover: false,
  pauseOnFocus: false,
  pauseOnHover: true,
  prevArrow: null,
  responsive: null,
  rows: 1,
  rtl: false,
  slide: "div",
  slidesPerRow: 1,
  slidesToScroll: 1,
  slidesToShow: 1,
  speed: 500,
  swipe: true,
  swipeEvent: null,
  swipeToSlide: false,
  touchMove: true,
  touchThreshold: 5,
  useCSS: true,
  useTransform: true,
  variableWidth: false,
  vertical: false,
  waitForAnimate: true
};

exports.default = defaultProps;

/***/ }),
/* 532 */
/***/ (function(module, exports, __webpack_require__) {

var MediaQuery = __webpack_require__(533);
var Util = __webpack_require__(270);
var each = Util.each;
var isFunction = Util.isFunction;
var isArray = Util.isArray;

/**
 * Allows for registration of query handlers.
 * Manages the query handler's state and is responsible for wiring up browser events
 *
 * @constructor
 */
function MediaQueryDispatch () {
    if(!window.matchMedia) {
        throw new Error('matchMedia not present, legacy browsers require a polyfill');
    }

    this.queries = {};
    this.browserIsIncapable = !window.matchMedia('only all').matches;
}

MediaQueryDispatch.prototype = {

    constructor : MediaQueryDispatch,

    /**
     * Registers a handler for the given media query
     *
     * @param {string} q the media query
     * @param {object || Array || Function} options either a single query handler object, a function, or an array of query handlers
     * @param {function} options.match fired when query matched
     * @param {function} [options.unmatch] fired when a query is no longer matched
     * @param {function} [options.setup] fired when handler first triggered
     * @param {boolean} [options.deferSetup=false] whether setup should be run immediately or deferred until query is first matched
     * @param {boolean} [shouldDegrade=false] whether this particular media query should always run on incapable browsers
     */
    register : function(q, options, shouldDegrade) {
        var queries         = this.queries,
            isUnconditional = shouldDegrade && this.browserIsIncapable;

        if(!queries[q]) {
            queries[q] = new MediaQuery(q, isUnconditional);
        }

        //normalise to object in an array
        if(isFunction(options)) {
            options = { match : options };
        }
        if(!isArray(options)) {
            options = [options];
        }
        each(options, function(handler) {
            if (isFunction(handler)) {
                handler = { match : handler };
            }
            queries[q].addHandler(handler);
        });

        return this;
    },

    /**
     * unregisters a query and all it's handlers, or a specific handler for a query
     *
     * @param {string} q the media query to target
     * @param {object || function} [handler] specific handler to unregister
     */
    unregister : function(q, handler) {
        var query = this.queries[q];

        if(query) {
            if(handler) {
                query.removeHandler(handler);
            }
            else {
                query.clear();
                delete this.queries[q];
            }
        }

        return this;
    }
};

module.exports = MediaQueryDispatch;


/***/ }),
/* 533 */
/***/ (function(module, exports, __webpack_require__) {

var QueryHandler = __webpack_require__(534);
var each = __webpack_require__(270).each;

/**
 * Represents a single media query, manages it's state and registered handlers for this query
 *
 * @constructor
 * @param {string} query the media query string
 * @param {boolean} [isUnconditional=false] whether the media query should run regardless of whether the conditions are met. Primarily for helping older browsers deal with mobile-first design
 */
function MediaQuery(query, isUnconditional) {
    this.query = query;
    this.isUnconditional = isUnconditional;
    this.handlers = [];
    this.mql = window.matchMedia(query);

    var self = this;
    this.listener = function(mql) {
        // Chrome passes an MediaQueryListEvent object, while other browsers pass MediaQueryList directly
        self.mql = mql.currentTarget || mql;
        self.assess();
    };
    this.mql.addListener(this.listener);
}

MediaQuery.prototype = {

    constuctor : MediaQuery,

    /**
     * add a handler for this query, triggering if already active
     *
     * @param {object} handler
     * @param {function} handler.match callback for when query is activated
     * @param {function} [handler.unmatch] callback for when query is deactivated
     * @param {function} [handler.setup] callback for immediate execution when a query handler is registered
     * @param {boolean} [handler.deferSetup=false] should the setup callback be deferred until the first time the handler is matched?
     */
    addHandler : function(handler) {
        var qh = new QueryHandler(handler);
        this.handlers.push(qh);

        this.matches() && qh.on();
    },

    /**
     * removes the given handler from the collection, and calls it's destroy methods
     *
     * @param {object || function} handler the handler to remove
     */
    removeHandler : function(handler) {
        var handlers = this.handlers;
        each(handlers, function(h, i) {
            if(h.equals(handler)) {
                h.destroy();
                return !handlers.splice(i,1); //remove from array and exit each early
            }
        });
    },

    /**
     * Determine whether the media query should be considered a match
     *
     * @return {Boolean} true if media query can be considered a match, false otherwise
     */
    matches : function() {
        return this.mql.matches || this.isUnconditional;
    },

    /**
     * Clears all handlers and unbinds events
     */
    clear : function() {
        each(this.handlers, function(handler) {
            handler.destroy();
        });
        this.mql.removeListener(this.listener);
        this.handlers.length = 0; //clear array
    },

    /*
        * Assesses the query, turning on all handlers if it matches, turning them off if it doesn't match
        */
    assess : function() {
        var action = this.matches() ? 'on' : 'off';

        each(this.handlers, function(handler) {
            handler[action]();
        });
    }
};

module.exports = MediaQuery;


/***/ }),
/* 534 */
/***/ (function(module, exports) {

/**
 * Delegate to handle a media query being matched and unmatched.
 *
 * @param {object} options
 * @param {function} options.match callback for when the media query is matched
 * @param {function} [options.unmatch] callback for when the media query is unmatched
 * @param {function} [options.setup] one-time callback triggered the first time a query is matched
 * @param {boolean} [options.deferSetup=false] should the setup callback be run immediately, rather than first time query is matched?
 * @constructor
 */
function QueryHandler(options) {
    this.options = options;
    !options.deferSetup && this.setup();
}

QueryHandler.prototype = {

    constructor : QueryHandler,

    /**
     * coordinates setup of the handler
     *
     * @function
     */
    setup : function() {
        if(this.options.setup) {
            this.options.setup();
        }
        this.initialised = true;
    },

    /**
     * coordinates setup and triggering of the handler
     *
     * @function
     */
    on : function() {
        !this.initialised && this.setup();
        this.options.match && this.options.match();
    },

    /**
     * coordinates the unmatch event for the handler
     *
     * @function
     */
    off : function() {
        this.options.unmatch && this.options.unmatch();
    },

    /**
     * called when a handler is to be destroyed.
     * delegates to the destroy or unmatch callbacks, depending on availability.
     *
     * @function
     */
    destroy : function() {
        this.options.destroy ? this.options.destroy() : this.off();
    },

    /**
     * determines equality by reference.
     * if object is supplied compare options, if function, compare match callback
     *
     * @function
     * @param {object || function} [target] the target for comparison
     */
    equals : function(target) {
        return this.options === target || this.options.match === target;
    }

};

module.exports = QueryHandler;


/***/ }),
/* 535 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_GroupPartnerLogo__ = __webpack_require__(536);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_FooterBar__ = __webpack_require__(554);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_FooterMenu__ = __webpack_require__(607);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_SocialLink__ = __webpack_require__(715);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_LanguageSwitcher__ = __webpack_require__(252);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Footer=function(_PureComponent){_inherits(Footer,_PureComponent);function Footer(){_classCallCheck(this,Footer);return _possibleConstructorReturn(this,(Footer.__proto__||Object.getPrototypeOf(Footer)).apply(this,arguments));}_createClass(Footer,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"footer"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"group-partner-logo-block"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_GroupPartnerLogo__["a" /* default */],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"footer-menu-block"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_FooterMenu__["a" /* default */],null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"social-block"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-7"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_SocialLink__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"col-5 change-language"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components_LanguageSwitcher__["a" /* default */],null))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"footer-bar-block"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_FooterBar__["a" /* default */],null)));}}]);return Footer;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);/* harmony default export */ __webpack_exports__["a"] = (Footer);

/***/ }),
/* 536 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_filter__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_Common_parterLogo__ = __webpack_require__(272);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GroupPartnerLogo=function(_PureComponent){_inherits(GroupPartnerLogo,_PureComponent);function GroupPartnerLogo(){_classCallCheck(this,GroupPartnerLogo);return _possibleConstructorReturn(this,(GroupPartnerLogo.__proto__||Object.getPrototypeOf(GroupPartnerLogo)).apply(this,arguments));}_createClass(GroupPartnerLogo,[{key:"render",value:function render(){var filterRow=function filterRow(row){return __WEBPACK_IMPORTED_MODULE_2_lodash_filter___default()(__WEBPACK_IMPORTED_MODULE_4__data_Common_parterLogo__["a" /* parterLogo */],function(i){return __WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(i,"row",1)===row;});};return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:"container-group-partner-logo"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:"group-partner-logo"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:"group-logo-row-1"},__WEBPACK_IMPORTED_MODULE_0_lodash_map___default()(filterRow(1),function(item,key){if(item.showLogo===true){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("a",{href:item.link,key:key},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("img",{src:item.logoImg,alt:""}));}})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:"group-logo-row-2"},__WEBPACK_IMPORTED_MODULE_0_lodash_map___default()(filterRow(2),function(item,key){if(item.showLogo===true){if(__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item,"class")==="angsana"){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("a",{href:item.link,key:key},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{"class":"icon-holder"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("img",{"class":item.class,alt:"",src:item.logoImg})));}return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("a",{href:item.link,key:key},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("img",{src:item.logoImg,alt:""}));}}))));}}]);return GroupPartnerLogo;}(__WEBPACK_IMPORTED_MODULE_3_react__["PureComponent"]);/* harmony default export */ __webpack_exports__["a"] = (GroupPartnerLogo);

/***/ }),
/* 537 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/flogo_02.d565b8a6.svg";

/***/ }),
/* 538 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/flogo_03.5afe1c09.svg";

/***/ }),
/* 539 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/flogo_04.27ab94e2.svg";

/***/ }),
/* 540 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/flogo_05.0036c4c0.svg";

/***/ }),
/* 541 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/flogo_06.0bcb9348.svg";

/***/ }),
/* 542 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/flogo_07.43c01125.svg";

/***/ }),
/* 543 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/flogo_08.54e093cf.svg";

/***/ }),
/* 544 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/flogo_09.5574a491.svg";

/***/ }),
/* 545 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/flogo_10.cac98d7e.svg";

/***/ }),
/* 546 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/flogo_11.934b1df1.svg";

/***/ }),
/* 547 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/flogo_12.a38b3a38.svg";

/***/ }),
/* 548 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/flogo_13.d28c1df3.svg";

/***/ }),
/* 549 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/flogo_14.41efc604.svg";

/***/ }),
/* 550 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/flogo_15.bca32db1.svg";

/***/ }),
/* 551 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/flogo_16.f7f804d8.svg";

/***/ }),
/* 552 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/dhawa-phuket.afc623b4.svg";

/***/ }),
/* 553 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/skypark.ce93a44f.png";

/***/ }),
/* 554 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__ = __webpack_require__(555);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_icon_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__ = __webpack_require__(60);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_Common_parterLogo__ = __webpack_require__(272);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hoc__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_dec2,_class,_class2,_temp2;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var mapStateToProps=function mapStateToProps(state){return state;};var actionToProps={};var FooterBar=(_dec=Object(__WEBPACK_IMPORTED_MODULE_6__hoc__["a" /* multiLanguage */])(),_dec2=Object(__WEBPACK_IMPORTED_MODULE_6__hoc__["b" /* withRedux */])(mapStateToProps,actionToProps),_dec(_class=_dec2(_class=(_temp2=_class2=function(_Component){_inherits(FooterBar,_Component);function FooterBar(){var _ref;var _temp,_this,_ret;_classCallCheck(this,FooterBar);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=FooterBar.__proto__||Object.getPrototypeOf(FooterBar)).call.apply(_ref,[this].concat(args))),_this),_this.state={openToggle:false},_this.handleToggle=function(){var openToggle=_this.state.openToggle;_this.setState({openToggle:!openToggle});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(FooterBar,[{key:"render",value:function render(){var openToggle=this.state.openToggle;var t=this.props.t;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:"footer-bar"},openToggle&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:"associated-sites"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:"col"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:"menu-box"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("strong",null,t("Property"))),__WEBPACK_IMPORTED_MODULE_2_lodash_map___default()(__WEBPACK_IMPORTED_MODULE_5__data_Common_parterLogo__["a" /* parterLogo */],function(item,key){if(item.property===true){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("a",{href:item.link},item.name));}})))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:"col"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:"menu-box"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("strong",null,t("Non-Property"))),__WEBPACK_IMPORTED_MODULE_2_lodash_map___default()(__WEBPACK_IMPORTED_MODULE_5__data_Common_parterLogo__["a" /* parterLogo */],function(item,key){if(item.property!==true){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("a",{href:item.link},item.name));}}))))))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:"row justify-content-between"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:"col-md-7"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("ul",{className:"container-footer-bar"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("li",{className:"container-footer-bar-menu"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("a",{href:"https://lagunaproperty.com/en/sitemap"},t("Site Map"))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("li",{className:"container-footer-bar-menu"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("a",{href:"https://lagunaproperty.com/en/terms"},t("Term of Use"))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("li",{className:"container-footer-bar-menu"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("a",{href:"https://lagunaproperty.com/en/privacy-policy"},t("Privacy Policy"))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("li",{className:"d-md-none"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("a",{onClick:this.handleToggle},t("Associated sites"),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("span",{className:"icon-arrow"},openToggle===true?__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a,{type:"caret-down"}):__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_icon___default.a,{type:"caret-up"})))))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:"col-md-5"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:"container-rights"},"\xA9 Laguna Property 2022 all rights reserved")))));}}]);return FooterBar;}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]),_class2.propTypes={t:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired},_temp2))||_class)||_class);/* harmony default export */ __webpack_exports__["a"] = (FooterBar);

/***/ }),
/* 555 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(104);

__webpack_require__(556);

/***/ }),
/* 556 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 557 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

Object.defineProperty(exports, "__esModule", { value: true });
var normalViewBox = '0 0 1024 1024';
var newViewBox = '64 64 896 896';
var fill = 'fill';
var outline = 'outline';
var twotone = 'twotone';
function getNode(viewBox) {
    var paths = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        paths[_i - 1] = arguments[_i];
    }
    return {
        tag: 'svg',
        attrs: { viewBox: viewBox, focusable: false },
        children: paths.map(function (path) {
            if (Array.isArray(path)) {
                return {
                    tag: 'path',
                    attrs: {
                        fill: path[0],
                        d: path[1]
                    }
                };
            }
            return {
                tag: 'path',
                attrs: {
                    d: path
                }
            };
        })
    };
}
function getIcon(name, theme, icon) {
    return {
        name: name,
        theme: theme,
        icon: icon
    };
}
exports.AccountBookFill = getIcon('account-book', fill, getNode(newViewBox, 'M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zM648.3 426.8l-87.7 161.1h45.7c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4v29.7h63.4c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4V752c0 5.5-4.5 10-10 10h-41.3c-5.5 0-10-4.5-10-10v-51.8h-63.1c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h63.1v-29.7h-63.1c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h45.2l-88-161.1c-2.6-4.8-.9-10.9 4-13.6 1.5-.8 3.1-1.2 4.8-1.2h46c3.8 0 7.2 2.1 8.9 5.5l72.9 144.3 73.2-144.3a10 10 0 0 1 8.9-5.5h45c5.5 0 10 4.5 10 10 .1 1.7-.3 3.3-1.1 4.8z'));
exports.AlertFill = getIcon('alert', fill, getNode(newViewBox, 'M512 244c176.18 0 319 142.82 319 319v233a32 32 0 0 1-32 32H225a32 32 0 0 1-32-32V563c0-176.18 142.82-319 319-319zM484 68h56a8 8 0 0 1 8 8v96a8 8 0 0 1-8 8h-56a8 8 0 0 1-8-8V76a8 8 0 0 1 8-8zM177.25 191.66a8 8 0 0 1 11.32 0l67.88 67.88a8 8 0 0 1 0 11.31l-39.6 39.6a8 8 0 0 1-11.31 0l-67.88-67.88a8 8 0 0 1 0-11.31l39.6-39.6zm669.6 0l39.6 39.6a8 8 0 0 1 0 11.3l-67.88 67.9a8 8 0 0 1-11.32 0l-39.6-39.6a8 8 0 0 1 0-11.32l67.89-67.88a8 8 0 0 1 11.31 0zM192 892h640a32 32 0 0 1 32 32v24a8 8 0 0 1-8 8H168a8 8 0 0 1-8-8v-24a32 32 0 0 1 32-32zm148-317v253h64V575h-64z'));
exports.AlipaySquareFill = getIcon('alipay-square', fill, getNode(newViewBox, 'M308.6 545.7c-19.8 2-57.1 10.7-77.4 28.6-61 53-24.5 150 99 150 71.8 0 143.5-45.7 199.8-119-80.2-38.9-148.1-66.8-221.4-59.6zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm29.4 663.2S703 689.4 598.7 639.5C528.8 725.2 438.6 777.3 345 777.3c-158.4 0-212.1-138.1-137.2-229 16.3-19.8 44.2-38.7 87.3-49.4 67.5-16.5 175 10.3 275.7 43.4 18.1-33.3 33.4-69.9 44.7-108.9H305.1V402h160v-56.2H271.3v-31.3h193.8v-80.1s0-13.5 13.7-13.5H557v93.6h191.7v31.3H557.1V402h156.4c-15 61.1-37.7 117.4-66.2 166.8 47.5 17.1 90.1 33.3 121.8 43.9 114.3 38.2 140.2 40.2 140.2 40.2v122.3z'));
exports.AliwangwangFill = getIcon('aliwangwang', fill, getNode(newViewBox, 'M868.2 377.4c-18.9-45.1-46.3-85.6-81.2-120.6a377.26 377.26 0 0 0-120.5-81.2A375.65 375.65 0 0 0 519 145.8c-41.9 0-82.9 6.7-121.9 20C306 123.3 200.8 120 170.6 120c-2.2 0-7.4 0-9.4.2-11.9.4-22.8 6.5-29.2 16.4-6.5 9.9-7.7 22.4-3.4 33.5l64.3 161.6a378.59 378.59 0 0 0-52.8 193.2c0 51.4 10 101 29.8 147.6 18.9 45 46.2 85.6 81.2 120.5 34.7 34.8 75.4 62.1 120.5 81.2C418.3 894 467.9 904 519 904c51.3 0 100.9-10 147.7-29.8 44.9-18.9 85.5-46.3 120.4-81.2 34.7-34.8 62.1-75.4 81.2-120.6a376.5 376.5 0 0 0 29.8-147.6c-.2-51.2-10.1-100.8-29.9-147.4zm-325.2 79c0 20.4-16.6 37.1-37.1 37.1-20.4 0-37.1-16.7-37.1-37.1v-55.1c0-20.4 16.6-37.1 37.1-37.1 20.4 0 37.1 16.6 37.1 37.1v55.1zm175.2 0c0 20.4-16.6 37.1-37.1 37.1S644 476.8 644 456.4v-55.1c0-20.4 16.7-37.1 37.1-37.1 20.4 0 37.1 16.6 37.1 37.1v55.1z'));
exports.AlipayCircleFill = getIcon('alipay-circle', fill, getNode(newViewBox, 'M308.6 545.7c-19.8 2-57.1 10.7-77.4 28.6-61 53-24.5 150 99 150 71.8 0 143.5-45.7 199.8-119-80.2-38.9-148.1-66.8-221.4-59.6zm460.5 67c100.1 33.4 154.7 43 166.7 44.8A445.9 445.9 0 0 0 960 512c0-247.4-200.6-448-448-448S64 264.6 64 512s200.6 448 448 448c155.9 0 293.2-79.7 373.5-200.5-75.6-29.8-213.6-85-286.8-120.1-69.9 85.7-160.1 137.8-253.7 137.8-158.4 0-212.1-138.1-137.2-229 16.3-19.8 44.2-38.7 87.3-49.4 67.5-16.5 175 10.3 275.7 43.4 18.1-33.3 33.4-69.9 44.7-108.9H305.1V402h160v-56.2H271.3v-31.3h193.8v-80.1s0-13.5 13.7-13.5H557v93.6h191.7v31.3H557.1V402h156.4c-15 61.1-37.7 117.4-66.2 166.8 47.5 17.1 90.1 33.3 121.8 43.9z'));
exports.AmazonCircleFill = getIcon('amazon-circle', fill, getNode(newViewBox, 'M485 467.5c-11.6 4.9-20.9 12.2-27.8 22-6.9 9.8-10.4 21.6-10.4 35.5 0 17.8 7.5 31.5 22.4 41.2 14.1 9.1 28.9 11.4 44.4 6.8 17.9-5.2 30-17.9 36.4-38.1 3-9.3 4.5-19.7 4.5-31.3v-50.2c-12.6.4-24.4 1.6-35.5 3.7-11.1 2.1-22.4 5.6-34 10.4zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm35.8 262.7c-7.2-10.9-20.1-16.4-38.7-16.4-1.3 0-3 .1-5.3.3-2.2.2-6.6 1.5-12.9 3.7a79.4 79.4 0 0 0-17.9 9.1c-5.5 3.8-11.5 10-18 18.4-6.4 8.5-11.5 18.4-15.3 29.8l-94-8.4c0-12.4 2.4-24.7 7-36.9 4.7-12.2 11.8-23.9 21.4-35 9.6-11.2 21.1-21 34.5-29.4 13.4-8.5 29.6-15.2 48.4-20.3 18.9-5.1 39.1-7.6 60.9-7.6 21.3 0 40.6 2.6 57.8 7.7 17.2 5.2 31.1 11.5 41.4 19.1a117 117 0 0 1 25.9 25.7c6.9 9.6 11.7 18.5 14.4 26.7 2.7 8.2 4 15.7 4 22.8v182.5c0 6.4 1.4 13 4.3 19.8 2.9 6.8 6.3 12.8 10.2 18 3.9 5.2 7.9 9.9 12 14.3 4.1 4.3 7.6 7.7 10.6 9.9l4.1 3.4-72.5 69.4c-8.5-7.7-16.9-15.4-25.2-23.4-8.3-8-14.5-14-18.5-18.1l-6.1-6.2c-2.4-2.3-5-5.7-8-10.2-8.1 12.2-18.5 22.8-31.1 31.8-12.7 9-26.3 15.6-40.7 19.7-14.5 4.1-29.4 6.5-44.7 7.1-15.3.6-30-1.5-43.9-6.5-13.9-5-26.5-11.7-37.6-20.3-11.1-8.6-19.9-20.2-26.5-35-6.6-14.8-9.9-31.5-9.9-50.4 0-17.4 3-33.3 8.9-47.7 6-14.5 13.6-26.5 23-36.1 9.4-9.6 20.7-18.2 34-25.7s26.4-13.4 39.2-17.7c12.8-4.2 26.6-7.8 41.5-10.7 14.9-2.9 27.6-4.8 38.2-5.7 10.6-.9 21.2-1.6 31.8-2v-39.4c0-13.5-2.3-23.5-6.7-30.1zm180.5 379.6c-2.8 3.3-7.5 7.8-14.1 13.5s-16.8 12.7-30.5 21.1c-13.7 8.4-28.8 16-45 22.9-16.3 6.9-36.3 12.9-60.1 18-23.7 5.1-48.2 7.6-73.3 7.6-25.4 0-50.7-3.2-76.1-9.6-25.4-6.4-47.6-14.3-66.8-23.7-19.1-9.4-37.6-20.2-55.1-32.2-17.6-12.1-31.7-22.9-42.4-32.5-10.6-9.6-19.6-18.7-26.8-27.1-1.7-1.9-2.8-3.6-3.2-5.1-.4-1.5-.3-2.8.3-3.7.6-.9 1.5-1.6 2.6-2.2a7.42 7.42 0 0 1 7.4.8c40.9 24.2 72.9 41.3 95.9 51.4 82.9 36.4 168 45.7 255.3 27.9 40.5-8.3 82.1-22.2 124.9-41.8 3.2-1.2 6-1.5 8.3-.9 2.3.6 3.5 2.4 3.5 5.4 0 2.8-1.6 6.3-4.8 10.2zm59.9-29c-1.8 11.1-4.9 21.6-9.1 31.8-7.2 17.1-16.3 30-27.1 38.4-3.6 2.9-6.4 3.8-8.3 2.8-1.9-1-1.9-3.5 0-7.4 4.5-9.3 9.2-21.8 14.2-37.7 5-15.8 5.7-26 2.1-30.5-1.1-1.5-2.7-2.6-5-3.6-2.2-.9-5.1-1.5-8.6-1.9s-6.7-.6-9.4-.8c-2.8-.2-6.5-.2-11.2 0-4.7.2-8 .4-10.1.6a874.4 874.4 0 0 1-17.1 1.5c-1.3.2-2.7.4-4.1.5-1.5.1-2.7.2-3.5.3l-2.7.3c-1 .1-1.7.2-2.2.2h-3.2l-1-.2-.6-.5-.5-.9c-1.3-3.3 3.7-7.4 15-12.4s22.3-8.1 32.9-9.3c9.8-1.5 21.3-1.5 34.5-.3s21.3 3.7 24.3 7.4c2.3 3.5 2.5 10.7.7 21.7z'));
exports.AndroidFill = getIcon('android', fill, getNode(newViewBox, 'M270.1 741.7c0 23.4 19.1 42.5 42.6 42.5h48.7v120.4c0 30.5 24.5 55.4 54.6 55.4 30.2 0 54.6-24.8 54.6-55.4V784.1h85v120.4c0 30.5 24.5 55.4 54.6 55.4 30.2 0 54.6-24.8 54.6-55.4V784.1h48.7c23.5 0 42.6-19.1 42.6-42.5V346.4h-486v395.3zm357.1-600.1l44.9-65c2.6-3.8 2-8.9-1.5-11.4-3.5-2.4-8.5-1.2-11.1 2.6l-46.6 67.6c-30.7-12.1-64.9-18.8-100.8-18.8-35.9 0-70.1 6.7-100.8 18.8l-46.6-67.5c-2.6-3.8-7.6-5.1-11.1-2.6-3.5 2.4-4.1 7.4-1.5 11.4l44.9 65c-71.4 33.2-121.4 96.1-127.8 169.6h486c-6.6-73.6-56.7-136.5-128-169.7zM409.5 244.1a26.9 26.9 0 1 1 26.9-26.9 26.97 26.97 0 0 1-26.9 26.9zm208.4 0a26.9 26.9 0 1 1 26.9-26.9 26.97 26.97 0 0 1-26.9 26.9zm223.4 100.7c-30.2 0-54.6 24.8-54.6 55.4v216.4c0 30.5 24.5 55.4 54.6 55.4 30.2 0 54.6-24.8 54.6-55.4V400.1c.1-30.6-24.3-55.3-54.6-55.3zm-658.6 0c-30.2 0-54.6 24.8-54.6 55.4v216.4c0 30.5 24.5 55.4 54.6 55.4 30.2 0 54.6-24.8 54.6-55.4V400.1c0-30.6-24.5-55.3-54.6-55.3z'));
exports.AmazonSquareFill = getIcon('amazon-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM547.8 326.7c-7.2-10.9-20.1-16.4-38.7-16.4-1.3 0-3 .1-5.3.3-2.2.2-6.6 1.5-12.9 3.7a79.4 79.4 0 0 0-17.9 9.1c-5.5 3.8-11.5 10-18 18.4-6.4 8.5-11.5 18.4-15.3 29.8l-94-8.4c0-12.4 2.4-24.7 7-36.9s11.8-23.9 21.4-35c9.6-11.2 21.1-21 34.5-29.4 13.4-8.5 29.6-15.2 48.4-20.3 18.9-5.1 39.1-7.6 60.9-7.6 21.3 0 40.6 2.6 57.8 7.7 17.2 5.2 31.1 11.5 41.4 19.1a117 117 0 0 1 25.9 25.7c6.9 9.6 11.7 18.5 14.4 26.7 2.7 8.2 4 15.7 4 22.8v182.5c0 6.4 1.4 13 4.3 19.8 2.9 6.8 6.3 12.8 10.2 18 3.9 5.2 7.9 9.9 12 14.3 4.1 4.3 7.6 7.7 10.6 9.9l4.1 3.4-72.5 69.4c-8.5-7.7-16.9-15.4-25.2-23.4-8.3-8-14.5-14-18.5-18.1l-6.1-6.2c-2.4-2.3-5-5.7-8-10.2-8.1 12.2-18.5 22.8-31.1 31.8-12.7 9-26.3 15.6-40.7 19.7-14.5 4.1-29.4 6.5-44.7 7.1-15.3.6-30-1.5-43.9-6.5-13.9-5-26.5-11.7-37.6-20.3-11.1-8.6-19.9-20.2-26.5-35-6.6-14.8-9.9-31.5-9.9-50.4 0-17.4 3-33.3 8.9-47.7 6-14.5 13.6-26.5 23-36.1 9.4-9.6 20.7-18.2 34-25.7s26.4-13.4 39.2-17.7c12.8-4.2 26.6-7.8 41.5-10.7 14.9-2.9 27.6-4.8 38.2-5.7 10.6-.9 21.2-1.6 31.8-2v-39.4c0-13.5-2.3-23.5-6.7-30.1zm180.5 379.6c-2.8 3.3-7.5 7.8-14.1 13.5s-16.8 12.7-30.5 21.1c-13.7 8.4-28.8 16-45 22.9-16.3 6.9-36.3 12.9-60.1 18-23.7 5.1-48.2 7.6-73.3 7.6-25.4 0-50.7-3.2-76.1-9.6-25.4-6.4-47.6-14.3-66.8-23.7-19.1-9.4-37.6-20.2-55.1-32.2-17.6-12.1-31.7-22.9-42.4-32.5-10.6-9.6-19.6-18.7-26.8-27.1-1.7-1.9-2.8-3.6-3.2-5.1-.4-1.5-.3-2.8.3-3.7.6-.9 1.5-1.6 2.6-2.2a7.42 7.42 0 0 1 7.4.8c40.9 24.2 72.9 41.3 95.9 51.4 82.9 36.4 168 45.7 255.3 27.9 40.5-8.3 82.1-22.2 124.9-41.8 3.2-1.2 6-1.5 8.3-.9 2.3.6 3.5 2.4 3.5 5.4 0 2.8-1.6 6.3-4.8 10.2zm59.9-29c-1.8 11.1-4.9 21.6-9.1 31.8-7.2 17.1-16.3 30-27.1 38.4-3.6 2.9-6.4 3.8-8.3 2.8-1.9-1-1.9-3.5 0-7.4 4.5-9.3 9.2-21.8 14.2-37.7 5-15.8 5.7-26 2.1-30.5-1.1-1.5-2.7-2.6-5-3.6-2.2-.9-5.1-1.5-8.6-1.9s-6.7-.6-9.4-.8c-2.8-.2-6.5-.2-11.2 0-4.7.2-8 .4-10.1.6a874.4 874.4 0 0 1-17.1 1.5c-1.3.2-2.7.4-4.1.5-1.5.1-2.7.2-3.5.3l-2.7.3c-1 .1-1.7.2-2.2.2h-3.2l-1-.2-.6-.5-.5-.9c-1.3-3.3 3.7-7.4 15-12.4s22.3-8.1 32.9-9.3c9.8-1.5 21.3-1.5 34.5-.3s21.3 3.7 24.3 7.4c2.3 3.5 2.5 10.7.7 21.7zM485 467.5c-11.6 4.9-20.9 12.2-27.8 22-6.9 9.8-10.4 21.6-10.4 35.5 0 17.8 7.5 31.5 22.4 41.2 14.1 9.1 28.9 11.4 44.4 6.8 17.9-5.2 30-17.9 36.4-38.1 3-9.3 4.5-19.7 4.5-31.3v-50.2c-12.6.4-24.4 1.6-35.5 3.7-11.1 2.1-22.4 5.6-34 10.4z'));
exports.ApiFill = getIcon('api', fill, getNode(newViewBox, 'M917.7 148.8l-42.4-42.4c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-76.1 76.1a199.27 199.27 0 0 0-112.1-34.3c-51.2 0-102.4 19.5-141.5 58.6L432.3 308.7a8.03 8.03 0 0 0 0 11.3L704 591.7c1.6 1.6 3.6 2.3 5.7 2.3 2 0 4.1-.8 5.7-2.3l101.9-101.9c68.9-69 77-175.7 24.3-253.5l76.1-76.1c3.1-3.2 3.1-8.3 0-11.4zM578.9 546.7a8.03 8.03 0 0 0-11.3 0L501 613.3 410.7 523l66.7-66.7c3.1-3.1 3.1-8.2 0-11.3L441 408.6a8.03 8.03 0 0 0-11.3 0L363 475.3l-43-43a7.85 7.85 0 0 0-5.7-2.3c-2 0-4.1.8-5.7 2.3L206.8 534.2c-68.9 68.9-77 175.7-24.3 253.5l-76.1 76.1a8.03 8.03 0 0 0 0 11.3l42.4 42.4c1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3l76.1-76.1c33.7 22.9 72.9 34.3 112.1 34.3 51.2 0 102.4-19.5 141.5-58.6l101.9-101.9c3.1-3.1 3.1-8.2 0-11.3l-43-43 66.7-66.7c3.1-3.1 3.1-8.2 0-11.3l-36.6-36.2z'));
exports.AppstoreFill = getIcon('appstore', fill, getNode(newViewBox, 'M864 144H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm0 400H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zM464 144H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm0 400H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16z'));
exports.AudioFill = getIcon('audio', fill, getNode(newViewBox, 'M512 624c93.9 0 170-75.2 170-168V232c0-92.8-76.1-168-170-168s-170 75.2-170 168v224c0 92.8 76.1 168 170 168zm330-170c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 140.3-113.7 254-254 254S258 594.3 258 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 168.7 126.6 307.9 290 327.6V884H326.7c-13.7 0-24.7 14.3-24.7 32v36c0 4.4 2.8 8 6.2 8h407.6c3.4 0 6.2-3.6 6.2-8v-36c0-17.7-11-32-24.7-32H548V782.1c165.3-18 294-158 294-328.1z'));
exports.AppleFill = getIcon('apple', fill, getNode(newViewBox, 'M747.4 535.7c-.4-68.2 30.5-119.6 92.9-157.5-34.9-50-87.7-77.5-157.3-82.8-65.9-5.2-138 38.4-164.4 38.4-27.9 0-91.7-36.6-141.9-36.6C273.1 298.8 163 379.8 163 544.6c0 48.7 8.9 99 26.7 150.8 23.8 68.2 109.6 235.3 199.1 232.6 46.8-1.1 79.9-33.2 140.8-33.2 59.1 0 89.7 33.2 141.9 33.2 90.3-1.3 167.9-153.2 190.5-221.6-121.1-57.1-114.6-167.2-114.6-170.7zm-105.1-305c50.7-60.2 46.1-115 44.6-134.7-44.8 2.6-96.6 30.5-126.1 64.8-32.5 36.8-51.6 82.3-47.5 133.6 48.4 3.7 92.6-21.2 129-63.7z'));
exports.BackwardFill = getIcon('backward', fill, getNode(normalViewBox, 'M485.6 249.9L198.2 498c-8.3 7.1-8.3 20.8 0 27.9l287.4 248.2c10.7 9.2 26.4.9 26.4-14V263.8c0-14.8-15.7-23.2-26.4-13.9zm320 0L518.2 498a18.6 18.6 0 0 0-6.2 14c0 5.2 2.1 10.4 6.2 14l287.4 248.2c10.7 9.2 26.4.9 26.4-14V263.8c0-14.8-15.7-23.2-26.4-13.9z'));
exports.BankFill = getIcon('bank', fill, getNode(newViewBox, 'M894 462c30.9 0 43.8-39.7 18.7-58L530.8 126.2a31.81 31.81 0 0 0-37.6 0L111.3 404c-25.1 18.2-12.2 58 18.8 58H192v374h-72c-4.4 0-8 3.6-8 8v52c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-52c0-4.4-3.6-8-8-8h-72V462h62zM381 836H264V462h117v374zm189 0H453V462h117v374zm190 0H642V462h118v374z'));
exports.BehanceCircleFill = getIcon('behance-circle', fill, getNode(newViewBox, 'M420.3 470.3c8.7-6.3 12.9-16.7 12.9-31 .3-6.8-1.1-13.5-4.1-19.6-2.7-4.9-6.7-9-11.6-11.9a44.8 44.8 0 0 0-16.6-6c-6.4-1.2-12.9-1.8-19.3-1.7h-70.3v79.7h76.1c13.1.1 24.2-3.1 32.9-9.5zm11.8 72c-9.8-7.5-22.9-11.2-39.2-11.2h-81.8v94h80.2c7.5 0 14.4-.7 21.1-2.1a50.5 50.5 0 0 0 17.8-7.2c5.1-3.3 9.2-7.8 12.3-13.6 3-5.8 4.5-13.2 4.5-22.1 0-17.7-5-30.2-14.9-37.8zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm86.5 286.9h138.4v33.7H598.5v-33.7zM512 628.8a89.52 89.52 0 0 1-27 31c-11.8 8.2-24.9 14.2-38.8 17.7a167.4 167.4 0 0 1-44.6 5.7H236V342.1h161c16.3 0 31.1 1.5 44.6 4.3 13.4 2.8 24.8 7.6 34.4 14.1 9.5 6.5 17 15.2 22.3 26 5.2 10.7 7.9 24.1 7.9 40 0 17.2-3.9 31.4-11.7 42.9-7.9 11.5-19.3 20.8-34.8 28.1 21.1 6 36.6 16.7 46.8 31.7 10.4 15.2 15.5 33.4 15.5 54.8 0 17.4-3.3 32.3-10 44.8zM790.8 576H612.4c0 19.4 6.7 38 16.8 48 10.2 9.9 24.8 14.9 43.9 14.9 13.8 0 25.5-3.5 35.5-10.4 9.9-6.9 15.9-14.2 18.1-21.8h59.8c-9.6 29.7-24.2 50.9-44 63.7-19.6 12.8-43.6 19.2-71.5 19.2-19.5 0-37-3.2-52.7-9.3-15.1-5.9-28.7-14.9-39.9-26.5a121.2 121.2 0 0 1-25.1-41.2c-6.1-16.9-9.1-34.7-8.9-52.6 0-18.5 3.1-35.7 9.1-51.7 11.5-31.1 35.4-56 65.9-68.9 16.3-6.8 33.8-10.2 51.5-10 21 0 39.2 4 55 12.2a111.6 111.6 0 0 1 38.6 32.8c10.1 13.7 17.2 29.3 21.7 46.9 4.3 17.3 5.8 35.5 4.6 54.7zm-122-95.6c-10.8 0-19.9 1.9-26.9 5.6-7 3.7-12.8 8.3-17.2 13.6a48.4 48.4 0 0 0-9.1 17.4c-1.6 5.3-2.7 10.7-3.1 16.2H723c-1.6-17.3-7.6-30.1-15.6-39.1-8.4-8.9-21.9-13.7-38.6-13.7z'));
exports.BellFill = getIcon('bell', fill, getNode(newViewBox, 'M816 768h-24V428c0-141.1-104.3-257.8-240-277.2V112c0-22.1-17.9-40-40-40s-40 17.9-40 40v38.8C336.3 170.2 232 286.9 232 428v340h-24c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h216c0 61.8 50.2 112 112 112s112-50.2 112-112h216c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM512 888c-26.5 0-48-21.5-48-48h96c0 26.5-21.5 48-48 48z'));
exports.BehanceSquareFill = getIcon('behance-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM598.5 350.9h138.4v33.7H598.5v-33.7zM512 628.8a89.52 89.52 0 0 1-27 31c-11.8 8.2-24.9 14.2-38.8 17.7a167.4 167.4 0 0 1-44.6 5.7H236V342.1h161c16.3 0 31.1 1.5 44.6 4.3 13.4 2.8 24.8 7.6 34.4 14.1 9.5 6.5 17 15.2 22.3 26 5.2 10.7 7.9 24.1 7.9 40 0 17.2-3.9 31.4-11.7 42.9-7.9 11.5-19.3 20.8-34.8 28.1 21.1 6 36.6 16.7 46.8 31.7 10.4 15.2 15.5 33.4 15.5 54.8 0 17.4-3.3 32.3-10 44.8zM790.8 576H612.4c0 19.4 6.7 38 16.8 48 10.2 9.9 24.8 14.9 43.9 14.9 13.8 0 25.5-3.5 35.5-10.4 9.9-6.9 15.9-14.2 18.1-21.8h59.8c-9.6 29.7-24.2 50.9-44 63.7-19.6 12.8-43.6 19.2-71.5 19.2-19.5 0-37-3.2-52.7-9.3-15.1-5.9-28.7-14.9-39.9-26.5a121.2 121.2 0 0 1-25.1-41.2c-6.1-16.9-9.1-34.7-8.9-52.6 0-18.5 3.1-35.7 9.1-51.7 11.5-31.1 35.4-56 65.9-68.9 16.3-6.8 33.8-10.2 51.5-10 21 0 39.2 4 55 12.2a111.6 111.6 0 0 1 38.6 32.8c10.1 13.7 17.2 29.3 21.7 46.9 4.3 17.3 5.8 35.5 4.6 54.7zm-122-95.6c-10.8 0-19.9 1.9-26.9 5.6-7 3.7-12.8 8.3-17.2 13.6a48.4 48.4 0 0 0-9.1 17.4c-1.6 5.3-2.7 10.7-3.1 16.2H723c-1.6-17.3-7.6-30.1-15.6-39.1-8.4-8.9-21.9-13.7-38.6-13.7zm-248.5-10.1c8.7-6.3 12.9-16.7 12.9-31 .3-6.8-1.1-13.5-4.1-19.6-2.7-4.9-6.7-9-11.6-11.9a44.8 44.8 0 0 0-16.6-6c-6.4-1.2-12.9-1.8-19.3-1.7h-70.3v79.7h76.1c13.1.1 24.2-3.1 32.9-9.5zm11.8 72c-9.8-7.5-22.9-11.2-39.2-11.2h-81.8v94h80.2c7.5 0 14.4-.7 21.1-2.1s12.7-3.8 17.8-7.2c5.1-3.3 9.2-7.8 12.3-13.6 3-5.8 4.5-13.2 4.5-22.1 0-17.7-5-30.2-14.9-37.8z'));
exports.BookFill = getIcon('book', fill, getNode(newViewBox, 'M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM668 345.9L621.5 312 572 347.4V124h96v221.9z'));
exports.BoxPlotFill = getIcon('box-plot', fill, getNode(newViewBox, 'M952 224h-52c-4.4 0-8 3.6-8 8v248h-92V304c0-4.4-3.6-8-8-8H448v432h344c4.4 0 8-3.6 8-8V548h92v244c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zm-728 80v176h-92V232c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V548h92v172c0 4.4 3.6 8 8 8h152V296H232c-4.4 0-8 3.6-8 8z'));
exports.BugFill = getIcon('bug', fill, getNode(newViewBox, 'M304 280h416c4.4 0 8-3.6 8-8 0-40-8.8-76.7-25.9-108.1a184.31 184.31 0 0 0-74-74C596.7 72.8 560 64 520 64h-16c-40 0-76.7 8.8-108.1 25.9a184.31 184.31 0 0 0-74 74C304.8 195.3 296 232 296 272c0 4.4 3.6 8 8 8z', 'M940 512H792V412c76.8 0 139-62.2 139-139 0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8a63 63 0 0 1-63 63H232a63 63 0 0 1-63-63c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 76.8 62.2 139 139 139v100H84c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h148v96c0 6.5.2 13 .7 19.3C164.1 728.6 116 796.7 116 876c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-44.2 23.9-82.9 59.6-103.7a273 273 0 0 0 22.7 49c24.3 41.5 59 76.2 100.5 100.5 28.9 16.9 61 28.8 95.3 34.5 4.4 0 8-3.6 8-8V484c0-4.4 3.6-8 8-8h60c4.4 0 8 3.6 8 8v464.2c0 4.4 3.6 8 8 8 34.3-5.7 66.4-17.6 95.3-34.5a281.38 281.38 0 0 0 123.2-149.5A120.4 120.4 0 0 1 836 876c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-79.3-48.1-147.4-116.7-176.7.4-6.4.7-12.8.7-19.3v-96h148c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
exports.CalculatorFill = getIcon('calculator', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM440.2 765h-50.8c-2.2 0-4.5-1.1-5.9-2.9L348 718.6l-35.5 43.5a7.38 7.38 0 0 1-5.9 2.9h-50.8c-6.6 0-10.2-7.9-5.8-13.1l62.7-76.8-61.2-74.9c-4.3-5.2-.7-13.1 5.9-13.1h50.9c2.2 0 4.5 1.1 5.9 2.9l34 41.6 34-41.6c1.5-1.9 3.6-2.9 5.9-2.9h50.8c6.6 0 10.2 7.9 5.9 13.1L383.5 675l62.7 76.8c4.2 5.3.6 13.2-6 13.2zm7.8-382c0 2.2-1.4 4-3.2 4H376v68.7c0 1.9-1.8 3.3-4 3.3h-48c-2.2 0-4-1.4-4-3.2V387h-68.8c-1.8 0-3.2-1.8-3.2-4v-48c0-2.2 1.4-4 3.2-4H320v-68.8c0-1.8 1.8-3.2 4-3.2h48c2.2 0 4 1.4 4 3.2V331h68.7c1.9 0 3.3 1.8 3.3 4v48zm328 369c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48zm0-104c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48zm0-265c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48z'));
exports.BulbFill = getIcon('bulb', fill, getNode(newViewBox, 'M348 676.1C250 619.4 184 513.4 184 392c0-181.1 146.9-328 328-328s328 146.9 328 328c0 121.4-66 227.4-164 284.1V792c0 17.7-14.3 32-32 32H380c-17.7 0-32-14.3-32-32V676.1zM392 888h240c4.4 0 8 3.6 8 8v32c0 17.7-14.3 32-32 32H416c-17.7 0-32-14.3-32-32v-32c0-4.4 3.6-8 8-8z'));
exports.BuildFill = getIcon('build', fill, getNode(newViewBox, 'M916 210H376c-17.7 0-32 14.3-32 32v236H108c-17.7 0-32 14.3-32 32v272c0 17.7 14.3 32 32 32h540c17.7 0 32-14.3 32-32V546h236c17.7 0 32-14.3 32-32V242c0-17.7-14.3-32-32-32zM612 746H412V546h200v200zm268-268H680V278h200v200z'));
exports.CalendarFill = getIcon('calendar', fill, getNode(newViewBox, 'M112 880c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V460H112v420zm768-696H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v176h800V216c0-17.7-14.3-32-32-32z'));
exports.CameraFill = getIcon('camera', fill, getNode(newViewBox, 'M864 260H728l-32.4-90.8a32.07 32.07 0 0 0-30.2-21.2H358.6c-13.5 0-25.6 8.5-30.1 21.2L296 260H160c-44.2 0-80 35.8-80 80v456c0 44.2 35.8 80 80 80h704c44.2 0 80-35.8 80-80V340c0-44.2-35.8-80-80-80zM512 716c-88.4 0-160-71.6-160-160s71.6-160 160-160 160 71.6 160 160-71.6 160-160 160zm-96-160a96 96 0 1 0 192 0 96 96 0 1 0-192 0z'));
exports.CarFill = getIcon('car', fill, getNode(newViewBox, 'M959 413.4L935.3 372a8 8 0 0 0-10.9-2.9l-50.7 29.6-78.3-216.2a63.9 63.9 0 0 0-60.9-44.4H301.2c-34.7 0-65.5 22.4-76.2 55.5l-74.6 205.2-50.8-29.6a8 8 0 0 0-10.9 2.9L65 413.4c-2.2 3.8-.9 8.6 2.9 10.8l60.4 35.2-14.5 40c-1.2 3.2-1.8 6.6-1.8 10v348.2c0 15.7 11.8 28.4 26.3 28.4h67.6c12.3 0 23-9.3 25.6-22.3l7.7-37.7h545.6l7.7 37.7c2.7 13 13.3 22.3 25.6 22.3h67.6c14.5 0 26.3-12.7 26.3-28.4V509.4c0-3.4-.6-6.8-1.8-10l-14.5-40 60.3-35.2a8 8 0 0 0 3-10.8zM264 621c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm388 75c0 4.4-3.6 8-8 8H380c-4.4 0-8-3.6-8-8v-84c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v36h168v-36c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v84zm108-75c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zM220 418l72.7-199.9.5-1.3.4-1.3c1.1-3.3 4.1-5.5 7.6-5.5h427.6l75.4 208H220z'));
exports.CaretDownFill = getIcon('caret-down', fill, getNode(normalViewBox, 'M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z'));
exports.CaretLeftFill = getIcon('caret-left', fill, getNode(normalViewBox, 'M689 165.1L308.2 493.5c-10.9 9.4-10.9 27.5 0 37L689 858.9c14.2 12.2 35 1.2 35-18.5V183.6c0-19.7-20.8-30.7-35-18.5z'));
exports.CaretRightFill = getIcon('caret-right', fill, getNode(normalViewBox, 'M715.8 493.5L335 165.1c-14.2-12.2-35-1.2-35 18.5v656.8c0 19.7 20.8 30.7 35 18.5l380.8-328.4c10.9-9.4 10.9-27.6 0-37z'));
exports.CarryOutFill = getIcon('carry-out', fill, getNode(newViewBox, 'M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zM694.5 432.7L481.9 725.4a16.1 16.1 0 0 1-26 0l-126.4-174c-3.8-5.3 0-12.7 6.5-12.7h55.2c5.1 0 10 2.5 13 6.6l64.7 89 150.9-207.8c3-4.1 7.8-6.6 13-6.6H688c6.5.1 10.3 7.5 6.5 12.8z'));
exports.CaretUpFill = getIcon('caret-up', fill, getNode(normalViewBox, 'M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z'));
exports.CheckCircleFill = getIcon('check-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm193.5 301.7l-210.6 292a31.8 31.8 0 0 1-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.5 12.7z'));
exports.CheckSquareFill = getIcon('check-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM695.5 365.7l-210.6 292a31.8 31.8 0 0 1-51.7 0L308.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H689c6.5 0 10.3 7.4 6.5 12.7z'));
exports.ChromeFill = getIcon('chrome', fill, getNode(newViewBox, 'M371.8 512c0 77.5 62.7 140.2 140.2 140.2S652.2 589.5 652.2 512 589.5 371.8 512 371.8 371.8 434.4 371.8 512zM900 362.4l-234.3 12.1c63.6 74.3 64.6 181.5 11.1 263.7l-188 289.2c78 4.2 158.4-12.9 231.2-55.2 180-104 253-322.1 180-509.8zM320.3 591.9L163.8 284.1A415.35 415.35 0 0 0 96 512c0 208 152.3 380.3 351.4 410.8l106.9-209.4c-96.6 18.2-189.9-34.8-234-121.5zm218.5-285.5l344.4 18.1C848 254.7 792.6 194 719.8 151.7 653.9 113.6 581.5 95.5 510.5 96c-122.5.5-242.2 55.2-322.1 154.5l128.2 196.9c32-91.9 124.8-146.7 222.2-141z'));
exports.CiCircleFill = getIcon('ci-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-63.6 656c-103 0-162.4-68.6-162.4-182.6v-49C286 373.5 345.4 304 448.3 304c88.3 0 152.3 56.9 152.3 138.1 0 2.4-2 4.4-4.4 4.4h-52.6c-4.2 0-7.6-3.2-8-7.4-4-46.1-37.6-77.6-87-77.6-61.1 0-95.6 45.4-95.6 126.9v49.3c0 80.3 34.5 125.1 95.6 125.1 49.3 0 82.8-29.5 87-72.4.4-4.1 3.8-7.3 8-7.3h52.7c2.4 0 4.4 2 4.4 4.4 0 77.4-64.3 132.5-152.3 132.5zM738 704.1c0 4.4-3.6 8-8 8h-50.4c-4.4 0-8-3.6-8-8V319.9c0-4.4 3.6-8 8-8H730c4.4 0 8 3.6 8 8v384.2z'));
exports.ClockCircleFill = getIcon('clock-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm176.5 585.7l-28.6 39a7.99 7.99 0 0 1-11.2 1.7L483.3 569.8a7.92 7.92 0 0 1-3.3-6.5V288c0-4.4 3.6-8 8-8h48.1c4.4 0 8 3.6 8 8v247.5l142.6 103.1c3.6 2.5 4.4 7.5 1.8 11.1z'));
exports.CloseCircleFill = getIcon('close-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm165.4 618.2l-66-.3L512 563.4l-99.3 118.4-66.1.3c-4.4 0-8-3.5-8-8 0-1.9.7-3.7 1.9-5.2l130.1-155L340.5 359a8.32 8.32 0 0 1-1.9-5.2c0-4.4 3.6-8 8-8l66.1.3L512 464.6l99.3-118.4 66-.3c4.4 0 8 3.5 8 8 0 1.9-.7 3.7-1.9 5.2L553.5 514l130 155c1.2 1.5 1.9 3.3 1.9 5.2 0 4.4-3.6 8-8 8z'));
exports.CloudFill = getIcon('cloud', fill, getNode(newViewBox, 'M811.4 418.7C765.6 297.9 648.9 212 512.2 212S258.8 297.8 213 418.6C127.3 441.1 64 519.1 64 612c0 110.5 89.5 200 199.9 200h496.2C870.5 812 960 722.5 960 612c0-92.7-63.1-170.7-148.6-193.3z'));
exports.CloseSquareFill = getIcon('close-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM676.1 657.9c4.4 5.2.7 13.1-6.1 13.1h-58.9c-4.7 0-9.2-2.1-12.3-5.7L512 561.8l-86.8 103.5c-3 3.6-7.5 5.7-12.3 5.7H354c-6.8 0-10.5-7.9-6.1-13.1L470.2 512 347.9 366.1A7.95 7.95 0 0 1 354 353h58.9c4.7 0 9.2 2.1 12.3 5.7L512 462.2l86.8-103.5c3-3.6 7.5-5.7 12.3-5.7H670c6.8 0 10.5 7.9 6.1 13.1L553.8 512l122.3 145.9z'));
exports.CodeSandboxSquareFill = getIcon('code-sandbox-square', fill, getNode(newViewBox, 'M307.9 536.7l87.6 49.9V681l96.7 55.9V524.8L307.9 418.4zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM755.7 653.2L512 794 268.3 653.2V371.8l110-63.6-.4-.2h.2L512 231l134 77h-.2l-.3.2 110.1 63.6v281.4zm-223.9 83.7l97.3-56.2v-94.1l87-49.5V418.5L531.8 525zm-20-352L418 331l-91.1 52.6 185.2 107 185.2-106.9-91.4-52.8z'));
exports.CodeSandboxCircleFill = getIcon('code-sandbox-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm243.7 589.2L512 794 268.3 653.2V371.8l110-63.6-.4-.2h.2L512 231l134 77h-.2l-.3.2 110.1 63.6v281.4zM307.9 536.7l87.6 49.9V681l96.7 55.9V524.8L307.9 418.4zm203.9-151.8L418 331l-91.1 52.6 185.2 107 185.2-106.9-91.4-52.8zm20 352l97.3-56.2v-94.1l87-49.5V418.5L531.8 525z'));
exports.CodeFill = getIcon('code', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM513.1 518.1l-192 161c-5.2 4.4-13.1.7-13.1-6.1v-62.7c0-2.3 1.1-4.6 2.9-6.1L420.7 512l-109.8-92.2a7.63 7.63 0 0 1-2.9-6.1V351c0-6.8 7.9-10.5 13.1-6.1l192 160.9c3.9 3.2 3.9 9.1 0 12.3zM716 673c0 4.4-3.4 8-7.5 8h-185c-4.1 0-7.5-3.6-7.5-8v-48c0-4.4 3.4-8 7.5-8h185c4.1 0 7.5 3.6 7.5 8v48z'));
exports.CompassFill = getIcon('compass', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM327.3 702.4c-2 .9-4.4 0-5.3-2.1-.4-1-.4-2.2 0-3.2l98.7-225.5 132.1 132.1-225.5 98.7zm375.1-375.1l-98.7 225.5-132.1-132.1L697.1 322c2-.9 4.4 0 5.3 2.1.4 1 .4 2.1 0 3.2z'));
exports.CodepenCircleFill = getIcon('codepen-circle', fill, getNode(newViewBox, 'M488.1 414.7V303.4L300.9 428l83.6 55.8zm254.1 137.7v-79.8l-59.8 39.9zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm278 533c0 1.1-.1 2.1-.2 3.1 0 .4-.1.7-.2 1a14.16 14.16 0 0 1-.8 3.2c-.2.6-.4 1.2-.6 1.7-.2.4-.4.8-.5 1.2-.3.5-.5 1.1-.8 1.6-.2.4-.4.7-.7 1.1-.3.5-.7 1-1 1.5-.3.4-.5.7-.8 1-.4.4-.8.9-1.2 1.3-.3.3-.6.6-1 .9-.4.4-.9.8-1.4 1.1-.4.3-.7.6-1.1.8-.1.1-.3.2-.4.3L525.2 786c-4 2.7-8.6 4-13.2 4-4.7 0-9.3-1.4-13.3-4L244.6 616.9c-.1-.1-.3-.2-.4-.3l-1.1-.8c-.5-.4-.9-.7-1.3-1.1-.3-.3-.6-.6-1-.9-.4-.4-.8-.8-1.2-1.3a7 7 0 0 1-.8-1c-.4-.5-.7-1-1-1.5-.2-.4-.5-.7-.7-1.1-.3-.5-.6-1.1-.8-1.6-.2-.4-.4-.8-.5-1.2-.2-.6-.4-1.2-.6-1.7-.1-.4-.3-.8-.4-1.2-.2-.7-.3-1.3-.4-2-.1-.3-.1-.7-.2-1-.1-1-.2-2.1-.2-3.1V427.9c0-1 .1-2.1.2-3.1.1-.3.1-.7.2-1a14.16 14.16 0 0 1 .8-3.2c.2-.6.4-1.2.6-1.7.2-.4.4-.8.5-1.2.2-.5.5-1.1.8-1.6.2-.4.4-.7.7-1.1.6-.9 1.2-1.7 1.8-2.5.4-.4.8-.9 1.2-1.3.3-.3.6-.6 1-.9.4-.4.9-.8 1.3-1.1.4-.3.7-.6 1.1-.8.1-.1.3-.2.4-.3L498.7 239c8-5.3 18.5-5.3 26.5 0l254.1 169.1c.1.1.3.2.4.3l1.1.8 1.4 1.1c.3.3.6.6 1 .9.4.4.8.8 1.2 1.3.7.8 1.3 1.6 1.8 2.5.2.4.5.7.7 1.1.3.5.6 1 .8 1.6.2.4.4.8.5 1.2.2.6.4 1.2.6 1.7.1.4.3.8.4 1.2.2.7.3 1.3.4 2 .1.3.1.7.2 1 .1 1 .2 2.1.2 3.1V597zm-254.1 13.3v111.3L723.1 597l-83.6-55.8zM281.8 472.6v79.8l59.8-39.9zM512 456.1l-84.5 56.4 84.5 56.4 84.5-56.4zM723.1 428L535.9 303.4v111.3l103.6 69.1zM384.5 541.2L300.9 597l187.2 124.6V610.3l-103.6-69.1z'));
exports.CodepenSquareFill = getIcon('codepen-square', fill, getNode(newViewBox, 'M723.1 428L535.9 303.4v111.3l103.6 69.1zM512 456.1l-84.5 56.4 84.5 56.4 84.5-56.4zm23.9 154.2v111.3L723.1 597l-83.6-55.8zm-151.4-69.1L300.9 597l187.2 124.6V610.3l-103.6-69.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-90 485c0 1.1-.1 2.1-.2 3.1 0 .4-.1.7-.2 1a14.16 14.16 0 0 1-.8 3.2c-.2.6-.4 1.2-.6 1.7-.2.4-.4.8-.5 1.2-.3.5-.5 1.1-.8 1.6-.2.4-.4.7-.7 1.1-.3.5-.7 1-1 1.5-.3.4-.5.7-.8 1-.4.4-.8.9-1.2 1.3-.3.3-.6.6-1 .9-.4.4-.9.8-1.4 1.1-.4.3-.7.6-1.1.8-.1.1-.3.2-.4.3L525.2 786c-4 2.7-8.6 4-13.2 4-4.7 0-9.3-1.4-13.3-4L244.6 616.9c-.1-.1-.3-.2-.4-.3l-1.1-.8c-.5-.4-.9-.7-1.3-1.1-.3-.3-.6-.6-1-.9-.4-.4-.8-.8-1.2-1.3a7 7 0 0 1-.8-1c-.4-.5-.7-1-1-1.5-.2-.4-.5-.7-.7-1.1-.3-.5-.6-1.1-.8-1.6-.2-.4-.4-.8-.5-1.2-.2-.6-.4-1.2-.6-1.7-.1-.4-.3-.8-.4-1.2-.2-.7-.3-1.3-.4-2-.1-.3-.1-.7-.2-1-.1-1-.2-2.1-.2-3.1V427.9c0-1 .1-2.1.2-3.1.1-.3.1-.7.2-1a14.16 14.16 0 0 1 .8-3.2c.2-.6.4-1.2.6-1.7.2-.4.4-.8.5-1.2.2-.5.5-1.1.8-1.6.2-.4.4-.7.7-1.1.6-.9 1.2-1.7 1.8-2.5.4-.4.8-.9 1.2-1.3.3-.3.6-.6 1-.9.4-.4.9-.8 1.3-1.1.4-.3.7-.6 1.1-.8.1-.1.3-.2.4-.3L498.7 239c8-5.3 18.5-5.3 26.5 0l254.1 169.1c.1.1.3.2.4.3l1.1.8 1.4 1.1c.3.3.6.6 1 .9.4.4.8.8 1.2 1.3.7.8 1.3 1.6 1.8 2.5.2.4.5.7.7 1.1.3.5.6 1 .8 1.6.2.4.4.8.5 1.2.2.6.4 1.2.6 1.7.1.4.3.8.4 1.2.2.7.3 1.3.4 2 .1.3.1.7.2 1 .1 1 .2 2.1.2 3.1V597zm-47.8-44.6v-79.8l-59.8 39.9zm-460.4-79.8v79.8l59.8-39.9zm206.3-57.9V303.4L300.9 428l83.6 55.8z'));
exports.ContactsFill = getIcon('contacts', fill, getNode(newViewBox, 'M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zM661 736h-43.9c-4.2 0-7.6-3.3-7.9-7.5-3.8-50.6-46-90.5-97.2-90.5s-93.4 40-97.2 90.5c-.3 4.2-3.7 7.5-7.9 7.5H363a8 8 0 0 1-8-8.4c2.8-53.3 32-99.7 74.6-126.1a111.8 111.8 0 0 1-29.1-75.5c0-61.9 49.9-112 111.4-112 61.5 0 111.4 50.1 111.4 112 0 29.1-11 55.5-29.1 75.5 42.7 26.5 71.8 72.8 74.6 126.1.4 4.6-3.2 8.4-7.8 8.4zM512 474c-28.5 0-51.7 23.3-51.7 52s23.2 52 51.7 52c28.5 0 51.7-23.3 51.7-52s-23.2-52-51.7-52z'));
exports.ControlFill = getIcon('control', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM404 683v77c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-77c-41.7-13.6-72-52.8-72-99s30.3-85.5 72-99V264c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v221c41.7 13.6 72 52.8 72 99s-30.3 85.5-72 99zm279.6-143.9c.2 0 .3-.1.4-.1v221c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V539c.2 0 .3.1.4.1-42-13.4-72.4-52.7-72.4-99.1 0-46.4 30.4-85.7 72.4-99.1-.2 0-.3.1-.4.1v-77c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v77c-.2 0-.3-.1-.4-.1 42 13.4 72.4 52.7 72.4 99.1 0 46.4-30.4 85.7-72.4 99.1zM616 440a36 36 0 1 0 72 0 36 36 0 1 0-72 0zM403.4 566.5l-1.5-2.4c0-.1-.1-.1-.1-.2l-.9-1.2c-.1-.1-.2-.2-.2-.3-1-1.3-2-2.5-3.2-3.6l-.2-.2c-.4-.4-.8-.8-1.2-1.1-.8-.8-1.7-1.5-2.6-2.1h-.1l-1.2-.9c-.1-.1-.3-.2-.4-.3-1.2-.8-2.5-1.6-3.9-2.2-.2-.1-.5-.2-.7-.4-.4-.2-.7-.3-1.1-.5-.3-.1-.7-.3-1-.4-.5-.2-1-.4-1.5-.5-.4-.1-.9-.3-1.3-.4l-.9-.3-1.4-.3c-.2-.1-.5-.1-.7-.2-.7-.1-1.4-.3-2.1-.4-.2 0-.4 0-.6-.1-.6-.1-1.1-.1-1.7-.2-.2 0-.4 0-.7-.1-.8 0-1.5-.1-2.3-.1s-1.5 0-2.3.1c-.2 0-.4 0-.7.1-.6 0-1.2.1-1.7.2-.2 0-.4 0-.6.1-.7.1-1.4.2-2.1.4-.2.1-.5.1-.7.2l-1.4.3-.9.3c-.4.1-.9.3-1.3.4-.5.2-1 .4-1.5.5-.3.1-.7.3-1 .4-.4.2-.7.3-1.1.5-.2.1-.5.2-.7.4-1.3.7-2.6 1.4-3.9 2.2-.1.1-.3.2-.4.3l-1.2.9h-.1c-.9.7-1.8 1.4-2.6 2.1-.4.4-.8.7-1.2 1.1l-.2.2a54.8 54.8 0 0 0-3.2 3.6c-.1.1-.2.2-.2.3l-.9 1.2c0 .1-.1.1-.1.2l-1.5 2.4c-.1.2-.2.3-.3.5-2.7 5.1-4.3 10.9-4.3 17s1.6 12 4.3 17c.1.2.2.3.3.5l1.5 2.4c0 .1.1.1.1.2l.9 1.2c.1.1.2.2.2.3 1 1.3 2 2.5 3.2 3.6l.2.2c.4.4.8.8 1.2 1.1.8.8 1.7 1.5 2.6 2.1h.1l1.2.9c.1.1.3.2.4.3 1.2.8 2.5 1.6 3.9 2.2.2.1.5.2.7.4.4.2.7.3 1.1.5.3.1.7.3 1 .4.5.2 1 .4 1.5.5.4.1.9.3 1.3.4l.9.3 1.4.3c.2.1.5.1.7.2.7.1 1.4.3 2.1.4.2 0 .4 0 .6.1.6.1 1.1.1 1.7.2.2 0 .4 0 .7.1.8 0 1.5.1 2.3.1s1.5 0 2.3-.1c.2 0 .4 0 .7-.1.6 0 1.2-.1 1.7-.2.2 0 .4 0 .6-.1.7-.1 1.4-.2 2.1-.4.2-.1.5-.1.7-.2l1.4-.3.9-.3c.4-.1.9-.3 1.3-.4.5-.2 1-.4 1.5-.5.3-.1.7-.3 1-.4.4-.2.7-.3 1.1-.5.2-.1.5-.2.7-.4 1.3-.7 2.6-1.4 3.9-2.2.1-.1.3-.2.4-.3l1.2-.9h.1c.9-.7 1.8-1.4 2.6-2.1.4-.4.8-.7 1.2-1.1l.2-.2c1.1-1.1 2.2-2.4 3.2-3.6.1-.1.2-.2.2-.3l.9-1.2c0-.1.1-.1.1-.2l1.5-2.4c.1-.2.2-.3.3-.5 2.7-5.1 4.3-10.9 4.3-17s-1.6-12-4.3-17c-.1-.2-.2-.4-.3-.5z'));
exports.ContainerFill = getIcon('container', fill, getNode(newViewBox, 'M832 64H192c-17.7 0-32 14.3-32 32v529c0-.6.4-1 1-1h219.3l5.2 24.7C397.6 708.5 450.8 752 512 752s114.4-43.5 126.4-103.3l5.2-24.7H863c.6 0 1 .4 1 1V96c0-17.7-14.3-32-32-32zM712 493c0 4.4-3.6 8-8 8H320c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h384c4.4 0 8 3.6 8 8v48zm0-160c0 4.4-3.6 8-8 8H320c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h384c4.4 0 8 3.6 8 8v48zm151 354H694.1c-11.6 32.8-32 62.3-59.1 84.7-34.5 28.6-78.2 44.3-123 44.3s-88.5-15.8-123-44.3a194.02 194.02 0 0 1-59.1-84.7H161c-.6 0-1-.4-1-1v242c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V686c0 .6-.4 1-1 1z'));
exports.CopyFill = getIcon('copy', fill, getNode(newViewBox, 'M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM382 896h-.2L232 746.2v-.2h150v150z'));
exports.CopyrightCircleFill = getIcon('copyright-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm5.4 670c-110 0-173.4-73.2-173.4-194.9v-52.3C344 364.2 407.4 290 517.3 290c94.3 0 162.7 60.7 162.7 147.4 0 2.6-2.1 4.7-4.7 4.7h-56.7c-4.2 0-7.6-3.2-8-7.4-4-49.5-40-83.4-93-83.4-65.3 0-102.1 48.5-102.1 135.5v52.6c0 85.7 36.9 133.6 102.1 133.6 52.8 0 88.7-31.7 93-77.8.4-4.1 3.8-7.3 8-7.3h56.8c2.6 0 4.7 2.1 4.7 4.7 0 82.6-68.7 141.4-162.7 141.4z'));
exports.CreditCardFill = getIcon('credit-card', fill, getNode(newViewBox, 'M928 160H96c-17.7 0-32 14.3-32 32v160h896V192c0-17.7-14.3-32-32-32zM64 832c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V440H64v392zm579-184c0-4.4 3.6-8 8-8h165c4.4 0 8 3.6 8 8v72c0 4.4-3.6 8-8 8H651c-4.4 0-8-3.6-8-8v-72z'));
exports.CrownFill = getIcon('crown', fill, getNode(newViewBox, 'M899.6 276.5L705 396.4 518.4 147.5a8.06 8.06 0 0 0-12.9 0L319 396.4 124.3 276.5c-5.7-3.5-13.1 1.2-12.2 7.9L188.5 865c1.1 7.9 7.9 14 16 14h615.1c8 0 14.9-6 15.9-14l76.4-580.6c.8-6.7-6.5-11.4-12.3-7.9zM512 734.2c-62.1 0-112.6-50.5-112.6-112.6S449.9 509 512 509s112.6 50.5 112.6 112.6S574.1 734.2 512 734.2zm0-160.9c-26.6 0-48.2 21.6-48.2 48.3 0 26.6 21.6 48.3 48.2 48.3s48.2-21.6 48.2-48.3c0-26.6-21.6-48.3-48.2-48.3z'));
exports.CustomerServiceFill = getIcon('customer-service', fill, getNode(newViewBox, 'M512 128c-212.1 0-384 171.9-384 384v360c0 13.3 10.7 24 24 24h184c35.3 0 64-28.7 64-64V624c0-35.3-28.7-64-64-64H200v-48c0-172.3 139.7-312 312-312s312 139.7 312 312v48H688c-35.3 0-64 28.7-64 64v208c0 35.3 28.7 64 64 64h184c13.3 0 24-10.7 24-24V512c0-212.1-171.9-384-384-384z'));
exports.DashboardFill = getIcon('dashboard', fill, getNode(newViewBox, 'M924.8 385.6a446.7 446.7 0 0 0-96-142.4 446.7 446.7 0 0 0-142.4-96C631.1 123.8 572.5 112 512 112s-119.1 11.8-174.4 35.2a446.7 446.7 0 0 0-142.4 96 446.7 446.7 0 0 0-96 142.4C75.8 440.9 64 499.5 64 560c0 132.7 58.3 257.7 159.9 343.1l1.7 1.4c5.8 4.8 13.1 7.5 20.6 7.5h531.7c7.5 0 14.8-2.7 20.6-7.5l1.7-1.4C901.7 817.7 960 692.7 960 560c0-60.5-11.9-119.1-35.2-174.4zM482 232c0-4.4 3.6-8 8-8h44c4.4 0 8 3.6 8 8v80c0 4.4-3.6 8-8 8h-44c-4.4 0-8-3.6-8-8v-80zM270 582c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-44c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v44zm90.7-204.5l-31.1 31.1a8.03 8.03 0 0 1-11.3 0L261.7 352a8.03 8.03 0 0 1 0-11.3l31.1-31.1c3.1-3.1 8.2-3.1 11.3 0l56.6 56.6c3.1 3.1 3.1 8.2 0 11.3zm291.1 83.6l-84.5 84.5c5 18.7.2 39.4-14.5 54.1a55.95 55.95 0 0 1-79.2 0 55.95 55.95 0 0 1 0-79.2 55.87 55.87 0 0 1 54.1-14.5l84.5-84.5c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3c3.1 3.1 3.1 8.1 0 11.3zm43-52.4l-31.1-31.1a8.03 8.03 0 0 1 0-11.3l56.6-56.6c3.1-3.1 8.2-3.1 11.3 0l31.1 31.1c3.1 3.1 3.1 8.2 0 11.3l-56.6 56.6a8.03 8.03 0 0 1-11.3 0zM846 582c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-44c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v44z'));
exports.DeleteFill = getIcon('delete', fill, getNode(newViewBox, 'M864 256H736v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zm-200 0H360v-72h304v72z'));
exports.DiffFill = getIcon('diff', fill, getNode(newViewBox, 'M854.2 306.6L611.3 72.9c-6-5.7-13.9-8.9-22.2-8.9H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h277l219 210.6V824c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V329.6c0-8.7-3.5-17-9.8-23zM553.4 201.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v704c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32V397.3c0-8.5-3.4-16.6-9.4-22.6L553.4 201.4zM568 753c0 3.8-3.4 7-7.5 7h-225c-4.1 0-7.5-3.2-7.5-7v-42c0-3.8 3.4-7 7.5-7h225c4.1 0 7.5 3.2 7.5 7v42zm0-220c0 3.8-3.4 7-7.5 7H476v84.9c0 3.9-3.1 7.1-7 7.1h-42c-3.8 0-7-3.2-7-7.1V540h-84.5c-4.1 0-7.5-3.2-7.5-7v-42c0-3.9 3.4-7 7.5-7H420v-84.9c0-3.9 3.2-7.1 7-7.1h42c3.9 0 7 3.2 7 7.1V484h84.5c4.1 0 7.5 3.1 7.5 7v42z'));
exports.DingtalkCircleFill = getIcon('dingtalk-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm227 385.3c-1 4.2-3.5 10.4-7 17.8h.1l-.4.7c-20.3 43.1-73.1 127.7-73.1 127.7s-.1-.2-.3-.5l-15.5 26.8h74.5L575.1 810l32.3-128h-58.6l20.4-84.7c-16.5 3.9-35.9 9.4-59 16.8 0 0-31.2 18.2-89.9-35 0 0-39.6-34.7-16.6-43.4 9.8-3.7 47.4-8.4 77-12.3 40-5.4 64.6-8.2 64.6-8.2S422 517 392.7 512.5c-29.3-4.6-66.4-53.1-74.3-95.8 0 0-12.2-23.4 26.3-12.3 38.5 11.1 197.9 43.2 197.9 43.2s-207.4-63.3-221.2-78.7c-13.8-15.4-40.6-84.2-37.1-126.5 0 0 1.5-10.5 12.4-7.7 0 0 153.3 69.7 258.1 107.9 104.8 37.9 195.9 57.3 184.2 106.7z'));
exports.DatabaseFill = getIcon('database', fill, getNode(newViewBox, 'M832 64H192c-17.7 0-32 14.3-32 32v224h704V96c0-17.7-14.3-32-32-32zM288 232c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zM160 928c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V704H160v224zm128-136c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM160 640h704V384H160v256zm128-168c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z'));
exports.DingtalkSquareFill = getIcon('dingtalk-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM739 449.3c-1 4.2-3.5 10.4-7 17.8h.1l-.4.7c-20.3 43.1-73.1 127.7-73.1 127.7s-.1-.2-.3-.5l-15.5 26.8h74.5L575.1 810l32.3-128h-58.6l20.4-84.7c-16.5 3.9-35.9 9.4-59 16.8 0 0-31.2 18.2-89.9-35 0 0-39.6-34.7-16.6-43.4 9.8-3.7 47.4-8.4 77-12.3 40-5.4 64.6-8.2 64.6-8.2S422 517 392.7 512.5c-29.3-4.6-66.4-53.1-74.3-95.8 0 0-12.2-23.4 26.3-12.3 38.5 11.1 197.9 43.2 197.9 43.2s-207.4-63.3-221.2-78.7c-13.8-15.4-40.6-84.2-37.1-126.5 0 0 1.5-10.5 12.4-7.7 0 0 153.3 69.7 258.1 107.9 104.8 37.9 195.9 57.3 184.2 106.7z'));
exports.DislikeFill = getIcon('dislike', fill, getNode(newViewBox, 'M885.9 490.3c3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-51.6-30.7-98.1-78.3-118.4a66.1 66.1 0 0 0-26.5-5.4H273v428h.3l85.8 310.8C372.9 889 418.9 924 470.9 924c29.7 0 57.4-11.8 77.9-33.4 20.5-21.5 31-49.7 29.5-79.4l-6-122.9h239.9c12.1 0 23.9-3.2 34.3-9.3 40.4-23.5 65.5-66.1 65.5-111 0-28.3-9.3-55.5-26.1-77.7zM112 132v364c0 17.7 14.3 32 32 32h65V100h-65c-17.7 0-32 14.3-32 32z'));
exports.DollarCircleFill = getIcon('dollar-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm22.3 665.2l.2 31.7c0 4.4-3.6 8.1-8 8.1h-28.4c-4.4 0-8-3.6-8-8v-31.4C401.3 723 359.5 672.4 355 617.4c-.4-4.7 3.3-8.7 8-8.7h46.2c3.9 0 7.3 2.8 7.9 6.6 5.1 31.7 29.8 55.4 74.1 61.3V533.9l-24.7-6.3c-52.3-12.5-102.1-45.1-102.1-112.7 0-72.9 55.4-112.1 126.2-119v-33c0-4.4 3.6-8 8-8h28.1c4.4 0 8 3.6 8 8v32.7c68.5 6.9 119.9 46.9 125.9 109.2.5 4.7-3.2 8.8-8 8.8h-44.9c-4 0-7.4-3-7.9-6.9-4-29.2-27.4-53-65.5-58.2v134.3l25.4 5.9c64.8 16 108.9 47 108.9 116.4 0 75.3-56 117.3-134.3 124.1zM426.6 410.3c0 25.4 15.7 45.1 49.5 57.3 4.7 1.9 9.4 3.4 15 5v-124c-36.9 4.7-64.5 25.4-64.5 61.7zm116.5 135.2c-2.8-.6-5.6-1.3-8.8-2.2V677c42.6-3.8 72-27.2 72-66.4 0-30.7-15.9-50.7-63.2-65.1z'));
exports.DownCircleFill = getIcon('down-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm184.5 353.7l-178 246a7.95 7.95 0 0 1-12.9 0l-178-246c-3.8-5.3 0-12.7 6.5-12.7H381c10.2 0 19.9 4.9 25.9 13.2L512 563.6l105.2-145.4c6-8.3 15.6-13.2 25.9-13.2H690c6.5 0 10.3 7.4 6.5 12.7z'));
exports.DownSquareFill = getIcon('down-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM696.5 412.7l-178 246a7.95 7.95 0 0 1-12.9 0l-178-246c-3.8-5.3 0-12.7 6.5-12.7H381c10.2 0 19.9 4.9 25.9 13.2L512 558.6l105.2-145.4c6-8.3 15.6-13.2 25.9-13.2H690c6.5 0 10.3 7.4 6.5 12.7z'));
exports.DribbbleCircleFill = getIcon('dribbble-circle', fill, getNode(newViewBox, 'M675.1 328.3a245.2 245.2 0 0 0-220.8-55.1c6.8 9.1 51.5 69.9 91.8 144 87.5-32.8 124.5-82.6 129-88.9zM554 552.8c-138.7 48.3-188.6 144.6-193 153.6 41.7 32.5 94.1 51.9 151 51.9 34.1 0 66.6-6.9 96.1-19.5-3.7-21.6-17.9-96.8-52.5-186.6l-1.6.6zm47.7-11.9c32.2 88.4 45.3 160.4 47.8 175.4 55.2-37.3 94.5-96.4 105.4-164.9-8.4-2.6-76.1-22.8-153.2-10.5zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 736c-158.8 0-288-129.2-288-288s129.2-288 288-288 288 129.2 288 288-129.2 288-288 288zm53.1-346.2c5.7 11.7 11.2 23.6 16.3 35.6 1.8 4.2 3.6 8.4 5.3 12.7 81.8-10.3 163.2 6.2 171.3 7.9-.5-58.1-21.3-111.4-55.5-153.3-5.3 7.1-46.5 60-137.4 97.1zM498.6 432c-40.8-72.5-84.7-133.4-91.2-142.3-68.8 32.5-120.3 95.9-136.2 172.2 11 .2 112.4.7 227.4-29.9zm30.6 82.5c3.2-1 6.4-2 9.7-2.9-6.2-14-12.9-28-19.9-41.7-122.8 36.8-242.1 35.2-252.8 35-.1 2.5-.1 5-.1 7.5 0 63.2 23.9 120.9 63.2 164.5 5.5-9.6 73-121.4 199.9-162.4z'));
exports.DribbbleSquareFill = getIcon('dribbble-square', fill, getNode(newViewBox, 'M498.6 432c-40.8-72.5-84.7-133.4-91.2-142.3-68.8 32.5-120.3 95.9-136.2 172.2 11 .2 112.4.7 227.4-29.9zm66.5 21.8c5.7 11.7 11.2 23.6 16.3 35.6 1.8 4.2 3.6 8.4 5.3 12.7 81.8-10.3 163.2 6.2 171.3 7.9-.5-58.1-21.3-111.4-55.5-153.3-5.3 7.1-46.5 60-137.4 97.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM512 800c-158.8 0-288-129.2-288-288s129.2-288 288-288 288 129.2 288 288-129.2 288-288 288zm89.7-259.1c32.2 88.4 45.3 160.4 47.8 175.4 55.2-37.3 94.5-96.4 105.4-164.9-8.4-2.6-76.1-22.8-153.2-10.5zm-72.5-26.4c3.2-1 6.4-2 9.7-2.9-6.2-14-12.9-28-19.9-41.7-122.8 36.8-242.1 35.2-252.8 35-.1 2.5-.1 5-.1 7.5 0 63.2 23.9 120.9 63.2 164.5 5.5-9.6 73-121.4 199.9-162.4zm145.9-186.2a245.2 245.2 0 0 0-220.8-55.1c6.8 9.1 51.5 69.9 91.8 144 87.5-32.8 124.5-82.6 129-88.9zM554 552.8c-138.7 48.3-188.6 144.6-193 153.6 41.7 32.5 94.1 51.9 151 51.9 34.1 0 66.6-6.9 96.1-19.5-3.7-21.6-17.9-96.8-52.5-186.6l-1.6.6z'));
exports.DropboxCircleFill = getIcon('dropbox-circle', fill, getNode(newViewBox, 'M663.8 455.5zm-151.5-93.8l-151.8 93.8 151.8 93.9 151.5-93.9zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm151.2 595.5L512.6 750l-151-90.5v-33.1l45.4 29.4 105.6-87.7 105.6 87.7 45.1-29.4v33.1zm-45.6-22.4l-105.3-87.7L407 637.1l-151-99.2 104.5-82.4L256 371.2 407 274l105.3 87.7L617.6 274 768 372.1l-104.2 83.5L768 539l-150.4 98.1z'));
exports.DropboxSquareFill = getIcon('dropbox-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM663.2 659.5L512.6 750l-151-90.5v-33.1l45.4 29.4 105.6-87.7 105.6 87.7 45.1-29.4v33.1zm-45.6-22.4l-105.3-87.7L407 637.1l-151-99.2 104.5-82.4L256 371.2 407 274l105.3 87.7L617.6 274 768 372.1l-104.2 83.5L768 539l-150.4 98.1zM512.3 361.7l-151.8 93.8 151.8 93.9 151.5-93.9zm151.5 93.8z'));
exports.EnvironmentFill = getIcon('environment', fill, getNode(newViewBox, 'M512 327c-29.9 0-58 11.6-79.2 32.8A111.6 111.6 0 0 0 400 439c0 29.9 11.7 58 32.8 79.2A111.6 111.6 0 0 0 512 551c29.9 0 58-11.7 79.2-32.8C612.4 497 624 468.9 624 439c0-29.9-11.6-58-32.8-79.2S541.9 327 512 327zm342.6-37.9a362.49 362.49 0 0 0-79.9-115.7 370.83 370.83 0 0 0-118.2-77.8C610.7 76.6 562.1 67 512 67c-50.1 0-98.7 9.6-144.5 28.5-44.3 18.3-84 44.5-118.2 77.8A363.6 363.6 0 0 0 169.4 289c-19.5 45-29.4 92.8-29.4 142 0 70.6 16.9 140.9 50.1 208.7 26.7 54.5 64 107.6 111 158.1 80.3 86.2 164.5 138.9 188.4 153a43.9 43.9 0 0 0 22.4 6.1c7.8 0 15.5-2 22.4-6.1 23.9-14.1 108.1-66.8 188.4-153 47-50.4 84.3-103.6 111-158.1C867.1 572 884 501.8 884 431.1c0-49.2-9.9-97-29.4-142zM512 615c-97.2 0-176-78.8-176-176s78.8-176 176-176 176 78.8 176 176-78.8 176-176 176z'));
exports.EditFill = getIcon('edit', fill, getNode(newViewBox, 'M880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32zm-622.3-84c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 0 0 0-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 0 0 9.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9z'));
exports.ExclamationCircleFill = getIcon('exclamation-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-32 232c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'));
exports.EuroCircleFill = getIcon('euro-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm63.5 375.8c4.4 0 8 3.6 8 8V475c0 4.4-3.6 8-8 8h-136c-.3 4.4-.3 9.1-.3 13.8v36h136.2c4.4 0 8 3.6 8 8V568c0 4.4-3.6 8-8 8H444.9c15.3 62 61.3 98.6 129.8 98.6 19.9 0 37.1-1.2 51.8-4.1 4.9-1 9.5 2.8 9.5 7.8v42.8c0 3.8-2.7 7-6.4 7.8-15.9 3.4-34.3 5.1-55.3 5.1-109.8 0-183-58.8-200.2-158H344c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h26.1v-36.9c0-4.4 0-8.8.3-12.8H344c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h31.7c19.7-94.2 92-149.9 198.6-149.9 20.9 0 39.4 1.9 55.3 5.4 3.7.8 6.3 4 6.3 7.8V346h.1c0 5.1-4.6 8.8-9.6 7.8-14.7-2.9-31.8-4.4-51.7-4.4-65.4 0-110.4 33.5-127.6 90.4h128.4z'));
exports.ExperimentFill = getIcon('experiment', fill, getNode(newViewBox, 'M218.9 636.3l42.6 26.6c.1.1.3.2.4.3l12.7 8 .3.3a186.9 186.9 0 0 0 94.1 25.1c44.9 0 87.2-15.7 121-43.8a256.27 256.27 0 0 1 164.9-59.9c52.3 0 102.2 15.7 144.6 44.5l7.9 5-111.6-289V179.8h63.5c4.4 0 8-3.6 8-8V120c0-4.4-3.6-8-8-8H264.7c-4.4 0-8 3.6-8 8v51.9c0 4.4 3.6 8 8 8h63.5v173.6L218.9 636.3zm333-203.1c22 0 39.9 17.9 39.9 39.9S573.9 513 551.9 513 512 495.1 512 473.1s17.9-39.9 39.9-39.9zM878 825.1l-29.9-77.4-85.7-53.5-.1.1c-.7-.5-1.5-1-2.2-1.5l-8.1-5-.3-.3c-29-17.5-62.3-26.8-97-26.8-44.9 0-87.2 15.7-121 43.8a256.27 256.27 0 0 1-164.9 59.9c-53 0-103.5-16.1-146.2-45.6l-28.9-18.1L146 825.1c-2.8 7.4-4.3 15.2-4.3 23 0 35.2 28.6 63.8 63.8 63.8h612.9c7.9 0 15.7-1.5 23-4.3a63.6 63.6 0 0 0 36.6-82.5z'));
exports.EyeInvisibleFill = getIcon('eye-invisible', fill, getNode(newViewBox, 'M508 624a112 112 0 0 0 112-112c0-3.28-.15-6.53-.43-9.74L498.26 623.57c3.21.28 6.45.43 9.74.43zm370.72-458.44L836 122.88a8 8 0 0 0-11.31 0L715.37 232.23Q624.91 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 0 0 0 51.5q56.7 119.43 136.55 191.45L112.56 835a8 8 0 0 0 0 11.31L155.25 889a8 8 0 0 0 11.31 0l712.16-712.12a8 8 0 0 0 0-11.32zM332 512a176 176 0 0 1 258.88-155.28l-48.62 48.62a112.08 112.08 0 0 0-140.92 140.92l-48.62 48.62A175.09 175.09 0 0 1 332 512z', 'M942.2 486.2Q889.4 375 816.51 304.85L672.37 449A176.08 176.08 0 0 1 445 676.37L322.74 798.63Q407.82 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 0 0 0-51.5z'));
exports.EyeFill = getIcon('eye', fill, getNode(newViewBox, 'M396 512a112 112 0 1 0 224 0 112 112 0 1 0-224 0zm546.2-25.8C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 0 0 0 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM508 688c-97.2 0-176-78.8-176-176s78.8-176 176-176 176 78.8 176 176-78.8 176-176 176z'));
exports.FacebookFill = getIcon('facebook', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-92.4 233.5h-63.9c-50.1 0-59.8 23.8-59.8 58.8v77.1h119.6l-15.6 120.7h-104V912H539.2V602.2H434.9V481.4h104.3v-89c0-103.3 63.1-159.6 155.3-159.6 44.2 0 82.1 3.3 93.2 4.8v107.9z'));
exports.FastBackwardFill = getIcon('fast-backward', fill, getNode(normalViewBox, 'M517.6 273.5L230.2 499.3a16.14 16.14 0 0 0 0 25.4l287.4 225.8c10.7 8.4 26.4.8 26.4-12.7V286.2c0-13.5-15.7-21.1-26.4-12.7zm320 0L550.2 499.3a16.14 16.14 0 0 0 0 25.4l287.4 225.8c10.7 8.4 26.4.8 26.4-12.7V286.2c0-13.5-15.7-21.1-26.4-12.7zm-620-25.5h-51.2c-3.5 0-6.4 2.7-6.4 6v516c0 3.3 2.9 6 6.4 6h51.2c3.5 0 6.4-2.7 6.4-6V254c0-3.3-2.9-6-6.4-6z'));
exports.FastForwardFill = getIcon('fast-forward', fill, getNode(normalViewBox, 'M793.8 499.3L506.4 273.5c-10.7-8.4-26.4-.8-26.4 12.7v451.6c0 13.5 15.7 21.1 26.4 12.7l287.4-225.8a16.14 16.14 0 0 0 0-25.4zm-320 0L186.4 273.5c-10.7-8.4-26.4-.8-26.4 12.7v451.5c0 13.5 15.7 21.1 26.4 12.7l287.4-225.8c4.1-3.2 6.2-8 6.2-12.7 0-4.6-2.1-9.4-6.2-12.6zM857.6 248h-51.2c-3.5 0-6.4 2.7-6.4 6v516c0 3.3 2.9 6 6.4 6h51.2c3.5 0 6.4-2.7 6.4-6V254c0-3.3-2.9-6-6.4-6z'));
exports.FileAddFill = getIcon('file-add', fill, getNode(newViewBox, 'M480 580H372a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h108v108a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8V644h108a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8H544V472a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v108zm374.6-291.3c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2z'));
exports.FileExcelFill = getIcon('file-excel', fill, getNode(newViewBox, 'M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM575.34 477.84l-61.22 102.3L452.3 477.8a12 12 0 0 0-10.27-5.79h-38.44a12 12 0 0 0-6.4 1.85 12 12 0 0 0-3.75 16.56l82.34 130.42-83.45 132.78a12 12 0 0 0-1.84 6.39 12 12 0 0 0 12 12h34.46a12 12 0 0 0 10.21-5.7l62.7-101.47 62.3 101.45a12 12 0 0 0 10.23 5.72h37.48a12 12 0 0 0 6.48-1.9 12 12 0 0 0 3.62-16.58l-83.83-130.55 85.3-132.47a12 12 0 0 0 1.9-6.5 12 12 0 0 0-12-12h-35.7a12 12 0 0 0-10.29 5.84z'));
exports.FileExclamationFill = getIcon('file-exclamation', fill, getNode(newViewBox, 'M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM512 784a40 40 0 1 0 0-80 40 40 0 0 0 0 80zm32-152V448a8 8 0 0 0-8-8h-48a8 8 0 0 0-8 8v184a8 8 0 0 0 8 8h48a8 8 0 0 0 8-8z'));
exports.FileImageFill = getIcon('file-image', fill, getNode(newViewBox, 'M854.6 288.7L639.4 73.4c-6-6-14.2-9.4-22.7-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.6-9.4-22.6zM400 402c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm296 294H328c-6.7 0-10.4-7.7-6.3-12.9l99.8-127.2a8 8 0 0 1 12.6 0l41.1 52.4 77.8-99.2a8 8 0 0 1 12.6 0l136.5 174c4.3 5.2.5 12.9-6.1 12.9zm-94-370V137.8L790.2 326H602z'));
exports.FileMarkdownFill = getIcon('file-markdown', fill, getNode(newViewBox, 'M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM426.13 600.93l59.11 132.97a16 16 0 0 0 14.62 9.5h24.06a16 16 0 0 0 14.63-9.51l59.1-133.35V758a16 16 0 0 0 16.01 16H641a16 16 0 0 0 16-16V486a16 16 0 0 0-16-16h-34.75a16 16 0 0 0-14.67 9.62L512.1 662.2l-79.48-182.59a16 16 0 0 0-14.67-9.61H383a16 16 0 0 0-16 16v272a16 16 0 0 0 16 16h27.13a16 16 0 0 0 16-16V600.93z'));
exports.FilePdfFill = getIcon('file-pdf', fill, getNode(newViewBox, 'M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM633.22 637.26c-15.18-.5-31.32.67-49.65 2.96-24.3-14.99-40.66-35.58-52.28-65.83l1.07-4.38 1.24-5.18c4.3-18.13 6.61-31.36 7.3-44.7.52-10.07-.04-19.36-1.83-27.97-3.3-18.59-16.45-29.46-33.02-30.13-15.45-.63-29.65 8-33.28 21.37-5.91 21.62-2.45 50.07 10.08 98.59-15.96 38.05-37.05 82.66-51.2 107.54-18.89 9.74-33.6 18.6-45.96 28.42-16.3 12.97-26.48 26.3-29.28 40.3-1.36 6.49.69 14.97 5.36 21.92 5.3 7.88 13.28 13 22.85 13.74 24.15 1.87 53.83-23.03 86.6-79.26 3.29-1.1 6.77-2.26 11.02-3.7l11.9-4.02c7.53-2.54 12.99-4.36 18.39-6.11 23.4-7.62 41.1-12.43 57.2-15.17 27.98 14.98 60.32 24.8 82.1 24.8 17.98 0 30.13-9.32 34.52-23.99 3.85-12.88.8-27.82-7.48-36.08-8.56-8.41-24.3-12.43-45.65-13.12zM385.23 765.68v-.36l.13-.34a54.86 54.86 0 0 1 5.6-10.76c4.28-6.58 10.17-13.5 17.47-20.87 3.92-3.95 8-7.8 12.79-12.12 1.07-.96 7.91-7.05 9.19-8.25l11.17-10.4-8.12 12.93c-12.32 19.64-23.46 33.78-33 43-3.51 3.4-6.6 5.9-9.1 7.51a16.43 16.43 0 0 1-2.61 1.42c-.41.17-.77.27-1.13.3a2.2 2.2 0 0 1-1.12-.15 2.07 2.07 0 0 1-1.27-1.91zM511.17 547.4l-2.26 4-1.4-4.38c-3.1-9.83-5.38-24.64-6.01-38-.72-15.2.49-24.32 5.29-24.32 6.74 0 9.83 10.8 10.07 27.05.22 14.28-2.03 29.14-5.7 35.65zm-5.81 58.46l1.53-4.05 2.09 3.8c11.69 21.24 26.86 38.96 43.54 51.31l3.6 2.66-4.39.9c-16.33 3.38-31.54 8.46-52.34 16.85 2.17-.88-21.62 8.86-27.64 11.17l-5.25 2.01 2.8-4.88c12.35-21.5 23.76-47.32 36.05-79.77zm157.62 76.26c-7.86 3.1-24.78.33-54.57-12.39l-7.56-3.22 8.2-.6c23.3-1.73 39.8-.45 49.42 3.07 4.1 1.5 6.83 3.39 8.04 5.55a4.64 4.64 0 0 1-1.36 6.31 6.7 6.7 0 0 1-2.17 1.28z'));
exports.FilePptFill = getIcon('file-ppt', fill, getNode(newViewBox, 'M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM468.53 760v-91.54h59.27c60.57 0 100.2-39.65 100.2-98.12 0-58.22-39.58-98.34-99.98-98.34H424a12 12 0 0 0-12 12v276a12 12 0 0 0 12 12h32.53a12 12 0 0 0 12-12zm0-139.33h34.9c47.82 0 67.19-12.93 67.19-50.33 0-32.05-18.12-50.12-49.87-50.12h-52.22v100.45z'));
exports.FileTextFill = getIcon('file-text', fill, getNode(newViewBox, 'M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM320 482a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h384a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8H320zm0 136a8 8 0 0 0-8 8v48a8 8 0 0 0 8 8h184a8 8 0 0 0 8-8v-48a8 8 0 0 0-8-8H320z'));
exports.FileWordFill = getIcon('file-word', fill, getNode(newViewBox, 'M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM512 566.1l52.81 197a12 12 0 0 0 11.6 8.9h31.77a12 12 0 0 0 11.6-8.88l74.37-276a12 12 0 0 0 .4-3.12 12 12 0 0 0-12-12h-35.57a12 12 0 0 0-11.7 9.31l-45.78 199.1-49.76-199.32A12 12 0 0 0 528.1 472h-32.2a12 12 0 0 0-11.64 9.1L434.6 680.01 388.5 481.3a12 12 0 0 0-11.68-9.29h-35.39a12 12 0 0 0-3.11.41 12 12 0 0 0-8.47 14.7l74.17 276A12 12 0 0 0 415.6 772h31.99a12 12 0 0 0 11.59-8.9l52.81-197z'));
exports.FileUnknownFill = getIcon('file-unknown', fill, getNode(newViewBox, 'M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM402 549c0 5.4 4.4 9.5 9.8 9.5h32.4c5.4 0 9.8-4.2 9.8-9.4 0-28.2 25.8-51.6 58-51.6s58 23.4 58 51.5c0 25.3-21 47.2-49.3 50.9-19.3 2.8-34.5 20.3-34.7 40.1v32c0 5.5 4.5 10 10 10h32c5.5 0 10-4.5 10-10v-12.2c0-6 4-11.5 9.7-13.3 44.6-14.4 75-54 74.3-98.9-.8-55.5-49.2-100.8-108.5-101.6-61.4-.7-111.5 45.6-111.5 103zm110 227a32 32 0 1 0 0-64 32 32 0 0 0 0 64z'));
exports.FileZipFill = getIcon('file-zip', fill, getNode(newViewBox, 'M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2zM296 136v64h64v-64h-64zm64 64v64h64v-64h-64zm-64 64v64h64v-64h-64zm64 64v64h64v-64h-64zm-64 64v64h64v-64h-64zm64 64v64h64v-64h-64zm-64 64v64h64v-64h-64zm0 64v160h128V584H296zm48 48h32v64h-32v-64z'));
exports.FileFill = getIcon('file', fill, getNode(newViewBox, 'M854.6 288.7c6 6 9.4 14.1 9.4 22.6V928c0 17.7-14.3 32-32 32H192c-17.7 0-32-14.3-32-32V96c0-17.7 14.3-32 32-32h424.7c8.5 0 16.7 3.4 22.7 9.4l215.2 215.3zM790.2 326L602 137.8V326h188.2z'));
exports.FilterFill = getIcon('filter', fill, getNode(newViewBox, 'M349 838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V642H349v196zm531.1-684H143.9c-24.5 0-39.8 26.7-27.5 48l221.3 376h348.8l221.3-376c12.1-21.3-3.2-48-27.7-48z'));
exports.FireFill = getIcon('fire', fill, getNode(newViewBox, 'M834.1 469.2A347.49 347.49 0 0 0 751.2 354l-29.1-26.7a8.09 8.09 0 0 0-13 3.3l-13 37.3c-8.1 23.4-23 47.3-44.1 70.8-1.4 1.5-3 1.9-4.1 2-1.1.1-2.8-.1-4.3-1.5-1.4-1.2-2.1-3-2-4.8 3.7-60.2-14.3-128.1-53.7-202C555.3 171 510 123.1 453.4 89.7l-41.3-24.3c-5.4-3.2-12.3 1-12 7.3l2.2 48c1.5 32.8-2.3 61.8-11.3 85.9-11 29.5-26.8 56.9-47 81.5a295.64 295.64 0 0 1-47.5 46.1 352.6 352.6 0 0 0-100.3 121.5A347.75 347.75 0 0 0 160 610c0 47.2 9.3 92.9 27.7 136a349.4 349.4 0 0 0 75.5 110.9c32.4 32 70 57.2 111.9 74.7C418.5 949.8 464.5 959 512 959s93.5-9.2 136.9-27.3A348.6 348.6 0 0 0 760.8 857c32.4-32 57.8-69.4 75.5-110.9a344.2 344.2 0 0 0 27.7-136c0-48.8-10-96.2-29.9-140.9z'));
exports.FlagFill = getIcon('flag', fill, getNode(newViewBox, 'M880 305H624V192c0-17.7-14.3-32-32-32H184v-40c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v784c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V640h248v113c0 17.7 14.3 32 32 32h416c17.7 0 32-14.3 32-32V337c0-17.7-14.3-32-32-32z'));
exports.FolderAddFill = getIcon('folder-add', fill, getNode(newViewBox, 'M880 298.4H521L403.7 186.2a8.15 8.15 0 0 0-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM632 577c0 3.8-3.4 7-7.5 7H540v84.9c0 3.9-3.2 7.1-7 7.1h-42c-3.8 0-7-3.2-7-7.1V584h-84.5c-4.1 0-7.5-3.2-7.5-7v-42c0-3.8 3.4-7 7.5-7H484v-84.9c0-3.9 3.2-7.1 7-7.1h42c3.8 0 7 3.2 7 7.1V528h84.5c4.1 0 7.5 3.2 7.5 7v42z'));
exports.FolderFill = getIcon('folder', fill, getNode(newViewBox, 'M880 298.4H521L403.7 186.2a8.15 8.15 0 0 0-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32z'));
exports.FolderOpenFill = getIcon('folder-open', fill, getNode(newViewBox, 'M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 0 0-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zm-180 0H238c-13 0-24.8 7.9-29.7 20L136 643.2V256h188.5l119.6 114.4H748V444z'));
exports.ForwardFill = getIcon('forward', fill, getNode(normalViewBox, 'M825.8 498L538.4 249.9c-10.7-9.2-26.4-.9-26.4 14v496.3c0 14.9 15.7 23.2 26.4 14L825.8 526c8.3-7.2 8.3-20.8 0-28zm-320 0L218.4 249.9c-10.7-9.2-26.4-.9-26.4 14v496.3c0 14.9 15.7 23.2 26.4 14L505.8 526c4.1-3.6 6.2-8.8 6.2-14 0-5.2-2.1-10.4-6.2-14z'));
exports.FrownFill = getIcon('frown', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM288 421a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm376 272h-48.1c-4.2 0-7.8-3.2-8.1-7.4C604 636.1 562.5 597 512 597s-92.1 39.1-95.8 88.6c-.3 4.2-3.9 7.4-8.1 7.4H360a8 8 0 0 1-8-8.4c4.4-84.3 74.5-151.6 160-151.6s155.6 67.3 160 151.6a8 8 0 0 1-8 8.4zm24-224a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'));
exports.FundFill = getIcon('fund', fill, getNode(newViewBox, 'M926 164H94c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V196c0-17.7-14.3-32-32-32zm-92.3 194.4l-297 297.2a8.03 8.03 0 0 1-11.3 0L410.9 541.1 238.4 713.7a8.03 8.03 0 0 1-11.3 0l-36.8-36.8a8.03 8.03 0 0 1 0-11.3l214.9-215c3.1-3.1 8.2-3.1 11.3 0L531 565l254.5-254.6c3.1-3.1 8.2-3.1 11.3 0l36.8 36.8c3.2 3 3.2 8.1.1 11.2z'));
exports.FunnelPlotFill = getIcon('funnel-plot', fill, getNode(newViewBox, 'M336.7 586h350.6l84.9-148H251.8zm543.4-432H143.9c-24.5 0-39.8 26.7-27.5 48L215 374h594l98.7-172c12.2-21.3-3.1-48-27.6-48zM349 838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V650H349v188z'));
exports.GiftFill = getIcon('gift', fill, getNode(newViewBox, 'M160 894c0 17.7 14.3 32 32 32h286V550H160v344zm386 32h286c17.7 0 32-14.3 32-32V550H546v376zm334-616H732.4c13.6-21.4 21.6-46.8 21.6-74 0-76.1-61.9-138-138-138-41.4 0-78.7 18.4-104 47.4-25.3-29-62.6-47.4-104-47.4-76.1 0-138 61.9-138 138 0 27.2 7.9 52.6 21.6 74H144c-17.7 0-32 14.3-32 32v140h366V310h68v172h366V342c0-17.7-14.3-32-32-32zm-402-4h-70c-38.6 0-70-31.4-70-70s31.4-70 70-70 70 31.4 70 70v70zm138 0h-70v-70c0-38.6 31.4-70 70-70s70 31.4 70 70-31.4 70-70 70z'));
exports.GithubFill = getIcon('github', fill, getNode(newViewBox, 'M511.6 76.3C264.3 76.2 64 276.4 64 523.5 64 718.9 189.3 885 363.8 946c23.5 5.9 19.9-10.8 19.9-22.2v-77.5c-135.7 15.9-141.2-73.9-150.3-88.9C215 726 171.5 718 184.5 703c30.9-15.9 62.4 4 98.9 57.9 26.4 39.1 77.9 32.5 104 26 5.7-23.5 17.9-44.5 34.7-60.8-140.6-25.2-199.2-111-199.2-213 0-49.5 16.3-95 48.3-131.7-20.4-60.5 1.9-112.3 4.9-120 58.1-5.2 118.5 41.6 123.2 45.3 33-8.9 70.7-13.6 112.9-13.6 42.4 0 80.2 4.9 113.5 13.9 11.3-8.6 67.3-48.8 121.3-43.9 2.9 7.7 24.7 58.3 5.5 118 32.4 36.8 48.9 82.7 48.9 132.3 0 102.2-59 188.1-200 212.9a127.5 127.5 0 0 1 38.1 91v112.5c.8 9 0 17.9 15 17.9 177.1-59.7 304.6-227 304.6-424.1 0-247.2-200.4-447.3-447.5-447.3z'));
exports.GitlabFill = getIcon('gitlab', fill, getNode(newViewBox, 'M910.5 553.2l-109-370.8c-6.8-20.4-23.1-34.1-44.9-34.1s-39.5 12.3-46.3 32.7l-72.2 215.4H386.2L314 181.1c-6.8-20.4-24.5-32.7-46.3-32.7s-39.5 13.6-44.9 34.1L113.9 553.2c-4.1 13.6 1.4 28.6 12.3 36.8l385.4 289 386.7-289c10.8-8.1 16.3-23.1 12.2-36.8z'));
exports.GoldenFill = getIcon('golden', fill, getNode(newViewBox, 'M905.9 806.7l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H596.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.3-.7 7.3-4.8 6.6-9.2zm-470.2-248c-.6-3.9-4-6.7-7.9-6.7H166.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248zM342 472h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H382.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8z'));
exports.GoogleCircleFill = getIcon('google-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm167 633.6C638.4 735 583 757 516.9 757c-95.7 0-178.5-54.9-218.8-134.9C281.5 589 272 551.6 272 512s9.5-77 26.1-110.1c40.3-80.1 123.1-135 218.8-135 66 0 121.4 24.3 163.9 63.8L610.6 401c-25.4-24.3-57.7-36.6-93.6-36.6-63.8 0-117.8 43.1-137.1 101-4.9 14.7-7.7 30.4-7.7 46.6s2.8 31.9 7.7 46.6c19.3 57.9 73.3 101 137 101 33 0 61-8.7 82.9-23.4 26-17.4 43.2-43.3 48.9-74H516.9v-94.8h230.7c2.9 16.1 4.4 32.8 4.4 50.1 0 74.7-26.7 137.4-73 180.1z'));
exports.GooglePlusCircleFill = getIcon('google-plus-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm36.5 558.8c-43.9 61.8-132.1 79.8-200.9 53.3-69-26.3-118-99.2-112.1-173.5 1.5-90.9 85.2-170.6 176.1-167.5 43.6-2 84.6 16.9 118 43.6-14.3 16.2-29 31.8-44.8 46.3-40.1-27.7-97.2-35.6-137.3-3.6-57.4 39.7-60 133.4-4.8 176.1 53.7 48.7 155.2 24.5 170.1-50.1-33.6-.5-67.4 0-101-1.1-.1-20.1-.2-40.1-.1-60.2 56.2-.2 112.5-.3 168.8.2 3.3 47.3-3 97.5-32 136.5zM791 536.5c-16.8.2-33.6.3-50.4.4-.2 16.8-.3 33.6-.3 50.4H690c-.2-16.8-.2-33.5-.3-50.3-16.8-.2-33.6-.3-50.4-.5v-50.1c16.8-.2 33.6-.3 50.4-.3.1-16.8.3-33.6.4-50.4h50.2l.3 50.4c16.8.2 33.6.2 50.4.3v50.1z'));
exports.GooglePlusSquareFill = getIcon('google-plus-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM548.5 622.8c-43.9 61.8-132.1 79.8-200.9 53.3-69-26.3-118-99.2-112.1-173.5 1.5-90.9 85.2-170.6 176.1-167.5 43.6-2 84.6 16.9 118 43.6-14.3 16.2-29 31.8-44.8 46.3-40.1-27.7-97.2-35.6-137.3-3.6-57.4 39.7-60 133.4-4.8 176.1 53.7 48.7 155.2 24.5 170.1-50.1-33.6-.5-67.4 0-101-1.1-.1-20.1-.2-40.1-.1-60.2 56.2-.2 112.5-.3 168.8.2 3.3 47.3-3 97.5-32 136.5zM791 536.5c-16.8.2-33.6.3-50.4.4-.2 16.8-.3 33.6-.3 50.4H690c-.2-16.8-.2-33.5-.3-50.3-16.8-.2-33.6-.3-50.4-.5v-50.1c16.8-.2 33.6-.3 50.4-.3.1-16.8.3-33.6.4-50.4h50.2l.3 50.4c16.8.2 33.6.2 50.4.3v50.1z'));
exports.GoogleSquareFill = getIcon('google-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM679 697.6C638.4 735 583 757 516.9 757c-95.7 0-178.5-54.9-218.8-134.9A245.02 245.02 0 0 1 272 512c0-39.6 9.5-77 26.1-110.1 40.3-80.1 123.1-135 218.8-135 66 0 121.4 24.3 163.9 63.8L610.6 401c-25.4-24.3-57.7-36.6-93.6-36.6-63.8 0-117.8 43.1-137.1 101-4.9 14.7-7.7 30.4-7.7 46.6s2.8 31.9 7.7 46.6c19.3 57.9 73.3 101 137 101 33 0 61-8.7 82.9-23.4 26-17.4 43.2-43.3 48.9-74H516.9v-94.8h230.7c2.9 16.1 4.4 32.8 4.4 50.1 0 74.7-26.7 137.4-73 180.1z'));
exports.HddFill = getIcon('hdd', fill, getNode(newViewBox, 'M832 64H192c-17.7 0-32 14.3-32 32v224h704V96c0-17.7-14.3-32-32-32zM456 216c0 4.4-3.6 8-8 8H264c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zM160 928c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V704H160v224zm576-136c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM160 640h704V384H160v256zm96-152c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H264c-4.4 0-8-3.6-8-8v-48z'));
exports.HeartFill = getIcon('heart', fill, getNode(newViewBox, 'M923 283.6a260.04 260.04 0 0 0-56.9-82.8 264.4 264.4 0 0 0-84-55.5A265.34 265.34 0 0 0 679.7 125c-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5a258.44 258.44 0 0 0-56.9 82.8c-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3.1-35.3-7-69.6-20.9-101.9z'));
exports.HighlightFill = getIcon('highlight', fill, getNode(newViewBox, 'M957.6 507.4L603.2 158.2a7.9 7.9 0 0 0-11.2 0L353.3 393.4a8.03 8.03 0 0 0-.1 11.3l.1.1 40 39.4-117.2 115.3a8.03 8.03 0 0 0-.1 11.3l.1.1 39.5 38.9-189.1 187H72.1c-4.4 0-8.1 3.6-8.1 8V860c0 4.4 3.6 8 8 8h344.9c2.1 0 4.1-.8 5.6-2.3l76.1-75.6 40.4 39.8a7.9 7.9 0 0 0 11.2 0l117.1-115.6 40.1 39.5a7.9 7.9 0 0 0 11.2 0l238.7-235.2c3.4-3 3.4-8 .3-11.2z'));
exports.HomeFill = getIcon('home', fill, getNode(newViewBox, 'M946.5 505L534.6 93.4a31.93 31.93 0 0 0-45.2 0L77.5 505c-12 12-18.8 28.3-18.8 45.3 0 35.3 28.7 64 64 64h43.4V908c0 17.7 14.3 32 32 32H448V716h112v224h265.9c17.7 0 32-14.3 32-32V614.3h43.4c17 0 33.3-6.7 45.3-18.8 24.9-25 24.9-65.5-.1-90.5z'));
exports.HourglassFill = getIcon('hourglass', fill, getNode(newViewBox, 'M742 318V184h86c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H196c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h86v134c0 81.5 42.4 153.2 106.4 194-64 40.8-106.4 112.5-106.4 194v134h-86c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h632c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-86V706c0-81.5-42.4-153.2-106.4-194 64-40.8 106.4-112.5 106.4-194z'));
exports.Html5Fill = getIcon('html5', fill, getNode(newViewBox, 'M145.2 96l66 746.6L512 928l299.6-85.4L878.9 96H145.2zm595 177.1l-4.8 47.2-1.7 19.5H382.3l8.2 94.2h335.1l-3.3 24.3-21.2 242.2-1.7 16.2-187 51.6v.3h-1.2l-.3.1v-.1h-.1l-188.6-52L310.8 572h91.1l6.5 73.2 102.4 27.7h.4l102-27.6 11.4-118.6H510.9v-.1H306l-22.8-253.5-1.7-24.3h460.3l-1.6 24.3z'));
exports.IdcardFill = getIcon('idcard', fill, getNode(newViewBox, 'M373 411c-28.5 0-51.7 23.3-51.7 52s23.2 52 51.7 52 51.7-23.3 51.7-52-23.2-52-51.7-52zm555-251H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zM608 420c0-4.4 1-8 2.3-8h123.4c1.3 0 2.3 3.6 2.3 8v48c0 4.4-1 8-2.3 8H610.3c-1.3 0-2.3-3.6-2.3-8v-48zm-86 253h-43.9c-4.2 0-7.6-3.3-7.9-7.5-3.8-50.5-46-90.5-97.2-90.5s-93.4 40-97.2 90.5c-.3 4.2-3.7 7.5-7.9 7.5H224a8 8 0 0 1-8-8.4c2.8-53.3 32-99.7 74.6-126.1a111.8 111.8 0 0 1-29.1-75.5c0-61.9 49.9-112 111.4-112s111.4 50.1 111.4 112c0 29.1-11 55.5-29.1 75.5 42.7 26.5 71.8 72.8 74.6 126.1.4 4.6-3.2 8.4-7.8 8.4zm278.9-53H615.1c-3.9 0-7.1-3.6-7.1-8v-48c0-4.4 3.2-8 7.1-8h185.7c3.9 0 7.1 3.6 7.1 8v48h.1c0 4.4-3.2 8-7.1 8z'));
exports.IeCircleFill = getIcon('ie-circle', fill, getNode(newViewBox, 'M693.6 284.4c-24 0-51.1 11.7-72.6 22 46.3 18 86 57.3 112.3 99.6 7.1-18.9 14.6-47.9 14.6-67.9 0-32-22.8-53.7-54.3-53.7zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm253.9 492.9H437.1c0 100.4 144.3 136 196.8 47.4h120.8c-32.6 91.7-119.7 146-216.8 146-35.1 0-70.3-.1-101.7-15.6-87.4 44.5-180.3 56.6-180.3-42 0-45.8 23.2-107.1 44-145C335 484 381.3 422.8 435.6 374.5c-43.7 18.9-91.1 66.3-122 101.2 25.9-112.8 129.5-193.6 237.1-186.5 130-59.8 209.7-34.1 209.7 38.6 0 27.4-10.6 63.3-21.4 87.9 25.2 45.5 33.3 97.6 26.9 141.2zM540.5 399.1c-53.7 0-102 39.7-104 94.9h208c-2-55.1-50.6-94.9-104-94.9zM320.6 602.9c-73 152.4 11.5 172.2 100.3 123.3-46.6-27.5-82.6-72.2-100.3-123.3z'));
exports.IeSquareFill = getIcon('ie-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM765.9 556.9H437.1c0 100.4 144.3 136 196.8 47.4h120.8c-32.6 91.7-119.7 146-216.8 146-35.1 0-70.3-.1-101.7-15.6-87.4 44.5-180.3 56.6-180.3-42 0-45.8 23.2-107.1 44-145C335 484 381.3 422.8 435.6 374.5c-43.7 18.9-91.1 66.3-122 101.2 25.9-112.8 129.5-193.6 237.1-186.5 130-59.8 209.7-34.1 209.7 38.6 0 27.4-10.6 63.3-21.4 87.9 25.2 45.5 33.3 97.6 26.9 141.2zm-72.3-272.5c-24 0-51.1 11.7-72.6 22 46.3 18 86 57.3 112.3 99.6 7.1-18.9 14.6-47.9 14.6-67.9 0-32-22.8-53.7-54.3-53.7zM540.5 399.1c-53.7 0-102 39.7-104 94.9h208c-2-55.1-50.6-94.9-104-94.9zM320.6 602.9c-73 152.4 11.5 172.2 100.3 123.3-46.6-27.5-82.6-72.2-100.3-123.3z'));
exports.InfoCircleFill = getIcon('info-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm32 664c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'));
exports.InstagramFill = getIcon('instagram', fill, getNode(newViewBox, 'M512 378.7c-73.4 0-133.3 59.9-133.3 133.3S438.6 645.3 512 645.3 645.3 585.4 645.3 512 585.4 378.7 512 378.7zM911.8 512c0-55.2.5-109.9-2.6-165-3.1-64-17.7-120.8-64.5-167.6-46.9-46.9-103.6-61.4-167.6-64.5-55.2-3.1-109.9-2.6-165-2.6-55.2 0-109.9-.5-165 2.6-64 3.1-120.8 17.7-167.6 64.5C132.6 226.3 118.1 283 115 347c-3.1 55.2-2.6 109.9-2.6 165s-.5 109.9 2.6 165c3.1 64 17.7 120.8 64.5 167.6 46.9 46.9 103.6 61.4 167.6 64.5 55.2 3.1 109.9 2.6 165 2.6 55.2 0 109.9.5 165-2.6 64-3.1 120.8-17.7 167.6-64.5 46.9-46.9 61.4-103.6 64.5-167.6 3.2-55.1 2.6-109.8 2.6-165zM512 717.1c-113.5 0-205.1-91.6-205.1-205.1S398.5 306.9 512 306.9 717.1 398.5 717.1 512 625.5 717.1 512 717.1zm213.5-370.7c-26.5 0-47.9-21.4-47.9-47.9s21.4-47.9 47.9-47.9 47.9 21.4 47.9 47.9a47.84 47.84 0 0 1-47.9 47.9z'));
exports.InsuranceFill = getIcon('insurance', fill, getNode(newViewBox, 'M519.9 358.8h97.9v41.6h-97.9zm347-188.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM411.3 656h-.2c0 4.4-3.6 8-8 8h-37.3c-4.4 0-8-3.6-8-8V471.4c-7.7 9.2-15.4 17.9-23.1 26a6.04 6.04 0 0 1-10.2-2.4l-13.2-43.5c-.6-2-.2-4.1 1.2-5.6 37-43.4 64.7-95.1 82.2-153.6 1.1-3.5 5-5.3 8.4-3.7l38.6 18.3c2.7 1.3 4.1 4.4 3.2 7.2a429.2 429.2 0 0 1-33.6 79V656zm296.5-49.2l-26.3 35.3a5.92 5.92 0 0 1-8.9.7c-30.6-29.3-56.8-65.2-78.1-106.9V656c0 4.4-3.6 8-8 8h-36.2c-4.4 0-8-3.6-8-8V536c-22 44.7-49 80.8-80.6 107.6a5.9 5.9 0 0 1-8.9-1.4L430 605.7a6 6 0 0 1 1.6-8.1c28.6-20.3 51.9-45.2 71-76h-55.1c-4.4 0-8-3.6-8-8V478c0-4.4 3.6-8 8-8h94.9v-18.6h-65.9c-4.4 0-8-3.6-8-8V316c0-4.4 3.6-8 8-8h184.7c4.4 0 8 3.6 8 8v127.2c0 4.4-3.6 8-8 8h-66.7v18.6h98.8c4.4 0 8 3.6 8 8v35.6c0 4.4-3.6 8-8 8h-59c18.1 29.1 41.8 54.3 72.3 76.9 2.6 2.1 3.2 5.9 1.2 8.5z'));
exports.InteractionFill = getIcon('interaction', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM726 585.7c0 55.3-44.7 100.1-99.7 100.1H420.6v53.4c0 5.7-6.5 8.8-10.9 5.3l-109.1-85.7c-3.5-2.7-3.5-8 0-10.7l109.1-85.7c4.4-3.5 10.9-.3 10.9 5.3v53.4h205.7c19.6 0 35.5-16 35.5-35.6v-78.9c0-3.7 3-6.8 6.8-6.8h50.7c3.7 0 6.8 3 6.8 6.8v79.1zm-2.6-209.9l-109.1 85.7c-4.4 3.5-10.9.3-10.9-5.3v-53.4H397.7c-19.6 0-35.5 16-35.5 35.6v78.9c0 3.7-3 6.8-6.8 6.8h-50.7c-3.7 0-6.8-3-6.8-6.8v-78.9c0-55.3 44.7-100.1 99.7-100.1h205.7v-53.4c0-5.7 6.5-8.8 10.9-5.3l109.1 85.7c3.6 2.5 3.6 7.8.1 10.5z'));
exports.InterationFill = getIcon('interation', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM726 585.7c0 55.3-44.7 100.1-99.7 100.1H420.6v53.4c0 5.7-6.5 8.8-10.9 5.3l-109.1-85.7c-3.5-2.7-3.5-8 0-10.7l109.1-85.7c4.4-3.5 10.9-.3 10.9 5.3v53.4h205.7c19.6 0 35.5-16 35.5-35.6v-78.9c0-3.7 3-6.8 6.8-6.8h50.7c3.7 0 6.8 3 6.8 6.8v79.1zm-2.6-209.9l-109.1 85.7c-4.4 3.5-10.9.3-10.9-5.3v-53.4H397.7c-19.6 0-35.5 16-35.5 35.6v78.9c0 3.7-3 6.8-6.8 6.8h-50.7c-3.7 0-6.8-3-6.8-6.8v-78.9c0-55.3 44.7-100.1 99.7-100.1h205.7v-53.4c0-5.7 6.5-8.8 10.9-5.3l109.1 85.7c3.6 2.5 3.6 7.8.1 10.5z'));
exports.LayoutFill = getIcon('layout', fill, getNode(newViewBox, 'M384 912h496c17.7 0 32-14.3 32-32V340H384v572zm496-800H384v164h528V144c0-17.7-14.3-32-32-32zm-768 32v736c0 17.7 14.3 32 32 32h176V112H144c-17.7 0-32 14.3-32 32z'));
exports.LeftCircleFill = getIcon('left-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm104 316.9c0 10.2-4.9 19.9-13.2 25.9L457.4 512l145.4 105.2c8.3 6 13.2 15.6 13.2 25.9V690c0 6.5-7.4 10.3-12.7 6.5l-246-178a7.95 7.95 0 0 1 0-12.9l246-178a8 8 0 0 1 12.7 6.5v46.8z'));
exports.LeftSquareFill = getIcon('left-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM624 380.9c0 10.2-4.9 19.9-13.2 25.9L465.4 512l145.4 105.2c8.3 6 13.2 15.6 13.2 25.9V690c0 6.5-7.4 10.3-12.7 6.5l-246-178a7.95 7.95 0 0 1 0-12.9l246-178c5.3-3.8 12.7 0 12.7 6.5v46.8z'));
exports.LikeFill = getIcon('like', fill, getNode(newViewBox, 'M885.9 533.7c16.8-22.2 26.1-49.4 26.1-77.7 0-44.9-25.1-87.4-65.5-111.1a67.67 67.67 0 0 0-34.3-9.3H572.4l6-122.9c1.4-29.7-9.1-57.9-29.5-79.4A106.62 106.62 0 0 0 471 99.9c-52 0-98 35-111.8 85.1l-85.9 311h-.3v428h472.3c9.2 0 18.2-1.8 26.5-5.4 47.6-20.3 78.3-66.8 78.3-118.4 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7-.2-12.6-2-25.1-5.6-37.1zM112 528v364c0 17.7 14.3 32 32 32h65V496h-65c-17.7 0-32 14.3-32 32z'));
exports.LockFill = getIcon('lock', fill, getNode(newViewBox, 'M832 464h-68V240c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM540 701v53c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-53a48.01 48.01 0 1 1 56 0zm152-237H332V240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v224z'));
exports.LinkedinFill = getIcon('linkedin', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM349.3 793.7H230.6V411.9h118.7v381.8zm-59.3-434a68.8 68.8 0 1 1 68.8-68.8c-.1 38-30.9 68.8-68.8 68.8zm503.7 434H675.1V608c0-44.3-.8-101.2-61.7-101.2-61.7 0-71.2 48.2-71.2 98v188.9H423.7V411.9h113.8v52.2h1.6c15.8-30 54.5-61.7 112.3-61.7 120.2 0 142.3 79.1 142.3 181.9v209.4z'));
exports.MailFill = getIcon('mail', fill, getNode(newViewBox, 'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-80.8 108.9L531.7 514.4c-7.8 6.1-18.7 6.1-26.5 0L189.6 268.9A7.2 7.2 0 0 1 194 256h648.8a7.2 7.2 0 0 1 4.4 12.9z'));
exports.MedicineBoxFill = getIcon('medicine-box', fill, getNode(newViewBox, 'M839.2 278.1a32 32 0 0 0-30.4-22.1H736V144c0-17.7-14.3-32-32-32H320c-17.7 0-32 14.3-32 32v112h-72.8a31.9 31.9 0 0 0-30.4 22.1L112 502v378c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V502l-72.8-223.9zM660 628c0 4.4-3.6 8-8 8H544v108c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V636H372c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h108V464c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v108h108c4.4 0 8 3.6 8 8v48zm4-372H360v-72h304v72z'));
exports.MediumCircleFill = getIcon('medium-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm256 253.7l-40.8 39.1c-3.6 2.7-5.3 7.1-4.6 11.4v287.7c-.7 4.4 1 8.8 4.6 11.4l40 39.1v8.7H566.4v-8.3l41.3-40.1c4.1-4.1 4.1-5.3 4.1-11.4V422.5l-115 291.6h-15.5L347.5 422.5V618c-1.2 8.2 1.7 16.5 7.5 22.4l53.8 65.1v8.7H256v-8.7l53.8-65.1a26.1 26.1 0 0 0 7-22.4V392c.7-6.3-1.7-12.4-6.5-16.7l-47.8-57.6V309H411l114.6 251.5 100.9-251.3H768v8.5z'));
exports.MediumSquareFill = getIcon('medium-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM768 317.7l-40.8 39.1c-3.6 2.7-5.3 7.1-4.6 11.4v287.7c-.7 4.4 1 8.8 4.6 11.4l40 39.1v8.7H566.4v-8.3l41.3-40.1c4.1-4.1 4.1-5.3 4.1-11.4V422.5l-115 291.6h-15.5L347.5 422.5V618c-1.2 8.2 1.7 16.5 7.5 22.4l53.8 65.1v8.7H256v-8.7l53.8-65.1a26.1 26.1 0 0 0 7-22.4V392c.7-6.3-1.7-12.4-6.5-16.7l-47.8-57.6V309H411l114.6 251.5 100.9-251.3H768v8.5z'));
exports.MehFill = getIcon('meh', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM288 421a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm384 200c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h304c4.4 0 8 3.6 8 8v48zm16-152a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'));
exports.MessageFill = getIcon('message', fill, getNode(newViewBox, 'M924.3 338.4a447.57 447.57 0 0 0-96.1-143.3 443.09 443.09 0 0 0-143-96.3A443.91 443.91 0 0 0 512 64h-2c-60.5.3-119 12.3-174.1 35.9a444.08 444.08 0 0 0-141.7 96.5 445 445 0 0 0-95 142.8A449.89 449.89 0 0 0 65 514.1c.3 69.4 16.9 138.3 47.9 199.9v152c0 25.4 20.6 46 45.9 46h151.8a447.72 447.72 0 0 0 199.5 48h2.1c59.8 0 117.7-11.6 172.3-34.3A443.2 443.2 0 0 0 827 830.5c41.2-40.9 73.6-88.7 96.3-142 23.5-55.2 35.5-113.9 35.8-174.5.2-60.9-11.6-120-34.8-175.6zM312.4 560c-26.4 0-47.9-21.5-47.9-48s21.5-48 47.9-48 47.9 21.5 47.9 48-21.4 48-47.9 48zm199.6 0c-26.4 0-47.9-21.5-47.9-48s21.5-48 47.9-48 47.9 21.5 47.9 48-21.5 48-47.9 48zm199.6 0c-26.4 0-47.9-21.5-47.9-48s21.5-48 47.9-48 47.9 21.5 47.9 48-21.5 48-47.9 48z'));
exports.MinusCircleFill = getIcon('minus-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm192 472c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h368c4.4 0 8 3.6 8 8v48z'));
exports.MinusSquareFill = getIcon('minus-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM704 536c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h368c4.4 0 8 3.6 8 8v48z'));
exports.MobileFill = getIcon('mobile', fill, getNode(newViewBox, 'M744 62H280c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h464c35.3 0 64-28.7 64-64V126c0-35.3-28.7-64-64-64zM512 824c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z'));
exports.MoneyCollectFill = getIcon('money-collect', fill, getNode(newViewBox, 'M911.5 699.7a8 8 0 0 0-10.3-4.8L840 717.2V179c0-37.6-30.4-68-68-68H252c-37.6 0-68 30.4-68 68v538.2l-61.3-22.3c-.9-.3-1.8-.5-2.7-.5-4.4 0-8 3.6-8 8V762c0 3.3 2.1 6.3 5.3 7.5L501 909.1c7.1 2.6 14.8 2.6 21.9 0l383.8-139.5c3.2-1.2 5.3-4.2 5.3-7.5v-59.6c0-1-.2-1.9-.5-2.8zm-243.8-377L564 514.3h57.6c4.4 0 8 3.6 8 8v27.1c0 4.4-3.6 8-8 8h-76.3v39h76.3c4.4 0 8 3.6 8 8v27.1c0 4.4-3.6 8-8 8h-76.3V703c0 4.4-3.6 8-8 8h-49.9c-4.4 0-8-3.6-8-8v-63.4h-76c-4.4 0-8-3.6-8-8v-27.1c0-4.4 3.6-8 8-8h76v-39h-76c-4.4 0-8-3.6-8-8v-27.1c0-4.4 3.6-8 8-8h57L356.5 322.8c-2.1-3.8-.7-8.7 3.2-10.8 1.2-.7 2.5-1 3.8-1h55.7a8 8 0 0 1 7.1 4.4L511 484.2h3.3L599 315.4c1.3-2.7 4.1-4.4 7.1-4.4h54.5c4.4 0 8 3.6 8.1 7.9 0 1.3-.4 2.6-1 3.8z'));
exports.PauseCircleFill = getIcon('pause-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-80 600c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V360c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v304zm224 0c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V360c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v304z'));
exports.PayCircleFill = getIcon('pay-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm166.6 246.8L567.5 515.6h62c4.4 0 8 3.6 8 8v29.9c0 4.4-3.6 8-8 8h-82V603h82c4.4 0 8 3.6 8 8v29.9c0 4.4-3.6 8-8 8h-82V717c0 4.4-3.6 8-8 8h-54.3c-4.4 0-8-3.6-8-8v-68.1h-81.7c-4.4 0-8-3.6-8-8V611c0-4.4 3.6-8 8-8h81.7v-41.5h-81.7c-4.4 0-8-3.6-8-8v-29.9c0-4.4 3.6-8 8-8h61.4L345.4 310.8a8.07 8.07 0 0 1 7-11.9h60.7c3 0 5.8 1.7 7.1 4.4l90.6 180h3.4l90.6-180a8 8 0 0 1 7.1-4.4h59.5c4.4 0 8 3.6 8 8 .2 1.4-.2 2.7-.8 3.9z'));
exports.NotificationFill = getIcon('notification', fill, getNode(newViewBox, 'M880 112c-3.8 0-7.7.7-11.6 2.3L292 345.9H128c-8.8 0-16 7.4-16 16.6v299c0 9.2 7.2 16.6 16 16.6h101.6c-3.7 11.6-5.6 23.9-5.6 36.4 0 65.9 53.8 119.5 120 119.5 55.4 0 102.1-37.6 115.9-88.4l408.6 164.2c3.9 1.5 7.8 2.3 11.6 2.3 16.9 0 32-14.2 32-33.2V145.2C912 126.2 897 112 880 112zM344 762.3c-26.5 0-48-21.4-48-47.8 0-11.2 3.9-21.9 11-30.4l84.9 34.1c-2 24.6-22.7 44.1-47.9 44.1z'));
exports.PhoneFill = getIcon('phone', fill, getNode(newViewBox, 'M885.6 230.2L779.1 123.8a80.83 80.83 0 0 0-57.3-23.8c-21.7 0-42.1 8.5-57.4 23.8L549.8 238.4a80.83 80.83 0 0 0-23.8 57.3c0 21.7 8.5 42.1 23.8 57.4l83.8 83.8A393.82 393.82 0 0 1 553.1 553 395.34 395.34 0 0 1 437 633.8L353.2 550a80.83 80.83 0 0 0-57.3-23.8c-21.7 0-42.1 8.5-57.4 23.8L123.8 664.5a80.89 80.89 0 0 0-23.8 57.4c0 21.7 8.5 42.1 23.8 57.4l106.3 106.3c24.4 24.5 58.1 38.4 92.7 38.4 7.3 0 14.3-.6 21.2-1.8 134.8-22.2 268.5-93.9 376.4-201.7C828.2 612.8 899.8 479.2 922.3 344c6.8-41.3-6.9-83.8-36.7-113.8z'));
exports.PictureFill = getIcon('picture', fill, getNode(newViewBox, 'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zM338 304c35.3 0 64 28.7 64 64s-28.7 64-64 64-64-28.7-64-64 28.7-64 64-64zm513.9 437.1a8.11 8.11 0 0 1-5.2 1.9H177.2c-4.4 0-8-3.6-8-8 0-1.9.7-3.7 1.9-5.2l170.3-202c2.8-3.4 7.9-3.8 11.3-1 .3.3.7.6 1 1l99.4 118 158.1-187.5c2.8-3.4 7.9-3.8 11.3-1 .3.3.7.6 1 1l229.6 271.6c2.6 3.3 2.2 8.4-1.2 11.2z'));
exports.PieChartFill = getIcon('pie-chart', fill, getNode(newViewBox, 'M863.1 518.5H505.5V160.9c0-4.4-3.6-8-8-8h-26a398.57 398.57 0 0 0-282.5 117 397.47 397.47 0 0 0-85.6 127C82.6 446.2 72 498.5 72 552.5S82.6 658.7 103.4 708c20.1 47.5 48.9 90.3 85.6 127 36.7 36.7 79.4 65.5 127 85.6a396.64 396.64 0 0 0 155.6 31.5 398.57 398.57 0 0 0 282.5-117c36.7-36.7 65.5-79.4 85.6-127a396.64 396.64 0 0 0 31.5-155.6v-26c-.1-4.4-3.7-8-8.1-8zM951 463l-2.6-28.2c-8.5-92-49.3-178.8-115.1-244.3A398.5 398.5 0 0 0 588.4 75.6L560.1 73c-4.7-.4-8.7 3.2-8.7 7.9v383.7c0 4.4 3.6 8 8 8l383.6-1c4.7-.1 8.4-4 8-8.6z'));
exports.PlayCircleFill = getIcon('play-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm144.1 454.9L437.7 677.8a8.02 8.02 0 0 1-12.7-6.5V353.7a8 8 0 0 1 12.7-6.5L656.1 506a7.9 7.9 0 0 1 0 12.9z'));
exports.PlaySquareFill = getIcon('play-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM641.7 520.8L442.3 677.6c-7.4 5.8-18.3.6-18.3-8.8V355.3c0-9.4 10.9-14.7 18.3-8.8l199.4 156.7a11.2 11.2 0 0 1 0 17.6z'));
exports.PlusCircleFill = getIcon('plus-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm192 472c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z'));
exports.PlusSquareFill = getIcon('plus-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM704 536c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z'));
exports.PoundCircleFill = getIcon('pound-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm146 658c0 4.4-3.6 8-8 8H376.2c-4.4 0-8-3.6-8-8v-38.5c0-3.7 2.5-6.9 6.1-7.8 44-10.9 72.8-49 72.8-94.2 0-14.7-2.5-29.4-5.9-44.2H374c-4.4 0-8-3.6-8-8v-30c0-4.4 3.6-8 8-8h53.7c-7.8-25.1-14.6-50.7-14.6-77.1 0-75.8 58.6-120.3 151.5-120.3 26.5 0 51.4 5.5 70.3 12.7 3.1 1.2 5.2 4.2 5.2 7.5v39.5a8 8 0 0 1-10.6 7.6c-17.9-6.4-39-10.5-60.4-10.5-53.3 0-87.3 26.6-87.3 70.2 0 24.7 6.2 47.9 13.4 70.5h112c4.4 0 8 3.6 8 8v30c0 4.4-3.6 8-8 8h-98.6c3.1 13.2 5.3 26.9 5.3 41 0 40.7-16.5 73.9-43.9 91.1v4.7h180c4.4 0 8 3.6 8 8V722z'));
exports.PrinterFill = getIcon('printer', fill, getNode(newViewBox, 'M732 120c0-4.4-3.6-8-8-8H300c-4.4 0-8 3.6-8 8v148h440V120zm120 212H172c-44.2 0-80 35.8-80 80v328c0 17.7 14.3 32 32 32h168v132c0 4.4 3.6 8 8 8h424c4.4 0 8-3.6 8-8V772h168c17.7 0 32-14.3 32-32V412c0-44.2-35.8-80-80-80zM664 844H360V568h304v276zm164-360c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-40c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v40z'));
exports.ProfileFill = getIcon('profile', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM380 696c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm0-144c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm0-144c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm304 272c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm0-144c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm0-144c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48z'));
exports.ProjectFill = getIcon('project', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM368 744c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v464zm192-280c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v184zm192 72c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v256z'));
exports.PushpinFill = getIcon('pushpin', fill, getNode(newViewBox, 'M878.3 392.1L631.9 145.7c-6.5-6.5-15-9.7-23.5-9.7s-17 3.2-23.5 9.7L423.8 306.9c-12.2-1.4-24.5-2-36.8-2-73.2 0-146.4 24.1-206.5 72.3-15.4 12.3-16.6 35.4-2.7 49.4l181.7 181.7-215.4 215.2a15.8 15.8 0 0 0-4.6 9.8l-3.4 37.2c-.9 9.4 6.6 17.4 15.9 17.4.5 0 1 0 1.5-.1l37.2-3.4c3.7-.3 7.2-2 9.8-4.6l215.4-215.4 181.7 181.7c6.5 6.5 15 9.7 23.5 9.7 9.7 0 19.3-4.2 25.9-12.4 56.3-70.3 79.7-158.3 70.2-243.4l161.1-161.1c12.9-12.8 12.9-33.8 0-46.8z'));
exports.PropertySafetyFill = getIcon('property-safety', fill, getNode(newViewBox, 'M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM648.3 332.8l-87.7 161.1h45.7c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4v29.7h63.4c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4V658c0 5.5-4.5 10-10 10h-41.3c-5.5 0-10-4.5-10-10v-51.8h-63.1c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h63.1v-29.7h-63.1c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h45.2l-88-161.1c-2.6-4.8-.9-10.9 4-13.6 1.5-.8 3.1-1.2 4.8-1.2h46c3.8 0 7.2 2.1 8.9 5.5l72.9 144.3 73.2-144.3a10 10 0 0 1 8.9-5.5h45c5.5 0 10 4.5 10 10 .1 1.7-.3 3.3-1.1 4.8z'));
exports.QqCircleFill = getIcon('qq-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm210.5 612.4c-11.5 1.4-44.9-52.7-44.9-52.7 0 31.3-16.2 72.2-51.1 101.8 16.9 5.2 54.9 19.2 45.9 34.4-7.3 12.3-125.6 7.9-159.8 4-34.2 3.8-152.5 8.3-159.8-4-9.1-15.2 28.9-29.2 45.8-34.4-35-29.5-51.1-70.4-51.1-101.8 0 0-33.4 54.1-44.9 52.7-5.4-.7-12.4-29.6 9.4-99.7 10.3-33 22-60.5 40.2-105.8-3.1-116.9 45.3-215 160.4-215 113.9 0 163.3 96.1 160.4 215 18.1 45.2 29.9 72.8 40.2 105.8 21.7 70.1 14.6 99.1 9.3 99.7z'));
exports.QqSquareFill = getIcon('qq-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM722.5 676.4c-11.5 1.4-44.9-52.7-44.9-52.7 0 31.3-16.2 72.2-51.1 101.8 16.9 5.2 54.9 19.2 45.9 34.4-7.3 12.3-125.6 7.9-159.8 4-34.2 3.8-152.5 8.3-159.8-4-9.1-15.2 28.9-29.2 45.8-34.4-35-29.5-51.1-70.4-51.1-101.8 0 0-33.4 54.1-44.9 52.7-5.4-.7-12.4-29.6 9.4-99.7 10.3-33 22-60.5 40.2-105.8-3.1-116.9 45.3-215 160.4-215 113.9 0 163.3 96.1 160.4 215 18.1 45.2 29.9 72.8 40.2 105.8 21.7 70.1 14.6 99.1 9.3 99.7z'));
exports.QuestionCircleFill = getIcon('question-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 708c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm62.9-219.5a48.3 48.3 0 0 0-30.9 44.8V620c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-21.5c0-23.1 6.7-45.9 19.9-64.9 12.9-18.6 30.9-32.8 52.1-40.9 34-13.1 56-41.6 56-72.7 0-44.1-43.1-80-96-80s-96 35.9-96 80v7.6c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V420c0-39.3 17.2-76 48.4-103.3C430.4 290.4 470 276 512 276s81.6 14.5 111.6 40.7C654.8 344 672 380.7 672 420c0 57.8-38.1 109.8-97.1 132.5z'));
exports.ReadFill = getIcon('read', fill, getNode(newViewBox, 'M928 161H699.2c-49.1 0-97.1 14.1-138.4 40.7L512 233l-48.8-31.3A255.2 255.2 0 0 0 324.8 161H96c-17.7 0-32 14.3-32 32v568c0 17.7 14.3 32 32 32h228.8c49.1 0 97.1 14.1 138.4 40.7l44.4 28.6c1.3.8 2.8 1.3 4.3 1.3s3-.4 4.3-1.3l44.4-28.6C602 807.1 650.1 793 699.2 793H928c17.7 0 32-14.3 32-32V193c0-17.7-14.3-32-32-32zM404 553.5c0 4.1-3.2 7.5-7.1 7.5H211.1c-3.9 0-7.1-3.4-7.1-7.5v-45c0-4.1 3.2-7.5 7.1-7.5h185.7c3.9 0 7.1 3.4 7.1 7.5v45zm0-140c0 4.1-3.2 7.5-7.1 7.5H211.1c-3.9 0-7.1-3.4-7.1-7.5v-45c0-4.1 3.2-7.5 7.1-7.5h185.7c3.9 0 7.1 3.4 7.1 7.5v45zm416 140c0 4.1-3.2 7.5-7.1 7.5H627.1c-3.9 0-7.1-3.4-7.1-7.5v-45c0-4.1 3.2-7.5 7.1-7.5h185.7c3.9 0 7.1 3.4 7.1 7.5v45zm0-140c0 4.1-3.2 7.5-7.1 7.5H627.1c-3.9 0-7.1-3.4-7.1-7.5v-45c0-4.1 3.2-7.5 7.1-7.5h185.7c3.9 0 7.1 3.4 7.1 7.5v45z'));
exports.ReconciliationFill = getIcon('reconciliation', fill, getNode(newViewBox, 'M676 623c-18.8 0-34 15.2-34 34s15.2 34 34 34 34-15.2 34-34-15.2-34-34-34zm204-455H668c0-30.9-25.1-56-56-56h-80c-30.9 0-56 25.1-56 56H264c-17.7 0-32 14.3-32 32v200h-88c-17.7 0-32 14.3-32 32v448c0 17.7 14.3 32 32 32h336c17.7 0 32-14.3 32-32v-16h368c17.7 0 32-14.3 32-32V200c0-17.7-14.3-32-32-32zM448 848H176V616h272v232zm0-296H176v-88h272v88zm20-272v-48h72v-56h64v56h72v48H468zm180 168v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8zm28 301c-50.8 0-92-41.2-92-92s41.2-92 92-92 92 41.2 92 92-41.2 92-92 92zm92-245c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-96c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v96zm-92 61c-50.8 0-92 41.2-92 92s41.2 92 92 92 92-41.2 92-92-41.2-92-92-92zm0 126c-18.8 0-34-15.2-34-34s15.2-34 34-34 34 15.2 34 34-15.2 34-34 34z'));
exports.RedEnvelopeFill = getIcon('red-envelope', fill, getNode(newViewBox, 'M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zM647 470.4l-87.2 161h45.9c4.6 0 8.4 3.8 8.4 8.4v25.1c0 4.6-3.8 8.4-8.4 8.4h-63.3v28.6h63.3c4.6 0 8.4 3.8 8.4 8.4v25c.2 4.6-3.6 8.5-8.2 8.5h-63.3v49.9c0 4.6-3.8 8.4-8.4 8.4h-43.7c-4.6 0-8.4-3.8-8.4-8.4v-49.9h-63c-4.6 0-8.4-3.8-8.4-8.4v-25.1c0-4.6 3.8-8.4 8.4-8.4h63v-28.6h-63c-4.6 0-8.4-3.8-8.4-8.4v-25.1c0-4.6 3.8-8.4 8.4-8.4h45.4l-87.5-161c-2.2-4.1-.7-9.1 3.4-11.4 1.3-.6 2.6-1 3.9-1h48.8c3.2 0 6.1 1.8 7.5 4.6l71.9 141.8 71.9-141.9a8.5 8.5 0 0 1 7.5-4.6h47.8c4.6 0 8.4 3.8 8.4 8.4-.1 1.5-.5 2.9-1.1 4.1zM512.6 323L289 148h446L512.6 323z'));
exports.RedditCircleFill = getIcon('reddit-circle', fill, getNode(newViewBox, 'M584 548a36 36 0 1 0 72 0 36 36 0 1 0-72 0zm144-108a35.9 35.9 0 0 0-32.5 20.6c18.8 14.3 34.4 30.7 45.9 48.8A35.98 35.98 0 0 0 728 440zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm245 477.9c4.6 13.5 7 27.6 7 42.1 0 99.4-112.8 180-252 180s-252-80.6-252-180c0-14.5 2.4-28.6 7-42.1A72.01 72.01 0 0 1 296 404c27.1 0 50.6 14.9 62.9 37 36.2-19.8 80.2-32.8 128.1-36.1l58.4-131.1c4.3-9.8 15.2-14.8 25.5-11.8l91.6 26.5a54.03 54.03 0 0 1 101.6 25.6c0 29.8-24.2 54-54 54-23.5 0-43.5-15.1-50.9-36.1L577 308.3l-43 96.5c49.1 3 94.2 16.1 131.2 36.3 12.3-22.1 35.8-37 62.9-37 39.8 0 72 32.2 72 72-.1 29.3-17.8 54.6-43.1 65.8zm-171.3 83c-14.9 11.7-44.3 24.3-73.7 24.3s-58.9-12.6-73.7-24.3c-9.3-7.3-22.7-5.7-30 3.6-7.3 9.3-5.7 22.7 3.6 30 25.7 20.4 65 33.5 100.1 33.5 35.1 0 74.4-13.1 100.2-33.5 9.3-7.3 10.9-20.8 3.6-30a21.46 21.46 0 0 0-30.1-3.6zM296 440a35.98 35.98 0 0 0-13.4 69.4c11.5-18.1 27.1-34.5 45.9-48.8A35.9 35.9 0 0 0 296 440zm72 108a36 36 0 1 0 72 0 36 36 0 1 0-72 0z'));
exports.RedditSquareFill = getIcon('reddit-square', fill, getNode(newViewBox, 'M296 440a35.98 35.98 0 0 0-13.4 69.4c11.5-18.1 27.1-34.5 45.9-48.8A35.9 35.9 0 0 0 296 440zm289.7 184.9c-14.9 11.7-44.3 24.3-73.7 24.3s-58.9-12.6-73.7-24.3c-9.3-7.3-22.7-5.7-30 3.6-7.3 9.3-5.7 22.7 3.6 30 25.7 20.4 65 33.5 100.1 33.5 35.1 0 74.4-13.1 100.2-33.5 9.3-7.3 10.9-20.8 3.6-30a21.46 21.46 0 0 0-30.1-3.6zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM757 541.9c4.6 13.5 7 27.6 7 42.1 0 99.4-112.8 180-252 180s-252-80.6-252-180c0-14.5 2.4-28.6 7-42.1A72.01 72.01 0 0 1 296 404c27.1 0 50.6 14.9 62.9 37 36.2-19.8 80.2-32.8 128.1-36.1l58.4-131.1c4.3-9.8 15.2-14.8 25.5-11.8l91.6 26.5a54.03 54.03 0 0 1 101.6 25.6c0 29.8-24.2 54-54 54-23.5 0-43.5-15.1-50.9-36.1L577 308.3l-43 96.5c49.1 3 94.2 16.1 131.2 36.3 12.3-22.1 35.8-37 62.9-37 39.8 0 72 32.2 72 72-.1 29.3-17.8 54.6-43.1 65.8zM584 548a36 36 0 1 0 72 0 36 36 0 1 0-72 0zm144-108a35.9 35.9 0 0 0-32.5 20.6c18.8 14.3 34.4 30.7 45.9 48.8A35.98 35.98 0 0 0 728 440zM368 548a36 36 0 1 0 72 0 36 36 0 1 0-72 0z'));
exports.RestFill = getIcon('rest', fill, getNode(newViewBox, 'M832 256h-28.1l-35.7-120.9c-4-13.7-16.5-23.1-30.7-23.1h-451c-14.3 0-26.8 9.4-30.7 23.1L220.1 256H192c-17.7 0-32 14.3-32 32v28c0 4.4 3.6 8 8 8h45.8l47.7 558.7a32 32 0 0 0 31.9 29.3h429.2a32 32 0 0 0 31.9-29.3L802.2 324H856c4.4 0 8-3.6 8-8v-28c0-17.7-14.3-32-32-32zM508 704c-79.5 0-144-64.5-144-144s64.5-144 144-144 144 64.5 144 144-64.5 144-144 144zM291 256l22.4-76h397.2l22.4 76H291zm137 304a80 80 0 1 0 160 0 80 80 0 1 0-160 0z'));
exports.RightCircleFill = getIcon('right-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm154.7 454.5l-246 178c-5.3 3.8-12.7 0-12.7-6.5v-46.9c0-10.2 4.9-19.9 13.2-25.9L566.6 512 421.2 406.8c-8.3-6-13.2-15.6-13.2-25.9V334c0-6.5 7.4-10.3 12.7-6.5l246 178c4.4 3.2 4.4 9.8 0 13z'));
exports.RocketFill = getIcon('rocket', fill, getNode(newViewBox, 'M864 736c0-111.6-65.4-208-160-252.9V317.3c0-15.1-5.3-29.7-15.1-41.2L536.5 95.4C530.1 87.8 521 84 512 84s-18.1 3.8-24.5 11.4L335.1 276.1a63.97 63.97 0 0 0-15.1 41.2v165.8C225.4 528 160 624.4 160 736h156.5c-2.3 7.2-3.5 15-3.5 23.8 0 22.1 7.6 43.7 21.4 60.8a97.2 97.2 0 0 0 43.1 30.6c23.1 54 75.6 88.8 134.5 88.8 29.1 0 57.3-8.6 81.4-24.8 23.6-15.8 41.9-37.9 53-64a97 97 0 0 0 43.1-30.5 97.52 97.52 0 0 0 21.4-60.8c0-8.4-1.1-16.4-3.1-23.8L864 736zM512 352a48.01 48.01 0 0 1 0 96 48.01 48.01 0 0 1 0-96zm116.1 432.2c-5.2 3-11.2 4.2-17.1 3.4l-19.5-2.4-2.8 19.4c-5.4 37.9-38.4 66.5-76.7 66.5s-71.3-28.6-76.7-66.5l-2.8-19.5-19.5 2.5a27.7 27.7 0 0 1-17.1-3.5c-8.7-5-14.1-14.3-14.1-24.4 0-10.6 5.9-19.4 14.6-23.8h231.3c8.8 4.5 14.6 13.3 14.6 23.8-.1 10.2-5.5 19.6-14.2 24.5z'));
exports.RightSquareFill = getIcon('right-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM658.7 518.5l-246 178c-5.3 3.8-12.7 0-12.7-6.5v-46.9c0-10.2 4.9-19.9 13.2-25.9L558.6 512 413.2 406.8c-8.3-6-13.2-15.6-13.2-25.9V334c0-6.5 7.4-10.3 12.7-6.5l246 178c4.4 3.2 4.4 9.8 0 13z'));
exports.SafetyCertificateFill = getIcon('safety-certificate', fill, getNode(newViewBox, 'M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM694.5 340.7L481.9 633.4a16.1 16.1 0 0 1-26 0l-126.4-174c-3.8-5.3 0-12.7 6.5-12.7h55.2c5.1 0 10 2.5 13 6.6l64.7 89 150.9-207.8c3-4.1 7.8-6.6 13-6.6H688c6.5.1 10.3 7.5 6.5 12.8z'));
exports.SaveFill = getIcon('save', fill, getNode(newViewBox, 'M893.3 293.3L730.7 130.7c-12-12-28.3-18.7-45.3-18.7H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V338.5c0-17-6.7-33.2-18.7-45.2zM384 176h256v112H384V176zm128 554c-79.5 0-144-64.5-144-144s64.5-144 144-144 144 64.5 144 144-64.5 144-144 144zm0-224c-44.2 0-80 35.8-80 80s35.8 80 80 80 80-35.8 80-80-35.8-80-80-80z'));
exports.ScheduleFill = getIcon('schedule', fill, getNode(newViewBox, 'M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zM424 688c0 4.4-3.6 8-8 8H232c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm0-136c0 4.4-3.6 8-8 8H232c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm374.5-91.3l-165 228.7a15.9 15.9 0 0 1-25.8 0L493.5 531.2c-3.8-5.3 0-12.7 6.5-12.7h54.9c5.1 0 9.9 2.5 12.9 6.6l52.8 73.1 103.7-143.7c3-4.2 7.8-6.6 12.9-6.6H792c6.5.1 10.3 7.5 6.5 12.8z'));
exports.SecurityScanFill = getIcon('security-scan', fill, getNode(newViewBox, 'M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM626.8 554c-48.5 48.5-123 55.2-178.6 20.1l-77.5 77.5a8.03 8.03 0 0 1-11.3 0l-34-34a8.03 8.03 0 0 1 0-11.3l77.5-77.5c-35.1-55.7-28.4-130.1 20.1-178.6 56.3-56.3 147.5-56.3 203.8 0 56.3 56.3 56.3 147.5 0 203.8zm-158.54-45.27a80.1 80.1 0 1 0 113.27-113.28 80.1 80.1 0 1 0-113.27 113.28z'));
exports.SettingFill = getIcon('setting', fill, getNode(newViewBox, 'M512.5 390.6c-29.9 0-57.9 11.6-79.1 32.8-21.1 21.2-32.8 49.2-32.8 79.1 0 29.9 11.7 57.9 32.8 79.1 21.2 21.1 49.2 32.8 79.1 32.8 29.9 0 57.9-11.7 79.1-32.8 21.1-21.2 32.8-49.2 32.8-79.1 0-29.9-11.7-57.9-32.8-79.1a110.96 110.96 0 0 0-79.1-32.8zm412.3 235.5l-65.4-55.9c3.1-19 4.7-38.4 4.7-57.7s-1.6-38.8-4.7-57.7l65.4-55.9a32.03 32.03 0 0 0 9.3-35.2l-.9-2.6a442.5 442.5 0 0 0-79.6-137.7l-1.8-2.1a32.12 32.12 0 0 0-35.1-9.5l-81.2 28.9c-30-24.6-63.4-44-99.6-57.5l-15.7-84.9a32.05 32.05 0 0 0-25.8-25.7l-2.7-.5c-52-9.4-106.8-9.4-158.8 0l-2.7.5a32.05 32.05 0 0 0-25.8 25.7l-15.8 85.3a353.44 353.44 0 0 0-98.9 57.3l-81.8-29.1a32 32 0 0 0-35.1 9.5l-1.8 2.1a445.93 445.93 0 0 0-79.6 137.7l-.9 2.6c-4.5 12.5-.8 26.5 9.3 35.2l66.2 56.5c-3.1 18.8-4.6 38-4.6 57 0 19.2 1.5 38.4 4.6 57l-66 56.5a32.03 32.03 0 0 0-9.3 35.2l.9 2.6c18.1 50.3 44.8 96.8 79.6 137.7l1.8 2.1a32.12 32.12 0 0 0 35.1 9.5l81.8-29.1c29.8 24.5 63 43.9 98.9 57.3l15.8 85.3a32.05 32.05 0 0 0 25.8 25.7l2.7.5a448.27 448.27 0 0 0 158.8 0l2.7-.5a32.05 32.05 0 0 0 25.8-25.7l15.7-84.9c36.2-13.6 69.6-32.9 99.6-57.5l81.2 28.9a32 32 0 0 0 35.1-9.5l1.8-2.1c34.8-41.1 61.5-87.4 79.6-137.7l.9-2.6c4.3-12.4.6-26.3-9.5-35zm-412.3 52.2c-97.1 0-175.8-78.7-175.8-175.8s78.7-175.8 175.8-175.8 175.8 78.7 175.8 175.8-78.7 175.8-175.8 175.8z'));
exports.ShopFill = getIcon('shop', fill, getNode(newViewBox, 'M882 272.1V144c0-17.7-14.3-32-32-32H174c-17.7 0-32 14.3-32 32v128.1c-16.7 1-30 14.9-30 31.9v131.7a177 177 0 0 0 14.4 70.4c4.3 10.2 9.6 19.8 15.6 28.9v345c0 17.6 14.3 32 32 32h274V736h128v176h274c17.7 0 32-14.3 32-32V535a175 175 0 0 0 15.6-28.9c9.5-22.3 14.4-46 14.4-70.4V304c0-17-13.3-30.9-30-31.9zm-72 568H640V704c0-17.7-14.3-32-32-32H416c-17.7 0-32 14.3-32 32v136.1H214V597.9c2.9 1.4 5.9 2.8 9 4 22.3 9.4 46 14.1 70.4 14.1s48-4.7 70.4-14.1c13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0 0 38.7 22.1c22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0 0 38.7 22.1c22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 3-1.3 6-2.6 9-4v242.2zm0-568.1H214v-88h596v88z'));
exports.ShoppingFill = getIcon('shopping', fill, getNode(newViewBox, 'M832 312H696v-16c0-101.6-82.4-184-184-184s-184 82.4-184 184v16H192c-17.7 0-32 14.3-32 32v536c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V344c0-17.7-14.3-32-32-32zm-208 0H400v-16c0-61.9 50.1-112 112-112s112 50.1 112 112v16z'));
exports.SketchCircleFill = getIcon('sketch-circle', fill, getNode(newViewBox, 'M582.3 625.6l147.9-166.3h-63.4zm90-202.3h62.5l-92.1-115.1zm-274.7 36L512 684.5l114.4-225.2zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm286.7 380.2L515.8 762.3c-1 1.1-2.4 1.7-3.8 1.7s-2.8-.6-3.8-1.7L225.3 444.2a5.14 5.14 0 0 1-.2-6.6L365.6 262c1-1.2 2.4-1.9 4-1.9h284.6c1.6 0 3 .7 4 1.9l140.5 175.6a4.9 4.9 0 0 1 0 6.6zm-190.5-20.9L512 326.1l-96.2 97.2zM420.3 301.1l-23.1 89.8 88.8-89.8zm183.4 0H538l88.8 89.8zm-222.4 7.1l-92.1 115.1h62.5zm-87.5 151.1l147.9 166.3-84.5-166.3z'));
exports.SketchSquareFill = getIcon('sketch-square', fill, getNode(newViewBox, 'M608.2 423.3L512 326.1l-96.2 97.2zm-25.9 202.3l147.9-166.3h-63.4zm90-202.3h62.5l-92.1-115.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-81.3 332.2L515.8 762.3c-1 1.1-2.4 1.7-3.8 1.7s-2.8-.6-3.8-1.7L225.3 444.2a5.14 5.14 0 0 1-.2-6.6L365.6 262c1-1.2 2.4-1.9 4-1.9h284.6c1.6 0 3 .7 4 1.9l140.5 175.6a4.9 4.9 0 0 1 0 6.6zm-401.1 15.1L512 684.5l114.4-225.2zm-16.3-151.1l-92.1 115.1h62.5zm-87.5 151.1l147.9 166.3-84.5-166.3zm126.5-158.2l-23.1 89.8 88.8-89.8zm183.4 0H538l88.8 89.8z'));
exports.SkinFill = getIcon('skin', fill, getNode(newViewBox, 'M870 126H663.8c-17.4 0-32.9 11.9-37 29.3C614.3 208.1 567 246 512 246s-102.3-37.9-114.8-90.7a37.93 37.93 0 0 0-37-29.3H154a44 44 0 0 0-44 44v252a44 44 0 0 0 44 44h75v388a44 44 0 0 0 44 44h478a44 44 0 0 0 44-44V466h75a44 44 0 0 0 44-44V170a44 44 0 0 0-44-44z'));
exports.SlackCircleFill = getIcon('slack-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM361.5 580.2c0 27.8-22.5 50.4-50.3 50.4a50.35 50.35 0 0 1-50.3-50.4c0-27.8 22.5-50.4 50.3-50.4h50.3v50.4zm134 134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V580.2c0-27.8 22.5-50.4 50.3-50.4a50.35 50.35 0 0 1 50.3 50.4v134.4zm-50.2-218.4h-134c-27.8 0-50.3-22.6-50.3-50.4 0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4-.1 27.9-22.6 50.4-50.3 50.4zm0-134.4c-13.3 0-26.1-5.3-35.6-14.8S395 324.8 395 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v50.4h-50.3zm83.7-50.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V311.4zM579.3 765c-27.8 0-50.3-22.6-50.3-50.4v-50.4h50.3c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm134-134.4h-134c-13.3 0-26.1-5.3-35.6-14.8S529 593.6 529 580.2c0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm0-134.4H663v-50.4c0-27.8 22.5-50.4 50.3-50.4s50.3 22.6 50.3 50.4c0 27.8-22.5 50.4-50.3 50.4z'));
exports.SlackSquareFill = getIcon('slack-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM529 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V311.4zM361.5 580.2c0 27.8-22.5 50.4-50.3 50.4a50.35 50.35 0 0 1-50.3-50.4c0-27.8 22.5-50.4 50.3-50.4h50.3v50.4zm134 134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V580.2c0-27.8 22.5-50.4 50.3-50.4a50.35 50.35 0 0 1 50.3 50.4v134.4zm-50.2-218.4h-134c-27.8 0-50.3-22.6-50.3-50.4 0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4-.1 27.9-22.6 50.4-50.3 50.4zm0-134.4c-13.3 0-26.1-5.3-35.6-14.8S395 324.8 395 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v50.4h-50.3zm134 403.2c-27.8 0-50.3-22.6-50.3-50.4v-50.4h50.3c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm134-134.4h-134a50.35 50.35 0 0 1-50.3-50.4c0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm0-134.4H663v-50.4c0-27.8 22.5-50.4 50.3-50.4s50.3 22.6 50.3 50.4c0 27.8-22.5 50.4-50.3 50.4z'));
exports.SkypeFill = getIcon('skype', fill, getNode(newViewBox, 'M883.7 578.6c4.1-22.5 6.3-45.5 6.3-68.5 0-51-10-100.5-29.7-147-19-45-46.3-85.4-81-120.1a375.79 375.79 0 0 0-120.1-80.9c-46.6-19.7-96-29.7-147-29.7-24 0-48.1 2.3-71.5 6.8A225.1 225.1 0 0 0 335.6 113c-59.7 0-115.9 23.3-158.1 65.5A222.25 222.25 0 0 0 112 336.6c0 38 9.8 75.4 28.1 108.4-3.7 21.4-5.7 43.3-5.7 65.1 0 51 10 100.5 29.7 147 19 45 46.2 85.4 80.9 120.1 34.7 34.7 75.1 61.9 120.1 80.9 46.6 19.7 96 29.7 147 29.7 22.2 0 44.4-2 66.2-5.9 33.5 18.9 71.3 29 110 29 59.7 0 115.9-23.2 158.1-65.5 42.3-42.2 65.5-98.4 65.5-158.1.1-38-9.7-75.5-28.2-108.7zm-370 162.9c-134.2 0-194.2-66-194.2-115.4 0-25.4 18.7-43.1 44.5-43.1 57.4 0 42.6 82.5 149.7 82.5 54.9 0 85.2-29.8 85.2-60.3 0-18.3-9-38.7-45.2-47.6l-119.4-29.8c-96.1-24.1-113.6-76.1-113.6-124.9 0-101.4 95.5-139.5 185.2-139.5 82.6 0 180 45.7 180 106.5 0 26.1-22.6 41.2-48.4 41.2-49 0-40-67.8-138.7-67.8-49 0-76.1 22.2-76.1 53.9s38.7 41.8 72.3 49.5l88.4 19.6c96.8 21.6 121.3 78.1 121.3 131.3 0 82.3-63.3 143.9-191 143.9z'));
exports.SlidersFill = getIcon('sliders', fill, getNode(newViewBox, 'M904 296h-66v-96c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v96h-66c-4.4 0-8 3.6-8 8v416c0 4.4 3.6 8 8 8h66v96c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-96h66c4.4 0 8-3.6 8-8V304c0-4.4-3.6-8-8-8zm-584-72h-66v-56c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v56h-66c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h66v56c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-56h66c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zm292 180h-66V232c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v172h-66c-4.4 0-8 3.6-8 8v200c0 4.4 3.6 8 8 8h66v172c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V620h66c4.4 0 8-3.6 8-8V412c0-4.4-3.6-8-8-8z'));
exports.SmileFill = getIcon('smile', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM288 421a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm224 272c-85.5 0-155.6-67.3-160-151.6a8 8 0 0 1 8-8.4h48.1c4.2 0 7.8 3.2 8.1 7.4C420 589.9 461.5 629 512 629s92.1-39.1 95.8-88.6c.3-4.2 3.9-7.4 8.1-7.4H664a8 8 0 0 1 8 8.4C667.6 625.7 597.5 693 512 693zm176-224a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'));
exports.SnippetsFill = getIcon('snippets', fill, getNode(newViewBox, 'M832 112H724V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H500V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H320c-17.7 0-32 14.3-32 32v120h-96c-17.7 0-32 14.3-32 32v632c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32v-96h96c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM664 486H514V336h.2L664 485.8v.2zm128 274h-56V456L544 264H360v-80h68v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h152v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h68v576z'));
exports.SoundFill = getIcon('sound', fill, getNode(newViewBox, 'M892.1 737.8l-110.3-63.7a15.9 15.9 0 0 0-21.7 5.9l-19.9 34.5c-4.4 7.6-1.8 17.4 5.8 21.8L856.3 800a15.9 15.9 0 0 0 21.7-5.9l19.9-34.5c4.4-7.6 1.7-17.4-5.8-21.8zM760 344a15.9 15.9 0 0 0 21.7 5.9L892 286.2c7.6-4.4 10.2-14.2 5.8-21.8L878 230a15.9 15.9 0 0 0-21.7-5.9L746 287.8a15.99 15.99 0 0 0-5.8 21.8L760 344zm174 132H806c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-40c0-8.8-7.2-16-16-16zM625.9 115c-5.9 0-11.9 1.6-17.4 5.3L254 352H90c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h164l354.5 231.7c5.5 3.6 11.6 5.3 17.4 5.3 16.7 0 32.1-13.3 32.1-32.1V147.1c0-18.8-15.4-32.1-32.1-32.1z'));
exports.StarFill = getIcon('star', fill, getNode(newViewBox, 'M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 0 0 .6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0 0 46.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3z'));
exports.StepBackwardFill = getIcon('step-backward', fill, getNode(normalViewBox, 'M347.6 528.95l383.2 301.02c14.25 11.2 35.2 1.1 35.2-16.95V210.97c0-18.05-20.95-28.14-35.2-16.94L347.6 495.05a21.53 21.53 0 0 0 0 33.9M330 864h-64a8 8 0 0 1-8-8V168a8 8 0 0 1 8-8h64a8 8 0 0 1 8 8v688a8 8 0 0 1-8 8'));
exports.StepForwardFill = getIcon('step-forward', fill, getNode(normalViewBox, 'M676.4 528.95L293.2 829.97c-14.25 11.2-35.2 1.1-35.2-16.95V210.97c0-18.05 20.95-28.14 35.2-16.94l383.2 301.02a21.53 21.53 0 0 1 0 33.9M694 864h64a8 8 0 0 0 8-8V168a8 8 0 0 0-8-8h-64a8 8 0 0 0-8 8v688a8 8 0 0 0 8 8'));
exports.StopFill = getIcon('stop', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm234.8 736.5L223.5 277.2c16-19.7 34-37.7 53.7-53.7l523.3 523.3c-16 19.6-34 37.7-53.7 53.7z'));
exports.SwitcherFill = getIcon('switcher', fill, getNode(newViewBox, 'M752 240H144c-17.7 0-32 14.3-32 32v608c0 17.7 14.3 32 32 32h608c17.7 0 32-14.3 32-32V272c0-17.7-14.3-32-32-32zM596 606c0 4.4-3.6 8-8 8H308c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h280c4.4 0 8 3.6 8 8v48zm284-494H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h576v576c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V144c0-17.7-14.3-32-32-32z'));
exports.TabletFill = getIcon('tablet', fill, getNode(newViewBox, 'M800 64H224c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zM512 824c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z'));
exports.TagFill = getIcon('tag', fill, getNode(newViewBox, 'M938 458.8l-29.6-312.6c-1.5-16.2-14.4-29-30.6-30.6L565.2 86h-.4c-3.2 0-5.7 1-7.6 2.9L88.9 557.2a9.96 9.96 0 0 0 0 14.1l363.8 363.8c1.9 1.9 4.4 2.9 7.1 2.9s5.2-1 7.1-2.9l468.3-468.3c2-2.1 3-5 2.8-8zM699 387c-35.3 0-64-28.7-64-64s28.7-64 64-64 64 28.7 64 64-28.7 64-64 64z'));
exports.TagsFill = getIcon('tags', fill, getNode(newViewBox, 'M483.2 790.3L861.4 412c1.7-1.7 2.5-4 2.3-6.3l-25.5-301.4c-.7-7.8-6.8-13.9-14.6-14.6L522.2 64.3c-2.3-.2-4.7.6-6.3 2.3L137.7 444.8a8.03 8.03 0 0 0 0 11.3l334.2 334.2c3.1 3.2 8.2 3.2 11.3 0zm122.7-533.4c18.7-18.7 49.1-18.7 67.9 0 18.7 18.7 18.7 49.1 0 67.9-18.7 18.7-49.1 18.7-67.9 0-18.7-18.7-18.7-49.1 0-67.9zm283.8 282.9l-39.6-39.5a8.03 8.03 0 0 0-11.3 0l-362 361.3-237.6-237a8.03 8.03 0 0 0-11.3 0l-39.6 39.5a8.03 8.03 0 0 0 0 11.3l243.2 242.8 39.6 39.5c3.1 3.1 8.2 3.1 11.3 0l407.3-406.6c3.1-3.1 3.1-8.2 0-11.3z'));
exports.TaobaoCircleFill = getIcon('taobao-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM315.7 291.5c27.3 0 49.5 22.1 49.5 49.4s-22.1 49.4-49.5 49.4a49.4 49.4 0 1 1 0-98.8zM366.9 578c-13.6 42.3-10.2 26.7-64.4 144.5l-78.5-49s87.7-79.8 105.6-116.2c19.2-38.4-21.1-58.9-21.1-58.9l-60.2-37.5 32.7-50.2c45.4 33.7 48.7 36.6 79.2 67.2 23.8 23.9 20.7 56.8 6.7 100.1zm427.2 55c-15.3 143.8-202.4 90.3-202.4 90.3l10.2-41.1 43.3 9.3c80 5 72.3-64.9 72.3-64.9V423c.6-77.3-72.6-85.4-204.2-38.3l30.6 8.3c-2.5 9-12.5 23.2-25.2 38.6h176v35.6h-99.1v44.5h98.7v35.7h-98.7V622c14.9-4.8 28.6-11.5 40.5-20.5l-8.7-32.5 46.5-14.4 38.8 94.9-57.3 23.9-10.2-37.8c-25.6 19.5-78.8 48-171.8 45.4-99.2 2.6-73.7-112-73.7-112l2.5-1.3H472c-.5 14.7-6.6 38.7 1.7 51.8 6.8 10.8 24.2 12.6 35.3 13.1 1.3.1 2.6.1 3.9.1v-85.3h-101v-35.7h101v-44.5H487c-22.7 24.1-43.5 44.1-43.5 44.1l-30.6-26.7c21.7-22.9 43.3-59.1 56.8-83.2-10.9 4.4-22 9.2-33.6 14.2-11.2 14.3-24.2 29-38.7 43.5.5.8-50-28.4-50-28.4 52.2-44.4 81.4-139.9 81.4-139.9l72.5 20.4s-5.9 14-18.4 35.6c290.3-82.3 307.4 50.5 307.4 50.5s19.1 91.8 3.8 235.7z'));
exports.TaobaoSquareFill = getIcon('taobao-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM315.7 291.5c27.3 0 49.5 22.1 49.5 49.4s-22.1 49.4-49.5 49.4a49.4 49.4 0 1 1 0-98.8zM366.9 578c-13.6 42.3-10.2 26.7-64.4 144.5l-78.5-49s87.7-79.8 105.6-116.2c19.2-38.4-21.1-58.9-21.1-58.9l-60.2-37.5 32.7-50.2c45.4 33.7 48.7 36.6 79.2 67.2 23.8 23.9 20.7 56.8 6.7 100.1zm427.2 55c-15.3 143.8-202.4 90.3-202.4 90.3l10.2-41.1 43.3 9.3c80 5 72.3-64.9 72.3-64.9V423c.6-77.3-72.6-85.4-204.2-38.3l30.6 8.3c-2.5 9-12.5 23.2-25.2 38.6h176v35.6h-99.1v44.5h98.7v35.7h-98.7V622c14.9-4.8 28.6-11.5 40.5-20.5l-8.7-32.5 46.5-14.4 38.8 94.9-57.3 23.9-10.2-37.8c-25.6 19.5-78.8 48-171.8 45.4-99.2 2.6-73.7-112-73.7-112l2.5-1.3H472c-.5 14.7-6.6 38.7 1.7 51.8 6.8 10.8 24.2 12.6 35.3 13.1 1.3.1 2.6.1 3.9.1v-85.3h-101v-35.7h101v-44.5H487c-22.7 24.1-43.5 44.1-43.5 44.1l-30.6-26.7c21.7-22.9 43.3-59.1 56.8-83.2-10.9 4.4-22 9.2-33.6 14.2-11.2 14.3-24.2 29-38.7 43.5.5.8-50-28.4-50-28.4 52.2-44.4 81.4-139.9 81.4-139.9l72.5 20.4s-5.9 14-18.4 35.6c290.3-82.3 307.4 50.5 307.4 50.5s19.1 91.8 3.8 235.7z'));
exports.ToolFill = getIcon('tool', fill, getNode(newViewBox, 'M865.3 244.7c-.3-.3-61.1 59.8-182.1 180.6l-84.9-84.9 180.9-180.9c-95.2-57.3-217.5-42.6-296.8 36.7A244.42 244.42 0 0 0 419 432l1.8 6.7-283.5 283.4c-6.2 6.2-6.2 16.4 0 22.6l141.4 141.4c6.2 6.2 16.4 6.2 22.6 0l283.3-283.3 6.7 1.8c83.7 22.3 173.6-.9 236-63.3 79.4-79.3 94.1-201.6 38-296.6z'));
exports.ThunderboltFill = getIcon('thunderbolt', fill, getNode(newViewBox, 'M848 359.3H627.7L825.8 109c4.1-5.3.4-13-6.3-13H436c-2.8 0-5.5 1.5-6.9 4L170 547.5c-3.1 5.3.7 12 6.9 12h174.4l-89.4 357.6c-1.9 7.8 7.5 13.3 13.3 7.7L853.5 373c5.2-4.9 1.7-13.7-5.5-13.7z'));
exports.TrademarkCircleFill = getIcon('trademark-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm164.7 660.2c-1.1.5-2.3.8-3.5.8h-62c-3.1 0-5.9-1.8-7.2-4.6l-74.6-159.2h-88.7V717c0 4.4-3.6 8-8 8H378c-4.4 0-8-3.6-8-8V307c0-4.4 3.6-8 8-8h155.6c98.8 0 144.2 59.9 144.2 131.1 0 70.2-43.6 106.4-78.4 119.2l80.8 164.2c2.1 3.9.4 8.7-3.5 10.7zM523.9 357h-83.4v148H522c53 0 82.8-25.6 82.8-72.4 0-50.3-32.9-75.6-80.9-75.6z'));
exports.TwitterCircleFill = getIcon('twitter-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm215.3 337.7c.3 4.7.3 9.6.3 14.4 0 146.8-111.8 315.9-316.1 315.9-63 0-121.4-18.3-170.6-49.8 9 1 17.6 1.4 26.8 1.4 52 0 99.8-17.6 137.9-47.4-48.8-1-89.8-33-103.8-77 17.1 2.5 32.5 2.5 50.1-2a111 111 0 0 1-88.9-109v-1.4c14.7 8.3 32 13.4 50.1 14.1a111.13 111.13 0 0 1-49.5-92.4c0-20.7 5.4-39.6 15.1-56a315.28 315.28 0 0 0 229 116.1C492 353.1 548.4 292 616.2 292c32 0 60.8 13.4 81.1 35 25.1-4.7 49.1-14.1 70.5-26.7-8.3 25.7-25.7 47.4-48.8 61.1 22.4-2.4 44-8.6 64-17.3-15.1 22.2-34 41.9-55.7 57.6z'));
exports.TrophyFill = getIcon('trophy', fill, getNode(newViewBox, 'M868 160h-92v-40c0-4.4-3.6-8-8-8H256c-4.4 0-8 3.6-8 8v40h-92a44 44 0 0 0-44 44v148c0 81.7 60 149.6 138.2 162C265.6 630.2 359 721.8 476 734.5v105.2H280c-17.7 0-32 14.3-32 32V904c0 4.4 3.6 8 8 8h512c4.4 0 8-3.6 8-8v-32.3c0-17.7-14.3-32-32-32H548V734.5C665 721.8 758.4 630.2 773.8 514 852 501.6 912 433.7 912 352V204a44 44 0 0 0-44-44zM248 439.6c-37.1-11.9-64-46.7-64-87.6V232h64v207.6zM840 352c0 41-26.9 75.8-64 87.6V232h64v120z'));
exports.TwitterSquareFill = getIcon('twitter-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM727.3 401.7c.3 4.7.3 9.6.3 14.4 0 146.8-111.8 315.9-316.1 315.9-63 0-121.4-18.3-170.6-49.8 9 1 17.6 1.4 26.8 1.4 52 0 99.8-17.6 137.9-47.4-48.8-1-89.8-33-103.8-77 17.1 2.5 32.5 2.5 50.1-2a111 111 0 0 1-88.9-109v-1.4c14.7 8.3 32 13.4 50.1 14.1a111.13 111.13 0 0 1-49.5-92.4c0-20.7 5.4-39.6 15.1-56a315.28 315.28 0 0 0 229 116.1C492 353.1 548.4 292 616.2 292c32 0 60.8 13.4 81.1 35 25.1-4.7 49.1-14.1 70.5-26.7-8.3 25.7-25.7 47.4-48.8 61.1 22.4-2.4 44-8.6 64-17.3-15.1 22.2-34 41.9-55.7 57.6z'));
exports.UnlockFill = getIcon('unlock', fill, getNode(newViewBox, 'M832 464H332V240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v68c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-68c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM540 701v53c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-53a48.01 48.01 0 1 1 56 0z'));
exports.UpCircleFill = getIcon('up-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm178 555h-46.9c-10.2 0-19.9-4.9-25.9-13.2L512 460.4 406.8 605.8c-6 8.3-15.6 13.2-25.9 13.2H334c-6.5 0-10.3-7.4-6.5-12.7l178-246c3.2-4.4 9.7-4.4 12.9 0l178 246c3.9 5.3.1 12.7-6.4 12.7z'));
exports.UpSquareFill = getIcon('up-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM690 624h-46.9c-10.2 0-19.9-4.9-25.9-13.2L512 465.4 406.8 610.8c-6 8.3-15.6 13.2-25.9 13.2H334c-6.5 0-10.3-7.4-6.5-12.7l178-246c3.2-4.4 9.7-4.4 12.9 0l178 246c3.9 5.3.1 12.7-6.4 12.7z'));
exports.UsbFill = getIcon('usb', fill, getNode(newViewBox, 'M408 312h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm352 120V144c0-17.7-14.3-32-32-32H296c-17.7 0-32 14.3-32 32v288c-66.2 0-120 52.1-120 116v356c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8V548c0-63.9-53.8-116-120-116zm-72 0H336V184h352v248zM568 312h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z'));
exports.WalletFill = getIcon('wallet', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-32 464H528V448h320v128zm-268-64a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'));
exports.VideoCameraFill = getIcon('video-camera', fill, getNode(newViewBox, 'M912 302.3L784 376V224c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v576c0 35.3 28.7 64 64 64h592c35.3 0 64-28.7 64-64V648l128 73.7c21.3 12.3 48-3.1 48-27.6V330c0-24.6-26.7-40-48-27.7zM328 352c0 4.4-3.6 8-8 8H208c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h112c4.4 0 8 3.6 8 8v48zm560 273l-104-59.8V458.9L888 399v226z'));
exports.WarningFill = getIcon('warning', fill, getNode(newViewBox, 'M955.7 856l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zM480 416c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v184c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V416zm32 352a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'));
exports.WeiboCircleFill = getIcon('weibo-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-44.4 672C353.1 736 236 680.4 236 588.9c0-47.8 30.2-103.1 82.3-155.3 69.5-69.6 150.6-101.4 181.1-70.8 13.5 13.5 14.8 36.8 6.1 64.6-4.5 14 13.1 6.3 13.1 6.3 56.2-23.6 105.2-25 123.1.7 9.6 13.7 8.6 32.8-.2 55.1-4.1 10.2 1.3 11.8 9 14.1 31.7 9.8 66.9 33.6 66.9 75.5.2 69.5-99.7 156.9-249.8 156.9zm207.3-290.8a34.9 34.9 0 0 0-7.2-34.1 34.68 34.68 0 0 0-33.1-10.7 18.24 18.24 0 0 1-7.6-35.7c24.1-5.1 50.1 2.3 67.7 21.9 17.7 19.6 22.4 46.3 14.9 69.8a18.13 18.13 0 0 1-22.9 11.7 18.18 18.18 0 0 1-11.8-22.9zm106 34.3s0 .1 0 0a21.1 21.1 0 0 1-26.6 13.7 21.19 21.19 0 0 1-13.6-26.7c11-34.2 4-73.2-21.7-101.8a104.04 104.04 0 0 0-98.9-32.1 21.14 21.14 0 0 1-25.1-16.3 21.07 21.07 0 0 1 16.2-25.1c49.4-10.5 102.8 4.8 139.1 45.1 36.3 40.2 46.1 95.1 30.6 143.2zm-334.5 6.1c-91.4 9-160.7 65.1-154.7 125.2 5.9 60.1 84.8 101.5 176.2 92.5 91.4-9.1 160.7-65.1 154.7-125.3-5.9-60.1-84.8-101.5-176.2-92.4zm80.2 141.7c-18.7 42.3-72.3 64.8-117.8 50.1-43.9-14.2-62.5-57.7-43.3-96.8 18.9-38.4 68-60.1 111.5-48.8 45 11.7 68 54.2 49.6 95.5zm-93-32.2c-14.2-5.9-32.4.2-41.2 13.9-8.8 13.8-4.7 30.2 9.3 36.6 14.3 6.5 33.2.3 42-13.8 8.8-14.3 4.2-30.6-10.1-36.7zm34.9-14.5c-5.4-2.2-12.2.5-15.4 5.8-3.1 5.4-1.4 11.5 4.1 13.8 5.5 2.3 12.6-.3 15.8-5.8 3-5.6 1-11.8-4.5-13.8z'));
exports.WechatFill = getIcon('wechat', fill, getNode(newViewBox, 'M690.1 377.4c5.9 0 11.8.2 17.6.5-24.4-128.7-158.3-227.1-319.9-227.1C209 150.8 64 271.4 64 420.2c0 81.1 43.6 154.2 111.9 203.6a21.5 21.5 0 0 1 9.1 17.6c0 2.4-.5 4.6-1.1 6.9-5.5 20.3-14.2 52.8-14.6 54.3-.7 2.6-1.7 5.2-1.7 7.9 0 5.9 4.8 10.8 10.8 10.8 2.3 0 4.2-.9 6.2-2l70.9-40.9c5.3-3.1 11-5 17.2-5 3.2 0 6.4.5 9.5 1.4 33.1 9.5 68.8 14.8 105.7 14.8 6 0 11.9-.1 17.8-.4-7.1-21-10.9-43.1-10.9-66 0-135.8 132.2-245.8 295.3-245.8zm-194.3-86.5c23.8 0 43.2 19.3 43.2 43.1s-19.3 43.1-43.2 43.1c-23.8 0-43.2-19.3-43.2-43.1s19.4-43.1 43.2-43.1zm-215.9 86.2c-23.8 0-43.2-19.3-43.2-43.1s19.3-43.1 43.2-43.1 43.2 19.3 43.2 43.1-19.4 43.1-43.2 43.1zm586.8 415.6c56.9-41.2 93.2-102 93.2-169.7 0-124-120.8-224.5-269.9-224.5-149 0-269.9 100.5-269.9 224.5S540.9 847.5 690 847.5c30.8 0 60.6-4.4 88.1-12.3 2.6-.8 5.2-1.2 7.9-1.2 5.2 0 9.9 1.6 14.3 4.1l59.1 34c1.7 1 3.3 1.7 5.2 1.7a9 9 0 0 0 6.4-2.6 9 9 0 0 0 2.6-6.4c0-2.2-.9-4.4-1.4-6.6-.3-1.2-7.6-28.3-12.2-45.3-.5-1.9-.9-3.8-.9-5.7.1-5.9 3.1-11.2 7.6-14.5zM600.2 587.2c-19.9 0-36-16.1-36-35.9 0-19.8 16.1-35.9 36-35.9s36 16.1 36 35.9c0 19.8-16.2 35.9-36 35.9zm179.9 0c-19.9 0-36-16.1-36-35.9 0-19.8 16.1-35.9 36-35.9s36 16.1 36 35.9a36.08 36.08 0 0 1-36 35.9z'));
exports.WindowsFill = getIcon('windows', fill, getNode(newViewBox, 'M523.8 191.4v288.9h382V128.1zm0 642.2l382 62.2v-352h-382zM120.1 480.2H443V201.9l-322.9 53.5zm0 290.4L443 823.2V543.8H120.1z'));
exports.YahooFill = getIcon('yahoo', fill, getNode(newViewBox, 'M937.3 231H824.7c-15.5 0-27.7 12.6-27.1 28.1l13.1 366h84.4l65.4-366.4c2.7-15.2-7.8-27.7-23.2-27.7zm-77.4 450.4h-14.1c-27.1 0-49.2 22.2-49.2 49.3v14.1c0 27.1 22.2 49.3 49.2 49.3h14.1c27.1 0 49.2-22.2 49.2-49.3v-14.1c0-27.1-22.2-49.3-49.2-49.3zM402.6 231C216.2 231 65 357 65 512.5S216.2 794 402.6 794s337.6-126 337.6-281.5S589.1 231 402.6 231zm225.2 225.2h-65.3L458.9 559.8v65.3h84.4v56.3H318.2v-56.3h84.4v-65.3L242.9 399.9h-37v-56.3h168.5v56.3h-37l93.4 93.5 28.1-28.1V400h168.8v56.2z'));
exports.WeiboSquareFill = getIcon('weibo-square', fill, getNode(newViewBox, 'M433.6 595.1c-14.2-5.9-32.4.2-41.2 13.9-8.8 13.8-4.7 30.2 9.3 36.6 14.3 6.5 33.2.3 42-13.8 8.8-14.3 4.2-30.6-10.1-36.7zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM467.6 736C353.1 736 236 680.4 236 588.9c0-47.8 30.2-103.1 82.3-155.3 69.5-69.6 150.6-101.4 181.1-70.8 13.5 13.5 14.8 36.8 6.1 64.6-4.5 14 13.1 6.3 13.1 6.3 56.2-23.6 105.2-25 123.1.7 9.6 13.7 8.6 32.8-.2 55.1-4.1 10.2 1.3 11.8 9 14.1 31.7 9.8 66.9 33.6 66.9 75.5.2 69.5-99.7 156.9-249.8 156.9zm207.3-290.8a34.9 34.9 0 0 0-7.2-34.1 34.68 34.68 0 0 0-33.1-10.7 18.24 18.24 0 0 1-7.6-35.7c24.1-5.1 50.1 2.3 67.7 21.9 17.7 19.6 22.4 46.3 14.9 69.8a18.13 18.13 0 0 1-22.9 11.7 18.18 18.18 0 0 1-11.8-22.9zm106 34.3s0 .1 0 0a21.1 21.1 0 0 1-26.6 13.7 21.19 21.19 0 0 1-13.6-26.7c11-34.2 4-73.2-21.7-101.8a104.04 104.04 0 0 0-98.9-32.1 21.14 21.14 0 0 1-25.1-16.3 21.07 21.07 0 0 1 16.2-25.1c49.4-10.5 102.8 4.8 139.1 45.1 36.3 40.2 46.1 95.1 30.6 143.2zm-334.5 6.1c-91.4 9-160.7 65.1-154.7 125.2 5.9 60.1 84.8 101.5 176.2 92.5 91.4-9.1 160.7-65.1 154.7-125.3-5.9-60.1-84.8-101.5-176.2-92.4zm80.2 141.7c-18.7 42.3-72.3 64.8-117.8 50.1-43.9-14.2-62.5-57.7-43.3-96.8 18.9-38.4 68-60.1 111.5-48.8 45 11.7 68 54.2 49.6 95.5zm-58.1-46.7c-5.4-2.2-12.2.5-15.4 5.8-3.1 5.4-1.4 11.5 4.1 13.8 5.5 2.3 12.6-.3 15.8-5.8 3-5.6 1-11.8-4.5-13.8z'));
exports.YuqueFill = getIcon('yuque', fill, getNode(newViewBox, 'M854.6 370.6c-9.9-39.4 9.9-102.2 73.4-124.4l-67.9-3.6s-25.7-90-143.6-98c-117.9-8.1-195-3-195-3s87.4 55.6 52.4 154.7c-25.6 52.5-65.8 95.6-108.8 144.7-1.3 1.3-2.5 2.6-3.5 3.7C319.4 605 96 860 96 860c245.9 64.4 410.7-6.3 508.2-91.1 20.5-.2 35.9-.3 46.3-.3 135.8 0 250.6-117.6 245.9-248.4-3.2-89.9-31.9-110.2-41.8-149.6z'));
exports.YoutubeFill = getIcon('youtube', fill, getNode(newViewBox, 'M941.3 296.1a112.3 112.3 0 0 0-79.2-79.3C792.2 198 512 198 512 198s-280.2 0-350.1 18.7A112.12 112.12 0 0 0 82.7 296C64 366 64 512 64 512s0 146 18.7 215.9c10.3 38.6 40.7 69 79.2 79.3C231.8 826 512 826 512 826s280.2 0 350.1-18.8c38.6-10.3 68.9-40.7 79.2-79.3C960 658 960 512 960 512s0-146-18.7-215.9zM423 646V378l232 133-232 135z'));
exports.ZhihuSquareFill = getIcon('zhihu-square', fill, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM432.3 592.8l71 80.7c9.2 33-3.3 63.1-3.3 63.1l-95.7-111.9v-.1c-8.9 29-20.1 57.3-33.3 84.7-22.6 45.7-55.2 54.7-89.5 57.7-34.4 3-23.3-5.3-23.3-5.3 68-55.5 78-87.8 96.8-123.1 11.9-22.3 20.4-64.3 25.3-96.8H264.1s4.8-31.2 19.2-41.7h101.6c.6-15.3-1.3-102.8-2-131.4h-49.4c-9.2 45-41 56.7-48.1 60.1-7 3.4-23.6 7.1-21.1 0 2.6-7.1 27-46.2 43.2-110.7 16.3-64.6 63.9-62 63.9-62-12.8 22.5-22.4 73.6-22.4 73.6h159.7c10.1 0 10.6 39 10.6 39h-90.8c-.7 22.7-2.8 83.8-5 131.4H519s12.2 15.4 12.2 41.7h-110l-.1 1.5c-1.5 20.4-6.3 43.9-12.9 67.6l24.1-18.1zm335.5 116h-87.6l-69.5 46.6-16.4-46.6h-40.1V321.5h213.6v387.3zM408.2 611s0-.1 0 0zm216 94.3l56.8-38.1h45.6-.1V364.7H596.7v302.5h14.1z'));
exports.ZhihuCircleFill = getIcon('zhihu-circle', fill, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-90.7 477.8l-.1 1.5c-1.5 20.4-6.3 43.9-12.9 67.6l24-18.1 71 80.7c9.2 33-3.3 63.1-3.3 63.1l-95.7-111.9v-.1c-8.9 29-20.1 57.3-33.3 84.7-22.6 45.7-55.2 54.7-89.5 57.7-34.4 3-23.3-5.3-23.3-5.3 68-55.5 78-87.8 96.8-123.1 11.9-22.3 20.4-64.3 25.3-96.8H264.1s4.8-31.2 19.2-41.7h101.6c.6-15.3-1.3-102.8-2-131.4h-49.4c-9.2 45-41 56.7-48.1 60.1-7 3.4-23.6 7.1-21.1 0 2.6-7.1 27-46.2 43.2-110.7 16.3-64.6 63.9-62 63.9-62-12.8 22.5-22.4 73.6-22.4 73.6h159.7c10.1 0 10.6 39 10.6 39h-90.8c-.7 22.7-2.8 83.8-5 131.4H519s12.2 15.4 12.2 41.7H421.3zm346.5 167h-87.6l-69.5 46.6-16.4-46.6h-40.1V321.5h213.6v387.3zM408.2 611s0-.1 0 0zm216 94.3l56.8-38.1h45.6-.1V364.7H596.7v302.5h14.1z'));
exports.AccountBookOutline = getIcon('account-book', outline, getNode(newViewBox, 'M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v584zM639.5 414h-45c-3 0-5.8 1.7-7.1 4.4L514 563.8h-2.8l-73.4-145.4a8 8 0 0 0-7.1-4.4h-46c-1.3 0-2.7.3-3.8 1-3.9 2.1-5.3 7-3.2 10.9l89.3 164h-48.6c-4.4 0-8 3.6-8 8v21.3c0 4.4 3.6 8 8 8h65.1v33.7h-65.1c-4.4 0-8 3.6-8 8v21.3c0 4.4 3.6 8 8 8h65.1V752c0 4.4 3.6 8 8 8h41.3c4.4 0 8-3.6 8-8v-53.8h65.4c4.4 0 8-3.6 8-8v-21.3c0-4.4-3.6-8-8-8h-65.4v-33.7h65.4c4.4 0 8-3.6 8-8v-21.3c0-4.4-3.6-8-8-8h-49.1l89.3-164.1c.6-1.2 1-2.5 1-3.8.1-4.4-3.4-8-7.9-8z'));
exports.AlertOutline = getIcon('alert', outline, getNode(newViewBox, 'M193 796c0 17.7 14.3 32 32 32h574c17.7 0 32-14.3 32-32V563c0-176.2-142.8-319-319-319S193 386.8 193 563v233zm72-233c0-136.4 110.6-247 247-247s247 110.6 247 247v193H404V585c0-5.5-4.5-10-10-10h-44c-5.5 0-10 4.5-10 10v171h-75V563zm-48.1-252.5l39.6-39.6c3.1-3.1 3.1-8.2 0-11.3l-67.9-67.9a8.03 8.03 0 0 0-11.3 0l-39.6 39.6a8.03 8.03 0 0 0 0 11.3l67.9 67.9c3.1 3.1 8.1 3.1 11.3 0zm669.6-79.2l-39.6-39.6a8.03 8.03 0 0 0-11.3 0l-67.9 67.9a8.03 8.03 0 0 0 0 11.3l39.6 39.6c3.1 3.1 8.2 3.1 11.3 0l67.9-67.9c3.1-3.2 3.1-8.2 0-11.3zM832 892H192c-17.7 0-32 14.3-32 32v24c0 4.4 3.6 8 8 8h688c4.4 0 8-3.6 8-8v-24c0-17.7-14.3-32-32-32zM484 180h56c4.4 0 8-3.6 8-8V76c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v96c0 4.4 3.6 8 8 8z'));
exports.AlipayCircleOutline = getIcon('alipay-circle', outline, getNode(newViewBox, 'M308.6 545.7c-19.8 2-57.1 10.7-77.4 28.6-61 53-24.5 150 99 150 71.8 0 143.5-45.7 199.8-119-80.2-38.9-148.1-66.8-221.4-59.6zm460.5 67c100.1 33.4 154.7 43 166.7 44.8A445.9 445.9 0 0 0 960 512c0-247.4-200.6-448-448-448S64 264.6 64 512s200.6 448 448 448c155.9 0 293.2-79.7 373.5-200.5-75.6-29.8-213.6-85-286.8-120.1-69.9 85.7-160.1 137.8-253.7 137.8-158.4 0-212.1-138.1-137.2-229 16.3-19.8 44.2-38.7 87.3-49.4 67.5-16.5 175 10.3 275.7 43.4 18.1-33.3 33.4-69.9 44.7-108.9H305.1V402h160v-56.2H271.3v-31.3h193.8v-80.1s0-13.5 13.7-13.5H557v93.6h191.7v31.3H557.1V402h156.4c-15 61.1-37.7 117.4-66.2 166.8 47.5 17.1 90.1 33.3 121.8 43.9z'));
exports.AliwangwangOutline = getIcon('aliwangwang', outline, getNode(newViewBox, 'M868.2 377.4c-18.9-45.1-46.3-85.6-81.2-120.6a377.26 377.26 0 0 0-120.5-81.2A375.65 375.65 0 0 0 519 145.8c-41.9 0-82.9 6.7-121.9 20C306 123.3 200.8 120 170.6 120c-2.2 0-7.4 0-9.4.2-11.9.4-22.8 6.5-29.2 16.4-6.5 9.9-7.7 22.4-3.4 33.5l64.3 161.6a378.59 378.59 0 0 0-52.8 193.2c0 51.4 10 101 29.8 147.6 18.9 45 46.2 85.6 81.2 120.5 34.7 34.8 75.4 62.1 120.5 81.2C418.3 894 467.9 904 519 904c51.3 0 100.9-10.1 147.7-29.8 44.9-18.9 85.5-46.3 120.4-81.2 34.7-34.8 62.1-75.4 81.2-120.6a376.5 376.5 0 0 0 29.8-147.6c-.2-51.2-10.1-100.8-29.9-147.4zm-66.4 266.5a307.08 307.08 0 0 1-65.9 98c-28.4 28.5-61.3 50.7-97.7 65.9h-.1c-38 16-78.3 24.2-119.9 24.2a306.51 306.51 0 0 1-217.5-90.2c-28.4-28.5-50.6-61.4-65.8-97.8v-.1c-16-37.8-24.1-78.2-24.1-119.9 0-55.4 14.8-109.7 42.8-157l13.2-22.1-9.5-23.9L206 192c14.9.6 35.9 2.1 59.7 5.6 43.8 6.5 82.5 17.5 114.9 32.6l19 8.9 19.9-6.8c31.5-10.8 64.8-16.2 98.9-16.2a306.51 306.51 0 0 1 217.5 90.2c28.4 28.5 50.6 61.4 65.8 97.8l.1.1.1.1c16 37.6 24.1 78 24.2 119.8-.1 41.7-8.3 82-24.3 119.8zM681.1 364.2c-20.4 0-37.1 16.7-37.1 37.1v55.1c0 20.4 16.6 37.1 37.1 37.1s37.1-16.7 37.1-37.1v-55.1c0-20.5-16.7-37.1-37.1-37.1zm-175.2 0c-20.5 0-37.1 16.7-37.1 37.1v55.1c0 20.4 16.7 37.1 37.1 37.1 20.5 0 37.1-16.7 37.1-37.1v-55.1c0-20.5-16.7-37.1-37.1-37.1z'));
exports.AndroidOutline = getIcon('android', outline, getNode(newViewBox, 'M448.3 225.2c-18.6 0-32 13.4-32 31.9s13.5 31.9 32 31.9c18.6 0 32-13.4 32-31.9.1-18.4-13.4-31.9-32-31.9zm393.9 96.4c-13.8-13.8-32.7-21.5-53.2-21.5-3.9 0-7.4.4-10.7 1v-1h-3.6c-5.5-30.6-18.6-60.5-38.1-87.4-18.7-25.7-43-47.9-70.8-64.9l25.1-35.8v-3.3c0-.8.4-2.3.7-3.8.6-2.4 1.4-5.5 1.4-8.9 0-18.5-13.5-31.9-32-31.9-9.8 0-19.5 5.7-25.9 15.4l-29.3 42.1c-30-9.8-62.4-15-93.8-15-31.3 0-63.7 5.2-93.8 15L389 79.4c-6.6-9.6-16.1-15.4-26-15.4-18.6 0-32 13.4-32 31.9 0 6.2 2.5 12.8 6.7 17.4l22.6 32.3c-28.7 17-53.5 39.4-72.2 65.1-19.4 26.9-32 56.8-36.7 87.4h-5.5v1c-3.2-.6-6.7-1-10.7-1-20.3 0-39.2 7.5-53.1 21.3-13.8 13.8-21.5 32.6-21.5 53v235c0 20.3 7.5 39.1 21.4 52.9 13.8 13.8 32.8 21.5 53.2 21.5 3.9 0 7.4-.4 10.7-1v93.5c0 29.2 23.9 53.1 53.2 53.1H331v58.3c0 20.3 7.5 39.1 21.4 52.9 13.8 13.8 32.8 21.5 53.2 21.5 20.3 0 39.2-7.5 53.1-21.3 13.8-13.8 21.5-32.6 21.5-53v-58.2H544v58.1c0 20.3 7.5 39.1 21.4 52.9 13.8 13.8 32.8 21.5 53.2 21.5 20.4 0 39.2-7.5 53.1-21.6 13.8-13.8 21.5-32.6 21.5-53v-58.2h31.9c29.3 0 53.2-23.8 53.2-53.1v-91.4c3.2.6 6.7 1 10.7 1 20.3 0 39.2-7.5 53.1-21.3 13.8-13.8 21.5-32.6 21.5-53v-235c-.1-20.3-7.6-39-21.4-52.9zM246 609.6c0 6.8-3.9 10.6-10.7 10.6-6.8 0-10.7-3.8-10.7-10.6V374.5c0-6.8 3.9-10.6 10.7-10.6 6.8 0 10.7 3.8 10.7 10.6v235.1zm131.1-396.8c37.5-27.3 85.3-42.3 135-42.3s97.5 15.1 135 42.5c32.4 23.7 54.2 54.2 62.7 87.5H314.4c8.5-33.4 30.5-64 62.7-87.7zm39.3 674.7c-.6 5.6-4.4 8.7-10.5 8.7-6.8 0-10.7-3.8-10.7-10.6v-58.2h21.2v60.1zm202.3 8.7c-6.8 0-10.7-3.8-10.7-10.6v-58.2h21.2v60.1c-.6 5.6-4.3 8.7-10.5 8.7zm95.8-132.6H309.9V364h404.6v399.6zm85.2-154c0 6.8-3.9 10.6-10.7 10.6-6.8 0-10.7-3.8-10.7-10.6V374.5c0-6.8 3.9-10.6 10.7-10.6 6.8 0 10.7 3.8 10.7 10.6v235.1zM576.1 225.2c-18.6 0-32 13.4-32 31.9s13.5 31.9 32 31.9c18.6 0 32.1-13.4 32.1-32-.1-18.6-13.4-31.8-32.1-31.8z'));
exports.ApiOutline = getIcon('api', outline, getNode(newViewBox, 'M917.7 148.8l-42.4-42.4c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-76.1 76.1a199.27 199.27 0 0 0-112.1-34.3c-51.2 0-102.4 19.5-141.5 58.6L432.3 308.7a8.03 8.03 0 0 0 0 11.3L704 591.7c1.6 1.6 3.6 2.3 5.7 2.3 2 0 4.1-.8 5.7-2.3l101.9-101.9c68.9-69 77-175.7 24.3-253.5l76.1-76.1c3.1-3.2 3.1-8.3 0-11.4zM769.1 441.7l-59.4 59.4-186.8-186.8 59.4-59.4c24.9-24.9 58.1-38.7 93.4-38.7 35.3 0 68.4 13.7 93.4 38.7 24.9 24.9 38.7 58.1 38.7 93.4 0 35.3-13.8 68.4-38.7 93.4zm-190.2 105a8.03 8.03 0 0 0-11.3 0L501 613.3 410.7 523l66.7-66.7c3.1-3.1 3.1-8.2 0-11.3L441 408.6a8.03 8.03 0 0 0-11.3 0L363 475.3l-43-43a7.85 7.85 0 0 0-5.7-2.3c-2 0-4.1.8-5.7 2.3L206.8 534.2c-68.9 69-77 175.7-24.3 253.5l-76.1 76.1a8.03 8.03 0 0 0 0 11.3l42.4 42.4c1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3l76.1-76.1c33.7 22.9 72.9 34.3 112.1 34.3 51.2 0 102.4-19.5 141.5-58.6l101.9-101.9c3.1-3.1 3.1-8.2 0-11.3l-43-43 66.7-66.7c3.1-3.1 3.1-8.2 0-11.3l-36.6-36.2zM441.7 769.1a131.32 131.32 0 0 1-93.4 38.7c-35.3 0-68.4-13.7-93.4-38.7a131.32 131.32 0 0 1-38.7-93.4c0-35.3 13.7-68.4 38.7-93.4l59.4-59.4 186.8 186.8-59.4 59.4z'));
exports.AppstoreOutline = getIcon('appstore', outline, getNode(newViewBox, 'M464 144H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H212V212h200v200zm452-268H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H612V212h200v200zM464 544H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H212V612h200v200zm452-268H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H612V612h200v200z'));
exports.AudioOutline = getIcon('audio', outline, getNode(newViewBox, 'M842 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 140.3-113.7 254-254 254S258 594.3 258 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 168.7 126.6 307.9 290 327.6V884H326.7c-13.7 0-24.7 14.3-24.7 32v36c0 4.4 2.8 8 6.2 8h407.6c3.4 0 6.2-3.6 6.2-8v-36c0-17.7-11-32-24.7-32H548V782.1c165.3-18 294-158 294-328.1zM512 624c93.9 0 170-75.2 170-168V232c0-92.8-76.1-168-170-168s-170 75.2-170 168v224c0 92.8 76.1 168 170 168zm-94-392c0-50.6 41.9-92 94-92s94 41.4 94 92v224c0 50.6-41.9 92-94 92s-94-41.4-94-92V232z'));
exports.AppleOutline = getIcon('apple', outline, getNode(newViewBox, 'M747.4 535.7c-.4-68.2 30.5-119.6 92.9-157.5-34.9-50-87.7-77.5-157.3-82.8-65.9-5.2-138 38.4-164.4 38.4-27.9 0-91.7-36.6-141.9-36.6C273.1 298.8 163 379.8 163 544.6c0 48.7 8.9 99 26.7 150.8 23.8 68.2 109.6 235.3 199.1 232.6 46.8-1.1 79.9-33.2 140.8-33.2 59.1 0 89.7 33.2 141.9 33.2 90.3-1.3 167.9-153.2 190.5-221.6-121.1-57.1-114.6-167.2-114.6-170.7zm-10.6 267c-14.3 19.9-28.7 35.6-41.9 45.7-10.5 8-18.6 11.4-24 11.6-9-.1-17.7-2.3-34.7-8.8-1.2-.5-2.5-1-4.2-1.6l-4.4-1.7c-17.4-6.7-27.8-10.3-41.1-13.8-18.6-4.8-37.1-7.4-56.9-7.4-20.2 0-39.2 2.5-58.1 7.2-13.9 3.5-25.6 7.4-42.7 13.8-.7.3-8.1 3.1-10.2 3.9-3.5 1.3-6.2 2.3-8.7 3.2-10.4 3.6-17 5.1-22.9 5.2-.7 0-1.3-.1-1.8-.2-1.1-.2-2.5-.6-4.1-1.3-4.5-1.8-9.9-5.1-16-9.8-14-10.9-29.4-28-45.1-49.9-27.5-38.6-53.5-89.8-66-125.7-15.4-44.8-23-87.7-23-128.6 0-60.2 17.8-106 48.4-137.1 26.3-26.6 61.7-41.5 97.8-42.3 5.9.1 14.5 1.5 25.4 4.5 8.6 2.3 18 5.4 30.7 9.9 3.8 1.4 16.9 6.1 18.5 6.7 7.7 2.8 13.5 4.8 19.2 6.6 18.2 5.8 32.3 9 47.6 9 15.5 0 28.8-3.3 47.7-9.8 7.1-2.4 32.9-12 37.5-13.6 25.6-9.1 44.5-14 60.8-15.2 4.8-.4 9.1-.4 13.2-.1 22.7 1.8 42.1 6.3 58.6 13.8-37.6 43.4-57 96.5-56.9 158.4-.3 14.7.9 31.7 5.1 51.8 6.4 30.5 18.6 60.7 37.9 89 14.7 21.5 32.9 40.9 54.7 57.8-11.5 23.7-25.6 48.2-40.4 68.8zm-94.5-572c50.7-60.2 46.1-115 44.6-134.7-44.8 2.6-96.6 30.5-126.1 64.8-32.5 36.8-51.6 82.3-47.5 133.6 48.4 3.7 92.6-21.2 129-63.7z'));
exports.BackwardOutline = getIcon('backward', outline, getNode(normalViewBox, 'M485.6 249.9L198.2 498c-8.3 7.1-8.3 20.8 0 27.9l287.4 248.2c10.7 9.2 26.4.9 26.4-14V263.8c0-14.8-15.7-23.2-26.4-13.9zm320 0L518.2 498a18.6 18.6 0 0 0-6.2 14c0 5.2 2.1 10.4 6.2 14l287.4 248.2c10.7 9.2 26.4.9 26.4-14V263.8c0-14.8-15.7-23.2-26.4-13.9z'));
exports.BankOutline = getIcon('bank', outline, getNode(newViewBox, 'M894 462c30.9 0 43.8-39.7 18.7-58L530.8 126.2a31.81 31.81 0 0 0-37.6 0L111.3 404c-25.1 18.2-12.2 58 18.8 58H192v374h-72c-4.4 0-8 3.6-8 8v52c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-52c0-4.4-3.6-8-8-8h-72V462h62zM512 196.7l271.1 197.2H240.9L512 196.7zM264 462h117v374H264V462zm189 0h117v374H453V462zm307 374H642V462h118v374z'));
exports.BellOutline = getIcon('bell', outline, getNode(newViewBox, 'M816 768h-24V428c0-141.1-104.3-257.7-240-277.1V112c0-22.1-17.9-40-40-40s-40 17.9-40 40v38.9c-135.7 19.4-240 136-240 277.1v340h-24c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h216c0 61.8 50.2 112 112 112s112-50.2 112-112h216c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM512 888c-26.5 0-48-21.5-48-48h96c0 26.5-21.5 48-48 48zM304 768V428c0-55.6 21.6-107.8 60.9-147.1S456.4 220 512 220c55.6 0 107.8 21.6 147.1 60.9S720 372.4 720 428v340H304z'));
exports.BehanceSquareOutline = getIcon('behance-square', outline, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM598.5 350.9h138.4v33.7H598.5v-33.7zM512 628.8a89.52 89.52 0 0 1-27 31c-11.8 8.2-24.9 14.2-38.8 17.7a167.4 167.4 0 0 1-44.6 5.7H236V342.1h161c16.3 0 31.1 1.5 44.6 4.3 13.4 2.8 24.8 7.6 34.4 14.1 9.5 6.5 17 15.2 22.3 26 5.2 10.7 7.9 24.1 7.9 40 0 17.2-3.9 31.4-11.7 42.9-7.9 11.5-19.3 20.8-34.8 28.1 21.1 6 36.6 16.7 46.8 31.7 10.4 15.2 15.5 33.4 15.5 54.8 0 17.4-3.3 32.3-10 44.8zM790.8 576H612.4c0 19.4 6.7 38 16.8 48 10.2 9.9 24.8 14.9 43.9 14.9 13.8 0 25.5-3.5 35.5-10.4 9.9-6.9 15.9-14.2 18.1-21.8h59.8c-9.6 29.7-24.2 50.9-44 63.7-19.6 12.8-43.6 19.2-71.5 19.2-19.5 0-37-3.2-52.7-9.3-15.1-5.9-28.7-14.9-39.9-26.5a121.2 121.2 0 0 1-25.1-41.2c-6.1-16.9-9.1-34.7-8.9-52.6 0-18.5 3.1-35.7 9.1-51.7 11.5-31.1 35.4-56 65.9-68.9 16.3-6.8 33.8-10.2 51.5-10 21 0 39.2 4 55 12.2a111.6 111.6 0 0 1 38.6 32.8c10.1 13.7 17.2 29.3 21.7 46.9 4.3 17.3 5.8 35.5 4.6 54.7zm-122-95.6c-10.8 0-19.9 1.9-26.9 5.6-7 3.7-12.8 8.3-17.2 13.6a48.4 48.4 0 0 0-9.1 17.4c-1.6 5.3-2.7 10.7-3.1 16.2H723c-1.6-17.3-7.6-30.1-15.6-39.1-8.4-8.9-21.9-13.7-38.6-13.7zm-248.5-10.1c8.7-6.3 12.9-16.7 12.9-31 .3-6.8-1.1-13.5-4.1-19.6-2.7-4.9-6.7-9-11.6-11.9a44.8 44.8 0 0 0-16.6-6c-6.4-1.2-12.9-1.8-19.3-1.7h-70.3v79.7h76.1c13.1.1 24.2-3.1 32.9-9.5zm11.8 72c-9.8-7.5-22.9-11.2-39.2-11.2h-81.8v94h80.2c7.5 0 14.4-.7 21.1-2.1s12.7-3.8 17.8-7.2c5.1-3.3 9.2-7.8 12.3-13.6 3-5.8 4.5-13.2 4.5-22.1 0-17.7-5-30.2-14.9-37.8z'));
exports.BookOutline = getIcon('book', outline, getNode(newViewBox, 'M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-260 72h96v209.9L621.5 312 572 347.4V136zm220 752H232V136h280v296.9c0 3.3 1 6.6 3 9.3a15.9 15.9 0 0 0 22.3 3.7l83.8-59.9 81.4 59.4c2.7 2 6 3.1 9.4 3.1 8.8 0 16-7.2 16-16V136h64v752z'));
exports.BoxPlotOutline = getIcon('box-plot', outline, getNode(newViewBox, 'M952 224h-52c-4.4 0-8 3.6-8 8v248h-92V304c0-4.4-3.6-8-8-8H232c-4.4 0-8 3.6-8 8v176h-92V232c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V548h92v172c0 4.4 3.6 8 8 8h560c4.4 0 8-3.6 8-8V548h92v244c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zM296 368h88v288h-88V368zm432 288H448V368h280v288z'));
exports.BulbOutline = getIcon('bulb', outline, getNode(newViewBox, 'M632 888H392c-4.4 0-8 3.6-8 8v32c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32v-32c0-4.4-3.6-8-8-8zM512 64c-181.1 0-328 146.9-328 328 0 121.4 66 227.4 164 284.1V792c0 17.7 14.3 32 32 32h264c17.7 0 32-14.3 32-32V676.1c98-56.7 164-162.7 164-284.1 0-181.1-146.9-328-328-328zm127.9 549.8L604 634.6V752H420V634.6l-35.9-20.8C305.4 568.3 256 484.5 256 392c0-141.4 114.6-256 256-256s256 114.6 256 256c0 92.5-49.4 176.3-128.1 221.8z'));
exports.BugOutline = getIcon('bug', outline, getNode(newViewBox, 'M304 280h56c4.4 0 8-3.6 8-8 0-28.3 5.9-53.2 17.1-73.5 10.6-19.4 26-34.8 45.4-45.4C450.9 142 475.7 136 504 136h16c28.3 0 53.2 5.9 73.5 17.1 19.4 10.6 34.8 26 45.4 45.4C650 218.9 656 243.7 656 272c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-40-8.8-76.7-25.9-108.1a184.31 184.31 0 0 0-74-74C596.7 72.8 560 64 520 64h-16c-40 0-76.7 8.8-108.1 25.9a184.31 184.31 0 0 0-74 74C304.8 195.3 296 232 296 272c0 4.4 3.6 8 8 8z', 'M940 512H792V412c76.8 0 139-62.2 139-139 0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8a63 63 0 0 1-63 63H232a63 63 0 0 1-63-63c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 76.8 62.2 139 139 139v100H84c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h148v96c0 6.5.2 13 .7 19.3C164.1 728.6 116 796.7 116 876c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-44.2 23.9-82.9 59.6-103.7a273 273 0 0 0 22.7 49c24.3 41.5 59 76.2 100.5 100.5S460.5 960 512 960s99.8-13.9 141.3-38.2a281.38 281.38 0 0 0 123.2-149.5A120 120 0 0 1 836 876c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8 0-79.3-48.1-147.4-116.7-176.7.4-6.4.7-12.8.7-19.3v-96h148c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM716 680c0 36.8-9.7 72-27.8 102.9-17.7 30.3-43 55.6-73.3 73.3C584 874.3 548.8 884 512 884s-72-9.7-102.9-27.8c-30.3-17.7-55.6-43-73.3-73.3A202.75 202.75 0 0 1 308 680V412h408v268z'));
exports.CalculatorOutline = getIcon('calculator', outline, getNode(newViewBox, 'M251.2 387H320v68.8c0 1.8 1.8 3.2 4 3.2h48c2.2 0 4-1.4 4-3.3V387h68.8c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H376v-68.8c0-1.8-1.8-3.2-4-3.2h-48c-2.2 0-4 1.4-4 3.2V331h-68.8c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm328 0h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm0 265h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm0 104h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm-195.7-81l61.2-74.9c4.3-5.2.7-13.1-5.9-13.1H388c-2.3 0-4.5 1-5.9 2.9l-34 41.6-34-41.6a7.85 7.85 0 0 0-5.9-2.9h-50.9c-6.6 0-10.2 7.9-5.9 13.1l61.2 74.9-62.7 76.8c-4.4 5.2-.8 13.1 5.8 13.1h50.8c2.3 0 4.5-1 5.9-2.9l35.5-43.5 35.5 43.5c1.5 1.8 3.7 2.9 5.9 2.9h50.8c6.6 0 10.2-7.9 5.9-13.1L383.5 675zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-36 732H180V180h664v664z'));
exports.BuildOutline = getIcon('build', outline, getNode(newViewBox, 'M916 210H376c-17.7 0-32 14.3-32 32v236H108c-17.7 0-32 14.3-32 32v272c0 17.7 14.3 32 32 32h540c17.7 0 32-14.3 32-32V546h236c17.7 0 32-14.3 32-32V242c0-17.7-14.3-32-32-32zm-504 68h200v200H412V278zm-68 468H144V546h200v200zm268 0H412V546h200v200zm268-268H680V278h200v200z'));
exports.CalendarOutline = getIcon('calendar', outline, getNode(newViewBox, 'M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zM184 392V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136H184z'));
exports.CameraOutline = getIcon('camera', outline, getNode(newViewBox, 'M864 248H728l-32.4-90.8a32.07 32.07 0 0 0-30.2-21.2H358.6c-13.5 0-25.6 8.5-30.1 21.2L296 248H160c-44.2 0-80 35.8-80 80v456c0 44.2 35.8 80 80 80h704c44.2 0 80-35.8 80-80V328c0-44.2-35.8-80-80-80zm8 536c0 4.4-3.6 8-8 8H160c-4.4 0-8-3.6-8-8V328c0-4.4 3.6-8 8-8h186.7l17.1-47.8 22.9-64.2h250.5l22.9 64.2 17.1 47.8H864c4.4 0 8 3.6 8 8v456zM512 384c-88.4 0-160 71.6-160 160s71.6 160 160 160 160-71.6 160-160-71.6-160-160-160zm0 256c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96z'));
exports.CarOutline = getIcon('car', outline, getNode(newViewBox, 'M380 704h264c4.4 0 8-3.6 8-8v-84c0-4.4-3.6-8-8-8h-40c-4.4 0-8 3.6-8 8v36H428v-36c0-4.4-3.6-8-8-8h-40c-4.4 0-8 3.6-8 8v84c0 4.4 3.6 8 8 8zm340-123a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm239-167.6L935.3 372a8 8 0 0 0-10.9-2.9l-50.7 29.6-78.3-216.2a63.9 63.9 0 0 0-60.9-44.4H301.2c-34.7 0-65.5 22.4-76.2 55.5l-74.6 205.2-50.8-29.6a8 8 0 0 0-10.9 2.9L65 413.4c-2.2 3.8-.9 8.6 2.9 10.8l60.4 35.2-14.5 40c-1.2 3.2-1.8 6.6-1.8 10v348.2c0 15.7 11.8 28.4 26.3 28.4h67.6c12.3 0 23-9.3 25.6-22.3l7.7-37.7h545.6l7.7 37.7c2.7 13 13.3 22.3 25.6 22.3h67.6c14.5 0 26.3-12.7 26.3-28.4V509.4c0-3.4-.6-6.8-1.8-10l-14.5-40 60.3-35.2a8 8 0 0 0 3-10.8zM840 517v237H184V517l15.6-43h624.8l15.6 43zM292.7 218.1l.5-1.3.4-1.3c1.1-3.3 4.1-5.5 7.6-5.5h427.6l75.4 208H220l72.7-199.9zM224 581a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'));
exports.CaretDownOutline = getIcon('caret-down', outline, getNode(normalViewBox, 'M840.4 300H183.6c-19.7 0-30.7 20.8-18.5 35l328.4 380.8c9.4 10.9 27.5 10.9 37 0L858.9 335c12.2-14.2 1.2-35-18.5-35z'));
exports.CaretLeftOutline = getIcon('caret-left', outline, getNode(normalViewBox, 'M689 165.1L308.2 493.5c-10.9 9.4-10.9 27.5 0 37L689 858.9c14.2 12.2 35 1.2 35-18.5V183.6c0-19.7-20.8-30.7-35-18.5z'));
exports.CaretRightOutline = getIcon('caret-right', outline, getNode(normalViewBox, 'M715.8 493.5L335 165.1c-14.2-12.2-35-1.2-35 18.5v656.8c0 19.7 20.8 30.7 35 18.5l380.8-328.4c10.9-9.4 10.9-27.6 0-37z'));
exports.CarryOutOutline = getIcon('carry-out', outline, getNode(newViewBox, 'M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v584zM688 420h-55.2c-5.1 0-10 2.5-13 6.6L468.9 634.4l-64.7-89c-3-4.1-7.8-6.6-13-6.6H336c-6.5 0-10.3 7.4-6.5 12.7l126.4 174a16.1 16.1 0 0 0 26 0l212.6-292.7c3.8-5.4 0-12.8-6.5-12.8z'));
exports.CheckCircleOutline = getIcon('check-circle', outline, getNode(newViewBox, 'M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8a31.8 31.8 0 0 0 51.7 0l210.6-292c3.9-5.3.1-12.7-6.4-12.7z', 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'));
exports.CaretUpOutline = getIcon('caret-up', outline, getNode(normalViewBox, 'M858.9 689L530.5 308.2c-9.4-10.9-27.5-10.9-37 0L165.1 689c-12.2 14.2-1.2 35 18.5 35h656.8c19.7 0 30.7-20.8 18.5-35z'));
exports.CheckSquareOutline = getIcon('check-square', outline, getNode(newViewBox, 'M433.1 657.7a31.8 31.8 0 0 0 51.7 0l210.6-292c3.8-5.3 0-12.7-6.5-12.7H642c-10.2 0-19.9 4.9-25.9 13.3L459 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H315c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8z', 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'));
exports.ChromeOutline = getIcon('chrome', outline, getNode(newViewBox, 'M928 512.3v-.3c0-229.8-186.2-416-416-416S96 282.2 96 512v.4c0 229.8 186.2 416 416 416s416-186.2 416-416v-.3.2zm-6.7-74.6l.6 3.3-.6-3.3zM676.7 638.2c53.5-82.2 52.5-189.4-11.1-263.7l162.4-8.4c20.5 44.4 32 93.8 32 145.9 0 185.2-144.6 336.6-327.1 347.4l143.8-221.2zM512 652.3c-77.5 0-140.2-62.7-140.2-140.2 0-77.7 62.7-140.2 140.2-140.2S652.2 434.5 652.2 512 589.5 652.3 512 652.3zm369.2-331.7l-3-5.7 3 5.7zM512 164c121.3 0 228.2 62.1 290.4 156.2l-263.6-13.9c-97.5-5.7-190.2 49.2-222.3 141.1L227.8 311c63.1-88.9 166.9-147 284.2-147zM102.5 585.8c26 145 127.1 264 261.6 315.1C229.6 850 128.5 731 102.5 585.8zM164 512c0-55.9 13.2-108.7 36.6-155.5l119.7 235.4c44.1 86.7 137.4 139.7 234 121.6l-74 145.1C302.9 842.5 164 693.5 164 512zm324.7 415.4c4 .2 8 .4 12 .5-4-.2-8-.3-12-.5z'));
exports.ClockCircleOutline = getIcon('clock-circle', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z', 'M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.4c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.8 11.2-1.7l28.6-39c2.6-3.7 1.8-8.7-1.8-11.2z'));
exports.CloseCircleOutline = getIcon('close-circle', outline, getNode(newViewBox, 'M685.4 354.8c0-4.4-3.6-8-8-8l-66 .3L512 465.6l-99.3-118.4-66.1-.3c-4.4 0-8 3.5-8 8 0 1.9.7 3.7 1.9 5.2l130.1 155L340.5 670a8.32 8.32 0 0 0-1.9 5.2c0 4.4 3.6 8 8 8l66.1-.3L512 564.4l99.3 118.4 66 .3c4.4 0 8-3.5 8-8 0-1.9-.7-3.7-1.9-5.2L553.5 515l130.1-155c1.2-1.4 1.8-3.3 1.8-5.2z', 'M512 65C264.6 65 64 265.6 64 513s200.6 448 448 448 448-200.6 448-448S759.4 65 512 65zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'));
exports.CloudOutline = getIcon('cloud', outline, getNode(newViewBox, 'M811.4 418.7C765.6 297.9 648.9 212 512.2 212S258.8 297.8 213 418.6C127.3 441.1 64 519.1 64 612c0 110.5 89.5 200 199.9 200h496.2C870.5 812 960 722.5 960 612c0-92.7-63.1-170.7-148.6-193.3zm36.3 281a123.07 123.07 0 0 1-87.6 36.3H263.9c-33.1 0-64.2-12.9-87.6-36.3A123.3 123.3 0 0 1 140 612c0-28 9.1-54.3 26.2-76.3a125.7 125.7 0 0 1 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0 1 52.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10c54.3 14.5 92.1 63.8 92.1 120 0 33.1-12.9 64.3-36.3 87.7z'));
exports.CloseSquareOutline = getIcon('close-square', outline, getNode(newViewBox, 'M354 671h58.9c4.7 0 9.2-2.1 12.3-5.7L512 561.8l86.8 103.5c3 3.6 7.5 5.7 12.3 5.7H670c6.8 0 10.5-7.9 6.1-13.1L553.8 512l122.4-145.9c4.4-5.2.7-13.1-6.1-13.1h-58.9c-4.7 0-9.2 2.1-12.3 5.7L512 462.2l-86.8-103.5c-3-3.6-7.5-5.7-12.3-5.7H354c-6.8 0-10.5 7.9-6.1 13.1L470.2 512 347.9 657.9A7.95 7.95 0 0 0 354 671z', 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'));
exports.CodeOutline = getIcon('code', outline, getNode(newViewBox, 'M516 673c0 4.4 3.4 8 7.5 8h185c4.1 0 7.5-3.6 7.5-8v-48c0-4.4-3.4-8-7.5-8h-185c-4.1 0-7.5 3.6-7.5 8v48zm-194.9 6.1l192-161c3.8-3.2 3.8-9.1 0-12.3l-192-160.9A7.95 7.95 0 0 0 308 351v62.7c0 2.4 1 4.6 2.9 6.1L420.7 512l-109.8 92.2a8.1 8.1 0 0 0-2.9 6.1V673c0 6.8 7.9 10.5 13.1 6.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'));
exports.CodepenCircleOutline = getIcon('codepen-circle', outline, getNode(newViewBox, 'M488.1 414.7V303.4L300.9 428l83.6 55.8zm254.1 137.7v-79.8l-59.8 39.9zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm278 533c0 1.1-.1 2.1-.2 3.1 0 .4-.1.7-.2 1a14.16 14.16 0 0 1-.8 3.2c-.2.6-.4 1.2-.6 1.7-.2.4-.4.8-.5 1.2-.3.5-.5 1.1-.8 1.6-.2.4-.4.7-.7 1.1-.3.5-.7 1-1 1.5-.3.4-.5.7-.8 1-.4.4-.8.9-1.2 1.3-.3.3-.6.6-1 .9-.4.4-.9.8-1.4 1.1-.4.3-.7.6-1.1.8-.1.1-.3.2-.4.3L525.2 786c-4 2.7-8.6 4-13.2 4-4.7 0-9.3-1.4-13.3-4L244.6 616.9c-.1-.1-.3-.2-.4-.3l-1.1-.8c-.5-.4-.9-.7-1.3-1.1-.3-.3-.6-.6-1-.9-.4-.4-.8-.8-1.2-1.3a7 7 0 0 1-.8-1c-.4-.5-.7-1-1-1.5-.2-.4-.5-.7-.7-1.1-.3-.5-.6-1.1-.8-1.6-.2-.4-.4-.8-.5-1.2-.2-.6-.4-1.2-.6-1.7-.1-.4-.3-.8-.4-1.2-.2-.7-.3-1.3-.4-2-.1-.3-.1-.7-.2-1-.1-1-.2-2.1-.2-3.1V427.9c0-1 .1-2.1.2-3.1.1-.3.1-.7.2-1a14.16 14.16 0 0 1 .8-3.2c.2-.6.4-1.2.6-1.7.2-.4.4-.8.5-1.2.2-.5.5-1.1.8-1.6.2-.4.4-.7.7-1.1.6-.9 1.2-1.7 1.8-2.5.4-.4.8-.9 1.2-1.3.3-.3.6-.6 1-.9.4-.4.9-.8 1.3-1.1.4-.3.7-.6 1.1-.8.1-.1.3-.2.4-.3L498.7 239c8-5.3 18.5-5.3 26.5 0l254.1 169.1c.1.1.3.2.4.3l1.1.8 1.4 1.1c.3.3.6.6 1 .9.4.4.8.8 1.2 1.3.7.8 1.3 1.6 1.8 2.5.2.4.5.7.7 1.1.3.5.6 1 .8 1.6.2.4.4.8.5 1.2.2.6.4 1.2.6 1.7.1.4.3.8.4 1.2.2.7.3 1.3.4 2 .1.3.1.7.2 1 .1 1 .2 2.1.2 3.1V597zm-254.1 13.3v111.3L723.1 597l-83.6-55.8zM281.8 472.6v79.8l59.8-39.9zM512 456.1l-84.5 56.4 84.5 56.4 84.5-56.4zM723.1 428L535.9 303.4v111.3l103.6 69.1zM384.5 541.2L300.9 597l187.2 124.6V610.3l-103.6-69.1z'));
exports.CompassOutline = getIcon('compass', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm198.4-588.1a32 32 0 0 0-24.5.5L414.9 415 296.4 686c-3.6 8.2-3.6 17.5 0 25.7 3.4 7.8 9.7 13.9 17.7 17 3.8 1.5 7.7 2.2 11.7 2.2 4.4 0 8.7-.9 12.8-2.7l271-118.6 118.5-271a32.06 32.06 0 0 0-17.7-42.7zM576.8 534.4l26.2 26.2-42.4 42.4-26.2-26.2L380 644.4 447.5 490 422 464.4l42.4-42.4 25.5 25.5L644.4 380l-67.6 154.4zM464.4 422L422 464.4l25.5 25.6 86.9 86.8 26.2 26.2 42.4-42.4-26.2-26.2-86.8-86.9z'));
exports.ContactsOutline = getIcon('contacts', outline, getNode(newViewBox, 'M594.3 601.5a111.8 111.8 0 0 0 29.1-75.5c0-61.9-49.9-112-111.4-112s-111.4 50.1-111.4 112c0 29.1 11 55.5 29.1 75.5a158.09 158.09 0 0 0-74.6 126.1 8 8 0 0 0 8 8.4H407c4.2 0 7.6-3.3 7.9-7.5 3.8-50.6 46-90.5 97.2-90.5s93.4 40 97.2 90.5c.3 4.2 3.7 7.5 7.9 7.5H661a8 8 0 0 0 8-8.4c-2.8-53.3-32-99.7-74.7-126.1zM512 578c-28.5 0-51.7-23.3-51.7-52s23.2-52 51.7-52 51.7 23.3 51.7 52-23.2 52-51.7 52zm416-354H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zm-40 568H136V296h120v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h120v496z'));
exports.ContainerOutline = getIcon('container', outline, getNode(newViewBox, 'M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V687h97.9c11.6 32.8 32 62.3 59.1 84.7 34.5 28.5 78.2 44.3 123 44.3s88.5-15.7 123-44.3c27.1-22.4 47.5-51.9 59.1-84.7H792v-63H643.6l-5.2 24.7C626.4 708.5 573.2 752 512 752s-114.4-43.5-126.5-103.3l-5.2-24.7H232V136h560v752zM320 341h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0 160h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z'));
exports.ControlOutline = getIcon('control', outline, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656zM340 683v77c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-77c-10.1 3.3-20.8 5-32 5s-21.9-1.8-32-5zm64-198V264c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v221c10.1-3.3 20.8-5 32-5s21.9 1.8 32 5zm-64 198c10.1 3.3 20.8 5 32 5s21.9-1.8 32-5c41.8-13.5 72-52.7 72-99s-30.2-85.5-72-99c-10.1-3.3-20.8-5-32-5s-21.9 1.8-32 5c-41.8 13.5-72 52.7-72 99s30.2 85.5 72 99zm.1-115.7c.3-.6.7-1.2 1-1.8v-.1l1.2-1.8c.1-.2.2-.3.3-.5.3-.5.7-.9 1-1.4.1-.1.2-.3.3-.4.5-.6.9-1.1 1.4-1.6l.3-.3 1.2-1.2.4-.4c.5-.5 1-.9 1.6-1.4.6-.5 1.1-.9 1.7-1.3.2-.1.3-.2.5-.3.5-.3.9-.7 1.4-1 .1-.1.3-.2.4-.3.6-.4 1.2-.7 1.9-1.1.1-.1.3-.1.4-.2.5-.3 1-.5 1.6-.8l.6-.3c.7-.3 1.3-.6 2-.8.7-.3 1.4-.5 2.1-.7.2-.1.4-.1.6-.2.6-.2 1.1-.3 1.7-.4.2 0 .3-.1.5-.1.7-.2 1.5-.3 2.2-.4.2 0 .3 0 .5-.1.6-.1 1.2-.1 1.8-.2h.6c.8 0 1.5-.1 2.3-.1s1.5 0 2.3.1h.6c.6 0 1.2.1 1.8.2.2 0 .3 0 .5.1.7.1 1.5.2 2.2.4.2 0 .3.1.5.1.6.1 1.2.3 1.7.4.2.1.4.1.6.2.7.2 1.4.4 2.1.7.7.2 1.3.5 2 .8l.6.3c.5.2 1.1.5 1.6.8.1.1.3.1.4.2.6.3 1.3.7 1.9 1.1.1.1.3.2.4.3.5.3 1 .6 1.4 1 .2.1.3.2.5.3.6.4 1.2.9 1.7 1.3s1.1.9 1.6 1.4l.4.4 1.2 1.2.3.3c.5.5 1 1.1 1.4 1.6.1.1.2.3.3.4.4.4.7.9 1 1.4.1.2.2.3.3.5l1.2 1.8s0 .1.1.1a36.18 36.18 0 0 1 5.1 18.5c0 6-1.5 11.7-4.1 16.7-.3.6-.7 1.2-1 1.8 0 0 0 .1-.1.1l-1.2 1.8c-.1.2-.2.3-.3.5-.3.5-.7.9-1 1.4-.1.1-.2.3-.3.4-.5.6-.9 1.1-1.4 1.6l-.3.3-1.2 1.2-.4.4c-.5.5-1 .9-1.6 1.4-.6.5-1.1.9-1.7 1.3-.2.1-.3.2-.5.3-.5.3-.9.7-1.4 1-.1.1-.3.2-.4.3-.6.4-1.2.7-1.9 1.1-.1.1-.3.1-.4.2-.5.3-1 .5-1.6.8l-.6.3c-.7.3-1.3.6-2 .8-.7.3-1.4.5-2.1.7-.2.1-.4.1-.6.2-.6.2-1.1.3-1.7.4-.2 0-.3.1-.5.1-.7.2-1.5.3-2.2.4-.2 0-.3 0-.5.1-.6.1-1.2.1-1.8.2h-.6c-.8 0-1.5.1-2.3.1s-1.5 0-2.3-.1h-.6c-.6 0-1.2-.1-1.8-.2-.2 0-.3 0-.5-.1-.7-.1-1.5-.2-2.2-.4-.2 0-.3-.1-.5-.1-.6-.1-1.2-.3-1.7-.4-.2-.1-.4-.1-.6-.2-.7-.2-1.4-.4-2.1-.7-.7-.2-1.3-.5-2-.8l-.6-.3c-.5-.2-1.1-.5-1.6-.8-.1-.1-.3-.1-.4-.2-.6-.3-1.3-.7-1.9-1.1-.1-.1-.3-.2-.4-.3-.5-.3-1-.6-1.4-1-.2-.1-.3-.2-.5-.3-.6-.4-1.2-.9-1.7-1.3s-1.1-.9-1.6-1.4l-.4-.4-1.2-1.2-.3-.3c-.5-.5-1-1.1-1.4-1.6-.1-.1-.2-.3-.3-.4-.4-.4-.7-.9-1-1.4-.1-.2-.2-.3-.3-.5l-1.2-1.8v-.1c-.4-.6-.7-1.2-1-1.8-2.6-5-4.1-10.7-4.1-16.7s1.5-11.7 4.1-16.7zM620 539v221c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V539c-10.1 3.3-20.8 5-32 5s-21.9-1.8-32-5zm64-198v-77c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v77c10.1-3.3 20.8-5 32-5s21.9 1.8 32 5zm-64 198c10.1 3.3 20.8 5 32 5s21.9-1.8 32-5c41.8-13.5 72-52.7 72-99s-30.2-85.5-72-99c-10.1-3.3-20.8-5-32-5s-21.9 1.8-32 5c-41.8 13.5-72 52.7-72 99s30.2 85.5 72 99zm.1-115.7c.3-.6.7-1.2 1-1.8v-.1l1.2-1.8c.1-.2.2-.3.3-.5.3-.5.7-.9 1-1.4.1-.1.2-.3.3-.4.5-.6.9-1.1 1.4-1.6l.3-.3 1.2-1.2.4-.4c.5-.5 1-.9 1.6-1.4.6-.5 1.1-.9 1.7-1.3.2-.1.3-.2.5-.3.5-.3.9-.7 1.4-1 .1-.1.3-.2.4-.3.6-.4 1.2-.7 1.9-1.1.1-.1.3-.1.4-.2.5-.3 1-.5 1.6-.8l.6-.3c.7-.3 1.3-.6 2-.8.7-.3 1.4-.5 2.1-.7.2-.1.4-.1.6-.2.6-.2 1.1-.3 1.7-.4.2 0 .3-.1.5-.1.7-.2 1.5-.3 2.2-.4.2 0 .3 0 .5-.1.6-.1 1.2-.1 1.8-.2h.6c.8 0 1.5-.1 2.3-.1s1.5 0 2.3.1h.6c.6 0 1.2.1 1.8.2.2 0 .3 0 .5.1.7.1 1.5.2 2.2.4.2 0 .3.1.5.1.6.1 1.2.3 1.7.4.2.1.4.1.6.2.7.2 1.4.4 2.1.7.7.2 1.3.5 2 .8l.6.3c.5.2 1.1.5 1.6.8.1.1.3.1.4.2.6.3 1.3.7 1.9 1.1.1.1.3.2.4.3.5.3 1 .6 1.4 1 .2.1.3.2.5.3.6.4 1.2.9 1.7 1.3s1.1.9 1.6 1.4l.4.4 1.2 1.2.3.3c.5.5 1 1.1 1.4 1.6.1.1.2.3.3.4.4.4.7.9 1 1.4.1.2.2.3.3.5l1.2 1.8v.1a36.18 36.18 0 0 1 5.1 18.5c0 6-1.5 11.7-4.1 16.7-.3.6-.7 1.2-1 1.8v.1l-1.2 1.8c-.1.2-.2.3-.3.5-.3.5-.7.9-1 1.4-.1.1-.2.3-.3.4-.5.6-.9 1.1-1.4 1.6l-.3.3-1.2 1.2-.4.4c-.5.5-1 .9-1.6 1.4-.6.5-1.1.9-1.7 1.3-.2.1-.3.2-.5.3-.5.3-.9.7-1.4 1-.1.1-.3.2-.4.3-.6.4-1.2.7-1.9 1.1-.1.1-.3.1-.4.2-.5.3-1 .5-1.6.8l-.6.3c-.7.3-1.3.6-2 .8-.7.3-1.4.5-2.1.7-.2.1-.4.1-.6.2-.6.2-1.1.3-1.7.4-.2 0-.3.1-.5.1-.7.2-1.5.3-2.2.4-.2 0-.3 0-.5.1-.6.1-1.2.1-1.8.2h-.6c-.8 0-1.5.1-2.3.1s-1.5 0-2.3-.1h-.6c-.6 0-1.2-.1-1.8-.2-.2 0-.3 0-.5-.1-.7-.1-1.5-.2-2.2-.4-.2 0-.3-.1-.5-.1-.6-.1-1.2-.3-1.7-.4-.2-.1-.4-.1-.6-.2-.7-.2-1.4-.4-2.1-.7-.7-.2-1.3-.5-2-.8l-.6-.3c-.5-.2-1.1-.5-1.6-.8-.1-.1-.3-.1-.4-.2-.6-.3-1.3-.7-1.9-1.1-.1-.1-.3-.2-.4-.3-.5-.3-1-.6-1.4-1-.2-.1-.3-.2-.5-.3-.6-.4-1.2-.9-1.7-1.3s-1.1-.9-1.6-1.4l-.4-.4-1.2-1.2-.3-.3c-.5-.5-1-1.1-1.4-1.6-.1-.1-.2-.3-.3-.4-.4-.4-.7-.9-1-1.4-.1-.2-.2-.3-.3-.5l-1.2-1.8v-.1c-.4-.6-.7-1.2-1-1.8-2.6-5-4.1-10.7-4.1-16.7s1.5-11.7 4.1-16.7z'));
exports.CopyOutline = getIcon('copy', outline, getNode(newViewBox, 'M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32zM704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z'));
exports.CreditCardOutline = getIcon('credit-card', outline, getNode(newViewBox, 'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-792 72h752v120H136V232zm752 560H136V440h752v352zm-237-64h165c4.4 0 8-3.6 8-8v-72c0-4.4-3.6-8-8-8H651c-4.4 0-8 3.6-8 8v72c0 4.4 3.6 8 8 8z'));
exports.CrownOutline = getIcon('crown', outline, getNode(newViewBox, 'M899.6 276.5L705 396.4 518.4 147.5a8.06 8.06 0 0 0-12.9 0L319 396.4 124.3 276.5c-5.7-3.5-13.1 1.2-12.2 7.9L188.5 865c1.1 7.9 7.9 14 16 14h615.1c8 0 14.9-6 15.9-14l76.4-580.6c.8-6.7-6.5-11.4-12.3-7.9zm-126 534.1H250.3l-53.8-409.4 139.8 86.1L512 252.9l175.7 234.4 139.8-86.1-53.9 409.4zM512 509c-62.1 0-112.6 50.5-112.6 112.6S449.9 734.2 512 734.2s112.6-50.5 112.6-112.6S574.1 509 512 509zm0 160.9c-26.6 0-48.2-21.6-48.2-48.3 0-26.6 21.6-48.3 48.2-48.3s48.2 21.6 48.2 48.3c0 26.6-21.6 48.3-48.2 48.3z'));
exports.CustomerServiceOutline = getIcon('customer-service', outline, getNode(newViewBox, 'M512 128c-212.1 0-384 171.9-384 384v360c0 13.3 10.7 24 24 24h184c35.3 0 64-28.7 64-64V624c0-35.3-28.7-64-64-64H200v-48c0-172.3 139.7-312 312-312s312 139.7 312 312v48H688c-35.3 0-64 28.7-64 64v208c0 35.3 28.7 64 64 64h184c13.3 0 24-10.7 24-24V512c0-212.1-171.9-384-384-384zM328 632v192H200V632h128zm496 192H696V632h128v192z'));
exports.DashboardOutline = getIcon('dashboard', outline, getNode(newViewBox, 'M924.8 385.6a446.7 446.7 0 0 0-96-142.4 446.7 446.7 0 0 0-142.4-96C631.1 123.8 572.5 112 512 112s-119.1 11.8-174.4 35.2a446.7 446.7 0 0 0-142.4 96 446.7 446.7 0 0 0-96 142.4C75.8 440.9 64 499.5 64 560c0 132.7 58.3 257.7 159.9 343.1l1.7 1.4c5.8 4.8 13.1 7.5 20.6 7.5h531.7c7.5 0 14.8-2.7 20.6-7.5l1.7-1.4C901.7 817.7 960 692.7 960 560c0-60.5-11.9-119.1-35.2-174.4zM761.4 836H262.6A371.12 371.12 0 0 1 140 560c0-99.4 38.7-192.8 109-263 70.3-70.3 163.7-109 263-109 99.4 0 192.8 38.7 263 109 70.3 70.3 109 163.7 109 263 0 105.6-44.5 205.5-122.6 276zM623.5 421.5a8.03 8.03 0 0 0-11.3 0L527.7 506c-18.7-5-39.4-.2-54.1 14.5a55.95 55.95 0 0 0 0 79.2 55.95 55.95 0 0 0 79.2 0 55.87 55.87 0 0 0 14.5-54.1l84.5-84.5c3.1-3.1 3.1-8.2 0-11.3l-28.3-28.3zM490 320h44c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8h-44c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8zm260 218v44c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-44c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8zm12.7-197.2l-31.1-31.1a8.03 8.03 0 0 0-11.3 0l-56.6 56.6a8.03 8.03 0 0 0 0 11.3l31.1 31.1c3.1 3.1 8.2 3.1 11.3 0l56.6-56.6c3.1-3.1 3.1-8.2 0-11.3zm-458.6-31.1a8.03 8.03 0 0 0-11.3 0l-31.1 31.1a8.03 8.03 0 0 0 0 11.3l56.6 56.6c3.1 3.1 8.2 3.1 11.3 0l31.1-31.1c3.1-3.1 3.1-8.2 0-11.3l-56.6-56.6zM262 530h-80c-4.4 0-8 3.6-8 8v44c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-44c0-4.4-3.6-8-8-8z'));
exports.DeleteOutline = getIcon('delete', outline, getNode(newViewBox, 'M360 184h-8c4.4 0 8-3.6 8-8v8h304v-8c0 4.4 3.6 8 8 8h-8v72h72v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80h72v-72zm504 72H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM731.3 840H292.7l-24.2-512h487l-24.2 512z'));
exports.DiffOutline = getIcon('diff', outline, getNode(newViewBox, 'M476 399.1c0-3.9-3.1-7.1-7-7.1h-42c-3.8 0-7 3.2-7 7.1V484h-84.5c-4.1 0-7.5 3.1-7.5 7v42c0 3.8 3.4 7 7.5 7H420v84.9c0 3.9 3.2 7.1 7 7.1h42c3.9 0 7-3.2 7-7.1V540h84.5c4.1 0 7.5-3.2 7.5-7v-42c0-3.9-3.4-7-7.5-7H476v-84.9zM560.5 704h-225c-4.1 0-7.5 3.2-7.5 7v42c0 3.8 3.4 7 7.5 7h225c4.1 0 7.5-3.2 7.5-7v-42c0-3.8-3.4-7-7.5-7zm-7.1-502.6c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v704c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32V397.3c0-8.5-3.4-16.6-9.4-22.6L553.4 201.4zM664 888H232V264h282.2L664 413.8V888zm190.2-581.4L611.3 72.9c-6-5.7-13.9-8.9-22.2-8.9H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h277l219 210.6V824c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V329.6c0-8.7-3.5-17-9.8-23z'));
exports.DatabaseOutline = getIcon('database', outline, getNode(newViewBox, 'M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-600 72h560v208H232V136zm560 480H232V408h560v208zm0 272H232V680h560v208zM304 240a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0 272a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0 272a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'));
exports.DislikeOutline = getIcon('dislike', outline, getNode(newViewBox, 'M885.9 490.3c3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-51.6-30.7-98.1-78.3-118.4a66.1 66.1 0 0 0-26.5-5.4H144c-17.7 0-32 14.3-32 32v364c0 17.7 14.3 32 32 32h129.3l85.8 310.8C372.9 889 418.9 924 470.9 924c29.7 0 57.4-11.8 77.9-33.4 20.5-21.5 31-49.7 29.5-79.4l-6-122.9h239.9c12.1 0 23.9-3.2 34.3-9.3 40.4-23.5 65.5-66.1 65.5-111 0-28.3-9.3-55.5-26.1-77.7zM184 456V172h81v284h-81zm627.2 160.4H496.8l9.6 198.4c.6 11.9-4.7 23.1-14.6 30.5-6.1 4.5-13.6 6.8-21.1 6.7a44.28 44.28 0 0 1-42.2-32.3L329 459.2V172h415.4a56.85 56.85 0 0 1 33.6 51.8c0 9.7-2.3 18.9-6.9 27.3l-13.9 25.4 21.9 19a56.76 56.76 0 0 1 19.6 43c0 9.7-2.3 18.9-6.9 27.3l-13.9 25.4 21.9 19a56.76 56.76 0 0 1 19.6 43c0 9.7-2.3 18.9-6.9 27.3l-14 25.5 21.9 19a56.76 56.76 0 0 1 19.6 43c0 19.1-11 37.5-28.8 48.4z'));
exports.DownCircleOutline = getIcon('down-circle', outline, getNode(newViewBox, 'M690 405h-46.9c-10.2 0-19.9 4.9-25.9 13.2L512 563.6 406.8 418.2c-6-8.3-15.6-13.2-25.9-13.2H334c-6.5 0-10.3 7.4-6.5 12.7l178 246c3.2 4.4 9.7 4.4 12.9 0l178-246c3.9-5.3.1-12.7-6.4-12.7z', 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'));
exports.DownSquareOutline = getIcon('down-square', outline, getNode(newViewBox, 'M505.5 658.7c3.2 4.4 9.7 4.4 12.9 0l178-246c3.8-5.3 0-12.7-6.5-12.7H643c-10.2 0-19.9 4.9-25.9 13.2L512 558.6 406.8 413.2c-6-8.3-15.6-13.2-25.9-13.2H334c-6.5 0-10.3 7.4-6.5 12.7l178 246z', 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'));
exports.DribbbleSquareOutline = getIcon('dribbble-square', outline, getNode(newViewBox, 'M498.6 432c-40.8-72.5-84.7-133.4-91.2-142.3-68.8 32.5-120.3 95.9-136.2 172.2 11 .2 112.4.7 227.4-29.9zm66.5 21.8c5.7 11.7 11.2 23.6 16.3 35.6 1.8 4.2 3.6 8.4 5.3 12.7 81.8-10.3 163.2 6.2 171.3 7.9-.5-58.1-21.3-111.4-55.5-153.3-5.3 7.1-46.5 60-137.4 97.1zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM512 800c-158.8 0-288-129.2-288-288s129.2-288 288-288 288 129.2 288 288-129.2 288-288 288zm89.7-259.1c32.2 88.4 45.3 160.4 47.8 175.4 55.2-37.3 94.5-96.4 105.4-164.9-8.4-2.6-76.1-22.8-153.2-10.5zm-72.5-26.4c3.2-1 6.4-2 9.7-2.9-6.2-14-12.9-28-19.9-41.7-122.8 36.8-242.1 35.2-252.8 35-.1 2.5-.1 5-.1 7.5 0 63.2 23.9 120.9 63.2 164.5 5.5-9.6 73-121.4 199.9-162.4zm145.9-186.2a245.2 245.2 0 0 0-220.8-55.1c6.8 9.1 51.5 69.9 91.8 144 87.5-32.8 124.5-82.6 129-88.9zM554 552.8c-138.7 48.3-188.6 144.6-193 153.6 41.7 32.5 94.1 51.9 151 51.9 34.1 0 66.6-6.9 96.1-19.5-3.7-21.6-17.9-96.8-52.5-186.6l-1.6.6z'));
exports.EnvironmentOutline = getIcon('environment', outline, getNode(newViewBox, 'M854.6 289.1a362.49 362.49 0 0 0-79.9-115.7 370.83 370.83 0 0 0-118.2-77.8C610.7 76.6 562.1 67 512 67c-50.1 0-98.7 9.6-144.5 28.5-44.3 18.3-84 44.5-118.2 77.8A363.6 363.6 0 0 0 169.4 289c-19.5 45-29.4 92.8-29.4 142 0 70.6 16.9 140.9 50.1 208.7 26.7 54.5 64 107.6 111 158.1 80.3 86.2 164.5 138.9 188.4 153a43.9 43.9 0 0 0 22.4 6.1c7.8 0 15.5-2 22.4-6.1 23.9-14.1 108.1-66.8 188.4-153 47-50.4 84.3-103.6 111-158.1C867.1 572 884 501.8 884 431.1c0-49.2-9.9-97-29.4-142zM512 880.2c-65.9-41.9-300-207.8-300-449.1 0-77.9 31.1-151.1 87.6-206.3C356.3 169.5 431.7 139 512 139s155.7 30.5 212.4 85.9C780.9 280 812 353.2 812 431.1c0 241.3-234.1 407.2-300 449.1zm0-617.2c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm79.2 255.2A111.6 111.6 0 0 1 512 551c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 0 1 400 439c0-29.9 11.7-58 32.8-79.2C454 338.6 482.1 327 512 327c29.9 0 58 11.6 79.2 32.8C612.4 381 624 409.1 624 439c0 29.9-11.6 58-32.8 79.2z'));
exports.EditOutline = getIcon('edit', outline, getNode(newViewBox, 'M257.7 752c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 0 0 0-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 0 0 9.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89zM880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32z'));
exports.ExclamationCircleOutline = getIcon('exclamation-circle', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z', 'M464 688a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm24-112h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8z'));
exports.ExperimentOutline = getIcon('experiment', outline, getNode(newViewBox, 'M512 472a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm367 352.9L696.3 352V178H768v-68H256v68h71.7v174L145 824.9c-2.8 7.4-4.3 15.2-4.3 23.1 0 35.3 28.7 64 64 64h614.6c7.9 0 15.7-1.5 23.1-4.3 33-12.7 49.4-49.8 36.6-82.8zM395.7 364.7V180h232.6v184.7L719.2 600c-20.7-5.3-42.1-8-63.9-8-61.2 0-119.2 21.5-165.3 60a188.78 188.78 0 0 1-121.3 43.9c-32.7 0-64.1-8.3-91.8-23.7l118.8-307.5zM210.5 844l41.7-107.8c35.7 18.1 75.4 27.8 116.6 27.8 61.2 0 119.2-21.5 165.3-60 33.9-28.2 76.3-43.9 121.3-43.9 35 0 68.4 9.5 97.6 27.1L813.5 844h-603z'));
exports.EyeInvisibleOutline = getIcon('eye-invisible', outline, getNode(newViewBox, 'M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 0 0 0-51.5zm-63.57-320.64L836 122.88a8 8 0 0 0-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 0 0 0 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 0 0 0 11.31L155.17 889a8 8 0 0 0 11.31 0l712.15-712.12a8 8 0 0 0 0-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 0 0-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 0 1 146.2-106.69L401.31 546.2A112 112 0 0 1 396 512z', 'M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 0 0 227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 0 1-112 112z'));
exports.EyeOutline = getIcon('eye', outline, getNode(newViewBox, 'M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 0 0 0 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258c161.3 0 279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766zm-4-430c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z'));
exports.FacebookOutline = getIcon('facebook', outline, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-32 736H663.9V602.2h104l15.6-120.7H663.9v-77.1c0-35 9.7-58.8 59.8-58.8h63.9v-108c-11.1-1.5-49-4.8-93.2-4.8-92.2 0-155.3 56.3-155.3 159.6v89H434.9v120.7h104.3V848H176V176h672v672z'));
exports.FastBackwardOutline = getIcon('fast-backward', outline, getNode(normalViewBox, 'M517.6 273.5L230.2 499.3a16.14 16.14 0 0 0 0 25.4l287.4 225.8c10.7 8.4 26.4.8 26.4-12.7V286.2c0-13.5-15.7-21.1-26.4-12.7zm320 0L550.2 499.3a16.14 16.14 0 0 0 0 25.4l287.4 225.8c10.7 8.4 26.4.8 26.4-12.7V286.2c0-13.5-15.7-21.1-26.4-12.7zm-620-25.5h-51.2c-3.5 0-6.4 2.7-6.4 6v516c0 3.3 2.9 6 6.4 6h51.2c3.5 0 6.4-2.7 6.4-6V254c0-3.3-2.9-6-6.4-6z'));
exports.FastForwardOutline = getIcon('fast-forward', outline, getNode(normalViewBox, 'M793.8 499.3L506.4 273.5c-10.7-8.4-26.4-.8-26.4 12.7v451.6c0 13.5 15.7 21.1 26.4 12.7l287.4-225.8a16.14 16.14 0 0 0 0-25.4zm-320 0L186.4 273.5c-10.7-8.4-26.4-.8-26.4 12.7v451.5c0 13.5 15.7 21.1 26.4 12.7l287.4-225.8c4.1-3.2 6.2-8 6.2-12.7 0-4.6-2.1-9.4-6.2-12.6zM857.6 248h-51.2c-3.5 0-6.4 2.7-6.4 6v516c0 3.3 2.9 6 6.4 6h51.2c3.5 0 6.4-2.7 6.4-6V254c0-3.3-2.9-6-6.4-6z'));
exports.FileAddOutline = getIcon('file-add', outline, getNode(newViewBox, 'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM544 472c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v108H372c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h108v108c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V644h108c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V472z'));
exports.FileExcelOutline = getIcon('file-excel', outline, getNode(newViewBox, 'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM514.1 580.1l-61.8-102.4c-2.2-3.6-6.1-5.8-10.3-5.8h-38.4c-2.3 0-4.5.6-6.4 1.9-5.6 3.5-7.3 10.9-3.7 16.6l82.3 130.4-83.4 132.8a12.04 12.04 0 0 0 10.2 18.4h34.5c4.2 0 8-2.2 10.2-5.7L510 664.8l62.3 101.4c2.2 3.6 6.1 5.7 10.2 5.7H620c2.3 0 4.5-.7 6.5-1.9 5.6-3.6 7.2-11 3.6-16.6l-84-130.4 85.3-132.5a12.04 12.04 0 0 0-10.1-18.5h-35.7c-4.2 0-8.1 2.2-10.3 5.8l-61.2 102.3z'));
exports.FileExclamationOutline = getIcon('file-exclamation', outline, getNode(newViewBox, 'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM472 744a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm16-104h48c4.4 0 8-3.6 8-8V448c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v184c0 4.4 3.6 8 8 8z'));
exports.FileImageOutline = getIcon('file-image', outline, getNode(newViewBox, 'M553.1 509.1l-77.8 99.2-41.1-52.4a8 8 0 0 0-12.6 0l-99.8 127.2a7.98 7.98 0 0 0 6.3 12.9H696c6.7 0 10.4-7.7 6.3-12.9l-136.5-174a8.1 8.1 0 0 0-12.7 0zM360 442a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm494.6-153.4L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494z'));
exports.FileMarkdownOutline = getIcon('file-markdown', outline, getNode(newViewBox, 'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM429 481.2c-1.9-4.4-6.2-7.2-11-7.2h-35c-6.6 0-12 5.4-12 12v272c0 6.6 5.4 12 12 12h27.1c6.6 0 12-5.4 12-12V582.1l66.8 150.2a12 12 0 0 0 11 7.1H524c4.7 0 9-2.8 11-7.1l66.8-150.6V758c0 6.6 5.4 12 12 12H641c6.6 0 12-5.4 12-12V486c0-6.6-5.4-12-12-12h-34.7c-4.8 0-9.1 2.8-11 7.2l-83.1 191-83.2-191z'));
exports.FilePptOutline = getIcon('file-ppt', outline, getNode(newViewBox, 'M424 476c-4.4 0-8 3.6-8 8v276c0 4.4 3.6 8 8 8h32.5c4.4 0 8-3.6 8-8v-95.5h63.3c59.4 0 96.2-38.9 96.2-94.1 0-54.5-36.3-94.3-96-94.3H424zm150.6 94.3c0 43.4-26.5 54.3-71.2 54.3h-38.9V516.2h56.2c33.8 0 53.9 19.7 53.9 54.1zm280-281.7L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494z'));
exports.FileTextOutline = getIcon('file-text', outline, getNode(newViewBox, 'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM504 618H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM312 490v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8z'));
exports.FilePdfOutline = getIcon('file-pdf', outline, getNode(newViewBox, 'M531.3 574.4l.3-1.4c5.8-23.9 13.1-53.7 7.4-80.7-3.8-21.3-19.5-29.6-32.9-30.2-15.8-.7-29.9 8.3-33.4 21.4-6.6 24-.7 56.8 10.1 98.6-13.6 32.4-35.3 79.5-51.2 107.5-29.6 15.3-69.3 38.9-75.2 68.7-1.2 5.5.2 12.5 3.5 18.8 3.7 7 9.6 12.4 16.5 15 3 1.1 6.6 2 10.8 2 17.6 0 46.1-14.2 84.1-79.4 5.8-1.9 11.8-3.9 17.6-5.9 27.2-9.2 55.4-18.8 80.9-23.1 28.2 15.1 60.3 24.8 82.1 24.8 21.6 0 30.1-12.8 33.3-20.5 5.6-13.5 2.9-30.5-6.2-39.6-13.2-13-45.3-16.4-95.3-10.2-24.6-15-40.7-35.4-52.4-65.8zM421.6 726.3c-13.9 20.2-24.4 30.3-30.1 34.7 6.7-12.3 19.8-25.3 30.1-34.7zm87.6-235.5c5.2 8.9 4.5 35.8.5 49.4-4.9-19.9-5.6-48.1-2.7-51.4.8.1 1.5.7 2.2 2zm-1.6 120.5c10.7 18.5 24.2 34.4 39.1 46.2-21.6 4.9-41.3 13-58.9 20.2-4.2 1.7-8.3 3.4-12.3 5 13.3-24.1 24.4-51.4 32.1-71.4zm155.6 65.5c.1.2.2.5-.4.9h-.2l-.2.3c-.8.5-9 5.3-44.3-8.6 40.6-1.9 45 7.3 45.1 7.4zm191.4-388.2L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494z'));
exports.FileZipOutline = getIcon('file-zip', outline, getNode(newViewBox, 'M296 392h64v64h-64zm0 190v160h128V582h-64v-62h-64v62zm80 48v64h-32v-64h32zm-16-302h64v64h-64zm-64-64h64v64h-64zm64 192h64v64h-64zm0-256h64v64h-64zm494.6 88.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h64v64h64v-64h174v216a42 42 0 0 0 42 42h216v494z'));
exports.FileOutline = getIcon('file', outline, getNode(newViewBox, 'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494z'));
exports.FilterOutline = getIcon('filter', outline, getNode(newViewBox, 'M880.1 154H143.9c-24.5 0-39.8 26.7-27.5 48L349 597.4V838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V597.4L907.7 202c12.2-21.3-3.1-48-27.6-48zM603.4 798H420.6V642h182.9v156zm9.6-236.6l-9.5 16.6h-183l-9.5-16.6L212.7 226h598.6L613 561.4z'));
exports.FileWordOutline = getIcon('file-word', outline, getNode(newViewBox, 'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM528.1 472h-32.2c-5.5 0-10.3 3.7-11.6 9.1L434.6 680l-46.1-198.7c-1.3-5.4-6.1-9.3-11.7-9.3h-35.4a12.02 12.02 0 0 0-11.6 15.1l74.2 276c1.4 5.2 6.2 8.9 11.6 8.9h32c5.4 0 10.2-3.6 11.6-8.9l52.8-197 52.8 197c1.4 5.2 6.2 8.9 11.6 8.9h31.8c5.4 0 10.2-3.6 11.6-8.9l74.4-276a12.04 12.04 0 0 0-11.6-15.1H647c-5.6 0-10.4 3.9-11.7 9.3l-45.8 199.1-49.8-199.3c-1.3-5.4-6.1-9.1-11.6-9.1z'));
exports.FireOutline = getIcon('fire', outline, getNode(newViewBox, 'M834.1 469.2A347.49 347.49 0 0 0 751.2 354l-29.1-26.7a8.09 8.09 0 0 0-13 3.3l-13 37.3c-8.1 23.4-23 47.3-44.1 70.8-1.4 1.5-3 1.9-4.1 2-1.1.1-2.8-.1-4.3-1.5-1.4-1.2-2.1-3-2-4.8 3.7-60.2-14.3-128.1-53.7-202C555.3 171 510 123.1 453.4 89.7l-41.3-24.3c-5.4-3.2-12.3 1-12 7.3l2.2 48c1.5 32.8-2.3 61.8-11.3 85.9-11 29.5-26.8 56.9-47 81.5a295.64 295.64 0 0 1-47.5 46.1 352.6 352.6 0 0 0-100.3 121.5A347.75 347.75 0 0 0 160 610c0 47.2 9.3 92.9 27.7 136a349.4 349.4 0 0 0 75.5 110.9c32.4 32 70 57.2 111.9 74.7C418.5 949.8 464.5 959 512 959s93.5-9.2 136.9-27.3A348.6 348.6 0 0 0 760.8 857c32.4-32 57.8-69.4 75.5-110.9a344.2 344.2 0 0 0 27.7-136c0-48.8-10-96.2-29.9-140.9zM713 808.5c-53.7 53.2-125 82.4-201 82.4s-147.3-29.2-201-82.4c-53.5-53.1-83-123.5-83-198.4 0-43.5 9.8-85.2 29.1-124 18.8-37.9 46.8-71.8 80.8-97.9a349.6 349.6 0 0 0 58.6-56.8c25-30.5 44.6-64.5 58.2-101a240 240 0 0 0 12.1-46.5c24.1 22.2 44.3 49 61.2 80.4 33.4 62.6 48.8 118.3 45.8 165.7a74.01 74.01 0 0 0 24.4 59.8 73.36 73.36 0 0 0 53.4 18.8c19.7-1 37.8-9.7 51-24.4 13.3-14.9 24.8-30.1 34.4-45.6 14 17.9 25.7 37.4 35 58.4 15.9 35.8 24 73.9 24 113.1 0 74.9-29.5 145.4-83 198.4z'));
exports.FileUnknownOutline = getIcon('file-unknown', outline, getNode(newViewBox, 'M854.6 288.7L639.4 73.4c-6-6-14.2-9.4-22.7-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.6-9.4-22.6zM790.2 326H602V137.8L790.2 326zm1.8 562H232V136h302v216a42 42 0 0 0 42 42h216v494zM402 549c0 5.4 4.4 9.5 9.8 9.5h32.4c5.4 0 9.8-4.2 9.8-9.4 0-28.2 25.8-51.6 58-51.6s58 23.4 58 51.5c0 25.3-21 47.2-49.3 50.9-19.3 2.8-34.5 20.3-34.7 40.1v32c0 5.5 4.5 10 10 10h32c5.5 0 10-4.5 10-10v-12.2c0-6 4-11.5 9.7-13.3 44.6-14.4 75-54 74.3-98.9-.8-55.5-49.2-100.8-108.5-101.6-61.4-.7-111.5 45.6-111.5 103zm78 195a32 32 0 1 0 64 0 32 32 0 1 0-64 0z'));
exports.FlagOutline = getIcon('flag', outline, getNode(newViewBox, 'M880 305H624V192c0-17.7-14.3-32-32-32H184v-40c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v784c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V640h248v113c0 17.7 14.3 32 32 32h416c17.7 0 32-14.3 32-32V337c0-17.7-14.3-32-32-32zM184 568V232h368v336H184zm656 145H504v-73h112c4.4 0 8-3.6 8-8V377h216v336z'));
exports.FolderAddOutline = getIcon('folder-add', outline, getNode(newViewBox, 'M484 443.1V528h-84.5c-4.1 0-7.5 3.1-7.5 7v42c0 3.8 3.4 7 7.5 7H484v84.9c0 3.9 3.2 7.1 7 7.1h42c3.9 0 7-3.2 7-7.1V584h84.5c4.1 0 7.5-3.2 7.5-7v-42c0-3.9-3.4-7-7.5-7H540v-84.9c0-3.9-3.1-7.1-7-7.1h-42c-3.8 0-7 3.2-7 7.1zm396-144.7H521L403.7 186.2a8.15 8.15 0 0 0-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z'));
exports.FolderOutline = getIcon('folder', outline, getNode(newViewBox, 'M880 298.4H521L403.7 186.2a8.15 8.15 0 0 0-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z'));
exports.FolderOpenOutline = getIcon('folder-open', outline, getNode(newViewBox, 'M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 0 0-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zM136 256h188.5l119.6 114.4H748V444H238c-13 0-24.8 7.9-29.7 20L136 643.2V256zm635.3 512H159l103.3-256h612.4L771.3 768z'));
exports.ForwardOutline = getIcon('forward', outline, getNode(normalViewBox, 'M825.8 498L538.4 249.9c-10.7-9.2-26.4-.9-26.4 14v496.3c0 14.9 15.7 23.2 26.4 14L825.8 526c8.3-7.2 8.3-20.8 0-28zm-320 0L218.4 249.9c-10.7-9.2-26.4-.9-26.4 14v496.3c0 14.9 15.7 23.2 26.4 14L505.8 526c4.1-3.6 6.2-8.8 6.2-14 0-5.2-2.1-10.4-6.2-14z'));
exports.FrownOutline = getIcon('frown', outline, getNode(newViewBox, 'M288 421a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm352 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm263 711c-34.2 34.2-74 61-118.3 79.8C611 874.2 562.3 884 512 884c-50.3 0-99-9.8-144.8-29.2A370.4 370.4 0 0 1 248.9 775c-34.2-34.2-61-74-79.8-118.3C149.8 611 140 562.3 140 512s9.8-99 29.2-144.8A370.4 370.4 0 0 1 249 248.9c34.2-34.2 74-61 118.3-79.8C413 149.8 461.7 140 512 140c50.3 0 99 9.8 144.8 29.2A370.4 370.4 0 0 1 775.1 249c34.2 34.2 61 74 79.8 118.3C874.2 413 884 461.7 884 512s-9.8 99-29.2 144.8A368.89 368.89 0 0 1 775 775zM512 533c-85.5 0-155.6 67.3-160 151.6a8 8 0 0 0 8 8.4h48.1c4.2 0 7.8-3.2 8.1-7.4C420 636.1 461.5 597 512 597s92.1 39.1 95.8 88.6c.3 4.2 3.9 7.4 8.1 7.4H664a8 8 0 0 0 8-8.4C667.6 600.3 597.5 533 512 533z'));
exports.FundOutline = getIcon('fund', outline, getNode(newViewBox, 'M926 164H94c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V196c0-17.7-14.3-32-32-32zm-40 632H134V236h752v560zm-658.9-82.3c3.1 3.1 8.2 3.1 11.3 0l172.5-172.5 114.4 114.5c3.1 3.1 8.2 3.1 11.3 0l297-297.2c3.1-3.1 3.1-8.2 0-11.3l-36.8-36.8a8.03 8.03 0 0 0-11.3 0L531 565 416.6 450.5a8.03 8.03 0 0 0-11.3 0l-214.9 215a8.03 8.03 0 0 0 0 11.3l36.7 36.9z'));
exports.FunnelPlotOutline = getIcon('funnel-plot', outline, getNode(newViewBox, 'M880.1 154H143.9c-24.5 0-39.8 26.7-27.5 48L349 607.4V838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V607.4L907.7 202c12.2-21.3-3.1-48-27.6-48zM603.4 798H420.6V650h182.9v148zm9.6-226.6l-8.4 14.6H419.3l-8.4-14.6L334.4 438h355.2L613 571.4zM726.3 374H297.7l-85-148h598.6l-85 148z'));
exports.GiftOutline = getIcon('gift', outline, getNode(newViewBox, 'M880 310H732.4c13.6-21.4 21.6-46.8 21.6-74 0-76.1-61.9-138-138-138-41.4 0-78.7 18.4-104 47.4-25.3-29-62.6-47.4-104-47.4-76.1 0-138 61.9-138 138 0 27.2 7.9 52.6 21.6 74H144c-17.7 0-32 14.3-32 32v200c0 4.4 3.6 8 8 8h40v344c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V550h40c4.4 0 8-3.6 8-8V342c0-17.7-14.3-32-32-32zm-334-74c0-38.6 31.4-70 70-70s70 31.4 70 70-31.4 70-70 70h-70v-70zm-138-70c38.6 0 70 31.4 70 70v70h-70c-38.6 0-70-31.4-70-70s31.4-70 70-70zM180 482V378h298v104H180zm48 68h250v308H228V550zm568 308H546V550h250v308zm48-376H546V378h298v104z'));
exports.GithubOutline = getIcon('github', outline, getNode(newViewBox, 'M511.6 76.3C264.3 76.2 64 276.4 64 523.5 64 718.9 189.3 885 363.8 946c23.5 5.9 19.9-10.8 19.9-22.2v-77.5c-135.7 15.9-141.2-73.9-150.3-88.9C215 726 171.5 718 184.5 703c30.9-15.9 62.4 4 98.9 57.9 26.4 39.1 77.9 32.5 104 26 5.7-23.5 17.9-44.5 34.7-60.8-140.6-25.2-199.2-111-199.2-213 0-49.5 16.3-95 48.3-131.7-20.4-60.5 1.9-112.3 4.9-120 58.1-5.2 118.5 41.6 123.2 45.3 33-8.9 70.7-13.6 112.9-13.6 42.4 0 80.2 4.9 113.5 13.9 11.3-8.6 67.3-48.8 121.3-43.9 2.9 7.7 24.7 58.3 5.5 118 32.4 36.8 48.9 82.7 48.9 132.3 0 102.2-59 188.1-200 212.9a127.5 127.5 0 0 1 38.1 91v112.5c.8 9 0 17.9 15 17.9 177.1-59.7 304.6-227 304.6-424.1 0-247.2-200.4-447.3-447.5-447.3z'));
exports.GitlabOutline = getIcon('gitlab', outline, getNode(newViewBox, 'M913.9 552.2L805 181.4v-.1c-7.6-22.9-25.7-36.5-48.3-36.5-23.4 0-42.5 13.5-49.7 35.2l-71.4 213H388.8l-71.4-213c-7.2-21.7-26.3-35.2-49.7-35.2-23.1 0-42.5 14.8-48.4 36.6L110.5 552.2c-4.4 14.7 1.2 31.4 13.5 40.7l368.5 276.4c2.6 3.6 6.2 6.3 10.4 7.8l8.6 6.4 8.5-6.4c4.9-1.7 9-4.7 11.9-8.9l368.4-275.4c12.4-9.2 18-25.9 13.6-40.6zM751.7 193.4c1-1.8 2.9-1.9 3.5-1.9 1.1 0 2.5.3 3.4 3L818 394.3H684.5l67.2-200.9zm-487.4 1c.9-2.6 2.3-2.9 3.4-2.9 2.7 0 2.9.1 3.4 1.7l67.3 201.2H206.5l57.8-200zM158.8 558.7l28.2-97.3 202.4 270.2-230.6-172.9zm73.9-116.4h122.1l90.8 284.3-212.9-284.3zM512.9 776L405.7 442.3H620L512.9 776zm157.9-333.7h119.5L580 723.1l90.8-280.8zm-40.7 293.9l207.3-276.7 29.5 99.2-236.8 177.5z'));
exports.HeartOutline = getIcon('heart', outline, getNode(newViewBox, 'M923 283.6a260.04 260.04 0 0 0-56.9-82.8 264.4 264.4 0 0 0-84-55.5A265.34 265.34 0 0 0 679.7 125c-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5a258.44 258.44 0 0 0-56.9 82.8c-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3.1-35.3-7-69.6-20.9-101.9zM512 814.8S156 586.7 156 385.5C156 283.6 240.3 201 344.3 201c73.1 0 136.5 40.8 167.7 100.4C543.2 241.8 606.6 201 679.7 201c104 0 188.3 82.6 188.3 184.5 0 201.2-356 429.3-356 429.3z'));
exports.HddOutline = getIcon('hdd', outline, getNode(newViewBox, 'M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-600 72h560v208H232V136zm560 480H232V408h560v208zm0 272H232V680h560v208zM496 208H312c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM312 544h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H312c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm328 244a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'));
exports.HighlightOutline = getIcon('highlight', outline, getNode(newViewBox, 'M957.6 507.4L603.2 158.2a7.9 7.9 0 0 0-11.2 0L353.3 393.4a8.03 8.03 0 0 0-.1 11.3l.1.1 40 39.4-117.2 115.3a8.03 8.03 0 0 0-.1 11.3l.1.1 39.5 38.9-189.1 187H72.1c-4.4 0-8.1 3.6-8.1 8V860c0 4.4 3.6 8 8 8h344.9c2.1 0 4.1-.8 5.6-2.3l76.1-75.6 40.4 39.8a7.9 7.9 0 0 0 11.2 0l117.1-115.6 40.1 39.5a7.9 7.9 0 0 0 11.2 0l238.7-235.2c3.4-3 3.4-8 .3-11.2zM389.8 796.2H229.6l134.4-133 80.1 78.9-54.3 54.1zm154.8-62.1L373.2 565.2l68.6-67.6 171.4 168.9-68.6 67.6zM713.1 658L450.3 399.1 597.6 254l262.8 259-147.3 145z'));
exports.HomeOutline = getIcon('home', outline, getNode(newViewBox, 'M946.5 505L560.1 118.8l-25.9-25.9a31.5 31.5 0 0 0-44.4 0L77.5 505a63.9 63.9 0 0 0-18.8 46c.4 35.2 29.7 63.3 64.9 63.3h42.5V940h691.8V614.3h43.4c17.1 0 33.2-6.7 45.3-18.8a63.6 63.6 0 0 0 18.7-45.3c0-17-6.7-33.1-18.8-45.2zM568 868H456V664h112v204zm217.9-325.7V868H632V640c0-22.1-17.9-40-40-40H432c-22.1 0-40 17.9-40 40v228H238.1V542.3h-96l370-369.7 23.1 23.1L882 542.3h-96.1z'));
exports.HourglassOutline = getIcon('hourglass', outline, getNode(newViewBox, 'M742 318V184h86c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H196c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h86v134c0 81.5 42.4 153.2 106.4 194-64 40.8-106.4 112.5-106.4 194v134h-86c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h632c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-86V706c0-81.5-42.4-153.2-106.4-194 64-40.8 106.4-112.5 106.4-194zm-72 388v134H354V706c0-42.2 16.4-81.9 46.3-111.7C430.1 564.4 469.8 548 512 548s81.9 16.4 111.7 46.3C653.6 624.1 670 663.8 670 706zm0-388c0 42.2-16.4 81.9-46.3 111.7C593.9 459.6 554.2 476 512 476s-81.9-16.4-111.7-46.3A156.63 156.63 0 0 1 354 318V184h316v134z'));
exports.Html5Outline = getIcon('html5', outline, getNode(newViewBox, 'M145 96l66 746.6L511.8 928l299.6-85.4L878.7 96H145zm610.9 700.6l-244.1 69.6-245.2-69.6-56.7-641.2h603.8l-57.8 641.2zM281 249l1.7 24.3 22.7 253.5h206.5v-.1h112.9l-11.4 118.5L511 672.9v.2h-.8l-102.4-27.7-6.5-73.2h-91l11.3 144.7 188.6 52h1.7v-.4l187.7-51.7 1.7-16.3 21.2-242.2 3.2-24.3H511v.2H389.9l-8.2-94.2h352.1l1.7-19.5 4.8-47.2L742 249H511z'));
exports.IdcardOutline = getIcon('idcard', outline, getNode(newViewBox, 'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136V232h752v560zM610.3 476h123.4c1.3 0 2.3-3.6 2.3-8v-48c0-4.4-1-8-2.3-8H610.3c-1.3 0-2.3 3.6-2.3 8v48c0 4.4 1 8 2.3 8zm4.8 144h185.7c3.9 0 7.1-3.6 7.1-8v-48c0-4.4-3.2-8-7.1-8H615.1c-3.9 0-7.1 3.6-7.1 8v48c0 4.4 3.2 8 7.1 8zM224 673h43.9c4.2 0 7.6-3.3 7.9-7.5 3.8-50.5 46-90.5 97.2-90.5s93.4 40 97.2 90.5c.3 4.2 3.7 7.5 7.9 7.5H522a8 8 0 0 0 8-8.4c-2.8-53.3-32-99.7-74.6-126.1a111.8 111.8 0 0 0 29.1-75.5c0-61.9-49.9-112-111.4-112s-111.4 50.1-111.4 112c0 29.1 11 55.5 29.1 75.5a158.09 158.09 0 0 0-74.6 126.1c-.4 4.6 3.2 8.4 7.8 8.4zm149-262c28.5 0 51.7 23.3 51.7 52s-23.2 52-51.7 52-51.7-23.3-51.7-52 23.2-52 51.7-52z'));
exports.InfoCircleOutline = getIcon('info-circle', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z', 'M464 336a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z'));
exports.InstagramOutline = getIcon('instagram', outline, getNode(newViewBox, 'M512 306.9c-113.5 0-205.1 91.6-205.1 205.1S398.5 717.1 512 717.1 717.1 625.5 717.1 512 625.5 306.9 512 306.9zm0 338.4c-73.4 0-133.3-59.9-133.3-133.3S438.6 378.7 512 378.7 645.3 438.6 645.3 512 585.4 645.3 512 645.3zm213.5-394.6c-26.5 0-47.9 21.4-47.9 47.9s21.4 47.9 47.9 47.9 47.9-21.3 47.9-47.9a47.84 47.84 0 0 0-47.9-47.9zM911.8 512c0-55.2.5-109.9-2.6-165-3.1-64-17.7-120.8-64.5-167.6-46.9-46.9-103.6-61.4-167.6-64.5-55.2-3.1-109.9-2.6-165-2.6-55.2 0-109.9-.5-165 2.6-64 3.1-120.8 17.7-167.6 64.5C132.6 226.3 118.1 283 115 347c-3.1 55.2-2.6 109.9-2.6 165s-.5 109.9 2.6 165c3.1 64 17.7 120.8 64.5 167.6 46.9 46.9 103.6 61.4 167.6 64.5 55.2 3.1 109.9 2.6 165 2.6 55.2 0 109.9.5 165-2.6 64-3.1 120.8-17.7 167.6-64.5 46.9-46.9 61.4-103.6 64.5-167.6 3.2-55.1 2.6-109.8 2.6-165zm-88 235.8c-7.3 18.2-16.1 31.8-30.2 45.8-14.1 14.1-27.6 22.9-45.8 30.2C695.2 844.7 570.3 840 512 840c-58.3 0-183.3 4.7-235.9-16.1-18.2-7.3-31.8-16.1-45.8-30.2-14.1-14.1-22.9-27.6-30.2-45.8C179.3 695.2 184 570.3 184 512c0-58.3-4.7-183.3 16.1-235.9 7.3-18.2 16.1-31.8 30.2-45.8s27.6-22.9 45.8-30.2C328.7 179.3 453.7 184 512 184s183.3-4.7 235.9 16.1c18.2 7.3 31.8 16.1 45.8 30.2 14.1 14.1 22.9 27.6 30.2 45.8C844.7 328.7 840 453.7 840 512c0 58.3 4.7 183.2-16.2 235.8z'));
exports.InsuranceOutline = getIcon('insurance', outline, getNode(newViewBox, 'M441.6 306.8L403 288.6a6.1 6.1 0 0 0-8.4 3.7c-17.5 58.5-45.2 110.1-82.2 153.6a6.05 6.05 0 0 0-1.2 5.6l13.2 43.5c1.3 4.4 7 5.7 10.2 2.4 7.7-8.1 15.4-16.9 23.1-26V656c0 4.4 3.6 8 8 8H403c4.4 0 8-3.6 8-8V393.1a429.2 429.2 0 0 0 33.6-79c1-2.9-.3-6-3-7.3zm26.8 9.2v127.2c0 4.4 3.6 8 8 8h65.9v18.6h-94.9c-4.4 0-8 3.6-8 8v35.6c0 4.4 3.6 8 8 8h55.1c-19.1 30.8-42.4 55.7-71 76a6 6 0 0 0-1.6 8.1l22.8 36.5c1.9 3.1 6.2 3.8 8.9 1.4 31.6-26.8 58.7-62.9 80.6-107.6v120c0 4.4 3.6 8 8 8h36.2c4.4 0 8-3.6 8-8V536c21.3 41.7 47.5 77.5 78.1 106.9 2.6 2.5 6.8 2.1 8.9-.7l26.3-35.3c2-2.7 1.4-6.5-1.2-8.4-30.5-22.6-54.2-47.8-72.3-76.9h59c4.4 0 8-3.6 8-8V478c0-4.4-3.6-8-8-8h-98.8v-18.6h66.7c4.4 0 8-3.6 8-8V316c0-4.4-3.6-8-8-8H476.4c-4.4 0-8 3.6-8 8zm51.5 42.8h97.9v41.6h-97.9v-41.6zm347-188.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z'));
exports.InteractionOutline = getIcon('interaction', outline, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656zM304.8 524h50.7c3.7 0 6.8-3 6.8-6.8v-78.9c0-19.7 15.9-35.6 35.5-35.6h205.7v53.4c0 5.7 6.5 8.8 10.9 5.3l109.1-85.7c3.5-2.7 3.5-8 0-10.7l-109.1-85.7c-4.4-3.5-10.9-.3-10.9 5.3V338H397.7c-55.1 0-99.7 44.8-99.7 100.1V517c0 4 3 7 6.8 7zm-4.2 134.9l109.1 85.7c4.4 3.5 10.9.3 10.9-5.3v-53.4h205.7c55.1 0 99.7-44.8 99.7-100.1v-78.9c0-3.7-3-6.8-6.8-6.8h-50.7c-3.7 0-6.8 3-6.8 6.8v78.9c0 19.7-15.9 35.6-35.5 35.6H420.6V568c0-5.7-6.5-8.8-10.9-5.3l-109.1 85.7c-3.5 2.5-3.5 7.8 0 10.5z'));
exports.InterationOutline = getIcon('interation', outline, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656zM304.8 524h50.7c3.7 0 6.8-3 6.8-6.8v-78.9c0-19.7 15.9-35.6 35.5-35.6h205.7v53.4c0 5.7 6.5 8.8 10.9 5.3l109.1-85.7c3.5-2.7 3.5-8 0-10.7l-109.1-85.7c-4.4-3.5-10.9-.3-10.9 5.3V338H397.7c-55.1 0-99.7 44.8-99.7 100.1V517c0 4 3 7 6.8 7zm-4.2 134.9l109.1 85.7c4.4 3.5 10.9.3 10.9-5.3v-53.4h205.7c55.1 0 99.7-44.8 99.7-100.1v-78.9c0-3.7-3-6.8-6.8-6.8h-50.7c-3.7 0-6.8 3-6.8 6.8v78.9c0 19.7-15.9 35.6-35.5 35.6H420.6V568c0-5.7-6.5-8.8-10.9-5.3l-109.1 85.7c-3.5 2.5-3.5 7.8 0 10.5z'));
exports.LayoutOutline = getIcon('layout', outline, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-696 72h136v656H184V184zm656 656H384V384h456v456zM384 320V184h456v136H384z'));
exports.LeftCircleOutline = getIcon('left-circle', outline, getNode(newViewBox, 'M603.3 327.5l-246 178a7.95 7.95 0 0 0 0 12.9l246 178c5.3 3.8 12.7 0 12.7-6.5V643c0-10.2-4.9-19.9-13.2-25.9L457.4 512l145.4-105.2c8.3-6 13.2-15.6 13.2-25.9V334c0-6.5-7.4-10.3-12.7-6.5z', 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'));
exports.LeftSquareOutline = getIcon('left-square', outline, getNode(newViewBox, 'M365.3 518.5l246 178c5.3 3.8 12.7 0 12.7-6.5v-46.9c0-10.2-4.9-19.9-13.2-25.9L465.4 512l145.4-105.2c8.3-6 13.2-15.6 13.2-25.9V334c0-6.5-7.4-10.3-12.7-6.5l-246 178a8.05 8.05 0 0 0 0 13z', 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'));
exports.LikeOutline = getIcon('like', outline, getNode(newViewBox, 'M885.9 533.7c16.8-22.2 26.1-49.4 26.1-77.7 0-44.9-25.1-87.4-65.5-111.1a67.67 67.67 0 0 0-34.3-9.3H572.4l6-122.9c1.4-29.7-9.1-57.9-29.5-79.4A106.62 106.62 0 0 0 471 99.9c-52 0-98 35-111.8 85.1l-85.9 311H144c-17.7 0-32 14.3-32 32v364c0 17.7 14.3 32 32 32h601.3c9.2 0 18.2-1.8 26.5-5.4 47.6-20.3 78.3-66.8 78.3-118.4 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7-.2-12.6-2-25.1-5.6-37.1zM184 852V568h81v284h-81zm636.4-353l-21.9 19 13.9 25.4a56.2 56.2 0 0 1 6.9 27.3c0 16.5-7.2 32.2-19.6 43l-21.9 19 13.9 25.4a56.2 56.2 0 0 1 6.9 27.3c0 16.5-7.2 32.2-19.6 43l-21.9 19 13.9 25.4a56.2 56.2 0 0 1 6.9 27.3c0 22.4-13.2 42.6-33.6 51.8H329V564.8l99.5-360.5a44.1 44.1 0 0 1 42.2-32.3c7.6 0 15.1 2.2 21.1 6.7 9.9 7.4 15.2 18.6 14.6 30.5l-9.6 198.4h314.4C829 418.5 840 436.9 840 456c0 16.5-7.2 32.1-19.6 43z'));
exports.LinkedinOutline = getIcon('linkedin', outline, getNode(newViewBox, 'M847.7 112H176.3c-35.5 0-64.3 28.8-64.3 64.3v671.4c0 35.5 28.8 64.3 64.3 64.3h671.4c35.5 0 64.3-28.8 64.3-64.3V176.3c0-35.5-28.8-64.3-64.3-64.3zm0 736c-447.8-.1-671.7-.2-671.7-.3.1-447.8.2-671.7.3-671.7 447.8.1 671.7.2 671.7.3-.1 447.8-.2 671.7-.3 671.7zM230.6 411.9h118.7v381.8H230.6zm59.4-52.2c37.9 0 68.8-30.8 68.8-68.8a68.8 68.8 0 1 0-137.6 0c-.1 38 30.7 68.8 68.8 68.8zm252.3 245.1c0-49.8 9.5-98 71.2-98 60.8 0 61.7 56.9 61.7 101.2v185.7h118.6V584.3c0-102.8-22.2-181.9-142.3-181.9-57.7 0-96.4 31.7-112.3 61.7h-1.6v-52.2H423.7v381.8h118.6V604.8z'));
exports.LockOutline = getIcon('lock', outline, getNode(newViewBox, 'M832 464h-68V240c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM332 240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v224H332V240zm460 600H232V536h560v304zM484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 1 0-56 0z'));
exports.MedicineBoxOutline = getIcon('medicine-box', outline, getNode(newViewBox, 'M839.2 278.1a32 32 0 0 0-30.4-22.1H736V144c0-17.7-14.3-32-32-32H320c-17.7 0-32 14.3-32 32v112h-72.8a31.9 31.9 0 0 0-30.4 22.1L112 502v378c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V502l-72.8-223.9zM360 184h304v72H360v-72zm480 656H184V513.4L244.3 328h535.4L840 513.4V840zM652 572H544V464c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v108H372c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h108v108c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V636h108c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z'));
exports.MehOutline = getIcon('meh', outline, getNode(newViewBox, 'M288 421a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm352 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm263 711c-34.2 34.2-74 61-118.3 79.8C611 874.2 562.3 884 512 884c-50.3 0-99-9.8-144.8-29.2A370.4 370.4 0 0 1 248.9 775c-34.2-34.2-61-74-79.8-118.3C149.8 611 140 562.3 140 512s9.8-99 29.2-144.8A370.4 370.4 0 0 1 249 248.9c34.2-34.2 74-61 118.3-79.8C413 149.8 461.7 140 512 140c50.3 0 99 9.8 144.8 29.2A370.4 370.4 0 0 1 775.1 249c34.2 34.2 61 74 79.8 118.3C874.2 413 884 461.7 884 512s-9.8 99-29.2 144.8A368.89 368.89 0 0 1 775 775zM664 565H360c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h304c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z'));
exports.MailOutline = getIcon('mail', outline, getNode(newViewBox, 'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 110.8V792H136V270.8l-27.6-21.5 39.3-50.5 42.8 33.3h643.1l42.8-33.3 39.3 50.5-27.7 21.5zM833.6 232L512 482 190.4 232l-42.8-33.3-39.3 50.5 27.6 21.5 341.6 265.6a55.99 55.99 0 0 0 68.7 0L888 270.8l27.6-21.5-39.3-50.5-42.7 33.2z'));
exports.MessageOutline = getIcon('message', outline, getNode(newViewBox, 'M464 512a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm200 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm-400 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm661.2-173.6c-22.6-53.7-55-101.9-96.3-143.3a444.35 444.35 0 0 0-143.3-96.3C630.6 75.7 572.2 64 512 64h-2c-60.6.3-119.3 12.3-174.5 35.9a445.35 445.35 0 0 0-142 96.5c-40.9 41.3-73 89.3-95.2 142.8-23 55.4-34.6 114.3-34.3 174.9A449.4 449.4 0 0 0 112 714v152a46 46 0 0 0 46 46h152.1A449.4 449.4 0 0 0 510 960h2.1c59.9 0 118-11.6 172.7-34.3a444.48 444.48 0 0 0 142.8-95.2c41.3-40.9 73.8-88.7 96.5-142 23.6-55.2 35.6-113.9 35.9-174.5.3-60.9-11.5-120-34.8-175.6zm-151.1 438C704 845.8 611 884 512 884h-1.7c-60.3-.3-120.2-15.3-173.1-43.5l-8.4-4.5H188V695.2l-4.5-8.4C155.3 633.9 140.3 574 140 513.7c-.4-99.7 37.7-193.3 107.6-263.8 69.8-70.5 163.1-109.5 262.8-109.9h1.7c50 0 98.5 9.7 144.2 28.9 44.6 18.7 84.6 45.6 119 80 34.3 34.3 61.3 74.4 80 119 19.4 46.2 29.1 95.2 28.9 145.8-.6 99.6-39.7 192.9-110.1 262.7z'));
exports.MinusCircleOutline = getIcon('minus-circle', outline, getNode(newViewBox, 'M696 480H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z', 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'));
exports.MinusSquareOutline = getIcon('minus-square', outline, getNode(newViewBox, 'M328 544h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z', 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'));
exports.MobileOutline = getIcon('mobile', outline, getNode(newViewBox, 'M744 62H280c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h464c35.3 0 64-28.7 64-64V126c0-35.3-28.7-64-64-64zm-8 824H288V134h448v752zM472 784a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'));
exports.MoneyCollectOutline = getIcon('money-collect', outline, getNode(newViewBox, 'M911.5 700.7a8 8 0 0 0-10.3-4.8L840 718.2V180c0-37.6-30.4-68-68-68H252c-37.6 0-68 30.4-68 68v538.2l-61.3-22.3c-.9-.3-1.8-.5-2.7-.5-4.4 0-8 3.6-8 8V763c0 3.3 2.1 6.3 5.3 7.5L501 910.1c7.1 2.6 14.8 2.6 21.9 0l383.8-139.5c3.2-1.2 5.3-4.2 5.3-7.5v-59.6c0-1-.2-1.9-.5-2.8zM512 837.5l-256-93.1V184h512v560.4l-256 93.1zM660.6 312h-54.5c-3 0-5.8 1.7-7.1 4.4l-84.7 168.8H511l-84.7-168.8a8 8 0 0 0-7.1-4.4h-55.7c-1.3 0-2.6.3-3.8 1-3.9 2.1-5.3 7-3.2 10.8l103.9 191.6h-57c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76v39h-76c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76V704c0 4.4 3.6 8 8 8h49.9c4.4 0 8-3.6 8-8v-63.5h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8h-76.3v-39h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8H564l103.7-191.6c.6-1.2 1-2.5 1-3.8-.1-4.3-3.7-7.9-8.1-7.9z'));
exports.PauseCircleOutline = getIcon('pause-circle', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm-88-532h-48c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8zm224 0h-48c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8z'));
exports.PayCircleOutline = getIcon('pay-circle', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm159.6-585h-59.5c-3 0-5.8 1.7-7.1 4.4l-90.6 180H511l-90.6-180a8 8 0 0 0-7.1-4.4h-60.7c-1.3 0-2.6.3-3.8 1-3.9 2.1-5.3 7-3.2 10.9L457 515.7h-61.4c-4.4 0-8 3.6-8 8v29.9c0 4.4 3.6 8 8 8h81.7V603h-81.7c-4.4 0-8 3.6-8 8v29.9c0 4.4 3.6 8 8 8h81.7V717c0 4.4 3.6 8 8 8h54.3c4.4 0 8-3.6 8-8v-68.1h82c4.4 0 8-3.6 8-8V611c0-4.4-3.6-8-8-8h-82v-41.5h82c4.4 0 8-3.6 8-8v-29.9c0-4.4-3.6-8-8-8h-62l111.1-204.8c.6-1.2 1-2.5 1-3.8-.1-4.4-3.7-8-8.1-8z'));
exports.NotificationOutline = getIcon('notification', outline, getNode(newViewBox, 'M880 112c-3.8 0-7.7.7-11.6 2.3L292 345.9H128c-8.8 0-16 7.4-16 16.6v299c0 9.2 7.2 16.6 16 16.6h101.7c-3.7 11.6-5.7 23.9-5.7 36.4 0 65.9 53.8 119.5 120 119.5 55.4 0 102.1-37.6 115.9-88.4l408.6 164.2c3.9 1.5 7.8 2.3 11.6 2.3 16.9 0 32-14.2 32-33.2V145.2C912 126.2 897 112 880 112zM344 762.3c-26.5 0-48-21.4-48-47.8 0-11.2 3.9-21.9 11-30.4l84.9 34.1c-2 24.6-22.7 44.1-47.9 44.1zm496 58.4L318.8 611.3l-12.9-5.2H184V417.9h121.9l12.9-5.2L840 203.3v617.4z'));
exports.PhoneOutline = getIcon('phone', outline, getNode(newViewBox, 'M877.1 238.7L770.6 132.3c-13-13-30.4-20.3-48.8-20.3s-35.8 7.2-48.8 20.3L558.3 246.8c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l89.6 89.7a405.46 405.46 0 0 1-86.4 127.3c-36.7 36.9-79.6 66-127.2 86.6l-89.6-89.7c-13-13-30.4-20.3-48.8-20.3a68.2 68.2 0 0 0-48.8 20.3L132.3 673c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l106.4 106.4c22.2 22.2 52.8 34.9 84.2 34.9 6.5 0 12.8-.5 19.2-1.6 132.4-21.8 263.8-92.3 369.9-198.3C818 606 888.4 474.6 910.4 342.1c6.3-37.6-6.3-76.3-33.3-103.4zm-37.6 91.5c-19.5 117.9-82.9 235.5-178.4 331s-213 158.9-330.9 178.4c-14.8 2.5-30-2.5-40.8-13.2L184.9 721.9 295.7 611l119.8 120 .9.9 21.6-8a481.29 481.29 0 0 0 285.7-285.8l8-21.6-120.8-120.7 110.8-110.9 104.5 104.5c10.8 10.8 15.8 26 13.3 40.8z'));
exports.PictureOutline = getIcon('picture', outline, getNode(newViewBox, 'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136v-39.9l138.5-164.3 150.1 178L658.1 489 888 761.6V792zm0-129.8L664.2 396.8c-3.2-3.8-9-3.8-12.2 0L424.6 666.4l-144-170.7c-3.2-3.8-9-3.8-12.2 0L136 652.7V232h752v430.2zM304 456a88 88 0 1 0 0-176 88 88 0 0 0 0 176zm0-116c15.5 0 28 12.5 28 28s-12.5 28-28 28-28-12.5-28-28 12.5-28 28-28z'));
exports.PieChartOutline = getIcon('pie-chart', outline, getNode(newViewBox, 'M864 518H506V160c0-4.4-3.6-8-8-8h-26a398.46 398.46 0 0 0-282.8 117.1 398.19 398.19 0 0 0-85.7 127.1A397.61 397.61 0 0 0 72 552a398.46 398.46 0 0 0 117.1 282.8c36.7 36.7 79.5 65.6 127.1 85.7A397.61 397.61 0 0 0 472 952a398.46 398.46 0 0 0 282.8-117.1c36.7-36.7 65.6-79.5 85.7-127.1A397.61 397.61 0 0 0 872 552v-26c0-4.4-3.6-8-8-8zM705.7 787.8A331.59 331.59 0 0 1 470.4 884c-88.1-.4-170.9-34.9-233.2-97.2C174.5 724.1 140 640.7 140 552c0-88.7 34.5-172.1 97.2-234.8 54.6-54.6 124.9-87.9 200.8-95.5V586h364.3c-7.7 76.3-41.3 147-96.6 201.8zM952 462.4l-2.6-28.2c-8.5-92.1-49.4-179-115.2-244.6A399.4 399.4 0 0 0 589 74.6L560.7 72c-4.7-.4-8.7 3.2-8.7 7.9V464c0 4.4 3.6 8 8 8l384-1c4.7 0 8.4-4 8-8.6zm-332.2-58.2V147.6a332.24 332.24 0 0 1 166.4 89.8c45.7 45.6 77 103.6 90 166.1l-256.4.7z'));
exports.PlaySquareOutline = getIcon('play-square', outline, getNode(newViewBox, 'M442.3 677.6l199.4-156.7a11.3 11.3 0 0 0 0-17.7L442.3 346.4c-7.4-5.8-18.3-.6-18.3 8.8v313.5c0 9.4 10.9 14.7 18.3 8.9z', 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'));
exports.PlayCircleOutline = getIcon('play-circle', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z', 'M719.4 499.1l-296.1-215A15.9 15.9 0 0 0 398 297v430c0 13.1 14.8 20.5 25.3 12.9l296.1-215a15.9 15.9 0 0 0 0-25.8zm-257.6 134V390.9L628.5 512 461.8 633.1z'));
exports.PlusCircleOutline = getIcon('plus-circle', outline, getNode(newViewBox, 'M696 480H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z', 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'));
exports.PrinterOutline = getIcon('printer', outline, getNode(newViewBox, 'M820 436h-40c-4.4 0-8 3.6-8 8v40c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-40c0-4.4-3.6-8-8-8zm32-104H732V120c0-4.4-3.6-8-8-8H300c-4.4 0-8 3.6-8 8v212H172c-44.2 0-80 35.8-80 80v328c0 17.7 14.3 32 32 32h168v132c0 4.4 3.6 8 8 8h424c4.4 0 8-3.6 8-8V772h168c17.7 0 32-14.3 32-32V412c0-44.2-35.8-80-80-80zM360 180h304v152H360V180zm304 664H360V568h304v276zm200-140H732V500H292v204H160V412c0-6.6 5.4-12 12-12h680c6.6 0 12 5.4 12 12v292z'));
exports.PlusSquareOutline = getIcon('plus-square', outline, getNode(newViewBox, 'M328 544h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z', 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'));
exports.ProfileOutline = getIcon('profile', outline, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656zM492 400h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0 144h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0 144h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zM340 368a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0 144a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0 144a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'));
exports.ProjectOutline = getIcon('project', outline, getNode(newViewBox, 'M280 752h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8zm192-280h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v184c0 4.4 3.6 8 8 8zm192 72h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v256c0 4.4 3.6 8 8 8zm216-432H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'));
exports.PushpinOutline = getIcon('pushpin', outline, getNode(newViewBox, 'M878.3 392.1L631.9 145.7c-6.5-6.5-15-9.7-23.5-9.7s-17 3.2-23.5 9.7L423.8 306.9c-12.2-1.4-24.5-2-36.8-2-73.2 0-146.4 24.1-206.5 72.3a33.23 33.23 0 0 0-2.7 49.4l181.7 181.7-215.4 215.2a15.8 15.8 0 0 0-4.6 9.8l-3.4 37.2c-.9 9.4 6.6 17.4 15.9 17.4.5 0 1 0 1.5-.1l37.2-3.4c3.7-.3 7.2-2 9.8-4.6l215.4-215.4 181.7 181.7c6.5 6.5 15 9.7 23.5 9.7 9.7 0 19.3-4.2 25.9-12.4 56.3-70.3 79.7-158.3 70.2-243.4l161.1-161.1c12.9-12.8 12.9-33.8 0-46.8zM666.2 549.3l-24.5 24.5 3.8 34.4a259.92 259.92 0 0 1-30.4 153.9L262 408.8c12.9-7.1 26.3-13.1 40.3-17.9 27.2-9.4 55.7-14.1 84.7-14.1 9.6 0 19.3.5 28.9 1.6l34.4 3.8 24.5-24.5L608.5 224 800 415.5 666.2 549.3z'));
exports.PropertySafetyOutline = getIcon('property-safety', outline, getNode(newViewBox, 'M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6zM430.5 318h-46c-1.7 0-3.3.4-4.8 1.2a10.1 10.1 0 0 0-4 13.6l88 161.1h-45.2c-5.5 0-10 4.5-10 10v21.3c0 5.5 4.5 10 10 10h63.1v29.7h-63.1c-5.5 0-10 4.5-10 10v21.3c0 5.5 4.5 10 10 10h63.1V658c0 5.5 4.5 10 10 10h41.3c5.5 0 10-4.5 10-10v-51.8h63.4c5.5 0 10-4.5 10-10v-21.3c0-5.5-4.5-10-10-10h-63.4v-29.7h63.4c5.5 0 10-4.5 10-10v-21.3c0-5.5-4.5-10-10-10h-45.7l87.7-161.1a10.05 10.05 0 0 0-8.8-14.8h-45c-3.8 0-7.2 2.1-8.9 5.5l-73.2 144.3-72.9-144.3c-1.7-3.4-5.2-5.5-9-5.5z'));
exports.QuestionCircleOutline = getIcon('question-circle', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z', 'M623.6 316.7C593.6 290.4 554 276 512 276s-81.6 14.5-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56.1 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.1 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0 1 30.9-44.8c59-22.7 97.1-74.7 97.1-132.5.1-39.3-17.1-76-48.3-103.3zM472 732a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'));
exports.ReadOutline = getIcon('read', outline, getNode(newViewBox, 'M928 161H699.2c-49.1 0-97.1 14.1-138.4 40.7L512 233l-48.8-31.3A255.2 255.2 0 0 0 324.8 161H96c-17.7 0-32 14.3-32 32v568c0 17.7 14.3 32 32 32h228.8c49.1 0 97.1 14.1 138.4 40.7l44.4 28.6c1.3.8 2.8 1.3 4.3 1.3s3-.4 4.3-1.3l44.4-28.6C602 807.1 650.1 793 699.2 793H928c17.7 0 32-14.3 32-32V193c0-17.7-14.3-32-32-32zM324.8 721H136V233h188.8c35.4 0 69.8 10.1 99.5 29.2l48.8 31.3 6.9 4.5v462c-47.6-25.6-100.8-39-155.2-39zm563.2 0H699.2c-54.4 0-107.6 13.4-155.2 39V298l6.9-4.5 48.8-31.3c29.7-19.1 64.1-29.2 99.5-29.2H888v488zM396.9 361H211.1c-3.9 0-7.1 3.4-7.1 7.5v45c0 4.1 3.2 7.5 7.1 7.5h185.7c3.9 0 7.1-3.4 7.1-7.5v-45c.1-4.1-3.1-7.5-7-7.5zm223.1 7.5v45c0 4.1 3.2 7.5 7.1 7.5h185.7c3.9 0 7.1-3.4 7.1-7.5v-45c0-4.1-3.2-7.5-7.1-7.5H627.1c-3.9 0-7.1 3.4-7.1 7.5zM396.9 501H211.1c-3.9 0-7.1 3.4-7.1 7.5v45c0 4.1 3.2 7.5 7.1 7.5h185.7c3.9 0 7.1-3.4 7.1-7.5v-45c.1-4.1-3.1-7.5-7-7.5zm416 0H627.1c-3.9 0-7.1 3.4-7.1 7.5v45c0 4.1 3.2 7.5 7.1 7.5h185.7c3.9 0 7.1-3.4 7.1-7.5v-45c.1-4.1-3.1-7.5-7-7.5z'));
exports.ReconciliationOutline = getIcon('reconciliation', outline, getNode(newViewBox, 'M676 565c-50.8 0-92 41.2-92 92s41.2 92 92 92 92-41.2 92-92-41.2-92-92-92zm0 126c-18.8 0-34-15.2-34-34s15.2-34 34-34 34 15.2 34 34-15.2 34-34 34zm204-523H668c0-30.9-25.1-56-56-56h-80c-30.9 0-56 25.1-56 56H264c-17.7 0-32 14.3-32 32v200h-88c-17.7 0-32 14.3-32 32v448c0 17.7 14.3 32 32 32h336c17.7 0 32-14.3 32-32v-16h368c17.7 0 32-14.3 32-32V200c0-17.7-14.3-32-32-32zm-412 64h72v-56h64v56h72v48H468v-48zm-20 616H176V616h272v232zm0-296H176v-88h272v88zm392 240H512V432c0-17.7-14.3-32-32-32H304V240h100v104h336V240h100v552zM704 408v96c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-96c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8zM592 512h48c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z'));
exports.RedEnvelopeOutline = getIcon('red-envelope', outline, getNode(newViewBox, 'M440.6 462.6a8.38 8.38 0 0 0-7.5-4.6h-48.8c-1.3 0-2.6.4-3.9 1a8.4 8.4 0 0 0-3.4 11.4l87.4 161.1H419c-4.6 0-8.4 3.8-8.4 8.4V665c0 4.6 3.8 8.4 8.4 8.4h63V702h-63c-4.6 0-8.4 3.8-8.4 8.4v25.1c0 4.6 3.8 8.4 8.4 8.4h63v49.9c0 4.6 3.8 8.4 8.4 8.4h43.7c4.6 0 8.4-3.8 8.4-8.4v-49.9h63.3c4.7 0 8.4-3.8 8.2-8.5v-25c0-4.6-3.8-8.4-8.4-8.4h-63.3v-28.6h63.3c4.6 0 8.4-3.8 8.4-8.4v-25.1c0-4.6-3.8-8.4-8.4-8.4h-45.9l87.2-161a8.45 8.45 0 0 0-7.4-12.4h-47.8c-3.1 0-6 1.8-7.5 4.6l-71.9 141.9-71.7-142zM832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V193.1l260.3 204.1c11.6 9.1 27.9 9.1 39.5 0L792 193.1V888zm0-751.3h-31.7L512 331.3 263.7 136.7H232v-.7h560v.7z'));
exports.RestOutline = getIcon('rest', outline, getNode(newViewBox, 'M508 704c79.5 0 144-64.5 144-144s-64.5-144-144-144-144 64.5-144 144 64.5 144 144 144zm0-224c44.2 0 80 35.8 80 80s-35.8 80-80 80-80-35.8-80-80 35.8-80 80-80z', 'M832 256h-28.1l-35.7-120.9c-4-13.7-16.5-23.1-30.7-23.1h-451c-14.3 0-26.8 9.4-30.7 23.1L220.1 256H192c-17.7 0-32 14.3-32 32v28c0 4.4 3.6 8 8 8h45.8l47.7 558.7a32 32 0 0 0 31.9 29.3h429.2a32 32 0 0 0 31.9-29.3L802.2 324H856c4.4 0 8-3.6 8-8v-28c0-17.7-14.3-32-32-32zm-518.6-76h397.2l22.4 76H291l22.4-76zm376.2 664H326.4L282 324h451.9l-44.3 520z'));
exports.RightCircleOutline = getIcon('right-circle', outline, getNode(newViewBox, 'M666.7 505.5l-246-178A8 8 0 0 0 408 334v46.9c0 10.2 4.9 19.9 13.2 25.9L566.6 512 421.2 617.2c-8.3 6-13.2 15.6-13.2 25.9V690c0 6.5 7.4 10.3 12.7 6.5l246-178c4.4-3.2 4.4-9.8 0-13z', 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'));
exports.RocketOutline = getIcon('rocket', outline, getNode(newViewBox, 'M864 736c0-111.6-65.4-208-160-252.9V317.3c0-15.1-5.3-29.7-15.1-41.2L536.5 95.4C530.1 87.8 521 84 512 84s-18.1 3.8-24.5 11.4L335.1 276.1a63.97 63.97 0 0 0-15.1 41.2v165.8C225.4 528 160 624.4 160 736h156.5c-2.3 7.2-3.5 15-3.5 23.8 0 22.1 7.6 43.7 21.4 60.8a97.2 97.2 0 0 0 43.1 30.6c23.1 54 75.6 88.8 134.5 88.8 29.1 0 57.3-8.6 81.4-24.8 23.6-15.8 41.9-37.9 53-64a97 97 0 0 0 43.1-30.5 97.52 97.52 0 0 0 21.4-60.8c0-8.4-1.1-16.4-3.1-23.8H864zM762.3 621.4c9.4 14.6 17 30.3 22.5 46.6H700V558.7a211.6 211.6 0 0 1 62.3 62.7zM388 483.1V318.8l124-147 124 147V668H388V483.1zM239.2 668c5.5-16.3 13.1-32 22.5-46.6 16.3-25.2 37.5-46.5 62.3-62.7V668h-84.8zm388.9 116.2c-5.2 3-11.2 4.2-17.1 3.4l-19.5-2.4-2.8 19.4c-5.4 37.9-38.4 66.5-76.7 66.5-38.3 0-71.3-28.6-76.7-66.5l-2.8-19.5-19.5 2.5a27.7 27.7 0 0 1-17.1-3.5c-8.7-5-14.1-14.3-14.1-24.4 0-10.6 5.9-19.4 14.6-23.8h231.3c8.8 4.5 14.6 13.3 14.6 23.8-.1 10.2-5.5 19.6-14.2 24.5zM464 400a48 48 0 1 0 96 0 48 48 0 1 0-96 0z'));
exports.RightSquareOutline = getIcon('right-square', outline, getNode(newViewBox, 'M412.7 696.5l246-178c4.4-3.2 4.4-9.7 0-12.9l-246-178c-5.3-3.8-12.7 0-12.7 6.5V381c0 10.2 4.9 19.9 13.2 25.9L558.6 512 413.2 617.2c-8.3 6-13.2 15.6-13.2 25.9V690c0 6.5 7.4 10.3 12.7 6.5z', 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'));
exports.SafetyCertificateOutline = getIcon('safety-certificate', outline, getNode(newViewBox, 'M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6zm-405.8-201c-3-4.1-7.8-6.6-13-6.6H336c-6.5 0-10.3 7.4-6.5 12.7l126.4 174a16.1 16.1 0 0 0 26 0l212.6-292.7c3.8-5.3 0-12.7-6.5-12.7h-55.2c-5.1 0-10 2.5-13 6.6L468.9 542.4l-64.7-89.1z'));
exports.ScheduleOutline = getIcon('schedule', outline, getNode(newViewBox, 'M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zm-40 568H136V296h120v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h120v496zM416 496H232c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm0 136H232c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm308.2-177.4L620.6 598.3l-52.8-73.1c-3-4.2-7.8-6.6-12.9-6.6H500c-6.5 0-10.3 7.4-6.5 12.7l114.1 158.2a15.9 15.9 0 0 0 25.8 0l165-228.7c3.8-5.3 0-12.7-6.5-12.7H737c-5-.1-9.8 2.4-12.8 6.5z'));
exports.SaveOutline = getIcon('save', outline, getNode(newViewBox, 'M893.3 293.3L730.7 130.7c-7.5-7.5-16.7-13-26.7-16V112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V338.5c0-17-6.7-33.2-18.7-45.2zM384 184h256v104H384V184zm456 656H184V184h136v136c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V205.8l136 136V840zM512 442c-79.5 0-144 64.5-144 144s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144zm0 224c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80z'));
exports.SecurityScanOutline = getIcon('security-scan', outline, getNode(newViewBox, 'M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6zM402.9 528.8l-77.5 77.5a8.03 8.03 0 0 0 0 11.3l34 34c3.1 3.1 8.2 3.1 11.3 0l77.5-77.5c55.7 35.1 130.1 28.4 178.6-20.1 56.3-56.3 56.3-147.5 0-203.8-56.3-56.3-147.5-56.3-203.8 0-48.5 48.5-55.2 123-20.1 178.6zm65.4-133.3c31.3-31.3 82-31.3 113.2 0 31.3 31.3 31.3 82 0 113.2-31.3 31.3-82 31.3-113.2 0s-31.3-81.9 0-113.2z'));
exports.SettingOutline = getIcon('setting', outline, getNode(newViewBox, 'M924.8 625.7l-65.5-56c3.1-19 4.7-38.4 4.7-57.8s-1.6-38.8-4.7-57.8l65.5-56a32.03 32.03 0 0 0 9.3-35.2l-.9-2.6a443.74 443.74 0 0 0-79.7-137.9l-1.8-2.1a32.12 32.12 0 0 0-35.1-9.5l-81.3 28.9c-30-24.6-63.5-44-99.7-57.6l-15.7-85a32.05 32.05 0 0 0-25.8-25.7l-2.7-.5c-52.1-9.4-106.9-9.4-159 0l-2.7.5a32.05 32.05 0 0 0-25.8 25.7l-15.8 85.4a351.86 351.86 0 0 0-99 57.4l-81.9-29.1a32 32 0 0 0-35.1 9.5l-1.8 2.1a446.02 446.02 0 0 0-79.7 137.9l-.9 2.6c-4.5 12.5-.8 26.5 9.3 35.2l66.3 56.6c-3.1 18.8-4.6 38-4.6 57.1 0 19.2 1.5 38.4 4.6 57.1L99 625.5a32.03 32.03 0 0 0-9.3 35.2l.9 2.6c18.1 50.4 44.9 96.9 79.7 137.9l1.8 2.1a32.12 32.12 0 0 0 35.1 9.5l81.9-29.1c29.8 24.5 63.1 43.9 99 57.4l15.8 85.4a32.05 32.05 0 0 0 25.8 25.7l2.7.5a449.4 449.4 0 0 0 159 0l2.7-.5a32.05 32.05 0 0 0 25.8-25.7l15.7-85a350 350 0 0 0 99.7-57.6l81.3 28.9a32 32 0 0 0 35.1-9.5l1.8-2.1c34.8-41.1 61.6-87.5 79.7-137.9l.9-2.6c4.5-12.3.8-26.3-9.3-35zM788.3 465.9c2.5 15.1 3.8 30.6 3.8 46.1s-1.3 31-3.8 46.1l-6.6 40.1 74.7 63.9a370.03 370.03 0 0 1-42.6 73.6L721 702.8l-31.4 25.8c-23.9 19.6-50.5 35-79.3 45.8l-38.1 14.3-17.9 97a377.5 377.5 0 0 1-85 0l-17.9-97.2-37.8-14.5c-28.5-10.8-55-26.2-78.7-45.7l-31.4-25.9-93.4 33.2c-17-22.9-31.2-47.6-42.6-73.6l75.5-64.5-6.5-40c-2.4-14.9-3.7-30.3-3.7-45.5 0-15.3 1.2-30.6 3.7-45.5l6.5-40-75.5-64.5c11.3-26.1 25.6-50.7 42.6-73.6l93.4 33.2 31.4-25.9c23.7-19.5 50.2-34.9 78.7-45.7l37.9-14.3 17.9-97.2c28.1-3.2 56.8-3.2 85 0l17.9 97 38.1 14.3c28.7 10.8 55.4 26.2 79.3 45.8l31.4 25.8 92.8-32.9c17 22.9 31.2 47.6 42.6 73.6L781.8 426l6.5 39.9zM512 326c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm79.2 255.2A111.6 111.6 0 0 1 512 614c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 0 1 400 502c0-29.9 11.7-58 32.8-79.2C454 401.6 482.1 390 512 390c29.9 0 58 11.6 79.2 32.8A111.6 111.6 0 0 1 624 502c0 29.9-11.7 58-32.8 79.2z'));
exports.ShoppingOutline = getIcon('shopping', outline, getNode(newViewBox, 'M832 312H696v-16c0-101.6-82.4-184-184-184s-184 82.4-184 184v16H192c-17.7 0-32 14.3-32 32v536c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V344c0-17.7-14.3-32-32-32zm-432-16c0-61.9 50.1-112 112-112s112 50.1 112 112v16H400v-16zm392 544H232V384h96v88c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-88h224v88c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-88h96v456z'));
exports.SkinOutline = getIcon('skin', outline, getNode(newViewBox, 'M870 126H663.8c-17.4 0-32.9 11.9-37 29.3C614.3 208.1 567 246 512 246s-102.3-37.9-114.8-90.7a37.93 37.93 0 0 0-37-29.3H154a44 44 0 0 0-44 44v252a44 44 0 0 0 44 44h75v388a44 44 0 0 0 44 44h478a44 44 0 0 0 44-44V466h75a44 44 0 0 0 44-44V170a44 44 0 0 0-44-44zm-28 268H723v432H301V394H182V198h153.3c28.2 71.2 97.5 120 176.7 120s148.5-48.8 176.7-120H842v196z'));
exports.SkypeOutline = getIcon('skype', outline, getNode(newViewBox, 'M883.7 578.6c4.1-22.5 6.3-45.5 6.3-68.5 0-51-10-100.5-29.7-147-19-45-46.3-85.4-81-120.1a375.79 375.79 0 0 0-120.1-80.9c-46.6-19.7-96-29.7-147-29.7-24 0-48.1 2.3-71.5 6.8A225.1 225.1 0 0 0 335.6 113c-59.7 0-115.9 23.3-158.1 65.5A222.25 222.25 0 0 0 112 336.6c0 38 9.8 75.4 28.1 108.4-3.7 21.4-5.7 43.3-5.7 65.1 0 51 10 100.5 29.7 147 19 45 46.2 85.4 80.9 120.1 34.7 34.7 75.1 61.9 120.1 80.9 46.6 19.7 96 29.7 147 29.7 22.2 0 44.4-2 66.2-5.9 33.5 18.9 71.3 29 110 29 59.7 0 115.9-23.2 158.1-65.5 42.3-42.2 65.5-98.4 65.5-158.1.1-38-9.7-75.5-28.2-108.7zm-88.1 216C766.9 823.4 729 839 688.4 839c-26.1 0-51.8-6.8-74.6-19.7l-22.5-12.7-25.5 4.5c-17.8 3.2-35.8 4.8-53.6 4.8-41.4 0-81.3-8.1-119.1-24.1-36.3-15.3-69-37.3-97.2-65.5a304.29 304.29 0 0 1-65.5-97.1c-16-37.7-24-77.6-24-119 0-17.4 1.6-35.2 4.6-52.8l4.4-25.1L203 410a151.02 151.02 0 0 1-19.1-73.4c0-40.6 15.7-78.5 44.4-107.2C257.1 200.7 295 185 335.6 185a153 153 0 0 1 71.4 17.9l22.4 11.8 24.8-4.8c18.9-3.6 38.4-5.5 58-5.5 41.4 0 81.3 8.1 119 24 36.5 15.4 69.1 37.4 97.2 65.5 28.2 28.1 50.2 60.8 65.6 97.2 16 37.7 24 77.6 24 119 0 18.4-1.7 37-5.1 55.5l-4.7 25.5 12.6 22.6c12.6 22.5 19.2 48 19.2 73.7 0 40.7-15.7 78.5-44.4 107.2zM583.4 466.2L495 446.6c-33.6-7.7-72.3-17.8-72.3-49.5s27.1-53.9 76.1-53.9c98.7 0 89.7 67.8 138.7 67.8 25.8 0 48.4-15.2 48.4-41.2 0-60.8-97.4-106.5-180-106.5-89.7 0-185.2 38.1-185.2 139.5 0 48.8 17.4 100.8 113.6 124.9l119.4 29.8c36.1 8.9 45.2 29.2 45.2 47.6 0 30.5-30.3 60.3-85.2 60.3-107.2 0-92.3-82.5-149.7-82.5-25.8 0-44.5 17.8-44.5 43.1 0 49.4 60 115.4 194.2 115.4 127.7 0 191-61.5 191-144 0-53.1-24.5-109.6-121.3-131.2z'));
exports.SlackSquareOutline = getIcon('slack-square', outline, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM529 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V311.4zM361.5 580.2c0 27.8-22.5 50.4-50.3 50.4a50.35 50.35 0 0 1-50.3-50.4c0-27.8 22.5-50.4 50.3-50.4h50.3v50.4zm134 134.4c0 27.8-22.5 50.4-50.3 50.4-27.8 0-50.3-22.6-50.3-50.4V580.2c0-27.8 22.5-50.4 50.3-50.4a50.35 50.35 0 0 1 50.3 50.4v134.4zm-50.2-218.4h-134c-27.8 0-50.3-22.6-50.3-50.4 0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4-.1 27.9-22.6 50.4-50.3 50.4zm0-134.4c-13.3 0-26.1-5.3-35.6-14.8S395 324.8 395 311.4c0-27.8 22.5-50.4 50.3-50.4 27.8 0 50.3 22.6 50.3 50.4v50.4h-50.3zm134 403.2c-27.8 0-50.3-22.6-50.3-50.4v-50.4h50.3c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm134-134.4h-134a50.35 50.35 0 0 1-50.3-50.4c0-27.8 22.5-50.4 50.3-50.4h134c27.8 0 50.3 22.6 50.3 50.4 0 27.8-22.5 50.4-50.3 50.4zm0-134.4H663v-50.4c0-27.8 22.5-50.4 50.3-50.4s50.3 22.6 50.3 50.4c0 27.8-22.5 50.4-50.3 50.4z'));
exports.SlidersOutline = getIcon('sliders', outline, getNode(newViewBox, 'M320 224h-66v-56c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v56h-66c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h66v56c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-56h66c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zm-60 508h-80V292h80v440zm644-436h-66v-96c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v96h-66c-4.4 0-8 3.6-8 8v416c0 4.4 3.6 8 8 8h66v96c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-96h66c4.4 0 8-3.6 8-8V304c0-4.4-3.6-8-8-8zm-60 364h-80V364h80v296zM612 404h-66V232c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v172h-66c-4.4 0-8 3.6-8 8v200c0 4.4 3.6 8 8 8h66v172c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V620h66c4.4 0 8-3.6 8-8V412c0-4.4-3.6-8-8-8zm-60 145a3 3 0 0 1-3 3h-74a3 3 0 0 1-3-3v-74a3 3 0 0 1 3-3h74a3 3 0 0 1 3 3v74z'));
exports.SmileOutline = getIcon('smile', outline, getNode(newViewBox, 'M288 421a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm352 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0zM512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm263 711c-34.2 34.2-74 61-118.3 79.8C611 874.2 562.3 884 512 884c-50.3 0-99-9.8-144.8-29.2A370.4 370.4 0 0 1 248.9 775c-34.2-34.2-61-74-79.8-118.3C149.8 611 140 562.3 140 512s9.8-99 29.2-144.8A370.4 370.4 0 0 1 249 248.9c34.2-34.2 74-61 118.3-79.8C413 149.8 461.7 140 512 140c50.3 0 99 9.8 144.8 29.2A370.4 370.4 0 0 1 775.1 249c34.2 34.2 61 74 79.8 118.3C874.2 413 884 461.7 884 512s-9.8 99-29.2 144.8A368.89 368.89 0 0 1 775 775zM664 533h-48.1c-4.2 0-7.8 3.2-8.1 7.4C604 589.9 562.5 629 512 629s-92.1-39.1-95.8-88.6c-.3-4.2-3.9-7.4-8.1-7.4H360a8 8 0 0 0-8 8.4c4.4 84.3 74.5 151.6 160 151.6s155.6-67.3 160-151.6a8 8 0 0 0-8-8.4z'));
exports.SnippetsOutline = getIcon('snippets', outline, getNode(newViewBox, 'M832 112H724V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H500V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H320c-17.7 0-32 14.3-32 32v120h-96c-17.7 0-32 14.3-32 32v632c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32v-96h96c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM664 888H232V336h218v174c0 22.1 17.9 40 40 40h174v338zm0-402H514V336h.2L664 485.8v.2zm128 274h-56V456L544 264H360v-80h68v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h152v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h68v576z'));
exports.SoundOutline = getIcon('sound', outline, getNode(newViewBox, 'M625.9 115c-5.9 0-11.9 1.6-17.4 5.3L254 352H90c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h164l354.5 231.7c5.5 3.6 11.6 5.3 17.4 5.3 16.7 0 32.1-13.3 32.1-32.1V147.1c0-18.8-15.4-32.1-32.1-32.1zM586 803L293.4 611.7l-18-11.7H146V424h129.4l17.9-11.7L586 221v582zm348-327H806c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-40c0-8.8-7.2-16-16-16zm-41.9 261.8l-110.3-63.7a15.9 15.9 0 0 0-21.7 5.9l-19.9 34.5c-4.4 7.6-1.8 17.4 5.8 21.8L856.3 800a15.9 15.9 0 0 0 21.7-5.9l19.9-34.5c4.4-7.6 1.7-17.4-5.8-21.8zM760 344a15.9 15.9 0 0 0 21.7 5.9L892 286.2c7.6-4.4 10.2-14.2 5.8-21.8L878 230a15.9 15.9 0 0 0-21.7-5.9L746 287.8a15.99 15.99 0 0 0-5.8 21.8L760 344z'));
exports.StarOutline = getIcon('star', outline, getNode(newViewBox, 'M908.1 353.1l-253.9-36.9L540.7 86.1c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L369.8 316.2l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 0 0 .6 45.3l183.7 179.1-43.4 252.9a31.95 31.95 0 0 0 46.4 33.7L512 754l227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3zM664.8 561.6l36.1 210.3L512 672.7 323.1 772l36.1-210.3-152.8-149L417.6 382 512 190.7 606.4 382l211.2 30.7-152.8 148.9z'));
exports.StepBackwardOutline = getIcon('step-backward', outline, getNode(normalViewBox, 'M347.6 528.95l383.2 301.02c14.25 11.2 35.2 1.1 35.2-16.95V210.97c0-18.05-20.95-28.14-35.2-16.94L347.6 495.05a21.53 21.53 0 0 0 0 33.9M330 864h-64a8 8 0 0 1-8-8V168a8 8 0 0 1 8-8h64a8 8 0 0 1 8 8v688a8 8 0 0 1-8 8'));
exports.StepForwardOutline = getIcon('step-forward', outline, getNode(normalViewBox, 'M676.4 528.95L293.2 829.97c-14.25 11.2-35.2 1.1-35.2-16.95V210.97c0-18.05 20.95-28.14 35.2-16.94l383.2 301.02a21.53 21.53 0 0 1 0 33.9M694 864h64a8 8 0 0 0 8-8V168a8 8 0 0 0-8-8h-64a8 8 0 0 0-8 8v688a8 8 0 0 0 8 8'));
exports.StopOutline = getIcon('stop', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372 0-89 31.3-170.8 83.5-234.8l523.3 523.3C682.8 852.7 601 884 512 884zm288.5-137.2L277.2 223.5C341.2 171.3 423 140 512 140c205.4 0 372 166.6 372 372 0 89-31.3 170.8-83.5 234.8z'));
exports.SwitcherOutline = getIcon('switcher', outline, getNode(newViewBox, 'M752 240H144c-17.7 0-32 14.3-32 32v608c0 17.7 14.3 32 32 32h608c17.7 0 32-14.3 32-32V272c0-17.7-14.3-32-32-32zm-40 600H184V312h528v528zm168-728H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h576v576c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V144c0-17.7-14.3-32-32-32zM300 550h296v64H300z'));
exports.TagOutline = getIcon('tag', outline, getNode(newViewBox, 'M938 458.8l-29.6-312.6c-1.5-16.2-14.4-29-30.6-30.6L565.2 86h-.4c-3.2 0-5.7 1-7.6 2.9L88.9 557.2a9.96 9.96 0 0 0 0 14.1l363.8 363.8c1.9 1.9 4.4 2.9 7.1 2.9s5.2-1 7.1-2.9l468.3-468.3c2-2.1 3-5 2.8-8zM459.7 834.7L189.3 564.3 589 164.6 836 188l23.4 247-399.7 399.7zM680 256c-48.5 0-88 39.5-88 88s39.5 88 88 88 88-39.5 88-88-39.5-88-88-88zm0 120c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z'));
exports.TabletOutline = getIcon('tablet', outline, getNode(newViewBox, 'M800 64H224c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zm-8 824H232V136h560v752zM472 784a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'));
exports.ShopOutline = getIcon('shop', outline, getNode(newViewBox, 'M882 272.1V144c0-17.7-14.3-32-32-32H174c-17.7 0-32 14.3-32 32v128.1c-16.7 1-30 14.9-30 31.9v131.7a177 177 0 0 0 14.4 70.4c4.3 10.2 9.6 19.8 15.6 28.9v345c0 17.6 14.3 32 32 32h676c17.7 0 32-14.3 32-32V535a175 175 0 0 0 15.6-28.9c9.5-22.3 14.4-46 14.4-70.4V304c0-17-13.3-30.9-30-31.9zM214 184h596v88H214v-88zm362 656.1H448V736h128v104.1zm234 0H640V704c0-17.7-14.3-32-32-32H416c-17.7 0-32 14.3-32 32v136.1H214V597.9c2.9 1.4 5.9 2.8 9 4 22.3 9.4 46 14.1 70.4 14.1s48-4.7 70.4-14.1c13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0 0 38.7 22.1c22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0 0 38.7 22.1c22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 3-1.3 6-2.6 9-4v242.2zm30-404.4c0 59.8-49 108.3-109.3 108.3-40.8 0-76.4-22.1-95.2-54.9-2.9-5-8.1-8.1-13.9-8.1h-.6c-5.7 0-11 3.1-13.9 8.1A109.24 109.24 0 0 1 512 544c-40.7 0-76.2-22-95-54.7-3-5.1-8.4-8.3-14.3-8.3s-11.4 3.2-14.3 8.3a109.63 109.63 0 0 1-95.1 54.7C233 544 184 495.5 184 435.7v-91.2c0-.3.2-.5.5-.5h655c.3 0 .5.2.5.5v91.2z'));
exports.TagsOutline = getIcon('tags', outline, getNode(newViewBox, 'M483.2 790.3L861.4 412c1.7-1.7 2.5-4 2.3-6.3l-25.5-301.4c-.7-7.8-6.8-13.9-14.6-14.6L522.2 64.3c-2.3-.2-4.7.6-6.3 2.3L137.7 444.8a8.03 8.03 0 0 0 0 11.3l334.2 334.2c3.1 3.2 8.2 3.2 11.3 0zm62.6-651.7l224.6 19 19 224.6L477.5 694 233.9 450.5l311.9-311.9zm60.16 186.23a48 48 0 1 0 67.88-67.89 48 48 0 1 0-67.88 67.89zM889.7 539.8l-39.6-39.5a8.03 8.03 0 0 0-11.3 0l-362 361.3-237.6-237a8.03 8.03 0 0 0-11.3 0l-39.6 39.5a8.03 8.03 0 0 0 0 11.3l243.2 242.8 39.6 39.5c3.1 3.1 8.2 3.1 11.3 0l407.3-406.6c3.1-3.1 3.1-8.2 0-11.3z'));
exports.TaobaoCircleOutline = getIcon('taobao-circle', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zM315.7 291.5c27.3 0 49.5 22.1 49.5 49.4s-22.1 49.4-49.5 49.4a49.4 49.4 0 1 1 0-98.8zM366.9 578c-13.6 42.3-10.2 26.7-64.4 144.5l-78.5-49s87.7-79.8 105.6-116.2c19.2-38.4-21.1-58.9-21.1-58.9l-60.2-37.5 32.7-50.2c45.4 33.7 48.7 36.6 79.2 67.2 23.8 23.9 20.7 56.8 6.7 100.1zm427.2 55c-15.3 143.8-202.4 90.3-202.4 90.3l10.2-41.1 43.3 9.3c80 5 72.3-64.9 72.3-64.9V423c.6-77.3-72.6-85.4-204.2-38.3l30.6 8.3c-2.5 9-12.5 23.2-25.2 38.6h176v35.6h-99.1v44.5h98.7v35.7h-98.7V622c14.9-4.8 28.6-11.5 40.5-20.5l-8.7-32.5 46.5-14.4 38.8 94.9-57.3 23.9-10.2-37.8c-25.6 19.5-78.8 48-171.8 45.4-99.2 2.6-73.7-112-73.7-112l2.5-1.3H472c-.5 14.7-6.6 38.7 1.7 51.8 6.8 10.8 24.2 12.6 35.3 13.1 1.3.1 2.6.1 3.9.1v-85.3h-101v-35.7h101v-44.5H487c-22.7 24.1-43.5 44.1-43.5 44.1l-30.6-26.7c21.7-22.9 43.3-59.1 56.8-83.2-10.9 4.4-22 9.2-33.6 14.2-11.2 14.3-24.2 29-38.7 43.5.5.8-50-28.4-50-28.4 52.2-44.4 81.4-139.9 81.4-139.9l72.5 20.4s-5.9 14-18.4 35.6c290.3-82.3 307.4 50.5 307.4 50.5s19.1 91.8 3.8 235.7z'));
exports.ToolOutline = getIcon('tool', outline, getNode(newViewBox, 'M876.6 239.5c-.5-.9-1.2-1.8-2-2.5-5-5-13.1-5-18.1 0L684.2 409.3l-67.9-67.9L788.7 169c.8-.8 1.4-1.6 2-2.5 3.6-6.1 1.6-13.9-4.5-17.5-98.2-58-226.8-44.7-311.3 39.7-67 67-89.2 162-66.5 247.4l-293 293c-3 3-2.8 7.9.3 11l169.7 169.7c3.1 3.1 8.1 3.3 11 .3l292.9-292.9c85.5 22.8 180.5.7 247.6-66.4 84.4-84.5 97.7-213.1 39.7-311.3zM786 499.8c-58.1 58.1-145.3 69.3-214.6 33.6l-8.8 8.8-.1-.1-274 274.1-79.2-79.2 230.1-230.1s0 .1.1.1l52.8-52.8c-35.7-69.3-24.5-156.5 33.6-214.6a184.2 184.2 0 0 1 144-53.5L537 318.9a32.05 32.05 0 0 0 0 45.3l124.5 124.5a32.05 32.05 0 0 0 45.3 0l132.8-132.8c3.7 51.8-14.4 104.8-53.6 143.9z'));
exports.ThunderboltOutline = getIcon('thunderbolt', outline, getNode(newViewBox, 'M848 359.3H627.7L825.8 109c4.1-5.3.4-13-6.3-13H436c-2.8 0-5.5 1.5-6.9 4L170 547.5c-3.1 5.3.7 12 6.9 12h174.4l-89.4 357.6c-1.9 7.8 7.5 13.3 13.3 7.7L853.5 373c5.2-4.9 1.7-13.7-5.5-13.7zM378.2 732.5l60.3-241H281.1l189.6-327.4h224.6L487 427.4h211L378.2 732.5z'));
exports.TrophyOutline = getIcon('trophy', outline, getNode(newViewBox, 'M868 160h-92v-40c0-4.4-3.6-8-8-8H256c-4.4 0-8 3.6-8 8v40h-92a44 44 0 0 0-44 44v148c0 81.7 60 149.6 138.2 162C265.7 630.2 359 721.7 476 734.5v105.2H280c-17.7 0-32 14.3-32 32V904c0 4.4 3.6 8 8 8h512c4.4 0 8-3.6 8-8v-32.3c0-17.7-14.3-32-32-32H548V734.5C665 721.7 758.3 630.2 773.8 514 852 501.6 912 433.7 912 352V204a44 44 0 0 0-44-44zM184 352V232h64v207.6a91.99 91.99 0 0 1-64-87.6zm520 128c0 49.1-19.1 95.4-53.9 130.1-34.8 34.8-81 53.9-130.1 53.9h-16c-49.1 0-95.4-19.1-130.1-53.9-34.8-34.8-53.9-81-53.9-130.1V184h384v296zm136-128c0 41-26.9 75.8-64 87.6V232h64v120z'));
exports.UnlockOutline = getIcon('unlock', outline, getNode(newViewBox, 'M832 464H332V240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v68c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-68c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zm-40 376H232V536h560v304zM484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 1 0-56 0z'));
exports.UpCircleOutline = getIcon('up-circle', outline, getNode(newViewBox, 'M518.5 360.3a7.95 7.95 0 0 0-12.9 0l-178 246c-3.8 5.3 0 12.7 6.5 12.7H381c10.2 0 19.9-4.9 25.9-13.2L512 460.4l105.2 145.4c6 8.3 15.6 13.2 25.9 13.2H690c6.5 0 10.3-7.4 6.5-12.7l-178-246z', 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'));
exports.UpSquareOutline = getIcon('up-square', outline, getNode(newViewBox, 'M334 624h46.9c10.2 0 19.9-4.9 25.9-13.2L512 465.4l105.2 145.4c6 8.3 15.6 13.2 25.9 13.2H690c6.5 0 10.3-7.4 6.5-12.7l-178-246a7.95 7.95 0 0 0-12.9 0l-178 246A7.96 7.96 0 0 0 334 624z', 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'));
exports.UsbOutline = getIcon('usb', outline, getNode(newViewBox, 'M760 432V144c0-17.7-14.3-32-32-32H296c-17.7 0-32 14.3-32 32v288c-66.2 0-120 52.1-120 116v356c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V548c0-24.3 21.6-44 48.1-44h495.8c26.5 0 48.1 19.7 48.1 44v356c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V548c0-63.9-53.8-116-120-116zm-424 0V184h352v248H336zm120-184h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm160 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z'));
exports.VideoCameraOutline = getIcon('video-camera', outline, getNode(newViewBox, 'M912 302.3L784 376V224c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v576c0 35.3 28.7 64 64 64h592c35.3 0 64-28.7 64-64V648l128 73.7c21.3 12.3 48-3.1 48-27.6V330c0-24.6-26.7-40-48-27.7zM712 792H136V232h576v560zm176-167l-104-59.8V458.9L888 399v226zM208 360h112c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H208c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z'));
exports.WalletOutline = getIcon('wallet', outline, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 464H528V448h312v128zm0 264H184V184h656v200H496c-17.7 0-32 14.3-32 32v192c0 17.7 14.3 32 32 32h344v200zM580 512a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'));
exports.WarningOutline = getIcon('warning', outline, getNode(newViewBox, 'M464 720a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm16-304v184c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V416c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8zm475.7 440l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zm-783.5-27.9L512 239.9l339.8 588.2H172.2z'));
exports.WechatOutline = getIcon('wechat', outline, getNode(newViewBox, 'M690.1 377.4c5.9 0 11.8.2 17.6.5-24.4-128.7-158.3-227.1-319.9-227.1C209 150.8 64 271.4 64 420.2c0 81.1 43.6 154.2 111.9 203.6a21.5 21.5 0 0 1 9.1 17.6c0 2.4-.5 4.6-1.1 6.9-5.5 20.3-14.2 52.8-14.6 54.3-.7 2.6-1.7 5.2-1.7 7.9 0 5.9 4.8 10.8 10.8 10.8 2.3 0 4.2-.9 6.2-2l70.9-40.9c5.3-3.1 11-5 17.2-5 3.2 0 6.4.5 9.5 1.4 33.1 9.5 68.8 14.8 105.7 14.8 6 0 11.9-.1 17.8-.4-7.1-21-10.9-43.1-10.9-66 0-135.8 132.2-245.8 295.3-245.8zm-194.3-86.5c23.8 0 43.2 19.3 43.2 43.1s-19.3 43.1-43.2 43.1c-23.8 0-43.2-19.3-43.2-43.1s19.4-43.1 43.2-43.1zm-215.9 86.2c-23.8 0-43.2-19.3-43.2-43.1s19.3-43.1 43.2-43.1 43.2 19.3 43.2 43.1-19.4 43.1-43.2 43.1zm586.8 415.6c56.9-41.2 93.2-102 93.2-169.7 0-124-120.8-224.5-269.9-224.5-149 0-269.9 100.5-269.9 224.5S540.9 847.5 690 847.5c30.8 0 60.6-4.4 88.1-12.3 2.6-.8 5.2-1.2 7.9-1.2 5.2 0 9.9 1.6 14.3 4.1l59.1 34c1.7 1 3.3 1.7 5.2 1.7a9 9 0 0 0 6.4-2.6 9 9 0 0 0 2.6-6.4c0-2.2-.9-4.4-1.4-6.6-.3-1.2-7.6-28.3-12.2-45.3-.5-1.9-.9-3.8-.9-5.7.1-5.9 3.1-11.2 7.6-14.5zM600.2 587.2c-19.9 0-36-16.1-36-35.9 0-19.8 16.1-35.9 36-35.9s36 16.1 36 35.9c0 19.8-16.2 35.9-36 35.9zm179.9 0c-19.9 0-36-16.1-36-35.9 0-19.8 16.1-35.9 36-35.9s36 16.1 36 35.9a36.08 36.08 0 0 1-36 35.9z'));
exports.WeiboCircleOutline = getIcon('weibo-circle', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm-44.4 672C353.1 736 236 680.4 236 588.9c0-47.8 30.2-103.1 82.3-155.3 69.5-69.6 150.6-101.4 181.1-70.8 13.5 13.5 14.8 36.8 6.1 64.6-4.5 14 13.1 6.3 13.1 6.3 56.2-23.6 105.2-25 123.1.7 9.6 13.7 8.6 32.8-.2 55.1-4.1 10.2 1.3 11.8 9 14.1 31.7 9.8 66.9 33.6 66.9 75.5.2 69.5-99.7 156.9-249.8 156.9zm207.3-290.8a34.9 34.9 0 0 0-7.2-34.1 34.68 34.68 0 0 0-33.1-10.7 18.24 18.24 0 0 1-7.6-35.7c24.1-5.1 50.1 2.3 67.7 21.9 17.7 19.6 22.4 46.3 14.9 69.8a18.13 18.13 0 0 1-22.9 11.7 18.18 18.18 0 0 1-11.8-22.9zm106 34.3s0 .1 0 0a21.1 21.1 0 0 1-26.6 13.7 21.19 21.19 0 0 1-13.6-26.7c11-34.2 4-73.2-21.7-101.8a104.04 104.04 0 0 0-98.9-32.1 21.14 21.14 0 0 1-25.1-16.3 21.07 21.07 0 0 1 16.2-25.1c49.4-10.5 102.8 4.8 139.1 45.1 36.3 40.2 46.1 95.1 30.6 143.2zm-334.5 6.1c-91.4 9-160.7 65.1-154.7 125.2 5.9 60.1 84.8 101.5 176.2 92.5 91.4-9.1 160.7-65.1 154.7-125.3-5.9-60.1-84.8-101.5-176.2-92.4zm80.2 141.7c-18.7 42.3-72.3 64.8-117.8 50.1-43.9-14.2-62.5-57.7-43.3-96.8 18.9-38.4 68-60.1 111.5-48.8 45 11.7 68 54.2 49.6 95.5zm-93-32.2c-14.2-5.9-32.4.2-41.2 13.9-8.8 13.8-4.7 30.2 9.3 36.6 14.3 6.5 33.2.3 42-13.8 8.8-14.3 4.2-30.6-10.1-36.7zm34.9-14.5c-5.4-2.2-12.2.5-15.4 5.8-3.1 5.4-1.4 11.5 4.1 13.8 5.5 2.3 12.6-.3 15.8-5.8 3-5.6 1-11.8-4.5-13.8z'));
exports.WindowsOutline = getIcon('windows', outline, getNode(newViewBox, 'M120.1 770.6L443 823.2V543.8H120.1v226.8zm63.4-163.5h196.2v141.6l-196.2-31.9V607.1zm340.3 226.5l382 62.2v-352h-382v289.8zm63.4-226.5h255.3v214.4l-255.3-41.6V607.1zm-63.4-415.7v288.8h382V128.1l-382 63.3zm318.7 225.5H587.3V245l255.3-42.3v214.2zm-722.4 63.3H443V201.9l-322.9 53.5v224.8zM183.5 309l196.2-32.5v140.4H183.5V309z'));
exports.YahooOutline = getIcon('yahoo', outline, getNode(newViewBox, 'M859.9 681.4h-14.1c-27.1 0-49.2 22.2-49.2 49.3v14.1c0 27.1 22.2 49.3 49.2 49.3h14.1c27.1 0 49.2-22.2 49.2-49.3v-14.1c0-27.1-22.2-49.3-49.2-49.3zM402.6 231C216.2 231 65 357 65 512.5S216.2 794 402.6 794s337.6-126 337.6-281.5S589.1 231 402.6 231zm0 507C245.1 738 121 634.6 121 512.5c0-62.3 32.3-119.7 84.9-161v48.4h37l159.8 159.9v65.3h-84.4v56.3h225.1v-56.3H459v-65.3l103.5-103.6h65.3v-56.3H459v65.3l-28.1 28.1-93.4-93.5h37v-56.3H216.4c49.4-35 114.3-56.6 186.2-56.6 157.6 0 281.6 103.4 281.6 225.5S560.2 738 402.6 738zm534.7-507H824.7c-15.5 0-27.7 12.6-27.1 28.1l13.1 366h84.4l65.4-366.4c2.7-15.2-7.8-27.7-23.2-27.7z'));
exports.WeiboSquareOutline = getIcon('weibo-square', outline, getNode(newViewBox, 'M433.6 595.1c-14.2-5.9-32.4.2-41.2 13.9-8.8 13.8-4.7 30.2 9.3 36.6 14.3 6.5 33.2.3 42-13.8 8.8-14.3 4.2-30.6-10.1-36.7zM880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM467.6 736C353.1 736 236 680.4 236 588.9c0-47.8 30.2-103.1 82.3-155.3 69.5-69.6 150.6-101.4 181.1-70.8 13.5 13.5 14.8 36.8 6.1 64.6-4.5 14 13.1 6.3 13.1 6.3 56.2-23.6 105.2-25 123.1.7 9.6 13.7 8.6 32.8-.2 55.1-4.1 10.2 1.3 11.8 9 14.1 31.7 9.8 66.9 33.6 66.9 75.5.2 69.5-99.7 156.9-249.8 156.9zm207.3-290.8a34.9 34.9 0 0 0-7.2-34.1 34.68 34.68 0 0 0-33.1-10.7 18.24 18.24 0 0 1-7.6-35.7c24.1-5.1 50.1 2.3 67.7 21.9 17.7 19.6 22.4 46.3 14.9 69.8a18.13 18.13 0 0 1-22.9 11.7 18.18 18.18 0 0 1-11.8-22.9zm106 34.3s0 .1 0 0a21.1 21.1 0 0 1-26.6 13.7 21.19 21.19 0 0 1-13.6-26.7c11-34.2 4-73.2-21.7-101.8a104.04 104.04 0 0 0-98.9-32.1 21.14 21.14 0 0 1-25.1-16.3 21.07 21.07 0 0 1 16.2-25.1c49.4-10.5 102.8 4.8 139.1 45.1 36.3 40.2 46.1 95.1 30.6 143.2zm-334.5 6.1c-91.4 9-160.7 65.1-154.7 125.2 5.9 60.1 84.8 101.5 176.2 92.5 91.4-9.1 160.7-65.1 154.7-125.3-5.9-60.1-84.8-101.5-176.2-92.4zm80.2 141.7c-18.7 42.3-72.3 64.8-117.8 50.1-43.9-14.2-62.5-57.7-43.3-96.8 18.9-38.4 68-60.1 111.5-48.8 45 11.7 68 54.2 49.6 95.5zm-58.1-46.7c-5.4-2.2-12.2.5-15.4 5.8-3.1 5.4-1.4 11.5 4.1 13.8 5.5 2.3 12.6-.3 15.8-5.8 3-5.6 1-11.8-4.5-13.8z'));
exports.YuqueOutline = getIcon('yuque', outline, getNode(newViewBox, 'M854.6 370.6c-9.9-39.4 9.9-102.2 73.4-124.4l-67.9-3.6s-25.7-90-143.6-98c-117.8-8.1-194.9-3-195-3 .1 0 87.4 55.6 52.4 154.7-25.6 52.5-65.8 95.6-108.8 144.7-1.3 1.3-2.5 2.6-3.5 3.7C319.4 605 96 860 96 860c245.9 64.4 410.7-6.3 508.2-91.1 20.5-.2 35.9-.3 46.3-.3 135.8 0 250.6-117.6 245.9-248.4-3.2-89.9-31.9-110.2-41.8-149.6zm-204.1 334c-10.6 0-26.2.1-46.8.3l-23.6.2-17.8 15.5c-47.1 41-104.4 71.5-171.4 87.6-52.5 12.6-110 16.2-172.7 9.6 18-20.5 36.5-41.6 55.4-63.1 92-104.6 173.8-197.5 236.9-268.5l1.4-1.4 1.3-1.5c4.1-4.6 20.6-23.3 24.7-28.1 9.7-11.1 17.3-19.9 24.5-28.6 30.7-36.7 52.2-67.8 69-102.2l1.6-3.3 1.2-3.4c13.7-38.8 15.4-76.9 6.2-112.8 22.5.7 46.5 1.9 71.7 3.6 33.3 2.3 55.5 12.9 71.1 29.2 5.8 6 10.2 12.5 13.4 18.7 1 2 1.7 3.6 2.3 5l5 17.7c-15.7 34.5-19.9 73.3-11.4 107.2 3 11.8 6.9 22.4 12.3 34.4 2.1 4.7 9.5 20.1 11 23.3 10.3 22.7 15.4 43 16.7 78.7 3.3 94.6-82.7 181.9-182 181.9z'));
exports.YoutubeOutline = getIcon('youtube', outline, getNode(newViewBox, 'M960 509.2c0-2.2 0-4.7-.1-7.6-.1-8.1-.3-17.2-.5-26.9-.8-27.9-2.2-55.7-4.4-81.9-3-36.1-7.4-66.2-13.4-88.8a139.52 139.52 0 0 0-98.3-98.5c-28.3-7.6-83.7-12.3-161.7-15.2-37.1-1.4-76.8-2.3-116.5-2.8-13.9-.2-26.8-.3-38.4-.4h-29.4c-11.6.1-24.5.2-38.4.4-39.7.5-79.4 1.4-116.5 2.8-78 3-133.5 7.7-161.7 15.2A139.35 139.35 0 0 0 82.4 304C76.3 326.6 72 356.7 69 392.8c-2.2 26.2-3.6 54-4.4 81.9-.3 9.7-.4 18.8-.5 26.9 0 2.9-.1 5.4-.1 7.6v5.6c0 2.2 0 4.7.1 7.6.1 8.1.3 17.2.5 26.9.8 27.9 2.2 55.7 4.4 81.9 3 36.1 7.4 66.2 13.4 88.8 12.8 47.9 50.4 85.7 98.3 98.5 28.2 7.6 83.7 12.3 161.7 15.2 37.1 1.4 76.8 2.3 116.5 2.8 13.9.2 26.8.3 38.4.4h29.4c11.6-.1 24.5-.2 38.4-.4 39.7-.5 79.4-1.4 116.5-2.8 78-3 133.5-7.7 161.7-15.2 47.9-12.8 85.5-50.5 98.3-98.5 6.1-22.6 10.4-52.7 13.4-88.8 2.2-26.2 3.6-54 4.4-81.9.3-9.7.4-18.8.5-26.9 0-2.9.1-5.4.1-7.6v-5.6zm-72 5.2c0 2.1 0 4.4-.1 7.1-.1 7.8-.3 16.4-.5 25.7-.7 26.6-2.1 53.2-4.2 77.9-2.7 32.2-6.5 58.6-11.2 76.3-6.2 23.1-24.4 41.4-47.4 47.5-21 5.6-73.9 10.1-145.8 12.8-36.4 1.4-75.6 2.3-114.7 2.8-13.7.2-26.4.3-37.8.3h-28.6l-37.8-.3c-39.1-.5-78.2-1.4-114.7-2.8-71.9-2.8-124.9-7.2-145.8-12.8-23-6.2-41.2-24.4-47.4-47.5-4.7-17.7-8.5-44.1-11.2-76.3-2.1-24.7-3.4-51.3-4.2-77.9-.3-9.3-.4-18-.5-25.7 0-2.7-.1-5.1-.1-7.1v-4.8c0-2.1 0-4.4.1-7.1.1-7.8.3-16.4.5-25.7.7-26.6 2.1-53.2 4.2-77.9 2.7-32.2 6.5-58.6 11.2-76.3 6.2-23.1 24.4-41.4 47.4-47.5 21-5.6 73.9-10.1 145.8-12.8 36.4-1.4 75.6-2.3 114.7-2.8 13.7-.2 26.4-.3 37.8-.3h28.6l37.8.3c39.1.5 78.2 1.4 114.7 2.8 71.9 2.8 124.9 7.2 145.8 12.8 23 6.2 41.2 24.4 47.4 47.5 4.7 17.7 8.5 44.1 11.2 76.3 2.1 24.7 3.4 51.3 4.2 77.9.3 9.3.4 18 .5 25.7 0 2.7.1 5.1.1 7.1v4.8zM423 646l232-135-232-133z'));
exports.AlibabaOutline = getIcon('alibaba', outline, getNode(newViewBox, 'M602.9 669.8c-37.2 2.6-33.6-17.3-11.5-46.2 50.4-67.2 143.7-158.5 147.9-225.2 5.8-86.6-81.3-113.4-171-113.4-62.4 1.6-127 18.9-171 34.6-151.6 53.5-246.6 137.5-306.9 232-62.4 93.4-43 183.2 91.8 185.8 101.8-4.2 170.5-32.5 239.7-68.2.5 0-192.5 55.1-263.9 14.7-7.9-4.2-15.7-10-17.8-26.2 0-33.1 54.6-67.7 86.6-78.7v-56.7c64.5 22.6 140.6 16.3 205.7-32 2.1 5.8 4.2 13.1 3.7 21h11c2.6-22.6-12.6-44.6-37.8-46.2 7.3 5.8 12.6 10.5 15.2 14.7l-1 1-.5.5c-83.9 58.8-165.3 31.5-173.1 29.9l46.7-45.7-13.1-33.1c92.9-32.5 169.5-56.2 296.9-78.7l-28.5-23 14.7-8.9c75.5 21 126.4 36.7 123.8 76.6-1 6.8-3.7 14.7-7.9 23.1C660.1 466.1 594 538 567.2 569c-17.3 20.5-34.6 39.4-46.7 58.3-13.6 19.4-20.5 37.3-21 53.5 2.6 131.8 391.4-61.9 468-112.9-111.7 47.8-232.9 93.5-364.6 101.9zm85-302.9c2.8 5.2 4.1 11.6 4.1 19.1-.1-6.8-1.4-13.3-4.1-19.1z'));
exports.AlignCenterOutline = getIcon('align-center', outline, getNode(newViewBox, 'M264 230h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm496 424c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496zm144 140H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-424H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
exports.AlignLeftOutline = getIcon('align-left', outline, getNode(newViewBox, 'M120 230h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0 424h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm784 140H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-424H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
exports.AlignRightOutline = getIcon('align-right', outline, getNode(newViewBox, 'M904 158H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 424H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 212H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-424H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
exports.AlipayOutline = getIcon('alipay', outline, getNode(newViewBox, 'M789 610.3c-38.7-12.9-90.7-32.7-148.5-53.6 34.8-60.3 62.5-129 80.7-203.6H530.5v-68.6h233.6v-38.3H530.5V132h-95.4c-16.7 0-16.7 16.5-16.7 16.5v97.8H182.2v38.3h236.3v68.6H223.4v38.3h378.4a667.18 667.18 0 0 1-54.5 132.9c-122.8-40.4-253.8-73.2-336.1-53-52.6 13-86.5 36.1-106.5 60.3-91.4 111-25.9 279.6 167.2 279.6C386 811.2 496 747.6 581.2 643 708.3 704 960 808.7 960 808.7V659.4s-31.6-2.5-171-49.1zM253.9 746.6c-150.5 0-195-118.3-120.6-183.1 24.8-21.9 70.2-32.6 94.4-35 89.4-8.8 172.2 25.2 269.9 72.8-68.8 89.5-156.3 145.3-243.7 145.3z'));
exports.AliyunOutline = getIcon('aliyun', outline, getNode(newViewBox, 'M959.2 383.9c-.3-82.1-66.9-148.6-149.1-148.6H575.9l21.6 85.2 201 43.7a42.58 42.58 0 0 1 32.9 39.7c.1.5.1 216.1 0 216.6a42.58 42.58 0 0 1-32.9 39.7l-201 43.7-21.6 85.3h234.2c82.1 0 148.8-66.5 149.1-148.6V383.9zM225.5 660.4a42.58 42.58 0 0 1-32.9-39.7c-.1-.6-.1-216.1 0-216.6.8-19.4 14.6-35.5 32.9-39.7l201-43.7 21.6-85.2H213.8c-82.1 0-148.8 66.4-149.1 148.6V641c.3 82.1 67 148.6 149.1 148.6H448l-21.6-85.3-200.9-43.9zm200.9-158.8h171v21.3h-171z'));
exports.AmazonOutline = getIcon('amazon', outline, getNode(newViewBox, 'M825 768.9c-3.3-.9-7.3-.4-11.9 1.3-61.6 28.2-121.5 48.3-179.7 60.2C507.7 856 385.2 842.6 266 790.3c-33.1-14.6-79.1-39.2-138-74a9.36 9.36 0 0 0-5.3-2c-2-.1-3.7.1-5.3.9-1.6.8-2.8 1.8-3.7 3.1-.9 1.3-1.1 3.1-.4 5.4.6 2.2 2.1 4.7 4.6 7.4 10.4 12.2 23.3 25.2 38.6 39s35.6 29.4 60.9 46.8c25.3 17.4 51.8 32.9 79.3 46.4 27.6 13.5 59.6 24.9 96.1 34.1s73 13.8 109.4 13.8c36.2 0 71.4-3.7 105.5-10.9 34.2-7.3 63-15.9 86.5-25.9 23.4-9.9 45-21 64.8-33 19.8-12 34.4-22.2 43.9-30.3 9.5-8.2 16.3-14.6 20.2-19.4 4.6-5.7 6.9-10.6 6.9-14.9.1-4.5-1.7-7.1-5-7.9zM527.4 348.1c-15.2 1.3-33.5 4.1-55 8.3-21.5 4.1-41.4 9.3-59.8 15.4s-37.2 14.6-56.3 25.4c-19.2 10.8-35.5 23.2-49 37s-24.5 31.1-33.1 52c-8.6 20.8-12.9 43.7-12.9 68.7 0 27.1 4.7 51.2 14.3 72.5 9.5 21.3 22.2 38 38.2 50.4 15.9 12.4 34 22.1 54 29.2 20 7.1 41.2 10.3 63.2 9.4 22-.9 43.5-4.3 64.4-10.3 20.8-5.9 40.4-15.4 58.6-28.3 18.2-12.9 33.1-28.2 44.8-45.7 4.3 6.6 8.1 11.5 11.5 14.7l8.7 8.9c5.8 5.9 14.7 14.6 26.7 26.1 11.9 11.5 24.1 22.7 36.3 33.7l104.4-99.9-6-4.9c-4.3-3.3-9.4-8-15.2-14.3-5.8-6.2-11.6-13.1-17.2-20.5-5.7-7.4-10.6-16.1-14.7-25.9-4.1-9.8-6.2-19.3-6.2-28.5V258.7c0-10.1-1.9-21-5.7-32.8-3.9-11.7-10.7-24.5-20.7-38.3-10-13.8-22.4-26.2-37.2-37-14.9-10.8-34.7-20-59.6-27.4-24.8-7.4-52.6-11.1-83.2-11.1-31.3 0-60.4 3.7-87.6 10.9-27.1 7.3-50.3 17-69.7 29.2-19.3 12.2-35.9 26.3-49.7 42.4-13.8 16.1-24.1 32.9-30.8 50.4-6.7 17.5-10.1 35.2-10.1 53.1L408 310c5.5-16.4 12.9-30.6 22-42.8 9.2-12.2 17.9-21 25.8-26.5 8-5.5 16.6-9.9 25.7-13.2 9.2-3.3 15.4-5 18.6-5.4 3.2-.3 5.7-.4 7.6-.4 26.7 0 45.2 7.9 55.6 23.6 6.5 9.5 9.7 23.9 9.7 43.3v56.6c-15.2.6-30.4 1.6-45.6 2.9zM573.1 500c0 16.6-2.2 31.7-6.5 45-9.2 29.1-26.7 47.4-52.4 54.8-22.4 6.6-43.7 3.3-63.9-9.8-21.5-14-32.2-33.8-32.2-59.3 0-19.9 5-36.9 15-51.1 10-14.1 23.3-24.7 40-31.7s33-12 49-14.9c15.9-3 33-4.8 51-5.4V500zm335.2 218.9c-4.3-5.4-15.9-8.9-34.9-10.7-19-1.8-35.5-1.7-49.7.4-15.3 1.8-31.1 6.2-47.3 13.4-16.3 7.1-23.4 13.1-21.6 17.8l.7 1.3.9.7 1.4.2h4.6c.8 0 1.8-.1 3.2-.2 1.4-.1 2.7-.3 3.9-.4 1.2-.1 2.9-.3 5.1-.4 2.1-.1 4.1-.4 6-.7.3 0 3.7-.3 10.3-.9 6.6-.6 11.4-1 14.3-1.3 2.9-.3 7.8-.6 14.5-.9 6.7-.3 12.1-.3 16.1 0 4 .3 8.5.7 13.6 1.1 5.1.4 9.2 1.3 12.4 2.7 3.2 1.3 5.6 3 7.1 5.1 5.2 6.6 4.2 21.2-3 43.9s-14 40.8-20.4 54.2c-2.8 5.7-2.8 9.2 0 10.7s6.7.1 11.9-4c15.6-12.2 28.6-30.6 39.1-55.3 6.1-14.6 10.5-29.8 13.1-45.7 2.4-15.9 2-26.2-1.3-31z'));
exports.AntCloudOutline = getIcon('ant-cloud', outline, getNode(newViewBox, 'M378.9 738c-3.1 0-6.1-.5-8.8-1.5l4.4 30.7h26.3l-15.5-29.9c-2.1.5-4.2.7-6.4.7zm421-291.2c-12.6 0-24.8 1.5-36.5 4.2-21.4-38.4-62.3-64.3-109.3-64.3-6.9 0-13.6.6-20.2 1.6-35.4-77.4-113.4-131.1-203.9-131.1-112.3 0-205.3 82.6-221.6 190.4C127.3 455.5 64 523.8 64 607c0 88.4 71.6 160.1 160 160.2h50l13.2-27.6c-26.2-8.3-43.3-29-39.1-48.8 4.6-21.6 32.8-33.9 63.1-27.5 22.9 4.9 40.4 19.1 45.5 35.1a26.1 26.1 0 0 1 22.1-12.4h.2c-.8-3.2-1.2-6.5-1.2-9.9 0-20.1 14.8-36.7 34.1-39.6v-25.4c0-4.4 3.6-8 8-8s8 3.6 8 8v26.3c4.6 1.2 8.8 3.2 12.6 5.8l19.5-21.4c3-3.3 8-3.5 11.3-.5 3.3 3 3.5 8 .5 11.3l-20 22-.2.2a40 40 0 0 1-46.9 59.2c-.4 5.6-2.6 10.7-6 14.8l20 38.4H804v-.1c86.5-2.2 156-73 156-160.1 0-88.5-71.7-160.2-160.1-160.2zM338.2 737.2l-4.3 30h24.4l-5.9-41.5c-3.5 4.6-8.3 8.5-14.2 11.5zM797.5 305a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm-65.7 61.3a24 24 0 1 0 48 0 24 24 0 1 0-48 0zM303.4 742.9l-11.6 24.3h26l3.5-24.7c-5.7.8-11.7 1-17.9.4z'));
exports.ApartmentOutline = getIcon('apartment', outline, getNode(newViewBox, 'M908 640H804V488c0-4.4-3.6-8-8-8H548v-96h108c8.8 0 16-7.2 16-16V80c0-8.8-7.2-16-16-16H368c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h108v96H228c-4.4 0-8 3.6-8 8v152H116c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16V656c0-8.8-7.2-16-16-16H292v-88h440v88H620c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h288c8.8 0 16-7.2 16-16V656c0-8.8-7.2-16-16-16zm-564 76v168H176V716h168zm84-408V140h168v168H428zm420 576H680V716h168v168z'));
exports.AntDesignOutline = getIcon('ant-design', outline, getNode(newViewBox, 'M716.3 313.8c19-18.9 19-49.7 0-68.6l-69.9-69.9.1.1c-18.5-18.5-50.3-50.3-95.3-95.2-21.2-20.7-55.5-20.5-76.5.5L80.9 474.2a53.84 53.84 0 0 0 0 76.4L474.6 944a54.14 54.14 0 0 0 76.5 0l165.1-165c19-18.9 19-49.7 0-68.6a48.7 48.7 0 0 0-68.7 0l-125 125.2c-5.2 5.2-13.3 5.2-18.5 0L189.5 521.4c-5.2-5.2-5.2-13.3 0-18.5l314.4-314.2c.4-.4.9-.7 1.3-1.1 5.2-4.1 12.4-3.7 17.2 1.1l125.2 125.1c19 19 49.8 19 68.7 0zM408.6 514.4a106.3 106.2 0 1 0 212.6 0 106.3 106.2 0 1 0-212.6 0zm536.2-38.6L821.9 353.5c-19-18.9-49.8-18.9-68.7.1a48.4 48.4 0 0 0 0 68.6l83 82.9c5.2 5.2 5.2 13.3 0 18.5l-81.8 81.7a48.4 48.4 0 0 0 0 68.6 48.7 48.7 0 0 0 68.7 0l121.8-121.7a53.93 53.93 0 0 0-.1-76.4z'));
exports.AreaChartOutline = getIcon('area-chart', outline, getNode(newViewBox, 'M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-616-64h536c4.4 0 8-3.6 8-8V284c0-7.2-8.7-10.7-13.7-5.7L592 488.6l-125.4-124a8.03 8.03 0 0 0-11.3 0l-189 189.6a7.87 7.87 0 0 0-2.3 5.6V720c0 4.4 3.6 8 8 8z'));
exports.ArrowLeftOutline = getIcon('arrow-left', outline, getNode(newViewBox, 'M872 474H286.9l350.2-304c5.6-4.9 2.2-14-5.2-14h-88.5c-3.9 0-7.6 1.4-10.5 3.9L155 487.8a31.96 31.96 0 0 0 0 48.3L535.1 866c1.5 1.3 3.3 2 5.2 2h91.5c7.4 0 10.8-9.2 5.2-14L286.9 550H872c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z'));
exports.ArrowDownOutline = getIcon('arrow-down', outline, getNode(newViewBox, 'M862 465.3h-81c-4.6 0-9 2-12.1 5.5L550 723.1V160c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v563.1L255.1 470.8c-3-3.5-7.4-5.5-12.1-5.5h-81c-6.8 0-10.5 8.1-6 13.2L487.9 861a31.96 31.96 0 0 0 48.3 0L868 478.5c4.5-5.2.8-13.2-6-13.2z'));
exports.ArrowUpOutline = getIcon('arrow-up', outline, getNode(newViewBox, 'M868 545.5L536.1 163a31.96 31.96 0 0 0-48.3 0L156 545.5a7.97 7.97 0 0 0 6 13.2h81c4.6 0 9-2 12.1-5.5L474 300.9V864c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V300.9l218.9 252.3c3 3.5 7.4 5.5 12.1 5.5h81c6.8 0 10.5-8 6-13.2z'));
exports.ArrowsAltOutline = getIcon('arrows-alt', outline, getNode(newViewBox, 'M855 160.1l-189.2 23.5c-6.6.8-9.3 8.8-4.7 13.5l54.7 54.7-153.5 153.5a8.03 8.03 0 0 0 0 11.3l45.1 45.1c3.1 3.1 8.2 3.1 11.3 0l153.6-153.6 54.7 54.7a7.94 7.94 0 0 0 13.5-4.7L863.9 169a7.9 7.9 0 0 0-8.9-8.9zM416.6 562.3a8.03 8.03 0 0 0-11.3 0L251.8 715.9l-54.7-54.7a7.94 7.94 0 0 0-13.5 4.7L160.1 855c-.6 5.2 3.7 9.5 8.9 8.9l189.2-23.5c6.6-.8 9.3-8.8 4.7-13.5l-54.7-54.7 153.6-153.6c3.1-3.1 3.1-8.2 0-11.3l-45.2-45z'));
exports.ArrowRightOutline = getIcon('arrow-right', outline, getNode(newViewBox, 'M869 487.8L491.2 159.9c-2.9-2.5-6.6-3.9-10.5-3.9h-88.5c-7.4 0-10.8 9.2-5.2 14l350.2 304H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h585.1L386.9 854c-5.6 4.9-2.2 14 5.2 14h91.5c1.9 0 3.8-.7 5.2-2L869 536.2a32.07 32.07 0 0 0 0-48.4z'));
exports.AuditOutline = getIcon('audit', outline, getNode(newViewBox, 'M296 250c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm184 144H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-48 458H208V148h560v320c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm440-88H728v-36.6c46.3-13.8 80-56.6 80-107.4 0-61.9-50.1-112-112-112s-112 50.1-112 112c0 50.7 33.7 93.6 80 107.4V764H520c-8.8 0-16 7.2-16 16v152c0 8.8 7.2 16 16 16h352c8.8 0 16-7.2 16-16V780c0-8.8-7.2-16-16-16zM646 620c0-27.6 22.4-50 50-50s50 22.4 50 50-22.4 50-50 50-50-22.4-50-50zm180 266H566v-60h260v60z'));
exports.BarChartOutline = getIcon('bar-chart', outline, getNode(newViewBox, 'M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-600-80h56c4.4 0 8-3.6 8-8V560c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8zm152 0h56c4.4 0 8-3.6 8-8V384c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v320c0 4.4 3.6 8 8 8zm152 0h56c4.4 0 8-3.6 8-8V462c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v242c0 4.4 3.6 8 8 8zm152 0h56c4.4 0 8-3.6 8-8V304c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v400c0 4.4 3.6 8 8 8z'));
exports.BarcodeOutline = getIcon('barcode', outline, getNode(newViewBox, 'M120 160H72c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8zm833 0h-48c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8zM200 736h112c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8H200c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8zm321 0h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8zm126 0h178c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8H647c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8zm-255 0h48c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8zm-79 64H201c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h112c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm257 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm256 0H648c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h178c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-385 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z'));
exports.BarsOutline = getIcon('bars', outline, getNode(normalViewBox, 'M912 192H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM104 228a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm0 284a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm0 284a56 56 0 1 0 112 0 56 56 0 1 0-112 0z'));
exports.BgColorsOutline = getIcon('bg-colors', outline, getNode(newViewBox, 'M766.4 744.3c43.7 0 79.4-36.2 79.4-80.5 0-53.5-79.4-140.8-79.4-140.8S687 610.3 687 663.8c0 44.3 35.7 80.5 79.4 80.5zm-377.1-44.1c7.1 7.1 18.6 7.1 25.6 0l256.1-256c7.1-7.1 7.1-18.6 0-25.6l-256-256c-.6-.6-1.3-1.2-2-1.7l-78.2-78.2a9.11 9.11 0 0 0-12.8 0l-48 48a9.11 9.11 0 0 0 0 12.8l67.2 67.2-207.8 207.9c-7.1 7.1-7.1 18.6 0 25.6l255.9 256zm12.9-448.6l178.9 178.9H223.4l178.8-178.9zM904 816H120c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8z'));
exports.BehanceOutline = getIcon('behance', outline, getNode(newViewBox, 'M634 294.3h199.5v48.4H634zM434.1 485.8c44.1-21.1 67.2-53.2 67.2-102.8 0-98.1-73-121.9-157.3-121.9H112v492.4h238.5c89.4 0 173.3-43 173.3-143 0-61.8-29.2-107.5-89.7-124.7zM220.2 345.1h101.5c39.1 0 74.2 10.9 74.2 56.3 0 41.8-27.3 58.6-66 58.6H220.2V345.1zm115.5 324.8H220.1V534.3H338c47.6 0 77.7 19.9 77.7 70.3 0 49.6-35.9 65.3-80 65.3zm575.8-89.5c0-105.5-61.7-193.4-173.3-193.4-108.5 0-182.3 81.7-182.3 188.8 0 111 69.9 187.2 182.3 187.2 85.1 0 140.2-38.3 166.7-120h-86.3c-9.4 30.5-47.6 46.5-77.3 46.5-57.4 0-87.4-33.6-87.4-90.7h256.9c.3-5.9.7-12.1.7-18.4zM653.9 537c3.1-46.9 34.4-76.2 81.2-76.2 49.2 0 73.8 28.9 78.1 76.2H653.9z'));
exports.BlockOutline = getIcon('block', outline, getNode(newViewBox, 'M856 376H648V168c0-8.8-7.2-16-16-16H168c-8.8 0-16 7.2-16 16v464c0 8.8 7.2 16 16 16h208v208c0 8.8 7.2 16 16 16h464c8.8 0 16-7.2 16-16V392c0-8.8-7.2-16-16-16zm-480 16v188H220V220h360v156H392c-8.8 0-16 7.2-16 16zm204 52v136H444V444h136zm224 360H444V648h188c8.8 0 16-7.2 16-16V444h156v360z'));
exports.BoldOutline = getIcon('bold', outline, getNode(newViewBox, 'M697.8 481.4c33.6-35 54.2-82.3 54.2-134.3v-10.2C752 229.3 663.9 142 555.3 142H259.4c-15.1 0-27.4 12.3-27.4 27.4v679.1c0 16.3 13.2 29.5 29.5 29.5h318.7c117 0 211.8-94.2 211.8-210.5v-11c0-73-37.4-137.3-94.2-175.1zM328 238h224.7c57.1 0 103.3 44.4 103.3 99.3v9.5c0 54.8-46.3 99.3-103.3 99.3H328V238zm366.6 429.4c0 62.9-51.7 113.9-115.5 113.9H328V542.7h251.1c63.8 0 115.5 51 115.5 113.9v10.8z'));
exports.BorderBottomOutline = getIcon('border-bottom', outline, getNode(newViewBox, 'M872 808H152c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-720-94h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0-498h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0 332h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0-166h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm166 166h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0-332h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm332 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0 332h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm222-72h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-388 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm388-404h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-388 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm388 426h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-388 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm388-404h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-388 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z'));
exports.BorderLeftOutline = getIcon('border-left', outline, getNode(newViewBox, 'M208 144h-56c-4.4 0-8 3.6-8 8v720c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V152c0-4.4-3.6-8-8-8zm166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm498 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM540 310h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM374 808h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
exports.BorderOuterOutline = getIcon('border-outer', outline, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656zM484 366h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zM302 548h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm364 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-182 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0 182h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z'));
exports.BorderInnerOutline = getIcon('border-inner', outline, getNode(newViewBox, 'M872 476H548V144h-72v332H152c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h324v332h72V548h324c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-664h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM650 216h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm56 592h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-56-592h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-166 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm56 592h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-56-426h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm56 260h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
exports.BorderRightOutline = getIcon('border-right', outline, getNode(newViewBox, 'M872 144h-56c-4.4 0-8 3.6-8 8v720c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V152c0-4.4-3.6-8-8-8zm-166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-498 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm166 166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM208 808h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm498 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM374 808h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
exports.BorderHorizontalOutline = getIcon('border-horizontal', outline, getNode(newViewBox, 'M540 144h-56c-4.4 0-8 3.6-8 8v720c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V152c0-4.4-3.6-8-8-8zm-166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm498 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-664 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm498 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM208 310h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm664 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-664 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm664 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM374 808h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
exports.BorderTopOutline = getIcon('border-top', outline, getNode(newViewBox, 'M872 144H152c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM208 310h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm166-166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm166 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332-498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 332h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
exports.BorderVerticleOutline = getIcon('border-verticle', outline, getNode(newViewBox, 'M872 476H152c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-166h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-664h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 498h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM650 216h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm56 592h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-56-592h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-166 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm332 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zM208 808h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM152 382h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm332 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zM208 642h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm332 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
exports.BorderOutline = getIcon('border', outline, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'));
exports.BranchesOutline = getIcon('branches', outline, getNode(newViewBox, 'M740 161c-61.8 0-112 50.2-112 112 0 50.1 33.1 92.6 78.5 106.9v95.9L320 602.4V318.1c44.2-15 76-56.9 76-106.1 0-61.8-50.2-112-112-112s-112 50.2-112 112c0 49.2 31.8 91 76 106.1V706c-44.2 15-76 56.9-76 106.1 0 61.8 50.2 112 112 112s112-50.2 112-112c0-49.2-31.8-91-76-106.1v-27.8l423.5-138.7a50.52 50.52 0 0 0 34.9-48.2V378.2c42.9-15.8 73.6-57 73.6-105.2 0-61.8-50.2-112-112-112zm-504 51a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm96 600a48.01 48.01 0 0 1-96 0 48.01 48.01 0 0 1 96 0zm408-491a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'));
exports.CheckOutline = getIcon('check', outline, getNode(newViewBox, 'M912 190h-69.9c-9.8 0-19.1 4.5-25.1 12.2L404.7 724.5 207 474a32 32 0 0 0-25.1-12.2H112c-6.7 0-10.4 7.7-6.3 12.9l273.9 347c12.8 16.2 37.4 16.2 50.3 0l488.4-618.9c4.1-5.1.4-12.8-6.3-12.8z'));
exports.CiOutline = getIcon('ci', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm218-572.1h-50.4c-4.4 0-8 3.6-8 8v384.2c0 4.4 3.6 8 8 8H730c4.4 0 8-3.6 8-8V319.9c0-4.4-3.6-8-8-8zm-281.4 49.6c49.5 0 83.1 31.5 87 77.6.4 4.2 3.8 7.4 8 7.4h52.6c2.4 0 4.4-2 4.4-4.4 0-81.2-64-138.1-152.3-138.1C345.4 304 286 373.5 286 488.4v49c0 114 59.4 182.6 162.3 182.6 88 0 152.3-55.1 152.3-132.5 0-2.4-2-4.4-4.4-4.4h-52.7c-4.2 0-7.6 3.2-8 7.3-4.2 43-37.7 72.4-87 72.4-61.1 0-95.6-44.9-95.6-125.2v-49.3c.1-81.4 34.6-126.8 95.7-126.8z'));
exports.CloseOutline = getIcon('close', outline, getNode(newViewBox, 'M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 0 0 203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z'));
exports.CloudDownloadOutline = getIcon('cloud-download', outline, getNode(newViewBox, 'M624 706.3h-74.1V464c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v242.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.7a8 8 0 0 0 12.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9z', 'M811.4 366.7C765.6 245.9 648.9 160 512.2 160S258.8 245.8 213 366.6C127.3 389.1 64 467.2 64 560c0 110.5 89.5 200 199.9 200H304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8h-40.1c-33.7 0-65.4-13.4-89-37.7-23.5-24.2-36-56.8-34.9-90.6.9-26.4 9.9-51.2 26.2-72.1 16.7-21.3 40.1-36.8 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0 1 52.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10C846.1 454.5 884 503.8 884 560c0 33.1-12.9 64.3-36.3 87.7a123.07 123.07 0 0 1-87.6 36.3H720c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h40.1C870.5 760 960 670.5 960 560c0-92.7-63.1-170.7-148.6-193.3z'));
exports.CloudServerOutline = getIcon('cloud-server', outline, getNode(newViewBox, 'M704 446H320c-4.4 0-8 3.6-8 8v402c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8V454c0-4.4-3.6-8-8-8zm-328 64h272v117H376V510zm272 290H376V683h272v117z', 'M424 748a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm0-178a32 32 0 1 0 64 0 32 32 0 1 0-64 0z', 'M811.4 368.9C765.6 248 648.9 162 512.2 162S258.8 247.9 213 368.8C126.9 391.5 63.5 470.2 64 563.6 64.6 668 145.6 752.9 247.6 762c4.7.4 8.7-3.3 8.7-8v-60.4c0-4-3-7.4-7-7.9-27-3.4-52.5-15.2-72.1-34.5-24-23.5-37.2-55.1-37.2-88.6 0-28 9.1-54.4 26.2-76.4 16.7-21.4 40.2-36.9 66.1-43.7l37.9-10 13.9-36.7c8.6-22.8 20.6-44.2 35.7-63.5 14.9-19.2 32.6-36 52.4-50 41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.3c19.9 14 37.5 30.8 52.4 50 15.1 19.3 27.1 40.7 35.7 63.5l13.8 36.6 37.8 10c54.2 14.4 92.1 63.7 92.1 120 0 33.6-13.2 65.1-37.2 88.6-19.5 19.2-44.9 31.1-71.9 34.5-4 .5-6.9 3.9-6.9 7.9V754c0 4.7 4.1 8.4 8.8 8 101.7-9.2 182.5-94 183.2-198.2.6-93.4-62.7-172.1-148.6-194.9z'));
exports.CloudSyncOutline = getIcon('cloud-sync', outline, getNode(newViewBox, 'M811.4 368.9C765.6 248 648.9 162 512.2 162S258.8 247.9 213 368.8C126.9 391.5 63.5 470.2 64 563.6 64.6 668 145.6 752.9 247.6 762c4.7.4 8.7-3.3 8.7-8v-60.4c0-4-3-7.4-7-7.9-27-3.4-52.5-15.2-72.1-34.5-24-23.5-37.2-55.1-37.2-88.6 0-28 9.1-54.4 26.2-76.4 16.7-21.4 40.2-36.9 66.1-43.7l37.9-10 13.9-36.7c8.6-22.8 20.6-44.2 35.7-63.5 14.9-19.2 32.6-36 52.4-50 41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.3c19.9 14 37.5 30.8 52.4 50 15.1 19.3 27.1 40.7 35.7 63.5l13.8 36.6 37.8 10c54.2 14.4 92.1 63.7 92.1 120 0 33.6-13.2 65.1-37.2 88.6-19.5 19.2-44.9 31.1-71.9 34.5-4 .5-6.9 3.9-6.9 7.9V754c0 4.7 4.1 8.4 8.8 8 101.7-9.2 182.5-94 183.2-198.2.6-93.4-62.7-172.1-148.6-194.9z', 'M376.9 656.4c1.8-33.5 15.7-64.7 39.5-88.6 25.4-25.5 60-39.8 96-39.8 36.2 0 70.3 14.1 96 39.8 1.4 1.4 2.7 2.8 4.1 4.3l-25 19.6a8 8 0 0 0 3 14.1l98.2 24c5 1.2 9.9-2.6 9.9-7.7l.5-101.3c0-6.7-7.6-10.5-12.9-6.3L663 532.7c-36.6-42-90.4-68.6-150.5-68.6-107.4 0-195 85.1-199.4 191.7-.2 4.5 3.4 8.3 8 8.3H369c4.2-.1 7.7-3.4 7.9-7.7zM703 664h-47.9c-4.2 0-7.7 3.3-8 7.6-1.8 33.5-15.7 64.7-39.5 88.6-25.4 25.5-60 39.8-96 39.8-36.2 0-70.3-14.1-96-39.8-1.4-1.4-2.7-2.8-4.1-4.3l25-19.6a8 8 0 0 0-3-14.1l-98.2-24c-5-1.2-9.9 2.6-9.9 7.7l-.4 101.4c0 6.7 7.6 10.5 12.9 6.3l23.2-18.2c36.6 42 90.4 68.6 150.5 68.6 107.4 0 195-85.1 199.4-191.7.2-4.5-3.4-8.3-8-8.3z'));
exports.CloudUploadOutline = getIcon('cloud-upload', outline, getNode(newViewBox, 'M518.3 459a8 8 0 0 0-12.6 0l-112 141.7a7.98 7.98 0 0 0 6.3 12.9h73.9V856c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V613.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 459z', 'M811.4 366.7C765.6 245.9 648.9 160 512.2 160S258.8 245.8 213 366.6C127.3 389.1 64 467.2 64 560c0 110.5 89.5 200 199.9 200H304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8h-40.1c-33.7 0-65.4-13.4-89-37.7-23.5-24.2-36-56.8-34.9-90.6.9-26.4 9.9-51.2 26.2-72.1 16.7-21.3 40.1-36.8 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0 1 52.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10C846.1 454.5 884 503.8 884 560c0 33.1-12.9 64.3-36.3 87.7a123.07 123.07 0 0 1-87.6 36.3H720c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h40.1C870.5 760 960 670.5 960 560c0-92.7-63.1-170.7-148.6-193.3z'));
exports.ClusterOutline = getIcon('cluster', outline, getNode(newViewBox, 'M888 680h-54V540H546v-92h238c8.8 0 16-7.2 16-16V168c0-8.8-7.2-16-16-16H240c-8.8 0-16 7.2-16 16v264c0 8.8 7.2 16 16 16h238v92H190v140h-54c-4.4 0-8 3.6-8 8v176c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8V688c0-4.4-3.6-8-8-8h-54v-72h220v72h-54c-4.4 0-8 3.6-8 8v176c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8V688c0-4.4-3.6-8-8-8h-54v-72h220v72h-54c-4.4 0-8 3.6-8 8v176c0 4.4 3.6 8 8 8h176c4.4 0 8-3.6 8-8V688c0-4.4-3.6-8-8-8zM256 805.3c0 1.5-1.2 2.7-2.7 2.7h-58.7c-1.5 0-2.7-1.2-2.7-2.7v-58.7c0-1.5 1.2-2.7 2.7-2.7h58.7c1.5 0 2.7 1.2 2.7 2.7v58.7zm288 0c0 1.5-1.2 2.7-2.7 2.7h-58.7c-1.5 0-2.7-1.2-2.7-2.7v-58.7c0-1.5 1.2-2.7 2.7-2.7h58.7c1.5 0 2.7 1.2 2.7 2.7v58.7zM288 384V216h448v168H288zm544 421.3c0 1.5-1.2 2.7-2.7 2.7h-58.7c-1.5 0-2.7-1.2-2.7-2.7v-58.7c0-1.5 1.2-2.7 2.7-2.7h58.7c1.5 0 2.7 1.2 2.7 2.7v58.7zM360 300a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'));
exports.CodepenOutline = getIcon('codepen', outline, getNode(newViewBox, 'M911.7 385.3l-.3-1.5c-.2-1-.3-1.9-.6-2.9-.2-.6-.4-1.1-.5-1.7-.3-.8-.5-1.7-.9-2.5-.2-.6-.5-1.1-.8-1.7-.4-.8-.8-1.5-1.2-2.3-.3-.5-.6-1.1-1-1.6-.8-1.2-1.7-2.4-2.6-3.6-.5-.6-1.1-1.3-1.7-1.9-.4-.5-.9-.9-1.4-1.3-.6-.6-1.3-1.1-1.9-1.6-.5-.4-1-.8-1.6-1.2-.2-.1-.4-.3-.6-.4L531.1 117.8a34.3 34.3 0 0 0-38.1 0L127.3 361.3c-.2.1-.4.3-.6.4-.5.4-1 .8-1.6 1.2-.7.5-1.3 1.1-1.9 1.6-.5.4-.9.9-1.4 1.3-.6.6-1.2 1.2-1.7 1.9-1 1.1-1.8 2.3-2.6 3.6-.3.5-.7 1-1 1.6-.4.7-.8 1.5-1.2 2.3-.3.5-.5 1.1-.8 1.7-.3.8-.6 1.7-.9 2.5-.2.6-.4 1.1-.5 1.7-.2.9-.4 1.9-.6 2.9l-.3 1.5c-.2 1.5-.3 3-.3 4.5v243.5c0 1.5.1 3 .3 4.5l.3 1.5.6 2.9c.2.6.3 1.1.5 1.7.3.9.6 1.7.9 2.5.2.6.5 1.1.8 1.7.4.8.7 1.5 1.2 2.3.3.5.6 1.1 1 1.6.5.7.9 1.4 1.5 2.1l1.2 1.5c.5.6 1.1 1.3 1.7 1.9.4.5.9.9 1.4 1.3.6.6 1.3 1.1 1.9 1.6.5.4 1 .8 1.6 1.2.2.1.4.3.6.4L493 905.7c5.6 3.8 12.3 5.8 19.1 5.8 6.6 0 13.3-1.9 19.1-5.8l365.6-243.5c.2-.1.4-.3.6-.4.5-.4 1-.8 1.6-1.2.7-.5 1.3-1.1 1.9-1.6.5-.4.9-.9 1.4-1.3.6-.6 1.2-1.2 1.7-1.9l1.2-1.5 1.5-2.1c.3-.5.7-1 1-1.6.4-.8.8-1.5 1.2-2.3.3-.5.5-1.1.8-1.7.3-.8.6-1.7.9-2.5.2-.5.4-1.1.5-1.7.3-.9.4-1.9.6-2.9l.3-1.5c.2-1.5.3-3 .3-4.5V389.8c-.3-1.5-.4-3-.6-4.5zM546.4 210.5l269.4 179.4-120.3 80.4-149-99.6V210.5zm-68.8 0v160.2l-149 99.6-120.3-80.4 269.3-179.4zM180.7 454.1l86 57.5-86 57.5v-115zm296.9 358.5L208.3 633.2l120.3-80.4 149 99.6v160.2zM512 592.8l-121.6-81.2L512 430.3l121.6 81.2L512 592.8zm34.4 219.8V652.4l149-99.6 120.3 80.4-269.3 179.4zM843.3 569l-86-57.5 86-57.5v115z'));
exports.CodeSandboxOutline = getIcon('code-sandbox', outline, getNode(newViewBox, 'M709.6 210l.4-.2h.2L512 96 313.9 209.8h-.2l.7.3L151.5 304v416L512 928l360.5-208V304l-162.9-94zM482.7 843.6L339.6 761V621.4L210 547.8V372.9l272.7 157.3v313.4zM238.2 321.5l134.7-77.8 138.9 79.7 139.1-79.9 135.2 78-273.9 158-274-158zM814 548.3l-128.8 73.1v139.1l-143.9 83V530.4L814 373.1v175.2z'));
exports.ColumHeightOutline = getIcon('colum-height', outline, getNode(newViewBox, 'M840 836H184c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h656c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm0-724H184c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h656c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zM610.8 378c6 0 9.4-7 5.7-11.7L515.7 238.7a7.14 7.14 0 0 0-11.3 0L403.6 366.3a7.23 7.23 0 0 0 5.7 11.7H476v268h-62.8c-6 0-9.4 7-5.7 11.7l100.8 127.5c2.9 3.7 8.5 3.7 11.3 0l100.8-127.5c3.7-4.7.4-11.7-5.7-11.7H548V378h62.8z'));
exports.ColumnWidthOutline = getIcon('column-width', outline, getNode(newViewBox, 'M180 176h-60c-4.4 0-8 3.6-8 8v656c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V184c0-4.4-3.6-8-8-8zm724 0h-60c-4.4 0-8 3.6-8 8v656c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V184c0-4.4-3.6-8-8-8zM785.3 504.3L657.7 403.6a7.23 7.23 0 0 0-11.7 5.7V476H378v-62.8c0-6-7-9.4-11.7-5.7L238.7 508.3a7.14 7.14 0 0 0 0 11.3l127.5 100.8c4.7 3.7 11.7.4 11.7-5.7V548h268v62.8c0 6 7 9.4 11.7 5.7l127.5-100.8c3.8-2.9 3.8-8.5.2-11.4z'));
exports.ColumnHeightOutline = getIcon('column-height', outline, getNode(newViewBox, 'M840 836H184c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h656c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm0-724H184c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h656c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zM610.8 378c6 0 9.4-7 5.7-11.7L515.7 238.7a7.14 7.14 0 0 0-11.3 0L403.6 366.3a7.23 7.23 0 0 0 5.7 11.7H476v268h-62.8c-6 0-9.4 7-5.7 11.7l100.8 127.5c2.9 3.7 8.5 3.7 11.3 0l100.8-127.5c3.7-4.7.4-11.7-5.7-11.7H548V378h62.8z'));
exports.CoffeeOutline = getIcon('coffee', outline, getNode(normalViewBox, 'M275 281c19.9 0 36-16.1 36-36V36c0-19.9-16.1-36-36-36s-36 16.1-36 36v209c0 19.9 16.1 36 36 36zm613 144H768c0-39.8-32.2-72-72-72H200c-39.8 0-72 32.2-72 72v248c0 3.4.2 6.7.7 9.9-.5 7-.7 14-.7 21.1 0 176.7 143.3 320 320 320 160.1 0 292.7-117.5 316.3-271H888c39.8 0 72-32.2 72-72V497c0-39.8-32.2-72-72-72zM696 681h-1.1c.7 7.6 1.1 15.2 1.1 23 0 137-111 248-248 248S200 841 200 704c0-7.8.4-15.4 1.1-23H200V425h496v256zm192-8H776V497h112v176zM613 281c19.9 0 36-16.1 36-36V36c0-19.9-16.1-36-36-36s-36 16.1-36 36v209c0 19.9 16.1 36 36 36zm-170 0c19.9 0 36-16.1 36-36V36c0-19.9-16.1-36-36-36s-36 16.1-36 36v209c0 19.9 16.1 36 36 36z'));
exports.CopyrightOutline = getIcon('copyright', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm5.6-532.7c53 0 89 33.8 93 83.4.3 4.2 3.8 7.4 8 7.4h56.7c2.6 0 4.7-2.1 4.7-4.7 0-86.7-68.4-147.4-162.7-147.4C407.4 290 344 364.2 344 486.8v52.3C344 660.8 407.4 734 517.3 734c94 0 162.7-58.8 162.7-141.4 0-2.6-2.1-4.7-4.7-4.7h-56.8c-4.2 0-7.6 3.2-8 7.3-4.2 46.1-40.1 77.8-93 77.8-65.3 0-102.1-47.9-102.1-133.6v-52.6c.1-87 37-135.5 102.2-135.5z'));
exports.DashOutline = getIcon('dash', outline, getNode(newViewBox, 'M112 476h160v72H112zm320 0h160v72H432zm320 0h160v72H752z'));
exports.DeploymentUnitOutline = getIcon('deployment-unit', outline, getNode(newViewBox, 'M888.3 693.2c-42.5-24.6-94.3-18-129.2 12.8l-53-30.7V523.6c0-15.7-8.4-30.3-22-38.1l-136-78.3v-67.1c44.2-15 76-56.8 76-106.1 0-61.9-50.1-112-112-112s-112 50.1-112 112c0 49.3 31.8 91.1 76 106.1v67.1l-136 78.3c-13.6 7.8-22 22.4-22 38.1v151.6l-53 30.7c-34.9-30.8-86.8-37.4-129.2-12.8-53.5 31-71.7 99.4-41 152.9 30.8 53.5 98.9 71.9 152.2 41 42.5-24.6 62.7-73 53.6-118.8l48.7-28.3 140.6 81c6.8 3.9 14.4 5.9 22 5.9s15.2-2 22-5.9L674.5 740l48.7 28.3c-9.1 45.7 11.2 94.2 53.6 118.8 53.3 30.9 121.5 12.6 152.2-41 30.8-53.6 12.6-122-40.7-152.9zm-673 138.4a47.6 47.6 0 0 1-65.2-17.6c-13.2-22.9-5.4-52.3 17.5-65.5a47.6 47.6 0 0 1 65.2 17.6c13.2 22.9 5.4 52.3-17.5 65.5zM522 463.8zM464 234a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm170 446.2l-122 70.3-122-70.3V539.8l122-70.3 122 70.3v140.4zm239.9 133.9c-13.2 22.9-42.4 30.8-65.2 17.6-22.8-13.2-30.7-42.6-17.5-65.5s42.4-30.8 65.2-17.6c22.9 13.2 30.7 42.5 17.5 65.5z'));
exports.DesktopOutline = getIcon('desktop', outline, getNode(newViewBox, 'M928 140H96c-17.7 0-32 14.3-32 32v496c0 17.7 14.3 32 32 32h380v112H304c-8.8 0-16 7.2-16 16v48c0 4.4 3.6 8 8 8h432c4.4 0 8-3.6 8-8v-48c0-8.8-7.2-16-16-16H548V700h380c17.7 0 32-14.3 32-32V172c0-17.7-14.3-32-32-32zm-40 488H136V212h752v416z'));
exports.DingdingOutline = getIcon('dingding', outline, getNode(newViewBox, 'M573.7 252.5C422.5 197.4 201.3 96.7 201.3 96.7c-15.7-4.1-17.9 11.1-17.9 11.1-5 61.1 33.6 160.5 53.6 182.8 19.9 22.3 319.1 113.7 319.1 113.7S326 357.9 270.5 341.9c-55.6-16-37.9 17.8-37.9 17.8 11.4 61.7 64.9 131.8 107.2 138.4 42.2 6.6 220.1 4 220.1 4s-35.5 4.1-93.2 11.9c-42.7 5.8-97 12.5-111.1 17.8-33.1 12.5 24 62.6 24 62.6 84.7 76.8 129.7 50.5 129.7 50.5 33.3-10.7 61.4-18.5 85.2-24.2L565 743.1h84.6L603 928l205.3-271.9H700.8l22.3-38.7c.3.5.4.8.4.8S799.8 496.1 829 433.8l.6-1h-.1c5-10.8 8.6-19.7 10-25.8 17-71.3-114.5-99.4-265.8-154.5z'));
exports.DisconnectOutline = getIcon('disconnect', outline, getNode(newViewBox, 'M832.6 191.4c-84.6-84.6-221.5-84.6-306 0l-96.9 96.9 51 51 96.9-96.9c53.8-53.8 144.6-59.5 204 0 59.5 59.5 53.8 150.2 0 204l-96.9 96.9 51.1 51.1 96.9-96.9c84.4-84.6 84.4-221.5-.1-306.1zM446.5 781.6c-53.8 53.8-144.6 59.5-204 0-59.5-59.5-53.8-150.2 0-204l96.9-96.9-51.1-51.1-96.9 96.9c-84.6 84.6-84.6 221.5 0 306s221.5 84.6 306 0l96.9-96.9-51-51-96.8 97zM260.3 209.4a8.03 8.03 0 0 0-11.3 0L209.4 249a8.03 8.03 0 0 0 0 11.3l554.4 554.4c3.1 3.1 8.2 3.1 11.3 0l39.6-39.6c3.1-3.1 3.1-8.2 0-11.3L260.3 209.4z'));
exports.DollarOutline = getIcon('dollar', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm47.7-395.2l-25.4-5.9V348.6c38 5.2 61.5 29 65.5 58.2.5 4 3.9 6.9 7.9 6.9h44.9c4.7 0 8.4-4.1 8-8.8-6.1-62.3-57.4-102.3-125.9-109.2V263c0-4.4-3.6-8-8-8h-28.1c-4.4 0-8 3.6-8 8v33c-70.8 6.9-126.2 46-126.2 119 0 67.6 49.8 100.2 102.1 112.7l24.7 6.3v142.7c-44.2-5.9-69-29.5-74.1-61.3-.6-3.8-4-6.6-7.9-6.6H363c-4.7 0-8.4 4-8 8.7 4.5 55 46.2 105.6 135.2 112.1V761c0 4.4 3.6 8 8 8h28.4c4.4 0 8-3.6 8-8.1l-.2-31.7c78.3-6.9 134.3-48.8 134.3-124-.1-69.4-44.2-100.4-109-116.4zm-68.6-16.2c-5.6-1.6-10.3-3.1-15-5-33.8-12.2-49.5-31.9-49.5-57.3 0-36.3 27.5-57 64.5-61.7v124zM534.3 677V543.3c3.1.9 5.9 1.6 8.8 2.2 47.3 14.4 63.2 34.4 63.2 65.1 0 39.1-29.4 62.6-72 66.4z'));
exports.DoubleRightOutline = getIcon('double-right', outline, getNode(newViewBox, 'M533.2 492.3L277.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H188c-6.7 0-10.4 7.7-6.3 12.9L447.1 512 181.7 851.1A7.98 7.98 0 0 0 188 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5zm304 0L581.9 166.1c-3-3.9-7.7-6.1-12.6-6.1H492c-6.7 0-10.4 7.7-6.3 12.9L751.1 512 485.7 851.1A7.98 7.98 0 0 0 492 864h77.3c4.9 0 9.6-2.3 12.6-6.1l255.3-326.1c9.1-11.7 9.1-27.9 0-39.5z'));
exports.DotChartOutline = getIcon('dot-chart', outline, getNode(newViewBox, 'M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM288 604a64 64 0 1 0 128 0 64 64 0 1 0-128 0zm118-224a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm158 228a96 96 0 1 0 192 0 96 96 0 1 0-192 0zm148-314a56 56 0 1 0 112 0 56 56 0 1 0-112 0z'));
exports.DoubleLeftOutline = getIcon('double-left', outline, getNode(newViewBox, 'M272.9 512l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L186.8 492.3a31.99 31.99 0 0 0 0 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H532c6.7 0 10.4-7.7 6.3-12.9L272.9 512zm304 0l265.4-339.1c4.1-5.2.4-12.9-6.3-12.9h-77.3c-4.9 0-9.6 2.3-12.6 6.1L490.8 492.3a31.99 31.99 0 0 0 0 39.5l255.3 326.1c3 3.9 7.7 6.1 12.6 6.1H836c6.7 0 10.4-7.7 6.3-12.9L576.9 512z'));
exports.DownloadOutline = getIcon('download', outline, getNode(newViewBox, 'M505.7 661a8 8 0 0 0 12.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9h-74.1V168c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v338.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.8zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z'));
exports.DribbbleOutline = getIcon('dribbble', outline, getNode(newViewBox, 'M512 96C282.6 96 96 282.6 96 512s186.6 416 416 416 416-186.6 416-416S741.4 96 512 96zm275.1 191.8c49.5 60.5 79.5 137.5 80.2 221.4-11.7-2.5-129.2-26.3-247.4-11.4-2.5-6.1-5-12.2-7.6-18.3-7.4-17.3-15.3-34.6-23.6-51.5C720 374.3 779.6 298 787.1 287.8zM512 157.2c90.3 0 172.8 33.9 235.5 89.5-6.4 9.1-59.9 81-186.2 128.4-58.2-107-122.7-194.8-132.6-208 27.3-6.6 55.2-9.9 83.3-9.9zM360.9 191c9.4 12.8 72.9 100.9 131.7 205.5C326.4 440.6 180 440 164.1 439.8c23.1-110.3 97.4-201.9 196.8-248.8zM156.7 512.5c0-3.6.1-7.3.2-10.9 15.5.3 187.7 2.5 365.2-50.6 10.2 19.9 19.9 40.1 28.8 60.3-4.7 1.3-9.4 2.7-14 4.2C353.6 574.9 256.1 736.4 248 750.1c-56.7-63-91.3-146.3-91.3-237.6zM512 867.8c-82.2 0-157.9-28-218.1-75 6.4-13.1 78.3-152 278.7-221.9l2.3-.8c49.9 129.6 70.5 238.3 75.8 269.5A350.46 350.46 0 0 1 512 867.8zm198.5-60.7c-3.6-21.6-22.5-125.6-69-253.3C752.9 536 850.7 565.2 862.8 569c-15.8 98.8-72.5 184.2-152.3 238.1z'));
exports.DropboxOutline = getIcon('dropbox', outline, getNode(newViewBox, 'M64 556.9l264.2 173.5L512.5 577 246.8 412.7zm896-290.3zm0 0L696.8 95 512.5 248.5l265.2 164.2L512.5 577l184.3 153.4L960 558.8 777.7 412.7zM513 609.8L328.2 763.3l-79.4-51.5v57.8L513 928l263.7-158.4v-57.8l-78.9 51.5zM328.2 95L64 265.1l182.8 147.6 265.7-164.2zM64 556.9z'));
exports.EllipsisOutline = getIcon('ellipsis', outline, getNode(newViewBox, 'M176 511a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm280 0a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm280 0a56 56 0 1 0 112 0 56 56 0 1 0-112 0z'));
exports.EnterOutline = getIcon('enter', outline, getNode(newViewBox, 'M864 170h-60c-4.4 0-8 3.6-8 8v518H310v-73c0-6.7-7.8-10.5-13-6.3l-141.9 112a8 8 0 0 0 0 12.6l141.9 112c5.3 4.2 13 .4 13-6.3v-75h498c35.3 0 64-28.7 64-64V178c0-4.4-3.6-8-8-8z'));
exports.EuroOutline = getIcon('euro', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm117.7-588.6c-15.9-3.5-34.4-5.4-55.3-5.4-106.7 0-178.9 55.7-198.6 149.9H344c-4.4 0-8 3.6-8 8v27.2c0 4.4 3.6 8 8 8h26.4c-.3 4.1-.3 8.4-.3 12.8v36.9H344c-4.4 0-8 3.6-8 8V568c0 4.4 3.6 8 8 8h30.2c17.2 99.2 90.4 158 200.2 158 20.9 0 39.4-1.7 55.3-5.1 3.7-.8 6.4-4 6.4-7.8v-42.8c0-5-4.6-8.8-9.5-7.8-14.7 2.8-31.9 4.1-51.8 4.1-68.5 0-114.5-36.6-129.8-98.6h130.6c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H439.2v-36c0-4.7 0-9.4.3-13.8h135.9c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H447.1c17.2-56.9 62.3-90.4 127.6-90.4 19.9 0 37.1 1.5 51.7 4.4a8 8 0 0 0 9.6-7.8v-42.8c0-3.8-2.6-7-6.3-7.8z'));
exports.ExceptionOutline = getIcon('exception', outline, getNode(newViewBox, 'M688 312v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8zm-392 88c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm376 116c-119.3 0-216 96.7-216 216s96.7 216 216 216 216-96.7 216-216-96.7-216-216-216zm107.5 323.5C750.8 868.2 712.6 884 672 884s-78.8-15.8-107.5-44.5C535.8 810.8 520 772.6 520 732s15.8-78.8 44.5-107.5C593.2 595.8 631.4 580 672 580s78.8 15.8 107.5 44.5C808.2 653.2 824 691.4 824 732s-15.8 78.8-44.5 107.5zM640 812a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm12-64h40c4.4 0 8-3.6 8-8V628c0-4.4-3.6-8-8-8h-40c-4.4 0-8 3.6-8 8v112c0 4.4 3.6 8 8 8zM440 852H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h272c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
exports.ExclamationOutline = getIcon('exclamation', outline, getNode(newViewBox, 'M448 804a64 64 0 1 0 128 0 64 64 0 1 0-128 0zm32-168h64c4.4 0 8-3.6 8-8V164c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8z'));
exports.ExportOutline = getIcon('export', outline, getNode(newViewBox, 'M888.3 757.4h-53.8c-4.2 0-7.7 3.5-7.7 7.7v61.8H197.1V197.1h629.8v61.8c0 4.2 3.5 7.7 7.7 7.7h53.8c4.2 0 7.7-3.4 7.7-7.7V158.7c0-17-13.7-30.7-30.7-30.7H158.7c-17 0-30.7 13.7-30.7 30.7v706.6c0 17 13.7 30.7 30.7 30.7h706.6c17 0 30.7-13.7 30.7-30.7V765.1c0-4.3-3.5-7.7-7.7-7.7zm18.6-251.7L765 393.7c-5.3-4.2-13-.4-13 6.3v76H438c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h314v76c0 6.7 7.8 10.5 13 6.3l141.9-112a8 8 0 0 0 0-12.6z'));
exports.FallOutline = getIcon('fall', outline, getNode(newViewBox, 'M925.9 804l-24-199.2c-.8-6.6-8.9-9.4-13.6-4.7L829 659.5 557.7 388.3c-6.3-6.2-16.4-6.2-22.6 0L433.3 490 156.6 213.3a8.03 8.03 0 0 0-11.3 0l-45 45.2a8.03 8.03 0 0 0 0 11.3L422 591.7c6.2 6.3 16.4 6.3 22.6 0L546.4 490l226.1 226-59.3 59.3a8.01 8.01 0 0 0 4.7 13.6l199.2 24c5.1.7 9.5-3.7 8.8-8.9z'));
exports.FileDoneOutline = getIcon('file-done', outline, getNode(newViewBox, 'M688 312v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8zm-392 88c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm376 116c-119.3 0-216 96.7-216 216s96.7 216 216 216 216-96.7 216-216-96.7-216-216-216zm107.5 323.5C750.8 868.2 712.6 884 672 884s-78.8-15.8-107.5-44.5C535.8 810.8 520 772.6 520 732s15.8-78.8 44.5-107.5C593.2 595.8 631.4 580 672 580s78.8 15.8 107.5 44.5C808.2 653.2 824 691.4 824 732s-15.8 78.8-44.5 107.5zM761 656h-44.3c-2.6 0-5 1.2-6.5 3.3l-63.5 87.8-23.1-31.9a7.92 7.92 0 0 0-6.5-3.3H573c-6.5 0-10.3 7.4-6.5 12.7l73.8 102.1c3.2 4.4 9.7 4.4 12.9 0l114.2-158c3.9-5.3.1-12.7-6.4-12.7zM440 852H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h272c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
exports.FileSyncOutline = getIcon('file-sync', outline, getNode(newViewBox, 'M296 256c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm192 200v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8zm-48 396H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h272c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm104.1-115.6c1.8-34.5 16.2-66.8 40.8-91.4 26.2-26.2 62-41 99.1-41 37.4 0 72.6 14.6 99.1 41 3.2 3.2 6.3 6.6 9.2 10.1L769.2 673a8 8 0 0 0 3 14.1l93.3 22.5c5 1.2 9.8-2.6 9.9-7.7l.6-95.4a8 8 0 0 0-12.9-6.4l-20.3 15.8C805.4 569.6 748.1 540 684 540c-109.9 0-199.6 86.9-204 195.7-.2 4.5 3.5 8.3 8 8.3h48.1c4.3 0 7.8-3.3 8-7.6zM880 744h-48.1c-4.3 0-7.8 3.3-8 7.6-1.8 34.5-16.2 66.8-40.8 91.4-26.2 26.2-62 41-99.1 41-37.4 0-72.6-14.6-99.1-41-3.2-3.2-6.3-6.6-9.2-10.1l23.1-17.9a8 8 0 0 0-3-14.1l-93.3-22.5c-5-1.2-9.8 2.6-9.9 7.7l-.6 95.4a8 8 0 0 0 12.9 6.4l20.3-15.8C562.6 918.4 619.9 948 684 948c109.9 0 199.6-86.9 204-195.7.2-4.5-3.5-8.3-8-8.3z'));
exports.FileProtectOutline = getIcon('file-protect', outline, getNode(newViewBox, 'M644.7 669.2a7.92 7.92 0 0 0-6.5-3.3H594c-6.5 0-10.3 7.4-6.5 12.7l73.8 102.1c3.2 4.4 9.7 4.4 12.9 0l114.2-158c3.8-5.3 0-12.7-6.5-12.7h-44.3c-2.6 0-5 1.2-6.5 3.3l-63.5 87.8-22.9-31.9zM688 306v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8zm-392 88c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm184 458H208V148h560v296c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h312c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm402.6-320.8l-192-66.7c-.9-.3-1.7-.4-2.6-.4s-1.8.1-2.6.4l-192 66.7a7.96 7.96 0 0 0-5.4 7.5v251.1c0 2.5 1.1 4.8 3.1 6.3l192 150.2c1.4 1.1 3.2 1.7 4.9 1.7s3.5-.6 4.9-1.7l192-150.2c1.9-1.5 3.1-3.8 3.1-6.3V538.7c0-3.4-2.2-6.4-5.4-7.5zM826 763.7L688 871.6 550 763.7V577l138-48 138 48v186.7z'));
exports.FileSearchOutline = getIcon('file-search', outline, getNode(newViewBox, 'M688 312v-48c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8zm-392 88c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H296zm144 452H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h272c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm445.7 51.5l-93.3-93.3C814.7 780.7 828 743.9 828 704c0-97.2-78.8-176-176-176s-176 78.8-176 176 78.8 176 176 176c35.8 0 69-10.7 96.8-29l94.7 94.7c1.6 1.6 3.6 2.3 5.6 2.3s4.1-.8 5.6-2.3l31-31a7.9 7.9 0 0 0 0-11.2zM652 816c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z'));
exports.FileJpgOutline = getIcon('file-jpg', outline, getNode(normalViewBox, 'M874.6 301.8L596.8 21.3c-4.5-4.5-9.4-8.3-14.7-11.5-1.4-.8-2.8-1.6-4.3-2.3-.9-.5-1.9-.9-2.8-1.3-9-4-18.9-6.2-29-6.2H201c-39.8 0-73 32.2-73 72v880c0 39.8 33.2 72 73 72h623c39.8 0 71-32.2 71-72V352.5c0-19-7-37.2-20.4-50.7zM583 110.4L783.8 312H583V110.4zM823 952H200V72h311v240c0 39.8 33.2 72 73 72h239v568zM350 696.5c0 24.2-7.5 31.4-21.9 31.4-9 0-18.4-5.8-24.8-18.5L272.9 732c13.4 22.9 32.3 34.2 61.3 34.2 41.6 0 60.8-29.9 60.8-66.2V577h-45v119.5zM501.3 577H437v186h44v-62h21.6c39.1 0 73.1-19.6 73.1-63.6 0-45.8-33.5-60.4-74.4-60.4zm-.8 89H481v-53h18.2c21.5 0 33.4 6.2 33.4 24.9 0 18.1-10.5 28.1-32.1 28.1zm182.5-9v36h30v30.1c-4 2.9-11 4.7-17.7 4.7-34.3 0-50.7-21.4-50.7-58.2 0-36.1 19.7-57.4 47.1-57.4 15.3 0 25 6.2 34 14.4l23.7-28.3c-12.7-12.8-32.1-24.2-59.2-24.2-49.6 0-91.1 35.3-91.1 97 0 62.7 40 95.1 91.5 95.1 25.9 0 49.2-10.2 61.5-22.6V657H683z'));
exports.FontColorsOutline = getIcon('font-colors', outline, getNode(newViewBox, 'M904 816H120c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8zm-650.3-80h85c4.2 0 8-2.7 9.3-6.8l53.7-166h219.2l53.2 166c1.3 4 5 6.8 9.3 6.8h89.1c1.1 0 2.2-.2 3.2-.5a9.7 9.7 0 0 0 6-12.4L573.6 118.6a9.9 9.9 0 0 0-9.2-6.6H462.1c-4.2 0-7.9 2.6-9.2 6.6L244.5 723.1c-.4 1-.5 2.1-.5 3.2-.1 5.3 4.3 9.7 9.7 9.7zm255.9-516.1h4.1l83.8 263.8H424.9l84.7-263.8z'));
exports.FontSizeOutline = getIcon('font-size', outline, getNode(newViewBox, 'M920 416H616c-4.4 0-8 3.6-8 8v112c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-56h60v320h-46c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h164c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8h-46V480h60v56c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V424c0-4.4-3.6-8-8-8zM656 296V168c0-4.4-3.6-8-8-8H104c-4.4 0-8 3.6-8 8v128c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-64h168v560h-92c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-92V232h168v64c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8z'));
exports.ForkOutline = getIcon('fork', outline, getNode(newViewBox, 'M752 100c-61.8 0-112 50.2-112 112 0 47.7 29.9 88.5 72 104.6v27.6L512 601.4 312 344.2v-27.6c42.1-16.1 72-56.9 72-104.6 0-61.8-50.2-112-112-112s-112 50.2-112 112c0 50.6 33.8 93.5 80 107.3v34.4c0 9.7 3.3 19.3 9.3 27L476 672.3v33.6c-44.2 15-76 56.9-76 106.1 0 61.8 50.2 112 112 112s112-50.2 112-112c0-49.2-31.8-91-76-106.1v-33.6l226.7-291.6c6-7.7 9.3-17.3 9.3-27v-34.4c46.2-13.8 80-56.7 80-107.3 0-61.8-50.2-112-112-112zM224 212a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm336 600a48.01 48.01 0 0 1-96 0 48.01 48.01 0 0 1 96 0zm192-552a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'));
exports.FormOutline = getIcon('form', outline, getNode(newViewBox, 'M904 512h-56c-4.4 0-8 3.6-8 8v320H184V184h320c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V520c0-4.4-3.6-8-8-8z', 'M355.9 534.9L354 653.8c-.1 8.9 7.1 16.2 16 16.2h.4l118-2.9c2-.1 4-.9 5.4-2.3l415.9-415c3.1-3.1 3.1-8.2 0-11.3L785.4 114.3c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-415.8 415a8.3 8.3 0 0 0-2.3 5.6zm63.5 23.6L779.7 199l45.2 45.1-360.5 359.7-45.7 1.1.7-46.4z'));
exports.FullscreenExitOutline = getIcon('fullscreen-exit', outline, getNode(newViewBox, 'M391 240.9c-.8-6.6-8.9-9.4-13.6-4.7l-43.7 43.7L200 146.3a8.03 8.03 0 0 0-11.3 0l-42.4 42.3a8.03 8.03 0 0 0 0 11.3L280 333.6l-43.9 43.9a8.01 8.01 0 0 0 4.7 13.6L401 410c5.1.6 9.5-3.7 8.9-8.9L391 240.9zm10.1 373.2L240.8 633c-6.6.8-9.4 8.9-4.7 13.6l43.9 43.9L146.3 824a8.03 8.03 0 0 0 0 11.3l42.4 42.3c3.1 3.1 8.2 3.1 11.3 0L333.7 744l43.7 43.7A8.01 8.01 0 0 0 391 783l18.9-160.1c.6-5.1-3.7-9.4-8.8-8.8zm221.8-204.2L783.2 391c6.6-.8 9.4-8.9 4.7-13.6L744 333.6 877.7 200c3.1-3.1 3.1-8.2 0-11.3l-42.4-42.3a8.03 8.03 0 0 0-11.3 0L690.3 279.9l-43.7-43.7a8.01 8.01 0 0 0-13.6 4.7L614.1 401c-.6 5.2 3.7 9.5 8.8 8.9zM744 690.4l43.9-43.9a8.01 8.01 0 0 0-4.7-13.6L623 614c-5.1-.6-9.5 3.7-8.9 8.9L633 783.1c.8 6.6 8.9 9.4 13.6 4.7l43.7-43.7L824 877.7c3.1 3.1 8.2 3.1 11.3 0l42.4-42.3c3.1-3.1 3.1-8.2 0-11.3L744 690.4z'));
exports.FullscreenOutline = getIcon('fullscreen', outline, getNode(newViewBox, 'M290 236.4l43.9-43.9a8.01 8.01 0 0 0-4.7-13.6L169 160c-5.1-.6-9.5 3.7-8.9 8.9L179 329.1c.8 6.6 8.9 9.4 13.6 4.7l43.7-43.7L370 423.7c3.1 3.1 8.2 3.1 11.3 0l42.4-42.3c3.1-3.1 3.1-8.2 0-11.3L290 236.4zm352.7 187.3c3.1 3.1 8.2 3.1 11.3 0l133.7-133.6 43.7 43.7a8.01 8.01 0 0 0 13.6-4.7L863.9 169c.6-5.1-3.7-9.5-8.9-8.9L694.8 179c-6.6.8-9.4 8.9-4.7 13.6l43.9 43.9L600.3 370a8.03 8.03 0 0 0 0 11.3l42.4 42.4zM845 694.9c-.8-6.6-8.9-9.4-13.6-4.7l-43.7 43.7L654 600.3a8.03 8.03 0 0 0-11.3 0l-42.4 42.3a8.03 8.03 0 0 0 0 11.3L734 787.6l-43.9 43.9a8.01 8.01 0 0 0 4.7 13.6L855 864c5.1.6 9.5-3.7 8.9-8.9L845 694.9zm-463.7-94.6a8.03 8.03 0 0 0-11.3 0L236.3 733.9l-43.7-43.7a8.01 8.01 0 0 0-13.6 4.7L160.1 855c-.6 5.1 3.7 9.5 8.9 8.9L329.2 845c6.6-.8 9.4-8.9 4.7-13.6L290 787.6 423.7 654c3.1-3.1 3.1-8.2 0-11.3l-42.4-42.4z'));
exports.GatewayOutline = getIcon('gateway', outline, getNode(newViewBox, 'M928 392c8.8 0 16-7.2 16-16V192c0-8.8-7.2-16-16-16H744c-8.8 0-16 7.2-16 16v56H296v-56c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16v184c0 8.8 7.2 16 16 16h56v240H96c-8.8 0-16 7.2-16 16v184c0 8.8 7.2 16 16 16h184c8.8 0 16-7.2 16-16v-56h432v56c0 8.8 7.2 16 16 16h184c8.8 0 16-7.2 16-16V648c0-8.8-7.2-16-16-16h-56V392h56zM792 240h88v88h-88v-88zm-648 88v-88h88v88h-88zm88 456h-88v-88h88v88zm648-88v88h-88v-88h88zm-80-64h-56c-8.8 0-16 7.2-16 16v56H296v-56c0-8.8-7.2-16-16-16h-56V392h56c8.8 0 16-7.2 16-16v-56h432v56c0 8.8 7.2 16 16 16h56v240z'));
exports.DownOutline = getIcon('down', outline, getNode(newViewBox, 'M884 256h-75c-5.1 0-9.9 2.5-12.9 6.6L512 654.2 227.9 262.6c-3-4.1-7.8-6.6-12.9-6.6h-75c-6.5 0-10.3 7.4-6.5 12.7l352.6 486.1c12.8 17.6 39 17.6 51.7 0l352.6-486.1c3.9-5.3.1-12.7-6.4-12.7z'));
exports.DragOutline = getIcon('drag', outline, getNode(newViewBox, 'M909.3 506.3L781.7 405.6a7.23 7.23 0 0 0-11.7 5.7V476H548V254h64.8c6 0 9.4-7 5.7-11.7L517.7 114.7a7.14 7.14 0 0 0-11.3 0L405.6 242.3a7.23 7.23 0 0 0 5.7 11.7H476v222H254v-64.8c0-6-7-9.4-11.7-5.7L114.7 506.3a7.14 7.14 0 0 0 0 11.3l127.5 100.8c4.7 3.7 11.7.4 11.7-5.7V548h222v222h-64.8c-6 0-9.4 7-5.7 11.7l100.8 127.5c2.9 3.7 8.5 3.7 11.3 0l100.8-127.5c3.7-4.7.4-11.7-5.7-11.7H548V548h222v64.8c0 6 7 9.4 11.7 5.7l127.5-100.8a7.3 7.3 0 0 0 .1-11.4z'));
exports.GlobalOutline = getIcon('global', outline, getNode(newViewBox, 'M854.4 800.9c.2-.3.5-.6.7-.9C920.6 722.1 960 621.7 960 512s-39.4-210.1-104.8-288c-.2-.3-.5-.5-.7-.8-1.1-1.3-2.1-2.5-3.2-3.7-.4-.5-.8-.9-1.2-1.4l-4.1-4.7-.1-.1c-1.5-1.7-3.1-3.4-4.6-5.1l-.1-.1c-3.2-3.4-6.4-6.8-9.7-10.1l-.1-.1-4.8-4.8-.3-.3c-1.5-1.5-3-2.9-4.5-4.3-.5-.5-1-1-1.6-1.5-1-1-2-1.9-3-2.8-.3-.3-.7-.6-1-1C736.4 109.2 629.5 64 512 64s-224.4 45.2-304.3 119.2c-.3.3-.7.6-1 1-1 .9-2 1.9-3 2.9-.5.5-1 1-1.6 1.5-1.5 1.4-3 2.9-4.5 4.3l-.3.3-4.8 4.8-.1.1c-3.3 3.3-6.5 6.7-9.7 10.1l-.1.1c-1.6 1.7-3.1 3.4-4.6 5.1l-.1.1c-1.4 1.5-2.8 3.1-4.1 4.7-.4.5-.8.9-1.2 1.4-1.1 1.2-2.1 2.5-3.2 3.7-.2.3-.5.5-.7.8C103.4 301.9 64 402.3 64 512s39.4 210.1 104.8 288c.2.3.5.6.7.9l3.1 3.7c.4.5.8.9 1.2 1.4l4.1 4.7c0 .1.1.1.1.2 1.5 1.7 3 3.4 4.6 5l.1.1c3.2 3.4 6.4 6.8 9.6 10.1l.1.1c1.6 1.6 3.1 3.2 4.7 4.7l.3.3c3.3 3.3 6.7 6.5 10.1 9.6 80.1 74 187 119.2 304.5 119.2s224.4-45.2 304.3-119.2a300 300 0 0 0 10-9.6l.3-.3c1.6-1.6 3.2-3.1 4.7-4.7l.1-.1c3.3-3.3 6.5-6.7 9.6-10.1l.1-.1c1.5-1.7 3.1-3.3 4.6-5 0-.1.1-.1.1-.2 1.4-1.5 2.8-3.1 4.1-4.7.4-.5.8-.9 1.2-1.4a99 99 0 0 0 3.3-3.7zm4.1-142.6c-13.8 32.6-32 62.8-54.2 90.2a444.07 444.07 0 0 0-81.5-55.9c11.6-46.9 18.8-98.4 20.7-152.6H887c-3 40.9-12.6 80.6-28.5 118.3zM887 484H743.5c-1.9-54.2-9.1-105.7-20.7-152.6 29.3-15.6 56.6-34.4 81.5-55.9A373.86 373.86 0 0 1 887 484zM658.3 165.5c39.7 16.8 75.8 40 107.6 69.2a394.72 394.72 0 0 1-59.4 41.8c-15.7-45-35.8-84.1-59.2-115.4 3.7 1.4 7.4 2.9 11 4.4zm-90.6 700.6c-9.2 7.2-18.4 12.7-27.7 16.4V697a389.1 389.1 0 0 1 115.7 26.2c-8.3 24.6-17.9 47.3-29 67.8-17.4 32.4-37.8 58.3-59 75.1zm59-633.1c11 20.6 20.7 43.3 29 67.8A389.1 389.1 0 0 1 540 327V141.6c9.2 3.7 18.5 9.1 27.7 16.4 21.2 16.7 41.6 42.6 59 75zM540 640.9V540h147.5c-1.6 44.2-7.1 87.1-16.3 127.8l-.3 1.2A445.02 445.02 0 0 0 540 640.9zm0-156.9V383.1c45.8-2.8 89.8-12.5 130.9-28.1l.3 1.2c9.2 40.7 14.7 83.5 16.3 127.8H540zm-56 56v100.9c-45.8 2.8-89.8 12.5-130.9 28.1l-.3-1.2c-9.2-40.7-14.7-83.5-16.3-127.8H484zm-147.5-56c1.6-44.2 7.1-87.1 16.3-127.8l.3-1.2c41.1 15.6 85 25.3 130.9 28.1V484H336.5zM484 697v185.4c-9.2-3.7-18.5-9.1-27.7-16.4-21.2-16.7-41.7-42.7-59.1-75.1-11-20.6-20.7-43.3-29-67.8 37.2-14.6 75.9-23.3 115.8-26.1zm0-370a389.1 389.1 0 0 1-115.7-26.2c8.3-24.6 17.9-47.3 29-67.8 17.4-32.4 37.8-58.4 59.1-75.1 9.2-7.2 18.4-12.7 27.7-16.4V327zM365.7 165.5c3.7-1.5 7.3-3 11-4.4-23.4 31.3-43.5 70.4-59.2 115.4-21-12-40.9-26-59.4-41.8 31.8-29.2 67.9-52.4 107.6-69.2zM165.5 365.7c13.8-32.6 32-62.8 54.2-90.2 24.9 21.5 52.2 40.3 81.5 55.9-11.6 46.9-18.8 98.4-20.7 152.6H137c3-40.9 12.6-80.6 28.5-118.3zM137 540h143.5c1.9 54.2 9.1 105.7 20.7 152.6a444.07 444.07 0 0 0-81.5 55.9A373.86 373.86 0 0 1 137 540zm228.7 318.5c-39.7-16.8-75.8-40-107.6-69.2 18.5-15.8 38.4-29.7 59.4-41.8 15.7 45 35.8 84.1 59.2 115.4-3.7-1.4-7.4-2.9-11-4.4zm292.6 0c-3.7 1.5-7.3 3-11 4.4 23.4-31.3 43.5-70.4 59.2-115.4 21 12 40.9 26 59.4 41.8a373.81 373.81 0 0 1-107.6 69.2z'));
exports.GooglePlusOutline = getIcon('google-plus', outline, getNode(newViewBox, 'M879.5 470.4c-.3-27-.4-54.2-.5-81.3h-80.8c-.3 27-.5 54.1-.7 81.3-27.2.1-54.2.3-81.2.6v80.9c27 .3 54.2.5 81.2.8.3 27 .3 54.1.5 81.1h80.9c.1-27 .3-54.1.5-81.3 27.2-.3 54.2-.4 81.2-.7v-80.9c-26.9-.2-54.1-.2-81.1-.5zm-530 .4c-.1 32.3 0 64.7.1 97 54.2 1.8 108.5 1 162.7 1.8-23.9 120.3-187.4 159.3-273.9 80.7-89-68.9-84.8-220 7.7-284 64.7-51.6 156.6-38.9 221.3 5.8 25.4-23.5 49.2-48.7 72.1-74.7-53.8-42.9-119.8-73.5-190-70.3-146.6-4.9-281.3 123.5-283.7 270.2-9.4 119.9 69.4 237.4 180.6 279.8 110.8 42.7 252.9 13.6 323.7-86 46.7-62.9 56.8-143.9 51.3-220-90.7-.7-181.3-.6-271.9-.3z'));
exports.GoogleOutline = getIcon('google', outline, getNode(newViewBox, 'M881 442.4H519.7v148.5h206.4c-8.9 48-35.9 88.6-76.6 115.8-34.4 23-78.3 36.6-129.9 36.6-99.9 0-184.4-67.5-214.6-158.2-7.6-23-12-47.6-12-72.9s4.4-49.9 12-72.9c30.3-90.6 114.8-158.1 214.7-158.1 56.3 0 106.8 19.4 146.6 57.4l110-110.1c-66.5-62-153.2-100-256.6-100-149.9 0-279.6 86-342.7 211.4-26 51.8-40.8 110.4-40.8 172.4S151 632.8 177 684.6C240.1 810 369.8 896 519.7 896c103.6 0 190.4-34.4 253.8-93 72.5-66.8 114.4-165.2 114.4-282.1 0-27.2-2.4-53.3-6.9-78.5z'));
exports.HeatMapOutline = getIcon('heat-map', outline, getNode(newViewBox, 'M955.7 856l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zm-790.4-23.9L512 231.9 858.7 832H165.3zm319-474.1l-228 394c-12.3 21.3 3.1 48 27.7 48h455.8c24.7 0 40.1-26.7 27.7-48L539.7 358c-6.2-10.7-17-16-27.7-16-10.8 0-21.6 5.3-27.7 16zm214 386H325.7L512 422l186.3 322zm-214-194.1l-57 98.4C415 669.5 430.4 696 455 696h114c24.6 0 39.9-26.5 27.7-47.7l-57-98.4c-6.1-10.6-16.9-15.9-27.7-15.9s-21.5 5.3-27.7 15.9zm57.1 98.4h-58.7l29.4-50.7 29.3 50.7z'));
exports.GoldOutline = getIcon('gold', outline, getNode(newViewBox, 'M342 472h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H382.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8zm91.2-196h159.5l20.7 128h-201l20.8-128zm2.5 282.7c-.6-3.9-4-6.7-7.9-6.7H166.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248zM196.5 748l20.7-128h159.5l20.7 128H196.5zm709.4 58.7l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H596.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.3-.7 7.3-4.8 6.6-9.2zM626.5 748l20.7-128h159.5l20.7 128H626.5z'));
exports.HistoryOutline = getIcon('history', outline, getNode(newViewBox, 'M536.1 273H488c-4.4 0-8 3.6-8 8v275.3c0 2.6 1.2 5 3.3 6.5l165.3 120.7c3.6 2.6 8.6 1.9 11.2-1.7l28.6-39c2.7-3.7 1.9-8.7-1.7-11.2L544.1 528.5V281c0-4.4-3.6-8-8-8zm219.8 75.2l156.8 38.3c5 1.2 9.9-2.6 9.9-7.7l.8-161.5c0-6.7-7.7-10.5-12.9-6.3L752.9 334.1a8 8 0 0 0 3 14.1zm167.7 301.1l-56.7-19.5a8 8 0 0 0-10.1 4.8c-1.9 5.1-3.9 10.1-6 15.1-17.8 42.1-43.3 80-75.9 112.5a353 353 0 0 1-112.5 75.9 352.18 352.18 0 0 1-137.7 27.8c-47.8 0-94.1-9.3-137.7-27.8a353 353 0 0 1-112.5-75.9c-32.5-32.5-58-70.4-75.9-112.5A353.44 353.44 0 0 1 171 512c0-47.8 9.3-94.2 27.8-137.8 17.8-42.1 43.3-80 75.9-112.5a353 353 0 0 1 112.5-75.9C430.6 167.3 477 158 524.8 158s94.1 9.3 137.7 27.8A353 353 0 0 1 775 261.7c10.2 10.3 19.8 21 28.6 32.3l59.8-46.8C784.7 146.6 662.2 81.9 524.6 82 285 82.1 92.6 276.7 95 516.4 97.4 751.9 288.9 942 524.8 942c185.5 0 343.5-117.6 403.7-282.3 1.5-4.2-.7-8.9-4.9-10.4z'));
exports.IeOutline = getIcon('ie', outline, getNode(newViewBox, 'M852.6 367.6c16.3-36.9 32.1-90.7 32.1-131.8 0-109.1-119.5-147.6-314.5-57.9-161.4-10.8-316.8 110.5-355.6 279.7 46.3-52.3 117.4-123.4 183-151.7C316.1 378.3 246.7 470 194 565.6c-31.1 56.9-66 148.8-66 217.5 0 147.9 139.3 129.8 270.4 63 47.1 23.1 99.8 23.4 152.5 23.4 145.7 0 276.4-81.4 325.2-219H694.9c-78.8 132.9-295.2 79.5-295.2-71.2h493.2c9.6-65.4-2.5-143.6-40.3-211.7zM224.8 648.3c26.6 76.7 80.6 143.8 150.4 185-133.1 73.4-259.9 43.6-150.4-185zm174-163.3c3-82.7 75.4-142.3 156-142.3 80.1 0 153 59.6 156 142.3h-312zm276.8-281.4c32.1-15.4 72.8-33 108.8-33 47.1 0 81.4 32.6 81.4 80.6 0 30-11.1 73.5-21.9 101.8-39.3-63.5-98.9-122.4-168.3-149.4z'));
exports.InboxOutline = getIcon('inbox', outline, getNode(normalViewBox, 'M885.2 446.3l-.2-.8-112.2-285.1c-5-16.1-19.9-27.2-36.8-27.2H281.2c-17 0-32.1 11.3-36.9 27.6L139.4 443l-.3.7-.2.8c-1.3 4.9-1.7 9.9-1 14.8-.1 1.6-.2 3.2-.2 4.8V830a60.9 60.9 0 0 0 60.8 60.8h627.2c33.5 0 60.8-27.3 60.9-60.8V464.1c0-1.3 0-2.6-.1-3.7.4-4.9 0-9.6-1.3-14.1zm-295.8-43l-.3 15.7c-.8 44.9-31.8 75.1-77.1 75.1-22.1 0-41.1-7.1-54.8-20.6S436 441.2 435.6 419l-.3-15.7H229.5L309 210h399.2l81.7 193.3H589.4zm-375 76.8h157.3c24.3 57.1 76 90.8 140.4 90.8 33.7 0 65-9.4 90.3-27.2 22.2-15.6 39.5-37.4 50.7-63.6h156.5V814H214.4V480.1z'));
exports.ImportOutline = getIcon('import', outline, getNode(newViewBox, 'M888.3 757.4h-53.8c-4.2 0-7.7 3.5-7.7 7.7v61.8H197.1V197.1h629.8v61.8c0 4.2 3.5 7.7 7.7 7.7h53.8c4.2 0 7.7-3.4 7.7-7.7V158.7c0-17-13.7-30.7-30.7-30.7H158.7c-17 0-30.7 13.7-30.7 30.7v706.6c0 17 13.7 30.7 30.7 30.7h706.6c17 0 30.7-13.7 30.7-30.7V765.1c0-4.3-3.5-7.7-7.7-7.7zM902 476H588v-76c0-6.7-7.8-10.5-13-6.3l-141.9 112a8 8 0 0 0 0 12.6l141.9 112c5.3 4.2 13 .4 13-6.3v-76h314c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
exports.InfoOutline = getIcon('info', outline, getNode(newViewBox, 'M448 224a64 64 0 1 0 128 0 64 64 0 1 0-128 0zm96 168h-64c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V400c0-4.4-3.6-8-8-8z'));
exports.ItalicOutline = getIcon('italic', outline, getNode(newViewBox, 'M798 160H366c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h181.2l-156 544H229c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h432c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8H474.4l156-544H798c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8z'));
exports.IssuesCloseOutline = getIcon('issues-close', outline, getNode(newViewBox, 'M464 688a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm72-112c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48zm400-188h-59.3c-2.6 0-5 1.2-6.5 3.3L763.7 538.1l-49.9-68.8a7.92 7.92 0 0 0-6.5-3.3H648c-6.5 0-10.3 7.4-6.5 12.7l109.2 150.7a16.1 16.1 0 0 0 26 0l165.8-228.7c3.8-5.3 0-12.7-6.5-12.7zm-44 306h-64.2c-5.5 0-10.6 2.9-13.6 7.5a352.2 352.2 0 0 1-49.8 62.2A355.92 355.92 0 0 1 651.1 840a355 355 0 0 1-138.7 27.9c-48.1 0-94.8-9.4-138.7-27.9a355.92 355.92 0 0 1-113.3-76.3A353.06 353.06 0 0 1 184 650.5c-18.6-43.8-28-90.5-28-138.5s9.4-94.7 28-138.5c17.9-42.4 43.6-80.5 76.4-113.2 32.8-32.7 70.9-58.4 113.3-76.3a355 355 0 0 1 138.7-27.9c48.1 0 94.8 9.4 138.7 27.9 42.4 17.9 80.5 43.6 113.3 76.3 19 19 35.6 39.8 49.8 62.2 2.9 4.7 8.1 7.5 13.6 7.5H892c6 0 9.8-6.3 7.2-11.6C828.8 178.5 684.7 82 517.7 80 278.9 77.2 80.5 272.5 80 511.2 79.5 750.1 273.3 944 512.4 944c169.2 0 315.6-97 386.7-238.4A8 8 0 0 0 892 694z'));
exports.KeyOutline = getIcon('key', outline, getNode(newViewBox, 'M608 112c-167.9 0-304 136.1-304 304 0 70.3 23.9 135 63.9 186.5l-41.1 41.1-62.3-62.3a8.15 8.15 0 0 0-11.4 0l-39.8 39.8a8.15 8.15 0 0 0 0 11.4l62.3 62.3-44.9 44.9-62.3-62.3a8.15 8.15 0 0 0-11.4 0l-39.8 39.8a8.15 8.15 0 0 0 0 11.4l62.3 62.3-65.3 65.3a8.03 8.03 0 0 0 0 11.3l42.3 42.3c3.1 3.1 8.2 3.1 11.3 0l253.6-253.6A304.06 304.06 0 0 0 608 720c167.9 0 304-136.1 304-304S775.9 112 608 112zm161.2 465.2C726.2 620.3 668.9 644 608 644c-60.9 0-118.2-23.7-161.2-66.8-43.1-43-66.8-100.3-66.8-161.2 0-60.9 23.7-118.2 66.8-161.2 43-43.1 100.3-66.8 161.2-66.8 60.9 0 118.2 23.7 161.2 66.8 43.1 43 66.8 100.3 66.8 161.2 0 60.9-23.7 118.2-66.8 161.2z'));
exports.LaptopOutline = getIcon('laptop', outline, getNode(newViewBox, 'M956.9 845.1L896.4 632V168c0-17.7-14.3-32-32-32h-704c-17.7 0-32 14.3-32 32v464L67.9 845.1C60.4 866 75.8 888 98 888h828.8c22.2 0 37.6-22 30.1-42.9zM200.4 208h624v395h-624V208zm228.3 608l8.1-37h150.3l8.1 37H428.7zm224 0l-19.1-86.7c-.8-3.7-4.1-6.3-7.8-6.3H398.2c-3.8 0-7 2.6-7.8 6.3L371.3 816H151l42.3-149h638.2l42.3 149H652.7z'));
exports.LeftOutline = getIcon('left', outline, getNode(newViewBox, 'M724 218.3V141c0-6.7-7.7-10.4-12.9-6.3L260.3 486.8a31.86 31.86 0 0 0 0 50.3l450.8 352.1c5.3 4.1 12.9.4 12.9-6.3v-77.3c0-4.9-2.3-9.6-6.1-12.6l-360-281 360-281.1c3.8-3 6.1-7.7 6.1-12.6z'));
exports.LinkOutline = getIcon('link', outline, getNode(newViewBox, 'M574 665.4a8.03 8.03 0 0 0-11.3 0L446.5 781.6c-53.8 53.8-144.6 59.5-204 0-59.5-59.5-53.8-150.2 0-204l116.2-116.2c3.1-3.1 3.1-8.2 0-11.3l-39.8-39.8a8.03 8.03 0 0 0-11.3 0L191.4 526.5c-84.6 84.6-84.6 221.5 0 306s221.5 84.6 306 0l116.2-116.2c3.1-3.1 3.1-8.2 0-11.3L574 665.4zm258.6-474c-84.6-84.6-221.5-84.6-306 0L410.3 307.6a8.03 8.03 0 0 0 0 11.3l39.7 39.7c3.1 3.1 8.2 3.1 11.3 0l116.2-116.2c53.8-53.8 144.6-59.5 204 0 59.5 59.5 53.8 150.2 0 204L665.3 562.6a8.03 8.03 0 0 0 0 11.3l39.8 39.8c3.1 3.1 8.2 3.1 11.3 0l116.2-116.2c84.5-84.6 84.5-221.5 0-306.1zM610.1 372.3a8.03 8.03 0 0 0-11.3 0L372.3 598.7a8.03 8.03 0 0 0 0 11.3l39.6 39.6c3.1 3.1 8.2 3.1 11.3 0l226.4-226.4c3.1-3.1 3.1-8.2 0-11.3l-39.5-39.6z'));
exports.LineChartOutline = getIcon('line-chart', outline, getNode(newViewBox, 'M888 792H200V168c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h752c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM305.8 637.7c3.1 3.1 8.1 3.1 11.3 0l138.3-137.6L583 628.5c3.1 3.1 8.2 3.1 11.3 0l275.4-275.3c3.1-3.1 3.1-8.2 0-11.3l-39.6-39.6a8.03 8.03 0 0 0-11.3 0l-230 229.9L461.4 404a8.03 8.03 0 0 0-11.3 0L266.3 586.7a8.03 8.03 0 0 0 0 11.3l39.5 39.7z'));
exports.LineHeightOutline = getIcon('line-height', outline, getNode(newViewBox, 'M648 160H104c-4.4 0-8 3.6-8 8v128c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-64h168v560h-92c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-92V232h168v64c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V168c0-4.4-3.6-8-8-8zm272.8 546H856V318h64.8c6 0 9.4-7 5.7-11.7L825.7 178.7a7.14 7.14 0 0 0-11.3 0L713.6 306.3a7.23 7.23 0 0 0 5.7 11.7H784v388h-64.8c-6 0-9.4 7-5.7 11.7l100.8 127.5c2.9 3.7 8.5 3.7 11.3 0l100.8-127.5a7.2 7.2 0 0 0-5.6-11.7z'));
exports.LineOutline = getIcon('line', outline, getNode(newViewBox, 'M904 476H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
exports.Loading3QuartersOutline = getIcon('loading-3-quarters', outline, getNode(normalViewBox, 'M512 1024c-69.1 0-136.2-13.5-199.3-40.2C251.7 958 197 921 150 874c-47-47-84-101.7-109.8-162.7C13.5 648.2 0 581.1 0 512c0-19.9 16.1-36 36-36s36 16.1 36 36c0 59.4 11.6 117 34.6 171.3 22.2 52.4 53.9 99.5 94.3 139.9 40.4 40.4 87.5 72.2 139.9 94.3C395 940.4 452.6 952 512 952c59.4 0 117-11.6 171.3-34.6 52.4-22.2 99.5-53.9 139.9-94.3 40.4-40.4 72.2-87.5 94.3-139.9C940.4 629 952 571.4 952 512c0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 0 0-94.3-139.9 437.71 437.71 0 0 0-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.2C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3s-13.5 136.2-40.2 199.3C958 772.3 921 827 874 874c-47 47-101.8 83.9-162.7 109.7-63.1 26.8-130.2 40.3-199.3 40.3z'));
exports.LoadingOutline = getIcon('loading', outline, getNode(normalViewBox, 'M988 548c-19.9 0-36-16.1-36-36 0-59.4-11.6-117-34.6-171.3a440.45 440.45 0 0 0-94.3-139.9 437.71 437.71 0 0 0-139.9-94.3C629 83.6 571.4 72 512 72c-19.9 0-36-16.1-36-36s16.1-36 36-36c69.1 0 136.2 13.5 199.3 40.3C772.3 66 827 103 874 150c47 47 83.9 101.8 109.7 162.7 26.7 63.1 40.2 130.2 40.2 199.3.1 19.9-16 36-35.9 36z'));
exports.LoginOutline = getIcon('login', outline, getNode(newViewBox, 'M521.7 82c-152.5-.4-286.7 78.5-363.4 197.7-3.4 5.3.4 12.3 6.7 12.3h70.3c4.8 0 9.3-2.1 12.3-5.8 7-8.5 14.5-16.7 22.4-24.5 32.6-32.5 70.5-58.1 112.7-75.9 43.6-18.4 90-27.8 137.9-27.8 47.9 0 94.3 9.3 137.9 27.8 42.2 17.8 80.1 43.4 112.7 75.9 32.6 32.5 58.1 70.4 76 112.5C865.7 417.8 875 464.1 875 512c0 47.9-9.4 94.2-27.8 137.8-17.8 42.1-43.4 80-76 112.5s-70.5 58.1-112.7 75.9A352.8 352.8 0 0 1 520.6 866c-47.9 0-94.3-9.4-137.9-27.8A353.84 353.84 0 0 1 270 762.3c-7.9-7.9-15.3-16.1-22.4-24.5-3-3.7-7.6-5.8-12.3-5.8H165c-6.3 0-10.2 7-6.7 12.3C234.9 863.2 368.5 942 520.6 942c236.2 0 428-190.1 430.4-425.6C953.4 277.1 761.3 82.6 521.7 82zM395.02 624v-76h-314c-4.4 0-8-3.6-8-8v-56c0-4.4 3.6-8 8-8h314v-76c0-6.7 7.8-10.5 13-6.3l141.9 112a8 8 0 0 1 0 12.6l-141.9 112c-5.2 4.1-13 .4-13-6.3z'));
exports.LogoutOutline = getIcon('logout', outline, getNode(newViewBox, 'M868 732h-70.3c-4.8 0-9.3 2.1-12.3 5.8-7 8.5-14.5 16.7-22.4 24.5a353.84 353.84 0 0 1-112.7 75.9A352.8 352.8 0 0 1 512.4 866c-47.9 0-94.3-9.4-137.9-27.8a353.84 353.84 0 0 1-112.7-75.9 353.28 353.28 0 0 1-76-112.5C167.3 606.2 158 559.9 158 512s9.4-94.2 27.8-137.8c17.8-42.1 43.4-80 76-112.5s70.5-58.1 112.7-75.9c43.6-18.4 90-27.8 137.9-27.8 47.9 0 94.3 9.3 137.9 27.8 42.2 17.8 80.1 43.4 112.7 75.9 7.9 7.9 15.3 16.1 22.4 24.5 3 3.7 7.6 5.8 12.3 5.8H868c6.3 0 10.2-7 6.7-12.3C798 160.5 663.8 81.6 511.3 82 271.7 82.6 79.6 277.1 82 516.4 84.4 751.9 276.2 942 512.4 942c152.1 0 285.7-78.8 362.3-197.7 3.4-5.3-.4-12.3-6.7-12.3zm88.9-226.3L815 393.7c-5.3-4.2-13-.4-13 6.3v76H488c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h314v76c0 6.7 7.8 10.5 13 6.3l141.9-112a8 8 0 0 0 0-12.6z'));
exports.ManOutline = getIcon('man', outline, getNode(newViewBox, 'M874 120H622c-3.3 0-6 2.7-6 6v56c0 3.3 2.7 6 6 6h160.4L583.1 387.3c-50-38.5-111-59.3-175.1-59.3-76.9 0-149.3 30-203.6 84.4S120 539.1 120 616s30 149.3 84.4 203.6C258.7 874 331.1 904 408 904s149.3-30 203.6-84.4C666 765.3 696 692.9 696 616c0-64.1-20.8-124.9-59.2-174.9L836 241.9V402c0 3.3 2.7 6 6 6h56c3.3 0 6-2.7 6-6V150c0-16.5-13.5-30-30-30zM408 828c-116.9 0-212-95.1-212-212s95.1-212 212-212 212 95.1 212 212-95.1 212-212 212z'));
exports.MediumOutline = getIcon('medium', outline, getNode(newViewBox, 'M834.7 279.8l61.3-58.9V208H683.7L532.4 586.4 360.3 208H137.7v12.9l71.6 86.6c7 6.4 10.6 15.8 9.7 25.2V673c2.2 12.3-1.7 24.8-10.3 33.7L128 805v12.7h228.6v-12.9l-80.6-98a39.99 39.99 0 0 1-11.1-33.7V378.7l200.7 439.2h23.3l172.6-439.2v349.9c0 9.2 0 11.1-6 17.2l-62.1 60.3V819h301.2v-12.9l-59.9-58.9c-5.2-4-7.9-10.7-6.8-17.2V297a18.1 18.1 0 0 1 6.8-17.2z'));
exports.MediumWorkmarkOutline = getIcon('medium-workmark', outline, getNode(normalViewBox, 'M517.2 590.55c0 3.55 0 4.36 2.4 6.55l13.43 13.25v.57h-59.57v-25.47a41.44 41.44 0 0 1-39.5 27.65c-30.61 0-52.84-24.25-52.84-68.87 0-41.8 23.99-69.69 57.65-69.69a35.15 35.15 0 0 1 34.61 21.67v-56.19a6.99 6.99 0 0 0-2.71-6.79l-12.8-12.45v-.56l59.33-7.04v177.37zm-43.74-8.09v-83.83a22.2 22.2 0 0 0-17.74-8.4c-14.48 0-28.47 13.25-28.47 52.62 0 36.86 12.07 49.88 27.1 49.88a23.91 23.91 0 0 0 19.11-10.27zm83.23 28.46V497.74a7.65 7.65 0 0 0-2.4-6.79l-13.19-13.74v-.57h59.56v114.8c0 3.55 0 4.36 2.4 6.54l13.12 12.45v.57l-59.49-.08zm-2.16-175.67c0-13.4 10.74-24.25 23.99-24.25 13.25 0 23.98 10.86 23.98 24.25 0 13.4-10.73 24.25-23.98 24.25s-23.99-10.85-23.99-24.25zm206.83 155.06c0 3.55 0 4.6 2.4 6.79l13.43 13.25v.57h-59.88V581.9a43.4 43.4 0 0 1-41.01 31.2c-26.55 0-40.78-19.56-40.78-56.59 0-17.86 0-37.43.56-59.41a6.91 6.91 0 0 0-2.4-6.55L620.5 477.2v-.57h59.09v73.81c0 24.25 3.51 40.42 18.54 40.42a23.96 23.96 0 0 0 19.35-12.2v-80.85a7.65 7.65 0 0 0-2.4-6.79l-13.27-13.82v-.57h59.56V590.3zm202.76 20.6c0-4.36.8-59.97.8-72.75 0-24.25-3.76-40.98-20.63-40.98a26.7 26.7 0 0 0-21.19 11.64 99.68 99.68 0 0 1 2.4 23.04c0 16.81-.56 38.23-.8 59.66a6.91 6.91 0 0 0 2.4 6.55l13.43 12.45v.56h-60.12c0-4.04.8-59.98.8-72.76 0-24.65-3.76-40.98-20.39-40.98-8.2.3-15.68 4.8-19.83 11.96v82.46c0 3.56 0 4.37 2.4 6.55l13.11 12.45v.56h-59.48V498.15a7.65 7.65 0 0 0-2.4-6.8l-13.19-14.14v-.57H841v28.78c5.53-19 23.13-31.76 42.7-30.96 19.82 0 33.26 11.16 38.93 32.34a46.41 46.41 0 0 1 44.77-32.34c26.55 0 41.58 19.8 41.58 57.23 0 17.87-.56 38.24-.8 59.66a6.5 6.5 0 0 0 2.72 6.55l13.11 12.45v.57h-59.88zM215.87 593.3l17.66 17.05v.57h-89.62v-.57l17.99-17.05a6.91 6.91 0 0 0 2.4-6.55V477.69c0-4.6 0-10.83.8-16.16L104.66 613.1h-.72l-62.6-139.45c-1.37-3.47-1.77-3.72-2.65-6.06v91.43a32.08 32.08 0 0 0 2.96 17.87l25.19 33.46v.57H0v-.57l25.18-33.55a32.16 32.16 0 0 0 2.96-17.78V457.97A19.71 19.71 0 0 0 24 444.15L6.16 420.78v-.56h63.96l53.56 118.1 47.17-118.1h62.6v.56l-17.58 19.8a6.99 6.99 0 0 0-2.72 6.8v139.37a6.5 6.5 0 0 0 2.72 6.55zm70.11-54.65v.56c0 34.6 17.67 48.5 38.38 48.5a43.5 43.5 0 0 0 40.77-24.97h.56c-7.2 34.2-28.14 50.36-59.48 50.36-33.82 0-65.72-20.61-65.72-68.39 0-50.2 31.98-70.25 67.32-70.25 28.46 0 58.76 13.58 58.76 57.24v6.95h-80.59zm0-6.95h39.42v-7.04c0-35.57-7.28-45.03-18.23-45.03-13.27 0-21.35 14.15-21.35 52.07h.16z'));
exports.MenuUnfoldOutline = getIcon('menu-unfold', outline, getNode(newViewBox, 'M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM142.4 642.1L298.7 519a8.84 8.84 0 0 0 0-13.9L142.4 381.9c-5.8-4.6-14.4-.5-14.4 6.9v246.3a8.9 8.9 0 0 0 14.4 7z'));
exports.MenuFoldOutline = getIcon('menu-fold', outline, getNode(newViewBox, 'M408 442h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm-8 204c0 4.4 3.6 8 8 8h480c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H408c-4.4 0-8 3.6-8 8v56zm504-486H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 632H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM115.4 518.9L271.7 642c5.8 4.6 14.4.5 14.4-6.9V388.9c0-7.4-8.5-11.5-14.4-6.9L115.4 505.1a8.74 8.74 0 0 0 0 13.8z'));
exports.MenuOutline = getIcon('menu', outline, getNode(newViewBox, 'M904 160H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0 624H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8zm0-312H120c-4.4 0-8 3.6-8 8v64c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-64c0-4.4-3.6-8-8-8z'));
exports.MinusOutline = getIcon('minus', outline, getNode(newViewBox, 'M872 474H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z'));
exports.MonitorOutline = getIcon('monitor', outline, getNode(newViewBox, 'M692.8 412.7l.2-.2-34.6-44.3a7.97 7.97 0 0 0-11.2-1.4l-50.4 39.3-70.5-90.1a7.97 7.97 0 0 0-11.2-1.4l-37.9 29.7a7.97 7.97 0 0 0-1.4 11.2l70.5 90.2-.2.1 34.6 44.3c2.7 3.5 7.7 4.1 11.2 1.4l50.4-39.3 64.1 82c2.7 3.5 7.7 4.1 11.2 1.4l37.9-29.6c3.5-2.7 4.1-7.7 1.4-11.2l-64.1-82.1zM608 112c-167.9 0-304 136.1-304 304 0 70.3 23.9 135 63.9 186.5L114.3 856.1a8.03 8.03 0 0 0 0 11.3l42.3 42.3c3.1 3.1 8.2 3.1 11.3 0l253.6-253.6C473 696.1 537.7 720 608 720c167.9 0 304-136.1 304-304S775.9 112 608 112zm161.2 465.2C726.2 620.3 668.9 644 608 644s-118.2-23.7-161.2-66.8C403.7 534.2 380 476.9 380 416s23.7-118.2 66.8-161.2c43-43.1 100.3-66.8 161.2-66.8s118.2 23.7 161.2 66.8c43.1 43 66.8 100.3 66.8 161.2s-23.7 118.2-66.8 161.2z'));
exports.MoreOutline = getIcon('more', outline, getNode(newViewBox, 'M456 231a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm0 280a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm0 280a56 56 0 1 0 112 0 56 56 0 1 0-112 0z'));
exports.OrderedListOutline = getIcon('ordered-list', outline, getNode(newViewBox, 'M920 760H336c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-568H336c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H336c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM216 712H100c-2.2 0-4 1.8-4 4v34c0 2.2 1.8 4 4 4h72.4v20.5h-35.7c-2.2 0-4 1.8-4 4v34c0 2.2 1.8 4 4 4h35.7V838H100c-2.2 0-4 1.8-4 4v34c0 2.2 1.8 4 4 4h116c2.2 0 4-1.8 4-4V716c0-2.2-1.8-4-4-4zM100 188h38v120c0 2.2 1.8 4 4 4h40c2.2 0 4-1.8 4-4V152c0-4.4-3.6-8-8-8h-78c-2.2 0-4 1.8-4 4v36c0 2.2 1.8 4 4 4zm116 240H100c-2.2 0-4 1.8-4 4v36c0 2.2 1.8 4 4 4h68.4l-70.3 77.7a8.3 8.3 0 0 0-2.1 5.4V592c0 2.2 1.8 4 4 4h116c2.2 0 4-1.8 4-4v-36c0-2.2-1.8-4-4-4h-68.4l70.3-77.7a8.3 8.3 0 0 0 2.1-5.4V432c0-2.2-1.8-4-4-4z'));
exports.NumberOutline = getIcon('number', outline, getNode(newViewBox, 'M872 394c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8H708V152c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v166H400V152c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v166H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h168v236H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h168v166c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V706h228v166c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V706h164c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8H708V394h164zM628 630H400V394h228v236z'));
exports.PauseOutline = getIcon('pause', outline, getNode(newViewBox, 'M304 176h80v672h-80zm408 0h-64c-4.4 0-8 3.6-8 8v656c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V184c0-4.4-3.6-8-8-8z'));
exports.PercentageOutline = getIcon('percentage', outline, getNode(newViewBox, 'M855.7 210.8l-42.4-42.4a8.03 8.03 0 0 0-11.3 0L168.3 801.9a8.03 8.03 0 0 0 0 11.3l42.4 42.4c3.1 3.1 8.2 3.1 11.3 0L855.6 222c3.2-3 3.2-8.1.1-11.2zM304 448c79.4 0 144-64.6 144-144s-64.6-144-144-144-144 64.6-144 144 64.6 144 144 144zm0-216c39.7 0 72 32.3 72 72s-32.3 72-72 72-72-32.3-72-72 32.3-72 72-72zm416 344c-79.4 0-144 64.6-144 144s64.6 144 144 144 144-64.6 144-144-64.6-144-144-144zm0 216c-39.7 0-72-32.3-72-72s32.3-72 72-72 72 32.3 72 72-32.3 72-72 72z'));
exports.PaperClipOutline = getIcon('paper-clip', outline, getNode(newViewBox, 'M779.3 196.6c-94.2-94.2-247.6-94.2-341.7 0l-261 260.8c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0 0 12.7 0l261-260.8c32.4-32.4 75.5-50.2 121.3-50.2s88.9 17.8 121.2 50.2c32.4 32.4 50.2 75.5 50.2 121.2 0 45.8-17.8 88.8-50.2 121.2l-266 265.9-43.1 43.1c-40.3 40.3-105.8 40.3-146.1 0-19.5-19.5-30.2-45.4-30.2-73s10.7-53.5 30.2-73l263.9-263.8c6.7-6.6 15.5-10.3 24.9-10.3h.1c9.4 0 18.1 3.7 24.7 10.3 6.7 6.7 10.3 15.5 10.3 24.9 0 9.3-3.7 18.1-10.3 24.7L372.4 653c-1.7 1.7-2.6 4-2.6 6.4s.9 4.7 2.6 6.4l36.9 36.9a9 9 0 0 0 12.7 0l215.6-215.6c19.9-19.9 30.8-46.3 30.8-74.4s-11-54.6-30.8-74.4c-41.1-41.1-107.9-41-149 0L463 364 224.8 602.1A172.22 172.22 0 0 0 174 724.8c0 46.3 18.1 89.8 50.8 122.5 33.9 33.8 78.3 50.7 122.7 50.7 44.4 0 88.8-16.9 122.6-50.7l309.2-309C824.8 492.7 850 432 850 367.5c.1-64.6-25.1-125.3-70.7-170.9z'));
exports.PicCenterOutline = getIcon('pic-center', outline, getNode(newViewBox, 'M952 792H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-632H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM848 660c8.8 0 16-7.2 16-16V380c0-8.8-7.2-16-16-16H176c-8.8 0-16 7.2-16 16v264c0 8.8 7.2 16 16 16h672zM232 436h560v152H232V436z'));
exports.PicLeftOutline = getIcon('pic-left', outline, getNode(newViewBox, 'M952 792H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-632H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM608 660c8.8 0 16-7.2 16-16V380c0-8.8-7.2-16-16-16H96c-8.8 0-16 7.2-16 16v264c0 8.8 7.2 16 16 16h512zM152 436h400v152H152V436zm552 210c0 4.4 3.6 8 8 8h224c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H712c-4.4 0-8 3.6-8 8v56zm8-204h224c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H712c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z'));
exports.PlusOutline = getIcon('plus', outline, getNode(newViewBox, 'M482 152h60q8 0 8 8v704q0 8-8 8h-60q-8 0-8-8V160q0-8 8-8z', 'M176 474h672q8 0 8 8v60q0 8-8 8H176q-8 0-8-8v-60q0-8 8-8z'));
exports.PicRightOutline = getIcon('pic-right', outline, getNode(newViewBox, 'M952 792H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-632H72c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h880c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-24 500c8.8 0 16-7.2 16-16V380c0-8.8-7.2-16-16-16H416c-8.8 0-16 7.2-16 16v264c0 8.8 7.2 16 16 16h512zM472 436h400v152H472V436zM80 646c0 4.4 3.6 8 8 8h224c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H88c-4.4 0-8 3.6-8 8v56zm8-204h224c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H88c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8z'));
exports.PoundOutline = getIcon('pound', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm138-209.8H469.8v-4.7c27.4-17.2 43.9-50.4 43.9-91.1 0-14.1-2.2-27.9-5.3-41H607c4.4 0 8-3.6 8-8v-30c0-4.4-3.6-8-8-8H495c-7.2-22.6-13.4-45.7-13.4-70.5 0-43.5 34-70.2 87.3-70.2 21.5 0 42.5 4.1 60.4 10.5 5.2 1.9 10.6-2 10.6-7.6v-39.5c0-3.3-2.1-6.3-5.2-7.5-18.8-7.2-43.8-12.7-70.3-12.7-92.9 0-151.5 44.5-151.5 120.3 0 26.3 6.9 52 14.6 77.1H374c-4.4 0-8 3.6-8 8v30c0 4.4 3.6 8 8 8h67.1c3.4 14.7 5.9 29.4 5.9 44.2 0 45.2-28.8 83.3-72.8 94.2-3.6.9-6.1 4.1-6.1 7.8V722c0 4.4 3.6 8 8 8H650c4.4 0 8-3.6 8-8v-39.8c0-4.4-3.6-8-8-8z'));
exports.PoweroffOutline = getIcon('poweroff', outline, getNode(newViewBox, 'M705.6 124.9a8 8 0 0 0-11.6 7.2v64.2c0 5.5 2.9 10.6 7.5 13.6a352.2 352.2 0 0 1 62.2 49.8c32.7 32.8 58.4 70.9 76.3 113.3a355 355 0 0 1 27.9 138.7c0 48.1-9.4 94.8-27.9 138.7a355.92 355.92 0 0 1-76.3 113.3 353.06 353.06 0 0 1-113.2 76.4c-43.8 18.6-90.5 28-138.5 28s-94.7-9.4-138.5-28a353.06 353.06 0 0 1-113.2-76.4A355.92 355.92 0 0 1 184 650.4a355 355 0 0 1-27.9-138.7c0-48.1 9.4-94.8 27.9-138.7 17.9-42.4 43.6-80.5 76.3-113.3 19-19 39.8-35.6 62.2-49.8 4.7-2.9 7.5-8.1 7.5-13.6V132c0-6-6.3-9.8-11.6-7.2C178.5 195.2 82 339.3 80 506.3 77.2 745.1 272.5 943.5 511.2 944c239 .5 432.8-193.3 432.8-432.4 0-169.2-97-315.7-238.4-386.7zM480 560h64c4.4 0 8-3.6 8-8V88c0-4.4-3.6-8-8-8h-64c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8z'));
exports.PullRequestOutline = getIcon('pull-request', outline, getNode(newViewBox, 'M788 705.9V192c0-8.8-7.2-16-16-16H602v-68.8c0-6-7-9.4-11.7-5.7L462.7 202.3a7.14 7.14 0 0 0 0 11.3l127.5 100.8c4.7 3.7 11.7.4 11.7-5.7V240h114v465.9c-44.2 15-76 56.9-76 106.1 0 61.8 50.2 112 112 112s112-50.2 112-112c.1-49.2-31.7-91-75.9-106.1zM752 860a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96zM384 212c0-61.8-50.2-112-112-112s-112 50.2-112 112c0 49.2 31.8 91 76 106.1V706c-44.2 15-76 56.9-76 106.1 0 61.8 50.2 112 112 112s112-50.2 112-112c0-49.2-31.8-91-76-106.1V318.1c44.2-15.1 76-56.9 76-106.1zm-160 0a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm96 600a48.01 48.01 0 0 1-96 0 48.01 48.01 0 0 1 96 0z'));
exports.QqOutline = getIcon('qq', outline, getNode(newViewBox, 'M824.8 613.2c-16-51.4-34.4-94.6-62.7-165.3C766.5 262.2 689.3 112 511.5 112 331.7 112 256.2 265.2 261 447.9c-28.4 70.8-46.7 113.7-62.7 165.3-34 109.5-23 154.8-14.6 155.8 18 2.2 70.1-82.4 70.1-82.4 0 49 25.2 112.9 79.8 159-26.4 8.1-85.7 29.9-71.6 53.8 11.4 19.3 196.2 12.3 249.5 6.3 53.3 6 238.1 13 249.5-6.3 14.1-23.8-45.3-45.7-71.6-53.8 54.6-46.2 79.8-110.1 79.8-159 0 0 52.1 84.6 70.1 82.4 8.5-1.1 19.5-46.4-14.5-155.8z'));
exports.QuestionOutline = getIcon('question', outline, getNode(newViewBox, 'M764 280.9c-14-30.6-33.9-58.1-59.3-81.6C653.1 151.4 584.6 125 512 125s-141.1 26.4-192.7 74.2c-25.4 23.6-45.3 51-59.3 81.7-14.6 32-22 65.9-22 100.9v27c0 6.2 5 11.2 11.2 11.2h54c6.2 0 11.2-5 11.2-11.2v-27c0-99.5 88.6-180.4 197.6-180.4s197.6 80.9 197.6 180.4c0 40.8-14.5 79.2-42 111.2-27.2 31.7-65.6 54.4-108.1 64-24.3 5.5-46.2 19.2-61.7 38.8a110.85 110.85 0 0 0-23.9 68.6v31.4c0 6.2 5 11.2 11.2 11.2h54c6.2 0 11.2-5 11.2-11.2v-31.4c0-15.7 10.9-29.5 26-32.9 58.4-13.2 111.4-44.7 149.3-88.7 19.1-22.3 34-47.1 44.3-74 10.7-27.9 16.1-57.2 16.1-87 0-35-7.4-69-22-100.9zM512 787c-30.9 0-56 25.1-56 56s25.1 56 56 56 56-25.1 56-56-25.1-56-56-56z'));
exports.RadarChartOutline = getIcon('radar-chart', outline, getNode(newViewBox, 'M926.8 397.1l-396-288a31.81 31.81 0 0 0-37.6 0l-396 288a31.99 31.99 0 0 0-11.6 35.8l151.3 466a32 32 0 0 0 30.4 22.1h489.5c13.9 0 26.1-8.9 30.4-22.1l151.3-466c4.2-13.2-.5-27.6-11.7-35.8zM838.6 417l-98.5 32-200-144.7V199.9L838.6 417zM466 567.2l-89.1 122.3-55.2-169.2L466 567.2zm-116.3-96.8L484 373.3v140.8l-134.3-43.7zM512 599.2l93.9 128.9H418.1L512 599.2zm28.1-225.9l134.2 97.1L540.1 514V373.3zM558 567.2l144.3-46.9-55.2 169.2L558 567.2zm-74-367.3v104.4L283.9 449l-98.5-32L484 199.9zM169.3 470.8l86.5 28.1 80.4 246.4-53.8 73.9-113.1-348.4zM327.1 853l50.3-69h269.3l50.3 69H327.1zm414.5-33.8l-53.8-73.9 80.4-246.4 86.5-28.1-113.1 348.4z'));
exports.QrcodeOutline = getIcon('qrcode', outline, getNode(newViewBox, 'M468 128H160c-17.7 0-32 14.3-32 32v308c0 4.4 3.6 8 8 8h332c4.4 0 8-3.6 8-8V136c0-4.4-3.6-8-8-8zm-56 284H192V192h220v220zm-138-74h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm194 210H136c-4.4 0-8 3.6-8 8v308c0 17.7 14.3 32 32 32h308c4.4 0 8-3.6 8-8V556c0-4.4-3.6-8-8-8zm-56 284H192V612h220v220zm-138-74h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm590-630H556c-4.4 0-8 3.6-8 8v332c0 4.4 3.6 8 8 8h332c4.4 0 8-3.6 8-8V160c0-17.7-14.3-32-32-32zm-32 284H612V192h220v220zm-138-74h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm194 210h-48c-4.4 0-8 3.6-8 8v134h-78V556c0-4.4-3.6-8-8-8H556c-4.4 0-8 3.6-8 8v332c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V644h78v102c0 4.4 3.6 8 8 8h190c4.4 0 8-3.6 8-8V556c0-4.4-3.6-8-8-8zM746 832h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm142 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z'));
exports.RadiusBottomleftOutline = getIcon('radius-bottomleft', outline, getNode(newViewBox, 'M712 824h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm2-696h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM136 374h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm0-174h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm752 624h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-348 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-230 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm230 624H358c-87.3 0-158-70.7-158-158V484c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v182c0 127 103 230 230 230h182c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
exports.RadiusBottomrightOutline = getIcon('radius-bottomright', outline, getNode(newViewBox, 'M368 824h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-58-624h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm578 102h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM192 824h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm292 72h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm174 0h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm230 276h-56c-4.4 0-8 3.6-8 8v182c0 87.3-70.7 158-158 158H484c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h182c127 0 230-103 230-230V484c0-4.4-3.6-8-8-8z'));
exports.RadiusUpleftOutline = getIcon('radius-upleft', outline, getNode(newViewBox, 'M656 200h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm58 624h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM192 650h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm696-696h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-348 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-174 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm174-696H358c-127 0-230 103-230 230v182c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V358c0-87.3 70.7-158 158-158h182c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
exports.RadiusUprightOutline = getIcon('radius-upright', outline, getNode(newViewBox, 'M368 128h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-2 696h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm522-174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM192 128h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 174h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm348 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm174 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-48-696H484c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h182c87.3 0 158 70.7 158 158v182c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V358c0-127-103-230-230-230z'));
exports.RadiusSettingOutline = getIcon('radius-setting', outline, getNode(newViewBox, 'M396 140h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm-44 684h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm524-204h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM192 344h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 160h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 160h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 160h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm320 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm160 0h-56c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm140-284c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V370c0-127-103-230-230-230H484c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h170c87.3 0 158 70.7 158 158v170zM236 96H92c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h144c4.4 0 8-3.6 8-8V104c0-4.4-3.6-8-8-8zm-48 101.6c0 1.3-1.1 2.4-2.4 2.4h-43.2c-1.3 0-2.4-1.1-2.4-2.4v-43.2c0-1.3 1.1-2.4 2.4-2.4h43.2c1.3 0 2.4 1.1 2.4 2.4v43.2zM920 780H776c-4.4 0-8 3.6-8 8v144c0 4.4 3.6 8 8 8h144c4.4 0 8-3.6 8-8V788c0-4.4-3.6-8-8-8zm-48 101.6c0 1.3-1.1 2.4-2.4 2.4h-43.2c-1.3 0-2.4-1.1-2.4-2.4v-43.2c0-1.3 1.1-2.4 2.4-2.4h43.2c1.3 0 2.4 1.1 2.4 2.4v43.2z'));
exports.RedditOutline = getIcon('reddit', outline, getNode(newViewBox, 'M288 568a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm338.7 119.7c-23.1 18.2-68.9 37.8-114.7 37.8s-91.6-19.6-114.7-37.8c-14.4-11.3-35.3-8.9-46.7 5.5s-8.9 35.3 5.5 46.7C396.3 771.6 457.5 792 512 792s115.7-20.4 155.9-52.1a33.25 33.25 0 1 0-41.2-52.2zM960 456c0-61.9-50.1-112-112-112-42.1 0-78.7 23.2-97.9 57.6-57.6-31.5-127.7-51.8-204.1-56.5L612.9 195l127.9 36.9c11.5 32.6 42.6 56.1 79.2 56.1 46.4 0 84-37.6 84-84s-37.6-84-84-84c-32 0-59.8 17.9-74 44.2L603.5 123a33.2 33.2 0 0 0-39.6 18.4l-90.8 203.9c-74.5 5.2-142.9 25.4-199.2 56.2A111.94 111.94 0 0 0 176 344c-61.9 0-112 50.1-112 112 0 45.8 27.5 85.1 66.8 102.5-7.1 21-10.8 43-10.8 65.5 0 154.6 175.5 280 392 280s392-125.4 392-280c0-22.6-3.8-44.5-10.8-65.5C932.5 541.1 960 501.8 960 456zM820 172.5a31.5 31.5 0 1 1 0 63 31.5 31.5 0 0 1 0-63zM120 456c0-30.9 25.1-56 56-56a56 56 0 0 1 50.6 32.1c-29.3 22.2-53.5 47.8-71.5 75.9a56.23 56.23 0 0 1-35.1-52zm392 381.5c-179.8 0-325.5-95.6-325.5-213.5S332.2 410.5 512 410.5 837.5 506.1 837.5 624 691.8 837.5 512 837.5zM868.8 508c-17.9-28.1-42.2-53.7-71.5-75.9 9-18.9 28.3-32.1 50.6-32.1 30.9 0 56 25.1 56 56 .1 23.5-14.5 43.7-35.1 52zM624 568a56 56 0 1 0 112 0 56 56 0 1 0-112 0z'));
exports.RedoOutline = getIcon('redo', outline, getNode(newViewBox, 'M758.2 839.1C851.8 765.9 912 651.9 912 523.9 912 303 733.5 124.3 512.6 124 291.4 123.7 112 302.8 112 523.9c0 125.2 57.5 236.9 147.6 310.2 3.5 2.8 8.6 2.2 11.4-1.3l39.4-50.5c2.7-3.4 2.1-8.3-1.2-11.1-8.1-6.6-15.9-13.7-23.4-21.2a318.64 318.64 0 0 1-68.6-101.7C200.4 609 192 567.1 192 523.9s8.4-85.1 25.1-124.5c16.1-38.1 39.2-72.3 68.6-101.7 29.4-29.4 63.6-52.5 101.7-68.6C426.9 212.4 468.8 204 512 204s85.1 8.4 124.5 25.1c38.1 16.1 72.3 39.2 101.7 68.6 29.4 29.4 52.5 63.6 68.6 101.7 16.7 39.4 25.1 81.3 25.1 124.5s-8.4 85.1-25.1 124.5a318.64 318.64 0 0 1-68.6 101.7c-9.3 9.3-19.1 18-29.3 26L668.2 724a8 8 0 0 0-14.1 3l-39.6 162.2c-1.2 5 2.6 9.9 7.7 9.9l167 .8c6.7 0 10.5-7.7 6.3-12.9l-37.3-47.9z'));
exports.ReloadOutline = getIcon('reload', outline, getNode(newViewBox, 'M909.1 209.3l-56.4 44.1C775.8 155.1 656.2 92 521.9 92 290 92 102.3 279.5 102 511.5 101.7 743.7 289.8 932 521.9 932c181.3 0 335.8-115 394.6-276.1 1.5-4.2-.7-8.9-4.9-10.3l-56.7-19.5a8 8 0 0 0-10.1 4.8c-1.8 5-3.8 10-5.9 14.9-17.3 41-42.1 77.8-73.7 109.4A344.77 344.77 0 0 1 655.9 829c-42.3 17.9-87.4 27-133.8 27-46.5 0-91.5-9.1-133.8-27A341.5 341.5 0 0 1 279 755.2a342.16 342.16 0 0 1-73.7-109.4c-17.9-42.4-27-87.4-27-133.9s9.1-91.5 27-133.9c17.3-41 42.1-77.8 73.7-109.4 31.6-31.6 68.4-56.4 109.3-73.8 42.3-17.9 87.4-27 133.8-27 46.5 0 91.5 9.1 133.8 27a341.5 341.5 0 0 1 109.3 73.8c9.9 9.9 19.2 20.4 27.8 31.4l-60.2 47a8 8 0 0 0 3 14.1l175.6 43c5 1.2 9.9-2.6 9.9-7.7l.8-180.9c-.1-6.6-7.8-10.3-13-6.2z'));
exports.RetweetOutline = getIcon('retweet', outline, getNode(normalViewBox, 'M136 552h63.6c4.4 0 8-3.6 8-8V288.7h528.6v72.6c0 1.9.6 3.7 1.8 5.2a8.3 8.3 0 0 0 11.7 1.4L893 255.4c4.3-5 3.6-10.3 0-13.2L749.7 129.8a8.22 8.22 0 0 0-5.2-1.8c-4.6 0-8.4 3.8-8.4 8.4V209H199.7c-39.5 0-71.7 32.2-71.7 71.8V544c0 4.4 3.6 8 8 8zm752-80h-63.6c-4.4 0-8 3.6-8 8v255.3H287.8v-72.6c0-1.9-.6-3.7-1.8-5.2a8.3 8.3 0 0 0-11.7-1.4L131 768.6c-4.3 5-3.6 10.3 0 13.2l143.3 112.4c1.5 1.2 3.3 1.8 5.2 1.8 4.6 0 8.4-3.8 8.4-8.4V815h536.6c39.5 0 71.7-32.2 71.7-71.8V480c-.2-4.4-3.8-8-8.2-8z'));
exports.RightOutline = getIcon('right', outline, getNode(newViewBox, 'M765.7 486.8L314.9 134.7A7.97 7.97 0 0 0 302 141v77.3c0 4.9 2.3 9.6 6.1 12.6l360 281.1-360 281.1c-3.9 3-6.1 7.7-6.1 12.6V883c0 6.7 7.7 10.4 12.9 6.3l450.8-352.1a31.96 31.96 0 0 0 0-50.4z'));
exports.RiseOutline = getIcon('rise', outline, getNode(newViewBox, 'M917 211.1l-199.2 24c-6.6.8-9.4 8.9-4.7 13.6l59.3 59.3-226 226-101.8-101.7c-6.3-6.3-16.4-6.2-22.6 0L100.3 754.1a8.03 8.03 0 0 0 0 11.3l45 45.2c3.1 3.1 8.2 3.1 11.3 0L433.3 534 535 635.7c6.3 6.2 16.4 6.2 22.6 0L829 364.5l59.3 59.3a8.01 8.01 0 0 0 13.6-4.7l24-199.2c.7-5.1-3.7-9.5-8.9-8.8z'));
exports.RollbackOutline = getIcon('rollback', outline, getNode(newViewBox, 'M793 242H366v-74c0-6.7-7.7-10.4-12.9-6.3l-142 112a8 8 0 0 0 0 12.6l142 112c5.2 4.1 12.9.4 12.9-6.3v-74h415v470H175c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h618c35.3 0 64-28.7 64-64V306c0-35.3-28.7-64-64-64z'));
exports.SafetyOutline = getIcon('safety', outline, getNode(normalViewBox, 'M512 64L128 192v384c0 212.1 171.9 384 384 384s384-171.9 384-384V192L512 64zm312 512c0 172.3-139.7 312-312 312S200 748.3 200 576V246l312-110 312 110v330z', 'M378.4 475.1a35.91 35.91 0 0 0-50.9 0 35.91 35.91 0 0 0 0 50.9l129.4 129.4 2.1 2.1a33.98 33.98 0 0 0 48.1 0L730.6 434a33.98 33.98 0 0 0 0-48.1l-2.8-2.8a33.98 33.98 0 0 0-48.1 0L483 579.7 378.4 475.1z'));
exports.RobotOutline = getIcon('robot', outline, getNode(newViewBox, 'M300 328a60 60 0 1 0 120 0 60 60 0 1 0-120 0zM852 64H172c-17.7 0-32 14.3-32 32v660c0 17.7 14.3 32 32 32h680c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-32 660H204V128h616v596zM604 328a60 60 0 1 0 120 0 60 60 0 1 0-120 0zm250.2 556H169.8c-16.5 0-29.8 14.3-29.8 32v36c0 4.4 3.3 8 7.4 8h729.1c4.1 0 7.4-3.6 7.4-8v-36c.1-17.7-13.2-32-29.7-32zM664 508H360c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h304c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z'));
exports.SearchOutline = getIcon('search', outline, getNode(newViewBox, 'M909.6 854.5L649.9 594.8C690.2 542.7 712 479 712 412c0-80.2-31.3-155.4-87.9-212.1-56.6-56.7-132-87.9-212.1-87.9s-155.5 31.3-212.1 87.9C143.2 256.5 112 331.8 112 412c0 80.1 31.3 155.5 87.9 212.1C256.5 680.8 331.8 712 412 712c67 0 130.6-21.8 182.7-62l259.7 259.6a8.2 8.2 0 0 0 11.6 0l43.6-43.5a8.2 8.2 0 0 0 0-11.6zM570.4 570.4C528 612.7 471.8 636 412 636s-116-23.3-158.4-65.6C211.3 528 188 471.8 188 412s23.3-116.1 65.6-158.4C296 211.3 352.2 188 412 188s116.1 23.2 158.4 65.6S636 352.2 636 412s-23.3 116.1-65.6 158.4z'));
exports.ScanOutline = getIcon('scan', outline, getNode(newViewBox, 'M136 384h56c4.4 0 8-3.6 8-8V200h176c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H196c-37.6 0-68 30.4-68 68v180c0 4.4 3.6 8 8 8zm512-184h176v176c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V196c0-37.6-30.4-68-68-68H648c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zM376 824H200V648c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v180c0 37.6 30.4 68 68 68h180c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm512-184h-56c-4.4 0-8 3.6-8 8v176H648c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h180c37.6 0 68-30.4 68-68V648c0-4.4-3.6-8-8-8zm16-164H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
exports.ScissorOutline = getIcon('scissor', outline, getNode(newViewBox, 'M567.1 512l318.5-319.3c5-5 1.5-13.7-5.6-13.7h-90.5c-2.1 0-4.2.8-5.6 2.3l-273.3 274-90.2-90.5c12.5-22.1 19.7-47.6 19.7-74.8 0-83.9-68.1-152-152-152s-152 68.1-152 152 68.1 152 152 152c27.7 0 53.6-7.4 75.9-20.3l90 90.3-90.1 90.3A151.04 151.04 0 0 0 288 582c-83.9 0-152 68.1-152 152s68.1 152 152 152 152-68.1 152-152c0-27.2-7.2-52.7-19.7-74.8l90.2-90.5 273.3 274c1.5 1.5 3.5 2.3 5.6 2.3H880c7.1 0 10.7-8.6 5.6-13.7L567.1 512zM288 370c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80zm0 444c-44.1 0-80-35.9-80-80s35.9-80 80-80 80 35.9 80 80-35.9 80-80 80z'));
exports.SelectOutline = getIcon('select', outline, getNode(newViewBox, 'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h360c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H184V184h656v320c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V144c0-17.7-14.3-32-32-32zM653.3 599.4l52.2-52.2a8.01 8.01 0 0 0-4.7-13.6l-179.4-21c-5.1-.6-9.5 3.7-8.9 8.9l21 179.4c.8 6.6 8.9 9.4 13.6 4.7l52.4-52.4 256.2 256.2c3.1 3.1 8.2 3.1 11.3 0l42.4-42.4c3.1-3.1 3.1-8.2 0-11.3L653.3 599.4z'));
exports.ShakeOutline = getIcon('shake', outline, getNode(newViewBox, 'M324 666a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm616.7-309.6L667.6 83.2C655.2 70.9 638.7 64 621.1 64s-34.1 6.8-46.5 19.2L83.3 574.5a65.85 65.85 0 0 0 0 93.1l273.2 273.2c12.3 12.3 28.9 19.2 46.5 19.2s34.1-6.8 46.5-19.2l491.3-491.3c25.6-25.7 25.6-67.5-.1-93.1zM403 880.1L143.9 621l477.2-477.2 259 259.2L403 880.1zM152.8 373.7a7.9 7.9 0 0 0 11.2 0L373.7 164a7.9 7.9 0 0 0 0-11.2l-38.4-38.4a7.9 7.9 0 0 0-11.2 0L114.3 323.9a7.9 7.9 0 0 0 0 11.2l38.5 38.6zm718.6 276.6a7.9 7.9 0 0 0-11.2 0L650.3 860.1a7.9 7.9 0 0 0 0 11.2l38.4 38.4a7.9 7.9 0 0 0 11.2 0L909.7 700a7.9 7.9 0 0 0 0-11.2l-38.3-38.5z'));
exports.ShareAltOutline = getIcon('share-alt', outline, getNode(newViewBox, 'M752 664c-28.5 0-54.8 10-75.4 26.7L469.4 540.8a160.68 160.68 0 0 0 0-57.6l207.2-149.9C697.2 350 723.5 360 752 360c66.2 0 120-53.8 120-120s-53.8-120-120-120-120 53.8-120 120c0 11.6 1.6 22.7 4.7 33.3L439.9 415.8C410.7 377.1 364.3 352 312 352c-88.4 0-160 71.6-160 160s71.6 160 160 160c52.3 0 98.7-25.1 127.9-63.8l196.8 142.5c-3.1 10.6-4.7 21.8-4.7 33.3 0 66.2 53.8 120 120 120s120-53.8 120-120-53.8-120-120-120zm0-476c28.7 0 52 23.3 52 52s-23.3 52-52 52-52-23.3-52-52 23.3-52 52-52zM312 600c-48.5 0-88-39.5-88-88s39.5-88 88-88 88 39.5 88 88-39.5 88-88 88zm440 236c-28.7 0-52-23.3-52-52s23.3-52 52-52 52 23.3 52 52-23.3 52-52 52z'));
exports.ShoppingCartOutline = getIcon('shopping-cart', outline, getNode(normalViewBox, 'M922.9 701.9H327.4l29.9-60.9 496.8-.9c16.8 0 31.2-12 34.2-28.6l68.8-385.1c1.8-10.1-.9-20.5-7.5-28.4a34.99 34.99 0 0 0-26.6-12.5l-632-2.1-5.4-25.4c-3.4-16.2-18-28-34.6-28H96.5a35.3 35.3 0 1 0 0 70.6h125.9L246 312.8l58.1 281.3-74.8 122.1a34.96 34.96 0 0 0-3 36.8c6 11.9 18.1 19.4 31.5 19.4h62.8a102.43 102.43 0 0 0-20.6 61.7c0 56.6 46 102.6 102.6 102.6s102.6-46 102.6-102.6c0-22.3-7.4-44-20.6-61.7h161.1a102.43 102.43 0 0 0-20.6 61.7c0 56.6 46 102.6 102.6 102.6s102.6-46 102.6-102.6c0-22.3-7.4-44-20.6-61.7H923c19.4 0 35.3-15.8 35.3-35.3a35.42 35.42 0 0 0-35.4-35.2zM305.7 253l575.8 1.9-56.4 315.8-452.3.8L305.7 253zm96.9 612.7c-17.4 0-31.6-14.2-31.6-31.6 0-17.4 14.2-31.6 31.6-31.6s31.6 14.2 31.6 31.6a31.6 31.6 0 0 1-31.6 31.6zm325.1 0c-17.4 0-31.6-14.2-31.6-31.6 0-17.4 14.2-31.6 31.6-31.6s31.6 14.2 31.6 31.6a31.6 31.6 0 0 1-31.6 31.6z'));
exports.ShrinkOutline = getIcon('shrink', outline, getNode(newViewBox, 'M881.7 187.4l-45.1-45.1a8.03 8.03 0 0 0-11.3 0L667.8 299.9l-54.7-54.7a7.94 7.94 0 0 0-13.5 4.7L576.1 439c-.6 5.2 3.7 9.5 8.9 8.9l189.2-23.5c6.6-.8 9.3-8.8 4.7-13.5l-54.7-54.7 157.6-157.6c3-3 3-8.1-.1-11.2zM439 576.1l-189.2 23.5c-6.6.8-9.3 8.9-4.7 13.5l54.7 54.7-157.5 157.5a8.03 8.03 0 0 0 0 11.3l45.1 45.1c3.1 3.1 8.2 3.1 11.3 0l157.6-157.6 54.7 54.7a7.94 7.94 0 0 0 13.5-4.7L447.9 585a7.9 7.9 0 0 0-8.9-8.9z'));
exports.SlackOutline = getIcon('slack', outline, getNode(newViewBox, 'M409.4 128c-42.4 0-76.7 34.4-76.7 76.8 0 20.3 8.1 39.9 22.4 54.3a76.74 76.74 0 0 0 54.3 22.5h76.7v-76.8c0-42.3-34.3-76.7-76.7-76.8zm0 204.8H204.7c-42.4 0-76.7 34.4-76.7 76.8s34.4 76.8 76.7 76.8h204.6c42.4 0 76.7-34.4 76.7-76.8.1-42.4-34.3-76.8-76.6-76.8zM614 486.4c42.4 0 76.8-34.4 76.7-76.8V204.8c0-42.4-34.3-76.8-76.7-76.8-42.4 0-76.7 34.4-76.7 76.8v204.8c0 42.5 34.3 76.8 76.7 76.8zm281.4-76.8c0-42.4-34.4-76.8-76.7-76.8S742 367.2 742 409.6v76.8h76.7c42.3 0 76.7-34.4 76.7-76.8zm-76.8 128H614c-42.4 0-76.7 34.4-76.7 76.8 0 20.3 8.1 39.9 22.4 54.3a76.74 76.74 0 0 0 54.3 22.5h204.6c42.4 0 76.7-34.4 76.7-76.8.1-42.4-34.3-76.7-76.7-76.8zM614 742.4h-76.7v76.8c0 42.4 34.4 76.8 76.7 76.8 42.4 0 76.8-34.4 76.7-76.8.1-42.4-34.3-76.7-76.7-76.8zM409.4 537.6c-42.4 0-76.7 34.4-76.7 76.8v204.8c0 42.4 34.4 76.8 76.7 76.8 42.4 0 76.8-34.4 76.7-76.8V614.4c0-20.3-8.1-39.9-22.4-54.3a76.92 76.92 0 0 0-54.3-22.5zM128 614.4c0 20.3 8.1 39.9 22.4 54.3a76.74 76.74 0 0 0 54.3 22.5c42.4 0 76.8-34.4 76.7-76.8v-76.8h-76.7c-42.3 0-76.7 34.4-76.7 76.8z'));
exports.SmallDashOutline = getIcon('small-dash', outline, getNode(newViewBox, 'M112 476h72v72h-72zm182 0h72v72h-72zm364 0h72v72h-72zm182 0h72v72h-72zm-364 0h72v72h-72z'));
exports.SolutionOutline = getIcon('solution', outline, getNode(newViewBox, 'M688 264c0-4.4-3.6-8-8-8H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48zm-8 136H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM480 544H296c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-48 308H208V148h560v344c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V108c0-17.7-14.3-32-32-32H168c-17.7 0-32 14.3-32 32v784c0 17.7 14.3 32 32 32h264c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm356.8-74.4c29-26.3 47.2-64.3 47.2-106.6 0-79.5-64.5-144-144-144s-144 64.5-144 144c0 42.3 18.2 80.3 47.2 106.6-57 32.5-96.2 92.7-99.2 162.1-.2 4.5 3.5 8.3 8 8.3h48.1c4.2 0 7.7-3.3 8-7.6C564 871.2 621.7 816 692 816s128 55.2 131.9 124.4c.2 4.2 3.7 7.6 8 7.6H880c4.6 0 8.2-3.8 8-8.3-2.9-69.5-42.2-129.6-99.2-162.1zM692 591c44.2 0 80 35.8 80 80s-35.8 80-80 80-80-35.8-80-80 35.8-80 80-80z'));
exports.SketchOutline = getIcon('sketch', outline, getNode(newViewBox, 'M925.6 405.1l-203-253.7a6.5 6.5 0 0 0-5-2.4H306.4c-1.9 0-3.8.9-5 2.4l-203 253.7a6.5 6.5 0 0 0 .2 8.3l408.6 459.5c1.2 1.4 3 2.1 4.8 2.1 1.8 0 3.5-.8 4.8-2.1l408.6-459.5a6.5 6.5 0 0 0 .2-8.3zM645.2 206.4l34.4 133.9-132.5-133.9h98.1zm8.2 178.5H370.6L512 242l141.4 142.9zM378.8 206.4h98.1L344.3 340.3l34.5-133.9zm-53.4 7l-44.1 171.5h-93.1l137.2-171.5zM194.6 434.9H289l125.8 247.7-220.2-247.7zM512 763.4L345.1 434.9h333.7L512 763.4zm97.1-80.8L735 434.9h94.4L609.1 682.6zm133.6-297.7l-44.1-171.5 137.2 171.5h-93.1z'));
exports.SortDescendingOutline = getIcon('sort-descending', outline, getNode(newViewBox, 'M839.6 433.8L749 150.5a9.24 9.24 0 0 0-8.9-6.5h-77.4c-4.1 0-7.6 2.6-8.9 6.5l-91.3 283.3c-.3.9-.5 1.9-.5 2.9 0 5.1 4.2 9.3 9.3 9.3h56.4c4.2 0 7.8-2.8 9-6.8l17.5-61.6h89l17.3 61.5c1.1 4 4.8 6.8 9 6.8h61.2c1 0 1.9-.1 2.8-.4 2.4-.8 4.3-2.4 5.5-4.6 1.1-2.2 1.3-4.7.6-7.1zM663.3 325.5l32.8-116.9h6.3l32.1 116.9h-71.2zm143.5 492.9H677.2v-.4l132.6-188.9c1.1-1.6 1.7-3.4 1.7-5.4v-36.4c0-5.1-4.2-9.3-9.3-9.3h-204c-5.1 0-9.3 4.2-9.3 9.3v43c0 5.1 4.2 9.3 9.3 9.3h122.6v.4L587.7 828.9a9.35 9.35 0 0 0-1.7 5.4v36.4c0 5.1 4.2 9.3 9.3 9.3h211.4c5.1 0 9.3-4.2 9.3-9.3v-43a9.2 9.2 0 0 0-9.2-9.3zM310.3 167.1a8 8 0 0 0-12.6 0L185.7 309c-4.2 5.3-.4 13 6.3 13h76v530c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V322h76c6.7 0 10.5-7.8 6.3-13l-112-141.9z'));
exports.SortAscendingOutline = getIcon('sort-ascending', outline, getNode(newViewBox, 'M839.6 433.8L749 150.5a9.24 9.24 0 0 0-8.9-6.5h-77.4c-4.1 0-7.6 2.6-8.9 6.5l-91.3 283.3c-.3.9-.5 1.9-.5 2.9 0 5.1 4.2 9.3 9.3 9.3h56.4c4.2 0 7.8-2.8 9-6.8l17.5-61.6h89l17.3 61.5c1.1 4 4.8 6.8 9 6.8h61.2c1 0 1.9-.1 2.8-.4 2.4-.8 4.3-2.4 5.5-4.6 1.1-2.2 1.3-4.7.6-7.1zM663.3 325.5l32.8-116.9h6.3l32.1 116.9h-71.2zm143.5 492.9H677.2v-.4l132.6-188.9c1.1-1.6 1.7-3.4 1.7-5.4v-36.4c0-5.1-4.2-9.3-9.3-9.3h-204c-5.1 0-9.3 4.2-9.3 9.3v43c0 5.1 4.2 9.3 9.3 9.3h122.6v.4L587.7 828.9a9.35 9.35 0 0 0-1.7 5.4v36.4c0 5.1 4.2 9.3 9.3 9.3h211.4c5.1 0 9.3-4.2 9.3-9.3v-43a9.2 9.2 0 0 0-9.2-9.3zM416 702h-76V172c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v530h-76c-6.7 0-10.5 7.8-6.3 13l112 141.9a8 8 0 0 0 12.6 0l112-141.9c4.1-5.2.4-13-6.3-13z'));
exports.StockOutline = getIcon('stock', outline, getNode(newViewBox, 'M904 747H120c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM165.7 621.8l39.7 39.5c3.1 3.1 8.2 3.1 11.3 0l234.7-233.9 97.6 97.3a32.11 32.11 0 0 0 45.2 0l264.2-263.2c3.1-3.1 3.1-8.2 0-11.3l-39.7-39.6a8.03 8.03 0 0 0-11.3 0l-235.7 235-97.7-97.3a32.11 32.11 0 0 0-45.2 0L165.7 610.5a7.94 7.94 0 0 0 0 11.3z'));
exports.SwapLeftOutline = getIcon('swap-left', outline, getNode(normalViewBox, 'M872 572H266.8l144.3-183c4.1-5.2.4-13-6.3-13H340c-9.8 0-19.1 4.5-25.1 12.2l-164 208c-16.5 21-1.6 51.8 25.1 51.8h696c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z'));
exports.SwapRightOutline = getIcon('swap-right', outline, getNode(normalViewBox, 'M873.1 596.2l-164-208A32 32 0 0 0 684 376h-64.8c-6.7 0-10.4 7.7-6.3 13l144.3 183H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h695.9c26.8 0 41.7-30.8 25.2-51.8z'));
exports.StrikethroughOutline = getIcon('strikethrough', outline, getNode(newViewBox, 'M952 474H569.9c-10-2-20.5-4-31.6-6-15.9-2.9-22.2-4.1-30.8-5.8-51.3-10-82.2-20-106.8-34.2-35.1-20.5-52.2-48.3-52.2-85.1 0-37 15.2-67.7 44-89 28.4-21 68.8-32.1 116.8-32.1 54.8 0 97.1 14.4 125.8 42.8 14.6 14.4 25.3 32.1 31.8 52.6 1.3 4.1 2.8 10 4.3 17.8.9 4.8 5.2 8.2 9.9 8.2h72.8c5.6 0 10.1-4.6 10.1-10.1v-1c-.7-6.8-1.3-12.1-2-16-7.3-43.5-28-81.7-59.7-110.3-44.4-40.5-109.7-61.8-188.7-61.8-72.3 0-137.4 18.1-183.3 50.9-25.6 18.4-45.4 41.2-58.6 67.7-13.5 27.1-20.3 58.4-20.3 92.9 0 29.5 5.7 54.5 17.3 76.5 8.3 15.7 19.6 29.5 34.1 42H72c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h433.2c2.1.4 3.9.8 5.9 1.2 30.9 6.2 49.5 10.4 66.6 15.2 23 6.5 40.6 13.3 55.2 21.5 35.8 20.2 53.3 49.2 53.3 89 0 35.3-15.5 66.8-43.6 88.8-30.5 23.9-75.6 36.4-130.5 36.4-43.7 0-80.7-8.5-110.2-25-29.1-16.3-49.1-39.8-59.7-69.5-.8-2.2-1.7-5.2-2.7-9-1.2-4.4-5.3-7.5-9.7-7.5h-79.7c-5.6 0-10.1 4.6-10.1 10.1v1c.2 2.3.4 4.2.6 5.7 6.5 48.8 30.3 88.8 70.7 118.8 47.1 34.8 113.4 53.2 191.8 53.2 84.2 0 154.8-19.8 204.2-57.3 25-18.9 44.2-42.2 57.1-69 13-27.1 19.7-57.9 19.7-91.5 0-31.8-5.8-58.4-17.8-81.4-5.8-11.2-13.1-21.5-21.8-30.8H952c4.4 0 8-3.6 8-8v-60a8 8 0 0 0-8-7.9z'));
exports.SwapOutline = getIcon('swap', outline, getNode(newViewBox, 'M847.9 592H152c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h605.2L612.9 851c-4.1 5.2-.4 13 6.3 13h72.5c4.9 0 9.5-2.2 12.6-6.1l168.8-214.1c16.5-21 1.6-51.8-25.2-51.8zM872 356H266.8l144.3-183c4.1-5.2.4-13-6.3-13h-72.5c-4.9 0-9.5 2.2-12.6 6.1L150.9 380.2c-16.5 21-1.6 51.8 25.1 51.8h696c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8z'));
exports.SyncOutline = getIcon('sync', outline, getNode(newViewBox, 'M168 504.2c1-43.7 10-86.1 26.9-126 17.3-41 42.1-77.7 73.7-109.4S337 212.3 378 195c42.4-17.9 87.4-27 133.9-27s91.5 9.1 133.8 27A341.5 341.5 0 0 1 755 268.8c9.9 9.9 19.2 20.4 27.8 31.4l-60.2 47a8 8 0 0 0 3 14.1l175.7 43c5 1.2 9.9-2.6 9.9-7.7l.8-180.9c0-6.7-7.7-10.5-12.9-6.3l-56.4 44.1C765.8 155.1 646.2 92 511.8 92 282.7 92 96.3 275.6 92 503.8a8 8 0 0 0 8 8.2h60c4.4 0 7.9-3.5 8-7.8zm756 7.8h-60c-4.4 0-7.9 3.5-8 7.8-1 43.7-10 86.1-26.9 126-17.3 41-42.1 77.8-73.7 109.4A342.45 342.45 0 0 1 512.1 856a342.24 342.24 0 0 1-243.2-100.8c-9.9-9.9-19.2-20.4-27.8-31.4l60.2-47a8 8 0 0 0-3-14.1l-175.7-43c-5-1.2-9.9 2.6-9.9 7.7l-.7 181c0 6.7 7.7 10.5 12.9 6.3l56.4-44.1C258.2 868.9 377.8 932 512.2 932c229.2 0 415.5-183.7 419.8-411.8a8 8 0 0 0-8-8.2z'));
exports.TableOutline = getIcon('table', outline, getNode(newViewBox, 'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 208H676V232h212v136zm0 224H676V432h212v160zM412 432h200v160H412V432zm200-64H412V232h200v136zm-476 64h212v160H136V432zm0-200h212v136H136V232zm0 424h212v136H136V656zm276 0h200v136H412V656zm476 136H676V656h212v136z'));
exports.TeamOutline = getIcon('team', outline, getNode(newViewBox, 'M824.2 699.9a301.55 301.55 0 0 0-86.4-60.4C783.1 602.8 812 546.8 812 484c0-110.8-92.4-201.7-203.2-200-109.1 1.7-197 90.6-197 200 0 62.8 29 118.8 74.2 155.5a300.95 300.95 0 0 0-86.4 60.4C345 754.6 314 826.8 312 903.8a8 8 0 0 0 8 8.2h56c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5A226.62 226.62 0 0 1 612 684c60.9 0 118.2 23.7 161.3 66.8C814.5 792 838 846.3 840 904.3c.1 4.3 3.7 7.7 8 7.7h56a8 8 0 0 0 8-8.2c-2-77-33-149.2-87.8-203.9zM612 612c-34.2 0-66.4-13.3-90.5-37.5a126.86 126.86 0 0 1-37.5-91.8c.3-32.8 13.4-64.5 36.3-88 24-24.6 56.1-38.3 90.4-38.7 33.9-.3 66.8 12.9 91 36.6 24.8 24.3 38.4 56.8 38.4 91.4 0 34.2-13.3 66.3-37.5 90.5A127.3 127.3 0 0 1 612 612zM361.5 510.4c-.9-8.7-1.4-17.5-1.4-26.4 0-15.9 1.5-31.4 4.3-46.5.7-3.6-1.2-7.3-4.5-8.8-13.6-6.1-26.1-14.5-36.9-25.1a127.54 127.54 0 0 1-38.7-95.4c.9-32.1 13.8-62.6 36.3-85.6 24.7-25.3 57.9-39.1 93.2-38.7 31.9.3 62.7 12.6 86 34.4 7.9 7.4 14.7 15.6 20.4 24.4 2 3.1 5.9 4.4 9.3 3.2 17.6-6.1 36.2-10.4 55.3-12.4 5.6-.6 8.8-6.6 6.3-11.6-32.5-64.3-98.9-108.7-175.7-109.9-110.9-1.7-203.3 89.2-203.3 199.9 0 62.8 28.9 118.8 74.2 155.5-31.8 14.7-61.1 35-86.5 60.4-54.8 54.7-85.8 126.9-87.8 204a8 8 0 0 0 8 8.2h56.1c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5 29.4-29.4 65.4-49.8 104.7-59.7 3.9-1 6.5-4.7 6-8.7z'));
exports.TaobaoOutline = getIcon('taobao', outline, getNode(newViewBox, 'M168.5 273.7a68.7 68.7 0 1 0 137.4 0 68.7 68.7 0 1 0-137.4 0zm730 79.2s-23.7-184.4-426.9-70.1c17.3-30 25.6-49.5 25.6-49.5L396.4 205s-40.6 132.6-113 194.4c0 0 70.1 40.6 69.4 39.4 20.1-20.1 38.2-40.6 53.7-60.4 16.1-7 31.5-13.6 46.7-19.8-18.6 33.5-48.7 83.8-78.8 115.6l42.4 37s28.8-27.7 60.4-61.2h36v61.8H372.9v49.5h140.3v118.5c-1.7 0-3.6 0-5.4-.2-15.4-.7-39.5-3.3-49-18.2-11.5-18.1-3-51.5-2.4-71.9h-97l-3.4 1.8s-35.5 159.1 102.3 155.5c129.1 3.6 203-36 238.6-63.1l14.2 52.6 79.6-33.2-53.9-131.9-64.6 20.1 12.1 45.2c-16.6 12.4-35.6 21.7-56.2 28.4V561.3h137.1v-49.5H628.1V450h137.6v-49.5H521.3c17.6-21.4 31.5-41.1 35-53.6l-42.5-11.6c182.8-65.5 284.5-54.2 283.6 53.2v282.8s10.8 97.1-100.4 90.1l-60.2-12.9-14.2 57.1S882.5 880 903.7 680.2c21.3-200-5.2-327.3-5.2-327.3zm-707.4 18.3l-45.4 69.7 83.6 52.1s56 28.5 29.4 81.9C233.8 625.5 112 736.3 112 736.3l109 68.1c75.4-163.7 70.5-142 89.5-200.7 19.5-60.1 23.7-105.9-9.4-139.1-42.4-42.6-47-46.6-110-93.4z'));
exports.ToTopOutline = getIcon('to-top', outline, getNode(newViewBox, 'M885 780H165c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zM400 325.7h73.9V664c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V325.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 171a8 8 0 0 0-12.6 0l-112 141.7c-4.1 5.3-.4 13 6.3 13z'));
exports.TrademarkOutline = getIcon('trademark', outline, getNode(newViewBox, 'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372zm87.5-334.7c34.8-12.8 78.4-49 78.4-119.2 0-71.2-45.5-131.1-144.2-131.1H378c-4.4 0-8 3.6-8 8v410c0 4.4 3.6 8 8 8h54.5c4.4 0 8-3.6 8-8V561.2h88.7l74.6 159.2c1.3 2.8 4.1 4.6 7.2 4.6h62a7.9 7.9 0 0 0 7.1-11.5l-80.6-164.2zM522 505h-81.5V357h83.4c48 0 80.9 25.3 80.9 75.5 0 46.9-29.8 72.5-82.8 72.5z'));
exports.TransactionOutline = getIcon('transaction', outline, getNode(newViewBox, 'M668.6 320c0-4.4-3.6-8-8-8h-54.5c-3 0-5.8 1.7-7.1 4.4l-84.7 168.8H511l-84.7-168.8a8 8 0 0 0-7.1-4.4h-55.7c-1.3 0-2.6.3-3.8 1-3.9 2.1-5.3 7-3.2 10.8l103.9 191.6h-57c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76v39h-76c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76V704c0 4.4 3.6 8 8 8h49.9c4.4 0 8-3.6 8-8v-63.5h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8h-76.3v-39h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8H564l103.7-191.6c.5-1.1.9-2.4.9-3.7zM157.9 504.2a352.7 352.7 0 0 1 103.5-242.4c32.5-32.5 70.3-58.1 112.4-75.9 43.6-18.4 89.9-27.8 137.6-27.8 47.8 0 94.1 9.3 137.6 27.8 42.1 17.8 79.9 43.4 112.4 75.9 10 10 19.3 20.5 27.9 31.4l-50 39.1a8 8 0 0 0 3 14.1l156.8 38.3c5 1.2 9.9-2.6 9.9-7.7l.8-161.5c0-6.7-7.7-10.5-12.9-6.3l-47.8 37.4C770.7 146.3 648.6 82 511.5 82 277 82 86.3 270.1 82 503.8a8 8 0 0 0 8 8.2h60c4.3 0 7.8-3.5 7.9-7.8zM934 512h-60c-4.3 0-7.9 3.5-8 7.8a352.7 352.7 0 0 1-103.5 242.4 352.57 352.57 0 0 1-112.4 75.9c-43.6 18.4-89.9 27.8-137.6 27.8s-94.1-9.3-137.6-27.8a352.57 352.57 0 0 1-112.4-75.9c-10-10-19.3-20.5-27.9-31.4l49.9-39.1a8 8 0 0 0-3-14.1l-156.8-38.3c-5-1.2-9.9 2.6-9.9 7.7l-.8 161.7c0 6.7 7.7 10.5 12.9 6.3l47.8-37.4C253.3 877.7 375.4 942 512.5 942 747 942 937.7 753.9 942 520.2a8 8 0 0 0-8-8.2z'));
exports.TwitterOutline = getIcon('twitter', outline, getNode(newViewBox, 'M928 254.3c-30.6 13.2-63.9 22.7-98.2 26.4a170.1 170.1 0 0 0 75-94 336.64 336.64 0 0 1-108.2 41.2A170.1 170.1 0 0 0 672 174c-94.5 0-170.5 76.6-170.5 170.6 0 13.2 1.6 26.4 4.2 39.1-141.5-7.4-267.7-75-351.6-178.5a169.32 169.32 0 0 0-23.2 86.1c0 59.2 30.1 111.4 76 142.1a172 172 0 0 1-77.1-21.7v2.1c0 82.9 58.6 151.6 136.7 167.4a180.6 180.6 0 0 1-44.9 5.8c-11.1 0-21.6-1.1-32.2-2.6C211 652 273.9 701.1 348.8 702.7c-58.6 45.9-132 72.9-211.7 72.9-14.3 0-27.5-.5-41.2-2.1C171.5 822 261.2 850 357.8 850 671.4 850 843 590.2 843 364.7c0-7.4 0-14.8-.5-22.2 33.2-24.3 62.3-54.4 85.5-88.2z'));
exports.UnderlineOutline = getIcon('underline', outline, getNode(newViewBox, 'M824 804H200c-4.4 0-8 3.4-8 7.6v60.8c0 4.2 3.6 7.6 8 7.6h624c4.4 0 8-3.4 8-7.6v-60.8c0-4.2-3.6-7.6-8-7.6zm-312-76c69.4 0 134.6-27.1 183.8-76.2C745 602.7 772 537.4 772 468V156c0-6.6-5.4-12-12-12h-60c-6.6 0-12 5.4-12 12v312c0 97-79 176-176 176s-176-79-176-176V156c0-6.6-5.4-12-12-12h-60c-6.6 0-12 5.4-12 12v312c0 69.4 27.1 134.6 76.2 183.8C377.3 701 442.6 728 512 728z'));
exports.UndoOutline = getIcon('undo', outline, getNode(newViewBox, 'M511.4 124C290.5 124.3 112 303 112 523.9c0 128 60.2 242 153.8 315.2l-37.5 48c-4.1 5.3-.3 13 6.3 12.9l167-.8c5.2 0 9-4.9 7.7-9.9L369.8 727a8 8 0 0 0-14.1-3L315 776.1c-10.2-8-20-16.7-29.3-26a318.64 318.64 0 0 1-68.6-101.7C200.4 609 192 567.1 192 523.9s8.4-85.1 25.1-124.5c16.1-38.1 39.2-72.3 68.6-101.7 29.4-29.4 63.6-52.5 101.7-68.6C426.9 212.4 468.8 204 512 204s85.1 8.4 124.5 25.1c38.1 16.1 72.3 39.2 101.7 68.6 29.4 29.4 52.5 63.6 68.6 101.7 16.7 39.4 25.1 81.3 25.1 124.5s-8.4 85.1-25.1 124.5a318.64 318.64 0 0 1-68.6 101.7c-7.5 7.5-15.3 14.5-23.4 21.2a7.93 7.93 0 0 0-1.2 11.1l39.4 50.5c2.8 3.5 7.9 4.1 11.4 1.3C854.5 760.8 912 649.1 912 523.9c0-221.1-179.4-400.2-400.6-399.9z'));
exports.UnorderedListOutline = getIcon('unordered-list', outline, getNode(newViewBox, 'M912 192H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zm0 284H328c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h584c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8zM104 228a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm0 284a56 56 0 1 0 112 0 56 56 0 1 0-112 0zm0 284a56 56 0 1 0 112 0 56 56 0 1 0-112 0z'));
exports.UpOutline = getIcon('up', outline, getNode(newViewBox, 'M890.5 755.3L537.9 269.2c-12.8-17.6-39-17.6-51.7 0L133.5 755.3A8 8 0 0 0 140 768h75c5.1 0 9.9-2.5 12.9-6.6L512 369.8l284.1 391.6c3 4.1 7.8 6.6 12.9 6.6h75c6.5 0 10.3-7.4 6.5-12.7z'));
exports.UploadOutline = getIcon('upload', outline, getNode(newViewBox, 'M400 317.7h73.9V656c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V317.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 163a8 8 0 0 0-12.6 0l-112 141.7c-4.1 5.3-.4 13 6.3 13zM878 626h-60c-4.4 0-8 3.6-8 8v154H214V634c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v198c0 17.7 14.3 32 32 32h684c17.7 0 32-14.3 32-32V634c0-4.4-3.6-8-8-8z'));
exports.UserAddOutline = getIcon('user-add', outline, getNode(newViewBox, 'M678.3 642.4c24.2-13 51.9-20.4 81.4-20.4h.1c3 0 4.4-3.6 2.2-5.6a371.67 371.67 0 0 0-103.7-65.8c-.4-.2-.8-.3-1.2-.5C719.2 505 759.6 431.7 759.6 349c0-137-110.8-248-247.5-248S264.7 212 264.7 349c0 82.7 40.4 156 102.6 201.1-.4.2-.8.3-1.2.5-44.7 18.9-84.8 46-119.3 80.6a373.42 373.42 0 0 0-80.4 119.5A373.6 373.6 0 0 0 137 888.8a8 8 0 0 0 8 8.2h59.9c4.3 0 7.9-3.5 8-7.8 2-77.2 32.9-149.5 87.6-204.3C357 628.2 432.2 597 512.2 597c56.7 0 111.1 15.7 158 45.1a8.1 8.1 0 0 0 8.1.3zM512.2 521c-45.8 0-88.9-17.9-121.4-50.4A171.2 171.2 0 0 1 340.5 349c0-45.9 17.9-89.1 50.3-121.6S466.3 177 512.2 177s88.9 17.9 121.4 50.4A171.2 171.2 0 0 1 683.9 349c0 45.9-17.9 89.1-50.3 121.6C601.1 503.1 558 521 512.2 521zM880 759h-84v-84c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v84h-84c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h84v84c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-84h84c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
exports.UsergroupAddOutline = getIcon('usergroup-add', outline, getNode(newViewBox, 'M892 772h-80v-80c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v80h-80c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h80v80c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-80h80c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM373.5 498.4c-.9-8.7-1.4-17.5-1.4-26.4 0-15.9 1.5-31.4 4.3-46.5.7-3.6-1.2-7.3-4.5-8.8-13.6-6.1-26.1-14.5-36.9-25.1a127.54 127.54 0 0 1-38.7-95.4c.9-32.1 13.8-62.6 36.3-85.6 24.7-25.3 57.9-39.1 93.2-38.7 31.9.3 62.7 12.6 86 34.4 7.9 7.4 14.7 15.6 20.4 24.4 2 3.1 5.9 4.4 9.3 3.2 17.6-6.1 36.2-10.4 55.3-12.4 5.6-.6 8.8-6.6 6.3-11.6-32.5-64.3-98.9-108.7-175.7-109.9-110.8-1.7-203.2 89.2-203.2 200 0 62.8 28.9 118.8 74.2 155.5-31.8 14.7-61.1 35-86.5 60.4-54.8 54.7-85.8 126.9-87.8 204a8 8 0 0 0 8 8.2h56.1c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5 29.4-29.4 65.4-49.8 104.7-59.7 3.8-1.1 6.4-4.8 5.9-8.8zM824 472c0-109.4-87.9-198.3-196.9-200C516.3 270.3 424 361.2 424 472c0 62.8 29 118.8 74.2 155.5a300.95 300.95 0 0 0-86.4 60.4C357 742.6 326 814.8 324 891.8a8 8 0 0 0 8 8.2h56c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5C505.8 695.7 563 672 624 672c110.4 0 200-89.5 200-200zm-109.5 90.5C690.3 586.7 658.2 600 624 600s-66.3-13.3-90.5-37.5a127.26 127.26 0 0 1-37.5-91.8c.3-32.8 13.4-64.5 36.3-88 24-24.6 56.1-38.3 90.4-38.7 33.9-.3 66.8 12.9 91 36.6 24.8 24.3 38.4 56.8 38.4 91.4-.1 34.2-13.4 66.3-37.6 90.5z'));
exports.UserOutline = getIcon('user', outline, getNode(newViewBox, 'M858.5 763.6a374 374 0 0 0-80.6-119.5 375.63 375.63 0 0 0-119.5-80.6c-.4-.2-.8-.3-1.2-.5C719.5 518 760 444.7 760 362c0-137-111-248-248-248S264 225 264 362c0 82.7 40.5 156 102.8 201.1-.4.2-.8.3-1.2.5-44.8 18.9-85 46-119.5 80.6a375.63 375.63 0 0 0-80.6 119.5A371.7 371.7 0 0 0 136 901.8a8 8 0 0 0 8 8.2h60c4.4 0 7.9-3.5 8-7.8 2-77.2 33-149.5 87.8-204.3 56.7-56.7 132-87.9 212.2-87.9s155.5 31.2 212.2 87.9C779 752.7 810 825 812 902.2c.1 4.4 3.6 7.8 8 7.8h60a8 8 0 0 0 8-8.2c-1-47.8-10.9-94.3-29.5-138.2zM512 534c-45.9 0-89.1-17.9-121.6-50.4S340 407.9 340 362c0-45.9 17.9-89.1 50.4-121.6S466.1 190 512 190s89.1 17.9 121.6 50.4S684 316.1 684 362c0 45.9-17.9 89.1-50.4 121.6S557.9 534 512 534z'));
exports.UserDeleteOutline = getIcon('user-delete', outline, getNode(newViewBox, 'M678.3 655.4c24.2-13 51.9-20.4 81.4-20.4h.1c3 0 4.4-3.6 2.2-5.6a371.67 371.67 0 0 0-103.7-65.8c-.4-.2-.8-.3-1.2-.5C719.2 518 759.6 444.7 759.6 362c0-137-110.8-248-247.5-248S264.7 225 264.7 362c0 82.7 40.4 156 102.6 201.1-.4.2-.8.3-1.2.5-44.7 18.9-84.8 46-119.3 80.6a373.42 373.42 0 0 0-80.4 119.5A373.6 373.6 0 0 0 137 901.8a8 8 0 0 0 8 8.2h59.9c4.3 0 7.9-3.5 8-7.8 2-77.2 32.9-149.5 87.6-204.3C357 641.2 432.2 610 512.2 610c56.7 0 111.1 15.7 158 45.1a8.1 8.1 0 0 0 8.1.3zM512.2 534c-45.8 0-88.9-17.9-121.4-50.4A171.2 171.2 0 0 1 340.5 362c0-45.9 17.9-89.1 50.3-121.6S466.3 190 512.2 190s88.9 17.9 121.4 50.4A171.2 171.2 0 0 1 683.9 362c0 45.9-17.9 89.1-50.3 121.6C601.1 516.1 558 534 512.2 534zM880 772H640c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h240c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8z'));
exports.UsergroupDeleteOutline = getIcon('usergroup-delete', outline, getNode(newViewBox, 'M888 784H664c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h224c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zM373.5 510.4c-.9-8.7-1.4-17.5-1.4-26.4 0-15.9 1.5-31.4 4.3-46.5.7-3.6-1.2-7.3-4.5-8.8-13.6-6.1-26.1-14.5-36.9-25.1a127.54 127.54 0 0 1-38.7-95.4c.9-32.1 13.8-62.6 36.3-85.6 24.7-25.3 57.9-39.1 93.2-38.7 31.9.3 62.7 12.6 86 34.4 7.9 7.4 14.7 15.6 20.4 24.4 2 3.1 5.9 4.4 9.3 3.2 17.6-6.1 36.2-10.4 55.3-12.4 5.6-.6 8.8-6.6 6.3-11.6-32.5-64.3-98.9-108.7-175.7-109.9-110.9-1.7-203.3 89.2-203.3 199.9 0 62.8 28.9 118.8 74.2 155.5-31.8 14.7-61.1 35-86.5 60.4-54.8 54.7-85.8 126.9-87.8 204a8 8 0 0 0 8 8.2h56.1c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5 29.4-29.4 65.4-49.8 104.7-59.7 3.9-1 6.5-4.7 6-8.7zM824 484c0-109.4-87.9-198.3-196.9-200C516.3 282.3 424 373.2 424 484c0 62.8 29 118.8 74.2 155.5a300.95 300.95 0 0 0-86.4 60.4C357 754.6 326 826.8 324 903.8a8 8 0 0 0 8 8.2h56c4.3 0 7.9-3.4 8-7.7 1.9-58 25.4-112.3 66.7-153.5C505.8 707.7 563 684 624 684c110.4 0 200-89.5 200-200zm-109.5 90.5C690.3 598.7 658.2 612 624 612s-66.3-13.3-90.5-37.5a127.26 127.26 0 0 1-37.5-91.8c.3-32.8 13.4-64.5 36.3-88 24-24.6 56.1-38.3 90.4-38.7 33.9-.3 66.8 12.9 91 36.6 24.8 24.3 38.4 56.8 38.4 91.4-.1 34.2-13.4 66.3-37.6 90.5z'));
exports.VerticalAlignBottomOutline = getIcon('vertical-align-bottom', outline, getNode(newViewBox, 'M859.9 780H164.1c-4.5 0-8.1 3.6-8.1 8v60c0 4.4 3.6 8 8.1 8h695.8c4.5 0 8.1-3.6 8.1-8v-60c0-4.4-3.6-8-8.1-8zM505.7 669a8 8 0 0 0 12.6 0l112-141.7c4.1-5.2.4-12.9-6.3-12.9h-74.1V176c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v338.3H400c-6.7 0-10.4 7.7-6.3 12.9l112 141.8z'));
exports.VerticalAlignMiddleOutline = getIcon('vertical-align-middle', outline, getNode(newViewBox, 'M859.9 474H164.1c-4.5 0-8.1 3.6-8.1 8v60c0 4.4 3.6 8 8.1 8h695.8c4.5 0 8.1-3.6 8.1-8v-60c0-4.4-3.6-8-8.1-8zm-353.6-74.7c2.9 3.7 8.5 3.7 11.3 0l100.8-127.5c3.7-4.7.4-11.7-5.7-11.7H550V104c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v156h-62.8c-6 0-9.4 7-5.7 11.7l100.8 127.6zm11.4 225.4a7.14 7.14 0 0 0-11.3 0L405.6 752.3a7.23 7.23 0 0 0 5.7 11.7H474v156c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V764h62.8c6 0 9.4-7 5.7-11.7L517.7 624.7z'));
exports.VerticalAlignTopOutline = getIcon('vertical-align-top', outline, getNode(newViewBox, 'M859.9 168H164.1c-4.5 0-8.1 3.6-8.1 8v60c0 4.4 3.6 8 8.1 8h695.8c4.5 0 8.1-3.6 8.1-8v-60c0-4.4-3.6-8-8.1-8zM518.3 355a8 8 0 0 0-12.6 0l-112 141.7a7.98 7.98 0 0 0 6.3 12.9h73.9V848c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V509.7H624c6.7 0 10.4-7.7 6.3-12.9L518.3 355z'));
exports.VerticalRightOutline = getIcon('vertical-right', outline, getNode(newViewBox, 'M326 164h-64c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V172c0-4.4-3.6-8-8-8zm444 72.4V164c0-6.8-7.9-10.5-13.1-6.1L335 512l421.9 354.1c5.2 4.4 13.1.7 13.1-6.1v-72.4c0-9.4-4.2-18.4-11.4-24.5L459.4 512l299.2-251.1c7.2-6.1 11.4-15.1 11.4-24.5z'));
exports.VerticalLeftOutline = getIcon('vertical-left', outline, getNode(newViewBox, 'M762 164h-64c-4.4 0-8 3.6-8 8v688c0 4.4 3.6 8 8 8h64c4.4 0 8-3.6 8-8V172c0-4.4-3.6-8-8-8zm-508 0v72.4c0 9.5 4.2 18.4 11.4 24.5L564.6 512 265.4 763.1c-7.2 6.1-11.4 15-11.4 24.5V860c0 6.8 7.9 10.5 13.1 6.1L689 512 267.1 157.9A7.95 7.95 0 0 0 254 164z'));
exports.WifiOutline = getIcon('wifi', outline, getNode(newViewBox, 'M723 620.5C666.8 571.6 593.4 542 513 542s-153.8 29.6-210.1 78.6a8.1 8.1 0 0 0-.8 11.2l36 42.9c2.9 3.4 8 3.8 11.4.9C393.1 637.2 450.3 614 513 614s119.9 23.2 163.5 61.5c3.4 2.9 8.5 2.5 11.4-.9l36-42.9c2.8-3.3 2.4-8.3-.9-11.2zm117.4-140.1C751.7 406.5 637.6 362 513 362s-238.7 44.5-327.5 118.4a8.05 8.05 0 0 0-1 11.3l36 42.9c2.8 3.4 7.9 3.8 11.2 1C308 472.2 406.1 434 513 434s205 38.2 281.2 101.6c3.4 2.8 8.4 2.4 11.2-1l36-42.9c2.8-3.4 2.4-8.5-1-11.3zm116.7-139C835.7 241.8 680.3 182 511 182c-168.2 0-322.6 59-443.7 157.4a8 8 0 0 0-1.1 11.4l36 42.9c2.8 3.3 7.8 3.8 11.1 1.1C222 306.7 360.3 254 511 254c151.8 0 291 53.5 400 142.7 3.4 2.8 8.4 2.3 11.2-1.1l36-42.9c2.9-3.4 2.4-8.5-1.1-11.3zM448 778a64 64 0 1 0 128 0 64 64 0 1 0-128 0z'));
exports.ZhihuOutline = getIcon('zhihu', outline, getNode(newViewBox, 'M564.7 230.1V803h60l25.2 71.4L756.3 803h131.5V230.1H564.7zm247.7 497h-59.9l-75.1 50.4-17.8-50.4h-18V308.3h170.7v418.8zM526.1 486.9H393.3c2.1-44.9 4.3-104.3 6.6-172.9h130.9l-.1-8.1c0-.6-.2-14.7-2.3-29.1-2.1-15-6.6-34.9-21-34.9H287.8c4.4-20.6 15.7-69.7 29.4-93.8l6.4-11.2-12.9-.7c-.8 0-19.6-.9-41.4 10.6-35.7 19-51.7 56.4-58.7 84.4-18.4 73.1-44.6 123.9-55.7 145.6-3.3 6.4-5.3 10.2-6.2 12.8-1.8 4.9-.8 9.8 2.8 13 10.5 9.5 38.2-2.9 38.5-3 .6-.3 1.3-.6 2.2-1 13.9-6.3 55.1-25 69.8-84.5h56.7c.7 32.2 3.1 138.4 2.9 172.9h-141l-2.1 1.5c-23.1 16.9-30.5 63.2-30.8 65.2l-1.4 9.2h167c-12.3 78.3-26.5 113.4-34 127.4-3.7 7-7.3 14-10.7 20.8-21.3 42.2-43.4 85.8-126.3 153.6-3.6 2.8-7 8-4.8 13.7 2.4 6.3 9.3 9.1 24.6 9.1 5.4 0 11.8-.3 19.4-1 49.9-4.4 100.8-18 135.1-87.6 17-35.1 31.7-71.7 43.9-108.9L497 850l5-12c.8-1.9 19-46.3 5.1-95.9l-.5-1.8-108.1-123-22 16.6c6.4-26.1 10.6-49.9 12.5-71.1h158.7v-8c0-40.1-18.5-63.9-19.2-64.9l-2.4-3z'));
exports.WeiboOutline = getIcon('weibo', outline, getNode(newViewBox, 'M457.3 543c-68.1-17.7-145 16.2-174.6 76.2-30.1 61.2-1 129.1 67.8 151.3 71.2 23 155.2-12.2 184.4-78.3 28.7-64.6-7.2-131-77.6-149.2zm-52 156.2c-13.8 22.1-43.5 31.7-65.8 21.6-22-10-28.5-35.7-14.6-57.2 13.7-21.4 42.3-31 64.4-21.7 22.4 9.5 29.6 35 16 57.3zm45.5-58.5c-5 8.6-16.1 12.7-24.7 9.1-8.5-3.5-11.2-13.1-6.4-21.5 5-8.4 15.6-12.4 24.1-9.1 8.7 3.2 11.8 12.9 7 21.5zm334.5-197.2c15 4.8 31-3.4 35.9-18.3 11.8-36.6 4.4-78.4-23.2-109a111.39 111.39 0 0 0-106-34.3 28.45 28.45 0 0 0-21.9 33.8 28.39 28.39 0 0 0 33.8 21.8c18.4-3.9 38.3 1.8 51.9 16.7a54.2 54.2 0 0 1 11.3 53.3 28.45 28.45 0 0 0 18.2 36zm99.8-206c-56.7-62.9-140.4-86.9-217.7-70.5a32.98 32.98 0 0 0-25.4 39.3 33.12 33.12 0 0 0 39.3 25.5c55-11.7 114.4 5.4 154.8 50.1 40.3 44.7 51.2 105.7 34 159.1-5.6 17.4 3.9 36 21.3 41.7 17.4 5.6 36-3.9 41.6-21.2v-.1c24.1-75.4 8.9-161.1-47.9-223.9zM729 499c-12.2-3.6-20.5-6.1-14.1-22.1 13.8-34.7 15.2-64.7.3-86-28-40.1-104.8-37.9-192.8-1.1 0 0-27.6 12.1-20.6-9.8 13.5-43.5 11.5-79.9-9.6-101-47.7-47.8-174.6 1.8-283.5 110.6C127.3 471.1 80 557.5 80 632.2 80 775.1 263.2 862 442.5 862c235 0 391.3-136.5 391.3-245 0-65.5-55.2-102.6-104.8-118zM443 810.8c-143 14.1-266.5-50.5-275.8-144.5-9.3-93.9 99.2-181.5 242.2-195.6 143-14.2 266.5 50.5 275.8 144.4C694.4 709 586 796.6 443 810.8z'));
exports.WomanOutline = getIcon('woman', outline, getNode(newViewBox, 'M712.8 548.8c53.6-53.6 83.2-125 83.2-200.8 0-75.9-29.5-147.2-83.2-200.8C659.2 93.6 587.8 64 512 64s-147.2 29.5-200.8 83.2C257.6 200.9 228 272.1 228 348c0 63.8 20.9 124.4 59.4 173.9 7.3 9.4 15.2 18.3 23.7 26.9 8.5 8.5 17.5 16.4 26.8 23.7 39.6 30.8 86.3 50.4 136.1 57V736H360c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h114v140c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V812h114c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8H550V629.5c61.5-8.2 118.2-36.1 162.8-80.7zM512 556c-55.6 0-107.7-21.6-147.1-60.9C325.6 455.8 304 403.6 304 348s21.6-107.7 60.9-147.1C404.2 161.5 456.4 140 512 140s107.7 21.6 147.1 60.9C698.4 240.2 720 292.4 720 348s-21.6 107.7-60.9 147.1C619.7 534.4 567.6 556 512 556z'));
exports.ZoomInOutline = getIcon('zoom-in', outline, getNode(newViewBox, 'M637 443H519V309c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8v134H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h118v134c0 4.4 3.6 8 8 8h60c4.4 0 8-3.6 8-8V519h118c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z'));
exports.AccountBookTwoTone = getIcon('account-book', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M712 304c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H384v48c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H184v584h656V256H712v48zm-65.6 121.8l-89.3 164.1h49.1c4.4 0 8 3.6 8 8v21.3c0 4.4-3.6 8-8 8h-65.4v33.7h65.4c4.4 0 8 3.6 8 8v21.3c0 4.4-3.6 8-8 8h-65.4V752c0 4.4-3.6 8-8 8h-41.3c-4.4 0-8-3.6-8-8v-53.8h-65.1c-4.4 0-8-3.6-8-8v-21.3c0-4.4 3.6-8 8-8h65.1v-33.7h-65.1c-4.4 0-8-3.6-8-8v-21.3c0-4.4 3.6-8 8-8H467l-89.3-164c-2.1-3.9-.7-8.8 3.2-10.9 1.1-.7 2.5-1 3.8-1h46a8 8 0 0 1 7.1 4.4l73.4 145.4h2.8l73.4-145.4c1.3-2.7 4.1-4.4 7.1-4.4h45c4.5 0 8 3.6 7.9 8 0 1.3-.4 2.6-1 3.8z'
    ], [
        primaryColor,
        'M639.5 414h-45c-3 0-5.8 1.7-7.1 4.4L514 563.8h-2.8l-73.4-145.4a8 8 0 0 0-7.1-4.4h-46c-1.3 0-2.7.3-3.8 1-3.9 2.1-5.3 7-3.2 10.9l89.3 164h-48.6c-4.4 0-8 3.6-8 8v21.3c0 4.4 3.6 8 8 8h65.1v33.7h-65.1c-4.4 0-8 3.6-8 8v21.3c0 4.4 3.6 8 8 8h65.1V752c0 4.4 3.6 8 8 8h41.3c4.4 0 8-3.6 8-8v-53.8h65.4c4.4 0 8-3.6 8-8v-21.3c0-4.4-3.6-8-8-8h-65.4v-33.7h65.4c4.4 0 8-3.6 8-8v-21.3c0-4.4-3.6-8-8-8h-49.1l89.3-164.1c.6-1.2 1-2.5 1-3.8.1-4.4-3.4-8-7.9-8z'
    ], [
        primaryColor,
        'M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v584z'
    ]);
});
exports.ZoomOutOutline = getIcon('zoom-out', outline, getNode(newViewBox, 'M637 443H325c-4.4 0-8 3.6-8 8v60c0 4.4 3.6 8 8 8h312c4.4 0 8-3.6 8-8v-60c0-4.4-3.6-8-8-8zm284 424L775 721c122.1-148.9 113.6-369.5-26-509-148-148.1-388.4-148.1-537 0-148.1 148.6-148.1 389 0 537 139.5 139.6 360.1 148.1 509 26l146 146c3.2 2.8 8.3 2.8 11 0l43-43c2.8-2.7 2.8-7.8 0-11zM696 696c-118.8 118.7-311.2 118.7-430 0-118.7-118.8-118.7-311.2 0-430 118.8-118.7 311.2-118.7 430 0 118.7 118.8 118.7 311.2 0 430z'));
exports.AlertTwoTone = getIcon('alert', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M340 585c0-5.5 4.5-10 10-10h44c5.5 0 10 4.5 10 10v171h355V563c0-136.4-110.6-247-247-247S265 426.6 265 563v193h75V585z'
    ], [
        primaryColor,
        'M216.9 310.5l39.6-39.6c3.1-3.1 3.1-8.2 0-11.3l-67.9-67.9a8.03 8.03 0 0 0-11.3 0l-39.6 39.6a8.03 8.03 0 0 0 0 11.3l67.9 67.9c3.1 3.1 8.1 3.1 11.3 0zm669.6-79.2l-39.6-39.6a8.03 8.03 0 0 0-11.3 0l-67.9 67.9a8.03 8.03 0 0 0 0 11.3l39.6 39.6c3.1 3.1 8.2 3.1 11.3 0l67.9-67.9c3.1-3.2 3.1-8.2 0-11.3zM484 180h56c4.4 0 8-3.6 8-8V76c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v96c0 4.4 3.6 8 8 8zm348 712H192c-17.7 0-32 14.3-32 32v24c0 4.4 3.6 8 8 8h688c4.4 0 8-3.6 8-8v-24c0-17.7-14.3-32-32-32zm-639-96c0 17.7 14.3 32 32 32h574c17.7 0 32-14.3 32-32V563c0-176.2-142.8-319-319-319S193 386.8 193 563v233zm72-233c0-136.4 110.6-247 247-247s247 110.6 247 247v193H404V585c0-5.5-4.5-10-10-10h-44c-5.5 0-10 4.5-10 10v171h-75V563z'
    ]);
});
exports.ApiTwoTone = getIcon('api', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M148.2 674.6zm106.7-92.3c-25 25-38.7 58.1-38.7 93.4s13.8 68.5 38.7 93.4c25 25 58.1 38.7 93.4 38.7 35.3 0 68.5-13.8 93.4-38.7l59.4-59.4-186.8-186.8-59.4 59.4zm420.8-366.1c-35.3 0-68.5 13.8-93.4 38.7l-59.4 59.4 186.8 186.8 59.4-59.4c24.9-25 38.7-58.1 38.7-93.4s-13.8-68.5-38.7-93.4c-25-25-58.1-38.7-93.4-38.7z'
    ], [
        primaryColor,
        'M578.9 546.7a8.03 8.03 0 0 0-11.3 0L501 613.3 410.7 523l66.7-66.7c3.1-3.1 3.1-8.2 0-11.3L441 408.6a8.03 8.03 0 0 0-11.3 0L363 475.3l-43-43a7.85 7.85 0 0 0-5.7-2.3c-2 0-4.1.8-5.7 2.3L206.8 534.2a199.45 199.45 0 0 0-58.6 140.4c-.2 39.5 11.2 79.1 34.3 113.1l-76.1 76.1a8.03 8.03 0 0 0 0 11.3l42.4 42.4c1.6 1.6 3.6 2.3 5.7 2.3s4.1-.8 5.7-2.3l76.1-76.1c33.7 22.9 72.9 34.3 112.1 34.3 51.2 0 102.4-19.5 141.5-58.6l101.9-101.9c3.1-3.1 3.1-8.2 0-11.3l-43-43 66.7-66.7c3.1-3.1 3.1-8.2 0-11.3l-36.6-36.2zM441.7 769.1a131.32 131.32 0 0 1-93.4 38.7c-35.3 0-68.4-13.7-93.4-38.7-24.9-24.9-38.7-58.1-38.7-93.4s13.7-68.4 38.7-93.4l59.4-59.4 186.8 186.8-59.4 59.4zm476-620.3l-42.4-42.4c-1.6-1.6-3.6-2.3-5.7-2.3s-4.1.8-5.7 2.3l-76.1 76.1a199.27 199.27 0 0 0-112.1-34.3c-51.2 0-102.4 19.5-141.5 58.6L432.3 308.7a8.03 8.03 0 0 0 0 11.3L704 591.7c1.6 1.6 3.6 2.3 5.7 2.3 2 0 4.1-.8 5.7-2.3l101.9-101.9c68.9-69 77-175.7 24.3-253.5l76.1-76.1c3.1-3.2 3.1-8.3 0-11.4zM769.1 441.7l-59.4 59.4-186.8-186.8 59.4-59.4c24.9-24.9 58.1-38.7 93.4-38.7s68.4 13.7 93.4 38.7c24.9 24.9 38.7 58.1 38.7 93.4s-13.8 68.4-38.7 93.4z'
    ]);
});
exports.AppstoreTwoTone = getIcon('appstore', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M864 144H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H612V212h200v200zM464 544H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H212V612h200v200zm52-668H160c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V160c0-8.8-7.2-16-16-16zm-52 268H212V212h200v200zm452 132H560c-8.8 0-16 7.2-16 16v304c0 8.8 7.2 16 16 16h304c8.8 0 16-7.2 16-16V560c0-8.8-7.2-16-16-16zm-52 268H612V612h200v200z'
    ], [
        secondaryColor,
        'M212 212h200v200H212zm400 0h200v200H612zM212 612h200v200H212zm400 0h200v200H612z'
    ]);
});
exports.BankTwoTone = getIcon('bank', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M240.9 393.9h542.2L512 196.7z'], [
        primaryColor,
        'M894 462c30.9 0 43.8-39.7 18.7-58L530.8 126.2a31.81 31.81 0 0 0-37.6 0L111.3 404c-25.1 18.2-12.2 58 18.8 58H192v374h-72c-4.4 0-8 3.6-8 8v52c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-52c0-4.4-3.6-8-8-8h-72V462h62zM381 836H264V462h117v374zm189 0H453V462h117v374zm190 0H642V462h118v374zM240.9 393.9L512 196.7l271.1 197.2H240.9z'
    ]);
});
exports.AudioTwoTone = getIcon('audio', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M512 552c54.3 0 98-43.2 98-96V232c0-52.8-43.7-96-98-96s-98 43.2-98 96v224c0 52.8 43.7 96 98 96z'
    ], [
        primaryColor,
        'M842 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 140.3-113.7 254-254 254S258 594.3 258 454c0-4.4-3.6-8-8-8h-60c-4.4 0-8 3.6-8 8 0 168.7 126.6 307.9 290 327.6V884H326.7c-13.7 0-24.7 14.3-24.7 32v36c0 4.4 2.8 8 6.2 8h407.6c3.4 0 6.2-3.6 6.2-8v-36c0-17.7-11-32-24.7-32H548V782.1c165.3-18 294-158 294-328.1z'
    ], [
        primaryColor,
        'M512 624c93.9 0 170-75.2 170-168V232c0-92.8-76.1-168-170-168s-170 75.2-170 168v224c0 92.8 76.1 168 170 168zm-98-392c0-52.8 43.7-96 98-96s98 43.2 98 96v224c0 52.8-43.7 96-98 96s-98-43.2-98-96V232z'
    ]);
});
exports.BellTwoTone = getIcon('bell', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M512 220c-55.6 0-107.8 21.6-147.1 60.9S304 372.4 304 428v340h416V428c0-55.6-21.6-107.8-60.9-147.1S567.6 220 512 220zm280 208c0-141.1-104.3-257.8-240-277.2v.1c135.7 19.4 240 136 240 277.1zM472 150.9v-.1C336.3 170.2 232 286.9 232 428c0-141.1 104.3-257.7 240-277.1z'
    ], [
        primaryColor,
        'M816 768h-24V428c0-141.1-104.3-257.7-240-277.1V112c0-22.1-17.9-40-40-40s-40 17.9-40 40v38.9c-135.7 19.4-240 136-240 277.1v340h-24c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h216c0 61.8 50.2 112 112 112s112-50.2 112-112h216c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zM512 888c-26.5 0-48-21.5-48-48h96c0 26.5-21.5 48-48 48zm208-120H304V428c0-55.6 21.6-107.8 60.9-147.1S456.4 220 512 220c55.6 0 107.8 21.6 147.1 60.9S720 372.4 720 428v340z'
    ]);
});
exports.BookTwoTone = getIcon('book', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-260 72h96v209.9L621.5 312 572 347.4V136zM232 888V136h280v296.9c0 3.3 1 6.6 3 9.3a15.9 15.9 0 0 0 22.3 3.7l83.8-59.9 81.4 59.4c2.7 2 6 3.1 9.4 3.1 8.8 0 16-7.2 16-16V136h64v752H232z'
    ], [secondaryColor, 'M668 345.9V136h-96v211.4l49.5-35.4z'], [
        secondaryColor,
        'M727.9 136v296.5c0 8.8-7.2 16-16 16-3.4 0-6.7-1.1-9.4-3.1L621.1 386l-83.8 59.9a15.9 15.9 0 0 1-22.3-3.7c-2-2.7-3-6-3-9.3V136H232v752h559.9V136h-64z'
    ]);
});
exports.BoxPlotTwoTone = getIcon('box-plot', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M296 368h88v288h-88zm152 0h280v288H448z'], [
        primaryColor,
        'M952 224h-52c-4.4 0-8 3.6-8 8v248h-92V304c0-4.4-3.6-8-8-8H232c-4.4 0-8 3.6-8 8v176h-92V232c0-4.4-3.6-8-8-8H72c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V548h92v172c0 4.4 3.6 8 8 8h560c4.4 0 8-3.6 8-8V548h92v244c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zM384 656h-88V368h88v288zm344 0H448V368h280v288z'
    ]);
});
exports.BugTwoTone = getIcon('bug', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M308 412v268c0 36.78 9.68 71.96 27.8 102.9a205.39 205.39 0 0 0 73.3 73.3A202.68 202.68 0 0 0 512 884c36.78 0 71.96-9.68 102.9-27.8a205.39 205.39 0 0 0 73.3-73.3A202.68 202.68 0 0 0 716 680V412H308zm484 172v96c0 6.5-.22 12.95-.66 19.35C859.94 728.64 908 796.7 908 876a8 8 0 0 1-8 8h-56a8 8 0 0 1-8-8c0-44.24-23.94-82.89-59.57-103.7a278.63 278.63 0 0 1-22.66 49.02 281.39 281.39 0 0 1-100.45 100.45C611.84 946.07 563.55 960 512 960s-99.84-13.93-141.32-38.23a281.39 281.39 0 0 1-100.45-100.45 278.63 278.63 0 0 1-22.66-49.02A119.95 119.95 0 0 0 188 876a8 8 0 0 1-8 8h-56a8 8 0 0 1-8-8c0-79.3 48.07-147.36 116.66-176.65A284.12 284.12 0 0 1 232 680v-96H84a8 8 0 0 1-8-8v-56a8 8 0 0 1 8-8h148V412c-76.77 0-139-62.23-139-139a8 8 0 0 1 8-8h60a8 8 0 0 1 8 8 63 63 0 0 0 63 63h560a63 63 0 0 0 63-63 8 8 0 0 1 8-8h60a8 8 0 0 1 8 8c0 76.77-62.23 139-139 139v100h148a8 8 0 0 1 8 8v56a8 8 0 0 1-8 8H792zM368 272a8 8 0 0 1-8 8h-56a8 8 0 0 1-8-8c0-40.04 8.78-76.75 25.9-108.07a184.57 184.57 0 0 1 74.03-74.03C427.25 72.78 463.96 64 504 64h16c40.04 0 76.75 8.78 108.07 25.9a184.57 184.57 0 0 1 74.03 74.03C719.22 195.25 728 231.96 728 272a8 8 0 0 1-8 8h-56a8 8 0 0 1-8-8c0-28.33-5.94-53.15-17.08-73.53a112.56 112.56 0 0 0-45.39-45.4C573.15 141.95 548.33 136 520 136h-16c-28.33 0-53.15 5.94-73.53 17.08a112.56 112.56 0 0 0-45.4 45.39C373.95 218.85 368 243.67 368 272z'
    ], [
        secondaryColor,
        'M308 412v268c0 36.78 9.68 71.96 27.8 102.9a205.39 205.39 0 0 0 73.3 73.3A202.68 202.68 0 0 0 512 884c36.78 0 71.96-9.68 102.9-27.8a205.39 205.39 0 0 0 73.3-73.3A202.68 202.68 0 0 0 716 680V412H308z'
    ]);
});
exports.BulbTwoTone = getIcon('bulb', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M512 136c-141.4 0-256 114.6-256 256 0 92.5 49.4 176.3 128.1 221.8l35.9 20.8V752h184V634.6l35.9-20.8C718.6 568.3 768 484.5 768 392c0-141.4-114.6-256-256-256z'
    ], [
        primaryColor,
        'M632 888H392c-4.4 0-8 3.6-8 8v32c0 17.7 14.3 32 32 32h192c17.7 0 32-14.3 32-32v-32c0-4.4-3.6-8-8-8zM512 64c-181.1 0-328 146.9-328 328 0 121.4 66 227.4 164 284.1V792c0 17.7 14.3 32 32 32h264c17.7 0 32-14.3 32-32V676.1c98-56.7 164-162.7 164-284.1 0-181.1-146.9-328-328-328zm127.9 549.8L604 634.6V752H420V634.6l-35.9-20.8C305.4 568.3 256 484.5 256 392c0-141.4 114.6-256 256-256s256 114.6 256 256c0 92.5-49.4 176.3-128.1 221.8z'
    ]);
});
exports.CalculatorTwoTone = getIcon('calculator', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
    ], [
        secondaryColor,
        'M184 840h656V184H184v656zm256.2-75h-50.8c-2.2 0-4.5-1.1-5.9-2.9L348 718.6l-35.5 43.5a7.38 7.38 0 0 1-5.9 2.9h-50.8c-6.6 0-10.2-7.9-5.8-13.1l62.7-76.8-61.2-74.9c-4.3-5.2-.7-13.1 5.9-13.1h50.9c2.2 0 4.5 1.1 5.9 2.9l34 41.6 34-41.6c1.5-1.9 3.6-2.9 5.9-2.9h50.8c6.6 0 10.2 7.9 5.9 13.1L383.5 675l62.7 76.8c4.2 5.3.6 13.2-6 13.2zM576 335c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48zm0 265c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48zm0 104c0-2.2 1.4-4 3.2-4h193.5c1.9 0 3.3 1.8 3.3 4v48c0 2.2-1.4 4-3.2 4H579.2c-1.8 0-3.2-1.8-3.2-4v-48zM248 335c0-2.2 1.4-4 3.2-4H320v-68.8c0-1.8 1.8-3.2 4-3.2h48c2.2 0 4 1.4 4 3.2V331h68.7c1.9 0 3.3 1.8 3.3 4v48c0 2.2-1.4 4-3.2 4H376v68.7c0 1.9-1.8 3.3-4 3.3h-48c-2.2 0-4-1.4-4-3.2V387h-68.8c-1.8 0-3.2-1.8-3.2-4v-48z'
    ], [
        primaryColor,
        'M383.5 675l61.3-74.8c4.3-5.2.7-13.1-5.9-13.1h-50.8c-2.3 0-4.4 1-5.9 2.9l-34 41.6-34-41.6a7.69 7.69 0 0 0-5.9-2.9h-50.9c-6.6 0-10.2 7.9-5.9 13.1l61.2 74.9-62.7 76.8c-4.4 5.2-.8 13.1 5.8 13.1h50.8c2.3 0 4.4-1 5.9-2.9l35.5-43.5 35.5 43.5c1.4 1.8 3.7 2.9 5.9 2.9h50.8c6.6 0 10.2-7.9 6-13.2L383.5 675zM251.2 387H320v68.8c0 1.8 1.8 3.2 4 3.2h48c2.2 0 4-1.4 4-3.3V387h68.8c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H376v-68.8c0-1.8-1.8-3.2-4-3.2h-48c-2.2 0-4 1.4-4 3.2V331h-68.8c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm328 369h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm0-104h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4zm0-265h193.6c1.8 0 3.2-1.8 3.2-4v-48c0-2.2-1.4-4-3.3-4H579.2c-1.8 0-3.2 1.8-3.2 4v48c0 2.2 1.4 4 3.2 4z'
    ]);
});
exports.BuildTwoTone = getIcon('build', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M144 546h200v200H144zm268-268h200v200H412z'], [
        primaryColor,
        'M916 210H376c-17.7 0-32 14.3-32 32v236H108c-17.7 0-32 14.3-32 32v272c0 17.7 14.3 32 32 32h540c17.7 0 32-14.3 32-32V546h236c17.7 0 32-14.3 32-32V242c0-17.7-14.3-32-32-32zM344 746H144V546h200v200zm268 0H412V546h200v200zm0-268H412V278h200v200zm268 0H680V278h200v200z'
    ]);
});
exports.CalendarTwoTone = getIcon('calendar', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M712 304c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H384v48c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H184v136h656V256H712v48z'
    ], [
        primaryColor,
        'M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zm0-448H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136z'
    ]);
});
exports.CameraTwoTone = getIcon('camera', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M864 320H677.2l-17.1-47.8-22.9-64.2H386.7l-22.9 64.2-17.1 47.8H160c-4.4 0-8 3.6-8 8v456c0 4.4 3.6 8 8 8h704c4.4 0 8-3.6 8-8V328c0-4.4-3.6-8-8-8zM512 704c-88.4 0-160-71.6-160-160s71.6-160 160-160 160 71.6 160 160-71.6 160-160 160z'
    ], [
        primaryColor,
        'M512 384c-88.4 0-160 71.6-160 160s71.6 160 160 160 160-71.6 160-160-71.6-160-160-160zm0 256c-53 0-96-43-96-96s43-96 96-96 96 43 96 96-43 96-96 96z'
    ], [
        primaryColor,
        'M864 248H728l-32.4-90.8a32.07 32.07 0 0 0-30.2-21.2H358.6c-13.5 0-25.6 8.5-30.1 21.2L296 248H160c-44.2 0-80 35.8-80 80v456c0 44.2 35.8 80 80 80h704c44.2 0 80-35.8 80-80V328c0-44.2-35.8-80-80-80zm8 536c0 4.4-3.6 8-8 8H160c-4.4 0-8-3.6-8-8V328c0-4.4 3.6-8 8-8h186.7l17.1-47.8 22.9-64.2h250.5l22.9 64.2 17.1 47.8H864c4.4 0 8 3.6 8 8v456z'
    ]);
});
exports.CarTwoTone = getIcon('car', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M199.6 474L184 517v237h656V517l-15.6-43H199.6zM264 621c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm388 75c0 4.4-3.6 8-8 8H380c-4.4 0-8-3.6-8-8v-84c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v36h168v-36c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v84zm108-75c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z'
    ], [primaryColor, 'M720 581a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'], [
        primaryColor,
        'M959 413.4L935.3 372a8 8 0 0 0-10.9-2.9l-50.7 29.6-78.3-216.2a63.9 63.9 0 0 0-60.9-44.4H301.2c-34.7 0-65.5 22.4-76.2 55.5l-74.6 205.2-50.8-29.6a8 8 0 0 0-10.9 2.9L65 413.4c-2.2 3.8-.9 8.6 2.9 10.8l60.4 35.2-14.5 40c-1.2 3.2-1.8 6.6-1.8 10v348.2c0 15.7 11.8 28.4 26.3 28.4h67.6c12.3 0 23-9.3 25.6-22.3l7.7-37.7h545.6l7.7 37.7c2.7 13 13.3 22.3 25.6 22.3h67.6c14.5 0 26.3-12.7 26.3-28.4V509.4c0-3.4-.6-6.8-1.8-10l-14.5-40 60.3-35.2a8 8 0 0 0 3-10.8zM292.7 218.1l.5-1.3.4-1.3c1.1-3.3 4.1-5.5 7.6-5.5h427.6l75.4 208H220l72.7-199.9zM840 754H184V517l15.6-43h624.8l15.6 43v237z'
    ], [
        primaryColor,
        'M224 581a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm420 23h-40c-4.4 0-8 3.6-8 8v36H428v-36c0-4.4-3.6-8-8-8h-40c-4.4 0-8 3.6-8 8v84c0 4.4 3.6 8 8 8h264c4.4 0 8-3.6 8-8v-84c0-4.4-3.6-8-8-8z'
    ]);
});
exports.CarryOutTwoTone = getIcon('carry-out', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v584z'
    ], [
        secondaryColor,
        'M712 304c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H384v48c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H184v584h656V256H712v48zm-17.5 128.8L481.9 725.5a16.1 16.1 0 0 1-26 0l-126.4-174c-3.8-5.3 0-12.7 6.5-12.7h55.2c5.2 0 10 2.5 13 6.6l64.7 89 150.9-207.8c3-4.1 7.9-6.6 13-6.6H688c6.5 0 10.3 7.4 6.5 12.8z'
    ], [
        primaryColor,
        'M688 420h-55.2c-5.1 0-10 2.5-13 6.6L468.9 634.4l-64.7-89c-3-4.1-7.8-6.6-13-6.6H336c-6.5 0-10.3 7.4-6.5 12.7l126.4 174a16.1 16.1 0 0 0 26 0l212.6-292.7c3.8-5.4 0-12.8-6.5-12.8z'
    ]);
});
exports.CheckCircleTwoTone = getIcon('check-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm193.4 225.7l-210.6 292a31.8 31.8 0 0 1-51.7 0L318.5 484.9c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.3 0 19.9 5 25.9 13.3l71.2 98.8 157.2-218c6-8.4 15.7-13.3 25.9-13.3H699c6.5 0 10.3 7.4 6.4 12.7z'
    ], [
        primaryColor,
        'M699 353h-46.9c-10.2 0-19.9 4.9-25.9 13.3L469 584.3l-71.2-98.8c-6-8.3-15.6-13.3-25.9-13.3H325c-6.5 0-10.3 7.4-6.5 12.7l124.6 172.8a31.8 31.8 0 0 0 51.7 0l210.6-292c3.9-5.3.1-12.7-6.4-12.7z'
    ]);
});
exports.CheckSquareTwoTone = getIcon('check-square', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
    ], [
        secondaryColor,
        'M184 840h656V184H184v656zm130-367.8h46.9c10.2 0 19.9 4.9 25.9 13.3l71.2 98.8 157.2-218c6-8.3 15.6-13.3 25.9-13.3H688c6.5 0 10.3 7.4 6.5 12.7l-210.6 292a31.8 31.8 0 0 1-51.7 0L307.5 484.9c-3.8-5.3 0-12.7 6.5-12.7z'
    ], [
        primaryColor,
        'M432.2 657.7a31.8 31.8 0 0 0 51.7 0l210.6-292c3.8-5.3 0-12.7-6.5-12.7h-46.9c-10.3 0-19.9 5-25.9 13.3L458 584.3l-71.2-98.8c-6-8.4-15.7-13.3-25.9-13.3H314c-6.5 0-10.3 7.4-6.5 12.7l124.7 172.8z'
    ]);
});
exports.ClockCircleTwoTone = getIcon('clock-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm176.5 509.7l-28.6 39a7.99 7.99 0 0 1-11.2 1.7L483.3 569.8a7.92 7.92 0 0 1-3.3-6.5V288c0-4.4 3.6-8 8-8h48.1c4.4 0 8 3.6 8 8v247.5l142.6 103.1c3.6 2.5 4.4 7.5 1.8 11.1z'
    ], [
        primaryColor,
        'M686.7 638.6L544.1 535.5V288c0-4.4-3.6-8-8-8H488c-4.4 0-8 3.6-8 8v275.3c0 2.6 1.2 5 3.3 6.5l165.4 120.6c3.6 2.6 8.6 1.9 11.2-1.7l28.6-39c2.6-3.6 1.8-8.6-1.8-11.1z'
    ]);
});
exports.CloseCircleTwoTone = getIcon('close-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm171.8 527.1c1.2 1.5 1.9 3.3 1.9 5.2 0 4.5-3.6 8-8 8l-66-.3-99.3-118.4-99.3 118.5-66.1.3c-4.4 0-8-3.6-8-8 0-1.9.7-3.7 1.9-5.2L471 512.3l-130.1-155a8.32 8.32 0 0 1-1.9-5.2c0-4.5 3.6-8 8-8l66.1.3 99.3 118.4 99.4-118.5 66-.3c4.4 0 8 3.6 8 8 0 1.9-.6 3.8-1.8 5.2l-130.1 155 129.9 154.9z'
    ], [
        primaryColor,
        'M685.8 352c0-4.4-3.6-8-8-8l-66 .3-99.4 118.5-99.3-118.4-66.1-.3c-4.4 0-8 3.5-8 8 0 1.9.7 3.7 1.9 5.2l130.1 155-130.1 154.9a8.32 8.32 0 0 0-1.9 5.2c0 4.4 3.6 8 8 8l66.1-.3 99.3-118.5L611.7 680l66 .3c4.4 0 8-3.5 8-8 0-1.9-.7-3.7-1.9-5.2L553.9 512.2l130.1-155c1.2-1.4 1.8-3.3 1.8-5.2z'
    ]);
});
exports.CloudTwoTone = getIcon('cloud', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M791.9 492l-37.8-10-13.8-36.5c-8.6-22.7-20.6-44.1-35.7-63.4a245.73 245.73 0 0 0-52.4-49.9c-41.1-28.9-89.5-44.2-140-44.2s-98.9 15.3-140 44.2a245.6 245.6 0 0 0-52.4 49.9 240.47 240.47 0 0 0-35.7 63.4l-13.9 36.6-37.9 9.9a125.7 125.7 0 0 0-66.1 43.7A123.1 123.1 0 0 0 140 612c0 33.1 12.9 64.3 36.3 87.7 23.4 23.4 54.5 36.3 87.6 36.3h496.2c33.1 0 64.2-12.9 87.6-36.3A123.3 123.3 0 0 0 884 612c0-56.2-37.8-105.5-92.1-120z'
    ], [
        primaryColor,
        'M811.4 418.7C765.6 297.9 648.9 212 512.2 212S258.8 297.8 213 418.6C127.3 441.1 64 519.1 64 612c0 110.5 89.5 200 199.9 200h496.2C870.5 812 960 722.5 960 612c0-92.7-63.1-170.7-148.6-193.3zm36.3 281a123.07 123.07 0 0 1-87.6 36.3H263.9c-33.1 0-64.2-12.9-87.6-36.3A123.3 123.3 0 0 1 140 612c0-28 9.1-54.3 26.2-76.3a125.7 125.7 0 0 1 66.1-43.7l37.9-9.9 13.9-36.6c8.6-22.8 20.6-44.1 35.7-63.4a245.6 245.6 0 0 1 52.4-49.9c41.1-28.9 89.5-44.2 140-44.2s98.9 15.3 140 44.2c19.9 14 37.5 30.8 52.4 49.9 15.1 19.3 27.1 40.7 35.7 63.4l13.8 36.5 37.8 10c54.3 14.5 92.1 63.8 92.1 120 0 33.1-12.9 64.3-36.3 87.7z'
    ]);
});
exports.CloseSquareTwoTone = getIcon('close-square', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
    ], [
        secondaryColor,
        'M184 840h656V184H184v656zm163.9-473.9A7.95 7.95 0 0 1 354 353h58.9c4.7 0 9.2 2.1 12.3 5.7L512 462.2l86.8-103.5c3-3.6 7.5-5.7 12.3-5.7H670c6.8 0 10.5 7.9 6.1 13.1L553.8 512l122.3 145.9c4.4 5.2.7 13.1-6.1 13.1h-58.9c-4.7 0-9.2-2.1-12.3-5.7L512 561.8l-86.8 103.5c-3 3.6-7.5 5.7-12.3 5.7H354c-6.8 0-10.5-7.9-6.1-13.1L470.2 512 347.9 366.1z'
    ], [
        primaryColor,
        'M354 671h58.9c4.8 0 9.3-2.1 12.3-5.7L512 561.8l86.8 103.5c3.1 3.6 7.6 5.7 12.3 5.7H670c6.8 0 10.5-7.9 6.1-13.1L553.8 512l122.3-145.9c4.4-5.2.7-13.1-6.1-13.1h-58.9c-4.8 0-9.3 2.1-12.3 5.7L512 462.2l-86.8-103.5c-3.1-3.6-7.6-5.7-12.3-5.7H354c-6.8 0-10.5 7.9-6.1 13.1L470.2 512 347.9 657.9A7.95 7.95 0 0 0 354 671z'
    ]);
});
exports.CodeTwoTone = getIcon('code', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
    ], [
        secondaryColor,
        'M184 840h656V184H184v656zm339.5-223h185c4.1 0 7.5 3.6 7.5 8v48c0 4.4-3.4 8-7.5 8h-185c-4.1 0-7.5-3.6-7.5-8v-48c0-4.4 3.4-8 7.5-8zM308 610.3c0-2.3 1.1-4.6 2.9-6.1L420.7 512l-109.8-92.2a7.63 7.63 0 0 1-2.9-6.1V351c0-6.8 7.9-10.5 13.1-6.1l192 160.9c3.9 3.2 3.9 9.1 0 12.3l-192 161c-5.2 4.4-13.1.7-13.1-6.1v-62.7z'
    ], [
        primaryColor,
        'M321.1 679.1l192-161c3.9-3.2 3.9-9.1 0-12.3l-192-160.9A7.95 7.95 0 0 0 308 351v62.7c0 2.4 1 4.6 2.9 6.1L420.7 512l-109.8 92.2a8.1 8.1 0 0 0-2.9 6.1V673c0 6.8 7.9 10.5 13.1 6.1zM516 673c0 4.4 3.4 8 7.5 8h185c4.1 0 7.5-3.6 7.5-8v-48c0-4.4-3.4-8-7.5-8h-185c-4.1 0-7.5 3.6-7.5 8v48z'
    ]);
});
exports.CompassTwoTone = getIcon('compass', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zM327.6 701.7c-2 .9-4.4 0-5.3-2.1-.4-1-.4-2.2 0-3.2L421 470.9 553.1 603l-225.5 98.7zm375.1-375.1L604 552.1 471.9 420l225.5-98.7c2-.9 4.4 0 5.3 2.1.4 1 .4 2.1 0 3.2z'
    ], [
        primaryColor,
        'M322.3 696.4c-.4 1-.4 2.2 0 3.2.9 2.1 3.3 3 5.3 2.1L553.1 603 421 470.9l-98.7 225.5zm375.1-375.1L471.9 420 604 552.1l98.7-225.5c.4-1.1.4-2.2 0-3.2-.9-2.1-3.3-3-5.3-2.1z'
    ], [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ]);
});
exports.ContactsTwoTone = getIcon('contacts', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M460.3 526a51.7 52 0 1 0 103.4 0 51.7 52 0 1 0-103.4 0z'
    ], [
        secondaryColor,
        'M768 352c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H548v56c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H328v56c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H136v496h752V296H768v56zM661 736h-43.8c-4.2 0-7.6-3.3-7.9-7.5-3.8-50.5-46-90.5-97.2-90.5s-93.4 39.9-97.2 90.5c-.3 4.2-3.7 7.5-7.9 7.5h-43.9a8 8 0 0 1-8-8.4c2.8-53.3 31.9-99.6 74.6-126.1-18.1-20-29.1-46.4-29.1-75.5 0-61.9 49.9-112 111.4-112s111.4 50.1 111.4 112c0 29.1-11 55.6-29.1 75.5 42.7 26.4 71.9 72.8 74.7 126.1a8 8 0 0 1-8 8.4z'
    ], [
        primaryColor,
        'M594.3 601.5a111.8 111.8 0 0 0 29.1-75.5c0-61.9-49.9-112-111.4-112s-111.4 50.1-111.4 112c0 29.1 11 55.5 29.1 75.5a158.09 158.09 0 0 0-74.6 126.1 8 8 0 0 0 8 8.4H407c4.2 0 7.6-3.3 7.9-7.5 3.8-50.6 46-90.5 97.2-90.5s93.4 40 97.2 90.5c.3 4.2 3.7 7.5 7.9 7.5H661a8 8 0 0 0 8-8.4c-2.8-53.3-32-99.7-74.7-126.1zM512 578c-28.5 0-51.7-23.3-51.7-52s23.2-52 51.7-52 51.7 23.3 51.7 52-23.2 52-51.7 52z'
    ], [
        primaryColor,
        'M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zm-40 568H136V296h120v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h120v496z'
    ]);
});
exports.ContainerTwoTone = getIcon('container', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M635 771.7c-34.5 28.6-78.2 44.3-123 44.3s-88.5-15.8-123-44.3a194.02 194.02 0 0 1-59.1-84.7H232v201h560V687h-97.9c-11.6 32.8-32 62.3-59.1 84.7z'
    ], [
        primaryColor,
        'M320 501h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z'
    ], [
        primaryColor,
        'M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V687h97.9c11.6 32.8 32 62.3 59.1 84.7 34.5 28.5 78.2 44.3 123 44.3s88.5-15.7 123-44.3c27.1-22.4 47.5-51.9 59.1-84.7H792v201zm0-264H643.6l-5.2 24.7C626.4 708.5 573.2 752 512 752s-114.4-43.5-126.5-103.3l-5.2-24.7H232V136h560v488z'
    ], [
        primaryColor,
        'M320 341h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z'
    ]);
});
exports.ControlTwoTone = getIcon('control', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
    ], [
        secondaryColor,
        'M616 440a36 36 0 1 0 72 0 36 36 0 1 0-72 0zM340.4 601.5l1.5 2.4c0 .1.1.1.1.2l.9 1.2c.1.1.2.2.2.3 1 1.3 2 2.5 3.2 3.6l.2.2c.4.4.8.8 1.2 1.1.8.8 1.7 1.5 2.6 2.1h.1l1.2.9c.1.1.3.2.4.3 1.2.8 2.5 1.6 3.9 2.2.2.1.5.2.7.4.4.2.7.3 1.1.5.3.1.7.3 1 .4.5.2 1 .4 1.5.5.4.1.9.3 1.3.4l.9.3 1.4.3c.2.1.5.1.7.2.7.1 1.4.3 2.1.4.2 0 .4 0 .6.1.6.1 1.1.1 1.7.2.2 0 .4 0 .7.1.8 0 1.5.1 2.3.1s1.5 0 2.3-.1c.2 0 .4 0 .7-.1.6 0 1.2-.1 1.7-.2.2 0 .4 0 .6-.1.7-.1 1.4-.2 2.1-.4.2-.1.5-.1.7-.2l1.4-.3.9-.3c.4-.1.9-.3 1.3-.4.5-.2 1-.4 1.5-.5.3-.1.7-.3 1-.4.4-.2.7-.3 1.1-.5.2-.1.5-.2.7-.4 1.3-.7 2.6-1.4 3.9-2.2.1-.1.3-.2.4-.3l1.2-.9h.1c.9-.7 1.8-1.4 2.6-2.1.4-.4.8-.7 1.2-1.1l.2-.2c1.1-1.1 2.2-2.4 3.2-3.6.1-.1.2-.2.2-.3l.9-1.2c0-.1.1-.1.1-.2l1.5-2.4c.1-.2.2-.3.3-.5 2.7-5.1 4.3-10.9 4.3-17s-1.6-12-4.3-17c-.1-.2-.2-.4-.3-.5l-1.5-2.4c0-.1-.1-.1-.1-.2l-.9-1.2c-.1-.1-.2-.2-.2-.3-1-1.3-2-2.5-3.2-3.6l-.2-.2c-.4-.4-.8-.8-1.2-1.1-.8-.8-1.7-1.5-2.6-2.1h-.1l-1.2-.9c-.1-.1-.3-.2-.4-.3-1.2-.8-2.5-1.6-3.9-2.2-.2-.1-.5-.2-.7-.4-.4-.2-.7-.3-1.1-.5-.3-.1-.7-.3-1-.4-.5-.2-1-.4-1.5-.5-.4-.1-.9-.3-1.3-.4l-.9-.3-1.4-.3c-.2-.1-.5-.1-.7-.2-.7-.1-1.4-.3-2.1-.4-.2 0-.4 0-.6-.1-.6-.1-1.1-.1-1.7-.2-.2 0-.4 0-.7-.1-.8 0-1.5-.1-2.3-.1s-1.5 0-2.3.1c-.2 0-.4 0-.7.1-.6 0-1.2.1-1.7.2-.2 0-.4 0-.6.1-.7.1-1.4.2-2.1.4-.2.1-.5.1-.7.2l-1.4.3-.9.3c-.4.1-.9.3-1.3.4-.5.2-1 .4-1.5.5-.3.1-.7.3-1 .4-.4.2-.7.3-1.1.5-.2.1-.5.2-.7.4-1.3.7-2.6 1.4-3.9 2.2-.1.1-.3.2-.4.3l-1.2.9h-.1c-.9.7-1.8 1.4-2.6 2.1-.4.4-.8.7-1.2 1.1l-.2.2a54.8 54.8 0 0 0-3.2 3.6c-.1.1-.2.2-.2.3l-.9 1.2c0 .1-.1.1-.1.2l-1.5 2.4c-.1.2-.2.3-.3.5-2.7 5.1-4.3 10.9-4.3 17s1.6 12 4.3 17c.1.2.2.3.3.5z'
    ], [
        secondaryColor,
        'M184 840h656V184H184v656zm436.4-499.1c-.2 0-.3.1-.4.1v-77c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v77c-.2 0-.3-.1-.4-.1 42 13.4 72.4 52.7 72.4 99.1 0 46.4-30.4 85.7-72.4 99.1.2 0 .3-.1.4-.1v221c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V539c.2 0 .3.1.4.1-42-13.4-72.4-52.7-72.4-99.1 0-46.4 30.4-85.7 72.4-99.1zM340 485V264c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v221c41.7 13.6 72 52.8 72 99s-30.3 85.5-72 99v77c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-77c-41.7-13.6-72-52.8-72-99s30.3-85.5 72-99z'
    ], [
        primaryColor,
        'M340 683v77c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-77c41.7-13.5 72-52.8 72-99s-30.3-85.4-72-99V264c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v221c-41.7 13.5-72 52.8-72 99s30.3 85.4 72 99zm.1-116c.1-.2.2-.3.3-.5l1.5-2.4c0-.1.1-.1.1-.2l.9-1.2c0-.1.1-.2.2-.3 1-1.2 2.1-2.5 3.2-3.6l.2-.2c.4-.4.8-.7 1.2-1.1.8-.7 1.7-1.4 2.6-2.1h.1l1.2-.9c.1-.1.3-.2.4-.3 1.3-.8 2.6-1.5 3.9-2.2.2-.2.5-.3.7-.4.4-.2.7-.3 1.1-.5.3-.1.7-.3 1-.4.5-.1 1-.3 1.5-.5.4-.1.9-.3 1.3-.4l.9-.3 1.4-.3c.2-.1.5-.1.7-.2.7-.2 1.4-.3 2.1-.4.2-.1.4-.1.6-.1.5-.1 1.1-.2 1.7-.2.3-.1.5-.1.7-.1.8-.1 1.5-.1 2.3-.1s1.5.1 2.3.1c.3.1.5.1.7.1.6.1 1.1.1 1.7.2.2.1.4.1.6.1.7.1 1.4.3 2.1.4.2.1.5.1.7.2l1.4.3.9.3c.4.1.9.3 1.3.4.5.1 1 .3 1.5.5.3.1.7.3 1 .4.4.2.7.3 1.1.5.2.2.5.3.7.4 1.4.6 2.7 1.4 3.9 2.2.1.1.3.2.4.3l1.2.9h.1c.9.6 1.8 1.3 2.6 2.1.4.3.8.7 1.2 1.1l.2.2c1.2 1.1 2.2 2.3 3.2 3.6 0 .1.1.2.2.3l.9 1.2c0 .1.1.1.1.2l1.5 2.4A36.03 36.03 0 0 1 408 584c0 6.1-1.6 11.9-4.3 17-.1.2-.2.3-.3.5l-1.5 2.4c0 .1-.1.1-.1.2l-.9 1.2c0 .1-.1.2-.2.3-1 1.2-2.1 2.5-3.2 3.6l-.2.2c-.4.4-.8.7-1.2 1.1-.8.7-1.7 1.4-2.6 2.1h-.1l-1.2.9c-.1.1-.3.2-.4.3-1.3.8-2.6 1.5-3.9 2.2-.2.2-.5.3-.7.4-.4.2-.7.3-1.1.5-.3.1-.7.3-1 .4-.5.1-1 .3-1.5.5-.4.1-.9.3-1.3.4l-.9.3-1.4.3c-.2.1-.5.1-.7.2-.7.2-1.4.3-2.1.4-.2.1-.4.1-.6.1-.5.1-1.1.2-1.7.2-.3.1-.5.1-.7.1-.8.1-1.5.1-2.3.1s-1.5-.1-2.3-.1c-.3-.1-.5-.1-.7-.1-.6-.1-1.1-.1-1.7-.2-.2-.1-.4-.1-.6-.1-.7-.1-1.4-.3-2.1-.4-.2-.1-.5-.1-.7-.2l-1.4-.3-.9-.3c-.4-.1-.9-.3-1.3-.4-.5-.1-1-.3-1.5-.5-.3-.1-.7-.3-1-.4-.4-.2-.7-.3-1.1-.5-.2-.2-.5-.3-.7-.4-1.4-.6-2.7-1.4-3.9-2.2-.1-.1-.3-.2-.4-.3l-1.2-.9h-.1c-.9-.6-1.8-1.3-2.6-2.1-.4-.3-.8-.7-1.2-1.1l-.2-.2c-1.2-1.1-2.2-2.3-3.2-3.6 0-.1-.1-.2-.2-.3l-.9-1.2c0-.1-.1-.1-.1-.2l-1.5-2.4c-.1-.2-.2-.3-.3-.5-2.7-5-4.3-10.9-4.3-17s1.6-11.9 4.3-17zm280.3-27.9c-.1 0-.2-.1-.4-.1v221c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V539c-.1 0-.2.1-.4.1 42-13.4 72.4-52.7 72.4-99.1 0-46.4-30.4-85.7-72.4-99.1.1 0 .2.1.4.1v-77c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v77c.1 0 .2-.1.4-.1-42 13.4-72.4 52.7-72.4 99.1 0 46.4 30.4 85.7 72.4 99.1zM652 404c19.9 0 36 16.1 36 36s-16.1 36-36 36-36-16.1-36-36 16.1-36 36-36z'
    ]);
});
exports.CopyTwoTone = getIcon('copy', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M232 706h142c22.1 0 40 17.9 40 40v142h250V264H232v442z'], [
        primaryColor,
        'M832 64H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h496v688c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V96c0-17.7-14.3-32-32-32z'
    ], [
        primaryColor,
        'M704 192H192c-17.7 0-32 14.3-32 32v530.7c0 8.5 3.4 16.6 9.4 22.6l173.3 173.3c2.2 2.2 4.7 4 7.4 5.5v1.9h4.2c3.5 1.3 7.2 2 11 2H704c17.7 0 32-14.3 32-32V224c0-17.7-14.3-32-32-32zM350 856.2L263.9 770H350v86.2zM664 888H414V746c0-22.1-17.9-40-40-40H232V264h432v624z'
    ]);
});
exports.CreditCardTwoTone = getIcon('credit-card', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M136 792h752V440H136v352zm507-144c0-4.4 3.6-8 8-8h165c4.4 0 8 3.6 8 8v72c0 4.4-3.6 8-8 8H651c-4.4 0-8-3.6-8-8v-72zM136 232h752v120H136z'
    ], [
        primaryColor,
        'M651 728h165c4.4 0 8-3.6 8-8v-72c0-4.4-3.6-8-8-8H651c-4.4 0-8 3.6-8 8v72c0 4.4 3.6 8 8 8z'
    ], [
        primaryColor,
        'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136V440h752v352zm0-440H136V232h752v120z'
    ]);
});
exports.CrownTwoTone = getIcon('crown', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M911.9 283.9v.5L835.5 865c-1 8-7.9 14-15.9 14H204.5c-8.1 0-14.9-6.1-16-14l-76.4-580.6v-.6 1.6L188.5 866c1.1 7.9 7.9 14 16 14h615.1c8 0 14.9-6 15.9-14l76.4-580.6c.1-.5.1-1 0-1.5z'
    ], [
        secondaryColor,
        'M773.6 810.6l53.9-409.4-139.8 86.1L512 252.9 336.3 487.3l-139.8-86.1 53.8 409.4h523.3zm-374.2-189c0-62.1 50.5-112.6 112.6-112.6s112.6 50.5 112.6 112.6v1c0 62.1-50.5 112.6-112.6 112.6s-112.6-50.5-112.6-112.6v-1z'
    ], [
        primaryColor,
        'M512 734.2c61.9 0 112.3-50.2 112.6-112.1v-.5c0-62.1-50.5-112.6-112.6-112.6s-112.6 50.5-112.6 112.6v.5c.3 61.9 50.7 112.1 112.6 112.1zm0-160.9c26.6 0 48.2 21.6 48.2 48.3 0 26.6-21.6 48.3-48.2 48.3s-48.2-21.6-48.2-48.3c0-26.6 21.6-48.3 48.2-48.3z'
    ], [
        primaryColor,
        'M188.5 865c1.1 7.9 7.9 14 16 14h615.1c8 0 14.9-6 15.9-14l76.4-580.6v-.5c.3-6.4-6.7-10.8-12.3-7.4L705 396.4 518.4 147.5a8.06 8.06 0 0 0-12.9 0L319 396.4 124.3 276.5c-5.5-3.4-12.6.9-12.2 7.3v.6L188.5 865zm147.8-377.7L512 252.9l175.7 234.4 139.8-86.1-53.9 409.4H250.3l-53.8-409.4 139.8 86.1z'
    ]);
});
exports.CustomerServiceTwoTone = getIcon('customer-service', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M696 632h128v192H696zm-496 0h128v192H200z'], [
        primaryColor,
        'M512 128c-212.1 0-384 171.9-384 384v360c0 13.3 10.7 24 24 24h184c35.3 0 64-28.7 64-64V624c0-35.3-28.7-64-64-64H200v-48c0-172.3 139.7-312 312-312s312 139.7 312 312v48H688c-35.3 0-64 28.7-64 64v208c0 35.3 28.7 64 64 64h184c13.3 0 24-10.7 24-24V512c0-212.1-171.9-384-384-384zM328 632v192H200V632h128zm496 192H696V632h128v192z'
    ]);
});
exports.DashboardTwoTone = getIcon('dashboard', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M512 188c-99.3 0-192.7 38.7-263 109-70.3 70.2-109 163.6-109 263 0 105.6 44.5 205.5 122.6 276h498.8A371.12 371.12 0 0 0 884 560c0-99.3-38.7-192.7-109-263-70.2-70.3-163.6-109-263-109zm-30 44c0-4.4 3.6-8 8-8h44c4.4 0 8 3.6 8 8v80c0 4.4-3.6 8-8 8h-44c-4.4 0-8-3.6-8-8v-80zM270 582c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-44c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v44zm90.7-204.4l-31.1 31.1a8.03 8.03 0 0 1-11.3 0l-56.6-56.6a8.03 8.03 0 0 1 0-11.3l31.1-31.1c3.1-3.1 8.2-3.1 11.3 0l56.6 56.6c3.1 3.1 3.1 8.2 0 11.3zm291.1 83.5l-84.5 84.5c5 18.7.2 39.4-14.5 54.1a55.95 55.95 0 0 1-79.2 0 55.95 55.95 0 0 1 0-79.2 55.87 55.87 0 0 1 54.1-14.5l84.5-84.5c3.1-3.1 8.2-3.1 11.3 0l28.3 28.3c3.1 3.1 3.1 8.2 0 11.3zm43-52.4l-31.1-31.1a8.03 8.03 0 0 1 0-11.3l56.6-56.6c3.1-3.1 8.2-3.1 11.3 0l31.1 31.1c3.1 3.1 3.1 8.2 0 11.3l-56.6 56.6a8.03 8.03 0 0 1-11.3 0zM846 538v44c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8v-44c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8z'
    ], [
        primaryColor,
        'M623.5 421.5a8.03 8.03 0 0 0-11.3 0L527.7 506c-18.7-5-39.4-.2-54.1 14.5a55.95 55.95 0 0 0 0 79.2 55.95 55.95 0 0 0 79.2 0 55.87 55.87 0 0 0 14.5-54.1l84.5-84.5c3.1-3.1 3.1-8.2 0-11.3l-28.3-28.3zM490 320h44c4.4 0 8-3.6 8-8v-80c0-4.4-3.6-8-8-8h-44c-4.4 0-8 3.6-8 8v80c0 4.4 3.6 8 8 8z'
    ], [
        primaryColor,
        'M924.8 385.6a446.7 446.7 0 0 0-96-142.4 446.7 446.7 0 0 0-142.4-96C631.1 123.8 572.5 112 512 112s-119.1 11.8-174.4 35.2a446.7 446.7 0 0 0-142.4 96 446.7 446.7 0 0 0-96 142.4C75.8 440.9 64 499.5 64 560c0 132.7 58.3 257.7 159.9 343.1l1.7 1.4c5.8 4.8 13.1 7.5 20.6 7.5h531.7c7.5 0 14.8-2.7 20.6-7.5l1.7-1.4C901.7 817.7 960 692.7 960 560c0-60.5-11.9-119.1-35.2-174.4zM761.4 836H262.6A371.12 371.12 0 0 1 140 560c0-99.4 38.7-192.8 109-263 70.3-70.3 163.7-109 263-109 99.4 0 192.8 38.7 263 109 70.3 70.3 109 163.7 109 263 0 105.6-44.5 205.5-122.6 276z'
    ], [
        primaryColor,
        'M762.7 340.8l-31.1-31.1a8.03 8.03 0 0 0-11.3 0l-56.6 56.6a8.03 8.03 0 0 0 0 11.3l31.1 31.1c3.1 3.1 8.2 3.1 11.3 0l56.6-56.6c3.1-3.1 3.1-8.2 0-11.3zM750 538v44c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-44c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8zM304.1 309.7a8.03 8.03 0 0 0-11.3 0l-31.1 31.1a8.03 8.03 0 0 0 0 11.3l56.6 56.6c3.1 3.1 8.2 3.1 11.3 0l31.1-31.1c3.1-3.1 3.1-8.2 0-11.3l-56.6-56.6zM262 530h-80c-4.4 0-8 3.6-8 8v44c0 4.4 3.6 8 8 8h80c4.4 0 8-3.6 8-8v-44c0-4.4-3.6-8-8-8z'
    ]);
});
exports.DeleteTwoTone = getIcon('delete', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M292.7 840h438.6l24.2-512h-487z'], [
        primaryColor,
        'M864 256H736v-80c0-35.3-28.7-64-64-64H352c-35.3 0-64 28.7-64 64v80H160c-17.7 0-32 14.3-32 32v32c0 4.4 3.6 8 8 8h60.4l24.7 523c1.6 34.1 29.8 61 63.9 61h454c34.2 0 62.3-26.8 63.9-61l24.7-523H888c4.4 0 8-3.6 8-8v-32c0-17.7-14.3-32-32-32zm-504-72h304v72H360v-72zm371.3 656H292.7l-24.2-512h487l-24.2 512z'
    ]);
});
exports.DiffTwoTone = getIcon('diff', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M232 264v624h432V413.8L514.2 264H232zm336 489c0 3.8-3.4 7-7.5 7h-225c-4.1 0-7.5-3.2-7.5-7v-42c0-3.8 3.4-7 7.5-7h225c4.1 0 7.5 3.2 7.5 7v42zm0-262v42c0 3.8-3.4 7-7.5 7H476v84.9c0 3.9-3.1 7.1-7 7.1h-42c-3.8 0-7-3.2-7-7.1V540h-84.5c-4.1 0-7.5-3.2-7.5-7v-42c0-3.9 3.4-7 7.5-7H420v-84.9c0-3.9 3.2-7.1 7-7.1h42c3.9 0 7 3.2 7 7.1V484h84.5c4.1 0 7.5 3.1 7.5 7z'
    ], [
        primaryColor,
        'M854.2 306.6L611.3 72.9c-6-5.7-13.9-8.9-22.2-8.9H296c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h277l219 210.6V824c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V329.6c0-8.7-3.5-17-9.8-23z'
    ], [
        primaryColor,
        'M553.4 201.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v704c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32V397.3c0-8.5-3.4-16.6-9.4-22.6L553.4 201.4zM664 888H232V264h282.2L664 413.8V888z'
    ], [
        primaryColor,
        'M476 399.1c0-3.9-3.1-7.1-7-7.1h-42c-3.8 0-7 3.2-7 7.1V484h-84.5c-4.1 0-7.5 3.1-7.5 7v42c0 3.8 3.4 7 7.5 7H420v84.9c0 3.9 3.2 7.1 7 7.1h42c3.9 0 7-3.2 7-7.1V540h84.5c4.1 0 7.5-3.2 7.5-7v-42c0-3.9-3.4-7-7.5-7H476v-84.9zM560.5 704h-225c-4.1 0-7.5 3.2-7.5 7v42c0 3.8 3.4 7 7.5 7h225c4.1 0 7.5-3.2 7.5-7v-42c0-3.8-3.4-7-7.5-7z'
    ]);
});
exports.DatabaseTwoTone = getIcon('database', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M232 616h560V408H232v208zm112-144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM232 888h560V680H232v208zm112-144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM232 344h560V136H232v208zm112-144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z'
    ], [
        primaryColor,
        'M304 512a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0 272a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0-544a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'
    ], [
        primaryColor,
        'M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V680h560v208zm0-272H232V408h560v208zm0-272H232V136h560v208z'
    ]);
});
exports.DislikeTwoTone = getIcon('dislike', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M273 100.1v428h.3l-.3-428zM820.4 525l-21.9-19 14-25.5a56.2 56.2 0 0 0 6.9-27.3c0-16.5-7.1-32.2-19.6-43l-21.9-19 13.9-25.4a56.2 56.2 0 0 0 6.9-27.3c0-16.5-7.1-32.2-19.6-43l-21.9-19 13.9-25.4a56.2 56.2 0 0 0 6.9-27.3c0-22.4-13.2-42.6-33.6-51.8H345v345.2c18.6 67.2 46.4 168 83.5 302.5a44.28 44.28 0 0 0 42.2 32.3c7.5.1 15-2.2 21.1-6.7 9.9-7.4 15.2-18.6 14.6-30.5l-9.6-198.4h314.4C829 605.5 840 587.1 840 568c0-16.5-7.1-32.2-19.6-43z'
    ], [
        primaryColor,
        'M112 132v364c0 17.7 14.3 32 32 32h65V100h-65c-17.7 0-32 14.3-32 32zm773.9 358.3c3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-28.3-9.3-55.5-26.1-77.7 3.6-12 5.4-24.4 5.4-37 0-51.6-30.7-98.1-78.3-118.4a66.1 66.1 0 0 0-26.5-5.4H273l.3 428 85.8 310.8C372.9 889 418.9 924 470.9 924c29.7 0 57.4-11.8 77.9-33.4 20.5-21.5 31-49.7 29.5-79.4l-6-122.9h239.9c12.1 0 23.9-3.2 34.3-9.3 40.4-23.5 65.5-66.1 65.5-111 0-28.3-9.3-55.5-26.1-77.7zm-74.7 126.1H496.8l9.6 198.4c.6 11.9-4.7 23.1-14.6 30.5-6.1 4.5-13.6 6.8-21.1 6.7a44.28 44.28 0 0 1-42.2-32.3c-37.1-134.4-64.9-235.2-83.5-302.5V172h399.4a56.85 56.85 0 0 1 33.6 51.8c0 9.7-2.3 18.9-6.9 27.3l-13.9 25.4 21.9 19a56.76 56.76 0 0 1 19.6 43c0 9.7-2.3 18.9-6.9 27.3l-13.9 25.4 21.9 19a56.76 56.76 0 0 1 19.6 43c0 9.7-2.3 18.9-6.9 27.3l-14 25.5 21.9 19a56.76 56.76 0 0 1 19.6 43c0 19.1-11 37.5-28.8 48.4z'
    ]);
});
exports.DownCircleTwoTone = getIcon('down-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm184.4 277.7l-178 246a7.95 7.95 0 0 1-12.9 0l-178-246c-3.8-5.3 0-12.7 6.5-12.7h46.9c10.3 0 19.9 4.9 25.9 13.2L512 563.6l105.2-145.4c6-8.3 15.7-13.2 25.9-13.2H690c6.5 0 10.3 7.4 6.4 12.7z'
    ], [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        primaryColor,
        'M690 405h-46.9c-10.2 0-19.9 4.9-25.9 13.2L512 563.6 406.8 418.2c-6-8.3-15.6-13.2-25.9-13.2H334c-6.5 0-10.3 7.4-6.5 12.7l178 246c3.2 4.4 9.7 4.4 12.9 0l178-246c3.9-5.3.1-12.7-6.4-12.7z'
    ]);
});
exports.DownSquareTwoTone = getIcon('down-square', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
    ], [
        secondaryColor,
        'M184 840h656V184H184v656zm150-440h46.9c10.3 0 19.9 4.9 25.9 13.2L512 558.6l105.2-145.4c6-8.3 15.7-13.2 25.9-13.2H690c6.5 0 10.3 7.4 6.4 12.7l-178 246a7.95 7.95 0 0 1-12.9 0l-178-246c-3.8-5.3 0-12.7 6.5-12.7z'
    ], [
        primaryColor,
        'M505.5 658.7c3.2 4.4 9.7 4.4 12.9 0l178-246c3.9-5.3.1-12.7-6.4-12.7h-46.9c-10.2 0-19.9 4.9-25.9 13.2L512 558.6 406.8 413.2c-6-8.3-15.6-13.2-25.9-13.2H334c-6.5 0-10.3 7.4-6.5 12.7l178 246z'
    ]);
});
exports.EnvironmentTwoTone = getIcon('environment', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M724.4 224.9C667.7 169.5 592.3 139 512 139s-155.7 30.5-212.4 85.8C243.1 280 212 353.2 212 431.1c0 241.3 234.1 407.2 300 449.1 65.9-41.9 300-207.8 300-449.1 0-77.9-31.1-151.1-87.6-206.2zM512 615c-97.2 0-176-78.8-176-176s78.8-176 176-176 176 78.8 176 176-78.8 176-176 176z'
    ], [
        primaryColor,
        'M512 263c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm79.2 255.2A111.6 111.6 0 0 1 512 551c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 0 1 400 439c0-29.9 11.7-58 32.8-79.2C454 338.6 482.1 327 512 327c29.9 0 58 11.6 79.2 32.8S624 409.1 624 439c0 29.9-11.6 58-32.8 79.2z'
    ], [
        primaryColor,
        'M854.6 289.1a362.49 362.49 0 0 0-79.9-115.7 370.83 370.83 0 0 0-118.2-77.8C610.7 76.6 562.1 67 512 67c-50.1 0-98.7 9.6-144.5 28.5-44.3 18.3-84 44.5-118.2 77.8A363.6 363.6 0 0 0 169.4 289c-19.5 45-29.4 92.8-29.4 142 0 70.6 16.9 140.9 50.1 208.7 26.7 54.5 64 107.6 111 158.1 80.3 86.2 164.5 138.9 188.4 153a43.9 43.9 0 0 0 22.4 6.1c7.8 0 15.5-2 22.4-6.1 23.9-14.1 108.1-66.8 188.4-153 47-50.4 84.3-103.6 111-158.1C867.1 572 884 501.8 884 431.1c0-49.2-9.9-97-29.4-142zM512 880.2c-65.9-41.9-300-207.8-300-449.1 0-77.9 31.1-151.1 87.6-206.3C356.3 169.5 431.7 139 512 139s155.7 30.5 212.4 85.9C780.9 280 812 353.2 812 431.1c0 241.3-234.1 407.2-300 449.1z'
    ]);
});
exports.EditTwoTone = getIcon('edit', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M761.1 288.3L687.8 215 325.1 577.6l-15.6 89 88.9-15.7z'], [
        primaryColor,
        'M880 836H144c-17.7 0-32 14.3-32 32v36c0 4.4 3.6 8 8 8h784c4.4 0 8-3.6 8-8v-36c0-17.7-14.3-32-32-32zm-622.3-84c2 0 4-.2 6-.5L431.9 722c2-.4 3.9-1.3 5.3-2.8l423.9-423.9a9.96 9.96 0 0 0 0-14.1L694.9 114.9c-1.9-1.9-4.4-2.9-7.1-2.9s-5.2 1-7.1 2.9L256.8 538.8c-1.5 1.5-2.4 3.3-2.8 5.3l-29.5 168.2a33.5 33.5 0 0 0 9.4 29.8c6.6 6.4 14.9 9.9 23.8 9.9zm67.4-174.4L687.8 215l73.3 73.3-362.7 362.6-88.9 15.7 15.6-89z'
    ]);
});
exports.ExclamationCircleTwoTone = getIcon('exclamation-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm-32 156c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V296zm32 440a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'
    ], [
        primaryColor,
        'M488 576h48c4.4 0 8-3.6 8-8V296c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8zm-24 112a48 48 0 1 0 96 0 48 48 0 1 0-96 0z'
    ]);
});
exports.ExperimentTwoTone = getIcon('experiment', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M551.9 513c19.6 0 35.9-14.2 39.3-32.8A40.02 40.02 0 0 1 552 512a40 40 0 0 1-40-39.4v.5c0 22 17.9 39.9 39.9 39.9zM752 687.8l-.3-.3c-29-17.5-62.3-26.8-97-26.8-44.9 0-87.2 15.7-121 43.8a256.27 256.27 0 0 1-164.9 59.9c-41.2 0-81-9.8-116.7-28L210.5 844h603l-59.9-155.2-1.6-1z'
    ], [
        primaryColor,
        'M879 824.9L696.3 352V178H768v-68H256v68h71.7v174L145 824.9c-2.8 7.4-4.3 15.2-4.3 23.1 0 35.3 28.7 64 64 64h614.6c7.9 0 15.7-1.5 23.1-4.3 33-12.7 49.4-49.8 36.6-82.8zM395.7 364.7V180h232.6v184.7L719.2 600c-20.7-5.3-42.1-8-63.9-8-61.2 0-119.2 21.5-165.3 60a188.78 188.78 0 0 1-121.3 43.9c-32.7 0-64.1-8.3-91.8-23.7l118.8-307.5zM210.5 844l41.6-107.6.1-.2c35.7 18.1 75.4 27.8 116.6 27.8 61.2 0 119.2-21.5 165.3-60 33.9-28.2 76.3-43.9 121.3-43.9 35 0 68.4 9.5 97.6 27.1l.6 1.6L813.5 844h-603z'
    ], [
        primaryColor,
        'M552 512c19.3 0 35.4-13.6 39.2-31.8.6-2.7.8-5.4.8-8.2 0-22.1-17.9-40-40-40s-40 17.9-40 40v.6a40 40 0 0 0 40 39.4z'
    ]);
});
exports.EyeInvisibleTwoTone = getIcon('eye-invisible', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M254.89 758.85l125.57-125.57a176 176 0 0 1 248.82-248.82L757 256.72Q651.69 186.07 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 0 0 0 51.5q69.27 145.91 173.09 221.05zM942.2 486.2Q889.46 375.11 816.7 305L672.48 449.27a176.09 176.09 0 0 1-227.22 227.21L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 0 0 0-51.5z'
    ], [
        primaryColor,
        'M942.2 486.2Q889.47 375.11 816.7 305l-50.88 50.88C807.31 395.53 843.45 447.4 874.7 512 791.5 684.2 673.4 766 512 766q-72.67 0-133.87-22.38L323 798.75Q408 838 512 838q288.3 0 430.2-300.3a60.29 60.29 0 0 0 0-51.5zM878.63 165.56L836 122.88a8 8 0 0 0-11.32 0L715.31 232.2Q624.86 186 512 186q-288.3 0-430.2 300.3a60.3 60.3 0 0 0 0 51.5q56.69 119.4 136.5 191.41L112.48 835a8 8 0 0 0 0 11.31L155.17 889a8 8 0 0 0 11.31 0l712.15-712.12a8 8 0 0 0 0-11.32zM149.3 512C232.6 339.8 350.7 258 512 258c54.54 0 104.13 9.36 149.12 28.39l-70.3 70.3a176 176 0 0 0-238.13 238.13l-83.42 83.42C223.1 637.49 183.3 582.28 149.3 512zm246.7 0a112.11 112.11 0 0 1 146.2-106.69L401.31 546.2A112 112 0 0 1 396 512z'
    ], [
        primaryColor,
        'M508 624c-3.46 0-6.87-.16-10.25-.47l-52.82 52.82a176.09 176.09 0 0 0 227.42-227.42l-52.82 52.82c.31 3.38.47 6.79.47 10.25a111.94 111.94 0 0 1-112 112z'
    ]);
});
exports.EyeTwoTone = getIcon('eye', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M81.8 537.8a60.3 60.3 0 0 1 0-51.5C176.6 286.5 319.8 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 0 0 0 51.5C176.6 737.5 319.9 838 512 838c-192.1 0-335.4-100.5-430.2-300.2z'
    ], [
        secondaryColor,
        'M512 258c-161.3 0-279.4 81.8-362.7 254C232.6 684.2 350.7 766 512 766c161.4 0 279.5-81.8 362.7-254C791.4 339.8 673.3 258 512 258zm-4 430c-97.2 0-176-78.8-176-176s78.8-176 176-176 176 78.8 176 176-78.8 176-176 176z'
    ], [
        primaryColor,
        'M942.2 486.2C847.4 286.5 704.1 186 512 186c-192.2 0-335.4 100.5-430.2 300.3a60.3 60.3 0 0 0 0 51.5C176.6 737.5 319.9 838 512 838c192.2 0 335.4-100.5 430.2-300.3 7.7-16.2 7.7-35 0-51.5zM512 766c-161.3 0-279.4-81.8-362.7-254C232.6 339.8 350.7 258 512 258s279.4 81.8 362.7 254C791.5 684.2 673.4 766 512 766z'
    ], [
        primaryColor,
        'M508 336c-97.2 0-176 78.8-176 176s78.8 176 176 176 176-78.8 176-176-78.8-176-176-176zm0 288c-61.9 0-112-50.1-112-112s50.1-112 112-112 112 50.1 112 112-50.1 112-112 112z'
    ]);
});
exports.FileAddTwoTone = getIcon('file-add', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm126 236v48c0 4.4-3.6 8-8 8H544v108c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V644H372c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h108V472c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v108h108c4.4 0 8 3.6 8 8z'
    ], [
        primaryColor,
        'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z'
    ], [
        primaryColor,
        'M544 472c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v108H372c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h108v108c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V644h108c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V472z'
    ]);
});
exports.FileExclamationTwoTone = getIcon('file-exclamation', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm-54 96c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v184c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V448zm32 336c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40z'
    ], [
        primaryColor,
        'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z'
    ], [
        primaryColor,
        'M488 640h48c4.4 0 8-3.6 8-8V448c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v184c0 4.4 3.6 8 8 8zm-16 104a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'
    ]);
});
exports.FileImageTwoTone = getIcon('file-image', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm-134 50c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm296 294H328.1c-6.7 0-10.4-7.7-6.3-12.9l99.8-127.2a8 8 0 0 1 12.6 0l41.1 52.4 77.8-99.2a8.1 8.1 0 0 1 12.7 0l136.5 174c4.1 5.2.4 12.9-6.3 12.9z'
    ], [
        primaryColor,
        'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z'
    ], [
        primaryColor,
        'M553.1 509.1l-77.8 99.2-41.1-52.4a8 8 0 0 0-12.6 0l-99.8 127.2a7.98 7.98 0 0 0 6.3 12.9H696c6.7 0 10.4-7.7 6.3-12.9l-136.5-174a8.1 8.1 0 0 0-12.7 0zM360 442a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'
    ]);
});
exports.FileExcelTwoTone = getIcon('file-excel', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm51.6 120h35.7a12.04 12.04 0 0 1 10.1 18.5L546.1 623l84 130.4c3.6 5.6 2 13-3.6 16.6-2 1.2-4.2 1.9-6.5 1.9h-37.5c-4.1 0-8-2.1-10.2-5.7L510 664.8l-62.7 101.5c-2.2 3.5-6 5.7-10.2 5.7h-34.5a12.04 12.04 0 0 1-10.2-18.4l83.4-132.8-82.3-130.4c-3.6-5.7-1.9-13.1 3.7-16.6 1.9-1.3 4.1-1.9 6.4-1.9H442c4.2 0 8.1 2.2 10.3 5.8l61.8 102.4 61.2-102.3c2.2-3.6 6.1-5.8 10.3-5.8z'
    ], [
        primaryColor,
        'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z'
    ], [
        primaryColor,
        'M514.1 580.1l-61.8-102.4c-2.2-3.6-6.1-5.8-10.3-5.8h-38.4c-2.3 0-4.5.6-6.4 1.9-5.6 3.5-7.3 10.9-3.7 16.6l82.3 130.4-83.4 132.8a12.04 12.04 0 0 0 10.2 18.4h34.5c4.2 0 8-2.2 10.2-5.7L510 664.8l62.3 101.4c2.2 3.6 6.1 5.7 10.2 5.7H620c2.3 0 4.5-.7 6.5-1.9 5.6-3.6 7.2-11 3.6-16.6l-84-130.4 85.3-132.5a12.04 12.04 0 0 0-10.1-18.5h-35.7c-4.2 0-8.1 2.2-10.3 5.8l-61.2 102.3z'
    ]);
});
exports.FileMarkdownTwoTone = getIcon('file-markdown', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm72.3 122H641c6.6 0 12 5.4 12 12v272c0 6.6-5.4 12-12 12h-27.2c-6.6 0-12-5.4-12-12V581.7L535 732.3c-2 4.3-6.3 7.1-11 7.1h-24.1a12 12 0 0 1-11-7.1l-66.8-150.2V758c0 6.6-5.4 12-12 12H383c-6.6 0-12-5.4-12-12V486c0-6.6 5.4-12 12-12h35c4.8 0 9.1 2.8 11 7.2l83.2 191 83.1-191c1.9-4.4 6.2-7.2 11-7.2z'
    ], [
        primaryColor,
        'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z'
    ], [
        primaryColor,
        'M429 481.2c-1.9-4.4-6.2-7.2-11-7.2h-35c-6.6 0-12 5.4-12 12v272c0 6.6 5.4 12 12 12h27.1c6.6 0 12-5.4 12-12V582.1l66.8 150.2a12 12 0 0 0 11 7.1H524c4.7 0 9-2.8 11-7.1l66.8-150.6V758c0 6.6 5.4 12 12 12H641c6.6 0 12-5.4 12-12V486c0-6.6-5.4-12-12-12h-34.7c-4.8 0-9.1 2.8-11 7.2l-83.1 191-83.2-191z'
    ]);
});
exports.FilePdfTwoTone = getIcon('file-pdf', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M509.2 490.8c-.7-1.3-1.4-1.9-2.2-2-2.9 3.3-2.2 31.5 2.7 51.4 4-13.6 4.7-40.5-.5-49.4zm-1.6 120.5c-7.7 20-18.8 47.3-32.1 71.4 4-1.6 8.1-3.3 12.3-5 17.6-7.2 37.3-15.3 58.9-20.2-14.9-11.8-28.4-27.7-39.1-46.2z'
    ], [
        secondaryColor,
        'M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm55 287.6c16.1-1.9 30.6-2.8 44.3-2.3 12.8.4 23.6 2 32 5.1.2.1.3.1.5.2.4.2.8.3 1.2.5.5.2 1.1.4 1.6.7.1.1.3.1.4.2 4.1 1.8 7.5 4 10.1 6.6 9.1 9.1 11.8 26.1 6.2 39.6-3.2 7.7-11.7 20.5-33.3 20.5-21.8 0-53.9-9.7-82.1-24.8-25.5 4.3-53.7 13.9-80.9 23.1-5.8 2-11.8 4-17.6 5.9-38 65.2-66.5 79.4-84.1 79.4-4.2 0-7.8-.9-10.8-2-6.9-2.6-12.8-8-16.5-15-.9-1.7-1.6-3.4-2.2-5.2-1.6-4.8-2.1-9.6-1.3-13.6l.6-2.7c.1-.2.1-.4.2-.6.2-.7.4-1.4.7-2.1 0-.1.1-.2.1-.3 4.1-11.9 13.6-23.4 27.7-34.6 12.3-9.8 27.1-18.7 45.9-28.4 15.9-28 37.6-75.1 51.2-107.4-10.8-41.8-16.7-74.6-10.1-98.6.9-3.3 2.5-6.4 4.6-9.1.2-.2.3-.4.5-.6.1-.1.1-.2.2-.2 6.3-7.5 16.9-11.9 28.1-11.5 16.6.7 29.7 11.5 33 30.1 1.7 8 2.2 16.5 1.9 25.7v.7c0 .5 0 1-.1 1.5-.7 13.3-3 26.6-7.3 44.7-.4 1.6-.8 3.2-1.2 5.2l-1 4.1-.1.3c.1.2.1.3.2.5l1.8 4.5c.1.3.3.7.4 1 .7 1.6 1.4 3.3 2.1 4.8v.1c8.7 18.8 19.7 33.4 33.9 45.1 4.3 3.5 8.9 6.7 13.9 9.8 1.8-.5 3.5-.7 5.3-.9z'
    ], [
        secondaryColor,
        'M391.5 761c5.7-4.4 16.2-14.5 30.1-34.7-10.3 9.4-23.4 22.4-30.1 34.7zm270.9-83l.2-.3h.2c.6-.4.5-.7.4-.9-.1-.1-4.5-9.3-45.1-7.4 35.3 13.9 43.5 9.1 44.3 8.6z'
    ], [
        primaryColor,
        'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z'
    ], [
        primaryColor,
        'M535.9 585.3c-.8-1.7-1.5-3.3-2.2-4.9-.1-.3-.3-.7-.4-1l-1.8-4.5c-.1-.2-.1-.3-.2-.5l.1-.3.2-1.1c4-16.3 8.6-35.3 9.4-54.4v-.7c.3-8.6-.2-17.2-2-25.6-3.8-21.3-19.5-29.6-32.9-30.2-11.3-.5-21.8 4-28.1 11.4-.1.1-.1.2-.2.2-.2.2-.4.4-.5.6-2.1 2.7-3.7 5.8-4.6 9.1-6.6 24-.7 56.8 10.1 98.6-13.6 32.4-35.3 79.4-51.2 107.4v.1c-27.7 14.3-64.1 35.8-73.6 62.9 0 .1-.1.2-.1.3-.2.7-.5 1.4-.7 2.1-.1.2-.1.4-.2.6-.2.9-.5 1.8-.6 2.7-.9 4-.4 8.8 1.3 13.6.6 1.8 1.3 3.5 2.2 5.2 3.7 7 9.6 12.4 16.5 15 3 1.1 6.6 2 10.8 2 17.6 0 46.1-14.2 84.1-79.4 5.8-1.9 11.8-3.9 17.6-5.9 27.2-9.2 55.4-18.8 80.9-23.1 28.2 15.1 60.3 24.8 82.1 24.8 21.6 0 30.1-12.8 33.3-20.5 5.6-13.5 2.9-30.5-6.2-39.6-2.6-2.6-6-4.8-10.1-6.6-.1-.1-.3-.1-.4-.2-.5-.2-1.1-.4-1.6-.7-.4-.2-.8-.3-1.2-.5-.2-.1-.3-.1-.5-.2-16.2-5.8-41.7-6.7-76.3-2.8l-5.3.6c-5-3-9.6-6.3-13.9-9.8-14.2-11.3-25.1-25.8-33.8-44.7zM391.5 761c6.7-12.3 19.8-25.3 30.1-34.7-13.9 20.2-24.4 30.3-30.1 34.7zM507 488.8c.8.1 1.5.7 2.2 2 5.2 8.9 4.5 35.8.5 49.4-4.9-19.9-5.6-48.1-2.7-51.4zm-19.2 188.9c-4.2 1.7-8.3 3.4-12.3 5 13.3-24.1 24.4-51.4 32.1-71.4 10.7 18.5 24.2 34.4 39.1 46.2-21.6 4.9-41.3 13-58.9 20.2zm175.4-.9c.1.2.2.5-.4.9h-.2l-.2.3c-.8.5-9 5.3-44.3-8.6 40.6-1.9 45 7.3 45.1 7.4z'
    ]);
});
exports.FilePptTwoTone = getIcon('file-ppt', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M464.5 516.2v108.4h38.9c44.7 0 71.2-10.9 71.2-54.3 0-34.4-20.1-54.1-53.9-54.1h-56.2z'
    ], [
        secondaryColor,
        'M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm90 218.4c0 55.2-36.8 94.1-96.2 94.1h-63.3V760c0 4.4-3.6 8-8 8H424c-4.4 0-8-3.6-8-8V484c0-4.4 3.6-8 8-8v.1h104c59.7 0 96 39.8 96 94.3z'
    ], [
        primaryColor,
        'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z'
    ], [
        primaryColor,
        'M424 476.1c-4.4-.1-8 3.5-8 7.9v276c0 4.4 3.6 8 8 8h32.5c4.4 0 8-3.6 8-8v-95.5h63.3c59.4 0 96.2-38.9 96.2-94.1 0-54.5-36.3-94.3-96-94.3H424zm150.6 94.2c0 43.4-26.5 54.3-71.2 54.3h-38.9V516.2h56.2c33.8 0 53.9 19.7 53.9 54.1z'
    ]);
});
exports.FileTextTwoTone = getIcon('file-text', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm-22 322c0 4.4-3.6 8-8 8H320c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm200-184v48c0 4.4-3.6 8-8 8H320c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h384c4.4 0 8 3.6 8 8z'
    ], [
        primaryColor,
        'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z'
    ], [
        primaryColor,
        'M312 490v48c0 4.4 3.6 8 8 8h384c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H320c-4.4 0-8 3.6-8 8zm192 128H320c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z'
    ]);
});
exports.FileUnknownTwoTone = getIcon('file-unknown', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm-22 424c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32zm110-228.4c.7 44.9-29.7 84.5-74.3 98.9-5.7 1.8-9.7 7.3-9.7 13.3V672c0 5.5-4.5 10-10 10h-32c-5.5 0-10-4.5-10-10v-32c.2-19.8 15.4-37.3 34.7-40.1C549 596.2 570 574.3 570 549c0-28.1-25.8-51.5-58-51.5s-58 23.4-58 51.6c0 5.2-4.4 9.4-9.8 9.4h-32.4c-5.4 0-9.8-4.1-9.8-9.5 0-57.4 50.1-103.7 111.5-103 59.3.8 107.7 46.1 108.5 101.6z'
    ], [
        primaryColor,
        'M854.6 288.7L639.4 73.4c-6-6-14.2-9.4-22.7-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.6-9.4-22.6zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z'
    ], [
        primaryColor,
        'M480 744a32 32 0 1 0 64 0 32 32 0 1 0-64 0zm-78-195c0 5.4 4.4 9.5 9.8 9.5h32.4c5.4 0 9.8-4.2 9.8-9.4 0-28.2 25.8-51.6 58-51.6s58 23.4 58 51.5c0 25.3-21 47.2-49.3 50.9-19.3 2.8-34.5 20.3-34.7 40.1v32c0 5.5 4.5 10 10 10h32c5.5 0 10-4.5 10-10v-12.2c0-6 4-11.5 9.7-13.3 44.6-14.4 75-54 74.3-98.9-.8-55.5-49.2-100.8-108.5-101.6-61.4-.7-111.5 45.6-111.5 103z'
    ]);
});
exports.FileZipTwoTone = getIcon('file-zip', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M344 630h32v2h-32z'], [
        secondaryColor,
        'M534 352V136H360v64h64v64h-64v64h64v64h-64v64h64v64h-64v62h64v160H296V520h64v-64h-64v-64h64v-64h-64v-64h64v-64h-64v-64h-64v752h560V394H576a42 42 0 0 1-42-42z'
    ], [
        primaryColor,
        'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h64v64h64v-64h174v216a42 42 0 0 0 42 42h216v494z'
    ], [
        primaryColor,
        'M296 392h64v64h-64zm0-128h64v64h-64zm0 318v160h128V582h-64v-62h-64v62zm48 50v-2h32v64h-32v-62zm16-432h64v64h-64zm0 256h64v64h-64zm0-128h64v64h-64z'
    ]);
});
exports.FileWordTwoTone = getIcon('file-word', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42zm101.3 129.3c1.3-5.4 6.1-9.3 11.7-9.3h35.6a12.04 12.04 0 0 1 11.6 15.1l-74.4 276c-1.4 5.3-6.2 8.9-11.6 8.9h-31.8c-5.4 0-10.2-3.7-11.6-8.9l-52.8-197-52.8 197c-1.4 5.3-6.2 8.9-11.6 8.9h-32c-5.4 0-10.2-3.7-11.6-8.9l-74.2-276a12.02 12.02 0 0 1 11.6-15.1h35.4c5.6 0 10.4 3.9 11.7 9.3L434.6 680l49.7-198.9c1.3-5.4 6.1-9.1 11.6-9.1h32.2c5.5 0 10.3 3.7 11.6 9.1l49.8 199.3 45.8-199.1z'
    ], [
        primaryColor,
        'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z'
    ], [
        primaryColor,
        'M528.1 472h-32.2c-5.5 0-10.3 3.7-11.6 9.1L434.6 680l-46.1-198.7c-1.3-5.4-6.1-9.3-11.7-9.3h-35.4a12.02 12.02 0 0 0-11.6 15.1l74.2 276c1.4 5.2 6.2 8.9 11.6 8.9h32c5.4 0 10.2-3.6 11.6-8.9l52.8-197 52.8 197c1.4 5.2 6.2 8.9 11.6 8.9h31.8c5.4 0 10.2-3.6 11.6-8.9l74.4-276a12.04 12.04 0 0 0-11.6-15.1H647c-5.6 0-10.4 3.9-11.7 9.3l-45.8 199.1-49.8-199.3c-1.3-5.4-6.1-9.1-11.6-9.1z'
    ]);
});
exports.FileTwoTone = getIcon('file', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M534 352V136H232v752h560V394H576a42 42 0 0 1-42-42z'], [
        primaryColor,
        'M854.6 288.6L639.4 73.4c-6-6-14.1-9.4-22.6-9.4H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V311.3c0-8.5-3.4-16.7-9.4-22.7zM602 137.8L790.2 326H602V137.8zM792 888H232V136h302v216a42 42 0 0 0 42 42h216v494z'
    ]);
});
exports.FilterTwoTone = getIcon('filter', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M420.6 798h182.9V642H420.6zM411 561.4l9.5 16.6h183l9.5-16.6L811.3 226H212.7z'
    ], [
        primaryColor,
        'M880.1 154H143.9c-24.5 0-39.8 26.7-27.5 48L349 597.4V838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V597.4L907.7 202c12.2-21.3-3.1-48-27.6-48zM603.5 798H420.6V642h182.9v156zm9.5-236.6l-9.5 16.6h-183l-9.5-16.6L212.7 226h598.6L613 561.4z'
    ]);
});
exports.FireTwoTone = getIcon('fire', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M737 438.6c-9.6 15.5-21.1 30.7-34.4 45.6a73.1 73.1 0 0 1-51 24.4 73.36 73.36 0 0 1-53.4-18.8 74.01 74.01 0 0 1-24.4-59.8c3-47.4-12.4-103.1-45.8-165.7-16.9-31.4-37.1-58.2-61.2-80.4a240 240 0 0 1-12.1 46.5 354.26 354.26 0 0 1-58.2 101 349.6 349.6 0 0 1-58.6 56.8c-34 26.1-62 60-80.8 97.9a275.96 275.96 0 0 0-29.1 124c0 74.9 29.5 145.3 83 198.4 53.7 53.2 125 82.4 201 82.4s147.3-29.2 201-82.4c53.5-53 83-123.5 83-198.4 0-39.2-8.1-77.3-24-113.1-9.3-21-21-40.5-35-58.4z'
    ], [
        primaryColor,
        'M834.1 469.2A347.49 347.49 0 0 0 751.2 354l-29.1-26.7a8.09 8.09 0 0 0-13 3.3l-13 37.3c-8.1 23.4-23 47.3-44.1 70.8-1.4 1.5-3 1.9-4.1 2-1.1.1-2.8-.1-4.3-1.5-1.4-1.2-2.1-3-2-4.8 3.7-60.2-14.3-128.1-53.7-202C555.3 171 510 123.1 453.4 89.7l-41.3-24.3c-5.4-3.2-12.3 1-12 7.3l2.2 48c1.5 32.8-2.3 61.8-11.3 85.9-11 29.5-26.8 56.9-47 81.5a295.64 295.64 0 0 1-47.5 46.1 352.6 352.6 0 0 0-100.3 121.5A347.75 347.75 0 0 0 160 610c0 47.2 9.3 92.9 27.7 136a349.4 349.4 0 0 0 75.5 110.9c32.4 32 70 57.2 111.9 74.7C418.5 949.8 464.5 959 512 959s93.5-9.2 136.9-27.3A348.6 348.6 0 0 0 760.8 857c32.4-32 57.8-69.4 75.5-110.9a344.2 344.2 0 0 0 27.7-136c0-48.8-10-96.2-29.9-140.9zM713 808.5c-53.7 53.2-125 82.4-201 82.4s-147.3-29.2-201-82.4c-53.5-53.1-83-123.5-83-198.4 0-43.5 9.8-85.2 29.1-124 18.8-37.9 46.8-71.8 80.8-97.9a349.6 349.6 0 0 0 58.6-56.8c25-30.5 44.6-64.5 58.2-101a240 240 0 0 0 12.1-46.5c24.1 22.2 44.3 49 61.2 80.4 33.4 62.6 48.8 118.3 45.8 165.7a74.01 74.01 0 0 0 24.4 59.8 73.36 73.36 0 0 0 53.4 18.8c19.7-1 37.8-9.7 51-24.4 13.3-14.9 24.8-30.1 34.4-45.6 14 17.9 25.7 37.4 35 58.4 15.9 35.8 24 73.9 24 113.1 0 74.9-29.5 145.4-83 198.4z'
    ]);
});
exports.FolderAddTwoTone = getIcon('folder-add', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M372.5 256H184v512h656V370.4H492.1L372.5 256zM540 443.1V528h84.5c4.1 0 7.5 3.1 7.5 7v42c0 3.8-3.4 7-7.5 7H540v84.9c0 3.9-3.1 7.1-7 7.1h-42c-3.8 0-7-3.2-7-7.1V584h-84.5c-4.1 0-7.5-3.2-7.5-7v-42c0-3.9 3.4-7 7.5-7H484v-84.9c0-3.9 3.2-7.1 7-7.1h42c3.9 0 7 3.2 7 7.1z'
    ], [
        primaryColor,
        'M880 298.4H521L403.7 186.2a8.15 8.15 0 0 0-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z'
    ], [
        primaryColor,
        'M484 443.1V528h-84.5c-4.1 0-7.5 3.1-7.5 7v42c0 3.8 3.4 7 7.5 7H484v84.9c0 3.9 3.2 7.1 7 7.1h42c3.9 0 7-3.2 7-7.1V584h84.5c4.1 0 7.5-3.2 7.5-7v-42c0-3.9-3.4-7-7.5-7H540v-84.9c0-3.9-3.1-7.1-7-7.1h-42c-3.8 0-7 3.2-7 7.1z'
    ]);
});
exports.FlagTwoTone = getIcon('flag', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M184 232h368v336H184z'], [secondaryColor, 'M624 632c0 4.4-3.6 8-8 8H504v73h336V377H624v255z'], [
        primaryColor,
        'M880 305H624V192c0-17.7-14.3-32-32-32H184v-40c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v784c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V640h248v113c0 17.7 14.3 32 32 32h416c17.7 0 32-14.3 32-32V337c0-17.7-14.3-32-32-32zM184 568V232h368v336H184zm656 145H504v-73h112c4.4 0 8-3.6 8-8V377h216v336z'
    ]);
});
exports.FolderTwoTone = getIcon('folder', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M880 298.4H521L403.7 186.2a8.15 8.15 0 0 0-5.5-2.2H144c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V330.4c0-17.7-14.3-32-32-32zM840 768H184V256h188.5l119.6 114.4H840V768z'
    ], [secondaryColor, 'M372.5 256H184v512h656V370.4H492.1z']);
});
exports.FolderOpenTwoTone = getIcon('folder-open', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M159 768h612.3l103.4-256H262.3z'], [
        primaryColor,
        'M928 444H820V330.4c0-17.7-14.3-32-32-32H473L355.7 186.2a8.15 8.15 0 0 0-5.5-2.2H96c-17.7 0-32 14.3-32 32v592c0 17.7 14.3 32 32 32h698c13 0 24.8-7.9 29.7-20l134-332c1.5-3.8 2.3-7.9 2.3-12 0-17.7-14.3-32-32-32zM136 256h188.5l119.6 114.4H748V444H238c-13 0-24.8 7.9-29.7 20L136 643.2V256zm635.3 512H159l103.3-256h612.4L771.3 768z'
    ]);
});
exports.FrownTwoTone = getIcon('frown', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zM288 421a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm376 272h-48.1c-4.2 0-7.8-3.2-8.1-7.4C604 636.1 562.5 597 512 597s-92.1 39.1-95.8 88.6c-.3 4.2-3.9 7.4-8.1 7.4H360a8 8 0 0 1-8-8.4c4.4-84.3 74.5-151.6 160-151.6s155.6 67.3 160 151.6a8 8 0 0 1-8 8.4zm24-224a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'
    ], [
        primaryColor,
        'M288 421a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm224 112c-85.5 0-155.6 67.3-160 151.6a8 8 0 0 0 8 8.4h48.1c4.2 0 7.8-3.2 8.1-7.4 3.7-49.5 45.3-88.6 95.8-88.6s92 39.1 95.8 88.6c.3 4.2 3.9 7.4 8.1 7.4H664a8 8 0 0 0 8-8.4C667.6 600.3 597.5 533 512 533zm128-112a48 48 0 1 0 96 0 48 48 0 1 0-96 0z'
    ]);
});
exports.FundTwoTone = getIcon('fund', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136V232h752v560z'
    ], [
        secondaryColor,
        'M136 792h752V232H136v560zm56.4-130.5l214.9-215c3.1-3.1 8.2-3.1 11.3 0L533 561l254.5-254.6c3.1-3.1 8.2-3.1 11.3 0l36.8 36.8c3.1 3.1 3.1 8.2 0 11.3l-297 297.2a8.03 8.03 0 0 1-11.3 0L412.9 537.2 240.4 709.7a8.03 8.03 0 0 1-11.3 0l-36.7-36.9a8.03 8.03 0 0 1 0-11.3z'
    ], [
        primaryColor,
        'M229.1 709.7c3.1 3.1 8.2 3.1 11.3 0l172.5-172.5 114.4 114.5c3.1 3.1 8.2 3.1 11.3 0l297-297.2c3.1-3.1 3.1-8.2 0-11.3l-36.8-36.8a8.03 8.03 0 0 0-11.3 0L533 561 418.6 446.5a8.03 8.03 0 0 0-11.3 0l-214.9 215a8.03 8.03 0 0 0 0 11.3l36.7 36.9z'
    ]);
});
exports.FunnelPlotTwoTone = getIcon('funnel-plot', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M420.6 798h182.9V650H420.6zM297.7 374h428.6l85-148H212.7zm113.2 197.4l8.4 14.6h185.3l8.4-14.6L689.6 438H334.4z'
    ], [
        primaryColor,
        'M880.1 154H143.9c-24.5 0-39.8 26.7-27.5 48L349 607.4V838c0 17.7 14.2 32 31.8 32h262.4c17.6 0 31.8-14.3 31.8-32V607.4L907.7 202c12.2-21.3-3.1-48-27.6-48zM603.5 798H420.6V650h182.9v148zm9.5-226.6l-8.4 14.6H419.3l-8.4-14.6L334.4 438h355.2L613 571.4zM726.3 374H297.7l-85-148h598.6l-85 148z'
    ]);
});
exports.GiftTwoTone = getIcon('gift', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M546 378h298v104H546zM228 550h250v308H228zm-48-172h298v104H180zm366 172h250v308H546z'
    ], [
        primaryColor,
        'M880 310H732.4c13.6-21.4 21.6-46.8 21.6-74 0-76.1-61.9-138-138-138-41.4 0-78.7 18.4-104 47.4-25.3-29-62.6-47.4-104-47.4-76.1 0-138 61.9-138 138 0 27.2 7.9 52.6 21.6 74H144c-17.7 0-32 14.3-32 32v200c0 4.4 3.6 8 8 8h40v344c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V550h40c4.4 0 8-3.6 8-8V342c0-17.7-14.3-32-32-32zM478 858H228V550h250v308zm0-376H180V378h298v104zm0-176h-70c-38.6 0-70-31.4-70-70s31.4-70 70-70 70 31.4 70 70v70zm68-70c0-38.6 31.4-70 70-70s70 31.4 70 70-31.4 70-70 70h-70v-70zm250 622H546V550h250v308zm48-376H546V378h298v104z'
    ]);
});
exports.HddTwoTone = getIcon('hdd', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M232 888h560V680H232v208zm448-140c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zM232 616h560V408H232v208zm72-128c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H312c-4.4 0-8-3.6-8-8v-48zm-72-144h560V136H232v208zm72-128c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H312c-4.4 0-8-3.6-8-8v-48z'
    ], [
        primaryColor,
        'M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V680h560v208zm0-272H232V408h560v208zm0-272H232V136h560v208z'
    ], [
        primaryColor,
        'M312 544h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H312c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0-272h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H312c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm328 516a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'
    ]);
});
exports.HeartTwoTone = getIcon('heart', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M923 283.6a260.04 260.04 0 0 0-56.9-82.8 264.4 264.4 0 0 0-84-55.5A265.34 265.34 0 0 0 679.7 125c-49.3 0-97.4 13.5-139.2 39-10 6.1-19.5 12.8-28.5 20.1-9-7.3-18.5-14-28.5-20.1-41.8-25.5-89.9-39-139.2-39-35.5 0-69.9 6.8-102.4 20.3-31.4 13-59.7 31.7-84 55.5a258.44 258.44 0 0 0-56.9 82.8c-13.9 32.3-21 66.6-21 101.9 0 33.3 6.8 68 20.3 103.3 11.3 29.5 27.5 60.1 48.2 91 32.8 48.9 77.9 99.9 133.9 151.6 92.8 85.7 184.7 144.9 188.6 147.3l23.7 15.2c10.5 6.7 24 6.7 34.5 0l23.7-15.2c3.9-2.5 95.7-61.6 188.6-147.3 56-51.7 101.1-102.7 133.9-151.6 20.7-30.9 37-61.5 48.2-91 13.5-35.3 20.3-70 20.3-103.3.1-35.3-7-69.6-20.9-101.9zM512 814.8S156 586.7 156 385.5C156 283.6 240.3 201 344.3 201c73.1 0 136.5 40.8 167.7 100.4C543.2 241.8 606.6 201 679.7 201c104 0 188.3 82.6 188.3 184.5 0 201.2-356 429.3-356 429.3z'
    ], [
        secondaryColor,
        'M679.7 201c-73.1 0-136.5 40.8-167.7 100.4C480.8 241.8 417.4 201 344.3 201c-104 0-188.3 82.6-188.3 184.5 0 201.2 356 429.3 356 429.3s356-228.1 356-429.3C868 283.6 783.7 201 679.7 201z'
    ]);
});
exports.HighlightTwoTone = getIcon('highlight', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M229.6 796.3h160.2l54.3-54.1-80.1-78.9zm220.7-397.1l262.8 258.9 147.3-145-262.8-259zm-77.1 166.1l171.4 168.9 68.6-67.6-171.4-168.9z'
    ], [
        primaryColor,
        'M957.6 507.5L603.2 158.3a7.9 7.9 0 0 0-11.2 0L353.3 393.5a8.03 8.03 0 0 0-.1 11.3l.1.1 40 39.4-117.2 115.3a8.03 8.03 0 0 0-.1 11.3l.1.1 39.5 38.9-189.1 187H72.1c-4.4 0-8.1 3.6-8.1 8v55.2c0 4.4 3.6 8 8 8h344.9c2.1 0 4.1-.8 5.6-2.3l76.1-75.6L539 830a7.9 7.9 0 0 0 11.2 0l117.1-115.6 40.1 39.5a7.9 7.9 0 0 0 11.2 0l238.7-235.2c3.4-3 3.4-8 .3-11.2zM389.8 796.3H229.6l134.4-133 80.1 78.9-54.3 54.1zm154.8-62.1L373.2 565.3l68.6-67.6 171.4 168.9-68.6 67.6zm168.5-76.1L450.3 399.2l147.3-145.1 262.8 259-147.3 145z'
    ]);
});
exports.HomeTwoTone = getIcon('home', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M512.1 172.6l-370 369.7h96V868H392V640c0-22.1 17.9-40 40-40h160c22.1 0 40 17.9 40 40v228h153.9V542.3H882L535.2 195.7l-23.1-23.1zm434.5 422.9c-6 6-13.1 10.8-20.8 13.9 7.7-3.2 14.8-7.9 20.8-13.9zm-887-34.7c5 30.3 31.4 53.5 63.1 53.5h.9c-31.9 0-58.9-23-64-53.5zm-.9-10.5v-1.9 1.9zm.1-2.6c.1-3.1.5-6.1 1-9.1-.6 2.9-.9 6-1 9.1z'
    ], [
        primaryColor,
        'M951 510c0-.1-.1-.1-.1-.2l-1.8-2.1c-.1-.1-.2-.3-.4-.4-.7-.8-1.5-1.6-2.2-2.4L560.1 118.8l-25.9-25.9a31.5 31.5 0 0 0-44.4 0L77.5 505a63.6 63.6 0 0 0-16 26.6l-.6 2.1-.3 1.1-.3 1.2c-.2.7-.3 1.4-.4 2.1 0 .1 0 .3-.1.4-.6 3-.9 6-1 9.1v3.3c0 .5 0 1 .1 1.5 0 .5 0 .9.1 1.4 0 .5.1 1 .1 1.5 0 .6.1 1.2.2 1.8 0 .3.1.6.1.9l.3 2.5v.1c5.1 30.5 32.2 53.5 64 53.5h42.5V940h691.7V614.3h43.4c8.6 0 16.9-1.7 24.5-4.9s14.7-7.9 20.8-13.9a63.6 63.6 0 0 0 18.7-45.3c0-14.7-5-28.8-14.3-40.2zM568 868H456V664h112v204zm217.9-325.7V868H632V640c0-22.1-17.9-40-40-40H432c-22.1 0-40 17.9-40 40v228H238.1V542.3h-96l370-369.7 23.1 23.1L882 542.3h-96.1z'
    ]);
});
exports.HourglassTwoTone = getIcon('hourglass', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M512 548c-42.2 0-81.9 16.4-111.7 46.3A156.63 156.63 0 0 0 354 706v134h316V706c0-42.2-16.4-81.9-46.3-111.7A156.63 156.63 0 0 0 512 548zM354 318c0 42.2 16.4 81.9 46.3 111.7C430.1 459.6 469.8 476 512 476s81.9-16.4 111.7-46.3C653.6 399.9 670 360.2 670 318V184H354v134z'
    ], [
        primaryColor,
        'M742 318V184h86c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8H196c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h86v134c0 81.5 42.4 153.2 106.4 194-64 40.8-106.4 112.5-106.4 194v134h-86c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h632c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-86V706c0-81.5-42.4-153.2-106.4-194 64-40.8 106.4-112.5 106.4-194zm-72 388v134H354V706c0-42.2 16.4-81.9 46.3-111.7C430.1 564.4 469.8 548 512 548s81.9 16.4 111.7 46.3C653.6 624.1 670 663.8 670 706zm0-388c0 42.2-16.4 81.9-46.3 111.7C593.9 459.6 554.2 476 512 476s-81.9-16.4-111.7-46.3A156.63 156.63 0 0 1 354 318V184h316v134z'
    ]);
});
exports.Html5TwoTone = getIcon('html5', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M145 96l66 746.6L511.8 928l299.6-85.4L878.7 96H145zm610.9 700.6l-244.1 69.6-245.2-69.6-56.7-641.2h603.8l-57.8 641.2z'
    ], [
        secondaryColor,
        'M209.9 155.4l56.7 641.2 245.2 69.6 244.1-69.6 57.8-641.2H209.9zm530.4 117.9l-4.8 47.2-1.7 19.5H381.7l8.2 94.2H511v-.2h214.7l-3.2 24.3-21.2 242.2-1.7 16.3-187.7 51.7v.4h-1.7l-188.6-52-11.3-144.7h91l6.5 73.2 102.4 27.7h.8v-.2l102.4-27.7 11.4-118.5H511.9v.1H305.4l-22.7-253.5L281 249h461l-1.7 24.3z'
    ], [
        primaryColor,
        'M281 249l1.7 24.3 22.7 253.5h206.5v-.1h112.9l-11.4 118.5L511 672.9v.2h-.8l-102.4-27.7-6.5-73.2h-91l11.3 144.7 188.6 52h1.7v-.4l187.7-51.7 1.7-16.3 21.2-242.2 3.2-24.3H511v.2H389.9l-8.2-94.2h352.1l1.7-19.5 4.8-47.2L742 249H511z'
    ]);
});
exports.IdcardTwoTone = getIcon('idcard', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136V232h752v560z'
    ], [
        secondaryColor,
        'M136 792h752V232H136v560zm472-372c0-4.4 1-8 2.3-8h123.4c1.3 0 2.3 3.6 2.3 8v48c0 4.4-1 8-2.3 8H610.3c-1.3 0-2.3-3.6-2.3-8v-48zm0 144c0-4.4 3.2-8 7.1-8h185.7c3.9 0 7.1 3.6 7.1 8v48c0 4.4-3.2 8-7.1 8H615.1c-3.9 0-7.1-3.6-7.1-8v-48zM216.2 664.6c2.8-53.3 31.9-99.6 74.6-126.1-18.1-20-29.1-46.4-29.1-75.5 0-61.9 49.9-112 111.4-112s111.4 50.1 111.4 112c0 29.1-11 55.6-29.1 75.5 42.6 26.4 71.8 72.8 74.6 126.1a8 8 0 0 1-8 8.4h-43.9c-4.2 0-7.6-3.3-7.9-7.5-3.8-50.5-46-90.5-97.2-90.5s-93.4 40-97.2 90.5c-.3 4.2-3.7 7.5-7.9 7.5H224c-4.6 0-8.2-3.8-7.8-8.4z'
    ], [
        secondaryColor,
        'M321.3 463a51.7 52 0 1 0 103.4 0 51.7 52 0 1 0-103.4 0z'
    ], [
        primaryColor,
        'M610.3 476h123.4c1.3 0 2.3-3.6 2.3-8v-48c0-4.4-1-8-2.3-8H610.3c-1.3 0-2.3 3.6-2.3 8v48c0 4.4 1 8 2.3 8zm4.8 144h185.7c3.9 0 7.1-3.6 7.1-8v-48c0-4.4-3.2-8-7.1-8H615.1c-3.9 0-7.1 3.6-7.1 8v48c0 4.4 3.2 8 7.1 8zM224 673h43.9c4.2 0 7.6-3.3 7.9-7.5 3.8-50.5 46-90.5 97.2-90.5s93.4 40 97.2 90.5c.3 4.2 3.7 7.5 7.9 7.5H522a8 8 0 0 0 8-8.4c-2.8-53.3-32-99.7-74.6-126.1a111.8 111.8 0 0 0 29.1-75.5c0-61.9-49.9-112-111.4-112s-111.4 50.1-111.4 112c0 29.1 11 55.5 29.1 75.5a158.09 158.09 0 0 0-74.6 126.1c-.4 4.6 3.2 8.4 7.8 8.4zm149-262c28.5 0 51.7 23.3 51.7 52s-23.2 52-51.7 52-51.7-23.3-51.7-52 23.2-52 51.7-52z'
    ]);
});
exports.InfoCircleTwoTone = getIcon('info-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm32 588c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V456c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v272zm-32-344a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'
    ], [
        primaryColor,
        'M464 336a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm72 112h-48c-4.4 0-8 3.6-8 8v272c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V456c0-4.4-3.6-8-8-8z'
    ]);
});
exports.InsuranceTwoTone = getIcon('insurance', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z'
    ], [secondaryColor, 'M521.9 358.8h97.9v41.6h-97.9z'], [
        secondaryColor,
        'M214 226.7v427.6l298 232.2 298-232.2V226.7L512 125.1 214 226.7zM413.3 656h-.2c0 4.4-3.6 8-8 8h-37.3c-4.4 0-8-3.6-8-8V471.4c-7.7 9.2-15.4 17.9-23.1 26a6.04 6.04 0 0 1-10.2-2.4l-13.2-43.5c-.6-2-.2-4.1 1.2-5.6 37-43.4 64.7-95.1 82.2-153.6 1.1-3.5 5-5.3 8.4-3.7l38.6 18.3c2.7 1.3 4.1 4.4 3.2 7.2a429.2 429.2 0 0 1-33.6 79V656zm257.9-340v127.2c0 4.4-3.6 8-8 8h-66.7v18.6h98.8c4.4 0 8 3.6 8 8v35.6c0 4.4-3.6 8-8 8h-59c18.1 29.1 41.8 54.3 72.3 76.9 2.6 2.1 3.2 5.9 1.2 8.5l-26.3 35.3a5.92 5.92 0 0 1-8.9.7c-30.6-29.3-56.8-65.2-78.1-106.9V656c0 4.4-3.6 8-8 8h-36.2c-4.4 0-8-3.6-8-8V536c-22 44.7-49 80.8-80.6 107.6a6.38 6.38 0 0 1-4.8 1.4c-1.7-.3-3.2-1.3-4.1-2.8L432 605.7a6 6 0 0 1 1.6-8.1c28.6-20.3 51.9-45.2 71-76h-55.1c-4.4 0-8-3.6-8-8V478c0-4.4 3.6-8 8-8h94.9v-18.6h-65.9c-4.4 0-8-3.6-8-8V316c0-4.4 3.6-8 8-8h184.7c4.4 0 8 3.6 8 8z'
    ], [
        primaryColor,
        'M443.7 306.9l-38.6-18.3c-3.4-1.6-7.3.2-8.4 3.7-17.5 58.5-45.2 110.2-82.2 153.6a5.7 5.7 0 0 0-1.2 5.6l13.2 43.5c1.4 4.5 7 5.8 10.2 2.4 7.7-8.1 15.4-16.8 23.1-26V656c0 4.4 3.6 8 8 8h37.3c4.4 0 8-3.6 8-8h.2V393.1a429.2 429.2 0 0 0 33.6-79c.9-2.8-.5-5.9-3.2-7.2zm26.8 9.1v127.4c0 4.4 3.6 8 8 8h65.9V470h-94.9c-4.4 0-8 3.6-8 8v35.6c0 4.4 3.6 8 8 8h55.1c-19.1 30.8-42.4 55.7-71 76a6 6 0 0 0-1.6 8.1l22.8 36.5c.9 1.5 2.4 2.5 4.1 2.8 1.7.3 3.5-.2 4.8-1.4 31.6-26.8 58.6-62.9 80.6-107.6v120c0 4.4 3.6 8 8 8h36.2c4.4 0 8-3.6 8-8V535.9c21.3 41.7 47.5 77.6 78.1 106.9 2.6 2.5 6.7 2.2 8.9-.7l26.3-35.3c2-2.6 1.4-6.4-1.2-8.5-30.5-22.6-54.2-47.8-72.3-76.9h59c4.4 0 8-3.6 8-8v-35.6c0-4.4-3.6-8-8-8h-98.8v-18.6h66.7c4.4 0 8-3.6 8-8V316c0-4.4-3.6-8-8-8H478.5c-4.4 0-8 3.6-8 8zm51.4 42.8h97.9v41.6h-97.9v-41.6z'
    ]);
});
exports.InteractionTwoTone = getIcon('interaction', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
    ], [
        secondaryColor,
        'M184 840h656V184H184v656zm114-401.9c0-55.3 44.6-100.1 99.7-100.1h205.8v-53.4c0-5.6 6.5-8.8 10.9-5.3L723.5 365c3.5 2.7 3.5 8 0 10.7l-109.1 85.7c-4.4 3.5-10.9.4-10.9-5.3v-53.4H397.8c-19.6 0-35.5 15.9-35.5 35.6v78.9c0 3.8-3.1 6.8-6.8 6.8h-50.7c-3.8 0-6.8-3-6.8-7v-78.9zm2.6 210.3l109.1-85.7c4.4-3.5 10.9-.4 10.9 5.3v53.4h205.6c19.6 0 35.5-15.9 35.5-35.6v-78.9c0-3.8 3.1-6.8 6.8-6.8h50.7c3.8 0 6.8 3.1 6.8 6.8v78.9c0 55.3-44.6 100.1-99.7 100.1H420.6v53.4c0 5.6-6.5 8.8-10.9 5.3l-109.1-85.7c-3.5-2.7-3.5-8 0-10.5z'
    ], [
        primaryColor,
        'M304.8 524h50.7c3.7 0 6.8-3 6.8-6.8v-78.9c0-19.7 15.9-35.6 35.5-35.6h205.7v53.4c0 5.7 6.5 8.8 10.9 5.3l109.1-85.7c3.5-2.7 3.5-8 0-10.7l-109.1-85.7c-4.4-3.5-10.9-.3-10.9 5.3V338H397.7c-55.1 0-99.7 44.8-99.7 100.1V517c0 4 3 7 6.8 7zm-4.2 134.9l109.1 85.7c4.4 3.5 10.9.3 10.9-5.3v-53.4h205.7c55.1 0 99.7-44.8 99.7-100.1v-78.9c0-3.7-3-6.8-6.8-6.8h-50.7c-3.7 0-6.8 3-6.8 6.8v78.9c0 19.7-15.9 35.6-35.5 35.6H420.6V568c0-5.7-6.5-8.8-10.9-5.3l-109.1 85.7c-3.5 2.5-3.5 7.8 0 10.5z'
    ]);
});
exports.InterationTwoTone = getIcon('interation', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
    ], [
        secondaryColor,
        'M184 840h656V184H184v656zm114-401.9c0-55.3 44.6-100.1 99.7-100.1h205.8v-53.4c0-5.6 6.5-8.8 10.9-5.3L723.5 365c3.5 2.7 3.5 8 0 10.7l-109.1 85.7c-4.4 3.5-10.9.4-10.9-5.3v-53.4H397.8c-19.6 0-35.5 15.9-35.5 35.6v78.9c0 3.8-3.1 6.8-6.8 6.8h-50.7c-3.8 0-6.8-3-6.8-7v-78.9zm2.6 210.3l109.1-85.7c4.4-3.5 10.9-.4 10.9 5.3v53.4h205.6c19.6 0 35.5-15.9 35.5-35.6v-78.9c0-3.8 3.1-6.8 6.8-6.8h50.7c3.8 0 6.8 3.1 6.8 6.8v78.9c0 55.3-44.6 100.1-99.7 100.1H420.6v53.4c0 5.6-6.5 8.8-10.9 5.3l-109.1-85.7c-3.5-2.7-3.5-8 0-10.5z'
    ], [
        primaryColor,
        'M304.8 524h50.7c3.7 0 6.8-3 6.8-6.8v-78.9c0-19.7 15.9-35.6 35.5-35.6h205.7v53.4c0 5.7 6.5 8.8 10.9 5.3l109.1-85.7c3.5-2.7 3.5-8 0-10.7l-109.1-85.7c-4.4-3.5-10.9-.3-10.9 5.3V338H397.7c-55.1 0-99.7 44.8-99.7 100.1V517c0 4 3 7 6.8 7zm-4.2 134.9l109.1 85.7c4.4 3.5 10.9.3 10.9-5.3v-53.4h205.7c55.1 0 99.7-44.8 99.7-100.1v-78.9c0-3.7-3-6.8-6.8-6.8h-50.7c-3.7 0-6.8 3-6.8 6.8v78.9c0 19.7-15.9 35.6-35.5 35.6H420.6V568c0-5.7-6.5-8.8-10.9-5.3l-109.1 85.7c-3.5 2.5-3.5 7.8 0 10.5z'
    ]);
});
exports.LayoutTwoTone = getIcon('layout', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M384 185h456v136H384zm-200 0h136v656H184zm696-73H144c-17.7 0-32 14.3-32 32v1c0-17.7 14.3-32 32-32h736c17.7 0 32 14.3 32 32v-1c0-17.7-14.3-32-32-32zM384 385h456v456H384z'
    ], [
        primaryColor,
        'M880 113H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V145c0-17.7-14.3-32-32-32zM320 841H184V185h136v656zm520 0H384V385h456v456zm0-520H384V185h456v136z'
    ]);
});
exports.LeftCircleTwoTone = getIcon('left-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm104 240.9c0 10.3-4.9 19.9-13.2 25.9L457.4 512l145.4 105.1c8.3 6 13.2 15.7 13.2 25.9v46.9c0 6.5-7.4 10.3-12.7 6.5l-246-178a7.95 7.95 0 0 1 0-12.9l246-178c5.3-3.8 12.7 0 12.7 6.5v46.9z'
    ], [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        primaryColor,
        'M603.3 327.5l-246 178a7.95 7.95 0 0 0 0 12.9l246 178c5.3 3.8 12.7 0 12.7-6.5V643c0-10.2-4.9-19.9-13.2-25.9L457.4 512l145.4-105.2c8.3-6 13.2-15.6 13.2-25.9V334c0-6.5-7.4-10.3-12.7-6.5z'
    ]);
});
exports.LeftSquareTwoTone = getIcon('left-square', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
    ], [
        secondaryColor,
        'M184 840h656V184H184v656zm181.3-334.5l246-178c5.3-3.8 12.7 0 12.7 6.5v46.9c0 10.3-4.9 19.9-13.2 25.9L465.4 512l145.4 105.2c8.3 6 13.2 15.7 13.2 25.9V690c0 6.5-7.4 10.3-12.7 6.4l-246-178a7.95 7.95 0 0 1 0-12.9z'
    ], [
        primaryColor,
        'M365.3 518.4l246 178c5.3 3.9 12.7.1 12.7-6.4v-46.9c0-10.2-4.9-19.9-13.2-25.9L465.4 512l145.4-105.2c8.3-6 13.2-15.6 13.2-25.9V334c0-6.5-7.4-10.3-12.7-6.5l-246 178a7.95 7.95 0 0 0 0 12.9z'
    ]);
});
exports.LikeTwoTone = getIcon('like', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M273 495.9v428l.3-428zm538.2-88.3H496.8l9.6-198.4c.6-11.9-4.7-23.1-14.6-30.5-6.1-4.5-13.6-6.8-21.1-6.7-19.6.1-36.9 13.4-42.2 32.3-37.1 134.4-64.9 235.2-83.5 302.5V852h399.4a56.85 56.85 0 0 0 33.6-51.8c0-9.7-2.3-18.9-6.9-27.3l-13.9-25.4 21.9-19a56.76 56.76 0 0 0 19.6-43c0-9.7-2.3-18.9-6.9-27.3l-13.9-25.4 21.9-19a56.76 56.76 0 0 0 19.6-43c0-9.7-2.3-18.9-6.9-27.3l-14-25.5 21.9-19a56.76 56.76 0 0 0 19.6-43c0-19.1-11-37.5-28.8-48.4z'
    ], [
        primaryColor,
        'M112 528v364c0 17.7 14.3 32 32 32h65V496h-65c-17.7 0-32 14.3-32 32zm773.9 5.7c16.8-22.2 26.1-49.4 26.1-77.7 0-44.9-25.1-87.5-65.5-111a67.67 67.67 0 0 0-34.3-9.3H572.3l6-122.9c1.5-29.7-9-57.9-29.5-79.4a106.4 106.4 0 0 0-77.9-33.4c-52 0-98 35-111.8 85.1l-85.8 310.8-.3 428h472.1c9.3 0 18.2-1.8 26.5-5.4 47.6-20.3 78.3-66.8 78.3-118.4 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37 16.8-22.2 26.1-49.4 26.1-77.7 0-12.6-1.8-25-5.4-37zM820.4 499l-21.9 19 14 25.5a56.2 56.2 0 0 1 6.9 27.3c0 16.5-7.1 32.2-19.6 43l-21.9 19 13.9 25.4a56.2 56.2 0 0 1 6.9 27.3c0 16.5-7.1 32.2-19.6 43l-21.9 19 13.9 25.4a56.2 56.2 0 0 1 6.9 27.3c0 22.4-13.2 42.6-33.6 51.8H345V506.8c18.6-67.2 46.4-168 83.5-302.5a44.28 44.28 0 0 1 42.2-32.3c7.5-.1 15 2.2 21.1 6.7 9.9 7.4 15.2 18.6 14.6 30.5l-9.6 198.4h314.4C829 418.5 840 436.9 840 456c0 16.5-7.1 32.2-19.6 43z'
    ]);
});
exports.LockTwoTone = getIcon('lock', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M832 464h-68V240c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zM332 240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v224H332V240zm460 600H232V536h560v304z'
    ], [
        secondaryColor,
        'M232 840h560V536H232v304zm280-226a48.01 48.01 0 0 1 28 87v53c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-53a48.01 48.01 0 0 1 28-87z'
    ], [
        primaryColor,
        'M484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 1 0-56 0z'
    ]);
});
exports.MailTwoTone = getIcon('mail', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M477.5 536.3L135.9 270.7l-27.5-21.4 27.6 21.5V792h752V270.8L546.2 536.3a55.99 55.99 0 0 1-68.7 0z'
    ], [secondaryColor, 'M876.3 198.8l39.3 50.5-27.6 21.5 27.7-21.5-39.3-50.5z'], [
        primaryColor,
        'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-94.5 72.1L512 482 190.5 232.1h643zm54.5 38.7V792H136V270.8l-27.6-21.5 27.5 21.4 341.6 265.6a55.99 55.99 0 0 0 68.7 0L888 270.8l27.6-21.5-39.3-50.5h.1l39.3 50.5-27.7 21.5z'
    ]);
});
exports.MedicineBoxTwoTone = getIcon('medicine-box', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M244.3 328L184 513.4V840h656V513.4L779.7 328H244.3zM660 628c0 4.4-3.6 8-8 8H544v108c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V636H372c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h108V464c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v108h108c4.4 0 8 3.6 8 8v48z'
    ], [
        primaryColor,
        'M652 572H544V464c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v108H372c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h108v108c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V636h108c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z'
    ], [
        primaryColor,
        'M839.2 278.1a32 32 0 0 0-30.4-22.1H736V144c0-17.7-14.3-32-32-32H320c-17.7 0-32 14.3-32 32v112h-72.8a31.9 31.9 0 0 0-30.4 22.1L112 502v378c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V502l-72.8-223.9zM360 184h304v72H360v-72zm480 656H184V513.4L244.3 328h535.4L840 513.4V840z'
    ]);
});
exports.MehTwoTone = getIcon('meh', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zM288 421a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm384 200c0 4.4-3.6 8-8 8H360c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h304c4.4 0 8 3.6 8 8v48zm16-152a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'
    ], [
        primaryColor,
        'M288 421a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm376 144H360c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h304c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm-24-144a48 48 0 1 0 96 0 48 48 0 1 0-96 0z'
    ]);
});
exports.MessageTwoTone = getIcon('message', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M775.3 248.9a369.62 369.62 0 0 0-119-80A370.2 370.2 0 0 0 512.1 140h-1.7c-99.7.4-193 39.4-262.8 109.9-69.9 70.5-108 164.1-107.6 263.8.3 60.3 15.3 120.2 43.5 173.1l4.5 8.4V836h140.8l8.4 4.5c52.9 28.2 112.8 43.2 173.1 43.5h1.7c99 0 192-38.2 262.1-107.6 70.4-69.8 109.5-163.1 110.1-262.7.2-50.6-9.5-99.6-28.9-145.8a370.15 370.15 0 0 0-80-119zM312 560a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96zm200 0a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96zm200 0a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'
    ], [
        primaryColor,
        'M664 512a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm-400 0a48 48 0 1 0 96 0 48 48 0 1 0-96 0z'
    ], [
        primaryColor,
        'M925.2 338.4c-22.6-53.7-55-101.9-96.3-143.3a444.35 444.35 0 0 0-143.3-96.3C630.6 75.7 572.2 64 512 64h-2c-60.6.3-119.3 12.3-174.5 35.9a445.35 445.35 0 0 0-142 96.5c-40.9 41.3-73 89.3-95.2 142.8-23 55.4-34.6 114.3-34.3 174.9A449.4 449.4 0 0 0 112 714v152a46 46 0 0 0 46 46h152.1A449.4 449.4 0 0 0 510 960h2.1c59.9 0 118-11.6 172.7-34.3a444.48 444.48 0 0 0 142.8-95.2c41.3-40.9 73.8-88.7 96.5-142 23.6-55.2 35.6-113.9 35.9-174.5.3-60.9-11.5-120-34.8-175.6zm-151.1 438C704 845.8 611 884 512 884h-1.7c-60.3-.3-120.2-15.3-173.1-43.5l-8.4-4.5H188V695.2l-4.5-8.4C155.3 633.9 140.3 574 140 513.7c-.4-99.7 37.7-193.3 107.6-263.8 69.8-70.5 163.1-109.5 262.8-109.9h1.7c50 0 98.5 9.7 144.2 28.9 44.6 18.7 84.6 45.6 119 80 34.3 34.3 61.3 74.4 80 119 19.4 46.2 29.1 95.2 28.9 145.8-.6 99.6-39.7 192.9-110.1 262.7z'
    ], [primaryColor, 'M464 512a48 48 0 1 0 96 0 48 48 0 1 0-96 0z']);
});
exports.MinusCircleTwoTone = getIcon('minus-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm192 396c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h368c4.4 0 8 3.6 8 8v48z'
    ], [
        primaryColor,
        'M696 480H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z'
    ]);
});
exports.MinusSquareTwoTone = getIcon('minus-square', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
    ], [
        secondaryColor,
        'M184 840h656V184H184v656zm136-352c0-4.4 3.6-8 8-8h368c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H328c-4.4 0-8-3.6-8-8v-48z'
    ], [
        primaryColor,
        'M328 544h368c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z'
    ]);
});
exports.MobileTwoTone = getIcon('mobile', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M744 64H280c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h464c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zm-8 824H288V136h448v752z'
    ], [
        secondaryColor,
        'M288 888h448V136H288v752zm224-142c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z'
    ], [primaryColor, 'M472 786a40 40 0 1 0 80 0 40 40 0 1 0-80 0z']);
});
exports.PauseCircleTwoTone = getIcon('pause-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm-80 524c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V360c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v304zm224 0c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V360c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v304z'
    ], [
        primaryColor,
        'M424 352h-48c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8zm224 0h-48c-4.4 0-8 3.6-8 8v304c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V360c0-4.4-3.6-8-8-8z'
    ]);
});
exports.MoneyCollectTwoTone = getIcon('money-collect', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M256 744.4l256 93.1 256-93.1V184H256v560.4zM359.7 313c1.2-.7 2.5-1 3.8-1h55.7a8 8 0 0 1 7.1 4.4L511 485.2h3.3L599 316.4c1.3-2.7 4.1-4.4 7.1-4.4h54.5c4.4 0 8 3.6 8.1 7.9 0 1.3-.4 2.6-1 3.8L564 515.3h57.6c4.4 0 8 3.6 8 8v27.1c0 4.4-3.6 8-8 8h-76.3v39h76.3c4.4 0 8 3.6 8 8v27.1c0 4.4-3.6 8-8 8h-76.3V704c0 4.4-3.6 8-8 8h-49.9c-4.4 0-8-3.6-8-8v-63.4h-76c-4.4 0-8-3.6-8-8v-27.1c0-4.4 3.6-8 8-8h76v-39h-76c-4.4 0-8-3.6-8-8v-27.1c0-4.4 3.6-8 8-8h57L356.5 323.8c-2.1-3.8-.7-8.7 3.2-10.8z'
    ], [
        primaryColor,
        'M911.5 700.7a8 8 0 0 0-10.3-4.8L840 718.2V180c0-37.6-30.4-68-68-68H252c-37.6 0-68 30.4-68 68v538.2l-61.3-22.3c-.9-.3-1.8-.5-2.7-.5-4.4 0-8 3.6-8 8V763c0 3.3 2.1 6.3 5.3 7.5L501 910.1c7.1 2.6 14.8 2.6 21.9 0l383.8-139.5c3.2-1.2 5.3-4.2 5.3-7.5v-59.6c0-1-.2-1.9-.5-2.8zM768 744.4l-256 93.1-256-93.1V184h512v560.4z'
    ], [
        primaryColor,
        'M460.4 515.4h-57c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76v39h-76c-4.4 0-8 3.6-8 8v27.1c0 4.4 3.6 8 8 8h76V704c0 4.4 3.6 8 8 8h49.9c4.4 0 8-3.6 8-8v-63.5h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8h-76.3v-39h76.3c4.4 0 8-3.6 8-8v-27.1c0-4.4-3.6-8-8-8H564l103.7-191.6c.6-1.2 1-2.5 1-3.8-.1-4.3-3.7-7.9-8.1-7.9h-54.5c-3 0-5.8 1.7-7.1 4.4l-84.7 168.8H511l-84.7-168.8a8 8 0 0 0-7.1-4.4h-55.7c-1.3 0-2.6.3-3.8 1-3.9 2.1-5.3 7-3.2 10.8l103.9 191.6z'
    ]);
});
exports.NotificationTwoTone = getIcon('notification', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M229.6 678.1c-3.7 11.6-5.6 23.9-5.6 36.4 0-12.5 2-24.8 5.7-36.4h-.1zm76.3-260.2H184v188.2h121.9l12.9 5.2L840 820.7V203.3L318.8 412.7z'
    ], [
        primaryColor,
        'M880 112c-3.8 0-7.7.7-11.6 2.3L292 345.9H128c-8.8 0-16 7.4-16 16.6v299c0 9.2 7.2 16.6 16 16.6h101.7c-3.7 11.6-5.7 23.9-5.7 36.4 0 65.9 53.8 119.5 120 119.5 55.4 0 102.1-37.6 115.9-88.4l408.6 164.2c3.9 1.5 7.8 2.3 11.6 2.3 16.9 0 32-14.2 32-33.2V145.2C912 126.2 897 112 880 112zM344 762.3c-26.5 0-48-21.4-48-47.8 0-11.2 3.9-21.9 11-30.4l84.9 34.1c-2 24.6-22.7 44.1-47.9 44.1zm496 58.4L318.8 611.3l-12.9-5.2H184V417.9h121.9l12.9-5.2L840 203.3v617.4z'
    ]);
});
exports.PhoneTwoTone = getIcon('phone', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M721.7 184.9L610.9 295.8l120.8 120.7-8 21.6A481.29 481.29 0 0 1 438 723.9l-21.6 8-.9-.9-119.8-120-110.8 110.9 104.5 104.5c10.8 10.7 26 15.7 40.8 13.2 117.9-19.5 235.4-82.9 330.9-178.4s158.9-213.1 178.4-331c2.5-14.8-2.5-30-13.3-40.8L721.7 184.9z'
    ], [
        primaryColor,
        'M877.1 238.7L770.6 132.3c-13-13-30.4-20.3-48.8-20.3s-35.8 7.2-48.8 20.3L558.3 246.8c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l89.6 89.7a405.46 405.46 0 0 1-86.4 127.3c-36.7 36.9-79.6 66-127.2 86.6l-89.6-89.7c-13-13-30.4-20.3-48.8-20.3a68.2 68.2 0 0 0-48.8 20.3L132.3 673c-13 13-20.3 30.5-20.3 48.9 0 18.5 7.2 35.8 20.3 48.9l106.4 106.4c22.2 22.2 52.8 34.9 84.2 34.9 6.5 0 12.8-.5 19.2-1.6 132.4-21.8 263.8-92.3 369.9-198.3C818 606 888.4 474.6 910.4 342.1c6.3-37.6-6.3-76.3-33.3-103.4zm-37.6 91.5c-19.5 117.9-82.9 235.5-178.4 331s-213 158.9-330.9 178.4c-14.8 2.5-30-2.5-40.8-13.2L184.9 721.9 295.7 611l119.8 120 .9.9 21.6-8a481.29 481.29 0 0 0 285.7-285.8l8-21.6-120.8-120.7 110.8-110.9 104.5 104.5c10.8 10.8 15.8 26 13.3 40.8z'
    ]);
});
exports.PictureTwoTone = getIcon('picture', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M928 160H96c-17.7 0-32 14.3-32 32v640c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V192c0-17.7-14.3-32-32-32zm-40 632H136v-39.9l138.5-164.3 150.1 178L658.1 489 888 761.6V792zm0-129.8L664.2 396.8c-3.2-3.8-9-3.8-12.2 0L424.6 666.4l-144-170.7c-3.2-3.8-9-3.8-12.2 0L136 652.7V232h752v430.2z'
    ], [
        secondaryColor,
        'M424.6 765.8l-150.1-178L136 752.1V792h752v-30.4L658.1 489z'
    ], [
        secondaryColor,
        'M136 652.7l132.4-157c3.2-3.8 9-3.8 12.2 0l144 170.7L652 396.8c3.2-3.8 9-3.8 12.2 0L888 662.2V232H136v420.7zM304 280a88 88 0 1 1 0 176 88 88 0 0 1 0-176z'
    ], [secondaryColor, 'M276 368a28 28 0 1 0 56 0 28 28 0 1 0-56 0z'], [
        primaryColor,
        'M304 456a88 88 0 1 0 0-176 88 88 0 0 0 0 176zm0-116c15.5 0 28 12.5 28 28s-12.5 28-28 28-28-12.5-28-28 12.5-28 28-28z'
    ]);
});
exports.PlayCircleTwoTone = getIcon('play-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm164.1 378.2L457.7 677.1a8.02 8.02 0 0 1-12.7-6.5V353a8 8 0 0 1 12.7-6.5l218.4 158.8a7.9 7.9 0 0 1 0 12.9z'
    ], [
        primaryColor,
        'M676.1 505.3L457.7 346.5A8 8 0 0 0 445 353v317.6a8.02 8.02 0 0 0 12.7 6.5l218.4-158.9a7.9 7.9 0 0 0 0-12.9z'
    ]);
});
exports.PlaySquareTwoTone = getIcon('play-square', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
    ], [
        secondaryColor,
        'M184 840h656V184H184v656zm240-484.7c0-9.4 10.9-14.7 18.3-8.8l199.4 156.7a11.2 11.2 0 0 1 0 17.6L442.3 677.6c-7.4 5.8-18.3.6-18.3-8.8V355.3z'
    ], [
        primaryColor,
        'M442.3 677.6l199.4-156.8a11.2 11.2 0 0 0 0-17.6L442.3 346.5c-7.4-5.9-18.3-.6-18.3 8.8v313.5c0 9.4 10.9 14.6 18.3 8.8z'
    ]);
});
exports.PieChartTwoTone = getIcon('pie-chart', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M316.2 920.5c-47.6-20.1-90.4-49-127.1-85.7a398.19 398.19 0 0 1-85.7-127.1A397.12 397.12 0 0 1 72 552.2v.2a398.57 398.57 0 0 0 117 282.5c36.7 36.7 79.4 65.5 127 85.6A396.64 396.64 0 0 0 471.6 952c27 0 53.6-2.7 79.7-7.9-25.9 5.2-52.4 7.8-79.3 7.8-54 .1-106.4-10.5-155.8-31.4zM560 472c-4.4 0-8-3.6-8-8V79.9c0-1.3.3-2.5.9-3.6-.9 1.3-1.5 2.9-1.5 4.6v383.7c0 4.4 3.6 8 8 8l383.6-1c1.6 0 3.1-.5 4.4-1.3-1 .5-2.2.7-3.4.7l-384 1z'
    ], [
        secondaryColor,
        'M619.8 147.6v256.6l256.4-.7c-13-62.5-44.3-120.5-90-166.1a332.24 332.24 0 0 0-166.4-89.8z'
    ], [
        secondaryColor,
        'M438 221.7c-75.9 7.6-146.2 40.9-200.8 95.5C174.5 379.9 140 463.3 140 552s34.5 172.1 97.2 234.8c62.3 62.3 145.1 96.8 233.2 97.2 88.2.4 172.7-34.1 235.3-96.2C761 733 794.6 662.3 802.3 586H438V221.7z'
    ], [
        primaryColor,
        'M864 518H506V160c0-4.4-3.6-8-8-8h-26a398.46 398.46 0 0 0-282.8 117.1 398.19 398.19 0 0 0-85.7 127.1A397.61 397.61 0 0 0 72 552v.2c0 53.9 10.6 106.2 31.4 155.5 20.1 47.6 49 90.4 85.7 127.1 36.7 36.7 79.5 65.6 127.1 85.7A397.61 397.61 0 0 0 472 952c26.9 0 53.4-2.6 79.3-7.8 26.1-5.3 51.7-13.1 76.4-23.6 47.6-20.1 90.4-49 127.1-85.7 36.7-36.7 65.6-79.5 85.7-127.1A397.61 397.61 0 0 0 872 552v-26c0-4.4-3.6-8-8-8zM705.7 787.8A331.59 331.59 0 0 1 470.4 884c-88.1-.4-170.9-34.9-233.2-97.2C174.5 724.1 140 640.7 140 552s34.5-172.1 97.2-234.8c54.6-54.6 124.9-87.9 200.8-95.5V586h364.3c-7.7 76.3-41.3 147-96.6 201.8z'
    ], [
        primaryColor,
        'M952 462.4l-2.6-28.2c-8.5-92.1-49.4-179-115.2-244.6A399.4 399.4 0 0 0 589 74.6L560.7 72c-3.4-.3-6.4 1.5-7.8 4.3a8.7 8.7 0 0 0-.9 3.6V464c0 4.4 3.6 8 8 8l384-1c1.2 0 2.3-.3 3.4-.7a8.1 8.1 0 0 0 4.6-7.9zm-332.2-58.2V147.6a332.24 332.24 0 0 1 166.4 89.8c45.7 45.6 77 103.6 90 166.1l-256.4.7z'
    ]);
});
exports.PlusCircleTwoTone = getIcon('plus-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm192 396c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48z'
    ], [
        primaryColor,
        'M696 480H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z'
    ]);
});
exports.PlusSquareTwoTone = getIcon('plus-square', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
    ], [
        secondaryColor,
        'M184 840h656V184H184v656zm136-352c0-4.4 3.6-8 8-8h152V328c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v152h152c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H544v152c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V544H328c-4.4 0-8-3.6-8-8v-48z'
    ], [
        primaryColor,
        'M328 544h152v152c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V544h152c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H544V328c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v152H328c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z'
    ]);
});
exports.PoundCircleTwoTone = getIcon('pound-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm146 582.1c0 4.4-3.6 8-8 8H376.2c-4.4 0-8-3.6-8-8v-38.5c0-3.7 2.5-6.9 6.1-7.8 44-10.9 72.8-49 72.8-94.2 0-14.7-2.5-29.4-5.9-44.2H374c-4.4 0-8-3.6-8-8v-30c0-4.4 3.6-8 8-8h53.7c-7.8-25.1-14.6-50.7-14.6-77.1 0-75.8 58.6-120.3 151.5-120.3 26.5 0 51.4 5.5 70.3 12.7 3.1 1.2 5.2 4.2 5.2 7.5v39.5a8 8 0 0 1-10.6 7.6c-17.9-6.4-39-10.5-60.4-10.5-53.3 0-87.3 26.6-87.3 70.2 0 24.7 6.2 47.9 13.4 70.5h112c4.4 0 8 3.6 8 8v30c0 4.4-3.6 8-8 8h-98.6c3.1 13.2 5.3 26.9 5.3 41 0 40.7-16.5 73.9-43.9 91.1v4.7h180c4.4 0 8 3.6 8 8v39.8z'
    ], [
        primaryColor,
        'M650 674.3H470v-4.7c27.4-17.2 43.9-50.4 43.9-91.1 0-14.1-2.2-27.8-5.3-41h98.6c4.4 0 8-3.6 8-8v-30c0-4.4-3.6-8-8-8h-112c-7.2-22.6-13.4-45.8-13.4-70.5 0-43.6 34-70.2 87.3-70.2 21.4 0 42.5 4.1 60.4 10.5a8 8 0 0 0 10.6-7.6v-39.5c0-3.3-2.1-6.3-5.2-7.5-18.9-7.2-43.8-12.7-70.3-12.7-92.9 0-151.5 44.5-151.5 120.3 0 26.4 6.8 52 14.6 77.1H374c-4.4 0-8 3.6-8 8v30c0 4.4 3.6 8 8 8h67.2c3.4 14.8 5.9 29.5 5.9 44.2 0 45.2-28.8 83.3-72.8 94.2-3.6.9-6.1 4.1-6.1 7.8v38.5c0 4.4 3.6 8 8 8H650c4.4 0 8-3.6 8-8v-39.8c0-4.4-3.6-8-8-8z'
    ]);
});
exports.PrinterTwoTone = getIcon('printer', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M360 180h304v152H360zm492 220H172c-6.6 0-12 5.4-12 12v292h132V500h440v204h132V412c0-6.6-5.4-12-12-12zm-24 84c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-40c0-4.4 3.6-8 8-8h40c4.4 0 8 3.6 8 8v40z'
    ], [
        primaryColor,
        'M852 332H732V120c0-4.4-3.6-8-8-8H300c-4.4 0-8 3.6-8 8v212H172c-44.2 0-80 35.8-80 80v328c0 17.7 14.3 32 32 32h168v132c0 4.4 3.6 8 8 8h424c4.4 0 8-3.6 8-8V772h168c17.7 0 32-14.3 32-32V412c0-44.2-35.8-80-80-80zM360 180h304v152H360V180zm304 664H360V568h304v276zm200-140H732V500H292v204H160V412c0-6.6 5.4-12 12-12h680c6.6 0 12 5.4 12 12v292z'
    ], [
        primaryColor,
        'M820 436h-40c-4.4 0-8 3.6-8 8v40c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-40c0-4.4-3.6-8-8-8z'
    ]);
});
exports.ProfileTwoTone = getIcon('profile', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
    ], [
        secondaryColor,
        'M184 840h656V184H184v656zm300-496c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48zm0 144c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48zm0 144c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H492c-4.4 0-8-3.6-8-8v-48zM380 328c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm0 144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40zm0 144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z'
    ], [
        primaryColor,
        'M340 656a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0-144a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm0-144a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm152 320h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0-144h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8zm0-144h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H492c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z'
    ]);
});
exports.ProjectTwoTone = getIcon('project', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
    ], [
        secondaryColor,
        'M184 840h656V184H184v656zm472-560c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v256c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280zm-192 0c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v184c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280zm-192 0c0-4.4 3.6-8 8-8h80c4.4 0 8 3.6 8 8v464c0 4.4-3.6 8-8 8h-80c-4.4 0-8-3.6-8-8V280z'
    ], [
        primaryColor,
        'M280 752h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v464c0 4.4 3.6 8 8 8zm192-280h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v184c0 4.4 3.6 8 8 8zm192 72h80c4.4 0 8-3.6 8-8V280c0-4.4-3.6-8-8-8h-80c-4.4 0-8 3.6-8 8v256c0 4.4 3.6 8 8 8z'
    ]);
});
exports.PushpinTwoTone = getIcon('pushpin', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M474.8 357.7l-24.5 24.5-34.4-3.8c-9.6-1.1-19.3-1.6-28.9-1.6-29 0-57.5 4.7-84.7 14.1-14 4.8-27.4 10.8-40.3 17.9l353.1 353.3a259.92 259.92 0 0 0 30.4-153.9l-3.8-34.4 24.5-24.5L800 415.5 608.5 224 474.8 357.7z'
    ], [
        primaryColor,
        'M878.3 392.1L631.9 145.7c-6.5-6.5-15-9.7-23.5-9.7s-17 3.2-23.5 9.7L423.8 306.9c-12.2-1.4-24.5-2-36.8-2-73.2 0-146.4 24.1-206.5 72.3a33.23 33.23 0 0 0-2.7 49.4l181.7 181.7-215.4 215.2a15.8 15.8 0 0 0-4.6 9.8l-3.4 37.2c-.9 9.4 6.6 17.4 15.9 17.4.5 0 1 0 1.5-.1l37.2-3.4c3.7-.3 7.2-2 9.8-4.6l215.4-215.4 181.7 181.7c6.5 6.5 15 9.7 23.5 9.7 9.7 0 19.3-4.2 25.9-12.4 56.3-70.3 79.7-158.3 70.2-243.4l161.1-161.1c12.9-12.8 12.9-33.8 0-46.8zM666.2 549.3l-24.5 24.5 3.8 34.4a259.92 259.92 0 0 1-30.4 153.9L262 408.8c12.9-7.1 26.3-13.1 40.3-17.9 27.2-9.4 55.7-14.1 84.7-14.1 9.6 0 19.3.5 28.9 1.6l34.4 3.8 24.5-24.5L608.5 224 800 415.5 666.2 549.3z'
    ]);
});
exports.PropertySafetyTwoTone = getIcon('property-safety', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z'
    ], [
        secondaryColor,
        'M214 226.7v427.6l298 232.2 298-232.2V226.7L512 125.1 214 226.7zM593.9 318h45c5.5 0 10 4.5 10 10 .1 1.7-.3 3.3-1.1 4.8l-87.7 161.1h45.7c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4v29.7h63.4c5.5 0 10 4.5 10 10v21.3c0 5.5-4.5 10-10 10h-63.4V658c0 5.5-4.5 10-10 10h-41.3c-5.5 0-10-4.5-10-10v-51.8H418c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h63.1v-29.7H418c-5.5 0-10-4.5-10-10v-21.3c0-5.5 4.5-10 10-10h45.2l-88-161.1c-2.6-4.8-.9-10.9 4-13.6 1.5-.8 3.1-1.2 4.8-1.2h46c3.8 0 7.2 2.1 8.9 5.5l72.9 144.3L585 323.5a10 10 0 0 1 8.9-5.5z'
    ], [
        primaryColor,
        'M438.9 323.5a9.88 9.88 0 0 0-8.9-5.5h-46c-1.7 0-3.3.4-4.8 1.2-4.9 2.7-6.6 8.8-4 13.6l88 161.1H418c-5.5 0-10 4.5-10 10v21.3c0 5.5 4.5 10 10 10h63.1v29.7H418c-5.5 0-10 4.5-10 10v21.3c0 5.5 4.5 10 10 10h63.1V658c0 5.5 4.5 10 10 10h41.3c5.5 0 10-4.5 10-10v-51.8h63.4c5.5 0 10-4.5 10-10v-21.3c0-5.5-4.5-10-10-10h-63.4v-29.7h63.4c5.5 0 10-4.5 10-10v-21.3c0-5.5-4.5-10-10-10h-45.7l87.7-161.1c.8-1.5 1.2-3.1 1.1-4.8 0-5.5-4.5-10-10-10h-45a10 10 0 0 0-8.9 5.5l-73.2 144.3-72.9-144.3z'
    ]);
});
exports.QuestionCircleTwoTone = getIcon('question-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm0 632c-22.1 0-40-17.9-40-40s17.9-40 40-40 40 17.9 40 40-17.9 40-40 40zm62.9-219.5a48.3 48.3 0 0 0-30.9 44.8V620c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-21.5c0-23.1 6.7-45.9 19.9-64.9 12.9-18.6 30.9-32.8 52.1-40.9 34-13.1 56-41.6 56-72.7 0-44.1-43.1-80-96-80s-96 35.9-96 80v7.6c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V420c0-39.3 17.2-76 48.4-103.3C430.4 290.4 470 276 512 276s81.6 14.5 111.6 40.7C654.8 344 672 380.7 672 420c0 57.8-38.1 109.8-97.1 132.5z'
    ], [
        primaryColor,
        'M472 732a40 40 0 1 0 80 0 40 40 0 1 0-80 0zm151.6-415.3C593.6 290.5 554 276 512 276s-81.6 14.4-111.6 40.7C369.2 344 352 380.7 352 420v7.6c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V420c0-44.1 43.1-80 96-80s96 35.9 96 80c0 31.1-22 59.6-56 72.7-21.2 8.1-39.2 22.3-52.1 40.9-13.2 19-19.9 41.8-19.9 64.9V620c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-22.7a48.3 48.3 0 0 1 30.9-44.8c59-22.7 97.1-74.7 97.1-132.5 0-39.3-17.2-76-48.4-103.3z'
    ]);
});
exports.ReconciliationTwoTone = getIcon('reconciliation', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M740 344H404V240H304v160h176c17.7 0 32 14.3 32 32v360h328V240H740v104zM584 448c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8v56c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-56zm92 301c-50.8 0-92-41.2-92-92s41.2-92 92-92 92 41.2 92 92-41.2 92-92 92zm92-341v96c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8v-96c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8z'
    ], [secondaryColor, 'M642 657a34 34 0 1 0 68 0 34 34 0 1 0-68 0z'], [
        primaryColor,
        'M592 512h48c4.4 0 8-3.6 8-8v-56c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8zm112-104v96c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-96c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8z'
    ], [
        primaryColor,
        'M880 168H668c0-30.9-25.1-56-56-56h-80c-30.9 0-56 25.1-56 56H264c-17.7 0-32 14.3-32 32v200h-88c-17.7 0-32 14.3-32 32v448c0 17.7 14.3 32 32 32h336c17.7 0 32-14.3 32-32v-16h368c17.7 0 32-14.3 32-32V200c0-17.7-14.3-32-32-32zm-412 64h72v-56h64v56h72v48H468v-48zm-20 616H176V616h272v232zm0-296H176v-88h272v88zm392 240H512V432c0-17.7-14.3-32-32-32H304V240h100v104h336V240h100v552z'
    ], [
        primaryColor,
        'M676 565c-50.8 0-92 41.2-92 92s41.2 92 92 92 92-41.2 92-92-41.2-92-92-92zm0 126c-18.8 0-34-15.2-34-34s15.2-34 34-34 34 15.2 34 34-15.2 34-34 34z'
    ]);
});
exports.RedEnvelopeTwoTone = getIcon('red-envelope', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M832 64H192c-17.7 0-32 14.3-32 32v832c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V96c0-17.7-14.3-32-32-32zm-40 824H232V193.1l260.3 204.1c11.6 9.1 27.9 9.1 39.5 0L792 193.1V888zm0-751.3h-31.7L512 331.3 263.7 136.7H232v-.7h560v.7z'
    ], [
        secondaryColor,
        'M492.3 397.2L232 193.1V888h560V193.1L531.8 397.2a31.99 31.99 0 0 1-39.5 0zm99.4 60.9h47.8a8.45 8.45 0 0 1 7.4 12.4l-87.2 161h45.9c4.6 0 8.4 3.8 8.4 8.4V665c0 4.6-3.8 8.4-8.4 8.4h-63.3V702h63.3c4.6 0 8.4 3.8 8.4 8.4v25c.2 4.7-3.5 8.5-8.2 8.5h-63.3v49.9c0 4.6-3.8 8.4-8.4 8.4h-43.7c-4.6 0-8.4-3.8-8.4-8.4v-49.9h-63c-4.6 0-8.4-3.8-8.4-8.4v-25.1c0-4.6 3.8-8.4 8.4-8.4h63v-28.6h-63c-4.6 0-8.4-3.8-8.4-8.4v-25.1c0-4.6 3.8-8.4 8.4-8.4h45.4L377 470.4a8.4 8.4 0 0 1 3.4-11.4c1.3-.6 2.6-1 3.9-1h48.8c3.2 0 6.1 1.8 7.5 4.6l71.7 142 71.9-141.9a8.6 8.6 0 0 1 7.5-4.6z'
    ], [secondaryColor, 'M232 136.7h31.7L512 331.3l248.3-194.6H792v-.7H232z'], [
        primaryColor,
        'M440.6 462.6a8.38 8.38 0 0 0-7.5-4.6h-48.8c-1.3 0-2.6.4-3.9 1a8.4 8.4 0 0 0-3.4 11.4l87.4 161.1H419c-4.6 0-8.4 3.8-8.4 8.4V665c0 4.6 3.8 8.4 8.4 8.4h63V702h-63c-4.6 0-8.4 3.8-8.4 8.4v25.1c0 4.6 3.8 8.4 8.4 8.4h63v49.9c0 4.6 3.8 8.4 8.4 8.4h43.7c4.6 0 8.4-3.8 8.4-8.4v-49.9h63.3c4.7 0 8.4-3.8 8.2-8.5v-25c0-4.6-3.8-8.4-8.4-8.4h-63.3v-28.6h63.3c4.6 0 8.4-3.8 8.4-8.4v-25.1c0-4.6-3.8-8.4-8.4-8.4h-45.9l87.2-161a8.45 8.45 0 0 0-7.4-12.4h-47.8c-3.1 0-6 1.8-7.5 4.6l-71.9 141.9-71.7-142z'
    ]);
});
exports.RestTwoTone = getIcon('rest', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M326.4 844h363.2l44.3-520H282l44.4 520zM508 416c79.5 0 144 64.5 144 144s-64.5 144-144 144-144-64.5-144-144 64.5-144 144-144z'
    ], [
        primaryColor,
        'M508 704c79.5 0 144-64.5 144-144s-64.5-144-144-144-144 64.5-144 144 64.5 144 144 144zm0-224c44.2 0 80 35.8 80 80s-35.8 80-80 80-80-35.8-80-80 35.8-80 80-80z'
    ], [
        primaryColor,
        'M832 256h-28.1l-35.7-120.9c-4-13.7-16.5-23.1-30.7-23.1h-451c-14.3 0-26.8 9.4-30.7 23.1L220.1 256H192c-17.7 0-32 14.3-32 32v28c0 4.4 3.6 8 8 8h45.8l47.7 558.7a32 32 0 0 0 31.9 29.3h429.2a32 32 0 0 0 31.9-29.3L802.2 324H856c4.4 0 8-3.6 8-8v-28c0-17.7-14.3-32-32-32zm-518.6-76h397.2l22.4 76H291l22.4-76zm376.2 664H326.4L282 324h451.9l-44.3 520z'
    ]);
});
exports.RightCircleTwoTone = getIcon('right-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm154.7 378.4l-246 178c-5.3 3.8-12.7 0-12.7-6.5V643c0-10.2 4.9-19.9 13.2-25.9L566.6 512 421.2 406.8c-8.3-6-13.2-15.6-13.2-25.9V334c0-6.5 7.4-10.3 12.7-6.5l246 178c4.4 3.2 4.4 9.7 0 12.9z'
    ], [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        primaryColor,
        'M666.7 505.5l-246-178c-5.3-3.8-12.7 0-12.7 6.5v46.9c0 10.3 4.9 19.9 13.2 25.9L566.6 512 421.2 617.1c-8.3 6-13.2 15.7-13.2 25.9v46.9c0 6.5 7.4 10.3 12.7 6.5l246-178c4.4-3.2 4.4-9.7 0-12.9z'
    ]);
});
exports.RocketTwoTone = getIcon('rocket', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M261.7 621.4c-9.4 14.6-17 30.3-22.5 46.6H324V558.7c-24.8 16.2-46 37.5-62.3 62.7zM700 558.7V668h84.8c-5.5-16.3-13.1-32-22.5-46.6a211.6 211.6 0 0 0-62.3-62.7zm-64-239.9l-124-147-124 147V668h248V318.8zM512 448a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'
    ], [
        primaryColor,
        'M864 736c0-111.6-65.4-208-160-252.9V317.3c0-15.1-5.3-29.7-15.1-41.2L536.5 95.4C530.1 87.8 521 84 512 84s-18.1 3.8-24.5 11.4L335.1 276.1a63.97 63.97 0 0 0-15.1 41.2v165.8C225.4 528 160 624.4 160 736h156.5c-2.3 7.2-3.5 15-3.5 23.8 0 22.1 7.6 43.7 21.4 60.8a97.2 97.2 0 0 0 43.1 30.6c23.1 54 75.6 88.8 134.5 88.8 29.1 0 57.3-8.6 81.4-24.8 23.6-15.8 41.9-37.9 53-64a97 97 0 0 0 43.1-30.5 97.52 97.52 0 0 0 21.4-60.8c0-8.4-1.1-16.4-3.1-23.8L864 736zm-540-68h-84.8c5.5-16.3 13.1-32 22.5-46.6 16.3-25.2 37.5-46.5 62.3-62.7V668zm64-184.9V318.8l124-147 124 147V668H388V483.1zm240.1 301.1c-5.2 3-11.2 4.2-17.1 3.4l-19.5-2.4-2.8 19.4c-5.4 37.9-38.4 66.5-76.7 66.5s-71.3-28.6-76.7-66.5l-2.8-19.5-19.5 2.5a27.7 27.7 0 0 1-17.1-3.5c-8.7-5-14.1-14.3-14.1-24.4 0-10.6 5.9-19.4 14.6-23.8h231.3c8.8 4.5 14.6 13.3 14.6 23.8-.1 10.2-5.5 19.6-14.2 24.5zM700 668V558.7a211.6 211.6 0 0 1 62.3 62.7c9.4 14.6 17 30.3 22.5 46.6H700z'
    ], [primaryColor, 'M464 400a48 48 0 1 0 96 0 48 48 0 1 0-96 0z']);
});
exports.RightSquareTwoTone = getIcon('right-square', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
    ], [
        secondaryColor,
        'M184 840h656V184H184v656zm216-196.9c0-10.2 4.9-19.9 13.2-25.9L558.6 512 413.2 406.8c-8.3-6-13.2-15.6-13.2-25.9V334c0-6.5 7.4-10.3 12.7-6.5l246 178c4.4 3.2 4.4 9.7 0 12.9l-246 178c-5.3 3.9-12.7.1-12.7-6.4v-46.9z'
    ], [
        primaryColor,
        'M412.7 696.4l246-178c4.4-3.2 4.4-9.7 0-12.9l-246-178c-5.3-3.8-12.7 0-12.7 6.5v46.9c0 10.3 4.9 19.9 13.2 25.9L558.6 512 413.2 617.2c-8.3 6-13.2 15.7-13.2 25.9V690c0 6.5 7.4 10.3 12.7 6.4z'
    ]);
});
exports.SafetyCertificateTwoTone = getIcon('safety-certificate', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z'
    ], [
        secondaryColor,
        'M214 226.7v427.6l298 232.2 298-232.2V226.7L512 125.1 214 226.7zM632.8 328H688c6.5 0 10.3 7.4 6.5 12.7L481.9 633.4a16.1 16.1 0 0 1-26 0l-126.4-174c-3.8-5.3 0-12.7 6.5-12.7h55.2c5.2 0 10 2.5 13 6.6l64.7 89.1 150.9-207.8c3-4.1 7.9-6.6 13-6.6z'
    ], [
        primaryColor,
        'M404.2 453.3c-3-4.1-7.8-6.6-13-6.6H336c-6.5 0-10.3 7.4-6.5 12.7l126.4 174a16.1 16.1 0 0 0 26 0l212.6-292.7c3.8-5.3 0-12.7-6.5-12.7h-55.2c-5.1 0-10 2.5-13 6.6L468.9 542.4l-64.7-89.1z'
    ]);
});
exports.SaveTwoTone = getIcon('save', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M704 320c0 17.7-14.3 32-32 32H352c-17.7 0-32-14.3-32-32V184H184v656h656V341.8l-136-136V320zM512 730c-79.5 0-144-64.5-144-144s64.5-144 144-144 144 64.5 144 144-64.5 144-144 144z'
    ], [
        primaryColor,
        'M512 442c-79.5 0-144 64.5-144 144s64.5 144 144 144 144-64.5 144-144-64.5-144-144-144zm0 224c-44.2 0-80-35.8-80-80s35.8-80 80-80 80 35.8 80 80-35.8 80-80 80z'
    ], [
        primaryColor,
        'M893.3 293.3L730.7 130.7c-.7-.7-1.4-1.3-2.1-2-.1-.1-.3-.2-.4-.3-.7-.7-1.5-1.3-2.2-1.9a64 64 0 0 0-22-11.7V112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V338.5c0-17-6.7-33.2-18.7-45.2zM384 184h256v104H384V184zm456 656H184V184h136v136c0 17.7 14.3 32 32 32h320c17.7 0 32-14.3 32-32V205.8l136 136V840z'
    ]);
});
exports.ScheduleTwoTone = getIcon('schedule', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M768 352c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H548v56c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H328v56c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-56H136v496h752V296H768v56zM424 688c0 4.4-3.6 8-8 8H232c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm0-136c0 4.4-3.6 8-8 8H232c-4.4 0-8-3.6-8-8v-48c0-4.4 3.6-8 8-8h184c4.4 0 8 3.6 8 8v48zm374.4-91.2l-165 228.7a15.9 15.9 0 0 1-25.8 0L493.5 531.3c-3.8-5.3 0-12.7 6.5-12.7h54.9c5.1 0 9.9 2.4 12.9 6.6l52.8 73.1 103.6-143.7c3-4.1 7.8-6.6 12.8-6.5h54.9c6.5 0 10.3 7.4 6.5 12.7z'
    ], [
        primaryColor,
        'M724.2 454.6L620.6 598.3l-52.8-73.1c-3-4.2-7.8-6.6-12.9-6.6H500c-6.5 0-10.3 7.4-6.5 12.7l114.1 158.2a15.9 15.9 0 0 0 25.8 0l165-228.7c3.8-5.3 0-12.7-6.5-12.7H737c-5-.1-9.8 2.4-12.8 6.5zM416 496H232c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z'
    ], [
        primaryColor,
        'M928 224H768v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H548v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H328v-56c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v56H96c-17.7 0-32 14.3-32 32v576c0 17.7 14.3 32 32 32h832c17.7 0 32-14.3 32-32V256c0-17.7-14.3-32-32-32zm-40 568H136V296h120v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h148v56c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-56h120v496z'
    ], [
        primaryColor,
        'M416 632H232c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h184c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z'
    ]);
});
exports.SecurityScanTwoTone = getIcon('security-scan', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M866.9 169.9L527.1 54.1C523 52.7 517.5 52 512 52s-11 .7-15.1 2.1L157.1 169.9c-8.3 2.8-15.1 12.4-15.1 21.2v482.4c0 8.8 5.7 20.4 12.6 25.9L499.3 968c3.5 2.7 8 4.1 12.6 4.1s9.2-1.4 12.6-4.1l344.7-268.6c6.9-5.4 12.6-17 12.6-25.9V191.1c.2-8.8-6.6-18.3-14.9-21.2zM810 654.3L512 886.5 214 654.3V226.7l298-101.6 298 101.6v427.6z'
    ], [
        secondaryColor,
        'M460.7 451.1a80.1 80.1 0 1 0 160.2 0 80.1 80.1 0 1 0-160.2 0z'
    ], [
        secondaryColor,
        'M214 226.7v427.6l298 232.2 298-232.2V226.7L512 125.1 214 226.7zm428.7 122.5c56.3 56.3 56.3 147.5 0 203.8-48.5 48.5-123 55.2-178.6 20.1l-77.5 77.5a8.03 8.03 0 0 1-11.3 0l-34-34a8.03 8.03 0 0 1 0-11.3l77.5-77.5c-35.1-55.7-28.4-130.1 20.1-178.6 56.3-56.3 147.5-56.3 203.8 0z'
    ], [
        primaryColor,
        'M418.8 527.8l-77.5 77.5a8.03 8.03 0 0 0 0 11.3l34 34c3.1 3.1 8.2 3.1 11.3 0l77.5-77.5c55.6 35.1 130.1 28.4 178.6-20.1 56.3-56.3 56.3-147.5 0-203.8-56.3-56.3-147.5-56.3-203.8 0-48.5 48.5-55.2 122.9-20.1 178.6zm65.4-133.3a80.1 80.1 0 0 1 113.3 0 80.1 80.1 0 0 1 0 113.3c-31.3 31.3-82 31.3-113.3 0s-31.3-82 0-113.3z'
    ]);
});
exports.SettingTwoTone = getIcon('setting', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M859.3 569.7l.2.1c3.1-18.9 4.6-38.2 4.6-57.3 0-17.1-1.3-34.3-3.7-51.1 2.4 16.7 3.6 33.6 3.6 50.5 0 19.4-1.6 38.8-4.7 57.8zM99 398.1c-.5-.4-.9-.8-1.4-1.3.7.7 1.4 1.4 2.2 2.1l65.5 55.9v-.1L99 398.1zm536.6-216h.1l-15.5-83.8c-.2-1-.4-1.9-.7-2.8.1.5.3 1.1.4 1.6l15.7 85zm54 546.5l31.4-25.8 92.8 32.9c17-22.9 31.3-47.5 42.6-73.6l-74.7-63.9 6.6-40.1c2.5-15.1 3.8-30.6 3.8-46.1s-1.3-31-3.8-46.1l-6.5-39.9 74.7-63.9c-11.4-26-25.6-50.7-42.6-73.6l-92.8 32.9-31.4-25.8c-23.9-19.6-50.6-35-79.3-45.8l-38.1-14.3-17.9-97a377.5 377.5 0 0 0-85 0l-17.9 97.2-37.9 14.3c-28.5 10.8-55 26.2-78.7 45.7l-31.4 25.9-93.4-33.2c-17 22.9-31.3 47.5-42.6 73.6l75.5 64.5-6.5 40c-2.5 14.9-3.7 30.2-3.7 45.5 0 15.2 1.3 30.6 3.7 45.5l6.5 40-75.5 64.5c11.4 26 25.6 50.7 42.6 73.6l93.4-33.2 31.4 25.9c23.7 19.5 50.2 34.9 78.7 45.7l37.8 14.5 17.9 97.2c28.2 3.2 56.9 3.2 85 0l17.9-97 38.1-14.3c28.8-10.8 55.4-26.2 79.3-45.8zm-177.1-50.3c-30.5 0-59.2-7.8-84.3-21.5C373.3 627 336 568.9 336 502c0-97.2 78.8-176 176-176 66.9 0 125 37.3 154.8 92.2 13.7 25 21.5 53.7 21.5 84.3 0 97.1-78.7 175.8-175.8 175.8zM207.2 812.8c-5.5 1.9-11.2 2.3-16.6 1.2 5.7 1.2 11.7 1 17.5-1l81.4-29c-.1-.1-.3-.2-.4-.3l-81.9 29.1zm717.6-414.7l-65.5 56c0 .2.1.5.1.7l65.4-55.9c7.1-6.1 11.1-14.9 11.2-24-.3 8.8-4.3 17.3-11.2 23.2z'
    ], [
        secondaryColor,
        'M935.8 646.6c.5 4.7 0 9.5-1.7 14.1l-.9 2.6a446.02 446.02 0 0 1-79.7 137.9l-1.8 2.1a32 32 0 0 1-35.1 9.5l-81.3-28.9a350 350 0 0 1-99.7 57.6l-15.7 85a32.05 32.05 0 0 1-25.8 25.7l-2.7.5a445.2 445.2 0 0 1-79.2 7.1h.3c26.7 0 53.4-2.4 79.4-7.1l2.7-.5a32.05 32.05 0 0 0 25.8-25.7l15.7-84.9c36.2-13.6 69.6-32.9 99.6-57.5l81.2 28.9a32 32 0 0 0 35.1-9.5l1.8-2.1c34.8-41.1 61.5-87.4 79.6-137.7l.9-2.6c1.6-4.7 2.1-9.7 1.5-14.5z'
    ], [
        primaryColor,
        'M688 502c0-30.3-7.7-58.9-21.2-83.8C637 363.3 578.9 326 512 326c-97.2 0-176 78.8-176 176 0 66.9 37.3 125 92.2 154.8 24.9 13.5 53.4 21.2 83.8 21.2 97.2 0 176-78.8 176-176zm-288 0c0-29.9 11.7-58 32.8-79.2C454 401.6 482.1 390 512 390c29.9 0 58 11.6 79.2 32.8A111.6 111.6 0 0 1 624 502c0 29.9-11.7 58-32.8 79.2A111.6 111.6 0 0 1 512 614c-29.9 0-58-11.7-79.2-32.8A111.6 111.6 0 0 1 400 502z'
    ], [
        primaryColor,
        'M594.1 952.2a32.05 32.05 0 0 0 25.8-25.7l15.7-85a350 350 0 0 0 99.7-57.6l81.3 28.9a32 32 0 0 0 35.1-9.5l1.8-2.1c34.8-41.1 61.6-87.5 79.7-137.9l.9-2.6c1.7-4.6 2.2-9.4 1.7-14.1-.9-7.9-4.7-15.4-11-20.9l-65.3-55.9-.2-.1c3.1-19 4.7-38.4 4.7-57.8 0-16.9-1.2-33.9-3.6-50.5-.3-2.2-.7-4.4-1-6.6 0-.2-.1-.5-.1-.7l65.5-56c6.9-5.9 10.9-14.4 11.2-23.2.1-4-.5-8.1-1.9-12l-.9-2.6a443.74 443.74 0 0 0-79.7-137.9l-1.8-2.1a32.12 32.12 0 0 0-35.1-9.5l-81.3 28.9c-30-24.6-63.4-44-99.6-57.6h-.1l-15.7-85c-.1-.5-.2-1.1-.4-1.6a32.08 32.08 0 0 0-25.4-24.1l-2.7-.5c-52.1-9.4-106.9-9.4-159 0l-2.7.5a32.05 32.05 0 0 0-25.8 25.7l-15.8 85.4a351.86 351.86 0 0 0-99 57.4l-81.9-29.1a32 32 0 0 0-35.1 9.5l-1.8 2.1a446.02 446.02 0 0 0-79.7 137.9l-.9 2.6a32.09 32.09 0 0 0 7.9 33.9c.5.4.9.9 1.4 1.3l66.3 56.6v.1c-3.1 18.8-4.6 37.9-4.6 57 0 19.2 1.5 38.4 4.6 57.1L99 625.5a32.03 32.03 0 0 0-9.3 35.2l.9 2.6c18.1 50.4 44.9 96.9 79.7 137.9l1.8 2.1c4.9 5.7 11.4 9.4 18.5 10.7 5.4 1 11.1.7 16.6-1.2l81.9-29.1c.1.1.3.2.4.3 29.7 24.3 62.8 43.6 98.6 57.1l15.8 85.4a32.05 32.05 0 0 0 25.8 25.7l2.7.5c26.1 4.7 52.8 7.1 79.5 7.1h.3c26.6 0 53.3-2.4 79.2-7.1l2.7-.5zm-39.8-66.5a377.5 377.5 0 0 1-85 0l-17.9-97.2-37.8-14.5c-28.5-10.8-55-26.2-78.7-45.7l-31.4-25.9-93.4 33.2c-17-22.9-31.2-47.6-42.6-73.6l75.5-64.5-6.5-40c-2.4-14.9-3.7-30.3-3.7-45.5 0-15.3 1.2-30.6 3.7-45.5l6.5-40-75.5-64.5c11.3-26.1 25.6-50.7 42.6-73.6l93.4 33.2 31.4-25.9c23.7-19.5 50.2-34.9 78.7-45.7l37.9-14.3 17.9-97.2c28.1-3.2 56.8-3.2 85 0l17.9 97 38.1 14.3c28.7 10.8 55.4 26.2 79.3 45.8l31.4 25.8 92.8-32.9c17 22.9 31.2 47.6 42.6 73.6L781.8 426l6.5 39.9c2.5 15.1 3.8 30.6 3.8 46.1s-1.3 31-3.8 46.1l-6.6 40.1 74.7 63.9a370.03 370.03 0 0 1-42.6 73.6L721 702.8l-31.4 25.8c-23.9 19.6-50.5 35-79.3 45.8l-38.1 14.3-17.9 97z'
    ]);
});
exports.ShopTwoTone = getIcon('shop', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M839.5 344h-655c-.3 0-.5.2-.5.5v91.2c0 59.8 49 108.3 109.3 108.3 40.7 0 76.2-22 95.1-54.7 2.9-5.1 8.4-8.3 14.3-8.3s11.3 3.2 14.3 8.3c18.8 32.7 54.3 54.7 95 54.7 40.8 0 76.4-22.1 95.1-54.9 2.9-5 8.2-8.1 13.9-8.1h.6c5.8 0 11 3.1 13.9 8.1 18.8 32.8 54.4 54.9 95.2 54.9C791 544 840 495.5 840 435.7v-91.2c0-.3-.2-.5-.5-.5z'
    ], [
        primaryColor,
        'M882 272.1V144c0-17.7-14.3-32-32-32H174c-17.7 0-32 14.3-32 32v128.1c-16.7 1-30 14.9-30 31.9v131.7a177 177 0 0 0 14.4 70.4c4.3 10.2 9.6 19.8 15.6 28.9v345c0 17.6 14.3 32 32 32h676c17.7 0 32-14.3 32-32V535a175 175 0 0 0 15.6-28.9c9.5-22.3 14.4-46 14.4-70.4V304c0-17-13.3-30.9-30-31.9zM214 184h596v88H214v-88zm362 656.1H448V736h128v104.1zm234.4 0H640V704c0-17.7-14.3-32-32-32H416c-17.7 0-32 14.3-32 32v136.1H214V597.9c2.9 1.4 5.9 2.8 9 4 22.3 9.4 46 14.1 70.4 14.1 24.4 0 48-4.7 70.4-14.1 13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0 0 38.7 22.1c22.3 9.4 46 14.1 70.4 14.1s48-4.7 70.4-14.1c13.8-5.8 26.8-13.2 38.7-22.1.2-.1.4-.1.6 0a180.4 180.4 0 0 0 38.7 22.1c22.3 9.4 46 14.1 70.4 14.1s48-4.7 70.4-14.1c3-1.3 6-2.6 9-4v242.2zM840 435.7c0 59.8-49 108.3-109.3 108.3-40.8 0-76.4-22.1-95.2-54.9-2.9-5-8.1-8.1-13.9-8.1h-.6c-5.7 0-11 3.1-13.9 8.1A109.24 109.24 0 0 1 512 544c-40.7 0-76.2-22-95-54.7-3-5.1-8.4-8.3-14.3-8.3s-11.4 3.2-14.3 8.3a109.63 109.63 0 0 1-95.1 54.7C233 544 184 495.5 184 435.7v-91.2c0-.3.2-.5.5-.5h655c.3 0 .5.2.5.5v91.2z'
    ]);
});
exports.ShoppingTwoTone = getIcon('shopping', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M696 472c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-88H400v88c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-88h-96v456h560V384h-96v88z'
    ], [
        primaryColor,
        'M832 312H696v-16c0-101.6-82.4-184-184-184s-184 82.4-184 184v16H192c-17.7 0-32 14.3-32 32v536c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V344c0-17.7-14.3-32-32-32zm-432-16c0-61.9 50.1-112 112-112s112 50.1 112 112v16H400v-16zm392 544H232V384h96v88c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-88h224v88c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-88h96v456z'
    ]);
});
exports.SkinTwoTone = getIcon('skin', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M512 318c-79.2 0-148.5-48.8-176.7-120H182v196h119v432h422V394h119V198H688.7c-28.2 71.2-97.5 120-176.7 120z'
    ], [
        primaryColor,
        'M870 126H663.8c-17.4 0-32.9 11.9-37 29.3C614.3 208.1 567 246 512 246s-102.3-37.9-114.8-90.7a37.93 37.93 0 0 0-37-29.3H154a44 44 0 0 0-44 44v252a44 44 0 0 0 44 44h75v388a44 44 0 0 0 44 44h478a44 44 0 0 0 44-44V466h75a44 44 0 0 0 44-44V170a44 44 0 0 0-44-44zm-28 268H723v432H301V394H182V198h153.3c28.2 71.2 97.5 120 176.7 120s148.5-48.8 176.7-120H842v196z'
    ]);
});
exports.SlidersTwoTone = getIcon('sliders', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M180 292h80v440h-80zm369 180h-74a3 3 0 0 0-3 3v74a3 3 0 0 0 3 3h74a3 3 0 0 0 3-3v-74a3 3 0 0 0-3-3zm215-108h80v296h-80z'
    ], [
        primaryColor,
        'M904 296h-66v-96c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v96h-66c-4.4 0-8 3.6-8 8v416c0 4.4 3.6 8 8 8h66v96c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-96h66c4.4 0 8-3.6 8-8V304c0-4.4-3.6-8-8-8zm-60 364h-80V364h80v296zM612 404h-66V232c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v172h-66c-4.4 0-8 3.6-8 8v200c0 4.4 3.6 8 8 8h66v172c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8V620h66c4.4 0 8-3.6 8-8V412c0-4.4-3.6-8-8-8zm-60 145a3 3 0 0 1-3 3h-74a3 3 0 0 1-3-3v-74a3 3 0 0 1 3-3h74a3 3 0 0 1 3 3v74zM320 224h-66v-56c0-4.4-3.6-8-8-8h-52c-4.4 0-8 3.6-8 8v56h-66c-4.4 0-8 3.6-8 8v560c0 4.4 3.6 8 8 8h66v56c0 4.4 3.6 8 8 8h52c4.4 0 8-3.6 8-8v-56h66c4.4 0 8-3.6 8-8V232c0-4.4-3.6-8-8-8zm-60 508h-80V292h80v440z'
    ]);
});
exports.SmileTwoTone = getIcon('smile', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zM288 421a48.01 48.01 0 0 1 96 0 48.01 48.01 0 0 1-96 0zm224 272c-85.5 0-155.6-67.3-160-151.6a8 8 0 0 1 8-8.4h48.1c4.2 0 7.8 3.2 8.1 7.4C420 589.9 461.5 629 512 629s92.1-39.1 95.8-88.6c.3-4.2 3.9-7.4 8.1-7.4H664a8 8 0 0 1 8 8.4C667.6 625.7 597.5 693 512 693zm176-224a48.01 48.01 0 0 1 0-96 48.01 48.01 0 0 1 0 96z'
    ], [
        primaryColor,
        'M288 421a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm376 112h-48.1c-4.2 0-7.8 3.2-8.1 7.4-3.7 49.5-45.3 88.6-95.8 88.6s-92-39.1-95.8-88.6c-.3-4.2-3.9-7.4-8.1-7.4H360a8 8 0 0 0-8 8.4c4.4 84.3 74.5 151.6 160 151.6s155.6-67.3 160-151.6a8 8 0 0 0-8-8.4zm-24-112a48 48 0 1 0 96 0 48 48 0 1 0-96 0z'
    ]);
});
exports.SnippetsTwoTone = getIcon('snippets', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M450 510V336H232v552h432V550H490c-22.1 0-40-17.9-40-40z'
    ], [
        primaryColor,
        'M832 112H724V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H500V72c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v40H320c-17.7 0-32 14.3-32 32v120h-96c-17.7 0-32 14.3-32 32v632c0 17.7 14.3 32 32 32h512c17.7 0 32-14.3 32-32v-96h96c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zM664 888H232V336h218v174c0 22.1 17.9 40 40 40h174v338zm0-402H514V336h.2L664 485.8v.2zm128 274h-56V456L544 264H360v-80h68v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h152v32c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-32h68v576z'
    ]);
});
exports.SoundTwoTone = getIcon('sound', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M275.4 424H146v176h129.4l18 11.7L586 803V221L293.3 412.3z'
    ], [
        primaryColor,
        'M892.1 737.8l-110.3-63.7a15.9 15.9 0 0 0-21.7 5.9l-19.9 34.5c-4.4 7.6-1.8 17.4 5.8 21.8L856.3 800a15.9 15.9 0 0 0 21.7-5.9l19.9-34.5c4.4-7.6 1.7-17.4-5.8-21.8zM934 476H806c-8.8 0-16 7.2-16 16v40c0 8.8 7.2 16 16 16h128c8.8 0 16-7.2 16-16v-40c0-8.8-7.2-16-16-16zM760 344a15.9 15.9 0 0 0 21.7 5.9L892 286.2c7.6-4.4 10.2-14.2 5.8-21.8L878 230a15.9 15.9 0 0 0-21.7-5.9L746 287.8a15.99 15.99 0 0 0-5.8 21.8L760 344zM625.9 115c-5.9 0-11.9 1.6-17.4 5.3L254 352H90c-8.8 0-16 7.2-16 16v288c0 8.8 7.2 16 16 16h164l354.5 231.7c5.5 3.6 11.6 5.3 17.4 5.3 16.7 0 32.1-13.3 32.1-32.1V147.1c0-18.8-15.4-32.1-32.1-32.1zM586 803L293.4 611.7l-18-11.7H146V424h129.4l17.9-11.7L586 221v582z'
    ]);
});
exports.StarTwoTone = getIcon('star', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M512.5 190.4l-94.4 191.3-211.2 30.7 152.8 149-36.1 210.3 188.9-99.3 188.9 99.2-36.1-210.3 152.8-148.9-211.2-30.7z'
    ], [
        primaryColor,
        'M908.6 352.8l-253.9-36.9L541.2 85.8c-3.1-6.3-8.2-11.4-14.5-14.5-15.8-7.8-35-1.3-42.9 14.5L370.3 315.9l-253.9 36.9c-7 1-13.4 4.3-18.3 9.3a32.05 32.05 0 0 0 .6 45.3l183.7 179.1L239 839.4a31.95 31.95 0 0 0 46.4 33.7l227.1-119.4 227.1 119.4c6.2 3.3 13.4 4.4 20.3 3.2 17.4-3 29.1-19.5 26.1-36.9l-43.4-252.9 183.7-179.1c5-4.9 8.3-11.3 9.3-18.3 2.7-17.5-9.5-33.7-27-36.3zM665.3 561.3l36.1 210.3-188.9-99.2-188.9 99.3 36.1-210.3-152.8-149 211.2-30.7 94.4-191.3 94.4 191.3 211.2 30.7-152.8 148.9z'
    ]);
});
exports.StopTwoTone = getIcon('stop', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm288.5 682.8L277.7 224C258 240 240 258 224 277.7l522.8 522.8C682.8 852.7 601 884 512 884c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372c0 89-31.3 170.8-83.5 234.8z'
    ], [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372c89 0 170.8-31.3 234.8-83.5L224 277.7c16-19.7 34-37.7 53.7-53.7l522.8 522.8C852.7 682.8 884 601 884 512c0-205.4-166.6-372-372-372z'
    ]);
});
exports.SwitcherTwoTone = getIcon('switcher', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [secondaryColor, 'M184 840h528V312H184v528zm116-290h296v64H300v-64z'], [
        primaryColor,
        'M880 112H264c-4.4 0-8 3.6-8 8v56c0 4.4 3.6 8 8 8h576v576c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8V144c0-17.7-14.3-32-32-32z'
    ], [
        primaryColor,
        'M752 240H144c-17.7 0-32 14.3-32 32v608c0 17.7 14.3 32 32 32h608c17.7 0 32-14.3 32-32V272c0-17.7-14.3-32-32-32zm-40 600H184V312h528v528z'
    ], [primaryColor, 'M300 550h296v64H300z']);
});
exports.TabletTwoTone = getIcon('tablet', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M800 64H224c-35.3 0-64 28.7-64 64v768c0 35.3 28.7 64 64 64h576c35.3 0 64-28.7 64-64V128c0-35.3-28.7-64-64-64zm-8 824H232V136h560v752z'
    ], [
        secondaryColor,
        'M232 888h560V136H232v752zm280-144c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z'
    ], [primaryColor, 'M472 784a40 40 0 1 0 80 0 40 40 0 1 0-80 0z']);
});
exports.TagTwoTone = getIcon('tag', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M589 164.6L189.3 564.3l270.4 270.4L859.4 435 836 188l-247-23.4zM680 432c-48.5 0-88-39.5-88-88s39.5-88 88-88 88 39.5 88 88-39.5 88-88 88z'
    ], [
        primaryColor,
        'M680 256c-48.5 0-88 39.5-88 88s39.5 88 88 88 88-39.5 88-88-39.5-88-88-88zm0 120c-17.7 0-32-14.3-32-32s14.3-32 32-32 32 14.3 32 32-14.3 32-32 32z'
    ], [
        primaryColor,
        'M938 458.8l-29.6-312.6c-1.5-16.2-14.4-29-30.6-30.6L565.2 86h-.4c-3.2 0-5.7 1-7.6 2.9L88.9 557.2a9.96 9.96 0 0 0 0 14.1l363.8 363.8a9.9 9.9 0 0 0 7.1 2.9c2.7 0 5.2-1 7.1-2.9l468.3-468.3c2-2.1 3-5 2.8-8zM459.7 834.7L189.3 564.3 589 164.6 836 188l23.4 247-399.7 399.7z'
    ]);
});
exports.TagsTwoTone = getIcon('tags', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M477.5 694l311.9-311.8-19-224.6-224.6-19-311.9 311.9L477.5 694zm116-415.5a47.81 47.81 0 0 1 33.9-33.9c16.6-4.4 34.2.3 46.4 12.4a47.93 47.93 0 0 1 12.4 46.4 47.81 47.81 0 0 1-33.9 33.9c-16.6 4.4-34.2-.3-46.4-12.4a48.3 48.3 0 0 1-12.4-46.4z'
    ], [
        secondaryColor,
        'M476.6 792.6c-1.7-.2-3.4-1-4.7-2.3L137.7 456.1a8.03 8.03 0 0 1 0-11.3L515.9 66.6c1.2-1.3 2.9-2.1 4.7-2.3h-.4c-2.3-.2-4.7.6-6.3 2.3L135.7 444.8a8.03 8.03 0 0 0 0 11.3l334.2 334.2c1.8 1.9 4.3 2.6 6.7 2.3z'
    ], [
        primaryColor,
        'M889.7 539.8l-39.6-39.5a8.03 8.03 0 0 0-11.3 0l-362 361.3-237.6-237a8.03 8.03 0 0 0-11.3 0l-39.6 39.5a8.03 8.03 0 0 0 0 11.3l243.2 242.8 39.6 39.5c3.1 3.1 8.2 3.1 11.3 0l407.3-406.6c3.1-3.1 3.1-8.2 0-11.3zM652.3 337.3a47.81 47.81 0 0 0 33.9-33.9c4.4-16.6-.3-34.2-12.4-46.4a47.93 47.93 0 0 0-46.4-12.4 47.81 47.81 0 0 0-33.9 33.9c-4.4 16.6.3 34.2 12.4 46.4a48.3 48.3 0 0 0 46.4 12.4z'
    ], [
        primaryColor,
        'M137.7 444.8a8.03 8.03 0 0 0 0 11.3l334.2 334.2c1.3 1.3 2.9 2.1 4.7 2.3 2.4.3 4.8-.5 6.6-2.3L861.4 412c1.7-1.7 2.5-4 2.3-6.3l-25.5-301.4c-.7-7.8-6.8-13.9-14.6-14.6L522.2 64.3h-1.6c-1.8.2-3.4 1-4.7 2.3L137.7 444.8zm408.1-306.2l224.6 19 19 224.6L477.5 694 233.9 450.5l311.9-311.9z'
    ]);
});
exports.ToolTwoTone = getIcon('tool', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M706.8 488.7a32.05 32.05 0 0 1-45.3 0L537 364.2a32.05 32.05 0 0 1 0-45.3l132.9-132.8a184.2 184.2 0 0 0-144 53.5c-58.1 58.1-69.3 145.3-33.6 214.6L439.5 507c-.1 0-.1-.1-.1-.1L209.3 737l79.2 79.2 274-274.1.1.1 8.8-8.8c69.3 35.7 156.5 24.5 214.6-33.6 39.2-39.1 57.3-92.1 53.6-143.9L706.8 488.7z'
    ], [
        primaryColor,
        'M876.6 239.5c-.5-.9-1.2-1.8-2-2.5-5-5-13.1-5-18.1 0L684.2 409.3l-67.9-67.9L788.7 169c.8-.8 1.4-1.6 2-2.5 3.6-6.1 1.6-13.9-4.5-17.5-98.2-58-226.8-44.7-311.3 39.7-67 67-89.2 162-66.5 247.4l-293 293c-3 3-2.8 7.9.3 11l169.7 169.7c3.1 3.1 8.1 3.3 11 .3l292.9-292.9c85.5 22.8 180.5.7 247.6-66.4 84.4-84.5 97.7-213.1 39.7-311.3zM786 499.8c-58.1 58.1-145.3 69.3-214.6 33.6l-8.8 8.8-.1-.1-274 274.1-79.2-79.2 230.1-230.1s0 .1.1.1l52.8-52.8c-35.7-69.3-24.5-156.5 33.6-214.6a184.2 184.2 0 0 1 144-53.5L537 318.9a32.05 32.05 0 0 0 0 45.3l124.5 124.5a32.05 32.05 0 0 0 45.3 0l132.8-132.8c3.7 51.8-14.4 104.8-53.6 143.9z'
    ]);
});
exports.TrademarkCircleTwoTone = getIcon('trademark-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm170.7 584.2c-1.1.5-2.3.8-3.5.8h-62c-3.1 0-5.9-1.8-7.2-4.6l-74.6-159.2h-88.7V717c0 4.4-3.6 8-8 8H384c-4.4 0-8-3.6-8-8V307c0-4.4 3.6-8 8-8h155.6c98.8 0 144.2 59.9 144.2 131.1 0 70.2-43.6 106.4-78.4 119.2l80.8 164.2c2.1 3.9.4 8.7-3.5 10.7z'
    ], [
        secondaryColor,
        'M529.9 357h-83.4v148H528c53 0 82.8-25.6 82.8-72.4 0-50.3-32.9-75.6-80.9-75.6z'
    ], [
        primaryColor,
        'M605.4 549.3c34.8-12.8 78.4-49 78.4-119.2 0-71.2-45.4-131.1-144.2-131.1H384c-4.4 0-8 3.6-8 8v410c0 4.4 3.6 8 8 8h54.7c4.4 0 8-3.6 8-8V561.2h88.7L610 720.4c1.3 2.8 4.1 4.6 7.2 4.6h62c1.2 0 2.4-.3 3.5-.8 3.9-2 5.6-6.8 3.5-10.7l-80.8-164.2zM528 505h-81.5V357h83.4c48 0 80.9 25.3 80.9 75.6 0 46.8-29.8 72.4-82.8 72.4z'
    ]);
});
exports.UnlockTwoTone = getIcon('unlock', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M232 840h560V536H232v304zm280-226a48.01 48.01 0 0 1 28 87v53c0 4.4-3.6 8-8 8h-40c-4.4 0-8-3.6-8-8v-53a48.01 48.01 0 0 1 28-87z'
    ], [
        primaryColor,
        'M484 701v53c0 4.4 3.6 8 8 8h40c4.4 0 8-3.6 8-8v-53a48.01 48.01 0 1 0-56 0z'
    ], [
        primaryColor,
        'M832 464H332V240c0-30.9 25.1-56 56-56h248c30.9 0 56 25.1 56 56v68c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-68c0-70.7-57.3-128-128-128H388c-70.7 0-128 57.3-128 128v224h-68c-17.7 0-32 14.3-32 32v384c0 17.7 14.3 32 32 32h640c17.7 0 32-14.3 32-32V496c0-17.7-14.3-32-32-32zm-40 376H232V536h560v304z'
    ]);
});
exports.TrophyTwoTone = getIcon('trophy', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M320 480c0 49.1 19.1 95.3 53.9 130.1 34.7 34.8 81 53.9 130.1 53.9h16c49.1 0 95.3-19.1 130.1-53.9 34.8-34.7 53.9-81 53.9-130.1V184H320v296zM184 352c0 41 26.9 75.8 64 87.6-37.1-11.9-64-46.7-64-87.6zm364 382.5C665 721.8 758.4 630.2 773.8 514 758.3 630.2 665 721.7 548 734.5zM250.2 514C265.6 630.2 359 721.8 476 734.5 359 721.7 265.7 630.2 250.2 514z'
    ], [
        primaryColor,
        'M868 160h-92v-40c0-4.4-3.6-8-8-8H256c-4.4 0-8 3.6-8 8v40h-92a44 44 0 0 0-44 44v148c0 81.7 60 149.6 138.2 162C265.7 630.2 359 721.7 476 734.5v105.2H280c-17.7 0-32 14.3-32 32V904c0 4.4 3.6 8 8 8h512c4.4 0 8-3.6 8-8v-32.3c0-17.7-14.3-32-32-32H548V734.5C665 721.7 758.3 630.2 773.8 514 852 501.6 912 433.7 912 352V204a44 44 0 0 0-44-44zM248 439.6a91.99 91.99 0 0 1-64-87.6V232h64v207.6zM704 480c0 49.1-19.1 95.4-53.9 130.1-34.8 34.8-81 53.9-130.1 53.9h-16c-49.1 0-95.4-19.1-130.1-53.9-34.8-34.8-53.9-81-53.9-130.1V184h384v296zm136-128c0 41-26.9 75.8-64 87.6V232h64v120z'
    ]);
});
exports.UpCircleTwoTone = getIcon('up-circle', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm178 479h-46.9c-10.2 0-19.9-4.9-25.9-13.2L512 460.4 406.8 605.8c-6 8.3-15.6 13.2-25.9 13.2H334c-6.5 0-10.3-7.4-6.5-12.7l178-246c3.2-4.4 9.7-4.4 12.9 0l178 246c3.9 5.3.1 12.7-6.4 12.7z'
    ], [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        primaryColor,
        'M518.4 360.3a7.95 7.95 0 0 0-12.9 0l-178 246c-3.8 5.3 0 12.7 6.5 12.7h46.9c10.3 0 19.9-4.9 25.9-13.2L512 460.4l105.2 145.4c6 8.3 15.7 13.2 25.9 13.2H690c6.5 0 10.3-7.4 6.4-12.7l-178-246z'
    ]);
});
exports.ThunderboltTwoTone = getIcon('thunderbolt', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M695.4 164.1H470.8L281.2 491.5h157.4l-60.3 241 319.8-305.1h-211z'
    ], [
        primaryColor,
        'M848.1 359.3H627.8L825.9 109c4.1-5.3.4-13-6.3-13H436.1c-2.8 0-5.5 1.5-6.9 4L170.1 547.5c-3.1 5.3.7 12 6.9 12h174.4L262 917.1c-1.9 7.8 7.5 13.3 13.3 7.7L853.6 373c5.2-4.9 1.7-13.7-5.5-13.7zM378.3 732.5l60.3-241H281.2l189.6-327.4h224.6L487.1 427.4h211L378.3 732.5z'
    ]);
});
exports.UpSquareTwoTone = getIcon('up-square', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 728H184V184h656v656z'
    ], [
        secondaryColor,
        'M184 840h656V184H184v656zm143.5-228.7l178-246c3.2-4.4 9.7-4.4 12.9 0l178 246c3.9 5.3.1 12.7-6.4 12.7h-46.9c-10.2 0-19.9-4.9-25.9-13.2L512 465.4 406.8 610.8c-6 8.3-15.6 13.2-25.9 13.2H334c-6.5 0-10.3-7.4-6.5-12.7z'
    ], [
        primaryColor,
        'M334 624h46.9c10.3 0 19.9-4.9 25.9-13.2L512 465.4l105.2 145.4c6 8.3 15.7 13.2 25.9 13.2H690c6.5 0 10.3-7.4 6.4-12.7l-178-246a7.95 7.95 0 0 0-12.9 0l-178 246c-3.8 5.3 0 12.7 6.5 12.7z'
    ]);
});
exports.UsbTwoTone = getIcon('usb', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M759.9 504H264.1c-26.5 0-48.1 19.7-48.1 44v292h592V548c0-24.3-21.6-44-48.1-44z'
    ], [
        primaryColor,
        'M456 248h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8zm160 0h-48c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8z'
    ], [
        primaryColor,
        'M760 432V144c0-17.7-14.3-32-32-32H296c-17.7 0-32 14.3-32 32v288c-66.2 0-120 52.1-120 116v356c0 4.4 3.6 8 8 8h720c4.4 0 8-3.6 8-8V548c0-63.9-53.8-116-120-116zM336 184h352v248H336V184zm472 656H216V548c0-24.3 21.6-44 48.1-44h495.8c26.5 0 48.1 19.7 48.1 44v292z'
    ]);
});
exports.VideoCameraTwoTone = getIcon('video-camera', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M136 792h576V232H136v560zm64-488c0-4.4 3.6-8 8-8h112c4.4 0 8 3.6 8 8v48c0 4.4-3.6 8-8 8H208c-4.4 0-8-3.6-8-8v-48z'
    ], [
        primaryColor,
        'M912 302.3L784 376V224c0-35.3-28.7-64-64-64H128c-35.3 0-64 28.7-64 64v576c0 35.3 28.7 64 64 64h592c35.3 0 64-28.7 64-64V648l128 73.7c21.3 12.3 48-3.1 48-27.6V330c0-24.6-26.7-40-48-27.7zM712 792H136V232h576v560zm176-167l-104-59.8V458.9L888 399v226z'
    ], [
        primaryColor,
        'M208 360h112c4.4 0 8-3.6 8-8v-48c0-4.4-3.6-8-8-8H208c-4.4 0-8 3.6-8 8v48c0 4.4 3.6 8 8 8z'
    ]);
});
exports.WalletTwoTone = getIcon('wallet', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M880 112H144c-17.7 0-32 14.3-32 32v736c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V144c0-17.7-14.3-32-32-32zm-40 464H528V448h312v128zm0-192H496c-17.7 0-32 14.3-32 32v192c0 17.7 14.3 32 32 32h344v200H184V184h656v200z'
    ], [
        secondaryColor,
        'M528 576h312V448H528v128zm92-104c22.1 0 40 17.9 40 40s-17.9 40-40 40-40-17.9-40-40 17.9-40 40-40z'
    ], [primaryColor, 'M580 512a40 40 0 1 0 80 0 40 40 0 1 0-80 0z'], [
        secondaryColor,
        'M184 840h656V640H496c-17.7 0-32-14.3-32-32V416c0-17.7 14.3-32 32-32h344V184H184v656z'
    ]);
});
exports.WarningTwoTone = getIcon('warning', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M955.7 856l-416-720c-6.2-10.7-16.9-16-27.7-16s-21.6 5.3-27.7 16l-416 720C56 877.4 71.4 904 96 904h832c24.6 0 40-26.6 27.7-48zm-783.5-27.9L512 239.9l339.8 588.2H172.2z'
    ], [
        secondaryColor,
        'M172.2 828.1h679.6L512 239.9 172.2 828.1zM560 720a48.01 48.01 0 0 1-96 0 48.01 48.01 0 0 1 96 0zm-16-304v184c0 4.4-3.6 8-8 8h-48c-4.4 0-8-3.6-8-8V416c0-4.4 3.6-8 8-8h48c4.4 0 8 3.6 8 8z'
    ], [
        primaryColor,
        'M464 720a48 48 0 1 0 96 0 48 48 0 1 0-96 0zm16-304v184c0 4.4 3.6 8 8 8h48c4.4 0 8-3.6 8-8V416c0-4.4-3.6-8-8-8h-48c-4.4 0-8 3.6-8 8z'
    ]);
});
exports.CiTwoTone = getIcon('ci', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm-63.5 522.8c49.3 0 82.8-29.4 87-72.4.4-4.1 3.8-7.3 8-7.3h52.7c2.4 0 4.4 2 4.4 4.4 0 77.4-64.3 132.5-152.3 132.5C345.4 720 286 651.4 286 537.4v-49C286 373.5 345.4 304 448.3 304c88.3 0 152.3 56.9 152.3 138.1 0 2.4-2 4.4-4.4 4.4h-52.6c-4.2 0-7.6-3.2-8-7.4-3.9-46.1-37.5-77.6-87-77.6-61.1 0-95.6 45.4-95.7 126.8v49.3c0 80.3 34.5 125.2 95.6 125.2zM738 704.1c0 4.4-3.6 8-8 8h-50.4c-4.4 0-8-3.6-8-8V319.9c0-4.4 3.6-8 8-8H730c4.4 0 8 3.6 8 8v384.2z'
    ], [
        primaryColor,
        'M730 311.9h-50.4c-4.4 0-8 3.6-8 8v384.2c0 4.4 3.6 8 8 8H730c4.4 0 8-3.6 8-8V319.9c0-4.4-3.6-8-8-8zm-281.4 49.6c49.5 0 83.1 31.5 87 77.6.4 4.2 3.8 7.4 8 7.4h52.6c2.4 0 4.4-2 4.4-4.4 0-81.2-64-138.1-152.3-138.1C345.4 304 286 373.5 286 488.4v49c0 114 59.4 182.6 162.3 182.6 88 0 152.3-55.1 152.3-132.5 0-2.4-2-4.4-4.4-4.4h-52.7c-4.2 0-7.6 3.2-8 7.3-4.2 43-37.7 72.4-87 72.4-61.1 0-95.6-44.9-95.6-125.2v-49.3c.1-81.4 34.6-126.8 95.7-126.8z'
    ]);
});
exports.CopyrightTwoTone = getIcon('copyright', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm5.5 533c52.9 0 88.8-31.7 93-77.8.4-4.1 3.8-7.3 8-7.3h56.8c2.6 0 4.7 2.1 4.7 4.7 0 82.6-68.7 141.4-162.7 141.4C407.4 734 344 660.8 344 539.1v-52.3C344 364.2 407.4 290 517.3 290c94.3 0 162.7 60.7 162.7 147.4 0 2.6-2.1 4.7-4.7 4.7h-56.7c-4.2 0-7.7-3.2-8-7.4-4-49.6-40-83.4-93-83.4-65.2 0-102.1 48.5-102.2 135.5v52.6c0 85.7 36.8 133.6 102.1 133.6z'
    ], [
        primaryColor,
        'M517.6 351.3c53 0 89 33.8 93 83.4.3 4.2 3.8 7.4 8 7.4h56.7c2.6 0 4.7-2.1 4.7-4.7 0-86.7-68.4-147.4-162.7-147.4C407.4 290 344 364.2 344 486.8v52.3C344 660.8 407.4 734 517.3 734c94 0 162.7-58.8 162.7-141.4 0-2.6-2.1-4.7-4.7-4.7h-56.8c-4.2 0-7.6 3.2-8 7.3-4.2 46.1-40.1 77.8-93 77.8-65.3 0-102.1-47.9-102.1-133.6v-52.6c.1-87 37-135.5 102.2-135.5z'
    ]);
});
exports.DollarTwoTone = getIcon('dollar', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        secondaryColor,
        'M426.6 410.3c0 25.4 15.7 45.1 49.5 57.3 4.7 1.9 9.4 3.4 15 5v-124c-37 4.7-64.5 25.4-64.5 61.7zm116.5 135.2c-2.9-.6-5.7-1.3-8.8-2.2V677c42.6-3.8 72-27.3 72-66.4 0-30.7-15.9-50.7-63.2-65.1z'
    ], [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm22.4 589.2l.2 31.7c0 4.5-3.6 8.1-8 8.1h-28.4c-4.4 0-8-3.6-8-8v-31.4c-89-6.5-130.7-57.1-135.2-112.1-.4-4.7 3.3-8.7 8-8.7h46.2c3.9 0 7.3 2.8 7.9 6.6 5.1 31.8 29.9 55.4 74.1 61.3V534l-24.7-6.3c-52.3-12.5-102.1-45.1-102.1-112.7 0-73 55.4-112.1 126.2-119v-33c0-4.4 3.6-8 8-8h28.1c4.4 0 8 3.6 8 8v32.7c68.5 6.9 119.8 46.9 125.9 109.2a8.1 8.1 0 0 1-8 8.8h-44.9c-4 0-7.4-2.9-7.9-6.9-4-29.2-27.5-53-65.5-58.2v134.3l25.4 5.9c64.8 16 108.9 47 109 116.4 0 75.2-56 117.1-134.3 124z'
    ], [
        primaryColor,
        'M559.7 488.8l-25.4-5.9V348.6c38 5.2 61.5 29 65.5 58.2.5 4 3.9 6.9 7.9 6.9h44.9c4.7 0 8.4-4.1 8-8.8-6.1-62.3-57.4-102.3-125.9-109.2V263c0-4.4-3.6-8-8-8h-28.1c-4.4 0-8 3.6-8 8v33c-70.8 6.9-126.2 46-126.2 119 0 67.6 49.8 100.2 102.1 112.7l24.7 6.3v142.7c-44.2-5.9-69-29.5-74.1-61.3-.6-3.8-4-6.6-7.9-6.6H363c-4.7 0-8.4 4-8 8.7 4.5 55 46.2 105.6 135.2 112.1V761c0 4.4 3.6 8 8 8h28.4c4.4 0 8-3.6 8-8.1l-.2-31.7c78.3-6.9 134.3-48.8 134.3-124-.1-69.4-44.2-100.4-109-116.4zm-68.6-16.2c-5.6-1.6-10.3-3.1-15-5-33.8-12.2-49.5-31.9-49.5-57.3 0-36.3 27.5-57 64.5-61.7v124zM534.3 677V543.3c3.1.9 5.9 1.6 8.8 2.2 47.3 14.4 63.2 34.4 63.2 65.1 0 39.1-29.4 62.6-72 66.4z'
    ]);
});
exports.EuroTwoTone = getIcon('euro', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M512 64C264.6 64 64 264.6 64 512s200.6 448 448 448 448-200.6 448-448S759.4 64 512 64zm0 820c-205.4 0-372-166.6-372-372s166.6-372 372-372 372 166.6 372 372-166.6 372-372 372z'
    ], [
        secondaryColor,
        'M512 140c-205.4 0-372 166.6-372 372s166.6 372 372 372 372-166.6 372-372-166.6-372-372-372zm117.1 581.1c0 3.8-2.7 7-6.4 7.8-15.9 3.4-34.4 5.1-55.3 5.1-109.8 0-183-58.8-200.2-158H337c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h26.1v-36.9c0-4.4 0-8.7.3-12.8H337c-4.4 0-8-3.6-8-8v-27.2c0-4.4 3.6-8 8-8h31.8C388.5 345.7 460.7 290 567.4 290c20.9 0 39.4 1.9 55.3 5.4 3.7.8 6.3 4 6.3 7.8V346a8 8 0 0 1-9.6 7.8c-14.6-2.9-31.8-4.4-51.7-4.4-65.3 0-110.4 33.5-127.6 90.4h128.3c4.4 0 8 3.6 8 8V475c0 4.4-3.6 8-8 8H432.5c-.3 4.4-.3 9.1-.3 13.8v36h136.4c4.4 0 8 3.6 8 8V568c0 4.4-3.6 8-8 8H438c15.3 62 61.3 98.6 129.8 98.6 19.9 0 37.1-1.3 51.8-4.1 4.9-1 9.5 2.8 9.5 7.8v42.8z'
    ], [
        primaryColor,
        'M619.6 670.5c-14.7 2.8-31.9 4.1-51.8 4.1-68.5 0-114.5-36.6-129.8-98.6h130.6c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H432.2v-36c0-4.7 0-9.4.3-13.8h135.9c4.4 0 8-3.6 8-8v-27.2c0-4.4-3.6-8-8-8H440.1c17.2-56.9 62.3-90.4 127.6-90.4 19.9 0 37.1 1.5 51.7 4.4a8 8 0 0 0 9.6-7.8v-42.8c0-3.8-2.6-7-6.3-7.8-15.9-3.5-34.4-5.4-55.3-5.4-106.7 0-178.9 55.7-198.6 149.9H337c-4.4 0-8 3.6-8 8v27.2c0 4.4 3.6 8 8 8h26.4c-.3 4.1-.3 8.4-.3 12.8v36.9H337c-4.4 0-8 3.6-8 8V568c0 4.4 3.6 8 8 8h30.2c17.2 99.2 90.4 158 200.2 158 20.9 0 39.4-1.7 55.3-5.1 3.7-.8 6.4-4 6.4-7.8v-42.8c0-5-4.6-8.8-9.5-7.8z'
    ]);
});
exports.GoldTwoTone = getIcon('gold', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        primaryColor,
        'M435.7 558.7c-.6-3.9-4-6.7-7.9-6.7H166.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248zM196.5 748l20.7-128h159.5l20.7 128H196.5zm709.4 58.7l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H596.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8h342c.4 0 .9 0 1.3-.1 4.3-.7 7.3-4.8 6.6-9.2zM626.5 748l20.7-128h159.5l20.7 128H626.5zM342 472h342c.4 0 .9 0 1.3-.1 4.4-.7 7.3-4.8 6.6-9.2l-40.2-248c-.6-3.9-4-6.7-7.9-6.7H382.2c-3.9 0-7.3 2.8-7.9 6.7l-40.2 248c-.1.4-.1.9-.1 1.3 0 4.4 3.6 8 8 8zm91.2-196h159.5l20.7 128h-201l20.8-128z'
    ], [
        secondaryColor,
        'M592.7 276H433.2l-20.8 128h201zM217.2 620l-20.7 128h200.9l-20.7-128zm430 0l-20.7 128h200.9l-20.7-128z'
    ]);
});
exports.CanlendarTwoTone = getIcon('canlendar', twotone, function (primaryColor, secondaryColor) {
    return getNode(newViewBox, [
        secondaryColor,
        'M712 304c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H384v48c0 4.4-3.6 8-8 8h-56c-4.4 0-8-3.6-8-8v-48H184v136h656V256H712v48z'
    ], [
        primaryColor,
        'M880 184H712v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H384v-64c0-4.4-3.6-8-8-8h-56c-4.4 0-8 3.6-8 8v64H144c-17.7 0-32 14.3-32 32v664c0 17.7 14.3 32 32 32h736c17.7 0 32-14.3 32-32V216c0-17.7-14.3-32-32-32zm-40 656H184V460h656v380zm0-448H184V256h128v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h256v48c0 4.4 3.6 8 8 8h56c4.4 0 8-3.6 8-8v-48h128v136z'
    ]);
});


/***/ }),
/* 558 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__ = __webpack_require__(280);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(596);









var twoToneColorPalette = {
    primaryColor: '#333',
    secondaryColor: '#E6E6E6'
};

var Icon = function (_React$Component) {
    __WEBPACK_IMPORTED_MODULE_6_babel_runtime_helpers_inherits___default()(Icon, _React$Component);

    function Icon() {
        __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_classCallCheck___default()(this, Icon);

        return __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Icon.__proto__ || Object.getPrototypeOf(Icon)).apply(this, arguments));
    }

    __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_createClass___default()(Icon, [{
        key: 'render',
        value: function render() {
            var _extends2;

            var _props = this.props,
                type = _props.type,
                className = _props.className,
                onClick = _props.onClick,
                style = _props.style,
                primaryColor = _props.primaryColor,
                secondaryColor = _props.secondaryColor,
                rest = __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_objectWithoutProperties___default()(_props, ['type', 'className', 'onClick', 'style', 'primaryColor', 'secondaryColor']);

            var target = void 0;
            var colors = twoToneColorPalette;
            if (primaryColor) {
                colors = {
                    primaryColor: primaryColor,
                    secondaryColor: secondaryColor || Object(__WEBPACK_IMPORTED_MODULE_8__utils__["c" /* getSecondaryColor */])(primaryColor)
                };
            }
            if (Object(__WEBPACK_IMPORTED_MODULE_8__utils__["d" /* isIconDefinition */])(type)) {
                target = type;
            } else if (typeof type === 'string') {
                target = Icon.get(type, colors);
                if (!target) {
                    // log(`Could not find icon: ${type}`);
                    return null;
                }
            }
            if (!target) {
                Object(__WEBPACK_IMPORTED_MODULE_8__utils__["e" /* log */])('type should be string or icon definiton, but got ' + type);
                return null;
            }
            if (target && typeof target.icon === 'function') {
                target = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, target, {
                    icon: target.icon(colors.primaryColor, colors.secondaryColor)
                });
            }
            return Object(__WEBPACK_IMPORTED_MODULE_8__utils__["b" /* generate */])(target.icon, 'svg-' + target.name, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()((_extends2 = {
                className: className,
                onClick: onClick,
                style: style
            }, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, 'data-icon', target.name), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, 'width', '1em'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, 'height', '1em'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, 'fill', 'currentColor'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, 'aria-hidden', 'true'), __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_defineProperty___default()(_extends2, 'focusable', 'false'), _extends2), rest));
        }
    }], [{
        key: 'add',
        value: function add() {
            var _this2 = this;

            for (var _len = arguments.length, icons = Array(_len), _key = 0; _key < _len; _key++) {
                icons[_key] = arguments[_key];
            }

            icons.forEach(function (icon) {
                _this2.definitions.set(Object(__WEBPACK_IMPORTED_MODULE_8__utils__["f" /* withSuffix */])(icon.name, icon.theme), icon);
            });
        }
    }, {
        key: 'clear',
        value: function clear() {
            this.definitions.clear();
        }
    }, {
        key: 'get',
        value: function get(key) {
            var colors = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : twoToneColorPalette;

            if (key) {
                var target = this.definitions.get(key);
                if (target && typeof target.icon === 'function') {
                    target = __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, target, {
                        icon: target.icon(colors.primaryColor, colors.secondaryColor)
                    });
                }
                return target;
            }
        }
    }, {
        key: 'setTwoToneColors',
        value: function setTwoToneColors(_ref) {
            var primaryColor = _ref.primaryColor,
                secondaryColor = _ref.secondaryColor;

            twoToneColorPalette.primaryColor = primaryColor;
            twoToneColorPalette.secondaryColor = secondaryColor || Object(__WEBPACK_IMPORTED_MODULE_8__utils__["c" /* getSecondaryColor */])(primaryColor);
        }
    }, {
        key: 'getTwoToneColors',
        value: function getTwoToneColors() {
            return __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_extends___default()({}, twoToneColorPalette);
        }
    }]);

    return Icon;
}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]);

Icon.displayName = 'IconReact';
Icon.definitions = new __WEBPACK_IMPORTED_MODULE_8__utils__["a" /* MiniMap */]();
/* harmony default export */ __webpack_exports__["a"] = (Icon);

/***/ }),
/* 559 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(560);
var $Object = __webpack_require__(43).Object;
module.exports = function defineProperty(it, key, desc) {
  return $Object.defineProperty(it, key, desc);
};


/***/ }),
/* 560 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(61);
// 19.1.2.4 / 15.2.3.6 Object.defineProperty(O, P, Attributes)
$export($export.S + $export.F * !__webpack_require__(54), 'Object', { defineProperty: __webpack_require__(53).f });


/***/ }),
/* 561 */
/***/ (function(module, exports) {

module.exports = function (it) {
  if (typeof it != 'function') throw TypeError(it + ' is not a function!');
  return it;
};


/***/ }),
/* 562 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(563), __esModule: true };

/***/ }),
/* 563 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(564);
module.exports = __webpack_require__(43).Object.assign;


/***/ }),
/* 564 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.1 Object.assign(target, source)
var $export = __webpack_require__(61);

$export($export.S + $export.F, 'Object', { assign: __webpack_require__(565) });


/***/ }),
/* 565 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// 19.1.2.1 Object.assign(target, source, ...)
var DESCRIPTORS = __webpack_require__(54);
var getKeys = __webpack_require__(127);
var gOPS = __webpack_require__(180);
var pIE = __webpack_require__(130);
var toObject = __webpack_require__(131);
var IObject = __webpack_require__(278);
var $assign = Object.assign;

// should work with symbols and should have deterministic property order (V8 bug)
module.exports = !$assign || __webpack_require__(105)(function () {
  var A = {};
  var B = {};
  // eslint-disable-next-line no-undef
  var S = Symbol();
  var K = 'abcdefghijklmnopqrst';
  A[S] = 7;
  K.split('').forEach(function (k) { B[k] = k; });
  return $assign({}, A)[S] != 7 || Object.keys($assign({}, B)).join('') != K;
}) ? function assign(target, source) { // eslint-disable-line no-unused-vars
  var T = toObject(target);
  var aLen = arguments.length;
  var index = 1;
  var getSymbols = gOPS.f;
  var isEnum = pIE.f;
  while (aLen > index) {
    var S = IObject(arguments[index++]);
    var keys = getSymbols ? getKeys(S).concat(getSymbols(S)) : getKeys(S);
    var length = keys.length;
    var j = 0;
    var key;
    while (length > j) {
      key = keys[j++];
      if (!DESCRIPTORS || isEnum.call(S, key)) T[key] = S[key];
    }
  } return T;
} : $assign;


/***/ }),
/* 566 */
/***/ (function(module, exports, __webpack_require__) {

// false -> Array#indexOf
// true  -> Array#includes
var toIObject = __webpack_require__(80);
var toLength = __webpack_require__(279);
var toAbsoluteIndex = __webpack_require__(567);
module.exports = function (IS_INCLUDES) {
  return function ($this, el, fromIndex) {
    var O = toIObject($this);
    var length = toLength(O.length);
    var index = toAbsoluteIndex(fromIndex, length);
    var value;
    // Array#includes uses SameValueZero equality algorithm
    // eslint-disable-next-line no-self-compare
    if (IS_INCLUDES && el != el) while (length > index) {
      value = O[index++];
      // eslint-disable-next-line no-self-compare
      if (value != value) return true;
    // Array#indexOf ignores holes, Array#includes - not
    } else for (;length > index; index++) if (IS_INCLUDES || index in O) {
      if (O[index] === el) return IS_INCLUDES || index || 0;
    } return !IS_INCLUDES && -1;
  };
};


/***/ }),
/* 567 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(176);
var max = Math.max;
var min = Math.min;
module.exports = function (index, length) {
  index = toInteger(index);
  return index < 0 ? max(index + length, 0) : min(index, length);
};


/***/ }),
/* 568 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(569), __esModule: true };

/***/ }),
/* 569 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(281);
__webpack_require__(575);
module.exports = __webpack_require__(184).f('iterator');


/***/ }),
/* 570 */
/***/ (function(module, exports, __webpack_require__) {

var toInteger = __webpack_require__(176);
var defined = __webpack_require__(175);
// true  -> String#at
// false -> String#codePointAt
module.exports = function (TO_STRING) {
  return function (that, pos) {
    var s = String(defined(that));
    var i = toInteger(pos);
    var l = s.length;
    var a, b;
    if (i < 0 || i >= l) return TO_STRING ? '' : undefined;
    a = s.charCodeAt(i);
    return a < 0xd800 || a > 0xdbff || i + 1 === l || (b = s.charCodeAt(i + 1)) < 0xdc00 || b > 0xdfff
      ? TO_STRING ? s.charAt(i) : a
      : TO_STRING ? s.slice(i, i + 2) : (a - 0xd800 << 10) + (b - 0xdc00) + 0x10000;
  };
};


/***/ }),
/* 571 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var create = __webpack_require__(182);
var descriptor = __webpack_require__(106);
var setToStringTag = __webpack_require__(183);
var IteratorPrototype = {};

// 25.1.2.1.1 %IteratorPrototype%[@@iterator]()
__webpack_require__(77)(IteratorPrototype, __webpack_require__(44)('iterator'), function () { return this; });

module.exports = function (Constructor, NAME, next) {
  Constructor.prototype = create(IteratorPrototype, { next: descriptor(1, next) });
  setToStringTag(Constructor, NAME + ' Iterator');
};


/***/ }),
/* 572 */
/***/ (function(module, exports, __webpack_require__) {

var dP = __webpack_require__(53);
var anObject = __webpack_require__(78);
var getKeys = __webpack_require__(127);

module.exports = __webpack_require__(54) ? Object.defineProperties : function defineProperties(O, Properties) {
  anObject(O);
  var keys = getKeys(Properties);
  var length = keys.length;
  var i = 0;
  var P;
  while (length > i) dP.f(O, P = keys[i++], Properties[P]);
  return O;
};


/***/ }),
/* 573 */
/***/ (function(module, exports, __webpack_require__) {

var document = __webpack_require__(52).document;
module.exports = document && document.documentElement;


/***/ }),
/* 574 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.2.9 / 15.2.3.2 Object.getPrototypeOf(O)
var has = __webpack_require__(62);
var toObject = __webpack_require__(131);
var IE_PROTO = __webpack_require__(177)('IE_PROTO');
var ObjectProto = Object.prototype;

module.exports = Object.getPrototypeOf || function (O) {
  O = toObject(O);
  if (has(O, IE_PROTO)) return O[IE_PROTO];
  if (typeof O.constructor == 'function' && O instanceof O.constructor) {
    return O.constructor.prototype;
  } return O instanceof Object ? ObjectProto : null;
};


/***/ }),
/* 575 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(576);
var global = __webpack_require__(52);
var hide = __webpack_require__(77);
var Iterators = __webpack_require__(107);
var TO_STRING_TAG = __webpack_require__(44)('toStringTag');

var DOMIterables = ('CSSRuleList,CSSStyleDeclaration,CSSValueList,ClientRectList,DOMRectList,DOMStringList,' +
  'DOMTokenList,DataTransferItemList,FileList,HTMLAllCollection,HTMLCollection,HTMLFormElement,HTMLSelectElement,' +
  'MediaList,MimeTypeArray,NamedNodeMap,NodeList,PaintRequestList,Plugin,PluginArray,SVGLengthList,SVGNumberList,' +
  'SVGPathSegList,SVGPointList,SVGStringList,SVGTransformList,SourceBufferList,StyleSheetList,TextTrackCueList,' +
  'TextTrackList,TouchList').split(',');

for (var i = 0; i < DOMIterables.length; i++) {
  var NAME = DOMIterables[i];
  var Collection = global[NAME];
  var proto = Collection && Collection.prototype;
  if (proto && !proto[TO_STRING_TAG]) hide(proto, TO_STRING_TAG, NAME);
  Iterators[NAME] = Iterators.Array;
}


/***/ }),
/* 576 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var addToUnscopables = __webpack_require__(577);
var step = __webpack_require__(578);
var Iterators = __webpack_require__(107);
var toIObject = __webpack_require__(80);

// 22.1.3.4 Array.prototype.entries()
// 22.1.3.13 Array.prototype.keys()
// 22.1.3.29 Array.prototype.values()
// 22.1.3.30 Array.prototype[@@iterator]()
module.exports = __webpack_require__(282)(Array, 'Array', function (iterated, kind) {
  this._t = toIObject(iterated); // target
  this._i = 0;                   // next index
  this._k = kind;                // kind
// 22.1.5.2.1 %ArrayIteratorPrototype%.next()
}, function () {
  var O = this._t;
  var kind = this._k;
  var index = this._i++;
  if (!O || index >= O.length) {
    this._t = undefined;
    return step(1);
  }
  if (kind == 'keys') return step(0, index);
  if (kind == 'values') return step(0, O[index]);
  return step(0, [index, O[index]]);
}, 'values');

// argumentsList[@@iterator] is %ArrayProto_values% (9.4.4.6, 9.4.4.7)
Iterators.Arguments = Iterators.Array;

addToUnscopables('keys');
addToUnscopables('values');
addToUnscopables('entries');


/***/ }),
/* 577 */
/***/ (function(module, exports) {

module.exports = function () { /* empty */ };


/***/ }),
/* 578 */
/***/ (function(module, exports) {

module.exports = function (done, value) {
  return { value: value, done: !!done };
};


/***/ }),
/* 579 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(580), __esModule: true };

/***/ }),
/* 580 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(581);
__webpack_require__(586);
__webpack_require__(587);
__webpack_require__(588);
module.exports = __webpack_require__(43).Symbol;


/***/ }),
/* 581 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

// ECMAScript 6 symbols shim
var global = __webpack_require__(52);
var has = __webpack_require__(62);
var DESCRIPTORS = __webpack_require__(54);
var $export = __webpack_require__(61);
var redefine = __webpack_require__(283);
var META = __webpack_require__(582).KEY;
var $fails = __webpack_require__(105);
var shared = __webpack_require__(178);
var setToStringTag = __webpack_require__(183);
var uid = __webpack_require__(129);
var wks = __webpack_require__(44);
var wksExt = __webpack_require__(184);
var wksDefine = __webpack_require__(185);
var enumKeys = __webpack_require__(583);
var isArray = __webpack_require__(584);
var anObject = __webpack_require__(78);
var isObject = __webpack_require__(79);
var toObject = __webpack_require__(131);
var toIObject = __webpack_require__(80);
var toPrimitive = __webpack_require__(173);
var createDesc = __webpack_require__(106);
var _create = __webpack_require__(182);
var gOPNExt = __webpack_require__(585);
var $GOPD = __webpack_require__(285);
var $GOPS = __webpack_require__(180);
var $DP = __webpack_require__(53);
var $keys = __webpack_require__(127);
var gOPD = $GOPD.f;
var dP = $DP.f;
var gOPN = gOPNExt.f;
var $Symbol = global.Symbol;
var $JSON = global.JSON;
var _stringify = $JSON && $JSON.stringify;
var PROTOTYPE = 'prototype';
var HIDDEN = wks('_hidden');
var TO_PRIMITIVE = wks('toPrimitive');
var isEnum = {}.propertyIsEnumerable;
var SymbolRegistry = shared('symbol-registry');
var AllSymbols = shared('symbols');
var OPSymbols = shared('op-symbols');
var ObjectProto = Object[PROTOTYPE];
var USE_NATIVE = typeof $Symbol == 'function' && !!$GOPS.f;
var QObject = global.QObject;
// Don't use setters in Qt Script, https://github.com/zloirock/core-js/issues/173
var setter = !QObject || !QObject[PROTOTYPE] || !QObject[PROTOTYPE].findChild;

// fallback for old Android, https://code.google.com/p/v8/issues/detail?id=687
var setSymbolDesc = DESCRIPTORS && $fails(function () {
  return _create(dP({}, 'a', {
    get: function () { return dP(this, 'a', { value: 7 }).a; }
  })).a != 7;
}) ? function (it, key, D) {
  var protoDesc = gOPD(ObjectProto, key);
  if (protoDesc) delete ObjectProto[key];
  dP(it, key, D);
  if (protoDesc && it !== ObjectProto) dP(ObjectProto, key, protoDesc);
} : dP;

var wrap = function (tag) {
  var sym = AllSymbols[tag] = _create($Symbol[PROTOTYPE]);
  sym._k = tag;
  return sym;
};

var isSymbol = USE_NATIVE && typeof $Symbol.iterator == 'symbol' ? function (it) {
  return typeof it == 'symbol';
} : function (it) {
  return it instanceof $Symbol;
};

var $defineProperty = function defineProperty(it, key, D) {
  if (it === ObjectProto) $defineProperty(OPSymbols, key, D);
  anObject(it);
  key = toPrimitive(key, true);
  anObject(D);
  if (has(AllSymbols, key)) {
    if (!D.enumerable) {
      if (!has(it, HIDDEN)) dP(it, HIDDEN, createDesc(1, {}));
      it[HIDDEN][key] = true;
    } else {
      if (has(it, HIDDEN) && it[HIDDEN][key]) it[HIDDEN][key] = false;
      D = _create(D, { enumerable: createDesc(0, false) });
    } return setSymbolDesc(it, key, D);
  } return dP(it, key, D);
};
var $defineProperties = function defineProperties(it, P) {
  anObject(it);
  var keys = enumKeys(P = toIObject(P));
  var i = 0;
  var l = keys.length;
  var key;
  while (l > i) $defineProperty(it, key = keys[i++], P[key]);
  return it;
};
var $create = function create(it, P) {
  return P === undefined ? _create(it) : $defineProperties(_create(it), P);
};
var $propertyIsEnumerable = function propertyIsEnumerable(key) {
  var E = isEnum.call(this, key = toPrimitive(key, true));
  if (this === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return false;
  return E || !has(this, key) || !has(AllSymbols, key) || has(this, HIDDEN) && this[HIDDEN][key] ? E : true;
};
var $getOwnPropertyDescriptor = function getOwnPropertyDescriptor(it, key) {
  it = toIObject(it);
  key = toPrimitive(key, true);
  if (it === ObjectProto && has(AllSymbols, key) && !has(OPSymbols, key)) return;
  var D = gOPD(it, key);
  if (D && has(AllSymbols, key) && !(has(it, HIDDEN) && it[HIDDEN][key])) D.enumerable = true;
  return D;
};
var $getOwnPropertyNames = function getOwnPropertyNames(it) {
  var names = gOPN(toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (!has(AllSymbols, key = names[i++]) && key != HIDDEN && key != META) result.push(key);
  } return result;
};
var $getOwnPropertySymbols = function getOwnPropertySymbols(it) {
  var IS_OP = it === ObjectProto;
  var names = gOPN(IS_OP ? OPSymbols : toIObject(it));
  var result = [];
  var i = 0;
  var key;
  while (names.length > i) {
    if (has(AllSymbols, key = names[i++]) && (IS_OP ? has(ObjectProto, key) : true)) result.push(AllSymbols[key]);
  } return result;
};

// 19.4.1.1 Symbol([description])
if (!USE_NATIVE) {
  $Symbol = function Symbol() {
    if (this instanceof $Symbol) throw TypeError('Symbol is not a constructor!');
    var tag = uid(arguments.length > 0 ? arguments[0] : undefined);
    var $set = function (value) {
      if (this === ObjectProto) $set.call(OPSymbols, value);
      if (has(this, HIDDEN) && has(this[HIDDEN], tag)) this[HIDDEN][tag] = false;
      setSymbolDesc(this, tag, createDesc(1, value));
    };
    if (DESCRIPTORS && setter) setSymbolDesc(ObjectProto, tag, { configurable: true, set: $set });
    return wrap(tag);
  };
  redefine($Symbol[PROTOTYPE], 'toString', function toString() {
    return this._k;
  });

  $GOPD.f = $getOwnPropertyDescriptor;
  $DP.f = $defineProperty;
  __webpack_require__(284).f = gOPNExt.f = $getOwnPropertyNames;
  __webpack_require__(130).f = $propertyIsEnumerable;
  $GOPS.f = $getOwnPropertySymbols;

  if (DESCRIPTORS && !__webpack_require__(128)) {
    redefine(ObjectProto, 'propertyIsEnumerable', $propertyIsEnumerable, true);
  }

  wksExt.f = function (name) {
    return wrap(wks(name));
  };
}

$export($export.G + $export.W + $export.F * !USE_NATIVE, { Symbol: $Symbol });

for (var es6Symbols = (
  // 19.4.2.2, 19.4.2.3, 19.4.2.4, 19.4.2.6, 19.4.2.8, 19.4.2.9, 19.4.2.10, 19.4.2.11, 19.4.2.12, 19.4.2.13, 19.4.2.14
  'hasInstance,isConcatSpreadable,iterator,match,replace,search,species,split,toPrimitive,toStringTag,unscopables'
).split(','), j = 0; es6Symbols.length > j;)wks(es6Symbols[j++]);

for (var wellKnownSymbols = $keys(wks.store), k = 0; wellKnownSymbols.length > k;) wksDefine(wellKnownSymbols[k++]);

$export($export.S + $export.F * !USE_NATIVE, 'Symbol', {
  // 19.4.2.1 Symbol.for(key)
  'for': function (key) {
    return has(SymbolRegistry, key += '')
      ? SymbolRegistry[key]
      : SymbolRegistry[key] = $Symbol(key);
  },
  // 19.4.2.5 Symbol.keyFor(sym)
  keyFor: function keyFor(sym) {
    if (!isSymbol(sym)) throw TypeError(sym + ' is not a symbol!');
    for (var key in SymbolRegistry) if (SymbolRegistry[key] === sym) return key;
  },
  useSetter: function () { setter = true; },
  useSimple: function () { setter = false; }
});

$export($export.S + $export.F * !USE_NATIVE, 'Object', {
  // 19.1.2.2 Object.create(O [, Properties])
  create: $create,
  // 19.1.2.4 Object.defineProperty(O, P, Attributes)
  defineProperty: $defineProperty,
  // 19.1.2.3 Object.defineProperties(O, Properties)
  defineProperties: $defineProperties,
  // 19.1.2.6 Object.getOwnPropertyDescriptor(O, P)
  getOwnPropertyDescriptor: $getOwnPropertyDescriptor,
  // 19.1.2.7 Object.getOwnPropertyNames(O)
  getOwnPropertyNames: $getOwnPropertyNames,
  // 19.1.2.8 Object.getOwnPropertySymbols(O)
  getOwnPropertySymbols: $getOwnPropertySymbols
});

// Chrome 38 and 39 `Object.getOwnPropertySymbols` fails on primitives
// https://bugs.chromium.org/p/v8/issues/detail?id=3443
var FAILS_ON_PRIMITIVES = $fails(function () { $GOPS.f(1); });

$export($export.S + $export.F * FAILS_ON_PRIMITIVES, 'Object', {
  getOwnPropertySymbols: function getOwnPropertySymbols(it) {
    return $GOPS.f(toObject(it));
  }
});

// 24.3.2 JSON.stringify(value [, replacer [, space]])
$JSON && $export($export.S + $export.F * (!USE_NATIVE || $fails(function () {
  var S = $Symbol();
  // MS Edge converts symbol values to JSON as {}
  // WebKit converts symbol values to JSON as null
  // V8 throws on boxed symbols
  return _stringify([S]) != '[null]' || _stringify({ a: S }) != '{}' || _stringify(Object(S)) != '{}';
})), 'JSON', {
  stringify: function stringify(it) {
    var args = [it];
    var i = 1;
    var replacer, $replacer;
    while (arguments.length > i) args.push(arguments[i++]);
    $replacer = replacer = args[1];
    if (!isObject(replacer) && it === undefined || isSymbol(it)) return; // IE8 returns string on undefined
    if (!isArray(replacer)) replacer = function (key, value) {
      if (typeof $replacer == 'function') value = $replacer.call(this, key, value);
      if (!isSymbol(value)) return value;
    };
    args[1] = replacer;
    return _stringify.apply($JSON, args);
  }
});

// 19.4.3.4 Symbol.prototype[@@toPrimitive](hint)
$Symbol[PROTOTYPE][TO_PRIMITIVE] || __webpack_require__(77)($Symbol[PROTOTYPE], TO_PRIMITIVE, $Symbol[PROTOTYPE].valueOf);
// 19.4.3.5 Symbol.prototype[@@toStringTag]
setToStringTag($Symbol, 'Symbol');
// 20.2.1.9 Math[@@toStringTag]
setToStringTag(Math, 'Math', true);
// 24.3.3 JSON[@@toStringTag]
setToStringTag(global.JSON, 'JSON', true);


/***/ }),
/* 582 */
/***/ (function(module, exports, __webpack_require__) {

var META = __webpack_require__(129)('meta');
var isObject = __webpack_require__(79);
var has = __webpack_require__(62);
var setDesc = __webpack_require__(53).f;
var id = 0;
var isExtensible = Object.isExtensible || function () {
  return true;
};
var FREEZE = !__webpack_require__(105)(function () {
  return isExtensible(Object.preventExtensions({}));
});
var setMeta = function (it) {
  setDesc(it, META, { value: {
    i: 'O' + ++id, // object ID
    w: {}          // weak collections IDs
  } });
};
var fastKey = function (it, create) {
  // return primitive with prefix
  if (!isObject(it)) return typeof it == 'symbol' ? it : (typeof it == 'string' ? 'S' : 'P') + it;
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return 'F';
    // not necessary to add metadata
    if (!create) return 'E';
    // add missing metadata
    setMeta(it);
  // return object ID
  } return it[META].i;
};
var getWeak = function (it, create) {
  if (!has(it, META)) {
    // can't set metadata to uncaught frozen object
    if (!isExtensible(it)) return true;
    // not necessary to add metadata
    if (!create) return false;
    // add missing metadata
    setMeta(it);
  // return hash weak collections IDs
  } return it[META].w;
};
// add metadata on freeze-family methods calling
var onFreeze = function (it) {
  if (FREEZE && meta.NEED && isExtensible(it) && !has(it, META)) setMeta(it);
  return it;
};
var meta = module.exports = {
  KEY: META,
  NEED: false,
  fastKey: fastKey,
  getWeak: getWeak,
  onFreeze: onFreeze
};


/***/ }),
/* 583 */
/***/ (function(module, exports, __webpack_require__) {

// all enumerable object keys, includes symbols
var getKeys = __webpack_require__(127);
var gOPS = __webpack_require__(180);
var pIE = __webpack_require__(130);
module.exports = function (it) {
  var result = getKeys(it);
  var getSymbols = gOPS.f;
  if (getSymbols) {
    var symbols = getSymbols(it);
    var isEnum = pIE.f;
    var i = 0;
    var key;
    while (symbols.length > i) if (isEnum.call(it, key = symbols[i++])) result.push(key);
  } return result;
};


/***/ }),
/* 584 */
/***/ (function(module, exports, __webpack_require__) {

// 7.2.2 IsArray(argument)
var cof = __webpack_require__(174);
module.exports = Array.isArray || function isArray(arg) {
  return cof(arg) == 'Array';
};


/***/ }),
/* 585 */
/***/ (function(module, exports, __webpack_require__) {

// fallback for IE11 buggy Object.getOwnPropertyNames with iframe and window
var toIObject = __webpack_require__(80);
var gOPN = __webpack_require__(284).f;
var toString = {}.toString;

var windowNames = typeof window == 'object' && window && Object.getOwnPropertyNames
  ? Object.getOwnPropertyNames(window) : [];

var getWindowNames = function (it) {
  try {
    return gOPN(it);
  } catch (e) {
    return windowNames.slice();
  }
};

module.exports.f = function getOwnPropertyNames(it) {
  return windowNames && toString.call(it) == '[object Window]' ? getWindowNames(it) : gOPN(toIObject(it));
};


/***/ }),
/* 586 */
/***/ (function(module, exports) {



/***/ }),
/* 587 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(185)('asyncIterator');


/***/ }),
/* 588 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(185)('observable');


/***/ }),
/* 589 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(590), __esModule: true };

/***/ }),
/* 590 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(591);
module.exports = __webpack_require__(43).Object.setPrototypeOf;


/***/ }),
/* 591 */
/***/ (function(module, exports, __webpack_require__) {

// 19.1.3.19 Object.setPrototypeOf(O, proto)
var $export = __webpack_require__(61);
$export($export.S, 'Object', { setPrototypeOf: __webpack_require__(592).set });


/***/ }),
/* 592 */
/***/ (function(module, exports, __webpack_require__) {

// Works with __proto__ only. Old v8 can't work with null proto objects.
/* eslint-disable no-proto */
var isObject = __webpack_require__(79);
var anObject = __webpack_require__(78);
var check = function (O, proto) {
  anObject(O);
  if (!isObject(proto) && proto !== null) throw TypeError(proto + ": can't set as prototype!");
};
module.exports = {
  set: Object.setPrototypeOf || ('__proto__' in {} ? // eslint-disable-line
    function (test, buggy, set) {
      try {
        set = __webpack_require__(172)(Function.call, __webpack_require__(285).f(Object.prototype, '__proto__').set, 2);
        set(test, []);
        buggy = !(test instanceof Array);
      } catch (e) { buggy = true; }
      return function setPrototypeOf(O, proto) {
        check(O, proto);
        if (buggy) O.__proto__ = proto;
        else set(O, proto);
        return O;
      };
    }({}, false) : undefined),
  check: check
};


/***/ }),
/* 593 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(594), __esModule: true };

/***/ }),
/* 594 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(595);
var $Object = __webpack_require__(43).Object;
module.exports = function create(P, D) {
  return $Object.create(P, D);
};


/***/ }),
/* 595 */
/***/ (function(module, exports, __webpack_require__) {

var $export = __webpack_require__(61);
// 19.1.2.2 / 15.2.3.5 Object.create(O [, Properties])
$export($export.S, 'Object', { create: __webpack_require__(182) });


/***/ }),
/* 596 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/* harmony export (immutable) */ __webpack_exports__["e"] = log;
/* harmony export (immutable) */ __webpack_exports__["d"] = isIconDefinition;
/* unused harmony export normalizeAttrs */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return MiniMap; });
/* harmony export (immutable) */ __webpack_exports__["b"] = generate;
/* harmony export (immutable) */ __webpack_exports__["c"] = getSecondaryColor;
/* harmony export (immutable) */ __webpack_exports__["f"] = withSuffix;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ant_design_colors__ = __webpack_require__(597);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__ant_design_colors___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__ant_design_colors__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);





function log(message) {
    if (!(process && Object({"NODE_ENV":"production","PUBLIC_URL":"","REACT_APP_WEBSITE_NAME":"Laguna","REACT_APP_SERVICE":"https://api.lagunaproperty.com","REACT_APP_LAGUNA_PROPERTY_URL":"https://lagunaproperty.com","REACT_APP_LAGUNA_PROPERTY_BINTAN_URL":"http://bintan.lagunaproperty.com","REACT_APP_LAGUNA_PROPERTY_PHUKET_URL":"https://lagunaproperty.com","REACT_APP_LAGUNA_PROPERTY_LANGCO_URL":"http://www.lagunalangco.com","REACT_APP_CLOUDFRONT":"https://d3vqeivyse4uh3.cloudfront.net/www/lagunaproperty","REACT_APP_CLOUDFRONT_ASSET":"assets","REACT_APP_CLOUDFRONT_PREVIEW_TRIP":"preview-trip/assets","REACT_APP_CLOUDFRONT_PHUKET_LAGUNA_VILLAGE_RESIDENCES":"location/phuket/laguna-village-residences/assets","REACT_APP_CLOUDFRONT_PHUKET_LAGUNA_PARK2":"location/phuket/laguna-park-2/assets","REACT_APP_CLOUDFRONT_PHUKET_DUSIT_DELUXE_POOL_VILLA":"location/phuket/dusit-deluxe-pool-villa/assets","REACT_APP_CLOUDFRONT_PHUKET_SKYPARK":"location/phuket/skypark/assets","REACT_APP_CLOUDFRONT_LAGUNA_BEACHSIDE":"location/phuket/laguna-beachside/assets","REACT_APP_CLOUDFRONT_LAGUNA_SEASIDE_RESIDENCES":"location/phuket/laguna-seaside-residences/assets","REACT_APP_GOOGLE_RECAPTCHA":"6LcABWUUAAAAADKAjhB-QnE0hEQb39ZR9Aknbjy7"}) && "production" === 'production')) {
        console.error('[@ant-design/icons-react]: ' + message + '.');
    }
}
function isIconDefinition(target) {
    return typeof target === 'object' && typeof target.name === 'string' && typeof target.theme === 'string' && (typeof target.icon === 'object' || typeof target.icon === 'function');
}
function normalizeAttrs() {
    var attrs = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

    return Object.keys(attrs).reduce(function (acc, key) {
        var val = attrs[key];
        switch (key) {
            case 'class':
                acc.className = val;
                delete acc['class'];
                break;
            default:
                acc[key] = val;
        }
        return acc;
    }, {});
}
var MiniMap = function () {
    function MiniMap() {
        __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_classCallCheck___default()(this, MiniMap);

        this.collection = {};
    }

    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_createClass___default()(MiniMap, [{
        key: 'clear',
        value: function clear() {
            this.collection = {};
        }
    }, {
        key: 'delete',
        value: function _delete(key) {
            return delete this.collection[key];
        }
    }, {
        key: 'get',
        value: function get(key) {
            return this.collection[key];
        }
    }, {
        key: 'has',
        value: function has(key) {
            return Boolean(this.collection[key]);
        }
    }, {
        key: 'set',
        value: function set(key, value) {
            this.collection[key] = value;
            return this;
        }
    }, {
        key: 'size',
        get: function get() {
            return Object.keys(this.collection).length;
        }
    }]);

    return MiniMap;
}();
function generate(node, key, rootProps) {
    if (!rootProps) {
        return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](node.tag, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({ key: key }, normalizeAttrs(node.attrs)), (node.children || []).map(function (child, index) {
            return generate(child, key + '-' + node.tag + '-' + index);
        }));
    }
    return __WEBPACK_IMPORTED_MODULE_4_react__["createElement"](node.tag, __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
        key: key
    }, normalizeAttrs(node.attrs), rootProps), (node.children || []).map(function (child, index) {
        return generate(child, key + '-' + node.tag + '-' + index);
    }));
}
function getSecondaryColor(primaryColor) {
    // choose the second color
    return Object(__WEBPACK_IMPORTED_MODULE_3__ant_design_colors__["generate"])(primaryColor)[0];
}
function withSuffix(name, theme) {
    switch (theme) {
        case 'fill':
            return name + '-fill';
        case 'outline':
            return name + '-o';
        case 'twotone':
            return name + '-twotone';
        default:
            throw new TypeError('Unknown theme type: ' + theme + ', name: ' + name);
    }
}
/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(171)))

/***/ }),
/* 597 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var generate_1 = __importDefault(__webpack_require__(598));
exports.generate = generate_1.default;
var presetPrimaryColors = {
    red: '#F5222D',
    volcano: '#FA541C',
    orange: '#FA8C16',
    gold: '#FAAD14',
    yellow: '#FADB14',
    lime: '#A0D911',
    green: '#52C41A',
    cyan: '#13C2C2',
    blue: '#1890FF',
    geekblue: '#2F54EB',
    purple: '#722ED1',
    magenta: '#EB2F96',
    grey: '#666666',
};
exports.presetPrimaryColors = presetPrimaryColors;
var presetPalettes = {};
exports.presetPalettes = presetPalettes;
Object.keys(presetPrimaryColors).forEach(function (key) {
    presetPalettes[key] = generate_1.default(presetPrimaryColors[key]);
    presetPalettes[key].primary = presetPalettes[key][5];
});
var red = presetPalettes.red;
exports.red = red;
var volcano = presetPalettes.volcano;
exports.volcano = volcano;
var gold = presetPalettes.gold;
exports.gold = gold;
var orange = presetPalettes.orange;
exports.orange = orange;
var yellow = presetPalettes.yellow;
exports.yellow = yellow;
var lime = presetPalettes.lime;
exports.lime = lime;
var green = presetPalettes.green;
exports.green = green;
var cyan = presetPalettes.cyan;
exports.cyan = cyan;
var blue = presetPalettes.blue;
exports.blue = blue;
var geekblue = presetPalettes.geekblue;
exports.geekblue = geekblue;
var purple = presetPalettes.purple;
exports.purple = purple;
var magenta = presetPalettes.magenta;
exports.magenta = magenta;
var grey = presetPalettes.grey;
exports.grey = grey;


/***/ }),
/* 598 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var tinycolor2_1 = __importDefault(__webpack_require__(599));
var hueStep = 2; // 色相阶梯
var saturationStep = 16; // 饱和度阶梯，浅色部分
var saturationStep2 = 5; // 饱和度阶梯，深色部分
var brightnessStep1 = 5; // 亮度阶梯，浅色部分
var brightnessStep2 = 15; // 亮度阶梯，深色部分
var lightColorCount = 5; // 浅色数量，主色上
var darkColorCount = 4; // 深色数量，主色下
function getHue(hsv, i, light) {
    var hue;
    // 根据色相不同，色相转向不同
    if (Math.round(hsv.h) >= 60 && Math.round(hsv.h) <= 240) {
        hue = light ? Math.round(hsv.h) - hueStep * i : Math.round(hsv.h) + hueStep * i;
    }
    else {
        hue = light ? Math.round(hsv.h) + hueStep * i : Math.round(hsv.h) - hueStep * i;
    }
    if (hue < 0) {
        hue += 360;
    }
    else if (hue >= 360) {
        hue -= 360;
    }
    return hue;
}
function getSaturation(hsv, i, light) {
    // grey color don't change saturation
    if (hsv.h === 0 && hsv.s === 0) {
        return hsv.s;
    }
    var saturation;
    if (light) {
        saturation = Math.round(hsv.s * 100) - saturationStep * i;
    }
    else if (i === darkColorCount) {
        saturation = Math.round(hsv.s * 100) + saturationStep;
    }
    else {
        saturation = Math.round(hsv.s * 100) + saturationStep2 * i;
    }
    // 边界值修正
    if (saturation > 100) {
        saturation = 100;
    }
    // 第一格的 s 限制在 6-10 之间
    if (light && i === lightColorCount && saturation > 10) {
        saturation = 10;
    }
    if (saturation < 6) {
        saturation = 6;
    }
    return saturation;
}
function getValue(hsv, i, light) {
    if (light) {
        return Math.round(hsv.v * 100) + brightnessStep1 * i;
    }
    return Math.round(hsv.v * 100) - brightnessStep2 * i;
}
function generate(color) {
    var patterns = [];
    var pColor = tinycolor2_1.default(color);
    for (var i = lightColorCount; i > 0; i -= 1) {
        var hsv = pColor.toHsv();
        var colorString = tinycolor2_1.default({
            h: getHue(hsv, i, true),
            s: getSaturation(hsv, i, true),
            v: getValue(hsv, i, true),
        }).toHexString();
        patterns.push(colorString);
    }
    patterns.push(pColor.toHexString());
    for (var i = 1; i <= darkColorCount; i += 1) {
        var hsv = pColor.toHsv();
        var colorString = tinycolor2_1.default({
            h: getHue(hsv, i),
            s: getSaturation(hsv, i),
            v: getValue(hsv, i),
        }).toHexString();
        patterns.push(colorString);
    }
    return patterns;
}
exports.default = generate;


/***/ }),
/* 599 */
/***/ (function(module, exports, __webpack_require__) {

// This file is autogenerated. It's used to publish CJS to npm.
(function (global, factory) {
   true ? module.exports = factory() :
  typeof define === 'function' && define.amd ? define(factory) :
  (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.tinycolor = factory());
})(this, (function () { 'use strict';

  function _typeof(obj) {
    "@babel/helpers - typeof";

    return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) {
      return typeof obj;
    } : function (obj) {
      return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
    }, _typeof(obj);
  }

  // https://github.com/bgrins/TinyColor
  // Brian Grinstead, MIT License

  var trimLeft = /^\s+/;
  var trimRight = /\s+$/;
  function tinycolor(color, opts) {
    color = color ? color : "";
    opts = opts || {};

    // If input is already a tinycolor, return itself
    if (color instanceof tinycolor) {
      return color;
    }
    // If we are called as a function, call using new instead
    if (!(this instanceof tinycolor)) {
      return new tinycolor(color, opts);
    }
    var rgb = inputToRGB(color);
    this._originalInput = color, this._r = rgb.r, this._g = rgb.g, this._b = rgb.b, this._a = rgb.a, this._roundA = Math.round(100 * this._a) / 100, this._format = opts.format || rgb.format;
    this._gradientType = opts.gradientType;

    // Don't let the range of [0,255] come back in [0,1].
    // Potentially lose a little bit of precision here, but will fix issues where
    // .5 gets interpreted as half of the total, instead of half of 1
    // If it was supposed to be 128, this was already taken care of by `inputToRgb`
    if (this._r < 1) this._r = Math.round(this._r);
    if (this._g < 1) this._g = Math.round(this._g);
    if (this._b < 1) this._b = Math.round(this._b);
    this._ok = rgb.ok;
  }
  tinycolor.prototype = {
    isDark: function isDark() {
      return this.getBrightness() < 128;
    },
    isLight: function isLight() {
      return !this.isDark();
    },
    isValid: function isValid() {
      return this._ok;
    },
    getOriginalInput: function getOriginalInput() {
      return this._originalInput;
    },
    getFormat: function getFormat() {
      return this._format;
    },
    getAlpha: function getAlpha() {
      return this._a;
    },
    getBrightness: function getBrightness() {
      //http://www.w3.org/TR/AERT#color-contrast
      var rgb = this.toRgb();
      return (rgb.r * 299 + rgb.g * 587 + rgb.b * 114) / 1000;
    },
    getLuminance: function getLuminance() {
      //http://www.w3.org/TR/2008/REC-WCAG20-20081211/#relativeluminancedef
      var rgb = this.toRgb();
      var RsRGB, GsRGB, BsRGB, R, G, B;
      RsRGB = rgb.r / 255;
      GsRGB = rgb.g / 255;
      BsRGB = rgb.b / 255;
      if (RsRGB <= 0.03928) R = RsRGB / 12.92;else R = Math.pow((RsRGB + 0.055) / 1.055, 2.4);
      if (GsRGB <= 0.03928) G = GsRGB / 12.92;else G = Math.pow((GsRGB + 0.055) / 1.055, 2.4);
      if (BsRGB <= 0.03928) B = BsRGB / 12.92;else B = Math.pow((BsRGB + 0.055) / 1.055, 2.4);
      return 0.2126 * R + 0.7152 * G + 0.0722 * B;
    },
    setAlpha: function setAlpha(value) {
      this._a = boundAlpha(value);
      this._roundA = Math.round(100 * this._a) / 100;
      return this;
    },
    toHsv: function toHsv() {
      var hsv = rgbToHsv(this._r, this._g, this._b);
      return {
        h: hsv.h * 360,
        s: hsv.s,
        v: hsv.v,
        a: this._a
      };
    },
    toHsvString: function toHsvString() {
      var hsv = rgbToHsv(this._r, this._g, this._b);
      var h = Math.round(hsv.h * 360),
        s = Math.round(hsv.s * 100),
        v = Math.round(hsv.v * 100);
      return this._a == 1 ? "hsv(" + h + ", " + s + "%, " + v + "%)" : "hsva(" + h + ", " + s + "%, " + v + "%, " + this._roundA + ")";
    },
    toHsl: function toHsl() {
      var hsl = rgbToHsl(this._r, this._g, this._b);
      return {
        h: hsl.h * 360,
        s: hsl.s,
        l: hsl.l,
        a: this._a
      };
    },
    toHslString: function toHslString() {
      var hsl = rgbToHsl(this._r, this._g, this._b);
      var h = Math.round(hsl.h * 360),
        s = Math.round(hsl.s * 100),
        l = Math.round(hsl.l * 100);
      return this._a == 1 ? "hsl(" + h + ", " + s + "%, " + l + "%)" : "hsla(" + h + ", " + s + "%, " + l + "%, " + this._roundA + ")";
    },
    toHex: function toHex(allow3Char) {
      return rgbToHex(this._r, this._g, this._b, allow3Char);
    },
    toHexString: function toHexString(allow3Char) {
      return "#" + this.toHex(allow3Char);
    },
    toHex8: function toHex8(allow4Char) {
      return rgbaToHex(this._r, this._g, this._b, this._a, allow4Char);
    },
    toHex8String: function toHex8String(allow4Char) {
      return "#" + this.toHex8(allow4Char);
    },
    toRgb: function toRgb() {
      return {
        r: Math.round(this._r),
        g: Math.round(this._g),
        b: Math.round(this._b),
        a: this._a
      };
    },
    toRgbString: function toRgbString() {
      return this._a == 1 ? "rgb(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ")" : "rgba(" + Math.round(this._r) + ", " + Math.round(this._g) + ", " + Math.round(this._b) + ", " + this._roundA + ")";
    },
    toPercentageRgb: function toPercentageRgb() {
      return {
        r: Math.round(bound01(this._r, 255) * 100) + "%",
        g: Math.round(bound01(this._g, 255) * 100) + "%",
        b: Math.round(bound01(this._b, 255) * 100) + "%",
        a: this._a
      };
    },
    toPercentageRgbString: function toPercentageRgbString() {
      return this._a == 1 ? "rgb(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%)" : "rgba(" + Math.round(bound01(this._r, 255) * 100) + "%, " + Math.round(bound01(this._g, 255) * 100) + "%, " + Math.round(bound01(this._b, 255) * 100) + "%, " + this._roundA + ")";
    },
    toName: function toName() {
      if (this._a === 0) {
        return "transparent";
      }
      if (this._a < 1) {
        return false;
      }
      return hexNames[rgbToHex(this._r, this._g, this._b, true)] || false;
    },
    toFilter: function toFilter(secondColor) {
      var hex8String = "#" + rgbaToArgbHex(this._r, this._g, this._b, this._a);
      var secondHex8String = hex8String;
      var gradientType = this._gradientType ? "GradientType = 1, " : "";
      if (secondColor) {
        var s = tinycolor(secondColor);
        secondHex8String = "#" + rgbaToArgbHex(s._r, s._g, s._b, s._a);
      }
      return "progid:DXImageTransform.Microsoft.gradient(" + gradientType + "startColorstr=" + hex8String + ",endColorstr=" + secondHex8String + ")";
    },
    toString: function toString(format) {
      var formatSet = !!format;
      format = format || this._format;
      var formattedString = false;
      var hasAlpha = this._a < 1 && this._a >= 0;
      var needsAlphaFormat = !formatSet && hasAlpha && (format === "hex" || format === "hex6" || format === "hex3" || format === "hex4" || format === "hex8" || format === "name");
      if (needsAlphaFormat) {
        // Special case for "transparent", all other non-alpha formats
        // will return rgba when there is transparency.
        if (format === "name" && this._a === 0) {
          return this.toName();
        }
        return this.toRgbString();
      }
      if (format === "rgb") {
        formattedString = this.toRgbString();
      }
      if (format === "prgb") {
        formattedString = this.toPercentageRgbString();
      }
      if (format === "hex" || format === "hex6") {
        formattedString = this.toHexString();
      }
      if (format === "hex3") {
        formattedString = this.toHexString(true);
      }
      if (format === "hex4") {
        formattedString = this.toHex8String(true);
      }
      if (format === "hex8") {
        formattedString = this.toHex8String();
      }
      if (format === "name") {
        formattedString = this.toName();
      }
      if (format === "hsl") {
        formattedString = this.toHslString();
      }
      if (format === "hsv") {
        formattedString = this.toHsvString();
      }
      return formattedString || this.toHexString();
    },
    clone: function clone() {
      return tinycolor(this.toString());
    },
    _applyModification: function _applyModification(fn, args) {
      var color = fn.apply(null, [this].concat([].slice.call(args)));
      this._r = color._r;
      this._g = color._g;
      this._b = color._b;
      this.setAlpha(color._a);
      return this;
    },
    lighten: function lighten() {
      return this._applyModification(_lighten, arguments);
    },
    brighten: function brighten() {
      return this._applyModification(_brighten, arguments);
    },
    darken: function darken() {
      return this._applyModification(_darken, arguments);
    },
    desaturate: function desaturate() {
      return this._applyModification(_desaturate, arguments);
    },
    saturate: function saturate() {
      return this._applyModification(_saturate, arguments);
    },
    greyscale: function greyscale() {
      return this._applyModification(_greyscale, arguments);
    },
    spin: function spin() {
      return this._applyModification(_spin, arguments);
    },
    _applyCombination: function _applyCombination(fn, args) {
      return fn.apply(null, [this].concat([].slice.call(args)));
    },
    analogous: function analogous() {
      return this._applyCombination(_analogous, arguments);
    },
    complement: function complement() {
      return this._applyCombination(_complement, arguments);
    },
    monochromatic: function monochromatic() {
      return this._applyCombination(_monochromatic, arguments);
    },
    splitcomplement: function splitcomplement() {
      return this._applyCombination(_splitcomplement, arguments);
    },
    // Disabled until https://github.com/bgrins/TinyColor/issues/254
    // polyad: function (number) {
    //   return this._applyCombination(polyad, [number]);
    // },
    triad: function triad() {
      return this._applyCombination(polyad, [3]);
    },
    tetrad: function tetrad() {
      return this._applyCombination(polyad, [4]);
    }
  };

  // If input is an object, force 1 into "1.0" to handle ratios properly
  // String input requires "1.0" as input, so 1 will be treated as 1
  tinycolor.fromRatio = function (color, opts) {
    if (_typeof(color) == "object") {
      var newColor = {};
      for (var i in color) {
        if (color.hasOwnProperty(i)) {
          if (i === "a") {
            newColor[i] = color[i];
          } else {
            newColor[i] = convertToPercentage(color[i]);
          }
        }
      }
      color = newColor;
    }
    return tinycolor(color, opts);
  };

  // Given a string or object, convert that input to RGB
  // Possible string inputs:
  //
  //     "red"
  //     "#f00" or "f00"
  //     "#ff0000" or "ff0000"
  //     "#ff000000" or "ff000000"
  //     "rgb 255 0 0" or "rgb (255, 0, 0)"
  //     "rgb 1.0 0 0" or "rgb (1, 0, 0)"
  //     "rgba (255, 0, 0, 1)" or "rgba 255, 0, 0, 1"
  //     "rgba (1.0, 0, 0, 1)" or "rgba 1.0, 0, 0, 1"
  //     "hsl(0, 100%, 50%)" or "hsl 0 100% 50%"
  //     "hsla(0, 100%, 50%, 1)" or "hsla 0 100% 50%, 1"
  //     "hsv(0, 100%, 100%)" or "hsv 0 100% 100%"
  //
  function inputToRGB(color) {
    var rgb = {
      r: 0,
      g: 0,
      b: 0
    };
    var a = 1;
    var s = null;
    var v = null;
    var l = null;
    var ok = false;
    var format = false;
    if (typeof color == "string") {
      color = stringInputToObject(color);
    }
    if (_typeof(color) == "object") {
      if (isValidCSSUnit(color.r) && isValidCSSUnit(color.g) && isValidCSSUnit(color.b)) {
        rgb = rgbToRgb(color.r, color.g, color.b);
        ok = true;
        format = String(color.r).substr(-1) === "%" ? "prgb" : "rgb";
      } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.v)) {
        s = convertToPercentage(color.s);
        v = convertToPercentage(color.v);
        rgb = hsvToRgb(color.h, s, v);
        ok = true;
        format = "hsv";
      } else if (isValidCSSUnit(color.h) && isValidCSSUnit(color.s) && isValidCSSUnit(color.l)) {
        s = convertToPercentage(color.s);
        l = convertToPercentage(color.l);
        rgb = hslToRgb(color.h, s, l);
        ok = true;
        format = "hsl";
      }
      if (color.hasOwnProperty("a")) {
        a = color.a;
      }
    }
    a = boundAlpha(a);
    return {
      ok: ok,
      format: color.format || format,
      r: Math.min(255, Math.max(rgb.r, 0)),
      g: Math.min(255, Math.max(rgb.g, 0)),
      b: Math.min(255, Math.max(rgb.b, 0)),
      a: a
    };
  }

  // Conversion Functions
  // --------------------

  // `rgbToHsl`, `rgbToHsv`, `hslToRgb`, `hsvToRgb` modified from:
  // <http://mjijackson.com/2008/02/rgb-to-hsl-and-rgb-to-hsv-color-model-conversion-algorithms-in-javascript>

  // `rgbToRgb`
  // Handle bounds / percentage checking to conform to CSS color spec
  // <http://www.w3.org/TR/css3-color/>
  // *Assumes:* r, g, b in [0, 255] or [0, 1]
  // *Returns:* { r, g, b } in [0, 255]
  function rgbToRgb(r, g, b) {
    return {
      r: bound01(r, 255) * 255,
      g: bound01(g, 255) * 255,
      b: bound01(b, 255) * 255
    };
  }

  // `rgbToHsl`
  // Converts an RGB color value to HSL.
  // *Assumes:* r, g, and b are contained in [0, 255] or [0, 1]
  // *Returns:* { h, s, l } in [0,1]
  function rgbToHsl(r, g, b) {
    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);
    var max = Math.max(r, g, b),
      min = Math.min(r, g, b);
    var h,
      s,
      l = (max + min) / 2;
    if (max == min) {
      h = s = 0; // achromatic
    } else {
      var d = max - min;
      s = l > 0.5 ? d / (2 - max - min) : d / (max + min);
      switch (max) {
        case r:
          h = (g - b) / d + (g < b ? 6 : 0);
          break;
        case g:
          h = (b - r) / d + 2;
          break;
        case b:
          h = (r - g) / d + 4;
          break;
      }
      h /= 6;
    }
    return {
      h: h,
      s: s,
      l: l
    };
  }

  // `hslToRgb`
  // Converts an HSL color value to RGB.
  // *Assumes:* h is contained in [0, 1] or [0, 360] and s and l are contained [0, 1] or [0, 100]
  // *Returns:* { r, g, b } in the set [0, 255]
  function hslToRgb(h, s, l) {
    var r, g, b;
    h = bound01(h, 360);
    s = bound01(s, 100);
    l = bound01(l, 100);
    function hue2rgb(p, q, t) {
      if (t < 0) t += 1;
      if (t > 1) t -= 1;
      if (t < 1 / 6) return p + (q - p) * 6 * t;
      if (t < 1 / 2) return q;
      if (t < 2 / 3) return p + (q - p) * (2 / 3 - t) * 6;
      return p;
    }
    if (s === 0) {
      r = g = b = l; // achromatic
    } else {
      var q = l < 0.5 ? l * (1 + s) : l + s - l * s;
      var p = 2 * l - q;
      r = hue2rgb(p, q, h + 1 / 3);
      g = hue2rgb(p, q, h);
      b = hue2rgb(p, q, h - 1 / 3);
    }
    return {
      r: r * 255,
      g: g * 255,
      b: b * 255
    };
  }

  // `rgbToHsv`
  // Converts an RGB color value to HSV
  // *Assumes:* r, g, and b are contained in the set [0, 255] or [0, 1]
  // *Returns:* { h, s, v } in [0,1]
  function rgbToHsv(r, g, b) {
    r = bound01(r, 255);
    g = bound01(g, 255);
    b = bound01(b, 255);
    var max = Math.max(r, g, b),
      min = Math.min(r, g, b);
    var h,
      s,
      v = max;
    var d = max - min;
    s = max === 0 ? 0 : d / max;
    if (max == min) {
      h = 0; // achromatic
    } else {
      switch (max) {
        case r:
          h = (g - b) / d + (g < b ? 6 : 0);
          break;
        case g:
          h = (b - r) / d + 2;
          break;
        case b:
          h = (r - g) / d + 4;
          break;
      }
      h /= 6;
    }
    return {
      h: h,
      s: s,
      v: v
    };
  }

  // `hsvToRgb`
  // Converts an HSV color value to RGB.
  // *Assumes:* h is contained in [0, 1] or [0, 360] and s and v are contained in [0, 1] or [0, 100]
  // *Returns:* { r, g, b } in the set [0, 255]
  function hsvToRgb(h, s, v) {
    h = bound01(h, 360) * 6;
    s = bound01(s, 100);
    v = bound01(v, 100);
    var i = Math.floor(h),
      f = h - i,
      p = v * (1 - s),
      q = v * (1 - f * s),
      t = v * (1 - (1 - f) * s),
      mod = i % 6,
      r = [v, q, p, p, t, v][mod],
      g = [t, v, v, q, p, p][mod],
      b = [p, p, t, v, v, q][mod];
    return {
      r: r * 255,
      g: g * 255,
      b: b * 255
    };
  }

  // `rgbToHex`
  // Converts an RGB color to hex
  // Assumes r, g, and b are contained in the set [0, 255]
  // Returns a 3 or 6 character hex
  function rgbToHex(r, g, b, allow3Char) {
    var hex = [pad2(Math.round(r).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16))];

    // Return a 3 character hex if possible
    if (allow3Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1)) {
      return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0);
    }
    return hex.join("");
  }

  // `rgbaToHex`
  // Converts an RGBA color plus alpha transparency to hex
  // Assumes r, g, b are contained in the set [0, 255] and
  // a in [0, 1]. Returns a 4 or 8 character rgba hex
  function rgbaToHex(r, g, b, a, allow4Char) {
    var hex = [pad2(Math.round(r).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16)), pad2(convertDecimalToHex(a))];

    // Return a 4 character hex if possible
    if (allow4Char && hex[0].charAt(0) == hex[0].charAt(1) && hex[1].charAt(0) == hex[1].charAt(1) && hex[2].charAt(0) == hex[2].charAt(1) && hex[3].charAt(0) == hex[3].charAt(1)) {
      return hex[0].charAt(0) + hex[1].charAt(0) + hex[2].charAt(0) + hex[3].charAt(0);
    }
    return hex.join("");
  }

  // `rgbaToArgbHex`
  // Converts an RGBA color to an ARGB Hex8 string
  // Rarely used, but required for "toFilter()"
  function rgbaToArgbHex(r, g, b, a) {
    var hex = [pad2(convertDecimalToHex(a)), pad2(Math.round(r).toString(16)), pad2(Math.round(g).toString(16)), pad2(Math.round(b).toString(16))];
    return hex.join("");
  }

  // `equals`
  // Can be called with any tinycolor input
  tinycolor.equals = function (color1, color2) {
    if (!color1 || !color2) return false;
    return tinycolor(color1).toRgbString() == tinycolor(color2).toRgbString();
  };
  tinycolor.random = function () {
    return tinycolor.fromRatio({
      r: Math.random(),
      g: Math.random(),
      b: Math.random()
    });
  };

  // Modification Functions
  // ----------------------
  // Thanks to less.js for some of the basics here
  // <https://github.com/cloudhead/less.js/blob/master/lib/less/functions.js>

  function _desaturate(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = tinycolor(color).toHsl();
    hsl.s -= amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
  }
  function _saturate(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = tinycolor(color).toHsl();
    hsl.s += amount / 100;
    hsl.s = clamp01(hsl.s);
    return tinycolor(hsl);
  }
  function _greyscale(color) {
    return tinycolor(color).desaturate(100);
  }
  function _lighten(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = tinycolor(color).toHsl();
    hsl.l += amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
  }
  function _brighten(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var rgb = tinycolor(color).toRgb();
    rgb.r = Math.max(0, Math.min(255, rgb.r - Math.round(255 * -(amount / 100))));
    rgb.g = Math.max(0, Math.min(255, rgb.g - Math.round(255 * -(amount / 100))));
    rgb.b = Math.max(0, Math.min(255, rgb.b - Math.round(255 * -(amount / 100))));
    return tinycolor(rgb);
  }
  function _darken(color, amount) {
    amount = amount === 0 ? 0 : amount || 10;
    var hsl = tinycolor(color).toHsl();
    hsl.l -= amount / 100;
    hsl.l = clamp01(hsl.l);
    return tinycolor(hsl);
  }

  // Spin takes a positive or negative amount within [-360, 360] indicating the change of hue.
  // Values outside of this range will be wrapped into this range.
  function _spin(color, amount) {
    var hsl = tinycolor(color).toHsl();
    var hue = (hsl.h + amount) % 360;
    hsl.h = hue < 0 ? 360 + hue : hue;
    return tinycolor(hsl);
  }

  // Combination Functions
  // ---------------------
  // Thanks to jQuery xColor for some of the ideas behind these
  // <https://github.com/infusion/jQuery-xcolor/blob/master/jquery.xcolor.js>

  function _complement(color) {
    var hsl = tinycolor(color).toHsl();
    hsl.h = (hsl.h + 180) % 360;
    return tinycolor(hsl);
  }
  function polyad(color, number) {
    if (isNaN(number) || number <= 0) {
      throw new Error("Argument to polyad must be a positive number");
    }
    var hsl = tinycolor(color).toHsl();
    var result = [tinycolor(color)];
    var step = 360 / number;
    for (var i = 1; i < number; i++) {
      result.push(tinycolor({
        h: (hsl.h + i * step) % 360,
        s: hsl.s,
        l: hsl.l
      }));
    }
    return result;
  }
  function _splitcomplement(color) {
    var hsl = tinycolor(color).toHsl();
    var h = hsl.h;
    return [tinycolor(color), tinycolor({
      h: (h + 72) % 360,
      s: hsl.s,
      l: hsl.l
    }), tinycolor({
      h: (h + 216) % 360,
      s: hsl.s,
      l: hsl.l
    })];
  }
  function _analogous(color, results, slices) {
    results = results || 6;
    slices = slices || 30;
    var hsl = tinycolor(color).toHsl();
    var part = 360 / slices;
    var ret = [tinycolor(color)];
    for (hsl.h = (hsl.h - (part * results >> 1) + 720) % 360; --results;) {
      hsl.h = (hsl.h + part) % 360;
      ret.push(tinycolor(hsl));
    }
    return ret;
  }
  function _monochromatic(color, results) {
    results = results || 6;
    var hsv = tinycolor(color).toHsv();
    var h = hsv.h,
      s = hsv.s,
      v = hsv.v;
    var ret = [];
    var modification = 1 / results;
    while (results--) {
      ret.push(tinycolor({
        h: h,
        s: s,
        v: v
      }));
      v = (v + modification) % 1;
    }
    return ret;
  }

  // Utility Functions
  // ---------------------

  tinycolor.mix = function (color1, color2, amount) {
    amount = amount === 0 ? 0 : amount || 50;
    var rgb1 = tinycolor(color1).toRgb();
    var rgb2 = tinycolor(color2).toRgb();
    var p = amount / 100;
    var rgba = {
      r: (rgb2.r - rgb1.r) * p + rgb1.r,
      g: (rgb2.g - rgb1.g) * p + rgb1.g,
      b: (rgb2.b - rgb1.b) * p + rgb1.b,
      a: (rgb2.a - rgb1.a) * p + rgb1.a
    };
    return tinycolor(rgba);
  };

  // Readability Functions
  // ---------------------
  // <http://www.w3.org/TR/2008/REC-WCAG20-20081211/#contrast-ratiodef (WCAG Version 2)

  // `contrast`
  // Analyze the 2 colors and returns the color contrast defined by (WCAG Version 2)
  tinycolor.readability = function (color1, color2) {
    var c1 = tinycolor(color1);
    var c2 = tinycolor(color2);
    return (Math.max(c1.getLuminance(), c2.getLuminance()) + 0.05) / (Math.min(c1.getLuminance(), c2.getLuminance()) + 0.05);
  };

  // `isReadable`
  // Ensure that foreground and background color combinations meet WCAG2 guidelines.
  // The third argument is an optional Object.
  //      the 'level' property states 'AA' or 'AAA' - if missing or invalid, it defaults to 'AA';
  //      the 'size' property states 'large' or 'small' - if missing or invalid, it defaults to 'small'.
  // If the entire object is absent, isReadable defaults to {level:"AA",size:"small"}.

  // *Example*
  //    tinycolor.isReadable("#000", "#111") => false
  //    tinycolor.isReadable("#000", "#111",{level:"AA",size:"large"}) => false
  tinycolor.isReadable = function (color1, color2, wcag2) {
    var readability = tinycolor.readability(color1, color2);
    var wcag2Parms, out;
    out = false;
    wcag2Parms = validateWCAG2Parms(wcag2);
    switch (wcag2Parms.level + wcag2Parms.size) {
      case "AAsmall":
      case "AAAlarge":
        out = readability >= 4.5;
        break;
      case "AAlarge":
        out = readability >= 3;
        break;
      case "AAAsmall":
        out = readability >= 7;
        break;
    }
    return out;
  };

  // `mostReadable`
  // Given a base color and a list of possible foreground or background
  // colors for that base, returns the most readable color.
  // Optionally returns Black or White if the most readable color is unreadable.
  // *Example*
  //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:false}).toHexString(); // "#112255"
  //    tinycolor.mostReadable(tinycolor.mostReadable("#123", ["#124", "#125"],{includeFallbackColors:true}).toHexString();  // "#ffffff"
  //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"large"}).toHexString(); // "#faf3f3"
  //    tinycolor.mostReadable("#a8015a", ["#faf3f3"],{includeFallbackColors:true,level:"AAA",size:"small"}).toHexString(); // "#ffffff"
  tinycolor.mostReadable = function (baseColor, colorList, args) {
    var bestColor = null;
    var bestScore = 0;
    var readability;
    var includeFallbackColors, level, size;
    args = args || {};
    includeFallbackColors = args.includeFallbackColors;
    level = args.level;
    size = args.size;
    for (var i = 0; i < colorList.length; i++) {
      readability = tinycolor.readability(baseColor, colorList[i]);
      if (readability > bestScore) {
        bestScore = readability;
        bestColor = tinycolor(colorList[i]);
      }
    }
    if (tinycolor.isReadable(baseColor, bestColor, {
      level: level,
      size: size
    }) || !includeFallbackColors) {
      return bestColor;
    } else {
      args.includeFallbackColors = false;
      return tinycolor.mostReadable(baseColor, ["#fff", "#000"], args);
    }
  };

  // Big List of Colors
  // ------------------
  // <https://www.w3.org/TR/css-color-4/#named-colors>
  var names = tinycolor.names = {
    aliceblue: "f0f8ff",
    antiquewhite: "faebd7",
    aqua: "0ff",
    aquamarine: "7fffd4",
    azure: "f0ffff",
    beige: "f5f5dc",
    bisque: "ffe4c4",
    black: "000",
    blanchedalmond: "ffebcd",
    blue: "00f",
    blueviolet: "8a2be2",
    brown: "a52a2a",
    burlywood: "deb887",
    burntsienna: "ea7e5d",
    cadetblue: "5f9ea0",
    chartreuse: "7fff00",
    chocolate: "d2691e",
    coral: "ff7f50",
    cornflowerblue: "6495ed",
    cornsilk: "fff8dc",
    crimson: "dc143c",
    cyan: "0ff",
    darkblue: "00008b",
    darkcyan: "008b8b",
    darkgoldenrod: "b8860b",
    darkgray: "a9a9a9",
    darkgreen: "006400",
    darkgrey: "a9a9a9",
    darkkhaki: "bdb76b",
    darkmagenta: "8b008b",
    darkolivegreen: "556b2f",
    darkorange: "ff8c00",
    darkorchid: "9932cc",
    darkred: "8b0000",
    darksalmon: "e9967a",
    darkseagreen: "8fbc8f",
    darkslateblue: "483d8b",
    darkslategray: "2f4f4f",
    darkslategrey: "2f4f4f",
    darkturquoise: "00ced1",
    darkviolet: "9400d3",
    deeppink: "ff1493",
    deepskyblue: "00bfff",
    dimgray: "696969",
    dimgrey: "696969",
    dodgerblue: "1e90ff",
    firebrick: "b22222",
    floralwhite: "fffaf0",
    forestgreen: "228b22",
    fuchsia: "f0f",
    gainsboro: "dcdcdc",
    ghostwhite: "f8f8ff",
    gold: "ffd700",
    goldenrod: "daa520",
    gray: "808080",
    green: "008000",
    greenyellow: "adff2f",
    grey: "808080",
    honeydew: "f0fff0",
    hotpink: "ff69b4",
    indianred: "cd5c5c",
    indigo: "4b0082",
    ivory: "fffff0",
    khaki: "f0e68c",
    lavender: "e6e6fa",
    lavenderblush: "fff0f5",
    lawngreen: "7cfc00",
    lemonchiffon: "fffacd",
    lightblue: "add8e6",
    lightcoral: "f08080",
    lightcyan: "e0ffff",
    lightgoldenrodyellow: "fafad2",
    lightgray: "d3d3d3",
    lightgreen: "90ee90",
    lightgrey: "d3d3d3",
    lightpink: "ffb6c1",
    lightsalmon: "ffa07a",
    lightseagreen: "20b2aa",
    lightskyblue: "87cefa",
    lightslategray: "789",
    lightslategrey: "789",
    lightsteelblue: "b0c4de",
    lightyellow: "ffffe0",
    lime: "0f0",
    limegreen: "32cd32",
    linen: "faf0e6",
    magenta: "f0f",
    maroon: "800000",
    mediumaquamarine: "66cdaa",
    mediumblue: "0000cd",
    mediumorchid: "ba55d3",
    mediumpurple: "9370db",
    mediumseagreen: "3cb371",
    mediumslateblue: "7b68ee",
    mediumspringgreen: "00fa9a",
    mediumturquoise: "48d1cc",
    mediumvioletred: "c71585",
    midnightblue: "191970",
    mintcream: "f5fffa",
    mistyrose: "ffe4e1",
    moccasin: "ffe4b5",
    navajowhite: "ffdead",
    navy: "000080",
    oldlace: "fdf5e6",
    olive: "808000",
    olivedrab: "6b8e23",
    orange: "ffa500",
    orangered: "ff4500",
    orchid: "da70d6",
    palegoldenrod: "eee8aa",
    palegreen: "98fb98",
    paleturquoise: "afeeee",
    palevioletred: "db7093",
    papayawhip: "ffefd5",
    peachpuff: "ffdab9",
    peru: "cd853f",
    pink: "ffc0cb",
    plum: "dda0dd",
    powderblue: "b0e0e6",
    purple: "800080",
    rebeccapurple: "663399",
    red: "f00",
    rosybrown: "bc8f8f",
    royalblue: "4169e1",
    saddlebrown: "8b4513",
    salmon: "fa8072",
    sandybrown: "f4a460",
    seagreen: "2e8b57",
    seashell: "fff5ee",
    sienna: "a0522d",
    silver: "c0c0c0",
    skyblue: "87ceeb",
    slateblue: "6a5acd",
    slategray: "708090",
    slategrey: "708090",
    snow: "fffafa",
    springgreen: "00ff7f",
    steelblue: "4682b4",
    tan: "d2b48c",
    teal: "008080",
    thistle: "d8bfd8",
    tomato: "ff6347",
    turquoise: "40e0d0",
    violet: "ee82ee",
    wheat: "f5deb3",
    white: "fff",
    whitesmoke: "f5f5f5",
    yellow: "ff0",
    yellowgreen: "9acd32"
  };

  // Make it easy to access colors via `hexNames[hex]`
  var hexNames = tinycolor.hexNames = flip(names);

  // Utilities
  // ---------

  // `{ 'name1': 'val1' }` becomes `{ 'val1': 'name1' }`
  function flip(o) {
    var flipped = {};
    for (var i in o) {
      if (o.hasOwnProperty(i)) {
        flipped[o[i]] = i;
      }
    }
    return flipped;
  }

  // Return a valid alpha value [0,1] with all invalid values being set to 1
  function boundAlpha(a) {
    a = parseFloat(a);
    if (isNaN(a) || a < 0 || a > 1) {
      a = 1;
    }
    return a;
  }

  // Take input from [0, n] and return it as [0, 1]
  function bound01(n, max) {
    if (isOnePointZero(n)) n = "100%";
    var processPercent = isPercentage(n);
    n = Math.min(max, Math.max(0, parseFloat(n)));

    // Automatically convert percentage into number
    if (processPercent) {
      n = parseInt(n * max, 10) / 100;
    }

    // Handle floating point rounding errors
    if (Math.abs(n - max) < 0.000001) {
      return 1;
    }

    // Convert into [0, 1] range if it isn't already
    return n % max / parseFloat(max);
  }

  // Force a number between 0 and 1
  function clamp01(val) {
    return Math.min(1, Math.max(0, val));
  }

  // Parse a base-16 hex value into a base-10 integer
  function parseIntFromHex(val) {
    return parseInt(val, 16);
  }

  // Need to handle 1.0 as 100%, since once it is a number, there is no difference between it and 1
  // <http://stackoverflow.com/questions/7422072/javascript-how-to-detect-number-as-a-decimal-including-1-0>
  function isOnePointZero(n) {
    return typeof n == "string" && n.indexOf(".") != -1 && parseFloat(n) === 1;
  }

  // Check to see if string passed in is a percentage
  function isPercentage(n) {
    return typeof n === "string" && n.indexOf("%") != -1;
  }

  // Force a hex value to have 2 characters
  function pad2(c) {
    return c.length == 1 ? "0" + c : "" + c;
  }

  // Replace a decimal with it's percentage value
  function convertToPercentage(n) {
    if (n <= 1) {
      n = n * 100 + "%";
    }
    return n;
  }

  // Converts a decimal to a hex value
  function convertDecimalToHex(d) {
    return Math.round(parseFloat(d) * 255).toString(16);
  }
  // Converts a hex value to a decimal
  function convertHexToDecimal(h) {
    return parseIntFromHex(h) / 255;
  }
  var matchers = function () {
    // <http://www.w3.org/TR/css3-values/#integers>
    var CSS_INTEGER = "[-\\+]?\\d+%?";

    // <http://www.w3.org/TR/css3-values/#number-value>
    var CSS_NUMBER = "[-\\+]?\\d*\\.\\d+%?";

    // Allow positive/negative integer/number.  Don't capture the either/or, just the entire outcome.
    var CSS_UNIT = "(?:" + CSS_NUMBER + ")|(?:" + CSS_INTEGER + ")";

    // Actual matching.
    // Parentheses and commas are optional, but not required.
    // Whitespace can take the place of commas or opening paren
    var PERMISSIVE_MATCH3 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    var PERMISSIVE_MATCH4 = "[\\s|\\(]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")[,|\\s]+(" + CSS_UNIT + ")\\s*\\)?";
    return {
      CSS_UNIT: new RegExp(CSS_UNIT),
      rgb: new RegExp("rgb" + PERMISSIVE_MATCH3),
      rgba: new RegExp("rgba" + PERMISSIVE_MATCH4),
      hsl: new RegExp("hsl" + PERMISSIVE_MATCH3),
      hsla: new RegExp("hsla" + PERMISSIVE_MATCH4),
      hsv: new RegExp("hsv" + PERMISSIVE_MATCH3),
      hsva: new RegExp("hsva" + PERMISSIVE_MATCH4),
      hex3: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
      hex6: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/,
      hex4: /^#?([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})([0-9a-fA-F]{1})$/,
      hex8: /^#?([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})([0-9a-fA-F]{2})$/
    };
  }();

  // `isValidCSSUnit`
  // Take in a single string / number and check to see if it looks like a CSS unit
  // (see `matchers` above for definition).
  function isValidCSSUnit(color) {
    return !!matchers.CSS_UNIT.exec(color);
  }

  // `stringInputToObject`
  // Permissive string parsing.  Take in a number of formats, and output an object
  // based on detected format.  Returns `{ r, g, b }` or `{ h, s, l }` or `{ h, s, v}`
  function stringInputToObject(color) {
    color = color.replace(trimLeft, "").replace(trimRight, "").toLowerCase();
    var named = false;
    if (names[color]) {
      color = names[color];
      named = true;
    } else if (color == "transparent") {
      return {
        r: 0,
        g: 0,
        b: 0,
        a: 0,
        format: "name"
      };
    }

    // Try to match string input using regular expressions.
    // Keep most of the number bounding out of this function - don't worry about [0,1] or [0,100] or [0,360]
    // Just return an object and let the conversion functions handle that.
    // This way the result will be the same whether the tinycolor is initialized with string or object.
    var match;
    if (match = matchers.rgb.exec(color)) {
      return {
        r: match[1],
        g: match[2],
        b: match[3]
      };
    }
    if (match = matchers.rgba.exec(color)) {
      return {
        r: match[1],
        g: match[2],
        b: match[3],
        a: match[4]
      };
    }
    if (match = matchers.hsl.exec(color)) {
      return {
        h: match[1],
        s: match[2],
        l: match[3]
      };
    }
    if (match = matchers.hsla.exec(color)) {
      return {
        h: match[1],
        s: match[2],
        l: match[3],
        a: match[4]
      };
    }
    if (match = matchers.hsv.exec(color)) {
      return {
        h: match[1],
        s: match[2],
        v: match[3]
      };
    }
    if (match = matchers.hsva.exec(color)) {
      return {
        h: match[1],
        s: match[2],
        v: match[3],
        a: match[4]
      };
    }
    if (match = matchers.hex8.exec(color)) {
      return {
        r: parseIntFromHex(match[1]),
        g: parseIntFromHex(match[2]),
        b: parseIntFromHex(match[3]),
        a: convertHexToDecimal(match[4]),
        format: named ? "name" : "hex8"
      };
    }
    if (match = matchers.hex6.exec(color)) {
      return {
        r: parseIntFromHex(match[1]),
        g: parseIntFromHex(match[2]),
        b: parseIntFromHex(match[3]),
        format: named ? "name" : "hex"
      };
    }
    if (match = matchers.hex4.exec(color)) {
      return {
        r: parseIntFromHex(match[1] + "" + match[1]),
        g: parseIntFromHex(match[2] + "" + match[2]),
        b: parseIntFromHex(match[3] + "" + match[3]),
        a: convertHexToDecimal(match[4] + "" + match[4]),
        format: named ? "name" : "hex8"
      };
    }
    if (match = matchers.hex3.exec(color)) {
      return {
        r: parseIntFromHex(match[1] + "" + match[1]),
        g: parseIntFromHex(match[2] + "" + match[2]),
        b: parseIntFromHex(match[3] + "" + match[3]),
        format: named ? "name" : "hex"
      };
    }
    return false;
  }
  function validateWCAG2Parms(parms) {
    // return valid WCAG2 parms for isReadable.
    // If input parms are invalid, return {"level":"AA", "size":"small"}
    var level, size;
    parms = parms || {
      level: "AA",
      size: "small"
    };
    level = (parms.level || "AA").toUpperCase();
    size = (parms.size || "small").toLowerCase();
    if (level !== "AA" && level !== "AAA") {
      level = "AA";
    }
    if (size !== "small" && size !== "large") {
      size = "small";
    }
    return {
      level: level,
      size: size
    };
  }

  return tinycolor;

}));


/***/ }),
/* 600 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = create;

var React = _interopRequireWildcard(__webpack_require__(0));

var _index = _interopRequireDefault(__webpack_require__(60));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var customCache = new Set();

function create() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var scriptUrl = options.scriptUrl,
      _options$extraCommonP = options.extraCommonProps,
      extraCommonProps = _options$extraCommonP === void 0 ? {} : _options$extraCommonP;
  /**
   * DOM API required.
   * Make sure in browser environment.
   * The Custom Icon will create a <script/>
   * that loads SVG symbols and insert the SVG Element into the document body.
   */

  if (typeof document !== 'undefined' && typeof window !== 'undefined' && typeof document.createElement === 'function' && typeof scriptUrl === 'string' && scriptUrl.length && !customCache.has(scriptUrl)) {
    var script = document.createElement('script');
    script.setAttribute('src', scriptUrl);
    script.setAttribute('data-namespace', scriptUrl);
    customCache.add(scriptUrl);
    document.body.appendChild(script);
  }

  var Iconfont = function Iconfont(props) {
    var type = props.type,
        children = props.children,
        restProps = __rest(props, ["type", "children"]); // component > children > type


    var content = null;

    if (props.type) {
      content = /*#__PURE__*/React.createElement("use", {
        xlinkHref: "#".concat(type)
      });
    }

    if (children) {
      content = children;
    }

    return /*#__PURE__*/React.createElement(_index["default"], _extends({}, extraCommonProps, restProps), content);
  };

  Iconfont.displayName = 'Iconfont';
  return Iconfont;
}

/***/ }),
/* 601 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getThemeFromTypeName = getThemeFromTypeName;
exports.removeTypeTheme = removeTypeTheme;
exports.withThemeSuffix = withThemeSuffix;
exports.alias = alias;
exports.svgBaseProps = void 0;

var _warning = _interopRequireDefault(__webpack_require__(64));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// These props make sure that the SVG behaviours like general text.
// Reference: https://blog.prototypr.io/align-svg-icons-to-text-and-say-goodbye-to-font-icons-d44b3d7b26b4
var svgBaseProps = {
  width: '1em',
  height: '1em',
  fill: 'currentColor',
  'aria-hidden': true,
  focusable: 'false'
};
exports.svgBaseProps = svgBaseProps;
var fillTester = /-fill$/;
var outlineTester = /-o$/;
var twoToneTester = /-twotone$/;

function getThemeFromTypeName(type) {
  var result = null;

  if (fillTester.test(type)) {
    result = 'filled';
  } else if (outlineTester.test(type)) {
    result = 'outlined';
  } else if (twoToneTester.test(type)) {
    result = 'twoTone';
  }

  return result;
}

function removeTypeTheme(type) {
  return type.replace(fillTester, '').replace(outlineTester, '').replace(twoToneTester, '');
}

function withThemeSuffix(type, theme) {
  var result = type;

  if (theme === 'filled') {
    result += '-fill';
  } else if (theme === 'outlined') {
    result += '-o';
  } else if (theme === 'twoTone') {
    result += '-twotone';
  } else {
    (0, _warning["default"])(false, 'Icon', "This icon '".concat(type, "' has unknown theme '").concat(theme, "'"));
  }

  return result;
} // For alias or compatibility


function alias(type) {
  var newType = type;

  switch (type) {
    case 'cross':
      newType = 'close';
      break;
    // https://github.com/ant-design/ant-design/issues/13007

    case 'interation':
      newType = 'interaction';
      break;
    // https://github.com/ant-design/ant-design/issues/16810

    case 'canlendar':
      newType = 'calendar';
      break;
    // https://github.com/ant-design/ant-design/issues/17448

    case 'colum-height':
      newType = 'column-height';
      break;

    default:
  }

  (0, _warning["default"])(newType === type, 'Icon', "Icon '".concat(type, "' was a typo and is now deprecated, please use '").concat(newType, "' instead."));
  return newType;
}

/***/ }),
/* 602 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _default2 = _interopRequireDefault(__webpack_require__(287));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _default2["default"];
exports["default"] = _default;

/***/ }),
/* 603 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports['default'] = {
  // Options.jsx
  items_per_page: '/ page',
  jump_to: 'Go to',
  jump_to_confirm: 'confirm',
  page: '',

  // Pagination.jsx
  prev_page: 'Previous Page',
  next_page: 'Next Page',
  prev_5: 'Previous 5 Pages',
  next_5: 'Next 5 Pages',
  prev_3: 'Previous 3 Pages',
  next_3: 'Next 3 Pages'
};
module.exports = exports['default'];

/***/ }),
/* 604 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports['default'] = {
  today: 'Today',
  now: 'Now',
  backToToday: 'Back to today',
  ok: 'Ok',
  clear: 'Clear',
  month: 'Month',
  year: 'Year',
  timeSelect: 'select time',
  dateSelect: 'select date',
  weekSelect: 'Choose a week',
  monthSelect: 'Choose a month',
  yearSelect: 'Choose a year',
  decadeSelect: 'Choose a decade',
  yearFormat: 'YYYY',
  dateFormat: 'M/D/YYYY',
  dayFormat: 'D',
  dateTimeFormat: 'M/D/YYYY HH:mm:ss',
  monthBeforeYear: true,
  previousMonth: 'Previous month (PageUp)',
  nextMonth: 'Next month (PageDown)',
  previousYear: 'Last year (Control + left)',
  nextYear: 'Next year (Control + right)',
  previousDecade: 'Last decade',
  nextDecade: 'Next decade',
  previousCentury: 'Last century',
  nextCentury: 'Next century'
};
module.exports = exports['default'];

/***/ }),
/* 605 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _en_US = _interopRequireDefault(__webpack_require__(288));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

var _default = _en_US["default"];
exports["default"] = _default;

/***/ }),
/* 606 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.setTwoToneColor = setTwoToneColor;
exports.getTwoToneColor = getTwoToneColor;

var _iconsReact = _interopRequireDefault(__webpack_require__(273));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function setTwoToneColor(primaryColor) {
  return _iconsReact["default"].setTwoToneColors({
    primaryColor: primaryColor
  });
}

function getTwoToneColor() {
  var colors = _iconsReact["default"].getTwoToneColors();

  return colors.primaryColor;
}

/***/ }),
/* 607 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hoc__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_dec2,_class,_class2,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var mapStateToProps=function mapStateToProps(state){return state;};var actionToProps={};var FooterMenu=(_dec=Object(__WEBPACK_IMPORTED_MODULE_3__hoc__["a" /* multiLanguage */])(),_dec2=Object(__WEBPACK_IMPORTED_MODULE_3__hoc__["b" /* withRedux */])(mapStateToProps,actionToProps),_dec(_class=_dec2(_class=(_temp=_class2=function(_Component){_inherits(FooterMenu,_Component);function FooterMenu(){_classCallCheck(this,FooterMenu);return _possibleConstructorReturn(this,(FooterMenu.__proto__||Object.getPrototypeOf(FooterMenu)).apply(this,arguments));}_createClass(FooterMenu,[{key:"render",value:function render(){var t=this.props.t;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"footer-menu"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"menu-box"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",null,t("Locations")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"http://www.bintan.lagunaproperty.com"},t("Bintan"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://lagunaproperty.com/en/project/phuket/laguna-park"},t("Phuket"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"http://www.lagunalangco.com/en/"},t("Lăng Cô"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"menu-box"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",null,t("The Santuary Club")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://lagunaproperty.com/en/sanctuary-club"},t("About the Club"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://lagunaproperty.com/en/sanctuary-club#ExclusivePrivileges"},t("Exclusive Privileges"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://lagunaproperty.com/en/sanctuary-club#ExchangeProgramme"},t("Exchange Programme"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://lagunaproperty.com/en/sanctuary-club#Network"},t("The Network"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"menu-box"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",null,t("Resales")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://lagunaproperty.com/en/resale/"},t("Properties"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://lagunaproperty.com/en/resale/faq"},t("FAQ"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"menu-box"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",null,t("Rentals")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://lagunaproperty.com/en/rental"},t("Properties"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://lagunaproperty.com/en/rental/faq"},t("FAQ"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"menu-box"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",null,t("News/Promotions")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://lagunaproperty.com/en/news/"},t("News/Promotions"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://lagunaproperty.com/en/construction-progress/"},t("Construction Progress"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"menu-box"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",null,t("About us")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://lagunaproperty.com/en/about-us#Mission"},t("Our Mission"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://lagunaproperty.com/en/about-us#Developer"},t("Developer"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"https://lagunaproperty.com/en/about-us#Milestones"},t("Milestones"))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"menu-box the-last-one"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",null,t("Newsletter signup")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers__["e" /* NewsletterForm */],null)));}}]);return FooterMenu;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class2.propTypes={t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func.isRequired},_temp))||_class)||_class);/* harmony default export */ __webpack_exports__["a"] = (FooterMenu);

/***/ }),
/* 608 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Newsletter; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_input__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form_style__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__hoc__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_dec2,_class,_class2,_temp2;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FormItem=__WEBPACK_IMPORTED_MODULE_4_antd_lib_form___default.a.Item;var Newsletter=(_dec=__WEBPACK_IMPORTED_MODULE_4_antd_lib_form___default.a.create(),_dec2=Object(__WEBPACK_IMPORTED_MODULE_7__hoc__["a" /* multiLanguage */])(),_dec(_class=_dec2(_class=(_temp2=_class2=function(_Component){_inherits(Newsletter,_Component);function Newsletter(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,Newsletter);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Newsletter.__proto__||Object.getPrototypeOf(Newsletter)).call.apply(_ref,[this].concat(args))),_this),_this.state={submitting:false},_this.submit=function(){var _ref2=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.mark(function _callee(data){var submitting;return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:submitting=_this.state.submitting;if(!submitting){_context.next=3;break;}return _context.abrupt("return",false);case 3:_this.setState({submitting:true});// sendEmail({
//   ...data,
//   contactType: "contact"
// });
// notification.success({
//   message: "Newsletter Signup Success"
// });
_this.setState({submitting:false});_this.props.form.resetFields();_this.props.onSubmit();return _context.abrupt("return",true);case 8:case"end":return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref2.apply(this,arguments);};}(),_this.handleSubmit=function(e){e.preventDefault();_this.props.form.validateFieldsAndScroll(function(err,values){if(!err){_this.submit(values);}});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Newsletter,[{key:"render",value:function render(){var t=this.props.t;var getFieldDecorator=this.props.form.getFieldDecorator;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:"newsletter-form"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_antd_lib_form___default.a,{onSubmit:this.handleSubmit},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(FormItem,null,getFieldDecorator("email",{rules:[{type:"email",message:t("This email is not valid email address")},{required:true,message:t("This field is required")}]})(__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_input___default.a,{placeholder:t("Your Email Address")})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components__["b" /* Button */],{defaultStyle:{padding:"0 14px",textTransform:"capitalize",letterSpacing:"normal",fontWeight:"bold",fontSize:"12px",lineHeight:"32px"},type:"default"},t("Submit")))));}}]);return Newsletter;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]),_class2.propTypes={t:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func.isRequired,onSubmit:__WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.func},_class2.defaultProps={onSubmit:function onSubmit(){return null;}},_temp2))||_class)||_class);

/***/ }),
/* 609 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 610 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 611 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.ANT_MARK = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(1));

var moment = _interopRequireWildcard(__webpack_require__(187));

var _interopDefault = _interopRequireDefault(__webpack_require__(612));

var _locale = __webpack_require__(613);

var _warning = _interopRequireDefault(__webpack_require__(64));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var ANT_MARK = 'internalMark';
exports.ANT_MARK = ANT_MARK;

function setMomentLocale(locale) {
  if (locale && locale.locale) {
    (0, _interopDefault["default"])(moment).locale(locale.locale);
  } else {
    (0, _interopDefault["default"])(moment).locale('en');
  }
}

var LocaleProvider = /*#__PURE__*/function (_React$Component) {
  _inherits(LocaleProvider, _React$Component);

  var _super = _createSuper(LocaleProvider);

  function LocaleProvider(props) {
    var _this;

    _classCallCheck(this, LocaleProvider);

    _this = _super.call(this, props);
    setMomentLocale(props.locale);
    (0, _locale.changeConfirmLocale)(props.locale && props.locale.Modal);
    (0, _warning["default"])(props._ANT_MARK__ === ANT_MARK, 'LocaleProvider', '`LocaleProvider` is deprecated. Please use `locale` with `ConfigProvider` instead: http://u.ant.design/locale');
    return _this;
  }

  _createClass(LocaleProvider, [{
    key: "getChildContext",
    value: function getChildContext() {
      return {
        antLocale: _extends(_extends({}, this.props.locale), {
          exist: true
        })
      };
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var locale = this.props.locale;

      if (prevProps.locale !== locale) {
        setMomentLocale(locale);
        (0, _locale.changeConfirmLocale)(locale && locale.Modal);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      (0, _locale.changeConfirmLocale)();
    }
  }, {
    key: "render",
    value: function render() {
      return this.props.children;
    }
  }]);

  return LocaleProvider;
}(React.Component);

exports["default"] = LocaleProvider;
LocaleProvider.propTypes = {
  locale: PropTypes.object
};
LocaleProvider.defaultProps = {
  locale: {}
};
LocaleProvider.childContextTypes = {
  antLocale: PropTypes.object
};

/***/ }),
/* 612 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = interopDefault;

// https://github.com/moment/moment/issues/3650
// since we are using ts 3.5.1, it should be safe to remove.
function interopDefault(m) {
  return m["default"] || m;
}

/***/ }),
/* 613 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.changeConfirmLocale = changeConfirmLocale;
exports.getConfirmLocale = getConfirmLocale;

var _default = _interopRequireDefault(__webpack_require__(287));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var runtimeLocale = _extends({}, _default["default"].Modal);

function changeConfirmLocale(newLocale) {
  if (newLocale) {
    runtimeLocale = _extends(_extends({}, runtimeLocale), newLocale);
  } else {
    runtimeLocale = _extends({}, _default["default"].Modal);
  }
}

function getConfirmLocale() {
  return runtimeLocale;
}

/***/ }),
/* 614 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.withConfigConsumer = withConfigConsumer;
exports.ConfigConsumer = exports.ConfigContext = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _createReactContext = _interopRequireDefault(__webpack_require__(188));

var _renderEmpty = _interopRequireDefault(__webpack_require__(617));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var ConfigContext = (0, _createReactContext["default"])({
  // We provide a default function for Context without provider
  getPrefixCls: function getPrefixCls(suffixCls, customizePrefixCls) {
    if (customizePrefixCls) return customizePrefixCls;
    return "ant-".concat(suffixCls);
  },
  renderEmpty: _renderEmpty["default"]
});
exports.ConfigContext = ConfigContext;
var ConfigConsumer = ConfigContext.Consumer;
exports.ConfigConsumer = ConfigConsumer;

function withConfigConsumer(config) {
  return function withConfigConsumerFunc(Component) {
    // Wrap with ConfigConsumer. Since we need compatible with react 15, be care when using ref methods
    var SFC = function SFC(props) {
      return /*#__PURE__*/React.createElement(ConfigConsumer, null, function (configProps) {
        var basicPrefixCls = config.prefixCls;
        var getPrefixCls = configProps.getPrefixCls;
        var customizePrefixCls = props.prefixCls;
        var prefixCls = getPrefixCls(basicPrefixCls, customizePrefixCls);
        return /*#__PURE__*/React.createElement(Component, _extends({}, configProps, props, {
          prefixCls: prefixCls
        }));
      });
    };

    var cons = Component.constructor;
    var name = cons && cons.displayName || Component.name || 'Component';
    SFC.displayName = "withConfigConsumer(".concat(name, ")");
    return SFC;
  };
}

/***/ }),
/* 615 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _gud = __webpack_require__(616);

var _gud2 = _interopRequireDefault(_gud);

var _warning = __webpack_require__(21);

var _warning2 = _interopRequireDefault(_warning);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var MAX_SIGNED_31_BIT_INT = 1073741823;

// Inlined Object.is polyfill.
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
function objectIs(x, y) {
  if (x === y) {
    return x !== 0 || 1 / x === 1 / y;
  } else {
    return x !== x && y !== y;
  }
}

function createEventEmitter(value) {
  var handlers = [];
  return {
    on: function on(handler) {
      handlers.push(handler);
    },
    off: function off(handler) {
      handlers = handlers.filter(function (h) {
        return h !== handler;
      });
    },
    get: function get() {
      return value;
    },
    set: function set(newValue, changedBits) {
      value = newValue;
      handlers.forEach(function (handler) {
        return handler(value, changedBits);
      });
    }
  };
}

function onlyChild(children) {
  return Array.isArray(children) ? children[0] : children;
}

function createReactContext(defaultValue, calculateChangedBits) {
  var _Provider$childContex, _Consumer$contextType;

  var contextProp = '__create-react-context-' + (0, _gud2.default)() + '__';

  var Provider = function (_Component) {
    _inherits(Provider, _Component);

    function Provider() {
      var _temp, _this, _ret;

      _classCallCheck(this, Provider);

      for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      return _ret = (_temp = (_this = _possibleConstructorReturn(this, _Component.call.apply(_Component, [this].concat(args))), _this), _this.emitter = createEventEmitter(_this.props.value), _temp), _possibleConstructorReturn(_this, _ret);
    }

    Provider.prototype.getChildContext = function getChildContext() {
      var _ref;

      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
    };

    Provider.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      if (this.props.value !== nextProps.value) {
        var oldValue = this.props.value;
        var newValue = nextProps.value;
        var changedBits = void 0;

        if (objectIs(oldValue, newValue)) {
          changedBits = 0; // No change
        } else {
          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
          if (false) {
            (0, _warning2.default)((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: %s', changedBits);
          }

          changedBits |= 0;

          if (changedBits !== 0) {
            this.emitter.set(nextProps.value, changedBits);
          }
        }
      }
    };

    Provider.prototype.render = function render() {
      return this.props.children;
    };

    return Provider;
  }(_react.Component);

  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = _propTypes2.default.object.isRequired, _Provider$childContex);

  var Consumer = function (_Component2) {
    _inherits(Consumer, _Component2);

    function Consumer() {
      var _temp2, _this2, _ret2;

      _classCallCheck(this, Consumer);

      for (var _len2 = arguments.length, args = Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
        args[_key2] = arguments[_key2];
      }

      return _ret2 = (_temp2 = (_this2 = _possibleConstructorReturn(this, _Component2.call.apply(_Component2, [this].concat(args))), _this2), _this2.state = {
        value: _this2.getValue()
      }, _this2.onUpdate = function (newValue, changedBits) {
        var observedBits = _this2.observedBits | 0;
        if ((observedBits & changedBits) !== 0) {
          _this2.setState({ value: _this2.getValue() });
        }
      }, _temp2), _possibleConstructorReturn(_this2, _ret2);
    }

    Consumer.prototype.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
      var observedBits = nextProps.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentDidMount = function componentDidMount() {
      if (this.context[contextProp]) {
        this.context[contextProp].on(this.onUpdate);
      }
      var observedBits = this.props.observedBits;

      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT // Subscribe to all changes by default
      : observedBits;
    };

    Consumer.prototype.componentWillUnmount = function componentWillUnmount() {
      if (this.context[contextProp]) {
        this.context[contextProp].off(this.onUpdate);
      }
    };

    Consumer.prototype.getValue = function getValue() {
      if (this.context[contextProp]) {
        return this.context[contextProp].get();
      } else {
        return defaultValue;
      }
    };

    Consumer.prototype.render = function render() {
      return onlyChild(this.props.children)(this.state.value);
    };

    return Consumer;
  }(_react.Component);

  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = _propTypes2.default.object, _Consumer$contextType);


  return {
    Provider: Provider,
    Consumer: Consumer
  };
}

exports.default = createReactContext;
module.exports = exports['default'];

/***/ }),
/* 616 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {// @flow


var key = '__global_unique_id__';

module.exports = function() {
  return global[key] = (global[key] || 0) + 1;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29)))

/***/ }),
/* 617 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _empty = _interopRequireDefault(__webpack_require__(618));

var _ = __webpack_require__(28);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var renderEmpty = function renderEmpty(componentName) {
  return /*#__PURE__*/React.createElement(_.ConfigConsumer, null, function (_ref) {
    var getPrefixCls = _ref.getPrefixCls;
    var prefix = getPrefixCls('empty');

    switch (componentName) {
      case 'Table':
      case 'List':
        return /*#__PURE__*/React.createElement(_empty["default"], {
          image: _empty["default"].PRESENTED_IMAGE_SIMPLE
        });

      case 'Select':
      case 'TreeSelect':
      case 'Cascader':
      case 'Transfer':
      case 'Mentions':
        return /*#__PURE__*/React.createElement(_empty["default"], {
          image: _empty["default"].PRESENTED_IMAGE_SIMPLE,
          className: "".concat(prefix, "-small")
        });

      default:
        return /*#__PURE__*/React.createElement(_empty["default"], null);
    }
  });
};

var _default = renderEmpty;
exports["default"] = _default;

/***/ }),
/* 618 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(24));

var _configProvider = __webpack_require__(28);

var _LocaleReceiver = _interopRequireDefault(__webpack_require__(186));

var _empty = _interopRequireDefault(__webpack_require__(619));

var _simple = _interopRequireDefault(__webpack_require__(620));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var defaultEmptyImg = /*#__PURE__*/React.createElement(_empty["default"], null);
var simpleEmptyImg = /*#__PURE__*/React.createElement(_simple["default"], null);

var Empty = function Empty(props) {
  return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
    var getPrefixCls = _ref.getPrefixCls;

    var className = props.className,
        customizePrefixCls = props.prefixCls,
        _props$image = props.image,
        image = _props$image === void 0 ? defaultEmptyImg : _props$image,
        description = props.description,
        children = props.children,
        imageStyle = props.imageStyle,
        restProps = __rest(props, ["className", "prefixCls", "image", "description", "children", "imageStyle"]);

    return /*#__PURE__*/React.createElement(_LocaleReceiver["default"], {
      componentName: "Empty"
    }, function (locale) {
      var prefixCls = getPrefixCls('empty', customizePrefixCls);
      var des = typeof description !== 'undefined' ? description : locale.description;
      var alt = typeof des === 'string' ? des : 'empty';
      var imageNode = null;

      if (typeof image === 'string') {
        imageNode = /*#__PURE__*/React.createElement("img", {
          alt: alt,
          src: image
        });
      } else {
        imageNode = image;
      }

      return /*#__PURE__*/React.createElement("div", _extends({
        className: (0, _classnames["default"])(prefixCls, _defineProperty({}, "".concat(prefixCls, "-normal"), image === simpleEmptyImg), className)
      }, restProps), /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-image"),
        style: imageStyle
      }, imageNode), des && /*#__PURE__*/React.createElement("p", {
        className: "".concat(prefixCls, "-description")
      }, des), children && /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-footer")
      }, children));
    });
  });
};

Empty.PRESENTED_IMAGE_DEFAULT = defaultEmptyImg;
Empty.PRESENTED_IMAGE_SIMPLE = simpleEmptyImg;
var _default = Empty;
exports["default"] = _default;

/***/ }),
/* 619 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Empty = function Empty() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "184",
    height: "152",
    viewBox: "0 0 184 152",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(24 31.67)"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fillOpacity: ".8",
    fill: "#F5F5F7",
    cx: "67.797",
    cy: "106.89",
    rx: "67.797",
    ry: "12.668"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M122.034 69.674L98.109 40.229c-1.148-1.386-2.826-2.225-4.593-2.225h-51.44c-1.766 0-3.444.839-4.592 2.225L13.56 69.674v15.383h108.475V69.674z",
    fill: "#AEB8C2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.537 86.214L80.63 61.102c-1.001-1.207-2.507-1.867-4.048-1.867H31.724c-1.54 0-3.047.66-4.048 1.867L6.769 86.214v13.792h94.768V86.214z",
    fill: "url(#linearGradient-1)",
    transform: "translate(13.56)"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.83 0h67.933a4 4 0 0 1 4 4v93.344a4 4 0 0 1-4 4H33.83a4 4 0 0 1-4-4V4a4 4 0 0 1 4-4z",
    fill: "#F5F5F7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M42.678 9.953h50.237a2 2 0 0 1 2 2V36.91a2 2 0 0 1-2 2H42.678a2 2 0 0 1-2-2V11.953a2 2 0 0 1 2-2zM42.94 49.767h49.713a2.262 2.262 0 1 1 0 4.524H42.94a2.262 2.262 0 0 1 0-4.524zM42.94 61.53h49.713a2.262 2.262 0 1 1 0 4.525H42.94a2.262 2.262 0 0 1 0-4.525zM121.813 105.032c-.775 3.071-3.497 5.36-6.735 5.36H20.515c-3.238 0-5.96-2.29-6.734-5.36a7.309 7.309 0 0 1-.222-1.79V69.675h26.318c2.907 0 5.25 2.448 5.25 5.42v.04c0 2.971 2.37 5.37 5.277 5.37h34.785c2.907 0 5.277-2.421 5.277-5.393V75.1c0-2.972 2.343-5.426 5.25-5.426h26.318v33.569c0 .617-.077 1.216-.221 1.789z",
    fill: "#DCE0E6"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M149.121 33.292l-6.83 2.65a1 1 0 0 1-1.317-1.23l1.937-6.207c-2.589-2.944-4.109-6.534-4.109-10.408C138.802 8.102 148.92 0 161.402 0 173.881 0 184 8.102 184 18.097c0 9.995-10.118 18.097-22.599 18.097-4.528 0-8.744-1.066-12.28-2.902z",
    fill: "#DCE0E6"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(149.65 15.383)",
    fill: "#FFF"
  }, /*#__PURE__*/React.createElement("ellipse", {
    cx: "20.654",
    cy: "3.167",
    rx: "2.849",
    ry: "2.815"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.698 5.63H0L2.898.704zM9.259.704h4.985V5.63H9.259z"
  }))));
};

var _default = Empty;
exports["default"] = _default;

/***/ }),
/* 620 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var Simple = function Simple() {
  return /*#__PURE__*/React.createElement("svg", {
    width: "64",
    height: "41",
    viewBox: "0 0 64 41",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 1)",
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("ellipse", {
    fill: "#F5F5F5",
    cx: "32",
    cy: "33",
    rx: "32",
    ry: "7"
  }), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    stroke: "#D9D9D9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M55 12.76L44.854 1.258C44.367.474 43.656 0 42.907 0H21.093c-.749 0-1.46.474-1.947 1.257L9 12.761V22h46v-9.24z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.613 15.931c0-1.605.994-2.93 2.227-2.931H55v18.137C55 33.26 53.68 35 52.05 35h-40.1C10.32 35 9 33.259 9 31.137V13h11.16c1.233 0 2.227 1.323 2.227 2.928v.022c0 1.605 1.005 2.901 2.237 2.901h14.752c1.232 0 2.237-1.308 2.237-2.913v-.007z",
    fill: "#FAFAFA"
  }))));
};

var _default = Simple;
exports["default"] = _default;

/***/ }),
/* 621 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(24));

var _configProvider = __webpack_require__(28);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var Group = function Group(props) {
  return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
    var _classNames;

    var getPrefixCls = _ref.getPrefixCls;
    var customizePrefixCls = props.prefixCls,
        _props$className = props.className,
        className = _props$className === void 0 ? '' : _props$className;
    var prefixCls = getPrefixCls('input-group', customizePrefixCls);
    var cls = (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-lg"), props.size === 'large'), _defineProperty(_classNames, "".concat(prefixCls, "-sm"), props.size === 'small'), _defineProperty(_classNames, "".concat(prefixCls, "-compact"), props.compact), _classNames), className);
    return /*#__PURE__*/React.createElement("span", {
      className: cls,
      style: props.style,
      onMouseEnter: props.onMouseEnter,
      onMouseLeave: props.onMouseLeave,
      onFocus: props.onFocus,
      onBlur: props.onBlur
    }, props.children);
  });
};

var _default = Group;
exports["default"] = _default;

/***/ }),
/* 622 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(24));

var _isMobile = __webpack_require__(623);

var _Input = _interopRequireDefault(__webpack_require__(108));

var _icon = _interopRequireDefault(__webpack_require__(60));

var _button = _interopRequireDefault(__webpack_require__(294));

var _configProvider = __webpack_require__(28);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var Search = /*#__PURE__*/function (_React$Component) {
  _inherits(Search, _React$Component);

  var _super = _createSuper(Search);

  function Search() {
    var _this;

    _classCallCheck(this, Search);

    _this = _super.apply(this, arguments);

    _this.saveInput = function (node) {
      _this.input = node;
    };

    _this.onChange = function (e) {
      var _this$props = _this.props,
          onChange = _this$props.onChange,
          onSearch = _this$props.onSearch;

      if (e && e.target && e.type === 'click' && onSearch) {
        onSearch(e.target.value, e);
      }

      if (onChange) {
        onChange(e);
      }
    };

    _this.onSearch = function (e) {
      var _this$props2 = _this.props,
          onSearch = _this$props2.onSearch,
          loading = _this$props2.loading,
          disabled = _this$props2.disabled;

      if (loading || disabled) {
        return;
      }

      if (onSearch) {
        onSearch(_this.input.input.value, e);
      }

      if (!(0, _isMobile.isMobile)({
        tablet: true
      })) {
        _this.input.focus();
      }
    };

    _this.renderLoading = function (prefixCls) {
      var _this$props3 = _this.props,
          enterButton = _this$props3.enterButton,
          size = _this$props3.size;

      if (enterButton) {
        return /*#__PURE__*/React.createElement(_button["default"], {
          className: "".concat(prefixCls, "-button"),
          type: "primary",
          size: size,
          key: "enterButton"
        }, /*#__PURE__*/React.createElement(_icon["default"], {
          type: "loading"
        }));
      }

      return /*#__PURE__*/React.createElement(_icon["default"], {
        className: "".concat(prefixCls, "-icon"),
        type: "loading",
        key: "loadingIcon"
      });
    };

    _this.renderSuffix = function (prefixCls) {
      var _this$props4 = _this.props,
          suffix = _this$props4.suffix,
          enterButton = _this$props4.enterButton,
          loading = _this$props4.loading;

      if (loading && !enterButton) {
        return [suffix, _this.renderLoading(prefixCls)];
      }

      if (enterButton) return suffix;
      var icon = /*#__PURE__*/React.createElement(_icon["default"], {
        className: "".concat(prefixCls, "-icon"),
        type: "search",
        key: "searchIcon",
        onClick: _this.onSearch
      });

      if (suffix) {
        return [/*#__PURE__*/React.isValidElement(suffix) ? /*#__PURE__*/React.cloneElement(suffix, {
          key: 'suffix'
        }) : null, icon];
      }

      return icon;
    };

    _this.renderAddonAfter = function (prefixCls) {
      var _this$props5 = _this.props,
          enterButton = _this$props5.enterButton,
          size = _this$props5.size,
          disabled = _this$props5.disabled,
          addonAfter = _this$props5.addonAfter,
          loading = _this$props5.loading;
      var btnClassName = "".concat(prefixCls, "-button");

      if (loading && enterButton) {
        return [_this.renderLoading(prefixCls), addonAfter];
      }

      if (!enterButton) return addonAfter;
      var button;
      var enterButtonAsElement = enterButton;
      var isAntdButton = enterButtonAsElement.type && enterButtonAsElement.type.__ANT_BUTTON === true;

      if (isAntdButton || enterButtonAsElement.type === 'button') {
        button = /*#__PURE__*/React.cloneElement(enterButtonAsElement, _extends({
          onClick: _this.onSearch,
          key: 'enterButton'
        }, isAntdButton ? {
          className: btnClassName,
          size: size
        } : {}));
      } else {
        button = /*#__PURE__*/React.createElement(_button["default"], {
          className: btnClassName,
          type: "primary",
          size: size,
          disabled: disabled,
          key: "enterButton",
          onClick: _this.onSearch
        }, enterButton === true ? /*#__PURE__*/React.createElement(_icon["default"], {
          type: "search"
        }) : enterButton);
      }

      if (addonAfter) {
        return [button, /*#__PURE__*/React.isValidElement(addonAfter) ? /*#__PURE__*/React.cloneElement(addonAfter, {
          key: 'addonAfter'
        }) : null];
      }

      return button;
    };

    _this.renderSearch = function (_ref) {
      var getPrefixCls = _ref.getPrefixCls;

      var _a = _this.props,
          customizePrefixCls = _a.prefixCls,
          customizeInputPrefixCls = _a.inputPrefixCls,
          size = _a.size,
          enterButton = _a.enterButton,
          className = _a.className,
          restProps = __rest(_a, ["prefixCls", "inputPrefixCls", "size", "enterButton", "className"]);

      delete restProps.onSearch;
      delete restProps.loading;
      var prefixCls = getPrefixCls('input-search', customizePrefixCls);
      var inputPrefixCls = getPrefixCls('input', customizeInputPrefixCls);
      var inputClassName;

      if (enterButton) {
        var _classNames;

        inputClassName = (0, _classnames["default"])(prefixCls, className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-enter-button"), !!enterButton), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(size), !!size), _classNames));
      } else {
        inputClassName = (0, _classnames["default"])(prefixCls, className);
      }

      return /*#__PURE__*/React.createElement(_Input["default"], _extends({
        onPressEnter: _this.onSearch
      }, restProps, {
        size: size,
        prefixCls: inputPrefixCls,
        addonAfter: _this.renderAddonAfter(prefixCls),
        suffix: _this.renderSuffix(prefixCls),
        onChange: _this.onChange,
        ref: _this.saveInput,
        className: inputClassName
      }));
    };

    return _this;
  }

  _createClass(Search, [{
    key: "focus",
    value: function focus() {
      this.input.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.input.blur();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderSearch);
    }
  }]);

  return Search;
}(React.Component);

exports["default"] = Search;
Search.defaultProps = {
  enterButton: false
};

/***/ }),
/* 623 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = isMobile
module.exports.isMobile = isMobile
module.exports.default = isMobile

var mobileRE = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino/i

var tabletRE = /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series[46]0|symbian|treo|up\.(browser|link)|vodafone|wap|windows (ce|phone)|xda|xiino|android|ipad|playbook|silk/i

function isMobile (opts) {
  if (!opts) opts = {}
  var ua = opts.ua
  if (!ua && typeof navigator !== 'undefined') ua = navigator.userAgent
  if (ua && ua.headers && typeof ua.headers['user-agent'] === 'string') {
    ua = ua.headers['user-agent']
  }
  if (typeof ua !== 'string') return false

  var result = opts.tablet ? tabletRE.test(ua) : mobileRE.test(ua)

  if (
    !result &&
    opts.tablet &&
    opts.featureDetect &&
    navigator &&
    navigator.maxTouchPoints > 1 &&
    ua.indexOf('Macintosh') !== -1 &&
    ua.indexOf('Safari') !== -1
  ) {
    result = true
  }

  return result
}


/***/ }),
/* 624 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(24));

var _reactLifecyclesCompat = __webpack_require__(83);

var _omit = _interopRequireDefault(__webpack_require__(84));

var _icon = _interopRequireDefault(__webpack_require__(60));

var _configProvider = __webpack_require__(28);

var _wave = _interopRequireDefault(__webpack_require__(625));

var _type = __webpack_require__(85);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};
/* eslint-disable react/button-has-type */


var rxTwoCNChar = /^[\u4e00-\u9fa5]{2}$/;
var isTwoCNChar = rxTwoCNChar.test.bind(rxTwoCNChar);

function isString(str) {
  return typeof str === 'string';
} // Insert one space between two chinese characters automatically.


function insertSpace(child, needInserted) {
  // Check the child if is undefined or null.
  if (child == null) {
    return;
  }

  var SPACE = needInserted ? ' ' : ''; // strictNullChecks oops.

  if (typeof child !== 'string' && typeof child !== 'number' && isString(child.type) && isTwoCNChar(child.props.children)) {
    return /*#__PURE__*/React.cloneElement(child, {}, child.props.children.split('').join(SPACE));
  }

  if (typeof child === 'string') {
    if (isTwoCNChar(child)) {
      child = child.split('').join(SPACE);
    }

    return /*#__PURE__*/React.createElement("span", null, child);
  }

  return child;
}

function spaceChildren(children, needInserted) {
  var isPrevChildPure = false;
  var childList = [];
  React.Children.forEach(children, function (child) {
    var type = _typeof(child);

    var isCurrentChildPure = type === 'string' || type === 'number';

    if (isPrevChildPure && isCurrentChildPure) {
      var lastIndex = childList.length - 1;
      var lastChild = childList[lastIndex];
      childList[lastIndex] = "".concat(lastChild).concat(child);
    } else {
      childList.push(child);
    }

    isPrevChildPure = isCurrentChildPure;
  }); // Pass to React.Children.map to auto fill key

  return React.Children.map(childList, function (child) {
    return insertSpace(child, needInserted);
  });
}

var ButtonTypes = (0, _type.tuple)('default', 'primary', 'ghost', 'dashed', 'danger', 'link');
var ButtonShapes = (0, _type.tuple)('circle', 'circle-outline', 'round');
var ButtonSizes = (0, _type.tuple)('large', 'default', 'small');
var ButtonHTMLTypes = (0, _type.tuple)('submit', 'button', 'reset');

var Button = /*#__PURE__*/function (_React$Component) {
  _inherits(Button, _React$Component);

  var _super = _createSuper(Button);

  function Button(props) {
    var _this;

    _classCallCheck(this, Button);

    _this = _super.call(this, props);

    _this.saveButtonRef = function (node) {
      _this.buttonNode = node;
    };

    _this.handleClick = function (e) {
      var loading = _this.state.loading;
      var onClick = _this.props.onClick;

      if (loading) {
        return;
      }

      if (onClick) {
        onClick(e);
      }
    };

    _this.renderButton = function (_ref) {
      var _classNames;

      var getPrefixCls = _ref.getPrefixCls,
          autoInsertSpaceInButton = _ref.autoInsertSpaceInButton;

      var _a = _this.props,
          customizePrefixCls = _a.prefixCls,
          type = _a.type,
          shape = _a.shape,
          size = _a.size,
          className = _a.className,
          children = _a.children,
          icon = _a.icon,
          ghost = _a.ghost,
          block = _a.block,
          rest = __rest(_a, ["prefixCls", "type", "shape", "size", "className", "children", "icon", "ghost", "block"]);

      var _this$state = _this.state,
          loading = _this$state.loading,
          hasTwoCNChar = _this$state.hasTwoCNChar;
      var prefixCls = getPrefixCls('btn', customizePrefixCls);
      var autoInsertSpace = autoInsertSpaceInButton !== false; // large => lg
      // small => sm

      var sizeCls = '';

      switch (size) {
        case 'large':
          sizeCls = 'lg';
          break;

        case 'small':
          sizeCls = 'sm';
          break;

        default:
          break;
      }

      var iconType = loading ? 'loading' : icon;
      var classes = (0, _classnames["default"])(prefixCls, className, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(type), type), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(shape), shape), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(sizeCls), sizeCls), _defineProperty(_classNames, "".concat(prefixCls, "-icon-only"), !children && children !== 0 && iconType), _defineProperty(_classNames, "".concat(prefixCls, "-loading"), !!loading), _defineProperty(_classNames, "".concat(prefixCls, "-background-ghost"), ghost), _defineProperty(_classNames, "".concat(prefixCls, "-two-chinese-chars"), hasTwoCNChar && autoInsertSpace), _defineProperty(_classNames, "".concat(prefixCls, "-block"), block), _classNames));
      var iconNode = iconType ? /*#__PURE__*/React.createElement(_icon["default"], {
        type: iconType
      }) : null;
      var kids = children || children === 0 ? spaceChildren(children, _this.isNeedInserted() && autoInsertSpace) : null;
      var linkButtonRestProps = (0, _omit["default"])(rest, ['htmlType', 'loading']);

      if (linkButtonRestProps.href !== undefined) {
        return /*#__PURE__*/React.createElement("a", _extends({}, linkButtonRestProps, {
          className: classes,
          onClick: _this.handleClick,
          ref: _this.saveButtonRef
        }), iconNode, kids);
      } // React does not recognize the `htmlType` prop on a DOM element. Here we pick it out of `rest`.


      var _b = rest,
          htmlType = _b.htmlType,
          otherProps = __rest(_b, ["htmlType"]);

      var buttonNode = /*#__PURE__*/React.createElement("button", _extends({}, (0, _omit["default"])(otherProps, ['loading']), {
        type: htmlType,
        className: classes,
        onClick: _this.handleClick,
        ref: _this.saveButtonRef
      }), iconNode, kids);

      if (type === 'link') {
        return buttonNode;
      }

      return /*#__PURE__*/React.createElement(_wave["default"], null, buttonNode);
    };

    _this.state = {
      loading: props.loading,
      hasTwoCNChar: false
    };
    return _this;
  }

  _createClass(Button, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.fixTwoCNChar();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      var _this2 = this;

      this.fixTwoCNChar();

      if (prevProps.loading && typeof prevProps.loading !== 'boolean') {
        clearTimeout(this.delayTimeout);
      }

      var loading = this.props.loading;

      if (loading && typeof loading !== 'boolean' && loading.delay) {
        this.delayTimeout = window.setTimeout(function () {
          _this2.setState({
            loading: loading
          });
        }, loading.delay);
      } else if (prevProps.loading !== loading) {
        // eslint-disable-next-line react/no-did-update-set-state
        this.setState({
          loading: loading
        });
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.delayTimeout) {
        clearTimeout(this.delayTimeout);
      }
    }
  }, {
    key: "fixTwoCNChar",
    value: function fixTwoCNChar() {
      // Fix for HOC usage like <FormatMessage />
      if (!this.buttonNode) {
        return;
      }

      var buttonText = this.buttonNode.textContent;

      if (this.isNeedInserted() && isTwoCNChar(buttonText)) {
        if (!this.state.hasTwoCNChar) {
          this.setState({
            hasTwoCNChar: true
          });
        }
      } else if (this.state.hasTwoCNChar) {
        this.setState({
          hasTwoCNChar: false
        });
      }
    }
  }, {
    key: "isNeedInserted",
    value: function isNeedInserted() {
      var _this$props = this.props,
          icon = _this$props.icon,
          children = _this$props.children,
          type = _this$props.type;
      return React.Children.count(children) === 1 && !icon && type !== 'link';
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderButton);
    }
  }]);

  return Button;
}(React.Component);

Button.__ANT_BUTTON = true;
Button.defaultProps = {
  loading: false,
  ghost: false,
  block: false,
  htmlType: 'button'
};
Button.propTypes = {
  type: PropTypes.string,
  shape: PropTypes.oneOf(ButtonShapes),
  size: PropTypes.oneOf(ButtonSizes),
  htmlType: PropTypes.oneOf(ButtonHTMLTypes),
  onClick: PropTypes.func,
  loading: PropTypes.oneOfType([PropTypes.bool, PropTypes.object]),
  className: PropTypes.string,
  icon: PropTypes.string,
  block: PropTypes.bool,
  title: PropTypes.string
};
(0, _reactLifecyclesCompat.polyfill)(Button);
var _default = Button;
exports["default"] = _default;

/***/ }),
/* 625 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _reactDom = __webpack_require__(30);

var _Event = _interopRequireDefault(__webpack_require__(626));

var _raf = _interopRequireDefault(__webpack_require__(295));

var _configProvider = __webpack_require__(28);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var styleForPesudo; // Where el is the DOM element you'd like to test for visibility

function isHidden(element) {
  if (false) {
    return false;
  }

  return !element || element.offsetParent === null;
}

function isNotGrey(color) {
  // eslint-disable-next-line no-useless-escape
  var match = (color || '').match(/rgba?\((\d*), (\d*), (\d*)(, [\.\d]*)?\)/);

  if (match && match[1] && match[2] && match[3]) {
    return !(match[1] === match[2] && match[2] === match[3]);
  }

  return true;
}

var Wave = /*#__PURE__*/function (_React$Component) {
  _inherits(Wave, _React$Component);

  var _super = _createSuper(Wave);

  function Wave() {
    var _this;

    _classCallCheck(this, Wave);

    _this = _super.apply(this, arguments);
    _this.animationStart = false;
    _this.destroy = false;

    _this.onClick = function (node, waveColor) {
      if (!node || isHidden(node) || node.className.indexOf('-leave') >= 0) {
        return;
      }

      var insertExtraNode = _this.props.insertExtraNode;
      _this.extraNode = document.createElement('div');

      var _assertThisInitialize = _assertThisInitialized(_this),
          extraNode = _assertThisInitialize.extraNode;

      extraNode.className = 'ant-click-animating-node';

      var attributeName = _this.getAttributeName();

      node.setAttribute(attributeName, 'true'); // Not white or transparnt or grey

      styleForPesudo = styleForPesudo || document.createElement('style');

      if (waveColor && waveColor !== '#ffffff' && waveColor !== 'rgb(255, 255, 255)' && isNotGrey(waveColor) && !/rgba\(\d*, \d*, \d*, 0\)/.test(waveColor) && // any transparent rgba color
      waveColor !== 'transparent') {
        // Add nonce if CSP exist
        if (_this.csp && _this.csp.nonce) {
          styleForPesudo.nonce = _this.csp.nonce;
        }

        extraNode.style.borderColor = waveColor;
        styleForPesudo.innerHTML = "\n      [ant-click-animating-without-extra-node='true']::after, .ant-click-animating-node {\n        --antd-wave-shadow-color: ".concat(waveColor, ";\n      }");

        if (!document.body.contains(styleForPesudo)) {
          document.body.appendChild(styleForPesudo);
        }
      }

      if (insertExtraNode) {
        node.appendChild(extraNode);
      }

      _Event["default"].addStartEventListener(node, _this.onTransitionStart);

      _Event["default"].addEndEventListener(node, _this.onTransitionEnd);
    };

    _this.onTransitionStart = function (e) {
      if (_this.destroy) return;
      var node = (0, _reactDom.findDOMNode)(_assertThisInitialized(_this));

      if (!e || e.target !== node) {
        return;
      }

      if (!_this.animationStart) {
        _this.resetEffect(node);
      }
    };

    _this.onTransitionEnd = function (e) {
      if (!e || e.animationName !== 'fadeEffect') {
        return;
      }

      _this.resetEffect(e.target);
    };

    _this.bindAnimationEvent = function (node) {
      if (!node || !node.getAttribute || node.getAttribute('disabled') || node.className.indexOf('disabled') >= 0) {
        return;
      }

      var onClick = function onClick(e) {
        // Fix radio button click twice
        if (e.target.tagName === 'INPUT' || isHidden(e.target)) {
          return;
        }

        _this.resetEffect(node); // Get wave color from target


        var waveColor = getComputedStyle(node).getPropertyValue('border-top-color') || // Firefox Compatible
        getComputedStyle(node).getPropertyValue('border-color') || getComputedStyle(node).getPropertyValue('background-color');
        _this.clickWaveTimeoutId = window.setTimeout(function () {
          return _this.onClick(node, waveColor);
        }, 0);

        _raf["default"].cancel(_this.animationStartId);

        _this.animationStart = true; // Render to trigger transition event cost 3 frames. Let's delay 10 frames to reset this.

        _this.animationStartId = (0, _raf["default"])(function () {
          _this.animationStart = false;
        }, 10);
      };

      node.addEventListener('click', onClick, true);
      return {
        cancel: function cancel() {
          node.removeEventListener('click', onClick, true);
        }
      };
    };

    _this.renderWave = function (_ref) {
      var csp = _ref.csp;
      var children = _this.props.children;
      _this.csp = csp;
      return children;
    };

    return _this;
  }

  _createClass(Wave, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var node = (0, _reactDom.findDOMNode)(this);

      if (!node || node.nodeType !== 1) {
        return;
      }

      this.instance = this.bindAnimationEvent(node);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.instance) {
        this.instance.cancel();
      }

      if (this.clickWaveTimeoutId) {
        clearTimeout(this.clickWaveTimeoutId);
      }

      this.destroy = true;
    }
  }, {
    key: "getAttributeName",
    value: function getAttributeName() {
      var insertExtraNode = this.props.insertExtraNode;
      return insertExtraNode ? 'ant-click-animating' : 'ant-click-animating-without-extra-node';
    }
  }, {
    key: "resetEffect",
    value: function resetEffect(node) {
      if (!node || node === this.extraNode || !(node instanceof Element)) {
        return;
      }

      var insertExtraNode = this.props.insertExtraNode;
      var attributeName = this.getAttributeName();
      node.setAttribute(attributeName, 'false'); // edge has bug on `removeAttribute` #14466

      if (styleForPesudo) {
        styleForPesudo.innerHTML = '';
      }

      if (insertExtraNode && this.extraNode && node.contains(this.extraNode)) {
        node.removeChild(this.extraNode);
      }

      _Event["default"].removeStartEventListener(node, this.onTransitionStart);

      _Event["default"].removeEndEventListener(node, this.onTransitionEnd);
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderWave);
    }
  }]);

  return Wave;
}(React.Component);

exports["default"] = Wave;

/***/ }),
/* 626 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
var START_EVENT_NAME_MAP = {
  transitionstart: {
    transition: 'transitionstart',
    WebkitTransition: 'webkitTransitionStart',
    MozTransition: 'mozTransitionStart',
    OTransition: 'oTransitionStart',
    msTransition: 'MSTransitionStart'
  },

  animationstart: {
    animation: 'animationstart',
    WebkitAnimation: 'webkitAnimationStart',
    MozAnimation: 'mozAnimationStart',
    OAnimation: 'oAnimationStart',
    msAnimation: 'MSAnimationStart'
  }
};

var END_EVENT_NAME_MAP = {
  transitionend: {
    transition: 'transitionend',
    WebkitTransition: 'webkitTransitionEnd',
    MozTransition: 'mozTransitionEnd',
    OTransition: 'oTransitionEnd',
    msTransition: 'MSTransitionEnd'
  },

  animationend: {
    animation: 'animationend',
    WebkitAnimation: 'webkitAnimationEnd',
    MozAnimation: 'mozAnimationEnd',
    OAnimation: 'oAnimationEnd',
    msAnimation: 'MSAnimationEnd'
  }
};

var startEvents = [];
var endEvents = [];

function detectEvents() {
  var testEl = document.createElement('div');
  var style = testEl.style;

  if (!('AnimationEvent' in window)) {
    delete START_EVENT_NAME_MAP.animationstart.animation;
    delete END_EVENT_NAME_MAP.animationend.animation;
  }

  if (!('TransitionEvent' in window)) {
    delete START_EVENT_NAME_MAP.transitionstart.transition;
    delete END_EVENT_NAME_MAP.transitionend.transition;
  }

  function process(EVENT_NAME_MAP, events) {
    for (var baseEventName in EVENT_NAME_MAP) {
      if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
        var baseEvents = EVENT_NAME_MAP[baseEventName];
        for (var styleName in baseEvents) {
          if (styleName in style) {
            events.push(baseEvents[styleName]);
            break;
          }
        }
      }
    }
  }

  process(START_EVENT_NAME_MAP, startEvents);
  process(END_EVENT_NAME_MAP, endEvents);
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  detectEvents();
}

function addEventListener(node, eventName, eventListener) {
  node.addEventListener(eventName, eventListener, false);
}

function removeEventListener(node, eventName, eventListener) {
  node.removeEventListener(eventName, eventListener, false);
}

var TransitionEvents = {
  // Start events
  startEvents: startEvents,

  addStartEventListener: function addStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    startEvents.forEach(function (startEvent) {
      addEventListener(node, startEvent, eventListener);
    });
  },
  removeStartEventListener: function removeStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      return;
    }
    startEvents.forEach(function (startEvent) {
      removeEventListener(node, startEvent, eventListener);
    });
  },


  // End events
  endEvents: endEvents,

  addEndEventListener: function addEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    endEvents.forEach(function (endEvent) {
      addEventListener(node, endEvent, eventListener);
    });
  },
  removeEndEventListener: function removeEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      return;
    }
    endEvents.forEach(function (endEvent) {
      removeEventListener(node, endEvent, eventListener);
    });
  }
};

exports['default'] = TransitionEvents;
module.exports = exports['default'];

/***/ }),
/* 627 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {var now = __webpack_require__(628)
  , root = typeof window === 'undefined' ? global : window
  , vendors = ['moz', 'webkit']
  , suffix = 'AnimationFrame'
  , raf = root['request' + suffix]
  , caf = root['cancel' + suffix] || root['cancelRequest' + suffix]

for(var i = 0; !raf && i < vendors.length; i++) {
  raf = root[vendors[i] + 'Request' + suffix]
  caf = root[vendors[i] + 'Cancel' + suffix]
      || root[vendors[i] + 'CancelRequest' + suffix]
}

// Some versions of FF have rAF but not cAF
if(!raf || !caf) {
  var last = 0
    , id = 0
    , queue = []
    , frameDuration = 1000 / 60

  raf = function(callback) {
    if(queue.length === 0) {
      var _now = now()
        , next = Math.max(0, frameDuration - (_now - last))
      last = next + _now
      setTimeout(function() {
        var cp = queue.slice(0)
        // Clear queue here to prevent
        // callbacks from appending listeners
        // to the current frame's queue
        queue.length = 0
        for(var i = 0; i < cp.length; i++) {
          if(!cp[i].cancelled) {
            try{
              cp[i].callback(last)
            } catch(e) {
              setTimeout(function() { throw e }, 0)
            }
          }
        }
      }, Math.round(next))
    }
    queue.push({
      handle: ++id,
      callback: callback,
      cancelled: false
    })
    return id
  }

  caf = function(handle) {
    for(var i = 0; i < queue.length; i++) {
      if(queue[i].handle === handle) {
        queue[i].cancelled = true
      }
    }
  }
}

module.exports = function(fn) {
  // Wrap in a new function to prevent
  // `cancel` potentially being assigned
  // to the native rAF function
  return raf.call(root, fn)
}
module.exports.cancel = function() {
  caf.apply(root, arguments)
}
module.exports.polyfill = function(object) {
  if (!object) {
    object = root;
  }
  object.requestAnimationFrame = raf
  object.cancelAnimationFrame = caf
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29)))

/***/ }),
/* 628 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {// Generated by CoffeeScript 1.12.2
(function() {
  var getNanoSeconds, hrtime, loadTime, moduleLoadTime, nodeLoadTime, upTime;

  if ((typeof performance !== "undefined" && performance !== null) && performance.now) {
    module.exports = function() {
      return performance.now();
    };
  } else if ((typeof process !== "undefined" && process !== null) && process.hrtime) {
    module.exports = function() {
      return (getNanoSeconds() - nodeLoadTime) / 1e6;
    };
    hrtime = process.hrtime;
    getNanoSeconds = function() {
      var hr;
      hr = hrtime();
      return hr[0] * 1e9 + hr[1];
    };
    moduleLoadTime = getNanoSeconds();
    upTime = process.uptime() * 1e9;
    nodeLoadTime = moduleLoadTime - upTime;
  } else if (Date.now) {
    module.exports = function() {
      return Date.now() - loadTime;
    };
    loadTime = Date.now();
  } else {
    module.exports = function() {
      return new Date().getTime() - loadTime;
    };
    loadTime = new Date().getTime();
  }

}).call(this);

//# sourceMappingURL=performance-now.js.map

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(171)))

/***/ }),
/* 629 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(24));

var _configProvider = __webpack_require__(28);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var ButtonGroup = function ButtonGroup(props) {
  return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, function (_ref) {
    var getPrefixCls = _ref.getPrefixCls;

    var customizePrefixCls = props.prefixCls,
        size = props.size,
        className = props.className,
        others = __rest(props, ["prefixCls", "size", "className"]);

    var prefixCls = getPrefixCls('btn-group', customizePrefixCls); // large => lg
    // small => sm

    var sizeCls = '';

    switch (size) {
      case 'large':
        sizeCls = 'lg';
        break;

      case 'small':
        sizeCls = 'sm';
        break;

      default:
        break;
    }

    var classes = (0, _classnames["default"])(prefixCls, _defineProperty({}, "".concat(prefixCls, "-").concat(sizeCls), sizeCls), className);
    return /*#__PURE__*/React.createElement("div", _extends({}, others, {
      className: classes
    }));
  });
};

var _default = ButtonGroup;
exports["default"] = _default;

/***/ }),
/* 630 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _reactLifecyclesCompat = __webpack_require__(83);

var _ClearableLabeledInput = _interopRequireDefault(__webpack_require__(293));

var _ResizableTextArea = _interopRequireDefault(__webpack_require__(631));

var _configProvider = __webpack_require__(28);

var _Input = __webpack_require__(108);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var TextArea = /*#__PURE__*/function (_React$Component) {
  _inherits(TextArea, _React$Component);

  var _super = _createSuper(TextArea);

  function TextArea(props) {
    var _this;

    _classCallCheck(this, TextArea);

    _this = _super.call(this, props);

    _this.saveTextArea = function (resizableTextArea) {
      _this.resizableTextArea = resizableTextArea;
    };

    _this.saveClearableInput = function (clearableInput) {
      _this.clearableInput = clearableInput;
    };

    _this.handleChange = function (e) {
      _this.setValue(e.target.value, function () {
        _this.resizableTextArea.resizeTextarea();
      });

      (0, _Input.resolveOnChange)(_this.resizableTextArea.textArea, e, _this.props.onChange);
    };

    _this.handleKeyDown = function (e) {
      var _this$props = _this.props,
          onPressEnter = _this$props.onPressEnter,
          onKeyDown = _this$props.onKeyDown;

      if (e.keyCode === 13 && onPressEnter) {
        onPressEnter(e);
      }

      if (onKeyDown) {
        onKeyDown(e);
      }
    };

    _this.handleReset = function (e) {
      _this.setValue('', function () {
        _this.resizableTextArea.renderTextArea();

        _this.focus();
      });

      (0, _Input.resolveOnChange)(_this.resizableTextArea.textArea, e, _this.props.onChange);
    };

    _this.renderTextArea = function (prefixCls) {
      return /*#__PURE__*/React.createElement(_ResizableTextArea["default"], _extends({}, _this.props, {
        prefixCls: prefixCls,
        onKeyDown: _this.handleKeyDown,
        onChange: _this.handleChange,
        ref: _this.saveTextArea
      }));
    };

    _this.renderComponent = function (_ref) {
      var getPrefixCls = _ref.getPrefixCls;
      var value = _this.state.value;
      var customizePrefixCls = _this.props.prefixCls;
      var prefixCls = getPrefixCls('input', customizePrefixCls);
      return /*#__PURE__*/React.createElement(_ClearableLabeledInput["default"], _extends({}, _this.props, {
        prefixCls: prefixCls,
        inputType: "text",
        value: (0, _Input.fixControlledValue)(value),
        element: _this.renderTextArea(prefixCls),
        handleReset: _this.handleReset,
        ref: _this.saveClearableInput
      }));
    };

    var value = typeof props.value === 'undefined' ? props.defaultValue : props.value;
    _this.state = {
      value: value
    };
    return _this;
  }

  _createClass(TextArea, [{
    key: "setValue",
    value: function setValue(value, callback) {
      if (!('value' in this.props)) {
        this.setState({
          value: value
        }, callback);
      }
    }
  }, {
    key: "focus",
    value: function focus() {
      this.resizableTextArea.textArea.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.resizableTextArea.textArea.blur();
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderComponent);
    }
  }], [{
    key: "getDerivedStateFromProps",
    value: function getDerivedStateFromProps(nextProps) {
      if ('value' in nextProps) {
        return {
          value: nextProps.value
        };
      }

      return null;
    }
  }]);

  return TextArea;
}(React.Component);

(0, _reactLifecyclesCompat.polyfill)(TextArea);
var _default = TextArea;
exports["default"] = _default;

/***/ }),
/* 631 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _reactLifecyclesCompat = __webpack_require__(83);

var _rcResizeObserver = _interopRequireDefault(__webpack_require__(632));

var _omit = _interopRequireDefault(__webpack_require__(84));

var _classnames = _interopRequireDefault(__webpack_require__(24));

var _calculateNodeHeight = _interopRequireDefault(__webpack_require__(637));

var _raf = _interopRequireDefault(__webpack_require__(295));

var _warning = _interopRequireDefault(__webpack_require__(64));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var ResizableTextArea = /*#__PURE__*/function (_React$Component) {
  _inherits(ResizableTextArea, _React$Component);

  var _super = _createSuper(ResizableTextArea);

  function ResizableTextArea(props) {
    var _this;

    _classCallCheck(this, ResizableTextArea);

    _this = _super.call(this, props);

    _this.saveTextArea = function (textArea) {
      _this.textArea = textArea;
    };

    _this.resizeOnNextFrame = function () {
      _raf["default"].cancel(_this.nextFrameActionId);

      _this.nextFrameActionId = (0, _raf["default"])(_this.resizeTextarea);
    };

    _this.resizeTextarea = function () {
      var autoSize = _this.props.autoSize || _this.props.autosize;

      if (!autoSize || !_this.textArea) {
        return;
      }

      var minRows = autoSize.minRows,
          maxRows = autoSize.maxRows;
      var textareaStyles = (0, _calculateNodeHeight["default"])(_this.textArea, false, minRows, maxRows);

      _this.setState({
        textareaStyles: textareaStyles,
        resizing: true
      }, function () {
        _raf["default"].cancel(_this.resizeFrameId);

        _this.resizeFrameId = (0, _raf["default"])(function () {
          _this.setState({
            resizing: false
          });

          _this.fixFirefoxAutoScroll();
        });
      });
    };

    _this.renderTextArea = function () {
      var _this$props = _this.props,
          prefixCls = _this$props.prefixCls,
          autoSize = _this$props.autoSize,
          autosize = _this$props.autosize,
          className = _this$props.className,
          disabled = _this$props.disabled;
      var _this$state = _this.state,
          textareaStyles = _this$state.textareaStyles,
          resizing = _this$state.resizing;
      (0, _warning["default"])(autosize === undefined, 'Input.TextArea', 'autosize is deprecated, please use autoSize instead.');
      var otherProps = (0, _omit["default"])(_this.props, ['prefixCls', 'onPressEnter', 'autoSize', 'autosize', 'defaultValue', 'allowClear']);
      var cls = (0, _classnames["default"])(prefixCls, className, _defineProperty({}, "".concat(prefixCls, "-disabled"), disabled)); // Fix https://github.com/ant-design/ant-design/issues/6776
      // Make sure it could be reset when using form.getFieldDecorator

      if ('value' in otherProps) {
        otherProps.value = otherProps.value || '';
      }

      var style = _extends(_extends(_extends({}, _this.props.style), textareaStyles), resizing ? {
        overflowX: 'hidden',
        overflowY: 'hidden'
      } : null);

      return /*#__PURE__*/React.createElement(_rcResizeObserver["default"], {
        onResize: _this.resizeOnNextFrame,
        disabled: !(autoSize || autosize)
      }, /*#__PURE__*/React.createElement("textarea", _extends({}, otherProps, {
        className: cls,
        style: style,
        ref: _this.saveTextArea
      })));
    };

    _this.state = {
      textareaStyles: {},
      resizing: false
    };
    return _this;
  }

  _createClass(ResizableTextArea, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.resizeTextarea();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // Re-render with the new content then recalculate the height as required.
      if (prevProps.value !== this.props.value) {
        this.resizeTextarea();
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      _raf["default"].cancel(this.nextFrameActionId);

      _raf["default"].cancel(this.resizeFrameId);
    } // https://github.com/ant-design/ant-design/issues/21870

  }, {
    key: "fixFirefoxAutoScroll",
    value: function fixFirefoxAutoScroll() {
      try {
        if (document.activeElement === this.textArea) {
          var currentStart = this.textArea.selectionStart;
          var currentEnd = this.textArea.selectionEnd;
          this.textArea.setSelectionRange(currentStart, currentEnd);
        }
      } catch (e) {// Fix error in Chrome:
        // Failed to read the 'selectionStart' property from 'HTMLInputElement'
        // http://stackoverflow.com/q/21177489/3040605
      }
    }
  }, {
    key: "render",
    value: function render() {
      return this.renderTextArea();
    }
  }]);

  return ResizableTextArea;
}(React.Component);

(0, _reactLifecyclesCompat.polyfill)(ResizableTextArea);
var _default = ResizableTextArea;
exports["default"] = _default;

/***/ }),
/* 632 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _typeof(obj) { if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

var __importStar = this && this.__importStar || function (mod) {
  if (mod && mod.__esModule) return mod;
  var result = {};
  if (mod != null) for (var k in mod) {
    if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
  }
  result["default"] = mod;
  return result;
};

var __importDefault = this && this.__importDefault || function (mod) {
  return mod && mod.__esModule ? mod : {
    "default": mod
  };
};

Object.defineProperty(exports, "__esModule", {
  value: true
});

var React = __importStar(__webpack_require__(0));

var findDOMNode_1 = __importDefault(__webpack_require__(633));

var toArray_1 = __importDefault(__webpack_require__(634));

var warning_1 = __importDefault(__webpack_require__(286));

var ref_1 = __webpack_require__(635);

var resize_observer_polyfill_1 = __importDefault(__webpack_require__(268));

var util_1 = __webpack_require__(636);

var INTERNAL_PREFIX_KEY = 'rc-observer-key'; // Still need to be compatible with React 15, we use class component here

var ReactResizeObserver =
/*#__PURE__*/
function (_React$Component) {
  _inherits(ReactResizeObserver, _React$Component);

  function ReactResizeObserver() {
    var _this;

    _classCallCheck(this, ReactResizeObserver);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(ReactResizeObserver).apply(this, arguments));
    _this.resizeObserver = null;
    _this.childNode = null;
    _this.currentElement = null;
    _this.state = {
      width: 0,
      height: 0
    };

    _this.onResize = function (entries) {
      var onResize = _this.props.onResize;
      var target = entries[0].target;

      var _target$getBoundingCl = target.getBoundingClientRect(),
          width = _target$getBoundingCl.width,
          height = _target$getBoundingCl.height;
      /**
       * Resize observer trigger when content size changed.
       * In most case we just care about element size,
       * let's use `boundary` instead of `contentRect` here to avoid shaking.
       */


      var fixedWidth = Math.floor(width);
      var fixedHeight = Math.floor(height);

      if (_this.state.width !== fixedWidth || _this.state.height !== fixedHeight) {
        var size = {
          width: fixedWidth,
          height: fixedHeight
        };

        _this.setState(size);

        if (onResize) {
          onResize(size);
        }
      }
    };

    _this.setChildNode = function (node) {
      _this.childNode = node;
    };

    return _this;
  }

  _createClass(ReactResizeObserver, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.onComponentUpdated();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.onComponentUpdated();
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      this.destroyObserver();
    }
  }, {
    key: "onComponentUpdated",
    value: function onComponentUpdated() {
      var disabled = this.props.disabled; // Unregister if disabled

      if (disabled) {
        this.destroyObserver();
        return;
      } // Unregister if element changed


      var element = findDOMNode_1.default(this.childNode || this);
      var elementChanged = element !== this.currentElement;

      if (elementChanged) {
        this.destroyObserver();
        this.currentElement = element;
      }

      if (!this.resizeObserver && element) {
        this.resizeObserver = new resize_observer_polyfill_1.default(this.onResize);
        this.resizeObserver.observe(element);
      }
    }
  }, {
    key: "destroyObserver",
    value: function destroyObserver() {
      if (this.resizeObserver) {
        this.resizeObserver.disconnect();
        this.resizeObserver = null;
      }
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      var childNodes = toArray_1.default(children);

      if (childNodes.length > 1) {
        warning_1.default(false, 'Find more than one child node with `children` in ResizeObserver. Will only observe first one.');
      } else if (childNodes.length === 0) {
        warning_1.default(false, '`children` of ResizeObserver is empty. Nothing is in observe.');
        return null;
      }

      var childNode = childNodes[0];

      if (React.isValidElement(childNode) && util_1.supportRef(childNode)) {
        var ref = childNode.ref;
        childNodes[0] = React.cloneElement(childNode, {
          ref: ref_1.composeRef(ref, this.setChildNode)
        });
      }

      return childNodes.length === 1 ? childNodes[0] : childNodes.map(function (node, index) {
        if (!React.isValidElement(node) || 'key' in node && node.key !== null) {
          return node;
        }

        return React.cloneElement(node, {
          key: "".concat(INTERNAL_PREFIX_KEY, "-").concat(index)
        });
      });
    }
  }]);

  return ReactResizeObserver;
}(React.Component);

ReactResizeObserver.displayName = 'ResizeObserver';
exports.default = ReactResizeObserver;

/***/ }),
/* 633 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = findDOMNode;

var _reactDom = _interopRequireDefault(__webpack_require__(30));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/**
 * Return if a node is a DOM node. Else will return by `findDOMNode`
 */
function findDOMNode(node) {
  if (node instanceof HTMLElement) {
    return node;
  }

  return _reactDom.default.findDOMNode(node);
}

/***/ }),
/* 634 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = toArray;

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactIs = __webpack_require__(50);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function toArray(children) {
  var ret = [];

  _react.default.Children.forEach(children, function (child) {
    if (child === undefined || child === null) {
      return;
    }

    if (Array.isArray(child)) {
      ret = ret.concat(toArray(child));
    } else if ((0, _reactIs.isFragment)(child) && child.props) {
      ret = ret.concat(toArray(child.props.children));
    } else {
      ret.push(child);
    }
  });

  return ret;
}

/***/ }),
/* 635 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.fillRef = fillRef;
exports.composeRef = composeRef;
exports.supportRef = supportRef;

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function fillRef(ref, node) {
  if (typeof ref === 'function') {
    ref(node);
  } else if (_typeof(ref) === 'object' && ref && 'current' in ref) {
    ref.current = node;
  }
}
/**
 * Merge refs into one ref function to support ref passing.
 */


function composeRef() {
  for (var _len = arguments.length, refs = new Array(_len), _key = 0; _key < _len; _key++) {
    refs[_key] = arguments[_key];
  }

  return function (node) {
    refs.forEach(function (ref) {
      fillRef(ref, node);
    });
  };
}

function supportRef(nodeOrComponent) {
  // Function component node
  if (nodeOrComponent.type && nodeOrComponent.type.prototype && !nodeOrComponent.type.prototype.render) {
    return false;
  } // Class component


  if (typeof nodeOrComponent === 'function' && nodeOrComponent.prototype && !nodeOrComponent.prototype.render) {
    return false;
  }

  return true;
}
/* eslint-enable */

/***/ }),
/* 636 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

function supportRef(node) {
  // Function component
  if (node.type && node.type.prototype && !node.type.prototype.render) {
    return false;
  }

  return true;
}

exports.supportRef = supportRef;

/***/ }),
/* 637 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculateNodeStyling = calculateNodeStyling;
exports["default"] = calculateNodeHeight;
// Thanks to https://github.com/andreypopp/react-textarea-autosize/

/**
 * calculateNodeHeight(uiTextNode, useCache = false)
 */
var HIDDEN_TEXTAREA_STYLE = "\n  min-height:0 !important;\n  max-height:none !important;\n  height:0 !important;\n  visibility:hidden !important;\n  overflow:hidden !important;\n  position:absolute !important;\n  z-index:-1000 !important;\n  top:0 !important;\n  right:0 !important\n";
var SIZING_STYLE = ['letter-spacing', 'line-height', 'padding-top', 'padding-bottom', 'font-family', 'font-weight', 'font-size', 'font-variant', 'text-rendering', 'text-transform', 'width', 'text-indent', 'padding-left', 'padding-right', 'border-width', 'box-sizing'];
var computedStyleCache = {};
var hiddenTextarea;

function calculateNodeStyling(node) {
  var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var nodeRef = node.getAttribute('id') || node.getAttribute('data-reactid') || node.getAttribute('name');

  if (useCache && computedStyleCache[nodeRef]) {
    return computedStyleCache[nodeRef];
  }

  var style = window.getComputedStyle(node);
  var boxSizing = style.getPropertyValue('box-sizing') || style.getPropertyValue('-moz-box-sizing') || style.getPropertyValue('-webkit-box-sizing');
  var paddingSize = parseFloat(style.getPropertyValue('padding-bottom')) + parseFloat(style.getPropertyValue('padding-top'));
  var borderSize = parseFloat(style.getPropertyValue('border-bottom-width')) + parseFloat(style.getPropertyValue('border-top-width'));
  var sizingStyle = SIZING_STYLE.map(function (name) {
    return "".concat(name, ":").concat(style.getPropertyValue(name));
  }).join(';');
  var nodeInfo = {
    sizingStyle: sizingStyle,
    paddingSize: paddingSize,
    borderSize: borderSize,
    boxSizing: boxSizing
  };

  if (useCache && nodeRef) {
    computedStyleCache[nodeRef] = nodeInfo;
  }

  return nodeInfo;
}

function calculateNodeHeight(uiTextNode) {
  var useCache = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var minRows = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
  var maxRows = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;

  if (!hiddenTextarea) {
    hiddenTextarea = document.createElement('textarea');
    document.body.appendChild(hiddenTextarea);
  } // Fix wrap="off" issue
  // https://github.com/ant-design/ant-design/issues/6577


  if (uiTextNode.getAttribute('wrap')) {
    hiddenTextarea.setAttribute('wrap', uiTextNode.getAttribute('wrap'));
  } else {
    hiddenTextarea.removeAttribute('wrap');
  } // Copy all CSS properties that have an impact on the height of the content in
  // the textbox


  var _calculateNodeStyling = calculateNodeStyling(uiTextNode, useCache),
      paddingSize = _calculateNodeStyling.paddingSize,
      borderSize = _calculateNodeStyling.borderSize,
      boxSizing = _calculateNodeStyling.boxSizing,
      sizingStyle = _calculateNodeStyling.sizingStyle; // Need to have the overflow attribute to hide the scrollbar otherwise
  // text-lines will not calculated properly as the shadow will technically be
  // narrower for content


  hiddenTextarea.setAttribute('style', "".concat(sizingStyle, ";").concat(HIDDEN_TEXTAREA_STYLE));
  hiddenTextarea.value = uiTextNode.value || uiTextNode.placeholder || '';
  var minHeight = Number.MIN_SAFE_INTEGER;
  var maxHeight = Number.MAX_SAFE_INTEGER;
  var height = hiddenTextarea.scrollHeight;
  var overflowY;

  if (boxSizing === 'border-box') {
    // border-box: add border, since height = content + padding + border
    height += borderSize;
  } else if (boxSizing === 'content-box') {
    // remove padding, since height = content
    height -= paddingSize;
  }

  if (minRows !== null || maxRows !== null) {
    // measure height of a textarea with a single row
    hiddenTextarea.value = ' ';
    var singleRowHeight = hiddenTextarea.scrollHeight - paddingSize;

    if (minRows !== null) {
      minHeight = singleRowHeight * minRows;

      if (boxSizing === 'border-box') {
        minHeight = minHeight + paddingSize + borderSize;
      }

      height = Math.max(minHeight, height);
    }

    if (maxRows !== null) {
      maxHeight = singleRowHeight * maxRows;

      if (boxSizing === 'border-box') {
        maxHeight = maxHeight + paddingSize + borderSize;
      }

      overflowY = height > maxHeight ? '' : 'hidden';
      height = Math.min(maxHeight, height);
    }
  }

  return {
    height: height,
    minHeight: minHeight,
    maxHeight: maxHeight,
    overflowY: overflowY
  };
}

/***/ }),
/* 638 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(24));

var _omit = _interopRequireDefault(__webpack_require__(84));

var _Input = _interopRequireDefault(__webpack_require__(108));

var _icon = _interopRequireDefault(__webpack_require__(60));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var ActionMap = {
  click: 'onClick',
  hover: 'onMouseOver'
};

var Password = /*#__PURE__*/function (_React$Component) {
  _inherits(Password, _React$Component);

  var _super = _createSuper(Password);

  function Password() {
    var _this;

    _classCallCheck(this, Password);

    _this = _super.apply(this, arguments);
    _this.state = {
      visible: false
    };

    _this.onVisibleChange = function () {
      var disabled = _this.props.disabled;

      if (disabled) {
        return;
      }

      _this.setState(function (_ref) {
        var visible = _ref.visible;
        return {
          visible: !visible
        };
      });
    };

    _this.saveInput = function (instance) {
      if (instance && instance.input) {
        _this.input = instance.input;
      }
    };

    return _this;
  }

  _createClass(Password, [{
    key: "getIcon",
    value: function getIcon() {
      var _iconProps;

      var _this$props = this.props,
          prefixCls = _this$props.prefixCls,
          action = _this$props.action;
      var iconTrigger = ActionMap[action] || '';
      var iconProps = (_iconProps = {}, _defineProperty(_iconProps, iconTrigger, this.onVisibleChange), _defineProperty(_iconProps, "className", "".concat(prefixCls, "-icon")), _defineProperty(_iconProps, "type", this.state.visible ? 'eye' : 'eye-invisible'), _defineProperty(_iconProps, "key", 'passwordIcon'), _defineProperty(_iconProps, "onMouseDown", function onMouseDown(e) {
        // Prevent focused state lost
        // https://github.com/ant-design/ant-design/issues/15173
        e.preventDefault();
      }), _iconProps);
      return /*#__PURE__*/React.createElement(_icon["default"], iconProps);
    }
  }, {
    key: "focus",
    value: function focus() {
      this.input.focus();
    }
  }, {
    key: "blur",
    value: function blur() {
      this.input.blur();
    }
  }, {
    key: "select",
    value: function select() {
      this.input.select();
    }
  }, {
    key: "render",
    value: function render() {
      var _a = this.props,
          className = _a.className,
          prefixCls = _a.prefixCls,
          inputPrefixCls = _a.inputPrefixCls,
          size = _a.size,
          visibilityToggle = _a.visibilityToggle,
          restProps = __rest(_a, ["className", "prefixCls", "inputPrefixCls", "size", "visibilityToggle"]);

      var suffixIcon = visibilityToggle && this.getIcon();
      var inputClassName = (0, _classnames["default"])(prefixCls, className, _defineProperty({}, "".concat(prefixCls, "-").concat(size), !!size));
      return /*#__PURE__*/React.createElement(_Input["default"], _extends({}, (0, _omit["default"])(restProps, ['suffix']), {
        type: this.state.visible ? 'text' : 'password',
        size: size,
        className: inputClassName,
        prefixCls: inputPrefixCls,
        suffix: suffixIcon,
        ref: this.saveInput
      }));
    }
  }]);

  return Password;
}(React.Component);

exports["default"] = Password;
Password.defaultProps = {
  inputPrefixCls: 'ant-input',
  prefixCls: 'ant-input-password',
  action: 'click',
  visibilityToggle: true
};

/***/ }),
/* 639 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

// This method of obtaining a reference to the global object needs to be
// kept identical to the way it is obtained in runtime.js
var g = (function() { return this })() || Function("return this")();

// Use `getOwnPropertyNames` because not all browsers support calling
// `hasOwnProperty` on the global `self` object in a worker. See #183.
var hadRuntime = g.regeneratorRuntime &&
  Object.getOwnPropertyNames(g).indexOf("regeneratorRuntime") >= 0;

// Save the old regeneratorRuntime in case it needs to be restored later.
var oldRuntime = hadRuntime && g.regeneratorRuntime;

// Force reevalutation of runtime.js.
g.regeneratorRuntime = undefined;

module.exports = __webpack_require__(640);

if (hadRuntime) {
  // Restore the original runtime.
  g.regeneratorRuntime = oldRuntime;
} else {
  // Remove the global property added by runtime.js.
  try {
    delete g.regeneratorRuntime;
  } catch(e) {
    g.regeneratorRuntime = undefined;
  }
}


/***/ }),
/* 640 */
/***/ (function(module, exports) {

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

!(function(global) {
  "use strict";

  var Op = Object.prototype;
  var hasOwn = Op.hasOwnProperty;
  var undefined; // More compressible than void 0.
  var $Symbol = typeof Symbol === "function" ? Symbol : {};
  var iteratorSymbol = $Symbol.iterator || "@@iterator";
  var asyncIteratorSymbol = $Symbol.asyncIterator || "@@asyncIterator";
  var toStringTagSymbol = $Symbol.toStringTag || "@@toStringTag";

  var inModule = typeof module === "object";
  var runtime = global.regeneratorRuntime;
  if (runtime) {
    if (inModule) {
      // If regeneratorRuntime is defined globally and we're in a module,
      // make the exports object identical to regeneratorRuntime.
      module.exports = runtime;
    }
    // Don't bother evaluating the rest of this file if the runtime was
    // already defined globally.
    return;
  }

  // Define the runtime globally (as expected by generated code) as either
  // module.exports (if we're in a module) or a new, empty object.
  runtime = global.regeneratorRuntime = inModule ? module.exports : {};

  function wrap(innerFn, outerFn, self, tryLocsList) {
    // If outerFn provided and outerFn.prototype is a Generator, then outerFn.prototype instanceof Generator.
    var protoGenerator = outerFn && outerFn.prototype instanceof Generator ? outerFn : Generator;
    var generator = Object.create(protoGenerator.prototype);
    var context = new Context(tryLocsList || []);

    // The ._invoke method unifies the implementations of the .next,
    // .throw, and .return methods.
    generator._invoke = makeInvokeMethod(innerFn, self, context);

    return generator;
  }
  runtime.wrap = wrap;

  // Try/catch helper to minimize deoptimizations. Returns a completion
  // record like context.tryEntries[i].completion. This interface could
  // have been (and was previously) designed to take a closure to be
  // invoked without arguments, but in all the cases we care about we
  // already have an existing method we want to call, so there's no need
  // to create a new function object. We can even get away with assuming
  // the method takes exactly one argument, since that happens to be true
  // in every case, so we don't have to touch the arguments object. The
  // only additional allocation required is the completion record, which
  // has a stable shape and so hopefully should be cheap to allocate.
  function tryCatch(fn, obj, arg) {
    try {
      return { type: "normal", arg: fn.call(obj, arg) };
    } catch (err) {
      return { type: "throw", arg: err };
    }
  }

  var GenStateSuspendedStart = "suspendedStart";
  var GenStateSuspendedYield = "suspendedYield";
  var GenStateExecuting = "executing";
  var GenStateCompleted = "completed";

  // Returning this object from the innerFn has the same effect as
  // breaking out of the dispatch switch statement.
  var ContinueSentinel = {};

  // Dummy constructor functions that we use as the .constructor and
  // .constructor.prototype properties for functions that return Generator
  // objects. For full spec compliance, you may wish to configure your
  // minifier not to mangle the names of these two functions.
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}

  // This is a polyfill for %IteratorPrototype% for environments that
  // don't natively support it.
  var IteratorPrototype = {};
  IteratorPrototype[iteratorSymbol] = function () {
    return this;
  };

  var getProto = Object.getPrototypeOf;
  var NativeIteratorPrototype = getProto && getProto(getProto(values([])));
  if (NativeIteratorPrototype &&
      NativeIteratorPrototype !== Op &&
      hasOwn.call(NativeIteratorPrototype, iteratorSymbol)) {
    // This environment has a native %IteratorPrototype%; use it instead
    // of the polyfill.
    IteratorPrototype = NativeIteratorPrototype;
  }

  var Gp = GeneratorFunctionPrototype.prototype =
    Generator.prototype = Object.create(IteratorPrototype);
  GeneratorFunction.prototype = Gp.constructor = GeneratorFunctionPrototype;
  GeneratorFunctionPrototype.constructor = GeneratorFunction;
  GeneratorFunctionPrototype[toStringTagSymbol] =
    GeneratorFunction.displayName = "GeneratorFunction";

  // Helper for defining the .next, .throw, and .return methods of the
  // Iterator interface in terms of a single ._invoke method.
  function defineIteratorMethods(prototype) {
    ["next", "throw", "return"].forEach(function(method) {
      prototype[method] = function(arg) {
        return this._invoke(method, arg);
      };
    });
  }

  runtime.isGeneratorFunction = function(genFun) {
    var ctor = typeof genFun === "function" && genFun.constructor;
    return ctor
      ? ctor === GeneratorFunction ||
        // For the native GeneratorFunction constructor, the best we can
        // do is to check its .name property.
        (ctor.displayName || ctor.name) === "GeneratorFunction"
      : false;
  };

  runtime.mark = function(genFun) {
    if (Object.setPrototypeOf) {
      Object.setPrototypeOf(genFun, GeneratorFunctionPrototype);
    } else {
      genFun.__proto__ = GeneratorFunctionPrototype;
      if (!(toStringTagSymbol in genFun)) {
        genFun[toStringTagSymbol] = "GeneratorFunction";
      }
    }
    genFun.prototype = Object.create(Gp);
    return genFun;
  };

  // Within the body of any async function, `await x` is transformed to
  // `yield regeneratorRuntime.awrap(x)`, so that the runtime can test
  // `hasOwn.call(value, "__await")` to determine if the yielded value is
  // meant to be awaited.
  runtime.awrap = function(arg) {
    return { __await: arg };
  };

  function AsyncIterator(generator) {
    function invoke(method, arg, resolve, reject) {
      var record = tryCatch(generator[method], generator, arg);
      if (record.type === "throw") {
        reject(record.arg);
      } else {
        var result = record.arg;
        var value = result.value;
        if (value &&
            typeof value === "object" &&
            hasOwn.call(value, "__await")) {
          return Promise.resolve(value.__await).then(function(value) {
            invoke("next", value, resolve, reject);
          }, function(err) {
            invoke("throw", err, resolve, reject);
          });
        }

        return Promise.resolve(value).then(function(unwrapped) {
          // When a yielded Promise is resolved, its final value becomes
          // the .value of the Promise<{value,done}> result for the
          // current iteration. If the Promise is rejected, however, the
          // result for this iteration will be rejected with the same
          // reason. Note that rejections of yielded Promises are not
          // thrown back into the generator function, as is the case
          // when an awaited Promise is rejected. This difference in
          // behavior between yield and await is important, because it
          // allows the consumer to decide what to do with the yielded
          // rejection (swallow it and continue, manually .throw it back
          // into the generator, abandon iteration, whatever). With
          // await, by contrast, there is no opportunity to examine the
          // rejection reason outside the generator function, so the
          // only option is to throw it from the await expression, and
          // let the generator function handle the exception.
          result.value = unwrapped;
          resolve(result);
        }, reject);
      }
    }

    var previousPromise;

    function enqueue(method, arg) {
      function callInvokeWithMethodAndArg() {
        return new Promise(function(resolve, reject) {
          invoke(method, arg, resolve, reject);
        });
      }

      return previousPromise =
        // If enqueue has been called before, then we want to wait until
        // all previous Promises have been resolved before calling invoke,
        // so that results are always delivered in the correct order. If
        // enqueue has not been called before, then it is important to
        // call invoke immediately, without waiting on a callback to fire,
        // so that the async generator function has the opportunity to do
        // any necessary setup in a predictable way. This predictability
        // is why the Promise constructor synchronously invokes its
        // executor callback, and why async functions synchronously
        // execute code before the first await. Since we implement simple
        // async functions in terms of async generators, it is especially
        // important to get this right, even though it requires care.
        previousPromise ? previousPromise.then(
          callInvokeWithMethodAndArg,
          // Avoid propagating failures to Promises returned by later
          // invocations of the iterator.
          callInvokeWithMethodAndArg
        ) : callInvokeWithMethodAndArg();
    }

    // Define the unified helper method that is used to implement .next,
    // .throw, and .return (see defineIteratorMethods).
    this._invoke = enqueue;
  }

  defineIteratorMethods(AsyncIterator.prototype);
  AsyncIterator.prototype[asyncIteratorSymbol] = function () {
    return this;
  };
  runtime.AsyncIterator = AsyncIterator;

  // Note that simple async functions are implemented on top of
  // AsyncIterator objects; they just return a Promise for the value of
  // the final result produced by the iterator.
  runtime.async = function(innerFn, outerFn, self, tryLocsList) {
    var iter = new AsyncIterator(
      wrap(innerFn, outerFn, self, tryLocsList)
    );

    return runtime.isGeneratorFunction(outerFn)
      ? iter // If outerFn is a generator, return the full iterator.
      : iter.next().then(function(result) {
          return result.done ? result.value : iter.next();
        });
  };

  function makeInvokeMethod(innerFn, self, context) {
    var state = GenStateSuspendedStart;

    return function invoke(method, arg) {
      if (state === GenStateExecuting) {
        throw new Error("Generator is already running");
      }

      if (state === GenStateCompleted) {
        if (method === "throw") {
          throw arg;
        }

        // Be forgiving, per 25.3.3.3.3 of the spec:
        // https://people.mozilla.org/~jorendorff/es6-draft.html#sec-generatorresume
        return doneResult();
      }

      context.method = method;
      context.arg = arg;

      while (true) {
        var delegate = context.delegate;
        if (delegate) {
          var delegateResult = maybeInvokeDelegate(delegate, context);
          if (delegateResult) {
            if (delegateResult === ContinueSentinel) continue;
            return delegateResult;
          }
        }

        if (context.method === "next") {
          // Setting context._sent for legacy support of Babel's
          // function.sent implementation.
          context.sent = context._sent = context.arg;

        } else if (context.method === "throw") {
          if (state === GenStateSuspendedStart) {
            state = GenStateCompleted;
            throw context.arg;
          }

          context.dispatchException(context.arg);

        } else if (context.method === "return") {
          context.abrupt("return", context.arg);
        }

        state = GenStateExecuting;

        var record = tryCatch(innerFn, self, context);
        if (record.type === "normal") {
          // If an exception is thrown from innerFn, we leave state ===
          // GenStateExecuting and loop back for another invocation.
          state = context.done
            ? GenStateCompleted
            : GenStateSuspendedYield;

          if (record.arg === ContinueSentinel) {
            continue;
          }

          return {
            value: record.arg,
            done: context.done
          };

        } else if (record.type === "throw") {
          state = GenStateCompleted;
          // Dispatch the exception by looping back around to the
          // context.dispatchException(context.arg) call above.
          context.method = "throw";
          context.arg = record.arg;
        }
      }
    };
  }

  // Call delegate.iterator[context.method](context.arg) and handle the
  // result, either by returning a { value, done } result from the
  // delegate iterator, or by modifying context.method and context.arg,
  // setting context.delegate to null, and returning the ContinueSentinel.
  function maybeInvokeDelegate(delegate, context) {
    var method = delegate.iterator[context.method];
    if (method === undefined) {
      // A .throw or .return when the delegate iterator has no .throw
      // method always terminates the yield* loop.
      context.delegate = null;

      if (context.method === "throw") {
        if (delegate.iterator.return) {
          // If the delegate iterator has a return method, give it a
          // chance to clean up.
          context.method = "return";
          context.arg = undefined;
          maybeInvokeDelegate(delegate, context);

          if (context.method === "throw") {
            // If maybeInvokeDelegate(context) changed context.method from
            // "return" to "throw", let that override the TypeError below.
            return ContinueSentinel;
          }
        }

        context.method = "throw";
        context.arg = new TypeError(
          "The iterator does not provide a 'throw' method");
      }

      return ContinueSentinel;
    }

    var record = tryCatch(method, delegate.iterator, context.arg);

    if (record.type === "throw") {
      context.method = "throw";
      context.arg = record.arg;
      context.delegate = null;
      return ContinueSentinel;
    }

    var info = record.arg;

    if (! info) {
      context.method = "throw";
      context.arg = new TypeError("iterator result is not an object");
      context.delegate = null;
      return ContinueSentinel;
    }

    if (info.done) {
      // Assign the result of the finished delegate to the temporary
      // variable specified by delegate.resultName (see delegateYield).
      context[delegate.resultName] = info.value;

      // Resume execution at the desired location (see delegateYield).
      context.next = delegate.nextLoc;

      // If context.method was "throw" but the delegate handled the
      // exception, let the outer generator proceed normally. If
      // context.method was "next", forget context.arg since it has been
      // "consumed" by the delegate iterator. If context.method was
      // "return", allow the original .return call to continue in the
      // outer generator.
      if (context.method !== "return") {
        context.method = "next";
        context.arg = undefined;
      }

    } else {
      // Re-yield the result returned by the delegate method.
      return info;
    }

    // The delegate iterator is finished, so forget it and continue with
    // the outer generator.
    context.delegate = null;
    return ContinueSentinel;
  }

  // Define Generator.prototype.{next,throw,return} in terms of the
  // unified ._invoke helper method.
  defineIteratorMethods(Gp);

  Gp[toStringTagSymbol] = "Generator";

  // A Generator should always return itself as the iterator object when the
  // @@iterator function is called on it. Some browsers' implementations of the
  // iterator prototype chain incorrectly implement this, causing the Generator
  // object to not be returned from this call. This ensures that doesn't happen.
  // See https://github.com/facebook/regenerator/issues/274 for more details.
  Gp[iteratorSymbol] = function() {
    return this;
  };

  Gp.toString = function() {
    return "[object Generator]";
  };

  function pushTryEntry(locs) {
    var entry = { tryLoc: locs[0] };

    if (1 in locs) {
      entry.catchLoc = locs[1];
    }

    if (2 in locs) {
      entry.finallyLoc = locs[2];
      entry.afterLoc = locs[3];
    }

    this.tryEntries.push(entry);
  }

  function resetTryEntry(entry) {
    var record = entry.completion || {};
    record.type = "normal";
    delete record.arg;
    entry.completion = record;
  }

  function Context(tryLocsList) {
    // The root entry object (effectively a try statement without a catch
    // or a finally block) gives us a place to store values thrown from
    // locations where there is no enclosing try statement.
    this.tryEntries = [{ tryLoc: "root" }];
    tryLocsList.forEach(pushTryEntry, this);
    this.reset(true);
  }

  runtime.keys = function(object) {
    var keys = [];
    for (var key in object) {
      keys.push(key);
    }
    keys.reverse();

    // Rather than returning an object with a next method, we keep
    // things simple and return the next function itself.
    return function next() {
      while (keys.length) {
        var key = keys.pop();
        if (key in object) {
          next.value = key;
          next.done = false;
          return next;
        }
      }

      // To avoid creating an additional object, we just hang the .value
      // and .done properties off the next function object itself. This
      // also ensures that the minifier will not anonymize the function.
      next.done = true;
      return next;
    };
  };

  function values(iterable) {
    if (iterable) {
      var iteratorMethod = iterable[iteratorSymbol];
      if (iteratorMethod) {
        return iteratorMethod.call(iterable);
      }

      if (typeof iterable.next === "function") {
        return iterable;
      }

      if (!isNaN(iterable.length)) {
        var i = -1, next = function next() {
          while (++i < iterable.length) {
            if (hasOwn.call(iterable, i)) {
              next.value = iterable[i];
              next.done = false;
              return next;
            }
          }

          next.value = undefined;
          next.done = true;

          return next;
        };

        return next.next = next;
      }
    }

    // Return an iterator with no values.
    return { next: doneResult };
  }
  runtime.values = values;

  function doneResult() {
    return { value: undefined, done: true };
  }

  Context.prototype = {
    constructor: Context,

    reset: function(skipTempReset) {
      this.prev = 0;
      this.next = 0;
      // Resetting context._sent for legacy support of Babel's
      // function.sent implementation.
      this.sent = this._sent = undefined;
      this.done = false;
      this.delegate = null;

      this.method = "next";
      this.arg = undefined;

      this.tryEntries.forEach(resetTryEntry);

      if (!skipTempReset) {
        for (var name in this) {
          // Not sure about the optimal order of these conditions:
          if (name.charAt(0) === "t" &&
              hasOwn.call(this, name) &&
              !isNaN(+name.slice(1))) {
            this[name] = undefined;
          }
        }
      }
    },

    stop: function() {
      this.done = true;

      var rootEntry = this.tryEntries[0];
      var rootRecord = rootEntry.completion;
      if (rootRecord.type === "throw") {
        throw rootRecord.arg;
      }

      return this.rval;
    },

    dispatchException: function(exception) {
      if (this.done) {
        throw exception;
      }

      var context = this;
      function handle(loc, caught) {
        record.type = "throw";
        record.arg = exception;
        context.next = loc;

        if (caught) {
          // If the dispatched exception was caught by a catch block,
          // then let that catch block handle the exception normally.
          context.method = "next";
          context.arg = undefined;
        }

        return !! caught;
      }

      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        var record = entry.completion;

        if (entry.tryLoc === "root") {
          // Exception thrown outside of any try block that could handle
          // it, so set the completion value of the entire function to
          // throw the exception.
          return handle("end");
        }

        if (entry.tryLoc <= this.prev) {
          var hasCatch = hasOwn.call(entry, "catchLoc");
          var hasFinally = hasOwn.call(entry, "finallyLoc");

          if (hasCatch && hasFinally) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            } else if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else if (hasCatch) {
            if (this.prev < entry.catchLoc) {
              return handle(entry.catchLoc, true);
            }

          } else if (hasFinally) {
            if (this.prev < entry.finallyLoc) {
              return handle(entry.finallyLoc);
            }

          } else {
            throw new Error("try statement without catch or finally");
          }
        }
      }
    },

    abrupt: function(type, arg) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc <= this.prev &&
            hasOwn.call(entry, "finallyLoc") &&
            this.prev < entry.finallyLoc) {
          var finallyEntry = entry;
          break;
        }
      }

      if (finallyEntry &&
          (type === "break" ||
           type === "continue") &&
          finallyEntry.tryLoc <= arg &&
          arg <= finallyEntry.finallyLoc) {
        // Ignore the finally entry if control is not jumping to a
        // location outside the try/catch block.
        finallyEntry = null;
      }

      var record = finallyEntry ? finallyEntry.completion : {};
      record.type = type;
      record.arg = arg;

      if (finallyEntry) {
        this.method = "next";
        this.next = finallyEntry.finallyLoc;
        return ContinueSentinel;
      }

      return this.complete(record);
    },

    complete: function(record, afterLoc) {
      if (record.type === "throw") {
        throw record.arg;
      }

      if (record.type === "break" ||
          record.type === "continue") {
        this.next = record.arg;
      } else if (record.type === "return") {
        this.rval = this.arg = record.arg;
        this.method = "return";
        this.next = "end";
      } else if (record.type === "normal" && afterLoc) {
        this.next = afterLoc;
      }

      return ContinueSentinel;
    },

    finish: function(finallyLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.finallyLoc === finallyLoc) {
          this.complete(entry.completion, entry.afterLoc);
          resetTryEntry(entry);
          return ContinueSentinel;
        }
      }
    },

    "catch": function(tryLoc) {
      for (var i = this.tryEntries.length - 1; i >= 0; --i) {
        var entry = this.tryEntries[i];
        if (entry.tryLoc === tryLoc) {
          var record = entry.completion;
          if (record.type === "throw") {
            var thrown = record.arg;
            resetTryEntry(entry);
          }
          return thrown;
        }
      }

      // The context.catch method must only be called with a location
      // argument that corresponds to a known catch block.
      throw new Error("illegal catch attempt");
    },

    delegateYield: function(iterable, resultName, nextLoc) {
      this.delegate = {
        iterator: values(iterable),
        resultName: resultName,
        nextLoc: nextLoc
      };

      if (this.method === "next") {
        // Deliberately forget the last sent value so that we don't
        // accidentally pass it on to the delegate.
        this.arg = undefined;
      }

      return ContinueSentinel;
    }
  };
})(
  // In sloppy mode, unbound `this` refers to the global object, fallback to
  // Function constructor if we're in global strict mode. That is sadly a form
  // of indirect eval which violates Content Security Policy.
  (function() { return this })() || Function("return this")()
);


/***/ }),
/* 641 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 642 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(104);

__webpack_require__(643);

/***/ }),
/* 643 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 644 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(24));

var _createDOMForm = _interopRequireDefault(__webpack_require__(645));

var _createFormField = _interopRequireDefault(__webpack_require__(302));

var _omit = _interopRequireDefault(__webpack_require__(84));

var _configProvider = __webpack_require__(28);

var _type = __webpack_require__(85);

var _warning = _interopRequireDefault(__webpack_require__(64));

var _FormItem = _interopRequireDefault(__webpack_require__(689));

var _constants = __webpack_require__(306);

var _context = _interopRequireDefault(__webpack_require__(307));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var FormLayouts = (0, _type.tuple)('horizontal', 'inline', 'vertical');

var Form = /*#__PURE__*/function (_React$Component) {
  _inherits(Form, _React$Component);

  var _super = _createSuper(Form);

  function Form(props) {
    var _this;

    _classCallCheck(this, Form);

    _this = _super.call(this, props);

    _this.renderForm = function (_ref) {
      var _classNames;

      var getPrefixCls = _ref.getPrefixCls;
      var _this$props = _this.props,
          customizePrefixCls = _this$props.prefixCls,
          hideRequiredMark = _this$props.hideRequiredMark,
          _this$props$className = _this$props.className,
          className = _this$props$className === void 0 ? '' : _this$props$className,
          layout = _this$props.layout;
      var prefixCls = getPrefixCls('form', customizePrefixCls);
      var formClassName = (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-horizontal"), layout === 'horizontal'), _defineProperty(_classNames, "".concat(prefixCls, "-vertical"), layout === 'vertical'), _defineProperty(_classNames, "".concat(prefixCls, "-inline"), layout === 'inline'), _defineProperty(_classNames, "".concat(prefixCls, "-hide-required-mark"), hideRequiredMark), _classNames), className);
      var formProps = (0, _omit["default"])(_this.props, ['prefixCls', 'className', 'layout', 'form', 'hideRequiredMark', 'wrapperCol', 'labelAlign', 'labelCol', 'colon']);
      return /*#__PURE__*/React.createElement("form", _extends({}, formProps, {
        className: formClassName
      }));
    };

    (0, _warning["default"])(!props.form, 'Form', 'It is unnecessary to pass `form` to `Form` after antd@1.7.0.');
    return _this;
  }

  _createClass(Form, [{
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          wrapperCol = _this$props2.wrapperCol,
          labelAlign = _this$props2.labelAlign,
          labelCol = _this$props2.labelCol,
          layout = _this$props2.layout,
          colon = _this$props2.colon;
      return /*#__PURE__*/React.createElement(_context["default"].Provider, {
        value: {
          wrapperCol: wrapperCol,
          labelAlign: labelAlign,
          labelCol: labelCol,
          vertical: layout === 'vertical',
          colon: colon
        }
      }, /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderForm));
    }
  }]);

  return Form;
}(React.Component);

exports["default"] = Form;
Form.defaultProps = {
  colon: true,
  layout: 'horizontal',
  hideRequiredMark: false,
  onSubmit: function onSubmit(e) {
    e.preventDefault();
  }
};
Form.propTypes = {
  prefixCls: PropTypes.string,
  layout: PropTypes.oneOf(FormLayouts),
  children: PropTypes.any,
  onSubmit: PropTypes.func,
  hideRequiredMark: PropTypes.bool,
  colon: PropTypes.bool
};
Form.Item = _FormItem["default"];
Form.createFormField = _createFormField["default"];

Form.create = function create() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  return (0, _createDOMForm["default"])(_extends(_extends({
    fieldNameProp: 'id'
  }, options), {
    fieldMetaProp: _constants.FIELD_META_PROP,
    fieldDataProp: _constants.FIELD_DATA_PROP
  }));
};

/***/ }),
/* 645 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends2 = __webpack_require__(49);

var _extends3 = _interopRequireDefault(_extends2);

var _reactDom = __webpack_require__(30);

var _reactDom2 = _interopRequireDefault(_reactDom);

var _domScrollIntoView = __webpack_require__(646);

var _domScrollIntoView2 = _interopRequireDefault(_domScrollIntoView);

var _has = __webpack_require__(649);

var _has2 = _interopRequireDefault(_has);

var _createBaseForm = __webpack_require__(298);

var _createBaseForm2 = _interopRequireDefault(_createBaseForm);

var _createForm = __webpack_require__(688);

var _utils = __webpack_require__(189);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function computedStyle(el, prop) {
  var getComputedStyle = window.getComputedStyle;
  var style =
  // If we have getComputedStyle
  getComputedStyle ?
  // Query it
  // TODO: From CSS-Query notes, we might need (node, null) for FF
  getComputedStyle(el) :

  // Otherwise, we are in IE and use currentStyle
  el.currentStyle;
  if (style) {
    return style[
    // Switch to camelCase for CSSOM
    // DEV: Grabbed from jQuery
    // https://github.com/jquery/jquery/blob/1.9-stable/src/css.js#L191-L194
    // https://github.com/jquery/jquery/blob/1.9-stable/src/core.js#L593-L597
    prop.replace(/-(\w)/gi, function (word, letter) {
      return letter.toUpperCase();
    })];
  }
  return undefined;
}

function getScrollableContainer(n) {
  var node = n;
  var nodeName = void 0;
  /* eslint no-cond-assign:0 */
  while ((nodeName = node.nodeName.toLowerCase()) !== 'body') {
    var overflowY = computedStyle(node, 'overflowY');
    // https://stackoverflow.com/a/36900407/3040605
    if (node !== n && (overflowY === 'auto' || overflowY === 'scroll') && node.scrollHeight > node.clientHeight) {
      return node;
    }
    node = node.parentNode;
  }
  return nodeName === 'body' ? node.ownerDocument : node;
}

var mixin = {
  getForm: function getForm() {
    return (0, _extends3['default'])({}, _createForm.mixin.getForm.call(this), {
      validateFieldsAndScroll: this.validateFieldsAndScroll
    });
  },
  validateFieldsAndScroll: function validateFieldsAndScroll(ns, opt, cb) {
    var _this = this;

    var _getParams = (0, _utils.getParams)(ns, opt, cb),
        names = _getParams.names,
        callback = _getParams.callback,
        options = _getParams.options;

    var newCb = function newCb(error, values) {
      if (error) {
        var validNames = _this.fieldsStore.getValidFieldsName();
        var firstNode = void 0;
        var firstTop = void 0;

        validNames.forEach(function (name) {
          if ((0, _has2['default'])(error, name)) {
            var instance = _this.getFieldInstance(name);
            if (instance) {
              var node = _reactDom2['default'].findDOMNode(instance);
              var top = node.getBoundingClientRect().top;
              if (node.type !== 'hidden' && (firstTop === undefined || firstTop > top)) {
                firstTop = top;
                firstNode = node;
              }
            }
          }
        });

        if (firstNode) {
          var c = options.container || getScrollableContainer(firstNode);
          (0, _domScrollIntoView2['default'])(firstNode, c, (0, _extends3['default'])({
            onlyScrollIfNeeded: true
          }, options.scroll));
        }
      }

      if (typeof callback === 'function') {
        callback(error, values);
      }
    };

    return this.validateFields(names, options, newCb);
  }
};

function createDOMForm(option) {
  return (0, _createBaseForm2['default'])((0, _extends3['default'])({}, option), [mixin]);
}

exports['default'] = createDOMForm;
module.exports = exports['default'];

/***/ }),
/* 646 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(647);

/***/ }),
/* 647 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var util = __webpack_require__(648);

function scrollIntoView(elem, container, config) {
  config = config || {};
  // document 归一化到 window
  if (container.nodeType === 9) {
    container = util.getWindow(container);
  }

  var allowHorizontalScroll = config.allowHorizontalScroll;
  var onlyScrollIfNeeded = config.onlyScrollIfNeeded;
  var alignWithTop = config.alignWithTop;
  var alignWithLeft = config.alignWithLeft;
  var offsetTop = config.offsetTop || 0;
  var offsetLeft = config.offsetLeft || 0;
  var offsetBottom = config.offsetBottom || 0;
  var offsetRight = config.offsetRight || 0;

  allowHorizontalScroll = allowHorizontalScroll === undefined ? true : allowHorizontalScroll;

  var isWin = util.isWindow(container);
  var elemOffset = util.offset(elem);
  var eh = util.outerHeight(elem);
  var ew = util.outerWidth(elem);
  var containerOffset = undefined;
  var ch = undefined;
  var cw = undefined;
  var containerScroll = undefined;
  var diffTop = undefined;
  var diffBottom = undefined;
  var win = undefined;
  var winScroll = undefined;
  var ww = undefined;
  var wh = undefined;

  if (isWin) {
    win = container;
    wh = util.height(win);
    ww = util.width(win);
    winScroll = {
      left: util.scrollLeft(win),
      top: util.scrollTop(win)
    };
    // elem 相对 container 可视视窗的距离
    diffTop = {
      left: elemOffset.left - winScroll.left - offsetLeft,
      top: elemOffset.top - winScroll.top - offsetTop
    };
    diffBottom = {
      left: elemOffset.left + ew - (winScroll.left + ww) + offsetRight,
      top: elemOffset.top + eh - (winScroll.top + wh) + offsetBottom
    };
    containerScroll = winScroll;
  } else {
    containerOffset = util.offset(container);
    ch = container.clientHeight;
    cw = container.clientWidth;
    containerScroll = {
      left: container.scrollLeft,
      top: container.scrollTop
    };
    // elem 相对 container 可视视窗的距离
    // 注意边框, offset 是边框到根节点
    diffTop = {
      left: elemOffset.left - (containerOffset.left + (parseFloat(util.css(container, 'borderLeftWidth')) || 0)) - offsetLeft,
      top: elemOffset.top - (containerOffset.top + (parseFloat(util.css(container, 'borderTopWidth')) || 0)) - offsetTop
    };
    diffBottom = {
      left: elemOffset.left + ew - (containerOffset.left + cw + (parseFloat(util.css(container, 'borderRightWidth')) || 0)) + offsetRight,
      top: elemOffset.top + eh - (containerOffset.top + ch + (parseFloat(util.css(container, 'borderBottomWidth')) || 0)) + offsetBottom
    };
  }

  if (diffTop.top < 0 || diffBottom.top > 0) {
    // 强制向上
    if (alignWithTop === true) {
      util.scrollTop(container, containerScroll.top + diffTop.top);
    } else if (alignWithTop === false) {
      util.scrollTop(container, containerScroll.top + diffBottom.top);
    } else {
      // 自动调整
      if (diffTop.top < 0) {
        util.scrollTop(container, containerScroll.top + diffTop.top);
      } else {
        util.scrollTop(container, containerScroll.top + diffBottom.top);
      }
    }
  } else {
    if (!onlyScrollIfNeeded) {
      alignWithTop = alignWithTop === undefined ? true : !!alignWithTop;
      if (alignWithTop) {
        util.scrollTop(container, containerScroll.top + diffTop.top);
      } else {
        util.scrollTop(container, containerScroll.top + diffBottom.top);
      }
    }
  }

  if (allowHorizontalScroll) {
    if (diffTop.left < 0 || diffBottom.left > 0) {
      // 强制向上
      if (alignWithLeft === true) {
        util.scrollLeft(container, containerScroll.left + diffTop.left);
      } else if (alignWithLeft === false) {
        util.scrollLeft(container, containerScroll.left + diffBottom.left);
      } else {
        // 自动调整
        if (diffTop.left < 0) {
          util.scrollLeft(container, containerScroll.left + diffTop.left);
        } else {
          util.scrollLeft(container, containerScroll.left + diffBottom.left);
        }
      }
    } else {
      if (!onlyScrollIfNeeded) {
        alignWithLeft = alignWithLeft === undefined ? true : !!alignWithLeft;
        if (alignWithLeft) {
          util.scrollLeft(container, containerScroll.left + diffTop.left);
        } else {
          util.scrollLeft(container, containerScroll.left + diffBottom.left);
        }
      }
    }
  }
}

module.exports = scrollIntoView;

/***/ }),
/* 648 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj; };

var RE_NUM = /[\-+]?(?:\d*\.|)\d+(?:[eE][\-+]?\d+|)/.source;

function getClientPosition(elem) {
  var box = undefined;
  var x = undefined;
  var y = undefined;
  var doc = elem.ownerDocument;
  var body = doc.body;
  var docElem = doc && doc.documentElement;
  // 根据 GBS 最新数据，A-Grade Browsers 都已支持 getBoundingClientRect 方法，不用再考虑传统的实现方式
  box = elem.getBoundingClientRect();

  // 注：jQuery 还考虑减去 docElem.clientLeft/clientTop
  // 但测试发现，这样反而会导致当 html 和 body 有边距/边框样式时，获取的值不正确
  // 此外，ie6 会忽略 html 的 margin 值，幸运地是没有谁会去设置 html 的 margin

  x = box.left;
  y = box.top;

  // In IE, most of the time, 2 extra pixels are added to the top and left
  // due to the implicit 2-pixel inset border.  In IE6/7 quirks mode and
  // IE6 standards mode, this border can be overridden by setting the
  // document element's border to zero -- thus, we cannot rely on the
  // offset always being 2 pixels.

  // In quirks mode, the offset can be determined by querying the body's
  // clientLeft/clientTop, but in standards mode, it is found by querying
  // the document element's clientLeft/clientTop.  Since we already called
  // getClientBoundingRect we have already forced a reflow, so it is not
  // too expensive just to query them all.

  // ie 下应该减去窗口的边框吧，毕竟默认 absolute 都是相对窗口定位的
  // 窗口边框标准是设 documentElement ,quirks 时设置 body
  // 最好禁止在 body 和 html 上边框 ，但 ie < 9 html 默认有 2px ，减去
  // 但是非 ie 不可能设置窗口边框，body html 也不是窗口 ,ie 可以通过 html,body 设置
  // 标准 ie 下 docElem.clientTop 就是 border-top
  // ie7 html 即窗口边框改变不了。永远为 2
  // 但标准 firefox/chrome/ie9 下 docElem.clientTop 是窗口边框，即使设了 border-top 也为 0

  x -= docElem.clientLeft || body.clientLeft || 0;
  y -= docElem.clientTop || body.clientTop || 0;

  return {
    left: x,
    top: y
  };
}

function getScroll(w, top) {
  var ret = w['page' + (top ? 'Y' : 'X') + 'Offset'];
  var method = 'scroll' + (top ? 'Top' : 'Left');
  if (typeof ret !== 'number') {
    var d = w.document;
    // ie6,7,8 standard mode
    ret = d.documentElement[method];
    if (typeof ret !== 'number') {
      // quirks mode
      ret = d.body[method];
    }
  }
  return ret;
}

function getScrollLeft(w) {
  return getScroll(w);
}

function getScrollTop(w) {
  return getScroll(w, true);
}

function getOffset(el) {
  var pos = getClientPosition(el);
  var doc = el.ownerDocument;
  var w = doc.defaultView || doc.parentWindow;
  pos.left += getScrollLeft(w);
  pos.top += getScrollTop(w);
  return pos;
}
function _getComputedStyle(elem, name, computedStyle_) {
  var val = '';
  var d = elem.ownerDocument;
  var computedStyle = computedStyle_ || d.defaultView.getComputedStyle(elem, null);

  // https://github.com/kissyteam/kissy/issues/61
  if (computedStyle) {
    val = computedStyle.getPropertyValue(name) || computedStyle[name];
  }

  return val;
}

var _RE_NUM_NO_PX = new RegExp('^(' + RE_NUM + ')(?!px)[a-z%]+$', 'i');
var RE_POS = /^(top|right|bottom|left)$/;
var CURRENT_STYLE = 'currentStyle';
var RUNTIME_STYLE = 'runtimeStyle';
var LEFT = 'left';
var PX = 'px';

function _getComputedStyleIE(elem, name) {
  // currentStyle maybe null
  // http://msdn.microsoft.com/en-us/library/ms535231.aspx
  var ret = elem[CURRENT_STYLE] && elem[CURRENT_STYLE][name];

  // 当 width/height 设置为百分比时，通过 pixelLeft 方式转换的 width/height 值
  // 一开始就处理了! CUSTOM_STYLE.height,CUSTOM_STYLE.width ,cssHook 解决@2011-08-19
  // 在 ie 下不对，需要直接用 offset 方式
  // borderWidth 等值也有问题，但考虑到 borderWidth 设为百分比的概率很小，这里就不考虑了

  // From the awesome hack by Dean Edwards
  // http://erik.eae.net/archives/2007/07/27/18.54.15/#comment-102291
  // If we're not dealing with a regular pixel number
  // but a number that has a weird ending, we need to convert it to pixels
  // exclude left right for relativity
  if (_RE_NUM_NO_PX.test(ret) && !RE_POS.test(name)) {
    // Remember the original values
    var style = elem.style;
    var left = style[LEFT];
    var rsLeft = elem[RUNTIME_STYLE][LEFT];

    // prevent flashing of content
    elem[RUNTIME_STYLE][LEFT] = elem[CURRENT_STYLE][LEFT];

    // Put in the new values to get a computed value out
    style[LEFT] = name === 'fontSize' ? '1em' : ret || 0;
    ret = style.pixelLeft + PX;

    // Revert the changed values
    style[LEFT] = left;

    elem[RUNTIME_STYLE][LEFT] = rsLeft;
  }
  return ret === '' ? 'auto' : ret;
}

var getComputedStyleX = undefined;
if (typeof window !== 'undefined') {
  getComputedStyleX = window.getComputedStyle ? _getComputedStyle : _getComputedStyleIE;
}

function each(arr, fn) {
  for (var i = 0; i < arr.length; i++) {
    fn(arr[i]);
  }
}

function isBorderBoxFn(elem) {
  return getComputedStyleX(elem, 'boxSizing') === 'border-box';
}

var BOX_MODELS = ['margin', 'border', 'padding'];
var CONTENT_INDEX = -1;
var PADDING_INDEX = 2;
var BORDER_INDEX = 1;
var MARGIN_INDEX = 0;

function swap(elem, options, callback) {
  var old = {};
  var style = elem.style;
  var name = undefined;

  // Remember the old values, and insert the new ones
  for (name in options) {
    if (options.hasOwnProperty(name)) {
      old[name] = style[name];
      style[name] = options[name];
    }
  }

  callback.call(elem);

  // Revert the old values
  for (name in options) {
    if (options.hasOwnProperty(name)) {
      style[name] = old[name];
    }
  }
}

function getPBMWidth(elem, props, which) {
  var value = 0;
  var prop = undefined;
  var j = undefined;
  var i = undefined;
  for (j = 0; j < props.length; j++) {
    prop = props[j];
    if (prop) {
      for (i = 0; i < which.length; i++) {
        var cssProp = undefined;
        if (prop === 'border') {
          cssProp = prop + which[i] + 'Width';
        } else {
          cssProp = prop + which[i];
        }
        value += parseFloat(getComputedStyleX(elem, cssProp)) || 0;
      }
    }
  }
  return value;
}

/**
 * A crude way of determining if an object is a window
 * @member util
 */
function isWindow(obj) {
  // must use == for ie8
  /* eslint eqeqeq:0 */
  return obj != null && obj == obj.window;
}

var domUtils = {};

each(['Width', 'Height'], function (name) {
  domUtils['doc' + name] = function (refWin) {
    var d = refWin.document;
    return Math.max(
    // firefox chrome documentElement.scrollHeight< body.scrollHeight
    // ie standard mode : documentElement.scrollHeight> body.scrollHeight
    d.documentElement['scroll' + name],
    // quirks : documentElement.scrollHeight 最大等于可视窗口多一点？
    d.body['scroll' + name], domUtils['viewport' + name](d));
  };

  domUtils['viewport' + name] = function (win) {
    // pc browser includes scrollbar in window.innerWidth
    var prop = 'client' + name;
    var doc = win.document;
    var body = doc.body;
    var documentElement = doc.documentElement;
    var documentElementProp = documentElement[prop];
    // 标准模式取 documentElement
    // backcompat 取 body
    return doc.compatMode === 'CSS1Compat' && documentElementProp || body && body[prop] || documentElementProp;
  };
});

/*
 得到元素的大小信息
 @param elem
 @param name
 @param {String} [extra]  'padding' : (css width) + padding
 'border' : (css width) + padding + border
 'margin' : (css width) + padding + border + margin
 */
function getWH(elem, name, extra) {
  if (isWindow(elem)) {
    return name === 'width' ? domUtils.viewportWidth(elem) : domUtils.viewportHeight(elem);
  } else if (elem.nodeType === 9) {
    return name === 'width' ? domUtils.docWidth(elem) : domUtils.docHeight(elem);
  }
  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];
  var borderBoxValue = name === 'width' ? elem.offsetWidth : elem.offsetHeight;
  var computedStyle = getComputedStyleX(elem);
  var isBorderBox = isBorderBoxFn(elem, computedStyle);
  var cssBoxValue = 0;
  if (borderBoxValue == null || borderBoxValue <= 0) {
    borderBoxValue = undefined;
    // Fall back to computed then un computed css if necessary
    cssBoxValue = getComputedStyleX(elem, name);
    if (cssBoxValue == null || Number(cssBoxValue) < 0) {
      cssBoxValue = elem.style[name] || 0;
    }
    // Normalize '', auto, and prepare for extra
    cssBoxValue = parseFloat(cssBoxValue) || 0;
  }
  if (extra === undefined) {
    extra = isBorderBox ? BORDER_INDEX : CONTENT_INDEX;
  }
  var borderBoxValueOrIsBorderBox = borderBoxValue !== undefined || isBorderBox;
  var val = borderBoxValue || cssBoxValue;
  if (extra === CONTENT_INDEX) {
    if (borderBoxValueOrIsBorderBox) {
      return val - getPBMWidth(elem, ['border', 'padding'], which, computedStyle);
    }
    return cssBoxValue;
  }
  if (borderBoxValueOrIsBorderBox) {
    var padding = extra === PADDING_INDEX ? -getPBMWidth(elem, ['border'], which, computedStyle) : getPBMWidth(elem, ['margin'], which, computedStyle);
    return val + (extra === BORDER_INDEX ? 0 : padding);
  }
  return cssBoxValue + getPBMWidth(elem, BOX_MODELS.slice(extra), which, computedStyle);
}

var cssShow = {
  position: 'absolute',
  visibility: 'hidden',
  display: 'block'
};

// fix #119 : https://github.com/kissyteam/kissy/issues/119
function getWHIgnoreDisplay(elem) {
  var val = undefined;
  var args = arguments;
  // in case elem is window
  // elem.offsetWidth === undefined
  if (elem.offsetWidth !== 0) {
    val = getWH.apply(undefined, args);
  } else {
    swap(elem, cssShow, function () {
      val = getWH.apply(undefined, args);
    });
  }
  return val;
}

function css(el, name, v) {
  var value = v;
  if ((typeof name === 'undefined' ? 'undefined' : _typeof(name)) === 'object') {
    for (var i in name) {
      if (name.hasOwnProperty(i)) {
        css(el, i, name[i]);
      }
    }
    return undefined;
  }
  if (typeof value !== 'undefined') {
    if (typeof value === 'number') {
      value += 'px';
    }
    el.style[name] = value;
    return undefined;
  }
  return getComputedStyleX(el, name);
}

each(['width', 'height'], function (name) {
  var first = name.charAt(0).toUpperCase() + name.slice(1);
  domUtils['outer' + first] = function (el, includeMargin) {
    return el && getWHIgnoreDisplay(el, name, includeMargin ? MARGIN_INDEX : BORDER_INDEX);
  };
  var which = name === 'width' ? ['Left', 'Right'] : ['Top', 'Bottom'];

  domUtils[name] = function (elem, val) {
    if (val !== undefined) {
      if (elem) {
        var computedStyle = getComputedStyleX(elem);
        var isBorderBox = isBorderBoxFn(elem);
        if (isBorderBox) {
          val += getPBMWidth(elem, ['padding', 'border'], which, computedStyle);
        }
        return css(elem, name, val);
      }
      return undefined;
    }
    return elem && getWHIgnoreDisplay(elem, name, CONTENT_INDEX);
  };
});

// 设置 elem 相对 elem.ownerDocument 的坐标
function setOffset(elem, offset) {
  // set position first, in-case top/left are set even on static elem
  if (css(elem, 'position') === 'static') {
    elem.style.position = 'relative';
  }

  var old = getOffset(elem);
  var ret = {};
  var current = undefined;
  var key = undefined;

  for (key in offset) {
    if (offset.hasOwnProperty(key)) {
      current = parseFloat(css(elem, key)) || 0;
      ret[key] = current + offset[key] - old[key];
    }
  }
  css(elem, ret);
}

module.exports = _extends({
  getWindow: function getWindow(node) {
    var doc = node.ownerDocument || node;
    return doc.defaultView || doc.parentWindow;
  },
  offset: function offset(el, value) {
    if (typeof value !== 'undefined') {
      setOffset(el, value);
    } else {
      return getOffset(el);
    }
  },

  isWindow: isWindow,
  each: each,
  css: css,
  clone: function clone(obj) {
    var ret = {};
    for (var i in obj) {
      if (obj.hasOwnProperty(i)) {
        ret[i] = obj[i];
      }
    }
    var overflow = obj.overflow;
    if (overflow) {
      for (var i in obj) {
        if (obj.hasOwnProperty(i)) {
          ret.overflow[i] = obj.overflow[i];
        }
      }
    }
    return ret;
  },
  scrollLeft: function scrollLeft(w, v) {
    if (isWindow(w)) {
      if (v === undefined) {
        return getScrollLeft(w);
      }
      window.scrollTo(v, getScrollTop(w));
    } else {
      if (v === undefined) {
        return w.scrollLeft;
      }
      w.scrollLeft = v;
    }
  },
  scrollTop: function scrollTop(w, v) {
    if (isWindow(w)) {
      if (v === undefined) {
        return getScrollTop(w);
      }
      window.scrollTo(getScrollLeft(w), v);
    } else {
      if (v === undefined) {
        return w.scrollTop;
      }
      w.scrollTop = v;
    }
  },

  viewportWidth: 0,
  viewportHeight: 0
}, domUtils);

/***/ }),
/* 649 */
/***/ (function(module, exports, __webpack_require__) {

var baseHas = __webpack_require__(650),
    hasPath = __webpack_require__(247);

/**
 * Checks if `path` is a direct property of `object`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The object to query.
 * @param {Array|string} path The path to check.
 * @returns {boolean} Returns `true` if `path` exists, else `false`.
 * @example
 *
 * var object = { 'a': { 'b': 2 } };
 * var other = _.create({ 'a': _.create({ 'b': 2 }) });
 *
 * _.has(object, 'a');
 * // => true
 *
 * _.has(object, 'a.b');
 * // => true
 *
 * _.has(object, ['a', 'b']);
 * // => true
 *
 * _.has(other, 'a');
 * // => false
 */
function has(object, path) {
  return object != null && hasPath(object, path, baseHas);
}

module.exports = has;


/***/ }),
/* 650 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.has` without support for deep paths.
 *
 * @private
 * @param {Object} [object] The object to query.
 * @param {Array|string} key The key to check.
 * @returns {boolean} Returns `true` if `key` exists, else `false`.
 */
function baseHas(object, key) {
  return object != null && hasOwnProperty.call(object, key);
}

module.exports = baseHas;


/***/ }),
/* 651 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;

var _from = __webpack_require__(652);

var _from2 = _interopRequireDefault(_from);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = function (arr) {
  if (Array.isArray(arr)) {
    for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) {
      arr2[i] = arr[i];
    }

    return arr2;
  } else {
    return (0, _from2.default)(arr);
  }
};

/***/ }),
/* 652 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = { "default": __webpack_require__(653), __esModule: true };

/***/ }),
/* 653 */
/***/ (function(module, exports, __webpack_require__) {

__webpack_require__(281);
__webpack_require__(654);
module.exports = __webpack_require__(43).Array.from;


/***/ }),
/* 654 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var ctx = __webpack_require__(172);
var $export = __webpack_require__(61);
var toObject = __webpack_require__(131);
var call = __webpack_require__(655);
var isArrayIter = __webpack_require__(656);
var toLength = __webpack_require__(279);
var createProperty = __webpack_require__(657);
var getIterFn = __webpack_require__(658);

$export($export.S + $export.F * !__webpack_require__(660)(function (iter) { Array.from(iter); }), 'Array', {
  // 22.1.2.1 Array.from(arrayLike, mapfn = undefined, thisArg = undefined)
  from: function from(arrayLike /* , mapfn = undefined, thisArg = undefined */) {
    var O = toObject(arrayLike);
    var C = typeof this == 'function' ? this : Array;
    var aLen = arguments.length;
    var mapfn = aLen > 1 ? arguments[1] : undefined;
    var mapping = mapfn !== undefined;
    var index = 0;
    var iterFn = getIterFn(O);
    var length, result, step, iterator;
    if (mapping) mapfn = ctx(mapfn, aLen > 2 ? arguments[2] : undefined, 2);
    // if object isn't iterable or it's array with default iterator - use simple case
    if (iterFn != undefined && !(C == Array && isArrayIter(iterFn))) {
      for (iterator = iterFn.call(O), result = new C(); !(step = iterator.next()).done; index++) {
        createProperty(result, index, mapping ? call(iterator, mapfn, [step.value, index], true) : step.value);
      }
    } else {
      length = toLength(O.length);
      for (result = new C(length); length > index; index++) {
        createProperty(result, index, mapping ? mapfn(O[index], index) : O[index]);
      }
    }
    result.length = index;
    return result;
  }
});


/***/ }),
/* 655 */
/***/ (function(module, exports, __webpack_require__) {

// call something on iterator step with safe closing on error
var anObject = __webpack_require__(78);
module.exports = function (iterator, fn, value, entries) {
  try {
    return entries ? fn(anObject(value)[0], value[1]) : fn(value);
  // 7.4.6 IteratorClose(iterator, completion)
  } catch (e) {
    var ret = iterator['return'];
    if (ret !== undefined) anObject(ret.call(iterator));
    throw e;
  }
};


/***/ }),
/* 656 */
/***/ (function(module, exports, __webpack_require__) {

// check on default Array iterator
var Iterators = __webpack_require__(107);
var ITERATOR = __webpack_require__(44)('iterator');
var ArrayProto = Array.prototype;

module.exports = function (it) {
  return it !== undefined && (Iterators.Array === it || ArrayProto[ITERATOR] === it);
};


/***/ }),
/* 657 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";

var $defineProperty = __webpack_require__(53);
var createDesc = __webpack_require__(106);

module.exports = function (object, index, value) {
  if (index in object) $defineProperty.f(object, index, createDesc(0, value));
  else object[index] = value;
};


/***/ }),
/* 658 */
/***/ (function(module, exports, __webpack_require__) {

var classof = __webpack_require__(659);
var ITERATOR = __webpack_require__(44)('iterator');
var Iterators = __webpack_require__(107);
module.exports = __webpack_require__(43).getIteratorMethod = function (it) {
  if (it != undefined) return it[ITERATOR]
    || it['@@iterator']
    || Iterators[classof(it)];
};


/***/ }),
/* 659 */
/***/ (function(module, exports, __webpack_require__) {

// getting tag from 19.1.3.6 Object.prototype.toString()
var cof = __webpack_require__(174);
var TAG = __webpack_require__(44)('toStringTag');
// ES3 wrong here
var ARG = cof(function () { return arguments; }()) == 'Arguments';

// fallback for IE11 Script Access Denied error
var tryGet = function (it, key) {
  try {
    return it[key];
  } catch (e) { /* empty */ }
};

module.exports = function (it) {
  var O, T, B;
  return it === undefined ? 'Undefined' : it === null ? 'Null'
    // @@toStringTag case
    : typeof (T = tryGet(O = Object(it), TAG)) == 'string' ? T
    // builtinTag case
    : ARG ? cof(O)
    // ES3 arguments fallback
    : (B = cof(O)) == 'Object' && typeof O.callee == 'function' ? 'Arguments' : B;
};


/***/ }),
/* 660 */
/***/ (function(module, exports, __webpack_require__) {

var ITERATOR = __webpack_require__(44)('iterator');
var SAFE_CLOSING = false;

try {
  var riter = [7][ITERATOR]();
  riter['return'] = function () { SAFE_CLOSING = true; };
  // eslint-disable-next-line no-throw-literal
  Array.from(riter, function () { throw 2; });
} catch (e) { /* empty */ }

module.exports = function (exec, skipClosing) {
  if (!skipClosing && !SAFE_CLOSING) return false;
  var safe = false;
  try {
    var arr = [7];
    var iter = arr[ITERATOR]();
    iter.next = function () { return { done: safe = true }; };
    arr[ITERATOR] = function () { return iter; };
    exec(arr);
  } catch (e) { /* empty */ }
  return safe;
};


/***/ }),
/* 661 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var React = __webpack_require__(0);
var factory = __webpack_require__(299);

if (typeof React === 'undefined') {
  throw Error(
    'create-react-class could not find the React object. If you are using script tags, ' +
      'make sure that React is being loaded before create-react-class.'
  );
}

// Hack to grab NoopUpdateQueue from isomorphic React
var ReactNoopUpdateQueue = new React.Component().updater;

module.exports = factory(
  React.Component,
  React.isValidElement,
  ReactNoopUpdateQueue
);


/***/ }),
/* 662 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(__webpack_require__(0));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var unsafeLifecyclesPolyfill = function unsafeLifecyclesPolyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  } // only handle componentWillReceiveProps


  if (typeof prototype.componentWillReceiveProps !== 'function') {
    return Component;
  } // In React 16.9, React.Profiler was introduced together with UNSAFE_componentWillReceiveProps
  // https://reactjs.org/blog/2019/08/08/react-v16.9.0.html#performance-measurements-with-reactprofiler


  if (!_react.default.Profiler) {
    return Component;
  } // Here polyfill get started


  prototype.UNSAFE_componentWillReceiveProps = prototype.componentWillReceiveProps;
  delete prototype.componentWillReceiveProps;
  return Component;
};

var _default = unsafeLifecyclesPolyfill;
exports.default = _default;

/***/ }),
/* 663 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _util = __webpack_require__(19);

var _validator = __webpack_require__(664);

var _validator2 = _interopRequireDefault(_validator);

var _messages2 = __webpack_require__(684);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Encapsulates a validation schema.
 *
 *  @param descriptor An object declaring validation rules
 *  for this schema.
 */
function Schema(descriptor) {
  this.rules = null;
  this._messages = _messages2.messages;
  this.define(descriptor);
}

Schema.prototype = {
  messages: function messages(_messages) {
    if (_messages) {
      this._messages = (0, _util.deepMerge)((0, _messages2.newMessages)(), _messages);
    }
    return this._messages;
  },
  define: function define(rules) {
    if (!rules) {
      throw new Error('Cannot configure a schema with no rules');
    }
    if ((typeof rules === 'undefined' ? 'undefined' : _typeof(rules)) !== 'object' || Array.isArray(rules)) {
      throw new Error('Rules must be an object');
    }
    this.rules = {};
    var z = void 0;
    var item = void 0;
    for (z in rules) {
      if (rules.hasOwnProperty(z)) {
        item = rules[z];
        this.rules[z] = Array.isArray(item) ? item : [item];
      }
    }
  },
  validate: function validate(source_) {
    var _this = this;

    var o = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var oc = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : function () {};

    var source = source_;
    var options = o;
    var callback = oc;
    if (typeof options === 'function') {
      callback = options;
      options = {};
    }
    if (!this.rules || Object.keys(this.rules).length === 0) {
      if (callback) {
        callback();
      }
      return Promise.resolve();
    }

    function complete(results) {
      var i = void 0;
      var errors = [];
      var fields = {};

      function add(e) {
        if (Array.isArray(e)) {
          var _errors;

          errors = (_errors = errors).concat.apply(_errors, e);
        } else {
          errors.push(e);
        }
      }

      for (i = 0; i < results.length; i++) {
        add(results[i]);
      }
      if (!errors.length) {
        errors = null;
        fields = null;
      } else {
        fields = (0, _util.convertFieldsError)(errors);
      }
      callback(errors, fields);
    }

    if (options.messages) {
      var messages = this.messages();
      if (messages === _messages2.messages) {
        messages = (0, _messages2.newMessages)();
      }
      (0, _util.deepMerge)(messages, options.messages);
      options.messages = messages;
    } else {
      options.messages = this.messages();
    }
    var arr = void 0;
    var value = void 0;
    var series = {};
    var keys = options.keys || Object.keys(this.rules);
    keys.forEach(function (z) {
      arr = _this.rules[z];
      value = source[z];
      arr.forEach(function (r) {
        var rule = r;
        if (typeof rule.transform === 'function') {
          if (source === source_) {
            source = _extends({}, source);
          }
          value = source[z] = rule.transform(value);
        }
        if (typeof rule === 'function') {
          rule = {
            validator: rule
          };
        } else {
          rule = _extends({}, rule);
        }
        rule.validator = _this.getValidationMethod(rule);
        rule.field = z;
        rule.fullField = rule.fullField || z;
        rule.type = _this.getType(rule);
        if (!rule.validator) {
          return;
        }
        series[z] = series[z] || [];
        series[z].push({
          rule: rule,
          value: value,
          source: source,
          field: z
        });
      });
    });
    var errorFields = {};
    return (0, _util.asyncMap)(series, options, function (data, doIt) {
      var rule = data.rule;
      var deep = (rule.type === 'object' || rule.type === 'array') && (_typeof(rule.fields) === 'object' || _typeof(rule.defaultField) === 'object');
      deep = deep && (rule.required || !rule.required && data.value);
      rule.field = data.field;

      function addFullfield(key, schema) {
        return _extends({}, schema, {
          fullField: rule.fullField + '.' + key
        });
      }

      function cb() {
        var e = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];

        var errors = e;
        if (!Array.isArray(errors)) {
          errors = [errors];
        }
        if (!options.suppressWarning && errors.length) {
          Schema.warning('async-validator:', errors);
        }
        if (errors.length && rule.message) {
          errors = [].concat(rule.message);
        }

        errors = errors.map((0, _util.complementError)(rule));

        if (options.first && errors.length) {
          errorFields[rule.field] = 1;
          return doIt(errors);
        }
        if (!deep) {
          doIt(errors);
        } else {
          // if rule is required but the target object
          // does not exist fail at the rule level and don't
          // go deeper
          if (rule.required && !data.value) {
            if (rule.message) {
              errors = [].concat(rule.message).map((0, _util.complementError)(rule));
            } else if (options.error) {
              errors = [options.error(rule, (0, _util.format)(options.messages.required, rule.field))];
            } else {
              errors = [];
            }
            return doIt(errors);
          }

          var fieldsSchema = {};
          if (rule.defaultField) {
            for (var k in data.value) {
              if (data.value.hasOwnProperty(k)) {
                fieldsSchema[k] = rule.defaultField;
              }
            }
          }
          fieldsSchema = _extends({}, fieldsSchema, data.rule.fields);
          for (var f in fieldsSchema) {
            if (fieldsSchema.hasOwnProperty(f)) {
              var fieldSchema = Array.isArray(fieldsSchema[f]) ? fieldsSchema[f] : [fieldsSchema[f]];
              fieldsSchema[f] = fieldSchema.map(addFullfield.bind(null, f));
            }
          }
          var schema = new Schema(fieldsSchema);
          schema.messages(options.messages);
          if (data.rule.options) {
            data.rule.options.messages = options.messages;
            data.rule.options.error = options.error;
          }
          schema.validate(data.value, data.rule.options || options, function (errs) {
            var finalErrors = [];
            if (errors && errors.length) {
              finalErrors.push.apply(finalErrors, errors);
            }
            if (errs && errs.length) {
              finalErrors.push.apply(finalErrors, errs);
            }
            doIt(finalErrors.length ? finalErrors : null);
          });
        }
      }

      var res = void 0;
      if (rule.asyncValidator) {
        res = rule.asyncValidator(rule, data.value, cb, data.source, options);
      } else if (rule.validator) {
        res = rule.validator(rule, data.value, cb, data.source, options);
        if (res === true) {
          cb();
        } else if (res === false) {
          cb(rule.message || rule.field + ' fails');
        } else if (res instanceof Array) {
          cb(res);
        } else if (res instanceof Error) {
          cb(res.message);
        }
      }
      if (res && res.then) {
        res.then(function () {
          return cb();
        }, function (e) {
          return cb(e);
        });
      }
    }, function (results) {
      complete(results);
    });
  },
  getType: function getType(rule) {
    if (rule.type === undefined && rule.pattern instanceof RegExp) {
      rule.type = 'pattern';
    }
    if (typeof rule.validator !== 'function' && rule.type && !_validator2['default'].hasOwnProperty(rule.type)) {
      throw new Error((0, _util.format)('Unknown rule type %s', rule.type));
    }
    return rule.type || 'string';
  },
  getValidationMethod: function getValidationMethod(rule) {
    if (typeof rule.validator === 'function') {
      return rule.validator;
    }
    var keys = Object.keys(rule);
    var messageIndex = keys.indexOf('message');
    if (messageIndex !== -1) {
      keys.splice(messageIndex, 1);
    }
    if (keys.length === 1 && keys[0] === 'required') {
      return _validator2['default'].required;
    }
    return _validator2['default'][this.getType(rule)] || false;
  }
};

Schema.register = function register(type, validator) {
  if (typeof validator !== 'function') {
    throw new Error('Cannot register a validator by type, validator is not a function');
  }
  _validator2['default'][type] = validator;
};

Schema.warning = _util.warning;

Schema.messages = _messages2.messages;

exports['default'] = Schema;

/***/ }),
/* 664 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _string = __webpack_require__(665);

var _string2 = _interopRequireDefault(_string);

var _method = __webpack_require__(671);

var _method2 = _interopRequireDefault(_method);

var _number = __webpack_require__(672);

var _number2 = _interopRequireDefault(_number);

var _boolean = __webpack_require__(673);

var _boolean2 = _interopRequireDefault(_boolean);

var _regexp = __webpack_require__(674);

var _regexp2 = _interopRequireDefault(_regexp);

var _integer = __webpack_require__(675);

var _integer2 = _interopRequireDefault(_integer);

var _float = __webpack_require__(676);

var _float2 = _interopRequireDefault(_float);

var _array = __webpack_require__(677);

var _array2 = _interopRequireDefault(_array);

var _object = __webpack_require__(678);

var _object2 = _interopRequireDefault(_object);

var _enum = __webpack_require__(679);

var _enum2 = _interopRequireDefault(_enum);

var _pattern = __webpack_require__(680);

var _pattern2 = _interopRequireDefault(_pattern);

var _date = __webpack_require__(681);

var _date2 = _interopRequireDefault(_date);

var _required = __webpack_require__(682);

var _required2 = _interopRequireDefault(_required);

var _type = __webpack_require__(683);

var _type2 = _interopRequireDefault(_type);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
  string: _string2['default'],
  method: _method2['default'],
  number: _number2['default'],
  boolean: _boolean2['default'],
  regexp: _regexp2['default'],
  integer: _integer2['default'],
  float: _float2['default'],
  array: _array2['default'],
  object: _object2['default'],
  'enum': _enum2['default'],
  pattern: _pattern2['default'],
  date: _date2['default'],
  url: _type2['default'],
  hex: _type2['default'],
  email: _type2['default'],
  required: _required2['default']
};

/***/ }),
/* 665 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(25);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Performs validation for string types.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function string(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value, 'string') && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options, 'string');
    if (!(0, _util.isEmptyValue)(value, 'string')) {
      _rule2['default'].type(rule, value, source, errors, options);
      _rule2['default'].range(rule, value, source, errors, options);
      _rule2['default'].pattern(rule, value, source, errors, options);
      if (rule.whitespace === true) {
        _rule2['default'].whitespace(rule, value, source, errors, options);
      }
    }
  }
  callback(errors);
}

exports['default'] = string;

/***/ }),
/* 666 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__(19);

var util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

/**
 *  Rule for validating whitespace.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function whitespace(rule, value, source, errors, options) {
  if (/^\s+$/.test(value) || value === '') {
    errors.push(util.format(options.messages.whitespace, rule.fullField));
  }
}

exports['default'] = whitespace;

/***/ }),
/* 667 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _util = __webpack_require__(19);

var util = _interopRequireWildcard(_util);

var _required = __webpack_require__(300);

var _required2 = _interopRequireDefault(_required);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

/* eslint max-len:0 */

var pattern = {
  // http://emailregex.com/
  email: /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/,
  url: new RegExp('^(?!mailto:)(?:(?:http|https|ftp)://|//)(?:\\S+(?::\\S*)?@)?(?:(?:(?:[1-9]\\d?|1\\d\\d|2[01]\\d|22[0-3])(?:\\.(?:1?\\d{1,2}|2[0-4]\\d|25[0-5])){2}(?:\\.(?:[0-9]\\d?|1\\d\\d|2[0-4]\\d|25[0-4]))|(?:(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)(?:\\.(?:[a-z\\u00a1-\\uffff0-9]+-?)*[a-z\\u00a1-\\uffff0-9]+)*(?:\\.(?:[a-z\\u00a1-\\uffff]{2,})))|localhost)(?::\\d{2,5})?(?:(/|\\?|#)[^\\s]*)?$', 'i'),
  hex: /^#?([a-f0-9]{6}|[a-f0-9]{3})$/i
};

var types = {
  integer: function integer(value) {
    return types.number(value) && parseInt(value, 10) === value;
  },
  float: function float(value) {
    return types.number(value) && !types.integer(value);
  },
  array: function array(value) {
    return Array.isArray(value);
  },
  regexp: function regexp(value) {
    if (value instanceof RegExp) {
      return true;
    }
    try {
      return !!new RegExp(value);
    } catch (e) {
      return false;
    }
  },
  date: function date(value) {
    return typeof value.getTime === 'function' && typeof value.getMonth === 'function' && typeof value.getYear === 'function';
  },
  number: function number(value) {
    if (isNaN(value)) {
      return false;
    }
    return typeof value === 'number';
  },
  object: function object(value) {
    return (typeof value === 'undefined' ? 'undefined' : _typeof(value)) === 'object' && !types.array(value);
  },
  method: function method(value) {
    return typeof value === 'function';
  },
  email: function email(value) {
    return typeof value === 'string' && !!value.match(pattern.email) && value.length < 255;
  },
  url: function url(value) {
    return typeof value === 'string' && !!value.match(pattern.url);
  },
  hex: function hex(value) {
    return typeof value === 'string' && !!value.match(pattern.hex);
  }
};

/**
 *  Rule for validating the type of a value.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function type(rule, value, source, errors, options) {
  if (rule.required && value === undefined) {
    (0, _required2['default'])(rule, value, source, errors, options);
    return;
  }
  var custom = ['integer', 'float', 'array', 'regexp', 'object', 'method', 'email', 'number', 'date', 'url', 'hex'];
  var ruleType = rule.type;
  if (custom.indexOf(ruleType) > -1) {
    if (!types[ruleType](value)) {
      errors.push(util.format(options.messages.types[ruleType], rule.fullField, rule.type));
    }
    // straight typeof check
  } else if (ruleType && (typeof value === 'undefined' ? 'undefined' : _typeof(value)) !== rule.type) {
    errors.push(util.format(options.messages.types[ruleType], rule.fullField, rule.type));
  }
}

exports['default'] = type;

/***/ }),
/* 668 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__(19);

var util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

/**
 *  Rule for validating minimum and maximum allowed values.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function range(rule, value, source, errors, options) {
  var len = typeof rule.len === 'number';
  var min = typeof rule.min === 'number';
  var max = typeof rule.max === 'number';
  // 正则匹配码点范围从U+010000一直到U+10FFFF的文字（补充平面Supplementary Plane）
  var spRegexp = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
  var val = value;
  var key = null;
  var num = typeof value === 'number';
  var str = typeof value === 'string';
  var arr = Array.isArray(value);
  if (num) {
    key = 'number';
  } else if (str) {
    key = 'string';
  } else if (arr) {
    key = 'array';
  }
  // if the value is not of a supported type for range validation
  // the validation rule rule should use the
  // type property to also test for a particular type
  if (!key) {
    return false;
  }
  if (arr) {
    val = value.length;
  }
  if (str) {
    // 处理码点大于U+010000的文字length属性不准确的bug，如"𠮷𠮷𠮷".lenght !== 3
    val = value.replace(spRegexp, '_').length;
  }
  if (len) {
    if (val !== rule.len) {
      errors.push(util.format(options.messages[key].len, rule.fullField, rule.len));
    }
  } else if (min && !max && val < rule.min) {
    errors.push(util.format(options.messages[key].min, rule.fullField, rule.min));
  } else if (max && !min && val > rule.max) {
    errors.push(util.format(options.messages[key].max, rule.fullField, rule.max));
  } else if (min && max && (val < rule.min || val > rule.max)) {
    errors.push(util.format(options.messages[key].range, rule.fullField, rule.min, rule.max));
  }
}

exports['default'] = range;

/***/ }),
/* 669 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__(19);

var util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

var ENUM = 'enum';

/**
 *  Rule for validating a value exists in an enumerable list.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function enumerable(rule, value, source, errors, options) {
  rule[ENUM] = Array.isArray(rule[ENUM]) ? rule[ENUM] : [];
  if (rule[ENUM].indexOf(value) === -1) {
    errors.push(util.format(options.messages[ENUM], rule.fullField, rule[ENUM].join(', ')));
  }
}

exports['default'] = enumerable;

/***/ }),
/* 670 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__(19);

var util = _interopRequireWildcard(_util);

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj['default'] = obj; return newObj; } }

/**
 *  Rule for validating a regular expression pattern.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param source The source object being validated.
 *  @param errors An array of errors that this rule may add
 *  validation errors to.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function pattern(rule, value, source, errors, options) {
  if (rule.pattern) {
    if (rule.pattern instanceof RegExp) {
      // if a RegExp instance is passed, reset `lastIndex` in case its `global`
      // flag is accidentally set to `true`, which in a validation scenario
      // is not necessary and the result might be misleading
      rule.pattern.lastIndex = 0;
      if (!rule.pattern.test(value)) {
        errors.push(util.format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
      }
    } else if (typeof rule.pattern === 'string') {
      var _pattern = new RegExp(rule.pattern);
      if (!_pattern.test(value)) {
        errors.push(util.format(options.messages.pattern.mismatch, rule.fullField, value, rule.pattern));
      }
    }
  }
}

exports['default'] = pattern;

/***/ }),
/* 671 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(25);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates a function.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function method(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (value !== undefined) {
      _rule2['default'].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = method;

/***/ }),
/* 672 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(25);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates a number.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function number(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if (value === '') {
      value = undefined;
    }
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (value !== undefined) {
      _rule2['default'].type(rule, value, source, errors, options);
      _rule2['default'].range(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = number;

/***/ }),
/* 673 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _util = __webpack_require__(19);

var _rule = __webpack_require__(25);

var _rule2 = _interopRequireDefault(_rule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates a boolean.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function boolean(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (value !== undefined) {
      _rule2['default'].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = boolean;

/***/ }),
/* 674 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(25);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates the regular expression type.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function regexp(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (!(0, _util.isEmptyValue)(value)) {
      _rule2['default'].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = regexp;

/***/ }),
/* 675 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(25);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates a number is an integer.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function integer(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (value !== undefined) {
      _rule2['default'].type(rule, value, source, errors, options);
      _rule2['default'].range(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = integer;

/***/ }),
/* 676 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(25);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates a number is a floating point number.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function floatFn(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (value !== undefined) {
      _rule2['default'].type(rule, value, source, errors, options);
      _rule2['default'].range(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = floatFn;

/***/ }),
/* 677 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(25);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates an array.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function array(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value, 'array') && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options, 'array');
    if (!(0, _util.isEmptyValue)(value, 'array')) {
      _rule2['default'].type(rule, value, source, errors, options);
      _rule2['default'].range(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = array;

/***/ }),
/* 678 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(25);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates an object.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function object(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (value !== undefined) {
      _rule2['default'].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = object;

/***/ }),
/* 679 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(25);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var ENUM = 'enum';

/**
 *  Validates an enumerable list.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function enumerable(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (value) {
      _rule2['default'][ENUM](rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = enumerable;

/***/ }),
/* 680 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(25);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

/**
 *  Validates a regular expression pattern.
 *
 *  Performs validation when a rule only contains
 *  a pattern property but is not declared as a string type.
 *
 *  @param rule The validation rule.
 *  @param value The value of the field on the source object.
 *  @param callback The callback function.
 *  @param source The source object being validated.
 *  @param options The validation options.
 *  @param options.messages The validation messages.
 */
function pattern(rule, value, callback, source, options) {
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value, 'string') && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (!(0, _util.isEmptyValue)(value, 'string')) {
      _rule2['default'].pattern(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = pattern;

/***/ }),
/* 681 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(25);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function date(rule, value, callback, source, options) {
  // console.log('integer rule called %j', rule);
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  // console.log('validate on %s value', value);
  if (validate) {
    if ((0, _util.isEmptyValue)(value) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options);
    if (!(0, _util.isEmptyValue)(value)) {
      var dateObject = void 0;

      if (typeof value === 'number') {
        dateObject = new Date(value);
      } else {
        dateObject = value;
      }

      _rule2['default'].type(rule, dateObject, source, errors, options);
      if (dateObject) {
        _rule2['default'].range(rule, dateObject.getTime(), source, errors, options);
      }
    }
  }
  callback(errors);
}

exports['default'] = date;

/***/ }),
/* 682 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _rule = __webpack_require__(25);

var _rule2 = _interopRequireDefault(_rule);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function required(rule, value, callback, source, options) {
  var errors = [];
  var type = Array.isArray(value) ? 'array' : typeof value === 'undefined' ? 'undefined' : _typeof(value);
  _rule2['default'].required(rule, value, source, errors, options, type);
  callback(errors);
}

exports['default'] = required;

/***/ }),
/* 683 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _rule = __webpack_require__(25);

var _rule2 = _interopRequireDefault(_rule);

var _util = __webpack_require__(19);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function type(rule, value, callback, source, options) {
  var ruleType = rule.type;
  var errors = [];
  var validate = rule.required || !rule.required && source.hasOwnProperty(rule.field);
  if (validate) {
    if ((0, _util.isEmptyValue)(value, ruleType) && !rule.required) {
      return callback();
    }
    _rule2['default'].required(rule, value, source, errors, options, ruleType);
    if (!(0, _util.isEmptyValue)(value, ruleType)) {
      _rule2['default'].type(rule, value, source, errors, options);
    }
  }
  callback(errors);
}

exports['default'] = type;

/***/ }),
/* 684 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.newMessages = newMessages;
function newMessages() {
  return {
    'default': 'Validation error on field %s',
    required: '%s is required',
    'enum': '%s must be one of %s',
    whitespace: '%s cannot be empty',
    date: {
      format: '%s date %s is invalid for format %s',
      parse: '%s date could not be parsed, %s is invalid ',
      invalid: '%s date %s is invalid'
    },
    types: {
      string: '%s is not a %s',
      method: '%s is not a %s (function)',
      array: '%s is not an %s',
      object: '%s is not an %s',
      number: '%s is not a %s',
      date: '%s is not a %s',
      boolean: '%s is not a %s',
      integer: '%s is not an %s',
      float: '%s is not a %s',
      regexp: '%s is not a valid %s',
      email: '%s is not a valid %s',
      url: '%s is not a valid %s',
      hex: '%s is not a valid %s'
    },
    string: {
      len: '%s must be exactly %s characters',
      min: '%s must be at least %s characters',
      max: '%s cannot be longer than %s characters',
      range: '%s must be between %s and %s characters'
    },
    number: {
      len: '%s must equal %s',
      min: '%s cannot be less than %s',
      max: '%s cannot be greater than %s',
      range: '%s must be between %s and %s'
    },
    array: {
      len: '%s must be exactly %s in length',
      min: '%s cannot be less than %s in length',
      max: '%s cannot be greater than %s in length',
      range: '%s must be between %s and %s in length'
    },
    pattern: {
      mismatch: '%s value %s does not match pattern %s'
    },
    clone: function clone() {
      var cloned = JSON.parse(JSON.stringify(this));
      cloned.clone = this.clone;
      return cloned;
    }
  };
}

var messages = exports.messages = newMessages();

/***/ }),
/* 685 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _defineProperty2 = __webpack_require__(126);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _extends2 = __webpack_require__(49);

var _extends3 = _interopRequireDefault(_extends2);

var _classCallCheck2 = __webpack_require__(63);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(81);

var _createClass3 = _interopRequireDefault(_createClass2);

exports['default'] = createFieldsStore;

var _set = __webpack_require__(301);

var _set2 = _interopRequireDefault(_set);

var _createFormField = __webpack_require__(302);

var _createFormField2 = _interopRequireDefault(_createFormField);

var _utils = __webpack_require__(189);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

function partOf(a, b) {
  return b.indexOf(a) === 0 && ['.', '['].indexOf(b[a.length]) !== -1;
}

function internalFlattenFields(fields) {
  return (0, _utils.flattenFields)(fields, function (_, node) {
    return (0, _createFormField.isFormField)(node);
  }, 'You must wrap field data with `createFormField`.');
}

var FieldsStore = function () {
  function FieldsStore(fields) {
    (0, _classCallCheck3['default'])(this, FieldsStore);

    _initialiseProps.call(this);

    this.fields = internalFlattenFields(fields);
    this.fieldsMeta = {};
  }

  (0, _createClass3['default'])(FieldsStore, [{
    key: 'updateFields',
    value: function updateFields(fields) {
      this.fields = internalFlattenFields(fields);
    }
  }, {
    key: 'flattenRegisteredFields',
    value: function flattenRegisteredFields(fields) {
      var validFieldsName = this.getAllFieldsName();
      return (0, _utils.flattenFields)(fields, function (path) {
        return validFieldsName.indexOf(path) >= 0;
      }, 'You cannot set a form field before rendering a field associated with the value.');
    }
  }, {
    key: 'setFields',
    value: function setFields(fields) {
      var _this = this;

      var fieldsMeta = this.fieldsMeta;
      var nowFields = (0, _extends3['default'])({}, this.fields, fields);
      var nowValues = {};
      Object.keys(fieldsMeta).forEach(function (f) {
        nowValues[f] = _this.getValueFromFields(f, nowFields);
      });
      Object.keys(nowValues).forEach(function (f) {
        var value = nowValues[f];
        var fieldMeta = _this.getFieldMeta(f);
        if (fieldMeta && fieldMeta.normalize) {
          var nowValue = fieldMeta.normalize(value, _this.getValueFromFields(f, _this.fields), nowValues);
          if (nowValue !== value) {
            nowFields[f] = (0, _extends3['default'])({}, nowFields[f], {
              value: nowValue
            });
          }
        }
      });
      this.fields = nowFields;
    }
  }, {
    key: 'resetFields',
    value: function resetFields(ns) {
      var fields = this.fields;

      var names = ns ? this.getValidFieldsFullName(ns) : this.getAllFieldsName();
      return names.reduce(function (acc, name) {
        var field = fields[name];
        if (field && 'value' in field) {
          acc[name] = {};
        }
        return acc;
      }, {});
    }
  }, {
    key: 'setFieldMeta',
    value: function setFieldMeta(name, meta) {
      this.fieldsMeta[name] = meta;
    }
  }, {
    key: 'setFieldsAsDirty',
    value: function setFieldsAsDirty() {
      var _this2 = this;

      Object.keys(this.fields).forEach(function (name) {
        var field = _this2.fields[name];
        var fieldMeta = _this2.fieldsMeta[name];
        if (field && fieldMeta && (0, _utils.hasRules)(fieldMeta.validate)) {
          _this2.fields[name] = (0, _extends3['default'])({}, field, {
            dirty: true
          });
        }
      });
    }
  }, {
    key: 'getFieldMeta',
    value: function getFieldMeta(name) {
      this.fieldsMeta[name] = this.fieldsMeta[name] || {};
      return this.fieldsMeta[name];
    }
  }, {
    key: 'getValueFromFields',
    value: function getValueFromFields(name, fields) {
      var field = fields[name];
      if (field && 'value' in field) {
        return field.value;
      }
      var fieldMeta = this.getFieldMeta(name);
      return fieldMeta && fieldMeta.initialValue;
    }
  }, {
    key: 'getValidFieldsName',
    value: function getValidFieldsName() {
      var _this3 = this;

      var fieldsMeta = this.fieldsMeta;

      return fieldsMeta ? Object.keys(fieldsMeta).filter(function (name) {
        return !_this3.getFieldMeta(name).hidden;
      }) : [];
    }
  }, {
    key: 'getAllFieldsName',
    value: function getAllFieldsName() {
      var fieldsMeta = this.fieldsMeta;

      return fieldsMeta ? Object.keys(fieldsMeta) : [];
    }
  }, {
    key: 'getValidFieldsFullName',
    value: function getValidFieldsFullName(maybePartialName) {
      var maybePartialNames = Array.isArray(maybePartialName) ? maybePartialName : [maybePartialName];
      return this.getValidFieldsName().filter(function (fullName) {
        return maybePartialNames.some(function (partialName) {
          return fullName === partialName || (0, _utils.startsWith)(fullName, partialName) && ['.', '['].indexOf(fullName[partialName.length]) >= 0;
        });
      });
    }
  }, {
    key: 'getFieldValuePropValue',
    value: function getFieldValuePropValue(fieldMeta) {
      var name = fieldMeta.name,
          getValueProps = fieldMeta.getValueProps,
          valuePropName = fieldMeta.valuePropName;

      var field = this.getField(name);
      var fieldValue = 'value' in field ? field.value : fieldMeta.initialValue;
      if (getValueProps) {
        return getValueProps(fieldValue);
      }
      return (0, _defineProperty3['default'])({}, valuePropName, fieldValue);
    }
  }, {
    key: 'getField',
    value: function getField(name) {
      return (0, _extends3['default'])({}, this.fields[name], {
        name: name
      });
    }
  }, {
    key: 'getNotCollectedFields',
    value: function getNotCollectedFields() {
      var _this4 = this;

      var fieldsName = this.getValidFieldsName();
      return fieldsName.filter(function (name) {
        return !_this4.fields[name];
      }).map(function (name) {
        return {
          name: name,
          dirty: false,
          value: _this4.getFieldMeta(name).initialValue
        };
      }).reduce(function (acc, field) {
        return (0, _set2['default'])(acc, field.name, (0, _createFormField2['default'])(field));
      }, {});
    }
  }, {
    key: 'getNestedAllFields',
    value: function getNestedAllFields() {
      var _this5 = this;

      return Object.keys(this.fields).reduce(function (acc, name) {
        return (0, _set2['default'])(acc, name, (0, _createFormField2['default'])(_this5.fields[name]));
      }, this.getNotCollectedFields());
    }
  }, {
    key: 'getFieldMember',
    value: function getFieldMember(name, member) {
      return this.getField(name)[member];
    }
  }, {
    key: 'getNestedFields',
    value: function getNestedFields(names, getter) {
      var fields = names || this.getValidFieldsName();
      return fields.reduce(function (acc, f) {
        return (0, _set2['default'])(acc, f, getter(f));
      }, {});
    }
  }, {
    key: 'getNestedField',
    value: function getNestedField(name, getter) {
      var fullNames = this.getValidFieldsFullName(name);
      if (fullNames.length === 0 || // Not registered
      fullNames.length === 1 && fullNames[0] === name // Name already is full name.
      ) {
          return getter(name);
        }
      var isArrayValue = fullNames[0][name.length] === '[';
      var suffixNameStartIndex = isArrayValue ? name.length : name.length + 1;
      return fullNames.reduce(function (acc, fullName) {
        return (0, _set2['default'])(acc, fullName.slice(suffixNameStartIndex), getter(fullName));
      }, isArrayValue ? [] : {});
    }
  }, {
    key: 'isValidNestedFieldName',


    // @private
    // BG: `a` and `a.b` cannot be use in the same form
    value: function isValidNestedFieldName(name) {
      var names = this.getAllFieldsName();
      return names.every(function (n) {
        return !partOf(n, name) && !partOf(name, n);
      });
    }
  }, {
    key: 'clearField',
    value: function clearField(name) {
      delete this.fields[name];
      delete this.fieldsMeta[name];
    }
  }]);
  return FieldsStore;
}();

var _initialiseProps = function _initialiseProps() {
  var _this6 = this;

  this.setFieldsInitialValue = function (initialValues) {
    var flattenedInitialValues = _this6.flattenRegisteredFields(initialValues);
    var fieldsMeta = _this6.fieldsMeta;
    Object.keys(flattenedInitialValues).forEach(function (name) {
      if (fieldsMeta[name]) {
        _this6.setFieldMeta(name, (0, _extends3['default'])({}, _this6.getFieldMeta(name), {
          initialValue: flattenedInitialValues[name]
        }));
      }
    });
  };

  this.getAllValues = function () {
    var fieldsMeta = _this6.fieldsMeta,
        fields = _this6.fields;

    return Object.keys(fieldsMeta).reduce(function (acc, name) {
      return (0, _set2['default'])(acc, name, _this6.getValueFromFields(name, fields));
    }, {});
  };

  this.getFieldsValue = function (names) {
    return _this6.getNestedFields(names, _this6.getFieldValue);
  };

  this.getFieldValue = function (name) {
    var fields = _this6.fields;

    return _this6.getNestedField(name, function (fullName) {
      return _this6.getValueFromFields(fullName, fields);
    });
  };

  this.getFieldsError = function (names) {
    return _this6.getNestedFields(names, _this6.getFieldError);
  };

  this.getFieldError = function (name) {
    return _this6.getNestedField(name, function (fullName) {
      return (0, _utils.getErrorStrs)(_this6.getFieldMember(fullName, 'errors'));
    });
  };

  this.isFieldValidating = function (name) {
    return _this6.getFieldMember(name, 'validating');
  };

  this.isFieldsValidating = function (ns) {
    var names = ns || _this6.getValidFieldsName();
    return names.some(function (n) {
      return _this6.isFieldValidating(n);
    });
  };

  this.isFieldTouched = function (name) {
    return _this6.getFieldMember(name, 'touched');
  };

  this.isFieldsTouched = function (ns) {
    var names = ns || _this6.getValidFieldsName();
    return names.some(function (n) {
      return _this6.isFieldTouched(n);
    });
  };
};

function createFieldsStore(fields) {
  return new FieldsStore(fields);
}
module.exports = exports['default'];

/***/ }),
/* 686 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var reactIs = __webpack_require__(50);

/**
 * Copyright 2015, Yahoo! Inc.
 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
 */
var REACT_STATICS = {
  childContextTypes: true,
  contextType: true,
  contextTypes: true,
  defaultProps: true,
  displayName: true,
  getDefaultProps: true,
  getDerivedStateFromError: true,
  getDerivedStateFromProps: true,
  mixins: true,
  propTypes: true,
  type: true
};
var KNOWN_STATICS = {
  name: true,
  length: true,
  prototype: true,
  caller: true,
  callee: true,
  arguments: true,
  arity: true
};
var FORWARD_REF_STATICS = {
  '$$typeof': true,
  render: true,
  defaultProps: true,
  displayName: true,
  propTypes: true
};
var MEMO_STATICS = {
  '$$typeof': true,
  compare: true,
  defaultProps: true,
  displayName: true,
  propTypes: true,
  type: true
};
var TYPE_STATICS = {};
TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;

function getStatics(component) {
  // React v16.11 and below
  if (reactIs.isMemo(component)) {
    return MEMO_STATICS;
  } // React v16.12 and above


  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
}

var defineProperty = Object.defineProperty;
var getOwnPropertyNames = Object.getOwnPropertyNames;
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
var getPrototypeOf = Object.getPrototypeOf;
var objectPrototype = Object.prototype;
function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
  if (typeof sourceComponent !== 'string') {
    // don't hoist over string (html) components
    if (objectPrototype) {
      var inheritedComponent = getPrototypeOf(sourceComponent);

      if (inheritedComponent && inheritedComponent !== objectPrototype) {
        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
      }
    }

    var keys = getOwnPropertyNames(sourceComponent);

    if (getOwnPropertySymbols) {
      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
    }

    var targetStatics = getStatics(targetComponent);
    var sourceStatics = getStatics(sourceComponent);

    for (var i = 0; i < keys.length; ++i) {
      var key = keys[i];

      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);

        try {
          // Avoid failures from read-only properties
          defineProperty(targetComponent, key, descriptor);
        } catch (e) {}
      }
    }
  }

  return targetComponent;
}

module.exports = hoistNonReactStatics;


/***/ }),
/* 687 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = __webpack_require__(63);

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = __webpack_require__(81);

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = __webpack_require__(132);

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = __webpack_require__(133);

var _inherits3 = _interopRequireDefault(_inherits2);

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var FieldElemWrapper = function (_React$Component) {
  (0, _inherits3['default'])(FieldElemWrapper, _React$Component);

  function FieldElemWrapper() {
    (0, _classCallCheck3['default'])(this, FieldElemWrapper);
    return (0, _possibleConstructorReturn3['default'])(this, (FieldElemWrapper.__proto__ || Object.getPrototypeOf(FieldElemWrapper)).apply(this, arguments));
  }

  (0, _createClass3['default'])(FieldElemWrapper, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _props = this.props,
          name = _props.name,
          form = _props.form;

      form.domFields[name] = true;
      form.recoverClearedField(name);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      var _props2 = this.props,
          name = _props2.name,
          form = _props2.form;

      var fieldMeta = form.fieldsStore.getFieldMeta(name);
      if (!fieldMeta.preserve) {
        // after destroy, delete data
        form.clearedFieldMetaCache[name] = {
          field: form.fieldsStore.getField(name),
          meta: fieldMeta
        };
        form.clearField(name);
      }
      delete form.domFields[name];
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);
  return FieldElemWrapper;
}(_react2['default'].Component);

exports['default'] = FieldElemWrapper;


FieldElemWrapper.propTypes = {
  name: _propTypes2['default'].string,
  form: _propTypes2['default'].shape({
    domFields: _propTypes2['default'].objectOf(_propTypes2['default'].bool),
    recoverClearedField: _propTypes2['default'].func,
    fieldsStore: _propTypes2['default'].shape({
      getFieldMeta: _propTypes2['default'].func,
      getField: _propTypes2['default'].func
    }),
    clearedFieldMetaCache: _propTypes2['default'].objectOf(_propTypes2['default'].shape({
      field: _propTypes2['default'].object,
      meta: _propTypes2['default'].object
    })),
    clearField: _propTypes2['default'].func
  }),
  children: _propTypes2['default'].node
};
module.exports = exports['default'];

/***/ }),
/* 688 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.mixin = undefined;

var _createBaseForm = __webpack_require__(298);

var _createBaseForm2 = _interopRequireDefault(_createBaseForm);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

var mixin = exports.mixin = {
  getForm: function getForm() {
    return {
      getFieldsValue: this.fieldsStore.getFieldsValue,
      getFieldValue: this.fieldsStore.getFieldValue,
      getFieldInstance: this.getFieldInstance,
      setFieldsValue: this.setFieldsValue,
      setFields: this.setFields,
      setFieldsInitialValue: this.fieldsStore.setFieldsInitialValue,
      getFieldDecorator: this.getFieldDecorator,
      getFieldProps: this.getFieldProps,
      getFieldsError: this.fieldsStore.getFieldsError,
      getFieldError: this.fieldsStore.getFieldError,
      isFieldValidating: this.fieldsStore.isFieldValidating,
      isFieldsValidating: this.fieldsStore.isFieldsValidating,
      isFieldsTouched: this.fieldsStore.isFieldsTouched,
      isFieldTouched: this.fieldsStore.isFieldTouched,
      isSubmitting: this.isSubmitting,
      submit: this.submit,
      validateFields: this.validateFields,
      resetFields: this.resetFields
    };
  }
};

function createForm(options) {
  return (0, _createBaseForm2['default'])(options, [mixin]);
}

exports['default'] = createForm;

/***/ }),
/* 689 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var ReactDOM = _interopRequireWildcard(__webpack_require__(30));

var PropTypes = _interopRequireWildcard(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(24));

var _rcAnimate = _interopRequireDefault(__webpack_require__(690));

var _omit = _interopRequireDefault(__webpack_require__(84));

var _row = _interopRequireDefault(__webpack_require__(697));

var _col = _interopRequireDefault(__webpack_require__(699));

var _icon = _interopRequireDefault(__webpack_require__(60));

var _configProvider = __webpack_require__(28);

var _warning = _interopRequireDefault(__webpack_require__(64));

var _type = __webpack_require__(85);

var _constants = __webpack_require__(306);

var _context = _interopRequireDefault(__webpack_require__(307));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _iterableToArray(iter) { if (typeof Symbol !== "undefined" && Symbol.iterator in Object(iter)) return Array.from(iter); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var ValidateStatuses = (0, _type.tuple)('success', 'warning', 'error', 'validating', '');
var FormLabelAligns = (0, _type.tuple)('left', 'right');

function intersperseSpace(list) {
  return list.reduce(function (current, item) {
    return [].concat(_toConsumableArray(current), [' ', item]);
  }, []).slice(1);
}

var FormItem = /*#__PURE__*/function (_React$Component) {
  _inherits(FormItem, _React$Component);

  var _super = _createSuper(FormItem);

  function FormItem() {
    var _this;

    _classCallCheck(this, FormItem);

    _this = _super.apply(this, arguments);
    _this.helpShow = false; // Resolve duplicated ids bug between different forms
    // https://github.com/ant-design/ant-design/issues/7351

    _this.onLabelClick = function () {
      var id = _this.props.id || _this.getId();

      if (!id) {
        return;
      }

      var formItemNode = ReactDOM.findDOMNode(_assertThisInitialized(_this));
      var control = formItemNode.querySelector("[id=\"".concat(id, "\"]"));

      if (control && control.focus) {
        control.focus();
      }
    };

    _this.onHelpAnimEnd = function (_key, helpShow) {
      _this.helpShow = helpShow;

      if (!helpShow) {
        _this.setState({});
      }
    };

    _this.renderFormItem = function (_ref) {
      var _itemClassName;

      var getPrefixCls = _ref.getPrefixCls;

      var _a = _this.props,
          customizePrefixCls = _a.prefixCls,
          style = _a.style,
          className = _a.className,
          restProps = __rest(_a, ["prefixCls", "style", "className"]);

      var prefixCls = getPrefixCls('form', customizePrefixCls);

      var children = _this.renderChildren(prefixCls);

      var itemClassName = (_itemClassName = {}, _defineProperty(_itemClassName, "".concat(prefixCls, "-item"), true), _defineProperty(_itemClassName, "".concat(prefixCls, "-item-with-help"), _this.helpShow), _defineProperty(_itemClassName, "".concat(className), !!className), _itemClassName);
      return /*#__PURE__*/React.createElement(_row["default"], _extends({
        className: (0, _classnames["default"])(itemClassName),
        style: style
      }, (0, _omit["default"])(restProps, ['id', 'htmlFor', 'label', 'labelAlign', 'labelCol', 'wrapperCol', 'help', 'extra', 'validateStatus', 'hasFeedback', 'required', 'colon']), {
        key: "row"
      }), children);
    };

    return _this;
  }

  _createClass(FormItem, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props = this.props,
          children = _this$props.children,
          help = _this$props.help,
          validateStatus = _this$props.validateStatus,
          id = _this$props.id;
      (0, _warning["default"])(this.getControls(children, true).length <= 1 || help !== undefined || validateStatus !== undefined, 'Form.Item', 'Cannot generate `validateStatus` and `help` automatically, ' + 'while there are more than one `getFieldDecorator` in it.');
      (0, _warning["default"])(!id, 'Form.Item', '`id` is deprecated for its label `htmlFor`. Please use `htmlFor` directly.');
    }
  }, {
    key: "getHelpMessage",
    value: function getHelpMessage() {
      var help = this.props.help;

      if (help === undefined && this.getOnlyControl()) {
        var _this$getField = this.getField(),
            errors = _this$getField.errors;

        if (errors) {
          return intersperseSpace(errors.map(function (e, index) {
            var node = null;

            if ( /*#__PURE__*/React.isValidElement(e)) {
              node = e;
            } else if ( /*#__PURE__*/React.isValidElement(e.message)) {
              node = e.message;
            } // eslint-disable-next-line react/no-array-index-key


            return node ? /*#__PURE__*/React.cloneElement(node, {
              key: index
            }) : e.message;
          }));
        }

        return '';
      }

      return help;
    }
  }, {
    key: "getControls",
    value: function getControls(children, recursively) {
      var controls = [];
      var childrenArray = React.Children.toArray(children);

      for (var i = 0; i < childrenArray.length; i++) {
        if (!recursively && controls.length > 0) {
          break;
        }

        var child = childrenArray[i];

        if (child.type && (child.type === FormItem || child.type.displayName === 'FormItem')) {
          continue;
        }

        if (!child.props) {
          continue;
        }

        if (_constants.FIELD_META_PROP in child.props) {
          // And means FIELD_DATA_PROP in child.props, too.
          controls.push(child);
        } else if (child.props.children) {
          controls = controls.concat(this.getControls(child.props.children, recursively));
        }
      }

      return controls;
    }
  }, {
    key: "getOnlyControl",
    value: function getOnlyControl() {
      var child = this.getControls(this.props.children, false)[0];
      return child !== undefined ? child : null;
    }
  }, {
    key: "getChildProp",
    value: function getChildProp(prop) {
      var child = this.getOnlyControl();
      return child && child.props && child.props[prop];
    }
  }, {
    key: "getId",
    value: function getId() {
      return this.getChildProp('id');
    }
  }, {
    key: "getMeta",
    value: function getMeta() {
      return this.getChildProp(_constants.FIELD_META_PROP);
    }
  }, {
    key: "getField",
    value: function getField() {
      return this.getChildProp(_constants.FIELD_DATA_PROP);
    }
  }, {
    key: "getValidateStatus",
    value: function getValidateStatus() {
      var onlyControl = this.getOnlyControl();

      if (!onlyControl) {
        return '';
      }

      var field = this.getField();

      if (field.validating) {
        return 'validating';
      }

      if (field.errors) {
        return 'error';
      }

      var fieldValue = 'value' in field ? field.value : this.getMeta().initialValue;

      if (fieldValue !== undefined && fieldValue !== null && fieldValue !== '') {
        return 'success';
      }

      return '';
    }
  }, {
    key: "isRequired",
    value: function isRequired() {
      var required = this.props.required;

      if (required !== undefined) {
        return required;
      }

      if (this.getOnlyControl()) {
        var meta = this.getMeta() || {};
        var validate = meta.validate || [];
        return validate.filter(function (item) {
          return !!item.rules;
        }).some(function (item) {
          return item.rules.some(function (rule) {
            return rule.required;
          });
        });
      }

      return false;
    }
  }, {
    key: "renderHelp",
    value: function renderHelp(prefixCls) {
      var help = this.getHelpMessage();
      var children = help ? /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-explain"),
        key: "help"
      }, help) : null;

      if (children) {
        this.helpShow = !!children;
      }

      return /*#__PURE__*/React.createElement(_rcAnimate["default"], {
        transitionName: "show-help",
        component: "",
        transitionAppear: true,
        key: "help",
        onEnd: this.onHelpAnimEnd
      }, children);
    }
  }, {
    key: "renderExtra",
    value: function renderExtra(prefixCls) {
      var extra = this.props.extra;
      return extra ? /*#__PURE__*/React.createElement("div", {
        className: "".concat(prefixCls, "-extra")
      }, extra) : null;
    }
  }, {
    key: "renderValidateWrapper",
    value: function renderValidateWrapper(prefixCls, c1, c2, c3) {
      var props = this.props;
      var onlyControl = this.getOnlyControl;
      var validateStatus = props.validateStatus === undefined && onlyControl ? this.getValidateStatus() : props.validateStatus;
      var classes = "".concat(prefixCls, "-item-control");

      if (validateStatus) {
        classes = (0, _classnames["default"])("".concat(prefixCls, "-item-control"), {
          'has-feedback': validateStatus && props.hasFeedback,
          'has-success': validateStatus === 'success',
          'has-warning': validateStatus === 'warning',
          'has-error': validateStatus === 'error',
          'is-validating': validateStatus === 'validating'
        });
      }

      var iconType = '';

      switch (validateStatus) {
        case 'success':
          iconType = 'check-circle';
          break;

        case 'warning':
          iconType = 'exclamation-circle';
          break;

        case 'error':
          iconType = 'close-circle';
          break;

        case 'validating':
          iconType = 'loading';
          break;

        default:
          iconType = '';
          break;
      }

      var icon = props.hasFeedback && iconType ? /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefixCls, "-item-children-icon")
      }, /*#__PURE__*/React.createElement(_icon["default"], {
        type: iconType,
        theme: iconType === 'loading' ? 'outlined' : 'filled'
      })) : null;
      return /*#__PURE__*/React.createElement("div", {
        className: classes
      }, /*#__PURE__*/React.createElement("span", {
        className: "".concat(prefixCls, "-item-children")
      }, c1, icon), c2, c3);
    }
  }, {
    key: "renderWrapper",
    value: function renderWrapper(prefixCls, children) {
      var _this2 = this;

      return /*#__PURE__*/React.createElement(_context["default"].Consumer, {
        key: "wrapper"
      }, function (_ref2) {
        var contextWrapperCol = _ref2.wrapperCol,
            vertical = _ref2.vertical;
        var wrapperCol = _this2.props.wrapperCol;
        var mergedWrapperCol = ('wrapperCol' in _this2.props ? wrapperCol : contextWrapperCol) || {};
        var className = (0, _classnames["default"])("".concat(prefixCls, "-item-control-wrapper"), mergedWrapperCol.className); // No pass FormContext since it's useless

        return /*#__PURE__*/React.createElement(_context["default"].Provider, {
          value: {
            vertical: vertical
          }
        }, /*#__PURE__*/React.createElement(_col["default"], _extends({}, mergedWrapperCol, {
          className: className
        }), children));
      });
    }
  }, {
    key: "renderLabel",
    value: function renderLabel(prefixCls) {
      var _this3 = this;

      return /*#__PURE__*/React.createElement(_context["default"].Consumer, {
        key: "label"
      }, function (_ref3) {
        var _classNames;

        var vertical = _ref3.vertical,
            contextLabelAlign = _ref3.labelAlign,
            contextLabelCol = _ref3.labelCol,
            contextColon = _ref3.colon;
        var _this3$props = _this3.props,
            label = _this3$props.label,
            labelCol = _this3$props.labelCol,
            labelAlign = _this3$props.labelAlign,
            colon = _this3$props.colon,
            id = _this3$props.id,
            htmlFor = _this3$props.htmlFor;

        var required = _this3.isRequired();

        var mergedLabelCol = ('labelCol' in _this3.props ? labelCol : contextLabelCol) || {};
        var mergedLabelAlign = 'labelAlign' in _this3.props ? labelAlign : contextLabelAlign;
        var labelClsBasic = "".concat(prefixCls, "-item-label");
        var labelColClassName = (0, _classnames["default"])(labelClsBasic, mergedLabelAlign === 'left' && "".concat(labelClsBasic, "-left"), mergedLabelCol.className);
        var labelChildren = label; // Keep label is original where there should have no colon

        var computedColon = colon === true || contextColon !== false && colon !== false;
        var haveColon = computedColon && !vertical; // Remove duplicated user input colon

        if (haveColon && typeof label === 'string' && label.trim() !== '') {
          labelChildren = label.replace(/[：:]\s*$/, '');
        }

        var labelClassName = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-item-required"), required), _defineProperty(_classNames, "".concat(prefixCls, "-item-no-colon"), !computedColon), _classNames));
        return label ? /*#__PURE__*/React.createElement(_col["default"], _extends({}, mergedLabelCol, {
          className: labelColClassName
        }), /*#__PURE__*/React.createElement("label", {
          htmlFor: htmlFor || id || _this3.getId(),
          className: labelClassName,
          title: typeof label === 'string' ? label : '',
          onClick: _this3.onLabelClick
        }, labelChildren)) : null;
      });
    }
  }, {
    key: "renderChildren",
    value: function renderChildren(prefixCls) {
      var children = this.props.children;
      return [this.renderLabel(prefixCls), this.renderWrapper(prefixCls, this.renderValidateWrapper(prefixCls, children, this.renderHelp(prefixCls), this.renderExtra(prefixCls)))];
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderFormItem);
    }
  }]);

  return FormItem;
}(React.Component);

exports["default"] = FormItem;
FormItem.defaultProps = {
  hasFeedback: false
};
FormItem.propTypes = {
  prefixCls: PropTypes.string,
  label: PropTypes.oneOfType([PropTypes.string, PropTypes.node]),
  labelCol: PropTypes.object,
  help: PropTypes.oneOfType([PropTypes.node, PropTypes.bool]),
  validateStatus: PropTypes.oneOf(ValidateStatuses),
  hasFeedback: PropTypes.bool,
  wrapperCol: PropTypes.object,
  className: PropTypes.string,
  id: PropTypes.string,
  children: PropTypes.node,
  colon: PropTypes.bool
};

/***/ }),
/* 690 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__ = __webpack_require__(49);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__ = __webpack_require__(126);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_rc_util_es_unsafeLifecyclesPolyfill__ = __webpack_require__(691);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__ = __webpack_require__(692);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__AnimateChild__ = __webpack_require__(693);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__util_animate__ = __webpack_require__(304);













var defaultKey = 'rc_animate_' + Date.now();

function getChildrenFromProps(props) {
  var children = props.children;
  if (__WEBPACK_IMPORTED_MODULE_6_react___default.a.isValidElement(children)) {
    if (!children.key) {
      return __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(children, {
        key: defaultKey
      });
    }
  }
  return children;
}

function noop() {}

var Animate = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_5_babel_runtime_helpers_inherits___default()(Animate, _React$Component);

  // eslint-disable-line

  function Animate(props) {
    __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_classCallCheck___default()(this, Animate);

    var _this = __WEBPACK_IMPORTED_MODULE_4_babel_runtime_helpers_possibleConstructorReturn___default()(this, (Animate.__proto__ || Object.getPrototypeOf(Animate)).call(this, props));

    _initialiseProps.call(_this);

    _this.currentlyAnimatingKeys = {};
    _this.keysToEnter = [];
    _this.keysToLeave = [];

    _this.state = {
      children: Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props))
    };

    _this.childrenRefs = {};
    return _this;
  }

  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_createClass___default()(Animate, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      var _this2 = this;

      var showProp = this.props.showProp;
      var children = this.state.children;
      if (showProp) {
        children = children.filter(function (child) {
          return !!child.props[showProp];
        });
      }
      children.forEach(function (child) {
        if (child) {
          _this2.performAppear(child.key);
        }
      });
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps(nextProps) {
      var _this3 = this;

      this.nextProps = nextProps;
      var nextChildren = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(nextProps));
      var props = this.props;
      // exclusive needs immediate response
      if (props.exclusive) {
        Object.keys(this.currentlyAnimatingKeys).forEach(function (key) {
          _this3.stop(key);
        });
      }
      var showProp = props.showProp;
      var currentlyAnimatingKeys = this.currentlyAnimatingKeys;
      // last props children if exclusive
      var currentChildren = props.exclusive ? Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props)) : this.state.children;
      // in case destroy in showProp mode
      var newChildren = [];
      if (showProp) {
        currentChildren.forEach(function (currentChild) {
          var nextChild = currentChild && Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(nextChildren, currentChild.key);
          var newChild = void 0;
          if ((!nextChild || !nextChild.props[showProp]) && currentChild.props[showProp]) {
            newChild = __WEBPACK_IMPORTED_MODULE_6_react___default.a.cloneElement(nextChild || currentChild, __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_defineProperty___default()({}, showProp, true));
          } else {
            newChild = nextChild;
          }
          if (newChild) {
            newChildren.push(newChild);
          }
        });
        nextChildren.forEach(function (nextChild) {
          if (!nextChild || !Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, nextChild.key)) {
            newChildren.push(nextChild);
          }
        });
      } else {
        newChildren = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["d" /* mergeChildren */])(currentChildren, nextChildren);
      }

      // need render to avoid update
      this.setState({
        children: newChildren
      });

      nextChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasPrev = child && Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, key);
        if (showProp) {
          var showInNext = child.props[showProp];
          if (hasPrev) {
            var showInNow = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(currentChildren, key, showProp);
            if (!showInNow && showInNext) {
              _this3.keysToEnter.push(key);
            }
          } else if (showInNext) {
            _this3.keysToEnter.push(key);
          }
        } else if (!hasPrev) {
          _this3.keysToEnter.push(key);
        }
      });

      currentChildren.forEach(function (child) {
        var key = child && child.key;
        if (child && currentlyAnimatingKeys[key]) {
          return;
        }
        var hasNext = child && Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(nextChildren, key);
        if (showProp) {
          var showInNow = child.props[showProp];
          if (hasNext) {
            var showInNext = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(nextChildren, key, showProp);
            if (!showInNext && showInNow) {
              _this3.keysToLeave.push(key);
            }
          } else if (showInNow) {
            _this3.keysToLeave.push(key);
          }
        } else if (!hasNext) {
          _this3.keysToLeave.push(key);
        }
      });
    }
  }, {
    key: 'componentDidUpdate',
    value: function componentDidUpdate() {
      var keysToEnter = this.keysToEnter;
      this.keysToEnter = [];
      keysToEnter.forEach(this.performEnter);
      var keysToLeave = this.keysToLeave;
      this.keysToLeave = [];
      keysToLeave.forEach(this.performLeave);
    }
  }, {
    key: 'isValidChildByKey',
    value: function isValidChildByKey(currentChildren, key) {
      var showProp = this.props.showProp;
      if (showProp) {
        return Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["b" /* findShownChildInChildrenByKey */])(currentChildren, key, showProp);
      }
      return Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["a" /* findChildInChildrenByKey */])(currentChildren, key);
    }
  }, {
    key: 'stop',
    value: function stop(key) {
      delete this.currentlyAnimatingKeys[key];
      var component = this.childrenRefs[key];
      if (component) {
        component.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      var _this4 = this;

      var props = this.props;
      this.nextProps = props;
      var stateChildren = this.state.children;
      var children = null;
      if (stateChildren) {
        children = stateChildren.map(function (child) {
          if (child === null || child === undefined) {
            return child;
          }
          if (!child.key) {
            throw new Error('must set key for <rc-animate> children');
          }
          return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
            __WEBPACK_IMPORTED_MODULE_10__AnimateChild__["a" /* default */],
            {
              key: child.key,
              ref: function ref(node) {
                _this4.childrenRefs[child.key] = node;
              },
              animation: props.animation,
              transitionName: props.transitionName,
              transitionEnter: props.transitionEnter,
              transitionAppear: props.transitionAppear,
              transitionLeave: props.transitionLeave
            },
            child
          );
        });
      }
      var Component = props.component;
      if (Component) {
        var passedProps = props;
        if (typeof Component === 'string') {
          passedProps = __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_extends___default()({
            className: props.className,
            style: props.style
          }, props.componentProps);
        }
        return __WEBPACK_IMPORTED_MODULE_6_react___default.a.createElement(
          Component,
          passedProps,
          children
        );
      }
      return children[0] || null;
    }
  }]);

  return Animate;
}(__WEBPACK_IMPORTED_MODULE_6_react___default.a.Component);

Animate.isAnimate = true;
Animate.propTypes = {
  className: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  style: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  component: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.any,
  componentProps: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  animation: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object,
  transitionName: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.object]),
  transitionEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  transitionAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  exclusive: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  transitionLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.bool,
  onEnd: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onEnter: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onLeave: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  onAppear: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,
  showProp: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.string,
  children: __WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.node
};
Animate.defaultProps = {
  animation: {},
  component: 'span',
  componentProps: {},
  transitionEnter: true,
  transitionLeave: true,
  transitionAppear: false,
  onEnd: noop,
  onEnter: noop,
  onLeave: noop,
  onAppear: noop
};

var _initialiseProps = function _initialiseProps() {
  var _this5 = this;

  this.performEnter = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillEnter(_this5.handleDoneAdding.bind(_this5, key, 'enter'));
    }
  };

  this.performAppear = function (key) {
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillAppear(_this5.handleDoneAdding.bind(_this5, key, 'appear'));
    }
  };

  this.handleDoneAdding = function (key, type) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props));
    if (!_this5.isValidChildByKey(currentChildren, key)) {
      // exclusive will not need this
      _this5.performLeave(key);
    } else if (type === 'appear') {
      if (__WEBPACK_IMPORTED_MODULE_11__util_animate__["a" /* default */].allowAppearCallback(props)) {
        props.onAppear(key);
        props.onEnd(key, true);
      }
    } else if (__WEBPACK_IMPORTED_MODULE_11__util_animate__["a" /* default */].allowEnterCallback(props)) {
      props.onEnter(key);
      props.onEnd(key, true);
    }
  };

  this.performLeave = function (key) {
    // may already remove by exclusive
    if (_this5.childrenRefs[key]) {
      _this5.currentlyAnimatingKeys[key] = true;
      _this5.childrenRefs[key].componentWillLeave(_this5.handleDoneLeaving.bind(_this5, key));
    }
  };

  this.handleDoneLeaving = function (key) {
    var props = _this5.props;
    delete _this5.currentlyAnimatingKeys[key];
    // if update on exclusive mode, skip check
    if (props.exclusive && props !== _this5.nextProps) {
      return;
    }
    var currentChildren = Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["e" /* toArrayChildren */])(getChildrenFromProps(props));
    // in case state change is too fast
    if (_this5.isValidChildByKey(currentChildren, key)) {
      _this5.performEnter(key);
    } else {
      var end = function end() {
        if (__WEBPACK_IMPORTED_MODULE_11__util_animate__["a" /* default */].allowLeaveCallback(props)) {
          props.onLeave(key);
          props.onEnd(key, false);
        }
      };
      if (!Object(__WEBPACK_IMPORTED_MODULE_9__ChildrenUtils__["c" /* isSameChildren */])(_this5.state.children, currentChildren, props.showProp)) {
        _this5.setState({
          children: currentChildren
        }, end);
      } else {
        end();
      }
    }
  };
};

/* harmony default export */ __webpack_exports__["default"] = (Object(__WEBPACK_IMPORTED_MODULE_8_rc_util_es_unsafeLifecyclesPolyfill__["a" /* default */])(Animate));

/***/ }),
/* 691 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


var unsafeLifecyclesPolyfill = function unsafeLifecyclesPolyfill(Component) {
  var prototype = Component.prototype;

  if (!prototype || !prototype.isReactComponent) {
    throw new Error('Can only polyfill class components');
  } // only handle componentWillReceiveProps


  if (typeof prototype.componentWillReceiveProps !== 'function') {
    return Component;
  } // In React 16.9, React.Profiler was introduced together with UNSAFE_componentWillReceiveProps
  // https://reactjs.org/blog/2019/08/08/react-v16.9.0.html#performance-measurements-with-reactprofiler


  if (!__WEBPACK_IMPORTED_MODULE_0_react___default.a.Profiler) {
    return Component;
  } // Here polyfill get started


  prototype.UNSAFE_componentWillReceiveProps = prototype.componentWillReceiveProps;
  delete prototype.componentWillReceiveProps;
  return Component;
};

/* harmony default export */ __webpack_exports__["a"] = (unsafeLifecyclesPolyfill);

/***/ }),
/* 692 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (immutable) */ __webpack_exports__["e"] = toArrayChildren;
/* harmony export (immutable) */ __webpack_exports__["a"] = findChildInChildrenByKey;
/* harmony export (immutable) */ __webpack_exports__["b"] = findShownChildInChildrenByKey;
/* unused harmony export findHiddenChildInChildrenByKey */
/* harmony export (immutable) */ __webpack_exports__["c"] = isSameChildren;
/* harmony export (immutable) */ __webpack_exports__["d"] = mergeChildren;
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);


function toArrayChildren(children) {
  var ret = [];
  __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.forEach(children, function (child) {
    ret.push(child);
  });
  return ret;
}

function findChildInChildrenByKey(children, key) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (ret) {
        return;
      }
      if (child && child.key === key) {
        ret = child;
      }
    });
  }
  return ret;
}

function findShownChildInChildrenByKey(children, key, showProp) {
  var ret = null;
  if (children) {
    children.forEach(function (child) {
      if (child && child.key === key && child.props[showProp]) {
        if (ret) {
          throw new Error('two child with same key for <rc-animate> children');
        }
        ret = child;
      }
    });
  }
  return ret;
}

function findHiddenChildInChildrenByKey(children, key, showProp) {
  var found = 0;
  if (children) {
    children.forEach(function (child) {
      if (found) {
        return;
      }
      found = child && child.key === key && !child.props[showProp];
    });
  }
  return found;
}

function isSameChildren(c1, c2, showProp) {
  var same = c1.length === c2.length;
  if (same) {
    c1.forEach(function (child, index) {
      var child2 = c2[index];
      if (child && child2) {
        if (child && !child2 || !child && child2) {
          same = false;
        } else if (child.key !== child2.key) {
          same = false;
        } else if (showProp && child.props[showProp] !== child2.props[showProp]) {
          same = false;
        }
      }
    });
  }
  return same;
}

function mergeChildren(prev, next) {
  var ret = [];

  // For each key of `next`, the list of keys to insert before that key in
  // the combined list
  var nextChildrenPending = {};
  var pendingChildren = [];
  prev.forEach(function (child) {
    if (child && findChildInChildrenByKey(next, child.key)) {
      if (pendingChildren.length) {
        nextChildrenPending[child.key] = pendingChildren;
        pendingChildren = [];
      }
    } else {
      pendingChildren.push(child);
    }
  });

  next.forEach(function (child) {
    if (child && Object.prototype.hasOwnProperty.call(nextChildrenPending, child.key)) {
      ret = ret.concat(nextChildrenPending[child.key]);
    }
    ret.push(child);
  });

  ret = ret.concat(pendingChildren);

  return ret;
}

/***/ }),
/* 693 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__ = __webpack_require__(63);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__ = __webpack_require__(81);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__ = __webpack_require__(132);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__ = __webpack_require__(133);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom__ = __webpack_require__(30);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_dom___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_dom__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_css_animation__ = __webpack_require__(694);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__util_animate__ = __webpack_require__(304);










var transitionMap = {
  enter: 'transitionEnter',
  appear: 'transitionAppear',
  leave: 'transitionLeave'
};

var AnimateChild = function (_React$Component) {
  __WEBPACK_IMPORTED_MODULE_3_babel_runtime_helpers_inherits___default()(AnimateChild, _React$Component);

  function AnimateChild() {
    __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_classCallCheck___default()(this, AnimateChild);

    return __WEBPACK_IMPORTED_MODULE_2_babel_runtime_helpers_possibleConstructorReturn___default()(this, (AnimateChild.__proto__ || Object.getPrototypeOf(AnimateChild)).apply(this, arguments));
  }

  __WEBPACK_IMPORTED_MODULE_1_babel_runtime_helpers_createClass___default()(AnimateChild, [{
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      this.stop();
    }
  }, {
    key: 'componentWillEnter',
    value: function componentWillEnter(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isEnterSupported(this.props)) {
        this.transition('enter', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillAppear',
    value: function componentWillAppear(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isAppearSupported(this.props)) {
        this.transition('appear', done);
      } else {
        done();
      }
    }
  }, {
    key: 'componentWillLeave',
    value: function componentWillLeave(done) {
      if (__WEBPACK_IMPORTED_MODULE_8__util_animate__["a" /* default */].isLeaveSupported(this.props)) {
        this.transition('leave', done);
      } else {
        // always sync, do not interupt with react component life cycle
        // update hidden -> animate hidden ->
        // didUpdate -> animate leave -> unmount (if animate is none)
        done();
      }
    }
  }, {
    key: 'transition',
    value: function transition(animationType, finishCallback) {
      var _this2 = this;

      var node = __WEBPACK_IMPORTED_MODULE_5_react_dom___default.a.findDOMNode(this);
      var props = this.props;
      var transitionName = props.transitionName;
      var nameIsObj = typeof transitionName === 'object';
      this.stop();
      var end = function end() {
        _this2.stopper = null;
        finishCallback();
      };
      if ((__WEBPACK_IMPORTED_MODULE_7_css_animation__["b" /* isCssAnimationSupported */] || !props.animation[animationType]) && transitionName && props[transitionMap[animationType]]) {
        var name = nameIsObj ? transitionName[animationType] : transitionName + '-' + animationType;
        var activeName = name + '-active';
        if (nameIsObj && transitionName[animationType + 'Active']) {
          activeName = transitionName[animationType + 'Active'];
        }
        this.stopper = Object(__WEBPACK_IMPORTED_MODULE_7_css_animation__["a" /* default */])(node, {
          name: name,
          active: activeName
        }, end);
      } else {
        this.stopper = props.animation[animationType](node, end);
      }
    }
  }, {
    key: 'stop',
    value: function stop() {
      var stopper = this.stopper;
      if (stopper) {
        this.stopper = null;
        stopper.stop();
      }
    }
  }, {
    key: 'render',
    value: function render() {
      return this.props.children;
    }
  }]);

  return AnimateChild;
}(__WEBPACK_IMPORTED_MODULE_4_react___default.a.Component);

AnimateChild.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  animation: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any,
  transitionName: __WEBPACK_IMPORTED_MODULE_6_prop_types___default.a.any
};
/* harmony default export */ __webpack_exports__["a"] = (AnimateChild);

/***/ }),
/* 694 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isCssAnimationSupported; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__ = __webpack_require__(181);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Event__ = __webpack_require__(695);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_classes__ = __webpack_require__(696);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_component_classes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_component_classes__);




var isCssAnimationSupported = __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].endEvents.length !== 0;
var capitalPrefixes = ['Webkit', 'Moz', 'O',
// ms is special .... !
'ms'];
var prefixes = ['-webkit-', '-moz-', '-o-', 'ms-', ''];

function getStyleProperty(node, name) {
  // old ff need null, https://developer.mozilla.org/en-US/docs/Web/API/Window/getComputedStyle
  var style = window.getComputedStyle(node, null);
  var ret = '';
  for (var i = 0; i < prefixes.length; i++) {
    ret = style.getPropertyValue(prefixes[i] + name);
    if (ret) {
      break;
    }
  }
  return ret;
}

function fixBrowserByTimeout(node) {
  if (isCssAnimationSupported) {
    var transitionDelay = parseFloat(getStyleProperty(node, 'transition-delay')) || 0;
    var transitionDuration = parseFloat(getStyleProperty(node, 'transition-duration')) || 0;
    var animationDelay = parseFloat(getStyleProperty(node, 'animation-delay')) || 0;
    var animationDuration = parseFloat(getStyleProperty(node, 'animation-duration')) || 0;
    var time = Math.max(transitionDuration + transitionDelay, animationDuration + animationDelay);
    // sometimes, browser bug
    node.rcEndAnimTimeout = setTimeout(function () {
      node.rcEndAnimTimeout = null;
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }, time * 1000 + 200);
  }
}

function clearBrowserBugTimeout(node) {
  if (node.rcEndAnimTimeout) {
    clearTimeout(node.rcEndAnimTimeout);
    node.rcEndAnimTimeout = null;
  }
}

var cssAnimation = function cssAnimation(node, transitionName, endCallback) {
  var nameIsObj = (typeof transitionName === 'undefined' ? 'undefined' : __WEBPACK_IMPORTED_MODULE_0_babel_runtime_helpers_typeof___default()(transitionName)) === 'object';
  var className = nameIsObj ? transitionName.name : transitionName;
  var activeClassName = nameIsObj ? transitionName.active : transitionName + '-active';
  var end = endCallback;
  var start = void 0;
  var active = void 0;
  var nodeClasses = __WEBPACK_IMPORTED_MODULE_2_component_classes___default()(node);

  if (endCallback && Object.prototype.toString.call(endCallback) === '[object Object]') {
    end = endCallback.end;
    start = endCallback.start;
    active = endCallback.active;
  }

  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    nodeClasses.remove(className);
    nodeClasses.remove(activeClassName);

    __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional end is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (end) {
      end();
    }
  };

  __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].addEndEventListener(node, node.rcEndListener);

  if (start) {
    start();
  }
  nodeClasses.add(className);

  node.rcAnimTimeout = setTimeout(function () {
    node.rcAnimTimeout = null;
    nodeClasses.add(activeClassName);
    if (active) {
      setTimeout(active, 0);
    }
    fixBrowserByTimeout(node);
    // 30ms for firefox
  }, 30);

  return {
    stop: function stop() {
      if (node.rcEndListener) {
        node.rcEndListener();
      }
    }
  };
};

cssAnimation.style = function (node, style, callback) {
  if (node.rcEndListener) {
    node.rcEndListener();
  }

  node.rcEndListener = function (e) {
    if (e && e.target !== node) {
      return;
    }

    if (node.rcAnimTimeout) {
      clearTimeout(node.rcAnimTimeout);
      node.rcAnimTimeout = null;
    }

    clearBrowserBugTimeout(node);

    __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].removeEndEventListener(node, node.rcEndListener);
    node.rcEndListener = null;

    // Usually this optional callback is used for informing an owner of
    // a leave animation and telling it to remove the child.
    if (callback) {
      callback();
    }
  };

  __WEBPACK_IMPORTED_MODULE_1__Event__["a" /* default */].addEndEventListener(node, node.rcEndListener);

  node.rcAnimTimeout = setTimeout(function () {
    for (var s in style) {
      if (style.hasOwnProperty(s)) {
        node.style[s] = style[s];
      }
    }
    node.rcAnimTimeout = null;
    fixBrowserByTimeout(node);
  }, 0);
};

cssAnimation.setTransition = function (node, p, value) {
  var property = p;
  var v = value;
  if (value === undefined) {
    v = property;
    property = '';
  }
  property = property || '';
  capitalPrefixes.forEach(function (prefix) {
    node.style[prefix + 'Transition' + property] = v;
  });
};

cssAnimation.isCssAnimationSupported = isCssAnimationSupported;



/* harmony default export */ __webpack_exports__["a"] = (cssAnimation);

/***/ }),
/* 695 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var START_EVENT_NAME_MAP = {
  transitionstart: {
    transition: 'transitionstart',
    WebkitTransition: 'webkitTransitionStart',
    MozTransition: 'mozTransitionStart',
    OTransition: 'oTransitionStart',
    msTransition: 'MSTransitionStart'
  },

  animationstart: {
    animation: 'animationstart',
    WebkitAnimation: 'webkitAnimationStart',
    MozAnimation: 'mozAnimationStart',
    OAnimation: 'oAnimationStart',
    msAnimation: 'MSAnimationStart'
  }
};

var END_EVENT_NAME_MAP = {
  transitionend: {
    transition: 'transitionend',
    WebkitTransition: 'webkitTransitionEnd',
    MozTransition: 'mozTransitionEnd',
    OTransition: 'oTransitionEnd',
    msTransition: 'MSTransitionEnd'
  },

  animationend: {
    animation: 'animationend',
    WebkitAnimation: 'webkitAnimationEnd',
    MozAnimation: 'mozAnimationEnd',
    OAnimation: 'oAnimationEnd',
    msAnimation: 'MSAnimationEnd'
  }
};

var startEvents = [];
var endEvents = [];

function detectEvents() {
  var testEl = document.createElement('div');
  var style = testEl.style;

  if (!('AnimationEvent' in window)) {
    delete START_EVENT_NAME_MAP.animationstart.animation;
    delete END_EVENT_NAME_MAP.animationend.animation;
  }

  if (!('TransitionEvent' in window)) {
    delete START_EVENT_NAME_MAP.transitionstart.transition;
    delete END_EVENT_NAME_MAP.transitionend.transition;
  }

  function process(EVENT_NAME_MAP, events) {
    for (var baseEventName in EVENT_NAME_MAP) {
      if (EVENT_NAME_MAP.hasOwnProperty(baseEventName)) {
        var baseEvents = EVENT_NAME_MAP[baseEventName];
        for (var styleName in baseEvents) {
          if (styleName in style) {
            events.push(baseEvents[styleName]);
            break;
          }
        }
      }
    }
  }

  process(START_EVENT_NAME_MAP, startEvents);
  process(END_EVENT_NAME_MAP, endEvents);
}

if (typeof window !== 'undefined' && typeof document !== 'undefined') {
  detectEvents();
}

function addEventListener(node, eventName, eventListener) {
  node.addEventListener(eventName, eventListener, false);
}

function removeEventListener(node, eventName, eventListener) {
  node.removeEventListener(eventName, eventListener, false);
}

var TransitionEvents = {
  // Start events
  startEvents: startEvents,

  addStartEventListener: function addStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    startEvents.forEach(function (startEvent) {
      addEventListener(node, startEvent, eventListener);
    });
  },
  removeStartEventListener: function removeStartEventListener(node, eventListener) {
    if (startEvents.length === 0) {
      return;
    }
    startEvents.forEach(function (startEvent) {
      removeEventListener(node, startEvent, eventListener);
    });
  },


  // End events
  endEvents: endEvents,

  addEndEventListener: function addEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      window.setTimeout(eventListener, 0);
      return;
    }
    endEvents.forEach(function (endEvent) {
      addEventListener(node, endEvent, eventListener);
    });
  },
  removeEndEventListener: function removeEndEventListener(node, eventListener) {
    if (endEvents.length === 0) {
      return;
    }
    endEvents.forEach(function (endEvent) {
      removeEventListener(node, endEvent, eventListener);
    });
  }
};

/* harmony default export */ __webpack_exports__["a"] = (TransitionEvents);

/***/ }),
/* 696 */
/***/ (function(module, exports, __webpack_require__) {

/**
 * Module dependencies.
 */

try {
  var index = __webpack_require__(303);
} catch (err) {
  var index = __webpack_require__(303);
}

/**
 * Whitespace regexp.
 */

var re = /\s+/;

/**
 * toString reference.
 */

var toString = Object.prototype.toString;

/**
 * Wrap `el` in a `ClassList`.
 *
 * @param {Element} el
 * @return {ClassList}
 * @api public
 */

module.exports = function(el){
  return new ClassList(el);
};

/**
 * Initialize a new ClassList for `el`.
 *
 * @param {Element} el
 * @api private
 */

function ClassList(el) {
  if (!el || !el.nodeType) {
    throw new Error('A DOM element reference is required');
  }
  this.el = el;
  this.list = el.classList;
}

/**
 * Add class `name` if not already present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.add = function(name){
  // classList
  if (this.list) {
    this.list.add(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (!~i) arr.push(name);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove class `name` when present, or
 * pass a regular expression to remove
 * any which match.
 *
 * @param {String|RegExp} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.remove = function(name){
  if ('[object RegExp]' == toString.call(name)) {
    return this.removeMatching(name);
  }

  // classList
  if (this.list) {
    this.list.remove(name);
    return this;
  }

  // fallback
  var arr = this.array();
  var i = index(arr, name);
  if (~i) arr.splice(i, 1);
  this.el.className = arr.join(' ');
  return this;
};

/**
 * Remove all classes matching `re`.
 *
 * @param {RegExp} re
 * @return {ClassList}
 * @api private
 */

ClassList.prototype.removeMatching = function(re){
  var arr = this.array();
  for (var i = 0; i < arr.length; i++) {
    if (re.test(arr[i])) {
      this.remove(arr[i]);
    }
  }
  return this;
};

/**
 * Toggle class `name`, can force state via `force`.
 *
 * For browsers that support classList, but do not support `force` yet,
 * the mistake will be detected and corrected.
 *
 * @param {String} name
 * @param {Boolean} force
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.toggle = function(name, force){
  // classList
  if (this.list) {
    if ("undefined" !== typeof force) {
      if (force !== this.list.toggle(name, force)) {
        this.list.toggle(name); // toggle again to correct
      }
    } else {
      this.list.toggle(name);
    }
    return this;
  }

  // fallback
  if ("undefined" !== typeof force) {
    if (!force) {
      this.remove(name);
    } else {
      this.add(name);
    }
  } else {
    if (this.has(name)) {
      this.remove(name);
    } else {
      this.add(name);
    }
  }

  return this;
};

/**
 * Return an array of classes.
 *
 * @return {Array}
 * @api public
 */

ClassList.prototype.array = function(){
  var className = this.el.getAttribute('class') || '';
  var str = className.replace(/^\s+|\s+$/g, '');
  var arr = str.split(re);
  if ('' === arr[0]) arr.shift();
  return arr;
};

/**
 * Check if class `name` is present.
 *
 * @param {String} name
 * @return {ClassList}
 * @api public
 */

ClassList.prototype.has =
ClassList.prototype.contains = function(name){
  return this.list
    ? this.list.contains(name)
    : !! ~index(this.array(), name);
};


/***/ }),
/* 697 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(24));

var PropTypes = _interopRequireWildcard(__webpack_require__(1));

var _configProvider = __webpack_require__(28);

var _RowContext = _interopRequireDefault(__webpack_require__(305));

var _type = __webpack_require__(85);

var _responsiveObserve = _interopRequireWildcard(__webpack_require__(698));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var RowAligns = (0, _type.tuple)('top', 'middle', 'bottom', 'stretch');
var RowJustify = (0, _type.tuple)('start', 'end', 'center', 'space-around', 'space-between');

var Row = /*#__PURE__*/function (_React$Component) {
  _inherits(Row, _React$Component);

  var _super = _createSuper(Row);

  function Row() {
    var _this;

    _classCallCheck(this, Row);

    _this = _super.apply(this, arguments);
    _this.state = {
      screens: {}
    };

    _this.renderRow = function (_ref) {
      var _classNames;

      var getPrefixCls = _ref.getPrefixCls;

      var _a = _this.props,
          customizePrefixCls = _a.prefixCls,
          type = _a.type,
          justify = _a.justify,
          align = _a.align,
          className = _a.className,
          style = _a.style,
          children = _a.children,
          others = __rest(_a, ["prefixCls", "type", "justify", "align", "className", "style", "children"]);

      var prefixCls = getPrefixCls('row', customizePrefixCls);

      var gutter = _this.getGutter();

      var classes = (0, _classnames["default"])((_classNames = {}, _defineProperty(_classNames, prefixCls, !type), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(type), type), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(type, "-").concat(justify), type && justify), _defineProperty(_classNames, "".concat(prefixCls, "-").concat(type, "-").concat(align), type && align), _classNames), className);

      var rowStyle = _extends(_extends(_extends({}, gutter[0] > 0 ? {
        marginLeft: gutter[0] / -2,
        marginRight: gutter[0] / -2
      } : {}), gutter[1] > 0 ? {
        marginTop: gutter[1] / -2,
        marginBottom: gutter[1] / -2
      } : {}), style);

      var otherProps = _extends({}, others);

      delete otherProps.gutter;
      return /*#__PURE__*/React.createElement(_RowContext["default"].Provider, {
        value: {
          gutter: gutter
        }
      }, /*#__PURE__*/React.createElement("div", _extends({}, otherProps, {
        className: classes,
        style: rowStyle
      }), children));
    };

    return _this;
  }

  _createClass(Row, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this2 = this;

      this.token = _responsiveObserve["default"].subscribe(function (screens) {
        var gutter = _this2.props.gutter;

        if (_typeof(gutter) === 'object' || Array.isArray(gutter) && (_typeof(gutter[0]) === 'object' || _typeof(gutter[1]) === 'object')) {
          _this2.setState({
            screens: screens
          });
        }
      });
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      _responsiveObserve["default"].unsubscribe(this.token);
    }
  }, {
    key: "getGutter",
    value: function getGutter() {
      var results = [0, 0];
      var gutter = this.props.gutter;
      var screens = this.state.screens;
      var normalizedGutter = Array.isArray(gutter) ? gutter : [gutter, 0];
      normalizedGutter.forEach(function (g, index) {
        if (_typeof(g) === 'object') {
          for (var i = 0; i < _responsiveObserve.responsiveArray.length; i++) {
            var breakpoint = _responsiveObserve.responsiveArray[i];

            if (screens[breakpoint] && g[breakpoint] !== undefined) {
              results[index] = g[breakpoint];
              break;
            }
          }
        } else {
          results[index] = g || 0;
        }
      });
      return results;
    }
  }, {
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderRow);
    }
  }]);

  return Row;
}(React.Component);

exports["default"] = Row;
Row.defaultProps = {
  gutter: 0
};
Row.propTypes = {
  type: PropTypes.oneOf(['flex']),
  align: PropTypes.oneOf(RowAligns),
  justify: PropTypes.oneOf(RowJustify),
  className: PropTypes.string,
  children: PropTypes.node,
  gutter: PropTypes.oneOfType([PropTypes.object, PropTypes.number, PropTypes.array]),
  prefixCls: PropTypes.string
};

/***/ }),
/* 698 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.responsiveMap = exports.responsiveArray = void 0;

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

// matchMedia polyfill for
// https://github.com/WickyNilliams/enquire.js/issues/82
var enquire; // TODO: Will be removed in antd 4.0 because we will no longer support ie9

if (typeof window !== 'undefined') {
  var matchMediaPolyfill = function matchMediaPolyfill(mediaQuery) {
    return {
      media: mediaQuery,
      matches: false,
      addListener: function addListener() {},
      removeListener: function removeListener() {}
    };
  }; // ref: https://github.com/ant-design/ant-design/issues/18774


  if (!window.matchMedia) window.matchMedia = matchMediaPolyfill; // eslint-disable-next-line global-require

  enquire = __webpack_require__(269);
}

var responsiveArray = ['xxl', 'xl', 'lg', 'md', 'sm', 'xs'];
exports.responsiveArray = responsiveArray;
var responsiveMap = {
  xs: '(max-width: 575px)',
  sm: '(min-width: 576px)',
  md: '(min-width: 768px)',
  lg: '(min-width: 992px)',
  xl: '(min-width: 1200px)',
  xxl: '(min-width: 1600px)'
};
exports.responsiveMap = responsiveMap;
var subscribers = [];
var subUid = -1;
var screens = {};
var responsiveObserve = {
  dispatch: function dispatch(pointMap) {
    screens = pointMap;

    if (subscribers.length < 1) {
      return false;
    }

    subscribers.forEach(function (item) {
      item.func(screens);
    });
    return true;
  },
  subscribe: function subscribe(func) {
    if (subscribers.length === 0) {
      this.register();
    }

    var token = (++subUid).toString();
    subscribers.push({
      token: token,
      func: func
    });
    func(screens);
    return token;
  },
  unsubscribe: function unsubscribe(token) {
    subscribers = subscribers.filter(function (item) {
      return item.token !== token;
    });

    if (subscribers.length === 0) {
      this.unregister();
    }
  },
  unregister: function unregister() {
    Object.keys(responsiveMap).map(function (screen) {
      return enquire.unregister(responsiveMap[screen]);
    });
  },
  register: function register() {
    var _this = this;

    Object.keys(responsiveMap).map(function (screen) {
      return enquire.register(responsiveMap[screen], {
        match: function match() {
          var pointMap = _extends(_extends({}, screens), _defineProperty({}, screen, true));

          _this.dispatch(pointMap);
        },
        unmatch: function unmatch() {
          var pointMap = _extends(_extends({}, screens), _defineProperty({}, screen, false));

          _this.dispatch(pointMap);
        },
        // Keep a empty destory to avoid triggering unmatch when unregister
        destroy: function destroy() {}
      });
    });
  }
};
var _default = responsiveObserve;
exports["default"] = _default;

/***/ }),
/* 699 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var React = _interopRequireWildcard(__webpack_require__(0));

var PropTypes = _interopRequireWildcard(__webpack_require__(1));

var _classnames = _interopRequireDefault(__webpack_require__(24));

var _RowContext = _interopRequireDefault(__webpack_require__(305));

var _configProvider = __webpack_require__(28);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function _getRequireWildcardCache() { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

var __rest = void 0 && (void 0).__rest || function (s, e) {
  var t = {};

  for (var p in s) {
    if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0) t[p] = s[p];
  }

  if (s != null && typeof Object.getOwnPropertySymbols === "function") for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
    if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i])) t[p[i]] = s[p[i]];
  }
  return t;
};

var objectOrNumber = PropTypes.oneOfType([PropTypes.object, PropTypes.number]);

var Col = /*#__PURE__*/function (_React$Component) {
  _inherits(Col, _React$Component);

  var _super = _createSuper(Col);

  function Col() {
    var _this;

    _classCallCheck(this, Col);

    _this = _super.apply(this, arguments);

    _this.renderCol = function (_ref) {
      var _classNames;

      var getPrefixCls = _ref.getPrefixCls;

      var _assertThisInitialize = _assertThisInitialized(_this),
          props = _assertThisInitialize.props;

      var customizePrefixCls = props.prefixCls,
          span = props.span,
          order = props.order,
          offset = props.offset,
          push = props.push,
          pull = props.pull,
          className = props.className,
          children = props.children,
          others = __rest(props, ["prefixCls", "span", "order", "offset", "push", "pull", "className", "children"]);

      var prefixCls = getPrefixCls('col', customizePrefixCls);
      var sizeClassObj = {};
      ['xs', 'sm', 'md', 'lg', 'xl', 'xxl'].forEach(function (size) {
        var _extends2;

        var sizeProps = {};
        var propSize = props[size];

        if (typeof propSize === 'number') {
          sizeProps.span = propSize;
        } else if (_typeof(propSize) === 'object') {
          sizeProps = propSize || {};
        }

        delete others[size];
        sizeClassObj = _extends(_extends({}, sizeClassObj), (_extends2 = {}, _defineProperty(_extends2, "".concat(prefixCls, "-").concat(size, "-").concat(sizeProps.span), sizeProps.span !== undefined), _defineProperty(_extends2, "".concat(prefixCls, "-").concat(size, "-order-").concat(sizeProps.order), sizeProps.order || sizeProps.order === 0), _defineProperty(_extends2, "".concat(prefixCls, "-").concat(size, "-offset-").concat(sizeProps.offset), sizeProps.offset || sizeProps.offset === 0), _defineProperty(_extends2, "".concat(prefixCls, "-").concat(size, "-push-").concat(sizeProps.push), sizeProps.push || sizeProps.push === 0), _defineProperty(_extends2, "".concat(prefixCls, "-").concat(size, "-pull-").concat(sizeProps.pull), sizeProps.pull || sizeProps.pull === 0), _extends2));
      });
      var classes = (0, _classnames["default"])(prefixCls, (_classNames = {}, _defineProperty(_classNames, "".concat(prefixCls, "-").concat(span), span !== undefined), _defineProperty(_classNames, "".concat(prefixCls, "-order-").concat(order), order), _defineProperty(_classNames, "".concat(prefixCls, "-offset-").concat(offset), offset), _defineProperty(_classNames, "".concat(prefixCls, "-push-").concat(push), push), _defineProperty(_classNames, "".concat(prefixCls, "-pull-").concat(pull), pull), _classNames), className, sizeClassObj);
      return /*#__PURE__*/React.createElement(_RowContext["default"].Consumer, null, function (_ref2) {
        var gutter = _ref2.gutter;
        var style = others.style;

        if (gutter) {
          style = _extends(_extends(_extends({}, gutter[0] > 0 ? {
            paddingLeft: gutter[0] / 2,
            paddingRight: gutter[0] / 2
          } : {}), gutter[1] > 0 ? {
            paddingTop: gutter[1] / 2,
            paddingBottom: gutter[1] / 2
          } : {}), style);
        }

        return /*#__PURE__*/React.createElement("div", _extends({}, others, {
          style: style,
          className: classes
        }), children);
      });
    };

    return _this;
  }

  _createClass(Col, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(_configProvider.ConfigConsumer, null, this.renderCol);
    }
  }]);

  return Col;
}(React.Component);

exports["default"] = Col;
Col.propTypes = {
  span: PropTypes.number,
  order: PropTypes.number,
  offset: PropTypes.number,
  push: PropTypes.number,
  pull: PropTypes.number,
  className: PropTypes.string,
  children: PropTypes.node,
  xs: objectOrNumber,
  sm: objectOrNumber,
  md: objectOrNumber,
  lg: objectOrNumber,
  xl: objectOrNumber,
  xxl: objectOrNumber
};

/***/ }),
/* 700 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Ebrochure; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__ = __webpack_require__(291);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_antd_lib_button_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button__ = __webpack_require__(294);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__ = __webpack_require__(290);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_antd_lib_input_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input__ = __webpack_require__(292);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form_style__ = __webpack_require__(296);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_antd_lib_form_style___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_antd_lib_form_style__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form__ = __webpack_require__(297);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_antd_lib_form___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_class2,_temp2;function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var FormItem=__WEBPACK_IMPORTED_MODULE_6_antd_lib_form___default.a.Item;var Ebrochure=(_dec=__WEBPACK_IMPORTED_MODULE_6_antd_lib_form___default.a.create(),_dec(_class=(_temp2=_class2=function(_Component){_inherits(Ebrochure,_Component);function Ebrochure(){var _ref,_this2=this;var _temp,_this,_ret;_classCallCheck(this,Ebrochure);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Ebrochure.__proto__||Object.getPrototypeOf(Ebrochure)).call.apply(_ref,[this].concat(args))),_this),_this.state={submitting:false},_this.downloadEbrochure=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee2(){var _this$props,location,project,language,result;return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee2$(_context2){while(1){switch(_context2.prev=_context2.next){case 0:_this$props=_this.props,location=_this$props.location,project=_this$props.project,language=_this$props.language;_context2.next=3;return fetch("https://api.lagunaproperty.com"+"/download_ebrochure",{method:"POST",headers:{Accept:"application/json, text/plain, */*","Content-Type":"application/json"},body:JSON.stringify({websiteKey:"lp",location:location,project:project,language:language})}).then(function(){var _ref3=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee(response){var blob,link;return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:_context.next=2;return response.blob();case 2:blob=_context.sent;link=document.createElement("a");link.href=window.URL.createObjectURL(blob);link.download="file.pdf";document.body.appendChild(link);link.click();document.body.removeChild(link);case 9:case"end":return _context.stop();}}},_callee,_this2);}));return function(_x){return _ref3.apply(this,arguments);};}());case 3:result=_context2.sent;return _context2.abrupt("return",result);case 5:case"end":return _context2.stop();}}},_callee2,_this2);})),_this.submit=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.mark(function _callee3(data){var submitting;return __WEBPACK_IMPORTED_MODULE_4_babel_runtime_regenerator___default.a.wrap(function _callee3$(_context3){while(1){switch(_context3.prev=_context3.next){case 0:submitting=_this.state.submitting;if(!submitting){_context3.next=3;break;}return _context3.abrupt("return",false);case 3:_this.setState({submitting:true});_context3.next=6;return _this.downloadEbrochure();case 6:// sendEmail({
//   ...data,
//   contactType: "contact"
// });
// notification.success({
//   message: "Contact Success"
// });
_this.setState({submitting:false});_this.props.form.resetFields();_this.props.onSubmit();return _context3.abrupt("return",true);case 10:case"end":return _context3.stop();}}},_callee3,_this2);}));return function(_x2){return _ref4.apply(this,arguments);};}(),_this.handleSubmit=function(e){e.preventDefault();_this.props.form.validateFieldsAndScroll(function(err,values){if(!err){_this.submit(values);}});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Ebrochure,[{key:"componentDidMount",value:function componentDidMount(){this.nameInput.focus();}},{key:"render",value:function render(){var _this3=this;var t=this.props.t;var getFieldDecorator=this.props.form.getFieldDecorator;var submitting=this.state.submitting;return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div",{className:"request-ebrochure-form"},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6_antd_lib_form___default.a,{onSubmit:this.handleSubmit,style:{width:360,background:"white",padding:"20px 50px 15px"}},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("p",{style:{fontSize:13,marginBottom:"1em"}},t("Please provide your name & email address")),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(FormItem,null,getFieldDecorator("name",{rules:[{required:true,message:t("This field is required")}]})(__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,{ref:function ref(e){_this3.nameInput=e;},placeholder:t("Name")+"*"}))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(FormItem,null,getFieldDecorator("email",{rules:[{type:"email",message:t("This email is not valid email address")},{required:true,message:t("This field is required")}]})(__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_antd_lib_input___default.a,{placeholder:t("Email address")+"*"}))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(FormItem,null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_antd_lib_button___default.a,{type:"primary",htmlType:"submit",loading:submitting},t("Submit")))));}}]);return Ebrochure;}(__WEBPACK_IMPORTED_MODULE_7_react__["Component"]),_class2.propTypes={t:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func.isRequired,onSubmit:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.func,location:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string,project:__WEBPACK_IMPORTED_MODULE_8_prop_types___default.a.string},_class2.defaultProps={onSubmit:function onSubmit(){return null;},location:"",project:""},_temp2))||_class);

/***/ }),
/* 701 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEmpty__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n"],["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  width: 100%;\n  height: 100%;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"],["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n"]),_templateObject3=_taggedTemplateLiteral(["\n  text-transform: uppercase;\n  font-family: Lato;\n  // font-family: Helvetica;\n  font-weight: 700;\n  font-size: 80px;\n  color: ",";\n  text-shadow: 6px 6px rgba(0, 0, 0, 0.5);\n  @media (max-width: 768px) {\n    font-size: 40px;\n  }\n"],["\n  text-transform: uppercase;\n  font-family: Lato;\n  // font-family: Helvetica;\n  font-weight: 700;\n  font-size: 80px;\n  color: ",";\n  text-shadow: 6px 6px rgba(0, 0, 0, 0.5);\n  @media (max-width: 768px) {\n    font-size: 40px;\n  }\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_2_styled_components__["b" /* default */].div(_templateObject);var Block=__WEBPACK_IMPORTED_MODULE_2_styled_components__["b" /* default */].div(_templateObject2);var Paragraph=__WEBPACK_IMPORTED_MODULE_2_styled_components__["b" /* default */].p(_templateObject3,function(props){return props.fontColor||"#00";});var ComingSoon=function(_PureComponent){_inherits(ComingSoon,_PureComponent);function ComingSoon(){_classCallCheck(this,ComingSoon);return _possibleConstructorReturn(this,(ComingSoon.__proto__||Object.getPrototypeOf(ComingSoon)).apply(this,arguments));}_createClass(ComingSoon,[{key:"render",value:function render(){var _props=this.props,src=_props.src,_props$fontColor=_props.fontColor,fontColor=_props$fontColor===undefined?"#000":_props$fontColor;console.log("ComingSoon",{src:src,fontColor:fontColor});if(!__WEBPACK_IMPORTED_MODULE_0_lodash_isEmpty___default()(src)){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Container,{className:"coming-soon"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["a" /* BackgroundImage */],{style:{display:"flex",justifyContent:"center",width:"100%",height:"100%"},image:src},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Block,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Paragraph,{fontColor:fontColor},"Coming Soon"))));}return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Block,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Paragraph,{fontColor:fontColor},"Coming Soon"));}}]);return ComingSoon;}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]);/* harmony default export */ __webpack_exports__["a"] = (ComingSoon);

/***/ }),
/* 702 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GalleryImages; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_omitBy__ = __webpack_require__(703);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_omitBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_omitBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_filter__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_GalleryLightbox__ = __webpack_require__(192);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp2;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import Lightbox from "../components/react-images";
var GalleryImages=(_temp2=_class=function(_Component){_inherits(GalleryImages,_Component);function GalleryImages(){var _ref;var _temp,_this,_ret;_classCallCheck(this,GalleryImages);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=GalleryImages.__proto__||Object.getPrototypeOf(GalleryImages)).call.apply(_ref,[this].concat(args))),_this),_this.state={currentCategory:1,lightboxIsOpen:false,currentImage:0},_this.handleClickCategory=function(categoryId){var currentCategory=_this.state.currentCategory;if(currentCategory!==categoryId){_this.setState({currentCategory:categoryId});}},_this.handleClickImageItem=function(index){_this.setState({lightboxIsOpen:true,currentImage:index});},_this.handleClickImageItemMobile=function(categoryId,imageIndex){_this.setState({lightboxIsOpen:true,currentImage:imageIndex,currentCategory:categoryId});},_this.gotoPrevious=function(){_this.setState({currentImage:_this.state.currentImage-1});},_this.gotoNext=function(){_this.setState({currentImage:_this.state.currentImage+1});},_this.gotoImage=function(index){_this.setState({currentImage:index});},_this.closeLightbox=function(){_this.setState({lightboxIsOpen:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(GalleryImages,[{key:"render",value:function render(){var _this2=this;var _state=this.state,currentCategory=_state.currentCategory,lightboxIsOpen=_state.lightboxIsOpen,currentImage=_state.currentImage;var _props=this.props,t=_props.t,categories=_props.categories,images=_props.images;var galleryImages=images;if(currentCategory!==1){galleryImages=__WEBPACK_IMPORTED_MODULE_3_lodash_filter___default()(galleryImages,{categoryId:currentCategory});}// Image for lightbox
return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",{className:"gallery-images"},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",{className:"d-none d-sm-block"},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",{className:"filter-bar"},__WEBPACK_IMPORTED_MODULE_2_lodash_map___default()(categories,function(category){var id=category.id,name=category.name;var activeClass=id===currentCategory?"active":"";return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",{key:id,className:"text "+activeClass,onClick:function onClick(){return _this2.handleClickCategory(id);}},t(name));}))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",{className:"image-block"},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",{className:"image-list"},__WEBPACK_IMPORTED_MODULE_2_lodash_map___default()(galleryImages,function(value,key){var image=value.image;console.log('image',image);return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",{key:key,className:"item",onClick:function onClick(){return _this2.handleClickImageItem(key);}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",{className:"image"},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components__["a" /* BackgroundImage */],{image:image})));}))))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",{className:"d-sm-none"},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",{className:"image-sections"},__WEBPACK_IMPORTED_MODULE_2_lodash_map___default()(__WEBPACK_IMPORTED_MODULE_1_lodash_omitBy___default()(categories,function(cat){return cat.id===1;}),function(category){var id=category.id,name=category.name;var categoryImages=__WEBPACK_IMPORTED_MODULE_3_lodash_filter___default()(images,{categoryId:id});return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",{key:id},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",{className:"category-header-text"},t(name)),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",{className:"image-list"},__WEBPACK_IMPORTED_MODULE_2_lodash_map___default()(categoryImages,function(value,imageIndex){var image=value.image;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",{key:imageIndex,className:"item",onClick:function onClick(){return _this2.handleClickImageItemMobile(id,imageIndex);}},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",{className:"image"},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components__["a" /* BackgroundImage */],{image:image})));})));}))),lightboxIsOpen&&__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components__["k" /* Modal */],{name:"gallery-images-modal",onCancel:this.closeLightbox},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_GalleryLightbox__["a" /* default */],{currentImage:currentImage,images:__WEBPACK_IMPORTED_MODULE_2_lodash_map___default()(galleryImages,function(value){return{src:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(value,"image"),caption:t(__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(value,"name"))};}),onClickPrev:this.gotoPrevious,onClickNext:this.gotoNext,onClickThumbnail:this.gotoImage})));}}]);return GalleryImages;}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]),_class.propTypes={t:__WEBPACK_IMPORTED_MODULE_5_prop_types___default.a.func.isRequired},_temp2);

/***/ }),
/* 703 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(36),
    negate = __webpack_require__(308),
    pickBy = __webpack_require__(704);

/**
 * The opposite of `_.pickBy`; this method creates an object composed of
 * the own and inherited enumerable string keyed properties of `object` that
 * `predicate` doesn't return truthy for. The predicate is invoked with two
 * arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omitBy(object, _.isNumber);
 * // => { 'b': '2' }
 */
function omitBy(object, predicate) {
  return pickBy(object, negate(baseIteratee(predicate)));
}

module.exports = omitBy;


/***/ }),
/* 704 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(69),
    baseIteratee = __webpack_require__(36),
    basePickBy = __webpack_require__(260),
    getAllKeysIn = __webpack_require__(190);

/**
 * Creates an object composed of the `object` properties `predicate` returns
 * truthy for. The predicate is invoked with two arguments: (value, key).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Object
 * @param {Object} object The source object.
 * @param {Function} [predicate=_.identity] The function invoked per property.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.pickBy(object, _.isNumber);
 * // => { 'a': 1, 'c': 3 }
 */
function pickBy(object, predicate) {
  if (object == null) {
    return {};
  }
  var props = arrayMap(getAllKeysIn(object), function(prop) {
    return [prop];
  });
  predicate = baseIteratee(predicate);
  return basePickBy(object, props, function(value, path) {
    return predicate(value, path[0]);
  });
}

module.exports = pickBy;


/***/ }),
/* 705 */
/***/ (function(module, exports, __webpack_require__) {

var isObject = __webpack_require__(31),
    isPrototype = __webpack_require__(122),
    nativeKeysIn = __webpack_require__(706);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function baseKeysIn(object) {
  if (!isObject(object)) {
    return nativeKeysIn(object);
  }
  var isProto = isPrototype(object),
      result = [];

  for (var key in object) {
    if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
      result.push(key);
    }
  }
  return result;
}

module.exports = baseKeysIn;


/***/ }),
/* 706 */
/***/ (function(module, exports) {

/**
 * This function is like
 * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
 * except that it includes inherited enumerable properties.
 *
 * @private
 * @param {Object} object The object to query.
 * @returns {Array} Returns the array of property names.
 */
function nativeKeysIn(object) {
  var result = [];
  if (object != null) {
    for (var key in Object(object)) {
      result.push(key);
    }
  }
  return result;
}

module.exports = nativeKeysIn;


/***/ }),
/* 707 */
/***/ (function(module, exports, __webpack_require__) {

var baseClamp = __webpack_require__(708),
    toNumber = __webpack_require__(160);

/**
 * Clamps `number` within the inclusive `lower` and `upper` bounds.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Number
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 * @example
 *
 * _.clamp(-10, -5, 5);
 * // => -5
 *
 * _.clamp(10, -5, 5);
 * // => 5
 */
function clamp(number, lower, upper) {
  if (upper === undefined) {
    upper = lower;
    lower = undefined;
  }
  if (upper !== undefined) {
    upper = toNumber(upper);
    upper = upper === upper ? upper : 0;
  }
  if (lower !== undefined) {
    lower = toNumber(lower);
    lower = lower === lower ? lower : 0;
  }
  return baseClamp(toNumber(number), lower, upper);
}

module.exports = clamp;


/***/ }),
/* 708 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.clamp` which doesn't coerce arguments.
 *
 * @private
 * @param {number} number The number to clamp.
 * @param {number} [lower] The lower bound.
 * @param {number} upper The upper bound.
 * @returns {number} Returns the clamped number.
 */
function baseClamp(number, lower, upper) {
  if (number === number) {
    if (upper !== undefined) {
      number = number <= upper ? number : upper;
    }
    if (lower !== undefined) {
      number = number >= lower ? number : lower;
    }
  }
  return number;
}

module.exports = baseClamp;


/***/ }),
/* 709 */
/***/ (function(module, exports, __webpack_require__) {

var baseProperty = __webpack_require__(248);

/**
 * Gets the size of an ASCII `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
var asciiSize = baseProperty('length');

module.exports = asciiSize;


/***/ }),
/* 710 */
/***/ (function(module, exports) {

/** Used to compose unicode character classes. */
var rsAstralRange = '\\ud800-\\udfff',
    rsComboMarksRange = '\\u0300-\\u036f',
    reComboHalfMarksRange = '\\ufe20-\\ufe2f',
    rsComboSymbolsRange = '\\u20d0-\\u20ff',
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsVarRange = '\\ufe0e\\ufe0f';

/** Used to compose unicode capture groups. */
var rsAstral = '[' + rsAstralRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsFitz = '\\ud83c[\\udffb-\\udfff]',
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = '(?:\\ud83c[\\udde6-\\uddff]){2}',
    rsSurrPair = '[\\ud800-\\udbff][\\udc00-\\udfff]',
    rsZWJ = '\\u200d';

/** Used to compose unicode regexes. */
var reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

/** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

/**
 * Gets the size of a Unicode `string`.
 *
 * @private
 * @param {string} string The string inspect.
 * @returns {number} Returns the string size.
 */
function unicodeSize(string) {
  var result = reUnicode.lastIndex = 0;
  while (reUnicode.test(string)) {
    ++result;
  }
  return result;
}

module.exports = unicodeSize;


/***/ }),
/* 711 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _default; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var _default=function(_React$PureComponent){_inherits(_default,_React$PureComponent);function _default(){var _ref;var _temp,_this,_ret;_classCallCheck(this,_default);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=_default.__proto__||Object.getPrototypeOf(_default)).call.apply(_ref,[this].concat(args))),_this),_this.handleClick=function(e){var _this$props=_this.props,index=_this$props.index,onClick=_this$props.onClick;// console.log('Thumbnail Click', index);
onClick(index);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(_default,[{key:'render',value:function render(){var _props=this.props,index=_props.index,src=_props.src,thumbnail=_props.thumbnail,active=_props.active;var url=thumbnail?thumbnail:src;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'thumbnail '+(active?'active':''),index:index,onClick:this.handleClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{style:{backgroundImage:'url("'+url+'")'}}));}}]);return _default;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent);

/***/ }),
/* 712 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_size__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_size___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_size__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_styled_components__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_GalleryLightbox__ = __webpack_require__(192);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp2;var _templateObject=_taggedTemplateLiteral(["\n  0% {\n    transform: scale(0.4);\n    opacity: 0;\n  }\n\n  70% {\n    transform: scale(0.9);\n    opacity: 0.8;\n  }\n\n  75% {\n    transform: scale(0.75);\n    opacity: 0.2;\n  }\n\n  85% {\n    transform: scale(0.6);\n    opacity: 0.2;\n  }\n\n  100% {\n    transform: scale(0.6);\n    opacity: 0.2;\n  }\n"],["\n  0% {\n    transform: scale(0.4);\n    opacity: 0;\n  }\n\n  70% {\n    transform: scale(0.9);\n    opacity: 0.8;\n  }\n\n  75% {\n    transform: scale(0.75);\n    opacity: 0.2;\n  }\n\n  85% {\n    transform: scale(0.6);\n    opacity: 0.2;\n  }\n\n  100% {\n    transform: scale(0.6);\n    opacity: 0.2;\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  animation: "," 2s infinite;\n"],["\n  animation: "," 2s infinite;\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}// Modal
// TypeResidenceVirtual,
var pulse=Object(__WEBPACK_IMPORTED_MODULE_5_styled_components__["c" /* keyframes */])(_templateObject);var AnimatedBubble=__WEBPACK_IMPORTED_MODULE_5_styled_components__["b" /* default */].g(_templateObject2,pulse);var TypeResidences=(_temp2=_class=function(_Component){_inherits(TypeResidences,_Component);function TypeResidences(){var _ref;var _temp,_this,_ret;_classCallCheck(this,TypeResidences);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=TypeResidences.__proto__||Object.getPrototypeOf(TypeResidences)).call.apply(_ref,[this].concat(args))),_this),_this.state={currentSection:0,showImageModal:false,showVirtualModal:false,currentImage:0,currentURL:""},_this.componentDidMount=function(){// typeresidence-container-des
_this.calPositionResDes();},_this.componentDidUpdate=function(){_this.calPositionResDes();},_this.calPositionResDes=function(){try{var heightBtnGroup=document.querySelector(".typeresidence-container-btn").clientHeight||80;document.querySelector(".typeresidence-container-des").style.bottom=heightBtnGroup+40+"px";}catch(error){console.error(error);}},_this.createSliderData=function(){var currentSection=_this.state.currentSection;var data=_this.props.data;var eachSlider=__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(data[0],"buttons["+currentSection+"].images");return eachSlider;},_this.createBtn=function(){var _this$props=_this.props,data=_this$props.data,t=_this$props.t;var currentSection=_this.state.currentSection;var allBtn=__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(data[0],"buttons");var renderBtn=__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components__["c" /* ButtonGroup */],{value:currentSection,items:allBtn,onChange:function onChange(value){return _this.setState({currentSection:value});},direction:"horizontal",renderItem:function renderItem(_ref2){var value=_ref2.value,name=_ref2.name,active=_ref2.active,onClick=_ref2.onClick,key=_ref2.key;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components__["b" /* Button */],{key:key,type:"secondary",active:active,activeStyle:{backgroundColor:"#00a9a5"},hoverStyle:{backgroundColor:"#00a9a5"},page:"residence",defaultStyle:{padding:"10px 15px",marginRight:"1px",fontWeight:"bold",fontSize:"13px",letterSpacing:"1px"},onClick:function onClick(){return _this.setState({currentSection:key});}},Object(__WEBPACK_IMPORTED_MODULE_8__utils__["b" /* getOrdinalSuffixWithElement */])(t(name)));}});return renderBtn;},_this.handleClickSection=function(key){_this.setState({currentSection:key});},_this.createimageImage=function(){var data=_this.props.data;var currentSection=_this.state.currentSection;var dataVirtual=__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(data[0],"buttons["+currentSection+"].image360");return __WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(dataVirtual,function(item,key){var translateAdd="translate("+item.x+","+item.y+")";// const currentImageIndex = _.get(item, "currentIndex", 0);
var currentImageIndex=key;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("g",{key:key,transform:translateAdd},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("radialGradient",{id:"grad1",x1:"0%",y1:"0%",x2:"100%",y2:"0%"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("stop",{offset:"10%",style:{stopColor:"#666666",stopOpacity:1}}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("stop",{offset:"90%",style:{stopColor:"#7f7e7e",stopOpacity:0.2}})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(AnimatedBubble,null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("circle",{cx:0,cy:0,r:"55",stroke:"#666666","stroke-width":"0",fill:"url(#grad1)",opacity:"1",onClick:function onClick(){return _this.handleClickImage(currentImageIndex);}})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("g",{className:"animatedBubble"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("circle",{cx:0,cy:0,r:"30",stroke:"#666666","stroke-width":"3",fill:"#666666",onClick:function onClick(){return _this.handleClickImage(currentImageIndex);}}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("image",{xlinkHref:"/assets/images/icon-image.png",x:-22,y:-23,width:45,height:45,onClick:function onClick(){return _this.handleClickImage(currentImageIndex);}})));});},_this.createimage360=function(){var data=_this.props.data;var currentSection=_this.state.currentSection;var dataVirtual=__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(data[0],"buttons["+currentSection+"].imageVirtual");return __WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(dataVirtual,function(item,key){var translateAdd="translate("+item.x+","+item.y+")";return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("g",{transform:translateAdd},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("radialGradient",{id:"grad1",x1:"0%",y1:"0%",x2:"100%",y2:"0%"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("stop",{offset:"10%",style:{stopColor:"#666666",stopOpacity:1}}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("stop",{offset:"90%",style:{stopColor:"#7f7e7e",stopOpacity:0.2}})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(AnimatedBubble,null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("circle",{cx:0,cy:0,r:"55",stroke:"#666666","stroke-width":"0",fill:"url(#grad1)",opacity:"1",onClick:function onClick(){return _this.handleClick360(item.path);}})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("g",{className:"animatedBubble"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("circle",{cx:0,cy:0,r:"30",stroke:"#666666","stroke-width":"3",fill:"#666666",onClick:function onClick(){return _this.handleClick360(item.path);}}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("image",{xlinkHref:"/assets/images/icon-360.png",x:-23,y:-20,width:45,height:45,onClick:function onClick(){return _this.handleClick360(item.path);}})));});},_this.createDisclaimer=function(){var _this$props2=_this.props,data=_this$props2.data,t=_this$props2.t;var currentSection=_this.state.currentSection;var dataDisclaimer=__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(data[0],"buttons["+currentSection+"].disclaimer");console.log("createDisclaimer",{data:data,dataDisclaimer:dataDisclaimer,lang:t(dataDisclaimer)});return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:"disclaimer"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("p",null,t(dataDisclaimer)));},_this.handleClickImage=function(key){console.log("TypeResidences - handleClickImage >>>> ",key);_this.setState({showImageModal:true,currentImage:key});},_this.handleClick360=function(path){_this.setState({showVirtualModal:true,currentURL:path});},_this.handleCloseModal=function(){_this.setState({showImageModal:false,showVirtualModal:false,currentImage:0});},_this.gotoPrevious=function(){_this.setState({currentImage:_this.state.currentImage-1});},_this.gotoNext=function(){_this.setState({currentImage:_this.state.currentImage+1});},_this.gotoImage=function(index){_this.setState({currentImage:index});},_temp),_possibleConstructorReturn(_this,_ret);}// x: PT.arrayOf(PT.number),
// y: PT.arrayOf(PT.number)
_createClass(TypeResidences,[{key:"componentWillMount",value:function componentWillMount(){this.setState({currentSection:0});}},{key:"componentWillReceiveProps",value:function componentWillReceiveProps(nextProps){// console.log('componentWillReceiveProps >>>> ', nextProps);
if(this.state.currentSection!==nextProps.currentSection){this.setState({currentSection:nextProps.currentSection});}}},{key:"render",value:function render(){var _state=this.state,currentSection=_state.currentSection,showImageModal=_state.showImageModal,showVirtualModal=_state.showVirtualModal,currentImage=_state.currentImage,currentURL=_state.currentURL;var _props=this.props,data=_props.data,viewBox=_props.viewBox,t=_props.t;var title=__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(data[0],"name");// _.get(data[0], `buttons[${currentSection}].name`);
var des=__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(data[0],"buttons["+currentSection+"].description");var sizeImage=__WEBPACK_IMPORTED_MODULE_0_lodash_size___default()(__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(data[0],"buttons["+currentSection+"].image360"));var sizeVirtual=__WEBPACK_IMPORTED_MODULE_0_lodash_size___default()(__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(data[0],"buttons["+currentSection+"].imageVirtual"));console.log("TypeResidences",data[0]);return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:"section-typeresidence"},currentSection===0&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:"section-typeresidence-crossimage"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components__["p" /* Slider */],{type:"type-background",items:this.createSliderData(),uiRenderer:function uiRenderer(item,index){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{key:index,className:"img-background",style:{backgroundImage:"url("+item.image+")",backgroundPosition:__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(item,"backgroundPosition","center center")}});}}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:"typeresidence-alpha"}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:"typeresidence-container-des title"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:"typeresidence-title"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("h2",null,t(title))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:"typeresidence-des"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("h3",{style:{color:"#000000"}},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{dangerouslySetInnerHTML:{__html:t(des)}}))))),currentSection!==0&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:"typeresidence-containall"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:"typeresidence-container-imgtype"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("svg",{// style={{ fill: "transparent", paddingTop: 50 }}
style:{fill:"transparent",paddingBottom:80}// style={{ fill: "transparent", paddingBottom: 100 }}
// width="80%"
// height="80%"
,viewBox:viewBox.x+" "+viewBox.y+" "+viewBox.width+" "+viewBox.height},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("image",{className:"typeresidence-imgtype",xlinkHref:t(__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(data[0],"buttons["+currentSection+"].floorPlan")),x:0,y:0,width:1920,height:1080}),this.createimageImage(),this.createimage360()),this.createDisclaimer()),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:"typeresidence-container-des"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:"typeresidence-title title"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("h2",{style:{color:"#000000",fontSize:"18px"}},t(title)))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:"typeresidence-label"},sizeImage>0&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:"typeresidence-labelmock"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:"typeresidence-blocklabel"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("img",{style:{width:"60%",height:"auto"},src:"/assets/images/icon-image.png",alt:""})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:"typeresidence-text black"},t("View Images"))),sizeVirtual>0&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:"typeresidence-labelmock"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:"typeresidence-blocklabel"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("img",{style:{width:"60%",height:"auto"},src:"/assets/images/icon-360.png",alt:""})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:"typeresidence-text black"},t("Virtual Tour"))))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:"typeresidence-container-btn"},this.createBtn()),showImageModal&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components__["k" /* Modal */],{name:"typeresidence-modal",onCancel:this.handleCloseModal},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_GalleryLightbox__["a" /* default */],{currentImage:currentImage,images:__WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(data[0],"buttons["+currentSection+"].images"),function(value){return{src:__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(value,"image"),caption:""};}),onClickPrev:this.gotoPrevious,onClickNext:this.gotoNext,onClickThumbnail:this.gotoImage})),showVirtualModal&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components__["k" /* Modal */],{name:"residences-virtual-modal",onCancel:this.handleCloseModal},currentURL?__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("iframe",{title:"tour",src:currentURL,width:"100%",height:"100%"}):__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__containers__["a" /* ComingSoon */],null)));}}]);return TypeResidences;}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]),_class.propTypes={data:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.shape()),viewBox:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.object.isRequired,t:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func,currentSection:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.number},_class.defaultProps={data:[],viewBox:{x:0,y:0,width:1920,height:1080},t:function t(){},currentSection:0},_temp2);/* harmony default export */ __webpack_exports__["a"] = (TypeResidences);

/***/ }),
/* 713 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(27);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-transform: uppercase;\n  font-size: 30px;\n"],["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-transform: uppercase;\n  font-size: 30px;\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Div=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject);var TypeResidenceVirtual=function(_PureComponent){_inherits(TypeResidenceVirtual,_PureComponent);function TypeResidenceVirtual(){_classCallCheck(this,TypeResidenceVirtual);return _possibleConstructorReturn(this,(TypeResidenceVirtual.__proto__||Object.getPrototypeOf(TypeResidenceVirtual)).apply(this,arguments));}_createClass(TypeResidenceVirtual,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Div,null,"Coming Soon virtual");}}]);return TypeResidenceVirtual;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);/* unused harmony default export */ var _unused_webpack_default_export = (TypeResidenceVirtual);

/***/ }),
/* 714 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return EbrochureDownload; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__containers__ = __webpack_require__(82);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  background: #f4f4f5;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 30px;\n"],["\n  width: 100%;\n  height: 100%;\n  background: #f4f4f5;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  font-size: 30px;\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Div=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject);var EbrochureDownload=function(_PureComponent){_inherits(EbrochureDownload,_PureComponent);function EbrochureDownload(){_classCallCheck(this,EbrochureDownload);return _possibleConstructorReturn(this,(EbrochureDownload.__proto__||Object.getPrototypeOf(EbrochureDownload)).apply(this,arguments));}_createClass(EbrochureDownload,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Div,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__containers__["c" /* EbrochureForm */],this.props));}}]);return EbrochureDownload;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]);

/***/ }),
/* 715 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_socialLink_logo_fb_png__ = __webpack_require__(716);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__images_socialLink_logo_fb_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__images_socialLink_logo_fb_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_socialLink_logo_yb_png__ = __webpack_require__(717);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__images_socialLink_logo_yb_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__images_socialLink_logo_yb_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_socialLink_logo_weibo_png__ = __webpack_require__(718);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__images_socialLink_logo_weibo_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__images_socialLink_logo_weibo_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_socialLink_logo_youku_png__ = __webpack_require__(719);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__images_socialLink_logo_youku_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6__images_socialLink_logo_youku_png__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SocialLink=(_temp=_class=function(_PureComponent){_inherits(SocialLink,_PureComponent);function SocialLink(){_classCallCheck(this,SocialLink);return _possibleConstructorReturn(this,(SocialLink.__proto__||Object.getPrototypeOf(SocialLink)).apply(this,arguments));}_createClass(SocialLink,[{key:"render",value:function render(){var items=this.props.items;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"social-link"},__WEBPACK_IMPORTED_MODULE_0_lodash_map___default()(items,function(item,key){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a",{href:item.link,key:item.value},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{src:item.icon,alt:"icon"}));}));}}]);return SocialLink;}(__WEBPACK_IMPORTED_MODULE_1_react__["PureComponent"]),_class.propTypes={items:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.shape({icon:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,line:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,value:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string}))},_class.defaultProps={items:[{icon:__WEBPACK_IMPORTED_MODULE_3__images_socialLink_logo_fb_png___default.a,link:"https://www.facebook.com/BanyanTreeGroupProperty",value:"facebook"},{icon:__WEBPACK_IMPORTED_MODULE_4__images_socialLink_logo_yb_png___default.a,link:"https://www.youtube.com/channel/UChnfjiLt9Qd1e5DPP0UfymA/videos",value:"youtube"},{icon:__WEBPACK_IMPORTED_MODULE_5__images_socialLink_logo_weibo_png___default.a,link:"https://www.weibo.com/p/1006062680069283/home?from=page_100606&mod=TAB#place",value:"weibo"},{icon:__WEBPACK_IMPORTED_MODULE_6__images_socialLink_logo_youku_png___default.a,link:"http://i.youku.com/i/UMTgyNTkxNzYyOA==",value:"youku"}]},_temp);/* harmony default export */ __webpack_exports__["a"] = (SocialLink);

/***/ }),
/* 716 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABEAAAATBAMAAACEi/vCAAAAHlBMVEVHcEwAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAABaVcReAAAACnRSTlMAgFsyC1MdJnYGOYTIQQAAADpJREFUCNdjYMAB2IwToCxFwQAIg1kQxmIVNHGAsJgEYRrgLCYNQSUDMItRUFAQwSrAqYMMFqcLiAQA+MoEqHfphI8AAAAASUVORK5CYII="

/***/ }),
/* 717 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABcAAAATCAMAAABMZWaEAAAAkFBMVEVHcEz5+fmdnZ2WlpaPj4+jo6OTk5P///////+MjIyGhobAwMD///+tra2oqKi1tbX////JycmYmJijo6PMzMz////09PTQ0NDCwsLLy8vt7e39/f2ampp/f3+AgID///99fX15eXlzc3N2dnZlZWVvb29ra2tubm5oaGhcXFx4eHjV1dXq6uq7u7tfX1+Hh4cS89C3AAAAHXRSTlMA/vz6+fr7eYD58vRz9/L58vby8vzlgICAgIDx8neVflsAAADcSURBVBjTdZHbcoMgFEUPCFRr1Nx7FZCbaE36/39XFDXJTLqemLVnOJwNbF4e2UBkK45VQSlOGCGEJZiWRbXbnkDgq/HOWaVHVOucN1eGYNdJXj/CZZdDYaLmVq85NyVQNx1ljbmvl6T9hkRFb4eBGTUHmkDWR9/+CHHRnk9J8wpZc/MCVUo+8+IyeR48ubvnKOfRwbN5bjsgbOwyN1vfKemvWTe0+7u91G0vf3jaQx16QElnxtb6ZqTXyjrfEQRfKKeYkSwSmt4fyjz0nKbp58f72zldmP/ln//6A4xUKJurw6+HAAAAAElFTkSuQmCC"

/***/ }),
/* 718 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAABUAAAATCAMAAABIkLa5AAAAS1BMVEUAAABxcXHn5+f7+/tkZGTGxsarq6v///////8oKCg9PT2hoaF9fX1ISEje3t4FBQX09PQZGRmKiopbW1sMDAy5ubmXl5fa2tpPT09BLDcXAAAAGXRSTlOAgICAf4CAgHmAgH+Af395gICAgICAgHx8LjyngwAAAMhJREFUGBlVwQlywjAQAMGxJXlWvk/g/y+NIVUp0o3/rb4RfrmAYzYIv5Q+V7iC8KNr9uQtOcNMeBsq8FBHzjQzEWrmrXOdy7WdTguhEx9N3qjrzNothBNfjrZP/ULs3Grex6MCozq9eAL56cdVqaMaZBh06OvRaqrQJ4OFRjO3bdUO6AwWWgvT0VQ6LcBgsNA6ohWKjkBrMJBtz7GBlxZg0CAy2XU6+0EfwK4G4YOz6bqrNEBfvAWhae+3Ddia4kfgr3Zuk39+ANdBCq00pE9oAAAAAElFTkSuQmCC"

/***/ }),
/* 719 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAACsAAAATCAMAAAA+qgQyAAABO1BMVEVHcEzJycnj4+PJycmnp6fl5eV8fHy/v7+9vb12dnZ4eHh/f3+srKze3t7b29uamprn5+erq6t3d3dxcXGWlpavr6/T09NtbW2Hh4fQ0NCUlJSTk5OYmJiYmJiTk5OKiop5eXnY2Njc3Ny/v79jY2N4eHijo6O+vr59fX12dna/v79/f3/Ly8uLi4ugoKCAgICtra2EhIR/f3+5ubnCwsKdnZ2ampqLi4ujo6OHh4d0dHSMjIxqampdXV2Ojo6qqqqCgoJra2uhoaGTk5ODg4OYmJiKiora2tqlpaVvb2+bm5ukpKS5ubmbm5vt7e16enq4uLhycnKkpKRhYWF3d3fFxcVgYGCEhIReXl5lZWVbW1tgYGBubm5XV1d0dHRsbGxiYmJqampwcHBVVVVra2tnZ2dQUFBHR0dNTU2iHdghAAAAWHRSTlMANiBPnAP4XUnq89GWDxu/Fo3Y+ryBPNS4Qa6bKbbHrv0pMFbe4Ah+xvtB21bTqOxr18JOMbSEyavQ98Pl791hvfwakOQY5QiH65+kic0H6Ha7vL+iZcD10Amj4QAAAVRJREFUGBndwcVaG1EAgNE/ySQzE0+IB3d3TYvVBWnRe8ctgfd/AiCwYcPHoquew39taF8FivrPTZKDg7zJ8lKAYnQ1VfejTILa3wQUy8uL9So069nregLymRZQEp5KMiWGT4SxpofR2PZdBTbMTtmbJBH00nt3y7AhfCDnGEuoZvA7Zc7ARdhoG7ugRVOzfku17NvNK5EFze3wSDGC+JCx9MNcAWoyvSZ2QfOn1p1U4O0kuZFZ0NwOj/KW9WVUTMzbK0BTpjNCgZirzzpzXbkX59IrQcwa4EnBtCKH79LMkjsNW+2wAKpYGDG3Fl070NphBValw5PasSMUmDHsOdeW8XFbNn454ern+2/EzntuNRA7W35Poe/Ai+LA4dFoemQe/pR9qVeZmCxBsZE5a6673YVt+sYHjAJ9SZ59/cQr09O8qAgZ433yrj3MO+U+fBzjX3sAcuY9kbKDXU8AAAAASUVORK5CYII="

/***/ }),
/* 720 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_find__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_size__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_size___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_size__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_findIndex__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isBoolean__ = __webpack_require__(721);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isBoolean___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isBoolean__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_replace__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_replace___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_replace__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isEqual__ = __webpack_require__(168);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isEqual___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_isEqual__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_get__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_transition_group_Transition__ = __webpack_require__(722);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_react_transition_group_Transition___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_react_transition_group_Transition__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_router_dom__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_jquery__ = __webpack_require__(724);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_jquery___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_jquery__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_scroll__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_react_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_react_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__hoc__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils_navigation__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__icons_ArrowDown__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__icons_ArrowUp__ = __webpack_require__(313);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__BackgroundImage__ = __webpack_require__(314);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__List__ = __webpack_require__(315);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__ListItem__ = __webpack_require__(732);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__HamburgerIcon__ = __webpack_require__(733);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp2;function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var durationEnter=200;var durationExit=1000;var defaultStyle={transition:"opacity "+durationEnter+"ms ease-in-out",opacity:0};var transitionStyles={entering:{opacity:0},entered:{opacity:1},exiting:{transition:"opacity "+durationExit+"ms ease-in-out"}};var Header=(_temp2=_class=function(_Component){_inherits(Header,_Component);function Header(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Header);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Header.__proto__||Object.getPrototypeOf(Header)).call.apply(_ref,[this].concat(args))),_this),_this.state={subHeaderScrollLeft:0,showSubHeaderRightArrow:true,scrollValue:200,offset:86,isLg:false,isSm:false,small:false,showMenu:false},_this.leftMenus=[{label:"The Santuary Club",key:"sanctuary-club"},{label:"Resales",key:"resale"},{label:"Rentals",key:"rental"}],_this.rightMenus=[{label:"News/Promotions",key:"news"},{label:"About us",key:"about-us"},{label:"Contact",key:"contact-us"}],_this.lastScrollY=0,_this.animating=false,_this.componentDidMount=function(){_this.sections=document.querySelectorAll(".main-content section");_this.firstSection=_this.sections[0];_this.lastSection=_this.sections[_this.sections.length-1];_this.btnUp=document.querySelector(".button-scroll-to-section.up");_this.btnDown=document.querySelector(".button-scroll-to-section.down");window.addEventListener("scroll",_this.handleScrollPage);window.addEventListener("resize",_this.updateDimensions);// window.addEventListener("hashchange", this.closeDrawer);
// window.addEventListener("wheel", this.handleMouseWheel);
__WEBPACK_IMPORTED_MODULE_13_react_scroll__["scrollSpy"].update();_this.updateDimensions();// Check hash, if there is hash then scroll to that section
if(window.location.hash===""){__WEBPACK_IMPORTED_MODULE_12_jquery___default()("html, body").stop().animate({scrollTop:1},10).animate({scrollTop:0},10);// trigger scroll to hilight 'gallery'
}},_this.componentDidUpdate=function(prevProps,prevState,snapshot){if(prevState.subHeaderScrollLeft!==_this.state.subHeaderScrollLeft){// document.getElementById('sub-header').scrollLeft = this.state.subHeaderScrollLeft;
__WEBPACK_IMPORTED_MODULE_12_jquery___default()(".sub-header").stop().animate({scrollLeft:_this.state.subHeaderScrollLeft},300);}if(__WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(prevState,"location.hash")!==__WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(_this.state,"location.hash")){var hash=_this.state.location.hash.substr(1);_this.scrollToSection(hash);}},_this.componentWillUnmount=function(){window.removeEventListener("scroll",_this.handleScrollPage);window.removeEventListener("resize",_this.updateDimensions);},_this.getSnapshotBeforeUpdate=function(prevProps,prevState){return{};},_this.updateDimensions=function(){var width=window.innerWidth;var offset=-90;if(width>768)offset=-152;if(width>1200)offset=-86;if(_this.state.offset!==offset)_this.setState({offset:offset});},_this.getBaseHref=function(){var key=arguments.length>0&&arguments[0]!==undefined?arguments[0]:"base";var language=_this.props.language;var map={base:"https://lagunaproperty.com"+"/"+language,bintan:""+"http://bintan.lagunaproperty.com",phuketDusitDeluxePoolVilla:"/"+language+"/projects/phuket/dusit-laguna-resort-villas-phuket",phuketLagunaPark:"/"+language+"/project/phuket/laguna-park",phuketVillageResidences:"/"+language+"/projects/phuket/laguna-village-residences",phuketLagunaPark2:"/"+language+"/projects/phuket/laguna-park-2",langco:"http://www.lagunalangco.com"+"/"+language,skypark:"/"+language+"/projects/phuket/skypark",lagunaBeachSide:"/"+language+"/projects/phuket/laguna-beachside",lagunaLakesideResidences:"/"+language+"/projects/phuket/laguna-lakeside-residences",lagunaSeasideResidences:"/"+language+"/projects/phuket/laguna-seaside-residences"};return map[key];},_this.handleScrollPage=function(){// this.lastScrollY = window.scrollY;
var pageYOffset=window.pageYOffset||document.documentElement.scrollTop;_this.lastScrollY=pageYOffset;var small=false;if(_this.lastScrollY>30){small=true;}_this.setState({small:small});var sectionIndex=_this.getSectionIndex();// console.log('getSectionIndex', sectionIndex);
// const isFirstSection = sectionIndex === 0;
// const isLastSection = sectionIndex + 1 === this.props.projectSections.length;
if(sectionIndex!==-1){// Show / Hide Button Up & Down
if(pageYOffset>0.5*_this.firstSection.offsetHeight){// if (!isFirstSection) {
// console.log('show top bottom');
_this.btnUp.classList.remove("hide");}else{// console.log('hide top bottom');
_this.btnUp.classList.add("hide");}// console.log('pageYOffset', pageYOffset);
// console.log('window.innerHeight', window.innerHeight);
// console.log('document.body.scrollHeight', document.body.scrollHeight);
// console.log('pageYOffset + window.innerHeight - document.body.scrollHeight', pageYOffset + window.innerHeight - document.body.scrollHeight);
if(document.body.scrollHeight-(pageYOffset+window.innerHeight)>=40){// if (!isLastSection) {
// console.log('show down bottom');
_this.btnDown.classList.remove("hide");}else{// console.log('hide down bottom');
_this.btnDown.classList.add("hide");}}},_this.setSubheaderScrollHorizontalPosition=function(scrollLeft){var subheader=document.getElementById("sub-header");var scrollWidth=subheader.scrollWidth,offsetWidth=subheader.offsetWidth;var showSubHeaderRightArrow=scrollWidth-(scrollLeft+offsetWidth)>_this.state.scrollValue;_this.setState({subHeaderScrollLeft:scrollLeft,showSubHeaderRightArrow:showSubHeaderRightArrow});},_this.handleClickSubMenuRightArrow=function(){// Get current Scroll;
var subheader=document.getElementById("sub-header");var scrollLeft=subheader.scrollLeft;_this.setSubheaderScrollHorizontalPosition(scrollLeft+_this.state.scrollValue);},_this.handleSetActive=function(to){var navElem=document.getElementById("nav-"+to);if(navElem){var navElemLeft=navElem.offsetLeft;var navElemWidth=navElem.offsetWidth;var windowWidth=window.innerWidth;var posLeft=-(0.5*windowWidth)+navElemLeft+0.5*navElemWidth;_this.setSubheaderScrollHorizontalPosition(posLeft);}},_this.handleSubHeaderScroll=function(e){var subheader=document.getElementById("sub-header");var scrollLeft=subheader.scrollLeft,scrollWidth=subheader.scrollWidth,offsetWidth=subheader.offsetWidth;var showSubHeaderRightArrow=scrollWidth-(scrollLeft+offsetWidth)>_this.state.scrollValue;_this.setState({showSubHeaderRightArrow:showSubHeaderRightArrow});},_this.handleSwitchLanguage=function(e){var _this$props=_this.props,language=_this$props.language,location=_this$props.location;var pathname=location.pathname;var nextLanguage=e.target.lang;// console.log(pathname, language, nextLanguage)
var nextUrl=__WEBPACK_IMPORTED_MODULE_5_lodash_replace___default()(pathname,"/"+language+"/","/"+nextLanguage+"/");_this.props.history.push(nextUrl);},_this.toggleShowMenu=function(target){var showMenu=__WEBPACK_IMPORTED_MODULE_4_lodash_isBoolean___default()(target)?target:!_this.state.showMenu;// console.log('showMenu', showMenu);
var overflow=showMenu?"hidden":"auto";document.body.style.overflow=overflow;_this.setState({showMenu:showMenu});},_this.scrollToSection=function(sectionId){// if (this.animating === false) {
var offset=_this.state.offset;// this.animating = true;
// const _self = this;
// Events.scrollEvent.register('end', function(to, element) {
//   _self.animating = false;
//   Events.scrollEvent.remove('end');
// });
__WEBPACK_IMPORTED_MODULE_13_react_scroll__["scroller"].scrollTo(sectionId,{duration:1000,delay:100,smooth:true,offset:offset// Scrolls to element + 50 pixels down the page
});// }
},_this.getSectionIndex=function(){var hash=window.location.hash.substr(1);var sections=_this.props.projectSections;var sectionIndex=__WEBPACK_IMPORTED_MODULE_3_lodash_findIndex___default()(sections,function(section){return section.key===hash;});return sectionIndex;},_this.getCurrentSection=function(){var hash=window.location.hash.substr(1);var sections=_this.props.projectSections;var sectionIndex=__WEBPACK_IMPORTED_MODULE_3_lodash_findIndex___default()(sections,function(section){return section.key===hash;});var section=sections[sectionIndex];return document.getElementById(section.key);},_this.atTopOfSection=function(){var section=_this.getCurrentSection();var pageYOffset=window.pageYOffset||document.documentElement.scrollTop;// pageScroll
var headerHeight=Object(__WEBPACK_IMPORTED_MODULE_16__utils_navigation__["a" /* getHeaderHeight */])();// const sectionHeight = section.offsetHeight;
var sectionTop=section.offsetTop;// const windowHeight = window.innerHeight;
// console.log('pageYOffset', pageYOffset);
// console.log('sectionHeight', sectionHeight);
// console.log('sectionTop', sectionTop);
// console.log('windowHeight', windowHeight);
// console.log('pageYOffset + headerHeight, sectionTop', pageYOffset + headerHeight, sectionTop, pageYOffset + headerHeight === sectionTop)
return pageYOffset+headerHeight-sectionTop<10;},_this.atBottomOfSection=function(){var section=_this.getCurrentSection();var pageYOffset=window.pageYOffset||document.documentElement.scrollTop;// pageScroll
var sectionHeight=section.offsetHeight;var sectionTop=section.offsetTop;var windowHeight=window.innerHeight;// console.log('pageYOffset', pageYOffset);
// console.log('sectionHeight', sectionHeight);
// console.log('sectionTop', sectionTop);
// console.log('windowHeight', windowHeight);
// console.log('pageYOffset + windowHeight, sectionTop + sectionHeight', pageYOffset + windowHeight, sectionTop + sectionHeight, (pageYOffset + windowHeight) - (sectionTop + sectionHeight) < 10);
return sectionTop+sectionHeight-(pageYOffset+windowHeight)<10;},_this.handleScrollUp=function(){var hash=window.location.hash.substr(1);var sections=_this.props.projectSections;var sectionIndex=__WEBPACK_IMPORTED_MODULE_3_lodash_findIndex___default()(sections,function(section){return section.key===hash;});// console.log('sectionIndex', sectionIndex);
var prevSection=sections[sectionIndex-1];if(prevSection)_this.scrollToSection(prevSection.key);},_this.handleScrollDown=function(){var hash=window.location.hash.substr(1);var sections=_this.props.projectSections;var sectionIndex=__WEBPACK_IMPORTED_MODULE_3_lodash_findIndex___default()(sections,function(section){return section.key===hash;});var nextIndex=hash?sectionIndex+1:1;var nextSection=sections[nextIndex];if(nextSection){_this.scrollToSection(nextSection.key);return;}// no next Section, try to scroll to bottom
__WEBPACK_IMPORTED_MODULE_13_react_scroll__["animateScroll"].scrollToBottom();},_this.handleClickSubMenuItem=function(subMenu){console.log("handleClickSubMenuItem",subMenu);var _this$props2=_this.props,history=_this$props2.history,location=_this$props2.location;history.push(location.pathname+"?currentSection="+subMenu.currentSection);},_this.renderSubHeader=function(){var _this$state=_this.state,offset=_this$state.offset,showSubHeaderRightArrow=_this$state.showSubHeaderRightArrow;var _this$props3=_this.props,subLogo=_this$props3.subLogo,projectSections=_this$props3.projectSections,t=_this$props3.t;// console.log("renderSubHeader", projectSections);
return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{className:"sub-header",id:"sub-header",onScroll:_this.handleSubHeaderScroll},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("a",{className:"item logo"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("img",{className:"sub-logo",src:subLogo,alt:"Logo"})),projectSections.map(function(subMenu,key){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{className:"item item-"+subMenu.key+" "+(subMenu.hideOnMobile?"d-none d-md-flex":"")+" ",id:"nav-"+subMenu.key,key:"item-"+subMenu.key},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_scroll__["Link"],{id:"nav-"+subMenu.key,key:"nav-"+subMenu.key,activeClass:"is-current",className:"item sub",to:subMenu.key,spy:true,hashSpy:true// containerId={subMenu.key}
,smooth:true,duration:500,isDynamic:true,ignoreCancelEvents:true,offset:offset,onSetActive:_this.handleSetActive},t(subMenu.label)),__WEBPACK_IMPORTED_MODULE_2_lodash_size___default()(subMenu.subitem)>0&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{className:"item container",id:"nav-sub-"+subMenu.key},__WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(subMenu.subitem,function(eachItem,key){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13_react_scroll__["Link"],{id:"nav-"+subMenu.key,key:"nav-sub-"+key,activeClass:"is-current",className:"item subitem",to:subMenu.key,spy:true,hashSpy:true// containerId={subMenu.key}
,smooth:true,duration:500,isDynamic:true,ignoreCancelEvents:true,offset:offset,onSetActive:_this.handleSetActive,onClick:function onClick(){return _this.handleClickSubMenuItem(eachItem);}},t(eachItem.label));})));})),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__BackgroundImage__["a" /* default */],{onClick:_this.handleClickSubMenuRightArrow,className:"scroll",style:{opacity:showSubHeaderRightArrow?1:0},image:Object(__WEBPACK_IMPORTED_MODULE_15__utils__["a" /* assetsPath */])()+"/images/icon/rightscroll.svg",position:"right center",repeat:"no-repeat",size:"auto 80%"}));},_this.closeDrawer=function(){return _this.toggleShowMenu(false);},_this.goto=function(to){_this.closeDrawer();_this.props.history.push(to);},_this.renderProjectDrawerMenu=function(key,label,baseUrl){// const residenseItems = key === 'laguna-park-2' ? [
//   <ListItem text={this.renderContent({
//     en: 'TOWNHOME',
//     ru: 'Таунхаусы',
//     cn: '联排别墅',
//   })} className="list-item-project-subpage" to={`${baseUrl}/#townhome`} />,
//   <ListItem text={this.renderContent({
//     en: 'VILLA',
//     ru: 'Виллы',
//     cn: '独栋别墅',
//   })} className="list-item-project-subpage" to={`${baseUrl}/#villa`} />,
// ] : [];
return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__ListItem__["a" /* default */],{text:label,className:"list-item-project",key:baseUrl,to:baseUrl,items:key!=="skypark"&&[__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__ListItem__["a" /* default */],{key:"gallery",text:"Gallery",className:"list-item-project-page",to:baseUrl+"/#gallery",showChildren:true,showToggleIcon:false,items:[__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__ListItem__["a" /* default */],{key:"images",text:"Images",className:"list-item-project-subpage",onClick:function onClick(){return _this.goto(baseUrl+"/#images");}}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__ListItem__["a" /* default */],{key:"video",text:"Video",className:"list-item-project-subpage",onClick:function onClick(){return _this.goto(baseUrl+"/#video");}})]}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__ListItem__["a" /* default */],{key:"concept",text:"Concept",className:"list-item-project-page",onClick:function onClick(){return _this.goto(baseUrl+"/#concept");}}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__ListItem__["a" /* default */],{key:"masterplan",text:"Master plan",className:"list-item-project-page",onClick:function onClick(){return _this.goto(baseUrl+"/#masterplan");}}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__ListItem__["a" /* default */],{key:"siteplan",text:"Site plan",className:"list-item-project-page",onClick:function onClick(){return _this.goto(baseUrl+"/#siteplan");}}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__ListItem__["a" /* default */],{key:"residences",text:"Residences",className:"list-item-project-page",onClick:function onClick(){return _this.goto(baseUrl+"/#residences");},showChildren:true// items={residenseItems}
}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__ListItem__["a" /* default */],{key:"residences",text:"Destination",className:"list-item-project-page",onClick:function onClick(){return _this.goto(baseUrl+"/#destination");}}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__ListItem__["a" /* default */],{key:"the-sanctuary-club",text:"The Santuary Club",className:"list-item-project-page",onClick:function onClick(){return _this.goto(baseUrl+"/#sanctuary-club");}})]});},_this.renderDrawerMenu=function(){var showMenu=_this.state.showMenu;var language=_this.props.language;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10_react_transition_group_Transition___default.a,{"in":showMenu,timeout:{enter:durationEnter,exit:durationExit},mountOnEnter:true,unmountOnExit:true},function(state){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{className:"navigation active "+(showMenu?"active":""),style:Object.assign({},defaultStyle,transitionStyles[state])},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20__List__["a" /* default */],{transitionDuration:2000,transitionInDelay:200,animState:state},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__ListItem__["a" /* default */],{text:"Locations",showChildren:true,items:[__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__ListItem__["a" /* default */],{key:"bintan",renderText:function renderText(){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong",null,"Bintan"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("span",{className:"secondary"},"Laguna Park"));},className:"list-item-location",to:"http://bintan.lagunaproperty.com"}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__ListItem__["a" /* default */],{key:"phuket",text:"Phuket",className:"list-item-location",items:[_this.renderProjectDrawerMenu("laguna-beachside","Laguna Beachside Residences",_this.getBaseHref("lagunaBeachSide")),_this.renderProjectDrawerMenu("laguna-lakeside-residences","Laguna Lakeside Residences",_this.getBaseHref("lagunaLakesideResidences")),_this.renderProjectDrawerMenu("laguna-seaside-residences","Laguna Seaside Residences",_this.getBaseHref("lagunaSeasideResidences")),_this.renderProjectDrawerMenu("laguna-park","Laguna Parkside Residences",_this.getBaseHref("phuketLagunaPark")),_this.renderProjectDrawerMenu("laguna-park-2","Laguna Park 2",_this.getBaseHref("phuketLagunaPark2")),_this.renderProjectDrawerMenu("laguna-village-residences","Laguna Village Residences",_this.getBaseHref("phuketVillageResidences")),_this.renderProjectDrawerMenu("skypark","Skypark",_this.getBaseHref("skypark"))]}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__ListItem__["a" /* default */],{key:"langco",text:"L\u0102NG C\xD4",renderText:function renderText(){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong",null,"L\u0102NG C\xD4"),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("span",{className:"secondary"},"Laguna Park"));},to:"http://www.lagunalangco.com/en/",className:"list-item-location"})]}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__ListItem__["a" /* default */],{text:"The Santuary Club",to:"/"+language+"/sanctuary-club"}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__ListItem__["a" /* default */],{text:"Resales",to:"/"+language+"/resales"}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__ListItem__["a" /* default */],{text:"Rentals",to:"/"+language+"/rental"}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__ListItem__["a" /* default */],{text:"News/Promotions",to:"/"+language+"/news"}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__ListItem__["a" /* default */],{text:"About us",to:"/"+language+"/about-us"}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_21__ListItem__["a" /* default */],{text:"Contact",to:"/"+language+"/contact"})));});},_this.getLanguageIcon=function(language){var _this$props4=_this.props,languages=_this$props4.languages,currentLanguage=_this$props4.currentLanguage;var targetLanguage=__WEBPACK_IMPORTED_MODULE_0_lodash_find___default()(languages,function(language){return language.key===currentLanguage;});return targetLanguage&&targetLanguage.icon||"";},_this.renderLanguageOption=function(_ref2){var name=_ref2.name,key=_ref2.key,icon=_ref2.icon,rest=_objectWithoutProperties(_ref2,["name","key","icon"]);return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("li",{key:key},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("a",{lang:key,onClick:_this.handleSwitchLanguage},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("img",{alt:"",src:icon}),name));},_this.renderMenu=function(_ref3){var label=_ref3.label,key=_ref3.key;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("a",{key:key,href:_this.getBaseHref()+"/"+key,className:"item"},_this.renderContent(label));},_this.renderContent=function(key){var t=_this.props.t;return t(key);},_temp),_possibleConstructorReturn(_this,_ret);}// ======================================================
// Commit Phase
// Can work with DOM, run side effects, schedule updates.
// ======================================================
// ======================================================
// Pre-commit Phase
// Can read the DOM
// ======================================================
_createClass(Header,[{key:"render",value:function render(){var _props=this.props,mainLogo=_props.mainLogo,hasSubHeader=_props.hasSubHeader,languages=_props.languages,language=_props.language;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("header",{className:""+(this.state.small?"small":"")},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{className:"main-header"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{className:"left"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{className:"item location"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("span",{className:"title"},this.renderContent("Locations")),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{className:"hover-container"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("ul",{className:"list"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("li",{className:"item"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong",null,this.renderContent("Phuket")),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("ul",{className:"location-sub-list"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("li",{className:"item"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("a",{href:this.getBaseHref("lagunaBeachSide"),rel:"noopener noreferrer"},this.renderContent("Laguna Beachside"))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("li",{className:"item"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("a",{href:this.getBaseHref("lagunaLakesideResidences"),rel:"noopener noreferrer"},this.renderContent("Laguna Lakeside Residences"))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("li",{className:"item"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("a",{href:this.getBaseHref("lagunaSeasideResidences"),rel:"noopener noreferrer"},this.renderContent("Laguna Seaside Residences"))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("li",{className:"item"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("a",{href:this.getBaseHref("phuketLagunaPark"),rel:"noopener noreferrer"},this.renderContent("Laguna Park"))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("li",{className:"item"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("a",{href:this.getBaseHref("phuketLagunaPark2"),rel:"noopener noreferrer"},this.renderContent("Laguna Park 2"))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("li",{className:"item"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("a",{href:this.getBaseHref("phuketVillageResidences"),rel:"noopener noreferrer"},this.renderContent("Laguna Village Residences"))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("li",{className:"item"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("a",{href:this.getBaseHref("skypark"),rel:"noopener noreferrer"},this.renderContent("Skypark"))))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("li",{className:"item"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("strong",null,this.renderContent("Lăng Cô")),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("a",{target:"_blank",href:this.getBaseHref("langco"),rel:"noopener noreferrer"},this.renderContent("Laguna Park")))))),this.leftMenus.map(this.renderMenu)),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("a",{href:this.getBaseHref(),className:"item logo"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("img",{className:"main-logo",src:mainLogo,alt:""})),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{className:"right"},this.rightMenus.map(this.renderMenu))),hasSubHeader&&this.renderSubHeader(),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("button",{onClick:this.toggleShowMenu,className:"menu-button"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22__HamburgerIcon__["a" /* default */],{width:42,height:42,open:this.state.showMenu}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("span",null,this.renderContent("Menu"))),this.renderDrawerMenu(),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("a",{href:this.getBaseHref()+"/contact-us",className:"mail-box"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("img",{src:Object(__WEBPACK_IMPORTED_MODULE_15__utils__["a" /* assetsPath */])()+"/images/icon/email.svg",alt:""})),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{className:"language"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("img",{className:"current-lang",alt:"",src:this.getLanguageIcon(language)}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("ul",{className:"list"},languages.map(this.renderLanguageOption)))),hasSubHeader&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{className:"button-scroll-wrapper up"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("button",{onClick:this.handleScrollUp,className:"button-scroll-to-section up"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__icons_ArrowUp__["a" /* default */],{width:40,height:40,fill:"#04a8a6"}))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{className:"button-scroll-wrapper down"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("button",{onClick:this.handleScrollDown,className:"button-scroll-to-section down"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__icons_ArrowDown__["a" /* default */],{width:40,height:40,fill:"#04a8a6"})))));}}],[{key:"getDerivedStateFromProps",// ======================================================
// Render Phase
// Pure and no side effects. May be paused, aborted or restarted by React.
// ======================================================
value:function getDerivedStateFromProps(props,state){// console.log('Header getDerivedStateFromProps', props.location, state.location, !_.isEqual(props.location, state.location));
if(!__WEBPACK_IMPORTED_MODULE_6_lodash_isEqual___default()(props.location,state.location)){return{showMenu:false,location:props.location};}return null;}// ======================================================
// Private Methods
// ======================================================
// handleMouseWheel = event => {
//   console.info(event.wheelDelta);
//   if (event.wheelData < 0) {
//     this.handleScrollDown();
//   } else {
//     this.handleScrollUp();
//   }
// }
// Page Scroll (เอาไว้ทำให้ Header หดลง)
/*
   * Button Scroll Up / Down
   */// handleScroll = (direction) => {
// const sections = document.querySelectorAll('.main-content section');
// let headerHeight = getHeaderHeight();
/*
    const pageYOffset =  window.pageYOffset || document.documentElement.scrollTop;
    _.forEach(sections, (section, sectionIndex) => {
      const stickyTop = section.offsetTop;
      const stickyBottom = stickyTop + section.offsetHeight;
      // console.log('pageYOffset', pageYOffset);
      // console.log('headerHeight', headerHeight);
      // console.log('stickyTop', stickyTop);
      // console.log('stickyBottom', stickyBottom);
      // console.log('pageYOffset + headerHeight >= stickyTop', pageYOffset + headerHeight >= stickyTop);
      // console.log('pageYOffset + headerHeight <= stickyBottom', pageYOffset + headerHeight <= stickyBottom);
      if (pageYOffset + headerHeight >= stickyTop && pageYOffset + headerHeight < stickyBottom) {
        const nextIndex = (direction === 'up') ? sectionIndex - 1 : sectionIndex + 1;
        // console.log('sectionIndex', sectionIndex);
        // console.log('nextIndex', nextIndex);
        const nextSection = sections[nextIndex];
        // console.log('nextSection', nextSection);
        if (nextSection) {
          const scrollTargetValue = (direction === 'up') ? nextSection.offsetTop - headerHeight : nextSection.offsetTop - headerHeight;
          // console.log('scrollTargetValue', scrollTargetValue);
          $('html, body').stop().animate({ scrollTop: scrollTargetValue }, 800); // eslint-disable-line
          return false
        }
        return false
      }
    });
    */// }
// End of Button Scroll Up / Down
}]);return Header;}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]),_class.propTypes={mainLogo:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string.isRequired,subLogo:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string.isRequired,hasSubHeader:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.bool,language:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string.isRequired,languages:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.arrayOf(__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.shape({name:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string.isRequired,key:__WEBPACK_IMPORTED_MODULE_9_prop_types___default.a.string.isRequired}))},_class.defaultProps={mainLogo:"http://lagunaproperty.com/images/flogo_01_h.svg",subLogo:"http://lagunaproperty.com/images/laguna-parkside-residences.png",hasSubHeader:true,languages:[{name:"ENGLISH",key:"en"},{name:"中文",key:"cn"},{name:"РУССКИЙ",key:"ru"}],mainMenus:[{key:"location",label:"Location",items:[]},{key:"sanctuary-club",label:"The Santuary Club"},{key:"resales",label:"Resales"},{key:"rental",label:"Rentals"},{key:"news",label:"News/Promotions"},{key:"about-us",label:"About us"},{key:"contact",label:"Contact"}],projectSections:[{key:"gallery",label:"Gallery"},{key:"concept",label:"Concept"},{key:"masterplan",label:"Master Plan"},{key:"siteplan",label:"Site Plan"},{key:"residences",label:"Residences"},{key:"destination",label:"Destination"},{key:"sanctuary-club",label:"The Santuary Club"},{key:"faq",label:"FAQ"},{key:"e-brochure",label:"E-Brochure"}]},_temp2);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_14__hoc__["a" /* multiLanguage */])()(Object(__WEBPACK_IMPORTED_MODULE_11_react_router_dom__["d" /* withRouter */])(Header)));

/***/ }),
/* 721 */
/***/ (function(module, exports, __webpack_require__) {

var baseGetTag = __webpack_require__(48),
    isObjectLike = __webpack_require__(26);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]';

/**
 * Checks if `value` is classified as a boolean primitive or object.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
 * @example
 *
 * _.isBoolean(false);
 * // => true
 *
 * _.isBoolean(null);
 * // => false
 */
function isBoolean(value) {
  return value === true || value === false ||
    (isObjectLike(value) && baseGetTag(value) == boolTag);
}

module.exports = isBoolean;


/***/ }),
/* 722 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;

var PropTypes = _interopRequireWildcard(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _reactDom = _interopRequireDefault(__webpack_require__(30));

var _reactLifecyclesCompat = __webpack_require__(83);

var _PropTypes = __webpack_require__(723);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = Object.defineProperty && Object.getOwnPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : {}; if (desc.get || desc.set) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; return newObj; } }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }

var UNMOUNTED = 'unmounted';
exports.UNMOUNTED = UNMOUNTED;
var EXITED = 'exited';
exports.EXITED = EXITED;
var ENTERING = 'entering';
exports.ENTERING = ENTERING;
var ENTERED = 'entered';
exports.ENTERED = ENTERED;
var EXITING = 'exiting';
/**
 * The Transition component lets you describe a transition from one component
 * state to another _over time_ with a simple declarative API. Most commonly
 * it's used to animate the mounting and unmounting of a component, but can also
 * be used to describe in-place transition states as well.
 *
 * ---
 *
 * **Note**: `Transition` is a platform-agnostic base component. If you're using
 * transitions in CSS, you'll probably want to use
 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
 * instead. It inherits all the features of `Transition`, but contains
 * additional features necessary to play nice with CSS transitions (hence the
 * name of the component).
 *
 * ---
 *
 * By default the `Transition` component does not alter the behavior of the
 * component it renders, it only tracks "enter" and "exit" states for the
 * components. It's up to you to give meaning and effect to those states. For
 * example we can add styles to a component when it enters or exits:
 *
 * ```jsx
 * import { Transition } from 'react-transition-group';
 *
 * const duration = 300;
 *
 * const defaultStyle = {
 *   transition: `opacity ${duration}ms ease-in-out`,
 *   opacity: 0,
 * }
 *
 * const transitionStyles = {
 *   entering: { opacity: 0 },
 *   entered:  { opacity: 1 },
 * };
 *
 * const Fade = ({ in: inProp }) => (
 *   <Transition in={inProp} timeout={duration}>
 *     {state => (
 *       <div style={{
 *         ...defaultStyle,
 *         ...transitionStyles[state]
 *       }}>
 *         I'm a fade Transition!
 *       </div>
 *     )}
 *   </Transition>
 * );
 * ```
 *
 * There are 4 main states a Transition can be in:
 *  - `'entering'`
 *  - `'entered'`
 *  - `'exiting'`
 *  - `'exited'`
 *
 * Transition state is toggled via the `in` prop. When `true` the component
 * begins the "Enter" stage. During this stage, the component will shift from
 * its current transition state, to `'entering'` for the duration of the
 * transition and then to the `'entered'` stage once it's complete. Let's take
 * the following example (we'll use the
 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
 *
 * ```jsx
 * function App() {
 *   const [inProp, setInProp] = useState(false);
 *   return (
 *     <div>
 *       <Transition in={inProp} timeout={500}>
 *         {state => (
 *           // ...
 *         )}
 *       </Transition>
 *       <button onClick={() => setInProp(true)}>
 *         Click to Enter
 *       </button>
 *     </div>
 *   );
 * }
 * ```
 *
 * When the button is clicked the component will shift to the `'entering'` state
 * and stay there for 500ms (the value of `timeout`) before it finally switches
 * to `'entered'`.
 *
 * When `in` is `false` the same thing happens except the state moves from
 * `'exiting'` to `'exited'`.
 */

exports.EXITING = EXITING;

var Transition =
/*#__PURE__*/
function (_React$Component) {
  _inheritsLoose(Transition, _React$Component);

  function Transition(props, context) {
    var _this;

    _this = _React$Component.call(this, props, context) || this;
    var parentGroup = context.transitionGroup; // In the context of a TransitionGroup all enters are really appears

    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
    var initialStatus;
    _this.appearStatus = null;

    if (props.in) {
      if (appear) {
        initialStatus = EXITED;
        _this.appearStatus = ENTERING;
      } else {
        initialStatus = ENTERED;
      }
    } else {
      if (props.unmountOnExit || props.mountOnEnter) {
        initialStatus = UNMOUNTED;
      } else {
        initialStatus = EXITED;
      }
    }

    _this.state = {
      status: initialStatus
    };
    _this.nextCallback = null;
    return _this;
  }

  var _proto = Transition.prototype;

  _proto.getChildContext = function getChildContext() {
    return {
      transitionGroup: null // allows for nested Transitions

    };
  };

  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
    var nextIn = _ref.in;

    if (nextIn && prevState.status === UNMOUNTED) {
      return {
        status: EXITED
      };
    }

    return null;
  }; // getSnapshotBeforeUpdate(prevProps) {
  //   let nextStatus = null
  //   if (prevProps !== this.props) {
  //     const { status } = this.state
  //     if (this.props.in) {
  //       if (status !== ENTERING && status !== ENTERED) {
  //         nextStatus = ENTERING
  //       }
  //     } else {
  //       if (status === ENTERING || status === ENTERED) {
  //         nextStatus = EXITING
  //       }
  //     }
  //   }
  //   return { nextStatus }
  // }


  _proto.componentDidMount = function componentDidMount() {
    this.updateStatus(true, this.appearStatus);
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var nextStatus = null;

    if (prevProps !== this.props) {
      var status = this.state.status;

      if (this.props.in) {
        if (status !== ENTERING && status !== ENTERED) {
          nextStatus = ENTERING;
        }
      } else {
        if (status === ENTERING || status === ENTERED) {
          nextStatus = EXITING;
        }
      }
    }

    this.updateStatus(false, nextStatus);
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.cancelNextCallback();
  };

  _proto.getTimeouts = function getTimeouts() {
    var timeout = this.props.timeout;
    var exit, enter, appear;
    exit = enter = appear = timeout;

    if (timeout != null && typeof timeout !== 'number') {
      exit = timeout.exit;
      enter = timeout.enter; // TODO: remove fallback for next major

      appear = timeout.appear !== undefined ? timeout.appear : enter;
    }

    return {
      exit: exit,
      enter: enter,
      appear: appear
    };
  };

  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
    if (mounting === void 0) {
      mounting = false;
    }

    if (nextStatus !== null) {
      // nextStatus will always be ENTERING or EXITING.
      this.cancelNextCallback();

      var node = _reactDom.default.findDOMNode(this);

      if (nextStatus === ENTERING) {
        this.performEnter(node, mounting);
      } else {
        this.performExit(node);
      }
    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
      this.setState({
        status: UNMOUNTED
      });
    }
  };

  _proto.performEnter = function performEnter(node, mounting) {
    var _this2 = this;

    var enter = this.props.enter;
    var appearing = this.context.transitionGroup ? this.context.transitionGroup.isMounting : mounting;
    var timeouts = this.getTimeouts();
    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
    // if we are mounting and running this it means appear _must_ be set

    if (!mounting && !enter) {
      this.safeSetState({
        status: ENTERED
      }, function () {
        _this2.props.onEntered(node);
      });
      return;
    }

    this.props.onEnter(node, appearing);
    this.safeSetState({
      status: ENTERING
    }, function () {
      _this2.props.onEntering(node, appearing);

      _this2.onTransitionEnd(node, enterTimeout, function () {
        _this2.safeSetState({
          status: ENTERED
        }, function () {
          _this2.props.onEntered(node, appearing);
        });
      });
    });
  };

  _proto.performExit = function performExit(node) {
    var _this3 = this;

    var exit = this.props.exit;
    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED

    if (!exit) {
      this.safeSetState({
        status: EXITED
      }, function () {
        _this3.props.onExited(node);
      });
      return;
    }

    this.props.onExit(node);
    this.safeSetState({
      status: EXITING
    }, function () {
      _this3.props.onExiting(node);

      _this3.onTransitionEnd(node, timeouts.exit, function () {
        _this3.safeSetState({
          status: EXITED
        }, function () {
          _this3.props.onExited(node);
        });
      });
    });
  };

  _proto.cancelNextCallback = function cancelNextCallback() {
    if (this.nextCallback !== null) {
      this.nextCallback.cancel();
      this.nextCallback = null;
    }
  };

  _proto.safeSetState = function safeSetState(nextState, callback) {
    // This shouldn't be necessary, but there are weird race conditions with
    // setState callbacks and unmounting in testing, so always make sure that
    // we can cancel any pending setState callbacks after we unmount.
    callback = this.setNextCallback(callback);
    this.setState(nextState, callback);
  };

  _proto.setNextCallback = function setNextCallback(callback) {
    var _this4 = this;

    var active = true;

    this.nextCallback = function (event) {
      if (active) {
        active = false;
        _this4.nextCallback = null;
        callback(event);
      }
    };

    this.nextCallback.cancel = function () {
      active = false;
    };

    return this.nextCallback;
  };

  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
    this.setNextCallback(handler);
    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;

    if (!node || doesNotHaveTimeoutOrListener) {
      setTimeout(this.nextCallback, 0);
      return;
    }

    if (this.props.addEndListener) {
      this.props.addEndListener(node, this.nextCallback);
    }

    if (timeout != null) {
      setTimeout(this.nextCallback, timeout);
    }
  };

  _proto.render = function render() {
    var status = this.state.status;

    if (status === UNMOUNTED) {
      return null;
    }

    var _this$props = this.props,
        children = _this$props.children,
        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition


    delete childProps.in;
    delete childProps.mountOnEnter;
    delete childProps.unmountOnExit;
    delete childProps.appear;
    delete childProps.enter;
    delete childProps.exit;
    delete childProps.timeout;
    delete childProps.addEndListener;
    delete childProps.onEnter;
    delete childProps.onEntering;
    delete childProps.onEntered;
    delete childProps.onExit;
    delete childProps.onExiting;
    delete childProps.onExited;

    if (typeof children === 'function') {
      return children(status, childProps);
    }

    var child = _react.default.Children.only(children);

    return _react.default.cloneElement(child, childProps);
  };

  return Transition;
}(_react.default.Component);

Transition.contextTypes = {
  transitionGroup: PropTypes.object
};
Transition.childContextTypes = {
  transitionGroup: function transitionGroup() {}
};
Transition.propTypes =  false ? {
  /**
   * A `function` child can be used instead of a React element. This function is
   * called with the current transition status (`'entering'`, `'entered'`,
   * `'exiting'`, `'exited'`, `'unmounted'`), which can be used to apply context
   * specific props to a component.
   *
   * ```jsx
   * <Transition in={this.state.in} timeout={150}>
   *   {state => (
   *     <MyComponent className={`fade fade-${state}`} />
   *   )}
   * </Transition>
   * ```
   */
  children: PropTypes.oneOfType([PropTypes.func.isRequired, PropTypes.element.isRequired]).isRequired,

  /**
   * Show the component; triggers the enter or exit states
   */
  in: PropTypes.bool,

  /**
   * By default the child component is mounted immediately along with
   * the parent `Transition` component. If you want to "lazy mount" the component on the
   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
   * mounted, even on "exited", unless you also specify `unmountOnExit`.
   */
  mountOnEnter: PropTypes.bool,

  /**
   * By default the child component stays mounted after it reaches the `'exited'` state.
   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
   */
  unmountOnExit: PropTypes.bool,

  /**
   * Normally a component is not transitioned if it is shown when the `<Transition>` component mounts.
   * If you want to transition on the first mount set `appear` to `true`, and the
   * component will transition in as soon as the `<Transition>` mounts.
   *
   * > Note: there are no specific "appear" states. `appear` only adds an additional `enter` transition.
   */
  appear: PropTypes.bool,

  /**
   * Enable or disable enter transitions.
   */
  enter: PropTypes.bool,

  /**
   * Enable or disable exit transitions.
   */
  exit: PropTypes.bool,

  /**
   * The duration of the transition, in milliseconds.
   * Required unless `addEndListener` is provided.
   *
   * You may specify a single timeout for all transitions:
   *
   * ```jsx
   * timeout={500}
   * ```
   *
   * or individually:
   *
   * ```jsx
   * timeout={{
   *  appear: 500,
   *  enter: 300,
   *  exit: 500,
   * }}
   * ```
   *
   * - `appear` defaults to the value of `enter`
   * - `enter` defaults to `0`
   * - `exit` defaults to `0`
   *
   * @type {number | { enter?: number, exit?: number, appear?: number }}
   */
  timeout: function timeout(props) {
    var pt = _PropTypes.timeoutsShape;
    if (!props.addEndListener) pt = pt.isRequired;

    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return pt.apply(void 0, [props].concat(args));
  },

  /**
   * Add a custom transition end trigger. Called with the transitioning
   * DOM node and a `done` callback. Allows for more fine grained transition end
   * logic. **Note:** Timeouts are still used as a fallback if provided.
   *
   * ```jsx
   * addEndListener={(node, done) => {
   *   // use the css transitionend event to mark the finish of a transition
   *   node.addEventListener('transitionend', done, false);
   * }}
   * ```
   */
  addEndListener: PropTypes.func,

  /**
   * Callback fired before the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEnter: PropTypes.func,

  /**
   * Callback fired after the "entering" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool)
   */
  onEntering: PropTypes.func,

  /**
   * Callback fired after the "entered" status is applied. An extra parameter
   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
   *
   * @type Function(node: HtmlElement, isAppearing: bool) -> void
   */
  onEntered: PropTypes.func,

  /**
   * Callback fired before the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExit: PropTypes.func,

  /**
   * Callback fired after the "exiting" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExiting: PropTypes.func,

  /**
   * Callback fired after the "exited" status is applied.
   *
   * @type Function(node: HtmlElement) -> void
   */
  onExited: PropTypes.func // Name the function so it is clearer in the documentation

} : {};

function noop() {}

Transition.defaultProps = {
  in: false,
  mountOnEnter: false,
  unmountOnExit: false,
  appear: false,
  enter: true,
  exit: true,
  onEnter: noop,
  onEntering: noop,
  onEntered: noop,
  onExit: noop,
  onExiting: noop,
  onExited: noop
};
Transition.UNMOUNTED = 0;
Transition.EXITED = 1;
Transition.ENTERING = 2;
Transition.ENTERED = 3;
Transition.EXITING = 4;

var _default = (0, _reactLifecyclesCompat.polyfill)(Transition);

exports.default = _default;

/***/ }),
/* 723 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


exports.__esModule = true;
exports.classNamesShape = exports.timeoutsShape = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
  enter: _propTypes.default.number,
  exit: _propTypes.default.number,
  appear: _propTypes.default.number
}).isRequired]) : null;
exports.timeoutsShape = timeoutsShape;
var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
  enter: _propTypes.default.string,
  exit: _propTypes.default.string,
  active: _propTypes.default.string
}), _propTypes.default.shape({
  enter: _propTypes.default.string,
  enterDone: _propTypes.default.string,
  enterActive: _propTypes.default.string,
  exit: _propTypes.default.string,
  exitDone: _propTypes.default.string,
  exitActive: _propTypes.default.string
})]) : null;
exports.classNamesShape = classNamesShape;

/***/ }),
/* 724 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */
( function( global, factory ) {

	"use strict";

	if ( typeof module === "object" && typeof module.exports === "object" ) {

		// For CommonJS and CommonJS-like environments where a proper `window`
		// is present, execute the factory and get jQuery.
		// For environments that do not have a `window` with a `document`
		// (such as Node.js), expose a factory as module.exports.
		// This accentuates the need for the creation of a real `window`.
		// e.g. var jQuery = require("jquery")(window);
		// See ticket trac-14549 for more info.
		module.exports = global.document ?
			factory( global, true ) :
			function( w ) {
				if ( !w.document ) {
					throw new Error( "jQuery requires a window with a document" );
				}
				return factory( w );
			};
	} else {
		factory( global );
	}

// Pass this if window is not defined yet
} )( typeof window !== "undefined" ? window : this, function( window, noGlobal ) {

// Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
// throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
// arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
// enough that all such attempts are guarded in a try block.
"use strict";

var arr = [];

var getProto = Object.getPrototypeOf;

var slice = arr.slice;

var flat = arr.flat ? function( array ) {
	return arr.flat.call( array );
} : function( array ) {
	return arr.concat.apply( [], array );
};


var push = arr.push;

var indexOf = arr.indexOf;

var class2type = {};

var toString = class2type.toString;

var hasOwn = class2type.hasOwnProperty;

var fnToString = hasOwn.toString;

var ObjectFunctionString = fnToString.call( Object );

var support = {};

var isFunction = function isFunction( obj ) {

		// Support: Chrome <=57, Firefox <=52
		// In some browsers, typeof returns "function" for HTML <object> elements
		// (i.e., `typeof document.createElement( "object" ) === "function"`).
		// We don't want to classify *any* DOM node as a function.
		// Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
		// Plus for old WebKit, typeof returns "function" for HTML collections
		// (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
		return typeof obj === "function" && typeof obj.nodeType !== "number" &&
			typeof obj.item !== "function";
	};


var isWindow = function isWindow( obj ) {
		return obj != null && obj === obj.window;
	};


var document = window.document;



	var preservedScriptAttributes = {
		type: true,
		src: true,
		nonce: true,
		noModule: true
	};

	function DOMEval( code, node, doc ) {
		doc = doc || document;

		var i, val,
			script = doc.createElement( "script" );

		script.text = code;
		if ( node ) {
			for ( i in preservedScriptAttributes ) {

				// Support: Firefox 64+, Edge 18+
				// Some browsers don't support the "nonce" property on scripts.
				// On the other hand, just using `getAttribute` is not enough as
				// the `nonce` attribute is reset to an empty string whenever it
				// becomes browsing-context connected.
				// See https://github.com/whatwg/html/issues/2369
				// See https://html.spec.whatwg.org/#nonce-attributes
				// The `node.getAttribute` check was added for the sake of
				// `jQuery.globalEval` so that it can fake a nonce-containing node
				// via an object.
				val = node[ i ] || node.getAttribute && node.getAttribute( i );
				if ( val ) {
					script.setAttribute( i, val );
				}
			}
		}
		doc.head.appendChild( script ).parentNode.removeChild( script );
	}


function toType( obj ) {
	if ( obj == null ) {
		return obj + "";
	}

	// Support: Android <=2.3 only (functionish RegExp)
	return typeof obj === "object" || typeof obj === "function" ?
		class2type[ toString.call( obj ) ] || "object" :
		typeof obj;
}
/* global Symbol */
// Defining this global in .eslintrc.json would create a danger of using the global
// unguarded in another place, it seems safer to define global only for this module



var version = "3.7.1",

	rhtmlSuffix = /HTML$/i,

	// Define a local copy of jQuery
	jQuery = function( selector, context ) {

		// The jQuery object is actually just the init constructor 'enhanced'
		// Need init if jQuery is called (just allow error to be thrown if not included)
		return new jQuery.fn.init( selector, context );
	};

jQuery.fn = jQuery.prototype = {

	// The current version of jQuery being used
	jquery: version,

	constructor: jQuery,

	// The default length of a jQuery object is 0
	length: 0,

	toArray: function() {
		return slice.call( this );
	},

	// Get the Nth element in the matched element set OR
	// Get the whole matched element set as a clean array
	get: function( num ) {

		// Return all the elements in a clean array
		if ( num == null ) {
			return slice.call( this );
		}

		// Return just the one element from the set
		return num < 0 ? this[ num + this.length ] : this[ num ];
	},

	// Take an array of elements and push it onto the stack
	// (returning the new matched element set)
	pushStack: function( elems ) {

		// Build a new jQuery matched element set
		var ret = jQuery.merge( this.constructor(), elems );

		// Add the old object onto the stack (as a reference)
		ret.prevObject = this;

		// Return the newly-formed element set
		return ret;
	},

	// Execute a callback for every element in the matched set.
	each: function( callback ) {
		return jQuery.each( this, callback );
	},

	map: function( callback ) {
		return this.pushStack( jQuery.map( this, function( elem, i ) {
			return callback.call( elem, i, elem );
		} ) );
	},

	slice: function() {
		return this.pushStack( slice.apply( this, arguments ) );
	},

	first: function() {
		return this.eq( 0 );
	},

	last: function() {
		return this.eq( -1 );
	},

	even: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return ( i + 1 ) % 2;
		} ) );
	},

	odd: function() {
		return this.pushStack( jQuery.grep( this, function( _elem, i ) {
			return i % 2;
		} ) );
	},

	eq: function( i ) {
		var len = this.length,
			j = +i + ( i < 0 ? len : 0 );
		return this.pushStack( j >= 0 && j < len ? [ this[ j ] ] : [] );
	},

	end: function() {
		return this.prevObject || this.constructor();
	},

	// For internal use only.
	// Behaves like an Array's method, not like a jQuery method.
	push: push,
	sort: arr.sort,
	splice: arr.splice
};

jQuery.extend = jQuery.fn.extend = function() {
	var options, name, src, copy, copyIsArray, clone,
		target = arguments[ 0 ] || {},
		i = 1,
		length = arguments.length,
		deep = false;

	// Handle a deep copy situation
	if ( typeof target === "boolean" ) {
		deep = target;

		// Skip the boolean and the target
		target = arguments[ i ] || {};
		i++;
	}

	// Handle case when target is a string or something (possible in deep copy)
	if ( typeof target !== "object" && !isFunction( target ) ) {
		target = {};
	}

	// Extend jQuery itself if only one argument is passed
	if ( i === length ) {
		target = this;
		i--;
	}

	for ( ; i < length; i++ ) {

		// Only deal with non-null/undefined values
		if ( ( options = arguments[ i ] ) != null ) {

			// Extend the base object
			for ( name in options ) {
				copy = options[ name ];

				// Prevent Object.prototype pollution
				// Prevent never-ending loop
				if ( name === "__proto__" || target === copy ) {
					continue;
				}

				// Recurse if we're merging plain objects or arrays
				if ( deep && copy && ( jQuery.isPlainObject( copy ) ||
					( copyIsArray = Array.isArray( copy ) ) ) ) {
					src = target[ name ];

					// Ensure proper type for the source value
					if ( copyIsArray && !Array.isArray( src ) ) {
						clone = [];
					} else if ( !copyIsArray && !jQuery.isPlainObject( src ) ) {
						clone = {};
					} else {
						clone = src;
					}
					copyIsArray = false;

					// Never move original objects, clone them
					target[ name ] = jQuery.extend( deep, clone, copy );

				// Don't bring in undefined values
				} else if ( copy !== undefined ) {
					target[ name ] = copy;
				}
			}
		}
	}

	// Return the modified object
	return target;
};

jQuery.extend( {

	// Unique for each copy of jQuery on the page
	expando: "jQuery" + ( version + Math.random() ).replace( /\D/g, "" ),

	// Assume jQuery is ready without the ready module
	isReady: true,

	error: function( msg ) {
		throw new Error( msg );
	},

	noop: function() {},

	isPlainObject: function( obj ) {
		var proto, Ctor;

		// Detect obvious negatives
		// Use toString instead of jQuery.type to catch host objects
		if ( !obj || toString.call( obj ) !== "[object Object]" ) {
			return false;
		}

		proto = getProto( obj );

		// Objects with no prototype (e.g., `Object.create( null )`) are plain
		if ( !proto ) {
			return true;
		}

		// Objects with prototype are plain iff they were constructed by a global Object function
		Ctor = hasOwn.call( proto, "constructor" ) && proto.constructor;
		return typeof Ctor === "function" && fnToString.call( Ctor ) === ObjectFunctionString;
	},

	isEmptyObject: function( obj ) {
		var name;

		for ( name in obj ) {
			return false;
		}
		return true;
	},

	// Evaluates a script in a provided context; falls back to the global one
	// if not specified.
	globalEval: function( code, options, doc ) {
		DOMEval( code, { nonce: options && options.nonce }, doc );
	},

	each: function( obj, callback ) {
		var length, i = 0;

		if ( isArrayLike( obj ) ) {
			length = obj.length;
			for ( ; i < length; i++ ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		} else {
			for ( i in obj ) {
				if ( callback.call( obj[ i ], i, obj[ i ] ) === false ) {
					break;
				}
			}
		}

		return obj;
	},


	// Retrieve the text value of an array of DOM nodes
	text: function( elem ) {
		var node,
			ret = "",
			i = 0,
			nodeType = elem.nodeType;

		if ( !nodeType ) {

			// If no nodeType, this is expected to be an array
			while ( ( node = elem[ i++ ] ) ) {

				// Do not traverse comment nodes
				ret += jQuery.text( node );
			}
		}
		if ( nodeType === 1 || nodeType === 11 ) {
			return elem.textContent;
		}
		if ( nodeType === 9 ) {
			return elem.documentElement.textContent;
		}
		if ( nodeType === 3 || nodeType === 4 ) {
			return elem.nodeValue;
		}

		// Do not include comment or processing instruction nodes

		return ret;
	},

	// results is for internal usage only
	makeArray: function( arr, results ) {
		var ret = results || [];

		if ( arr != null ) {
			if ( isArrayLike( Object( arr ) ) ) {
				jQuery.merge( ret,
					typeof arr === "string" ?
						[ arr ] : arr
				);
			} else {
				push.call( ret, arr );
			}
		}

		return ret;
	},

	inArray: function( elem, arr, i ) {
		return arr == null ? -1 : indexOf.call( arr, elem, i );
	},

	isXMLDoc: function( elem ) {
		var namespace = elem && elem.namespaceURI,
			docElem = elem && ( elem.ownerDocument || elem ).documentElement;

		// Assume HTML when documentElement doesn't yet exist, such as inside
		// document fragments.
		return !rhtmlSuffix.test( namespace || docElem && docElem.nodeName || "HTML" );
	},

	// Support: Android <=4.0 only, PhantomJS 1 only
	// push.apply(_, arraylike) throws on ancient WebKit
	merge: function( first, second ) {
		var len = +second.length,
			j = 0,
			i = first.length;

		for ( ; j < len; j++ ) {
			first[ i++ ] = second[ j ];
		}

		first.length = i;

		return first;
	},

	grep: function( elems, callback, invert ) {
		var callbackInverse,
			matches = [],
			i = 0,
			length = elems.length,
			callbackExpect = !invert;

		// Go through the array, only saving the items
		// that pass the validator function
		for ( ; i < length; i++ ) {
			callbackInverse = !callback( elems[ i ], i );
			if ( callbackInverse !== callbackExpect ) {
				matches.push( elems[ i ] );
			}
		}

		return matches;
	},

	// arg is for internal usage only
	map: function( elems, callback, arg ) {
		var length, value,
			i = 0,
			ret = [];

		// Go through the array, translating each of the items to their new values
		if ( isArrayLike( elems ) ) {
			length = elems.length;
			for ( ; i < length; i++ ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}

		// Go through every key on the object,
		} else {
			for ( i in elems ) {
				value = callback( elems[ i ], i, arg );

				if ( value != null ) {
					ret.push( value );
				}
			}
		}

		// Flatten any nested arrays
		return flat( ret );
	},

	// A global GUID counter for objects
	guid: 1,

	// jQuery.support is not used in Core but other projects attach their
	// properties to it so it needs to exist.
	support: support
} );

if ( typeof Symbol === "function" ) {
	jQuery.fn[ Symbol.iterator ] = arr[ Symbol.iterator ];
}

// Populate the class2type map
jQuery.each( "Boolean Number String Function Array Date RegExp Object Error Symbol".split( " " ),
	function( _i, name ) {
		class2type[ "[object " + name + "]" ] = name.toLowerCase();
	} );

function isArrayLike( obj ) {

	// Support: real iOS 8.2 only (not reproducible in simulator)
	// `in` check used to prevent JIT error (gh-2145)
	// hasOwn isn't used here due to false negatives
	// regarding Nodelist length in IE
	var length = !!obj && "length" in obj && obj.length,
		type = toType( obj );

	if ( isFunction( obj ) || isWindow( obj ) ) {
		return false;
	}

	return type === "array" || length === 0 ||
		typeof length === "number" && length > 0 && ( length - 1 ) in obj;
}


function nodeName( elem, name ) {

	return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();

}
var pop = arr.pop;


var sort = arr.sort;


var splice = arr.splice;


var whitespace = "[\\x20\\t\\r\\n\\f]";


var rtrimCSS = new RegExp(
	"^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$",
	"g"
);




// Note: an element does not contain itself
jQuery.contains = function( a, b ) {
	var bup = b && b.parentNode;

	return a === bup || !!( bup && bup.nodeType === 1 && (

		// Support: IE 9 - 11+
		// IE doesn't have `contains` on SVG.
		a.contains ?
			a.contains( bup ) :
			a.compareDocumentPosition && a.compareDocumentPosition( bup ) & 16
	) );
};




// CSS string/identifier serialization
// https://drafts.csswg.org/cssom/#common-serializing-idioms
var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;

function fcssescape( ch, asCodePoint ) {
	if ( asCodePoint ) {

		// U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
		if ( ch === "\0" ) {
			return "\uFFFD";
		}

		// Control characters and (dependent upon position) numbers get escaped as code points
		return ch.slice( 0, -1 ) + "\\" + ch.charCodeAt( ch.length - 1 ).toString( 16 ) + " ";
	}

	// Other potentially-special ASCII characters get backslash-escaped
	return "\\" + ch;
}

jQuery.escapeSelector = function( sel ) {
	return ( sel + "" ).replace( rcssescape, fcssescape );
};




var preferredDoc = document,
	pushNative = push;

( function() {

var i,
	Expr,
	outermostContext,
	sortInput,
	hasDuplicate,
	push = pushNative,

	// Local document vars
	document,
	documentElement,
	documentIsHTML,
	rbuggyQSA,
	matches,

	// Instance-specific data
	expando = jQuery.expando,
	dirruns = 0,
	done = 0,
	classCache = createCache(),
	tokenCache = createCache(),
	compilerCache = createCache(),
	nonnativeSelectorCache = createCache(),
	sortOrder = function( a, b ) {
		if ( a === b ) {
			hasDuplicate = true;
		}
		return 0;
	},

	booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|" +
		"loop|multiple|open|readonly|required|scoped",

	// Regular expressions

	// https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
	identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace +
		"?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",

	// Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
	attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +

		// Operator (capture 2)
		"*([*^$|!~]?=)" + whitespace +

		// "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
		"*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" +
		whitespace + "*\\]",

	pseudos = ":(" + identifier + ")(?:\\((" +

		// To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
		// 1. quoted (capture 3; capture 4 or capture 5)
		"('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +

		// 2. simple (capture 6)
		"((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +

		// 3. anything else (capture 2)
		".*" +
		")\\)|)",

	// Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
	rwhitespace = new RegExp( whitespace + "+", "g" ),

	rcomma = new RegExp( "^" + whitespace + "*," + whitespace + "*" ),
	rleadingCombinator = new RegExp( "^" + whitespace + "*([>+~]|" + whitespace + ")" +
		whitespace + "*" ),
	rdescend = new RegExp( whitespace + "|>" ),

	rpseudo = new RegExp( pseudos ),
	ridentifier = new RegExp( "^" + identifier + "$" ),

	matchExpr = {
		ID: new RegExp( "^#(" + identifier + ")" ),
		CLASS: new RegExp( "^\\.(" + identifier + ")" ),
		TAG: new RegExp( "^(" + identifier + "|[*])" ),
		ATTR: new RegExp( "^" + attributes ),
		PSEUDO: new RegExp( "^" + pseudos ),
		CHILD: new RegExp(
			"^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" +
				whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" +
				whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i" ),
		bool: new RegExp( "^(?:" + booleans + ")$", "i" ),

		// For use in libraries implementing .is()
		// We use this for POS matching in `select`
		needsContext: new RegExp( "^" + whitespace +
			"*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace +
			"*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i" )
	},

	rinputs = /^(?:input|select|textarea|button)$/i,
	rheader = /^h\d$/i,

	// Easily-parseable/retrievable ID or TAG or CLASS selectors
	rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,

	rsibling = /[+~]/,

	// CSS escapes
	// https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
	runescape = new RegExp( "\\\\[\\da-fA-F]{1,6}" + whitespace +
		"?|\\\\([^\\r\\n\\f])", "g" ),
	funescape = function( escape, nonHex ) {
		var high = "0x" + escape.slice( 1 ) - 0x10000;

		if ( nonHex ) {

			// Strip the backslash prefix from a non-hex escape sequence
			return nonHex;
		}

		// Replace a hexadecimal escape sequence with the encoded Unicode code point
		// Support: IE <=11+
		// For values outside the Basic Multilingual Plane (BMP), manually construct a
		// surrogate pair
		return high < 0 ?
			String.fromCharCode( high + 0x10000 ) :
			String.fromCharCode( high >> 10 | 0xD800, high & 0x3FF | 0xDC00 );
	},

	// Used for iframes; see `setDocument`.
	// Support: IE 9 - 11+, Edge 12 - 18+
	// Removing the function wrapper causes a "Permission Denied"
	// error in IE/Edge.
	unloadHandler = function() {
		setDocument();
	},

	inDisabledFieldset = addCombinator(
		function( elem ) {
			return elem.disabled === true && nodeName( elem, "fieldset" );
		},
		{ dir: "parentNode", next: "legend" }
	);

// Support: IE <=9 only
// Accessing document.activeElement can throw unexpectedly
// https://bugs.jquery.com/ticket/13393
function safeActiveElement() {
	try {
		return document.activeElement;
	} catch ( err ) { }
}

// Optimize for push.apply( _, NodeList )
try {
	push.apply(
		( arr = slice.call( preferredDoc.childNodes ) ),
		preferredDoc.childNodes
	);

	// Support: Android <=4.0
	// Detect silently failing push.apply
	// eslint-disable-next-line no-unused-expressions
	arr[ preferredDoc.childNodes.length ].nodeType;
} catch ( e ) {
	push = {
		apply: function( target, els ) {
			pushNative.apply( target, slice.call( els ) );
		},
		call: function( target ) {
			pushNative.apply( target, slice.call( arguments, 1 ) );
		}
	};
}

function find( selector, context, results, seed ) {
	var m, i, elem, nid, match, groups, newSelector,
		newContext = context && context.ownerDocument,

		// nodeType defaults to 9, since context defaults to document
		nodeType = context ? context.nodeType : 9;

	results = results || [];

	// Return early from calls with invalid selector or context
	if ( typeof selector !== "string" || !selector ||
		nodeType !== 1 && nodeType !== 9 && nodeType !== 11 ) {

		return results;
	}

	// Try to shortcut find operations (as opposed to filters) in HTML documents
	if ( !seed ) {
		setDocument( context );
		context = context || document;

		if ( documentIsHTML ) {

			// If the selector is sufficiently simple, try using a "get*By*" DOM method
			// (excepting DocumentFragment context, where the methods don't exist)
			if ( nodeType !== 11 && ( match = rquickExpr.exec( selector ) ) ) {

				// ID selector
				if ( ( m = match[ 1 ] ) ) {

					// Document context
					if ( nodeType === 9 ) {
						if ( ( elem = context.getElementById( m ) ) ) {

							// Support: IE 9 only
							// getElementById can match elements by name instead of ID
							if ( elem.id === m ) {
								push.call( results, elem );
								return results;
							}
						} else {
							return results;
						}

					// Element context
					} else {

						// Support: IE 9 only
						// getElementById can match elements by name instead of ID
						if ( newContext && ( elem = newContext.getElementById( m ) ) &&
							find.contains( context, elem ) &&
							elem.id === m ) {

							push.call( results, elem );
							return results;
						}
					}

				// Type selector
				} else if ( match[ 2 ] ) {
					push.apply( results, context.getElementsByTagName( selector ) );
					return results;

				// Class selector
				} else if ( ( m = match[ 3 ] ) && context.getElementsByClassName ) {
					push.apply( results, context.getElementsByClassName( m ) );
					return results;
				}
			}

			// Take advantage of querySelectorAll
			if ( !nonnativeSelectorCache[ selector + " " ] &&
				( !rbuggyQSA || !rbuggyQSA.test( selector ) ) ) {

				newSelector = selector;
				newContext = context;

				// qSA considers elements outside a scoping root when evaluating child or
				// descendant combinators, which is not what we want.
				// In such cases, we work around the behavior by prefixing every selector in the
				// list with an ID selector referencing the scope context.
				// The technique has to be used as well when a leading combinator is used
				// as such selectors are not recognized by querySelectorAll.
				// Thanks to Andrew Dupont for this technique.
				if ( nodeType === 1 &&
					( rdescend.test( selector ) || rleadingCombinator.test( selector ) ) ) {

					// Expand context for sibling selectors
					newContext = rsibling.test( selector ) && testContext( context.parentNode ) ||
						context;

					// We can use :scope instead of the ID hack if the browser
					// supports it & if we're not changing the context.
					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when
					// strict-comparing two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( newContext != context || !support.scope ) {

						// Capture the context ID, setting it first if necessary
						if ( ( nid = context.getAttribute( "id" ) ) ) {
							nid = jQuery.escapeSelector( nid );
						} else {
							context.setAttribute( "id", ( nid = expando ) );
						}
					}

					// Prefix every selector in the list
					groups = tokenize( selector );
					i = groups.length;
					while ( i-- ) {
						groups[ i ] = ( nid ? "#" + nid : ":scope" ) + " " +
							toSelector( groups[ i ] );
					}
					newSelector = groups.join( "," );
				}

				try {
					push.apply( results,
						newContext.querySelectorAll( newSelector )
					);
					return results;
				} catch ( qsaError ) {
					nonnativeSelectorCache( selector, true );
				} finally {
					if ( nid === expando ) {
						context.removeAttribute( "id" );
					}
				}
			}
		}
	}

	// All others
	return select( selector.replace( rtrimCSS, "$1" ), context, results, seed );
}

/**
 * Create key-value caches of limited size
 * @returns {function(string, object)} Returns the Object data after storing it on itself with
 *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
 *	deleting the oldest entry
 */
function createCache() {
	var keys = [];

	function cache( key, value ) {

		// Use (key + " ") to avoid collision with native prototype properties
		// (see https://github.com/jquery/sizzle/issues/157)
		if ( keys.push( key + " " ) > Expr.cacheLength ) {

			// Only keep the most recent entries
			delete cache[ keys.shift() ];
		}
		return ( cache[ key + " " ] = value );
	}
	return cache;
}

/**
 * Mark a function for special use by jQuery selector module
 * @param {Function} fn The function to mark
 */
function markFunction( fn ) {
	fn[ expando ] = true;
	return fn;
}

/**
 * Support testing using an element
 * @param {Function} fn Passed the created element and returns a boolean result
 */
function assert( fn ) {
	var el = document.createElement( "fieldset" );

	try {
		return !!fn( el );
	} catch ( e ) {
		return false;
	} finally {

		// Remove from its parent by default
		if ( el.parentNode ) {
			el.parentNode.removeChild( el );
		}

		// release memory in IE
		el = null;
	}
}

/**
 * Returns a function to use in pseudos for input types
 * @param {String} type
 */
function createInputPseudo( type ) {
	return function( elem ) {
		return nodeName( elem, "input" ) && elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for buttons
 * @param {String} type
 */
function createButtonPseudo( type ) {
	return function( elem ) {
		return ( nodeName( elem, "input" ) || nodeName( elem, "button" ) ) &&
			elem.type === type;
	};
}

/**
 * Returns a function to use in pseudos for :enabled/:disabled
 * @param {Boolean} disabled true for :disabled; false for :enabled
 */
function createDisabledPseudo( disabled ) {

	// Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
	return function( elem ) {

		// Only certain elements can match :enabled or :disabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
		// https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
		if ( "form" in elem ) {

			// Check for inherited disabledness on relevant non-disabled elements:
			// * listed form-associated elements in a disabled fieldset
			//   https://html.spec.whatwg.org/multipage/forms.html#category-listed
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
			// * option elements in a disabled optgroup
			//   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
			// All such elements have a "form" property.
			if ( elem.parentNode && elem.disabled === false ) {

				// Option elements defer to a parent optgroup if present
				if ( "label" in elem ) {
					if ( "label" in elem.parentNode ) {
						return elem.parentNode.disabled === disabled;
					} else {
						return elem.disabled === disabled;
					}
				}

				// Support: IE 6 - 11+
				// Use the isDisabled shortcut property to check for disabled fieldset ancestors
				return elem.isDisabled === disabled ||

					// Where there is no isDisabled, check manually
					elem.isDisabled !== !disabled &&
						inDisabledFieldset( elem ) === disabled;
			}

			return elem.disabled === disabled;

		// Try to winnow out elements that can't be disabled before trusting the disabled property.
		// Some victims get caught in our net (label, legend, menu, track), but it shouldn't
		// even exist on them, let alone have a boolean value.
		} else if ( "label" in elem ) {
			return elem.disabled === disabled;
		}

		// Remaining elements are neither :enabled nor :disabled
		return false;
	};
}

/**
 * Returns a function to use in pseudos for positionals
 * @param {Function} fn
 */
function createPositionalPseudo( fn ) {
	return markFunction( function( argument ) {
		argument = +argument;
		return markFunction( function( seed, matches ) {
			var j,
				matchIndexes = fn( [], seed.length, argument ),
				i = matchIndexes.length;

			// Match elements found at the specified indexes
			while ( i-- ) {
				if ( seed[ ( j = matchIndexes[ i ] ) ] ) {
					seed[ j ] = !( matches[ j ] = seed[ j ] );
				}
			}
		} );
	} );
}

/**
 * Checks a node for validity as a jQuery selector context
 * @param {Element|Object=} context
 * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
 */
function testContext( context ) {
	return context && typeof context.getElementsByTagName !== "undefined" && context;
}

/**
 * Sets document-related variables once based on the current document
 * @param {Element|Object} [node] An element or document object to use to set the document
 * @returns {Object} Returns the current document
 */
function setDocument( node ) {
	var subWindow,
		doc = node ? node.ownerDocument || node : preferredDoc;

	// Return early if doc is invalid or already selected
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( doc == document || doc.nodeType !== 9 || !doc.documentElement ) {
		return document;
	}

	// Update global variables
	document = doc;
	documentElement = document.documentElement;
	documentIsHTML = !jQuery.isXMLDoc( document );

	// Support: iOS 7 only, IE 9 - 11+
	// Older browsers didn't support unprefixed `matches`.
	matches = documentElement.matches ||
		documentElement.webkitMatchesSelector ||
		documentElement.msMatchesSelector;

	// Support: IE 9 - 11+, Edge 12 - 18+
	// Accessing iframe documents after unload throws "permission denied" errors
	// (see trac-13936).
	// Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
	// all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
	if ( documentElement.msMatchesSelector &&

		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		preferredDoc != document &&
		( subWindow = document.defaultView ) && subWindow.top !== subWindow ) {

		// Support: IE 9 - 11+, Edge 12 - 18+
		subWindow.addEventListener( "unload", unloadHandler );
	}

	// Support: IE <10
	// Check if getElementById returns elements by name
	// The broken getElementById methods don't pick up programmatically-set names,
	// so use a roundabout getElementsByName test
	support.getById = assert( function( el ) {
		documentElement.appendChild( el ).id = jQuery.expando;
		return !document.getElementsByName ||
			!document.getElementsByName( jQuery.expando ).length;
	} );

	// Support: IE 9 only
	// Check to see if it's possible to do matchesSelector
	// on a disconnected node.
	support.disconnectedMatch = assert( function( el ) {
		return matches.call( el, "*" );
	} );

	// Support: IE 9 - 11+, Edge 12 - 18+
	// IE/Edge don't support the :scope pseudo-class.
	support.scope = assert( function() {
		return document.querySelectorAll( ":scope" );
	} );

	// Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
	// Make sure the `:has()` argument is parsed unforgivingly.
	// We include `*` in the test to detect buggy implementations that are
	// _selectively_ forgiving (specifically when the list includes at least
	// one valid selector).
	// Note that we treat complete lack of support for `:has()` as if it were
	// spec-compliant support, which is fine because use of `:has()` in such
	// environments will fail in the qSA path and fall back to jQuery traversal
	// anyway.
	support.cssHas = assert( function() {
		try {
			document.querySelector( ":has(*,:jqfake)" );
			return false;
		} catch ( e ) {
			return true;
		}
	} );

	// ID filter and find
	if ( support.getById ) {
		Expr.filter.ID = function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				return elem.getAttribute( "id" ) === attrId;
			};
		};
		Expr.find.ID = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var elem = context.getElementById( id );
				return elem ? [ elem ] : [];
			}
		};
	} else {
		Expr.filter.ID =  function( id ) {
			var attrId = id.replace( runescape, funescape );
			return function( elem ) {
				var node = typeof elem.getAttributeNode !== "undefined" &&
					elem.getAttributeNode( "id" );
				return node && node.value === attrId;
			};
		};

		// Support: IE 6 - 7 only
		// getElementById is not reliable as a find shortcut
		Expr.find.ID = function( id, context ) {
			if ( typeof context.getElementById !== "undefined" && documentIsHTML ) {
				var node, i, elems,
					elem = context.getElementById( id );

				if ( elem ) {

					// Verify the id attribute
					node = elem.getAttributeNode( "id" );
					if ( node && node.value === id ) {
						return [ elem ];
					}

					// Fall back on getElementsByName
					elems = context.getElementsByName( id );
					i = 0;
					while ( ( elem = elems[ i++ ] ) ) {
						node = elem.getAttributeNode( "id" );
						if ( node && node.value === id ) {
							return [ elem ];
						}
					}
				}

				return [];
			}
		};
	}

	// Tag
	Expr.find.TAG = function( tag, context ) {
		if ( typeof context.getElementsByTagName !== "undefined" ) {
			return context.getElementsByTagName( tag );

		// DocumentFragment nodes don't have gEBTN
		} else {
			return context.querySelectorAll( tag );
		}
	};

	// Class
	Expr.find.CLASS = function( className, context ) {
		if ( typeof context.getElementsByClassName !== "undefined" && documentIsHTML ) {
			return context.getElementsByClassName( className );
		}
	};

	/* QSA/matchesSelector
	---------------------------------------------------------------------- */

	// QSA and matchesSelector support

	rbuggyQSA = [];

	// Build QSA regex
	// Regex strategy adopted from Diego Perini
	assert( function( el ) {

		var input;

		documentElement.appendChild( el ).innerHTML =
			"<a id='" + expando + "' href='' disabled='disabled'></a>" +
			"<select id='" + expando + "-\r\\' disabled='disabled'>" +
			"<option selected=''></option></select>";

		// Support: iOS <=7 - 8 only
		// Boolean attributes and "value" are not treated correctly in some XML documents
		if ( !el.querySelectorAll( "[selected]" ).length ) {
			rbuggyQSA.push( "\\[" + whitespace + "*(?:value|" + booleans + ")" );
		}

		// Support: iOS <=7 - 8 only
		if ( !el.querySelectorAll( "[id~=" + expando + "-]" ).length ) {
			rbuggyQSA.push( "~=" );
		}

		// Support: iOS 8 only
		// https://bugs.webkit.org/show_bug.cgi?id=136851
		// In-page `selector#id sibling-combinator selector` fails
		if ( !el.querySelectorAll( "a#" + expando + "+*" ).length ) {
			rbuggyQSA.push( ".#.+[+~]" );
		}

		// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
		// In some of the document kinds, these selectors wouldn't work natively.
		// This is probably OK but for backwards compatibility we want to maintain
		// handling them through jQuery traversal in jQuery 3.x.
		if ( !el.querySelectorAll( ":checked" ).length ) {
			rbuggyQSA.push( ":checked" );
		}

		// Support: Windows 8 Native Apps
		// The type and name attributes are restricted during .innerHTML assignment
		input = document.createElement( "input" );
		input.setAttribute( "type", "hidden" );
		el.appendChild( input ).setAttribute( "name", "D" );

		// Support: IE 9 - 11+
		// IE's :disabled selector does not pick up the children of disabled fieldsets
		// Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
		// In some of the document kinds, these selectors wouldn't work natively.
		// This is probably OK but for backwards compatibility we want to maintain
		// handling them through jQuery traversal in jQuery 3.x.
		documentElement.appendChild( el ).disabled = true;
		if ( el.querySelectorAll( ":disabled" ).length !== 2 ) {
			rbuggyQSA.push( ":enabled", ":disabled" );
		}

		// Support: IE 11+, Edge 15 - 18+
		// IE 11/Edge don't find elements on a `[name='']` query in some cases.
		// Adding a temporary attribute to the document before the selection works
		// around the issue.
		// Interestingly, IE 10 & older don't seem to have the issue.
		input = document.createElement( "input" );
		input.setAttribute( "name", "" );
		el.appendChild( input );
		if ( !el.querySelectorAll( "[name='']" ).length ) {
			rbuggyQSA.push( "\\[" + whitespace + "*name" + whitespace + "*=" +
				whitespace + "*(?:''|\"\")" );
		}
	} );

	if ( !support.cssHas ) {

		// Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
		// Our regular `try-catch` mechanism fails to detect natively-unsupported
		// pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
		// in browsers that parse the `:has()` argument as a forgiving selector list.
		// https://drafts.csswg.org/selectors/#relational now requires the argument
		// to be parsed unforgivingly, but browsers have not yet fully adjusted.
		rbuggyQSA.push( ":has" );
	}

	rbuggyQSA = rbuggyQSA.length && new RegExp( rbuggyQSA.join( "|" ) );

	/* Sorting
	---------------------------------------------------------------------- */

	// Document order sorting
	sortOrder = function( a, b ) {

		// Flag for duplicate removal
		if ( a === b ) {
			hasDuplicate = true;
			return 0;
		}

		// Sort on method existence if only one input has compareDocumentPosition
		var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
		if ( compare ) {
			return compare;
		}

		// Calculate position if both inputs belong to the same document
		// Support: IE 11+, Edge 17 - 18+
		// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
		// two documents; shallow comparisons work.
		// eslint-disable-next-line eqeqeq
		compare = ( a.ownerDocument || a ) == ( b.ownerDocument || b ) ?
			a.compareDocumentPosition( b ) :

			// Otherwise we know they are disconnected
			1;

		// Disconnected nodes
		if ( compare & 1 ||
			( !support.sortDetached && b.compareDocumentPosition( a ) === compare ) ) {

			// Choose the first element that is related to our preferred document
			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( a === document || a.ownerDocument == preferredDoc &&
				find.contains( preferredDoc, a ) ) {
				return -1;
			}

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			if ( b === document || b.ownerDocument == preferredDoc &&
				find.contains( preferredDoc, b ) ) {
				return 1;
			}

			// Maintain original order
			return sortInput ?
				( indexOf.call( sortInput, a ) - indexOf.call( sortInput, b ) ) :
				0;
		}

		return compare & 4 ? -1 : 1;
	};

	return document;
}

find.matches = function( expr, elements ) {
	return find( expr, null, null, elements );
};

find.matchesSelector = function( elem, expr ) {
	setDocument( elem );

	if ( documentIsHTML &&
		!nonnativeSelectorCache[ expr + " " ] &&
		( !rbuggyQSA || !rbuggyQSA.test( expr ) ) ) {

		try {
			var ret = matches.call( elem, expr );

			// IE 9's matchesSelector returns false on disconnected nodes
			if ( ret || support.disconnectedMatch ||

					// As well, disconnected nodes are said to be in a document
					// fragment in IE 9
					elem.document && elem.document.nodeType !== 11 ) {
				return ret;
			}
		} catch ( e ) {
			nonnativeSelectorCache( expr, true );
		}
	}

	return find( expr, document, null, [ elem ] ).length > 0;
};

find.contains = function( context, elem ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( context.ownerDocument || context ) != document ) {
		setDocument( context );
	}
	return jQuery.contains( context, elem );
};


find.attr = function( elem, name ) {

	// Set document vars if needed
	// Support: IE 11+, Edge 17 - 18+
	// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
	// two documents; shallow comparisons work.
	// eslint-disable-next-line eqeqeq
	if ( ( elem.ownerDocument || elem ) != document ) {
		setDocument( elem );
	}

	var fn = Expr.attrHandle[ name.toLowerCase() ],

		// Don't get fooled by Object.prototype properties (see trac-13807)
		val = fn && hasOwn.call( Expr.attrHandle, name.toLowerCase() ) ?
			fn( elem, name, !documentIsHTML ) :
			undefined;

	if ( val !== undefined ) {
		return val;
	}

	return elem.getAttribute( name );
};

find.error = function( msg ) {
	throw new Error( "Syntax error, unrecognized expression: " + msg );
};

/**
 * Document sorting and removing duplicates
 * @param {ArrayLike} results
 */
jQuery.uniqueSort = function( results ) {
	var elem,
		duplicates = [],
		j = 0,
		i = 0;

	// Unless we *know* we can detect duplicates, assume their presence
	//
	// Support: Android <=4.0+
	// Testing for detecting duplicates is unpredictable so instead assume we can't
	// depend on duplicate detection in all browsers without a stable sort.
	hasDuplicate = !support.sortStable;
	sortInput = !support.sortStable && slice.call( results, 0 );
	sort.call( results, sortOrder );

	if ( hasDuplicate ) {
		while ( ( elem = results[ i++ ] ) ) {
			if ( elem === results[ i ] ) {
				j = duplicates.push( i );
			}
		}
		while ( j-- ) {
			splice.call( results, duplicates[ j ], 1 );
		}
	}

	// Clear input after sorting to release objects
	// See https://github.com/jquery/sizzle/pull/225
	sortInput = null;

	return results;
};

jQuery.fn.uniqueSort = function() {
	return this.pushStack( jQuery.uniqueSort( slice.apply( this ) ) );
};

Expr = jQuery.expr = {

	// Can be adjusted by the user
	cacheLength: 50,

	createPseudo: markFunction,

	match: matchExpr,

	attrHandle: {},

	find: {},

	relative: {
		">": { dir: "parentNode", first: true },
		" ": { dir: "parentNode" },
		"+": { dir: "previousSibling", first: true },
		"~": { dir: "previousSibling" }
	},

	preFilter: {
		ATTR: function( match ) {
			match[ 1 ] = match[ 1 ].replace( runescape, funescape );

			// Move the given value to match[3] whether quoted or unquoted
			match[ 3 ] = ( match[ 3 ] || match[ 4 ] || match[ 5 ] || "" )
				.replace( runescape, funescape );

			if ( match[ 2 ] === "~=" ) {
				match[ 3 ] = " " + match[ 3 ] + " ";
			}

			return match.slice( 0, 4 );
		},

		CHILD: function( match ) {

			/* matches from matchExpr["CHILD"]
				1 type (only|nth|...)
				2 what (child|of-type)
				3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
				4 xn-component of xn+y argument ([+-]?\d*n|)
				5 sign of xn-component
				6 x of xn-component
				7 sign of y-component
				8 y of y-component
			*/
			match[ 1 ] = match[ 1 ].toLowerCase();

			if ( match[ 1 ].slice( 0, 3 ) === "nth" ) {

				// nth-* requires argument
				if ( !match[ 3 ] ) {
					find.error( match[ 0 ] );
				}

				// numeric x and y parameters for Expr.filter.CHILD
				// remember that false/true cast respectively to 0/1
				match[ 4 ] = +( match[ 4 ] ?
					match[ 5 ] + ( match[ 6 ] || 1 ) :
					2 * ( match[ 3 ] === "even" || match[ 3 ] === "odd" )
				);
				match[ 5 ] = +( ( match[ 7 ] + match[ 8 ] ) || match[ 3 ] === "odd" );

			// other types prohibit arguments
			} else if ( match[ 3 ] ) {
				find.error( match[ 0 ] );
			}

			return match;
		},

		PSEUDO: function( match ) {
			var excess,
				unquoted = !match[ 6 ] && match[ 2 ];

			if ( matchExpr.CHILD.test( match[ 0 ] ) ) {
				return null;
			}

			// Accept quoted arguments as-is
			if ( match[ 3 ] ) {
				match[ 2 ] = match[ 4 ] || match[ 5 ] || "";

			// Strip excess characters from unquoted arguments
			} else if ( unquoted && rpseudo.test( unquoted ) &&

				// Get excess from tokenize (recursively)
				( excess = tokenize( unquoted, true ) ) &&

				// advance to the next closing parenthesis
				( excess = unquoted.indexOf( ")", unquoted.length - excess ) - unquoted.length ) ) {

				// excess is a negative index
				match[ 0 ] = match[ 0 ].slice( 0, excess );
				match[ 2 ] = unquoted.slice( 0, excess );
			}

			// Return only captures needed by the pseudo filter method (type and argument)
			return match.slice( 0, 3 );
		}
	},

	filter: {

		TAG: function( nodeNameSelector ) {
			var expectedNodeName = nodeNameSelector.replace( runescape, funescape ).toLowerCase();
			return nodeNameSelector === "*" ?
				function() {
					return true;
				} :
				function( elem ) {
					return nodeName( elem, expectedNodeName );
				};
		},

		CLASS: function( className ) {
			var pattern = classCache[ className + " " ];

			return pattern ||
				( pattern = new RegExp( "(^|" + whitespace + ")" + className +
					"(" + whitespace + "|$)" ) ) &&
				classCache( className, function( elem ) {
					return pattern.test(
						typeof elem.className === "string" && elem.className ||
							typeof elem.getAttribute !== "undefined" &&
								elem.getAttribute( "class" ) ||
							""
					);
				} );
		},

		ATTR: function( name, operator, check ) {
			return function( elem ) {
				var result = find.attr( elem, name );

				if ( result == null ) {
					return operator === "!=";
				}
				if ( !operator ) {
					return true;
				}

				result += "";

				if ( operator === "=" ) {
					return result === check;
				}
				if ( operator === "!=" ) {
					return result !== check;
				}
				if ( operator === "^=" ) {
					return check && result.indexOf( check ) === 0;
				}
				if ( operator === "*=" ) {
					return check && result.indexOf( check ) > -1;
				}
				if ( operator === "$=" ) {
					return check && result.slice( -check.length ) === check;
				}
				if ( operator === "~=" ) {
					return ( " " + result.replace( rwhitespace, " " ) + " " )
						.indexOf( check ) > -1;
				}
				if ( operator === "|=" ) {
					return result === check || result.slice( 0, check.length + 1 ) === check + "-";
				}

				return false;
			};
		},

		CHILD: function( type, what, _argument, first, last ) {
			var simple = type.slice( 0, 3 ) !== "nth",
				forward = type.slice( -4 ) !== "last",
				ofType = what === "of-type";

			return first === 1 && last === 0 ?

				// Shortcut for :nth-*(n)
				function( elem ) {
					return !!elem.parentNode;
				} :

				function( elem, _context, xml ) {
					var cache, outerCache, node, nodeIndex, start,
						dir = simple !== forward ? "nextSibling" : "previousSibling",
						parent = elem.parentNode,
						name = ofType && elem.nodeName.toLowerCase(),
						useCache = !xml && !ofType,
						diff = false;

					if ( parent ) {

						// :(first|last|only)-(child|of-type)
						if ( simple ) {
							while ( dir ) {
								node = elem;
								while ( ( node = node[ dir ] ) ) {
									if ( ofType ?
										nodeName( node, name ) :
										node.nodeType === 1 ) {

										return false;
									}
								}

								// Reverse direction for :only-* (if we haven't yet done so)
								start = dir = type === "only" && !start && "nextSibling";
							}
							return true;
						}

						start = [ forward ? parent.firstChild : parent.lastChild ];

						// non-xml :nth-child(...) stores cache data on `parent`
						if ( forward && useCache ) {

							// Seek `elem` from a previously-cached index
							outerCache = parent[ expando ] || ( parent[ expando ] = {} );
							cache = outerCache[ type ] || [];
							nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
							diff = nodeIndex && cache[ 2 ];
							node = nodeIndex && parent.childNodes[ nodeIndex ];

							while ( ( node = ++nodeIndex && node && node[ dir ] ||

								// Fallback to seeking `elem` from the start
								( diff = nodeIndex = 0 ) || start.pop() ) ) {

								// When found, cache indexes on `parent` and break
								if ( node.nodeType === 1 && ++diff && node === elem ) {
									outerCache[ type ] = [ dirruns, nodeIndex, diff ];
									break;
								}
							}

						} else {

							// Use previously-cached element index if available
							if ( useCache ) {
								outerCache = elem[ expando ] || ( elem[ expando ] = {} );
								cache = outerCache[ type ] || [];
								nodeIndex = cache[ 0 ] === dirruns && cache[ 1 ];
								diff = nodeIndex;
							}

							// xml :nth-child(...)
							// or :nth-last-child(...) or :nth(-last)?-of-type(...)
							if ( diff === false ) {

								// Use the same loop as above to seek `elem` from the start
								while ( ( node = ++nodeIndex && node && node[ dir ] ||
									( diff = nodeIndex = 0 ) || start.pop() ) ) {

									if ( ( ofType ?
										nodeName( node, name ) :
										node.nodeType === 1 ) &&
										++diff ) {

										// Cache the index of each encountered element
										if ( useCache ) {
											outerCache = node[ expando ] ||
												( node[ expando ] = {} );
											outerCache[ type ] = [ dirruns, diff ];
										}

										if ( node === elem ) {
											break;
										}
									}
								}
							}
						}

						// Incorporate the offset, then check against cycle size
						diff -= last;
						return diff === first || ( diff % first === 0 && diff / first >= 0 );
					}
				};
		},

		PSEUDO: function( pseudo, argument ) {

			// pseudo-class names are case-insensitive
			// https://www.w3.org/TR/selectors/#pseudo-classes
			// Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
			// Remember that setFilters inherits from pseudos
			var args,
				fn = Expr.pseudos[ pseudo ] || Expr.setFilters[ pseudo.toLowerCase() ] ||
					find.error( "unsupported pseudo: " + pseudo );

			// The user may use createPseudo to indicate that
			// arguments are needed to create the filter function
			// just as jQuery does
			if ( fn[ expando ] ) {
				return fn( argument );
			}

			// But maintain support for old signatures
			if ( fn.length > 1 ) {
				args = [ pseudo, pseudo, "", argument ];
				return Expr.setFilters.hasOwnProperty( pseudo.toLowerCase() ) ?
					markFunction( function( seed, matches ) {
						var idx,
							matched = fn( seed, argument ),
							i = matched.length;
						while ( i-- ) {
							idx = indexOf.call( seed, matched[ i ] );
							seed[ idx ] = !( matches[ idx ] = matched[ i ] );
						}
					} ) :
					function( elem ) {
						return fn( elem, 0, args );
					};
			}

			return fn;
		}
	},

	pseudos: {

		// Potentially complex pseudos
		not: markFunction( function( selector ) {

			// Trim the selector passed to compile
			// to avoid treating leading and trailing
			// spaces as combinators
			var input = [],
				results = [],
				matcher = compile( selector.replace( rtrimCSS, "$1" ) );

			return matcher[ expando ] ?
				markFunction( function( seed, matches, _context, xml ) {
					var elem,
						unmatched = matcher( seed, null, xml, [] ),
						i = seed.length;

					// Match elements unmatched by `matcher`
					while ( i-- ) {
						if ( ( elem = unmatched[ i ] ) ) {
							seed[ i ] = !( matches[ i ] = elem );
						}
					}
				} ) :
				function( elem, _context, xml ) {
					input[ 0 ] = elem;
					matcher( input, null, xml, results );

					// Don't keep the element
					// (see https://github.com/jquery/sizzle/issues/299)
					input[ 0 ] = null;
					return !results.pop();
				};
		} ),

		has: markFunction( function( selector ) {
			return function( elem ) {
				return find( selector, elem ).length > 0;
			};
		} ),

		contains: markFunction( function( text ) {
			text = text.replace( runescape, funescape );
			return function( elem ) {
				return ( elem.textContent || jQuery.text( elem ) ).indexOf( text ) > -1;
			};
		} ),

		// "Whether an element is represented by a :lang() selector
		// is based solely on the element's language value
		// being equal to the identifier C,
		// or beginning with the identifier C immediately followed by "-".
		// The matching of C against the element's language value is performed case-insensitively.
		// The identifier C does not have to be a valid language name."
		// https://www.w3.org/TR/selectors/#lang-pseudo
		lang: markFunction( function( lang ) {

			// lang value must be a valid identifier
			if ( !ridentifier.test( lang || "" ) ) {
				find.error( "unsupported lang: " + lang );
			}
			lang = lang.replace( runescape, funescape ).toLowerCase();
			return function( elem ) {
				var elemLang;
				do {
					if ( ( elemLang = documentIsHTML ?
						elem.lang :
						elem.getAttribute( "xml:lang" ) || elem.getAttribute( "lang" ) ) ) {

						elemLang = elemLang.toLowerCase();
						return elemLang === lang || elemLang.indexOf( lang + "-" ) === 0;
					}
				} while ( ( elem = elem.parentNode ) && elem.nodeType === 1 );
				return false;
			};
		} ),

		// Miscellaneous
		target: function( elem ) {
			var hash = window.location && window.location.hash;
			return hash && hash.slice( 1 ) === elem.id;
		},

		root: function( elem ) {
			return elem === documentElement;
		},

		focus: function( elem ) {
			return elem === safeActiveElement() &&
				document.hasFocus() &&
				!!( elem.type || elem.href || ~elem.tabIndex );
		},

		// Boolean properties
		enabled: createDisabledPseudo( false ),
		disabled: createDisabledPseudo( true ),

		checked: function( elem ) {

			// In CSS3, :checked should return both checked and selected elements
			// https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
			return ( nodeName( elem, "input" ) && !!elem.checked ) ||
				( nodeName( elem, "option" ) && !!elem.selected );
		},

		selected: function( elem ) {

			// Support: IE <=11+
			// Accessing the selectedIndex property
			// forces the browser to treat the default option as
			// selected when in an optgroup.
			if ( elem.parentNode ) {
				// eslint-disable-next-line no-unused-expressions
				elem.parentNode.selectedIndex;
			}

			return elem.selected === true;
		},

		// Contents
		empty: function( elem ) {

			// https://www.w3.org/TR/selectors/#empty-pseudo
			// :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
			//   but not by others (comment: 8; processing instruction: 7; etc.)
			// nodeType < 6 works because attributes (2) do not appear as children
			for ( elem = elem.firstChild; elem; elem = elem.nextSibling ) {
				if ( elem.nodeType < 6 ) {
					return false;
				}
			}
			return true;
		},

		parent: function( elem ) {
			return !Expr.pseudos.empty( elem );
		},

		// Element/input types
		header: function( elem ) {
			return rheader.test( elem.nodeName );
		},

		input: function( elem ) {
			return rinputs.test( elem.nodeName );
		},

		button: function( elem ) {
			return nodeName( elem, "input" ) && elem.type === "button" ||
				nodeName( elem, "button" );
		},

		text: function( elem ) {
			var attr;
			return nodeName( elem, "input" ) && elem.type === "text" &&

				// Support: IE <10 only
				// New HTML5 attribute values (e.g., "search") appear
				// with elem.type === "text"
				( ( attr = elem.getAttribute( "type" ) ) == null ||
					attr.toLowerCase() === "text" );
		},

		// Position-in-collection
		first: createPositionalPseudo( function() {
			return [ 0 ];
		} ),

		last: createPositionalPseudo( function( _matchIndexes, length ) {
			return [ length - 1 ];
		} ),

		eq: createPositionalPseudo( function( _matchIndexes, length, argument ) {
			return [ argument < 0 ? argument + length : argument ];
		} ),

		even: createPositionalPseudo( function( matchIndexes, length ) {
			var i = 0;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		odd: createPositionalPseudo( function( matchIndexes, length ) {
			var i = 1;
			for ( ; i < length; i += 2 ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		lt: createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i;

			if ( argument < 0 ) {
				i = argument + length;
			} else if ( argument > length ) {
				i = length;
			} else {
				i = argument;
			}

			for ( ; --i >= 0; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} ),

		gt: createPositionalPseudo( function( matchIndexes, length, argument ) {
			var i = argument < 0 ? argument + length : argument;
			for ( ; ++i < length; ) {
				matchIndexes.push( i );
			}
			return matchIndexes;
		} )
	}
};

Expr.pseudos.nth = Expr.pseudos.eq;

// Add button/input type pseudos
for ( i in { radio: true, checkbox: true, file: true, password: true, image: true } ) {
	Expr.pseudos[ i ] = createInputPseudo( i );
}
for ( i in { submit: true, reset: true } ) {
	Expr.pseudos[ i ] = createButtonPseudo( i );
}

// Easy API for creating new setFilters
function setFilters() {}
setFilters.prototype = Expr.filters = Expr.pseudos;
Expr.setFilters = new setFilters();

function tokenize( selector, parseOnly ) {
	var matched, match, tokens, type,
		soFar, groups, preFilters,
		cached = tokenCache[ selector + " " ];

	if ( cached ) {
		return parseOnly ? 0 : cached.slice( 0 );
	}

	soFar = selector;
	groups = [];
	preFilters = Expr.preFilter;

	while ( soFar ) {

		// Comma and first run
		if ( !matched || ( match = rcomma.exec( soFar ) ) ) {
			if ( match ) {

				// Don't consume trailing commas as valid
				soFar = soFar.slice( match[ 0 ].length ) || soFar;
			}
			groups.push( ( tokens = [] ) );
		}

		matched = false;

		// Combinators
		if ( ( match = rleadingCombinator.exec( soFar ) ) ) {
			matched = match.shift();
			tokens.push( {
				value: matched,

				// Cast descendant combinators to space
				type: match[ 0 ].replace( rtrimCSS, " " )
			} );
			soFar = soFar.slice( matched.length );
		}

		// Filters
		for ( type in Expr.filter ) {
			if ( ( match = matchExpr[ type ].exec( soFar ) ) && ( !preFilters[ type ] ||
				( match = preFilters[ type ]( match ) ) ) ) {
				matched = match.shift();
				tokens.push( {
					value: matched,
					type: type,
					matches: match
				} );
				soFar = soFar.slice( matched.length );
			}
		}

		if ( !matched ) {
			break;
		}
	}

	// Return the length of the invalid excess
	// if we're just parsing
	// Otherwise, throw an error or return tokens
	if ( parseOnly ) {
		return soFar.length;
	}

	return soFar ?
		find.error( selector ) :

		// Cache the tokens
		tokenCache( selector, groups ).slice( 0 );
}

function toSelector( tokens ) {
	var i = 0,
		len = tokens.length,
		selector = "";
	for ( ; i < len; i++ ) {
		selector += tokens[ i ].value;
	}
	return selector;
}

function addCombinator( matcher, combinator, base ) {
	var dir = combinator.dir,
		skip = combinator.next,
		key = skip || dir,
		checkNonElements = base && key === "parentNode",
		doneName = done++;

	return combinator.first ?

		// Check against closest ancestor/preceding element
		function( elem, context, xml ) {
			while ( ( elem = elem[ dir ] ) ) {
				if ( elem.nodeType === 1 || checkNonElements ) {
					return matcher( elem, context, xml );
				}
			}
			return false;
		} :

		// Check against all ancestor/preceding elements
		function( elem, context, xml ) {
			var oldCache, outerCache,
				newCache = [ dirruns, doneName ];

			// We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
			if ( xml ) {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						if ( matcher( elem, context, xml ) ) {
							return true;
						}
					}
				}
			} else {
				while ( ( elem = elem[ dir ] ) ) {
					if ( elem.nodeType === 1 || checkNonElements ) {
						outerCache = elem[ expando ] || ( elem[ expando ] = {} );

						if ( skip && nodeName( elem, skip ) ) {
							elem = elem[ dir ] || elem;
						} else if ( ( oldCache = outerCache[ key ] ) &&
							oldCache[ 0 ] === dirruns && oldCache[ 1 ] === doneName ) {

							// Assign to newCache so results back-propagate to previous elements
							return ( newCache[ 2 ] = oldCache[ 2 ] );
						} else {

							// Reuse newcache so results back-propagate to previous elements
							outerCache[ key ] = newCache;

							// A match means we're done; a fail means we have to keep checking
							if ( ( newCache[ 2 ] = matcher( elem, context, xml ) ) ) {
								return true;
							}
						}
					}
				}
			}
			return false;
		};
}

function elementMatcher( matchers ) {
	return matchers.length > 1 ?
		function( elem, context, xml ) {
			var i = matchers.length;
			while ( i-- ) {
				if ( !matchers[ i ]( elem, context, xml ) ) {
					return false;
				}
			}
			return true;
		} :
		matchers[ 0 ];
}

function multipleContexts( selector, contexts, results ) {
	var i = 0,
		len = contexts.length;
	for ( ; i < len; i++ ) {
		find( selector, contexts[ i ], results );
	}
	return results;
}

function condense( unmatched, map, filter, context, xml ) {
	var elem,
		newUnmatched = [],
		i = 0,
		len = unmatched.length,
		mapped = map != null;

	for ( ; i < len; i++ ) {
		if ( ( elem = unmatched[ i ] ) ) {
			if ( !filter || filter( elem, context, xml ) ) {
				newUnmatched.push( elem );
				if ( mapped ) {
					map.push( i );
				}
			}
		}
	}

	return newUnmatched;
}

function setMatcher( preFilter, selector, matcher, postFilter, postFinder, postSelector ) {
	if ( postFilter && !postFilter[ expando ] ) {
		postFilter = setMatcher( postFilter );
	}
	if ( postFinder && !postFinder[ expando ] ) {
		postFinder = setMatcher( postFinder, postSelector );
	}
	return markFunction( function( seed, results, context, xml ) {
		var temp, i, elem, matcherOut,
			preMap = [],
			postMap = [],
			preexisting = results.length,

			// Get initial elements from seed or context
			elems = seed ||
				multipleContexts( selector || "*",
					context.nodeType ? [ context ] : context, [] ),

			// Prefilter to get matcher input, preserving a map for seed-results synchronization
			matcherIn = preFilter && ( seed || !selector ) ?
				condense( elems, preMap, preFilter, context, xml ) :
				elems;

		if ( matcher ) {

			// If we have a postFinder, or filtered seed, or non-seed postFilter
			// or preexisting results,
			matcherOut = postFinder || ( seed ? preFilter : preexisting || postFilter ) ?

				// ...intermediate processing is necessary
				[] :

				// ...otherwise use results directly
				results;

			// Find primary matches
			matcher( matcherIn, matcherOut, context, xml );
		} else {
			matcherOut = matcherIn;
		}

		// Apply postFilter
		if ( postFilter ) {
			temp = condense( matcherOut, postMap );
			postFilter( temp, [], context, xml );

			// Un-match failing elements by moving them back to matcherIn
			i = temp.length;
			while ( i-- ) {
				if ( ( elem = temp[ i ] ) ) {
					matcherOut[ postMap[ i ] ] = !( matcherIn[ postMap[ i ] ] = elem );
				}
			}
		}

		if ( seed ) {
			if ( postFinder || preFilter ) {
				if ( postFinder ) {

					// Get the final matcherOut by condensing this intermediate into postFinder contexts
					temp = [];
					i = matcherOut.length;
					while ( i-- ) {
						if ( ( elem = matcherOut[ i ] ) ) {

							// Restore matcherIn since elem is not yet a final match
							temp.push( ( matcherIn[ i ] = elem ) );
						}
					}
					postFinder( null, ( matcherOut = [] ), temp, xml );
				}

				// Move matched elements from seed to results to keep them synchronized
				i = matcherOut.length;
				while ( i-- ) {
					if ( ( elem = matcherOut[ i ] ) &&
						( temp = postFinder ? indexOf.call( seed, elem ) : preMap[ i ] ) > -1 ) {

						seed[ temp ] = !( results[ temp ] = elem );
					}
				}
			}

		// Add elements to results, through postFinder if defined
		} else {
			matcherOut = condense(
				matcherOut === results ?
					matcherOut.splice( preexisting, matcherOut.length ) :
					matcherOut
			);
			if ( postFinder ) {
				postFinder( null, results, matcherOut, xml );
			} else {
				push.apply( results, matcherOut );
			}
		}
	} );
}

function matcherFromTokens( tokens ) {
	var checkContext, matcher, j,
		len = tokens.length,
		leadingRelative = Expr.relative[ tokens[ 0 ].type ],
		implicitRelative = leadingRelative || Expr.relative[ " " ],
		i = leadingRelative ? 1 : 0,

		// The foundational matcher ensures that elements are reachable from top-level context(s)
		matchContext = addCombinator( function( elem ) {
			return elem === checkContext;
		}, implicitRelative, true ),
		matchAnyContext = addCombinator( function( elem ) {
			return indexOf.call( checkContext, elem ) > -1;
		}, implicitRelative, true ),
		matchers = [ function( elem, context, xml ) {

			// Support: IE 11+, Edge 17 - 18+
			// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
			// two documents; shallow comparisons work.
			// eslint-disable-next-line eqeqeq
			var ret = ( !leadingRelative && ( xml || context != outermostContext ) ) || (
				( checkContext = context ).nodeType ?
					matchContext( elem, context, xml ) :
					matchAnyContext( elem, context, xml ) );

			// Avoid hanging onto element
			// (see https://github.com/jquery/sizzle/issues/299)
			checkContext = null;
			return ret;
		} ];

	for ( ; i < len; i++ ) {
		if ( ( matcher = Expr.relative[ tokens[ i ].type ] ) ) {
			matchers = [ addCombinator( elementMatcher( matchers ), matcher ) ];
		} else {
			matcher = Expr.filter[ tokens[ i ].type ].apply( null, tokens[ i ].matches );

			// Return special upon seeing a positional matcher
			if ( matcher[ expando ] ) {

				// Find the next relative operator (if any) for proper handling
				j = ++i;
				for ( ; j < len; j++ ) {
					if ( Expr.relative[ tokens[ j ].type ] ) {
						break;
					}
				}
				return setMatcher(
					i > 1 && elementMatcher( matchers ),
					i > 1 && toSelector(

						// If the preceding token was a descendant combinator, insert an implicit any-element `*`
						tokens.slice( 0, i - 1 )
							.concat( { value: tokens[ i - 2 ].type === " " ? "*" : "" } )
					).replace( rtrimCSS, "$1" ),
					matcher,
					i < j && matcherFromTokens( tokens.slice( i, j ) ),
					j < len && matcherFromTokens( ( tokens = tokens.slice( j ) ) ),
					j < len && toSelector( tokens )
				);
			}
			matchers.push( matcher );
		}
	}

	return elementMatcher( matchers );
}

function matcherFromGroupMatchers( elementMatchers, setMatchers ) {
	var bySet = setMatchers.length > 0,
		byElement = elementMatchers.length > 0,
		superMatcher = function( seed, context, xml, results, outermost ) {
			var elem, j, matcher,
				matchedCount = 0,
				i = "0",
				unmatched = seed && [],
				setMatched = [],
				contextBackup = outermostContext,

				// We must always have either seed elements or outermost context
				elems = seed || byElement && Expr.find.TAG( "*", outermost ),

				// Use integer dirruns iff this is the outermost matcher
				dirrunsUnique = ( dirruns += contextBackup == null ? 1 : Math.random() || 0.1 ),
				len = elems.length;

			if ( outermost ) {

				// Support: IE 11+, Edge 17 - 18+
				// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
				// two documents; shallow comparisons work.
				// eslint-disable-next-line eqeqeq
				outermostContext = context == document || context || outermost;
			}

			// Add elements passing elementMatchers directly to results
			// Support: iOS <=7 - 9 only
			// Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
			// elements by id. (see trac-14142)
			for ( ; i !== len && ( elem = elems[ i ] ) != null; i++ ) {
				if ( byElement && elem ) {
					j = 0;

					// Support: IE 11+, Edge 17 - 18+
					// IE/Edge sometimes throw a "Permission denied" error when strict-comparing
					// two documents; shallow comparisons work.
					// eslint-disable-next-line eqeqeq
					if ( !context && elem.ownerDocument != document ) {
						setDocument( elem );
						xml = !documentIsHTML;
					}
					while ( ( matcher = elementMatchers[ j++ ] ) ) {
						if ( matcher( elem, context || document, xml ) ) {
							push.call( results, elem );
							break;
						}
					}
					if ( outermost ) {
						dirruns = dirrunsUnique;
					}
				}

				// Track unmatched elements for set filters
				if ( bySet ) {

					// They will have gone through all possible matchers
					if ( ( elem = !matcher && elem ) ) {
						matchedCount--;
					}

					// Lengthen the array for every element, matched or not
					if ( seed ) {
						unmatched.push( elem );
					}
				}
			}

			// `i` is now the count of elements visited above, and adding it to `matchedCount`
			// makes the latter nonnegative.
			matchedCount += i;

			// Apply set filters to unmatched elements
			// NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
			// equals `i`), unless we didn't visit _any_ elements in the above loop because we have
			// no element matchers and no seed.
			// Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
			// case, which will result in a "00" `matchedCount` that differs from `i` but is also
			// numerically zero.
			if ( bySet && i !== matchedCount ) {
				j = 0;
				while ( ( matcher = setMatchers[ j++ ] ) ) {
					matcher( unmatched, setMatched, context, xml );
				}

				if ( seed ) {

					// Reintegrate element matches to eliminate the need for sorting
					if ( matchedCount > 0 ) {
						while ( i-- ) {
							if ( !( unmatched[ i ] || setMatched[ i ] ) ) {
								setMatched[ i ] = pop.call( results );
							}
						}
					}

					// Discard index placeholder values to get only actual matches
					setMatched = condense( setMatched );
				}

				// Add matches to results
				push.apply( results, setMatched );

				// Seedless set matches succeeding multiple successful matchers stipulate sorting
				if ( outermost && !seed && setMatched.length > 0 &&
					( matchedCount + setMatchers.length ) > 1 ) {

					jQuery.uniqueSort( results );
				}
			}

			// Override manipulation of globals by nested matchers
			if ( outermost ) {
				dirruns = dirrunsUnique;
				outermostContext = contextBackup;
			}

			return unmatched;
		};

	return bySet ?
		markFunction( superMatcher ) :
		superMatcher;
}

function compile( selector, match /* Internal Use Only */ ) {
	var i,
		setMatchers = [],
		elementMatchers = [],
		cached = compilerCache[ selector + " " ];

	if ( !cached ) {

		// Generate a function of recursive functions that can be used to check each element
		if ( !match ) {
			match = tokenize( selector );
		}
		i = match.length;
		while ( i-- ) {
			cached = matcherFromTokens( match[ i ] );
			if ( cached[ expando ] ) {
				setMatchers.push( cached );
			} else {
				elementMatchers.push( cached );
			}
		}

		// Cache the compiled function
		cached = compilerCache( selector,
			matcherFromGroupMatchers( elementMatchers, setMatchers ) );

		// Save selector and tokenization
		cached.selector = selector;
	}
	return cached;
}

/**
 * A low-level selection function that works with jQuery's compiled
 *  selector functions
 * @param {String|Function} selector A selector or a pre-compiled
 *  selector function built with jQuery selector compile
 * @param {Element} context
 * @param {Array} [results]
 * @param {Array} [seed] A set of elements to match against
 */
function select( selector, context, results, seed ) {
	var i, tokens, token, type, find,
		compiled = typeof selector === "function" && selector,
		match = !seed && tokenize( ( selector = compiled.selector || selector ) );

	results = results || [];

	// Try to minimize operations if there is only one selector in the list and no seed
	// (the latter of which guarantees us context)
	if ( match.length === 1 ) {

		// Reduce context if the leading compound selector is an ID
		tokens = match[ 0 ] = match[ 0 ].slice( 0 );
		if ( tokens.length > 2 && ( token = tokens[ 0 ] ).type === "ID" &&
				context.nodeType === 9 && documentIsHTML && Expr.relative[ tokens[ 1 ].type ] ) {

			context = ( Expr.find.ID(
				token.matches[ 0 ].replace( runescape, funescape ),
				context
			) || [] )[ 0 ];
			if ( !context ) {
				return results;

			// Precompiled matchers will still verify ancestry, so step up a level
			} else if ( compiled ) {
				context = context.parentNode;
			}

			selector = selector.slice( tokens.shift().value.length );
		}

		// Fetch a seed set for right-to-left matching
		i = matchExpr.needsContext.test( selector ) ? 0 : tokens.length;
		while ( i-- ) {
			token = tokens[ i ];

			// Abort if we hit a combinator
			if ( Expr.relative[ ( type = token.type ) ] ) {
				break;
			}
			if ( ( find = Expr.find[ type ] ) ) {

				// Search, expanding context for leading sibling combinators
				if ( ( seed = find(
					token.matches[ 0 ].replace( runescape, funescape ),
					rsibling.test( tokens[ 0 ].type ) &&
						testContext( context.parentNode ) || context
				) ) ) {

					// If seed is empty or no tokens remain, we can return early
					tokens.splice( i, 1 );
					selector = seed.length && toSelector( tokens );
					if ( !selector ) {
						push.apply( results, seed );
						return results;
					}

					break;
				}
			}
		}
	}

	// Compile and execute a filtering function if one is not provided
	// Provide `match` to avoid retokenization if we modified the selector above
	( compiled || compile( selector, match ) )(
		seed,
		context,
		!documentIsHTML,
		results,
		!context || rsibling.test( selector ) && testContext( context.parentNode ) || context
	);
	return results;
}

// One-time assignments

// Support: Android <=4.0 - 4.1+
// Sort stability
support.sortStable = expando.split( "" ).sort( sortOrder ).join( "" ) === expando;

// Initialize against the default document
setDocument();

// Support: Android <=4.0 - 4.1+
// Detached nodes confoundingly follow *each other*
support.sortDetached = assert( function( el ) {

	// Should return 1, but returns 4 (following)
	return el.compareDocumentPosition( document.createElement( "fieldset" ) ) & 1;
} );

jQuery.find = find;

// Deprecated
jQuery.expr[ ":" ] = jQuery.expr.pseudos;
jQuery.unique = jQuery.uniqueSort;

// These have always been private, but they used to be documented as part of
// Sizzle so let's maintain them for now for backwards compatibility purposes.
find.compile = compile;
find.select = select;
find.setDocument = setDocument;
find.tokenize = tokenize;

find.escape = jQuery.escapeSelector;
find.getText = jQuery.text;
find.isXML = jQuery.isXMLDoc;
find.selectors = jQuery.expr;
find.support = jQuery.support;
find.uniqueSort = jQuery.uniqueSort;

	/* eslint-enable */

} )();


var dir = function( elem, dir, until ) {
	var matched = [],
		truncate = until !== undefined;

	while ( ( elem = elem[ dir ] ) && elem.nodeType !== 9 ) {
		if ( elem.nodeType === 1 ) {
			if ( truncate && jQuery( elem ).is( until ) ) {
				break;
			}
			matched.push( elem );
		}
	}
	return matched;
};


var siblings = function( n, elem ) {
	var matched = [];

	for ( ; n; n = n.nextSibling ) {
		if ( n.nodeType === 1 && n !== elem ) {
			matched.push( n );
		}
	}

	return matched;
};


var rneedsContext = jQuery.expr.match.needsContext;

var rsingleTag = ( /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i );



// Implement the identical functionality for filter and not
function winnow( elements, qualifier, not ) {
	if ( isFunction( qualifier ) ) {
		return jQuery.grep( elements, function( elem, i ) {
			return !!qualifier.call( elem, i, elem ) !== not;
		} );
	}

	// Single element
	if ( qualifier.nodeType ) {
		return jQuery.grep( elements, function( elem ) {
			return ( elem === qualifier ) !== not;
		} );
	}

	// Arraylike of elements (jQuery, arguments, Array)
	if ( typeof qualifier !== "string" ) {
		return jQuery.grep( elements, function( elem ) {
			return ( indexOf.call( qualifier, elem ) > -1 ) !== not;
		} );
	}

	// Filtered directly for both simple and complex selectors
	return jQuery.filter( qualifier, elements, not );
}

jQuery.filter = function( expr, elems, not ) {
	var elem = elems[ 0 ];

	if ( not ) {
		expr = ":not(" + expr + ")";
	}

	if ( elems.length === 1 && elem.nodeType === 1 ) {
		return jQuery.find.matchesSelector( elem, expr ) ? [ elem ] : [];
	}

	return jQuery.find.matches( expr, jQuery.grep( elems, function( elem ) {
		return elem.nodeType === 1;
	} ) );
};

jQuery.fn.extend( {
	find: function( selector ) {
		var i, ret,
			len = this.length,
			self = this;

		if ( typeof selector !== "string" ) {
			return this.pushStack( jQuery( selector ).filter( function() {
				for ( i = 0; i < len; i++ ) {
					if ( jQuery.contains( self[ i ], this ) ) {
						return true;
					}
				}
			} ) );
		}

		ret = this.pushStack( [] );

		for ( i = 0; i < len; i++ ) {
			jQuery.find( selector, self[ i ], ret );
		}

		return len > 1 ? jQuery.uniqueSort( ret ) : ret;
	},
	filter: function( selector ) {
		return this.pushStack( winnow( this, selector || [], false ) );
	},
	not: function( selector ) {
		return this.pushStack( winnow( this, selector || [], true ) );
	},
	is: function( selector ) {
		return !!winnow(
			this,

			// If this is a positional/relative selector, check membership in the returned set
			// so $("p:first").is("p:last") won't return true for a doc with two "p".
			typeof selector === "string" && rneedsContext.test( selector ) ?
				jQuery( selector ) :
				selector || [],
			false
		).length;
	}
} );


// Initialize a jQuery object


// A central reference to the root jQuery(document)
var rootjQuery,

	// A simple way to check for HTML strings
	// Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
	// Strict HTML recognition (trac-11290: must start with <)
	// Shortcut simple #id case for speed
	rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,

	init = jQuery.fn.init = function( selector, context, root ) {
		var match, elem;

		// HANDLE: $(""), $(null), $(undefined), $(false)
		if ( !selector ) {
			return this;
		}

		// Method init() accepts an alternate rootjQuery
		// so migrate can support jQuery.sub (gh-2101)
		root = root || rootjQuery;

		// Handle HTML strings
		if ( typeof selector === "string" ) {
			if ( selector[ 0 ] === "<" &&
				selector[ selector.length - 1 ] === ">" &&
				selector.length >= 3 ) {

				// Assume that strings that start and end with <> are HTML and skip the regex check
				match = [ null, selector, null ];

			} else {
				match = rquickExpr.exec( selector );
			}

			// Match html or make sure no context is specified for #id
			if ( match && ( match[ 1 ] || !context ) ) {

				// HANDLE: $(html) -> $(array)
				if ( match[ 1 ] ) {
					context = context instanceof jQuery ? context[ 0 ] : context;

					// Option to run scripts is true for back-compat
					// Intentionally let the error be thrown if parseHTML is not present
					jQuery.merge( this, jQuery.parseHTML(
						match[ 1 ],
						context && context.nodeType ? context.ownerDocument || context : document,
						true
					) );

					// HANDLE: $(html, props)
					if ( rsingleTag.test( match[ 1 ] ) && jQuery.isPlainObject( context ) ) {
						for ( match in context ) {

							// Properties of context are called as methods if possible
							if ( isFunction( this[ match ] ) ) {
								this[ match ]( context[ match ] );

							// ...and otherwise set as attributes
							} else {
								this.attr( match, context[ match ] );
							}
						}
					}

					return this;

				// HANDLE: $(#id)
				} else {
					elem = document.getElementById( match[ 2 ] );

					if ( elem ) {

						// Inject the element directly into the jQuery object
						this[ 0 ] = elem;
						this.length = 1;
					}
					return this;
				}

			// HANDLE: $(expr, $(...))
			} else if ( !context || context.jquery ) {
				return ( context || root ).find( selector );

			// HANDLE: $(expr, context)
			// (which is just equivalent to: $(context).find(expr)
			} else {
				return this.constructor( context ).find( selector );
			}

		// HANDLE: $(DOMElement)
		} else if ( selector.nodeType ) {
			this[ 0 ] = selector;
			this.length = 1;
			return this;

		// HANDLE: $(function)
		// Shortcut for document ready
		} else if ( isFunction( selector ) ) {
			return root.ready !== undefined ?
				root.ready( selector ) :

				// Execute immediately if ready is not present
				selector( jQuery );
		}

		return jQuery.makeArray( selector, this );
	};

// Give the init function the jQuery prototype for later instantiation
init.prototype = jQuery.fn;

// Initialize central reference
rootjQuery = jQuery( document );


var rparentsprev = /^(?:parents|prev(?:Until|All))/,

	// Methods guaranteed to produce a unique set when starting from a unique set
	guaranteedUnique = {
		children: true,
		contents: true,
		next: true,
		prev: true
	};

jQuery.fn.extend( {
	has: function( target ) {
		var targets = jQuery( target, this ),
			l = targets.length;

		return this.filter( function() {
			var i = 0;
			for ( ; i < l; i++ ) {
				if ( jQuery.contains( this, targets[ i ] ) ) {
					return true;
				}
			}
		} );
	},

	closest: function( selectors, context ) {
		var cur,
			i = 0,
			l = this.length,
			matched = [],
			targets = typeof selectors !== "string" && jQuery( selectors );

		// Positional selectors never match, since there's no _selection_ context
		if ( !rneedsContext.test( selectors ) ) {
			for ( ; i < l; i++ ) {
				for ( cur = this[ i ]; cur && cur !== context; cur = cur.parentNode ) {

					// Always skip document fragments
					if ( cur.nodeType < 11 && ( targets ?
						targets.index( cur ) > -1 :

						// Don't pass non-elements to jQuery#find
						cur.nodeType === 1 &&
							jQuery.find.matchesSelector( cur, selectors ) ) ) {

						matched.push( cur );
						break;
					}
				}
			}
		}

		return this.pushStack( matched.length > 1 ? jQuery.uniqueSort( matched ) : matched );
	},

	// Determine the position of an element within the set
	index: function( elem ) {

		// No argument, return index in parent
		if ( !elem ) {
			return ( this[ 0 ] && this[ 0 ].parentNode ) ? this.first().prevAll().length : -1;
		}

		// Index in selector
		if ( typeof elem === "string" ) {
			return indexOf.call( jQuery( elem ), this[ 0 ] );
		}

		// Locate the position of the desired element
		return indexOf.call( this,

			// If it receives a jQuery object, the first element is used
			elem.jquery ? elem[ 0 ] : elem
		);
	},

	add: function( selector, context ) {
		return this.pushStack(
			jQuery.uniqueSort(
				jQuery.merge( this.get(), jQuery( selector, context ) )
			)
		);
	},

	addBack: function( selector ) {
		return this.add( selector == null ?
			this.prevObject : this.prevObject.filter( selector )
		);
	}
} );

function sibling( cur, dir ) {
	while ( ( cur = cur[ dir ] ) && cur.nodeType !== 1 ) {}
	return cur;
}

jQuery.each( {
	parent: function( elem ) {
		var parent = elem.parentNode;
		return parent && parent.nodeType !== 11 ? parent : null;
	},
	parents: function( elem ) {
		return dir( elem, "parentNode" );
	},
	parentsUntil: function( elem, _i, until ) {
		return dir( elem, "parentNode", until );
	},
	next: function( elem ) {
		return sibling( elem, "nextSibling" );
	},
	prev: function( elem ) {
		return sibling( elem, "previousSibling" );
	},
	nextAll: function( elem ) {
		return dir( elem, "nextSibling" );
	},
	prevAll: function( elem ) {
		return dir( elem, "previousSibling" );
	},
	nextUntil: function( elem, _i, until ) {
		return dir( elem, "nextSibling", until );
	},
	prevUntil: function( elem, _i, until ) {
		return dir( elem, "previousSibling", until );
	},
	siblings: function( elem ) {
		return siblings( ( elem.parentNode || {} ).firstChild, elem );
	},
	children: function( elem ) {
		return siblings( elem.firstChild );
	},
	contents: function( elem ) {
		if ( elem.contentDocument != null &&

			// Support: IE 11+
			// <object> elements with no `data` attribute has an object
			// `contentDocument` with a `null` prototype.
			getProto( elem.contentDocument ) ) {

			return elem.contentDocument;
		}

		// Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
		// Treat the template element as a regular one in browsers that
		// don't support it.
		if ( nodeName( elem, "template" ) ) {
			elem = elem.content || elem;
		}

		return jQuery.merge( [], elem.childNodes );
	}
}, function( name, fn ) {
	jQuery.fn[ name ] = function( until, selector ) {
		var matched = jQuery.map( this, fn, until );

		if ( name.slice( -5 ) !== "Until" ) {
			selector = until;
		}

		if ( selector && typeof selector === "string" ) {
			matched = jQuery.filter( selector, matched );
		}

		if ( this.length > 1 ) {

			// Remove duplicates
			if ( !guaranteedUnique[ name ] ) {
				jQuery.uniqueSort( matched );
			}

			// Reverse order for parents* and prev-derivatives
			if ( rparentsprev.test( name ) ) {
				matched.reverse();
			}
		}

		return this.pushStack( matched );
	};
} );
var rnothtmlwhite = ( /[^\x20\t\r\n\f]+/g );



// Convert String-formatted options into Object-formatted ones
function createOptions( options ) {
	var object = {};
	jQuery.each( options.match( rnothtmlwhite ) || [], function( _, flag ) {
		object[ flag ] = true;
	} );
	return object;
}

/*
 * Create a callback list using the following parameters:
 *
 *	options: an optional list of space-separated options that will change how
 *			the callback list behaves or a more traditional option object
 *
 * By default a callback list will act like an event callback list and can be
 * "fired" multiple times.
 *
 * Possible options:
 *
 *	once:			will ensure the callback list can only be fired once (like a Deferred)
 *
 *	memory:			will keep track of previous values and will call any callback added
 *					after the list has been fired right away with the latest "memorized"
 *					values (like a Deferred)
 *
 *	unique:			will ensure a callback can only be added once (no duplicate in the list)
 *
 *	stopOnFalse:	interrupt callings when a callback returns false
 *
 */
jQuery.Callbacks = function( options ) {

	// Convert options from String-formatted to Object-formatted if needed
	// (we check in cache first)
	options = typeof options === "string" ?
		createOptions( options ) :
		jQuery.extend( {}, options );

	var // Flag to know if list is currently firing
		firing,

		// Last fire value for non-forgettable lists
		memory,

		// Flag to know if list was already fired
		fired,

		// Flag to prevent firing
		locked,

		// Actual callback list
		list = [],

		// Queue of execution data for repeatable lists
		queue = [],

		// Index of currently firing callback (modified by add/remove as needed)
		firingIndex = -1,

		// Fire callbacks
		fire = function() {

			// Enforce single-firing
			locked = locked || options.once;

			// Execute callbacks for all pending executions,
			// respecting firingIndex overrides and runtime changes
			fired = firing = true;
			for ( ; queue.length; firingIndex = -1 ) {
				memory = queue.shift();
				while ( ++firingIndex < list.length ) {

					// Run callback and check for early termination
					if ( list[ firingIndex ].apply( memory[ 0 ], memory[ 1 ] ) === false &&
						options.stopOnFalse ) {

						// Jump to end and forget the data so .add doesn't re-fire
						firingIndex = list.length;
						memory = false;
					}
				}
			}

			// Forget the data if we're done with it
			if ( !options.memory ) {
				memory = false;
			}

			firing = false;

			// Clean up if we're done firing for good
			if ( locked ) {

				// Keep an empty list if we have data for future add calls
				if ( memory ) {
					list = [];

				// Otherwise, this object is spent
				} else {
					list = "";
				}
			}
		},

		// Actual Callbacks object
		self = {

			// Add a callback or a collection of callbacks to the list
			add: function() {
				if ( list ) {

					// If we have memory from a past run, we should fire after adding
					if ( memory && !firing ) {
						firingIndex = list.length - 1;
						queue.push( memory );
					}

					( function add( args ) {
						jQuery.each( args, function( _, arg ) {
							if ( isFunction( arg ) ) {
								if ( !options.unique || !self.has( arg ) ) {
									list.push( arg );
								}
							} else if ( arg && arg.length && toType( arg ) !== "string" ) {

								// Inspect recursively
								add( arg );
							}
						} );
					} )( arguments );

					if ( memory && !firing ) {
						fire();
					}
				}
				return this;
			},

			// Remove a callback from the list
			remove: function() {
				jQuery.each( arguments, function( _, arg ) {
					var index;
					while ( ( index = jQuery.inArray( arg, list, index ) ) > -1 ) {
						list.splice( index, 1 );

						// Handle firing indexes
						if ( index <= firingIndex ) {
							firingIndex--;
						}
					}
				} );
				return this;
			},

			// Check if a given callback is in the list.
			// If no argument is given, return whether or not list has callbacks attached.
			has: function( fn ) {
				return fn ?
					jQuery.inArray( fn, list ) > -1 :
					list.length > 0;
			},

			// Remove all callbacks from the list
			empty: function() {
				if ( list ) {
					list = [];
				}
				return this;
			},

			// Disable .fire and .add
			// Abort any current/pending executions
			// Clear all callbacks and values
			disable: function() {
				locked = queue = [];
				list = memory = "";
				return this;
			},
			disabled: function() {
				return !list;
			},

			// Disable .fire
			// Also disable .add unless we have memory (since it would have no effect)
			// Abort any pending executions
			lock: function() {
				locked = queue = [];
				if ( !memory && !firing ) {
					list = memory = "";
				}
				return this;
			},
			locked: function() {
				return !!locked;
			},

			// Call all callbacks with the given context and arguments
			fireWith: function( context, args ) {
				if ( !locked ) {
					args = args || [];
					args = [ context, args.slice ? args.slice() : args ];
					queue.push( args );
					if ( !firing ) {
						fire();
					}
				}
				return this;
			},

			// Call all the callbacks with the given arguments
			fire: function() {
				self.fireWith( this, arguments );
				return this;
			},

			// To know if the callbacks have already been called at least once
			fired: function() {
				return !!fired;
			}
		};

	return self;
};


function Identity( v ) {
	return v;
}
function Thrower( ex ) {
	throw ex;
}

function adoptValue( value, resolve, reject, noValue ) {
	var method;

	try {

		// Check for promise aspect first to privilege synchronous behavior
		if ( value && isFunction( ( method = value.promise ) ) ) {
			method.call( value ).done( resolve ).fail( reject );

		// Other thenables
		} else if ( value && isFunction( ( method = value.then ) ) ) {
			method.call( value, resolve, reject );

		// Other non-thenables
		} else {

			// Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
			// * false: [ value ].slice( 0 ) => resolve( value )
			// * true: [ value ].slice( 1 ) => resolve()
			resolve.apply( undefined, [ value ].slice( noValue ) );
		}

	// For Promises/A+, convert exceptions into rejections
	// Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
	// Deferred#then to conditionally suppress rejection.
	} catch ( value ) {

		// Support: Android 4.0 only
		// Strict mode functions invoked without .call/.apply get global-object context
		reject.apply( undefined, [ value ] );
	}
}

jQuery.extend( {

	Deferred: function( func ) {
		var tuples = [

				// action, add listener, callbacks,
				// ... .then handlers, argument index, [final state]
				[ "notify", "progress", jQuery.Callbacks( "memory" ),
					jQuery.Callbacks( "memory" ), 2 ],
				[ "resolve", "done", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 0, "resolved" ],
				[ "reject", "fail", jQuery.Callbacks( "once memory" ),
					jQuery.Callbacks( "once memory" ), 1, "rejected" ]
			],
			state = "pending",
			promise = {
				state: function() {
					return state;
				},
				always: function() {
					deferred.done( arguments ).fail( arguments );
					return this;
				},
				"catch": function( fn ) {
					return promise.then( null, fn );
				},

				// Keep pipe for back-compat
				pipe: function( /* fnDone, fnFail, fnProgress */ ) {
					var fns = arguments;

					return jQuery.Deferred( function( newDefer ) {
						jQuery.each( tuples, function( _i, tuple ) {

							// Map tuples (progress, done, fail) to arguments (done, fail, progress)
							var fn = isFunction( fns[ tuple[ 4 ] ] ) && fns[ tuple[ 4 ] ];

							// deferred.progress(function() { bind to newDefer or newDefer.notify })
							// deferred.done(function() { bind to newDefer or newDefer.resolve })
							// deferred.fail(function() { bind to newDefer or newDefer.reject })
							deferred[ tuple[ 1 ] ]( function() {
								var returned = fn && fn.apply( this, arguments );
								if ( returned && isFunction( returned.promise ) ) {
									returned.promise()
										.progress( newDefer.notify )
										.done( newDefer.resolve )
										.fail( newDefer.reject );
								} else {
									newDefer[ tuple[ 0 ] + "With" ](
										this,
										fn ? [ returned ] : arguments
									);
								}
							} );
						} );
						fns = null;
					} ).promise();
				},
				then: function( onFulfilled, onRejected, onProgress ) {
					var maxDepth = 0;
					function resolve( depth, deferred, handler, special ) {
						return function() {
							var that = this,
								args = arguments,
								mightThrow = function() {
									var returned, then;

									// Support: Promises/A+ section 2.3.3.3.3
									// https://promisesaplus.com/#point-59
									// Ignore double-resolution attempts
									if ( depth < maxDepth ) {
										return;
									}

									returned = handler.apply( that, args );

									// Support: Promises/A+ section 2.3.1
									// https://promisesaplus.com/#point-48
									if ( returned === deferred.promise() ) {
										throw new TypeError( "Thenable self-resolution" );
									}

									// Support: Promises/A+ sections 2.3.3.1, 3.5
									// https://promisesaplus.com/#point-54
									// https://promisesaplus.com/#point-75
									// Retrieve `then` only once
									then = returned &&

										// Support: Promises/A+ section 2.3.4
										// https://promisesaplus.com/#point-64
										// Only check objects and functions for thenability
										( typeof returned === "object" ||
											typeof returned === "function" ) &&
										returned.then;

									// Handle a returned thenable
									if ( isFunction( then ) ) {

										// Special processors (notify) just wait for resolution
										if ( special ) {
											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special )
											);

										// Normal processors (resolve) also hook into progress
										} else {

											// ...and disregard older resolution values
											maxDepth++;

											then.call(
												returned,
												resolve( maxDepth, deferred, Identity, special ),
												resolve( maxDepth, deferred, Thrower, special ),
												resolve( maxDepth, deferred, Identity,
													deferred.notifyWith )
											);
										}

									// Handle all other returned values
									} else {

										// Only substitute handlers pass on context
										// and multiple values (non-spec behavior)
										if ( handler !== Identity ) {
											that = undefined;
											args = [ returned ];
										}

										// Process the value(s)
										// Default process is resolve
										( special || deferred.resolveWith )( that, args );
									}
								},

								// Only normal processors (resolve) catch and reject exceptions
								process = special ?
									mightThrow :
									function() {
										try {
											mightThrow();
										} catch ( e ) {

											if ( jQuery.Deferred.exceptionHook ) {
												jQuery.Deferred.exceptionHook( e,
													process.error );
											}

											// Support: Promises/A+ section 2.3.3.3.4.1
											// https://promisesaplus.com/#point-61
											// Ignore post-resolution exceptions
											if ( depth + 1 >= maxDepth ) {

												// Only substitute handlers pass on context
												// and multiple values (non-spec behavior)
												if ( handler !== Thrower ) {
													that = undefined;
													args = [ e ];
												}

												deferred.rejectWith( that, args );
											}
										}
									};

							// Support: Promises/A+ section 2.3.3.3.1
							// https://promisesaplus.com/#point-57
							// Re-resolve promises immediately to dodge false rejection from
							// subsequent errors
							if ( depth ) {
								process();
							} else {

								// Call an optional hook to record the error, in case of exception
								// since it's otherwise lost when execution goes async
								if ( jQuery.Deferred.getErrorHook ) {
									process.error = jQuery.Deferred.getErrorHook();

								// The deprecated alias of the above. While the name suggests
								// returning the stack, not an error instance, jQuery just passes
								// it directly to `console.warn` so both will work; an instance
								// just better cooperates with source maps.
								} else if ( jQuery.Deferred.getStackHook ) {
									process.error = jQuery.Deferred.getStackHook();
								}
								window.setTimeout( process );
							}
						};
					}

					return jQuery.Deferred( function( newDefer ) {

						// progress_handlers.add( ... )
						tuples[ 0 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onProgress ) ?
									onProgress :
									Identity,
								newDefer.notifyWith
							)
						);

						// fulfilled_handlers.add( ... )
						tuples[ 1 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onFulfilled ) ?
									onFulfilled :
									Identity
							)
						);

						// rejected_handlers.add( ... )
						tuples[ 2 ][ 3 ].add(
							resolve(
								0,
								newDefer,
								isFunction( onRejected ) ?
									onRejected :
									Thrower
							)
						);
					} ).promise();
				},

				// Get a promise for this deferred
				// If obj is provided, the promise aspect is added to the object
				promise: function( obj ) {
					return obj != null ? jQuery.extend( obj, promise ) : promise;
				}
			},
			deferred = {};

		// Add list-specific methods
		jQuery.each( tuples, function( i, tuple ) {
			var list = tuple[ 2 ],
				stateString = tuple[ 5 ];

			// promise.progress = list.add
			// promise.done = list.add
			// promise.fail = list.add
			promise[ tuple[ 1 ] ] = list.add;

			// Handle state
			if ( stateString ) {
				list.add(
					function() {

						// state = "resolved" (i.e., fulfilled)
						// state = "rejected"
						state = stateString;
					},

					// rejected_callbacks.disable
					// fulfilled_callbacks.disable
					tuples[ 3 - i ][ 2 ].disable,

					// rejected_handlers.disable
					// fulfilled_handlers.disable
					tuples[ 3 - i ][ 3 ].disable,

					// progress_callbacks.lock
					tuples[ 0 ][ 2 ].lock,

					// progress_handlers.lock
					tuples[ 0 ][ 3 ].lock
				);
			}

			// progress_handlers.fire
			// fulfilled_handlers.fire
			// rejected_handlers.fire
			list.add( tuple[ 3 ].fire );

			// deferred.notify = function() { deferred.notifyWith(...) }
			// deferred.resolve = function() { deferred.resolveWith(...) }
			// deferred.reject = function() { deferred.rejectWith(...) }
			deferred[ tuple[ 0 ] ] = function() {
				deferred[ tuple[ 0 ] + "With" ]( this === deferred ? undefined : this, arguments );
				return this;
			};

			// deferred.notifyWith = list.fireWith
			// deferred.resolveWith = list.fireWith
			// deferred.rejectWith = list.fireWith
			deferred[ tuple[ 0 ] + "With" ] = list.fireWith;
		} );

		// Make the deferred a promise
		promise.promise( deferred );

		// Call given func if any
		if ( func ) {
			func.call( deferred, deferred );
		}

		// All done!
		return deferred;
	},

	// Deferred helper
	when: function( singleValue ) {
		var

			// count of uncompleted subordinates
			remaining = arguments.length,

			// count of unprocessed arguments
			i = remaining,

			// subordinate fulfillment data
			resolveContexts = Array( i ),
			resolveValues = slice.call( arguments ),

			// the primary Deferred
			primary = jQuery.Deferred(),

			// subordinate callback factory
			updateFunc = function( i ) {
				return function( value ) {
					resolveContexts[ i ] = this;
					resolveValues[ i ] = arguments.length > 1 ? slice.call( arguments ) : value;
					if ( !( --remaining ) ) {
						primary.resolveWith( resolveContexts, resolveValues );
					}
				};
			};

		// Single- and empty arguments are adopted like Promise.resolve
		if ( remaining <= 1 ) {
			adoptValue( singleValue, primary.done( updateFunc( i ) ).resolve, primary.reject,
				!remaining );

			// Use .then() to unwrap secondary thenables (cf. gh-3000)
			if ( primary.state() === "pending" ||
				isFunction( resolveValues[ i ] && resolveValues[ i ].then ) ) {

				return primary.then();
			}
		}

		// Multiple arguments are aggregated like Promise.all array elements
		while ( i-- ) {
			adoptValue( resolveValues[ i ], updateFunc( i ), primary.reject );
		}

		return primary.promise();
	}
} );


// These usually indicate a programmer mistake during development,
// warn about them ASAP rather than swallowing them by default.
var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

// If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
// captured before the async barrier to get the original error cause
// which may otherwise be hidden.
jQuery.Deferred.exceptionHook = function( error, asyncError ) {

	// Support: IE 8 - 9 only
	// Console exists when dev tools are open, which can happen at any time
	if ( window.console && window.console.warn && error && rerrorNames.test( error.name ) ) {
		window.console.warn( "jQuery.Deferred exception: " + error.message,
			error.stack, asyncError );
	}
};




jQuery.readyException = function( error ) {
	window.setTimeout( function() {
		throw error;
	} );
};




// The deferred used on DOM ready
var readyList = jQuery.Deferred();

jQuery.fn.ready = function( fn ) {

	readyList
		.then( fn )

		// Wrap jQuery.readyException in a function so that the lookup
		// happens at the time of error handling instead of callback
		// registration.
		.catch( function( error ) {
			jQuery.readyException( error );
		} );

	return this;
};

jQuery.extend( {

	// Is the DOM ready to be used? Set to true once it occurs.
	isReady: false,

	// A counter to track how many items to wait for before
	// the ready event fires. See trac-6781
	readyWait: 1,

	// Handle when the DOM is ready
	ready: function( wait ) {

		// Abort if there are pending holds or we're already ready
		if ( wait === true ? --jQuery.readyWait : jQuery.isReady ) {
			return;
		}

		// Remember that the DOM is ready
		jQuery.isReady = true;

		// If a normal DOM Ready event fired, decrement, and wait if need be
		if ( wait !== true && --jQuery.readyWait > 0 ) {
			return;
		}

		// If there are functions bound, to execute
		readyList.resolveWith( document, [ jQuery ] );
	}
} );

jQuery.ready.then = readyList.then;

// The ready event handler and self cleanup method
function completed() {
	document.removeEventListener( "DOMContentLoaded", completed );
	window.removeEventListener( "load", completed );
	jQuery.ready();
}

// Catch cases where $(document).ready() is called
// after the browser event has already occurred.
// Support: IE <=9 - 10 only
// Older IE sometimes signals "interactive" too soon
if ( document.readyState === "complete" ||
	( document.readyState !== "loading" && !document.documentElement.doScroll ) ) {

	// Handle it asynchronously to allow scripts the opportunity to delay ready
	window.setTimeout( jQuery.ready );

} else {

	// Use the handy event callback
	document.addEventListener( "DOMContentLoaded", completed );

	// A fallback to window.onload, that will always work
	window.addEventListener( "load", completed );
}




// Multifunctional method to get and set values of a collection
// The value/s can optionally be executed if it's a function
var access = function( elems, fn, key, value, chainable, emptyGet, raw ) {
	var i = 0,
		len = elems.length,
		bulk = key == null;

	// Sets many values
	if ( toType( key ) === "object" ) {
		chainable = true;
		for ( i in key ) {
			access( elems, fn, i, key[ i ], true, emptyGet, raw );
		}

	// Sets one value
	} else if ( value !== undefined ) {
		chainable = true;

		if ( !isFunction( value ) ) {
			raw = true;
		}

		if ( bulk ) {

			// Bulk operations run against the entire set
			if ( raw ) {
				fn.call( elems, value );
				fn = null;

			// ...except when executing function values
			} else {
				bulk = fn;
				fn = function( elem, _key, value ) {
					return bulk.call( jQuery( elem ), value );
				};
			}
		}

		if ( fn ) {
			for ( ; i < len; i++ ) {
				fn(
					elems[ i ], key, raw ?
						value :
						value.call( elems[ i ], i, fn( elems[ i ], key ) )
				);
			}
		}
	}

	if ( chainable ) {
		return elems;
	}

	// Gets
	if ( bulk ) {
		return fn.call( elems );
	}

	return len ? fn( elems[ 0 ], key ) : emptyGet;
};


// Matches dashed string for camelizing
var rmsPrefix = /^-ms-/,
	rdashAlpha = /-([a-z])/g;

// Used by camelCase as callback to replace()
function fcamelCase( _all, letter ) {
	return letter.toUpperCase();
}

// Convert dashed to camelCase; used by the css and data modules
// Support: IE <=9 - 11, Edge 12 - 15
// Microsoft forgot to hump their vendor prefix (trac-9572)
function camelCase( string ) {
	return string.replace( rmsPrefix, "ms-" ).replace( rdashAlpha, fcamelCase );
}
var acceptData = function( owner ) {

	// Accepts only:
	//  - Node
	//    - Node.ELEMENT_NODE
	//    - Node.DOCUMENT_NODE
	//  - Object
	//    - Any
	return owner.nodeType === 1 || owner.nodeType === 9 || !( +owner.nodeType );
};




function Data() {
	this.expando = jQuery.expando + Data.uid++;
}

Data.uid = 1;

Data.prototype = {

	cache: function( owner ) {

		// Check if the owner object already has a cache
		var value = owner[ this.expando ];

		// If not, create one
		if ( !value ) {
			value = {};

			// We can accept data for non-element nodes in modern browsers,
			// but we should not, see trac-8335.
			// Always return an empty object.
			if ( acceptData( owner ) ) {

				// If it is a node unlikely to be stringify-ed or looped over
				// use plain assignment
				if ( owner.nodeType ) {
					owner[ this.expando ] = value;

				// Otherwise secure it in a non-enumerable property
				// configurable must be true to allow the property to be
				// deleted when data is removed
				} else {
					Object.defineProperty( owner, this.expando, {
						value: value,
						configurable: true
					} );
				}
			}
		}

		return value;
	},
	set: function( owner, data, value ) {
		var prop,
			cache = this.cache( owner );

		// Handle: [ owner, key, value ] args
		// Always use camelCase key (gh-2257)
		if ( typeof data === "string" ) {
			cache[ camelCase( data ) ] = value;

		// Handle: [ owner, { properties } ] args
		} else {

			// Copy the properties one-by-one to the cache object
			for ( prop in data ) {
				cache[ camelCase( prop ) ] = data[ prop ];
			}
		}
		return cache;
	},
	get: function( owner, key ) {
		return key === undefined ?
			this.cache( owner ) :

			// Always use camelCase key (gh-2257)
			owner[ this.expando ] && owner[ this.expando ][ camelCase( key ) ];
	},
	access: function( owner, key, value ) {

		// In cases where either:
		//
		//   1. No key was specified
		//   2. A string key was specified, but no value provided
		//
		// Take the "read" path and allow the get method to determine
		// which value to return, respectively either:
		//
		//   1. The entire cache object
		//   2. The data stored at the key
		//
		if ( key === undefined ||
				( ( key && typeof key === "string" ) && value === undefined ) ) {

			return this.get( owner, key );
		}

		// When the key is not a string, or both a key and value
		// are specified, set or extend (existing objects) with either:
		//
		//   1. An object of properties
		//   2. A key and value
		//
		this.set( owner, key, value );

		// Since the "set" path can have two possible entry points
		// return the expected data based on which path was taken[*]
		return value !== undefined ? value : key;
	},
	remove: function( owner, key ) {
		var i,
			cache = owner[ this.expando ];

		if ( cache === undefined ) {
			return;
		}

		if ( key !== undefined ) {

			// Support array or space separated string of keys
			if ( Array.isArray( key ) ) {

				// If key is an array of keys...
				// We always set camelCase keys, so remove that.
				key = key.map( camelCase );
			} else {
				key = camelCase( key );

				// If a key with the spaces exists, use it.
				// Otherwise, create an array by matching non-whitespace
				key = key in cache ?
					[ key ] :
					( key.match( rnothtmlwhite ) || [] );
			}

			i = key.length;

			while ( i-- ) {
				delete cache[ key[ i ] ];
			}
		}

		// Remove the expando if there's no more data
		if ( key === undefined || jQuery.isEmptyObject( cache ) ) {

			// Support: Chrome <=35 - 45
			// Webkit & Blink performance suffers when deleting properties
			// from DOM nodes, so set to undefined instead
			// https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
			if ( owner.nodeType ) {
				owner[ this.expando ] = undefined;
			} else {
				delete owner[ this.expando ];
			}
		}
	},
	hasData: function( owner ) {
		var cache = owner[ this.expando ];
		return cache !== undefined && !jQuery.isEmptyObject( cache );
	}
};
var dataPriv = new Data();

var dataUser = new Data();



//	Implementation Summary
//
//	1. Enforce API surface and semantic compatibility with 1.9.x branch
//	2. Improve the module's maintainability by reducing the storage
//		paths to a single mechanism.
//	3. Use the same single mechanism to support "private" and "user" data.
//	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
//	5. Avoid exposing implementation details on user objects (eg. expando properties)
//	6. Provide a clear path for implementation upgrade to WeakMap in 2014

var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
	rmultiDash = /[A-Z]/g;

function getData( data ) {
	if ( data === "true" ) {
		return true;
	}

	if ( data === "false" ) {
		return false;
	}

	if ( data === "null" ) {
		return null;
	}

	// Only convert to a number if it doesn't change the string
	if ( data === +data + "" ) {
		return +data;
	}

	if ( rbrace.test( data ) ) {
		return JSON.parse( data );
	}

	return data;
}

function dataAttr( elem, key, data ) {
	var name;

	// If nothing was found internally, try to fetch any
	// data from the HTML5 data-* attribute
	if ( data === undefined && elem.nodeType === 1 ) {
		name = "data-" + key.replace( rmultiDash, "-$&" ).toLowerCase();
		data = elem.getAttribute( name );

		if ( typeof data === "string" ) {
			try {
				data = getData( data );
			} catch ( e ) {}

			// Make sure we set the data so it isn't changed later
			dataUser.set( elem, key, data );
		} else {
			data = undefined;
		}
	}
	return data;
}

jQuery.extend( {
	hasData: function( elem ) {
		return dataUser.hasData( elem ) || dataPriv.hasData( elem );
	},

	data: function( elem, name, data ) {
		return dataUser.access( elem, name, data );
	},

	removeData: function( elem, name ) {
		dataUser.remove( elem, name );
	},

	// TODO: Now that all calls to _data and _removeData have been replaced
	// with direct calls to dataPriv methods, these can be deprecated.
	_data: function( elem, name, data ) {
		return dataPriv.access( elem, name, data );
	},

	_removeData: function( elem, name ) {
		dataPriv.remove( elem, name );
	}
} );

jQuery.fn.extend( {
	data: function( key, value ) {
		var i, name, data,
			elem = this[ 0 ],
			attrs = elem && elem.attributes;

		// Gets all values
		if ( key === undefined ) {
			if ( this.length ) {
				data = dataUser.get( elem );

				if ( elem.nodeType === 1 && !dataPriv.get( elem, "hasDataAttrs" ) ) {
					i = attrs.length;
					while ( i-- ) {

						// Support: IE 11 only
						// The attrs elements can be null (trac-14894)
						if ( attrs[ i ] ) {
							name = attrs[ i ].name;
							if ( name.indexOf( "data-" ) === 0 ) {
								name = camelCase( name.slice( 5 ) );
								dataAttr( elem, name, data[ name ] );
							}
						}
					}
					dataPriv.set( elem, "hasDataAttrs", true );
				}
			}

			return data;
		}

		// Sets multiple values
		if ( typeof key === "object" ) {
			return this.each( function() {
				dataUser.set( this, key );
			} );
		}

		return access( this, function( value ) {
			var data;

			// The calling jQuery object (element matches) is not empty
			// (and therefore has an element appears at this[ 0 ]) and the
			// `value` parameter was not undefined. An empty jQuery object
			// will result in `undefined` for elem = this[ 0 ] which will
			// throw an exception if an attempt to read a data cache is made.
			if ( elem && value === undefined ) {

				// Attempt to get data from the cache
				// The key will always be camelCased in Data
				data = dataUser.get( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// Attempt to "discover" the data in
				// HTML5 custom data-* attrs
				data = dataAttr( elem, key );
				if ( data !== undefined ) {
					return data;
				}

				// We tried really hard, but the data doesn't exist.
				return;
			}

			// Set the data...
			this.each( function() {

				// We always store the camelCased key
				dataUser.set( this, key, value );
			} );
		}, null, value, arguments.length > 1, null, true );
	},

	removeData: function( key ) {
		return this.each( function() {
			dataUser.remove( this, key );
		} );
	}
} );


jQuery.extend( {
	queue: function( elem, type, data ) {
		var queue;

		if ( elem ) {
			type = ( type || "fx" ) + "queue";
			queue = dataPriv.get( elem, type );

			// Speed up dequeue by getting out quickly if this is just a lookup
			if ( data ) {
				if ( !queue || Array.isArray( data ) ) {
					queue = dataPriv.access( elem, type, jQuery.makeArray( data ) );
				} else {
					queue.push( data );
				}
			}
			return queue || [];
		}
	},

	dequeue: function( elem, type ) {
		type = type || "fx";

		var queue = jQuery.queue( elem, type ),
			startLength = queue.length,
			fn = queue.shift(),
			hooks = jQuery._queueHooks( elem, type ),
			next = function() {
				jQuery.dequeue( elem, type );
			};

		// If the fx queue is dequeued, always remove the progress sentinel
		if ( fn === "inprogress" ) {
			fn = queue.shift();
			startLength--;
		}

		if ( fn ) {

			// Add a progress sentinel to prevent the fx queue from being
			// automatically dequeued
			if ( type === "fx" ) {
				queue.unshift( "inprogress" );
			}

			// Clear up the last queue stop function
			delete hooks.stop;
			fn.call( elem, next, hooks );
		}

		if ( !startLength && hooks ) {
			hooks.empty.fire();
		}
	},

	// Not public - generate a queueHooks object, or return the current one
	_queueHooks: function( elem, type ) {
		var key = type + "queueHooks";
		return dataPriv.get( elem, key ) || dataPriv.access( elem, key, {
			empty: jQuery.Callbacks( "once memory" ).add( function() {
				dataPriv.remove( elem, [ type + "queue", key ] );
			} )
		} );
	}
} );

jQuery.fn.extend( {
	queue: function( type, data ) {
		var setter = 2;

		if ( typeof type !== "string" ) {
			data = type;
			type = "fx";
			setter--;
		}

		if ( arguments.length < setter ) {
			return jQuery.queue( this[ 0 ], type );
		}

		return data === undefined ?
			this :
			this.each( function() {
				var queue = jQuery.queue( this, type, data );

				// Ensure a hooks for this queue
				jQuery._queueHooks( this, type );

				if ( type === "fx" && queue[ 0 ] !== "inprogress" ) {
					jQuery.dequeue( this, type );
				}
			} );
	},
	dequeue: function( type ) {
		return this.each( function() {
			jQuery.dequeue( this, type );
		} );
	},
	clearQueue: function( type ) {
		return this.queue( type || "fx", [] );
	},

	// Get a promise resolved when queues of a certain type
	// are emptied (fx is the type by default)
	promise: function( type, obj ) {
		var tmp,
			count = 1,
			defer = jQuery.Deferred(),
			elements = this,
			i = this.length,
			resolve = function() {
				if ( !( --count ) ) {
					defer.resolveWith( elements, [ elements ] );
				}
			};

		if ( typeof type !== "string" ) {
			obj = type;
			type = undefined;
		}
		type = type || "fx";

		while ( i-- ) {
			tmp = dataPriv.get( elements[ i ], type + "queueHooks" );
			if ( tmp && tmp.empty ) {
				count++;
				tmp.empty.add( resolve );
			}
		}
		resolve();
		return defer.promise( obj );
	}
} );
var pnum = ( /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/ ).source;

var rcssNum = new RegExp( "^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i" );


var cssExpand = [ "Top", "Right", "Bottom", "Left" ];

var documentElement = document.documentElement;



	var isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem );
		},
		composed = { composed: true };

	// Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
	// Check attachment across shadow DOM boundaries when possible (gh-3504)
	// Support: iOS 10.0-10.2 only
	// Early iOS 10 versions support `attachShadow` but not `getRootNode`,
	// leading to errors. We need to check for `getRootNode`.
	if ( documentElement.getRootNode ) {
		isAttached = function( elem ) {
			return jQuery.contains( elem.ownerDocument, elem ) ||
				elem.getRootNode( composed ) === elem.ownerDocument;
		};
	}
var isHiddenWithinTree = function( elem, el ) {

		// isHiddenWithinTree might be called from jQuery#filter function;
		// in that case, element will be second argument
		elem = el || elem;

		// Inline style trumps all
		return elem.style.display === "none" ||
			elem.style.display === "" &&

			// Otherwise, check computed style
			// Support: Firefox <=43 - 45
			// Disconnected elements can have computed display: none, so first confirm that elem is
			// in the document.
			isAttached( elem ) &&

			jQuery.css( elem, "display" ) === "none";
	};



function adjustCSS( elem, prop, valueParts, tween ) {
	var adjusted, scale,
		maxIterations = 20,
		currentValue = tween ?
			function() {
				return tween.cur();
			} :
			function() {
				return jQuery.css( elem, prop, "" );
			},
		initial = currentValue(),
		unit = valueParts && valueParts[ 3 ] || ( jQuery.cssNumber[ prop ] ? "" : "px" ),

		// Starting value computation is required for potential unit mismatches
		initialInUnit = elem.nodeType &&
			( jQuery.cssNumber[ prop ] || unit !== "px" && +initial ) &&
			rcssNum.exec( jQuery.css( elem, prop ) );

	if ( initialInUnit && initialInUnit[ 3 ] !== unit ) {

		// Support: Firefox <=54
		// Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
		initial = initial / 2;

		// Trust units reported by jQuery.css
		unit = unit || initialInUnit[ 3 ];

		// Iteratively approximate from a nonzero starting point
		initialInUnit = +initial || 1;

		while ( maxIterations-- ) {

			// Evaluate and update our best guess (doubling guesses that zero out).
			// Finish if the scale equals or crosses 1 (making the old*new product non-positive).
			jQuery.style( elem, prop, initialInUnit + unit );
			if ( ( 1 - scale ) * ( 1 - ( scale = currentValue() / initial || 0.5 ) ) <= 0 ) {
				maxIterations = 0;
			}
			initialInUnit = initialInUnit / scale;

		}

		initialInUnit = initialInUnit * 2;
		jQuery.style( elem, prop, initialInUnit + unit );

		// Make sure we update the tween properties later on
		valueParts = valueParts || [];
	}

	if ( valueParts ) {
		initialInUnit = +initialInUnit || +initial || 0;

		// Apply relative offset (+=/-=) if specified
		adjusted = valueParts[ 1 ] ?
			initialInUnit + ( valueParts[ 1 ] + 1 ) * valueParts[ 2 ] :
			+valueParts[ 2 ];
		if ( tween ) {
			tween.unit = unit;
			tween.start = initialInUnit;
			tween.end = adjusted;
		}
	}
	return adjusted;
}


var defaultDisplayMap = {};

function getDefaultDisplay( elem ) {
	var temp,
		doc = elem.ownerDocument,
		nodeName = elem.nodeName,
		display = defaultDisplayMap[ nodeName ];

	if ( display ) {
		return display;
	}

	temp = doc.body.appendChild( doc.createElement( nodeName ) );
	display = jQuery.css( temp, "display" );

	temp.parentNode.removeChild( temp );

	if ( display === "none" ) {
		display = "block";
	}
	defaultDisplayMap[ nodeName ] = display;

	return display;
}

function showHide( elements, show ) {
	var display, elem,
		values = [],
		index = 0,
		length = elements.length;

	// Determine new display value for elements that need to change
	for ( ; index < length; index++ ) {
		elem = elements[ index ];
		if ( !elem.style ) {
			continue;
		}

		display = elem.style.display;
		if ( show ) {

			// Since we force visibility upon cascade-hidden elements, an immediate (and slow)
			// check is required in this first loop unless we have a nonempty display value (either
			// inline or about-to-be-restored)
			if ( display === "none" ) {
				values[ index ] = dataPriv.get( elem, "display" ) || null;
				if ( !values[ index ] ) {
					elem.style.display = "";
				}
			}
			if ( elem.style.display === "" && isHiddenWithinTree( elem ) ) {
				values[ index ] = getDefaultDisplay( elem );
			}
		} else {
			if ( display !== "none" ) {
				values[ index ] = "none";

				// Remember what we're overwriting
				dataPriv.set( elem, "display", display );
			}
		}
	}

	// Set the display of the elements in a second loop to avoid constant reflow
	for ( index = 0; index < length; index++ ) {
		if ( values[ index ] != null ) {
			elements[ index ].style.display = values[ index ];
		}
	}

	return elements;
}

jQuery.fn.extend( {
	show: function() {
		return showHide( this, true );
	},
	hide: function() {
		return showHide( this );
	},
	toggle: function( state ) {
		if ( typeof state === "boolean" ) {
			return state ? this.show() : this.hide();
		}

		return this.each( function() {
			if ( isHiddenWithinTree( this ) ) {
				jQuery( this ).show();
			} else {
				jQuery( this ).hide();
			}
		} );
	}
} );
var rcheckableType = ( /^(?:checkbox|radio)$/i );

var rtagName = ( /<([a-z][^\/\0>\x20\t\r\n\f]*)/i );

var rscriptType = ( /^$|^module$|\/(?:java|ecma)script/i );



( function() {
	var fragment = document.createDocumentFragment(),
		div = fragment.appendChild( document.createElement( "div" ) ),
		input = document.createElement( "input" );

	// Support: Android 4.0 - 4.3 only
	// Check state lost if the name is set (trac-11217)
	// Support: Windows Web Apps (WWA)
	// `name` and `type` must use .setAttribute for WWA (trac-14901)
	input.setAttribute( "type", "radio" );
	input.setAttribute( "checked", "checked" );
	input.setAttribute( "name", "t" );

	div.appendChild( input );

	// Support: Android <=4.1 only
	// Older WebKit doesn't clone checked state correctly in fragments
	support.checkClone = div.cloneNode( true ).cloneNode( true ).lastChild.checked;

	// Support: IE <=11 only
	// Make sure textarea (and checkbox) defaultValue is properly cloned
	div.innerHTML = "<textarea>x</textarea>";
	support.noCloneChecked = !!div.cloneNode( true ).lastChild.defaultValue;

	// Support: IE <=9 only
	// IE <=9 replaces <option> tags with their contents when inserted outside of
	// the select element.
	div.innerHTML = "<option></option>";
	support.option = !!div.lastChild;
} )();


// We have to close these tags to support XHTML (trac-13200)
var wrapMap = {

	// XHTML parsers do not magically insert elements in the
	// same way that tag soup parsers do. So we cannot shorten
	// this by omitting <tbody> or other required elements.
	thead: [ 1, "<table>", "</table>" ],
	col: [ 2, "<table><colgroup>", "</colgroup></table>" ],
	tr: [ 2, "<table><tbody>", "</tbody></table>" ],
	td: [ 3, "<table><tbody><tr>", "</tr></tbody></table>" ],

	_default: [ 0, "", "" ]
};

wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
wrapMap.th = wrapMap.td;

// Support: IE <=9 only
if ( !support.option ) {
	wrapMap.optgroup = wrapMap.option = [ 1, "<select multiple='multiple'>", "</select>" ];
}


function getAll( context, tag ) {

	// Support: IE <=9 - 11 only
	// Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
	var ret;

	if ( typeof context.getElementsByTagName !== "undefined" ) {
		ret = context.getElementsByTagName( tag || "*" );

	} else if ( typeof context.querySelectorAll !== "undefined" ) {
		ret = context.querySelectorAll( tag || "*" );

	} else {
		ret = [];
	}

	if ( tag === undefined || tag && nodeName( context, tag ) ) {
		return jQuery.merge( [ context ], ret );
	}

	return ret;
}


// Mark scripts as having already been evaluated
function setGlobalEval( elems, refElements ) {
	var i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		dataPriv.set(
			elems[ i ],
			"globalEval",
			!refElements || dataPriv.get( refElements[ i ], "globalEval" )
		);
	}
}


var rhtml = /<|&#?\w+;/;

function buildFragment( elems, context, scripts, selection, ignored ) {
	var elem, tmp, tag, wrap, attached, j,
		fragment = context.createDocumentFragment(),
		nodes = [],
		i = 0,
		l = elems.length;

	for ( ; i < l; i++ ) {
		elem = elems[ i ];

		if ( elem || elem === 0 ) {

			// Add nodes directly
			if ( toType( elem ) === "object" ) {

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, elem.nodeType ? [ elem ] : elem );

			// Convert non-html into a text node
			} else if ( !rhtml.test( elem ) ) {
				nodes.push( context.createTextNode( elem ) );

			// Convert html into DOM nodes
			} else {
				tmp = tmp || fragment.appendChild( context.createElement( "div" ) );

				// Deserialize a standard representation
				tag = ( rtagName.exec( elem ) || [ "", "" ] )[ 1 ].toLowerCase();
				wrap = wrapMap[ tag ] || wrapMap._default;
				tmp.innerHTML = wrap[ 1 ] + jQuery.htmlPrefilter( elem ) + wrap[ 2 ];

				// Descend through wrappers to the right content
				j = wrap[ 0 ];
				while ( j-- ) {
					tmp = tmp.lastChild;
				}

				// Support: Android <=4.0 only, PhantomJS 1 only
				// push.apply(_, arraylike) throws on ancient WebKit
				jQuery.merge( nodes, tmp.childNodes );

				// Remember the top-level container
				tmp = fragment.firstChild;

				// Ensure the created nodes are orphaned (trac-12392)
				tmp.textContent = "";
			}
		}
	}

	// Remove wrapper from fragment
	fragment.textContent = "";

	i = 0;
	while ( ( elem = nodes[ i++ ] ) ) {

		// Skip elements already in the context collection (trac-4087)
		if ( selection && jQuery.inArray( elem, selection ) > -1 ) {
			if ( ignored ) {
				ignored.push( elem );
			}
			continue;
		}

		attached = isAttached( elem );

		// Append to fragment
		tmp = getAll( fragment.appendChild( elem ), "script" );

		// Preserve script evaluation history
		if ( attached ) {
			setGlobalEval( tmp );
		}

		// Capture executables
		if ( scripts ) {
			j = 0;
			while ( ( elem = tmp[ j++ ] ) ) {
				if ( rscriptType.test( elem.type || "" ) ) {
					scripts.push( elem );
				}
			}
		}
	}

	return fragment;
}


var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;

function returnTrue() {
	return true;
}

function returnFalse() {
	return false;
}

function on( elem, types, selector, data, fn, one ) {
	var origFn, type;

	// Types can be a map of types/handlers
	if ( typeof types === "object" ) {

		// ( types-Object, selector, data )
		if ( typeof selector !== "string" ) {

			// ( types-Object, data )
			data = data || selector;
			selector = undefined;
		}
		for ( type in types ) {
			on( elem, type, selector, data, types[ type ], one );
		}
		return elem;
	}

	if ( data == null && fn == null ) {

		// ( types, fn )
		fn = selector;
		data = selector = undefined;
	} else if ( fn == null ) {
		if ( typeof selector === "string" ) {

			// ( types, selector, fn )
			fn = data;
			data = undefined;
		} else {

			// ( types, data, fn )
			fn = data;
			data = selector;
			selector = undefined;
		}
	}
	if ( fn === false ) {
		fn = returnFalse;
	} else if ( !fn ) {
		return elem;
	}

	if ( one === 1 ) {
		origFn = fn;
		fn = function( event ) {

			// Can use an empty set, since event contains the info
			jQuery().off( event );
			return origFn.apply( this, arguments );
		};

		// Use same guid so caller can remove using origFn
		fn.guid = origFn.guid || ( origFn.guid = jQuery.guid++ );
	}
	return elem.each( function() {
		jQuery.event.add( this, types, fn, data, selector );
	} );
}

/*
 * Helper functions for managing events -- not part of the public interface.
 * Props to Dean Edwards' addEvent library for many of the ideas.
 */
jQuery.event = {

	global: {},

	add: function( elem, types, handler, data, selector ) {

		var handleObjIn, eventHandle, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.get( elem );

		// Only attach events to objects that accept data
		if ( !acceptData( elem ) ) {
			return;
		}

		// Caller can pass in an object of custom data in lieu of the handler
		if ( handler.handler ) {
			handleObjIn = handler;
			handler = handleObjIn.handler;
			selector = handleObjIn.selector;
		}

		// Ensure that invalid selectors throw exceptions at attach time
		// Evaluate against documentElement in case elem is a non-element node (e.g., document)
		if ( selector ) {
			jQuery.find.matchesSelector( documentElement, selector );
		}

		// Make sure that the handler has a unique ID, used to find/remove it later
		if ( !handler.guid ) {
			handler.guid = jQuery.guid++;
		}

		// Init the element's event structure and main handler, if this is the first
		if ( !( events = elemData.events ) ) {
			events = elemData.events = Object.create( null );
		}
		if ( !( eventHandle = elemData.handle ) ) {
			eventHandle = elemData.handle = function( e ) {

				// Discard the second event of a jQuery.event.trigger() and
				// when an event is called after a page has unloaded
				return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ?
					jQuery.event.dispatch.apply( elem, arguments ) : undefined;
			};
		}

		// Handle multiple events separated by a space
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// There *must* be a type, no attaching namespace-only handlers
			if ( !type ) {
				continue;
			}

			// If event changes its type, use the special event handlers for the changed type
			special = jQuery.event.special[ type ] || {};

			// If selector defined, determine special event api type, otherwise given type
			type = ( selector ? special.delegateType : special.bindType ) || type;

			// Update special based on newly reset type
			special = jQuery.event.special[ type ] || {};

			// handleObj is passed to all event handlers
			handleObj = jQuery.extend( {
				type: type,
				origType: origType,
				data: data,
				handler: handler,
				guid: handler.guid,
				selector: selector,
				needsContext: selector && jQuery.expr.match.needsContext.test( selector ),
				namespace: namespaces.join( "." )
			}, handleObjIn );

			// Init the event handler queue if we're the first
			if ( !( handlers = events[ type ] ) ) {
				handlers = events[ type ] = [];
				handlers.delegateCount = 0;

				// Only use addEventListener if the special events handler returns false
				if ( !special.setup ||
					special.setup.call( elem, data, namespaces, eventHandle ) === false ) {

					if ( elem.addEventListener ) {
						elem.addEventListener( type, eventHandle );
					}
				}
			}

			if ( special.add ) {
				special.add.call( elem, handleObj );

				if ( !handleObj.handler.guid ) {
					handleObj.handler.guid = handler.guid;
				}
			}

			// Add to the element's handler list, delegates in front
			if ( selector ) {
				handlers.splice( handlers.delegateCount++, 0, handleObj );
			} else {
				handlers.push( handleObj );
			}

			// Keep track of which events have ever been used, for event optimization
			jQuery.event.global[ type ] = true;
		}

	},

	// Detach an event or set of events from an element
	remove: function( elem, types, handler, selector, mappedTypes ) {

		var j, origCount, tmp,
			events, t, handleObj,
			special, handlers, type, namespaces, origType,
			elemData = dataPriv.hasData( elem ) && dataPriv.get( elem );

		if ( !elemData || !( events = elemData.events ) ) {
			return;
		}

		// Once for each type.namespace in types; type may be omitted
		types = ( types || "" ).match( rnothtmlwhite ) || [ "" ];
		t = types.length;
		while ( t-- ) {
			tmp = rtypenamespace.exec( types[ t ] ) || [];
			type = origType = tmp[ 1 ];
			namespaces = ( tmp[ 2 ] || "" ).split( "." ).sort();

			// Unbind all events (on this namespace, if provided) for the element
			if ( !type ) {
				for ( type in events ) {
					jQuery.event.remove( elem, type + types[ t ], handler, selector, true );
				}
				continue;
			}

			special = jQuery.event.special[ type ] || {};
			type = ( selector ? special.delegateType : special.bindType ) || type;
			handlers = events[ type ] || [];
			tmp = tmp[ 2 ] &&
				new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" );

			// Remove matching events
			origCount = j = handlers.length;
			while ( j-- ) {
				handleObj = handlers[ j ];

				if ( ( mappedTypes || origType === handleObj.origType ) &&
					( !handler || handler.guid === handleObj.guid ) &&
					( !tmp || tmp.test( handleObj.namespace ) ) &&
					( !selector || selector === handleObj.selector ||
						selector === "**" && handleObj.selector ) ) {
					handlers.splice( j, 1 );

					if ( handleObj.selector ) {
						handlers.delegateCount--;
					}
					if ( special.remove ) {
						special.remove.call( elem, handleObj );
					}
				}
			}

			// Remove generic event handler if we removed something and no more handlers exist
			// (avoids potential for endless recursion during removal of special event handlers)
			if ( origCount && !handlers.length ) {
				if ( !special.teardown ||
					special.teardown.call( elem, namespaces, elemData.handle ) === false ) {

					jQuery.removeEvent( elem, type, elemData.handle );
				}

				delete events[ type ];
			}
		}

		// Remove data and the expando if it's no longer used
		if ( jQuery.isEmptyObject( events ) ) {
			dataPriv.remove( elem, "handle events" );
		}
	},

	dispatch: function( nativeEvent ) {

		var i, j, ret, matched, handleObj, handlerQueue,
			args = new Array( arguments.length ),

			// Make a writable jQuery.Event from the native event object
			event = jQuery.event.fix( nativeEvent ),

			handlers = (
				dataPriv.get( this, "events" ) || Object.create( null )
			)[ event.type ] || [],
			special = jQuery.event.special[ event.type ] || {};

		// Use the fix-ed jQuery.Event rather than the (read-only) native event
		args[ 0 ] = event;

		for ( i = 1; i < arguments.length; i++ ) {
			args[ i ] = arguments[ i ];
		}

		event.delegateTarget = this;

		// Call the preDispatch hook for the mapped type, and let it bail if desired
		if ( special.preDispatch && special.preDispatch.call( this, event ) === false ) {
			return;
		}

		// Determine handlers
		handlerQueue = jQuery.event.handlers.call( this, event, handlers );

		// Run delegates first; they may want to stop propagation beneath us
		i = 0;
		while ( ( matched = handlerQueue[ i++ ] ) && !event.isPropagationStopped() ) {
			event.currentTarget = matched.elem;

			j = 0;
			while ( ( handleObj = matched.handlers[ j++ ] ) &&
				!event.isImmediatePropagationStopped() ) {

				// If the event is namespaced, then each handler is only invoked if it is
				// specially universal or its namespaces are a superset of the event's.
				if ( !event.rnamespace || handleObj.namespace === false ||
					event.rnamespace.test( handleObj.namespace ) ) {

					event.handleObj = handleObj;
					event.data = handleObj.data;

					ret = ( ( jQuery.event.special[ handleObj.origType ] || {} ).handle ||
						handleObj.handler ).apply( matched.elem, args );

					if ( ret !== undefined ) {
						if ( ( event.result = ret ) === false ) {
							event.preventDefault();
							event.stopPropagation();
						}
					}
				}
			}
		}

		// Call the postDispatch hook for the mapped type
		if ( special.postDispatch ) {
			special.postDispatch.call( this, event );
		}

		return event.result;
	},

	handlers: function( event, handlers ) {
		var i, handleObj, sel, matchedHandlers, matchedSelectors,
			handlerQueue = [],
			delegateCount = handlers.delegateCount,
			cur = event.target;

		// Find delegate handlers
		if ( delegateCount &&

			// Support: IE <=9
			// Black-hole SVG <use> instance trees (trac-13180)
			cur.nodeType &&

			// Support: Firefox <=42
			// Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
			// https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
			// Support: IE 11 only
			// ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
			!( event.type === "click" && event.button >= 1 ) ) {

			for ( ; cur !== this; cur = cur.parentNode || this ) {

				// Don't check non-elements (trac-13208)
				// Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
				if ( cur.nodeType === 1 && !( event.type === "click" && cur.disabled === true ) ) {
					matchedHandlers = [];
					matchedSelectors = {};
					for ( i = 0; i < delegateCount; i++ ) {
						handleObj = handlers[ i ];

						// Don't conflict with Object.prototype properties (trac-13203)
						sel = handleObj.selector + " ";

						if ( matchedSelectors[ sel ] === undefined ) {
							matchedSelectors[ sel ] = handleObj.needsContext ?
								jQuery( sel, this ).index( cur ) > -1 :
								jQuery.find( sel, this, null, [ cur ] ).length;
						}
						if ( matchedSelectors[ sel ] ) {
							matchedHandlers.push( handleObj );
						}
					}
					if ( matchedHandlers.length ) {
						handlerQueue.push( { elem: cur, handlers: matchedHandlers } );
					}
				}
			}
		}

		// Add the remaining (directly-bound) handlers
		cur = this;
		if ( delegateCount < handlers.length ) {
			handlerQueue.push( { elem: cur, handlers: handlers.slice( delegateCount ) } );
		}

		return handlerQueue;
	},

	addProp: function( name, hook ) {
		Object.defineProperty( jQuery.Event.prototype, name, {
			enumerable: true,
			configurable: true,

			get: isFunction( hook ) ?
				function() {
					if ( this.originalEvent ) {
						return hook( this.originalEvent );
					}
				} :
				function() {
					if ( this.originalEvent ) {
						return this.originalEvent[ name ];
					}
				},

			set: function( value ) {
				Object.defineProperty( this, name, {
					enumerable: true,
					configurable: true,
					writable: true,
					value: value
				} );
			}
		} );
	},

	fix: function( originalEvent ) {
		return originalEvent[ jQuery.expando ] ?
			originalEvent :
			new jQuery.Event( originalEvent );
	},

	special: {
		load: {

			// Prevent triggered image.load events from bubbling to window.load
			noBubble: true
		},
		click: {

			// Utilize native event to ensure correct state for checkable inputs
			setup: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Claim the first handler
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					// dataPriv.set( el, "click", ... )
					leverageNative( el, "click", true );
				}

				// Return false to allow normal processing in the caller
				return false;
			},
			trigger: function( data ) {

				// For mutual compressibility with _default, replace `this` access with a local var.
				// `|| data` is dead code meant only to preserve the variable through minification.
				var el = this || data;

				// Force setup before triggering a click
				if ( rcheckableType.test( el.type ) &&
					el.click && nodeName( el, "input" ) ) {

					leverageNative( el, "click" );
				}

				// Return non-false to allow normal event-path propagation
				return true;
			},

			// For cross-browser consistency, suppress native .click() on links
			// Also prevent it if we're currently inside a leveraged native-event stack
			_default: function( event ) {
				var target = event.target;
				return rcheckableType.test( target.type ) &&
					target.click && nodeName( target, "input" ) &&
					dataPriv.get( target, "click" ) ||
					nodeName( target, "a" );
			}
		},

		beforeunload: {
			postDispatch: function( event ) {

				// Support: Firefox 20+
				// Firefox doesn't alert if the returnValue field is not set.
				if ( event.result !== undefined && event.originalEvent ) {
					event.originalEvent.returnValue = event.result;
				}
			}
		}
	}
};

// Ensure the presence of an event listener that handles manually-triggered
// synthetic events by interrupting progress until reinvoked in response to
// *native* events that it fires directly, ensuring that state changes have
// already occurred before other listeners are invoked.
function leverageNative( el, type, isSetup ) {

	// Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
	if ( !isSetup ) {
		if ( dataPriv.get( el, type ) === undefined ) {
			jQuery.event.add( el, type, returnTrue );
		}
		return;
	}

	// Register the controller as a special universal handler for all event namespaces
	dataPriv.set( el, type, false );
	jQuery.event.add( el, type, {
		namespace: false,
		handler: function( event ) {
			var result,
				saved = dataPriv.get( this, type );

			if ( ( event.isTrigger & 1 ) && this[ type ] ) {

				// Interrupt processing of the outer synthetic .trigger()ed event
				if ( !saved ) {

					// Store arguments for use when handling the inner native event
					// There will always be at least one argument (an event object), so this array
					// will not be confused with a leftover capture object.
					saved = slice.call( arguments );
					dataPriv.set( this, type, saved );

					// Trigger the native event and capture its result
					this[ type ]();
					result = dataPriv.get( this, type );
					dataPriv.set( this, type, false );

					if ( saved !== result ) {

						// Cancel the outer synthetic event
						event.stopImmediatePropagation();
						event.preventDefault();

						return result;
					}

				// If this is an inner synthetic event for an event with a bubbling surrogate
				// (focus or blur), assume that the surrogate already propagated from triggering
				// the native event and prevent that from happening again here.
				// This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
				// bubbling surrogate propagates *after* the non-bubbling base), but that seems
				// less bad than duplication.
				} else if ( ( jQuery.event.special[ type ] || {} ).delegateType ) {
					event.stopPropagation();
				}

			// If this is a native event triggered above, everything is now in order
			// Fire an inner synthetic event with the original arguments
			} else if ( saved ) {

				// ...and capture the result
				dataPriv.set( this, type, jQuery.event.trigger(
					saved[ 0 ],
					saved.slice( 1 ),
					this
				) );

				// Abort handling of the native event by all jQuery handlers while allowing
				// native handlers on the same element to run. On target, this is achieved
				// by stopping immediate propagation just on the jQuery event. However,
				// the native event is re-wrapped by a jQuery one on each level of the
				// propagation so the only way to stop it for jQuery is to stop it for
				// everyone via native `stopPropagation()`. This is not a problem for
				// focus/blur which don't bubble, but it does also stop click on checkboxes
				// and radios. We accept this limitation.
				event.stopPropagation();
				event.isImmediatePropagationStopped = returnTrue;
			}
		}
	} );
}

jQuery.removeEvent = function( elem, type, handle ) {

	// This "if" is needed for plain objects
	if ( elem.removeEventListener ) {
		elem.removeEventListener( type, handle );
	}
};

jQuery.Event = function( src, props ) {

	// Allow instantiation without the 'new' keyword
	if ( !( this instanceof jQuery.Event ) ) {
		return new jQuery.Event( src, props );
	}

	// Event object
	if ( src && src.type ) {
		this.originalEvent = src;
		this.type = src.type;

		// Events bubbling up the document may have been marked as prevented
		// by a handler lower down the tree; reflect the correct value.
		this.isDefaultPrevented = src.defaultPrevented ||
				src.defaultPrevented === undefined &&

				// Support: Android <=2.3 only
				src.returnValue === false ?
			returnTrue :
			returnFalse;

		// Create target properties
		// Support: Safari <=6 - 7 only
		// Target should not be a text node (trac-504, trac-13143)
		this.target = ( src.target && src.target.nodeType === 3 ) ?
			src.target.parentNode :
			src.target;

		this.currentTarget = src.currentTarget;
		this.relatedTarget = src.relatedTarget;

	// Event type
	} else {
		this.type = src;
	}

	// Put explicitly provided properties onto the event object
	if ( props ) {
		jQuery.extend( this, props );
	}

	// Create a timestamp if incoming event doesn't have one
	this.timeStamp = src && src.timeStamp || Date.now();

	// Mark it as fixed
	this[ jQuery.expando ] = true;
};

// jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
// https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
jQuery.Event.prototype = {
	constructor: jQuery.Event,
	isDefaultPrevented: returnFalse,
	isPropagationStopped: returnFalse,
	isImmediatePropagationStopped: returnFalse,
	isSimulated: false,

	preventDefault: function() {
		var e = this.originalEvent;

		this.isDefaultPrevented = returnTrue;

		if ( e && !this.isSimulated ) {
			e.preventDefault();
		}
	},
	stopPropagation: function() {
		var e = this.originalEvent;

		this.isPropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopPropagation();
		}
	},
	stopImmediatePropagation: function() {
		var e = this.originalEvent;

		this.isImmediatePropagationStopped = returnTrue;

		if ( e && !this.isSimulated ) {
			e.stopImmediatePropagation();
		}

		this.stopPropagation();
	}
};

// Includes all common event props including KeyEvent and MouseEvent specific props
jQuery.each( {
	altKey: true,
	bubbles: true,
	cancelable: true,
	changedTouches: true,
	ctrlKey: true,
	detail: true,
	eventPhase: true,
	metaKey: true,
	pageX: true,
	pageY: true,
	shiftKey: true,
	view: true,
	"char": true,
	code: true,
	charCode: true,
	key: true,
	keyCode: true,
	button: true,
	buttons: true,
	clientX: true,
	clientY: true,
	offsetX: true,
	offsetY: true,
	pointerId: true,
	pointerType: true,
	screenX: true,
	screenY: true,
	targetTouches: true,
	toElement: true,
	touches: true,
	which: true
}, jQuery.event.addProp );

jQuery.each( { focus: "focusin", blur: "focusout" }, function( type, delegateType ) {

	function focusMappedHandler( nativeEvent ) {
		if ( document.documentMode ) {

			// Support: IE 11+
			// Attach a single focusin/focusout handler on the document while someone wants
			// focus/blur. This is because the former are synchronous in IE while the latter
			// are async. In other browsers, all those handlers are invoked synchronously.

			// `handle` from private data would already wrap the event, but we need
			// to change the `type` here.
			var handle = dataPriv.get( this, "handle" ),
				event = jQuery.event.fix( nativeEvent );
			event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
			event.isSimulated = true;

			// First, handle focusin/focusout
			handle( nativeEvent );

			// ...then, handle focus/blur
			//
			// focus/blur don't bubble while focusin/focusout do; simulate the former by only
			// invoking the handler at the lower level.
			if ( event.target === event.currentTarget ) {

				// The setup part calls `leverageNative`, which, in turn, calls
				// `jQuery.event.add`, so event handle will already have been set
				// by this point.
				handle( event );
			}
		} else {

			// For non-IE browsers, attach a single capturing handler on the document
			// while someone wants focusin/focusout.
			jQuery.event.simulate( delegateType, nativeEvent.target,
				jQuery.event.fix( nativeEvent ) );
		}
	}

	jQuery.event.special[ type ] = {

		// Utilize native event if possible so blur/focus sequence is correct
		setup: function() {

			var attaches;

			// Claim the first handler
			// dataPriv.set( this, "focus", ... )
			// dataPriv.set( this, "blur", ... )
			leverageNative( this, type, true );

			if ( document.documentMode ) {

				// Support: IE 9 - 11+
				// We use the same native handler for focusin & focus (and focusout & blur)
				// so we need to coordinate setup & teardown parts between those events.
				// Use `delegateType` as the key as `type` is already used by `leverageNative`.
				attaches = dataPriv.get( this, delegateType );
				if ( !attaches ) {
					this.addEventListener( delegateType, focusMappedHandler );
				}
				dataPriv.set( this, delegateType, ( attaches || 0 ) + 1 );
			} else {

				// Return false to allow normal processing in the caller
				return false;
			}
		},
		trigger: function() {

			// Force setup before trigger
			leverageNative( this, type );

			// Return non-false to allow normal event-path propagation
			return true;
		},

		teardown: function() {
			var attaches;

			if ( document.documentMode ) {
				attaches = dataPriv.get( this, delegateType ) - 1;
				if ( !attaches ) {
					this.removeEventListener( delegateType, focusMappedHandler );
					dataPriv.remove( this, delegateType );
				} else {
					dataPriv.set( this, delegateType, attaches );
				}
			} else {

				// Return false to indicate standard teardown should be applied
				return false;
			}
		},

		// Suppress native focus or blur if we're currently inside
		// a leveraged native-event stack
		_default: function( event ) {
			return dataPriv.get( event.target, type );
		},

		delegateType: delegateType
	};

	// Support: Firefox <=44
	// Firefox doesn't have focus(in | out) events
	// Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
	//
	// Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
	// focus(in | out) events fire after focus & blur events,
	// which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
	// Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
	//
	// Support: IE 9 - 11+
	// To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
	// attach a single handler for both events in IE.
	jQuery.event.special[ delegateType ] = {
		setup: function() {

			// Handle: regular nodes (via `this.ownerDocument`), window
			// (via `this.document`) & document (via `this`).
			var doc = this.ownerDocument || this.document || this,
				dataHolder = document.documentMode ? this : doc,
				attaches = dataPriv.get( dataHolder, delegateType );

			// Support: IE 9 - 11+
			// We use the same native handler for focusin & focus (and focusout & blur)
			// so we need to coordinate setup & teardown parts between those events.
			// Use `delegateType` as the key as `type` is already used by `leverageNative`.
			if ( !attaches ) {
				if ( document.documentMode ) {
					this.addEventListener( delegateType, focusMappedHandler );
				} else {
					doc.addEventListener( type, focusMappedHandler, true );
				}
			}
			dataPriv.set( dataHolder, delegateType, ( attaches || 0 ) + 1 );
		},
		teardown: function() {
			var doc = this.ownerDocument || this.document || this,
				dataHolder = document.documentMode ? this : doc,
				attaches = dataPriv.get( dataHolder, delegateType ) - 1;

			if ( !attaches ) {
				if ( document.documentMode ) {
					this.removeEventListener( delegateType, focusMappedHandler );
				} else {
					doc.removeEventListener( type, focusMappedHandler, true );
				}
				dataPriv.remove( dataHolder, delegateType );
			} else {
				dataPriv.set( dataHolder, delegateType, attaches );
			}
		}
	};
} );

// Create mouseenter/leave events using mouseover/out and event-time checks
// so that event delegation works in jQuery.
// Do the same for pointerenter/pointerleave and pointerover/pointerout
//
// Support: Safari 7 only
// Safari sends mouseenter too often; see:
// https://bugs.chromium.org/p/chromium/issues/detail?id=470258
// for the description of the bug (it existed in older Chrome versions as well).
jQuery.each( {
	mouseenter: "mouseover",
	mouseleave: "mouseout",
	pointerenter: "pointerover",
	pointerleave: "pointerout"
}, function( orig, fix ) {
	jQuery.event.special[ orig ] = {
		delegateType: fix,
		bindType: fix,

		handle: function( event ) {
			var ret,
				target = this,
				related = event.relatedTarget,
				handleObj = event.handleObj;

			// For mouseenter/leave call the handler if related is outside the target.
			// NB: No relatedTarget if the mouse left/entered the browser window
			if ( !related || ( related !== target && !jQuery.contains( target, related ) ) ) {
				event.type = handleObj.origType;
				ret = handleObj.handler.apply( this, arguments );
				event.type = fix;
			}
			return ret;
		}
	};
} );

jQuery.fn.extend( {

	on: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn );
	},
	one: function( types, selector, data, fn ) {
		return on( this, types, selector, data, fn, 1 );
	},
	off: function( types, selector, fn ) {
		var handleObj, type;
		if ( types && types.preventDefault && types.handleObj ) {

			// ( event )  dispatched jQuery.Event
			handleObj = types.handleObj;
			jQuery( types.delegateTarget ).off(
				handleObj.namespace ?
					handleObj.origType + "." + handleObj.namespace :
					handleObj.origType,
				handleObj.selector,
				handleObj.handler
			);
			return this;
		}
		if ( typeof types === "object" ) {

			// ( types-object [, selector] )
			for ( type in types ) {
				this.off( type, selector, types[ type ] );
			}
			return this;
		}
		if ( selector === false || typeof selector === "function" ) {

			// ( types [, fn] )
			fn = selector;
			selector = undefined;
		}
		if ( fn === false ) {
			fn = returnFalse;
		}
		return this.each( function() {
			jQuery.event.remove( this, types, fn, selector );
		} );
	}
} );


var

	// Support: IE <=10 - 11, Edge 12 - 13 only
	// In IE/Edge using regex groups here causes severe slowdowns.
	// See https://connect.microsoft.com/IE/feedback/details/1736512/
	rnoInnerhtml = /<script|<style|<link/i,

	// checked="checked" or checked
	rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,

	rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;

// Prefer a tbody over its parent table for containing new rows
function manipulationTarget( elem, content ) {
	if ( nodeName( elem, "table" ) &&
		nodeName( content.nodeType !== 11 ? content : content.firstChild, "tr" ) ) {

		return jQuery( elem ).children( "tbody" )[ 0 ] || elem;
	}

	return elem;
}

// Replace/restore the type attribute of script elements for safe DOM manipulation
function disableScript( elem ) {
	elem.type = ( elem.getAttribute( "type" ) !== null ) + "/" + elem.type;
	return elem;
}
function restoreScript( elem ) {
	if ( ( elem.type || "" ).slice( 0, 5 ) === "true/" ) {
		elem.type = elem.type.slice( 5 );
	} else {
		elem.removeAttribute( "type" );
	}

	return elem;
}

function cloneCopyEvent( src, dest ) {
	var i, l, type, pdataOld, udataOld, udataCur, events;

	if ( dest.nodeType !== 1 ) {
		return;
	}

	// 1. Copy private data: events, handlers, etc.
	if ( dataPriv.hasData( src ) ) {
		pdataOld = dataPriv.get( src );
		events = pdataOld.events;

		if ( events ) {
			dataPriv.remove( dest, "handle events" );

			for ( type in events ) {
				for ( i = 0, l = events[ type ].length; i < l; i++ ) {
					jQuery.event.add( dest, type, events[ type ][ i ] );
				}
			}
		}
	}

	// 2. Copy user data
	if ( dataUser.hasData( src ) ) {
		udataOld = dataUser.access( src );
		udataCur = jQuery.extend( {}, udataOld );

		dataUser.set( dest, udataCur );
	}
}

// Fix IE bugs, see support tests
function fixInput( src, dest ) {
	var nodeName = dest.nodeName.toLowerCase();

	// Fails to persist the checked state of a cloned checkbox or radio button.
	if ( nodeName === "input" && rcheckableType.test( src.type ) ) {
		dest.checked = src.checked;

	// Fails to return the selected option to the default selected state when cloning options
	} else if ( nodeName === "input" || nodeName === "textarea" ) {
		dest.defaultValue = src.defaultValue;
	}
}

function domManip( collection, args, callback, ignored ) {

	// Flatten any nested arrays
	args = flat( args );

	var fragment, first, scripts, hasScripts, node, doc,
		i = 0,
		l = collection.length,
		iNoClone = l - 1,
		value = args[ 0 ],
		valueIsFunction = isFunction( value );

	// We can't cloneNode fragments that contain checked, in WebKit
	if ( valueIsFunction ||
			( l > 1 && typeof value === "string" &&
				!support.checkClone && rchecked.test( value ) ) ) {
		return collection.each( function( index ) {
			var self = collection.eq( index );
			if ( valueIsFunction ) {
				args[ 0 ] = value.call( this, index, self.html() );
			}
			domManip( self, args, callback, ignored );
		} );
	}

	if ( l ) {
		fragment = buildFragment( args, collection[ 0 ].ownerDocument, false, collection, ignored );
		first = fragment.firstChild;

		if ( fragment.childNodes.length === 1 ) {
			fragment = first;
		}

		// Require either new content or an interest in ignored elements to invoke the callback
		if ( first || ignored ) {
			scripts = jQuery.map( getAll( fragment, "script" ), disableScript );
			hasScripts = scripts.length;

			// Use the original fragment for the last item
			// instead of the first because it can end up
			// being emptied incorrectly in certain situations (trac-8070).
			for ( ; i < l; i++ ) {
				node = fragment;

				if ( i !== iNoClone ) {
					node = jQuery.clone( node, true, true );

					// Keep references to cloned scripts for later restoration
					if ( hasScripts ) {

						// Support: Android <=4.0 only, PhantomJS 1 only
						// push.apply(_, arraylike) throws on ancient WebKit
						jQuery.merge( scripts, getAll( node, "script" ) );
					}
				}

				callback.call( collection[ i ], node, i );
			}

			if ( hasScripts ) {
				doc = scripts[ scripts.length - 1 ].ownerDocument;

				// Re-enable scripts
				jQuery.map( scripts, restoreScript );

				// Evaluate executable scripts on first document insertion
				for ( i = 0; i < hasScripts; i++ ) {
					node = scripts[ i ];
					if ( rscriptType.test( node.type || "" ) &&
						!dataPriv.access( node, "globalEval" ) &&
						jQuery.contains( doc, node ) ) {

						if ( node.src && ( node.type || "" ).toLowerCase()  !== "module" ) {

							// Optional AJAX dependency, but won't run scripts if not present
							if ( jQuery._evalUrl && !node.noModule ) {
								jQuery._evalUrl( node.src, {
									nonce: node.nonce || node.getAttribute( "nonce" )
								}, doc );
							}
						} else {

							// Unwrap a CDATA section containing script contents. This shouldn't be
							// needed as in XML documents they're already not visible when
							// inspecting element contents and in HTML documents they have no
							// meaning but we're preserving that logic for backwards compatibility.
							// This will be removed completely in 4.0. See gh-4904.
							DOMEval( node.textContent.replace( rcleanScript, "" ), node, doc );
						}
					}
				}
			}
		}
	}

	return collection;
}

function remove( elem, selector, keepData ) {
	var node,
		nodes = selector ? jQuery.filter( selector, elem ) : elem,
		i = 0;

	for ( ; ( node = nodes[ i ] ) != null; i++ ) {
		if ( !keepData && node.nodeType === 1 ) {
			jQuery.cleanData( getAll( node ) );
		}

		if ( node.parentNode ) {
			if ( keepData && isAttached( node ) ) {
				setGlobalEval( getAll( node, "script" ) );
			}
			node.parentNode.removeChild( node );
		}
	}

	return elem;
}

jQuery.extend( {
	htmlPrefilter: function( html ) {
		return html;
	},

	clone: function( elem, dataAndEvents, deepDataAndEvents ) {
		var i, l, srcElements, destElements,
			clone = elem.cloneNode( true ),
			inPage = isAttached( elem );

		// Fix IE cloning issues
		if ( !support.noCloneChecked && ( elem.nodeType === 1 || elem.nodeType === 11 ) &&
				!jQuery.isXMLDoc( elem ) ) {

			// We eschew jQuery#find here for performance reasons:
			// https://jsperf.com/getall-vs-sizzle/2
			destElements = getAll( clone );
			srcElements = getAll( elem );

			for ( i = 0, l = srcElements.length; i < l; i++ ) {
				fixInput( srcElements[ i ], destElements[ i ] );
			}
		}

		// Copy the events from the original to the clone
		if ( dataAndEvents ) {
			if ( deepDataAndEvents ) {
				srcElements = srcElements || getAll( elem );
				destElements = destElements || getAll( clone );

				for ( i = 0, l = srcElements.length; i < l; i++ ) {
					cloneCopyEvent( srcElements[ i ], destElements[ i ] );
				}
			} else {
				cloneCopyEvent( elem, clone );
			}
		}

		// Preserve script evaluation history
		destElements = getAll( clone, "script" );
		if ( destElements.length > 0 ) {
			setGlobalEval( destElements, !inPage && getAll( elem, "script" ) );
		}

		// Return the cloned set
		return clone;
	},

	cleanData: function( elems ) {
		var data, elem, type,
			special = jQuery.event.special,
			i = 0;

		for ( ; ( elem = elems[ i ] ) !== undefined; i++ ) {
			if ( acceptData( elem ) ) {
				if ( ( data = elem[ dataPriv.expando ] ) ) {
					if ( data.events ) {
						for ( type in data.events ) {
							if ( special[ type ] ) {
								jQuery.event.remove( elem, type );

							// This is a shortcut to avoid jQuery.event.remove's overhead
							} else {
								jQuery.removeEvent( elem, type, data.handle );
							}
						}
					}

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataPriv.expando ] = undefined;
				}
				if ( elem[ dataUser.expando ] ) {

					// Support: Chrome <=35 - 45+
					// Assign undefined instead of using delete, see Data#remove
					elem[ dataUser.expando ] = undefined;
				}
			}
		}
	}
} );

jQuery.fn.extend( {
	detach: function( selector ) {
		return remove( this, selector, true );
	},

	remove: function( selector ) {
		return remove( this, selector );
	},

	text: function( value ) {
		return access( this, function( value ) {
			return value === undefined ?
				jQuery.text( this ) :
				this.empty().each( function() {
					if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
						this.textContent = value;
					}
				} );
		}, null, value, arguments.length );
	},

	append: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.appendChild( elem );
			}
		} );
	},

	prepend: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9 ) {
				var target = manipulationTarget( this, elem );
				target.insertBefore( elem, target.firstChild );
			}
		} );
	},

	before: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this );
			}
		} );
	},

	after: function() {
		return domManip( this, arguments, function( elem ) {
			if ( this.parentNode ) {
				this.parentNode.insertBefore( elem, this.nextSibling );
			}
		} );
	},

	empty: function() {
		var elem,
			i = 0;

		for ( ; ( elem = this[ i ] ) != null; i++ ) {
			if ( elem.nodeType === 1 ) {

				// Prevent memory leaks
				jQuery.cleanData( getAll( elem, false ) );

				// Remove any remaining nodes
				elem.textContent = "";
			}
		}

		return this;
	},

	clone: function( dataAndEvents, deepDataAndEvents ) {
		dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
		deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;

		return this.map( function() {
			return jQuery.clone( this, dataAndEvents, deepDataAndEvents );
		} );
	},

	html: function( value ) {
		return access( this, function( value ) {
			var elem = this[ 0 ] || {},
				i = 0,
				l = this.length;

			if ( value === undefined && elem.nodeType === 1 ) {
				return elem.innerHTML;
			}

			// See if we can take a shortcut and just use innerHTML
			if ( typeof value === "string" && !rnoInnerhtml.test( value ) &&
				!wrapMap[ ( rtagName.exec( value ) || [ "", "" ] )[ 1 ].toLowerCase() ] ) {

				value = jQuery.htmlPrefilter( value );

				try {
					for ( ; i < l; i++ ) {
						elem = this[ i ] || {};

						// Remove element nodes and prevent memory leaks
						if ( elem.nodeType === 1 ) {
							jQuery.cleanData( getAll( elem, false ) );
							elem.innerHTML = value;
						}
					}

					elem = 0;

				// If using innerHTML throws an exception, use the fallback method
				} catch ( e ) {}
			}

			if ( elem ) {
				this.empty().append( value );
			}
		}, null, value, arguments.length );
	},

	replaceWith: function() {
		var ignored = [];

		// Make the changes, replacing each non-ignored context element with the new content
		return domManip( this, arguments, function( elem ) {
			var parent = this.parentNode;

			if ( jQuery.inArray( this, ignored ) < 0 ) {
				jQuery.cleanData( getAll( this ) );
				if ( parent ) {
					parent.replaceChild( elem, this );
				}
			}

		// Force callback invocation
		}, ignored );
	}
} );

jQuery.each( {
	appendTo: "append",
	prependTo: "prepend",
	insertBefore: "before",
	insertAfter: "after",
	replaceAll: "replaceWith"
}, function( name, original ) {
	jQuery.fn[ name ] = function( selector ) {
		var elems,
			ret = [],
			insert = jQuery( selector ),
			last = insert.length - 1,
			i = 0;

		for ( ; i <= last; i++ ) {
			elems = i === last ? this : this.clone( true );
			jQuery( insert[ i ] )[ original ]( elems );

			// Support: Android <=4.0 only, PhantomJS 1 only
			// .get() because push.apply(_, arraylike) throws on ancient WebKit
			push.apply( ret, elems.get() );
		}

		return this.pushStack( ret );
	};
} );
var rnumnonpx = new RegExp( "^(" + pnum + ")(?!px)[a-z%]+$", "i" );

var rcustomProp = /^--/;


var getStyles = function( elem ) {

		// Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
		// IE throws on elements created in popups
		// FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
		var view = elem.ownerDocument.defaultView;

		if ( !view || !view.opener ) {
			view = window;
		}

		return view.getComputedStyle( elem );
	};

var swap = function( elem, options, callback ) {
	var ret, name,
		old = {};

	// Remember the old values, and insert the new ones
	for ( name in options ) {
		old[ name ] = elem.style[ name ];
		elem.style[ name ] = options[ name ];
	}

	ret = callback.call( elem );

	// Revert the old values
	for ( name in options ) {
		elem.style[ name ] = old[ name ];
	}

	return ret;
};


var rboxStyle = new RegExp( cssExpand.join( "|" ), "i" );



( function() {

	// Executing both pixelPosition & boxSizingReliable tests require only one layout
	// so they're executed at the same time to save the second computation.
	function computeStyleTests() {

		// This is a singleton, we need to execute it only once
		if ( !div ) {
			return;
		}

		container.style.cssText = "position:absolute;left:-11111px;width:60px;" +
			"margin-top:1px;padding:0;border:0";
		div.style.cssText =
			"position:relative;display:block;box-sizing:border-box;overflow:scroll;" +
			"margin:auto;border:1px;padding:1px;" +
			"width:60%;top:1%";
		documentElement.appendChild( container ).appendChild( div );

		var divStyle = window.getComputedStyle( div );
		pixelPositionVal = divStyle.top !== "1%";

		// Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
		reliableMarginLeftVal = roundPixelMeasures( divStyle.marginLeft ) === 12;

		// Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
		// Some styles come back with percentage values, even though they shouldn't
		div.style.right = "60%";
		pixelBoxStylesVal = roundPixelMeasures( divStyle.right ) === 36;

		// Support: IE 9 - 11 only
		// Detect misreporting of content dimensions for box-sizing:border-box elements
		boxSizingReliableVal = roundPixelMeasures( divStyle.width ) === 36;

		// Support: IE 9 only
		// Detect overflow:scroll screwiness (gh-3699)
		// Support: Chrome <=64
		// Don't get tricked when zoom affects offsetWidth (gh-4029)
		div.style.position = "absolute";
		scrollboxSizeVal = roundPixelMeasures( div.offsetWidth / 3 ) === 12;

		documentElement.removeChild( container );

		// Nullify the div so it wouldn't be stored in the memory and
		// it will also be a sign that checks already performed
		div = null;
	}

	function roundPixelMeasures( measure ) {
		return Math.round( parseFloat( measure ) );
	}

	var pixelPositionVal, boxSizingReliableVal, scrollboxSizeVal, pixelBoxStylesVal,
		reliableTrDimensionsVal, reliableMarginLeftVal,
		container = document.createElement( "div" ),
		div = document.createElement( "div" );

	// Finish early in limited (non-browser) environments
	if ( !div.style ) {
		return;
	}

	// Support: IE <=9 - 11 only
	// Style of cloned element affects source element cloned (trac-8908)
	div.style.backgroundClip = "content-box";
	div.cloneNode( true ).style.backgroundClip = "";
	support.clearCloneStyle = div.style.backgroundClip === "content-box";

	jQuery.extend( support, {
		boxSizingReliable: function() {
			computeStyleTests();
			return boxSizingReliableVal;
		},
		pixelBoxStyles: function() {
			computeStyleTests();
			return pixelBoxStylesVal;
		},
		pixelPosition: function() {
			computeStyleTests();
			return pixelPositionVal;
		},
		reliableMarginLeft: function() {
			computeStyleTests();
			return reliableMarginLeftVal;
		},
		scrollboxSize: function() {
			computeStyleTests();
			return scrollboxSizeVal;
		},

		// Support: IE 9 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Behavior in IE 9 is more subtle than in newer versions & it passes
		// some versions of this test; make sure not to make it pass there!
		//
		// Support: Firefox 70+
		// Only Firefox includes border widths
		// in computed dimensions. (gh-4529)
		reliableTrDimensions: function() {
			var table, tr, trChild, trStyle;
			if ( reliableTrDimensionsVal == null ) {
				table = document.createElement( "table" );
				tr = document.createElement( "tr" );
				trChild = document.createElement( "div" );

				table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
				tr.style.cssText = "box-sizing:content-box;border:1px solid";

				// Support: Chrome 86+
				// Height set through cssText does not get applied.
				// Computed height then comes back as 0.
				tr.style.height = "1px";
				trChild.style.height = "9px";

				// Support: Android 8 Chrome 86+
				// In our bodyBackground.html iframe,
				// display for all div elements is set to "inline",
				// which causes a problem only in Android 8 Chrome 86.
				// Ensuring the div is `display: block`
				// gets around this issue.
				trChild.style.display = "block";

				documentElement
					.appendChild( table )
					.appendChild( tr )
					.appendChild( trChild );

				trStyle = window.getComputedStyle( tr );
				reliableTrDimensionsVal = ( parseInt( trStyle.height, 10 ) +
					parseInt( trStyle.borderTopWidth, 10 ) +
					parseInt( trStyle.borderBottomWidth, 10 ) ) === tr.offsetHeight;

				documentElement.removeChild( table );
			}
			return reliableTrDimensionsVal;
		}
	} );
} )();


function curCSS( elem, name, computed ) {
	var width, minWidth, maxWidth, ret,
		isCustomProp = rcustomProp.test( name ),

		// Support: Firefox 51+
		// Retrieving style before computed somehow
		// fixes an issue with getting wrong values
		// on detached elements
		style = elem.style;

	computed = computed || getStyles( elem );

	// getPropertyValue is needed for:
	//   .css('filter') (IE 9 only, trac-12537)
	//   .css('--customProperty) (gh-3144)
	if ( computed ) {

		// Support: IE <=9 - 11+
		// IE only supports `"float"` in `getPropertyValue`; in computed styles
		// it's only available as `"cssFloat"`. We no longer modify properties
		// sent to `.css()` apart from camelCasing, so we need to check both.
		// Normally, this would create difference in behavior: if
		// `getPropertyValue` returns an empty string, the value returned
		// by `.css()` would be `undefined`. This is usually the case for
		// disconnected elements. However, in IE even disconnected elements
		// with no styles return `"none"` for `getPropertyValue( "float" )`
		ret = computed.getPropertyValue( name ) || computed[ name ];

		if ( isCustomProp && ret ) {

			// Support: Firefox 105+, Chrome <=105+
			// Spec requires trimming whitespace for custom properties (gh-4926).
			// Firefox only trims leading whitespace. Chrome just collapses
			// both leading & trailing whitespace to a single space.
			//
			// Fall back to `undefined` if empty string returned.
			// This collapses a missing definition with property defined
			// and set to an empty string but there's no standard API
			// allowing us to differentiate them without a performance penalty
			// and returning `undefined` aligns with older jQuery.
			//
			// rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
			// as whitespace while CSS does not, but this is not a problem
			// because CSS preprocessing replaces them with U+000A LINE FEED
			// (which *is* CSS whitespace)
			// https://www.w3.org/TR/css-syntax-3/#input-preprocessing
			ret = ret.replace( rtrimCSS, "$1" ) || undefined;
		}

		if ( ret === "" && !isAttached( elem ) ) {
			ret = jQuery.style( elem, name );
		}

		// A tribute to the "awesome hack by Dean Edwards"
		// Android Browser returns percentage for some values,
		// but width seems to be reliably pixels.
		// This is against the CSSOM draft spec:
		// https://drafts.csswg.org/cssom/#resolved-values
		if ( !support.pixelBoxStyles() && rnumnonpx.test( ret ) && rboxStyle.test( name ) ) {

			// Remember the original values
			width = style.width;
			minWidth = style.minWidth;
			maxWidth = style.maxWidth;

			// Put in the new values to get a computed value out
			style.minWidth = style.maxWidth = style.width = ret;
			ret = computed.width;

			// Revert the changed values
			style.width = width;
			style.minWidth = minWidth;
			style.maxWidth = maxWidth;
		}
	}

	return ret !== undefined ?

		// Support: IE <=9 - 11 only
		// IE returns zIndex value as an integer.
		ret + "" :
		ret;
}


function addGetHookIf( conditionFn, hookFn ) {

	// Define the hook, we'll check on the first run if it's really needed.
	return {
		get: function() {
			if ( conditionFn() ) {

				// Hook not needed (or it's not possible to use it due
				// to missing dependency), remove it.
				delete this.get;
				return;
			}

			// Hook needed; redefine it so that the support test is not executed again.
			return ( this.get = hookFn ).apply( this, arguments );
		}
	};
}


var cssPrefixes = [ "Webkit", "Moz", "ms" ],
	emptyStyle = document.createElement( "div" ).style,
	vendorProps = {};

// Return a vendor-prefixed property or undefined
function vendorPropName( name ) {

	// Check for vendor prefixed names
	var capName = name[ 0 ].toUpperCase() + name.slice( 1 ),
		i = cssPrefixes.length;

	while ( i-- ) {
		name = cssPrefixes[ i ] + capName;
		if ( name in emptyStyle ) {
			return name;
		}
	}
}

// Return a potentially-mapped jQuery.cssProps or vendor prefixed property
function finalPropName( name ) {
	var final = jQuery.cssProps[ name ] || vendorProps[ name ];

	if ( final ) {
		return final;
	}
	if ( name in emptyStyle ) {
		return name;
	}
	return vendorProps[ name ] = vendorPropName( name ) || name;
}


var

	// Swappable if display is none or starts with table
	// except "table", "table-cell", or "table-caption"
	// See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
	rdisplayswap = /^(none|table(?!-c[ea]).+)/,
	cssShow = { position: "absolute", visibility: "hidden", display: "block" },
	cssNormalTransform = {
		letterSpacing: "0",
		fontWeight: "400"
	};

function setPositiveNumber( _elem, value, subtract ) {

	// Any relative (+/-) values have already been
	// normalized at this point
	var matches = rcssNum.exec( value );
	return matches ?

		// Guard against undefined "subtract", e.g., when used as in cssHooks
		Math.max( 0, matches[ 2 ] - ( subtract || 0 ) ) + ( matches[ 3 ] || "px" ) :
		value;
}

function boxModelAdjustment( elem, dimension, box, isBorderBox, styles, computedVal ) {
	var i = dimension === "width" ? 1 : 0,
		extra = 0,
		delta = 0,
		marginDelta = 0;

	// Adjustment may not be necessary
	if ( box === ( isBorderBox ? "border" : "content" ) ) {
		return 0;
	}

	for ( ; i < 4; i += 2 ) {

		// Both box models exclude margin
		// Count margin delta separately to only add it after scroll gutter adjustment.
		// This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
		if ( box === "margin" ) {
			marginDelta += jQuery.css( elem, box + cssExpand[ i ], true, styles );
		}

		// If we get here with a content-box, we're seeking "padding" or "border" or "margin"
		if ( !isBorderBox ) {

			// Add padding
			delta += jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );

			// For "border" or "margin", add border
			if ( box !== "padding" ) {
				delta += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );

			// But still keep track of it otherwise
			} else {
				extra += jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}

		// If we get here with a border-box (content + padding + border), we're seeking "content" or
		// "padding" or "margin"
		} else {

			// For "content", subtract padding
			if ( box === "content" ) {
				delta -= jQuery.css( elem, "padding" + cssExpand[ i ], true, styles );
			}

			// For "content" or "padding", subtract border
			if ( box !== "margin" ) {
				delta -= jQuery.css( elem, "border" + cssExpand[ i ] + "Width", true, styles );
			}
		}
	}

	// Account for positive content-box scroll gutter when requested by providing computedVal
	if ( !isBorderBox && computedVal >= 0 ) {

		// offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
		// Assuming integer scroll gutter, subtract the rest and round down
		delta += Math.max( 0, Math.ceil(
			elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
			computedVal -
			delta -
			extra -
			0.5

		// If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
		// Use an explicit zero to avoid NaN (gh-3964)
		) ) || 0;
	}

	return delta + marginDelta;
}

function getWidthOrHeight( elem, dimension, extra ) {

	// Start with computed style
	var styles = getStyles( elem ),

		// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
		// Fake content-box until we know it's needed to know the true value.
		boxSizingNeeded = !support.boxSizingReliable() || extra,
		isBorderBox = boxSizingNeeded &&
			jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
		valueIsBorderBox = isBorderBox,

		val = curCSS( elem, dimension, styles ),
		offsetProp = "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 );

	// Support: Firefox <=54
	// Return a confounding non-pixel value or feign ignorance, as appropriate.
	if ( rnumnonpx.test( val ) ) {
		if ( !extra ) {
			return val;
		}
		val = "auto";
	}


	// Support: IE 9 - 11 only
	// Use offsetWidth/offsetHeight for when box sizing is unreliable.
	// In those cases, the computed value can be trusted to be border-box.
	if ( ( !support.boxSizingReliable() && isBorderBox ||

		// Support: IE 10 - 11+, Edge 15 - 18+
		// IE/Edge misreport `getComputedStyle` of table rows with width/height
		// set in CSS while `offset*` properties report correct values.
		// Interestingly, in some cases IE 9 doesn't suffer from this issue.
		!support.reliableTrDimensions() && nodeName( elem, "tr" ) ||

		// Fall back to offsetWidth/offsetHeight when value is "auto"
		// This happens for inline elements with no explicit setting (gh-3571)
		val === "auto" ||

		// Support: Android <=4.1 - 4.3 only
		// Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
		!parseFloat( val ) && jQuery.css( elem, "display", false, styles ) === "inline" ) &&

		// Make sure the element is visible & connected
		elem.getClientRects().length ) {

		isBorderBox = jQuery.css( elem, "boxSizing", false, styles ) === "border-box";

		// Where available, offsetWidth/offsetHeight approximate border box dimensions.
		// Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
		// retrieved value as a content box dimension.
		valueIsBorderBox = offsetProp in elem;
		if ( valueIsBorderBox ) {
			val = elem[ offsetProp ];
		}
	}

	// Normalize "" and auto
	val = parseFloat( val ) || 0;

	// Adjust for the element's box model
	return ( val +
		boxModelAdjustment(
			elem,
			dimension,
			extra || ( isBorderBox ? "border" : "content" ),
			valueIsBorderBox,
			styles,

			// Provide the current computed size to request scroll gutter calculation (gh-3589)
			val
		)
	) + "px";
}

jQuery.extend( {

	// Add in style property hooks for overriding the default
	// behavior of getting and setting a style property
	cssHooks: {
		opacity: {
			get: function( elem, computed ) {
				if ( computed ) {

					// We should always get a number back from opacity
					var ret = curCSS( elem, "opacity" );
					return ret === "" ? "1" : ret;
				}
			}
		}
	},

	// Don't automatically add "px" to these possibly-unitless properties
	cssNumber: {
		animationIterationCount: true,
		aspectRatio: true,
		borderImageSlice: true,
		columnCount: true,
		flexGrow: true,
		flexShrink: true,
		fontWeight: true,
		gridArea: true,
		gridColumn: true,
		gridColumnEnd: true,
		gridColumnStart: true,
		gridRow: true,
		gridRowEnd: true,
		gridRowStart: true,
		lineHeight: true,
		opacity: true,
		order: true,
		orphans: true,
		scale: true,
		widows: true,
		zIndex: true,
		zoom: true,

		// SVG-related
		fillOpacity: true,
		floodOpacity: true,
		stopOpacity: true,
		strokeMiterlimit: true,
		strokeOpacity: true
	},

	// Add in properties whose names you wish to fix before
	// setting or getting the value
	cssProps: {},

	// Get and set the style property on a DOM Node
	style: function( elem, name, value, extra ) {

		// Don't set styles on text and comment nodes
		if ( !elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style ) {
			return;
		}

		// Make sure that we're working with the right name
		var ret, type, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name ),
			style = elem.style;

		// Make sure that we're working with the right name. We don't
		// want to query the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Gets hook for the prefixed version, then unprefixed version
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// Check if we're setting a value
		if ( value !== undefined ) {
			type = typeof value;

			// Convert "+=" or "-=" to relative numbers (trac-7345)
			if ( type === "string" && ( ret = rcssNum.exec( value ) ) && ret[ 1 ] ) {
				value = adjustCSS( elem, name, ret );

				// Fixes bug trac-9237
				type = "number";
			}

			// Make sure that null and NaN values aren't set (trac-7116)
			if ( value == null || value !== value ) {
				return;
			}

			// If a number was passed in, add the unit (except for certain CSS properties)
			// The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
			// "px" to a few hardcoded values.
			if ( type === "number" && !isCustomProp ) {
				value += ret && ret[ 3 ] || ( jQuery.cssNumber[ origName ] ? "" : "px" );
			}

			// background-* props affect original clone's values
			if ( !support.clearCloneStyle && value === "" && name.indexOf( "background" ) === 0 ) {
				style[ name ] = "inherit";
			}

			// If a hook was provided, use that value, otherwise just set the specified value
			if ( !hooks || !( "set" in hooks ) ||
				( value = hooks.set( elem, value, extra ) ) !== undefined ) {

				if ( isCustomProp ) {
					style.setProperty( name, value );
				} else {
					style[ name ] = value;
				}
			}

		} else {

			// If a hook was provided get the non-computed value from there
			if ( hooks && "get" in hooks &&
				( ret = hooks.get( elem, false, extra ) ) !== undefined ) {

				return ret;
			}

			// Otherwise just get the value from the style object
			return style[ name ];
		}
	},

	css: function( elem, name, extra, styles ) {
		var val, num, hooks,
			origName = camelCase( name ),
			isCustomProp = rcustomProp.test( name );

		// Make sure that we're working with the right name. We don't
		// want to modify the value if it is a CSS custom property
		// since they are user-defined.
		if ( !isCustomProp ) {
			name = finalPropName( origName );
		}

		// Try prefixed name followed by the unprefixed name
		hooks = jQuery.cssHooks[ name ] || jQuery.cssHooks[ origName ];

		// If a hook was provided get the computed value from there
		if ( hooks && "get" in hooks ) {
			val = hooks.get( elem, true, extra );
		}

		// Otherwise, if a way to get the computed value exists, use that
		if ( val === undefined ) {
			val = curCSS( elem, name, styles );
		}

		// Convert "normal" to computed value
		if ( val === "normal" && name in cssNormalTransform ) {
			val = cssNormalTransform[ name ];
		}

		// Make numeric if forced or a qualifier was provided and val looks numeric
		if ( extra === "" || extra ) {
			num = parseFloat( val );
			return extra === true || isFinite( num ) ? num || 0 : val;
		}

		return val;
	}
} );

jQuery.each( [ "height", "width" ], function( _i, dimension ) {
	jQuery.cssHooks[ dimension ] = {
		get: function( elem, computed, extra ) {
			if ( computed ) {

				// Certain elements can have dimension info if we invisibly show them
				// but it must have a current display style that would benefit
				return rdisplayswap.test( jQuery.css( elem, "display" ) ) &&

					// Support: Safari 8+
					// Table columns in Safari have non-zero offsetWidth & zero
					// getBoundingClientRect().width unless display is changed.
					// Support: IE <=11 only
					// Running getBoundingClientRect on a disconnected node
					// in IE throws an error.
					( !elem.getClientRects().length || !elem.getBoundingClientRect().width ) ?
					swap( elem, cssShow, function() {
						return getWidthOrHeight( elem, dimension, extra );
					} ) :
					getWidthOrHeight( elem, dimension, extra );
			}
		},

		set: function( elem, value, extra ) {
			var matches,
				styles = getStyles( elem ),

				// Only read styles.position if the test has a chance to fail
				// to avoid forcing a reflow.
				scrollboxSizeBuggy = !support.scrollboxSize() &&
					styles.position === "absolute",

				// To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
				boxSizingNeeded = scrollboxSizeBuggy || extra,
				isBorderBox = boxSizingNeeded &&
					jQuery.css( elem, "boxSizing", false, styles ) === "border-box",
				subtract = extra ?
					boxModelAdjustment(
						elem,
						dimension,
						extra,
						isBorderBox,
						styles
					) :
					0;

			// Account for unreliable border-box dimensions by comparing offset* to computed and
			// faking a content-box to get border and padding (gh-3699)
			if ( isBorderBox && scrollboxSizeBuggy ) {
				subtract -= Math.ceil(
					elem[ "offset" + dimension[ 0 ].toUpperCase() + dimension.slice( 1 ) ] -
					parseFloat( styles[ dimension ] ) -
					boxModelAdjustment( elem, dimension, "border", false, styles ) -
					0.5
				);
			}

			// Convert to pixels if value adjustment is needed
			if ( subtract && ( matches = rcssNum.exec( value ) ) &&
				( matches[ 3 ] || "px" ) !== "px" ) {

				elem.style[ dimension ] = value;
				value = jQuery.css( elem, dimension );
			}

			return setPositiveNumber( elem, value, subtract );
		}
	};
} );

jQuery.cssHooks.marginLeft = addGetHookIf( support.reliableMarginLeft,
	function( elem, computed ) {
		if ( computed ) {
			return ( parseFloat( curCSS( elem, "marginLeft" ) ) ||
				elem.getBoundingClientRect().left -
					swap( elem, { marginLeft: 0 }, function() {
						return elem.getBoundingClientRect().left;
					} )
			) + "px";
		}
	}
);

// These hooks are used by animate to expand properties
jQuery.each( {
	margin: "",
	padding: "",
	border: "Width"
}, function( prefix, suffix ) {
	jQuery.cssHooks[ prefix + suffix ] = {
		expand: function( value ) {
			var i = 0,
				expanded = {},

				// Assumes a single number if not a string
				parts = typeof value === "string" ? value.split( " " ) : [ value ];

			for ( ; i < 4; i++ ) {
				expanded[ prefix + cssExpand[ i ] + suffix ] =
					parts[ i ] || parts[ i - 2 ] || parts[ 0 ];
			}

			return expanded;
		}
	};

	if ( prefix !== "margin" ) {
		jQuery.cssHooks[ prefix + suffix ].set = setPositiveNumber;
	}
} );

jQuery.fn.extend( {
	css: function( name, value ) {
		return access( this, function( elem, name, value ) {
			var styles, len,
				map = {},
				i = 0;

			if ( Array.isArray( name ) ) {
				styles = getStyles( elem );
				len = name.length;

				for ( ; i < len; i++ ) {
					map[ name[ i ] ] = jQuery.css( elem, name[ i ], false, styles );
				}

				return map;
			}

			return value !== undefined ?
				jQuery.style( elem, name, value ) :
				jQuery.css( elem, name );
		}, name, value, arguments.length > 1 );
	}
} );


function Tween( elem, options, prop, end, easing ) {
	return new Tween.prototype.init( elem, options, prop, end, easing );
}
jQuery.Tween = Tween;

Tween.prototype = {
	constructor: Tween,
	init: function( elem, options, prop, end, easing, unit ) {
		this.elem = elem;
		this.prop = prop;
		this.easing = easing || jQuery.easing._default;
		this.options = options;
		this.start = this.now = this.cur();
		this.end = end;
		this.unit = unit || ( jQuery.cssNumber[ prop ] ? "" : "px" );
	},
	cur: function() {
		var hooks = Tween.propHooks[ this.prop ];

		return hooks && hooks.get ?
			hooks.get( this ) :
			Tween.propHooks._default.get( this );
	},
	run: function( percent ) {
		var eased,
			hooks = Tween.propHooks[ this.prop ];

		if ( this.options.duration ) {
			this.pos = eased = jQuery.easing[ this.easing ](
				percent, this.options.duration * percent, 0, 1, this.options.duration
			);
		} else {
			this.pos = eased = percent;
		}
		this.now = ( this.end - this.start ) * eased + this.start;

		if ( this.options.step ) {
			this.options.step.call( this.elem, this.now, this );
		}

		if ( hooks && hooks.set ) {
			hooks.set( this );
		} else {
			Tween.propHooks._default.set( this );
		}
		return this;
	}
};

Tween.prototype.init.prototype = Tween.prototype;

Tween.propHooks = {
	_default: {
		get: function( tween ) {
			var result;

			// Use a property on the element directly when it is not a DOM element,
			// or when there is no matching style property that exists.
			if ( tween.elem.nodeType !== 1 ||
				tween.elem[ tween.prop ] != null && tween.elem.style[ tween.prop ] == null ) {
				return tween.elem[ tween.prop ];
			}

			// Passing an empty string as a 3rd parameter to .css will automatically
			// attempt a parseFloat and fallback to a string if the parse fails.
			// Simple values such as "10px" are parsed to Float;
			// complex values such as "rotate(1rad)" are returned as-is.
			result = jQuery.css( tween.elem, tween.prop, "" );

			// Empty strings, null, undefined and "auto" are converted to 0.
			return !result || result === "auto" ? 0 : result;
		},
		set: function( tween ) {

			// Use step hook for back compat.
			// Use cssHook if its there.
			// Use .style if available and use plain properties where available.
			if ( jQuery.fx.step[ tween.prop ] ) {
				jQuery.fx.step[ tween.prop ]( tween );
			} else if ( tween.elem.nodeType === 1 && (
				jQuery.cssHooks[ tween.prop ] ||
					tween.elem.style[ finalPropName( tween.prop ) ] != null ) ) {
				jQuery.style( tween.elem, tween.prop, tween.now + tween.unit );
			} else {
				tween.elem[ tween.prop ] = tween.now;
			}
		}
	}
};

// Support: IE <=9 only
// Panic based approach to setting things on disconnected nodes
Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
	set: function( tween ) {
		if ( tween.elem.nodeType && tween.elem.parentNode ) {
			tween.elem[ tween.prop ] = tween.now;
		}
	}
};

jQuery.easing = {
	linear: function( p ) {
		return p;
	},
	swing: function( p ) {
		return 0.5 - Math.cos( p * Math.PI ) / 2;
	},
	_default: "swing"
};

jQuery.fx = Tween.prototype.init;

// Back compat <1.8 extension point
jQuery.fx.step = {};




var
	fxNow, inProgress,
	rfxtypes = /^(?:toggle|show|hide)$/,
	rrun = /queueHooks$/;

function schedule() {
	if ( inProgress ) {
		if ( document.hidden === false && window.requestAnimationFrame ) {
			window.requestAnimationFrame( schedule );
		} else {
			window.setTimeout( schedule, jQuery.fx.interval );
		}

		jQuery.fx.tick();
	}
}

// Animations created synchronously will run synchronously
function createFxNow() {
	window.setTimeout( function() {
		fxNow = undefined;
	} );
	return ( fxNow = Date.now() );
}

// Generate parameters to create a standard animation
function genFx( type, includeWidth ) {
	var which,
		i = 0,
		attrs = { height: type };

	// If we include width, step value is 1 to do all cssExpand values,
	// otherwise step value is 2 to skip over Left and Right
	includeWidth = includeWidth ? 1 : 0;
	for ( ; i < 4; i += 2 - includeWidth ) {
		which = cssExpand[ i ];
		attrs[ "margin" + which ] = attrs[ "padding" + which ] = type;
	}

	if ( includeWidth ) {
		attrs.opacity = attrs.width = type;
	}

	return attrs;
}

function createTween( value, prop, animation ) {
	var tween,
		collection = ( Animation.tweeners[ prop ] || [] ).concat( Animation.tweeners[ "*" ] ),
		index = 0,
		length = collection.length;
	for ( ; index < length; index++ ) {
		if ( ( tween = collection[ index ].call( animation, prop, value ) ) ) {

			// We're done with this property
			return tween;
		}
	}
}

function defaultPrefilter( elem, props, opts ) {
	var prop, value, toggle, hooks, oldfire, propTween, restoreDisplay, display,
		isBox = "width" in props || "height" in props,
		anim = this,
		orig = {},
		style = elem.style,
		hidden = elem.nodeType && isHiddenWithinTree( elem ),
		dataShow = dataPriv.get( elem, "fxshow" );

	// Queue-skipping animations hijack the fx hooks
	if ( !opts.queue ) {
		hooks = jQuery._queueHooks( elem, "fx" );
		if ( hooks.unqueued == null ) {
			hooks.unqueued = 0;
			oldfire = hooks.empty.fire;
			hooks.empty.fire = function() {
				if ( !hooks.unqueued ) {
					oldfire();
				}
			};
		}
		hooks.unqueued++;

		anim.always( function() {

			// Ensure the complete handler is called before this completes
			anim.always( function() {
				hooks.unqueued--;
				if ( !jQuery.queue( elem, "fx" ).length ) {
					hooks.empty.fire();
				}
			} );
		} );
	}

	// Detect show/hide animations
	for ( prop in props ) {
		value = props[ prop ];
		if ( rfxtypes.test( value ) ) {
			delete props[ prop ];
			toggle = toggle || value === "toggle";
			if ( value === ( hidden ? "hide" : "show" ) ) {

				// Pretend to be hidden if this is a "show" and
				// there is still data from a stopped show/hide
				if ( value === "show" && dataShow && dataShow[ prop ] !== undefined ) {
					hidden = true;

				// Ignore all other no-op show/hide data
				} else {
					continue;
				}
			}
			orig[ prop ] = dataShow && dataShow[ prop ] || jQuery.style( elem, prop );
		}
	}

	// Bail out if this is a no-op like .hide().hide()
	propTween = !jQuery.isEmptyObject( props );
	if ( !propTween && jQuery.isEmptyObject( orig ) ) {
		return;
	}

	// Restrict "overflow" and "display" styles during box animations
	if ( isBox && elem.nodeType === 1 ) {

		// Support: IE <=9 - 11, Edge 12 - 15
		// Record all 3 overflow attributes because IE does not infer the shorthand
		// from identically-valued overflowX and overflowY and Edge just mirrors
		// the overflowX value there.
		opts.overflow = [ style.overflow, style.overflowX, style.overflowY ];

		// Identify a display type, preferring old show/hide data over the CSS cascade
		restoreDisplay = dataShow && dataShow.display;
		if ( restoreDisplay == null ) {
			restoreDisplay = dataPriv.get( elem, "display" );
		}
		display = jQuery.css( elem, "display" );
		if ( display === "none" ) {
			if ( restoreDisplay ) {
				display = restoreDisplay;
			} else {

				// Get nonempty value(s) by temporarily forcing visibility
				showHide( [ elem ], true );
				restoreDisplay = elem.style.display || restoreDisplay;
				display = jQuery.css( elem, "display" );
				showHide( [ elem ] );
			}
		}

		// Animate inline elements as inline-block
		if ( display === "inline" || display === "inline-block" && restoreDisplay != null ) {
			if ( jQuery.css( elem, "float" ) === "none" ) {

				// Restore the original display value at the end of pure show/hide animations
				if ( !propTween ) {
					anim.done( function() {
						style.display = restoreDisplay;
					} );
					if ( restoreDisplay == null ) {
						display = style.display;
						restoreDisplay = display === "none" ? "" : display;
					}
				}
				style.display = "inline-block";
			}
		}
	}

	if ( opts.overflow ) {
		style.overflow = "hidden";
		anim.always( function() {
			style.overflow = opts.overflow[ 0 ];
			style.overflowX = opts.overflow[ 1 ];
			style.overflowY = opts.overflow[ 2 ];
		} );
	}

	// Implement show/hide animations
	propTween = false;
	for ( prop in orig ) {

		// General show/hide setup for this element animation
		if ( !propTween ) {
			if ( dataShow ) {
				if ( "hidden" in dataShow ) {
					hidden = dataShow.hidden;
				}
			} else {
				dataShow = dataPriv.access( elem, "fxshow", { display: restoreDisplay } );
			}

			// Store hidden/visible for toggle so `.stop().toggle()` "reverses"
			if ( toggle ) {
				dataShow.hidden = !hidden;
			}

			// Show elements before animating them
			if ( hidden ) {
				showHide( [ elem ], true );
			}

			/* eslint-disable no-loop-func */

			anim.done( function() {

				/* eslint-enable no-loop-func */

				// The final step of a "hide" animation is actually hiding the element
				if ( !hidden ) {
					showHide( [ elem ] );
				}
				dataPriv.remove( elem, "fxshow" );
				for ( prop in orig ) {
					jQuery.style( elem, prop, orig[ prop ] );
				}
			} );
		}

		// Per-property setup
		propTween = createTween( hidden ? dataShow[ prop ] : 0, prop, anim );
		if ( !( prop in dataShow ) ) {
			dataShow[ prop ] = propTween.start;
			if ( hidden ) {
				propTween.end = propTween.start;
				propTween.start = 0;
			}
		}
	}
}

function propFilter( props, specialEasing ) {
	var index, name, easing, value, hooks;

	// camelCase, specialEasing and expand cssHook pass
	for ( index in props ) {
		name = camelCase( index );
		easing = specialEasing[ name ];
		value = props[ index ];
		if ( Array.isArray( value ) ) {
			easing = value[ 1 ];
			value = props[ index ] = value[ 0 ];
		}

		if ( index !== name ) {
			props[ name ] = value;
			delete props[ index ];
		}

		hooks = jQuery.cssHooks[ name ];
		if ( hooks && "expand" in hooks ) {
			value = hooks.expand( value );
			delete props[ name ];

			// Not quite $.extend, this won't overwrite existing keys.
			// Reusing 'index' because we have the correct "name"
			for ( index in value ) {
				if ( !( index in props ) ) {
					props[ index ] = value[ index ];
					specialEasing[ index ] = easing;
				}
			}
		} else {
			specialEasing[ name ] = easing;
		}
	}
}

function Animation( elem, properties, options ) {
	var result,
		stopped,
		index = 0,
		length = Animation.prefilters.length,
		deferred = jQuery.Deferred().always( function() {

			// Don't match elem in the :animated selector
			delete tick.elem;
		} ),
		tick = function() {
			if ( stopped ) {
				return false;
			}
			var currentTime = fxNow || createFxNow(),
				remaining = Math.max( 0, animation.startTime + animation.duration - currentTime ),

				// Support: Android 2.3 only
				// Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
				temp = remaining / animation.duration || 0,
				percent = 1 - temp,
				index = 0,
				length = animation.tweens.length;

			for ( ; index < length; index++ ) {
				animation.tweens[ index ].run( percent );
			}

			deferred.notifyWith( elem, [ animation, percent, remaining ] );

			// If there's more to do, yield
			if ( percent < 1 && length ) {
				return remaining;
			}

			// If this was an empty animation, synthesize a final progress notification
			if ( !length ) {
				deferred.notifyWith( elem, [ animation, 1, 0 ] );
			}

			// Resolve the animation and report its conclusion
			deferred.resolveWith( elem, [ animation ] );
			return false;
		},
		animation = deferred.promise( {
			elem: elem,
			props: jQuery.extend( {}, properties ),
			opts: jQuery.extend( true, {
				specialEasing: {},
				easing: jQuery.easing._default
			}, options ),
			originalProperties: properties,
			originalOptions: options,
			startTime: fxNow || createFxNow(),
			duration: options.duration,
			tweens: [],
			createTween: function( prop, end ) {
				var tween = jQuery.Tween( elem, animation.opts, prop, end,
					animation.opts.specialEasing[ prop ] || animation.opts.easing );
				animation.tweens.push( tween );
				return tween;
			},
			stop: function( gotoEnd ) {
				var index = 0,

					// If we are going to the end, we want to run all the tweens
					// otherwise we skip this part
					length = gotoEnd ? animation.tweens.length : 0;
				if ( stopped ) {
					return this;
				}
				stopped = true;
				for ( ; index < length; index++ ) {
					animation.tweens[ index ].run( 1 );
				}

				// Resolve when we played the last frame; otherwise, reject
				if ( gotoEnd ) {
					deferred.notifyWith( elem, [ animation, 1, 0 ] );
					deferred.resolveWith( elem, [ animation, gotoEnd ] );
				} else {
					deferred.rejectWith( elem, [ animation, gotoEnd ] );
				}
				return this;
			}
		} ),
		props = animation.props;

	propFilter( props, animation.opts.specialEasing );

	for ( ; index < length; index++ ) {
		result = Animation.prefilters[ index ].call( animation, elem, props, animation.opts );
		if ( result ) {
			if ( isFunction( result.stop ) ) {
				jQuery._queueHooks( animation.elem, animation.opts.queue ).stop =
					result.stop.bind( result );
			}
			return result;
		}
	}

	jQuery.map( props, createTween, animation );

	if ( isFunction( animation.opts.start ) ) {
		animation.opts.start.call( elem, animation );
	}

	// Attach callbacks from options
	animation
		.progress( animation.opts.progress )
		.done( animation.opts.done, animation.opts.complete )
		.fail( animation.opts.fail )
		.always( animation.opts.always );

	jQuery.fx.timer(
		jQuery.extend( tick, {
			elem: elem,
			anim: animation,
			queue: animation.opts.queue
		} )
	);

	return animation;
}

jQuery.Animation = jQuery.extend( Animation, {

	tweeners: {
		"*": [ function( prop, value ) {
			var tween = this.createTween( prop, value );
			adjustCSS( tween.elem, prop, rcssNum.exec( value ), tween );
			return tween;
		} ]
	},

	tweener: function( props, callback ) {
		if ( isFunction( props ) ) {
			callback = props;
			props = [ "*" ];
		} else {
			props = props.match( rnothtmlwhite );
		}

		var prop,
			index = 0,
			length = props.length;

		for ( ; index < length; index++ ) {
			prop = props[ index ];
			Animation.tweeners[ prop ] = Animation.tweeners[ prop ] || [];
			Animation.tweeners[ prop ].unshift( callback );
		}
	},

	prefilters: [ defaultPrefilter ],

	prefilter: function( callback, prepend ) {
		if ( prepend ) {
			Animation.prefilters.unshift( callback );
		} else {
			Animation.prefilters.push( callback );
		}
	}
} );

jQuery.speed = function( speed, easing, fn ) {
	var opt = speed && typeof speed === "object" ? jQuery.extend( {}, speed ) : {
		complete: fn || !fn && easing ||
			isFunction( speed ) && speed,
		duration: speed,
		easing: fn && easing || easing && !isFunction( easing ) && easing
	};

	// Go to the end state if fx are off
	if ( jQuery.fx.off ) {
		opt.duration = 0;

	} else {
		if ( typeof opt.duration !== "number" ) {
			if ( opt.duration in jQuery.fx.speeds ) {
				opt.duration = jQuery.fx.speeds[ opt.duration ];

			} else {
				opt.duration = jQuery.fx.speeds._default;
			}
		}
	}

	// Normalize opt.queue - true/undefined/null -> "fx"
	if ( opt.queue == null || opt.queue === true ) {
		opt.queue = "fx";
	}

	// Queueing
	opt.old = opt.complete;

	opt.complete = function() {
		if ( isFunction( opt.old ) ) {
			opt.old.call( this );
		}

		if ( opt.queue ) {
			jQuery.dequeue( this, opt.queue );
		}
	};

	return opt;
};

jQuery.fn.extend( {
	fadeTo: function( speed, to, easing, callback ) {

		// Show any hidden elements after setting opacity to 0
		return this.filter( isHiddenWithinTree ).css( "opacity", 0 ).show()

			// Animate to the value specified
			.end().animate( { opacity: to }, speed, easing, callback );
	},
	animate: function( prop, speed, easing, callback ) {
		var empty = jQuery.isEmptyObject( prop ),
			optall = jQuery.speed( speed, easing, callback ),
			doAnimation = function() {

				// Operate on a copy of prop so per-property easing won't be lost
				var anim = Animation( this, jQuery.extend( {}, prop ), optall );

				// Empty animations, or finishing resolves immediately
				if ( empty || dataPriv.get( this, "finish" ) ) {
					anim.stop( true );
				}
			};

		doAnimation.finish = doAnimation;

		return empty || optall.queue === false ?
			this.each( doAnimation ) :
			this.queue( optall.queue, doAnimation );
	},
	stop: function( type, clearQueue, gotoEnd ) {
		var stopQueue = function( hooks ) {
			var stop = hooks.stop;
			delete hooks.stop;
			stop( gotoEnd );
		};

		if ( typeof type !== "string" ) {
			gotoEnd = clearQueue;
			clearQueue = type;
			type = undefined;
		}
		if ( clearQueue ) {
			this.queue( type || "fx", [] );
		}

		return this.each( function() {
			var dequeue = true,
				index = type != null && type + "queueHooks",
				timers = jQuery.timers,
				data = dataPriv.get( this );

			if ( index ) {
				if ( data[ index ] && data[ index ].stop ) {
					stopQueue( data[ index ] );
				}
			} else {
				for ( index in data ) {
					if ( data[ index ] && data[ index ].stop && rrun.test( index ) ) {
						stopQueue( data[ index ] );
					}
				}
			}

			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this &&
					( type == null || timers[ index ].queue === type ) ) {

					timers[ index ].anim.stop( gotoEnd );
					dequeue = false;
					timers.splice( index, 1 );
				}
			}

			// Start the next in the queue if the last step wasn't forced.
			// Timers currently will call their complete callbacks, which
			// will dequeue but only if they were gotoEnd.
			if ( dequeue || !gotoEnd ) {
				jQuery.dequeue( this, type );
			}
		} );
	},
	finish: function( type ) {
		if ( type !== false ) {
			type = type || "fx";
		}
		return this.each( function() {
			var index,
				data = dataPriv.get( this ),
				queue = data[ type + "queue" ],
				hooks = data[ type + "queueHooks" ],
				timers = jQuery.timers,
				length = queue ? queue.length : 0;

			// Enable finishing flag on private data
			data.finish = true;

			// Empty the queue first
			jQuery.queue( this, type, [] );

			if ( hooks && hooks.stop ) {
				hooks.stop.call( this, true );
			}

			// Look for any active animations, and finish them
			for ( index = timers.length; index--; ) {
				if ( timers[ index ].elem === this && timers[ index ].queue === type ) {
					timers[ index ].anim.stop( true );
					timers.splice( index, 1 );
				}
			}

			// Look for any animations in the old queue and finish them
			for ( index = 0; index < length; index++ ) {
				if ( queue[ index ] && queue[ index ].finish ) {
					queue[ index ].finish.call( this );
				}
			}

			// Turn off finishing flag
			delete data.finish;
		} );
	}
} );

jQuery.each( [ "toggle", "show", "hide" ], function( _i, name ) {
	var cssFn = jQuery.fn[ name ];
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return speed == null || typeof speed === "boolean" ?
			cssFn.apply( this, arguments ) :
			this.animate( genFx( name, true ), speed, easing, callback );
	};
} );

// Generate shortcuts for custom animations
jQuery.each( {
	slideDown: genFx( "show" ),
	slideUp: genFx( "hide" ),
	slideToggle: genFx( "toggle" ),
	fadeIn: { opacity: "show" },
	fadeOut: { opacity: "hide" },
	fadeToggle: { opacity: "toggle" }
}, function( name, props ) {
	jQuery.fn[ name ] = function( speed, easing, callback ) {
		return this.animate( props, speed, easing, callback );
	};
} );

jQuery.timers = [];
jQuery.fx.tick = function() {
	var timer,
		i = 0,
		timers = jQuery.timers;

	fxNow = Date.now();

	for ( ; i < timers.length; i++ ) {
		timer = timers[ i ];

		// Run the timer and safely remove it when done (allowing for external removal)
		if ( !timer() && timers[ i ] === timer ) {
			timers.splice( i--, 1 );
		}
	}

	if ( !timers.length ) {
		jQuery.fx.stop();
	}
	fxNow = undefined;
};

jQuery.fx.timer = function( timer ) {
	jQuery.timers.push( timer );
	jQuery.fx.start();
};

jQuery.fx.interval = 13;
jQuery.fx.start = function() {
	if ( inProgress ) {
		return;
	}

	inProgress = true;
	schedule();
};

jQuery.fx.stop = function() {
	inProgress = null;
};

jQuery.fx.speeds = {
	slow: 600,
	fast: 200,

	// Default speed
	_default: 400
};


// Based off of the plugin by Clint Helfers, with permission.
jQuery.fn.delay = function( time, type ) {
	time = jQuery.fx ? jQuery.fx.speeds[ time ] || time : time;
	type = type || "fx";

	return this.queue( type, function( next, hooks ) {
		var timeout = window.setTimeout( next, time );
		hooks.stop = function() {
			window.clearTimeout( timeout );
		};
	} );
};


( function() {
	var input = document.createElement( "input" ),
		select = document.createElement( "select" ),
		opt = select.appendChild( document.createElement( "option" ) );

	input.type = "checkbox";

	// Support: Android <=4.3 only
	// Default value for a checkbox should be "on"
	support.checkOn = input.value !== "";

	// Support: IE <=11 only
	// Must access selectedIndex to make default options select
	support.optSelected = opt.selected;

	// Support: IE <=11 only
	// An input loses its value after becoming a radio
	input = document.createElement( "input" );
	input.value = "t";
	input.type = "radio";
	support.radioValue = input.value === "t";
} )();


var boolHook,
	attrHandle = jQuery.expr.attrHandle;

jQuery.fn.extend( {
	attr: function( name, value ) {
		return access( this, jQuery.attr, name, value, arguments.length > 1 );
	},

	removeAttr: function( name ) {
		return this.each( function() {
			jQuery.removeAttr( this, name );
		} );
	}
} );

jQuery.extend( {
	attr: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set attributes on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		// Fallback to prop when attributes are not supported
		if ( typeof elem.getAttribute === "undefined" ) {
			return jQuery.prop( elem, name, value );
		}

		// Attribute hooks are determined by the lowercase version
		// Grab necessary hook if one is defined
		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {
			hooks = jQuery.attrHooks[ name.toLowerCase() ] ||
				( jQuery.expr.match.bool.test( name ) ? boolHook : undefined );
		}

		if ( value !== undefined ) {
			if ( value === null ) {
				jQuery.removeAttr( elem, name );
				return;
			}

			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			elem.setAttribute( name, value + "" );
			return value;
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		ret = jQuery.find.attr( elem, name );

		// Non-existent attributes return null, we normalize to undefined
		return ret == null ? undefined : ret;
	},

	attrHooks: {
		type: {
			set: function( elem, value ) {
				if ( !support.radioValue && value === "radio" &&
					nodeName( elem, "input" ) ) {
					var val = elem.value;
					elem.setAttribute( "type", value );
					if ( val ) {
						elem.value = val;
					}
					return value;
				}
			}
		}
	},

	removeAttr: function( elem, value ) {
		var name,
			i = 0,

			// Attribute names can contain non-HTML whitespace characters
			// https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
			attrNames = value && value.match( rnothtmlwhite );

		if ( attrNames && elem.nodeType === 1 ) {
			while ( ( name = attrNames[ i++ ] ) ) {
				elem.removeAttribute( name );
			}
		}
	}
} );

// Hooks for boolean attributes
boolHook = {
	set: function( elem, value, name ) {
		if ( value === false ) {

			// Remove boolean attributes when set to false
			jQuery.removeAttr( elem, name );
		} else {
			elem.setAttribute( name, name );
		}
		return name;
	}
};

jQuery.each( jQuery.expr.match.bool.source.match( /\w+/g ), function( _i, name ) {
	var getter = attrHandle[ name ] || jQuery.find.attr;

	attrHandle[ name ] = function( elem, name, isXML ) {
		var ret, handle,
			lowercaseName = name.toLowerCase();

		if ( !isXML ) {

			// Avoid an infinite loop by temporarily removing this function from the getter
			handle = attrHandle[ lowercaseName ];
			attrHandle[ lowercaseName ] = ret;
			ret = getter( elem, name, isXML ) != null ?
				lowercaseName :
				null;
			attrHandle[ lowercaseName ] = handle;
		}
		return ret;
	};
} );




var rfocusable = /^(?:input|select|textarea|button)$/i,
	rclickable = /^(?:a|area)$/i;

jQuery.fn.extend( {
	prop: function( name, value ) {
		return access( this, jQuery.prop, name, value, arguments.length > 1 );
	},

	removeProp: function( name ) {
		return this.each( function() {
			delete this[ jQuery.propFix[ name ] || name ];
		} );
	}
} );

jQuery.extend( {
	prop: function( elem, name, value ) {
		var ret, hooks,
			nType = elem.nodeType;

		// Don't get/set properties on text, comment and attribute nodes
		if ( nType === 3 || nType === 8 || nType === 2 ) {
			return;
		}

		if ( nType !== 1 || !jQuery.isXMLDoc( elem ) ) {

			// Fix name and attach hooks
			name = jQuery.propFix[ name ] || name;
			hooks = jQuery.propHooks[ name ];
		}

		if ( value !== undefined ) {
			if ( hooks && "set" in hooks &&
				( ret = hooks.set( elem, value, name ) ) !== undefined ) {
				return ret;
			}

			return ( elem[ name ] = value );
		}

		if ( hooks && "get" in hooks && ( ret = hooks.get( elem, name ) ) !== null ) {
			return ret;
		}

		return elem[ name ];
	},

	propHooks: {
		tabIndex: {
			get: function( elem ) {

				// Support: IE <=9 - 11 only
				// elem.tabIndex doesn't always return the
				// correct value when it hasn't been explicitly set
				// Use proper attribute retrieval (trac-12072)
				var tabindex = jQuery.find.attr( elem, "tabindex" );

				if ( tabindex ) {
					return parseInt( tabindex, 10 );
				}

				if (
					rfocusable.test( elem.nodeName ) ||
					rclickable.test( elem.nodeName ) &&
					elem.href
				) {
					return 0;
				}

				return -1;
			}
		}
	},

	propFix: {
		"for": "htmlFor",
		"class": "className"
	}
} );

// Support: IE <=11 only
// Accessing the selectedIndex property
// forces the browser to respect setting selected
// on the option
// The getter ensures a default option is selected
// when in an optgroup
// eslint rule "no-unused-expressions" is disabled for this code
// since it considers such accessions noop
if ( !support.optSelected ) {
	jQuery.propHooks.selected = {
		get: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent && parent.parentNode ) {
				parent.parentNode.selectedIndex;
			}
			return null;
		},
		set: function( elem ) {

			/* eslint no-unused-expressions: "off" */

			var parent = elem.parentNode;
			if ( parent ) {
				parent.selectedIndex;

				if ( parent.parentNode ) {
					parent.parentNode.selectedIndex;
				}
			}
		}
	};
}

jQuery.each( [
	"tabIndex",
	"readOnly",
	"maxLength",
	"cellSpacing",
	"cellPadding",
	"rowSpan",
	"colSpan",
	"useMap",
	"frameBorder",
	"contentEditable"
], function() {
	jQuery.propFix[ this.toLowerCase() ] = this;
} );




	// Strip and collapse whitespace according to HTML spec
	// https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
	function stripAndCollapse( value ) {
		var tokens = value.match( rnothtmlwhite ) || [];
		return tokens.join( " " );
	}


function getClass( elem ) {
	return elem.getAttribute && elem.getAttribute( "class" ) || "";
}

function classesToArray( value ) {
	if ( Array.isArray( value ) ) {
		return value;
	}
	if ( typeof value === "string" ) {
		return value.match( rnothtmlwhite ) || [];
	}
	return [];
}

jQuery.fn.extend( {
	addClass: function( value ) {
		var classNames, cur, curValue, className, i, finalValue;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).addClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		classNames = classesToArray( value );

		if ( classNames.length ) {
			return this.each( function() {
				curValue = getClass( this );
				cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];
						if ( cur.indexOf( " " + className + " " ) < 0 ) {
							cur += className + " ";
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						this.setAttribute( "class", finalValue );
					}
				}
			} );
		}

		return this;
	},

	removeClass: function( value ) {
		var classNames, cur, curValue, className, i, finalValue;

		if ( isFunction( value ) ) {
			return this.each( function( j ) {
				jQuery( this ).removeClass( value.call( this, j, getClass( this ) ) );
			} );
		}

		if ( !arguments.length ) {
			return this.attr( "class", "" );
		}

		classNames = classesToArray( value );

		if ( classNames.length ) {
			return this.each( function() {
				curValue = getClass( this );

				// This expression is here for better compressibility (see addClass)
				cur = this.nodeType === 1 && ( " " + stripAndCollapse( curValue ) + " " );

				if ( cur ) {
					for ( i = 0; i < classNames.length; i++ ) {
						className = classNames[ i ];

						// Remove *all* instances
						while ( cur.indexOf( " " + className + " " ) > -1 ) {
							cur = cur.replace( " " + className + " ", " " );
						}
					}

					// Only assign if different to avoid unneeded rendering.
					finalValue = stripAndCollapse( cur );
					if ( curValue !== finalValue ) {
						this.setAttribute( "class", finalValue );
					}
				}
			} );
		}

		return this;
	},

	toggleClass: function( value, stateVal ) {
		var classNames, className, i, self,
			type = typeof value,
			isValidValue = type === "string" || Array.isArray( value );

		if ( isFunction( value ) ) {
			return this.each( function( i ) {
				jQuery( this ).toggleClass(
					value.call( this, i, getClass( this ), stateVal ),
					stateVal
				);
			} );
		}

		if ( typeof stateVal === "boolean" && isValidValue ) {
			return stateVal ? this.addClass( value ) : this.removeClass( value );
		}

		classNames = classesToArray( value );

		return this.each( function() {
			if ( isValidValue ) {

				// Toggle individual class names
				self = jQuery( this );

				for ( i = 0; i < classNames.length; i++ ) {
					className = classNames[ i ];

					// Check each className given, space separated list
					if ( self.hasClass( className ) ) {
						self.removeClass( className );
					} else {
						self.addClass( className );
					}
				}

			// Toggle whole class name
			} else if ( value === undefined || type === "boolean" ) {
				className = getClass( this );
				if ( className ) {

					// Store className if set
					dataPriv.set( this, "__className__", className );
				}

				// If the element has a class name or if we're passed `false`,
				// then remove the whole classname (if there was one, the above saved it).
				// Otherwise bring back whatever was previously saved (if anything),
				// falling back to the empty string if nothing was stored.
				if ( this.setAttribute ) {
					this.setAttribute( "class",
						className || value === false ?
							"" :
							dataPriv.get( this, "__className__" ) || ""
					);
				}
			}
		} );
	},

	hasClass: function( selector ) {
		var className, elem,
			i = 0;

		className = " " + selector + " ";
		while ( ( elem = this[ i++ ] ) ) {
			if ( elem.nodeType === 1 &&
				( " " + stripAndCollapse( getClass( elem ) ) + " " ).indexOf( className ) > -1 ) {
				return true;
			}
		}

		return false;
	}
} );




var rreturn = /\r/g;

jQuery.fn.extend( {
	val: function( value ) {
		var hooks, ret, valueIsFunction,
			elem = this[ 0 ];

		if ( !arguments.length ) {
			if ( elem ) {
				hooks = jQuery.valHooks[ elem.type ] ||
					jQuery.valHooks[ elem.nodeName.toLowerCase() ];

				if ( hooks &&
					"get" in hooks &&
					( ret = hooks.get( elem, "value" ) ) !== undefined
				) {
					return ret;
				}

				ret = elem.value;

				// Handle most common string cases
				if ( typeof ret === "string" ) {
					return ret.replace( rreturn, "" );
				}

				// Handle cases where value is null/undef or number
				return ret == null ? "" : ret;
			}

			return;
		}

		valueIsFunction = isFunction( value );

		return this.each( function( i ) {
			var val;

			if ( this.nodeType !== 1 ) {
				return;
			}

			if ( valueIsFunction ) {
				val = value.call( this, i, jQuery( this ).val() );
			} else {
				val = value;
			}

			// Treat null/undefined as ""; convert numbers to string
			if ( val == null ) {
				val = "";

			} else if ( typeof val === "number" ) {
				val += "";

			} else if ( Array.isArray( val ) ) {
				val = jQuery.map( val, function( value ) {
					return value == null ? "" : value + "";
				} );
			}

			hooks = jQuery.valHooks[ this.type ] || jQuery.valHooks[ this.nodeName.toLowerCase() ];

			// If set returns undefined, fall back to normal setting
			if ( !hooks || !( "set" in hooks ) || hooks.set( this, val, "value" ) === undefined ) {
				this.value = val;
			}
		} );
	}
} );

jQuery.extend( {
	valHooks: {
		option: {
			get: function( elem ) {

				var val = jQuery.find.attr( elem, "value" );
				return val != null ?
					val :

					// Support: IE <=10 - 11 only
					// option.text throws exceptions (trac-14686, trac-14858)
					// Strip and collapse whitespace
					// https://html.spec.whatwg.org/#strip-and-collapse-whitespace
					stripAndCollapse( jQuery.text( elem ) );
			}
		},
		select: {
			get: function( elem ) {
				var value, option, i,
					options = elem.options,
					index = elem.selectedIndex,
					one = elem.type === "select-one",
					values = one ? null : [],
					max = one ? index + 1 : options.length;

				if ( index < 0 ) {
					i = max;

				} else {
					i = one ? index : 0;
				}

				// Loop through all the selected options
				for ( ; i < max; i++ ) {
					option = options[ i ];

					// Support: IE <=9 only
					// IE8-9 doesn't update selected after form reset (trac-2551)
					if ( ( option.selected || i === index ) &&

							// Don't return options that are disabled or in a disabled optgroup
							!option.disabled &&
							( !option.parentNode.disabled ||
								!nodeName( option.parentNode, "optgroup" ) ) ) {

						// Get the specific value for the option
						value = jQuery( option ).val();

						// We don't need an array for one selects
						if ( one ) {
							return value;
						}

						// Multi-Selects return an array
						values.push( value );
					}
				}

				return values;
			},

			set: function( elem, value ) {
				var optionSet, option,
					options = elem.options,
					values = jQuery.makeArray( value ),
					i = options.length;

				while ( i-- ) {
					option = options[ i ];

					/* eslint-disable no-cond-assign */

					if ( option.selected =
						jQuery.inArray( jQuery.valHooks.option.get( option ), values ) > -1
					) {
						optionSet = true;
					}

					/* eslint-enable no-cond-assign */
				}

				// Force browsers to behave consistently when non-matching value is set
				if ( !optionSet ) {
					elem.selectedIndex = -1;
				}
				return values;
			}
		}
	}
} );

// Radios and checkboxes getter/setter
jQuery.each( [ "radio", "checkbox" ], function() {
	jQuery.valHooks[ this ] = {
		set: function( elem, value ) {
			if ( Array.isArray( value ) ) {
				return ( elem.checked = jQuery.inArray( jQuery( elem ).val(), value ) > -1 );
			}
		}
	};
	if ( !support.checkOn ) {
		jQuery.valHooks[ this ].get = function( elem ) {
			return elem.getAttribute( "value" ) === null ? "on" : elem.value;
		};
	}
} );




// Return jQuery for attributes-only inclusion
var location = window.location;

var nonce = { guid: Date.now() };

var rquery = ( /\?/ );



// Cross-browser xml parsing
jQuery.parseXML = function( data ) {
	var xml, parserErrorElem;
	if ( !data || typeof data !== "string" ) {
		return null;
	}

	// Support: IE 9 - 11 only
	// IE throws on parseFromString with invalid input.
	try {
		xml = ( new window.DOMParser() ).parseFromString( data, "text/xml" );
	} catch ( e ) {}

	parserErrorElem = xml && xml.getElementsByTagName( "parsererror" )[ 0 ];
	if ( !xml || parserErrorElem ) {
		jQuery.error( "Invalid XML: " + (
			parserErrorElem ?
				jQuery.map( parserErrorElem.childNodes, function( el ) {
					return el.textContent;
				} ).join( "\n" ) :
				data
		) );
	}
	return xml;
};


var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
	stopPropagationCallback = function( e ) {
		e.stopPropagation();
	};

jQuery.extend( jQuery.event, {

	trigger: function( event, data, elem, onlyHandlers ) {

		var i, cur, tmp, bubbleType, ontype, handle, special, lastElement,
			eventPath = [ elem || document ],
			type = hasOwn.call( event, "type" ) ? event.type : event,
			namespaces = hasOwn.call( event, "namespace" ) ? event.namespace.split( "." ) : [];

		cur = lastElement = tmp = elem = elem || document;

		// Don't do events on text and comment nodes
		if ( elem.nodeType === 3 || elem.nodeType === 8 ) {
			return;
		}

		// focus/blur morphs to focusin/out; ensure we're not firing them right now
		if ( rfocusMorph.test( type + jQuery.event.triggered ) ) {
			return;
		}

		if ( type.indexOf( "." ) > -1 ) {

			// Namespaced trigger; create a regexp to match event type in handle()
			namespaces = type.split( "." );
			type = namespaces.shift();
			namespaces.sort();
		}
		ontype = type.indexOf( ":" ) < 0 && "on" + type;

		// Caller can pass in a jQuery.Event object, Object, or just an event type string
		event = event[ jQuery.expando ] ?
			event :
			new jQuery.Event( type, typeof event === "object" && event );

		// Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
		event.isTrigger = onlyHandlers ? 2 : 3;
		event.namespace = namespaces.join( "." );
		event.rnamespace = event.namespace ?
			new RegExp( "(^|\\.)" + namespaces.join( "\\.(?:.*\\.|)" ) + "(\\.|$)" ) :
			null;

		// Clean up the event in case it is being reused
		event.result = undefined;
		if ( !event.target ) {
			event.target = elem;
		}

		// Clone any incoming data and prepend the event, creating the handler arg list
		data = data == null ?
			[ event ] :
			jQuery.makeArray( data, [ event ] );

		// Allow special events to draw outside the lines
		special = jQuery.event.special[ type ] || {};
		if ( !onlyHandlers && special.trigger && special.trigger.apply( elem, data ) === false ) {
			return;
		}

		// Determine event propagation path in advance, per W3C events spec (trac-9951)
		// Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
		if ( !onlyHandlers && !special.noBubble && !isWindow( elem ) ) {

			bubbleType = special.delegateType || type;
			if ( !rfocusMorph.test( bubbleType + type ) ) {
				cur = cur.parentNode;
			}
			for ( ; cur; cur = cur.parentNode ) {
				eventPath.push( cur );
				tmp = cur;
			}

			// Only add window if we got to document (e.g., not plain obj or detached DOM)
			if ( tmp === ( elem.ownerDocument || document ) ) {
				eventPath.push( tmp.defaultView || tmp.parentWindow || window );
			}
		}

		// Fire handlers on the event path
		i = 0;
		while ( ( cur = eventPath[ i++ ] ) && !event.isPropagationStopped() ) {
			lastElement = cur;
			event.type = i > 1 ?
				bubbleType :
				special.bindType || type;

			// jQuery handler
			handle = ( dataPriv.get( cur, "events" ) || Object.create( null ) )[ event.type ] &&
				dataPriv.get( cur, "handle" );
			if ( handle ) {
				handle.apply( cur, data );
			}

			// Native handler
			handle = ontype && cur[ ontype ];
			if ( handle && handle.apply && acceptData( cur ) ) {
				event.result = handle.apply( cur, data );
				if ( event.result === false ) {
					event.preventDefault();
				}
			}
		}
		event.type = type;

		// If nobody prevented the default action, do it now
		if ( !onlyHandlers && !event.isDefaultPrevented() ) {

			if ( ( !special._default ||
				special._default.apply( eventPath.pop(), data ) === false ) &&
				acceptData( elem ) ) {

				// Call a native DOM method on the target with the same name as the event.
				// Don't do default actions on window, that's where global variables be (trac-6170)
				if ( ontype && isFunction( elem[ type ] ) && !isWindow( elem ) ) {

					// Don't re-trigger an onFOO event when we call its FOO() method
					tmp = elem[ ontype ];

					if ( tmp ) {
						elem[ ontype ] = null;
					}

					// Prevent re-triggering of the same event, since we already bubbled it above
					jQuery.event.triggered = type;

					if ( event.isPropagationStopped() ) {
						lastElement.addEventListener( type, stopPropagationCallback );
					}

					elem[ type ]();

					if ( event.isPropagationStopped() ) {
						lastElement.removeEventListener( type, stopPropagationCallback );
					}

					jQuery.event.triggered = undefined;

					if ( tmp ) {
						elem[ ontype ] = tmp;
					}
				}
			}
		}

		return event.result;
	},

	// Piggyback on a donor event to simulate a different one
	// Used only for `focus(in | out)` events
	simulate: function( type, elem, event ) {
		var e = jQuery.extend(
			new jQuery.Event(),
			event,
			{
				type: type,
				isSimulated: true
			}
		);

		jQuery.event.trigger( e, null, elem );
	}

} );

jQuery.fn.extend( {

	trigger: function( type, data ) {
		return this.each( function() {
			jQuery.event.trigger( type, data, this );
		} );
	},
	triggerHandler: function( type, data ) {
		var elem = this[ 0 ];
		if ( elem ) {
			return jQuery.event.trigger( type, data, elem, true );
		}
	}
} );


var
	rbracket = /\[\]$/,
	rCRLF = /\r?\n/g,
	rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
	rsubmittable = /^(?:input|select|textarea|keygen)/i;

function buildParams( prefix, obj, traditional, add ) {
	var name;

	if ( Array.isArray( obj ) ) {

		// Serialize array item.
		jQuery.each( obj, function( i, v ) {
			if ( traditional || rbracket.test( prefix ) ) {

				// Treat each array item as a scalar.
				add( prefix, v );

			} else {

				// Item is non-scalar (array or object), encode its numeric index.
				buildParams(
					prefix + "[" + ( typeof v === "object" && v != null ? i : "" ) + "]",
					v,
					traditional,
					add
				);
			}
		} );

	} else if ( !traditional && toType( obj ) === "object" ) {

		// Serialize object item.
		for ( name in obj ) {
			buildParams( prefix + "[" + name + "]", obj[ name ], traditional, add );
		}

	} else {

		// Serialize scalar item.
		add( prefix, obj );
	}
}

// Serialize an array of form elements or a set of
// key/values into a query string
jQuery.param = function( a, traditional ) {
	var prefix,
		s = [],
		add = function( key, valueOrFunction ) {

			// If value is a function, invoke it and use its return value
			var value = isFunction( valueOrFunction ) ?
				valueOrFunction() :
				valueOrFunction;

			s[ s.length ] = encodeURIComponent( key ) + "=" +
				encodeURIComponent( value == null ? "" : value );
		};

	if ( a == null ) {
		return "";
	}

	// If an array was passed in, assume that it is an array of form elements.
	if ( Array.isArray( a ) || ( a.jquery && !jQuery.isPlainObject( a ) ) ) {

		// Serialize the form elements
		jQuery.each( a, function() {
			add( this.name, this.value );
		} );

	} else {

		// If traditional, encode the "old" way (the way 1.3.2 or older
		// did it), otherwise encode params recursively.
		for ( prefix in a ) {
			buildParams( prefix, a[ prefix ], traditional, add );
		}
	}

	// Return the resulting serialization
	return s.join( "&" );
};

jQuery.fn.extend( {
	serialize: function() {
		return jQuery.param( this.serializeArray() );
	},
	serializeArray: function() {
		return this.map( function() {

			// Can add propHook for "elements" to filter or add form elements
			var elements = jQuery.prop( this, "elements" );
			return elements ? jQuery.makeArray( elements ) : this;
		} ).filter( function() {
			var type = this.type;

			// Use .is( ":disabled" ) so that fieldset[disabled] works
			return this.name && !jQuery( this ).is( ":disabled" ) &&
				rsubmittable.test( this.nodeName ) && !rsubmitterTypes.test( type ) &&
				( this.checked || !rcheckableType.test( type ) );
		} ).map( function( _i, elem ) {
			var val = jQuery( this ).val();

			if ( val == null ) {
				return null;
			}

			if ( Array.isArray( val ) ) {
				return jQuery.map( val, function( val ) {
					return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
				} );
			}

			return { name: elem.name, value: val.replace( rCRLF, "\r\n" ) };
		} ).get();
	}
} );


var
	r20 = /%20/g,
	rhash = /#.*$/,
	rantiCache = /([?&])_=[^&]*/,
	rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,

	// trac-7653, trac-8125, trac-8152: local protocol detection
	rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
	rnoContent = /^(?:GET|HEAD)$/,
	rprotocol = /^\/\//,

	/* Prefilters
	 * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
	 * 2) These are called:
	 *    - BEFORE asking for a transport
	 *    - AFTER param serialization (s.data is a string if s.processData is true)
	 * 3) key is the dataType
	 * 4) the catchall symbol "*" can be used
	 * 5) execution will start with transport dataType and THEN continue down to "*" if needed
	 */
	prefilters = {},

	/* Transports bindings
	 * 1) key is the dataType
	 * 2) the catchall symbol "*" can be used
	 * 3) selection will start with transport dataType and THEN go to "*" if needed
	 */
	transports = {},

	// Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
	allTypes = "*/".concat( "*" ),

	// Anchor tag for parsing the document origin
	originAnchor = document.createElement( "a" );

originAnchor.href = location.href;

// Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
function addToPrefiltersOrTransports( structure ) {

	// dataTypeExpression is optional and defaults to "*"
	return function( dataTypeExpression, func ) {

		if ( typeof dataTypeExpression !== "string" ) {
			func = dataTypeExpression;
			dataTypeExpression = "*";
		}

		var dataType,
			i = 0,
			dataTypes = dataTypeExpression.toLowerCase().match( rnothtmlwhite ) || [];

		if ( isFunction( func ) ) {

			// For each dataType in the dataTypeExpression
			while ( ( dataType = dataTypes[ i++ ] ) ) {

				// Prepend if requested
				if ( dataType[ 0 ] === "+" ) {
					dataType = dataType.slice( 1 ) || "*";
					( structure[ dataType ] = structure[ dataType ] || [] ).unshift( func );

				// Otherwise append
				} else {
					( structure[ dataType ] = structure[ dataType ] || [] ).push( func );
				}
			}
		}
	};
}

// Base inspection function for prefilters and transports
function inspectPrefiltersOrTransports( structure, options, originalOptions, jqXHR ) {

	var inspected = {},
		seekingTransport = ( structure === transports );

	function inspect( dataType ) {
		var selected;
		inspected[ dataType ] = true;
		jQuery.each( structure[ dataType ] || [], function( _, prefilterOrFactory ) {
			var dataTypeOrTransport = prefilterOrFactory( options, originalOptions, jqXHR );
			if ( typeof dataTypeOrTransport === "string" &&
				!seekingTransport && !inspected[ dataTypeOrTransport ] ) {

				options.dataTypes.unshift( dataTypeOrTransport );
				inspect( dataTypeOrTransport );
				return false;
			} else if ( seekingTransport ) {
				return !( selected = dataTypeOrTransport );
			}
		} );
		return selected;
	}

	return inspect( options.dataTypes[ 0 ] ) || !inspected[ "*" ] && inspect( "*" );
}

// A special extend for ajax options
// that takes "flat" options (not to be deep extended)
// Fixes trac-9887
function ajaxExtend( target, src ) {
	var key, deep,
		flatOptions = jQuery.ajaxSettings.flatOptions || {};

	for ( key in src ) {
		if ( src[ key ] !== undefined ) {
			( flatOptions[ key ] ? target : ( deep || ( deep = {} ) ) )[ key ] = src[ key ];
		}
	}
	if ( deep ) {
		jQuery.extend( true, target, deep );
	}

	return target;
}

/* Handles responses to an ajax request:
 * - finds the right dataType (mediates between content-type and expected dataType)
 * - returns the corresponding response
 */
function ajaxHandleResponses( s, jqXHR, responses ) {

	var ct, type, finalDataType, firstDataType,
		contents = s.contents,
		dataTypes = s.dataTypes;

	// Remove auto dataType and get content-type in the process
	while ( dataTypes[ 0 ] === "*" ) {
		dataTypes.shift();
		if ( ct === undefined ) {
			ct = s.mimeType || jqXHR.getResponseHeader( "Content-Type" );
		}
	}

	// Check if we're dealing with a known content-type
	if ( ct ) {
		for ( type in contents ) {
			if ( contents[ type ] && contents[ type ].test( ct ) ) {
				dataTypes.unshift( type );
				break;
			}
		}
	}

	// Check to see if we have a response for the expected dataType
	if ( dataTypes[ 0 ] in responses ) {
		finalDataType = dataTypes[ 0 ];
	} else {

		// Try convertible dataTypes
		for ( type in responses ) {
			if ( !dataTypes[ 0 ] || s.converters[ type + " " + dataTypes[ 0 ] ] ) {
				finalDataType = type;
				break;
			}
			if ( !firstDataType ) {
				firstDataType = type;
			}
		}

		// Or just use first one
		finalDataType = finalDataType || firstDataType;
	}

	// If we found a dataType
	// We add the dataType to the list if needed
	// and return the corresponding response
	if ( finalDataType ) {
		if ( finalDataType !== dataTypes[ 0 ] ) {
			dataTypes.unshift( finalDataType );
		}
		return responses[ finalDataType ];
	}
}

/* Chain conversions given the request and the original response
 * Also sets the responseXXX fields on the jqXHR instance
 */
function ajaxConvert( s, response, jqXHR, isSuccess ) {
	var conv2, current, conv, tmp, prev,
		converters = {},

		// Work with a copy of dataTypes in case we need to modify it for conversion
		dataTypes = s.dataTypes.slice();

	// Create converters map with lowercased keys
	if ( dataTypes[ 1 ] ) {
		for ( conv in s.converters ) {
			converters[ conv.toLowerCase() ] = s.converters[ conv ];
		}
	}

	current = dataTypes.shift();

	// Convert to each sequential dataType
	while ( current ) {

		if ( s.responseFields[ current ] ) {
			jqXHR[ s.responseFields[ current ] ] = response;
		}

		// Apply the dataFilter if provided
		if ( !prev && isSuccess && s.dataFilter ) {
			response = s.dataFilter( response, s.dataType );
		}

		prev = current;
		current = dataTypes.shift();

		if ( current ) {

			// There's only work to do if current dataType is non-auto
			if ( current === "*" ) {

				current = prev;

			// Convert response if prev dataType is non-auto and differs from current
			} else if ( prev !== "*" && prev !== current ) {

				// Seek a direct converter
				conv = converters[ prev + " " + current ] || converters[ "* " + current ];

				// If none found, seek a pair
				if ( !conv ) {
					for ( conv2 in converters ) {

						// If conv2 outputs current
						tmp = conv2.split( " " );
						if ( tmp[ 1 ] === current ) {

							// If prev can be converted to accepted input
							conv = converters[ prev + " " + tmp[ 0 ] ] ||
								converters[ "* " + tmp[ 0 ] ];
							if ( conv ) {

								// Condense equivalence converters
								if ( conv === true ) {
									conv = converters[ conv2 ];

								// Otherwise, insert the intermediate dataType
								} else if ( converters[ conv2 ] !== true ) {
									current = tmp[ 0 ];
									dataTypes.unshift( tmp[ 1 ] );
								}
								break;
							}
						}
					}
				}

				// Apply converter (if not an equivalence)
				if ( conv !== true ) {

					// Unless errors are allowed to bubble, catch and return them
					if ( conv && s.throws ) {
						response = conv( response );
					} else {
						try {
							response = conv( response );
						} catch ( e ) {
							return {
								state: "parsererror",
								error: conv ? e : "No conversion from " + prev + " to " + current
							};
						}
					}
				}
			}
		}
	}

	return { state: "success", data: response };
}

jQuery.extend( {

	// Counter for holding the number of active queries
	active: 0,

	// Last-Modified header cache for next request
	lastModified: {},
	etag: {},

	ajaxSettings: {
		url: location.href,
		type: "GET",
		isLocal: rlocalProtocol.test( location.protocol ),
		global: true,
		processData: true,
		async: true,
		contentType: "application/x-www-form-urlencoded; charset=UTF-8",

		/*
		timeout: 0,
		data: null,
		dataType: null,
		username: null,
		password: null,
		cache: null,
		throws: false,
		traditional: false,
		headers: {},
		*/

		accepts: {
			"*": allTypes,
			text: "text/plain",
			html: "text/html",
			xml: "application/xml, text/xml",
			json: "application/json, text/javascript"
		},

		contents: {
			xml: /\bxml\b/,
			html: /\bhtml/,
			json: /\bjson\b/
		},

		responseFields: {
			xml: "responseXML",
			text: "responseText",
			json: "responseJSON"
		},

		// Data converters
		// Keys separate source (or catchall "*") and destination types with a single space
		converters: {

			// Convert anything to text
			"* text": String,

			// Text to html (true = no transformation)
			"text html": true,

			// Evaluate text as a json expression
			"text json": JSON.parse,

			// Parse text as xml
			"text xml": jQuery.parseXML
		},

		// For options that shouldn't be deep extended:
		// you can add your own custom options here if
		// and when you create one that shouldn't be
		// deep extended (see ajaxExtend)
		flatOptions: {
			url: true,
			context: true
		}
	},

	// Creates a full fledged settings object into target
	// with both ajaxSettings and settings fields.
	// If target is omitted, writes into ajaxSettings.
	ajaxSetup: function( target, settings ) {
		return settings ?

			// Building a settings object
			ajaxExtend( ajaxExtend( target, jQuery.ajaxSettings ), settings ) :

			// Extending ajaxSettings
			ajaxExtend( jQuery.ajaxSettings, target );
	},

	ajaxPrefilter: addToPrefiltersOrTransports( prefilters ),
	ajaxTransport: addToPrefiltersOrTransports( transports ),

	// Main method
	ajax: function( url, options ) {

		// If url is an object, simulate pre-1.5 signature
		if ( typeof url === "object" ) {
			options = url;
			url = undefined;
		}

		// Force options to be an object
		options = options || {};

		var transport,

			// URL without anti-cache param
			cacheURL,

			// Response headers
			responseHeadersString,
			responseHeaders,

			// timeout handle
			timeoutTimer,

			// Url cleanup var
			urlAnchor,

			// Request state (becomes false upon send and true upon completion)
			completed,

			// To know if global events are to be dispatched
			fireGlobals,

			// Loop variable
			i,

			// uncached part of the url
			uncached,

			// Create the final options object
			s = jQuery.ajaxSetup( {}, options ),

			// Callbacks context
			callbackContext = s.context || s,

			// Context for global events is callbackContext if it is a DOM node or jQuery collection
			globalEventContext = s.context &&
				( callbackContext.nodeType || callbackContext.jquery ) ?
				jQuery( callbackContext ) :
				jQuery.event,

			// Deferreds
			deferred = jQuery.Deferred(),
			completeDeferred = jQuery.Callbacks( "once memory" ),

			// Status-dependent callbacks
			statusCode = s.statusCode || {},

			// Headers (they are sent all at once)
			requestHeaders = {},
			requestHeadersNames = {},

			// Default abort message
			strAbort = "canceled",

			// Fake xhr
			jqXHR = {
				readyState: 0,

				// Builds headers hashtable if needed
				getResponseHeader: function( key ) {
					var match;
					if ( completed ) {
						if ( !responseHeaders ) {
							responseHeaders = {};
							while ( ( match = rheaders.exec( responseHeadersString ) ) ) {
								responseHeaders[ match[ 1 ].toLowerCase() + " " ] =
									( responseHeaders[ match[ 1 ].toLowerCase() + " " ] || [] )
										.concat( match[ 2 ] );
							}
						}
						match = responseHeaders[ key.toLowerCase() + " " ];
					}
					return match == null ? null : match.join( ", " );
				},

				// Raw string
				getAllResponseHeaders: function() {
					return completed ? responseHeadersString : null;
				},

				// Caches the header
				setRequestHeader: function( name, value ) {
					if ( completed == null ) {
						name = requestHeadersNames[ name.toLowerCase() ] =
							requestHeadersNames[ name.toLowerCase() ] || name;
						requestHeaders[ name ] = value;
					}
					return this;
				},

				// Overrides response content-type header
				overrideMimeType: function( type ) {
					if ( completed == null ) {
						s.mimeType = type;
					}
					return this;
				},

				// Status-dependent callbacks
				statusCode: function( map ) {
					var code;
					if ( map ) {
						if ( completed ) {

							// Execute the appropriate callbacks
							jqXHR.always( map[ jqXHR.status ] );
						} else {

							// Lazy-add the new callbacks in a way that preserves old ones
							for ( code in map ) {
								statusCode[ code ] = [ statusCode[ code ], map[ code ] ];
							}
						}
					}
					return this;
				},

				// Cancel the request
				abort: function( statusText ) {
					var finalText = statusText || strAbort;
					if ( transport ) {
						transport.abort( finalText );
					}
					done( 0, finalText );
					return this;
				}
			};

		// Attach deferreds
		deferred.promise( jqXHR );

		// Add protocol if not provided (prefilters might expect it)
		// Handle falsy url in the settings object (trac-10093: consistency with old signature)
		// We also use the url parameter if available
		s.url = ( ( url || s.url || location.href ) + "" )
			.replace( rprotocol, location.protocol + "//" );

		// Alias method option to type as per ticket trac-12004
		s.type = options.method || options.type || s.method || s.type;

		// Extract dataTypes list
		s.dataTypes = ( s.dataType || "*" ).toLowerCase().match( rnothtmlwhite ) || [ "" ];

		// A cross-domain request is in order when the origin doesn't match the current origin.
		if ( s.crossDomain == null ) {
			urlAnchor = document.createElement( "a" );

			// Support: IE <=8 - 11, Edge 12 - 15
			// IE throws exception on accessing the href property if url is malformed,
			// e.g. http://example.com:80x/
			try {
				urlAnchor.href = s.url;

				// Support: IE <=8 - 11 only
				// Anchor's host property isn't correctly set when s.url is relative
				urlAnchor.href = urlAnchor.href;
				s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !==
					urlAnchor.protocol + "//" + urlAnchor.host;
			} catch ( e ) {

				// If there is an error parsing the URL, assume it is crossDomain,
				// it can be rejected by the transport if it is invalid
				s.crossDomain = true;
			}
		}

		// Convert data if not already a string
		if ( s.data && s.processData && typeof s.data !== "string" ) {
			s.data = jQuery.param( s.data, s.traditional );
		}

		// Apply prefilters
		inspectPrefiltersOrTransports( prefilters, s, options, jqXHR );

		// If request was aborted inside a prefilter, stop there
		if ( completed ) {
			return jqXHR;
		}

		// We can fire global events as of now if asked to
		// Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
		fireGlobals = jQuery.event && s.global;

		// Watch for a new set of requests
		if ( fireGlobals && jQuery.active++ === 0 ) {
			jQuery.event.trigger( "ajaxStart" );
		}

		// Uppercase the type
		s.type = s.type.toUpperCase();

		// Determine if request has content
		s.hasContent = !rnoContent.test( s.type );

		// Save the URL in case we're toying with the If-Modified-Since
		// and/or If-None-Match header later on
		// Remove hash to simplify url manipulation
		cacheURL = s.url.replace( rhash, "" );

		// More options handling for requests with no content
		if ( !s.hasContent ) {

			// Remember the hash so we can put it back
			uncached = s.url.slice( cacheURL.length );

			// If data is available and should be processed, append data to url
			if ( s.data && ( s.processData || typeof s.data === "string" ) ) {
				cacheURL += ( rquery.test( cacheURL ) ? "&" : "?" ) + s.data;

				// trac-9682: remove data so that it's not used in an eventual retry
				delete s.data;
			}

			// Add or update anti-cache param if needed
			if ( s.cache === false ) {
				cacheURL = cacheURL.replace( rantiCache, "$1" );
				uncached = ( rquery.test( cacheURL ) ? "&" : "?" ) + "_=" + ( nonce.guid++ ) +
					uncached;
			}

			// Put hash and anti-cache on the URL that will be requested (gh-1732)
			s.url = cacheURL + uncached;

		// Change '%20' to '+' if this is encoded form body content (gh-2658)
		} else if ( s.data && s.processData &&
			( s.contentType || "" ).indexOf( "application/x-www-form-urlencoded" ) === 0 ) {
			s.data = s.data.replace( r20, "+" );
		}

		// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
		if ( s.ifModified ) {
			if ( jQuery.lastModified[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-Modified-Since", jQuery.lastModified[ cacheURL ] );
			}
			if ( jQuery.etag[ cacheURL ] ) {
				jqXHR.setRequestHeader( "If-None-Match", jQuery.etag[ cacheURL ] );
			}
		}

		// Set the correct header, if data is being sent
		if ( s.data && s.hasContent && s.contentType !== false || options.contentType ) {
			jqXHR.setRequestHeader( "Content-Type", s.contentType );
		}

		// Set the Accepts header for the server, depending on the dataType
		jqXHR.setRequestHeader(
			"Accept",
			s.dataTypes[ 0 ] && s.accepts[ s.dataTypes[ 0 ] ] ?
				s.accepts[ s.dataTypes[ 0 ] ] +
					( s.dataTypes[ 0 ] !== "*" ? ", " + allTypes + "; q=0.01" : "" ) :
				s.accepts[ "*" ]
		);

		// Check for headers option
		for ( i in s.headers ) {
			jqXHR.setRequestHeader( i, s.headers[ i ] );
		}

		// Allow custom headers/mimetypes and early abort
		if ( s.beforeSend &&
			( s.beforeSend.call( callbackContext, jqXHR, s ) === false || completed ) ) {

			// Abort if not done already and return
			return jqXHR.abort();
		}

		// Aborting is no longer a cancellation
		strAbort = "abort";

		// Install callbacks on deferreds
		completeDeferred.add( s.complete );
		jqXHR.done( s.success );
		jqXHR.fail( s.error );

		// Get transport
		transport = inspectPrefiltersOrTransports( transports, s, options, jqXHR );

		// If no transport, we auto-abort
		if ( !transport ) {
			done( -1, "No Transport" );
		} else {
			jqXHR.readyState = 1;

			// Send global event
			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxSend", [ jqXHR, s ] );
			}

			// If request was aborted inside ajaxSend, stop there
			if ( completed ) {
				return jqXHR;
			}

			// Timeout
			if ( s.async && s.timeout > 0 ) {
				timeoutTimer = window.setTimeout( function() {
					jqXHR.abort( "timeout" );
				}, s.timeout );
			}

			try {
				completed = false;
				transport.send( requestHeaders, done );
			} catch ( e ) {

				// Rethrow post-completion exceptions
				if ( completed ) {
					throw e;
				}

				// Propagate others as results
				done( -1, e );
			}
		}

		// Callback for when everything is done
		function done( status, nativeStatusText, responses, headers ) {
			var isSuccess, success, error, response, modified,
				statusText = nativeStatusText;

			// Ignore repeat invocations
			if ( completed ) {
				return;
			}

			completed = true;

			// Clear timeout if it exists
			if ( timeoutTimer ) {
				window.clearTimeout( timeoutTimer );
			}

			// Dereference transport for early garbage collection
			// (no matter how long the jqXHR object will be used)
			transport = undefined;

			// Cache response headers
			responseHeadersString = headers || "";

			// Set readyState
			jqXHR.readyState = status > 0 ? 4 : 0;

			// Determine if successful
			isSuccess = status >= 200 && status < 300 || status === 304;

			// Get response data
			if ( responses ) {
				response = ajaxHandleResponses( s, jqXHR, responses );
			}

			// Use a noop converter for missing script but not if jsonp
			if ( !isSuccess &&
				jQuery.inArray( "script", s.dataTypes ) > -1 &&
				jQuery.inArray( "json", s.dataTypes ) < 0 ) {
				s.converters[ "text script" ] = function() {};
			}

			// Convert no matter what (that way responseXXX fields are always set)
			response = ajaxConvert( s, response, jqXHR, isSuccess );

			// If successful, handle type chaining
			if ( isSuccess ) {

				// Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
				if ( s.ifModified ) {
					modified = jqXHR.getResponseHeader( "Last-Modified" );
					if ( modified ) {
						jQuery.lastModified[ cacheURL ] = modified;
					}
					modified = jqXHR.getResponseHeader( "etag" );
					if ( modified ) {
						jQuery.etag[ cacheURL ] = modified;
					}
				}

				// if no content
				if ( status === 204 || s.type === "HEAD" ) {
					statusText = "nocontent";

				// if not modified
				} else if ( status === 304 ) {
					statusText = "notmodified";

				// If we have data, let's convert it
				} else {
					statusText = response.state;
					success = response.data;
					error = response.error;
					isSuccess = !error;
				}
			} else {

				// Extract error from statusText and normalize for non-aborts
				error = statusText;
				if ( status || !statusText ) {
					statusText = "error";
					if ( status < 0 ) {
						status = 0;
					}
				}
			}

			// Set data for the fake xhr object
			jqXHR.status = status;
			jqXHR.statusText = ( nativeStatusText || statusText ) + "";

			// Success/Error
			if ( isSuccess ) {
				deferred.resolveWith( callbackContext, [ success, statusText, jqXHR ] );
			} else {
				deferred.rejectWith( callbackContext, [ jqXHR, statusText, error ] );
			}

			// Status-dependent callbacks
			jqXHR.statusCode( statusCode );
			statusCode = undefined;

			if ( fireGlobals ) {
				globalEventContext.trigger( isSuccess ? "ajaxSuccess" : "ajaxError",
					[ jqXHR, s, isSuccess ? success : error ] );
			}

			// Complete
			completeDeferred.fireWith( callbackContext, [ jqXHR, statusText ] );

			if ( fireGlobals ) {
				globalEventContext.trigger( "ajaxComplete", [ jqXHR, s ] );

				// Handle the global AJAX counter
				if ( !( --jQuery.active ) ) {
					jQuery.event.trigger( "ajaxStop" );
				}
			}
		}

		return jqXHR;
	},

	getJSON: function( url, data, callback ) {
		return jQuery.get( url, data, callback, "json" );
	},

	getScript: function( url, callback ) {
		return jQuery.get( url, undefined, callback, "script" );
	}
} );

jQuery.each( [ "get", "post" ], function( _i, method ) {
	jQuery[ method ] = function( url, data, callback, type ) {

		// Shift arguments if data argument was omitted
		if ( isFunction( data ) ) {
			type = type || callback;
			callback = data;
			data = undefined;
		}

		// The url can be an options object (which then must have .url)
		return jQuery.ajax( jQuery.extend( {
			url: url,
			type: method,
			dataType: type,
			data: data,
			success: callback
		}, jQuery.isPlainObject( url ) && url ) );
	};
} );

jQuery.ajaxPrefilter( function( s ) {
	var i;
	for ( i in s.headers ) {
		if ( i.toLowerCase() === "content-type" ) {
			s.contentType = s.headers[ i ] || "";
		}
	}
} );


jQuery._evalUrl = function( url, options, doc ) {
	return jQuery.ajax( {
		url: url,

		// Make this explicit, since user can override this through ajaxSetup (trac-11264)
		type: "GET",
		dataType: "script",
		cache: true,
		async: false,
		global: false,

		// Only evaluate the response if it is successful (gh-4126)
		// dataFilter is not invoked for failure responses, so using it instead
		// of the default converter is kludgy but it works.
		converters: {
			"text script": function() {}
		},
		dataFilter: function( response ) {
			jQuery.globalEval( response, options, doc );
		}
	} );
};


jQuery.fn.extend( {
	wrapAll: function( html ) {
		var wrap;

		if ( this[ 0 ] ) {
			if ( isFunction( html ) ) {
				html = html.call( this[ 0 ] );
			}

			// The elements to wrap the target around
			wrap = jQuery( html, this[ 0 ].ownerDocument ).eq( 0 ).clone( true );

			if ( this[ 0 ].parentNode ) {
				wrap.insertBefore( this[ 0 ] );
			}

			wrap.map( function() {
				var elem = this;

				while ( elem.firstElementChild ) {
					elem = elem.firstElementChild;
				}

				return elem;
			} ).append( this );
		}

		return this;
	},

	wrapInner: function( html ) {
		if ( isFunction( html ) ) {
			return this.each( function( i ) {
				jQuery( this ).wrapInner( html.call( this, i ) );
			} );
		}

		return this.each( function() {
			var self = jQuery( this ),
				contents = self.contents();

			if ( contents.length ) {
				contents.wrapAll( html );

			} else {
				self.append( html );
			}
		} );
	},

	wrap: function( html ) {
		var htmlIsFunction = isFunction( html );

		return this.each( function( i ) {
			jQuery( this ).wrapAll( htmlIsFunction ? html.call( this, i ) : html );
		} );
	},

	unwrap: function( selector ) {
		this.parent( selector ).not( "body" ).each( function() {
			jQuery( this ).replaceWith( this.childNodes );
		} );
		return this;
	}
} );


jQuery.expr.pseudos.hidden = function( elem ) {
	return !jQuery.expr.pseudos.visible( elem );
};
jQuery.expr.pseudos.visible = function( elem ) {
	return !!( elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length );
};




jQuery.ajaxSettings.xhr = function() {
	try {
		return new window.XMLHttpRequest();
	} catch ( e ) {}
};

var xhrSuccessStatus = {

		// File protocol always yields status code 0, assume 200
		0: 200,

		// Support: IE <=9 only
		// trac-1450: sometimes IE returns 1223 when it should be 204
		1223: 204
	},
	xhrSupported = jQuery.ajaxSettings.xhr();

support.cors = !!xhrSupported && ( "withCredentials" in xhrSupported );
support.ajax = xhrSupported = !!xhrSupported;

jQuery.ajaxTransport( function( options ) {
	var callback, errorCallback;

	// Cross domain only allowed if supported through XMLHttpRequest
	if ( support.cors || xhrSupported && !options.crossDomain ) {
		return {
			send: function( headers, complete ) {
				var i,
					xhr = options.xhr();

				xhr.open(
					options.type,
					options.url,
					options.async,
					options.username,
					options.password
				);

				// Apply custom fields if provided
				if ( options.xhrFields ) {
					for ( i in options.xhrFields ) {
						xhr[ i ] = options.xhrFields[ i ];
					}
				}

				// Override mime type if needed
				if ( options.mimeType && xhr.overrideMimeType ) {
					xhr.overrideMimeType( options.mimeType );
				}

				// X-Requested-With header
				// For cross-domain requests, seeing as conditions for a preflight are
				// akin to a jigsaw puzzle, we simply never set it to be sure.
				// (it can always be set on a per-request basis or even using ajaxSetup)
				// For same-domain requests, won't change header if already provided.
				if ( !options.crossDomain && !headers[ "X-Requested-With" ] ) {
					headers[ "X-Requested-With" ] = "XMLHttpRequest";
				}

				// Set headers
				for ( i in headers ) {
					xhr.setRequestHeader( i, headers[ i ] );
				}

				// Callback
				callback = function( type ) {
					return function() {
						if ( callback ) {
							callback = errorCallback = xhr.onload =
								xhr.onerror = xhr.onabort = xhr.ontimeout =
									xhr.onreadystatechange = null;

							if ( type === "abort" ) {
								xhr.abort();
							} else if ( type === "error" ) {

								// Support: IE <=9 only
								// On a manual native abort, IE9 throws
								// errors on any property access that is not readyState
								if ( typeof xhr.status !== "number" ) {
									complete( 0, "error" );
								} else {
									complete(

										// File: protocol always yields status 0; see trac-8605, trac-14207
										xhr.status,
										xhr.statusText
									);
								}
							} else {
								complete(
									xhrSuccessStatus[ xhr.status ] || xhr.status,
									xhr.statusText,

									// Support: IE <=9 only
									// IE9 has no XHR2 but throws on binary (trac-11426)
									// For XHR2 non-text, let the caller handle it (gh-2498)
									( xhr.responseType || "text" ) !== "text"  ||
									typeof xhr.responseText !== "string" ?
										{ binary: xhr.response } :
										{ text: xhr.responseText },
									xhr.getAllResponseHeaders()
								);
							}
						}
					};
				};

				// Listen to events
				xhr.onload = callback();
				errorCallback = xhr.onerror = xhr.ontimeout = callback( "error" );

				// Support: IE 9 only
				// Use onreadystatechange to replace onabort
				// to handle uncaught aborts
				if ( xhr.onabort !== undefined ) {
					xhr.onabort = errorCallback;
				} else {
					xhr.onreadystatechange = function() {

						// Check readyState before timeout as it changes
						if ( xhr.readyState === 4 ) {

							// Allow onerror to be called first,
							// but that will not handle a native abort
							// Also, save errorCallback to a variable
							// as xhr.onerror cannot be accessed
							window.setTimeout( function() {
								if ( callback ) {
									errorCallback();
								}
							} );
						}
					};
				}

				// Create the abort callback
				callback = callback( "abort" );

				try {

					// Do send the request (this may raise an exception)
					xhr.send( options.hasContent && options.data || null );
				} catch ( e ) {

					// trac-14683: Only rethrow if this hasn't been notified as an error yet
					if ( callback ) {
						throw e;
					}
				}
			},

			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




// Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
jQuery.ajaxPrefilter( function( s ) {
	if ( s.crossDomain ) {
		s.contents.script = false;
	}
} );

// Install script dataType
jQuery.ajaxSetup( {
	accepts: {
		script: "text/javascript, application/javascript, " +
			"application/ecmascript, application/x-ecmascript"
	},
	contents: {
		script: /\b(?:java|ecma)script\b/
	},
	converters: {
		"text script": function( text ) {
			jQuery.globalEval( text );
			return text;
		}
	}
} );

// Handle cache's special case and crossDomain
jQuery.ajaxPrefilter( "script", function( s ) {
	if ( s.cache === undefined ) {
		s.cache = false;
	}
	if ( s.crossDomain ) {
		s.type = "GET";
	}
} );

// Bind script tag hack transport
jQuery.ajaxTransport( "script", function( s ) {

	// This transport only deals with cross domain or forced-by-attrs requests
	if ( s.crossDomain || s.scriptAttrs ) {
		var script, callback;
		return {
			send: function( _, complete ) {
				script = jQuery( "<script>" )
					.attr( s.scriptAttrs || {} )
					.prop( { charset: s.scriptCharset, src: s.url } )
					.on( "load error", callback = function( evt ) {
						script.remove();
						callback = null;
						if ( evt ) {
							complete( evt.type === "error" ? 404 : 200, evt.type );
						}
					} );

				// Use native DOM manipulation to avoid our domManip AJAX trickery
				document.head.appendChild( script[ 0 ] );
			},
			abort: function() {
				if ( callback ) {
					callback();
				}
			}
		};
	}
} );




var oldCallbacks = [],
	rjsonp = /(=)\?(?=&|$)|\?\?/;

// Default jsonp settings
jQuery.ajaxSetup( {
	jsonp: "callback",
	jsonpCallback: function() {
		var callback = oldCallbacks.pop() || ( jQuery.expando + "_" + ( nonce.guid++ ) );
		this[ callback ] = true;
		return callback;
	}
} );

// Detect, normalize options and install callbacks for jsonp requests
jQuery.ajaxPrefilter( "json jsonp", function( s, originalSettings, jqXHR ) {

	var callbackName, overwritten, responseContainer,
		jsonProp = s.jsonp !== false && ( rjsonp.test( s.url ) ?
			"url" :
			typeof s.data === "string" &&
				( s.contentType || "" )
					.indexOf( "application/x-www-form-urlencoded" ) === 0 &&
				rjsonp.test( s.data ) && "data"
		);

	// Handle iff the expected data type is "jsonp" or we have a parameter to set
	if ( jsonProp || s.dataTypes[ 0 ] === "jsonp" ) {

		// Get callback name, remembering preexisting value associated with it
		callbackName = s.jsonpCallback = isFunction( s.jsonpCallback ) ?
			s.jsonpCallback() :
			s.jsonpCallback;

		// Insert callback into url or form data
		if ( jsonProp ) {
			s[ jsonProp ] = s[ jsonProp ].replace( rjsonp, "$1" + callbackName );
		} else if ( s.jsonp !== false ) {
			s.url += ( rquery.test( s.url ) ? "&" : "?" ) + s.jsonp + "=" + callbackName;
		}

		// Use data converter to retrieve json after script execution
		s.converters[ "script json" ] = function() {
			if ( !responseContainer ) {
				jQuery.error( callbackName + " was not called" );
			}
			return responseContainer[ 0 ];
		};

		// Force json dataType
		s.dataTypes[ 0 ] = "json";

		// Install callback
		overwritten = window[ callbackName ];
		window[ callbackName ] = function() {
			responseContainer = arguments;
		};

		// Clean-up function (fires after converters)
		jqXHR.always( function() {

			// If previous value didn't exist - remove it
			if ( overwritten === undefined ) {
				jQuery( window ).removeProp( callbackName );

			// Otherwise restore preexisting value
			} else {
				window[ callbackName ] = overwritten;
			}

			// Save back as free
			if ( s[ callbackName ] ) {

				// Make sure that re-using the options doesn't screw things around
				s.jsonpCallback = originalSettings.jsonpCallback;

				// Save the callback name for future use
				oldCallbacks.push( callbackName );
			}

			// Call if it was a function and we have a response
			if ( responseContainer && isFunction( overwritten ) ) {
				overwritten( responseContainer[ 0 ] );
			}

			responseContainer = overwritten = undefined;
		} );

		// Delegate to script
		return "script";
	}
} );




// Support: Safari 8 only
// In Safari 8 documents created via document.implementation.createHTMLDocument
// collapse sibling forms: the second one becomes a child of the first one.
// Because of that, this security measure has to be disabled in Safari 8.
// https://bugs.webkit.org/show_bug.cgi?id=137337
support.createHTMLDocument = ( function() {
	var body = document.implementation.createHTMLDocument( "" ).body;
	body.innerHTML = "<form></form><form></form>";
	return body.childNodes.length === 2;
} )();


// Argument "data" should be string of html
// context (optional): If specified, the fragment will be created in this context,
// defaults to document
// keepScripts (optional): If true, will include scripts passed in the html string
jQuery.parseHTML = function( data, context, keepScripts ) {
	if ( typeof data !== "string" ) {
		return [];
	}
	if ( typeof context === "boolean" ) {
		keepScripts = context;
		context = false;
	}

	var base, parsed, scripts;

	if ( !context ) {

		// Stop scripts or inline event handlers from being executed immediately
		// by using document.implementation
		if ( support.createHTMLDocument ) {
			context = document.implementation.createHTMLDocument( "" );

			// Set the base href for the created document
			// so any parsed elements with URLs
			// are based on the document's URL (gh-2965)
			base = context.createElement( "base" );
			base.href = document.location.href;
			context.head.appendChild( base );
		} else {
			context = document;
		}
	}

	parsed = rsingleTag.exec( data );
	scripts = !keepScripts && [];

	// Single tag
	if ( parsed ) {
		return [ context.createElement( parsed[ 1 ] ) ];
	}

	parsed = buildFragment( [ data ], context, scripts );

	if ( scripts && scripts.length ) {
		jQuery( scripts ).remove();
	}

	return jQuery.merge( [], parsed.childNodes );
};


/**
 * Load a url into a page
 */
jQuery.fn.load = function( url, params, callback ) {
	var selector, type, response,
		self = this,
		off = url.indexOf( " " );

	if ( off > -1 ) {
		selector = stripAndCollapse( url.slice( off ) );
		url = url.slice( 0, off );
	}

	// If it's a function
	if ( isFunction( params ) ) {

		// We assume that it's the callback
		callback = params;
		params = undefined;

	// Otherwise, build a param string
	} else if ( params && typeof params === "object" ) {
		type = "POST";
	}

	// If we have elements to modify, make the request
	if ( self.length > 0 ) {
		jQuery.ajax( {
			url: url,

			// If "type" variable is undefined, then "GET" method will be used.
			// Make value of this field explicit since
			// user can override it through ajaxSetup method
			type: type || "GET",
			dataType: "html",
			data: params
		} ).done( function( responseText ) {

			// Save response for use in complete callback
			response = arguments;

			self.html( selector ?

				// If a selector was specified, locate the right elements in a dummy div
				// Exclude scripts to avoid IE 'Permission Denied' errors
				jQuery( "<div>" ).append( jQuery.parseHTML( responseText ) ).find( selector ) :

				// Otherwise use the full result
				responseText );

		// If the request succeeds, this function gets "data", "status", "jqXHR"
		// but they are ignored because response was set above.
		// If it fails, this function gets "jqXHR", "status", "error"
		} ).always( callback && function( jqXHR, status ) {
			self.each( function() {
				callback.apply( this, response || [ jqXHR.responseText, status, jqXHR ] );
			} );
		} );
	}

	return this;
};




jQuery.expr.pseudos.animated = function( elem ) {
	return jQuery.grep( jQuery.timers, function( fn ) {
		return elem === fn.elem;
	} ).length;
};




jQuery.offset = {
	setOffset: function( elem, options, i ) {
		var curPosition, curLeft, curCSSTop, curTop, curOffset, curCSSLeft, calculatePosition,
			position = jQuery.css( elem, "position" ),
			curElem = jQuery( elem ),
			props = {};

		// Set position first, in-case top/left are set even on static elem
		if ( position === "static" ) {
			elem.style.position = "relative";
		}

		curOffset = curElem.offset();
		curCSSTop = jQuery.css( elem, "top" );
		curCSSLeft = jQuery.css( elem, "left" );
		calculatePosition = ( position === "absolute" || position === "fixed" ) &&
			( curCSSTop + curCSSLeft ).indexOf( "auto" ) > -1;

		// Need to be able to calculate position if either
		// top or left is auto and position is either absolute or fixed
		if ( calculatePosition ) {
			curPosition = curElem.position();
			curTop = curPosition.top;
			curLeft = curPosition.left;

		} else {
			curTop = parseFloat( curCSSTop ) || 0;
			curLeft = parseFloat( curCSSLeft ) || 0;
		}

		if ( isFunction( options ) ) {

			// Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
			options = options.call( elem, i, jQuery.extend( {}, curOffset ) );
		}

		if ( options.top != null ) {
			props.top = ( options.top - curOffset.top ) + curTop;
		}
		if ( options.left != null ) {
			props.left = ( options.left - curOffset.left ) + curLeft;
		}

		if ( "using" in options ) {
			options.using.call( elem, props );

		} else {
			curElem.css( props );
		}
	}
};

jQuery.fn.extend( {

	// offset() relates an element's border box to the document origin
	offset: function( options ) {

		// Preserve chaining for setter
		if ( arguments.length ) {
			return options === undefined ?
				this :
				this.each( function( i ) {
					jQuery.offset.setOffset( this, options, i );
				} );
		}

		var rect, win,
			elem = this[ 0 ];

		if ( !elem ) {
			return;
		}

		// Return zeros for disconnected and hidden (display: none) elements (gh-2310)
		// Support: IE <=11 only
		// Running getBoundingClientRect on a
		// disconnected node in IE throws an error
		if ( !elem.getClientRects().length ) {
			return { top: 0, left: 0 };
		}

		// Get document-relative position by adding viewport scroll to viewport-relative gBCR
		rect = elem.getBoundingClientRect();
		win = elem.ownerDocument.defaultView;
		return {
			top: rect.top + win.pageYOffset,
			left: rect.left + win.pageXOffset
		};
	},

	// position() relates an element's margin box to its offset parent's padding box
	// This corresponds to the behavior of CSS absolute positioning
	position: function() {
		if ( !this[ 0 ] ) {
			return;
		}

		var offsetParent, offset, doc,
			elem = this[ 0 ],
			parentOffset = { top: 0, left: 0 };

		// position:fixed elements are offset from the viewport, which itself always has zero offset
		if ( jQuery.css( elem, "position" ) === "fixed" ) {

			// Assume position:fixed implies availability of getBoundingClientRect
			offset = elem.getBoundingClientRect();

		} else {
			offset = this.offset();

			// Account for the *real* offset parent, which can be the document or its root element
			// when a statically positioned element is identified
			doc = elem.ownerDocument;
			offsetParent = elem.offsetParent || doc.documentElement;
			while ( offsetParent &&
				( offsetParent === doc.body || offsetParent === doc.documentElement ) &&
				jQuery.css( offsetParent, "position" ) === "static" ) {

				offsetParent = offsetParent.parentNode;
			}
			if ( offsetParent && offsetParent !== elem && offsetParent.nodeType === 1 ) {

				// Incorporate borders into its offset, since they are outside its content origin
				parentOffset = jQuery( offsetParent ).offset();
				parentOffset.top += jQuery.css( offsetParent, "borderTopWidth", true );
				parentOffset.left += jQuery.css( offsetParent, "borderLeftWidth", true );
			}
		}

		// Subtract parent offsets and element margins
		return {
			top: offset.top - parentOffset.top - jQuery.css( elem, "marginTop", true ),
			left: offset.left - parentOffset.left - jQuery.css( elem, "marginLeft", true )
		};
	},

	// This method will return documentElement in the following cases:
	// 1) For the element inside the iframe without offsetParent, this method will return
	//    documentElement of the parent window
	// 2) For the hidden or detached element
	// 3) For body or html element, i.e. in case of the html node - it will return itself
	//
	// but those exceptions were never presented as a real life use-cases
	// and might be considered as more preferable results.
	//
	// This logic, however, is not guaranteed and can change at any point in the future
	offsetParent: function() {
		return this.map( function() {
			var offsetParent = this.offsetParent;

			while ( offsetParent && jQuery.css( offsetParent, "position" ) === "static" ) {
				offsetParent = offsetParent.offsetParent;
			}

			return offsetParent || documentElement;
		} );
	}
} );

// Create scrollLeft and scrollTop methods
jQuery.each( { scrollLeft: "pageXOffset", scrollTop: "pageYOffset" }, function( method, prop ) {
	var top = "pageYOffset" === prop;

	jQuery.fn[ method ] = function( val ) {
		return access( this, function( elem, method, val ) {

			// Coalesce documents and windows
			var win;
			if ( isWindow( elem ) ) {
				win = elem;
			} else if ( elem.nodeType === 9 ) {
				win = elem.defaultView;
			}

			if ( val === undefined ) {
				return win ? win[ prop ] : elem[ method ];
			}

			if ( win ) {
				win.scrollTo(
					!top ? val : win.pageXOffset,
					top ? val : win.pageYOffset
				);

			} else {
				elem[ method ] = val;
			}
		}, method, val, arguments.length );
	};
} );

// Support: Safari <=7 - 9.1, Chrome <=37 - 49
// Add the top/left cssHooks using jQuery.fn.position
// Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
// Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
// getComputedStyle returns percent when specified for top/left/bottom/right;
// rather than make the css module depend on the offset module, just check for it here
jQuery.each( [ "top", "left" ], function( _i, prop ) {
	jQuery.cssHooks[ prop ] = addGetHookIf( support.pixelPosition,
		function( elem, computed ) {
			if ( computed ) {
				computed = curCSS( elem, prop );

				// If curCSS returns percentage, fallback to offset
				return rnumnonpx.test( computed ) ?
					jQuery( elem ).position()[ prop ] + "px" :
					computed;
			}
		}
	);
} );


// Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
jQuery.each( { Height: "height", Width: "width" }, function( name, type ) {
	jQuery.each( {
		padding: "inner" + name,
		content: type,
		"": "outer" + name
	}, function( defaultExtra, funcName ) {

		// Margin is only for outerHeight, outerWidth
		jQuery.fn[ funcName ] = function( margin, value ) {
			var chainable = arguments.length && ( defaultExtra || typeof margin !== "boolean" ),
				extra = defaultExtra || ( margin === true || value === true ? "margin" : "border" );

			return access( this, function( elem, type, value ) {
				var doc;

				if ( isWindow( elem ) ) {

					// $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
					return funcName.indexOf( "outer" ) === 0 ?
						elem[ "inner" + name ] :
						elem.document.documentElement[ "client" + name ];
				}

				// Get document width or height
				if ( elem.nodeType === 9 ) {
					doc = elem.documentElement;

					// Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
					// whichever is greatest
					return Math.max(
						elem.body[ "scroll" + name ], doc[ "scroll" + name ],
						elem.body[ "offset" + name ], doc[ "offset" + name ],
						doc[ "client" + name ]
					);
				}

				return value === undefined ?

					// Get width or height on the element, requesting but not forcing parseFloat
					jQuery.css( elem, type, extra ) :

					// Set width or height on the element
					jQuery.style( elem, type, value, extra );
			}, type, chainable ? margin : undefined, chainable );
		};
	} );
} );


jQuery.each( [
	"ajaxStart",
	"ajaxStop",
	"ajaxComplete",
	"ajaxError",
	"ajaxSuccess",
	"ajaxSend"
], function( _i, type ) {
	jQuery.fn[ type ] = function( fn ) {
		return this.on( type, fn );
	};
} );




jQuery.fn.extend( {

	bind: function( types, data, fn ) {
		return this.on( types, null, data, fn );
	},
	unbind: function( types, fn ) {
		return this.off( types, null, fn );
	},

	delegate: function( selector, types, data, fn ) {
		return this.on( types, selector, data, fn );
	},
	undelegate: function( selector, types, fn ) {

		// ( namespace ) or ( selector, types [, fn] )
		return arguments.length === 1 ?
			this.off( selector, "**" ) :
			this.off( types, selector || "**", fn );
	},

	hover: function( fnOver, fnOut ) {
		return this
			.on( "mouseenter", fnOver )
			.on( "mouseleave", fnOut || fnOver );
	}
} );

jQuery.each(
	( "blur focus focusin focusout resize scroll click dblclick " +
	"mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " +
	"change select submit keydown keypress keyup contextmenu" ).split( " " ),
	function( _i, name ) {

		// Handle event binding
		jQuery.fn[ name ] = function( data, fn ) {
			return arguments.length > 0 ?
				this.on( name, null, data, fn ) :
				this.trigger( name );
		};
	}
);




// Support: Android <=4.0 only
// Make sure we trim BOM and NBSP
// Require that the "whitespace run" starts from a non-whitespace
// to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;

// Bind a function to a context, optionally partially applying any
// arguments.
// jQuery.proxy is deprecated to promote standards (specifically Function#bind)
// However, it is not slated for removal any time soon
jQuery.proxy = function( fn, context ) {
	var tmp, args, proxy;

	if ( typeof context === "string" ) {
		tmp = fn[ context ];
		context = fn;
		fn = tmp;
	}

	// Quick check to determine if target is callable, in the spec
	// this throws a TypeError, but we will just return undefined.
	if ( !isFunction( fn ) ) {
		return undefined;
	}

	// Simulated bind
	args = slice.call( arguments, 2 );
	proxy = function() {
		return fn.apply( context || this, args.concat( slice.call( arguments ) ) );
	};

	// Set the guid of unique handler to the same of original handler, so it can be removed
	proxy.guid = fn.guid = fn.guid || jQuery.guid++;

	return proxy;
};

jQuery.holdReady = function( hold ) {
	if ( hold ) {
		jQuery.readyWait++;
	} else {
		jQuery.ready( true );
	}
};
jQuery.isArray = Array.isArray;
jQuery.parseJSON = JSON.parse;
jQuery.nodeName = nodeName;
jQuery.isFunction = isFunction;
jQuery.isWindow = isWindow;
jQuery.camelCase = camelCase;
jQuery.type = toType;

jQuery.now = Date.now;

jQuery.isNumeric = function( obj ) {

	// As of jQuery 3.0, isNumeric is limited to
	// strings and numbers (primitives or objects)
	// that can be coerced to finite numbers (gh-2662)
	var type = jQuery.type( obj );
	return ( type === "number" || type === "string" ) &&

		// parseFloat NaNs numeric-cast false positives ("")
		// ...but misinterprets leading-number strings, particularly hex literals ("0x...")
		// subtraction forces infinities to NaN
		!isNaN( obj - parseFloat( obj ) );
};

jQuery.trim = function( text ) {
	return text == null ?
		"" :
		( text + "" ).replace( rtrim, "$1" );
};



// Register as a named AMD module, since jQuery can be concatenated with other
// files that may use define, but not via a proper concatenation script that
// understands anonymous AMD modules. A named AMD is safest and most robust
// way to register. Lowercase jquery is used because AMD module names are
// derived from file names, and jQuery is normally delivered in a lowercase
// file name. Do this after creating the global so that if an AMD module wants
// to call noConflict to hide this version of jQuery, it will work.

// Note that for maximum portability, libraries that are not jQuery should
// declare themselves as anonymous modules, and avoid setting a global if an
// AMD loader is present. jQuery is a special case. For more information, see
// https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

if ( true ) {
	!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function() {
		return jQuery;
	}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
}




var

	// Map over jQuery in case of overwrite
	_jQuery = window.jQuery,

	// Map over the $ in case of overwrite
	_$ = window.$;

jQuery.noConflict = function( deep ) {
	if ( window.$ === jQuery ) {
		window.$ = _$;
	}

	if ( deep && window.jQuery === jQuery ) {
		window.jQuery = _jQuery;
	}

	return jQuery;
};

// Expose jQuery and $ identifiers, even in AMD
// (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
// and CommonJS for browser emulators (trac-13566)
if ( typeof noGlobal === "undefined" ) {
	window.jQuery = window.$ = jQuery;
}




return jQuery;
} );


/***/ }),
/* 725 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _scrollLink = __webpack_require__(194);

var _scrollLink2 = _interopRequireDefault(_scrollLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var LinkElement = function (_React$Component) {
  _inherits(LinkElement, _React$Component);

  function LinkElement() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, LinkElement);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = LinkElement.__proto__ || Object.getPrototypeOf(LinkElement)).call.apply(_ref, [this].concat(args))), _this), _this.render = function () {
      return _react2.default.createElement(
        'a',
        _this.props,
        _this.props.children
      );
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  return LinkElement;
}(_react2.default.Component);

;

exports.default = (0, _scrollLink2.default)(LinkElement);

/***/ }),
/* 726 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {/**
 * lodash (Custom Build) <https://lodash.com/>
 * Build: `lodash modularize exports="npm" -o ./`
 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */

/** Used as the `TypeError` message for "Functions" methods. */
var FUNC_ERROR_TEXT = 'Expected a function';

/** Used as references for various `Number` constants. */
var NAN = 0 / 0;

/** `Object#toString` result references. */
var symbolTag = '[object Symbol]';

/** Used to match leading and trailing whitespace. */
var reTrim = /^\s+|\s+$/g;

/** Used to detect bad signed hexadecimal string values. */
var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

/** Used to detect binary string values. */
var reIsBinary = /^0b[01]+$/i;

/** Used to detect octal string values. */
var reIsOctal = /^0o[0-7]+$/i;

/** Built-in method references without a dependency on `root`. */
var freeParseInt = parseInt;

/** Detect free variable `global` from Node.js. */
var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;

/** Detect free variable `self`. */
var freeSelf = typeof self == 'object' && self && self.Object === Object && self;

/** Used as a reference to the global object. */
var root = freeGlobal || freeSelf || Function('return this')();

/** Used for built-in method references. */
var objectProto = Object.prototype;

/**
 * Used to resolve the
 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
 * of values.
 */
var objectToString = objectProto.toString;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeMax = Math.max,
    nativeMin = Math.min;

/**
 * Gets the timestamp of the number of milliseconds that have elapsed since
 * the Unix epoch (1 January 1970 00:00:00 UTC).
 *
 * @static
 * @memberOf _
 * @since 2.4.0
 * @category Date
 * @returns {number} Returns the timestamp.
 * @example
 *
 * _.defer(function(stamp) {
 *   console.log(_.now() - stamp);
 * }, _.now());
 * // => Logs the number of milliseconds it took for the deferred invocation.
 */
var now = function() {
  return root.Date.now();
};

/**
 * Creates a debounced function that delays invoking `func` until after `wait`
 * milliseconds have elapsed since the last time the debounced function was
 * invoked. The debounced function comes with a `cancel` method to cancel
 * delayed `func` invocations and a `flush` method to immediately invoke them.
 * Provide `options` to indicate whether `func` should be invoked on the
 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
 * with the last arguments provided to the debounced function. Subsequent
 * calls to the debounced function return the result of the last `func`
 * invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the debounced function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.debounce` and `_.throttle`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to debounce.
 * @param {number} [wait=0] The number of milliseconds to delay.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=false]
 *  Specify invoking on the leading edge of the timeout.
 * @param {number} [options.maxWait]
 *  The maximum time `func` is allowed to be delayed before it's invoked.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new debounced function.
 * @example
 *
 * // Avoid costly calculations while the window size is in flux.
 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
 *
 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
 * jQuery(element).on('click', _.debounce(sendMail, 300, {
 *   'leading': true,
 *   'trailing': false
 * }));
 *
 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
 * var source = new EventSource('/stream');
 * jQuery(source).on('message', debounced);
 *
 * // Cancel the trailing debounced invocation.
 * jQuery(window).on('popstate', debounced.cancel);
 */
function debounce(func, wait, options) {
  var lastArgs,
      lastThis,
      maxWait,
      result,
      timerId,
      lastCallTime,
      lastInvokeTime = 0,
      leading = false,
      maxing = false,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  wait = toNumber(wait) || 0;
  if (isObject(options)) {
    leading = !!options.leading;
    maxing = 'maxWait' in options;
    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }

  function invokeFunc(time) {
    var args = lastArgs,
        thisArg = lastThis;

    lastArgs = lastThis = undefined;
    lastInvokeTime = time;
    result = func.apply(thisArg, args);
    return result;
  }

  function leadingEdge(time) {
    // Reset any `maxWait` timer.
    lastInvokeTime = time;
    // Start the timer for the trailing edge.
    timerId = setTimeout(timerExpired, wait);
    // Invoke the leading edge.
    return leading ? invokeFunc(time) : result;
  }

  function remainingWait(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime,
        result = wait - timeSinceLastCall;

    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
  }

  function shouldInvoke(time) {
    var timeSinceLastCall = time - lastCallTime,
        timeSinceLastInvoke = time - lastInvokeTime;

    // Either this is the first call, activity has stopped and we're at the
    // trailing edge, the system time has gone backwards and we're treating
    // it as the trailing edge, or we've hit the `maxWait` limit.
    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
  }

  function timerExpired() {
    var time = now();
    if (shouldInvoke(time)) {
      return trailingEdge(time);
    }
    // Restart the timer.
    timerId = setTimeout(timerExpired, remainingWait(time));
  }

  function trailingEdge(time) {
    timerId = undefined;

    // Only invoke if we have `lastArgs` which means `func` has been
    // debounced at least once.
    if (trailing && lastArgs) {
      return invokeFunc(time);
    }
    lastArgs = lastThis = undefined;
    return result;
  }

  function cancel() {
    if (timerId !== undefined) {
      clearTimeout(timerId);
    }
    lastInvokeTime = 0;
    lastArgs = lastCallTime = lastThis = timerId = undefined;
  }

  function flush() {
    return timerId === undefined ? result : trailingEdge(now());
  }

  function debounced() {
    var time = now(),
        isInvoking = shouldInvoke(time);

    lastArgs = arguments;
    lastThis = this;
    lastCallTime = time;

    if (isInvoking) {
      if (timerId === undefined) {
        return leadingEdge(lastCallTime);
      }
      if (maxing) {
        // Handle invocations in a tight loop.
        timerId = setTimeout(timerExpired, wait);
        return invokeFunc(lastCallTime);
      }
    }
    if (timerId === undefined) {
      timerId = setTimeout(timerExpired, wait);
    }
    return result;
  }
  debounced.cancel = cancel;
  debounced.flush = flush;
  return debounced;
}

/**
 * Creates a throttled function that only invokes `func` at most once per
 * every `wait` milliseconds. The throttled function comes with a `cancel`
 * method to cancel delayed `func` invocations and a `flush` method to
 * immediately invoke them. Provide `options` to indicate whether `func`
 * should be invoked on the leading and/or trailing edge of the `wait`
 * timeout. The `func` is invoked with the last arguments provided to the
 * throttled function. Subsequent calls to the throttled function return the
 * result of the last `func` invocation.
 *
 * **Note:** If `leading` and `trailing` options are `true`, `func` is
 * invoked on the trailing edge of the timeout only if the throttled function
 * is invoked more than once during the `wait` timeout.
 *
 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
 *
 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
 * for details over the differences between `_.throttle` and `_.debounce`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Function
 * @param {Function} func The function to throttle.
 * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
 * @param {Object} [options={}] The options object.
 * @param {boolean} [options.leading=true]
 *  Specify invoking on the leading edge of the timeout.
 * @param {boolean} [options.trailing=true]
 *  Specify invoking on the trailing edge of the timeout.
 * @returns {Function} Returns the new throttled function.
 * @example
 *
 * // Avoid excessively updating the position while scrolling.
 * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
 *
 * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
 * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
 * jQuery(element).on('click', throttled);
 *
 * // Cancel the trailing throttled invocation.
 * jQuery(window).on('popstate', throttled.cancel);
 */
function throttle(func, wait, options) {
  var leading = true,
      trailing = true;

  if (typeof func != 'function') {
    throw new TypeError(FUNC_ERROR_TEXT);
  }
  if (isObject(options)) {
    leading = 'leading' in options ? !!options.leading : leading;
    trailing = 'trailing' in options ? !!options.trailing : trailing;
  }
  return debounce(func, wait, {
    'leading': leading,
    'maxWait': wait,
    'trailing': trailing
  });
}

/**
 * Checks if `value` is the
 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
 * @example
 *
 * _.isObject({});
 * // => true
 *
 * _.isObject([1, 2, 3]);
 * // => true
 *
 * _.isObject(_.noop);
 * // => true
 *
 * _.isObject(null);
 * // => false
 */
function isObject(value) {
  var type = typeof value;
  return !!value && (type == 'object' || type == 'function');
}

/**
 * Checks if `value` is object-like. A value is object-like if it's not `null`
 * and has a `typeof` result of "object".
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
 * @example
 *
 * _.isObjectLike({});
 * // => true
 *
 * _.isObjectLike([1, 2, 3]);
 * // => true
 *
 * _.isObjectLike(_.noop);
 * // => false
 *
 * _.isObjectLike(null);
 * // => false
 */
function isObjectLike(value) {
  return !!value && typeof value == 'object';
}

/**
 * Checks if `value` is classified as a `Symbol` primitive or object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
 * @example
 *
 * _.isSymbol(Symbol.iterator);
 * // => true
 *
 * _.isSymbol('abc');
 * // => false
 */
function isSymbol(value) {
  return typeof value == 'symbol' ||
    (isObjectLike(value) && objectToString.call(value) == symbolTag);
}

/**
 * Converts `value` to a number.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to process.
 * @returns {number} Returns the number.
 * @example
 *
 * _.toNumber(3.2);
 * // => 3.2
 *
 * _.toNumber(Number.MIN_VALUE);
 * // => 5e-324
 *
 * _.toNumber(Infinity);
 * // => Infinity
 *
 * _.toNumber('3.2');
 * // => 3.2
 */
function toNumber(value) {
  if (typeof value == 'number') {
    return value;
  }
  if (isSymbol(value)) {
    return NAN;
  }
  if (isObject(value)) {
    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
    value = isObject(other) ? (other + '') : other;
  }
  if (typeof value != 'string') {
    return value === 0 ? value : +value;
  }
  value = value.replace(reTrim, '');
  var isBinary = reIsBinary.test(value);
  return (isBinary || reIsOctal.test(value))
    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
    : (reIsBadHex.test(value) ? NAN : +value);
}

module.exports = throttle;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29)))

/***/ }),
/* 727 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = {
  /*
   * https://github.com/oblador/angular-scroll (duScrollDefaultEasing)
   */
  defaultEasing: function defaultEasing(x) {
    if (x < 0.5) {
      return Math.pow(x * 2, 2) / 2;
    }
    return 1 - Math.pow((1 - x) * 2, 2) / 2;
  },
  /*
   * https://gist.github.com/gre/1650294
   */
  // no easing, no acceleration
  linear: function linear(x) {
    return x;
  },
  // accelerating from zero velocity
  easeInQuad: function easeInQuad(x) {
    return x * x;
  },
  // decelerating to zero velocity
  easeOutQuad: function easeOutQuad(x) {
    return x * (2 - x);
  },
  // acceleration until halfway, then deceleration
  easeInOutQuad: function easeInOutQuad(x) {
    return x < .5 ? 2 * x * x : -1 + (4 - 2 * x) * x;
  },
  // accelerating from zero velocity 
  easeInCubic: function easeInCubic(x) {
    return x * x * x;
  },
  // decelerating to zero velocity π
  easeOutCubic: function easeOutCubic(x) {
    return --x * x * x + 1;
  },
  // acceleration until halfway, then deceleration 
  easeInOutCubic: function easeInOutCubic(x) {
    return x < .5 ? 4 * x * x * x : (x - 1) * (2 * x - 2) * (2 * x - 2) + 1;
  },
  // accelerating from zero velocity 
  easeInQuart: function easeInQuart(x) {
    return x * x * x * x;
  },
  // decelerating to zero velocity 
  easeOutQuart: function easeOutQuart(x) {
    return 1 - --x * x * x * x;
  },
  // acceleration until halfway, then deceleration
  easeInOutQuart: function easeInOutQuart(x) {
    return x < .5 ? 8 * x * x * x * x : 1 - 8 * --x * x * x * x;
  },
  // accelerating from zero velocity
  easeInQuint: function easeInQuint(x) {
    return x * x * x * x * x;
  },
  // decelerating to zero velocity
  easeOutQuint: function easeOutQuint(x) {
    return 1 + --x * x * x * x * x;
  },
  // acceleration until halfway, then deceleration 
  easeInOutQuint: function easeInOutQuint(x) {
    return x < .5 ? 16 * x * x * x * x * x : 1 + 16 * --x * x * x * x * x;
  }
};

/***/ }),
/* 728 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _passiveEventListeners = __webpack_require__(196);

var events = ['mousedown', 'mousewheel', 'touchmove', 'keydown'];

exports.default = {
  subscribe: function subscribe(cancelEvent) {
    return typeof document !== 'undefined' && events.forEach(function (event) {
      return (0, _passiveEventListeners.addPassiveEventListener)(document, event, cancelEvent);
    });
  }
};

/***/ }),
/* 729 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _scrollLink = __webpack_require__(194);

var _scrollLink2 = _interopRequireDefault(_scrollLink);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ButtonElement = function (_React$Component) {
  _inherits(ButtonElement, _React$Component);

  function ButtonElement() {
    _classCallCheck(this, ButtonElement);

    return _possibleConstructorReturn(this, (ButtonElement.__proto__ || Object.getPrototypeOf(ButtonElement)).apply(this, arguments));
  }

  _createClass(ButtonElement, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement(
        'button',
        this.props,
        this.props.children
      );
    }
  }]);

  return ButtonElement;
}(_react2.default.Component);

;

exports.default = (0, _scrollLink2.default)(ButtonElement);

/***/ }),
/* 730 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _scrollElement = __webpack_require__(312);

var _scrollElement2 = _interopRequireDefault(_scrollElement);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ElementWrapper = function (_React$Component) {
  _inherits(ElementWrapper, _React$Component);

  function ElementWrapper() {
    _classCallCheck(this, ElementWrapper);

    return _possibleConstructorReturn(this, (ElementWrapper.__proto__ || Object.getPrototypeOf(ElementWrapper)).apply(this, arguments));
  }

  _createClass(ElementWrapper, [{
    key: 'render',
    value: function render() {
      var _this2 = this;

      // Remove `parentBindings` and `name` from props
      var newProps = _extends({}, this.props);
      delete newProps.name;
      if (newProps.parentBindings) {
        delete newProps.parentBindings;
      }

      return _react2.default.createElement(
        'div',
        _extends({}, newProps, { ref: function ref(el) {
            _this2.props.parentBindings.domNode = el;
          } }),
        this.props.children
      );
    }
  }]);

  return ElementWrapper;
}(_react2.default.Component);

;

ElementWrapper.propTypes = {
  name: _propTypes2.default.string,
  id: _propTypes2.default.string
};

exports.default = (0, _scrollElement2.default)(ElementWrapper);

/***/ }),
/* 731 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/* DEPRECATED */

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var React = __webpack_require__(0);
var ReactDOM = __webpack_require__(30);

var utils = __webpack_require__(135);
var scrollSpy = __webpack_require__(195);
var defaultScroller = __webpack_require__(134);
var PropTypes = __webpack_require__(1);
var scrollHash = __webpack_require__(311);

var protoTypes = {
  to: PropTypes.string.isRequired,
  containerId: PropTypes.string,
  container: PropTypes.object,
  activeClass: PropTypes.string,
  spy: PropTypes.bool,
  smooth: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  offset: PropTypes.number,
  delay: PropTypes.number,
  isDynamic: PropTypes.bool,
  onClick: PropTypes.func,
  duration: PropTypes.oneOfType([PropTypes.number, PropTypes.func]),
  absolute: PropTypes.bool,
  onSetActive: PropTypes.func,
  onSetInactive: PropTypes.func,
  ignoreCancelEvents: PropTypes.bool,
  hashSpy: PropTypes.bool,
  spyThrottle: PropTypes.number
};

var Helpers = {
  Scroll: function Scroll(Component, customScroller) {

    console.warn("Helpers.Scroll is deprecated since v1.7.0");

    var scroller = customScroller || defaultScroller;

    var Scroll = function (_React$Component) {
      _inherits(Scroll, _React$Component);

      function Scroll(props) {
        _classCallCheck(this, Scroll);

        var _this = _possibleConstructorReturn(this, (Scroll.__proto__ || Object.getPrototypeOf(Scroll)).call(this, props));

        _initialiseProps.call(_this);

        _this.state = {
          active: false
        };
        return _this;
      }

      _createClass(Scroll, [{
        key: 'getScrollSpyContainer',
        value: function getScrollSpyContainer() {
          var containerId = this.props.containerId;
          var container = this.props.container;

          if (containerId) {
            return document.getElementById(containerId);
          }

          if (container && container.nodeType) {
            return container;
          }

          return document;
        }
      }, {
        key: 'componentDidMount',
        value: function componentDidMount() {
          if (this.props.spy || this.props.hashSpy) {
            var scrollSpyContainer = this.getScrollSpyContainer();

            if (!scrollSpy.isMounted(scrollSpyContainer)) {
              scrollSpy.mount(scrollSpyContainer, this.props.spyThrottle);
            }

            if (this.props.hashSpy) {
              if (!scrollHash.isMounted()) {
                scrollHash.mount(scroller);
              }
              scrollHash.mapContainer(this.props.to, scrollSpyContainer);
            }

            if (this.props.spy) {
              scrollSpy.addStateHandler(this.stateHandler);
            }

            scrollSpy.addSpyHandler(this.spyHandler, scrollSpyContainer);

            this.setState({
              container: scrollSpyContainer
            });
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          scrollSpy.unmount(this.stateHandler, this.spyHandler);
        }
      }, {
        key: 'render',
        value: function render() {
          var className = "";

          if (this.state && this.state.active) {
            className = ((this.props.className || "") + " " + (this.props.activeClass || "active")).trim();
          } else {
            className = this.props.className;
          }

          var props = _extends({}, this.props);

          for (var prop in protoTypes) {
            if (props.hasOwnProperty(prop)) {
              delete props[prop];
            }
          }

          props.className = className;
          props.onClick = this.handleClick;

          return React.createElement(Component, props);
        }
      }]);

      return Scroll;
    }(React.Component);

    var _initialiseProps = function _initialiseProps() {
      var _this2 = this;

      this.scrollTo = function (to, props) {
        scroller.scrollTo(to, _extends({}, _this2.state, props));
      };

      this.handleClick = function (event) {

        /*
         * give the posibility to override onClick
         */

        if (_this2.props.onClick) {
          _this2.props.onClick(event);
        }

        /*
         * dont bubble the navigation
         */

        if (event.stopPropagation) event.stopPropagation();
        if (event.preventDefault) event.preventDefault();

        /*
         * do the magic!
         */
        _this2.scrollTo(_this2.props.to, _this2.props);
      };

      this.stateHandler = function () {
        if (scroller.getActiveLink() !== _this2.props.to) {
          if (_this2.state !== null && _this2.state.active && _this2.props.onSetInactive) {
            _this2.props.onSetInactive();
          }
          _this2.setState({ active: false });
        }
      };

      this.spyHandler = function (y) {

        var scrollSpyContainer = _this2.getScrollSpyContainer();

        if (scrollHash.isMounted() && !scrollHash.isInitialized()) {
          return;
        }

        var to = _this2.props.to;
        var element = null;
        var elemTopBound = 0;
        var elemBottomBound = 0;
        var containerTop = 0;

        if (scrollSpyContainer.getBoundingClientRect) {
          var containerCords = scrollSpyContainer.getBoundingClientRect();
          containerTop = containerCords.top;
        }

        if (!element || _this2.props.isDynamic) {
          element = scroller.get(to);
          if (!element) {
            return;
          }

          var cords = element.getBoundingClientRect();
          elemTopBound = cords.top - containerTop + y;
          elemBottomBound = elemTopBound + cords.height;
        }

        var offsetY = y - _this2.props.offset;
        var isInside = offsetY >= Math.floor(elemTopBound) && offsetY < Math.floor(elemBottomBound);
        var isOutside = offsetY < Math.floor(elemTopBound) || offsetY >= Math.floor(elemBottomBound);
        var activeLink = scroller.getActiveLink();

        if (isOutside) {
          if (to === activeLink) {
            scroller.setActiveLink(void 0);
          }

          if (_this2.props.hashSpy && scrollHash.getHash() === to) {
            scrollHash.changeHash();
          }

          if (_this2.props.spy && _this2.state.active) {
            _this2.setState({ active: false });
            _this2.props.onSetInactive && _this2.props.onSetInactive();
          }

          return scrollSpy.updateStates();
        }

        if (isInside && activeLink !== to) {
          scroller.setActiveLink(to);

          _this2.props.hashSpy && scrollHash.changeHash(to);

          if (_this2.props.spy) {
            _this2.setState({ active: true });
            _this2.props.onSetActive && _this2.props.onSetActive(to);
          }
          return scrollSpy.updateStates();
        }
      };
    };

    ;

    Scroll.propTypes = protoTypes;

    Scroll.defaultProps = { offset: 0 };

    return Scroll;
  },
  Element: function Element(Component) {

    console.warn("Helpers.Element is deprecated since v1.7.0");

    var Element = function (_React$Component2) {
      _inherits(Element, _React$Component2);

      function Element(props) {
        _classCallCheck(this, Element);

        var _this3 = _possibleConstructorReturn(this, (Element.__proto__ || Object.getPrototypeOf(Element)).call(this, props));

        _this3.childBindings = {
          domNode: null
        };
        return _this3;
      }

      _createClass(Element, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
          if (typeof window === 'undefined') {
            return false;
          }
          this.registerElems(this.props.name);
        }
      }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps) {
          if (this.props.name !== prevProps.name) {
            this.registerElems(this.props.name);
          }
        }
      }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
          if (typeof window === 'undefined') {
            return false;
          }
          defaultScroller.unregister(this.props.name);
        }
      }, {
        key: 'registerElems',
        value: function registerElems(name) {
          defaultScroller.register(name, this.childBindings.domNode);
        }
      }, {
        key: 'render',
        value: function render() {
          return React.createElement(Component, _extends({}, this.props, { parentBindings: this.childBindings }));
        }
      }]);

      return Element;
    }(React.Component);

    ;

    Element.propTypes = {
      name: PropTypes.string,
      id: PropTypes.string
    };

    return Element;
  }
};

module.exports = Helpers;

/***/ }),
/* 732 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _default; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__icons_ArrowDown__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__List__ = __webpack_require__(315);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp2;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var _default=(_temp2=_class=function(_React$Component){_inherits(_default,_React$Component);function _default(){var _ref;var _temp,_this,_ret;_classCallCheck(this,_default);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=_default.__proto__||Object.getPrototypeOf(_default)).call.apply(_ref,[this].concat(args))),_this),_this.state={showChildren:_this.props.showChildren},_this.toggleChildren=function(){return _this.setState({showChildren:!_this.state.showChildren});},_this.handleClickListItem=function(){if(_this.props.items.length>0){_this.toggleChildren();}},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(_default,[{key:'render',value:function render(){var _props=this.props,text=_props.text,to=_props.to,renderText=_props.renderText,className=_props.className,items=_props.items,showToggleIcon=_props.showToggleIcon,onClick=_props.onClick;var showChildren=this.state.showChildren;var LinkComponent=typeof to!=='undefined'?__WEBPACK_IMPORTED_MODULE_1_react_router_dom__["c" /* NavLink */]:'a';// const LinkComponent = 'a';
var componentProps=typeof to!=='undefined'?{to:to}:{href:to,onClick:onClick};// if (to === `undefined`) componentProps.onClick = onClick;
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'list-item '+className+' '+(showChildren?'open':''),onClick:this.handleClickListItem},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(LinkComponent,componentProps,typeof renderText==='function'?renderText():text),items.length>0&&showToggleIcon&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{className:'btn-toggle',onClick:this.toggleChildren},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__icons_ArrowDown__["a" /* default */],{width:'0.8em',height:'0.8em',fill:'#000'}))),items.length>0&&showChildren&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__List__["a" /* default */],null,items));}}]);return _default;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component),_class.defaultProps={showChildren:false,text:'No Text',className:'',items:[],showToggleIcon:true},_temp2);

/***/ }),
/* 733 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _default; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_animejs__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_animejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_animejs__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var lineLeftClose='M128,188 256,188 384,188';var lineLeftOpen='M158,158 256,256 354,158';var lineCenterClose='M128,256 384,256';var lineCenterOpen='M256,256 256,256';var lineRightClose='M128,324 256,324 384,324';var lineRightOpen='M158,354 256,256 354,354';var animeConfig={easing:'easeOutQuad',elasticity:0,duration:300};var _default=function(_React$Component){_inherits(_default,_React$Component);function _default(){_classCallCheck(this,_default);return _possibleConstructorReturn(this,(_default.__proto__||Object.getPrototypeOf(_default)).apply(this,arguments));}_createClass(_default,[{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){if(this.props.open!==prevProps.open){if(this.props.open){__WEBPACK_IMPORTED_MODULE_1_animejs___default()(Object.assign({targets:'#line-left',d:lineLeftOpen},animeConfig));__WEBPACK_IMPORTED_MODULE_1_animejs___default()(Object.assign({targets:'#line-center',d:lineCenterOpen},animeConfig,{duration:200}));__WEBPACK_IMPORTED_MODULE_1_animejs___default()(Object.assign({targets:'#line-right',d:lineRightOpen},animeConfig));}else{__WEBPACK_IMPORTED_MODULE_1_animejs___default()(Object.assign({targets:'#line-left',d:lineLeftClose},animeConfig));__WEBPACK_IMPORTED_MODULE_1_animejs___default()(Object.assign({targets:'#line-center',d:lineCenterClose},animeConfig));__WEBPACK_IMPORTED_MODULE_1_animejs___default()(Object.assign({targets:'#line-right',d:lineRightClose},animeConfig));}}}},{key:'render',value:function render(){var open=this.props.open;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',Object.assign({viewBox:'0 0 512 512'},this.props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{x:0,y:0,width:512,height:512,fill:'white'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{style:{transition:'all 500ms',transformOrigin:'256px 256px'},transform:'rotate('+(open?'180':'0')+')'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:lineLeftClose,stroke:'black',fill:'none',strokeWidth:8,id:'line-left'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:lineCenterClose,stroke:'black',fill:'none',strokeWidth:8,id:'line-center'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{d:lineRightClose,stroke:'black',fill:'none',strokeWidth:8,id:'line-right'})));}}]);return _default;}(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Component);

/***/ }),
/* 734 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return LoadingSlider; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_styled_components__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_animejs__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_animejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_animejs__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;var _templateObject=_taggedTemplateLiteral(["\n  .bar {\n    width: 0%;\n    height: ","px;\n    background-color: ",";\n  }\n"],["\n  .bar {\n    width: 0%;\n    height: ","px;\n    background-color: ",";\n  }\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Container=__WEBPACK_IMPORTED_MODULE_2_styled_components__["b" /* default */].div(_templateObject,function(props){return props.height;},function(props){return props.color;});var LoadingSlider=(_temp=_class=function(_PureComponent){_inherits(LoadingSlider,_PureComponent);function LoadingSlider(props){_classCallCheck(this,LoadingSlider);var _this=_possibleConstructorReturn(this,(LoadingSlider.__proto__||Object.getPrototypeOf(LoadingSlider)).call(this,props));_this.componentDidMount=function(){var duration=_this.props.duration;_this.animateBar=__WEBPACK_IMPORTED_MODULE_3_animejs___default()({targets:_this.barRef.current,easing:"linear",duration:duration,width:"100%",loop:true});_this.animateBar.update=function(anim){if(anim.progress===100){_this.props.onComplete();}};};_this.getAnimate=function(){return _this.animateBar;};_this.barRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();return _this;}_createClass(LoadingSlider,[{key:"render",value:function render(){var _props=this.props,height=_props.height,color=_props.color;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Container,{height:height,color:color},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{ref:this.barRef,className:"bar"}));}}]);return LoadingSlider;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]),_class.propTypes={onComplete:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func,height:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number,color:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,duration:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.number},_class.defaultProps={onComplete:function onComplete(){return null;},height:5,color:"lightgrey",duration:5000},_temp);

/***/ }),
/* 735 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SliderWithLoading; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_styled_components__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_animejs__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_animejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_animejs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;var _templateObject=_taggedTemplateLiteral(["\n  position: relative;\n  width: 100%;\n  height: 100%;\n"],["\n  position: relative;\n  width: 100%;\n  height: 100%;\n"]),_templateObject2=_taggedTemplateLiteral(["\n  position: absolute;\n  z-index: 2;\n  width: 100%;\n  ",";\n"],["\n  position: absolute;\n  z-index: 2;\n  width: 100%;\n  ",";\n"]);function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var SliderWithLoading=(_temp=_class=function(_Component){_inherits(SliderWithLoading,_Component);function SliderWithLoading(props){_classCallCheck(this,SliderWithLoading);var _this=_possibleConstructorReturn(this,(SliderWithLoading.__proto__||Object.getPrototypeOf(SliderWithLoading)).call(this,props));_this.state={onIndex:0};_this.handleLoadingComplete=function(){if(_this.sliderRef&&_this.sliderRef.current)_this.sliderRef.current.slickNext();};_this.handleBeforeChangeSlider=function(current,next){if(current<next){_this.sliderRef.current.slickNext();}else if(current>next){_this.sliderRef.current.slickPrev();}_this.barRef.current.getAnimate().restart();// anime({
//   targets: ".content-title",
//   easing: "linear",
//   width: [500, 300],
//   scale: [1.1, 1],
//   opacity: [0, 1],
//   duration: 2000,
//   delay: 1500,
// });
// anime({
//   targets: ".content-title-detail",
//   easing: "linear",
//   scale: [1.8, 1],
//   opacity: [0.2, 1],
//   duration: 2000,
//   delay: 2000,
// });
};_this.renderTitle=function(){var _this$props=_this.props,t=_this$props.t,items=_this$props.items;var onIndex=_this.state.onIndex;var item=items[onIndex];console.log("renderTitle",_this.props);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"content-title "+__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(item,"position"),ref:_this.titleRef},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"content-title-detail "+__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(item,"position"),style:{alignItems:"flex-start"}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h1",null,t(__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(item,"title"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h1",null,t(__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(item,"subTitle")))));};_this.sliderRef=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createRef();_this.barRef=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createRef();_this.titleRef=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createRef();return _this;}_createClass(SliderWithLoading,[{key:"render",value:function render(){var _props=this.props,t=_props.t,items=_props.items,position=_props.position,loadingHeight=_props.loadingHeight,loadingColor=_props.loadingColor,duration=_props.duration,isRenderTitle=_props.isRenderTitle;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Container,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components__["p" /* Slider */],{sliderRef:this.sliderRef,settings:{dots:false,autoplay:false,beforeChange:this.handleBeforeChangeSlider},items:items,onClick:function onClick(a,b,c,d){return console.log("handleBeforeChangeSlider",a,b,c,d);},uiRenderer:function uiRenderer(item){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"img-background",style:{backgroundImage:"url('"+__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(item,"image")+"')"}});}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(LoadingContainer,{position:position},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components__["i" /* LoadingSlider */],{ref:this.barRef,height:loadingHeight,color:loadingColor,duration:duration,onComplete:this.handleLoadingComplete})));}}]);return SliderWithLoading;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]),_class.propTypes={t:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,items:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.array,position:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,loadingHeight:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,loadingColor:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,duration:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number,isRenderTitle:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool},_class.defaultProps={items:[],position:"bottom",loadingHeight:5,loadingColor:"lightgrey",duration:5000,isRenderTitle:false,t:function t(){}},_temp);var Container=__WEBPACK_IMPORTED_MODULE_3_styled_components__["b" /* default */].div(_templateObject);var LoadingContainer=__WEBPACK_IMPORTED_MODULE_3_styled_components__["b" /* default */].div(_templateObject2,function(props){if(props.position==="top"){return"\n        top: 0;\n      ";}else if(props.position==="bottom"){return"\n        bottom: 0;\n      ";}});

/***/ }),
/* 736 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_forEach__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__icons_ArrowDown__ = __webpack_require__(198);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__icons_ArrowUp__ = __webpack_require__(313);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import { assetsPath } from '../utils'
// const downGreen = `${assetsPath()}/images/icon/down-green.png`;
// const SM_MIN_WIDTH = 0
// const SM_MAX_WIDTH = 576
// const LG_MIN_WIDTH = 576
// const LG_MAX_WIDTH = 1140
// if (isLg) offset = -152;
// if (isSm) offset = -90;
var ButtonScrollToSection=function(_React$Component){_inherits(ButtonScrollToSection,_React$Component);function ButtonScrollToSection(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ButtonScrollToSection);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ButtonScrollToSection.__proto__||Object.getPrototypeOf(ButtonScrollToSection)).call.apply(_ref,[this].concat(args))),_this),_this.componentDidMount=function(){_this.sections=document.querySelectorAll('.main-content section');_this.firstSection=_this.sections[0];_this.lastSection=_this.sections[_this.sections.length-1];_this.btnUp=document.querySelector('.button-scroll-to-section.up');_this.btnDown=document.querySelector('.button-scroll-to-section.down');window.addEventListener('scroll',_this.handleVisibleButtonScroll);_this.handleVisibleButtonScroll();},_this.componentWillUnMount=function(){window.removeEventListener('scroll');},_this.getHeaderHeight=function(){var header=document.getElementsByTagName('header')[0];var headerHeight=header.offsetHeight;// Prevent calculate headerheight wrong, due to shrink animation
if(window.innerWidth>1200&&document.documentElement.scrollTop<100)headerHeight=86;return headerHeight;},_this.handleVisibleButtonScroll=function(){if(window.pageYOffset>_this.firstSection.offsetHeight){// console.log('show top bottom');
_this.btnUp.classList.remove('hide');}else{// console.log('hide top bottom');
_this.btnUp.classList.add('hide');}if(window.pageYOffset<=_this.lastSection.offsetTop){// console.log('show down bottom');
_this.btnDown.classList.remove('hide');}else{// console.log('hide down bottom');
_this.btnDown.classList.add('hide');}},_this.handleScroll=function(direction){var sections=document.querySelectorAll('.main-content section');var headerHeight=_this.getHeaderHeight();__WEBPACK_IMPORTED_MODULE_0_lodash_forEach___default()(sections,function(section,sectionIndex){var stickyTop=section.offsetTop;var stickyBottom=stickyTop+section.offsetHeight;if(window.pageYOffset+headerHeight>=stickyTop&&window.pageYOffset+headerHeight<=stickyBottom){var nextIndex=direction==='up'?sectionIndex-1:sectionIndex+1;var nextSection=sections[nextIndex];if(nextSection){var scrollTargetValue=direction==='up'?nextSection.offsetTop-headerHeight:nextSection.offsetTop-headerHeight;$('html, body').stop().animate({scrollTop:scrollTargetValue},800);// eslint-disable-line
return false;}return false;}});},_this.handleScrollUp=function(){_this.handleScroll('up');},_this.handleScrollDown=function(){_this.handleScroll('down');},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ButtonScrollToSection,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{onClick:this.handleScrollUp,className:'button-scroll-to-section up'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__icons_ArrowUp__["a" /* default */],{width:40,height:40,fill:'#04a8a6'})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('button',{onClick:this.handleScrollDown,className:'button-scroll-to-section down'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__icons_ArrowDown__["a" /* default */],{width:40,height:40,fill:'#04a8a6'})));}}]);return ButtonScrollToSection;}(__WEBPACK_IMPORTED_MODULE_1_react___default.a.Component);/* unused harmony default export */ var _unused_webpack_default_export = (ButtonScrollToSection);

/***/ }),
/* 737 */
/***/ (function(module, exports, __webpack_require__) {

var identity = __webpack_require__(98);

/**
 * Casts `value` to `identity` if it's not a function.
 *
 * @private
 * @param {*} value The value to inspect.
 * @returns {Function} Returns cast function.
 */
function castFunction(value) {
  return typeof value == 'function' ? value : identity;
}

module.exports = castFunction;


/***/ }),
/* 738 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_dom__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__NewsArticleSummary__ = __webpack_require__(318);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NewsArticleCard=(_temp=_class=function(_Component){_inherits(NewsArticleCard,_Component);function NewsArticleCard(){_classCallCheck(this,NewsArticleCard);return _possibleConstructorReturn(this,(NewsArticleCard.__proto__||Object.getPrototypeOf(NewsArticleCard)).apply(this,arguments));}_createClass(NewsArticleCard,[{key:'render',value:function render(){var _props=this.props,media=_props.media,title=_props.title,dateString=_props.dateString,to=_props.to,excerpt=_props.excerpt;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'related-news-card'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xl-12 col-lg-6 col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img-wrapper'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{alt:'related-news-article-img',src:media}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'col-xl-12 col-lg-6 col-md-12'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__NewsArticleSummary__["a" /* default */],{title:title,dateString:dateString,excerpt:excerpt,to:to}))));}}]);return NewsArticleCard;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.propTypes={media:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string.required,title:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,dateString:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,to:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,excerpt:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string},_class.defaultProps={title:"title",dateString:"dateString",to:"/",excerpt:"excerpt"},_temp);/* harmony default export */ __webpack_exports__["a"] = (NewsArticleCard);

/***/ }),
/* 739 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return GradientPage; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_skrollr__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_skrollr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_skrollr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var GradientPage=(_temp=_class=function(_Component){_inherits(GradientPage,_Component);function GradientPage(){_classCallCheck(this,GradientPage);return _possibleConstructorReturn(this,(GradientPage.__proto__||Object.getPrototypeOf(GradientPage)).apply(this,arguments));}_createClass(GradientPage,[{key:'render',value:function render(){var _props=this.props,image=_props.image,children=_props.children,themeWhite=_props.themeWhite;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'gradient-page-component'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'parallax-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_skrollr__["Parallax"],{data:{'data-86-bottom-top':'transform: translateY(-100px); filter: blur(300px) saturate(2);','data-250-top':'transform: translateY(0px); filter: blur(0px) saturate(1);'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-img-bg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img-bg',style:{backgroundImage:'url('+image+')'}})))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'bg-right '+(themeWhite?'theme-white':'')},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text'},children)));}}]);return GradientPage;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class.propTypes={image:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string,themeWhite:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool},_class.defaultProps={image:'https://lagunaproperty.com/images/03-sanctuary-club_63.jpg',themeWhite:false},_temp);

/***/ }),
/* 740 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

var _skrollr = __webpack_require__(741);

var _skrollr2 = _interopRequireDefault(_skrollr);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var ParallaxProvider = function (_React$Component) {
  _inherits(ParallaxProvider, _React$Component);

  function ParallaxProvider() {
    var _ref;

    var _temp, _this, _ret;

    _classCallCheck(this, ParallaxProvider);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref = ParallaxProvider.__proto__ || Object.getPrototypeOf(ParallaxProvider)).call.apply(_ref, [this].concat(args))), _this), _this.refresh = function () {
      if (_this.skrollr) _this.skrollr.refresh();
    }, _this.isMobile = function () {
      return (/Android|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent || navigator.vendor || window.opera)
      );
    }, _this.shouldInitOrDestroy = function () {
      var disableOnMobile = _this.props.disableOnMobile;

      if (!disableOnMobile) {
        _this.initSkrollr();
        return;
      }

      if (disableOnMobile && _this.isMobile() && _this.skrollr !== undefined) {
        _this.skrollr.destroy();
        _this.skrollr = undefined;
      }

      if (disableOnMobile && !_this.isMobile() && _this.skrollr === undefined) {
        _this.initSkrollr();
      }
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ParallaxProvider, [{
    key: 'initSkrollr',
    value: function initSkrollr() {
      this.skrollr = _skrollr2.default.init(this.props.init);
    }
  }, {
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.shouldInitOrDestroy();
      window.addEventListener('resize', this.shouldInitOrDestroy);
    }
  }, {
    key: 'componentWillUnmount',
    value: function componentWillUnmount() {
      window.removeEventListener('resize', this.shouldInitOrDestroy);
      if (this.skrollr) this.skrollr.destroy();
    }
  }, {
    key: 'getChildContext',
    value: function getChildContext() {
      return { refresh: this.refresh };
    }
  }, {
    key: 'render',
    value: function render() {
      var children = this.props.children;

      return _react2.default.createElement(
        'div',
        { id: 'skrollr-body' },
        children
      );
    }
  }]);

  return ParallaxProvider;
}(_react2.default.Component);

ParallaxProvider.propTypes = {
  init: _propTypes2.default.object,
  disableOnMobile: _propTypes2.default.bool
};
ParallaxProvider.defaultProps = {
  init: {},
  disableOnMobile: true
};
ParallaxProvider.childContextTypes = {
  refresh: _propTypes2.default.func
};
exports.default = ParallaxProvider;

/***/ }),
/* 741 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_RESULT__;/*! skrollr 0.6.26 (2014-06-08) | Alexander Prinzhorn - https://github.com/Prinzhorn/skrollr | Free to use under terms of MIT license */
(function(e,t,r){"use strict";function n(r){if(o=t.documentElement,a=t.body,K(),it=this,r=r||{},ut=r.constants||{},r.easing)for(var n in r.easing)U[n]=r.easing[n];yt=r.edgeStrategy||"set",ct={beforerender:r.beforerender,render:r.render,keyframe:r.keyframe},ft=r.forceHeight!==!1,ft&&(Vt=r.scale||1),mt=r.mobileDeceleration||x,dt=r.smoothScrolling!==!1,gt=r.smoothScrollingDuration||E,vt={targetTop:it.getScrollTop()},Gt=(r.mobileCheck||function(){return/Android|iPhone|iPad|iPod|BlackBerry/i.test(navigator.userAgent||navigator.vendor||e.opera)})(),Gt?(st=t.getElementById("skrollr-body"),st&&at(),X(),Dt(o,[y,S],[T])):Dt(o,[y,b],[T]),it.refresh(),St(e,"resize orientationchange",function(){var e=o.clientWidth,t=o.clientHeight;(t!==$t||e!==Mt)&&($t=t,Mt=e,_t=!0)});var i=Y();return function l(){Z(),bt=i(l)}(),it}var o,a,i={get:function(){return it},init:function(e){return it||new n(e)},VERSION:"0.6.26"},l=Object.prototype.hasOwnProperty,s=e.Math,c=e.getComputedStyle,f="touchstart",u="touchmove",m="touchcancel",p="touchend",d="skrollable",g=d+"-before",v=d+"-between",h=d+"-after",y="skrollr",T="no-"+y,b=y+"-desktop",S=y+"-mobile",k="linear",w=1e3,x=.004,E=200,A="start",F="end",C="center",D="bottom",H="___skrollable_id",I=/^(?:input|textarea|button|select)$/i,P=/^\s+|\s+$/g,N=/^data(?:-(_\w+))?(?:-?(-?\d*\.?\d+p?))?(?:-?(start|end|top|center|bottom))?(?:-?(top|center|bottom))?$/,O=/\s*(@?[\w\-\[\]]+)\s*:\s*(.+?)\s*(?:;|$)/gi,V=/^(@?[a-z\-]+)\[(\w+)\]$/,z=/-([a-z0-9_])/g,q=function(e,t){return t.toUpperCase()},L=/[\-+]?[\d]*\.?[\d]+/g,M=/\{\?\}/g,$=/rgba?\(\s*-?\d+\s*,\s*-?\d+\s*,\s*-?\d+/g,_=/[a-z\-]+-gradient/g,B="",G="",K=function(){var e=/^(?:O|Moz|webkit|ms)|(?:-(?:o|moz|webkit|ms)-)/;if(c){var t=c(a,null);for(var n in t)if(B=n.match(e)||+n==n&&t[n].match(e))break;if(!B)return B=G="",r;B=B[0],"-"===B.slice(0,1)?(G=B,B={"-webkit-":"webkit","-moz-":"Moz","-ms-":"ms","-o-":"O"}[B]):G="-"+B.toLowerCase()+"-"}},Y=function(){var t=e.requestAnimationFrame||e[B.toLowerCase()+"RequestAnimationFrame"],r=Pt();return(Gt||!t)&&(t=function(t){var n=Pt()-r,o=s.max(0,1e3/60-n);return e.setTimeout(function(){r=Pt(),t()},o)}),t},R=function(){var t=e.cancelAnimationFrame||e[B.toLowerCase()+"CancelAnimationFrame"];return(Gt||!t)&&(t=function(t){return e.clearTimeout(t)}),t},U={begin:function(){return 0},end:function(){return 1},linear:function(e){return e},quadratic:function(e){return e*e},cubic:function(e){return e*e*e},swing:function(e){return-s.cos(e*s.PI)/2+.5},sqrt:function(e){return s.sqrt(e)},outCubic:function(e){return s.pow(e-1,3)+1},bounce:function(e){var t;if(.5083>=e)t=3;else if(.8489>=e)t=9;else if(.96208>=e)t=27;else{if(!(.99981>=e))return 1;t=91}return 1-s.abs(3*s.cos(1.028*e*t)/t)}};n.prototype.refresh=function(e){var n,o,a=!1;for(e===r?(a=!0,lt=[],Bt=0,e=t.getElementsByTagName("*")):e.length===r&&(e=[e]),n=0,o=e.length;o>n;n++){var i=e[n],l=i,s=[],c=dt,f=yt,u=!1;if(a&&H in i&&delete i[H],i.attributes){for(var m=0,p=i.attributes.length;p>m;m++){var g=i.attributes[m];if("data-anchor-target"!==g.name)if("data-smooth-scrolling"!==g.name)if("data-edge-strategy"!==g.name)if("data-emit-events"!==g.name){var v=g.name.match(N);if(null!==v){var h={props:g.value,element:i,eventType:g.name.replace(z,q)};s.push(h);var y=v[1];y&&(h.constant=y.substr(1));var T=v[2];/p$/.test(T)?(h.isPercentage=!0,h.offset=(0|T.slice(0,-1))/100):h.offset=0|T;var b=v[3],S=v[4]||b;b&&b!==A&&b!==F?(h.mode="relative",h.anchors=[b,S]):(h.mode="absolute",b===F?h.isEnd=!0:h.isPercentage||(h.offset=h.offset*Vt))}}else u=!0;else f=g.value;else c="off"!==g.value;else if(l=t.querySelector(g.value),null===l)throw'Unable to find anchor target "'+g.value+'"'}if(s.length){var k,w,x;!a&&H in i?(x=i[H],k=lt[x].styleAttr,w=lt[x].classAttr):(x=i[H]=Bt++,k=i.style.cssText,w=Ct(i)),lt[x]={element:i,styleAttr:k,classAttr:w,anchorTarget:l,keyFrames:s,smoothScrolling:c,edgeStrategy:f,emitEvents:u,lastFrameIndex:-1},Dt(i,[d],[])}}}for(Et(),n=0,o=e.length;o>n;n++){var E=lt[e[n][H]];E!==r&&(J(E),et(E))}return it},n.prototype.relativeToAbsolute=function(e,t,r){var n=o.clientHeight,a=e.getBoundingClientRect(),i=a.top,l=a.bottom-a.top;return t===D?i-=n:t===C&&(i-=n/2),r===D?i+=l:r===C&&(i+=l/2),i+=it.getScrollTop(),0|i+.5},n.prototype.animateTo=function(e,t){t=t||{};var n=Pt(),o=it.getScrollTop();return pt={startTop:o,topDiff:e-o,targetTop:e,duration:t.duration||w,startTime:n,endTime:n+(t.duration||w),easing:U[t.easing||k],done:t.done},pt.topDiff||(pt.done&&pt.done.call(it,!1),pt=r),it},n.prototype.stopAnimateTo=function(){pt&&pt.done&&pt.done.call(it,!0),pt=r},n.prototype.isAnimatingTo=function(){return!!pt},n.prototype.isMobile=function(){return Gt},n.prototype.setScrollTop=function(t,r){return ht=r===!0,Gt?Kt=s.min(s.max(t,0),Ot):e.scrollTo(0,t),it},n.prototype.getScrollTop=function(){return Gt?Kt:e.pageYOffset||o.scrollTop||a.scrollTop||0},n.prototype.getMaxScrollTop=function(){return Ot},n.prototype.on=function(e,t){return ct[e]=t,it},n.prototype.off=function(e){return delete ct[e],it},n.prototype.destroy=function(){var e=R();e(bt),wt(),Dt(o,[T],[y,b,S]);for(var t=0,n=lt.length;n>t;t++)ot(lt[t].element);o.style.overflow=a.style.overflow="",o.style.height=a.style.height="",st&&i.setStyle(st,"transform","none"),it=r,st=r,ct=r,ft=r,Ot=0,Vt=1,ut=r,mt=r,zt="down",qt=-1,Mt=0,$t=0,_t=!1,pt=r,dt=r,gt=r,vt=r,ht=r,Bt=0,yt=r,Gt=!1,Kt=0,Tt=r};var X=function(){var n,i,l,c,d,g,v,h,y,T,b,S;St(o,[f,u,m,p].join(" "),function(e){var o=e.changedTouches[0];for(c=e.target;3===c.nodeType;)c=c.parentNode;switch(d=o.clientY,g=o.clientX,T=e.timeStamp,I.test(c.tagName)||e.preventDefault(),e.type){case f:n&&n.blur(),it.stopAnimateTo(),n=c,i=v=d,l=g,y=T;break;case u:I.test(c.tagName)&&t.activeElement!==c&&e.preventDefault(),h=d-v,S=T-b,it.setScrollTop(Kt-h,!0),v=d,b=T;break;default:case m:case p:var a=i-d,k=l-g,w=k*k+a*a;if(49>w){if(!I.test(n.tagName)){n.focus();var x=t.createEvent("MouseEvents");x.initMouseEvent("click",!0,!0,e.view,1,o.screenX,o.screenY,o.clientX,o.clientY,e.ctrlKey,e.altKey,e.shiftKey,e.metaKey,0,null),n.dispatchEvent(x)}return}n=r;var E=h/S;E=s.max(s.min(E,3),-3);var A=s.abs(E/mt),F=E*A+.5*mt*A*A,C=it.getScrollTop()-F,D=0;C>Ot?(D=(Ot-C)/F,C=Ot):0>C&&(D=-C/F,C=0),A*=1-D,it.animateTo(0|C+.5,{easing:"outCubic",duration:A})}}),e.scrollTo(0,0),o.style.overflow=a.style.overflow="hidden"},j=function(){var e,t,r,n,a,i,l,c,f,u,m,p=o.clientHeight,d=At();for(c=0,f=lt.length;f>c;c++)for(e=lt[c],t=e.element,r=e.anchorTarget,n=e.keyFrames,a=0,i=n.length;i>a;a++)l=n[a],u=l.offset,m=d[l.constant]||0,l.frame=u,l.isPercentage&&(u*=p,l.frame=u),"relative"===l.mode&&(ot(t),l.frame=it.relativeToAbsolute(r,l.anchors[0],l.anchors[1])-u,ot(t,!0)),l.frame+=m,ft&&!l.isEnd&&l.frame>Ot&&(Ot=l.frame);for(Ot=s.max(Ot,Ft()),c=0,f=lt.length;f>c;c++){for(e=lt[c],n=e.keyFrames,a=0,i=n.length;i>a;a++)l=n[a],m=d[l.constant]||0,l.isEnd&&(l.frame=Ot-l.offset+m);e.keyFrames.sort(Nt)}},W=function(e,t){for(var r=0,n=lt.length;n>r;r++){var o,a,s=lt[r],c=s.element,f=s.smoothScrolling?e:t,u=s.keyFrames,m=u.length,p=u[0],y=u[u.length-1],T=p.frame>f,b=f>y.frame,S=T?p:y,k=s.emitEvents,w=s.lastFrameIndex;if(T||b){if(T&&-1===s.edge||b&&1===s.edge)continue;switch(T?(Dt(c,[g],[h,v]),k&&w>-1&&(xt(c,p.eventType,zt),s.lastFrameIndex=-1)):(Dt(c,[h],[g,v]),k&&m>w&&(xt(c,y.eventType,zt),s.lastFrameIndex=m)),s.edge=T?-1:1,s.edgeStrategy){case"reset":ot(c);continue;case"ease":f=S.frame;break;default:case"set":var x=S.props;for(o in x)l.call(x,o)&&(a=nt(x[o].value),0===o.indexOf("@")?c.setAttribute(o.substr(1),a):i.setStyle(c,o,a));continue}}else 0!==s.edge&&(Dt(c,[d,v],[g,h]),s.edge=0);for(var E=0;m-1>E;E++)if(f>=u[E].frame&&u[E+1].frame>=f){var A=u[E],F=u[E+1];for(o in A.props)if(l.call(A.props,o)){var C=(f-A.frame)/(F.frame-A.frame);C=A.props[o].easing(C),a=rt(A.props[o].value,F.props[o].value,C),a=nt(a),0===o.indexOf("@")?c.setAttribute(o.substr(1),a):i.setStyle(c,o,a)}k&&w!==E&&("down"===zt?xt(c,A.eventType,zt):xt(c,F.eventType,zt),s.lastFrameIndex=E);break}}},Z=function(){_t&&(_t=!1,Et());var e,t,n=it.getScrollTop(),o=Pt();if(pt)o>=pt.endTime?(n=pt.targetTop,e=pt.done,pt=r):(t=pt.easing((o-pt.startTime)/pt.duration),n=0|pt.startTop+t*pt.topDiff),it.setScrollTop(n,!0);else if(!ht){var a=vt.targetTop-n;a&&(vt={startTop:qt,topDiff:n-qt,targetTop:n,startTime:Lt,endTime:Lt+gt}),vt.endTime>=o&&(t=U.sqrt((o-vt.startTime)/gt),n=0|vt.startTop+t*vt.topDiff)}if(Gt&&st&&i.setStyle(st,"transform","translate(0, "+-Kt+"px) "+Tt),ht||qt!==n){zt=n>qt?"down":qt>n?"up":zt,ht=!1;var l={curTop:n,lastTop:qt,maxTop:Ot,direction:zt},s=ct.beforerender&&ct.beforerender.call(it,l);s!==!1&&(W(n,it.getScrollTop()),qt=n,ct.render&&ct.render.call(it,l)),e&&e.call(it,!1)}Lt=o},J=function(e){for(var t=0,r=e.keyFrames.length;r>t;t++){for(var n,o,a,i,l=e.keyFrames[t],s={};null!==(i=O.exec(l.props));)a=i[1],o=i[2],n=a.match(V),null!==n?(a=n[1],n=n[2]):n=k,o=o.indexOf("!")?Q(o):[o.slice(1)],s[a]={value:o,easing:U[n]};l.props=s}},Q=function(e){var t=[];return $.lastIndex=0,e=e.replace($,function(e){return e.replace(L,function(e){return 100*(e/255)+"%"})}),G&&(_.lastIndex=0,e=e.replace(_,function(e){return G+e})),e=e.replace(L,function(e){return t.push(+e),"{?}"}),t.unshift(e),t},et=function(e){var t,r,n={};for(t=0,r=e.keyFrames.length;r>t;t++)tt(e.keyFrames[t],n);for(n={},t=e.keyFrames.length-1;t>=0;t--)tt(e.keyFrames[t],n)},tt=function(e,t){var r;for(r in t)l.call(e.props,r)||(e.props[r]=t[r]);for(r in e.props)t[r]=e.props[r]},rt=function(e,t,r){var n,o=e.length;if(o!==t.length)throw"Can't interpolate between \""+e[0]+'" and "'+t[0]+'"';var a=[e[0]];for(n=1;o>n;n++)a[n]=e[n]+(t[n]-e[n])*r;return a},nt=function(e){var t=1;return M.lastIndex=0,e[0].replace(M,function(){return e[t++]})},ot=function(e,t){e=[].concat(e);for(var r,n,o=0,a=e.length;a>o;o++)n=e[o],r=lt[n[H]],r&&(t?(n.style.cssText=r.dirtyStyleAttr,Dt(n,r.dirtyClassAttr)):(r.dirtyStyleAttr=n.style.cssText,r.dirtyClassAttr=Ct(n),n.style.cssText=r.styleAttr,Dt(n,r.classAttr)))},at=function(){Tt="translateZ(0)",i.setStyle(st,"transform",Tt);var e=c(st),t=e.getPropertyValue("transform"),r=e.getPropertyValue(G+"transform"),n=t&&"none"!==t||r&&"none"!==r;n||(Tt="")};i.setStyle=function(e,t,r){var n=e.style;if(t=t.replace(z,q).replace("-",""),"zIndex"===t)n[t]=isNaN(r)?r:""+(0|r);else if("float"===t)n.styleFloat=n.cssFloat=r;else try{B&&(n[B+t.slice(0,1).toUpperCase()+t.slice(1)]=r),n[t]=r}catch(o){}};var it,lt,st,ct,ft,ut,mt,pt,dt,gt,vt,ht,yt,Tt,bt,St=i.addEvent=function(t,r,n){var o=function(t){return t=t||e.event,t.target||(t.target=t.srcElement),t.preventDefault||(t.preventDefault=function(){t.returnValue=!1,t.defaultPrevented=!0}),n.call(this,t)};r=r.split(" ");for(var a,i=0,l=r.length;l>i;i++)a=r[i],t.addEventListener?t.addEventListener(a,n,!1):t.attachEvent("on"+a,o),Yt.push({element:t,name:a,listener:n})},kt=i.removeEvent=function(e,t,r){t=t.split(" ");for(var n=0,o=t.length;o>n;n++)e.removeEventListener?e.removeEventListener(t[n],r,!1):e.detachEvent("on"+t[n],r)},wt=function(){for(var e,t=0,r=Yt.length;r>t;t++)e=Yt[t],kt(e.element,e.name,e.listener);Yt=[]},xt=function(e,t,r){ct.keyframe&&ct.keyframe.call(it,e,t,r)},Et=function(){var e=it.getScrollTop();Ot=0,ft&&!Gt&&(a.style.height=""),j(),ft&&!Gt&&(a.style.height=Ot+o.clientHeight+"px"),Gt?it.setScrollTop(s.min(it.getScrollTop(),Ot)):it.setScrollTop(e,!0),ht=!0},At=function(){var e,t,r=o.clientHeight,n={};for(e in ut)t=ut[e],"function"==typeof t?t=t.call(it):/p$/.test(t)&&(t=t.slice(0,-1)/100*r),n[e]=t;return n},Ft=function(){var e=st&&st.offsetHeight||0,t=s.max(e,a.scrollHeight,a.offsetHeight,o.scrollHeight,o.offsetHeight,o.clientHeight);return t-o.clientHeight},Ct=function(t){var r="className";return e.SVGElement&&t instanceof e.SVGElement&&(t=t[r],r="baseVal"),t[r]},Dt=function(t,n,o){var a="className";if(e.SVGElement&&t instanceof e.SVGElement&&(t=t[a],a="baseVal"),o===r)return t[a]=n,r;for(var i=t[a],l=0,s=o.length;s>l;l++)i=It(i).replace(It(o[l])," ");i=Ht(i);for(var c=0,f=n.length;f>c;c++)-1===It(i).indexOf(It(n[c]))&&(i+=" "+n[c]);t[a]=Ht(i)},Ht=function(e){return e.replace(P,"")},It=function(e){return" "+e+" "},Pt=Date.now||function(){return+new Date},Nt=function(e,t){return e.frame-t.frame},Ot=0,Vt=1,zt="down",qt=-1,Lt=Pt(),Mt=0,$t=0,_t=!1,Bt=0,Gt=!1,Kt=0,Yt=[]; true?!(__WEBPACK_AMD_DEFINE_RESULT__ = function(){return i}.call(exports, __webpack_require__, exports, module),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"undefined"!=typeof module&&module.exports?module.exports=i:e.skrollr=i})(window,document);

/***/ }),
/* 742 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var Parallax = function (_React$Component) {
  _inherits(Parallax, _React$Component);

  function Parallax() {
    _classCallCheck(this, Parallax);

    return _possibleConstructorReturn(this, (Parallax.__proto__ || Object.getPrototypeOf(Parallax)).apply(this, arguments));
  }

  _createClass(Parallax, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      if (typeof this.context.refresh === 'function') this.context.refresh();
    }
  }, {
    key: 'componentWillReceiveProps',
    value: function componentWillReceiveProps() {
      if (typeof this.context.refresh === 'function') this.context.refresh();
    }
  }, {
    key: 'render',
    value: function render() {
      var _props = this.props,
          data = _props.data,
          children = _props.children;

      return _react2.default.createElement(
        'div',
        data,
        children
      );
    }
  }]);

  return Parallax;
}(_react2.default.Component);

Parallax.contextTypes = { refresh: _propTypes2.default.func };
exports.default = Parallax;

/***/ }),
/* 743 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Select__ = __webpack_require__(744);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Input__ = __webpack_require__(745);
/* harmony default export */ __webpack_exports__["a"] = ({Input:__WEBPACK_IMPORTED_MODULE_1__Input__["a" /* default */],Select:__WEBPACK_IMPORTED_MODULE_0__Select__["a" /* default */]});

/***/ }),
/* 744 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _default; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp2;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var _default=(_temp2=_class=function(_PureComponent){_inherits(_default,_PureComponent);function _default(){var _ref;var _temp,_this,_ret;_classCallCheck(this,_default);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=_default.__proto__||Object.getPrototypeOf(_default)).call.apply(_ref,[this].concat(args))),_this),_this.state={},_this.componentDidMount=function(){},_this.componentDidUpdate=function(prevProps,prevState,snapshot){},_this.componentWillUnmount=function(){},_this.getSnapshotBeforeUpdate=function(prevProps,prevState){return{};},_this.handleChange=function(e){console.log('handleChange',e.target.value);// const { name, onChange } = this.props
// onChange(name, value)
},_this.renderOptions=function(){var options=_this.props.options;return options.map(function(option,i){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('option',{key:option.value,value:option.value},option.label||'Option '+(i+1));});},_temp),_possibleConstructorReturn(_this,_ret);}// ======================================================
// Commit Phase
// Can work with DOM, run side effects, schedule updates.
// ======================================================
// ======================================================
// Pre-commit Phase
// Can read the DOM
// ======================================================
_createClass(_default,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('select',{onChange:this.handleChange},this.renderOptions()));}}],[{key:'getDerivedStateFromProps',// ======================================================
// Render Phase
// Pure and no side effects. May be paused, aborted or restarted by React.
// ======================================================
value:function getDerivedStateFromProps(props,state){return{};}// ======================================================
// Private Methods
// ======================================================
}]);return _default;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]),_class.propTypes={},_class.defaultProps={},_temp2);

/***/ }),
/* 745 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _default; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp2;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var _default=(_temp2=_class=function(_PureComponent){_inherits(_default,_PureComponent);function _default(){var _ref;var _temp,_this,_ret;_classCallCheck(this,_default);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=_default.__proto__||Object.getPrototypeOf(_default)).call.apply(_ref,[this].concat(args))),_this),_this.state={},_this.componentDidMount=function(){},_this.componentDidUpdate=function(prevProps,prevState,snapshot){},_this.componentWillUnmount=function(){},_this.getSnapshotBeforeUpdate=function(prevProps,prevState){return{};},_this.handleChange=function(e){console.log('handleChange',e.target.value);// const { name, onChange } = this.props
// onChange(name, value)
},_temp),_possibleConstructorReturn(_this,_ret);}// ======================================================
// Commit Phase
// Can work with DOM, run side effects, schedule updates.
// ======================================================
// ======================================================
// Pre-commit Phase
// Can read the DOM
// ======================================================
_createClass(_default,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('input',Object.assign({},this.props,{onChange:this.handleChange})));}}],[{key:'getDerivedStateFromProps',// ======================================================
// Render Phase
// Pure and no side effects. May be paused, aborted or restarted by React.
// ======================================================
value:function getDerivedStateFromProps(props,state){return{};}// ======================================================
// Private Methods
// ======================================================
}]);return _default;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]),_class.propTypes={},_class.defaultProps={},_temp2);

/***/ }),
/* 746 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _default; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(747);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp2;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var _default=(_temp2=_class=function(_PureComponent){_inherits(_default,_PureComponent);function _default(){var _ref;var _temp,_this,_ret;_classCallCheck(this,_default);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=_default.__proto__||Object.getPrototypeOf(_default)).call.apply(_ref,[this].concat(args))),_this),_this.state={isActive:Object(__WEBPACK_IMPORTED_MODULE_2__utils__["b" /* isPrivacyPolicy */])()// ======================================================
// Commit Phase
// Can work with DOM, run side effects, schedule updates.
// ======================================================
},_this.componentDidMount=function(){},_this.componentDidUpdate=function(prevProps,prevState,snapshot){},_this.componentWillUnmount=function(){},_this.getSnapshotBeforeUpdate=function(prevProps,prevState){return{};},_this.handleAcceptPrivacyPolicy=function(){Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* acceptPrivacyPolicy */])();_this.setState(function(){return{isActive:true};});},_temp),_possibleConstructorReturn(_this,_ret);}// ======================================================
// Pre-commit Phase
// Can read the DOM
// ======================================================
_createClass(_default,[{key:'render',value:function render(){var isActive=this.state.isActive;var _props=this.props,text=_props.text,linkText=_props.linkText,buttonText=_props.buttonText,href=_props.href;if(isActive)return'';return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'privacy-policy'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'description'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span',null,text),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('a',{href:href,target:'_blank',className:'button-popup'},linkText)))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('button',{onClick:this.handleAcceptPrivacyPolicy,className:'button-accept'},buttonText)));}}],[{key:'getDerivedStateFromProps',// ======================================================
// Render Phase
// Pure and no side effects. May be paused, aborted or restarted by React.
// ======================================================
value:function getDerivedStateFromProps(props,state){return{};}// ======================================================
// Private Methods
// ======================================================
}]);return _default;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]),_class.propTypes={},_class.defaultProps={},_temp2);

/***/ }),
/* 747 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return isPrivacyPolicy; });
/* unused harmony export deletePrivacyPolicy */
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return acceptPrivacyPolicy; });
var acceptPrivacyPolicy=function acceptPrivacyPolicy(){setCookie('privacy-policy',true,365);};var deletePrivacyPolicy=function deletePrivacyPolicy(){setCookie('privacy-policy','',0);};var setCookie=function setCookie(cname,cvalue,exdays){var d=new Date();d.setTime(d.getTime()+exdays*24*60*60*1000);var expires="expires="+d.toUTCString();document.cookie=cname+"="+cvalue+";"+expires+";path=/";};var getCookie=function getCookie(cname){var name=cname+"=";var decodedCookie=decodeURIComponent(document.cookie);var ca=decodedCookie.split(';');console.log('getCookie',ca);for(var i=0;i<ca.length;i++){var c=ca[i];while(c.charAt(0)==' '){// eslint-disable-line
c=c.substring(1);}if(c.indexOf(name)==0){// eslint-disable-line
return c.substring(name.length,c.length);}}return"";};var isPrivacyPolicy=function isPrivacyPolicy(){return getCookie('privacy-policy')&&getCookie('privacy-policy')!=='';};

/***/ }),
/* 748 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_redux_thunk__ = __webpack_require__(749);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_logger__ = __webpack_require__(750);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_redux_logger___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_redux_logger__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__reducers__ = __webpack_require__(751);
// import React from "react";
// import { whyDidYouUpdate } from "why-did-you-update";
/* harmony default export */ __webpack_exports__["a"] = (function(){var initialState=arguments.length>0&&arguments[0]!==undefined?arguments[0]:{};var middlewares=[__WEBPACK_IMPORTED_MODULE_1_redux_thunk__["a" /* default */]];if(false){middlewares.push(createLogger());// whyDidYouUpdate(React);
}var store=Object(__WEBPACK_IMPORTED_MODULE_0_redux__["createStore"])(__WEBPACK_IMPORTED_MODULE_3__reducers__["a" /* default */],initialState,__WEBPACK_IMPORTED_MODULE_0_redux__["applyMiddleware"].apply(undefined,middlewares));return store;});

/***/ }),
/* 749 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/** A function that accepts a potential "extra argument" value to be injected later,
 * and returns an instance of the thunk middleware that uses that value
 */
function createThunkMiddleware(extraArgument) {
  // Standard Redux middleware definition pattern:
  // See: https://redux.js.org/tutorials/fundamentals/part-4-store#writing-custom-middleware
  var middleware = function middleware(_ref) {
    var dispatch = _ref.dispatch,
        getState = _ref.getState;
    return function (next) {
      return function (action) {
        // The thunk middleware looks for any functions that were passed to `store.dispatch`.
        // If this "action" is really a function, call it and return the result.
        if (typeof action === 'function') {
          // Inject the store's `dispatch` and `getState` methods, as well as any "extra arg"
          return action(dispatch, getState, extraArgument);
        } // Otherwise, pass the action down the middleware chain as usual


        return next(action);
      };
    };
  };

  return middleware;
}

var thunk = createThunkMiddleware(); // Attach the factory function so users can create a customized version
// with whatever "extra arg" they want to inject into their thunks

thunk.withExtraArgument = createThunkMiddleware;
/* harmony default export */ __webpack_exports__["a"] = (thunk);

/***/ }),
/* 750 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {!function(e,t){ true?t(exports):"function"==typeof define&&define.amd?define(["exports"],t):t(e.reduxLogger=e.reduxLogger||{})}(this,function(e){"use strict";function t(e,t){e.super_=t,e.prototype=Object.create(t.prototype,{constructor:{value:e,enumerable:!1,writable:!0,configurable:!0}})}function r(e,t){Object.defineProperty(this,"kind",{value:e,enumerable:!0}),t&&t.length&&Object.defineProperty(this,"path",{value:t,enumerable:!0})}function n(e,t,r){n.super_.call(this,"E",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0}),Object.defineProperty(this,"rhs",{value:r,enumerable:!0})}function o(e,t){o.super_.call(this,"N",e),Object.defineProperty(this,"rhs",{value:t,enumerable:!0})}function i(e,t){i.super_.call(this,"D",e),Object.defineProperty(this,"lhs",{value:t,enumerable:!0})}function a(e,t,r){a.super_.call(this,"A",e),Object.defineProperty(this,"index",{value:t,enumerable:!0}),Object.defineProperty(this,"item",{value:r,enumerable:!0})}function f(e,t,r){var n=e.slice((r||t)+1||e.length);return e.length=t<0?e.length+t:t,e.push.apply(e,n),e}function u(e){var t="undefined"==typeof e?"undefined":N(e);return"object"!==t?t:e===Math?"math":null===e?"null":Array.isArray(e)?"array":"[object Date]"===Object.prototype.toString.call(e)?"date":"function"==typeof e.toString&&/^\/.*\//.test(e.toString())?"regexp":"object"}function l(e,t,r,c,s,d,p){s=s||[],p=p||[];var g=s.slice(0);if("undefined"!=typeof d){if(c){if("function"==typeof c&&c(g,d))return;if("object"===("undefined"==typeof c?"undefined":N(c))){if(c.prefilter&&c.prefilter(g,d))return;if(c.normalize){var h=c.normalize(g,d,e,t);h&&(e=h[0],t=h[1])}}}g.push(d)}"regexp"===u(e)&&"regexp"===u(t)&&(e=e.toString(),t=t.toString());var y="undefined"==typeof e?"undefined":N(e),v="undefined"==typeof t?"undefined":N(t),b="undefined"!==y||p&&p[p.length-1].lhs&&p[p.length-1].lhs.hasOwnProperty(d),m="undefined"!==v||p&&p[p.length-1].rhs&&p[p.length-1].rhs.hasOwnProperty(d);if(!b&&m)r(new o(g,t));else if(!m&&b)r(new i(g,e));else if(u(e)!==u(t))r(new n(g,e,t));else if("date"===u(e)&&e-t!==0)r(new n(g,e,t));else if("object"===y&&null!==e&&null!==t)if(p.filter(function(t){return t.lhs===e}).length)e!==t&&r(new n(g,e,t));else{if(p.push({lhs:e,rhs:t}),Array.isArray(e)){var w;e.length;for(w=0;w<e.length;w++)w>=t.length?r(new a(g,w,new i(void 0,e[w]))):l(e[w],t[w],r,c,g,w,p);for(;w<t.length;)r(new a(g,w,new o(void 0,t[w++])))}else{var x=Object.keys(e),S=Object.keys(t);x.forEach(function(n,o){var i=S.indexOf(n);i>=0?(l(e[n],t[n],r,c,g,n,p),S=f(S,i)):l(e[n],void 0,r,c,g,n,p)}),S.forEach(function(e){l(void 0,t[e],r,c,g,e,p)})}p.length=p.length-1}else e!==t&&("number"===y&&isNaN(e)&&isNaN(t)||r(new n(g,e,t)))}function c(e,t,r,n){return n=n||[],l(e,t,function(e){e&&n.push(e)},r),n.length?n:void 0}function s(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":s(o[r.path[n]],r.index,r.item);break;case"D":delete o[r.path[n]];break;case"E":case"N":o[r.path[n]]=r.rhs}}else switch(r.kind){case"A":s(e[t],r.index,r.item);break;case"D":e=f(e,t);break;case"E":case"N":e[t]=r.rhs}return e}function d(e,t,r){if(e&&t&&r&&r.kind){for(var n=e,o=-1,i=r.path?r.path.length-1:0;++o<i;)"undefined"==typeof n[r.path[o]]&&(n[r.path[o]]="number"==typeof r.path[o]?[]:{}),n=n[r.path[o]];switch(r.kind){case"A":s(r.path?n[r.path[o]]:n,r.index,r.item);break;case"D":delete n[r.path[o]];break;case"E":case"N":n[r.path[o]]=r.rhs}}}function p(e,t,r){if(r.path&&r.path.length){var n,o=e[t],i=r.path.length-1;for(n=0;n<i;n++)o=o[r.path[n]];switch(r.kind){case"A":p(o[r.path[n]],r.index,r.item);break;case"D":o[r.path[n]]=r.lhs;break;case"E":o[r.path[n]]=r.lhs;break;case"N":delete o[r.path[n]]}}else switch(r.kind){case"A":p(e[t],r.index,r.item);break;case"D":e[t]=r.lhs;break;case"E":e[t]=r.lhs;break;case"N":e=f(e,t)}return e}function g(e,t,r){if(e&&t&&r&&r.kind){var n,o,i=e;for(o=r.path.length-1,n=0;n<o;n++)"undefined"==typeof i[r.path[n]]&&(i[r.path[n]]={}),i=i[r.path[n]];switch(r.kind){case"A":p(i[r.path[n]],r.index,r.item);break;case"D":i[r.path[n]]=r.lhs;break;case"E":i[r.path[n]]=r.lhs;break;case"N":delete i[r.path[n]]}}}function h(e,t,r){if(e&&t){var n=function(n){r&&!r(e,t,n)||d(e,t,n)};l(e,t,n)}}function y(e){return"color: "+F[e].color+"; font-weight: bold"}function v(e){var t=e.kind,r=e.path,n=e.lhs,o=e.rhs,i=e.index,a=e.item;switch(t){case"E":return[r.join("."),n,"→",o];case"N":return[r.join("."),o];case"D":return[r.join(".")];case"A":return[r.join(".")+"["+i+"]",a];default:return[]}}function b(e,t,r,n){var o=c(e,t);try{n?r.groupCollapsed("diff"):r.group("diff")}catch(e){r.log("diff")}o?o.forEach(function(e){var t=e.kind,n=v(e);r.log.apply(r,["%c "+F[t].text,y(t)].concat(P(n)))}):r.log("—— no diff ——");try{r.groupEnd()}catch(e){r.log("—— diff end —— ")}}function m(e,t,r,n){switch("undefined"==typeof e?"undefined":N(e)){case"object":return"function"==typeof e[n]?e[n].apply(e,P(r)):e[n];case"function":return e(t);default:return e}}function w(e){var t=e.timestamp,r=e.duration;return function(e,n,o){var i=["action"];return i.push("%c"+String(e.type)),t&&i.push("%c@ "+n),r&&i.push("%c(in "+o.toFixed(2)+" ms)"),i.join(" ")}}function x(e,t){var r=t.logger,n=t.actionTransformer,o=t.titleFormatter,i=void 0===o?w(t):o,a=t.collapsed,f=t.colors,u=t.level,l=t.diff,c="undefined"==typeof t.titleFormatter;e.forEach(function(o,s){var d=o.started,p=o.startedTime,g=o.action,h=o.prevState,y=o.error,v=o.took,w=o.nextState,x=e[s+1];x&&(w=x.prevState,v=x.started-d);var S=n(g),k="function"==typeof a?a(function(){return w},g,o):a,j=D(p),E=f.title?"color: "+f.title(S)+";":"",A=["color: gray; font-weight: lighter;"];A.push(E),t.timestamp&&A.push("color: gray; font-weight: lighter;"),t.duration&&A.push("color: gray; font-weight: lighter;");var O=i(S,j,v);try{k?f.title&&c?r.groupCollapsed.apply(r,["%c "+O].concat(A)):r.groupCollapsed(O):f.title&&c?r.group.apply(r,["%c "+O].concat(A)):r.group(O)}catch(e){r.log(O)}var N=m(u,S,[h],"prevState"),P=m(u,S,[S],"action"),C=m(u,S,[y,h],"error"),F=m(u,S,[w],"nextState");if(N)if(f.prevState){var L="color: "+f.prevState(h)+"; font-weight: bold";r[N]("%c prev state",L,h)}else r[N]("prev state",h);if(P)if(f.action){var T="color: "+f.action(S)+"; font-weight: bold";r[P]("%c action    ",T,S)}else r[P]("action    ",S);if(y&&C)if(f.error){var M="color: "+f.error(y,h)+"; font-weight: bold;";r[C]("%c error     ",M,y)}else r[C]("error     ",y);if(F)if(f.nextState){var _="color: "+f.nextState(w)+"; font-weight: bold";r[F]("%c next state",_,w)}else r[F]("next state",w);l&&b(h,w,r,k);try{r.groupEnd()}catch(e){r.log("—— log end ——")}})}function S(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=Object.assign({},L,e),r=t.logger,n=t.stateTransformer,o=t.errorTransformer,i=t.predicate,a=t.logErrors,f=t.diffPredicate;if("undefined"==typeof r)return function(){return function(e){return function(t){return e(t)}}};if(e.getState&&e.dispatch)return console.error("[redux-logger] redux-logger not installed. Make sure to pass logger instance as middleware:\n// Logger with default options\nimport { logger } from 'redux-logger'\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n// Or you can create your own logger with custom options http://bit.ly/redux-logger-options\nimport createLogger from 'redux-logger'\nconst logger = createLogger({\n  // ...options\n});\nconst store = createStore(\n  reducer,\n  applyMiddleware(logger)\n)\n"),function(){return function(e){return function(t){return e(t)}}};var u=[];return function(e){var r=e.getState;return function(e){return function(l){if("function"==typeof i&&!i(r,l))return e(l);var c={};u.push(c),c.started=O.now(),c.startedTime=new Date,c.prevState=n(r()),c.action=l;var s=void 0;if(a)try{s=e(l)}catch(e){c.error=o(e)}else s=e(l);c.took=O.now()-c.started,c.nextState=n(r());var d=t.diff&&"function"==typeof f?f(r,l):t.diff;if(x(u,Object.assign({},t,{diff:d})),u.length=0,c.error)throw c.error;return s}}}}var k,j,E=function(e,t){return new Array(t+1).join(e)},A=function(e,t){return E("0",t-e.toString().length)+e},D=function(e){return A(e.getHours(),2)+":"+A(e.getMinutes(),2)+":"+A(e.getSeconds(),2)+"."+A(e.getMilliseconds(),3)},O="undefined"!=typeof performance&&null!==performance&&"function"==typeof performance.now?performance:Date,N="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},P=function(e){if(Array.isArray(e)){for(var t=0,r=Array(e.length);t<e.length;t++)r[t]=e[t];return r}return Array.from(e)},C=[];k="object"===("undefined"==typeof global?"undefined":N(global))&&global?global:"undefined"!=typeof window?window:{},j=k.DeepDiff,j&&C.push(function(){"undefined"!=typeof j&&k.DeepDiff===c&&(k.DeepDiff=j,j=void 0)}),t(n,r),t(o,r),t(i,r),t(a,r),Object.defineProperties(c,{diff:{value:c,enumerable:!0},observableDiff:{value:l,enumerable:!0},applyDiff:{value:h,enumerable:!0},applyChange:{value:d,enumerable:!0},revertChange:{value:g,enumerable:!0},isConflict:{value:function(){return"undefined"!=typeof j},enumerable:!0},noConflict:{value:function(){return C&&(C.forEach(function(e){e()}),C=null),c},enumerable:!0}});var F={E:{color:"#2196F3",text:"CHANGED:"},N:{color:"#4CAF50",text:"ADDED:"},D:{color:"#F44336",text:"DELETED:"},A:{color:"#2196F3",text:"ARRAY:"}},L={level:"log",logger:console,logErrors:!0,collapsed:void 0,predicate:void 0,duration:!1,timestamp:!0,stateTransformer:function(e){return e},actionTransformer:function(e){return e},errorTransformer:function(e){return e},colors:{title:function(){return"inherit"},prevState:function(){return"#9E9E9E"},action:function(){return"#03A9F4"},nextState:function(){return"#4CAF50"},error:function(){return"#F20404"}},diff:!1,diffPredicate:void 0,transformer:void 0},T=function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},t=e.dispatch,r=e.getState;return"function"==typeof t||"function"==typeof r?S()({dispatch:t,getState:r}):void console.error("\n[redux-logger v3] BREAKING CHANGE\n[redux-logger v3] Since 3.0.0 redux-logger exports by default logger with default settings.\n[redux-logger v3] Change\n[redux-logger v3] import createLogger from 'redux-logger'\n[redux-logger v3] to\n[redux-logger v3] import { createLogger } from 'redux-logger'\n")};e.defaults=L,e.createLogger=S,e.logger=T,e.default=T,Object.defineProperty(e,"__esModule",{value:!0})});

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29)))

/***/ }),
/* 751 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_redux__ = __webpack_require__(91);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__language__ = __webpack_require__(752);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__location__ = __webpack_require__(753);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__device__ = __webpack_require__(754);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__laguna_beachside__ = __webpack_require__(755);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__laguna_seaside_residences__ = __webpack_require__(756);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__phuket_skypark__ = __webpack_require__(757);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__phuket_laguna_park_2__ = __webpack_require__(758);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__phuket_laguna_village_residences__ = __webpack_require__(759);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__phuket_dusit_deluxe_pool_villa__ = __webpack_require__(760);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__preview_trip__ = __webpack_require__(761);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__home__ = __webpack_require__(762);
/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_0_redux__["combineReducers"])({language:__WEBPACK_IMPORTED_MODULE_1__language__["a" /* default */],location:__WEBPACK_IMPORTED_MODULE_2__location__["a" /* default */],device:__WEBPACK_IMPORTED_MODULE_3__device__["a" /* default */],"laguna-beachside":__WEBPACK_IMPORTED_MODULE_4__laguna_beachside__["a" /* default */],"laguna-seaside-residences-dev":__WEBPACK_IMPORTED_MODULE_5__laguna_seaside_residences__["a" /* default */],"laguna-seaside-residences":__WEBPACK_IMPORTED_MODULE_5__laguna_seaside_residences__["a" /* default */],"phuket-skypark":__WEBPACK_IMPORTED_MODULE_6__phuket_skypark__["a" /* default */],"phuket-laguna-park-2":__WEBPACK_IMPORTED_MODULE_7__phuket_laguna_park_2__["a" /* default */],"phuket-laguna-village-residences":__WEBPACK_IMPORTED_MODULE_8__phuket_laguna_village_residences__["a" /* default */],"phuket-dusit-deluxe-pool-villa":__WEBPACK_IMPORTED_MODULE_9__phuket_dusit_deluxe_pool_villa__["a" /* default */],home:__WEBPACK_IMPORTED_MODULE_11__home__["a" /* default */],"preview-trip":__WEBPACK_IMPORTED_MODULE_10__preview_trip__["a" /* default */]}));

/***/ }),
/* 752 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionType__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__locales__ = __webpack_require__(255);
var initialState={languages:__WEBPACK_IMPORTED_MODULE_1__locales__["a" /* default */].languages,currentActive:__WEBPACK_IMPORTED_MODULE_1__locales__["a" /* default */].defaultLanguage};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionType__["j" /* SWITCH_LANGUAGE */]:return Object.assign({},state,{currentActive:action.language});default:return state;}});

/***/ }),
/* 753 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionType__ = __webpack_require__(18);
var initialState={currentActive:null};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionType__["k" /* SWITCH_LOCATION */]:return Object.assign({},state,{currentActive:action.location});default:return state;}});

/***/ }),
/* 754 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionType__ = __webpack_require__(18);
var initialState={isMobile:false};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionType__["a" /* CHECK_MOBILE */]:return Object.assign({},state,{isMobile:action.isMobile});default:return state;}});

/***/ }),
/* 755 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionType__ = __webpack_require__(18);
var initialState={data:{}};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionType__["c" /* RECEIVE_LAGUNA_BEACHSIDE */]:return Object.assign({},state,{data:action.data});default:return state;}});

/***/ }),
/* 756 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionType__ = __webpack_require__(18);
var initialState={data:{}};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionType__["d" /* RECEIVE_LAGUNA_SEASIDE_RESIDENCES */]:return Object.assign({},state,{data:action.data});default:return state;}});

/***/ }),
/* 757 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionType__ = __webpack_require__(18);
var initialState={data:{}};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionType__["h" /* RECEIVE_PHUKET_SKYPARK */]:return Object.assign({},state,{data:action.data});default:return state;}});

/***/ }),
/* 758 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionType__ = __webpack_require__(18);
var initialState={data:{}};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionType__["f" /* RECEIVE_PHUKET_LAGUNA_PARK_2 */]:return Object.assign({},state,{data:action.data});default:return state;}});

/***/ }),
/* 759 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionType__ = __webpack_require__(18);
var initialState={data:{}};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionType__["g" /* RECEIVE_PHUKET_LAGUNA_VILLAGE_RESIDENCES */]:return Object.assign({},state,{data:action.data});default:return state;}});

/***/ }),
/* 760 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionType__ = __webpack_require__(18);
var initialState={data:{}};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionType__["e" /* RECEIVE_PHUKET_DUSIT_DELUXE_POOL_VILLA */]:return Object.assign({},state,{data:action.data});default:return state;}});

/***/ }),
/* 761 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionType__ = __webpack_require__(18);
var initialState={data:{}};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionType__["i" /* RECEIVE_PREVIEW_TRIP */]:return Object.assign({},state,{data:action.data});default:return state;}});

/***/ }),
/* 762 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__actions_actionType__ = __webpack_require__(18);
var initialState={data:{}};/* harmony default export */ __webpack_exports__["a"] = (function(){var state=arguments.length>0&&arguments[0]!==undefined?arguments[0]:initialState;var action=arguments[1];switch(action.type){case __WEBPACK_IMPORTED_MODULE_0__actions_actionType__["b" /* RECEIVE_HOME */]:return Object.assign({},state,{data:action.data});default:return state;}});

/***/ }),
/* 763 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__pages__ = __webpack_require__(764);
/* harmony default export */ __webpack_exports__["a"] = ([{component:__WEBPACK_IMPORTED_MODULE_1__pages__["m" /* Root */],routes:[{key:"preview-trip",path:"/:language/projects/preview-trip/enquiry/",exact:true,component:__WEBPACK_IMPORTED_MODULE_1__pages__["l" /* PreviewTrip */]},{key:"laguna-beachside",path:"/:language/projects/phuket/laguna-beachside/",exact:true,component:__WEBPACK_IMPORTED_MODULE_1__pages__["d" /* LagunaBeachside */]},{key:"laguna-lakeside-residences",path:"/:language/projects/phuket/laguna-lakeside-residences/",exact:true,component:function component(props){var match=props.match;var lang=__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(match,"params.language");var language=lang==="cn"?"zh":lang;console.log("xxxxxxxxxxxxxxxxxxxxxxxx");window.location.href="https://www.lagunaproperty.com/laguna-lakeside-residences/registrationform/"+language;return null;}},{key:"laguna-seaside-residences",path:"/:language/projects/phuket/laguna-seaside-residences/",exact:true,component:__WEBPACK_IMPORTED_MODULE_1__pages__["e" /* LagunaSeasideResidences */]},{key:"phuket-laguna-village-residences",path:"/:language/projects/phuket/laguna-village-residences/",exact:true,component:__WEBPACK_IMPORTED_MODULE_1__pages__["j" /* PhuketLagunaVillageResidences */]},{key:"phuket-laguna-park-2",path:"/:language/projects/phuket/laguna-park-2/",exact:true,component:__WEBPACK_IMPORTED_MODULE_1__pages__["i" /* PhuketLagunaPark2 */]},{key:"phuket-skypark",path:"/:language/projects/phuket/skypark/",exact:true,component:__WEBPACK_IMPORTED_MODULE_1__pages__["k" /* PhuketSkypark */]},// {
//   key: "dusit-deluxe-pool-villa",
//   path: "/:language/projects/phuket/dusit-laguna-resort-villas-phuket/",
//   exact: true,
//   component: PhuketDusitDeluxePoolVilla,
// },
{key:"home",path:"/:language/home",exact:true,component:__WEBPACK_IMPORTED_MODULE_1__pages__["c" /* Home */]},{key:"news",path:"/:language/news",exact:true,component:__WEBPACK_IMPORTED_MODULE_1__pages__["f" /* News */]},{key:"newsDetail",path:"/:language/news/:newsId/:slug",exact:true,component:__WEBPACK_IMPORTED_MODULE_1__pages__["g" /* NewsDetail */]},{key:"sanctuary-club",path:"/:language/sanctuary-club",exact:true,component:__WEBPACK_IMPORTED_MODULE_1__pages__["n" /* SanctuaryClub */]},{key:"about-us",path:"/:language/about-us",exact:true,component:__WEBPACK_IMPORTED_MODULE_1__pages__["a" /* AboutUs */]},{key:"contact-us",path:"/:language/contact-us",exact:true,component:__WEBPACK_IMPORTED_MODULE_1__pages__["b" /* ContactUs */]},{key:"404",path:"*",exact:false,component:__WEBPACK_IMPORTED_MODULE_1__pages__["h" /* NotFound */]}]}]);

/***/ }),
/* 764 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__Root__ = __webpack_require__(765);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "m", function() { return __WEBPACK_IMPORTED_MODULE_0__Root__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__LagunaBeachside__ = __webpack_require__(770);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return __WEBPACK_IMPORTED_MODULE_1__LagunaBeachside__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__LagunaSeasideResidences__ = __webpack_require__(863);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return __WEBPACK_IMPORTED_MODULE_2__LagunaSeasideResidences__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__PhuketLagunaVillageResidences__ = __webpack_require__(891);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "j", function() { return __WEBPACK_IMPORTED_MODULE_3__PhuketLagunaVillageResidences__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__PhuketLagunaPark2__ = __webpack_require__(911);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "i", function() { return __WEBPACK_IMPORTED_MODULE_4__PhuketLagunaPark2__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__PhuketSkypark__ = __webpack_require__(933);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "k", function() { return __WEBPACK_IMPORTED_MODULE_5__PhuketSkypark__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__PhuketDusitDeluxePoolVilla__ = __webpack_require__(1005);
/* unused harmony reexport PhuketDusitDeluxePoolVilla */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__PreviewTrip__ = __webpack_require__(1030);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "l", function() { return __WEBPACK_IMPORTED_MODULE_7__PreviewTrip__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Home__ = __webpack_require__(1074);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return __WEBPACK_IMPORTED_MODULE_8__Home__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__News__ = __webpack_require__(1083);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return __WEBPACK_IMPORTED_MODULE_9__News__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__News_NewsDetail__ = __webpack_require__(1085);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return __WEBPACK_IMPORTED_MODULE_10__News_NewsDetail__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__SanctuaryClub__ = __webpack_require__(1086);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "n", function() { return __WEBPACK_IMPORTED_MODULE_11__SanctuaryClub__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__AboutUs__ = __webpack_require__(1116);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_12__AboutUs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__ContactUs__ = __webpack_require__(1121);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return __WEBPACK_IMPORTED_MODULE_13__ContactUs__["a"]; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__NotFound__ = __webpack_require__(1123);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "h", function() { return __WEBPACK_IMPORTED_MODULE_14__NotFound__["a"]; });


/***/ }),
/* 765 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_router_config__ = __webpack_require__(229);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hoc__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import MobileDetect from "mobile-detect";
// import { switchMobile } from "../actions/device";
// const md = new MobileDetect(window.navigator.userAgent);
var mapStateToProps=function mapStateToProps(state){return{currentLang:state.language.currentActive};};var actionToProps={// switchMobile
};var Root=function(_Component){_inherits(Root,_Component);function Root(){_classCallCheck(this,Root);return _possibleConstructorReturn(this,(Root.__proto__||Object.getPrototypeOf(Root)).apply(this,arguments));}_createClass(Root,[{key:"render",// componentDidMount() {
//   console.log('md.os()', md.os());
//   const isMobile = md.os() === 'iOS' || md.os() === 'Android';
//   this.props.actions.switchMobile(isMobile);
// }
value:function render(){var _props=this.props,route=_props.route,currentLang=_props.currentLang;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_helmet__["Helmet"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("html",{lang:currentLang,amp:true}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("meta",{charSet:"utf-8"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("title",null,"Laguna"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("link",{rel:"canonical",href:window.location.href})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"root-content"},Object(__WEBPACK_IMPORTED_MODULE_1_react_router_config__["a" /* renderRoutes */])(route.routes)));}}]);return Root;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_3__hoc__["b" /* withRedux */])(mapStateToProps,actionToProps)(Root));

/***/ }),
/* 766 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var React = __webpack_require__(0);
var React__default = _interopDefault(React);
var shallowEqual = _interopDefault(__webpack_require__(767));

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;
  subClass.__proto__ = superClass;
}

var canUseDOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);
function withSideEffect(reducePropsToState, handleStateChangeOnClient, mapStateOnServer) {
  if (typeof reducePropsToState !== 'function') {
    throw new Error('Expected reducePropsToState to be a function.');
  }

  if (typeof handleStateChangeOnClient !== 'function') {
    throw new Error('Expected handleStateChangeOnClient to be a function.');
  }

  if (typeof mapStateOnServer !== 'undefined' && typeof mapStateOnServer !== 'function') {
    throw new Error('Expected mapStateOnServer to either be undefined or a function.');
  }

  function getDisplayName(WrappedComponent) {
    return WrappedComponent.displayName || WrappedComponent.name || 'Component';
  }

  return function wrap(WrappedComponent) {
    if (typeof WrappedComponent !== 'function') {
      throw new Error('Expected WrappedComponent to be a React component.');
    }

    var mountedInstances = [];
    var state;

    function emitChange() {
      state = reducePropsToState(mountedInstances.map(function (instance) {
        return instance.props;
      }));

      if (SideEffect.canUseDOM) {
        handleStateChangeOnClient(state);
      } else if (mapStateOnServer) {
        state = mapStateOnServer(state);
      }
    }

    var SideEffect =
    /*#__PURE__*/
    function (_Component) {
      _inheritsLoose(SideEffect, _Component);

      function SideEffect() {
        return _Component.apply(this, arguments) || this;
      }

      // Try to use displayName of wrapped component
      // Expose canUseDOM so tests can monkeypatch it
      SideEffect.peek = function peek() {
        return state;
      };

      SideEffect.rewind = function rewind() {
        if (SideEffect.canUseDOM) {
          throw new Error('You may only call rewind() on the server. Call peek() to read the current state.');
        }

        var recordedState = state;
        state = undefined;
        mountedInstances = [];
        return recordedState;
      };

      var _proto = SideEffect.prototype;

      _proto.shouldComponentUpdate = function shouldComponentUpdate(nextProps) {
        return !shallowEqual(nextProps, this.props);
      };

      _proto.componentWillMount = function componentWillMount() {
        mountedInstances.push(this);
        emitChange();
      };

      _proto.componentDidUpdate = function componentDidUpdate() {
        emitChange();
      };

      _proto.componentWillUnmount = function componentWillUnmount() {
        var index = mountedInstances.indexOf(this);
        mountedInstances.splice(index, 1);
        emitChange();
      };

      _proto.render = function render() {
        return React__default.createElement(WrappedComponent, this.props);
      };

      return SideEffect;
    }(React.Component);

    _defineProperty(SideEffect, "displayName", "SideEffect(" + getDisplayName(WrappedComponent) + ")");

    _defineProperty(SideEffect, "canUseDOM", canUseDOM);

    return SideEffect;
  };
}

module.exports = withSideEffect;


/***/ }),
/* 767 */
/***/ (function(module, exports) {

//

module.exports = function shallowEqual(objA, objB, compare, compareContext) {
  var ret = compare ? compare.call(compareContext, objA, objB) : void 0;

  if (ret !== void 0) {
    return !!ret;
  }

  if (objA === objB) {
    return true;
  }

  if (typeof objA !== "object" || !objA || typeof objB !== "object" || !objB) {
    return false;
  }

  var keysA = Object.keys(objA);
  var keysB = Object.keys(objB);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(objB);

  // Test for A's keys different from B.
  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key)) {
      return false;
    }

    var valueA = objA[key];
    var valueB = objB[key];

    ret = compare ? compare.call(compareContext, valueA, valueB, key) : void 0;

    if (ret === false || (ret === void 0 && valueA !== valueB)) {
      return false;
    }
  }

  return true;
};


/***/ }),
/* 768 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var isArray = Array.isArray;
var keyList = Object.keys;
var hasProp = Object.prototype.hasOwnProperty;
var hasElementType = typeof Element !== 'undefined';

function equal(a, b) {
  // fast-deep-equal index.js 2.0.1
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    var arrA = isArray(a)
      , arrB = isArray(b)
      , i
      , length
      , key;

    if (arrA && arrB) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    if (arrA != arrB) return false;

    var dateA = a instanceof Date
      , dateB = b instanceof Date;
    if (dateA != dateB) return false;
    if (dateA && dateB) return a.getTime() == b.getTime();

    var regexpA = a instanceof RegExp
      , regexpB = b instanceof RegExp;
    if (regexpA != regexpB) return false;
    if (regexpA && regexpB) return a.toString() == b.toString();

    var keys = keyList(a);
    length = keys.length;

    if (length !== keyList(b).length)
      return false;

    for (i = length; i-- !== 0;)
      if (!hasProp.call(b, keys[i])) return false;
    // end fast-deep-equal

    // start react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element && b instanceof Element)
      return a === b;

    // custom handling for React
    for (i = length; i-- !== 0;) {
      key = keys[i];
      if (key === '_owner' && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner.
        //  _owner contains circular references
        // and is not needed when comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of a react element
        continue;
      } else {
        // all other properties should be traversed as usual
        if (!equal(a[key], b[key])) return false;
      }
    }
    // end react-fast-compare

    // fast-deep-equal index.js 2.0.1
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

module.exports = function exportedEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if ((error.message && error.message.match(/stack|recursion/i)) || (error.number === -2146828260)) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('Warning: react-fast-compare does not handle circular references.', error.name, error.message);
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};


/***/ }),
/* 769 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(global) {exports.__esModule = true;
exports.warn = exports.requestAnimationFrame = exports.reducePropsToState = exports.mapStateOnServer = exports.handleClientStateChange = exports.convertReactPropstoHtmlAttributes = undefined;

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _objectAssign = __webpack_require__(47);

var _objectAssign2 = _interopRequireDefault(_objectAssign);

var _HelmetConstants = __webpack_require__(319);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var encodeSpecialCharacters = function encodeSpecialCharacters(str) {
    var encode = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : true;

    if (encode === false) {
        return String(str);
    }

    return String(str).replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#x27;");
};

var getTitleFromPropsList = function getTitleFromPropsList(propsList) {
    var innermostTitle = getInnermostProperty(propsList, _HelmetConstants.TAG_NAMES.TITLE);
    var innermostTemplate = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.TITLE_TEMPLATE);

    if (innermostTemplate && innermostTitle) {
        // use function arg to avoid need to escape $ characters
        return innermostTemplate.replace(/%s/g, function () {
            return innermostTitle;
        });
    }

    var innermostDefaultTitle = getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFAULT_TITLE);

    return innermostTitle || innermostDefaultTitle || undefined;
};

var getOnChangeClientState = function getOnChangeClientState(propsList) {
    return getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ON_CHANGE_CLIENT_STATE) || function () {};
};

var getAttributesFromPropsList = function getAttributesFromPropsList(tagType, propsList) {
    return propsList.filter(function (props) {
        return typeof props[tagType] !== "undefined";
    }).map(function (props) {
        return props[tagType];
    }).reduce(function (tagAttrs, current) {
        return _extends({}, tagAttrs, current);
    }, {});
};

var getBaseTagFromPropsList = function getBaseTagFromPropsList(primaryAttributes, propsList) {
    return propsList.filter(function (props) {
        return typeof props[_HelmetConstants.TAG_NAMES.BASE] !== "undefined";
    }).map(function (props) {
        return props[_HelmetConstants.TAG_NAMES.BASE];
    }).reverse().reduce(function (innermostBaseTag, tag) {
        if (!innermostBaseTag.length) {
            var keys = Object.keys(tag);

            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && tag[lowerCaseAttributeKey]) {
                    return innermostBaseTag.concat(tag);
                }
            }
        }

        return innermostBaseTag;
    }, []);
};

var getTagsFromPropsList = function getTagsFromPropsList(tagName, primaryAttributes, propsList) {
    // Calculate list of tags, giving priority innermost component (end of the propslist)
    var approvedSeenTags = {};

    return propsList.filter(function (props) {
        if (Array.isArray(props[tagName])) {
            return true;
        }
        if (typeof props[tagName] !== "undefined") {
            warn("Helmet: " + tagName + " should be of type \"Array\". Instead found type \"" + _typeof(props[tagName]) + "\"");
        }
        return false;
    }).map(function (props) {
        return props[tagName];
    }).reverse().reduce(function (approvedTags, instanceTags) {
        var instanceSeenTags = {};

        instanceTags.filter(function (tag) {
            var primaryAttributeKey = void 0;
            var keys = Object.keys(tag);
            for (var i = 0; i < keys.length; i++) {
                var attributeKey = keys[i];
                var lowerCaseAttributeKey = attributeKey.toLowerCase();

                // Special rule with link tags, since rel and href are both primary tags, rel takes priority
                if (primaryAttributes.indexOf(lowerCaseAttributeKey) !== -1 && !(primaryAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[primaryAttributeKey].toLowerCase() === "canonical") && !(lowerCaseAttributeKey === _HelmetConstants.TAG_PROPERTIES.REL && tag[lowerCaseAttributeKey].toLowerCase() === "stylesheet")) {
                    primaryAttributeKey = lowerCaseAttributeKey;
                }
                // Special case for innerHTML which doesn't work lowercased
                if (primaryAttributes.indexOf(attributeKey) !== -1 && (attributeKey === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attributeKey === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT || attributeKey === _HelmetConstants.TAG_PROPERTIES.ITEM_PROP)) {
                    primaryAttributeKey = attributeKey;
                }
            }

            if (!primaryAttributeKey || !tag[primaryAttributeKey]) {
                return false;
            }

            var value = tag[primaryAttributeKey].toLowerCase();

            if (!approvedSeenTags[primaryAttributeKey]) {
                approvedSeenTags[primaryAttributeKey] = {};
            }

            if (!instanceSeenTags[primaryAttributeKey]) {
                instanceSeenTags[primaryAttributeKey] = {};
            }

            if (!approvedSeenTags[primaryAttributeKey][value]) {
                instanceSeenTags[primaryAttributeKey][value] = true;
                return true;
            }

            return false;
        }).reverse().forEach(function (tag) {
            return approvedTags.push(tag);
        });

        // Update seen tags with tags from this instance
        var keys = Object.keys(instanceSeenTags);
        for (var i = 0; i < keys.length; i++) {
            var attributeKey = keys[i];
            var tagUnion = (0, _objectAssign2.default)({}, approvedSeenTags[attributeKey], instanceSeenTags[attributeKey]);

            approvedSeenTags[attributeKey] = tagUnion;
        }

        return approvedTags;
    }, []).reverse();
};

var getInnermostProperty = function getInnermostProperty(propsList, property) {
    for (var i = propsList.length - 1; i >= 0; i--) {
        var props = propsList[i];

        if (props.hasOwnProperty(property)) {
            return props[property];
        }
    }

    return null;
};

var reducePropsToState = function reducePropsToState(propsList) {
    return {
        baseTag: getBaseTagFromPropsList([_HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        bodyAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.BODY, propsList),
        defer: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.DEFER),
        encode: getInnermostProperty(propsList, _HelmetConstants.HELMET_PROPS.ENCODE_SPECIAL_CHARACTERS),
        htmlAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.HTML, propsList),
        linkTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.LINK, [_HelmetConstants.TAG_PROPERTIES.REL, _HelmetConstants.TAG_PROPERTIES.HREF], propsList),
        metaTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.META, [_HelmetConstants.TAG_PROPERTIES.NAME, _HelmetConstants.TAG_PROPERTIES.CHARSET, _HelmetConstants.TAG_PROPERTIES.HTTPEQUIV, _HelmetConstants.TAG_PROPERTIES.PROPERTY, _HelmetConstants.TAG_PROPERTIES.ITEM_PROP], propsList),
        noscriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.NOSCRIPT, [_HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        onChangeClientState: getOnChangeClientState(propsList),
        scriptTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.SCRIPT, [_HelmetConstants.TAG_PROPERTIES.SRC, _HelmetConstants.TAG_PROPERTIES.INNER_HTML], propsList),
        styleTags: getTagsFromPropsList(_HelmetConstants.TAG_NAMES.STYLE, [_HelmetConstants.TAG_PROPERTIES.CSS_TEXT], propsList),
        title: getTitleFromPropsList(propsList),
        titleAttributes: getAttributesFromPropsList(_HelmetConstants.ATTRIBUTE_NAMES.TITLE, propsList)
    };
};

var rafPolyfill = function () {
    var clock = Date.now();

    return function (callback) {
        var currentTime = Date.now();

        if (currentTime - clock > 16) {
            clock = currentTime;
            callback(currentTime);
        } else {
            setTimeout(function () {
                rafPolyfill(callback);
            }, 0);
        }
    };
}();

var cafPolyfill = function cafPolyfill(id) {
    return clearTimeout(id);
};

var requestAnimationFrame = typeof window !== "undefined" ? window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || rafPolyfill : global.requestAnimationFrame || rafPolyfill;

var cancelAnimationFrame = typeof window !== "undefined" ? window.cancelAnimationFrame || window.webkitCancelAnimationFrame || window.mozCancelAnimationFrame || cafPolyfill : global.cancelAnimationFrame || cafPolyfill;

var warn = function warn(msg) {
    return console && typeof console.warn === "function" && console.warn(msg);
};

var _helmetCallback = null;

var handleClientStateChange = function handleClientStateChange(newState) {
    if (_helmetCallback) {
        cancelAnimationFrame(_helmetCallback);
    }

    if (newState.defer) {
        _helmetCallback = requestAnimationFrame(function () {
            commitTagChanges(newState, function () {
                _helmetCallback = null;
            });
        });
    } else {
        commitTagChanges(newState);
        _helmetCallback = null;
    }
};

var commitTagChanges = function commitTagChanges(newState, cb) {
    var baseTag = newState.baseTag,
        bodyAttributes = newState.bodyAttributes,
        htmlAttributes = newState.htmlAttributes,
        linkTags = newState.linkTags,
        metaTags = newState.metaTags,
        noscriptTags = newState.noscriptTags,
        onChangeClientState = newState.onChangeClientState,
        scriptTags = newState.scriptTags,
        styleTags = newState.styleTags,
        title = newState.title,
        titleAttributes = newState.titleAttributes;

    updateAttributes(_HelmetConstants.TAG_NAMES.BODY, bodyAttributes);
    updateAttributes(_HelmetConstants.TAG_NAMES.HTML, htmlAttributes);

    updateTitle(title, titleAttributes);

    var tagUpdates = {
        baseTag: updateTags(_HelmetConstants.TAG_NAMES.BASE, baseTag),
        linkTags: updateTags(_HelmetConstants.TAG_NAMES.LINK, linkTags),
        metaTags: updateTags(_HelmetConstants.TAG_NAMES.META, metaTags),
        noscriptTags: updateTags(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags),
        scriptTags: updateTags(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags),
        styleTags: updateTags(_HelmetConstants.TAG_NAMES.STYLE, styleTags)
    };

    var addedTags = {};
    var removedTags = {};

    Object.keys(tagUpdates).forEach(function (tagType) {
        var _tagUpdates$tagType = tagUpdates[tagType],
            newTags = _tagUpdates$tagType.newTags,
            oldTags = _tagUpdates$tagType.oldTags;


        if (newTags.length) {
            addedTags[tagType] = newTags;
        }
        if (oldTags.length) {
            removedTags[tagType] = tagUpdates[tagType].oldTags;
        }
    });

    cb && cb();

    onChangeClientState(newState, addedTags, removedTags);
};

var flattenArray = function flattenArray(possibleArray) {
    return Array.isArray(possibleArray) ? possibleArray.join("") : possibleArray;
};

var updateTitle = function updateTitle(title, attributes) {
    if (typeof title !== "undefined" && document.title !== title) {
        document.title = flattenArray(title);
    }

    updateAttributes(_HelmetConstants.TAG_NAMES.TITLE, attributes);
};

var updateAttributes = function updateAttributes(tagName, attributes) {
    var elementTag = document.getElementsByTagName(tagName)[0];

    if (!elementTag) {
        return;
    }

    var helmetAttributeString = elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
    var helmetAttributes = helmetAttributeString ? helmetAttributeString.split(",") : [];
    var attributesToRemove = [].concat(helmetAttributes);
    var attributeKeys = Object.keys(attributes);

    for (var i = 0; i < attributeKeys.length; i++) {
        var attribute = attributeKeys[i];
        var value = attributes[attribute] || "";

        if (elementTag.getAttribute(attribute) !== value) {
            elementTag.setAttribute(attribute, value);
        }

        if (helmetAttributes.indexOf(attribute) === -1) {
            helmetAttributes.push(attribute);
        }

        var indexToSave = attributesToRemove.indexOf(attribute);
        if (indexToSave !== -1) {
            attributesToRemove.splice(indexToSave, 1);
        }
    }

    for (var _i = attributesToRemove.length - 1; _i >= 0; _i--) {
        elementTag.removeAttribute(attributesToRemove[_i]);
    }

    if (helmetAttributes.length === attributesToRemove.length) {
        elementTag.removeAttribute(_HelmetConstants.HELMET_ATTRIBUTE);
    } else if (elementTag.getAttribute(_HelmetConstants.HELMET_ATTRIBUTE) !== attributeKeys.join(",")) {
        elementTag.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, attributeKeys.join(","));
    }
};

var updateTags = function updateTags(type, tags) {
    var headElement = document.head || document.querySelector(_HelmetConstants.TAG_NAMES.HEAD);
    var tagNodes = headElement.querySelectorAll(type + "[" + _HelmetConstants.HELMET_ATTRIBUTE + "]");
    var oldTags = Array.prototype.slice.call(tagNodes);
    var newTags = [];
    var indexToDelete = void 0;

    if (tags && tags.length) {
        tags.forEach(function (tag) {
            var newElement = document.createElement(type);

            for (var attribute in tag) {
                if (tag.hasOwnProperty(attribute)) {
                    if (attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML) {
                        newElement.innerHTML = tag.innerHTML;
                    } else if (attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
                        if (newElement.styleSheet) {
                            newElement.styleSheet.cssText = tag.cssText;
                        } else {
                            newElement.appendChild(document.createTextNode(tag.cssText));
                        }
                    } else {
                        var value = typeof tag[attribute] === "undefined" ? "" : tag[attribute];
                        newElement.setAttribute(attribute, value);
                    }
                }
            }

            newElement.setAttribute(_HelmetConstants.HELMET_ATTRIBUTE, "true");

            // Remove a duplicate tag from domTagstoRemove, so it isn't cleared.
            if (oldTags.some(function (existingTag, index) {
                indexToDelete = index;
                return newElement.isEqualNode(existingTag);
            })) {
                oldTags.splice(indexToDelete, 1);
            } else {
                newTags.push(newElement);
            }
        });
    }

    oldTags.forEach(function (tag) {
        return tag.parentNode.removeChild(tag);
    });
    newTags.forEach(function (tag) {
        return headElement.appendChild(tag);
    });

    return {
        oldTags: oldTags,
        newTags: newTags
    };
};

var generateElementAttributesAsString = function generateElementAttributesAsString(attributes) {
    return Object.keys(attributes).reduce(function (str, key) {
        var attr = typeof attributes[key] !== "undefined" ? key + "=\"" + attributes[key] + "\"" : "" + key;
        return str ? str + " " + attr : attr;
    }, "");
};

var generateTitleAsString = function generateTitleAsString(type, title, attributes, encode) {
    var attributeString = generateElementAttributesAsString(attributes);
    var flattenedTitle = flattenArray(title);
    return attributeString ? "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeString + ">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">" : "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\">" + encodeSpecialCharacters(flattenedTitle, encode) + "</" + type + ">";
};

var generateTagsAsString = function generateTagsAsString(type, tags, encode) {
    return tags.reduce(function (str, tag) {
        var attributeHtml = Object.keys(tag).filter(function (attribute) {
            return !(attribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || attribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT);
        }).reduce(function (string, attribute) {
            var attr = typeof tag[attribute] === "undefined" ? attribute : attribute + "=\"" + encodeSpecialCharacters(tag[attribute], encode) + "\"";
            return string ? string + " " + attr : attr;
        }, "");

        var tagContent = tag.innerHTML || tag.cssText || "";

        var isSelfClosing = _HelmetConstants.SELF_CLOSING_TAGS.indexOf(type) === -1;

        return str + "<" + type + " " + _HelmetConstants.HELMET_ATTRIBUTE + "=\"true\" " + attributeHtml + (isSelfClosing ? "/>" : ">" + tagContent + "</" + type + ">");
    }, "");
};

var convertElementAttributestoReactProps = function convertElementAttributestoReactProps(attributes) {
    var initProps = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(attributes).reduce(function (obj, key) {
        obj[_HelmetConstants.REACT_TAG_MAP[key] || key] = attributes[key];
        return obj;
    }, initProps);
};

var convertReactPropstoHtmlAttributes = function convertReactPropstoHtmlAttributes(props) {
    var initAttributes = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    return Object.keys(props).reduce(function (obj, key) {
        obj[_HelmetConstants.HTML_TAG_MAP[key] || key] = props[key];
        return obj;
    }, initAttributes);
};

var generateTitleAsReactComponent = function generateTitleAsReactComponent(type, title, attributes) {
    var _initProps;

    // assigning into an array to define toString function on it
    var initProps = (_initProps = {
        key: title
    }, _initProps[_HelmetConstants.HELMET_ATTRIBUTE] = true, _initProps);
    var props = convertElementAttributestoReactProps(attributes, initProps);

    return [_react2.default.createElement(_HelmetConstants.TAG_NAMES.TITLE, props, title)];
};

var generateTagsAsReactComponent = function generateTagsAsReactComponent(type, tags) {
    return tags.map(function (tag, i) {
        var _mappedTag;

        var mappedTag = (_mappedTag = {
            key: i
        }, _mappedTag[_HelmetConstants.HELMET_ATTRIBUTE] = true, _mappedTag);

        Object.keys(tag).forEach(function (attribute) {
            var mappedAttribute = _HelmetConstants.REACT_TAG_MAP[attribute] || attribute;

            if (mappedAttribute === _HelmetConstants.TAG_PROPERTIES.INNER_HTML || mappedAttribute === _HelmetConstants.TAG_PROPERTIES.CSS_TEXT) {
                var content = tag.innerHTML || tag.cssText;
                mappedTag.dangerouslySetInnerHTML = { __html: content };
            } else {
                mappedTag[mappedAttribute] = tag[attribute];
            }
        });

        return _react2.default.createElement(type, mappedTag);
    });
};

var getMethodsForTag = function getMethodsForTag(type, tags, encode) {
    switch (type) {
        case _HelmetConstants.TAG_NAMES.TITLE:
            return {
                toComponent: function toComponent() {
                    return generateTitleAsReactComponent(type, tags.title, tags.titleAttributes, encode);
                },
                toString: function toString() {
                    return generateTitleAsString(type, tags.title, tags.titleAttributes, encode);
                }
            };
        case _HelmetConstants.ATTRIBUTE_NAMES.BODY:
        case _HelmetConstants.ATTRIBUTE_NAMES.HTML:
            return {
                toComponent: function toComponent() {
                    return convertElementAttributestoReactProps(tags);
                },
                toString: function toString() {
                    return generateElementAttributesAsString(tags);
                }
            };
        default:
            return {
                toComponent: function toComponent() {
                    return generateTagsAsReactComponent(type, tags);
                },
                toString: function toString() {
                    return generateTagsAsString(type, tags, encode);
                }
            };
    }
};

var mapStateOnServer = function mapStateOnServer(_ref) {
    var baseTag = _ref.baseTag,
        bodyAttributes = _ref.bodyAttributes,
        encode = _ref.encode,
        htmlAttributes = _ref.htmlAttributes,
        linkTags = _ref.linkTags,
        metaTags = _ref.metaTags,
        noscriptTags = _ref.noscriptTags,
        scriptTags = _ref.scriptTags,
        styleTags = _ref.styleTags,
        _ref$title = _ref.title,
        title = _ref$title === undefined ? "" : _ref$title,
        titleAttributes = _ref.titleAttributes;
    return {
        base: getMethodsForTag(_HelmetConstants.TAG_NAMES.BASE, baseTag, encode),
        bodyAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.BODY, bodyAttributes, encode),
        htmlAttributes: getMethodsForTag(_HelmetConstants.ATTRIBUTE_NAMES.HTML, htmlAttributes, encode),
        link: getMethodsForTag(_HelmetConstants.TAG_NAMES.LINK, linkTags, encode),
        meta: getMethodsForTag(_HelmetConstants.TAG_NAMES.META, metaTags, encode),
        noscript: getMethodsForTag(_HelmetConstants.TAG_NAMES.NOSCRIPT, noscriptTags, encode),
        script: getMethodsForTag(_HelmetConstants.TAG_NAMES.SCRIPT, scriptTags, encode),
        style: getMethodsForTag(_HelmetConstants.TAG_NAMES.STYLE, styleTags, encode),
        title: getMethodsForTag(_HelmetConstants.TAG_NAMES.TITLE, { title: title, titleAttributes: titleAttributes }, encode)
    };
};

exports.convertReactPropstoHtmlAttributes = convertReactPropstoHtmlAttributes;
exports.handleClientStateChange = handleClientStateChange;
exports.mapStateOnServer = mapStateOnServer;
exports.reducePropsToState = reducePropsToState;
exports.requestAnimationFrame = requestAnimationFrame;
exports.warn = warn;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(29)))

/***/ }),
/* 770 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _default; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_skrollr__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_skrollr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_skrollr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_scroll__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_helmet__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hoc__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_language__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_location__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_laguna_beachside__ = __webpack_require__(771);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Gallery__ = __webpack_require__(789);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Concept__ = __webpack_require__(852);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Faq__ = __webpack_require__(853);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Destination__ = __webpack_require__(854);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__TheSanctuaryclub__ = __webpack_require__(855);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Siteplan__ = __webpack_require__(856);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Masterplan__ = __webpack_require__(858);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Residences__ = __webpack_require__(860);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Ebrochure__ = __webpack_require__(861);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var page="laguna-beachside";var sections=[{key:"gallery",label:"Gallery"},{key:"concept",label:"Concept"},{key:"masterplan",label:"Master Plan"},{key:"siteplan",label:"Site Plan"},{key:"residences",label:{en:"Room Types",ru:"Типы квартир",cn:"房型"},subitem:[{// key: "studio",
// label: {
//   en: "STUDIO",
//   ru: "Студии",
//   cn: "一室公寓",
// },
key:"1-bed",label:{en:"ONE-BEDROOM",ru:"1-Спальня",cn:"1-卧室"},path:"/:language/projects/laguna-beachside/",currentSection:0},{// key: "one-bedroom",
// label: {
//   en: "1 BEDROOM",
//   ru: "Одна спальня",
//   cn: "一卧室套房",
// },
key:"2-bed",label:{en:"TWO-BEDROOM",ru:"2-Спальня",cn:"2-卧室"},path:"/:language/projects/laguna-beachside/",currentSection:1},{// key: "two-bedroom",
// label: {
//   en: "2 BEDROOM",
//   ru: "Две спальни",
//   cn: "两卧室套房",
// },
key:"3-bed",label:{en:"THREE-BEDROOM",ru:"3-Спальня",cn:"3-卧室"},path:"/:language/projects/laguna-beachside/",currentSection:2}]},{key:"destination",label:"Destination"},{key:"sanctuary-club",label:"The Santuary Club"},{key:"faq",label:"FAQ",hideOnMobile:true},{key:"e-brochure",label:"E-Brochure",hideOnMobile:true}];var mapStateToProps=function mapStateToProps(state){return Object.assign({},state);};var actionToProps={switchLanguage:__WEBPACK_IMPORTED_MODULE_7__actions_language__["a" /* switchLanguage */],switchLocation:__WEBPACK_IMPORTED_MODULE_8__actions_location__["a" /* switchLocation */],initAppLagunaBeachside:__WEBPACK_IMPORTED_MODULE_9__actions_laguna_beachside__["a" /* initAppLagunaBeachside */]};var _default=(_dec=Object(__WEBPACK_IMPORTED_MODULE_6__hoc__["b" /* withRedux */])(mapStateToProps,actionToProps),_dec(_class=function(_Component){_inherits(_default,_Component);function _default(props){_classCallCheck(this,_default);var _this=_possibleConstructorReturn(this,(_default.__proto__||Object.getPrototypeOf(_default)).call(this,props));_this.handleWheel=function(evt){if(evt.deltaY>0){var atBottomOfSection=_this.headerRef.current.atBottomOfSection();if(atBottomOfSection){evt.preventDefault();evt.stopPropagation();evt.returnValue=false;// console.log('evt', evt.deltaY);
_this.headerRef.current.handleScrollDown();}}if(evt.deltaY<0){var atTopOfSection=_this.headerRef.current.atTopOfSection();if(atTopOfSection){evt.preventDefault();evt.stopPropagation();evt.returnValue=false;// console.log('evt', evt.deltaY);
_this.headerRef.current.handleScrollUp();}}};_this.setLanguage=function(language){_this.props.actions.switchLanguage(language);};_this.setLocation=function(location){_this.props.actions.switchLocation(location);};_this.fetchData=function(){_this.props.actions.initAppLagunaBeachside();};_this.renderSectionWithId=function(component,id){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_scroll__["Element"],{name:id},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("section",{id:id},component));};_this.headerRef=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createRef();return _this;}_createClass(_default,[{key:"componentDidMount",value:function componentDidMount(){this.setLanguage(this.props.match.params.language);this.setLocation(this.props.route.key);this.fetchData();}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps){var currentLanguage=prevProps.match.params.language;var nextLanguage=this.props.match.params.language;if(currentLanguage!==nextLanguage){this.setLanguage(nextLanguage);}}},{key:"render",value:function render(){var pageData=__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(this.props,page+".data");var isMobile=__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(this.props,"device.isMobile");var currentLanguage=__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(this.props,"language.currentActive");console.log("pageData-beach",{page:page,pageData:pageData});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_skrollr__["ParallaxProvider"],{init:{smoothScrollingDuration:500,smoothScrolling:true,forceHeight:false}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_helmet__["Helmet"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("title",null,"New Beachfront Condo For sale near Phuket | Laguna Property"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("meta",{name:"description",content:"Your dream beachfront property awaits. Laguna Property is a leading and trusted property developer since 1993. Discover Phuket\u2019s newest beachfront condos on our page."}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("meta",{name:"keywords",content:"affordable condo for sale phuket,beachfront condo for sale phuket,apartment for sale near Phuket beach,condo for sale near bang tao beach,new beachfront condo phuket,new condo sales phuket,2 bedroom condos for sale phuket,1 bedroom condo for sale phuket,1 bed condo for sale phuket,2 bed condo for sale phuket"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["f" /* Header */],{mainLogo:Object(__WEBPACK_IMPORTED_MODULE_10__utils__["a" /* assetsPath */])()+"/images/logo-laguna-property.svg",subLogo:Object(__WEBPACK_IMPORTED_MODULE_10__utils__["a" /* assetsPath */])(page)+"/images/logo/logo-navbar.png",language:currentLanguage,projectSections:sections,wrappedComponentRef:this.headerRef}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"main-content laguna-beachside",disable_onWheel:this.handleWheel},this.renderSectionWithId(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Gallery__["a" /* default */],Object.assign({},__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"gallery"),{page:page})),"gallery"),this.renderSectionWithId(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Concept__["a" /* default */],{imageSlider:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"concept.imageSlider"),content:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"concept.content"),page:page}),"concept"),this.renderSectionWithId(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Masterplan__["a" /* default */],{map:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"masterPlan.maps"),page:page}),"masterplan"),this.renderSectionWithId(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Siteplan__["a" /* default */],{map:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"sitePlan.maps"),dataSitePlan:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"sitePlan.type"),subTabs:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"sitePlan.subTabs"),descriptions:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"sitePlan.descriptions"),page:page}),"siteplan"),this.renderSectionWithId(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Residences__["a" /* default */],{landingPage:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"residence.landingPage"),type:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"residence.type"),page:page}),"residences"),this.renderSectionWithId(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Destination__["a" /* default */],{isMobile:isMobile,imageSlider:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"destination.landingPage"),title:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"destination.content.title"),description:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"destination.content.description"),mapData:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"destination.map"),page:page}),"destination"),this.renderSectionWithId(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__TheSanctuaryclub__["a" /* default */],{description:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"sanctuaryClub.description"),image:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"sanctuaryClub.image"),title:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"sanctuaryClub.title"),page:page}),"sanctuary-club"),this.renderSectionWithId(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Faq__["a" /* default */],Object.assign({},__webpack_require__(862),{page:page})),"faq"),this.renderSectionWithId(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Ebrochure__["a" /* default */],{location:"phuket",project:"laguna-beachside",page:page}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["d" /* Footer */],null)),"e-brochure"))));}}]);return _default;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class);

/***/ }),
/* 771 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return initAppLagunaBeachside; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_reduce__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_reduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_reduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actionType__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_laguna_beachside__ = __webpack_require__(774);
var _this=this;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var initAppLagunaBeachside=function initAppLagunaBeachside(){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch){var listApi,apiResult,mapData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:listApi=[];_context.t0=listApi;_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_3__services_laguna_beachside__["c" /* fetchGalleryApi */])();case 4:_context.t1=_context.sent;_context.t2={key:"gallery",data:_context.t1};_context.t0.push.call(_context.t0,_context.t2);_context.t3=listApi;_context.next=10;return Object(__WEBPACK_IMPORTED_MODULE_3__services_laguna_beachside__["a" /* fetchConceptApi */])();case 10:_context.t4=_context.sent;_context.t5={key:"concept",data:_context.t4};_context.t3.push.call(_context.t3,_context.t5);_context.t6=listApi;_context.next=16;return Object(__WEBPACK_IMPORTED_MODULE_3__services_laguna_beachside__["d" /* fetchMasterPlanApi */])();case 16:_context.t7=_context.sent;_context.t8={key:"masterPlan",data:_context.t7};_context.t6.push.call(_context.t6,_context.t8);_context.t9=listApi;_context.next=22;return Object(__WEBPACK_IMPORTED_MODULE_3__services_laguna_beachside__["g" /* fetchSitePlanApi */])();case 22:_context.t10=_context.sent;_context.t11={key:"sitePlan",data:_context.t10};_context.t9.push.call(_context.t9,_context.t11);_context.t12=listApi;_context.next=28;return Object(__WEBPACK_IMPORTED_MODULE_3__services_laguna_beachside__["e" /* fetchResidenceApi */])();case 28:_context.t13=_context.sent;_context.t14={key:"residence",data:_context.t13};_context.t12.push.call(_context.t12,_context.t14);_context.t15=listApi;_context.next=34;return Object(__WEBPACK_IMPORTED_MODULE_3__services_laguna_beachside__["b" /* fetchDestinationApi */])();case 34:_context.t16=_context.sent;_context.t17={key:"destination",data:_context.t16};_context.t15.push.call(_context.t15,_context.t17);_context.t18=listApi;_context.next=40;return Object(__WEBPACK_IMPORTED_MODULE_3__services_laguna_beachside__["f" /* fetchSanctuaryClubApi */])();case 40:_context.t19=_context.sent;_context.t20={key:"sanctuaryClub",data:_context.t19};_context.t18.push.call(_context.t18,_context.t20);_context.prev=43;_context.next=46;return Promise.all(listApi);case 46:apiResult=_context.sent;mapData=__WEBPACK_IMPORTED_MODULE_1_lodash_reduce___default()(apiResult,function(result,value,index){var key=value.key,data=value.data;return Object.assign({},result,_defineProperty({},key,data));},{});dispatch({type:__WEBPACK_IMPORTED_MODULE_2__actionType__["c" /* RECEIVE_LAGUNA_BEACHSIDE */],data:mapData});_context.next=54;break;case 51:_context.prev=51;_context.t21=_context["catch"](43);console.error("initAppLagunaBeachside err",_context.t21);case 54:case"end":return _context.stop();}}},_callee,_this,[[43,51]]);}));return function(_x){return _ref.apply(this,arguments);};}();};

/***/ }),
/* 772 */
/***/ (function(module, exports) {

/**
 * A specialized version of `_.reduce` for arrays without support for
 * iteratee shorthands.
 *
 * @private
 * @param {Array} [array] The array to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} [accumulator] The initial value.
 * @param {boolean} [initAccum] Specify using the first element of `array` as
 *  the initial value.
 * @returns {*} Returns the accumulated value.
 */
function arrayReduce(array, iteratee, accumulator, initAccum) {
  var index = -1,
      length = array == null ? 0 : array.length;

  if (initAccum && length) {
    accumulator = array[++index];
  }
  while (++index < length) {
    accumulator = iteratee(accumulator, array[index], index, array);
  }
  return accumulator;
}

module.exports = arrayReduce;


/***/ }),
/* 773 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.reduce` and `_.reduceRight`, without support
 * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function} iteratee The function invoked per iteration.
 * @param {*} accumulator The initial value.
 * @param {boolean} initAccum Specify using the first or last element of
 *  `collection` as the initial value.
 * @param {Function} eachFunc The function to iterate over `collection`.
 * @returns {*} Returns the accumulated value.
 */
function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
  eachFunc(collection, function(value, index, collection) {
    accumulator = initAccum
      ? (initAccum = false, value)
      : iteratee(accumulator, value, index, collection);
  });
  return accumulator;
}

module.exports = baseReduce;


/***/ }),
/* 774 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchGalleryApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchConceptApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchMasterPlanApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return fetchSitePlanApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fetchResidenceApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchDestinationApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fetchSanctuaryClubApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_LagunaBeachside_gallery__ = __webpack_require__(775);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_LagunaBeachside_concept__ = __webpack_require__(776);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_LagunaBeachside_masterplan__ = __webpack_require__(777);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_LagunaBeachside_sitePlan__ = __webpack_require__(778);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_LagunaBeachside_residence__ = __webpack_require__(786);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_LagunaBeachside_destination__ = __webpack_require__(787);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_LagunaBeachside_sanctuaryClub__ = __webpack_require__(788);
var fetchGalleryApi=function fetchGalleryApi(){return Promise.resolve(__WEBPACK_IMPORTED_MODULE_0__data_LagunaBeachside_gallery__["a" /* default */]);};var fetchConceptApi=function fetchConceptApi(){return Promise.resolve(__WEBPACK_IMPORTED_MODULE_1__data_LagunaBeachside_concept__["a" /* default */]);};var fetchMasterPlanApi=function fetchMasterPlanApi(){return Promise.resolve(__WEBPACK_IMPORTED_MODULE_2__data_LagunaBeachside_masterplan__["a" /* default */]);};var fetchSitePlanApi=function fetchSitePlanApi(){return Promise.resolve(__WEBPACK_IMPORTED_MODULE_3__data_LagunaBeachside_sitePlan__["a" /* default */]);};var fetchResidenceApi=function fetchResidenceApi(){return Promise.resolve(__WEBPACK_IMPORTED_MODULE_4__data_LagunaBeachside_residence__["a" /* default */]);};var fetchDestinationApi=function fetchDestinationApi(){return Promise.resolve(__WEBPACK_IMPORTED_MODULE_5__data_LagunaBeachside_destination__["a" /* default */]);};var fetchSanctuaryClubApi=function fetchSanctuaryClubApi(){return Promise.resolve(__WEBPACK_IMPORTED_MODULE_6__data_LagunaBeachside_sanctuaryClub__["a" /* default */]);};

/***/ }),
/* 775 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_find__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components__ = __webpack_require__(6);
var baseAssetUrl=Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])("laguna-beachside");var baseAssetVideoUrl=baseAssetUrl+"/videos";// const residencesCommonArea1 = `${baseAssetUrl}/images/gallery/images/residences-common-area/1.jpg`;
// const heroShotImg2_dev = `${assetsPath(
//   "laguna-beachside"
// )}/images/gallery/hero-shot/dev-1.jpg`;
// const heroShotImg4_dev = `${assetsPath(
//   "laguna-beachside"
// )}/images/gallery/hero-shot/dev-2.jpg`;
// const heroShotImg5_dev = `${assetsPath(
//   "laguna-beachside"
// )}/images/gallery/hero-shot/dev-3.jpg`;
var heroShotImg1=Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])("laguna-beachside")+"/images/gallery/hero-shot/1.jpg";var heroShotImg2=Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])("laguna-beachside")+"/images/gallery/hero-shot/2.jpg";var heroShotImg3=Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])("laguna-beachside")+"/images/gallery/hero-shot/3.jpg";var heroShotImg4=Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])("laguna-beachside")+"/images/gallery/hero-shot/4.jpg";var heroShotImg5=Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])("laguna-beachside")+"/images/gallery/hero-shot/5.jpg";var heroShotImg6=Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])("laguna-beachside")+"/images/gallery/hero-shot/6.jpg";var heroShotImg7=Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])("laguna-beachside")+"/images/gallery/hero-shot/7.jpg";var heroShotImg8=Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])("laguna-beachside")+"/images/gallery/hero-shot/8.jpg";var destinationLifestyle1=Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])("laguna-beachside")+"/images/gallery/images/destination-lifestyle/1.jpg";var destinationLifestyle2=Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])("laguna-beachside")+"/images/gallery/images/destination-lifestyle/2.jpg";var destinationLifestyle3=Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])("laguna-beachside")+"/images/gallery/images/destination-lifestyle/3.jpg";var destinationLifestyle4=Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])("laguna-beachside")+"/images/gallery/images/destination-lifestyle/4.jpg";var destinationLifestyle5=Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])("laguna-beachside")+"/images/gallery/images/destination-lifestyle/5.jpg";var destinationLifestyle6=Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])("laguna-beachside")+"/images/gallery/images/destination-lifestyle/6.jpg";var destinationLifestyle7=Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])("laguna-beachside")+"/images/gallery/images/destination-lifestyle/7.jpg";var residencesAerial1=Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])("laguna-beachside")+"/images/gallery/images/residences-aerial/1.jpg";var residencesAerial2=Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])("laguna-beachside")+"/images/gallery/images/residences-aerial/2.jpg";var residencesAerial3=Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])("laguna-beachside")+"/images/gallery/images/residences-aerial/3.jpg";var residencesCommonArea1=Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])("laguna-beachside")+"/images/gallery/images/residences-common-area/1.jpg";var residencesCommonArea2=Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])("laguna-beachside")+"/images/gallery/images/residences-common-area/2.jpg";var residencesExterior1=Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])("laguna-beachside")+"/images/gallery/images/residences-exterior/1.jpg";var residencesExterior2=Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])("laguna-beachside")+"/images/gallery/images/residences-exterior/2.jpg";var residencesExterior3=Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])("laguna-beachside")+"/images/gallery/images/residences-exterior/3.jpg";var residencesExterior4=Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])("laguna-beachside")+"/images/gallery/images/residences-exterior/4.jpg";var residencesInterior1=Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])("laguna-beachside")+"/images/gallery/images/residences-interior/1.jpg";var residencesInterior2=Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])("laguna-beachside")+"/images/gallery/images/residences-interior/2.jpg";var residencesInterior3=Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])("laguna-beachside")+"/images/gallery/images/residences-interior/3.jpg";var residencesInterior4=Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])("laguna-beachside")+"/images/gallery/images/residences-interior/4.jpg";var residencesInterior5=Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])("laguna-beachside")+"/images/gallery/images/residences-interior/5.jpg";var residencesInterior6=Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])("laguna-beachside")+"/images/gallery/images/residences-interior/6.jpg";var residencesInterior7=Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])("laguna-beachside")+"/images/gallery/images/residences-interior/7.jpg";var residencesInterior8=Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])("laguna-beachside")+"/images/gallery/images/residences-interior/8.jpg";var residencesLifestyle1=Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])("laguna-beachside")+"/images/gallery/images/residences-lifestyle/1.jpg";// const video = {
//   en: `${baseAssetVideoUrl}/Laguna_Park_2_3D_flythrough_ENG_w-disclaimer_Comp.mp4`,
//   ru: `${baseAssetVideoUrl}/Laguna_Park_2_3D_flythrough_Trilingual_Comp.mp4`,
//   cn: `${baseAssetVideoUrl}/Laguna_Park_2_3D_flythrough_Trilingual_Comp.mp4`,
// };
var videoSource=Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])("laguna-beachside")+"/images/gallery/video/LBS video.mp4";// const video = `${assetsPath(
//   "laguna-beachside"
// )}/images/gallery/video/1.jpg`;
var video={en:videoSource,ru:videoSource,cn:videoSource};var videos=[{titleKey:"propertyVideo",source:{en:Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])("phuket-laguna-park-2")+"/video/LP2_2_16x9_EN_Compress.mp4",ru:Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])("phuket-laguna-park-2")+"/video/LP2_2_16x9_EN_Compress.mp4",cn:Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])("phuket-laguna-park-2")+"/video/LP2_2_16x9_EN_Compress.mp4"// en: `${baseAssetVideoUrl}/Laguna_Park_2_3D_flythrough_ENG_w-disclaimer_Comp.mp4`,
// cn: `${baseAssetVideoUrl}/Laguna_Park_2_3D_flythrough_Trilingual_Comp.mp4`,
// ru: `${baseAssetVideoUrl}/Laguna_Park_2_3D_flythrough_Trilingual_Comp.mp4`,
},text:{en:["PROPERTY VIDEO"],cn:["项目视频"],ru:["ВИДЕО ПРОЕКТА"]}},{titleKey:"interiorTownHomeVideo",source:{en:Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])("phuket-laguna-park-2")+"/images/gallery/video/2.jpg",ru:Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])("phuket-laguna-park-2")+"/images/gallery/video/2.jpg",cn:Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])("phuket-laguna-park-2")+"/images/gallery/video/2.jpg"// en: `${baseAssetVideoUrl}/Laguna_Park_2_TH_Interior_Video_V.3_17062020.mp4`,
// cn: `${baseAssetVideoUrl}/Laguna_Park_2_TH_Interior_Video_V.3_17062020.mp4`,
// ru: `${baseAssetVideoUrl}/Laguna_Park_2_TH_Interior_Video_V.3_17062020.mp4`,
},text:{en:["TOWNHOME"],cn:["联排别墅"],ru:["ТАУНХАУСЫ"]}},{titleKey:"interiorVillaVideo",source:{en:Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])("phuket-laguna-park-2")+"/images/gallery/video/3.jpg",ru:Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])("phuket-laguna-park-2")+"/images/gallery/video/3.jpg",cn:Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])("phuket-laguna-park-2")+"/images/gallery/video/3.jpg"// en: `${baseAssetVideoUrl}/Laguna_Park_2_Villa_Interior_Video_V.3_17062020.mp4`,
// cn: `${baseAssetVideoUrl}/Laguna_Park_2_Villa_Interior_Video_V.3_17062020.mp4`,
// ru: `${baseAssetVideoUrl}/Laguna_Park_2_Villa_Interior_Video_V.3_17062020.mp4`,
},text:{en:["SEMI-DETACHED"],cn:["双拼别墅"],ru:["Дуплекс"]}}];var heroShot=[{image:heroShotImg1},{image:heroShotImg2},{image:heroShotImg3},{image:heroShotImg4},{image:heroShotImg5},{image:heroShotImg6},{image:heroShotImg7},{image:heroShotImg8}];var categories=[{id:1,name:"All Images"},{id:2,name:"Residences – Aerial"},{id:3,name:"Residences – Exterior"},{id:4,name:"Residences – Interior"},{id:5,name:"Residences – Common Area"},{id:6,name:"Residences – Lifestyle"},{id:7,name:"Destination Lifestyle"}];var images=[{categoryId:2,name:"Aerial – 1",image:residencesAerial1},{categoryId:2,name:"Aerial – 2",image:residencesAerial2},{categoryId:2,name:"Aerial – 3",image:residencesAerial3},{categoryId:3,name:"Building 1",image:residencesExterior1},{categoryId:3,name:"Building 2",image:residencesExterior2},{categoryId:3,name:"Building 3",image:residencesExterior3},{categoryId:3,name:"Building 4",image:residencesExterior4},{categoryId:4,name:"1 Bedroom - Living room",image:residencesInterior1},{categoryId:4,name:"2 Bedroom - Living room",image:residencesInterior2},{categoryId:4,name:"2 Bedroom - Lanai",image:residencesInterior3},{categoryId:4,name:"2 Bedroom - Section",image:residencesInterior4},{categoryId:4,name:"3 Bedroom - Living room",image:residencesInterior5},{categoryId:4,name:"3 Bedroom - Lanai",image:residencesInterior6},{categoryId:4,name:"2 bedroom - garden",image:residencesInterior7},{categoryId:4,name:"3 bedroom - garden",image:residencesInterior8},{categoryId:5,name:"Rooftop Pool",image:residencesCommonArea1},{categoryId:5,name:"Rooftop Facilities",image:residencesCommonArea2},{categoryId:6,name:"Lifestyle",image:residencesLifestyle1},{categoryId:7,name:"destination - 1",image:destinationLifestyle1},{categoryId:7,name:"destination - 2",image:destinationLifestyle2},{categoryId:7,name:"destination - 3",image:destinationLifestyle3},{categoryId:7,name:"destination - 4",image:destinationLifestyle4},{categoryId:7,name:"destination - 5",image:destinationLifestyle5},{categoryId:7,name:"destination - 6",image:destinationLifestyle6},{categoryId:7,name:"destination - 7",image:destinationLifestyle7}];var image360=null;/* harmony default export */ __webpack_exports__["a"] = ({heroShot:heroShot,categories:categories,images:__WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(images,function(image){return Object.assign({},image,{category:__WEBPACK_IMPORTED_MODULE_0_lodash_find___default()(categories,{id:image.categoryId})});}),video:video,// videos,
image360:image360,view360:[{id:"AERIAL",type:"virtual-tour",// src: (
//   <iframe
//     width="100%"
//     height="100%"
//     src={`${assetsPath(
//       "laguna-beachside"
//     )}/images/gallery/virtual-tour/aerial/LBS-Aerial-VTR-Final-20Dec2021.html`}
//     frameborder="0"
//     allowfullscreen
//     allow="vr"
//   ></iframe>
// ),
src:Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])("laguna-beachside")+"/360/aerial/LBS-Aerial.html",// src: `${assetsPath(
//   "laguna-beachside"
// )}/images/gallery/virtual-tour/aerial/LBS-Aerial-VTR-Final-20Dec2021.html`,
list:[]},{id:"INTERIOR",type:"virtual-tour",src:Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])("laguna-beachside")+"/360/interior/tour.html"// type: "list",
// src: `${assetsPath(
//   "laguna-beachside"
// )}/images/gallery/virtual-tour/1.jpg`,
// list: [],
}]});

/***/ }),
/* 776 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(2);
var img1=Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])("laguna-beachside")+"/images/concept/1.jpg";var img2=Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])("laguna-beachside")+"/images/concept/2.jpg";var img3=Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])("laguna-beachside")+"/images/concept/3.jpg";var img4=Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])("laguna-beachside")+"/images/concept/4.jpg";var imageSlider=[{image:img1},{image:img2},{image:img3},{image:img4}];var content={en:"<h2 style=\"text-align: center;margin-top: 20px;\">LAGUNA BEACHSIDE - CAREFREE COASTAL LIFESTYLE</h2>\n    <p>Located within Laguna Phuket within a few short steps to Bangtao Beach, Laguna Beachside is the newest address in Asia\u2019s finest integrated resort.</p>\n    <br />\n    <p>The development is ideally positioned just a few metres from the beach itself and features a dedicated beach area which offers owners the best seats in the house to enjoy the stunning sunset over the light-speckled waters of the Andaman Sea.</p>\n    <br />\n    <p>A unique rooftop recreation area connecting all four low-rise buildings of Laguna Beachside provides a communal space for residents to enjoy the tropical outdoors, enriching their lifestyle, and adding to the development\u2019s carefree beach resort vibe.</p>\n    <br />\n    <p>Ideal for the modern lifestyle, the 1- to 3-bedroom condominium units at Laguna Beachside start at a spacious 59 sqm. The larger 2- and 3-bedroom units are designed to enjoy maximum panoramic views from their respective full width lanai. The unique semi-outdoor lanai feature provides additional living space, which can be opened up to extend the balcony for relaxed outdoor living, or closed off with an optional glass screen to increase interior floor space.</p>\n    <br />\n    <p>A choice of fit-out options offers the flexibility for owners to customise their own living area, or choose a fully furnished option for the ultimate convenience.</p>",cn:"<h2 style=\"text-align: center;margin-top: 40px;\">\u60A6\u6D77\u82D1 - \u65E0\u5FE7\u65E0\u8651\u7684\u6D77\u6EE8\u751F\u6D3B\u65B9\u5F0F</h2>\n    <p>\u5168\u65B0\u7684\u60A6\u6D77\u82D1\u4F4D\u4E8E\u666E\u5409\u4E50\u53E4\u6D6A\uFF0C\u5730\u5904\u4E9A\u6D32\u4E00\u6D41\u7684\u7EFC\u5408\u5EA6\u5047\u80DC\u5730\uFF0C\u8DDD\u79BB\u90A6\u6D9B\u6D77\u6EE9\u51E0\u6B65\u4E4B\u9065\u3002</p>\n    <br />\n    <p>\u8BE5\u9879\u76EE\u4F4D\u7F6E\u4F18\u8D8A\uFF0C\u8DDD\u79BB\u6D77\u6EE9\u53EA\u6709\u6570\u7C73\uFF0C\u62E5\u6709\u4E00\u4E2A\u4E13\u5C5E\u6D77\u6EE9\u533A\uFF0C\u4E1A\u4E3B\u53EF\u4EE5\u5750\u5728\u6700\u597D\u7684\u4F4D\u7F6E\u6B23\u8D4F\u5B89\u8FBE\u66FC\u6D77\u7CBC\u7CBC\u6C34\u9762\u4E0A\u7684\u58EE\u89C2\u65E5\u843D\u3002</p>\n    <br />\n    <p>\u72EC\u7279\u7684\u5C4B\u9876\u5A31\u4E50\u533A\u8FDE\u63A5\u7740\u60A6\u6D77\u82D1\u7684\u6240\u6709\u56DB\u680B\u4F4E\u5C42\u5EFA\u7B51\uFF0C\u4E3A\u5C45\u6C11\u63D0\u4F9B\u4E00\u4E2A\u4EAB\u53D7\u70ED\u5E26\u6237\u5916\u73AF\u5883\u7684\u516C\u5171\u7A7A\u95F4\uFF0C\u4E30\u5BCC\u4EBA\u4EEC\u7684\u751F\u6D3B\u65B9\u5F0F\uFF0C\u4E3A\u9879\u76EE\u8425\u9020\u65E0\u5FE7\u65E0\u8651\u7684\u6D77\u6EE9\u5EA6\u5047\u6C1B\u56F4\u3002</p>\n    <br />\n    <p>\u60A6\u6D77\u82D1\u7684\u4E00\u81F3\u4E09\u5367\u5BA4\u516C\u5BD3\u662F\u73B0\u4EE3\u751F\u6D3B\u65B9\u5F0F\u7684\u7406\u60F3\u9009\u62E9\uFF0C\u9762\u79EF\u4E3A59\u5E73\u65B9\u7C73\u8D77\uFF0C\u7A7A\u95F4\u5BBD\u655E\u3002\u66F4\u5927\u7684\u4E24\u5367\u5BA4\u548C\u4E09\u5367\u5BA4\u5355\u5143\u53EF\u4ECE\u5404\u81EA\u7684\u5168\u5BBD\u5916\u5ECA\u6B23\u8D4F\u5230\u5F00\u9614\u7684\u5168\u666F\u3002\u72EC\u7279\u7684\u534A\u9732\u5929\u5916\u5ECA\u63D0\u4F9B\u989D\u5916\u7684\u8D77\u5C45\u7A7A\u95F4\uFF0C\u53EF\u4EE5\u8BA9\u5176\u4FDD\u6301\u5F00\u653E\u4EE5\u6269\u5C55\u9633\u53F0\uFF0C\u5C3D\u4EAB\u4F11\u95F2\u6237\u5916\u751F\u6D3B\uFF0C\u6216\u9009\u7528\u73BB\u7483\u9694\u65AD\u5C01\u95ED\u4EE5\u589E\u52A0\u5BA4\u5185\u7A7A\u95F4\u3002</p>\n    <br />\n    <p>\u53EF\u9009\u7684\u88C5\u4FEE\u65B9\u6848\u4E3A\u4E1A\u4E3B\u5E26\u6765\u4E2A\u6027\u5B9A\u5236\u8D77\u5C45\u533A\u7684\u7075\u6D3B\u6027\uFF0C\u6216\u9009\u62E9\u5168\u88C5\u5168\u914D\u65B9\u6848\u4EE5\u4EAB\u53D7\u7EC8\u6781\u4FBF\u5229\u3002</p>",ru:"<h2 style=\"text-align: center;margin-top: 40px;\">Laguna Beachside - \u0411\u0435\u0437\u0437\u0430\u0431\u043E\u0442\u043D\u0430\u044F \u0436\u0438\u0437\u043D\u044C \u043D\u0430 \u043F\u043E\u0431\u0435\u0440\u0435\u0436\u044C\u0435</h2>\n    <p>Laguna Beachside \u2014 \u044D\u0442\u043E \u043D\u043E\u0432\u044B\u0439 \u0436\u0438\u043B\u043E\u0439 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0441 \u0432 \u041B\u0430\u0433\u0443\u043D\u0430 \u041F\u0445\u0443\u043A\u0435\u0442 \u2013 \u0432  \u043B\u0443\u0447\u0448\u0435\u043C \u0438\u043D\u0442\u0435\u0433\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u043C \u043A\u0443\u0440\u043E\u0440\u0442\u0435 \u0410\u0437\u0438\u0438  \u0438 \u0432 \u0448\u0430\u0433\u043E\u0432\u043E\u0439 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E\u0441\u0442\u0438 \u043E\u0442 \u043F\u043B\u044F\u0436\u0430 \u0411\u0430\u043D\u0433\u0442\u0430\u043E.</p>\n    <br />\n    <p>\u0416\u0438\u043B\u043E\u0439 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0441 \u0438\u0434\u0435\u0430\u043B\u044C\u043D\u043E \u0440\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D \u0432\u0441\u0435\u0433\u043E \u0432 \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u0438\u0445 \u043C\u0435\u0442\u0440\u0430\u0445 \u043E\u0442 \u043F\u043B\u044F\u0436\u0430 \u0438 \u0432\u043A\u043B\u044E\u0447\u0430\u0435\u0442 \u043E\u0442\u0434\u0435\u043B\u044C\u043D\u0443\u044E \u043F\u043B\u044F\u0436\u043D\u0443\u044E \u0437\u043E\u043D\u0443, \u043E\u0442\u043A\u0443\u0434\u0430 \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u044B \u043C\u043E\u0433\u0443\u0442 \u043D\u0430\u0441\u043B\u0430\u0434\u0438\u0442\u044C\u0441\u044F \u043B\u0443\u0447\u0448\u0438\u043C\u0438 \u0432\u0438\u0434\u0430\u043C\u0438 \u043D\u0430 \u0437\u0430\u043A\u0430\u0442 \u0441\u043E\u043B\u043D\u0446\u0430 \u043D\u0430\u0434 \u0438\u0441\u043A\u0440\u044F\u0449\u0438\u043C\u0438\u0441\u044F \u0432\u043E\u0434\u0430\u043C\u0438 \u0410\u043D\u0434\u0430\u043C\u0430\u043D\u0441\u043A\u043E\u0433\u043E \u043C\u043E\u0440\u044F.</p>\n    <br />\n    <p>\u041D\u0430 \u043A\u0440\u044B\u0448\u0435 \u0432\u0441\u0435\u0445 \u0447\u0435\u0442\u044B\u0440\u0435\u0445 \u043C\u0430\u043B\u043E\u044D\u0442\u0430\u0436\u043D\u044B\u0445 \u0437\u0434\u0430\u043D\u0438\u0439 Laguna Beachside \u0440\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0430 \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u0430\u044F \u0437\u043E\u043D\u0430 \u043E\u0431\u0449\u0435\u0433\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F, \u0433\u0434\u0435 \u0436\u0438\u0442\u0435\u043B\u0438 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0441\u0430 \u043C\u043E\u0433\u0443\u0442 \u043E\u0442\u0434\u043E\u0445\u043D\u0443\u0442\u044C \u043D\u0430 \u043E\u0442\u043A\u0440\u044B\u0442\u043E\u043C \u0432\u043E\u0437\u0434\u0443\u0445\u0435 \u0441\u0440\u0435\u0434\u0438 \u0442\u0440\u043E\u043F\u0438\u043A\u043E\u0432, \u0440\u0430\u0437\u043D\u043E\u043E\u0431\u0440\u0430\u0437\u044F \u0441\u0432\u043E\u0439 \u043E\u0431\u0440\u0430\u0437 \u0436\u0438\u0437\u043D\u0438 \u0438 \u0432\u043D\u043E\u0441\u044F \u0432\u043A\u043B\u0430\u0434 \u0432 \u043E\u0436\u0438\u0432\u043B\u0435\u043D\u043D\u0443\u044E \u0438 \u0431\u0435\u0437\u0437\u0430\u0431\u043E\u0442\u043D\u0443\u044E \u0430\u0442\u043C\u043E\u0441\u0444\u0435\u0440\u0443 \u043F\u043B\u044F\u0436\u043D\u043E\u0433\u043E \u043A\u0443\u0440\u043E\u0440\u0442\u0430.</p>\n    <br />\n    <p>\u041A\u0432\u0430\u0440\u0442\u0438\u0440\u044B \u0441 \u043E\u0434\u043D\u043E\u0439, \u0434\u0432\u0443\u043C\u044F \u0438\u043B\u0438 \u0442\u0440\u0435\u043C\u044F \u0441\u043F\u0430\u043B\u044C\u043D\u044F\u043C\u0438 \u0432 \u0436\u0438\u043B\u043E\u043C \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0441\u0435 Laguna Beachside \u0438\u0434\u0435\u0430\u043B\u044C\u043D\u043E \u043F\u043E\u0434\u0445\u043E\u0434\u044F\u0442 \u0434\u043B\u044F \u0441\u043E\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E\u0433\u043E \u043E\u0431\u0440\u0430\u0437\u0430 \u0436\u0438\u0437\u043D\u0438. \u0418\u0445 \u043F\u043B\u043E\u0449\u0430\u0434\u044C \u043D\u0430\u0447\u0438\u043D\u0430\u0435\u0442\u0441\u044F \u043E\u0442 59 \u043A\u0432. \u043C. \u041F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u043A\u0430 \u043A\u0432\u0430\u0440\u0442\u0438\u0440 \u0441 \u0434\u0432\u0443\u043C\u044F \u0438 \u0442\u0440\u0435\u043C\u044F \u0441\u043F\u0430\u043B\u044C\u043D\u044F\u043C\u0438 \u043F\u043E\u0437\u0432\u043E\u043B\u044F\u0435\u0442 \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u043E \u043D\u0430\u0441\u043B\u0430\u0436\u0434\u0430\u0442\u044C\u0441\u044F \u043F\u0430\u043D\u043E\u0440\u0430\u043C\u043D\u044B\u043C\u043D\u044B\u043C\u0438 \u0432\u0438\u0434\u0430\u043C\u0438 \u0441 \u0438\u0445 \u043F\u0440\u043E\u0441\u0442\u043E\u0440\u043D\u044B\u0445 \u0432\u0435\u0440\u0430\u043D\u0434. \u0411\u043B\u0430\u0433\u043E\u0434\u0430\u0440\u044F \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u043E\u0439 \u043F\u043E\u043B\u0443\u043E\u0442\u043A\u0440\u044B\u0442\u043E\u0439 \u0432\u0435\u0440\u0430\u043D\u0434\u0435 \u043E\u0431\u0435\u0441\u043F\u0435\u0447\u0438\u0432\u0430\u0435\u0442\u0441\u044F \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u0436\u0438\u043B\u043E\u0435 \u043F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u0441\u0442\u0432\u043E, \u043A\u043E\u0442\u043E\u0440\u043E\u0435 \u043C\u043E\u0436\u043D\u043E \u043E\u0441\u0442\u0430\u0432\u0438\u0442\u044C \u043E\u0442\u043A\u0440\u044B\u0442\u044B\u043C \u0434\u043B\u044F \u0440\u0430\u0441\u0448\u0438\u0440\u0435\u043D\u0438\u044F \u0431\u0430\u043B\u043A\u043E\u043D\u0430 \u0438 \u043D\u0430\u0441\u043B\u0430\u0436\u0434\u0430\u0442\u044C\u0441\u044F \u0436\u0438\u0437\u043D\u044C\u044E \u043D\u0430 \u0441\u0432\u0435\u0436\u0435\u043C \u0432\u043E\u0437\u0434\u0443\u0445\u0435, \u0438\u043B\u0438 \u0436\u0435 \u043E\u0441\u0442\u0435\u043A\u043B\u0438\u0442\u044C \u0434\u043B\u044F \u0443\u0432\u0435\u043B\u0438\u0447\u0435\u043D\u0438\u044F \u043F\u043B\u043E\u0449\u0430\u0434\u0438 \u0432\u043D\u0443\u0442\u0440\u0435\u043D\u043D\u0435\u0433\u043E \u043F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u0441\u0442\u0432\u0430.</p>\n    <br />\n    <p>\u0412\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u044B \u043C\u043E\u0433\u0443\u0442 \u0432\u043E\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C\u0441\u044F \u0440\u044F\u0434\u043E\u043C \u0438\u043D\u0434\u0438\u0432\u0438\u0434\u0443\u0430\u043B\u044C\u043D\u044B\u0445 \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u043E\u0432 \u043E\u0431\u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0430 \u043A\u0432\u0430\u0440\u0442\u0438\u0440\u044B \u0438\u043B\u0438 \u0432\u044B\u0431\u0440\u0430\u0442\u044C \u043F\u043E\u043B\u043D\u043E\u0441\u0442\u044C\u044E \u043E\u0431\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043D\u044B\u0439 \u0432\u0430\u0440\u0438\u0430\u043D\u0442.</p>"};// const content = {
//   en:
//     `<p>Nestled amongst tropical greenery in a gated estate, the Laguna Park 2 has brand new, 2 and 3-bedroom townhomes for sale. They are located adjacent to Laguna Phuket, the 1,000-acre integrated resort complex along a three-kilometre stretch of pristine beach at Bang Tao Bay.</p><p>The contemporary-styled townhomes and villas provide spacious living areas in a secure, gated environment which will include 24-hour security, recreational and communal facilities and professional property management services by Laguna Property.</p><h2>Live in Harmony with Nature</h2><p>Our 2 and 3-bedroom townhouses offer plenty of light and space with floor to ceiling windows and sliding doors, a spacious garden area and a rooftop terrace. These work in concert to provide you with the sense of combining the outdoors and indoors into one environment offering spaciousness in harmony with nature. Our 3-bedroom townhomes offer an average of 220 sqm of space in which to live and entertain.</p><p>The enclosed yard provides plenty of safe space for children to play and adults to entertain or lounge amid the lush, tropical greenery with mature trees. Indoors, you’ll enjoy a clean, contemporary, airy design with all the modern conveniences.</p><h2>Enjoy a Laguna Phuket Lifestyle</h2><p>Residents will be able to enjoy all the amenities and communal facilities of the famed Laguna Phuket Resort just a 25-minute drive from the international airport. With a nearby championship golf course and shopping and dining facilities, you’ll have everything you need to live a life of ease and leisure within this secure gated community.</p><p>The larger towns of Kamala and Patong Beach are just a 30-minute drive down the coast offering additional shopping, dining and leisure attractions and activities. There are also plenty of pristine beaches on the west coast, including Laguna’s own spectacular Bang Tao Beach. This makes the community perfectly situated to make the most of a west coast lifestyle.</p><h2>Contact Laguna Property to Buy Your Townhome</h2><p>By investing in our contemporary townhomes, you’ll be able to start enjoying the healthy lifestyle that comes with living in the most exclusive community on the island. A lifestyle enjoyed amid the lagoons and tropical garden ambience of this safe and secure, gated resort community.</p><p>Contact us today to start living life to its fullest. Become a part of the most enviable leisure lifestyle on the island.</p>`,
//   cn:
//     "<p> 新推出的乐古浪熙园二期项目坐落在郁郁葱葱的热带草木之中，位于普吉岛乐古浪，这个1000英亩的综合度假胜地在邦道湾原始古朴的海滩上绵延三公里。 <br /> <br /> 现代风格的联排别墅和独栋别墅在安全的封闭式环境中提供了宽敞的居住空间，包括二十四小时安保、娱乐和公共设施以及乐古浪提供的专业物业管理服务。</p>",
//   ru:
//     "<p> Новый охраняемый жилой комплекс Laguna Park Фаза 2 расположен среди пышной тропической зелени по соседству с удостоенным множества наград курортным комплексом Laguna Phuket, занимающим 1000 акров, простирающихся вдоль чистейшего пляжа Банг Тао. <br /> <br /> Созданные в современном стиле таунхаусы и виллы отличаются просторными жилыми помещениями и расположением на безопасной территории под круглосуточной охраной. Доступны места для отдыха общего пользования, а также услуги по профессиональному управлению собственностью, предоставляемые комплексом Laguna. </p>"
// };
/* harmony default export */ __webpack_exports__["a"] = ({imageSlider:imageSlider,content:content});

/***/ }),
/* 777 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(2);
var maps=Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])("phuket-laguna-park-2")+"/images/master-plan/image.jpg";/* harmony default export */ __webpack_exports__["a"] = ({maps:maps});

/***/ }),
/* 778 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__svg_floor_roof__ = __webpack_require__(779);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__svg_floor_1__ = __webpack_require__(780);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__svg_floor_2__ = __webpack_require__(781);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_floor_3__ = __webpack_require__(782);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__svg_floor_4__ = __webpack_require__(783);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_floor_5__ = __webpack_require__(784);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__svg_floor_siteplan__ = __webpack_require__(785);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__data_LagunaBeachside_sitePlan_svg_coming_soon__ = __webpack_require__(320);
var subType=[{value:"all",title:{en:"ALL",ru:"Все",cn:"全部"}},{value:"1-bed",title:{en:"1 Bedroom",ru:"1 Bedroom",cn:"1 卧室"}},{value:"2-bed",title:{en:"2 Bedroom",ru:"2 Bedroom",cn:"2 卧室"}},{value:"3-bed",title:{en:"3 Bedroom",ru:"3 Bedroom",cn:"3 卧室"}}];var subTabs=[{value:"all",title:{en:"All",ru:"Все",cn:"全部"},showModal:false,img:__WEBPACK_IMPORTED_MODULE_1__svg_floor_1__["a" /* default */]// img: Siteplan,
},{value:"a",title:{en:"Block 1",ru:"Блок 1",cn:"1栋"},showModal:false,img:__WEBPACK_IMPORTED_MODULE_1__svg_floor_1__["a" /* default */]},{value:"b",title:{en:"Block 2",ru:"Блок 2",cn:"2栋"},showModal:false,img:__WEBPACK_IMPORTED_MODULE_1__svg_floor_1__["a" /* default */]},{value:"c",title:{en:"Block 3",ru:"Блок 3",cn:"3栋"},showModal:false,img:__WEBPACK_IMPORTED_MODULE_1__svg_floor_1__["a" /* default */]},{value:"d",title:{en:"Block 4",ru:"Блок 4",cn:"4栋"},showModal:false,img:__WEBPACK_IMPORTED_MODULE_1__svg_floor_1__["a" /* default */]// img: Comming,
}];var type=[{value:"roof",title:{en:"roof Floor",ru:"roof Floor",cn:"roof Floor"},floorPlan:{all:__WEBPACK_IMPORTED_MODULE_0__svg_floor_roof__["a" /* default */],a:__WEBPACK_IMPORTED_MODULE_0__svg_floor_roof__["a" /* default */],b:__WEBPACK_IMPORTED_MODULE_0__svg_floor_roof__["a" /* default */],c:__WEBPACK_IMPORTED_MODULE_0__svg_floor_roof__["a" /* default */],d:__WEBPACK_IMPORTED_MODULE_0__svg_floor_roof__["a" /* default */]// d: Comming,
},buttons:subType},{value:"1st",title:{en:"1st Floor",ru:"1-й этаж",cn:"1楼"},floorPlan:{all:__WEBPACK_IMPORTED_MODULE_1__svg_floor_1__["a" /* default */],a:__WEBPACK_IMPORTED_MODULE_1__svg_floor_1__["a" /* default */],b:__WEBPACK_IMPORTED_MODULE_1__svg_floor_1__["a" /* default */],c:__WEBPACK_IMPORTED_MODULE_1__svg_floor_1__["a" /* default */],d:__WEBPACK_IMPORTED_MODULE_1__svg_floor_1__["a" /* default */]},buttons:subType},{value:"2nd",title:{en:"2nd Floor",ru:"2-й этаж",cn:"2楼"},floorPlan:{all:__WEBPACK_IMPORTED_MODULE_2__svg_floor_2__["a" /* default */],a:__WEBPACK_IMPORTED_MODULE_2__svg_floor_2__["a" /* default */],b:__WEBPACK_IMPORTED_MODULE_2__svg_floor_2__["a" /* default */],c:__WEBPACK_IMPORTED_MODULE_2__svg_floor_2__["a" /* default */],d:__WEBPACK_IMPORTED_MODULE_2__svg_floor_2__["a" /* default */]},buttons:subType},{value:"3rd",title:{en:"3rd Floor",ru:"3-й этаж",cn:"3楼"},floorPlan:{all:__WEBPACK_IMPORTED_MODULE_3__svg_floor_3__["a" /* default */],a:__WEBPACK_IMPORTED_MODULE_3__svg_floor_3__["a" /* default */],b:__WEBPACK_IMPORTED_MODULE_3__svg_floor_3__["a" /* default */],c:__WEBPACK_IMPORTED_MODULE_3__svg_floor_3__["a" /* default */],d:__WEBPACK_IMPORTED_MODULE_3__svg_floor_3__["a" /* default */]},buttons:subType},{value:"4th",title:{en:"4th Floor",ru:"4-й этаж",cn:"4楼"},floorPlan:{all:__WEBPACK_IMPORTED_MODULE_4__svg_floor_4__["a" /* default */],a:__WEBPACK_IMPORTED_MODULE_4__svg_floor_4__["a" /* default */],b:__WEBPACK_IMPORTED_MODULE_4__svg_floor_4__["a" /* default */],c:__WEBPACK_IMPORTED_MODULE_4__svg_floor_4__["a" /* default */],d:__WEBPACK_IMPORTED_MODULE_4__svg_floor_4__["a" /* default */]},buttons:subType},{value:"5th",title:{en:"5th Floor",ru:"5-й этаж",cn:"5楼"},floorPlan:{all:__WEBPACK_IMPORTED_MODULE_5__svg_floor_5__["a" /* default */],a:__WEBPACK_IMPORTED_MODULE_5__svg_floor_5__["a" /* default */],b:__WEBPACK_IMPORTED_MODULE_5__svg_floor_5__["a" /* default */],c:__WEBPACK_IMPORTED_MODULE_5__svg_floor_5__["a" /* default */],d:__WEBPACK_IMPORTED_MODULE_5__svg_floor_5__["a" /* default */]},buttons:subType}];var descriptions=[{value:"1-bed",title:{en:"ONE-BEDROOM",cn:"1-卧室",ru:"1-Спальня"},des:{en:"Ideal for the modern lifestyle, the 1-bedroom condominium units at Laguna Beachside start at a spacious 59 sqm. A choice of fit-out options offers the flexibility for owners to customise their own living area.",cn:"悦海苑的一卧室公寓面积为59平方米起，空间宽敞，是现代生活方式的理想选择。可选的装修方案为业主带来个性定制起居空间的灵活性。",ru:"Идеально подходят для современного образа жизни, площадь 1 спальных просторных квартир начинается от 59 кв. м.Владельцы могут воспользоваться рядом индивидуальных вариантов обустройства квартиры или выбрать полностью обставленный вариант."}},{value:"2-bed",title:{en:"TWO-BEDROOM",cn:"2-卧室",ru:"2-Спальня"},des:{en:"The larger 2-bedroom units are designed to enjoy maximum panoramic views from their respective full width lanai.",cn:"更大的两卧室公寓可从各自的全宽休闲阳台欣赏到开阔的全景。",ru:"Планировка квартир с двумя спальнями позволяет максимально наслаждаться панорамнымными видами с их просторных веранд."}},{value:"3-bed",title:{en:"THREE-BEDROOM",cn:"3-卧室",ru:"3-Спальня"},des:{en:"The 3-bedroom units with the unique semi-outdoor lanai feature provides additional living space, which can be opened up to extend the balcony for relaxed outdoor living, or closed off with an optional glass screen to increase interior floor space",cn:"三卧室公寓拥有独特的半露天休闲阳台，提供额外的起居空间，并可开放至阳台，尽享休闲户外生活，或选用玻璃封闭以增加室内空间。",ru:"Варианты с 3 спальнями благодаря уникальной полуоткрытой веранде обеспечивают дополнительное жилое пространство, которое можно оставить открытым для расширения балкона и наслаждаться жизнью на свежем воздухе, или же остеклить для увеличения площади внутреннего пространства."}}];/* harmony default export */ __webpack_exports__["a"] = ({// maps,
type:type,subTabs:subTabs,descriptions:descriptions});

/***/ }),
/* 779 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(2);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var currentLang=_ref.currentLang,selectedType=_ref.selectedType,selectedBuilding=_ref.selectedBuilding;var BG=Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* assetsPath */])("laguna-beachside")+"/images/site-plan/"+currentLang+"/r.jpg";var shouldDisplayByLang=function shouldDisplayByLang(selectLang){return currentLang===selectLang?"display":"display-none";};var shouldDisplay=function shouldDisplay(build,type){return selectedBuilding===build||selectedBuilding==="all"?"opacity-in":"opacity-out";};// const shouldDisplay = (build) => {
//   return selectedBuilding === build ? "opacity-in" : "opacity-out";
// };
console.log("xxxxxxxxx",{currentLang:currentLang,selectedType:selectedType,selectedBuilding:selectedBuilding});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 841.89 595.28",className:"site-plan-svg"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"map"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("image",{xlinkHref:BG,height:"100%",width:"100%"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"floorplan"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3",className:shouldDisplay("c"),"data-name":"3",points:"349.69 289.26 350.82 280.73 328.6 280.73 328.64 232.12 286.86 232.15 286.83 254.5 279.05 254.56 279.05 232.37 237.86 232.15 237.86 229.56 205.96 229.56 205.99 251.65 198.24 251.75 198.21 232.18 156.4 232.21 156.43 254.53 148.65 254.59 148.61 232.15 107.58 232.12 107.55 229.5 75.64 229.56 75.61 256.87 82.46 256.9 82.43 275.84 99.46 275.84 99.43 291.37 130.61 291.43 130.58 294.24 162.58 294.28 162.58 273.25 170.33 273.25 170.33 291.43 201.52 291.43 201.55 294.28 233.43 294.31 233.46 285.9 265.55 285.96 265.49 294.24 297.52 294.34 297.49 291.43 328.64 291.46 328.64 289.31 349.69 289.26",fill:"#231f20",opacity:"0.8"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polyline",{id:"_2",className:shouldDisplay("b"),"data-name":"2",points:"608.92 305.87 608.61 314.59 586.42 309.46 583.58 321.96 572.24 319.37 570.49 327.24 456.39 301.46 457.43 297.12 437.43 292.53 437.18 292.21 435.27 291.74 428.8 290.96 428.86 291.18 413.68 289.12 412.77 295.74 402.49 294.4 402.39 295.28 381.33 292.37 380.83 296.4 349.18 292.03 353.58 259.46 357.55 230.87 389.11 235.25 388.8 237.75 429.49 243.18 428.96 247.43 439.52 248.87 440.8 243.65 481.55 252.93 480.74 256.5 511.21 263.4 510.11 268.43 520.36 270.71 521.52 265.71 551.92 272.65 552.74 269.15 593.52 278.37 588.42 301.21 608.83 305.84",fill:"#231f20",opacity:"0.8"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1",className:shouldDisplay("a"),"data-name":"1",points:"631.96 336.59 729.52 341.71 729.02 351.4 760.89 353.09 762.89 321.53 764.83 321.4 766.33 293.96 725.21 291.81 725.58 286.49 693.74 284.84 692.55 306.93 681.96 306.37 683.17 284.03 641.36 281.84 641.14 287.74 609.96 286.15 608.83 305.84 607.99 325.31 632.52 326.59 631.96 336.59",fill:"#231f20",opacity:"0.8"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_4",className:shouldDisplay("d"),"data-name":"4",points:"428.91 295.92 428.91 290.88 435.47 291.84 437.46 292.28 437.46 328.14 460.93 328.14 460.93 359.43 464.35 359.43 464.35 391.28 460.95 391.28 460.95 421.7 464.35 421.7 464.35 453.67 460.95 453.67 460.95 484.82 447.14 484.82 447.14 489.84 429.19 493.35 405.82 493.35 405.82 428.92 422.93 428.92 422.93 405.18 406.08 405.18 406.08 378.79 422.93 378.79 422.93 364.14 405.82 364.14 405.82 320.88 428.89 320.88 428.91 295.92",fill:"#231f20",opacity:"0"})));});

/***/ }),
/* 780 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(2);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var currentLang=_ref.currentLang,selectedType=_ref.selectedType,selectedBuilding=_ref.selectedBuilding;var BG=Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* assetsPath */])("laguna-beachside")+"/images/site-plan/"+currentLang+"/1.jpg";var shouldDisplayByType=function shouldDisplayByType(type){return selectedType===type||selectedType==="all"?"opacity-in":"opacity-out";};var shouldDisplay=function shouldDisplay(build,type){return(selectedType===type||selectedType==="all")&&(selectedBuilding===build||selectedBuilding==="all")?"opacity-in":"opacity-out";};// const shouldDisplay = (build, type) => {
//   return (selectedType === type || selectedType === "all") &&
//     selectedBuilding === build
//     ? "opacity-in"
//     : "opacity-out";
// };
var fill="#231f20";var opacity=1;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 841.89 595.28","data-name":"Layer 1",className:"site-plan-svg"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"map"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("image",{xlinkHref:BG,height:"100%",width:"100%"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"floorplan"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{className:"building-a"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"2-bed","data-name":"1_2",className:shouldDisplay("a","2-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"609.31",y:"286.8",width:"31.13",height:"27.39",transform:"translate(18.09 -35.02) rotate(3.26)",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"693.14",y:"285.49",width:"31.79",height:"27.18",transform:"translate(18.14 -39.81) rotate(3.26)",fill:"#231f20",opacity:"0.9"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"3-bed","data-name":"1_3",className:shouldDisplay("a","3-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"641.3",y:"282.86",width:"41.1",height:"27.46",transform:"translate(18.4 -38.04) rotate(3.34)",fill:"#231f20",opacity:"0.9"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{className:"building-b"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"2-bed","data-name":"2_2",className:shouldDisplay("b","2-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"355.64",y:"232.74",width:"31.17",height:"27.14",transform:"translate(37.17 -48.45) rotate(7.86)",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"477.33",y:"259.51",width:"31.17",height:"27.14",transform:"translate(72.55 -102.19) rotate(12.77)",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"518.16",y:"268.69",width:"31.17",height:"27.14",transform:"translate(75.59 -110.99) rotate(12.77)",fill:"#231f20",opacity:"0.9"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"3-bed","data-name":"2_3",className:shouldDisplay("b","3-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"386.83",y:"240.25",width:"41.1",height:"27.53",transform:"translate(39.37 -54.29) rotate(8.01)",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"549.96",y:"273.5",width:"41.1",height:"27.25",transform:"translate(77.35 -118.72) rotate(12.74)",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"437.27",y:"248.05",width:"41.1",height:"27.25",transform:"translate(68.96 -94.5) rotate(12.74)",fill:"#231f20",opacity:"0.9"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{className:"building-c"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"2-bed","data-name":"3_2",className:shouldDisplay("c","2-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"75.55",y:"229.21",width:"31.31",height:"27.44",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"205.86",y:"229.21",width:"31.31",height:"27.44",fill:"#231f20",opacity:"0.9"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"3-bed","data-name":"3_3",className:shouldDisplay("c","3-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"107.66",y:"232.09",width:"40.95",height:"27.32",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"156.48",y:"232.09",width:"41.74",height:"27.32",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"237.96",y:"232.09",width:"41.07",height:"27.32",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"286.89",y:"232.09",width:"41.82",height:"27.32",fill:"#231f20",opacity:"0.9"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{className:"building-d"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"1-bed","data-name":"4_1",className:shouldDisplay("d","1-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"_4106","data-name":"4106",x:"405.9",y:"320.5",width:"23.4",height:"21.27",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"_4107","data-name":"4107",x:"405.9",y:"341.7",width:"23.4",height:"21.97",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"_4108","data-name":"4108",x:"405.9",y:"428.5",width:"23.1",height:"21.3",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_4109","data-name":"4109",points:"429 449.8 405.9 449.8 405.9 471 428.8 471 429 449.8",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"_4110","data-name":"4110",x:"405.9",y:"471",width:"22.9",height:"21.94",fill:"#231f20",opacity:"0.9"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"2-bed","data-name":"4_2",className:shouldDisplay("d","2-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_4101","data-name":"4101",points:"460.9 484.5 433.6 484.5 433.6 452.5 461 452.5 460.9 484.5",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_4102","data-name":"4102",points:"464.4 421.3 464.4 453.3 436.8 453.3 436.8 421.3 464.4 421.3",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_4103","data-name":"4103",points:"433.5 422.1 433.5 390.9 461 390.9 461 422.1 433.5 422.1",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_4104","data-name":"4104",points:"437 359 464.4 359 464.4 391 436.8 391 437 359",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_4105","data-name":"4105",points:"433.5 327.8 461 327.8 461 359.7 433.5 359.7 433.5 327.8",fill:"#231f20",opacity:"0.9"})))));});

/***/ }),
/* 781 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(2);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var currentLang=_ref.currentLang,selectedType=_ref.selectedType,selectedBuilding=_ref.selectedBuilding;var BG=Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* assetsPath */])("laguna-beachside")+"/images/site-plan/"+currentLang+"/2.jpg";var shouldDisplayByLang=function shouldDisplayByLang(selectLang){return currentLang===selectLang?"display":"display-none";};var shouldDisplayByType=function shouldDisplayByType(type){return selectedType===type||selectedType==="all"?"opacity-in":"opacity-out";};var shouldDisplay=function shouldDisplay(build,type){return(selectedType===type||selectedType==="all")&&(selectedBuilding===build||selectedBuilding==="all")?"opacity-in":"opacity-out";};// const shouldDisplay = (build, type) => {
//   return (selectedType === type || selectedType === "all") &&
//     selectedBuilding === build
//     ? "opacity-in"
//     : "opacity-out";
// };
var fill="#231f20";var opacity=1;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 841.89 595.28",className:"site-plan-svg"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"map"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("image",{xlinkHref:BG,height:"100%",width:"100%"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"floorplan"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{className:"building-a"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"2-bed","data-name":"1_2",className:shouldDisplay("a","2-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"609.28",y:"286.8",width:"31.13",height:"27.39",transform:"translate(18.09 -35.02) rotate(3.26)",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"693.12",y:"285.47",width:"31.11",height:"27.18",transform:"translate(18.14 -39.79) rotate(3.26)",fill:"#231f20",opacity:"0.9"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"3-bed","data-name":"1_3",className:shouldDisplay("a","3-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"641.27",y:"282.86",width:"41.1",height:"27.46",transform:"translate(18.4 -38.04) rotate(3.34)",fill:"#231f20",opacity:"0.9"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{className:"building-b"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"1-bed","data-name":"2_1",className:shouldDisplay("b","1-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"402.45 295.4 401.74 295.31 401.77 295.01 397.07 294.37 397.03 294.63 396.51 294.56 396.54 294.3 391.84 293.65 391.79 293.97 391.27 293.9 391.31 293.58 386.61 292.93 386.56 293.22 385.98 293.14 386.02 292.85 381.5 292.23 384.64 269.39 404.91 272.18 405.02 272.19 405.62 272.28 402.45 295.4",fill:"#231f20",opacity:"0.9"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"2-bed","data-name":"2_2",className:shouldDisplay("b","2-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"355.62",y:"232.74",width:"31.17",height:"27.14",transform:"translate(37.17 -48.45) rotate(7.86)",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"350.88",y:"267.07",width:"31.17",height:"27.14",transform:"translate(41.82 -47.48) rotate(7.86)",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"477.3",y:"259.51",width:"31.17",height:"27.14",transform:"translate(72.55 -102.19) rotate(12.77)",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"518.13",y:"268.69",width:"31.17",height:"27.14",transform:"translate(75.59 -110.99) rotate(12.77)",fill:"#231f20",opacity:"0.9"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"3-bed","data-name":"2_3",className:shouldDisplay("b","3-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"386.81",y:"240.25",width:"41.1",height:"27.53",transform:"translate(39.37 -54.28) rotate(8.01)",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"437.24",y:"248.05",width:"41.1",height:"27.25",transform:"translate(68.96 -94.5) rotate(12.74)",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"549.93",y:"273.5",width:"41.1",height:"27.25",transform:"translate(77.35 -118.72) rotate(12.74)",fill:"#231f20",opacity:"0.9"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{className:"building-c"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"2-bed","data-name":"3_2",className:shouldDisplay("c","2-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"75.52",y:"229.21",width:"31.31",height:"27.44",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"99.52",y:"263.96",width:"31.06",height:"27.26",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"131.37",y:"266.82",width:"31.21",height:"27.26",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"170.32",y:"264.01",width:"31.21",height:"27.26",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"297.45",y:"264.01",width:"31.21",height:"27.26",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"202.2",y:"266.92",width:"31.21",height:"27.26",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"265.57",y:"266.92",width:"31.21",height:"27.26",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"205.83",y:"229.21",width:"31.31",height:"27.44",fill:"#231f20",opacity:"0.9"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"3-bed","data-name":"3_3",className:shouldDisplay("c","3-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"107.64",y:"232.09",width:"40.95",height:"27.32",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"156.45",y:"232.09",width:"41.74",height:"27.32",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"237.93",y:"232.09",width:"41.07",height:"27.32",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"286.87",y:"232.09",width:"41.82",height:"27.32",fill:"#231f20",opacity:"0.9"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{className:"building-d"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"1-bed","data-name":"4_1",className:shouldDisplay("d","1-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"_4106","data-name":"4106",x:"405.9",y:"320.5",width:"23.4",height:"21.27",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"_4107","data-name":"4107",x:"405.9",y:"341.7",width:"23.4",height:"21.97",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"_4108","data-name":"4108",x:"405.9",y:"428.5",width:"23.1",height:"21.3",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_4109","data-name":"4109",points:"429 449.8 405.9 449.8 405.9 471 428.8 471 429 449.8",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"_4110","data-name":"4110",x:"405.9",y:"471",width:"22.9",height:"21.94",fill:"#231f20",opacity:"0.9"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"2-bed","data-name":"4_2",className:shouldDisplay("d","2-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_4101","data-name":"4101",points:"460.9 484.5 433.6 484.5 433.6 452.5 461 452.5 460.9 484.5",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_4102","data-name":"4102",points:"464.4 421.3 464.4 453.3 436.8 453.3 436.8 421.3 464.4 421.3",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_4103","data-name":"4103",points:"433.5 422.1 433.5 390.9 461 390.9 461 422.1 433.5 422.1",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_4104","data-name":"4104",points:"437 359 464.4 359 464.4 391 436.8 391 437 359",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_4105","data-name":"4105",points:"433.5 327.8 461 327.8 461 359.7 433.5 359.7 433.5 327.8",fill:"#231f20",opacity:"0.9"})))));});

/***/ }),
/* 782 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(2);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var currentLang=_ref.currentLang,selectedType=_ref.selectedType,selectedBuilding=_ref.selectedBuilding;var BG=Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* assetsPath */])("laguna-beachside")+"/images/site-plan/"+currentLang+"/3.jpg";var shouldDisplayByLang=function shouldDisplayByLang(selectLang){return currentLang===selectLang?"display":"display-none";};var shouldDisplayByType=function shouldDisplayByType(type){return selectedType===type||selectedType==="all"?"opacity-in":"opacity-out";};var shouldDisplay=function shouldDisplay(build,type){return(selectedType===type||selectedType==="all")&&(selectedBuilding===build||selectedBuilding==="all")?"opacity-in":"opacity-out";};// const shouldDisplay = (build, type) => {
//   return (selectedType === type || selectedType === "all") &&
//     selectedBuilding === build
//     ? "opacity-in"
//     : "opacity-out";
// };
var fill="#231f20";var opacity=1;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 841.89 595.28",className:"site-plan-svg"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"map"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("image",{xlinkHref:BG,height:"100%",width:"100%"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"floorplan"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{className:"building-a"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"1-bed","data-name":"1_1",className:shouldDisplay("a","1-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"704.2 340.43 703.49 340.39 703.5 340.1 698.75 339.88 698.74 340.14 698.21 340.12 698.22 339.85 693.48 339.63 693.46 339.96 692.93 339.93 692.95 339.61 688.2 339.39 688.19 339.68 687.6 339.65 687.61 339.36 683.06 339.15 684.13 316.12 704.57 317.07 704.68 317.08 705.29 317.11 704.2 340.43",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"631.96 336.61 632.65 336.71 632.7 336.45 636.85 336.65 636.84 336.94 637.46 337.03 637.58 336.66 641.78 336.92 641.72 337.08 642.25 337.22 642.44 336.9 646.55 337.17 646.54 337.39 647.15 337.46 647.22 337.12 651.42 337.36 651.35 337.71 651.93 337.69 652.01 337.4 656.17 337.7 656.15 337.93 656.76 337.98 656.75 337.67 660.94 337.86 661.93 320.43 632.93 318.94 631.96 336.61",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"683.55 315.96 683.5 315.95 683.38 315.95 662.94 315 661.87 338.02 666.42 338.23 666.41 338.53 667 338.56 667.01 338.26 671.76 338.48 671.75 338.81 672.28 338.83 672.29 338.51 677.04 338.73 677.02 338.99 677.55 339.01 677.57 338.75 682.23 338.97 683.55 315.96",fill:"#231f20",opacity:"0.9"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"2-bed","data-name":"1_2",className:shouldDisplay("a","2-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"609.28",y:"286.8",width:"31.13",height:"27.39",transform:"translate(18.09 -35.02) rotate(3.26)",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"693.12",y:"285.47",width:"31.11",height:"27.18",transform:"translate(18.14 -39.79) rotate(3.26)",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"729.77",y:"324.9",width:"31.76",height:"27.18",transform:"translate(20.44 -41.83) rotate(3.26)",fill:"#231f20",opacity:"0.9"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"3-bed","data-name":"1_3",className:shouldDisplay("a","3-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"641.27",y:"282.86",width:"41.1",height:"27.46",transform:"translate(18.4 -38.04) rotate(3.34)",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"724.64",y:"292.73",width:"41.23",height:"27.46",transform:"translate(19.11 -42.88) rotate(3.34)",fill:"#231f20",opacity:"0.9"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{className:"building-b"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"1-bed","data-name":"2_1",className:shouldDisplay("b","1-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"402.45 295.4 401.74 295.31 401.77 295.01 397.07 294.37 397.03 294.63 396.51 294.56 396.54 294.3 391.84 293.65 391.79 293.97 391.27 293.9 391.31 293.58 386.61 292.93 386.56 293.22 385.98 293.14 386.02 292.85 381.5 292.23 384.64 269.39 404.91 272.18 405.02 272.19 405.62 272.28 402.45 295.4",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"456.36 301.56 457.02 301.78 457.11 301.53 461.18 302.43 461.11 302.71 461.71 302.9 461.89 302.56 465.99 303.53 465.89 303.68 466.39 303.9 466.64 303.62 470.64 304.59 470.6 304.81 471.19 304.98 471.32 304.65 475.41 305.61 475.29 305.93 475.86 306.01 475.99 305.75 480.04 306.75 479.97 306.96 480.57 307.12 480.61 306.81 484.71 307.71 488.64 290.7 460.32 284.31 456.36 301.56",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"570.42 327.42 569.73 327.34 569.75 327.07 565.7 326.14 565.63 326.42 565.01 326.33 564.99 325.94 560.88 325.05 560.9 325.24 560.35 325.22 560.25 324.86 556.22 324.01 556.17 324.23 555.56 324.12 555.59 323.77 551.48 322.87 551.46 323.22 550.9 323.04 550.9 322.75 546.82 321.91 546.78 322.13 546.18 322.02 546.27 321.72 542.18 320.77 545.96 303.72 574.28 310.15 570.42 327.42",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"513.07 314.12 517 296.99 489.2 290.78 485.49 307.85 489.57 308.78 489.48 309.08 490.09 309.19 490.12 308.97 494.21 309.79 494.21 310.09 494.76 310.26 494.79 309.91 498.9 310.8 498.87 311.15 499.48 311.25 499.54 311.03 503.57 311.86 503.67 312.23 504.22 312.24 504.2 312.06 508.31 312.93 508.34 313.32 508.95 313.41 509.02 313.13 513.08 314.04 513.07 314.12",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"541.48 320.68 545.4 303.55 517.6 297.34 513.89 314.41 517.98 315.34 517.89 315.64 518.49 315.75 518.53 315.53 522.62 316.36 522.62 316.65 523.17 316.82 523.2 316.48 527.31 317.36 527.28 317.71 527.89 317.81 527.94 317.59 531.97 318.43 532.08 318.79 532.62 318.8 532.61 318.62 536.72 319.5 536.74 319.89 537.36 319.97 537.42 319.69 541.48 320.61 541.48 320.68",fill:"#231f20",opacity:"0.9"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"2-bed","data-name":"2_2",className:shouldDisplay("b","2-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"355.62",y:"232.74",width:"31.17",height:"27.14",transform:"translate(37.17 -48.45) rotate(7.86)",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"350.88",y:"267.07",width:"31.17",height:"27.14",transform:"translate(41.82 -47.48) rotate(7.86)",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"477.3",y:"259.51",width:"31.17",height:"27.14",transform:"translate(72.55 -102.19) rotate(12.77)",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"518.13",y:"268.69",width:"31.17",height:"27.14",transform:"translate(75.59 -110.99) rotate(12.77)",fill:"#231f20",opacity:"0.9"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"3-bed","data-name":"2_3",className:shouldDisplay("b","3-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"386.81",y:"240.25",width:"41.1",height:"27.53",transform:"translate(39.37 -54.28) rotate(8.01)",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"437.24",y:"248.05",width:"41.1",height:"27.25",transform:"translate(68.96 -94.5) rotate(12.74)",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"549.93",y:"273.5",width:"41.1",height:"27.25",transform:"translate(77.35 -118.72) rotate(12.74)",fill:"#231f20",opacity:"0.9"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{className:"building-c"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"2-bed","data-name":"3_2",className:shouldDisplay("c","2-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"75.52",y:"229.21",width:"31.31",height:"27.44",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"99.52",y:"263.96",width:"31.06",height:"27.26",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"131.37",y:"266.82",width:"31.21",height:"27.26",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"170.32",y:"264.01",width:"31.21",height:"27.26",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"297.45",y:"264.01",width:"31.21",height:"27.26",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"202.2",y:"266.92",width:"31.21",height:"27.26",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"265.57",y:"266.92",width:"31.21",height:"27.26",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"205.83",y:"229.21",width:"31.31",height:"27.44",fill:"#231f20",opacity:"0.9"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"3-bed","data-name":"3_3",className:shouldDisplay("c","3-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"107.64",y:"232.09",width:"40.95",height:"27.32",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"156.45",y:"232.09",width:"41.74",height:"27.32",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"237.93",y:"232.09",width:"41.07",height:"27.32",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"286.87",y:"232.09",width:"41.82",height:"27.32",fill:"#231f20",opacity:"0.9"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{className:"building-d"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"1-bed","data-name":"4_1",className:shouldDisplay("d","1-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"_4106","data-name":"4106",x:"405.9",y:"320.5",width:"23.4",height:"21.27",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"_4107","data-name":"4107",x:"405.9",y:"341.7",width:"23.4",height:"21.97",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"_4108","data-name":"4108",x:"405.9",y:"428.5",width:"23.1",height:"21.3",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_4109","data-name":"4109",points:"429 449.8 405.9 449.8 405.9 471 428.8 471 429 449.8",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"_4110","data-name":"4110",x:"405.9",y:"471",width:"22.9",height:"21.94",fill:"#231f20",opacity:"0.9"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"2-bed","data-name":"4_2",className:shouldDisplay("d","2-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_4101","data-name":"4101",points:"460.9 484.5 433.6 484.5 433.6 452.5 461 452.5 460.9 484.5",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_4102","data-name":"4102",points:"464.4 421.3 464.4 453.3 436.8 453.3 436.8 421.3 464.4 421.3",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_4103","data-name":"4103",points:"433.5 422.1 433.5 390.9 461 390.9 461 422.1 433.5 422.1",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_4104","data-name":"4104",points:"437 359 464.4 359 464.4 391 436.8 391 437 359",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_4105","data-name":"4105",points:"433.5 327.8 461 327.8 461 359.7 433.5 359.7 433.5 327.8",fill:"#231f20",opacity:"0.9"})))));});

/***/ }),
/* 783 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(2);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var currentLang=_ref.currentLang,selectedType=_ref.selectedType,selectedBuilding=_ref.selectedBuilding;var BG=Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* assetsPath */])("laguna-beachside")+"/images/site-plan/"+currentLang+"/4.jpg";var shouldDisplayByLang=function shouldDisplayByLang(selectLang){return currentLang===selectLang?"display":"display-none";};var shouldDisplayByType=function shouldDisplayByType(type){return selectedType===type||selectedType==="all"?"opacity-in":"opacity-out";};var shouldDisplay=function shouldDisplay(build,type){return(selectedType===type||selectedType==="all")&&(selectedBuilding===build||selectedBuilding==="all")?"opacity-in":"opacity-out";};// const shouldDisplay = (build, type) => {
//   return (selectedType === type || selectedType === "all") &&
//     selectedBuilding === build
//     ? "opacity-in"
//     : "opacity-out";
// };
var fill="#231f20";var opacity=1;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 841.89 595.28",className:"site-plan-svg"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"map"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("image",{xlinkHref:BG,height:"100%",width:"100%"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"floorplan"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{className:"building-a"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"1-bed","data-name":"1_1",className:shouldDisplay("a","1-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"704.2 340.43 703.49 340.39 703.5 340.1 698.75 339.88 698.74 340.14 698.21 340.12 698.22 339.85 693.48 339.63 693.46 339.96 692.93 339.93 692.95 339.61 688.2 339.39 688.19 339.68 687.6 339.65 687.61 339.36 683.06 339.15 684.13 316.12 704.57 317.07 704.68 317.08 705.29 317.11 704.2 340.43",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"631.96 336.61 632.65 336.71 632.7 336.45 636.85 336.65 636.84 336.94 637.46 337.03 637.58 336.66 641.78 336.92 641.72 337.09 642.25 337.22 642.44 336.9 646.55 337.17 646.54 337.4 647.15 337.46 647.22 337.12 651.42 337.36 651.35 337.71 651.93 337.69 652.01 337.4 656.17 337.7 656.15 337.93 656.76 337.98 656.75 337.67 660.94 337.86 661.93 320.43 632.93 318.94 631.96 336.61",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"683.55 315.96 683.5 315.95 683.38 315.95 662.94 315 661.87 338.02 666.42 338.23 666.41 338.53 667 338.56 667.01 338.26 671.76 338.48 671.75 338.81 672.28 338.83 672.29 338.51 677.04 338.73 677.02 338.99 677.55 339.01 677.57 338.75 682.23 338.97 683.55 315.96",fill:"#231f20",opacity:"0.9"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"2-bed","data-name":"1_2",className:shouldDisplay("a","2-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"609.28",y:"286.8",width:"31.13",height:"27.39",transform:"translate(18.09 -35.02) rotate(3.26)",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"693.12",y:"285.47",width:"31.11",height:"27.18",transform:"translate(18.14 -39.79) rotate(3.26)",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"729.77",y:"324.9",width:"31.76",height:"27.18",transform:"translate(20.44 -41.83) rotate(3.26)",fill:"#231f20",opacity:"0.9"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"3-bed","data-name":"1_3",className:shouldDisplay("a","3-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"641.27",y:"282.86",width:"41.1",height:"27.46",transform:"translate(18.4 -38.04) rotate(3.34)",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"724.64",y:"292.73",width:"41.23",height:"27.46",transform:"translate(19.11 -42.88) rotate(3.34)",fill:"#231f20",opacity:"0.9"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{className:"building-b"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"1-bed","data-name":"2_1",className:shouldDisplay("b","1-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"402.45 295.4 401.74 295.31 401.77 295.01 397.07 294.37 397.03 294.63 396.51 294.56 396.54 294.3 391.84 293.65 391.79 293.97 391.27 293.9 391.31 293.58 386.61 292.93 386.56 293.22 385.98 293.14 386.02 292.85 381.5 292.23 384.64 269.39 404.91 272.18 405.02 272.19 405.62 272.28 402.45 295.4",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"456.36 301.56 457.02 301.78 457.11 301.53 461.18 302.43 461.11 302.71 461.71 302.9 461.89 302.56 465.99 303.53 465.89 303.68 466.39 303.9 466.64 303.62 470.64 304.59 470.6 304.81 471.19 304.98 471.32 304.65 475.41 305.61 475.29 305.93 475.86 306.01 475.99 305.75 480.04 306.75 479.97 306.96 480.57 307.12 480.61 306.81 484.71 307.71 488.64 290.7 460.32 284.31 456.36 301.56",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"570.42 327.42 569.73 327.34 569.75 327.07 565.7 326.14 565.63 326.42 565.01 326.33 564.99 325.94 560.88 325.06 560.9 325.24 560.35 325.22 560.25 324.86 556.22 324.01 556.17 324.23 555.56 324.13 555.59 323.77 551.48 322.87 551.46 323.22 550.9 323.04 550.9 322.75 546.82 321.91 546.78 322.13 546.18 322.02 546.27 321.72 542.18 320.77 545.96 303.72 574.28 310.15 570.42 327.42",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"513.07 314.12 517 296.99 489.2 290.78 485.49 307.85 489.57 308.78 489.48 309.08 490.09 309.19 490.12 308.97 494.21 309.79 494.21 310.09 494.76 310.26 494.79 309.91 498.9 310.8 498.87 311.15 499.48 311.25 499.54 311.03 503.57 311.87 503.67 312.23 504.22 312.24 504.2 312.06 508.31 312.93 508.34 313.32 508.95 313.41 509.02 313.13 513.08 314.05 513.07 314.12",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"541.48 320.68 545.4 303.55 517.6 297.34 513.89 314.41 517.98 315.34 517.89 315.64 518.49 315.75 518.53 315.53 522.62 316.36 522.62 316.65 523.17 316.82 523.2 316.48 527.31 317.36 527.28 317.71 527.89 317.81 527.94 317.59 531.97 318.43 532.08 318.79 532.62 318.8 532.61 318.62 536.72 319.5 536.74 319.89 537.36 319.97 537.42 319.69 541.48 320.61 541.48 320.68",fill:"#231f20",opacity:"0.9"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"2-bed","data-name":"2_2",className:shouldDisplay("b","2-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"355.62",y:"232.74",width:"31.17",height:"27.14",transform:"translate(37.17 -48.45) rotate(7.86)",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"350.88",y:"267.07",width:"31.17",height:"27.14",transform:"translate(41.82 -47.48) rotate(7.86)",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"477.3",y:"259.51",width:"31.17",height:"27.14",transform:"translate(72.55 -102.19) rotate(12.77)",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"518.13",y:"268.69",width:"31.17",height:"27.14",transform:"translate(75.59 -110.99) rotate(12.77)",fill:"#231f20",opacity:"0.9"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"3-bed","data-name":"2_3",className:shouldDisplay("b","3-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"386.81",y:"240.25",width:"41.1",height:"27.53",transform:"translate(39.37 -54.28) rotate(8.01)",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"437.24",y:"248.05",width:"41.1",height:"27.25",transform:"translate(68.96 -94.5) rotate(12.74)",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"549.93",y:"273.5",width:"41.1",height:"27.25",transform:"translate(77.35 -118.72) rotate(12.74)",fill:"#231f20",opacity:"0.9"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{className:"building-c"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"2-bed","data-name":"3_2",className:shouldDisplay("c","2-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"75.52",y:"229.21",width:"31.31",height:"27.44",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"99.52",y:"263.96",width:"31.06",height:"27.26",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"131.37",y:"266.82",width:"31.21",height:"27.26",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"170.32",y:"264.01",width:"31.21",height:"27.26",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"297.45",y:"264.01",width:"31.21",height:"27.26",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"202.2",y:"266.92",width:"31.21",height:"27.26",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"265.57",y:"266.92",width:"31.21",height:"27.26",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"205.83",y:"229.21",width:"31.31",height:"27.44",fill:"#231f20",opacity:"0.9"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"3-bed","data-name":"3_3",className:shouldDisplay("c","3-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"107.64",y:"232.09",width:"40.95",height:"27.32",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"156.45",y:"232.09",width:"41.74",height:"27.32",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"237.93",y:"232.09",width:"41.07",height:"27.32",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"286.87",y:"232.09",width:"41.82",height:"27.32",fill:"#231f20",opacity:"0.9"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{className:"building-d"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"1-bed","data-name":"4_1",className:shouldDisplay("d","1-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"_4106","data-name":"4106",x:"405.9",y:"320.5",width:"23.4",height:"21.27",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"_4107","data-name":"4107",x:"405.9",y:"341.7",width:"23.4",height:"21.97",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"_4108","data-name":"4108",x:"405.9",y:"428.5",width:"23.1",height:"21.3",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_4109","data-name":"4109",points:"429 449.8 405.9 449.8 405.9 471 428.8 471 429 449.8",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"_4110","data-name":"4110",x:"405.9",y:"471",width:"22.9",height:"21.94",fill:"#231f20",opacity:"0.9"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"2-bed","data-name":"4_2",className:shouldDisplay("d","2-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_4101","data-name":"4101",points:"460.9 484.5 433.6 484.5 433.6 452.5 461 452.5 460.9 484.5",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_4102","data-name":"4102",points:"464.4 421.3 464.4 453.3 436.8 453.3 436.8 421.3 464.4 421.3",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_4103","data-name":"4103",points:"433.5 422.1 433.5 390.9 461 390.9 461 422.1 433.5 422.1",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_4104","data-name":"4104",points:"437 359 464.4 359 464.4 391 436.8 391 437 359",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_4105","data-name":"4105",points:"433.5 327.8 461 327.8 461 359.7 433.5 359.7 433.5 327.8",fill:"#231f20",opacity:"0.9"})))));});

/***/ }),
/* 784 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(2);
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var currentLang=_ref.currentLang,selectedType=_ref.selectedType,selectedBuilding=_ref.selectedBuilding;var BG=Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* assetsPath */])("laguna-beachside")+"/images/site-plan/"+currentLang+"/5.jpg";var shouldDisplayByLang=function shouldDisplayByLang(selectLang){return currentLang===selectLang?"display":"display-none";};var shouldDisplayByType=function shouldDisplayByType(type){return selectedType===type||selectedType==="all"?"opacity-in":"opacity-out";};var shouldDisplay=function shouldDisplay(build,type){return(selectedType===type||selectedType==="all")&&(selectedBuilding===build||selectedBuilding==="all")?"opacity-in":"opacity-out";};// const shouldDisplay = (build, type) => {
//   return (selectedType === type || selectedType === "all") &&
//     selectedBuilding === build
//     ? "opacity-in"
//     : "opacity-out";
// };
var fill="#231f20";var opacity=1;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 841.89 595.28",className:"site-plan-svg"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"map"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("image",{xlinkHref:BG,height:"100%",width:"100%"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"floorplan"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{className:"building-a"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"1-bed","data-name":"1_1",className:shouldDisplay("a","1-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"704.2 340.43 703.49 340.39 703.5 340.1 698.75 339.88 698.74 340.14 698.21 340.12 698.22 339.85 693.48 339.63 693.46 339.96 692.93 339.93 692.95 339.61 688.2 339.39 688.19 339.68 687.6 339.65 687.61 339.36 683.06 339.15 684.13 316.12 704.57 317.07 704.68 317.08 705.29 317.11 704.2 340.43",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"631.96 336.61 632.65 336.71 632.7 336.45 636.85 336.65 636.84 336.94 637.46 337.03 637.58 336.66 641.78 336.92 641.72 337.08 642.25 337.22 642.44 336.9 646.55 337.17 646.54 337.4 647.15 337.46 647.22 337.12 651.42 337.36 651.35 337.71 651.93 337.69 652.01 337.4 656.17 337.7 656.15 337.93 656.76 337.98 656.75 337.67 660.94 337.86 661.93 320.43 632.93 318.94 631.96 336.61",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"683.55 315.96 683.5 315.95 683.38 315.95 662.94 315 661.87 338.02 666.42 338.23 666.41 338.53 667 338.56 667.01 338.26 671.76 338.48 671.75 338.81 672.28 338.83 672.29 338.51 677.04 338.73 677.02 338.99 677.55 339.01 677.57 338.75 682.23 338.97 683.55 315.96",fill:"#231f20",opacity:"0.9"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"2-bed","data-name":"1_2",className:shouldDisplay("a","2-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"609.28",y:"286.8",width:"31.13",height:"27.39",transform:"translate(18.09 -35.02) rotate(3.26)",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"693.12",y:"285.47",width:"31.11",height:"27.18",transform:"matrix(1, 0.06, -0.06, 1, 18.14, -39.79)",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"729.77",y:"324.9",width:"31.76",height:"27.18",transform:"translate(20.44 -41.83) rotate(3.26)",fill:"#231f20",opacity:"0.9"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"3-bed","data-name":"1_3",className:shouldDisplay("a","3-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"641.27",y:"282.86",width:"41.1",height:"27.46",transform:"translate(18.4 -38.04) rotate(3.34)",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"724.64",y:"292.73",width:"41.23",height:"27.46",transform:"translate(19.11 -42.88) rotate(3.34)",fill:"#231f20",opacity:"0.9"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{className:"building-b"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"1-bed","data-name":"2_1",className:shouldDisplay("b","1-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"402.45 295.4 401.74 295.31 401.77 295.01 397.07 294.37 397.03 294.63 396.51 294.56 396.54 294.3 391.84 293.65 391.79 293.97 391.27 293.9 391.31 293.58 386.61 292.93 386.56 293.22 385.98 293.14 386.02 292.85 381.5 292.23 384.64 269.39 404.91 272.18 405.02 272.19 405.62 272.28 402.45 295.4",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"456.36 301.56 457.02 301.78 457.11 301.53 461.18 302.43 461.11 302.71 461.71 302.9 461.89 302.56 465.99 303.53 465.89 303.68 466.39 303.9 466.64 303.62 470.64 304.59 470.6 304.81 471.19 304.98 471.32 304.65 475.41 305.61 475.29 305.93 475.86 306.01 475.99 305.75 480.04 306.75 479.97 306.96 480.57 307.12 480.61 306.81 484.71 307.71 488.64 290.7 460.32 284.31 456.36 301.56",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"570.42 327.42 569.73 327.34 569.75 327.07 565.7 326.14 565.63 326.42 565.01 326.33 564.99 325.94 560.88 325.06 560.9 325.24 560.35 325.22 560.25 324.86 556.22 324.01 556.17 324.23 555.56 324.13 555.59 323.77 551.48 322.87 551.46 323.22 550.9 323.04 550.9 322.75 546.82 321.91 546.78 322.13 546.18 322.02 546.27 321.72 542.18 320.77 545.96 303.72 574.28 310.15 570.42 327.42",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"513.07 314.12 517 296.99 489.2 290.78 485.49 307.85 489.57 308.78 489.48 309.08 490.09 309.19 490.12 308.97 494.21 309.79 494.21 310.09 494.76 310.26 494.79 309.91 498.9 310.8 498.87 311.15 499.48 311.25 499.54 311.03 503.57 311.87 503.67 312.23 504.22 312.24 504.2 312.06 508.31 312.93 508.34 313.32 508.95 313.41 509.02 313.13 513.08 314.05 513.07 314.12",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"541.48 320.68 545.4 303.55 517.6 297.34 513.89 314.41 517.98 315.34 517.89 315.64 518.49 315.75 518.53 315.53 522.62 316.36 522.62 316.65 523.17 316.82 523.2 316.48 527.31 317.36 527.28 317.71 527.89 317.81 527.94 317.59 531.97 318.43 532.08 318.79 532.62 318.8 532.61 318.62 536.72 319.5 536.74 319.89 537.36 319.97 537.42 319.69 541.48 320.61 541.48 320.68",fill:"#231f20",opacity:"0.9"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"2-bed","data-name":"2_2",className:shouldDisplay("b","2-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"355.62",y:"232.74",width:"31.17",height:"27.14",transform:"translate(37.17 -48.45) rotate(7.86)",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"350.88",y:"267.07",width:"31.17",height:"27.14",transform:"translate(41.82 -47.48) rotate(7.86)",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"477.3",y:"259.51",width:"31.17",height:"27.14",transform:"translate(72.55 -102.19) rotate(12.77)",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"518.13",y:"268.69",width:"31.17",height:"27.14",transform:"translate(75.59 -110.99) rotate(12.77)",fill:"#231f20",opacity:"0.9"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"3-bed","data-name":"2_3",className:shouldDisplay("b","3-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"386.81",y:"240.25",width:"41.1",height:"27.53",transform:"translate(39.37 -54.28) rotate(8.01)",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"437.24",y:"248.05",width:"41.1",height:"27.25",transform:"translate(68.96 -94.5) rotate(12.74)",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"549.93",y:"273.5",width:"41.1",height:"27.25",transform:"translate(77.35 -118.72) rotate(12.74)",fill:"#231f20",opacity:"0.9"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{className:"building-c"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"2-bed","data-name":"3_2",className:shouldDisplay("c","2-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"75.52",y:"229.21",width:"31.31",height:"27.44",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"99.52",y:"263.96",width:"31.06",height:"27.26",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"131.37",y:"266.82",width:"31.21",height:"27.26",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"170.32",y:"264.01",width:"31.21",height:"27.26",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"297.45",y:"264.01",width:"31.21",height:"27.26",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"202.2",y:"266.92",width:"31.21",height:"27.26",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"265.57",y:"266.92",width:"31.21",height:"27.26",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"205.83",y:"229.21",width:"31.31",height:"27.44",fill:"#231f20",opacity:"0.9"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"3-bed","data-name":"3_3",className:shouldDisplay("c","3-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"107.64",y:"232.09",width:"40.95",height:"27.32",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"156.45",y:"232.09",width:"41.74",height:"27.32",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"237.93",y:"232.09",width:"41.07",height:"27.32",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"286.87",y:"232.09",width:"41.82",height:"27.32",fill:"#231f20",opacity:"0.9"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{className:"building-d"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"1-bed","data-name":"4_1",className:shouldDisplay("d","1-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"_4106","data-name":"4106",x:"405.9",y:"320.5",width:"23.4",height:"21.27",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"_4107","data-name":"4107",x:"405.9",y:"341.7",width:"23.4",height:"21.97",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"_4108","data-name":"4108",x:"405.9",y:"428.5",width:"23.1",height:"21.3",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_4109","data-name":"4109",points:"429 449.8 405.9 449.8 405.9 471 428.8 471 429 449.8",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"_4110","data-name":"4110",x:"405.9",y:"471",width:"22.9",height:"21.94",fill:"#231f20",opacity:"0.9"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"2-bed","data-name":"4_2",className:shouldDisplay("d","2-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_4101","data-name":"4101",points:"460.9 484.5 433.6 484.5 433.6 452.5 461 452.5 460.9 484.5",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_4102","data-name":"4102",points:"464.4 421.3 464.4 453.3 436.8 453.3 436.8 421.3 464.4 421.3",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_4103","data-name":"4103",points:"433.5 422.1 433.5 390.9 461 390.9 461 422.1 433.5 422.1",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_4104","data-name":"4104",points:"437 359 464.4 359 464.4 391 436.8 391 437 359",fill:"#231f20",opacity:"0.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_4105","data-name":"4105",points:"433.5 327.8 461 327.8 461 359.7 433.5 359.7 433.5 327.8",fill:"#231f20",opacity:"0.9"})))));});

/***/ }),
/* 785 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(2);
// import _ from 'lodash'
// import MultiLineText from './MultiLineText';
/* unused harmony default export */ var _unused_webpack_default_export = (function(_ref){var currentLang=_ref.currentLang,handleClick=_ref.handleClick;var shouldDisplayByLang=function shouldDisplayByLang(selectLang){return currentLang===selectLang?"display":"display-none";};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 600 458",className:"allfloor-of-unitplan"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"cn",className:shouldDisplayByLang("cn")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("image",{xlinkHref:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* assetsPath */])("laguna-beachside")+"/images/site-plan/cn.png"// height="100%"
,width:"100%"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"ru",className:shouldDisplayByLang("ru")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("image",{xlinkHref:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* assetsPath */])("laguna-beachside")+"/images/site-plan/ru.png"// height="100%"
,width:"100%"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"en",className:shouldDisplayByLang("en")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("image",{xlinkHref:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* assetsPath */])("laguna-beachside")+"/images/site-plan/en.png"// height="100%"
,width:"100%"}))));});

/***/ }),
/* 786 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(2);
var selectPath=function selectPath(str){return""+Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])("laguna-beachside")+str;};var landingPage=[{image:selectPath("/images/residence/landing-page/1.jpg")},{image:selectPath("/images/residence/landing-page/2.jpg")},{image:selectPath("/images/residence/landing-page/3.jpg")},{image:selectPath("/images/residence/landing-page/4.jpg")},{image:selectPath("/images/residence/landing-page/5.jpg")},{image:selectPath("/images/residence/landing-page/6.jpg")}];var type=[{// name: "ONE-BEDROOM",
name:{en:"ONE-BEDROOM",cn:"1-卧室",ru:"1-Спальня"},thumbnail:[{image:selectPath("/images/residence/thumbnail/1-bed/1.jpg")},{image:selectPath("/images/residence/thumbnail/1-bed/1.jpg")}],buttons:[{type:"description",value:0,name:"Description",title:"Description",description:{en:"<p>Ideal for the modern lifestyle, the 1-bedroom condominium units at Laguna Beachside start at a spacious 59 sqm. A choice of fit-out options offers the flexibility for owners to customise their own living area.</p>",cn:"<p>悦海苑的一卧室公寓面积为59平方米起，空间宽敞，是现代生活方式的理想选择。可选的装修方案为业主带来个性定制起居空间的灵活性。</p>",ru:"<p>Ideal for the modern lifestyle, the 1-bedroom condominium units at Laguna Beachside start at a spacious 59 sqm. A choice of fit-out options offers the flexibility for owners to customise their own living area.</p>"},images:[{image:selectPath("/images/residence/description/1-bed/1.jpg")},{image:selectPath("/images/residence/description/1-bed/2.jpg")}]},{type:"plan",// name: "TYPE A",
name:{en:"TYPE A",cn:"A 型",ru:"тип A"},value:1,floorPlan:{en:selectPath("/images/residence/floor-plan/1-bed/en/1.png"),ru:selectPath("/images/residence/floor-plan/1-bed/eu/1.png"),cn:selectPath("/images/residence/floor-plan/1-bed/cn/1.png")},images:[],image360:[],imageVirtual:[]},{type:"plan",// name: "TYPE B",
name:{en:"TYPE B",cn:"B 型",ru:"тип B"},value:2,floorPlan:{en:selectPath("/images/residence/floor-plan/1-bed/en/2.png"),ru:selectPath("/images/residence/floor-plan/1-bed/ru/2.png"),cn:selectPath("/images/residence/floor-plan/1-bed/cn/2.png")},images:[],image360:[],imageVirtual:[]}]},{// name: "TWO-BEDROOM",
name:{en:"TWO-BEDROOM",cn:"2-卧室",ru:"2-Спальня"},thumbnail:[{image:selectPath("/images/residence/thumbnail/2-bed/1.jpg")},{image:selectPath("/images/residence/thumbnail/2-bed/1.jpg")}],buttons:[{type:"description",value:0,name:"Description",title:"Description",description:{en:"<p>The larger 2-bedroom units are designed to enjoy maximum panoramic views from their respective full width lanai.</p>",cn:"<p>更大的两卧室公寓可从各自的全宽休闲阳台欣赏到开阔的全景。</p>",ru:"<p>The larger 2-bedroom units are designed to enjoy maximum panoramic views from their respective full width lanai.</p>"},images:[{image:selectPath("/images/residence/description/2-bed/1.jpg")},{image:selectPath("/images/residence/description/2-bed/2.jpg")},{image:selectPath("/images/residence/description/2-bed/3.jpg")}]},{type:"plan",// name: "TYPE A",
name:{en:"TYPE A",cn:"A 型",ru:"тип A"},value:1,floorPlan:{en:selectPath("/images/residence/floor-plan/2-bed/en/1.png"),ru:selectPath("/images/residence/floor-plan/2-bed/ru/1.png"),cn:selectPath("/images/residence/floor-plan/2-bed/cn/1.png")},images:[],image360:[],imageVirtual:[],disclaimer:{en:"*The garden area shown on the first-floor plan shall be available for exclusive use of the owners of the first-floor condominium units.",cn:"*一楼楼层图上所显示的花园区域为一楼公寓业主的专属区域.",ru:"*The garden area shown on the first-floor plan shall be available for exclusive use of the owners of the first-floor condominium units."}}]},{// name: "THREE-BEDROOM",
name:{en:"THREE-BEDROOM",cn:"3-卧室",ru:"3-Спальня"},thumbnail:[{image:selectPath("/images/residence/thumbnail/3-bed/1.jpg")},{image:selectPath("/images/residence/thumbnail/3-bed/1.jpg")}],buttons:[{type:"description",value:0,name:"Description",title:"Description",description:{en:"<p>The 3-bedroom units with the unique semi-outdoor lanai feature provide additional living space, which can be opened up to extend the balcony for relaxed outdoor living, or closed off with an optional glass screen to increase interior floor space.</p>",cn:"<p>三卧室公寓拥有独特的半露天休闲阳台，提供额外的起居空间，并可开放至阳台，尽享休闲户外生活，或选用玻璃封闭以增加室内空间。</p>",ru:"<p>The 3-bedroom units with the unique semi-outdoor lanai feature provide additional living space, which can be opened up to extend the balcony for relaxed outdoor living, or closed off with an optional glass screen to increase interior floor space.</p>"},images:[{image:selectPath("/images/residence/description/3-bed/1.jpg")},{image:selectPath("/images/residence/description/3-bed/2.jpg")}]},{type:"plan",// name: "TYPE A",
name:{en:"TYPE A",cn:"A 型",ru:"тип A"},value:1,floorPlan:{en:selectPath("/images/residence/floor-plan/3-bed/en/1.png"),ru:selectPath("/images/residence/floor-plan/3-bed/ru/1.png"),cn:selectPath("/images/residence/floor-plan/3-bed/cn/1.png")},images:[],image360:[],imageVirtual:[],disclaimer:{en:"*The garden area shown on the first-floor plan shall be available for exclusive use of the owners of the first-floor condominium units.",cn:"*一楼楼层图上所显示的花园区域为一楼公寓业主的专属区域.",ru:"*The garden area shown on the first-floor plan shall be available for exclusive use of the owners of the first-floor condominium units."}},{type:"plan",// name: "TYPE B",
name:{en:"TYPE B",cn:"B 型",ru:"тип B"},value:2,floorPlan:{en:selectPath("/images/residence/floor-plan/3-bed/en/2.png"),ru:selectPath("/images/residence/floor-plan/3-bed/ru/2.png"),cn:selectPath("/images/residence/floor-plan/3-bed/cn/2.png")},images:[],image360:[],imageVirtual:[],disclaimer:{en:"*The garden area shown on the first-floor plan shall be available for exclusive use of the owners of the first-floor condominium units.",cn:"*一楼楼层图上所显示的花园区域为一楼公寓业主的专属区域.",ru:"*The garden area shown on the first-floor plan shall be available for exclusive use of the owners of the first-floor condominium units."}}]}];/* harmony default export */ __webpack_exports__["a"] = ({landingPage:landingPage,type:type});

/***/ }),
/* 787 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(2);
var landingPage=[{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+'/images/destination/landing-page/1.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+'/images/destination/landing-page/2.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+'/images/destination/landing-page/3.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+'/images/destination/landing-page/4.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+'/images/destination/landing-page/5.jpg'}];var map=[{value:"country",name:"Country Map",image:{en:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+'/images/destination/country-map/map-country_en.png',cn:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+'/images/destination/country-map/map-country_cn.png',ru:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+'/images/destination/country-map/map-country_ru.png'}},{value:"city",name:"City Map",images:[{name:"Airport",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])()+'/images/icon/map-icon-01.png',image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+'/images/destination/city-map/airport.png'},{name:"Beaches",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])()+'/images/icon/map-icon-02.png',image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+'/images/destination/city-map/beach.png'},{name:"Islands",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])()+'/images/icon/map-icon-03.png',image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+'/images/destination/city-map/island.png'},{name:"Schools",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])()+'/images/icon/map-icon-05.png',image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+'/images/destination/city-map/school.png'},{name:"Tourist Attractions",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])()+'/images/icon/map-icon-06.png',image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+'/images/destination/city-map/tourist-attraction.png'}]},{value:"project",name:"Project Map",images:[{name:"Hotels & Resorts",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])()+'/images/icon/project-icon-01.png',svg:null},{name:"Restaurants",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])()+'/images/icon/project-icon-02.png',svg:null},{name:"Spas",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])()+'/images/icon/project-icon-03.png',svg:null},{name:"Galleries & Shopping",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])()+'/images/icon/project-icon-04.png',svg:null},{name:"Shuttle Bus",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])()+'/images/icon/project-icon-05.png',svg:null},{name:"Shuttle Boat",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])()+'/images/icon/project-icon-06.png',svg:null}]}];var content={title:"Destination",description:{en:"<p>Surrounded by the turquoise waters of the Andaman Sea and fringed by golden shores, Phuket is an island that compels travelers to visit from around the world.<br><br>Reaching Phuket is easy with direct flights from main cities around the world.The island is also linked to Thailand’s mainland by road.<br><br>Laguna Phuket itself is located in a prime west coast area of Phuket with proximity to an abundance of facilities. Local shopping malls, international schools and world-class hospitals are all close by, while Phuket’s international airport can be reached by car in just 25 minutes.<p>",cn:"<p>乐古浪普吉岛被金色海岸紧紧包围，四周萦绕着绿松石般的海水，这座岛屿吸引着世界各地的游客纷至沓来。<br><br>普吉岛的交通十分便捷，从世界主要城市搭乘直飞航班即可抵达。这里与泰国主岛相连，通过汽车或船只都可轻松到达。<br><br>乐古浪普吉岛位于普吉岛的西海岸，现代设施齐全。购物中心，国际学校，世界级医院随手可得，驱车25分钟即可到达普吉岛国际机场。<p>",ru:"<p>Остров Пхукет, окруженный лазурными водами Андаманского моря, омывающими золотистые песчаные пляжи, манит к себе путешественников со всего мира.<br><br>Добраться до острова очень просто: вылететь прямым рейсом можно из крупных городов разных стран. Из материковой части Таиланда сюда можно доехать на автомобиле по шоссейной дороге.<br><br>Курортный комплекс Laguna Phuket расположен на элитном западном побережье Пхукета. В непосредственной близости находится вся необходимая инфраструктура: торговые галереи, международные школы, больницы мирового уровня. До международного аэропорта Пхукета 25 минут езды на автомобиле.<p>"}};/* harmony default export */ __webpack_exports__["a"] = ({landingPage:landingPage,map:map,content:content});

/***/ }),
/* 788 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(2);
/* harmony default export */ __webpack_exports__["a"] = ({title:"The Santuary Club",description:{en:"Experience ultimate lifestyle within worldwide network under the Banyan Group. Membership is exclusively offered to the owners of Laguna, Banyan Tree, Angsana and Cassia properties only.",cn:"体验悦榕集团全球网络内的终极生活方式。仅向乐古浪、悦榕庄、悦椿和悦梿物业的业主提供会员权益。",ru:"Наслаждайтесь роскошным стилем жизни, пользуясь глобальной сетью компании Banyan Group. Членство предлагается только владельцам собственности в рамках проектов Laguna, Banyan Tree, Angsana и Cassia."},image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])("laguna-beachside")+"/images/the-sanctuary-club/image.jpg"});

/***/ }),
/* 789 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Gallery; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Gallery=function(_Component){_inherits(Gallery,_Component);function Gallery(){_classCallCheck(this,Gallery);return _possibleConstructorReturn(this,(Gallery.__proto__||Object.getPrototypeOf(Gallery)).apply(this,arguments));}_createClass(Gallery,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common__["e" /* Gallery */],this.props);}}]);return Gallery;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 790 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Concept; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_skrollr__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_skrollr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_skrollr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hoc__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_class2,_temp;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Concept=(_dec=Object(__WEBPACK_IMPORTED_MODULE_4__hoc__["a" /* multiLanguage */])(),_dec(_class=(_temp=_class2=function(_Component){_inherits(Concept,_Component);function Concept(){_classCallCheck(this,Concept);return _possibleConstructorReturn(this,(Concept.__proto__||Object.getPrototypeOf(Concept)).apply(this,arguments));}_createClass(Concept,[{key:"render",value:function render(){var _props=this.props,page=_props.page,t=_props.t,imageSlider=_props.imageSlider,content=_props.content;var logoImage=Object(__WEBPACK_IMPORTED_MODULE_6__utils__["a" /* assetsPath */])(page)+"/images/logo/logo-gray.png";if(page==="phuket-dusit-deluxe-pool-villa"){logoImage=Object(__WEBPACK_IMPORTED_MODULE_6__utils__["a" /* assetsPath */])(page)+"/images/logo/logo-white.png";}else if(page==="phuket-skypark"){logoImage=Object(__WEBPACK_IMPORTED_MODULE_6__utils__["a" /* assetsPath */])(page)+"/images/logo/logo-white.png";}else if(page==="laguna-beachside"){logoImage=Object(__WEBPACK_IMPORTED_MODULE_6__utils__["a" /* assetsPath */])(page)+"/images/logo/logo-white.png";}else if(page==="laguna-seaside-residences"){logoImage=Object(__WEBPACK_IMPORTED_MODULE_6__utils__["a" /* assetsPath */])(page)+"/images/logo/logo-white.png";}else if(page==="laguna-seaside-residences-dev"){logoImage=Object(__WEBPACK_IMPORTED_MODULE_6__utils__["a" /* assetsPath */])(page)+"/images/logo/logo-white.png";}console.log("logoImage",{page:page,logoImage:logoImage});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"section-concept"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"row no-gutters"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-xl-6"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"parallax-container"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_skrollr__["Parallax"],{data:{"data-top-top":"transform: translateY(0px);"// "data-top-bottom": "transform: translateY(250px);"
}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"image-slider-block"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components__["p" /* Slider */],{settings:{arrows:false,dots:true},items:imageSlider,uiRenderer:function uiRenderer(item){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"img-background",style:{backgroundImage:"url('"+__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(item,"image")+"')",backgroundPosition:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(item,"backgroundPosition","center center")}});}}))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-xl-6"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"content-block"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components__["j" /* Logo */],{src:logoImage}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h2",{style:{// marginTop: page === "laguna-beachside" ? "80px" : "30px",
marginTop:"80px",marginBottom:"20px"}},t("Concept")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"description",dangerouslySetInnerHTML:{__html:t(content)}})))));}}]);return Concept;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]),_class2.propTypes={t:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired},_temp))||_class);

/***/ }),
/* 791 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Destination; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_find__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_skrollr__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_skrollr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_skrollr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__containers_ProjectMap__ = __webpack_require__(792);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_PhuketMap__ = __webpack_require__(817);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__hoc__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Compass=function Compass(){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("img",{className:"compass",src:Object(__WEBPACK_IMPORTED_MODULE_9__utils__["a" /* assetsPath */])()+"/images/compass/compass-2x-north.png",alt:"compass",style:{position:"absolute",top:"8%",right:"2%",width:60}});};var Destination=(_dec=Object(__WEBPACK_IMPORTED_MODULE_8__hoc__["a" /* multiLanguage */])(),_dec(_class=function(_Component){_inherits(Destination,_Component);function Destination(props){_classCallCheck(this,Destination);var _this=_possibleConstructorReturn(this,(Destination.__proto__||Object.getPrototypeOf(Destination)).call(this,props));_this.handleCloseModal=function(){// reset
if(_this.projectMapRef&&_this.projectMapRef.current)_this.projectMapRef.current.reset();if(_this.phuketMapRef&&_this.phuketMapRef.current)_this.phuketMapRef.current.reset();// close
_this.setState({open:false});};_this.handleClickButtonMenu=function(key){console.log("handleClickButtonMenu",key);_this.setState({open:true,page:key});};_this.renderCountryMap=function(imageMap){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:"page-map"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:"page-map-background",style:{backgroundImage:"url("+imageMap+")"}}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Compass,null));};_this.renderCityMap=function(imageMap){var _this$props=_this.props,t=_this$props.t,currentLanguage=_this$props.currentLanguage;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__containers_PhuketMap__["a" /* default */],{t:t,currentLanguage:currentLanguage,isMobile:_this.props.isMobile,ref:_this.phuketMapRef}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Compass,null));};_this.renderProjectMap=function(imageMap){var _this$props2=_this.props,t=_this$props2.t,currentLanguage=_this$props2.currentLanguage,project=_this$props2.project;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Fragment,null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__containers_ProjectMap__["a" /* default */],{t:t,currentLanguage:currentLanguage,ref:_this.projectMapRef,project:project}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Compass,null));};_this.state={// open: true,
// page: "project",
open:false,page:"country"};_this.projectMapRef=__WEBPACK_IMPORTED_MODULE_3_react___default.a.createRef();_this.phuketMapRef=__WEBPACK_IMPORTED_MODULE_3_react___default.a.createRef();return _this;}_createClass(Destination,[{key:"render",value:function render(){var _this2=this;var _state=this.state,open=_state.open,page=_state.page;var _props=this.props,t=_props.t,currentLanguage=_props.currentLanguage,imageSlider=_props.imageSlider,title=_props.title,description=_props.description,mapData=_props.mapData;var findKey=__WEBPACK_IMPORTED_MODULE_2_lodash_find___default()(mapData,["value",page]);var keyValue=__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(findKey,"value");console.log("render-destination",page);var imageMap=void 0;if(keyValue==="country"){imageMap=__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(findKey,"image."+currentLanguage);}if(keyValue==="city"||keyValue==="project"){imageMap=__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(findKey,"images");}return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:"section-destination"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:"parallax-container"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_skrollr__["Parallax"],{data:{"data-bottom-top":"transform: translateY(0);","data-top-bottom":"transform: translateY(0);"}},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:"container-slider"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components__["p" /* Slider */],{type:"type-background",sliderRef:this.sliderRef,items:imageSlider,settings:{arrows:false},uiRenderer:function uiRenderer(item,index){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:"img-background",style:{backgroundImage:"url("+item.image+")",backgroundPosition:item.backgroundPosition}});}})))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:"container-destination-content"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:"destination-content"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("h2",null,t(title)),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{dangerouslySetInnerHTML:{__html:t(description)}}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:"destination-button"},__WEBPACK_IMPORTED_MODULE_0_lodash_map___default()(mapData,function(item,index){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components__["b" /* Button */],{key:index,type:"primary",hoverStyle:{backgroundColor:"white",color:"#04a8a6"},defaultStyle:{marginRight:"5px",marginBottom:"7px",padding:"2px 11px"},onClick:function onClick(){return _this2.handleClickButtonMenu(item.value);}},t(item.name));})))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:"destination-modal-content"},open&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components__["k" /* Modal */],{name:"destination-modal",onCancel:this.handleCloseModal},page==="country"&&this.renderCountryMap(imageMap),page==="city"&&this.renderCityMap(imageMap),page==="project"&&this.renderProjectMap(imageMap),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:"destination-button-group"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components__["c" /* ButtonGroup */],{value:page,items:mapData,onChange:function onChange(value){return _this2.setState({page:value});},direction:"horizontal",renderItem:function renderItem(_ref){var value=_ref.value,name=_ref.name,active=_ref.active,onClick=_ref.onClick;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components__["b" /* Button */],{key:value,type:"secondary",active:active,activeStyle:{backgroundColor:"#00a9a5"},hoverStyle:{backgroundColor:"#00a9a5"},defaultStyle:{padding:"12px 17px",marginRight:"2px",fontWeight:"bold",fontSize:"13px",letterSpacing:"1px"},onClick:onClick},t(name));}})))));}}]);return Destination;}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]))||_class);

/***/ }),
/* 792 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__ProjectMap__ = __webpack_require__(793);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__ProjectMap__["a"]; });


/***/ }),
/* 793 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_includes__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_filter__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_cloneDeep__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_merge__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_merge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_reduce__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_reduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_reduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_animejs__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_animejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_animejs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_responsive__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_react_responsive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_react_responsive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_Button__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_ButtonGroup__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__components_GalleryLightbox__ = __webpack_require__(192);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components_Compass__ = __webpack_require__(812);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__components_Bus__ = __webpack_require__(813);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__components_svg_Pin__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__components_svg_MultiLineText__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__utils_detector__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__common__ = __webpack_require__(333);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__common_pins__ = __webpack_require__(816);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__common_logos__ = __webpack_require__(66);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp2;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Mobile=function Mobile(props){return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_responsive___default.a,Object.assign({},props,{maxWidth:767}));};var Desktop=function Desktop(props){return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9_react_responsive___default.a,Object.assign({},props,{minWidth:768}));};var fixIETransform=function fixIETransform(id){return function(anim){var g=document.getElementById(id);if(g){var transform=getComputedStyle(g).getPropertyValue("transform");g.setAttribute("transform",transform);}};};var contentPath="https://d3vqeivyse4uh3.cloudfront.net/www/lagunaproperty";var iconHotel=contentPath+"/assets/images/project-map/project-icon-01.png";var iconRestaurant=contentPath+"/assets/images/project-map/project-icon-02.png";var iconSpa=contentPath+"/assets/images/project-map/project-icon-03.png";var iconGallery=contentPath+"/assets/images/project-map/project-icon-04.png";var iconBus=contentPath+"/assets/images/project-map/project-icon-05.png";var iconBoat=contentPath+"/assets/images/project-map/project-icon-06.png";var INITIAL_STATE={currentPage:"hotel",lightboxIsOpen:false,lightboxCurrentImage:0,lightboxImages:[]};var overwriteMerge=function overwriteMerge(destinationArray,sourceArray,options){var destination=destinationArray.slice();sourceArray.forEach(function(e,i){Object.keys(e).forEach(function(key){// console.log(destination[0][key])
destination[i][key]=sourceArray[i][key];});});return destination;};var switchLanguage=function switchLanguage(activeLanguage){switch(activeLanguage){case"cn":return __WEBPACK_IMPORTED_MODULE_20__common__["a" /* CHtexts */];case"ru":return __WEBPACK_IMPORTED_MODULE_20__common__["b" /* RUtexts */];default:return __WEBPACK_IMPORTED_MODULE_20__common__["c" /* texts */];}};// Render Side Button
var renderButton=function renderButton(_ref){var value=_ref.value,label=_ref.label,icon=_ref.icon,active=_ref.active,type=_ref.type,key=_ref.key,onClick=_ref.onClick;return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_Button__["a" /* default */],{key:key,type:"default",active:active,activeStyle:{backgroundColor:"#ffffff",color:"black"},hoverStyle:{backgroundColor:"#ffffff",color:"black"},defaultStyle:{marginRight:"3px",backgroundColor:"#dbdbdb",padding:"2px 5px 2px 5px",letterSpacing:0,color:"black",marginBottom:"3px"},onClick:onClick},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div",{style:{display:"flex",alignItems:"center"}},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("img",{src:icon,width:23,height:23,style:{marginRight:7},alt:""}),label));};var ProjectMap=(_temp2=_class=function(_React$Component){_inherits(ProjectMap,_React$Component);function ProjectMap(){var _ref2;var _temp,_this,_ret;_classCallCheck(this,ProjectMap);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref2=ProjectMap.__proto__||Object.getPrototypeOf(ProjectMap)).call.apply(_ref2,[this].concat(args))),_this),_this.state=INITIAL_STATE,_this.reset=function(){_this.setState(INITIAL_STATE);},_this.handleChangePage=function(page){return _this.setState({currentPage:page});},_this.filterTextsByPage=function(page){var _this$props=_this.props,currentLanguage=_this$props.currentLanguage,project=_this$props.project;var selActiveLanguage=switchLanguage(currentLanguage);var mergedTexts=__WEBPACK_IMPORTED_MODULE_5_lodash_merge___default()(__WEBPACK_IMPORTED_MODULE_4_lodash_cloneDeep___default()(__WEBPACK_IMPORTED_MODULE_20__common__["c" /* texts */]),selActiveLanguage,{arrayMerge:overwriteMerge});return __WEBPACK_IMPORTED_MODULE_3_lodash_filter___default()(mergedTexts,function(text,i){var excludeList=__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(text,"options.excludes",[]);if(__WEBPACK_IMPORTED_MODULE_1_lodash_includes___default()(excludeList,"project-map/"+page)||__WEBPACK_IMPORTED_MODULE_1_lodash_includes___default()(excludeList,"project-map")||__WEBPACK_IMPORTED_MODULE_1_lodash_includes___default()(excludeList,"project-map/project/"+project))return false;return true;});},_this.filterTextsForMobile=function(page){var _this$props2=_this.props,currentLanguage=_this$props2.currentLanguage,project=_this$props2.project;var selActiveLanguage=switchLanguage(currentLanguage);var mergedTexts=__WEBPACK_IMPORTED_MODULE_5_lodash_merge___default()(__WEBPACK_IMPORTED_MODULE_4_lodash_cloneDeep___default()(__WEBPACK_IMPORTED_MODULE_20__common__["c" /* texts */]),selActiveLanguage,{arrayMerge:overwriteMerge});return __WEBPACK_IMPORTED_MODULE_3_lodash_filter___default()(mergedTexts,function(text,i){var excludeList=__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(text,"options.excludes",[]);if(__WEBPACK_IMPORTED_MODULE_1_lodash_includes___default()(excludeList,"masterplan")||__WEBPACK_IMPORTED_MODULE_1_lodash_includes___default()(excludeList,"project-map/project/"+project))return false;return true;});},_this.handleClickPin=function(markerProps){_this.setState({lightboxIsOpen:true,lightboxCurrentImage:0,lightboxImages:markerProps.images});},_this.gotoPrevious=function(){_this.setState({currentImage:_this.state.currentImage-1});},_this.gotoNext=function(){_this.setState({currentImage:_this.state.currentImage+1});},_this.gotoImage=function(index){_this.setState({currentImage:index});},_this.closeLightbox=function(){_this.setState({lightboxIsOpen:false});},_this.gotoPrevious=function(){_this.setState({lightboxCurrentImage:_this.state.lightboxCurrentImage-1});},_this.gotoNext=function(){_this.setState({lightboxCurrentImage:_this.state.lightboxCurrentImage+1});},_this.gotoImage=function(index){_this.setState({lightboxCurrentImage:index});},_this.renderTextBubble=function(bubbleProps,markerProps){var text=bubbleProps.text,width=bubbleProps.width,style=bubbleProps.style;// const { currentLanguage } = markerProps;
var offsetX=20;var rectWidth=2*offsetX+width;// const translateText = _.get(text, currentLanguage, ['']);
return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("rect",{x:"0",y:"0",width:rectWidth,height:"40",rx:"20",ry:"20",fill:markerProps.color}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__components_svg_MultiLineText__["a" /* default */],{text:text,x:offsetX,y:4,textAnchor:"start",width:width,height:32,style:Object.assign({},style,{fill:"white"})}));},_this.renderRestaurantBubble=function(bubbleProps,markerProps){var t=_this.props.t;var url=bubbleProps.url,width=bubbleProps.width,height=bubbleProps.height,num=bubbleProps.num;var arrowSize=10;var offsetX=20;var rectWidth=2*offsetX+32*width/height;return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("rect",{x:"0",y:"0",width:rectWidth,height:"68",rx:"20",ry:"20",fill:"#d68000"}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("image",{x:offsetX,y:4,width:32*width/height,xlinkHref:url,height:32}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("rect",{x:0,y:40,width:rectWidth,height:1,fill:"white",opacity:0.5}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("text",{x:0.5*rectWidth,y:56,width:rectWidth,height:28,textAnchor:"middle",style:{fill:"white",fontSize:10}},num," ",num===1?t("Restaurant"):t("Restaurants")),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("svg",{viewBox:"0 0 100 100",x:rectWidth-28+0.5*(28-arrowSize),y:40+0.5*(28-arrowSize)-1,width:arrowSize,height:arrowSize},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("path",{d:"M25.5,100 75.5,50 25.5,0",fill:"none",stroke:"white",strokeWidth:5})));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ProjectMap,[{key:"playBusRoute",value:function playBusRoute(){// Bus 1
var bus1Paths=[{path:__WEBPACK_IMPORTED_MODULE_8_animejs___default.a.path("#bus-trail1"),duration:5000},{path:__WEBPACK_IMPORTED_MODULE_8_animejs___default.a.path("#bus-trail2"),duration:4000},{path:__WEBPACK_IMPORTED_MODULE_8_animejs___default.a.path("#bus-trail3"),duration:4000},{path:__WEBPACK_IMPORTED_MODULE_8_animejs___default.a.path("#bus-trail4"),duration:5000},{path:__WEBPACK_IMPORTED_MODULE_8_animejs___default.a.path("#bus-trail5"),duration:5000}];var bus1Timeline=__WEBPACK_IMPORTED_MODULE_6_lodash_reduce___default()(bus1Paths,function(timeline,busPath){return timeline.add({targets:"#bus-1",translateX:busPath.path("x"),translateY:busPath.path("y"),easing:"easeInOutQuad",duration:busPath.duration,delay:500,update:__WEBPACK_IMPORTED_MODULE_19__utils_detector__["a" /* isIE */]?fixIETransform("bus-1"):null});},__WEBPACK_IMPORTED_MODULE_8_animejs___default.a.timeline({direction:"alternate",loop:true,delay:500}));bus1Timeline.play();// Bus 2
var bus2Paths=[// { path: anime.path("#bus-trail1"), duration: 5000 },
{path:__WEBPACK_IMPORTED_MODULE_8_animejs___default.a.path("#bus-trail2"),duration:4000},{path:__WEBPACK_IMPORTED_MODULE_8_animejs___default.a.path("#bus-trail3"),duration:4000},{path:__WEBPACK_IMPORTED_MODULE_8_animejs___default.a.path("#bus-trail4"),duration:5000}];var bus2Timeline=__WEBPACK_IMPORTED_MODULE_6_lodash_reduce___default()(bus2Paths,function(timeline,busPath){return timeline.add({targets:"#bus-2",translateX:busPath.path("x"),translateY:busPath.path("y"),easing:"easeInOutQuad",duration:busPath.duration,delay:500,update:__WEBPACK_IMPORTED_MODULE_19__utils_detector__["a" /* isIE */]?fixIETransform("bus-2"):null});},__WEBPACK_IMPORTED_MODULE_8_animejs___default.a.timeline({direction:"alternate",loop:true,delay:3500}));bus2Timeline.play();// Bus 2
var bus3Paths=[{path:__WEBPACK_IMPORTED_MODULE_8_animejs___default.a.path("#bus-trail1"),duration:5000},{path:__WEBPACK_IMPORTED_MODULE_8_animejs___default.a.path("#bus-trail2"),duration:4000},{path:__WEBPACK_IMPORTED_MODULE_8_animejs___default.a.path("#bus-trail3"),duration:4000},{path:__WEBPACK_IMPORTED_MODULE_8_animejs___default.a.path("#bus-trail4"),duration:5000},{path:__WEBPACK_IMPORTED_MODULE_8_animejs___default.a.path("#bus-trail5"),duration:5000}];var bus3Timeline=__WEBPACK_IMPORTED_MODULE_6_lodash_reduce___default()(bus3Paths,function(timeline,busPath){return timeline.add({targets:"#bus-3",translateX:busPath.path("x"),translateY:busPath.path("y"),easing:"easeInOutQuad",duration:busPath.duration,delay:500,update:__WEBPACK_IMPORTED_MODULE_19__utils_detector__["a" /* isIE */]?fixIETransform("bus-3"):null});},__WEBPACK_IMPORTED_MODULE_8_animejs___default.a.timeline({direction:"alternate",loop:true,delay:500}));bus3Timeline.seek(bus3Timeline.duration);bus3Timeline.reverse();}},{key:"playBoatRoute",value:function playBoatRoute(){var boatPaths=[{path:__WEBPACK_IMPORTED_MODULE_8_animejs___default.a.path("#boat-trail1"),duration:3000},{path:__WEBPACK_IMPORTED_MODULE_8_animejs___default.a.path("#boat-trail2"),duration:2000},{path:__WEBPACK_IMPORTED_MODULE_8_animejs___default.a.path("#boat-trail3"),duration:2000},{path:__WEBPACK_IMPORTED_MODULE_8_animejs___default.a.path("#boat-trail4"),duration:3000},{path:__WEBPACK_IMPORTED_MODULE_8_animejs___default.a.path("#boat-trail5"),duration:3000},{path:__WEBPACK_IMPORTED_MODULE_8_animejs___default.a.path("#boat-trail6"),duration:3000},{path:__WEBPACK_IMPORTED_MODULE_8_animejs___default.a.path("#boat-trail7"),duration:2000},{path:__WEBPACK_IMPORTED_MODULE_8_animejs___default.a.path("#boat-trail8"),duration:2000},{path:__WEBPACK_IMPORTED_MODULE_8_animejs___default.a.path("#boat-trail9"),duration:3000},{path:__WEBPACK_IMPORTED_MODULE_8_animejs___default.a.path("#boat-trail10"),duration:3000},{path:__WEBPACK_IMPORTED_MODULE_8_animejs___default.a.path("#boat-trail11"),duration:3000}];var boatTimeline=__WEBPACK_IMPORTED_MODULE_6_lodash_reduce___default()(boatPaths,function(timeline,boatPath){return timeline.add({targets:"#boat",translateX:boatPath.path("x"),translateY:boatPath.path("y"),easing:"easeInOutQuad",duration:boatPath.duration||5000,delay:500,update:__WEBPACK_IMPORTED_MODULE_19__utils_detector__["a" /* isIE */]?fixIETransform("boat"):null});},__WEBPACK_IMPORTED_MODULE_8_animejs___default.a.timeline({direction:"alternate",loop:true,delay:500}));boatTimeline.play();}},{key:"componentDidUpdate",value:function componentDidUpdate(){if(this.state.currentPage==="boat")this.playBoatRoute();if(this.state.currentPage==="bus")this.playBusRoute();}},{key:"render",value:function render(){var _this2=this;var _props=this.props,pins=_props.pins,t=_props.t,currentLanguage=_props.currentLanguage,_props$project=_props.project,project=_props$project===undefined?"phuket-skypark":_props$project,children=_props.children;// const baseAssetUrl = assetsPath("phuket-laguna-park-2");
// const baseAssetUrl = assetsPath("phuket-skypark");
var baseAssetUrl=Object(__WEBPACK_IMPORTED_MODULE_18__utils__["a" /* assetsPath */])(project);var bg=baseAssetUrl+"/images/project-map/phuket-masterplan-"+currentLanguage+".png";// const bg = `${baseAssetUrl}/images/project-map/phuket-masterplan-no-logo-${currentLanguage}.png`;
var _state=this.state,currentPage=_state.currentPage,lightboxIsOpen=_state.lightboxIsOpen,lightboxCurrentImage=_state.lightboxCurrentImage,lightboxImages=_state.lightboxImages;var filteredTexts=this.filterTextsByPage(currentPage);var filteredTextsMobile=this.filterTextsForMobile(currentPage);var pinsToRender=__WEBPACK_IMPORTED_MODULE_0_lodash_map___default()(pins,function(pin){if(pin.group==="restaurant"){return Object.assign({},pin,{bubble:Object.assign({},pin.bubble,{render:_this2.renderRestaurantBubble})});}if(pin.group==="spa"||pin.group==="gallery"){return Object.assign({},pin,{bubble:Object.assign({},pin.bubble,{render:_this2.renderTextBubble})});}return pin;});console.log("render-project-map",project);return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div",{className:"project-map-container"},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("svg",{className:"project-map",viewBox:"0 0 1730 1080",width:"100%"},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("image",{xlinkHref:bg,x:0,y:0,width:"100%",height:1080}),currentPage==="bus"&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("g",{// style={{ transform: "scale(0.96) translate(73px, -25px)" }}
style:{transform:"scale(0.824) translate(230px, 20px)"}},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("path",{id:"bus-trail1","class":"bus-trail",d:"M261,212.5c0,0,0.3,1.8-0.7,6c-1,4.2-22,64.5-21,79.2c1,14.7,9.3,17.5,12.7,20 s9.2,8.7,13,12.2s8,3.8,13,10c5,6.2,1,22.7,4.2,27.9c3.2,5.2,26,14.5,34.7,19.2c8.7,4.7,16.8,16.8,16.8,16.8s7.2-2.3,12-4 c4.8-1.7,8.2-1.7,12-3.7c3.8-2,8.3-6,12.2-14.3c3.8-8.3,6.8-17.5,13.3-21.7s16.5-1.8,24.7-3.3c3.3-0.6,10.2-4.3,17.3-10.7 c18-16.1,39.8-42.8,44.1-52.3c4.5-10.1,2.1-18.5,1.9-23.4c-0.2-4.9,2.3-2.6,2.3-19.3"}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("path",{id:"bus-trail2","class":"bus-trail",d:"M473.5,250.9c0,16.7-2.5,14.4-2.3,19.3c0.2,4.9,2.6,13.3-1.9,23.4 c-4.2,9.5-26.1,36.3-44.1,52.3c0,0,10.3,10.2,14.1,16.8s5.8,19.5,6,27.8s-0.2,19.2,1.2,22.5s5.8,8,5.8,8s-3.6,0-6.2,1.5 c-3.3,1.9-9.4,9.6-12.6,16c-5.8,11.3-12,21.5-12,21.5"}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("path",{id:"bus-trail3","class":"bus-trail",d:"M421.4,460c0,0,6.2-10.2,12-21.5c3.2-6.4,9.3-14.1,12.6-16c2.6-1.5,6.2-1.5,6.2-1.5 s8.5,2.5,14.8,2.2s30.8-3.5,37.4-6.6s22.1-14,34.9-23.1s20.3-12.4,32.7-13.5s31.2,0,31.2,0s1.5-8.9,1.5-23.6s-1.8-20.8-1.5-24.4 s1.5-4,1.5-4"}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("path",{id:"bus-trail4","class":"bus-trail",d:"M604.8,328c0,0-1.2,0.4-1.5,4s1.5,9.6,1.5,24.4s-1.5,23.6-1.5,23.6s14.2,1.1,20.9,2.5 s19.6,4.8,29,7.4s19.8,5.4,19.8,5.4s3.1,8.6,4.1,16.9s1.9,14.3,3,19.2c1.1,4.9,3.2,7.8,5.2,16.4s5,20.4,5,20.4"}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("path",{id:"bus-trail5","class":"bus-trail",d:"M690.2,468.1c0,0-3-11.8-5-20.4s-4.2-11.4-5.2-16.4c-1.1-5-2-11-3-19.2 s-4.1-16.9-4.1-16.9s4.5,1.9,12.8-1.5s23-14.4,26.9-18s18.8-12.6,29-23.6s15.1-21,22.4-26.2s25.1-9.5,32.6-15.8s12.5-12,21-12.8 s10,0,10,0"})),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("g",{className:"xxxx",style:{transform:"scale(0.824) translate(230px, 20px)"}// style={{ transform: "scale(0.96) translate(73px, -25px)" }}
},currentPage==="boat"&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("path",{id:"boat-trail11",className:"boat-trail",d:"M802.5,254c8-0.5,15-1.7,21.7-1.2c6.8,0.5,16.4,5.7,24.9,5.2s14.5-5.8,26.5-4.7 S900,267,900,267"}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("path",{id:"boat-trail10",className:"boat-trail",d:"M646.5,325c0,0,43-6.5,59.5-17s37.3-43.3,56.5-49.5c12-3.9,32-4,40-4.5"}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("path",{id:"boat-trail9",className:"boat-trail",d:"M583,265.5c0,0-8.5,28,1.5,41.5c6.5,8,48.7,4.5,62,8c7.3,1.9,5,9.5,0,10"}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("path",{id:"boat-trail8",className:"boat-trail",d:"M627,255.5c0,0-29.5-28.5-42.5-19s-1.5,29-1.5,29"}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("path",{id:"boat-trail7",className:"boat-trail",d:"M621.5,219.5c0,0,4,9,5.5,16s0,20,0,20"}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("path",{id:"boat-trail6",className:"boat-trail",d:"M595.5,209c0,0,2.3,8.5,9.8,10.5s16.2,0,16.2,0"}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("path",{id:"boat-trail5",className:"boat-trail",d:"M542,276c0,0,11.7-27.7,26.2-46.5c7.3-9.5,24.7-19.5,27.3-20.5"}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("path",{id:"boat-trail4",className:"boat-trail",d:"M396.5,311.5c0,0,4.9-33.7,15.7-39.7s31.7-0.4,63.2-1c27.1-0.5,55.1-3.6,61-3.5 c5.5,1,5.6,8.7,5.6,8.7"}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("path",{id:"boat-trail3",className:"boat-trail",d:"M426,229c0,0-17.9,10.6-26.8,38c-8.8,27.2-2.8,44.5-2.8,44.5"}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("path",{id:"boat-trail2",className:"boat-trail",d:"M408.5,211.5c0,0-2,6.5,3.5,11.5s14,6,14,6"}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("path",{id:"boat-trail1",className:"boat-trail",d:"M297.5,211.5c0,0,25,13.5,55.5,14s55.5-14,55.5-14"})),currentPage==="boat"&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("g",{id:"boat"},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("svg",{viewBox:"0 0 81 109",x:-20,y:-52,width:40,height:52},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("path",{fill:"#a28e81",d:"M81,40.5C81,72,40.83,109,40.83,109S0,71,0,40.5a40.5,40.5,0,0,1,81,0Z"}),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("g",{transform:"scale(0.6) translate(30 20)"},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("path",{fill:"white",d:"M3.5,74.2c21.1-2.5,44.9-5.4,66-7.9c-2.9,8.1-9.5,11.4-12.9,16.9c-15-6.9-32.6,4.9-49.9,0 C5.6,80.2,4.6,77.2,3.5,74.2L3.5,74.2z M35,0.6c0,1.9,0,3.8,0,5.6C30.6,4.7,26.1,4,21.7,4.2l0,1.8c-3.9,1.2-7.7,0.3-11.4-0.7 c2.1-0.3,4.2-0.4,6.3-0.8l-0.2-2.2C22.5-0.3,28.7-0.4,35,0.6L35,0.6z M0,83.3c8.4,4.4,20.2,7.8,35.3,4.7c13.8-2.9,23,0.7,34.8-1.2 c-12.1-0.1-16.9-5.3-25.3-3.9C13.5,89,9.6,85.1,0,83.3L0,83.3z M34.1,67.5V17.7L2.4,65.8L34.1,67.5L34.1,67.5z M63.8,65.4 C67,40,56.1,21.6,35.5,7.9c3.8,23,4.2,43.2,1,60.8C45.8,67.5,55,66.4,63.8,65.4z"}))))),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("g",{id:"pins",className:"d-none d-md-block"// style={{ transform: "scale(0.824) translate(230px, 20px)" }}
,style:{transform:"scale(0.96) translate(75px, -25px)"}},pinsToRender.map(function(pin,i){return __WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__components_svg_Pin__["a" /* default */],Object.assign({t:t,key:"pin-"+i},pin,{// x={100}
// y={100}
currentLanguage:currentLanguage,onClick:function onClick(pinProps){return _this2.handleClickPin(pinProps);},visible:pin.group===currentPage}));})),currentPage==="bus"&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("g",{// style={{ transform: "scale(0.96) translate(73px, -25px)" }}
style:{transform:"scale(0.824) translate(230px, 20px)"}},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("g",{id:"bus-1"},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_Bus__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("g",{id:"bus-2"},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_Bus__["a" /* default */],null)),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("g",{id:"bus-3"},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__components_Bus__["a" /* default */],null))),children),currentPage==="boat"&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("div",{className:"boat-legend"},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("span",null,"1"),t("Outrigger Hotel Phuket Beach Resort")),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("span",null,"2"),t("Cassia Beach")),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("span",null,"3"),t("Dusit Thani Laguna Phuket")),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("span",null,"4"),t("Cassia Hotel")),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("span",null,"5"),t("Canal Village Shopping")),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("span",null,"6"),t("Xana Beach Club")),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("span",null,"7"),t("Baan Talay Restaurant")),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("span",null,"8"),t("Angsana Poolside")),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("span",null,"9"),t("Bodega Restaurant")),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("span",null,"10"),t("Angsana Lobby")),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("span",null,"11"),t("Banyan Tree Spa")),__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement("span",null,"12"),t("Banyan Tree Lobby")))),lightboxIsOpen&&__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components__["k" /* Modal */],{name:"project-map-gallery-modal",onCancel:this.closeLightbox},__WEBPACK_IMPORTED_MODULE_7_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__components_GalleryLightbox__["a" /* default */],{currentImage:lightboxCurrentImage,images:__WEBPACK_IMPORTED_MODULE_0_lodash_map___default()(lightboxImages,function(value){return{src:__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(value,"url"),caption:t(__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(value,"name"))};}),onClickPrev:this.gotoPrevious,onClickNext:this.gotoNext,onClickThumbnail:this.gotoImage})));}}]);return ProjectMap;}(__WEBPACK_IMPORTED_MODULE_7_react___default.a.Component),_class.defaultProps={texts:__WEBPACK_IMPORTED_MODULE_20__common__["c" /* texts */],pins:__WEBPACK_IMPORTED_MODULE_21__common_pins__["a" /* default */]},_temp2);/* harmony default export */ __webpack_exports__["a"] = (ProjectMap);

/***/ }),
/* 794 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(86),
    keys = __webpack_require__(59);

/**
 * The base implementation of `_.assign` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssign(object, source) {
  return object && copyObject(source, keys(source), object);
}

module.exports = baseAssign;


/***/ }),
/* 795 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(86),
    keysIn = __webpack_require__(109);

/**
 * The base implementation of `_.assignIn` without support for multiple sources
 * or `customizer` functions.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @returns {Object} Returns `object`.
 */
function baseAssignIn(object, source) {
  return object && copyObject(source, keysIn(source), object);
}

module.exports = baseAssignIn;


/***/ }),
/* 796 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(86),
    getSymbols = __webpack_require__(154);

/**
 * Copies own symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbols(source, object) {
  return copyObject(source, getSymbols(source), object);
}

module.exports = copySymbols;


/***/ }),
/* 797 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(86),
    getSymbolsIn = __webpack_require__(309);

/**
 * Copies own and inherited symbols of `source` to `object`.
 *
 * @private
 * @param {Object} source The object to copy symbols from.
 * @param {Object} [object={}] The object to copy symbols to.
 * @returns {Object} Returns `object`.
 */
function copySymbolsIn(source, object) {
  return copyObject(source, getSymbolsIn(source), object);
}

module.exports = copySymbolsIn;


/***/ }),
/* 798 */
/***/ (function(module, exports) {

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Initializes an array clone.
 *
 * @private
 * @param {Array} array The array to clone.
 * @returns {Array} Returns the initialized clone.
 */
function initCloneArray(array) {
  var length = array.length,
      result = new array.constructor(length);

  // Add properties assigned by `RegExp#exec`.
  if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
    result.index = array.index;
    result.input = array.input;
  }
  return result;
}

module.exports = initCloneArray;


/***/ }),
/* 799 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(202),
    cloneDataView = __webpack_require__(800),
    cloneRegExp = __webpack_require__(801),
    cloneSymbol = __webpack_require__(802),
    cloneTypedArray = __webpack_require__(323);

/** `Object#toString` result references. */
var boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]';

var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

/**
 * Initializes an object clone based on its `toStringTag`.
 *
 * **Note:** This function only supports cloning values with tags of
 * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
 *
 * @private
 * @param {Object} object The object to clone.
 * @param {string} tag The `toStringTag` of the object to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the initialized clone.
 */
function initCloneByTag(object, tag, isDeep) {
  var Ctor = object.constructor;
  switch (tag) {
    case arrayBufferTag:
      return cloneArrayBuffer(object);

    case boolTag:
    case dateTag:
      return new Ctor(+object);

    case dataViewTag:
      return cloneDataView(object, isDeep);

    case float32Tag: case float64Tag:
    case int8Tag: case int16Tag: case int32Tag:
    case uint8Tag: case uint8ClampedTag: case uint16Tag: case uint32Tag:
      return cloneTypedArray(object, isDeep);

    case mapTag:
      return new Ctor;

    case numberTag:
    case stringTag:
      return new Ctor(object);

    case regexpTag:
      return cloneRegExp(object);

    case setTag:
      return new Ctor;

    case symbolTag:
      return cloneSymbol(object);
  }
}

module.exports = initCloneByTag;


/***/ }),
/* 800 */
/***/ (function(module, exports, __webpack_require__) {

var cloneArrayBuffer = __webpack_require__(202);

/**
 * Creates a clone of `dataView`.
 *
 * @private
 * @param {Object} dataView The data view to clone.
 * @param {boolean} [isDeep] Specify a deep clone.
 * @returns {Object} Returns the cloned data view.
 */
function cloneDataView(dataView, isDeep) {
  var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
  return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
}

module.exports = cloneDataView;


/***/ }),
/* 801 */
/***/ (function(module, exports) {

/** Used to match `RegExp` flags from their coerced string values. */
var reFlags = /\w*$/;

/**
 * Creates a clone of `regexp`.
 *
 * @private
 * @param {Object} regexp The regexp to clone.
 * @returns {Object} Returns the cloned regexp.
 */
function cloneRegExp(regexp) {
  var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
  result.lastIndex = regexp.lastIndex;
  return result;
}

module.exports = cloneRegExp;


/***/ }),
/* 802 */
/***/ (function(module, exports, __webpack_require__) {

var Symbol = __webpack_require__(71);

/** Used to convert symbols to primitives and strings. */
var symbolProto = Symbol ? Symbol.prototype : undefined,
    symbolValueOf = symbolProto ? symbolProto.valueOf : undefined;

/**
 * Creates a clone of the `symbol` object.
 *
 * @private
 * @param {Object} symbol The symbol object to clone.
 * @returns {Object} Returns the cloned symbol object.
 */
function cloneSymbol(symbol) {
  return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
}

module.exports = cloneSymbol;


/***/ }),
/* 803 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsMap = __webpack_require__(804),
    baseUnary = __webpack_require__(95),
    nodeUtil = __webpack_require__(121);

/* Node.js helper references. */
var nodeIsMap = nodeUtil && nodeUtil.isMap;

/**
 * Checks if `value` is classified as a `Map` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 * @example
 *
 * _.isMap(new Map);
 * // => true
 *
 * _.isMap(new WeakMap);
 * // => false
 */
var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

module.exports = isMap;


/***/ }),
/* 804 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(72),
    isObjectLike = __webpack_require__(26);

/** `Object#toString` result references. */
var mapTag = '[object Map]';

/**
 * The base implementation of `_.isMap` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a map, else `false`.
 */
function baseIsMap(value) {
  return isObjectLike(value) && getTag(value) == mapTag;
}

module.exports = baseIsMap;


/***/ }),
/* 805 */
/***/ (function(module, exports, __webpack_require__) {

var baseIsSet = __webpack_require__(806),
    baseUnary = __webpack_require__(95),
    nodeUtil = __webpack_require__(121);

/* Node.js helper references. */
var nodeIsSet = nodeUtil && nodeUtil.isSet;

/**
 * Checks if `value` is classified as a `Set` object.
 *
 * @static
 * @memberOf _
 * @since 4.3.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 * @example
 *
 * _.isSet(new Set);
 * // => true
 *
 * _.isSet(new WeakSet);
 * // => false
 */
var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

module.exports = isSet;


/***/ }),
/* 806 */
/***/ (function(module, exports, __webpack_require__) {

var getTag = __webpack_require__(72),
    isObjectLike = __webpack_require__(26);

/** `Object#toString` result references. */
var setTag = '[object Set]';

/**
 * The base implementation of `_.isSet` without Node.js optimizations.
 *
 * @private
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is a set, else `false`.
 */
function baseIsSet(value) {
  return isObjectLike(value) && getTag(value) == setTag;
}

module.exports = baseIsSet;


/***/ }),
/* 807 */
/***/ (function(module, exports, __webpack_require__) {

var Stack = __webpack_require__(114),
    assignMergeValue = __webpack_require__(326),
    baseFor = __webpack_require__(250),
    baseMergeDeep = __webpack_require__(808),
    isObject = __webpack_require__(31),
    keysIn = __webpack_require__(109),
    safeGet = __webpack_require__(328);

/**
 * The base implementation of `_.merge` without support for multiple sources.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} [customizer] The function to customize merged values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMerge(object, source, srcIndex, customizer, stack) {
  if (object === source) {
    return;
  }
  baseFor(source, function(srcValue, key) {
    stack || (stack = new Stack);
    if (isObject(srcValue)) {
      baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
    }
    else {
      var newValue = customizer
        ? customizer(safeGet(object, key), srcValue, (key + ''), object, source, stack)
        : undefined;

      if (newValue === undefined) {
        newValue = srcValue;
      }
      assignMergeValue(object, key, newValue);
    }
  }, keysIn);
}

module.exports = baseMerge;


/***/ }),
/* 808 */
/***/ (function(module, exports, __webpack_require__) {

var assignMergeValue = __webpack_require__(326),
    cloneBuffer = __webpack_require__(322),
    cloneTypedArray = __webpack_require__(323),
    copyArray = __webpack_require__(201),
    initCloneObject = __webpack_require__(324),
    isArguments = __webpack_require__(92),
    isArray = __webpack_require__(13),
    isArrayLikeObject = __webpack_require__(809),
    isBuffer = __webpack_require__(93),
    isFunction = __webpack_require__(149),
    isObject = __webpack_require__(31),
    isPlainObject = __webpack_require__(327),
    isTypedArray = __webpack_require__(120),
    safeGet = __webpack_require__(328),
    toPlainObject = __webpack_require__(810);

/**
 * A specialized version of `baseMerge` for arrays and objects which performs
 * deep merges and tracks traversed objects enabling objects with circular
 * references to be merged.
 *
 * @private
 * @param {Object} object The destination object.
 * @param {Object} source The source object.
 * @param {string} key The key of the value to merge.
 * @param {number} srcIndex The index of `source`.
 * @param {Function} mergeFunc The function to merge values.
 * @param {Function} [customizer] The function to customize assigned values.
 * @param {Object} [stack] Tracks traversed source values and their merged
 *  counterparts.
 */
function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
  var objValue = safeGet(object, key),
      srcValue = safeGet(source, key),
      stacked = stack.get(srcValue);

  if (stacked) {
    assignMergeValue(object, key, stacked);
    return;
  }
  var newValue = customizer
    ? customizer(objValue, srcValue, (key + ''), object, source, stack)
    : undefined;

  var isCommon = newValue === undefined;

  if (isCommon) {
    var isArr = isArray(srcValue),
        isBuff = !isArr && isBuffer(srcValue),
        isTyped = !isArr && !isBuff && isTypedArray(srcValue);

    newValue = srcValue;
    if (isArr || isBuff || isTyped) {
      if (isArray(objValue)) {
        newValue = objValue;
      }
      else if (isArrayLikeObject(objValue)) {
        newValue = copyArray(objValue);
      }
      else if (isBuff) {
        isCommon = false;
        newValue = cloneBuffer(srcValue, true);
      }
      else if (isTyped) {
        isCommon = false;
        newValue = cloneTypedArray(srcValue, true);
      }
      else {
        newValue = [];
      }
    }
    else if (isPlainObject(srcValue) || isArguments(srcValue)) {
      newValue = objValue;
      if (isArguments(objValue)) {
        newValue = toPlainObject(objValue);
      }
      else if (!isObject(objValue) || isFunction(objValue)) {
        newValue = initCloneObject(srcValue);
      }
    }
    else {
      isCommon = false;
    }
  }
  if (isCommon) {
    // Recursively merge objects and arrays (susceptible to call stack limits).
    stack.set(srcValue, newValue);
    mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
    stack['delete'](srcValue);
  }
  assignMergeValue(object, key, newValue);
}

module.exports = baseMergeDeep;


/***/ }),
/* 809 */
/***/ (function(module, exports, __webpack_require__) {

var isArrayLike = __webpack_require__(41),
    isObjectLike = __webpack_require__(26);

/**
 * This method is like `_.isArrayLike` except that it also checks if `value`
 * is an object.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Lang
 * @param {*} value The value to check.
 * @returns {boolean} Returns `true` if `value` is an array-like object,
 *  else `false`.
 * @example
 *
 * _.isArrayLikeObject([1, 2, 3]);
 * // => true
 *
 * _.isArrayLikeObject(document.body.children);
 * // => true
 *
 * _.isArrayLikeObject('abc');
 * // => false
 *
 * _.isArrayLikeObject(_.noop);
 * // => false
 */
function isArrayLikeObject(value) {
  return isObjectLike(value) && isArrayLike(value);
}

module.exports = isArrayLikeObject;


/***/ }),
/* 810 */
/***/ (function(module, exports, __webpack_require__) {

var copyObject = __webpack_require__(86),
    keysIn = __webpack_require__(109);

/**
 * Converts `value` to a plain object flattening inherited enumerable string
 * keyed properties of `value` to own properties of the plain object.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category Lang
 * @param {*} value The value to convert.
 * @returns {Object} Returns the converted plain object.
 * @example
 *
 * function Foo() {
 *   this.b = 2;
 * }
 *
 * Foo.prototype.c = 3;
 *
 * _.assign({ 'a': 1 }, new Foo);
 * // => { 'a': 1, 'b': 2 }
 *
 * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
 * // => { 'a': 1, 'b': 2, 'c': 3 }
 */
function toPlainObject(value) {
  return copyObject(value, keysIn(value));
}

module.exports = toPlainObject;


/***/ }),
/* 811 */
/***/ (function(module, exports, __webpack_require__) {

var baseRest = __webpack_require__(329),
    isIterateeCall = __webpack_require__(124);

/**
 * Creates a function like `_.assign`.
 *
 * @private
 * @param {Function} assigner The function to assign values.
 * @returns {Function} Returns the new assigner function.
 */
function createAssigner(assigner) {
  return baseRest(function(object, sources) {
    var index = -1,
        length = sources.length,
        customizer = length > 1 ? sources[length - 1] : undefined,
        guard = length > 2 ? sources[2] : undefined;

    customizer = (assigner.length > 3 && typeof customizer == 'function')
      ? (length--, customizer)
      : undefined;

    if (guard && isIterateeCall(sources[0], sources[1], guard)) {
      customizer = length < 3 ? undefined : customizer;
      length = 1;
    }
    object = Object(object);
    while (++index < length) {
      var source = sources[index];
      if (source) {
        assigner(object, source, index, customizer);
      }
    }
    return object;
  });
}

module.exports = createAssigner;


/***/ }),
/* 812 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* unused harmony default export */ var _unused_webpack_default_export = (function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",Object.assign({viewBox:"0 0 300 300",xmlSpace:"preserve"},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#FFFFFF",points:"147.9,46.3 162.1,134.7 250.5,148.9 162.1,163.2 147.9,251.6 133.7,163.2 45.3,148.9 133.7,134.7"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#808285",points:"147.9,46.3 147.9,149 133.7,134.7"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#808285",points:"147.9,251.5 147.9,149 162.1,163.1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#808285",points:"45.3,148.9 148,148.9 133.7,163.1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{fill:"#808285",points:"250.5,148.9 148,148.9 162.1,134.7"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M295.7,132.9c-2.9,0.2-4.1,0.8-4.4,3c-0.2,1.6-0.3,3.9-0.3,8.7v20.8h-1.6l-22-27.1h-0.1v13 c0,4.7,0.2,7.2,0.3,8.7c0.2,2.7,1.4,3.3,4.9,3.5v1.4h-12.2v-1.4c3-0.2,4.3-0.8,4.5-3.4c0.2-1.6,0.3-4.1,0.3-8.8V140 c0-3.8-0.1-4-1-5.2c-1.1-1.3-2.2-1.7-4.6-1.9v-1.4h7.6l21.6,25.9h0.2v-12.7c0-4.7-0.2-7.1-0.4-8.6c-0.3-2.3-1.4-3-5.1-3.2v-1.4 h12.2V132.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M28.4,139.3c-1.1-3.3-2.9-6.8-8.5-6.8c-5,0-7.2,2.8-7.2,5.7c0,3.8,3.1,5.6,8.2,7.6c5.1,2.1,11.2,4.5,11.2,10.3 c0,5.4-5.7,9.8-14.3,9.8c-2.7,0-4.8-0.4-6.3-0.8c-1.6-0.5-2.6-0.8-3.2-1.1c-0.5-1.1-1.3-5.5-1.7-8l1.9-0.4c1,3.2,3.9,8.4,10.6,8.4 c4.9,0,7.8-2.4,7.8-6.2c0-3.8-3.6-5.6-8.4-7.7c-4.2-1.8-10.7-4.3-10.7-10.2c0-4.9,5-9.2,13.3-9.2c3,0,5.7,0.6,8.2,1.2 c0.3,1.9,0.6,3.9,1.1,7.1L28.4,139.3"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M162.5,289.6c-0.3,1.7-1.3,6.5-1.8,8.1h-24.9v-1.4c4.7-0.4,5.1-0.8,5.1-5v-20.6c0-4.6-0.4-4.8-4.4-5.2v-1.4h23 c0,1.2,0.3,4.7,0.4,7.4l-1.5,0.2c-0.5-2.2-1-3.3-1.7-4.4c-0.7-1.2-2.1-1.5-5.8-1.5H147c-1.6,0-1.7,0.2-1.7,1.6v11.8h4.8 c4.7,0,5-0.4,5.6-3.9h1.5v9.9h-1.5c-0.7-3.7-1-4-5.5-4h-4.9v9.8c0,2.4,0.3,3.6,1.2,4.2c1,0.7,2.8,0.7,5.4,0.7 c3.9,0,5.4-0.4,6.5-1.8c0.8-1,1.8-2.8,2.6-4.8L162.5,289.6"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M171.9,5.2c-3.6,0.5-4,0.9-5.6,5.2c-1.1,3.3-4.3,13.1-8.5,27.5h-1.6c-2.8-8.3-6.4-18.3-9-25.8h-0.1 c-2.9,9.1-5.8,17.4-8.4,25.8h-1.6c-2.7-9.4-5.6-18.4-8.5-27.6c-1.3-4.2-2-4.7-5.2-5.1V3.8h12.6v1.4c-3.8,0.5-3.9,0.9-3.1,3.5 c2,7,4,13.9,6.3,21.3h0.1c2.8-8.8,5.8-17.3,8.4-25.8h1.5c2.9,8.5,5.9,16.9,9,25.8h0.1c2.2-6.9,5.1-17,5.8-20.7 c0.7-3.1,0.5-3.6-3.5-4.1V3.8h11.4V5.2"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M25.6,113c12.6-44.2,48.6-78.7,93.8-89l-1.1-4.8C71.4,30,34,65.7,20.9,111.7L25.6,113 M23.2,114.8 c1.3,0,2.5-1.1,2.5-2.5c0-1.3-1.1-2.4-2.5-2.4c-1.4,0-2.4,1.1-2.4,2.4C20.8,113.7,21.8,114.8,23.2,114.8 M118.9,24.1 c1.3,0,2.4-1.1,2.4-2.5c0-1.3-1.1-2.4-2.4-2.4c-1.3,0-2.5,1.1-2.5,2.4C116.4,23,117.5,24.1,118.9,24.1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M128.1,273.6c-50.1-7.8-90.5-44.9-103.2-93.2l-4.7,1.3c13.2,50.2,55.2,88.7,107.2,96.8L128.1,273.6 M127.8,278.4c1.3,0,2.5-1.1,2.5-2.4c0-1.4-1.1-2.5-2.5-2.5c-1.4,0-2.4,1.1-2.4,2.5C125.3,277.3,126.4,278.4,127.8,278.4 M22.5,183.4c1.4,0,2.5-1.1,2.5-2.5c0-1.3-1.1-2.4-2.5-2.4c-1.3,0-2.4,1.1-2.4,2.4C20.1,182.3,21.2,183.4,22.5,183.4"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M272.9,171.1c-9.7,52.6-51.7,93.8-104.7,102.3l0.8,4.8c55-8.9,98.6-51.7,108.7-106.3L272.9,171.1 M275.3,174 c1.4,0,2.5-1.1,2.5-2.5c0-1.3-1.1-2.4-2.5-2.4c-1.3,0-2.4,1.1-2.4,2.4C272.9,172.9,274,174,275.3,174 M168.6,278.3 c1.4,0,2.4-1.1,2.4-2.5c0-1.4-1.1-2.4-2.4-2.4c-1.3,0-2.4,1.1-2.4,2.4C166.2,277.2,167.3,278.3,168.6,278.3"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M175,23.7c47.8,10.4,85.6,47.7,96.7,95.3l4.8-1.1C265,68.5,225.7,29.8,176,19L175,23.7 M175.5,23.8 c1.4,0,2.5-1.1,2.5-2.4c0-1.4-1.1-2.5-2.5-2.5c-1.3,0-2.4,1.1-2.4,2.5C173.1,22.7,174.2,23.8,175.5,23.8 M274.1,120.9 c1.3,0,2.4-1.1,2.4-2.4c0-1.3-1.1-2.5-2.4-2.5c-1.4,0-2.5,1.1-2.5,2.5C271.6,119.8,272.7,120.9,274.1,120.9"})));});

/***/ }),
/* 813 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{viewBox:"0 0 81 109",x:-20,y:-52,width:40,height:52},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#a28e81",d:"M81,40.5C81,72,40.83,109,40.83,109S0,71,0,40.5a40.5,40.5,0,0,1,81,0Z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"scale(0.7) translate(22 11)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"white",d:"M55.3,16C53.9,15.7,44,13.8,35,13.8c-9.2,0-18.9,1.8-20.3,2.1c-4.2,0.1-7.5,3.9-7.5,8.6v38.1 c0,4.5,3.1,8.3,7.1,8.6v3.9c0,0.4,0.3,0.8,0.7,0.8h7.5c0.4,0,0.7-0.4,0.7-0.8v-3.9h23.6v3.9c0,0.4,0.3,0.8,0.7,0.8h7.5 c0.4,0,0.7-0.4,0.7-0.8v-3.9c4-0.3,7.2-4,7.2-8.6V24.6C62.8,19.9,59.4,16.1,55.3,16z M21.9,17.9c0-0.4,0.3-0.8,0.7-0.8h24.8 c0.4,0,0.7,0.3,0.7,0.8v1.7c0,0.4-0.3,0.8-0.7,0.8H22.6c-0.4,0-0.7-0.3-0.7-0.8V17.9z M23.5,61c-1,1.5-9.8,1.2-11.8-0.9 c-1.2-1.2-1.3-6.3,0-7.4c1.8-1.4,6,2,8.3,3.2C22.4,57.1,24.5,59.4,23.5,61z M44.3,66.9c0,0.6-0.2,1.1-0.5,1.1H26.2 c-0.3,0-0.5-0.5-0.5-1.1v-2.4c0-0.6,0.2-1.1,0.5-1.1h17.6c0.3,0,0.5,0.5,0.5,1.1V66.9z M35,50.7c-9.1,0-17.6-2.4-24.1-6.7V24.6 c0-2.5,48.2-2.5,48.2,0V44C52.6,48.3,44.1,50.7,35,50.7z M59.4,60.1c-2,2.1-10.8,2.4-11.8,0.9c-1-1.5,1.1-3.8,3.5-5.1 c2.3-1.2,6.5-4.6,8.3-3.2C60.7,53.8,60.6,58.8,59.4,60.1z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"white",d:"M4.4,35.5C6,35.8,5.5,40,5.6,41.9c0.1,2.1-0.5,4.5-1.8,4.7c-1.3,0.2-4.5-5-4-7.2C0.1,38,3.2,35.3,4.4,35.5z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"white",d:"M65.4,35.5c-1.6,0.3-1.1,4.5-1.2,6.4c-0.1,2.1,0.5,4.5,1.8,4.7c1.3,0.2,4.5-5,4-7.2 C69.7,38,66.6,35.3,65.4,35.5z"})));});

/***/ }),
/* 814 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(69),
    baseClone = __webpack_require__(321),
    baseUnset = __webpack_require__(256),
    castPath = __webpack_require__(73),
    copyObject = __webpack_require__(86),
    customOmitClone = __webpack_require__(815),
    flatRest = __webpack_require__(263),
    getAllKeysIn = __webpack_require__(190);

/** Used to compose bitmasks for cloning. */
var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

/**
 * The opposite of `_.pick`; this method creates an object composed of the
 * own and inherited enumerable property paths of `object` that are not omitted.
 *
 * **Note:** This method is considerably slower than `_.pick`.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Object
 * @param {Object} object The source object.
 * @param {...(string|string[])} [paths] The property paths to omit.
 * @returns {Object} Returns the new object.
 * @example
 *
 * var object = { 'a': 1, 'b': '2', 'c': 3 };
 *
 * _.omit(object, ['a', 'c']);
 * // => { 'b': '2' }
 */
var omit = flatRest(function(object, paths) {
  var result = {};
  if (object == null) {
    return result;
  }
  var isDeep = false;
  paths = arrayMap(paths, function(path) {
    path = castPath(path, object);
    isDeep || (isDeep = path.length > 1);
    return path;
  });
  copyObject(object, getAllKeysIn(object), result);
  if (isDeep) {
    result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
  }
  var length = paths.length;
  while (length--) {
    baseUnset(result, paths[length]);
  }
  return result;
});

module.exports = omit;


/***/ }),
/* 815 */
/***/ (function(module, exports, __webpack_require__) {

var isPlainObject = __webpack_require__(327);

/**
 * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
 * objects.
 *
 * @private
 * @param {*} value The value to inspect.
 * @param {string} key The key of the property to inspect.
 * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
 */
function customOmitClone(value) {
  return isPlainObject(value) ? undefined : value;
}

module.exports = customOmitClone;


/***/ }),
/* 816 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(2);
var contentPath="https://d3vqeivyse4uh3.cloudfront.net/www/lagunaproperty";var selectPath=function selectPath(str){return""+Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])("laguna-beachside")+str;};var bubbleBeachside={// url: `${contentPath}/assets/images/project-map/logo/outrigger.svg`,
url:selectPath("/images/logo/logo-white.png"),width:207,height:88};var bubbleOutrigger={// url: `${contentPath}/assets/images/project-map/logo/outrigger.svg`,
url:contentPath+"/assets/images/project-map/logo/SAii_Phuket.svg",width:207,height:88};var bubbleCassia={url:contentPath+"/assets/images/project-map/logo/cassia.svg",x:-15,y:-80,width:212,height:94};var bubbleDusit={url:contentPath+"/assets/images/project-map/logo/Dusit-thani.svg",width:218,height:100};var bubbleHolidayClub={url:contentPath+"/assets/images/project-map/logo/laguna-holidayclub-phuketresort.svg",x:-90,y:-10,width:146,height:77};// const bubbleSkypark = {
//   url: `${contentPath}/assets/images/project-map/logo/phuket-skypark.svg`,
//   x: -90,
//   y: -10,
//   width: 146,
//   height: 77,
// };
var bubbleAngsanaPhuket={url:contentPath+"/assets/images/project-map/logo/angsana-laguna-phuket.svg",width:195,height:57};var bubbleBanyantreeSpaSanctuary={url:contentPath+"/assets/images/project-map/logo/banyan-tree-spasanctuary.svg",width:245,height:56};var bubbleBanyantree={url:contentPath+"/assets/images/project-map/logo/banyan-tree.svg",width:150,height:69};var bubbleBanyantreeDoublepoolVilla={url:contentPath+"/assets/images/project-map/logo/banyan-tree-doublepool-villa.svg",width:280,height:60};var bubbleAngsanaVillaResortPhuket={url:contentPath+"/assets/images/project-map/logo/angsana-villa-resort-phuket.svg",width:179,height:50};/* harmony default export */ __webpack_exports__["a"] = ([// // ======================================= Hotels =======================================
// {
//   id: 18,
//   type: "Pin",
//   color: "#434a6a",
//   group: "hotel",
//   animated: true,
//   x: 880,
//   y: 250,
//   bubble: bubbleBanyantree,
//   images: [
//     {
//       name: "Banyan Tree Phuket",
//       url: `${contentPath}/assets/images/project-map/hotel/BanyanTree/1.jpg`,
//     },
//   ],
// },
// {
//   id: 19,
//   type: "Pin",
//   color: "#434a6a",
//   group: "hotel",
//   animated: true,
//   x: 645,
//   y: 270,
//   bubble: bubbleAngsanaPhuket,
//   images: [
//     {
//       name: "Angsana Laguna Phuket",
//       url: `${contentPath}/assets/images/project-map/hotel/Angsana/1.jpg`,
//     },
//   ],
// },
// {
//   id: 20,
//   type: "Pin",
//   color: "#434a6a",
//   group: "hotel",
//   animated: true,
//   x: 1230,
//   y: 660,
//   bubble: bubbleAngsanaVillaResortPhuket,
//   images: [
//     {
//       name: "Angsana Villas Resort Phuket",
//       url: `${contentPath}/assets/images/project-map/hotel/AngsanaVillas/1.jpg`,
//     },
//   ],
// },
// {
//   id: 21,
//   type: "Pin",
//   color: "#434a6a",
//   group: "hotel",
//   animated: true,
//   x: 460,
//   y: 295,
//   bubble: bubbleCassia,
//   images: [
//     {
//       name: "Cassia Phuket",
//       url: `${contentPath}/assets/images/project-map/hotel/Cassia/1.jpg`,
//     },
//   ],
// },
// {
//   id: 22,
//   type: "Pin",
//   color: "#434a6a",
//   group: "hotel",
//   animated: true,
//   x: 590,
//   y: 390,
//   bubble: bubbleHolidayClub,
//   images: [
//     {
//       name: "Laguna Holiday Club Phuket Resort",
//       url: `${contentPath}/assets/images/project-map/hotel/Laguna/1.jpg`,
//     },
//   ],
// },
// {
//   id: 23,
//   type: "Pin",
//   color: "#434a6a",
//   group: "hotel",
//   animated: true,
//   x: 540,
//   y: 195,
//   bubble: bubbleDusit,
//   images: [
//     {
//       name: "Dusit Thani Laguna Phuket",
//       url: `${contentPath}/assets/images/project-map/hotel/DusitThani/1.jpg`,
//     },
//   ],
// },
// {
//   id: 24,
//   type: "Pin",
//   color: "#434a6a",
//   group: "hotel",
//   animated: true,
//   x: 360,
//   y: 220,
//   bubble: bubbleOutrigger,
//   images: [
//     {
//       name: "Outrigger Laguna Phuket Beach Resort",
//       url: `${contentPath}/assets/images/project-map/hotel/Outrigger/1.jpg`,
//     },
//   ],
// },
// // ================================
// {
//   type: "Pin",
//   color: "#434a6a",
//   group: "hotel",
//   animated: true,
//   x: 440,
//   y: 460,
//   bubble: bubbleSkypark,
//   images: [
//     {
//       name: "Skypark",
//       url: `${contentPath}/assets/images/project-map/hotel/skypark/1.jpg`
//     }
//   ]
// },
// {
//   type: "Pin",
//   color: "#434a6a",
//   group: "hotel",
//   animated: true,
//   x: 880,
//   y: 250,
//   bubble: bubbleBanyantreeSpaSanctuary,
//   images: [
//     {
//       name: "Banyan Tree Spa Sanctuary",
//       url: `${contentPath}/assets/images/project-map/hotel/SpaSanctuary/1.jpg`,
//     },
//   ],
// },
// {
//   type: "Pin",
//   color: "#434a6a",
//   group: "hotel",
//   animated: true,
//   x: 1007,
//   y: 305,
//   bubble: bubbleBanyantreeDoublepoolVilla,
//   images: [
//     {
//       name: "DoublePool Villas by Banyan Tree",
//       url: `${contentPath}/assets/images/project-map/hotel/DoublePoolVillas/1.jpg`,
//     },
//   ],
// },
// // ======================================= Restaurants =======================================
// {
//   type: "Pin",
//   color: "#d68000",
//   group: "restaurant",
//   animated: true,
//   x: 284,
//   y: 171,
//   bubble: {
//     ...bubbleOutrigger,
//     num: 5,
//   },
//   images: [
//     {
//       name: "Edgewater",
//       url: `${contentPath}/assets/images/project-map/restaurant/Outrigger/1.jpg`,
//     },
//     {
//       name: `Metzo's`,
//       url: `${contentPath}/assets/images/project-map/restaurant/Outrigger/2.jpg`,
//     },
//     {
//       name: "Icon Terrace & Lounge",
//       url: `${contentPath}/assets/images/project-map/restaurant/Outrigger/3.jpg`,
//     },
//     {
//       name: "Locavore",
//       url: `${contentPath}/assets/images/project-map/restaurant/Outrigger/4.jpg`,
//     },
//     {
//       name: "Voyager 47 Club Lounge",
//       url: `${contentPath}/assets/images/project-map/restaurant/Outrigger/5.jpg`,
//     },
//   ],
// },
// {
//   type: "Pin",
//   color: "#d68000",
//   group: "restaurant",
//   animated: true,
//   x: 478,
//   y: 196,
//   bubble: {
//     ...bubbleDusit,
//     num: 5,
//   },
//   images: [
//     {
//       name: "Casuarina Beach Restaurant",
//       url: `${contentPath}/assets/images/project-map/restaurant/DusitThani/1.jpg`,
//     },
//     {
//       name: "Laguna Café",
//       url: `${contentPath}/assets/images/project-map/restaurant/DusitThani/2.jpg`,
//     },
//     {
//       name: "La Trattoria",
//       url: `${contentPath}/assets/images/project-map/restaurant/DusitThani/3.jpg`,
//     },
//     {
//       name: "Horizon Lounge",
//       url: `${contentPath}/assets/images/project-map/restaurant/DusitThani/4.jpg`,
//     },
//     {
//       name: "Ruen Thai",
//       url: `${contentPath}/assets/images/project-map/restaurant/DusitThani/5.jpg`,
//     },
//   ],
// },
// {
//   type: "Pin",
//   color: "#d68000",
//   group: "restaurant",
//   animated: true,
//   x: 420,
//   y: 291,
//   bubble: {
//     ...bubbleCassia,
//     x: -130,
//     num: 1,
//   },
//   images: [
//     {
//       name: "Vista Gastro - Pub",
//       url: `${contentPath}/assets/images/project-map/restaurant/Cassia/1.jpg`,
//     },
//   ],
// },
// {
//   type: "Pin",
//   color: "#d68000",
//   group: "restaurant",
//   animated: true,
//   x: 547,
//   y: 395,
//   bubble: {
//     ...bubbleHolidayClub,
//     // url: `${contentPath}/assets/images/project-map/dining-logo/Laguna.png`,
//     // render: renderRestaurantBubble,
//     // width: 96,
//     num: 1,
//   },
//   images: [
//     {
//       name: "Seedling Restaurant",
//       url: `${contentPath}/assets/images/project-map/restaurant/Laguna/1.jpg`,
//     },
//   ],
// },
// {
//   type: "Pin",
//   color: "#d68000",
//   group: "restaurant",
//   animated: true,
//   x: 648,
//   y: 287,
//   bubble: {
//     ...bubbleAngsanaPhuket,
//     // url: `${contentPath}/assets/images/project-map/dining-logo/Angsana.png`,
//     // render: renderRestaurantBubble,
//     // width: 114,
//     num: 6,
//   },
//   images: [
//     {
//       name: "Baan Talay",
//       url: `${contentPath}/assets/images/project-map/restaurant/Angsana/1.jpg`,
//     },
//     {
//       name: "Bodega & Grill",
//       url: `${contentPath}/assets/images/project-map/restaurant/Angsana/2.jpg`,
//     },
//     {
//       name: "Loy Krathong Bar",
//       url: `${contentPath}/assets/images/project-map/restaurant/Angsana/3.jpg`,
//     },
//     {
//       name: "Market Place",
//       url: `${contentPath}/assets/images/project-map/restaurant/Angsana/4.jpg`,
//     },
//     {
//       name: "Poolside",
//       url: `${contentPath}/assets/images/project-map/restaurant/Angsana/5.jpg`,
//     },
//     {
//       name: "Xana Beach Club",
//       url: `${contentPath}/assets/images/project-map/restaurant/Angsana/6.jpg`,
//     },
//   ],
// },
// {
//   type: "Pin",
//   color: "#d68000",
//   group: "restaurant",
//   animated: true,
//   x: 926,
//   y: 278,
//   bubble: {
//     ...bubbleBanyantree,
//     // url: `${contentPath}/assets/images/project-map/dining-logo/Banyan_Tree.png`,
//     // render: renderRestaurantBubble,
//     // width: 102,
//     num: 7,
//   },
//   images: [
//     {
//       name: "Banyan Café",
//       url: `${contentPath}/assets/images/project-map/restaurant/BanyanTree/1.jpg`,
//     },
//     {
//       name: "Lobby Bar & Wine Rack",
//       url: `${contentPath}/assets/images/project-map/restaurant/BanyanTree/2.jpg`,
//     },
//     {
//       name: "Pool Bar",
//       url: `${contentPath}/assets/images/project-map/restaurant/BanyanTree/3.jpg`,
//     },
//     {
//       name: "Saffron",
//       url: `${contentPath}/assets/images/project-map/restaurant/BanyanTree/4.jpg`,
//     },
//     {
//       name: "Tamarind Restaurant",
//       url: `${contentPath}/assets/images/project-map/restaurant/BanyanTree/5.jpg`,
//     },
//     {
//       name: "Tre’ Restaurant",
//       url: `${contentPath}/assets/images/project-map/restaurant/BanyanTree/6.jpg`,
//     },
//     {
//       name: "Watercourt",
//       url: `${contentPath}/assets/images/project-map/restaurant/BanyanTree/7.jpg`,
//     },
//   ],
// },
// {
//   type: "Pin",
//   color: "#d68000",
//   group: "restaurant",
//   animated: true,
//   x: 1208,
//   y: 569,
//   bubble: {
//     ...bubbleAngsanaVillaResortPhuket,
//     // url: `${contentPath}/assets/images/project-map/dining-logo/Angsana-villas.png`,
//     // render: renderRestaurantBubble,
//     width: 138,
//     num: 2,
//   },
//   images: [
//     {
//       name: "Baan Aroi",
//       url: `${contentPath}/assets/images/project-map/restaurant/AngsanaVillas/1.jpg`,
//     },
//     {
//       name: "Panache Restaurant",
//       url: `${contentPath}/assets/images/project-map/restaurant/AngsanaVillas/2.jpg`,
//     },
//   ],
// },
// // ======================================= Spa =======================================
// {
//   type: "Pin",
//   color: "#699e84",
//   group: "spa",
//   animated: true,
//   x: 443,
//   y: 206,
//   bubble: {
//     text: ["ANGSANA SPA DUSIT THANI", "LAGUNA PHUKET"],
//     width: 140,
//     // url: `${contentPath}/assets/images/project-map/spa-logo/Dusit_Thani.png`,
//     x: -200,
//     y: -40,
//   },
//   images: [
//     {
//       name: "Angsana Spa Dusit Thani Laguna Phuket",
//       url: `${contentPath}/assets/images/project-map/spa/DusitThani/1.jpg`,
//     },
//   ],
// },
// {
//   type: "Pin",
//   color: "#699e84",
//   group: "spa",
//   animated: true,
//   x: 634,
//   y: 293,
//   // bubble: {
//   //   url: `${contentPath}/assets/images/project-map/spa-logo/Angsana.png`
//   // },
//   bubble: {
//     text: ["ANGSANA SPA", "LAGUNA PHUKET"],
//     width: 80,
//     y: -20,
//   },
//   images: [
//     {
//       name: "Angsana Spa Laguna Phuket",
//       url: `${contentPath}/assets/images/project-map/spa/Angsana/1.jpg`,
//     },
//   ],
// },
// {
//   type: "Pin",
//   color: "#699e84",
//   group: "spa",
//   animated: true,
//   x: 896,
//   y: 303,
//   // bubble: {
//   //   url: `${contentPath}/assets/images/project-map/spa-logo/Banyan_Tree.png`
//   // },
//   bubble: {
//     text: ["BANYAN TREE SPA"],
//     width: 140,
//     style: { fontSize: 15 },
//   },
//   images: [
//     {
//       name: "Banyan Tree Spa",
//       url: `${contentPath}/assets/images/project-map/spa/BanyanTree/1.jpg`,
//     },
//   ],
// },
// {
//   type: "Pin",
//   color: "#699e84",
//   group: "spa",
//   animated: true,
//   x: 419,
//   y: 323,
//   // bubble: {
//   //   url: `${contentPath}/assets/images/project-map/spa-logo/Chill_Chill.png`,
//   //   x: -150
//   // },
//   bubble: {
//     text: ["CHILL CHILL SPA"],
//     width: 120,
//     x: -150,
//     y: 20,
//     style: { fontSize: 15 },
//   },
//   images: [
//     {
//       name: "Chill Chill Spa",
//       url: `${contentPath}/assets/images/project-map/spa/ChillChill/1.jpg`,
//     },
//   ],
// },
// // ======================================= Galleries & Shopping =======================================
// {
//   type: "Pin",
//   color: "#428b95",
//   group: "gallery",
//   animated: true,
//   x: 514,
//   y: 274,
//   // bubble: {
//   //   url: `${contentPath}/assets/images/project-map/gallery-logo/Canal_Village.png`,
//   //   x: -100,
//   //   y: -10
//   // },
//   bubble: {
//     text: ["CANAL VILLAGE", "SHOPPING"],
//     width: 80,
//     x: -140,
//   },
//   images: [
//     {
//       name: "Canal Village Shopping",
//       url: `${contentPath}/assets/images/project-map/gallery/CanalVillage/1.jpg`,
//     },
//   ],
// },
// {
//   type: "Pin",
//   color: "#428b95",
//   group: "gallery",
//   animated: true,
//   x: 661,
//   y: 285,
//   // bubble: {
//   //   url: `${contentPath}/assets/images/project-map/gallery-logo/Angsana.png`,
//   //   y: -10
//   // },
//   bubble: {
//     text: ["ANGSANA", "GALLERY"],
//     width: 60,
//     y: -10,
//   },
//   images: [
//     {
//       name: "Angsana Gallery",
//       url: `${contentPath}/assets/images/project-map/gallery/Angsana/1.jpg`,
//     },
//   ],
// },
// {
//   type: "Pin",
//   color: "#428b95",
//   group: "gallery",
//   animated: true,
//   x: 870,
//   y: 278,
//   // bubble: {
//   //   url: `${contentPath}/assets/images/project-map/gallery-logo/Banyan_Tree.png`,
//   //   y: -10
//   // },
//   bubble: {
//     text: ["BANYAN TREE", "GALLERY"],
//     width: 80,
//     y: -10,
//   },
//   images: [
//     {
//       name: "Banyan Tree Gallery",
//       url: `${contentPath}/assets/images/project-map/gallery/BanyanTree/1.jpg`,
//     },
//   ],
// },
// // ======================================= Bus =======================================
// {
//   type: "Pin",
//   color: "#705c4e",
//   group: "bus",
//   x: 261,
//   y: 212,
//   animated: false,
// },
// {
//   type: "Pin",
//   color: "#705c4e",
//   group: "bus",
//   x: 383,
//   y: 360,
//   animated: false,
// },
// {
//   type: "Pin",
//   color: "#705c4e",
//   group: "bus",
//   x: 473,
//   y: 255,
//   animated: false,
// },
// {
//   type: "Pin",
//   color: "#705c4e",
//   group: "bus",
//   x: 421,
//   y: 460,
//   animated: false,
// },
// {
//   type: "Pin",
//   color: "#705c4e",
//   group: "bus",
//   x: 604,
//   y: 329,
//   animated: false,
// },
// {
//   type: "Pin",
//   color: "#705c4e",
//   group: "bus",
//   x: 690,
//   y: 468,
//   animated: false,
// },
// {
//   type: "Pin",
//   color: "#705c4e",
//   group: "bus",
//   x: 827,
//   y: 297,
//   animated: false,
// },
// // ======================================= Boat =======================================
// {
//   type: "Pin",
//   label: "1",
//   color: "#9f5a3a",
//   group: "boat",
//   x: 297.5,
//   y: 211.5,
//   animated: false,
// },
// {
//   type: "Pin",
//   label: "2",
//   color: "#9f5a3a",
//   group: "boat",
//   x: 408.5,
//   y: 211.5,
//   animated: false,
// },
// {
//   type: "Pin",
//   label: "3",
//   color: "#9f5a3a",
//   group: "boat",
//   x: 426.67,
//   y: 230,
//   animated: false,
// },
// {
//   type: "Pin",
//   label: "4",
//   color: "#9f5a3a",
//   group: "boat",
//   x: 396.54,
//   y: 314,
//   animated: false,
// },
// {
//   type: "Pin",
//   label: "5",
//   color: "#9f5a3a",
//   group: "boat",
//   x: 541.54,
//   y: 278.5,
//   animated: false,
// },
// {
//   type: "Pin",
//   label: "6",
//   color: "#9f5a3a",
//   group: "boat",
//   x: 595.54,
//   y: 209.5,
//   animated: false,
// },
// {
//   type: "Pin",
//   label: "7",
//   color: "#9f5a3a",
//   group: "boat",
//   x: 621.5,
//   y: 219.5,
//   animated: false,
// },
// {
//   type: "Pin",
//   label: "8",
//   color: "#9f5a3a",
//   group: "boat",
//   x: 628.54,
//   y: 257.9,
//   animated: false,
// },
// {
//   type: "Pin",
//   label: "9",
//   color: "#9f5a3a",
//   group: "boat",
//   x: 583.55,
//   y: 266.57,
//   animated: false,
// },
// {
//   type: "Pin",
//   label: "10",
//   color: "#9f5a3a",
//   group: "boat",
//   x: 645.17,
//   y: 329,
//   animated: false,
// },
// {
//   type: "Pin",
//   label: "11",
//   color: "#9f5a3a",
//   group: "boat",
//   x: 800,
//   y: 255,
//   animated: false,
// },
// {
//   type: "Pin",
//   label: "12",
//   color: "#9f5a3a",
//   group: "boat",
//   x: 900,
//   y: 268,
//   animated: false,
// },
]);

/***/ }),
/* 817 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__PhuketMap__ = __webpack_require__(818);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_0__PhuketMap__["a"]; });


/***/ }),
/* 818 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep__ = __webpack_require__(200);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_merge__ = __webpack_require__(325);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_merge___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_merge__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isArray__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_responsive__ = __webpack_require__(330);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_responsive___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react_responsive__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_styled_components__ = __webpack_require__(27);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__common__ = __webpack_require__(819);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__components_Button__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_ButtonGroup__ = __webpack_require__(199);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_svg_Pin__ = __webpack_require__(331);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_svg_MultiLineText__ = __webpack_require__(332);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_svg_Airplane__ = __webpack_require__(820);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_svg_LagunaPropertyBubble__ = __webpack_require__(821);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp;var _templateObject=_taggedTemplateLiteral(["\n  0% {\n    transform: scale(1);\n  }\n\n  100% {\n    transform: scale(1.05);\n  }\n"],["\n  0% {\n    transform: scale(1);\n  }\n\n  100% {\n    transform: scale(1.05);\n  }\n"]),_templateObject2=_taggedTemplateLiteral(["\n  transform-origin: 50% 50%;\n  animation: "," 1s infinite ease-out alternate;\n"],["\n  transform-origin: 50% 50%;\n  animation: "," 1s infinite ease-out alternate;\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var contentPath="https://d3vqeivyse4uh3.cloudfront.net/www/lagunaproperty";var iconAirport=contentPath+"/assets/images/phuket-map/map-icon-01.png";var iconBeach=contentPath+"/assets/images/phuket-map/map-icon-02.png";var iconIsland=contentPath+"/assets/images/phuket-map/map-icon-03.png";var iconSchool=contentPath+"/assets/images/phuket-map/map-icon-05.png";var iconAttraction=contentPath+"/assets/images/phuket-map/map-icon-06.png";var bg=contentPath+"/assets/images/phuket-map/phuket-map.png";var Desktop=function Desktop(props){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_responsive___default.a,Object.assign({},props,{minWidth:768}));};var Mobile=function Mobile(props){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_responsive___default.a,Object.assign({},props,{maxWidth:767}));};var overwriteMerge=function overwriteMerge(destinationArray,sourceArray,options){var destination=destinationArray.slice();sourceArray.forEach(function(e,i){Object.keys(e).forEach(function(key){// console.log(destination[0][key])
destination[i][key]=sourceArray[i][key];});});return destination;};var switchLanguage=function switchLanguage(activeLanguage){switch(activeLanguage){case"cn":return __WEBPACK_IMPORTED_MODULE_6__common__["a" /* CNtexts */];case"ru":return __WEBPACK_IMPORTED_MODULE_6__common__["b" /* RUtexts */];default:return __WEBPACK_IMPORTED_MODULE_6__common__["c" /* texts */];}};var INITIAL_STATE={currentPage:"airport"};var bounce=Object(__WEBPACK_IMPORTED_MODULE_5_styled_components__["c" /* keyframes */])(_templateObject);var AnimatedBubble=__WEBPACK_IMPORTED_MODULE_5_styled_components__["b" /* default */].g(_templateObject2,bounce);// Render Bubble in Pin
var renderPinBubble=function renderPinBubble(_ref,_ref2){var text=_ref.text,_ref$textAnchor=_ref.textAnchor,textAnchor=_ref$textAnchor===undefined?"start":_ref$textAnchor,width=_ref.width,style=_ref.style;var currentLanguage=_ref2.currentLanguage;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("g",null,typeof text[currentLanguage]==="string"&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("text",{x:0,y:0,width:width,height:28,textAnchor:textAnchor,style:Object.assign({fill:"#454969",fontSize:10},style)},text[currentLanguage]),__WEBPACK_IMPORTED_MODULE_2_lodash_isArray___default()(text[currentLanguage])&&__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_svg_MultiLineText__["a" /* default */],{x:0,text:text[currentLanguage],textAnchor:"start",style:style}));};// Render Side Button
var renderButton=function renderButton(_ref3){var value=_ref3.value,label=_ref3.label,icon=_ref3.icon,active=_ref3.active,type=_ref3.type,key=_ref3.key,onClick=_ref3.onClick;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__components_Button__["a" /* default */],{key:key,type:"default",active:active,activeStyle:{backgroundColor:"#ffffff",color:"black"},hoverStyle:{backgroundColor:"#ffffff",color:"black"},defaultStyle:{marginRight:"3px",backgroundColor:"#dbdbdb",padding:"2px 5px 2px 5px",letterSpacing:0,color:"black",marginBottom:"3px"},onClick:onClick},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{style:{display:"flex",alignItems:"center"}},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("img",{src:icon,alt:"",width:23,height:23,style:{marginRight:7}}),label));};var PhuketMap=(_temp=_class=function(_React$Component){_inherits(PhuketMap,_React$Component);function PhuketMap(props){_classCallCheck(this,PhuketMap);var _this=_possibleConstructorReturn(this,(PhuketMap.__proto__||Object.getPrototypeOf(PhuketMap)).call(this,props));_this.reset=function(){_this.setState(INITIAL_STATE);};_this.handleChangePage=function(page){return _this.setState({currentPage:page});};_this.renderTexts=function(){var currentLanguage=_this.props.currentLanguage;var selActiveLanguage=switchLanguage(currentLanguage);var mergedTexts=__WEBPACK_IMPORTED_MODULE_1_lodash_merge___default()(__WEBPACK_IMPORTED_MODULE_0_lodash_cloneDeep___default()(__WEBPACK_IMPORTED_MODULE_6__common__["c" /* texts */]),selActiveLanguage,{arrayMerge:overwriteMerge});return mergedTexts.map(function(element,i){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_svg_MultiLineText__["a" /* default */],Object.assign({key:"ele-"+i},element));});};_this.state=INITIAL_STATE;return _this;}_createClass(PhuketMap,[{key:"render",value:function render(){var _props=this.props,texts=_props.texts,pins=_props.pins,t=_props.t,currentLanguage=_props.currentLanguage;var currentPage=this.state.currentPage;return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:"city-map-container"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:"page-menu"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_ButtonGroup__["a" /* default */],{value:this.state.currentPage,items:[{value:"airport",label:t("Airport"),icon:iconAirport},{value:"beach",label:t("Beaches"),icon:iconBeach},{value:"island",label:t("Islands"),icon:iconIsland},{value:"school",label:t("Schools"),icon:iconSchool},{value:"attraction",label:t("Tourist Attrachtions"),icon:iconAttraction}],direction:"vertical",onChange:this.handleChangePage,renderItem:renderButton})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("svg",{className:"city-map phuket-map ",viewBox:"0 0 541 850",width:"541",height:"850"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("rect",{x:0,y:0,width:541,height:850,fill:"#EDEDEF"}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("image",{xlinkHref:bg,width:541,height:850}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(AnimatedBubble,null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_svg_LagunaPropertyBubble__["a" /* default */],{x:178-62,y:387-62,width:62,height:62})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("g",null,this.renderTexts(),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("polygon",{id:"arrow-thep",fill:"#434A69",points:"255.9,332.9 255.9,340 251.6,336.6 \t"}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("polygon",{id:"arrow-bandon",fill:"#434A69",points:"213.6,427 213.6,419.9 217.9,423.2 \t"}),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("polygon",{id:"arrow-srisoon",fill:"#434A69",points:"188.2,473.7 188.2,480.8 183.8,477.4 \t"})),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Mobile,null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("g",{id:"pins",className:"pins-mobile"},pins.map(function(pin,i){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_svg_Pin__["a" /* default */],Object.assign({key:"pin-"+i},pin,{currentLanguage:currentLanguage,visible:pin.group!=="school"}));}))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(Desktop,null,__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("g",{id:"pins",className:"pins-desktop"},pins.map(function(pin,i){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_svg_Pin__["a" /* default */],Object.assign({key:"pin-"+i},pin,{currentLanguage:currentLanguage,visible:pin.group===currentPage}));})))));}}]);return PhuketMap;}(__WEBPACK_IMPORTED_MODULE_3_react___default.a.Component),_class.defaultProps={texts:[// Terrain
{type:"MultiLineText",group:"terrain",x:318,y:66,text:["PHANG NGA"],style:{fill:"#606769"}},{type:"MultiLineText",group:"terrain",textAnchor:"start",x:258,y:329,text:["THEPKASATTRI RD."],style:{fill:"#434a69"}},{type:"MultiLineText",group:"terrain",textAnchor:"end",x:211,y:424,text:["BAN DON","CHERNG","TALAY RD."],style:{fill:"#434a69"}},{type:"MultiLineText",group:"terrain",textAnchor:"start",x:192,y:471,text:["SRISOONTHORN RD."],style:{fill:"#434a69"}},{type:"MultiLineText",group:"terrain",textAnchor:"end",x:171,y:115,text:["SARASIN BRIDGE"],style:{fill:"#41d3ab"}}],pins:[// Airport
{type:"Pin",color:"#58595b",group:"airport",animated:false,x:237,y:275,markerWidth:10,renderPin:function renderPin(){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_svg_Airplane__["a" /* default */],{x:-15,y:-20,width:20,height:20});},bubble:{x:10,y:-24,text:{en:["PHUKET","INTERNATIONAL","AIRPORT"],cn:["PHUKET","INTERNATIONAL","机场"],ru:["PHUKET","INTERNATIONAL","Аэропорт"]},textAnchor:"start",render:renderPinBubble,style:{fontSize:10,fill:"#58595b"}}},// Beach
{type:"Pin",color:"#454969",group:"beach",animated:false,x:165,y:427,markerWidth:15,bubble:{x:-14,y:-10,text:{en:"BANGTAO BEACH",cn:"邦涛海滩",ru:"Пляж Банг Тао"},textAnchor:"end",render:renderPinBubble,style:{fontSize:14}}},{type:"Pin",color:"#454969",group:"beach",animated:false,x:157,y:448,markerWidth:10,bubble:{x:-10,y:-10,text:{en:"SURIN BEACH",cn:"苏林海滩",ru:"Пляж Сурин (Surin Beach)"},textAnchor:"end",render:renderPinBubble}},{type:"Pin",color:"#454969",group:"beach",animated:false,x:156,y:473,markerWidth:10,bubble:{x:-10,y:-10,text:{en:"KAMALA BEACH",cn:"卡玛拉海滩",ru:"Пляж Камала (Kamala Beach)"},textAnchor:"end",render:renderPinBubble}},{type:"Pin",color:"#454969",group:"beach",animated:false,x:182,y:542,markerWidth:10,bubble:{x:-10,y:-10,text:{en:"PATONG BEACH",cn:"芭东海滩",ru:"Пляж Патонг (Patong Beach)"},textAnchor:"end",render:renderPinBubble}},// Island
{type:"Pin",color:"#728dae",group:"island",animated:false,x:382,y:441,markerWidth:10,bubble:{x:10,y:-6,text:{en:"RANG NOI ISLAND",cn:"小朗岛",ru:"Остров Rang Noi"},textAnchor:"start",render:renderPinBubble}},{type:"Pin",color:"#728dae",group:"island",animated:false,x:382,y:462,markerWidth:10,bubble:{x:10,y:-6,text:{en:"RANG YAI ISLAND",cn:"大朗岛",ru:"Остров Rang Yai"},textAnchor:"start",render:renderPinBubble}},{type:"Pin",color:"#728dae",group:"island",animated:false,x:360,y:488,markerWidth:10,bubble:{x:10,y:-6,text:{en:"COCONUT ISLAND",cn:"椰子岛",ru:"Остров Coconut Island"},textAnchor:"start",render:renderPinBubble}},{type:"Pin",color:"#728dae",group:"island",animated:false,x:398,y:693,markerWidth:10,bubble:{x:10,y:-6,text:{en:"PHI PHI ISLAND",cn:"皮皮岛",ru:"Архипелаг Пхи-Пхи (Koh Phi Phi)"},textAnchor:"start",render:renderPinBubble}},{type:"Pin",color:"#728dae",group:"island",animated:false,x:286,y:678,markerWidth:10,bubble:{x:10,y:-6,text:{en:"LON ISLAND",cn:"桃花岛",ru:"Ко Лон (Koh Lon)"},textAnchor:"start",render:renderPinBubble}},{type:"Pin",color:"#728dae",group:"island",animated:false,x:312,y:717,markerWidth:10,bubble:{x:-10,y:-6,width:76,text:{en:"MAITON ISLAND",cn:"蜜月岛",ru:"Остров Maiton Island"},textAnchor:"end",render:renderPinBubble}},{type:"Pin",color:"#728dae",group:"island",animated:false,x:283,y:740,markerWidth:10,bubble:{x:10,y:-6,text:{en:"CORAL ISLAND",cn:"珊瑚岛",ru:"Ко Хай (Koh Hae)"},textAnchor:"start",render:renderPinBubble}},// School
{type:"Pin",color:"#5b3a70",group:"school",animated:false,x:250,y:424,markerWidth:10,bubble:{x:10,y:-24,text:{en:["PHUKET","INTERNATIONAL","ACADEMY"],cn:["普吉国际学校"],ru:["Пхукетская международная академия "]},textAnchor:"start",render:renderPinBubble,style:{fontSize:10,fill:"#5b3a70"}}},{type:"Pin",color:"#5b3a70",group:"school",animated:false,x:240,y:511,markerWidth:10,bubble:{x:10,y:-24,text:{en:["BRITISH","INTERNATIONAL","SCHOOL"],cn:["英国国际学校"],ru:["Британская международная школа"]},textAnchor:"start",render:renderPinBubble,style:{fontSize:10,fill:"#5b3a70"}}},{type:"Pin",color:"#5b3a70",group:"school",animated:false,x:252,y:567,markerWidth:10,bubble:{x:10,y:-24,text:{en:["HEADSTART","INTERNATIONAL","SCHOOL"],cn:["普吉领袖国际学校","",""],ru:["Междунарожная школа","«Headstart»",""]},textAnchor:"start",render:renderPinBubble,style:{fontSize:10,fill:"#5b3a70"}}},// Tourist Attraction
{type:"Pin",color:"#4d6c64",group:"attraction",animated:false,x:300,y:376,markerWidth:10,bubble:{x:10,y:-6,text:{en:["BANGPAE","WATERFALL"],cn:["BANGPAE","瀑布"],ru:["Водопад ","BANGPAE"]},textAnchor:"start",render:renderPinBubble,style:{fontSize:10,fill:"#4d6c64"}}},{type:"Pin",color:"#4d6c64",group:"attraction",animated:false,x:270,y:408,markerWidth:10,bubble:{x:10,y:-6,text:{en:["TONSAI","WATERFALL"],cn:["通赛瀑布",""],ru:["Водопад ","TONSAI"]},textAnchor:"start",render:renderPinBubble,style:{fontSize:10,fill:"#4d6c64"}}},{type:"Pin",color:"#4d6c64",group:"attraction",animated:false,x:253,y:535,markerWidth:10,bubble:{x:10,y:-6,text:{en:"CENTRAL FESTIVAL",cn:"普吉岛中央百货",ru:"ТРЦ «Сentral Festival»"},textAnchor:"start",render:renderPinBubble,style:{fontSize:10,fill:"#4d6c64"}}},{type:"Pin",color:"#4d6c64",group:"attraction",animated:false,x:272,y:552,markerWidth:10,bubble:{x:10,y:-18,text:{en:["PHUKET","OLDTOWN"],cn:["普吉老镇",""],ru:["Старинный город","«Phuket Town»"]},textAnchor:"start",render:renderPinBubble,style:{fontSize:10,fill:"#4d6c64"}}},{type:"Pin",color:"#4d6c64",group:"attraction",animated:false,x:241,y:586,markerWidth:10,bubble:{x:10,y:-6,text:{en:"CHALONG TEMPLE",cn:"查龙寺",ru:"Храм CHALONG"},textAnchor:"start",render:renderPinBubble,style:{fontSize:10,fill:"#4d6c64"}}},{type:"Pin",color:"#4d6c64",group:"attraction",animated:false,x:201,y:620,markerWidth:10,bubble:{x:-10,y:-6,width:76,text:{en:"BIG BUDDHA",cn:"普吉大佛",ru:"Храм BIG BUDDHA"},textAnchor:"end",render:renderPinBubble,style:{fontSize:10,fill:"#4d6c64"}}},{type:"Pin",color:"#4d6c64",group:"attraction",animated:false,x:194,y:697,markerWidth:10,bubble:{x:10,y:-6,text:{en:["PHOMTHEP","CAPE"],cn:["神仙半岛",""],ru:["Мыс","PHOMTHEP"]},textAnchor:"start",render:renderPinBubble,style:{fontSize:10,fill:"#4d6c64"}}}]},_temp);/* harmony default export */ __webpack_exports__["a"] = (PhuketMap);

/***/ }),
/* 819 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return texts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return CNtexts; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return RUtexts; });
var texts=[// Terrain
{type:"MultiLineText",group:"terrain",x:318,y:66,text:["PHANG NGA"],style:{fill:"#606769"}},{type:"MultiLineText",group:"terrain",textAnchor:"start",x:258,y:329,text:["THEPKASATTRI RD."],style:{fill:"#434a69"}},{type:"MultiLineText",group:"terrain",textAnchor:"end",x:211,y:424,text:["BAN DON","CHERNG","TALAY RD."],style:{fill:"#434a69"}},{type:"MultiLineText",group:"terrain",textAnchor:"start",x:192,y:471,text:["SRISOONTHORN RD."],style:{fill:"#434a69"}},{type:"MultiLineText",group:"terrain",textAnchor:"end",x:171,y:115,text:["SARASIN BRIDGE"],style:{fill:"#41d3ab"}}];var CNtexts=[// Terrain
{text:["攀牙"]},{text:["Thepkasattri路"]},{text:["Ban Don","Cherng","路"]},{text:["Srisoonthorn路"]},{text:["萨拉辛桥"]}];var RUtexts=[// Terrain
{text:["Пхангнга (Phang Nga)"]},{text:["Дорога Тепкасатри (Thepkasattri Road)"]},{text:["Дорога","Ban Don","Cherng","Talay RD."]},{text:["Дорога Срисунтхорн (Srisoonthorn Road)"]},{text:["Мост Сарасин (Sarasin)"]}];

/***/ }),
/* 820 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",Object.assign({viewBox:"0 0 15.2 15.2"},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#58595B",d:"M14.1,13.5l-0.9-3.1L14,9.7c0.2-0.2,0.2-0.4,0.1-0.6l-0.4-0.5c-0.1-0.2-0.4-0.2-0.6,0l-0.3,0.2l-0.3-1.2 l0.8-0.7c0.2-0.2,0.2-0.4,0.1-0.6L13,5.8c-0.1-0.2-0.4-0.2-0.6,0L12,6.1l-0.2-0.8c1-1.1,1.9-2,2.4-2.5c1.4-1.6,1-2.7,0.9-2.7l0,0 c0,0,0,0,0,0l0,0l0,0c-0.1,0-1.1-0.5-2.7,0.9C11.9,1.5,11,2.4,9.9,3.4L9.1,3.2l0.3-0.3c0.2-0.2,0.2-0.5,0-0.6L8.9,1.9 C8.7,1.7,8.5,1.8,8.3,1.9L7.6,2.8L6.4,2.4l0.2-0.3c0.2-0.2,0.2-0.5,0-0.6L6.1,1.2C6,1,5.7,1.1,5.5,1.3L4.9,2L1.7,1.1 c-0.2-0.1-0.4,0-0.6,0.2L0.9,1.6l5.4,3.4c0.1,0.1,0.2,0.2,0.3,0.3l0.6,0.8c-1.6,1.6-3,3.1-3.4,3.8l-3-0.5c-0.2,0-0.4,0-0.5,0.2 L0,9.9l2.8,1.8c-0.9,1.2-1,1.7-1,1.7s0.6-0.1,1.7-1l1.9,2.8l0.4-0.3c0.2-0.1,0.2-0.3,0.2-0.5l-0.5-3C5.9,11,7.5,9.6,9.1,8l0.8,0.6 c0.1,0.1,0.2,0.2,0.3,0.3l3.4,5.4l0.3-0.3C14.1,13.9,14.2,13.7,14.1,13.5z"}));});

/***/ }),
/* 821 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony default export */ __webpack_exports__["a"] = (function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",Object.assign({viewBox:"0 0 61.8 62",xmlSpace:"preserve"},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#00A19B",d:"M0,31C0,14,13.8,0.1,30.9,0.1S61.8,14,61.8,31c0,7.3-2.6,14.1-6.8,19.4c0,0.2,5.4,11.3,5.4,11.3 s-11.8-5-12-5.1c-5,3.4-11,5.4-17.4,5.4C13.8,61.9,0,48.1,0,31z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M16.2,35.2c-1.5,0-2.4-0.8-2.4-2c0-1.4,1.6-2,2.9-2.6c0.2-0.1,0.4-0.2,0.5-0.2c0.3-0.1,0.5-0.2,0.7-0.3 c0.6-0.2,0.6-0.2,0.6-1.1c0-0.8-0.3-1.1-1.3-1.2c0,0-0.1,0-0.1,0c-0.9,0-1.6,0.5-1.8,0.7l0,0c-0.1,0.1-0.2,0.1-0.3,0.1 c-0.1,0-0.1,0-0.2-0.1c0,0-0.1-0.1-0.1-0.2c0-0.1,0.1-0.3,0.3-0.5c0.9-0.8,2-0.9,2.6-0.9c1,0,2.4,0.2,2.4,1.5V32 c0,0.1,0,0.3,0,0.4c0,0.8,0,1.3,0.2,1.9c0.1,0.2,0.2,0.4,0.5,0.4c0.2,0,0.3,0.1,0.4,0.2c0,0.2-0.2,0.2-0.3,0.3 c-0.2,0-0.4,0.1-0.6,0.1l0,0c-0.2,0-0.4,0-0.6-0.1l0,0c-0.9-0.3-1-0.6-1.1-0.8c0,0,0,0,0-0.1c0-0.1-0.1-0.1-0.1-0.1c0,0,0,0,0,0 c0,0,0,0,0,0l0,0C18,34.7,17.6,35.2,16.2,35.2L16.2,35.2z M18.5,30.5l-0.9,0.4c-1.3,0.6-2.1,1-2.1,1.9c0,0.7,0.5,1.2,1.4,1.2 c1.1,0,1.6-0.9,1.6-1.9V30.5L18.5,30.5z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M50.2,35.2c-1.5,0-2.4-0.8-2.4-2c0-1.4,1.6-2,2.9-2.6c0.2-0.1,0.4-0.2,0.5-0.2c0.3-0.1,0.5-0.2,0.7-0.3 c0.6-0.2,0.6-0.2,0.6-1.1c0-0.8-0.3-1.1-1.3-1.2c0,0-0.1,0-0.1,0c-0.9,0-1.6,0.5-1.8,0.7l0,0c-0.1,0.1-0.2,0.1-0.3,0.1 c-0.1,0-0.1,0-0.2-0.1c0,0-0.1-0.1-0.1-0.2c0-0.1,0.1-0.3,0.3-0.5c0.9-0.8,2-0.9,2.6-0.9c1,0,2.4,0.2,2.4,1.5V32 c0,0.1,0,0.3,0,0.4c0,0.8,0,1.1,0.2,1.7c0.1,0.2,0.2,0.4,0.5,0.4c0.2,0,0.3,0.1,0.4,0.2c0,0.2-0.2,0.2-0.3,0.3 c-0.2,0-0.4,0-0.6,0l0,0c-0.2,0-0.4,0-0.6-0.1l0,0c-0.9-0.3-1-0.6-1.1-0.8c0,0,0,0,0-0.1c0-0.1-0.1-0.1-0.1-0.1c0,0,0,0,0,0 c0,0,0,0,0,0l0,0C52,34.6,51.6,35.2,50.2,35.2L50.2,35.2z M52.5,30.5l-0.9,0.4c-1.3,0.6-2.1,1-2.1,1.9c0,0.7,0.5,1.2,1.4,1.2 c1.1,0,1.6-0.9,1.6-1.9V30.5L52.5,30.5z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M33.4,35.2c-1.4,0-2.4-1-2.4-2.4c0,0,0-4.6,0-4.7c0-0.2-0.1-0.3-0.4-0.3l-0.2,0c-0.2,0-0.5,0-0.5-0.2 c0-0.2,0.2-0.2,0.4-0.3l0.1,0c0.3,0,0.6-0.1,1-0.1c0.6,0,1.1,0.2,1.1,0.7v3.9c0,1.2,0.2,2.3,1.6,2.3c1.5,0,1.7-1.5,1.7-2.9V28 c0-0.1,0-0.3-0.4-0.3l-0.1,0c0,0-0.1,0-0.1,0c0,0-0.1,0-0.1,0c-0.1,0-0.4,0-0.4-0.2c0-0.2,0.2-0.2,0.4-0.3l0.1,0 c0.3,0,0.6-0.1,1-0.1c0.6,0,1.1,0.2,1.1,0.7c0,0.3,0,1.7,0,3c0,1,0,1.9,0,2c0,0.6,0.1,1,0.2,1.3c0.1,0.2,0.2,0.4,0.5,0.4h0 c0.1,0,0.4,0,0.4,0.2c0,0,0,0.2-0.3,0.2c-0.2,0-0.4,0.1-0.5,0.1l0,0c-0.2,0-0.3,0-0.4,0c-0.1,0-0.1,0-0.2,0l0,0 c-0.3-0.1-0.6-0.2-0.7-0.3c-0.2-0.2-0.3-0.4-0.3-0.5l0,0c0,0,0,0,0-0.1c0,0,0,0,0-0.1c0,0-0.1,0.1-0.1,0.1c0,0.1-0.1,0.1-0.1,0.2 C35.5,34.6,34.6,35.2,33.4,35.2L33.4,35.2z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M44,27c1.4,0,2.4,1,2.4,2.4c0,0,0,4.8,0,4.8c0,0.2,0.1,0.3,0.4,0.3h0.2c0.2,0,0.5,0,0.5,0.2 c0,0.2-0.2,0.2-0.4,0.3l-0.1,0c-0.3,0-0.6,0.1-1,0.1c-0.6,0-1.1-0.2-1.1-0.7v-4c0-1.2-0.2-2.3-1.6-2.3c-1.5,0-1.7,1.5-1.7,2.9 v3.3c0,0.1,0,0.3,0.4,0.3l0.1,0c0,0,0.1,0,0.1,0c0,0,0.1,0,0.1,0c0.1,0,0.4,0,0.4,0.2c0,0.2-0.2,0.2-0.4,0.3l-0.1,0 c-0.3,0-0.6,0.1-1,0.1c-0.6,0-1.1-0.2-1.1-0.7c0-0.3,0-1.8,0-3.1c0-1,0-1.9,0-2c0-0.6-0.1-0.9-0.2-1.2c-0.1-0.2-0.2-0.4-0.5-0.4 l0,0c-0.1,0-0.4,0-0.4-0.2c0,0,0-0.2,0.3-0.2c0.2,0,0.3-0.1,0.5-0.1l0,0c0.2,0,0.3,0,0.4,0c0.1,0,0.1,0,0.2,0l0,0 c0.3,0.1,0.6,0.2,0.7,0.3c0.2,0.2,0.3,0.4,0.3,0.5l0,0c0,0,0,0,0,0.1c0,0,0,0,0,0.1c0,0,0.1-0.1,0.1-0.1c0-0.1,0.1-0.1,0.1-0.2 C41.9,27.8,42.8,27,44,27L44,27z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M26.3,35.2c-3,0-4.6-1.4-4.6-3.9c0-1.3,0.5-2.3,1.5-3.3c1.2-1.1,2.9-0.8,3.2-0.8c0.3,0,0.5,0.1,0.8,0.1 c0.2,0,0.4,0,0.6-0.1l0.2-0.1c0.4-0.2,0.5-0.3,0.7-0.3c0.1,0,0.1,0,0.2,0.1c0.2,0.2,0,0.4-0.1,0.5c0,0,0,0-0.1,0.1 c-0.3,0.4-0.7,0.7-1,0.8c-0.8,0.1-1.4-0.4-2-0.4c-1.7,0-2.1,1.9-2.1,3c0,1.6,0.6,3.4,3.3,3.4c0,0,0.1,0,0.1,0v0c0,0,0,0,0,0l0,0 l0,0c0.1,0,0.2,0,0.3,0c0,0,0.1,0,0.1,0c0.3,0,0.3-0.2,0.3-0.3l0-2.5c0-0.1-0.1-0.2-0.1-0.2c0,0,0,0-0.1,0c-0.1,0-0.3,0-0.5,0 c-0.3,0-0.7,0-1.1,0c-0.5,0-0.7,0-0.8-0.1C25,31.1,25,31,25,31c0-0.3,0.3-0.3,0.7-0.3c0.1,0,0.3,0,0.6,0c0.6,0,1.5,0,1.7,0 c0.5,0,1.1,0.2,1.1,0.8l0,1c0,0.1,0,0.2,0,0.3v1.2c0,0.8-0.7,1.3-2.2,1.4l-0.1,0C26.6,35.2,26.5,35.2,26.3,35.2L26.3,35.2z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M10.3,35.2c-1.4,0-1.9-0.4-1.9-1.6l0-3.9v-4.1h0.1l0,0H8.4v-0.4c0-0.1,0-0.3-0.4-0.3l-0.1,0 c-0.3,0-0.6,0-0.6-0.2c0-0.2,0.3-0.2,0.5-0.3l0,0c0.1,0,0.2,0,0.4,0c0.2,0,0.4,0,0.6,0c0.6,0,1.1,0.2,1.1,0.7l0,8.4 c0,0.3,0,0.6,0.2,0.8c0.1,0.1,0.3,0.2,0.6,0.2c0.4,0,1.1-0.1,1.9-0.7l0,0c0.2-0.1,0.4-0.2,0.5-0.1c0.1,0.1,0.1,0.1,0.1,0.2 c0,0.1-0.1,0.3-0.3,0.5C12,35.1,10.8,35.2,10.3,35.2L10.3,35.2z"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#00A19B",d:"M22.5,25c0,0,0-0.1,0-0.2c0.1-0.2,0.5-0.9,1.2-1.4c0.8-0.6,1.6-0.9,2.2-1.3c0.5-0.4,0.8-0.7,0.8-1 c0,0,0-0.1,0-0.1c0,0,0,0,0.1,0.1c0,0.2,0,1-0.7,1.8c-0.5,0.6-1.3,1-1.9,1.2c-0.5,0.3-0.9,0.4-1.3,0.7C22.9,24.8,22.6,25,22.5,25z "}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#EC008C",d:"M26.9,22.2c0,0.1,0.3,1.1-0.5,2c-0.8,1-1.9,1.2-2.8,1.5c-0.7,0.3-1.4,0.6-1.8,1.2 c-0.1,0.1-0.1,0.2-0.2,0.3c-0.1,0-0.1-0.1-0.1-0.2c0-0.1-0.1-1,0.7-1.7c0.9-0.8,1.7-1,3-1.7c1-0.5,1.3-1.2,1.4-1.4 c0,0,0.1-0.2,0.1-0.2C26.8,21.9,26.8,22.1,26.9,22.2z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M18.7,38.5h1.6c0.5,0,0.9,0.2,0.9,0.9c0,0.6-0.4,0.9-1,0.9H19v1.3h-0.3V38.5z M19,40h1.2 c0.5,0,0.7-0.2,0.7-0.6c0-0.4-0.3-0.6-0.6-0.6H19V40z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M21.9,38.5h1.6c0.5,0,1,0.2,1,0.8c0,0.3-0.2,0.6-0.6,0.7v0c0.4,0.1,0.5,0.3,0.5,0.8c0,0.2,0,0.6,0.1,0.6 h-0.3c-0.1-0.1-0.1-0.3-0.1-0.6c0-0.5-0.2-0.7-0.7-0.7h-1.2v1.3h-0.3V38.5z M22.2,39.9h1.3c0.3,0,0.6-0.1,0.6-0.6 c0-0.4-0.3-0.5-0.6-0.5h-1.3V39.9z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M26.7,38.4c0.9,0,1.6,0.5,1.6,1.6c0,1.1-0.8,1.6-1.6,1.6s-1.6-0.5-1.6-1.6C25.1,39,25.8,38.4,26.7,38.4z M26.7,41.3c0.7,0,1.3-0.4,1.3-1.3s-0.6-1.3-1.3-1.3c-0.7,0-1.3,0.4-1.3,1.3S26,41.3,26.7,41.3z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M29,38.5h1.6c0.5,0,0.9,0.2,0.9,0.9c0,0.6-0.4,0.9-1,0.9h-1.2v1.3H29V38.5z M29.3,40h1.2 c0.5,0,0.7-0.2,0.7-0.6c0-0.4-0.3-0.6-0.6-0.6h-1.3V40z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M32.2,38.5h2.4v0.3h-2.1v1h2v0.3h-2v1.1h2.1v0.3h-2.4V38.5z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M35.3,38.5h1.6c0.5,0,1,0.2,1,0.8c0,0.3-0.2,0.6-0.6,0.7v0c0.4,0.1,0.5,0.3,0.5,0.8c0,0.2,0,0.6,0.1,0.6 h-0.3c-0.1-0.1-0.1-0.3-0.1-0.6c0-0.5-0.2-0.7-0.7-0.7h-1.2v1.3h-0.3V38.5z M35.6,39.9h1.3c0.3,0,0.6-0.1,0.6-0.6 c0-0.4-0.3-0.5-0.6-0.5h-1.3V39.9z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M39.5,38.8h-1.2v-0.3H41v0.3h-1.2v2.7h-0.3V38.8z"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{fill:"#FFFFFF",d:"M42.5,40.3l-1.3-1.7h0.4l1.1,1.4l1.1-1.4h0.4l-1.3,1.7v1.3h-0.3V40.3z"})))));});

/***/ }),
/* 822 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Ebrochure; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hoc__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__containers__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__utils__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_class2,_temp2;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Ebrochure=(_dec=Object(__WEBPACK_IMPORTED_MODULE_2__hoc__["a" /* multiLanguage */])(),_dec(_class=(_temp2=_class2=function(_Component){_inherits(Ebrochure,_Component);function Ebrochure(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Ebrochure);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Ebrochure.__proto__||Object.getPrototypeOf(Ebrochure)).call.apply(_ref,[this].concat(args))),_this),_this.state={showDownloadModal:false},_this.handleOpenDownload=function(){_this.setState({showDownloadModal:true});},_this.handleCloseModal=function(){_this.setState({showDownloadModal:false});},_this.handleEbrochureDownloaded=function(){_this.setState({showDownloadModal:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Ebrochure,[{key:"render",value:function render(){var _this2=this;var _props=this.props,page=_props.page,t=_props.t,currentLanguage=_props.currentLanguage;var showDownloadModal=this.state.showDownloadModal;console.log("assetsPath(page) ebrochure >>>> ",this.props);return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"section-ebrochure container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"section-ebrochure-image"},page==="phuket-laguna-park-2"?__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"section-ebrochure-image",src:Object(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* assetsPath */])(page)+"/images/e-brochure/cover-new-"+currentLanguage+".jpg",alt:""}):__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"section-ebrochure-image",src:Object(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* assetsPath */])(page)+"/images/e-brochure/cover-"+currentLanguage+".jpg",alt:""})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"section-ebrochure-containbtn"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",{style:{margin:20}},t("E-Brochure")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"section-ebrochure-btn _df_button"// className="section-ebrochure-btn"
,source:Object(__WEBPACK_IMPORTED_MODULE_5__utils__["a" /* assetsPath */])(page)+"/pdf/brochure/"+currentLanguage+".pdf"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ebrochure-text"},t("View Online"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"section-ebrochure-btn",onClick:function onClick(){return _this2.handleOpenDownload();}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"ebrochure-text"},t("Download"))))),showDownloadModal&&__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["k" /* Modal */],{name:"ebrochure-modal",onCancel:this.handleCloseModal},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__containers__["b" /* EbrochureDownload */],{t:this.props.t,location:this.props.location,project:this.props.project,language:this.props.currentLanguage,onSubmit:this.handleEbrochureDownloaded})));}}]);return Ebrochure;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]),_class2.propTypes={t:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.func},_class2.defaultProps={t:function t(){}},_temp2))||_class);

/***/ }),
/* 823 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Faq; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_includes__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_filter__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hoc__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_class2,_temp2;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Faq=(_dec=Object(__WEBPACK_IMPORTED_MODULE_5__hoc__["a" /* multiLanguage */])(),_dec(_class=(_temp2=_class2=function(_Component){_inherits(Faq,_Component);function Faq(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Faq);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Faq.__proto__||Object.getPrototypeOf(Faq)).call.apply(_ref,[this].concat(args))),_this),_this.state={currentCategoryId:1,showAnswerId:0},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Faq,[{key:"render",value:function render(){var _this2=this;var _props=this.props,t=_props.t,category=_props.category,faqs=_props.faqs,currentLanguage=_props.currentLanguage;var _state=this.state,currentCategoryId=_state.currentCategoryId,showAnswerId=_state.showAnswerId;var faqId=__WEBPACK_IMPORTED_MODULE_2_lodash_filter___default()(faqs,["categoryId",currentCategoryId]);return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:"section-faq"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:"row section-name"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("h2",null,t("FAQ"))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:"row container-faq"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:"col-xl-3 col-lg-10"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("ul",{className:"ul-faq-title"},__WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(category,function(value){var isInclude=__WEBPACK_IMPORTED_MODULE_0_lodash_includes___default()(value.displayOn,currentLanguage);if(isInclude){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("li",{key:value.id,className:"title-faq "+(value.id===currentCategoryId?"active":""),onClick:function onClick(){return _this2.setState({currentCategoryId:value.id,showAnswerId:0});}},t(value.name));}return null;}))),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:"col-xl-8 col-lg-10"},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(faqId,function(value,key){var isInclude=__WEBPACK_IMPORTED_MODULE_0_lodash_includes___default()(value.displayOn,currentLanguage);if(value.categoryId===currentCategoryId&&isInclude){return __WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("li",{className:"question-faq",key:key},__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("h3",{onClick:function onClick(){return _this2.setState({showAnswer:true,showAnswerId:key});}},t({en:"Q.",cn:"问.",ru:"B."}),t(value.question)),__WEBPACK_IMPORTED_MODULE_3_react___default.a.createElement("div",{className:"answer-faq "+(showAnswerId===key?"show-answer":"")},t(value.answer)));}}))))));}}]);return Faq;}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]),_class2.propTypes={t:__WEBPACK_IMPORTED_MODULE_4_prop_types___default.a.func.isRequired},_temp2))||_class);

/***/ }),
/* 824 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_split__ = __webpack_require__(161);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_split___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_split__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_last__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_last__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_size__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_size___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_size__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_map__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_head__ = __webpack_require__(825);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_head___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_head__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_find__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_get__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_chain__ = __webpack_require__(826);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_chain___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_chain__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_router_dom__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_skrollr__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_react_skrollr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_react_skrollr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__hoc__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__containers__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_video_react__ = __webpack_require__(829);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_video_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_video_react__);
var _slicedToArray=function(){function sliceIterator(arr,i){var _arr=[];var _n=true;var _d=false;var _e=undefined;try{for(var _i=arr[Symbol.iterator](),_s;!(_n=(_s=_i.next()).done);_n=true){_arr.push(_s.value);if(i&&_arr.length===i)break;}}catch(err){_d=true;_e=err;}finally{try{if(!_n&&_i["return"])_i["return"]();}finally{if(_d)throw _e;}}return _arr;}return function(arr,i){if(Array.isArray(arr)){return arr;}else if(Symbol.iterator in Object(arr)){return sliceIterator(arr,i);}else{throw new TypeError("Invalid attempt to destructure non-iterable instance");}};}();var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_class2,_temp2;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_11_react_router_dom__["d" /* withRouter */])((_dec=Object(__WEBPACK_IMPORTED_MODULE_13__hoc__["a" /* multiLanguage */])(),_dec(_class=(_temp2=_class2=function(_Component){_inherits(Gallery,_Component);function Gallery(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Gallery);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Gallery.__proto__||Object.getPrototypeOf(Gallery)).call.apply(_ref,[this].concat(args))),_this),_this.state={selectedVirtualTourSubType:"",selectedVirtualTourType:"",showImagesModal:false,showVideoModal:false,showTourModal:false,showSubMenuVideo:false,videoSource:_this.props.video},_this.handleClickImages=function(){var history=_this.props.history;history.push({hash:"#images"});},_this.handleClickVideo=function(){var _this$props=_this.props,history=_this$props.history,videos=_this$props.videos;if(videos&&videos.length>0){_this.setState({showSubMenuVideo:!_this.state.showSubMenuVideo});}else{history.push({hash:"#video"});_this.setState({showVideoModal:true});}},_this.handleClickTour=function(){var history=_this.props.history;history.push({hash:"#tour"});},_this.handleCloseImagesModal=function(){var history=_this.props.history;history.push({hash:"#gallery"});},_this.handleCloseVideoModal=function(){var history=_this.props.history;history.push({hash:"#gallery"});},_this.handleCloseTourModal=function(){var history=_this.props.history;history.push({hash:"#gallery"});},_this.handleSelectVirtualTourType=function(type){console.log("xxxxxx handleSelectVirtualTourType",type);_this.setState({selectedVirtualTourType:type,selectedVirtualTourSubType:""});},_this.handleSelectVirtualTourSubType=function(type,subType){_this.setState({selectedVirtualTourType:type,selectedVirtualTourSubType:subType});},_this.handleClickViewVideo=function(videoTitleKey){var history=_this.props.history;console.log("handleClickViewVideo - videoSource",videoTitleKey);history.push({hash:"#video-"+videoTitleKey});_this.setState({showVideoModal:true,showSubMenuVideo:false});},_this.renderVirtualTour=function(){var _this$state=_this.state,selectedVirtualTourType=_this$state.selectedVirtualTourType,selectedVirtualTourSubType=_this$state.selectedVirtualTourSubType;var _this$props2=_this.props,image360=_this$props2.image360,view360=_this$props2.view360,page=_this$props2.page;console.log("renderVirtualTour",{image360:image360,view360:view360});if(image360){return image360?__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("iframe",{title:"tour",src:image360,width:"100%",height:"100%"}):__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__containers__["a" /* ComingSoon */],null);}if(!view360){return image360?__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("iframe",{title:"tour",src:image360,width:"100%",height:"100%"}):__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__containers__["a" /* ComingSoon */],null);}// let virtualTourView =
//   _.find(view360, (view) => view.id === selectedVirtualTourType) ||
//   _.head(view360);
// let virtualTourElement = <div />;
// if (
//   virtualTourView &&
//   _.get(virtualTourView, "src") &&
//   _.get(virtualTourView, "type") !== "list"
// ) {
//   virtualTourElement = (
//     <iframe
//       title="tour"
//       src={_.get(virtualTourView, "src")}
//       width="100%"
//       height="100%"
//     />
//   );
// } else {
//   virtualTourElement = (
//     <ComingSoon
//       fontColor={page === "laguna-beachside" ? "#fff" : "#000"}
//       src={_.get(virtualTourView, "src")}
//     />
//   );
// }
var virtualTourView=__WEBPACK_IMPORTED_MODULE_6_lodash_find___default()(view360,function(view){return view.id===selectedVirtualTourType;})||__WEBPACK_IMPORTED_MODULE_5_lodash_head___default()(view360);var virtualTourElement=__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",null);if(virtualTourView&&virtualTourView.src// virtualTourView.type !== "list" &&
// _.isEmpty(selectedVirtualTourType)
){virtualTourElement=__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("iframe",{title:"tour",src:__WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(virtualTourView,"src"),width:"100%",height:"100%"});}else{virtualTourElement=__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("img",{className:"banner-360",alt:"",src:__WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(virtualTourView,"src"),width:"100%",height:"100%"});}console.log("virtualTourElement",{virtualTourView:virtualTourView,src:__WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(virtualTourView,"src"),type:__WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(virtualTourView,"type"),selectedVirtualTourType:selectedVirtualTourType});// console.log("renderVirtualTour - virtualTourElement", {
//   view360,
//   virtualTourElement,
// });
var buttonElements=__WEBPACK_IMPORTED_MODULE_4_lodash_map___default()(view360,function(view,i){console.log(".xxxxxxxxxxxxxxxxx",{view:view,id:view.id,src:view.src});// if (_.size(view.list) <= 0) {
//   virtualTourElement = (
//     <iframe
//       title="tour"
//       src={_.get(virtualTourView, "src")}
//       width="100%"
//       height="100%"
//     />
//   );
// }
if(view.list&&__WEBPACK_IMPORTED_MODULE_3_lodash_size___default()(view.list)>0){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{className:"custom-dropdown direction-up"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components__["b" /* Button */],{className:"main-button",defaultStyle:{backgroundColor:view.id===selectedVirtualTourType||__WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty___default()(selectedVirtualTourType)&&i===0?"#04a8a6":"#333"}},view.id.toUpperCase()),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{className:"sub-list"},__WEBPACK_IMPORTED_MODULE_4_lodash_map___default()(view.list,function(subView,j){console.log("xxxxxxxxxxxxxxxxx",{subView:subView});if(subView.id===selectedVirtualTourSubType){virtualTourElement=subView.src;}return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components__["b" /* Button */],{defaultStyle:{backgroundColor:subView.id===selectedVirtualTourSubType?"#04a8a6":"rgba(51, 51, 51, 0.7)"},onClick:function onClick(){return _this.handleSelectVirtualTourSubType(view.id,subView.id);}},subView.id.toUpperCase());})));}return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components__["b" /* Button */],{defaultStyle:{backgroundColor:view.id===selectedVirtualTourType||__WEBPACK_IMPORTED_MODULE_2_lodash_isEmpty___default()(selectedVirtualTourType)&&i===0?"#04a8a6":"#333"},onClick:function onClick(){return _this.handleSelectVirtualTourType(view.id);}},view.id.toUpperCase());});return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{className:"virtual-tour-container"},__WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(virtualTourView,"type")!=="hidden"&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{className:"type-selection"},buttonElements),virtualTourElement);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Gallery,[{key:"componentDidUpdate",value:function componentDidUpdate(prevProps,prevState){var view360=this.props.view360;console.log("+++++",{state:this.state,prevState:prevState});if(prevState.view360!==view360&&prevState.selectedVirtualTourType===""){console.log("+++++++++++++++++++++++++++ 1",{prevState:prevState.selectedVirtualTourType,state:this.state.selectedVirtualTourType});this.setState({selectedVirtualTourType:__WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(view360,[0,"id"]),selectedVirtualTourSubType:__WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(view360,[0,"list",0,"id"])});}}},{key:"render",value:function render(){var _this2=this;console.log(">>>>>",this);var _state=this.state,videoSource=_state.videoSource,showImagesModal=_state.showImagesModal,showVideoModal=_state.showVideoModal,showTourModal=_state.showTourModal,showSubMenuVideo=_state.showSubMenuVideo;var _props=this.props,page=_props.page,t=_props.t,heroShot=_props.heroShot,videos=_props.videos,isRenderTitle=_props.isRenderTitle;var title="Gallery-title-"+page;if(page==="phuket-dusit-deluxe-pool-villa"){title={en:"DUSIT LAGUNA RESORT VILLAS, PHUKET",cn:"普吉岛乐古浪都喜度假别墅酒店",ru:"DUSIT LAGUNA RESORT VILLAS, PHUKET"};}// if (page === "laguna-beachside") {
//   title = {
//     en: "DUSIT LAGUNA RESORT VILLAS, PHUKET",
//     cn: "普吉岛乐古浪都喜度假别墅酒店",
//     ru: "DUSIT LAGUNA RESORT VILLAS, PHUKET",
//   };
// }
// _.lastIndexOf([1, 2, 1, 2], 2);
// const users = [
//   { user: "barney", age: 36 },
//   { user: "fred", age: 40 },
//   { user: "pebbles", age: 1 },
// ];
// const type = _chain(users)
//   .sortBy("age")
//   .map(function(o) {
//     return o.user + " is " + o.age;
//   })
//   .head()
//   .value();
var type=__WEBPACK_IMPORTED_MODULE_1_lodash_last___default()(__WEBPACK_IMPORTED_MODULE_0_lodash_split___default()(t(videoSource),"."));// const type = _.last(_.split(videoSource, "."));
// const type = _.last(_.split(_.get(videoSource, "en"), "."));
console.log("videoSource",// {
//   showVideoModal,
//   videoSource,
//   type,
// },
// t(videoSource),
heroShot);var hasMultipleVideo=videos&&videos.length>1;return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{className:"section-gallery"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{className:"parallax-container"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12_react_skrollr__["Parallax"],{data:{"data-0-start":"transform: translateY(0px);"}},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{className:"image-slider-block"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components__["q" /* SliderWithLoading */],{items:heroShot,des:__WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(heroShot,"title"),duration:6000,loadingHeight:7,loadingColor:"#04a8a6",position:"bottom",isRenderTitle:true,t:t})))),isRenderTitle===false&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{className:"content-block"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("h1",{dangerouslySetInnerHTML:{__html:t(title)}}),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{className:"button-actions"},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components__["b" /* Button */],{type:"primary",hoverStyle:{backgroundColor:"white",color:"#04a8a6"},defaultStyle:{marginRight:"8px"},onClick:this.handleClickImages},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("img",{src:Object(__WEBPACK_IMPORTED_MODULE_16__utils__["a" /* assetsPath */])("phuket-laguna-village-residences")+"/images/icon/icon-image.png",alt:""})," ",t("Images")),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components__["b" /* Button */],{type:"primary",hoverStyle:{backgroundColor:"white",color:"#04a8a6"},defaultStyle:{marginRight:"8px",minWidth:"120px"},onClick:this.handleClickVideo},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("img",{src:Object(__WEBPACK_IMPORTED_MODULE_16__utils__["a" /* assetsPath */])("phuket-laguna-village-residences")+"/images/icon/icon-vdo.png",alt:""})," ",t("Video"),hasMultipleVideo&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("div",{className:"button-submenu "+(showSubMenuVideo?"show":"hide")},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("ul",{className:"list"},videos.map(function(_video){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("li",{onClick:function onClick(){return _this2.handleClickViewVideo(_video.titleKey);}},__WEBPACK_IMPORTED_MODULE_4_lodash_map___default()(t(__WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(_video,"text",{})),function(text){return __WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("p",null,text);}));})))),__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components__["b" /* Button */],{type:"primary",hoverStyle:{backgroundColor:"white",color:"#04a8a6"},defaultStyle:{marginRight:"8px"},onClick:this.handleClickTour},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement("img",{src:Object(__WEBPACK_IMPORTED_MODULE_16__utils__["a" /* assetsPath */])("phuket-laguna-village-residences")+"/images/icon/icon-360.png",alt:""})," ",t("Tour"))))),showImagesModal&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components__["k" /* Modal */],{name:"gallery-modal",onCancel:this.handleCloseImagesModal},__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__containers__["d" /* GalleryImages */],this.props)),showVideoModal&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components__["k" /* Modal */],{name:"video-modal",onCancel:this.handleCloseVideoModal},type==="mp4"?__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17_video_react__["Player"],{playsInline:true,autoPlay:true,mute:true,src:t(videoSource)}):__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__containers__["a" /* ComingSoon */],{fontColor:page==="laguna-beachside"?"#fff":"#000",src:t(videoSource)})),showTourModal&&__WEBPACK_IMPORTED_MODULE_8_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__components__["k" /* Modal */],{name:"tour-modal",onCancel:this.handleCloseTourModal},this.renderVirtualTour()));}}],[{key:"getDerivedStateFromProps",value:function getDerivedStateFromProps(props){var hash=__WEBPACK_IMPORTED_MODULE_7_lodash_get___default()(props,"location.hash");var hashContainVideo=hash.indexOf("#video")!==-1;var _hash$split=hash.split("-"),_hash$split2=_slicedToArray(_hash$split,2),videoTitleKey=_hash$split2[1];var targetVideoSource=props.video;if(videoTitleKey&&props.videos&&props.videos.length>0){var targetVideo=props.videos.find(function(video){return video.titleKey===videoTitleKey;});if(targetVideo)targetVideoSource=props.t(targetVideo.source);}// console.log("getDerivedStateFromProps", {
//   showVideoModal: hashContainVideo && !_.isEmpty(targetVideoSource),
//   hashContainVideo,
//   targetVideoSource: !_.isEmpty(targetVideoSource),
// });
return{videoSource:targetVideoSource,showImagesModal:hash==="#images",// showVideoModal: hashContainVideo && targetVideoSource,
showVideoModal:hashContainVideo,showTourModal:hash==="#tour"};}}]);return Gallery;}(__WEBPACK_IMPORTED_MODULE_8_react__["Component"]),_class2.propTypes={t:__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.func.isRequired,isRenderTitle:__WEBPACK_IMPORTED_MODULE_10_prop_types___default.a.bool},_class2.defaultProps={isRenderTitle:false},_temp2))||_class)));

/***/ }),
/* 825 */
/***/ (function(module, exports) {

/**
 * Gets the first element of `array`.
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @alias first
 * @category Array
 * @param {Array} array The array to query.
 * @returns {*} Returns the first element of `array`.
 * @example
 *
 * _.head([1, 2, 3]);
 * // => 1
 *
 * _.head([]);
 * // => undefined
 */
function head(array) {
  return (array && array.length) ? array[0] : undefined;
}

module.exports = head;


/***/ }),
/* 826 */
/***/ (function(module, exports, __webpack_require__) {

var lodash = __webpack_require__(827);

/**
 * Creates a `lodash` wrapper instance that wraps `value` with explicit method
 * chain sequences enabled. The result of such sequences must be unwrapped
 * with `_#value`.
 *
 * @static
 * @memberOf _
 * @since 1.3.0
 * @category Seq
 * @param {*} value The value to wrap.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * var users = [
 *   { 'user': 'barney',  'age': 36 },
 *   { 'user': 'fred',    'age': 40 },
 *   { 'user': 'pebbles', 'age': 1 }
 * ];
 *
 * var youngest = _
 *   .chain(users)
 *   .sortBy('age')
 *   .map(function(o) {
 *     return o.user + ' is ' + o.age;
 *   })
 *   .head()
 *   .value();
 * // => 'pebbles is 1'
 */
function chain(value) {
  var result = lodash(value);
  result.__chain__ = true;
  return result;
}

module.exports = chain;


/***/ }),
/* 827 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(334),
    LodashWrapper = __webpack_require__(335),
    baseLodash = __webpack_require__(204),
    isArray = __webpack_require__(13),
    isObjectLike = __webpack_require__(26),
    wrapperClone = __webpack_require__(828);

/** Used for built-in method references. */
var objectProto = Object.prototype;

/** Used to check objects for own properties. */
var hasOwnProperty = objectProto.hasOwnProperty;

/**
 * Creates a `lodash` object which wraps `value` to enable implicit method
 * chain sequences. Methods that operate on and return arrays, collections,
 * and functions can be chained together. Methods that retrieve a single value
 * or may return a primitive value will automatically end the chain sequence
 * and return the unwrapped value. Otherwise, the value must be unwrapped
 * with `_#value`.
 *
 * Explicit chain sequences, which must be unwrapped with `_#value`, may be
 * enabled using `_.chain`.
 *
 * The execution of chained methods is lazy, that is, it's deferred until
 * `_#value` is implicitly or explicitly called.
 *
 * Lazy evaluation allows several methods to support shortcut fusion.
 * Shortcut fusion is an optimization to merge iteratee calls; this avoids
 * the creation of intermediate arrays and can greatly reduce the number of
 * iteratee executions. Sections of a chain sequence qualify for shortcut
 * fusion if the section is applied to an array and iteratees accept only
 * one argument. The heuristic for whether a section qualifies for shortcut
 * fusion is subject to change.
 *
 * Chaining is supported in custom builds as long as the `_#value` method is
 * directly or indirectly included in the build.
 *
 * In addition to lodash methods, wrappers have `Array` and `String` methods.
 *
 * The wrapper `Array` methods are:
 * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
 *
 * The wrapper `String` methods are:
 * `replace` and `split`
 *
 * The wrapper methods that support shortcut fusion are:
 * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
 * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
 * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
 *
 * The chainable wrapper methods are:
 * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
 * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
 * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
 * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
 * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
 * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
 * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
 * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
 * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
 * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
 * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
 * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
 * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
 * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
 * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
 * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
 * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
 * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
 * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
 * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
 * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
 * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
 * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
 * `zipObject`, `zipObjectDeep`, and `zipWith`
 *
 * The wrapper methods that are **not** chainable by default are:
 * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
 * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
 * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
 * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
 * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
 * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
 * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
 * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
 * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
 * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
 * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
 * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
 * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
 * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
 * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
 * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
 * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
 * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
 * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
 * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
 * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
 * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
 * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
 * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
 * `upperFirst`, `value`, and `words`
 *
 * @name _
 * @constructor
 * @category Seq
 * @param {*} value The value to wrap in a `lodash` instance.
 * @returns {Object} Returns the new `lodash` wrapper instance.
 * @example
 *
 * function square(n) {
 *   return n * n;
 * }
 *
 * var wrapped = _([1, 2, 3]);
 *
 * // Returns an unwrapped value.
 * wrapped.reduce(_.add);
 * // => 6
 *
 * // Returns a wrapped value.
 * var squares = wrapped.map(square);
 *
 * _.isArray(squares);
 * // => false
 *
 * _.isArray(squares.value());
 * // => true
 */
function lodash(value) {
  if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
    if (value instanceof LodashWrapper) {
      return value;
    }
    if (hasOwnProperty.call(value, '__wrapped__')) {
      return wrapperClone(value);
    }
  }
  return new LodashWrapper(value);
}

// Ensure wrappers are instances of `baseLodash`.
lodash.prototype = baseLodash.prototype;
lodash.prototype.constructor = lodash;

module.exports = lodash;


/***/ }),
/* 828 */
/***/ (function(module, exports, __webpack_require__) {

var LazyWrapper = __webpack_require__(334),
    LodashWrapper = __webpack_require__(335),
    copyArray = __webpack_require__(201);

/**
 * Creates a clone of `wrapper`.
 *
 * @private
 * @param {Object} wrapper The wrapper to clone.
 * @returns {Object} Returns the cloned wrapper.
 */
function wrapperClone(wrapper) {
  if (wrapper instanceof LazyWrapper) {
    return wrapper.clone();
  }
  var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
  result.__actions__ = copyArray(wrapper.__actions__);
  result.__index__  = wrapper.__index__;
  result.__values__ = wrapper.__values__;
  return result;
}

module.exports = wrapperClone;


/***/ }),
/* 829 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(12);

var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "Player", {
  enumerable: true,
  get: function get() {
    return _Player["default"];
  }
});
Object.defineProperty(exports, "Video", {
  enumerable: true,
  get: function get() {
    return _Video["default"];
  }
});
Object.defineProperty(exports, "BigPlayButton", {
  enumerable: true,
  get: function get() {
    return _BigPlayButton["default"];
  }
});
Object.defineProperty(exports, "LoadingSpinner", {
  enumerable: true,
  get: function get() {
    return _LoadingSpinner["default"];
  }
});
Object.defineProperty(exports, "PosterImage", {
  enumerable: true,
  get: function get() {
    return _PosterImage["default"];
  }
});
Object.defineProperty(exports, "Slider", {
  enumerable: true,
  get: function get() {
    return _Slider["default"];
  }
});
Object.defineProperty(exports, "Bezel", {
  enumerable: true,
  get: function get() {
    return _Bezel["default"];
  }
});
Object.defineProperty(exports, "Shortcut", {
  enumerable: true,
  get: function get() {
    return _Shortcut["default"];
  }
});
Object.defineProperty(exports, "ControlBar", {
  enumerable: true,
  get: function get() {
    return _ControlBar["default"];
  }
});
Object.defineProperty(exports, "PlayToggle", {
  enumerable: true,
  get: function get() {
    return _PlayToggle["default"];
  }
});
Object.defineProperty(exports, "ForwardControl", {
  enumerable: true,
  get: function get() {
    return _ForwardControl["default"];
  }
});
Object.defineProperty(exports, "ReplayControl", {
  enumerable: true,
  get: function get() {
    return _ReplayControl["default"];
  }
});
Object.defineProperty(exports, "FullscreenToggle", {
  enumerable: true,
  get: function get() {
    return _FullscreenToggle["default"];
  }
});
Object.defineProperty(exports, "ProgressControl", {
  enumerable: true,
  get: function get() {
    return _ProgressControl["default"];
  }
});
Object.defineProperty(exports, "SeekBar", {
  enumerable: true,
  get: function get() {
    return _SeekBar["default"];
  }
});
Object.defineProperty(exports, "PlayProgressBar", {
  enumerable: true,
  get: function get() {
    return _PlayProgressBar["default"];
  }
});
Object.defineProperty(exports, "LoadProgressBar", {
  enumerable: true,
  get: function get() {
    return _LoadProgressBar["default"];
  }
});
Object.defineProperty(exports, "MouseTimeDisplay", {
  enumerable: true,
  get: function get() {
    return _MouseTimeDisplay["default"];
  }
});
Object.defineProperty(exports, "VolumeMenuButton", {
  enumerable: true,
  get: function get() {
    return _VolumeMenuButton["default"];
  }
});
Object.defineProperty(exports, "PlaybackRateMenuButton", {
  enumerable: true,
  get: function get() {
    return _PlaybackRateMenuButton["default"];
  }
});
Object.defineProperty(exports, "PlaybackRate", {
  enumerable: true,
  get: function get() {
    return _PlaybackRate["default"];
  }
});
Object.defineProperty(exports, "ClosedCaptionButton", {
  enumerable: true,
  get: function get() {
    return _ClosedCaptionButton["default"];
  }
});
Object.defineProperty(exports, "RemainingTimeDisplay", {
  enumerable: true,
  get: function get() {
    return _RemainingTimeDisplay["default"];
  }
});
Object.defineProperty(exports, "CurrentTimeDisplay", {
  enumerable: true,
  get: function get() {
    return _CurrentTimeDisplay["default"];
  }
});
Object.defineProperty(exports, "DurationDisplay", {
  enumerable: true,
  get: function get() {
    return _DurationDisplay["default"];
  }
});
Object.defineProperty(exports, "TimeDivider", {
  enumerable: true,
  get: function get() {
    return _TimeDivider["default"];
  }
});
Object.defineProperty(exports, "MenuButton", {
  enumerable: true,
  get: function get() {
    return _MenuButton["default"];
  }
});
Object.defineProperty(exports, "playerReducer", {
  enumerable: true,
  get: function get() {
    return _reducers.playerReducer;
  }
});
Object.defineProperty(exports, "operationReducer", {
  enumerable: true,
  get: function get() {
    return _reducers.operationReducer;
  }
});
exports.videoActions = exports.playerActions = void 0;

var _Player = _interopRequireDefault(__webpack_require__(830));

var _Video = _interopRequireDefault(__webpack_require__(342));

var _BigPlayButton = _interopRequireDefault(__webpack_require__(339));

var _LoadingSpinner = _interopRequireDefault(__webpack_require__(340));

var _PosterImage = _interopRequireDefault(__webpack_require__(341));

var _Slider = _interopRequireDefault(__webpack_require__(208));

var _Bezel = _interopRequireDefault(__webpack_require__(345));

var _Shortcut = _interopRequireDefault(__webpack_require__(346));

var _ControlBar = _interopRequireDefault(__webpack_require__(347));

var _PlayToggle = _interopRequireDefault(__webpack_require__(353));

var _ForwardControl = _interopRequireDefault(__webpack_require__(354));

var _ReplayControl = _interopRequireDefault(__webpack_require__(356));

var _FullscreenToggle = _interopRequireDefault(__webpack_require__(357));

var _ProgressControl = _interopRequireDefault(__webpack_require__(348));

var _SeekBar = _interopRequireDefault(__webpack_require__(349));

var _PlayProgressBar = _interopRequireDefault(__webpack_require__(350));

var _LoadProgressBar = _interopRequireDefault(__webpack_require__(351));

var _MouseTimeDisplay = _interopRequireDefault(__webpack_require__(352));

var _VolumeMenuButton = _interopRequireDefault(__webpack_require__(362));

var _PlaybackRateMenuButton = _interopRequireDefault(__webpack_require__(209));

var _PlaybackRate = _interopRequireDefault(__webpack_require__(848));

var _ClosedCaptionButton = _interopRequireDefault(__webpack_require__(849));

var _RemainingTimeDisplay = _interopRequireDefault(__webpack_require__(358));

var _CurrentTimeDisplay = _interopRequireDefault(__webpack_require__(359));

var _DurationDisplay = _interopRequireDefault(__webpack_require__(360));

var _TimeDivider = _interopRequireDefault(__webpack_require__(361));

var _MenuButton = _interopRequireDefault(__webpack_require__(210));

var playerActions = _interopRequireWildcard(__webpack_require__(137));

exports.playerActions = playerActions;

var videoActions = _interopRequireWildcard(__webpack_require__(207));

exports.videoActions = videoActions;

var _reducers = __webpack_require__(337);

/***/ }),
/* 830 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(12);

var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(57));

var _defineProperty2 = _interopRequireDefault(__webpack_require__(205));

var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(206));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(10));

var _createClass2 = _interopRequireDefault(__webpack_require__(11));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(16));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(15));

var _inherits2 = _interopRequireDefault(__webpack_require__(17));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(9));

var _Manager = _interopRequireDefault(__webpack_require__(834));

var _BigPlayButton = _interopRequireDefault(__webpack_require__(339));

var _LoadingSpinner = _interopRequireDefault(__webpack_require__(340));

var _PosterImage = _interopRequireDefault(__webpack_require__(341));

var _Video = _interopRequireDefault(__webpack_require__(342));

var _Bezel = _interopRequireDefault(__webpack_require__(345));

var _Shortcut = _interopRequireDefault(__webpack_require__(346));

var _ControlBar = _interopRequireDefault(__webpack_require__(347));

var browser = _interopRequireWildcard(__webpack_require__(847));

var _dom = __webpack_require__(138);

var _utils = __webpack_require__(46);

var _fullscreen = _interopRequireDefault(__webpack_require__(338));

var propTypes = {
  children: _propTypes["default"].any,
  width: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  height: _propTypes["default"].oneOfType([_propTypes["default"].string, _propTypes["default"].number]),
  fluid: _propTypes["default"].bool,
  muted: _propTypes["default"].bool,
  playsInline: _propTypes["default"].bool,
  aspectRatio: _propTypes["default"].string,
  className: _propTypes["default"].string,
  videoId: _propTypes["default"].string,
  startTime: _propTypes["default"].number,
  loop: _propTypes["default"].bool,
  autoPlay: _propTypes["default"].bool,
  src: _propTypes["default"].string,
  poster: _propTypes["default"].string,
  preload: _propTypes["default"].oneOf(['auto', 'metadata', 'none']),
  onLoadStart: _propTypes["default"].func,
  onWaiting: _propTypes["default"].func,
  onCanPlay: _propTypes["default"].func,
  onCanPlayThrough: _propTypes["default"].func,
  onPlaying: _propTypes["default"].func,
  onEnded: _propTypes["default"].func,
  onSeeking: _propTypes["default"].func,
  onSeeked: _propTypes["default"].func,
  onPlay: _propTypes["default"].func,
  onPause: _propTypes["default"].func,
  onProgress: _propTypes["default"].func,
  onDurationChange: _propTypes["default"].func,
  onError: _propTypes["default"].func,
  onSuspend: _propTypes["default"].func,
  onAbort: _propTypes["default"].func,
  onEmptied: _propTypes["default"].func,
  onStalled: _propTypes["default"].func,
  onLoadedMetadata: _propTypes["default"].func,
  onLoadedData: _propTypes["default"].func,
  onTimeUpdate: _propTypes["default"].func,
  onRateChange: _propTypes["default"].func,
  onVolumeChange: _propTypes["default"].func,
  store: _propTypes["default"].object
};
var defaultProps = {
  fluid: true,
  muted: false,
  playsInline: false,
  preload: 'auto',
  aspectRatio: 'auto'
};

var Player =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Player, _Component);

  function Player(props) {
    var _this;

    (0, _classCallCheck2["default"])(this, Player);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Player).call(this, props));
    _this.controlsHideTimer = null;
    _this.video = null; // the Video component

    _this.manager = new _Manager["default"](props.store);
    _this.actions = _this.manager.getActions();

    _this.manager.subscribeToPlayerStateChange(_this.handleStateChange.bind((0, _assertThisInitialized2["default"])(_this)));

    _this.getStyle = _this.getStyle.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleResize = _this.handleResize.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getChildren = _this.getChildren.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleMouseMove = (0, _utils.throttle)(_this.handleMouseMove.bind((0, _assertThisInitialized2["default"])(_this)), 250);
    _this.handleMouseDown = _this.handleMouseDown.bind((0, _assertThisInitialized2["default"])(_this));
    _this.startControlsTimer = _this.startControlsTimer.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleFullScreenChange = _this.handleFullScreenChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleKeyDown = _this.handleKeyDown.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(Player, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      this.handleResize();
      window.addEventListener('resize', this.handleResize);

      _fullscreen["default"].addEventListener(this.handleFullScreenChange);
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      // Remove event listener
      window.removeEventListener('resize', this.handleResize);

      _fullscreen["default"].removeEventListener(this.handleFullScreenChange);

      if (this.controlsHideTimer) {
        window.clearTimeout(this.controlsHideTimer);
      }
    }
  }, {
    key: "getDefaultChildren",
    value: function getDefaultChildren(originalChildren) {
      var _this2 = this;

      return [_react["default"].createElement(_Video["default"], {
        ref: function ref(c) {
          _this2.video = c;
          _this2.manager.video = _this2.video;
        },
        key: "video",
        order: 0.0
      }, originalChildren), _react["default"].createElement(_PosterImage["default"], {
        key: "poster-image",
        order: 1.0
      }), _react["default"].createElement(_LoadingSpinner["default"], {
        key: "loading-spinner",
        order: 2.0
      }), _react["default"].createElement(_Bezel["default"], {
        key: "bezel",
        order: 3.0
      }), _react["default"].createElement(_BigPlayButton["default"], {
        key: "big-play-button",
        order: 4.0
      }), _react["default"].createElement(_ControlBar["default"], {
        key: "control-bar",
        order: 5.0
      }), _react["default"].createElement(_Shortcut["default"], {
        key: "shortcut",
        order: 99.0
      })];
    }
  }, {
    key: "getChildren",
    value: function getChildren(props) {
      var _ = props.className,
          originalChildren = props.children,
          propsWithoutChildren = (0, _objectWithoutProperties2["default"])(props, ["className", "children"]);

      var children = _react["default"].Children.toArray(this.props.children).filter(function (e) {
        return !(0, _utils.isVideoChild)(e);
      });

      var defaultChildren = this.getDefaultChildren(originalChildren);
      return (0, _utils.mergeAndSortChildren)(defaultChildren, children, propsWithoutChildren);
    }
  }, {
    key: "setWidthOrHeight",
    value: function setWidthOrHeight(style, name, value) {
      var styleVal;

      if (typeof value === 'string') {
        if (value === 'auto') {
          styleVal = 'auto';
        } else if (value.match(/\d+%/)) {
          styleVal = value;
        }
      } else if (typeof value === 'number') {
        styleVal = "".concat(value, "px");
      }

      Object.assign(style, (0, _defineProperty2["default"])({}, name, styleVal));
    }
  }, {
    key: "getStyle",
    value: function getStyle() {
      var _this$props = this.props,
          fluid = _this$props.fluid,
          propsAspectRatio = _this$props.aspectRatio,
          propsHeight = _this$props.height,
          propsWidth = _this$props.width;

      var _this$manager$getStat = this.manager.getState(),
          player = _this$manager$getStat.player;

      var style = {};
      var width;
      var height;
      var aspectRatio; // The aspect ratio is either used directly or to calculate width and height.

      if (propsAspectRatio !== undefined && propsAspectRatio !== 'auto') {
        // Use any aspectRatio that's been specifically set
        aspectRatio = propsAspectRatio;
      } else if (player.videoWidth) {
        // Otherwise try to get the aspect ratio from the video metadata
        aspectRatio = "".concat(player.videoWidth, ":").concat(player.videoHeight);
      } else {
        // Or use a default. The video element's is 2:1, but 16:9 is more common.
        aspectRatio = '16:9';
      } // Get the ratio as a decimal we can use to calculate dimensions


      var ratioParts = aspectRatio.split(':');
      var ratioMultiplier = ratioParts[1] / ratioParts[0];

      if (propsWidth !== undefined) {
        // Use any width that's been specifically set
        width = propsWidth;
      } else if (propsHeight !== undefined) {
        // Or calulate the width from the aspect ratio if a height has been set
        width = propsHeight / ratioMultiplier;
      } else {
        // Or use the video's metadata, or use the video el's default of 300
        width = player.videoWidth || 400;
      }

      if (propsHeight !== undefined) {
        // Use any height that's been specifically set
        height = propsHeight;
      } else {
        // Otherwise calculate the height from the ratio and the width
        height = width * ratioMultiplier;
      }

      if (fluid) {
        style.paddingTop = "".concat(ratioMultiplier * 100, "%");
      } else {
        // If Width contains "auto", set "auto" in style
        this.setWidthOrHeight(style, 'width', width);
        this.setWidthOrHeight(style, 'height', height);
      }

      return style;
    } // get redux state
    // { player, operation }

  }, {
    key: "getState",
    value: function getState() {
      return this.manager.getState();
    } // get playback rate

  }, {
    key: "play",
    // play the video
    value: function play() {
      this.video.play();
    } // pause the video

  }, {
    key: "pause",
    value: function pause() {
      this.video.pause();
    } // Change the video source and re-load the video:

  }, {
    key: "load",
    value: function load() {
      this.video.load();
    } // Add a new text track to the video

  }, {
    key: "addTextTrack",
    value: function addTextTrack() {
      var _this$video;

      (_this$video = this.video).addTextTrack.apply(_this$video, arguments);
    } // Check if your browser can play different types of video:

  }, {
    key: "canPlayType",
    value: function canPlayType() {
      var _this$video2;

      (_this$video2 = this.video).canPlayType.apply(_this$video2, arguments);
    } // seek video by time

  }, {
    key: "seek",
    value: function seek(time) {
      this.video.seek(time);
    } // jump forward x seconds

  }, {
    key: "forward",
    value: function forward(seconds) {
      this.video.forward(seconds);
    } // jump back x seconds

  }, {
    key: "replay",
    value: function replay(seconds) {
      this.video.replay(seconds);
    } // enter or exist full screen

  }, {
    key: "toggleFullscreen",
    value: function toggleFullscreen() {
      this.video.toggleFullscreen();
    } // subscribe to player state change

  }, {
    key: "subscribeToStateChange",
    value: function subscribeToStateChange(listener) {
      return this.manager.subscribeToPlayerStateChange(listener);
    } // player resize

  }, {
    key: "handleResize",
    value: function handleResize() {}
  }, {
    key: "handleFullScreenChange",
    value: function handleFullScreenChange(event) {
      if (event.target === this.manager.rootElement) {
        this.actions.handleFullscreenChange(_fullscreen["default"].isFullscreen);
      }
    }
  }, {
    key: "handleMouseDown",
    value: function handleMouseDown() {
      this.startControlsTimer();
    }
  }, {
    key: "handleMouseMove",
    value: function handleMouseMove() {
      this.startControlsTimer();
    }
  }, {
    key: "handleKeyDown",
    value: function handleKeyDown() {
      this.startControlsTimer();
    }
  }, {
    key: "startControlsTimer",
    value: function startControlsTimer() {
      var _this3 = this;

      var controlBarActiveTime = 3000;

      _react["default"].Children.forEach(this.props.children, function (element) {
        if (!_react["default"].isValidElement(element) || element.type !== _ControlBar["default"]) {
          return;
        }

        var autoHideTime = element.props.autoHideTime;

        if (typeof autoHideTime === 'number') {
          controlBarActiveTime = autoHideTime;
        }
      });

      this.actions.userActivate(true);
      clearTimeout(this.controlsHideTimer);
      this.controlsHideTimer = setTimeout(function () {
        _this3.actions.userActivate(false);
      }, controlBarActiveTime);
    }
  }, {
    key: "handleStateChange",
    value: function handleStateChange(state, prevState) {
      if (state.isFullscreen !== prevState.isFullscreen) {
        this.handleResize(); // focus root when switching fullscreen mode to avoid confusion #276

        (0, _dom.focusNode)(this.manager.rootElement);
      }

      this.forceUpdate(); // re-render
    }
  }, {
    key: "handleFocus",
    value: function handleFocus() {
      this.actions.activate(true);
    }
  }, {
    key: "handleBlur",
    value: function handleBlur() {
      this.actions.activate(false);
    }
  }, {
    key: "render",
    value: function render() {
      var _this4 = this;

      var fluid = this.props.fluid;

      var _this$manager$getStat2 = this.manager.getState(),
          player = _this$manager$getStat2.player;

      var paused = player.paused,
          hasStarted = player.hasStarted,
          waiting = player.waiting,
          seeking = player.seeking,
          isFullscreen = player.isFullscreen,
          userActivity = player.userActivity;
      var props = (0, _objectSpread2["default"])({}, this.props, {
        player: player,
        actions: this.actions,
        manager: this.manager,
        store: this.manager.store,
        video: this.video ? this.video.video : null
      });
      var children = this.getChildren(props);
      return _react["default"].createElement("div", {
        className: (0, _classnames["default"])({
          'video-react-controls-enabled': true,
          'video-react-has-started': hasStarted,
          'video-react-paused': paused,
          'video-react-playing': !paused,
          'video-react-waiting': waiting,
          'video-react-seeking': seeking,
          'video-react-fluid': fluid,
          'video-react-fullscreen': isFullscreen,
          'video-react-user-inactive': !userActivity,
          'video-react-user-active': userActivity,
          'video-react-workinghover': !browser.IS_IOS
        }, 'video-react', this.props.className),
        style: this.getStyle(),
        ref: function ref(c) {
          _this4.manager.rootElement = c;
        },
        role: "region",
        onTouchStart: this.handleMouseDown,
        onMouseDown: this.handleMouseDown,
        onTouchMove: this.handleMouseMove,
        onMouseMove: this.handleMouseMove,
        onKeyDown: this.handleKeyDown,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        tabIndex: "-1"
      }, children);
    }
  }, {
    key: "playbackRate",
    get: function get() {
      return this.video.playbackRate;
    } // set playback rate
    // speed of video
    ,
    set: function set(rate) {
      this.video.playbackRate = rate;
    }
  }, {
    key: "muted",
    get: function get() {
      return this.video.muted;
    },
    set: function set(val) {
      this.video.muted = val;
    }
  }, {
    key: "volume",
    get: function get() {
      return this.video.volume;
    },
    set: function set(val) {
      this.video.volume = val;
    } // video width

  }, {
    key: "videoWidth",
    get: function get() {
      return this.video.videoWidth;
    } // video height

  }, {
    key: "videoHeight",
    get: function get() {
      return this.video.videoHeight;
    }
  }]);
  return Player;
}(_react.Component);

exports["default"] = Player;
Player.contextTypes = {
  store: _propTypes["default"].object
};
Player.propTypes = propTypes;
Player.defaultProps = defaultProps;
Player.displayName = 'Player';

/***/ }),
/* 831 */
/***/ (function(module, exports, __webpack_require__) {

var _typeof = __webpack_require__(136)["default"];
function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
module.exports = toPrimitive, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 832 */
/***/ (function(module, exports) {

function _objectWithoutPropertiesLoose(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}
module.exports = _objectWithoutPropertiesLoose, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 833 */
/***/ (function(module, exports) {

function _setPrototypeOf(o, p) {
  module.exports = _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  }, module.exports.__esModule = true, module.exports["default"] = module.exports;
  return _setPrototypeOf(o, p);
}
module.exports = _setPrototypeOf, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 834 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(12);

var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(57));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(10));

var _createClass2 = _interopRequireDefault(__webpack_require__(11));

var _redux = __webpack_require__(91);

var _reducers = _interopRequireDefault(__webpack_require__(337));

var playerActions = _interopRequireWildcard(__webpack_require__(137));

var videoActions = _interopRequireWildcard(__webpack_require__(207));

var Manager =
/*#__PURE__*/
function () {
  function Manager(store) {
    (0, _classCallCheck2["default"])(this, Manager);
    this.store = store || (0, _redux.createStore)(_reducers["default"]);
    this.video = null;
    this.rootElement = null;
  }

  (0, _createClass2["default"])(Manager, [{
    key: "getActions",
    value: function getActions() {
      var manager = this;
      var dispatch = this.store.dispatch;
      var actions = (0, _objectSpread2["default"])({}, playerActions, videoActions);

      function bindActionCreator(actionCreator) {
        return function bindAction() {
          // eslint-disable-next-line prefer-rest-params
          var action = actionCreator.apply(manager, arguments);

          if (typeof action !== 'undefined') {
            dispatch(action);
          }
        };
      }

      return Object.keys(actions).filter(function (key) {
        return typeof actions[key] === 'function';
      }).reduce(function (boundActions, key) {
        boundActions[key] = bindActionCreator(actions[key]);
        return boundActions;
      }, {});
    }
  }, {
    key: "getState",
    value: function getState() {
      return this.store.getState();
    } // subscribe state change

  }, {
    key: "subscribeToStateChange",
    value: function subscribeToStateChange(listener, getState) {
      if (!getState) {
        getState = this.getState.bind(this);
      }

      var prevState = getState();

      var handleChange = function handleChange() {
        var state = getState();

        if (state === prevState) {
          return;
        }

        var prevStateCopy = prevState;
        prevState = state;
        listener(state, prevStateCopy);
      };

      return this.store.subscribe(handleChange);
    } // subscribe to operation state change

  }, {
    key: "subscribeToOperationStateChange",
    value: function subscribeToOperationStateChange(listener) {
      var _this = this;

      return this.subscribeToStateChange(listener, function () {
        return _this.getState().operation;
      });
    } // subscribe to player state change

  }, {
    key: "subscribeToPlayerStateChange",
    value: function subscribeToPlayerStateChange(listener) {
      var _this2 = this;

      return this.subscribeToStateChange(listener, function () {
        return _this2.getState().player;
      });
    }
  }]);
  return Manager;
}();

exports["default"] = Manager;

/***/ }),
/* 835 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = player;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(57));

var _video = __webpack_require__(207);

var _player = __webpack_require__(137);

var initialState = {
  currentSrc: null,
  duration: 0,
  currentTime: 0,
  seekingTime: 0,
  buffered: null,
  waiting: false,
  seeking: false,
  paused: true,
  autoPaused: false,
  ended: false,
  playbackRate: 1,
  muted: false,
  volume: 1,
  readyState: 0,
  networkState: 0,
  videoWidth: 0,
  videoHeight: 0,
  hasStarted: false,
  userActivity: true,
  isActive: false,
  isFullscreen: false,
  activeTextTrack: null
};

function player() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _player.USER_ACTIVATE:
      return (0, _objectSpread2["default"])({}, state, {
        userActivity: action.activity
      });

    case _player.PLAYER_ACTIVATE:
      return (0, _objectSpread2["default"])({}, state, {
        isActive: action.activity
      });

    case _player.FULLSCREEN_CHANGE:
      return (0, _objectSpread2["default"])({}, state, {
        isFullscreen: !!action.isFullscreen
      });

    case _video.SEEKING_TIME:
      return (0, _objectSpread2["default"])({}, state, {
        seekingTime: action.time
      });

    case _video.END_SEEKING:
      return (0, _objectSpread2["default"])({}, state, {
        seekingTime: 0
      });

    case _video.LOAD_START:
      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
        hasStarted: false,
        ended: false
      });

    case _video.CAN_PLAY:
      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
        waiting: false
      });

    case _video.WAITING:
      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
        waiting: true
      });

    case _video.CAN_PLAY_THROUGH:
    case _video.PLAYING:
      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
        waiting: false
      });

    case _video.PLAY:
      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
        ended: false,
        paused: false,
        autoPaused: false,
        waiting: false,
        hasStarted: true
      });

    case _video.PAUSE:
      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
        paused: true
      });

    case _video.END:
      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
        ended: true
      });

    case _video.SEEKING:
      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
        seeking: true
      });

    case _video.SEEKED:
      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
        seeking: false
      });

    case _video.ERROR:
      return (0, _objectSpread2["default"])({}, state, action.videoProps, {
        error: 'UNKNOWN ERROR',
        ended: true
      });

    case _video.DURATION_CHANGE:
    case _video.TIME_UPDATE:
    case _video.VOLUME_CHANGE:
    case _video.PROGRESS_CHANGE:
    case _video.RATE_CHANGE:
    case _video.SUSPEND:
    case _video.ABORT:
    case _video.EMPTIED:
    case _video.STALLED:
    case _video.LOADED_META_DATA:
    case _video.LOADED_DATA:
    case _video.RESIZE:
      return (0, _objectSpread2["default"])({}, state, action.videoProps);

    case _video.ACTIVATE_TEXT_TRACK:
      return (0, _objectSpread2["default"])({}, state, {
        activeTextTrack: action.textTrack
      });

    default:
      return state;
  }
}

/***/ }),
/* 836 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = operation;

var _objectSpread2 = _interopRequireDefault(__webpack_require__(57));

var _player = __webpack_require__(137);

var initialState = {
  count: 0,
  operation: {
    action: '',
    source: ''
  }
};

function operation() {
  var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
  var action = arguments.length > 1 ? arguments[1] : undefined;

  switch (action.type) {
    case _player.OPERATE:
      return (0, _objectSpread2["default"])({}, state, {
        count: state.count + 1,
        operation: (0, _objectSpread2["default"])({}, state.operation, action.operation)
      });

    default:
      return state;
  }
}

/***/ }),
/* 837 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(344);
function _arrayWithoutHoles(arr) {
  if (Array.isArray(arr)) return arrayLikeToArray(arr);
}
module.exports = _arrayWithoutHoles, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 838 */
/***/ (function(module, exports) {

function _iterableToArray(iter) {
  if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter);
}
module.exports = _iterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 839 */
/***/ (function(module, exports, __webpack_require__) {

var arrayLikeToArray = __webpack_require__(344);
function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return arrayLikeToArray(o, minLen);
}
module.exports = _unsupportedIterableToArray, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 840 */
/***/ (function(module, exports) {

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
module.exports = _nonIterableSpread, module.exports.__esModule = true, module.exports["default"] = module.exports;

/***/ }),
/* 841 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = PopupButton;

var _extends2 = _interopRequireDefault(__webpack_require__(111));

var _objectSpread2 = _interopRequireDefault(__webpack_require__(57));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(9));

var _ClickableComponent = _interopRequireDefault(__webpack_require__(363));

var _Popup = _interopRequireDefault(__webpack_require__(842));

var propTypes = {
  inline: _propTypes["default"].bool,
  onClick: _propTypes["default"].func.isRequired,
  onFocus: _propTypes["default"].func,
  onBlur: _propTypes["default"].func,
  className: _propTypes["default"].string
};
var defaultProps = {
  inline: true
};

function PopupButton(props) {
  var inline = props.inline,
      className = props.className;
  var ps = (0, _objectSpread2["default"])({}, props);
  delete ps.children;
  delete ps.inline;
  delete ps.className;
  return _react["default"].createElement(_ClickableComponent["default"], (0, _extends2["default"])({
    className: (0, _classnames["default"])(className, {
      'video-react-menu-button-inline': !!inline,
      'video-react-menu-button-popup': !inline
    }, 'video-react-control video-react-button video-react-menu-button')
  }, ps), _react["default"].createElement(_Popup["default"], props));
}

PopupButton.propTypes = propTypes;
PopupButton.defaultProps = defaultProps;
PopupButton.displayName = 'PopupButton';

/***/ }),
/* 842 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(12);

var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(10));

var _createClass2 = _interopRequireDefault(__webpack_require__(11));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(16));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(15));

var _inherits2 = _interopRequireDefault(__webpack_require__(17));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireWildcard(__webpack_require__(0));

var propTypes = {
  player: _propTypes["default"].object,
  children: _propTypes["default"].any
};

var Popup =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Popup, _Component);

  function Popup(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, Popup);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Popup).call(this, props, context));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(Popup, [{
    key: "handleClick",
    value: function handleClick(event) {
      event.preventDefault(); // event.stopPropagation();
    }
  }, {
    key: "render",
    value: function render() {
      var children = this.props.children;
      return _react["default"].createElement("div", {
        className: "video-react-menu",
        onClick: this.handleClick
      }, _react["default"].createElement("div", {
        className: "video-react-menu-content"
      }, children));
    }
  }]);
  return Popup;
}(_react.Component);

exports["default"] = Popup;
Popup.propTypes = propTypes;
Popup.displayName = 'Popup';

/***/ }),
/* 843 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(12);

var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(__webpack_require__(111));

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(10));

var _createClass2 = _interopRequireDefault(__webpack_require__(11));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(16));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(15));

var _inherits2 = _interopRequireDefault(__webpack_require__(17));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(9));

var _Slider = _interopRequireDefault(__webpack_require__(208));

var _VolumeLevel = _interopRequireDefault(__webpack_require__(844));

var propTypes = {
  actions: _propTypes["default"].object,
  player: _propTypes["default"].object,
  className: _propTypes["default"].string,
  onFocus: _propTypes["default"].func,
  onBlur: _propTypes["default"].func
};

var VolumeBar =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(VolumeBar, _Component);

  function VolumeBar(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, VolumeBar);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(VolumeBar).call(this, props, context));
    _this.state = {
      percentage: '0%'
    };
    _this.handleMouseMove = _this.handleMouseMove.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handlePercentageChange = _this.handlePercentageChange.bind((0, _assertThisInitialized2["default"])(_this));
    _this.checkMuted = _this.checkMuted.bind((0, _assertThisInitialized2["default"])(_this));
    _this.getPercent = _this.getPercent.bind((0, _assertThisInitialized2["default"])(_this));
    _this.stepForward = _this.stepForward.bind((0, _assertThisInitialized2["default"])(_this));
    _this.stepBack = _this.stepBack.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(VolumeBar, [{
    key: "componentDidMount",
    value: function componentDidMount() {}
  }, {
    key: "getPercent",
    value: function getPercent() {
      var player = this.props.player;

      if (player.muted) {
        return 0;
      }

      return player.volume;
    }
  }, {
    key: "checkMuted",
    value: function checkMuted() {
      var _this$props = this.props,
          player = _this$props.player,
          actions = _this$props.actions;

      if (player.muted) {
        actions.mute(false);
      }
    }
  }, {
    key: "handleMouseMove",
    value: function handleMouseMove(event) {
      var actions = this.props.actions;
      this.checkMuted();
      var distance = this.slider.calculateDistance(event);
      actions.changeVolume(distance);
    }
  }, {
    key: "stepForward",
    value: function stepForward() {
      var _this$props2 = this.props,
          player = _this$props2.player,
          actions = _this$props2.actions;
      this.checkMuted();
      actions.changeVolume(player.volume + 0.1);
    }
  }, {
    key: "stepBack",
    value: function stepBack() {
      var _this$props3 = this.props,
          player = _this$props3.player,
          actions = _this$props3.actions;
      this.checkMuted();
      actions.changeVolume(player.volume - 0.1);
    }
  }, {
    key: "handleFocus",
    value: function handleFocus(e) {
      if (this.props.onFocus) {
        this.props.onFocus(e);
      }
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(e) {
      if (this.props.onBlur) {
        this.props.onBlur(e);
      }
    }
  }, {
    key: "handlePercentageChange",
    value: function handlePercentageChange(percentage) {
      if (percentage !== this.state.percentage) {
        this.setState({
          percentage: percentage
        });
      }
    }
  }, {
    key: "handleClick",
    value: function handleClick(event) {
      event.stopPropagation();
    }
  }, {
    key: "render",
    value: function render() {
      var _this2 = this;

      var _this$props4 = this.props,
          player = _this$props4.player,
          className = _this$props4.className;
      var volume = (player.volume * 100).toFixed(2);
      return _react["default"].createElement(_Slider["default"], (0, _extends2["default"])({
        ref: function ref(c) {
          _this2.slider = c;
        },
        label: "volume level",
        valuenow: volume,
        valuetext: "".concat(volume, "%"),
        onMouseMove: this.handleMouseMove,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur,
        onClick: this.handleClick,
        sliderActive: this.handleFocus,
        sliderInactive: this.handleBlur,
        getPercent: this.getPercent,
        onPercentageChange: this.handlePercentageChange,
        stepForward: this.stepForward,
        stepBack: this.stepBack
      }, this.props, {
        className: (0, _classnames["default"])(className, 'video-react-volume-bar video-react-slider-bar')
      }), _react["default"].createElement(_VolumeLevel["default"], this.props));
    }
  }]);
  return VolumeBar;
}(_react.Component);

VolumeBar.propTypes = propTypes;
VolumeBar.displayName = 'VolumeBar';
var _default = VolumeBar;
exports["default"] = _default;

/***/ }),
/* 844 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireDefault(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(9));

var propTypes = {
  percentage: _propTypes["default"].string,
  vertical: _propTypes["default"].bool,
  className: _propTypes["default"].string
};
var defaultProps = {
  percentage: '100%',
  vertical: false
};

function VolumeLevel(_ref) {
  var percentage = _ref.percentage,
      vertical = _ref.vertical,
      className = _ref.className;
  var style = {};

  if (vertical) {
    style.height = percentage;
  } else {
    style.width = percentage;
  }

  return _react["default"].createElement("div", {
    className: (0, _classnames["default"])(className, 'video-react-volume-level'),
    style: style
  }, _react["default"].createElement("span", {
    className: "video-react-control-text"
  }));
}

VolumeLevel.propTypes = propTypes;
VolumeLevel.defaultProps = defaultProps;
VolumeLevel.displayName = 'VolumeLevel';
var _default = VolumeLevel;
exports["default"] = _default;

/***/ }),
/* 845 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(12);

var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(10));

var _createClass2 = _interopRequireDefault(__webpack_require__(11));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(16));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(15));

var _inherits2 = _interopRequireDefault(__webpack_require__(17));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireWildcard(__webpack_require__(0));

var propTypes = {
  children: _propTypes["default"].any
};

var Menu =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(Menu, _Component);

  function Menu(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, Menu);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(Menu).call(this, props, context));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(Menu, [{
    key: "handleClick",
    value: function handleClick(event) {
      event.preventDefault(); // event.stopPropagation();
    }
  }, {
    key: "render",
    value: function render() {
      return _react["default"].createElement("div", {
        className: "video-react-menu video-react-lock-showing",
        role: "presentation",
        onClick: this.handleClick
      }, _react["default"].createElement("ul", {
        className: "video-react-menu-content"
      }, this.props.children));
    }
  }]);
  return Menu;
}(_react.Component);

exports["default"] = Menu;
Menu.propTypes = propTypes;
Menu.displayName = 'Menu';

/***/ }),
/* 846 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(12);

var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(10));

var _createClass2 = _interopRequireDefault(__webpack_require__(11));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(16));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(15));

var _inherits2 = _interopRequireDefault(__webpack_require__(17));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(9));

var propTypes = {
  item: _propTypes["default"].object,
  index: _propTypes["default"].number,
  activateIndex: _propTypes["default"].number,
  onSelectItem: _propTypes["default"].func
};

var MenuItem =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(MenuItem, _Component);

  function MenuItem(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, MenuItem);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(MenuItem).call(this, props, context));
    _this.handleClick = _this.handleClick.bind((0, _assertThisInitialized2["default"])(_this));
    return _this;
  }

  (0, _createClass2["default"])(MenuItem, [{
    key: "handleClick",
    value: function handleClick() {
      var _this$props = this.props,
          index = _this$props.index,
          onSelectItem = _this$props.onSelectItem;
      onSelectItem(index);
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props2 = this.props,
          item = _this$props2.item,
          index = _this$props2.index,
          activateIndex = _this$props2.activateIndex;
      return _react["default"].createElement("li", {
        className: (0, _classnames["default"])({
          'video-react-menu-item': true,
          'video-react-selected': index === activateIndex
        }),
        role: "menuitem",
        onClick: this.handleClick
      }, item.label, _react["default"].createElement("span", {
        className: "video-react-control-text"
      }));
    }
  }]);
  return MenuItem;
}(_react.Component);

exports["default"] = MenuItem;
MenuItem.propTypes = propTypes;
MenuItem.displayName = 'MenuItem';

/***/ }),
/* 847 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.IS_IOS = exports.IS_IPOD = exports.IS_IPHONE = exports.IS_IPAD = void 0;
var USER_AGENT = typeof window !== 'undefined' && window.navigator ? window.navigator.userAgent : ''; // const webkitVersionMap = (/AppleWebKit\/([\d.]+)/i).exec(USER_AGENT);
// const appleWebkitVersion = webkitVersionMap ? parseFloat(webkitVersionMap.pop()) : null;

/*
 * Device is an iPhone
 *
 * @type {Boolean}
 * @constant
 * @private
 */

var IS_IPAD = /iPad/i.test(USER_AGENT); // The Facebook app's UIWebView identifies as both an iPhone and iPad, so
// to identify iPhones, we need to exclude iPads.
// http://artsy.github.io/blog/2012/10/18/the-perils-of-ios-user-agent-sniffing/

exports.IS_IPAD = IS_IPAD;
var IS_IPHONE = /iPhone/i.test(USER_AGENT) && !IS_IPAD;
exports.IS_IPHONE = IS_IPHONE;
var IS_IPOD = /iPod/i.test(USER_AGENT);
exports.IS_IPOD = IS_IPOD;
var IS_IOS = IS_IPHONE || IS_IPAD || IS_IPOD;
exports.IS_IOS = IS_IOS;

/***/ }),
/* 848 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(12);

var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(10));

var _createClass2 = _interopRequireDefault(__webpack_require__(11));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(16));

var _inherits2 = _interopRequireDefault(__webpack_require__(17));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _PlaybackRateMenuButton = _interopRequireDefault(__webpack_require__(209));

var _utils = __webpack_require__(46);

var PlaybackRate =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(PlaybackRate, _Component);

  function PlaybackRate(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, PlaybackRate);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(PlaybackRate).call(this, props, context));
    (0, _utils.deprecatedWarning)('PlaybackRate', 'PlaybackRateMenuButton');
    return _this;
  }

  (0, _createClass2["default"])(PlaybackRate, [{
    key: "render",
    value: function render() {
      return _react["default"].createElement(_PlaybackRateMenuButton["default"], this.props);
    }
  }]);
  return PlaybackRate;
}(_react.Component);

exports["default"] = PlaybackRate;
PlaybackRate.displayName = 'PlaybackRate';

/***/ }),
/* 849 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _interopRequireWildcard = __webpack_require__(12);

var _interopRequireDefault = __webpack_require__(5);

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _classCallCheck2 = _interopRequireDefault(__webpack_require__(10));

var _createClass2 = _interopRequireDefault(__webpack_require__(11));

var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(14));

var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(16));

var _assertThisInitialized2 = _interopRequireDefault(__webpack_require__(15));

var _inherits2 = _interopRequireDefault(__webpack_require__(17));

var _propTypes = _interopRequireDefault(__webpack_require__(1));

var _react = _interopRequireWildcard(__webpack_require__(0));

var _classnames = _interopRequireDefault(__webpack_require__(9));

var _MenuButton = _interopRequireDefault(__webpack_require__(210));

var propTypes = {
  player: _propTypes["default"].object,
  actions: _propTypes["default"].object,
  className: _propTypes["default"].string,
  offMenuText: _propTypes["default"].string,
  showOffMenu: _propTypes["default"].bool,
  kinds: _propTypes["default"].array
};
var defaultProps = {
  offMenuText: 'Off',
  showOffMenu: true,
  kinds: ['captions', 'subtitles'] // `kind`s of TextTrack to look for to associate it with this menu.

};

var ClosedCaptionButton =
/*#__PURE__*/
function (_Component) {
  (0, _inherits2["default"])(ClosedCaptionButton, _Component);

  function ClosedCaptionButton(props, context) {
    var _this;

    (0, _classCallCheck2["default"])(this, ClosedCaptionButton);
    _this = (0, _possibleConstructorReturn2["default"])(this, (0, _getPrototypeOf2["default"])(ClosedCaptionButton).call(this, props, context));
    _this.getTextTrackItems = _this.getTextTrackItems.bind((0, _assertThisInitialized2["default"])(_this));
    _this.updateState = _this.updateState.bind((0, _assertThisInitialized2["default"])(_this));
    _this.handleSelectItem = _this.handleSelectItem.bind((0, _assertThisInitialized2["default"])(_this));
    _this.state = _this.getTextTrackItems();
    return _this;
  }

  (0, _createClass2["default"])(ClosedCaptionButton, [{
    key: "componentDidUpdate",
    value: function componentDidUpdate() {
      this.updateState();
    }
  }, {
    key: "getTextTrackItems",
    value: function getTextTrackItems() {
      var _this$props = this.props,
          kinds = _this$props.kinds,
          player = _this$props.player,
          offMenuText = _this$props.offMenuText,
          showOffMenu = _this$props.showOffMenu;
      var textTracks = player.textTracks,
          activeTextTrack = player.activeTextTrack;
      var textTrackItems = {
        items: [],
        selectedIndex: 0
      };
      var tracks = Array.from(textTracks || []);

      if (tracks.length === 0) {
        return textTrackItems;
      }

      if (showOffMenu) {
        textTrackItems.items.push({
          label: offMenuText || 'Off',
          value: null
        });
      }

      tracks.forEach(function (textTrack) {
        // ignore invalid text track kind
        if (kinds.length && !kinds.includes(textTrack.kind)) {
          return;
        }

        textTrackItems.items.push({
          label: textTrack.label,
          value: textTrack.language
        });
      });
      textTrackItems.selectedIndex = textTrackItems.items.findIndex(function (item) {
        return activeTextTrack && activeTextTrack.language === item.value;
      });

      if (textTrackItems.selectedIndex === -1) {
        textTrackItems.selectedIndex = 0;
      }

      return textTrackItems;
    }
  }, {
    key: "updateState",
    value: function updateState() {
      var textTrackItems = this.getTextTrackItems();

      if (textTrackItems.selectedIndex !== this.state.selectedIndex || !this.textTrackItemsAreEqual(textTrackItems.items, this.state.items)) {
        this.setState(textTrackItems);
      }
    }
  }, {
    key: "textTrackItemsAreEqual",
    value: function textTrackItemsAreEqual(items1, items2) {
      if (items1.length !== items2.length) {
        return false;
      }

      for (var i = 0; i < items1.length; i++) {
        if (!items2[i] || items1[i].label !== items2[i].label || items1[i].value !== items2[i].value) {
          return false;
        }
      }

      return true;
    }
  }, {
    key: "handleSelectItem",
    value: function handleSelectItem(index) {
      var _this$props2 = this.props,
          player = _this$props2.player,
          actions = _this$props2.actions,
          showOffMenu = _this$props2.showOffMenu;
      var textTracks = player.textTracks; // For the 'subtitles-off' button, the first condition will never match
      // so all subtitles will be turned off

      Array.from(textTracks).forEach(function (textTrack, i) {
        // if it shows the `Off` menu, the first item is `Off`
        if (index === (showOffMenu ? i + 1 : i)) {
          textTrack.mode = 'showing';
          actions.activateTextTrack(textTrack);
        } else {
          textTrack.mode = 'hidden';
        }
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$state = this.state,
          items = _this$state.items,
          selectedIndex = _this$state.selectedIndex;
      return _react["default"].createElement(_MenuButton["default"], {
        className: (0, _classnames["default"])('video-react-closed-caption', this.props.className),
        onSelectItem: this.handleSelectItem,
        items: items,
        selectedIndex: selectedIndex
      }, _react["default"].createElement("span", {
        className: "video-react-control-text"
      }, "Closed Caption"));
    }
  }]);
  return ClosedCaptionButton;
}(_react.Component);

ClosedCaptionButton.propTypes = propTypes;
ClosedCaptionButton.defaultProps = defaultProps;
ClosedCaptionButton.displayName = 'ClosedCaptionButton';
var _default = ClosedCaptionButton;
exports["default"] = _default;

/***/ }),
/* 850 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_filter__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isEmpty__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_map__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hoc__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_router_dom__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_skrollr__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_react_skrollr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_react_skrollr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__containers__ = __webpack_require__(82);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils__ = __webpack_require__(2);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_class2,_temp2;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// Route,
var Residences=(_dec=Object(__WEBPACK_IMPORTED_MODULE_4__hoc__["a" /* multiLanguage */])(),_dec(_class=(_temp2=_class2=function(_Component){_inherits(Residences,_Component);function Residences(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Residences);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Residences.__proto__||Object.getPrototypeOf(Residences)).call.apply(_ref,[this].concat(args))),_this),_this.state={showTypeModal:false,currentSection:0,showTourModal:false,hoverType:null},_this.createTypeBtn=function(){var _this$props=_this.props,type=_this$props.type,t=_this$props.t;var hoverType=_this.state.hoverType;return __WEBPACK_IMPORTED_MODULE_3_lodash_map___default()(type,function(item,key){console.log(".... createTypeBtn",item);return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{key:key,className:"residence-divbtn "+(hoverType===key?"active":""),onClick:function onClick(e){return _this.handleClickType(key,e);},onMouseEnter:function onMouseEnter(){return _this.setState({hoverType:key});},onMouseLeave:function onMouseLeave(){return _this.setState({hoverType:null});}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:"image-block"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components__["a" /* BackgroundImage */],{className:"residence-imagetype img-0",image:item.thumbnail[0].image}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components__["a" /* BackgroundImage */],{className:"residence-imagetype img-1",image:item.thumbnail[1].image})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:"residence-text"},t(__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(item,"name"))));});},_this.handleClickType=function(key,e){e.preventDefault();_this.setState({showTypeModal:true,currentSection:key});},_this.handleCloseTypeModal=function(){_this.setState({showTypeModal:false});// clear queryString
var _this$props2=_this.props,history=_this$props2.history,location=_this$props2.location;history.push(""+location.pathname);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Residences,[{key:"render",value:function render(){var _props=this.props,landingPage=_props.landingPage,type=_props.type,t=_props.t;if(__WEBPACK_IMPORTED_MODULE_1_lodash_isEmpty___default()(type))return null;var hoverType=this.state.hoverType;var _state=this.state,currentSection=_state.currentSection,showTypeModal=_state.showTypeModal;var locationParams=__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(this.props,"location.search");var searchParams=new URLSearchParams(locationParams);var currentSectionSearchParams=searchParams.get("currentSection");var idCurrentSection=currentSectionSearchParams?currentSectionSearchParams:currentSection;var dataModel=__WEBPACK_IMPORTED_MODULE_0_lodash_filter___default()(type,function(item,key){return key===Number(idCurrentSection);});console.log("dataModel",dataModel);// const widthScreen = window.innerWidth;
// const lgSize = 960;
// console.log("landingPage", landingPage);
// console.log('this.props.match >>> residence >>> ', this.props);
// const currentFromUrl2 = parseQueryString() // queryString.parse(_.get(this.props.location, "search"));
// const currentFromUrl = queryString.parse(_.get(this.props.location, "search"));
var currentFromUrl=Object(__WEBPACK_IMPORTED_MODULE_11__utils__["c" /* parseQueryString */])();// queryString.parse(_.get(this.props.location, "search"));
// console.log('currentFromUrl.currentSection >>> ', currentFromUrl.currentSection);
// console.log('showTypeModal >>> ', showTypeModal);
return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:"section-residence"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:"parallax-container"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_skrollr__["Parallax"],{data:{"data-bottom-top":"transform: translateY(-100px); filter: blur(200px) saturate(2);","data-150-top":"transform: translateY(0px); filter: blur(0px) saturate(1);"}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:"image-slider-block"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components__["p" /* Slider */],{items:landingPage,settings:{arrows:false},uiRenderer:function uiRenderer(item,index){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components__["a" /* BackgroundImage */],{key:index,className:"residence-imagetype img-2",image:__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(item,"image"),position:__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(item,"backgroundPosition","center center")});}})))),__WEBPACK_IMPORTED_MODULE_3_lodash_map___default()(type,function(value,key){return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components__["a" /* BackgroundImage */],{key:key,className:"image-hover-show type-"+key+" "+(hoverType===key?"show":""),image:__WEBPACK_IMPORTED_MODULE_2_lodash_get___default()(value,"thumbnail.1.image")});}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:"residence-alpha"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:"parallax-container"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_skrollr__["Parallax"],{data:{"data-bottom-top":"transform: translateY(100px); opacity: 0;","data-bottom-bottom":"transform: translateY(0px); opacity: 1;"}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:"bg"})))),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:"residence-containertype-btn"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8_react_skrollr__["Parallax"],{data:{"data-bottom-top":"transform: translateY(100px);","data-bottom-bottom":"transform: translateY(0px);"}},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:"residence-typebtn btn"},this.createTypeBtn()))),(showTypeModal||currentFromUrl.currentSection!==undefined)&&__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components__["k" /* Modal */],{name:"residences-modal",onCancel:this.handleCloseTypeModal},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__containers__["f" /* TypeResidences */],{data:dataModel,t:t,currentSection:0})));}}]);return Residences;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]),_class2.propTypes={t:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.func,match:__WEBPACK_IMPORTED_MODULE_7_prop_types___default.a.shape().isRequired},_class2.defaultProps={t:function t(){}},_temp2))||_class);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_6_react_router_dom__["d" /* withRouter */])(Residences));

/***/ }),
/* 851 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TheSanctuaryclub; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_skrollr__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_skrollr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_skrollr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hoc__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TheSanctuaryclub=(_dec=Object(__WEBPACK_IMPORTED_MODULE_2__hoc__["a" /* multiLanguage */])(),_dec(_class=function(_Component){_inherits(TheSanctuaryclub,_Component);function TheSanctuaryclub(){_classCallCheck(this,TheSanctuaryclub);return _possibleConstructorReturn(this,(TheSanctuaryclub.__proto__||Object.getPrototypeOf(TheSanctuaryclub)).apply(this,arguments));}_createClass(TheSanctuaryclub,[{key:"render",value:function render(){var _props=this.props,t=_props.t,description=_props.description,image=_props.image,title=_props.title,currentLanguage=_props.currentLanguage,page=_props.page;console.log("TheSanctuaryclub",{page:page,image:image});return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"section-sanctuaryclub"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"parallax-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_skrollr__["Parallax"],{data:{"data-86-bottom-top":"transform: translateY(-100px); filter: blur(300px) saturate(2);","data-250-top":"transform: translateY(0px); filter: blur(0px) saturate(1);"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["a" /* BackgroundImage */],{image:image,style:{backgroundPositionY:"top"}}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"sanctuaryclub-content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_skrollr__["Parallax"],{data:{"data-bottom-top":"transform: translateY(200px); opacity: 0;","data-250-top":"transform: translateY(0px); opacity: 1;"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",null,t(title)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{dangerouslySetInnerHTML:{__html:t(description)}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{className:"sanctuaryclub-button-text",href:"/"+currentLanguage+"/sanctuary-club"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["b" /* Button */],{type:"default",defaultStyle:{padding:"2px 50px"}},t("View Benefits")))))));}}]);return TheSanctuaryclub;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class);

/***/ }),
/* 852 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Concept; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Concept=function(_Component){_inherits(Concept,_Component);function Concept(){_classCallCheck(this,Concept);return _possibleConstructorReturn(this,(Concept.__proto__||Object.getPrototypeOf(Concept)).apply(this,arguments));}_createClass(Concept,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common__["a" /* Concept */],this.props);}}]);return Concept;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 853 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Faq; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Faq=function(_Component){_inherits(Faq,_Component);function Faq(){_classCallCheck(this,Faq);return _possibleConstructorReturn(this,(Faq.__proto__||Object.getPrototypeOf(Faq)).apply(this,arguments));}_createClass(Faq,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common__["d" /* Faq */],this.props);}}]);return Faq;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 854 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Destination; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Bubble__ = __webpack_require__(364);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Destination=function(_Component){_inherits(Destination,_Component);function Destination(){_classCallCheck(this,Destination);return _possibleConstructorReturn(this,(Destination.__proto__||Object.getPrototypeOf(Destination)).apply(this,arguments));}_createClass(Destination,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common__["b" /* Destination */],Object.assign({},this.props,{project:"laguna-beachside",projectMapChildren:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(1350, 860)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"laguna-beachside-bubble-masterplan"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_Bubble__["a" /* default */],null)))}));}}]);return Destination;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 855 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TheSanctuaryclub; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TheSanctuaryclub=function(_Component){_inherits(TheSanctuaryclub,_Component);function TheSanctuaryclub(){_classCallCheck(this,TheSanctuaryclub);return _possibleConstructorReturn(this,(TheSanctuaryclub.__proto__||Object.getPrototypeOf(TheSanctuaryclub)).apply(this,arguments));}_createClass(TheSanctuaryclub,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common__["g" /* TheSanctuaryclub */],this.props);}}]);return TheSanctuaryclub;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 856 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Siteplan; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_findIndex__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_find__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isEmpty__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__hoc__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_icons_ArrowRight__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_icons_ArrowLeft__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_popup__ = __webpack_require__(857);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Siteplan=(_dec=Object(__WEBPACK_IMPORTED_MODULE_7__hoc__["a" /* multiLanguage */])(),_dec(_class=function(_Component){_inherits(Siteplan,_Component);function Siteplan(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Siteplan);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Siteplan.__proto__||Object.getPrototypeOf(Siteplan)).call.apply(_ref,[this].concat(args))),_this),_this.state={openModal:false,selectedType:"all",selectedBuilding:"all",pageModal:"1st",selectedSubTab:"all",pageModalSiteplan:"",pageModalData:null,popupHover:"",width:window.innerWidth},_this.hover=function(){var allEl=document.querySelectorAll("#floorplan path, #floorplan polygon, #floorplan rect");for(var i=0;i<allEl.length;i+=1){allEl[i].addEventListener("mouseover",_this.handleUnitHover);}},_this.unhover=function(){var allEl=document.querySelectorAll("#floorplan path, #floorplan polygon, #floorplan rect");for(var i=0;i<allEl.length;i+=1){allEl[i].addEventListener("mouseout",_this.handleUnitUnHover);}},_this.handleUnitUnHover=function(e){_this.setState({popupHover:""});},_this.handleUnitHover=function(e){var currentHoverType=e.target.parentElement.id;_this.setState({popupHover:currentHoverType});},_this.componentDidMount=function(){window.addEventListener("resize",_this.updateDimensions);_this.updateDimensions();},_this.updateDimensions=function(){var width=_this.state.width;_this.setState({width:window.innerWidth});},_this.componentWillUnmount=function(){window.removeEventListener("resize",_this.updateDimensions);},_this.test=function(val){var pageModal=_this.state.pageModal;var dataSitePlan=_this.props.dataSitePlan;var findPageModalData=__WEBPACK_IMPORTED_MODULE_3_lodash_find___default()(dataSitePlan,function(_ref2){var value=_ref2.value;return value===pageModal;});console.log("............ test",{val:val,dataSitePlan:dataSitePlan,findPageModalData:findPageModalData,pageModal:pageModal});_this.setState({pageModalData:findPageModalData||{},selectedSubTab:val});},_this.handleCloseModal=function(){_this.setState({openModal:false,selectedType:"all",pageModal:"1st",pageModalSiteplan:"",pageModalData:null});},_this.handleClickForOpenModal=function(pageModal){var dataSitePlan=_this.props.dataSitePlan;var findPageModalData=__WEBPACK_IMPORTED_MODULE_3_lodash_find___default()(dataSitePlan,function(_ref3){var value=_ref3.value;return value===pageModal;});_this.setState({openModal:true,selectedType:"all",pageModal:pageModal,pageModalData:findPageModalData||{}});},_this.handleSliderRight=function(){var dataSitePlan=_this.props.dataSitePlan;var pageModal=_this.state.pageModal;var sliderCurrentIndex=__WEBPACK_IMPORTED_MODULE_2_lodash_findIndex___default()(dataSitePlan,function(_ref4){var value=_ref4.value;return value===pageModal;});var lastDataSitePlanIndex=dataSitePlan.length-1;var sliderNextIndex=sliderCurrentIndex===lastDataSitePlanIndex?0:sliderCurrentIndex+1;var nextModal=__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(dataSitePlan,[sliderNextIndex]);var nextPageModal=__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(nextModal,"value");console.log("handleSliderRight",_defineProperty({sliderCurrentIndex:sliderCurrentIndex,nextModal:nextModal},"nextModal",nextModal));_this.setState({pageModal:nextPageModal,pageModalData:nextModal||{}});},_this.handleSliderLeft=function(){var dataSitePlan=_this.props.dataSitePlan;var pageModal=_this.state.pageModal;var sliderCurrentIndex=__WEBPACK_IMPORTED_MODULE_2_lodash_findIndex___default()(dataSitePlan,function(_ref5){var value=_ref5.value;return value===pageModal;});var lastDataSitePlanIndex=dataSitePlan.length-1;var sliderNextIndex=sliderCurrentIndex===0?lastDataSitePlanIndex:sliderCurrentIndex-1;var nextModal=__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(dataSitePlan,[sliderNextIndex]);var nextPageModal=__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(nextModal,"value");_this.setState({pageModal:nextPageModal,pageModalData:nextModal||{}});},_this.handleChangeType=function(selectedType){_this.setState({selectedType:selectedType});},_this.handleChangeSubTab=function(selectedSubTab){_this.setState({selectedSubTab:selectedSubTab});},_this.handleBlock=function(valueBlock){var pageModal=_this.state.pageModal;var dataSitePlan=_this.props.dataSitePlan;var findPageModalData=__WEBPACK_IMPORTED_MODULE_3_lodash_find___default()(dataSitePlan,function(_ref6){var value=_ref6.value;return value===pageModal;});console.log("handleBlock",{valueBlock:valueBlock,dataSitePlan:dataSitePlan,pageModal:pageModal});_this.setState({pageModalData:findPageModalData||{},selectedSubTab:valueBlock});},_this.renderPopup=function(){var _this$props=_this.props,descriptions=_this$props.descriptions,t=_this$props.t;var popupHover=_this.state.popupHover;var mapHoverData=__WEBPACK_IMPORTED_MODULE_0_lodash_map___default()(descriptions,function(item){var getTypePopup=__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item,"value");// const getDataPopup = _.get(item, "title");
var getTitlePopup=__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item,"title");var getDataPopup=__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item,"des");var activePopup=getTypePopup===popupHover?"active":"";// console.log("renderPopup", {
//   item,
//   getTypePopup,
//   getDataPopup,
//   activePopup,
// });
// console.log("renderPopup", { getTypePopup, popupHover, getTypePopup });
return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_popup__["a" /* default */],{title:t(getTitlePopup),data:t(getDataPopup),active:activePopup,onclick:_this.handleUnitHover});});return mapHoverData;},_this.renderAllFloor=function(){// const selectedSubTab = "a";
// const { selectedType, pageModalData, width } = this.state;
var _this$state=_this.state,selectedSubTab=_this$state.selectedSubTab,selectedType=_this$state.selectedType,pageModalData=_this$state.pageModalData,width=_this$state.width;var _this$props2=_this.props,subTabs=_this$props2.subTabs,currentLanguage=_this$props2.currentLanguage,t=_this$props2.t;var CurrentBlocks=function CurrentBlocks(){return null;};var showImg=__WEBPACK_IMPORTED_MODULE_3_lodash_find___default()(subTabs,function(_ref7){var value=_ref7.value;return value===selectedSubTab;});var mapElement=__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(pageModalData,"floorPlan."+selectedSubTab,null);console.log("renderAllFloor",{subTabs:subTabs,selectedSubTab:selectedSubTab,pageModalData:pageModalData});if(mapElement){CurrentBlocks=mapElement;}else{if(showImg){CurrentBlocks=showImg.img;}}console.log("BEACHSIDE SITE-PLAN",{subTabs:subTabs,currentLanguage:currentLanguage,selectedSubTab:selectedSubTab,selectedType:selectedType,pageModalData:pageModalData,showImg:showImg});return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react__["Fragment"],null,_this.renderPopup(),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(CurrentBlocks,{currentLang:currentLanguage,selectedSubTab:selectedSubTab,selectedType:selectedType,selectedBuilding:selectedSubTab,handleClick:function handleClick(selectedModal){_this.handleClickForOpenModal(selectedModal);}}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:"siteplan-button-group-subtabs"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components__["c" /* ButtonGroup */],{value:selectedType,items:__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(pageModalData,"buttons"),onChange:function onChange(value){_this.setState({selectedType:value,popupHover:value});setTimeout(function(){_this.setState({popupHover:""});},10000);},direction:width<992?"horizontal":"vertical",renderItem:function renderItem(_ref8){var value=_ref8.value,title=_ref8.title,active=_ref8.active,onClick=_ref8.onClick;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components__["b" /* Button */],{key:value,type:"secondary",active:active,activeStyle:{backgroundColor:"#00a9a5"},hoverStyle:{backgroundColor:"#00a9a5"},defaultStyle:{padding:"12px 17px",marginRight:"2px",fontWeight:"bold",fontSize:"13px",letterSpacing:"1px"},onClick:onClick},t(title));}})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:"button-slider"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("button",{onClick:_this.handleSliderLeft,className:"button-scroll-to-section left"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_icons_ArrowLeft__["a" /* default */],{width:40,height:40,fill:"#04a8a6"})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("button",{onClick:_this.handleSliderRight,className:"button-scroll-to-section right"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_icons_ArrowRight__["a" /* default */],{width:40,height:40,fill:"#04a8a6"})))));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Siteplan,[{key:"componentDidUpdate",value:function componentDidUpdate(prevProps){this.hover();this.unhover();if(this.props.dataSitePlan!==prevProps.dataSitePlan){!__WEBPACK_IMPORTED_MODULE_4_lodash_isEmpty___default()(this.props.dataSitePlan)&&this.test("all");}}},{key:"render",value:function render(){var _this2=this;var _props=this.props,t=_props.t,currentLanguage=_props.currentLanguage,page=_props.page,subTabs=_props.subTabs,dataSitePlan=_props.dataSitePlan;var _state=this.state,pageModalData=_state.pageModalData,selectedSubTab=_state.selectedSubTab;// loop สร้าง siteplan ตาม floor และเมื่อคลิก floor ให้โชว์ popup 3 menu คลิก menu ไหนให้ filter โชว์แค่อันนั้น
// const CurrentBuildingPlan = _.get(pageModalData, `floorPlan.${currentLanguage}`);
// let CurrentBuildingPlan = () => {
//   return null;
// };
// if (pageModalData) {
//   CurrentBuildingPlan = pageModalData.floorPlan[selectedSubTab];
// }
// var MyComponent = Components[type + "Component"];
// return React.createElement(MyComponent, {});
return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:"section-siteplan "+page+" site-plan-has-menu"},this.renderAllFloor(),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:"siteplan-container-buttongroup"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components__["c" /* ButtonGroup */],{value:selectedSubTab,items:subTabs,direction:"horizontal",renderItem:function renderItem(_ref9){var value=_ref9.value,title=_ref9.title,showModal=_ref9.showModal,active=_ref9.active,onClick=_ref9.onClick;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components__["b" /* Button */],{key:value,type:"secondary",active:active,activeStyle:{backgroundColor:"#00a9a5"},hoverStyle:{backgroundColor:"#00a9a5"},defaultStyle:{padding:"12px 17px",marginRight:"2px",fontWeight:"bold",fontSize:"13px",letterSpacing:"1px"},onClick:function onClick(){console.log("SVG-FLOOR-CHANGE",{showModal:showModal,value:value});if(showModal===true){_this2.handleClickForOpenModalSiteplan(value);}else{_this2.handleBlock(value);}}},t(title)));}})));}}]);return Siteplan;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]))||_class);

/***/ }),
/* 857 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_Close__ = __webpack_require__(101);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var popup=function(_Component){_inherits(popup,_Component);function popup(){_classCallCheck(this,popup);return _possibleConstructorReturn(this,(popup.__proto__||Object.getPrototypeOf(popup)).apply(this,arguments));}_createClass(popup,[{key:"render",value:function render(){var _props=this.props,data=_props.data,title=_props.title,active=_props.active,onclick=_props.onclick;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"popup "+active},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,title),data,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"button-close-popup"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{onClick:onclick,className:"button-scroll-to-section close"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_icons_Close__["a" /* default */],{width:20,height:20,fill:"#04a8a6"}))));}}]);return popup;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (popup);

/***/ }),
/* 858 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Masterplan; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_includes__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_filter__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_reject__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_reject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_reject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_animejs__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_animejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_animejs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_ProjectMap_PhuketMasterplan__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_ProjectMap_common_logos__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__hoc__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_navigation__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_detector__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_scroll__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Bubble__ = __webpack_require__(364);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import styled, { keyframes } from "styled-components";
// Filter LVR logo
var logos=__WEBPACK_IMPORTED_MODULE_3_lodash_reject___default()(__WEBPACK_IMPORTED_MODULE_7__containers_ProjectMap_common_logos__["a" /* default */],function(logo){return logo.key==="laguna-beachside";});// const bounce = keyframes`
//   0% {
//     transform: scale(0);
//   }
//   20% {
//     transform: scale(1);
//   }
//   40% {
//     transform: scale(0.7);
//   }
//   60% {
//     transform: scale(1);
//   }
//   100% {
//     transform: scale(1);
//   }
// `;
// const AnimatedBubble = styled.g`
//   cursor: pointer;
//   animation-name: ${bounce};
//   animation-duration: 3s;
//   animation-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);
//   animation-iteration-count: infinite;
// `;
var filterTexts=function filterTexts(texts){return __WEBPACK_IMPORTED_MODULE_2_lodash_filter___default()(texts,function(text,i){var excludeList=__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(text,"options.excludes",[]);if(__WEBPACK_IMPORTED_MODULE_0_lodash_includes___default()(excludeList,"lpark2/masterplan")||__WEBPACK_IMPORTED_MODULE_0_lodash_includes___default()(excludeList,"masterplan"))return false;return true;});};var fixIETransform=function fixIETransform(id){return function(anim){var g=document.getElementById(id);if(g){var transform=getComputedStyle(g).getPropertyValue("transform");g.setAttribute("transform",transform);}};};var Masterplan=(_dec=Object(__WEBPACK_IMPORTED_MODULE_8__hoc__["a" /* multiLanguage */])(),_dec(_class=function(_Component){_inherits(Masterplan,_Component);function Masterplan(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Masterplan);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Masterplan.__proto__||Object.getPrototypeOf(Masterplan)).call.apply(_ref,[this].concat(args))),_this),_this.handleClickBubble=function(){// go to master plan
var headerHeight=Object(__WEBPACK_IMPORTED_MODULE_9__utils_navigation__["a" /* getHeaderHeight */])();__WEBPACK_IMPORTED_MODULE_11_react_scroll__["scroller"].scrollTo("siteplan",{duration:1500,smooth:true,offset:-headerHeight});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Masterplan,[{key:"componentDidMount",value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_5_animejs___default()({targets:"#laguna-beachside-bubble",scale:[{value:0,duration:0,elasticity:0},{value:1,duration:2000,elasticity:400}],loop:true,update:__WEBPACK_IMPORTED_MODULE_10__utils_detector__["a" /* isIE */]?fixIETransform("laguna-beachside-bubble"):null});}},{key:"render",value:function render(){var _props=this.props,t=_props.t,currentLanguage=_props.currentLanguage;// console.log('filterTexts >>> ', filterTexts);
return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",{className:"section-masterplan"},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__containers_ProjectMap_PhuketMasterplan__["a" /* default */],{activeLanguage:currentLanguage,filterTexts:filterTexts},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("g",{transform:"translate(250, 230)"},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("g",{id:"laguna-beachside-bubble",onClick:this.handleClickBubble},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Bubble__["a" /* default */],null)))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",{className:"masterplan-name"},t("Master Plan")));}}]);return Masterplan;}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]))||_class);

/***/ }),
/* 859 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var isMergeableObject = function isMergeableObject(value) {
	return isNonNullObject(value)
		&& !isSpecial(value)
};

function isNonNullObject(value) {
	return !!value && typeof value === 'object'
}

function isSpecial(value) {
	var stringValue = Object.prototype.toString.call(value);

	return stringValue === '[object RegExp]'
		|| stringValue === '[object Date]'
		|| isReactElement(value)
}

// see https://github.com/facebook/react/blob/b5ac963fb791d1298e7f396236383bc955f916c1/src/isomorphic/classic/element/ReactElement.js#L21-L25
var canUseSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = canUseSymbol ? Symbol.for('react.element') : 0xeac7;

function isReactElement(value) {
	return value.$$typeof === REACT_ELEMENT_TYPE
}

function emptyTarget(val) {
	return Array.isArray(val) ? [] : {}
}

function cloneUnlessOtherwiseSpecified(value, options) {
	return (options.clone !== false && options.isMergeableObject(value))
		? deepmerge(emptyTarget(value), value, options)
		: value
}

function defaultArrayMerge(target, source, options) {
	return target.concat(source).map(function(element) {
		return cloneUnlessOtherwiseSpecified(element, options)
	})
}

function mergeObject(target, source, options) {
	var destination = {};
	if (options.isMergeableObject(target)) {
		Object.keys(target).forEach(function(key) {
			destination[key] = cloneUnlessOtherwiseSpecified(target[key], options);
		});
	}
	Object.keys(source).forEach(function(key) {
		if (!options.isMergeableObject(source[key]) || !target[key]) {
			destination[key] = cloneUnlessOtherwiseSpecified(source[key], options);
		} else {
			destination[key] = deepmerge(target[key], source[key], options);
		}
	});
	return destination
}

function deepmerge(target, source, options) {
	options = options || {};
	options.arrayMerge = options.arrayMerge || defaultArrayMerge;
	options.isMergeableObject = options.isMergeableObject || isMergeableObject;

	var sourceIsArray = Array.isArray(source);
	var targetIsArray = Array.isArray(target);
	var sourceAndTargetTypesMatch = sourceIsArray === targetIsArray;

	if (!sourceAndTargetTypesMatch) {
		return cloneUnlessOtherwiseSpecified(source, options)
	} else if (sourceIsArray) {
		return options.arrayMerge(target, source, options)
	} else {
		return mergeObject(target, source, options)
	}
}

deepmerge.all = function deepmergeAll(array, options) {
	if (!Array.isArray(array)) {
		throw new Error('first argument should be an array')
	}

	return array.reduce(function(prev, next) {
		return deepmerge(prev, next, options)
	}, {})
};

var deepmerge_1 = deepmerge;

/* harmony default export */ __webpack_exports__["a"] = (deepmerge_1);


/***/ }),
/* 860 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Residences; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Residences=function(_Component){_inherits(Residences,_Component);function Residences(){_classCallCheck(this,Residences);return _possibleConstructorReturn(this,(Residences.__proto__||Object.getPrototypeOf(Residences)).apply(this,arguments));}_createClass(Residences,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common__["f" /* Residences */],this.props);}}]);return Residences;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 861 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Ebrochure; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Ebrochure=function(_Component){_inherits(Ebrochure,_Component);function Ebrochure(){_classCallCheck(this,Ebrochure);return _possibleConstructorReturn(this,(Ebrochure.__proto__||Object.getPrototypeOf(Ebrochure)).apply(this,arguments));}_createClass(Ebrochure,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common__["c" /* Ebrochure */],this.props);}}]);return Ebrochure;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 862 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "category", function() { return category; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faqs", function() { return faqs; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var category=[{id:1,name:"Legal",displayOn:["en","cn","ru"]},{id:2,name:"Construction",displayOn:["en","cn","ru"]},{id:3,name:"Estate And Property Management",displayOn:["en","cn","ru"]},{id:4,name:"Owner benefits",displayOn:["en","cn","ru"]},{id:5,name:"Financing",displayOn:["en","cn","ru"]}];var faqs=[{categoryId:1,question:{en:"What types of ownership are available?",ru:"Какие формы собственности существуют?",cn:"有哪些类型的所有权?"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Condominiums are available on a freehold basis for both Thai and non-Thai buyers. However, according to current Thai law, non-Thais may only purchase up to 49% of the condominium\u2019s saleable area on a freehold basis. Otherwise, they may purchase any remaining units on a renewable leasehold basis (currently for a maximum period of 30 years as permitted by law).")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041F\u0440\u0438\u043E\u0431\u0440\u0435\u0442\u0435\u043D\u0438\u0435 \u043A\u0432\u0430\u0440\u0442\u0438\u0440 \u0432 \u043A\u043E\u043D\u0434\u043E\u043C\u0438\u043D\u0438\u0443\u043C\u0430\u0445 \u0432 \u043F\u043E\u043B\u043D\u0443\u044E \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u044C \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E \u043A\u0430\u043A \u0434\u043B\u044F \u0442\u0430\u0439\u0441\u043A\u0438\u0445 \u043F\u043E\u043A\u0443\u043F\u0430\u0442\u0435\u043B\u0435\u0439, \u0442\u0430\u043A \u0438 \u0434\u043B\u044F \u0438\u043D\u043E\u0441\u0442\u0440\u0430\u043D\u0446\u0435\u0432. \u041E\u0434\u043D\u0430\u043A\u043E, \u0441\u043E\u0433\u043B\u0430\u0441\u043D\u043E \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0449\u0435\u043C\u0443 \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0443 \u0422\u0430\u0438\u043B\u0430\u043D\u0434\u0430, \u043F\u043E\u043A\u0443\u043F\u0430\u0442\u0435\u043B\u0438, \u043D\u0435 \u044F\u0432\u043B\u044F\u044E\u0449\u0438\u0435\u0441\u044F \u0442\u0430\u0439\u0446\u0430\u043C\u0438, \u043C\u043E\u0433\u0443\u0442 \u043F\u0440\u0438\u043E\u0431\u0440\u0435\u0441\u0442\u0438 \u0432 \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u044C \u0442\u043E\u043B\u044C\u043A\u043E \u0434\u043E 49% \u043E\u0431\u0449\u0435\u0433\u043E \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u0430 \u043A\u0432\u0430\u0440\u0442\u0438\u0440 \u0432 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0441\u0435. \u041F\u0440\u0438 \u044D\u0442\u043E\u043C \u043E\u0441\u0442\u0430\u043B\u044C\u043D\u044B\u0435 \u043A\u0432\u0430\u0440\u0442\u0438\u0440\u044B \u043C\u043E\u0436\u043D\u043E \u043F\u0440\u0438\u043E\u0431\u0440\u0435\u0441\u0442\u0438 \u043D\u0430 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u0445 \u0434\u043E\u043B\u0433\u043E\u0441\u0440\u043E\u043E\u0447\u043D\u043E\u0439 \u0430\u0440\u0435\u043D\u0434\u044B \u0441 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u044C\u044E \u043C\u043D\u043E\u0433\u043E\u043A\u0440\u0430\u0442\u043D\u043E\u0433\u043E \u043F\u0440\u043E\u0434\u043B\u0435\u043D\u0438\u044F \u0430\u0440\u0435\u043D\u0434\u044B (\u043D\u0430 \u0434\u0430\u043D\u043D\u044B\u0439 \u043C\u043E\u043C\u0435\u043D\u0442 \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u044B\u0439 \u0441\u0440\u043E\u043A \u0430\u0440\u0435\u043D\u0434\u044B \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E\u043C \u0441\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 \u043D\u0430 30 \u043B\u0435\u0442).")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u5BF9\u4E8E\u6CF0\u56FD\u548C\u975E\u6CF0\u56FD\u4E70\u5BB6\u6765\u8BF4\uFF0C\u516C\u5BD3\u90FD\u53EF\u8D2D\u4E70\u6C38\u4E45\u4EA7\u6743\u3002\u7136\u800C\uFF0C\u6839\u636E\u6CF0\u56FD\u73B0\u884C\u6CD5\u5F8B\uFF0C\u975E\u6CF0\u56FD\u4EBA\u6700\u591A\u53EA\u80FD\u8D2D\u4E7049%\u7684\u516C\u5BD3\u53EF\u51FA\u552E\u9762\u79EF\u3002\u5426\u5219\uFF0C\u4ED6\u4EEC\u53EF\u901A\u8FC7\u53EF\u7EED\u79DF\u7684\u79DF\u8D41\u4EA7\u6743\u65B9\u5F0F\uFF08\u76EE\u524D\u6CD5\u5F8B\u5141\u8BB8\u7684\u6700\u957F\u79DF\u671F\u4E3A30\u5E74\uFF09\u8D2D\u4E70\u4EFB\u4F55\u5269\u4F59\u7684\u5355\u5143\u3002"))}},{categoryId:1,question:{en:"What are the costs associated with the lease / freehold registration?",ru:"Каковы затраты, связанные с арендой / регистрацией собственности?",cn:"与租赁/永久产权登记相关的费用是多少?"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Lease registration fees and stamp duty (currently 1.1% of the lease premium) is payable to the Land Department upon registration of the lease. The cost of lease renewals will be borne by the lessee according to the contracts"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Freehold registration fees (currently 2.0% of the appraisal price) is payable to the Land Department upon transfer and registration of title. The appraisal price is assessed by Thailand\u2019s Treasury Department which is generally below market value. Other applicable taxes upon transfer and registration of freehold title are:"," "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Corporate Income Withholding Tax (currently 1.0% of the selling price or appraisal price, whichever is higher)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Specific Business Tax (currently 3.3% of the selling price or appraisal price, whichever is higher)"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"The burden between seller and buyer for the above costs will be specified in the relevant agreements."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"Note: Applicable rates stated are current and may be subject to change.")))),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0421\u0431\u043E\u0440\u044B \u0437\u0430 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044E \u0430\u0440\u0435\u043D\u0434\u044B \u0438 \u0433\u0435\u0440\u0431\u043E\u0432\u044B\u0439 \u0441\u0431\u043E\u0440 (\u0432 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0435 \u0432\u0440\u0435\u043C\u044F 1,1 % \u043E\u0442 \u0430\u0440\u0435\u043D\u0434\u043D\u043E\u0439 \u043F\u043B\u0430\u0442\u044B) \u0443\u043F\u043B\u0430\u0447\u0438\u0432\u0430\u044E\u0442\u0441\u044F \u0432 \u0417\u0435\u043C\u0435\u043B\u044C\u043D\u044B\u0439 \u0434\u0435\u043F\u0430\u0440\u0442\u0430\u043C\u0435\u043D\u0442 \u043F\u0440\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0430\u0440\u0435\u043D\u0434\u044B. \u0420\u0430\u0441\u0445\u043E\u0434\u044B \u043F\u043E \u043F\u0440\u043E\u0434\u043B\u0435\u043D\u0438\u044E \u0430\u0440\u0435\u043D\u0434\u044B \u043D\u0435\u0441\u0435\u0442 \u0430\u0440\u0435\u043D\u0434\u0430\u0442\u043E\u0440 \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u043C\u0438 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u043E\u0432."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0421\u0431\u043E\u0440\u044B \u0437\u0430 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044E \u043F\u0440\u0430\u0432\u0430 \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438 (\u0432 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0435 \u0432\u0440\u0435\u043C\u044F 2,0 % \u043E\u0442 \u043E\u0446\u0435\u043D\u043E\u0447\u043D\u043E\u0439 \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u0438) \u0443\u043F\u043B\u0430\u0447\u0438\u0432\u0430\u044E\u0442\u0441\u044F \u0432 \u0417\u0435\u043C\u0435\u043B\u044C\u043D\u044B\u0439 \u0434\u0435\u043F\u0430\u0440\u0442\u0430\u043C\u0435\u043D\u0442 \u043F\u0440\u0438 \u043F\u0435\u0440\u0435\u0434\u0430\u0447\u0435 \u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u043F\u0440\u0430\u0432\u0430 \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438. \u041E\u0446\u0435\u043D\u043E\u0447\u043D\u0430\u044F \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u044F\u0435\u0442\u0441\u044F \u041C\u0438\u043D\u0438\u0441\u0442\u0435\u0440\u0441\u0442\u0432\u043E\u043C \u0444\u0438\u043D\u0430\u043D\u0441\u043E\u0432 \u0422\u0430\u0438\u043B\u0430\u043D\u0434\u0430 \u0438 \u043E\u0431\u044B\u0447\u043D\u043E \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u043D\u0438\u0436\u0435 \u0440\u044B\u043D\u043E\u0447\u043D\u043E\u0439. \u0414\u0440\u0443\u0433\u0438\u0435 \u043F\u0440\u0438\u043C\u0435\u043D\u0438\u043C\u044B\u0435 \u043D\u0430\u043B\u043E\u0433\u0438 \u043F\u0440\u0438 \u043F\u0435\u0440\u0435\u0434\u0430\u0447\u0435 \u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u043F\u0440\u0430\u0432\u0430 \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u0432\u043A\u043B\u044E\u0447\u0430\u044E\u0442 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0435:"," "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041D\u0430\u043B\u043E\u0433 \u043D\u0430 \u0434\u043E\u0445\u043E\u0434\u044B \u044E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u0438\u0445 \u043B\u0438\u0446 (\u0432 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0435 \u0432\u0440\u0435\u043C\u044F \u0441\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 1,0 % \u043E\u0442 \u043F\u0440\u043E\u0434\u0430\u0436\u043D\u043E\u0439 \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u0438 \u0438\u043B\u0438 \u043E\u0446\u0435\u043D\u043E\u0447\u043D\u043E\u0439 \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u0438, \u0432 \u0437\u0430\u0432\u0438\u0441\u0438\u043C\u043E\u0441\u0442\u0438 \u043E\u0442 \u0442\u043E\u0433\u043E, \u043A\u0430\u043A\u0430\u044F \u0438\u0437 \u043D\u0438\u0445 \u0432\u044B\u0448\u0435)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0421\u043F\u0435\u0446\u0438\u0430\u043B\u044C\u043D\u044B\u0439 \u043D\u0430\u043B\u043E\u0433 \u043D\u0430 \u043F\u0440\u0438\u0431\u044B\u043B\u044C (\u0432 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0435 \u0432\u0440\u0435\u043C\u044F \u0441\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 3,3 % \u043E\u0442 \u043F\u0440\u043E\u0434\u0430\u0436\u043D\u043E\u0439 \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u0438 \u0438\u043B\u0438 \u043E\u0446\u0435\u043D\u043E\u0447\u043D\u043E\u0439 \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u0438, \u0432 \u0437\u0430\u0432\u0438\u0441\u0438\u043C\u043E\u0441\u0442\u0438 \u043E\u0442 \u0442\u043E\u0433\u043E, \u043A\u0430\u043A\u0430\u044F \u0438\u0437 \u043D\u0438\u0445 \u0432\u044B\u0448\u0435)"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0430 \u0438 \u043F\u043E\u043A\u0443\u043F\u0430\u0442\u0435\u043B\u044F \u043F\u043E \u043E\u043F\u043B\u0430\u0442\u0435 \u0432\u044B\u0448\u0435\u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0445 \u0440\u0430\u0441\u0445\u043E\u0434\u043E\u0432 \u043E\u0433\u043E\u0432\u0430\u0440\u0438\u0432\u0430\u0435\u0442\u0441\u044F \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0445 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430\u0445."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"\u041F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0435: \u041F\u0440\u0438\u043C\u0435\u043D\u0438\u043C\u044B\u0435 \u0441\u0442\u0430\u0432\u043A\u0438 \u0443\u043A\u0430\u0437\u0430\u043D\u044B \u043F\u043E \u0441\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u044E \u043D\u0430 \u0442\u0435\u043A\u0443\u0449\u0438\u0439 \u043C\u043E\u043C\u0435\u043D\u0442 \u0438 \u043C\u043E\u0433\u0443\u0442 \u0431\u044B\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u044B.")))),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u7B54.\u79DF\u8D41\u767B\u8BB0\u65F6\u987B\u5411\u56FD\u571F\u90E8\u95E8\u7F34\u4ED8\u79DF\u8D41\u767B\u8BB0\u8D39\u548C\u5370\u82B1\u7A0E\uFF08\u5F53\u524D\u4E3A\u79DF\u8D41\u8D39\u76841.1%\uFF09\u3002\u79DF\u8D41\u7EED\u671F\u7684\u8D39\u7528\u5C06\u6839\u636E\u5408\u540C\u7531\u627F\u79DF\u4EBA\u627F\u62C5\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u6C38\u4E45\u4EA7\u6743\u8F6C\u8BA9\u548C\u767B\u8BB0\u65F6\uFF0C\u5E94\u5411\u56FD\u571F\u90E8\u95E8\u7F34\u4ED8\u4EA7\u6743\u767B\u8BB0\u8D39\uFF08\u5F53\u524D\u4E3A\u4F30\u4EF7\u76842.0%\uFF09\u3002\u4F30\u4EF7\u7531\u6CF0\u56FD\u8D22\u653F\u90E8\u8BC4\u4F30\uFF0C\u4E00\u822C\u4F1A\u4F4E\u4E8E\u5E02\u573A\u4EF7\u503C\u3002\u6C38\u4E45\u4EA7\u6743\u8F6C\u8BA9\u548C\u767B\u8BB0\u65F6\u9002\u7528\u7684\u5176\u4ED6\u7A0E\u5305\u62EC\uFF1A"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u4F01\u4E1A\u6240\u5F97\u9884\u6263\u7A0E\uFF08\u5F53\u524D\u4E3A\u552E\u4EF7\u6216\u4F30\u4EF7\u76841.0%\uFF0C\u4EE5\u8F83\u9AD8\u8005\u4E3A\u51C6\uFF09")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u7279\u6B8A\u8425\u4E1A\u7A0E\uFF08\u5F53\u524D\u4E3A\u552E\u4EF7\u6216\u4F30\u4EF7\u4EF7\u76843.3%\uFF0C\u4EE5\u8F83\u9AD8\u8005\u4E3A\u51C6\uFF09"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u5356\u65B9\u548C\u4E70\u65B9\u5BF9\u4E0A\u8FF0\u8D39\u7528\u7684\u627F\u62C5\u5C06\u5728\u76F8\u5173\u534F\u8BAE\u4E2D\u89C4\u5B9A\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"\u6CE8\uFF1A\u6240\u5217\u7684\u9002\u7528\u8D39\u7387\u4E3A\u5F53\u524D\u60C5\u51B5\uFF0C\u53EF\u80FD\u4F1A\u6709\u53D8\u5316\u3002"))))}},{categoryId:1,question:{en:"Is a leasehold condominium transferable?",ru:"Можно ли передать права долгосречной аренды на  квартиры в жилом комплексе другим лицам?",cn:"租赁公寓可以转让吗？"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Yes. Leasehold condominiums may be transferred subject to the terms and conditions of the lease agreement. Generally, a small fee is payable. In addition, the new owner must agree to be bound by the terms and conditions contained in the original lease agreement.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0414\u0430. \u041F\u0440\u0430\u0432\u0430 \u0434\u043E\u043B\u0433\u043E\u0441\u0440\u043E\u0447\u043D\u043E\u0439 \u0430\u0440\u0435\u043D\u0434\u044B \u043D\u0430 \u043A\u0432\u0430\u0440\u0442\u0438\u0440\u044B \u0432 \u043A\u043E\u043D\u0434\u043E\u043C\u0438\u043D\u0438\u0443\u043C\u0435 \u043C\u043E\u0433\u0443\u0442 \u0431\u044B\u0442\u044C \u043F\u0435\u0440\u0435\u0434\u0430\u043D\u044B \u0434\u0440\u0443\u0433\u0438\u043C \u043B\u0438\u0446\u0430\u043C \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u043C\u0438 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430 \u0430\u0440\u0435\u043D\u0434\u044B. \u041A\u0430\u043A \u043F\u0440\u0430\u0432\u0438\u043B\u043E, \u0437\u0430 \u044D\u0442\u043E \u0432\u0437\u0438\u043C\u0430\u0435\u0442\u0441\u044F \u043D\u0435\u0431\u043E\u043B\u044C\u0448\u0430\u044F \u043F\u043B\u0430\u0442\u0430. \u041A\u0440\u043E\u043C\u0435 \u0442\u043E\u0433\u043E, \u043D\u043E\u0432\u044B\u0439 \u0430\u0440\u0435\u043D\u0434\u0430\u0442\u043E\u0440 \u0434\u043E\u043B\u0436\u0435\u043D \u0432\u0437\u044F\u0442\u044C \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E \u043F\u043E \u0441\u043E\u0431\u043B\u044E\u0434\u0435\u043D\u0438\u044E \u0443\u0441\u043B\u043E\u0432\u0438\u0439, \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u0449\u0438\u0445\u0441\u044F \u0432 \u043F\u0435\u0440\u0432\u043E\u043D\u0430\u0447\u0430\u043B\u044C\u043D\u043E\u043C \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0435 \u0430\u0440\u0435\u043D\u0434\u044B.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u7B54.\u53EF\u4EE5\u3002\u79DF\u8D41\u516C\u5BD3\u53EF\u4EE5\u6309\u7167\u79DF\u8D41\u534F\u8BAE\u7684\u6761\u6B3E\u548C\u6761\u4EF6\u8F6C\u8BA9\u3002\u901A\u5E38\u9700\u8981\u652F\u4ED8\u5C11\u91CF\u8D39\u7528\u3002\u6B64\u5916\uFF0C\u65B0\u4E1A\u4E3B\u5FC5\u987B\u540C\u610F\u53D7\u539F\u79DF\u7EA6\u6761\u6B3E\u7EA6\u675F\u3002"))}},{categoryId:1,question:{en:"Is leasehold ownership secure?",ru:"Защищены ли права арендатора на арендованную недвижимость?",cn:"租赁所有权安全吗？"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Leasehold ownership is a common method of ownership for foreign buyers. Once the lease is registered at the Land Department, the lessee\u2019s rights over the condominium unit will be officially recognized.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0412\u043B\u0430\u0434\u0435\u043D\u0438\u0435 \u043D\u0430 \u043F\u0440\u0430\u0432\u0430\u0445 \u0434\u043E\u043B\u0433\u043E\u0441\u0440\u043E\u0447\u043D\u043E\u0439 \u0430\u0440\u0435\u043D\u0434\u044B \u2014 \u0440\u0430\u0441\u043F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u043D\u044B\u0439 \u0441\u043F\u043E\u0441\u043E\u0431 \u0432\u043B\u0430\u0434\u0435\u043D\u0438\u044F \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u044C\u044E \u0438\u043D\u043E\u0441\u0442\u0440\u0430\u043D\u043D\u044B\u043C\u0438 \u043F\u043E\u043A\u0443\u043F\u0430\u0442\u0435\u043B\u044F\u043C\u0438. \u041F\u043E\u0441\u043B\u0435 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430 \u0430\u0440\u0435\u043D\u0434\u044B \u0432 \u0417\u0435\u043C\u0435\u043B\u044C\u043D\u043E\u043C \u0434\u0435\u043F\u0430\u0440\u0442\u0430\u043C\u0435\u043D\u0442\u0435 \u043E\u0444\u0438\u0446\u0438\u0430\u043B\u044C\u043D\u043E \u043F\u0440\u0438\u0437\u043D\u0430\u044E\u0442\u0441\u044F \u043F\u0440\u0430\u0432\u0430 \u0430\u0440\u0435\u043D\u0434\u0430\u0442\u043E\u0440\u0430 \u043D\u0430 \u043A\u0432\u0430\u0440\u0442\u0438\u0440\u0443 \u0432 \u0436\u0438\u043B\u043E\u043C \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0441\u0435.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u7B54.\u79DF\u8D41\u4EA7\u6743\u662F\u5916\u56FD\u4E70\u5BB6\u7684\u4E00\u79CD\u5E38\u89C1\u6240\u6709\u6743\u65B9\u5F0F\u3002\u79DF\u7EA6\u4E00\u65E6\u5728\u56FD\u571F\u90E8\u95E8\u767B\u8BB0\uFF0C\u627F\u79DF\u4EBA\u7684\u516C\u5BD3\u6240\u6709\u6743\u5C06\u5F97\u5230\u6B63\u5F0F\u627F\u8BA4\u3002"))}},{categoryId:1,question:{en:"When will the registration and transfer of the condominiums take place?",ru:"В какой момент происходит регистрация и передача прав на квартиры в жилом комплексе?",cn:"公寓的登记和转让什么时候进行？"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Approximately 90 days after full payment has been received and construction of all buildings in the Project are completed. We will notify the owner of any documents and fees required for registration. Owners may opt to accept the hand-over of their purchased/leased unit and move in before registration and transfer of condominium unit ownership, upon the occupancy permit of the building being granted (terms and conditions apply).")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 90 \u0434\u043D\u0435\u0439 \u043F\u043E\u0441\u043B\u0435 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u043F\u043E\u043B\u043D\u043E\u0439 \u043E\u043F\u043B\u0430\u0442\u044B \u0438 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 \u0432\u0441\u0435\u0445 \u0437\u0434\u0430\u043D\u0438\u0439 \u0432 \u0440\u0430\u043C\u043A\u0430\u0445 \u041F\u0440\u043E\u0435\u043A\u0442\u0430. \u041C\u044B \u0443\u0432\u0435\u0434\u043E\u043C\u0438\u043C \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0430 \u043E \u0442\u043E\u043C, \u043A\u0430\u043A\u0438\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B \u0438 \u043F\u043E\u0448\u043B\u0438\u043D\u044B \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u044B \u0434\u043B\u044F \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438. \u0412\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u044B \u043C\u043E\u0433\u0443\u0442 \u043D\u0430\u0447\u0430\u0442\u044C \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C\u0441\u044F \u0441\u0432\u043E\u0435\u0439 \u043A\u0432\u0430\u0440\u0442\u0438\u0440\u043E\u0439 \u0438 \u0432\u044C\u0435\u0445\u0430\u0442\u044C \u0434\u043E \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0438\u043F\u0435\u0440\u0435\u0434\u0430\u0447\u0438 \u043F\u0440\u0430\u0432\u0430 \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u043D\u0430 \u043A\u0432\u0430\u0440\u0442\u0438\u0440\u0443 \u0432 \u043A\u043E\u043D\u0434\u043E\u043C\u0438\u043D\u0438\u0443\u043C\u0435 \u043F\u0440\u0438 \u043D\u0430\u043B\u0438\u0447\u0438\u0438 \u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u0438\u044F \u043D\u0430 \u043F\u0440\u043E\u0436\u0438\u0432\u0430\u043D\u0438\u0435 \u0432 \u044D\u0442\u043E\u043C \u0437\u0434\u0430\u043D\u0438\u0438 (\u043F\u0440\u0438\u043C\u0435\u043D\u044F\u044E\u0442\u0441\u044F \u0443\u0441\u043B\u043E\u0432\u0438\u044F).")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u7B54.\u5728\u6536\u5230\u5168\u90E8\u6B3E\u9879\u5E76\u5B8C\u6210\u9879\u76EE\u4E2D\u6240\u6709\u5EFA\u7B51\u7684\u5EFA\u9020\u540E\u5927\u7EA690\u5929\u3002\u6211\u4EEC\u5C06\u544A\u77E5\u4E1A\u4E3B\u6240\u9700\u7684\u6240\u6709\u6587\u4EF6\u548C\u767B\u8BB0\u8D39\u7528\u3002\u4E1A\u4E3B\u53EF\u9009\u62E9\u5728\u767B\u8BB0\u548C\u8F6C\u8BA9\u516C\u5BD3\u6240\u6709\u6743\u4E4B\u524D\uFF0C\u5F53\u53D6\u5F97\u5EFA\u7B51\u4F7F\u7528\u8BB8\u53EF\uFF08\u9002\u7528\u6761\u6B3E\u548C\u6761\u4EF6\uFF09\u540E\uFF0C\u63A5\u53D7\u5176\u8D2D\u4E70/\u79DF\u8D41\u516C\u5BD3\u7684\u79FB\u4EA4\u5E76\u642C\u5165\u3002"))}},{categoryId:1,question:{en:"Should I appoint a lawyer to review the agreements?",ru:"Должен ли я нанять адвоката для проверки соглашений?",cn:"我应该请律师来审阅这些协议吗？"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Our agreements have been used for a number of years and have been reviewed by major international law firms. We have our own in-house legal team which can assist to clarify any questions you may have concerning the agreements. However, should you wish to obtain specific advice regarding the structuring of your investment, we recommend you consult with a professional legal and/or financial adviser.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041D\u0430\u0448\u0438 \u0441\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u044E\u0442\u0441\u044F \u0443\u0436\u0435 \u043C\u043D\u043E\u0433\u043E \u043B\u0435\u0442 \u0438 \u043F\u0440\u043E\u0448\u043B\u0438 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0443 \u043A\u0440\u0443\u043F\u043D\u044B\u043C\u0438 \u043C\u0435\u0436\u0434\u0443\u043D\u0430\u0440\u043E\u0434\u043D\u044B\u043C\u0438 \u044E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u0438\u043C\u0438 \u0444\u0438\u0440\u043C\u0430\u043C\u0438. \u0423 \u043D\u0430\u0441 \u0435\u0441\u0442\u044C \u0441\u0432\u043E\u0438 \u044E\u0440\u0438\u0441\u0442\u044B, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u043C\u043E\u0433\u0443\u0442 \u043E\u0442\u0432\u0435\u0442\u0438\u0442\u044C \u043D\u0430 \u043B\u044E\u0431\u044B\u0435 \u0432\u0430\u0448\u0438 \u0432\u043E\u043F\u0440\u043E\u0441\u044B \u043F\u043E \u0441\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F\u043C. \u041E\u0434\u043D\u0430\u043A\u043E, \u0435\u0441\u043B\u0438 \u0432\u044B \u0445\u043E\u0442\u0438\u0442\u0435 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u043A\u043E\u043D\u043A\u0440\u0435\u0442\u043D\u044B\u0435 \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0430\u0446\u0438\u0438 \u043F\u043E \u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044E \u0438\u043D\u0432\u0435\u0441\u0442\u0438\u0446\u0438\u0439, \u043C\u044B \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u043C \u043F\u0440\u043E\u043A\u043E\u043D\u0441\u0443\u043B\u044C\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0441\u044F \u0441 \u043F\u0440\u043E\u0444\u0435\u0441\u0441\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u043C \u044E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u0438\u043C \u0438 (\u0438\u043B\u0438) \u0444\u0438\u043D\u0430\u043D\u0441\u043E\u0432\u044B\u043C \u043A\u043E\u043D\u0441\u0443\u043B\u044C\u0442\u0430\u043D\u0442\u043E\u043C.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u7B54.\u6211\u4EEC\u7684\u534F\u8BAE\u5DF2\u7ECF\u4F7F\u7528\u591A\u5E74\uFF0C\u5E76\u7ECF\u4E3B\u6D41\u56FD\u9645\u5F8B\u5E08\u4E8B\u52A1\u6240\u5BA1\u6838\u3002\u6211\u4EEC\u62E5\u6709\u81EA\u5DF1\u7684\u5185\u90E8\u6CD5\u5F8B\u56E2\u961F\uFF0C\u53EF\u4EE5\u5E2E\u52A9\u6F84\u6E05\u5173\u4E8E\u534F\u8BAE\u7684\u4EFB\u4F55\u95EE\u9898\u3002\u7136\u800C\uFF0C\u5982\u679C\u4F60\u5E0C\u671B\u83B7\u5F97\u5173\u4E8E\u4F60\u7684\u6295\u8D44\u7ED3\u6784\u7684\u5177\u4F53\u5EFA\u8BAE\uFF0C\u5EFA\u8BAE\u4F60\u54A8\u8BE2\u4E13\u4E1A\u7684\u6CD5\u5F8B\u548C/\u6216\u8D22\u52A1\u987E\u95EE\u3002"))}},{categoryId:1,question:{en:"What types of visas are available for foreigners to stay in Thailand?",ru:"Какие типы виз доступны иностранцам для пребывания в Таиланде?",cn:"外国人在泰国可以获得哪些签证？"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"There are various forms of visas available to foreigners who wish to enter Thailand for study, business, investment, retirement and other purposes ranging from 90 days to 1 year multiple entry which include."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Education visa when enrolled at registered education institution within Thailand"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Business visa when operating a business"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Retirement visa for people aged 50 years or over and meet financial requirements"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Marriage visa for foreigners married to a Thai"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Thailand Elite Visa - a government led program offering memberships including 5 year visas")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Please consult with an immigration specialist or Thai Embassy / Consulate for more information.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0421\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u044E\u0442 \u0440\u0430\u0437\u043B\u0438\u0447\u043D\u044B\u0435 \u0444\u043E\u0440\u043C\u044B \u0432\u0438\u0437, \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B\u0435 \u0434\u043B\u044F \u0438\u043D\u043E\u0441\u0442\u0440\u0430\u043D\u0446\u0435\u0432, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u0445\u043E\u0442\u044F\u0442 \u043F\u0440\u0438\u0435\u0445\u0430\u0442\u044C \u0432 \u0422\u0430\u0438\u043B\u0430\u043D\u0434 \u0434\u043B\u044F \u0443\u0447\u0435\u0431\u044B, \u0432\u0435\u0434\u0435\u043D\u0438\u044F \u0431\u0438\u0437\u043D\u0435\u0441\u0430, \u0438\u043D\u0432\u0435\u0441\u0442\u0438\u0446\u0438\u0439, \u0432\u044B\u0445\u043E\u0434\u0430 \u043D\u0430 \u043F\u0435\u043D\u0441\u0438\u044E \u0438 \u0434\u0440\u0443\u0433\u0438\u0445 \u0446\u0435\u043B\u0435\u0439 \u043D\u0430 \u0441\u0440\u043E\u043A \u043E\u0442 90 \u0434\u043D\u0435\u0439 \u0434\u043E 1 \u0433\u043E\u0434\u0430 \u0441 \u043C\u043D\u043E\u0433\u043E\u043A\u0440\u0430\u0442\u043D\u044B\u043C \u0432\u044A\u0435\u0437\u0434\u043E\u043C. \u041A \u0442\u0430\u043A\u0438\u043C \u0432\u0438\u0437\u0430\u043C \u043E\u0442\u043D\u043E\u0441\u044F\u0442\u0441\u044F \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0435:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u0412\u0438\u0437\u0430 \u0434\u043B\u044F \u0446\u0435\u043B\u0435\u0439 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u043E\u0431\u0440\u0430\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u043F\u0440\u0438 \u043F\u043E\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u0438 \u0432 \u0430\u043A\u043A\u0440\u0435\u0434\u0438\u0442\u043E\u0432\u0430\u043D\u043D\u043E\u0435 \u0443\u0447\u0435\u0431\u043D\u043E\u0435 \u0437\u0430\u0432\u0435\u0434\u0435\u043D\u0438\u0435 \u0432 \u0422\u0430\u0438\u043B\u0430\u043D\u0434\u0435"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u0414\u0435\u043B\u043E\u0432\u0430\u044F \u0432\u0438\u0437\u0430 \u0434\u043B\u044F \u0432\u0435\u0434\u0435\u043D\u0438\u044F \u043F\u0440\u0435\u0434\u043F\u0440\u0438\u043D\u0438\u043C\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u043E\u0439 \u0434\u0435\u044F\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u0438"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u041F\u0435\u043D\u0441\u0438\u043E\u043D\u043D\u0430\u044F \u0432\u0438\u0437\u0430 \u0434\u043B\u044F \u043B\u044E\u0434\u0435\u0439 \u0432 \u0432\u043E\u0437\u0440\u0430\u0441\u0442\u0435 50 \u043B\u0435\u0442 \u0438 \u0441\u0442\u0430\u0440\u0448\u0435, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u043E\u0442\u0432\u0435\u0447\u0430\u044E\u0442 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u044B\u043C \u0444\u0438\u043D\u0430\u043D\u0441\u043E\u0432\u044B\u043C \u0442\u0440\u0435\u0431\u043E\u0432\u0430\u043D\u0438\u044F\u043C"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u0411\u0440\u0430\u0447\u043D\u0430\u044F \u0432\u0438\u0437\u0430 \u0434\u043B\u044F \u0438\u043D\u043E\u0441\u0442\u0440\u0430\u043D\u0446\u0435\u0432, \u0441\u043E\u0441\u0442\u043E\u044F\u0449\u0438\u0445 \u0432 \u0431\u0440\u0430\u043A\u0435 \u0441 \u0442\u0430\u0439\u0446\u0435\u043C \u0438\u043B\u0438 \u0442\u0430\u0439\u043A\u043E\u0439"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u0422\u0430\u0438\u043B\u0430\u043D\u0434\u0441\u043A\u0430\u044F \u044D\u043B\u0438\u0442\u043D\u0430\u044F \u0432\u0438\u0437\u0430, \u0432\u044B\u0434\u0430\u0432\u0430\u0435\u043C\u0430\u044F \u043F\u043E \u043F\u0440\u0430\u0432\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0439 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0435 \u0438 \u043F\u0440\u0435\u0434\u043B\u0430\u0433\u0430\u044E\u0449\u0430\u044F \u0447\u043B\u0435\u043D\u0441\u0442\u0432\u043E, \u0432\u043A\u043B\u044E\u0447\u0430\u044F \u0432\u0438\u0437\u044B, \u0432\u044B\u0434\u0430\u0432\u0430\u0435\u043C\u044B\u0435 \u043D\u0430 \u0441\u0440\u043E\u043A 5 \u043B\u0435\u0442")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0414\u043B\u044F \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u043F\u0440\u043E\u043A\u043E\u043D\u0441\u0443\u043B\u044C\u0442\u0438\u0440\u0443\u0439\u0442\u0435\u0441\u044C \u0441\u043E \u0441\u043F\u0435\u0446\u0438\u0430\u043B\u0438\u0441\u0442\u043E\u043C \u043F\u043E \u0432\u043E\u043F\u0440\u043E\u0441\u0430\u043C \u0438\u043C\u043C\u0438\u0433\u0440\u0430\u0446\u0438\u0438 \u0438\u043B\u0438 \u043F\u043E\u0441\u043E\u043B\u044C\u0441\u0442\u0432\u043E\u043C/\u043A\u043E\u043D\u0441\u0443\u043B\u044C\u0441\u0442\u0432\u043E\u043C \u0422\u0430\u0438\u043B\u0430\u043D\u0434\u0430.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u7B54.\u4ECE90\u5929\u52301\u5E74\u7684\u591A\u6B21\u5165\u5883\uFF0C\u6709\u591A\u79CD\u5F62\u5F0F\u7684\u7B7E\u8BC1\u53EF\u4F9B\u5916\u56FD\u4EBA\u56E0\u5B66\u4E60\u3001\u5546\u52A1\u3001\u6295\u8D44\u3001\u9000\u4F11\u548C\u5176\u4ED6\u76EE\u7684\u6765\u6CF0\u56FD\uFF0C\u5176\u4E2D\u5305\u62EC\uFF1A"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u5728\u6CF0\u56FD\u6CE8\u518C\u6559\u80B2\u673A\u6784\u5C31\u8BFB\u65F6\u7684\u6559\u80B2\u7B7E\u8BC1"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u7ECF\u8425\u4F01\u4E1A\u65F6\u7684\u5546\u52A1\u7B7E\u8BC1"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u9000\u4F11\u7B7E\u8BC1\uFF0C\u9002\u7528\u4E8E\u5E74\u9F84\u572850\u5C81\u621650\u5C81\u4EE5\u4E0A\u5E76\u6EE1\u8DB3\u8D22\u52A1\u8981\u6C42\u7684\u4EBA"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u5A5A\u59FB\u7B7E\u8BC1\uFF0C\u9002\u7528\u4E8E\u4E0E\u6CF0\u56FD\u4EBA\u7ED3\u5A5A\u7684\u5916\u56FD\u4EBA"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u6CF0\u56FD\u7CBE\u82F1\u7B7E\u8BC1\uFF0C\u4E00\u4E2A\u653F\u5E9C\u4E3B\u5BFC\u9879\u76EE\uFF0C\u63D0\u4F9B\u5305\u542B5\u5E74\u7B7E\u8BC1\u7684\u4F1A\u5458\u8D44\u683C")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u8BF7\u54A8\u8BE2\u79FB\u6C11\u4E13\u5BB6\u6216\u6CF0\u56FD\u5927\u4F7F\u9986/\u9886\u4E8B\u9986\u4E86\u89E3\u66F4\u591A\u4FE1\u606F\u3002"))}},// ====================================================================== //
{categoryId:2,question:{en:"Types and number of units for sale?",ru:"Каковы типы и количество квартир на продажу?",cn:"待售单元的种类和数量如何？"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"The development includes four (4) low-rise condominium buildings comprising a total of approximately 185 units. One, two and three bedroom configurations are available ranging in size from 59 \u2013 131 square metres.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041F\u0440\u043E\u0435\u043A\u0442 \u0432\u043A\u043B\u044E\u0447\u0430\u0435\u0442 \u0447\u0435\u0442\u044B\u0440\u0435 (4) \u043C\u0430\u043B\u043E\u044D\u0442\u0430\u0436\u043D\u044B\u0445 \u0437\u0434\u0430\u043D\u0438\u044F-\u043A\u043E\u043D\u0434\u043E\u043C\u0438\u043D\u0438\u0443\u043C\u0430 \u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u043D\u0430 185 \u043A\u0432\u0430\u0440\u0442\u0438\u0440. \u0414\u043E\u0441\u0442\u0443\u043F\u043D\u044B \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u044B \u0441 \u043E\u0434\u043D\u043E\u0439, \u0434\u0432\u0443\u043C\u044F \u0438 \u0442\u0440\u0435\u043C\u044F \u0441\u043F\u0430\u043B\u044C\u043D\u044F\u043C\u0438 \u043F\u043B\u043E\u0449\u0430\u0434\u044C\u044E \u043E\u0442 59 \u0434\u043E 131 \u043A\u0432\u0430\u0434\u0440\u0430\u0442\u043D\u044B\u0445 \u043C\u0435\u0442\u0440\u043E\u0432.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u8BE5\u9879\u76EE\u5305\u62EC\u56DB\u680B\u4F4E\u5C42\u516C\u5BD3\u697C\uFF0C\u5171\u5305\u542B\u7EA6185\u4E2A\u5355\u5143\u3002\u4E00\u5367\u5BA4\u3001\u4E24\u5367\u5BA4\u548C\u4E09\u5367\u5BA4\u516C\u5BD3\u7684\u9762\u79EF\u4ECE 59-131\u5E73\u65B9\u7C73\u4E0D\u7B49\u3002"))}},{categoryId:2,question:{en:"How long does construction take?",ru:"Сколько времени занимает строительство?",cn:"建筑施工需要多长时间？"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Construction can only commence once the relevant government environmental and building approvals are obtained and is estimated to take approximately 20-24 months for each building to complete from the commencement date.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0421\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E \u043C\u043E\u0436\u0435\u0442 \u043D\u0430\u0447\u0430\u0442\u044C\u0441\u044F \u0442\u043E\u043B\u044C\u043A\u043E \u043F\u043E\u0441\u043B\u0435 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0445 \u0433\u043E\u0441\u0443\u0434\u0430\u0440\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u0445 \u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u0438\u0439 \u043F\u0440\u0438\u0440\u043E\u0434\u043E\u043E\u0445\u0440\u0430\u043D\u043D\u044B\u0445 \u043E\u0440\u0433\u0430\u043D\u043E\u0432 \u0438 \u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u0438\u0439 \u043D\u0430 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0435 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0445 \u0440\u0430\u0431\u043E\u0442. \u041F\u0440\u0435\u0434\u0432\u0430\u0440\u0438\u0442\u0435\u043B\u044C\u043D\u043E, \u043D\u0430 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E \u043A\u0430\u0436\u0434\u043E\u0433\u043E \u0437\u0434\u0430\u043D\u0438\u044F \u0441 \u0434\u0430\u0442\u044B \u043D\u0430\u0447\u0430\u043B\u0430 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 \u043F\u043E\u0442\u0440\u0435\u0431\u0443\u0435\u0442\u0441\u044F \u043F\u0440\u0438\u043C\u0435\u0440\u043D\u043E \u043E\u0442 20 \u0434\u043E 24 \u043C\u0435\u0441\u044F\u0446\u0435\u0432.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u7B54.\u5728\u83B7\u5F97\u76F8\u5173\u7684\u653F\u5E9C\u73AF\u5883\u548C\u5EFA\u7B51\u6279\u51C6\u540E\u624D\u80FD\u5F00\u59CB\u65BD\u5DE5\u3002\u4ECE\u5F00\u5DE5\u65E5\u671F\u5F00\u59CB\uFF0C\u6BCF\u680B\u5EFA\u7B51\u4F30\u8BA1\u9700\u8981\u5927\u7EA620-24\u4E2A\u6708\u7684\u65F6\u95F4\u5B8C\u6210\u3002"))}},{categoryId:2,question:{en:"Is a warranty period offered?",ru:"Имеется ли гарантийный срок?",cn:"提供保修期吗？"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Yes. A five (5) year building structure warranty is offered from the date of completion of construction. Warranties on materials and furnishings will be subject to a one (1) year warranty."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"*Subject to exclusion under contract and law.")))),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0414\u0430. \u0413\u0430\u0440\u0430\u043D\u0442\u0438\u044F \u043D\u0430 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u043D\u0443\u044E \u043A\u043E\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0438\u044E \u0441\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 5 (\u043F\u044F\u0442\u044C) \u043B\u0435\u0442 \u0441 \u0434\u0430\u0442\u044B \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430. \u0413\u0430\u0440\u0430\u043D\u0442\u0438\u044F \u043D\u0430 \u043C\u0430\u0442\u0435\u0440\u0438\u0430\u043B\u044B \u0438 \u043C\u0435\u0431\u0435\u043B\u044C \u0441\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 1 (\u043E\u0434\u0438\u043D) \u0433\u043E\u0434."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"*\u0417\u0430 \u0438\u0441\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435\u043C \u0441\u043B\u0443\u0447\u0430\u0435\u0432, \u043F\u0440\u0435\u0434\u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u043D\u044B\u0445 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u043E\u043C \u0438 \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E\u043C.")))),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u662F\u7684\u3002\u81EA\u7AE3\u5DE5\u4E4B\u65E5\u8D77\uFF0C\u63D0\u4F9B\u4E3A\u671F\u4E94\u5E74\u7684\u5EFA\u7B51\u7ED3\u6784\u4FDD\u4FEE\u3002\u6750\u6599\u548C\u5BB6\u5177\u7684\u4FDD\u4FEE\u671F\u4E3A\u4E00\u5E74\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"*\u53D7\u5408\u540C\u548C\u6CD5\u5F8B\u89C4\u5B9A\u7684\u9664\u5916\u8D23\u4EFB\u7EA6\u675F\u3002"))))}},{categoryId:2,question:{en:"What is included in the property?",ru:"Что включено в приобретаемую недвижимость?",cn:"房产内包含什么？"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Basic fit-out option includes flooring, walls, sanitary ware, kitchen bench, sink, air-conditioning. Fitted option includes fixed furnishings (wardrobes, kitchen cabinets and built-in kitchen appliances, etc). Furnished option includes loose furniture and amenities (beds, sofa, dining table and chairs, curtains, fridge, microwave, etc).")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0412 \u0431\u0430\u0437\u043E\u0432\u0443\u044E \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0430\u0446\u0438\u044E \u0432\u0445\u043E\u0434\u044F\u0442 \u0447\u0438\u0441\u0442\u043E\u0432\u0430\u044F \u043E\u0442\u0434\u0435\u043B\u043A\u0430 \u043F\u043E\u043B\u043E\u0432 \u0438 \u0441\u0442\u0435\u043D, \u0441\u0430\u043D\u0442\u0435\u0445\u043D\u0438\u043A\u0430, \u043A\u0443\u0445\u043E\u043D\u043D\u0430\u044F \u0441\u0442\u043E\u043B\u0435\u0448\u043D\u0438\u0446\u0430, \u0440\u0430\u043A\u043E\u0432\u0438\u043D\u0430, \u043A\u043E\u043D\u0434\u0438\u0446\u0438\u043E\u043D\u0435\u0440. \u0414\u0430\u043B\u0435\u0435 \u0438\u0434\u0435\u0442 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0430\u0446\u0438\u044F, \u0432\u043A\u043B\u044E\u0447\u0430\u044E\u0449\u0430\u044F \u0432\u0441\u0442\u0440\u043E\u0435\u043D\u043D\u0443\u044E \u043C\u0435\u0431\u0435\u043B\u044C \u0438 \u0442\u0435\u0445\u043D\u0438\u043A\u0443 (\u0433\u0430\u0440\u0434\u0435\u0440\u043E\u0431\u044B, \u043A\u0443\u0445\u043E\u043D\u043D\u044B\u0435 \u0433\u0430\u0440\u043D\u0438\u0442\u0443\u0440\u044B, \u0432\u0441\u0442\u0440\u043E\u0435\u043D\u043D\u043E\u0435 \u043A\u0443\u0445\u043E\u043D\u043D\u043E\u0435 \u043E\u0431\u043E\u0440\u0443\u0434\u043E\u0432\u0430\u043D\u0438\u0435 \u0438 \u0442. \u043F.). \u041A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u0430\u0446\u0438\u044F \u043F\u043E\u0434 \u043A\u043B\u044E\u0447 \u0432\u043A\u043B\u044E\u0447\u0430\u0435\u0442 \u0441\u0432\u043E\u0431\u043E\u0434\u043D\u043E \u0441\u0442\u043E\u044F\u0449\u0443\u044E \u043C\u0435\u0431\u0435\u043B\u044C \u0438 \u043F\u0440\u0435\u0434\u043C\u0435\u0442\u044B \u0434\u043E\u043C\u0430\u0448\u043D\u0435\u0433\u043E \u0431\u044B\u0442\u0430 (\u043A\u0440\u043E\u0432\u0430\u0442\u0438, \u0434\u0438\u0432\u0430\u043D, \u043E\u0431\u0435\u0434\u0435\u043D\u043D\u044B\u0439 \u0441\u0442\u043E\u043B \u0438 \u0441\u0442\u0443\u043B\u044C\u044F, \u0448\u0442\u043E\u0440\u044B, \u0445\u043E\u043B\u043E\u0434\u0438\u043B\u044C\u043D\u0438\u043A, \u043C\u0438\u043A\u0440\u043E\u0432\u043E\u043B\u043D\u043E\u0432\u0430\u044F \u043F\u0435\u0447\u044C \u0438 \u0442. \u043F.).")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u7B80\u88C5\u9009\u9879\u5305\u62EC\u5730\u677F\u3001\u5899\u58C1\u3001\u536B\u751F\u6D01\u5177\u3001\u53A8\u623F\u5DE5\u4F5C\u53F0\u3001\u6C34\u69FD\u3001\u7A7A\u8C03\u3002\u7CBE\u88C5\u9009\u9879\u5305\u62EC\u56FA\u5B9A\u5BB6\u5177\uFF08\u8863\u67DC\u3001\u53A8\u623F\u6A71\u67DC\u548C\u5D4C\u5165\u5F0F\u53A8\u623F\u7535\u5668\u7B49\uFF09\u3002\u5168\u88C5\u5168\u914D\u9009\u9879\u5305\u62EC\u53EF\u79FB\u52A8\u5BB6\u5177\u548C\u8BBE\u65BD\uFF08\u5E8A\u3001\u6C99\u53D1\u3001\u9910\u684C\u548C\u6905\u5B50\u3001\u7A97\u5E18\u3001\u51B0\u7BB1\u3001\u5FAE\u6CE2\u7089\u7B49\uFF09\u3002"))}},{categoryId:2,question:{en:"Is customization of the units allowed?",ru:"Разрешена ли перепланировка квартир?",cn:"允许定制单元吗？"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"There are two (2) interior design options available and another option to enclose the balcony. The building must be built in accordance with building code and permits as issued by the relevant authorities so no changes to the external areas or structural items are permitted.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u044B 2 (\u0434\u0432\u0430) \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0430 \u0432\u043D\u0443\u0442\u0440\u0435\u043D\u043D\u0435\u0439 \u043F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u043A\u0438 \u0438 \u0435\u0449\u0435 \u043E\u0434\u0438\u043D \u0432\u0430\u0440\u0438\u0430\u043D\u0442, \u0432\u043A\u043B\u044E\u0447\u0430\u044E\u0449\u0438\u0439 \u0431\u0430\u043B\u043A\u043E\u043D. \u0417\u0434\u0430\u043D\u0438\u0435 \u0434\u043E\u043B\u0436\u043D\u043E \u0441\u0442\u0440\u043E\u0438\u0442\u044C\u0441\u044F \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441\u043E \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u043C\u0438 \u043D\u043E\u0440\u043C\u0430\u043C\u0438 \u0438 \u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u0438\u044F\u043C\u0438, \u0432\u044B\u0434\u0430\u043D\u043D\u044B\u043C\u0438 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u043C\u0438 \u043E\u0440\u0433\u0430\u043D\u0430\u043C\u0438, \u043F\u043E\u044D\u0442\u043E\u043C\u0443 \u043D\u0438\u043A\u0430\u043A\u0438\u0435 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u0432\u043D\u0435\u0448\u043D\u0438\u0445 \u0443\u0447\u0430\u0441\u0442\u043A\u043E\u0432 \u0438\u043B\u0438 \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u043E\u0432 \u043A\u043E\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0438\u0438 \u043D\u0435 \u0434\u043E\u043F\u0443\u0441\u043A\u0430\u044E\u0442\u0441\u044F.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u6709\u4E24\u79CD\u5BA4\u5185\u8BBE\u8BA1\u53EF\u4F9B\u9009\u62E9\uFF0C\u53E6\u53EF\u5C01\u95ED\u9633\u53F0\u3002\u5EFA\u7B51\u5FC5\u987B\u6309\u7167\u5EFA\u7B51\u89C4\u8303\u548C\u76F8\u5173\u90E8\u95E8\u9881\u53D1\u7684\u8BB8\u53EF\u8BC1\u5EFA\u9020\uFF0C\u56E0\u6B64\u5916\u90E8\u533A\u57DF\u6216\u7ED3\u6784\u9879\u76EE\u4E0D\u5F97\u66F4\u6539\u3002"))}},// ====================================================================== //
{categoryId:3,question:{en:"What infrastructure and common facilities are provided and who will manage these?",ru:"Что входит в инфраструктуру и общие объекты и кто будет ими управлять?",cn:"提供哪些基础设施和公共设施，由谁来管理？"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"The infrastructure and common facilities includes roads and drainage, lighting, landscape areas, swimming pools, deck areas and water and electricity supplies. Services shall include 24 hours on-site security, garbage collection, cleaning and maintenance of infrastructure and common facilities or any other services as required for the common use or benefit of owners. In addition, owners will be entitled to access certain amenities including the shuttle bus service. The condominium manager shall be Laguna (or its designated manager).")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0418\u043D\u0444\u0440\u0430\u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u0430 \u0438 \u043E\u0431\u0449\u0438\u0435 \u043E\u0431\u044A\u0435\u043A\u0442\u044B \u0432\u043A\u043B\u044E\u0447\u0430\u044E\u0442 \u0434\u043E\u0440\u043E\u0433\u0438 \u0438 \u043A\u0430\u043D\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u044E, \u043E\u0441\u0432\u0435\u0449\u0435\u043D\u0438\u0435, \u043B\u0430\u043D\u0434\u0448\u0430\u0444\u0442\u043D\u044B\u0435 \u0437\u043E\u043D\u044B, \u0431\u0430\u0441\u0441\u0435\u0439\u043D\u044B, \u0442\u0435\u0440\u0440\u0430\u0441\u044B, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0432\u043E\u0434\u043E- \u0438 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u0441\u043D\u0430\u0431\u0436\u0435\u043D\u0438\u0435. \u0423\u0441\u043B\u0443\u0433\u0438 \u0432\u043A\u043B\u044E\u0447\u0430\u044E\u0442 \u043A\u0440\u0443\u0433\u043B\u043E\u0441\u0443\u0442\u043E\u0447\u043D\u0443\u044E \u043E\u0445\u0440\u0430\u043D\u0443 \u0432 \u043C\u0435\u0441\u0442\u0435 \u043E\u0431\u044A\u0435\u043A\u0442\u0430, \u0432\u044B\u0432\u043E\u0437 \u043C\u0443\u0441\u043E\u0440\u0430, \u0443\u0431\u043E\u0440\u043A\u0443 \u0438 \u043E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u043D\u0438\u0435 \u0438\u043D\u0444\u0440\u0430\u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u044B \u0438 \u043E\u0431\u0449\u0438\u0445 \u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0432\u0441\u0435 \u0434\u0440\u0443\u0433\u0438\u0435 \u0443\u0441\u043B\u0443\u0433\u0438, \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u044B\u0435 \u0434\u043B\u044F \u043E\u0431\u0449\u0435\u0433\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0438\u043B\u0438 \u0432\u044B\u0433\u043E\u0434 \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0435\u0432. \u0422\u0430\u043A\u0436\u0435 \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u044B \u0438\u043C\u0435\u044E\u0442 \u043F\u0440\u0430\u0432\u043E \u043D\u0430 \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u044B\u043C \u0443\u0434\u043E\u0431\u0441\u0442\u0432\u0430\u043C, \u0432\u043A\u043B\u044E\u0447\u0430\u044F \u0443\u0441\u043B\u0443\u0433\u0438 \u0432\u043D\u0443\u0442\u0440\u0435\u043D\u043D\u0435\u0433\u043E \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0430 \u043A\u0443\u0440\u043E\u0440\u0442\u0430. \u0423\u043F\u0440\u0430\u0432\u043B\u044F\u044E\u0449\u0438\u043C \u043A\u043E\u043D\u0434\u043E\u043C\u0438\u043D\u0438\u0443\u043C\u043E\u043C \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F Laguna (\u0438\u043B\u0438 \u043D\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044B\u0439 \u0435\u044E \u0443\u043F\u0440\u0430\u0432\u043B\u044F\u044E\u0449\u0438\u0439).")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u57FA\u7840\u8BBE\u65BD\u548C\u516C\u7528\u8BBE\u65BD\u5305\u62EC\u9053\u8DEF\u548C\u6392\u6C34\u3001\u7167\u660E\u3001\u666F\u89C2\u533A\u3001\u6E38\u6CF3\u6C60\u3001\u7532\u677F\u533A\u3001\u6C34\u7535\u4F9B\u5E94\u7B49\u3002\u670D\u52A1\u5305\u62EC24\u5C0F\u65F6\u73B0\u573A\u4FDD\u5B89\u3001\u5783\u573E\u6536\u96C6\u3001\u57FA\u7840\u8BBE\u65BD\u548C\u516C\u5171\u8BBE\u65BD\u7684\u6E05\u6D01\u548C\u7EF4\u62A4\u6216\u4E3A\u4E1A\u4E3B\u7684\u5171\u540C\u4F7F\u7528\u6216\u5229\u76CA\u6240\u9700\u7684\u4EFB\u4F55\u5176\u4ED6\u670D\u52A1\u3002\u6B64\u5916\uFF0C\u4E1A\u4E3B\u5C06\u6709\u6743\u4F7F\u7528\u6307\u5B9A\u8BBE\u65BD\uFF0C\u5305\u62EC\u73ED\u8F66\u670D\u52A1\u3002\u516C\u5BD3\u7BA1\u7406\u4EBA\u4E3A\u4E50\u53E4\u6D6A\uFF08\u6216\u5176\u6307\u5B9A\u7684\u7BA1\u7406\u4EBA\uFF09\u3002"))}},{categoryId:3,question:{en:"What are the estimated fees payable for the infrastructure, common facilities and services provided?",ru:"Каков ориентировочный размер платы за пользование инфраструктурой, общими объектами и услугами?",cn:"针对提供的基础设施、公共设施和服务，需支付的估计费用是多少？"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"The fees for the cost of maintenance for the infrastructure, common facilities, services provided (\u201Ccommon area fee\u201D) and maintenance fees towards other services and facilities supplied to the condominium \u201Cnon-common area fees\u2019 in aggregate shall be Baht 50 per square metre per month for the initial year and may be subject to change based upon the actual expenses incurred from time to time. The annual fees are determined by the total expenses incurred and proportionately divided amongst the sellable area of the units in the condominium."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"In addition, a fund shall be established for the cost of major repairs, replacement and/or improvement for the infrastructure and common facilities (\u201Cspecial fund\u201D). Contributions will be made on a regular basis so that the fund is built up over time. The rate shall be Baht 100 per square metre per year for the initial year and may be subject to change. If the fund balance is not sufficient for the cost of major repairs, owners may be required to pay an additional amount as requested by the manager from time to time."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"The cost of water and electricity supplied to individual condominiums shall be based upon metered consumption.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041F\u043B\u0430\u0442\u0430 \u0437\u0430 \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u0438\u0435 \u0438\u043D\u0444\u0440\u0430\u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u044B \u0438 \u043C\u0435\u0441\u0442 \u043E\u0431\u0449\u0435\u0433\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F, \u0430 \u0442\u0430\u043A\u0436\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0443\u0441\u043B\u0443\u0433 (\u0434\u0430\u043B\u0435\u0435 \u2014 \xAB\u043F\u043B\u0430\u0442\u0430 \u0437\u0430 \u0442\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u044E \u043E\u0431\u0449\u0435\u0433\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F\xBB) \u0438 \u043F\u043B\u0430\u0442\u0430 \u0437\u0430 \u0434\u0440\u0443\u0433\u0438\u0435 \u0443\u0441\u043B\u0443\u0433\u0438 \u0438 \u0443\u0434\u043E\u0431\u0441\u0442\u0432\u0430, \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u043C\u044B\u0435 \u043A\u043E\u043D\u0434\u043E\u043C\u0438\u043D\u0438\u0443\u043C\u0443 (\u0434\u0430\u043B\u0435\u0435 \xAB\u043F\u043B\u0430\u0442\u0430 \u0437\u0430 \u0442\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u044E, \u043D\u0435 \u0432\u0445\u043E\u0434\u044F\u0449\u0443\u044E \u0432 \u043E\u0431\u0449\u0435\u0435 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\xBB) \u0432 \u0441\u043E\u0432\u043E\u043A\u0443\u043F\u043D\u043E\u0441\u0442\u0438 \u0441\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 50 \u0431\u0430\u0442\u043E\u0432 \u0437\u0430 \u043E\u0434\u0438\u043D \u043A\u0432\u0430\u0434\u0440\u0430\u0442\u043D\u044B\u0439 \u043C\u0435\u0442\u0440 \u0432 \u043C\u0435\u0441\u044F\u0446 \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 \u043F\u0435\u0440\u0432\u043E\u0433\u043E \u0433\u043E\u0434\u0430. \u0415\u0435 \u0440\u0430\u0437\u043C\u0435\u0440 \u043C\u043E\u0436\u0435\u0442 \u043F\u0435\u0440\u0438\u043E\u0434\u0438\u0447\u0435\u0441\u043A\u0438 \u043F\u0435\u0440\u0435\u0441\u043C\u0430\u0442\u0440\u0438\u0432\u0430\u0442\u044C\u0441\u044F \u0432 \u0437\u0430\u0432\u0438\u0441\u0438\u043C\u043E\u0441\u0442\u0438 \u043E\u0442 \u0444\u0430\u043A\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u0445 \u0440\u0430\u0441\u0445\u043E\u0434\u043E\u0432. \u0415\u0436\u0435\u0433\u043E\u0434\u043D\u044B\u0439 \u0440\u0430\u0437\u043C\u0435\u0440 \u043F\u043B\u0430\u0442\u044B \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u044F\u0435\u0442\u0441\u044F \u043E\u0431\u0449\u0435\u0439 \u0441\u0443\u043C\u043C\u043E\u0439 \u043F\u043E\u043D\u0435\u0441\u0435\u043D\u043D\u044B\u0445 \u0440\u0430\u0441\u0445\u043E\u0434\u043E\u0432 \u0438 \u043F\u0440\u043E\u043F\u043E\u0440\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u043E \u0440\u0430\u0441\u043F\u0440\u0435\u0434\u0435\u043B\u044F\u0435\u0442\u0441\u044F \u043C\u0435\u0436\u0434\u0443 \u043F\u0440\u043E\u0434\u0430\u0432\u0430\u0435\u043C\u043E\u0439 \u043F\u043B\u043E\u0449\u0430\u0434\u044C\u044E \u043A\u0432\u0430\u0440\u0442\u0438\u0440 \u0432 \u043A\u043E\u043D\u0434\u043E\u043C\u0438\u043D\u0438\u0443\u043C\u0435."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041A\u0440\u043E\u043C\u0435 \u0442\u043E\u0433\u043E, \u0441\u043E\u0437\u0434\u0430\u0435\u0442\u0441\u044F \u0444\u043E\u043D\u0434 \u0434\u043B\u044F \u043F\u043E\u043A\u0440\u044B\u0442\u0438\u044F \u0437\u0430\u0442\u0440\u0430\u0442 \u043D\u0430 \u043A\u0430\u043F\u0438\u0442\u0430\u043B\u044C\u043D\u044B\u0439 \u0440\u0435\u043C\u043E\u043D\u0442, \u0437\u0430\u043C\u0435\u043D\u0443 \u0438 (\u0438\u043B\u0438) \u0443\u043B\u0443\u0447\u0448\u0435\u043D\u0438\u0435 \u0438\u043D\u0444\u0440\u0430\u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u044B \u0438 \u043E\u0431\u0449\u0438\u0445 \u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432 (\u0434\u0430\u043B\u0435\u0435 \u2014 \xAB\u0441\u043F\u0435\u0446\u0438\u0430\u043B\u044C\u043D\u044B\u0439 \u0444\u043E\u043D\u0434\xBB). \u0412\u0437\u043D\u043E\u0441\u044B \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u044E\u0442\u0441\u044F \u043D\u0430 \u0440\u0435\u0433\u0443\u043B\u044F\u0440\u043D\u043E\u0439 \u043E\u0441\u043D\u043E\u0432\u0435 \u0441 \u0446\u0435\u043B\u044C\u044E \u043F\u043E\u0441\u0442\u0435\u043F\u0435\u043D\u043D\u043E\u0433\u043E \u043D\u0430\u043A\u043E\u043F\u043B\u0435\u043D\u0438\u044F \u0441\u0440\u0435\u0434\u0441\u0442\u0432 \u0444\u043E\u043D\u0434\u043E\u043C. \u0420\u0430\u0437\u043C\u0435\u0440 \u043F\u043B\u0430\u0442\u044B \u0441\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 100 \u0431\u0430\u0442 \u0437\u0430 \u043E\u0434\u0438\u043D \u043A\u0432\u0430\u0434\u0440\u0430\u0442\u043D\u044B\u0439 \u043C\u0435\u0442\u0440 \u0432 \u0433\u043E\u0434 \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 \u043F\u0435\u0440\u0432\u043E\u0433\u043E \u0433\u043E\u0434\u0430 \u0438 \u043C\u043E\u0436\u0435\u0442 \u043F\u0435\u0440\u0435\u0441\u043C\u0430\u0442\u0440\u0438\u0432\u0430\u0442\u044C\u0441\u044F. \u0415\u0441\u043B\u0438 \u043E\u0441\u0442\u0430\u0442\u043A\u0430 \u0441\u0440\u0435\u0434\u0441\u0442\u0432 \u0444\u043E\u043D\u0434\u0430 \u043D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043E\u0447\u043D\u043E \u0434\u043B\u044F \u043F\u043E\u043A\u0440\u044B\u0442\u0438\u044F \u0437\u0430\u0442\u0440\u0430\u0442 \u043D\u0430 \u043A\u0430\u043F\u0438\u0442\u0430\u043B\u044C\u043D\u044B\u0439 \u0440\u0435\u043C\u043E\u043D\u0442, \u0443\u043F\u0440\u0430\u0432\u043B\u044F\u044E\u0449\u0438\u0439 \u043F\u0435\u0440\u0438\u043E\u0434\u0438\u0447\u0435\u0441\u043A\u0438 \u043C\u043E\u0436\u0435\u0442 \u0442\u0440\u0435\u0431\u043E\u0432\u0430\u0442\u044C \u043E\u0442 \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u0438\u043A\u043E\u0432 \u0432\u043D\u0435\u0441\u0435\u043D\u0438\u044F \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0445 \u0441\u0443\u043C\u043C."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0421\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C \u0432\u043E\u0434\u044B \u0438 \u044D\u043B\u0435\u043A\u0442\u0440\u0438\u0447\u0435\u0441\u0442\u0432\u0430, \u043F\u043E\u0442\u0440\u0435\u0431\u043B\u044F\u0435\u043C\u044B\u0435 \u043E\u0442\u0434\u0435\u043B\u044C\u043D\u044B\u043C\u0438 \u043A\u0432\u0430\u0440\u0442\u0438\u0440\u0430\u043C\u0438 \u0432\u0437\u0438\u043C\u0430\u0435\u0442\u0441\u044F \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u043F\u043E\u043A\u0430\u0437\u0430\u043D\u0438\u044F\u043C\u0438 \u0441\u0447\u0435\u0442\u0447\u0438\u043A\u043E\u0432.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u9488\u5BF9\u63D0\u4F9B\u7684\u57FA\u7840\u8BBE\u65BD\u3001\u516C\u7528\u8BBE\u65BD\u3001\u670D\u52A1\u7684\u7EF4\u62A4\u8D39\u7528\uFF08\u201C\u516C\u5171\u533A\u57DF\u8D39\u201D\uFF09\u4EE5\u53CA\u9488\u5BF9\u63D0\u4F9B\u7ED9\u516C\u5BD3\u7684\u5176\u4ED6\u670D\u52A1\u548C\u8BBE\u65BD\u7684\u7EF4\u62A4\u8D39\u7528\uFF08\u201C\u975E\u516C\u5171\u533A\u57DF\u8D39\u201D\uFF09\uFF0C\u521D\u59CB\u5E74\u5408\u8BA1\u4E3A\u6BCF\u6708\u6BCF\u5E73\u65B9\u7C7350\u6CF0\u94E2\uFF0C\u53EF\u80FD\u4F1A\u6839\u636E\u5B9E\u9645\u652F\u51FA\u53D8\u52A8\u3002\u6BCF\u5E74\u8D39\u7528\u7531\u6240\u53D1\u751F\u7684\u603B\u652F\u51FA\u51B3\u5B9A\uFF0C\u5E76\u6309\u6BD4\u4F8B\u5728\u516C\u5BD3\u5355\u5143\u7684\u53EF\u552E\u9762\u79EF\u4E2D\u5206\u644A\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u6B64\u5916\uFF0C\u8FD8\u4E3A\u57FA\u7840\u8BBE\u65BD\u548C\u516C\u5171\u8BBE\u65BD\u7684\u5927\u4FEE\u3001\u66F4\u6362\u548C/\u6216\u6539\u8FDB\u8D39\u7528\u8BBE\u7ACB\u57FA\u91D1\uFF08\u201C\u7279\u522B\u57FA\u91D1\u201D\uFF09\u3002\u5C06\u5B9A\u671F\u7F34\u6B3E\uFF0C\u4EE5\u4FBF\u57FA\u91D1\u9010\u6B65\u5EFA\u7ACB\u3002\u521D\u59CB\u5E74\u7684\u8D39\u7387\u4E3A\u6BCF\u5E74\u6BCF\u5E73\u65B9\u7C73100\u6CF0\u94E2\uFF0C\u53EF\u80FD\u4F1A\u6709\u53D8\u52A8\u3002\u5982\u57FA\u91D1\u4F59\u989D\u4E0D\u8DB3\u4EE5\u652F\u4ED8\u5927\u4FEE\u8D39\u7528\uFF0C\u4E1A\u4E3B\u53EF\u80FD\u987B\u6309\u7BA1\u7406\u4EBA\u4E0D\u65F6\u7684\u8981\u6C42\u652F\u4ED8\u989D\u5916\u6B3E\u9879\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u5355\u4E2A\u516C\u5BD3\u7684\u6C34\u7535\u8D39\u6309\u7528\u91CF\u8BA1\u7B97\u3002"))}},{categoryId:3,question:{en:"What property management services are provided?",ru:"Какие услуги по управлению объектами недвижимости предоставляются?",cn:"提供哪些物业管理服务？"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Laguna Property Management and/or Laguna Beachside Phuket hospitality team will provide a full range of property services to individual owners including, pest control, routine and preventative maintenance, general repairs, housekeeping and other reasonable requests. Rates vary according to the frequency and scope of service. In addition, Laguna Rentals and/or Laguna Beachside Phuket hospitality team provides owners with the ability to generate a rental income from their property with short-term* and long-term rentals (see below).")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u044E\u0449\u0438\u0439 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B Laguna Property Management \u0438 (\u0438\u043B\u0438) Laguna Beachside Phuket \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0430\u043C \u043F\u043E\u043B\u043D\u044B\u0439 \u043D\u0430\u0431\u043E\u0440 \u0443\u0441\u043B\u0443\u0433 \u043F\u043E \u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044E \u043E\u0431\u044A\u0435\u043A\u0442\u0430\u043C\u0438 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u0438, \u0432\u043A\u043B\u044E\u0447\u0430\u044F \u0431\u043E\u0440\u044C\u0431\u0443 \u0441 \u0432\u0440\u0435\u0434\u0438\u0442\u0435\u043B\u044F\u043C\u0438, \u0442\u0435\u043A\u0443\u0449\u0435\u0435 \u0438 \u043F\u0440\u043E\u0444\u0438\u043B\u0430\u043A\u0442\u0438\u0447\u0435\u0441\u043A\u043E\u0435 \u043E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u043D\u0438\u0435, \u043E\u0431\u0449\u0438\u0439 \u0440\u0435\u043C\u043E\u043D\u0442, \u0443\u0431\u043E\u0440\u043A\u0443 \u0438 \u0443\u0434\u043E\u0432\u043B\u0435\u0442\u0432\u043E\u0440\u0435\u043D\u0438\u0435 \u0434\u0440\u0443\u0433\u0438\u0445 \u043E\u0431\u043E\u0441\u043D\u043E\u0432\u0430\u043D\u043D\u044B\u0445 \u0437\u0430\u043F\u0440\u043E\u0441\u043E\u0432. \u0420\u0430\u0437\u043C\u0435\u0440 \u043F\u043B\u0430\u0442\u044B \u0432\u0430\u0440\u044C\u0438\u0440\u0443\u0435\u0442\u0441\u044F \u0432 \u0437\u0430\u0432\u0438\u0441\u0438\u043C\u043E\u0441\u0442\u0438 \u043E\u0442 \u0447\u0430\u0441\u0442\u043E\u0442\u044B \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u044F \u0443\u0441\u043B\u0443\u0433 \u0438 \u0438\u0445 \u043E\u0431\u044A\u0435\u043C\u0430. \u0422\u0430\u043A\u0436\u0435 \u043E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u044E\u0449\u0438\u0439 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B Laguna Rentals \u0438 (\u0438\u043B\u0438) Laguna Beachside Phuket \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0430\u043C \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u044C \u043F\u043E\u043B\u0443\u0447\u0430\u0442\u044C \u0434\u043E\u0445\u043E\u0434 \u043E\u0442 \u0430\u0440\u0435\u043D\u0434\u044B \u0438\u0445 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u0438 \u043F\u043E\u0441\u0440\u0435\u0434\u0441\u0442\u0432\u043E\u043C \u043A\u0440\u0430\u0442\u043A\u043E\u0441\u0440\u043E\u0447\u043D\u043E\u0439* \u0438 \u0434\u043E\u043B\u0433\u043E\u0441\u0440\u043E\u0447\u043D\u043E\u0439 \u0430\u0440\u0435\u043D\u0434\u044B (\u0441\u043C. \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E \u043D\u0438\u0436\u0435).")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u4E50\u53E4\u6D6A\u7269\u4E1A\u7BA1\u7406\u548C/\u6216\u4E50\u53E4\u6D6A\u60A6\u6D77\u82D1\u63A5\u5F85\u56E2\u961F\u5C06\u4E3A\u5355\u4E2A\u4E1A\u4E3B\u63D0\u4F9B\u5168\u65B9\u4F4D\u7684\u7269\u4E1A\u670D\u52A1\uFF0C\u5305\u62EC\u866B\u5BB3\u9632\u6CBB\u3001\u4F8B\u884C\u548C\u9884\u9632\u6027\u7EF4\u62A4\u3001\u4E00\u822C\u7EF4\u4FEE\u3001\u5BB6\u653F\u548C\u5176\u4ED6\u5408\u7406\u8981\u6C42\u7684\u670D\u52A1\u3002\u6536\u8D39\u6839\u636E\u670D\u52A1\u7684\u9891\u7387\u548C\u8303\u56F4\u800C\u53D8\u5316\u3002\u6B64\u5916\uFF0C\u4E50\u53E4\u6D6A\u79DF\u8D41\u548C/\u6216\u4E50\u53E4\u6D6A\u60A6\u6D77\u82D1\u63A5\u5F85\u56E2\u961F\u53EF\u4F7F\u4E1A\u4E3B\u4ECE\u5176\u77ED\u671F*\u548C\u957F\u671F\u623F\u4EA7\u79DF\u8D41\u4E2D\u83B7\u53D6\u6536\u5165\uFF08\u89C1\u4E0B\u6587\uFF09\u3002"))}},{categoryId:3,question:{en:"Can I rent my unit out on my own?",ru:"Могу ли я сдать свою квартиру самостоятельно?",cn:"我可以自己把房子租出去吗？"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Yes, owners may rent out their property on a long-term basis (6 months or more) directly or through external agents."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"For short-term* rentals of 1 to 6 months, these must be conducted exclusively through Laguna Rentals who provides owners with the ability to generate a rental income from their property when not in residence with short-term and long-term rentals."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Any short-term* rentals of less than 30 days must be conducted exclusively through Laguna Beachside Phuket hospitality team (who will hold a hotel license) and will require the fully furnished option."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"* Terms and conditions apply")))),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0414\u0430, \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u0438\u043A\u0438 \u043C\u043E\u0433\u0443\u0442 \u0441\u0434\u0430\u0432\u0430\u0442\u044C \u0441\u0432\u043E\u044E \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u044C \u0432 \u0430\u0440\u0435\u043D\u0434\u0443 \u043D\u0430 \u0434\u043E\u043B\u0433\u043E\u0441\u0440\u043E\u0447\u043D\u043E\u0439 \u043E\u0441\u043D\u043E\u0432\u0435 (\u043D\u0430 6 \u0438 \u0431\u043E\u043B\u0435\u0435 \u043C\u0435\u0441\u044F\u0446\u0435\u0432) \u043D\u0430\u043F\u0440\u044F\u043C\u0443\u044E \u0438\u043B\u0438 \u0447\u0435\u0440\u0435\u0437 \u043F\u043E\u0441\u0440\u0435\u0434\u043D\u0438\u043A\u043E\u0432."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041F\u0440\u0438 \u043A\u0440\u0430\u0442\u043A\u043E\u0441\u0440\u043E\u0447\u043D\u043E\u0439* \u0430\u0440\u0435\u043D\u0434\u0435, \u0441\u0440\u043E\u043A \u043A\u043E\u0442\u043E\u0440\u043E\u0439 \u0441\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 \u043E\u0442 1 \u0434\u043E 6 \u043C\u0435\u0441\u044F\u0446\u0435\u0432, \u0430\u0440\u0435\u043D\u0434\u0430 \u0434\u043E\u043B\u0436\u043D\u0430 \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0442\u044C\u0441\u044F \u0438\u0441\u043A\u043B\u044E\u0447\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u044E Laguna Rentals, \u043A\u043E\u0442\u043E\u0440\u0430\u044F \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0430\u043C \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u044C \u043F\u043E\u043B\u0443\u0447\u0430\u0442\u044C \u0434\u043E\u0445\u043E\u0434 \u043E\u0442 \u0438\u0445 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u0438, \u043A\u043E\u0433\u0434\u0430 \u043E\u043D\u0438 \u043D\u0435 \u043F\u0440\u043E\u0436\u0438\u0432\u0430\u044E\u0442 \u0432 \u043D\u0435\u0439, \u0441\u0434\u0430\u0432\u0430\u044F \u0435\u0435 \u0432 \u0430\u0440\u0435\u043D\u0434\u0443 \u043D\u0430 \u043A\u043E\u0440\u043E\u0442\u043A\u0438\u0439 \u0438 \u0434\u043B\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u0441\u0440\u043E\u043A."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0421\u0434\u0430\u0447\u0430 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u0438 \u043D\u0430 \u043A\u043E\u0440\u043E\u0442\u043A\u0438\u0439* \u0441\u0440\u043E\u043A, \u0441\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u044E\u0449\u0438\u0439 \u043C\u0435\u043D\u0435\u0435 30 \u0434\u043D\u0435\u0439, \u0434\u043E\u043B\u0436\u043D\u0430 \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0442\u044C\u0441\u044F \u0438\u0441\u043A\u043B\u044E\u0447\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 \u043E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u044E\u0449\u0438\u0439 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B Laguna Beachside Phuket (\u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u0431\u0443\u0434\u0435\u0442 \u043E\u0431\u043B\u0430\u0434\u0430\u0442\u044C \u043B\u0438\u0446\u0435\u043D\u0437\u0438\u0435\u0439 \u043D\u0430 \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u0435\u043D\u0438\u0435 \u0433\u043E\u0441\u0442\u0438\u043D\u0438\u0447\u043D\u043E\u0439 \u0434\u0435\u044F\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u0438), \u043F\u0440\u0438 \u044D\u0442\u043E\u043C \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0439 \u043E\u0431\u044A\u0435\u043A\u0442 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u0438 \u0434\u043E\u043B\u0436\u0435\u043D \u0431\u044B\u0442\u044C \u0443\u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0442\u043E\u0432\u0430\u043D \u043F\u043E\u0434 \u043A\u043B\u044E\u0447."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"* \u0414\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0442 \u043F\u0440\u0430\u0432\u0438\u043B\u0430 \u0438 \u0443\u0441\u043B\u043E\u0432\u0438\u044F")))),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u53EF\u4EE5\uFF0C\u4E1A\u4E3B\u53EF\u4EE5\u76F4\u63A5\u6216\u901A\u8FC7\u5916\u90E8\u4E2D\u4ECB\u957F\u671F\uFF086\u4E2A\u6708\u6216\u4EE5\u4E0A\uFF09\u51FA\u79DF\u5176\u623F\u4EA7\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"1\u81F36\u4E2A\u6708\u7684\u77ED\u671F*\u79DF\u8D41\u5FC5\u987B\u5B8C\u5168\u901A\u8FC7\u4E50\u53E4\u6D6A\u79DF\u8D41\u8FDB\u884C\uFF0C\u8BE5\u90E8\u95E8\u53EF\u4F7F\u4E1A\u4E3B\u5728\u4E0D\u5C45\u4F4F\u65F6\u901A\u8FC7\u77ED\u671F\u548C\u957F\u671F\u79DF\u8D41\u83B7\u53D6\u79DF\u91D1\u6536\u5165\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u4EFB\u4F55\u5C11\u4E8E30\u5929\u7684\u77ED\u671F*\u79DF\u8D41\u5FC5\u987B\u901A\u8FC7\u4E50\u53E4\u6D6A\u60A6\u6D77\u82D1\u670D\u52A1\u56E2\u961F\uFF08\u8BE5\u56E2\u961F\u5C06\u6301\u6709\u9152\u5E97\u6267\u7167\uFF09\u72EC\u5BB6\u529E\u7406\uFF0C\u5E76\u9700\u9009\u62E9\u5168\u88C5\u5168\u914D\u9009\u9879\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"* \u9002\u7528\u6761\u6B3E\u548C\u6761\u4EF6"))))}},{categoryId:3,question:{en:"What are the taxes levied on rental income that an owner will be subject to?",ru:"Какие налоги взимаются с дохода от аренды, получаемого владельцем?",cn:"业主的租金收入需要缴纳什么税？"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Owners may be required to file an income tax return in Thailand based upon rental income earned and pay the applicable tax. Rental distributions made to owners may be subject to withholding tax under the Thai Revenue Code with rates ranging from 5 \u2013 15%, subject to owners tax structure status."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"Note: applicable tax rates are current at the date of issue of this FAQ and may be subject to changes. The unit owner shall be responsible for any income and any other taxes, duties and fees of whatever nature which may be levied by relevant authorities on the unit in connection with the rental.")))),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041E\u0442 \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0435\u0432 \u043C\u043E\u0436\u0435\u0442 \u043F\u043E\u0442\u0440\u0435\u0431\u043E\u0432\u0430\u0442\u044C\u0441\u044F \u043F\u043E\u0434\u0430\u0447\u0430 \u043D\u0430\u043B\u043E\u0433\u043E\u0432\u043E\u0439 \u0434\u0435\u043A\u043B\u0430\u0440\u0430\u0446\u0438\u0438 \u0432 \u0422\u0430\u0438\u043B\u0430\u043D\u0434\u0435 \u0441 \u0443\u043A\u0430\u0437\u0430\u043D\u0438\u0435\u043C \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u043D\u043E\u0433\u043E \u0434\u043E\u0445\u043E\u0434\u0430 \u043E\u0442 \u0430\u0440\u0435\u043D\u0434\u044B \u0438 \u0443\u043F\u043B\u0430\u0442\u043E\u0439 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0435\u0433\u043E \u043D\u0430\u043B\u043E\u0433\u0430. \u0412 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u043D\u0430\u043B\u043E\u0433\u043E\u0432\u044B\u043C \u043A\u043E\u0434\u0435\u043A\u0441\u043E\u043C \u0422\u0430\u0438\u043B\u0430\u043D\u0434\u0430 \u0432\u044B\u043F\u043B\u0430\u0442\u0430 \u0430\u0440\u0435\u043D\u0434\u043D\u043E\u0439 \u043F\u043B\u0430\u0442\u044B \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0430\u043C \u043C\u043E\u0436\u0435\u0442 \u043E\u0431\u043B\u0430\u0433\u0430\u0442\u044C\u0441\u044F \u043D\u0430\u043B\u043E\u0433\u043E\u043C, \u043F\u043E \u0441\u0442\u0430\u0432\u043A\u0435 \u043E\u0442 5 \u0434\u043E 15%, \u0432 \u0437\u0430\u0432\u0438\u0441\u0438\u043C\u043E\u0441\u0442\u0438 \u043E\u0442 \u043D\u0430\u043B\u043E\u0433\u043E\u0432\u043E\u0439 \u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u044B \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0430."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"\u041F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0435: \u043F\u0440\u0438\u043C\u0435\u043D\u0438\u043C\u044B\u0435 \u0441\u0442\u0430\u0432\u043A\u0438 \u043D\u0430\u043B\u043E\u0433\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u044B \u043D\u0430 \u0434\u0430\u0442\u0443 \u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0446\u0438\u0438 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u0441 \u043E\u0442\u0432\u0435\u0442\u0430\u043C\u0438 \u043D\u0430 \u0447\u0430\u0441\u0442\u043E \u0437\u0430\u0434\u0430\u0432\u0430\u0435\u043C\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B \u0438 \u043C\u043E\u0433\u0443\u0442 \u0431\u044B\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u044B. \u0412\u043B\u0430\u0434\u0435\u043B\u0435\u0446 \u043A\u0432\u0430\u0440\u0442\u0438\u0440\u044B \u043D\u0435\u0441\u0435\u0442 \u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u044C \u0437\u0430 \u0443\u043F\u043B\u0430\u0442\u0443 \u0432\u0441\u0435\u0445 \u043D\u0430\u043B\u043E\u0433\u043E\u0432 \u043D\u0430 \u0434\u043E\u0445\u043E\u0434\u044B \u0438 \u0434\u0440\u0443\u0433\u0438\u0445 \u043D\u0430\u043B\u043E\u0433\u043E\u0432, \u043F\u043E\u0448\u043B\u0438\u043D \u0438 \u0441\u0431\u043E\u0440\u043E\u0432 \u043B\u044E\u0431\u043E\u0433\u043E \u0432\u0438\u0434\u0430, \u043A\u043E\u0442\u043E\u0440\u044B\u043C\u0438 \u043C\u043E\u0433\u0443\u0442 \u043E\u0431\u043B\u0430\u0433\u0430\u0442\u044C \u043A\u0432\u0430\u0440\u0442\u0438\u0440\u0443 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0435 \u043E\u0440\u0433\u0430\u043D\u044B \u0432\u043B\u0430\u0441\u0442\u0438 \u0432 \u0441\u0432\u044F\u0437\u0438 \u0441 \u0435\u0435 \u0441\u0434\u0430\u0447\u0435\u0439 \u0432 \u0430\u0440\u0435\u043D\u0434\u0443.")))),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u4E1A\u4E3B\u53EF\u80FD\u9700\u8981\u5728\u6CF0\u56FD\u6839\u636E\u79DF\u91D1\u6536\u5165\u7533\u62A5\u6240\u5F97\u7A0E\u5E76\u652F\u4ED8\u9002\u7528\u7684\u7A0E\u6536\u3002\u6839\u636E\u6CF0\u56FD\u7A0E\u6536\u6CD5\u5178\uFF0C\u5411\u4E1A\u4E3B\u5206\u914D\u7684\u79DF\u91D1\u53EF\u80FD\u8981\u7F34\u7EB3\u9884\u6263\u7A0E\uFF0C\u7A0E\u7387\u4E3A5-15%\uFF0C\u89C6\u4E1A\u4E3B\u7A0E\u6536\u7ED3\u6784\u72B6\u51B5\u800C\u5B9A\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"\u6CE8\uFF1A\u9002\u7528\u7A0E\u7387\u4E3A\u672C\u5E38\u89C1\u95EE\u9898\u89E3\u7B54\u53D1\u51FA\u4E4B\u65E5\u7684\u73B0\u884C\u7A0E\u7387\uFF0C\u53EF\u80FD\u4F1A\u53D8\u52A8\u3002\u6709\u5173\u90E8\u95E8\u53EF\u80FD\u5BF9\u8BE5\u5355\u5143\u5F81\u6536\u7684\u4E0E\u79DF\u91D1\u6709\u5173\u7684\u4EFB\u4F55\u6536\u5165\u7A0E\u3001\u5176\u4ED6\u7A0E\u6536\u548C\u4EFB\u4F55\u6027\u8D28\u7684\u8D39\u7528\uFF0C\u7531\u4E1A\u4E3B\u8D1F\u8D23\u3002"))))}},// ====================================================================== //
{categoryId:4,question:{en:"What privileges will I receive as an owner?",ru:"Какие привилегии я получу как владелец?",cn:"作为业主，我将得到什么特权？"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Owners will receive membership to the Banyan Group \u2018s signature property owners program, the Sanctuary Club*, which entitles then to discounts and privileges at Banyan Tree , Angsana, Cassia, Dhawa and Laguna resorts, spas and galleries worldwide including:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"30% discount on best available rates for hotel accommodation")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"30% discount on golf green fees")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"25% discount on food and beverage")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"20% discount on a-la-carte spa menu")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"15% discount on gallery merchandise")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"15% discount on in-house tours")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"15% discount on laundry")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"10% discount airport transfers")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Priority wait-list on reservations")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Early check-in / late check-out")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Invitations to pre-openings of new hotels and Banyan Tree events")))),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0412\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u044B \u0430\u043F\u0430\u0440\u0442\u0430\u043C\u0435\u043D\u0442\u043E\u0432 \u0441\u0442\u0430\u043D\u043E\u0432\u044F\u0442\u0441\u044F \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0430\u043C\u0438 Sanctuary Club* \u2013 \u044D\u043A\u0441\u043A\u043B\u044E\u0437\u0438\u0432\u043D\u043E\u0433\u043E \u043A\u043B\u0443\u0431\u0430 \u043E\u0442 Banyan Group \u0434\u043B\u044F \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u0438\u043A\u043E\u0432 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u0438, \u0447\u0442\u043E \u0434\u0430\u0435\u0442 \u0438\u043C \u043F\u0440\u0430\u0432\u043E \u043D\u0430 \u0441\u043A\u0438\u0434\u043A\u0438 \u0438 \u043F\u0440\u0438\u0432\u0438\u043B\u0435\u0433\u0438\u0438 \u043D\u0430 \u0432\u0441\u0435\u0445 \u043A\u0443\u0440\u043E\u0440\u0442\u0430\u0445, \u0432 \u0441\u043F\u0430 \u0438 \u0442\u043E\u0440\u0433\u043E\u0432\u044B\u0445 \u0433\u0430\u043B\u0435\u0440\u0435\u044F\u0445 \u0432 Banyan Tree, Angsana, Cassia, Dhawa and Laguna \u043F\u043E \u0432\u0441\u0435\u043C\u0443 \u043C\u0438\u0440\u0443, \u0432\u043A\u043B\u044E\u0447\u0430\u044F \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0435:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0421\u043A\u0438\u0434\u043A\u0430 \u0432 \u0440\u0430\u0437\u043C\u0435\u0440\u0435 30% \u043D\u0430 \u043B\u0443\u0447\u0448\u0438\u0435 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B\u0435 \u0446\u0435\u043D\u044B \u043D\u0430 \u043F\u0440\u043E\u0436\u0438\u0432\u0430\u043D\u0438\u0435 \u0432 \u043E\u0442\u0435\u043B\u044F\u0445")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0421\u043A\u0438\u0434\u043A\u0430 \u0432 \u0440\u0430\u0437\u043C\u0435\u0440\u0435 30% \u043D\u0430 \u043F\u043B\u0430\u0442\u0443 \u0437\u0430 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435 \u043F\u043E\u043B\u0435\u043C \u0434\u043B\u044F \u0433\u043E\u043B\u044C\u0444\u0430 (\xAB\u0433\u0440\u0438\u043D-\u0444\u0438\xBB)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0421\u043A\u0438\u0434\u043A\u0430 \u0432 \u0440\u0430\u0437\u043C\u0435\u0440\u0435 25% \u043D\u0430 \u0435\u0434\u0443 \u0438 \u043D\u0430\u043F\u0438\u0442\u043A\u0438")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0421\u043A\u0438\u0434\u043A\u0430 \u0432 \u0440\u0430\u0437\u043C\u0435\u0440\u0435 20% \u043D\u0430 \u043C\u0435\u043D\u044E a-la-carte \u0432 \u0441\u043F\u0430-\u043E\u0442\u0435\u043B\u044F\u0445")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0421\u043A\u0438\u0434\u043A\u0430 \u0432 \u0440\u0430\u0437\u043C\u0435\u0440\u0435 15% \u043D\u0430 \u0442\u043E\u0432\u0430\u0440\u044B \u0432 \u0431\u0443\u0442\u0438\u043A\u0430\u0445")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0421\u043A\u0438\u0434\u043A\u0430 \u0432 \u0440\u0430\u0437\u043C\u0435\u0440\u0435 15% \u043D\u0430 \u0442\u0443\u0440\u044B, \u043F\u0440\u0435\u0434\u043B\u0430\u0433\u0430\u0435\u043C\u044B\u0435 \u043E\u0442\u0435\u043B\u044F\u043C\u0438")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0421\u043A\u0438\u0434\u043A\u0430 \u0432 \u0440\u0430\u0437\u043C\u0435\u0440\u0435 15% \u043D\u0430 \u0443\u0441\u043B\u0443\u0433\u0438 \u043F\u0440\u0430\u0447\u0435\u0447\u043D\u043E\u0439")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0421\u043A\u0438\u0434\u043A\u0430 \u0432 \u0440\u0430\u0437\u043C\u0435\u0440\u0435 10% \u043D\u0430 \u0442\u0440\u0430\u043D\u0441\u0444\u0435\u0440\u044B \u0438\u0437 \u0430\u044D\u0440\u043E\u043F\u043E\u0440\u0442\u0430 / \u0432 \u0430\u044D\u0440\u043E\u043F\u043E\u0440\u0442")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041F\u0440\u0438\u043E\u0440\u0438\u0442\u0435\u0442 \u0432 \u043B\u0438\u0441\u0442\u0435 \u043E\u0436\u0438\u0434\u0430\u043D\u0438\u044F \u043F\u0440\u0438 \u0431\u0440\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0438")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0420\u0430\u043D\u043D\u0438\u0439 \u0437\u0430\u0435\u0437\u0434 / \u043F\u043E\u0437\u0434\u043D\u0438\u0439 \u0432\u044B\u0435\u0437\u0434")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041F\u0440\u0438\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u043D\u0430 \u043F\u0440\u0435\u0434\u043F\u0440\u043E\u0434\u0430\u0436\u043D\u044B\u0435 \u043E\u0442\u043A\u0440\u044B\u0442\u0438\u044F \u043D\u043E\u0432\u044B\u0445 \u043E\u0442\u0435\u043B\u0435\u0439 \u0438 \u043C\u0435\u0440\u043E\u043F\u0440\u0438\u044F\u0442\u0438\u044F Banyan Tree")))),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u4E1A\u4E3B\u5C06\u83B7\u5F97\u60A6\u6995\u96C6\u56E2\u7684\u6807\u5FD7\u6027\u4E1A\u4E3B\u8BA1\u5212\u201C\u6995\u6E90\u4F1A\u201D*\u4F1A\u7C4D\uFF0C\u6210\u4E3A\u8BE5\u4FF1\u4E50\u90E8\u4F1A\u5458\uFF0C\u53EF\u5728\u5168\u7403\u8303\u56F4\u7684\u60A6\u6995\u5E84\u3001\u60A6\u693F\u3001\u60A6\u68BF\u3001\u60A6\u82D1\u548C\u4E50\u53E4\u6D6A\u5EA6\u5047\u6751\u3001Spa\u548C\u827A\u54C1\u9601\u4EAB\u53D7\u6298\u6263\u4E0E\u7279\u6743\uFF0C\u5305\u62EC\uFF1A"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u9152\u5E97\u4F4F\u5BBF\u6700\u4F18\u623F\u4EF77\u6298")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u9AD8\u5C14\u592B\u679C\u5CAD\u8D397\u6298")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u9910\u996E7.5\u6298")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u6C34\u7597\u4E2D\u5FC38\u6298")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u96F6\u552E\u827A\u54C1\u9601\u5546\u54C18.5\u6298")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u9152\u5E97\u65C5\u6E38\u670D\u52A18.5\u6298")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u6D17\u8863\u670D\u52A18.5\u6298")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u673A\u573A\u63A5\u90019\u6298")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u9884\u8BA2\u4F18\u5148\u7B49\u5F85\u540D\u5355")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u63D0\u65E9\u5165\u4F4F/\u5EF6\u8FDF\u9000\u623F")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u65B0\u9152\u5E97\u9884\u5F00\u4E1A\u548C\u60A6\u6995\u6D3B\u52A8\u9080\u8BF7"))))}},// ====================================================================== //
{categoryId:5,question:{en:"What are the terms of payment?",ru:"Какие предусмотрены условия оплаты?",cn:"付款方式是什么?"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"There are 2 options available:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Option 1: 100% Payment upon purchase / during construction"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"100% payment upon purchase for already completed properties. Progressive payments for properties under construction are as per the table below."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Construction Payment Term"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"th-col2"},"Of Selling Price"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"st")," Payment upon signing contract"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"nd")," Payment when construction is 25% complete",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"rd")," Payment when construction is 50% complete",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"th")," Payment when construction is 75% complete",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"3")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"th")," Payment upon completion of construction"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{textAlign:"center"}},"Total"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"100%")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"Notes:")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",{className:"notes"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"1. Concrete structure substantially completed."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"2. Roof, brickwork and rendering substantially completed."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"3. Electrical conduits, pipework and plastering substantially completed."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"4. Interest will be applied to the post-construction deferred balance as outlined under Financing Option.")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Option 2: 50% payment upon purchase / during construction with 50% deferred payment over 1, 3 or 5 years"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"50% payment upon purchase for already completed properties. Progressive payments for properties under construction (50% during construction / 50% post construction) as per the table below"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Deferred Payment Plan"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"th-col2"},"Of Selling Price"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"st")," Payment upon signing contract"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"nd")," Payment when construction is 25% complete",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"10%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"rd")," Payment when construction is 50% complete",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"10%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"th")," Payment when construction is 75% complete",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"3")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"10%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"Post construction payments",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"6")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"50%")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Financing Options"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"th-col2"},"Interest Rate",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"(per annum)"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1 Year (4 quarterly installments)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"3%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3 Year (12 quarterly installments)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"5%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5 Year (20 quarterly installments)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"7%")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Notes:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",{className:"notes"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"1. Concrete structure substantially completed.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"2. Roof, brickwork and rendering substantially completed.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"3. Electrical conduits, pipework and plastering substantially completed.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"4. Interest will be applied to the post-construction deferred balance as outlined under Financing Option."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"table-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"tr-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Price")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Reservation Deposit")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Construction Completion ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Payment 50% (Minus Deposit)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Remaining Post Finance 50%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:"3",className:"td-group-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Quarterly Installment"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"tr-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"1 Year (3%)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"3 Year (5%)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"5 Year (7%)"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"636,763"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"225,646"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"149,228")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"7,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"891,468"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"315,904"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"208,919")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"9,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,146,173"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"406,162"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"268,611")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"11,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,400,878"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"496,421"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"328,302")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"13,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"6,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"6,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,655,583"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"586,679"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"387,993")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"15,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"7,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"7,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,910,288"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"676,937"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"447,684")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"17,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"8,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"8,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,164,993"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"767,196"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"507,375")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"19,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"9,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"9,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,419,698"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"857,454"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"567,067")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"21,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"10,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"10,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,674,403"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"947,712"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"626,758")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"23,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"11,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"11,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,929,108"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,037,971"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"686,449")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"25,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"12,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"12,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3,183,813"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,128,229"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"746,140")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Notes:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",{className:"notes"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"1. All amounts are stated in Thai Baht (THB).")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"2. The above table sets out the estimated payments required under the respective payment plans for selling prices between THB 5,000,000 \u2013 25,000,000.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"3. The estimated payments are indicative only and the developer / seller does not accept any responsibility or liability whatsoever for any inaccuracies or omissions.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"4. Payment terms are subject to change without notice.")))),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0414\u043B\u044F \u0432\u0441\u0435\u0445 \u043D\u043E\u0432\u044B\u0445 \u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u0438 \u043C\u044B \u043F\u0440\u0435\u0434\u043B\u0430\u0433\u0430\u0435\u043C 2 \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0430 \u043E\u043F\u043B\u0430\u0442\u044B:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u0412\u0430\u0440\u0438\u0430\u043D\u0442 1. 100 % \u043E\u043F\u043B\u0430\u0442\u0430 \u043F\u0440\u0438 \u043F\u043E\u043A\u0443\u043F\u043A\u0435 / \u0432\u043E \u0432\u0440\u0435\u043C\u044F \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"100% \u043E\u043F\u043B\u0430\u0442\u0430 \u043F\u0440\u0438 \u043F\u043E\u043A\u0443\u043F\u043A\u0435 \u0433\u043E\u0442\u043E\u0432\u044B\u0445 \u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432. \u041F\u0440\u043E\u0433\u0440\u0435\u0441\u0441\u0438\u0432\u043D\u044B\u0435 \u043F\u043B\u0430\u0442\u0435\u0436\u0438 \u0434\u043B\u044F \u0441\u0442\u0440\u043E\u044F\u0449\u0438\u0445\u0441\u044F \u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432 \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u044B \u0432 \u0442\u0430\u0431\u043B\u0438\u0446\u0435 \u043D\u0438\u0436\u0435."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"\u0421\u0440\u043E\u043A \u043F\u043B\u0430\u0442\u0435\u0436\u0430 \u043D\u0430 \u043C\u043E\u043C\u0435\u043D\u0442 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"th-col2"},"% \u043E\u0442 \u0446\u0435\u043D\u044B \u043F\u0440\u043E\u0434\u0430\u0436\u0438"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1-\u0439 \u043F\u043B\u0430\u0442\u0435\u0436 \u043F\u0440\u0438 \u0437\u0430\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0438 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2-\u0439 \u043F\u043B\u0430\u0442\u0435\u0436 \u043F\u0440\u0438 25-\u043F\u0440\u043E\u0446\u0435\u043D\u0442\u043D\u043E\u0439 \u0433\u043E\u0442\u043E\u0432\u043D\u043E\u0441\u0442\u0438 \u043E\u0431\u044A\u0435\u043A\u0442\u0430",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3-\u0439 \u043F\u043B\u0430\u0442\u0435\u0436 \u043F\u0440\u0438 50-\u043F\u0440\u043E\u0446\u0435\u043D\u0442\u043D\u043E\u0439 \u0433\u043E\u0442\u043E\u0432\u043D\u043E\u0441\u0442\u0438 \u043E\u0431\u044A\u0435\u043A\u0442\u0430",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4-\u0439 \u043F\u043B\u0430\u0442\u0435\u0436 \u043F\u0440\u0438 75-\u043F\u0440\u043E\u0446\u0435\u043D\u0442\u043D\u043E\u0439 \u0433\u043E\u0442\u043E\u0432\u043D\u043E\u0441\u0442\u0438 \u043E\u0431\u044A\u0435\u043A\u0442\u0430",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"3")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5-\u0439 \u043F\u043B\u0430\u0442\u0435\u0436 \u043F\u043E \u043E\u043A\u043E\u043D\u0447\u0430\u043D\u0438\u0438 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{textAlign:"center"}},"\u0412\u0441\u0435\u0433\u043E"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"100%")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u041F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u044F:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",{className:"notes"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"1. \u041A\u043E\u0440\u043E\u0431\u043A\u0430 \u0437\u0434\u0430\u043D\u0438\u044F \u0432 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u043C \u0432\u043E\u0437\u0432\u0435\u0434\u0435\u043D\u0430.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"2. \u0412\u043E\u0437\u0432\u0435\u0434\u0435\u043D\u0438\u0435 \u043A\u0440\u043E\u0432\u043B\u0438, \u043A\u0438\u0440\u043F\u0438\u0447\u043D\u0430\u044F \u043A\u043B\u0430\u0434\u043A\u0430 \u0438 \u0448\u0442\u0443\u043A\u0430\u0442\u0443\u0440\u043A\u0430 \u043D\u0430\u0440\u0443\u0436\u043D\u043E\u0439 \u043F\u043E\u0432\u0435\u0440\u0445\u043D\u043E\u0441\u0442\u0438 \u0441\u0442\u0435\u043D \u0432 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u043C \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u044B.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"3. \u042D\u043B\u0435\u043A\u0442\u0440\u043E\u043F\u0440\u043E\u0432\u043E\u0434\u043A\u0430, \u0440\u0430\u0437\u0432\u043E\u0434\u043A\u0430 \u0442\u0440\u0443\u0431 \u0438 \u0432\u043D\u0443\u0442\u0440\u0435\u043D\u043D\u0435\u0435 \u043E\u0448\u0442\u0443\u043A\u0430\u0442\u0443\u0440\u0438\u0432\u0430\u043D\u0438\u0435 \u0432 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u043C \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u044B.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"4. \u041D\u0430 \u043E\u0442\u043B\u043E\u0436\u0435\u043D\u043D\u044B\u0439 \u043E\u0441\u0442\u0430\u0442\u043E\u043A \u043E\u043F\u043B\u0430\u0442\u044B \u043F\u043E\u0441\u043B\u0435 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 \u043D\u0430\u0447\u0438\u0441\u043B\u044F\u044E\u0442\u0441\u044F \u043F\u0440\u043E\u0446\u0435\u043D\u0442\u044B \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u0440\u0430\u0437\u0434\u0435\u043B\u043E\u043C \xAB\u0412\u0430\u0440\u0438\u0430\u043D\u0442\u044B \u0444\u0438\u043D\u0430\u043D\u0441\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F\xBB."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u0412\u0430\u0440\u0438\u0430\u043D\u0442 2. \u041F\u0435\u0440\u0432\u044B\u0435 50 % \u043F\u0440\u0438 \u043F\u043E\u043A\u0443\u043F\u043A\u0435 / \u043F\u043E \u044D\u0442\u0430\u043F\u0430\u043C \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 \u0438 \u0432\u0442\u043E\u0440\u044B\u0435 50 % \u0432 \u0440\u0430\u0441\u0441\u0440\u043E\u0447\u043A\u0443 \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 1, 3 \u0438\u043B\u0438 5 \u043B\u0435\u0442"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"50 % \u043E\u043F\u043B\u0430\u0442\u044B \u043F\u0440\u0438 \u043F\u043E\u043A\u0443\u043F\u043A\u0435 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043D\u044B\u0445 \u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432. \u041F\u0440\u043E\u0433\u0440\u0435\u0441\u0441\u0438\u0432\u043D\u044B\u0435 \u043F\u043B\u0430\u0442\u0435\u0436\u0438 \u0434\u043B\u044F \u0441\u0442\u0440\u043E\u044F\u0449\u0438\u0445\u0441\u044F \u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432 (50 % \u043F\u043E \u044D\u0442\u0430\u043F\u0430\u043C \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 / 50 % \u043F\u043E\u0441\u043B\u0435 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430) \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u044B \u0432 \u0442\u0430\u0431\u043B\u0438\u0446\u0435 \u043D\u0438\u0436\u0435."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"\u0413\u0440\u0430\u0444\u0438\u043A \u043E\u0442\u043B\u043E\u0436\u0435\u043D\u043D\u044B\u0445 \u043F\u043B\u0430\u0442\u0435\u0436\u0435\u0439"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"th-col2"},"% \u043E\u0442 \u0446\u0435\u043D\u044B \u043F\u0440\u043E\u0434\u0430\u0436\u0438"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1-\u0439 \u043F\u043B\u0430\u0442\u0435\u0436 \u043F\u0440\u0438 \u0437\u0430\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0438 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2-\u0439 \u043F\u043B\u0430\u0442\u0435\u0436 \u043F\u0440\u0438 25-\u043F\u0440\u043E\u0446\u0435\u043D\u0442\u043D\u043E\u0439 \u0433\u043E\u0442\u043E\u0432\u043D\u043E\u0441\u0442\u0438 \u043E\u0431\u044A\u0435\u043A\u0442\u0430",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"10%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3-\u0439 \u043F\u043B\u0430\u0442\u0435\u0436 \u043F\u0440\u0438 50-\u043F\u0440\u043E\u0446\u0435\u043D\u0442\u043D\u043E\u0439 \u0433\u043E\u0442\u043E\u0432\u043D\u043E\u0441\u0442\u0438 \u043E\u0431\u044A\u0435\u043A\u0442\u0430",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"10%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4-\u0439 \u043F\u043B\u0430\u0442\u0435\u0436 \u043F\u0440\u0438 75-\u043F\u0440\u043E\u0446\u0435\u043D\u0442\u043D\u043E\u0439 \u0433\u043E\u0442\u043E\u0432\u043D\u043E\u0441\u0442\u0438 \u043E\u0431\u044A\u0435\u043A\u0442\u0430",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"3")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"10%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u041F\u043B\u0430\u0442\u0435\u0436\u0438 \u043F\u043E \u043E\u043A\u043E\u043D\u0447\u0430\u043D\u0438\u0438 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"6")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"50%")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"\u0412\u0430\u0440\u0438\u0430\u043D\u0442\u044B \u0444\u0438\u043D\u0430\u043D\u0441\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"th-col2"},"\u041F\u0440\u043E\u0446\u0435\u043D\u0442\u043D\u0430\u044F",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"\u0441\u0442\u0430\u0432\u043A\u0430 (\u0433\u043E\u0434\u043E\u0432\u044B\u0445)"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1 \u0433\u043E\u0434 (4 \u0435\u0436\u0435\u043A\u0432\u0430\u0440\u0442\u0430\u043B\u044C\u043D\u044B\u0445 \u043F\u043B\u0430\u0442\u0435\u0436\u0430)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"3%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3 \u0433\u043E\u0434\u0430 (12 \u0435\u0436\u0435\u043A\u0432\u0430\u0440\u0442\u0430\u043B\u044C\u043D\u044B\u0445 \u043F\u043B\u0430\u0442\u0435\u0436\u0435\u0439)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"5%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5 \u043B\u0435\u0442 (20 \u0435\u0436\u0435\u043A\u0432\u0430\u0440\u0442\u0430\u043B\u044C\u043D\u044B\u0445 \u043F\u043B\u0430\u0442\u0435\u0436\u0435\u0439)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"7%")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u041F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u044F:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",{className:"notes"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"1. \u041A\u043E\u0440\u043E\u0431\u043A\u0430 \u0437\u0434\u0430\u043D\u0438\u044F \u0432 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u043C \u0432\u043E\u0437\u0432\u0435\u0434\u0435\u043D\u0430.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"2. \u0412\u043E\u0437\u0432\u0435\u0434\u0435\u043D\u0438\u0435 \u043A\u0440\u043E\u0432\u043B\u0438, \u043A\u0438\u0440\u043F\u0438\u0447\u043D\u0430\u044F \u043A\u043B\u0430\u0434\u043A\u0430 \u0438 \u0448\u0442\u0443\u043A\u0430\u0442\u0443\u0440\u043A\u0430 \u043D\u0430\u0440\u0443\u0436\u043D\u043E\u0439 \u043F\u043E\u0432\u0435\u0440\u0445\u043D\u043E\u0441\u0442\u0438 \u0441\u0442\u0435\u043D \u0432 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u043C \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u044B.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"3. \u042D\u043B\u0435\u043A\u0442\u0440\u043E\u043F\u0440\u043E\u0432\u043E\u0434\u043A\u0430, \u0440\u0430\u0437\u0432\u043E\u0434\u043A\u0430 \u0442\u0440\u0443\u0431 \u0438 \u0432\u043D\u0443\u0442\u0440\u0435\u043D\u043D\u0435\u0435 \u043E\u0448\u0442\u0443\u043A\u0430\u0442\u0443\u0440\u0438\u0432\u0430\u043D\u0438\u0435 \u0432 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u043C \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u044B.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"4. \u041D\u0430 \u043E\u0442\u043B\u043E\u0436\u0435\u043D\u043D\u044B\u0439 \u043E\u0441\u0442\u0430\u0442\u043E\u043A \u043E\u043F\u043B\u0430\u0442\u044B \u043F\u043E\u0441\u043B\u0435 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 \u043D\u0430\u0447\u0438\u0441\u043B\u044F\u044E\u0442\u0441\u044F \u043F\u0440\u043E\u0446\u0435\u043D\u0442\u044B \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u0440\u0430\u0437\u0434\u0435\u043B\u043E\u043C \xAB\u0412\u0430\u0440\u0438\u0430\u043D\u0442\u044B \u0444\u0438\u043D\u0430\u043D\u0441\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F\xBB."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"table-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"tr-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u0426\u0435\u043D\u0430")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u0414\u0435\u043F\u043E\u0437\u0438\u0442")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u041E\u043F\u043B\u0430\u0442\u0430 50 % \u043F\u043E",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"\u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044E",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"\u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"\u0432\u0430 (\u043C\u0438\u043D\u0443\u0441 \u0434\u0435\u043F\u043E\u0437\u0438\u0442)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u041E\u043F\u043B\u0430\u0442\u0430",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"\u043E\u0441\u0442\u0430\u0432\u0448\u0438\u0445\u0441",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"\u044F 50 %")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:"3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u0415\u0436\u0435\u043A\u0432\u0430\u0440\u0442\u0430\u043B\u044C\u043D\u044B\u0435 \u0432\u0437\u043D\u043E\u0441\u044B"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"tr-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"1 \u0433\u043E\u0434 (3%)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"3 \u0433\u043E\u0434\u0430 (5%)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"5 \u0433\u043E\u0434 (7%)"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"636,763"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"225,646"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"149,228")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"7,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"891,468"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"315,904"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"208,919")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"9,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,146,173"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"406,162"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"268,611")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"11,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,400,878"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"496,421"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"328,302")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"13,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"6,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"6,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,655,583"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"586,679"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"387,993")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"15,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"7,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"7,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,910,288"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"676,937"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"447,684")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"17,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"8,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"8,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,164,993"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"767,196"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"507,375")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"19,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"9,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"9,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,419,698"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"857,454"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"567,067")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"21,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"10,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"10,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,674,403"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"947,712"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"626,758")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"23,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"11,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"11,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,929,108"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,037,971"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"686,449")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"25,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"12,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"12,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3,183,813"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,128,229"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"746,140")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u041F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u044F:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",{className:"notes"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"1. \u0412\u0441\u0435 \u0441\u0443\u043C\u043C\u044B \u0443\u043A\u0430\u0437\u0430\u043D\u044B \u0432 \u0442\u0430\u0439\u0441\u043A\u0438\u0445 \u0431\u0430\u0442\u0430\u0445.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"2. \u0412 \u043F\u0440\u0438\u0432\u0435\u0434\u0435\u043D\u043D\u043E\u0439 \u0432\u044B\u0448\u0435 \u0442\u0430\u0431\u043B\u0438\u0446\u0435 \u0443\u043A\u0430\u0437\u0430\u043D\u044B \u0440\u0430\u0441\u0447\u0435\u0442\u043D\u044B\u0435 \u0441\u0443\u043C\u043C\u044B \u043F\u043B\u0430\u0442\u0435\u0436\u0435\u0439, \u043F\u0440\u0435\u0434\u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u043D\u044B\u0445 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u043C\u0438 \u0433\u0440\u0430\u0444\u0438\u043A\u0430\u043C\u0438 \u0434\u043B\u044F \u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u0438 \u0441 \u043F\u0440\u043E\u0434\u0430\u0436\u043D\u043E\u0439 \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C\u044E \u043E\u0442 5 000 000 \u0434\u043E 25 000 000 THB.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"3. \u041F\u043B\u0430\u0442\u0435\u0436\u0438 \u044F\u0432\u043B\u044F\u044E\u0442\u0441\u044F \u043B\u0438\u0448\u044C \u043E\u0440\u0438\u0435\u043D\u0442\u0438\u0440\u043E\u0432\u043E\u0447\u043D\u044B\u043C\u0438 \u0438 \u0437\u0430\u0441\u0442\u0440\u043E\u0439\u0449\u0438\u043A / \u043F\u0440\u043E\u0434\u0430\u0432\u0435\u0446 \u043D\u0435 \u043D\u0435\u0441\u0435\u0442 \u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u0437\u0430 \u043B\u044E\u0431\u044B\u0435 \u043D\u0435\u0442\u043E\u0447\u043D\u043E\u0441\u0442\u0438 \u0438\u043B\u0438 \u043E\u0448\u0438\u0431\u043A\u0438.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"4. \u0423\u0441\u043B\u043E\u0432\u0438\u044F \u043E\u043F\u043B\u0430\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0431\u044B\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u044B \u0431\u0435\u0437 \u043F\u0440\u0435\u0434\u0432\u0430\u0440\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0433\u043E \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F.")))),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u4E24\u79CD\u4ED8\u6B3E\u8BA1\u5212\uFF1A"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u9009\u62E9 1:\u8D2D\u4E70/\u65BD\u5DE5\u671F\u95F4\u5168\u989D\u4ED8\u6B3E"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"\u8D2D\u4E70\u5DF2\u7AE3\u5DE5\u7269\u4E1A\u65F6\u5168\u989D\u4ED8\u6B3E\u3002 \u5BF9\u4E8E\u5728\u5EFA\u7269\u4E1A\uFF0C\u6309\u4E0B\u8868\u6839\u636E\u65BD\u5DE5\u8FDB\u5EA6\u5206\u671F\u4ED8\u6B3E\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"\u65BD\u5DE5\u8FDB\u5EA6\u4ED8\u6B3E\u8BA1\u5212"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"th-col2"},"\u4ED8\u6B3E\u6BD4\u4F8B"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u7B7E\u7F72\u5408\u540C\u65F6\u8FDB\u884C\u9996\u4ED8"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u5DE5\u7A0B\u5B8C\u6210 25%\u65F6\u8FDB\u884C\u7B2C 2 \u6B21\u4ED8\u6B3E",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u5DE5\u7A0B\u5B8C\u6210 50%\u65F6\u8FDB\u884C\u7B2C 3 \u6B21\u4ED8\u6B3E",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u5DE5\u7A0B\u5B8C\u6210 75%\u65F6\u8FDB\u884C\u7B2C 4 \u6B21\u4ED8\u6B3E",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"3")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u7AE3\u5DE5\u65F6\u8FDB\u884C\u7B2C 5 \u6B21\u4ED8\u6B3E"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{textAlign:"center"}},"\u5408\u8BA1"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"100%")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u5907\u6CE8:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",{className:"notes"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"1. \u6DF7\u51DD\u571F\u7ED3\u6784\u57FA\u672C\u5B8C\u6210\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"2. \u5C4B\u9876\u3001\u7816\u780C\u548C\u7C89\u5237\u57FA\u672C\u5B8C\u6210\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"3. \u7535\u529B\u7BA1\u3001\u7BA1\u9053\u5DE5\u7A0B\u548C\u62B9\u7070\u57FA\u672C\u5B8C\u6210\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"4. \u7AE3\u5DE5\u540E\u5EF6\u671F\u4ED8\u6B3E\u4F59\u989D\u9700\u652F\u4ED8\u8D22\u52A1\u9009\u62E9\u4E2D\u6240\u5217\u7684\u5229\u606F\u3002"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u9009\u62E9 2:\u8D2D\u4E70\u65F6/\u65BD\u5DE5\u671F\u95F4\u4ED8\u6B3E 50%\uFF0C\u5269\u4F59\u7684 50%\u5EF6\u671F\u6B3E\u9879\u5728 1 \u5E74\u30013 \u5E74\u6216 5 \u5E74\u5185\u652F\u4ED8"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"\u8D2D\u4E70\u5DF2\u7AE3\u5DE5\u7269\u4E1A\u652F\u4ED8 50%\u7684\u6B3E\u9879\u3002\u5BF9\u4E8E\u5728\u5EFA\u7269\u4E1A\uFF0C\u6309\u4E0B\u8868\u6839\u636E\u65BD\u5DE5\u8FDB\u5EA6\u5206\u671F\u4ED8\u6B3E(\u65BD\u5DE5\u671F\u95F4\u4ED8 \u6B3E 50%/\u7AE3\u5DE5\u540E\u4ED8\u6B3E 50%)\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"\u5EF6\u671F\u4ED8\u6B3E\u8BA1\u5212"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"th-col2"},"\u4ED8\u6B3E\u6BD4\u4F8B"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u7B7E\u7F72\u5408\u540C\u65F6\u8FDB\u884C\u9996\u4ED8"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u5DE5\u7A0B\u5B8C\u6210 25%\u65F6\u7B2C 2 \u6B21\u4ED8\u6B3E",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"10%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u5DE5\u7A0B\u5B8C\u6210 50%\u65F6\u7B2C 3 \u6B21\u4ED8\u6B3E",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"10%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u5DE5\u7A0B\u5B8C\u6210 75%\u65F6\u7B2C 4 \u6B21\u4ED8\u6B3E",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"3")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"10%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u7AE3\u5DE5\u540E\u4ED8\u6B3E",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"6")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"50%")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"\u5206\u671F\u4ED8\u6B3E\u9009\u62E9"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"th-col2"},"\u5229\u7387(\u6BCF\u5E74)"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1 \u5E74 (4 \u4E2A\u5B63\u5EA6\u5206\u671F\u4ED8\u6B3E)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"3%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3 \u5E74 (12 \u4E2A\u5B63\u5EA6\u5206\u671F\u4ED8\u6B3E)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"5%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5 \u5E74 (20 \u4E2A\u5B63\u5EA6\u5206\u671F\u4ED8\u6B3E)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"7%")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u5907\u6CE8:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",{className:"notes"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"1. \u6DF7\u51DD\u571F\u7ED3\u6784\u57FA\u672C\u5B8C\u6210\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"2. \u5C4B\u9876\u3001\u7816\u780C\u548C\u7C89\u5237\u57FA\u672C\u5B8C\u6210\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"3. \u7535\u529B\u7BA1\u3001\u7BA1\u9053\u5DE5\u7A0B\u548C\u62B9\u7070\u57FA\u672C\u5B8C\u6210\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"4. \u7AE3\u5DE5\u540E\u5EF6\u671F\u4ED8\u6B3E\u4F59\u989D\u9700\u652F\u4ED8\u8D22\u52A1\u9009\u62E9\u4E2D\u6240\u5217\u7684\u5229\u606F\u3002"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"table-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"tr-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u4EF7\u683C")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u9884\u5B9A\u91D1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u65BD\u5DE5\u671F\u95F4\u4ED8\u6B3E 50% (\u51CF\u53BB\u5B9A\u91D1)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u7AE3\u5DE5\u540E\u4ED8\u6B3E 50%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:"3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u6309\u5B63\u5EA6\u5206\u671F\u4ED8\u6B3E"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"tr-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"1 \u5E74 (3%)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"3 \u5E74 (5%)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"5 \u5E74 (7%)"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"636,763"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"225,646"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"149,228")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"7,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"891,468"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"315,904"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"208,919")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"9,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,146,173"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"406,162"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"268,611")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"11,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,400,878"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"496,421"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"328,302")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"13,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"6,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"6,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,655,583"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"586,679"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"387,993")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"15,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"7,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"7,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,910,288"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"676,937"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"447,684")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"17,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"8,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"8,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,164,993"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"767,196"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"507,375")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"19,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"9,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"9,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,419,698"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"857,454"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"567,067")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"21,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"10,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"10,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,674,403"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"947,712"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"626,758")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"23,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"11,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"11,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,929,108"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,037,971"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"686,449")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"25,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"12,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"12,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3,183,813"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,128,229"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"746,140")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u5907\u6CE8:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",{className:"notes"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"1. \u8D27\u5E01\u5355\u4F4D\u4E3A\u6CF0\u94E2\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"2. \u4E0A\u8868\u5217\u51FA\u4E86\u9500\u552E\u4EF7\u683C\u4E3A5,000,000 \u2013 25,000,000\u6CF0\u94E2\u65F6\uFF0C\u76F8\u5E94\u4ED8\u6B3E\u8BA1\u5212\u6240\u9700\u652F\u4ED8\u7684\u9884\u8BA1\u91D1\u989D\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"3. \u9884\u8BA1\u4ED8\u6B3E\u91D1\u989D\u4EC5\u4F9B\u53C2\u8003\u3002\u5982\u6709\u9519\u6F0F\uFF0C\u5F00\u53D1\u5546/\u9500\u552E\u65B9\u6982\u4E0D\u8D1F\u8D23\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"4. \u4ED8\u6B3E\u65B9\u5F0F\u5982\u6709\u66F4\u6539\uFF0C\u6055\u4E0D\u53E6\u884C\u901A\u77E5\u3002"))))}}];

/***/ }),
/* 863 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _default; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_skrollr__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_skrollr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_skrollr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_scroll__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_helmet__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hoc__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_language__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_location__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_laguna_seaside_residences__ = __webpack_require__(864);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Gallery__ = __webpack_require__(880);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Concept__ = __webpack_require__(881);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Faq__ = __webpack_require__(882);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Destination__ = __webpack_require__(883);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__TheSanctuaryclub__ = __webpack_require__(884);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Siteplan__ = __webpack_require__(885);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Masterplan__ = __webpack_require__(887);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Residences__ = __webpack_require__(888);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Ebrochure__ = __webpack_require__(889);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var page="laguna-seaside-residences";var sections=[{key:"gallery",label:"Gallery"},{key:"concept",label:"Concept"},{key:"masterplan",label:"Master Plan"},{key:"siteplan",label:"Site Plan"},{key:"residences",label:{en:"Room Types",ru:"Типы квартир",cn:"房型"},subitem:[{// key: "studio",
// label: {
//   en: "STUDIO",
//   ru: "Студии",
//   cn: "一室公寓",
// },
key:"1-bed",label:{en:"ONE-BEDROOM",ru:"1-Спальня",cn:"1-卧室"},path:"/:language/projects/laguna-seaside-residences/",currentSection:0},{// key: "one-bedroom",
// label: {
//   en: "1 BEDROOM",
//   ru: "Одна спальня",
//   cn: "一卧室套房",
// },
key:"2-bed",label:{en:"TWO-BEDROOM",ru:"2-Спальня",cn:"2-卧室"},path:"/:language/projects/laguna-seaside-residences/",currentSection:1},{// key: "two-bedroom",
// label: {
//   en: "2 BEDROOM",
//   ru: "Две спальни",
//   cn: "两卧室套房",
// },
key:"3-bed",label:{en:"THREE-BEDROOM",ru:"3-Спальня",cn:"3-卧室"},path:"/:language/projects/laguna-seaside-residences/",currentSection:2}]},{key:"destination",label:"Destination"},{key:"sanctuary-club",label:"The Santuary Club"},{key:"faq",label:"FAQ",hideOnMobile:true},{key:"e-brochure",label:"E-Brochure",hideOnMobile:true}];var mapStateToProps=function mapStateToProps(state){return Object.assign({},state);};var actionToProps={switchLanguage:__WEBPACK_IMPORTED_MODULE_7__actions_language__["a" /* switchLanguage */],switchLocation:__WEBPACK_IMPORTED_MODULE_8__actions_location__["a" /* switchLocation */],initAppLagunaSeasideResidences:__WEBPACK_IMPORTED_MODULE_9__actions_laguna_seaside_residences__["a" /* initAppLagunaSeasideResidences */]};var _default=(_dec=Object(__WEBPACK_IMPORTED_MODULE_6__hoc__["b" /* withRedux */])(mapStateToProps,actionToProps),_dec(_class=function(_Component){_inherits(_default,_Component);function _default(props){_classCallCheck(this,_default);var _this=_possibleConstructorReturn(this,(_default.__proto__||Object.getPrototypeOf(_default)).call(this,props));_this.handleWheel=function(evt){if(evt.deltaY>0){var atBottomOfSection=_this.headerRef.current.atBottomOfSection();if(atBottomOfSection){evt.preventDefault();evt.stopPropagation();evt.returnValue=false;// console.log('evt', evt.deltaY);
_this.headerRef.current.handleScrollDown();}}if(evt.deltaY<0){var atTopOfSection=_this.headerRef.current.atTopOfSection();if(atTopOfSection){evt.preventDefault();evt.stopPropagation();evt.returnValue=false;// console.log('evt', evt.deltaY);
_this.headerRef.current.handleScrollUp();}}};_this.setLanguage=function(language){_this.props.actions.switchLanguage(language);};_this.setLocation=function(location){_this.props.actions.switchLocation(location);};_this.fetchData=function(){_this.props.actions.initAppLagunaSeasideResidences();};_this.renderSectionWithId=function(component,id){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_scroll__["Element"],{name:id},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("section",{id:id},component));};_this.headerRef=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createRef();return _this;}_createClass(_default,[{key:"componentDidMount",value:function componentDidMount(){this.setLanguage(this.props.match.params.language);this.setLocation(this.props.route.key);this.fetchData();}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps){var currentLanguage=prevProps.match.params.language;var nextLanguage=this.props.match.params.language;if(currentLanguage!==nextLanguage){this.setLanguage(nextLanguage);}}},{key:"render",value:function render(){var pageData=__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(this.props,page+".data");var isMobile=__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(this.props,"device.isMobile");var currentLanguage=__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(this.props,"language.currentActive");console.log("pageData-seaside",{page:page,pageData:pageData});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_skrollr__["ParallaxProvider"],{init:{smoothScrollingDuration:500,smoothScrolling:true,forceHeight:false}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_helmet__["Helmet"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("title",null,"New Beachfront Condo For sale near Phuket | Laguna Property"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("meta",{name:"description",content:"Your dream beachfront property awaits. Laguna Property is a leading and trusted property developer since 1993. Discover Phuket\u2019s newest beachfront condos on our page."}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("meta",{name:"keywords",content:"affordable condo for sale phuket,beachfront condo for sale phuket,apartment for sale near Phuket beach,condo for sale near bang tao beach,new beachfront condo phuket,new condo sales phuket,2 bedroom condos for sale phuket,1 bedroom condo for sale phuket,1 bed condo for sale phuket,2 bed condo for sale phuket"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["f" /* Header */],{mainLogo:Object(__WEBPACK_IMPORTED_MODULE_10__utils__["a" /* assetsPath */])()+"/images/logo-laguna-property.svg",subLogo:Object(__WEBPACK_IMPORTED_MODULE_10__utils__["a" /* assetsPath */])(page)+"/images/logo/logo-navbar.png",language:currentLanguage,projectSections:sections,wrappedComponentRef:this.headerRef}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"main-content laguna-seaside-residences",disable_onWheel:this.handleWheel},this.renderSectionWithId(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Gallery__["a" /* default */],Object.assign({},__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"gallery"),{page:page})),"gallery"),this.renderSectionWithId(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Concept__["a" /* default */],{imageSlider:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"concept.imageSlider"),content:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"concept.content"),page:page}),"concept"),this.renderSectionWithId(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Masterplan__["a" /* default */],{map:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"masterPlan.maps"),page:page}),"masterplan"),this.renderSectionWithId(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Siteplan__["a" /* default */],{map:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"sitePlan.maps"),dataSitePlan:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"sitePlan.type"),subTabs:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"sitePlan.subTabs"),descriptions:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"sitePlan.descriptions"),page:page}),"siteplan"),this.renderSectionWithId(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Residences__["a" /* default */],{landingPage:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"residence.landingPage"),type:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"residence.type"),page:page}),"residences"),this.renderSectionWithId(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Destination__["a" /* default */],{isMobile:isMobile,imageSlider:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"destination.landingPage"),title:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"destination.content.title"),description:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"destination.content.description"),mapData:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"destination.map"),page:page}),"destination"),this.renderSectionWithId(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__TheSanctuaryclub__["a" /* default */],{description:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"sanctuaryClub.description"),image:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"sanctuaryClub.image"),title:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"sanctuaryClub.title"),page:page}),"sanctuary-club"),this.renderSectionWithId(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Faq__["a" /* default */],Object.assign({},__webpack_require__(890),{page:page})),"faq"),this.renderSectionWithId(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Ebrochure__["a" /* default */],{location:"phuket",project:"laguna-seaside-residences",page:page}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["d" /* Footer */],null)),"e-brochure"))));}}]);return _default;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class);

/***/ }),
/* 864 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return initAppLagunaSeasideResidences; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_reduce__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_reduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_reduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actionType__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_laguna_seaside_residences__ = __webpack_require__(865);
var _this=this;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var initAppLagunaSeasideResidences=function initAppLagunaSeasideResidences(){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch){var listApi,apiResult,mapData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:listApi=[];_context.t0=listApi;_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_3__services_laguna_seaside_residences__["c" /* fetchGalleryApi */])();case 4:_context.t1=_context.sent;_context.t2={key:"gallery",data:_context.t1};_context.t0.push.call(_context.t0,_context.t2);_context.t3=listApi;_context.next=10;return Object(__WEBPACK_IMPORTED_MODULE_3__services_laguna_seaside_residences__["a" /* fetchConceptApi */])();case 10:_context.t4=_context.sent;_context.t5={key:"concept",data:_context.t4};_context.t3.push.call(_context.t3,_context.t5);_context.t6=listApi;_context.next=16;return Object(__WEBPACK_IMPORTED_MODULE_3__services_laguna_seaside_residences__["d" /* fetchMasterPlanApi */])();case 16:_context.t7=_context.sent;_context.t8={key:"masterPlan",data:_context.t7};_context.t6.push.call(_context.t6,_context.t8);_context.t9=listApi;_context.next=22;return Object(__WEBPACK_IMPORTED_MODULE_3__services_laguna_seaside_residences__["g" /* fetchSitePlanApi */])();case 22:_context.t10=_context.sent;_context.t11={key:"sitePlan",data:_context.t10};_context.t9.push.call(_context.t9,_context.t11);_context.t12=listApi;_context.next=28;return Object(__WEBPACK_IMPORTED_MODULE_3__services_laguna_seaside_residences__["e" /* fetchResidenceApi */])();case 28:_context.t13=_context.sent;_context.t14={key:"residence",data:_context.t13};_context.t12.push.call(_context.t12,_context.t14);_context.t15=listApi;_context.next=34;return Object(__WEBPACK_IMPORTED_MODULE_3__services_laguna_seaside_residences__["b" /* fetchDestinationApi */])();case 34:_context.t16=_context.sent;_context.t17={key:"destination",data:_context.t16};_context.t15.push.call(_context.t15,_context.t17);_context.t18=listApi;_context.next=40;return Object(__WEBPACK_IMPORTED_MODULE_3__services_laguna_seaside_residences__["f" /* fetchSanctuaryClubApi */])();case 40:_context.t19=_context.sent;_context.t20={key:"sanctuaryClub",data:_context.t19};_context.t18.push.call(_context.t18,_context.t20);_context.prev=43;_context.next=46;return Promise.all(listApi);case 46:apiResult=_context.sent;mapData=__WEBPACK_IMPORTED_MODULE_1_lodash_reduce___default()(apiResult,function(result,value,index){var key=value.key,data=value.data;return Object.assign({},result,_defineProperty({},key,data));},{});dispatch({type:__WEBPACK_IMPORTED_MODULE_2__actionType__["d" /* RECEIVE_LAGUNA_SEASIDE_RESIDENCES */],data:mapData});_context.next=54;break;case 51:_context.prev=51;_context.t21=_context["catch"](43);console.error("initAppLagunaSeasideResidences err",_context.t21);case 54:case"end":return _context.stop();}}},_callee,_this,[[43,51]]);}));return function(_x){return _ref.apply(this,arguments);};}();};

/***/ }),
/* 865 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchGalleryApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchConceptApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchMasterPlanApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return fetchSitePlanApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fetchResidenceApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchDestinationApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fetchSanctuaryClubApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_LagunaSeasideResidences_gallery__ = __webpack_require__(866);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_LagunaSeasideResidences_concept__ = __webpack_require__(867);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_LagunaSeasideResidences_masterplan__ = __webpack_require__(868);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_LagunaSeasideResidences_sitePlan__ = __webpack_require__(869);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_LagunaSeasideResidences_residence__ = __webpack_require__(877);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_LagunaSeasideResidences_destination__ = __webpack_require__(878);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_LagunaSeasideResidences_sanctuaryClub__ = __webpack_require__(879);
var fetchGalleryApi=function fetchGalleryApi(){return Promise.resolve(__WEBPACK_IMPORTED_MODULE_0__data_LagunaSeasideResidences_gallery__["a" /* default */]);};var fetchConceptApi=function fetchConceptApi(){return Promise.resolve(__WEBPACK_IMPORTED_MODULE_1__data_LagunaSeasideResidences_concept__["a" /* default */]);};var fetchMasterPlanApi=function fetchMasterPlanApi(){return Promise.resolve(__WEBPACK_IMPORTED_MODULE_2__data_LagunaSeasideResidences_masterplan__["a" /* default */]);};var fetchSitePlanApi=function fetchSitePlanApi(){return Promise.resolve(__WEBPACK_IMPORTED_MODULE_3__data_LagunaSeasideResidences_sitePlan__["a" /* default */]);};var fetchResidenceApi=function fetchResidenceApi(){return Promise.resolve(__WEBPACK_IMPORTED_MODULE_4__data_LagunaSeasideResidences_residence__["a" /* default */]);};var fetchDestinationApi=function fetchDestinationApi(){return Promise.resolve(__WEBPACK_IMPORTED_MODULE_5__data_LagunaSeasideResidences_destination__["a" /* default */]);};var fetchSanctuaryClubApi=function fetchSanctuaryClubApi(){return Promise.resolve(__WEBPACK_IMPORTED_MODULE_6__data_LagunaSeasideResidences_sanctuaryClub__["a" /* default */]);};

/***/ }),
/* 866 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_find__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(2);
var baseAssetUrl=Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* assetsPath */])("laguna-seaside-residences");var heroShotImg1=baseAssetUrl+"/images/gallery/hero-shot/1.jpg";var heroShotImg2=baseAssetUrl+"/images/gallery/hero-shot/2.jpg";var heroShotImg3=baseAssetUrl+"/images/gallery/hero-shot/3.jpg";var heroShotImg4=baseAssetUrl+"/images/gallery/hero-shot/4.jpg";var aerial1=baseAssetUrl+"/images/gallery/images/aerial/1.jpg";var aerial2=baseAssetUrl+"/images/gallery/images/aerial/2.jpg";var commonArea1=baseAssetUrl+"/images/gallery/images/common-area/1.jpg";var commonArea2=baseAssetUrl+"/images/gallery/images/common-area/2.jpg";var exterior1=baseAssetUrl+"/images/gallery/images/exterior/1.jpg";var exterior2=baseAssetUrl+"/images/gallery/images/exterior/2.jpg";var interior1=baseAssetUrl+"/images/gallery/images/interior/1.jpg";var interior2=baseAssetUrl+"/images/gallery/images/interior/2.jpg";var interior3=baseAssetUrl+"/images/gallery/images/interior/3.jpg";var interior4=baseAssetUrl+"/images/gallery/images/interior/4.jpg";var interior5=baseAssetUrl+"/images/gallery/images/interior/5.jpg";var interior6=baseAssetUrl+"/images/gallery/images/interior/6.jpg";var interior7=baseAssetUrl+"/images/gallery/images/interior/7.jpg";var interior8=baseAssetUrl+"/images/gallery/images/interior/8.jpg";var lifestyle1=baseAssetUrl+"/images/gallery/images/lifestyle/1.jpg";var lifestyle2=baseAssetUrl+"/images/gallery/images/lifestyle/2.jpg";var lifestyle3=baseAssetUrl+"/images/gallery/images/lifestyle/3.jpg";var lifestyle4=baseAssetUrl+"/images/gallery/images/lifestyle/4.jpg";var lifestyle5=baseAssetUrl+"/images/gallery/images/lifestyle/5.jpg";var videoSource=baseAssetUrl+"/images/gallery/video/Laguna Seaside3 slide image - lingual version.mp4";var video={en:videoSource,ru:videoSource,cn:videoSource};var heroShot=[{image:heroShotImg1},{image:heroShotImg2},{image:heroShotImg3},{image:heroShotImg4}];var categories=[{id:1,name:"All Images"},{id:2,name:"Aerial"},{id:3,name:"Exterior"},{id:4,name:"Interior"},{id:5,name:"Common Area"},{id:6,name:"Lifestyle"}];var images=[{categoryId:2,name:"Aerial – 1",image:aerial1},{categoryId:2,name:"Aerial – 2",image:aerial2},{categoryId:3,name:"Building 1",image:exterior1},{categoryId:3,name:"Building 2",image:exterior2},{categoryId:4,name:"1 Bedroom - Living room",image:interior1},{categoryId:4,name:"2 Bedroom - Living room",image:interior2},{categoryId:4,name:"2 Bedroom - Lanai",image:interior3},{categoryId:4,name:"2 Bedroom - Section",image:interior4},{categoryId:4,name:"3 Bedroom - Living room",image:interior5},{categoryId:4,name:"3 Bedroom - Lanai",image:interior6},{categoryId:4,name:"2 bedroom - garden",image:interior7},{categoryId:4,name:"3 bedroom - garden",image:interior8},{categoryId:5,name:"Rooftop Pool",image:commonArea1},{categoryId:5,name:"Rooftop Facilities",image:commonArea2},{categoryId:6,name:"Lifestyle",image:lifestyle1},{categoryId:6,name:"Lifestyle",image:lifestyle2},{categoryId:6,name:"Lifestyle",image:lifestyle3},{categoryId:6,name:"Lifestyle",image:lifestyle4},{categoryId:6,name:"Lifestyle",image:lifestyle5}];var image360=null;/* harmony default export */ __webpack_exports__["a"] = ({heroShot:heroShot,categories:categories,images:__WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(images,function(image){return Object.assign({},image,{category:__WEBPACK_IMPORTED_MODULE_0_lodash_find___default()(categories,{id:image.categoryId})});}),video:video,image360:image360,view360:[{id:"AERIAL",type:"virtual-tour",src:baseAssetUrl+"/360/aerial/index.html",list:[]},{id:"INTERIOR",type:"virtual-tour",src:baseAssetUrl+"/360/interior/index.html"}]});

/***/ }),
/* 867 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(2);
var baseAssetUrl=Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])("laguna-seaside-residences");var img1=baseAssetUrl+"/images/concept/1.jpg";var img2=baseAssetUrl+"/images/concept/2.jpg";var img3=baseAssetUrl+"/images/concept/3.jpg";var img4=baseAssetUrl+"/images/concept/4.jpg";var imageSlider=[{image:img1},{image:img2},{image:img3},{image:img4}];var content={en:"<h2 style=\"text-align: center;margin-top: 60px;\">BEACH RESORT LIVING</h2>\n    <p>Located within Laguna Phuket and a few short steps to Bangtao Beach, Laguna Seaside Residences is the newest address in Asia\u2019s finest intergrated resort.</p>\n    <br />\n    <p>The development is ideally positioned just a few metres from the beach itself and features a dedicated beach area which offers owners the best seats in the house to enjoy the stunning sunset over the light - speckled waters of the Andaman Sea.</p>\n    <br />\n    <p>A unique roof top recreation area provides a communal space for residents to enjoy the tropical outdoors, enriching their lifestyle, and adding to the development\u2019s carefree beach resort vibe.</p>",cn:"<h2 style=\"text-align: center;margin-top: 40px;\">\u6D77\u6EE8\u5EA6\u5047\u751F\u6D3B</h2>\n    <p>\u5168\u65B0\u7684\u4E50\u53E4\u6D6A\u6D77\u6EE8\u4F4F\u5B85\u4F4D\u4E8E\u4E9A\u6D32\u9876\u7EA7\u7EFC\u5408\u5EA6\u5047\u6751\u666E\u5409\u4E50\u53E4\u6D6A\uFF0C\u8DDD\u79BB\u90A6\u6D9B\u6D77\u6EE9\u4EC5\u51E0\u6B65\u4E4B\u9065\u3002</p>\n    <br />\n    <p>\u8BE5\u9879\u76EE\u5730\u7406\u4F4D\u7F6E\u4F18\u8D8A\uFF0C\u8DDD\u79BB\u6D77\u6EE9\u53EA\u6709\u6570\u7C73\u5E76\u62E5\u6709\u4E00\u4E2A\u4E13\u5C5E\u6D77\u6EE9\u533A\uFF0C\u4E3A\u4E1A\u4E3B\u63D0\u4F9B\u6B23\u8D4F\u5B89\u8FBE\u66FC\u6D77\u4E0A\u58EE\u89C2\u843D\u65E5\u7684\u7EDD\u4F73\u4F4D\u7F6E\u3002</p>\n    <br />\n    <p>\u72EC\u7279\u7684\u5C4B\u9876\u4F11\u95F2\u533A\u4E3A\u5C45\u6C11\u63D0\u4F9B\u4E00\u4E2A\u4EAB\u53D7\u70ED\u5E26\u6237\u5916\u73AF\u5883\u7684\u516C\u5171\u7A7A\u95F4\uFF0C\u4E30\u5BCC\u4ED6\u4EEC\u7684\u751F\u6D3B\u65B9\u5F0F\uFF0C\u4E5F\u8425\u9020\u51FA\u95F2\u9002\u60EC\u610F\u7684\u6D77\u6EE9\u5EA6\u5047\u6C1B\u56F4\u3002</p>",ru:"<h2 style=\"text-align: center;margin-top: 40px;\">\u0416\u0438\u0437\u043D\u044C \u043D\u0430 \u043F\u043B\u044F\u0436\u043D\u043E\u043C \u043A\u0443\u0440\u043E\u0440\u0442\u0435</h2>\n    <p>Laguna Seaside Residences \u2014 \u044D\u0442\u043E \u043D\u043E\u0432\u044B\u0439 \u0436\u0438\u043B\u043E\u0439 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0441 \u0432 \u041B\u0430\u0433\u0443\u043D\u0430 \u041F\u0445\u0443\u043A\u0435\u0442 \u2013 \u0432 \u043B\u0443 \u0447\u0448\u0435\u043C \u0438\u043D\u0442\u0435\u0433\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u043C \u043A\u0443\u0440\u043E\u0440\u0442\u0435 \u0410\u0437\u0438\u0438 \u0438 \u0432 \u0448\u0430\u0433\u043E\u0432\u043E\u0439 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E\u0441\u0442\u0438 \u043E\u0442 \u043F\u043B\u044F\u0436\u0430 \u0411\u0430\u043D\u0433\u0442\u0430\u043E</p>\n    <br />\n    <p>\u0416\u0438\u043B\u043E\u0439 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0441 \u0438\u0434\u0435\u0430\u043B\u044C\u043D\u043E \u0440\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D \u0432\u0441\u0435\u0433\u043E \u0432 \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u0438\u0445 \u043C\u0435\u0442\u0440\u0430\u0445 \u043E\u0442 \u043F\u043B\u044F\u0436\u0430 \u0438 \u0432\u043A\u043B\u044E\u0447\u0430\u0435\u0442 \u043E\u0442\u0434\u0435\u043B\u044C\u043D\u0443\u044E \u043F\u043B\u044F\u0436\u043D\u0443\u044E \u0437\u043E\u043D\u0443, \u043E\u0442\u043A\u0443\u0434\u0430 \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u044B \u043C\u043E\u0433\u0443\u0442 \u043D\u0430\u0441\u043B\u0430\u0434\u0438\u0442\u044C\u0441\u044F \u043B\u0443\u0447\u0448\u0438\u043C\u0438 \u0432\u0438\u0434\u0430\u043C\u0438 \u043D\u0430 \u0437\u0430\u043A\u0430\u0442 \u0441\u043E\u043B\u043D\u0446\u0430 \u043D\u0430\u0434 \u0438\u0441\u043A\u0440\u044F\u0449\u0438\u043C\u0438\u0441\u044F \u0432\u043E\u0434\u0430\u043C\u0438 \u0410\u043D\u0434\u0430\u043C\u0430\u043D\u0441\u043A\u043E\u0433\u043E \u043C\u043E\u0440\u044F.</p>\n    <br />\n    <p>\u041D\u0430 \u043A\u0440\u044B\u0448\u0435 \u0432\u0441\u0435\u0445 \u0447\u0435\u0442\u044B\u0440\u0435\u0445 \u043C\u0430\u043B\u043E\u044D\u0442\u0430\u0436\u043D\u044B\u0445 \u0437\u0434\u0430\u043D\u0438\u0439 Laguna Seaside Residences \u0440\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0430 \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u0430\u044F \u0437\u043E\u043D\u0430 \u043E\u0431\u0449\u0435\u0433\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F, \u0433\u0434\u0435 \u0436\u0438\u0442\u0435\u043B\u0438 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0441\u0430 \u043C\u043E\u0433\u0443\u0442 \u043E\u0442\u0434\u043E\u0445\u043D\u0443\u0442\u044C \u043D\u0430 \u043E\u0442\u043A\u0440\u044B\u0442\u043E\u043C \u0432\u043E\u0437\u0434\u0443\u0445\u0435 \u0441\u0440\u0435\u0434\u0438 \u0442\u0440\u043E\u043F\u0438\u043A\u043E\u0432, \u0440\u0430\u0437\u043D\u043E\u043E\u0431\u0440\u0430\u0437\u044F \u0441\u0432\u043E\u0439 \u043E\u0431\u0440\u0430\u0437 \u0436\u0438\u0437\u043D\u0438 \u0438 \u0432\u043D\u043E\u0441\u044F \u0432\u043A\u043B\u0430\u0434 \u0432 \u043E\u0436\u0438\u0432\u043B\u0435\u043D\u043D\u0443\u044E \u0438 \u0431\u0435\u0437\u0437\u0430\u0431\u043E\u0442\u043D\u0443\u044E \u0430\u0442\u043C\u043E\u0441\u0444\u0435\u0440\u0443 \u043F\u043B\u044F\u0436\u043D\u043E\u0433\u043E \u043A\u0443\u0440\u043E\u0440\u0442\u0430.</p>"};/* harmony default export */ __webpack_exports__["a"] = ({imageSlider:imageSlider,content:content});

/***/ }),
/* 868 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(2);
var maps=Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])("phuket-laguna-park-2")+"/images/master-plan/image.jpg";/* harmony default export */ __webpack_exports__["a"] = ({maps:maps});

/***/ }),
/* 869 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__svg_floor_roof__ = __webpack_require__(870);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__svg_floor_1__ = __webpack_require__(871);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__svg_floor_2__ = __webpack_require__(872);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__svg_floor_3__ = __webpack_require__(873);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__svg_floor_4__ = __webpack_require__(874);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__svg_floor_5__ = __webpack_require__(875);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__svg_floor_siteplan__ = __webpack_require__(876);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__data_LagunaBeachside_sitePlan_svg_coming_soon__ = __webpack_require__(320);
var subType=[{value:"all",title:{en:"ALL",ru:"Все",cn:"全部"}},{value:"1-bed",title:{en:"1 Bedroom",ru:"1 Bedroom",cn:"1 卧室"}},{value:"2-bed",title:{en:"2 Bedroom",ru:"2 Bedroom",cn:"2 卧室"}},{value:"3-bed",title:{en:"3 Bedroom",ru:"3 Bedroom",cn:"3 卧室"}}];var subTabs=[{value:"all",title:{en:"All",ru:"Все",cn:"全部"},showModal:false,img:__WEBPACK_IMPORTED_MODULE_1__svg_floor_1__["a" /* default */]// img: Siteplan,
},{value:"a",title:{en:"Block 1",ru:"Блок 1",cn:"1栋"},showModal:false,img:__WEBPACK_IMPORTED_MODULE_1__svg_floor_1__["a" /* default */]}];var type=[{value:"roof",title:{en:"roof Floor",ru:"roof Floor",cn:"roof Floor"},floorPlan:{all:__WEBPACK_IMPORTED_MODULE_0__svg_floor_roof__["a" /* default */],a:__WEBPACK_IMPORTED_MODULE_0__svg_floor_roof__["a" /* default */],b:__WEBPACK_IMPORTED_MODULE_0__svg_floor_roof__["a" /* default */],c:__WEBPACK_IMPORTED_MODULE_0__svg_floor_roof__["a" /* default */],d:__WEBPACK_IMPORTED_MODULE_0__svg_floor_roof__["a" /* default */]// d: Comming,
},buttons:subType},{value:"1st",title:{en:"1st Floor",ru:"1-й этаж",cn:"1楼"},floorPlan:{all:__WEBPACK_IMPORTED_MODULE_1__svg_floor_1__["a" /* default */],a:__WEBPACK_IMPORTED_MODULE_1__svg_floor_1__["a" /* default */],b:__WEBPACK_IMPORTED_MODULE_1__svg_floor_1__["a" /* default */],c:__WEBPACK_IMPORTED_MODULE_1__svg_floor_1__["a" /* default */],d:__WEBPACK_IMPORTED_MODULE_1__svg_floor_1__["a" /* default */]},buttons:subType},{value:"2nd",title:{en:"2nd Floor",ru:"2-й этаж",cn:"2楼"},floorPlan:{all:__WEBPACK_IMPORTED_MODULE_2__svg_floor_2__["a" /* default */],a:__WEBPACK_IMPORTED_MODULE_2__svg_floor_2__["a" /* default */],b:__WEBPACK_IMPORTED_MODULE_2__svg_floor_2__["a" /* default */],c:__WEBPACK_IMPORTED_MODULE_2__svg_floor_2__["a" /* default */],d:__WEBPACK_IMPORTED_MODULE_2__svg_floor_2__["a" /* default */]},buttons:subType},{value:"3rd",title:{en:"3rd Floor",ru:"3-й этаж",cn:"3楼"},floorPlan:{all:__WEBPACK_IMPORTED_MODULE_3__svg_floor_3__["a" /* default */],a:__WEBPACK_IMPORTED_MODULE_3__svg_floor_3__["a" /* default */],b:__WEBPACK_IMPORTED_MODULE_3__svg_floor_3__["a" /* default */],c:__WEBPACK_IMPORTED_MODULE_3__svg_floor_3__["a" /* default */],d:__WEBPACK_IMPORTED_MODULE_3__svg_floor_3__["a" /* default */]},buttons:subType},{value:"4th",title:{en:"4th Floor",ru:"4-й этаж",cn:"4楼"},floorPlan:{all:__WEBPACK_IMPORTED_MODULE_4__svg_floor_4__["a" /* default */],a:__WEBPACK_IMPORTED_MODULE_4__svg_floor_4__["a" /* default */],b:__WEBPACK_IMPORTED_MODULE_4__svg_floor_4__["a" /* default */],c:__WEBPACK_IMPORTED_MODULE_4__svg_floor_4__["a" /* default */],d:__WEBPACK_IMPORTED_MODULE_4__svg_floor_4__["a" /* default */]},buttons:subType},{value:"5th",title:{en:"5th Floor",ru:"5-й этаж",cn:"5楼"},floorPlan:{all:__WEBPACK_IMPORTED_MODULE_5__svg_floor_5__["a" /* default */],a:__WEBPACK_IMPORTED_MODULE_5__svg_floor_5__["a" /* default */],b:__WEBPACK_IMPORTED_MODULE_5__svg_floor_5__["a" /* default */],c:__WEBPACK_IMPORTED_MODULE_5__svg_floor_5__["a" /* default */],d:__WEBPACK_IMPORTED_MODULE_5__svg_floor_5__["a" /* default */]},buttons:subType}];var descriptions=[{value:"1-bed",title:{en:"ONE-BEDROOM",cn:"1-卧室",ru:"1-Спальня"},des:{en:"Ideal for the modern lifestyle, the 1-bedroom condominium units at Laguna Beachside start at a spacious 59 sqm. A choice of fit-out options offers the flexibility for owners to customise their own living area.",cn:"悦海苑的一卧室公寓面积为59平方米起，空间宽敞，是现代生活方式的理想选择。可选的装修方案为业主带来个性定制起居空间的灵活性。",ru:"Идеально подходят для современного образа жизни, площадь 1 спальных просторных квартир начинается от 59 кв. м.Владельцы могут воспользоваться рядом индивидуальных вариантов обустройства квартиры или выбрать полностью обставленный вариант."}},{value:"2-bed",title:{en:"TWO-BEDROOM",cn:"2-卧室",ru:"2-Спальня"},des:{en:"The larger 2-bedroom units are designed to enjoy maximum panoramic views from their respective full width lanai.",cn:"更大的两卧室公寓可从各自的全宽休闲阳台欣赏到开阔的全景。",ru:"Планировка квартир с двумя спальнями позволяет максимально наслаждаться панорамнымными видами с их просторных веранд."}},{value:"3-bed",title:{en:"THREE-BEDROOM",cn:"3-卧室",ru:"3-Спальня"},des:{en:"The 3-bedroom units with the unique semi-outdoor lanai feature provides additional living space, which can be opened up to extend the balcony for relaxed outdoor living, or closed off with an optional glass screen to increase interior floor space",cn:"三卧室公寓拥有独特的半露天休闲阳台，提供额外的起居空间，并可开放至阳台，尽享休闲户外生活，或选用玻璃封闭以增加室内空间。",ru:"Варианты с 3 спальнями благодаря уникальной полуоткрытой веранде обеспечивают дополнительное жилое пространство, которое можно оставить открытым для расширения балкона и наслаждаться жизнью на свежем воздухе, или же остеклить для увеличения площади внутреннего пространства."}}];/* harmony default export */ __webpack_exports__["a"] = ({// maps,
type:type,subTabs:subTabs,descriptions:descriptions});

/***/ }),
/* 870 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(2);
var baseAssetUrl=Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* assetsPath */])("laguna-seaside-residences");/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var currentLang=_ref.currentLang,selectedType=_ref.selectedType,selectedBuilding=_ref.selectedBuilding;var BG=baseAssetUrl+"/images/site-plan/"+currentLang+"/roof.png";var shouldDisplay=function shouldDisplay(build,type){return selectedBuilding===build||selectedBuilding==="all"?"opacity-in":"opacity-out";};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 841.89 595.28",className:"site-plan-svg"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"map"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("image",{xlinkHref:BG,height:"100%",width:"100%"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"floorplan"}));});

/***/ }),
/* 871 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(2);
var baseAssetUrl=Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* assetsPath */])("laguna-seaside-residences");/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var currentLang=_ref.currentLang,selectedType=_ref.selectedType,selectedBuilding=_ref.selectedBuilding;var BG=baseAssetUrl+"/images/site-plan/"+currentLang+"/1.png";var shouldDisplay=function shouldDisplay(build,type){return(selectedType===type||selectedType==="all")&&(selectedBuilding===build||selectedBuilding==="all")?"opacity-in":"opacity-out";};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 800 500","data-name":"Layer 1",className:"site-plan-svg",height:"500px",width:"500px"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"map"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("image",{xlinkHref:BG,height:"100%",width:"100%"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"floorplan"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{className:"building-a"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"2-bed","data-name":"1_2",className:shouldDisplay("a","2-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"624.52 275.62 556.04 275.79 556.04 217.46 624.06 217.46 624.52 275.62",opacity:"0.8"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"3-bed","data-name":"1_3",className:shouldDisplay("a","3-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"625.93",y:"216.21",width:"89.43",height:"59.52",opacity:"0.8"})))));});

/***/ }),
/* 872 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(2);
var baseAssetUrl=Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* assetsPath */])("laguna-seaside-residences");/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var currentLang=_ref.currentLang,selectedType=_ref.selectedType,selectedBuilding=_ref.selectedBuilding;var BG=baseAssetUrl+"/images/site-plan/"+currentLang+"/2.png";var shouldDisplay=function shouldDisplay(build,type){return(selectedType===type||selectedType==="all")&&(selectedBuilding===build||selectedBuilding==="all")?"opacity-in":"opacity-out";};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 800 500","data-name":"Layer 1",className:"site-plan-svg"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"map"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("image",{xlinkHref:BG,height:"100%",width:"100%"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"floorplan"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{className:"building-a"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"1-bed",className:shouldDisplay("a","1-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"145",y:"292.09",width:"61.34",height:"37.85",transform:"translate(-10.81 6.36) rotate(-2.01)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"208.35",y:"289.82",width:"61.41",height:"37.85",transform:"translate(-10.69 8.58) rotate(-2.01)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"278.84",y:"283.68",width:"61.66",height:"37.85",transform:"translate(-10.43 11.06) rotate(-2.01)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"342.16",y:"281.54",width:"61.3",height:"37.85",transform:"matrix(1, -0.04, 0.04, 1, -10.32, 13.27)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"2-bed",className:shouldDisplay("a","2-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"624.59 277.98 558.24 278.15 558.24 220.93 624.15 220.93 624.59 277.98"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"476.99 268.12 410.7 270.6 408.65 211.27 474.51 208.99 476.99 268.12"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"545.86 277.92 479.28 280.4 477.27 222.39 543.41 220.1 545.86 277.92"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"3-bed",className:shouldDisplay("a","3-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"115.13",y:"219.74",width:"89.23",height:"59.79",transform:"translate(-8.62 5.73) rotate(-2)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"206.07",y:"216.47",width:"89.23",height:"59.79",transform:"matrix(1, -0.03, 0.03, 1, -8.45, 8.91)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"306.55",y:"212.93",width:"89.23",height:"59.79",transform:"matrix(1, -0.03, 0.03, 1, -8.27, 12.42)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"626.13",y:"220.27",width:"89.69",height:"57.97"})))));});

/***/ }),
/* 873 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(2);
var baseAssetUrl=Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* assetsPath */])("laguna-seaside-residences");/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var currentLang=_ref.currentLang,selectedType=_ref.selectedType,selectedBuilding=_ref.selectedBuilding;var BG=baseAssetUrl+"/images/site-plan/"+currentLang+"/3.png";var shouldDisplay=function shouldDisplay(build,type){return(selectedType===type||selectedType==="all")&&(selectedBuilding===build||selectedBuilding==="all")?"opacity-in":"opacity-out";};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 800 500","data-name":"Layer 1",className:"site-plan-svg"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"map"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("image",{xlinkHref:BG,height:"100%",width:"100%"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"floorplan"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{className:"building-a"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"1-bed",className:shouldDisplay("a","1-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"143.72",y:"292.05",width:"62.41",height:"37.83",transform:"translate(-10.81 6.33) rotate(-2.01)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"208.54",y:"289.73",width:"61.33",height:"38.23",transform:"translate(-10.69 8.59) rotate(-2.01)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"277.68",y:"283.48",width:"62.41",height:"37.83",transform:"translate(-10.43 11.03) rotate(-2.01)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"341.72",y:"281.32",width:"61.69",height:"37.83",transform:"translate(-10.31 13.26) rotate(-2.01)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"404.99",y:"279.13",width:"62.17",height:"37.83",transform:"matrix(1, -0.04, 0.04, 1, -10.19, 15.49)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"2-bed",className:shouldDisplay("a","2-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"624.82 277.97 558.51 278.15 558.51 218.83 624.38 218.83 624.82 277.97"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"476.48 268.12 410.02 270.6 407.97 211.31 474 209.03 476.48 268.12"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"547.17 277.78 479.32 280.31 477.27 221.02 544.68 218.69 547.17 277.78"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"3-bed",className:shouldDisplay("a","3-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"115.24",y:"219.55",width:"89.18",height:"59.76",transform:"translate(-8.62 5.74) rotate(-2)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"206.13",y:"216.28",width:"89.18",height:"59.76",transform:"translate(-8.45 8.91) rotate(-2)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"306.55",y:"212.74",width:"89.18",height:"59.76",transform:"translate(-8.26 12.42) rotate(-2)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"626.36",y:"218.86",width:"89.64",height:"59.76"})))));});

/***/ }),
/* 874 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(2);
var baseAssetUrl=Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* assetsPath */])("laguna-seaside-residences");/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var currentLang=_ref.currentLang,selectedType=_ref.selectedType,selectedBuilding=_ref.selectedBuilding;var BG=baseAssetUrl+"/images/site-plan/"+currentLang+"/4.png";var shouldDisplay=function shouldDisplay(build,type){return(selectedType===type||selectedType==="all")&&(selectedBuilding===build||selectedBuilding==="all")?"opacity-in":"opacity-out";};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 800 500","data-name":"Layer 1",className:"site-plan-svg"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"map"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("image",{xlinkHref:BG,height:"100%",width:"100%"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"floorplan"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{className:"building-a"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"1-bed",className:shouldDisplay("a","1-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"143.34",y:"292.05",width:"63.27",height:"37.85",transform:"translate(-10.81 6.33) rotate(-2.01)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"208.54",y:"289.6",width:"60.92",height:"37.85",transform:"translate(-10.68 8.58) rotate(-2.01)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"277.66",y:"283.51",width:"62.44",height:"37.85",transform:"translate(-10.43 11.03) rotate(-2.01)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"341.74",y:"281.35",width:"61.72",height:"37.85",transform:"translate(-10.31 13.27) rotate(-2.01)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"405.05",y:"279.16",width:"62.21",height:"37.85",transform:"translate(-10.2 15.5) rotate(-2.01)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"2-bed",className:shouldDisplay("a","2-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"624.59 277.51 558.24 277.68 558.24 220.73 624.15 220.73 624.59 277.51"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"477.3 268.12 409.42 270.65 407.37 211.33 474.81 208.99 477.3 268.12"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"547.52 277.94 479.63 280.46 477.64 222.74 545.08 220.41 547.52 277.94"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"3-bed",className:shouldDisplay("a","3-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"115.14",y:"220.42",width:"89.23",height:"58.91",transform:"translate(-8.63 5.73) rotate(-2)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"206.08",y:"216.64",width:"89.97",height:"59.41",transform:"translate(-8.45 8.92) rotate(-2)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"306.56",y:"213.58",width:"89.23",height:"58.94",transform:"translate(-8.28 12.42) rotate(-2)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"626.57",y:"220.08",width:"89.24",height:"57.93"})))));});

/***/ }),
/* 875 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(2);
var baseAssetUrl=Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* assetsPath */])("laguna-seaside-residences");/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var currentLang=_ref.currentLang,selectedType=_ref.selectedType,selectedBuilding=_ref.selectedBuilding;var BG=baseAssetUrl+"/images/site-plan/"+currentLang+"/5.png";var shouldDisplay=function shouldDisplay(build,type){return(selectedType===type||selectedType==="all")&&(selectedBuilding===build||selectedBuilding==="all")?"opacity-in":"opacity-out";};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 800 500","data-name":"Layer 1",className:"site-plan-svg"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"map"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("image",{xlinkHref:BG,height:"100%",width:"100%"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"floorplan"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{className:"building-a"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"1-bed",className:shouldDisplay("a","1-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"142.78",y:"292.06",width:"63.83",height:"37.85",transform:"translate(-10.81 6.32) rotate(-2.01)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"208.3",y:"289.48",width:"63.57",height:"38.31",transform:"matrix(1, -0.04, 0.04, 1, -10.69, 8.62)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"277.77",y:"283.51",width:"62.44",height:"37.85",transform:"translate(-10.43 11.03) rotate(-2.01)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"341.85",y:"281.34",width:"61.72",height:"37.85",transform:"translate(-10.31 13.27) rotate(-2.01)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"405.16",y:"279.16",width:"62.21",height:"37.85",transform:"translate(-10.2 15.5) rotate(-2.01)"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"2-bed",className:shouldDisplay("a","2-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"624.7 277.73 558.35 277.91 558.35 218.55 624.26 218.55 624.7 277.73"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"477.1 268.1 409.37 270.62 407.32 211.3 474.6 208.97 477.1 268.1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"547.68 277.54 479.8 280.06 477.75 220.74 545.19 218.41 547.68 277.54"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"3-bed",className:shouldDisplay("a","3-bed")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"115.24",y:"219.54",width:"89.23",height:"59.79",transform:"translate(-8.62 5.74) rotate(-2)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"206.19",y:"216.27",width:"89.23",height:"59.79",transform:"matrix(1, -0.03, 0.03, 1, -8.45, 8.91)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"306.66",y:"212.73",width:"89.23",height:"59.79",transform:"translate(-8.26 12.42) rotate(-2)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"627.06",y:"218.44",width:"88.75",height:"59.11"})))));});

/***/ }),
/* 876 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(2);
// import _ from 'lodash'
// import MultiLineText from './MultiLineText';
var baseAssetUrl=Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* assetsPath */])("laguna-seaside-residences");/* unused harmony default export */ var _unused_webpack_default_export = (function(_ref){var currentLang=_ref.currentLang,handleClick=_ref.handleClick;var shouldDisplayByLang=function shouldDisplayByLang(selectLang){return currentLang===selectLang?"display":"display-none";};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 800 500",className:"allfloor-of-unitplan"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"cn",className:shouldDisplayByLang("cn")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("image",{xlinkHref:baseAssetUrl+"/images/site-plan/cn.png"// height="100%"
,width:"100%"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"ru",className:shouldDisplayByLang("ru")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("image",{xlinkHref:baseAssetUrl+"/images/site-plan/ru.png"// height="100%"
,width:"100%"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"en",className:shouldDisplayByLang("en")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("image",{xlinkHref:baseAssetUrl+"/images/site-plan/en.png"// height="100%"
,width:"100%"}))));});

/***/ }),
/* 877 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(2);
var selectPath=function selectPath(str){return""+Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])("laguna-beachside")+str;};var landingPage=[{image:selectPath("/images/residence/landing-page/1.jpg")},{image:selectPath("/images/residence/landing-page/2.jpg")},{image:selectPath("/images/residence/landing-page/3.jpg")},{image:selectPath("/images/residence/landing-page/4.jpg")},{image:selectPath("/images/residence/landing-page/5.jpg")},{image:selectPath("/images/residence/landing-page/6.jpg")}];var type=[{// name: "ONE-BEDROOM",
name:{en:"ONE-BEDROOM",cn:"1-卧室",ru:"1-Спальня"},thumbnail:[{image:selectPath("/images/residence/thumbnail/1-bed/1.jpg")},{image:selectPath("/images/residence/thumbnail/1-bed/1.jpg")}],buttons:[{type:"description",value:0,name:"Description",title:"Description",description:{en:"<p>Ideal for the modern lifestyle, the 1-bedroom condominium units at Laguna Seaside Residences start at a spacious 60 sqm. A choice of fit-out options offers the flexibility for owners to customise their own living area.</p>",cn:"<p>乐古浪海滨住宅的一卧室公寓面积为60平方米起，空间宽敞，是现代生活方式的理想选择。可选的装修方案为业主带来个性定制起居空间的灵活性。</p>",ru:"<p>Ideal for the modern lifestyle, the 1-bedroom condominium units at Laguna Seaside Residences start at a spacious 60 sqm. A choice of fit-out options offers the flexibility for owners to customise their own living area.</p>"},images:[{image:selectPath("/images/residence/description/1-bed/1.jpg")},{image:selectPath("/images/residence/description/1-bed/2.jpg")}]},// {
//   type: "plan",
//   // name: "TYPE A",
//   name: {
//     en: "TYPE A",
//     cn: "A 型",
//     ru: "тип A",
//   },
//   value: 1,
//   floorPlan: {
//     en: selectPath("/images/residence/floor-plan/1-bed/en/1.png"),
//     ru: selectPath("/images/residence/floor-plan/1-bed/eu/1.png"),
//     cn: selectPath("/images/residence/floor-plan/1-bed/cn/1.png"),
//   },
//   images: [],
//   image360: [],
//   imageVirtual: [],
// },
{type:"plan",// name: "TYPE B",
name:{en:"TYPE B",cn:"B 型",ru:"тип B"},value:2,floorPlan:{en:selectPath("/images/residence/floor-plan/1-bed/en/2.png"),ru:selectPath("/images/residence/floor-plan/1-bed/ru/2.png"),cn:selectPath("/images/residence/floor-plan/1-bed/cn/2.png")},images:[],image360:[],imageVirtual:[]}]},{// name: "TWO-BEDROOM",
name:{en:"TWO-BEDROOM",cn:"2-卧室",ru:"2-Спальня"},thumbnail:[{image:selectPath("/images/residence/thumbnail/2-bed/1.jpg")},{image:selectPath("/images/residence/thumbnail/2-bed/1.jpg")}],buttons:[{type:"description",value:0,name:"Description",title:"Description",description:{en:"<p>The larger 2-bedroom units are designed to enjoy maximum panoramic views from their respective full width lanai.</p>",cn:"<p>更大的两卧室公寓可从各自的全宽休闲阳台欣赏到开阔的全景。</p>",ru:"<p>The larger 2-bedroom units are designed to enjoy maximum panoramic views from their respective full width lanai.</p>"},images:[{image:selectPath("/images/residence/description/2-bed/1.jpg")},{image:selectPath("/images/residence/description/2-bed/2.jpg")},{image:selectPath("/images/residence/description/2-bed/3.jpg")}]},{type:"plan",// name: "TYPE A",
name:{en:"TYPE A",cn:"A 型",ru:"тип A"},value:1,floorPlan:{en:selectPath("/images/residence/floor-plan/2-bed/en/1.png"),ru:selectPath("/images/residence/floor-plan/2-bed/ru/1.png"),cn:selectPath("/images/residence/floor-plan/2-bed/cn/1.png")},images:[],image360:[],imageVirtual:[],disclaimer:{en:"*The garden area shown on the first-floor plan shall be available for exclusive use of the owners of the first-floor condominium units.",cn:"*一楼楼层图上所显示的花园区域为一楼公寓业主的专属区域.",ru:"*The garden area shown on the first-floor plan shall be available for exclusive use of the owners of the first-floor condominium units."}}]},{// name: "THREE-BEDROOM",
name:{en:"THREE-BEDROOM",cn:"3-卧室",ru:"3-Спальня"},thumbnail:[{image:selectPath("/images/residence/thumbnail/3-bed/1.jpg")},{image:selectPath("/images/residence/thumbnail/3-bed/1.jpg")}],buttons:[{type:"description",value:0,name:"Description",title:"Description",description:{en:"<p>The 3-bedroom units with the unique semi-outdoor lanai feature provide additional living space, which can be opened up to extend the balcony for relaxed outdoor living, or closed off with an optional glass screen to increase interior floor space.</p>",cn:"<p>三卧室公寓拥有独特的半露天休闲阳台，提供额外的起居空间，并可开放至阳台，尽享休闲户外生活，或选用玻璃封闭以增加室内空间。</p>",ru:"<p>The 3-bedroom units with the unique semi-outdoor lanai feature provide additional living space, which can be opened up to extend the balcony for relaxed outdoor living, or closed off with an optional glass screen to increase interior floor space.</p>"},images:[{image:selectPath("/images/residence/description/3-bed/1.jpg")},{image:selectPath("/images/residence/description/3-bed/2.jpg")}]},{type:"plan",// name: "TYPE A",
name:{en:"TYPE A",cn:"A 型",ru:"тип A"},value:1,floorPlan:{en:selectPath("/images/residence/floor-plan/3-bed/en/1.png"),ru:selectPath("/images/residence/floor-plan/3-bed/ru/1.png"),cn:selectPath("/images/residence/floor-plan/3-bed/cn/1.png")},images:[],image360:[],imageVirtual:[],disclaimer:{en:"*The garden area shown on the first-floor plan shall be available for exclusive use of the owners of the first-floor condominium units.",cn:"*一楼楼层图上所显示的花园区域为一楼公寓业主的专属区域.",ru:"*The garden area shown on the first-floor plan shall be available for exclusive use of the owners of the first-floor condominium units."}},{type:"plan",// name: "TYPE B",
name:{en:"TYPE B",cn:"B 型",ru:"тип B"},value:2,floorPlan:{en:selectPath("/images/residence/floor-plan/3-bed/en/2.png"),ru:selectPath("/images/residence/floor-plan/3-bed/ru/2.png"),cn:selectPath("/images/residence/floor-plan/3-bed/cn/2.png")},images:[],image360:[],imageVirtual:[],disclaimer:{en:"*The garden area shown on the first-floor plan shall be available for exclusive use of the owners of the first-floor condominium units.",cn:"*一楼楼层图上所显示的花园区域为一楼公寓业主的专属区域.",ru:"*The garden area shown on the first-floor plan shall be available for exclusive use of the owners of the first-floor condominium units."}}]}];/* harmony default export */ __webpack_exports__["a"] = ({landingPage:landingPage,type:type});

/***/ }),
/* 878 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(2);
var landingPage=[{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+'/images/destination/landing-page/1.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+'/images/destination/landing-page/2.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+'/images/destination/landing-page/3.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+'/images/destination/landing-page/4.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+'/images/destination/landing-page/5.jpg'}];var map=[{value:"country",name:"Country Map",image:{en:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+'/images/destination/country-map/map-country_en.png',cn:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+'/images/destination/country-map/map-country_cn.png',ru:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+'/images/destination/country-map/map-country_ru.png'}},{value:"city",name:"City Map",images:[{name:"Airport",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])()+'/images/icon/map-icon-01.png',image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+'/images/destination/city-map/airport.png'},{name:"Beaches",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])()+'/images/icon/map-icon-02.png',image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+'/images/destination/city-map/beach.png'},{name:"Islands",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])()+'/images/icon/map-icon-03.png',image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+'/images/destination/city-map/island.png'},{name:"Schools",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])()+'/images/icon/map-icon-05.png',image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+'/images/destination/city-map/school.png'},{name:"Tourist Attractions",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])()+'/images/icon/map-icon-06.png',image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+'/images/destination/city-map/tourist-attraction.png'}]},{value:"project",name:"Project Map",images:[{name:"Hotels & Resorts",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])()+'/images/icon/project-icon-01.png',svg:null},{name:"Restaurants",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])()+'/images/icon/project-icon-02.png',svg:null},{name:"Spas",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])()+'/images/icon/project-icon-03.png',svg:null},{name:"Galleries & Shopping",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])()+'/images/icon/project-icon-04.png',svg:null},{name:"Shuttle Bus",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])()+'/images/icon/project-icon-05.png',svg:null},{name:"Shuttle Boat",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])()+'/images/icon/project-icon-06.png',svg:null}]}];var content={title:"Destination",description:{en:"<p>Surrounded by the turquoise waters of the Andaman Sea and fringed by golden shores, Phuket is an island that compels travelers to visit from around the world.<br><br>Reaching Phuket is easy with direct flights from main cities around the world.The island is also linked to Thailand’s mainland by road.<br><br>Laguna Phuket itself is located in a prime west coast area of Phuket with proximity to an abundance of facilities. Local shopping malls, international schools and world-class hospitals are all close by, while Phuket’s international airport can be reached by car in just 25 minutes.<p>",cn:"<p>乐古浪普吉岛被金色海岸紧紧包围，四周萦绕着绿松石般的海水，这座岛屿吸引着世界各地的游客纷至沓来。<br><br>普吉岛的交通十分便捷，从世界主要城市搭乘直飞航班即可抵达。这里与泰国主岛相连，通过汽车或船只都可轻松到达。<br><br>乐古浪普吉岛位于普吉岛的西海岸，现代设施齐全。购物中心，国际学校，世界级医院随手可得，驱车25分钟即可到达普吉岛国际机场。<p>",ru:"<p>Остров Пхукет, окруженный лазурными водами Андаманского моря, омывающими золотистые песчаные пляжи, манит к себе путешественников со всего мира.<br><br>Добраться до острова очень просто: вылететь прямым рейсом можно из крупных городов разных стран. Из материковой части Таиланда сюда можно доехать на автомобиле по шоссейной дороге.<br><br>Курортный комплекс Laguna Phuket расположен на элитном западном побережье Пхукета. В непосредственной близости находится вся необходимая инфраструктура: торговые галереи, международные школы, больницы мирового уровня. До международного аэропорта Пхукета 25 минут езды на автомобиле.<p>"}};/* harmony default export */ __webpack_exports__["a"] = ({landingPage:landingPage,map:map,content:content});

/***/ }),
/* 879 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(2);
/* harmony default export */ __webpack_exports__["a"] = ({title:"The Santuary Club",description:{en:"Experience ultimate lifestyle within worldwide network under the Banyan Group. Membership is exclusively offered to the owners of Laguna, Banyan Tree, Angsana and Cassia properties only.",cn:"体验悦榕集团全球网络内的终极生活方式。仅向乐古浪、悦榕庄、悦椿和悦梿物业的业主 提供会员权益。",ru:"Наслаждайтесь роскошным стилем жизни, пользуясь глобальной сетью компании Banyan Group. Членство предлагается только владельцам собственности в рамках проектов Laguna, Banyan Tree , Angsana и Cassia."},image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])("laguna-beachside")+"/images/the-sanctuary-club/image.jpg"});

/***/ }),
/* 880 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Gallery; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Gallery=function(_Component){_inherits(Gallery,_Component);function Gallery(){_classCallCheck(this,Gallery);return _possibleConstructorReturn(this,(Gallery.__proto__||Object.getPrototypeOf(Gallery)).apply(this,arguments));}_createClass(Gallery,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common__["e" /* Gallery */],this.props);}}]);return Gallery;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 881 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Concept; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Concept=function(_Component){_inherits(Concept,_Component);function Concept(){_classCallCheck(this,Concept);return _possibleConstructorReturn(this,(Concept.__proto__||Object.getPrototypeOf(Concept)).apply(this,arguments));}_createClass(Concept,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common__["a" /* Concept */],this.props);}}]);return Concept;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 882 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Faq; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Faq=function(_Component){_inherits(Faq,_Component);function Faq(){_classCallCheck(this,Faq);return _possibleConstructorReturn(this,(Faq.__proto__||Object.getPrototypeOf(Faq)).apply(this,arguments));}_createClass(Faq,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common__["d" /* Faq */],this.props);}}]);return Faq;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 883 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Destination; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Bubble__ = __webpack_require__(365);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Destination=function(_Component){_inherits(Destination,_Component);function Destination(){_classCallCheck(this,Destination);return _possibleConstructorReturn(this,(Destination.__proto__||Object.getPrototypeOf(Destination)).apply(this,arguments));}_createClass(Destination,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common__["b" /* Destination */],Object.assign({},this.props,{project:"laguna-seaside-residences",projectMapChildren:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(1350, 860)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"laguna-seaside-residences-bubble-masterplan"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_Bubble__["a" /* default */],null)))}));}}]);return Destination;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 884 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TheSanctuaryclub; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TheSanctuaryclub=function(_Component){_inherits(TheSanctuaryclub,_Component);function TheSanctuaryclub(){_classCallCheck(this,TheSanctuaryclub);return _possibleConstructorReturn(this,(TheSanctuaryclub.__proto__||Object.getPrototypeOf(TheSanctuaryclub)).apply(this,arguments));}_createClass(TheSanctuaryclub,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common__["g" /* TheSanctuaryclub */],this.props);}}]);return TheSanctuaryclub;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 885 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Siteplan; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_findIndex__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_find__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isEmpty__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__hoc__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_icons_ArrowRight__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_icons_ArrowLeft__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__components_popup__ = __webpack_require__(886);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Siteplan=(_dec=Object(__WEBPACK_IMPORTED_MODULE_7__hoc__["a" /* multiLanguage */])(),_dec(_class=function(_Component){_inherits(Siteplan,_Component);function Siteplan(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Siteplan);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Siteplan.__proto__||Object.getPrototypeOf(Siteplan)).call.apply(_ref,[this].concat(args))),_this),_this.state={openModal:false,selectedType:"all",selectedBuilding:"all",pageModal:"1st",selectedSubTab:"all",pageModalSiteplan:"",pageModalData:null,popupHover:"",width:window.innerWidth},_this.hover=function(){var allEl=document.querySelectorAll("#floorplan path, #floorplan polygon, #floorplan rect");for(var i=0;i<allEl.length;i+=1){allEl[i].addEventListener("mouseover",_this.handleUnitHover);}},_this.unhover=function(){var allEl=document.querySelectorAll("#floorplan path, #floorplan polygon, #floorplan rect");for(var i=0;i<allEl.length;i+=1){allEl[i].addEventListener("mouseout",_this.handleUnitUnHover);}},_this.handleUnitUnHover=function(e){_this.setState({popupHover:""});},_this.handleUnitHover=function(e){var currentHoverType=e.target.parentElement.id;_this.setState({popupHover:currentHoverType});},_this.componentDidMount=function(){window.addEventListener("resize",_this.updateDimensions);_this.updateDimensions();},_this.updateDimensions=function(){var width=_this.state.width;_this.setState({width:window.innerWidth});},_this.componentWillUnmount=function(){window.removeEventListener("resize",_this.updateDimensions);},_this.test=function(val){var pageModal=_this.state.pageModal;var dataSitePlan=_this.props.dataSitePlan;var findPageModalData=__WEBPACK_IMPORTED_MODULE_3_lodash_find___default()(dataSitePlan,function(_ref2){var value=_ref2.value;return value===pageModal;});console.log("............ test",{val:val,dataSitePlan:dataSitePlan,findPageModalData:findPageModalData,pageModal:pageModal});_this.setState({pageModalData:findPageModalData||{},selectedSubTab:val});},_this.handleCloseModal=function(){_this.setState({openModal:false,selectedType:"all",pageModal:"1st",pageModalSiteplan:"",pageModalData:null});},_this.handleClickForOpenModal=function(pageModal){var dataSitePlan=_this.props.dataSitePlan;var findPageModalData=__WEBPACK_IMPORTED_MODULE_3_lodash_find___default()(dataSitePlan,function(_ref3){var value=_ref3.value;return value===pageModal;});_this.setState({openModal:true,selectedType:"all",pageModal:pageModal,pageModalData:findPageModalData||{}});},_this.handleSliderRight=function(){var dataSitePlan=_this.props.dataSitePlan;var pageModal=_this.state.pageModal;var sliderCurrentIndex=__WEBPACK_IMPORTED_MODULE_2_lodash_findIndex___default()(dataSitePlan,function(_ref4){var value=_ref4.value;return value===pageModal;});var lastDataSitePlanIndex=dataSitePlan.length-1;var sliderNextIndex=sliderCurrentIndex===lastDataSitePlanIndex?0:sliderCurrentIndex+1;var nextModal=__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(dataSitePlan,[sliderNextIndex]);var nextPageModal=__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(nextModal,"value");console.log("handleSliderRight",_defineProperty({sliderCurrentIndex:sliderCurrentIndex,nextModal:nextModal},"nextModal",nextModal));_this.setState({pageModal:nextPageModal,pageModalData:nextModal||{}});},_this.handleSliderLeft=function(){var dataSitePlan=_this.props.dataSitePlan;var pageModal=_this.state.pageModal;var sliderCurrentIndex=__WEBPACK_IMPORTED_MODULE_2_lodash_findIndex___default()(dataSitePlan,function(_ref5){var value=_ref5.value;return value===pageModal;});var lastDataSitePlanIndex=dataSitePlan.length-1;var sliderNextIndex=sliderCurrentIndex===0?lastDataSitePlanIndex:sliderCurrentIndex-1;var nextModal=__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(dataSitePlan,[sliderNextIndex]);var nextPageModal=__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(nextModal,"value");_this.setState({pageModal:nextPageModal,pageModalData:nextModal||{}});},_this.handleChangeType=function(selectedType){_this.setState({selectedType:selectedType});},_this.handleChangeSubTab=function(selectedSubTab){_this.setState({selectedSubTab:selectedSubTab});},_this.handleBlock=function(valueBlock){var pageModal=_this.state.pageModal;var dataSitePlan=_this.props.dataSitePlan;var findPageModalData=__WEBPACK_IMPORTED_MODULE_3_lodash_find___default()(dataSitePlan,function(_ref6){var value=_ref6.value;return value===pageModal;});console.log("handleBlock",{valueBlock:valueBlock,dataSitePlan:dataSitePlan,pageModal:pageModal});_this.setState({pageModalData:findPageModalData||{},selectedSubTab:valueBlock});},_this.renderPopup=function(){var _this$props=_this.props,descriptions=_this$props.descriptions,t=_this$props.t;var popupHover=_this.state.popupHover;var mapHoverData=__WEBPACK_IMPORTED_MODULE_0_lodash_map___default()(descriptions,function(item){var getTypePopup=__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item,"value");// const getDataPopup = _.get(item, "title");
var getTitlePopup=__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item,"title");var getDataPopup=__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item,"des");var activePopup=getTypePopup===popupHover?"active":"";// console.log("renderPopup", {
//   item,
//   getTypePopup,
//   getDataPopup,
//   activePopup,
// });
// console.log("renderPopup", { getTypePopup, popupHover, getTypePopup });
return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__components_popup__["a" /* default */],{title:t(getTitlePopup),data:t(getDataPopup),active:activePopup,onclick:_this.handleUnitHover});});return mapHoverData;},_this.renderAllFloor=function(){// const selectedSubTab = "a";
// const { selectedType, pageModalData, width } = this.state;
var _this$state=_this.state,selectedSubTab=_this$state.selectedSubTab,selectedType=_this$state.selectedType,pageModalData=_this$state.pageModalData,width=_this$state.width;var _this$props2=_this.props,subTabs=_this$props2.subTabs,currentLanguage=_this$props2.currentLanguage,t=_this$props2.t;var CurrentBlocks=function CurrentBlocks(){return null;};var showImg=__WEBPACK_IMPORTED_MODULE_3_lodash_find___default()(subTabs,function(_ref7){var value=_ref7.value;return value===selectedSubTab;});var mapElement=__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(pageModalData,"floorPlan."+selectedSubTab,null);console.log("renderAllFloor",{subTabs:subTabs,selectedSubTab:selectedSubTab,pageModalData:pageModalData});if(mapElement){CurrentBlocks=mapElement;}else{if(showImg){CurrentBlocks=showImg.img;}}console.log("SEASIDE RESIDENCES SITE-PLAN",{subTabs:subTabs,currentLanguage:currentLanguage,selectedSubTab:selectedSubTab,selectedType:selectedType,pageModalData:pageModalData,showImg:showImg});return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react__["Fragment"],null,_this.renderPopup(),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(CurrentBlocks,{currentLang:currentLanguage,selectedSubTab:selectedSubTab,selectedType:selectedType,selectedBuilding:selectedSubTab,handleClick:function handleClick(selectedModal){_this.handleClickForOpenModal(selectedModal);}}),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:"siteplan-button-group-subtabs"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components__["c" /* ButtonGroup */],{value:selectedType,items:__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(pageModalData,"buttons"),onChange:function onChange(value){_this.setState({selectedType:value,popupHover:value});setTimeout(function(){_this.setState({popupHover:""});},10000);},direction:width<992?"horizontal":"vertical",renderItem:function renderItem(_ref8){var value=_ref8.value,title=_ref8.title,active=_ref8.active,onClick=_ref8.onClick;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components__["b" /* Button */],{key:value,type:"secondary",active:active,activeStyle:{backgroundColor:"#00a9a5"},hoverStyle:{backgroundColor:"#00a9a5"},defaultStyle:{padding:"12px 17px",marginRight:"2px",fontWeight:"bold",fontSize:"13px",letterSpacing:"1px"},onClick:onClick},t(title));}})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:"button-slider"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("button",{onClick:_this.handleSliderLeft,className:"button-scroll-to-section left"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_icons_ArrowLeft__["a" /* default */],{width:40,height:40,fill:"#04a8a6"})),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("button",{onClick:_this.handleSliderRight,className:"button-scroll-to-section right"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_icons_ArrowRight__["a" /* default */],{width:40,height:40,fill:"#04a8a6"})))));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Siteplan,[{key:"componentDidUpdate",value:function componentDidUpdate(prevProps){this.hover();this.unhover();if(this.props.dataSitePlan!==prevProps.dataSitePlan){!__WEBPACK_IMPORTED_MODULE_4_lodash_isEmpty___default()(this.props.dataSitePlan)&&this.test("all");}}},{key:"render",value:function render(){var _this2=this;var _props=this.props,t=_props.t,currentLanguage=_props.currentLanguage,page=_props.page,subTabs=_props.subTabs,dataSitePlan=_props.dataSitePlan;var _state=this.state,pageModalData=_state.pageModalData,selectedSubTab=_state.selectedSubTab;// loop สร้าง siteplan ตาม floor และเมื่อคลิก floor ให้โชว์ popup 3 menu คลิก menu ไหนให้ filter โชว์แค่อันนั้น
// const CurrentBuildingPlan = _.get(pageModalData, `floorPlan.${currentLanguage}`);
// let CurrentBuildingPlan = () => {
//   return null;
// };
// if (pageModalData) {
//   CurrentBuildingPlan = pageModalData.floorPlan[selectedSubTab];
// }
// var MyComponent = Components[type + "Component"];
// return React.createElement(MyComponent, {});
return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:"section-siteplan "+page+" site-plan-has-menu"},this.renderAllFloor(),__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement("div",{className:"siteplan-container-buttongroup"},__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components__["c" /* ButtonGroup */],{value:selectedSubTab,items:subTabs,direction:"horizontal",renderItem:function renderItem(_ref9){var value=_ref9.value,title=_ref9.title,showModal=_ref9.showModal,active=_ref9.active,onClick=_ref9.onClick;return __WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_5_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components__["b" /* Button */],{key:value,type:"secondary",active:active,activeStyle:{backgroundColor:"#00a9a5"},hoverStyle:{backgroundColor:"#00a9a5"},defaultStyle:{padding:"12px 17px",marginRight:"2px",fontWeight:"bold",fontSize:"13px",letterSpacing:"1px"},onClick:function onClick(){console.log("SVG-FLOOR-CHANGE",{showModal:showModal,value:value});if(showModal===true){_this2.handleClickForOpenModalSiteplan(value);}else{_this2.handleBlock(value);}}},t(title)));}})));}}]);return Siteplan;}(__WEBPACK_IMPORTED_MODULE_5_react__["Component"]))||_class);

/***/ }),
/* 886 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_Close__ = __webpack_require__(101);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var popup=function(_Component){_inherits(popup,_Component);function popup(){_classCallCheck(this,popup);return _possibleConstructorReturn(this,(popup.__proto__||Object.getPrototypeOf(popup)).apply(this,arguments));}_createClass(popup,[{key:"render",value:function render(){var _props=this.props,data=_props.data,title=_props.title,active=_props.active,onclick=_props.onclick;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"popup "+active},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,title),data,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"button-close-popup"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{onClick:onclick,className:"button-scroll-to-section close"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_icons_Close__["a" /* default */],{width:20,height:20,fill:"#04a8a6"}))));}}]);return popup;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (popup);

/***/ }),
/* 887 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Masterplan; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_includes__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_filter__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_reject__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_reject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_reject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_animejs__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_animejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_animejs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_ProjectMap_PhuketMasterplan__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_ProjectMap_common_logos__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__hoc__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_navigation__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_detector__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_scroll__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Bubble__ = __webpack_require__(365);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import styled, { keyframes } from "styled-components";
// Filter LVR logo
var logos=__WEBPACK_IMPORTED_MODULE_3_lodash_reject___default()(__WEBPACK_IMPORTED_MODULE_7__containers_ProjectMap_common_logos__["a" /* default */],function(logo){return logo.key==="laguna-seaside-residences";});// const bounce = keyframes`
//   0% {
//     transform: scale(0);
//   }
//   20% {
//     transform: scale(1);
//   }
//   40% {
//     transform: scale(0.7);
//   }
//   60% {
//     transform: scale(1);
//   }
//   100% {
//     transform: scale(1);
//   }
// `;
// const AnimatedBubble = styled.g`
//   cursor: pointer;
//   animation-name: ${bounce};
//   animation-duration: 3s;
//   animation-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);
//   animation-iteration-count: infinite;
// `;
var filterTexts=function filterTexts(texts){return __WEBPACK_IMPORTED_MODULE_2_lodash_filter___default()(texts,function(text,i){var excludeList=__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(text,"options.excludes",[]);if(__WEBPACK_IMPORTED_MODULE_0_lodash_includes___default()(excludeList,"lpark2/masterplan")||__WEBPACK_IMPORTED_MODULE_0_lodash_includes___default()(excludeList,"masterplan"))return false;return true;});};var fixIETransform=function fixIETransform(id){return function(anim){var g=document.getElementById(id);if(g){var transform=getComputedStyle(g).getPropertyValue("transform");g.setAttribute("transform",transform);}};};var Masterplan=(_dec=Object(__WEBPACK_IMPORTED_MODULE_8__hoc__["a" /* multiLanguage */])(),_dec(_class=function(_Component){_inherits(Masterplan,_Component);function Masterplan(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Masterplan);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Masterplan.__proto__||Object.getPrototypeOf(Masterplan)).call.apply(_ref,[this].concat(args))),_this),_this.handleClickBubble=function(){// go to master plan
var headerHeight=Object(__WEBPACK_IMPORTED_MODULE_9__utils_navigation__["a" /* getHeaderHeight */])();__WEBPACK_IMPORTED_MODULE_11_react_scroll__["scroller"].scrollTo("siteplan",{duration:1500,smooth:true,offset:-headerHeight});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Masterplan,[{key:"componentDidMount",value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_5_animejs___default()({targets:"#laguna-seaside-residences-bubble",scale:[{value:0,duration:0,elasticity:0},{value:1,duration:2000,elasticity:400}],loop:true,update:__WEBPACK_IMPORTED_MODULE_10__utils_detector__["a" /* isIE */]?fixIETransform("laguna-seaside-residences-bubble"):null});}},{key:"render",value:function render(){var _props=this.props,t=_props.t,currentLanguage=_props.currentLanguage;// console.log('filterTexts >>> ', filterTexts);
return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",{className:"section-masterplan"},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__containers_ProjectMap_PhuketMasterplan__["a" /* default */],{activeLanguage:currentLanguage,filterTexts:filterTexts},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("g",{transform:"translate(270, 250)"},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("g",{id:"laguna-seaside-residences-bubble",onClick:this.handleClickBubble},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Bubble__["a" /* default */],null)))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",{className:"masterplan-name"},t("Master Plan")));}}]);return Masterplan;}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]))||_class);

/***/ }),
/* 888 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Residences; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Residences=function(_Component){_inherits(Residences,_Component);function Residences(){_classCallCheck(this,Residences);return _possibleConstructorReturn(this,(Residences.__proto__||Object.getPrototypeOf(Residences)).apply(this,arguments));}_createClass(Residences,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common__["f" /* Residences */],this.props);}}]);return Residences;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 889 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Ebrochure; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Ebrochure=function(_Component){_inherits(Ebrochure,_Component);function Ebrochure(){_classCallCheck(this,Ebrochure);return _possibleConstructorReturn(this,(Ebrochure.__proto__||Object.getPrototypeOf(Ebrochure)).apply(this,arguments));}_createClass(Ebrochure,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common__["c" /* Ebrochure */],this.props);}}]);return Ebrochure;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 890 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "category", function() { return category; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faqs", function() { return faqs; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var category=[{id:1,name:"Legal",displayOn:["en","cn","ru"]},{id:2,name:"Construction",displayOn:["en","cn","ru"]},{id:3,name:"Estate And Property Management",displayOn:["en","cn","ru"]},{id:4,name:"Owner benefits",displayOn:["en","cn","ru"]},{id:5,name:"Financing",displayOn:["en","cn","ru"]}];var faqs=[{categoryId:1,question:{en:"What types of ownership are available?",ru:"Какие формы собственности существуют?",cn:"有哪些类型的所有权?"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Condominiums are available on a freehold basis for both Thai and non-Thai buyers. However, according to current Thai law, non-Thais may only purchase up to 49% of the condominium\u2019s saleable area on a freehold basis. Otherwise, they may purchase any remaining units on a renewable leasehold basis (currently for a maximum period of 30 years as permitted by law).")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041F\u0440\u0438\u043E\u0431\u0440\u0435\u0442\u0435\u043D\u0438\u0435 \u043A\u0432\u0430\u0440\u0442\u0438\u0440 \u0432 \u043A\u043E\u043D\u0434\u043E\u043C\u0438\u043D\u0438\u0443\u043C\u0430\u0445 \u0432 \u043F\u043E\u043B\u043D\u0443\u044E \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u044C \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E \u043A\u0430\u043A \u0434\u043B\u044F \u0442\u0430\u0439\u0441\u043A\u0438\u0445 \u043F\u043E\u043A\u0443\u043F\u0430\u0442\u0435\u043B\u0435\u0439, \u0442\u0430\u043A \u0438 \u0434\u043B\u044F \u0438\u043D\u043E\u0441\u0442\u0440\u0430\u043D\u0446\u0435\u0432. \u041E\u0434\u043D\u0430\u043A\u043E, \u0441\u043E\u0433\u043B\u0430\u0441\u043D\u043E \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0449\u0435\u043C\u0443 \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0443 \u0422\u0430\u0438\u043B\u0430\u043D\u0434\u0430, \u043F\u043E\u043A\u0443\u043F\u0430\u0442\u0435\u043B\u0438, \u043D\u0435 \u044F\u0432\u043B\u044F\u044E\u0449\u0438\u0435\u0441\u044F \u0442\u0430\u0439\u0446\u0430\u043C\u0438, \u043C\u043E\u0433\u0443\u0442 \u043F\u0440\u0438\u043E\u0431\u0440\u0435\u0441\u0442\u0438 \u0432 \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u044C \u0442\u043E\u043B\u044C\u043A\u043E \u0434\u043E 49% \u043E\u0431\u0449\u0435\u0433\u043E \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u0430 \u043A\u0432\u0430\u0440\u0442\u0438\u0440 \u0432 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0441\u0435. \u041F\u0440\u0438 \u044D\u0442\u043E\u043C \u043E\u0441\u0442\u0430\u043B\u044C\u043D\u044B\u0435 \u043A\u0432\u0430\u0440\u0442\u0438\u0440\u044B \u043C\u043E\u0436\u043D\u043E \u043F\u0440\u0438\u043E\u0431\u0440\u0435\u0441\u0442\u0438 \u043D\u0430 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u0445 \u0434\u043E\u043B\u0433\u043E\u0441\u0440\u043E\u043E\u0447\u043D\u043E\u0439 \u0430\u0440\u0435\u043D\u0434\u044B \u0441 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u044C\u044E \u043C\u043D\u043E\u0433\u043E\u043A\u0440\u0430\u0442\u043D\u043E\u0433\u043E \u043F\u0440\u043E\u0434\u043B\u0435\u043D\u0438\u044F \u0430\u0440\u0435\u043D\u0434\u044B (\u043D\u0430 \u0434\u0430\u043D\u043D\u044B\u0439 \u043C\u043E\u043C\u0435\u043D\u0442 \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u044B\u0439 \u0441\u0440\u043E\u043A \u0430\u0440\u0435\u043D\u0434\u044B \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E\u043C \u0441\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 \u043D\u0430 30 \u043B\u0435\u0442).")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u5BF9\u4E8E\u6CF0\u56FD\u548C\u975E\u6CF0\u56FD\u4E70\u5BB6\u6765\u8BF4\uFF0C\u516C\u5BD3\u90FD\u53EF\u8D2D\u4E70\u6C38\u4E45\u4EA7\u6743\u3002\u7136\u800C\uFF0C\u6839\u636E\u6CF0\u56FD\u73B0\u884C\u6CD5\u5F8B\uFF0C\u975E\u6CF0\u56FD\u4EBA\u6700\u591A\u53EA\u80FD\u8D2D\u4E7049%\u7684\u516C\u5BD3\u53EF\u51FA\u552E\u9762\u79EF\u4F5C\u4E3A\u6C38\u4E45\u4EA7\u6743\u3002\u5426\u5219\uFF0C\u4ED6\u4EEC\u53EF\u901A\u8FC7\u53EF\u7EED\u79DF\u7684\u79DF\u8D41\u4EA7\u6743\u65B9\u5F0F\uFF08\u76EE\u524D\u6CD5\u5F8B\u5141\u8BB8\u7684\u6700\u957F\u79DF\u671F\u4E3A30\u5E74\uFF09\u8D2D\u4E70\u4EFB\u4F55\u5269\u4F59\u7684\u5355\u5143\u3002"))}},{categoryId:1,question:{en:"What are the costs associated with the lease / freehold registration?",ru:"Каковы затраты, связанные с арендой / регистрацией собственности?",cn:"与租赁/永久产权登记相关的费用是多少?"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Lease registration fees and stamp duty (currently 1.1% of the lease premium) is payable to the Land Department upon registration of the lease. The cost of lease renewals will be borne by the lessee according to the contracts."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Freehold registration fees (currently 2.0% of the appraisal price) is payable to the Land Department upon transfer and registration of title. The appraisal price is assessed by Thailand\u2019s Treasury Department which is generally below market value. Other applicable taxes upon transfer and registration of freehold title are:"," "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Corporate Income Withholding Tax (currently 1.0% of the selling price or appraisal price, whichever is higher)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Specific Business Tax (currently 3.3% of the selling price or appraisal price, whichever is higher)"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"The burden between seller and buyer for the above costs will be specified in the relevant agreements."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"Note: Applicable rates stated are current and may be subject to change.")))),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0421\u0431\u043E\u0440\u044B \u0437\u0430 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044E \u0430\u0440\u0435\u043D\u0434\u044B \u0438 \u0433\u0435\u0440\u0431\u043E\u0432\u044B\u0439 \u0441\u0431\u043E\u0440 (\u0432 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0435 \u0432\u0440\u0435\u043C\u044F 1,1 % \u043E\u0442 \u0430\u0440\u0435\u043D\u0434\u043D\u043E\u0439 \u043F\u043B\u0430\u0442\u044B) \u0443\u043F\u043B\u0430\u0447\u0438\u0432\u0430\u044E\u0442\u0441\u044F \u0432 \u0417\u0435\u043C\u0435\u043B\u044C\u043D\u044B\u0439 \u0434\u0435\u043F\u0430\u0440\u0442\u0430\u043C\u0435\u043D\u0442 \u043F\u0440\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0430\u0440\u0435\u043D\u0434\u044B. \u0420\u0430\u0441\u0445\u043E\u0434\u044B \u043F\u043E \u043F\u0440\u043E\u0434\u043B\u0435\u043D\u0438\u044E \u0430\u0440\u0435\u043D\u0434\u044B \u043D\u0435\u0441\u0435\u0442 \u0430\u0440\u0435\u043D\u0434\u0430\u0442\u043E\u0440 \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u043C\u0438 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u043E\u0432."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0421\u0431\u043E\u0440\u044B \u0437\u0430 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044E \u043F\u0440\u0430\u0432\u0430 \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438 (\u0432 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0435 \u0432\u0440\u0435\u043C\u044F 2,0 % \u043E\u0442 \u043E\u0446\u0435\u043D\u043E\u0447\u043D\u043E\u0439 \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u0438) \u0443\u043F\u043B\u0430\u0447\u0438\u0432\u0430\u044E\u0442\u0441\u044F \u0432 \u0417\u0435\u043C\u0435\u043B\u044C\u043D\u044B\u0439 \u0434\u0435\u043F\u0430\u0440\u0442\u0430\u043C\u0435\u043D\u0442 \u043F\u0440\u0438 \u043F\u0435\u0440\u0435\u0434\u0430\u0447\u0435 \u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u043F\u0440\u0430\u0432\u0430 \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438. \u041E\u0446\u0435\u043D\u043E\u0447\u043D\u0430\u044F \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u044F\u0435\u0442\u0441\u044F \u041C\u0438\u043D\u0438\u0441\u0442\u0435\u0440\u0441\u0442\u0432\u043E\u043C \u0444\u0438\u043D\u0430\u043D\u0441\u043E\u0432 \u0422\u0430\u0438\u043B\u0430\u043D\u0434\u0430 \u0438 \u043E\u0431\u044B\u0447\u043D\u043E \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u043D\u0438\u0436\u0435 \u0440\u044B\u043D\u043E\u0447\u043D\u043E\u0439. \u0414\u0440\u0443\u0433\u0438\u0435 \u043F\u0440\u0438\u043C\u0435\u043D\u0438\u043C\u044B\u0435 \u043D\u0430\u043B\u043E\u0433\u0438 \u043F\u0440\u0438 \u043F\u0435\u0440\u0435\u0434\u0430\u0447\u0435 \u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u043F\u0440\u0430\u0432\u0430 \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u0432\u043A\u043B\u044E\u0447\u0430\u044E\u0442 \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0435:"," "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041D\u0430\u043B\u043E\u0433 \u043D\u0430 \u0434\u043E\u0445\u043E\u0434\u044B \u044E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u0438\u0445 \u043B\u0438\u0446 (\u0432 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0435 \u0432\u0440\u0435\u043C\u044F \u0441\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 1,0 % \u043E\u0442 \u043F\u0440\u043E\u0434\u0430\u0436\u043D\u043E\u0439 \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u0438 \u0438\u043B\u0438 \u043E\u0446\u0435\u043D\u043E\u0447\u043D\u043E\u0439 \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u0438, \u0432 \u0437\u0430\u0432\u0438\u0441\u0438\u043C\u043E\u0441\u0442\u0438 \u043E\u0442 \u0442\u043E\u0433\u043E, \u043A\u0430\u043A\u0430\u044F \u0438\u0437 \u043D\u0438\u0445 \u0432\u044B\u0448\u0435)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0421\u043F\u0435\u0446\u0438\u0430\u043B\u044C\u043D\u044B\u0439 \u043D\u0430\u043B\u043E\u0433 \u043D\u0430 \u043F\u0440\u0438\u0431\u044B\u043B\u044C (\u0432 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0435 \u0432\u0440\u0435\u043C\u044F \u0441\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 3,3 % \u043E\u0442 \u043F\u0440\u043E\u0434\u0430\u0436\u043D\u043E\u0439 \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u0438 \u0438\u043B\u0438 \u043E\u0446\u0435\u043D\u043E\u0447\u043D\u043E\u0439 \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u0438, \u0432 \u0437\u0430\u0432\u0438\u0441\u0438\u043C\u043E\u0441\u0442\u0438 \u043E\u0442 \u0442\u043E\u0433\u043E, \u043A\u0430\u043A\u0430\u044F \u0438\u0437 \u043D\u0438\u0445 \u0432\u044B\u0448\u0435)"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0430 \u0438 \u043F\u043E\u043A\u0443\u043F\u0430\u0442\u0435\u043B\u044F \u043F\u043E \u043E\u043F\u043B\u0430\u0442\u0435 \u0432\u044B\u0448\u0435\u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0445 \u0440\u0430\u0441\u0445\u043E\u0434\u043E\u0432 \u043E\u0433\u043E\u0432\u0430\u0440\u0438\u0432\u0430\u0435\u0442\u0441\u044F \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0445 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430\u0445."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"\u041F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0435: \u041F\u0440\u0438\u043C\u0435\u043D\u0438\u043C\u044B\u0435 \u0441\u0442\u0430\u0432\u043A\u0438 \u0443\u043A\u0430\u0437\u0430\u043D\u044B \u043F\u043E \u0441\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u044E \u043D\u0430 \u0442\u0435\u043A\u0443\u0449\u0438\u0439 \u043C\u043E\u043C\u0435\u043D\u0442 \u0438 \u043C\u043E\u0433\u0443\u0442 \u0431\u044B\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u044B.")))),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u79DF\u8D41\u767B\u8BB0\u65F6\u987B\u5411\u56FD\u571F\u90E8\u95E8\u7F34\u4ED8\u79DF\u8D41\u767B\u8BB0\u8D39\u548C\u5370\u82B1\u7A0E\uFF08\u5F53\u524D\u4E3A\u79DF\u8D41\u8D39\u76841.1%\uFF09\u3002\u79DF\u8D41\u7EED\u671F\u7684\u8D39\u7528\u5C06\u6839\u636E\u5408\u540C\u7531\u627F\u79DF\u4EBA\u627F\u62C5\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u6C38\u4E45\u4EA7\u6743\u8F6C\u8BA9\u548C\u767B\u8BB0\u65F6\uFF0C\u5E94\u5411\u56FD\u571F\u90E8\u95E8\u7F34\u4ED8\u4EA7\u6743\u767B\u8BB0\u8D39\uFF08\u5F53\u524D\u4E3A\u4F30\u4EF7\u76842.0%\uFF09\u3002\u4F30\u4EF7\u7531\u6CF0\u56FD\u8D22\u653F\u90E8\u8BC4\u4F30\uFF0C\u4E00\u822C\u4F1A\u4F4E\u4E8E\u5E02\u573A\u4EF7\u503C\u3002\u6C38\u4E45\u4EA7\u6743\u8F6C\u8BA9\u548C\u767B\u8BB0\u65F6\u9002\u7528\u7684\u5176\u4ED6\u7A0E\u5305\u62EC\uFF1A"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u4F01\u4E1A\u6240\u5F97\u9884\u6263\u7A0E\uFF08\u5F53\u524D\u4E3A\u552E\u4EF7\u6216\u4F30\u4EF7\u76841.0%\uFF0C\u4EE5\u8F83\u9AD8\u8005\u4E3A\u51C6\uFF09")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u7279\u6B8A\u8425\u4E1A\u7A0E\uFF08\u5F53\u524D\u4E3A\u552E\u4EF7\u6216\u4F30\u4EF7\u4EF7\u76843.3%\uFF0C\u4EE5\u8F83\u9AD8\u8005\u4E3A\u51C6\uFF09"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u5356\u65B9\u548C\u4E70\u65B9\u5BF9\u4E0A\u8FF0\u8D39\u7528\u7684\u627F\u62C5\u5C06\u5728\u76F8\u5173\u534F\u8BAE\u4E2D\u89C4\u5B9A\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"\u6CE8\uFF1A\u6240\u5217\u7684\u9002\u7528\u8D39\u7387\u4E3A\u5F53\u524D\u60C5\u51B5\uFF0C\u53EF\u80FD\u4F1A\u6709\u53D8\u5316\u3002"))))}},{categoryId:1,question:{en:"Is a leasehold condominium transferable?",ru:"Можно ли передать права долгосречной аренды на  квартиры в жилом комплексе другим лицам?",cn:"租赁公寓可以转让吗？"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Yes. Leasehold condominiums may be transferred subject to the terms and conditions of the lease agreement. Generally, a small fee is payable. In addition, the new owner must agree to be bound by the terms and conditions contained in the original lease agreement.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0414\u0430. \u041F\u0440\u0430\u0432\u0430 \u0434\u043E\u043B\u0433\u043E\u0441\u0440\u043E\u0447\u043D\u043E\u0439 \u0430\u0440\u0435\u043D\u0434\u044B \u043D\u0430 \u043A\u0432\u0430\u0440\u0442\u0438\u0440\u044B \u0432 \u043A\u043E\u043D\u0434\u043E\u043C\u0438\u043D\u0438\u0443\u043C\u0435 \u043C\u043E\u0433\u0443\u0442 \u0431\u044B\u0442\u044C \u043F\u0435\u0440\u0435\u0434\u0430\u043D\u044B \u0434\u0440\u0443\u0433\u0438\u043C \u043B\u0438\u0446\u0430\u043C \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u043C\u0438 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430 \u0430\u0440\u0435\u043D\u0434\u044B. \u041A\u0430\u043A \u043F\u0440\u0430\u0432\u0438\u043B\u043E, \u0437\u0430 \u044D\u0442\u043E \u0432\u0437\u0438\u043C\u0430\u0435\u0442\u0441\u044F \u043D\u0435\u0431\u043E\u043B\u044C\u0448\u0430\u044F \u043F\u043B\u0430\u0442\u0430. \u041A\u0440\u043E\u043C\u0435 \u0442\u043E\u0433\u043E, \u043D\u043E\u0432\u044B\u0439 \u0430\u0440\u0435\u043D\u0434\u0430\u0442\u043E\u0440 \u0434\u043E\u043B\u0436\u0435\u043D \u0432\u0437\u044F\u0442\u044C \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E \u043F\u043E \u0441\u043E\u0431\u043B\u044E\u0434\u0435\u043D\u0438\u044E \u0443\u0441\u043B\u043E\u0432\u0438\u0439, \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u0449\u0438\u0445\u0441\u044F \u0432 \u043F\u0435\u0440\u0432\u043E\u043D\u0430\u0447\u0430\u043B\u044C\u043D\u043E\u043C \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0435 \u0430\u0440\u0435\u043D\u0434\u044B.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u53EF\u4EE5\u3002\u79DF\u8D41\u516C\u5BD3\u53EF\u4EE5\u6309\u7167\u79DF\u8D41\u534F\u8BAE\u7684\u6761\u6B3E\u548C\u6761\u4EF6\u8F6C\u8BA9\u3002\u901A\u5E38\u9700\u8981\u652F\u4ED8\u5C11\u91CF\u8D39\u7528\u3002\u6B64\u5916\uFF0C\u65B0\u4E1A\u4E3B\u5FC5\u987B\u540C\u610F\u53D7\u539F\u79DF\u7EA6\u6761\u6B3E\u7EA6\u675F\u3002"))}},{categoryId:1,question:{en:"Is leasehold ownership secure?",ru:"Защищены ли права арендатора на арендованную недвижимость?",cn:"租赁所有权安全吗？"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Leasehold ownership is a common method of ownership for foreign buyers. Once the lease is registered at the Land Department, the lessee\u2019s rights over the condominium unit will be officially recognized.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0412\u043B\u0430\u0434\u0435\u043D\u0438\u0435 \u043D\u0430 \u043F\u0440\u0430\u0432\u0430\u0445 \u0434\u043E\u043B\u0433\u043E\u0441\u0440\u043E\u0447\u043D\u043E\u0439 \u0430\u0440\u0435\u043D\u0434\u044B \u2014 \u0440\u0430\u0441\u043F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u043D\u044B\u0439 \u0441\u043F\u043E\u0441\u043E\u0431 \u0432\u043B\u0430\u0434\u0435\u043D\u0438\u044F \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u044C\u044E \u0438\u043D\u043E\u0441\u0442\u0440\u0430\u043D\u043D\u044B\u043C\u0438 \u043F\u043E\u043A\u0443\u043F\u0430\u0442\u0435\u043B\u044F\u043C\u0438. \u041F\u043E\u0441\u043B\u0435 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430 \u0430\u0440\u0435\u043D\u0434\u044B \u0432 \u0417\u0435\u043C\u0435\u043B\u044C\u043D\u043E\u043C \u0434\u0435\u043F\u0430\u0440\u0442\u0430\u043C\u0435\u043D\u0442\u0435 \u043E\u0444\u0438\u0446\u0438\u0430\u043B\u044C\u043D\u043E \u043F\u0440\u0438\u0437\u043D\u0430\u044E\u0442\u0441\u044F \u043F\u0440\u0430\u0432\u0430 \u0430\u0440\u0435\u043D\u0434\u0430\u0442\u043E\u0440\u0430 \u043D\u0430 \u043A\u0432\u0430\u0440\u0442\u0438\u0440\u0443 \u0432 \u0436\u0438\u043B\u043E\u043C \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0441\u0435.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u79DF\u8D41\u4EA7\u6743\u662F\u5916\u56FD\u4E70\u5BB6\u7684\u4E00\u79CD\u5E38\u89C1\u6240\u6709\u6743\u65B9\u5F0F\u3002\u79DF\u7EA6\u4E00\u65E6\u5728\u56FD\u571F\u90E8\u95E8\u767B\u8BB0\uFF0C\u627F\u79DF\u4EBA\u7684\u516C\u5BD3\u6240\u6709\u6743\u5C06\u5F97\u5230\u6B63\u5F0F\u627F\u8BA4\u3002"))}},{categoryId:1,question:{en:"When will the registration and transfer of the condominiums take place?",ru:"В какой момент происходит регистрация и передача прав на квартиры в жилом комплексе?",cn:"公寓的登记和转让什么时候进行？"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Approximately 180 days after full payment has been received and construction of all buildings in the Project are completed and condominium license is obtained. We will notify the owner of any documents and fees required for registration. Owners may opt to accept the hand-over of their purchased/leased unit and move in before registration and transfer of condominium unit ownership, upon the occupancy permit of the building being granted (terms and conditions apply).")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 180 \u0434\u043D\u0435\u0439 \u043F\u043E\u0441\u043B\u0435 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u043F\u043E\u043B\u043D\u043E\u0439 \u043E\u043F\u043B\u0430\u0442\u044B \u0438 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 \u0432\u0441\u0435\u0445 \u0437\u0434\u0430\u043D\u0438\u0439 \u0432 \u0440\u0430\u043C\u043A\u0430\u0445 \u041F\u0440\u043E\u0435\u043A\u0442\u0430. \u041C\u044B \u0443\u0432\u0435\u0434\u043E\u043C\u0438\u043C \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0430 \u043E \u0442\u043E\u043C, \u043A\u0430\u043A\u0438\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B \u0438 \u043F\u043E\u0448\u043B\u0438\u043D\u044B \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u044B \u0434\u043B\u044F \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438. \u0412\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u044B \u043C\u043E\u0433\u0443\u0442 \u043D\u0430\u0447\u0430\u0442\u044C \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C\u0441\u044F \u0441\u0432\u043E\u0435\u0439 \u043A\u0432\u0430\u0440\u0442\u0438\u0440\u043E\u0439 \u0438 \u0432\u044C\u0435\u0445\u0430\u0442\u044C \u0434\u043E \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0438 \u043F\u0435\u0440\u0435\u0434\u0430\u0447\u0438 \u043F\u0440\u0430\u0432\u0430 \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u043D\u0430 \u043A\u0432\u0430\u0440\u0442\u0438\u0440\u0443 \u0432 \u043A\u043E\u043D\u0434\u043E\u043C\u0438\u043D\u0438\u0443\u043C\u0435 \u043F\u0440\u0438 \u043D\u0430\u043B\u0438\u0447\u0438\u0438 \u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u0438\u044F \u043D\u0430 \u043F\u0440\u043E\u0436\u0438\u0432\u0430\u043D\u0438\u0435 \u0432 \u044D\u0442\u043E\u043C \u0437\u0434\u0430\u043D\u0438\u0438 (\u043F\u0440\u0438\u043C\u0435\u043D\u044F\u044E\u0442\u0441\u044F \u0443\u0441\u043B\u043E\u0432\u0438\u044F).")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u5728\u6536\u5230\u5168\u90E8\u6B3E\u9879\u5E76\u5B8C\u6210\u9879\u76EE\u4E2D\u6240\u6709\u5EFA\u7B51\u7684\u5EFA\u9020\u540E\u4E14\u83B7\u5F97\u516C\u5BD3\u6267\u7167\u540E\u5927\u7EA6180\u5929\u3002\u6211\u4EEC\u5C06\u544A\u77E5\u4E1A\u4E3B\u6240\u9700\u7684\u6240\u6709\u6587\u4EF6\u548C\u767B\u8BB0\u8D39\u7528\u3002\u4E1A\u4E3B\u53EF\u9009\u62E9\u5728\u767B\u8BB0\u548C\u8F6C\u8BA9\u516C\u5BD3\u6240\u6709\u6743\u4E4B\u524D\uFF0C\u5F53\u53D6\u5F97\u5EFA\u7B51\u4F7F\u7528\u8BB8\u53EF\uFF08\u9002\u7528\u6761\u6B3E\u548C\u6761\u4EF6\uFF09\u540E\uFF0C\u63A5\u53D7\u5176\u8D2D\u4E70/\u79DF\u8D41\u516C\u5BD3\u7684\u79FB\u4EA4\u5E76\u642C\u5165\u3002"))}},{categoryId:1,question:{en:"Should I appoint a lawyer to review the agreements?",ru:"Должен ли я нанять адвоката для проверки соглашений?",cn:"我应该请律师来审阅这些协议吗？"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Our agreements have been used for a number of years and have been reviewed by major international law firms. We have our own in-house legal team which can assist to clarify any questions you may have concerning the agreements. However, should you wish to obtain specific advice regarding the structuring of your investment, we recommend you consult with a professional legal and/or financial adviser.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041D\u0430\u0448\u0438 \u0441\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u044E\u0442\u0441\u044F \u0443\u0436\u0435 \u043C\u043D\u043E\u0433\u043E \u043B\u0435\u0442 \u0438 \u043F\u0440\u043E\u0448\u043B\u0438 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0443 \u043A\u0440\u0443\u043F\u043D\u044B\u043C\u0438 \u043C\u0435\u0436\u0434\u0443\u043D\u0430\u0440\u043E\u0434\u043D\u044B\u043C\u0438 \u044E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u0438\u043C\u0438 \u0444\u0438\u0440\u043C\u0430\u043C\u0438. \u0423 \u043D\u0430\u0441 \u0435\u0441\u0442\u044C \u0441\u0432\u043E\u0438 \u044E\u0440\u0438\u0441\u0442\u044B, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u043C\u043E\u0433\u0443\u0442 \u043E\u0442\u0432\u0435\u0442\u0438\u0442\u044C \u043D\u0430 \u043B\u044E\u0431\u044B\u0435 \u0432\u0430\u0448\u0438 \u0432\u043E\u043F\u0440\u043E\u0441\u044B \u043F\u043E \u0441\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F\u043C. \u041E\u0434\u043D\u0430\u043A\u043E, \u0435\u0441\u043B\u0438 \u0432\u044B \u0445\u043E\u0442\u0438\u0442\u0435 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u043A\u043E\u043D\u043A\u0440\u0435\u0442\u043D\u044B\u0435 \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0430\u0446\u0438\u0438 \u043F\u043E \u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044E \u0438\u043D\u0432\u0435\u0441\u0442\u0438\u0446\u0438\u0439, \u043C\u044B \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u043C \u043F\u0440\u043E\u043A\u043E\u043D\u0441\u0443\u043B\u044C\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0441\u044F \u0441 \u043F\u0440\u043E\u0444\u0435\u0441\u0441\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u043C \u044E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u0438\u043C \u0438 (\u0438\u043B\u0438) \u0444\u0438\u043D\u0430\u043D\u0441\u043E\u0432\u044B\u043C \u043A\u043E\u043D\u0441\u0443\u043B\u044C\u0442\u0430\u043D\u0442\u043E\u043C.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u6211\u4EEC\u7684\u534F\u8BAE\u5DF2\u7ECF\u4F7F\u7528\u591A\u5E74\uFF0C\u5E76\u7ECF\u4E3B\u6D41\u56FD\u9645\u5F8B\u5E08\u4E8B\u52A1\u6240\u5BA1\u6838\u3002\u6211\u4EEC\u62E5\u6709\u81EA\u5DF1\u7684\u5185\u90E8\u6CD5\u5F8B\u56E2\u961F\uFF0C\u53EF\u4EE5\u5E2E\u52A9\u89E3\u91CA\u5173\u4E8E\u534F\u8BAE\u7684\u4EFB\u4F55\u95EE\u9898\u3002\u7136\u800C\uFF0C\u5982\u679C\u4F60\u5E0C\u671B\u83B7\u5F97\u5173\u4E8E\u4F60\u7684\u6295\u8D44\u7ED3\u6784\u7684\u5177\u4F53\u5EFA\u8BAE\uFF0C\u5EFA\u8BAE\u4F60\u54A8\u8BE2\u4E13\u4E1A\u7684\u6CD5\u5F8B\u548C/\u6216\u8D22\u52A1\u987E\u95EE\u3002"))}},{categoryId:1,question:{en:"What types of visas are available for foreigners to stay in Thailand?",ru:"Какие типы виз доступны иностранцам для пребывания в Таиланде?",cn:"外国人在泰国可以获得哪些签证？"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"There are various forms of visas available to foreigners who wish to enter Thailand for study, business, investment, retirement and other purposes ranging from 90 days to 20 years multiple entry which include."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Long-Term Resident (LTR) visa offering 10 year renewable visas for four categories of foreign nationals: wealthy global citizens, wealthy pensioners, work-from-Thailand professionals, and highly-skilled professionals - subject to meeting qualification."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Education visa when enrolled at registered education institution within Thailand"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Business visa when operating a business"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Retirement visa for people aged 50 years or over and meet financial requirements"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Marriage visa for foreigners married to a Thai"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Thailand Elite Visa - a government led program offering memberships including 5 to 20 year visas")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Please consult with an immigration specialist or Thai Embassy / Consulate for more information.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0421\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u044E\u0442 \u0440\u0430\u0437\u043B\u0438\u0447\u043D\u044B\u0435 \u0444\u043E\u0440\u043C\u044B \u0432\u0438\u0437, \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B\u0435 \u0434\u043B\u044F \u0438\u043D\u043E\u0441\u0442\u0440\u0430\u043D\u0446\u0435\u0432, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u0445\u043E\u0442\u044F\u0442 \u043F\u0440\u0438\u0435\u0445\u0430\u0442\u044C \u0432 \u0422\u0430\u0438\u043B\u0430\u043D\u0434 \u0434\u043B\u044F \u0443\u0447\u0435\u0431\u044B, \u0432\u0435\u0434\u0435\u043D\u0438\u044F \u0431\u0438\u0437\u043D\u0435\u0441\u0430, \u0438\u043D\u0432\u0435\u0441\u0442\u0438\u0446\u0438\u0439, \u0432\u044B\u0445\u043E\u0434\u0430 \u043D\u0430 \u043F\u0435\u043D\u0441\u0438\u044E \u0438 \u0434\u0440\u0443\u0433\u0438\u0445 \u0446\u0435\u043B\u0435\u0439 \u043D\u0430 \u0441\u0440\u043E\u043A \u043E\u0442 90 \u0434\u043D\u0435\u0439 \u0434\u043E 20 \u043B\u0435\u0442 \u0441 \u043C\u043D\u043E\u0433\u043E\u043A\u0440\u0430\u0442\u043D\u044B\u043C \u0432\u044A\u0435\u0437\u0434\u043E\u043C. \u041A \u0442\u0430\u043A\u0438\u043C \u0432\u0438\u0437\u0430\u043C \u043E\u0442\u043D\u043E\u0441\u044F\u0442\u0441\u044F \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0435:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Long-Term Resident (LTR) \u0432\u0438\u0437\u0430 \u043F\u0440\u0435\u0434\u043B\u0430\u0433\u0430\u0435\u0442 10-\u043B\u0435\u0442\u043D\u0438\u0435 \u0432\u043E\u0437\u043E\u0431\u043D\u043E\u0432\u043B\u044F\u0435\u043C\u044B\u0435 \u0432\u0438\u0437\u044B \u0434\u043B\u044F \u0447\u0435\u0442\u044B\u0440\u0435\u0445 \u043A\u0430\u0442\u0435\u0433\u043E\u0440\u0438\u0439 \u0438\u043D\u043E\u0441\u0442\u0440\u0430\u043D\u043D\u044B\u0445 \u0433\u0440\u0430\u0436\u0434\u0430\u043D: \u0441\u043E\u0441\u0442\u043E\u044F\u0442\u0435\u043B\u044C\u043D\u044B\u0445 \u0433\u0440\u0430\u0436\u0434\u0430\u043D \u043C\u0438\u0440\u0430, \u0441\u043E\u0441\u0442\u043E\u044F\u0442\u0435\u043B\u044C\u043D\u044B\u0445 \u043F\u0435\u043D\u0441\u0438\u043E\u043D\u0435\u0440\u043E\u0432, \u0441\u043F\u0435\u0446\u0438\u0430\u043B\u0438\u0441\u0442\u043E\u0432, \u0440\u0430\u0431\u043E\u0442\u0430\u044E\u0449\u0438\u0445 \u0432 \u0422\u0430\u0438\u043B\u0430\u043D\u0434\u0435, \u0438 \u0432\u044B\u0441\u043E\u043A\u043E\u043A\u0432\u0430\u043B\u0438\u0444\u0438\u0446\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0445 \u0441\u043F\u0435\u0446\u0438\u0430\u043B\u0438\u0441\u0442\u043E\u0432 - \u043F\u0440\u0438 \u0443\u0441\u043B\u043E\u0432\u0438\u0438 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u044F \u0442\u0440\u0435\u0431\u043E\u0432\u0430\u043D\u0438\u044F\u043C."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u0423\u0447\u0435\u0431\u043D\u0430\u044F \u0432\u0438\u0437\u0430 \u043F\u0440\u0438 \u043F\u043E\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u0438 \u0432 \u0430\u043A\u043A\u0440\u0435\u0434\u0438\u0442\u043E\u0432\u0430\u043D\u043D\u043E\u0435 \u0443\u0447\u0435\u0431\u043D\u043E\u0435 \u0437\u0430\u0432\u0435\u0434\u0435\u043D\u0438\u0435 \u0432 \u0422\u0430\u0438\u043B\u0430\u043D\u0434\u0435"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u0411\u0438\u0437\u043D\u0435\u0441 \u0432\u0438\u0437\u0430 \u0434\u043B\u044F \u0432\u0435\u0434\u0435\u043D\u0438\u044F \u043F\u0440\u0435\u0434\u043F\u0440\u0438\u043D\u0438\u043C\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u043E\u0439 \u0434\u0435\u044F\u0442\u0435\u043B\u044C\u043D\u043E\u0441\u0442\u0438"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u041F\u0435\u043D\u0441\u0438\u043E\u043D\u043D\u0430\u044F \u0432\u0438\u0437\u0430 \u0434\u043B\u044F \u043B\u044E\u0434\u0435\u0439 \u0432 \u0432\u043E\u0437\u0440\u0430\u0441\u0442\u0435 50 \u043B\u0435\u0442 \u0438 \u0441\u0442\u0430\u0440\u0448\u0435, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u043E\u0442\u0432\u0435\u0447\u0430\u044E\u0442 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u044B\u043C \u0444\u0438\u043D\u0430\u043D\u0441\u043E\u0432\u044B\u043C \u0442\u0440\u0435\u0431\u043E\u0432\u0430\u043D\u0438\u044F\u043C"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u0411\u0440\u0430\u0447\u043D\u0430\u044F \u0432\u0438\u0437\u0430 \u0434\u043B\u044F \u0438\u043D\u043E\u0441\u0442\u0440\u0430\u043D\u0446\u0435\u0432, \u0441\u043E\u0441\u0442\u043E\u044F\u0449\u0438\u0445 \u0432 \u0431\u0440\u0430\u043A\u0435 \u0441 \u0442\u0430\u0439\u0446\u0435\u043C \u0438\u043B\u0438 \u0442\u0430\u0439\u043A\u043E\u0439"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u0422\u0430\u0438\u043B\u0430\u043D\u0434\u0441\u043A\u0430\u044F \u044D\u043B\u0438\u0442\u043D\u0430\u044F \u0432\u0438\u0437\u0430, \u0432\u044B\u0434\u0430\u0432\u0430\u0435\u043C\u0430\u044F \u043F\u043E \u043F\u0440\u0430\u0432\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0439 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0435 \u0438 \u043F\u0440\u0435\u0434\u043B\u0430\u0433\u0430\u044E\u0449\u0430\u044F \u0447\u043B\u0435\u043D\u0441\u0442\u0432\u043E, \u0432\u043A\u043B\u044E\u0447\u0430\u044F \u0432\u0438\u0437\u044B, \u0432\u044B\u0434\u0430\u0432\u0430\u0435\u043C\u044B\u0435 \u043D\u0430 \u0441\u0440\u043E\u043A 5 \u043B\u0435\u0442")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0414\u043B\u044F \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u043F\u0440\u043E\u043A\u043E\u043D\u0441\u0443\u043B\u044C\u0442\u0438\u0440\u0443\u0439\u0442\u0435\u0441\u044C \u0441\u043E \u0441\u043F\u0435\u0446\u0438\u0430\u043B\u0438\u0441\u0442\u043E\u043C \u043F\u043E \u0432\u043E\u043F\u0440\u043E\u0441\u0430\u043C \u0438\u043C\u043C\u0438\u0433\u0440\u0430\u0446\u0438\u0438 \u0438\u043B\u0438 \u043F\u043E\u0441\u043E\u043B\u044C\u0441\u0442\u0432\u043E\u043C/\u043A\u043E\u043D\u0441\u0443\u043B\u044C\u0441\u0442\u0432\u043E\u043C \u0422\u0430\u0438\u043B\u0430\u043D\u0434\u0430.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u5BF9\u4E8E\u5E0C\u671B\u524D\u5F80\u6CF0\u56FD\u5B66\u4E60\u3001\u51FA\u5DEE\u3001\u6295\u8D44\u3001\u4EAB\u53D7\u9000\u4F11\u751F\u6D3B\u6216\u56E0\u5176\u4ED6\u76EE\u7684\u524D\u5F80\u6CF0\u56FD\u7684\u5916\u7C4D\u4EBA\u58EB\uFF0C\u5F53\u5C40\u63D0\u4F9B\u591A\u79CD\u5F62\u5F0F\u4E14\u671F\u9650\u4ECB\u4E8E 90 \u5929\u81F3 20\u5E74\u7684\u591A\u6B21\u5165\u5883\u7B7E\u8BC1\uFF0C\u5176\u4E2D\u5305\u62EC\uFF1A"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u957F\u671F\u5C45\u6C11(LTR)\u7B7E\u8BC1\u4E3A\u56DB\u7C7B\u5916\u56FD\u4EBA\u63D0\u4F9B 10 \u5E74\u53EF\u7EED\u7B7E\u7B7E\u8BC1\uFF1A\u5BCC\u6709\u7684\u5168\u7403\u516C\u6C11\u3001\u5BCC\u6709\u7684\u517B\u8001\u91D1\u9886\u53D6\u8005\u3001\u5728\u6CF0\u56FD\u5DE5\u4F5C\u7684\u4E13\u4E1A\u4EBA\u58EB\u548C\u9AD8\u6280\u80FD\u4E13\u4E1A\u4EBA\u58EB - \u987B\u7B26\u5408\u7533\u8BF7\u8D44\u683C"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u6559\u80B2\u7B7E\u8BC1\uFF0C\u9002\u7528\u4E8E\u5C31\u8BFB\u4E8E\u6CF0\u56FD\u6CE8\u518C\u6559\u80B2\u673A\u6784\u7684\u4EBA\u58EB"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u5546\u52A1\u7B7E\u8BC1\uFF0C\u9002\u7528\u4E8E\u7ECF\u8425\u516C\u53F8\u7684\u4EBA\u58EB"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u9000\u4F11\u7B7E\u8BC1\uFF0C\u9002\u7528\u4E8E\u5E74\u6EE1 50 \u5C81\u4E14\u7B26\u5408\u8D22\u52A1\u8981\u6C42\u7684\u4EBA\u58EB"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u7ED3\u5A5A\u7B7E\u8BC1\uFF0C\u9002\u7528\u4E8E\u4E0E\u6CF0\u56FD\u4EBA\u7ED3\u5A5A\u7684\u5916\u7C4D\u4EBA\u58EB"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u6CF0\u56FD\u7CBE\u82F1\u7B7E\u8BC1\uFF0C\u4E00\u9879\u7531\u653F\u5E9C\u5F15\u5BFC\u7684\u8BA1\u5212\uFF0C\u63D0\u4F9B\u5305\u62EC 5 -20\u5E74\u7B7E\u8BC1\u7684\u4F1A\u7C4D")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u5982\u9700\u4E86\u89E3\u66F4\u591A\u4FE1\u606F\uFF0C\u8BF7\u54A8\u8BE2\u79FB\u6C11\u4E13\u5BB6\u6216\u6CF0\u56FD\u5927\u4F7F\u9986/\u9886\u4E8B\u9986"))}},// ====================================================================== //
{categoryId:2,question:{en:"Types and number of units for sale?",ru:"Каковы типы и количество квартир на продажу?",cn:"待售单元的种类和数量如何？"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"The development includes one (1) low-rise condominium buildings comprising a total of approximately 50 units. One, two and three bedroom configurations are available ranging in size from 60 \u2013 131 square metres.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041F\u0440\u043E\u0435\u043A\u0442 \u0432\u043A\u043B\u044E\u0447\u0430\u0435\u0442 \u043E\u0434\u043D\u043E (1) \u043C\u0430\u043B\u043E\u044D\u0442\u0430\u0436\u043D\u043E\u0435 \u0437\u0434\u0430\u043D\u0438\u0435-\u043A\u043E\u043D\u0434\u043E\u043C\u0438\u043D\u0438\u0443\u043C \u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u043D\u0430 50 \u043A\u0432\u0430\u0440\u0442\u0438\u0440. \u0414\u043E\u0441\u0442\u0443\u043F\u043D\u044B \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u044B \u0441 \u043E\u0434\u043D\u043E\u0439, \u0434\u0432\u0443\u043C\u044F \u0438 \u0442\u0440\u0435\u043C\u044F \u0441\u043F\u0430\u043B\u044C\u043D\u044F\u043C\u0438 \u043F\u043B\u043E\u0449\u0430\u0434\u044C\u044E \u043E\u0442 60 \u0434\u043E 131 \u043A\u0432\u0430\u0434\u0440\u0430\u0442\u043D\u044B\u0445 \u043C\u0435\u0442\u0440\u043E\u0432.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u8BE5\u9879\u76EE\u5305\u62EC\u4E00\u680B\u4F4E\u5C42\u516C\u5BD3\u697C\uFF0C\u5171\u5305\u542B\u7EA650\u4E2A\u5355\u5143\u3002\u4E00\u5367\u5BA4\u3001\u4E24\u5367\u5BA4\u548C\u4E09\u5367\u5BA4\u516C\u5BD3\u7684\u9762\u79EF\u4ECE 60-131\u5E73\u65B9\u7C73\u4E0D\u7B49\u3002"))}},{categoryId:2,question:{en:"How long does construction take?",ru:"Сколько времени занимает строительство?",cn:"建筑施工需要多长时间？"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Construction can only commence once the relevant government environmental and building approvals are obtained and is estimated to take approximately 18-24 months to complete from the commencement date.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0421\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E \u043C\u043E\u0436\u0435\u0442 \u043D\u0430\u0447\u0430\u0442\u044C\u0441\u044F \u0442\u043E\u043B\u044C\u043A\u043E \u043F\u043E\u0441\u043B\u0435 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0445 \u0433\u043E\u0441\u0443\u0434\u0430\u0440\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u0445 \u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u0438\u0439 \u043F\u0440\u0438\u0440\u043E\u0434\u043E\u043E\u0445\u0440\u0430\u043D\u043D\u044B\u0445 \u043E\u0440\u0433\u0430\u043D\u043E\u0432 \u0438 \u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u0438\u0439 \u043D\u0430 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0435 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0445 \u0440\u0430\u0431\u043E\u0442. \u041F\u0440\u0435\u0434\u0432\u0430\u0440\u0438\u0442\u0435\u043B\u044C\u043D\u043E, \u043D\u0430 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E \u043A\u0430\u0436\u0434\u043E\u0433\u043E \u0437\u0434\u0430\u043D\u0438\u044F \u0441 \u0434\u0430\u0442\u044B \u043D\u0430\u0447\u0430\u043B\u0430 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 \u043F\u043E\u0442\u0440\u0435\u0431\u0443\u0435\u0442\u0441\u044F \u043F\u0440\u0438\u043C\u0435\u0440\u043D\u043E \u043E\u0442 18 \u0434\u043E 24 \u043C\u0435\u0441\u044F\u0446\u0435\u0432.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u5728\u83B7\u5F97\u76F8\u5173\u7684\u653F\u5E9C\u73AF\u5883\u548C\u5EFA\u7B51\u6279\u51C6\u540E\u624D\u80FD\u5F00\u59CB\u65BD\u5DE5\u3002\u4ECE\u5F00\u5DE5\u65E5\u671F\u5F00\u59CB\uFF0C\u5EFA\u7B51\u4F30\u8BA1\u9700\u8981\u5927\u7EA618-24\u4E2A\u6708\u7684\u65F6\u95F4\u5B8C\u6210\u3002"))}},{categoryId:2,question:{en:"Is a warranty period offered?",ru:"Имеется ли гарантийный срок?",cn:"提供保修期吗？"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Yes. A five (5) year building structure warranty is offered from the date of completion of construction. Warranties on any other component parts of the building will be subject to a two (2) year warranty.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0414\u0430, \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u0433\u0430\u0440\u0430\u043D\u0442\u0438\u044F \u043D\u0430 \u043A\u043E\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0438\u044E \u0437\u0434\u0430\u043D\u0438\u044F \u0441\u0440\u043E\u043A\u043E\u043C \u043D\u0430 \u043F\u044F\u0442\u044C (5) \u043B\u0435\u0442 \u0441 \u043C\u043E\u043C\u0435\u043D\u0442\u0430 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430. \u0413\u0430\u0440\u0430\u043D\u0442\u0438\u044F \u043D\u0430 \u043B\u044E\u0431\u044B\u0435 \u0434\u0440\u0443\u0433\u0438\u0435 \u0441\u043E\u0441\u0442\u0430\u0432\u043D\u044B\u0435 \u0447\u0430\u0441\u0442\u0438 \u0437\u0434\u0430\u043D\u0438\u044F \u0441\u043E\u0441\u0442\u0430\u0432\u0438\u0442 \u0434\u0432\u0430 (2) \u0433\u043E\u0434\u0430."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"* \u0417\u0430 \u0438\u0441\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435\u043C \u0441\u043B\u0443\u0447\u0430\u0435\u0432, \u043F\u0440\u0435\u0434\u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u043D\u044B\u0445 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u043E\u043C \u0438 \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E\u043C.")))),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u662F\u7684\u3002\u81EA\u7AE3\u5DE5\u4E4B\u65E5\u8D77\uFF0C\u63D0\u4F9B\u4E3A\u671F\u4E94\u5E74\u7684\u5EFA\u7B51\u7ED3\u6784\u4FDD\u4FEE\u3002\u5EFA\u7B51\u5176\u4ED6\u90E8\u5206\u4FDD\u4FEE\u671F\u4E3A\u4E24\u5E74\u3002"))}},{categoryId:2,question:{en:"What is included in the property?",ru:"Что включено в приобретаемую недвижимость?",cn:"房产内包含什么？"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Fixed furnishings (wardrobes, kitchen cabinets and built-in appliances) is included. Loose furniture, artworks and amenities are not included but are available to purchase separately.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0412\u0441\u0442\u0440\u043E\u0435\u043D\u043D\u044B\u0439 \u0432\u0430\u0440\u0438\u0430\u043D\u0442 \u0432\u043A\u043B\u044E\u0447\u0430\u0435\u0442 \u0432 \u0441\u0435\u0431\u044F \u0432\u0441\u0442\u0440\u043E\u0435\u043D\u043D\u0443\u044E \u043C\u0435\u0431\u0435\u043B\u044C (\u0448\u043A\u0430\u0444\u044B, \u043A\u0443\u0445\u043E\u043D\u043D\u044B\u0435 \u0448\u043A\u0430\u0444\u044B \u0438 \u0432\u0441\u0442\u0440\u043E\u0435\u043D\u043D\u0443\u044E \u043A\u0443\u0445\u043E\u043D\u043D\u0443\u044E \u0442\u0435\u0445\u043D\u0438\u043A\u0443, \u043A\u043E\u043D\u0434\u0438\u0446\u0438\u043E\u043D\u0435\u0440 \u0438 \u0442. \u043F.). \u041C\u0435\u0431\u0435\u043B\u044C, \u043F\u0440\u043E\u0438\u0437\u0432\u0435\u0434\u0435\u043D\u0438\u044F \u0438\u0441\u043A\u0443\u0441\u0441\u0442\u0432\u0430 \u0438 \u0443\u0434\u043E\u0431\u0441\u0442\u0432\u0430 \u043D\u0435 \u0432\u043A\u043B\u044E\u0447\u0435\u043D\u044B \u0432 \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C, \u043D\u043E \u0438\u0445 \u043C\u043E\u0436\u043D\u043E \u043F\u0440\u0438\u043E\u0431\u0440\u0435\u0441\u0442\u0438 \u043E\u0442\u0434\u0435\u043B\u044C\u043D\u043E.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u5305\u542B\u56FA\u5B9A\u5BB6\u5177\uFF08\u8863\u67DC\u3001\u53A8\u623F\u6A71\u67DC\u548C\u5D4C\u5165\u5F0F\u7535\u5668\u7B49\uFF09\u3002\u4E0D\u5305\u542B\u53EF\u79FB\u52A8\u5BB6\u5177,\u88C5\u9970\u548C\u5176\u4ED6\u8BBE\u5907\u8BBE\u65BD\uFF0C\u4F46\u53EF\u989D\u5916\u8D2D\u4E70\u3002"))}},{categoryId:2,question:{en:"Is customization of the units allowed?",ru:"Разрешена ли перепланировка квартир?",cn:"允许定制单元吗？"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"There are two (2) interior design options available and another option to enclose the balcony. The building must be built in accordance with building code and permits as issued by the relevant authorities so no changes to the external areas or structural items are permitted.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u044B 2 (\u0434\u0432\u0430) \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0430 \u0432\u043D\u0443\u0442\u0440\u0435\u043D\u043D\u0435\u0439 \u043F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u043A\u0438 \u0438 \u0435\u0449\u0435 \u043E\u0434\u0438\u043D \u0432\u0430\u0440\u0438\u0430\u043D\u0442, \u0432\u043A\u043B\u044E\u0447\u0430\u044E\u0449\u0438\u0439 \u0431\u0430\u043B\u043A\u043E\u043D. \u0417\u0434\u0430\u043D\u0438\u0435 \u0434\u043E\u043B\u0436\u043D\u043E \u0441\u0442\u0440\u043E\u0438\u0442\u044C\u0441\u044F \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441\u043E \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u043C\u0438 \u043D\u043E\u0440\u043C\u0430\u043C\u0438 \u0438 \u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u0438\u044F\u043C\u0438, \u0432\u044B\u0434\u0430\u043D\u043D\u044B\u043C\u0438 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u043C\u0438 \u043E\u0440\u0433\u0430\u043D\u0430\u043C\u0438, \u043F\u043E\u044D\u0442\u043E\u043C\u0443 \u043D\u0438\u043A\u0430\u043A\u0438\u0435 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u0432\u043D\u0435\u0448\u043D\u0438\u0445 \u0443\u0447\u0430\u0441\u0442\u043A\u043E\u0432 \u0438\u043B\u0438 \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u043E\u0432 \u043A\u043E\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0438\u0438 \u043D\u0435 \u0434\u043E\u043F\u0443\u0441\u043A\u0430\u044E\u0442\u0441\u044F.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u6709\u4E24\u79CD\u5BA4\u5185\u8BBE\u8BA1\u53EF\u4F9B\u9009\u62E9\uFF0C\u53E6\u53EF\u5C01\u95ED\u9633\u53F0\u3002\u5EFA\u7B51\u5FC5\u987B\u6309\u7167\u5EFA\u7B51\u89C4\u8303\u548C\u76F8\u5173\u90E8\u95E8\u9881\u53D1\u7684\u8BB8\u53EF\u8BC1\u5EFA\u9020\uFF0C\u56E0\u6B64\u5916\u90E8\u533A\u57DF\u6216\u7ED3\u6784\u9879\u76EE\u4E0D\u5F97\u66F4\u6539\u3002"))}},// ====================================================================== //
{categoryId:3,question:{en:"What infrastructure and common facilities are provided and who will manage these?",ru:"Что входит в инфраструктуру и общие объекты и кто будет ими управлять?",cn:"提供哪些基础设施和公共设施，由谁来管理？"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"The infrastructure and common facilities includes roads and drainage, lighting, landscape areas, swimming pools, deck areas and water and electricity supplies. Services shall include 24 hours on-site security, garbage collection, cleaning and maintenance of infrastructure and common facilities or any other services as required for the common use or benefit of owners. In addition, owners will be entitled to access certain amenities including the shuttle bus service. The condominium manager shall be Laguna (or its designated manager).")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0418\u043D\u0444\u0440\u0430\u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u0430 \u0438 \u043E\u0431\u0449\u0438\u0435 \u043E\u0431\u044A\u0435\u043A\u0442\u044B \u0432\u043A\u043B\u044E\u0447\u0430\u044E\u0442 \u0434\u043E\u0440\u043E\u0433\u0438 \u0438 \u043A\u0430\u043D\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u044E, \u043E\u0441\u0432\u0435\u0449\u0435\u043D\u0438\u0435, \u043B\u0430\u043D\u0434\u0448\u0430\u0444\u0442\u043D\u044B\u0435 \u0437\u043E\u043D\u044B, \u0431\u0430\u0441\u0441\u0435\u0439\u043D\u044B, \u0442\u0435\u0440\u0440\u0430\u0441\u044B, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0432\u043E\u0434\u043E- \u0438 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u0441\u043D\u0430\u0431\u0436\u0435\u043D\u0438\u0435. \u0423\u0441\u043B\u0443\u0433\u0438 \u0432\u043A\u043B\u044E\u0447\u0430\u044E\u0442 \u043A\u0440\u0443\u0433\u043B\u043E\u0441\u0443\u0442\u043E\u0447\u043D\u0443\u044E \u043E\u0445\u0440\u0430\u043D\u0443 \u0432 \u043C\u0435\u0441\u0442\u0435 \u043E\u0431\u044A\u0435\u043A\u0442\u0430, \u0432\u044B\u0432\u043E\u0437 \u043C\u0443\u0441\u043E\u0440\u0430, \u0443\u0431\u043E\u0440\u043A\u0443 \u0438 \u043E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u043D\u0438\u0435 \u0438\u043D\u0444\u0440\u0430\u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u044B \u0438 \u043E\u0431\u0449\u0438\u0445 \u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0432\u0441\u0435 \u0434\u0440\u0443\u0433\u0438\u0435 \u0443\u0441\u043B\u0443\u0433\u0438, \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u044B\u0435 \u0434\u043B\u044F \u043E\u0431\u0449\u0435\u0433\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0438\u043B\u0438 \u0432\u044B\u0433\u043E\u0434 \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0435\u0432. \u0422\u0430\u043A\u0436\u0435 \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u044B \u0438\u043C\u0435\u044E\u0442 \u043F\u0440\u0430\u0432\u043E \u043D\u0430 \u0434\u043E\u0441\u0442\u0443\u043F \u043A \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u044B\u043C \u0443\u0434\u043E\u0431\u0441\u0442\u0432\u0430\u043C, \u0432\u043A\u043B\u044E\u0447\u0430\u044F \u0443\u0441\u043B\u0443\u0433\u0438 \u0432\u043D\u0443\u0442\u0440\u0435\u043D\u043D\u0435\u0433\u043E \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0430 \u043A\u0443\u0440\u043E\u0440\u0442\u0430. \u0423\u043F\u0440\u0430\u0432\u043B\u044F\u044E\u0449\u0438\u043C \u043A\u043E\u043D\u0434\u043E\u043C\u0438\u043D\u0438\u0443\u043C\u043E\u043C \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F Laguna (\u0438\u043B\u0438 \u043D\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044B\u0439 \u0435\u044E \u0443\u043F\u0440\u0430\u0432\u043B\u044F\u044E\u0449\u0438\u0439).")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u57FA\u7840\u8BBE\u65BD\u548C\u516C\u7528\u8BBE\u65BD\u5305\u62EC\u9053\u8DEF\u548C\u6392\u6C34\u3001\u7167\u660E\u3001\u666F\u89C2\u533A\u3001\u6E38\u6CF3\u6C60\u3001\u7532\u677F\u533A\u3001\u6C34\u7535\u4F9B\u5E94\u7B49\u3002\u670D\u52A1\u5305\u62EC24\u5C0F\u65F6\u73B0\u573A\u4FDD\u5B89\u3001\u5783\u573E\u6536\u96C6\u3001\u57FA\u7840\u8BBE\u65BD\u548C\u516C\u5171\u8BBE\u65BD\u7684\u6E05\u6D01\u548C\u7EF4\u62A4\u6216\u4E3A\u4E1A\u4E3B\u7684\u5171\u540C\u4F7F\u7528\u6216\u5229\u76CA\u6240\u9700\u7684\u4EFB\u4F55\u5176\u4ED6\u670D\u52A1\u3002\u6B64\u5916\uFF0C\u4E1A\u4E3B\u5C06\u6709\u6743\u4F7F\u7528\u6307\u5B9A\u8BBE\u65BD\uFF0C\u5305\u62EC\u73ED\u8F66\u670D\u52A1\u3002\u516C\u5BD3\u7BA1\u7406\u4EBA\u4E3A\u4E50\u53E4\u6D6A\uFF08\u6216\u5176\u6307\u5B9A\u7684\u7BA1\u7406\u4EBA\uFF09\u3002"))}},{categoryId:3,question:{en:"What are the estimated fees payable for the infrastructure, common facilities and services provided?",ru:"Каков ориентировочный размер платы за пользование инфраструктурой, общими объектами и услугами?",cn:"针对提供的基础设施、公共设施和服务，需支付的估计费用是多少？"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"The fees for the cost of maintenance for the infrastructure, common facilities, services provided (\u201Ccommon area fee\u201D) and maintenance fees towards other services and facilities supplied to the condominium \u201Cnon-common area fees\u2019 in aggregate shall be Baht 50 per square metre per month for the initial year and may be subject to change based upon the actual expenses incurred from time to time. The annual fees are determined by the total expenses incurred and proportionately divided amongst the sellable area of the units in the condominium."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"In addition, a fund shall be established for the cost of major repairs, replacement and/or improvement for the infrastructure and common facilities (\u201Cspecial fund\u201D). Contributions will be made on a regular basis so that the fund is built up over time. The rate shall be Baht 100 per square metre per year for the initial year and may be subject to change. If the fund balance is not sufficient for the cost of major repairs, owners may be required to pay an additional amount as requested by the manager from time to time."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"The cost of water and electricity supplied to individual condominiums shall be based upon metered consumption.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041F\u043B\u0430\u0442\u0430 \u0437\u0430 \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u043D\u0438\u0435 \u0438\u043D\u0444\u0440\u0430\u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u044B \u0438 \u043C\u0435\u0441\u0442 \u043E\u0431\u0449\u0435\u0433\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F, \u0430 \u0442\u0430\u043A\u0436\u0435 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0443\u0441\u043B\u0443\u0433 (\u0434\u0430\u043B\u0435\u0435 \u2014 \xAB\u043F\u043B\u0430\u0442\u0430 \u0437\u0430 \u0442\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u044E \u043E\u0431\u0449\u0435\u0433\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F\xBB) \u0438 \u043F\u043B\u0430\u0442\u0430 \u0437\u0430 \u0434\u0440\u0443\u0433\u0438\u0435 \u0443\u0441\u043B\u0443\u0433\u0438 \u0438 \u0443\u0434\u043E\u0431\u0441\u0442\u0432\u0430, \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u043C\u044B\u0435 \u043A\u043E\u043D\u0434\u043E\u043C\u0438\u043D\u0438\u0443\u043C\u0443 (\u0434\u0430\u043B\u0435\u0435 \xAB\u043F\u043B\u0430\u0442\u0430 \u0437\u0430 \u0442\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u044E, \u043D\u0435 \u0432\u0445\u043E\u0434\u044F\u0449\u0443\u044E \u0432 \u043E\u0431\u0449\u0435\u0435 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435\xBB) \u0432 \u0441\u043E\u0432\u043E\u043A\u0443\u043F\u043D\u043E\u0441\u0442\u0438 \u0441\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 50 \u0431\u0430\u0442\u043E\u0432 \u0437\u0430 \u043E\u0434\u0438\u043D \u043A\u0432\u0430\u0434\u0440\u0430\u0442\u043D\u044B\u0439 \u043C\u0435\u0442\u0440 \u0432 \u043C\u0435\u0441\u044F\u0446 \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 \u043F\u0435\u0440\u0432\u043E\u0433\u043E \u0433\u043E\u0434\u0430. \u0415\u0435 \u0440\u0430\u0437\u043C\u0435\u0440 \u043C\u043E\u0436\u0435\u0442 \u043F\u0435\u0440\u0438\u043E\u0434\u0438\u0447\u0435\u0441\u043A\u0438 \u043F\u0435\u0440\u0435\u0441\u043C\u0430\u0442\u0440\u0438\u0432\u0430\u0442\u044C\u0441\u044F \u0432 \u0437\u0430\u0432\u0438\u0441\u0438\u043C\u043E\u0441\u0442\u0438 \u043E\u0442 \u0444\u0430\u043A\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u0445 \u0440\u0430\u0441\u0445\u043E\u0434\u043E\u0432. \u0415\u0436\u0435\u0433\u043E\u0434\u043D\u044B\u0439 \u0440\u0430\u0437\u043C\u0435\u0440 \u043F\u043B\u0430\u0442\u044B \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u044F\u0435\u0442\u0441\u044F \u043E\u0431\u0449\u0435\u0439 \u0441\u0443\u043C\u043C\u043E\u0439 \u043F\u043E\u043D\u0435\u0441\u0435\u043D\u043D\u044B\u0445 \u0440\u0430\u0441\u0445\u043E\u0434\u043E\u0432 \u0438 \u043F\u0440\u043E\u043F\u043E\u0440\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u043E \u0440\u0430\u0441\u043F\u0440\u0435\u0434\u0435\u043B\u044F\u0435\u0442\u0441\u044F \u043C\u0435\u0436\u0434\u0443 \u043F\u0440\u043E\u0434\u0430\u0432\u0430\u0435\u043C\u043E\u0439 \u043F\u043B\u043E\u0449\u0430\u0434\u044C\u044E \u043A\u0432\u0430\u0440\u0442\u0438\u0440 \u0432 \u043A\u043E\u043D\u0434\u043E\u043C\u0438\u043D\u0438\u0443\u043C\u0435."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041A\u0440\u043E\u043C\u0435 \u0442\u043E\u0433\u043E, \u0441\u043E\u0437\u0434\u0430\u0435\u0442\u0441\u044F \u0444\u043E\u043D\u0434 \u0434\u043B\u044F \u043F\u043E\u043A\u0440\u044B\u0442\u0438\u044F \u0437\u0430\u0442\u0440\u0430\u0442 \u043D\u0430 \u043A\u0430\u043F\u0438\u0442\u0430\u043B\u044C\u043D\u044B\u0439 \u0440\u0435\u043C\u043E\u043D\u0442, \u0437\u0430\u043C\u0435\u043D\u0443 \u0438 (\u0438\u043B\u0438) \u0443\u043B\u0443\u0447\u0448\u0435\u043D\u0438\u0435 \u0438\u043D\u0444\u0440\u0430\u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u044B \u0438 \u043E\u0431\u0449\u0438\u0445 \u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432 (\u0434\u0430\u043B\u0435\u0435 \u2014 \xAB\u0441\u043F\u0435\u0446\u0438\u0430\u043B\u044C\u043D\u044B\u0439 \u0444\u043E\u043D\u0434\xBB). \u0412\u0437\u043D\u043E\u0441\u044B \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u044E\u0442\u0441\u044F \u043D\u0430 \u0440\u0435\u0433\u0443\u043B\u044F\u0440\u043D\u043E\u0439 \u043E\u0441\u043D\u043E\u0432\u0435 \u0441 \u0446\u0435\u043B\u044C\u044E \u043F\u043E\u0441\u0442\u0435\u043F\u0435\u043D\u043D\u043E\u0433\u043E \u043D\u0430\u043A\u043E\u043F\u043B\u0435\u043D\u0438\u044F \u0441\u0440\u0435\u0434\u0441\u0442\u0432 \u0444\u043E\u043D\u0434\u043E\u043C. \u0420\u0430\u0437\u043C\u0435\u0440 \u043F\u043B\u0430\u0442\u044B \u0441\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 100 \u0431\u0430\u0442 \u0437\u0430 \u043E\u0434\u0438\u043D \u043A\u0432\u0430\u0434\u0440\u0430\u0442\u043D\u044B\u0439 \u043C\u0435\u0442\u0440 \u0432 \u0433\u043E\u0434 \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 \u043F\u0435\u0440\u0432\u043E\u0433\u043E \u0433\u043E\u0434\u0430 \u0438 \u043C\u043E\u0436\u0435\u0442 \u043F\u0435\u0440\u0435\u0441\u043C\u0430\u0442\u0440\u0438\u0432\u0430\u0442\u044C\u0441\u044F. \u0415\u0441\u043B\u0438 \u043E\u0441\u0442\u0430\u0442\u043A\u0430 \u0441\u0440\u0435\u0434\u0441\u0442\u0432 \u0444\u043E\u043D\u0434\u0430 \u043D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043E\u0447\u043D\u043E \u0434\u043B\u044F \u043F\u043E\u043A\u0440\u044B\u0442\u0438\u044F \u0437\u0430\u0442\u0440\u0430\u0442 \u043D\u0430 \u043A\u0430\u043F\u0438\u0442\u0430\u043B\u044C\u043D\u044B\u0439 \u0440\u0435\u043C\u043E\u043D\u0442, \u0443\u043F\u0440\u0430\u0432\u043B\u044F\u044E\u0449\u0438\u0439 \u043F\u0435\u0440\u0438\u043E\u0434\u0438\u0447\u0435\u0441\u043A\u0438 \u043C\u043E\u0436\u0435\u0442 \u0442\u0440\u0435\u0431\u043E\u0432\u0430\u0442\u044C \u043E\u0442 \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u0438\u043A\u043E\u0432 \u0432\u043D\u0435\u0441\u0435\u043D\u0438\u044F \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0445 \u0441\u0443\u043C\u043C."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0421\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C \u0432\u043E\u0434\u044B \u0438 \u044D\u043B\u0435\u043A\u0442\u0440\u0438\u0447\u0435\u0441\u0442\u0432\u0430, \u043F\u043E\u0442\u0440\u0435\u0431\u043B\u044F\u0435\u043C\u044B\u0435 \u043E\u0442\u0434\u0435\u043B\u044C\u043D\u044B\u043C\u0438 \u043A\u0432\u0430\u0440\u0442\u0438\u0440\u0430\u043C\u0438 \u0432\u0437\u0438\u043C\u0430\u0435\u0442\u0441\u044F \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u043F\u043E\u043A\u0430\u0437\u0430\u043D\u0438\u044F\u043C\u0438 \u0441\u0447\u0435\u0442\u0447\u0438\u043A\u043E\u0432.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u9488\u5BF9\u63D0\u4F9B\u7684\u57FA\u7840\u8BBE\u65BD\u3001\u516C\u7528\u8BBE\u65BD\u3001\u670D\u52A1\u7684\u7EF4\u62A4\u8D39\u7528\uFF08\u201C\u516C\u5171\u533A\u57DF\u8D39\u201D\uFF09\u4EE5\u53CA\u9488\u5BF9\u63D0\u4F9B\u7ED9\u516C\u5BD3\u7684\u5176\u4ED6\u670D\u52A1\u548C\u8BBE\u65BD\u7684\u7EF4\u62A4\u8D39\u7528\uFF08\u201C\u975E\u516C\u5171\u533A\u57DF\u8D39\u201D\uFF09\uFF0C\u521D\u59CB\u5E74\u5408\u8BA1\u4E3A\u6BCF\u6708\u6BCF\u5E73\u65B9\u7C7350\u6CF0\u94E2\uFF0C\u53EF\u80FD\u4F1A\u6839\u636E\u5B9E\u9645\u652F\u51FA\u53D8\u52A8\u3002\u6BCF\u5E74\u8D39\u7528\u7531\u6240\u53D1\u751F\u7684\u603B\u652F\u51FA\u51B3\u5B9A\uFF0C\u5E76\u6309\u6BD4\u4F8B\u5728\u516C\u5BD3\u5355\u5143\u7684\u53EF\u552E\u9762\u79EF\u4E2D\u5206\u644A\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u6B64\u5916\uFF0C\u8FD8\u4E3A\u57FA\u7840\u8BBE\u65BD\u548C\u516C\u5171\u8BBE\u65BD\u7684\u5927\u4FEE\u3001\u66F4\u6362\u548C/\u6216\u6539\u8FDB\u8D39\u7528\u8BBE\u7ACB\u57FA\u91D1\uFF08\u201C\u7279\u522B\u57FA\u91D1\u201D\uFF09\u3002\u5C06\u5B9A\u671F\u7F34\u6B3E\uFF0C\u4EE5\u4FBF\u57FA\u91D1\u9010\u6B65\u5EFA\u7ACB\u3002\u521D\u59CB\u5E74\u7684\u8D39\u7387\u4E3A\u6BCF\u5E74\u6BCF\u5E73\u65B9\u7C73100\u6CF0\u94E2\uFF0C\u53EF\u80FD\u4F1A\u6709\u53D8\u52A8\u3002\u5982\u57FA\u91D1\u4F59\u989D\u4E0D\u8DB3\u4EE5\u652F\u4ED8\u5927\u4FEE\u8D39\u7528\uFF0C\u4E1A\u4E3B\u53EF\u80FD\u987B\u6309\u7BA1\u7406\u4EBA\u4E0D\u65F6\u7684\u8981\u6C42\u652F\u4ED8\u989D\u5916\u6B3E\u9879\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u5355\u4E2A\u516C\u5BD3\u7684\u6C34\u7535\u8D39\u6309\u7528\u91CF\u8BA1\u7B97\u3002"))}},{categoryId:3,question:{en:"What property management services are provided?",ru:"Какие услуги по управлению объектами недвижимости предоставляются?",cn:"提供哪些物业管理服务？"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Laguna will provide a full range of property services to individual owners including, pest control, routine and preventative maintenance, general repairs, housekeeping and other reasonable requests. Rates vary according to the frequency and scope of service. In addition, Laguna provides owners with the ability to generate a rental income from their property with short-term* and long-term rentals (see below).")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u044E\u0449\u0438\u0439 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B Laguna \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0430\u043C \u043F\u043E\u043B\u043D\u044B\u0439 \u043D\u0430\u0431\u043E\u0440 \u0443\u0441\u043B\u0443\u0433 \u043F\u043E \u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044E \u043E\u0431\u044A\u0435\u043A\u0442\u0430\u043C\u0438 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u0438, \u0432\u043A\u043B\u044E\u0447\u0430\u044F \u0431\u043E\u0440\u044C\u0431\u0443 \u0441 \u0432\u0440\u0435\u0434\u0438\u0442\u0435\u043B\u044F\u043C\u0438, \u0442\u0435\u043A\u0443\u0449\u0435\u0435 \u0438 \u043F\u0440\u043E\u0444\u0438\u043B\u0430\u043A\u0442\u0438\u0447\u0435\u0441\u043A\u043E\u0435 \u043E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u043D\u0438\u0435, \u043E\u0431\u0449\u0438\u0439 \u0440\u0435\u043C\u043E\u043D\u0442, \u0443\u0431\u043E\u0440\u043A\u0443 \u0438 \u0443\u0434\u043E\u0432\u043B\u0435\u0442\u0432\u043E\u0440\u0435\u043D\u0438\u0435 \u0434\u0440\u0443\u0433\u0438\u0445 \u043E\u0431\u043E\u0441\u043D\u043E\u0432\u0430\u043D\u043D\u044B\u0445 \u0437\u0430\u043F\u0440\u043E\u0441\u043E\u0432. \u0422\u0430\u043A\u0436\u0435 \u043E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u044E\u0449\u0438\u0439 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B Laguna \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0430\u043C \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u044C \u043F\u043E\u043B\u0443\u0447\u0430\u0442\u044C \u0434\u043E\u0445\u043E\u0434 \u043E\u0442 \u0430\u0440\u0435\u043D\u0434\u044B \u0438\u0445 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u0438 \u043F\u043E\u0441\u0440\u0435\u0434\u0441\u0442\u0432\u043E\u043C \u043A\u0440\u0430\u0442\u043A\u043E\u0441\u0440\u043E\u0447\u043D\u043E\u0439* \u0438 \u0434\u043E\u043B\u0433\u043E\u0441\u0440\u043E\u0447\u043D\u043E\u0439 \u0430\u0440\u0435\u043D\u0434\u044B (\u0441\u043C. \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044E \u043D\u0438\u0436\u0435).")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u4E50\u53E4\u6D6A\u5C06\u4E3A\u4E1A\u4E3B\u63D0\u4F9B\u5168\u65B9\u4F4D\u7684\u7269\u4E1A\u670D\u52A1\uFF0C\u5305\u62EC\u866B\u5BB3\u9632\u6CBB\u3001\u4F8B\u884C\u548C\u9884\u9632\u6027\u7EF4\u62A4\u3001\u4E00\u822C\u7EF4\u4FEE\u3001\u5BB6\u653F\u548C\u5176\u4ED6\u5408\u7406\u8981\u6C42\u7684\u670D\u52A1\u3002\u6536\u8D39\u6839\u636E\u670D\u52A1\u7684\u9891\u7387\u548C\u8303\u56F4\u800C\u53D8\u5316\u3002\u6B64\u5916\uFF0C\u4E50\u53E4\u6D6A\u79DF\u8D41\u670D\u52A1\u53EF\u4F7F\u4E1A\u4E3B\u4ECE\u5176\u77ED\u671F*\u548C\u957F\u671F\u623F\u4EA7\u79DF\u8D41\u4E2D\u83B7\u53D6\u6536\u5165\uFF08\u89C1\u4E0B\u6587\uFF09\u3002"))}},{categoryId:3,question:{en:"Can I rent my unit out on my own?",ru:"Могу ли я сдать свою квартиру самостоятельно?",cn:"我可以自己把房子租出去吗？"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Yes, owners may rent out their property on a long-term basis (6 months or more) directly or through external agents."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"For short-term* rentals less than 6 months, these must be conducted exclusively through Laguna Rentals who provides owners with the ability to generate a rental income from their property when not in residence with short-term and long-term rentals."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"* Terms and conditions apply")))),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0414\u0430, \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u0438\u043A\u0438 \u043C\u043E\u0433\u0443\u0442 \u0441\u0434\u0430\u0432\u0430\u0442\u044C \u0441\u0432\u043E\u044E \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u044C \u0432 \u0430\u0440\u0435\u043D\u0434\u0443 \u043D\u0430 \u0434\u043E\u043B\u0433\u043E\u0441\u0440\u043E\u0447\u043D\u043E\u0439 \u043E\u0441\u043D\u043E\u0432\u0435 (\u043D\u0430 6 \u0438 \u0431\u043E\u043B\u0435\u0435 \u043C\u0435\u0441\u044F\u0446\u0435\u0432) \u043D\u0430\u043F\u0440\u044F\u043C\u0443\u044E \u0438\u043B\u0438 \u0447\u0435\u0440\u0435\u0437 \u043F\u043E\u0441\u0440\u0435\u0434\u043D\u0438\u043A\u043E\u0432."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041F\u0440\u0438 \u043A\u0440\u0430\u0442\u043A\u043E\u0441\u0440\u043E\u0447\u043D\u043E\u0439* \u0430\u0440\u0435\u043D\u0434\u0435, \u0441\u0440\u043E\u043A \u043A\u043E\u0442\u043E\u0440\u043E\u0439 \u0441\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 \u043E\u0442 1 \u0434\u043E 6 \u043C\u0435\u0441\u044F\u0446\u0435\u0432, \u0430\u0440\u0435\u043D\u0434\u0430 \u0434\u043E\u043B\u0436\u043D\u0430 \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0442\u044C\u0441\u044F \u0438\u0441\u043A\u043B\u044E\u0447\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u044E Laguna Rentals, \u043A\u043E\u0442\u043E\u0440\u0430\u044F \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0430\u043C \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u044C \u043F\u043E\u043B\u0443\u0447\u0430\u0442\u044C \u0434\u043E\u0445\u043E\u0434 \u043E\u0442 \u0438\u0445 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u0438, \u043A\u043E\u0433\u0434\u0430 \u043E\u043D\u0438 \u043D\u0435 \u043F\u0440\u043E\u0436\u0438\u0432\u0430\u044E\u0442 \u0432 \u043D\u0435\u0439, \u0441\u0434\u0430\u0432\u0430\u044F \u0435\u0435 \u0432 \u0430\u0440\u0435\u043D\u0434\u0443 \u043D\u0430 \u043A\u043E\u0440\u043E\u0442\u043A\u0438\u0439 \u0438 \u0434\u043B\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u0441\u0440\u043E\u043A."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"* \u0414\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0442 \u043F\u0440\u0430\u0432\u0438\u043B\u0430 \u0438 \u0443\u0441\u043B\u043E\u0432\u0438\u044F")))),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u53EF\u4EE5\uFF0C\u4E1A\u4E3B\u53EF\u4EE5\u76F4\u63A5\u6216\u901A\u8FC7\u5916\u90E8\u4E2D\u4ECB\u957F\u671F\uFF086\u4E2A\u6708\u6216\u4EE5\u4E0A\uFF09\u51FA\u79DF\u5176\u623F\u4EA7\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u4F4E\u4E8E6\u4E2A\u6708\u7684\u77ED\u671F*\u79DF\u8D41\u5FC5\u987B\u5B8C\u5168\u901A\u8FC7\u4E50\u53E4\u6D6A\u79DF\u8D41\u8FDB\u884C\uFF0C\u8BE5\u90E8\u95E8\u53EF\u4F7F\u4E1A\u4E3B\u5728\u4E0D\u5C45\u4F4F\u65F6\u901A\u8FC7\u77ED\u671F\u548C\u957F\u671F\u79DF\u8D41\u83B7\u53D6\u79DF\u91D1\u6536\u5165\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"* \u9002\u7528\u6761\u6B3E\u548C\u6761\u4EF6"))))}},{categoryId:3,question:{en:"What are the taxes levied on rental income that an owner will be subject to?",ru:"Какие налоги взимаются с дохода от аренды, получаемого владельцем?",cn:"业主的租金收入需要缴纳什么税？"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Owners may be required to file an income tax return in Thailand based upon rental income earned and pay the applicable tax. Rental distributions made to owners may be subject to withholding tax under the Thai Revenue Code with rates ranging from 5 \u2013 15%, subject to owners tax structure status."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"Note: applicable tax rates are current at the date of issue of this FAQ and may be subject to changes. The unit owner shall be responsible for any income and any other taxes, duties and fees of whatever nature which may be levied by relevant authorities on the unit in connection with the rental")))),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041E\u0442 \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0435\u0432 \u043C\u043E\u0436\u0435\u0442 \u043F\u043E\u0442\u0440\u0435\u0431\u043E\u0432\u0430\u0442\u044C\u0441\u044F \u043F\u043E\u0434\u0430\u0447\u0430 \u043D\u0430\u043B\u043E\u0433\u043E\u0432\u043E\u0439 \u0434\u0435\u043A\u043B\u0430\u0440\u0430\u0446\u0438\u0438 \u0432 \u0422\u0430\u0438\u043B\u0430\u043D\u0434\u0435 \u0441 \u0443\u043A\u0430\u0437\u0430\u043D\u0438\u0435\u043C \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u043D\u043E\u0433\u043E \u0434\u043E\u0445\u043E\u0434\u0430 \u043E\u0442 \u0430\u0440\u0435\u043D\u0434\u044B \u0438 \u0443\u043F\u043B\u0430\u0442\u043E\u0439 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0435\u0433\u043E \u043D\u0430\u043B\u043E\u0433\u0430. \u0412 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u043D\u0430\u043B\u043E\u0433\u043E\u0432\u044B\u043C \u043A\u043E\u0434\u0435\u043A\u0441\u043E\u043C \u0422\u0430\u0438\u043B\u0430\u043D\u0434\u0430 \u0432\u044B\u043F\u043B\u0430\u0442\u0430 \u0430\u0440\u0435\u043D\u0434\u043D\u043E\u0439 \u043F\u043B\u0430\u0442\u044B \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0430\u043C \u043C\u043E\u0436\u0435\u0442 \u043E\u0431\u043B\u0430\u0433\u0430\u0442\u044C\u0441\u044F \u043D\u0430\u043B\u043E\u0433\u043E\u043C, \u043F\u043E \u0441\u0442\u0430\u0432\u043A\u0435 \u043E\u0442 5 \u0434\u043E 15%, \u0432 \u0437\u0430\u0432\u0438\u0441\u0438\u043C\u043E\u0441\u0442\u0438 \u043E\u0442 \u043D\u0430\u043B\u043E\u0433\u043E\u0432\u043E\u0439 \u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u044B \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0430."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"\u041F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0435: \u043F\u0440\u0438\u043C\u0435\u043D\u0438\u043C\u044B\u0435 \u0441\u0442\u0430\u0432\u043A\u0438 \u043D\u0430\u043B\u043E\u0433\u0430 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u044B \u043D\u0430 \u0434\u0430\u0442\u0443 \u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0446\u0438\u0438 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0438 \u0441 \u043E\u0442\u0432\u0435\u0442\u0430\u043C\u0438 \u043D\u0430 \u0447\u0430\u0441\u0442\u043E \u0437\u0430\u0434\u0430\u0432\u0430\u0435\u043C\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B \u0438 \u043C\u043E\u0433\u0443\u0442 \u0431\u044B\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u044B. \u0412\u043B\u0430\u0434\u0435\u043B\u0435\u0446 \u043A\u0432\u0430\u0440\u0442\u0438\u0440\u044B \u043D\u0435\u0441\u0435\u0442 \u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u044C \u0437\u0430 \u0443\u043F\u043B\u0430\u0442\u0443 \u0432\u0441\u0435\u0445 \u043D\u0430\u043B\u043E\u0433\u043E\u0432 \u043D\u0430 \u0434\u043E\u0445\u043E\u0434\u044B \u0438 \u0434\u0440\u0443\u0433\u0438\u0445 \u043D\u0430\u043B\u043E\u0433\u043E\u0432, \u043F\u043E\u0448\u043B\u0438\u043D \u0438 \u0441\u0431\u043E\u0440\u043E\u0432 \u043B\u044E\u0431\u043E\u0433\u043E \u0432\u0438\u0434\u0430, \u043A\u043E\u0442\u043E\u0440\u044B\u043C\u0438 \u043C\u043E\u0433\u0443\u0442 \u043E\u0431\u043B\u0430\u0433\u0430\u0442\u044C \u043A\u0432\u0430\u0440\u0442\u0438\u0440\u0443 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0435 \u043E\u0440\u0433\u0430\u043D\u044B \u0432\u043B\u0430\u0441\u0442\u0438 \u0432 \u0441\u0432\u044F\u0437\u0438 \u0441 \u0435\u0435 \u0441\u0434\u0430\u0447\u0435\u0439 \u0432 \u0430\u0440\u0435\u043D\u0434\u0443.")))),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u4E1A\u4E3B\u53EF\u80FD\u9700\u8981\u5728\u6CF0\u56FD\u6839\u636E\u79DF\u91D1\u6536\u5165\u7533\u62A5\u6240\u5F97\u7A0E\u5E76\u652F\u4ED8\u9002\u7528\u7684\u7A0E\u6536\u3002\u6839\u636E\u6CF0\u56FD\u7A0E\u6536\u6CD5\u5178\uFF0C\u5411\u4E1A\u4E3B\u5206\u914D\u7684\u79DF\u91D1\u53EF\u80FD\u8981\u7F34\u7EB3\u9884\u6263\u7A0E\uFF0C\u7A0E\u7387\u4E3A5-15%\uFF0C\u89C6\u4E1A\u4E3B\u7A0E\u6536\u7ED3\u6784\u72B6\u51B5\u800C\u5B9A\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"\u6CE8\uFF1A\u9002\u7528\u7A0E\u7387\u4E3A\u672C\u5E38\u89C1\u95EE\u9898\u89E3\u7B54\u53D1\u51FA\u4E4B\u65E5\u7684\u73B0\u884C\u7A0E\u7387\uFF0C\u53EF\u80FD\u4F1A\u53D8\u52A8\u3002\u6709\u5173\u90E8\u95E8\u53EF\u80FD\u5BF9\u8BE5\u5355\u5143\u5F81\u6536\u7684\u4E0E\u79DF\u91D1\u6709\u5173\u7684\u4EFB\u4F55\u6536\u5165\u7A0E\u3001\u5176\u4ED6\u7A0E\u6536\u548C\u4EFB\u4F55\u6027\u8D28\u7684\u8D39\u7528\uFF0C\u7531\u4E1A\u4E3B\u8D1F\u8D23\u3002"))))}},// ====================================================================== //
{categoryId:4,question:{en:"What privileges will I receive as an owner?",ru:"Какие привилегии я получу как владелец?",cn:"作为业主，我将得到什么特权？"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Owners will receive membership to the Banyan Group's signature property owners' program, the Sanctuary Club*, which entitles owners to discounts and privileges at the Group's resorts, spas and galleries worldwide including:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"30% discount on best available rates for hotel accommodation")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"30% discount on golf green fees")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"25% discount on food and beverage")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"20% discount on a-la-carte spa menu")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"15% discount on gallery merchandise")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"15% discount on in-house tours")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"15% discount on laundry")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"10% discount airport transfers")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Priority wait-list on reservations")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Early check-in / late check-out"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"* Terms and conditions apply")))),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0412\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u044B \u0430\u043F\u0430\u0440\u0442\u0430\u043C\u0435\u043D\u0442\u043E\u0432 \u0441\u0442\u0430\u043D\u043E\u0432\u044F\u0442\u0441\u044F \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0430\u043C\u0438 Sanctuary Club* \u2013 \u044D\u043A\u0441\u043A\u043B\u044E\u0437\u0438\u0432\u043D\u043E\u0433\u043E \u043A\u043B\u0443\u0431\u0430 \u043E\u0442 Banyan Group \u0434\u043B\u044F \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u0438\u043A\u043E\u0432 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u0438, \u0447\u0442\u043E \u0434\u0430\u0435\u0442 \u0438\u043C \u043F\u0440\u0430\u0432\u043E \u043D\u0430 \u0441\u043A\u0438\u0434\u043A\u0438 \u0438 \u043F\u0440\u0438\u0432\u0438\u043B\u0435\u0433\u0438\u0438 \u043D\u0430 \u0432\u0441\u0435\u0445 \u043A\u0443\u0440\u043E\u0440\u0442\u0430\u0445, \u0432 \u0441\u043F\u0430 \u0438 \u0442\u043E\u0440\u0433\u043E\u0432\u044B\u0445 \u0433\u0430\u043B\u0435\u0440\u0435\u044F\u0445 , \u0432\u043A\u043B\u044E\u0447\u0430\u044F \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0435\u0435:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0421\u043A\u0438\u0434\u043A\u0430 \u0432 \u0440\u0430\u0437\u043C\u0435\u0440\u0435 30% \u043D\u0430 \u043B\u0443\u0447\u0448\u0438\u0435 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B\u0435 \u0446\u0435\u043D\u044B \u043D\u0430 \u043F\u0440\u043E\u0436\u0438\u0432\u0430\u043D\u0438\u0435 \u0432 \u043E\u0442\u0435\u043B\u044F\u0445")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0421\u043A\u0438\u0434\u043A\u0430 \u0432 \u0440\u0430\u0437\u043C\u0435\u0440\u0435 30% \u043D\u0430 \u043F\u043B\u0430\u0442\u0443 \u0437\u0430 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435 \u043F\u043E\u043B\u0435\u043C \u0434\u043B\u044F \u0433\u043E\u043B\u044C\u0444\u0430 (\xAB\u0433\u0440\u0438\u043D-\u0444\u0438\xBB)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0421\u043A\u0438\u0434\u043A\u0430 \u0432 \u0440\u0430\u0437\u043C\u0435\u0440\u0435 25% \u043D\u0430 \u0435\u0434\u0443 \u0438 \u043D\u0430\u043F\u0438\u0442\u043A\u0438")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0421\u043A\u0438\u0434\u043A\u0430 \u0432 \u0440\u0430\u0437\u043C\u0435\u0440\u0435 20% \u043D\u0430 \u043C\u0435\u043D\u044E a-la-carte \u0432 \u0441\u043F\u0430-\u043E\u0442\u0435\u043B\u044F\u0445")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0421\u043A\u0438\u0434\u043A\u0430 \u0432 \u0440\u0430\u0437\u043C\u0435\u0440\u0435 15% \u043D\u0430 \u0442\u043E\u0432\u0430\u0440\u044B \u0432 \u0431\u0443\u0442\u0438\u043A\u0430\u0445")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0421\u043A\u0438\u0434\u043A\u0430 \u0432 \u0440\u0430\u0437\u043C\u0435\u0440\u0435 15% \u043D\u0430 \u0442\u0443\u0440\u044B, \u043F\u0440\u0435\u0434\u043B\u0430\u0433\u0430\u0435\u043C\u044B\u0435 \u043E\u0442\u0435\u043B\u044F\u043C\u0438")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0421\u043A\u0438\u0434\u043A\u0430 \u0432 \u0440\u0430\u0437\u043C\u0435\u0440\u0435 15% \u043D\u0430 \u0443\u0441\u043B\u0443\u0433\u0438 \u043F\u0440\u0430\u0447\u0435\u0447\u043D\u043E\u0439")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0421\u043A\u0438\u0434\u043A\u0430 \u0432 \u0440\u0430\u0437\u043C\u0435\u0440\u0435 10% \u043D\u0430 \u0442\u0440\u0430\u043D\u0441\u0444\u0435\u0440\u044B \u0438\u0437 \u0430\u044D\u0440\u043E\u043F\u043E\u0440\u0442\u0430 / \u0432 \u0430\u044D\u0440\u043E\u043F\u043E\u0440\u0442")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041F\u0440\u0438\u043E\u0440\u0438\u0442\u0435\u0442 \u0432 \u043B\u0438\u0441\u0442\u0435 \u043E\u0436\u0438\u0434\u0430\u043D\u0438\u044F \u043F\u0440\u0438 \u0431\u0440\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0438")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0420\u0430\u043D\u043D\u0438\u0439 \u0437\u0430\u0435\u0437\u0434 / \u043F\u043E\u0437\u0434\u043D\u0438\u0439 \u0432\u044B\u0435\u0437\u0434")))),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u4E1A\u4E3B\u5C06\u6210\u4E3A\u60A6\u6995\u96C6\u56E2\u4E13\u5C5E\u7684\u201C\u6995\u6E90\u4F1A\u4FF1\u4E50\u90E8\u201D\u4F1A\u5458\uFF0C\u83B7\u5F97\u5168\u7403\u96C6\u56E2\u54C1\u724C\u65D7\u4E0B\u7684\u5EA6\u5047\u6751, Spa \u548C\u827A\u54C1\u9601\u7684\u6298\u6263\u548C\u7279\u6743\uFF0C\u5305\u62EC\uFF1A"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u9152\u5E97\u4F4F\u5BBF\u6700\u4F18\u623F\u4EF77\u6298")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u9AD8\u5C14\u592B\u679C\u5CAD\u8D397\u6298")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u9910\u996E7.5\u6298")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u6C34\u7597\u4E2D\u5FC38\u6298")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u96F6\u552E\u827A\u54C1\u9601\u5546\u54C18.5\u6298")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u9152\u5E97\u65C5\u6E38\u670D\u52A18.5\u6298")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u6D17\u8863\u670D\u52A18.5\u6298")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u673A\u573A\u63A5\u90019\u6298")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u9884\u8BA2\u4F18\u5148\u7B49\u5F85\u540D\u5355")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u63D0\u65E9\u5165\u4F4F/\u5EF6\u8FDF\u9000\u623F"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"* \u9002\u7528\u6761\u6B3E\u548C\u6761\u4EF6"))))}},// ====================================================================== //
{categoryId:5,question:{en:"What are the terms of payment?",ru:"Какие предусмотрены условия оплаты?",cn:"付款方式是什么?"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"There are 2 options available:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Option 1:\xA0 100% Payment upon purchase / during construction"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"100% payment upon purchase for already completed properties. Progressive payments for properties under construction are as per the table below."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"table-center"},"Construction Payment Term"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"th-col2"},"Of Selling Price"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"st")," Payment upon signing contract"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"nd")," Payment when construction is 25% complete",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"rd")," Payment when construction is 50% complete",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"th")," Payment when construction is 75% complete",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"3")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"th")," Payment upon completion of construction"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"Total"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"100%")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"Notes:")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",{className:"notes"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"1. Concrete structure substantially completed."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"2. Roof, brickwork and rendering substantially completed."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"3. Electrical conduits, pipework and plastering substantially completed."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"4. Interest will be applied to the post-construction deferred balance as outlined under Financing Option.")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Option 2:\xA0 50% payment upon purchase / during construction with 50% deferred payment over 1, 3 or 5 years"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"50% payment upon purchase for already completed properties. Progressive payments for properties under construction (50% during construction / 50% post construction) as per the table below."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"table-center"},"Deferred Payment Plan"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"th-col2"},"Of Selling Price"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"st")," Payment upon signing contract"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"nd")," Payment when construction is 25% complete",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"10%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"rd")," Payment when construction is 50% complete",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"10%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"th")," Payment when construction is 75% complete",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"3")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"10%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"Post construction payments",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"6")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"50%")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"table-center"},"Financing Options"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"th-col2"},"Interest Rate",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"(per annum)"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1 Year (4 quarterly installments)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"3%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3 Year (12 quarterly installments)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"5%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5 Year (20 quarterly installments)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"7%")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"Notes:")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",{className:"notes"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"1. Concrete structure substantially completed."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"2. Roof, brickwork and rendering substantially completed."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"3. Electrical conduits, pipework and plastering substantially completed."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"4. Interest will be applied to the post-construction deferred balance as outlined under Financing Option.")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"table-center table-number"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"tr-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Price")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Reservation Deposit")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Construction Completion ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Payment 50% (Minus Deposit)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Remaining Post Finance 50%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:"3",className:"td-group-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Quarterly Installment"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"tr-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"1 Year (3%)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"3 Year (5%)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"5 Year (7%)"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"9,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,146,173"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"406,162"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"268,611")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"12,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"6,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,528,230"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"541,550"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"358,147")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"15,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"7,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"7,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,910,288"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"676,937"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"447,684")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"18,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"8,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"9,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,292,345"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"812,325"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"537,221")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"21,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"10,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"10,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,674,403"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"947,712"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"626,758")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"24,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"11,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"12,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3,056,460"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,083,100"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"716,295")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"27,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"13,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"13,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3,438,518"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,218,487"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"805,832")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"30,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"14,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"15,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3,820,575"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,353,875"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"895,368")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"33,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"16,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"16,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4,202,633"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,489,262"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"984,905")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"36,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"17,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"18,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4,584,690"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,624,650"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,074,442")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Notes:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",{className:"notes"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"1. All amounts are stated in Thai Baht (THB).")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"2. The above table sets out the estimated payments required under the respective payment plans for selling prices between THB 9,000,000 \u2013 36,000,000.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"3. The estimated payments are indicative only and the developer / seller does not accept any responsibility or liability whatsoever for any inaccuracies or omissions.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"4. Payment terms are subject to change without notice.")))),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0414\u043B\u044F \u0432\u0441\u0435\u0445 \u043D\u043E\u0432\u044B\u0445 \u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u0438 \u043C\u044B \u043F\u0440\u0435\u0434\u043B\u0430\u0433\u0430\u0435\u043C 2 \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0430 \u043E\u043F\u043B\u0430\u0442\u044B:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u0412\u0430\u0440\u0438\u0430\u043D\u0442 1:\xA0 \u041E\u043F\u043B\u0430\u0442\u0430 \u0432 \u0440\u0430\u0437\u043C\u0435\u0440\u0435 100% \u043F\u0440\u0438 \u043F\u043E\u043A\u0443\u043F\u043A\u0435 / \u0432\u043E \u0432\u0440\u0435\u043C\u044F \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"\u041E\u043F\u043B\u0430\u0442\u0430 \u0432 \u0440\u0430\u0437\u043C\u0435\u0440\u0435 100% \u043F\u0440\u0438 \u043F\u043E\u043A\u0443\u043F\u043A\u0435 \u0433\u043E\u0442\u043E\u0432\u043E\u0439 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u0438. \u041F\u0440\u043E\u0433\u0440\u0435\u0441\u0441\u0438\u0432\u043D\u044B\u0435 \u043F\u043B\u0430\u0442\u0435\u0436\u0438 \u0437\u0430 \u0441\u0442\u0440\u043E\u044F\u0449\u0443\u044E\u0441\u044F \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u044C \u0443\u043A\u0430\u0437\u0430\u043D\u044B \u0432 \u0442\u0430\u0431\u043B\u0438\u0446\u0435 \u043D\u0438\u0436\u0435."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"table-center"},"\u0421\u0440\u043E\u043A \u043F\u043B\u0430\u0442\u0435\u0436\u0430 \u043D\u0430 \u043C\u043E\u043C\u0435\u043D\u0442 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"th-col2"},"% \u043E\u0442 \u0446\u0435\u043D\u044B \u043F\u0440\u043E\u0434\u0430\u0436\u0438"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1-\u0439 \u043F\u043B\u0430\u0442\u0435\u0436 \u043F\u0440\u0438 \u043F\u043E\u0434\u043F\u0438\u0441\u0430\u043D\u0438\u0438 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2-\u0439 \u043F\u043B\u0430\u0442\u0435\u0436 \u043F\u0440\u0438 \u0433\u043E\u0442\u043E\u0432\u043D\u043E\u0441\u0442\u0438 \u043E\u0431\u044A\u0435\u043A\u0442\u0430 \u043D\u0430 25%",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3-\u0439 \u043F\u043B\u0430\u0442\u0435\u0436 \u0433\u043E\u0442\u043E\u0432\u043D\u043E\u0441\u0442\u0438 \u043E\u0431\u044A\u0435\u043A\u0442\u0430 \u043D\u0430 50%",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4-\u0439 \u043F\u043B\u0430\u0442\u0435\u0436 \u0433\u043E\u0442\u043E\u0432\u043D\u043E\u0441\u0442\u0438 \u043E\u0431\u044A\u0435\u043A\u0442\u0430 \u043D\u0430 75%",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"3")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5-\u0439 \u043F\u043B\u0430\u0442\u0435\u0436 \u043F\u043E \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u0438 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u0418\u0442\u043E\u0433\u043E"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"100%")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u041F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u044F:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",{className:"notes"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"1. \u041A\u043E\u0440\u043E\u0431\u043A\u0430 \u0437\u0434\u0430\u043D\u0438\u044F \u0432 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u043C \u0432\u043E\u0437\u0432\u0435\u0434\u0435\u043D\u0430.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"2. \u0412\u043E\u0437\u0432\u0435\u0434\u0435\u043D\u0438\u0435 \u043A\u0440\u043E\u0432\u043B\u0438, \u043A\u0438\u0440\u043F\u0438\u0447\u043D\u0430\u044F \u043A\u043B\u0430\u0434\u043A\u0430 \u0438 \u0448\u0442\u0443\u043A\u0430\u0442\u0443\u0440\u043A\u0430 \u043D\u0430\u0440\u0443\u0436\u043D\u043E\u0439 \u043F\u043E\u0432\u0435\u0440\u0445\u043D\u043E\u0441\u0442\u0438 \u0441\u0442\u0435\u043D \u0432 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u043C \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u044B.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"3. \u042D\u043B\u0435\u043A\u0442\u0440\u043E\u043F\u0440\u043E\u0432\u043E\u0434\u043A\u0430, \u0440\u0430\u0437\u0432\u043E\u0434\u043A\u0430 \u0442\u0440\u0443\u0431 \u0438 \u0432\u043D\u0443\u0442\u0440\u0435\u043D\u043D\u0435\u0435 \u043E\u0448\u0442\u0443\u043A\u0430\u0442\u0443\u0440\u0438\u0432\u0430\u043D\u0438\u0435 \u0432 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u043C \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u044B.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"4. \u041D\u0430 \u043E\u0442\u043B\u043E\u0436\u0435\u043D\u043D\u044B\u0439 \u043E\u0441\u0442\u0430\u0442\u043E\u043A \u043E\u043F\u043B\u0430\u0442\u044B \u043F\u043E\u0441\u043B\u0435 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 \u043D\u0430\u0447\u0438\u0441\u043B\u044F\u044E\u0442\u0441\u044F \u043F\u0440\u043E\u0446\u0435\u043D\u0442\u044B \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u0440\u0430\u0437\u0434\u0435\u043B\u043E\u043C \xAB\u0412\u0430\u0440\u0438\u0430\u043D\u0442\u044B \u0444\u0438\u043D\u0430\u043D\u0441\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F\xBB."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u0412\u0430\u0440\u0438\u0430\u043D\u0442 2:\xA0 \u041E\u043F\u043B\u0430\u0442\u0430 \u0432 \u0440\u0430\u0437\u043C\u0435\u0440\u0435 50% \u043F\u0440\u0438 \u043F\u043E\u043A\u0443\u043F\u043A\u0435 / \u0432\u043E \u0432\u0440\u0435\u043C\u044F \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 \u0441 \u043E\u0442\u0441\u0440\u043E\u0447\u043A\u043E\u0439 \u043E\u043F\u043B\u0430\u0442\u044B \u0432 \u0440\u0430\u0437\u043C\u0435\u0440\u0435 50% \u043D\u0430 1, 3 \u0438\u043B\u0438 5 \u043B\u0435\u0442"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"\u041E\u043F\u043B\u0430\u0442\u0430 \u0432 \u0440\u0430\u0437\u043C\u0435\u0440\u0435 50% \u043F\u0440\u0438 \u043F\u043E\u043A\u0443\u043F\u043A\u0435 \u0433\u043E\u0442\u043E\u0432\u043E\u0439 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u0438. \u041F\u0440\u043E\u0433\u0440\u0435\u0441\u0441\u0438\u0432\u043D\u044B\u0435 \u043F\u043B\u0430\u0442\u0435\u0436\u0438 \u0437\u0430 \u0441\u0442\u0440\u043E\u044F\u0449\u0443\u044E\u0441\u044F \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u044C (50% \u0432\u043E \u0432\u0440\u0435\u043C\u044F \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 / 50% \u043F\u043E\u0441\u043B\u0435 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430) \u0441\u043E\u0433\u043B\u0430\u0441\u043D\u043E \u0442\u0430\u0431\u043B\u0438\u0446\u0435 \u043D\u0438\u0436\u0435."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"table-center"},"\u0413\u0440\u0430\u0444\u0438\u043A \u043E\u0442\u043B\u043E\u0436\u0435\u043D\u043D\u044B\u0445 \u043F\u043B\u0430\u0442\u0435\u0436\u0435\u0439"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"th-col2"},"% \u043E\u0442 \u0446\u0435\u043D\u044B \u043F\u0440\u043E\u0434\u0430\u0436\u0438"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1-\u0439 \u043F\u043B\u0430\u0442\u0435\u0436 \u043F\u0440\u0438 \u043F\u043E\u0434\u043F\u0438\u0441\u0430\u043D\u0438\u0438 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2-\u0439 \u043F\u043B\u0430\u0442\u0435\u0436 \u043F\u0440\u0438 \u0433\u043E\u0442\u043E\u0432\u043D\u043E\u0441\u0442\u0438 \u043E\u0431\u044A\u0435\u043A\u0442\u0430 \u043D\u0430 25%",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"10%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3-\u0439 \u043F\u043B\u0430\u0442\u0435\u0436 \u043F\u0440\u0438 \u0433\u043E\u0442\u043E\u0432\u043D\u043E\u0441\u0442\u0438 \u043E\u0431\u044A\u0435\u043A\u0442\u0430 \u043D\u0430 50%",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"10%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4-\u0439 \u043F\u043B\u0430\u0442\u0435\u0436 \u043F\u0440\u0438 \u0433\u043E\u0442\u043E\u0432\u043D\u043E\u0441\u0442\u0438 \u043E\u0431\u044A\u0435\u043A\u0442\u0430 \u043D\u0430 75%"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"10%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u041F\u043B\u0430\u0442\u0435\u0436\u0438 \u043F\u043E\u0441\u043B\u0435 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"6")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"50%")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"table-center"},"\u0412\u0430\u0440\u0438\u0430\u043D\u0442\u044B \u0444\u0438\u043D\u0430\u043D\u0441\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"th-col2"},"\u041F\u0440\u043E\u0446\u0435\u043D\u0442\u043D\u0430\u044F",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"\u0441\u0442\u0430\u0432\u043A\u0430 (\u0433\u043E\u0434\u043E\u0432\u044B\u0445)"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1 \u0433\u043E\u0434 (4 \u043A\u0432\u0430\u0440\u0442\u0430\u043B\u044C\u043D\u044B\u0445 \u043F\u043B\u0430\u0442\u0435\u0436\u0430)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"3%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3 \u0433\u043E\u0434\u0430 (12 \u043A\u0432\u0430\u0440\u0442\u0430\u043B\u044C\u043D\u044B\u0445 \u043F\u043B\u0430\u0442\u0435\u0436\u0430)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"5%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5 \u043B\u0435\u0442 (20 \u043A\u0432\u0430\u0440\u0442\u0430\u043B\u044C\u043D\u044B\u0445 \u043F\u043B\u0430\u0442\u0435\u0436\u0430)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"7%")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u041F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u044F:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",{className:"notes"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"1. \u041A\u043E\u0440\u043E\u0431\u043A\u0430 \u0437\u0434\u0430\u043D\u0438\u044F \u0432 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u043C \u0432\u043E\u0437\u0432\u0435\u0434\u0435\u043D\u0430.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"2. \u0412\u043E\u0437\u0432\u0435\u0434\u0435\u043D\u0438\u0435 \u043A\u0440\u043E\u0432\u043B\u0438, \u043A\u0438\u0440\u043F\u0438\u0447\u043D\u0430\u044F \u043A\u043B\u0430\u0434\u043A\u0430 \u0438 \u0448\u0442\u0443\u043A\u0430\u0442\u0443\u0440\u043A\u0430 \u043D\u0430\u0440\u0443\u0436\u043D\u043E\u0439 \u043F\u043E\u0432\u0435\u0440\u0445\u043D\u043E\u0441\u0442\u0438 \u0441\u0442\u0435\u043D \u0432 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u043C \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u044B.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"3. \u042D\u043B\u0435\u043A\u0442\u0440\u043E\u043F\u0440\u043E\u0432\u043E\u0434\u043A\u0430, \u0440\u0430\u0437\u0432\u043E\u0434\u043A\u0430 \u0442\u0440\u0443\u0431 \u0438 \u0432\u043D\u0443\u0442\u0440\u0435\u043D\u043D\u0435\u0435 \u043E\u0448\u0442\u0443\u043A\u0430\u0442\u0443\u0440\u0438\u0432\u0430\u043D\u0438\u0435 \u0432 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u043C \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u044B.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"4. \u041D\u0430 \u043E\u0442\u043B\u043E\u0436\u0435\u043D\u043D\u044B\u0439 \u043E\u0441\u0442\u0430\u0442\u043E\u043A \u043E\u043F\u043B\u0430\u0442\u044B \u043F\u043E\u0441\u043B\u0435 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 \u043D\u0430\u0447\u0438\u0441\u043B\u044F\u044E\u0442\u0441\u044F \u043F\u0440\u043E\u0446\u0435\u043D\u0442\u044B \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u0440\u0430\u0437\u0434\u0435\u043B\u043E\u043C \xAB\u0412\u0430\u0440\u0438\u0430\u043D\u0442\u044B \u0444\u0438\u043D\u0430\u043D\u0441\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F\xBB."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"table-center table-number"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"tr-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u0426\u0435\u043D\u0430")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u0420\u0435\u0437\u0435\u0440\u0432\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u0434\u0435\u043F\u043E\u0437\u0438\u0442")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u041F\u043B\u0430\u0442\u0435\u0436 \u043F\u043E \u043E\u043A\u043E\u043D\u0447\u0430\u043D\u0438\u0438 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 50%",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"(\u041C\u0438\u043D\u0443\u0441 \u0434\u0435\u043F\u043E\u0437\u0438\u0442)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u0420\u0430\u0441\u0441\u0440\u043E\u0447\u043A\u0430 \u043F\u043E\u0441\u043B\u0435 \u043E\u043A\u043E\u043D\u0447\u0430\u043D\u0438\u044F \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 50%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:"3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u0415\u0436\u0435\u043A\u0432\u0430\u0440\u0442\u0430\u043B\u044C\u043D\u044B\u0439 \u043F\u043B\u0430\u0442\u0435\u0436"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"tr-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"1 \u0433\u043E\u0434 (3%)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"3 \u0433\u043E\u0434\u0430 (5%)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"5 \u043B\u0435\u0442 (7%)"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"9,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,146,173"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"406,162"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"268,611")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"12,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"6,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,528,230"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"541,550"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"358,147")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"15,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"7,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"7,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,910,288"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"676,937"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"447,684")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"18,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"8,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"9,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,292,345"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"812,325"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"537,221")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"21,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"10,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"10,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,674,403"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"947,712"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"626,758")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"24,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"11,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"12,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3,056,460"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,083,100"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"716,295")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"27,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"13,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"13,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3,438,518"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,218,487"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"805,832")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"30,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"14,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"15,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3,820,575"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,353,875"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"895,368")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"33,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"16,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"16,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4,202,633"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,489,262"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"984,905")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"36,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"17,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"18,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4,584,690"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,624,650"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,074,442")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u041F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u044F:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",{className:"notes"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"1. \u0412\u0441\u0435 \u0441\u0443\u043C\u043C\u044B \u0443\u043A\u0430\u0437\u0430\u043D\u044B \u0432 \u0442\u0430\u0439\u0441\u043A\u0438\u0445 \u0431\u0430\u0442\u0430\u0445 (THB).")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"2. \u0412 \u043F\u0440\u0438\u0432\u0435\u0434\u0435\u043D\u043D\u043E\u0439 \u0432\u044B\u0448\u0435 \u0442\u0430\u0431\u043B\u0438\u0446\u0435 \u0443\u043A\u0430\u0437\u0430\u043D\u044B \u0440\u0430\u0441\u0447\u0435\u0442\u043D\u044B\u0435 \u0441\u0443\u043C\u043C\u044B \u043F\u043B\u0430\u0442\u0435\u0436\u0435\u0439, \u043F\u0440\u0435\u0434\u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u043D\u044B\u0445 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u043C\u0438 \u0433\u0440\u0430\u0444\u0438\u043A\u0430\u043C\u0438 \u0434\u043B\u044F \u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u0438 \u0441 \u043F\u0440\u043E\u0434\u0430\u0436\u043D\u043E\u0439 \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C\u044E \u043E\u0442 9 000 000 \u0434\u043E 36 000 000 THB.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"3. \u0420\u0430\u0441\u0447\u0435\u0442\u043D\u044B\u0435 \u0441\u0443\u043C\u043C\u044B \u043F\u043B\u0430\u0442\u0435\u0436\u0435\u0439 \u044F\u0432\u043B\u044F\u044E\u0442\u0441\u044F \u043E\u0440\u0438\u0435\u043D\u0442\u0438\u0440\u043E\u0432\u043E\u0447\u043D\u044B\u043C\u0438, \u0438 \u0437\u0430\u0441\u0442\u0440\u043E\u0439\u0449\u0438\u043A / \u043F\u0440\u043E\u0434\u0430\u0432\u0435\u0446 \u043D\u0435 \u043D\u0435\u0441\u0443\u0442 \u043D\u0438\u043A\u0430\u043A\u043E\u0439 \u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u0437\u0430 \u043D\u0435\u0442\u043E\u0447\u043D\u043E\u0441\u0442\u0438 \u0438\u043B\u0438 \u0443\u043F\u0443\u0449\u0435\u043D\u0438\u044F.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"4. \u0423\u0441\u043B\u043E\u0432\u0438\u044F \u043E\u043F\u043B\u0430\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0431\u044B\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u044B \u0431\u0435\u0437 \u043F\u0440\u0435\u0434\u0432\u0430\u0440\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0433\u043E \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F.")))),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u4E24\u79CD\u4ED8\u6B3E\u8BA1\u5212\uFF1A"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u9009\u62E91\uFF1A \u8D2D\u4E70/\u65BD\u5DE5\u671F\u95F4\u5168\u989D\u4ED8\u6B3E"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"\u8D2D\u4E70\u5DF2\u7AE3\u5DE5\u7269\u4E1A\u65F6\u5168\u989D\u4ED8\u6B3E\u3002 \u5BF9\u4E8E\u5728\u5EFA\u7269\u4E1A\uFF0C\u6309\u4E0B\u8868\u6839\u636E\u65BD\u5DE5\u8FDB\u5EA6\u5206\u671F\u4ED8\u6B3E\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"table-center"},"\u65BD\u5DE5\u8FDB\u5EA6\u4ED8\u6B3E\u8BA1\u5212"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"th-col2"},"\u552E\u4EF7\u4ED8\u6B3E\u6BD4\u4F8B"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u7B7E\u7F72\u5408\u540C\u65F6\u8FDB\u884C\u9996\u4ED8"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u5DE5\u7A0B\u5B8C\u621025%\u65F6\u8FDB\u884C\u7B2C2\u6B21\u4ED8\u6B3E",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u5DE5\u7A0B\u5B8C\u621050%\u65F6\u8FDB\u884C\u7B2C3\u6B21\u4ED8\u6B3E",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u5DE5\u7A0B\u5B8C\u621075%\u65F6\u8FDB\u884C\u7B2C4\u6B21\u4ED8\u6B3E",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"3")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u7AE3\u5DE5\u65F6\u8FDB\u884C\u7B2C5\u6B21\u4ED8\u6B3E"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u5408\u8BA1"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"100%")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u5907\u6CE8:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",{className:"notes"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"1. \u6DF7\u51DD\u571F\u7ED3\u6784\u57FA\u672C\u5B8C\u6210\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"2. \u5C4B\u9876\u3001\u7816\u780C\u548C\u7C89\u5237\u57FA\u672C\u5B8C\u6210\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"3. \u7535\u529B\u7BA1\u3001\u7BA1\u9053\u5DE5\u7A0B\u548C\u62B9\u7070\u57FA\u672C\u5B8C\u6210\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"4. \u7AE3\u5DE5\u540E\u5EF6\u671F\u4ED8\u6B3E\u4F59\u989D\u9700\u652F\u4ED8\u8D22\u52A1\u9009\u62E9\u4E2D\u6240\u5217\u7684\u5229\u606F\u3002"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u9009\u62E92\uFF1A \u8D2D\u4E70\u65F6/\u65BD\u5DE5\u671F\u95F4\u4ED8\u6B3E50%\uFF0C\u5269\u4F59\u768450%\u5EF6\u671F\u6B3E\u9879\u57281\u5E74\u30013\u5E74\u62165\u5E74\u5185\u652F\u4ED8"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"\u8D2D\u4E70\u5DF2\u7AE3\u5DE5\u7269\u4E1A\u652F\u4ED8 50%\u7684\u6B3E\u9879\u3002\u5BF9\u4E8E\u5728\u5EFA\u7269\u4E1A\uFF0C\u6309\u4E0B\u8868\u6839\u636E\u65BD\u5DE5\u8FDB\u5EA6\u5206\u671F\u4ED8\u6B3E(\u65BD\u5DE5\u671F\u95F4\u4ED8 \u6B3E 50%/\u7AE3\u5DE5\u540E\u4ED8\u6B3E 50%)\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"table-center"},"\u5EF6\u671F\u4ED8\u6B3E\u8BA1\u5212"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"th-col2"},"\u552E\u4EF7\u4ED8\u6B3E\u6BD4\u4F8B"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u7B7E\u7F72\u5408\u540C\u65F6\u8FDB\u884C\u9996\u4ED8"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u5DE5\u7A0B\u5B8C\u6210 25%\u65F6\u7B2C 2 \u6B21\u4ED8\u6B3E",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"10%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u5DE5\u7A0B\u5B8C\u6210 50%\u65F6\u7B2C 3 \u6B21\u4ED8\u6B3E",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"10%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u5DE5\u7A0B\u5B8C\u6210 75%\u65F6\u7B2C 4 \u6B21\u4ED8\u6B3E",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"3")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"10%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u7AE3\u5DE5\u540E\u4ED8\u6B3E",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"6")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"50%")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"table-center"},"\u8D22\u52A1\u9009\u62E9"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"th-col2"},"\u5229\u7387 (\u6BCF\u5E74)"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1\u5E74 (4 \u4E2A\u5B63\u5EA6\u5206\u671F\u4ED8\u6B3E)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"3%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3\u5E74 (12 \u4E2A\u5B63\u5EA6\u5206\u671F\u4ED8\u6B3E)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"5%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5\u5E74 (20 \u4E2A\u5B63\u5EA6\u5206\u671F\u4ED8\u6B3E)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"7%")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u5907\u6CE8:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",{className:"notes"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"1. \u6DF7\u51DD\u571F\u7ED3\u6784\u57FA\u672C\u5B8C\u6210\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"2. \u5C4B\u9876\u3001\u7816\u780C\u548C\u7C89\u5237\u57FA\u672C\u5B8C\u6210\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"3. \u7535\u529B\u7BA1\u3001\u7BA1\u9053\u5DE5\u7A0B\u548C\u62B9\u7070\u57FA\u672C\u5B8C\u6210\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"4. \u7AE3\u5DE5\u540E\u5EF6\u671F\u4ED8\u6B3E\u4F59\u989D\u9700\u652F\u4ED8\u8D22\u52A1\u9009\u62E9\u4E2D\u6240\u5217\u7684\u5229\u606F\u3002"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"table-center table-number"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"tr-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u4EF7\u683C")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u5B9A\u91D1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u5DE5\u7A0B\u5B8C\u5DE5\u652F\u4ED8 50%\u623F\u6B3E ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"(\u6263\u9664\u5B9A\u91D1)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u5269\u4F5950%\u623F\u6B3E\u5206\u671F\u652F\u4ED8")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:"3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u6BCF\u5B63\u5EA6\u652F\u4ED8\u6B3E\u9879"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"tr-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"1 \u5E74 (3%)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"3 \u5E74 (5%)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"5 \u5E74 (7%)"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"9,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,146,173"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"406,162"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"268,611")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"12,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"6,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,528,230"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"541,550"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"358,147")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"15,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"7,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"7,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,910,288"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"676,937"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"447,684")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"18,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"8,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"9,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,292,345"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"812,325"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"537,221")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"21,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"10,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"10,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,674,403"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"947,712"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"626,758")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"24,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"11,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"12,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3,056,460"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,083,100"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"716,295")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"27,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"13,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"13,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3,438,518"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,218,487"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"805,832")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"30,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"14,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"15,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3,820,575"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,353,875"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"895,368")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"33,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"16,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"16,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4,202,633"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,489,262"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"984,905")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"36,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"17,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"18,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4,584,690"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,624,650"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,074,442")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u5907\u6CE8:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",{className:"notes"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"1. \u6240\u6709\u91D1\u989D\u5747\u4EE5\u6CF0\u94E2\uFF08THB\uFF09\u8868\u793A\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"2. \u4E0A\u8868\u5217\u51FA\u4E86\u9500\u552E\u4EF7\u683C\u4E3A9,000,000 \u2013 36,000,000\u6CF0\u94E2\u65F6\uFF0C\u76F8\u5E94\u4ED8\u6B3E\u8BA1\u5212\u6240\u9700\u652F\u4ED8\u7684\u9884\u8BA1\u91D1\u989D\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"3. \u9884\u8BA1\u4ED8\u6B3E\u989D\u4EC5\u4F5C\u793A\u610F\u53C2\u8003\u7528\u9014\u3002\u5982\u6709\u9519\u6F0F\uFF0C\u5F00\u53D1\u5546/\u9500\u552E\u65B9\u6982\u4E0D\u8D1F\u8D23\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"4. \u4ED8\u6B3E\u8BA1\u5212\u5982\u6709\u66F4\u6539\uFF0C\u6055\u4E0D\u53E6\u884C\u901A\u77E5\u3002"))))}}];

/***/ }),
/* 891 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PhuketLagunaVillageResidences; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_skrollr__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_skrollr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_skrollr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_scroll__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_helmet__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hoc__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_language__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_location__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_phuket_laguna_village_residences__ = __webpack_require__(892);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Gallery__ = __webpack_require__(901);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Concept__ = __webpack_require__(902);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Faq__ = __webpack_require__(903);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Destination__ = __webpack_require__(904);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__TheSanctuaryclub__ = __webpack_require__(905);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Siteplan__ = __webpack_require__(906);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Masterplan__ = __webpack_require__(907);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Residences__ = __webpack_require__(908);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Ebrochure__ = __webpack_require__(909);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var page="phuket-laguna-village-residences";var sections=[{key:"gallery",label:"Gallery"},{key:"concept",label:"Concept"},{key:"masterplan",label:"Master Plan"},{key:"siteplan",label:"Site Plan"},{key:"residences",label:"Residences"},{key:"destination",label:"Destination"},{key:"sanctuary-club",label:"The Santuary Club"},{key:"faq",label:"FAQ",hideOnMobile:true},{key:"e-brochure",label:"E-Brochure",hideOnMobile:true}];var mapStateToProps=function mapStateToProps(state){return Object.assign({},state);};var actionToProps={switchLanguage:__WEBPACK_IMPORTED_MODULE_7__actions_language__["a" /* switchLanguage */],switchLocation:__WEBPACK_IMPORTED_MODULE_8__actions_location__["a" /* switchLocation */],initAppPhuketLagunaVillageResidences:__WEBPACK_IMPORTED_MODULE_9__actions_phuket_laguna_village_residences__["a" /* initAppPhuketLagunaVillageResidences */]};var PhuketLagunaVillageResidences=(_dec=Object(__WEBPACK_IMPORTED_MODULE_6__hoc__["b" /* withRedux */])(mapStateToProps,actionToProps),_dec(_class=function(_Component){_inherits(PhuketLagunaVillageResidences,_Component);function PhuketLagunaVillageResidences(props){_classCallCheck(this,PhuketLagunaVillageResidences);var _this=_possibleConstructorReturn(this,(PhuketLagunaVillageResidences.__proto__||Object.getPrototypeOf(PhuketLagunaVillageResidences)).call(this,props));_this.handleWheel=function(evt){if(evt.deltaY>0){var atBottomOfSection=_this.headerRef.current.atBottomOfSection();if(atBottomOfSection){evt.preventDefault();evt.stopPropagation();evt.returnValue=false;// console.log('evt', evt.deltaY);
_this.headerRef.current.handleScrollDown();}}if(evt.deltaY<0){var atTopOfSection=_this.headerRef.current.atTopOfSection();if(atTopOfSection){evt.preventDefault();evt.stopPropagation();evt.returnValue=false;// console.log('evt', evt.deltaY);
_this.headerRef.current.handleScrollUp();}}};_this.setLanguage=function(language){_this.props.actions.switchLanguage(language);};_this.setLocation=function(location){_this.props.actions.switchLocation(location);};_this.fetchData=function(){_this.props.actions.initAppPhuketLagunaVillageResidences();};_this.renderSectionWithId=function(component,id){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_scroll__["Element"],{name:id},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("section",{id:id},component));};_this.headerRef=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createRef();return _this;}_createClass(PhuketLagunaVillageResidences,[{key:"componentDidMount",value:function componentDidMount(){this.setLanguage(this.props.match.params.language);this.setLocation(this.props.route.key);this.fetchData();}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps){var currentLanguage=prevProps.match.params.language;var nextLanguage=this.props.match.params.language;if(currentLanguage!==nextLanguage){this.setLanguage(nextLanguage);}}},{key:"render",value:function render(){var pageData=__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(this.props,page+".data");var isMobile=__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(this.props,"device.isMobile");var currentLanguage=__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(this.props,"language.currentActive");console.log("pageData-Village",{page:page,pageData:pageData});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_skrollr__["ParallaxProvider"],{init:{smoothScrollingDuration:100,smoothScrolling:true,forceHeight:false}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_helmet__["Helmet"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("title",null,"Luxury Villas in Phuket For Sale | Laguna Property"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("meta",{name:"description",content:"Find your home luxury villa at Laguna Village in Phuket. We have 4-bedroom villas with private pool now for sale in Phuket."}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("meta",{name:"keywords",content:"4 bedroom villa residence phuket, 4 bedroom residences with private pool in phuket, 4 bedroom house with pool for sale phuket, buy luxury 4 bedroom villa phuket, luxury villas in phuket for sale, villa resort bang tao beach, residence with private pool in phuket for sale, buy luxury villas in phuket"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["f" /* Header */],{mainLogo:Object(__WEBPACK_IMPORTED_MODULE_10__utils__["a" /* assetsPath */])()+"/images/logo-laguna-property.svg",subLogo:Object(__WEBPACK_IMPORTED_MODULE_10__utils__["a" /* assetsPath */])(page)+"/images/logo/logo.png",language:currentLanguage,projectSections:sections,wrappedComponentRef:this.headerRef}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"main-content laguna-village-residences-page",disable_onWheel:this.handleWheel},this.renderSectionWithId(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Gallery__["a" /* default */],Object.assign({},__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"gallery"),{page:page})),"gallery"),this.renderSectionWithId(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Concept__["a" /* default */],{imageSlider:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"concept.imageSlider"),content:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"concept.content"),page:page}),"concept"),this.renderSectionWithId(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Masterplan__["a" /* default */],{map:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"masterPlan.maps"),page:page}),"masterplan"),this.renderSectionWithId(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Siteplan__["a" /* default */],{map:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"sitePlan.maps"),dataSitePlan:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"sitePlan.type"),page:page}),"siteplan"),this.renderSectionWithId(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Residences__["a" /* default */],{landingPage:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"residence.landingPage"),type:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"residence.type"),page:page}),"residences"),this.renderSectionWithId(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Destination__["a" /* default */],{isMobile:isMobile,imageSlider:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"destination.landingPage"),title:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"destination.content.title"),description:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"destination.content.description"),mapData:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"destination.map"),page:page}),"destination"),this.renderSectionWithId(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__TheSanctuaryclub__["a" /* default */],{description:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"sanctuaryClub.description"),image:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"sanctuaryClub.image"),title:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"sanctuaryClub.title"),page:page}),"sanctuary-club"),this.renderSectionWithId(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Faq__["a" /* default */],Object.assign({},__webpack_require__(910),{page:page})),"faq"),this.renderSectionWithId(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Ebrochure__["a" /* default */],{location:"phuket",project:"laguna-village-residences",page:page}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["d" /* Footer */],null)),"e-brochure"))));}}]);return PhuketLagunaVillageResidences;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class);

/***/ }),
/* 892 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return initAppPhuketLagunaVillageResidences; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_reduce__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_reduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_reduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_actionType__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_phuket_laguna_village_residences__ = __webpack_require__(893);
var _this=this;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var initAppPhuketLagunaVillageResidences=function initAppPhuketLagunaVillageResidences(){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch){var listApi,apiResult,mapData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:listApi=[];_context.t0=listApi;_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_3__services_phuket_laguna_village_residences__["c" /* fetchGalleryApi */])();case 4:_context.t1=_context.sent;_context.t2={key:"gallery",data:_context.t1};_context.t0.push.call(_context.t0,_context.t2);_context.t3=listApi;_context.next=10;return Object(__WEBPACK_IMPORTED_MODULE_3__services_phuket_laguna_village_residences__["a" /* fetchConceptApi */])();case 10:_context.t4=_context.sent;_context.t5={key:"concept",data:_context.t4};_context.t3.push.call(_context.t3,_context.t5);_context.t6=listApi;_context.next=16;return Object(__WEBPACK_IMPORTED_MODULE_3__services_phuket_laguna_village_residences__["d" /* fetchMasterPlanApi */])();case 16:_context.t7=_context.sent;_context.t8={key:"masterPlan",data:_context.t7};_context.t6.push.call(_context.t6,_context.t8);_context.t9=listApi;_context.next=22;return Object(__WEBPACK_IMPORTED_MODULE_3__services_phuket_laguna_village_residences__["g" /* fetchSitePlanApi */])();case 22:_context.t10=_context.sent;_context.t11={key:"sitePlan",data:_context.t10};_context.t9.push.call(_context.t9,_context.t11);_context.t12=listApi;_context.next=28;return Object(__WEBPACK_IMPORTED_MODULE_3__services_phuket_laguna_village_residences__["e" /* fetchResidenceApi */])();case 28:_context.t13=_context.sent;_context.t14={key:"residence",data:_context.t13};_context.t12.push.call(_context.t12,_context.t14);_context.t15=listApi;_context.next=34;return Object(__WEBPACK_IMPORTED_MODULE_3__services_phuket_laguna_village_residences__["b" /* fetchDestinationApi */])();case 34:_context.t16=_context.sent;_context.t17={key:"destination",data:_context.t16};_context.t15.push.call(_context.t15,_context.t17);_context.t18=listApi;_context.next=40;return Object(__WEBPACK_IMPORTED_MODULE_3__services_phuket_laguna_village_residences__["f" /* fetchSanctuaryClubApi */])();case 40:_context.t19=_context.sent;_context.t20={key:"sanctuaryClub",data:_context.t19};_context.t18.push.call(_context.t18,_context.t20);_context.prev=43;_context.next=46;return Promise.all(listApi);case 46:apiResult=_context.sent;mapData=__WEBPACK_IMPORTED_MODULE_1_lodash_reduce___default()(apiResult,function(result,value,index){var key=value.key,data=value.data;return Object.assign({},result,_defineProperty({},key,data));},{});dispatch({type:__WEBPACK_IMPORTED_MODULE_2__actions_actionType__["g" /* RECEIVE_PHUKET_LAGUNA_VILLAGE_RESIDENCES */],data:mapData});_context.next=54;break;case 51:_context.prev=51;_context.t21=_context["catch"](43);console.error("initAppPhuketLagunaVillageResidences err",_context.t21);case 54:case"end":return _context.stop();}}},_callee,_this,[[43,51]]);}));return function(_x){return _ref.apply(this,arguments);};}();};

/***/ }),
/* 893 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchGalleryApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchConceptApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchMasterPlanApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return fetchSitePlanApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fetchResidenceApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchDestinationApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fetchSanctuaryClubApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_PhuketLagunaVillageResidences_gallery__ = __webpack_require__(894);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_PhuketLagunaVillageResidences_concept__ = __webpack_require__(895);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_PhuketLagunaVillageResidences_masterplan__ = __webpack_require__(896);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_PhuketLagunaVillageResidences_sitePlan__ = __webpack_require__(897);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_PhuketLagunaVillageResidences_residence__ = __webpack_require__(898);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_PhuketLagunaVillageResidences_destination__ = __webpack_require__(899);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_PhuketLagunaVillageResidences_sanctuaryClub__ = __webpack_require__(900);
var fetchGalleryApi=function fetchGalleryApi(){return Promise.resolve(__WEBPACK_IMPORTED_MODULE_0__data_PhuketLagunaVillageResidences_gallery__["a" /* default */]);};var fetchConceptApi=function fetchConceptApi(){return Promise.resolve(__WEBPACK_IMPORTED_MODULE_1__data_PhuketLagunaVillageResidences_concept__["a" /* default */]);};var fetchMasterPlanApi=function fetchMasterPlanApi(){return Promise.resolve(__WEBPACK_IMPORTED_MODULE_2__data_PhuketLagunaVillageResidences_masterplan__["a" /* default */]);};var fetchSitePlanApi=function fetchSitePlanApi(){return Promise.resolve(__WEBPACK_IMPORTED_MODULE_3__data_PhuketLagunaVillageResidences_sitePlan__["a" /* default */]);};var fetchResidenceApi=function fetchResidenceApi(){return Promise.resolve(__WEBPACK_IMPORTED_MODULE_4__data_PhuketLagunaVillageResidences_residence__["a" /* default */]);};var fetchDestinationApi=function fetchDestinationApi(){return Promise.resolve(__WEBPACK_IMPORTED_MODULE_5__data_PhuketLagunaVillageResidences_destination__["a" /* default */]);};var fetchSanctuaryClubApi=function fetchSanctuaryClubApi(){return Promise.resolve(__WEBPACK_IMPORTED_MODULE_6__data_PhuketLagunaVillageResidences_sanctuaryClub__["a" /* default */]);};

/***/ }),
/* 894 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_find__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__utils__ = __webpack_require__(2);
var baseAssetUrl=Object(__WEBPACK_IMPORTED_MODULE_2__utils__["a" /* assetsPath */])("phuket-laguna-village-residences");var baseAssetVideoUrl=baseAssetUrl+"/videos";var heroShotImg1=baseAssetUrl+"/images/gallery/hero-shot/1.jpg";var heroShotImg2=baseAssetUrl+"/images/gallery/hero-shot/2.jpg";var heroShotImg3=baseAssetUrl+"/images/gallery/hero-shot/3.jpg";var heroShotImg4=baseAssetUrl+"/images/gallery/hero-shot/4.jpg";var residencesAerialImg1=baseAssetUrl+"/images/gallery/images/destination-lifestyle/1.jpg";var residencesAerialImg2=baseAssetUrl+"/images/gallery/images/destination-lifestyle/2.jpg";var residencesAerialImg3=baseAssetUrl+"/images/gallery/images/destination-lifestyle/3.jpg";var residencesAerialImg4=baseAssetUrl+"/images/gallery/images/destination-lifestyle/4.jpg";var residencesAerialImg5=baseAssetUrl+"/images/gallery/images/destination-lifestyle/5.jpg";var residencesAerialImg6=baseAssetUrl+"/images/gallery/images/destination-lifestyle/6.jpg";var residencesAerialImg7=baseAssetUrl+"/images/gallery/images/destination-lifestyle/7.jpg";var residencesAerialImg8=baseAssetUrl+"/images/gallery/images/destination-lifestyle/8.jpg";var residencesAerialImg9=baseAssetUrl+"/images/gallery/images/destination-lifestyle/9.jpg";var residencesAerialImg10=baseAssetUrl+"/images/gallery/images/destination-lifestyle/10.jpg";var residencesAerialImg11=baseAssetUrl+"/images/gallery/images/destination-lifestyle/11.jpg";var residencesAerialImg12=baseAssetUrl+"/images/gallery/images/destination-lifestyle/12.jpg";var residencesAerialImg13=baseAssetUrl+"/images/gallery/images/destination-lifestyle/13.jpg";var residencesAerialImg14=baseAssetUrl+"/images/gallery/images/destination-lifestyle/14.jpg";var residencesAerialImg15=baseAssetUrl+"/images/gallery/images/destination-lifestyle/15.jpg";var residencesAerialImg16=baseAssetUrl+"/images/gallery/images/destination-lifestyle/16.jpg";var residencesAerialImg17=baseAssetUrl+"/images/gallery/images/destination-lifestyle/17.jpg";var residencesAerialImg18=baseAssetUrl+"/images/gallery/images/destination-lifestyle/18.jpg";var residencesAerialImg19=baseAssetUrl+"/images/gallery/images/destination-lifestyle/19.jpg";var residencesAerialImg20=baseAssetUrl+"/images/gallery/images/destination-lifestyle/20.jpg";var residencesAerialImg21=baseAssetUrl+"/images/gallery/images/destination-lifestyle/21.jpg";var residencesAerialImg22=baseAssetUrl+"/images/gallery/images/destination-lifestyle/22.jpg";var residencesAerialImg23=baseAssetUrl+"/images/gallery/images/destination-lifestyle/23.jpg";var residencesAerialImg24=baseAssetUrl+"/images/gallery/images/destination-lifestyle/24.jpg";var residencesAerial1=baseAssetUrl+"/images/gallery/images/residences-aerial/1.jpg";var residencesAerial2=baseAssetUrl+"/images/gallery/images/residences-aerial/2.jpg";var residencesExterior1=baseAssetUrl+"/images/gallery/images/residences-exterior/1.jpg";var residencesExterior2=baseAssetUrl+"/images/gallery/images/residences-exterior/2.jpg";var residencesExterior3=baseAssetUrl+"/images/gallery/images/residences-exterior/3.jpg";var residencesInterior1=baseAssetUrl+"/images/gallery/images/residences\u2013interior/1.jpg";var residencesInterior2=baseAssetUrl+"/images/gallery/images/residences\u2013interior/2.jpg";var residencesInterior3=baseAssetUrl+"/images/gallery/images/residences\u2013interior/3.jpg";var residencesInterior4=baseAssetUrl+"/images/gallery/images/residences\u2013interior/4.jpg";var residencesInterior5=baseAssetUrl+"/images/gallery/images/residences\u2013interior/5.jpg";var residencesInterior6=baseAssetUrl+"/images/gallery/images/residences\u2013interior/6.jpg";var residencesLifestyle1=baseAssetUrl+"/images/gallery/images/residences\u2013lifestyle/1.jpg";var residencesLifestyle2=baseAssetUrl+"/images/gallery/images/residences\u2013lifestyle/2.jpg";var residencesLifestyle3=baseAssetUrl+"/images/gallery/images/residences\u2013lifestyle/3.jpg";var residencesLifestyle4=baseAssetUrl+"/images/gallery/images/residences\u2013lifestyle/4.jpg";var residencesLifestyle5=baseAssetUrl+"/images/gallery/images/residences\u2013lifestyle/5.jpg";var residencesLifestyle6=baseAssetUrl+"/images/gallery/images/residences\u2013lifestyle/6.jpg";var residencesLifestyle7=baseAssetUrl+"/images/gallery/images/residences\u2013lifestyle/7.jpg";var videos=[{titleKey:"propertyVideo",source:{en:baseAssetVideoUrl+"/Laguna_Village Video_Trilingual_Mar 2022.mp4",cn:baseAssetVideoUrl+"/Laguna_Village Video_Trilingual_Mar 2022.mp4",ru:baseAssetVideoUrl+"/Laguna_Village Video_Trilingual_Mar 2022.mp4"},text:{en:["PROPERTY VIDEO"],cn:["项目视频"],ru:["ВИДЕО ПРОЕКТА"]}},{titleKey:"interiorVideo",source:{en:baseAssetVideoUrl+"/LVR8_Interior_video_V4.mp4",cn:baseAssetVideoUrl+"/LVR8_Interior_video_V4.mp4",ru:baseAssetVideoUrl+"/LVR8_Interior_video_V4.mp4"},text:{en:["INTERIOR VIDEO"],cn:["室内装饰视频"],ru:["ВИДЕО ИНТЕРЬЕРА"]}}];var heroShot=[{image:heroShotImg1},{image:heroShotImg2},{image:heroShotImg3},{image:heroShotImg4}];var categories=[{id:1,name:"All Images"},{id:2,name:"Residences – Aerial"},{id:3,name:"Residences – Exterior"},{id:4,name:"Residences – Interior"},{id:5,name:"Residences – Lifestyle"},{id:6,name:"Destination Lifestyle"}];var images=[{categoryId:2,name:"Aerial - 1",image:residencesAerial1},{categoryId:2,name:"Aerial - 2",image:residencesAerial2},{categoryId:3,name:"Exterior - 1",image:residencesExterior1},{categoryId:3,name:"Exterior - 2",image:residencesExterior2},{categoryId:3,name:"Exterior - 3",image:residencesExterior3},{categoryId:4,name:"Master Bedroom",image:residencesInterior1},{categoryId:4,name:"Master Bathroom",image:residencesInterior2},{categoryId:4,name:"Living Room - 1",image:residencesInterior3},{categoryId:4,name:"Living Room - 2",image:residencesInterior4},{categoryId:4,name:"Dining Room",image:residencesInterior5},{categoryId:4,name:"Multipurpose Room",image:residencesInterior6},{categoryId:5,name:"",image:residencesLifestyle1},{categoryId:5,name:"",image:residencesLifestyle2},{categoryId:5,name:"",image:residencesLifestyle3},{categoryId:5,name:"",image:residencesLifestyle4},{categoryId:5,name:"",image:residencesLifestyle5},{categoryId:5,name:"",image:residencesLifestyle6},{categoryId:5,name:"",image:residencesLifestyle7},{categoryId:6,name:"",image:residencesAerialImg1},{categoryId:6,name:"",image:residencesAerialImg2},{categoryId:6,name:"",image:residencesAerialImg3},{categoryId:6,name:"",image:residencesAerialImg4},{categoryId:6,name:"",image:residencesAerialImg5},{categoryId:6,name:"",image:residencesAerialImg6},{categoryId:6,name:"",image:residencesAerialImg7},{categoryId:6,name:"",image:residencesAerialImg8},{categoryId:6,name:"",image:residencesAerialImg9},{categoryId:6,name:"",image:residencesAerialImg10},{categoryId:6,name:"",image:residencesAerialImg11},{categoryId:6,name:"",image:residencesAerialImg12},{categoryId:6,name:"",image:residencesAerialImg13},{categoryId:6,name:"",image:residencesAerialImg14},{categoryId:6,name:"",image:residencesAerialImg15},{categoryId:6,name:"",image:residencesAerialImg16},{categoryId:6,name:"",image:residencesAerialImg17},{categoryId:6,name:"",image:residencesAerialImg18},{categoryId:6,name:"",image:residencesAerialImg19},{categoryId:6,name:"",image:residencesAerialImg20},{categoryId:6,name:"",image:residencesAerialImg21},{categoryId:6,name:"",image:residencesAerialImg22},{categoryId:6,name:"",image:residencesAerialImg23},{categoryId:6,name:"",image:residencesAerialImg24}];var video="https://d3vqeivyse4uh3.cloudfront.net/www/lagunaproperty/vdo/laguna_village_video_trilingual_comp.mp4";var image360="https://d3vqeivyse4uh3.cloudfront.net/www/lagunaproperty/location/phuket/laguna-village-residences/assets/360/17.+Virtual+Tour_Aerial/output/LVR-aerial.html";/* harmony default export */ __webpack_exports__["a"] = ({heroShot:heroShot,categories:categories,images:__WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(images,function(image){return Object.assign({},image,{category:__WEBPACK_IMPORTED_MODULE_0_lodash_find___default()(categories,{id:image.categoryId})});}),video:video,videos:videos,image360:image360});

/***/ }),
/* 895 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(2);
var img1=Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-village-residences')+'/images/concept/1.jpg';var img2=Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-village-residences')+'/images/concept/2.jpg';var img3=Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-village-residences')+'/images/concept/3.jpg';var img4=Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-village-residences')+'/images/concept/4.jpg';var img5=Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-village-residences')+'/images/concept/5.jpg';var img6=Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-village-residences')+'/images/concept/6.jpg';var imageSlider=[{image:img1},{image:img2,backgroundPosition:'40% center'},{image:img3,backgroundPosition:'left center'},{image:img4},{image:img5,backgroundPosition:'60% center'},{image:img6,backgroundPosition:'10% center'}];var content={en:"<p>Perfectly positioned around one of the tranquil lagoons which pepper this lush parkland adorning Phuket’s west coast, the 16 new private pool residences in the well-established Laguna Village Residences development are perfectly located and for sale within the heart of the upscale residential community set amidst palm tree-lined lagoons and landscaped gardens. </p><p>With an enviable address in a multi-award-winning destination resort, these 4-bedroom luxury villas in Laguna Village Residences offer residents a rare chance to be surrounded by five-star resorts and a myriad of leisure facilities all easily accessible via the Laguna inter-resort shuttle service.</p>",cn:"<p> 在普吉岛西海岸郁郁葱葱的静谧潟湖旁，成熟的Laguna Village Residences房地产开发项目新推出的十六套泳池住宅坐落在高档住宅小区的核心位置，棕榈树随处可见，景色宜人。 <br /> <br /> Laguna Village Residences 新推出的泳池住宅位于屡获殊荣的度假胜地的绝佳位置，周围是五星级度假村和一系列休闲设施，通过乐古浪往返于度假村之间的穿梭巴士可以轻松抵达。 </p>",ru:"<p> Идеально расположенные в одной из тихих лагун на обрамленном роскошной зеленью западном побережье Пхукета, 16 новых резиденций с бассейнами являются частью проекта застройки Laguna Village Residences. Отличное местоположение на территории жилого комплекса премиум-класса, раскинувшегося среди озер и тропических садов. <br /> <br /> Находящиеся в самом престижном районе острова, на территории удостоенного множества наград комплекса, резиденции Laguna Village Residences представляют собой редкий шанс жить в окружении пятизвездочных отелей, в доступности к морю и к самой стильной инфраструктуре острова, благодаря внутренней транспортной системе. </p>"};/* harmony default export */ __webpack_exports__["a"] = ({imageSlider:imageSlider,content:content});

/***/ }),
/* 896 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(2);
var maps=Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-village-residences')+"/images/master-plan/image.jpg";/* harmony default export */ __webpack_exports__["a"] = ({maps:maps});

/***/ }),
/* 897 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(2);
var maps=Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-village-residences')+"/images/site-plan/siteplan-image.jpg";/* harmony default export */ __webpack_exports__["a"] = ({maps:maps});

/***/ }),
/* 898 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(2);
var landingPage=[{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-village-residences')+'/images/residence/landing-page/1.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-village-residences')+'/images/residence/landing-page/2.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-village-residences')+'/images/residence/landing-page/3.jpg',backgroundPosition:'15% center'}];var type=[{name:"Residences",thumbnail:[{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-village-residences')+'/images/residence/residence/thumbnail/1.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-village-residences')+'/images/residence/residence/thumbnail/2_edit.jpg'}],buttons:[{type:"description",value:0,name:"Description",title:"Residences",description:{en:"<p>The ultimate in privacy and exclusivity, these grand villas feature four luxurious bedrooms overlooking a large private swimming pool and extensive gardens. Built to the most exacting standards, the grand two-storey Laguna Village Residences each occupies a built-up area of 671 square metres and sit on lagoon-fronting plots of between 1,034 to 1,482 sqm.</p>",cn:"<p>这些独栋别墅提供了私密空间与尊贵享受，包括四间豪华卧室，可以俯瞰一个大型私人游泳池和繁茂花园。<br><br>Laguna Village Residences 的两层住宅遵守最严格的标准，每套住宅建成面积671平方米，占地面积1034至1482平方米，可以远眺潟湖。</p>",ru:"<p>Эти виллы с четырьмя роскошными спальнями, окна которых выходят на большой собственный бассейн и великолепный сад, гарантируют полную приватность и эксклюзивность.<br><br>Двухэтажные здания Laguna Village Residences построены в соответствии со строжайшими стандартами. Каждое из них занимает площадь 671 кв. м, площадь расположенных в лагуне прилегающих участков составляет 1034-1482 кв. м.</p>"},images:[{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-village-residences')+'/images/residence/residence/description/1.jpg',backgroundPosition:'0% center'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-village-residences')+'/images/residence/residence/description/2.jpg',backgroundPosition:'center bottom'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-village-residences')+'/images/residence/residence/description/3.jpg',backgroundPosition:'center bottom'}]},{type:"plan",name:"Lower Floor",value:1,floorPlan:{en:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-village-residences')+'/images/residence/residence/floor-plan/lower-floor/floor-plan/image.jpg',ru:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-village-residences')+'/images/residence/residence/floor-plan/lower-floor/floor-plan/image.jpg',cn:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-village-residences')+'/images/residence/residence/floor-plan/lower-floor/floor-plan/image.jpg'},images:[{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-village-residences')+'/images/residence/residence/floor-plan/lower-floor/images/1.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-village-residences')+'/images/residence/residence/floor-plan/lower-floor/images/2.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-village-residences')+'/images/residence/residence/floor-plan/lower-floor/images/3.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-village-residences')+'/images/residence/residence/floor-plan/lower-floor/images/4.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-village-residences')+'/images/residence/residence/floor-plan/lower-floor/images/5.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-village-residences')+'/images/residence/residence/floor-plan/lower-floor/images/6.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-village-residences')+'/images/residence/residence/floor-plan/lower-floor/images/7.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-village-residences')+'/images/residence/residence/floor-plan/lower-floor/images/8.jpg'}],image360:[{x:950,y:500,path:'/assets/images/residence/residence/floor-plan/lower-floor/images/8.jpg'}],imageVirtual:[]},{type:"plan",name:"Upper Floor",value:2,floorPlan:{en:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-village-residences')+'/images/residence/residence/floor-plan/upper-floor/floor-plan/image.jpg',ru:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-village-residences')+'/images/residence/residence/floor-plan/upper-floor/floor-plan/image.jpg',cn:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-village-residences')+'/images/residence/residence/floor-plan/upper-floor/floor-plan/image.jpg'},images:[{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-village-residences')+'/images/residence/residence/floor-plan/upper-floor/images/1.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-village-residences')+'/images/residence/residence/floor-plan/upper-floor/images/2.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-village-residences')+'/images/residence/residence/floor-plan/upper-floor/images/3.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-village-residences')+'/images/residence/residence/floor-plan/upper-floor/images/4.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-village-residences')+'/images/residence/residence/floor-plan/upper-floor/images/5.jpg'}],image360:[{x:950,y:500,path:'/assets/images/residence/residence/floor-plan/lower-floor/images/8.jpg'}],imageVirtual:[]}]}];/* harmony default export */ __webpack_exports__["a"] = ({landingPage:landingPage,type:type});

/***/ }),
/* 899 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(2);
var landingPage=[{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-village-residences')+'/images/destination/landing-page/1.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-village-residences')+'/images/destination/landing-page/2-2.jpg',backgroundPosition:'right'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-village-residences')+'/images/destination/landing-page/3.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-village-residences')+'/images/destination/landing-page/4.jpg',backgroundPosition:'right'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-village-residences')+'/images/destination/landing-page/5.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-village-residences')+'/images/destination/landing-page/6.jpg'}];var map=[{value:"country",name:"Country Map",image:{en:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+'/images/destination/country-map/map-country_en.png',cn:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+'/images/destination/country-map/map-country_cn.png',ru:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+'/images/destination/country-map/map-country_ru.png'}},{value:"city",name:"City Map",images:[{name:"Airport",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-village-residences')+'/images/icon/map-icon-01.png',image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-village-residences')+'/images/destination/city-map/airport.png'},{name:"Beaches",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-village-residences')+'/images/icon/map-icon-02.png',image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-village-residences')+'/images/destination/city-map/beach.png'},{name:"Islands",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-village-residences')+'/images/icon/map-icon-03.png',image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-village-residences')+'/images/destination/city-map/island.png'},{name:"Schools",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-village-residences')+'/images/icon/map-icon-05.png',image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-village-residences')+'/images/destination/city-map/school.png'},{name:"Tourist Attractions",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-village-residences')+'/images/icon/map-icon-06.png',image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-village-residences')+'/images/destination/city-map/tourist-attraction.png'}]},{value:"project",name:"Project Map",images:[{name:"Hotels & Resorts",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-village-residences')+'/images/icon/project-icon-01.png',svg:null},{name:"Restaurants",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-village-residences')+'/images/icon/project-icon-02.png',svg:null},{name:"Spas",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-village-residences')+'/images/icon/project-icon-03.png',svg:null},{name:"Galleries & Shopping",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-village-residences')+'/images/icon/project-icon-04.png',svg:null},{name:"Shuttle Bus",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-village-residences')+'/images/icon/project-icon-05.png',svg:null},{name:"Shuttle Boat",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-village-residences')+'/images/icon/project-icon-06.png',svg:null}]}];var content={title:"Destination",description:{en:"<p>Surrounded by the turquoise waters of the Andaman Sea and fringed by golden shores, Phuket is an island that compels travellers to visit from around the world.</p><p>Reaching Phuket is easy with direct flights from main cities around the world. The island is also linked to Thailand’s mainland by road.</p><p>Laguna Phuket itself is located in a prime west coast area of Phuket with proximity to an abundance of facilities. Local shopping malls, international schools and world-class hospitals are all close by, while Phuket’s international airport can be reached by car in just 25 minutes.</p>",cn:"<p>乐古浪普吉岛被金色海岸紧紧包围，四周萦绕着绿松石般的海水，这座岛屿吸引着世界各地的游客纷至沓来。<br><br>普吉岛的交通十分便捷，从世界主要城市搭乘直飞航班即可抵达。这里与泰国主岛相连，通过汽车或船只都可轻松到达。<br><br>乐古浪普吉岛位于普吉岛的西海岸，现代设施齐全。购物中心，国际学校，世界级医院随手可得，驱车25分钟即可到达普吉岛国际机场。<p>",ru:"<p>Остров Пхукет, окруженный лазурными водами Андаманского моря, омывающими золотистые песчаные пляжи, манит к себе путешественников со всего мира.<br><br>Добраться до острова очень просто: вылететь прямым рейсом можно из крупных городов разных стран. Из материковой части Таиланда сюда можно доехать на автомобиле по шоссейной дороге.<br><br>Курортный комплекс Laguna Phuket расположен на элитном западном побережье Пхукета. В непосредственной близости находится вся необходимая инфраструктура: торговые галереи, международные школы, больницы мирового уровня. До международного аэропорта Пхукета 25 минут езды на автомобиле.<p>"}};/* harmony default export */ __webpack_exports__["a"] = ({landingPage:landingPage,map:map,content:content});

/***/ }),
/* 900 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(2);
/* harmony default export */ __webpack_exports__["a"] = ({title:"The Santuary Club",description:{en:"Experience ultimate lifestyle within worldwide network under the Banyan Group. Membership is exclusively offered to the owners of Laguna, Banyan Tree, Angsana and Cassia properties only",cn:"体验悦榕集团全球网络内的终极生活方式。仅向乐古浪、悦榕庄、悦椿和悦梿物业的业主提供会员权益。",ru:"Наслаждайтесь роскошным стилем жизни, пользуясь глобальной сетью компании Banyan Group. Членство предлагается только владельцам собственности в рамках проектов Laguna, Banyan Tree, Angsana и Cassia."},image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])("phuket-laguna-village-residences")+"/images/the-sanctuary-club/image.jpg"});

/***/ }),
/* 901 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Gallery; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Gallery=function(_Component){_inherits(Gallery,_Component);function Gallery(){_classCallCheck(this,Gallery);return _possibleConstructorReturn(this,(Gallery.__proto__||Object.getPrototypeOf(Gallery)).apply(this,arguments));}_createClass(Gallery,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common__["e" /* Gallery */],this.props);}}]);return Gallery;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 902 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Concept; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Concept=function(_Component){_inherits(Concept,_Component);function Concept(){_classCallCheck(this,Concept);return _possibleConstructorReturn(this,(Concept.__proto__||Object.getPrototypeOf(Concept)).apply(this,arguments));}_createClass(Concept,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common__["a" /* Concept */],this.props);}}]);return Concept;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 903 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Faq; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Faq=function(_Component){_inherits(Faq,_Component);function Faq(){_classCallCheck(this,Faq);return _possibleConstructorReturn(this,(Faq.__proto__||Object.getPrototypeOf(Faq)).apply(this,arguments));}_createClass(Faq,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common__["d" /* Faq */],this.props);}}]);return Faq;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 904 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Destination; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Bubble__ = __webpack_require__(366);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Destination=function(_Component){_inherits(Destination,_Component);function Destination(){_classCallCheck(this,Destination);return _possibleConstructorReturn(this,(Destination.__proto__||Object.getPrototypeOf(Destination)).apply(this,arguments));}_createClass(Destination,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common__["b" /* Destination */],Object.assign({},this.props,{project:"laguna-village-residences",projectMapChildren:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(1065, 625)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"lvr-bubble"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_Bubble__["a" /* default */],{x:-160,width:160,height:163})))}));}}]);return Destination;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 905 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TheSanctuaryclub; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TheSanctuaryclub=function(_Component){_inherits(TheSanctuaryclub,_Component);function TheSanctuaryclub(){_classCallCheck(this,TheSanctuaryclub);return _possibleConstructorReturn(this,(TheSanctuaryclub.__proto__||Object.getPrototypeOf(TheSanctuaryclub)).apply(this,arguments));}_createClass(TheSanctuaryclub,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common__["g" /* TheSanctuaryclub */],this.props);}}]);return TheSanctuaryclub;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 906 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Siteplan; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hoc__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Siteplan=(_dec=Object(__WEBPACK_IMPORTED_MODULE_1__hoc__["a" /* multiLanguage */])(),_dec(_class=function(_Component){_inherits(Siteplan,_Component);function Siteplan(){_classCallCheck(this,Siteplan);return _possibleConstructorReturn(this,(Siteplan.__proto__||Object.getPrototypeOf(Siteplan)).apply(this,arguments));}_createClass(Siteplan,[{key:"render",value:function render(){var _props=this.props,t=_props.t,map=_props.map;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"section-siteplan villa"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{viewBox:"0 0 1630 1080"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("image",{xlinkHref:map,x:0,y:0,width:1630,height:1080})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"siteplan-name"},t("Site Plan")));}}]);return Siteplan;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class);

/***/ }),
/* 907 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Masterplan; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_includes__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_filter__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_reject__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_reject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_reject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_animejs__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_animejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_animejs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_scroll__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_ProjectMap_PhuketMasterplan__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_ProjectMap_common_logos__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_Bubble__ = __webpack_require__(366);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__hoc__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_navigation__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_detector__ = __webpack_require__(56);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import styled, { keyframes } from "styled-components";
// import LagunaVillageResidencesBubble from "../../components/svg/LagunaVillageResidencesBubble";
// Filter LVR logo
var logos=__WEBPACK_IMPORTED_MODULE_3_lodash_reject___default()(__WEBPACK_IMPORTED_MODULE_8__containers_ProjectMap_common_logos__["a" /* default */],function(logo){return logo.key==="laguna-village-residences";});// const bounce = keyframes`
//   0% {
//     transform: scale(0);
//   }
//   20% {
//     transform: scale(1);
//   }
//   40% {
//     transform: scale(0.7);
//   }
//   60% {
//     transform: scale(1);
//   }
//   100% {
//     transform: scale(1);
//   }
// `;
// const AnimatedBubble = styled.g`
//   cursor: pointer;
//   animation-name: ${bounce};
//   animation-duration: 3s;
//   animation-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);
//   animation-iteration-count: infinite;
// `;
var filterTexts=function filterTexts(texts){return __WEBPACK_IMPORTED_MODULE_2_lodash_filter___default()(texts,function(text,i){var excludeList=__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(text,"options.excludes",[]);if(__WEBPACK_IMPORTED_MODULE_0_lodash_includes___default()(excludeList,"lvr/masterplan")||__WEBPACK_IMPORTED_MODULE_0_lodash_includes___default()(excludeList,"masterplan"))return false;return true;});};var fixIETransform=function fixIETransform(id){return function(anim){var g=document.getElementById(id);if(g){var transform=getComputedStyle(g).getPropertyValue("transform");g.setAttribute("transform",transform);}};};var Masterplan=(_dec=Object(__WEBPACK_IMPORTED_MODULE_10__hoc__["a" /* multiLanguage */])(),_dec(_class=function(_Component){_inherits(Masterplan,_Component);function Masterplan(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Masterplan);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Masterplan.__proto__||Object.getPrototypeOf(Masterplan)).call.apply(_ref,[this].concat(args))),_this),_this.handleClickBubble=function(){// go to master plan
var headerHeight=Object(__WEBPACK_IMPORTED_MODULE_11__utils_navigation__["a" /* getHeaderHeight */])();__WEBPACK_IMPORTED_MODULE_6_react_scroll__["scroller"].scrollTo("siteplan",{duration:1500,smooth:true,offset:-headerHeight});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Masterplan,[{key:"componentDidMount",value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_5_animejs___default()({targets:"#lvr-bubble",scale:[{value:0,duration:0,elasticity:0},{value:1,duration:2000,elasticity:400}],loop:true,update:__WEBPACK_IMPORTED_MODULE_12__utils_detector__["a" /* isIE */]?fixIETransform("lvr-bubble"):null});}},{key:"render",value:function render(){var _props=this.props,t=_props.t,currentLanguage=_props.currentLanguage;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",{className:"section-masterplan"},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__containers_ProjectMap_PhuketMasterplan__["a" /* default */],{activeLanguage:currentLanguage,filterTexts:filterTexts},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("g",{transform:"translate(1065, 625)"},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("g",{id:"lvr-bubble",onClick:this.handleClickBubble},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_Bubble__["a" /* default */],{x:-160,width:160,height:163})))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",{className:"masterplan-name"},t("Master Plan")));}}]);return Masterplan;}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]))||_class);

/***/ }),
/* 908 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Residences; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Residences=function(_Component){_inherits(Residences,_Component);function Residences(){_classCallCheck(this,Residences);return _possibleConstructorReturn(this,(Residences.__proto__||Object.getPrototypeOf(Residences)).apply(this,arguments));}_createClass(Residences,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common__["f" /* Residences */],this.props);}}]);return Residences;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 909 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Ebrochure; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Ebrochure=function(_Component){_inherits(Ebrochure,_Component);function Ebrochure(){_classCallCheck(this,Ebrochure);return _possibleConstructorReturn(this,(Ebrochure.__proto__||Object.getPrototypeOf(Ebrochure)).apply(this,arguments));}_createClass(Ebrochure,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common__["c" /* Ebrochure */],this.props);}}]);return Ebrochure;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 910 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "category", function() { return category; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faqs", function() { return faqs; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var category=[{id:1,name:"Legal",displayOn:["en","cn","ru"]},{id:2,name:"Construction",displayOn:["en","cn","ru"]},{id:3,name:"Rental Program",displayOn:["en","cn","ru"]},{id:4,name:"Property Management",displayOn:["en","cn","ru"]},{id:5,name:"Privileges",displayOn:["en","cn","ru"]},{id:6,name:"Infrastructure & Common Areas",displayOn:["en","cn","ru"]},{id:7,name:"Financing",displayOn:["en","cn","ru"]}];var faqs=[{categoryId:1,question:"What types of ownership are available?",displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"The various types of ownership available depend upon the type of property purchased and are set out in more detail below:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null," Cassia Phuket"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"This is a development consisting of leasehold apartments offering a maximum period of 30 years as permitted by law and are renewable.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null," Laguna Village Villas"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"This is a development consisting of condominiums under the Condominium Act. Condominiums can be acquired on both a leasehold and freehold basis. However, the number of freeholds held by foreigners in a condominium is limited to 49% of the total area of the units, excluding the area of the registered common property.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null," The Lofts at Laguna Village"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"This is a development consisting of leasehold apartments offering the same lease as described above for Cassia Phuket.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Laguna Village Townhomes and Laguna Village Residences"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"These landed properties are available on a 30 years leasehold basis and are renewable for the land for foreigners and freehold ownership of the building. According to Thai Law, foreigners may have ownership of buildings developed upon the land leased by them, but not the land itself. Land may be available for freehold ownership for Thai buyers.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null," Banyan Tree Villas"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"As these villas are an integral part of the exclusive Banyan Tree Phuket Resort, land is offered on a 30 year leasehold (the maximum period) as permitted by law and are renewable. However, the buildings are sold as freehold.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null," Dusit Thani Pool Villas"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"As these villas are an integral part of the exclusive Dusit Thani Laguna Phuket, land is on a 30 year leasehold (the maximum period) as permitted by law and are renewable. However, the buildings are sold as freehold.")))),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u044B \u0440\u0430\u0437\u043B\u0438\u0447\u043D\u044B\u0435 \u0444\u043E\u0440\u043C\u044B \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u0432 \u0437\u0430\u0432\u0438\u0441\u0438\u043C\u043E\u0441\u0442\u0438 \u043E\u0442 \u0442\u0438\u043F\u0430 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u0438. \u041F\u043E\u043B\u043D\u044B\u0439 \u0441\u043F\u0438\u0441\u043E\u043A \u043F\u0440\u0435\u0434\u043B\u043E\u0436\u0435\u043D\u0438\u0439 \u043F\u0440\u0438\u0432\u0435\u0434\u0435\u043D \u043D\u0438\u0436\u0435:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null," Cassia \u041F\u0445\u0443\u043A\u0435\u0442"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u042D\u0442\u043E \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0441 \u0430\u043F\u0430\u0440\u0442\u0430\u043C\u0435\u043D\u0442\u043E\u0432 \u0441 \u043F\u0440\u0430\u0432\u043E\u043C \u0432\u043B\u0430\u0434\u0435\u043D\u0438\u044F \u0430\u0440\u0435\u043D\u0434\u044B, \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u0437\u0430\u043A\u043E\u043D\u043E\u043C \u0441 \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u044B\u043C \u0441\u0440\u043E\u043A\u043E\u043C \u043D\u0430 30 \u043B\u0435\u0442 \u0441 \u043F\u043E\u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u043C \u043F\u0440\u043E\u0434\u043B\u0435\u043D\u0438\u0435\u043C \u0430\u0440\u0435\u043D\u0434\u044B.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null," \u0412\u0438\u043B\u043B\u044B Laguna Village Villas"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041E\u0431\u044A\u0435\u043A\u0442\u044B \u043F\u043E\u043F\u0430\u0434\u0430\u044E\u0442 \u043F\u043E\u0434 \u044E\u0440\u0438\u0441\u0434\u0438\u043A\u0446\u0438\u044E \u0437\u0430\u043A\u043E\u043D\u0430, \u0441\u043E\u0433\u043B\u0430\u0441\u043D\u043E \u043A\u043E\u0442\u043E\u0440\u043E\u0433\u043E \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u044C \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u043F\u0440\u0438\u043E\u0431\u0440\u0435\u0442\u0435\u043D\u0430 \u043D\u0430 \u043F\u0440\u0430\u0432\u0430\u0445 \u0430\u0440\u0435\u043D\u0434\u044B \u0438\u043B\u0438 \u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0430 \u043A\u0430\u043A \u0447\u0430\u0441\u0442\u043D\u0430\u044F \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u044C. \u041D\u043E \u043F\u0440\u043E\u0446\u0435\u043D\u0442 \u0432\u043B\u0430\u0434\u0435\u043D\u0438\u044F, \u043D\u0430\u0445\u043E\u0434\u044F\u0449\u0438\u0445\u0441\u044F \u0432 \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u0438\u043D\u043E\u0441\u0442\u0440\u0430\u043D\u0446\u0435\u0432 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0438\u0432\u0430\u0435\u0442\u0441\u044F \u0434\u043E 49% \u043E\u0442 \u043E\u0431\u0449\u0435\u0439 \u043F\u043B\u043E\u0449\u0430\u0434\u0438, \u0437\u0430 \u0438\u0441\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0435\u043C \u043F\u043B\u043E\u0449\u0430\u0434\u0438 \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0439 \u0434\u043B\u044F \u043E\u0431\u0449\u0435\u0433\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null," \u041B\u043E\u0444\u0442\u044B \u0432 Laguna Village"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041B\u043E\u0444\u0442\u044B \u0432 Laguna Village \u043F\u0440\u0435\u0434\u043B\u0430\u0433\u0430\u044E\u0442\u0441\u044F \u043D\u0430 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u0445 \u0430\u0440\u0435\u043D\u0434\u044B \u043D\u0430 \u0442\u0435\u0445 \u0436\u0435 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u0445 \u0447\u0442\u043E \u0438 \u043E\u0431 Cassia \u041F\u0445\u0443\u043A\u0435\u0442.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u0422\u0430\u0443\u043D\u0445\u0430\u0443\u0441\u044B Laguna Village Townhomes \u0438 \u0440\u0435\u0437\u0438\u0434\u0435\u043D\u0446\u0438\u0438 Laguna Village Residences"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u042D\u0442\u0430 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u044C \u043F\u0440\u0435\u0434\u043B\u0430\u0433\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u043F\u0440\u0430\u0432\u0430\u0445 \u0430\u0440\u0435\u043D\u0434\u044B \u0437\u0435\u043C\u043B\u0438 \u043D\u0430 30 \u043B\u0435\u0442 \u0434\u043B\u044F \u0438\u043D\u043E\u0441\u0442\u0440\u0430\u043D\u0446\u0435\u0432, \u0441 \u043F\u043E\u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u043C \u043F\u0440\u043E\u0434\u043B\u0435\u043D\u0438\u0435\u043C \u0430\u0440\u0435\u043D\u0434\u044B \u0438 \u043F\u043E\u043B\u043D\u043E\u0433\u043E \u043F\u0440\u0430\u0432\u0430 \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u0434\u043B\u044F \u043F\u043E\u0441\u0442\u0440\u043E\u0439\u043A\u0438. \u0421\u043E\u0433\u043B\u0430\u0441\u043D\u043E \u0442\u0430\u0439\u0441\u043A\u043E\u043C\u0443 \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0443, \u0438\u043D\u043E\u0441\u0442\u0440\u0430\u043D\u0446\u044B \u043C\u043E\u0433\u0443\u0442 \u043F\u0440\u0438\u043E\u0431\u0440\u0435\u0442\u0430\u0442\u044C \u0437\u0434\u0430\u043D\u0438\u044F, \u0441\u043F\u0440\u043E\u0435\u043A\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u044B\u0435 \u043D\u0430 \u0430\u0440\u0435\u043D\u0434\u043E\u0432\u0430\u043D\u043D\u043E\u0439 \u0437\u0435\u043C\u043B\u0435, \u043D\u043E \u043D\u0435 \u0438\u043C\u0435\u044E\u0442 \u043F\u0440\u0430\u0432 \u043F\u043E\u043B\u043D\u043E\u0433\u043E \u0432\u043B\u0430\u0434\u0435\u043D\u0438\u044F \u043D\u0430 \u0441\u0430\u043C\u0443 \u0437\u0435\u043C\u043B\u044E.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null," \u0412\u0438\u043B\u043B\u044B Banyan Tree Villas"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041F\u043E\u0441\u043A\u043E\u043B\u044C\u043A\u0443 \u044D\u0442\u0438 \u0432\u0438\u043B\u043B\u044B \u044F\u0432\u043B\u044F\u044E\u0442\u0441\u044F \u043D\u0435\u043E\u0442\u044A\u0435\u043C\u043B\u0435\u043C\u043E\u0439 \u0447\u0430\u0441\u0442\u044C\u044E \u044D\u043A\u0441\u043A\u043B\u044E\u0437\u0438\u0432\u043D\u043E\u0433\u043E \u043A\u0443\u0440\u043E\u0440\u0442\u0430 Banyan Tree Phuket Resort, \u0437\u0435\u043C\u043B\u044F \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u0442\u043E\u043B\u044C\u043A\u043E \u043D\u0430 \u043F\u0440\u0430\u0432\u0430\u0445 \u0430\u0440\u0435\u043D\u0434\u044B \u043D\u0430 30 \u043B\u0435\u0442 \u0441 \u043F\u043E\u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u043C \u043F\u0440\u043E\u0434\u043B\u0435\u043D\u0438\u0435\u043C \u0430\u0440\u0435\u043D\u0434\u044B. \u0412 \u0442\u043E \u0432\u0440\u0435\u043C\u044F \u043A\u0430\u043A \u0437\u0434\u0430\u043D\u0438\u044F \u043E\u0444\u043E\u0440\u043C\u043B\u044F\u044E\u0442\u0441\u044F \u043A\u0430\u043A \u0447\u0430\u0441\u0442\u043D\u0430\u044F \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u044C.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null," \u0412\u0438\u043B\u043B\u044B \u0441 \u0431\u0430\u0441\u0441\u0435\u0439\u043D\u043E\u043C Dusit Thani Pool Villas"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041F\u043E\u0441\u043A\u043E\u043B\u044C\u043A\u0443 \u044D\u0442\u0438 \u0432\u0438\u043B\u043B\u044B \u044F\u0432\u043B\u044F\u044E\u0442\u0441\u044F \u043D\u0435\u043E\u0442\u044A\u0435\u043C\u043B\u0435\u043C\u043E\u0439 \u0447\u0430\u0441\u0442\u044C\u044E \u044D\u043A\u0441\u043A\u043B\u044E\u0437\u0438\u0432\u043D\u043E\u0433\u043E \u043A\u0443\u0440\u043E\u0440\u0442\u0430 Dusit Thani Laguna Phuket,) \u0437\u0435\u043C\u043B\u044F \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u0442\u043E\u043B\u044C\u043A\u043E \u043D\u0430 \u043F\u0440\u0430\u0432\u0430\u0445 \u0430\u0440\u0435\u043D\u0434\u044B \u043D\u0430 30 \u043B\u0435\u0442 \u0441 \u043F\u043E\u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u043C \u043F\u0440\u043E\u0434\u043B\u0435\u043D\u0438\u0435\u043C \u0430\u0440\u0435\u043D\u0434\u044B. \u0412 \u0442\u043E \u0432\u0440\u0435\u043C\u044F \u043A\u0430\u043A \u0437\u0434\u0430\u043D\u0438\u044F \u043E\u0444\u043E\u0440\u043C\u043B\u044F\u044E\u0442\u0441\u044F \u043A\u0430\u043A \u0447\u0430\u0441\u0442\u043D\u0430\u044F \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u044C.")))),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u5728\u4E50\u53E4\u6D6A\uFF0C\u8D2D\u4E70\u4E0D\u540C\u7C7B\u578B\u7684\u623F\u4EA7\u6709\u4E0D\u540C\u7C7B\u578B\u7684\u4EA7\u6743\uFF0C\u5177\u4F53\u89C4\u5B9A\u5982\u4E0B\uFF1A"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null," \u60A6\u68BF\u666E\u5409"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u672C\u5F00\u53D1\u9879\u76EE\u4E3A\u79DF\u8D41\u4EA7\u6743\u9879\u76EE\uFF0C\u79DF\u8D41\u6743\u9700\u8981\u7ECF\u8FC7\u653F\u5E9C\u6CE8\u518C\uFF08\u6309\u76EE\u524D\u6CD5\u5F8B\u89C4\u5B9A\u79DF\u8D41\u6700\u5927\u671F\u9650\u4E3A30\u5E74\uFF09\u5E76\u53EF\u4EE5\u7EED\u79DF\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null," \u4E50\u53E4\u6D6A\u4E61\u6751\u8054\u6392\u522B\u5885"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u672C\u5F00\u53D1\u9879\u76EE\u4E3A\u5171\u7BA1\u5F0F\u516C\u5BD3\u3002\u5171\u7BA1\u5F0F\u516C\u5BD3\u7684\u6240\u6709\u6743\u53EF\u4EE5\u662F\u79DF\u8D41\u6301\u6709\uFF0C\u4E5F\u53EF\u4EE5\u662F\u6C38\u4E45\u6301\u6709\u3002\u4F46\u662F\uFF0C\u5916\u7C4D\u4EBA\u58EB\u6301\u6709\u6C38\u4E45\u4EA7\u6743\u7684\u516C\u5BD3\u5355\u4F4D\u6570\u91CF\u4E0D\u5F97\u8D85\u8FC7\u6240\u6709\u516C\u5BD3\u5355\u4F4D\u603B\u9762\u79EF\u768449%\uFF0C\u4E0D\u5305\u62EC\u5DF2\u767B\u8BB0\u7684\u516C\u5171\u7269\u4E1A\u7684\u9762\u79EF\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null," \u4E50\u53E4\u6D6A\u4E61\u6751\u9601\u697C"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u672C\u5F00\u53D1\u9879\u76EE\u4E3A\u79DF\u8D41\u4EA7\u6743\u9879\u76EE\uFF0C\u63D0\u4F9B\u4E0E\u4E0A\u8FF0\u60A6\u68BF\u666E\u5409\u76F8\u540C\u7684\u79DF\u8D41\u4F7F\u7528\u5F62\u5F0F\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u4E50\u53E4\u6D6A\u4E61\u6751\u8054\u4F53\u522B\u5885\u548C\u4E50\u53E4\u6D6A\u4E61\u6751\u72EC\u7ACB\u522B\u5885"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u5BF9\u4E8E\u5916\u7C4D\u4EBA\u58EB\uFF0C\u8FD9\u4E24\u79CD\u7C7B\u578B\u7684\u623F\u4EA7\u63D0\u4F9B\u79DF\u8D41\u4EA7\u6743\uFF08\u6309\u76EE\u524D\u6CD5\u5F8B\u89C4\u5B9A\u79DF\u8D41\u6700\u5927\u671F\u9650\u4E3A30\u5E74\uFF09\u5E76\u53EF\u4EE5\u7EED\u79DF\u3002\u4EE5\u53CA\u5728\u5176\u79DF\u8D41\u571F\u5730\u4E0A\u6240\u5F00\u53D1\u5EFA\u7B51\u7269\u7684\u6240\u6709\u6743\u3002\u6839\u636E\u6CF0\u56FD\u6CD5\u5F8B\uFF0C\u5916\u7C4D\u4E1A\u4E3B\u53EF\u80FD\u83B7\u5F97\u5728\u5176\u79DF\u8D41\u571F\u5730\u4E0A\u6240\u5F00\u53D1\u5EFA\u7B51\u7269\u7684\u6240\u6709\u6743\uFF0C\u4F46\u6CA1\u6709\u571F\u5730\u672C\u8EAB\u7684\u6240\u6709\u6743\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null," \u60A6\u6995\u5E84\u522B\u5885"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u7531\u4E8E\u8FD9\u4E9B\u522B\u5885\u662F\u72EC\u6709\u7684\u666E\u5409\u5C9B\u60A6\u6995\u5EA6\u5047\u6751\u4E0D\u53EF\u5206\u5272\u7684\u4E00\u90E8\u5206\uFF0C\u6240\u4EE5\u5F00\u53D1\u9879\u76EE\u4E3A\u79DF\u8D41\u4EA7\u6743\u9879\u76EE\uFF08\u6309\u76EE\u524D\u6CD5\u5F8B\u89C4\u5B9A\u79DF\u8D41\u6700\u5927\u671F\u9650\u4E3A30\u5E74\uFF09\u5E76\u53EF\u4EE5\u7EED\u79DF\u3002\u4EE5\u53CA\u5728\u5176\u79DF\u8D41\u571F\u5730\u4E0A\u6240\u5F00\u53D1\u5EFA\u7B51\u7269\u7684\u6240\u6709\u6743\u3002\u6839\u636E\u6CF0\u56FD\u6CD5\u5F8B\uFF0C\u5916\u7C4D\u4E1A\u4E3B\u53EF\u80FD\u83B7\u5F97\u5728\u5176\u79DF\u8D41\u571F\u5730\u4E0A\u6240\u5F00\u53D1\u5EFA\u7B51\u7269\u7684\u6240\u6709\u6743\uFF0C\u4F46\u6CA1\u6709\u571F\u5730\u672C\u8EAB\u7684\u6240\u6709\u6743\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null," \u90FD\u559C\u5929\u9619\u6CF3\u6C60\u522B\u5885"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u7531\u4E8E\u8FD9\u4E9B\u522B\u5885\u662F\u72EC\u6709\u7684\u666E\u5409\u5C9B\u4E50\u53E4\u6D6A\u90FD\u559C\u5929\u9619\u5EA6\u5047\u6751\u4E0D\u53EF\u5206\u5272\u7684\u4E00\u90E8\u5206\uFF0C\u6240\u4EE5\u5F00\u53D1\u9879\u76EE\u4E3A\u79DF\u8D41\u4EA7\u6743\u9879\u76EE\uFF08\u6309\u76EE\u524D\u6CD5\u5F8B\u89C4\u5B9A\u79DF\u8D41\u6700\u5927\u671F\u9650\u4E3A30\u5E74\uFF09\u5E76\u53EF\u4EE5\u7EED\u79DF\u3002\u4EE5\u53CA\u5728\u5176\u79DF\u8D41\u571F\u5730\u4E0A\u6240\u5F00\u53D1\u5EFA\u7B51\u7269\u7684\u6240\u6709\u6743\u3002\u6839\u636E\u6CF0\u56FD\u6CD5\u5F8B\uFF0C\u5916\u7C4D\u4E1A\u4E3B\u53EF\u80FD\u83B7\u5F97\u5728\u5176\u79DF\u8D41\u571F\u5730\u4E0A\u6240\u5F00\u53D1\u5EFA\u7B51\u7269\u7684\u6240\u6709\u6743\uFF0C\u4F46\u6CA1\u6709\u571F\u5730\u672C\u8EAB\u7684\u6240\u6709\u6743\u3002"))))}},{categoryId:1,question:"What are the costs associated with the lease / freehold registration?",displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"These are outlined below:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null," Leasehold land title"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Lease registration fees and stamp duty (currently 1.1% of the land rental or lease premium) is payable to the Land Department upon registration of the lease.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null," Freehold building title"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Freehold registration fee (2% of the appraisal price of building) is payable to the Land Department upon transfer and registration of title of the building. The appraisal price is calculated relative to the government\u2019s tax assessment value which is generally well below market value. Other applicable taxes upon transfer and registration of freehold building title are:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"white-circle"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Corporate Income Tax")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"(currently 1.0% of the selling price or appraisal price, whichever is higher)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"white-circle"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Special Business Tax")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"(currently 3.3% of the selling price or appraisal price, whichever is higher)")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"The burden between the seller and the purchaser for the above costs will be specified in the Lease and/or Sale & Purchase Agreements."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"Note: applicable tax rates are current at the date of issue of this FAQ and may be subject to changes. The unit owner shall be responsible for any income and any other taxes, duties and fees of whatever nature which may be levied by relevant authorities on the unit in connection with the rental. All unit owners are advised to seek their own tax advice in this regard.")))),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0421\u043F\u0438\u0441\u043E\u043A \u0432\u0441\u0435\u0445 \u0437\u0430\u0442\u0440\u0430\u0442 \u043F\u0440\u0438\u0432\u0435\u0434\u0435\u043D \u043D\u0438\u0436\u0435\uFF1A"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041F\u0440\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430 \u0430\u0440\u0435\u043D\u0434\u044B \u0432 \u0417\u0435\u043C\u0435\u043B\u044C\u043D\u043E\u043C \u0434\u0435\u043F\u0430\u0440\u0442\u0430\u043C\u0435\u043D\u0442\u0435 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u043E\u043F\u043B\u0430\u0442\u0438\u0442\u044C \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0435 \u0441\u0431\u043E\u0440\u044B \u0438 \u043F\u043E\u0448\u043B\u0438\u043D\u044B (\u0432 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0435 \u0432\u0440\u0435\u043C\u044F 1,1% \u043E\u0442 \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u0438 \u0430\u0440\u0435\u043D\u0434\u044B)."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null," \u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F \u043F\u0440\u0430\u0432 \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041F\u0440\u0438 \u043F\u0435\u0440\u0435\u0434\u0430\u0447\u0435 \u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u043F\u0440\u0430\u0432\u0430 \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u043D\u0430 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u044C \u0432 \u0417\u0435\u043C\u0435\u043B\u044C\u043D\u044B\u0439 \u0434\u0435\u043F\u0430\u0440\u0442\u0430\u043C\u0435\u043D\u0442 \u043E\u043F\u043B\u0430\u0447\u0438\u0432\u0430\u0435\u0442\u0441\u044F \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u0432\u0437\u043D\u043E\u0441 (2% \u043E\u0442 \u043E\u0446\u0435\u043D\u043E\u0447\u043D\u043E\u0439 \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u0438 \u043E\u0431\u044A\u0435\u043A\u0442\u0430). \u041E\u0446\u0435\u043D\u043E\u0447\u043D\u0430\u044F \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u0438 \u043E\u0431\u044B\u0447\u043D\u043E \u0431\u0435\u0440\u0435\u0442\u0441\u044F \u0441 \u0433\u043E\u0441\u0443\u0434\u0430\u0440\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0433\u043E \u0440\u0435\u0435\u0441\u0442\u0440\u0430. \u041A\u0430\u043A \u043F\u0440\u0430\u0432\u0438\u043B\u043E, \u043E\u043D\u0430 \u0437\u043D\u0430\u0447\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u043D\u0438\u0436\u0435 \u0440\u044B\u043D\u043E\u0447\u043D\u043E\u0439 \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u0438 \u043E\u0431\u044A\u0435\u043A\u0442\u0430. \u0414\u0440\u0443\u0433\u0438\u043C\u0438 \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u043C\u0438 \u043D\u0430\u043B\u043E\u0433\u0430\u043C\u0438 \u043D\u0430 \u043F\u0435\u0440\u0435\u0434\u0430\u0447\u0443 \u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044E \u043F\u0440\u0430\u0432\u0430 \u043D\u0430 \u0441\u0432\u043E\u0431\u043E\u0434\u043D\u043E\u0435 \u0432\u043B\u0430\u0434\u0435\u043D\u0438\u0435 \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u044F\u0432\u043B\u044F\u044E\u0442\u0441\u044F\uFF1A"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"white-circle"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u041D\u0430\u043B\u043E\u0433 \u043D\u0430 \u0434\u043E\u0445\u043E\u0434 \u0434\u043B\u044F \u044E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u0438\u0445 \u043B\u0438\u0446")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"(\u0432 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0435 \u0432\u0440\u0435\u043C\u044F \u0441\u0442\u0430\u0432\u043A\u0430 \u0441\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 1.0% \u043E\u0442 \u0446\u0435\u043D\u044B \u043F\u0440\u043E\u0434\u0430\u0436\u0438 \u0438\u043B\u0438 \u0440\u044B\u043D\u043E\u0447\u043D\u043E\u0439 \u0446\u0435\u043D\u044B, \u0432 \u0437\u0430\u0432\u0438\u0441\u0438\u043C\u043E\u0441\u0442\u0438 \u043E\u0442 \u0442\u043E\u0433\u043E, \u043A\u0430\u043A\u0430\u044F \u0438\u0437 \u043D\u0438\u0445 \u0432\u044B\u0448\u0435)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"white-circle"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u041A\u043E\u043C\u043C\u0435\u0440\u0447\u0435\u0441\u043A\u0438\u0439 \u043D\u0430\u043B\u043E\u0433")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"(\u0432 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0435 \u0432\u0440\u0435\u043C\u044F \u0441\u0442\u0430\u0432\u043A\u0430 \u0441\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 3.3% \u043E\u0442 \u0446\u0435\u043D\u044B \u043F\u0440\u043E\u0434\u0430\u0436\u0438 \u0438\u043B\u0438 \u0440\u044B\u043D\u043E\u0447\u043D\u043E\u0439 \u0446\u0435\u043D\u044B, \u0432 \u0437\u0430\u0432\u0438\u0441\u0438\u043C\u043E\u0441\u0442\u0438 \u043E\u0442 \u0442\u043E\u0433\u043E, \u043A\u0430\u043A\u0430\u044F \u0438\u0437 \u043D\u0438\u0445 \u0432\u044B\u0448\u0435)")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0430 \u0438 \u043F\u043E\u043A\u0443\u043F\u0430\u0442\u0435\u043B\u044F \u0432 \u043E\u0442\u043D\u043E\u0448\u0435\u043D\u0438\u0438 \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0445 \u0432\u044B\u0448\u0435 \u0440\u0430\u0441\u0445\u043E\u0434\u043E\u0432 \u043E\u043F\u0438\u0441\u044B\u0432\u0430\u044E\u0442\u0441\u044F \u0432 \u0441\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0438 \u043E\u0431 \u0430\u0440\u0435\u043D\u0434\u0435 \u0438 / \u0438\u043B\u0438 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0435 \u043A\u0443\u043F\u043B\u0435-\u043F\u0440\u043E\u0434\u0430\u0436\u0438."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"\u041F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0435: \u043E\u0431\u0440\u0430\u0442\u0438\u0442\u0435 \u0432\u043D\u0438\u043C\u0430\u043D\u0438\u0435 \u043D\u0430 \u0442\u043E, \u0447\u0442\u043E \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0435 \u0441\u0442\u0430\u0432\u043A\u0438 \u043D\u0430\u043B\u043E\u0433\u043E\u0432\u044B\u0445 \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432 \u0441\u043E\u0433\u043B\u0430\u0441\u043D\u043E \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0449\u0435\u0433\u043E \u0442\u0430\u0439\u0441\u043A\u043E\u0433\u043E \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 \u043F\u0440\u0438\u0432\u0435\u0434\u0435\u043D\u044B \u043D\u0430 \u0434\u0430\u0442\u0443 \u0432\u044B\u043F\u0443\u0441\u043A\u0430 \u0434\u0430\u043D\u043D\u043E\u0433\u043E \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430. \u041F\u043E\u0441\u043B\u0435 \u0434\u0430\u0442\u044B \u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0446\u0438\u0438 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B \u0441\u0442\u0430\u0432\u043A\u0438 \u0438 \u0443\u0441\u043B\u043E\u0432\u0438\u044F \u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u044F \u043C\u043E\u0433\u0443\u0442 \u0431\u044B\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u044B.")))),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u5177\u4F53\u6761\u6B3E\u5982\u4E0B\uFF1A"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null," \u571F\u5730\u79DF\u8D41\u4F7F\u7528\u6743"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u79DF\u8D41\u4F7F\u7528\u6743\u767B\u8BB0\u8D39\u548C\u5370\u82B1\u7A0E\uFF08\u73B0\u4E3A\u5730\u79DF\u6216\u79DF\u8D41\u4F7F\u7528\u8D39\u76841.1%\uFF09\u987B\u5728\u767B\u8BB0\u79DF\u8D41\u4F7F\u7528\u6743\u65F6\u5411\u56FD\u571F\u8D44\u6E90\u90E8\u7F34\u7EB3\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null," \u5EFA\u7B51\u6C38\u4E45\u4EA7\u6743"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u6C38\u4E45\u4EA7\u6743\u767B\u8BB0\u8D39\uFF08\u73B0\u4E3A\u7269\u4E1A\u4F30\u4EF7\u76842%\uFF09\u987B\u5728\u8F6C\u8BA9\u548C\u767B\u8BB0\u4EA7\u6743\u65F6\u5411\u56FD\u571F\u8D44\u6E90\u90E8\u7F34\u7EB3\u3002\u4F30\u4EF7\u662F\u76F8\u5BF9\u4E8E\u653F\u5E9C\u7684\u7A0E\u52A1\u8BC4\u4F30\u503C\u8BA1\u7B97\u5F97\u51FA\uFF0C\u901A\u5E38\u8FDC\u4F4E\u4E8E\u5E02\u4EF7\u3002\u8F6C\u8BA9\u548C\u767B\u8BB0\u6C38\u4E45\u4EA7\u6743\u65F6\u7684\u5176\u4ED6\u9002\u7528\u7A0E\u9879\u6709\uFF1A"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u4F01\u4E1A\u6240\u5F97\u7A0E")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"(\u73B0\u4E3A\u552E\u4EF7\u6216\u4F30\u4EF7\u76841.0%\uFF0C\u4EE5\u8F83\u9AD8\u8005\u4E3A\u51C6)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u7279\u522B\u8425\u4E1A\u7A0E")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"(\u73B0\u4E3A\u552E\u4EF7\u6216\u4F30\u4EF7\u76843.3%\uFF0C\u4EE5\u8F83\u9AD8\u8005\u4E3A\u51C6)")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u4E0A\u8FF0\u8D39\u7528\u4E2D\uFF0C\u4E70\u5356\u53CC\u65B9\u5404\u81EA\u627F\u62C5\u7684\u8D39\u7528\u5C06\u5728\u79DF\u8D41\u548C/\u6216\u4E70\u5356\u534F\u8BAE\u4E2D\u8BE6\u7EC6\u8BF4\u660E\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"\u5907\u6CE8\uFF1A \u8BF7\u6CE8\u610F\uFF0C\u6B64\u5904\u7684\u767B\u8BB0\u8D39\u4EE5\u53CA\u67D0\u4E9B\u9002\u7528\u7A0E\u7387\u9002\u7528\u4E8E\u73B0\u5728\uFF0C\u6839\u636E\u76F8\u5173\u6CF0\u56FD\u6CD5\u5F8B\u6709\u968F\u65F6\u66F4\u6539\u7684\u53EF\u80FD\u3002"))))}},{categoryId:1,question:"Is leasehold land transferable?",displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Leasehold land may be transferred subject to the terms and conditions of the agreements. Generally, an assignment fee is payable. In addition, the assignee must agree to be bound by the terms and conditions contained in the original lease agreement.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0410\u0440\u0435\u043D\u0434\u043E\u0432\u0430\u043D\u043D\u0430\u044F \u0437\u0435\u043C\u043B\u044F \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u043F\u0435\u0440\u0435\u0434\u0430\u043D\u0430 \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u044F\u043C\u0438 \u0438 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u043C\u0438 \u0441\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F. \u041A\u0430\u043A \u043F\u0440\u0430\u0432\u0438\u043B\u043E, \u043F\u0440\u0438 \u044D\u0442\u043E\u043C \u0443\u043F\u043B\u0430\u0447\u0438\u0432\u0430\u0435\u0442\u0441\u044F \u043F\u043E\u0448\u043B\u0438\u043D\u0430. \u041A\u0440\u043E\u043C\u0435 \u0442\u043E\u0433\u043E, \u043F\u0440\u0430\u0432\u043E\u043F\u0440\u0435\u0435\u043C\u043D\u0438\u043A \u0434\u043E\u043B\u0436\u0435\u043D \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u0442\u044C\u0441\u044F \u0441\u043E\u0431\u043B\u044E\u0434\u0430\u0442\u044C \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u0438 \u0443\u0441\u043B\u043E\u0432\u0438\u044F, \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u0449\u0438\u0435\u0441\u044F \u0432 \u043F\u0435\u0440\u0432\u043E\u043D\u0430\u0447\u0430\u043B\u044C\u043D\u043E\u043C \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0435 \u0430\u0440\u0435\u043D\u0434\u044B.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u79DF\u8D41\u4F7F\u7528\u7684\u571F\u5730\u53EF\u4EE5\u6839\u636E\u534F\u8BAE\u7684\u6761\u6B3E\u548C\u6761\u4EF6\u8FDB\u884C\u8F6C\u8BA9\u3002\u4E00\u822C\u60C5\u51B5\u4E0B\uFF0C\u987B\u652F\u4ED8\u4E00\u7B14\u8F6C\u8BA9\u8D39\u3002 \u6B64\u5916\uFF0C\u53D7\u8BA9\u4EBA\u5FC5\u987B\u540C\u610F\u63A5\u53D7\u539F\u79DF\u8D41\u534F\u8BAE\u4E2D\u6240\u542B\u6761\u6B3E\u548C\u6761\u4EF6\u7684\u7EA6\u675F\u3002"))}},{categoryId:1,question:"Can leasehold be upgraded to freehold title?",displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"This depends upon particular circumstances and is set out in more detail below:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null," Cassia Phuket and the Lofts at Laguna Village"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"An apartment may not be upgraded to freehold since the unit is a partial lease of the relevant building. Upgrading to a freehold basis may only be available should the law change to allow the apartment to have separate title deed for each unit or if a condominium license is later obtained.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null," Laguna Village Villas"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"This may be possible provided that the foreign ownership quota is not exceeded (currently 49% of total saleable area). Where applicable, an option fee may also be payable (generally based upon the lease premium) to upgrade the title.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Laguna Village Townhomes and Laguna Village Residences"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Upgrading from leasehold to freehold title may be available, provided that the lessee is eligible under relevant Thai laws and regulations to take transfer of and own the land (currently, foreigners are prohibited to acquire land on a freehold basis).")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null," Banyan Tree Villas"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"As these villas are an integral part of the exclusive Banyan Tree Phuket Resort, the option to purchase the land on a freehold basis is not available.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null," Dusit Thani Pool Villas "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"As these villas are an integral part of the exclusive Dusit Thani Laguna Phuket, the option to purchase the land on a freehold basis is not available.")))),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u042D\u0442\u043E \u0437\u0430\u0432\u0438\u0441\u0438\u0442 \u043E\u0442 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u044B\u0445 \u043E\u0431\u0441\u0442\u043E\u044F\u0442\u0435\u043B\u044C\u0441\u0442\u0432. \u0414\u0435\u0442\u0430\u043B\u0438 \u0438\u0437\u043B\u043E\u0436\u0435\u043D\u044B \u043D\u0438\u0436\u0435\uFF1A"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null," \u041B\u043E\u0444\u0442\u044B \u0432 Laguna Village \u0438 Cassia \u041F\u0445\u0443\u043A\u0435\u0442"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041A\u0432\u0430\u0440\u0442\u0438\u0440\u044B \u043D\u0435 \u043C\u043E\u0433\u0443\u0442 \u0431\u044B\u0442\u044C \u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u044B \u0432 \u0447\u0430\u0441\u0442\u043D\u0443\u044E \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u044C, \u0442\u0430\u043A \u043A\u0430\u043A \u043F\u0440\u0430\u0432\u0430 \u043D\u0430 \u043E\u0431\u044A\u0435\u043A\u0442 \u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u044B \u0432 \u043A\u0430\u0447\u0435\u0441\u0442\u0432\u0435 \u0447\u0430\u0441\u0442\u0438\u0447\u043D\u043E\u0439 \u0430\u0440\u0435\u043D\u0434\u044B \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0435\u043C \u0437\u0434\u0430\u043D\u0438\u0438. \u041F\u0435\u0440\u0435\u0432\u043E\u0434 \u0432 \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u044C \u0431\u0443\u0434\u0435\u0442 \u0434\u043E\u0441\u0442\u0443\u043F\u0435\u043D, \u0442\u043E\u043B\u044C\u043A\u043E \u0435\u0441\u043B\u0438 \u0438\u0437\u043C\u0435\u043D\u0438\u0442\u044C\u0441\u044F \u0437\u0430\u043A\u043E\u043D, \u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u043F\u043E\u0437\u0432\u043E\u043B\u0438\u0442 \u043E\u0444\u043E\u0440\u043C\u0438\u0442\u044C \u043E\u0442\u0434\u0435\u043B\u044C\u043D\u044B\u0439 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442 \u043F\u0440\u0430\u0432\u0430 \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u043D\u0430 \u043A\u0430\u0436\u0434\u0443\u044E \u043A\u0432\u0430\u0440\u0442\u0438\u0440\u0443, \u0438\u043B\u0438 \u0435\u0441\u043B\u0438 \u0431\u0443\u0434\u0435\u0442 \u043F\u043E\u043B\u0443\u0447\u0435\u043D \u043F\u0430\u0442\u0435\u043D\u0442 \u043D\u0430 \u043A\u0432\u0430\u0440\u0442\u0438\u0440\u0443.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null," \u0412\u0438\u043B\u043B\u044B Laguna Village Villas"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u042D\u0442\u043E \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E \u043F\u0440\u0438 \u0443\u0441\u043B\u043E\u0432\u0438\u0438, \u0447\u0442\u043E \u0438\u043D\u043E\u0441\u0442\u0440\u0430\u043D\u043D\u0430\u044F \u043A\u0432\u043E\u0442\u0430 \u043D\u0430 \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u044C \u043D\u0435 \u0431\u044B\u043B\u0430 \u043F\u0440\u0435\u0432\u044B\u0448\u0435\u043D\u0430 49%. \u041F\u0440\u0438 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0438 \u043F\u0440\u0430\u0432 \u0432\u043B\u0430\u0434\u0435\u043D\u0438\u044F \u0442\u0430\u043A\u0436\u0435 \u043C\u043E\u0433\u0443\u0442 \u0438\u0437\u043C\u0435\u043D\u0438\u0442\u044C\u0441\u044F \u0443\u0441\u043B\u043E\u0432\u0438\u044F \u043E\u043F\u043B\u0430\u0442\u044B (\u043A\u0430\u043A \u043F\u0440\u0430\u0432\u0438\u043B\u043E, \u044D\u0442\u043E \u043E\u0431\u0443\u0441\u043B\u043E\u0432\u043B\u0435\u043D\u043E \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0439 \u043D\u0430\u0446\u0435\u043D\u043A\u043E\u0439 \u043D\u0430 \u0430\u0440\u0435\u043D\u0434\u0443).")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u0422\u0430\u0443\u043D\u0445\u0430\u0443\u0441\u044B Laguna Village Town homes \u0438 \u0440\u0435\u0437\u0438\u0434\u0435\u043D\u0446\u0438\u0438 Laguna Village Residences"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041F\u0435\u0440\u0435\u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u0435 \u043F\u0440\u0430\u0432 \u0430\u0440\u0435\u043D\u0434\u044B \u043D\u0430 \u043F\u0440\u0430\u0432\u043E \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u0431\u0443\u0434\u0435\u0442 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E \u0432 \u0441\u043B\u0443\u0447\u0430\u0435 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u0437\u0430\u043A\u043E\u043D\u0430, \u0435\u0441\u043B\u0438 \u0430\u0440\u0435\u043D\u0434\u0430\u0442\u043E\u0440 \u0438\u043C\u0435\u0435\u0442 \u043F\u0440\u0430\u0432\u043E \u043D\u0430 \u043F\u0440\u0438\u043D\u044F\u0442\u0438\u0435, \u043F\u0435\u0440\u0435\u0434\u0430\u0447\u0443 \u0438 \u0432\u043B\u0430\u0434\u0435\u043D\u0438\u0435 \u0437\u0435\u043C\u043B\u0435\u0439 \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u0442\u0430\u0439\u0441\u043A\u0438\u043C \u0437\u0430\u043A\u043E\u043D\u0430\u043C (\u0432 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0435 \u0432\u0440\u0435\u043C\u044F \u0438\u043D\u043E\u0441\u0442\u0440\u0430\u043D\u0446\u0430\u043C \u0437\u0430\u043F\u0440\u0435\u0449\u0435\u043D\u043E \u043F\u0440\u0438\u043E\u0431\u0440\u0435\u0442\u0430\u0442\u044C \u0437\u0435\u043C\u043B\u044E \u0441 \u043F\u0440\u0430\u0432\u043E\u043C \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438).")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null," \u0412\u0438\u043B\u043B\u044B Banyan Tree Villas"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041F\u043E\u0441\u043A\u043E\u043B\u044C\u043A\u0443 \u044D\u0442\u0438 \u0432\u0438\u043B\u043B\u044B \u044F\u0432\u043B\u044F\u044E\u0442\u0441\u044F \u043D\u0435\u043E\u0442\u044A\u0435\u043C\u043B\u0435\u043C\u043E\u0439 \u0447\u0430\u0441\u0442\u044C\u044E \u044D\u043A\u0441\u043A\u043B\u044E\u0437\u0438\u0432\u043D\u043E\u0433\u043E \u043A\u0443\u0440\u043E\u0440\u0442\u0430 Banyan Tree Phuket Resort, \u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u0435 \u0437\u0435\u043C\u043B\u0438 \u0432 \u0447\u0430\u0441\u0442\u043D\u0443\u044E \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u044C \u043D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null," \u0412\u0438\u043B\u043B\u044B \u0441 \u0431\u0430\u0441\u0441\u0435\u0439\u043D\u043E\u043C Dusit Thani Pool Villas"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041F\u043E\u0441\u043A\u043E\u043B\u044C\u043A\u0443 \u044D\u0442\u0438 \u0432\u0438\u043B\u043B\u044B \u044F\u0432\u043B\u044F\u044E\u0442\u0441\u044F \u043D\u0435\u043E\u0442\u044A\u0435\u043C\u043B\u0435\u043C\u043E\u0439 \u0447\u0430\u0441\u0442\u044C\u044E \u044D\u043A\u0441\u043A\u043B\u044E\u0437\u0438\u0432\u043D\u043E\u0433\u043E \u043A\u0443\u0440\u043E\u0440\u0442\u0430 Dusit Thani Laguna Phuket, \u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u0435 \u0437\u0435\u043C\u043B\u0438 \u0432 \u0447\u0430\u0441\u0442\u043D\u0443\u044E \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u044C \u043D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E.")))),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u8FD9\u53D6\u51B3\u4E8E\u7279\u5B9A\u7684\u60C5\u51B5\uFF0C\u8BE6\u7EC6\u89C4\u5B9A\u5982\u4E0B\uFF1A"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null," \u4E50\u53E4\u6D6A\u6D77\u6EE8\u516C\u5BD3\u548C\u4E50\u53E4\u6D6A\u4E61\u6751\u9601\u697C\u516C\u5BD3"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u7531\u4E8E\u516C\u5BD3\u4E2D\u7684\u6BCF\u4E2A\u5355\u5143\u90FD\u662F\u6574\u680B\u516C\u5BD3\u7684\u76F8\u5173\u90E8\u5206\uFF0C\u6240\u4EE5\u516C\u5BD3\u623F\u4EA7\u662F\u4E0D\u53EF\u4EE5\u4ECE\u79DF\u8D41\u6743\u8F6C\u4E3A\u6C38\u4E45\u4EA7\u6743\u7684\u3002\u53EA\u6709\u6CD5\u5F8B\u53D8\u66F4\u5141\u8BB8\u516C\u5BD3\u5185\u5404\u5355\u4F4D\u62E5\u6709\u5355\u72EC\u7684\u5730\u5951\u6216\u65E5\u540E\u83B7\u5F97\u5171\u7BA1\u516C\u5BD3\u8BB8\u53EF\u8BC1\uFF0C\u624D\u80FD\u5B9E\u73B0\u79DF\u8D41\u4F7F\u7528\u6743\u81F3\u6C38\u4E45\u4EA7\u6743\u7684\u5347\u7EA7\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null," \u4E50\u53E4\u6D6A\u4E61\u6751\u8054\u6392\u522B\u5885"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u53EA\u8981\u672A\u8D85\u8FC7\u5916\u56FD\u4EBA\u6240\u6709\u6743\u914D\u989D\uFF0C\u8FD9\u5C31\u662F\u53EF\u80FD\u7684\uFF08\u76EE\u524D\u4E3A\u603B\u9762\u79EF\u768449%\uFF09\u3002\u5982\u9002\u7528\uFF0C\u8FD8\u53EF\u80FD\u987B\u652F\u4ED8\u4E00\u7B14\u9009\u8D2D\u8D39\uFF08\u4E00\u822C\u57FA\u4E8E\u79DF\u8D41\u8D39\uFF09\u624D\u80FD\u5347\u7EA7\u6240\u6709\u6743\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u4E50\u53E4\u6D6A\u4E61\u6751\u8054\u4F53\u522B\u5885\u548C\u4E50\u53E4\u6D6A\u4E61\u6751\u72EC\u7ACB\u522B\u5885"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u82E5\u6CF0\u56FD\u76F8\u5173\u6CD5\u5F8B\u6CD5\u89C4\u53D8\u66F4\u5141\u8BB8\u627F\u79DF\u4EBA\u62E5\u6709\u571F\u5730\uFF0C\u5219\u53EF\u5B9E\u73B0\u79DF\u8D41\u6743\u81F3\u6C38\u4E45\u4EA7\u6743\u7684\u5347\u7EA7\u3002\uFF08\u76EE\u524D\uFF0C\u6CF0\u56FD\u7981\u6B62\u5916\u56FD\u4EBA\u83B7\u5F97\u571F\u5730\u6240\u6709\u6743\uFF09\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null," \u60A6\u6995\u5E84\u522B\u5885"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u7531\u4E8E\u8FD9\u4E9B\u522B\u5885\u662F\u72EC\u6709\u7684\u666E\u5409\u5C9B\u60A6\u6995\u5E84\u5EA6\u5047\u6751\u4E0D\u53EF\u5206\u5272\u7684\u4E00\u90E8\u5206\uFF0C\u56E0\u6B64\u8FD9\u4E9B\u522B\u5885\u7684\u571F\u5730\u4E0D\u80FD\u8F6C\u4E3A\u6C38\u4E45\u4EA7\u6743\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null," \u90FD\u559C\u5929\u9619\u6CF3\u6C60\u522B\u5885"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u7531\u4E8E\u8FD9\u4E9B\u522B\u5885\u662F\u72EC\u6709\u7684\u90FD\u559C\u5929\u9619\u5EA6\u5047\u6751\u4E0D\u53EF\u5206\u5272\u7684\u4E00\u90E8\u5206\uFF0C\u56E0\u6B64\u8FD9\u4E9B\u522B\u5885\u7684\u571F\u5730\u4E0D\u80FD\u8F6C\u4E3A\u6C38\u4E45\u4EA7\u6743\u3002"))))}},{categoryId:1,question:"Is leasehold land ownership secure?",displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Our land titles in most cases are free from mortgage and any encumbrances. Leasehold land ownership is the preferred method of ownership for foreign buyers. Once the lease is registered at the Land Department, the right of use to the land will be vested with the lessee.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041D\u0430\u0448\u0438 \u043F\u0440\u0430\u0432\u0430 \u043D\u0430 \u0437\u0435\u043C\u043B\u044E \u043D\u0435 \u044F\u0432\u043B\u044F\u044E\u0442\u0441\u044F \u043F\u0440\u0435\u0434\u043C\u0435\u0442\u043E\u043C \u0437\u0430\u043B\u043E\u0433\u0430 \u0438\u043B\u0438 \u0434\u0440\u0443\u0433\u0438\u0445 \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432, \u043F\u043E\u044D\u0442\u043E\u043C\u0443 \u044F\u0432\u043B\u044F\u044E\u0442\u0441\u044F \u0430\u0431\u0441\u043E\u043B\u044E\u0442\u043D\u043E \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u044B\u043C \u0432\u0438\u0434\u043E\u043C \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u0434\u043B\u044F \u0438\u043D\u043E\u0441\u0442\u0440\u0430\u043D\u043D\u044B\u0445 \u043F\u043E\u043A\u0443\u043F\u0430\u0442\u0435\u043B\u0435\u0439. \u0410\u0440\u0435\u043D\u0434\u0430\u0442\u043E\u0440\u0443 \u043F\u0435\u0440\u0435\u0445\u043E\u0434\u044F\u0442 \u043F\u0440\u0430\u0432\u0430 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0437\u0435\u043C\u043B\u0435\u0439 \u0441\u0440\u0430\u0437\u0443 \u043F\u0440\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430 \u0432 \u0417\u0435\u043C\u0435\u043B\u044C\u043D\u043E\u043C \u0434\u0435\u043F\u0430\u0440\u0442\u0430\u043C\u0435\u043D\u0442\u0435.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u4E50\u53E4\u6D6A\u7684\u571F\u5730\u5927\u591A\u6570\u60C5\u51B5\u4E0B\u6CA1\u6709\u8FDB\u884C\u94F6\u884C\u62B5\u62BC\u548C\u4EFB\u4F55\u4EA7\u6743\u8D1F\u62C5\u3002\u540C\u65F6\u571F\u5730\u7684\u79DF\u8D41\u6743\u4EA7\u6743\u662F\u63D0\u4F9B\u7ED9\u5916\u7C4D\u4E1A\u4E3B\u7684\u6700\u4F73\u4EA7\u6743\u65B9\u5F0F\u3002\u4E00\u65E6\u79DF\u8D41\u4F7F\u7528\u6743\u5728\u56FD\u571F\u8D44\u6E90\u90E8\u767B\u8BB0\u540E\uFF0C\u571F\u5730\u7684\u4F7F\u7528\u6743\u5373\u5F52\u627F\u79DF\u4EBA\u6240\u6709\u3002"))}},{categoryId:1,question:"Should I appoint a lawyer to review the agreements?",displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Our agreements have been used for a number of years and have been reviewed by major international law firms. We have our own in-house legal team which will assist to clarify any questions you may have concerning the agreements. However, should you wish to obtain specific advice regarding the structuring of your investment, we recommend you consult with a professional legal and/or financial adviser.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041D\u0430\u0448\u0438 \u0441\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u044E\u0442\u0441\u044F \u0443\u0436\u0435 \u043C\u043D\u043E\u0433\u043E \u043B\u0435\u0442 \u0438 \u0431\u044B\u043B\u0438 \u0440\u0430\u0441\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u044B \u043C\u043D\u043E\u0433\u0438\u043C\u0438 \u043A\u0440\u0443\u043F\u043D\u044B\u043C\u0438 \u043C\u0435\u0436\u0434\u0443\u043D\u0430\u0440\u043E\u0434\u043D\u044B\u043C\u0438 \u044E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u0438\u043C\u0438 \u0444\u0438\u0440\u043C\u0430\u043C\u0438. \u0423 \u043D\u0430\u0441 \u0435\u0441\u0442\u044C \u0441\u0432\u043E\u0438 \u044E\u0440\u0438\u0441\u0442\u044B, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u043C\u043E\u0433\u0443\u0442 \u043E\u0442\u0432\u0435\u0442\u0438\u0442\u044C \u043D\u0430 \u043B\u044E\u0431\u044B\u0435 \u0432\u0430\u0448\u0438 \u0432\u043E\u043F\u0440\u043E\u0441\u044B \u043F\u043E \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430\u043C. \u041E\u0434\u043D\u0430\u043A\u043E, \u0435\u0441\u043B\u0438 \u0432\u044B \u0445\u043E\u0442\u0438\u0442\u0435 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u043A\u043E\u043D\u043A\u0440\u0435\u0442\u043D\u044B\u0435 \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0430\u0446\u0438\u0438 \u043F\u043E \u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044E \u0438\u043D\u0432\u0435\u0441\u0442\u0438\u0446\u0438\u0439, \u043C\u044B \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u043C \u043F\u0440\u043E\u043A\u043E\u043D\u0441\u0443\u043B\u044C\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0441\u044F \u0441 \u043F\u0440\u043E\u0444\u0435\u0441\u0441\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u043C \u044E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u0438\u043C \u0438 / \u0438\u043B\u0438 \u0444\u0438\u043D\u0430\u043D\u0441\u043E\u0432\u044B\u043C \u043A\u043E\u043D\u0441\u0443\u043B\u044C\u0442\u0430\u043D\u0442\u043E\u043C.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u6211\u4EEC\u7684\u534F\u8BAE\u5DF2\u7ECF\u4F7F\u7528\u591A\u5E74\uFF0C\u5E76\u4E14\u5DF2\u901A\u8FC7\u5404\u5927\u56FD\u9645\u5F8B\u5E08\u4E8B\u52A1\u6240\u7684\u5BA1\u6838\u3002\u6211\u4EEC\u62E5\u6709\u81EA\u5DF1\u7684\u5185\u90E8\u6CD5\u5F8B\u56E2\u961F\uFF0C\u53EF\u4EE5\u534F\u52A9\u89E3\u7B54\u60A8\u5BF9\u534F\u8BAE\u7684\u4EFB\u4F55\u7591\u95EE\u3002\u4F46\u662F\uFF0C\u5982\u679C\u60A8\u5E0C\u671B\u5C31\u60A8\u7684\u6295\u8D44\u83B7\u5F97\u8BE6\u7EC6\u800C\u5177\u4F53\u7684\u610F\u89C1\uFF0C\u5EFA\u8BAE\u60A8\u54A8\u8BE2\u4E13\u4E1A\u6CD5\u5F8B\u548C/\u6216\u8D22\u52A1\u987E\u95EE\u3002"))}},{categoryId:1,question:"What is the measurement of square wah?",displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Our agreements indicate the property\u2019s areas with land measurement under the Thai system set by the Land Department. The most commonly used land measurements are as follows:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"One rai equals 1,600 square meters"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"One ngan equals 400 square metres"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"One square wah equals 4 square metres"))),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041C\u044B \u043E\u0431\u044F\u0437\u0430\u043D\u044B \u0443\u043A\u0430\u0437\u044B\u0432\u0430\u0442\u044C \u043F\u043B\u043E\u0449\u0430\u0434\u044C \u0437\u0435\u043C\u0435\u043B\u044C\u043D\u044B\u0445 \u0443\u0447\u0430\u0441\u0442\u043A\u043E\u0432 \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u0442\u0430\u0439\u0441\u043A\u043E\u0439 \u0441\u0438\u0441\u0442\u0435\u043C\u043E\u0439, \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u043E\u0439 \u0417\u0435\u043C\u0435\u043B\u044C\u043D\u044B\u043C \u0434\u0435\u043F\u0430\u0440\u0442\u0430\u043C\u0435\u043D\u0442\u043E\u043C. \u041D\u0430\u0438\u0431\u043E\u043B\u0435\u0435 \u0447\u0430\u0441\u0442\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u0442\u0441\u044F \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0430\u044F \u0441\u0438\u0441\u0442\u0435\u043C\u0430 \u0438\u0437\u043C\u0435\u0440\u0435\u043D\u0438\u044F:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u041E\u0434\u0438\u043D \u0440\u0430\u0439 \u0440\u0430\u0432\u0435\u043D 1600 \u043A\u0432\u0430\u0434\u0440\u0430\u0442\u043D\u044B\u043C \u043C\u0435\u0442\u0440\u0430\u043C"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u041E\u0434\u0438\u043D \u043D\u0433\u0430\u043D \u0440\u0430\u0432\u0435\u043D 400 \u043A\u0432\u0430\u0434\u0440\u0430\u0442\u043D\u044B\u043C \u043C\u0435\u0442\u0440\u0430\u043C"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u041E\u0434\u0438\u043D \u043A\u0432\u0430\u0434\u0440\u0430\u0442\u043D\u044B\u0439 \u0432\u0430\u0430 \u0440\u0430\u0432\u0435\u043D 4 \u043A\u0432\u0430\u0434\u0440\u0430\u0442\u043D\u044B\u043C \u043C\u0435\u0442\u0440\u0430\u043C"))),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u6211\u4EEC\u7684\u534F\u8BAE\u4F9D\u7167\u56FD\u571F\u8D44\u6E90\u90E8\u5236\u5B9A\u7684\u6CF0\u5236\u571F\u5730\u5EA6\u91CF\u5355\u4F4D\u6765\u8868\u793A\u7269\u4E1A\u7684\u9762\u79EF\u3002\u6700\u5E38\u7528\u7684\u571F\u5730\u5EA6\u91CF\u5355\u4F4D\u5982\u4E0B\uFF1A"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"1\u83B1\uFF08rai\uFF09\u7B49\u4E8E1,600\u5E73\u65B9\u7C73"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"1\u5E72\uFF08ngan\uFF09\u7B49\u4E8E400\u5E73\u65B9\u7C73"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"1\u5E73\u65B9\u74E6\uFF08wah\uFF09\u7B49\u4E8E4\u5E73\u65B9\u7C73")))}},{categoryId:1,question:"When will be the lease / house transfer registration take place?",displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Approximately 90 days after full payments of the Rental and/or Purchase Price of the land and/or buildings have been made providing that title deeds have been registered and issued by the Land Department. We will notify the lessee / buyer of any required documents and fees which will be incurred upon registration.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041F\u0440\u0438\u043C\u0435\u0440\u043D\u043E \u0447\u0435\u0440\u0435\u0437 90 \u0434\u043D\u0435\u0439 \u043F\u043E\u0441\u043B\u0435 \u043F\u043E\u043B\u043D\u043E\u0439 \u043E\u043F\u043B\u0430\u0442\u044B \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u0438 \u0430\u0440\u0435\u043D\u0434\u044B \u0438 \u043E\u0431\u044A\u0435\u043A\u0442\u0430 \u043C\u044B \u0441\u043E\u043E\u0431\u0449\u0438\u043C \u0430\u0440\u0435\u043D\u0434\u0430\u0442\u043E\u0440\u0443 / \u043F\u043E\u043A\u0443\u043F\u0430\u0442\u0435\u043B\u044E \u0441\u043F\u0438\u0441\u043E\u043A \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u044B\u0445 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432 \u0438 \u0441\u0431\u043E\u0440\u043E\u0432, \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u044B\u0445 \u0434\u043B\u044F \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438. \u0412 \u0441\u043B\u0443\u0447\u0430\u0435 \u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u044F \u043E\u0431\u044A\u0435\u043A\u0442\u0430, \u044F\u0432\u043B\u044F\u044E\u0449\u0435\u0433\u043E \u0447\u0430\u0441\u0442\u044C\u044E \u043A\u043E\u043D\u0434\u043E\u043C\u0438\u043D\u0438\u0443\u043C\u0430, \u0438\u043C\u0443\u0449\u0435\u0441\u0442\u0432\u043E \u0431\u0443\u0434\u0435\u0442 \u043F\u0435\u0440\u0435\u0434\u0430\u043D\u043E \u0442\u043E\u043B\u044C\u043A\u043E \u043F\u0440\u0438 \u0443\u0441\u043B\u043E\u0432\u0438\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u043F\u0440\u0430\u0432 \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u0432 \u0417\u0435\u043C\u0435\u043B\u044C\u043D\u043E\u043C \u0434\u0435\u043F\u0430\u0440\u0442\u0430\u043C\u0435\u043D\u0442\u0435.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u5728\u56FD\u571F\u8D44\u6E90\u90E8\u767B\u8BB0\u5E76\u9881\u53D1\u5951\u636E\u7684\u571F\u5730\u548C/\u6216\u5EFA\u7B51\u7269\u7684\u79DF\u91D1\u548C/\u6216\u8D2D\u4E70\u4EF7\u5168\u90E8\u7ED3\u6E05\u540E\u7EA690\u5929\uFF0C\u6211\u4EEC\u4F1A\u544A\u77E5\u627F\u79DF\u4EBA/\u8D2D\u4E70\u8005\u767B\u8BB0\u65F6\u6240\u9700\u7684\u6240\u6709\u6587\u4EF6\u6863\u6848\u548C\u8D39\u7528\u3002"))}},{categoryId:1,question:"What types of Long Term Visas are available for Foreigners?",displayOn:["en"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"There are various forms of Long Term Visas available to Foreigners wishing to stay longer. Please consult with an immigration specialist or Thai Embassy/Consulate for more information."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",{className:"dashed"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null," 90 day Tourist Visa")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null," Education Visa \u2013")," for families with children wishing to enroll in school within Thailand"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null," Business Visa\u2013 Non-B Visa \u2013 "),"for those employed or doing business in Thailand"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null," Retirement Visa "),"for people aged 50 years or over and meet financial requirements"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null," Marriage Visa "),"for foreigners married to Thai citizen"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null," Thailand Elite Visa - * "),"purchased thru a private company"))),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null)}},{categoryId:2,question:"How long does construction take?",displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"All construction works are subject to receiving the appropriate Government approvals. Generally, it will take approximately 12-18 months to complete the building and landscaping from the date of commencement of construction for townhomes and residences and 18 \u2013 24 months for larger apartment buildings and hotel villa developments.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0412\u0441\u0435 \u044D\u0442\u0430\u043F\u044B \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0445 \u0440\u0430\u0431\u043E\u0442 \u0441\u043E\u0433\u043B\u0430\u0441\u043E\u0432\u044B\u0432\u0430\u044E\u0442\u0441\u044F \u0441 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u043C\u0438 \u0433\u043E\u0441\u0443\u0434\u0430\u0440\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u043C\u0438 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u044F\u043C\u0438. \u041A\u0430\u043A \u043F\u0440\u0430\u0432\u0438\u043B\u043E, \u0434\u043B\u044F \u0442\u0430\u0443\u043D\u0445\u0430\u0443\u0441\u043E\u0432 \u0438 \u0436\u0438\u043B\u044B\u0445 \u0434\u043E\u043C\u043E\u0432 \u044D\u0442\u043E \u0437\u0430\u0439\u043C\u0435\u0442 \u043E\u043A\u043E\u043B\u043E 12-18 \u043C\u0435\u0441\u044F\u0446\u0435\u0432, \u0447\u0442\u043E\u0431\u044B \u0437\u0430\u0432\u0435\u0440\u0448\u0438\u0442\u044C \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E \u0438 \u043E\u0437\u0435\u043B\u0435\u043D\u0435\u043D\u0438\u0435 \u0441 \u0434\u0430\u0442\u044B \u043D\u0430\u0447\u0430\u043B\u0430 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430; \u0438 18 - 24 \u043C\u0435\u0441\u044F\u0446\u0435\u0432 \u0434\u043B\u044F \u043C\u043D\u043E\u0433\u043E\u044D\u0442\u0430\u0436\u043D\u043E\u0433\u043E \u0437\u0434\u0430\u043D\u0438\u044F \u0438 \u043E\u0442\u0435\u043B\u044C\u043D\u043E\u0433\u043E \u043F\u0440\u043E\u0435\u043A\u0442\u0430.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u6240\u6709\u5EFA\u7B51\u5DE5\u7A0B\u5FC5\u987B\u5F97\u5230\u9002\u5F53\u7684\u653F\u5E9C\u6279\u51C6\u540E\u65B9\u53EF\u8FDB\u884C\u3002\u4E00\u822C\u800C\u8A00\uFF0C\u5BF9\u4E8E\u8054\u4F53\u522B\u5885\u548C\u72EC\u7ACB\u522B\u5885, \u4ECE\u5F00\u5DE5\u7B2C\u4E00\u5929\u7B97\u8D77\uFF0C\u5927\u7EA6\u9700\u898112-18\u4E2A\u6708\u624D\u80FD\u5B8C\u6210\u5EFA\u7B51\u548C\u666F\u89C2\u7EFF\u5316\u3002\u800C\u5BF9\u4E8E\u5927\u578B\u7684\u516C\u5BD3\u697C\u4EE5\u53CA\u9152\u5E97\u522B\u5885\uFF0C\u9700\u898118-24\u4E2A\u6708\u3002"))}},{categoryId:2,question:"What is the warranty period offered?",displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Generally a one year warranty period is offered on the building and component parts or accessories from the date of completion of construction.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041E\u0431\u044B\u0447\u043D\u043E \u043F\u0440\u0435\u0434\u043B\u0430\u0433\u0430\u0435\u0442\u0441\u044F \u043E\u0434\u0438\u043D \u0433\u043E\u0434 \u0433\u0430\u0440\u0430\u043D\u0442\u0438\u0439\u043D\u043E\u0433\u043E \u0441\u0440\u043E\u043A\u0430 \u043F\u0440\u0435\u0434\u043B\u0430\u0433\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0437\u0434\u0430\u043D\u0438\u044F \u0438 \u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442\u044B \u0438\u043B\u0438 \u0430\u043A\u0441\u0435\u0441\u0441\u0443\u0430\u0440\u044B \u0441 \u0434\u0430\u0442\u044B \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u4E00\u822C\u800C\u8A00\uFF0C\u4ECE\u7AE3\u5DE5\u4E4B\u65E5\u8D77\uFF0C\u5BF9\u623F\u5C4B\u53CA\u5176\u6784\u4EF6\u6216\u914D\u4EF6\u63D0\u4F9B\u4E00\u5E74\u4FDD\u4FEE\u3002"))}},{categoryId:2,question:"Is customization of the building allowed?",displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"All of our residential properties have been professionally designed by leading architects and engineers and construction must be in accordance with building permits issued by the Government authorities. However, we will consider minor modifications which do not breach the construction permit and do not impact the building structure such as internal partitions, built-in furniture, wall and floor tiles, and do not affect the overall aesthetics of a development. Customization options are available with Laguna Village Deluxe Residences.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041F\u043B\u0430\u043D \u0432\u0441\u0435\u0445 \u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432 \u0436\u0438\u043B\u043E\u0439 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u044C \u0440\u0430\u0437\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u0435\u0442\u0441\u044F \u043F\u0440\u043E\u0444\u0435\u0441\u0441\u0438\u043E\u043D\u0430\u043B\u0430\u043C\u0438 - \u0432\u0435\u0434\u0443\u0449\u0438\u043C\u0438 \u0430\u0440\u0445\u0438\u0442\u0435\u043A\u0442\u043E\u0440\u0430\u043C\u0438 \u0438 \u0438\u043D\u0436\u0435\u043D\u0435\u0440\u0430\u043C\u0438, \u0430 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E \u0432\u0435\u0434\u0435\u0442\u0441\u044F \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u0432\u044B\u0434\u0430\u043D\u043D\u044B\u043C\u0438 \u0433\u043E\u0441\u0443\u0434\u0430\u0440\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u043C\u0438 \u043E\u0440\u0433\u0430\u043D\u0430\u043C\u0438 \u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u0438\u044F\u043C\u0438 \u043D\u0430 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E. \u0422\u0435\u043C \u043D\u0435 \u043C\u0435\u043D\u0435\u0435, \u043C\u044B \u043C\u043E\u0436\u0435\u043C \u0432\u043D\u0435\u0441\u0442\u0438 \u043D\u0435\u0437\u043D\u0430\u0447\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u043D\u0435 \u043D\u0430\u0440\u0443\u0448\u0430\u044E\u0442 \u0443\u0441\u043B\u043E\u0432\u0438\u044F \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u043D\u043E\u0433\u043E \u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u0438\u044F \u043D\u0430 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E, \u0438 \u043D\u0435 \u043F\u043E\u0432\u043B\u0438\u044F\u044E\u0442 \u043D\u0430 \u043A\u043E\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0438\u044E \u0437\u0434\u0430\u043D\u0438\u044F. \u041E\u0431\u044B\u0447\u043D\u043E \u044D\u0442\u043E \u0440\u0430\u0431\u043E\u0442\u044B, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u043D\u0435 \u0432\u043B\u0438\u044F\u044E\u0442 \u043D\u0430 \u043E\u0431\u0449\u0443\u044E \u044D\u0441\u0442\u0435\u0442\u0438\u043A\u0443 \u043F\u043E\u0441\u0442\u0440\u043E\u0439\u043A\u0438, \u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440, \u043F\u0435\u0440\u0435\u043D\u043E\u0441 \u0432\u043D\u0443\u0442\u0440\u0435\u043D\u043D\u0438\u0445 \u043F\u0435\u0440\u0435\u0433\u043E\u0440\u043E\u0434\u043E\u043A \u0438 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0435 \u0434\u0435\u0442\u0430\u043B\u0435\u0439 \u0432\u043D\u0443\u0442\u0440\u0435\u043D\u043D\u0435\u0439 \u043E\u0442\u0434\u0435\u043B\u043A\u0438 \u0438 \u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u044F - \u0432\u0441\u0442\u0440\u043E\u0435\u043D\u043D\u0430\u044F \u043C\u0435\u0431\u0435\u043B\u044C, \u0441\u0442\u0435\u043D\u044B \u0438 \u043F\u043E\u043B \u0438 \u0442\u0430\u043A \u0434\u0430\u043B\u0435\u0435. \u0412\u043E\u0437\u043C\u043E\u0436\u043D\u044B \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u044B \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u043F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u0434\u043B\u044F Laguna Village Deluxe Residences.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u6211\u4EEC\u6240\u6709\u7684\u4F4F\u5B85\u7269\u4E1A\u5747\u7531\u9876\u7EA7\u5EFA\u7B51\u5E08\u548C\u5DE5\u7A0B\u5E08\u4E13\u4E1A\u8BBE\u8BA1\uFF0C\u5E76\u4E14\u4F9D\u7167\u653F\u5E9C\u673A\u6784\u6240\u9881\u53D1\u7684\u65BD\u5DE5\u8BB8\u53EF\u8BC1\u8FDB\u884C\u5EFA\u9020\u3002\u4E0D\u8FC7\uFF0C\u6211\u4EEC\u4F1A\u8003\u8651\u60A8\u63D0\u51FA\u7684\u5FAE\u5C0F\u6539\u52A8\uFF0C\u4F46\u524D\u63D0\u662F\u8FD9\u4E9B\u6539\u52A8\u4E0D\u8FDD\u80CC\u65BD\u5DE5\u8BB8\u53EF\u8BC1\uFF0C\u4E0D\u5F71\u54CD\u5EFA\u7B51\u7ED3\u6784\uFF08\u4F8B\u5982\u5185\u90E8\u9694\u5899\uFF0C\u5185\u7F6E\u5F0F\u5BB6\u5177\uFF0C\u5899\u9762\u548C\u5730\u9762\u7684\u74F7\u7816\u7B49\uFF09\uFF0C\u5E76\u4E14\u4E0D\u5F71\u54CD\u5F00\u53D1\u9879\u76EE\u7684\u6574\u4F53\u7F8E\u89C2\u3002\u4E50\u53E4\u6D6A\u4E61\u6751\u8C6A\u534E\u72EC\u7ACB\u522B\u5885\u53EF\u4EE5\u9009\u62E9\u4E2A\u6027\u5316\u9009\u9879\u3002"))}},{categoryId:3,question:"Is there a rental program available and what are the potential returns?",displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Yes, various rental programs are available for many of our property developments. The terms and conditions of rental programs and the returns may differ depending upon the type of property. Please contact the Property Sales Centre for further details.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0414\u0430, \u0441\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u044E\u0442 \u0440\u0430\u0437\u043B\u0438\u0447\u043D\u044B\u0435 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B \u0430\u0440\u0435\u043D\u0434\u044B. \u0421\u0440\u043E\u043A\u0438 \u0438 \u0443\u0441\u043B\u043E\u0432\u0438\u044F \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B \u0430\u0440\u0435\u043D\u0434\u044B, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0441\u0443\u043C\u043C\u0430 \u043F\u043E\u043B\u0443\u0447\u0430\u0435\u043C\u043E\u0433\u043E \u0434\u043E\u0445\u043E\u0434\u0430, \u043C\u043E\u0433\u0443\u0442 \u0432\u0430\u0440\u044C\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0441\u044F \u0432 \u0437\u0430\u0432\u0438\u0441\u0438\u043C\u043E\u0441\u0442\u0438 \u043E\u0442 \u0442\u0438\u043F\u0430 \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438. \u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043E\u0431\u0440\u0430\u0442\u0438\u0442\u0435\u0441\u044C \u0432 \u041E\u0442\u0434\u0435\u043B \u041F\u0440\u043E\u0434\u0430\u0436 \u0434\u043B\u044F \u0443\u0442\u043E\u0447\u043D\u0435\u043D\u0438\u044F \u0434\u0435\u0442\u0430\u043B\u0435\u0439.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u662F\u7684\uFF0C\u5BF9\u4E8E\u6211\u4EEC\u7684\u5F88\u591A\u623F\u4EA7\uFF0C\u6211\u4EEC\u6709\u591A\u79CD\u79DF\u8D41\u8BA1\u5212\u53EF\u4F9B\u9009\u62E9\u3002\u6839\u636E\u7269\u4E1A\u7684\u7C7B\u578B\uFF0C\u79DF\u8D41\u8BA1\u5212\u7684\u6761\u6B3E\u548C\u6761\u4EF6\u4EE5\u53CA\u56DE\u62A5\u5404\u4E0D\u76F8\u540C\u3002\u8BF7\u8054\u7CFB\u7269\u4E1A\u9500\u552E\u4E2D\u5FC3\uFF0C\u8FDB\u4E00\u6B65\u4E86\u89E3\u8BE6\u60C5\u3002"))}},{categoryId:3,question:"What are the taxes levied on the rental program that an owner will be subject to?",displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"A withholding tax is generally deducted from rental distributions made which owners earn under the relevant rental scheme agreement. Foreign and Thai tax resident owners are subject to 15% and 5% withholding tax respectively. A local property tax may also be levied upon owners who rent out their properties at the rate of 1% of the rental. However, owners receiving a rental income may also be liable to lodge a tax return in Thailand in respect of rental income earned. For tax related matters pertaining to your investment, we recommend you consult with an independent legal and/or financial adviser."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"Note: Applicable tax rates are current by may be subject to change by the relevant Thai authorities"))),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041D\u0430\u043B\u043E\u0433 \u0432\u0437\u044B\u043C\u0430\u0442\u0441\u044F \u0441 \u0441\u0443\u043C\u043C\u044B, \u0432\u044B\u0440\u0443\u0447\u0435\u043D\u043D\u043E\u0439 \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0435\u043C \u0441\u043E\u0433\u043B\u0430\u0441\u043D\u043E \u0414\u043E\u0433\u043E\u0432\u043E\u0440\u0430 \u0430\u0440\u0435\u043D\u0434\u044B. \u0418\u043D\u043E\u0441\u0442\u0440\u0430\u043D\u043D\u044B\u0435 \u0433\u0440\u0430\u0436\u0434\u0430\u043D\u0435, \u043F\u043E\u043B\u0443\u0447\u0430\u044E\u0449\u0438\u0435 \u0434\u043E\u0445\u043E\u0434 \u0441 \u0430\u0440\u0435\u043D\u0434\u044B, \u043E\u043F\u043B\u0430\u0447\u0438\u0432\u0430\u044E\u0442 \u043D\u0430\u043B\u043E\u0433 \u0432 \u0440\u0430\u0437\u043C\u0435\u0440\u0435 15%. \u0421\u0442\u0430\u0432\u043A\u0430 \u043D\u0430\u043B\u043E\u0433\u043E\u043E\u0431\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u0434\u043B\u044F \u043C\u0435\u0441\u0442\u043D\u044B\u0445 \u0436\u0438\u0442\u0435\u043B\u0435\u0439 \u0441\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 5%. \u041C\u044B \u043D\u0435 \u043C\u043E\u0436\u0435\u043C \u043F\u0440\u043E\u043A\u043E\u043D\u0441\u0443\u043B\u044C\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C \u0432\u0430\u0441 \u043F\u043E \u0432\u043E\u043F\u0440\u043E\u0441\u0430\u043C \u043D\u0430\u043B\u043E\u0433\u043E\u043E\u0431\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u0432 \u043F\u043E\u043B\u043D\u043E\u043C \u043E\u0431\u044A\u0435\u043C\u0435. \u041D\u0430\u0441\u0442\u043E\u044F\u0442\u0435\u043B\u044C\u043D\u043E \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u043C \u043F\u0440\u043E\u043A\u043E\u043D\u0441\u0443\u043B\u044C\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0441\u044F \u0441 \u043D\u0435\u0437\u0430\u0432\u0438\u0441\u0438\u043C\u044B\u043C \u044E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u0438\u043C \u0438 / \u0438\u043B\u0438 \u043D\u0430\u043B\u043E\u0433\u043E\u0432\u044B\u043C \u043A\u043E\u043D\u0441\u0443\u043B\u044C\u0442\u0430\u043D\u0442\u043E\u043C."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"\u041F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0435: \u043E\u0431\u0440\u0430\u0442\u0438\u0442\u0435 \u0432\u043D\u0438\u043C\u0430\u043D\u0438\u0435 \u043D\u0430 \u0442\u043E, \u0447\u0442\u043E \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0435 \u0441\u0442\u0430\u0432\u043A\u0438 \u043D\u0430\u043B\u043E\u0433\u043E\u0432\u044B\u0445 \u043E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432 \u0441\u043E\u0433\u043B\u0430\u0441\u043D\u043E \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0449\u0435\u0433\u043E \u0442\u0430\u0439\u0441\u043A\u043E\u0433\u043E \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 \u043F\u0440\u0438\u0432\u0435\u0434\u0435\u043D\u044B \u043D\u0430 \u0434\u0430\u0442\u0443 \u0432\u044B\u043F\u0443\u0441\u043A\u0430 \u0434\u0430\u043D\u043D\u043E\u0433\u043E \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430. \u041F\u043E\u0441\u043B\u0435 \u0434\u0430\u0442\u044B \u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0446\u0438\u0438 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B \u0441\u0442\u0430\u0432\u043A\u0438 \u0438 \u0443\u0441\u043B\u043E\u0432\u0438\u044F \u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u044F \u043C\u043E\u0433\u0443\u0442 \u0431\u044B\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u044B."))),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u4E1A\u4E3B\u9700\u4F9D\u7167\u300A\u79DF\u8D41\u65B9\u6848\u534F\u8BAE\u300B\u4E3A\u6240\u8D5A\u5F97\u7684\u79DF\u91D1\u7EB3\u7A0E\u3002\u51FA\u79DF\u7269\u4E1A\u7684\u5916\u7C4D\u4E1A\u4E3B\u9884\u626315%\u7684\u79DF\u91D1\u6240\u5F97\u7A0E\uFF1B\u6CF0\u7C4D\u4E1A\u4E3B\u9884\u62635%\u7684\u79DF\u91D1\u6240\u5F97\u7A0E\u3002\u4E1A\u4E3B\u51FA\u79DF\u623F\u4EA7\u6240\u5F97\u79DF\u91D11%\u7684\u672C\u5730\u7269\u4E1A\u7A0E\u4E5F\u53EF\u80FD\u4F1A\u88AB\u6536\u53D6\u3002\u6211\u4EEC\u5F3A\u70C8\u5EFA\u8BAE\u60A8\u54A8\u8BE2\u72EC\u7ACB\u7684\u6CD5\u5F8B\u548C/\u6216\u7A0E\u52A1\u987E\u95EE\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"\u5907\u6CE8\uFF1A\u8BF7\u6CE8\u610F\uFF0C\u6B64\u5904\u7684\u67D0\u4E9B\u9002\u7528\u7A0E\u7387\u53EF\u80FD\u4F1A\u6839\u636E\u6CF0\u56FD\u6CD5\u5F8B\u6539\u53D8\u800C\u53D1\u751F\u6539\u53D8\u3002")))}},{categoryId:4,question:"What types of property management services are offered and what is the approximate cost?",displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"In addition to common area property management, optional property management services are available to individual owners. For properties in a rental program, these services (such as housekeeping, pool cleaning, gardening, routine and preventative maintenance, general repairs and pest control) will normally be provided as part of the rental program. However, these services are also available to non-rental program properties. Please contact the Property Sales Centre for further details.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0412 \u0434\u043E\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0435 \u043A \u0443\u0445\u043E\u0434\u0443 \u0437\u0430 \u043E\u0431\u0449\u0435\u0439 \u0442\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u0435\u0439 \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0430\u043C \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u0438 \u043F\u0440\u0435\u0434\u043B\u0430\u0433\u0430\u044E\u0442\u0441\u044F \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u0443\u0441\u043B\u0443\u0433\u0438. \u041E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u043D\u0438\u0435 \u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432, \u0443\u0447\u0430\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0445 \u0432 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0435 \u0430\u0440\u0435\u043D\u0434\u044B, \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u0441\u043E\u0433\u043B\u0430\u0441\u043D\u043E \u0443\u0441\u043B\u043E\u0432\u0438\u0439 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B. \u0421\u044E\u0434\u0430 \u0432\u043A\u043B\u044E\u0447\u0435\u043D\u044B \u0442\u0430\u043A\u0438\u0435 \u0443\u0441\u043B\u0443\u0433\u0438, \u043A\u0430\u043A \u0443\u0431\u043E\u0440\u043A\u0430, \u0447\u0438\u0441\u0442\u043A\u0430 \u0431\u0430\u0441\u0441\u0435\u0439\u043D\u0430, \u043E\u0437\u0435\u043B\u0435\u043D\u0435\u043D\u0438\u0435, \u0442\u0435\u043A\u0443\u0449\u0435\u0435 \u0438 \u043F\u0440\u043E\u0444\u0438\u043B\u0430\u043A\u0442\u0438\u0447\u0435\u0441\u043A\u043E\u0435 \u043E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u043D\u0438\u0435, \u043A\u0430\u043F\u0438\u0442\u0430\u043B\u044C\u043D\u044B\u0439 \u0440\u0435\u043C\u043E\u043D\u0442 \u0438 \u0431\u043E\u0440\u044C\u0431\u0430 \u0441 \u0432\u0440\u0435\u0434\u0438\u0442\u0435\u043B\u044F\u043C\u0438. \u0422\u0435\u043C \u043D\u0435 \u043C\u0435\u043D\u0435\u0435, \u0434\u0430\u043D\u043D\u044B\u0435 \u0443\u0441\u043B\u0443\u0433\u0438 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B \u0438 \u0434\u043B\u044F \u0434\u0440\u0443\u0433\u0438\u0445 \u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432. \u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043E\u0431\u0440\u0430\u0442\u0438\u0442\u0435\u0441\u044C \u0432 \u041E\u0442\u0434\u0435\u043B \u043F\u0440\u043E\u0434\u0430\u0436 \u0434\u043B\u044F \u0443\u0442\u043E\u0447\u043D\u0435\u043D\u0438\u044F \u0434\u0435\u0442\u0430\u043B\u0435\u0439.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u9664\u4E86\u516C\u5171\u533A\u57DF\u7684\u7269\u4E1A\u7BA1\u7406\u4E4B\u5916\uFF0C\u6211\u4EEC\u8FD8\u4E3A\u6BCF\u4F4D\u4E1A\u4E3B\u63D0\u4F9B\u9009\u62E9\u6027\u7684\u7269\u4E1A\u7BA1\u7406\u670D\u52A1\u3002\u5BF9\u4E8E\u52A0\u5165\u79DF\u8D41\u8BA1\u5212\u7684\u7269\u4E1A\uFF0C\u8FD9\u4E9B\u670D\u52A1\uFF08\u4F8B\u5982\u5BB6\u653F\uFF0C\u6CF3\u6C60\u6E05\u6D01\uFF0C\u56ED\u827A\uFF0C\u5B9A\u671F\u548C\u9884\u9632\u6027\u7EF4\u62A4\uFF0C\u4E00\u822C\u7EF4\u4FEE\u53CA\u75C5\u866B\u5BB3\u9632\u6CBB\uFF09\u901A\u5E38\u4F5C\u4E3A\u79DF\u8D41\u8BA1\u5212\u7684\u4E00\u90E8\u5206\u63D0\u4F9B\u3002\u4F46\u662F\uFF0C\u672A\u52A0\u5165\u79DF\u8D41\u8BA1\u5212\u7684\u7269\u4E1A\u4E5F\u53EF\u4EE5\u4EAB\u53D7\u8FD9\u4E9B\u670D\u52A1\u3002 \u8BF7\u8054\u7CFB\u7269\u4E1A\u9500\u552E\u4E2D\u5FC3\uFF0C\u8FDB\u4E00\u6B65\u4E86\u89E3\u8BE6\u60C5\u3002"))}},{categoryId:5,question:"What privileges will I receive as an owner of a Laguna Phuket property?",displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"As an owner of a property in Laguna Phuket, you may be entitled to a membership at Laguna Phuket Golf Club (depending on property project, not available for Lofts 2-Bedroom at Laguna Village and Cassia Phuket apartments)."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Owners will receive a \u2018Sanctuary Club\u2019 card which entitles holders to discounts and privileges at all Banyan Tree, Angsana and Laguna Resorts worldwide."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"30% discount on best available rates for hotel accommodation"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null," 25% discount on food and beverage"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null," 20% discount on golf green fees"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null," 20% discount on a-la-carte spa menu"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null," 15% discount on gallery merchandise"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null," 15% discount on in-house tours"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null," 15% discount on laundry"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null," 10% discount airport and ferry terminal transfers"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null," Priority wait-list on reservations"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null," Early check-in / late check-out")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Terms and conditions apply.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041A\u0430\u043A \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0443 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u0438 \u0432 Laguna Phuket, \u0432\u0430\u043C \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u0447\u043B\u0435\u043D\u0441\u0442\u0432\u043E \u0432 \u0433\u043E\u043B\u044C\u0444 \u043A\u043B\u0443\u0431 -Laguna Phuket Golf Club (\u0438\u0441\u043A\u043B\u044E\u0447\u0430\u044F \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0435\u0432 \u0434\u0432\u0443\u0445 \u0441\u043F\u0430\u043B\u044C\u043D\u044B\u0445 \u041B\u043E\u0444\u0442\u043E\u0432 \u0432 Laguna Village \u0438 \u0430\u043F\u0430\u0440\u0442\u0430\u043C\u0435\u043D\u0442\u043E\u0432 \u0432 Cassia \u041F\u0445\u0443\u043A\u0435\u0442)."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041A\u0440\u043E\u043C\u0435 \u0442\u043E\u0433\u043E, \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u044B \u043F\u043E\u043B\u0443\u0447\u0430\u044E\u0442 \u043A\u0430\u0440\u0442\u0443 \u044D\u043A\u0441\u043A\u043B\u044E\u0437\u0438\u0432\u043D\u043E\u0433\u043E \u043A\u043B\u0443\u0431\u0430 \u201CBanyan Tree Sanctuary Club\u201D \u043F\u043E \u043A\u043E\u0442\u043E\u0440\u043E\u0439 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u044E\u0442\u0441\u044F \u043F\u0440\u0438\u0432\u0438\u043B\u0435\u0433\u0438\u0438 \u0438 \u0441\u043A\u0438\u0434\u043A\u0438 \u0432 \u043E\u0442\u0435\u043B\u044F\u0445 Banyan Tree, Angsana \u0438 Laguna \u043A\u0443\u0440\u043E\u0440\u0442\u0430\u0445, \u0441\u043F\u0430 \u0438 \u0433\u0430\u043B\u0435\u0440\u0435\u0439 \u0432 \u0440\u0430\u0437\u043D\u044B\u0445 \u0441\u0442\u0440\u0430\u043D\u0430\u0445 \u043C\u0438\u0440\u0430 \u0432\u043A\u043B\u044E\u0447\u0430\u044F:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"30% \u0441\u043A\u0438\u0434\u043A\u0438 \u043E\u0442 \u043D\u0430\u0438\u0431\u043E\u043B\u0435\u0435 \u0432\u044B\u0433\u043E\u0434\u043D\u043E\u0439 \u0446\u0435\u043D\u044B \u043D\u0430 \u043F\u0440\u043E\u0436\u0438\u0432\u0430\u043D\u0438\u0435 \u0432 \u043E\u0442\u0435\u043B\u0435"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null," 25% \u0441\u043A\u0438\u0434\u043A\u0438 \u043D\u0430 \u0435\u0434\u0443 \u0438 \u043D\u0430\u043F\u0438\u0442\u043A\u0438"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null," 20% \u0441\u043A\u0438\u0434\u043A\u0438 \u043E\u0442 \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u0438 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u043F\u043E\u043B\u0435\u043C \u0434\u043B\u044F \u0438\u0433\u0440\u044B \u0432 \u0433\u043E\u043B\u044C\u0444"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null," 20% \u0441\u043A\u0438\u0434\u043A\u0438 \u043D\u0430 \u0441\u0440\u0435\u0434\u0441\u0442\u0432\u0430 \u0434\u043B\u044F \u0441\u043F\u0430-\u043F\u0440\u043E\u0446\u0435\u0434\u0443\u0440 \u043F\u043E \u0432\u044B\u0431\u043E\u0440\u0443"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null," 15% \u0441\u043A\u0438\u0434\u043A\u0438 \u043D\u0430 \u043F\u043E\u043A\u0443\u043F\u043A\u0438 \u0432 \u0442\u043E\u0440\u0433\u043E\u0432\u043E\u0439 \u0433\u0430\u043B\u0435\u0440\u0435\u0435"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null," 15% \u0441\u043A\u0438\u0434\u043A\u0438 \u043D\u0430 \u0442\u0443\u0440\u044B \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0443\u0435\u043C\u044B\u0435 \u043E\u0442\u0435\u043B\u0435\u043C"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null," 15% \u0441\u043A\u0438\u0434\u043A\u0438 \u043D\u0430 \u0443\u0441\u043B\u0443\u0433\u0438 \u043F\u0440\u0430\u0447\u0435\u0447\u043D\u043E\u0439"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"10% \u0441\u043A\u0438\u0434\u043A\u0438 \u043D\u0430 \u043F\u043E\u0435\u0437\u0434\u043A\u0438 \u0438\u0437/\u0434\u043E \u0430\u044D\u0440\u043E\u043F\u043E\u0440\u0442\u0430 \u0438 \u043F\u0440\u0438\u0447\u0430\u043B\u0430 \u043F\u0430\u0440\u043E\u043C\u043D\u043E\u0439 \u043F\u0435\u0440\u0435\u043F\u0440\u0430\u0432\u044B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u041F\u0440\u0438\u043E\u0440\u0438\u0442\u0435\u0442\u043D\u044B\u0439 \u0441\u0442\u0430\u0442\u0443\u0441 \u043F\u0440\u0438 \u043E\u0436\u0438\u0434\u0430\u043D\u0438\u0438 \u0441\u0432\u043E\u0431\u043E\u0434\u043D\u043E\u0433\u043E \u043D\u043E\u043C\u0435\u0440\u0430 \u0434\u043B\u044F \u0431\u0440\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null," \u0440\u0430\u043D\u043D\u0438\u0439 \u0437\u0430\u0435\u0437\u0434/\u043F\u043E\u0437\u0434\u043D\u0438\u0439 \u0432\u044B\u0435\u0437\u0434")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"**\u041C\u043E\u0433\u0443\u0442 \u0434\u0435\u0439\u0441\u0442\u0432\u043E\u0432\u0430\u0442\u044C \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u0438\u044F.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u4F5C\u4E3A\u666E\u5409\u5C9B\u4E50\u53E4\u6D6A\u7269\u4E1A\u7684\u4E1A\u4E3B\uFF0C\u60A8\u6709\u8D44\u683C\u6210\u4E3A\u666E\u5409\u5C9B\u4E50\u53E4\u6D6A\u9AD8\u5C14\u592B\u4FF1\u4E50\u90E8\u7684\u4F1A\u5458\u3002\uFF08\u6839\u636E\u7269\u4E1A\u9879\u76EE\uFF0C\u4E0D\u53EF\u7528\u4E8E\u4E24\u623F\u7684\u4E50\u53E4\u6D6A\u4E61\u6751\u9601\u697C\u516C\u5BD3\u548C\u666E\u5409\u60A6\u68BF\u516C\u5BD3\uFF09\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"(\u6B64\u5916\uFF0C\u4E1A\u4E3B\u5C06\u6536\u5230\u4E00\u5F20\u201C\u6995\u6E90\u4F1A\u4FF1\u4E50\u90E8\u201D\u4F1A\u5458\u5361\uFF0C\u83B7\u5F97\u5168\u7403\u6240\u6709\u60A6\u6995\u5E84,\u60A6\u693F\u53CA\u4E50\u53E4\u6D6A\u5EA6\u5047\u6751\u54C1\u724C\u7684\u7279\u6743\u548C\u6298\u6263\u548C\u7279\u6743\u3002)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u9152\u5E97\u4F4F\u5BBF\u6700\u4F18\u4EF7\u683C7\u6298"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null," \u9910\u996E7.5\u6298"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null," \u9AD8\u5C14\u592B\u679C\u5CAD\u8D398\u6298"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null," Spa\u6309\u6469\u65B9\u5F0F\u968F\u5FC3\u90098\u6298"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null," \u96F6\u552E\u827A\u54C1\u5E97\u5546\u54C18.5\u6298"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null," \u9152\u5E97\u63D0\u4F9B\u65C5\u884C8.5\u6298"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null," \u6D17\u8863\u670D\u52A18.5\u6298"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null," \u673A\u573A\u53CA\u6E21\u8239\u7801\u5934\u63A5\u90019\u6298"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null," \u4F18\u5148\u9884\u8BA2"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null," \u63D0\u65E9\u5165\u4F4F/\u5EF6\u8FDF\u9000\u623F")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"**\u9075\u5FAA\u9644\u5C5E\u6761\u6B3E\u3002"))}},{categoryId:5,question:"Who will be entitled to the Golf Club membership?",displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"For individual buyers: you; your legal spouse and your children (who are not over 21 years of age) will be entitled to the Golf Club membership. For corporate buyers, the company may nominate 2 directors who will receive the membership (depending on property project).")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0414\u043B\u044F \u0438\u043D\u0434\u0438\u0432\u0438\u0434\u0443\u0430\u043B\u044C\u043D\u044B\u0445 \u043F\u043E\u043A\u0443\u043F\u0430\u0442\u0435\u043B\u0435\u0439: \u0432\u044B, \u0432\u0430\u0448 \u0437\u0430\u043A\u043E\u043D\u043D\u044B\u0439 \u0441\u0443\u043F\u0440\u0443\u0433 \u0438 \u0432\u0430\u0448\u0438 \u0434\u0435\u0442\u0438 ( \u043D\u0435 \u0441\u0442\u0430\u0440\u0448\u0435 21 \u0433\u043E\u0434\u0430) \u0431\u0443\u0434\u0435\u0442 \u0438\u043C\u0435\u0442\u044C \u043F\u0440\u0430\u0432\u043E \u043D\u0430 \u0447\u043B\u0435\u043D\u0441\u0442\u0432\u043E Golf Club. \u0414\u043B\u044F \u043A\u043E\u0440\u043F\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u044B\u0445 \u043F\u043E\u043A\u0443\u043F\u0430\u0442\u0435\u043B\u0435\u0439, \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u044F \u043C\u043E\u0436\u0435\u0442 \u043D\u0430\u0437\u043D\u0430\u0447\u0438\u0442\u044C 2-\u0445 \u0434\u0438\u0440\u0435\u043A\u0442\u043E\u0440\u043E\u0432, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u0441\u043C\u043E\u0433\u0443\u0442 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u0447\u043B\u0435\u043D\u0441\u0442\u0432\u0430.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u6839\u636E\u6211\u4EEC\u73B0\u884C\u7684\u653F\u7B56\uFF0C\u5982\u679C\u60A8\u4EE5\u81EA\u5DF1\u7684\u540D\u4E49\u8D2D\u4E70\u7269\u4E1A\uFF1A\u60A8\uFF0C\u60A8\u7684\u5408\u6CD5\u914D\u5076\u53CA\u5B50\u5973\uFF0821\u5468\u5C81\u4EE5\u4E0B\uFF09\u5C06\u6709\u8D44\u683C\u6210\u4E3A\u9AD8\u5C14\u592B\u4FF1\u4E50\u90E8\u7684\u4F1A\u5458\u3002\u4F46\u662F\uFF0C\u53EA\u6709\u4E00\u4E2A\u4EBA\u80FD\u591F\u6CE8\u518C\u9AD8\u5C14\u592B\u4FF1\u4E50\u90E8\u7684\u4F1A\u7C4D\u3002\u5982\u679C\u623F\u4EA7\u662F\u4EE5\u516C\u53F8\u7684\u540D\u4E49\u8D2D\u4E70\u7684\uFF0C\u8BE5\u516C\u53F8\u7684\u6700\u9AD8\u6267\u884C\u8005\u987B\u6307\u5B9A\u5C06\u6210\u4E3A\u4F1A\u5458\u7684\u4EBA\u3002"))}},{categoryId:6,question:"What infrastructure facilities and services are provided?",displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Being an owner in Asia\u2019s leading resort, a collection of hotels with their restaurants, rejuvenating spas, recreation facilities (including the acclaimed Laguna Phuket Golf Course) and Canal Village shops are all within easy reach via the inter-resort shuttle bus and ferry services."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"The infrastructure facilities and services meet the same high standards of the hotels and include:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Security 24-hour security guards stationed in each development."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Roads and fences \u2013 each gated development contains a private internal road and a perimeter fence."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Electricity \u2013 power is provided by the Provincial Electricity Authority."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Water \u2013 each development is supplied with water from reservoirs within the complex and/or the Provincial Water Authority."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Landscaped area \u2013 each development normally contains open space for recreational use by owners."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Communications \u2013 each property is provided with telephone lines. Broadband and cable TV connections may be separately arranged."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Garbage collection \u2013 provided on a daily basis by Laguna Service Company."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Estate Management \u2013 a dedicated estate management office is provided to oversee the 24-hour security, garbage collection, gardening and landscaping, general cleaning and ongoing maintenance of common areas in residential developments. Our dedicated staffs are also happy to assist owners with any reasonable request."))),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041B\u044E\u0431\u043E\u0439 \u0432\u043B\u0430\u0434\u0435\u043B\u0435\u0446 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u0438, c\u043C\u043E\u0436\u0435\u0442 \u0441 \u043B\u0435\u0433\u043A\u043E\u0441\u0442\u044C\u044E \u0434\u043E\u0431\u0440\u0430\u0442\u044C\u0441\u044F \u0434\u043E \u043E\u0442\u0435\u043B\u0435\u0439, \u0440\u0435\u0441\u0442\u043E\u0440\u0430\u043D\u043E\u0432, \u0441\u0430\u043B\u043E\u043D\u043E\u0432, \u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432 \u043E\u0442\u0434\u044B\u0445\u0430 \u0438 \u0434\u043E\u0441\u0443\u0433\u0430 (\u0432 \u0442\u043E\u043C \u0447\u0438\u0441\u043B\u0435 \u0438\u0437\u0432\u0435\u0441\u0442\u043D\u043E\u0433\u043E \u0433\u043E\u043B\u044C\u0444-\u043A\u043B\u0443\u0431\u0430 Laguna Phuket Golf \u0421ourse) \u0438 \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u043E\u0432 Canal Village \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E \u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u044B\u0445 \u0430\u0432\u0442\u043E\u0431\u0443\u0441\u043E\u0432 \u0438 \u043F\u0430\u0440\u043E\u043C\u043E\u0432 \u043A\u0443\u0440\u0441\u0438\u0440\u0443\u044E\u0449\u0438\u0445 \u043F\u043E \u0432\u0441\u0435\u0439 \u0442\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u0438 \u0432\u0435\u0434\u0443\u0449\u0435\u0433\u043E \u043A\u0443\u0440\u043E\u0440\u0442\u0430 \u0410\u0437\u0438\u0438."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041F\u0440\u0435\u0434\u043B\u0430\u0433\u0430\u0435\u043C\u044B\u0435 \u0432\u044B\u0441\u043E\u043A\u043E\u043A\u0430\u0447\u0435\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u0435 \u0443\u0441\u043B\u0443\u0433\u0438 \u0438 \u0438\u043D\u0444\u0440\u0430\u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u0430:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u0411\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u044C - 24-\u0447\u0430\u0441\u043E\u0432\u0430\u044F \u043E\u0445\u0440\u0430\u043D\u0430, \u0440\u0430\u0437\u043C\u0435\u0449\u0430\u0435\u043C\u0430\u044F \u043D\u0430 \u0432\u0445\u043E\u0434\u0435 \u043A\u0430\u0436\u0434\u043E\u0433\u043E \u0443\u0447\u0430\u0441\u0442\u043A\u0430."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u0414\u043E\u0440\u043E\u0433\u0438 \u0438 \u043E\u0433\u0440\u0430\u0436\u0434\u0435\u043D\u0438\u044F - \u0432 \u043A\u0430\u0436\u0434\u043E\u043C \u0436\u0438\u043B\u043E\u043C \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0441\u0435 \u043F\u0440\u043E\u043B\u043E\u0436\u0435\u043D\u044B \u0432\u043D\u0443\u0442\u0440\u0435\u043D\u043D\u0438\u0435 \u0434\u043E\u0440\u043E\u0433\u0438, \u0430 \u043F\u043E \u043F\u0435\u0440\u0438\u043C\u0435\u0442\u0440\u0443 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u044B \u043E\u0433\u0440\u0430\u0436\u0434\u0435\u043D\u0438\u044F"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u042D\u043B\u0435\u043A\u0442\u0440\u043E\u0441\u043D\u0430\u0431\u0436\u0435\u043D\u0438\u0435 - \u044D\u043B\u0435\u043A\u0442\u0440\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u043F\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u041C\u0435\u0441\u0442\u043D\u044B\u043C \u0434\u0435\u043F\u0430\u0440\u0442\u0430\u043C\u0435\u043D\u0442\u043E\u043C \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u0441\u043D\u0430\u0431\u0436\u0435\u043D\u0438\u044F \u0422\u0430\u0438\u043B\u0430\u043D\u0434\u0430."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u0412\u043E\u0434\u043E\u043F\u0440\u043E\u0432\u043E\u0434 - \u043A\u0430\u0436\u0434\u043E\u0435 \u0437\u0434\u0430\u043D\u0438\u0435 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043E \u043A \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u043C\u0443 \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0443 \u0432\u043E\u0434\u044B, \u043A \u0440\u0435\u0437\u0435\u0440\u0432\u0443\u0430\u0440\u0443 \u0438/\u0438\u043B\u0438 \u0441\u043A\u0432\u0430\u0436\u0438\u043D\u0435."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u0417\u0435\u043B\u0435\u043D\u0430\u044F \u0437\u043E\u043D\u0430 - \u043D\u0435 \u043C\u0435\u043D\u0435\u0435 5% \u043E\u0442 \u043E\u0431\u0449\u0435\u0439 \u043F\u043B\u043E\u0449\u0430\u0434\u0438 \u0443\u0447\u0430\u0441\u0442\u043A\u0430 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u0432 \u043E\u0431\u0449\u0435\u0435 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435 \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0430\u043C"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u041A\u043E\u043C\u043C\u0443\u043D\u0438\u043A\u0430\u0446\u0438\u0438 - \u043A\u0430\u0436\u0434\u044B\u0439 \u0434\u043E\u043C \u0438\u043C\u0435\u0435\u0442 \u0434\u0432\u0435 \u0432\u043D\u0435\u0448\u043D\u0438\u0435 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u043D\u044B\u0435 \u043B\u0438\u043D\u0438\u0438. \u0418\u043D\u0442\u0435\u0440\u043D\u0435\u0442 \u0438 \u043A\u0430\u0431\u0435\u043B\u044C\u043D\u043E\u0435 \u0442\u0435\u043B\u0435\u0432\u0438\u0434\u0435\u043D\u0438\u0435 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0430\u044E\u0442\u0441\u044F \u043E\u0442\u0434\u0435\u043B\u044C\u043D\u043E."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u0412\u044B\u0432\u043E\u0437 \u043C\u0443\u0441\u043E\u0440\u0430 \u2013 \u0435\u0436\u0435\u0434\u043D\u0435\u0432\u043D\u044B\u0439 \u0432\u044B\u0432\u043E\u0437 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0435\u0439 Laguna Service Company."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u0423\u0445\u043E\u0434 \u0437\u0430 \u0442\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u0435\u0439 - \u0441\u043F\u0435\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0435 \u0411\u044E\u0440\u043E \u043F\u043E \u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044E \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u044C\u044E \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0435\u0442 \u043D\u0430\u0434\u0437\u043E\u0440 \u0437\u0430 24-\u0447\u0430\u0441\u043E\u0432\u043E\u0439 \u043E\u0445\u0440\u0430\u043D\u043E\u0439, \u0432\u044B\u0432\u043E\u0437\u043E\u043C \u043C\u0443\u0441\u043E\u0440\u0430, \u043E\u0437\u0435\u043B\u0435\u043D\u0435\u043D\u0438\u0435\u043C \u0438 \u0431\u043B\u0430\u0433\u043E\u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E\u043C, \u0433\u0435\u043D\u0435\u0440\u0430\u043B\u044C\u043D\u043E\u0439 \u0443\u0431\u043E\u0440\u043A\u043E\u0439 \u0438 \u0442\u0435\u043A\u0443\u0449\u0438\u043C\u0438 \u0437\u0430\u0434\u0430\u0447\u0430\u043C\u0438 \u043F\u043E \u0443\u0445\u043E\u0434\u0443 \u0437\u0430 \u043C\u0435\u0441\u0442\u0430\u043C\u0438 \u043E\u0431\u0449\u0435\u0433\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0432 \u0437\u0434\u0430\u043D\u0438\u0438. \u041D\u0430\u0448 \u0437\u0430\u0431\u043E\u0442\u043B\u0438\u0432\u044B\u0439 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B \u0432\u0441\u0435\u0433\u0434\u0430 \u0440\u0430\u0434 \u043F\u043E\u043C\u043E\u0447\u044C \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0430\u043C \u0443\u0434\u043E\u0432\u043B\u0435\u0442\u0432\u043E\u0440\u0438\u0442\u044C \u043B\u044E\u0431\u043E\u0439 \u0440\u0430\u0437\u0443\u043C\u043D\u044B\u0439 \u0437\u0430\u043F\u0440\u043E\u0441."))),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u4F5C\u4E3A\u4E9A\u6D32\u9876\u7EA7\u5EA6\u5047\u6751\u7684\u4E1A\u4E3B\uFF0C\u60A8\u53EF\u4EE5\u901A\u8FC7\u514D\u8D39\u7684\u5EA6\u5047\u6751\u5185\u5F80\u8FD4\u73ED\u8F66\u548C\u8F6E\u6E21\u670D\u52A1\uFF0C\u8F7B\u677E\u4FBF\u6377\u5730\u4F7F\u7528\u4E94\u5BB6\u8C6A\u534E\u9152\u5E97\u53CA\u5176\u9910\u5385\uFF0C\u56DE\u6625\u6C34\u7597\u4F1A\u6240\uFF0C\u4F11\u95F2\u8BBE\u65BD\uFF08\u5305\u62EC\u5907\u53D7\u8D5E\u8A89\u7684\u666E\u5409\u5C9B\u4E50\u53E4\u6D6A\u9AD8\u5C14\u592B\u7403\u573A\uFF09\u53CA\u5361\u5A1C\u6751\u8D2D\u7269\u4E2D\u5FC3\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u6240\u6709\u57FA\u7840\u8BBE\u65BD\u548C\u670D\u52A1\u5177\u6709\u4E0E\u9152\u5E97\u5339\u914D\u7684\u9AD8\u6807\u51C6\uFF0C\u5305\u62EC\uFF1A"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u5B89\u4FDD \u2014 \u6240\u6709\u9879\u76EE\u7684\u5165\u53E3\u5927\u95E8\u5904\u5747\u6709\u4FDD\u5B8924\u5C0F\u65F6\u7AD9\u5C97\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u9053\u8DEF\u548C\u56F4\u5899 \u2014 \u5404\u95E8\u7981\u793E\u533A\u5747\u6709\u5185\u90E8\u79C1\u5BB6\u9053\u8DEF\u548C\u56F4\u5899\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u7535\u529B \u2014 \u7531\u6CF0\u56FD\u7701\u7EA7\u7535\u529B\u5C40\u4F9B\u7535\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u4F9B\u6C34 \u2014 \u5404\u9879\u76EE\u5747\u8BBE\u6709\u6765\u81EA\u84C4\u6C34\u6C60\u548C/\u6216\u6DF1\u4E95\u7684\u72EC\u7ACB\u4F9B\u6C34\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u56ED\u666F\u533A \u2014 \u81F3\u5C11\u5212\u51FA\u9879\u76EE\u603B\u9762\u79EF\u76845%\u4F9B\u4E1A\u4E3B\u516C\u7528\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u901A\u8BAF \u2014 \u6BCF\u5957\u623F\u5C4B\u5747\u63A5\u6709\u4E24\u6761\u5916\u7EBF\u7535\u8BDD\u7EBF\u3002 \u5BBD\u5E26\u548C\u6709\u7EBF\u7535\u89C6\u8FDE\u63A5\u9700\u8981\u53E6\u884C\u5B89\u6392\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u5783\u573E\u6536\u96C6 \u2014 \u4E50\u53E4\u6D6A\u670D\u52A1\u516C\u53F8\u63D0\u4F9B\u6BCF\u65E5\u5783\u573E\u6536\u96C6\u670D\u52A1\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u7269\u4E1A\u7BA1\u7406 \u2014 \u8BBE\u6709\u4E13\u95E8\u7684\u7269\u4E1A\u7BA1\u7406\u90E8\u95E8\uFF0C\u5BF9\u9879\u76EE\u7684\u516C\u5171\u533A\u57DF\u63D0\u4F9B24\u5C0F\u65F6\u7684\u5B89\u5168\u76D1\u63A7\uFF0C\u5783\u573E\u6536\u96C6\uFF0C\u56ED\u827A\u53CA\u666F\u89C2\u7EFF\u5316\uFF0C\u57FA\u672C\u6E05\u6D01\u548C\u65E5\u5E38\u7EF4\u62A4\u670D\u52A1\u3002\u6211\u4EEC\u7684\u4E13\u804C\u4EBA\u5458\u4E50\u4E8E\u6EE1\u8DB3\u4E1A\u4E3B\u7684\u4EFB\u4F55\u5408\u7406\u8981\u6C42\u3002")))}},{categoryId:6,question:"What are the estimated common area charges?",displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Common area charges are the costs the owners pay for ongoing maintenance and upkeep of the common infrastructure and facilities, which are provided for their benefit. These are set out in more detail below:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Cassia Phuket, Lofts at Laguna Village, Laguna Townhomes and Laguna Residences"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"The common areas are managed on behalf of owners by our dedicated estate management office. The annual charges that apply differ by development depending upon the total expenses and the total number of properties within a particular development among which the expenses will be proportionately divided. Details of the estimated annual fees for a particular development can be provided upon request. In addition, a sinking fund has been established for each development. The purpose of the sinking fund is to accumulate funds for major infrastructure repairs and/or improvements which may be undertaken in the future. Rather than charge a large upfront amount, contributions will be sought on a regular basis so that the fund is built up over time.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null," Laguna Village Villas"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"The common area is managed by the Condominium Juristic Person (CJP). The annual charges are based on the total expenses incurred and are divided by the total number of properties on a proportionate basis. In addition, a sinking fund has been established. The purpose of the sinking fund is to accumulate funds for major infrastructure repairs and/or improvements which may be undertaken in the future. Rather than charge a large upfront amount, contributions will be sought on a regular basis so that the fund is built up over time.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null," Banyan Tree Villas"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Common area costs are absorbed by the Banyan Tree as part of their normal operating costs.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null," Dusit Thani Pool Villas"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Common area costs are absorbed by the Dusit Thani Laguna Phuket as part of their normal operating costs.")))),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041F\u043B\u0430\u0442\u0435\u0436\u0438 \u0437\u0430 \u043E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u043D\u0438\u0435 \u0442\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u0438 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u044E\u0442\u0441\u044F \u0434\u043B\u044F \u043F\u043B\u0430\u043D\u043E\u0432\u043E\u0433\u043E \u043E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u043D\u0438\u044F \u0438 \u043F\u043E\u0434\u0434\u0435\u0440\u0436\u0430\u043D\u0438\u044F \u043E\u0431\u0449\u0438\u0445 \u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432 \u0438 \u0438\u043D\u0444\u0440\u0430\u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u044B \u0432 \u043D\u0430\u0434\u043B\u0435\u0436\u0430\u0449\u0435\u043C \u0441\u043E\u0441\u0442\u043E\u044F\u043D\u0438\u0438. \u0414\u0435\u0442\u0430\u043B\u044C\u043D\u0430\u044F \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u043F\u0440\u0438\u0432\u0435\u0434\u0435\u043D\u0430 \u043D\u0438\u0436\u0435\uFF1A"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Cassia \u041F\u0445\u0443\u043A\u0435\u0442, \u041B\u043E\u0444\u0442\u044B \u0432 Laguna Village, \u0420\u0435\u0437\u0438\u0434\u0435\u043D\u0446\u0438\u0438 Laguna Village Residences \u0438 \u0442\u0430\u0443\u043D\u0445\u0430\u0443\u0441\u044B Laguna Village Townhomes"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0423\u0445\u043E\u0434 \u0437\u0430 \u0442\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u0435\u0439 \u043E\u0431\u0449\u0435\u0433\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u043E\u0442 \u0438\u043C\u0435\u043D\u0438 \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0435\u0432 \u043D\u0430\u0448\u0435\u0439 \u0441\u043F\u0435\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0439 \u0441\u043B\u0443\u0436\u0431\u043E\u0439. \u0421\u0443\u043C\u043C\u0430 \u0435\u0436\u0435\u0433\u043E\u0434\u043D\u044B\u0445 \u0432\u044B\u043F\u043B\u0430\u0442 \u043E\u0441\u043D\u043E\u0432\u0430\u043D\u0430 \u043D\u0430 \u043E\u0431\u0449\u0438\u0445 \u0440\u0430\u0441\u0445\u043E\u0434\u0430\u0445, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u043F\u0440\u043E\u043F\u043E\u0440\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u043E \u0434\u0435\u043B\u044F\u0442\u0441\u044F \u043C\u0435\u0436\u0434\u0443 \u0432\u0441\u0435\u043C\u0438 \u043E\u0431\u044A\u0435\u043A\u0442\u0430\u043C\u0438. \u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u043E \u043F\u0440\u0435\u0434\u043F\u043E\u043B\u0430\u0433\u0430\u0435\u043C\u044B\u0445 \u0435\u0436\u0435\u0433\u043E\u0434\u043D\u044B\u0445 \u0441\u0431\u043E\u0440\u0430\u0445 \u0434\u043B\u044F \u043A\u043E\u043D\u043A\u0440\u0435\u0442\u043D\u043E\u0433\u043E \u043E\u0431\u044A\u0435\u043A\u0442\u0430 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u043F\u043E \u0437\u0430\u043F\u0440\u043E\u0441\u0443. \u041A\u0440\u043E\u043C\u0435 \u0442\u043E\u0433\u043E, \u0434\u043B\u044F \u043A\u0430\u0436\u0434\u043E\u0433\u043E \u043F\u0440\u043E\u0435\u043A\u0442\u0430 \u0441\u043E\u0437\u0434\u0430\u0435\u0442\u0441\u044F \u0430\u043C\u043E\u0440\u0442\u0438\u0437\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u0444\u043E\u043D\u0434. \u0426\u0435\u043B\u044C \u0430\u043C\u043E\u0440\u0442\u0438\u0437\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0433\u043E \u0444\u043E\u043D\u0434\u0430 - \u043D\u0430\u043A\u043E\u043F\u043B\u0435\u043D\u0438\u0435 \u0441\u0440\u0435\u0434\u0441\u0442\u0432 \u043D\u0430 \u043A\u0430\u043F\u0438\u0442\u0430\u043B\u044C\u043D\u044B\u0439 \u0440\u0435\u043C\u043E\u043D\u0442 \u0438\u043D\u0444\u0440\u0430\u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u044B \u0438/\u0438\u043B\u0438 \u0443\u043B\u0443\u0447\u0448\u0435\u043D\u0438\u044F, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u0431\u0443\u0434\u0435\u0442 \u0440\u0435\u0448\u0435\u043D\u043E \u0441\u0434\u0435\u043B\u0430\u0442\u044C \u0432 \u0431\u0443\u0434\u0443\u0449\u0435\u043C. \u0424\u043E\u043D\u0434 \u0441\u043E\u0437\u0434\u0430\u0435\u0442\u0441\u044F \u043F\u0443\u0442\u0435\u043C \u043D\u0435\u0437\u043D\u0430\u0447\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0445 \u043F\u043E\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u0439 \u043D\u0430 \u0440\u0435\u0433\u0443\u043B\u044F\u0440\u043D\u043E\u0439 \u043E\u0441\u043D\u043E\u0432\u0435, \u0447\u0442\u043E \u043F\u043E\u0437\u0432\u043E\u043B\u044F\u0435\u0442 \u0438\u0441\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E\u0441\u0442\u044C \u043E\u0442\u043F\u043B\u0430\u0442\u044B \u043A\u0440\u0443\u043F\u043D\u044B\u0445 \u0441\u0443\u043C\u043C \u043F\u0440\u0438 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E\u0441\u0442\u0438 \u0440\u0435\u043C\u043E\u043D\u0442\u0430.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null," \u0412\u0438\u043B\u043B\u044B Laguna Village Villas"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041E\u0431\u0449\u0430\u044F \u043F\u043B\u043E\u0449\u0430\u0434\u044C \u043E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u0435\u0442\u0441\u044F \u044E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u0438\u043C \u043B\u0438\u0446\u043E\u043C (Condominium Juristic Person (CJP). \u0421\u0443\u043C\u043C\u0430 \u0435\u0436\u0435\u0433\u043E\u0434\u043D\u044B\u0445 \u0432\u044B\u043F\u043B\u0430\u0442 \u043E\u0441\u043D\u043E\u0432\u0430\u043D\u0430 \u043D\u0430 \u043E\u0431\u0449\u0438\u0445 \u0440\u0430\u0441\u0445\u043E\u0434\u0430\u0445, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u043F\u0440\u043E\u043F\u043E\u0440\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u043E \u0434\u0435\u043B\u044F\u0442\u0441\u044F \u043C\u0435\u0436\u0434\u0443 \u0432\u0441\u0435\u043C\u0438 \u043E\u0431\u044A\u0435\u043A\u0442\u0430\u043C\u0438. \u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u043E \u043F\u0440\u0435\u0434\u043F\u043E\u043B\u0430\u0433\u0430\u0435\u043C\u044B\u0445 \u0435\u0436\u0435\u0433\u043E\u0434\u043D\u044B\u0445 \u0441\u0431\u043E\u0440\u0430\u0445 \u0434\u043B\u044F \u043A\u043E\u043D\u043A\u0440\u0435\u0442\u043D\u043E\u0433\u043E \u043E\u0431\u044A\u0435\u043A\u0442\u0430 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u043F\u043E \u0437\u0430\u043F\u0440\u043E\u0441\u0443. \u041A\u0440\u043E\u043C\u0435 \u0442\u043E\u0433\u043E, \u0434\u043B\u044F \u043A\u0430\u0436\u0434\u043E\u0433\u043E \u043F\u0440\u043E\u0435\u043A\u0442\u0430 \u0441\u043E\u0437\u0434\u0430\u0435\u0442\u0441\u044F \u0430\u043C\u043E\u0440\u0442\u0438\u0437\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u0444\u043E\u043D\u0434. \u0426\u0435\u043B\u044C \u0430\u043C\u043E\u0440\u0442\u0438\u0437\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0433\u043E \u0444\u043E\u043D\u0434\u0430 - \u043D\u0430\u043A\u043E\u043F\u043B\u0435\u043D\u0438\u0435 \u0441\u0440\u0435\u0434\u0441\u0442\u0432 \u043D\u0430 \u043A\u0430\u043F\u0438\u0442\u0430\u043B\u044C\u043D\u044B\u0439 \u0440\u0435\u043C\u043E\u043D\u0442 \u0438\u043D\u0444\u0440\u0430\u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u044B \u0438/\u0438\u043B\u0438 \u0443\u043B\u0443\u0447\u0448\u0435\u043D\u0438\u044F, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u0431\u0443\u0434\u0435\u0442 \u0440\u0435\u0448\u0435\u043D\u043E \u0441\u0434\u0435\u043B\u0430\u0442\u044C \u0432 \u0431\u0443\u0434\u0443\u0449\u0435\u043C. \u0424\u043E\u043D\u0434 \u0441\u043E\u0437\u0434\u0430\u0435\u0442\u0441\u044F \u043F\u0443\u0442\u0435\u043C \u043D\u0435\u0437\u043D\u0430\u0447\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0445 \u043F\u043E\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u0439 \u043D\u0430 \u0440\u0435\u0433\u0443\u043B\u044F\u0440\u043D\u043E\u0439 \u043E\u0441\u043D\u043E\u0432\u0435, \u0447\u0442\u043E \u043F\u043E\u0437\u0432\u043E\u043B\u044F\u0435\u0442 \u0438\u0441\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E\u0441\u0442\u044C \u043E\u0442\u043F\u043B\u0430\u0442\u044B \u043A\u0440\u0443\u043F\u043D\u044B\u0445 \u0441\u0443\u043C\u043C \u043F\u0440\u0438 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E\u0441\u0442\u0438 \u0440\u0435\u043C\u043E\u043D\u0442\u0430.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null," \u0412\u0438\u043B\u043B\u044B \u0432 Banyan Tree Village"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041E\u0431\u0449\u0438\u0435 \u0440\u0430\u0441\u0445\u043E\u0434\u044B, \u044F\u0432\u043B\u044F\u044E\u0449\u0438\u0435\u0441\u044F \u0447\u0430\u0441\u0442\u044C\u044E \u043E\u0431\u044B\u0447\u043D\u044B\u0445 \u044D\u043A\u0441\u043F\u043B\u0443\u0430\u0442\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0445 \u0440\u0430\u0441\u0445\u043E\u0434\u043E\u0432, \u043E\u043F\u043B\u0430\u0447\u0438\u0432\u0430\u044E\u0442\u0441\u044F Banyan Tree.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null," \u0412\u0438\u043B\u043B\u044B \u0441 \u0431\u0430\u0441\u0441\u0435\u0439\u043D\u043E\u043C Dusit Thani Pool Villas"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041E\u0431\u0449\u0438\u0435 \u0440\u0430\u0441\u0445\u043E\u0434\u044B, \u044F\u0432\u043B\u044F\u044E\u0449\u0438\u0435\u0441\u044F \u0447\u0430\u0441\u0442\u044C\u044E \u043E\u0431\u044B\u0447\u043D\u044B\u0445 \u044D\u043A\u0441\u043F\u043B\u0443\u0430\u0442\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0445 \u0440\u0430\u0441\u0445\u043E\u0434\u043E\u0432, \u043E\u043F\u043B\u0430\u0447\u0438\u0432\u0430\u044E\u0442\u0441\u044F Dusit Thani Laguna Phuket.")))),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u516C\u5171\u533A\u57DF\u7BA1\u7406\u8D39\u662F\u4E3A\u4E86\u4E1A\u4E3B\u7684\u5229\u76CA\u800C\u5411\u5176\u6536\u53D6\u7684\u516C\u5171\u57FA\u7840\u8BBE\u65BD\u548C\u8BBE\u5907\u7684\u65E5\u5E38\u7EF4\u62A4\u548C\u517B\u62A4\u8D39\u7528\u3002\u8BE6\u7EC6\u89C4\u5B9A\u5982\u4E0B\uFF1A"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u4E50\u53E4\u6D6A\u4E61\u6751\u8054\u4F53\u522B\u5885\u548C\u4E50\u53E4\u6D6A\u4E61\u6751\u72EC\u7ACB\u522B\u5885"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u516C\u5171\u533A\u57DF\u7531\u6211\u4EEC\u4E13\u95E8\u7684\u7269\u4E1A\u7BA1\u7406\u90E8\u95E8\u4EE3\u8868\u4E1A\u4E3B\u8FDB\u884C\u7BA1\u7406\u3002\u6BCF\u5E74\u7684\u8D39\u7528\u56E0\u9879\u76EE\u7684\u4E0D\u540C\u800C\u6709\u6240\u4E0D\u540C\uFF0C\u6839\u636E\u603B\u8D39\u7528\u4EE5\u53CA\u540C\u4E00\u9879\u76EE\u5185\u7684\u7269\u4E1A\u603B\u6570\u6309\u6BD4\u4F8B\u5206\u644A\u3002\u7279\u5B9A\u9879\u76EE\u7684\u8BE6\u7EC6\u9884\u4F30\u5E74\u8D39\u53EF\u5E94\u8981\u6C42\u63D0\u4F9B\u3002\u6B64\u5916\uFF0C\u5404\u9879\u76EE\u8FD8\u5C06\u8BBE\u7ACB\u507F\u503A\u57FA\u91D1\uFF0C\u4EE5\u4FBF\u4E3A\u65E5\u540E\u53EF\u80FD\u5BF9\u4E3B\u8981\u57FA\u7840\u8BBE\u65BD\u8FDB\u884C\u7684\u7EF4\u4FEE\u548C/\u6216\u6539\u8FDB\u79EF\u7D2F\u8D44\u91D1\u3002\u4E0E\u5176\u9884\u5148\u6536\u53D6\u4E00\u5927\u7B14\u91D1\u989D\uFF0C\u4E0D\u5982\u5B9A\u671F\u6536\u53D6\u8D44\u91D1\uFF0C\u4EE5\u4FBF\u957F\u65F6\u95F4\u79EF\u7D2F\u4EE5\u5907\u4E0D\u65F6\u4E4B\u9700\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null," \u4E50\u53E4\u6D6A\u4E61\u6751\u8054\u6392\u522B\u5885"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u516C\u5171\u533A\u57DF\u7531\u5171\u7BA1\u6CD5\u4EBA\uFF08CJP\uFF09\u8FDB\u884C\u7BA1\u7406\u3002\u6BCF\u5E74\u7684\u8D39\u7528\u7531\u4EA7\u751F\u7684\u603B\u8D39\u7528\u9664\u4EE5\u7269\u4E1A\u603B\u6570\u51B3\u5B9A\uFF0C\u5E76\u6309\u6BD4\u4F8B\u5206\u644A\u3002\u7279\u5B9A\u9879\u76EE\u7684\u8BE6\u7EC6\u9884\u4F30\u5E74\u8D39\u53EF\u5E94\u8981\u6C42\u63D0\u4F9B\u3002\u6B64\u5916\uFF0C\u5404\u9879\u76EE\u8FD8\u5C06\u8BBE\u7ACB\u507F\u503A\u57FA\u91D1\uFF0C\u4EE5\u4FBF\u4E3A\u65E5\u540E\u53EF\u80FD\u5BF9\u4E3B\u8981\u57FA\u7840\u8BBE\u65BD\u8FDB\u884C\u7684\u7EF4\u4FEE\u548C/\u6216\u6539\u8FDB\u79EF\u7D2F\u8D44\u91D1\u3002\u4E0E\u5176\u9884\u5148\u6536\u53D6\u4E00\u5927\u7B14\u91D1\u989D\uFF0C\u4E0D\u5982\u5B9A\u671F\u6536\u53D6\u8D44\u91D1\uFF0C\u4EE5\u4FBF\u957F\u65F6\u95F4\u79EF\u7D2F\u4EE5\u5907\u4E0D\u65F6\u4E4B\u9700\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null," \u4E50\u53E4\u6D6A\u4E61\u6751\u9601\u697C"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u516C\u5171\u533A\u57DF\u7531\u6211\u4EEC\u4E13\u95E8\u7684\u7269\u4E1A\u7BA1\u7406\u90E8\u95E8\u4EE3\u8868\u4E1A\u4E3B\u8FDB\u884C\u7BA1\u7406\u3002\u6BCF\u5E74\u7684\u8D39\u7528\u7531\u4EA7\u751F\u7684\u603B\u8D39\u7528\u9664\u4EE5\u7269\u4E1A\u603B\u6570\u51B3\u5B9A\uFF0C\u5E76\u6309\u6BD4\u4F8B\u5206\u644A\u3002\u7279\u5B9A\u9879\u76EE\u7684\u8BE6\u7EC6\u9884\u4F30\u5E74\u8D39\u53EF\u5E94\u8981\u6C42\u63D0\u4F9B\u3002\u6B64\u5916\uFF0C\u5404\u9879\u76EE\u8FD8\u5C06\u8BBE\u7ACB\u507F\u503A\u57FA\u91D1\uFF0C\u4EE5\u4FBF\u4E3A\u65E5\u540E\u53EF\u80FD\u5BF9\u4E3B\u8981\u57FA\u7840\u8BBE\u65BD\u8FDB\u884C\u7684\u7EF4\u4FEE\u548C/\u6216\u6539\u8FDB\u79EF\u7D2F\u8D44\u91D1\u3002\u4E0E\u5176\u9884\u5148\u6536\u53D6\u4E00\u5927\u7B14\u91D1\u989D\uFF0C\u4E0D\u5982\u5B9A\u671F\u6536\u53D6\u8D44\u91D1\uFF0C\u4EE5\u4FBF\u957F\u65F6\u95F4\u79EF\u7D2F\u4EE5\u5907\u4E0D\u65F6\u4E4B\u9700\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null," \u60A6\u6995\u5E84\u522B\u5885"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u516C\u5171\u533A\u57DF\u7BA1\u7406\u8D39\u5C06\u4F5C\u4E3A\u6B63\u5E38\u8FD0\u4F5C\u8D39\u7528\u7684\u4E00\u90E8\u5206\uFF0C\u7531\u60A6\u6995\u96C6\u56E2\u627F\u62C5\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null," \u90FD\u559C\u5929\u9619\u6CF3\u6C60\u522B\u5885"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u516C\u5171\u533A\u57DF\u7BA1\u7406\u8D39\u5C06\u4F5C\u4E3A\u6B63\u5E38\u8FD0\u4F5C\u8D39\u7528\u7684\u4E00\u90E8\u5206\uFF0C\u7531\u666E\u5409\u5C9B\u4E50\u53E4\u6D6A\u90FD\u559C\u5929\u9619\u9152\u5E97\u627F\u62C5\u3002"))))}},{categoryId:7,question:"What are the terms of payment?",displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"For all new properties sold, we offer 2 options of payment plans. Payment terms are as follows:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Option 1: 100% Payment upon purchase / during construction"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"100% payment upon purchase for already completed properties. Progressive payments for properties under construction are as per the table below."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Construction Payment Term"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"th-col2"},"Of Selling Price"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"st")," Payment upon signing contact"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"nd")," Payment when construction is 25% complete",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"rd")," Payment when construction is 50% complete",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"th")," Payment when construction is 75% complete",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"3")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"th")," Payment upon completion of construction"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{textAlign:"center"}},"Total"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"100%")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Notes:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",{className:"notes"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Areas and dimensions are approximate and subject to final survey and change.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Prices include fixed furnishing and do not include loose furniture.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Concrete structure substantially completed.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Roof, brickwork and rendering substantially completed.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Electrical conduits, pipework and plastering substantially completed.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Interest will be applied to the post-construction deferred balance as outlined under Financing Option"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Option 2: 50% payment upon purchase / during construction with 50% deferred payment over 1, 3 or 5 years"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"50% payment upon purchase for already completed properties. Progressive payments for properties under construction (50% during construction / 50% post construction) as per the table below"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Deferred Payment Plan"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"th-col2"},"Of Selling Price"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"st")," Payment upon signing contract"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"nd")," Payment when construction is 50% complete",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"10%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"rd")," Payment when construction is 75% complete",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"10%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"th")," Payment upon completion of construction",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"3")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"10%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"Post construction payments",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"4")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"50%")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Financing Options"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"th-col2"},"Interest Rate",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"(per annum)"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1 Year (4 quarterly installments)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"3%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3 Year (12 quarterly installments)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"5%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5 Year (20 quarterly installments)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"7%")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Notes:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",{className:"notes"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Areas and dimensions are approximate and subject to final survey and change.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Prices include fixed furnishing and do not include loose furniture.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Concrete structure substantially completed.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Roof, brickwork and rendering substantially completed.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Electrical conduits, pipework and plastering substantially completed.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Interest will be applied to the post-construction deferred balance as outlined under Financing Option"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"table-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"tr-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Price")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Reservation Deposit")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Construction Completion ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Payment 50% (Minus Deposit)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Remaining Post Finance 50%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:"3",className:"td-group-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Monthly Installment"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"tr-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"1 Year (3%)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"3 Year (5%)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"5 Year (7%)"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"10,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,273,525"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"451,292"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"298,456")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"15,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"7,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"7,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,910,288"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"676,937"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"447,684")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"20,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"9,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"10,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,547,050"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"902,583"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"596,912")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"25,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"12,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"12,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3,183,813"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,128,229"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"746,140")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"30,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"14,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"15,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3,820,575"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,353,875"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"895,368")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"35,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"17,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"17,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4,457,338"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,579,520"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,044,596")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"40,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"19,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"20,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5,094,100"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,805,166"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,193,824")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"45,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"22,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"22,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5,730,863"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,030,812"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,343,053")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"50,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"24,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"25,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"6,367,625"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,256,458"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,492,281")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"55,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"27,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"27,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"7,004,388"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,482,104"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,641,509")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"60,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"29,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"30,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"7,641,150"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,707,749"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,790,737")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Notes:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",{className:"notes"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"All amounts are stated in Thai Baht (THB).")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"The above table sets out the estimated payments required under the respective payment plans for selling prices between THB 10,000,000 - 60,000,000.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"The estimated payments are indicative only and the developer / seller does not accept any responsibility or liability whatsoever for any inaccuracies or omissions.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"One year deferred plan is 12 equal monthly installments (3% interest applies).")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Three year deferred plan is 36 equal monthly installments (5% interest applies).")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Five year deferred plan is 60 equal monthly installments (7% interest applies).")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Payment terms are subject to change without notice.")))),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0414\u043B\u044F \u0432\u0441\u0435\u0445 \u043D\u043E\u0432\u044B\u0445 \u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u0438 \u043C\u044B \u043F\u0440\u0435\u0434\u043B\u0430\u0433\u0430\u0435\u043C 2 \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0430 \u043E\u043F\u043B\u0430\u0442\u044B. \u0423\u0441\u043B\u043E\u0432\u0438\u044F \u043E\u043F\u043B\u0430\u0442\u044B\uFF1A"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u0412\u0430\u0440\u0438\u0430\u043D\u0442 1: 100% \u043E\u043F\u043B\u0430\u0442\u0430 \u043F\u0440\u0438 \u043F\u043E\u043A\u0443\u043F\u043A\u0435 / \u0432\u043E \u0432\u0440\u0435\u043C\u044F \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"100% \u043E\u043F\u043B\u0430\u0442\u0430 \u043F\u0440\u0438 \u043F\u043E\u043A\u0443\u043F\u043A\u0435 \u0433\u043E\u0442\u043E\u0432\u044B\u0445 \u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432. \u041F\u0440\u043E\u0433\u0440\u0435\u0441\u0441\u0438\u0432\u043D\u044B\u0435 \u043F\u043B\u0430\u0442\u0435\u0436\u0438 \u0434\u043B\u044F \u0441\u0442\u0440\u043E\u044F\u0449\u0438\u0445\u0441\u044F \u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432 \u0432 \u0441 \u043D\u0438\u0436\u0435\u043F\u0440\u0438\u0432\u0435\u0434\u0435\u043D\u043D\u043E\u0439 \u0442\u0430\u0431\u043B\u0438\u0446\u0435."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"\u0420\u0435\u0437\u0435\u0440\u0432\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u0434\u0435\u043F\u043E\u0437\u0438\u0442"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"th-col2"},"\u0422\u0430\u0439\u0441\u043A\u0438\u0445 \u0411\u0430\u0442\u0430\u0445"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"\u0439")," \u043F\u043B\u0430\u0442\u0435\u0436 \u043F\u0440\u0438 \u043F\u043E\u0434\u043F\u0438\u0441\u0430\u043D\u0438\u0438 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"\u0439")," \u043F\u0440\u0438 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0438 25% \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0445 \u0440\u0430\u0431\u043E\u0442",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"\u0439")," \u043F\u0440\u0438 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0438 50% \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0445 \u0440\u0430\u0431\u043E\u0442",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"\u0439")," \u043F\u0440\u0438 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0438 75% \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0445 \u0440\u0430\u0431\u043E\u0442",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"3")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"\u0439")," \u043F\u0440\u0438 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u0438 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{textAlign:"center"}},"\u0418\u0442\u043E\u0433\u043E"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"100%")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u041F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0435:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",{className:"notes"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u041F\u043B\u043E\u0449\u0430\u0434\u0438 \u0438 \u0440\u0430\u0437\u043C\u0435\u0440\u044B \u0443\u043A\u0430\u0437\u0430\u043D\u044B \u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0438 \u043C\u043E\u0433\u0443\u0442 \u0438\u0437\u043C\u0435\u043D\u044F\u0442\u044C\u0441\u044F \u043F\u043E \u0438\u0442\u043E\u0433\u0430\u043C \u0444\u0438\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0438\u0437\u043C\u0435\u0440\u0435\u043D\u0438\u0439.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u0426\u0435\u043D\u044B \u0432\u043A\u043B\u044E\u0447\u0430\u044E\u0442 \u0432\u0441\u0442\u0440\u043E\u0435\u043D\u043D\u0443\u044E \u043C\u0435\u0431\u043B\u0438\u0440\u043E\u0432\u043A\u0443; \u043D\u0435\u0432\u0441\u0442\u0440\u043E\u0435\u043D\u043D\u0430\u044F \u043C\u0435\u0431\u0435\u043B\u044C \u043D\u0435 \u0432\u043A\u043B\u044E\u0447\u0435\u043D\u0430.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u0411\u0435\u0442\u043E\u043D\u043D\u0430\u044F \u043A\u043E\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0438\u044F \u0432 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u043C \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0430.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u041A\u0440\u044B\u0448\u0430, \u0443\u043A\u043B\u0430\u0434\u043A\u0430 \u043A\u0438\u0440\u043F\u0438\u0447\u0430 \u0438 \u043D\u0430\u0440\u0443\u0436\u043D\u0430\u044F \u043E\u0442\u0434\u0435\u043B\u043A\u0430 \u0432 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u043C \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u044B.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u042D\u043B\u0435\u043A\u0442\u0440\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u043F\u0440\u043E\u0432\u043E\u0434\u043A\u0430, \u0443\u043A\u043B\u0430\u0434\u043A\u0430 \u0432\u043E\u0434\u043E\u043F\u0440\u043E\u0432\u043E\u0434\u043D\u044B\u0445 \u0442\u0440\u0443\u0431 \u0438 \u0432\u043D\u0443\u0442\u0440\u0435\u043D\u043D\u044F\u044F \u043E\u0442\u0434\u0435\u043B\u043A\u0430 \u0432 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u043C \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u044B.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u041F\u0440\u043E\u0446\u0435\u043D\u0442\u044B \u043F\u043E \u0440\u0430\u0441\u0441\u0440\u043E\u0447\u043A\u0435 \u0431\u0443\u0434\u0443\u0442 \u043D\u0430\u0447\u0438\u0441\u043B\u0435\u043D\u044B \u043D\u0430 \u043E\u0442\u043B\u043E\u0436\u0435\u043D\u043D\u044B\u0435 \u043F\u043B\u0430\u0442\u0435\u0436\u0438 \u043F\u043E \u043E\u043A\u043E\u043D\u0447\u0430\u043D\u0438\u0438 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430, \u043A\u0430\u043A \u0443\u043A\u0430\u0437\u0430\u043D\u043E \u0432 \u0442\u0430\u0431\u043B\u0438\u0446\u0435 \xAB\u0412\u0430\u0440\u0438\u0430\u043D\u0442\u044B \u0444\u0438\u043D\u0430\u043D\u0441\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F\xBB"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u0412\u0430\u0440\u0438\u0430\u043D\u0442 2: \u041E\u043F\u043B\u0430\u0442\u044B \u0432 \u0440\u0430\u0441\u0441\u0440\u043E\u0447\u043A\u0443"),"\u041F\u0435\u0440\u0432\u044B\u0435 50% \u043F\u043E \u044D\u0442\u0430\u043F\u0430\u043C \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 \u0438 \u0432\u0442\u043E\u0440\u044B\u0435 50% \u0432 \u0440\u0430\u0441\u0441\u0440\u043E\u0447\u043A\u0443 \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 1, 3 \u0438\u043B\u0438 5 \u043B\u0435\u0442 \u0432 \u0437\u0430\u0432\u0438\u0441\u0438\u043C\u043E\u0441\u0442\u0438 \u043E\u0442 \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u043E\u0433\u043E \u043F\u043B\u0430\u043D\u0430 \u043E\u043F\u043B\u0430\u0442\u044B.",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"50% \u043E\u043F\u043B\u0430\u0442\u044B \u043F\u0440\u0438 \u043F\u043E\u043A\u0443\u043F\u043A\u0435 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043D\u044B\u0445 \u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432 \u0438 \u043E\u043F\u043B\u0430\u0442\u0430 \u0432 \u0440\u0430\u0441\u0441\u0440\u043E\u0447\u043A\u0443 \u0434\u043B\u044F \u0441\u0442\u0440\u043E\u044F\u0449\u0438\u0445\u0441\u044F \u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432 (50% \u043F\u043E \u044D\u0442\u0430\u043F\u0430\u043C \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 / 50% \u043F\u043E\u0441\u043B\u0435 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430) \u0441\u043C\u043E\u0442\u0440\u0438\u0442\u0435 \u0442\u0430\u0431\u043B\u0438\u0446\u0443 \u0438\u0437\u043B\u043E\u0436\u0435\u043D\u043D\u0443\u044E \u043D\u0438\u0436\u0435."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"\u0420\u0435\u0437\u0435\u0440\u0432\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u0434\u0435\u043F\u043E\u0437\u0438\u0442"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"th-col2"},"\u0422\u0430\u0439\u0441\u043A\u0438\u0445 \u0411\u0430\u0442\u0430\u0445"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"\u0439")," \u043F\u043B\u0430\u0442\u0435\u0436 \u043F\u0440\u0438 \u043F\u043E\u0434\u043F\u0438\u0441\u0430\u043D\u0438\u0438 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"\u0439")," \u043F\u0440\u0438 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0438 50% \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0445 \u0440\u0430\u0431\u043E\u0442",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"10%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"\u0439")," \u043F\u0440\u0438 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0438 75% \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0445 \u0440\u0430\u0431\u043E\u0442",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"10%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"\u0439")," \u043F\u0440\u0438 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u0438 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"3")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"10%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u041F\u043B\u0430\u0442\u0435\u0436 \u043F\u043E\u0441\u043B\u0435 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"4")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"50%")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"\u0412\u0430\u0440\u0438\u0430\u043D\u0442\u044B \u0444\u0438\u043D\u0430\u043D\u0441\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"th-col2"},"\u041F\u0440\u043E\u0446\u0435\u043D\u0442\u043D\u0430\u044F",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"\u0441\u0442\u0430\u0432\u043A\u0430"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1 \u0433\u043E\u0434 (4 \u0435\u0436\u0435\u043A\u0432\u0430\u0440\u0442\u0430\u043B\u044C\u043D\u044B\u0445 \u043F\u043B\u0430\u0442\u0435\u0436\u0430)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"3%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3 \u0433\u043E\u0434\u0430 (12 \u0435\u0436\u0435\u043A\u0432\u0430\u0440\u0442\u0430\u043B\u044C\u043D\u044B\u0445 \u043F\u043B\u0430\u0442\u0435\u0436\u0435\u0439)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"5%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5 \u043B\u0435\u0442 (20 \u0435\u0436\u0435\u043A\u0432\u0430\u0440\u0442\u0430\u043B\u044C\u043D\u044B\u0445 \u043F\u043B\u0430\u0442\u0435\u0436\u0435\u0439)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"7%")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u041F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0435:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",{className:"notes"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u041F\u043B\u043E\u0449\u0430\u0434\u0438 \u0438 \u0440\u0430\u0437\u043C\u0435\u0440\u044B \u0443\u043A\u0430\u0437\u0430\u043D\u044B \u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0438 \u043C\u043E\u0433\u0443\u0442 \u0438\u0437\u043C\u0435\u043D\u044F\u0442\u044C\u0441\u044F \u043F\u043E \u0438\u0442\u043E\u0433\u0430\u043C \u0444\u0438\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0438\u0437\u043C\u0435\u0440\u0435\u043D\u0438\u0439.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u0426\u0435\u043D\u044B \u0432\u043A\u043B\u044E\u0447\u0430\u044E\u0442 \u0432\u0441\u0442\u0440\u043E\u0435\u043D\u043D\u0443\u044E \u043C\u0435\u0431\u043B\u0438\u0440\u043E\u0432\u043A\u0443; \u043D\u0435\u0432\u0441\u0442\u0440\u043E\u0435\u043D\u043D\u0430\u044F \u043C\u0435\u0431\u0435\u043B\u044C \u043D\u0435 \u0432\u043A\u043B\u044E\u0447\u0435\u043D\u0430.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u0411\u0435\u0442\u043E\u043D\u043D\u0430\u044F \u043A\u043E\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0438\u044F \u0432 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u043C \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0430.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u041A\u0440\u044B\u0448\u0430, \u0443\u043A\u043B\u0430\u0434\u043A\u0430 \u043A\u0438\u0440\u043F\u0438\u0447\u0430 \u0438 \u043D\u0430\u0440\u0443\u0436\u043D\u0430\u044F \u043E\u0442\u0434\u0435\u043B\u043A\u0430 \u0432 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u043C \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u044B.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u042D\u043B\u0435\u043A\u0442\u0440\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u043F\u0440\u043E\u0432\u043E\u0434\u043A\u0430, \u0443\u043A\u043B\u0430\u0434\u043A\u0430 \u0432\u043E\u0434\u043E\u043F\u0440\u043E\u0432\u043E\u0434\u043D\u044B\u0445 \u0442\u0440\u0443\u0431 \u0438 \u0432\u043D\u0443\u0442\u0440\u0435\u043D\u043D\u044F\u044F \u043E\u0442\u0434\u0435\u043B\u043A\u0430 \u0432 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u043C \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u044B.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u041F\u0440\u043E\u0446\u0435\u043D\u0442\u044B \u043F\u043E \u0440\u0430\u0441\u0441\u0440\u043E\u0447\u043A\u0435 \u0431\u0443\u0434\u0443\u0442 \u043D\u0430\u0447\u0438\u0441\u043B\u0435\u043D\u044B \u043D\u0430 \u043E\u0442\u043B\u043E\u0436\u0435\u043D\u043D\u044B\u0435 \u043F\u043B\u0430\u0442\u0435\u0436\u0438 \u043F\u043E \u043E\u043A\u043E\u043D\u0447\u0430\u043D\u0438\u0438 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430, \u043A\u0430\u043A \u0443\u043A\u0430\u0437\u0430\u043D\u043E \u0432 \u0442\u0430\u0431\u043B\u0438\u0446\u0435 \xAB\u0412\u0430\u0440\u0438\u0430\u043D\u0442\u044B \u0444\u0438\u043D\u0430\u043D\u0441\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F\xBB"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"table-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"tr-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u0426\u0435\u043D\u0430")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u0414\u0435\u043F\u043E\u0437\u0438\u0442")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u041E\u043F\u043B\u0430\u0442\u0430 50% \u043F\u0440\u0438",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"\u043F\u043E\u0434\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u043A\u043E\u043D\u0442\u0440\u0430\u043A\u0442\u0430",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"(\u043C\u0438\u043D\u0443\u0441 \u0434\u0435\u043F\u043E\u0437\u0438\u0442)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u041E\u043F\u043B\u0430\u0442\u0430 \u0432\u0442\u043E\u0440\u044B\u0445",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"50% \u043F\u043E\u0441\u043B\u0435",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"\u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:"3",className:"td-group-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u0415\u0436\u0435\u043C\u0435\u0441\u044F\u0447\u043D\u044B\u0435 \u043F\u043B\u0430\u0442\u0435\u0436\u0438"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"tr-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"1 \u0433\u043E\u0434 (3%)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"3 \u0433\u043E\u0434\u0430 (5%)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"5 \u0433\u043E\u0434 (7%)"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"10,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,273,525"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"451,292"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"298,456")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"15,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"7,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"7,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,910,288"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"676,937"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"447,684")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"20,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"9,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"10,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,547,050"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"902,583"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"596,912")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"25,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"12,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"12,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3,183,813"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,128,229"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"746,140")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"30,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"14,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"15,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3,820,575"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,353,875"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"895,368")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"35,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"17,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"17,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4,457,338"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,579,520"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,044,596")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"40,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"19,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"20,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5,094,100"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,805,166"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,193,824")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"45,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"22,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"22,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5,730,863"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,030,812"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,343,053")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"50,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"24,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"25,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"6,367,625"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,256,458"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,492,281")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"55,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"27,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"27,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"7,004,388"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,482,104"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,641,509")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"60,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"29,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"30,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"7,641,150"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,707,749"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,790,737")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u041F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u044F:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",{className:"notes"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u0412\u0441\u0435 \u0441\u0443\u043C\u043C\u044B \u0443\u043A\u0430\u0437\u0430\u043D\u044B \u0432 \u0411\u0430\u0442\u0430\u0445")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u0412 \u0442\u0430\u0431\u043B\u0438\u0446\u0435 \u0432\u044B\u0448\u0435 \u0443\u043A\u0430\u0437\u0430\u043D\u044B \u043F\u0440\u0435\u0434\u043F\u043E\u043B\u0430\u0433\u0430\u0435\u043C\u044B\u0435 \u043F\u043B\u0430\u0442\u0435\u0436\u0438, \u0432 \u0440\u0430\u043C\u043A\u0430\u0445 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0445 \u043F\u043B\u0430\u043D\u043E\u0432 \u043E\u043F\u043B\u0430\u0442\u044B \u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432, \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C\u044E \u043C\u0435\u0436\u0434\u0443 10,000, 000-60,000, 000 \u0411\u0430\u0442.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u041F\u043B\u0430\u0442\u0435\u0436\u0438 \u044F\u0432\u043B\u044F\u044E\u0442\u0441\u044F \u043B\u0438\u0448\u044C \u043E\u0440\u0438\u0435\u043D\u0442\u0438\u0440\u043E\u0432\u043E\u0447\u043D\u044B\u043C\u0438 \u0438 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C / \u043F\u0440\u043E\u0434\u0430\u0432\u0435\u0446 \u043D\u0435 \u043D\u0435\u0441\u0435\u0442 \u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u044C \u0437\u0430 \u043B\u044E\u0431\u044B\u0435 \u043D\u0435\u0442\u043E\u0447\u043D\u043E\u0441\u0442\u0438 \u0438\u043B\u0438 \u043E\u0448\u0438\u0431\u043A\u0438.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u041E\u043F\u043B\u0430\u0442\u0430 \u0432 \u0440\u0430\u0441\u0441\u0440\u043E\u0447\u043A\u0443 \u0441\u0440\u043E\u043A\u043E\u043C \u043D\u0430 \u043E\u0434\u0438\u043D \u0433\u043E\u0434 \u043F\u043E\u0434\u0440\u0430\u0437\u0443\u043C\u0435\u0432\u0430\u0435\u0442 \u0432\u044B\u043F\u043B\u0430\u0442\u0443 12 \u0435\u0436\u0435\u043C\u0435\u0441\u044F\u0447\u043D\u044B\u0445 \u043F\u043B\u0430\u0442\u0435\u0436\u0435\u0439 (\u0441 \u0443\u0447\u0435\u0442\u043E\u043C 3% \u0433\u043E\u0434\u043E\u0432\u044B\u0445).")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u041E\u043F\u043B\u0430\u0442\u0430 \u0432 \u0440\u0430\u0441\u0441\u0440\u043E\u0447\u043A\u0443 \u0441\u0440\u043E\u043A\u043E\u043C \u043D\u0430 \u0442\u0440\u0438 \u0433\u043E\u0434\u0430 \u043F\u043E\u0434\u0440\u0430\u0437\u0443\u043C\u0435\u0432\u0430\u0435\u0442 \u0432\u044B\u043F\u043B\u0430\u0442\u0443 36 \u0435\u0436\u0435\u043C\u0435\u0441\u044F\u0447\u043D\u044B\u0445 \u043F\u043B\u0430\u0442\u0435\u0436\u0435\u0439 (\u0441 \u0443\u0447\u0435\u0442\u043E\u043C 5% \u0433\u043E\u0434\u043E\u0432\u044B\u0445).")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u041E\u043F\u043B\u0430\u0442\u0430 \u0432 \u0440\u0430\u0441\u0441\u0440\u043E\u0447\u043A\u0443 \u0441\u0440\u043E\u043A\u043E\u043C \u043D\u0430 \u043F\u044F\u0442\u044C \u043B\u0435\u0442 \u043F\u043E\u0434\u0440\u0430\u0437\u0443\u043C\u0435\u0432\u0430\u0435\u0442 \u0432\u044B\u043F\u043B\u0430\u0442\u0443 60 \u0435\u0436\u0435\u043C\u0435\u0441\u044F\u0447\u043D\u044B\u0445 \u043F\u043B\u0430\u0442\u0435\u0436\u0435\u0439 (\u0441 \u0443\u0447\u0435\u0442\u043E\u043C 7% \u0433\u043E\u0434\u043E\u0432\u044B\u0445).")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u0423\u0441\u043B\u043E\u0432\u0438\u044F \u043E\u043F\u043B\u0430\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0431\u044B\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u044B \u0431\u0435\u0437 \u043F\u0440\u0435\u0434\u0432\u0430\u0440\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0433\u043E \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F.")))),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u5BF9\u4E8E\u6240\u6709\u51FA\u552E\u7684\u65B0\u7269\u4E1A\uFF0C\u6211\u4EEC\u63D0\u4F9B\u4E24\u79CD\u4ED8\u6B3E\u8BA1\u5212\u3002 \u4ED8\u6B3E\u65B9\u5F0F\u5982\u4E0B\uFF1A"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u9009\u62E91\uFF1A100% \u8D2D\u4E70\u4EF7\u683C\u4ED8\u6B3E\u6216\u5EFA\u9020\u671F\u95F4\u4ED8\u6B3E"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"\u5BF9\u4E8E\u5DF2\u5EFA\u6210\u7269\u4E1A\uFF0C\u4F9D\u636E\u8D2D\u4E70\u4EF7\u683C100%\u4ED8\u6B3E\u3002\u5BF9\u4E8E\u5728\u5EFA\u7269\u4E1A\uFF0C\u4F9D\u636E\u4E0B\u8868\u6309\u8FDB\u5EA6\u5206\u671F\u4ED8\u6B3E\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"\u6309\u5EFA\u9020\u5206\u671F\u4ED8\u6B3E"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"th-col2"},"\u9500\u552E\u4EF7\u683C"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u9996\u7B14\u6B3E\u9879\u4E8E\u7B7E\u8BA2\u8D2D\u4E70\u5408\u540C\u652F\u4ED8"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"\u9500\u552E\u4EF7\u768420%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u7B2C\u4E8C\u7B14\u6B3E\u9879\u4E8E\u5DE5\u7A0B\u5B8C\u621025%\u65F6\u652F\u4ED8",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"\u9500\u552E\u4EF7\u768420%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u7B2C\u4E09\u7B14\u6B3E\u9879\u4E8E\u5DE5\u7A0B\u5B8C\u621050%\u65F6\u652F\u4ED8",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"\u9500\u552E\u4EF7\u768420%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u7B2C\u56DB\u7B14\u6B3E\u9879\u4E8E\u5DE5\u7A0B\u5B8C\u621075%\u65F6\u652F\u4ED8",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"3")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"\u9500\u552E\u4EF7\u768420%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u7B2C\u4E94\u7B14\u6B3E\u9879\u4E8E\u5DE5\u7A0B\u5B8C\u6210\u65F6\u652F\u4ED8"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"\u9500\u552E\u4EF7\u768420%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{textAlign:"center"}},"\u603B\u989D"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"\u9500\u552E\u4EF7\u683C\u7684100%")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u5907\u6CE8\uFF1A"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",{className:"notes"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u9762\u79EF\u4E0E\u5C3A\u5BF8\u4EC5\u4E3A\u9884\u4F30\uFF0C\u5B9E\u9645\u6570\u636E\u4EE5\u6700\u7EC8\u6D4B\u7ED8\u4E3A\u51C6")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u4EF7\u683C\u5305\u542B\u88C5\u4FEE\uFF0C\u4E0D\u5305\u542B\u53EF\u79FB\u52A8\u5BB6\u5177")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u6DF7\u51DD\u571F\u57FA\u7840\u7ED3\u6784\u5DE5\u7A0B\u5B8C\u6210")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u5916\u5899\u53CA\u5C01\u9876\u5DE5\u7A0B\u5B8C\u6210")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u6C34\u7535\u5DE5\u7A0B\uFF0C\u7BA1\u9053\u53CA\u6C34\u6CE5\u62B9\u5E73\u5DE5\u7A0B\u5B8C\u6210")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u5229\u606F\u5C06\u6839\u636E\u6240\u9009\u4ED8\u6B3E\u65B9\u6848\u4EE5\u622A\u81F3\u7AE3\u5DE5\u4ED8\u6B3E\u4E4B\u540E\u7684\u5269\u4F59\u623F\u6B3E\u4F59\u989D\u8BA1\u7B97"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u9009\u62E92\uFF1A50% \u8D2D\u4E70\u4EF7\u683C\u4ED8\u6B3E\u6216\u5EFA\u9020\u671F\u95F4\u4ED8\u6B3E\uFF0C50%\u5EF6\u671F1\u5E74,3\u5E74\u62165\u5E74\u4ED8\u6B3E\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"\u5BF9\u4E8E\u5DF2\u5EFA\u6210\u7269\u4E1A\uFF0C\u4F9D\u636E\u8D2D\u4E70\u4EF7\u683C\u768450%\u4ED8\u6B3E\u3002\u5BF9\u4E8E\u5728\u5EFA\u7269\u4E1A\uFF0C\u4F9D\u636E\u4E0B\u8868\u6309\u8FDB\u5EA6\u5206\u671F\u4ED8\u6B3E\uFF0850%\u5EFA\u9020\u671F\u95F4\u652F\u4ED8 / 50%\u5EFA\u9020\u5B8C\u6210\u65F6\u652F\u4ED8\uFF09\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"\u9884\u5B9A\u91D1"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"th-col2"},"\u6CF0\u94E2"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u9996\u7B14\u6B3E\u9879\u4E8E\u7B7E\u8BA2\u8D2D\u4E70\u5408\u540C\u652F\u4ED8"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"\u9500\u552E\u4EF7\u768420%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u7B2C\u4E8C\u7B14\u6B3E\u9879\u4E8E\u5DE5\u7A0B\u5B8C\u621050%\u4E4B\u65F6\u652F\u4ED8",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"\u9500\u552E\u4EF7\u768410%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u7B2C\u4E09\u7B14\u6B3E\u9879\u4E8E\u5DE5\u7A0B\u5B8C\u621075%\u65F6\u652F\u4ED8",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"\u9500\u552E\u4EF7\u768410%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u7B2C\u56DB\u7B14\u6B3E\u9879\u4E8E\u5DE5\u7A0B\u5B8C\u5DE5\u65F6\u652F\u4ED8",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"3")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"\u9500\u552E\u4EF7\u768410%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u5EFA\u6210\u540E\u652F\u4ED8",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"4")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"\u9500\u552E\u4EF7\u768450%")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"\u8D22\u52A1\u9009\u62E9"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"th-col2"},"\u5229\u7387"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1\u5E74 (4 \u4E2A\u5B63\u5EA6\u5206\u671F)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"3%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3\u5E74 (12 \u4E2A\u5B63\u5EA6\u5206\u671F)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"5%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5\u5E74 (20 \u4E2A\u5B63\u5EA6\u5206\u671F)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"7%")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u5907\u6CE8\uFF1A"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",{className:"notes"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u9762\u79EF\u4E0E\u5C3A\u5BF8\u4EC5\u4E3A\u9884\u4F30\uFF0C\u5B9E\u9645\u6570\u636E\u4EE5\u6700\u7EC8\u6D4B\u7ED8\u4E3A\u51C6")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u4EF7\u683C\u5305\u542B\u88C5\u4FEE\uFF0C\u4E0D\u5305\u542B\u53EF\u79FB\u52A8\u5BB6\u5177")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u6DF7\u51DD\u571F\u57FA\u7840\u7ED3\u6784\u5DE5\u7A0B\u5B8C\u6210")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u5916\u5899\u53CA\u5C01\u9876\u5DE5\u7A0B\u5B8C\u6210")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u6C34\u7535\u5DE5\u7A0B\uFF0C\u7BA1\u9053\u53CA\u6C34\u6CE5\u62B9\u5E73\u5DE5\u7A0B\u5B8C\u6210")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u5229\u606F\u5C06\u6839\u636E\u6240\u9009\u4ED8\u6B3E\u65B9\u6848\u4EE5\u622A\u81F3\u7AE3\u5DE5\u4ED8\u6B3E\u4E4B\u540E\u7684\u5269\u4F59\u623F\u6B3E\u4F59\u989D\u8BA1\u7B97"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"table-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"tr-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u552E\u4EF7")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u5B9A\u91D1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u65BD\u5DE5\u671F\u95F4\u4ED8\u6B3E50%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u7AE3\u5DE5\u540E\u4ED8\u6B3E")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:"3",className:"td-group-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u7AE3\u5DE5\u540E\u2014\u6309\u6708\u5206\u671F\u4ED8\u6B3E"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"tr-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"1\u5E74\u671F\u8BA1\u5212\u5229\u606F\u4E3A3%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"3\u5E74\u671F\u8BA1\u5212\u5229\u606F\u4E3A5%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"5\u5E74\u8BA1\u5212\u5229\u606F\u4E3A7%"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"10,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,273,525"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"451,292"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"298,456")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"15,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"7,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"7,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,910,288"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"676,937"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"447,684")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"20,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"9,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"10,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,547,050"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"902,583"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"596,912")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"25,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"12,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"12,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3,183,813"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,128,229"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"746,140")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"30,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"14,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"15,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3,820,575"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,353,875"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"895,368")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"35,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"17,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"17,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4,457,338"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,579,520"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,044,596")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"40,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"19,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"20,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5,094,100"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,805,166"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,193,824")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"45,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"22,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"22,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5,730,863"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,030,812"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,343,053")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"50,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"24,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"25,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"6,367,625"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,256,458"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,492,281")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"55,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"27,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"27,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"7,004,388"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,482,104"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,641,509")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"60,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"29,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"30,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"7,641,150"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,707,749"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,790,737")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u5907\u6CE8\uFF1A"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",{className:"notes"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u6240\u6709\u91D1\u989D\u5747\u4EE5\u6CF0\u94E2\u8868\u793A\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u4E0A\u8868\u6240\u5217\u4E3A\u552E\u4EF7\u4ECB\u4E8E1000\u4E07\u81F36000\u4E07\u6CF0\u94E2\u7684\u7269\u4E1A\u5728\u76F8\u5E94\u4ED8\u6B3E\u8BA1\u5212\u4E0B\u89C4\u5B9A\u7684\u9884\u8BA1\u4ED8\u6B3E\u989D\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u9884\u8BA1\u4ED8\u6B3E\u989D\u4EC5\u4F5C\u793A\u610F\u53C2\u8003\u7528\u9014\u3002\u5982\u6709\u9519\u6F0F\uFF0C\u5F00\u53D1\u5546/\u9500\u552E\u65B9\u6982\u4E0D\u8D1F\u8D23\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u4E00\u5E74\u671F\u5EF6\u671F\u4ED8\u6B3E\u8BA1\u5212\u662F\u6307\uFF0C\u520612\u4E2A\u6708\u6309\u6708\u7B49\u989D\u5206\u671F\u4ED8\u6B3E\uFF08\u5229\u606F\u4E3A3%\uFF09\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u4E09\u5E74\u671F\u5EF6\u671F\u4ED8\u6B3E\u8BA1\u5212\u662F\u6307\uFF0C\u520636\u4E2A\u6708\u6309\u6708\u7B49\u989D\u5206\u671F\u4ED8\u6B3E\uFF08\u5229\u606F\u4E3A5%\uFF09\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u4E94\u5E74\u671F\u5EF6\u671F\u4ED8\u6B3E\u8BA1\u5212\u662F\u6307\uFF0C\u520660\u4E2A\u6708\u6309\u6708\u7B49\u989D\u5206\u671F\u4ED8\u6B3E\uFF08\u5229\u606F\u4E3A7%\uFF09\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u4ED8\u6B3E\u65B9\u5F0F\u5982\u6709\u66F4\u6539\uFF0C\u6055\u4E0D\u53E6\u884C\u901A\u77E5\u3002"))))}}];

/***/ }),
/* 911 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PhuketLagunaPark2; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_skrollr__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_skrollr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_skrollr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_scroll__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_helmet__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hoc__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_language__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_location__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_phuket_laguna_park_2__ = __webpack_require__(912);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Gallery__ = __webpack_require__(921);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Concept__ = __webpack_require__(922);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Faq__ = __webpack_require__(923);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Destination__ = __webpack_require__(924);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__TheSanctuaryclub__ = __webpack_require__(925);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Siteplan__ = __webpack_require__(926);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Masterplan__ = __webpack_require__(929);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Residences__ = __webpack_require__(930);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Ebrochure__ = __webpack_require__(931);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var page="phuket-laguna-park-2";var sections=[{key:"gallery",label:"Gallery"},{key:"concept",label:"Concept"},{key:"masterplan",label:"Master Plan"},{key:"siteplan",label:"Site Plan"},{key:"residences",label:"Residences",subitem:[{key:"townhome",label:{en:"TOWNHOME",ru:"Таунхаусы",cn:"联排别墅"},path:"/:language/projects/phuket/laguna-park-2/",currentSection:0},{key:"villa",label:{// en: "Semi-detached",
// ru: "Дуплекс",
// cn: "双拼别墅",
en:"VILLA",ru:"Виллы",cn:"独栋别墅"},path:"/:language/projects/phuket/laguna-park-2/",currentSection:1}]},{key:"destination",label:"Destination"},{key:"sanctuary-club",label:"The Santuary Club"},{key:"faq",label:"FAQ",hideOnMobile:true},{key:"e-brochure",label:"E-Brochure",hideOnMobile:true}];var mapStateToProps=function mapStateToProps(state){console.log("mapStateToProps",state);return Object.assign({},state);};var actionToProps={switchLanguage:__WEBPACK_IMPORTED_MODULE_7__actions_language__["a" /* switchLanguage */],switchLocation:__WEBPACK_IMPORTED_MODULE_8__actions_location__["a" /* switchLocation */],initAppPhuketLagunaPark2:__WEBPACK_IMPORTED_MODULE_9__actions_phuket_laguna_park_2__["a" /* initAppPhuketLagunaPark2 */]};var PhuketLagunaPark2=(_dec=Object(__WEBPACK_IMPORTED_MODULE_6__hoc__["b" /* withRedux */])(mapStateToProps,actionToProps),_dec(_class=function(_Component){_inherits(PhuketLagunaPark2,_Component);function PhuketLagunaPark2(props){_classCallCheck(this,PhuketLagunaPark2);var _this=_possibleConstructorReturn(this,(PhuketLagunaPark2.__proto__||Object.getPrototypeOf(PhuketLagunaPark2)).call(this,props));_this.handleWheel=function(evt){if(evt.deltaY>0){var atBottomOfSection=_this.headerRef.current.atBottomOfSection();if(atBottomOfSection){evt.preventDefault();evt.stopPropagation();evt.returnValue=false;// console.log('evt', evt.deltaY);
_this.headerRef.current.handleScrollDown();}}if(evt.deltaY<0){var atTopOfSection=_this.headerRef.current.atTopOfSection();if(atTopOfSection){evt.preventDefault();evt.stopPropagation();evt.returnValue=false;// console.log('evt', evt.deltaY);
_this.headerRef.current.handleScrollUp();}}};_this.setLanguage=function(language){_this.props.actions.switchLanguage(language);};_this.setLocation=function(location){_this.props.actions.switchLocation(location);};_this.fetchData=function(){_this.props.actions.initAppPhuketLagunaPark2();};_this.renderSectionWithId=function(component,id){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_scroll__["Element"],{name:id},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("section",{id:id},component));};_this.headerRef=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createRef();return _this;}_createClass(PhuketLagunaPark2,[{key:"componentDidMount",value:function componentDidMount(){this.setLanguage(this.props.match.params.language);this.setLocation(this.props.route.key);this.fetchData();}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps){var currentLanguage=prevProps.match.params.language;var nextLanguage=this.props.match.params.language;if(currentLanguage!==nextLanguage){this.setLanguage(nextLanguage);}}},{key:"render",value:function render(){var pageData=__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(this.props,page+".data");var isMobile=__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(this.props,"device.isMobile");var currentLanguage=__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(this.props,"language.currentActive");console.log("pageData-Park2",{page:page,pageData:pageData});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_skrollr__["ParallaxProvider"],{init:{smoothScrollingDuration:500,smoothScrolling:true,forceHeight:false}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_helmet__["Helmet"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("title",null,"Laguna Park 2 and 3 Bedroom Townhomes For Sale"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("meta",{name:"description",content:"Live amongst tropical greenery at Laguna Park, a contemporary gated estate. Choose from brand new 2 and 3 Bedroom townhomes for sale at Bang Tao, Phuket."}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("meta",{name:"keywords",content:"2 bed townhouse for sale phuket, 3 bed town house for sale phuket, 4 bed house bang tao phuket, 3 bed town house phuket, 2 bedroom townhomes phuket, buy 2 bedroom townhouse phuket, 4 bedroom house for sale phuket"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["f" /* Header */],{mainLogo:Object(__WEBPACK_IMPORTED_MODULE_10__utils__["a" /* assetsPath */])()+"/images/logo-laguna-property.svg",subLogo:Object(__WEBPACK_IMPORTED_MODULE_10__utils__["a" /* assetsPath */])(page)+"/images/logo/logo-navbar.png",language:currentLanguage,projectSections:sections,wrappedComponentRef:this.headerRef}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"main-content laguna-park-2-page",disable_onWheel:this.handleWheel},this.renderSectionWithId(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Gallery__["a" /* default */],Object.assign({},__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"gallery"),{page:page})),"gallery"),this.renderSectionWithId(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Concept__["a" /* default */],{imageSlider:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"concept.imageSlider"),content:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"concept.content"),page:page}),"concept"),this.renderSectionWithId(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Masterplan__["a" /* default */],{map:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"masterPlan.maps"),page:page}),"masterplan"),this.renderSectionWithId(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Siteplan__["a" /* default */],{map:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"sitePlan.maps"),dataSitePlan:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"sitePlan.type"),descriptions:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"sitePlan.descriptions"),page:page}),"siteplan"),this.renderSectionWithId(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Residences__["a" /* default */],{landingPage:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"residence.landingPage"),type:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"residence.type"),page:page}),"residences"),this.renderSectionWithId(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Destination__["a" /* default */],{isMobile:isMobile,imageSlider:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"destination.landingPage"),title:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"destination.content.title"),description:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"destination.content.description"),mapData:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"destination.map"),page:page}),"destination"),this.renderSectionWithId(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__TheSanctuaryclub__["a" /* default */],{description:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"sanctuaryClub.description"),image:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"sanctuaryClub.image"),title:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"sanctuaryClub.title"),page:page}),"sanctuary-club"),this.renderSectionWithId(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Faq__["a" /* default */],Object.assign({},__webpack_require__(932),{page:page})),"faq"),this.renderSectionWithId(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Ebrochure__["a" /* default */],{location:"phuket",project:"laguna-park-2",page:page}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["d" /* Footer */],null)),"e-brochure"))));}}]);return PhuketLagunaPark2;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class);

/***/ }),
/* 912 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return initAppPhuketLagunaPark2; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_reduce__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_reduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_reduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_actionType__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_phuket_laguna_park_2__ = __webpack_require__(913);
var _this=this;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var initAppPhuketLagunaPark2=function initAppPhuketLagunaPark2(){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch){var listApi,apiResult,mapData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:listApi=[];_context.t0=listApi;_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_3__services_phuket_laguna_park_2__["c" /* fetchGalleryApi */])();case 4:_context.t1=_context.sent;_context.t2={key:"gallery",data:_context.t1};_context.t0.push.call(_context.t0,_context.t2);_context.t3=listApi;_context.next=10;return Object(__WEBPACK_IMPORTED_MODULE_3__services_phuket_laguna_park_2__["a" /* fetchConceptApi */])();case 10:_context.t4=_context.sent;_context.t5={key:"concept",data:_context.t4};_context.t3.push.call(_context.t3,_context.t5);_context.t6=listApi;_context.next=16;return Object(__WEBPACK_IMPORTED_MODULE_3__services_phuket_laguna_park_2__["d" /* fetchMasterPlanApi */])();case 16:_context.t7=_context.sent;_context.t8={key:"masterPlan",data:_context.t7};_context.t6.push.call(_context.t6,_context.t8);_context.t9=listApi;_context.next=22;return Object(__WEBPACK_IMPORTED_MODULE_3__services_phuket_laguna_park_2__["g" /* fetchSitePlanApi */])();case 22:_context.t10=_context.sent;_context.t11={key:"sitePlan",data:_context.t10};_context.t9.push.call(_context.t9,_context.t11);_context.t12=listApi;_context.next=28;return Object(__WEBPACK_IMPORTED_MODULE_3__services_phuket_laguna_park_2__["e" /* fetchResidenceApi */])();case 28:_context.t13=_context.sent;_context.t14={key:"residence",data:_context.t13};_context.t12.push.call(_context.t12,_context.t14);_context.t15=listApi;_context.next=34;return Object(__WEBPACK_IMPORTED_MODULE_3__services_phuket_laguna_park_2__["b" /* fetchDestinationApi */])();case 34:_context.t16=_context.sent;_context.t17={key:"destination",data:_context.t16};_context.t15.push.call(_context.t15,_context.t17);_context.t18=listApi;_context.next=40;return Object(__WEBPACK_IMPORTED_MODULE_3__services_phuket_laguna_park_2__["f" /* fetchSanctuaryClubApi */])();case 40:_context.t19=_context.sent;_context.t20={key:"sanctuaryClub",data:_context.t19};_context.t18.push.call(_context.t18,_context.t20);_context.prev=43;_context.next=46;return Promise.all(listApi);case 46:apiResult=_context.sent;mapData=__WEBPACK_IMPORTED_MODULE_1_lodash_reduce___default()(apiResult,function(result,value,index){var key=value.key,data=value.data;return Object.assign({},result,_defineProperty({},key,data));},{});dispatch({type:__WEBPACK_IMPORTED_MODULE_2__actions_actionType__["f" /* RECEIVE_PHUKET_LAGUNA_PARK_2 */],data:mapData});_context.next=54;break;case 51:_context.prev=51;_context.t21=_context["catch"](43);console.error("initAppPhuketLagunaPark2 err",_context.t21);case 54:case"end":return _context.stop();}}},_callee,_this,[[43,51]]);}));return function(_x){return _ref.apply(this,arguments);};}();};

/***/ }),
/* 913 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchGalleryApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchConceptApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchMasterPlanApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return fetchSitePlanApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fetchResidenceApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchDestinationApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fetchSanctuaryClubApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_PhuketLagunaPark2_gallery__ = __webpack_require__(914);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_PhuketLagunaPark2_concept__ = __webpack_require__(915);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_PhuketLagunaPark2_masterplan__ = __webpack_require__(916);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_PhuketLagunaPark2_sitePlan__ = __webpack_require__(917);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_PhuketLagunaPark2_residence__ = __webpack_require__(918);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_PhuketLagunaPark2_destination__ = __webpack_require__(919);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_PhuketLagunaPark2_sanctuaryClub__ = __webpack_require__(920);
var fetchGalleryApi=function fetchGalleryApi(){return Promise.resolve(__WEBPACK_IMPORTED_MODULE_0__data_PhuketLagunaPark2_gallery__["a" /* default */]);};var fetchConceptApi=function fetchConceptApi(){return Promise.resolve(__WEBPACK_IMPORTED_MODULE_1__data_PhuketLagunaPark2_concept__["a" /* default */]);};var fetchMasterPlanApi=function fetchMasterPlanApi(){return Promise.resolve(__WEBPACK_IMPORTED_MODULE_2__data_PhuketLagunaPark2_masterplan__["a" /* default */]);};var fetchSitePlanApi=function fetchSitePlanApi(){return Promise.resolve(__WEBPACK_IMPORTED_MODULE_3__data_PhuketLagunaPark2_sitePlan__["a" /* default */]);};var fetchResidenceApi=function fetchResidenceApi(){return Promise.resolve(__WEBPACK_IMPORTED_MODULE_4__data_PhuketLagunaPark2_residence__["a" /* default */]);};var fetchDestinationApi=function fetchDestinationApi(){return Promise.resolve(__WEBPACK_IMPORTED_MODULE_5__data_PhuketLagunaPark2_destination__["a" /* default */]);};var fetchSanctuaryClubApi=function fetchSanctuaryClubApi(){return Promise.resolve(__WEBPACK_IMPORTED_MODULE_6__data_PhuketLagunaPark2_sanctuaryClub__["a" /* default */]);};

/***/ }),
/* 914 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_find__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(2);
var baseAssetUrl=Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])("phuket-laguna-park-2");var baseAssetVideoUrl=baseAssetUrl+"/videos";var aerialImg1=baseAssetUrl+"/images/gallery/aerial/Aerial 1.jpg";var aerialImg2=baseAssetUrl+"/images/gallery/aerial/Aerial 2.jpg";var aerialImg3=baseAssetUrl+"/images/gallery/aerial/Aerial 3.jpg";var commonAreaImg1=baseAssetUrl+"/images/gallery/common-area/Common Area 1.jpg";var commonAreaImg2=baseAssetUrl+"/images/gallery/common-area/Common Area 2.jpg";var commonAreaImg3=baseAssetUrl+"/images/gallery/common-area/Common Area 3.jpg";var commonAreaImg4=baseAssetUrl+"/images/gallery/common-area/Common Area 4.jpg";var destinationLifestyleImg1=baseAssetUrl+"/images/gallery/destination-lifestyle/Destination - lifestyle 1.jpg";var destinationLifestyleImg2=baseAssetUrl+"/images/gallery/destination-lifestyle/Destination - lifestyle 2.jpg";var destinationLifestyleImg3=baseAssetUrl+"/images/gallery/destination-lifestyle/Destination - lifestyle 3.jpg";var destinationLifestyleImg4=baseAssetUrl+"/images/gallery/destination-lifestyle/Destination - lifestyle 4.jpg";var destinationLifestyleImg5=baseAssetUrl+"/images/gallery/destination-lifestyle/Destination - lifestyle 5.jpg";var destinationLifestyleImg6=baseAssetUrl+"/images/gallery/destination-lifestyle/Destination - lifestyle 6.jpg";var destinationLifestyleImg7=baseAssetUrl+"/images/gallery/destination-lifestyle/Destination - lifestyle 7.jpg";var destinationLifestyleImg8=baseAssetUrl+"/images/gallery/destination-lifestyle/Destination - lifestyle 8.jpg";var destinationLifestyleImg9=baseAssetUrl+"/images/gallery/destination-lifestyle/Destination - lifestyle 9.jpg";var destinationLifestyleImg10=baseAssetUrl+"/images/gallery/destination-lifestyle/Destination - lifestyle 10.jpg";var exteriorImg1=baseAssetUrl+"/images/gallery/exterior/Exterior Townhome 1.jpg";var exteriorImg2=baseAssetUrl+"/images/gallery/exterior/Exterior Townhome 2.jpg";var exteriorImg3=baseAssetUrl+"/images/gallery/exterior/Exterior Townhome 3.jpg";var exteriorImg4=baseAssetUrl+"/images/gallery/exterior/Exterior Villa 1.jpg";var exteriorImg5=baseAssetUrl+"/images/gallery/exterior/Exterior Villa 2.jpg";var exteriorImg6=baseAssetUrl+"/images/gallery/exterior/Exterior Villa 3.jpg";var exteriorImg7=baseAssetUrl+"/images/gallery/exterior/Exterior Villa 4.jpg";var exteriorImg8=baseAssetUrl+"/images/gallery/exterior/Exterior.jpg";var interiorImg1=baseAssetUrl+"/images/gallery/interior/Interior Townhome Bedroom.jpg";var interiorImg2=baseAssetUrl+"/images/gallery/interior/Interior Townhome Living Room.jpg";var interiorImg3=baseAssetUrl+"/images/gallery/interior/Interior Villa Bedroom.jpg";var interiorImg4=baseAssetUrl+"/images/gallery/interior/Interior Villa Living Room.jpg";var residencesLifestyleImg1=baseAssetUrl+"/images/gallery/residences-lifestyle/Residences-lifestyle 1.jpg";var residencesLifestyleImg2=baseAssetUrl+"/images/gallery/residences-lifestyle/Residences-lifestyle 2.jpg";var residencesLifestyleImg3=baseAssetUrl+"/images/gallery/residences-lifestyle/Residences-lifestyle 3.jpg";var residencesLifestyleImg4=baseAssetUrl+"/images/gallery/residences-lifestyle/Residences-lifestyle 4.jpg";var residencesLifestyleImg5=baseAssetUrl+"/images/gallery/residences-lifestyle/Residences-lifestyle 5.jpg";var heroShotImg1=baseAssetUrl+"/images/gallery/hero-shot/001.LP2-Exterior-Townhomes-003.jpg";var heroShotImg2=baseAssetUrl+"/images/gallery/hero-shot/002.LP2-Exterior-Villas-004.jpg";var heroShotImg3=baseAssetUrl+"/images/gallery/hero-shot/003.LP2-Exterior-Villas-006.jpg";var heroShotImg4=baseAssetUrl+"/images/gallery/hero-shot/004.LP2-Exterior-Villas-007.jpg";var heroShotImg5=baseAssetUrl+"/images/gallery/hero-shot/006.LP2-Interior-Villas Living room-004.jpg";var heroShotImg6=baseAssetUrl+"/images/gallery/hero-shot/007.LP2-Interior-Villas Bedroom-003.jpg";var heroShotImg7=baseAssetUrl+"/images/gallery/hero-shot/008.LP2-Interior-Townhomes Living room-002.jpg";var heroShotImg8=baseAssetUrl+"/images/gallery/hero-shot/009.LP2-Interior-Townhomes Bedroom-001.jpg";// const residencesAerial1 = `${baseAssetUrl}/images/gallery/images/aerial/1.jpg`;
// const residencesAerial2 = `${baseAssetUrl}/images/gallery/images/aerial/2.jpg`;
// const residencesAerial3 = `${baseAssetUrl}/images/gallery/images/aerial/3.jpg`;
// const residencesExterior1 = `${baseAssetUrl}/images/gallery/images/exterior/1.jpg`;
// const residencesExterior2 = `${baseAssetUrl}/images/gallery/images/exterior/2.jpg`;
// const residencesExterior3 = `${baseAssetUrl}/images/gallery/images/exterior/3.jpg`;
// const residencesExterior4 = `${baseAssetUrl}/images/gallery/images/exterior/4.jpg`;
// const residencesExterior5 = `${baseAssetUrl}/images/gallery/images/exterior/5.jpg`;
// const residencesExterior6 = `${baseAssetUrl}/images/gallery/images/exterior/6.jpg`;
// const residencesExterior7 = `${baseAssetUrl}/images/gallery/images/exterior/7.jpg`;
// const residencesExterior8 = `${baseAssetUrl}/images/gallery/images/exterior/8.jpg`;
// const residencesInterior1 = `${baseAssetUrl}/images/gallery/images/interior/1.jpg`;
// const residencesInterior2 = `${baseAssetUrl}/images/gallery/images/interior/2.jpg`;
// const residencesInterior3 = `${baseAssetUrl}/images/gallery/images/interior/3.jpg`;
// const residencesInterior4 = `${baseAssetUrl}/images/gallery/images/interior/4.jpg`;
// const residencesCommonArea1 = `${baseAssetUrl}/images/gallery/images/common-area/1.jpg`;
// const residencesCommonArea2 = `${baseAssetUrl}/images/gallery/images/common-area/2.jpg`;
// const residencesCommonArea3 = `${baseAssetUrl}/images/gallery/images/common-area/3.jpg`;
// const residencesCommonArea4 = `${baseAssetUrl}/images/gallery/images/common-area/4.jpg`;
// const residencesLifestyle1 = `${baseAssetUrl}/images/gallery/images/residences-lifestyle/1.jpg`;
// const residencesLifestyle2 = `${baseAssetUrl}/images/gallery/images/residences-lifestyle/2.jpg`;
// const residencesLifestyle3 = `${baseAssetUrl}/images/gallery/images/residences-lifestyle/3.jpg`;
// const residencesLifestyle4 = `${baseAssetUrl}/images/gallery/images/residences-lifestyle/4.jpg`;
// const residencesLifestyle5 = `${baseAssetUrl}/images/gallery/images/residences-lifestyle/5.jpg`;
// const destinationLifestyle1 = `${baseAssetUrl}/images/gallery/images/destination-lifestyle/1.jpg`;
// const destinationLifestyle2 = `${baseAssetUrl}/images/gallery/images/destination-lifestyle/2.jpg`;
// const destinationLifestyle3 = `${baseAssetUrl}/images/gallery/images/destination-lifestyle/3.jpg`;
// const destinationLifestyle4 = `${baseAssetUrl}/images/gallery/images/destination-lifestyle/4.jpg`;
// const destinationLifestyle5 = `${baseAssetUrl}/images/gallery/images/destination-lifestyle/5.jpg`;
// const destinationLifestyle6 = `${baseAssetUrl}/images/gallery/images/destination-lifestyle/6.jpg`;
// const destinationLifestyle7 = `${baseAssetUrl}/images/gallery/images/destination-lifestyle/7.jpg`;
// const destinationLifestyle8 = `${baseAssetUrl}/images/gallery/images/destination-lifestyle/8.jpg`;
// const destinationLifestyle9 = `${baseAssetUrl}/images/gallery/images/destination-lifestyle/9.jpg`;
// const destinationLifestyle10 = `${baseAssetUrl}/images/gallery/images/destination-lifestyle/10.jpg`;
var video={en:baseAssetVideoUrl+"/Laguna Park 2 - 3D flythrough_Trilingual_Dec 2019_LowRes.mp4",ru:baseAssetVideoUrl+"/Laguna Park 2 - 3D flythrough_Trilingual_Dec 2019_LowRes.mp4",cn:baseAssetVideoUrl+"/Laguna Park 2 - 3D flythrough_Trilingual_Dec 2019_LowRes.mp4"};// const videos = [
//   {
//     titleKey: "propertyVideo",
//     source: {
//       en: `${baseAssetVideoUrl}/video/LP2_2_16x9_EN_Compress.mp4`,
//       ru: `${baseAssetVideoUrl}/video/LP2_2_16x9_EN_Compress.mp4`,
//       cn: `${baseAssetVideoUrl}/video/LP2_2_16x9_EN_Compress.mp4`,
//     },
//     text: {
//       en: ["PROPERTY VIDEO"],
//       cn: ["项目视频"],
//       ru: ["ВИДЕО ПРОЕКТА"],
//     },
//   },
//   {
//     titleKey: "interiorTownHomeVideo",
//     source: {
//       en: `${baseAssetVideoUrl}/images/gallery/video/2.jpg`,
//       ru: `${baseAssetVideoUrl}/images/gallery/video/2.jpg`,
//       cn: `${baseAssetVideoUrl}/images/gallery/video/2.jpg`,
//     },
//     text: {
//       en: ["TOWNHOME"],
//       cn: ["联排别墅"],
//       ru: ["ТАУНХАУСЫ"],
//     },
//   },
//   {
//     titleKey: "interiorVillaVideo",
//     source: {
//       en: `${baseAssetVideoUrl}/images/gallery/video/3.jpg`,
//       ru: `${baseAssetVideoUrl}/images/gallery/video/3.jpg`,
//       cn: `${baseAssetVideoUrl}/images/gallery/video/3.jpg`,
//     },
//     text: {
//       en: ["VILLA"],
//       cn: ["独栋别墅"],
//       ru: ["Виллы"],
//     },
//   },
// ];
var heroShot=[{image:heroShotImg1},{image:heroShotImg2},{image:heroShotImg3},{image:heroShotImg4},{image:heroShotImg5},{image:heroShotImg6},{image:heroShotImg7},{image:heroShotImg8}];var categories=[{id:1,name:"All Images"},{id:2,name:"Aerial"},{id:3,name:"Exterior"},{id:4,name:"Interior"},{id:5,name:"Common Area"},{id:6,name:"Residences - Lifestyle"},{id:7,name:"Destination - Lifestyle"}];var images=[{categoryId:2,name:"Aerial - 1",image:aerialImg1},{categoryId:2,name:"Aerial - 2",image:aerialImg2},{categoryId:2,name:"Aerial - 3",image:aerialImg3},{categoryId:3,name:"Exterior",image:exteriorImg1},{categoryId:3,name:"Exterior Townhome 1",image:exteriorImg2},{categoryId:3,name:"Exterior Townhome 2",image:exteriorImg3},{categoryId:3,name:"Exterior Townhome 3",image:exteriorImg4},{categoryId:3,name:"Exterior Villa 1",image:exteriorImg5},{categoryId:3,name:"Exterior Villa 2",image:exteriorImg6},{categoryId:3,name:"Exterior Villa 3",image:exteriorImg7},{categoryId:3,name:"Exterior Villa 4",image:exteriorImg8},{categoryId:4,name:"Interior Townhome Bedroom",image:interiorImg1},{categoryId:4,name:"Interior Townhome Living Room",image:interiorImg2},{categoryId:4,name:"Interior Villa Bedroom",image:interiorImg3},{categoryId:4,name:"Interior Villa Living Room",image:interiorImg4},{categoryId:5,name:"Common Area - 1",image:commonAreaImg1},{categoryId:5,name:"Common Area - 2",image:commonAreaImg2},{categoryId:5,name:"Common Area - 3",image:commonAreaImg3},{categoryId:5,name:"Common Area - 4",image:commonAreaImg4},{categoryId:6,name:"Lifestyle - 1",image:residencesLifestyleImg1},{categoryId:6,name:"Lifestyle - 2",image:residencesLifestyleImg2},{categoryId:6,name:"Lifestyle - 3",image:residencesLifestyleImg3},{categoryId:6,name:"Lifestyle - 4",image:residencesLifestyleImg4},{categoryId:6,name:"Lifestyle - 5",image:residencesLifestyleImg5},{categoryId:7,name:"destination - 1",image:destinationLifestyleImg1},{categoryId:7,name:"destination - 2",image:destinationLifestyleImg2},{categoryId:7,name:"destination - 3",image:destinationLifestyleImg3},{categoryId:7,name:"destination - 4",image:destinationLifestyleImg4},{categoryId:7,name:"destination - 5",image:destinationLifestyleImg5},{categoryId:7,name:"destination - 6",image:destinationLifestyleImg6},{categoryId:7,name:"destination - 7",image:destinationLifestyleImg7},{categoryId:7,name:"destination - 8",image:destinationLifestyleImg8},{categoryId:7,name:"destination - 9",image:destinationLifestyleImg9},{categoryId:7,name:"destination - 10",image:destinationLifestyleImg10}];var image360=null;/* harmony default export */ __webpack_exports__["a"] = ({heroShot:heroShot,categories:categories,images:__WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(images,function(image){return Object.assign({},image,{category:__WEBPACK_IMPORTED_MODULE_0_lodash_find___default()(categories,{id:image.categoryId})});}),video:video,image360:image360,view360:[// {
//   id: "AERIAL",
//   type: "list",
//   src: `${baseAssetUrl}/360/aerial_perspective.jpg`,
//   list: [],
// },
// {
//   id: "INTERIOR",
//   type: "hidden",
//   src: `${baseAssetUrl}/360/interior/index.html`,
//   // src: "https://forviz.com/virtual-tour/lagunapark2-interior-virtual-tour/",
//   // src:
//   //   "https://edm.lagunaproperty.com/2022/lagunapark2-interior-virtual-tour/index.htm",
//   // type: "list",
//   // src: `${assetsPath(
//   //   "phuket-laguna-park-2"
//   // )}/images/gallery/virtual-tour/1.jpg`,
//   // list: [
//   //   {
//   //     id: "SEMI-DETACHED",
//   //     target: "_blank",
//   //     src: (
//   //       <div
//   //         style={{
//   //           display: "flex",
//   //           justifyContent: "center",
//   //           alignItems: "center",
//   //           width: "100%",
//   //           height: "100%",
//   //         }}
//   //       />
//   //     ),
//   //   },
//   //   {
//   //     id: "TOWNHOME",
//   //     target: "_blank",
//   //     src: (
//   //       <div
//   //         style={{
//   //           display: "flex",
//   //           justifyContent: "center",
//   //           alignItems: "center",
//   //           width: "100%",
//   //           height: "100%",
//   //         }}
//   //       />
//   //     ),
//   //   },
//   // ],
// },
{id:"INTERIOR",type:"list",list:[{id:"VILLA",target:"_blank",src:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("iframe",{width:"100%",height:"100%",src:"https://my.matterport.com/show/?m=RzGenJ177tk",frameborder:"0",allowfullscreen:true,allow:"vr"}),href:"https://my.matterport.com/show/?m=RzGenJ177tk"},{id:"TOWNHOME",target:"_blank",src:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("iframe",{width:"100%",height:"100%",src:"https://my.matterport.com/show/?m=CY6oRgpAriw",frameborder:"0",allowfullscreen:true,allow:"vr"}),href:"https://my.matterport.com/show/?m=CY6oRgpAriw"}]}]});

/***/ }),
/* 915 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(2);
var baseAssetUrl=Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])("phuket-laguna-park-2");var img1=baseAssetUrl+"/images/concept/1. LP2-Exterior-Villas-007.jpg";var img2=baseAssetUrl+"/images/concept/2. LP2-Exterior-Townhomes-003.jpg";var img3=baseAssetUrl+"/images/concept/3. LP2-Exterior-Townhomes-002.jpg";var img4=baseAssetUrl+"/images/concept/4. LP2-Interior-Townhomes Living room-002.jpg";var img5=baseAssetUrl+"/images/concept/5. LP2-Interior-Townhomes Bedroom-001.jpg";var imageSlider=[{image:img1},{image:img2},{image:img3},{image:img4},{image:img5}];var content={en:"<p>Phuket\u2019s most desired residential neighbourhood</p>\n    <br />\n    <p>Nestled amongst tropical greenery in a gated estate, the new Laguna Park 2 is located adjacent to Laguna Phuket, the 1,000-acre integrated resort complex along a three- kilometre stretch of pristine beach at Bang Tao Bay.</p>\n    <br />\n    <p>The contemporary-styled townhomes and villas provide spacious living areas in a secure, gated environment which will include 24-hour security, recreational and communal facilities and professional property management services by Laguna.</p>",cn:"<p>\u666E\u5409\u5C9B\u6700\u53D7\u9752\u7750\u7684\u4F4F\u5B85\u533A</p>\n    <br />\n    <p>\u65B0\u63A8\u51FA\u7684\u4E50\u53E4\u6D6A\u7199\u56ED\u4E8C\u671F\u9879\u76EE\u5750 \u843D\u5728\u90C1\u90C1\u8471\u8471\u7684\u70ED\u5E26\u8349\u6728\u4E4B\u4E2D\uFF0C \u4F4D\u4E8E\u666E\u5409\u5C9B\u4E50\u53E4\u6D6A\uFF0C\u8FD9\u4E2A1000\u82F1 \u4EA9\u7684\u7EFC\u5408\u5EA6\u5047\u80DC\u5730\u5728\u90A6\u9053\u6E7E\u539F\u59CB \u53E4\u6734\u7684\u6D77\u6EE9\u4E0A\u7EF5\u5EF6\u4E09\u516C\u91CC\u3002</p>\n    <br />\n    <p>\u73B0\u4EE3\u98CE\u683C\u7684\u8054\u6392\u522B\u5885\u548C\u72EC\u680B\u522B\u5885\u5728\u5B89\u5168\u7684\u5C01\u95ED\u5F0F\u73AF\u5883\u4E2D\u63D0\u4F9B\u4E86\u5BBD\u655E\u7684\u5C45\u4F4F\u7A7A\u95F4\uFF0C\u5305\u62EC\u4E8C\u5341\u56DB\u5C0F\u65F6\u5B89\u4FDD\u3001\u5A31\u4E50\u548C\u516C\u5171\u8BBE\u65BD\u4EE5\u53CA\u4E50\u53E4\u6D6A\u63D0\u4F9B\u7684\u4E13\u4E1A\u7269\u4E1A\u7BA1\u7406\u670D\u52A1</p>",ru:"<p>\u0421\u0430\u043C\u044B\u0439 \u0436\u0435\u043B\u0430\u043D\u043D\u044B\u0439 \u0436\u0438\u043B\u043E\u0439 \u0440\u0430\u0439\u043E\u043D \u043D\u0430 \u041F\u0445\u0443\u043A\u0435\u0442\u0435</p>\n    <br />\n    <p>\u041D\u043E\u0432\u044B\u0439 \u043E\u0445\u0440\u0430\u043D\u044F\u0435\u043C\u044B\u0439 \u0436\u0438\u043B\u043E\u0439 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0441 Laguna Park \u0424\u0430\u0437\u0430 2 \u0440\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D \u0441\u0440\u0435\u0434\u0438 \u043F\u044B\u0448\u043D\u043E\u0439 \u0442\u0440\u043E\u043F\u0438\u0447\u0435\u0441\u043A\u043E\u0439 \u0437\u0435\u043B\u0435\u043D\u0438 \u043F\u043E \u0441\u043E\u0441\u0435\u0434\u0441\u0442\u0432\u0443 \u0441 \u0443\u0434\u043E\u0441\u0442\u043E\u0435\u043D\u043D\u044B\u043C \u043C\u043D\u043E\u0436\u0435\u0441\u0442\u0432\u0430 \u043D\u0430\u0433\u0440\u0430\u0434 \u043A\u0443\u0440\u043E\u0440\u0442\u043D\u044B\u043C \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0441\u043E\u043C Laguna Phuket, \u0437\u0430\u043D\u0438\u043C\u0430\u044E\u0449\u0438\u043C 1000 \u0430\u043A\u0440\u043E\u0432, \u043F\u0440\u043E\u0441\u0442\u0438\u0440\u0430\u044E\u0449\u0438\u0445\u0441\u044F \u0432\u0434\u043E\u043B\u044C \u0447\u0438\u0441\u0442\u0435\u0439\u0448\u0435\u0433\u043E \u043F\u043B\u044F\u0436\u0430 \u0411\u0430\u043D\u0433 \u0422\u0430\u043E.</p>\n    <br />\n    <p>\u0421\u043E\u0437\u0434\u0430\u043D\u043D\u044B\u0435 \u0432 \u0441\u043E\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E\u043C \u0441\u0442\u0438\u043B\u0435 \u0442\u0430\u0443\u043D\u0445\u0430\u0443\u0441\u044B \u0438 \u0432\u0438\u043B\u043B\u044B \u043E\u0442\u043B\u0438\u0447\u0430\u044E\u0442\u0441\u044F \u043F\u0440\u043E\u0441\u0442\u043E\u0440\u043D\u044B\u043C\u0438 \u0436\u0438\u043B\u044B\u043C\u0438 \u043F\u043E\u043C\u0435\u0449\u0435\u043D\u0438\u044F\u043C\u0438 \u0438 \u0440\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u0435\u043C \u043D\u0430 \u0431\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0439 \u0442\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u0438 \u043F\u043E\u0434 \u043A\u0440\u0443\u0433\u043B\u043E\u0441\u0443\u0442\u043E\u0447\u043D\u043E\u0439 \u043E\u0445\u0440\u0430\u043D\u043E\u0439. \u0414\u043E\u0441\u0442\u0443\u043F\u043D\u044B \u043C\u0435\u0441\u0442\u0430 \u0434\u043B\u044F \u043E\u0442\u0434\u044B\u0445\u0430 \u043E\u0431\u0449\u0435\u0433\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F, \u0430 \u0442\u0430\u043A\u0436\u0435 \u0443\u0441\u043B\u0443\u0433\u0438 \u043F\u043E \u043F\u0440\u043E\u0444\u0435\u0441\u0441\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u043E\u043C\u0443 \u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044E \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u044C\u044E, \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u043C\u044B\u0435 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0441\u043E\u043C Laguna.</p>"};/* harmony default export */ __webpack_exports__["a"] = ({imageSlider:imageSlider,content:content});

/***/ }),
/* 916 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(2);
var baseAssetUrl=Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])("phuket-laguna-park-2");var maps=baseAssetUrl+"/images/master-plan/image.jpg";/* harmony default export */ __webpack_exports__["a"] = ({maps:maps});

/***/ }),
/* 917 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(2);
var baseAssetUrl=Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])("phuket-laguna-park-2");var maps=baseAssetUrl+"/images/site-plan/image.jpg";var type=[{value:"all",title:{en:"ALL",ru:"ALL",cn:"ALL"}},{value:"townhome",title:{en:"TOWNHOMES",ru:"Таунхаусы",cn:"联排别墅"}},{value:"villa",title:{en:"VILLAS",ru:"Виллы",cn:"独栋别墅"}}];var descriptions=[{value:"Villas",title:{en:"Offering generous and practical spaces for larger families, the three- storey villas sit on larger land plots averaging 375 sqm in size. Villas come with three to five bedrooms, as well as multiple living spaces and maid’s quarters with a separate entrance.",cn:"乐古浪熙园的三层独栋别墅空间更 加宽敞实用，平均面积375平方米， 适合更大的家庭。独栋别墅提供了 三间至五间卧室，此外还包括多功 能起居空间和一间拥有单独入口的 保姆房。",ru:"Трехэтажные виллы отличаются исключительной просторностью и практичностью, необходимые большим семьям. Площадь прилегающего участка в среднем составляет 375 кв.м. Виллы включают в себя три-пять спален, множество жилых помещений и помещение для прислуги с отдельным входом."}},{value:"Townhomes",title:{en:"The three-storey townhomes at Laguna Park offer on average 220 sqm of space to live, work, play, and gather. Townhomes come with two or three bedrooms.",cn:"乐古浪熙园的三层联排别墅平均面 积220平方米，适合休息、工作、 玩乐和聚会。联排别墅提供了两间 或三间卧室。",ru:"Жилая площадь трехэтажных таунхаусов, расположенных в комплексе Laguna Park, составляет 220 кв. м. Это предоставляет множество возможностей для отдыха, работы, игр и встреч. Таунхаусы включают в себя две или три спальни."}}];/* harmony default export */ __webpack_exports__["a"] = ({maps:"",type:type,descriptions:descriptions});

/***/ }),
/* 918 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(2);
var baseAssetUrl=Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])("phuket-laguna-park-2");var landingPage=[{image:baseAssetUrl+"/images/residence/landing-page/LP2-Exterior-008.jpg"},{image:baseAssetUrl+"/images/residence/landing-page/LP2-Exterior-Townhomes-001.jpg"},{image:baseAssetUrl+"/images/residence/landing-page/LP2-Exterior-Townhomes-003.jpg"},{image:baseAssetUrl+"/images/residence/landing-page/LP2-Exterior-Villas-004.jpg"},{image:baseAssetUrl+"/images/residence/landing-page/LP2-Exterior-Villas-007.jpg"}];var type=[{name:"Townhomes",thumbnail:[{image:baseAssetUrl+"/images/residence/thumbnail/Townhomes-Thumbnail.jpg"},{image:baseAssetUrl+"/images/residence/thumbnail/Townhomes-Thumbnail.jpg"}],buttons:[{type:"description",value:0,name:"Description",title:"Description",description:{en:"<p>The three-storey townhomes at Laguna Park offer on average 220 sqm of space to live, work, play, and gather. Townhomes come with two or three bedrooms.</p>",cn:"<p>乐古浪熙园的三层联排别墅 平均面积220平方米，适合 休息、工作、玩乐和聚会。 联排别墅提供了两间或三间 卧室。</p>",ru:"<p>Жилая площадь трехэтажных таунхаусов, расположенных в комплексе Laguna Park, составляет 220 кв. м. Это предоставляет множество возможностей для отдыха, работы, игр и встреч. Таунхаусы включают в себя две или три спальни.</p>"},images:[{image:baseAssetUrl+"/images/residence/description/townhome/LP2-Exterior-Townhomes-001.jpg"},{image:baseAssetUrl+"/images/residence/description/townhome/LP2-Exterior-Townhomes-002.jpg"},{image:baseAssetUrl+"/images/residence/description/townhome/LP2-Exterior-Townhomes-003.jpg"},{image:baseAssetUrl+"/images/residence/description/townhome/LP2-Interior-Townhomes Bedroom-001.jpg"},{image:baseAssetUrl+"/images/residence/description/townhome/LP2-Interior-Townhomes Living room-002.jpg"}]},{type:"plan",name:"Ground Floor (Standard)",value:1,floorPlan:{en:baseAssetUrl+"/images/residence/floor-plan/townhome/en/sg.png",ru:baseAssetUrl+"/images/residence/floor-plan/townhome/ru/sg.png",cn:baseAssetUrl+"/images/residence/floor-plan/townhome/cn/sg.png"},images:[{image:baseAssetUrl+"/images/residence/floor-plan/townhome/ground-floor-(standard).jpg"}],image360:[{x:950,y:500}],imageVirtual:[{x:1000,y:640,path:baseAssetUrl+"/360/townhome/LP2-ST-TH-Living.html"}]},{type:"plan",name:"Ground Floor (Deluxe – Upgrade)",value:2,floorPlan:{en:baseAssetUrl+"/images/residence/floor-plan/townhome/en/dg.png",ru:baseAssetUrl+"/images/residence/floor-plan/townhome/ru/dg.png",cn:baseAssetUrl+"/images/residence/floor-plan/townhome/cn/dg.png"},images:[{image:baseAssetUrl+"/images/residence/floor-plan/townhome/ground-floor-(deluxe-upgrade).jpg"}],image360:[{x:950,y:460}],imageVirtual:[{x:980,y:600,path:baseAssetUrl+"/360/townhome/LP2-DLX-TH-PL.html"}]},{type:"plan",name:"1 st Floor",value:3,floorPlan:{en:baseAssetUrl+"/images/residence/floor-plan/townhome/en/s1.png",ru:baseAssetUrl+"/images/residence/floor-plan/townhome/ru/s1.png",cn:baseAssetUrl+"/images/residence/floor-plan/townhome/cn/s1.png"},images:[{image:baseAssetUrl+"/images/residence/floor-plan/townhome/1-floor-(standard).jpg"}],image360:[{x:1030,y:700}],imageVirtual:[{x:950,y:700,path:baseAssetUrl+"/360/townhome/LP2-ST-TH-MB.html"}]},{type:"plan",name:"2 nd Floor (Standard)",value:4,floorPlan:{en:baseAssetUrl+"/images/residence/floor-plan/townhome/en/s2.png",ru:baseAssetUrl+"/images/residence/floor-plan/townhome/ru/s2.png",cn:baseAssetUrl+"/images/residence/floor-plan/townhome/cn/s2.png"},images:[],image360:[],imageVirtual:[{x:990,y:610,path:baseAssetUrl+"/360/townhome/LP2-ST-TH-RF.html"}]},{type:"plan",name:"2 nd Floor (Deluxe – Upgrade)",value:5,floorPlan:{en:baseAssetUrl+"/images/residence/floor-plan/townhome/en/d2.png",ru:baseAssetUrl+"/images/residence/floor-plan/townhome/ru/d2.png",cn:baseAssetUrl+"/images/residence/floor-plan/townhome/cn/d2.png"},images:[],image360:[],imageVirtual:[{x:1030,y:570,// y: 520,
path:baseAssetUrl+"/360/townhome/LP2-DLX-TH-MPR.html"}]}]},{name:"Villas",thumbnail:[{image:baseAssetUrl+"/images/residence/thumbnail/Villa Thumbnail.jpg"},{image:baseAssetUrl+"/images/residence/thumbnail/Villa Thumbnail.jpg"}],buttons:[{type:"description",value:0,name:"Description",title:"Description",description:{en:"<p>Offering generous and practical spaces for larger families, the three-storey villas sit on larger land plots averaging 375 sqm in size. Villas come with three to five bedrooms, as well as multiple living spaces and maid’s quarters with a separate entrance.</p>",cn:"<p>乐古浪熙园的三层独栋别墅 空间更加宽敞实用，平均面 积375平方米，适合更大的家 庭。独栋别墅提供了三间至 五间卧室，此外还包括多功 能起居空间和一间拥有单独 入口的保姆房。</p>",ru:"<p>Трехэтажные виллы отличаются исключительной просторностью и практичностью, необходимые большим семьям. Площадь прилегающего участка в среднем составляет 375 кв.м. Виллы включают в себя три- пять спален, множество жилых помещений и помещение для прислуги с отдельным входом.</p>"},images:[{image:baseAssetUrl+"/images/residence/description/villa/LP2-Exterior-Villas-004.jpg"},{image:baseAssetUrl+"/images/residence/description/villa/LP2-Exterior-Villas-006.jpg"},{image:baseAssetUrl+"/images/residence/description/villa/\tLP2-Exterior-Villas-007.jpg"},{image:baseAssetUrl+"/images/residence/description/villa/LP2-Interior-Villas Bedroom-003.jpg"},{image:baseAssetUrl+"/images/residence/description/villa/LP2-Interior-Villas Living room-004.jpg"}]},{type:"plan",name:"Ground Floor (Standard)",value:1,floorPlan:{en:baseAssetUrl+"/images/residence/floor-plan/villa/en/sg.png",ru:baseAssetUrl+"/images/residence/floor-plan/villa/ru/sg.png",cn:baseAssetUrl+"/images/residence/floor-plan/villa/cn/sg.png"},images:[{image:baseAssetUrl+"/images/residence/floor-plan/villa/ground-floor-(standard).jpg"}],image360:[{x:950,y:500}],imageVirtual:[{x:1020,y:400,path:baseAssetUrl+"/360/villa/LP2-ST-VL-LIV.html"},{x:840,y:720,path:baseAssetUrl+"/360/villa/LP2-ST-VL-BR.html"}]},{type:"plan",name:"Ground Floor (Deluxe – Upgrade)",value:2,floorPlan:{en:baseAssetUrl+"/images/residence/floor-plan/villa/en/dg.png",ru:baseAssetUrl+"/images/residence/floor-plan/villa/ru/dg.png",cn:baseAssetUrl+"/images/residence/floor-plan/villa/cn/dg.png"},images:[{image:baseAssetUrl+"/images/residence/floor-plan/villa/ground-floor-(deluxe-upgrade).jpg"}],image360:[{x:950,y:420}],imageVirtual:[{x:920,y:730,path:baseAssetUrl+"/360/villa/LP2-DLX-VL-PL.html"}]},{type:"plan",name:"1 st Floor",value:3,floorPlan:{en:baseAssetUrl+"/images/residence/floor-plan/villa/en/s1.png",ru:baseAssetUrl+"/images/residence/floor-plan/villa/ru/s1.png",cn:baseAssetUrl+"/images/residence/floor-plan/villa/cn/s1.png"},images:[{image:baseAssetUrl+"/images/residence/floor-plan/villa/1-floor-(standard).jpg"}],image360:[{x:930,y:700}],imageVirtual:[{x:850,y:720,path:baseAssetUrl+"/360/villa/LP2-DLX-VL-MBR.html"},{x:1000,y:540,path:baseAssetUrl+"/360/villa/LP2-DLX-VL-FM.html"}]},{type:"plan",name:"2 nd Floor (Standard)",value:4,floorPlan:{en:baseAssetUrl+"/images/residence/floor-plan/villa/en/s2.png",ru:baseAssetUrl+"/images/residence/floor-plan/villa/ru/s2.png",cn:baseAssetUrl+"/images/residence/floor-plan/villa/cn/s2.png"},images:[],image360:[],imageVirtual:[{x:930,y:670,path:baseAssetUrl+"/360/villa/LP2-ST-VL-RF.html"}]},{type:"plan",name:"2 nd Floor (Deluxe – Upgrade)",value:5,floorPlan:{en:baseAssetUrl+"/images/residence/floor-plan/villa/en/d2.png",ru:baseAssetUrl+"/images/residence/floor-plan/villa/ru/d2.png",cn:baseAssetUrl+"/images/residence/floor-plan/villa/cn/d2.png"},images:[],image360:[],imageVirtual:[{x:1000,y:560,path:baseAssetUrl+"/360/villa/LP2-DLX-VL-MPR.html"}]}]}];/* harmony default export */ __webpack_exports__["a"] = ({landingPage:landingPage,type:type});

/***/ }),
/* 919 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(2);
var landingPage=[{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+'/images/destination/landing-page/1.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+'/images/destination/landing-page/2.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+'/images/destination/landing-page/3.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+'/images/destination/landing-page/4.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+'/images/destination/landing-page/5.jpg'}];var map=[{value:"country",name:"Country Map",image:{en:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+'/images/destination/country-map/map-country_en.png',cn:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+'/images/destination/country-map/map-country_cn.png',ru:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+'/images/destination/country-map/map-country_ru.png'}},{value:"city",name:"City Map",images:[{name:"Airport",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])()+'/images/icon/map-icon-01.png',image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+'/images/destination/city-map/airport.png'},{name:"Beaches",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])()+'/images/icon/map-icon-02.png',image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+'/images/destination/city-map/beach.png'},{name:"Islands",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])()+'/images/icon/map-icon-03.png',image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+'/images/destination/city-map/island.png'},{name:"Schools",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])()+'/images/icon/map-icon-05.png',image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+'/images/destination/city-map/school.png'},{name:"Tourist Attractions",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])()+'/images/icon/map-icon-06.png',image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+'/images/destination/city-map/tourist-attraction.png'}]},{value:"project",name:"Project Map",images:[{name:"Hotels & Resorts",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])()+'/images/icon/project-icon-01.png',svg:null},{name:"Restaurants",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])()+'/images/icon/project-icon-02.png',svg:null},{name:"Spas",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])()+'/images/icon/project-icon-03.png',svg:null},{name:"Galleries & Shopping",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])()+'/images/icon/project-icon-04.png',svg:null},{name:"Shuttle Bus",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])()+'/images/icon/project-icon-05.png',svg:null},{name:"Shuttle Boat",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])()+'/images/icon/project-icon-06.png',svg:null}]}];var content={title:"Destination",description:{en:"<p>Surrounded by the turquoise waters of the Andaman Sea and fringed by golden shores, Phuket is an island that compels travelers to visit from around the world.<br><br>Reaching Phuket is easy with direct flights from main cities around the world.The island is also linked to Thailand’s mainland by road.<br><br>Laguna Phuket itself is located in a prime west coast area of Phuket with proximity to an abundance of facilities. Local shopping malls, international schools and world-class hospitals are all close by, while Phuket’s international airport can be reached by car in just 25 minutes.<p>",cn:"<p>乐古浪普吉岛被金色海岸紧紧包围，四周萦绕着绿松石般的海水，这座岛屿吸引着世界各地的游客纷至沓来。<br><br>普吉岛的交通十分便捷，从世界主要城市搭乘直飞航班即可抵达。这里与泰国主岛相连，通过汽车或船只都可轻松到达。<br><br>乐古浪普吉岛位于普吉岛的西海岸，现代设施齐全。购物中心，国际学校，世界级医院随手可得，驱车25分钟即可到达普吉岛国际机场。<p>",ru:"<p>Остров Пхукет, окруженный лазурными водами Андаманского моря, омывающими золотистые песчаные пляжи, манит к себе путешественников со всего мира.<br><br>Добраться до острова очень просто: вылететь прямым рейсом можно из крупных городов разных стран. Из материковой части Таиланда сюда можно доехать на автомобиле по шоссейной дороге.<br><br>Курортный комплекс Laguna Phuket расположен на элитном западном побережье Пхукета. В непосредственной близости находится вся необходимая инфраструктура: торговые галереи, международные школы, больницы мирового уровня. До международного аэропорта Пхукета 25 минут езды на автомобиле.<p>"}};/* harmony default export */ __webpack_exports__["a"] = ({landingPage:landingPage,map:map,content:content});

/***/ }),
/* 920 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(2);
/* harmony default export */ __webpack_exports__["a"] = ({title:"The Santuary Club",description:{en:"Experience ultimate lifestyle within worldwide network under the Banyan Group. Membership is exclusively offered to the owners of Laguna, the Banyan Tree, Angsana and Cassia properties only.",cn:"体验悦榕集团全球网络内的精华生活方式。仅向乐古浪、悦榕庄、悦椿和悦庭物业的业主提供会员权益。",ru:"Наслаждайтесь роскошным стилем жизни, пользуясь глобальной сетью группы Banyan Group. Членство предлагается только владельцам собственности в рамках проектов Laguna, Banyan Group, Angsana и Cassia."},image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])("phuket-laguna-park-2")+"/images/the-sanctuary-club/image.jpg"});

/***/ }),
/* 921 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Gallery; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Gallery=function(_Component){_inherits(Gallery,_Component);function Gallery(){_classCallCheck(this,Gallery);return _possibleConstructorReturn(this,(Gallery.__proto__||Object.getPrototypeOf(Gallery)).apply(this,arguments));}_createClass(Gallery,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common__["e" /* Gallery */],this.props);}}]);return Gallery;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 922 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Concept; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Concept=function(_Component){_inherits(Concept,_Component);function Concept(){_classCallCheck(this,Concept);return _possibleConstructorReturn(this,(Concept.__proto__||Object.getPrototypeOf(Concept)).apply(this,arguments));}_createClass(Concept,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common__["a" /* Concept */],this.props);}}]);return Concept;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 923 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Faq; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Faq=function(_Component){_inherits(Faq,_Component);function Faq(){_classCallCheck(this,Faq);return _possibleConstructorReturn(this,(Faq.__proto__||Object.getPrototypeOf(Faq)).apply(this,arguments));}_createClass(Faq,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common__["d" /* Faq */],this.props);}}]);return Faq;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 924 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Destination; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Bubble__ = __webpack_require__(367);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Destination=function(_Component){_inherits(Destination,_Component);function Destination(){_classCallCheck(this,Destination);return _possibleConstructorReturn(this,(Destination.__proto__||Object.getPrototypeOf(Destination)).apply(this,arguments));}_createClass(Destination,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common__["b" /* Destination */],Object.assign({},this.props,{project:"laguna-park-2",projectMapChildren:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(1350, 860)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"lpark2-bubble-masterplan"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_Bubble__["a" /* default */],null)))}));}}]);return Destination;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 925 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TheSanctuaryclub; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TheSanctuaryclub=function(_Component){_inherits(TheSanctuaryclub,_Component);function TheSanctuaryclub(){_classCallCheck(this,TheSanctuaryclub);return _possibleConstructorReturn(this,(TheSanctuaryclub.__proto__||Object.getPrototypeOf(TheSanctuaryclub)).apply(this,arguments));}_createClass(TheSanctuaryclub,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common__["g" /* TheSanctuaryclub */],this.props);}}]);return TheSanctuaryclub;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 926 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Siteplan; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hoc__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_PhuketLagunaPark2_sitePlan_svg__ = __webpack_require__(927);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components_popup__ = __webpack_require__(928);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Siteplan=(_dec=Object(__WEBPACK_IMPORTED_MODULE_4__hoc__["a" /* multiLanguage */])(),_dec(_class=function(_Component){_inherits(Siteplan,_Component);function Siteplan(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Siteplan);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Siteplan.__proto__||Object.getPrototypeOf(Siteplan)).call.apply(_ref,[this].concat(args))),_this),_this.state={type:"all",popupHover:""},_this.hover=function(){var allEl=document.querySelectorAll("#floorplan g");console.log("allEl",allEl);for(var i=0;i<allEl.length;i+=1){allEl[i].addEventListener("mouseover",_this.handleUnitHover);}},_this.unhover=function(){var allEl=document.querySelectorAll("#floorplan g");for(var i=0;i<allEl.length;i+=1){allEl[i].addEventListener("mouseout",_this.handleUnitUnHover);}},_this.handleUnitUnHover=function(e){_this.setState({popupHover:""});},_this.handleUnitHover=function(e){var currentHoverType=e.target.parentElement.id;console.log("allEl handleUnitHover",{currentHoverType:currentHoverType,e:e.target.parentElement});_this.setState({popupHover:currentHoverType});},_this.renderPopup=function(){var _this$props=_this.props,descriptions=_this$props.descriptions,t=_this$props.t;var _this$state=_this.state,popupHover=_this$state.popupHover,type=_this$state.type;var mapHoverData=__WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(descriptions,function(item){var getTypePopup=__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(item,"value");var getDataPopup=__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(item,"title");var activePopup=getTypePopup===popupHover?"active":"";console.log("renderPopup",item);return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components_popup__["a" /* default */],{title:t(getTypePopup),data:t(getDataPopup),active:activePopup,onclick:_this.handleUnitHover});});return mapHoverData;},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Siteplan,[{key:"componentDidUpdate",value:function componentDidUpdate(){this.hover();this.unhover();}},{key:"render",value:function render(){var _this2=this;var _props=this.props,t=_props.t,dataSitePlan=_props.dataSitePlan,currentLanguage=_props.currentLanguage,page=_props.page;var type=this.state.type;console.log("render-siteplan",type);return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{className:"section-siteplan "+page+" site-plan-has-menu"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__data_PhuketLagunaPark2_sitePlan_svg__["a" /* default */],{currentLang:currentLanguage,selectedType:type}),this.renderPopup(),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{className:"siteplan-container-buttongroup"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["c" /* ButtonGroup */],{value:type,items:dataSitePlan,onChange:function onChange(value){return _this2.setState({type:value,popupHover:value});},direction:"horizontal",renderItem:function renderItem(_ref2){var value=_ref2.value,title=_ref2.title,active=_ref2.active,onClick=_ref2.onClick;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["b" /* Button */],{key:value,type:"secondary",active:active,activeStyle:{backgroundColor:"#00a9a5"},hoverStyle:{backgroundColor:"#00a9a5"},defaultStyle:{marginRight:"1px",textTransform:"uppercase"},onClick:onClick},t(title));}})));}}]);return Siteplan;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]))||_class);

/***/ }),
/* 927 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
// import MultiLineText from './MultiLineText';
var translate=function translate(key,lang){var dictionary={"Future Development":{en:"Future Development",cn:"未来开发项目",ru:"будущее развитие"},"20 Minutes":{en:"20 Minutes",cn:"(20分钟车程)",ru:"(20 минут езды)"},"To Phuket International Airport":{en:"To Phuket International Airport",cn:"普吉岛国际机场",ru:"МЕЖДУНАРОДНЫЙ АЭРОПОРТ ПХУКЕТА"},// 'Phuket Airport': {
//   en: 'To Phuket International Airport',
//   cn: '普吉岛国际机场',
//   ru: 'АЭРОПОРТ ПХУКЕТА'
// },
International:{en:"To Phuket International Airport",cn:"",ru:"МЕЖДУНАРОДНЫЙ"},"Main Entrance":{en:"Main Entrance",cn:"主入口",ru:"Главный въезд"},"Laguna Park 2":{en:"Laguna Park 2",cn:"乐古浪熙园 2",ru:"Laguna Park 2"},"To Ban Don":{en:"To Ban Don",cn:"班顿",ru:"ХРАМ BAN DON"},Townhome:{en:"Townhome",cn:"双拼别墅",ru:"ТАУНХАУС"},Villa:{en:"Villa",cn:"独栋别墅",ru:"ВИЛЛА"},Townhomes:{en:"Townhomes",cn:"联排别墅",ru:"Таунхаусы"},Villas:{en:"Villas",cn:"独栋别墅",ru:"Виллы"},"To Angsana Villas Resort, Laguna Phuket":{en:"To Angsana Villas Resort, Laguna Phuket",cn:"悦椿别墅度假村",ru:"ОТЕЛЬ Angsana Villas Resort, Laguna Phuket"}};return __WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(dictionary,key+"."+lang,"Content not found");// <tspan class="cls-59">{translate('Future Development', currentLang)}</tspan>
};/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var currentLang=_ref.currentLang,selectedType=_ref.selectedType;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg"// id="floorplan"
,viewBox:"0 0 841.89 595.28",className:"site-plan-svg"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("defs",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("linearGradient",{id:"linear-gradient",x1:"427.69",y1:"595.28",x2:"427.69",y2:"512.09",gradientUnits:"userSpaceOnUse"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("stop",{offset:"0","stop-color":"#fff"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("stop",{offset:"0.72","stop-color":"#fff"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("stop",{offset:"1","stop-color":"#fff","stop-opacity":"0"}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g",{id:"bg"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M83.77,490.11V311.75s2.28-21.65-6.27-35.33L41,207.47s-5.69-10.26-5.69-26.78V109.46H621.12L737.93,208,732.52,401.5h5.41v12.25H225.09l-31.34,24.5s-63.25,13.11-85.48,61.54Z",fill:"#dcddde"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M-896.33,849.1l86.61-137.9c7.73-12.31,20.29-23,32.94-29.83,29.28-15.8,57.56-4.87,87.31,3.43l73.08,20.38c34.3,9.56,63.53,17.5,96.15-4.24l81.94-43.75c34.43-18.37,66.88-40,106.16-46.19,42.15-6.65,86.12-3.6,128.67-3.85,42.36,0,84.84.23,127.19-.74C-41.37,605.61-3,608.32,28.24,590c44.26-26,55.22-83.18,77.33-125.32,17.1-32.59,52.19-44.05,87.61-44.05H720.84",fill:"none",stroke:"#dcddde","stroke-linecap":"round","stroke-miterlimit":"10","stroke-width":"36.47"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M76.22,127.84H595.1s18.42.81,31.53,13.91l73.69,61.16s24.32,43.69-40.26,43.69H102.58a12.87,12.87,0,0,1-9.12-6.22L68.1,191.52a24.53,24.53,0,0,1-1.71-9.83V138.38S66.68,128.69,76.22,127.84Z",fill:"#e6e7e7",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M303.3,244.08H667.56s47.58-2.13,30.77-39.17l-77.21-63.82s-12.25-9.41-26.21-10.54H300.31V243.94Z",fill:"#fff",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M125.94,264.64H675s14.81.58,14,17.47l-35,105.07s-4.56,14.6-20.23,14.6H125.94s-10.26-2.29-11.11-12.6V276.1S116.25,266.36,125.94,264.64Z",fill:"#e6e7e7",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"336.49",y:"130.61",width:"8.36",height:"113.56",fill:"#dcddde"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line",{x1:"303.39",y1:"187.34",x2:"303.39",y2:"130.36",fill:"none",stroke:"#7d7f81","stroke-miterlimit":"10","stroke-width":"0.23"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("circle",{cx:"117.96",cy:"434.03",r:"15.81",fill:"#fff",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M439.89-183.62c8.58,40.2,17.23,80.38,25.48,120.64,4.17,20.34,21.05,29.81,36.06,42.74l58.16,50.1c39.49,34,180.19,157.84,213,183.15,22.47,17.34,36.23,35.62,22.91,65.31L719,495.93c-9.07,25.8-50.13,130.29-48.43,141.7,1.74,11.56,13.21,22.15,20.79,30.41,64.26,70.08,127.19,141.28,190.73,212l63.82,129.16",fill:"none",stroke:"#808184","stroke-linecap":"round","stroke-miterlimit":"10","stroke-width":"31.28"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"355.77",y:"267.86",width:"8.36",height:"128.63",fill:"#dcddde"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M767.85,233.11l-31.91-25.92-66.18,194h62.87L777.53,273C788.08,250.78,767.85,233.11,767.85,233.11Z",fill:"#e6e7e7",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"676.42",y:"393.95",width:"38.04",height:"51.95",rx:"1.41",fill:"#c5c6c8",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.66"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line",{x1:"70.1",y1:"187.36",x2:"303.34",y2:"187.36",fill:"none",stroke:"#fff","stroke-miterlimit":"10","stroke-width":"0.68"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line",{x1:"122.42",y1:"243.94",x2:"122.42",y2:"130.55",fill:"none",stroke:"#fff","stroke-miterlimit":"10","stroke-width":"0.68"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line",{x1:"148.35",y1:"243.94",x2:"148.35",y2:"130.55",fill:"none",stroke:"#fff","stroke-miterlimit":"10","stroke-width":"0.68"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line",{x1:"174.18",y1:"243.94",x2:"174.18",y2:"130.55",fill:"none",stroke:"#fff","stroke-miterlimit":"10","stroke-width":"0.68"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line",{x1:"200.02",y1:"243.94",x2:"200.02",y2:"130.55",fill:"none",stroke:"#fff","stroke-miterlimit":"10","stroke-width":"0.68"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line",{x1:"225.85",y1:"243.94",x2:"225.85",y2:"130.55",fill:"none",stroke:"#fff","stroke-miterlimit":"10","stroke-width":"0.68"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line",{x1:"251.68",y1:"243.94",x2:"251.68",y2:"130.55",fill:"none",stroke:"#fff","stroke-miterlimit":"10","stroke-width":"0.68"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line",{x1:"277.61",y1:"243.94",x2:"277.61",y2:"130.55",fill:"none",stroke:"#fff","stroke-miterlimit":"10","stroke-width":"0.68"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line",{x1:"303.44",y1:"243.94",x2:"303.44",y2:"130.55",fill:"none",stroke:"#fff","stroke-miterlimit":"10","stroke-width":"0.68"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line",{x1:"96.55",y1:"237.48",x2:"96.55",y2:"130.36",fill:"none",stroke:"#fff","stroke-miterlimit":"10","stroke-width":"0.68"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M698.63,204.81,621.42,141s-12.25-9.4-26.21-10.54H551.64V244H667.86S715.44,241.85,698.63,204.81Z",fill:"#fff"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"760.36",y:"479.2",width:"18.1",height:"30.38",fill:"#b3d337",stroke:"#7d7f81","stroke-miterlimit":"10","stroke-width":"0.17"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"766.37",y:"483.21",width:"4.09",height:"9.15",transform:"translate(1256.21 -280.63) rotate(90)",fill:"#838383",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"762.75",y:"497.39",width:"10.27",height:"6.8",transform:"translate(1268.67 -267.09) rotate(90)",fill:"#838383",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"771.29 502.65 773.1 502.65 773.1 497.62 771.29 497.62 771.29 488.36 764.96 488.36 764.96 489.29 763.85 489.29 763.85 501.24 764.49 501.24 764.49 505.25 771.29 505.25 771.29 502.65",fill:"#a6a7aa",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M771.3,497.63s0-8.31,0-8.33h-3.78v-.93H765v.95h-1.14v11.92h.66v1.44h8.64v-5.05Z",fill:"#c3c5c7",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"762.48",y:"491.08",width:"10.17",height:"7.43",transform:"translate(1262.36 -272.76) rotate(90)",fill:"#838383",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"767.54",y:"480.29",width:"4.13",height:"6.78",transform:"translate(1253.28 -285.93) rotate(90)",fill:"#aee2fa",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M771.31,498.37V488.25H765v1h-1.14v8.86H765v.3Zm-4.46-2.86H771v1.79h-4.14Z",fill:"#e5e6e6",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"763.83",y:"482.94",width:"3.75",height:"1.46",transform:"translate(1249.37 -282.03) rotate(90)",fill:"#dfdfdd",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.03"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"773.18",y:"487.53",width:"1.79",height:"1.79",transform:"translate(1262.5 -285.65) rotate(90)",fill:"#dfdfdd",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.04"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"766.21",y:"489.53",width:"6.43",height:"3.79",transform:"translate(1260.84 -277.99) rotate(90)",fill:"#6e7071",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.03"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"767.97",y:"491.39",width:"6.4",height:"0.07",transform:"translate(1262.6 -279.75) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"767.82",y:"491.39",width:"6.4",height:"0.07",transform:"translate(1262.45 -279.6) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"767.67",y:"491.39",width:"6.4",height:"0.07",transform:"translate(1262.29 -279.45) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"767.52",y:"491.39",width:"6.4",height:"0.07",transform:"translate(1262.14 -279.3) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"767.37",y:"491.39",width:"6.4",height:"0.07",transform:"translate(1261.99 -279.15) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"767.22",y:"491.39",width:"6.4",height:"0.07",transform:"translate(1261.84 -278.99) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"767.07",y:"491.39",width:"6.4",height:"0.07",transform:"translate(1261.69 -278.84) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"766.92",y:"491.39",width:"6.4",height:"0.07",transform:"translate(1261.54 -278.69) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"766.77",y:"491.39",width:"6.4",height:"0.07",transform:"translate(1261.39 -278.54) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"766.62",y:"491.39",width:"6.4",height:"0.07",transform:"translate(1261.24 -278.39) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"766.47",y:"491.39",width:"6.4",height:"0.07",transform:"translate(1261.09 -278.24) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"766.31",y:"491.39",width:"6.4",height:"0.07",transform:"translate(1260.94 -278.09) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"766.16",y:"491.39",width:"6.4",height:"0.07",transform:"translate(1260.79 -277.94) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"766.01",y:"491.39",width:"6.4",height:"0.07",transform:"translate(1260.64 -277.79) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"765.86",y:"491.39",width:"6.4",height:"0.07",transform:"translate(1260.48 -277.64) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"765.71",y:"491.39",width:"6.4",height:"0.07",transform:"translate(1260.33 -277.49) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"765.56",y:"491.39",width:"6.4",height:"0.07",transform:"translate(1260.18 -277.34) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"765.41",y:"491.39",width:"6.4",height:"0.07",transform:"translate(1260.03 -277.18) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"765.26",y:"491.39",width:"6.4",height:"0.07",transform:"translate(1259.88 -277.03) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"765.11",y:"491.39",width:"6.4",height:"0.07",transform:"translate(1259.73 -276.88) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"764.96",y:"491.39",width:"6.4",height:"0.07",transform:"translate(1259.58 -276.73) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"764.81",y:"491.39",width:"6.4",height:"0.07",transform:"translate(1259.43 -276.58) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"764.66",y:"491.39",width:"6.4",height:"0.07",transform:"translate(1259.28 -276.43) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"764.5",y:"491.39",width:"6.4",height:"0.07",transform:"translate(1259.13 -276.28) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M772.09,507.16a1.67,1.67,0,0,1-.84-1.52h-6.74c0,.69,0,1.27-.5,1.52Z",fill:"#838383"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"758.07",y:"519.66",width:"20.39",height:"36.86",fill:"#4f9656",stroke:"#7d7f81","stroke-miterlimit":"10","stroke-width":"0.19"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"763.17 526.37 762.66 526.37 762.66 522.54 774.51 522.54 774.51 525.72 774.51 526.37 774.51 529.55 763.17 529.55 763.17 526.37",fill:"#aee2fa",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.03"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"760.75",y:"523.77",width:"3.3",height:"1.9",transform:"translate(1287.11 -237.67) rotate(90)",fill:"#e0e0de",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.03"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"761.45",y:"526.83",width:"1.49",height:"1.49",transform:"translate(1289.77 -234.61) rotate(90)",fill:"#e0e0de",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.03"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"766.13",y:"523.84",width:"4.07",height:"10.01",transform:"translate(1297.02 -239.32) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.03"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"763.29",y:"530.73",width:"9.76",height:"10.01",transform:"translate(1303.9 -232.44) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.03"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"760.27",y:"530.93",width:"9.98",height:"10.01",transform:"translate(1301.19 -229.33) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.03"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"762.78",y:"537.03",width:"9.98",height:"10.01",transform:"translate(1309.81 -225.74) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.03"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"766.04",y:"538.68",width:"6.24",height:"10.01",transform:"translate(1312.85 -225.47) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.03"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"760.38",y:"541.37",width:"10.47",height:"9.19",transform:"translate(1311.58 -219.64) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.03"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M761.28,552.38h5.87a1.42,1.42,0,0,0,1,1.27h-7.85A1.44,1.44,0,0,0,761.28,552.38Z",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.03"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"761.27",y:"550.33",width:"5.89",height:"2.51",transform:"translate(1528.42 1103.17) rotate(-180)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.03"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"770.22 551.17 760.99 551.17 760.99 540.92 761.78 540.92 761.78 531.65 763.15 531.65 763.17 529.56 773.16 529.56 773.16 535.87 774.17 535.87 774.17 540.6 776.27 540.6 776.27 547.38 770.22 547.38 770.22 551.17",fill:"#a7a9ac",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.03"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"763.13 529.54 773.14 529.54 773.14 535.87 774.13 535.87 774.13 540.58 776.27 540.58 776.27 547.36 764.31 547.36 764.31 545.61 763.13 545.61 763.13 529.54",fill:"#c5c6c8",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.03"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M763.12,541.75h11.12v-5.89h-1v-5.94H763.14l0,5.09h-.36v3.28h.37Zm5.87-.69v-3.47h5v3.47Z",fill:"#e6e7e7",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.03"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"765.31",y:"527.72",width:"5.7",height:"10.09",transform:"translate(1300.93 -235.39) rotate(90)",fill:"#6e6f71",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"760.45",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1296.04 -230.49) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"760.58",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1296.17 -230.63) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"760.71",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1296.31 -230.76) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"760.85",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1296.44 -230.89) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"760.98",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1296.57 -231.03) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"761.11",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1296.71 -231.16) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"761.25",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1296.84 -231.29) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"761.38",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1296.97 -231.43) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"761.51",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1297.11 -231.56) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"761.65",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1297.24 -231.7) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"761.78",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1297.38 -231.83) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"761.92",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1297.51 -231.96) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"762.05",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1297.64 -232.1) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"762.18",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1297.78 -232.23) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"762.32",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1297.91 -232.36) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"762.45",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1298.04 -232.5) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"762.58",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1298.18 -232.63) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"762.72",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1298.31 -232.76) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"762.85",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1298.44 -232.9) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"762.98",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1298.58 -233.03) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"763.12",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1298.71 -233.17) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"763.25",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1298.85 -233.3) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"763.39",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1298.98 -233.43) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"763.52",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1299.11 -233.57) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"763.65",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1299.25 -233.7) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"763.79",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1299.38 -233.83) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"763.92",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1299.51 -233.97) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"764.05",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1299.65 -234.1) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"764.19",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1299.78 -234.23) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"764.32",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1299.91 -234.37) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"764.45",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1300.05 -234.5) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"764.59",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1300.18 -234.64) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"764.72",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1300.32 -234.77) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"764.86",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1300.45 -234.9) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"764.99",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1300.58 -235.04) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"765.12",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1300.72 -235.17) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"765.26",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1300.85 -235.3) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"765.39",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1300.98 -235.44) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"765.52",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1301.12 -235.57) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"765.66",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1301.25 -235.71) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"765.79",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1301.38 -235.84) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"765.92",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1301.52 -235.97) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"766.06",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1301.65 -236.11) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"766.19",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1301.79 -236.24) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"766.33",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1301.92 -236.37) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"766.46",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1302.05 -236.51) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"766.59",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1302.19 -236.64) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"766.73",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1302.32 -236.77) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"766.86",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1302.45 -236.91) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"766.99",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1302.59 -237.04) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"767.13",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1302.72 -237.18) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"767.26",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1302.85 -237.31) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"767.4",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1302.99 -237.44) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"767.53",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1303.12 -237.58) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"767.66",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1303.26 -237.71) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"767.8",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1303.39 -237.84) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"767.93",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1303.52 -237.98) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"768.06",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1303.66 -238.11) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"768.2",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1303.79 -238.24) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"768.33",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1303.92 -238.38) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"768.46",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1304.06 -238.51) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"768.6",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1304.19 -238.65) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"768.73",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1304.32 -238.78) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"768.87",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1304.46 -238.91) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"769",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1304.59 -239.05) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"769.13",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1304.73 -239.18) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"769.27",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1304.86 -239.31) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"769.4",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1304.99 -239.45) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"769.53",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1305.13 -239.58) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"769.67",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1305.26 -239.71) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"769.8",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1305.39 -239.85) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"769.93",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1305.53 -239.98) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"770.07",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1305.66 -240.12) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"770.2",y:"532.74",width:"5.64",height:"0.06",transform:"translate(1305.79 -240.25) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(785.58 497.28)","font-size":"8",fill:"none","font-family":"Helvetica"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{"letter-spacing":"-0.11em"},"T"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"4",y:"0"},"ownhome")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(785.58 497.28)","font-size":"8",fill:"#6a6c6d","font-family":"Helvetica"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{"letter-spacing":"-0.11em"},"T"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"4",y:"0"},"ownhome")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(785.58 497.28)","font-size":"8",fill:"none","font-family":"Helvetica"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{"letter-spacing":"-0.11em"},"T"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"4",y:"0"},"ownhome")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(785.58 540.28)","font-size":"8",fill:"none","font-family":"Helvetica"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{"letter-spacing":"-0.02em"},"V"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"5.2",y:"0"},"illa")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(785.58 540.28)","font-size":"8",fill:"#6a6c6d","font-family":"Helvetica"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{"letter-spacing":"-0.02em"},"V"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"5.2",y:"0"},"illa")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(785.58 540.28)","font-size":"8",fill:"none","font-family":"Helvetica"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{"letter-spacing":"-0.02em"},"V"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"5.2",y:"0"},"illa")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"51.32 73.87 53.05 84.65 63.83 86.39 53.05 88.12 51.32 98.9 49.58 88.12 38.8 86.39 49.58 84.65 51.32 73.87",fill:"#414042"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"51.32 73.87 51.32 86.4 49.58 84.65 51.32 73.87",fill:"#808285"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"51.32 98.9 51.32 86.4 53.05 88.12 51.32 98.9",fill:"#808285"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"38.8 86.39 51.33 86.39 49.59 88.12 38.8 86.39",fill:"#808285"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"63.83 86.39 51.33 86.39 53.05 84.65 63.83 86.39",fill:"#808285"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M53.42,69c-.36,0-.51.1-.54.37s0,.48,0,1.07v2.54h-.2L50,69.63h0v1.58a9.85,9.85,0,0,0,0,1.06c0,.32.17.4.6.42v.18H49.11v-.18c.36,0,.52-.1.55-.41a10.4,10.4,0,0,0,0-1.07V69.82c0-.46,0-.48-.12-.64A.76.76,0,0,0,49,69v-.17h.93l2.63,3.15h0V70.39a9.61,9.61,0,0,0,0-1c0-.28-.18-.36-.62-.39v-.17h1.49V69",fill:"#414042"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M52.48,101.07a1,1,0,0,0-1-.83c-.62,0-.88.34-.88.69s.38.67,1,.92,1.37.55,1.37,1.27-.7,1.19-1.75,1.19a3,3,0,0,1-.78-.1l-.39-.13a6.94,6.94,0,0,1-.21-1l.23,0a1.35,1.35,0,0,0,1.3,1c.6,0,.94-.3.94-.76s-.43-.69-1-.94S50,101.85,50,101.14s.61-1.12,1.63-1.12a4,4,0,0,1,1,.15c0,.23.07.47.13.86l-.23,0",fill:"#414042"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M68.45,87c0,.2-.17.79-.22,1h-3v-.18c.57,0,.62-.09.62-.61V84.72c0-.56,0-.58-.54-.62v-.17h2.81c0,.14,0,.57,0,.9l-.18,0a1.61,1.61,0,0,0-.2-.54c-.09-.14-.26-.18-.71-.18h-.48c-.2,0-.21,0-.21.2v1.44h.59c.57,0,.61,0,.68-.47h.18v1.2h-.18c-.08-.45-.12-.49-.67-.49h-.6v1.19c0,.3,0,.44.15.51a1.38,1.38,0,0,0,.66.08c.47,0,.65,0,.79-.21a2,2,0,0,0,.31-.59l.19,0",fill:"#414042"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M38.51,84.21c-.43.06-.49.11-.68.63s-.52,1.6-1,3.36H36.6c-.35-1-.78-2.23-1.1-3.14h0c-.35,1.11-.7,2.12-1,3.14h-.2c-.33-1.14-.69-2.25-1-3.37-.16-.52-.25-.58-.64-.62V84h1.53v.18c-.46.06-.47.11-.37.43.24.85.49,1.7.76,2.59h0c.35-1.07.71-2.11,1-3.14h.19c.35,1,.72,2.06,1.1,3.15h0c.27-.84.62-2.08.71-2.53s.06-.44-.42-.5V84h1.38v.18",fill:"#414042"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M36.4,82A15.54,15.54,0,0,1,47.84,71.15l-.13-.58A16.14,16.14,0,0,0,35.82,81.84l.58.17m-.29.21a.3.3,0,1,0-.3-.3.29.29,0,0,0,.3.3M47.77,71.16a.29.29,0,0,0,.3-.3.3.3,0,1,0-.59,0,.29.29,0,0,0,.29.3",fill:"#414042"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M48.91,101.59A15.53,15.53,0,0,1,36.32,90.22l-.58.15a16.13,16.13,0,0,0,13.08,11.81l.09-.59m0,.59a.29.29,0,0,0,.3-.3.3.3,0,0,0-.3-.3.31.31,0,0,0-.3.3.3.3,0,0,0,.3.3M36,90.59A.3.3,0,1,0,36,90a.3.3,0,0,0,0,.59",fill:"#414042"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M66.56,89.09A15.51,15.51,0,0,1,53.8,101.57l.09.59a16.12,16.12,0,0,0,13.26-13l-.59-.11m.29.35a.3.3,0,1,0,0-.59.3.3,0,0,0,0,.59m-13,12.73a.3.3,0,0,0,.3-.3.29.29,0,0,0-.3-.3.3.3,0,0,0-.3.3.31.31,0,0,0,.3.3",fill:"#414042"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M54.62,71.12A15.52,15.52,0,0,1,66.41,82.74l.59-.13A16.15,16.15,0,0,0,54.75,70.53l-.13.59m.07,0a.3.3,0,1,0,0-.59.3.3,0,1,0,0,.59M66.71,83a.3.3,0,0,0,0-.59.3.3,0,1,0,0,.59",fill:"#414042"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(706.31 114.21)","font-size":"8",fill:"#6a6c6d","font-family":"Helvetica"},"20 Minutes",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"0",y:"9.6","letter-spacing":"-0.11em"},"T"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"4",y:"9.6"},"o Phuket International"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"81.83",y:"9.6","letter-spacing":"-0.05em"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"83.62",y:"9.6"},"Airport")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(706.31 114.21)","font-size":"8",fill:"none","font-family":"Helvetica"},"20 Minutes",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"4",y:"9.6"},"o Phuket International"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"81.83",y:"9.6","letter-spacing":"-0.05em"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"83.62",y:"9.6"},"Airport")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line",{x1:"673.41",y1:"83.62",x2:"701.92",y2:"106.04",fill:"none"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line",{x1:"681.77",y1:"90.19",x2:"701.92",y2:"106.04",fill:"none",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"2.4"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"681.48 94.4 673.41 83.62 685.79 88.92 681.48 94.4",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line",{x1:"141.33",y1:"502.37",x2:"162.69",y2:"469.6",fill:"none"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line",{x1:"147.59",y1:"492.77",x2:"162.69",y2:"469.6",fill:"none",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"2.59"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"152.14 492.67 141.33 502.37 145.84 488.56 152.14 492.67",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(171.35 483.94)","font-size":"8",fill:"none","font-family":"Helvetica"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{"letter-spacing":"-0.11em"},"T"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"4",y:"0"},"o"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"8.45",y:"0","letter-spacing":"-0.05em"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"10.23",y:"0"},"Angsana"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"44.04",y:"0","letter-spacing":"-0.02em"},"V"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"49.23",y:"0"},"illas Resort, Laguna Phuket")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(171.35 483.94)","font-size":"8",fill:"#6a6c6d","font-family":"Helvetica"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{"letter-spacing":"-0.11em"},"T"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"4",y:"0"},"o"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"8.45",y:"0","letter-spacing":"-0.05em"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"10.23",y:"0"},"Angsana"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"44.04",y:"0","letter-spacing":"-0.02em"},"V"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"49.23",y:"0"},"illas Resort, Laguna Phuket")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(171.35 483.94)","font-size":"8",fill:"none","font-family":"Helvetica"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{"letter-spacing":"-0.11em"},"T"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"4",y:"0"},"o"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"8.45",y:"0","letter-spacing":"-0.05em"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"10.23",y:"0"},"Angsana"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"44.04",y:"0","letter-spacing":"-0.02em"},"V"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"49.23",y:"0"},"illas Resort, Laguna Phuket")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line",{x1:"661.73",y1:"520.27",x2:"675.62",y2:"483.7",fill:"none"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line",{x1:"665.8",y1:"509.55",x2:"675.62",y2:"483.7",fill:"none",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"2.59"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"670.23 508.49 661.73 520.27 663.2 505.82 670.23 508.49",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(28.22 531.05)","font-size":"6",fill:"none","font-family":"Helvetica"},"Updated 4 September 2019"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"329.17 228.88 329.17 244.01 337.17 244.01 337.17 231.38 341.5 231.38 341.5 130.59 332.5 130.59 332.5 146.38 333.5 146.38 333.5 228.88 329.17 228.88",fill:"#dcddde"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(657.35 477.94)","font-size":"8",fill:"#6a6c6d","font-family":"Helvetica"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{"letter-spacing":"-0.11em"},"T"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"4",y:"0"},"o Ban Don")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M639.75,270.22H671s11.25.5,10.5,13.5l-34.5,104s-.5,5.5-7.25,11Z",fill:"#fff"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g",{id:"floorplan"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g",{id:"Villas","data-name":"Villas"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"125.94 267.59 352.44 267.59 352.44 396.65 126.22 396.65 118.53 388.96 118.53 274.71 125.94 267.59",fill:"#4f9656",stroke:"#7d7f81","stroke-miterlimit":"10","stroke-width":"0.23"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"150.43 342.74 151.53 342.74 151.53 334.47 125.94 334.47 125.94 341.33 125.94 342.74 125.94 349.6 150.43 349.6 150.43 342.74",fill:"#aee2fa",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"148.54",y:"337.13",width:"7.12",height:"4.1",transform:"translate(491.28 187.08) rotate(90)",fill:"#e0e0de",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"150.94",y:"343.74",width:"3.21",height:"3.22",transform:"translate(497.89 192.81) rotate(90)",fill:"#e0e0de",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"135.24",y:"337.29",width:"8.79",height:"21.61",transform:"translate(487.73 208.46) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"129.1",y:"352.15",width:"21.06",height:"21.61",transform:"translate(502.58 223.32) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"135.14",y:"352.58",width:"21.55",height:"21.61",transform:"translate(509.3 217.47) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"129.71",y:"365.75",width:"21.55",height:"21.61",transform:"translate(517.04 236.06) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"130.76",y:"369.32",width:"13.46",height:"21.61",transform:"translate(517.62 242.63) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"133.86",y:"375.13",width:"22.6",height:"19.83",transform:"translate(530.2 239.89) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M154.5,398.9H141.84a3.09,3.09,0,0,1-2.19,2.74h17v0A3.09,3.09,0,0,1,154.5,398.9Z",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"141.82",y:"394.47",width:"12.72",height:"5.41",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"135.22 396.27 155.14 396.27 155.14 374.15 153.43 374.15 153.43 354.15 150.48 354.15 150.44 349.62 128.85 349.62 128.85 363.25 126.67 363.25 126.67 373.47 122.14 373.47 122.14 388.09 135.22 388.09 135.22 396.27",fill:"#a7a9ac",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"150.52 349.58 128.89 349.58 128.89 363.25 126.76 363.25 126.76 373.43 122.14 373.43 122.14 388.04 147.96 388.04 147.96 384.28 150.52 384.28 150.52 349.58",fill:"#c5c6c8",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M150.52,368.48h.81v-7.09h-.77l-.07-11H128.75v12.82h-2.23V376h24Zm-23.55,6V367h10.9v7.48Z",fill:"#e6e7e7",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"133.5",y:"345.66",width:"12.31",height:"21.78",transform:"translate(496.21 216.9) rotate(90)",fill:"#6e6f71",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.13"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"144.13",y:"356.5",width:"12.18",height:"0.12",transform:"translate(506.78 206.34) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"143.84",y:"356.5",width:"12.18",height:"0.12",transform:"translate(506.5 206.63) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"143.55",y:"356.5",width:"12.18",height:"0.12",transform:"translate(506.21 206.92) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"143.27",y:"356.5",width:"12.18",height:"0.12",transform:"translate(505.92 207.21) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"142.98",y:"356.5",width:"12.18",height:"0.12",transform:"translate(505.63 207.5) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"142.69",y:"356.5",width:"12.18",height:"0.12",transform:"translate(505.34 207.79) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"142.4",y:"356.5",width:"12.18",height:"0.12",transform:"translate(505.05 208.08) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"142.11",y:"356.5",width:"12.18",height:"0.12",transform:"translate(504.76 208.36) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"141.82",y:"356.5",width:"12.18",height:"0.12",transform:"translate(504.48 208.65) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"141.53",y:"356.5",width:"12.18",height:"0.12",transform:"translate(504.19 208.94) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"141.25",y:"356.5",width:"12.18",height:"0.12",transform:"translate(503.9 209.23) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"140.96",y:"356.5",width:"12.18",height:"0.12",transform:"translate(503.61 209.52) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"140.67",y:"356.5",width:"12.18",height:"0.12",transform:"translate(503.32 209.81) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"140.38",y:"356.5",width:"12.18",height:"0.12",transform:"translate(503.03 210.09) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"140.09",y:"356.5",width:"12.18",height:"0.12",transform:"translate(502.74 210.38) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"139.8",y:"356.5",width:"12.18",height:"0.12",transform:"translate(502.46 210.67) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"139.52",y:"356.5",width:"12.18",height:"0.12",transform:"translate(502.17 210.96) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"139.23",y:"356.5",width:"12.18",height:"0.12",transform:"translate(501.88 211.25) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"138.94",y:"356.5",width:"12.18",height:"0.12",transform:"translate(501.59 211.54) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"138.65",y:"356.5",width:"12.18",height:"0.12",transform:"translate(501.3 211.83) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"138.36",y:"356.5",width:"12.18",height:"0.12",transform:"translate(501.01 212.11) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"138.07",y:"356.5",width:"12.18",height:"0.12",transform:"translate(500.72 212.4) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"137.78",y:"356.5",width:"12.18",height:"0.12",transform:"translate(500.44 212.69) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"137.5",y:"356.5",width:"12.18",height:"0.12",transform:"translate(500.15 212.98) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"137.21",y:"356.5",width:"12.18",height:"0.12",transform:"translate(499.86 213.27) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"136.92",y:"356.5",width:"12.18",height:"0.12",transform:"translate(499.57 213.56) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"136.63",y:"356.5",width:"12.18",height:"0.12",transform:"translate(499.28 213.85) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"136.34",y:"356.5",width:"12.18",height:"0.12",transform:"translate(498.99 214.13) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"136.05",y:"356.5",width:"12.18",height:"0.12",transform:"translate(498.71 214.42) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"135.76",y:"356.5",width:"12.18",height:"0.12",transform:"translate(498.42 214.71) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"135.48",y:"356.5",width:"12.18",height:"0.12",transform:"translate(498.13 215) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"135.19",y:"356.5",width:"12.18",height:"0.12",transform:"translate(497.84 215.29) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"134.9",y:"356.5",width:"12.18",height:"0.12",transform:"translate(497.55 215.58) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"134.61",y:"356.5",width:"12.18",height:"0.12",transform:"translate(497.26 215.86) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"134.32",y:"356.5",width:"12.18",height:"0.12",transform:"translate(496.97 216.15) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"134.03",y:"356.5",width:"12.18",height:"0.12",transform:"translate(496.69 216.44) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"133.75",y:"356.5",width:"12.18",height:"0.12",transform:"translate(496.4 216.73) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"133.46",y:"356.5",width:"12.18",height:"0.12",transform:"translate(496.11 217.02) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"133.17",y:"356.5",width:"12.18",height:"0.12",transform:"translate(495.82 217.31) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"132.88",y:"356.5",width:"12.18",height:"0.12",transform:"translate(495.53 217.6) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"132.59",y:"356.5",width:"12.18",height:"0.12",transform:"translate(495.24 217.88) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"132.3",y:"356.5",width:"12.18",height:"0.12",transform:"translate(494.95 218.17) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"132.01",y:"356.5",width:"12.18",height:"0.12",transform:"translate(494.67 218.46) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"131.73",y:"356.5",width:"12.18",height:"0.12",transform:"translate(494.38 218.75) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"131.44",y:"356.5",width:"12.18",height:"0.12",transform:"translate(494.09 219.04) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"131.15",y:"356.5",width:"12.18",height:"0.12",transform:"translate(493.8 219.33) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"130.86",y:"356.5",width:"12.18",height:"0.12",transform:"translate(493.51 219.62) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"130.57",y:"356.5",width:"12.18",height:"0.12",transform:"translate(493.22 219.9) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"130.28",y:"356.5",width:"12.18",height:"0.12",transform:"translate(492.94 220.19) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"129.99",y:"356.5",width:"12.18",height:"0.12",transform:"translate(492.65 220.48) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"129.71",y:"356.5",width:"12.18",height:"0.12",transform:"translate(492.36 220.77) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"129.42",y:"356.5",width:"12.18",height:"0.12",transform:"translate(492.07 221.06) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"129.13",y:"356.5",width:"12.18",height:"0.12",transform:"translate(491.78 221.35) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"128.84",y:"356.5",width:"12.18",height:"0.12",transform:"translate(491.49 221.64) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"128.55",y:"356.5",width:"12.18",height:"0.12",transform:"translate(491.2 221.92) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"128.26",y:"356.5",width:"12.18",height:"0.12",transform:"translate(490.92 222.21) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"127.98",y:"356.5",width:"12.18",height:"0.12",transform:"translate(490.63 222.5) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"127.69",y:"356.5",width:"12.18",height:"0.12",transform:"translate(490.34 222.79) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"127.4",y:"356.5",width:"12.18",height:"0.12",transform:"translate(490.05 223.08) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"127.11",y:"356.5",width:"12.18",height:"0.12",transform:"translate(489.76 223.37) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"126.82",y:"356.5",width:"12.18",height:"0.12",transform:"translate(489.47 223.65) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"126.53",y:"356.5",width:"12.18",height:"0.12",transform:"translate(489.18 223.94) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"126.24",y:"356.5",width:"12.18",height:"0.12",transform:"translate(488.9 224.23) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"125.96",y:"356.5",width:"12.18",height:"0.12",transform:"translate(488.61 224.52) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"125.67",y:"356.5",width:"12.18",height:"0.12",transform:"translate(488.32 224.81) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"125.38",y:"356.5",width:"12.18",height:"0.12",transform:"translate(488.03 225.1) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"125.09",y:"356.5",width:"12.18",height:"0.12",transform:"translate(487.74 225.39) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"124.8",y:"356.5",width:"12.18",height:"0.12",transform:"translate(487.45 225.67) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"124.51",y:"356.5",width:"12.18",height:"0.12",transform:"translate(487.17 225.96) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"124.22",y:"356.5",width:"12.18",height:"0.12",transform:"translate(486.88 226.25) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"123.94",y:"356.5",width:"12.18",height:"0.12",transform:"translate(486.59 226.54) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"123.65",y:"356.5",width:"12.18",height:"0.12",transform:"translate(486.3 226.83) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"123.36",y:"356.5",width:"12.18",height:"0.12",transform:"translate(486.01 227.12) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"123.07",y:"356.5",width:"12.18",height:"0.12",transform:"translate(485.72 227.41) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"166.27 342.74 165.18 342.74 165.18 334.47 190.76 334.47 190.76 341.33 190.76 342.74 190.76 349.6 166.27 349.6 166.27 342.74",fill:"#aee2fa",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"161.04",y:"337.13",width:"7.12",height:"4.1",transform:"translate(503.78 174.58) rotate(90)",fill:"#e0e0de",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"162.55",y:"343.74",width:"3.21",height:"3.22",transform:"translate(509.51 181.19) rotate(90)",fill:"#e0e0de",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"172.68",y:"337.29",width:"8.79",height:"21.61",transform:"translate(525.17 171.02) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"166.54",y:"352.15",width:"21.06",height:"21.61",transform:"translate(540.02 185.88) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"160.01",y:"352.58",width:"21.55",height:"21.61",transform:"translate(534.17 192.6) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"165.44",y:"365.75",width:"21.55",height:"21.61",transform:"translate(552.77 200.33) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"172.48",y:"369.32",width:"13.46",height:"21.61",transform:"translate(559.33 200.91) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"160.25",y:"375.13",width:"22.6",height:"19.83",transform:"translate(556.59 213.5) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M162.2,398.9h12.67a3.08,3.08,0,0,0,2.19,2.74h-17v0A3.07,3.07,0,0,0,162.2,398.9Z",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"162.17",y:"394.47",width:"12.72",height:"5.41",transform:"translate(337.05 794.35) rotate(-180)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"181.49 396.27 161.57 396.27 161.57 374.15 163.28 374.15 163.28 354.15 166.23 354.15 166.27 349.62 187.85 349.62 187.85 363.25 190.03 363.25 190.03 373.47 194.56 373.47 194.56 388.09 181.49 388.09 181.49 396.27",fill:"#a7a9ac",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"166.18 349.58 187.81 349.58 187.81 363.25 189.95 363.25 189.95 373.43 194.56 373.43 194.56 388.04 168.75 388.04 168.75 384.28 166.18 384.28 166.18 349.58",fill:"#c5c6c8",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M166.18,376h24V363.22H188V350.4H166.21l-.06,11h-.78v7.09h.81Zm12.65-1.5V367h10.9v7.48Z",fill:"#e6e7e7",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"170.89",y:"345.66",width:"12.31",height:"21.78",transform:"translate(533.6 179.51) rotate(90)",fill:"#6e6f71",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.13"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"160.4",y:"356.5",width:"12.18",height:"0.12",transform:"translate(523.05 190.08) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"160.68",y:"356.5",width:"12.18",height:"0.12",transform:"translate(523.34 189.79) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"160.97",y:"356.5",width:"12.18",height:"0.12",transform:"translate(523.62 189.5) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"161.26",y:"356.5",width:"12.18",height:"0.12",transform:"translate(523.91 189.21) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"161.55",y:"356.5",width:"12.18",height:"0.12",transform:"translate(524.2 188.93) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"161.84",y:"356.5",width:"12.18",height:"0.12",transform:"translate(524.49 188.64) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"162.13",y:"356.5",width:"12.18",height:"0.12",transform:"translate(524.78 188.35) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"162.42",y:"356.5",width:"12.18",height:"0.12",transform:"translate(525.07 188.06) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"162.7",y:"356.5",width:"12.18",height:"0.12",transform:"translate(525.36 187.77) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"162.99",y:"356.5",width:"12.18",height:"0.12",transform:"translate(525.64 187.48) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"163.28",y:"356.5",width:"12.18",height:"0.12",transform:"translate(525.93 187.19) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"163.57",y:"356.5",width:"12.18",height:"0.12",transform:"translate(526.22 186.91) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"163.86",y:"356.5",width:"12.18",height:"0.12",transform:"translate(526.51 186.62) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"164.15",y:"356.5",width:"12.18",height:"0.12",transform:"translate(526.8 186.33) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"164.43",y:"356.5",width:"12.18",height:"0.12",transform:"translate(527.09 186.04) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"164.72",y:"356.5",width:"12.18",height:"0.12",transform:"translate(527.38 185.75) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"165.01",y:"356.5",width:"12.18",height:"0.12",transform:"translate(527.66 185.46) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"165.3",y:"356.5",width:"12.18",height:"0.12",transform:"translate(527.95 185.18) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"165.59",y:"356.5",width:"12.18",height:"0.12",transform:"translate(528.24 184.89) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"165.88",y:"356.5",width:"12.18",height:"0.12",transform:"translate(528.53 184.6) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"166.17",y:"356.5",width:"12.18",height:"0.12",transform:"translate(528.82 184.31) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"166.45",y:"356.5",width:"12.18",height:"0.12",transform:"translate(529.11 184.02) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"166.74",y:"356.5",width:"12.18",height:"0.12",transform:"translate(529.39 183.73) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"167.03",y:"356.5",width:"12.18",height:"0.12",transform:"translate(529.68 183.44) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"167.32",y:"356.5",width:"12.18",height:"0.12",transform:"translate(529.97 183.16) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"167.61",y:"356.5",width:"12.18",height:"0.12",transform:"translate(530.26 182.87) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"167.9",y:"356.5",width:"12.18",height:"0.12",transform:"translate(530.55 182.58) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"168.19",y:"356.5",width:"12.18",height:"0.12",transform:"translate(530.84 182.29) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"168.47",y:"356.5",width:"12.18",height:"0.12",transform:"translate(531.13 182) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"168.76",y:"356.5",width:"12.18",height:"0.12",transform:"translate(531.41 181.71) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"169.05",y:"356.5",width:"12.18",height:"0.12",transform:"translate(531.7 181.42) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"169.34",y:"356.5",width:"12.18",height:"0.12",transform:"translate(531.99 181.14) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"169.63",y:"356.5",width:"12.18",height:"0.12",transform:"translate(532.28 180.85) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"169.92",y:"356.5",width:"12.18",height:"0.12",transform:"translate(532.57 180.56) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"170.2",y:"356.5",width:"12.18",height:"0.12",transform:"translate(532.86 180.27) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"170.49",y:"356.5",width:"12.18",height:"0.12",transform:"translate(533.15 179.98) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"170.78",y:"356.5",width:"12.18",height:"0.12",transform:"translate(533.43 179.69) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"171.07",y:"356.5",width:"12.18",height:"0.12",transform:"translate(533.72 179.41) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"171.36",y:"356.5",width:"12.18",height:"0.12",transform:"translate(534.01 179.12) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"171.65",y:"356.5",width:"12.18",height:"0.12",transform:"translate(534.3 178.83) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"171.94",y:"356.5",width:"12.18",height:"0.12",transform:"translate(534.59 178.54) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"172.22",y:"356.5",width:"12.18",height:"0.12",transform:"translate(534.88 178.25) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"172.51",y:"356.5",width:"12.18",height:"0.12",transform:"translate(535.16 177.96) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"172.8",y:"356.5",width:"12.18",height:"0.12",transform:"translate(535.45 177.67) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"173.09",y:"356.5",width:"12.18",height:"0.12",transform:"translate(535.74 177.39) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"173.38",y:"356.5",width:"12.18",height:"0.12",transform:"translate(536.03 177.1) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"173.67",y:"356.5",width:"12.18",height:"0.12",transform:"translate(536.32 176.81) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"173.96",y:"356.5",width:"12.18",height:"0.12",transform:"translate(536.61 176.52) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"174.24",y:"356.5",width:"12.18",height:"0.12",transform:"translate(536.9 176.23) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"174.53",y:"356.5",width:"12.18",height:"0.12",transform:"translate(537.18 175.94) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"174.82",y:"356.5",width:"12.18",height:"0.12",transform:"translate(537.47 175.65) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"175.11",y:"356.5",width:"12.18",height:"0.12",transform:"translate(537.76 175.37) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"175.4",y:"356.5",width:"12.18",height:"0.12",transform:"translate(538.05 175.08) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"175.69",y:"356.5",width:"12.18",height:"0.12",transform:"translate(538.34 174.79) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"175.97",y:"356.5",width:"12.18",height:"0.12",transform:"translate(538.63 174.5) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"176.26",y:"356.5",width:"12.18",height:"0.12",transform:"translate(538.92 174.21) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"176.55",y:"356.5",width:"12.18",height:"0.12",transform:"translate(539.2 173.92) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"176.84",y:"356.5",width:"12.18",height:"0.12",transform:"translate(539.49 173.64) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"177.13",y:"356.5",width:"12.18",height:"0.12",transform:"translate(539.78 173.35) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"177.42",y:"356.5",width:"12.18",height:"0.12",transform:"translate(540.07 173.06) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"177.71",y:"356.5",width:"12.18",height:"0.12",transform:"translate(540.36 172.77) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"177.99",y:"356.5",width:"12.18",height:"0.12",transform:"translate(540.65 172.48) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"178.28",y:"356.5",width:"12.18",height:"0.12",transform:"translate(540.94 172.19) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"178.57",y:"356.5",width:"12.18",height:"0.12",transform:"translate(541.22 171.9) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"178.86",y:"356.5",width:"12.18",height:"0.12",transform:"translate(541.51 171.62) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"179.15",y:"356.5",width:"12.18",height:"0.12",transform:"translate(541.8 171.33) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"179.44",y:"356.5",width:"12.18",height:"0.12",transform:"translate(542.09 171.04) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"179.73",y:"356.5",width:"12.18",height:"0.12",transform:"translate(542.38 170.75) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"180.01",y:"356.5",width:"12.18",height:"0.12",transform:"translate(542.67 170.46) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"180.3",y:"356.5",width:"12.18",height:"0.12",transform:"translate(542.95 170.17) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"180.59",y:"356.5",width:"12.18",height:"0.12",transform:"translate(543.24 169.88) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"180.88",y:"356.5",width:"12.18",height:"0.12",transform:"translate(543.53 169.6) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"181.17",y:"356.5",width:"12.18",height:"0.12",transform:"translate(543.82 169.31) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"181.46",y:"356.5",width:"12.18",height:"0.12",transform:"translate(544.11 169.02) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"227.93 342.74 229.02 342.74 229.02 334.47 203.44 334.47 203.44 341.33 203.44 342.74 203.44 349.6 227.93 349.6 227.93 342.74",fill:"#aee2fa",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"226.04",y:"337.13",width:"7.12",height:"4.1",transform:"translate(568.78 109.58) rotate(90)",fill:"#e0e0de",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"228.43",y:"343.74",width:"3.21",height:"3.22",transform:"translate(575.39 115.31) rotate(90)",fill:"#e0e0de",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"212.73",y:"337.29",width:"8.79",height:"21.61",transform:"translate(565.22 130.97) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"206.6",y:"352.15",width:"21.06",height:"21.61",transform:"translate(580.08 145.82) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"212.64",y:"352.58",width:"21.55",height:"21.61",transform:"translate(586.8 139.97) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"207.21",y:"365.75",width:"21.55",height:"21.61",transform:"translate(594.53 158.57) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"208.26",y:"369.32",width:"13.46",height:"21.61",transform:"translate(595.11 165.13) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"211.35",y:"375.13",width:"22.6",height:"19.83",transform:"translate(607.7 162.39) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M232,398.9H219.33a3.08,3.08,0,0,1-2.19,2.74h17v0A3.07,3.07,0,0,1,232,398.9Z",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"219.32",y:"394.47",width:"12.72",height:"5.41",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"212.72 396.27 232.63 396.27 232.63 374.15 230.92 374.15 230.92 354.15 227.97 354.15 227.93 349.62 206.35 349.62 206.35 363.25 204.17 363.25 204.17 373.47 199.64 373.47 199.64 388.09 212.72 388.09 212.72 396.27",fill:"#a7a9ac",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"228.02 349.58 206.39 349.58 206.39 363.25 204.25 363.25 204.25 373.43 199.64 373.43 199.64 388.04 225.45 388.04 225.45 384.28 228.02 384.28 228.02 349.58",fill:"#c5c6c8",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M228,368.48h.81v-7.09h-.78l-.06-11H206.25v12.82H204V376h24Zm-23.55,6V367h10.9v7.48Z",fill:"#e6e7e7",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"211",y:"345.66",width:"12.31",height:"21.78",transform:"translate(573.71 139.4) rotate(90)",fill:"#6e6f71",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.13"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"221.63",y:"356.5",width:"12.18",height:"0.12",transform:"translate(584.28 128.85) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"221.34",y:"356.5",width:"12.18",height:"0.12",transform:"translate(583.99 129.14) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"221.05",y:"356.5",width:"12.18",height:"0.12",transform:"translate(583.7 129.42) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"220.76",y:"356.5",width:"12.18",height:"0.12",transform:"translate(583.41 129.71) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"220.47",y:"356.5",width:"12.18",height:"0.12",transform:"translate(583.13 130) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"220.19",y:"356.5",width:"12.18",height:"0.12",transform:"translate(582.84 130.29) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"219.9",y:"356.5",width:"12.18",height:"0.12",transform:"translate(582.55 130.58) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"219.61",y:"356.5",width:"12.18",height:"0.12",transform:"translate(582.26 130.87) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"219.32",y:"356.5",width:"12.18",height:"0.12",transform:"translate(581.97 131.16) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"219.03",y:"356.5",width:"12.18",height:"0.12",transform:"translate(581.68 131.44) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"218.74",y:"356.5",width:"12.18",height:"0.12",transform:"translate(581.39 131.73) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"218.45",y:"356.5",width:"12.18",height:"0.12",transform:"translate(581.11 132.02) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"218.17",y:"356.5",width:"12.18",height:"0.12",transform:"translate(580.82 132.31) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"217.88",y:"356.5",width:"12.18",height:"0.12",transform:"translate(580.53 132.6) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"217.59",y:"356.5",width:"12.18",height:"0.12",transform:"translate(580.24 132.89) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"217.3",y:"356.5",width:"12.18",height:"0.12",transform:"translate(579.95 133.18) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"217.01",y:"356.5",width:"12.18",height:"0.12",transform:"translate(579.66 133.46) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"216.72",y:"356.5",width:"12.18",height:"0.12",transform:"translate(579.38 133.75) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"216.43",y:"356.5",width:"12.18",height:"0.12",transform:"translate(579.09 134.04) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"216.15",y:"356.5",width:"12.18",height:"0.12",transform:"translate(578.8 134.33) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"215.86",y:"356.5",width:"12.18",height:"0.12",transform:"translate(578.51 134.62) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"215.57",y:"356.5",width:"12.18",height:"0.12",transform:"translate(578.22 134.91) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"215.28",y:"356.5",width:"12.18",height:"0.12",transform:"translate(577.93 135.2) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"214.99",y:"356.5",width:"12.18",height:"0.12",transform:"translate(577.64 135.48) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"214.7",y:"356.5",width:"12.18",height:"0.12",transform:"translate(577.36 135.77) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"214.42",y:"356.5",width:"12.18",height:"0.12",transform:"translate(577.07 136.06) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"214.13",y:"356.5",width:"12.18",height:"0.12",transform:"translate(576.78 136.35) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"213.84",y:"356.5",width:"12.18",height:"0.12",transform:"translate(576.49 136.64) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"213.55",y:"356.5",width:"12.18",height:"0.12",transform:"translate(576.2 136.93) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"213.26",y:"356.5",width:"12.18",height:"0.12",transform:"translate(575.91 137.21) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"212.97",y:"356.5",width:"12.18",height:"0.12",transform:"translate(575.62 137.5) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"212.68",y:"356.5",width:"12.18",height:"0.12",transform:"translate(575.34 137.79) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"212.4",y:"356.5",width:"12.18",height:"0.12",transform:"translate(575.05 138.08) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"212.11",y:"356.5",width:"12.18",height:"0.12",transform:"translate(574.76 138.37) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"211.82",y:"356.5",width:"12.18",height:"0.12",transform:"translate(574.47 138.66) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"211.53",y:"356.5",width:"12.18",height:"0.12",transform:"translate(574.18 138.95) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"211.24",y:"356.5",width:"12.18",height:"0.12",transform:"translate(573.89 139.23) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"210.95",y:"356.5",width:"12.18",height:"0.12",transform:"translate(573.61 139.52) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"210.66",y:"356.5",width:"12.18",height:"0.12",transform:"translate(573.32 139.81) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"210.38",y:"356.5",width:"12.18",height:"0.12",transform:"translate(573.03 140.1) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"210.09",y:"356.5",width:"12.18",height:"0.12",transform:"translate(572.74 140.39) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"209.8",y:"356.5",width:"12.18",height:"0.12",transform:"translate(572.45 140.68) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"209.51",y:"356.5",width:"12.18",height:"0.12",transform:"translate(572.16 140.97) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"209.22",y:"356.5",width:"12.18",height:"0.12",transform:"translate(571.87 141.25) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"208.93",y:"356.5",width:"12.18",height:"0.12",transform:"translate(571.59 141.54) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"208.64",y:"356.5",width:"12.18",height:"0.12",transform:"translate(571.3 141.83) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"208.36",y:"356.5",width:"12.18",height:"0.12",transform:"translate(571.01 142.12) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"208.07",y:"356.5",width:"12.18",height:"0.12",transform:"translate(570.72 142.41) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"207.78",y:"356.5",width:"12.18",height:"0.12",transform:"translate(570.43 142.7) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"207.49",y:"356.5",width:"12.18",height:"0.12",transform:"translate(570.14 142.98) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"207.2",y:"356.5",width:"12.18",height:"0.12",transform:"translate(569.85 143.27) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"206.91",y:"356.5",width:"12.18",height:"0.12",transform:"translate(569.57 143.56) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"206.63",y:"356.5",width:"12.18",height:"0.12",transform:"translate(569.28 143.85) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"206.34",y:"356.5",width:"12.18",height:"0.12",transform:"translate(568.99 144.14) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"206.05",y:"356.5",width:"12.18",height:"0.12",transform:"translate(568.7 144.43) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"205.76",y:"356.5",width:"12.18",height:"0.12",transform:"translate(568.41 144.72) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"205.47",y:"356.5",width:"12.18",height:"0.12",transform:"translate(568.12 145) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"205.18",y:"356.5",width:"12.18",height:"0.12",transform:"translate(567.84 145.29) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"204.89",y:"356.5",width:"12.18",height:"0.12",transform:"translate(567.55 145.58) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"204.61",y:"356.5",width:"12.18",height:"0.12",transform:"translate(567.26 145.87) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"204.32",y:"356.5",width:"12.18",height:"0.12",transform:"translate(566.97 146.16) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"204.03",y:"356.5",width:"12.18",height:"0.12",transform:"translate(566.68 146.45) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"203.74",y:"356.5",width:"12.18",height:"0.12",transform:"translate(566.39 146.74) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"203.45",y:"356.5",width:"12.18",height:"0.12",transform:"translate(566.1 147.02) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"203.16",y:"356.5",width:"12.18",height:"0.12",transform:"translate(565.82 147.31) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"202.87",y:"356.5",width:"12.18",height:"0.12",transform:"translate(565.53 147.6) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"202.59",y:"356.5",width:"12.18",height:"0.12",transform:"translate(565.24 147.89) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"202.3",y:"356.5",width:"12.18",height:"0.12",transform:"translate(564.95 148.18) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"202.01",y:"356.5",width:"12.18",height:"0.12",transform:"translate(564.66 148.47) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"201.72",y:"356.5",width:"12.18",height:"0.12",transform:"translate(564.37 148.75) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"201.43",y:"356.5",width:"12.18",height:"0.12",transform:"translate(564.08 149.04) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"201.14",y:"356.5",width:"12.18",height:"0.12",transform:"translate(563.8 149.33) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"200.86",y:"356.5",width:"12.18",height:"0.12",transform:"translate(563.51 149.62) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"200.57",y:"356.5",width:"12.18",height:"0.12",transform:"translate(563.22 149.91) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"243.77 342.74 242.68 342.74 242.68 334.47 268.26 334.47 268.26 341.33 268.26 342.74 268.26 349.6 243.77 349.6 243.77 342.74",fill:"#aee2fa",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"238.54",y:"337.13",width:"7.12",height:"4.1",transform:"translate(581.28 97.08) rotate(90)",fill:"#e0e0de",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"240.05",y:"343.74",width:"3.21",height:"3.22",transform:"translate(587.01 103.69) rotate(90)",fill:"#e0e0de",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"250.17",y:"337.29",width:"8.79",height:"21.61",transform:"translate(602.66 93.53) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"244.04",y:"352.15",width:"21.06",height:"21.61",transform:"translate(617.52 108.38) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"237.51",y:"352.58",width:"21.55",height:"21.61",transform:"translate(611.67 115.1) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"242.94",y:"365.75",width:"21.55",height:"21.61",transform:"translate(630.26 122.84) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"249.97",y:"369.32",width:"13.46",height:"21.61",transform:"translate(636.83 123.42) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"237.75",y:"375.13",width:"22.6",height:"19.83",transform:"translate(634.09 136) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M239.7,398.9h12.66a3.09,3.09,0,0,0,2.19,2.74h-17v0A3.09,3.09,0,0,0,239.7,398.9Z",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"239.66",y:"394.47",width:"12.72",height:"5.41",transform:"translate(492.04 794.35) rotate(-180)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"258.98 396.27 239.06 396.27 239.06 374.15 240.77 374.15 240.77 354.15 243.72 354.15 243.76 349.62 265.35 349.62 265.35 363.25 267.53 363.25 267.53 373.47 272.06 373.47 272.06 388.09 258.98 388.09 258.98 396.27",fill:"#a7a9ac",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"243.68 349.58 265.31 349.58 265.31 363.25 267.44 363.25 267.44 373.43 272.06 373.43 272.06 388.04 246.24 388.04 246.24 384.28 243.68 384.28 243.68 349.58",fill:"#c5c6c8",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M243.68,376h24V363.22h-2.23V350.4H243.71l-.07,11h-.77v7.09h.81Zm12.65-1.5V367h10.9v7.48Z",fill:"#e6e7e7",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"248.39",y:"345.66",width:"12.31",height:"21.78",transform:"translate(611.1 102.01) rotate(90)",fill:"#6e6f71",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.13"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"237.89",y:"356.5",width:"12.18",height:"0.12",transform:"translate(600.54 112.58) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"238.18",y:"356.5",width:"12.18",height:"0.12",transform:"translate(600.83 112.3) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"238.47",y:"356.5",width:"12.18",height:"0.12",transform:"translate(601.12 112.01) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"238.76",y:"356.5",width:"12.18",height:"0.12",transform:"translate(601.41 111.72) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"239.05",y:"356.5",width:"12.18",height:"0.12",transform:"translate(601.7 111.43) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"239.33",y:"356.5",width:"12.18",height:"0.12",transform:"translate(601.99 111.14) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"239.62",y:"356.5",width:"12.18",height:"0.12",transform:"translate(602.28 110.85) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"239.91",y:"356.5",width:"12.18",height:"0.12",transform:"translate(602.56 110.56) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"240.2",y:"356.5",width:"12.18",height:"0.12",transform:"translate(602.85 110.28) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"240.49",y:"356.5",width:"12.18",height:"0.12",transform:"translate(603.14 109.99) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"240.78",y:"356.5",width:"12.18",height:"0.12",transform:"translate(603.43 109.7) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"241.07",y:"356.5",width:"12.18",height:"0.12",transform:"translate(603.72 109.41) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"241.35",y:"356.5",width:"12.18",height:"0.12",transform:"translate(604.01 109.12) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"241.64",y:"356.5",width:"12.18",height:"0.12",transform:"translate(604.29 108.83) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"241.93",y:"356.5",width:"12.18",height:"0.12",transform:"translate(604.58 108.54) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"242.22",y:"356.5",width:"12.18",height:"0.12",transform:"translate(604.87 108.26) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"242.51",y:"356.5",width:"12.18",height:"0.12",transform:"translate(605.16 107.97) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"242.8",y:"356.5",width:"12.18",height:"0.12",transform:"translate(605.45 107.68) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"243.09",y:"356.5",width:"12.18",height:"0.12",transform:"translate(605.74 107.39) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"243.37",y:"356.5",width:"12.18",height:"0.12",transform:"translate(606.03 107.1) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"243.66",y:"356.5",width:"12.18",height:"0.12",transform:"translate(606.31 106.81) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"243.95",y:"356.5",width:"12.18",height:"0.12",transform:"translate(606.6 106.53) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"244.24",y:"356.5",width:"12.18",height:"0.12",transform:"translate(606.89 106.24) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"244.53",y:"356.5",width:"12.18",height:"0.12",transform:"translate(607.18 105.95) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"244.82",y:"356.5",width:"12.18",height:"0.12",transform:"translate(607.47 105.66) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"245.1",y:"356.5",width:"12.18",height:"0.12",transform:"translate(607.76 105.37) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"245.39",y:"356.5",width:"12.18",height:"0.12",transform:"translate(608.05 105.08) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"245.68",y:"356.5",width:"12.18",height:"0.12",transform:"translate(608.33 104.79) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"245.97",y:"356.5",width:"12.18",height:"0.12",transform:"translate(608.62 104.51) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"246.26",y:"356.5",width:"12.18",height:"0.12",transform:"translate(608.91 104.22) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"246.55",y:"356.5",width:"12.18",height:"0.12",transform:"translate(609.2 103.93) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"246.84",y:"356.5",width:"12.18",height:"0.12",transform:"translate(609.49 103.64) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"247.12",y:"356.5",width:"12.18",height:"0.12",transform:"translate(609.78 103.35) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"247.41",y:"356.5",width:"12.18",height:"0.12",transform:"translate(610.06 103.06) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"247.7",y:"356.5",width:"12.18",height:"0.12",transform:"translate(610.35 102.77) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"247.99",y:"356.5",width:"12.18",height:"0.12",transform:"translate(610.64 102.49) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"248.28",y:"356.5",width:"12.18",height:"0.12",transform:"translate(610.93 102.2) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"248.57",y:"356.5",width:"12.18",height:"0.12",transform:"translate(611.22 101.91) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"248.86",y:"356.5",width:"12.18",height:"0.12",transform:"translate(611.51 101.62) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"249.14",y:"356.5",width:"12.18",height:"0.12",transform:"translate(611.8 101.33) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"249.43",y:"356.5",width:"12.18",height:"0.12",transform:"translate(612.08 101.04) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"249.72",y:"356.5",width:"12.18",height:"0.12",transform:"translate(612.37 100.75) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"250.01",y:"356.5",width:"12.18",height:"0.12",transform:"translate(612.66 100.47) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"250.3",y:"356.5",width:"12.18",height:"0.12",transform:"translate(612.95 100.18) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"250.59",y:"356.5",width:"12.18",height:"0.12",transform:"translate(613.24 99.89) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"250.87",y:"356.5",width:"12.18",height:"0.12",transform:"translate(613.53 99.6) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"251.16",y:"356.5",width:"12.18",height:"0.12",transform:"translate(613.82 99.31) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"251.45",y:"356.5",width:"12.18",height:"0.12",transform:"translate(614.1 99.02) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"251.74",y:"356.5",width:"12.18",height:"0.12",transform:"translate(614.39 98.74) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"252.03",y:"356.5",width:"12.18",height:"0.12",transform:"translate(614.68 98.45) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"252.32",y:"356.5",width:"12.18",height:"0.12",transform:"translate(614.97 98.16) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"252.61",y:"356.5",width:"12.18",height:"0.12",transform:"translate(615.26 97.87) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"252.89",y:"356.5",width:"12.18",height:"0.12",transform:"translate(615.55 97.58) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"253.18",y:"356.5",width:"12.18",height:"0.12",transform:"translate(615.83 97.29) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"253.47",y:"356.5",width:"12.18",height:"0.12",transform:"translate(616.12 97) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"253.76",y:"356.5",width:"12.18",height:"0.12",transform:"translate(616.41 96.72) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"254.05",y:"356.5",width:"12.18",height:"0.12",transform:"translate(616.7 96.43) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"254.34",y:"356.5",width:"12.18",height:"0.12",transform:"translate(616.99 96.14) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"254.63",y:"356.5",width:"12.18",height:"0.12",transform:"translate(617.28 95.85) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"254.91",y:"356.5",width:"12.18",height:"0.12",transform:"translate(617.57 95.56) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"255.2",y:"356.5",width:"12.18",height:"0.12",transform:"translate(617.85 95.27) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"255.49",y:"356.5",width:"12.18",height:"0.12",transform:"translate(618.14 94.98) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"255.78",y:"356.5",width:"12.18",height:"0.12",transform:"translate(618.43 94.7) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"256.07",y:"356.5",width:"12.18",height:"0.12",transform:"translate(618.72 94.41) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"256.36",y:"356.5",width:"12.18",height:"0.12",transform:"translate(619.01 94.12) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"256.64",y:"356.5",width:"12.18",height:"0.12",transform:"translate(619.3 93.83) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"256.93",y:"356.5",width:"12.18",height:"0.12",transform:"translate(619.59 93.54) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"257.22",y:"356.5",width:"12.18",height:"0.12",transform:"translate(619.87 93.25) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"257.51",y:"356.5",width:"12.18",height:"0.12",transform:"translate(620.16 92.97) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"257.8",y:"356.5",width:"12.18",height:"0.12",transform:"translate(620.45 92.68) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"258.09",y:"356.5",width:"12.18",height:"0.12",transform:"translate(620.74 92.39) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"258.38",y:"356.5",width:"12.18",height:"0.12",transform:"translate(621.03 92.1) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"258.66",y:"356.5",width:"12.18",height:"0.12",transform:"translate(621.32 91.81) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"258.95",y:"356.5",width:"12.18",height:"0.12",transform:"translate(621.61 91.52) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"305.42 342.74 306.52 342.74 306.52 334.47 280.94 334.47 280.94 341.33 280.94 342.74 280.94 349.6 305.42 349.6 305.42 342.74",fill:"#aee2fa",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"303.54",y:"337.13",width:"7.12",height:"4.1",transform:"translate(646.27 32.08) rotate(90)",fill:"#e0e0de",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"305.93",y:"343.74",width:"3.21",height:"3.22",transform:"translate(652.88 37.81) rotate(90)",fill:"#e0e0de",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"290.23",y:"337.29",width:"8.79",height:"21.61",transform:"translate(642.72 53.47) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"284.09",y:"352.15",width:"21.06",height:"21.61",transform:"translate(657.57 68.32) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"290.13",y:"352.58",width:"21.55",height:"21.61",transform:"translate(664.29 62.48) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"284.7",y:"365.75",width:"21.55",height:"21.61",transform:"translate(672.03 81.07) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"285.76",y:"369.32",width:"13.46",height:"21.61",transform:"translate(672.61 87.64) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"288.85",y:"375.13",width:"22.6",height:"19.83",transform:"translate(685.2 84.9) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M309.5,398.9H296.83a3.09,3.09,0,0,1-2.19,2.74h17v0A3.06,3.06,0,0,1,309.5,398.9Z",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"296.81",y:"394.47",width:"12.72",height:"5.41",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"290.21 396.27 310.13 396.27 310.13 374.15 308.42 374.15 308.42 354.15 305.47 354.15 305.43 349.62 283.84 349.62 283.84 363.25 281.66 363.25 281.66 373.47 277.13 373.47 277.13 388.09 290.21 388.09 290.21 396.27",fill:"#a7a9ac",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"305.51 349.58 283.89 349.58 283.89 363.25 281.75 363.25 281.75 373.43 277.13 373.43 277.13 388.04 302.95 388.04 302.95 384.28 305.51 384.28 305.51 349.58",fill:"#c5c6c8",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M305.52,368.48h.81v-7.09h-.78l-.06-11H283.74v12.82h-2.23V376h24Zm-23.55,6V367h10.89v7.48Z",fill:"#e6e7e7",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"288.49",y:"345.66",width:"12.31",height:"21.78",transform:"translate(651.2 61.9) rotate(90)",fill:"#6e6f71",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.13"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"299.12",y:"356.5",width:"12.18",height:"0.12",transform:"translate(661.78 51.35) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"298.84",y:"356.5",width:"12.18",height:"0.12",transform:"translate(661.49 51.64) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"298.55",y:"356.5",width:"12.18",height:"0.12",transform:"translate(661.2 51.93) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"298.26",y:"356.5",width:"12.18",height:"0.12",transform:"translate(660.91 52.22) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"297.97",y:"356.5",width:"12.18",height:"0.12",transform:"translate(660.62 52.51) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"297.68",y:"356.5",width:"12.18",height:"0.12",transform:"translate(660.33 52.79) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"297.39",y:"356.5",width:"12.18",height:"0.12",transform:"translate(660.05 53.08) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"297.1",y:"356.5",width:"12.18",height:"0.12",transform:"translate(659.76 53.37) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"296.82",y:"356.5",width:"12.18",height:"0.12",transform:"translate(659.47 53.66) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"296.53",y:"356.5",width:"12.18",height:"0.12",transform:"translate(659.18 53.95) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"296.24",y:"356.5",width:"12.18",height:"0.12",transform:"translate(658.89 54.24) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"295.95",y:"356.5",width:"12.18",height:"0.12",transform:"translate(658.6 54.53) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"295.66",y:"356.5",width:"12.18",height:"0.12",transform:"translate(658.31 54.81) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"295.37",y:"356.5",width:"12.18",height:"0.12",transform:"translate(658.03 55.1) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"295.09",y:"356.5",width:"12.18",height:"0.12",transform:"translate(657.74 55.39) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"294.8",y:"356.5",width:"12.18",height:"0.12",transform:"translate(657.45 55.68) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"294.51",y:"356.5",width:"12.18",height:"0.12",transform:"translate(657.16 55.97) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"294.22",y:"356.5",width:"12.18",height:"0.12",transform:"translate(656.87 56.26) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"293.93",y:"356.5",width:"12.18",height:"0.12",transform:"translate(656.58 56.54) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"293.64",y:"356.5",width:"12.18",height:"0.12",transform:"translate(656.29 56.83) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"293.35",y:"356.5",width:"12.18",height:"0.12",transform:"translate(656.01 57.12) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"293.07",y:"356.5",width:"12.18",height:"0.12",transform:"translate(655.72 57.41) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"292.78",y:"356.5",width:"12.18",height:"0.12",transform:"translate(655.43 57.7) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"292.49",y:"356.5",width:"12.18",height:"0.12",transform:"translate(655.14 57.99) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"292.2",y:"356.5",width:"12.18",height:"0.12",transform:"translate(654.85 58.28) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"291.91",y:"356.5",width:"12.18",height:"0.12",transform:"translate(654.56 58.56) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"291.62",y:"356.5",width:"12.18",height:"0.12",transform:"translate(654.28 58.85) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"291.33",y:"356.5",width:"12.18",height:"0.12",transform:"translate(653.99 59.14) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"291.05",y:"356.5",width:"12.18",height:"0.12",transform:"translate(653.7 59.43) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"290.76",y:"356.5",width:"12.18",height:"0.12",transform:"translate(653.41 59.72) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"290.47",y:"356.5",width:"12.18",height:"0.12",transform:"translate(653.12 60.01) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"290.18",y:"356.5",width:"12.18",height:"0.12",transform:"translate(652.83 60.3) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"289.89",y:"356.5",width:"12.18",height:"0.12",transform:"translate(652.54 60.58) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"289.6",y:"356.5",width:"12.18",height:"0.12",transform:"translate(652.26 60.87) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"289.31",y:"356.5",width:"12.18",height:"0.12",transform:"translate(651.97 61.16) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"289.03",y:"356.5",width:"12.18",height:"0.12",transform:"translate(651.68 61.45) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"288.74",y:"356.5",width:"12.18",height:"0.12",transform:"translate(651.39 61.74) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"288.45",y:"356.5",width:"12.18",height:"0.12",transform:"translate(651.1 62.03) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"288.16",y:"356.5",width:"12.18",height:"0.12",transform:"translate(650.81 62.31) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"287.87",y:"356.5",width:"12.18",height:"0.12",transform:"translate(650.52 62.6) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"287.58",y:"356.5",width:"12.18",height:"0.12",transform:"translate(650.24 62.89) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"287.3",y:"356.5",width:"12.18",height:"0.12",transform:"translate(649.95 63.18) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"287.01",y:"356.5",width:"12.18",height:"0.12",transform:"translate(649.66 63.47) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"286.72",y:"356.5",width:"12.18",height:"0.12",transform:"translate(649.37 63.76) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"286.43",y:"356.5",width:"12.18",height:"0.12",transform:"translate(649.08 64.05) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"286.14",y:"356.5",width:"12.18",height:"0.12",transform:"translate(648.79 64.33) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"285.85",y:"356.5",width:"12.18",height:"0.12",transform:"translate(648.5 64.62) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"285.56",y:"356.5",width:"12.18",height:"0.12",transform:"translate(648.22 64.91) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"285.28",y:"356.5",width:"12.18",height:"0.12",transform:"translate(647.93 65.2) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"284.99",y:"356.5",width:"12.18",height:"0.12",transform:"translate(647.64 65.49) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"284.7",y:"356.5",width:"12.18",height:"0.12",transform:"translate(647.35 65.78) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"284.41",y:"356.5",width:"12.18",height:"0.12",transform:"translate(647.06 66.07) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"284.12",y:"356.5",width:"12.18",height:"0.12",transform:"translate(646.77 66.35) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"283.83",y:"356.5",width:"12.18",height:"0.12",transform:"translate(646.49 66.64) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"283.54",y:"356.5",width:"12.18",height:"0.12",transform:"translate(646.2 66.93) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"283.26",y:"356.5",width:"12.18",height:"0.12",transform:"translate(645.91 67.22) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"282.97",y:"356.5",width:"12.18",height:"0.12",transform:"translate(645.62 67.51) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"282.68",y:"356.5",width:"12.18",height:"0.12",transform:"translate(645.33 67.8) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"282.39",y:"356.5",width:"12.18",height:"0.12",transform:"translate(645.04 68.08) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"282.1",y:"356.5",width:"12.18",height:"0.12",transform:"translate(644.75 68.37) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"281.81",y:"356.5",width:"12.18",height:"0.12",transform:"translate(644.47 68.66) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"281.53",y:"356.5",width:"12.18",height:"0.12",transform:"translate(644.18 68.95) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"281.24",y:"356.5",width:"12.18",height:"0.12",transform:"translate(643.89 69.24) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"280.95",y:"356.5",width:"12.18",height:"0.12",transform:"translate(643.6 69.53) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"280.66",y:"356.5",width:"12.18",height:"0.12",transform:"translate(643.31 69.82) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"280.37",y:"356.5",width:"12.18",height:"0.12",transform:"translate(643.02 70.1) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"280.08",y:"356.5",width:"12.18",height:"0.12",transform:"translate(642.73 70.39) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"279.79",y:"356.5",width:"12.18",height:"0.12",transform:"translate(642.45 70.68) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"279.51",y:"356.5",width:"12.18",height:"0.12",transform:"translate(642.16 70.97) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"279.22",y:"356.5",width:"12.18",height:"0.12",transform:"translate(641.87 71.26) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"278.93",y:"356.5",width:"12.18",height:"0.12",transform:"translate(641.58 71.55) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"278.64",y:"356.5",width:"12.18",height:"0.12",transform:"translate(641.29 71.84) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"278.35",y:"356.5",width:"12.18",height:"0.12",transform:"translate(641 72.12) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"278.06",y:"356.5",width:"12.18",height:"0.12",transform:"translate(640.72 72.41) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"321.27 342.74 320.17 342.74 320.17 334.47 345.75 334.47 345.75 341.33 345.75 342.74 345.75 349.6 321.27 349.6 321.27 342.74",fill:"#aee2fa",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"316.04",y:"337.13",width:"7.12",height:"4.1",transform:"translate(658.77 19.58) rotate(90)",fill:"#e0e0de",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"317.55",y:"343.74",width:"3.21",height:"3.22",transform:"translate(664.5 26.2) rotate(90)",fill:"#e0e0de",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"327.67",y:"337.29",width:"8.79",height:"21.61",transform:"translate(680.16 16.03) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"321.53",y:"352.15",width:"21.06",height:"21.61",transform:"translate(695.01 30.88) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"315.01",y:"352.58",width:"21.55",height:"21.61",transform:"translate(689.17 37.6) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"320.43",y:"365.75",width:"21.55",height:"21.61",transform:"translate(707.76 45.34) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"327.47",y:"369.32",width:"13.46",height:"21.61",transform:"translate(714.32 45.92) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"315.24",y:"375.13",width:"22.6",height:"19.83",transform:"translate(711.59 58.51) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M317.19,398.9h12.67a3.09,3.09,0,0,0,2.19,2.74h-17v0A3.06,3.06,0,0,0,317.19,398.9Z",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"317.16",y:"394.47",width:"12.72",height:"5.41",transform:"translate(647.04 794.35) rotate(-180)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"336.48 396.27 316.56 396.27 316.56 374.15 318.27 374.15 318.27 354.15 321.22 354.15 321.26 349.62 342.85 349.62 342.85 363.25 345.03 363.25 345.03 373.47 349.56 373.47 349.56 388.09 336.48 388.09 336.48 396.27",fill:"#a7a9ac",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"321.18 349.58 342.8 349.58 342.8 363.25 344.94 363.25 344.94 373.43 349.56 373.43 349.56 388.04 323.74 388.04 323.74 384.28 321.18 384.28 321.18 349.58",fill:"#c5c6c8",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M321.17,376h24V363.22H343V350.4H321.2l-.06,11h-.78v7.09h.81Zm12.65-1.5V367h10.9v7.48Z",fill:"#e6e7e7",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"325.88",y:"345.66",width:"12.31",height:"21.78",transform:"translate(688.59 24.51) rotate(90)",fill:"#6e6f71",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.13"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"315.39",y:"356.5",width:"12.18",height:"0.12",transform:"translate(678.04 35.09) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"315.68",y:"356.5",width:"12.18",height:"0.12",transform:"translate(678.33 34.8) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"315.97",y:"356.5",width:"12.18",height:"0.12",transform:"translate(678.62 34.51) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"316.25",y:"356.5",width:"12.18",height:"0.12",transform:"translate(678.91 34.22) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"316.54",y:"356.5",width:"12.18",height:"0.12",transform:"translate(679.19 33.93) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"316.83",y:"356.5",width:"12.18",height:"0.12",transform:"translate(679.48 33.64) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"317.12",y:"356.5",width:"12.18",height:"0.12",transform:"translate(679.77 33.36) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"317.41",y:"356.5",width:"12.18",height:"0.12",transform:"translate(680.06 33.07) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"317.7",y:"356.5",width:"12.18",height:"0.12",transform:"translate(680.35 32.78) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"317.98",y:"356.5",width:"12.18",height:"0.12",transform:"translate(680.64 32.49) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"318.27",y:"356.5",width:"12.18",height:"0.12",transform:"translate(680.93 32.2) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"318.56",y:"356.5",width:"12.18",height:"0.12",transform:"translate(681.21 31.91) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"318.85",y:"356.5",width:"12.18",height:"0.12",transform:"translate(681.5 31.63) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"319.14",y:"356.5",width:"12.18",height:"0.12",transform:"translate(681.79 31.34) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"319.43",y:"356.5",width:"12.18",height:"0.12",transform:"translate(682.08 31.05) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"319.72",y:"356.5",width:"12.18",height:"0.12",transform:"translate(682.37 30.76) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"320",y:"356.5",width:"12.18",height:"0.12",transform:"translate(682.66 30.47) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"320.29",y:"356.5",width:"12.18",height:"0.12",transform:"translate(682.94 30.18) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"320.58",y:"356.5",width:"12.18",height:"0.12",transform:"translate(683.23 29.89) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"320.87",y:"356.5",width:"12.18",height:"0.12",transform:"translate(683.52 29.61) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"321.16",y:"356.5",width:"12.18",height:"0.12",transform:"translate(683.81 29.32) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"321.45",y:"356.5",width:"12.18",height:"0.12",transform:"translate(684.1 29.03) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"321.74",y:"356.5",width:"12.18",height:"0.12",transform:"translate(684.39 28.74) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"322.02",y:"356.5",width:"12.18",height:"0.12",transform:"translate(684.68 28.45) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"322.31",y:"356.5",width:"12.18",height:"0.12",transform:"translate(684.96 28.16) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"322.6",y:"356.5",width:"12.18",height:"0.12",transform:"translate(685.25 27.87) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"322.89",y:"356.5",width:"12.18",height:"0.12",transform:"translate(685.54 27.59) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"323.18",y:"356.5",width:"12.18",height:"0.12",transform:"translate(685.83 27.3) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"323.47",y:"356.5",width:"12.18",height:"0.12",transform:"translate(686.12 27.01) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"323.75",y:"356.5",width:"12.18",height:"0.12",transform:"translate(686.41 26.72) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"324.04",y:"356.5",width:"12.18",height:"0.12",transform:"translate(686.7 26.43) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"324.33",y:"356.5",width:"12.18",height:"0.12",transform:"translate(686.98 26.14) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"324.62",y:"356.5",width:"12.18",height:"0.12",transform:"translate(687.27 25.86) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"324.91",y:"356.5",width:"12.18",height:"0.12",transform:"translate(687.56 25.57) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"325.2",y:"356.5",width:"12.18",height:"0.12",transform:"translate(687.85 25.28) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"325.49",y:"356.5",width:"12.18",height:"0.12",transform:"translate(688.14 24.99) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"325.77",y:"356.5",width:"12.18",height:"0.12",transform:"translate(688.43 24.7) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"326.06",y:"356.5",width:"12.18",height:"0.12",transform:"translate(688.72 24.41) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"326.35",y:"356.5",width:"12.18",height:"0.12",transform:"translate(689 24.12) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"326.64",y:"356.5",width:"12.18",height:"0.12",transform:"translate(689.29 23.84) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"326.93",y:"356.5",width:"12.18",height:"0.12",transform:"translate(689.58 23.55) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"327.22",y:"356.5",width:"12.18",height:"0.12",transform:"translate(689.87 23.26) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"327.51",y:"356.5",width:"12.18",height:"0.12",transform:"translate(690.16 22.97) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"327.79",y:"356.5",width:"12.18",height:"0.12",transform:"translate(690.45 22.68) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"328.08",y:"356.5",width:"12.18",height:"0.12",transform:"translate(690.73 22.39) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"328.37",y:"356.5",width:"12.18",height:"0.12",transform:"translate(691.02 22.1) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"328.66",y:"356.5",width:"12.18",height:"0.12",transform:"translate(691.31 21.82) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"328.95",y:"356.5",width:"12.18",height:"0.12",transform:"translate(691.6 21.53) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"329.24",y:"356.5",width:"12.18",height:"0.12",transform:"translate(691.89 21.24) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"329.53",y:"356.5",width:"12.18",height:"0.12",transform:"translate(692.18 20.95) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"329.81",y:"356.5",width:"12.18",height:"0.12",transform:"translate(692.47 20.66) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"330.1",y:"356.5",width:"12.18",height:"0.12",transform:"translate(692.75 20.37) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"330.39",y:"356.5",width:"12.18",height:"0.12",transform:"translate(693.04 20.09) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"330.68",y:"356.5",width:"12.18",height:"0.12",transform:"translate(693.33 19.8) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"330.97",y:"356.5",width:"12.18",height:"0.12",transform:"translate(693.62 19.51) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"331.26",y:"356.5",width:"12.18",height:"0.12",transform:"translate(693.91 19.22) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"331.54",y:"356.5",width:"12.18",height:"0.12",transform:"translate(694.2 18.93) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"331.83",y:"356.5",width:"12.18",height:"0.12",transform:"translate(694.49 18.64) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"332.12",y:"356.5",width:"12.18",height:"0.12",transform:"translate(694.77 18.35) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"332.41",y:"356.5",width:"12.18",height:"0.12",transform:"translate(695.06 18.07) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"332.7",y:"356.5",width:"12.18",height:"0.12",transform:"translate(695.35 17.78) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"332.99",y:"356.5",width:"12.18",height:"0.12",transform:"translate(695.64 17.49) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"333.28",y:"356.5",width:"12.18",height:"0.12",transform:"translate(695.93 17.2) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"333.56",y:"356.5",width:"12.18",height:"0.12",transform:"translate(696.22 16.91) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"333.85",y:"356.5",width:"12.18",height:"0.12",transform:"translate(696.5 16.62) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"334.14",y:"356.5",width:"12.18",height:"0.12",transform:"translate(696.79 16.33) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"334.43",y:"356.5",width:"12.18",height:"0.12",transform:"translate(697.08 16.05) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"334.72",y:"356.5",width:"12.18",height:"0.12",transform:"translate(697.37 15.76) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"335.01",y:"356.5",width:"12.18",height:"0.12",transform:"translate(697.66 15.47) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"335.3",y:"356.5",width:"12.18",height:"0.12",transform:"translate(697.95 15.18) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"335.58",y:"356.5",width:"12.18",height:"0.12",transform:"translate(698.24 14.89) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"335.87",y:"356.5",width:"12.18",height:"0.12",transform:"translate(698.52 14.6) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"336.16",y:"356.5",width:"12.18",height:"0.12",transform:"translate(698.81 14.31) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"336.45",y:"356.5",width:"12.18",height:"0.12",transform:"translate(699.1 14.03) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"150.43 321.38 151.53 321.38 151.53 329.65 125.94 329.65 125.94 322.79 125.94 321.38 125.94 314.52 150.43 314.52 150.43 321.38",fill:"#aee2fa",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"148.54",y:"322.89",width:"7.12",height:"4.1",transform:"translate(-172.84 477.04) rotate(-90)",fill:"#e0e0de",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"150.94",y:"317.16",width:"3.21",height:"3.22",transform:"translate(-166.23 471.31) rotate(-90)",fill:"#e0e0de",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"135.24",y:"305.22",width:"8.79",height:"21.61",transform:"translate(-176.39 455.66) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"129.1",y:"290.37",width:"21.06",height:"21.61",transform:"translate(-161.54 440.8) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"135.14",y:"289.93",width:"21.55",height:"21.61",transform:"translate(-154.82 446.65) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"129.71",y:"276.77",width:"21.55",height:"21.61",transform:"translate(-147.08 428.06) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"130.76",y:"273.19",width:"13.46",height:"21.61",transform:"translate(-146.5 421.49) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"133.86",y:"269.16",width:"22.6",height:"19.83",transform:"translate(-133.92 424.23) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M154.5,267.61H141.84a3.09,3.09,0,0,0-2.19-2.74h17v0A3.09,3.09,0,0,0,154.5,267.61Z",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"141.82",y:"266.62",width:"12.72",height:"5.41",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"135.22 267.85 155.14 267.85 155.14 289.97 153.43 289.97 153.43 309.97 150.48 309.97 150.44 314.5 128.85 314.5 128.85 300.87 126.67 300.87 126.67 290.65 122.14 290.65 122.14 276.03 135.22 276.03 135.22 267.85",fill:"#a7a9ac",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"150.52 314.54 128.89 314.54 128.89 300.87 126.76 300.87 126.76 290.69 122.14 290.69 122.14 276.08 147.96 276.08 147.96 279.84 150.52 279.84 150.52 314.54",fill:"#c5c6c8",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M150.52,288.17h-24V300.9h2.23v12.82h21.74l.07-11h.77v-7.09h-.81Zm-12.65,1.5v7.48H127v-7.48Z",fill:"#e6e7e7",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"133.5",y:"296.67",width:"12.31",height:"21.78",transform:"translate(-167.91 447.22) rotate(-90)",fill:"#6e6f71",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.13"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"144.13",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-157.34 457.78) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"143.84",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-157.62 457.49) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"143.55",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-157.91 457.2) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"143.27",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-158.2 456.91) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"142.98",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-158.49 456.62) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"142.69",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-158.78 456.33) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"142.4",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-159.07 456.04) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"142.11",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-159.36 455.76) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"141.82",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-159.64 455.47) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"141.53",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-159.93 455.18) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"141.25",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-160.22 454.89) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"140.96",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-160.51 454.6) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"140.67",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-160.8 454.31) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"140.38",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-161.09 454.03) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"140.09",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-161.38 453.74) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"139.8",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-161.66 453.45) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"139.52",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-161.95 453.16) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"139.23",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-162.24 452.87) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"138.94",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-162.53 452.58) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"138.65",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-162.82 452.29) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"138.36",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-163.11 452.01) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"138.07",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-163.4 451.72) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"137.78",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-163.68 451.43) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"137.5",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-163.97 451.14) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"137.21",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-164.26 450.85) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"136.92",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-164.55 450.56) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"136.63",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-164.84 450.27) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"136.34",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-165.13 449.99) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"136.05",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-165.41 449.7) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"135.76",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-165.7 449.41) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"135.48",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-165.99 449.12) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"135.19",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-166.28 448.83) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"134.9",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-166.57 448.54) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"134.61",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-166.86 448.26) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"134.32",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-167.15 447.97) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"134.03",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-167.43 447.68) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"133.75",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-167.72 447.39) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"133.46",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-168.01 447.1) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"133.17",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-168.3 446.81) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"132.88",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-168.59 446.52) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"132.59",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-168.88 446.24) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"132.3",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-169.17 445.95) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"132.01",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-169.45 445.66) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"131.73",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-169.74 445.37) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"131.44",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-170.03 445.08) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"131.15",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-170.32 444.79) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"130.86",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-170.61 444.5) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"130.57",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-170.9 444.22) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"130.28",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-171.18 443.93) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"129.99",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-171.47 443.64) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"129.71",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-171.76 443.35) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"129.42",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-172.05 443.06) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"129.13",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-172.34 442.77) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"128.84",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-172.63 442.48) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"128.55",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-172.92 442.2) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"128.26",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-173.2 441.91) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"127.98",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-173.49 441.62) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"127.69",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-173.78 441.33) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"127.4",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-174.07 441.04) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"127.11",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-174.36 440.75) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"126.82",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-174.65 440.47) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"126.53",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-174.94 440.18) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"126.24",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-175.22 439.89) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"125.96",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-175.51 439.6) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"125.67",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-175.8 439.31) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"125.38",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-176.09 439.02) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"125.09",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-176.38 438.73) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"124.8",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-176.67 438.45) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"124.51",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-176.95 438.16) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"124.22",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-177.24 437.87) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"123.94",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-177.53 437.58) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"123.65",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-177.82 437.29) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"123.36",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-178.11 437) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"123.07",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-178.4 436.71) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"166.27 321.38 165.18 321.38 165.18 329.65 190.76 329.65 190.76 322.79 190.76 321.38 190.76 314.52 166.27 314.52 166.27 321.38",fill:"#aee2fa",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"161.04",y:"322.89",width:"7.12",height:"4.1",transform:"translate(-160.34 489.54) rotate(-90)",fill:"#e0e0de",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"162.55",y:"317.16",width:"3.21",height:"3.22",transform:"translate(-154.61 482.93) rotate(-90)",fill:"#e0e0de",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"172.68",y:"305.22",width:"8.79",height:"21.61",transform:"translate(-138.95 493.1) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"166.54",y:"290.37",width:"21.06",height:"21.61",transform:"translate(-124.1 478.24) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"160.01",y:"289.93",width:"21.55",height:"21.61",transform:"translate(-129.95 471.52) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"165.44",y:"276.77",width:"21.55",height:"21.61",transform:"translate(-111.35 463.79) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"172.48",y:"273.19",width:"13.46",height:"21.61",transform:"translate(-104.79 463.21) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"160.25",y:"269.16",width:"22.6",height:"19.83",transform:"translate(-107.53 450.62) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M162.2,267.61h12.67a3.08,3.08,0,0,1,2.19-2.74h-17v0A3.07,3.07,0,0,1,162.2,267.61Z",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"162.17",y:"266.62",width:"12.72",height:"5.41",transform:"translate(337.05 538.66) rotate(-180)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"181.49 267.85 161.57 267.85 161.57 289.97 163.28 289.97 163.28 309.97 166.23 309.97 166.27 314.5 187.85 314.5 187.85 300.87 190.03 300.87 190.03 290.65 194.56 290.65 194.56 276.03 181.49 276.03 181.49 267.85",fill:"#a7a9ac",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"166.18 314.54 187.81 314.54 187.81 300.87 189.95 300.87 189.95 290.69 194.56 290.69 194.56 276.08 168.75 276.08 168.75 279.84 166.18 279.84 166.18 314.54",fill:"#c5c6c8",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M166.18,295.64h-.81v7.09h.78l.06,11H188V300.9h2.23V288.17h-24Zm23.55-6v7.48h-10.9v-7.48Z",fill:"#e6e7e7",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"170.89",y:"296.67",width:"12.31",height:"21.78",transform:"translate(-130.52 484.61) rotate(-90)",fill:"#6e6f71",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.13"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"160.4",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-141.07 474.04) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"160.68",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-140.78 474.33) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"160.97",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-140.5 474.62) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"161.26",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-140.21 474.91) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"161.55",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-139.92 475.19) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"161.84",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-139.63 475.48) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"162.13",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-139.34 475.77) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"162.42",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-139.05 476.06) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"162.7",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-138.76 476.35) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"162.99",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-138.48 476.64) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"163.28",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-138.19 476.92) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"163.57",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-137.9 477.21) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"163.86",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-137.61 477.5) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"164.15",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-137.32 477.79) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"164.43",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-137.03 478.08) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"164.72",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-136.74 478.37) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"165.01",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-136.46 478.66) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"165.3",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-136.17 478.94) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"165.59",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-135.88 479.23) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"165.88",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-135.59 479.52) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"166.17",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-135.3 479.81) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"166.45",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-135.01 480.1) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"166.74",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-134.73 480.39) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"167.03",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-134.44 480.68) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"167.32",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-134.15 480.96) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"167.61",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-133.86 481.25) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"167.9",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-133.57 481.54) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"168.19",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-133.28 481.83) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"168.47",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-132.99 482.12) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"168.76",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-132.71 482.41) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"169.05",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-132.42 482.7) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"169.34",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-132.13 482.98) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"169.63",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-131.84 483.27) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"169.92",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-131.55 483.56) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"170.2",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-131.26 483.85) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"170.49",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-130.97 484.14) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"170.78",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-130.69 484.43) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"171.07",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-130.4 484.71) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"171.36",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-130.11 485) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"171.65",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-129.82 485.29) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"171.94",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-129.53 485.58) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"172.22",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-129.24 485.87) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"172.51",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-128.95 486.16) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"172.8",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-128.67 486.45) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"173.09",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-128.38 486.73) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"173.38",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-128.09 487.02) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"173.67",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-127.8 487.31) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"173.96",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-127.51 487.6) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"174.24",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-127.22 487.89) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"174.53",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-126.94 488.18) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"174.82",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-126.65 488.47) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"175.11",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-126.36 488.75) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"175.4",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-126.07 489.04) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"175.69",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-125.78 489.33) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"175.97",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-125.49 489.62) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"176.26",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-125.2 489.91) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"176.55",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-124.92 490.2) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"176.84",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-124.63 490.48) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"177.13",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-124.34 490.77) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"177.42",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-124.05 491.06) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"177.71",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-123.76 491.35) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"177.99",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-123.47 491.64) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"178.28",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-123.18 491.93) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"178.57",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-122.9 492.22) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"178.86",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-122.61 492.5) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"179.15",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-122.32 492.79) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"179.44",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-122.03 493.08) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"179.73",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-121.74 493.37) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"180.01",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-121.45 493.66) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"180.3",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-121.17 493.95) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"180.59",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-120.88 494.24) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"180.88",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-120.59 494.52) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"181.17",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-120.3 494.81) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"181.46",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-120.01 495.1) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"227.93 321.38 229.02 321.38 229.02 329.65 203.44 329.65 203.44 322.79 203.44 321.38 203.44 314.52 227.93 314.52 227.93 321.38",fill:"#aee2fa",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"226.04",y:"322.89",width:"7.12",height:"4.1",transform:"translate(-95.34 554.54) rotate(-90)",fill:"#e0e0de",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"228.43",y:"317.16",width:"3.21",height:"3.22",transform:"translate(-88.73 548.81) rotate(-90)",fill:"#e0e0de",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"212.73",y:"305.22",width:"8.79",height:"21.61",transform:"translate(-98.9 533.15) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"206.6",y:"290.37",width:"21.06",height:"21.61",transform:"translate(-84.04 518.3) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"212.64",y:"289.93",width:"21.55",height:"21.61",transform:"translate(-77.32 524.15) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"207.21",y:"276.77",width:"21.55",height:"21.61",transform:"translate(-69.59 505.55) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"208.26",y:"273.19",width:"13.46",height:"21.61",transform:"translate(-69.01 498.99) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"211.35",y:"269.16",width:"22.6",height:"19.83",transform:"translate(-56.42 501.73) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M232,267.61H219.33a3.08,3.08,0,0,0-2.19-2.74h17v0A3.07,3.07,0,0,0,232,267.61Z",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"219.32",y:"266.62",width:"12.72",height:"5.41",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"212.72 267.85 232.63 267.85 232.63 289.97 230.92 289.97 230.92 309.97 227.97 309.97 227.93 314.5 206.35 314.5 206.35 300.87 204.17 300.87 204.17 290.65 199.64 290.65 199.64 276.03 212.72 276.03 212.72 267.85",fill:"#a7a9ac",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"228.02 314.54 206.39 314.54 206.39 300.87 204.25 300.87 204.25 290.69 199.64 290.69 199.64 276.08 225.45 276.08 225.45 279.84 228.02 279.84 228.02 314.54",fill:"#c5c6c8",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M228,288.17H204V300.9h2.23v12.82H228l.06-11h.78v-7.09H228Zm-12.65,1.5v7.48h-10.9v-7.48Z",fill:"#e6e7e7",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"211",y:"296.67",width:"12.31",height:"21.78",transform:"translate(-90.41 524.72) rotate(-90)",fill:"#6e6f71",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.13"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"221.63",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-79.84 535.27) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"221.34",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-80.13 534.98) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"221.05",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-80.42 534.7) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"220.76",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-80.71 534.41) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"220.47",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-80.99 534.12) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"220.19",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-81.28 533.83) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"219.9",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-81.57 533.54) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"219.61",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-81.86 533.25) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"219.32",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-82.15 532.96) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"219.03",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-82.44 532.68) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"218.74",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-82.73 532.39) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"218.45",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-83.01 532.1) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"218.17",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-83.3 531.81) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"217.88",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-83.59 531.52) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"217.59",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-83.88 531.23) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"217.3",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-84.17 530.94) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"217.01",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-84.46 530.66) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"216.72",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-84.74 530.37) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"216.43",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-85.03 530.08) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"216.15",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-85.32 529.79) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"215.86",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-85.61 529.5) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"215.57",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-85.9 529.21) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"215.28",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-86.19 528.92) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"214.99",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-86.48 528.64) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"214.7",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-86.76 528.35) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"214.42",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-87.05 528.06) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"214.13",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-87.34 527.77) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"213.84",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-87.63 527.48) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"213.55",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-87.92 527.19) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"213.26",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-88.21 526.91) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"212.97",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-88.5 526.62) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"212.68",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-88.78 526.33) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"212.4",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-89.07 526.04) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"212.11",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-89.36 525.75) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"211.82",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-89.65 525.46) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"211.53",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-89.94 525.17) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"211.24",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-90.23 524.89) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"210.95",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-90.51 524.6) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"210.66",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-90.8 524.31) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"210.38",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-91.09 524.02) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"210.09",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-91.38 523.73) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"209.8",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-91.67 523.44) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"209.51",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-91.96 523.15) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"209.22",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-92.25 522.87) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"208.93",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-92.53 522.58) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"208.64",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-92.82 522.29) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"208.36",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-93.11 522) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"208.07",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-93.4 521.71) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"207.78",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-93.69 521.42) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"207.49",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-93.98 521.14) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"207.2",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-94.27 520.85) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"206.91",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-94.55 520.56) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"206.63",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-94.84 520.27) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"206.34",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-95.13 519.98) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"206.05",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-95.42 519.69) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"205.76",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-95.71 519.4) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"205.47",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-96 519.12) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"205.18",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-96.28 518.83) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"204.89",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-96.57 518.54) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"204.61",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-96.86 518.25) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"204.32",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-97.15 517.96) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"204.03",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-97.44 517.67) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"203.74",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-97.73 517.38) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"203.45",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-98.02 517.1) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"203.16",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-98.3 516.81) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"202.87",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-98.59 516.52) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"202.59",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-98.88 516.23) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"202.3",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-99.17 515.94) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"202.01",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-99.46 515.65) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"201.72",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-99.75 515.37) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"201.43",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-100.04 515.08) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"201.14",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-100.32 514.79) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"200.86",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-100.61 514.5) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"200.57",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-100.9 514.21) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"243.77 321.38 242.68 321.38 242.68 329.65 268.26 329.65 268.26 322.79 268.26 321.38 268.26 314.52 243.77 314.52 243.77 321.38",fill:"#aee2fa",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"238.54",y:"322.89",width:"7.12",height:"4.1",transform:"translate(-82.84 567.04) rotate(-90)",fill:"#e0e0de",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"240.05",y:"317.16",width:"3.21",height:"3.22",transform:"translate(-77.11 560.43) rotate(-90)",fill:"#e0e0de",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"250.17",y:"305.22",width:"8.79",height:"21.61",transform:"translate(-61.46 570.59) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"244.04",y:"290.37",width:"21.06",height:"21.61",transform:"translate(-46.6 555.74) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"237.51",y:"289.93",width:"21.55",height:"21.61",transform:"translate(-52.45 549.02) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"242.94",y:"276.77",width:"21.55",height:"21.61",transform:"translate(-33.86 541.28) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"249.97",y:"273.19",width:"13.46",height:"21.61",transform:"translate(-27.29 540.7) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"237.75",y:"269.16",width:"22.6",height:"19.83",transform:"translate(-30.03 528.12) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M239.7,267.61h12.66a3.09,3.09,0,0,1,2.19-2.74h-17v0A3.09,3.09,0,0,1,239.7,267.61Z",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"239.66",y:"266.62",width:"12.72",height:"5.41",transform:"translate(492.04 538.66) rotate(-180)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"258.98 267.85 239.06 267.85 239.06 289.97 240.77 289.97 240.77 309.97 243.72 309.97 243.76 314.5 265.35 314.5 265.35 300.87 267.53 300.87 267.53 290.65 272.06 290.65 272.06 276.03 258.98 276.03 258.98 267.85",fill:"#a7a9ac",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"243.68 314.54 265.31 314.54 265.31 300.87 267.44 300.87 267.44 290.69 272.06 290.69 272.06 276.08 246.24 276.08 246.24 279.84 243.68 279.84 243.68 314.54",fill:"#c5c6c8",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M243.68,295.64h-.81v7.09h.77l.07,11h21.74V300.9h2.23V288.17h-24Zm23.55-6v7.48h-10.9v-7.48Z",fill:"#e6e7e7",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"248.39",y:"296.67",width:"12.31",height:"21.78",transform:"translate(-53.02 562.11) rotate(-90)",fill:"#6e6f71",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.13"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"237.89",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-63.58 551.54) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"238.18",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-63.29 551.82) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"238.47",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-63 552.11) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"238.76",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-62.71 552.4) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"239.05",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-62.42 552.69) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"239.33",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-62.13 552.98) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"239.62",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-61.84 553.27) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"239.91",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-61.56 553.56) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"240.2",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-61.27 553.84) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"240.49",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-60.98 554.13) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"240.78",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-60.69 554.42) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"241.07",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-60.4 554.71) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"241.35",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-60.11 555) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"241.64",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-59.83 555.29) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"241.93",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-59.54 555.58) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"242.22",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-59.25 555.86) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"242.51",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-58.96 556.15) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"242.8",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-58.67 556.44) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"243.09",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-58.38 556.73) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"243.37",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-58.09 557.02) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"243.66",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-57.81 557.31) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"243.95",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-57.52 557.59) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"244.24",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-57.23 557.88) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"244.53",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-56.94 558.17) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"244.82",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-56.65 558.46) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"245.1",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-56.36 558.75) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"245.39",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-56.07 559.04) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"245.68",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-55.79 559.33) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"245.97",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-55.5 559.61) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"246.26",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-55.21 559.9) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"246.55",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-54.92 560.19) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"246.84",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-54.63 560.48) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"247.12",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-54.34 560.77) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"247.41",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-54.06 561.06) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"247.7",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-53.77 561.35) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"247.99",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-53.48 561.63) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"248.28",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-53.19 561.92) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"248.57",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-52.9 562.21) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"248.86",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-52.61 562.5) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"249.14",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-52.32 562.79) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"249.43",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-52.04 563.08) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"249.72",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-51.75 563.36) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"250.01",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-51.46 563.65) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"250.3",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-51.17 563.94) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"250.59",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-50.88 564.23) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"250.87",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-50.59 564.52) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"251.16",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-50.3 564.81) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"251.45",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-50.02 565.1) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"251.74",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-49.73 565.38) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"252.03",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-49.44 565.67) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"252.32",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-49.15 565.96) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"252.61",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-48.86 566.25) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"252.89",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-48.57 566.54) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"253.18",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-48.29 566.83) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"253.47",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-48 567.12) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"253.76",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-47.71 567.4) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"254.05",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-47.42 567.69) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"254.34",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-47.13 567.98) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"254.63",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-46.84 568.27) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"254.91",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-46.55 568.56) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"255.2",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-46.27 568.85) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"255.49",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-45.98 569.14) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"255.78",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-45.69 569.42) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"256.07",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-45.4 569.71) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"256.36",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-45.11 570) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"256.64",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-44.82 570.29) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"256.93",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-44.53 570.58) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"257.22",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-44.25 570.87) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"257.51",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-43.96 571.15) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"257.8",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-43.67 571.44) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"258.09",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-43.38 571.73) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"258.38",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-43.09 572.02) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"258.66",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-42.8 572.31) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"258.95",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-42.51 572.6) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"305.42 321.38 306.52 321.38 306.52 329.65 280.94 329.65 280.94 322.79 280.94 321.38 280.94 314.52 305.42 314.52 305.42 321.38",fill:"#aee2fa",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"303.54",y:"322.89",width:"7.12",height:"4.1",transform:"translate(-17.85 632.04) rotate(-90)",fill:"#e0e0de",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"305.93",y:"317.16",width:"3.21",height:"3.22",transform:"translate(-11.24 626.31) rotate(-90)",fill:"#e0e0de",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"290.23",y:"305.22",width:"8.79",height:"21.61",transform:"translate(-21.4 610.65) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"284.09",y:"290.37",width:"21.06",height:"21.61",transform:"translate(-6.55 595.8) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"290.13",y:"289.93",width:"21.55",height:"21.61",transform:"translate(0.17 601.64) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"284.7",y:"276.77",width:"21.55",height:"21.61",transform:"translate(7.91 583.05) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"285.76",y:"273.19",width:"13.46",height:"21.61",transform:"translate(8.49 576.48) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"288.85",y:"269.16",width:"22.6",height:"19.83",transform:"translate(21.08 579.22) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M309.5,267.61H296.83a3.09,3.09,0,0,0-2.19-2.74h17v0A3.06,3.06,0,0,0,309.5,267.61Z",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"296.81",y:"266.62",width:"12.72",height:"5.41",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"290.21 267.85 310.13 267.85 310.13 289.97 308.42 289.97 308.42 309.97 305.47 309.97 305.43 314.5 283.84 314.5 283.84 300.87 281.66 300.87 281.66 290.65 277.13 290.65 277.13 276.03 290.21 276.03 290.21 267.85",fill:"#a7a9ac",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"305.51 314.54 283.89 314.54 283.89 300.87 281.75 300.87 281.75 290.69 277.13 290.69 277.13 276.08 302.95 276.08 302.95 279.84 305.51 279.84 305.51 314.54",fill:"#c5c6c8",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M305.52,288.17h-24V300.9h2.23v12.82h21.75l.06-11h.78v-7.09h-.81Zm-12.66,1.5v7.48H282v-7.48Z",fill:"#e6e7e7",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"288.49",y:"296.67",width:"12.31",height:"21.78",transform:"translate(-12.92 602.22) rotate(-90)",fill:"#6e6f71",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.13"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"299.12",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-2.34 612.77) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"298.84",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-2.63 612.48) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"298.55",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-2.92 612.19) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"298.26",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-3.21 611.9) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"297.97",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-3.5 611.61) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"297.68",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-3.79 611.33) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"297.39",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-4.07 611.04) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"297.1",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-4.36 610.75) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"296.82",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-4.65 610.46) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"296.53",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-4.94 610.17) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"296.24",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-5.23 609.88) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"295.95",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-5.52 609.59) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"295.66",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-5.81 609.31) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"295.37",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-6.09 609.02) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"295.09",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-6.38 608.73) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"294.8",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-6.67 608.44) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"294.51",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-6.96 608.15) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"294.22",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-7.25 607.86) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"293.93",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-7.54 607.58) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"293.64",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-7.83 607.29) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"293.35",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-8.11 607) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"293.07",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-8.4 606.71) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"292.78",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-8.69 606.42) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"292.49",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-8.98 606.13) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"292.2",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-9.27 605.84) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"291.91",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-9.56 605.56) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"291.62",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-9.84 605.27) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"291.33",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-10.13 604.98) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"291.05",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-10.42 604.69) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"290.76",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-10.71 604.4) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"290.47",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-11 604.11) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"290.18",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-11.29 603.82) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"289.89",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-11.58 603.54) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"289.6",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-11.86 603.25) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"289.31",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-12.15 602.96) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"289.03",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-12.44 602.67) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"288.74",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-12.73 602.38) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"288.45",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-13.02 602.09) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"288.16",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-13.31 601.81) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"287.87",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-13.6 601.52) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"287.58",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-13.88 601.23) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"287.3",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-14.17 600.94) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"287.01",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-14.46 600.65) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"286.72",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-14.75 600.36) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"286.43",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-15.04 600.07) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"286.14",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-15.33 599.79) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"285.85",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-15.62 599.5) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"285.56",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-15.9 599.21) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"285.28",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-16.19 598.92) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"284.99",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-16.48 598.63) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"284.7",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-16.77 598.34) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"284.41",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-17.06 598.05) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"284.12",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-17.35 597.77) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"283.83",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-17.63 597.48) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"283.54",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-17.92 597.19) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"283.26",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-18.21 596.9) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"282.97",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-18.5 596.61) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"282.68",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-18.79 596.32) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"282.39",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-19.08 596.03) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"282.1",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-19.37 595.75) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"281.81",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-19.65 595.46) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"281.53",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-19.94 595.17) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"281.24",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-20.23 594.88) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"280.95",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-20.52 594.59) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"280.66",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-20.81 594.3) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"280.37",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-21.1 594.02) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"280.08",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-21.39 593.73) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"279.79",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-21.67 593.44) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"279.51",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-21.96 593.15) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"279.22",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-22.25 592.86) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"278.93",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-22.54 592.57) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"278.64",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-22.83 592.28) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"278.35",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-23.12 592) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"278.06",y:"307.49",width:"12.18",height:"0.12",transform:"translate(-23.4 591.71) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"321.27 321.38 320.17 321.38 320.17 329.65 345.75 329.65 345.75 322.79 345.75 321.38 345.75 314.52 321.27 314.52 321.27 321.38",fill:"#aee2fa",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"316.04",y:"322.89",width:"7.12",height:"4.1",transform:"translate(-5.35 644.54) rotate(-90)",fill:"#e0e0de",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"317.55",y:"317.16",width:"3.21",height:"3.22",transform:"translate(0.38 637.92) rotate(-90)",fill:"#e0e0de",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"327.67",y:"305.22",width:"8.79",height:"21.61",transform:"translate(16.04 648.09) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"321.53",y:"290.37",width:"21.06",height:"21.61",transform:"translate(30.89 633.24) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"315.01",y:"289.93",width:"21.55",height:"21.61",transform:"translate(25.05 626.52) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"320.43",y:"276.77",width:"21.55",height:"21.61",transform:"translate(43.64 618.78) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"327.47",y:"273.19",width:"13.46",height:"21.61",transform:"translate(50.2 618.2) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"315.24",y:"269.16",width:"22.6",height:"19.83",transform:"translate(47.47 605.61) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M317.19,267.61h12.67a3.09,3.09,0,0,1,2.19-2.74h-17v0A3.06,3.06,0,0,1,317.19,267.61Z",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"317.16",y:"266.62",width:"12.72",height:"5.41",transform:"translate(647.04 538.66) rotate(-180)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"336.48 267.85 316.56 267.85 316.56 289.97 318.27 289.97 318.27 309.97 321.22 309.97 321.26 314.5 342.85 314.5 342.85 300.87 345.03 300.87 345.03 290.65 349.56 290.65 349.56 276.03 336.48 276.03 336.48 267.85",fill:"#a7a9ac",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"321.18 314.54 342.8 314.54 342.8 300.87 344.94 300.87 344.94 290.69 349.56 290.69 349.56 276.08 323.74 276.08 323.74 279.84 321.18 279.84 321.18 314.54",fill:"#c5c6c8",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M321.17,295.64h-.81v7.09h.78l.06,11H343V300.9h2.23V288.17h-24Zm23.55-6v7.48h-10.9v-7.48Z",fill:"#e6e7e7",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"325.88",y:"296.67",width:"12.31",height:"21.78",transform:"translate(24.47 639.61) rotate(-90)",fill:"#6e6f71",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.13"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"315.39",y:"307.49",width:"12.18",height:"0.12",transform:"translate(13.92 629.03) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"315.68",y:"307.49",width:"12.18",height:"0.12",transform:"translate(14.21 629.32) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"315.97",y:"307.49",width:"12.18",height:"0.12",transform:"translate(14.5 629.61) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"316.25",y:"307.49",width:"12.18",height:"0.12",transform:"translate(14.79 629.9) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"316.54",y:"307.49",width:"12.18",height:"0.12",transform:"translate(15.07 630.19) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"316.83",y:"307.49",width:"12.18",height:"0.12",transform:"translate(15.36 630.48) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"317.12",y:"307.49",width:"12.18",height:"0.12",transform:"translate(15.65 630.76) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"317.41",y:"307.49",width:"12.18",height:"0.12",transform:"translate(15.94 631.05) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"317.7",y:"307.49",width:"12.18",height:"0.12",transform:"translate(16.23 631.34) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"317.98",y:"307.49",width:"12.18",height:"0.12",transform:"translate(16.52 631.63) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"318.27",y:"307.49",width:"12.18",height:"0.12",transform:"translate(16.81 631.92) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"318.56",y:"307.49",width:"12.18",height:"0.12",transform:"translate(17.09 632.21) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"318.85",y:"307.49",width:"12.18",height:"0.12",transform:"translate(17.38 632.49) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"319.14",y:"307.49",width:"12.18",height:"0.12",transform:"translate(17.67 632.78) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"319.43",y:"307.49",width:"12.18",height:"0.12",transform:"translate(17.96 633.07) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"319.72",y:"307.49",width:"12.18",height:"0.12",transform:"translate(18.25 633.36) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"320",y:"307.49",width:"12.18",height:"0.12",transform:"translate(18.54 633.65) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"320.29",y:"307.49",width:"12.18",height:"0.12",transform:"translate(18.83 633.94) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"320.58",y:"307.49",width:"12.18",height:"0.12",transform:"translate(19.11 634.23) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"320.87",y:"307.49",width:"12.18",height:"0.12",transform:"translate(19.4 634.51) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"321.16",y:"307.49",width:"12.18",height:"0.12",transform:"translate(19.69 634.8) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"321.45",y:"307.49",width:"12.18",height:"0.12",transform:"translate(19.98 635.09) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"321.74",y:"307.49",width:"12.18",height:"0.12",transform:"translate(20.27 635.38) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"322.02",y:"307.49",width:"12.18",height:"0.12",transform:"translate(20.56 635.67) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"322.31",y:"307.49",width:"12.18",height:"0.12",transform:"translate(20.84 635.96) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"322.6",y:"307.49",width:"12.18",height:"0.12",transform:"translate(21.13 636.25) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"322.89",y:"307.49",width:"12.18",height:"0.12",transform:"translate(21.42 636.53) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"323.18",y:"307.49",width:"12.18",height:"0.12",transform:"translate(21.71 636.82) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"323.47",y:"307.49",width:"12.18",height:"0.12",transform:"translate(22 637.11) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"323.75",y:"307.49",width:"12.18",height:"0.12",transform:"translate(22.29 637.4) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"324.04",y:"307.49",width:"12.18",height:"0.12",transform:"translate(22.58 637.69) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"324.33",y:"307.49",width:"12.18",height:"0.12",transform:"translate(22.86 637.98) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"324.62",y:"307.49",width:"12.18",height:"0.12",transform:"translate(23.15 638.26) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"324.91",y:"307.49",width:"12.18",height:"0.12",transform:"translate(23.44 638.55) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"325.2",y:"307.49",width:"12.18",height:"0.12",transform:"translate(23.73 638.84) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"325.49",y:"307.49",width:"12.18",height:"0.12",transform:"translate(24.02 639.13) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"325.77",y:"307.49",width:"12.18",height:"0.12",transform:"translate(24.31 639.42) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"326.06",y:"307.49",width:"12.18",height:"0.12",transform:"translate(24.6 639.71) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"326.35",y:"307.49",width:"12.18",height:"0.12",transform:"translate(24.88 640) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"326.64",y:"307.49",width:"12.18",height:"0.12",transform:"translate(25.17 640.28) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"326.93",y:"307.49",width:"12.18",height:"0.12",transform:"translate(25.46 640.57) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"327.22",y:"307.49",width:"12.18",height:"0.12",transform:"translate(25.75 640.86) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"327.51",y:"307.49",width:"12.18",height:"0.12",transform:"translate(26.04 641.15) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"327.79",y:"307.49",width:"12.18",height:"0.12",transform:"translate(26.33 641.44) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"328.08",y:"307.49",width:"12.18",height:"0.12",transform:"translate(26.61 641.73) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"328.37",y:"307.49",width:"12.18",height:"0.12",transform:"translate(26.9 642.02) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"328.66",y:"307.49",width:"12.18",height:"0.12",transform:"translate(27.19 642.3) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"328.95",y:"307.49",width:"12.18",height:"0.12",transform:"translate(27.48 642.59) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"329.24",y:"307.49",width:"12.18",height:"0.12",transform:"translate(27.77 642.88) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"329.53",y:"307.49",width:"12.18",height:"0.12",transform:"translate(28.06 643.17) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"329.81",y:"307.49",width:"12.18",height:"0.12",transform:"translate(28.35 643.46) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"330.1",y:"307.49",width:"12.18",height:"0.12",transform:"translate(28.63 643.75) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"330.39",y:"307.49",width:"12.18",height:"0.12",transform:"translate(28.92 644.03) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"330.68",y:"307.49",width:"12.18",height:"0.12",transform:"translate(29.21 644.32) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"330.97",y:"307.49",width:"12.18",height:"0.12",transform:"translate(29.5 644.61) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"331.26",y:"307.49",width:"12.18",height:"0.12",transform:"translate(29.79 644.9) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"331.54",y:"307.49",width:"12.18",height:"0.12",transform:"translate(30.08 645.19) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"331.83",y:"307.49",width:"12.18",height:"0.12",transform:"translate(30.37 645.48) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"332.12",y:"307.49",width:"12.18",height:"0.12",transform:"translate(30.65 645.77) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"332.41",y:"307.49",width:"12.18",height:"0.12",transform:"translate(30.94 646.05) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"332.7",y:"307.49",width:"12.18",height:"0.12",transform:"translate(31.23 646.34) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"332.99",y:"307.49",width:"12.18",height:"0.12",transform:"translate(31.52 646.63) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"333.28",y:"307.49",width:"12.18",height:"0.12",transform:"translate(31.81 646.92) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"333.56",y:"307.49",width:"12.18",height:"0.12",transform:"translate(32.1 647.21) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"333.85",y:"307.49",width:"12.18",height:"0.12",transform:"translate(32.38 647.5) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"334.14",y:"307.49",width:"12.18",height:"0.12",transform:"translate(32.67 647.79) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"334.43",y:"307.49",width:"12.18",height:"0.12",transform:"translate(32.96 648.07) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"334.72",y:"307.49",width:"12.18",height:"0.12",transform:"translate(33.25 648.36) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"335.01",y:"307.49",width:"12.18",height:"0.12",transform:"translate(33.54 648.65) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"335.3",y:"307.49",width:"12.18",height:"0.12",transform:"translate(33.83 648.94) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"335.58",y:"307.49",width:"12.18",height:"0.12",transform:"translate(34.12 649.23) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"335.87",y:"307.49",width:"12.18",height:"0.12",transform:"translate(34.4 649.52) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"336.16",y:"307.49",width:"12.18",height:"0.12",transform:"translate(34.69 649.81) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"336.45",y:"307.49",width:"12.18",height:"0.12",transform:"translate(34.98 650.09) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(170.88 287.05)","font-size":"8",fill:"#231f20","font-family":"Helvetica"},"LP2",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"2.22",y:"9.6"},"V4")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(131.55 373.05)","font-size":"8",fill:"#231f20","font-family":"Helvetica"},"LP2",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"2.22",y:"9.6"},"V1")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(286.22 373.05)","font-size":"8",fill:"#231f20","font-family":"Helvetica"},"LP2",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"2.22",y:"9.6"},"V9")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(248.88 287.05)","font-size":"8",fill:"#231f20","font-family":"Helvetica"},"LP2",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"2.22",y:"9.6"},"V8")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(248.88 373.05)","font-size":"8",fill:"#231f20","font-family":"Helvetica"},"LP2",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"2.22",y:"9.6"},"V7")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(208.88 287.05)","font-size":"8",fill:"#231f20","font-family":"Helvetica"},"LP2",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"2.22",y:"9.6"},"V6")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(286.22 287.05)","font-size":"8",fill:"#231f20","font-family":"Helvetica"},"LP2",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"0",y:"9.6"},"V10")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(326.88 287.05)","font-size":"8",fill:"#231f20","font-family":"Helvetica"},"LP2",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"0",y:"9.6"},"V12")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(326.88 373.05)","font-size":"8",fill:"#231f20","font-family":"Helvetica"},"LP2",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"0.29",y:"9.6"},"V"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"5.63",y:"9.6","letter-spacing":"-0.07em"},"1"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"9.49",y:"9.6"},"1")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(170.88 373.05)","font-size":"8",fill:"#231f20","font-family":"Helvetica"},"LP2",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"2.22",y:"9.6"},"V3")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(131.55 287.05)","font-size":"8",fill:"#231f20","font-family":"Helvetica"},"LP2",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"2.22",y:"9.6"},"V2")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(208.88 373.05)","font-size":"8",fill:"#231f20","font-family":"Helvetica"},"LP2",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"2.22",y:"9.6"},"V5")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line",{x1:"118.53",y1:"331.98",x2:"352.54",y2:"331.98",fill:"none",stroke:"#fff","stroke-miterlimit":"10","stroke-width":"0.68"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line",{x1:"158.28",y1:"267.59",x2:"158.28",y2:"396.65",fill:"none",stroke:"#fff","stroke-miterlimit":"10","stroke-width":"0.68"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line",{x1:"197.17",y1:"267.59",x2:"197.17",y2:"396.65",fill:"none",stroke:"#fff","stroke-miterlimit":"10","stroke-width":"0.68"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line",{x1:"235.91",y1:"267.59",x2:"235.91",y2:"396.65",fill:"none",stroke:"#fff","stroke-miterlimit":"10","stroke-width":"0.68"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line",{x1:"274.66",y1:"267.59",x2:"274.66",y2:"396.65",fill:"none",stroke:"#fff","stroke-miterlimit":"10","stroke-width":"0.68"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line",{x1:"313.41",y1:"267.59",x2:"313.41",y2:"396.65",fill:"none",stroke:"#fff","stroke-miterlimit":"10","stroke-width":"0.68"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g",{id:"Villas","data-name":"Villas"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"363.53",y:"267.59",width:"271.47",height:"129.07",fill:"#4f9656",stroke:"#7d7f81","stroke-miterlimit":"10","stroke-width":"0.34"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"635",y:"267.59",width:"9.5",height:"129.07",fill:"#dcddde"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"363.33",y:"332.18",width:"38.67",height:"64.67",fill:"#fff"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"375.77 321.38 374.68 321.38 374.68 329.65 400.26 329.65 400.26 322.79 400.26 321.38 400.26 314.52 375.77 314.52 375.77 321.38",fill:"#aee2fa",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"370.54",y:"322.89",width:"7.12",height:"4.1",transform:"translate(49.16 699.04) rotate(-90)",fill:"#e0e0de",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"372.05",y:"317.16",width:"3.21",height:"3.22",transform:"translate(54.89 692.43) rotate(-90)",fill:"#e0e0de",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"382.17",y:"305.22",width:"8.79",height:"21.61",transform:"translate(70.54 702.59) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"376.04",y:"290.37",width:"21.06",height:"21.61",transform:"translate(85.4 687.74) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"369.51",y:"289.93",width:"21.55",height:"21.61",transform:"translate(79.55 681.02) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"374.94",y:"276.77",width:"21.55",height:"21.61",transform:"translate(98.14 673.28) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"381.97",y:"273.19",width:"13.46",height:"21.61",transform:"translate(104.71 672.7) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"369.75",y:"269.16",width:"22.6",height:"19.83",transform:"translate(101.97 660.12) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M371.7,267.61h12.66a3.09,3.09,0,0,1,2.19-2.74h-17v0A3.09,3.09,0,0,1,371.7,267.61Z",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"371.66",y:"266.62",width:"12.72",height:"5.41",transform:"translate(756.04 538.66) rotate(-180)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"390.98 267.85 371.06 267.85 371.06 289.97 372.77 289.97 372.77 309.97 375.72 309.97 375.76 314.5 397.35 314.5 397.35 300.87 399.53 300.87 399.53 290.65 404.06 290.65 404.06 276.03 390.98 276.03 390.98 267.85",fill:"#a7a9ac",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"375.68 314.54 397.31 314.54 397.31 300.87 399.44 300.87 399.44 290.69 404.06 290.69 404.06 276.08 378.24 276.08 378.24 279.84 375.68 279.84 375.68 314.54",fill:"#c5c6c8",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M375.68,295.64h-.81v7.09h.77l.07,11h21.74V300.9h2.23V288.17h-24Zm23.55-6v7.48h-10.9v-7.48Z",fill:"#e6e7e7",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"380.39",y:"296.67",width:"12.31",height:"21.78",transform:"translate(78.98 694.11) rotate(-90)",fill:"#6e6f71",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.13"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"369.89",y:"307.49",width:"12.18",height:"0.12",transform:"translate(68.42 683.54) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"370.18",y:"307.49",width:"12.18",height:"0.12",transform:"translate(68.71 683.82) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"370.47",y:"307.49",width:"12.18",height:"0.12",transform:"translate(69 684.11) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"370.76",y:"307.49",width:"12.18",height:"0.12",transform:"translate(69.29 684.4) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"371.05",y:"307.49",width:"12.18",height:"0.12",transform:"translate(69.58 684.69) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"371.33",y:"307.49",width:"12.18",height:"0.12",transform:"translate(69.87 684.98) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"371.62",y:"307.49",width:"12.18",height:"0.12",transform:"translate(70.16 685.27) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"371.91",y:"307.49",width:"12.18",height:"0.12",transform:"translate(70.44 685.56) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"372.2",y:"307.49",width:"12.18",height:"0.12",transform:"translate(70.73 685.84) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"372.49",y:"307.49",width:"12.18",height:"0.12",transform:"translate(71.02 686.13) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"372.78",y:"307.49",width:"12.18",height:"0.12",transform:"translate(71.31 686.42) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"373.07",y:"307.49",width:"12.18",height:"0.12",transform:"translate(71.6 686.71) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"373.35",y:"307.49",width:"12.18",height:"0.12",transform:"translate(71.89 687) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"373.64",y:"307.49",width:"12.18",height:"0.12",transform:"translate(72.17 687.29) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"373.93",y:"307.49",width:"12.18",height:"0.12",transform:"translate(72.46 687.58) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"374.22",y:"307.49",width:"12.18",height:"0.12",transform:"translate(72.75 687.86) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"374.51",y:"307.49",width:"12.18",height:"0.12",transform:"translate(73.04 688.15) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"374.8",y:"307.49",width:"12.18",height:"0.12",transform:"translate(73.33 688.44) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"375.09",y:"307.49",width:"12.18",height:"0.12",transform:"translate(73.62 688.73) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"375.37",y:"307.49",width:"12.18",height:"0.12",transform:"translate(73.91 689.02) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"375.66",y:"307.49",width:"12.18",height:"0.12",transform:"translate(74.19 689.31) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"375.95",y:"307.49",width:"12.18",height:"0.12",transform:"translate(74.48 689.59) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"376.24",y:"307.49",width:"12.18",height:"0.12",transform:"translate(74.77 689.88) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"376.53",y:"307.49",width:"12.18",height:"0.12",transform:"translate(75.06 690.17) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"376.82",y:"307.49",width:"12.18",height:"0.12",transform:"translate(75.35 690.46) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"377.1",y:"307.49",width:"12.18",height:"0.12",transform:"translate(75.64 690.75) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"377.39",y:"307.49",width:"12.18",height:"0.12",transform:"translate(75.93 691.04) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"377.68",y:"307.49",width:"12.18",height:"0.12",transform:"translate(76.21 691.33) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"377.97",y:"307.49",width:"12.18",height:"0.12",transform:"translate(76.5 691.61) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"378.26",y:"307.49",width:"12.18",height:"0.12",transform:"translate(76.79 691.9) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"378.55",y:"307.49",width:"12.18",height:"0.12",transform:"translate(77.08 692.19) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"378.84",y:"307.49",width:"12.18",height:"0.12",transform:"translate(77.37 692.48) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"379.12",y:"307.49",width:"12.18",height:"0.12",transform:"translate(77.66 692.77) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"379.41",y:"307.49",width:"12.18",height:"0.12",transform:"translate(77.94 693.06) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"379.7",y:"307.49",width:"12.18",height:"0.12",transform:"translate(78.23 693.35) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"379.99",y:"307.49",width:"12.18",height:"0.12",transform:"translate(78.52 693.63) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"380.28",y:"307.49",width:"12.18",height:"0.12",transform:"translate(78.81 693.92) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"380.57",y:"307.49",width:"12.18",height:"0.12",transform:"translate(79.1 694.21) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"380.86",y:"307.49",width:"12.18",height:"0.12",transform:"translate(79.39 694.5) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"381.14",y:"307.49",width:"12.18",height:"0.12",transform:"translate(79.68 694.79) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"381.43",y:"307.49",width:"12.18",height:"0.12",transform:"translate(79.96 695.08) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"381.72",y:"307.49",width:"12.18",height:"0.12",transform:"translate(80.25 695.36) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"382.01",y:"307.49",width:"12.18",height:"0.12",transform:"translate(80.54 695.65) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"382.3",y:"307.49",width:"12.18",height:"0.12",transform:"translate(80.83 695.94) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"382.59",y:"307.49",width:"12.18",height:"0.12",transform:"translate(81.12 696.23) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"382.87",y:"307.49",width:"12.18",height:"0.12",transform:"translate(81.41 696.52) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"383.16",y:"307.49",width:"12.18",height:"0.12",transform:"translate(81.7 696.81) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"383.45",y:"307.49",width:"12.18",height:"0.12",transform:"translate(81.98 697.1) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"383.74",y:"307.49",width:"12.18",height:"0.12",transform:"translate(82.27 697.38) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"384.03",y:"307.49",width:"12.18",height:"0.12",transform:"translate(82.56 697.67) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"384.32",y:"307.49",width:"12.18",height:"0.12",transform:"translate(82.85 697.96) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"384.61",y:"307.49",width:"12.18",height:"0.12",transform:"translate(83.14 698.25) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"384.89",y:"307.49",width:"12.18",height:"0.12",transform:"translate(83.43 698.54) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"385.18",y:"307.49",width:"12.18",height:"0.12",transform:"translate(83.71 698.83) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"385.47",y:"307.49",width:"12.18",height:"0.12",transform:"translate(84 699.12) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"385.76",y:"307.49",width:"12.18",height:"0.12",transform:"translate(84.29 699.4) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"386.05",y:"307.49",width:"12.18",height:"0.12",transform:"translate(84.58 699.69) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"386.34",y:"307.49",width:"12.18",height:"0.12",transform:"translate(84.87 699.98) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"386.63",y:"307.49",width:"12.18",height:"0.12",transform:"translate(85.16 700.27) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"386.91",y:"307.49",width:"12.18",height:"0.12",transform:"translate(85.45 700.56) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"387.2",y:"307.49",width:"12.18",height:"0.12",transform:"translate(85.73 700.85) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"387.49",y:"307.49",width:"12.18",height:"0.12",transform:"translate(86.02 701.14) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"387.78",y:"307.49",width:"12.18",height:"0.12",transform:"translate(86.31 701.42) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"388.07",y:"307.49",width:"12.18",height:"0.12",transform:"translate(86.6 701.71) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"388.36",y:"307.49",width:"12.18",height:"0.12",transform:"translate(86.89 702) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"388.64",y:"307.49",width:"12.18",height:"0.12",transform:"translate(87.18 702.29) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"388.93",y:"307.49",width:"12.18",height:"0.12",transform:"translate(87.47 702.58) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"389.22",y:"307.49",width:"12.18",height:"0.12",transform:"translate(87.75 702.87) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"389.51",y:"307.49",width:"12.18",height:"0.12",transform:"translate(88.04 703.15) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"389.8",y:"307.49",width:"12.18",height:"0.12",transform:"translate(88.33 703.44) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"390.09",y:"307.49",width:"12.18",height:"0.12",transform:"translate(88.62 703.73) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"390.38",y:"307.49",width:"12.18",height:"0.12",transform:"translate(88.91 704.02) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"390.66",y:"307.49",width:"12.18",height:"0.12",transform:"translate(89.2 704.31) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"390.95",y:"307.49",width:"12.18",height:"0.12",transform:"translate(89.49 704.6) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"437.42 321.38 438.52 321.38 438.52 329.65 412.94 329.65 412.94 322.79 412.94 321.38 412.94 314.52 437.42 314.52 437.42 321.38",fill:"#aee2fa",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"435.54",y:"322.89",width:"7.12",height:"4.1",transform:"translate(114.15 764.04) rotate(-90)",fill:"#e0e0de",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"437.93",y:"317.16",width:"3.21",height:"3.22",transform:"translate(120.76 758.31) rotate(-90)",fill:"#e0e0de",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"422.23",y:"305.22",width:"8.79",height:"21.61",transform:"translate(110.6 742.65) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"416.09",y:"290.37",width:"21.06",height:"21.61",transform:"translate(125.45 727.8) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"422.13",y:"289.93",width:"21.55",height:"21.61",transform:"translate(132.17 733.64) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"416.7",y:"276.77",width:"21.55",height:"21.61",transform:"translate(139.91 715.05) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"417.76",y:"273.19",width:"13.46",height:"21.61",transform:"translate(140.49 708.48) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"420.85",y:"269.16",width:"22.6",height:"19.83",transform:"translate(153.08 711.22) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M441.5,267.61H428.83a3.09,3.09,0,0,0-2.19-2.74h17v0A3.06,3.06,0,0,0,441.5,267.61Z",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"428.81",y:"266.62",width:"12.72",height:"5.41",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"422.21 267.85 442.13 267.85 442.13 289.97 440.42 289.97 440.42 309.97 437.47 309.97 437.43 314.5 415.84 314.5 415.84 300.87 413.66 300.87 413.66 290.65 409.13 290.65 409.13 276.03 422.21 276.03 422.21 267.85",fill:"#a7a9ac",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"437.51 314.54 415.89 314.54 415.89 300.87 413.75 300.87 413.75 290.69 409.13 290.69 409.13 276.08 434.95 276.08 434.95 279.84 437.51 279.84 437.51 314.54",fill:"#c5c6c8",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M437.52,288.17h-24V300.9h2.23v12.82h21.75l.06-11h.78v-7.09h-.81Zm-12.66,1.5v7.48H414v-7.48Z",fill:"#e6e7e7",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"420.49",y:"296.67",width:"12.31",height:"21.78",transform:"translate(119.08 734.22) rotate(-90)",fill:"#6e6f71",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.13"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"431.12",y:"307.49",width:"12.18",height:"0.12",transform:"translate(129.66 744.77) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"430.84",y:"307.49",width:"12.18",height:"0.12",transform:"translate(129.37 744.48) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"430.55",y:"307.49",width:"12.18",height:"0.12",transform:"translate(129.08 744.19) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"430.26",y:"307.49",width:"12.18",height:"0.12",transform:"translate(128.79 743.9) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"429.97",y:"307.49",width:"12.18",height:"0.12",transform:"translate(128.5 743.61) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"429.68",y:"307.49",width:"12.18",height:"0.12",transform:"translate(128.21 743.33) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"429.39",y:"307.49",width:"12.18",height:"0.12",transform:"translate(127.93 743.04) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"429.1",y:"307.49",width:"12.18",height:"0.12",transform:"translate(127.64 742.75) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"428.82",y:"307.49",width:"12.18",height:"0.12",transform:"translate(127.35 742.46) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"428.53",y:"307.49",width:"12.18",height:"0.12",transform:"translate(127.06 742.17) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"428.24",y:"307.49",width:"12.18",height:"0.12",transform:"translate(126.77 741.88) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"427.95",y:"307.49",width:"12.18",height:"0.12",transform:"translate(126.48 741.59) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"427.66",y:"307.49",width:"12.18",height:"0.12",transform:"translate(126.19 741.31) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"427.37",y:"307.49",width:"12.18",height:"0.12",transform:"translate(125.91 741.02) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"427.09",y:"307.49",width:"12.18",height:"0.12",transform:"translate(125.62 740.73) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"426.8",y:"307.49",width:"12.18",height:"0.12",transform:"translate(125.33 740.44) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"426.51",y:"307.49",width:"12.18",height:"0.12",transform:"translate(125.04 740.15) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"426.22",y:"307.49",width:"12.18",height:"0.12",transform:"translate(124.75 739.86) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"425.93",y:"307.49",width:"12.18",height:"0.12",transform:"translate(124.46 739.58) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"425.64",y:"307.49",width:"12.18",height:"0.12",transform:"translate(124.17 739.29) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"425.35",y:"307.49",width:"12.18",height:"0.12",transform:"translate(123.89 739) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"425.07",y:"307.49",width:"12.18",height:"0.12",transform:"translate(123.6 738.71) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"424.78",y:"307.49",width:"12.18",height:"0.12",transform:"translate(123.31 738.42) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"424.49",y:"307.49",width:"12.18",height:"0.12",transform:"translate(123.02 738.13) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"424.2",y:"307.49",width:"12.18",height:"0.12",transform:"translate(122.73 737.84) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"423.91",y:"307.49",width:"12.18",height:"0.12",transform:"translate(122.44 737.56) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"423.62",y:"307.49",width:"12.18",height:"0.12",transform:"translate(122.16 737.27) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"423.33",y:"307.49",width:"12.18",height:"0.12",transform:"translate(121.87 736.98) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"423.05",y:"307.49",width:"12.18",height:"0.12",transform:"translate(121.58 736.69) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"422.76",y:"307.49",width:"12.18",height:"0.12",transform:"translate(121.29 736.4) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"422.47",y:"307.49",width:"12.18",height:"0.12",transform:"translate(121 736.11) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"422.18",y:"307.49",width:"12.18",height:"0.12",transform:"translate(120.71 735.82) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"421.89",y:"307.49",width:"12.18",height:"0.12",transform:"translate(120.42 735.54) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"421.6",y:"307.49",width:"12.18",height:"0.12",transform:"translate(120.14 735.25) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"421.31",y:"307.49",width:"12.18",height:"0.12",transform:"translate(119.85 734.96) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"421.03",y:"307.49",width:"12.18",height:"0.12",transform:"translate(119.56 734.67) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"420.74",y:"307.49",width:"12.18",height:"0.12",transform:"translate(119.27 734.38) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"420.45",y:"307.49",width:"12.18",height:"0.12",transform:"translate(118.98 734.09) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"420.16",y:"307.49",width:"12.18",height:"0.12",transform:"translate(118.69 733.81) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"419.87",y:"307.49",width:"12.18",height:"0.12",transform:"translate(118.4 733.52) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"419.58",y:"307.49",width:"12.18",height:"0.12",transform:"translate(118.12 733.23) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"419.3",y:"307.49",width:"12.18",height:"0.12",transform:"translate(117.83 732.94) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"419.01",y:"307.49",width:"12.18",height:"0.12",transform:"translate(117.54 732.65) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"418.72",y:"307.49",width:"12.18",height:"0.12",transform:"translate(117.25 732.36) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"418.43",y:"307.49",width:"12.18",height:"0.12",transform:"translate(116.96 732.07) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"418.14",y:"307.49",width:"12.18",height:"0.12",transform:"translate(116.67 731.79) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"417.85",y:"307.49",width:"12.18",height:"0.12",transform:"translate(116.38 731.5) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"417.56",y:"307.49",width:"12.18",height:"0.12",transform:"translate(116.1 731.21) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"417.28",y:"307.49",width:"12.18",height:"0.12",transform:"translate(115.81 730.92) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"416.99",y:"307.49",width:"12.18",height:"0.12",transform:"translate(115.52 730.63) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"416.7",y:"307.49",width:"12.18",height:"0.12",transform:"translate(115.23 730.34) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"416.41",y:"307.49",width:"12.18",height:"0.12",transform:"translate(114.94 730.05) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"416.12",y:"307.49",width:"12.18",height:"0.12",transform:"translate(114.65 729.77) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"415.83",y:"307.49",width:"12.18",height:"0.12",transform:"translate(114.37 729.48) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"415.54",y:"307.49",width:"12.18",height:"0.12",transform:"translate(114.08 729.19) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"415.26",y:"307.49",width:"12.18",height:"0.12",transform:"translate(113.79 728.9) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"414.97",y:"307.49",width:"12.18",height:"0.12",transform:"translate(113.5 728.61) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"414.68",y:"307.49",width:"12.18",height:"0.12",transform:"translate(113.21 728.32) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"414.39",y:"307.49",width:"12.18",height:"0.12",transform:"translate(112.92 728.03) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"414.1",y:"307.49",width:"12.18",height:"0.12",transform:"translate(112.63 727.75) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"413.81",y:"307.49",width:"12.18",height:"0.12",transform:"translate(112.35 727.46) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"413.53",y:"307.49",width:"12.18",height:"0.12",transform:"translate(112.06 727.17) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"413.24",y:"307.49",width:"12.18",height:"0.12",transform:"translate(111.77 726.88) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"412.95",y:"307.49",width:"12.18",height:"0.12",transform:"translate(111.48 726.59) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"412.66",y:"307.49",width:"12.18",height:"0.12",transform:"translate(111.19 726.3) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"412.37",y:"307.49",width:"12.18",height:"0.12",transform:"translate(110.9 726.02) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"412.08",y:"307.49",width:"12.18",height:"0.12",transform:"translate(110.61 725.73) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"411.79",y:"307.49",width:"12.18",height:"0.12",transform:"translate(110.33 725.44) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"411.51",y:"307.49",width:"12.18",height:"0.12",transform:"translate(110.04 725.15) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"411.22",y:"307.49",width:"12.18",height:"0.12",transform:"translate(109.75 724.86) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"410.93",y:"307.49",width:"12.18",height:"0.12",transform:"translate(109.46 724.57) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"410.64",y:"307.49",width:"12.18",height:"0.12",transform:"translate(109.17 724.28) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"410.35",y:"307.49",width:"12.18",height:"0.12",transform:"translate(108.88 724) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"410.06",y:"307.49",width:"12.18",height:"0.12",transform:"translate(108.6 723.71) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"453.27 321.38 452.17 321.38 452.17 329.65 477.75 329.65 477.75 322.79 477.75 321.38 477.75 314.52 453.27 314.52 453.27 321.38",fill:"#aee2fa",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"448.04",y:"322.89",width:"7.12",height:"4.1",transform:"translate(126.65 776.54) rotate(-90)",fill:"#e0e0de",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"449.55",y:"317.16",width:"3.21",height:"3.22",transform:"translate(132.38 769.92) rotate(-90)",fill:"#e0e0de",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"459.67",y:"305.22",width:"8.79",height:"21.61",transform:"translate(148.04 780.09) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"453.53",y:"290.37",width:"21.06",height:"21.61",transform:"translate(162.89 765.24) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"447.01",y:"289.93",width:"21.55",height:"21.61",transform:"translate(157.05 758.52) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"452.43",y:"276.77",width:"21.55",height:"21.61",transform:"translate(175.64 750.78) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"459.47",y:"273.19",width:"13.46",height:"21.61",transform:"translate(182.2 750.2) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"447.24",y:"269.16",width:"22.6",height:"19.83",transform:"translate(179.47 737.61) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M449.19,267.61h12.67a3.09,3.09,0,0,1,2.19-2.74h-17v0A3.06,3.06,0,0,1,449.19,267.61Z",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"449.16",y:"266.62",width:"12.72",height:"5.41",transform:"translate(911.04 538.66) rotate(-180)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"468.48 267.85 448.56 267.85 448.56 289.97 450.27 289.97 450.27 309.97 453.22 309.97 453.26 314.5 474.85 314.5 474.85 300.87 477.03 300.87 477.03 290.65 481.56 290.65 481.56 276.03 468.48 276.03 468.48 267.85",fill:"#a7a9ac",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"453.18 314.54 474.8 314.54 474.8 300.87 476.94 300.87 476.94 290.69 481.56 290.69 481.56 276.08 455.74 276.08 455.74 279.84 453.18 279.84 453.18 314.54",fill:"#c5c6c8",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M453.17,295.64h-.81v7.09h.78l.06,11H475V300.9h2.23V288.17h-24Zm23.55-6v7.48h-10.9v-7.48Z",fill:"#e6e7e7",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"457.88",y:"296.67",width:"12.31",height:"21.78",transform:"translate(156.47 771.61) rotate(-90)",fill:"#6e6f71",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.13"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"447.39",y:"307.49",width:"12.18",height:"0.12",transform:"translate(145.92 761.03) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"447.68",y:"307.49",width:"12.18",height:"0.12",transform:"translate(146.21 761.32) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"447.97",y:"307.49",width:"12.18",height:"0.12",transform:"translate(146.5 761.61) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"448.25",y:"307.49",width:"12.18",height:"0.12",transform:"translate(146.79 761.9) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"448.54",y:"307.49",width:"12.18",height:"0.12",transform:"translate(147.07 762.19) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"448.83",y:"307.49",width:"12.18",height:"0.12",transform:"translate(147.36 762.48) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"449.12",y:"307.49",width:"12.18",height:"0.12",transform:"translate(147.65 762.76) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"449.41",y:"307.49",width:"12.18",height:"0.12",transform:"translate(147.94 763.05) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"449.7",y:"307.49",width:"12.18",height:"0.12",transform:"translate(148.23 763.34) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"449.98",y:"307.49",width:"12.18",height:"0.12",transform:"translate(148.52 763.63) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"450.27",y:"307.49",width:"12.18",height:"0.12",transform:"translate(148.81 763.92) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"450.56",y:"307.49",width:"12.18",height:"0.12",transform:"translate(149.09 764.21) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"450.85",y:"307.49",width:"12.18",height:"0.12",transform:"translate(149.38 764.49) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"451.14",y:"307.49",width:"12.18",height:"0.12",transform:"translate(149.67 764.78) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"451.43",y:"307.49",width:"12.18",height:"0.12",transform:"translate(149.96 765.07) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"451.72",y:"307.49",width:"12.18",height:"0.12",transform:"translate(150.25 765.36) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"452",y:"307.49",width:"12.18",height:"0.12",transform:"translate(150.54 765.65) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"452.29",y:"307.49",width:"12.18",height:"0.12",transform:"translate(150.83 765.94) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"452.58",y:"307.49",width:"12.18",height:"0.12",transform:"translate(151.11 766.23) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"452.87",y:"307.49",width:"12.18",height:"0.12",transform:"translate(151.4 766.51) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"453.16",y:"307.49",width:"12.18",height:"0.12",transform:"translate(151.69 766.8) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"453.45",y:"307.49",width:"12.18",height:"0.12",transform:"translate(151.98 767.09) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"453.74",y:"307.49",width:"12.18",height:"0.12",transform:"translate(152.27 767.38) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"454.02",y:"307.49",width:"12.18",height:"0.12",transform:"translate(152.56 767.67) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"454.31",y:"307.49",width:"12.18",height:"0.12",transform:"translate(152.84 767.96) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"454.6",y:"307.49",width:"12.18",height:"0.12",transform:"translate(153.13 768.25) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"454.89",y:"307.49",width:"12.18",height:"0.12",transform:"translate(153.42 768.53) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"455.18",y:"307.49",width:"12.18",height:"0.12",transform:"translate(153.71 768.82) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"455.47",y:"307.49",width:"12.18",height:"0.12",transform:"translate(154 769.11) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"455.75",y:"307.49",width:"12.18",height:"0.12",transform:"translate(154.29 769.4) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"456.04",y:"307.49",width:"12.18",height:"0.12",transform:"translate(154.58 769.69) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"456.33",y:"307.49",width:"12.18",height:"0.12",transform:"translate(154.86 769.98) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"456.62",y:"307.49",width:"12.18",height:"0.12",transform:"translate(155.15 770.26) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"456.91",y:"307.49",width:"12.18",height:"0.12",transform:"translate(155.44 770.55) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"457.2",y:"307.49",width:"12.18",height:"0.12",transform:"translate(155.73 770.84) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"457.49",y:"307.49",width:"12.18",height:"0.12",transform:"translate(156.02 771.13) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"457.77",y:"307.49",width:"12.18",height:"0.12",transform:"translate(156.31 771.42) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"458.06",y:"307.49",width:"12.18",height:"0.12",transform:"translate(156.6 771.71) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"458.35",y:"307.49",width:"12.18",height:"0.12",transform:"translate(156.88 772) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"458.64",y:"307.49",width:"12.18",height:"0.12",transform:"translate(157.17 772.28) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"458.93",y:"307.49",width:"12.18",height:"0.12",transform:"translate(157.46 772.57) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"459.22",y:"307.49",width:"12.18",height:"0.12",transform:"translate(157.75 772.86) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"459.51",y:"307.49",width:"12.18",height:"0.12",transform:"translate(158.04 773.15) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"459.79",y:"307.49",width:"12.18",height:"0.12",transform:"translate(158.33 773.44) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"460.08",y:"307.49",width:"12.18",height:"0.12",transform:"translate(158.61 773.73) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"460.37",y:"307.49",width:"12.18",height:"0.12",transform:"translate(158.9 774.02) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"460.66",y:"307.49",width:"12.18",height:"0.12",transform:"translate(159.19 774.3) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"460.95",y:"307.49",width:"12.18",height:"0.12",transform:"translate(159.48 774.59) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"461.24",y:"307.49",width:"12.18",height:"0.12",transform:"translate(159.77 774.88) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"461.53",y:"307.49",width:"12.18",height:"0.12",transform:"translate(160.06 775.17) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"461.81",y:"307.49",width:"12.18",height:"0.12",transform:"translate(160.35 775.46) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"462.1",y:"307.49",width:"12.18",height:"0.12",transform:"translate(160.63 775.75) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"462.39",y:"307.49",width:"12.18",height:"0.12",transform:"translate(160.92 776.03) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"462.68",y:"307.49",width:"12.18",height:"0.12",transform:"translate(161.21 776.32) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"462.97",y:"307.49",width:"12.18",height:"0.12",transform:"translate(161.5 776.61) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"463.26",y:"307.49",width:"12.18",height:"0.12",transform:"translate(161.79 776.9) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"463.54",y:"307.49",width:"12.18",height:"0.12",transform:"translate(162.08 777.19) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"463.83",y:"307.49",width:"12.18",height:"0.12",transform:"translate(162.37 777.48) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"464.12",y:"307.49",width:"12.18",height:"0.12",transform:"translate(162.65 777.77) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"464.41",y:"307.49",width:"12.18",height:"0.12",transform:"translate(162.94 778.05) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"464.7",y:"307.49",width:"12.18",height:"0.12",transform:"translate(163.23 778.34) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"464.99",y:"307.49",width:"12.18",height:"0.12",transform:"translate(163.52 778.63) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"465.28",y:"307.49",width:"12.18",height:"0.12",transform:"translate(163.81 778.92) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"465.56",y:"307.49",width:"12.18",height:"0.12",transform:"translate(164.1 779.21) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"465.85",y:"307.49",width:"12.18",height:"0.12",transform:"translate(164.38 779.5) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"466.14",y:"307.49",width:"12.18",height:"0.12",transform:"translate(164.67 779.79) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"466.43",y:"307.49",width:"12.18",height:"0.12",transform:"translate(164.96 780.07) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"466.72",y:"307.49",width:"12.18",height:"0.12",transform:"translate(165.25 780.36) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"467.01",y:"307.49",width:"12.18",height:"0.12",transform:"translate(165.54 780.65) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"467.3",y:"307.49",width:"12.18",height:"0.12",transform:"translate(165.83 780.94) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"467.58",y:"307.49",width:"12.18",height:"0.12",transform:"translate(166.12 781.23) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"467.87",y:"307.49",width:"12.18",height:"0.12",transform:"translate(166.4 781.52) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"468.16",y:"307.49",width:"12.18",height:"0.12",transform:"translate(166.69 781.81) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"468.45",y:"307.49",width:"12.18",height:"0.12",transform:"translate(166.98 782.09) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"368.9",y:"352.82",width:"24.64",height:"30.82",fill:"#939598"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M393.55,352.66V335.9H368.9v11.62h-4.77v5.14Zm-15.74-5.15h-6.34v-10.4h6.34Zm13,0H384.5v-10.4h6.34Z",fill:"#939598"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line",{x1:"406.5",y1:"267.59",x2:"406.5",y2:"332.05",fill:"none",stroke:"#fff","stroke-miterlimit":"10","stroke-width":"0.68"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line",{x1:"402.17",y1:"332.19",x2:"402.17",y2:"396.65",fill:"none",stroke:"#fff","stroke-miterlimit":"10","stroke-width":"0.68"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line",{x1:"445.25",y1:"267.59",x2:"445.25",y2:"396.65",fill:"none",stroke:"#fff","stroke-miterlimit":"10","stroke-width":"0.68"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line",{x1:"484",y1:"267.59",x2:"484",y2:"396.65",fill:"none",stroke:"#fff","stroke-miterlimit":"10","stroke-width":"0.68"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line",{x1:"521.66",y1:"267.59",x2:"521.66",y2:"396.65",fill:"none",stroke:"#fff","stroke-miterlimit":"10","stroke-width":"0.68"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line",{x1:"559.33",y1:"267.59",x2:"559.33",y2:"396.65",fill:"none",stroke:"#fff","stroke-miterlimit":"10","stroke-width":"0.68"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line",{x1:"597",y1:"267.59",x2:"597",y2:"396.65",fill:"none",stroke:"#fff","stroke-miterlimit":"10","stroke-width":"0.68"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line",{x1:"635",y1:"267.59",x2:"635",y2:"396.65",fill:"none",stroke:"#fff","stroke-miterlimit":"10","stroke-width":"0.68"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line",{x1:"363.53",y1:"331.98",x2:"634.67",y2:"331.98",fill:"none",stroke:"#fff","stroke-miterlimit":"10","stroke-width":"0.68"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"437.42 342.74 438.52 342.74 438.52 334.47 412.94 334.47 412.94 341.33 412.94 342.74 412.94 349.6 437.42 349.6 437.42 342.74",fill:"#aee2fa",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"435.54",y:"337.13",width:"7.12",height:"4.1",transform:"translate(778.27 -99.92) rotate(90)",fill:"#e0e0de",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"437.93",y:"343.74",width:"3.21",height:"3.22",transform:"translate(784.88 -94.19) rotate(90)",fill:"#e0e0de",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"422.23",y:"337.29",width:"8.79",height:"21.61",transform:"translate(774.72 -78.53) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"416.09",y:"352.15",width:"21.06",height:"21.61",transform:"translate(789.57 -63.68) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"422.13",y:"352.58",width:"21.55",height:"21.61",transform:"translate(796.29 -69.52) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"416.7",y:"365.75",width:"21.55",height:"21.61",transform:"translate(804.03 -50.93) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"417.76",y:"369.32",width:"13.46",height:"21.61",transform:"translate(804.61 -44.36) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"420.85",y:"375.13",width:"22.6",height:"19.83",transform:"translate(817.2 -47.1) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M441.5,398.9H428.83a3.09,3.09,0,0,1-2.19,2.74h17v0A3.06,3.06,0,0,1,441.5,398.9Z",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"428.81",y:"394.47",width:"12.72",height:"5.41",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"422.21 396.27 442.13 396.27 442.13 374.15 440.42 374.15 440.42 354.15 437.47 354.15 437.43 349.62 415.84 349.62 415.84 363.25 413.66 363.25 413.66 373.47 409.13 373.47 409.13 388.09 422.21 388.09 422.21 396.27",fill:"#a7a9ac",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"437.51 349.58 415.89 349.58 415.89 363.25 413.75 363.25 413.75 373.43 409.13 373.43 409.13 388.04 434.95 388.04 434.95 384.28 437.51 384.28 437.51 349.58",fill:"#c5c6c8",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M437.52,368.48h.81v-7.09h-.78l-.06-11H415.74v12.82h-2.23V376h24Zm-23.55,6V367h10.89v7.48Z",fill:"#e6e7e7",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"420.49",y:"345.66",width:"12.31",height:"21.78",transform:"translate(783.2 -70.1) rotate(90)",fill:"#6e6f71",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.13"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"431.12",y:"356.5",width:"12.18",height:"0.12",transform:"translate(793.78 -80.65) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"430.84",y:"356.5",width:"12.18",height:"0.12",transform:"translate(793.49 -80.36) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"430.55",y:"356.5",width:"12.18",height:"0.12",transform:"translate(793.2 -80.07) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"430.26",y:"356.5",width:"12.18",height:"0.12",transform:"translate(792.91 -79.78) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"429.97",y:"356.5",width:"12.18",height:"0.12",transform:"translate(792.62 -79.49) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"429.68",y:"356.5",width:"12.18",height:"0.12",transform:"translate(792.33 -79.21) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"429.39",y:"356.5",width:"12.18",height:"0.12",transform:"translate(792.05 -78.92) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"429.1",y:"356.5",width:"12.18",height:"0.12",transform:"translate(791.76 -78.63) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"428.82",y:"356.5",width:"12.18",height:"0.12",transform:"translate(791.47 -78.34) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"428.53",y:"356.5",width:"12.18",height:"0.12",transform:"translate(791.18 -78.05) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"428.24",y:"356.5",width:"12.18",height:"0.12",transform:"translate(790.89 -77.76) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"427.95",y:"356.5",width:"12.18",height:"0.12",transform:"translate(790.6 -77.47) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"427.66",y:"356.5",width:"12.18",height:"0.12",transform:"translate(790.31 -77.19) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"427.37",y:"356.5",width:"12.18",height:"0.12",transform:"translate(790.03 -76.9) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"427.09",y:"356.5",width:"12.18",height:"0.12",transform:"translate(789.74 -76.61) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"426.8",y:"356.5",width:"12.18",height:"0.12",transform:"translate(789.45 -76.32) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"426.51",y:"356.5",width:"12.18",height:"0.12",transform:"translate(789.16 -76.03) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"426.22",y:"356.5",width:"12.18",height:"0.12",transform:"translate(788.87 -75.74) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"425.93",y:"356.5",width:"12.18",height:"0.12",transform:"translate(788.58 -75.46) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"425.64",y:"356.5",width:"12.18",height:"0.12",transform:"translate(788.29 -75.17) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"425.35",y:"356.5",width:"12.18",height:"0.12",transform:"translate(788.01 -74.88) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"425.07",y:"356.5",width:"12.18",height:"0.12",transform:"translate(787.72 -74.59) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"424.78",y:"356.5",width:"12.18",height:"0.12",transform:"translate(787.43 -74.3) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"424.49",y:"356.5",width:"12.18",height:"0.12",transform:"translate(787.14 -74.01) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"424.2",y:"356.5",width:"12.18",height:"0.12",transform:"translate(786.85 -73.72) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"423.91",y:"356.5",width:"12.18",height:"0.12",transform:"translate(786.56 -73.44) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"423.62",y:"356.5",width:"12.18",height:"0.12",transform:"translate(786.28 -73.15) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"423.33",y:"356.5",width:"12.18",height:"0.12",transform:"translate(785.99 -72.86) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"423.05",y:"356.5",width:"12.18",height:"0.12",transform:"translate(785.7 -72.57) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"422.76",y:"356.5",width:"12.18",height:"0.12",transform:"translate(785.41 -72.28) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"422.47",y:"356.5",width:"12.18",height:"0.12",transform:"translate(785.12 -71.99) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"422.18",y:"356.5",width:"12.18",height:"0.12",transform:"translate(784.83 -71.7) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"421.89",y:"356.5",width:"12.18",height:"0.12",transform:"translate(784.54 -71.42) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"421.6",y:"356.5",width:"12.18",height:"0.12",transform:"translate(784.26 -71.13) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"421.31",y:"356.5",width:"12.18",height:"0.12",transform:"translate(783.97 -70.84) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"421.03",y:"356.5",width:"12.18",height:"0.12",transform:"translate(783.68 -70.55) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"420.74",y:"356.5",width:"12.18",height:"0.12",transform:"translate(783.39 -70.26) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"420.45",y:"356.5",width:"12.18",height:"0.12",transform:"translate(783.1 -69.97) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"420.16",y:"356.5",width:"12.18",height:"0.12",transform:"translate(782.81 -69.69) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"419.87",y:"356.5",width:"12.18",height:"0.12",transform:"translate(782.52 -69.4) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"419.58",y:"356.5",width:"12.18",height:"0.12",transform:"translate(782.24 -69.11) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"419.3",y:"356.5",width:"12.18",height:"0.12",transform:"translate(781.95 -68.82) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"419.01",y:"356.5",width:"12.18",height:"0.12",transform:"translate(781.66 -68.53) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"418.72",y:"356.5",width:"12.18",height:"0.12",transform:"translate(781.37 -68.24) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"418.43",y:"356.5",width:"12.18",height:"0.12",transform:"translate(781.08 -67.95) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"418.14",y:"356.5",width:"12.18",height:"0.12",transform:"translate(780.79 -67.67) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"417.85",y:"356.5",width:"12.18",height:"0.12",transform:"translate(780.5 -67.38) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"417.56",y:"356.5",width:"12.18",height:"0.12",transform:"translate(780.22 -67.09) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"417.28",y:"356.5",width:"12.18",height:"0.12",transform:"translate(779.93 -66.8) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"416.99",y:"356.5",width:"12.18",height:"0.12",transform:"translate(779.64 -66.51) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"416.7",y:"356.5",width:"12.18",height:"0.12",transform:"translate(779.35 -66.22) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"416.41",y:"356.5",width:"12.18",height:"0.12",transform:"translate(779.06 -65.93) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"416.12",y:"356.5",width:"12.18",height:"0.12",transform:"translate(778.77 -65.65) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"415.83",y:"356.5",width:"12.18",height:"0.12",transform:"translate(778.49 -65.36) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"415.54",y:"356.5",width:"12.18",height:"0.12",transform:"translate(778.2 -65.07) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"415.26",y:"356.5",width:"12.18",height:"0.12",transform:"translate(777.91 -64.78) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"414.97",y:"356.5",width:"12.18",height:"0.12",transform:"translate(777.62 -64.49) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"414.68",y:"356.5",width:"12.18",height:"0.12",transform:"translate(777.33 -64.2) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"414.39",y:"356.5",width:"12.18",height:"0.12",transform:"translate(777.04 -63.92) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"414.1",y:"356.5",width:"12.18",height:"0.12",transform:"translate(776.75 -63.63) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"413.81",y:"356.5",width:"12.18",height:"0.12",transform:"translate(776.47 -63.34) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"413.53",y:"356.5",width:"12.18",height:"0.12",transform:"translate(776.18 -63.05) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"413.24",y:"356.5",width:"12.18",height:"0.12",transform:"translate(775.89 -62.76) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"412.95",y:"356.5",width:"12.18",height:"0.12",transform:"translate(775.6 -62.47) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"412.66",y:"356.5",width:"12.18",height:"0.12",transform:"translate(775.31 -62.18) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"412.37",y:"356.5",width:"12.18",height:"0.12",transform:"translate(775.02 -61.9) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"412.08",y:"356.5",width:"12.18",height:"0.12",transform:"translate(774.73 -61.61) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"411.79",y:"356.5",width:"12.18",height:"0.12",transform:"translate(774.45 -61.32) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"411.51",y:"356.5",width:"12.18",height:"0.12",transform:"translate(774.16 -61.03) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"411.22",y:"356.5",width:"12.18",height:"0.12",transform:"translate(773.87 -60.74) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"410.93",y:"356.5",width:"12.18",height:"0.12",transform:"translate(773.58 -60.45) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"410.64",y:"356.5",width:"12.18",height:"0.12",transform:"translate(773.29 -60.16) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"410.35",y:"356.5",width:"12.18",height:"0.12",transform:"translate(773 -59.88) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"410.06",y:"356.5",width:"12.18",height:"0.12",transform:"translate(772.72 -59.59) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"453.27 342.74 452.17 342.74 452.17 334.47 477.75 334.47 477.75 341.33 477.75 342.74 477.75 349.6 453.27 349.6 453.27 342.74",fill:"#aee2fa",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"448.04",y:"337.13",width:"7.12",height:"4.1",transform:"translate(790.77 -112.42) rotate(90)",fill:"#e0e0de",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"449.55",y:"343.74",width:"3.21",height:"3.22",transform:"translate(796.5 -105.8) rotate(90)",fill:"#e0e0de",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"459.67",y:"337.29",width:"8.79",height:"21.61",transform:"translate(812.16 -115.97) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"453.53",y:"352.15",width:"21.06",height:"21.61",transform:"translate(827.01 -101.12) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"447.01",y:"352.58",width:"21.55",height:"21.61",transform:"translate(821.17 -94.4) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"452.43",y:"365.75",width:"21.55",height:"21.61",transform:"translate(839.76 -86.66) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"459.47",y:"369.32",width:"13.46",height:"21.61",transform:"translate(846.32 -86.08) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"447.24",y:"375.13",width:"22.6",height:"19.83",transform:"translate(843.59 -73.49) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M449.19,398.9h12.67a3.09,3.09,0,0,0,2.19,2.74h-17v0A3.06,3.06,0,0,0,449.19,398.9Z",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"449.16",y:"394.47",width:"12.72",height:"5.41",transform:"translate(911.04 794.35) rotate(-180)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"468.48 396.27 448.56 396.27 448.56 374.15 450.27 374.15 450.27 354.15 453.22 354.15 453.26 349.62 474.85 349.62 474.85 363.25 477.03 363.25 477.03 373.47 481.56 373.47 481.56 388.09 468.48 388.09 468.48 396.27",fill:"#a7a9ac",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"453.18 349.58 474.8 349.58 474.8 363.25 476.94 363.25 476.94 373.43 481.56 373.43 481.56 388.04 455.74 388.04 455.74 384.28 453.18 384.28 453.18 349.58",fill:"#c5c6c8",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M453.17,376h24V363.22H475V350.4H453.2l-.06,11h-.78v7.09h.81Zm12.65-1.5V367h10.9v7.48Z",fill:"#e6e7e7",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"457.88",y:"345.66",width:"12.31",height:"21.78",transform:"translate(820.59 -107.49) rotate(90)",fill:"#6e6f71",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.13"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"447.39",y:"356.5",width:"12.18",height:"0.12",transform:"translate(810.04 -96.91) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"447.68",y:"356.5",width:"12.18",height:"0.12",transform:"translate(810.33 -97.2) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"447.97",y:"356.5",width:"12.18",height:"0.12",transform:"translate(810.62 -97.49) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"448.25",y:"356.5",width:"12.18",height:"0.12",transform:"translate(810.91 -97.78) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"448.54",y:"356.5",width:"12.18",height:"0.12",transform:"translate(811.19 -98.07) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"448.83",y:"356.5",width:"12.18",height:"0.12",transform:"translate(811.48 -98.36) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"449.12",y:"356.5",width:"12.18",height:"0.12",transform:"translate(811.77 -98.64) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"449.41",y:"356.5",width:"12.18",height:"0.12",transform:"translate(812.06 -98.93) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"449.7",y:"356.5",width:"12.18",height:"0.12",transform:"translate(812.35 -99.22) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"449.98",y:"356.5",width:"12.18",height:"0.12",transform:"translate(812.64 -99.51) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"450.27",y:"356.5",width:"12.18",height:"0.12",transform:"translate(812.93 -99.8) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"450.56",y:"356.5",width:"12.18",height:"0.12",transform:"translate(813.21 -100.09) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"450.85",y:"356.5",width:"12.18",height:"0.12",transform:"translate(813.5 -100.37) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"451.14",y:"356.5",width:"12.18",height:"0.12",transform:"translate(813.79 -100.66) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"451.43",y:"356.5",width:"12.18",height:"0.12",transform:"translate(814.08 -100.95) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"451.72",y:"356.5",width:"12.18",height:"0.12",transform:"translate(814.37 -101.24) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"452",y:"356.5",width:"12.18",height:"0.12",transform:"translate(814.66 -101.53) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"452.29",y:"356.5",width:"12.18",height:"0.12",transform:"translate(814.94 -101.82) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"452.58",y:"356.5",width:"12.18",height:"0.12",transform:"translate(815.23 -102.11) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"452.87",y:"356.5",width:"12.18",height:"0.12",transform:"translate(815.52 -102.39) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"453.16",y:"356.5",width:"12.18",height:"0.12",transform:"translate(815.81 -102.68) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"453.45",y:"356.5",width:"12.18",height:"0.12",transform:"translate(816.1 -102.97) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"453.74",y:"356.5",width:"12.18",height:"0.12",transform:"translate(816.39 -103.26) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"454.02",y:"356.5",width:"12.18",height:"0.12",transform:"translate(816.68 -103.55) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"454.31",y:"356.5",width:"12.18",height:"0.12",transform:"translate(816.96 -103.84) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"454.6",y:"356.5",width:"12.18",height:"0.12",transform:"translate(817.25 -104.13) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"454.89",y:"356.5",width:"12.18",height:"0.12",transform:"translate(817.54 -104.41) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"455.18",y:"356.5",width:"12.18",height:"0.12",transform:"translate(817.83 -104.7) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"455.47",y:"356.5",width:"12.18",height:"0.12",transform:"translate(818.12 -104.99) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"455.75",y:"356.5",width:"12.18",height:"0.12",transform:"translate(818.41 -105.28) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"456.04",y:"356.5",width:"12.18",height:"0.12",transform:"translate(818.7 -105.57) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"456.33",y:"356.5",width:"12.18",height:"0.12",transform:"translate(818.98 -105.86) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"456.62",y:"356.5",width:"12.18",height:"0.12",transform:"translate(819.27 -106.14) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"456.91",y:"356.5",width:"12.18",height:"0.12",transform:"translate(819.56 -106.43) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"457.2",y:"356.5",width:"12.18",height:"0.12",transform:"translate(819.85 -106.72) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"457.49",y:"356.5",width:"12.18",height:"0.12",transform:"translate(820.14 -107.01) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"457.77",y:"356.5",width:"12.18",height:"0.12",transform:"translate(820.43 -107.3) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"458.06",y:"356.5",width:"12.18",height:"0.12",transform:"translate(820.72 -107.59) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"458.35",y:"356.5",width:"12.18",height:"0.12",transform:"translate(821 -107.88) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"458.64",y:"356.5",width:"12.18",height:"0.12",transform:"translate(821.29 -108.16) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"458.93",y:"356.5",width:"12.18",height:"0.12",transform:"translate(821.58 -108.45) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"459.22",y:"356.5",width:"12.18",height:"0.12",transform:"translate(821.87 -108.74) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"459.51",y:"356.5",width:"12.18",height:"0.12",transform:"translate(822.16 -109.03) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"459.79",y:"356.5",width:"12.18",height:"0.12",transform:"translate(822.45 -109.32) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"460.08",y:"356.5",width:"12.18",height:"0.12",transform:"translate(822.73 -109.61) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"460.37",y:"356.5",width:"12.18",height:"0.12",transform:"translate(823.02 -109.9) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"460.66",y:"356.5",width:"12.18",height:"0.12",transform:"translate(823.31 -110.18) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"460.95",y:"356.5",width:"12.18",height:"0.12",transform:"translate(823.6 -110.47) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"461.24",y:"356.5",width:"12.18",height:"0.12",transform:"translate(823.89 -110.76) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"461.53",y:"356.5",width:"12.18",height:"0.12",transform:"translate(824.18 -111.05) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"461.81",y:"356.5",width:"12.18",height:"0.12",transform:"translate(824.47 -111.34) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"462.1",y:"356.5",width:"12.18",height:"0.12",transform:"translate(824.75 -111.63) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"462.39",y:"356.5",width:"12.18",height:"0.12",transform:"translate(825.04 -111.91) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"462.68",y:"356.5",width:"12.18",height:"0.12",transform:"translate(825.33 -112.2) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"462.97",y:"356.5",width:"12.18",height:"0.12",transform:"translate(825.62 -112.49) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"463.26",y:"356.5",width:"12.18",height:"0.12",transform:"translate(825.91 -112.78) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"463.54",y:"356.5",width:"12.18",height:"0.12",transform:"translate(826.2 -113.07) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"463.83",y:"356.5",width:"12.18",height:"0.12",transform:"translate(826.49 -113.36) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"464.12",y:"356.5",width:"12.18",height:"0.12",transform:"translate(826.77 -113.65) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"464.41",y:"356.5",width:"12.18",height:"0.12",transform:"translate(827.06 -113.93) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"464.7",y:"356.5",width:"12.18",height:"0.12",transform:"translate(827.35 -114.22) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"464.99",y:"356.5",width:"12.18",height:"0.12",transform:"translate(827.64 -114.51) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"465.28",y:"356.5",width:"12.18",height:"0.12",transform:"translate(827.93 -114.8) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"465.56",y:"356.5",width:"12.18",height:"0.12",transform:"translate(828.22 -115.09) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"465.85",y:"356.5",width:"12.18",height:"0.12",transform:"translate(828.5 -115.38) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"466.14",y:"356.5",width:"12.18",height:"0.12",transform:"translate(828.79 -115.67) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"466.43",y:"356.5",width:"12.18",height:"0.12",transform:"translate(829.08 -115.95) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"466.72",y:"356.5",width:"12.18",height:"0.12",transform:"translate(829.37 -116.24) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"467.01",y:"356.5",width:"12.18",height:"0.12",transform:"translate(829.66 -116.53) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"467.3",y:"356.5",width:"12.18",height:"0.12",transform:"translate(829.95 -116.82) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"467.58",y:"356.5",width:"12.18",height:"0.12",transform:"translate(830.24 -117.11) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"467.87",y:"356.5",width:"12.18",height:"0.12",transform:"translate(830.52 -117.4) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"468.16",y:"356.5",width:"12.18",height:"0.12",transform:"translate(830.81 -117.69) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"468.45",y:"356.5",width:"12.18",height:"0.12",transform:"translate(831.1 -117.97) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"513.42 321.38 514.52 321.38 514.52 329.65 488.94 329.65 488.94 322.79 488.94 321.38 488.94 314.52 513.42 314.52 513.42 321.38",fill:"#aee2fa",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"511.54",y:"322.89",width:"7.12",height:"4.1",transform:"translate(190.15 840.04) rotate(-90)",fill:"#e0e0de",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"513.93",y:"317.16",width:"3.21",height:"3.22",transform:"translate(196.76 834.31) rotate(-90)",fill:"#e0e0de",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"498.23",y:"305.22",width:"8.79",height:"21.61",transform:"translate(186.6 818.65) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"492.09",y:"290.37",width:"21.06",height:"21.61",transform:"translate(201.45 803.8) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"498.13",y:"289.93",width:"21.55",height:"21.61",transform:"translate(208.17 809.64) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"492.7",y:"276.77",width:"21.55",height:"21.61",transform:"translate(215.91 791.05) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"493.76",y:"273.19",width:"13.46",height:"21.61",transform:"translate(216.49 784.48) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"496.85",y:"269.16",width:"22.6",height:"19.83",transform:"translate(229.08 787.22) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M517.5,267.61H504.83a3.09,3.09,0,0,0-2.19-2.74h17v0A3.06,3.06,0,0,0,517.5,267.61Z",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"504.81",y:"266.62",width:"12.72",height:"5.41",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"498.21 267.85 518.13 267.85 518.13 289.97 516.42 289.97 516.42 309.97 513.47 309.97 513.43 314.5 491.84 314.5 491.84 300.87 489.66 300.87 489.66 290.65 485.13 290.65 485.13 276.03 498.21 276.03 498.21 267.85",fill:"#a7a9ac",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"513.51 314.54 491.89 314.54 491.89 300.87 489.75 300.87 489.75 290.69 485.13 290.69 485.13 276.08 510.95 276.08 510.95 279.84 513.51 279.84 513.51 314.54",fill:"#c5c6c8",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M513.52,288.17h-24V300.9h2.23v12.82h21.75l.06-11h.78v-7.09h-.81Zm-12.66,1.5v7.48H490v-7.48Z",fill:"#e6e7e7",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"496.49",y:"296.67",width:"12.31",height:"21.78",transform:"translate(195.08 810.22) rotate(-90)",fill:"#6e6f71",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.13"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"507.12",y:"307.49",width:"12.18",height:"0.12",transform:"translate(205.66 820.77) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"506.84",y:"307.49",width:"12.18",height:"0.12",transform:"translate(205.37 820.48) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"506.55",y:"307.49",width:"12.18",height:"0.12",transform:"translate(205.08 820.19) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"506.26",y:"307.49",width:"12.18",height:"0.12",transform:"translate(204.79 819.9) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"505.97",y:"307.49",width:"12.18",height:"0.12",transform:"translate(204.5 819.61) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"505.68",y:"307.49",width:"12.18",height:"0.12",transform:"translate(204.21 819.33) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"505.39",y:"307.49",width:"12.18",height:"0.12",transform:"translate(203.93 819.04) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"505.1",y:"307.49",width:"12.18",height:"0.12",transform:"translate(203.64 818.75) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"504.82",y:"307.49",width:"12.18",height:"0.12",transform:"translate(203.35 818.46) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"504.53",y:"307.49",width:"12.18",height:"0.12",transform:"translate(203.06 818.17) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"504.24",y:"307.49",width:"12.18",height:"0.12",transform:"translate(202.77 817.88) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"503.95",y:"307.49",width:"12.18",height:"0.12",transform:"translate(202.48 817.59) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"503.66",y:"307.49",width:"12.18",height:"0.12",transform:"translate(202.19 817.31) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"503.37",y:"307.49",width:"12.18",height:"0.12",transform:"translate(201.91 817.02) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"503.09",y:"307.49",width:"12.18",height:"0.12",transform:"translate(201.62 816.73) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"502.8",y:"307.49",width:"12.18",height:"0.12",transform:"translate(201.33 816.44) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"502.51",y:"307.49",width:"12.18",height:"0.12",transform:"translate(201.04 816.15) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"502.22",y:"307.49",width:"12.18",height:"0.12",transform:"translate(200.75 815.86) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"501.93",y:"307.49",width:"12.18",height:"0.12",transform:"translate(200.46 815.58) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"501.64",y:"307.49",width:"12.18",height:"0.12",transform:"translate(200.17 815.29) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"501.35",y:"307.49",width:"12.18",height:"0.12",transform:"translate(199.89 815) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"501.07",y:"307.49",width:"12.18",height:"0.12",transform:"translate(199.6 814.71) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"500.78",y:"307.49",width:"12.18",height:"0.12",transform:"translate(199.31 814.42) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"500.49",y:"307.49",width:"12.18",height:"0.12",transform:"translate(199.02 814.13) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"500.2",y:"307.49",width:"12.18",height:"0.12",transform:"translate(198.73 813.84) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"499.91",y:"307.49",width:"12.18",height:"0.12",transform:"translate(198.44 813.56) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"499.62",y:"307.49",width:"12.18",height:"0.12",transform:"translate(198.16 813.27) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"499.33",y:"307.49",width:"12.18",height:"0.12",transform:"translate(197.87 812.98) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"499.05",y:"307.49",width:"12.18",height:"0.12",transform:"translate(197.58 812.69) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"498.76",y:"307.49",width:"12.18",height:"0.12",transform:"translate(197.29 812.4) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"498.47",y:"307.49",width:"12.18",height:"0.12",transform:"translate(197 812.11) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"498.18",y:"307.49",width:"12.18",height:"0.12",transform:"translate(196.71 811.82) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"497.89",y:"307.49",width:"12.18",height:"0.12",transform:"translate(196.42 811.54) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"497.6",y:"307.49",width:"12.18",height:"0.12",transform:"translate(196.14 811.25) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"497.31",y:"307.49",width:"12.18",height:"0.12",transform:"translate(195.85 810.96) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"497.03",y:"307.49",width:"12.18",height:"0.12",transform:"translate(195.56 810.67) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"496.74",y:"307.49",width:"12.18",height:"0.12",transform:"translate(195.27 810.38) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"496.45",y:"307.49",width:"12.18",height:"0.12",transform:"translate(194.98 810.09) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"496.16",y:"307.49",width:"12.18",height:"0.12",transform:"translate(194.69 809.81) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"495.87",y:"307.49",width:"12.18",height:"0.12",transform:"translate(194.4 809.52) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"495.58",y:"307.49",width:"12.18",height:"0.12",transform:"translate(194.12 809.23) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"495.3",y:"307.49",width:"12.18",height:"0.12",transform:"translate(193.83 808.94) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"495.01",y:"307.49",width:"12.18",height:"0.12",transform:"translate(193.54 808.65) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"494.72",y:"307.49",width:"12.18",height:"0.12",transform:"translate(193.25 808.36) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"494.43",y:"307.49",width:"12.18",height:"0.12",transform:"translate(192.96 808.07) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"494.14",y:"307.49",width:"12.18",height:"0.12",transform:"translate(192.67 807.79) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"493.85",y:"307.49",width:"12.18",height:"0.12",transform:"translate(192.38 807.5) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"493.56",y:"307.49",width:"12.18",height:"0.12",transform:"translate(192.1 807.21) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"493.28",y:"307.49",width:"12.18",height:"0.12",transform:"translate(191.81 806.92) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"492.99",y:"307.49",width:"12.18",height:"0.12",transform:"translate(191.52 806.63) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"492.7",y:"307.49",width:"12.18",height:"0.12",transform:"translate(191.23 806.34) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"492.41",y:"307.49",width:"12.18",height:"0.12",transform:"translate(190.94 806.05) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"492.12",y:"307.49",width:"12.18",height:"0.12",transform:"translate(190.65 805.77) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"491.83",y:"307.49",width:"12.18",height:"0.12",transform:"translate(190.37 805.48) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"491.54",y:"307.49",width:"12.18",height:"0.12",transform:"translate(190.08 805.19) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"491.26",y:"307.49",width:"12.18",height:"0.12",transform:"translate(189.79 804.9) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"490.97",y:"307.49",width:"12.18",height:"0.12",transform:"translate(189.5 804.61) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"490.68",y:"307.49",width:"12.18",height:"0.12",transform:"translate(189.21 804.32) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"490.39",y:"307.49",width:"12.18",height:"0.12",transform:"translate(188.92 804.03) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"490.1",y:"307.49",width:"12.18",height:"0.12",transform:"translate(188.63 803.75) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"489.81",y:"307.49",width:"12.18",height:"0.12",transform:"translate(188.35 803.46) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"489.53",y:"307.49",width:"12.18",height:"0.12",transform:"translate(188.06 803.17) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"489.24",y:"307.49",width:"12.18",height:"0.12",transform:"translate(187.77 802.88) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"488.95",y:"307.49",width:"12.18",height:"0.12",transform:"translate(187.48 802.59) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"488.66",y:"307.49",width:"12.18",height:"0.12",transform:"translate(187.19 802.3) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"488.37",y:"307.49",width:"12.18",height:"0.12",transform:"translate(186.9 802.02) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"488.08",y:"307.49",width:"12.18",height:"0.12",transform:"translate(186.61 801.73) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"487.79",y:"307.49",width:"12.18",height:"0.12",transform:"translate(186.33 801.44) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"487.51",y:"307.49",width:"12.18",height:"0.12",transform:"translate(186.04 801.15) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"487.22",y:"307.49",width:"12.18",height:"0.12",transform:"translate(185.75 800.86) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"486.93",y:"307.49",width:"12.18",height:"0.12",transform:"translate(185.46 800.57) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"486.64",y:"307.49",width:"12.18",height:"0.12",transform:"translate(185.17 800.28) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"486.35",y:"307.49",width:"12.18",height:"0.12",transform:"translate(184.88 800) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"486.06",y:"307.49",width:"12.18",height:"0.12",transform:"translate(184.6 799.71) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"529.27 321.38 528.17 321.38 528.17 329.65 553.75 329.65 553.75 322.79 553.75 321.38 553.75 314.52 529.27 314.52 529.27 321.38",fill:"#aee2fa",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"524.04",y:"322.89",width:"7.12",height:"4.1",transform:"translate(202.65 852.54) rotate(-90)",fill:"#e0e0de",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"525.55",y:"317.16",width:"3.21",height:"3.22",transform:"translate(208.38 845.92) rotate(-90)",fill:"#e0e0de",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"535.67",y:"305.22",width:"8.79",height:"21.61",transform:"translate(224.04 856.09) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"529.53",y:"290.37",width:"21.06",height:"21.61",transform:"translate(238.89 841.24) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"523.01",y:"289.93",width:"21.55",height:"21.61",transform:"translate(233.05 834.52) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"528.43",y:"276.77",width:"21.55",height:"21.61",transform:"translate(251.64 826.78) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"535.47",y:"273.19",width:"13.46",height:"21.61",transform:"translate(258.2 826.2) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"523.24",y:"269.16",width:"22.6",height:"19.83",transform:"translate(255.47 813.61) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M525.19,267.61h12.67a3.09,3.09,0,0,1,2.19-2.74h-17v0A3.06,3.06,0,0,1,525.19,267.61Z",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"525.16",y:"266.62",width:"12.72",height:"5.41",transform:"translate(1063.04 538.66) rotate(-180)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"544.48 267.85 524.56 267.85 524.56 289.97 526.27 289.97 526.27 309.97 529.22 309.97 529.26 314.5 550.85 314.5 550.85 300.87 553.03 300.87 553.03 290.65 557.56 290.65 557.56 276.03 544.48 276.03 544.48 267.85",fill:"#a7a9ac",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"529.18 314.54 550.8 314.54 550.8 300.87 552.94 300.87 552.94 290.69 557.56 290.69 557.56 276.08 531.74 276.08 531.74 279.84 529.18 279.84 529.18 314.54",fill:"#c5c6c8",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M529.17,295.64h-.81v7.09h.78l.06,11H551V300.9h2.23V288.17h-24Zm23.55-6v7.48h-10.9v-7.48Z",fill:"#e6e7e7",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"533.88",y:"296.67",width:"12.31",height:"21.78",transform:"translate(232.47 847.61) rotate(-90)",fill:"#6e6f71",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.13"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"523.39",y:"307.49",width:"12.18",height:"0.12",transform:"translate(221.92 837.03) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"523.68",y:"307.49",width:"12.18",height:"0.12",transform:"translate(222.21 837.32) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"523.97",y:"307.49",width:"12.18",height:"0.12",transform:"translate(222.5 837.61) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"524.25",y:"307.49",width:"12.18",height:"0.12",transform:"translate(222.79 837.9) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"524.54",y:"307.49",width:"12.18",height:"0.12",transform:"translate(223.07 838.19) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"524.83",y:"307.49",width:"12.18",height:"0.12",transform:"translate(223.36 838.48) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"525.12",y:"307.49",width:"12.18",height:"0.12",transform:"translate(223.65 838.76) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"525.41",y:"307.49",width:"12.18",height:"0.12",transform:"translate(223.94 839.05) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"525.7",y:"307.49",width:"12.18",height:"0.12",transform:"translate(224.23 839.34) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"525.98",y:"307.49",width:"12.18",height:"0.12",transform:"translate(224.52 839.63) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"526.27",y:"307.49",width:"12.18",height:"0.12",transform:"translate(224.81 839.92) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"526.56",y:"307.49",width:"12.18",height:"0.12",transform:"translate(225.09 840.21) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"526.85",y:"307.49",width:"12.18",height:"0.12",transform:"translate(225.38 840.49) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"527.14",y:"307.49",width:"12.18",height:"0.12",transform:"translate(225.67 840.78) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"527.43",y:"307.49",width:"12.18",height:"0.12",transform:"translate(225.96 841.07) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"527.72",y:"307.49",width:"12.18",height:"0.12",transform:"translate(226.25 841.36) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"528",y:"307.49",width:"12.18",height:"0.12",transform:"translate(226.54 841.65) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"528.29",y:"307.49",width:"12.18",height:"0.12",transform:"translate(226.83 841.94) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"528.58",y:"307.49",width:"12.18",height:"0.12",transform:"translate(227.11 842.23) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"528.87",y:"307.49",width:"12.18",height:"0.12",transform:"translate(227.4 842.51) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"529.16",y:"307.49",width:"12.18",height:"0.12",transform:"translate(227.69 842.8) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"529.45",y:"307.49",width:"12.18",height:"0.12",transform:"translate(227.98 843.09) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"529.74",y:"307.49",width:"12.18",height:"0.12",transform:"translate(228.27 843.38) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"530.02",y:"307.49",width:"12.18",height:"0.12",transform:"translate(228.56 843.67) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"530.31",y:"307.49",width:"12.18",height:"0.12",transform:"translate(228.84 843.96) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"530.6",y:"307.49",width:"12.18",height:"0.12",transform:"translate(229.13 844.25) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"530.89",y:"307.49",width:"12.18",height:"0.12",transform:"translate(229.42 844.53) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"531.18",y:"307.49",width:"12.18",height:"0.12",transform:"translate(229.71 844.82) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"531.47",y:"307.49",width:"12.18",height:"0.12",transform:"translate(230 845.11) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"531.75",y:"307.49",width:"12.18",height:"0.12",transform:"translate(230.29 845.4) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"532.04",y:"307.49",width:"12.18",height:"0.12",transform:"translate(230.58 845.69) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"532.33",y:"307.49",width:"12.18",height:"0.12",transform:"translate(230.86 845.98) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"532.62",y:"307.49",width:"12.18",height:"0.12",transform:"translate(231.15 846.26) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"532.91",y:"307.49",width:"12.18",height:"0.12",transform:"translate(231.44 846.55) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"533.2",y:"307.49",width:"12.18",height:"0.12",transform:"translate(231.73 846.84) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"533.49",y:"307.49",width:"12.18",height:"0.12",transform:"translate(232.02 847.13) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"533.77",y:"307.49",width:"12.18",height:"0.12",transform:"translate(232.31 847.42) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"534.06",y:"307.49",width:"12.18",height:"0.12",transform:"translate(232.6 847.71) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"534.35",y:"307.49",width:"12.18",height:"0.12",transform:"translate(232.88 848) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"534.64",y:"307.49",width:"12.18",height:"0.12",transform:"translate(233.17 848.28) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"534.93",y:"307.49",width:"12.18",height:"0.12",transform:"translate(233.46 848.57) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"535.22",y:"307.49",width:"12.18",height:"0.12",transform:"translate(233.75 848.86) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"535.51",y:"307.49",width:"12.18",height:"0.12",transform:"translate(234.04 849.15) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"535.79",y:"307.49",width:"12.18",height:"0.12",transform:"translate(234.33 849.44) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"536.08",y:"307.49",width:"12.18",height:"0.12",transform:"translate(234.61 849.73) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"536.37",y:"307.49",width:"12.18",height:"0.12",transform:"translate(234.9 850.02) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"536.66",y:"307.49",width:"12.18",height:"0.12",transform:"translate(235.19 850.3) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"536.95",y:"307.49",width:"12.18",height:"0.12",transform:"translate(235.48 850.59) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"537.24",y:"307.49",width:"12.18",height:"0.12",transform:"translate(235.77 850.88) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"537.53",y:"307.49",width:"12.18",height:"0.12",transform:"translate(236.06 851.17) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"537.81",y:"307.49",width:"12.18",height:"0.12",transform:"translate(236.35 851.46) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"538.1",y:"307.49",width:"12.18",height:"0.12",transform:"translate(236.63 851.75) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"538.39",y:"307.49",width:"12.18",height:"0.12",transform:"translate(236.92 852.03) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"538.68",y:"307.49",width:"12.18",height:"0.12",transform:"translate(237.21 852.32) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"538.97",y:"307.49",width:"12.18",height:"0.12",transform:"translate(237.5 852.61) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"539.26",y:"307.49",width:"12.18",height:"0.12",transform:"translate(237.79 852.9) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"539.54",y:"307.49",width:"12.18",height:"0.12",transform:"translate(238.08 853.19) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"539.83",y:"307.49",width:"12.18",height:"0.12",transform:"translate(238.37 853.48) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"540.12",y:"307.49",width:"12.18",height:"0.12",transform:"translate(238.65 853.77) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"540.41",y:"307.49",width:"12.18",height:"0.12",transform:"translate(238.94 854.05) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"540.7",y:"307.49",width:"12.18",height:"0.12",transform:"translate(239.23 854.34) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"540.99",y:"307.49",width:"12.18",height:"0.12",transform:"translate(239.52 854.63) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"541.28",y:"307.49",width:"12.18",height:"0.12",transform:"translate(239.81 854.92) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"541.56",y:"307.49",width:"12.18",height:"0.12",transform:"translate(240.1 855.21) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"541.85",y:"307.49",width:"12.18",height:"0.12",transform:"translate(240.38 855.5) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"542.14",y:"307.49",width:"12.18",height:"0.12",transform:"translate(240.67 855.79) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"542.43",y:"307.49",width:"12.18",height:"0.12",transform:"translate(240.96 856.07) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"542.72",y:"307.49",width:"12.18",height:"0.12",transform:"translate(241.25 856.36) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"543.01",y:"307.49",width:"12.18",height:"0.12",transform:"translate(241.54 856.65) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"543.3",y:"307.49",width:"12.18",height:"0.12",transform:"translate(241.83 856.94) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"543.58",y:"307.49",width:"12.18",height:"0.12",transform:"translate(242.12 857.23) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"543.87",y:"307.49",width:"12.18",height:"0.12",transform:"translate(242.4 857.52) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"544.16",y:"307.49",width:"12.18",height:"0.12",transform:"translate(242.69 857.81) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"544.45",y:"307.49",width:"12.18",height:"0.12",transform:"translate(242.98 858.09) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"513.42 342.74 514.52 342.74 514.52 334.47 488.94 334.47 488.94 341.33 488.94 342.74 488.94 349.6 513.42 349.6 513.42 342.74",fill:"#aee2fa",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"511.54",y:"337.13",width:"7.12",height:"4.1",transform:"translate(854.27 -175.92) rotate(90)",fill:"#e0e0de",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"513.93",y:"343.74",width:"3.21",height:"3.22",transform:"translate(860.88 -170.19) rotate(90)",fill:"#e0e0de",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"498.23",y:"337.29",width:"8.79",height:"21.61",transform:"translate(850.72 -154.53) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"492.09",y:"352.15",width:"21.06",height:"21.61",transform:"translate(865.57 -139.68) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"498.13",y:"352.58",width:"21.55",height:"21.61",transform:"translate(872.29 -145.52) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"492.7",y:"365.75",width:"21.55",height:"21.61",transform:"translate(880.03 -126.93) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"493.76",y:"369.32",width:"13.46",height:"21.61",transform:"translate(880.61 -120.36) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"496.85",y:"375.13",width:"22.6",height:"19.83",transform:"translate(893.2 -123.1) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M517.5,398.9H504.83a3.09,3.09,0,0,1-2.19,2.74h17v0A3.06,3.06,0,0,1,517.5,398.9Z",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"504.81",y:"394.47",width:"12.72",height:"5.41",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"498.21 396.27 518.13 396.27 518.13 374.15 516.42 374.15 516.42 354.15 513.47 354.15 513.43 349.62 491.84 349.62 491.84 363.25 489.66 363.25 489.66 373.47 485.13 373.47 485.13 388.09 498.21 388.09 498.21 396.27",fill:"#a7a9ac",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"513.51 349.58 491.89 349.58 491.89 363.25 489.75 363.25 489.75 373.43 485.13 373.43 485.13 388.04 510.95 388.04 510.95 384.28 513.51 384.28 513.51 349.58",fill:"#c5c6c8",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M513.52,368.48h.81v-7.09h-.78l-.06-11H491.74v12.82h-2.23V376h24Zm-23.55,6V367h10.89v7.48Z",fill:"#e6e7e7",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"496.49",y:"345.66",width:"12.31",height:"21.78",transform:"translate(859.2 -146.1) rotate(90)",fill:"#6e6f71",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.13"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"507.12",y:"356.5",width:"12.18",height:"0.12",transform:"translate(869.78 -156.65) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"506.84",y:"356.5",width:"12.18",height:"0.12",transform:"translate(869.49 -156.36) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"506.55",y:"356.5",width:"12.18",height:"0.12",transform:"translate(869.2 -156.07) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"506.26",y:"356.5",width:"12.18",height:"0.12",transform:"translate(868.91 -155.78) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"505.97",y:"356.5",width:"12.18",height:"0.12",transform:"translate(868.62 -155.49) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"505.68",y:"356.5",width:"12.18",height:"0.12",transform:"translate(868.33 -155.21) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"505.39",y:"356.5",width:"12.18",height:"0.12",transform:"translate(868.05 -154.92) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"505.1",y:"356.5",width:"12.18",height:"0.12",transform:"translate(867.76 -154.63) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"504.82",y:"356.5",width:"12.18",height:"0.12",transform:"translate(867.47 -154.34) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"504.53",y:"356.5",width:"12.18",height:"0.12",transform:"translate(867.18 -154.05) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"504.24",y:"356.5",width:"12.18",height:"0.12",transform:"translate(866.89 -153.76) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"503.95",y:"356.5",width:"12.18",height:"0.12",transform:"translate(866.6 -153.47) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"503.66",y:"356.5",width:"12.18",height:"0.12",transform:"translate(866.31 -153.19) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"503.37",y:"356.5",width:"12.18",height:"0.12",transform:"translate(866.03 -152.9) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"503.09",y:"356.5",width:"12.18",height:"0.12",transform:"translate(865.74 -152.61) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"502.8",y:"356.5",width:"12.18",height:"0.12",transform:"translate(865.45 -152.32) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"502.51",y:"356.5",width:"12.18",height:"0.12",transform:"translate(865.16 -152.03) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"502.22",y:"356.5",width:"12.18",height:"0.12",transform:"translate(864.87 -151.74) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"501.93",y:"356.5",width:"12.18",height:"0.12",transform:"translate(864.58 -151.46) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"501.64",y:"356.5",width:"12.18",height:"0.12",transform:"translate(864.29 -151.17) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"501.35",y:"356.5",width:"12.18",height:"0.12",transform:"translate(864.01 -150.88) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"501.07",y:"356.5",width:"12.18",height:"0.12",transform:"translate(863.72 -150.59) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"500.78",y:"356.5",width:"12.18",height:"0.12",transform:"translate(863.43 -150.3) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"500.49",y:"356.5",width:"12.18",height:"0.12",transform:"translate(863.14 -150.01) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"500.2",y:"356.5",width:"12.18",height:"0.12",transform:"translate(862.85 -149.72) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"499.91",y:"356.5",width:"12.18",height:"0.12",transform:"translate(862.56 -149.44) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"499.62",y:"356.5",width:"12.18",height:"0.12",transform:"translate(862.28 -149.15) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"499.33",y:"356.5",width:"12.18",height:"0.12",transform:"translate(861.99 -148.86) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"499.05",y:"356.5",width:"12.18",height:"0.12",transform:"translate(861.7 -148.57) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"498.76",y:"356.5",width:"12.18",height:"0.12",transform:"translate(861.41 -148.28) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"498.47",y:"356.5",width:"12.18",height:"0.12",transform:"translate(861.12 -147.99) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"498.18",y:"356.5",width:"12.18",height:"0.12",transform:"translate(860.83 -147.7) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"497.89",y:"356.5",width:"12.18",height:"0.12",transform:"translate(860.54 -147.42) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"497.6",y:"356.5",width:"12.18",height:"0.12",transform:"translate(860.26 -147.13) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"497.31",y:"356.5",width:"12.18",height:"0.12",transform:"translate(859.97 -146.84) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"497.03",y:"356.5",width:"12.18",height:"0.12",transform:"translate(859.68 -146.55) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"496.74",y:"356.5",width:"12.18",height:"0.12",transform:"translate(859.39 -146.26) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"496.45",y:"356.5",width:"12.18",height:"0.12",transform:"translate(859.1 -145.97) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"496.16",y:"356.5",width:"12.18",height:"0.12",transform:"translate(858.81 -145.69) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"495.87",y:"356.5",width:"12.18",height:"0.12",transform:"translate(858.52 -145.4) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"495.58",y:"356.5",width:"12.18",height:"0.12",transform:"translate(858.24 -145.11) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"495.3",y:"356.5",width:"12.18",height:"0.12",transform:"translate(857.95 -144.82) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"495.01",y:"356.5",width:"12.18",height:"0.12",transform:"translate(857.66 -144.53) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"494.72",y:"356.5",width:"12.18",height:"0.12",transform:"translate(857.37 -144.24) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"494.43",y:"356.5",width:"12.18",height:"0.12",transform:"translate(857.08 -143.95) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"494.14",y:"356.5",width:"12.18",height:"0.12",transform:"translate(856.79 -143.67) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"493.85",y:"356.5",width:"12.18",height:"0.12",transform:"translate(856.5 -143.38) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"493.56",y:"356.5",width:"12.18",height:"0.12",transform:"translate(856.22 -143.09) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"493.28",y:"356.5",width:"12.18",height:"0.12",transform:"translate(855.93 -142.8) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"492.99",y:"356.5",width:"12.18",height:"0.12",transform:"translate(855.64 -142.51) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"492.7",y:"356.5",width:"12.18",height:"0.12",transform:"translate(855.35 -142.22) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"492.41",y:"356.5",width:"12.18",height:"0.12",transform:"translate(855.06 -141.93) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"492.12",y:"356.5",width:"12.18",height:"0.12",transform:"translate(854.77 -141.65) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"491.83",y:"356.5",width:"12.18",height:"0.12",transform:"translate(854.49 -141.36) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"491.54",y:"356.5",width:"12.18",height:"0.12",transform:"translate(854.2 -141.07) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"491.26",y:"356.5",width:"12.18",height:"0.12",transform:"translate(853.91 -140.78) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"490.97",y:"356.5",width:"12.18",height:"0.12",transform:"translate(853.62 -140.49) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"490.68",y:"356.5",width:"12.18",height:"0.12",transform:"translate(853.33 -140.2) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"490.39",y:"356.5",width:"12.18",height:"0.12",transform:"translate(853.04 -139.92) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"490.1",y:"356.5",width:"12.18",height:"0.12",transform:"translate(852.75 -139.63) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"489.81",y:"356.5",width:"12.18",height:"0.12",transform:"translate(852.47 -139.34) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"489.53",y:"356.5",width:"12.18",height:"0.12",transform:"translate(852.18 -139.05) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"489.24",y:"356.5",width:"12.18",height:"0.12",transform:"translate(851.89 -138.76) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"488.95",y:"356.5",width:"12.18",height:"0.12",transform:"translate(851.6 -138.47) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"488.66",y:"356.5",width:"12.18",height:"0.12",transform:"translate(851.31 -138.18) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"488.37",y:"356.5",width:"12.18",height:"0.12",transform:"translate(851.02 -137.9) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"488.08",y:"356.5",width:"12.18",height:"0.12",transform:"translate(850.73 -137.61) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"487.79",y:"356.5",width:"12.18",height:"0.12",transform:"translate(850.45 -137.32) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"487.51",y:"356.5",width:"12.18",height:"0.12",transform:"translate(850.16 -137.03) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"487.22",y:"356.5",width:"12.18",height:"0.12",transform:"translate(849.87 -136.74) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"486.93",y:"356.5",width:"12.18",height:"0.12",transform:"translate(849.58 -136.45) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"486.64",y:"356.5",width:"12.18",height:"0.12",transform:"translate(849.29 -136.16) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"486.35",y:"356.5",width:"12.18",height:"0.12",transform:"translate(849 -135.88) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"486.06",y:"356.5",width:"12.18",height:"0.12",transform:"translate(848.72 -135.59) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"529.27 342.74 528.17 342.74 528.17 334.47 553.75 334.47 553.75 341.33 553.75 342.74 553.75 349.6 529.27 349.6 529.27 342.74",fill:"#aee2fa",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"524.04",y:"337.13",width:"7.12",height:"4.1",transform:"translate(866.77 -188.42) rotate(90)",fill:"#e0e0de",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"525.55",y:"343.74",width:"3.21",height:"3.22",transform:"translate(872.5 -181.8) rotate(90)",fill:"#e0e0de",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"535.67",y:"337.29",width:"8.79",height:"21.61",transform:"translate(888.16 -191.97) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"529.53",y:"352.15",width:"21.06",height:"21.61",transform:"translate(903.01 -177.12) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"523.01",y:"352.58",width:"21.55",height:"21.61",transform:"translate(897.17 -170.4) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"528.43",y:"365.75",width:"21.55",height:"21.61",transform:"translate(915.76 -162.66) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"535.47",y:"369.32",width:"13.46",height:"21.61",transform:"translate(922.32 -162.08) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"523.24",y:"375.13",width:"22.6",height:"19.83",transform:"translate(919.59 -149.49) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M525.19,398.9h12.67a3.09,3.09,0,0,0,2.19,2.74h-17v0A3.06,3.06,0,0,0,525.19,398.9Z",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"525.16",y:"394.47",width:"12.72",height:"5.41",transform:"translate(1063.04 794.35) rotate(-180)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"544.48 396.27 524.56 396.27 524.56 374.15 526.27 374.15 526.27 354.15 529.22 354.15 529.26 349.62 550.85 349.62 550.85 363.25 553.03 363.25 553.03 373.47 557.56 373.47 557.56 388.09 544.48 388.09 544.48 396.27",fill:"#a7a9ac",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"529.18 349.58 550.8 349.58 550.8 363.25 552.94 363.25 552.94 373.43 557.56 373.43 557.56 388.04 531.74 388.04 531.74 384.28 529.18 384.28 529.18 349.58",fill:"#c5c6c8",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M529.17,376h24V363.22H551V350.4H529.2l-.06,11h-.78v7.09h.81Zm12.65-1.5V367h10.9v7.48Z",fill:"#e6e7e7",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"533.88",y:"345.66",width:"12.31",height:"21.78",transform:"translate(896.59 -183.49) rotate(90)",fill:"#6e6f71",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.13"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"523.39",y:"356.5",width:"12.18",height:"0.12",transform:"translate(886.04 -172.91) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"523.68",y:"356.5",width:"12.18",height:"0.12",transform:"translate(886.33 -173.2) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"523.97",y:"356.5",width:"12.18",height:"0.12",transform:"translate(886.62 -173.49) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"524.25",y:"356.5",width:"12.18",height:"0.12",transform:"translate(886.91 -173.78) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"524.54",y:"356.5",width:"12.18",height:"0.12",transform:"translate(887.19 -174.07) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"524.83",y:"356.5",width:"12.18",height:"0.12",transform:"translate(887.48 -174.36) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"525.12",y:"356.5",width:"12.18",height:"0.12",transform:"translate(887.77 -174.64) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"525.41",y:"356.5",width:"12.18",height:"0.12",transform:"translate(888.06 -174.93) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"525.7",y:"356.5",width:"12.18",height:"0.12",transform:"translate(888.35 -175.22) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"525.98",y:"356.5",width:"12.18",height:"0.12",transform:"translate(888.64 -175.51) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"526.27",y:"356.5",width:"12.18",height:"0.12",transform:"translate(888.93 -175.8) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"526.56",y:"356.5",width:"12.18",height:"0.12",transform:"translate(889.21 -176.09) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"526.85",y:"356.5",width:"12.18",height:"0.12",transform:"translate(889.5 -176.37) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"527.14",y:"356.5",width:"12.18",height:"0.12",transform:"translate(889.79 -176.66) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"527.43",y:"356.5",width:"12.18",height:"0.12",transform:"translate(890.08 -176.95) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"527.72",y:"356.5",width:"12.18",height:"0.12",transform:"translate(890.37 -177.24) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"528",y:"356.5",width:"12.18",height:"0.12",transform:"translate(890.66 -177.53) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"528.29",y:"356.5",width:"12.18",height:"0.12",transform:"translate(890.94 -177.82) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"528.58",y:"356.5",width:"12.18",height:"0.12",transform:"translate(891.23 -178.11) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"528.87",y:"356.5",width:"12.18",height:"0.12",transform:"translate(891.52 -178.39) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"529.16",y:"356.5",width:"12.18",height:"0.12",transform:"translate(891.81 -178.68) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"529.45",y:"356.5",width:"12.18",height:"0.12",transform:"translate(892.1 -178.97) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"529.74",y:"356.5",width:"12.18",height:"0.12",transform:"translate(892.39 -179.26) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"530.02",y:"356.5",width:"12.18",height:"0.12",transform:"translate(892.68 -179.55) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"530.31",y:"356.5",width:"12.18",height:"0.12",transform:"translate(892.96 -179.84) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"530.6",y:"356.5",width:"12.18",height:"0.12",transform:"translate(893.25 -180.13) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"530.89",y:"356.5",width:"12.18",height:"0.12",transform:"translate(893.54 -180.41) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"531.18",y:"356.5",width:"12.18",height:"0.12",transform:"translate(893.83 -180.7) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"531.47",y:"356.5",width:"12.18",height:"0.12",transform:"translate(894.12 -180.99) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"531.75",y:"356.5",width:"12.18",height:"0.12",transform:"translate(894.41 -181.28) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"532.04",y:"356.5",width:"12.18",height:"0.12",transform:"translate(894.7 -181.57) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"532.33",y:"356.5",width:"12.18",height:"0.12",transform:"translate(894.98 -181.86) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"532.62",y:"356.5",width:"12.18",height:"0.12",transform:"translate(895.27 -182.14) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"532.91",y:"356.5",width:"12.18",height:"0.12",transform:"translate(895.56 -182.43) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"533.2",y:"356.5",width:"12.18",height:"0.12",transform:"translate(895.85 -182.72) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"533.49",y:"356.5",width:"12.18",height:"0.12",transform:"translate(896.14 -183.01) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"533.77",y:"356.5",width:"12.18",height:"0.12",transform:"translate(896.43 -183.3) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"534.06",y:"356.5",width:"12.18",height:"0.12",transform:"translate(896.72 -183.59) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"534.35",y:"356.5",width:"12.18",height:"0.12",transform:"translate(897 -183.88) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"534.64",y:"356.5",width:"12.18",height:"0.12",transform:"translate(897.29 -184.16) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"534.93",y:"356.5",width:"12.18",height:"0.12",transform:"translate(897.58 -184.45) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"535.22",y:"356.5",width:"12.18",height:"0.12",transform:"translate(897.87 -184.74) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"535.51",y:"356.5",width:"12.18",height:"0.12",transform:"translate(898.16 -185.03) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"535.79",y:"356.5",width:"12.18",height:"0.12",transform:"translate(898.45 -185.32) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"536.08",y:"356.5",width:"12.18",height:"0.12",transform:"translate(898.73 -185.61) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"536.37",y:"356.5",width:"12.18",height:"0.12",transform:"translate(899.02 -185.9) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"536.66",y:"356.5",width:"12.18",height:"0.12",transform:"translate(899.31 -186.18) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"536.95",y:"356.5",width:"12.18",height:"0.12",transform:"translate(899.6 -186.47) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"537.24",y:"356.5",width:"12.18",height:"0.12",transform:"translate(899.89 -186.76) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"537.53",y:"356.5",width:"12.18",height:"0.12",transform:"translate(900.18 -187.05) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"537.81",y:"356.5",width:"12.18",height:"0.12",transform:"translate(900.47 -187.34) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"538.1",y:"356.5",width:"12.18",height:"0.12",transform:"translate(900.75 -187.63) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"538.39",y:"356.5",width:"12.18",height:"0.12",transform:"translate(901.04 -187.91) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"538.68",y:"356.5",width:"12.18",height:"0.12",transform:"translate(901.33 -188.2) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"538.97",y:"356.5",width:"12.18",height:"0.12",transform:"translate(901.62 -188.49) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"539.26",y:"356.5",width:"12.18",height:"0.12",transform:"translate(901.91 -188.78) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"539.54",y:"356.5",width:"12.18",height:"0.12",transform:"translate(902.2 -189.07) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"539.83",y:"356.5",width:"12.18",height:"0.12",transform:"translate(902.49 -189.36) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"540.12",y:"356.5",width:"12.18",height:"0.12",transform:"translate(902.77 -189.65) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"540.41",y:"356.5",width:"12.18",height:"0.12",transform:"translate(903.06 -189.93) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"540.7",y:"356.5",width:"12.18",height:"0.12",transform:"translate(903.35 -190.22) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"540.99",y:"356.5",width:"12.18",height:"0.12",transform:"translate(903.64 -190.51) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"541.28",y:"356.5",width:"12.18",height:"0.12",transform:"translate(903.93 -190.8) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"541.56",y:"356.5",width:"12.18",height:"0.12",transform:"translate(904.22 -191.09) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"541.85",y:"356.5",width:"12.18",height:"0.12",transform:"translate(904.5 -191.38) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"542.14",y:"356.5",width:"12.18",height:"0.12",transform:"translate(904.79 -191.67) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"542.43",y:"356.5",width:"12.18",height:"0.12",transform:"translate(905.08 -191.95) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"542.72",y:"356.5",width:"12.18",height:"0.12",transform:"translate(905.37 -192.24) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"543.01",y:"356.5",width:"12.18",height:"0.12",transform:"translate(905.66 -192.53) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"543.3",y:"356.5",width:"12.18",height:"0.12",transform:"translate(905.95 -192.82) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"543.58",y:"356.5",width:"12.18",height:"0.12",transform:"translate(906.24 -193.11) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"543.87",y:"356.5",width:"12.18",height:"0.12",transform:"translate(906.52 -193.4) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"544.16",y:"356.5",width:"12.18",height:"0.12",transform:"translate(906.81 -193.69) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"544.45",y:"356.5",width:"12.18",height:"0.12",transform:"translate(907.1 -193.97) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"589.42 321.38 590.52 321.38 590.52 329.65 564.94 329.65 564.94 322.79 564.94 321.38 564.94 314.52 589.42 314.52 589.42 321.38",fill:"#aee2fa",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"587.54",y:"322.89",width:"7.12",height:"4.1",transform:"translate(266.15 916.04) rotate(-90)",fill:"#e0e0de",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"589.93",y:"317.16",width:"3.21",height:"3.22",transform:"translate(272.76 910.31) rotate(-90)",fill:"#e0e0de",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"574.23",y:"305.22",width:"8.79",height:"21.61",transform:"translate(262.6 894.65) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"568.09",y:"290.37",width:"21.06",height:"21.61",transform:"translate(277.45 879.8) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"574.13",y:"289.93",width:"21.55",height:"21.61",transform:"translate(284.17 885.64) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"568.7",y:"276.77",width:"21.55",height:"21.61",transform:"translate(291.91 867.05) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"569.76",y:"273.19",width:"13.46",height:"21.61",transform:"translate(292.49 860.48) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"572.85",y:"269.16",width:"22.6",height:"19.83",transform:"translate(305.08 863.22) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M593.5,267.61H580.83a3.09,3.09,0,0,0-2.19-2.74h17v0A3.06,3.06,0,0,0,593.5,267.61Z",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"580.81",y:"266.62",width:"12.72",height:"5.41",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"574.21 267.85 594.13 267.85 594.13 289.97 592.42 289.97 592.42 309.97 589.47 309.97 589.43 314.5 567.84 314.5 567.84 300.87 565.66 300.87 565.66 290.65 561.13 290.65 561.13 276.03 574.21 276.03 574.21 267.85",fill:"#a7a9ac",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"589.51 314.54 567.89 314.54 567.89 300.87 565.75 300.87 565.75 290.69 561.13 290.69 561.13 276.08 586.95 276.08 586.95 279.84 589.51 279.84 589.51 314.54",fill:"#c5c6c8",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M589.52,288.17h-24V300.9h2.23v12.82h21.75l.06-11h.78v-7.09h-.81Zm-12.66,1.5v7.48H566v-7.48Z",fill:"#e6e7e7",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"572.49",y:"296.67",width:"12.31",height:"21.78",transform:"translate(271.08 886.22) rotate(-90)",fill:"#6e6f71",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.13"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"583.12",y:"307.49",width:"12.18",height:"0.12",transform:"translate(281.66 896.77) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"582.84",y:"307.49",width:"12.18",height:"0.12",transform:"translate(281.37 896.48) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"582.55",y:"307.49",width:"12.18",height:"0.12",transform:"translate(281.08 896.19) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"582.26",y:"307.49",width:"12.18",height:"0.12",transform:"translate(280.79 895.9) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"581.97",y:"307.49",width:"12.18",height:"0.12",transform:"translate(280.5 895.61) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"581.68",y:"307.49",width:"12.18",height:"0.12",transform:"translate(280.21 895.33) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"581.39",y:"307.49",width:"12.18",height:"0.12",transform:"translate(279.93 895.04) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"581.1",y:"307.49",width:"12.18",height:"0.12",transform:"translate(279.64 894.75) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"580.82",y:"307.49",width:"12.18",height:"0.12",transform:"translate(279.35 894.46) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"580.53",y:"307.49",width:"12.18",height:"0.12",transform:"translate(279.06 894.17) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"580.24",y:"307.49",width:"12.18",height:"0.12",transform:"translate(278.77 893.88) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"579.95",y:"307.49",width:"12.18",height:"0.12",transform:"translate(278.48 893.59) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"579.66",y:"307.49",width:"12.18",height:"0.12",transform:"translate(278.19 893.31) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"579.37",y:"307.49",width:"12.18",height:"0.12",transform:"translate(277.91 893.02) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"579.09",y:"307.49",width:"12.18",height:"0.12",transform:"translate(277.62 892.73) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"578.8",y:"307.49",width:"12.18",height:"0.12",transform:"translate(277.33 892.44) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"578.51",y:"307.49",width:"12.18",height:"0.12",transform:"translate(277.04 892.15) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"578.22",y:"307.49",width:"12.18",height:"0.12",transform:"translate(276.75 891.86) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"577.93",y:"307.49",width:"12.18",height:"0.12",transform:"translate(276.46 891.58) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"577.64",y:"307.49",width:"12.18",height:"0.12",transform:"translate(276.17 891.29) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"577.35",y:"307.49",width:"12.18",height:"0.12",transform:"translate(275.89 891) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"577.07",y:"307.49",width:"12.18",height:"0.12",transform:"translate(275.6 890.71) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"576.78",y:"307.49",width:"12.18",height:"0.12",transform:"translate(275.31 890.42) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"576.49",y:"307.49",width:"12.18",height:"0.12",transform:"translate(275.02 890.13) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"576.2",y:"307.49",width:"12.18",height:"0.12",transform:"translate(274.73 889.84) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"575.91",y:"307.49",width:"12.18",height:"0.12",transform:"translate(274.44 889.56) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"575.62",y:"307.49",width:"12.18",height:"0.12",transform:"translate(274.16 889.27) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"575.33",y:"307.49",width:"12.18",height:"0.12",transform:"translate(273.87 888.98) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"575.05",y:"307.49",width:"12.18",height:"0.12",transform:"translate(273.58 888.69) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"574.76",y:"307.49",width:"12.18",height:"0.12",transform:"translate(273.29 888.4) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"574.47",y:"307.49",width:"12.18",height:"0.12",transform:"translate(273 888.11) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"574.18",y:"307.49",width:"12.18",height:"0.12",transform:"translate(272.71 887.82) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"573.89",y:"307.49",width:"12.18",height:"0.12",transform:"translate(272.42 887.54) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"573.6",y:"307.49",width:"12.18",height:"0.12",transform:"translate(272.14 887.25) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"573.31",y:"307.49",width:"12.18",height:"0.12",transform:"translate(271.85 886.96) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"573.03",y:"307.49",width:"12.18",height:"0.12",transform:"translate(271.56 886.67) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"572.74",y:"307.49",width:"12.18",height:"0.12",transform:"translate(271.27 886.38) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"572.45",y:"307.49",width:"12.18",height:"0.12",transform:"translate(270.98 886.09) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"572.16",y:"307.49",width:"12.18",height:"0.12",transform:"translate(270.69 885.81) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"571.87",y:"307.49",width:"12.18",height:"0.12",transform:"translate(270.4 885.52) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"571.58",y:"307.49",width:"12.18",height:"0.12",transform:"translate(270.12 885.23) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"571.3",y:"307.49",width:"12.18",height:"0.12",transform:"translate(269.83 884.94) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"571.01",y:"307.49",width:"12.18",height:"0.12",transform:"translate(269.54 884.65) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"570.72",y:"307.49",width:"12.18",height:"0.12",transform:"translate(269.25 884.36) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"570.43",y:"307.49",width:"12.18",height:"0.12",transform:"translate(268.96 884.07) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"570.14",y:"307.49",width:"12.18",height:"0.12",transform:"translate(268.67 883.79) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"569.85",y:"307.49",width:"12.18",height:"0.12",transform:"translate(268.38 883.5) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"569.56",y:"307.49",width:"12.18",height:"0.12",transform:"translate(268.1 883.21) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"569.28",y:"307.49",width:"12.18",height:"0.12",transform:"translate(267.81 882.92) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"568.99",y:"307.49",width:"12.18",height:"0.12",transform:"translate(267.52 882.63) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"568.7",y:"307.49",width:"12.18",height:"0.12",transform:"translate(267.23 882.34) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"568.41",y:"307.49",width:"12.18",height:"0.12",transform:"translate(266.94 882.05) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"568.12",y:"307.49",width:"12.18",height:"0.12",transform:"translate(266.65 881.77) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"567.83",y:"307.49",width:"12.18",height:"0.12",transform:"translate(266.37 881.48) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"567.54",y:"307.49",width:"12.18",height:"0.12",transform:"translate(266.08 881.19) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"567.26",y:"307.49",width:"12.18",height:"0.12",transform:"translate(265.79 880.9) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"566.97",y:"307.49",width:"12.18",height:"0.12",transform:"translate(265.5 880.61) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"566.68",y:"307.49",width:"12.18",height:"0.12",transform:"translate(265.21 880.32) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"566.39",y:"307.49",width:"12.18",height:"0.12",transform:"translate(264.92 880.03) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"566.1",y:"307.49",width:"12.18",height:"0.12",transform:"translate(264.63 879.75) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"565.81",y:"307.49",width:"12.18",height:"0.12",transform:"translate(264.35 879.46) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"565.53",y:"307.49",width:"12.18",height:"0.12",transform:"translate(264.06 879.17) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"565.24",y:"307.49",width:"12.18",height:"0.12",transform:"translate(263.77 878.88) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"564.95",y:"307.49",width:"12.18",height:"0.12",transform:"translate(263.48 878.59) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"564.66",y:"307.49",width:"12.18",height:"0.12",transform:"translate(263.19 878.3) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"564.37",y:"307.49",width:"12.18",height:"0.12",transform:"translate(262.9 878.02) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"564.08",y:"307.49",width:"12.18",height:"0.12",transform:"translate(262.61 877.73) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"563.79",y:"307.49",width:"12.18",height:"0.12",transform:"translate(262.33 877.44) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"563.51",y:"307.49",width:"12.18",height:"0.12",transform:"translate(262.04 877.15) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"563.22",y:"307.49",width:"12.18",height:"0.12",transform:"translate(261.75 876.86) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"562.93",y:"307.49",width:"12.18",height:"0.12",transform:"translate(261.46 876.57) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"562.64",y:"307.49",width:"12.18",height:"0.12",transform:"translate(261.17 876.28) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"562.35",y:"307.49",width:"12.18",height:"0.12",transform:"translate(260.88 876) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"562.06",y:"307.49",width:"12.18",height:"0.12",transform:"translate(260.6 875.71) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"605.27 321.38 604.17 321.38 604.17 329.65 629.75 329.65 629.75 322.79 629.75 321.38 629.75 314.52 605.27 314.52 605.27 321.38",fill:"#aee2fa",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"600.04",y:"322.89",width:"7.12",height:"4.1",transform:"translate(278.65 928.54) rotate(-90)",fill:"#e0e0de",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"601.55",y:"317.16",width:"3.21",height:"3.22",transform:"translate(284.38 921.92) rotate(-90)",fill:"#e0e0de",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"611.67",y:"305.22",width:"8.79",height:"21.61",transform:"translate(300.04 932.09) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"605.53",y:"290.37",width:"21.06",height:"21.61",transform:"translate(314.89 917.24) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"599.01",y:"289.93",width:"21.55",height:"21.61",transform:"translate(309.05 910.52) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"604.43",y:"276.77",width:"21.55",height:"21.61",transform:"translate(327.64 902.78) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"611.47",y:"273.19",width:"13.46",height:"21.61",transform:"translate(334.2 902.2) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"599.24",y:"269.16",width:"22.6",height:"19.83",transform:"translate(331.47 889.61) rotate(-90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M601.19,267.61h12.67a3.09,3.09,0,0,1,2.19-2.74h-17v0A3.06,3.06,0,0,1,601.19,267.61Z",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"601.16",y:"266.62",width:"12.72",height:"5.41",transform:"translate(1215.04 538.66) rotate(-180)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"620.48 267.85 600.56 267.85 600.56 289.97 602.27 289.97 602.27 309.97 605.22 309.97 605.26 314.5 626.85 314.5 626.85 300.87 629.03 300.87 629.03 290.65 633.56 290.65 633.56 276.03 620.48 276.03 620.48 267.85",fill:"#a7a9ac",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"605.18 314.54 626.8 314.54 626.8 300.87 628.94 300.87 628.94 290.69 633.56 290.69 633.56 276.08 607.74 276.08 607.74 279.84 605.18 279.84 605.18 314.54",fill:"#c5c6c8",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M605.17,295.64h-.81v7.09h.78l.06,11H627V300.9h2.23V288.17h-24Zm23.55-6v7.48h-10.9v-7.48Z",fill:"#e6e7e7",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"609.88",y:"296.67",width:"12.31",height:"21.78",transform:"translate(308.47 923.61) rotate(-90)",fill:"#6e6f71",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.13"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"599.39",y:"307.49",width:"12.18",height:"0.12",transform:"translate(297.92 913.03) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"599.68",y:"307.49",width:"12.18",height:"0.12",transform:"translate(298.21 913.32) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"599.97",y:"307.49",width:"12.18",height:"0.12",transform:"translate(298.5 913.61) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"600.25",y:"307.49",width:"12.18",height:"0.12",transform:"translate(298.79 913.9) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"600.54",y:"307.49",width:"12.18",height:"0.12",transform:"translate(299.07 914.19) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"600.83",y:"307.49",width:"12.18",height:"0.12",transform:"translate(299.36 914.48) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"601.12",y:"307.49",width:"12.18",height:"0.12",transform:"translate(299.65 914.76) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"601.41",y:"307.49",width:"12.18",height:"0.12",transform:"translate(299.94 915.05) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"601.7",y:"307.49",width:"12.18",height:"0.12",transform:"translate(300.23 915.34) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"601.98",y:"307.49",width:"12.18",height:"0.12",transform:"translate(300.52 915.63) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"602.27",y:"307.49",width:"12.18",height:"0.12",transform:"translate(300.81 915.92) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"602.56",y:"307.49",width:"12.18",height:"0.12",transform:"translate(301.09 916.21) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"602.85",y:"307.49",width:"12.18",height:"0.12",transform:"translate(301.38 916.49) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"603.14",y:"307.49",width:"12.18",height:"0.12",transform:"translate(301.67 916.78) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"603.43",y:"307.49",width:"12.18",height:"0.12",transform:"translate(301.96 917.07) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"603.72",y:"307.49",width:"12.18",height:"0.12",transform:"translate(302.25 917.36) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"604",y:"307.49",width:"12.18",height:"0.12",transform:"translate(302.54 917.65) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"604.29",y:"307.49",width:"12.18",height:"0.12",transform:"translate(302.83 917.94) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"604.58",y:"307.49",width:"12.18",height:"0.12",transform:"translate(303.11 918.23) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"604.87",y:"307.49",width:"12.18",height:"0.12",transform:"translate(303.4 918.51) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"605.16",y:"307.49",width:"12.18",height:"0.12",transform:"translate(303.69 918.8) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"605.45",y:"307.49",width:"12.18",height:"0.12",transform:"translate(303.98 919.09) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"605.74",y:"307.49",width:"12.18",height:"0.12",transform:"translate(304.27 919.38) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"606.02",y:"307.49",width:"12.18",height:"0.12",transform:"translate(304.56 919.67) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"606.31",y:"307.49",width:"12.18",height:"0.12",transform:"translate(304.84 919.96) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"606.6",y:"307.49",width:"12.18",height:"0.12",transform:"translate(305.13 920.25) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"606.89",y:"307.49",width:"12.18",height:"0.12",transform:"translate(305.42 920.53) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"607.18",y:"307.49",width:"12.18",height:"0.12",transform:"translate(305.71 920.82) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"607.47",y:"307.49",width:"12.18",height:"0.12",transform:"translate(306 921.11) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"607.75",y:"307.49",width:"12.18",height:"0.12",transform:"translate(306.29 921.4) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"608.04",y:"307.49",width:"12.18",height:"0.12",transform:"translate(306.58 921.69) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"608.33",y:"307.49",width:"12.18",height:"0.12",transform:"translate(306.86 921.98) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"608.62",y:"307.49",width:"12.18",height:"0.12",transform:"translate(307.15 922.26) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"608.91",y:"307.49",width:"12.18",height:"0.12",transform:"translate(307.44 922.55) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"609.2",y:"307.49",width:"12.18",height:"0.12",transform:"translate(307.73 922.84) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"609.49",y:"307.49",width:"12.18",height:"0.12",transform:"translate(308.02 923.13) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"609.77",y:"307.49",width:"12.18",height:"0.12",transform:"translate(308.31 923.42) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"610.06",y:"307.49",width:"12.18",height:"0.12",transform:"translate(308.6 923.71) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"610.35",y:"307.49",width:"12.18",height:"0.12",transform:"translate(308.88 924) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"610.64",y:"307.49",width:"12.18",height:"0.12",transform:"translate(309.17 924.28) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"610.93",y:"307.49",width:"12.18",height:"0.12",transform:"translate(309.46 924.57) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"611.22",y:"307.49",width:"12.18",height:"0.12",transform:"translate(309.75 924.86) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"611.51",y:"307.49",width:"12.18",height:"0.12",transform:"translate(310.04 925.15) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"611.79",y:"307.49",width:"12.18",height:"0.12",transform:"translate(310.33 925.44) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"612.08",y:"307.49",width:"12.18",height:"0.12",transform:"translate(310.61 925.73) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"612.37",y:"307.49",width:"12.18",height:"0.12",transform:"translate(310.9 926.02) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"612.66",y:"307.49",width:"12.18",height:"0.12",transform:"translate(311.19 926.3) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"612.95",y:"307.49",width:"12.18",height:"0.12",transform:"translate(311.48 926.59) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"613.24",y:"307.49",width:"12.18",height:"0.12",transform:"translate(311.77 926.88) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"613.53",y:"307.49",width:"12.18",height:"0.12",transform:"translate(312.06 927.17) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"613.81",y:"307.49",width:"12.18",height:"0.12",transform:"translate(312.35 927.46) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"614.1",y:"307.49",width:"12.18",height:"0.12",transform:"translate(312.63 927.75) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"614.39",y:"307.49",width:"12.18",height:"0.12",transform:"translate(312.92 928.03) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"614.68",y:"307.49",width:"12.18",height:"0.12",transform:"translate(313.21 928.32) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"614.97",y:"307.49",width:"12.18",height:"0.12",transform:"translate(313.5 928.61) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"615.26",y:"307.49",width:"12.18",height:"0.12",transform:"translate(313.79 928.9) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"615.54",y:"307.49",width:"12.18",height:"0.12",transform:"translate(314.08 929.19) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"615.83",y:"307.49",width:"12.18",height:"0.12",transform:"translate(314.37 929.48) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"616.12",y:"307.49",width:"12.18",height:"0.12",transform:"translate(314.65 929.77) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"616.41",y:"307.49",width:"12.18",height:"0.12",transform:"translate(314.94 930.05) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"616.7",y:"307.49",width:"12.18",height:"0.12",transform:"translate(315.23 930.34) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"616.99",y:"307.49",width:"12.18",height:"0.12",transform:"translate(315.52 930.63) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"617.28",y:"307.49",width:"12.18",height:"0.12",transform:"translate(315.81 930.92) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"617.56",y:"307.49",width:"12.18",height:"0.12",transform:"translate(316.1 931.21) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"617.85",y:"307.49",width:"12.18",height:"0.12",transform:"translate(316.38 931.5) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"618.14",y:"307.49",width:"12.18",height:"0.12",transform:"translate(316.67 931.79) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"618.43",y:"307.49",width:"12.18",height:"0.12",transform:"translate(316.96 932.07) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"618.72",y:"307.49",width:"12.18",height:"0.12",transform:"translate(317.25 932.36) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"619.01",y:"307.49",width:"12.18",height:"0.12",transform:"translate(317.54 932.65) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"619.3",y:"307.49",width:"12.18",height:"0.12",transform:"translate(317.83 932.94) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"619.58",y:"307.49",width:"12.18",height:"0.12",transform:"translate(318.12 933.23) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"619.87",y:"307.49",width:"12.18",height:"0.12",transform:"translate(318.4 933.52) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"620.16",y:"307.49",width:"12.18",height:"0.12",transform:"translate(318.69 933.81) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"620.45",y:"307.49",width:"12.18",height:"0.12",transform:"translate(318.98 934.09) rotate(-90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"589.42 342.74 590.52 342.74 590.52 334.47 564.94 334.47 564.94 341.33 564.94 342.74 564.94 349.6 589.42 349.6 589.42 342.74",fill:"#aee2fa",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"587.54",y:"337.13",width:"7.12",height:"4.1",transform:"translate(930.27 -251.92) rotate(90)",fill:"#e0e0de",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"589.93",y:"343.74",width:"3.21",height:"3.22",transform:"translate(936.88 -246.19) rotate(90)",fill:"#e0e0de",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"574.23",y:"337.29",width:"8.79",height:"21.61",transform:"translate(926.72 -230.53) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"568.09",y:"352.15",width:"21.06",height:"21.61",transform:"translate(941.57 -215.68) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"574.13",y:"352.58",width:"21.55",height:"21.61",transform:"translate(948.29 -221.52) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"568.7",y:"365.75",width:"21.55",height:"21.61",transform:"translate(956.03 -202.93) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"569.76",y:"369.32",width:"13.46",height:"21.61",transform:"translate(956.61 -196.36) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"572.85",y:"375.13",width:"22.6",height:"19.83",transform:"translate(969.2 -199.1) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M593.5,398.9H580.83a3.09,3.09,0,0,1-2.19,2.74h17v0A3.06,3.06,0,0,1,593.5,398.9Z",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"580.81",y:"394.47",width:"12.72",height:"5.41",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"574.21 396.27 594.13 396.27 594.13 374.15 592.42 374.15 592.42 354.15 589.47 354.15 589.43 349.62 567.84 349.62 567.84 363.25 565.66 363.25 565.66 373.47 561.13 373.47 561.13 388.09 574.21 388.09 574.21 396.27",fill:"#a7a9ac",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"589.51 349.58 567.89 349.58 567.89 363.25 565.75 363.25 565.75 373.43 561.13 373.43 561.13 388.04 586.95 388.04 586.95 384.28 589.51 384.28 589.51 349.58",fill:"#c5c6c8",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M589.52,368.48h.81v-7.09h-.78l-.06-11H567.74v12.82h-2.23V376h24Zm-23.55,6V367h10.89v7.48Z",fill:"#e6e7e7",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"572.49",y:"345.66",width:"12.31",height:"21.78",transform:"translate(935.2 -222.1) rotate(90)",fill:"#6e6f71",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.13"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"583.12",y:"356.5",width:"12.18",height:"0.12",transform:"translate(945.78 -232.65) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"582.84",y:"356.5",width:"12.18",height:"0.12",transform:"translate(945.49 -232.36) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"582.55",y:"356.5",width:"12.18",height:"0.12",transform:"translate(945.2 -232.07) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"582.26",y:"356.5",width:"12.18",height:"0.12",transform:"translate(944.91 -231.78) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"581.97",y:"356.5",width:"12.18",height:"0.12",transform:"translate(944.62 -231.49) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"581.68",y:"356.5",width:"12.18",height:"0.12",transform:"translate(944.33 -231.21) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"581.39",y:"356.5",width:"12.18",height:"0.12",transform:"translate(944.05 -230.92) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"581.1",y:"356.5",width:"12.18",height:"0.12",transform:"translate(943.76 -230.63) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"580.82",y:"356.5",width:"12.18",height:"0.12",transform:"translate(943.47 -230.34) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"580.53",y:"356.5",width:"12.18",height:"0.12",transform:"translate(943.18 -230.05) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"580.24",y:"356.5",width:"12.18",height:"0.12",transform:"translate(942.89 -229.76) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"579.95",y:"356.5",width:"12.18",height:"0.12",transform:"translate(942.6 -229.47) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"579.66",y:"356.5",width:"12.18",height:"0.12",transform:"translate(942.31 -229.19) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"579.37",y:"356.5",width:"12.18",height:"0.12",transform:"translate(942.03 -228.9) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"579.09",y:"356.5",width:"12.18",height:"0.12",transform:"translate(941.74 -228.61) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"578.8",y:"356.5",width:"12.18",height:"0.12",transform:"translate(941.45 -228.32) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"578.51",y:"356.5",width:"12.18",height:"0.12",transform:"translate(941.16 -228.03) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"578.22",y:"356.5",width:"12.18",height:"0.12",transform:"translate(940.87 -227.74) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"577.93",y:"356.5",width:"12.18",height:"0.12",transform:"translate(940.58 -227.46) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"577.64",y:"356.5",width:"12.18",height:"0.12",transform:"translate(940.29 -227.17) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"577.35",y:"356.5",width:"12.18",height:"0.12",transform:"translate(940.01 -226.88) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"577.07",y:"356.5",width:"12.18",height:"0.12",transform:"translate(939.72 -226.59) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"576.78",y:"356.5",width:"12.18",height:"0.12",transform:"translate(939.43 -226.3) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"576.49",y:"356.5",width:"12.18",height:"0.12",transform:"translate(939.14 -226.01) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"576.2",y:"356.5",width:"12.18",height:"0.12",transform:"translate(938.85 -225.72) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"575.91",y:"356.5",width:"12.18",height:"0.12",transform:"translate(938.56 -225.44) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"575.62",y:"356.5",width:"12.18",height:"0.12",transform:"translate(938.28 -225.15) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"575.33",y:"356.5",width:"12.18",height:"0.12",transform:"translate(937.99 -224.86) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"575.05",y:"356.5",width:"12.18",height:"0.12",transform:"translate(937.7 -224.57) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"574.76",y:"356.5",width:"12.18",height:"0.12",transform:"translate(937.41 -224.28) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"574.47",y:"356.5",width:"12.18",height:"0.12",transform:"translate(937.12 -223.99) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"574.18",y:"356.5",width:"12.18",height:"0.12",transform:"translate(936.83 -223.7) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"573.89",y:"356.5",width:"12.18",height:"0.12",transform:"translate(936.54 -223.42) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"573.6",y:"356.5",width:"12.18",height:"0.12",transform:"translate(936.26 -223.13) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"573.31",y:"356.5",width:"12.18",height:"0.12",transform:"translate(935.97 -222.84) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"573.03",y:"356.5",width:"12.18",height:"0.12",transform:"translate(935.68 -222.55) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"572.74",y:"356.5",width:"12.18",height:"0.12",transform:"translate(935.39 -222.26) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"572.45",y:"356.5",width:"12.18",height:"0.12",transform:"translate(935.1 -221.97) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"572.16",y:"356.5",width:"12.18",height:"0.12",transform:"translate(934.81 -221.69) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"571.87",y:"356.5",width:"12.18",height:"0.12",transform:"translate(934.52 -221.4) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"571.58",y:"356.5",width:"12.18",height:"0.12",transform:"translate(934.24 -221.11) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"571.3",y:"356.5",width:"12.18",height:"0.12",transform:"translate(933.95 -220.82) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"571.01",y:"356.5",width:"12.18",height:"0.12",transform:"translate(933.66 -220.53) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"570.72",y:"356.5",width:"12.18",height:"0.12",transform:"translate(933.37 -220.24) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"570.43",y:"356.5",width:"12.18",height:"0.12",transform:"translate(933.08 -219.95) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"570.14",y:"356.5",width:"12.18",height:"0.12",transform:"translate(932.79 -219.67) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"569.85",y:"356.5",width:"12.18",height:"0.12",transform:"translate(932.5 -219.38) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"569.56",y:"356.5",width:"12.18",height:"0.12",transform:"translate(932.22 -219.09) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"569.28",y:"356.5",width:"12.18",height:"0.12",transform:"translate(931.93 -218.8) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"568.99",y:"356.5",width:"12.18",height:"0.12",transform:"translate(931.64 -218.51) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"568.7",y:"356.5",width:"12.18",height:"0.12",transform:"translate(931.35 -218.22) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"568.41",y:"356.5",width:"12.18",height:"0.12",transform:"translate(931.06 -217.93) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"568.12",y:"356.5",width:"12.18",height:"0.12",transform:"translate(930.77 -217.65) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"567.83",y:"356.5",width:"12.18",height:"0.12",transform:"translate(930.49 -217.36) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"567.54",y:"356.5",width:"12.18",height:"0.12",transform:"translate(930.2 -217.07) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"567.26",y:"356.5",width:"12.18",height:"0.12",transform:"translate(929.91 -216.78) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"566.97",y:"356.5",width:"12.18",height:"0.12",transform:"translate(929.62 -216.49) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"566.68",y:"356.5",width:"12.18",height:"0.12",transform:"translate(929.33 -216.2) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"566.39",y:"356.5",width:"12.18",height:"0.12",transform:"translate(929.04 -215.92) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"566.1",y:"356.5",width:"12.18",height:"0.12",transform:"translate(928.75 -215.63) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"565.81",y:"356.5",width:"12.18",height:"0.12",transform:"translate(928.47 -215.34) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"565.53",y:"356.5",width:"12.18",height:"0.12",transform:"translate(928.18 -215.05) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"565.24",y:"356.5",width:"12.18",height:"0.12",transform:"translate(927.89 -214.76) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"564.95",y:"356.5",width:"12.18",height:"0.12",transform:"translate(927.6 -214.47) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"564.66",y:"356.5",width:"12.18",height:"0.12",transform:"translate(927.31 -214.18) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"564.37",y:"356.5",width:"12.18",height:"0.12",transform:"translate(927.02 -213.9) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"564.08",y:"356.5",width:"12.18",height:"0.12",transform:"translate(926.73 -213.61) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"563.79",y:"356.5",width:"12.18",height:"0.12",transform:"translate(926.45 -213.32) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"563.51",y:"356.5",width:"12.18",height:"0.12",transform:"translate(926.16 -213.03) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"563.22",y:"356.5",width:"12.18",height:"0.12",transform:"translate(925.87 -212.74) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"562.93",y:"356.5",width:"12.18",height:"0.12",transform:"translate(925.58 -212.45) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"562.64",y:"356.5",width:"12.18",height:"0.12",transform:"translate(925.29 -212.16) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"562.35",y:"356.5",width:"12.18",height:"0.12",transform:"translate(925 -211.88) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"562.06",y:"356.5",width:"12.18",height:"0.12",transform:"translate(924.72 -211.59) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"605.27 342.74 604.17 342.74 604.17 334.47 629.75 334.47 629.75 341.33 629.75 342.74 629.75 349.6 605.27 349.6 605.27 342.74",fill:"#aee2fa",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"600.04",y:"337.13",width:"7.12",height:"4.1",transform:"translate(942.77 -264.42) rotate(90)",fill:"#e0e0de",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"601.55",y:"343.74",width:"3.21",height:"3.22",transform:"translate(948.5 -257.8) rotate(90)",fill:"#e0e0de",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"611.67",y:"337.29",width:"8.79",height:"21.61",transform:"translate(964.16 -267.97) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"605.53",y:"352.15",width:"21.06",height:"21.61",transform:"translate(979.01 -253.12) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"599.01",y:"352.58",width:"21.55",height:"21.61",transform:"translate(973.17 -246.4) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"604.43",y:"365.75",width:"21.55",height:"21.61",transform:"translate(991.76 -238.66) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"611.47",y:"369.32",width:"13.46",height:"21.61",transform:"translate(998.32 -238.08) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"599.24",y:"375.13",width:"22.6",height:"19.83",transform:"translate(995.59 -225.49) rotate(90)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M601.19,398.9h12.67a3.09,3.09,0,0,0,2.19,2.74h-17v0A3.06,3.06,0,0,0,601.19,398.9Z",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"601.16",y:"394.47",width:"12.72",height:"5.41",transform:"translate(1215.04 794.35) rotate(-180)",fill:"#838484",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"620.48 396.27 600.56 396.27 600.56 374.15 602.27 374.15 602.27 354.15 605.22 354.15 605.26 349.62 626.85 349.62 626.85 363.25 629.03 363.25 629.03 373.47 633.56 373.47 633.56 388.09 620.48 388.09 620.48 396.27",fill:"#a7a9ac",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"605.18 349.58 626.8 349.58 626.8 363.25 628.94 363.25 628.94 373.43 633.56 373.43 633.56 388.04 607.74 388.04 607.74 384.28 605.18 384.28 605.18 349.58",fill:"#c5c6c8",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M605.17,376h24V363.22H627V350.4H605.2l-.06,11h-.78v7.09h.81Zm12.65-1.5V367h10.9v7.48Z",fill:"#e6e7e7",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"609.88",y:"345.66",width:"12.31",height:"21.78",transform:"translate(972.59 -259.49) rotate(90)",fill:"#6e6f71",stroke:"#808184","stroke-miterlimit":"10","stroke-width":"0.13"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"599.39",y:"356.5",width:"12.18",height:"0.12",transform:"translate(962.04 -248.91) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"599.68",y:"356.5",width:"12.18",height:"0.12",transform:"translate(962.33 -249.2) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"599.97",y:"356.5",width:"12.18",height:"0.12",transform:"translate(962.62 -249.49) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"600.25",y:"356.5",width:"12.18",height:"0.12",transform:"translate(962.91 -249.78) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"600.54",y:"356.5",width:"12.18",height:"0.12",transform:"translate(963.19 -250.07) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"600.83",y:"356.5",width:"12.18",height:"0.12",transform:"translate(963.48 -250.36) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"601.12",y:"356.5",width:"12.18",height:"0.12",transform:"translate(963.77 -250.64) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"601.41",y:"356.5",width:"12.18",height:"0.12",transform:"translate(964.06 -250.93) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"601.7",y:"356.5",width:"12.18",height:"0.12",transform:"translate(964.35 -251.22) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"601.98",y:"356.5",width:"12.18",height:"0.12",transform:"translate(964.64 -251.51) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"602.27",y:"356.5",width:"12.18",height:"0.12",transform:"translate(964.93 -251.8) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"602.56",y:"356.5",width:"12.18",height:"0.12",transform:"translate(965.21 -252.09) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"602.85",y:"356.5",width:"12.18",height:"0.12",transform:"translate(965.5 -252.37) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"603.14",y:"356.5",width:"12.18",height:"0.12",transform:"translate(965.79 -252.66) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"603.43",y:"356.5",width:"12.18",height:"0.12",transform:"translate(966.08 -252.95) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"603.72",y:"356.5",width:"12.18",height:"0.12",transform:"translate(966.37 -253.24) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"604",y:"356.5",width:"12.18",height:"0.12",transform:"translate(966.66 -253.53) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"604.29",y:"356.5",width:"12.18",height:"0.12",transform:"translate(966.94 -253.82) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"604.58",y:"356.5",width:"12.18",height:"0.12",transform:"translate(967.23 -254.11) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"604.87",y:"356.5",width:"12.18",height:"0.12",transform:"translate(967.52 -254.39) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"605.16",y:"356.5",width:"12.18",height:"0.12",transform:"translate(967.81 -254.68) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"605.45",y:"356.5",width:"12.18",height:"0.12",transform:"translate(968.1 -254.97) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"605.74",y:"356.5",width:"12.18",height:"0.12",transform:"translate(968.39 -255.26) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"606.02",y:"356.5",width:"12.18",height:"0.12",transform:"translate(968.68 -255.55) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"606.31",y:"356.5",width:"12.18",height:"0.12",transform:"translate(968.96 -255.84) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"606.6",y:"356.5",width:"12.18",height:"0.12",transform:"translate(969.25 -256.13) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"606.89",y:"356.5",width:"12.18",height:"0.12",transform:"translate(969.54 -256.41) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"607.18",y:"356.5",width:"12.18",height:"0.12",transform:"translate(969.83 -256.7) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"607.47",y:"356.5",width:"12.18",height:"0.12",transform:"translate(970.12 -256.99) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"607.75",y:"356.5",width:"12.18",height:"0.12",transform:"translate(970.41 -257.28) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"608.04",y:"356.5",width:"12.18",height:"0.12",transform:"translate(970.7 -257.57) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"608.33",y:"356.5",width:"12.18",height:"0.12",transform:"translate(970.98 -257.86) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"608.62",y:"356.5",width:"12.18",height:"0.12",transform:"translate(971.27 -258.14) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"608.91",y:"356.5",width:"12.18",height:"0.12",transform:"translate(971.56 -258.43) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"609.2",y:"356.5",width:"12.18",height:"0.12",transform:"translate(971.85 -258.72) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"609.49",y:"356.5",width:"12.18",height:"0.12",transform:"translate(972.14 -259.01) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"609.77",y:"356.5",width:"12.18",height:"0.12",transform:"translate(972.43 -259.3) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"610.06",y:"356.5",width:"12.18",height:"0.12",transform:"translate(972.72 -259.59) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"610.35",y:"356.5",width:"12.18",height:"0.12",transform:"translate(973 -259.88) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"610.64",y:"356.5",width:"12.18",height:"0.12",transform:"translate(973.29 -260.16) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"610.93",y:"356.5",width:"12.18",height:"0.12",transform:"translate(973.58 -260.45) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"611.22",y:"356.5",width:"12.18",height:"0.12",transform:"translate(973.87 -260.74) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"611.51",y:"356.5",width:"12.18",height:"0.12",transform:"translate(974.16 -261.03) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"611.79",y:"356.5",width:"12.18",height:"0.12",transform:"translate(974.45 -261.32) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"612.08",y:"356.5",width:"12.18",height:"0.12",transform:"translate(974.73 -261.61) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"612.37",y:"356.5",width:"12.18",height:"0.12",transform:"translate(975.02 -261.9) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"612.66",y:"356.5",width:"12.18",height:"0.12",transform:"translate(975.31 -262.18) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"612.95",y:"356.5",width:"12.18",height:"0.12",transform:"translate(975.6 -262.47) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"613.24",y:"356.5",width:"12.18",height:"0.12",transform:"translate(975.89 -262.76) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"613.53",y:"356.5",width:"12.18",height:"0.12",transform:"translate(976.18 -263.05) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"613.81",y:"356.5",width:"12.18",height:"0.12",transform:"translate(976.47 -263.34) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"614.1",y:"356.5",width:"12.18",height:"0.12",transform:"translate(976.75 -263.63) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"614.39",y:"356.5",width:"12.18",height:"0.12",transform:"translate(977.04 -263.91) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"614.68",y:"356.5",width:"12.18",height:"0.12",transform:"translate(977.33 -264.2) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"614.97",y:"356.5",width:"12.18",height:"0.12",transform:"translate(977.62 -264.49) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"615.26",y:"356.5",width:"12.18",height:"0.12",transform:"translate(977.91 -264.78) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"615.54",y:"356.5",width:"12.18",height:"0.12",transform:"translate(978.2 -265.07) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"615.83",y:"356.5",width:"12.18",height:"0.12",transform:"translate(978.49 -265.36) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"616.12",y:"356.5",width:"12.18",height:"0.12",transform:"translate(978.77 -265.65) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"616.41",y:"356.5",width:"12.18",height:"0.12",transform:"translate(979.06 -265.93) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"616.7",y:"356.5",width:"12.18",height:"0.12",transform:"translate(979.35 -266.22) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"616.99",y:"356.5",width:"12.18",height:"0.12",transform:"translate(979.64 -266.51) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"617.28",y:"356.5",width:"12.18",height:"0.12",transform:"translate(979.93 -266.8) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"617.56",y:"356.5",width:"12.18",height:"0.12",transform:"translate(980.22 -267.09) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"617.85",y:"356.5",width:"12.18",height:"0.12",transform:"translate(980.5 -267.38) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"618.14",y:"356.5",width:"12.18",height:"0.12",transform:"translate(980.79 -267.67) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"618.43",y:"356.5",width:"12.18",height:"0.12",transform:"translate(981.08 -267.95) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"618.72",y:"356.5",width:"12.18",height:"0.12",transform:"translate(981.37 -268.24) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"619.01",y:"356.5",width:"12.18",height:"0.12",transform:"translate(981.66 -268.53) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"619.3",y:"356.5",width:"12.18",height:"0.12",transform:"translate(981.95 -268.82) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"619.58",y:"356.5",width:"12.18",height:"0.12",transform:"translate(982.24 -269.11) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"619.87",y:"356.5",width:"12.18",height:"0.12",transform:"translate(982.52 -269.4) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"620.16",y:"356.5",width:"12.18",height:"0.12",transform:"translate(982.81 -269.69) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"620.45",y:"356.5",width:"12.18",height:"0.12",transform:"translate(983.1 -269.97) rotate(90)",fill:"#808184"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(381.55 287.05)","font-size":"8",fill:"#231f20","font-family":"Helvetica"},"LP2",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"0",y:"9.6"},"V14")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(418.88 287.05)","font-size":"8",fill:"#231f20","font-family":"Helvetica"},"LP2",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"0",y:"9.6"},"V16")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(459.55 287.05)","font-size":"8",fill:"#231f20","font-family":"Helvetica"},"LP2",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"0",y:"9.6"},"V18")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(496.05 287.05)","font-size":"8",fill:"#231f20","font-family":"Helvetica"},"LP2",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"0",y:"9.6"},"V20")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(536.05 287.05)","font-size":"8",fill:"#231f20","font-family":"Helvetica"},"LP2",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"0",y:"9.6"},"V22")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(571.55 287.05)","font-size":"8",fill:"#231f20","font-family":"Helvetica"},"LP2",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"0",y:"9.6"},"V24")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(612.05 287.05)","font-size":"8",fill:"#231f20","font-family":"Helvetica"},"LP2",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"0",y:"9.6"},"V26")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(418.88 373.05)","font-size":"8",fill:"#231f20","font-family":"Helvetica"},"LP2",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"0",y:"9.6"},"V15")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(459.55 373.05)","font-size":"8",fill:"#231f20","font-family":"Helvetica"},"LP2",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"0",y:"9.6"},"V17")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(495.05 373.05)","font-size":"8",fill:"#231f20","font-family":"Helvetica"},"LP2",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"0",y:"9.6"},"V19")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(536.05 373.05)","font-size":"8",fill:"#231f20","font-family":"Helvetica"},"LP2",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"0",y:"9.6"},"V21")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(571.55 373.05)","font-size":"8",fill:"#231f20","font-family":"Helvetica"},"LP2",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"0",y:"9.6"},"V23")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(612.05 373.05)","font-size":"8",fill:"#231f20","font-family":"Helvetica"},"LP2",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"0",y:"9.6"},"V25"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g",{id:"Townhomes","data-name":"Townhomes"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"344.71",y:"128",width:"103",height:"116.16",fill:"#b3d337",stroke:"#7d7f81","stroke-miterlimit":"10","stroke-width":"0.23","stroke-dasharray":"12"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"447.71",y:"186.08",width:"51.5",height:"58.08",fill:"#b3d337",stroke:"#7d7f81","stroke-miterlimit":"10","stroke-width":"0.23","stroke-dasharray":"12"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line",{x1:"345.1",y1:"187.36",x2:"551.5",y2:"187.36",fill:"none",stroke:"#fff","stroke-miterlimit":"10","stroke-width":"0.68"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line",{x1:"370.94",y1:"243.94",x2:"370.94",y2:"130.55",fill:"none",stroke:"#fff","stroke-miterlimit":"10","stroke-width":"0.68"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line",{x1:"396.77",y1:"243.94",x2:"396.77",y2:"130.55",fill:"none",stroke:"#fff","stroke-miterlimit":"10","stroke-width":"0.68"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line",{x1:"422.61",y1:"243.94",x2:"422.61",y2:"130.55",fill:"none",stroke:"#fff","stroke-miterlimit":"10","stroke-width":"0.68"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line",{x1:"448.44",y1:"243.94",x2:"448.44",y2:"130.55",fill:"none",stroke:"#fff","stroke-miterlimit":"10","stroke-width":"0.68"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line",{x1:"474.27",y1:"243.94",x2:"474.27",y2:"130.55",fill:"none",stroke:"#fff","stroke-miterlimit":"10","stroke-width":"0.68"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line",{x1:"500.27",y1:"243.94",x2:"500.27",y2:"130.55",fill:"none",stroke:"#fff","stroke-miterlimit":"10","stroke-width":"0.68"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("line",{x1:"551.27",y1:"243.94",x2:"551.27",y2:"187.38",fill:"none",stroke:"#fff","stroke-miterlimit":"10","stroke-width":"0.68"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"376.65",y:"194.95",width:"8.83",height:"19.74",transform:"translate(585.89 -176.25) rotate(90)",fill:"#838383",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"368.83",y:"225.56",width:"22.16",height:"14.68",transform:"translate(612.8 -147.01) rotate(90)",fill:"#838383",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"387.27 236.91 391.18 236.91 391.18 226.05 387.27 226.05 387.27 206.07 373.6 206.07 373.6 208.06 371.2 208.06 371.2 233.86 372.58 233.86 372.58 242.53 387.27 242.53 387.27 236.91",fill:"#a6a7aa",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M387.28,226.08s0-18,0-18h-8.15v-2h-5.49v2h-2.45v25.73h1.41V237h18.65v-10.9Z",fill:"#c3c5c7",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"368.25",y:"211.94",width:"21.95",height:"16.05",transform:"translate(599.19 -159.25) rotate(90)",fill:"#d1d3d4",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"379.17",y:"188.64",width:"8.91",height:"14.63",transform:"translate(579.58 -187.67) rotate(90)",fill:"#aee2fa",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M387.32,227.68l0-21.86H373.65v2.08h-2.46V227h2.46v.66Zm-9.64-6.19h8.95v3.87h-8.95Z",fill:"#e5e6e6",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"371.16",y:"194.37",width:"8.1",height:"3.14",transform:"translate(571.14 -179.26) rotate(90)",fill:"#dfdfdd",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"391.35",y:"204.27",width:"3.86",height:"3.86",transform:"translate(599.48 -187.08) rotate(90)",fill:"#dfdfdd",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.08"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"376.29",y:"208.59",width:"13.88",height:"8.18",transform:"translate(595.91 -170.55) rotate(90)",fill:"#6e7071",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.05"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"380.11",y:"212.6",width:"13.81",height:"0.15",transform:"translate(599.69 -174.34) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"379.78",y:"212.6",width:"13.81",height:"0.15",transform:"translate(599.37 -174.01) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"379.46",y:"212.6",width:"13.81",height:"0.15",transform:"translate(599.04 -173.69) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"379.13",y:"212.6",width:"13.81",height:"0.15",transform:"translate(598.71 -173.36) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"378.81",y:"212.6",width:"13.81",height:"0.15",transform:"translate(598.39 -173.03) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"378.48",y:"212.6",width:"13.81",height:"0.15",transform:"translate(598.06 -172.71) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"378.15",y:"212.6",width:"13.81",height:"0.15",transform:"translate(597.74 -172.38) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"377.83",y:"212.6",width:"13.81",height:"0.15",transform:"translate(597.41 -172.06) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"377.5",y:"212.6",width:"13.81",height:"0.15",transform:"translate(597.09 -171.73) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"377.18",y:"212.6",width:"13.81",height:"0.15",transform:"translate(596.76 -171.41) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"376.85",y:"212.6",width:"13.81",height:"0.15",transform:"translate(596.44 -171.08) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"376.53",y:"212.6",width:"13.81",height:"0.15",transform:"translate(596.11 -170.76) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"376.2",y:"212.6",width:"13.81",height:"0.15",transform:"translate(595.78 -170.43) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"375.88",y:"212.6",width:"13.81",height:"0.15",transform:"translate(595.46 -170.1) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"375.55",y:"212.6",width:"13.81",height:"0.15",transform:"translate(595.13 -169.78) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"375.22",y:"212.6",width:"13.81",height:"0.15",transform:"translate(594.81 -169.45) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"374.9",y:"212.6",width:"13.81",height:"0.15",transform:"translate(594.48 -169.13) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"374.57",y:"212.6",width:"13.81",height:"0.15",transform:"translate(594.16 -168.8) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"374.25",y:"212.6",width:"13.81",height:"0.15",transform:"translate(593.83 -168.48) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"373.92",y:"212.6",width:"13.81",height:"0.15",transform:"translate(593.5 -168.15) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"373.6",y:"212.6",width:"13.81",height:"0.15",transform:"translate(593.18 -167.83) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"373.27",y:"212.6",width:"13.81",height:"0.15",transform:"translate(592.85 -167.5) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"372.95",y:"212.6",width:"13.81",height:"0.15",transform:"translate(592.53 -167.17) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"372.62",y:"212.6",width:"13.81",height:"0.15",transform:"translate(592.2 -166.85) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M389,246.65a3.56,3.56,0,0,1-1.81-3.27H372.62c-.09,1.48,0,2.72-1.07,3.27Z",fill:"#838383"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"356.13",y:"194.95",width:"8.83",height:"19.74",transform:"translate(565.37 -155.72) rotate(90)",fill:"#838383",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"350.63",y:"225.56",width:"22.16",height:"14.68",transform:"translate(594.61 -128.81) rotate(90)",fill:"#838383",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"354.35 236.91 350.44 236.91 350.44 226.05 354.35 226.05 354.35 206.07 368.02 206.07 368.02 208.06 370.41 208.06 370.41 233.86 369.04 233.86 369.04 242.53 354.35 242.53 354.35 236.91",fill:"#a6a7aa",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M354.33,226.08s0-18,0-18h8.15v-2H368v2h2.45v25.73H369V237H350.37v-10.9Z",fill:"#c3c5c7",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"351.42",y:"211.94",width:"21.95",height:"16.05",transform:"translate(582.36 -142.43) rotate(90)",fill:"#d1d3d4",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"353.54",y:"188.64",width:"8.91",height:"14.63",transform:"translate(553.95 -162.04) rotate(90)",fill:"#aee2fa",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M368,227.68V227h2.46V207.9H368v-2.08H354.34l0,21.86Zm-4-2.32H355v-3.87h8.95Z",fill:"#e5e6e6",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"362.37",y:"194.37",width:"8.1",height:"3.14",transform:"translate(562.35 -170.48) rotate(90)",fill:"#dfdfdd",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"346.41",y:"204.27",width:"3.86",height:"3.86",transform:"translate(554.54 -142.14) rotate(90)",fill:"#dfdfdd",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.08"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"351.45",y:"208.59",width:"13.88",height:"8.18",transform:"translate(571.07 -145.71) rotate(90)",fill:"#6e7071",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.05"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"347.7",y:"212.6",width:"13.81",height:"0.15",transform:"translate(567.28 -141.93) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"348.02",y:"212.6",width:"13.81",height:"0.15",transform:"translate(567.61 -142.25) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"348.35",y:"212.6",width:"13.81",height:"0.15",transform:"translate(567.93 -142.58) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"348.68",y:"212.6",width:"13.81",height:"0.15",transform:"translate(568.26 -142.9) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"349",y:"212.6",width:"13.81",height:"0.15",transform:"translate(568.58 -143.23) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"349.33",y:"212.6",width:"13.81",height:"0.15",transform:"translate(568.91 -143.56) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"349.65",y:"212.6",width:"13.81",height:"0.15",transform:"translate(569.23 -143.88) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"349.98",y:"212.6",width:"13.81",height:"0.15",transform:"translate(569.56 -144.21) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"350.3",y:"212.6",width:"13.81",height:"0.15",transform:"translate(569.89 -144.53) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"350.63",y:"212.6",width:"13.81",height:"0.15",transform:"translate(570.21 -144.86) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"350.95",y:"212.6",width:"13.81",height:"0.15",transform:"translate(570.54 -145.18) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"351.28",y:"212.6",width:"13.81",height:"0.15",transform:"translate(570.86 -145.51) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"351.61",y:"212.6",width:"13.81",height:"0.15",transform:"translate(571.19 -145.83) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"351.93",y:"212.6",width:"13.81",height:"0.15",transform:"translate(571.51 -146.16) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"352.26",y:"212.6",width:"13.81",height:"0.15",transform:"translate(571.84 -146.49) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"352.58",y:"212.6",width:"13.81",height:"0.15",transform:"translate(572.16 -146.81) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"352.91",y:"212.6",width:"13.81",height:"0.15",transform:"translate(572.49 -147.14) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"353.23",y:"212.6",width:"13.81",height:"0.15",transform:"translate(572.82 -147.46) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"353.56",y:"212.6",width:"13.81",height:"0.15",transform:"translate(573.14 -147.79) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"353.88",y:"212.6",width:"13.81",height:"0.15",transform:"translate(573.47 -148.11) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"354.21",y:"212.6",width:"13.81",height:"0.15",transform:"translate(573.79 -148.44) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"354.54",y:"212.6",width:"13.81",height:"0.15",transform:"translate(574.12 -148.76) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"354.86",y:"212.6",width:"13.81",height:"0.15",transform:"translate(574.44 -149.09) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"355.19",y:"212.6",width:"13.81",height:"0.15",transform:"translate(574.77 -149.42) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M352.62,246.65a3.56,3.56,0,0,0,1.81-3.27H369c.09,1.48,0,2.72,1.06,3.27Z",fill:"#838383"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"428.37",y:"194.95",width:"8.83",height:"19.74",transform:"translate(637.61 -227.96) rotate(90)",fill:"#838383",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"420.54",y:"225.56",width:"22.16",height:"14.68",transform:"translate(664.51 -198.72) rotate(90)",fill:"#838383",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"438.99 236.91 442.89 236.91 442.89 226.05 438.99 226.05 438.99 206.07 425.31 206.07 425.31 208.06 422.92 208.06 422.92 233.86 424.29 233.86 424.29 242.53 438.99 242.53 438.99 236.91",fill:"#a6a7aa",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M439,226.08s0-18,0-18h-8.15v-2h-5.5v2H422.9v25.73h1.41V237H443v-10.9Z",fill:"#c3c5c7",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"419.96",y:"211.94",width:"21.95",height:"16.05",transform:"translate(650.9 -210.97) rotate(90)",fill:"#d1d3d4",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"430.88",y:"188.64",width:"8.91",height:"14.63",transform:"translate(631.29 -239.38) rotate(90)",fill:"#aee2fa",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M439,227.68l0-21.86H425.36v2.08H422.9V227h2.46v.66Zm-9.64-6.19h8.95v3.87h-8.95Z",fill:"#e5e6e6",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"422.87",y:"194.37",width:"8.1",height:"3.14",transform:"translate(622.85 -230.98) rotate(90)",fill:"#dfdfdd",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"443.06",y:"204.27",width:"3.86",height:"3.86",transform:"translate(651.19 -238.79) rotate(90)",fill:"#dfdfdd",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.08"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"428",y:"208.59",width:"13.88",height:"8.18",transform:"translate(647.62 -222.26) rotate(90)",fill:"#6e7071",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.05"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"431.82",y:"212.6",width:"13.81",height:"0.15",transform:"translate(651.4 -226.05) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"431.49",y:"212.6",width:"13.81",height:"0.15",transform:"translate(651.08 -225.72) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"431.17",y:"212.6",width:"13.81",height:"0.15",transform:"translate(650.75 -225.4) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"430.84",y:"212.6",width:"13.81",height:"0.15",transform:"translate(650.43 -225.07) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"430.52",y:"212.6",width:"13.81",height:"0.15",transform:"translate(650.1 -224.75) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"430.19",y:"212.6",width:"13.81",height:"0.15",transform:"translate(649.77 -224.42) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"429.87",y:"212.6",width:"13.81",height:"0.15",transform:"translate(649.45 -224.1) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"429.54",y:"212.6",width:"13.81",height:"0.15",transform:"translate(649.12 -223.77) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"429.22",y:"212.6",width:"13.81",height:"0.15",transform:"translate(648.8 -223.44) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"428.89",y:"212.6",width:"13.81",height:"0.15",transform:"translate(648.47 -223.12) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"428.56",y:"212.6",width:"13.81",height:"0.15",transform:"translate(648.15 -222.79) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"428.24",y:"212.6",width:"13.81",height:"0.15",transform:"translate(647.82 -222.47) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"427.91",y:"212.6",width:"13.81",height:"0.15",transform:"translate(647.5 -222.14) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"427.59",y:"212.6",width:"13.81",height:"0.15",transform:"translate(647.17 -221.82) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"427.26",y:"212.6",width:"13.81",height:"0.15",transform:"translate(646.84 -221.49) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"426.94",y:"212.6",width:"13.81",height:"0.15",transform:"translate(646.52 -221.17) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"426.61",y:"212.6",width:"13.81",height:"0.15",transform:"translate(646.19 -220.84) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"426.29",y:"212.6",width:"13.81",height:"0.15",transform:"translate(645.87 -220.51) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"425.96",y:"212.6",width:"13.81",height:"0.15",transform:"translate(645.54 -220.19) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"425.63",y:"212.6",width:"13.81",height:"0.15",transform:"translate(645.22 -219.86) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"425.31",y:"212.6",width:"13.81",height:"0.15",transform:"translate(644.89 -219.54) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"424.98",y:"212.6",width:"13.81",height:"0.15",transform:"translate(644.57 -219.21) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"424.66",y:"212.6",width:"13.81",height:"0.15",transform:"translate(644.24 -218.89) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"424.33",y:"212.6",width:"13.81",height:"0.15",transform:"translate(643.91 -218.56) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M440.71,246.65a3.56,3.56,0,0,1-1.81-3.27H424.33c-.09,1.48,0,2.72-1.06,3.27Z",fill:"#838383"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"407.84",y:"194.95",width:"8.83",height:"19.74",transform:"translate(617.08 -207.43) rotate(90)",fill:"#838383",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"402.34",y:"225.56",width:"22.16",height:"14.68",transform:"translate(646.32 -180.53) rotate(90)",fill:"#838383",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"406.06 236.91 402.15 236.91 402.15 226.05 406.06 226.05 406.06 206.07 419.73 206.07 419.73 208.06 422.13 208.06 422.13 233.86 420.75 233.86 420.75 242.53 406.06 242.53 406.06 236.91",fill:"#a6a7aa",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M406.05,226.08s0-18,0-18h8.15v-2h5.49v2h2.45v25.73h-1.41V237H402.08v-10.9Z",fill:"#c3c5c7",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"403.13",y:"211.94",width:"21.95",height:"16.05",transform:"translate(634.08 -194.14) rotate(90)",fill:"#d1d3d4",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"405.25",y:"188.64",width:"8.91",height:"14.63",transform:"translate(605.66 -213.75) rotate(90)",fill:"#aee2fa",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M419.68,227.68V227h2.46V207.9h-2.46v-2.08H406.05l0,21.86Zm-4-2.32H406.7v-3.87h8.95Z",fill:"#e5e6e6",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"414.08",y:"194.37",width:"8.1",height:"3.14",transform:"translate(614.06 -222.19) rotate(90)",fill:"#dfdfdd",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"398.12",y:"204.27",width:"3.86",height:"3.86",transform:"translate(606.25 -193.85) rotate(90)",fill:"#dfdfdd",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.08"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"403.16",y:"208.59",width:"13.88",height:"8.18",transform:"translate(622.78 -197.42) rotate(90)",fill:"#6e7071",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.05"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"399.41",y:"212.6",width:"13.81",height:"0.15",transform:"translate(618.99 -193.64) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"399.74",y:"212.6",width:"13.81",height:"0.15",transform:"translate(619.32 -193.96) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"400.06",y:"212.6",width:"13.81",height:"0.15",transform:"translate(619.64 -194.29) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"400.39",y:"212.6",width:"13.81",height:"0.15",transform:"translate(619.97 -194.62) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"400.71",y:"212.6",width:"13.81",height:"0.15",transform:"translate(620.3 -194.94) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"401.04",y:"212.6",width:"13.81",height:"0.15",transform:"translate(620.62 -195.27) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"401.36",y:"212.6",width:"13.81",height:"0.15",transform:"translate(620.95 -195.59) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"401.69",y:"212.6",width:"13.81",height:"0.15",transform:"translate(621.27 -195.92) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"402.01",y:"212.6",width:"13.81",height:"0.15",transform:"translate(621.6 -196.24) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"402.34",y:"212.6",width:"13.81",height:"0.15",transform:"translate(621.92 -196.57) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"402.67",y:"212.6",width:"13.81",height:"0.15",transform:"translate(622.25 -196.89) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"402.99",y:"212.6",width:"13.81",height:"0.15",transform:"translate(622.57 -197.22) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"403.32",y:"212.6",width:"13.81",height:"0.15",transform:"translate(622.9 -197.55) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"403.64",y:"212.6",width:"13.81",height:"0.15",transform:"translate(623.23 -197.87) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"403.97",y:"212.6",width:"13.81",height:"0.15",transform:"translate(623.55 -198.2) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"404.29",y:"212.6",width:"13.81",height:"0.15",transform:"translate(623.88 -198.52) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"404.62",y:"212.6",width:"13.81",height:"0.15",transform:"translate(624.2 -198.85) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"404.94",y:"212.6",width:"13.81",height:"0.15",transform:"translate(624.53 -199.17) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"405.27",y:"212.6",width:"13.81",height:"0.15",transform:"translate(624.85 -199.5) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"405.6",y:"212.6",width:"13.81",height:"0.15",transform:"translate(625.18 -199.82) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"405.92",y:"212.6",width:"13.81",height:"0.15",transform:"translate(625.5 -200.15) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"406.25",y:"212.6",width:"13.81",height:"0.15",transform:"translate(625.83 -200.48) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"406.57",y:"212.6",width:"13.81",height:"0.15",transform:"translate(626.16 -200.8) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"406.9",y:"212.6",width:"13.81",height:"0.15",transform:"translate(626.48 -201.13) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M404.33,246.65a3.56,3.56,0,0,0,1.81-3.27h14.57c.09,1.48,0,2.72,1.07,3.27Z",fill:"#838383"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"480.08",y:"194.95",width:"8.83",height:"19.74",transform:"translate(689.32 -279.67) rotate(90)",fill:"#838383",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"472.25",y:"225.56",width:"22.16",height:"14.68",transform:"translate(716.23 -250.43) rotate(90)",fill:"#838383",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"490.7 236.91 494.6 236.91 494.6 226.05 490.7 226.05 490.7 206.07 477.02 206.07 477.02 208.06 474.63 208.06 474.63 233.86 476 233.86 476 242.53 490.7 242.53 490.7 236.91",fill:"#a6a7aa",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M490.71,226.08s0-18,0-18h-8.15v-2h-5.5v2h-2.44v25.73H476V237h18.65v-10.9Z",fill:"#c3c5c7",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"471.67",y:"211.94",width:"21.95",height:"16.05",transform:"translate(702.61 -262.68) rotate(90)",fill:"#d1d3d4",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"482.59",y:"188.64",width:"8.91",height:"14.63",transform:"translate(683 -291.1) rotate(90)",fill:"#aee2fa",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M490.74,227.68l0-21.86H477.07v2.08h-2.45V227h2.45v.66Zm-9.64-6.19h8.95v3.87H481.1Z",fill:"#e5e6e6",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"474.58",y:"194.37",width:"8.1",height:"3.14",transform:"translate(674.56 -282.69) rotate(90)",fill:"#dfdfdd",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"494.78",y:"204.27",width:"3.86",height:"3.86",transform:"translate(702.91 -290.5) rotate(90)",fill:"#dfdfdd",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.08"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"479.72",y:"208.59",width:"13.88",height:"8.18",transform:"translate(699.33 -273.97) rotate(90)",fill:"#6e7071",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.05"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"483.53",y:"212.6",width:"13.81",height:"0.15",transform:"translate(703.11 -277.76) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"483.21",y:"212.6",width:"13.81",height:"0.15",transform:"translate(702.79 -277.43) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"482.88",y:"212.6",width:"13.81",height:"0.15",transform:"translate(702.46 -277.11) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"482.55",y:"212.6",width:"13.81",height:"0.15",transform:"translate(702.14 -276.78) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"482.23",y:"212.6",width:"13.81",height:"0.15",transform:"translate(701.81 -276.46) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"481.9",y:"212.6",width:"13.81",height:"0.15",transform:"translate(701.49 -276.13) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"481.58",y:"212.6",width:"13.81",height:"0.15",transform:"translate(701.16 -275.81) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"481.25",y:"212.6",width:"13.81",height:"0.15",transform:"translate(700.84 -275.48) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"480.93",y:"212.6",width:"13.81",height:"0.15",transform:"translate(700.51 -275.16) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"480.6",y:"212.6",width:"13.81",height:"0.15",transform:"translate(700.18 -274.83) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"480.28",y:"212.6",width:"13.81",height:"0.15",transform:"translate(699.86 -274.5) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"479.95",y:"212.6",width:"13.81",height:"0.15",transform:"translate(699.53 -274.18) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"479.62",y:"212.6",width:"13.81",height:"0.15",transform:"translate(699.21 -273.85) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"479.3",y:"212.6",width:"13.81",height:"0.15",transform:"translate(698.88 -273.53) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"478.97",y:"212.6",width:"13.81",height:"0.15",transform:"translate(698.56 -273.2) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"478.65",y:"212.6",width:"13.81",height:"0.15",transform:"translate(698.23 -272.88) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"478.32",y:"212.6",width:"13.81",height:"0.15",transform:"translate(697.91 -272.55) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"478",y:"212.6",width:"13.81",height:"0.15",transform:"translate(697.58 -272.23) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"477.67",y:"212.6",width:"13.81",height:"0.15",transform:"translate(697.25 -271.9) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"477.35",y:"212.6",width:"13.81",height:"0.15",transform:"translate(696.93 -271.57) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"477.02",y:"212.6",width:"13.81",height:"0.15",transform:"translate(696.6 -271.25) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"476.69",y:"212.6",width:"13.81",height:"0.15",transform:"translate(696.28 -270.92) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"476.37",y:"212.6",width:"13.81",height:"0.15",transform:"translate(695.95 -270.6) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"476.04",y:"212.6",width:"13.81",height:"0.15",transform:"translate(695.63 -270.27) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M492.42,246.65a3.56,3.56,0,0,1-1.81-3.27H476.05c-.1,1.48,0,2.72-1.07,3.27Z",fill:"#838383"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"459.56",y:"194.95",width:"8.83",height:"19.74",transform:"translate(668.8 -259.15) rotate(90)",fill:"#838383",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"454.05",y:"225.56",width:"22.16",height:"14.68",transform:"translate(698.03 -232.24) rotate(90)",fill:"#838383",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"457.77 236.91 453.86 236.91 453.86 226.05 457.77 226.05 457.77 206.07 471.44 206.07 471.44 208.06 473.84 208.06 473.84 233.86 472.46 233.86 472.46 242.53 457.77 242.53 457.77 236.91",fill:"#a6a7aa",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M457.76,226.08s0-18,0-18h8.15v-2h5.49v2h2.45v25.73h-1.41V237H453.79v-10.9Z",fill:"#c3c5c7",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"454.85",y:"211.94",width:"21.95",height:"16.05",transform:"translate(685.79 -245.85) rotate(90)",fill:"#d1d3d4",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"456.96",y:"188.64",width:"8.91",height:"14.63",transform:"translate(657.37 -265.46) rotate(90)",fill:"#aee2fa",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M471.39,227.68V227h2.46V207.9h-2.46v-2.08H457.76l0,21.86Zm-4-2.32h-9v-3.87h9Z",fill:"#e5e6e6",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"465.79",y:"194.37",width:"8.1",height:"3.14",transform:"translate(665.78 -273.9) rotate(90)",fill:"#dfdfdd",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"449.83",y:"204.27",width:"3.86",height:"3.86",transform:"translate(657.96 -245.56) rotate(90)",fill:"#dfdfdd",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.08"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"454.87",y:"208.59",width:"13.88",height:"8.18",transform:"translate(674.49 -249.13) rotate(90)",fill:"#6e7071",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.05"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"451.12",y:"212.6",width:"13.81",height:"0.15",transform:"translate(670.7 -245.35) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"451.45",y:"212.6",width:"13.81",height:"0.15",transform:"translate(671.03 -245.68) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"451.77",y:"212.6",width:"13.81",height:"0.15",transform:"translate(671.36 -246) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"452.1",y:"212.6",width:"13.81",height:"0.15",transform:"translate(671.68 -246.33) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"452.42",y:"212.6",width:"13.81",height:"0.15",transform:"translate(672.01 -246.65) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"452.75",y:"212.6",width:"13.81",height:"0.15",transform:"translate(672.33 -246.98) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"453.08",y:"212.6",width:"13.81",height:"0.15",transform:"translate(672.66 -247.3) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"453.4",y:"212.6",width:"13.81",height:"0.15",transform:"translate(672.98 -247.63) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"453.73",y:"212.6",width:"13.81",height:"0.15",transform:"translate(673.31 -247.96) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"454.05",y:"212.6",width:"13.81",height:"0.15",transform:"translate(673.63 -248.28) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"454.38",y:"212.6",width:"13.81",height:"0.15",transform:"translate(673.96 -248.61) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"454.7",y:"212.6",width:"13.81",height:"0.15",transform:"translate(674.29 -248.93) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"455.03",y:"212.6",width:"13.81",height:"0.15",transform:"translate(674.61 -249.26) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"455.35",y:"212.6",width:"13.81",height:"0.15",transform:"translate(674.94 -249.58) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"455.68",y:"212.6",width:"13.81",height:"0.15",transform:"translate(675.26 -249.91) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"456.01",y:"212.6",width:"13.81",height:"0.15",transform:"translate(675.59 -250.23) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"456.33",y:"212.6",width:"13.81",height:"0.15",transform:"translate(675.91 -250.56) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"456.66",y:"212.6",width:"13.81",height:"0.15",transform:"translate(676.24 -250.89) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"456.98",y:"212.6",width:"13.81",height:"0.15",transform:"translate(676.56 -251.21) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"457.31",y:"212.6",width:"13.81",height:"0.15",transform:"translate(676.89 -251.54) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"457.63",y:"212.6",width:"13.81",height:"0.15",transform:"translate(677.22 -251.86) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"457.96",y:"212.6",width:"13.81",height:"0.15",transform:"translate(677.54 -252.19) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"458.28",y:"212.6",width:"13.81",height:"0.15",transform:"translate(677.87 -252.51) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"458.61",y:"212.6",width:"13.81",height:"0.15",transform:"translate(678.19 -252.84) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M456,246.65a3.54,3.54,0,0,0,1.81-3.27h14.57c.09,1.48,0,2.72,1.07,3.27Z",fill:"#838383"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"376.65",y:"159.95",width:"8.83",height:"19.74",transform:"translate(211.25 550.89) rotate(-90)",fill:"#838383",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"368.83",y:"134.41",width:"22.16",height:"14.68",transform:"translate(238.16 521.66) rotate(-90)",fill:"#838383",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"387.27 137.73 391.18 137.73 391.18 148.6 387.27 148.6 387.27 168.58 373.6 168.58 373.6 166.59 371.2 166.59 371.2 140.78 372.58 140.78 372.58 132.12 387.27 132.12 387.27 137.73",fill:"#a6a7aa",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M387.28,148.57s0,17.94,0,18h-8.15v2h-5.49v-2.05h-2.45V140.78h1.41v-3.11h18.65v10.9Z",fill:"#c3c5c7",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"368.25",y:"146.65",width:"21.95",height:"16.05",transform:"translate(224.55 533.9) rotate(-90)",fill:"#d1d3d4",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"379.17",y:"171.38",width:"8.91",height:"14.63",transform:"translate(204.93 562.32) rotate(-90)",fill:"#aee2fa",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M373.65,147v.65h-2.46v19.13h2.46v2.07h13.63l0-21.85Zm4,2.32h8.95v3.87h-8.95Z",fill:"#e5e6e6",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"371.16",y:"177.14",width:"8.1",height:"3.14",transform:"translate(196.5 553.91) rotate(-90)",fill:"#dfdfdd",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"391.35",y:"166.51",width:"3.86",height:"3.86",transform:"translate(224.84 561.73) rotate(-90)",fill:"#dfdfdd",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.08"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"376.29",y:"157.88",width:"13.88",height:"8.18",transform:"translate(221.26 545.2) rotate(-90)",fill:"#6e7071",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.05"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"380.11",y:"161.89",width:"13.81",height:"0.15",transform:"translate(225.04 548.98) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"379.78",y:"161.89",width:"13.81",height:"0.15",transform:"translate(224.72 548.66) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"379.46",y:"161.89",width:"13.81",height:"0.15",transform:"translate(224.39 548.33) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"379.13",y:"161.89",width:"13.81",height:"0.15",transform:"translate(224.07 548.01) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"378.81",y:"161.89",width:"13.81",height:"0.15",transform:"translate(223.74 547.68) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"378.48",y:"161.89",width:"13.81",height:"0.15",transform:"translate(223.42 547.36) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"378.15",y:"161.89",width:"13.81",height:"0.15",transform:"translate(223.09 547.03) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"377.83",y:"161.89",width:"13.81",height:"0.15",transform:"translate(222.77 546.7) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"377.5",y:"161.89",width:"13.81",height:"0.15",transform:"translate(222.44 546.38) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"377.18",y:"161.89",width:"13.81",height:"0.15",transform:"translate(222.11 546.05) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"376.85",y:"161.89",width:"13.81",height:"0.15",transform:"translate(221.79 545.73) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"376.53",y:"161.89",width:"13.81",height:"0.15",transform:"translate(221.46 545.4) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"376.2",y:"161.89",width:"13.81",height:"0.15",transform:"translate(221.14 545.08) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"375.88",y:"161.89",width:"13.81",height:"0.15",transform:"translate(220.81 544.75) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"375.55",y:"161.89",width:"13.81",height:"0.15",transform:"translate(220.49 544.42) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"375.22",y:"161.89",width:"13.81",height:"0.15",transform:"translate(220.16 544.1) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"374.9",y:"161.89",width:"13.81",height:"0.15",transform:"translate(219.84 543.77) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"374.57",y:"161.89",width:"13.81",height:"0.15",transform:"translate(219.51 543.45) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"374.25",y:"161.89",width:"13.81",height:"0.15",transform:"translate(219.18 543.12) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"373.92",y:"161.89",width:"13.81",height:"0.15",transform:"translate(218.86 542.8) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"373.6",y:"161.89",width:"13.81",height:"0.15",transform:"translate(218.53 542.47) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"373.27",y:"161.89",width:"13.81",height:"0.15",transform:"translate(218.21 542.15) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"372.95",y:"161.89",width:"13.81",height:"0.15",transform:"translate(217.88 541.82) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"372.62",y:"161.89",width:"13.81",height:"0.15",transform:"translate(217.56 541.49) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M389,128a3.54,3.54,0,0,0-1.81,3.27H372.62c-.09-1.48,0-2.73-1.07-3.27Z",fill:"#838383"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"356.13",y:"159.95",width:"8.83",height:"19.74",transform:"translate(190.73 530.37) rotate(-90)",fill:"#838383",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"350.63",y:"134.41",width:"22.16",height:"14.68",transform:"translate(219.96 503.46) rotate(-90)",fill:"#838383",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"354.35 137.73 350.44 137.73 350.44 148.6 354.35 148.6 354.35 168.58 368.02 168.58 368.02 166.59 370.41 166.59 370.41 140.78 369.04 140.78 369.04 132.12 354.35 132.12 354.35 137.73",fill:"#a6a7aa",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M354.33,148.57s0,17.94,0,18h8.15v2H368v-2.05h2.45V140.78H369v-3.11H350.37v10.9Z",fill:"#c3c5c7",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"351.42",y:"146.65",width:"21.95",height:"16.05",transform:"translate(207.72 517.07) rotate(-90)",fill:"#d1d3d4",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"353.54",y:"171.38",width:"8.91",height:"14.63",transform:"translate(179.3 536.69) rotate(-90)",fill:"#aee2fa",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M354.3,147l0,21.85H368v-2.07h2.46V147.62H368V147Zm9.64,6.19H355v-3.87h8.95Z",fill:"#e5e6e6",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"362.37",y:"177.14",width:"8.1",height:"3.14",transform:"translate(187.71 545.12) rotate(-90)",fill:"#dfdfdd",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"346.41",y:"166.51",width:"3.86",height:"3.86",transform:"translate(179.89 516.78) rotate(-90)",fill:"#dfdfdd",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.08"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"351.45",y:"157.88",width:"13.88",height:"8.18",transform:"translate(196.42 520.35) rotate(-90)",fill:"#6e7071",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.05"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"347.7",y:"161.89",width:"13.81",height:"0.15",transform:"translate(192.64 516.57) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"348.02",y:"161.89",width:"13.81",height:"0.15",transform:"translate(192.96 516.9) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"348.35",y:"161.89",width:"13.81",height:"0.15",transform:"translate(193.29 517.22) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"348.68",y:"161.89",width:"13.81",height:"0.15",transform:"translate(193.61 517.55) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"349",y:"161.89",width:"13.81",height:"0.15",transform:"translate(193.94 517.88) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"349.33",y:"161.89",width:"13.81",height:"0.15",transform:"translate(194.26 518.2) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"349.65",y:"161.89",width:"13.81",height:"0.15",transform:"translate(194.59 518.53) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"349.98",y:"161.89",width:"13.81",height:"0.15",transform:"translate(194.91 518.85) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"350.3",y:"161.89",width:"13.81",height:"0.15",transform:"translate(195.24 519.18) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"350.63",y:"161.89",width:"13.81",height:"0.15",transform:"translate(195.57 519.5) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"350.95",y:"161.89",width:"13.81",height:"0.15",transform:"translate(195.89 519.83) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"351.28",y:"161.89",width:"13.81",height:"0.15",transform:"translate(196.22 520.15) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"351.61",y:"161.89",width:"13.81",height:"0.15",transform:"translate(196.54 520.48) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"351.93",y:"161.89",width:"13.81",height:"0.15",transform:"translate(196.87 520.81) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"352.26",y:"161.89",width:"13.81",height:"0.15",transform:"translate(197.19 521.13) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"352.58",y:"161.89",width:"13.81",height:"0.15",transform:"translate(197.52 521.46) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"352.91",y:"161.89",width:"13.81",height:"0.15",transform:"translate(197.84 521.78) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"353.23",y:"161.89",width:"13.81",height:"0.15",transform:"translate(198.17 522.11) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"353.56",y:"161.89",width:"13.81",height:"0.15",transform:"translate(198.5 522.43) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"353.88",y:"161.89",width:"13.81",height:"0.15",transform:"translate(198.82 522.76) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"354.21",y:"161.89",width:"13.81",height:"0.15",transform:"translate(199.15 523.08) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"354.54",y:"161.89",width:"13.81",height:"0.15",transform:"translate(199.47 523.41) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"354.86",y:"161.89",width:"13.81",height:"0.15",transform:"translate(199.8 523.74) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"355.19",y:"161.89",width:"13.81",height:"0.15",transform:"translate(200.12 524.06) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M352.62,128a3.54,3.54,0,0,1,1.81,3.27H369c.09-1.48,0-2.73,1.06-3.27Z",fill:"#838383"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"428.37",y:"159.95",width:"8.83",height:"19.74",transform:"translate(262.96 602.6) rotate(-90)",fill:"#838383",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"420.54",y:"134.41",width:"22.16",height:"14.68",transform:"translate(289.87 573.37) rotate(-90)",fill:"#838383",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"438.99 137.73 442.89 137.73 442.89 148.6 438.99 148.6 438.99 168.58 425.31 168.58 425.31 166.59 422.92 166.59 422.92 140.78 424.29 140.78 424.29 132.12 438.99 132.12 438.99 137.73",fill:"#a6a7aa",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M439,148.57s0,17.94,0,18h-8.15v2h-5.5v-2.05H422.9V140.78h1.41v-3.11H443v10.9Z",fill:"#c3c5c7",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"419.96",y:"146.65",width:"21.95",height:"16.05",transform:"translate(276.26 585.61) rotate(-90)",fill:"#d1d3d4",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"430.88",y:"171.38",width:"8.91",height:"14.63",transform:"translate(256.64 614.03) rotate(-90)",fill:"#aee2fa",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M425.36,147v.65H422.9v19.13h2.46v2.07H439L439,147Zm4,2.32h8.95v3.87h-8.95Z",fill:"#e5e6e6",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"422.87",y:"177.14",width:"8.1",height:"3.14",transform:"translate(248.21 605.62) rotate(-90)",fill:"#dfdfdd",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"443.06",y:"166.51",width:"3.86",height:"3.86",transform:"translate(276.55 613.44) rotate(-90)",fill:"#dfdfdd",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.08"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"428",y:"157.88",width:"13.88",height:"8.18",transform:"translate(272.98 596.91) rotate(-90)",fill:"#6e7071",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.05"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"431.82",y:"161.89",width:"13.81",height:"0.15",transform:"translate(276.76 600.69) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"431.49",y:"161.89",width:"13.81",height:"0.15",transform:"translate(276.43 600.37) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"431.17",y:"161.89",width:"13.81",height:"0.15",transform:"translate(276.11 600.04) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"430.84",y:"161.89",width:"13.81",height:"0.15",transform:"translate(275.78 599.72) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"430.52",y:"161.89",width:"13.81",height:"0.15",transform:"translate(275.45 599.39) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"430.19",y:"161.89",width:"13.81",height:"0.15",transform:"translate(275.13 599.07) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"429.87",y:"161.89",width:"13.81",height:"0.15",transform:"translate(274.8 598.74) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"429.54",y:"161.89",width:"13.81",height:"0.15",transform:"translate(274.48 598.42) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"429.22",y:"161.89",width:"13.81",height:"0.15",transform:"translate(274.15 598.09) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"428.89",y:"161.89",width:"13.81",height:"0.15",transform:"translate(273.83 597.76) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"428.56",y:"161.89",width:"13.81",height:"0.15",transform:"translate(273.5 597.44) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"428.24",y:"161.89",width:"13.81",height:"0.15",transform:"translate(273.18 597.11) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"427.91",y:"161.89",width:"13.81",height:"0.15",transform:"translate(272.85 596.79) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"427.59",y:"161.89",width:"13.81",height:"0.15",transform:"translate(272.52 596.46) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"427.26",y:"161.89",width:"13.81",height:"0.15",transform:"translate(272.2 596.14) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"426.94",y:"161.89",width:"13.81",height:"0.15",transform:"translate(271.87 595.81) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"426.61",y:"161.89",width:"13.81",height:"0.15",transform:"translate(271.55 595.49) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"426.29",y:"161.89",width:"13.81",height:"0.15",transform:"translate(271.22 595.16) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"425.96",y:"161.89",width:"13.81",height:"0.15",transform:"translate(270.9 594.83) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"425.63",y:"161.89",width:"13.81",height:"0.15",transform:"translate(270.57 594.51) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"425.31",y:"161.89",width:"13.81",height:"0.15",transform:"translate(270.25 594.18) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"424.98",y:"161.89",width:"13.81",height:"0.15",transform:"translate(269.92 593.86) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"424.66",y:"161.89",width:"13.81",height:"0.15",transform:"translate(269.59 593.53) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"424.33",y:"161.89",width:"13.81",height:"0.15",transform:"translate(269.27 593.21) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M440.71,128a3.54,3.54,0,0,0-1.81,3.27H424.33c-.09-1.48,0-2.73-1.06-3.27Z",fill:"#838383"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"407.84",y:"159.95",width:"8.83",height:"19.74",transform:"translate(242.44 582.08) rotate(-90)",fill:"#838383",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"402.34",y:"134.41",width:"22.16",height:"14.68",transform:"translate(271.67 555.17) rotate(-90)",fill:"#838383",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"406.06 137.73 402.15 137.73 402.15 148.6 406.06 148.6 406.06 168.58 419.73 168.58 419.73 166.59 422.13 166.59 422.13 140.78 420.75 140.78 420.75 132.12 406.06 132.12 406.06 137.73",fill:"#a6a7aa",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M406.05,148.57s0,17.94,0,18h8.15v2h5.49v-2.05h2.45V140.78h-1.41v-3.11H402.08v10.9Z",fill:"#c3c5c7",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"403.13",y:"146.65",width:"21.95",height:"16.05",transform:"translate(259.43 568.78) rotate(-90)",fill:"#d1d3d4",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"405.25",y:"171.38",width:"8.91",height:"14.63",transform:"translate(231.01 588.4) rotate(-90)",fill:"#aee2fa",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M406,147l0,21.85h13.63v-2.07h2.46V147.62h-2.46V147Zm9.64,6.19H406.7v-3.87h8.95Z",fill:"#e5e6e6",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"414.08",y:"177.14",width:"8.1",height:"3.14",transform:"translate(239.42 596.83) rotate(-90)",fill:"#dfdfdd",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"398.12",y:"166.51",width:"3.86",height:"3.86",transform:"translate(231.6 568.49) rotate(-90)",fill:"#dfdfdd",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.08"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"403.16",y:"157.88",width:"13.88",height:"8.18",transform:"translate(248.13 572.07) rotate(-90)",fill:"#6e7071",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.05"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"399.41",y:"161.89",width:"13.81",height:"0.15",transform:"translate(244.35 568.28) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"399.74",y:"161.89",width:"13.81",height:"0.15",transform:"translate(244.67 568.61) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"400.06",y:"161.89",width:"13.81",height:"0.15",transform:"translate(245 568.94) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"400.39",y:"161.89",width:"13.81",height:"0.15",transform:"translate(245.32 569.26) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"400.71",y:"161.89",width:"13.81",height:"0.15",transform:"translate(245.65 569.59) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"401.04",y:"161.89",width:"13.81",height:"0.15",transform:"translate(245.97 569.91) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"401.36",y:"161.89",width:"13.81",height:"0.15",transform:"translate(246.3 570.24) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"401.69",y:"161.89",width:"13.81",height:"0.15",transform:"translate(246.63 570.56) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"402.01",y:"161.89",width:"13.81",height:"0.15",transform:"translate(246.95 570.89) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"402.34",y:"161.89",width:"13.81",height:"0.15",transform:"translate(247.28 571.22) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"402.67",y:"161.89",width:"13.81",height:"0.15",transform:"translate(247.6 571.54) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"402.99",y:"161.89",width:"13.81",height:"0.15",transform:"translate(247.93 571.87) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"403.32",y:"161.89",width:"13.81",height:"0.15",transform:"translate(248.25 572.19) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"403.64",y:"161.89",width:"13.81",height:"0.15",transform:"translate(248.58 572.52) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"403.97",y:"161.89",width:"13.81",height:"0.15",transform:"translate(248.9 572.84) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"404.29",y:"161.89",width:"13.81",height:"0.15",transform:"translate(249.23 573.17) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"404.62",y:"161.89",width:"13.81",height:"0.15",transform:"translate(249.56 573.49) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"404.94",y:"161.89",width:"13.81",height:"0.15",transform:"translate(249.88 573.82) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"405.27",y:"161.89",width:"13.81",height:"0.15",transform:"translate(250.21 574.15) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"405.6",y:"161.89",width:"13.81",height:"0.15",transform:"translate(250.53 574.47) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"405.92",y:"161.89",width:"13.81",height:"0.15",transform:"translate(250.86 574.8) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"406.25",y:"161.89",width:"13.81",height:"0.15",transform:"translate(251.18 575.12) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"406.57",y:"161.89",width:"13.81",height:"0.15",transform:"translate(251.51 575.45) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"406.9",y:"161.89",width:"13.81",height:"0.15",transform:"translate(251.83 575.77) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M404.33,128a3.54,3.54,0,0,1,1.81,3.27h14.57c.09-1.48,0-2.73,1.07-3.27Z",fill:"#838383"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(352.13 228.72)","font-size":"8",fill:"#231f20","font-family":"Helvetica"},"LP2",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"-2.66",y:"9.6"},"TH19")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(374.13 228.72)","font-size":"8",fill:"#231f20","font-family":"Helvetica"},"LP2",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"-2.66",y:"9.6"},"TH21")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(404.38 228.72)","font-size":"8",fill:"#231f20","font-family":"Helvetica"},"LP2",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"-2.66",y:"9.6"},"TH23")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(426.38 228.72)","font-size":"8",fill:"#231f20","font-family":"Helvetica"},"LP2",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"-2.66",y:"9.6"},"TH25")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(455.63 228.72)","font-size":"8",fill:"#231f20","font-family":"Helvetica"},"LP2",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"-2.66",y:"9.6"},"TH27")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(477.63 228.72)","font-size":"8",fill:"#231f20","font-family":"Helvetica"},"LP2",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"-2.66",y:"9.6"},"TH29")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(352.63 142.97)","font-size":"8",fill:"#231f20","font-family":"Helvetica"},"LP2",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"-2.66",y:"9.6"},"TH20")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(374.63 142.97)","font-size":"8",fill:"#231f20","font-family":"Helvetica"},"LP2",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"-2.66",y:"9.6"},"TH22")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(404.13 142.97)","font-size":"8",fill:"#231f20","font-family":"Helvetica"},"LP2",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"-2.66",y:"9.6"},"TH24")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(426.13 142.97)","font-size":"8",fill:"#231f20","font-family":"Helvetica"},"LP2",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"-2.66",y:"9.6"},"TH26"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("g",{id:"Townhomes","data-name":"Townhomes"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"70.24 187.38 70.24 137.81 77.65 130.4 329.08 130.4 329.08 187.38 303.3 187.38 303.3 244.08 103.57 244.08 96.02 236.82 70.24 187.38",fill:"#b3d337",stroke:"#7d7f81","stroke-miterlimit":"10","stroke-width":"0.23"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"128.32",y:"194.95",width:"8.83",height:"19.74",transform:"translate(337.56 72.09) rotate(90)",fill:"#838383",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"120.49",y:"225.56",width:"22.16",height:"14.68",transform:"translate(364.47 101.32) rotate(90)",fill:"#838383",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"138.94 236.91 142.85 236.91 142.85 226.05 138.94 226.05 138.94 206.07 125.27 206.07 125.27 208.06 122.87 208.06 122.87 233.86 124.25 233.86 124.25 242.53 138.94 242.53 138.94 236.91",fill:"#a6a7aa",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M139,226.08s0-18,0-18H130.8v-2h-5.49v2h-2.45v25.73h1.41V237h18.65v-10.9Z",fill:"#c3c5c7",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"119.92",y:"211.94",width:"21.95",height:"16.05",transform:"translate(350.86 89.08) rotate(90)",fill:"#d1d3d4",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"130.84",y:"188.64",width:"8.91",height:"14.63",transform:"translate(331.25 60.66) rotate(90)",fill:"#aee2fa",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M139,227.68l0-21.86H125.31v2.08h-2.45V227h2.45v.66Zm-9.65-6.19h9v3.87h-9Z",fill:"#e5e6e6",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"122.82",y:"194.37",width:"8.1",height:"3.14",transform:"translate(322.81 69.07) rotate(90)",fill:"#dfdfdd",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"143.02",y:"204.27",width:"3.86",height:"3.86",transform:"translate(351.15 61.25) rotate(90)",fill:"#dfdfdd",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.08"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"127.96",y:"208.59",width:"13.88",height:"8.18",transform:"translate(347.58 77.78) rotate(90)",fill:"#6e7071",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.05"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"131.77",y:"212.6",width:"13.81",height:"0.15",transform:"translate(351.36 74) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"131.45",y:"212.6",width:"13.81",height:"0.15",transform:"translate(351.03 74.32) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"131.12",y:"212.6",width:"13.81",height:"0.15",transform:"translate(350.71 74.65) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"130.8",y:"212.6",width:"13.81",height:"0.15",transform:"translate(350.38 74.97) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"130.47",y:"212.6",width:"13.81",height:"0.15",transform:"translate(350.06 75.3) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"130.15",y:"212.6",width:"13.81",height:"0.15",transform:"translate(349.73 75.62) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"129.82",y:"212.6",width:"13.81",height:"0.15",transform:"translate(349.4 75.95) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"129.5",y:"212.6",width:"13.81",height:"0.15",transform:"translate(349.08 76.28) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"129.17",y:"212.6",width:"13.81",height:"0.15",transform:"translate(348.75 76.6) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"128.84",y:"212.6",width:"13.81",height:"0.15",transform:"translate(348.43 76.93) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"128.52",y:"212.6",width:"13.81",height:"0.15",transform:"translate(348.1 77.25) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"128.19",y:"212.6",width:"13.81",height:"0.15",transform:"translate(347.78 77.58) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"127.87",y:"212.6",width:"13.81",height:"0.15",transform:"translate(347.45 77.9) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"127.54",y:"212.6",width:"13.81",height:"0.15",transform:"translate(347.13 78.23) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"127.22",y:"212.6",width:"13.81",height:"0.15",transform:"translate(346.8 78.55) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"126.89",y:"212.6",width:"13.81",height:"0.15",transform:"translate(346.47 78.88) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"126.57",y:"212.6",width:"13.81",height:"0.15",transform:"translate(346.15 79.21) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"126.24",y:"212.6",width:"13.81",height:"0.15",transform:"translate(345.82 79.53) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"125.91",y:"212.6",width:"13.81",height:"0.15",transform:"translate(345.5 79.86) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"125.59",y:"212.6",width:"13.81",height:"0.15",transform:"translate(345.17 80.18) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"125.26",y:"212.6",width:"13.81",height:"0.15",transform:"translate(344.85 80.51) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"124.94",y:"212.6",width:"13.81",height:"0.15",transform:"translate(344.52 80.83) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"124.61",y:"212.6",width:"13.81",height:"0.15",transform:"translate(344.19 81.16) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"124.29",y:"212.6",width:"13.81",height:"0.15",transform:"translate(343.87 81.48) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M140.66,246.65a3.57,3.57,0,0,1-1.81-3.27H124.29c-.09,1.48,0,2.72-1.07,3.27Z",fill:"#838383"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"107.8",y:"194.95",width:"8.83",height:"19.74",transform:"translate(317.04 92.61) rotate(90)",fill:"#838383",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"102.3",y:"225.56",width:"22.16",height:"14.68",transform:"translate(346.27 119.52) rotate(90)",fill:"#838383",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"106.01 236.91 102.11 236.91 102.11 226.05 106.01 226.05 106.01 206.07 119.69 206.07 119.69 208.06 122.08 208.06 122.08 233.86 120.7 233.86 120.7 242.53 106.01 242.53 106.01 236.91",fill:"#a6a7aa",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M106,226.08s0-18,0-18h8.15v-2h5.49v2h2.45v25.73h-1.41V237H102v-10.9Z",fill:"#c3c5c7",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"103.09",y:"211.94",width:"21.95",height:"16.05",transform:"translate(334.03 105.91) rotate(90)",fill:"#d1d3d4",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"105.2",y:"188.64",width:"8.91",height:"14.63",transform:"translate(305.61 86.29) rotate(90)",fill:"#aee2fa",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M119.64,227.68V227h2.45V207.9h-2.45v-2.08H106L106,227.68Zm-4-2.32h-9v-3.87h9Z",fill:"#e5e6e6",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"114.03",y:"194.37",width:"8.1",height:"3.14",transform:"translate(314.02 77.86) rotate(90)",fill:"#dfdfdd",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"98.08",y:"204.27",width:"3.86",height:"3.86",transform:"translate(306.21 106.2) rotate(90)",fill:"#dfdfdd",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.08"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"103.12",y:"208.59",width:"13.88",height:"8.18",transform:"translate(322.73 102.63) rotate(90)",fill:"#6e7071",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.05"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"99.37",y:"212.6",width:"13.81",height:"0.15",transform:"translate(318.95 106.41) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"99.69",y:"212.6",width:"13.81",height:"0.15",transform:"translate(319.27 106.08) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"100.02",y:"212.6",width:"13.81",height:"0.15",transform:"translate(319.6 105.75) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"100.34",y:"212.6",width:"13.81",height:"0.15",transform:"translate(319.92 105.43) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"100.67",y:"212.6",width:"13.81",height:"0.15",transform:"translate(320.25 105.1) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"100.99",y:"212.6",width:"13.81",height:"0.15",transform:"translate(320.58 104.78) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"101.32",y:"212.6",width:"13.81",height:"0.15",transform:"translate(320.9 104.45) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"101.64",y:"212.6",width:"13.81",height:"0.15",transform:"translate(321.23 104.13) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"101.97",y:"212.6",width:"13.81",height:"0.15",transform:"translate(321.55 103.8) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"102.3",y:"212.6",width:"13.81",height:"0.15",transform:"translate(321.88 103.48) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"102.62",y:"212.6",width:"13.81",height:"0.15",transform:"translate(322.2 103.15) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"102.95",y:"212.6",width:"13.81",height:"0.15",transform:"translate(322.53 102.82) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"103.27",y:"212.6",width:"13.81",height:"0.15",transform:"translate(322.85 102.5) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"103.6",y:"212.6",width:"13.81",height:"0.15",transform:"translate(323.18 102.17) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"103.92",y:"212.6",width:"13.81",height:"0.15",transform:"translate(323.51 101.85) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"104.25",y:"212.6",width:"13.81",height:"0.15",transform:"translate(323.83 101.52) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"104.57",y:"212.6",width:"13.81",height:"0.15",transform:"translate(324.16 101.2) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"104.9",y:"212.6",width:"13.81",height:"0.15",transform:"translate(324.48 100.87) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"105.23",y:"212.6",width:"13.81",height:"0.15",transform:"translate(324.81 100.55) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"105.55",y:"212.6",width:"13.81",height:"0.15",transform:"translate(325.13 100.22) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"105.88",y:"212.6",width:"13.81",height:"0.15",transform:"translate(325.46 99.89) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"106.2",y:"212.6",width:"13.81",height:"0.15",transform:"translate(325.78 99.57) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"106.53",y:"212.6",width:"13.81",height:"0.15",transform:"translate(326.11 99.24) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"106.85",y:"212.6",width:"13.81",height:"0.15",transform:"translate(326.44 98.92) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M104.29,246.65a3.57,3.57,0,0,0,1.81-3.27h14.56c.09,1.48,0,2.72,1.07,3.27Z",fill:"#838383"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"102.46",y:"159.82",width:"8.83",height:"19.74",transform:"translate(-62.81 276.57) rotate(-90)",fill:"#838383",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"94.64",y:"134.28",width:"22.16",height:"14.68",transform:"translate(-35.9 247.34) rotate(-90)",fill:"#838383",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"113.08 137.6 116.99 137.6 116.99 148.47 113.08 148.47 113.08 168.45 99.41 168.45 99.41 166.46 97.02 166.46 97.02 140.65 98.39 140.65 98.39 131.99 113.08 131.99 113.08 137.6",fill:"#a6a7aa",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M113.09,148.44s0,17.94,0,18H105v2h-5.5v-2.05H97V140.65h1.41v-3.11h18.65v10.9Z",fill:"#c3c5c7",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"94.06",y:"146.52",width:"21.95",height:"16.05",transform:"translate(-49.51 259.58) rotate(-90)",fill:"#d1d3d4",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"104.98",y:"171.24",width:"8.91",height:"14.63",transform:"translate(-69.13 288) rotate(-90)",fill:"#aee2fa",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M99.46,146.84v.65H97v19.13h2.46v2.07h13.63l0-21.85Zm4,2.32h9V153h-9Z",fill:"#e5e6e6",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"96.97",y:"177.01",width:"8.1",height:"3.14",transform:"translate(-77.56 279.59) rotate(-90)",fill:"#dfdfdd",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"117.16",y:"166.38",width:"3.86",height:"3.86",transform:"translate(-49.22 287.41) rotate(-90)",fill:"#dfdfdd",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.08"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"102.1",y:"157.75",width:"13.88",height:"8.18",transform:"translate(-52.79 270.88) rotate(-90)",fill:"#6e7071",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.05"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"105.92",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-49.01 274.66) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"105.59",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-49.34 274.34) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"105.27",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-49.67 274.01) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"104.94",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-49.99 273.69) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"104.62",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-50.32 273.36) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"104.29",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-50.64 273.04) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"103.97",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-50.97 272.71) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"103.64",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-51.29 272.38) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"103.31",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-51.62 272.06) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"102.99",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-51.94 271.73) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"102.66",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-52.27 271.41) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"102.34",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-52.6 271.08) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"102.01",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-52.92 270.76) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"101.69",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-53.25 270.43) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"101.36",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-53.57 270.11) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"101.04",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-53.9 269.78) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"100.71",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-54.22 269.45) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"100.38",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-54.55 269.13) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"100.06",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-54.87 268.8) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"99.73",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-55.2 268.48) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"99.41",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-55.53 268.15) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"99.08",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-55.85 267.83) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"98.76",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-56.18 267.5) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"98.43",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-56.5 267.18) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M114.81,127.87a3.54,3.54,0,0,0-1.81,3.27H98.43c-.09-1.48,0-2.73-1.07-3.27Z",fill:"#838383"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"81.94",y:"159.82",width:"8.83",height:"19.74",transform:"translate(-83.33 256.05) rotate(-90)",fill:"#838383",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"76.44",y:"134.28",width:"22.16",height:"14.68",transform:"translate(-54.1 229.14) rotate(-90)",fill:"#838383",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"80.16 137.6 76.25 137.6 76.25 148.47 80.16 148.47 80.16 168.45 93.83 168.45 93.83 166.46 96.22 166.46 96.22 140.65 94.85 140.65 94.85 131.99 80.16 131.99 80.16 137.6",fill:"#a6a7aa",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M80.14,148.44s0,17.94,0,18h8.15v2h5.5v-2.05h2.45V140.65H94.83v-3.11H76.18v10.9Z",fill:"#c3c5c7",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"77.23",y:"146.52",width:"21.95",height:"16.05",transform:"translate(-66.34 242.75) rotate(-90)",fill:"#d1d3d4",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"79.35",y:"171.24",width:"8.91",height:"14.63",transform:"translate(-94.76 262.37) rotate(-90)",fill:"#aee2fa",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M80.11,146.84l0,21.85H93.78v-2.07h2.46V147.49H93.78v-.65ZM89.75,153h-9v-3.87h9Z",fill:"#e5e6e6",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"88.18",y:"177.01",width:"8.1",height:"3.14",transform:"translate(-86.35 270.8) rotate(-90)",fill:"#dfdfdd",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"72.22",y:"166.38",width:"3.86",height:"3.86",transform:"translate(-94.17 242.46) rotate(-90)",fill:"#dfdfdd",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.08"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"77.26",y:"157.75",width:"13.88",height:"8.18",transform:"translate(-77.64 246.03) rotate(-90)",fill:"#6e7071",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.05"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"73.51",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-81.42 242.25) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"73.83",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-81.1 242.58) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"74.16",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-80.77 242.9) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"74.49",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-80.45 243.23) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"74.81",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-80.12 243.56) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"75.14",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-79.8 243.88) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"75.46",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-79.47 244.21) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"75.79",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-79.14 244.53) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"76.11",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-78.82 244.86) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"76.44",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-78.49 245.18) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"76.77",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-78.17 245.51) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"77.09",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-77.84 245.83) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"77.42",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-77.52 246.16) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"77.74",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-77.19 246.49) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"78.07",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-76.87 246.81) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"78.39",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-76.54 247.14) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"78.72",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-76.21 247.46) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"79.04",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-75.89 247.79) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"79.37",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-75.56 248.11) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"79.7",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-75.24 248.44) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"80.02",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-74.91 248.76) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"80.35",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-74.59 249.09) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"80.67",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-74.26 249.42) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"81",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-73.94 249.74) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M78.43,127.87a3.54,3.54,0,0,1,1.81,3.27H94.81c.09-1.48,0-2.73,1.07-3.27Z",fill:"#838383"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"154.18",y:"159.82",width:"8.83",height:"19.74",transform:"translate(-11.1 328.28) rotate(-90)",fill:"#838383",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"146.35",y:"134.28",width:"22.16",height:"14.68",transform:"translate(15.81 299.05) rotate(-90)",fill:"#838383",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"164.8 137.6 168.7 137.6 168.7 148.47 164.8 148.47 164.8 168.45 151.12 168.45 151.12 166.46 148.73 166.46 148.73 140.65 150.1 140.65 150.1 131.99 164.8 131.99 164.8 137.6",fill:"#a6a7aa",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M164.81,148.44s0,17.94,0,18h-8.15v2h-5.5v-2.05h-2.45V140.65h1.42v-3.11h18.64v10.9Z",fill:"#c3c5c7",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"145.77",y:"146.52",width:"21.95",height:"16.05",transform:"translate(2.2 311.29) rotate(-90)",fill:"#d1d3d4",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"156.69",y:"171.24",width:"8.91",height:"14.63",transform:"translate(-17.41 339.71) rotate(-90)",fill:"#aee2fa",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M151.17,146.84v.65h-2.46v19.13h2.46v2.07H164.8l0-21.85Zm4,2.32h9V153h-9Z",fill:"#e5e6e6",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"148.68",y:"177.01",width:"8.1",height:"3.14",transform:"translate(-25.85 331.3) rotate(-90)",fill:"#dfdfdd",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"168.88",y:"166.38",width:"3.86",height:"3.86",transform:"translate(2.49 339.12) rotate(-90)",fill:"#dfdfdd",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.08"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"153.81",y:"157.75",width:"13.88",height:"8.18",transform:"translate(-1.08 322.59) rotate(-90)",fill:"#6e7071",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.05"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"157.63",y:"161.76",width:"13.81",height:"0.15",transform:"translate(2.7 326.37) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"157.31",y:"161.76",width:"13.81",height:"0.15",transform:"translate(2.37 326.05) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"156.98",y:"161.76",width:"13.81",height:"0.15",transform:"translate(2.05 325.72) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"156.65",y:"161.76",width:"13.81",height:"0.15",transform:"translate(1.72 325.4) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"156.33",y:"161.76",width:"13.81",height:"0.15",transform:"translate(1.4 325.07) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"156",y:"161.76",width:"13.81",height:"0.15",transform:"translate(1.07 324.75) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"155.68",y:"161.76",width:"13.81",height:"0.15",transform:"translate(0.74 324.42) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"155.35",y:"161.76",width:"13.81",height:"0.15",transform:"translate(0.42 324.1) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"155.03",y:"161.76",width:"13.81",height:"0.15",transform:"translate(0.09 323.77) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"154.7",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-0.23 323.44) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"154.37",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-0.56 323.12) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"154.05",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-0.88 322.79) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"153.72",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-1.21 322.47) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"153.4",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-1.53 322.14) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"153.07",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-1.86 321.82) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"152.75",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-2.19 321.49) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"152.42",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-2.51 321.17) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"152.1",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-2.84 320.84) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"151.77",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-3.16 320.51) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"151.44",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-3.49 320.19) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"151.12",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-3.81 319.86) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"150.79",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-4.14 319.54) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"150.47",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-4.46 319.21) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"150.14",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-4.79 318.89) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M166.52,127.87a3.54,3.54,0,0,0-1.81,3.27H150.15c-.1-1.48,0-2.73-1.07-3.27Z",fill:"#838383"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"133.65",y:"159.82",width:"8.83",height:"19.74",transform:"translate(-31.62 307.76) rotate(-90)",fill:"#838383",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"128.15",y:"134.28",width:"22.16",height:"14.68",transform:"translate(-2.39 280.85) rotate(-90)",fill:"#838383",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"131.87 137.6 127.96 137.6 127.96 148.47 131.87 148.47 131.87 168.45 145.54 168.45 145.54 166.46 147.94 166.46 147.94 140.65 146.56 140.65 146.56 131.99 131.87 131.99 131.87 137.6",fill:"#a6a7aa",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M131.86,148.44s0,17.94,0,18H140v2h5.49v-2.05H148V140.65h-1.41v-3.11H127.89v10.9Z",fill:"#c3c5c7",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"128.94",y:"146.52",width:"21.95",height:"16.05",transform:"translate(-14.63 294.46) rotate(-90)",fill:"#d1d3d4",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"131.06",y:"171.24",width:"8.91",height:"14.63",transform:"translate(-43.05 314.08) rotate(-90)",fill:"#aee2fa",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M131.82,146.84l0,21.85h13.63v-2.07H148V147.49h-2.46v-.65Zm9.65,6.19h-9v-3.87h9Z",fill:"#e5e6e6",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"139.89",y:"177.01",width:"8.1",height:"3.14",transform:"translate(-34.64 322.51) rotate(-90)",fill:"#dfdfdd",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"123.93",y:"166.38",width:"3.86",height:"3.86",transform:"translate(-42.45 294.17) rotate(-90)",fill:"#dfdfdd",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.08"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"128.97",y:"157.75",width:"13.88",height:"8.18",transform:"translate(-25.93 297.75) rotate(-90)",fill:"#6e7071",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.05"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"125.22",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-29.71 293.97) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"125.55",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-29.39 294.29) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"125.87",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-29.06 294.62) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"126.2",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-28.74 294.94) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"126.52",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-28.41 295.27) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"126.85",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-28.08 295.59) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"127.17",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-27.76 295.92) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"127.5",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-27.43 296.24) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"127.83",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-27.11 296.57) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"128.15",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-26.78 296.9) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"128.48",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-26.46 297.22) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"128.8",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-26.13 297.55) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"129.13",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-25.8 297.87) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"129.45",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-25.48 298.2) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"129.78",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-25.15 298.52) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"130.1",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-24.83 298.85) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"130.43",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-24.5 299.17) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"130.76",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-24.18 299.5) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"131.08",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-23.85 299.83) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"131.41",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-23.53 300.15) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"131.73",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-23.2 300.48) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"132.06",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-22.87 300.8) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"132.38",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-22.55 301.13) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"132.71",y:"161.76",width:"13.81",height:"0.15",transform:"translate(-22.22 301.45) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M130.14,127.87a3.53,3.53,0,0,1,1.81,3.27h14.57c.09-1.48,0-2.73,1.07-3.27Z",fill:"#838383"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"205.89",y:"159.82",width:"8.83",height:"19.74",transform:"translate(40.61 380) rotate(-90)",fill:"#838383",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"198.06",y:"134.28",width:"22.16",height:"14.68",transform:"translate(67.52 350.76) rotate(-90)",fill:"#838383",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"216.51 137.6 220.41 137.6 220.41 148.47 216.51 148.47 216.51 168.45 202.83 168.45 202.83 166.46 200.44 166.46 200.44 140.65 201.82 140.65 201.82 131.99 216.51 131.99 216.51 137.6",fill:"#a6a7aa",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M216.52,148.44s0,17.94,0,18h-8.15v2h-5.5v-2.05h-2.44V140.65h1.41v-3.11h18.65v10.9Z",fill:"#c3c5c7",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"197.48",y:"146.52",width:"21.95",height:"16.05",transform:"translate(53.91 363) rotate(-90)",fill:"#d1d3d4",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"208.4",y:"171.24",width:"8.91",height:"14.63",transform:"translate(34.3 391.42) rotate(-90)",fill:"#aee2fa",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M202.88,146.84v.65h-2.45v19.13h2.45v2.07h13.63l0-21.85Zm4,2.32h9V153h-9Z",fill:"#e5e6e6",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"200.39",y:"177.01",width:"8.1",height:"3.14",transform:"translate(25.86 383.01) rotate(-90)",fill:"#dfdfdd",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"220.59",y:"166.38",width:"3.86",height:"3.86",transform:"translate(54.2 390.83) rotate(-90)",fill:"#dfdfdd",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.08"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"205.53",y:"157.75",width:"13.88",height:"8.18",transform:"translate(50.63 374.3) rotate(-90)",fill:"#6e7071",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.05"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"209.34",y:"161.76",width:"13.81",height:"0.15",transform:"translate(54.41 378.09) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"209.02",y:"161.76",width:"13.81",height:"0.15",transform:"translate(54.08 377.76) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"208.69",y:"161.76",width:"13.81",height:"0.15",transform:"translate(53.76 377.44) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"208.37",y:"161.76",width:"13.81",height:"0.15",transform:"translate(53.43 377.11) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"208.04",y:"161.76",width:"13.81",height:"0.15",transform:"translate(53.11 376.78) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"207.71",y:"161.76",width:"13.81",height:"0.15",transform:"translate(52.78 376.46) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"207.39",y:"161.76",width:"13.81",height:"0.15",transform:"translate(52.46 376.13) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"207.06",y:"161.76",width:"13.81",height:"0.15",transform:"translate(52.13 375.81) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"206.74",y:"161.76",width:"13.81",height:"0.15",transform:"translate(51.8 375.48) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"206.41",y:"161.76",width:"13.81",height:"0.15",transform:"translate(51.48 375.16) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"206.09",y:"161.76",width:"13.81",height:"0.15",transform:"translate(51.15 374.83) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"205.76",y:"161.76",width:"13.81",height:"0.15",transform:"translate(50.83 374.51) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"205.44",y:"161.76",width:"13.81",height:"0.15",transform:"translate(50.5 374.18) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"205.11",y:"161.76",width:"13.81",height:"0.15",transform:"translate(50.18 373.85) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"204.78",y:"161.76",width:"13.81",height:"0.15",transform:"translate(49.85 373.53) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"204.46",y:"161.76",width:"13.81",height:"0.15",transform:"translate(49.53 373.2) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"204.13",y:"161.76",width:"13.81",height:"0.15",transform:"translate(49.2 372.88) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"203.81",y:"161.76",width:"13.81",height:"0.15",transform:"translate(48.87 372.55) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"203.48",y:"161.76",width:"13.81",height:"0.15",transform:"translate(48.55 372.23) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"203.16",y:"161.76",width:"13.81",height:"0.15",transform:"translate(48.22 371.9) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"202.83",y:"161.76",width:"13.81",height:"0.15",transform:"translate(47.9 371.58) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"202.51",y:"161.76",width:"13.81",height:"0.15",transform:"translate(47.57 371.25) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"202.18",y:"161.76",width:"13.81",height:"0.15",transform:"translate(47.25 370.92) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"201.85",y:"161.76",width:"13.81",height:"0.15",transform:"translate(46.92 370.6) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M218.23,127.87a3.54,3.54,0,0,0-1.81,3.27H201.86c-.1-1.48,0-2.73-1.07-3.27Z",fill:"#838383"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"185.37",y:"159.82",width:"8.83",height:"19.74",transform:"translate(20.09 359.47) rotate(-90)",fill:"#838383",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"179.86",y:"134.28",width:"22.16",height:"14.68",transform:"translate(49.33 332.56) rotate(-90)",fill:"#838383",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"183.58 137.6 179.67 137.6 179.67 148.47 183.58 148.47 183.58 168.45 197.25 168.45 197.25 166.46 199.65 166.46 199.65 140.65 198.27 140.65 198.27 131.99 183.58 131.99 183.58 137.6",fill:"#a6a7aa",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M183.57,148.44s0,17.94,0,18h8.15v2h5.49v-2.05h2.45V140.65h-1.41v-3.11H179.6v10.9Z",fill:"#c3c5c7",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"180.66",y:"146.52",width:"21.95",height:"16.05",transform:"translate(37.08 346.18) rotate(-90)",fill:"#d1d3d4",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"182.77",y:"171.24",width:"8.91",height:"14.63",transform:"translate(8.67 365.79) rotate(-90)",fill:"#aee2fa",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M183.53,146.84l0,21.85h13.64v-2.07h2.45V147.49h-2.45v-.65Zm9.65,6.19h-9v-3.87h9Z",fill:"#e5e6e6",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"191.6",y:"177.01",width:"8.1",height:"3.14",transform:"translate(17.07 374.23) rotate(-90)",fill:"#dfdfdd",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"175.64",y:"166.38",width:"3.86",height:"3.86",transform:"translate(9.26 345.89) rotate(-90)",fill:"#dfdfdd",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.08"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"180.68",y:"157.75",width:"13.88",height:"8.18",transform:"translate(25.79 349.46) rotate(-90)",fill:"#6e7071",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.05"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"176.93",y:"161.76",width:"13.81",height:"0.15",transform:"translate(22 345.68) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"177.26",y:"161.76",width:"13.81",height:"0.15",transform:"translate(22.33 346) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"177.58",y:"161.76",width:"13.81",height:"0.15",transform:"translate(22.65 346.33) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"177.91",y:"161.76",width:"13.81",height:"0.15",transform:"translate(22.98 346.65) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"178.23",y:"161.76",width:"13.81",height:"0.15",transform:"translate(23.3 346.98) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"178.56",y:"161.76",width:"13.81",height:"0.15",transform:"translate(23.63 347.3) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"178.89",y:"161.76",width:"13.81",height:"0.15",transform:"translate(23.95 347.63) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"179.21",y:"161.76",width:"13.81",height:"0.15",transform:"translate(24.28 347.96) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"179.54",y:"161.76",width:"13.81",height:"0.15",transform:"translate(24.6 348.28) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"179.86",y:"161.76",width:"13.81",height:"0.15",transform:"translate(24.93 348.61) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"180.19",y:"161.76",width:"13.81",height:"0.15",transform:"translate(25.26 348.93) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"180.51",y:"161.76",width:"13.81",height:"0.15",transform:"translate(25.58 349.26) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"180.84",y:"161.76",width:"13.81",height:"0.15",transform:"translate(25.91 349.58) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"181.17",y:"161.76",width:"13.81",height:"0.15",transform:"translate(26.23 349.91) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"181.49",y:"161.76",width:"13.81",height:"0.15",transform:"translate(26.56 350.23) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"181.82",y:"161.76",width:"13.81",height:"0.15",transform:"translate(26.88 350.56) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"182.14",y:"161.76",width:"13.81",height:"0.15",transform:"translate(27.21 350.89) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"182.47",y:"161.76",width:"13.81",height:"0.15",transform:"translate(27.53 351.21) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"182.79",y:"161.76",width:"13.81",height:"0.15",transform:"translate(27.86 351.54) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"183.12",y:"161.76",width:"13.81",height:"0.15",transform:"translate(28.19 351.86) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"183.44",y:"161.76",width:"13.81",height:"0.15",transform:"translate(28.51 352.19) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"183.77",y:"161.76",width:"13.81",height:"0.15",transform:"translate(28.84 352.51) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"184.1",y:"161.76",width:"13.81",height:"0.15",transform:"translate(29.16 352.84) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"184.42",y:"161.76",width:"13.81",height:"0.15",transform:"translate(29.49 353.17) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M181.85,127.87a3.55,3.55,0,0,1,1.82,3.27h14.56c.09-1.48,0-2.73,1.07-3.27Z",fill:"#838383"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"257.6",y:"159.82",width:"8.83",height:"19.74",transform:"translate(92.33 431.71) rotate(-90)",fill:"#838383",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"249.77",y:"134.28",width:"22.16",height:"14.68",transform:"translate(119.23 402.47) rotate(-90)",fill:"#838383",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"268.22 137.6 272.13 137.6 272.13 148.47 268.22 148.47 268.22 168.45 254.54 168.45 254.54 166.46 252.15 166.46 252.15 140.65 253.53 140.65 253.53 131.99 268.22 131.99 268.22 137.6",fill:"#a6a7aa",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M268.23,148.44s0,17.94,0,18h-8.15v2h-5.49v-2.05h-2.45V140.65h1.41v-3.11H272.2v10.9Z",fill:"#c3c5c7",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"249.2",y:"146.52",width:"21.95",height:"16.05",transform:"translate(105.62 414.72) rotate(-90)",fill:"#d1d3d4",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"260.11",y:"171.24",width:"8.91",height:"14.63",transform:"translate(86.01 443.13) rotate(-90)",fill:"#aee2fa",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M254.59,146.84v.65h-2.45v19.13h2.45v2.07h13.64l0-21.85Zm4,2.32h8.95V153h-8.95Z",fill:"#e5e6e6",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"252.1",y:"177.01",width:"8.1",height:"3.14",transform:"translate(77.57 434.73) rotate(-90)",fill:"#dfdfdd",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"272.3",y:"166.38",width:"3.86",height:"3.86",transform:"translate(105.91 442.54) rotate(-90)",fill:"#dfdfdd",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.08"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"257.24",y:"157.75",width:"13.88",height:"8.18",transform:"translate(102.34 426.01) rotate(-90)",fill:"#6e7071",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.05"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"261.05",y:"161.76",width:"13.81",height:"0.15",transform:"translate(106.12 429.8) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"260.73",y:"161.76",width:"13.81",height:"0.15",transform:"translate(105.8 429.47) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"260.4",y:"161.76",width:"13.81",height:"0.15",transform:"translate(105.47 429.15) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"260.08",y:"161.76",width:"13.81",height:"0.15",transform:"translate(105.14 428.82) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"259.75",y:"161.76",width:"13.81",height:"0.15",transform:"translate(104.82 428.5) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"259.43",y:"161.76",width:"13.81",height:"0.15",transform:"translate(104.49 428.17) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"259.1",y:"161.76",width:"13.81",height:"0.15",transform:"translate(104.17 427.84) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"258.78",y:"161.76",width:"13.81",height:"0.15",transform:"translate(103.84 427.52) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"258.45",y:"161.76",width:"13.81",height:"0.15",transform:"translate(103.52 427.19) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"258.12",y:"161.76",width:"13.81",height:"0.15",transform:"translate(103.19 426.87) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"257.8",y:"161.76",width:"13.81",height:"0.15",transform:"translate(102.87 426.54) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"257.47",y:"161.76",width:"13.81",height:"0.15",transform:"translate(102.54 426.22) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"257.15",y:"161.76",width:"13.81",height:"0.15",transform:"translate(102.21 425.89) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"256.82",y:"161.76",width:"13.81",height:"0.15",transform:"translate(101.89 425.57) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"256.5",y:"161.76",width:"13.81",height:"0.15",transform:"translate(101.56 425.24) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"256.17",y:"161.76",width:"13.81",height:"0.15",transform:"translate(101.24 424.91) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"255.84",y:"161.76",width:"13.81",height:"0.15",transform:"translate(100.91 424.59) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"255.52",y:"161.76",width:"13.81",height:"0.15",transform:"translate(100.59 424.26) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"255.19",y:"161.76",width:"13.81",height:"0.15",transform:"translate(100.26 423.94) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"254.87",y:"161.76",width:"13.81",height:"0.15",transform:"translate(99.94 423.61) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"254.54",y:"161.76",width:"13.81",height:"0.15",transform:"translate(99.61 423.29) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"254.22",y:"161.76",width:"13.81",height:"0.15",transform:"translate(99.28 422.96) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"253.89",y:"161.76",width:"13.81",height:"0.15",transform:"translate(98.96 422.64) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"253.57",y:"161.76",width:"13.81",height:"0.15",transform:"translate(98.63 422.31) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M269.94,127.87a3.56,3.56,0,0,0-1.81,3.27H253.57c-.09-1.48,0-2.73-1.07-3.27Z",fill:"#838383"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"237.08",y:"159.82",width:"8.83",height:"19.74",transform:"translate(71.8 411.18) rotate(-90)",fill:"#838383",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"231.58",y:"134.28",width:"22.16",height:"14.68",transform:"translate(101.04 384.28) rotate(-90)",fill:"#838383",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"235.29 137.6 231.38 137.6 231.38 148.47 235.29 148.47 235.29 168.45 248.97 168.45 248.97 166.46 251.36 166.46 251.36 140.65 249.98 140.65 249.98 131.99 235.29 131.99 235.29 137.6",fill:"#a6a7aa",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M235.28,148.44s0,17.94,0,18h8.15v2h5.49v-2.05h2.45V140.65H250v-3.11H231.31v10.9Z",fill:"#c3c5c7",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"232.37",y:"146.52",width:"21.95",height:"16.05",transform:"translate(88.79 397.89) rotate(-90)",fill:"#d1d3d4",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"234.48",y:"171.24",width:"8.91",height:"14.63",transform:"translate(60.38 417.5) rotate(-90)",fill:"#aee2fa",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M235.24,146.84l0,21.85h13.64v-2.07h2.45V147.49h-2.45v-.65Zm9.65,6.19h-8.95v-3.87h8.95Z",fill:"#e5e6e6",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"243.31",y:"177.01",width:"8.1",height:"3.14",transform:"translate(68.78 425.94) rotate(-90)",fill:"#dfdfdd",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"227.36",y:"166.38",width:"3.86",height:"3.86",transform:"translate(60.97 397.6) rotate(-90)",fill:"#dfdfdd",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.08"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"232.39",y:"157.75",width:"13.88",height:"8.18",transform:"translate(77.5 401.17) rotate(-90)",fill:"#6e7071",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.05"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"228.64",y:"161.76",width:"13.81",height:"0.15",transform:"translate(73.71 397.39) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"228.97",y:"161.76",width:"13.81",height:"0.15",transform:"translate(74.04 397.71) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"229.3",y:"161.76",width:"13.81",height:"0.15",transform:"translate(74.36 398.04) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"229.62",y:"161.76",width:"13.81",height:"0.15",transform:"translate(74.69 398.37) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"229.95",y:"161.76",width:"13.81",height:"0.15",transform:"translate(75.01 398.69) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"230.27",y:"161.76",width:"13.81",height:"0.15",transform:"translate(75.34 399.02) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"230.6",y:"161.76",width:"13.81",height:"0.15",transform:"translate(75.66 399.34) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"230.92",y:"161.76",width:"13.81",height:"0.15",transform:"translate(75.99 399.67) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"231.25",y:"161.76",width:"13.81",height:"0.15",transform:"translate(76.32 399.99) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"231.57",y:"161.76",width:"13.81",height:"0.15",transform:"translate(76.64 400.32) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"231.9",y:"161.76",width:"13.81",height:"0.15",transform:"translate(76.97 400.64) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"232.23",y:"161.76",width:"13.81",height:"0.15",transform:"translate(77.29 400.97) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"232.55",y:"161.76",width:"13.81",height:"0.15",transform:"translate(77.62 401.3) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"232.88",y:"161.76",width:"13.81",height:"0.15",transform:"translate(77.94 401.62) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"233.2",y:"161.76",width:"13.81",height:"0.15",transform:"translate(78.27 401.95) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"233.53",y:"161.76",width:"13.81",height:"0.15",transform:"translate(78.6 402.27) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"233.85",y:"161.76",width:"13.81",height:"0.15",transform:"translate(78.92 402.6) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"234.18",y:"161.76",width:"13.81",height:"0.15",transform:"translate(79.25 402.92) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"234.5",y:"161.76",width:"13.81",height:"0.15",transform:"translate(79.57 403.25) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"234.83",y:"161.76",width:"13.81",height:"0.15",transform:"translate(79.9 403.57) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"235.16",y:"161.76",width:"13.81",height:"0.15",transform:"translate(80.22 403.9) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"235.48",y:"161.76",width:"13.81",height:"0.15",transform:"translate(80.55 404.23) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"235.81",y:"161.76",width:"13.81",height:"0.15",transform:"translate(80.87 404.55) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"236.13",y:"161.76",width:"13.81",height:"0.15",transform:"translate(81.2 404.88) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M233.57,127.87a3.56,3.56,0,0,1,1.81,3.27h14.56c.09-1.48,0-2.73,1.07-3.27Z",fill:"#838383"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"309.24",y:"159.82",width:"8.83",height:"19.74",transform:"translate(143.97 483.35) rotate(-90)",fill:"#838383",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"301.41",y:"134.28",width:"22.16",height:"14.68",transform:"translate(170.87 454.11) rotate(-90)",fill:"#838383",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"319.86 137.6 323.77 137.6 323.77 148.47 319.86 148.47 319.86 168.45 306.19 168.45 306.19 166.46 303.79 166.46 303.79 140.65 305.17 140.65 305.17 131.99 319.86 131.99 319.86 137.6",fill:"#a6a7aa",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M319.87,148.44s0,17.94,0,18h-8.15v2h-5.49v-2.05h-2.45V140.65h1.41v-3.11h18.65v10.9Z",fill:"#c3c5c7",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"300.84",y:"146.52",width:"21.95",height:"16.05",transform:"translate(157.26 466.36) rotate(-90)",fill:"#d1d3d4",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"311.76",y:"171.24",width:"8.91",height:"14.63",transform:"translate(137.65 494.77) rotate(-90)",fill:"#aee2fa",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M306.23,146.84v.65h-2.45v19.13h2.45v2.07h13.64l0-21.85Zm4,2.32h8.95V153h-8.95Z",fill:"#e5e6e6",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"303.74",y:"177.01",width:"8.1",height:"3.14",transform:"translate(129.21 486.37) rotate(-90)",fill:"#dfdfdd",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"323.94",y:"166.38",width:"3.86",height:"3.86",transform:"translate(157.55 494.18) rotate(-90)",fill:"#dfdfdd",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.08"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"308.88",y:"157.75",width:"13.88",height:"8.18",transform:"translate(153.98 477.65) rotate(-90)",fill:"#6e7071",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.05"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"312.69",y:"161.76",width:"13.81",height:"0.15",transform:"translate(157.76 481.44) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"312.37",y:"161.76",width:"13.81",height:"0.15",transform:"translate(157.44 481.11) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"312.04",y:"161.76",width:"13.81",height:"0.15",transform:"translate(157.11 480.79) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"311.72",y:"161.76",width:"13.81",height:"0.15",transform:"translate(156.78 480.46) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"311.39",y:"161.76",width:"13.81",height:"0.15",transform:"translate(156.46 480.14) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"311.07",y:"161.76",width:"13.81",height:"0.15",transform:"translate(156.13 479.81) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"310.74",y:"161.76",width:"13.81",height:"0.15",transform:"translate(155.81 479.49) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"310.42",y:"161.76",width:"13.81",height:"0.15",transform:"translate(155.48 479.16) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"310.09",y:"161.76",width:"13.81",height:"0.15",transform:"translate(155.16 478.83) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"309.76",y:"161.76",width:"13.81",height:"0.15",transform:"translate(154.83 478.51) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"309.44",y:"161.76",width:"13.81",height:"0.15",transform:"translate(154.51 478.18) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"309.11",y:"161.76",width:"13.81",height:"0.15",transform:"translate(154.18 477.86) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"308.79",y:"161.76",width:"13.81",height:"0.15",transform:"translate(153.85 477.53) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"308.46",y:"161.76",width:"13.81",height:"0.15",transform:"translate(153.53 477.21) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"308.14",y:"161.76",width:"13.81",height:"0.15",transform:"translate(153.2 476.88) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"307.81",y:"161.76",width:"13.81",height:"0.15",transform:"translate(152.88 476.56) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"307.49",y:"161.76",width:"13.81",height:"0.15",transform:"translate(152.55 476.23) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"307.16",y:"161.76",width:"13.81",height:"0.15",transform:"translate(152.23 475.9) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"306.83",y:"161.76",width:"13.81",height:"0.15",transform:"translate(151.9 475.58) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"306.51",y:"161.76",width:"13.81",height:"0.15",transform:"translate(151.58 475.25) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"306.18",y:"161.76",width:"13.81",height:"0.15",transform:"translate(151.25 474.93) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"305.86",y:"161.76",width:"13.81",height:"0.15",transform:"translate(150.92 474.6) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"305.53",y:"161.76",width:"13.81",height:"0.15",transform:"translate(150.6 474.28) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"305.21",y:"161.76",width:"13.81",height:"0.15",transform:"translate(150.27 473.95) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M321.58,127.87a3.56,3.56,0,0,0-1.81,3.27H305.21c-.09-1.48,0-2.73-1.07-3.27Z",fill:"#838383"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"288.72",y:"159.82",width:"8.83",height:"19.74",transform:"translate(123.44 462.83) rotate(-90)",fill:"#838383",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"283.22",y:"134.28",width:"22.16",height:"14.68",transform:"translate(152.68 435.92) rotate(-90)",fill:"#838383",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"286.93 137.6 283.02 137.6 283.02 148.47 286.93 148.47 286.93 168.45 300.61 168.45 300.61 166.46 303 166.46 303 140.65 301.62 140.65 301.62 131.99 286.93 131.99 286.93 137.6",fill:"#a6a7aa",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M286.92,148.44s0,17.94,0,18h8.15v2h5.49v-2.05H303V140.65H301.6v-3.11H283v10.9Z",fill:"#c3c5c7",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"284.01",y:"146.52",width:"21.95",height:"16.05",transform:"translate(140.43 449.53) rotate(-90)",fill:"#d1d3d4",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"286.12",y:"171.24",width:"8.91",height:"14.63",transform:"translate(112.02 469.14) rotate(-90)",fill:"#aee2fa",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M286.88,146.84l0,21.85h13.64v-2.07H303V147.49h-2.45v-.65Zm9.65,6.19h-8.95v-3.87h8.95Z",fill:"#e5e6e6",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"294.95",y:"177.01",width:"8.1",height:"3.14",transform:"translate(120.42 477.58) rotate(-90)",fill:"#dfdfdd",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"279",y:"166.38",width:"3.86",height:"3.86",transform:"translate(112.61 449.24) rotate(-90)",fill:"#dfdfdd",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.08"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"284.04",y:"157.75",width:"13.88",height:"8.18",transform:"translate(129.14 452.81) rotate(-90)",fill:"#6e7071",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.05"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"280.28",y:"161.76",width:"13.81",height:"0.15",transform:"translate(125.35 449.03) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"280.61",y:"161.76",width:"13.81",height:"0.15",transform:"translate(125.68 449.35) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"280.94",y:"161.76",width:"13.81",height:"0.15",transform:"translate(126 449.68) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"281.26",y:"161.76",width:"13.81",height:"0.15",transform:"translate(126.33 450.01) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"281.59",y:"161.76",width:"13.81",height:"0.15",transform:"translate(126.65 450.33) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"281.91",y:"161.76",width:"13.81",height:"0.15",transform:"translate(126.98 450.66) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"282.24",y:"161.76",width:"13.81",height:"0.15",transform:"translate(127.31 450.98) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"282.56",y:"161.76",width:"13.81",height:"0.15",transform:"translate(127.63 451.31) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"282.89",y:"161.76",width:"13.81",height:"0.15",transform:"translate(127.96 451.63) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"283.21",y:"161.76",width:"13.81",height:"0.15",transform:"translate(128.28 451.96) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"283.54",y:"161.76",width:"13.81",height:"0.15",transform:"translate(128.61 452.28) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"283.87",y:"161.76",width:"13.81",height:"0.15",transform:"translate(128.93 452.61) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"284.19",y:"161.76",width:"13.81",height:"0.15",transform:"translate(129.26 452.94) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"284.52",y:"161.76",width:"13.81",height:"0.15",transform:"translate(129.58 453.26) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"284.84",y:"161.76",width:"13.81",height:"0.15",transform:"translate(129.91 453.59) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"285.17",y:"161.76",width:"13.81",height:"0.15",transform:"translate(130.24 453.91) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"285.49",y:"161.76",width:"13.81",height:"0.15",transform:"translate(130.56 454.24) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"285.82",y:"161.76",width:"13.81",height:"0.15",transform:"translate(130.89 454.56) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"286.15",y:"161.76",width:"13.81",height:"0.15",transform:"translate(131.21 454.89) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"286.47",y:"161.76",width:"13.81",height:"0.15",transform:"translate(131.54 455.21) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"286.8",y:"161.76",width:"13.81",height:"0.15",transform:"translate(131.86 455.54) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"287.12",y:"161.76",width:"13.81",height:"0.15",transform:"translate(132.19 455.87) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"287.45",y:"161.76",width:"13.81",height:"0.15",transform:"translate(132.51 456.19) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"287.77",y:"161.76",width:"13.81",height:"0.15",transform:"translate(132.84 456.52) rotate(-90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M285.21,127.87a3.56,3.56,0,0,1,1.81,3.27h14.56c.09-1.48,0-2.73,1.07-3.27Z",fill:"#838383"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"180.03",y:"194.95",width:"8.83",height:"19.74",transform:"translate(389.27 20.38) rotate(90)",fill:"#838383",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"172.2",y:"225.56",width:"22.16",height:"14.68",transform:"translate(416.18 49.61) rotate(90)",fill:"#838383",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"190.65 236.91 194.56 236.91 194.56 226.05 190.65 226.05 190.65 206.07 176.98 206.07 176.98 208.06 174.58 208.06 174.58 233.86 175.96 233.86 175.96 242.53 190.65 242.53 190.65 236.91",fill:"#a6a7aa",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M190.66,226.08s0-18,0-18h-8.15v-2H177v2h-2.45v25.73H176V237h18.65v-10.9Z",fill:"#c3c5c7",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"171.63",y:"211.94",width:"21.95",height:"16.05",transform:"translate(402.57 37.37) rotate(90)",fill:"#d1d3d4",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"182.55",y:"188.64",width:"8.91",height:"14.63",transform:"translate(382.96 8.95) rotate(90)",fill:"#aee2fa",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M190.7,227.68l0-21.86H177v2.08h-2.45V227H177v.66Zm-9.65-6.19h9v3.87h-9Z",fill:"#e5e6e6",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"174.53",y:"194.37",width:"8.1",height:"3.14",transform:"translate(374.52 17.36) rotate(90)",fill:"#dfdfdd",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"194.73",y:"204.27",width:"3.86",height:"3.86",transform:"translate(402.86 9.54) rotate(90)",fill:"#dfdfdd",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.08"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"179.67",y:"208.59",width:"13.88",height:"8.18",transform:"translate(399.29 26.07) rotate(90)",fill:"#6e7071",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.05"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"183.49",y:"212.6",width:"13.81",height:"0.15",transform:"translate(403.07 22.28) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"183.16",y:"212.6",width:"13.81",height:"0.15",transform:"translate(402.74 22.61) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"182.84",y:"212.6",width:"13.81",height:"0.15",transform:"translate(402.42 22.94) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"182.51",y:"212.6",width:"13.81",height:"0.15",transform:"translate(402.09 23.26) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"182.18",y:"212.6",width:"13.81",height:"0.15",transform:"translate(401.77 23.59) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"181.86",y:"212.6",width:"13.81",height:"0.15",transform:"translate(401.44 23.91) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"181.53",y:"212.6",width:"13.81",height:"0.15",transform:"translate(401.12 24.24) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"181.21",y:"212.6",width:"13.81",height:"0.15",transform:"translate(400.79 24.56) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"180.88",y:"212.6",width:"13.81",height:"0.15",transform:"translate(400.46 24.89) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"180.56",y:"212.6",width:"13.81",height:"0.15",transform:"translate(400.14 25.21) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"180.23",y:"212.6",width:"13.81",height:"0.15",transform:"translate(399.81 25.54) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"179.91",y:"212.6",width:"13.81",height:"0.15",transform:"translate(399.49 25.87) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"179.58",y:"212.6",width:"13.81",height:"0.15",transform:"translate(399.16 26.19) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"179.25",y:"212.6",width:"13.81",height:"0.15",transform:"translate(398.84 26.52) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"178.93",y:"212.6",width:"13.81",height:"0.15",transform:"translate(398.51 26.84) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"178.6",y:"212.6",width:"13.81",height:"0.15",transform:"translate(398.19 27.17) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"178.28",y:"212.6",width:"13.81",height:"0.15",transform:"translate(397.86 27.49) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"177.95",y:"212.6",width:"13.81",height:"0.15",transform:"translate(397.53 27.82) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"177.63",y:"212.6",width:"13.81",height:"0.15",transform:"translate(397.21 28.15) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"177.3",y:"212.6",width:"13.81",height:"0.15",transform:"translate(396.88 28.47) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"176.98",y:"212.6",width:"13.81",height:"0.15",transform:"translate(396.56 28.8) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"176.65",y:"212.6",width:"13.81",height:"0.15",transform:"translate(396.23 29.12) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"176.32",y:"212.6",width:"13.81",height:"0.15",transform:"translate(395.91 29.45) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"176",y:"212.6",width:"13.81",height:"0.15",transform:"translate(395.58 29.77) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M192.38,246.65a3.54,3.54,0,0,1-1.81-3.27H176c-.09,1.48,0,2.72-1.07,3.27Z",fill:"#838383"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"159.51",y:"194.95",width:"8.83",height:"19.74",transform:"translate(368.75 40.9) rotate(90)",fill:"#838383",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"154.01",y:"225.56",width:"22.16",height:"14.68",transform:"translate(397.99 67.81) rotate(90)",fill:"#838383",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"157.72 236.91 153.82 236.91 153.82 226.05 157.72 226.05 157.72 206.07 171.4 206.07 171.4 208.06 173.79 208.06 173.79 233.86 172.41 233.86 172.41 242.53 157.72 242.53 157.72 236.91",fill:"#a6a7aa",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M157.71,226.08s0-18,0-18h8.15v-2h5.5v2h2.44v25.73h-1.41V237H153.74v-10.9Z",fill:"#c3c5c7",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"154.8",y:"211.94",width:"21.95",height:"16.05",transform:"translate(385.74 54.19) rotate(90)",fill:"#d1d3d4",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"156.92",y:"188.64",width:"8.91",height:"14.63",transform:"translate(357.32 34.58) rotate(90)",fill:"#aee2fa",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M171.35,227.68V227h2.45V207.9h-2.45v-2.08H157.72l0,21.86Zm-4-2.32h-8.95v-3.87h8.95Z",fill:"#e5e6e6",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"165.75",y:"194.37",width:"8.1",height:"3.14",transform:"translate(365.73 26.14) rotate(90)",fill:"#dfdfdd",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"149.79",y:"204.27",width:"3.86",height:"3.86",transform:"translate(357.92 54.49) rotate(90)",fill:"#dfdfdd",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.08"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"154.83",y:"208.59",width:"13.88",height:"8.18",transform:"translate(374.45 50.91) rotate(90)",fill:"#6e7071",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.05"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"151.08",y:"212.6",width:"13.81",height:"0.15",transform:"translate(370.66 54.69) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"151.4",y:"212.6",width:"13.81",height:"0.15",transform:"translate(370.99 54.37) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"151.73",y:"212.6",width:"13.81",height:"0.15",transform:"translate(371.31 54.04) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"152.05",y:"212.6",width:"13.81",height:"0.15",transform:"translate(371.64 53.72) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"152.38",y:"212.6",width:"13.81",height:"0.15",transform:"translate(371.96 53.39) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"152.7",y:"212.6",width:"13.81",height:"0.15",transform:"translate(372.29 53.07) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"153.03",y:"212.6",width:"13.81",height:"0.15",transform:"translate(372.61 52.74) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"153.36",y:"212.6",width:"13.81",height:"0.15",transform:"translate(372.94 52.42) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"153.68",y:"212.6",width:"13.81",height:"0.15",transform:"translate(373.26 52.09) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"154.01",y:"212.6",width:"13.81",height:"0.15",transform:"translate(373.59 51.76) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"154.33",y:"212.6",width:"13.81",height:"0.15",transform:"translate(373.92 51.44) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"154.66",y:"212.6",width:"13.81",height:"0.15",transform:"translate(374.24 51.11) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"154.98",y:"212.6",width:"13.81",height:"0.15",transform:"translate(374.57 50.79) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"155.31",y:"212.6",width:"13.81",height:"0.15",transform:"translate(374.89 50.46) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"155.63",y:"212.6",width:"13.81",height:"0.15",transform:"translate(375.22 50.14) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"155.96",y:"212.6",width:"13.81",height:"0.15",transform:"translate(375.54 49.81) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"156.29",y:"212.6",width:"13.81",height:"0.15",transform:"translate(375.87 49.49) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"156.61",y:"212.6",width:"13.81",height:"0.15",transform:"translate(376.19 49.16) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"156.94",y:"212.6",width:"13.81",height:"0.15",transform:"translate(376.52 48.83) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"157.26",y:"212.6",width:"13.81",height:"0.15",transform:"translate(376.85 48.51) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"157.59",y:"212.6",width:"13.81",height:"0.15",transform:"translate(377.17 48.18) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"157.91",y:"212.6",width:"13.81",height:"0.15",transform:"translate(377.5 47.86) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"158.24",y:"212.6",width:"13.81",height:"0.15",transform:"translate(377.82 47.53) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"158.56",y:"212.6",width:"13.81",height:"0.15",transform:"translate(378.15 47.21) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M156,246.65a3.56,3.56,0,0,0,1.81-3.27h14.56c.1,1.48,0,2.72,1.07,3.27Z",fill:"#838383"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"231.74",y:"194.95",width:"8.83",height:"19.74",transform:"translate(440.98 -31.34) rotate(90)",fill:"#838383",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"223.92",y:"225.56",width:"22.16",height:"14.68",transform:"translate(467.89 -2.1) rotate(90)",fill:"#838383",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"242.36 236.91 246.27 236.91 246.27 226.05 242.36 226.05 242.36 206.07 228.69 206.07 228.69 208.06 226.29 208.06 226.29 233.86 227.67 233.86 227.67 242.53 242.36 242.53 242.36 236.91",fill:"#a6a7aa",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M242.37,226.08s0-18,0-18h-8.15v-2h-5.49v2h-2.45v25.73h1.41V237h18.65v-10.9Z",fill:"#c3c5c7",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"223.34",y:"211.94",width:"21.95",height:"16.05",transform:"translate(454.28 -14.34) rotate(90)",fill:"#d1d3d4",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"234.26",y:"188.64",width:"8.91",height:"14.63",transform:"translate(434.67 -42.76) rotate(90)",fill:"#aee2fa",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M242.41,227.68l0-21.86H228.74v2.08h-2.46V227h2.46v.66Zm-9.64-6.19h8.95v3.87h-8.95Z",fill:"#e5e6e6",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"226.25",y:"194.37",width:"8.1",height:"3.14",transform:"translate(426.23 -34.35) rotate(90)",fill:"#dfdfdd",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"246.44",y:"204.27",width:"3.86",height:"3.86",transform:"translate(454.57 -42.17) rotate(90)",fill:"#dfdfdd",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.08"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"231.38",y:"208.59",width:"13.88",height:"8.18",transform:"translate(451 -25.64) rotate(90)",fill:"#6e7071",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.05"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"235.2",y:"212.6",width:"13.81",height:"0.15",transform:"translate(454.78 -29.43) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"234.87",y:"212.6",width:"13.81",height:"0.15",transform:"translate(454.46 -29.1) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"234.55",y:"212.6",width:"13.81",height:"0.15",transform:"translate(454.13 -28.78) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"234.22",y:"212.6",width:"13.81",height:"0.15",transform:"translate(453.8 -28.45) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"233.9",y:"212.6",width:"13.81",height:"0.15",transform:"translate(453.48 -28.12) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"233.57",y:"212.6",width:"13.81",height:"0.15",transform:"translate(453.15 -27.8) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"233.24",y:"212.6",width:"13.81",height:"0.15",transform:"translate(452.83 -27.47) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"232.92",y:"212.6",width:"13.81",height:"0.15",transform:"translate(452.5 -27.15) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"232.59",y:"212.6",width:"13.81",height:"0.15",transform:"translate(452.18 -26.82) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"232.27",y:"212.6",width:"13.81",height:"0.15",transform:"translate(451.85 -26.5) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"231.94",y:"212.6",width:"13.81",height:"0.15",transform:"translate(451.53 -26.17) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"231.62",y:"212.6",width:"13.81",height:"0.15",transform:"translate(451.2 -25.85) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"231.29",y:"212.6",width:"13.81",height:"0.15",transform:"translate(450.87 -25.52) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"230.97",y:"212.6",width:"13.81",height:"0.15",transform:"translate(450.55 -25.19) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"230.64",y:"212.6",width:"13.81",height:"0.15",transform:"translate(450.22 -24.87) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"230.31",y:"212.6",width:"13.81",height:"0.15",transform:"translate(449.9 -24.54) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"229.99",y:"212.6",width:"13.81",height:"0.15",transform:"translate(449.57 -24.22) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"229.66",y:"212.6",width:"13.81",height:"0.15",transform:"translate(449.25 -23.89) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"229.34",y:"212.6",width:"13.81",height:"0.15",transform:"translate(448.92 -23.57) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"229.01",y:"212.6",width:"13.81",height:"0.15",transform:"translate(448.6 -23.24) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"228.69",y:"212.6",width:"13.81",height:"0.15",transform:"translate(448.27 -22.92) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"228.36",y:"212.6",width:"13.81",height:"0.15",transform:"translate(447.94 -22.59) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"228.04",y:"212.6",width:"13.81",height:"0.15",transform:"translate(447.62 -22.26) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"227.71",y:"212.6",width:"13.81",height:"0.15",transform:"translate(447.29 -21.94) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M244.09,246.65a3.56,3.56,0,0,1-1.81-3.27H227.71c-.09,1.48,0,2.72-1.07,3.27Z",fill:"#838383"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"211.22",y:"194.95",width:"8.83",height:"19.74",transform:"translate(420.46 -10.81) rotate(90)",fill:"#838383",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"205.72",y:"225.56",width:"22.16",height:"14.68",transform:"translate(449.7 16.09) rotate(90)",fill:"#838383",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"209.44 236.91 205.53 236.91 205.53 226.05 209.44 226.05 209.44 206.07 223.11 206.07 223.11 208.06 225.5 208.06 225.5 233.86 224.13 233.86 224.13 242.53 209.44 242.53 209.44 236.91",fill:"#a6a7aa",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M209.42,226.08s0-18,0-18h8.15v-2h5.5v2h2.45v25.73h-1.41V237H205.46v-10.9Z",fill:"#c3c5c7",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"206.51",y:"211.94",width:"21.95",height:"16.05",transform:"translate(437.45 2.48) rotate(90)",fill:"#d1d3d4",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"208.63",y:"188.64",width:"8.91",height:"14.63",transform:"translate(409.04 -17.13) rotate(90)",fill:"#aee2fa",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M223.06,227.68V227h2.46V207.9h-2.46v-2.08H209.43l0,21.86Zm-4-2.32h-8.95v-3.87H219Z",fill:"#e5e6e6",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"217.46",y:"194.37",width:"8.1",height:"3.14",transform:"translate(417.44 -25.57) rotate(90)",fill:"#dfdfdd",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"201.5",y:"204.27",width:"3.86",height:"3.86",transform:"translate(409.63 2.77) rotate(90)",fill:"#dfdfdd",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.08"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"206.54",y:"208.59",width:"13.88",height:"8.18",transform:"translate(426.16 -0.8) rotate(90)",fill:"#6e7071",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.05"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"202.79",y:"212.6",width:"13.81",height:"0.15",transform:"translate(422.37 2.98) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"203.11",y:"212.6",width:"13.81",height:"0.15",transform:"translate(422.7 2.66) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"203.44",y:"212.6",width:"13.81",height:"0.15",transform:"translate(423.02 2.33) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"203.77",y:"212.6",width:"13.81",height:"0.15",transform:"translate(423.35 2.01) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"204.09",y:"212.6",width:"13.81",height:"0.15",transform:"translate(423.67 1.68) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"204.42",y:"212.6",width:"13.81",height:"0.15",transform:"translate(424 1.35) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"204.74",y:"212.6",width:"13.81",height:"0.15",transform:"translate(424.32 1.03) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"205.07",y:"212.6",width:"13.81",height:"0.15",transform:"translate(424.65 0.7) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"205.39",y:"212.6",width:"13.81",height:"0.15",transform:"translate(424.98 0.38) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"205.72",y:"212.6",width:"13.81",height:"0.15",transform:"translate(425.3 0.05) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"206.04",y:"212.6",width:"13.81",height:"0.15",transform:"translate(425.63 -0.27) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"206.37",y:"212.6",width:"13.81",height:"0.15",transform:"translate(425.95 -0.6) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"206.7",y:"212.6",width:"13.81",height:"0.15",transform:"translate(426.28 -0.92) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"207.02",y:"212.6",width:"13.81",height:"0.15",transform:"translate(426.6 -1.25) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"207.35",y:"212.6",width:"13.81",height:"0.15",transform:"translate(426.93 -1.58) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"207.67",y:"212.6",width:"13.81",height:"0.15",transform:"translate(427.25 -1.9) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"208",y:"212.6",width:"13.81",height:"0.15",transform:"translate(427.58 -2.23) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"208.32",y:"212.6",width:"13.81",height:"0.15",transform:"translate(427.91 -2.55) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"208.65",y:"212.6",width:"13.81",height:"0.15",transform:"translate(428.23 -2.88) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"208.97",y:"212.6",width:"13.81",height:"0.15",transform:"translate(428.56 -3.2) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"209.3",y:"212.6",width:"13.81",height:"0.15",transform:"translate(428.88 -3.53) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"209.63",y:"212.6",width:"13.81",height:"0.15",transform:"translate(429.21 -3.85) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"209.95",y:"212.6",width:"13.81",height:"0.15",transform:"translate(429.53 -4.18) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"210.28",y:"212.6",width:"13.81",height:"0.15",transform:"translate(429.86 -4.51) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M207.71,246.65a3.56,3.56,0,0,0,1.81-3.27h14.57c.09,1.48,0,2.72,1.06,3.27Z",fill:"#838383"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"283.46",y:"194.95",width:"8.83",height:"19.74",transform:"translate(492.7 -83.05) rotate(90)",fill:"#838383",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"275.63",y:"225.56",width:"22.16",height:"14.68",transform:"translate(519.6 -53.81) rotate(90)",fill:"#838383",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"294.07 236.91 297.98 236.91 297.98 226.05 294.07 226.05 294.07 206.07 280.4 206.07 280.4 208.06 278.01 208.06 278.01 233.86 279.38 233.86 279.38 242.53 294.07 242.53 294.07 236.91",fill:"#a6a7aa",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M294.09,226.08s0-18,0-18h-8.15v-2h-5.5v2H278v25.73h1.41V237h18.65v-10.9Z",fill:"#c3c5c7",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"275.05",y:"211.94",width:"21.95",height:"16.05",transform:"translate(505.99 -66.06) rotate(90)",fill:"#d1d3d4",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"285.97",y:"188.64",width:"8.91",height:"14.63",transform:"translate(486.38 -94.47) rotate(90)",fill:"#aee2fa",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M294.12,227.68l0-21.86H280.45v2.08H278V227h2.46v.66Zm-9.64-6.19h8.95v3.87h-8.95Z",fill:"#e5e6e6",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"277.96",y:"194.37",width:"8.1",height:"3.14",transform:"translate(477.94 -86.07) rotate(90)",fill:"#dfdfdd",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"298.15",y:"204.27",width:"3.86",height:"3.86",transform:"translate(506.28 -93.88) rotate(90)",fill:"#dfdfdd",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.08"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"283.09",y:"208.59",width:"13.88",height:"8.18",transform:"translate(502.71 -77.35) rotate(90)",fill:"#6e7071",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.05"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"286.91",y:"212.6",width:"13.81",height:"0.15",transform:"translate(506.49 -81.14) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"286.58",y:"212.6",width:"13.81",height:"0.15",transform:"translate(506.17 -80.81) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"286.26",y:"212.6",width:"13.81",height:"0.15",transform:"translate(505.84 -80.49) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"285.93",y:"212.6",width:"13.81",height:"0.15",transform:"translate(505.52 -80.16) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"285.61",y:"212.6",width:"13.81",height:"0.15",transform:"translate(505.19 -79.84) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"285.28",y:"212.6",width:"13.81",height:"0.15",transform:"translate(504.86 -79.51) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"284.96",y:"212.6",width:"13.81",height:"0.15",transform:"translate(504.54 -79.19) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"284.63",y:"212.6",width:"13.81",height:"0.15",transform:"translate(504.21 -78.86) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"284.31",y:"212.6",width:"13.81",height:"0.15",transform:"translate(503.89 -78.53) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"283.98",y:"212.6",width:"13.81",height:"0.15",transform:"translate(503.56 -78.21) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"283.65",y:"212.6",width:"13.81",height:"0.15",transform:"translate(503.24 -77.88) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"283.33",y:"212.6",width:"13.81",height:"0.15",transform:"translate(502.91 -77.56) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"283",y:"212.6",width:"13.81",height:"0.15",transform:"translate(502.59 -77.23) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"282.68",y:"212.6",width:"13.81",height:"0.15",transform:"translate(502.26 -76.91) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"282.35",y:"212.6",width:"13.81",height:"0.15",transform:"translate(501.93 -76.58) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"282.03",y:"212.6",width:"13.81",height:"0.15",transform:"translate(501.61 -76.26) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"281.7",y:"212.6",width:"13.81",height:"0.15",transform:"translate(501.28 -75.93) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"281.38",y:"212.6",width:"13.81",height:"0.15",transform:"translate(500.96 -75.6) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"281.05",y:"212.6",width:"13.81",height:"0.15",transform:"translate(500.63 -75.28) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"280.72",y:"212.6",width:"13.81",height:"0.15",transform:"translate(500.31 -74.95) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"280.4",y:"212.6",width:"13.81",height:"0.15",transform:"translate(499.98 -74.63) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"280.07",y:"212.6",width:"13.81",height:"0.15",transform:"translate(499.66 -74.3) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"279.75",y:"212.6",width:"13.81",height:"0.15",transform:"translate(499.33 -73.98) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"279.42",y:"212.6",width:"13.81",height:"0.15",transform:"translate(499 -73.65) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M295.8,246.65a3.56,3.56,0,0,1-1.81-3.27H279.42c-.09,1.48,0,2.72-1.06,3.27Z",fill:"#838383"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"262.93",y:"194.95",width:"8.83",height:"19.74",transform:"translate(472.17 -62.52) rotate(90)",fill:"#838383",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"257.43",y:"225.56",width:"22.16",height:"14.68",transform:"translate(501.41 -35.62) rotate(90)",fill:"#838383",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("polygon",{points:"261.15 236.91 257.24 236.91 257.24 226.05 261.15 226.05 261.15 206.07 274.82 206.07 274.82 208.06 277.21 208.06 277.21 233.86 275.84 233.86 275.84 242.53 261.15 242.53 261.15 236.91",fill:"#a6a7aa",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M261.14,226.08s0-18,0-18h8.15v-2h5.49v2h2.45v25.73h-1.41V237H257.17v-10.9Z",fill:"#c3c5c7",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"258.22",y:"211.94",width:"21.95",height:"16.05",transform:"translate(489.17 -49.23) rotate(90)",fill:"#d1d3d4",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.02"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"260.34",y:"188.64",width:"8.91",height:"14.63",transform:"translate(460.75 -68.84) rotate(90)",fill:"#aee2fa",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M274.77,227.68V227h2.46V207.9h-2.46v-2.08H261.14l0,21.86Zm-4-2.32h-8.95v-3.87h8.95Z",fill:"#e5e6e6",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.01"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"269.17",y:"194.37",width:"8.1",height:"3.14",transform:"translate(469.15 -77.28) rotate(90)",fill:"#dfdfdd",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.06"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"253.21",y:"204.27",width:"3.86",height:"3.86",transform:"translate(461.34 -48.94) rotate(90)",fill:"#dfdfdd",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.08"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"258.25",y:"208.59",width:"13.88",height:"8.18",transform:"translate(477.87 -52.51) rotate(90)",fill:"#6e7071",stroke:"#808083","stroke-miterlimit":"10","stroke-width":"0.05"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"254.5",y:"212.6",width:"13.81",height:"0.15",transform:"translate(474.08 -48.73) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"254.83",y:"212.6",width:"13.81",height:"0.15",transform:"translate(474.41 -49.05) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"255.15",y:"212.6",width:"13.81",height:"0.15",transform:"translate(474.73 -49.38) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"255.48",y:"212.6",width:"13.81",height:"0.15",transform:"translate(475.06 -49.71) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"255.8",y:"212.6",width:"13.81",height:"0.15",transform:"translate(475.39 -50.03) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"256.13",y:"212.6",width:"13.81",height:"0.15",transform:"translate(475.71 -50.36) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"256.45",y:"212.6",width:"13.81",height:"0.15",transform:"translate(476.04 -50.68) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"256.78",y:"212.6",width:"13.81",height:"0.15",transform:"translate(476.36 -51.01) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"257.1",y:"212.6",width:"13.81",height:"0.15",transform:"translate(476.69 -51.33) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"257.43",y:"212.6",width:"13.81",height:"0.15",transform:"translate(477.01 -51.66) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"257.76",y:"212.6",width:"13.81",height:"0.15",transform:"translate(477.34 -51.98) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"258.08",y:"212.6",width:"13.81",height:"0.15",transform:"translate(477.66 -52.31) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"258.41",y:"212.6",width:"13.81",height:"0.15",transform:"translate(477.99 -52.64) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"258.73",y:"212.6",width:"13.81",height:"0.15",transform:"translate(478.32 -52.96) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"259.06",y:"212.6",width:"13.81",height:"0.15",transform:"translate(478.64 -53.29) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"259.38",y:"212.6",width:"13.81",height:"0.15",transform:"translate(478.97 -53.61) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"259.71",y:"212.6",width:"13.81",height:"0.15",transform:"translate(479.29 -53.94) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"260.03",y:"212.6",width:"13.81",height:"0.15",transform:"translate(479.62 -54.26) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"260.36",y:"212.6",width:"13.81",height:"0.15",transform:"translate(479.94 -54.59) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"260.69",y:"212.6",width:"13.81",height:"0.15",transform:"translate(480.27 -54.91) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"261.01",y:"212.6",width:"13.81",height:"0.15",transform:"translate(480.59 -55.24) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"261.34",y:"212.6",width:"13.81",height:"0.15",transform:"translate(480.92 -55.57) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"261.66",y:"212.6",width:"13.81",height:"0.15",transform:"translate(481.25 -55.89) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("rect",{x:"261.99",y:"212.6",width:"13.81",height:"0.15",transform:"translate(481.57 -56.22) rotate(90)",fill:"#808083"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M259.42,246.65a3.56,3.56,0,0,0,1.81-3.27H275.8c.09,1.48,0,2.72,1.07,3.27Z",fill:"#838383"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(104.13 228.72)","font-size":"8",fill:"#231f20","font-family":"Helvetica"},"LP2",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"-0.44",y:"9.6"},"TH1")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(126.13 228.72)","font-size":"8",fill:"#231f20","font-family":"Helvetica"},"LP2",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"-0.44",y:"9.6"},"TH3")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(156.38 228.72)","font-size":"8",fill:"#231f20","font-family":"Helvetica"},"LP2",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"-0.44",y:"9.6"},"TH5")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(178.38 228.72)","font-size":"8",fill:"#231f20","font-family":"Helvetica"},"LP2",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"-0.44",y:"9.6"},"TH7")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(207.63 228.72)","font-size":"8",fill:"#231f20","font-family":"Helvetica"},"LP2",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"-0.44",y:"9.6"},"TH9")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(229.63 228.72)","font-size":"8",fill:"#231f20","font-family":"Helvetica"},"LP2",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"-2.37",y:"9.6"},"TH"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"8.29",y:"9.6","letter-spacing":"-0.07em"},"1"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"12.15",y:"9.6"},"1")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(259.13 228.72)","font-size":"8",fill:"#231f20","font-family":"Helvetica"},"LP2",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"-2.66",y:"9.6"},"TH13")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(281.13 228.72)","font-size":"8",fill:"#231f20","font-family":"Helvetica"},"LP2",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"-2.66",y:"9.6"},"TH15")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(78.13 142.97)","font-size":"8",fill:"#231f20","font-family":"Helvetica"},"LP2",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"-0.44",y:"9.6"},"TH2")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(100.13 142.97)","font-size":"8",fill:"#231f20","font-family":"Helvetica"},"LP2",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"-0.44",y:"9.6"},"TH4")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(131.13 142.97)","font-size":"8",fill:"#231f20","font-family":"Helvetica"},"LP2",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"-0.44",y:"9.6"},"TH6")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(153.13 142.97)","font-size":"8",fill:"#231f20","font-family":"Helvetica"},"LP2",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"-0.44",y:"9.6"},"TH8")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(182.63 142.97)","font-size":"8",fill:"#231f20","font-family":"Helvetica"},"LP2",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"-2.66",y:"9.6"},"TH10")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(204.63 142.97)","font-size":"8",fill:"#231f20","font-family":"Helvetica"},"LP2",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"-2.66",y:"9.6"},"TH12")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(234.13 142.97)","font-size":"8",fill:"#231f20","font-family":"Helvetica"},"LP2",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"-2.66",y:"9.6"},"TH14")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(256.13 142.97)","font-size":"8",fill:"#231f20","font-family":"Helvetica"},"LP2",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"-2.66",y:"9.6"},"TH16")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(285.88 142.97)","font-size":"8",fill:"#231f20","font-family":"Helvetica"},"LP2",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"-2.66",y:"9.6"},"TH17")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("text",{transform:"translate(307.88 142.97)","font-size":"8",fill:"#231f20","font-family":"Helvetica"},"LP2",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("tspan",{x:"-2.66",y:"9.6"},"TH18")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{d:"M326,209.9v-9.19H309v25h17v-9.19h7.13V209.9Zm-5.5,13.15H310.25v-6.5H320.5Zm0-12.87H310.25v-6.5H320.5Z",fill:"#939598"}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{id:"flim_townhome","data-name":"flim townhome",style:{transform:"translateY(-26px)"},className:"cls-76 "+(selectedType==="townhome"||selectedType==="all"?"flim-out":"flim-in"),d:"M76.22,153.79H595.1s18.42.8,31.53,13.91l73.69,61.16s24.32,43.69-40.27,43.69H102.58a12.87,12.87,0,0,1-9.12-6.22L68.1,217.46a24.51,24.51,0,0,1-1.71-9.82V164.33s.29-9.69,9.83-10.54"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("path",{id:"flim_villa","data-name":"flim villa",className:"cls-76 "+(selectedType==="villa"||selectedType==="all"?"flim-out":"flim-in"),style:{transform:"translateY(-26px)"},d:"M125.94,290.59H675s14.81.58,14,17.47l-35,105.07s-4.56,14.6-20.23,14.6H125.94s-10.26-2.29-11.11-12.6V302.05s1.42-9.74,11.11-11.46"}));});

/***/ }),
/* 928 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_Close__ = __webpack_require__(101);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var popup=function(_Component){_inherits(popup,_Component);function popup(){_classCallCheck(this,popup);return _possibleConstructorReturn(this,(popup.__proto__||Object.getPrototypeOf(popup)).apply(this,arguments));}_createClass(popup,[{key:"render",value:function render(){var _props=this.props,data=_props.data,title=_props.title,active=_props.active,onclick=_props.onclick;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"popup "+active},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,title),data,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"button-close-popup"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{onClick:onclick,className:"button-scroll-to-section close"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_icons_Close__["a" /* default */],{width:20,height:20,fill:"#04a8a6"}))));}}]);return popup;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (popup);

/***/ }),
/* 929 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Masterplan; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_includes__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_filter__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_reject__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_reject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_reject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_animejs__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_animejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_animejs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_ProjectMap_PhuketMasterplan__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_ProjectMap_common_logos__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__hoc__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_navigation__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_detector__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_scroll__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Bubble__ = __webpack_require__(367);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import styled, { keyframes } from "styled-components";
// Filter LVR logo
var logos=__WEBPACK_IMPORTED_MODULE_3_lodash_reject___default()(__WEBPACK_IMPORTED_MODULE_7__containers_ProjectMap_common_logos__["a" /* default */],function(logo){return logo.key==="laguna-park2";});// const bounce = keyframes`
//   0% {
//     transform: scale(0);
//   }
//   20% {
//     transform: scale(1);
//   }
//   40% {
//     transform: scale(0.7);
//   }
//   60% {
//     transform: scale(1);
//   }
//   100% {
//     transform: scale(1);
//   }
// `;
// const AnimatedBubble = styled.g`
//   cursor: pointer;
//   animation-name: ${bounce};
//   animation-duration: 3s;
//   animation-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);
//   animation-iteration-count: infinite;
// `;
var filterTexts=function filterTexts(texts){return __WEBPACK_IMPORTED_MODULE_2_lodash_filter___default()(texts,function(text,i){var excludeList=__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(text,"options.excludes",[]);if(__WEBPACK_IMPORTED_MODULE_0_lodash_includes___default()(excludeList,"lpark2/masterplan")||__WEBPACK_IMPORTED_MODULE_0_lodash_includes___default()(excludeList,"masterplan"))return false;return true;});};var fixIETransform=function fixIETransform(id){return function(anim){var g=document.getElementById(id);if(g){var transform=getComputedStyle(g).getPropertyValue("transform");g.setAttribute("transform",transform);}};};var Masterplan=(_dec=Object(__WEBPACK_IMPORTED_MODULE_8__hoc__["a" /* multiLanguage */])(),_dec(_class=function(_Component){_inherits(Masterplan,_Component);function Masterplan(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Masterplan);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Masterplan.__proto__||Object.getPrototypeOf(Masterplan)).call.apply(_ref,[this].concat(args))),_this),_this.handleClickBubble=function(){// go to master plan
var headerHeight=Object(__WEBPACK_IMPORTED_MODULE_9__utils_navigation__["a" /* getHeaderHeight */])();__WEBPACK_IMPORTED_MODULE_11_react_scroll__["scroller"].scrollTo("siteplan",{duration:1500,smooth:true,offset:-headerHeight});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Masterplan,[{key:"componentDidMount",value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_5_animejs___default()({targets:"#lpark2-bubble",scale:[{value:0,duration:0,elasticity:0},{value:1,duration:2000,elasticity:400}],loop:true,update:__WEBPACK_IMPORTED_MODULE_10__utils_detector__["a" /* isIE */]?fixIETransform("lpark2-bubble"):null});}},{key:"render",value:function render(){var _props=this.props,t=_props.t,currentLanguage=_props.currentLanguage;console.log("filterTexts >>> ",logos);return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",{className:"section-masterplan"},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__containers_ProjectMap_PhuketMasterplan__["a" /* default */],{activeLanguage:currentLanguage,filterTexts:filterTexts},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("g",{transform:"translate(1280, 710)"},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("g",{id:"lpark2-bubble",onClick:this.handleClickBubble},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Bubble__["a" /* default */],null)))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",{className:"masterplan-name"},t("Master Plan")));}}]);return Masterplan;}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]))||_class);

/***/ }),
/* 930 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Residences; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Residences=function(_Component){_inherits(Residences,_Component);function Residences(){_classCallCheck(this,Residences);return _possibleConstructorReturn(this,(Residences.__proto__||Object.getPrototypeOf(Residences)).apply(this,arguments));}_createClass(Residences,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common__["f" /* Residences */],this.props);}}]);return Residences;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 931 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Ebrochure; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Ebrochure=function(_Component){_inherits(Ebrochure,_Component);function Ebrochure(){_classCallCheck(this,Ebrochure);return _possibleConstructorReturn(this,(Ebrochure.__proto__||Object.getPrototypeOf(Ebrochure)).apply(this,arguments));}_createClass(Ebrochure,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common__["c" /* Ebrochure */],this.props);}}]);return Ebrochure;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 932 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "category", function() { return category; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faqs", function() { return faqs; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var category=[{id:1,name:"Legal",displayOn:["en","cn","ru"]},{id:2,name:"Construction",displayOn:["en","cn","ru"]},{id:3,name:"Rental Program",displayOn:["en","cn","ru"]},{id:4,name:"Estate And Property Management",displayOn:["en","cn","ru"]},// { id: 4, name: "Property Management", displayOn: ["en", "cn", "ru"] },
{id:5,name:"Privileges",displayOn:["en","cn","ru"]},{id:6,name:"Infrastructure & Common Areas",displayOn:["en","ru"]}];var faqs=[{categoryId:1,question:{en:"What types of ownership are available?",ru:"Какие формы собственности существуют?",cn:"产权有哪些类型?"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Land is available on a leasehold basis. Leases are registered with the government (currently for a maximum period of 30 years as permitted by law) and are renewable. However, the buildings are sold as freehold."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"The cost of land lease renewals will be borne by the lessee according to the contracts."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"According to current Thai Law, non-Thai\u2019s are entitled to own the buildings developed upon the land leased by them, but not the land itself. Land will be available for freehold purchase by Thai buyers once a land subdivision is completed."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Upgrading land from leasehold to freehold title will be available once a land subdivision is completed, provided that the lessee is eligible under relevant Thai laws and regulations to take transfer of and own the land (currently, non-Thai\u2019s are prohibited to acquire land on a freehold basis).")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0417\u0435\u043C\u043B\u044F \u043F\u043E\u0434 \u0441\u0442\u0440\u043E\u0435\u043D\u0438\u0435\u043C \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u0432\u043E \u0432\u043B\u0430\u0434\u0435\u043D\u0438\u0435 \u043D\u0430 \u043F\u0440\u0430\u0432\u0430\u0445 \u0434\u043E\u043B\u0433\u043E\u0441\u0440\u043E\u0447\u043D\u043E\u0439 \u0430\u0440\u0435\u043D\u0434\u044B. \u041D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u0430 \u0433\u043E\u0441\u0443\u0434\u0430\u0440\u0441\u0442\u0432\u0435\u043D\u043D\u0430\u044F \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F \u0430\u0440\u0435\u043D\u0434\u043D\u044B\u0445 \u043F\u0440\u0430\u0432 (\u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u043C \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E\u043C \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u044B\u0439 \u0441\u0440\u043E\u043A \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0441\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 30 \u043B\u0435\u0442) \u0441 \u043F\u043E\u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u043C \u043F\u0440\u043E\u0434\u043B\u0435\u043D\u0438\u0435\u043C \u043D\u0430 \u043D\u043E\u0432\u044B\u0439 \u0441\u0440\u043E\u043A. \u041E\u0434\u043D\u0430\u043A\u043E \u0437\u0434\u0430\u043D\u0438\u044F \u0442\u0430\u0443\u043D\u0445\u0430\u0443\u0441\u043E\u0432 \u0438 \u0432\u0438\u043B\u043B \u043F\u0440\u043E\u0434\u0430\u044E\u0442\u0441\u044F \u0432 \u043F\u043E\u043B\u043D\u0443\u044E \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u044C."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0421\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C \u043F\u0440\u043E\u0434\u043B\u0435\u043D\u0438\u044F \u0430\u0440\u0435\u043D\u0434\u044B \u0437\u0435\u043C\u043B\u0438 \u0431\u0443\u0434\u0435\u0442 \u043F\u043E\u043A\u0440\u044B\u0432\u0430\u0442\u044C\u0441\u044F \u0437\u0430 \u0441\u0447\u0435\u0442 \u0430\u0440\u0435\u043D\u0434\u0430\u0442\u043E\u0440\u0430 \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u043E\u043C."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0421\u043E\u0433\u043B\u0430\u0441\u043D\u043E \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0443 \u0422\u0430\u0438\u043B\u0430\u043D\u0434\u0430 \u0438\u043D\u043E\u0441\u0442\u0440\u0430\u043D\u0446\u044B \u043C\u043E\u0433\u0443\u0442 \u043F\u0440\u0438\u043E\u0431\u0440\u0435\u0442\u0430\u0442\u044C \u0437\u0434\u0430\u043D\u0438\u044F, \u043F\u043E\u0441\u0442\u0440\u043E\u0435\u043D\u043D\u044B\u0435 \u043D\u0430 \u0430\u0440\u0435\u043D\u0434\u043E\u0432\u0430\u043D\u043D\u043E\u0439 \u0437\u0435\u043C\u043B\u0435, \u043D\u043E \u043D\u0435 \u0438\u043C\u0435\u044E\u0442 \u043F\u0440\u0430\u0432 \u043D\u0430 \u0432\u043B\u0430\u0434\u0435\u043D\u0438\u0435 \u0437\u0435\u043C\u043B\u0435\u0439. \u0417\u0435\u043C\u043B\u044F \u0431\u0443\u0434\u0435\u0442 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u0430 \u0434\u043B\u044F \u043F\u043E\u043A\u0443\u043F\u043A\u0438 \u0441 \u043F\u043E\u043B\u043D\u044B\u043C \u043F\u0440\u0430\u0432\u043E\u043C \u0432\u043B\u0430\u0434\u0435\u043D\u0438\u044F \u043B\u0438\u0446\u0430\u043C, \u044F\u0432\u043B\u044F\u044E\u0449\u0438\u043C\u0441\u044F \u0433\u0440\u0430\u0436\u0434\u0430\u043D\u0430\u043C\u0438 \u0422\u0430\u0438\u043B\u0430\u043D\u0434\u0430, \u043A\u043E\u0433\u0434\u0430 \u0440\u0430\u0437\u0434\u0435\u043B \u0437\u0435\u043C\u043B\u0438 \u0431\u0443\u0434\u0435\u0442 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041F\u0435\u0440\u0435\u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u0435 \u043F\u0440\u0430\u0432 \u0430\u0440\u0435\u043D\u0434\u044B \u043D\u0430 \u043F\u0440\u0430\u0432\u043E \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u0431\u0443\u0434\u0435\u0442 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E \u043F\u043E\u0441\u043B\u0435 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u0440\u0430\u0437\u0434\u0435\u043B\u0430 \u0437\u0435\u043C\u0435\u043B\u044C\u043D\u044B\u0445 \u0443\u0447\u0430\u0441\u0442\u043A\u043E\u0432 \u043F\u0440\u0438 \u0443\u0441\u043B\u043E\u0432\u0438\u0438, \u0447\u0442\u043E \u0430\u0440\u0435\u043D\u0434\u0430\u0442\u043E\u0440 \u0438\u043C\u0435\u0435\u0442 \u043F\u0440\u0430\u0432\u043E \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u0437\u0430\u043A\u043E\u043D\u0430\u043C\u0438 \u0438 \u043D\u043E\u0440\u043C\u0430\u0442\u0438\u0432\u043D\u044B\u043C\u0438 \u043F\u0440\u0430\u0432\u043E\u0432\u044B\u043C\u0438 \u0430\u043A\u0442\u0430\u043C\u0438 \u0422\u0430\u0438\u043B\u0430\u043D\u0434\u0430 \u043F\u0440\u0438\u043D\u0438\u043C\u0430\u0442\u044C \u043F\u0435\u0440\u0435\u0434\u0430\u0447\u0443 \u0437\u0435\u043C\u043B\u0438 \u0438 \u0432\u043B\u0430\u0434\u0435\u0442\u044C \u0437\u0435\u043C\u043B\u0435\u0439 (\u0432 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0435 \u0432\u0440\u0435\u043C\u044F \u043B\u0438\u0446\u0430\u043C, \u043D\u0435 \u044F\u0432\u043B\u044F\u044E\u0449\u0438\u043C\u0441\u044F \u0433\u0440\u0430\u0436\u0434\u0430\u043D\u0430\u043C\u0438 \u0422\u0430\u0438\u043B\u0430\u043D\u0434\u0430, \u0437\u0430\u043F\u0440\u0435\u0449\u0435\u043D\u043E \u043F\u0440\u0438\u043E\u0431\u0440\u0435\u0442\u0430\u0442\u044C \u0437\u0435\u043C\u043B\u044E \u043D\u0430 \u043F\u0440\u0430\u0432\u0430\u0445 \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438).")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u571F\u5730\u51FA\u552E\u57FA\u4E8E\u79DF\u8D41\u6240\u6709\u6743\u3002\u7269\u4E1A\u79DF\u8D41\u53CA\u7EED\u79DF\u9700\u8981\u901A\u8FC7\u653F\u5E9C\u90E8\u95E8\u6CE8\u518C\u3002(\u6839\u636E\u6CF0\u56FD\u6CD5\u5F8B\uFF0C\u76EE\u524D \u6CD5\u5F8B\u89C4\u5B9A\u6700\u591A 30 \u5E74\u7684\u79DF\u8D41\u671F)\u3002\u4F46\u662F\u623F\u5C4B\u5EFA\u7B51\u90E8\u5206\u4F5C\u4E3A\u6C38\u4E45\u4EA7\u6743\u51FA\u552E\u3002 \u7EED\u7B7E\u79DF\u8D41\u6240\u6709\u6743 \u7684\u8D39\u7528\u5C06\u6839\u636E\u5408\u540C\u7531\u627F\u79DF\u4EBA\u627F\u62C5\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u6839\u636E\u73B0\u6709\u6CF0\u56FD\u6CD5\u5F8B\uFF0C\u5916\u7C4D\u4E1A\u4E3B\u53EF\u80FD\u83B7\u5F97\u5728\u5176\u79DF\u8D41\u571F\u5730\u4E0A\u6240\u5F00\u53D1\u5EFA\u7B51\u7269\u7684\u6240\u6709\u6743\uFF0C\u4F46\u6CA1\u6709\u571F\u5730 \u672C\u8EAB\u7684\u6240\u6709\u6743\u3002\u5728\u571F\u5730\u7EC6\u5206\u5B8C\u6210\u540E\uFF0C\u6CF0\u56FD\u4E1A\u4E3B\u53EF\u4EE5\u62E5\u6709\u5BF9\u571F\u5730\u7684\u6240\u6709\u6743\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u5728\u571F\u5730\u7EC6\u5206\u5B8C\u6210\u540E\uFF0C\u82E5\u6CF0\u56FD\u76F8\u5173\u6CD5\u5F8B\u6CD5\u89C4\u53D8\u66F4\u5141\u8BB8\u627F\u79DF\u4EBA\u62E5\u6709\u571F\u5730\uFF0C\u5219\u53EF\u5B9E\u73B0\u79DF\u8D41\u6743\u81F3\u6C38\u4E45 \u4EA7\u6743\u7684\u5347\u7EA7\u3002(\u76EE\u524D\uFF0C\u6CF0\u56FD\u7981\u6B62\u975E\u6CF0\u56FD\u4EBA\u4EE5\u6C38\u4E45\u4EA7\u6743\u7684\u65B9\u5F0F\u83B7\u5F97\u571F\u5730)\u3002"))}},{categoryId:1,question:{en:"What are the costs associated with the lease / freehold registration?",ru:"Каковы затраты, связанные с арендой / регистрацией собственности?",cn:"租赁产权/永久产权登记的相关费用如何?"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"These are outlined below:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Leasehold land"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Lease registration fees and stamp duty (currently 1.1% of the rental or lease premium) is payable to the Land Department upon registration of the lease.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Freehold buildings"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Freehold registration fee (currently 2% of the appraisal price of building) is payable to the Land Department upon transfer and registration of ownership of the buildings. The appraisal price is calculated relative to the government\u2019s tax assessment value. Other applicable taxes upon transfer and registration of ownership of the freehold buildings are:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"white-circle"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Corporate Income Tax")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"(Currently 1.0% of the selling price or appraisal price, whichever is higher)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"white-circle"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Special Business Tax")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"(Currently 3.3% of the selling price or appraisal price, whichever is higher)")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"The burden between the seller and the purchaser for the above costs will be specified in the Lease and/or Sale & Purchase Agreements."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"Note: Applicable registration fees and tax rates are current but may be subject to change by the relevant Thai authorities.")))),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041E\u043D\u0438 \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u044B \u043D\u0438\u0436\u0435:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F \u043F\u0440\u0430\u0432 \u0430\u0440\u0435\u043D\u0434\u044B \u043D\u0430 \u0437\u0435\u043C\u043B\u044E"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041F\u0440\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430 \u0430\u0440\u0435\u043D\u0434\u044B \u0432 \u0417\u0435\u043C\u0435\u043B\u044C\u043D\u043E\u043C \u0434\u0435\u043F\u0430\u0440\u0442\u0430\u043C\u0435\u043D\u0442\u0435 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u043E\u043F\u043B\u0430\u0442\u0438\u0442\u044C \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0435 \u0441\u0431\u043E\u0440\u044B \u0438 \u043F\u043E\u0448\u043B\u0438\u043D\u044B (\u0432 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0435 \u0432\u0440\u0435\u043C\u044F 1,1 % \u043E\u0442 \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u0438 \u0430\u0440\u0435\u043D\u0434\u044B \u0438\u043B\u0438 \u043F\u0440\u0435\u043C\u0438\u0430\u043B\u044C\u043D\u043E\u0439 \u043D\u0430\u0434\u0431\u0430\u0432\u043A\u0438).")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F \u043F\u0440\u0430\u0432 \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u043D\u0430 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u044C/\u0437\u0435\u043C\u043B\u044E"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041F\u0440\u0438 \u043F\u0435\u0440\u0435\u0434\u0430\u0447\u0435 \u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u043F\u0440\u0430\u0432\u0430 \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u043D\u0430 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u044C \u0432 \u0417\u0435\u043C\u0435\u043B\u044C\u043D\u044B\u0439 \u0434\u0435\u043F\u0430\u0440\u0442\u0430\u043C\u0435\u043D\u0442 \u043E\u043F\u043B\u0430\u0447\u0438\u0432\u0430\u0435\u0442\u0441\u044F \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u0432\u0437\u043D\u043E\u0441 (2 % \u043E\u0442 \u043E\u0446\u0435\u043D\u043E\u0447\u043D\u043E\u0439 \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u0438 \u043E\u0431\u044A\u0435\u043A\u0442\u0430). \u041E\u0446\u0435\u043D\u043E\u0447\u043D\u0430\u044F \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C \u043E\u0431\u044B\u0447\u043D\u043E \u0440\u0430\u0441\u0441\u0447\u0438\u0442\u044B\u0432\u0430\u0435\u0442\u0441\u044F \u043E\u0442\u043D\u043E\u0441\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0437\u043D\u0430\u0447\u0435\u043D\u0438\u044F \u0434\u043B\u044F \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438\u044F \u043D\u0430\u043B\u043E\u0433\u043E\u0432\u043E\u0439 \u0431\u0430\u0437\u044B, \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u043E\u0439 \u043F\u0440\u0430\u0432\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E\u043C. \u041A\u0430\u043A \u043F\u0440\u0430\u0432\u0438\u043B\u043E, \u043E\u043D\u0430 \u0437\u043D\u0430\u0447\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u043D\u0438\u0436\u0435 \u0440\u044B\u043D\u043E\u0447\u043D\u043E\u0439 \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u0438 \u043E\u0431\u044A\u0435\u043A\u0442\u0430. \u041A \u0434\u0440\u0443\u0433\u0438\u043C \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u043C \u043D\u0430\u043B\u043E\u0433\u0430\u043C \u043D\u0430 \u043F\u0435\u0440\u0435\u0434\u0430\u0447\u0443 \u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044E \u043F\u0440\u0430\u0432\u0430 \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u043E\u0442\u043D\u043E\u0441\u044F\u0442\u0441\u044F \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0435:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"white-circle"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u041D\u0430\u043B\u043E\u0433 \u043D\u0430 \u0434\u043E\u0445\u043E\u0434\u044B \u044E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u0438\u0445 \u043B\u0438\u0446")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"(\u0432 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0435 \u0432\u0440\u0435\u043C\u044F \u0441\u0442\u0430\u0432\u043A\u0430 \u0441\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 1,0 % \u043E\u0442 \u0446\u0435\u043D\u044B \u043F\u0440\u043E\u0434\u0430\u0436\u0438 \u0438\u043B\u0438 \u043E\u0446\u0435\u043D\u043E\u0447\u043D\u043E\u0439 \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u0438, \u0432 \u0437\u0430\u0432\u0438\u0441\u0438\u043C\u043E\u0441\u0442\u0438 \u043E\u0442 \u0442\u043E\u0433\u043E, \u043A\u0430\u043A\u0430\u044F \u0438\u0437 \u043D\u0438\u0445 \u0432\u044B\u0448\u0435)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"white-circle"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u0421\u043F\u0435\u0446\u0438\u0430\u043B\u044C\u043D\u044B\u0439 \u043D\u0430\u043B\u043E\u0433 \u043D\u0430 \u043F\u0440\u0438\u0431\u044B\u043B\u044C")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"(\u0432 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0435 \u0432\u0440\u0435\u043C\u044F \u0441\u0442\u0430\u0432\u043A\u0430 \u0441\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 3,3 % \u043E\u0442 \u0446\u0435\u043D\u044B \u043F\u0440\u043E\u0434\u0430\u0436\u0438 \u0438\u043B\u0438 \u043E\u0446\u0435\u043D\u043E\u0447\u043D\u043E\u0439 \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u0438, \u0432 \u0437\u0430\u0432\u0438\u0441\u0438\u043C\u043E\u0441\u0442\u0438 \u043E\u0442 \u0442\u043E\u0433\u043E, \u043A\u0430\u043A\u0430\u044F \u0438\u0437 \u043D\u0438\u0445 \u0432\u044B\u0448\u0435)")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0430 \u0438 \u043F\u043E\u043A\u0443\u043F\u0430\u0442\u0435\u043B\u044F \u0432 \u043E\u0442\u043D\u043E\u0448\u0435\u043D\u0438\u0438 \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0445 \u0432\u044B\u0448\u0435 \u0440\u0430\u0441\u0445\u043E\u0434\u043E\u0432 \u043E\u043F\u0438\u0441\u044B\u0432\u0430\u044E\u0442\u0441\u044F \u0432 \u0441\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0438 \u043E\u0431 \u0430\u0440\u0435\u043D\u0434\u0435 \u0438 (\u0438\u043B\u0438) \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0435 \u043A\u0443\u043F\u043B\u0435-\u043F\u0440\u043E\u0434\u0430\u0436\u0438."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"\u041F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0435: \u0412 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u043C \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0435 \u043F\u0440\u0438\u0432\u0435\u0434\u0435\u043D\u044B \u043F\u0440\u0438\u043C\u0435\u043D\u0438\u043C\u044B\u0435 \u0442\u0435\u043A\u0443\u0449\u0438\u0435 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0435 \u0441\u0431\u043E\u0440\u044B \u0438 \u043D\u0430\u043B\u043E\u0433\u043E\u0432\u044B\u0435 \u0441\u0442\u0430\u0432\u043A\u0438, \u043D\u043E \u043E\u043D\u0438 \u043C\u043E\u0433\u0443\u0442 \u0431\u044B\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u044B \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u043C\u0438 \u0433\u043E\u0441\u0443\u0434\u0430\u0440\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u043C\u0438 \u043E\u0440\u0433\u0430\u043D\u0430\u043C\u0438 \u0422\u0430\u0438\u043B\u0430\u043D\u0434\u0430.")))),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u5177\u4F53\u6761\u6B3E\u5982\u4E0B:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u79DF\u8D41\u4EA7\u6743\u571F\u5730"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u79DF\u8D41\u4EA7\u6743\u767B\u8BB0\u8D39\u548C\u5370\u82B1\u7A0E(\u73B0\u4E3A\u5730\u79DF\u6216\u79DF\u8D41\u4F7F\u7528\u8D39\u76841.1%)\u987B\u5728\u767B\u8BB0\u65F6\u5411\u56FD\u571F\u8D44\u6E90\u90E8\u7F34\u7EB3\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u6C38\u4E45\u4EA7\u6743\u5EFA\u7B51"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u6C38\u4E45\u4EA7\u6743\u767B\u8BB0\u8D39(\u73B0\u4E3A\u7269\u4E1A\u4F30\u4EF7\u76842%)\u987B\u5728\u8F6C\u8BA9\u548C\u767B\u8BB0\u5EFA\u7B51\u4EA7\u6743\u65F6\u5411\u56FD\u571F\u8D44\u6E90\u90E8\u7F34\u7EB3\u3002\u4F30\u4EF7\u6839 \u636E\u653F\u5E9C\u7684\u7A0E\u52A1\u8BC4\u4F30\u503C\u8BA1\u7B97\u5F97\u51FA\u3002\u8F6C\u8BA9\u548C\u767B\u8BB0\u6C38\u4E45\u4EA7\u6743\u5EFA\u7B51\u65F6\u9002\u7528\u7684\u5176\u4ED6\u7A0E\u9879\u6709:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{classNme:"white-circle"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u4F01\u4E1A\u6240\u5F97\u7A0E")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"(\u73B0\u4E3A\u552E\u4EF7\u6216\u4F30\u4EF7\u76841.0%\uFF0C\u4EE5\u8F83\u9AD8\u8005\u4E3A\u51C6)\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{classNme:"white-circle"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u7279\u522B\u8425\u4E1A\u7A0E")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"(\u73B0\u4E3A\u552E\u4EF7\u6216\u4F30\u4EF7\u76843.3%\uFF0C\u4EE5\u8F83\u9AD8\u8005\u4E3A\u51C6)\u3002")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u4E0A\u8FF0\u8D39\u7528\u4E2D\uFF0C\u4E70\u5356\u53CC\u65B9\u5404\u81EA\u627F\u62C5\u7684\u8D39\u7528\u5C06\u5728\u79DF\u8D41\u548C/\u6216\u4E70\u5356\u534F\u8BAE\u4E2D\u8BE6\u7EC6\u8BF4\u660E\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"\u5907\u6CE8: \u8BF7\u6CE8\u610F\uFF0C\u6B64\u5904\u7684\u767B\u8BB0\u8D39\u4EE5\u53CA\u67D0\u4E9B\u9002\u7528\u7A0E\u7387\u9002\u7528\u4E8E\u73B0\u5728\uFF0C\u6839\u636E\u76F8\u5173\u6CF0\u56FD\u6CD5\u5F8B\u6709\u968F\u65F6\u66F4\u6539\u7684\u53EF\u80FD\u3002"))))}},{categoryId:1,question:{en:"Is leasehold land transferable?",ru:"Возможна ли передача прав аренды земельного участка?",cn:"租赁产权的土地可以转让吗?"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Yes. Leasehold land may be transferred subject to the terms and conditions of the lease agreement. Generally, a small fee is payable. In addition, the new owner must agree to be bound by the terms and conditions contained in the original lease agreement.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0414\u0430. \u0410\u0440\u0435\u043D\u0434\u043E\u0432\u0430\u043D\u043D\u0430\u044F \u0437\u0435\u043C\u043B\u044F \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u043F\u0435\u0440\u0435\u0434\u0430\u043D\u0430 \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u044F\u043C\u0438 \u0438 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u043C\u0438 \u0441\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F. \u041A\u0430\u043A \u043F\u0440\u0430\u0432\u0438\u043B\u043E, \u043F\u0440\u0438 \u044D\u0442\u043E\u043C \u043F\u043B\u0430\u0442\u0438\u0442\u0441\u044F \u043F\u043E\u0448\u043B\u0438\u043D\u0430. \u041A\u0440\u043E\u043C\u0435 \u0442\u043E\u0433\u043E, \u043F\u0440\u0430\u0432\u043E\u043F\u0440\u0435\u0435\u043C\u043D\u0438\u043A \u0434\u043E\u043B\u0436\u0435\u043D \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u0442\u044C\u0441\u044F \u0441\u043E\u0431\u043B\u044E\u0434\u0430\u0442\u044C \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u044F \u0438 \u0443\u0441\u043B\u043E\u0432\u0438\u044F, \u0441\u043E\u0434\u0435\u0440\u0436\u0430\u0449\u0438\u0435\u0441\u044F \u0432 \u043F\u0435\u0440\u0432\u043E\u043D\u0430\u0447\u0430\u043B\u044C\u043D\u043E\u043C \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0435 \u0430\u0440\u0435\u043D\u0434\u044B.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u79DF\u8D41\u4EA7\u6743\u7684\u571F\u5730\u53EF\u4EE5\u6839\u636E\u534F\u8BAE\u7684\u6761\u6B3E\u548C\u6761\u4EF6\u8FDB\u884C\u8F6C\u8BA9\u3002 \u901A\u5E38\u9700\u652F\u4ED8\u5C11\u989D\u8D39\u7528\u3002\u6B64\u5916\uFF0C\u65B0\u4E1A\u4E3B\u5FC5\u987B\u540C\u610F\u63A5\u53D7\u539F\u79DF\u8D41\u534F\u8BAE\u4E2D\u6240\u542B\u7684\u6761\u6B3E\u548C\u6761\u4EF6\u3002"))}},{categoryId:1,question:{en:"Is leasehold land ownership secure?",ru:"Как обеспечивается безопасность аренды земельного владения?",cn:"土地的租赁产权是否安全?"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Leasehold land ownership is the preferred method of ownership for non-Thais. Once the lease is registered at the Land Department, the owner\u2019s rights to the land will be officially recognized.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0412\u043B\u0430\u0434\u0435\u043D\u0438\u0435 \u043D\u0430 \u043F\u0440\u0430\u0432\u0430\u0445 \u0430\u0440\u0435\u043D\u0434\u044B \u0437\u0435\u043C\u043B\u0438 \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u043F\u0440\u0435\u0434\u043F\u043E\u0447\u0442\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u043C \u043C\u0435\u0442\u043E\u0434\u043E\u043C \u0432\u043B\u0430\u0434\u0435\u043D\u0438\u044F \u0434\u043B\u044F \u043B\u0438\u0446, \u043D\u0435 \u044F\u0432\u043B\u044F\u044E\u0449\u0438\u0445\u0441\u044F \u0433\u0440\u0430\u0436\u0434\u0430\u043D\u0430\u043C\u0438 \u0422\u0430\u0438\u043B\u0430\u043D\u0434\u0430. \u0410\u0440\u0435\u043D\u0434\u0430\u0442\u043E\u0440\u0443 \u043F\u0435\u0440\u0435\u0445\u043E\u0434\u044F\u0442 \u043F\u0440\u0430\u0432\u0430 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0437\u0435\u043C\u043B\u0435\u0439 \u0441\u0440\u0430\u0437\u0443 \u043F\u0440\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430 \u0432 \u0417\u0435\u043C\u0435\u043B\u044C\u043D\u043E\u043C \u0434\u0435\u043F\u0430\u0440\u0442\u0430\u043C\u0435\u043D\u0442\u0435.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u571F\u5730\u7684\u79DF\u8D41\u4EA7\u6743\u662F\u63D0\u4F9B\u7ED9\u975E\u6CF0\u56FD\u4E1A\u4E3B\u7684\u6700\u4F73\u4EA7\u6743\u65B9\u5F0F\u3002\u4E00\u65E6\u79DF\u8D41\u4EA7\u6743\u5728\u56FD\u571F\u8D44\u6E90\u90E8\u767B\u8BB0\u540E\uFF0C\u4E1A \u4E3B\u5BF9\u571F\u5730\u7684\u6743\u5229\u5C06\u5F97\u5230\u6B63\u5F0F\u8BA4\u53EF\u3002"))}},{categoryId:1,question:{en:"When will the lease / house transfer registration take place?",ru:"Когда будет проходить процесс регистрации прав аренды / передачи дома?",cn:"何时进行租赁/房屋转交登记?"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Approximately 90 days after full payment has been received and construction is complete. We will notify the owner of any documents and fees required for registration.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041F\u0440\u0438\u043C\u0435\u0440\u043D\u043E \u0447\u0435\u0440\u0435\u0437 90 \u0434\u043D\u0435\u0439 \u043F\u043E\u0441\u043B\u0435 \u043E\u043F\u043B\u0430\u0442\u044B \u043F\u043E\u043B\u043D\u043E\u0439 \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u0438 \u0438 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 \u043E\u0431\u044A\u0435\u043A\u0442\u0430 \u043C\u044B \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u0438\u043C \u043F\u043E\u043A\u0443\u043F\u0430\u0442\u0435\u043B\u044E \u0441\u043F\u0438\u0441\u043E\u043A \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u044B\u0445 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432 \u0438 \u0441\u0431\u043E\u0440\u043E\u0432, \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u044B\u0445 \u0434\u043B\u044F \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u6536\u5230\u5168\u989D\u4ED8\u6B3E\u540E\u7EA690\u5929\uFF0C\u4E14\u9879\u76EE\u4E2D\u6240\u6709\u5EFA\u7B51\u7684\u65BD\u5DE5\u5B8C\u6210\u540E\uFF0C\u6211\u4EEC\u4F1A\u544A\u77E5\u4E1A\u4E3B\u767B\u8BB0\u6240\u9700\u7684\u6240\u6709 \u6587\u4EF6\u548C\u8D39\u7528\u3002"))}},{categoryId:1,question:{en:"Should I appoint a lawyer to review the agreements?",ru:"Должен ли я нанять адвоката для проверки соглашений?",cn:"我是否应该委托律师审核协议?"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Our agreements have been used for a number of years and have been reviewed by major international law firms. We have our own in-house legal team which will assist to clarify any questions you may have concerning the agreements. However, should you wish to obtain specific advice regarding the structuring of your investment, we recommend you consult with a professional legal and/or financial adviser.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041D\u0430\u0448\u0438 \u0441\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u044E\u0442\u0441\u044F \u0443\u0436\u0435 \u043C\u043D\u043E\u0433\u043E \u043B\u0435\u0442 \u0438 \u043F\u0440\u043E\u0448\u043B\u0438 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0443 \u043A\u0440\u0443\u043F\u043D\u044B\u043C\u0438 \u043C\u0435\u0436\u0434\u0443\u043D\u0430\u0440\u043E\u0434\u043D\u044B\u043C\u0438 \u044E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u0438\u043C\u0438 \u0444\u0438\u0440\u043C\u0430\u043C\u0438. \u0423 \u043D\u0430\u0441 \u0435\u0441\u0442\u044C \u0441\u0432\u043E\u0438 \u044E\u0440\u0438\u0441\u0442\u044B, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u043C\u043E\u0433\u0443\u0442 \u043E\u0442\u0432\u0435\u0442\u0438\u0442\u044C \u043D\u0430 \u043B\u044E\u0431\u044B\u0435 \u0432\u0430\u0448\u0438 \u0432\u043E\u043F\u0440\u043E\u0441\u044B \u043F\u043E \u0441\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F\u043C. \u041E\u0434\u043D\u0430\u043A\u043E, \u0435\u0441\u043B\u0438 \u0432\u044B \u0445\u043E\u0442\u0438\u0442\u0435 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u043A\u043E\u043D\u043A\u0440\u0435\u0442\u043D\u044B\u0435 \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0430\u0446\u0438\u0438 \u043F\u043E \u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044E \u0438\u043D\u0432\u0435\u0441\u0442\u0438\u0446\u0438\u0439, \u043C\u044B \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u043C \u043F\u0440\u043E\u043A\u043E\u043D\u0441\u0443\u043B\u044C\u0442\u0438\u0440\u043E\u0432\u0430\u0442\u044C\u0441\u044F \u0441 \u043F\u0440\u043E\u0444\u0435\u0441\u0441\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u044B\u043C \u044E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u0438\u043C \u0438 (\u0438\u043B\u0438) \u0444\u0438\u043D\u0430\u043D\u0441\u043E\u0432\u044B\u043C \u043A\u043E\u043D\u0441\u0443\u043B\u044C\u0442\u0430\u043D\u0442\u043E\u043C.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u6211\u4EEC\u7684\u534F\u8BAE\u5DF2\u7ECF\u4F7F\u7528\u591A\u5E74\uFF0C\u5E76\u4E14\u5DF2\u901A\u8FC7\u5404\u5927\u56FD\u9645\u5F8B\u5E08\u4E8B\u52A1\u6240\u7684\u5BA1\u6838\u3002\u6211\u4EEC\u62E5\u6709\u81EA\u5DF1\u7684\u5185\u90E8\u6CD5\u5F8B \u56E2\u961F\uFF0C\u53EF\u4EE5\u534F\u52A9\u89E3\u7B54\u60A8\u5BF9\u534F\u8BAE\u7684\u4EFB\u4F55\u7591\u95EE\u3002\u4F46\u662F\uFF0C\u5982\u679C\u60A8\u5E0C\u671B\u83B7\u5F97\u5173\u4E8E\u6295\u8D44\u7684\u8BE6\u7EC6\u800C\u5177\u4F53\u7684\u610F \u89C1\uFF0C\u5EFA\u8BAE\u60A8\u54A8\u8BE2\u4E13\u4E1A\u6CD5\u5F8B\u548C/\u6216\u8D22\u52A1\u987E\u95EE\u3002"))}},{categoryId:1,question:{en:"What is the measurement of square wah?",ru:"Что такое квадратный ваа?",cn:"平方瓦(wah)是什么度量单位?"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Our agreements indicate the property\u2019s areas with land measurement under the Thai system set by the Land Department. The most commonly used land measurements are as follows:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"One rai equals 1,600 square meters"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"One ngan equals 400 square meters"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"One square wah equals 4 square meters"))),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041C\u044B \u043E\u0431\u044F\u0437\u0430\u043D\u044B \u0443\u043A\u0430\u0437\u044B\u0432\u0430\u0442\u044C \u043F\u043B\u043E\u0449\u0430\u0434\u044C \u0437\u0435\u043C\u0435\u043B\u044C\u043D\u044B\u0445 \u0443\u0447\u0430\u0441\u0442\u043A\u043E\u0432 \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u0442\u0430\u0439\u0441\u043A\u043E\u0439 \u0441\u0438\u0441\u0442\u0435\u043C\u043E\u0439 \u0438\u0437\u043C\u0435\u0440\u0435\u043D\u0438\u044F, \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u043E\u0439 \u0417\u0435\u043C\u0435\u043B\u044C\u043D\u044B\u043C \u0434\u0435\u043F\u0430\u0440\u0442\u0430\u043C\u0435\u043D\u0442\u043E\u043C. \u041D\u0430\u0438\u0431\u043E\u043B\u0435\u0435 \u0447\u0430\u0441\u0442\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u0442\u0441\u044F \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0430\u044F \u0441\u0438\u0441\u0442\u0435\u043C\u0430 \u0438\u0437\u043C\u0435\u0440\u0435\u043D\u0438\u044F:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u041E\u0434\u0438\u043D \u0440\u0430\u0439 \u0440\u0430\u0432\u0435\u043D 1600 \u043A\u0432\u0430\u0434\u0440\u0430\u0442\u043D\u044B\u043C \u043C\u0435\u0442\u0440\u0430\u043C"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u041E\u0434\u0438\u043D \u043D\u0433\u0430\u043D \u0440\u0430\u0432\u0435\u043D 400 \u043A\u0432\u0430\u0434\u0440\u0430\u0442\u043D\u044B\u043C \u043C\u0435\u0442\u0440\u0430\u043C"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u041E\u0434\u0438\u043D \u043A\u0432\u0430\u0434\u0440\u0430\u0442\u043D\u044B\u0439 \u0432\u0430\u0430 \u0440\u0430\u0432\u0435\u043D 4 \u043A\u0432\u0430\u0434\u0440\u0430\u0442\u043D\u044B\u043C \u043C\u0435\u0442\u0440\u0430\u043C"))),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u6211\u4EEC\u7684\u534F\u8BAE\u4F9D\u7167\u56FD\u571F\u8D44\u6E90\u90E8\u5236\u5B9A\u7684\u6CF0\u5236\u571F\u5730\u5EA6\u91CF\u5355\u4F4D\u6765\u8868\u793A\u7269\u4E1A\u7684\u9762\u79EF\u3002\u6700\u5E38\u7528\u7684\u571F\u5730\u5EA6\u91CF\u5355 \u4F4D\u5982\u4E0B:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"1 \u83B1(rai)\u7B49\u4E8E 1,600 \u5E73\u65B9\u7C73"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"1 \u5E72(ngan)\u7B49\u4E8E 400 \u5E73\u65B9\u7C73"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"1 \u5E73\u65B9\u74E6(wah)\u7B49\u4E8E 4 \u5E73\u65B9\u7C73")))}},{categoryId:2,question:{en:"What types of visas are available for foreigners to stay in Thailand?",ru:"Какие типы виз доступны иностранцам для пребывания в Таиланде?",cn:"外籍人士将能获得何种泰国居留签证?"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"There are various forms of visas available to foreigners who wish to enter Thailand for study, business, investment, retirement and other purposes ranging from 90 days to 1 year multiple entry which include."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Education visa when enrolled at registered education institution within Thailand"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Business visa when operating a business or employed"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Retirement visa for people aged 50 years or over and meet financial requirements"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Marriage visa for foreigners married to a Thai"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Thailand Elite Visa - a government led program offering memberships including 5 year visas and other privileges"))),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0421\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u044E\u0442 \u0440\u0430\u0437\u043B\u0438\u0447\u043D\u044B\u0435 \u0444\u043E\u0440\u043C\u044B \u0432\u0438\u0437, \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B\u0445 \u0434\u043B\u044F \u0438\u043D\u043E\u0441\u0442\u0440\u0430\u043D\u0446\u0435\u0432, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u0445\u043E\u0442\u044F\u0442 \u043F\u0440\u0438\u0435\u0445\u0430\u0442\u044C \u0432 \u0422\u0430\u0438\u043B\u0430\u043D\u0434 \u0434\u043B\u044F \u0443\u0447\u0435\u0431\u044B, \u0432\u0435\u0434\u0435\u043D\u0438\u044F \u0431\u0438\u0437\u043D\u0435\u0441\u0430, \u0438\u043D\u0432\u0435\u0441\u0442\u0438\u0446\u0438\u0439, \u0432\u044B\u0445\u043E\u0434\u0430 \u043D\u0430 \u043F\u0435\u043D\u0441\u0438\u044E \u0438 \u0434\u0440\u0443\u0433\u0438\u0445 \u0446\u0435\u043B\u0435\u0439 \u043D\u0430 \u0441\u0440\u043E\u043A \u043E\u0442 90 \u0434\u043D\u0435\u0439 \u0434\u043E 1 \u0433\u043E\u0434\u0430 \u0441 \u043C\u043D\u043E\u0433\u043E\u043A\u0440\u0430\u0442\u043D\u044B\u043C \u0432\u044A\u0435\u0437\u0434\u043E\u043C. \u041A \u0442\u0430\u043A\u0438\u043C \u0432\u0438\u0437\u0430\u043C \u043E\u0442\u043D\u043E\u0441\u044F\u0442\u0441\u044F \u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u0435:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u041E\u0431\u0440\u0430\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u043D\u0430\u044F \u0432\u0438\u0437\u0430 \u043F\u0440\u0438 \u043F\u043E\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u0438 \u0432 \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0435 \u0443\u0447\u0435\u0431\u043D\u043E\u0435 \u0437\u0430\u0432\u0435\u0434\u0435\u043D\u0438\u0435 \u0432 \u0422\u0430\u0438\u043B\u0430\u043D\u0434\u0435;"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u0414\u0435\u043B\u043E\u0432\u0430\u044F \u0432\u0438\u0437\u0430 \u0434\u043B\u044F \u0432\u0435\u0434\u0435\u043D\u0438\u044F \u0431\u0438\u0437\u043D\u0435\u0441\u0430 \u0438\u043B\u0438 \u0440\u0430\u0431\u043E\u0447\u0438\u0445 \u0446\u0435\u043B\u0435\u0439;"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u041F\u0435\u043D\u0441\u0438\u043E\u043D\u043D\u0430\u044F \u0432\u0438\u0437\u0430 \u0434\u043B\u044F \u043B\u044E\u0434\u0435\u0439 \u0432 \u0432\u043E\u0437\u0440\u0430\u0441\u0442\u0435 50\u043B\u0435\u0442 \u0438 \u0441\u0442\u0430\u0440\u0448\u0435, \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0445 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u043D\u044B\u043C \u0444\u0438\u043D\u0430\u043D\u0441\u043E\u0432\u044B\u043C \u0442\u0440\u0435\u0431\u043E\u0432\u0430\u043D\u0438\u044F\u043C;"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u0411\u0440\u0430\u0447\u043D\u0430\u044F \u0432\u0438\u0437\u0430 \u0434\u043B\u044F \u0438\u043D\u043E\u0441\u0442\u0440\u0430\u043D\u0446\u0435\u0432, \u0441\u043E\u0441\u0442\u043E\u044F\u0449\u0438\u0445 \u0432 \u0431\u0440\u0430\u043A\u0435 \u0441 \u0433\u0440\u0430\u0436\u0434\u0430\u043D\u0438\u043D\u043E\u043C/\u0433\u0440\u0430\u0436\u0434\u0430\u043D\u043A\u043E\u0439 \u0422\u0430\u0438\u043B\u0430\u043D\u0434\u0430;"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Thailand Elite Visa \u2013 \u043F\u0440\u0430\u0432\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0435\u043D\u043D\u0430\u044F \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0430 \u0447\u043B\u0435\u043D\u0441\u0442\u0432\u0430, \u043F\u0440\u0435\u0434\u043B\u0430\u0433\u0430\u044E\u0449\u0430\u044F, \u0432 \u0442\u043E\u043C \u0447\u0438\u0441\u043B\u0435, \u0432\u0438\u0437\u044B \u043D\u0430 5 \u043B\u0435\u0442 \u0438 \u0434\u0440\u0443\u0433\u0438\u0435 \u043F\u0440\u0438\u0432\u0438\u043B\u0435\u0433\u0438\u0438."))),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u5BF9\u4E8E\u5E0C\u671B\u524D\u5F80\u6CF0\u56FD\u5B66\u4E60,\u51FA\u5DEE,\u6295\u8D44,\u4EAB\u53D7\u9000\u4F11\u751F\u6D3B\u6216\u56E0\u5176\u4ED6\u76EE\u7684\u524D\u5F80\u6CF0\u56FD\u7684\u5916\u7C4D\u4EBA\u58EB\uFF0C\u5F53\u5C40\u63D0\u4F9B\u591A \u79CD\u5F62\u5F0F\u4E14\u671F\u9650\u4ECB\u4E8E 90 \u5929\u81F3 1 \u5E74\u7684\u591A\u6B21\u5165\u5883\u7B7E\u8BC1\uFF0C\u5176\u4E2D\u5305\u62EC:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u6559\u80B2\u7B7E\u8BC1\uFF0C"),"\u9002\u7528\u4E8E\u5C31\u8BFB\u4E8E\u6CF0\u56FD\u6CE8\u518C\u6559\u80B2\u673A\u6784\u7684\u4EBA\u58EB"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u5546\u52A1\u7B7E\u8BC1\uFF0C"),"\u9002\u7528\u4E8E\u7ECF\u8425\u516C\u53F8\u7684\u4EBA\u58EB\u6216\u96C7\u5458"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u9000\u4F11\u7B7E\u8BC1\uFF0C"),"\u9002\u7528\u4E8E\u5E74\u6EE1 50 \u5C81\u4E14\u7B26\u5408\u8D22\u52A1\u8981\u6C42\u7684\u4EBA\u58EB"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u7ED3\u5A5A\u7B7E\u8BC1\uFF0C"),"\u9002\u7528\u4E8E\u4E0E\u6CF0\u56FD\u4EBA\u7ED3\u5A5A\u7684\u5916\u7C4D\u4EBA\u58EB"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u6CF0\u56FD\u7CBE\u82F1\u7B7E\u8BC1\uFF0C"),"\u4E00\u9879\u7531\u653F\u5E9C\u5F15\u5BFC\u7684\u8BA1\u5212\uFF0C\u63D0\u4F9B\u5305\u62EC 5 \u5E74\u7B7E\u8BC1\u548C\u5176\u4ED6\u7279\u6743 \u5982\u9700\u4E86\u89E3\u66F4\u591A\u4FE1\u606F\uFF0C\u8BF7\u54A8\u8BE2\u79FB\u6C11\u4E13\u5BB6\u6216\u6CF0\u56FD\u5927\u4F7F\u9986/\u9886\u4E8B\u9986\u3002")))}},///////////////////////////
{categoryId:2,question:{en:"What is the project area?",ru:"此项目占地多大？",cn:"Какая площадь проекта?"},displayOn:["en"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Phase 1 is a total area of approximately 6 rai (10,000 m2).")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041E\u0431\u0449\u0430\u044F \u043F\u043B\u043E\u0449\u0430\u0434\u044C \u043F\u0435\u0440\u0432\u043E\u0433\u043E \u044D\u0442\u0430\u043F\u0430 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 \u043F\u0440\u0438\u043C\u0435\u0440\u043D\u043E 6 \u0440\u0430\u0439. (10,000 m2).")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u4E00\u671F\u5360\u57306\u83B1\u3002\u8054\u6392\u522B\u5885\u548C\u72EC\u680B\u522B\u5885\u7684\u5360\u5730\u9762\u79EF\u5C06\u5728\u5404\u81EA\u7684\u76F8\u5173\u534F\u8BAE\u4E2D\u6307\u5B9A\u3002(6\u83B1\u7D04\u70BA10,000m2)"))}},{categoryId:2,question:{en:"How long does construction take?",ru:"Сколько времени занимает строительство?",cn:"建筑施工需要多长时间？"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Generally it will take approximately 12 - 18 months to complete construction of the Townhomes and Villas.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041A\u0430\u043A \u043F\u0440\u0430\u0432\u0438\u043B\u043E, \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E \u0432\u0438\u043B\u043B\u044B \u0438\u043B\u0438 \u0442\u0430\u0443\u0445\u0430\u0443\u0441\u0430 \u0437\u0430\u043D\u0438\u043C\u0430\u0435\u0442 12-18 \u043C\u0435\u0441\u044F\u0446\u0435\u0432.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u4E00\u822C\u800C\u8A00\uFF0C\u5BF9\u4E8E\u8054\u6392\u522B\u5885\u548C\u72EC\u7ACB\u522B\u5885\uFF0C\u5927\u7EA6\u9700\u898112-18\u4E2A\u6708\u624D\u80FD\u5B8C\u6210\u5EFA\u7B51\u548C\u666F\u89C2\u7EFF\u5316\u3002"))}},{categoryId:2,question:{en:"Is a warranty period offered?",ru:"Какой гарантийный срок предлагается?",cn:"保修期为多久？"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Yes. A one year building structure warranty is offered from the date of completion of construction for the Town Homes and Villas.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041E\u0434\u0438\u043D \u0433\u043E\u0434 \u0433\u0430\u0440\u0430\u043D\u0442\u0438\u0439\u043D\u043E\u0433\u043E \u0441\u0440\u043E\u043A\u0430 \u043F\u0440\u0435\u0434\u043B\u0430\u0433\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u0437\u0434\u0430\u043D\u0438\u044F \u0438 \u043A\u043E\u043C\u043F\u043E\u043D\u0435\u043D\u0442\u044B \u0438\u043B\u0438 \u0430\u043A\u0441\u0435\u0441\u0441\u0443\u0430\u0440\u044B \u0441 \u0434\u0430\u0442\u044B \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u4E00\u822C\u800C\u8A00\uFF0C\u4ECE\u7AE3\u5DE5\u4E4B\u65E5\u8D77\uFF0C\u5BF9\u8054\u6392\u522B\u5885\u548C\u72EC\u680B\u522B\u5885\u63D0\u4F9B\u4E00\u5E74\u5EFA\u7B51\u7ED3\u6784\u4FDD\u4FEE\u3002"))}},{categoryId:2,question:{en:"What is included in the property?",ru:"Что входит в готовый объект?",cn:"交房标准是什么？"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Wardrobe, kitchen and landscaping is included (refer to specifications). Loose furniture is not included.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0428\u043A\u0430\u0444, \u043A\u0443\u0445\u043D\u044F \u0438 \u043E\u0437\u0435\u043B\u0435\u043D\u0435\u043D\u0438\u0435 \u0432\u043A\u043B\u044E\u0447\u0435\u043D\u044B(\u0441\u043C. \u0441\u043F\u0435\u0446\u0438\u0444\u0438\u043A\u0430\u0446\u0438\u0438). \u041D\u0435\u0432\u0441\u0442\u0440\u043E\u0435\u043D\u043D\u0430\u044F \u043C\u0435\u0431\u0435\u043B\u044C \u043D\u0435 \u0432\u043A\u043B\u044E\u0447\u0435\u043D\u0430.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u5305\u62EC\u8863\u67DC,\u53A8\u623F\u4EE5\u53CA\u7EFF\u5316\uFF08\u8BF7\u53C2\u9605\u89C4\u683C\uFF09\u3002\u5BB6\u5177\u4E0D\u5305\u62EC\u5728\u5185\u3002"))}},{categoryId:2,question:{en:"Is customization of the building allowed?",ru:"Можно ли перестраивать или перепланировать объект?",cn:"是否可以根据个人喜好或需要对房屋进行改建？"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"All of our residential properties have been designed by professional architects and engineers and construction must be in accordance with building permits issued by the Government authorities. Other minor modifications for the Townhomes and Villas which do not breach the construction permit and do not impact the building structure such as internal partitions, built-in furniture, etc and which do not affect the overall aesthetics of the project may be done after house hand over (subject to developer approval).")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041F\u043B\u0430\u043D \u0432\u0441\u0435\u0445 \u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432 \u0436\u0438\u043B\u043E\u0439 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u044C \u0440\u0430\u0437\u0440\u0430\u0431\u0430\u0442\u044B\u0432\u0430\u0435\u0442\u0441\u044F \u043F\u0440\u043E\u0444\u0435\u0441\u0441\u0438\u043E\u043D\u0430\u043B\u0430\u043C\u0438 - \u0432\u0435\u0434\u0443\u0449\u0438\u043C\u0438 \u0430\u0440\u0445\u0438\u0442\u0435\u043A\u0442\u043E\u0440\u0430\u043C\u0438 \u0438 \u0438\u043D\u0436\u0435\u043D\u0435\u0440\u0430\u043C\u0438, \u0430 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E \u0432\u0435\u0434\u0435\u0442\u0441\u044F \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u0432\u044B\u0434\u0430\u043D\u043D\u044B\u043C\u0438 \u0433\u043E\u0441\u0443\u0434\u0430\u0440\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u043C\u0438 \u043E\u0440\u0433\u0430\u043D\u0430\u043C\u0438 \u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u0438\u044F\u043C\u0438 \u043D\u0430 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E. \u0422\u0435\u043C \u043D\u0435 \u043C\u0435\u043D\u0435\u0435, \u043C\u044B \u043C\u043E\u0436\u0435\u043C \u0432\u043D\u0435\u0441\u0442\u0438 \u043D\u0435\u0437\u043D\u0430\u0447\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u043D\u0435 \u043D\u0430\u0440\u0443\u0448\u0430\u044E\u0442 \u0443\u0441\u043B\u043E\u0432\u0438\u044F \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u043D\u043E\u0433\u043E \u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u0438\u044F \u043D\u0430 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E, \u0438 \u043D\u0435 \u043F\u043E\u0432\u043B\u0438\u044F\u044E\u0442 \u043D\u0430 \u043A\u043E\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0438\u044E \u0437\u0434\u0430\u043D\u0438\u044F. \u041E\u0431\u044B\u0447\u043D\u043E \u044D\u0442\u043E \u0440\u0430\u0431\u043E\u0442\u044B, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u043D\u0435 \u0432\u043B\u0438\u044F\u044E\u0442 \u043D\u0430 \u043E\u0431\u0449\u0443\u044E \u044D\u0441\u0442\u0435\u0442\u0438\u043A\u0443 \u043F\u043E\u0441\u0442\u0440\u043E\u0439\u043A\u0438, \u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440, \u043F\u0435\u0440\u0435\u043D\u043E\u0441 \u0432\u043D\u0443\u0442\u0440\u0435\u043D\u043D\u0438\u0445 \u043F\u0435\u0440\u0435\u0433\u043E\u0440\u043E\u0434\u043E\u043A \u0438 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u0435 \u0434\u0435\u0442\u0430\u043B\u0435\u0439 \u0432\u043D\u0443\u0442\u0440\u0435\u043D\u043D\u0435\u0439 \u043E\u0442\u0434\u0435\u043B\u043A\u0438 \u0438 \u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u044F - \u0432\u0441\u0442\u0440\u043E\u0435\u043D\u043D\u0430\u044F \u043C\u0435\u0431\u0435\u043B\u044C, \u0441\u0442\u0435\u043D\u044B \u0438 \u043F\u043E\u043B \u0438 \u0442\u0430\u043A \u0434\u0430\u043B\u0435\u0435.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u6211\u4EEC\u6240\u6709\u7684\u4F4F\u5B85\u7269\u4E1A\u5747\u7531\u9876\u7EA7\u5EFA\u7B51\u5E08\u548C\u5DE5\u7A0B\u5E08\u8BBE\u8BA1\uFF0C\u5E76\u4E14\u4F9D\u7167\u653F\u5E9C\u673A\u6784\u6240\u9881\u53D1\u7684\u65BD\u5DE5\u8BB8\u53EF\u8BC1\u8FDB\u884C\u5EFA\u9020\u3002\u5982\u9700\u5BF9\u8054\u6392\u522B\u5885\u548C\u72EC\u680B\u522B\u5885\u8FDB\u884C\u4E0D\u8FDD\u53CD\u65BD\u5DE5\u8BB8\u53EF\u8BC1,\u4E0D\u5F71\u54CD\u5EFA\u7B51\u7ED3\u6784\u7684\u5C0F\u6539\u52A8\uFF0C\u4F8B\u5982\u5185\u90E8\u9694\u5899,\u5185\u7F6E\u5F0F\u5BB6\u5177\u7B49\uFF0C\u9700\u5728\u623F\u5C4B\u5B8C\u5DE5\u4EA4\u4ED8\u540E\u8FDB\u884C\uFF0C\u4E14\u4E0D\u80FD\u5F71\u54CD\u5F00\u53D1\u9879\u76EE\u7684\u6574\u4F53\u7F8E\u89C2\u3002\uFF08\u5FC5\u987B\u53D7\u5230\u5F00\u53D1\u5546\u200B\u6279\u51C6\uFF09\u3002"))}},{categoryId:2,question:{en:"Cost for water and electricity meter installation?",ru:"Какие затраты на воду и установку счетчика для электричества?",cn:"水表和电表的安装费用是多少？"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"The electricity meter deposit is THB 5,000 and THB 15,000 for Townhome and Villa respectively. The water meter deposit is THB 535 for both Townhome and Villa. (These may be subject to change by the relevant government authority)")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0423\u0441\u0442\u0430\u043D\u043E\u0432\u043A\u0430 \u0441\u0447\u0435\u0442\u0447\u0438\u043A\u0430 \u0434\u043B\u044F \u044D\u043B\u0435\u043A\u0442\u0440\u0438\u0447\u0435\u0441\u0442\u0432\u0430 \u0441\u0442\u043E\u0438\u0442 THB 5,000 \u0438 THB 5,000 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043D\u043D\u043E \u0434\u043B\u044F \u0422\u0430\u0443\u043D\u0445\u0430\u0443\u0441\u043E\u0432 \u0438 \u0412\u0438\u043B\u043B. \u0421\u0447\u0435\u0442\u0447\u0438\u043A \u0434\u043B\u044F \u0432\u043E\u0434\u044B 535 \u0431\u0430\u0442. (\u043C\u043E\u0433\u0443\u0442 \u0431\u044B\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u044B \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u0433\u043E\u0441\u0443\u0434\u0430\u0440\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u043C\u0438 \u043D\u043E\u0440\u043C\u0430\u043C\u0438)")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u7535\u8868\u4FDD\u8BC1\u91D1\u4E3A\u8054\u6392\u522B\u58855\u5343\u6CF0\u94E2\uFF0C\u72EC\u680B\u522B\u58851\u4E075\u5343\u6CF0\u94E2\u3002\u8054\u6392\u548C\u72EC\u680B\u522B\u5885\u7684\u6C34\u8868\u4FDD\u8BC1\u91D1\u90FD\u662F535\u6CF0\u94E2\u3002\uFF08\u6839\u636E\u76F8\u5173\u653F\u5E9C\u6388\u6743\uFF0C\u53EF\u80FD\u6709\u53D8\u52A8\uFF09\u3002"))}},{categoryId:3,question:{en:"Is there a rental program available?",ru:"Существует ли программа аренды?",cn:"贵方是否提供任何租赁计划？如果有，潜在回报是多少？"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Laguna Property will provide an optional rental/letting service for individual owners but a hotel-type managed rental program is currently not contemplated. A market-rate commission will be charged based upon the rental value.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Laguna Property \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 \u0443\u0441\u043B\u0443\u0433\u0443 \u0430\u0440\u0435\u043D\u0434\u044B \u0434\u043B\u044F \u0438\u043D\u0434\u0438\u0432\u0438\u0434\u0443\u0430\u043B\u044C\u043D\u044B\u0445 \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0435\u0432, \u043E\u0434\u043D\u0430\u043A\u043E \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0430 \u0430\u0440\u0435\u043D\u0434\u044B \u0443\u043F\u0440\u0430\u0432\u043B\u044F\u0435\u043C\u0430\u044F \u043E\u043F\u0435\u0440\u0430\u0442\u043E\u0440\u043E\u043C \u0432 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0435 \u0432\u0440\u0435\u043C\u044F \u043D\u0435 \u0440\u0430\u0441\u0441\u043C\u0430\u0442\u0440\u0438\u0432\u0430\u0435\u0442\u0441\u044F. \u041A\u043E\u043C\u0438\u0441\u0441\u0438\u044F \u0432\u0437\u0438\u043C\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u043E\u0441\u043D\u043E\u0432\u0430\u043D\u0438\u0438 \u0440\u044B\u043D\u043E\u0447\u043D\u043E\u0433\u043E \u043A\u0443\u0440\u0441\u0430 \u043E\u0442 \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u0438 \u0430\u0440\u0435\u043D\u0434\u044B.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u76EE\u524D\u4E0D\u63D0\u4F9B\u9152\u5E97\u7BA1\u7406\u5F0F\u79DF\u8D41\u65B9\u6848\uFF0C\u4F46\u4E50\u53E4\u6D6A\u623F\u4EA7\u4E3A\u4E2A\u4EBA\u4E1A\u4E3B\u63D0\u4F9B\u53EF\u9009\u79DF\u8D41\u670D\u52A1\uFF0C\u6839\u636E\u5E02\u573A\u4F63\u91D1\u7387\u4EE5\u53CA\u623F\u5C4B\u79DF\u91D1\u6536\u53D6\u670D\u52A1\u8D39\u3002"))}},{categoryId:3,question:{en:"What are the taxes levied on the rental income?",ru:"Каковы налоги оплачивает владелец недвижимости при участии в  аренде?",cn:"出租物业的业主须缴纳哪些税费？"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Generally, rental income earned by non-resident (foreign) owners is subject to 15% withholding tax whereas rental income earned by Thai tax resident is subject to 5% withholding tax."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"Note: Applicable tax rates are current but may be subject to change by the relevant Thai authorities."))),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0414\u043E\u0445\u043E\u0434 \u043E\u0442 \u0430\u0440\u0435\u043D\u0434\u044B \u043E\u0431\u043A\u043B\u0430\u0434\u044B\u0432\u0430\u0435\u0442\u0441\u044F \u043D\u0430\u043B\u043E\u0433\u043E\u043C, \u0434\u043B\u044F \u0438\u043D\u043E\u0441\u0442\u0440\u0430\u043D\u043D\u044B\u0445 \u0433\u0440\u0430\u0436\u0434\u0430\u043D, \u043D\u0430\u043B\u043E\u0433 \u0441\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 - 15%, \u0434\u043B\u044F \u043C\u0435\u0441\u0442\u043D\u044B\u0445 \u0436\u0438\u0442\u0435\u043B\u0435\u0439 \u0422\u0430\u0439\u0441\u043A\u043E\u0439 \u043D\u0430\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u043E\u0441\u0442\u0438 - 5%."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"\u041F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0435: \u041F\u0440\u0438\u043C\u0435\u043D\u0438\u043C\u043E \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0435 \u0441\u0431\u043E\u0440\u044B \u0438 \u043D\u0430\u043B\u043E\u0433\u043E\u0432\u044B\u0435 \u0441\u0442\u0430\u0432\u043A\u0438 \u044F\u0432\u043B\u044F\u044E\u0442\u0441\u044F \u0442\u0435\u043A\u0443\u0449\u0438\u043C\u0438, \u043D\u043E \u043C\u043E\u0433\u0443\u0442 \u0431\u044B\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u044B \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u043C \u0432\u043B\u0430\u0441\u0442\u044F\u043C \u0422\u0430\u0438\u043B\u0430\u043D\u0434\u0430."))),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u901A\u5E38\u51FA\u79DF\u7269\u4E1A\u7684\u5916\u7C4D\u4E1A\u4E3B\u9700\u7F34\u7EB315%\u7684\u79DF\u91D1\u6240\u5F97\u7A0E\uFF1B\u6CF0\u7C4D\u4E1A\u4E3B\u9700\u7F34\u7EB35% \u7684\u79DF\u91D1\u6240\u5F97\u7A0E\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"\u5907\u6CE8\uFF1A\u8BF7\u6CE8\u610F\uFF0C\u6B64\u5904\u7684\u67D0\u4E9B\u9002\u7528\u7A0E\u7387\u53EF\u80FD\u4F1A\u6839\u636E\u6CF0\u56FD\u6CD5\u5F8B\u6539\u53D8\u800C\u53D1\u751F\u6539\u53D8\u3002")))}},{categoryId:3,question:{en:"Can I rent out the property by myself short term and/or long term?",ru:"Могу ли я сдать свою недвижимость в краткосрочную и / или долгосрочную аренду?",cn:"我可以自己短期或长期出租物业吗？"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Yes, terms and conditions will apply.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0414\u0430, \u0441 \u043F\u0440\u0438\u043C\u0435\u043D\u0435\u043D\u0438\u0435\u043C \u0441\u0440\u043E\u043A\u043E\u0432 \u0438 \u0443\u0441\u043B\u043E\u0432\u0438\u0439.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u53EF\u4EE5\uFF0C\u6761\u4EF6\u548C\u6761\u6B3E\u9002\u7528\u3002"))}},// =========== add new =========== //
{categoryId:4,question:{en:"What infrastructure and common facilities are provided and who will manage these?",ru:"Какая предоставляется инфраструктура и объекты общего назначения и кто будет управлять?",cn:"项目包含哪些基础设施和公共设施？这些设施由谁负责管理？"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"A.")," The infrastructure and common facilities includes roads and drainage, lighting, landscape areas, swimming pools, deck areas and water and electricity supplies. Services shall include 24 hours on-site security, garbage collection, cleaning and maintenance of infrastructure and common facilities or any other services as required for the common use or benefit of owners. In addition, owners will be entitled to access certain amenities including the shuttle bus service. The condominium manager shall be Laguna (or its designated manager).")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"O.")," \u0418\u043D\u0444\u0440\u0430\u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u0430 \u0438 \u043E\u0431\u044A\u0435\u043A\u0442\u044B \u043E\u0431\u0449\u0435\u0433\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0432\u043A\u043B\u044E\u0447\u0430\u044E\u0442 \u0432 \u0441\u0435\u0431\u044F \u0434\u043E\u0440\u043E\u0433\u0438, \u043A\u0430\u043D\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u044E, \u043E\u0441\u0432\u0435\u0449\u0435\u043D\u0438\u0435, \u043B\u0430\u043D\u0434\u0448\u0430\u0444\u0442\u043D\u044B\u0435 \u0437\u043E\u043D\u044B, \u0431\u0430\u0441\u0441\u0435\u0439\u043D\u044B, \u043F\u043B\u043E\u0449\u0430\u0434\u043A\u0438, \u0432\u043E\u0434\u043E\u0441\u043D\u0430\u0431\u0436\u0435\u043D\u0438\u0435 \u0438 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u0441\u043D\u0430\u0431\u0436\u0435\u043D\u0438\u0435. \u0423\u0441\u043B\u0443\u0433\u0438 \u0434\u043E\u043B\u0436\u043D\u044B \u0432\u043A\u043B\u044E\u0447\u0430\u0442\u044C 24-\u0447\u0430\u0441\u043E\u0432\u0443\u044E \u043E\u0445\u0440\u0430\u043D\u0443, \u0441\u0431\u043E\u0440 \u043C\u0443\u0441\u043E\u0440\u0430, \u0443\u0431\u043E\u0440\u043A\u0443 \u0438 \u043E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u043D\u0438\u0435 \u0438\u043D\u0444\u0440\u0430\u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u044B \u0438 \u043C\u0435\u0441\u0442 \u043E\u0431\u0449\u0435\u0433\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F, \u0430 \u0442\u0430\u043A\u0436\u0435 \u043B\u044E\u0431\u044B\u0435 \u0434\u0440\u0443\u0433\u0438\u0435 \u0443\u0441\u043B\u0443\u0433\u0438, \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u044B\u0435 \u0434\u043B\u044F \u043E\u0431\u0449\u0435\u0433\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0438\u043B\u0438 \u0442\u0440\u0435\u0431\u0443\u0435\u043C\u044B\u0435 \u0432 \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u0430\u0445 \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0435\u0432. \u041A\u0440\u043E\u043C\u0435 \u0442\u043E\u0433\u043E, \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u044B \u0431\u0443\u0434\u0443\u0442 \u0438\u043C\u0435\u0442\u044C \u043F\u0440\u0430\u0432\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u044B\u043C \u0443\u0434\u043E\u0431\u0441\u0442\u0432\u0430\u043C \u043A\u0443\u0440\u043E\u0440\u0442\u0430, \u0432\u043A\u043B\u044E\u0447\u0430\u044F \u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u044B\u0439 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442 \u0432\u043D\u0443\u0442\u0440\u0438 \u043A\u0443\u0440\u043E\u0440\u0442\u0430. \u0423\u043F\u0440\u0430\u0432\u043B\u044F\u044E\u0449\u0438\u043C \u043A\u043E\u043D\u0434\u043E\u043C\u0438\u043D\u0438\u0443\u043C\u043E\u043C \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F Laguna (\u0438\u043B\u0438 \u043D\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044B\u0439 \u0435\u044E \u043C\u0435\u043D\u0435\u0434\u0436\u0435\u0440).")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u7B54.")," ","\u57FA\u7840\u8BBE\u65BD\u4E0E\u516C\u5171\u8BBE\u65BD\u5305\u62EC\uFF1A\u9053\u8DEF\u548C\u6392\u6C34\u3001\u7167\u660E\u3001\u666F\u89C2\u533A\u3001\u6E38\u6CF3\u6C60\u3001\u7532\u677F\u533A\u4E0E\u6C34\u7535\u4F9B\u5E94\u3002\u670D\u52A1\u5305\u62EC\uFF1A24\u5C0F\u65F6\u73B0\u573A\u4FDD\u5B89\u3001\u5783\u573E\u6536\u96C6\u3001\u6E05\u6D01\u6253\u626B\uFF0C\u4EE5\u53CA\u57FA\u7840\u8BBE\u65BD\u548C\u5171\u540C\u8BBE\u65BD\u7684\u7EF4\u62A4\uFF0C\u6216\u5176\u4ED6\u4EFB\u4F55\u4E1A\u4E3B\u53EF\u4EE5\u5171\u540C\u4F7F\u7528\u6216\u6536\u76CA\u7684\u670D\u52A1\u3002\u6B64\u5916\uFF0C\u4E1A\u4E3B\u5C06\u6709\u6743\u4F7F\u7528\u4E00\u4E9B\u8BBE\u65BD\uFF0C\u5305\u62EC\u7A7F\u68AD\u5DF4\u58EB\u670D\u52A1\u3002\u516C\u5BD3\u7ECF\u7406\u5C06\u7531\u4E50\u53E4\u6D6A\u623F\uFF08\u6216\u5176\u6307\u6D3E\u4E4B\u7ECF\u7406\uFF09\u62C5\u4EFB\u3002"))}},{categoryId:4,question:{en:"What are the estimated fees payable for the infrastructure, common facilities and services provided?",ru:"Каковы сборы за обслуживание инфраструктуры проекта, общественной территории и за другие предоставляемые услуги?",cn:"基础设施、公共设施和服务预计费用是多少?"},displayOn:["en","ru","cn"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"A.")," The fees for the cost of maintenance for the infrastructure, common facilities, services provided (\u201Ccommon area fee\u201D) and maintenance fees towards other services and facilities shall be Baht 585 per square wah per year (or Baht 147 per square meter per year) for the initial year and may be subject to change based upon the actual expenses incurred from time to time. The annual fees are determined by the total expenses incurred and proportionately divided amongst the sellable plot area of the properties in the estate."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"In addition, a fund shall be established for the cost of major repairs, replacement and/or improvement for the infrastructure and common facilities (\u201Cspecial fund\u201D). Contributions will be made on a regular basis so that the fund is built up over time. The rate shall be Baht 25 per square metre per year for the initial year and may be subject to change. If the fund balance is not sufficient for the cost of major repairs, owners may be required to pay an additional amount as requested by the manager from time to time."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"The cost of water and electricity supplied to individual properties shall be based upon metered consumption.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"O.")," \u041F\u043B\u0430\u0442\u0430 \u0437\u0430 \u043E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u043D\u0438\u0435 \u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432 \u0438\u043D\u0444\u0440\u0430\u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u044B, \u043C\u0435\u0441\u0442 \u043E\u0431\u0449\u0435\u0433\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F, \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u043C\u044B\u0445 \u0443\u0441\u043B\u0443\u0433 (\xAB\u043F\u043B\u0430\u0442\u0430 \u0437\u0430 \u043C\u0435\u0441\u0442\u0430 \u043E\u0431\u0449\u0435\u0433\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F\xBB), \u0430 \u0442\u0430\u043A\u0436\u0435 \u043F\u043B\u0430\u0442\u0430 \u0437\u0430 \u043A\u043E\u043C\u043C\u0443\u043D\u0430\u043B\u044C\u043D\u044B\u0435 \u0443\u0441\u043B\u0443\u0433\u0438 \u0438 \u043F\u043B\u0430\u0442\u0430 \u0437\u0430 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0434\u0440\u0443\u0433\u0438\u0445 \u0443\u0441\u043B\u0443\u0433 \u0441\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 147 \u0431\u0430\u0442\u043E\u0432 \u0437\u0430 \u043A\u0432\u0430\u0434\u0440\u0430\u0442\u043D\u044B\u0439 \u043C\u0435\u0442\u0440 \u0432 \u0433\u043E\u0434 \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 \u043F\u0435\u0440\u0432\u043E\u0433\u043E \u0433\u043E\u0434\u0430. \u042D\u0442\u0430 \u0441\u0443\u043C\u043C\u0430 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0430 \u0432 \u0437\u0430\u0432\u0438\u0441\u0438\u043C\u043E\u0441\u0442\u0438 \u043E\u0442 \u0444\u0430\u043A\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u0445 \u043F\u0435\u0440\u0438\u043E\u0434\u0438\u0447\u0435\u0441\u043A\u0438 \u0432\u043E\u0437\u043D\u0438\u043A\u0430\u044E\u0449\u0438\u0445 \u0440\u0430\u0441\u0445\u043E\u0434\u043E\u0432. \u0415\u0436\u0435\u0433\u043E\u0434\u043D\u044B\u0435 \u043F\u043B\u0430\u0442\u0435\u0436\u0438 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u044F\u044E\u0442\u0441\u044F \u043D\u0430 \u043E\u0441\u043D\u043E\u0432\u0430\u043D\u0438\u0438 \u043E\u0431\u0449\u0435\u0439 \u0441\u0443\u043C\u043C\u044B \u043F\u043E\u043D\u0435\u0441\u0435\u043D\u043D\u044B\u0445 \u0440\u0430\u0441\u0445\u043E\u0434\u043E\u0432 \u0438 \u043F\u0440\u043E\u043F\u043E\u0440\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u043E \u0440\u0430\u0437\u0434\u0435\u043B\u044F\u044E\u0442\u0441\u044F \u043C\u0435\u0436\u0434\u0443 \u043F\u0440\u0435\u0434\u043B\u0430\u0433\u0430\u0435\u043C\u044B\u043C\u0438 \u0434\u043B\u044F \u043F\u0440\u043E\u0434\u0430\u0436\u0438 \u0443\u0447\u0430\u0441\u0442\u043A\u0430\u043C\u0438 \u0432 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0441\u0435."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041A\u0440\u043E\u043C\u0435 \u0442\u043E\u0433\u043E, \u043F\u0440\u0435\u0434\u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u043E \u0441\u043E\u0437\u0434\u0430\u043D\u0438\u0435 \u0444\u043E\u043D\u0434\u0430 \u0434\u043B\u044F \u043F\u043E\u043A\u0440\u044B\u0442\u0438\u044F \u0440\u0430\u0441\u0445\u043E\u0434\u043E\u0432 \u043D\u0430 \u043A\u0430\u043F\u0438\u0442\u0430\u043B\u044C\u043D\u044B\u0439 \u0440\u0435\u043C\u043E\u043D\u0442, \u0437\u0430\u043C\u0435\u043D\u0443 \u0438(\u0438\u043B\u0438) \u0443\u043B\u0443\u0447\u0448\u0435\u043D\u0438\u0435 \u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432 \u0438\u043D\u0444\u0440\u0430\u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u044B \u0438 \u043C\u0435\u0441\u0442 \u043E\u0431\u0449\u0435\u0433\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F (\xAB\u0441\u043F\u0435\u0446\u0438\u0430\u043B\u044C\u043D\u044B\u0439 \u0444\u043E\u043D\u0434\xBB). \u0412\u0437\u043D\u043E\u0441\u044B \u0434\u043B\u044F \u043F\u043E\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u044F \u0444\u043E\u043D\u0434\u0430 \u0431\u0443\u0434\u0443\u0442 \u043F\u0440\u043E\u0438\u0437\u0432\u043E\u0434\u0438\u0442\u044C\u0441\u044F \u043D\u0430 \u0440\u0435\u0433\u0443\u043B\u044F\u0440\u043D\u043E\u0439 \u043E\u0441\u043D\u043E\u0432\u0435. \u0421\u0442\u0430\u0432\u043A\u0430 \u0441\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 25 \u0431\u0430\u0442\u043E\u0432 \u0437\u0430 \u043A\u0432\u0430\u0434\u0440\u0430\u0442\u043D\u044B\u0439 \u043C\u0435\u0442\u0440 \u0432 \u0433\u043E\u0434 \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 \u043F\u0435\u0440\u0432\u043E\u0433\u043E \u0433\u043E\u0434\u0430 \u0438 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0430. \u0415\u0441\u043B\u0438 \u043E\u0441\u0442\u0430\u0442\u043E\u043A \u0441\u0440\u0435\u0434\u0441\u0442\u0432 \u043D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043E\u0447\u0435\u043D \u0434\u043B\u044F \u043F\u043E\u043A\u0440\u044B\u0442\u0438\u044F \u0437\u0430\u0442\u0440\u0430\u0442 \u043D\u0430 \u043A\u0430\u043F\u0438\u0442\u0430\u043B\u044C\u043D\u044B\u0439 \u0440\u0435\u043C\u043E\u043D\u0442, \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0430\u043C \u043C\u043E\u0436\u0435\u0442 \u0442\u0440\u0435\u0431\u043E\u0432\u0430\u0442\u044C\u0441\u044F \u043F\u0435\u0440\u0438\u043E\u0434\u0438\u0447\u0435\u0441\u043A\u0438 \u0432\u043D\u043E\u0441\u0438\u0442\u044C \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u0443\u044E \u0441\u0443\u043C\u043C\u0443 \u043F\u043E \u0437\u0430\u043F\u0440\u043E\u0441\u0443 \u0443\u043F\u0440\u0430\u0432\u043B\u044F\u044E\u0449\u0435\u0433\u043E."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0421\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C \u0432\u043E\u0434\u044B \u0438 \u044D\u043B\u0435\u043A\u0442\u0440\u0438\u0447\u0435\u0441\u0442\u0432\u0430, \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u043C\u044B\u0445 \u0432 \u043E\u0442\u0434\u0435\u043B\u044C\u043D\u044B\u0435 \u043F\u043E\u043C\u0435\u0449\u0435\u043D\u0438\u044F, \u0440\u0430\u0441\u0441\u0447\u0438\u0442\u044B\u0432\u0430\u0435\u0442\u0441\u044F \u043D\u0430 \u043E\u0441\u043D\u043E\u0432\u0430\u043D\u0438\u0438 \u043F\u043E\u043A\u0430\u0437\u0430\u043D\u0438\u0439 \u0441\u0447\u0435\u0442\u0447\u0438\u043A\u043E\u0432.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u7B54.")," ","\u57FA\u7840\u8BBE\u65BD\u3001\u516C\u5171\u8BBE\u65BD\u3001\u63D0\u4F9B\u670D\u52A1(\u201C\u516C\u5171\u533A\u57DF\u670D\u52A1\u8D39\u201D)\u7684\u7EF4\u62A4\u6210\u672C\u8D39\u7528\u4EE5\u53CA\u5BF9\u5176\u4ED6\u670D\u52A1\u548C \u8BBE\u65BD\u7684\u7EF4\u62A4\u8D39\u7528\uFF0C\u7B2C\u4E00\u5E74\u4E3A\u6BCF\u5E73\u65B9\u7C73 147 \u6CF0\u94E2\uFF0C\u53EF\u80FD\u4F1A\u6839\u636E\u5B9E\u9645\u8D39\u7528\u53D1\u751F\u53D8\u5316\u3002\u6BCF\u5E74\u7684\u8D39\u7528\u7531 \u6240\u4EA7\u751F\u7684\u603B\u8D39\u7528\u51B3\u5B9A\uFF0C\u5E76\u6309\u9500\u552E\u9762\u79EF\u6309\u6BD4\u4F8B\u8FDB\u884C\u5206\u644A\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u53E6\u5916\uFF0C\u8FD8\u5E94\u4E3A\u57FA\u7840\u8BBE\u65BD\u4E0E\u5171\u540C\u8BBE\u65BD\u7684\u4E3B\u8981\u7EF4\u4FEE\u3001\u4EE5\u53CA\u5176\u66F4\u6362\u548C/\u6216\u6539\u9020\u8D39\u7528\u8BBE\u7ACB\u57FA\u91D1(\u201C\u7279\u522B \u57FA\u91D1\u201D)\u3002\u8BE5\u57FA\u91D1\u8981\u6C42\u4E1A\u4E3B\u5B9A\u671F\u652F\u4ED8\u3002\u521D\u59CB\u5E74\u5EA6\u8D39\u7528\u5E94\u4E3A\u6BCF\u5E73\u65B9\u7C73 25 \u6CF0\u94E2\uFF0C\u53EF\u80FD\u4F1A\u6709\u6240\u53D8 \u52A8\u3002\u5982\u679C\u57FA\u91D1\u7684\u4F59\u989D\u4E0D\u8DB3\u4EE5\u8FDB\u884C\u5927\u4FEE\u7F2E\u65F6\uFF0C\u5219\u4E1A\u4E3B\u53EF\u80FD\u9700\u8981\u6839\u636E\u7BA1\u7406\u65B9\u7684\u8981\u6C42\uFF0C\u4E0D\u65F6\u652F\u4ED8\u989D\u5916 \u7684\u7EF4\u4FEE\u8D39\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u5404\u4E2A\u5355\u5143\u7684\u6C34\u7535\u8D39\u7528\uFF0C\u5C06\u6309\u8BA1\u91CF\u6D88\u8D39\u4E3A\u51C6\u3002"))}},{categoryId:4,question:{en:"What property management services are provided?",ru:"Какие предоставляются услуги по управлению собственностью?",cn:"所提供的物业管理服务有哪些？"},displayOn:["en","ru","cn"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"A.")," Laguna will provide a full range of property services to individual owners including, pest control, routine and preventative maintenance, general repairs, housekeeping and other reasonable requests. Rates vary according to the frequency and scope of service. In addition, Laguna provides owners with the ability to generate a rental income from their property with short-term* and long-term rentals (see below).")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"O.")," \u0423\u043F\u0440\u0430\u0432\u043B\u044F\u044E\u0449\u0430\u044F \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u044F Laguna \u0438/\u0438\u043B\u0438 \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u0438 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0441\u0430 Skypark Phuket \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u044F\u0442 \u043F\u043E\u043B\u043D\u044B\u0439 \u0441\u043F\u0435\u043A\u0442\u0440 \u0443\u0441\u043B\u0443\u0433, \u0432\u043A\u043B\u044E\u0447\u0430\u044F \u0431\u043E\u0440\u044C\u0431\u0443 \u0441 \u0432\u0440\u0435\u0434\u0438\u0442\u0435\u043B\u044F\u043C\u0438, \u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u043E\u0435 \u0438 \u043F\u0440\u043E\u0444\u0438\u043B\u0430\u043A\u0442\u0438\u0447\u0435\u0441\u043A\u043E\u0435 \u043E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u043D\u0438\u0435, \u043E\u0431\u0449\u0438\u0435 \u0440\u0435\u043C\u043E\u043D\u0442\u043D\u044B\u0435 \u0440\u0430\u0431\u043E\u0442\u044B, \u0443\u0431\u043E\u0440\u043A\u0443 \u0438 \u0434\u0440\u0443\u0433\u0438\u0435 \u0432\u0438\u0434\u044B \u0440\u0430\u0431\u043E\u0442 \u043F\u043E \u043F\u0440\u043E\u0441\u044C\u0431\u0435 \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0430. \u0421\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C \u0443\u0441\u043B\u0443\u0433 \u0437\u0430\u0432\u0438\u0441\u0438\u0442 \u043E\u0442 \u0447\u0430\u0441\u0442\u043E\u0442\u044B \u043C\u0430\u0441\u0448\u0442\u0430\u0431\u0430 \u0438\u0445 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u044F. \u0411\u043E\u043B\u0435\u0435 \u0442\u043E\u0433\u043E, \u043E\u0442\u0434\u0435\u043B \u043F\u043E \u0430\u0440\u0435\u043D\u0434\u0435 \xABLaguna Rentals\xBB \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0430\u043C \u043A\u0432\u0430\u0440\u0442\u0438\u0440, \u043D\u0435 \u0432\u0445\u043E\u0434\u044F\u0449\u0438\u0445 \u0432 \u0441\u043E\u0441\u0442\u0430\u0432 \u043E\u0442\u0435\u043B\u044F, \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u044C \u043F\u043E\u043B\u0443\u0447\u0430\u0442\u044C \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u0434\u043E\u0445\u043E\u0434 \u043E\u0442 \u0441\u0434\u0430\u0447\u0438 \u0438\u0445 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u0438 \u0432 \u0434\u043E\u043B\u0433\u043E\u0441\u0440\u043E\u0447\u043D\u0443\u044E \u0438 \u043A\u0440\u0430\u0442\u043A\u043E\u0441\u0440\u043E\u0447\u043D\u0443\u044E \u0430\u0440\u0435\u043D\u0434\u0443* (\u0441\u043C. \u043D\u0438\u0436\u0435).")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u7B54.")," ","\u4E50\u53E4\u6D6A\u5C06\u4E3A\u4E2A\u4F53\u4E1A\u4E3B\u63D0\u4F9B\u5168\u65B9\u4F4D\u7684\u7269\u4E1A\u7BA1\u7406\u670D\u52A1\uFF0C\u5305\u62EC\u866B\u5BB3\u9632\u6CBB\u3001\u5E38\u89C4\u4E0E\u9884\u9632\u6027\u7EF4\u62A4\u3001\u4E00\u822C\u7EF4\u4FEE\u3001\u5BB6\u653F\u670D\u52A1\uFF0C\u4EE5\u53CA\u5176\u4ED6\u5408\u7406\u8981\u6C42\u3002\u6536\u8D39\u89C6\u670D\u52A1\u7684\u9891\u7387\u4E0E\u8303\u56F4\u800C\u5F02\u3002\u6B64\u5916\uFF0C\u901A\u8FC7\u4E50\u53E4\u6D6A\u56E2\u961F\u53EF\u8BA9\u4E1A\u4E3B\u5728\u4F4F\u5B85\u7A7A\u7F6E\u65F6\u4EE5\u77ED\u671F*\u548C\u957F\u671F\u51FA\u79DF\uFF08\u89C1\u4E0B\u6587\uFF09\u7684\u65B9\u5F0F\u83B7\u53D6\u79DF\u91D1\u6536\u76CA\u3002"))}},{categoryId:4,question:{en:"Can I rent my unit out on my own?",ru:"Могу ли я самостоятельно сдать в аренду свою квартиру?",cn:"我是否可以自行租赁我的单位？"},displayOn:["en","ru","cn"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"A.")," Yes, owners may rent out their property on a long-term basis (6 months or more) directly or through external agents."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"For short-term* rentals less than 6 months, these must be conducted exclusively through Laguna Rentals who provides owners with the ability to generate a rental income from their property when not in residence with short-term and long-term rentals."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"* Terms and conditions apply"))),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"O.")," \u0414\u0430. \u0412 \u0441\u043B\u0443\u0447\u0430\u0435 \u0441\u0434\u0430\u0447\u0438 \u0432 \u0430\u0440\u0435\u043D\u0434\u0443 \u043D\u0430 \u0434\u043B\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u0441\u0440\u043E\u043A (6 \u043C\u0435\u0441\u044F\u0446\u0435\u0432 \u0438 \u0431\u043E\u043B\u0435\u0435) \u043D\u0435\u0442 \u043D\u0438\u043A\u0430\u043A\u0438\u0445 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u0438\u0439, \u0441\u0434\u0430\u0447\u0430 \u0432 \u0430\u0440\u0435\u043D\u0434\u0443 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u043F\u0440\u043E\u0438\u0437\u0432\u0435\u0434\u0435\u043D\u0430 \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0435\u043C \u0438\u043B\u0438 \u0441\u0442\u043E\u0440\u043E\u043D\u043D\u0438\u043C \u0430\u0433\u0435\u043D\u0442\u043E\u043C."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0412 \u0441\u043B\u0443\u0447\u0430\u0435 \u043A\u0440\u0430\u0442\u043A\u043E\u0441\u0440\u043E\u0447\u043D\u043E\u0439* \u0430\u0440\u0435\u043D\u0434\u044B \u043E\u0442 1 \u0434\u043E 6 \u043C\u0435\u0441\u044F\u0446\u0435\u0432, \u0432\u0441\u0435 \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u0438 \u0434\u043E\u043B\u0436\u043D\u044B \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0442\u044C\u0441\u044F \u0447\u0435\u0440\u0435\u0437 \u043E\u0442\u0434\u0435\u043B \u043F\u043E \u0430\u0440\u0435\u043D\u0434\u0435 Laguna Rentals, \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u044E\u0449\u0438\u0439 \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0430\u043C \u0436\u0438\u043B\u043E\u0439 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u0438, \u043D\u0435 \u044F\u0432\u043B\u044F\u044E\u0449\u0438\u0445\u0441\u044F \u0447\u0430\u0441\u0442\u044C\u044E \u043E\u0442\u0435\u043B\u044F, \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u044C \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0433\u043E \u0434\u043E\u0445\u043E\u0434\u0430 \u0441 \u0430\u0440\u0435\u043D\u0434\u044B \u0438\u0445 \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438, \u0435\u0441\u043B\u0438 \u0442\u0435 \u043D\u0435 \u043F\u0440\u043E\u0436\u0438\u0432\u0430\u044E\u0442 \u0442\u0430\u043C \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 \u043A\u043E\u0440\u043E\u0442\u043A\u043E\u0433\u043E \u0438\u043B\u0438 \u0434\u043B\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0433\u043E \u043F\u0435\u0440\u0438\u043E\u0434\u0430."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0421\u0434\u0430\u0447\u0430 \u0432 \u0430\u0440\u0435\u043D\u0434\u0443 \u043D\u0430 \u043A\u043E\u0440\u043E\u0442\u043A\u0438\u0439* \u0441\u0440\u043E\u043A \u043C\u0435\u043D\u0435\u0435 30 \u0434\u043D\u0435\u0439 \u0434\u043E\u043B\u0436\u043D\u0430 \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0442\u044C\u0441\u044F \u0438\u0441\u043A\u043B\u044E\u0447\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0443 \u0430\u0440\u0435\u043D\u0434\u044B Skypark Phuket (\u0432\u043B\u0430\u0434\u0435\u044E\u0449\u0430\u044F \u0433\u043E\u0441\u0442\u0438\u043D\u0438\u0447\u043D\u043E\u0439 \u043B\u0438\u0446\u0435\u043D\u0437\u0438\u0435\u0439). \u0412 \u043A\u0432\u0430\u0440\u0442\u0438\u0440\u0430\u0445, \u0443\u043F\u0440\u0430\u0432\u043B\u044F\u0435\u043C\u044B\u0445 \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u0433\u043E\u0441\u0442\u0438\u043D\u0438\u0447\u043D\u043E\u0439 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u043E\u0439 \u0441\u0434\u0430\u0447\u0438 \u0432 \u0430\u0440\u0435\u043D\u0434\u0443, \u0434\u043E\u043B\u0436\u0435\u043D \u043F\u0440\u0438\u0441\u0443\u0442\u0441\u0442\u0432\u043E\u0432\u0430\u0442\u044C \u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u044B\u0439 \u043D\u0430\u0431\u043E\u0440 \u043C\u0435\u0431\u0435\u043B\u0438."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"* \u041F\u0440\u0438\u043C\u0435\u043D\u044F\u044E\u0442\u0441\u044F \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u044B\u0435 \u043F\u0440\u0430\u0432\u0438\u043B\u0430 \u0438 \u0443\u0441\u043B\u043E\u0432\u0438\u044F."))),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u7B54.")," ","\u7B54.\u662F\u7684\uFF0C\u4E1A\u4E3B\u53EF\u4EE5\u76F4\u63A5\u6216\u901A\u8FC7\u5916\u90E8\u4E2D\u4ECB\u957F\u671F\uFF086\u4E2A\u6708\u6216\u66F4\u957F\u65F6\u95F4\uFF09\u51FA\u79DF\u5176\u623F\u4EA7\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u5BF9\u4E8E\u4F4E\u4E8E6\u4E2A\u6708\u7684\u77ED\u671F*\u79DF\u8D41\uFF0C\u4E1A\u4E3B\u5C31\u5FC5\u987B\u901A\u8FC7\u4E50\u53E4\u6D6A\u79DF\u8D41\uFF08Laguna Rentals\uFF09\u6765\u8FDB\u884C\u3002\u8FD9\u4F7F\u4E1A\u4E3B\u80FD\u591F\u5728\u4E0D\u5C45\u4F4F\u671F\u95F4\uFF0C\u901A\u8FC7\u77ED\u671F\u548C\u957F\u671F\u79DF\u8D41\u4ECE\u5176\u623F\u4EA7\u4E2D\u83B7\u5F97\u79DF\u91D1\u6536\u5165\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"* \u9700\u53D7\u4E00\u5B9A\u6761\u6B3E\u4E0E\u6761\u4EF6\u7EA6\u675F\u3002")))}},{categoryId:4,question:{en:"What are the taxes levied on rental income that an owner will be subject to?",ru:"Какие налоги должен будет выплачивать владелец с дохода от сдачи в аренду?",cn:"业主需要缴纳哪些租金收入税？"},displayOn:["en","ru","cn"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"A.")," Owners may be required to file an income tax return in Thailand based upon rental income earned and pay the applicable tax. Rental distributions made to owners may be subject to withholding tax under the Thai Revenue Code with rates ranging from 5 \u2013 15%, subject to owners tax structure status."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"Note: applicable tax rates are current at the date of issue of this FAQ and may be subject to changes. The unit owner shall be responsible for any income and any other taxes, duties and fees of whatever nature which may be levied by relevant authorities on the unit in connection with the rental."))),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"O.")," \u0414\u043E\u0445\u043E\u0434\u044B \u0441 \u0430\u0440\u0435\u043D\u0434\u044B, \u043F\u043E\u043B\u0443\u0447\u0430\u0435\u043C\u044B\u0435 \u0437\u0430\u0440\u0443\u0431\u0435\u0436\u043D\u044B\u043C\u0438 \u0433\u0440\u0430\u0436\u0434\u0430\u043D\u0430\u043C\u0438, \u043E\u0431\u043B\u0430\u0433\u0430\u044E\u0442\u0441\u044F \u043D\u0430\u043B\u043E\u0433\u043E\u043C \u0432 15%. \u0414\u043E\u0445\u043E\u0434\u044B \u0441 \u0430\u0440\u0435\u043D\u0434\u044B, \u043F\u043E\u043B\u0443\u0447\u0430\u0435\u043C\u044B\u0435 \u0433\u0440\u0430\u0436\u0434\u0430\u043D\u0430\u043C\u0438 \u0422\u0430\u0438\u043B\u0430\u043D\u0434\u0430, \u043E\u0431\u043B\u0430\u0433\u0430\u044E\u0442\u0441\u044F \u043D\u0430\u043B\u043E\u0433\u043E\u043C \u0432 5%."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"\u041F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0435: \u043F\u0440\u0438\u0432\u0435\u0434\u0435\u043D\u043D\u044B\u0435 \u043D\u0430\u043B\u043E\u0433\u043E\u0432\u044B\u0435 \u0441\u0442\u0430\u0432\u043A\u0438 \u044F\u0432\u043B\u044F\u044E\u0442\u0441\u044F \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u043C\u0438 \u043D\u0430 \u043C\u043E\u043C\u0435\u043D\u0442 \u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0446\u0438\u0438 \u0434\u0430\u043D\u043D\u043E\u0433\u043E \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0441 \u0447\u0430\u0441\u0442\u043E \u0437\u0430\u0434\u0430\u0432\u0430\u0435\u043C\u044B\u043C\u0438 \u0432\u043E\u043F\u0440\u043E\u0441\u0430\u043C\u0438 \u0438 \u043C\u043E\u0433\u0443\u0442 \u0431\u044B\u0442\u044C \u043F\u0435\u0440\u0435\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u044B. \u0412\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u044B \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u043D\u0435\u0441\u0443\u0442 \u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u044C \u0437\u0430 \u043F\u043E\u043B\u0443\u0447\u0430\u0435\u043C\u044B\u0435 \u0434\u043E\u0445\u043E\u0434\u044B \u0438 \u0443\u043F\u043B\u0430\u0442\u0443 \u0440\u0430\u0437\u043D\u043E\u043E\u0431\u0440\u0430\u0437\u043D\u044B\u0445 \u043D\u0430\u043B\u043E\u0433\u043E\u0432, \u043F\u043E\u0448\u043B\u0438\u043D \u0438 \u0441\u0431\u043E\u0440\u043E\u0432, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u043C\u043E\u0433\u0443\u0442 \u0432\u0437\u0438\u043C\u0430\u0442\u044C\u0441\u044F \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u043C\u0438 \u0433\u043E\u0441\u0443\u0434\u0430\u0440\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u043C\u0438 \u043E\u0440\u0433\u0430\u043D\u0430\u043C\u0438 \u0432 \u0441\u0432\u044F\u0437\u0438 \u0441\u043E \u0441\u0434\u0430\u0447\u0435\u0439 \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u0432 \u0430\u0440\u0435\u043D\u0434\u0443."))),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u7B54.")," ","\u4E1A\u4E3B\u9700\u8981\u6839\u636E\u6240\u8D5A\u53D6\u7684\u79DF\u91D1\u6536\u5165\u5728\u6CF0\u56FD\u63D0\u4EA4\u6240\u5F97\u7A0E\u7533\u62A5\u8868\u5E76\u652F\u4ED8\u9002\u7528\u7684\u7A0E\u6B3E\u3002\u6839\u636E\u6CF0\u56FD\u7A0E \u6CD5\uFF0C\u5411\u4E1A\u4E3B\u5206\u914D\u7684\u79DF\u91D1\u9700\u8981\u7F34\u7EB3 5% \u81F3 15% \u7684\u7A0E\u8D39\uFF0C\u5177\u4F53\u53D6\u51B3\u4E8E\u4E1A\u4E3B\u7684\u7A0E\u6536\u7ED3\u6784\u72B6\u51B5\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"\u5907\u6CE8\uFF1A\u9002\u7528\u7684\u7A0E\u7387\u662F\u672C\u5E38\u89C1\u95EE\u9898\u89E3\u7B54\u53D1\u5E03\u4E4B\u65E5\u7684\u73B0\u884C\u7A0E\u7387\uFF0C\u53EF\u80FD\u4F1A\u6709\u6240\u53D8\u5316\u3002\u623F\u5C4B\u6301\u6709\u8005\u5E94\u5BF9\u6709\u5173 \u5F53\u5C40\u53EF\u80FD\u5BF9\u5355\u4F4D\u5F81\u6536\u7684\u4E0E\u79DF\u91D1\u6709\u5173\u7684\u4EFB\u4F55\u6536\u5165\u548C\u4EFB\u4F55\u5176\u4ED6\u7A0E\u6536\u3001\u5173\u7A0E\u548C\u8D39\u7528\u8D1F\u8D23\u3002")))}},// =========== add new =========== //
{categoryId:4,question:{en:"What types of property management services are offered and what is the approximate cost?",ru:"Какие услуги по уходу недвижимости вы предлагаете и сколько примерно они стоят?",cn:"贵方提供哪些类型的物业管理服务？费用大概是多少？"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"In addition to common area property management by Laguna, optional property management services by Laguna are available to individual owners such as housekeeping, pool cleaning, gardening, routine and preventative maintenance, general repairs and pest control. Please contact the Property Sales Centre for further details.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0412 \u0434\u043E\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0435 \u043A \u0443\u0445\u043E\u0434\u0443 \u0437\u0430 \u043E\u0431\u0449\u0435\u0439 \u0442\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u0435\u0439 \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0430\u043C \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u0438 \u043F\u0440\u0435\u0434\u043B\u0430\u0433\u0430\u044E\u0442\u0441\u044F \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u0443\u0441\u043B\u0443\u0433\u0438. \u041E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u043D\u0438\u0435 \u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432, \u0443\u0447\u0430\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0445 \u0432 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0435 \u0430\u0440\u0435\u043D\u0434\u044B, \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u0441\u043E\u0433\u043B\u0430\u0441\u043D\u043E \u0443\u0441\u043B\u043E\u0432\u0438\u0439 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B. \u0421\u044E\u0434\u0430 \u0432\u043A\u043B\u044E\u0447\u0435\u043D\u044B \u0442\u0430\u043A\u0438\u0435 \u0443\u0441\u043B\u0443\u0433\u0438, \u043A\u0430\u043A \u0443\u0431\u043E\u0440\u043A\u0430, \u0447\u0438\u0441\u0442\u043A\u0430 \u0431\u0430\u0441\u0441\u0435\u0439\u043D\u0430, \u043E\u0437\u0435\u043B\u0435\u043D\u0435\u043D\u0438\u0435, \u0442\u0435\u043A\u0443\u0449\u0435\u0435 \u0438 \u043F\u0440\u043E\u0444\u0438\u043B\u0430\u043A\u0442\u0438\u0447\u0435\u0441\u043A\u043E\u0435 \u043E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u043D\u0438\u0435, \u043A\u0430\u043F\u0438\u0442\u0430\u043B\u044C\u043D\u044B\u0439 \u0440\u0435\u043C\u043E\u043D\u0442 \u0438 \u0431\u043E\u0440\u044C\u0431\u0430 \u0441 \u0432\u0440\u0435\u0434\u0438\u0442\u0435\u043B\u044F\u043C\u0438. \u0422\u0435\u043C \u043D\u0435 \u043C\u0435\u043D\u0435\u0435, \u0434\u0430\u043D\u043D\u044B\u0435 \u0443\u0441\u043B\u0443\u0433\u0438 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B \u0438 \u0434\u043B\u044F \u0434\u0440\u0443\u0433\u0438\u0445 \u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432. \u041F\u043E\u0436\u0430\u043B\u0443\u0439\u0441\u0442\u0430, \u043E\u0431\u0440\u0430\u0442\u0438\u0442\u0435\u0441\u044C \u0432 \u041E\u0442\u0434\u0435\u043B \u043F\u0440\u043E\u0434\u0430\u0436 \u0434\u043B\u044F \u0443\u0442\u043E\u0447\u043D\u0435\u043D\u0438\u044F \u0434\u0435\u0442\u0430\u043B\u0435\u0439.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u9664\u4E86\u516C\u5171\u533A\u57DF\u7684\u7269\u4E1A\u7BA1\u7406\u4E4B\u5916\uFF0C\u4E50\u53E4\u6D6A\u8FD8\u4E3A\u6BCF\u4F4D\u4E1A\u4E3B\u63D0\u4F9B\u9009\u62E9\u6027\u7684\u7269\u4E1A\u7BA1\u7406\u670D\u52A1\uFF0C\u4F8B\u5982\u5BB6\u653F,\u6CF3\u6C60\u6E05\u6D01,\u56ED\u827A,\u5B9A\u671F\u548C\u9884\u9632\u6027\u7EF4\u62A4,\u4E00\u822C\u7EF4\u4FEE\u53CA\u75C5\u866B\u5BB3\u9632\u6CBB\u3002\u8BF7\u8054\u7CFB\u7269\u4E1A\u9500\u552E\u4E2D\u5FC3\uFF0C\u8FDB\u4E00\u6B65\u4E86\u89E3\u8BE6\u60C5\u3002"))}},{categoryId:5,question:{en:"What privileges will I receive as an owner?",ru:"Какие льготы я получу как владелец недвижимости Laguna Park?",cn:"作为Laguna Park的业主，我将享有哪些优惠？"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Owners will receive a \u2018Sanctuary Club\u2019 card which entitles holders to discounts and privileges at all Banyan Tree, Angsana and Laguna Resorts worldwide."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null," ","30% discount on best available rates for hotel accommodation"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null," 25% discount on food and beverage"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null," 30% discount on golf green fees"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null," 20% discount on a-la-carte spa menu"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null," 15% discount on gallery merchandise"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null," 15% discount on in-house tours"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null," 15% discount on laundry"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null," 10% discount airport and ferry terminal transfers"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null," Priority wait-list on reservations"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null," Early check-in / late check-out")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"**Terms and conditions apply.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0412\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u044B \u043F\u043E\u043B\u0443\u0447\u0430\u0442 \u043A\u0430\u0440\u0442\u0443 \xABSanctuary Club\xBB, \u043F\u043E \u043A\u043E\u0442\u043E\u0440\u043E\u0439 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u044E\u0442\u0441\u044F \u043F\u0440\u0438\u0432\u0438\u043B\u0435\u0433\u0438\u0438 \u0438 \u0441\u043A\u0438\u0434\u043A\u0438 \u0432 \u043E\u0442\u0435\u043B\u044F\u0445 \u0438 \u043D\u0430 \u043A\u0443\u0440\u043E\u0440\u0442\u0430\u0445 Banyan Tree, Angsana \u0438 Laguna \u0432 \u0440\u0430\u0437\u043D\u044B\u0445 \u0441\u0442\u0440\u0430\u043D\u0430\u0445 \u043C\u0438\u0440\u0430."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u0441\u043A\u0438\u0434\u043A\u0430 30% \u043E\u0442 \u043D\u0430\u0438\u0431\u043E\u043B\u0435\u0435 \u0432\u044B\u0433\u043E\u0434\u043D\u043E\u0439 \u0446\u0435\u043D\u044B \u043D\u0430 \u043F\u0440\u043E\u0436\u0438\u0432\u0430\u043D\u0438\u0435 \u0432 \u043E\u0442\u0435\u043B\u0435"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u0441\u043A\u0438\u0434\u043A\u0430 25% \u043D\u0430 \u0435\u0434\u0443 \u0438 \u043D\u0430\u043F\u0438\u0442\u043A\u0438"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u0441\u043A\u0438\u0434\u043A\u0430 30% \u043E\u0442 \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u0438 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u043F\u043E\u043B\u0435\u043C \u0434\u043B\u044F \u0438\u0433\u0440\u044B \u0432 \u0433\u043E\u043B\u044C\u0444"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u0441\u043A\u0438\u0434\u043A\u0430 20% \u043D\u0430 \u0441\u0440\u0435\u0434\u0441\u0442\u0432\u0430 \u0434\u043B\u044F \u0441\u043F\u0430-\u043F\u0440\u043E\u0446\u0435\u0434\u0443\u0440 \u043F\u043E \u0432\u044B\u0431\u043E\u0440\u0443"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u0441\u043A\u0438\u0434\u043A\u0430 15% \u043D\u0430 \u043F\u043E\u043A\u0443\u043F\u043A\u0438 \u0432 \u0442\u043E\u0440\u0433\u043E\u0432\u043E\u0439 \u0433\u0430\u043B\u0435\u0440\u0435\u0435"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u0441\u043A\u0438\u0434\u043A\u0430 15% \u043D\u0430 \u0442\u0443\u0440\u044B, \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0443\u0435\u043C\u044B\u0435 \u043E\u0442\u0435\u043B\u0435\u043C"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u0441\u043A\u0438\u0434\u043A\u0430 15% \u043D\u0430 \u0443\u0441\u043B\u0443\u0433\u0438 \u043F\u0440\u0430\u0447\u0435\u0447\u043D\u043E\u0439"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u0441\u043A\u0438\u0434\u043A\u0430 10% \u043D\u0430 \u043F\u043E\u0435\u0437\u0434\u043A\u0438 \u0438\u0437/\u0434\u043E \u0430\u044D\u0440\u043E\u043F\u043E\u0440\u0442\u0430 \u0438 \u043F\u0440\u0438\u0447\u0430\u043B\u0430 \u043F\u0430\u0440\u043E\u043C\u043D\u043E\u0439 \u043F\u0435\u0440\u0435\u043F\u0440\u0430\u0432\u044B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u043F\u0440\u0438\u043E\u0440\u0438\u0442\u0435\u0442\u043D\u044B\u0439 \u0441\u0442\u0430\u0442\u0443\u0441 \u043F\u0440\u0438 \u043E\u0436\u0438\u0434\u0430\u043D\u0438\u0438 \u0441\u0432\u043E\u0431\u043E\u0434\u043D\u043E\u0433\u043E \u043D\u043E\u043C\u0435\u0440\u0430 \u0434\u043B\u044F \u0431\u0440\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u0440\u0430\u043D\u043D\u0438\u0439 \u0437\u0430\u0435\u0437\u0434 / \u043F\u043E\u0437\u0434\u043D\u0438\u0439 \u0432\u044B\u0435\u0437\u0434")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"**\u041C\u043E\u0433\u0443\u0442 \u0434\u0435\u0439\u0441\u0442\u0432\u043E\u0432\u0430\u0442\u044C \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u0438\u044F.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u4E1A\u4E3B\u5C06\u6536\u5230\u4E00\u5F20\u201C\u6995\u6E90\u4F1A\u4FF1\u4E50\u90E8\u201D\u5361\uFF0C\u83B7\u5F97\u5168\u7403\u6240\u6709\u60A6\u6995\u5E84,\u60A6\u693F\u53CA\u4E50\u53E4\u6D6A\u5EA6\u5047\u6751\u54C1\u724C\u7684\u7279\u6743\u548C\u6298\u6263\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u9152\u5E97\u4F4F\u5BBF\u6700\u4F18\u4EF7\u683C7\u6298"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u9910\u996E7.5\u6298"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u9AD8\u5C14\u592B\u679C\u5CAD\u8D397\u6298"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Spa\u6309\u6469\u65B9\u5F0F\u968F\u5FC3\u90098\u6298"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u96F6\u552E\u827A\u54C1\u5E97\u5546\u54C18.5\u6298"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u9152\u5E97\u63D0\u4F9B\u65C5\u884C8.5\u6298"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u6D17\u8863\u670D\u52A18.5\u6298"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u673A\u573A\u53CA\u6E21\u8239\u7801\u5934\u63A5\u90019\u6298"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u4F18\u5148\u9884\u8BA2"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u63D0\u65E9\u5165\u4F4F/\u5EF6\u8FDF\u9000\u623F")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"**\u9075\u5FAA\u9644\u5C5E\u6761\u6B3E\u3002"))}},{categoryId:5,question:{en:"Will the property come with a golf membership?",ru:"Будет членство в гольф клуб предоставляться владельцам недвижимости?",cn:"此物业业主可以获得高尔夫俱乐部的会员吗？"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Yes, owners will be provided with a 5 year golf membership at Laguna Phuket Golf Club.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0412\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0430\u043C \u0431\u0443\u0434\u0435\u0442 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0442\u044C\u0441\u044F\xA0\u0447\u043B\u0435\u043D\u0441\u0442\u0432\u043E \u0432 Laguna Phuket Golf Club \u043D\u0430 5 \u043B\u0435\u0442.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u662F\u7684\uFF0C\u4E1A\u4E3B\u5C06\u4EAB\u67095 \u5E74\u666E\u5409\u5C9B\u4E50\u53E4\u6D6A\u9AD8\u5C14\u592B\u4FF1\u4E50\u90E8\u4F1A\u7C4D\u3002"))}},{categoryId:6,question:{en:"What infrastructure facilities and services are provided?",ru:"К каким объектам инфраструктуры и услугам предоставляется доступ?",cn:""},displayOn:["en","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Being an owner in Asia\u2019s leading resort, a collection of hotels with their restaurants, rejuvenating spas, recreation facilities (including the acclaimed Laguna Phuket Golf Club) and Canal Village shops are all within easy reach via the inter-resort shuttle bus and ferry services."," "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"The infrastructure facilities and services meet the same high standards of the hotels and include:"," "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Security \u2013 24-hour security guards."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Roads \u2013 private internal roads."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Electricity \u2013 power provided by the Provincial Electricity Authority."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Water \u2013 water from reservoirs within the complex and/or the Provincial Water Authority."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Landscaped area \u2013 open space for recreational use by owners."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Communications \u2013 each property is provided with telephone lines. Broadband and cable TV connections may be separately arranged."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Garbage collection \u2013 provided on a daily basis by Laguna Service Company."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Estate Management \u2013 a dedicated team of Laguna Estate Services oversees the 24-hour security, garbage collection, gardening and landscaping, general cleaning and ongoing maintenance of common areas."))),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041B\u044E\u0431\u043E\u0439 \u0432\u043B\u0430\u0434\u0435\u043B\u0435\u0446 \u043E\u0431\u044A\u0435\u043A\u0442\u0430 \u043D\u0430 \u0442\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u0438 \u0432\u0435\u0434\u0443\u0449\u0435\u0433\u043E \u043A\u0443\u0440\u043E\u0440\u0442\u0430 \u0410\u0437\u0438\u0438 \u043C\u043E\u0436\u0435\u0442 \u0441 \u043B\u0435\u0433\u043A\u043E\u0441\u0442\u044C\u044E \u0434\u043E\u0431\u0440\u0430\u0442\u044C\u0441\u044F \u0434\u043E \u043B\u044E\u0431\u043E\u0433\u043E \u0438\u0437 \u043F\u044F\u0442\u0438 \u043E\u0442\u0435\u043B\u0435\u0439 \u0441 \u0440\u0435\u0441\u0442\u043E\u0440\u0430\u043D\u0430\u043C\u0438, \u0441\u0430\u043B\u043E\u043D\u043E\u0432, \u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0430\u0446\u0438\u0438 \u043E\u0442\u0434\u044B\u0445\u0430 \u0438 \u0434\u043E\u0441\u0443\u0433\u0430 (\u0432 \u0442\u043E\u043C \u0447\u0438\u0441\u043B\u0435 \u0438\u0437\u0432\u0435\u0441\u0442\u043D\u043E\u0433\u043E \u0433\u043E\u043B\u044C\u0444-\u043A\u043B\u0443\u0431\u0430 Laguna Phuket Golf \u0421ourse) \u0438 \u043C\u0430\u0433\u0430\u0437\u0438\u043D\u043E\u0432 Canal Village \u0441 \u043F\u043E\u043C\u043E\u0449\u044C\u044E \u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u044B\u0445 \u0430\u0432\u0442\u043E\u0431\u0443\u0441\u043E\u0432 \u0438 \u043F\u0430\u0440\u043E\u043C\u043E\u0432, \u043A\u0443\u0440\u0441\u0438\u0440\u0443\u044E\u0449\u0438\u0445 \u043F\u043E \u0432\u0441\u0435\u0439 \u0442\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u0438."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041F\u0440\u0435\u0434\u043B\u0430\u0433\u0430\u0435\u043C\u044B\u0435 \u0432\u044B\u0441\u043E\u043A\u043E\u043A\u0430\u0447\u0435\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u0435 \u0443\u0441\u043B\u0443\u0433\u0438 \u0438 \u0438\u043D\u0444\u0440\u0430\u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u0430:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u0411\u0435\u0437\u043E\u043F\u0430\u0441\u043D\u043E\u0441\u0442\u044C - 24-\u0447\u0430\u0441\u043E\u0432\u0430\u044F \u043E\u0445\u0440\u0430\u043D\u0430 \u043D\u0430 \u0432\u0445\u043E\u0434\u0435 \u043A\u0430\u0436\u0434\u043E\u0433\u043E \u043F\u043E\u0441\u0435\u043B\u043A\u0430."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u0414\u043E\u0440\u043E\u0433\u0438 \u0438 \u043E\u0433\u0440\u0430\u0436\u0434\u0435\u043D\u0438\u044F - \u0432 \u043A\u0430\u0436\u0434\u043E\u043C \u0436\u0438\u043B\u043E\u043C \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0441\u0435 \u043F\u0440\u043E\u043B\u043E\u0436\u0435\u043D\u044B \u0432\u043D\u0443\u0442\u0440\u0435\u043D\u043D\u0438\u0435 \u0434\u043E\u0440\u043E\u0433\u0438, \u0430 \u043F\u043E \u043F\u0435\u0440\u0438\u043C\u0435\u0442\u0440\u0443 \u0443\u0441\u0442\u0430\u043D\u043E\u0432\u043B\u0435\u043D\u044B \u043E\u0433\u0440\u0430\u0436\u0434\u0435\u043D\u0438\u044F."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u042D\u043B\u0435\u043A\u0442\u0440\u043E\u0441\u043D\u0430\u0431\u0436\u0435\u043D\u0438\u0435 - \u044D\u043B\u0435\u043A\u0442\u0440\u0438\u0447\u0435\u0441\u0442\u0432\u043E \u043F\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u041C\u0435\u0441\u0442\u043D\u044B\u043C \u0434\u0435\u043F\u0430\u0440\u0442\u0430\u043C\u0435\u043D\u0442\u043E\u043C \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u0441\u043D\u0430\u0431\u0436\u0435\u043D\u0438\u044F \u0422\u0430\u0438\u043B\u0430\u043D\u0434\u0430."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u0412\u043E\u0434\u043E\u043F\u0440\u043E\u0432\u043E\u0434 - \u043A\u0430\u0436\u0434\u043E\u0435 \u0437\u0434\u0430\u043D\u0438\u0435 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0435\u043D\u043E \u043A \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u043C\u0443 \u0438\u0441\u0442\u043E\u0447\u043D\u0438\u043A\u0443 \u0432\u043E\u0434\u044B, \u043A \u0440\u0435\u0437\u0435\u0440\u0432\u0443\u0430\u0440\u0443 \u0438/\u0438\u043B\u0438 \u0441\u043A\u0432\u0430\u0436\u0438\u043D\u0435."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u0417\u0435\u043B\u0435\u043D\u0430\u044F \u0437\u043E\u043D\u0430 - \u043E\u0431\u0449\u0430\u044F \u0442\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u044F \u0434\u043B\u044F \u0440\u0435\u043A\u0440\u0435\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0433\u043E \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0430\u043C\u0438."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u041A\u043E\u043C\u043C\u0443\u043D\u0438\u043A\u0430\u0446\u0438\u0438 - \u043A\u0430\u0436\u0434\u044B\u0439 \u0434\u043E\u043C \u0438\u043C\u0435\u0435\u0442 \u0434\u0432\u0435 \u0432\u043D\u0435\u0448\u043D\u0438\u0435 \u0442\u0435\u043B\u0435\u0444\u043E\u043D\u043D\u044B\u0435 \u043B\u0438\u043D\u0438\u0438. \u0418\u043D\u0442\u0435\u0440\u043D\u0435\u0442 \u0438 \u043A\u0430\u0431\u0435\u043B\u044C\u043D\u043E\u0435 \u0442\u0435\u043B\u0435\u0432\u0438\u0434\u0435\u043D\u0438\u0435 \u043F\u043E\u0434\u043A\u043B\u044E\u0447\u0430\u044E\u0442\u0441\u044F \u043E\u0442\u0434\u0435\u043B\u044C\u043D\u043E."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u0412\u044B\u0432\u043E\u0437 \u043C\u0443\u0441\u043E\u0440\u0430 - \u0435\u0436\u0435\u0434\u043D\u0435\u0432\u043D\u044B\u0439 \u0432\u044B\u0432\u043E\u0437 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0435\u0439 Laguna Service Company."," "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u0423\u0445\u043E\u0434 \u0437\u0430 \u0442\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u0435\u0439 - \u0441\u043F\u0435\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0435 \u0411\u044E\u0440\u043E \u043F\u043E \u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044E \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u044C\u044E \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0435\u0442 \u043D\u0430\u0434\u0437\u043E\u0440 \u0437\u0430 24-\u0447\u0430\u0441\u043E\u0432\u043E\u0439 \u043E\u0445\u0440\u0430\u043D\u043E\u0439, \u0432\u044B\u0432\u043E\u0437\u043E\u043C \u043C\u0443\u0441\u043E\u0440\u0430, \u043E\u0437\u0435\u043B\u0435\u043D\u0435\u043D\u0438\u0435\u043C \u0438 \u0431\u043B\u0430\u0433\u043E\u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u043E\u043C, \u0433\u0435\u043D\u0435\u0440\u0430\u043B\u044C\u043D\u043E\u0439 \u0443\u0431\u043E\u0440\u043A\u043E\u0439 \u0438 \u0442\u0435\u043A\u0443\u0449\u0438\u043C\u0438 \u0437\u0430\u0434\u0430\u0447\u0430\u043C\u0438 \u043F\u043E \u0443\u0445\u043E\u0434\u0443 \u0437\u0430 \u043C\u0435\u0441\u0442\u0430\u043C\u0438 \u043E\u0431\u0449\u0435\u0433\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0432 \u0437\u0434\u0430\u043D\u0438\u0438. \u041D\u0430\u0448 \u0437\u0430\u0431\u043E\u0442\u043B\u0438\u0432\u044B\u0439 \u043F\u0435\u0440\u0441\u043E\u043D\u0430\u043B \u0432\u0441\u0435\u0433\u0434\u0430 \u0440\u0430\u0434 \u043F\u043E\u043C\u043E\u0447\u044C \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0430\u043C \u0443\u0434\u043E\u0432\u043B\u0435\u0442\u0432\u043E\u0440\u0438\u0442\u044C \u043B\u044E\u0431\u043E\u0439 \u0440\u0430\u0437\u0443\u043C\u043D\u044B\u0439 \u0437\u0430\u043F\u0440\u043E\u0441."))),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null)}},{categoryId:6,question:{en:"What are the estimated common area charges?",ru:"Каков уровень платежей по уходу за общей территорией?",cn:""},displayOn:["en","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"The common areas are managed on behalf of owners by our dedicated estate management team. The annual charges that apply differ by development depending upon the total expenses and the total number of properties within a particular development among which the expenses will be proportionately divided. The initial estimated fee for Townhomes and Villas shall be Baht 400 / square wah per year."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"In addition, a sinking fund is established for each development. The purpose of the sinking fund is to accumulate funds for major infrastructure repairs and/or improvements which may be undertaken in the future. Rather than charge a large upfront amount, contributions will be sought on a regular basis so that the fund is built up over time. The initial estimated fee for the Townhomes and Villas shall be Baht 100 / square wah per year.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0423\u0445\u043E\u0434 \u0437\u0430 \u0442\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u0435\u0439 \u043E\u0431\u0449\u0435\u0433\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u043E\u0442 \u0438\u043C\u0435\u043D\u0438 \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0435\u0432 \u043D\u0430\u0448\u0435\u0439 \u0441\u043F\u0435\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0439 \u0441\u043B\u0443\u0436\u0431\u043E\u0439. \u0421\u0443\u043C\u043C\u0430 \u0435\u0436\u0435\u0433\u043E\u0434\u043D\u044B\u0445 \u043F\u043B\u0430\u0442\u0435\u0436\u0435\u0439 \u0437\u0430\u0432\u0438\u0441\u0438\u0442 \u043E\u0442 \u0441\u0430\u043C\u043E\u0433\u043E \u043E\u0431\u044A\u0435\u043A\u0442\u0430 \u0438 \u043E\u0431\u0449\u0435\u0433\u043E \u043A\u043E\u043B\u0438\u0447\u0435\u0441\u0442\u0432\u0430 \u043F\u043E\u043C\u0435\u0449\u0435\u043D\u0438\u0439 \u0432 \u0437\u0434\u0430\u043D\u0438\u0438, \u0441\u0440\u0435\u0434\u0438 \u043A\u043E\u0442\u043E\u0440\u044B\u0445 \u0431\u0443\u0434\u0443\u0442 \u043F\u0440\u043E\u043F\u043E\u0440\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u043E \u0440\u0430\u0437\u0434\u0435\u043B\u0435\u043D\u044B \u0440\u0430\u0441\u0445\u043E\u0434\u044B. \u0413\u043E\u0434\u0438\u0447\u043D\u044B\u0439 \u0432\u0437\u043D\u043E\u0441 \u0441\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 400 \u0431\u0430\u0442 / \u0432\u0430\u0445\xB2 \u0432 \u0433\u043E\u0434."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041A\u0440\u043E\u043C\u0435 \u0442\u043E\u0433\u043E, \u0434\u043B\u044F \u043A\u0430\u0436\u0434\u043E\u0433\u043E \u043F\u0440\u043E\u0435\u043A\u0442\u0430 \u0441\u043E\u0437\u0434\u0430\u0435\u0442\u0441\u044F \u0430\u043C\u043E\u0440\u0442\u0438\u0437\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u0444\u043E\u043D\u0434. \u0426\u0435\u043B\u044C \u0430\u043C\u043E\u0440\u0442\u0438\u0437\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0433\u043E \u0444\u043E\u043D\u0434\u0430 - \u043D\u0430\u043A\u043E\u043F\u043B\u0435\u043D\u0438\u0435 \u0441\u0440\u0435\u0434\u0441\u0442\u0432 \u043D\u0430 \u043A\u0430\u043F\u0438\u0442\u0430\u043B\u044C\u043D\u044B\u0439 \u0440\u0435\u043C\u043E\u043D\u0442 \u0438\u043D\u0444\u0440\u0430\u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u044B \u0438/\u0438\u043B\u0438 \u0443\u043B\u0443\u0447\u0448\u0435\u043D\u0438\u044F, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u0431\u0443\u0434\u0435\u0442 \u0440\u0435\u0448\u0435\u043D\u043E \u0441\u0434\u0435\u043B\u0430\u0442\u044C \u0432 \u0431\u0443\u0434\u0443\u0449\u0435\u043C. \u0424\u043E\u043D\u0434 \u0441\u043E\u0437\u0434\u0430\u0435\u0442\u0441\u044F \u043F\u0443\u0442\u0435\u043C \u043D\u0435\u0437\u043D\u0430\u0447\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0445 \u043F\u043E\u0441\u0442\u0443\u043F\u043B\u0435\u043D\u0438\u0439 \u043D\u0430 \u0440\u0435\u0433\u0443\u043B\u044F\u0440\u043D\u043E\u0439 \u043E\u0441\u043D\u043E\u0432\u0435, \u0447\u0442\u043E \u043F\u043E\u0437\u0432\u043E\u043B\u044F\u0435\u0442 \u0438\u0441\u043A\u043B\u044E\u0447\u0438\u0442\u044C \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E\u0441\u0442\u044C \u043E\u0442\u043F\u043B\u0430\u0442\u044B \u043A\u0440\u0443\u043F\u043D\u044B\u0445 \u0441\u0443\u043C\u043C \u043F\u0440\u0438 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E\u0441\u0442\u0438 \u0440\u0435\u043C\u043E\u043D\u0442\u0430. \u0413\u043E\u0434\u043E\u0432\u043E\u0439 \u0432\u0437\u043D\u043E\u0441 \u0441\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 100 \u0431\u0430\u0442/ \u0432\u0430\u0445\xB2 \u0432 \u0433\u043E\u0434.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null)}},{categoryId:6,question:{en:"Are pets allowed?",ru:"Можно иметь домашних животных",cn:""},displayOn:["en","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Yes, subject to rules and regulations.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Y\u0414\u0430, \u0441 \u043F\u0440\u0438\u043C\u0438\u043D\u0435\u043D\u0438\u0435\u043C \u043F\u0440\u0430\u0432\u0438\u043B \u0438 \u0443\u0441\u043B\u043E\u0432\u0438\u0439.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null)}},{categoryId:7,question:{en:"What are the terms of payment?",ru:"Какие условия оплаты существуют?",cn:"付款方式是什么？"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"There are 2 options available:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Option 1: 100% Payment upon purchase / during construction"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"100% payment upon purchase for already completed properties. Progressive payments for properties under construction are as per the table below."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Construction Payment Term"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"th-col2"},"Of Selling Price"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"st")," Payment upon signing contract"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"nd")," Payment when construction is 25% complete",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"rd")," Payment when construction is 50% complete",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"th")," Payment when construction is 75% complete",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"3")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"th")," Payment upon completion of construction"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{textAlign:"center"}},"Total"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"100%")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Notes:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",{className:"notes"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Areas and dimensions are approximate and subject to final survey and change.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Prices include fixed furnishing and do not include loose furniture.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Concrete structure substantially completed.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Roof, brickwork and rendering substantially completed.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Electrical conduits, pipework and plastering substantially completed.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Interest will be applied to the post-construction deferred balance as outlined under Financing Option"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Option 2: 50% payment upon purchase / during construction with 50% deferred payment over 1, 3 or 5 years"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"50% payment upon purchase for already completed properties. Progressive payments for properties under construction (50% during construction / 50% post construction) as per the table below"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Deferred Payment Plan"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"th-col2"},"Of Selling Price"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"st")," Payment upon signing contract"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"nd")," Payment when construction is 50% complete",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"10%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"rd")," Payment when construction is 75% complete",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"10%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"th")," Payment upon completion of construction",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"3")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"10%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"Post construction payments",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"4")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"50%")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Financing Options"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"th-col2"},"Interest Rate",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"(per annum)"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1 Year (4 quarterly installments)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"3%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3 Year (12 quarterly installments)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"5%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5 Year (20 quarterly installments)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"7%")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Notes:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",{className:"notes"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Areas and dimensions are approximate and subject to final survey and change.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Prices include fixed furnishing and do not include loose furniture.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Concrete structure substantially completed.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Roof, brickwork and rendering substantially completed.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Electrical conduits, pipework and plastering substantially completed.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Interest will be applied to the post-construction deferred balance as outlined under Financing Option"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"table-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"tr-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Price")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Reservation Deposit")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Construction Completion ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Payment 50% (Minus Deposit)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Remaining Post Finance 50%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:"3",className:"td-group-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Quaterly Installment"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"tr-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"1 Year (3%)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"3 Year (5%)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"5 Year (7%)"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"12,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"6,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,528,230"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"541,550"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"358,147")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"13,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"6,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"6,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,655,583"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"586,679"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"387,993")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"14,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"6,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"7,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,782,935"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"631,808"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"417,839")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"15,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"7,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"7,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,910,288"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"676,937"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"447,684")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"16,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"7,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"8,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,037,640"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"722,066"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"477,530")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"17,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"8,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"8,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,164,993"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"767,196"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"507,375")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"18,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"8,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"9,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,292,345"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"812,325"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"537,221")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"19,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"9,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"9,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,419,698"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"857,454"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"567,067")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"20,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"9,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"10,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,547,050"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"902,583"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"596,912")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"21,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"10,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"10,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,674,403"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"947,712"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"626,758")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"22,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"10,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"11,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,801,755"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"992,841"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"656,603")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Notes:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",{className:"notes"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"All amounts are stated in Thai Baht (THB). ")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"The above table sets out the estimated payments required under the respective payment plans for selling prices between THB 12,000,000 \u2013 22,000,000")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"The estimated payments are indicative only and the developer / seller does not accept any responsibility or liability whatsoever for any inaccuracies or omissions.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Payment terms are subject to change without notice.")))),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0414\u043B\u044F \u0432\u0441\u0435\u0445 \u043D\u043E\u0432\u044B\u0445 \u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u0438 \u043C\u044B \u043F\u0440\u0435\u0434\u043B\u0430\u0433\u0430\u0435\u043C 2 \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0430 \u043E\u043F\u043B\u0430\u0442\u044B. \u0423\u0441\u043B\u043E\u0432\u0438\u044F \u043E\u043F\u043B\u0430\u0442\u044B\uFF1A"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u0412\u0430\u0440\u0438\u0430\u043D\u0442 1: 100% \u043E\u043F\u043B\u0430\u0442\u0430 \u043F\u0440\u0438 \u043F\u043E\u043A\u0443\u043F\u043A\u0435 / \u0432\u043E \u0432\u0440\u0435\u043C\u044F \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"100% \u043E\u043F\u043B\u0430\u0442\u0430 \u043F\u0440\u0438 \u043F\u043E\u043A\u0443\u043F\u043A\u0435 \u0433\u043E\u0442\u043E\u0432\u044B\u0445 \u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432. \u041F\u0440\u043E\u0433\u0440\u0435\u0441\u0441\u0438\u0432\u043D\u044B\u0435 \u043F\u043B\u0430\u0442\u0435\u0436\u0438 \u0434\u043B\u044F \u0441\u0442\u0440\u043E\u044F\u0449\u0438\u0445\u0441\u044F \u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432 \u0432 \u0441 \u043D\u0438\u0436\u0435\u043F\u0440\u0438\u0432\u0435\u0434\u0435\u043D\u043D\u043E\u0439 \u0442\u0430\u0431\u043B\u0438\u0446\u0435."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"\u0420\u0435\u0437\u0435\u0440\u0432\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u0434\u0435\u043F\u043E\u0437\u0438\u0442"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"th-col2"},"\u0422\u0430\u0439\u0441\u043A\u0438\u0445 \u0411\u0430\u0442\u0430\u0445"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"\u0439")," \u043F\u043B\u0430\u0442\u0435\u0436 \u043F\u0440\u0438 \u043F\u043E\u0434\u043F\u0438\u0441\u0430\u043D\u0438\u0438 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"\u0439")," \u043F\u0440\u0438 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0438 25% \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0445 \u0440\u0430\u0431\u043E\u0442",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"\u0439")," \u043F\u0440\u0438 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0438 50% \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0445 \u0440\u0430\u0431\u043E\u0442",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"\u0439")," \u043F\u0440\u0438 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0438 75% \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0445 \u0440\u0430\u0431\u043E\u0442",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"3")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"\u0439")," \u043F\u0440\u0438 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u0438 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{textAlign:"center"}},"\u0418\u0442\u043E\u0433\u043E"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"100%")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u041F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0435:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",{className:"notes"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u041F\u043B\u043E\u0449\u0430\u0434\u0438 \u0438 \u0440\u0430\u0437\u043C\u0435\u0440\u044B \u0443\u043A\u0430\u0437\u0430\u043D\u044B \u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0438 \u043C\u043E\u0433\u0443\u0442 \u0438\u0437\u043C\u0435\u043D\u044F\u0442\u044C\u0441\u044F \u043F\u043E \u0438\u0442\u043E\u0433\u0430\u043C \u0444\u0438\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0438\u0437\u043C\u0435\u0440\u0435\u043D\u0438\u0439.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u0426\u0435\u043D\u044B \u0432\u043A\u043B\u044E\u0447\u0430\u044E\u0442 \u0432\u0441\u0442\u0440\u043E\u0435\u043D\u043D\u0443\u044E \u043C\u0435\u0431\u043B\u0438\u0440\u043E\u0432\u043A\u0443; \u043D\u0435\u0432\u0441\u0442\u0440\u043E\u0435\u043D\u043D\u0430\u044F \u043C\u0435\u0431\u0435\u043B\u044C \u043D\u0435 \u0432\u043A\u043B\u044E\u0447\u0435\u043D\u0430.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u0411\u0435\u0442\u043E\u043D\u043D\u0430\u044F \u043A\u043E\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0438\u044F \u0432 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u043C \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0430.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u041A\u0440\u044B\u0448\u0430, \u0443\u043A\u043B\u0430\u0434\u043A\u0430 \u043A\u0438\u0440\u043F\u0438\u0447\u0430 \u0438 \u043D\u0430\u0440\u0443\u0436\u043D\u0430\u044F \u043E\u0442\u0434\u0435\u043B\u043A\u0430 \u0432 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u043C \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u044B.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u042D\u043B\u0435\u043A\u0442\u0440\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u043F\u0440\u043E\u0432\u043E\u0434\u043A\u0430, \u0443\u043A\u043B\u0430\u0434\u043A\u0430 \u0432\u043E\u0434\u043E\u043F\u0440\u043E\u0432\u043E\u0434\u043D\u044B\u0445 \u0442\u0440\u0443\u0431 \u0438 \u0432\u043D\u0443\u0442\u0440\u0435\u043D\u043D\u044F\u044F \u043E\u0442\u0434\u0435\u043B\u043A\u0430 \u0432 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u043C \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u044B.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u041F\u0440\u043E\u0446\u0435\u043D\u0442\u044B \u043F\u043E \u0440\u0430\u0441\u0441\u0440\u043E\u0447\u043A\u0435 \u0431\u0443\u0434\u0443\u0442 \u043D\u0430\u0447\u0438\u0441\u043B\u0435\u043D\u044B \u043D\u0430 \u043E\u0442\u043B\u043E\u0436\u0435\u043D\u043D\u044B\u0435 \u043F\u043B\u0430\u0442\u0435\u0436\u0438 \u043F\u043E \u043E\u043A\u043E\u043D\u0447\u0430\u043D\u0438\u0438 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430, \u043A\u0430\u043A \u0443\u043A\u0430\u0437\u0430\u043D\u043E \u0432 \u0442\u0430\u0431\u043B\u0438\u0446\u0435 \xAB\u0412\u0430\u0440\u0438\u0430\u043D\u0442\u044B \u0444\u0438\u043D\u0430\u043D\u0441\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F\xBB"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u0412\u0430\u0440\u0438\u0430\u043D\u0442 2: \u041E\u043F\u043B\u0430\u0442\u044B \u0432 \u0440\u0430\u0441\u0441\u0440\u043E\u0447\u043A\u0443"),"\u041F\u0435\u0440\u0432\u044B\u0435 50% \u043F\u043E \u044D\u0442\u0430\u043F\u0430\u043C \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 \u0438 \u0432\u0442\u043E\u0440\u044B\u0435 50% \u0432 \u0440\u0430\u0441\u0441\u0440\u043E\u0447\u043A\u0443 \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 1, 3 \u0438\u043B\u0438 5 \u043B\u0435\u0442 \u0432 \u0437\u0430\u0432\u0438\u0441\u0438\u043C\u043E\u0441\u0442\u0438 \u043E\u0442 \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u043E\u0433\u043E \u043F\u043B\u0430\u043D\u0430 \u043E\u043F\u043B\u0430\u0442\u044B.",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"50% \u043E\u043F\u043B\u0430\u0442\u044B \u043F\u0440\u0438 \u043F\u043E\u043A\u0443\u043F\u043A\u0435 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043D\u044B\u0445 \u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432 \u0438 \u043E\u043F\u043B\u0430\u0442\u0430 \u0432 \u0440\u0430\u0441\u0441\u0440\u043E\u0447\u043A\u0443 \u0434\u043B\u044F \u0441\u0442\u0440\u043E\u044F\u0449\u0438\u0445\u0441\u044F \u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432 (50% \u043F\u043E \u044D\u0442\u0430\u043F\u0430\u043C \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 / 50% \u043F\u043E\u0441\u043B\u0435 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430) \u0441\u043C\u043E\u0442\u0440\u0438\u0442\u0435 \u0442\u0430\u0431\u043B\u0438\u0446\u0443 \u0438\u0437\u043B\u043E\u0436\u0435\u043D\u043D\u0443\u044E \u043D\u0438\u0436\u0435."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"\u0420\u0435\u0437\u0435\u0440\u0432\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u0434\u0435\u043F\u043E\u0437\u0438\u0442"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"th-col2"},"\u0422\u0430\u0439\u0441\u043A\u0438\u0445 \u0411\u0430\u0442\u0430\u0445"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"\u0439")," \u043F\u043B\u0430\u0442\u0435\u0436 \u043F\u0440\u0438 \u043F\u043E\u0434\u043F\u0438\u0441\u0430\u043D\u0438\u0438 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"\u0439")," \u043F\u0440\u0438 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0438 50% \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0445 \u0440\u0430\u0431\u043E\u0442",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"10%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"\u0439")," \u043F\u0440\u0438 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0438 75% \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0445 \u0440\u0430\u0431\u043E\u0442",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"10%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"\u0439")," \u043F\u0440\u0438 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u0438 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"3")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"10%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u041F\u043B\u0430\u0442\u0435\u0436 \u043F\u043E\u0441\u043B\u0435 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"4")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"50%")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"\u0412\u0430\u0440\u0438\u0430\u043D\u0442\u044B \u0444\u0438\u043D\u0430\u043D\u0441\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"th-col2"},"\u041F\u0440\u043E\u0446\u0435\u043D\u0442\u043D\u0430\u044F",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"\u0441\u0442\u0430\u0432\u043A\u0430"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1 \u0433\u043E\u0434 (4 \u0435\u0436\u0435\u043A\u0432\u0430\u0440\u0442\u0430\u043B\u044C\u043D\u044B\u0445 \u043F\u043B\u0430\u0442\u0435\u0436\u0430)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"3%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3 \u0433\u043E\u0434\u0430 (12 \u0435\u0436\u0435\u043A\u0432\u0430\u0440\u0442\u0430\u043B\u044C\u043D\u044B\u0445 \u043F\u043B\u0430\u0442\u0435\u0436\u0435\u0439)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"5%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5 \u043B\u0435\u0442 (20 \u0435\u0436\u0435\u043A\u0432\u0430\u0440\u0442\u0430\u043B\u044C\u043D\u044B\u0445 \u043F\u043B\u0430\u0442\u0435\u0436\u0435\u0439)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"7%")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u041F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0435:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",{className:"notes"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u041F\u043B\u043E\u0449\u0430\u0434\u0438 \u0438 \u0440\u0430\u0437\u043C\u0435\u0440\u044B \u0443\u043A\u0430\u0437\u0430\u043D\u044B \u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0438 \u043C\u043E\u0433\u0443\u0442 \u0438\u0437\u043C\u0435\u043D\u044F\u0442\u044C\u0441\u044F \u043F\u043E \u0438\u0442\u043E\u0433\u0430\u043C \u0444\u0438\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0438\u0437\u043C\u0435\u0440\u0435\u043D\u0438\u0439.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u0426\u0435\u043D\u044B \u0432\u043A\u043B\u044E\u0447\u0430\u044E\u0442 \u0432\u0441\u0442\u0440\u043E\u0435\u043D\u043D\u0443\u044E \u043C\u0435\u0431\u043B\u0438\u0440\u043E\u0432\u043A\u0443; \u043D\u0435\u0432\u0441\u0442\u0440\u043E\u0435\u043D\u043D\u0430\u044F \u043C\u0435\u0431\u0435\u043B\u044C \u043D\u0435 \u0432\u043A\u043B\u044E\u0447\u0435\u043D\u0430.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u0411\u0435\u0442\u043E\u043D\u043D\u0430\u044F \u043A\u043E\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0438\u044F \u0432 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u043C \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0430.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u041A\u0440\u044B\u0448\u0430, \u0443\u043A\u043B\u0430\u0434\u043A\u0430 \u043A\u0438\u0440\u043F\u0438\u0447\u0430 \u0438 \u043D\u0430\u0440\u0443\u0436\u043D\u0430\u044F \u043E\u0442\u0434\u0435\u043B\u043A\u0430 \u0432 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u043C \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u044B.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u042D\u043B\u0435\u043A\u0442\u0440\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u043F\u0440\u043E\u0432\u043E\u0434\u043A\u0430, \u0443\u043A\u043B\u0430\u0434\u043A\u0430 \u0432\u043E\u0434\u043E\u043F\u0440\u043E\u0432\u043E\u0434\u043D\u044B\u0445 \u0442\u0440\u0443\u0431 \u0438 \u0432\u043D\u0443\u0442\u0440\u0435\u043D\u043D\u044F\u044F \u043E\u0442\u0434\u0435\u043B\u043A\u0430 \u0432 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u043C \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u044B.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u041F\u0440\u043E\u0446\u0435\u043D\u0442\u044B \u043F\u043E \u0440\u0430\u0441\u0441\u0440\u043E\u0447\u043A\u0435 \u0431\u0443\u0434\u0443\u0442 \u043D\u0430\u0447\u0438\u0441\u043B\u0435\u043D\u044B \u043D\u0430 \u043E\u0442\u043B\u043E\u0436\u0435\u043D\u043D\u044B\u0435 \u043F\u043B\u0430\u0442\u0435\u0436\u0438 \u043F\u043E \u043E\u043A\u043E\u043D\u0447\u0430\u043D\u0438\u0438 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430, \u043A\u0430\u043A \u0443\u043A\u0430\u0437\u0430\u043D\u043E \u0432 \u0442\u0430\u0431\u043B\u0438\u0446\u0435 \xAB\u0412\u0430\u0440\u0438\u0430\u043D\u0442\u044B \u0444\u0438\u043D\u0430\u043D\u0441\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F\xBB"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"table-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"tr-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u0426\u0435\u043D\u0430")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u0414\u0435\u043F\u043E\u0437\u0438\u0442")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u041E\u043F\u043B\u0430\u0442\u0430 50% \u043F\u0440\u0438",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"\u043F\u043E\u0434\u043F\u0438\u0441\u0430\u043D\u0438\u0435 \u043A\u043E\u043D\u0442\u0440\u0430\u043A\u0442\u0430",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"(\u043C\u0438\u043D\u0443\u0441 \u0434\u0435\u043F\u043E\u0437\u0438\u0442)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u041E\u043F\u043B\u0430\u0442\u0430 \u0432\u0442\u043E\u0440\u044B\u0445",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"50% \u043F\u043E\u0441\u043B\u0435",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"\u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:"3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u0415\u0436\u0435\u043C\u0435\u0441\u044F\u0447\u043D\u044B\u0435 \u043F\u043B\u0430\u0442\u0435\u0436\u0438"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"tr-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"1 \u0433\u043E\u0434 (3%)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"3 \u0433\u043E\u0434\u0430 (5%)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"5 \u0433\u043E\u0434 (7%)"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"12,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"6,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,528,230"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"541,550"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"358,147")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"13,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"6,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"6,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,655,583"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"586,679"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"387,993")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"14,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"6,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"7,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,782,935"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"631,808"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"417,839")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"15,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"7,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"7,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,910,288"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"676,937"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"447,684")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"16,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"7,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"8,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,037,640"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"722,066"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"477,530")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"17,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"8,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"8,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,164,993"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"767,196"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"507,375")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"18,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"8,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"9,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,292,345"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"812,325"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"537,221")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"19,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"9,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"9,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,419,698"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"857,454"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"567,067")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"20,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"9,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"10,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,547,050"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"902,583"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"596,912")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"21,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"10,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"10,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,674,403"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"947,712"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"626,758")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"22,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"10,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"11,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,801,755"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"992,841"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"656,603")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u041F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u044F:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",{className:"notes"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u0412\u0441\u0435 \u0441\u0443\u043C\u043C\u044B \u0443\u043A\u0430\u0437\u0430\u043D\u044B \u0432 \u0411\u0430\u0442\u0430\u0445")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u0412 \u0442\u0430\u0431\u043B\u0438\u0446\u0435 \u0432\u044B\u0448\u0435 \u0443\u043A\u0430\u0437\u0430\u043D\u044B \u043F\u0440\u0435\u0434\u043F\u043E\u043B\u0430\u0433\u0430\u0435\u043C\u044B\u0435 \u043F\u043B\u0430\u0442\u0435\u0436\u0438, \u0432 \u0440\u0430\u043C\u043A\u0430\u0445 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0445 \u043F\u043B\u0430\u043D\u043E\u0432 \u043E\u043F\u043B\u0430\u0442\u044B \u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432, \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C\u044E \u043C\u0435\u0436\u0434\u0443 12,000,000-22,000,000 \u0411\u0430\u0442\u0442.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u041F\u043B\u0430\u0442\u0435\u0436\u0438 \u044F\u0432\u043B\u044F\u044E\u0442\u0441\u044F \u043B\u0438\u0448\u044C \u043E\u0440\u0438\u0435\u043D\u0442\u0438\u0440\u043E\u0432\u043E\u0447\u043D\u044B\u043C\u0438 \u0438 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C / \u043F\u0440\u043E\u0434\u0430\u0432\u0435\u0446 \u043D\u0435 \u043D\u0435\u0441\u0435\u0442 \u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u044C \u0437\u0430 \u043B\u044E\u0431\u044B\u0435 \u043D\u0435\u0442\u043E\u0447\u043D\u043E\u0441\u0442\u0438 \u0438\u043B\u0438 \u043E\u0448\u0438\u0431\u043A\u0438.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u0423\u0441\u043B\u043E\u0432\u0438\u044F \u043E\u043F\u043B\u0430\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0431\u044B\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u044B \u0431\u0435\u0437 \u043F\u0440\u0435\u0434\u0432\u0430\u0440\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0433\u043E \u0443\u0432\u0435\u0434\u043E\u043C\u043B\u0435\u043D\u0438\u044F.")))),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u5BF9\u4E8E\u6240\u6709\u51FA\u552E\u7684\u65B0\u7269\u4E1A\uFF0C\u6211\u4EEC\u63D0\u4F9B\u4E24\u79CD\u4ED8\u6B3E\u8BA1\u5212\u3002 \u4ED8\u6B3E\u65B9\u5F0F\u5982\u4E0B\uFF1A"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u9009\u62E91\uFF1A100% \u8D2D\u4E70\u4EF7\u683C\u4ED8\u6B3E\u6216\u5EFA\u9020\u671F\u95F4\u4ED8\u6B3E"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"\u5BF9\u4E8E\u5DF2\u5EFA\u6210\u7269\u4E1A\uFF0C\u4F9D\u636E\u8D2D\u4E70\u4EF7\u683C100%\u4ED8\u6B3E\u3002\u5BF9\u4E8E\u5728\u5EFA\u7269\u4E1A\uFF0C\u4F9D\u636E\u4E0B\u8868\u6309\u8FDB\u5EA6\u5206\u671F\u4ED8\u6B3E\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"\u6309\u5EFA\u9020\u5206\u671F\u4ED8\u6B3E"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"th-col2"},"\u9500\u552E\u4EF7\u683C"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u9996\u7B14\u6B3E\u9879\u4E8E\u7B7E\u8BA2\u8D2D\u4E70\u5408\u540C\u652F\u4ED8"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"\u9500\u552E\u4EF7\u768420%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u7B2C\u4E8C\u7B14\u6B3E\u9879\u4E8E\u5DE5\u7A0B\u5B8C\u621025%\u65F6\u652F\u4ED8",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"\u9500\u552E\u4EF7\u768420%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u7B2C\u4E09\u7B14\u6B3E\u9879\u4E8E\u5DE5\u7A0B\u5B8C\u621050%\u65F6\u652F\u4ED8",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"\u9500\u552E\u4EF7\u768420%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u7B2C\u56DB\u7B14\u6B3E\u9879\u4E8E\u5DE5\u7A0B\u5B8C\u621075%\u65F6\u652F\u4ED8",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"3")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"\u9500\u552E\u4EF7\u768420%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u7B2C\u4E94\u7B14\u6B3E\u9879\u4E8E\u5DE5\u7A0B\u5B8C\u6210\u65F6\u652F\u4ED8"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"\u9500\u552E\u4EF7\u768420%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{textAlign:"center"}},"\u603B\u989D"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"\u9500\u552E\u4EF7\u683C\u7684100%")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u5907\u6CE8\uFF1A"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",{className:"notes"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u9762\u79EF\u4E0E\u5C3A\u5BF8\u4EC5\u4E3A\u9884\u4F30\uFF0C\u5B9E\u9645\u6570\u636E\u4EE5\u6700\u7EC8\u6D4B\u7ED8\u4E3A\u51C6")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u4EF7\u683C\u5305\u542B\u88C5\u4FEE\uFF0C\u4E0D\u5305\u542B\u53EF\u79FB\u52A8\u5BB6\u5177")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u6DF7\u51DD\u571F\u57FA\u7840\u7ED3\u6784\u5DE5\u7A0B\u5B8C\u6210")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u5916\u5899\u53CA\u5C01\u9876\u5DE5\u7A0B\u5B8C\u6210")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u6C34\u7535\u5DE5\u7A0B\uFF0C\u7BA1\u9053\u53CA\u6C34\u6CE5\u62B9\u5E73\u5DE5\u7A0B\u5B8C\u6210")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u5229\u606F\u5C06\u6839\u636E\u6240\u9009\u4ED8\u6B3E\u65B9\u6848\u4EE5\u622A\u81F3\u7AE3\u5DE5\u4ED8\u6B3E\u4E4B\u540E\u7684\u5269\u4F59\u623F\u6B3E\u4F59\u989D\u8BA1\u7B97"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u9009\u62E92\uFF1A50% \u8D2D\u4E70\u4EF7\u683C\u4ED8\u6B3E\u6216\u5EFA\u9020\u671F\u95F4\u4ED8\u6B3E\uFF0C50%\u5EF6\u671F1\u5E74,3\u5E74\u62165\u5E74\u4ED8\u6B3E\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"\u5BF9\u4E8E\u5DF2\u5EFA\u6210\u7269\u4E1A\uFF0C\u4F9D\u636E\u8D2D\u4E70\u4EF7\u683C\u768450%\u4ED8\u6B3E\u3002\u5BF9\u4E8E\u5728\u5EFA\u7269\u4E1A\uFF0C\u4F9D\u636E\u4E0B\u8868\u6309\u8FDB\u5EA6\u5206\u671F\u4ED8\u6B3E\uFF0850%\u5EFA\u9020\u671F\u95F4\u652F\u4ED8 / 50%\u5EFA\u9020\u5B8C\u6210\u65F6\u652F\u4ED8\uFF09\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"\u9884\u5B9A\u91D1"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"th-col2"},"\u6CF0\u94E2"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u9996\u7B14\u6B3E\u9879\u4E8E\u7B7E\u8BA2\u8D2D\u4E70\u5408\u540C\u652F\u4ED8"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"\u9500\u552E\u4EF7\u768420%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u7B2C\u4E8C\u7B14\u6B3E\u9879\u4E8E\u5DE5\u7A0B\u5B8C\u621050%\u4E4B\u65F6\u652F\u4ED8",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"\u9500\u552E\u4EF7\u768410%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u7B2C\u4E09\u7B14\u6B3E\u9879\u4E8E\u5DE5\u7A0B\u5B8C\u621075%\u65F6\u652F\u4ED8",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"\u9500\u552E\u4EF7\u768410%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u7B2C\u56DB\u7B14\u6B3E\u9879\u4E8E\u5DE5\u7A0B\u5B8C\u5DE5\u65F6\u652F\u4ED8",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"3")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"\u9500\u552E\u4EF7\u768410%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u5EFA\u6210\u540E\u652F\u4ED8",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"4")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"\u9500\u552E\u4EF7\u768450%")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"\u8D22\u52A1\u9009\u62E9"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"th-col2"},"\u5229\u7387"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1\u5E74 (4 \u4E2A\u5B63\u5EA6\u5206\u671F)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"3%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3\u5E74 (12 \u4E2A\u5B63\u5EA6\u5206\u671F)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"5%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5\u5E74 (20 \u4E2A\u5B63\u5EA6\u5206\u671F)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"7%")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u5907\u6CE8\uFF1A"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",{className:"notes"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u9762\u79EF\u4E0E\u5C3A\u5BF8\u4EC5\u4E3A\u9884\u4F30\uFF0C\u5B9E\u9645\u6570\u636E\u4EE5\u6700\u7EC8\u6D4B\u7ED8\u4E3A\u51C6")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u4EF7\u683C\u5305\u542B\u88C5\u4FEE\uFF0C\u4E0D\u5305\u542B\u53EF\u79FB\u52A8\u5BB6\u5177")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u6DF7\u51DD\u571F\u57FA\u7840\u7ED3\u6784\u5DE5\u7A0B\u5B8C\u6210")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u5916\u5899\u53CA\u5C01\u9876\u5DE5\u7A0B\u5B8C\u6210")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u6C34\u7535\u5DE5\u7A0B\uFF0C\u7BA1\u9053\u53CA\u6C34\u6CE5\u62B9\u5E73\u5DE5\u7A0B\u5B8C\u6210")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u5229\u606F\u5C06\u6839\u636E\u6240\u9009\u4ED8\u6B3E\u65B9\u6848\u4EE5\u622A\u81F3\u7AE3\u5DE5\u4ED8\u6B3E\u4E4B\u540E\u7684\u5269\u4F59\u623F\u6B3E\u4F59\u989D\u8BA1\u7B97"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"table-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"tr-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u552E\u4EF7")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u9884\u5B9A\u91D1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u65BD\u5DE5\u671F\u95F4\u4ED8 \u6B3E 50% \uFF08\u51CF\u53BB\u5B9A\u91D1\uFF09")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u7AE3\u5DE5\u540E\u4ED8\u6B3E \u5269\u4F5950%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:"3"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u6309\u6708\u5206\u671F\u4ED8\u6B3E"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"tr-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"1 \u5E74 (3%)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"3 \u5E74 (5%)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"5 \u5E74 (7%)"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"12,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"6,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,528,230"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"541,550"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"358,147")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"13,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"6,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"6,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,655,583"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"586,679"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"387,993")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"14,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"6,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"7,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,782,935"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"631,808"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"417,839")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"15,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"7,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"7,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,910,288"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"676,937"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"447,684")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"16,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"7,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"8,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,037,640"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"722,066"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"477,530")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"17,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"8,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"8,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,164,993"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"767,196"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"507,375")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"18,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"8,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"9,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,292,345"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"812,325"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"537,221")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"19,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"9,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"9,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,419,698"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"857,454"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"567,067")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"20,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"9,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"10,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,547,050"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"902,583"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"596,912")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"21,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"10,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"10,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,674,403"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"947,712"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"626,758")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"22,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"10,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"11,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,801,755"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"992,841"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"656,603")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u5907\u6CE8\uFF1A"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",{className:"notes"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u6240\u6709\u91D1\u989D\u5747\u4EE5\u6CF0\u94E2\u8868\u793A\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u4E0A\u8868\u5217\u51FA\u4E86\u9500\u552E\u4EF7\u683C\u4E3A 12,000,000-22,000,000 \u6CF0\u94E2\u65F6\uFF0C\u76F8\u5E94\u4ED8\u6B3E\u8BA1\u5212\u6240\u9700\u652F\u4ED8\u7684\u9884\u8BA1\u91D1\u989D\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u9884\u8BA1\u4ED8\u6B3E\u989D\u4EC5\u4F5C\u793A\u610F\u53C2\u8003\u7528\u9014\u3002\u5982\u6709\u9519\u6F0F\uFF0C\u5F00\u53D1\u5546/\u9500\u552E\u65B9\u6982\u4E0D\u8D1F\u8D23\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u4ED8\u6B3E\u65B9\u5F0F\u5982\u6709\u66F4\u6539\uFF0C\u6055\u4E0D\u53E6\u884C\u901A\u77E5\u3002"))))}}];

/***/ }),
/* 933 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return PhuketSkypark; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_skrollr__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_skrollr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_skrollr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_scroll__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_helmet__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hoc__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_language__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_location__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_phuket_skypark__ = __webpack_require__(934);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Gallery__ = __webpack_require__(994);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Concept__ = __webpack_require__(995);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Faq__ = __webpack_require__(996);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Destination__ = __webpack_require__(997);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__TheSanctuaryclub__ = __webpack_require__(998);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Siteplan__ = __webpack_require__(999);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Masterplan__ = __webpack_require__(1001);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Residences__ = __webpack_require__(1002);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Ebrochure__ = __webpack_require__(1003);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var page="phuket-skypark";var sections=[{key:"gallery",label:"Gallery"},{key:"concept",label:"Concept"},{key:"masterplan",label:"Master Plan"},{key:"siteplan",label:"Site Plan"},{key:"residences",label:{en:"Room Types",ru:"Типы квартир",cn:"房型"},subitem:[{key:"studio",label:{en:"STUDIO",ru:"Студии",cn:"一室公寓"},path:"/:language/projects/phuket/skypark/",currentSection:0},{key:"one-bedroom",label:{en:"1 BEDROOM",ru:"Одна спальня",cn:"一卧室套房"},path:"/:language/projects/phuket/skypark/",currentSection:1},{key:"two-bedroom",label:{en:"2 BEDROOM",ru:"Две спальни",cn:"两卧室套房"},path:"/:language/projects/phuket/skypark/",currentSection:2}]},{key:"destination",label:"Destination"},{key:"sanctuary-club",label:"The Santuary Club"},{key:"faq",label:"FAQ",hideOnMobile:true},{key:"e-brochure",label:"E-Brochure",hideOnMobile:true}];var mapStateToProps=function mapStateToProps(state){return Object.assign({},state);};var actionToProps={switchLanguage:__WEBPACK_IMPORTED_MODULE_7__actions_language__["a" /* switchLanguage */],switchLocation:__WEBPACK_IMPORTED_MODULE_8__actions_location__["a" /* switchLocation */],initAppPhuketSkypark:__WEBPACK_IMPORTED_MODULE_9__actions_phuket_skypark__["a" /* initAppPhuketSkypark */]};var PhuketSkypark=(_dec=Object(__WEBPACK_IMPORTED_MODULE_6__hoc__["b" /* withRedux */])(mapStateToProps,actionToProps),_dec(_class=function(_Component){_inherits(PhuketSkypark,_Component);function PhuketSkypark(props){_classCallCheck(this,PhuketSkypark);var _this=_possibleConstructorReturn(this,(PhuketSkypark.__proto__||Object.getPrototypeOf(PhuketSkypark)).call(this,props));_this.handleWheel=function(evt){if(evt.deltaY>0){var atBottomOfSection=_this.headerRef.current.atBottomOfSection();if(atBottomOfSection){evt.preventDefault();evt.stopPropagation();evt.returnValue=false;// console.log('evt', evt.deltaY);
_this.headerRef.current.handleScrollDown();}}if(evt.deltaY<0){var atTopOfSection=_this.headerRef.current.atTopOfSection();if(atTopOfSection){evt.preventDefault();evt.stopPropagation();evt.returnValue=false;// console.log('evt', evt.deltaY);
_this.headerRef.current.handleScrollUp();}}};_this.setLanguage=function(language){_this.props.actions.switchLanguage(language);};_this.setLocation=function(location){_this.props.actions.switchLocation(location);};_this.fetchData=function(){_this.props.actions.initAppPhuketSkypark();};_this.renderSectionWithId=function(component,id){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_scroll__["Element"],{name:id},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("section",{id:id},component));};_this.headerRef=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createRef();return _this;}_createClass(PhuketSkypark,[{key:"componentDidMount",value:function componentDidMount(){this.setLanguage(this.props.match.params.language);this.setLocation(this.props.route.key);this.fetchData();}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps){var currentLanguage=prevProps.match.params.language;var nextLanguage=this.props.match.params.language;if(currentLanguage!==nextLanguage){this.setLanguage(nextLanguage);}}},{key:"render",value:function render(){var pageData=__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(this.props,page+".data");var isMobile=__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(this.props,"device.isMobile");var currentLanguage=__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(this.props,"language.currentActive");console.log("pageData-Skypark",{page:page,pageData:pageData});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_skrollr__["ParallaxProvider"],{init:{smoothScrollingDuration:500,smoothScrolling:true,forceHeight:false}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_helmet__["Helmet"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("title",null,"New Beachfront Condo For sale near Phuket | Laguna Property"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("meta",{name:"description",content:"Your dream beachfront property awaits. Laguna Property is a leading and trusted property developer since 1993. Discover Phuket\u2019s newest beachfront condos on our page."}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("meta",{name:"keywords",content:"affordable condo for sale phuket,beachfront condo for sale phuket,apartment for sale near Phuket beach,condo for sale near bang tao beach,new beachfront condo phuket,new condo sales phuket,2 bedroom condos for sale phuket,1 bedroom condo for sale phuket,1 bed condo for sale phuket,2 bed condo for sale phuket"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["f" /* Header */],{mainLogo:Object(__WEBPACK_IMPORTED_MODULE_10__utils__["a" /* assetsPath */])()+"/images/logo-laguna-property.svg",subLogo:Object(__WEBPACK_IMPORTED_MODULE_10__utils__["a" /* assetsPath */])(page)+"/images/logo/logo-navbar.png",language:currentLanguage,projectSections:sections,wrappedComponentRef:this.headerRef}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"main-content skypark-page",disable_onWheel:this.handleWheel},this.renderSectionWithId(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Gallery__["a" /* default */],Object.assign({},__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"gallery"),{page:page})),"gallery"),this.renderSectionWithId(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Concept__["a" /* default */],{imageSlider:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"concept.imageSlider"),content:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"concept.content"),page:page}),"concept"),this.renderSectionWithId(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Masterplan__["a" /* default */],{map:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"masterPlan.maps"),page:page}),"masterplan"),this.renderSectionWithId(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Siteplan__["a" /* default */],{map:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"sitePlan.maps"),dataSitePlan:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"sitePlan.type"),subTabs:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"sitePlan.subTabs"),descriptions:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"sitePlan.descriptions"),page:page}),"siteplan"),this.renderSectionWithId(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Residences__["a" /* default */],{landingPage:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"residence.landingPage"),type:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"residence.type"),page:page}),"residences"),this.renderSectionWithId(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Destination__["a" /* default */],{isMobile:isMobile,imageSlider:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"destination.landingPage"),title:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"destination.content.title"),description:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"destination.content.description"),mapData:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"destination.map"),page:page}),"destination"),this.renderSectionWithId(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__TheSanctuaryclub__["a" /* default */],{description:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"sanctuaryClub.description"),image:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"sanctuaryClub.image"),title:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"sanctuaryClub.title"),page:page}),"sanctuary-club"),this.renderSectionWithId(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Faq__["a" /* default */],Object.assign({},__webpack_require__(1004),{page:page})),"faq"),this.renderSectionWithId(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Ebrochure__["a" /* default */],{location:"phuket",project:"skypark",page:page}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["d" /* Footer */],null)),"e-brochure"))));}}]);return PhuketSkypark;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class);

/***/ }),
/* 934 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return initAppPhuketSkypark; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_reduce__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_reduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_reduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_actionType__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_phuket_skypark__ = __webpack_require__(935);
var _this=this;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var initAppPhuketSkypark=function initAppPhuketSkypark(){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch){var listApi,apiResult,mapData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:listApi=[];_context.t0=listApi;_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_3__services_phuket_skypark__["c" /* fetchGalleryApi */])();case 4:_context.t1=_context.sent;_context.t2={key:"gallery",data:_context.t1};_context.t0.push.call(_context.t0,_context.t2);_context.t3=listApi;_context.next=10;return Object(__WEBPACK_IMPORTED_MODULE_3__services_phuket_skypark__["a" /* fetchConceptApi */])();case 10:_context.t4=_context.sent;_context.t5={key:"concept",data:_context.t4};_context.t3.push.call(_context.t3,_context.t5);_context.t6=listApi;_context.next=16;return Object(__WEBPACK_IMPORTED_MODULE_3__services_phuket_skypark__["d" /* fetchMasterPlanApi */])();case 16:_context.t7=_context.sent;_context.t8={key:"masterPlan",data:_context.t7};_context.t6.push.call(_context.t6,_context.t8);_context.t9=listApi;_context.next=22;return Object(__WEBPACK_IMPORTED_MODULE_3__services_phuket_skypark__["g" /* fetchSitePlanApi */])();case 22:_context.t10=_context.sent;_context.t11={key:"sitePlan",data:_context.t10};_context.t9.push.call(_context.t9,_context.t11);_context.t12=listApi;_context.next=28;return Object(__WEBPACK_IMPORTED_MODULE_3__services_phuket_skypark__["e" /* fetchResidenceApi */])();case 28:_context.t13=_context.sent;_context.t14={key:"residence",data:_context.t13};_context.t12.push.call(_context.t12,_context.t14);_context.t15=listApi;_context.next=34;return Object(__WEBPACK_IMPORTED_MODULE_3__services_phuket_skypark__["b" /* fetchDestinationApi */])();case 34:_context.t16=_context.sent;_context.t17={key:"destination",data:_context.t16};_context.t15.push.call(_context.t15,_context.t17);_context.t18=listApi;_context.next=40;return Object(__WEBPACK_IMPORTED_MODULE_3__services_phuket_skypark__["f" /* fetchSanctuaryClubApi */])();case 40:_context.t19=_context.sent;_context.t20={key:"sanctuaryClub",data:_context.t19};_context.t18.push.call(_context.t18,_context.t20);_context.prev=43;_context.next=46;return Promise.all(listApi);case 46:apiResult=_context.sent;mapData=__WEBPACK_IMPORTED_MODULE_1_lodash_reduce___default()(apiResult,function(result,value,index){var key=value.key,data=value.data;return Object.assign({},result,_defineProperty({},key,data));},{});dispatch({type:__WEBPACK_IMPORTED_MODULE_2__actions_actionType__["h" /* RECEIVE_PHUKET_SKYPARK */],data:mapData});_context.next=54;break;case 51:_context.prev=51;_context.t21=_context["catch"](43);console.error("initAppPhuketSkypark err",_context.t21);case 54:case"end":return _context.stop();}}},_callee,_this,[[43,51]]);}));return function(_x){return _ref.apply(this,arguments);};}();};

/***/ }),
/* 935 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchGalleryApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchConceptApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchMasterPlanApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return fetchSitePlanApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fetchResidenceApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchDestinationApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fetchSanctuaryClubApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_PhuketSkypark_gallery__ = __webpack_require__(936);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_PhuketSkypark_concept__ = __webpack_require__(937);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_PhuketSkypark_masterplan__ = __webpack_require__(938);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_PhuketSkypark_sitePlan__ = __webpack_require__(939);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_PhuketSkypark_residence__ = __webpack_require__(991);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_PhuketSkypark_destination__ = __webpack_require__(992);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_PhuketSkypark_sanctuaryClub__ = __webpack_require__(993);
var fetchGalleryApi=function fetchGalleryApi(){return Promise.resolve(__WEBPACK_IMPORTED_MODULE_0__data_PhuketSkypark_gallery__["a" /* default */]);};var fetchConceptApi=function fetchConceptApi(){return Promise.resolve(__WEBPACK_IMPORTED_MODULE_1__data_PhuketSkypark_concept__["a" /* default */]);};var fetchMasterPlanApi=function fetchMasterPlanApi(){return Promise.resolve(__WEBPACK_IMPORTED_MODULE_2__data_PhuketSkypark_masterplan__["a" /* default */]);};var fetchSitePlanApi=function fetchSitePlanApi(){return Promise.resolve(__WEBPACK_IMPORTED_MODULE_3__data_PhuketSkypark_sitePlan__["a" /* default */]);};var fetchResidenceApi=function fetchResidenceApi(){return Promise.resolve(__WEBPACK_IMPORTED_MODULE_4__data_PhuketSkypark_residence__["a" /* default */]);};var fetchDestinationApi=function fetchDestinationApi(){return Promise.resolve(__WEBPACK_IMPORTED_MODULE_5__data_PhuketSkypark_destination__["a" /* default */]);};var fetchSanctuaryClubApi=function fetchSanctuaryClubApi(){return Promise.resolve(__WEBPACK_IMPORTED_MODULE_6__data_PhuketSkypark_sanctuaryClub__["a" /* default */]);};

/***/ }),
/* 936 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_find__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(2);
var baseAssetUrl=Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])("phuket-skypark");var baseAssetVideoUrl=baseAssetUrl+"/videos";var heroShotImg1=baseAssetUrl+"/images/gallery/hero-shot/01.jpg";var heroShotImg2=baseAssetUrl+"/images/gallery/hero-shot/02.jpg";var heroShotImg3=baseAssetUrl+"/images/gallery/hero-shot/03.jpg";var heroShotImg4=baseAssetUrl+"/images/gallery/hero-shot/04.jpg";var heroShotImg5=baseAssetUrl+"/images/gallery/hero-shot/05.jpg";var heroShotImg6=baseAssetUrl+"/images/gallery/hero-shot/06.jpg";var heroShotImg7=baseAssetUrl+"/images/gallery/hero-shot/07.jpg";var heroShotImg8=baseAssetUrl+"/images/gallery/hero-shot/08.jpg";var heroShotImg9=baseAssetUrl+"/images/gallery/hero-shot/09.jpg";// const heroShotImg10 = `${baseAssetUrl}/images/gallery/hero-shot/10.jpg`;
var residencesAerial1=baseAssetUrl+"/images/gallery/images/residences-aerial/01.jpg";var residencesAerial2=baseAssetUrl+"/images/gallery/images/residences-aerial/02.jpg";var residencesAerial3=baseAssetUrl+"/images/gallery/images/residences-aerial/03.jpg";var residencesAerial4=baseAssetUrl+"/images/gallery/images/residences-aerial/04.jpg";var residencesExterior1=baseAssetUrl+"/images/gallery/images/residences-exterior/01.jpg";var residencesExterior2=baseAssetUrl+"/images/gallery/images/residences-exterior/02.jpg";var residencesExterior3=baseAssetUrl+"/images/gallery/images/residences-exterior/03.jpg";var residencesExterior4=baseAssetUrl+"/images/gallery/images/residences-exterior/04.jpg";var residencesInterior1=baseAssetUrl+"/images/gallery/images/residences-interior/01.jpg";var residencesInterior2=baseAssetUrl+"/images/gallery/images/residences-interior/02.jpg";var residencesInterior3=baseAssetUrl+"/images/gallery/images/residences-interior/03.jpg";var residencesInterior4=baseAssetUrl+"/images/gallery/images/residences-interior/04.jpg";var residencesInterior5=baseAssetUrl+"/images/gallery/images/residences-interior/05.jpg";var residencesInterior6=baseAssetUrl+"/images/gallery/images/residences-interior/06.jpg";var residencesInterior7=baseAssetUrl+"/images/gallery/images/residences-interior/07.jpg";var residencesCommonArea1=baseAssetUrl+"/images/gallery/images/residences-common-area/01.jpg";var residencesCommonArea2=baseAssetUrl+"/images/gallery/images/residences-common-area/02.jpg";var residencesCommonArea3=baseAssetUrl+"/images/gallery/images/residences-common-area/03.jpg";var residencesLifestyle1=baseAssetUrl+"/images/gallery/images/residences-lifestyle/01.jpg";var residencesLifestyle2=baseAssetUrl+"/images/gallery/images/residences-lifestyle/02.jpg";var destinationLifestyle1=baseAssetUrl+"/images/gallery/images/destination-lifestyle/01.jpg";var destinationLifestyle2=baseAssetUrl+"/images/gallery/images/destination-lifestyle/02.jpg";var destinationLifestyle3=baseAssetUrl+"/images/gallery/images/destination-lifestyle/03.jpg";var destinationLifestyle4=baseAssetUrl+"/images/gallery/images/destination-lifestyle/04.jpg";var destinationLifestyle5=baseAssetUrl+"/images/gallery/images/destination-lifestyle/05.jpg";var destinationLifestyle6=baseAssetUrl+"/images/gallery/images/destination-lifestyle/06.jpg";var destinationLifestyle7=baseAssetUrl+"/images/gallery/images/destination-lifestyle/07.jpg";var destinationLifestyle8=baseAssetUrl+"/images/gallery/images/destination-lifestyle/08.jpg";var video={en:baseAssetVideoUrl+"/skypark.mp4",ru:baseAssetVideoUrl+"/skypark.mp4",cn:baseAssetVideoUrl+"/skypark.mp4"};var videos=[{titleKey:"propertyVideo",source:{en:baseAssetVideoUrl+"/SkyPark_animation_3Lingual_Mar 2022.mp4",cn:baseAssetVideoUrl+"/SkyPark_animation_3Lingual_Mar 2022.mp4",ru:baseAssetVideoUrl+"/SkyPark_animation_3Lingual_Mar 2022.mp4"},text:{en:["PROPERTY VIDEO"],cn:["项目视频"],ru:["ВИДЕО ПРОЕКТА"]}},{titleKey:"interiorVideoStudio",source:{en:baseAssetVideoUrl+"/SKYPARK_Studio_Interior_video_V.3_17062020.mp4",cn:baseAssetVideoUrl+"/SKYPARK_Studio_Interior_video_V.3_17062020.mp4",ru:baseAssetVideoUrl+"/SKYPARK_Studio_Interior_video_V.3_17062020.mp4"},text:{en:["STUDIO"],cn:["一室公寓"],ru:["СТУДИЯ"]}},{titleKey:"interiorVideoOneBedroom",source:{en:baseAssetVideoUrl+"/SKYPARK_1-bedroom_Interior_video_V.4_17062020.mp4",cn:baseAssetVideoUrl+"/SKYPARK_1-bedroom_Interior_video_V.4_17062020.mp4",ru:baseAssetVideoUrl+"/SKYPARK_1-bedroom_Interior_video_V.4_17062020.mp4"},text:{en:["ONE - BEDROOM"],cn:["一卧开间"],ru:["КВАРТИРА С","ОДНОЙ СПАЛЬНЕЙ"]}},{titleKey:"interiorVideoTwoBedroom",source:{en:baseAssetVideoUrl+"/SKYPARK_2-bedroom_Interior_video_V.3_17062020.mp4",cn:baseAssetVideoUrl+"/SKYPARK_2-bedroom_Interior_video_V.3_17062020.mp4",ru:baseAssetVideoUrl+"/SKYPARK_2-bedroom_Interior_video_V.3_17062020.mp4"},text:{en:["TWO - BEDROOM"],cn:["两卧室套房"],ru:["КВАРТИРА С","ДВУМЯ СПАЛЬНЯМИ"]}}];var heroShot=[{image:heroShotImg1},{image:heroShotImg2},{image:heroShotImg3},{image:heroShotImg4},{image:heroShotImg5},{image:heroShotImg6},{image:heroShotImg7},{image:heroShotImg8},{image:heroShotImg9}];var categories=[{id:1,name:"All Images"},{id:2,name:"Residences – Aerial"},{id:3,name:"Residences – Exterior"},{id:4,name:"Residences – Interior"},{id:5,name:"Residences – Common Area"},{id:6,name:"Residences – Lifestyle"},{id:7,name:"Destination Lifestyle"}];var images=[{categoryId:2,name:"Aerial - 1",image:residencesAerial1},{categoryId:2,name:"Aerial - 2",image:residencesAerial2},{categoryId:2,name:"Aerial - 3",image:residencesAerial3},{categoryId:2,name:"Aerial - 4",image:residencesAerial4},{categoryId:3,name:"Exterior - 1",image:residencesExterior1},{categoryId:3,name:"Exterior - 2",image:residencesExterior2},{categoryId:3,name:"Exterior - 3",image:residencesExterior3},{categoryId:3,name:"Exterior - 4",image:residencesExterior4},{categoryId:4,name:"One bedroom - 1",image:residencesInterior1},{categoryId:4,name:"One bedroom - 2",image:residencesInterior2},{categoryId:4,name:"Studio - 1",image:residencesInterior3},{categoryId:4,name:"Two bedroom - 1",image:residencesInterior4},{categoryId:4,name:"Two bedroom - 2",image:residencesInterior5},{categoryId:4,name:"Two bedroom - 3",image:residencesInterior6},{categoryId:4,name:"Two bedroom - 4",image:residencesInterior7},{categoryId:5,name:"Rooftop pool",image:residencesCommonArea1},{categoryId:5,name:"Sky running track",image:residencesCommonArea2},{categoryId:5,name:"Common area",image:residencesCommonArea3},{categoryId:6,name:"Lifestyle - 1",image:residencesLifestyle1},{categoryId:6,name:"Lifestyle - 2",image:residencesLifestyle2},{categoryId:7,name:"Lifestyle - 1",image:destinationLifestyle1},{categoryId:7,name:"Lifestyle - 2",image:destinationLifestyle2},{categoryId:7,name:"Lifestyle - 3",image:destinationLifestyle3},{categoryId:7,name:"Lifestyle - 4",image:destinationLifestyle4},{categoryId:7,name:"Lifestyle - 5",image:destinationLifestyle5},{categoryId:7,name:"Lifestyle - 6",image:destinationLifestyle6},{categoryId:7,name:"Lifestyle - 7",image:destinationLifestyle7},{categoryId:7,name:"Lifestyle - 8",image:destinationLifestyle8}];var image360=null;var view360=[{id:"AERIAL",src:baseAssetUrl+"/360/aerial/SKP-Aerial.html"},{id:"INTERIOR",type:"list",src:baseAssetUrl+"/360/interior/SKP-2AL.html",list:[{id:"TYPE 2A-1",target:"_blank",src:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("iframe",{width:"100%",height:"100%",src:"https://my.matterport.com/show/?m=V7SYTo7mChH",frameborder:"0",allowfullscreen:true,allow:"vr"}),href:"https://my.matterport.com/show/?m=V7SYTo7mChH"},{id:"TYPE 1B",target:"_blank",src:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("iframe",{width:"100%",height:"100%",src:"https://my.matterport.com/show/?m=eUq9Wp3t6LD",frameborder:"0",allowfullscreen:true,allow:"vr"}),href:"https://my.matterport.com/show/?m=eUq9Wp3t6LD"},{id:"TYPE 1A",target:"_blank",src:__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("iframe",{width:"100%",height:"100%",src:"https://my.matterport.com/show/?m=F3tM8isRq4s",frameborder:"0",allowfullscreen:true,allow:"vr"}),href:"https://my.matterport.com/show/?m=F3tM8isRq4s"}]}];/* harmony default export */ __webpack_exports__["a"] = ({heroShot:heroShot,categories:categories,images:__WEBPACK_IMPORTED_MODULE_1_lodash_map___default()(images,function(image){return Object.assign({},image,{category:__WEBPACK_IMPORTED_MODULE_0_lodash_find___default()(categories,{id:image.categoryId})});}),video:video,videos:videos,image360:image360,view360:view360});

/***/ }),
/* 937 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(2);
var img1=Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])("phuket-skypark")+"/images/concept/01.jpg";var img2=Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])("phuket-skypark")+"/images/concept/02.jpg";var img3=Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])("phuket-skypark")+"/images/concept/03.jpg";var img4=Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])("phuket-skypark")+"/images/concept/04.jpg";var img5=Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])("phuket-skypark")+"/images/concept/05.jpg";var imageSlider=[{image:img1},{image:img2},{image:img3},{image:img4},{image:img5}];var content={en:"<p>Nestled within the lush natural landscaping overlooking the verdant Laguna Phuket Golf Course, Skypark Celeste Laguna Phuket offers owners a tranquil place to call home. Skypark Celeste Laguna Phuket provides residents peace of mind with affordable live-in condominiums that add convenience and style to tropical living.</p><br/>\n  <p>Residents enjoy exclusive access to leisure facilities on the rooftop, which also offers relaxing areas and doubles as a community meeting space. The development\u2019s buildings are linked together with sky bridges surrounded by greenery, lagoon views and glimpses of the ocean. The skypool and unique sky jogging track allow residents to stay healthy while enjoying the beautiful outdoors.</p><br/>\n  <p><strong>PREMIER DESTINATION RESORT</strong></p><br/>\n  <p>Overlooking the top-tier Laguna Phuket Golf Course, Skypark Celeste Laguna Phuket occupies a prime location inside Laguna Phuket, Asia\u2019s finest integrated resort, and puts residents within close proximity of the three-kilometre-long Bang Tao beach. Residents have access to the inter-resort shuttle service to enjoy the facilities of five star resorts and deluxe leisure pursuits within the award-winning complex.</p><br/>\n  <p>In addition to the choice of luxurious spas, upscale resorts, facilities and activities within Laguna Phuket, residents are also well placed to make the most of lifestyle attractions such as the nearby Boat Avenue shopping complex and the Central Porto de Phuket boutique retail and dining complex.</p>",cn:"<p>\u6D77\u5929\u82D1\u585E\u52D2\u4E1D\u5750\u843D\u4E8E\u90C1\u90C1\u8471\u8471\u7684\u81EA\u7136\u666F\u89C2\u4E4B\u4E2D\uFF0C\u4FEF\u77B0\u7FE0\u7EFF\u7684\n  \u666E\u5409\u5C9B\u4E50\u53E4\u6D6A\u9AD8\u5C14\u592B\u7403\u573A\uFF0C\u4E3A\u4E1A\u4E3B\u4EEC\u63D0\u4F9B\u5B81\u9759\u8212\u9002\u7684\u751F\u6D3B\u73AF\n  \u5883\u3002\u6D77\u5929\u82D1\u585E\u52D2\u4E1D\u63D0\u4F9B\u9AD8\u6027\u4EF7\u6BD4\u7684\u81EA\u4F4F\u578B\u516C\u5BD3\uFF0C\u4E3A\u4E1A\u4E3B\u4EEC\u7684\n  \u70ED\u5E26\u751F\u6D3B\u589E\u6DFB\u4FBF\u5229\u548C\u683C\u8C03\u3002</p><br/>\n  <p>\u4E1A\u4E3B\u4EEC\u53EF\u4E13\u4EAB\u5C4B\u9876\u4F11\u95F2\u8BBE\u65BD\uFF0C\u6B64\u5916\uFF0C\u5C4B\u9876\u8FD8\u53EF\u4F5C\u4E3A\u4F11\u95F2\u5A31\u4E50\n  \u533A\u548C\u793E\u533A\u805A\u4F1A\u573A\u6240\u3002\u8FD9\u4E2A\u9879\u76EE\u7684\u591A\u680B\u5EFA\u7B51\u90FD\u901A\u8FC7\u5929\u6865\u76F8\u8FDE\uFF0C\n  \u5468\u56F4\u88AB\u7EFF\u690D\u3001\u6CFB\u6E56\u548C\u5927\u6D77\u666F\u89C2\u6240\u56F4\u7ED5\u3002\u7A7A\u4E2D\u6E38\u6CF3\u6C60\u548C\u72EC\u7279\u7684\n  \u7A7A\u4E2D\u6162\u8DD1\u9053\u8BA9\u4E1A\u4E3B\u4EEC\u5728\u953B\u70BC\u8EAB\u4F53\u7684\u540C\u65F6\u53C8\u53EF\u4EAB\u53D7\u7F8E\u4E3D\u7684\u6237\u5916\n  \u666F\u81F4\u3002</p><br/>\n  <p><strong>\u9996\u5C48\u4E00\u6307\u7684\u5EA6\u5047\u80DC\u5730</strong></p><br/>\n  <p>\u6D77\u5929\u82D1\u585E\u52D2\u4E1D\u4FEF\u77B0\u9996\u5C48\u4E00\u6307\u7684\u666E\u5409\u5C9B\u4E50\u53E4\u6D6A\u9AD8\u5C14\u592B\u7403\u573A\uFF0C\u5750\n  \u843D\u4E8E\u4E9A\u6D32\u6700\u7F8E\u4E3D\u7684\u7EFC\u5408\u5EA6\u5047\u6751\u666E\u5409\u5C9B\u4E50\u53E4\u6D6A\u4E4B\u4E2D\uFF0C\u5730\u7406\u4F4D\u7F6E\n  \u4F18\u8D8A\uFF0C\u4E09\u516C\u91CC\u957F\u7684\u90A6\u6D9B\u6D77\u6EE9\u8FD1\u5728\u54AB\u5C3A\u3002\u4E1A\u4E3B\u4EEC\u53EF\u4EE5\u4F7F\u7528\u5EA6\u5047\n  \u6751\u63A5\u9A73\u670D\u52A1\uFF0C\u5C3D\u60C5\u4EAB\u53D7\u8FD9\u4E2A\u5C61\u83B7\u6B8A\u8363\u7684\u4E94\u661F\u7EA7\u5EA6\u5047\u6751\u5185\u5404\u9879\n  \u8C6A\u534E\u4F11\u95F2\u914D\u5957\u8BBE\u65BD\u3002</p><br/>\n  <p>\u9664\u4E86\u666E\u5409\u5C9B\u4E50\u53E4\u6D6A\u5185\u7684\u7CBE\u9009\u8C6A\u534ESpa\u3001\u9AD8\u7AEF\u5EA6\u5047\u6751\u3001\u5404\u7C7B\u8BBE \u65BD\u548C\u6D3B\u52A8\u4E4B\u5916\uFF0C\u4E1A\u4E3B\u4EEC\u8FD8\u53EF\u4EE5\u4EAB\u53D7\u5404\u79CD\u751F\u6D3B\u914D\u5957\uFF0C\u5982\u9644\u8FD1\u7684 Boat Avenue\u8D2D\u7269\u4E2D\u5FC3\u548CCentral Porto de Phuket\u7CBE\u54C1\u96F6\u552E \u9910\u996E\u7EFC\u5408\u4F53\u3002</p>",ru:"<p>\u0416\u0438\u043B\u043E\u0439 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0441 Skypark Aurora Laguna Phuket \u0440\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D \u0432 \u043E\u043A\u0440\u0443\u0436\u0435\u043D\u0438\u0438 \u0436\u0438\u0432\u043E\u043F\u0438\u0441\u043D\u043E\u0433\u043E \u043F\u0440\u0438\u0440\u043E\u0434\u043D\u043E\u0433\u043E \u043B\u0430\u043D\u0434\u0448\u0430\u0444\u0442\u0430 \u0441 \u0432\u0438\u0434\u043E\u043C \u043D\u0430 \u043F\u043E\u043B\u0435 \u0434\u043B\u044F \u0433\u043E\u043B\u044C\u0444\u0430 Laguna Phuket. Skypark Celeste Laguna Phuket \u043F\u0440\u0435\u0434\u043B\u0430\u0433\u0430\u0435\u0442 \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0430\u043C \u0441\u043F\u043E\u043A\u043E\u0439\u043D\u043E\u0435 \u043C\u0435\u0441\u0442\u043E, \u043A\u043E\u0442\u043E\u0440\u043E\u0435 \u043C\u043E\u0436\u043D\u043E \u043D\u0430\u0437\u0432\u0430\u0442\u044C \u0434\u043E\u043C\u043E\u043C. Skypark Celeste Laguna Phuket \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 \u0436\u0438\u0442\u0435\u043B\u044F\u043C \u0441\u043F\u043E\u043A\u043E\u0439\u0441\u0442\u0432\u0438\u0435 \u0438 \u0443\u043C\u0438\u0440\u043E\u0442\u0432\u043E\u0440\u0435\u043D\u0438\u0435, \u0431\u043B\u0430\u0433\u043E\u0434\u0430\u0440\u044F \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B\u043C \u043A\u0432\u0430\u0440\u0442\u0438\u0440\u0430\u043C \u0434\u043B\u044F \u043F\u0440\u043E\u0436\u0438\u0432\u0430\u043D\u0438\u044F, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u0434\u043E\u0431\u0430\u0432\u043B\u044F\u044E\u0442 \u0443\u0434\u043E\u0431\u0441\u0442\u0432\u043E \u0438 \u0441\u0442\u0438\u043B\u044C \u0432 \u0436\u0438\u0437\u043D\u044C \u0432 \u0442\u0440\u043E\u043F\u0438\u043A\u0430\u0445.</p><br/>\n  <p>\u0416\u0438\u0442\u0435\u043B\u0438 \u043F\u043E\u043B\u044C\u0437\u0443\u044E\u0442\u0441\u044F \u044D\u043A\u0441\u043A\u043B\u044E\u0437\u0438\u0432\u043D\u044B\u043C \u0434\u043E\u0441\u0442\u0443\u043F\u043E\u043C \u043A \u043C\u0435\u0441\u0442\u0430\u043C \u043E\u0442\u0434\u044B\u0445\u0430 \u043D\u0430 \u043A\u0440\u044B\u0448\u0435, \u0433\u0434\u0435 \u0442\u0430\u043A\u0436\u0435 \u0435\u0441\u0442\u044C \u0437\u043E\u043D\u044B \u043E\u0442\u0434\u044B\u0445\u0430 \u0438 \u043E\u0434\u043D\u043E\u0432\u0440\u0435\u043C\u0435\u043D\u043D\u043E \u043C\u0435\u0441\u0442\u043E \u0434\u043B\u044F \u043E\u0431\u0449\u0435\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u0445 \u0432\u0441\u0442\u0440\u0435\u0447. \u0417\u0434\u0430\u043D\u0438\u044F \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0441\u0430 \u0441\u043E\u0435\u0434\u0438\u043D\u0435\u043D\u044B \u043C\u0435\u0436\u0434\u0443 \u0441\u043E\u0431\u043E\u0439 \u043F\u0435\u0440\u0435\u0445\u043E\u0434\u0430\u043C\u0438, \u043E\u043A\u0440\u0443\u0436\u0435\u043D\u043D\u044B\u043C\u0438 \u0437\u0435\u043B\u0435\u043D\u044C\u044E, \u0432\u0438\u0434\u043E\u043C \u043D\u0430 \u043B\u0430\u0433\u0443\u043D\u0443 \u0438 \u0447\u0430\u0441\u0442\u0438\u0447\u043D\u044B\u043C\u0438 \u0432\u0438\u0434\u0430\u043C\u0438 \u043D\u0430 \u043E\u043A\u0435\u0430\u043D. \u0411\u0430\u0441\u0441\u0435\u0439\u043D \u0438 \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u0430\u044F \u0431\u0435\u0433\u043E\u0432\u0430\u044F \u0434\u043E\u0440\u043E\u0436\u043A\u0430, \u0440\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u043D\u044B\u0435 \u043D\u0430 \u043A\u0440\u044B\u0448\u0435, \u043F\u043E\u0437\u0432\u043E\u043B\u044F\u044E\u0442 \u0436\u0438\u0442\u0435\u043B\u044F\u043C \u043E\u0441\u0442\u0430\u0432\u0430\u0442\u044C\u0441\u044F \u0437\u0434\u043E\u0440\u043E\u0432\u044B\u043C\u0438, \u043D\u0430\u0441\u043B\u0430\u0436\u0434\u0430\u044F\u0441\u044C \u043F\u0440\u0435\u043A\u0440\u0430\u0441\u043D\u044B\u043C\u0438 \u0432\u0438\u0434\u0430\u043C\u0438 \u043D\u0430 \u043E\u0442\u043A\u0440\u044B\u0442\u043E\u043C \u0432\u043E\u0437\u0434\u0443\u0445\u0435.</p><br/>\n  <p><strong>\u041F\u0420\u041E\u0416\u0418\u0412\u0410\u041D\u0418\u0415 \u041D\u0410 \u042D\u041B\u0418\u0422\u041D\u041E\u041C \u041A\u0423\u0420\u041E\u0420\u0422\u0415</strong></p><br/>\n  <p>Skypark Celeste Laguna Phuket \u0440\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D \u0432 \u043D\u0435\u043F\u043E\u0441\u0440\u0435\u0434\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0439 \u0431\u043B\u0438\u0437\u043E\u0441\u0442\u0438 \u043E\u0442 \u043F\u043E\u043B\u044F \u0434\u043B\u044F \u0433\u043E\u043B\u044C\u0444\u0430 Laguna Phuket, \u0432 \u044D\u043B\u0438\u0442\u043D\u043E\u043C \u0440\u0430\u0439\u043E\u043D\u0435 \u0441\u0430\u043C\u043E\u0433\u043E \u0431\u043E\u043B\u044C\u0448\u043E\u0433\u043E \u043A\u0443\u0440\u043E\u0440\u0442\u043D\u043E\u0433\u043E \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0441\u0430 \u0410\u0437\u0438\u0438, \u043D\u0435\u0434\u0430\u043B\u0435\u043A\u043E \u043E\u0442 \u043F\u043B\u044F\u0436\u0430 \u0411\u0430\u043D\u0433\u0442\u0430\u043E, \u043A\u043E\u0442\u043E\u0440\u044B\u0439 \u0437\u0430\u043D\u0438\u043C\u0430\u0435\u0442 \u0442\u0440\u0438 \u043A\u0438\u043B\u043E\u043C\u0435\u0442\u0440\u0430 \u043F\u043E\u0431\u0435\u0440\u0435\u0436\u044C\u044F. \u0416\u0438\u0442\u0435\u043B\u0438 \u043C\u043E\u0433\u0443\u0442 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C\u0441\u044F \u0443\u0441\u043B\u0443\u0433\u0430\u043C\u0438 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442\u0430 \u0432\u043D\u0443\u0442\u0440\u0438 \u043A\u0443\u0440\u043E\u0440\u0442\u0430, \u043F\u0440\u0435\u0434\u043D\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u043E\u0433\u043E \u0434\u043B\u044F \u0443\u0434\u043E\u0431\u043D\u043E\u0433\u043E \u043F\u043E\u0441\u0435\u0449\u0435\u043D\u0438\u044F \u043F\u044F\u0442\u0438\u0437\u0432\u0435\u0437\u0434\u043E\u0447\u043D\u044B\u0445 \u0433\u043E\u0441\u0442\u0438\u043D\u0438\u0446 \u0438 \u044D\u043B\u0438\u0442\u043D\u044B\u0445 \u0434\u043E\u0441\u0443\u0433\u043E\u0432\u044B\u0445 \u0446\u0435\u043D\u0442\u0440\u043E\u0432 \u044D\u0442\u043E\u0433\u043E \u043F\u043E\u0442\u0440\u044F\u0441\u0430\u044E\u0449\u0435\u0433\u043E \u043A\u0443\u0440\u043E\u0440\u0442\u043D\u043E\u0433\u043E \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0441\u0430. \u041F\u043E\u043C\u0438\u043C\u043E \u0432\u044B\u0431\u043E\u0440\u0430 \u043B\u044E\u043A\u0441\u043E\u0432\u044B\u0445 \u0441\u043F\u0430 \u0438 \u0444\u0435\u0448\u0435\u043D\u0435\u0431\u0435\u043B\u044C\u043D\u044B\u0445 \u043A\u0443\u0440\u043E\u0440\u0442\u043D\u044B\u0445 \u0446\u0435\u043D\u0442\u0440\u043E\u0432 \u0432 Laguna Phuket, \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u0438\u043A\u0438 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u0438 \u0436\u0438\u043B\u044C\u044F \u0442\u0430\u043A\u0436\u0435 \u043C\u043E\u0433\u0443\u0442 \u043F\u043E\u0441\u0435\u0449\u0430\u0442\u044C \u0441\u0430\u043C\u044B\u0435 \u043B\u0443\u0447\u0448\u0438\u0435 \u0442\u043E\u0440\u0433\u043E\u0432\u044B\u0435 \u0446\u0435\u043D\u0442\u0440\u044B, \u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440 \u0440\u0430\u0441\u043F\u043E\u043B\u043E\u0436\u0435\u043D\u043D\u044B\u0439 \u043F\u043E\u0431\u043B\u0438\u0437\u043E\u0441\u0442\u0438 \u0442\u043E\u0440\u0433\u043E\u0432\u044B\u0439 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0441 Boat Avenue \u0438 \u0442\u043E\u0440\u0433\u043E\u0432\u043E-\u0440\u0430\u0437\u0432\u043B\u0435\u043A\u0430\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0441 Central Porto de Phuket.</p>"};/* harmony default export */ __webpack_exports__["a"] = ({imageSlider:imageSlider,content:content});

/***/ }),
/* 938 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(2);
var maps=Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+"/images/master-plan/image.jpg";/* harmony default export */ __webpack_exports__["a"] = ({maps:maps});

/***/ }),
/* 939 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_PhuketSkypark_sitePlan_svg_a_1__ = __webpack_require__(940);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_PhuketSkypark_sitePlan_svg_a_2__ = __webpack_require__(945);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_PhuketSkypark_sitePlan_svg_a_3__ = __webpack_require__(947);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_PhuketSkypark_sitePlan_svg_a_4__ = __webpack_require__(949);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_PhuketSkypark_sitePlan_svg_a_5__ = __webpack_require__(951);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_PhuketSkypark_sitePlan_svg_a_6__ = __webpack_require__(953);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__data_PhuketSkypark_sitePlan_svg_a_7__ = __webpack_require__(955);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__data_PhuketSkypark_sitePlan_svg_b_1__ = __webpack_require__(957);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__data_PhuketSkypark_sitePlan_svg_b_2__ = __webpack_require__(959);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__data_PhuketSkypark_sitePlan_svg_b_3__ = __webpack_require__(961);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__data_PhuketSkypark_sitePlan_svg_b_4__ = __webpack_require__(963);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__data_PhuketSkypark_sitePlan_svg_b_5__ = __webpack_require__(965);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__data_PhuketSkypark_sitePlan_svg_b_6__ = __webpack_require__(967);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__data_PhuketSkypark_sitePlan_svg_b_7__ = __webpack_require__(969);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__data_PhuketSkypark_sitePlan_svg_b_8__ = __webpack_require__(971);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__data_PhuketSkypark_sitePlan_svg_c_1__ = __webpack_require__(973);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__data_PhuketSkypark_sitePlan_svg_c_2__ = __webpack_require__(975);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__data_PhuketSkypark_sitePlan_svg_c_3__ = __webpack_require__(977);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__data_PhuketSkypark_sitePlan_svg_c_4__ = __webpack_require__(979);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20__data_PhuketSkypark_sitePlan_svg_c_5__ = __webpack_require__(981);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21__data_PhuketSkypark_sitePlan_svg_c_6__ = __webpack_require__(983);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22__data_PhuketSkypark_sitePlan_svg_c_7__ = __webpack_require__(985);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23__data_PhuketSkypark_sitePlan_svg_c_8__ = __webpack_require__(987);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__data_PhuketSkypark_sitePlan_svg_a_siteplan__ = __webpack_require__(989);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__data_PhuketSkypark_sitePlan_svg_c_coming_soon__ = __webpack_require__(990);
// import BPA8 from "../../../data/PhuketSkypark/sitePlan/svg/a/8";
var maps=Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])("phuket-skypark")+"/images/site-plan/image.jpg";var subType=[{value:"all",title:{en:"ALL",ru:"Все",cn:"全部"}},{value:"studio",title:{en:"Studio",ru:"Блок",cn:"一室公寓"}},{value:"one-bedroom",title:{en:"One-bedroom",ru:"Одна спальня",cn:"一卧室套房"}},{value:"two-bedroom",title:{en:"Two-bedroom",ru:"Две спальни",cn:"两卧室套房"}}];var subTabs=[{value:"all",title:{en:"All",ru:"Все",cn:"全部"},showModal:false,img:__WEBPACK_IMPORTED_MODULE_24__data_PhuketSkypark_sitePlan_svg_a_siteplan__["a" /* default */]},{value:"a",title:{en:"Block A",ru:"Блок A",cn:"A栋"},showModal:false,img:__WEBPACK_IMPORTED_MODULE_1__data_PhuketSkypark_sitePlan_svg_a_1__["a" /* default */]},{value:"b",title:{en:"Block B",ru:"Блок B",cn:"B栋"},showModal:false,img:__WEBPACK_IMPORTED_MODULE_8__data_PhuketSkypark_sitePlan_svg_b_1__["a" /* default */]},{value:"c",title:{en:"Block C",ru:"Блок C",cn:"C栋"},showModal:false,img:__WEBPACK_IMPORTED_MODULE_25__data_PhuketSkypark_sitePlan_svg_c_coming_soon__["a" /* default */]}];var type=[{value:"1st",title:{en:"1st Floor",ru:"1-й этаж",cn:"1楼"},floorPlan:{a:__WEBPACK_IMPORTED_MODULE_1__data_PhuketSkypark_sitePlan_svg_a_1__["a" /* default */],b:__WEBPACK_IMPORTED_MODULE_25__data_PhuketSkypark_sitePlan_svg_c_coming_soon__["a" /* default */],c:__WEBPACK_IMPORTED_MODULE_25__data_PhuketSkypark_sitePlan_svg_c_coming_soon__["a" /* default */]},buttons:subType},{value:"2nd",title:{en:"2nd Floor",ru:"2-й этаж",cn:"2楼"},floorPlan:{a:__WEBPACK_IMPORTED_MODULE_2__data_PhuketSkypark_sitePlan_svg_a_2__["a" /* default */],b:__WEBPACK_IMPORTED_MODULE_25__data_PhuketSkypark_sitePlan_svg_c_coming_soon__["a" /* default */],c:__WEBPACK_IMPORTED_MODULE_25__data_PhuketSkypark_sitePlan_svg_c_coming_soon__["a" /* default */]},buttons:subType},{value:"3rd",title:{en:"3rd Floor",ru:"3-й этаж",cn:"3楼"},floorPlan:{a:__WEBPACK_IMPORTED_MODULE_3__data_PhuketSkypark_sitePlan_svg_a_3__["a" /* default */],b:__WEBPACK_IMPORTED_MODULE_25__data_PhuketSkypark_sitePlan_svg_c_coming_soon__["a" /* default */],c:__WEBPACK_IMPORTED_MODULE_25__data_PhuketSkypark_sitePlan_svg_c_coming_soon__["a" /* default */]},buttons:subType},{value:"4th",title:{en:"4th Floor",ru:"4-й этаж",cn:"4楼"},floorPlan:{a:__WEBPACK_IMPORTED_MODULE_4__data_PhuketSkypark_sitePlan_svg_a_4__["a" /* default */],b:__WEBPACK_IMPORTED_MODULE_25__data_PhuketSkypark_sitePlan_svg_c_coming_soon__["a" /* default */],c:__WEBPACK_IMPORTED_MODULE_25__data_PhuketSkypark_sitePlan_svg_c_coming_soon__["a" /* default */]},buttons:subType},{value:"5th",title:{en:"5th Floor",ru:"5-й этаж",cn:"5楼"},floorPlan:{a:__WEBPACK_IMPORTED_MODULE_5__data_PhuketSkypark_sitePlan_svg_a_5__["a" /* default */],b:__WEBPACK_IMPORTED_MODULE_25__data_PhuketSkypark_sitePlan_svg_c_coming_soon__["a" /* default */],c:__WEBPACK_IMPORTED_MODULE_25__data_PhuketSkypark_sitePlan_svg_c_coming_soon__["a" /* default */]},buttons:subType},{value:"6th",title:{en:"6th Floor",ru:"6-й этаж",cn:"6楼"},floorPlan:{a:__WEBPACK_IMPORTED_MODULE_6__data_PhuketSkypark_sitePlan_svg_a_6__["a" /* default */],b:__WEBPACK_IMPORTED_MODULE_25__data_PhuketSkypark_sitePlan_svg_c_coming_soon__["a" /* default */],c:__WEBPACK_IMPORTED_MODULE_25__data_PhuketSkypark_sitePlan_svg_c_coming_soon__["a" /* default */]},buttons:subType},{value:"7th",title:{en:"7th Floor",ru:"7-й этаж",cn:"7楼"},floorPlan:{a:__WEBPACK_IMPORTED_MODULE_7__data_PhuketSkypark_sitePlan_svg_a_7__["a" /* default */],b:__WEBPACK_IMPORTED_MODULE_25__data_PhuketSkypark_sitePlan_svg_c_coming_soon__["a" /* default */],c:__WEBPACK_IMPORTED_MODULE_25__data_PhuketSkypark_sitePlan_svg_c_coming_soon__["a" /* default */]},buttons:subType}];var descriptions=[{value:"studio",title:{en:"The intelligently-designed 28 sqm studio apartments offer all the modern conveniences to cater to long-term residents and visiting guests.",cn:"智能设计的28平方米一卧开间可提供所有现代化的便利设施，以满足长住业主和来访客人的需求。",ru:"Умно спроектированные квартиры-студии площадью 28 кв.м предлагают все современные удобства как для постоянных жителей, так и гостей."}},{value:"one-bedroom",title:{en:"The one-bedroom apartments at Skypark offer between 30 to 39 sqm of calming space to relax and recharge in the comfortable living area and separate master bedroom.",cn:"海天苑的一卧套房为住客提供30至39平方米的安静空间，可在舒适的生活区和独立的主卧室充分放松和休整",ru:"Квартиры с одной спальней в Skypark площадью от 30 до 39 кв.м предлагают пространства для отдыха и перезарядки в уютной гостиной и отдельной главной спальне."}},{value:"two-bedroom",title:{en:"The spacious homes at Skypark range from 40 to 60 sqm and feature two separate bedrooms that can also be opened up to form one flowing space with the living room to suit moments of live, work, and rest.",cn:"海天苑的宽敞二卧室套房面积从40平方米到60平方米不等，配有两个独立的卧室，也可以与客厅打通，形成一个流动空间，以适应生活、工作和休息的需要。",ru:"Просторные квартиры в Skypark варьируются от 40 до 60 кв.м и имеют две отдельные спальни и гостиную, для различных моментов жизни, работы и отдыха."}}];// const type = [
//   {
//     value: 'all',
//     title: {
//       en: 'ALL',
//       ru: 'ALL',
//       cn: 'ALL',
//     },
//   },
//   {
//     value: 'studio',
//     title: {
//       en: 'Studio',
//       ru: 'Studio',
//       cn: 'Studio',
//     },
//   },
//   {
//     value: 'one-bedroom',
//     title: {
//       en: 'One-bedroom',
//       ru: 'One-bedroom',
//       cn: 'One-bedroom',
//     },
//   },
//   {
//     value: 'two-bedroom',
//     title: {
//       en: 'Two-bedroom',
//       ru: 'Two-bedroom',
//       cn: 'Two-bedroom',
//     },
//   },
// ];
/* harmony default export */ __webpack_exports__["a"] = ({maps:maps,type:type,subTabs:subTabs,descriptions:descriptions});

/***/ }),
/* 940 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__img_1_png__ = __webpack_require__(941);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__img_1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__img_1_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__img_1_cn_png__ = __webpack_require__(942);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__img_1_cn_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2__img_1_cn_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__img_1_ru_png__ = __webpack_require__(943);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__img_1_ru_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3__img_1_ru_png__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__img_1_en_png__ = __webpack_require__(944);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__img_1_en_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__img_1_en_png__);
// import _ from 'lodash'
// import MultiLineText from './MultiLineText';
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var currentLang=_ref.currentLang,selectedType=_ref.selectedType;var shouldDisplayByLang=function shouldDisplayByLang(selectLang){return currentLang===selectLang?"display":"display-none";};var shouldDisplayByType=function shouldDisplayByType(type){return selectedType===type||selectedType==="all"?"opacity-in":"opacity-out";};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 500 500","data-name":"Layer 1",className:"site-plan-svg",width:1200,height:1200},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"map"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("image",{className:shouldDisplayByLang("cn"),xlinkHref:__WEBPACK_IMPORTED_MODULE_2__img_1_cn_png___default.a,height:"100%",width:"100%"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("image",{className:shouldDisplayByLang("ru"),xlinkHref:__WEBPACK_IMPORTED_MODULE_3__img_1_ru_png___default.a,height:"100%",width:"100%"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("image",{className:shouldDisplayByLang("en"),xlinkHref:__WEBPACK_IMPORTED_MODULE_4__img_1_en_png___default.a,height:"100%",width:"100%"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"floorplan"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"studio",className:shouldDisplayByType("studio")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"138.91 250.54 135.15 254.3 135.15 254.3 137.82 256.97 145.58 264.73 145.93 264.38 145.96 264.42 149.4 260.98 148.91 260.49 157.94 251.45 158.09 251.6 162.5 247.2 162.32 247.02 163.98 245.37 146.46 227.84 131.34 242.96 138.91 250.54",fill:"#231f20"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"one-bedroom",className:shouldDisplayByType("one-bedroom")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"143.79 228.44 145.5 226.72 128 209.22 112.85 224.37 112.32 223.84 105.56 230.6 116.19 241.23 119.58 237.83 126.99 245.24 139.44 232.78 139.66 233 144 228.65 143.79 228.44",fill:"#231f20"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"two-bedroom",className:shouldDisplayByType("two-bedroom")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"182.17 301.23 178.79 304.61 197.71 323.52 204.83 316.39 204.52 316.08 207.15 313.44 207.28 313.57 218.1 302.75 217.97 302.62 219.63 300.97 192.66 274 173.8 292.86 182.17 301.23",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"216.39 248.67 197.74 230.02 194.03 233.73 185.72 225.42 170.58 240.57 197.47 267.46 197.51 267.42 197.58 267.49 216.39 248.67",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"334.22 206.6 316.29 224.5 324.61 232.75 324.51 232.88 329.71 238.08 329.88 237.91 331.52 239.55 358.39 212.68 339.53 193.82 330.49 202.86 334.22 206.6",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"148.15 187.8 130.25 169.86 122 178.18 121.87 178.08 116.67 183.29 116.84 183.46 115.2 185.09 142.07 211.96 160.93 193.1 151.88 184.06 148.15 187.8",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"371.02 169.74 367.24 165.96 340.11 193.09 349.55 202.52 349.65 202.43 359.1 211.88 385.98 185 384.31 183.33 384.46 183.18 373.67 172.4 373.54 172.53 370.89 169.87 371.02 169.74",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"184.97 224.65 188.75 220.87 161.63 193.74 152.19 203.18 152.29 203.28 142.84 212.73 169.72 239.61 171.39 237.94 171.54 238.09 182.32 227.3 182.19 227.17 184.84 224.52 184.97 224.65",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"149.68 261.3 145.9 265.08 173.03 292.21 182.46 282.77 182.37 282.68 191.82 273.22 164.94 246.34 163.27 248.01 163.12 247.87 152.34 258.65 152.47 258.78 149.81 261.43 149.68 261.3",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"330.41 240.47 328.82 238.87 328.84 238.85 325.77 235.78 325.69 235.86 317.97 228.15 318.05 228.06 315.43 225.44 315.83 225.04 312.02 221.23 302.61 230.63 306.35 234.37 288.36 252.36 303.43 267.44 330.41 240.47",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"225.42 295.16 227.01 293.56 227.03 293.59 230.1 290.52 230.02 290.43 237.74 282.71 237.82 282.8 240.45 280.18 240.84 280.57 244.65 276.76 235.25 267.36 231.51 271.09 213.52 253.1 198.44 268.18 225.42 295.16",fill:"#231f20"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{xmlns:"http://www.w3.org/2000/svg",id:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"cn",className:shouldDisplayByLang("cn")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(244 160)",fontSize:"10",fill:"#58595b","font-family":"Termina-Bold, Termina Bold"},"1 \u697C")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"ru",className:shouldDisplayByLang("ru")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(226 160)",fontSize:"11",fill:"#58595b","font-family":"Helvetica-Bold, Helvetica","font-weight":"700"},"1-\u0419 \u042D\u0422\u0410\u0416")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"en",className:shouldDisplayByLang("en")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(234 160)",fontSize:"10",fill:"#58595b","font-family":"Termina-Bold, Termina Bold","font-weight":"700"},"1st Floor"))));});

/***/ }),
/* 941 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1.322105ca.png";

/***/ }),
/* 942 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1-cn.7e15b4d0.png";

/***/ }),
/* 943 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1-ru.bb2d8b60.png";

/***/ }),
/* 944 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1-en.322105ca.png";

/***/ }),
/* 945 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__img_2_png__ = __webpack_require__(946);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__img_2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__img_2_png__);
// import _ from 'lodash'
// import MultiLineText from './MultiLineText';
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var currentLang=_ref.currentLang,selectedType=_ref.selectedType;var shouldDisplayByLang=function shouldDisplayByLang(selectLang){return currentLang===selectLang?"display":"display-none";};var shouldDisplayByType=function shouldDisplayByType(type){return selectedType===type||selectedType==="all"?"opacity-in":"opacity-out";};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 500 500",className:"site-plan-svg"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"map"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("image",{xlinkHref:__WEBPACK_IMPORTED_MODULE_1__img_2_png___default.a,height:"100%",width:"100%"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"floorplan"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"studio",className:shouldDisplayByType("studio")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"231.82 267.87 235.59 264.11 235.59 264.11 232.91 261.44 225.16 253.68 224.81 254.03 224.77 253.99 221.33 257.43 221.83 257.93 212.79 266.96 212.64 266.81 208.24 271.21 208.41 271.39 206.75 273.05 224.28 290.57 239.4 275.45 231.82 267.87",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"176.2 212.25 179.96 208.49 179.96 208.49 177.29 205.81 169.53 198.06 169.18 198.4 169.15 198.36 165.71 201.8 166.2 202.3 157.17 211.33 157.02 211.18 152.61 215.59 152.79 215.76 151.13 217.42 168.65 234.94 183.77 219.82 176.2 212.25",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"119.37 227.4 115.61 231.16 115.61 231.16 118.28 233.84 126.04 241.59 126.39 241.25 126.42 241.28 129.86 237.84 129.37 237.35 138.4 228.32 138.55 228.46 142.96 224.06 142.78 223.89 144.44 222.23 126.92 204.71 111.8 219.83 119.37 227.4",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"362.24 172.88 358.48 169.12 358.48 169.12 355.81 171.79 348.05 179.55 348.39 179.89 348.36 179.93 351.8 183.37 352.29 182.88 361.32 191.91 361.18 192.06 365.58 196.46 365.75 196.29 367.41 197.95 384.93 180.43 369.81 165.3 362.24 172.88",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"306.64 228.47 302.88 224.71 302.88 224.71 300.21 227.38 292.45 235.14 292.8 235.49 292.76 235.53 296.2 238.97 296.69 238.47 305.73 247.5 305.58 247.65 309.99 252.06 310.16 251.89 311.82 253.54 329.34 236.02 314.22 220.9 306.64 228.47",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"377.33 229.79 381.1 233.56 381.1 233.56 383.77 230.88 391.53 223.13 391.18 222.78 391.22 222.74 387.78 219.3 387.28 219.8 378.25 210.76 378.4 210.62 373.99 206.21 373.82 206.38 372.16 204.72 354.64 222.25 369.76 237.37 377.33 229.79",fill:"#231f20"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"one-bedroom",className:shouldDisplayByType("one-bedroom")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"137.43 231.15 130.28 238.31 129.82 237.85 123.06 244.6 130.99 252.53 127.63 255.9 138.26 266.53 148.43 256.36 147.9 255.83 162.97 240.75 145.27 223.06 139.21 229.12 139.36 229.27 137.45 231.18 137.43 231.15",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"346.21 215.87 347.87 217.52 330.35 235.04 315.25 219.95 315.07 220.12 311.27 216.32 313.7 213.89 314.06 214.26 329.36 198.96 341.85 211.46 342.05 211.26 346.43 215.65 346.21 215.87",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"290.58 271.49 292.24 273.15 274.72 290.67 259.62 275.57 259.45 275.75 255.65 271.95 258.07 269.52 258.44 269.88 273.73 254.59 286.23 267.09 286.42 266.89 290.8 271.27 290.58 271.49",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"188.85 251.84 187.19 253.5 169.67 235.98 184.77 220.88 184.59 220.71 188.4 216.91 190.82 219.33 190.46 219.7 205.75 234.99 193.26 247.49 193.45 247.68 189.07 252.06 188.85 251.84",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"133.28 196.28 131.63 197.94 114.11 180.41 129.2 165.32 129.03 165.14 132.83 161.34 135.26 163.77 134.89 164.13 150.19 179.42 137.69 191.92 137.88 192.12 133.5 196.5 133.28 196.28",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"366.49 199 348.87 216.63 330.36 198.11 330.2 198.27 326.42 194.48 328.8 192.1 329.19 192.5 344.51 177.18 360.35 193.01 360.55 192.82 364.98 197.25 364.86 197.37 366.49 199",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"310.95 254.54 293.33 272.16 274.82 253.65 274.67 253.8 270.88 250.02 273.26 247.64 273.66 248.03 288.98 232.71 304.81 248.55 305.01 248.35 309.44 252.78 309.32 252.91 310.95 254.54",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"205.73 272.18 188.11 254.56 206.62 236.04 206.47 235.89 210.25 232.1 212.64 234.49 212.24 234.88 227.56 250.2 211.72 266.04 211.92 266.24 207.49 270.67 207.37 270.54 205.73 272.18",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"150.2 216.65 132.58 199.03 151.09 180.51 150.94 180.36 154.72 176.57 157.11 178.96 156.71 179.35 172.03 194.67 156.19 210.51 156.39 210.71 151.96 215.14 151.84 215.01 150.2 216.65",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"335.97 240.73 353.59 223.11 372.1 241.62 372.25 241.47 376.04 245.25 373.66 247.63 373.26 247.24 357.95 262.56 342.11 246.72 341.91 246.92 337.48 242.49 337.6 242.36 335.97 240.73",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"235.62 324.03 235.62 302.62 224.78 302.62 219.52 297.36 201 315.89 209.12 324 209.12 328.78 221.99 328.78 221.99 329.28 225.82 329.28 225.82 324.06 235.62 324.03",fill:"#231f20"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"two-bedroom",className:shouldDisplayByType("two-bedroom")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"315.49 275.94 308.21 268.66 335.1 241.77 336.73 243.39 336.85 243.26 339.94 246.36 339.84 246.46 350.27 256.89 350.72 256.44 354.43 260.15 335.38 279.21 331.66 275.5 323.25 283.91 315.38 276.05 315.49 275.94",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"208.92 305.79 199.19 315.51 190.93 307.25 187.49 310.69 168.43 291.63 175.58 284.48 175.98 284.88 191.14 269.72 218.06 296.64 216.39 298.31 216.56 298.48 209.08 305.95 208.92 305.79",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"289.62 305.54 299.35 315.26 307.61 307 311.05 310.44 330.11 291.38 322.96 284.23 322.56 284.63 307.4 269.47 280.48 296.39 282.15 298.06 281.99 298.23 289.46 305.7 289.62 305.54",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"148.69 256.77 144.91 260.55 172.03 287.68 181.47 278.24 181.38 278.14 190.83 268.69 163.95 241.81 162.28 243.48 162.13 243.34 151.34 254.12 151.47 254.25 148.82 256.9 148.69 256.77",fill:"#231f20"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{xmlns:"http://www.w3.org/2000/svg",id:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"cn",className:shouldDisplayByLang("cn")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(244 160)","font-size":"10",fill:"#58595b","font-family":"Termina-Bold, Termina Bold"},"2 \u697C")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"ru",className:shouldDisplayByLang("ru")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(226 160)","font-size":"11",fill:"#58595b","font-family":"Helvetica-Bold, Helvetica","font-weight":"700"},"2-\u0419 \u042D\u0422\u0410\u0416")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"en",className:shouldDisplayByLang("en")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(234 160)","font-size":"10",fill:"#58595b","font-family":"Termina-Bold, Termina Bold","font-weight":"700"},"2nd Floor"))));});

/***/ }),
/* 946 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/2.ba755126.png";

/***/ }),
/* 947 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__img_3_png__ = __webpack_require__(948);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__img_3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__img_3_png__);
// import _ from 'lodash'
// import MultiLineText from './MultiLineText';
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var currentLang=_ref.currentLang,selectedType=_ref.selectedType;var shouldDisplayByLang=function shouldDisplayByLang(selectLang){return currentLang===selectLang?"display":"display-none";};var shouldDisplayByType=function shouldDisplayByType(type){return selectedType===type||selectedType==="all"?"opacity-in":"opacity-out";};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 500 500",className:"site-plan-svg"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"map"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("image",{xlinkHref:__WEBPACK_IMPORTED_MODULE_1__img_3_png___default.a,height:"100%",width:"100%"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"floorplan"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"studio",className:shouldDisplayByType("studio")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"358.2 176.93 354.44 173.17 354.44 173.17 357.11 170.5 364.87 162.74 365.22 163.08 365.25 163.05 368.69 166.49 368.2 166.98 377.23 176.01 377.38 175.87 381.79 180.27 381.61 180.44 383.27 182.1 365.75 199.63 350.63 184.5 358.2 176.93",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"302.67 232.46 298.91 228.7 298.91 228.7 301.58 226.03 309.34 218.27 309.69 218.61 309.72 218.58 313.16 222.02 312.67 222.51 321.7 231.54 321.85 231.4 326.26 235.8 326.08 235.97 327.74 237.63 310.22 255.16 295.1 240.03 302.67 232.46",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"227.67 267.13 231.44 263.37 231.44 263.37 234.11 266.04 241.87 273.8 241.52 274.15 241.56 274.18 238.12 277.62 237.62 277.13 228.59 286.16 228.74 286.31 224.33 290.71 224.16 290.54 222.5 292.2 204.98 274.68 220.1 259.56 227.67 267.13",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"172.1 211.56 175.86 207.79 175.86 207.79 178.53 210.47 186.29 218.22 185.95 218.57 185.98 218.61 182.54 222.05 182.05 221.55 173.02 230.59 173.16 230.74 168.76 235.14 168.59 234.97 166.93 236.63 149.41 219.1 164.53 203.98 172.1 211.56",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"119.96 231.34 116.2 235.1 116.19 235.09 113.52 232.42 105.76 224.67 106.11 224.32 106.07 224.28 109.51 220.84 110.01 221.34 119.04 212.3 118.89 212.16 123.3 207.75 123.47 207.92 125.13 206.26 142.65 223.79 127.53 238.91 119.96 231.34",fill:"#231f20"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"one-bedroom",className:shouldDisplayByType("one-bedroom")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"159.55 244.07 161.26 242.36 143.76 224.85 128.61 240.01 128.08 239.48 121.32 246.23 131.95 256.86 135.34 253.46 142.75 260.87 155.21 248.41 155.42 248.63 159.76 244.29 159.55 244.07",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"372.1 207.97 370.44 206.31 352.92 223.84 368.02 238.93 367.85 239.11 371.65 242.91 374.07 240.48 373.71 240.12 389.01 224.82 376.51 212.33 376.7 212.13 372.32 207.75 372.1 207.97",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"328.5 236.74 346.12 219.12 327.61 200.61 327.76 200.46 323.98 196.67 321.6 199.05 321.99 199.44 306.67 214.76 322.51 230.6 322.31 230.8 326.74 235.23 326.87 235.11 328.5 236.74",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"272.99 292.25 290.61 274.63 272.1 256.12 272.25 255.96 268.47 252.18 266.09 254.56 266.48 254.95 251.16 270.27 267 286.11 266.81 286.31 271.24 290.74 271.36 290.62 272.99 292.25",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"167.85 237.45 185.47 255.07 203.99 236.56 204.14 236.72 207.93 232.93 205.54 230.55 205.15 230.94 189.83 215.63 173.99 231.46 173.79 231.27 169.36 235.7 169.49 235.82 167.85 237.45",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"112.28 181.89 129.91 199.51 148.42 181 148.57 181.15 152.36 177.36 149.98 174.98 149.58 175.38 134.26 160.06 118.42 175.9 118.22 175.7 113.8 180.13 113.92 180.25 112.28 181.89",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"340.44 211.72 340.62 211.52 340.65 211.58 339.2 210.13 339.19 210.14 331.96 202.92 331.49 203.38 324.49 196.38 332.4 188.43 329.38 185.4 339.9 174.88 350.07 185.05 349.64 185.48 364.72 200.55 347.02 218.25 340.93 212.15 340.44 211.72",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"284.88 267.29 285.05 267.09 285.08 267.15 283.63 265.69 283.62 265.71 276.39 258.48 275.92 258.95 268.92 251.95 276.84 244 273.81 240.97 284.33 230.45 294.51 240.62 294.08 241.04 309.15 256.12 291.45 273.81 285.36 267.72 284.88 267.29",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"192.83 249.39 193.03 249.56 192.97 249.59 194.43 248.14 194.41 248.13 201.64 240.9 201.17 240.43 208.17 233.43 216.12 241.35 219.15 238.32 229.68 248.84 219.5 259.02 219.07 258.59 204 273.66 186.31 255.96 192.4 249.87 192.83 249.39",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"137.32 193.88 137.53 194.06 137.47 194.09 138.92 192.64 138.9 192.62 146.13 185.39 145.66 184.93 152.67 177.92 160.61 185.84 163.64 182.81 174.17 193.34 164 203.51 163.57 203.08 148.5 218.15 130.8 200.46 136.89 194.36 137.32 193.88",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"358.48 231.19 358.3 231.39 358.27 231.33 359.72 232.78 359.73 232.77 366.96 240 367.43 239.53 374.43 246.53 366.52 254.48 369.54 257.51 359.02 268.03 348.85 257.86 349.27 257.43 334.2 242.36 351.9 224.67 357.99 230.76 358.48 231.19",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"233.86 325.54 233.86 304.13 223.02 304.13 217.76 298.87 199.24 317.4 207.35 325.52 207.35 330.29 220.22 330.29 220.22 330.79 224.06 330.79 224.06 325.57 233.86 325.54",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"261.64 325.6 261.64 304.19 272.49 304.19 277.74 298.93 296.27 317.46 288.15 325.57 288.15 330.35 275.28 330.35 275.28 330.85 271.44 330.85 271.44 325.63 261.64 325.6",fill:"#231f20"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"two-bedroom",className:shouldDisplayByType("two-bedroom")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"339.56 267.43 321.57 285.42 306.42 270.27 333.39 243.29 335.06 244.96 335.08 244.93 348.5 258.35 348.89 257.95 352.7 261.76 343.3 271.16 339.56 267.43",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"280.05 296.68 281.77 298.4 280.38 299.79 287.77 307.18 287.92 307.03 293.95 313.05 301.06 320.17 327.99 293.25 305.74 271 280.05 296.68",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"183.1 294.66 174.69 286.24 189.83 271.1 216.83 298.1 215.2 299.73 215.22 299.76 201.71 313.27 202.16 313.71 198.44 317.43 179.39 298.37 183.1 294.66",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{"class":"cls-2",x:"147.08",y:"252.81",width:"38.24",height:"26.67",transform:"translate(236.87 -39.57) rotate(45)",fill:"#231f20"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"cn",className:shouldDisplayByLang("cn")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(244 160)","font-size":"10",fill:"#58595b","font-family":"Termina-Bold, Termina Bold"},"3 \u697C")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"ru",className:shouldDisplayByLang("ru")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(226 160)","font-size":"11",fill:"#58595b","font-family":"Helvetica-Bold, Helvetica","font-weight":"700"},"3-\u0419 \u042D\u0422\u0410\u0416")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"en",className:shouldDisplayByLang("en")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(234 160)","font-size":"10",fill:"#58595b","font-family":"Termina-Bold, Termina Bold","font-weight":"700"},"3rd Floor"))));});

/***/ }),
/* 948 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/3.d5d6add6.png";

/***/ }),
/* 949 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__img_4_png__ = __webpack_require__(950);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__img_4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__img_4_png__);
// import _ from 'lodash'
// import MultiLineText from './MultiLineText';
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var currentLang=_ref.currentLang,selectedType=_ref.selectedType;var shouldDisplayByLang=function shouldDisplayByLang(selectLang){return currentLang===selectLang?"display":"display-none";};var shouldDisplayByType=function shouldDisplayByType(type){return selectedType===type||selectedType==="all"?"opacity-in":"opacity-out";};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 500 500",className:"site-plan-svg"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"map"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("image",{xlinkHref:__WEBPACK_IMPORTED_MODULE_1__img_4_png___default.a,height:"100%",width:"100%"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"floorplan"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"studio",className:shouldDisplayByType("studio")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"134.74 246.05 130.97 249.81 130.97 249.81 133.65 252.48 141.41 260.24 141.75 259.9 141.79 259.93 145.23 256.49 144.73 256 153.77 246.97 153.92 247.11 158.32 242.71 158.15 242.53 159.81 240.88 142.28 223.35 127.16 238.48 134.74 246.05",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"172.91 212.25 176.68 208.49 176.68 208.48 174 205.81 166.25 198.05 165.9 198.4 165.86 198.36 162.42 201.8 162.92 202.3 153.88 211.33 153.73 211.18 149.33 215.59 149.5 215.76 147.84 217.42 165.37 234.94 180.49 219.82 172.91 212.25",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"228.6 267.93 232.36 264.17 232.36 264.17 229.69 261.5 221.93 253.74 221.58 254.09 221.55 254.05 218.11 257.49 218.6 257.98 209.57 267.02 209.42 266.87 205.01 271.27 205.19 271.45 203.53 273.11 221.05 290.63 236.17 275.5 228.6 267.93",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"303.39 228.5 299.63 224.74 299.63 224.74 296.95 227.41 289.2 235.17 289.54 235.52 289.5 235.56 292.94 239 293.44 238.5 302.47 247.53 302.32 247.68 306.73 252.09 306.9 251.91 308.56 253.57 326.08 236.05 310.96 220.93 303.39 228.5",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"359.01 172.88 355.25 169.12 355.25 169.12 352.58 171.79 344.82 179.55 345.17 179.89 345.13 179.93 348.57 183.37 349.07 182.88 358.1 191.91 357.95 192.06 362.36 196.46 362.53 196.29 364.19 197.95 381.71 180.43 366.59 165.3 359.01 172.88",fill:"#231f20"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"one-bedroom",className:shouldDisplayByType("one-bedroom")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"344.75 217.4 327.13 235.02 308.61 216.51 308.46 216.66 304.68 212.88 307.06 210.5 307.45 210.89 322.77 195.57 338.61 211.41 338.81 211.22 343.24 215.65 343.11 215.77 344.75 217.4",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"289.24 272.91 271.62 290.53 253.11 272.02 252.95 272.17 249.17 268.39 251.55 266.01 251.94 266.4 267.26 251.08 283.1 266.92 283.3 266.72 287.73 271.15 287.61 271.28 289.24 272.91",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"183.91 253.7 166.29 236.08 184.81 217.57 184.65 217.42 188.44 213.63 190.82 216.01 190.42 216.41 205.74 231.73 189.9 247.56 190.1 247.76 185.67 252.19 185.55 252.07 183.91 253.7",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"128.47 198.02 110.84 180.4 129.36 161.88 129.2 161.73 132.99 157.95 135.37 160.33 134.97 160.72 150.29 176.04 134.46 191.88 134.65 192.08 130.22 196.51 130.1 196.38 128.47 198.02",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"351.26 222.33 368.88 204.71 387.39 223.22 387.55 223.07 391.33 226.85 388.95 229.24 388.56 228.84 373.24 244.16 357.4 228.32 357.2 228.52 352.77 224.09 352.89 223.96 351.26 222.33",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"361.56 197.32 363.27 199.03 345.77 216.54 330.61 201.38 330.08 201.91 323.33 195.16 333.95 184.53 337.35 187.93 344.76 180.52 357.21 192.98 357.43 192.76 361.77 197.1 361.56 197.32",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"305.87 253 307.58 254.72 290.08 272.22 274.93 257.07 274.4 257.6 267.64 250.84 278.27 240.22 281.67 243.61 289.07 236.21 301.53 248.66 301.74 248.44 306.09 252.79 305.87 253",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"204.19 270.29 202.47 272.01 184.97 254.5 200.12 239.35 199.59 238.82 206.35 232.06 216.98 242.69 213.58 246.09 220.99 253.49 208.53 265.95 208.75 266.17 204.4 270.51 204.19 270.29",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"148.68 214.78 146.97 216.5 129.46 198.99 144.61 183.84 144.08 183.31 150.84 176.56 161.47 187.18 158.07 190.58 165.48 197.99 153.02 210.44 153.24 210.66 148.9 215 148.68 214.78",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"122.08 206.46 123.74 204.8 141.27 222.32 126.17 237.42 126.34 237.59 122.54 241.4 120.11 238.97 120.48 238.61 105.18 223.31 117.68 210.81 117.48 210.62 121.87 206.24 122.08 206.46",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"232.43 324.06 232.43 302.65 221.59 302.65 216.33 297.39 197.8 315.92 205.92 324.03 205.92 328.81 218.79 328.81 218.79 329.31 222.63 329.31 222.63 324.08 232.43 324.06",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"260.21 324.12 260.21 302.71 271.05 302.71 276.31 297.45 294.83 315.98 286.72 324.09 286.72 328.87 273.85 328.87 273.85 329.37 270.01 329.37 270.01 324.14 260.21 324.12",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"340.71 248.77 347.86 255.92 347.4 256.38 354.16 263.14 362.09 255.2 365.46 258.57 376.09 247.94 365.91 237.77 365.38 238.3 350.31 223.23 332.62 240.92 338.68 246.99 338.83 246.84 340.73 248.74 340.71 248.77",fill:"#231f20"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"two-bedroom",className:shouldDisplayByType("two-bedroom")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"311.11 313.86 307.73 310.49 299.04 319.17 291.92 312.05 291.36 312.6 276.21 297.46 304.17 269.5 322.69 288.03 322.99 287.73 330.12 294.85 311.11 313.86",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{x:"308.66",y:"251.15",width:"38.24",height:"26.67",transform:"translate(-91.01 309.24) rotate(-45)",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"161.92 242.98 160.21 244.69 158.82 243.3 151.43 250.69 151.58 250.85 145.56 256.87 138.44 263.99 165.36 290.91 187.61 268.66 161.92 242.98",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{points:"191.2 302.58 173.21 284.59 188.36 269.44 215.33 296.41 213.67 298.08 213.69 298.1 200.28 311.51 200.68 311.91 196.87 315.72 187.46 306.32 191.2 302.58",fill:"#231f20"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{xmlns:"http://www.w3.org/2000/svg",id:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"cn",className:shouldDisplayByLang("cn")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(244 160)","font-size":"10",fill:"#58595b","font-family":"Termina-Bold, Termina Bold"},"4 \u697C")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"ru",className:shouldDisplayByLang("ru")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(226 160)","font-size":"11",fill:"#58595b","font-family":"Helvetica-Bold, Helvetica","font-weight":"700"},"4-\u0419 \u042D\u0422\u0410\u0416")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"en",className:shouldDisplayByLang("en")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(234 160)","font-size":"10",fill:"#58595b","font-family":"Termina-Bold, Termina Bold","font-weight":"700"},"4th Floor"))));});

/***/ }),
/* 950 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/4.a06b58f5.png";

/***/ }),
/* 951 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__img_5_png__ = __webpack_require__(952);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__img_5_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__img_5_png__);
// import _ from 'lodash'
// import MultiLineText from './MultiLineText';
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var currentLang=_ref.currentLang,selectedType=_ref.selectedType;var shouldDisplayByLang=function shouldDisplayByLang(selectLang){return currentLang===selectLang?"display":"display-none";};var shouldDisplayByType=function shouldDisplayByType(type){return selectedType===type||selectedType==="all"?"opacity-in":"opacity-out";};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 500 500",className:"site-plan-svg"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"map"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("image",{xlinkHref:__WEBPACK_IMPORTED_MODULE_1__img_5_png___default.a,height:"100%",width:"100%"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"floorplan"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"studio",className:shouldDisplayByType("studio")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"140.7 248.45 136.94 252.21 136.94 252.21 134.27 249.53 126.51 241.78 126.86 241.43 126.82 241.39 130.26 237.95 130.75 238.45 139.79 229.41 139.64 229.27 144.04 224.86 144.22 225.03 145.88 223.38 163.4 240.9 148.28 256.02 140.7 248.45",fill:"#231f20"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"one-bedroom",className:shouldDisplayByType("one-bedroom")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"144.93 222.45 127.31 204.83 108.8 223.34 108.64 223.19 104.86 226.97 107.24 229.35 107.63 228.96 122.95 244.28 138.79 228.44 138.99 228.64 143.42 224.21 143.3 224.08 144.93 222.45",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"236.03 324.09 236.03 302.68 225.19 302.68 219.93 297.42 201.41 315.95 209.52 324.06 209.52 328.84 222.39 328.84 222.39 329.34 226.23 329.34 226.23 324.12 236.03 324.09",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"263.81 324.15 263.81 302.74 274.65 302.74 279.91 297.48 298.44 316.01 290.32 324.12 290.32 328.9 277.45 328.9 277.45 329.4 273.61 329.4 273.61 324.17 263.81 324.15",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-3",points:"355.81 225.1 354.1 223.39 336.6 240.89 351.75 256.04 351.22 256.57 357.97 263.33 368.6 252.7 365.2 249.31 372.61 241.9 360.16 229.44 360.37 229.23 356.03 224.88 355.81 225.1",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"379.32 211.15 379.14 211.36 379.11 211.3 380.56 212.75 380.57 212.73 387.8 219.96 388.27 219.49 395.27 226.5 387.36 234.45 390.38 237.47 379.86 248 369.69 237.83 370.12 237.4 355.04 222.33 372.74 204.63 378.83 210.72 379.32 211.15",fill:"#231f20"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"two-bedroom",className:shouldDisplayByType("two-bedroom")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"350.77 256.8 354.55 260.58 327.43 287.71 317.99 278.27 318.09 278.18 308.63 268.72 335.51 241.84 337.19 243.51 337.33 243.37 348.12 254.15 347.99 254.28 350.64 256.93 350.77 256.8",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"299.26 222.16 307.56 213.86 315.72 222.02 315.73 222 329.85 236.12 302.83 263.14 284.31 244.62 284.01 244.91 276.88 237.79 295.89 218.78 299.26 222.16",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"183.05 204.69 191.34 212.98 183.18 221.14 183.2 221.16 169.08 235.27 142.06 208.25 160.59 189.73 160.29 189.43 167.41 182.31 186.42 201.31 183.05 204.69",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"150.27 272.4 141.97 264.11 150.13 255.95 150.12 255.94 164.23 241.82 191.25 268.84 172.73 287.36 173.03 287.66 165.9 294.79 146.89 275.78 150.27 272.4",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"330.5 197.69 327.12 194.32 308.21 213.23 315.34 220.36 315.65 220.04 318.29 222.68 318.16 222.81 328.98 233.63 329.11 233.5 330.76 235.15 357.73 208.18 338.87 189.32 330.5 197.69",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"274.82 253.38 271.44 250 252.52 268.92 259.65 276.04 259.97 275.73 262.6 278.36 262.47 278.49 273.29 289.31 273.42 289.18 275.08 290.84 302.05 263.87 283.19 245.01 274.82 253.38",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"318.32 296.88 321.69 300.26 302.78 319.17 295.65 312.04 295.97 311.73 293.33 309.09 293.2 309.22 282.38 298.4 282.51 298.27 280.86 296.62 307.83 269.65 326.69 288.51 318.32 296.88",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"207.48 235.9 210.85 232.53 191.94 213.61 184.81 220.74 185.13 221.05 182.49 223.69 182.36 223.56 171.54 234.38 171.67 234.51 170.02 236.16 196.99 263.13 215.85 244.27 207.48 235.9",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"151.9 180.33 155.28 176.95 136.37 158.04 129.24 165.16 129.55 165.48 126.92 168.12 126.79 167.99 115.97 178.81 116.1 178.94 114.44 180.59 141.41 207.56 160.27 188.7 151.9 180.33",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{"class":"cls-2",x:"201.59",y:"254.55",width:"38.24",height:"26.67",transform:"translate(254.07 -77.61) rotate(45)",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{"class":"cls-2",x:"176.98",y:"279.16",width:"38.24",height:"26.67",transform:"translate(264.26 -52.99) rotate(45)",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{"class":"cls-2",x:"343.28",y:"171.34",width:"38.24",height:"26.67",transform:"translate(-24.44 310.35) rotate(-45)",fill:"#231f20"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{xmlns:"http://www.w3.org/2000/svg",id:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"cn",className:shouldDisplayByLang("cn")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(244 160)","font-size":"10",fill:"#58595b","font-family":"Termina-Bold, Termina Bold"},"5 \u697C")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"ru",className:shouldDisplayByLang("ru")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(226 160)","font-size":"11",fill:"#58595b","font-family":"Helvetica-Bold, Helvetica","font-weight":"700"},"5-\u0419 \u042D\u0422\u0410\u0416")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"en",className:shouldDisplayByLang("en")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(234 160)","font-size":"10",fill:"#58595b","font-family":"Termina-Bold, Termina Bold","font-weight":"700"},"5th Floor"))));});

/***/ }),
/* 952 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/5.63cb9336.png";

/***/ }),
/* 953 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__img_6_png__ = __webpack_require__(954);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__img_6_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__img_6_png__);
// import _ from 'lodash'
// import MultiLineText from './MultiLineText';
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var currentLang=_ref.currentLang,selectedType=_ref.selectedType;var shouldDisplayByLang=function shouldDisplayByLang(selectLang){return currentLang===selectLang?"display":"display-none";};var shouldDisplayByType=function shouldDisplayByType(type){return selectedType===type||selectedType==="all"?"opacity-in":"opacity-out";};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 500 500",className:"site-plan-svg"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"map"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("image",{xlinkHref:__WEBPACK_IMPORTED_MODULE_1__img_6_png___default.a,height:"100%",width:"100%"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"floorplan"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"studio",className:shouldDisplayByType("studio")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"359.04 254.75 362.81 258.51 362.81 258.51 365.48 255.84 373.24 248.08 372.89 247.73 372.93 247.69 369.49 244.25 368.99 244.75 359.96 235.72 360.11 235.57 355.7 231.16 355.53 231.33 353.87 229.68 336.35 247.2 351.47 262.32 359.04 254.75",fill:"#231f20"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"one-bedroom",className:shouldDisplayByType("one-bedroom")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"120.45 217.49 120.62 217.7 120.65 217.64 119.2 219.09 119.19 219.07 111.96 226.3 111.49 225.83 104.49 232.84 112.41 240.78 109.38 243.81 119.9 254.34 130.08 244.16 129.65 243.74 144.72 228.66 127.02 210.97 120.93 217.06 120.45 217.49",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"144.11 231.38 145.77 229.72 163.29 247.24 148.19 262.34 148.37 262.51 144.57 266.31 142.14 263.89 142.5 263.52 127.21 248.23 139.71 235.73 139.51 235.54 143.89 231.16 144.11 231.38",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"235.83 330.54 235.83 309.13 224.99 309.13 219.74 303.87 201.21 322.4 209.33 330.51 209.33 335.29 222.2 335.29 222.2 335.79 226.03 335.79 226.03 330.56 235.83 330.54",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"263.62 330.6 263.62 309.19 274.46 309.19 279.72 303.93 298.24 322.45 290.13 330.57 290.13 335.35 277.26 335.35 277.26 335.84 273.42 335.84 273.42 330.62 263.62 330.6",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"361.28 235.44 361.49 235.26 361.43 235.23 362.88 236.68 362.87 236.7 370.09 243.93 369.63 244.39 376.63 251.4 384.58 243.48 387.6 246.51 398.13 235.98 387.96 225.81 387.53 226.24 372.46 211.17 354.76 228.86 360.86 234.95 361.28 235.44",fill:"#231f20"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"two-bedroom",className:shouldDisplayByType("two-bedroom")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{"class":"cls-2",x:"176.93",y:"285.54",width:"38.17",height:"26.54",transform:"translate(268.7 -51.08) rotate(45)",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"304.29 309.68 295.87 318.09 280.73 302.95 307.73 275.95 309.36 277.58 309.38 277.56 322.9 291.07 323.34 290.62 327.06 294.33 308 313.39 304.29 309.68",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{"class":"cls-2",x:"314.14",y:"257.03",width:"38.17",height:"31.48",transform:"translate(-95.28 315.52) rotate(-45)",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"252.79 274.86 265.98 288.05 265.87 288.15 273.25 295.53 273.36 295.42 275.01 297.08 301.98 270.11 279.76 247.89 252.79 274.86",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"192.19 220.27 179.01 233.46 178.9 233.35 171.52 240.73 171.63 240.84 169.97 242.5 196.94 269.46 219.16 247.24 192.19 220.27",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"136.57 164.65 123.38 177.84 123.27 177.73 115.9 185.1 116.01 185.21 114.35 186.87 141.31 213.84 163.54 191.62 136.57 164.65",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{"class":"cls-2",x:"315.49",y:"205.24",width:"38.24",height:"26.67",transform:"translate(-56.55 300.62) rotate(-45)",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"347.75 186.72 344.38 183.35 363.29 164.43 370.42 171.56 370.1 171.88 372.74 174.51 372.87 174.38 383.69 185.2 383.56 185.33 385.21 186.99 358.24 213.96 339.38 195.1 347.75 186.72",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"292.25 242.23 288.87 238.86 307.78 219.94 314.91 227.07 314.59 227.38 317.23 230.02 317.36 229.89 328.18 240.71 328.05 240.84 329.7 242.49 302.73 269.46 283.87 250.6 292.25 242.23",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"224.91 259.71 228.28 256.33 247.2 275.25 240.07 282.37 239.76 282.06 237.12 284.69 237.25 284.82 226.43 295.64 226.3 295.51 224.65 297.17 197.68 270.2 216.53 251.34 224.91 259.71",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"169.31 204.11 172.69 200.74 191.6 219.65 184.47 226.78 184.16 226.46 181.52 229.1 181.65 229.23 170.83 240.05 170.7 239.92 169.05 241.57 142.08 214.6 160.94 195.74 169.31 204.11",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"163.9 285.76 160.52 289.14 141.61 270.23 148.74 263.1 149.05 263.42 151.69 260.78 151.56 260.65 162.38 249.83 162.51 249.96 164.16 248.31 191.13 275.27 172.27 294.13 163.9 285.76",fill:"#231f20"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"cn",className:shouldDisplayByLang("cn")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(244 160)","font-size":"10",fill:"#58595b","font-family":"Termina-Bold, Termina Bold"},"6 \u697C")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"ru",className:shouldDisplayByLang("ru")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(226 160)","font-size":"11",fill:"#58595b","font-family":"Helvetica-Bold, Helvetica","font-weight":"700"},"6-\u0419 \u042D\u0422\u0410\u0416")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"en",className:shouldDisplayByLang("en")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(234 160)","font-size":"10",fill:"#58595b","font-family":"Termina-Bold, Termina Bold","font-weight":"700"},"6th Floor"))));});

/***/ }),
/* 954 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/6.ead91827.png";

/***/ }),
/* 955 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__img_7_png__ = __webpack_require__(956);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__img_7_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__img_7_png__);
// import _ from 'lodash'
// import MultiLineText from './MultiLineText';
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var currentLang=_ref.currentLang,selectedType=_ref.selectedType;var shouldDisplayByLang=function shouldDisplayByLang(selectLang){return currentLang===selectLang?"display":"display-none";};var shouldDisplayByType=function shouldDisplayByType(type){return selectedType===type||selectedType==="all"?"opacity-in":"opacity-out";};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 500 500",className:"site-plan-svg"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"map"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("image",{xlinkHref:__WEBPACK_IMPORTED_MODULE_1__img_7_png___default.a,height:"100%",width:"100%"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"floorplan"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"studio",className:shouldDisplayByType("studio")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"361.49 251.84 365.26 255.6 365.25 255.6 362.58 258.27 354.82 266.03 354.48 265.68 354.44 265.72 351 262.28 351.5 261.79 342.46 252.75 342.31 252.9 337.91 248.49 338.08 248.32 336.42 246.66 353.94 229.14 369.07 244.26 361.49 251.84",fill:"#231f20"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"one-bedroom",className:shouldDisplayByType("one-bedroom")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"136.98 236.19 129.83 243.34 130.29 243.8 123.53 250.56 115.6 242.63 112.23 245.99 101.6 235.36 111.77 225.19 112.31 225.72 127.38 210.65 145.07 228.35 139.01 234.41 138.86 234.26 136.96 236.17 136.98 236.19",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"374.25 212.34 372.54 210.63 355.03 228.13 370.19 243.28 369.66 243.81 376.41 250.57 387.04 239.94 383.64 236.54 391.05 229.14 378.6 216.68 378.81 216.47 374.47 212.12 374.25 212.34",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"163.37 246.7 145.75 229.08 127.24 247.59 127.09 247.44 123.3 251.22 125.68 253.6 126.08 253.21 141.4 268.53 157.24 252.69 157.43 252.89 161.86 248.46 161.74 248.33 163.37 246.7",fill:"#231f20"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"two-bedroom",className:shouldDisplayByType("two-bedroom")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"223.46 295.29 225.17 293.57 226.56 294.97 233.95 287.57 233.8 287.42 239.82 281.4 246.94 274.28 220.02 247.36 197.77 269.61 223.46 295.29",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"313.91 299.54 295.97 317.48 280.82 302.33 307.85 275.31 322.99 290.45 323.41 290.03 327.16 293.78 317.66 303.29 313.91 299.54",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"259.52 281.89 249.05 271.42 268.08 252.39 271.43 255.73 279.8 247.35 302.03 269.58 275.15 296.45 273.47 294.77 273.3 294.94 262.53 284.18 262.65 284.06 260 281.41 259.52 281.89",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"351.05 262.2 361.52 272.67 342.48 291.71 339.14 288.37 330.76 296.74 308.54 274.51 335.41 247.64 337.1 249.32 337.27 249.15 348.03 259.91 347.91 260.03 350.56 262.69 351.05 262.2",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"184.72 226.31 195.19 215.84 214.22 234.88 210.88 238.22 219.26 246.6 197.03 268.82 170.15 241.95 171.84 240.26 171.66 240.09 182.43 229.32 182.55 229.44 185.2 226.79 184.72 226.31",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"129.15 170.74 139.62 160.28 158.66 179.31 155.31 182.65 163.69 191.03 141.46 213.26 114.59 186.38 116.27 184.7 116.1 184.52 126.86 173.76 126.98 173.88 129.63 171.23 129.15 170.74",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{"class":"cls-2",x:"178.62",y:"280.9",width:"31.48",height:"38.17",transform:"translate(-155.19 225.29) rotate(-45)",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{"class":"cls-2",x:"313.87",y:"200.63",width:"38.17",height:"31.48",transform:"translate(-55.48 298.8) rotate(-45)",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"361.82 179.54 370.24 171.13 385.39 186.28 358.38 213.28 356.75 211.64 356.73 211.67 343.21 198.15 342.77 198.6 339.06 194.89 358.11 175.83 361.82 179.54",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"306.23 235.14 314.64 226.72 329.79 241.87 302.79 268.87 301.16 267.24 301.13 267.26 287.62 253.75 287.17 254.2 283.46 250.48 302.52 231.43 306.23 235.14",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"175.98 217.5 184.39 225.91 169.25 241.06 142.24 214.06 143.88 212.42 143.85 212.4 157.37 198.89 156.92 198.44 160.63 194.73 179.69 213.78 175.98 217.5",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{"class":"cls-2",points:"157.5 271.03 149.08 262.61 164.23 247.47 191.23 274.47 189.59 276.1 189.62 276.13 176.11 289.64 176.55 290.08 172.84 293.8 153.78 274.74 157.5 271.03",fill:"#231f20"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{xmlns:"http://www.w3.org/2000/svg",id:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"cn",className:shouldDisplayByLang("cn")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(244 160)","font-size":"10",fill:"#58595b","font-family":"Termina-Bold, Termina Bold"},"7 \u697C")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"ru",className:shouldDisplayByLang("ru")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(226 160)","font-size":"11",fill:"#58595b","font-family":"Helvetica-Bold, Helvetica","font-weight":"700"},"7-\u0419 \u042D\u0422\u0410\u0416")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"en",className:shouldDisplayByLang("en")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(234 160)","font-size":"10",fill:"#58595b","font-family":"Termina-Bold, Termina Bold","font-weight":"700"},"7th Floor"))));});

/***/ }),
/* 956 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/7.9edaa332.png";

/***/ }),
/* 957 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__1_png__ = __webpack_require__(958);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__1_png__);
// import _ from 'lodash'
// import MultiLineText from './MultiLineText';
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var currentLang=_ref.currentLang,selectedType=_ref.selectedType;var shouldDisplayByLang=function shouldDisplayByLang(selectLang){return currentLang===selectLang?"display":"display-none";};var shouldDisplayByType=function shouldDisplayByType(type){return selectedType===type||selectedType==="all"?"opacity-in":"opacity-out";};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 329.4 363.4",className:"site-plan-svg"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"map"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("image",{xlinkHref:__WEBPACK_IMPORTED_MODULE_1__1_png___default.a,height:"100%",width:"100%"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"floorplan"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"studio",className:shouldDisplayByType("studio")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1A_2105","data-name":"1A_2105",points:"108.2 97.6 134.4 97.6 134.4 141 94.6 141 94.6 132.1 107.5 119.1 107.5 97.6 108.2 97.6",fill:"#231f20"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"two-bedroom",className:shouldDisplayByType("two-bedroom")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_2B1_2101","data-name":"2B1_2101",points:"252.3 97.6 292.3 97.5 292.3 138.6 287 138.6 287 137.1 282.7 137.1 282.7 141 252.3 141 252.3 97.6",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_2A2_2102","data-name":"2A2_2102",points:"213 97.6 252.3 97.6 252.3 141 247 141 247 137.2 242.7 137.2 242.7 141 213 141 213 97.6",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_2B1_2103","data-name":"2B1_2103",points:"173.7 97.6 213 97.6 213 141 207.7 141 207.7 137.1 203.4 137.1 203.4 140.9 173.7 140.9 173.7 97.6",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_2Ax2_2104","data-name":"2Ax2_2104",points:"134.4 97.6 173.7 97.6 173.7 140.9 168.4 140.9 168.4 137.2 164.2 137.2 164.2 141 134.4 141 134.4 97.6",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_2B1_2106","data-name":"2B1_2106",points:"94.6 151.5 106.5 151.5 106.5 156.2 116 156.2 116 198.6 72.6 198.6 72.6 156.7 94.5 156.7 94.6 151.5",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"_2Ax2_2107","data-name":"2Ax2_2107",x:"72.6",y:"198.6",width:"43.4",height:"39.27",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_2A1_2108","data-name":"2A1_2108",points:"116 277.3 72.7 277.3 72.7 237.9 116 237.9 116 277.3",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"_2A2_2109","data-name":"2A2_2109",x:"72.7",y:"277.3",width:"43.3",height:"39.92",fill:"#231f20"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{xmlns:"http://www.w3.org/2000/svg",id:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"cn",className:shouldDisplayByLang("cn")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(265.3 148.4)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2101"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(225.8 148.4)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2102"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(185.7 148.4)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2103"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(148.5 148.4)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2104"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(114.2 148.4)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2105"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(118.9 179.4)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2106",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{"font-size":"5.39",fill:"#a7a9ac","font-family":"STHeitiTC-Medium, STHeitiTC Medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{x:"0",y:"6.5"},"\u65E0\u969C\u788D\u8BBE\u65BD"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(118.9 223.6)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2107"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(118.9 301.9)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2109"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(118.9 262.3)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2108"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(182.4 213.2)","font-size":"10",fill:"#58595b","font-family":"Termina-Bold, Termina Bold"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{"font-weight":"700"},"1"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{x:"5.1",y:"0","font-family":"STHeitiTC-Medium, STHeitiTC Medium"},"\u697C"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"ru",className:shouldDisplayByLang("ru")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(265.3 148.4)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2101"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(225.8 148.4)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2102"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(185.7 148.4)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2103"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(148.5 148.4)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2104"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(114.2 148.4)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2105"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(118.9 179.4)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2106",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{"font-size":"5"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{x:"0",y:"4"},"\u0434\u043B\u044F \u043B\u044E\u0434\u0435\u0439 \u0441"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{x:"0",y:"8"},"\u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u043D\u044B\u043C\u0438"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{x:"0",y:"12"},"\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u044F\u043C\u0438"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(118.9 223.6)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2107"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(118.9 301.9)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2109"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(118.9 262.3)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2108"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(174.6 213.2)","font-size":"11",fill:"#58595b","font-family":"Helvetica-Bold, Helvetica","font-weight":"700"},"1-\u0419 \u042D\u0422\u0410\u0416")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"en",className:shouldDisplayByLang("en")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(265.3 148.6)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2101"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(225.8 148.6)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2102"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(185.7 148.6)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2103"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(148.5 148.6)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2104"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(114.2 148.6)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2105"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(118.9 179.5)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2106",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{x:"0",y:"7.1"},"Handicap")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(118.9 223.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2107"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(118.9 302)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2109"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(172.1 213.3)","font-size":"10",fill:"#58595b","font-family":"Termina-Bold, Termina Bold","font-weight":"700"},"1st Floor"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(118.9 262.4)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2108"))));});

/***/ }),
/* 958 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1.dded6043.png";

/***/ }),
/* 959 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__2_png__ = __webpack_require__(960);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__2_png__);
// import _ from 'lodash'
// import MultiLineText from './MultiLineText';
/* unused harmony default export */ var _unused_webpack_default_export = (function(_ref){var currentLang=_ref.currentLang,selectedType=_ref.selectedType;var shouldDisplayByLang=function shouldDisplayByLang(selectLang){return currentLang===selectLang?"display":"display-none";};var shouldDisplayByType=function shouldDisplayByType(type){return selectedType===type||selectedType==="all"?"opacity-in":"opacity-out";};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 329.4 363.4",className:"site-plan-svg"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"map"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("image",{xlinkHref:__WEBPACK_IMPORTED_MODULE_1__2_png___default.a,height:"100%",width:"100%"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"floorplan"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"studio",className:shouldDisplayByType("studio")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1A_2223","data-name":"1A_2223",points:"224.3 63.3 239.1 63.3 239.1 90.5 213.6 90.5 213.6 68.6 224.3 68.6 224.3 63.3",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1A_2222","data-name":"1A_2222",points:"198.2 63.4 212.8 63.4 212.8 90.5 187.3 90.5 187.3 68.6 198.2 68.6 198.2 63.4",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1A_2207","data-name":"1A_2207",points:"108.2 97.7 134.4 97.7 134.4 119.6 122.9 119.6 122.9 124.8 108.1 124.8 108.2 97.7",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1A_2208","data-name":"1A_2208",points:"72.5 133.9 94.6 133.9 94.6 144.6 99.8 144.6 99.8 159.4 72.6 159.4 72.5 133.9",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1A_2215","data-name":"1A_2215",points:"38.3 238 65.5 238 65.5 263.7 43.6 263.7 43.6 252.7 38.3 252.7 38.3 238",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1A_2216","data-name":"1A_2216",points:"38.3 226.5 38.3 211.8 65.5 211.8 65.5 238 43.6 237.8 43.6 226.5 38.3 226.5",fill:"#231f20"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"one-bedroom",className:shouldDisplayByType("one-bedroom")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1Bx_2201","data-name":"1Bx_2201",points:"265.3 97.7 291.5 97.7 291.5 124.9 280.3 124.9 280.3 129.1 265.3 129.1 265.3 97.7",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"_1C_2202","data-name":"1C_2202",x:"239.1",y:"97.7",width:"26.2",height:"31.79",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"_1B_2203","data-name":"1B_2203",x:"212.9",y:"97.5",width:"26",height:"27.32",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1Bx_2204","data-name":"1Bx_2204",points:"186.7 97.7 212.9 97.7 212.9 124.8 201.7 124.8 201.7 129 186.7 129 186.7 97.7",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"_1C_2205","data-name":"1C_2205",x:"160.5",y:"97.7",width:"26.1",height:"31.9",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"_1B_2206","data-name":"1B_2206",x:"134.4",y:"97.7",width:"26.2",height:"27.14",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"_1B_2209","data-name":"1B_2209",x:"72.6",y:"159.4",width:"27.1",height:"26.21",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1Bx_2210","data-name":"1Bx_2210",points:"104.1 196.8 104.1 211.9 72.6 211.9 72.6 185.6 99.8 185.6 99.8 196.8 104.1 196.8",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"_1C_2211","data-name":"1C_2211",x:"72.6",y:"211.9",width:"31.9",height:"26.11",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"_1B_2212","data-name":"1B_2212",x:"72.6",y:"238",width:"27.1",height:"26.18",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1Bx_2213","data-name":"1Bx_2213",points:"104.1 275.3 104.1 290.4 72.6 290.4 72.6 264.1 99.8 264.1 99.8 275.3 104.1 275.3",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"_1C_2214","data-name":"1C_2214",x:"72.6",y:"290.4",width:"31.9",height:"26.18",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1D_2219","data-name":"1D_2219",points:"80.4 71.9 92.2 60.1 96 63.9 107.4 63.9 107.4 90.5 100.2 90.5 92.7 98 77.2 82.5 84.1 75.6 80.4 71.9",fill:"#231f20"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"two-bedroom",className:shouldDisplayByType("two-bedroom")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_2Ax2_2221","data-name":"2Ax2_2221",points:"159.8 63.4 186.7 63.4 186.7 90.5 147.9 90.5 147.9 68.6 159.8 68.6 159.8 63.4",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_2Ax2_2220","data-name":"2Ax2_2220",points:"108.1 63.4 135.1 63.4 135.1 68.6 147 68.6 147 90.5 108.2 90.5 108.1 63.4",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_2A2_2218","data-name":"2A2_2218",points:"38.4 133.2 65.5 133.2 65.5 172.3 43.6 172.3 43.6 146.4 38.3 146.4 38.4 133.2",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_2Ax2_2217","data-name":"2Ax2_2217",points:"38.3 184.9 43.6 184.9 43.6 172.3 65.5 172.3 65.5 211.8 38.3 211.8 38.3 184.9",fill:"#231f20"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{xmlns:"http://www.w3.org/2000/svg",id:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"cn",className:shouldDisplayByLang("cn")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(272.8 138)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2201"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(246 138)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2202"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(220 138)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2203"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(193.5 138)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2204"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(167.4 138)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2205"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(141.5 138)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2206"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(116.2 133.2)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2207"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(104.5 148.1)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2208"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(110 174.1)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2209"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(110 200.4)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2210"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(110 225.9)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2211"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(110 251.9)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2212"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(110 278.3)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2213"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(110 304.9)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2214"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(73.4 60.1)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2219"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(122.1 55.9)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2220"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(161.3 55.9)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2221"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(194 55.9)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2222"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(219.1 55.9)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2223"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(14 154.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2218"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(14 192.9)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2217"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(14 225.6)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2216"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(14 252.2)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2215"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(193.9 211.2)","font-size":"10",fill:"#58595b","font-family":"Termina-Bold, Termina Bold"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{"font-weight":"700"},"2"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{x:"5.1",y:"0","font-family":"STHeitiTC-Medium, STHeitiTC Medium"},"\u697C"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"ru",className:shouldDisplayByLang("ru")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(272.8 138)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2201"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(246 138)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2202"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(220 138)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2203"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(193.5 138)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2204"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(167.4 138)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2205"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(141.5 138)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2206"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(116.2 133.2)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2207"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(104.5 148.1)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2208"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(110 174.1)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2209"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(110 200.4)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2210"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(110 225.9)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2211"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(110 251.9)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2212"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(110 278.3)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2213"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(110 304.9)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2214"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(73.4 60.1)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2219"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(122.1 55.9)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2220"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(161.3 55.9)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2221"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(194 55.9)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2222"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(219.1 55.9)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2223"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(14 154.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2218"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(14 192.9)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2217"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(14 225.6)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2216"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(14 252.2)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2215"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(186 211.2)","font-size":"11",fill:"#58595b","font-family":"Helvetica-Bold, Helvetica","font-weight":"700"},"2-\u0419 \u042D\u0422\u0410\u0416")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"en",className:shouldDisplayByLang("en")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(272.8 138)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2201"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(246 138)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2202"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(220 138)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2203"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(193.5 138)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2204"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(167.4 138)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2205"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(141.5 138)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2206"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(116.2 133.2)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2207"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(104.5 148)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2208"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(110 174.1)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2209"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(110 200.4)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2210"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(110 225.9)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2211"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(110 251.9)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2212"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(110 278.2)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2213"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(110 304.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2214"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(73.4 60.1)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2219"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(122.1 55.9)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2220"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(161.3 55.9)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2221"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(194 55.9)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2222"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(219.1 55.9)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2223"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(14 154.7)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2218"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(14 192.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2217"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(14 225.6)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2216"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(14 252.2)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2215"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(181.6 211.2)","font-size":"10",fill:"#58595b","font-family":"Termina-Bold, Termina Bold","font-weight":"700"},"2nd Floor"))));});

/***/ }),
/* 960 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/2.cfd380f7.png";

/***/ }),
/* 961 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__3_png__ = __webpack_require__(962);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__3_png__);
// import _ from 'lodash'
// import MultiLineText from './MultiLineText';
/* unused harmony default export */ var _unused_webpack_default_export = (function(_ref){var currentLang=_ref.currentLang,selectedType=_ref.selectedType;var shouldDisplayByLang=function shouldDisplayByLang(selectLang){return currentLang===selectLang?"display":"display-none";};var shouldDisplayByType=function shouldDisplayByType(type){return selectedType===type||selectedType==="all"?"opacity-in":"opacity-out";};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 329.4 363.4",className:"site-plan-svg"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"map"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("image",{xlinkHref:__WEBPACK_IMPORTED_MODULE_1__3_png___default.a,height:"100%",width:"100%"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"floorplan"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"studio",className:shouldDisplayByType("studio")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1A_2324","data-name":"1A_2324",points:"227.7 63.3 227.7 68.6 238.5 68.6 238.5 90.4 213 90.4 213 63.3 227.7 63.3",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1A_2301","data-name":"1A_2301",points:"291.5 97.6 291.5 124.8 276.7 124.8 276.7 119.5 265.5 119.5 265.5 97.6 291.5 97.6",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1A_2304","data-name":"1A_2304",points:"198.2 124.8 198.2 119.6 187.4 119.6 187.4 97.6 213 97.6 213 124.9 198.2 124.8",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1A_2307","data-name":"1A_2307",points:"109 97.6 134.4 97.6 134.4 124.7 119.6 124.7 119.6 119.5 108.9 119.5 109 97.6",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1A_2308","data-name":"1A_2308",points:"99.8 133.2 99.8 147.9 94.6 147.9 94.6 159.4 72.7 159.4 72.7 133.2 99.8 133.2",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1A_2310","data-name":"1A_2310",points:"72.7 185.5 99.7 185.5 99.7 200.3 94.6 200.3 94.6 211.8 72.7 211.8 72.7 185.5",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1A_2313","data-name":"1A_2313",points:"72.7 264.1 99.9 264.1 99.9 279 94.5 279 94.5 290.3 72.7 290.3 72.7 264.1",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1A_2315","data-name":"1A_2315",points:"43.7 237.8 65.5 237.8 65.5 264.8 38.4 264.8 38.4 249.3 43.6 249.3 43.7 237.8",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1A_2316","data-name":"1A_2316",points:"38.4 223.2 43.4 223.2 43.4 211.7 65.5 211.7 65.5 237.8 38.4 237.8 38.4 223.2",fill:"#231f20"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"one-bedroom",className:shouldDisplayByType("one-bedroom")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1Cx_2302","data-name":"1Cx_2302",points:"239.1 97.6 265.3 97.6 265.3 133.9 250.3 133.9 250.3 129.5 239.1 129.5 239.1 97.6",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1B_2303","data-name":"1B_2303",points:"213 97.6 239.1 97.6 239.1 124.9 212.9 124.9 213 97.6",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1Cx_2305","data-name":"1Cx_2305",points:"160.6 97.6 186.7 97.6 186.7 133.8 171.8 133.8 171.8 129.5 160.6 129.5 160.6 97.6",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"_1B_2306","data-name":"1B_2306",x:"134.4",y:"97.6",width:"26.2",height:"27.2",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1B_2309","data-name":"1B_2309",points:"99.8 159.3 99.8 185 72.7 185 72.7 159.5 99.8 159.3",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1Cx_2311","data-name":"1Cx_2311",points:"108.9 211.7 108.9 226.8 104.6 226.8 104.6 238 72.7 238 72.7 211.9 108.9 211.7",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1B_2312","data-name":"1B_2312",points:"99.9 263.4 72.6 263.4 72.6 238 99.8 238 99.9 263.4",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1Cx_2314","data-name":"1Cx_2314",points:"108.9 290.3 108.9 305.3 104.5 305.3 104.5 316.5 73.1 316.5 73.1 290.5 108.9 290.3",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1D_2319","data-name":"1D_2319",points:"35.2 117.2 46.9 105.4 50.6 109.1 57.6 102.2 73 117.7 65.2 125.5 65.2 132.4 38.8 132.4 38.8 121.1 35.2 117.2",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_2302","data-name":"2302",points:"80.5 71.9 92.2 60.1 96 63.8 107.4 63.8 107.4 90 100.3 90 92.5 97.8 77.2 82.5 84.1 75.6 80.5 71.9",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"_1B_2323","data-name":"1B_2323",x:"187.3",y:"63.3",width:"25.2",height:"27.14",fill:"#231f20"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"two-bedroom",className:shouldDisplayByType("two-bedroom")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_2B1_2318","data-name":"2B1_2318",points:"38.4 133.9 65.5 133.9 65.5 172 38.4 172 38.4 133.9",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_2A2_2317","data-name":"2A2_2317",points:"65.3 211.7 38.4 211.7 38.4 198.5 43.6 198.5 43.6 173 65.4 173 65.3 211.7",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_2A2_2321","data-name":"2A2_2321",points:"121.5 63.3 121.5 68.5 147.1 68.5 147.1 90.5 108.9 90.5 108.2 90.5 108.2 63.3 121.5 63.3",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"_2B1_2322","data-name":"2B1_2322",x:"148",y:"63.3",width:"38.3",height:"26.66",fill:"#231f20"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{xmlns:"http://www.w3.org/2000/svg",id:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"cn",className:shouldDisplayByLang("cn")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(272.7 139.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2301"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(247.1 139.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2302"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(221.9 139.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2303"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(194.2 139.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2304"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(168 139.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2305"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(141.7 139.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2306"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(116.6 135.1)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2307"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(104.9 149.9)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2308"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(110.4 175.9)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2309"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(110.4 202.3)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2310"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(110.4 227.7)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2311"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(110.4 253.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2312"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(110.4 280.1)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2313"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(110.4 306.7)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2314"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(73.7 62)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2320"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(28.8 103.6)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2319"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(122.4 49.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2321"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(161.6 49.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2322"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(194.4 49.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2323"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(219.5 49.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2324"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(19 156.6)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2318"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(19 194.7)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2317"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(19 227.5)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2316"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(19 254.1)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2315"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(181.7 219.3)","font-size":"10",fill:"#58595b","font-family":"Termina-Bold, Termina Bold"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{"font-weight":"700"},"3"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{x:"5.1",y:"0","font-family":"STHeitiTC-Medium, STHeitiTC Medium"},"\u697C"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"ru",className:shouldDisplayByLang("ru")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(272.6 139.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2301"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(247 139.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2302"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(221.8 139.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2303"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(194.1 139.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2304"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(167.9 139.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2305"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(141.6 139.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2306"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(116.5 135.1)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2307"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(104.8 149.9)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2308"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(110.3 175.9)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2309"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(110.3 202.3)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2310"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(110.3 227.7)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2311"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(110.3 253.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2312"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(110.3 280.1)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2313"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(110.3 306.7)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2314"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(73.7 62)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2320"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(28.7 103.6)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2319"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(122.4 49.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2321"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(161.6 49.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2322"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(194.3 49.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2323"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(219.4 49.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2324"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(19 156.6)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2318"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(19 194.7)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2317"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(19 227.5)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2316"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(19 254.1)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2315"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(173.8 219.3)","font-size":"11",fill:"#58595b","font-family":"Helvetica-Bold, Helvetica","font-weight":"700"},"3-\u0419 \u042D\u0422\u0410\u0416")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"en",className:shouldDisplayByLang("en")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(272.7 140)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2301"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(247.1 140)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2302"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(221.9 140)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2303"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(194.2 140)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2304"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(168 140)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2305"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(141.7 140)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2306"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(116.6 135.2)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2307"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(104.9 150.1)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2308"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(110.4 176.1)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2309"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(110.4 202.4)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2310"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(110.4 227.9)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2311"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(110.4 253.9)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2312"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(110.4 280.3)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2313"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(110.4 306.9)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2314"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(73.7 62.1)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2320"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(28.8 103.7)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2319"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(122.4 50)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2321"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(161.6 50)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2322"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(194.4 50)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2323"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(219.5 50)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2324"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(19 156.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2318"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(19 194.9)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2317"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(19 227.6)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2316"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(19 254.2)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2315"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(170.6 219.4)","font-size":"10",fill:"#58595b","font-family":"Termina-Bold, Termina Bold","font-weight":"700"},"3rd Floor"))));});

/***/ }),
/* 962 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/3.c56777cf.png";

/***/ }),
/* 963 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__4_png__ = __webpack_require__(964);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__4_png__);
// import _ from 'lodash'
// import MultiLineText from './MultiLineText';
/* unused harmony default export */ var _unused_webpack_default_export = (function(_ref){var currentLang=_ref.currentLang,selectedType=_ref.selectedType;var shouldDisplayByLang=function shouldDisplayByLang(selectLang){return currentLang===selectLang?"display":"display-none";};var shouldDisplayByType=function shouldDisplayByType(type){return selectedType===type||selectedType==="all"?"opacity-in":"opacity-out";};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 329.4 363.4",className:"site-plan-svg"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"map"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("image",{xlinkHref:__WEBPACK_IMPORTED_MODULE_1__4_png___default.a,height:"100%",width:"100%"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"floorplan"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"studio",className:shouldDisplayByType("studio")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1A2401","data-name":"1A2401",points:"265.3 97.7 291.5 97.7 291.5 119.6 280.1 119.6 280.1 124.8 265.4 124.8 265.3 97.7",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1A_2404","data-name":"1A_2404",points:"201.6 119.5 201.6 124.8 186.7 124.8 186.7 97.7 212.9 97.7 212.9 119.6 201.6 119.5",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1A_2407","data-name":"1A_2407",points:"108.1 97.7 134.3 97.7 134.3 119.5 122.8 119.5 122.8 124.8 108.3 124.8 108.1 97.7",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1A_2408","data-name":"1A_2408",points:"73.1 133.9 94.6 133.9 94.6 144.5 99.8 144.5 99.8 158.9 72.6 158.9 72.6 134 73.1 133.9",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1A_2410","data-name":"1A_2410",points:"99.8 197 99.8 211.6 72.6 211.6 72.6 185.6 94.5 185.6 94.5 197 99.8 197",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1A_2413","data-name":"1A_2413",points:"99.9 275.5 99.9 290.1 73.1 290.1 73.1 264.1 94.6 264.1 94.6 275.6 99.9 275.5",fill:"#231f20"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"one-bedroom",className:shouldDisplayByType("one-bedroom")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1Cx_2402","data-name":"1Cx_2402",points:"239.1 97.7 265.3 97.7 265.3 129.6 254.1 129.6 254.1 133.7 239.1 133.7 239.1 97.7",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1C_2403","data-name":"1C_2403",points:"213.7 97.7 239.1 97.7 239.1 129.6 212.9 129.6 212.9 97.7 213.7 97.7",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1Cx_2405","data-name":"1Cx_2405",points:"160.5 97.7 186.7 97.7 186.7 129.6 175.5 129.6 175.5 133.7 160.5 133.7 160.5 97.7",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1C_2406","data-name":"1C_2406",points:"134.3 97.7 160.5 97.7 160.5 129.6 134.3 129.6 134.3 97.7",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"_1C_2409","data-name":"1C_2409",x:"72.6",y:"159.4",width:"31.9",height:"26.24",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1Cx_2411","data-name":"1Cx_2411",points:"72.6 211.7 104.5 211.7 104.5 223 108.8 223 108.8 238 72.6 238 72.6 211.7",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1C_2412","data-name":"1C_2412",points:"104.5 264.2 72.6 264.1 72.6 238 104.4 238 104.5 264.2",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1Cx_2414","data-name":"1Cx_2414",points:"104.5 290.4 104.5 301.5 108.9 301.5 108.9 316.6 73.1 316.6 73.1 290.5 104.5 290.4",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"_1B_2415","data-name":"1B_2415",x:"38.3",y:"238.4",width:"26.7",height:"25.55",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1Bx_2416","data-name":"1Bx_2416",points:"34 211.7 65.1 211.7 65.1 237.8 38.3 237.8 38.3 226.8 34 226.8 34 211.7",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1D_2419","data-name":"1D_2419",points:"35.3 117.2 47 105.4 50.7 109.1 57.8 101.9 73.3 117.4 65.5 125.3 65.5 132.5 38.8 132.5 38.8 121 35.3 117.2",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1D_2420","data-name":"1D_2420",points:"80.4 71.9 92.2 60.1 95.9 63.8 107.5 63.8 107.5 90.1 100.2 90.1 92.7 97.7 77.4 82.4 84.2 75.7 80.4 71.9",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1Bx_2423","data-name":"1Bx_2423",points:"187.5 63.3 197.9 63.3 197.9 59 212.9 59 212.9 90 187.4 90 187.5 63.3",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1B_2424","data-name":"1B_2424",points:"239.1 63.4 239.1 90.5 212.9 90.5 212.9 63.4 239.1 63.4",fill:"#231f20"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"two-bedroom",className:shouldDisplayByType("two-bedroom")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"_2B2_2422","data-name":"2B2_2422",x:"147.4",y:"63.4",width:"40",height:"26.96",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_2B1_2421","data-name":"2B1_2421",points:"108.7 63.4 147.4 63.4 147.4 90.3 108.1 90.3 108.1 63.4 108.7 63.4",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("path",{id:"_2Bx2_2418","data-name":"2Bx2_2418",d:"M33.6,133.2H65V172H38.3V160.1H33.7S33.1,133.2,33.6,133.2Z",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_2B1_2417","data-name":"2B1_2417",points:"38.3 180.7 38.3 172 65 172 65.1 211.7 38.2 211.7 38.3 180.7",fill:"#231f20"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"cn",className:shouldDisplayByLang("cn")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(272.7 141.7)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2401"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(247.3 141.7)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2402"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(221.2 141.7)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2403"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(194.9 141.7)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2404"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(169.1 141.7)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2405",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{fontSize:"5.39",fill:"#a7a9ac","font-family":"STHeitiTC-Medium, STHeitiTC Medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{x:"-6.9",y:"6.5"},"\u65E0\u969C\u788D\u8BBE\u65BD"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(143.1 141.7)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2406"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(116.8 133.4)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2407"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(105.1 149.6)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2408"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(110.6 175.7)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2409"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(110.6 202)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2410"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(110.6 227.5)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2411"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(110.6 253.5)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2412"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(110.6 279.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2413"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(110.6 306.4)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2414"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(73.1 65.2)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2420"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(29 105.4)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2419"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(121.8 53)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2421"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(161 53)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2422"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(193.8 53)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2423"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(218.8 53)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2424"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(12.6 156.2)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2418"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(12.6 194.3)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2417"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(12.6 227.1)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2416"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(12.6 253.7)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2415"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(193.7 219.6)","font-size":"10",fill:"#58595b","font-family":"Termina-Bold, Termina Bold"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{"font-weight":"700"},"4"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{x:"5.1",y:"0","font-family":"STHeitiTC-Medium, STHeitiTC Medium"},"\u697C"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"ru",className:shouldDisplayByLang("ru")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(272.8 141.6)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2401"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(247.3 141.6)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2402"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(221.3 141.6)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2403"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(195 141.6)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2404"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(169.2 141.6)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2405",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{fontSize:"5"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{x:"-2.2",y:"4"},"\u0434\u043B\u044F \u043B\u044E\u0434\u0435\u0439 \u0441"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{x:"-4.1",y:"8"},"\u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u043D\u044B\u043C\u0438"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{x:"-4.1",y:"12"},"\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u044F\u043C\u0438"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(143.2 141.6)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2406"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(116.8 133.4)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2407"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(105.2 149.6)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2408"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(110.7 175.6)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2409"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(110.7 202)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2410"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(110.7 227.4)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2411"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(110.7 253.5)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2412"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(110.7 279.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2413"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(110.7 306.4)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2414"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(73.2 65.2)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2420"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(29.1 105.4)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2419"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(121.9 53)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2421"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(161.1 53)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2422"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(193.8 53)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2423"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(218.9 53)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2424"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(12.7 156.2)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2418"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(12.7 194.3)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2417"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(12.7 227)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2416"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(12.7 253.6)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2415"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(185.9 219.6)","font-size":"11",fill:"#58595b","font-family":"Helvetica-Bold, Helvetica","font-weight":"700"},"4-\u0419 \u042D\u0422\u0410\u0416")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"en",className:shouldDisplayByLang("en")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(272.8 141.7)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2401"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(247.3 141.7)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2402"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(221.2 141.7)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2403"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(194.9 141.7)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2404"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(169.2 141.7)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2405",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{fontSize:"5"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{x:"-4",y:"6"},"Handicap"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(143.1 141.7)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2406"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(116.8 133.4)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2407"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(105.1 149.6)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2408"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(110.6 175.7)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2409"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(110.6 202)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2410"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(110.6 227.5)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2411"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(110.6 253.5)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2412"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(110.6 279.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2413"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(110.6 306.4)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2414"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(73.1 65.2)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2420"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(29 105.4)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2419"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(121.9 53)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2421"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(161.1 53)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2422"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(193.8 53)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2423"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(218.9 53)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2424"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(12.6 156.2)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2418"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(12.6 194.3)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2417"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(12.6 227.1)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2416"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(12.6 253.7)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2415"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(182.5 219.6)","font-size":"10",fill:"#58595b","font-family":"Termina-Bold, Termina Bold","font-weight":"700"},"4th Floor"))));});

/***/ }),
/* 964 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/4.2c0f5f1e.png";

/***/ }),
/* 965 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__5_png__ = __webpack_require__(966);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__5_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__5_png__);
// import _ from 'lodash'
// import MultiLineText from './MultiLineText';
/* unused harmony default export */ var _unused_webpack_default_export = (function(_ref){var currentLang=_ref.currentLang,selectedType=_ref.selectedType;var shouldDisplayByLang=function shouldDisplayByLang(selectLang){return currentLang===selectLang?"display":"display-none";};var shouldDisplayByType=function shouldDisplayByType(type){return selectedType===type||selectedType==="all"?"opacity-in":"opacity-out";};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 329.4 363.4",className:"site-plan-svg"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"map"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("image",{xlinkHref:__WEBPACK_IMPORTED_MODULE_1__5_png___default.a,height:"100%",width:"100%"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"floorplan"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"studio",className:shouldDisplayByType("studio")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1A_2501","data-name":"1A_2501",points:"292.2 97.8 292.2 124.8 276.7 124.8 276.7 119.6 265.5 119.6 265.5 97.7 292.2 97.8",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1A_2504","data-name":"1A_2504",points:"198.2 124.8 198.2 119.6 186.7 119.6 186.7 97.7 212.9 97.7 212.9 124.9 198.2 124.8",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1A_2507","data-name":"1A_2507",points:"107.4 97.7 134.4 97.7 134.4 124.7 119.6 124.7 119.6 119.6 107.4 119.6 107.4 97.7",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1A_2508","data-name":"1A_2508",points:"72.6 132.5 99.7 132.5 99.7 148 94.6 148 94.6 159.4 72.6 159.4 72.6 132.5",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1A_2510","data-name":"1A_2510",points:"99.8 200.4 94.6 200.4 94.6 211.8 72.6 211.8 72.6 185.6 99.9 185.6 99.8 200.4",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1A_2513","data-name":"1A_2513",points:"99.8 279.1 94.5 279.1 94.5 290.3 72.6 290.3 72.6 264.2 99.7 264.2 99.8 279.1",fill:"#231f20"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"one-bedroom",className:shouldDisplayByType("one-bedroom")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1Bx_2502","data-name":"1Bx_2502",points:"239.1 97.7 265.3 97.7 265.3 129.1 250.3 129.1 250.3 124.8 239.1 124.8 239.1 97.7",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1Cx_2503","data-name":"1Cx_2503",points:"212.9 97.7 239.1 97.7 239.1 133.9 224.1 133.9 224.1 129.6 212.9 129.6 212.9 97.7",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1Bx_2505","data-name":"1Bx_2505",points:"160.5 97.7 186.7 97.7 186.7 129.2 171.7 129.2 171.7 125.1 160.5 125.1 160.5 97.7",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1Cx_2506","data-name":"1Cx_2506",points:"134.4 97.7 160.4 97.7 160.4 133.9 145.5 133.9 145.5 129.8 134.4 129.8 134.4 97.7",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1Cx_2509","data-name":"1Cx_2509",points:"72.6 159.4 108.8 159.4 108.8 174.4 104.5 174.4 104.5 185.6 72.6 185.6 72.6 159.4",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1Bx_2511","data-name":"1Bx_2511",points:"72.6 211.8 104.1 211.8 104.1 226.8 99.8 226.8 99.8 238 72.6 238 72.6 211.8",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1Cx_2512","data-name":"1Cx_2512",points:"108.9 238 108.9 252.8 104.5 252.8 104.5 264.2 72.6 264.2 72.6 238 108.9 238",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1Bx_2514","data-name":"1Bx_2514",points:"104.1 290.3 104.1 305.4 100 305.4 100 317.3 72.6 317.3 72.6 290.4 104.1 290.3",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1Bx_2515","data-name":"1Bx_2515",points:"65 237.8 65 264.9 34.1 264.9 34.1 249.1 38.2 249.1 38.2 238 65 237.8",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1B_2516","data-name":"1B_2516",points:"38.3 212.3 65.5 212.3 65.5 237.8 37.9 237.8 37.9 212.1 38.3 212.3",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1D_2519","data-name":"1D_2519",points:"35.1 117.2 46.9 105.5 50.6 109.2 58.5 101.3 74 116.7 65.5 125.3 65.5 133.2 38.8 133.2 38.8 121 35.1 117.2",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1D_2520","data-name":"1D_2520",points:"80.4 72 92.2 60.2 95.9 63.9 108.1 63.9 108.1 90.4 100.2 90.5 92.5 98.1 77.2 82.7 84.1 75.8 80.4 72",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1C_2523","data-name":"1C_2523",points:"186.7 58.6 212.9 58.6 212.9 90.5 186.7 90.4 186.7 58.6",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"_1C_2524","data-name":"1C_2524",x:"212.9",y:"58.6",width:"26.2",height:"31.9",fill:"#231f20"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"two-bedroom",className:shouldDisplayByType("two-bedroom")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_2Bx1_2522","data-name":"2Bx1_2522",points:"147.4 58.6 174.3 58.6 174.3 63.4 186.6 63.4 186.6 90.5 147.4 90.5 147.4 58.6",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_2Bx2_2521","data-name":"2Bx2_2521",points:"108.1 58.6 135.1 58.6 135.1 63.4 147.4 63.4 147.4 90.5 108.1 90.5 108.1 58.6",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"_2B1_2518","data-name":"2B1_2518",x:"38.3",y:"133.2",width:"27.1",height:"39.29",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_2Bx2_2517","data-name":"2Bx2_2517",points:"33.6 184.9 38.3 184.9 38.3 172.5 65.5 172.5 65.5 212.3 33.6 212.3 33.6 184.9",fill:"#231f20"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{xmlns:"http://www.w3.org/2000/svg",id:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"cn",className:shouldDisplayByLang("cn")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(271.5 142.7)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2501"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(246 142.7)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2502"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(220 142.7)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2503"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(193.7 142.7)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2504"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(167.9 142.7)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2505"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(141.9 142.7)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2506"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(115.5 134.4)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2507"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(106 150.7)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2508"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(111.5 176.7)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2509"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(111.5 203)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2510"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(111.5 228.5)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2511"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(111.5 254.6)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2512"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(111.5 280.9)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2513"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(111.5 307.5)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2514"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(69.8 66.3)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2520"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(27.8 106.4)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2519"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(120.6 49.9)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2521"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(159.8 49.9)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2522"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(193.8 49.9)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2523"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(219.7 49.9)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2524"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(11.4 157.3)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2518"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(11.4 195.3)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2517"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(11.4 228.1)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2516"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(11.4 254.7)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2515"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(182.9 217.7)","font-size":"10",fill:"#58595b","font-family":"Termina-Bold, Termina Bold"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{"font-weight":"700"},"5"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{x:"5.1",y:"0","font-family":"STHeitiTC-Medium, STHeitiTC Medium"},"\u697C"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"ru",className:shouldDisplayByLang("ru")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(271.4 142.7)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2501"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(245.9 142.7)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2502"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(219.9 142.7)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2503"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(193.6 142.7)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2504"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(167.8 142.7)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2505"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(141.8 142.7)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2506"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(115.5 134.4)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2507"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(105.9 150.7)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2508"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(111.4 176.7)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2509"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(111.4 203)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2510"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(111.4 228.5)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2511"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(111.4 254.6)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2512"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(111.4 280.9)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2513"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(111.4 307.5)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2514"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(69.7 66.3)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2520"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(27.7 106.4)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2519"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(120.5 49.9)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2521"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(159.7 49.9)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2522"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(193.7 49.9)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2523"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(219.6 49.9)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2524"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(11.3 157.3)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2518"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(11.3 195.3)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2517"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(11.3 228.1)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2516"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(11.3 254.7)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2515"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(175 217.7)","font-size":"11",fill:"#58595b","font-family":"Helvetica-Bold, Helvetica","font-weight":"700"},"5-\u0419 \u042D\u0422\u0410\u0416")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"en",className:shouldDisplayByLang("en")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(271.5 142.7)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2501"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(246 142.7)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2502"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(220 142.7)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2503"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(193.6 142.7)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2504"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(167.9 142.7)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2505"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(141.8 142.7)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2506"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(115.5 134.4)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2507"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(106 150.6)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2508"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(111.5 176.7)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2509"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(111.5 203)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2510"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(111.5 228.5)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2511"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(111.5 254.5)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2512"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(111.5 280.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2513"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(111.5 307.4)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2514"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(69.7 66.2)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2520"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(27.7 106.4)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2519"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(120.6 49.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2521"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(159.8 49.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2522"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(193.8 49.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2523"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(219.7 49.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2524"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(11.4 157.2)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2518"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(11.4 195.3)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2517"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(11.4 228.1)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2516"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(11.4 254.7)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2515"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(171.7 217.6)","font-size":"10",fill:"#58595b","font-family":"Termina-Bold, Termina Bold","font-weight":"700"},"5th Floot"))));});

/***/ }),
/* 966 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/5.a245aae8.png";

/***/ }),
/* 967 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__6_png__ = __webpack_require__(968);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__6_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__6_png__);
// import _ from 'lodash'
// import MultiLineText from './MultiLineText';
/* unused harmony default export */ var _unused_webpack_default_export = (function(_ref){var currentLang=_ref.currentLang,selectedType=_ref.selectedType;var shouldDisplayByLang=function shouldDisplayByLang(selectLang){return currentLang===selectLang?"display":"display-none";};var shouldDisplayByType=function shouldDisplayByType(type){return selectedType===type||selectedType==="all"?"opacity-in":"opacity-out";};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 329.4 363.4",className:"site-plan-svg"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"map"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("image",{xlinkHref:__WEBPACK_IMPORTED_MODULE_1__6_png___default.a,height:"100%",width:"100%"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"floorplan"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"studio",className:shouldDisplayByType("studio")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1A_2605","data-name":"1A_2605",points:"108.1 97.7 133.9 97.7 133.9 119.6 122.9 119.6 122.9 124.6 108.2 124.6 108.1 97.7",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1A_2606","data-name":"1A_2606",points:"94.5 133.9 94.5 144.6 99.8 144.6 99.8 159.3 72.6 159.3 72.6 133.9 94.5 133.9",fill:"#231f20"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"one-bedroom",className:shouldDisplayByType("one-bedroom")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1Cx_2620","data-name":"1Cx_2620",points:"212.9 58.6 224.2 58.6 224.2 54.3 239.1 54.3 239.1 90.5 212.9 90.5 212.9 58.6",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1Cx_2619","data-name":"1Cx_2619",points:"186.7 58.6 197.9 58.6 197.9 54.5 212.9 54.5 212.9 90.5 186.7 90.5 186.7 58.6",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1D_2616","data-name":"1D_2616",points:"76.9 82.9 84.1 75.7 80.4 72 92.1 60.3 95.8 64 107.5 64 107.5 90.5 100.2 90.5 92.4 98.4 76.9 82.9",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1D_2615","data-name":"1D_2615",points:"35.1 117.2 46.9 105.5 50.6 109.2 57.5 102.3 73 117.8 65.4 125.4 65.4 132.5 38.8 132.5 38.8 121.2 35.1 117.2",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1Cx_2612","data-name":"1Cx_2612",points:"29.3 211.8 65.3 211.8 65.3 238 33.6 238 33.6 226.7 29.3 226.7 29.3 211.8",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1C_2611","data-name":"1C_2611",points:"65.4 264.8 33.6 264.8 33.6 238 65.3 238 65.4 264.8",fill:"#231f20"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"two-bedroom",className:shouldDisplayByType("two-bedroom")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_2Bx2_2601","data-name":"2Bx2_2601",points:"252.2 97.7 291.5 97.7 291.5 129.7 264.6 129.7 264.6 124.8 252.2 124.8 252.2 97.7",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_2Cx1_2602","data-name":"2Cx1_2602",points:"213.5 97.7 252.2 97.7 252.2 134.4 225.3 134.4 225.3 129.6 213.5 129.6 213.5 97.7",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_2Bx2_2603","data-name":"2Bx2_2603",points:"174.2 97.7 213.5 97.7 213.5 129.6 186.1 129.6 186.1 124.8 174.2 124.8 174.2 97.7",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"_2C1_2604","data-name":"2C1_2604",x:"135.1",y:"97.7",width:"39.1",height:"31.9",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_2Bx2_2607","data-name":"2Bx2_2607",points:"72.6 159.4 104.5 159.4 104.5 186.4 99.8 186.4 99.8 198.7 72.6 198.7 72.6 159.4",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"_2C1_2608","data-name":"2C1_2608",x:"72.6",y:"198.7",width:"31.9",height:"38.58",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_2Cx2_2609","data-name":"2Cx2_2609",points:"109.3 238 109.3 264.9 104.5 264.9 104.5 276.8 72.6 276.8 72.6 238 109.3 238",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_2Bx1_2610","data-name":"2Bx1_2610",points:"99.8 316.6 72.6 316.6 72.6 276.8 104.5 276.8 104.5 304.2 99.8 304.2 99.8 316.6",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_2C1_2613","data-name":"2C1_2613",points:"33.6 172 65.6 172 65.6 211.8 33.5 211.8 33.6 172",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_2Cx2_2614","data-name":"2Cx2_2614",points:"28.8 133.2 65.6 133.2 65.6 172 33.6 172 33.6 160.1 28.8 160.1 28.8 133.2",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_2Cx1_2617","data-name":"2Cx1_2617",points:"108.1 58.6 120.5 58.6 120.5 53.9 147.4 53.9 147.4 90.5 108.1 90.5 108.1 58.6",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_2C2_2618","data-name":"2C2_2618",points:"159.7 58.6 186.7 58.6 186.7 90.5 147.4 90.5 147.4 58.6 159.7 58.6",fill:"#231f20"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{xmlns:"http://www.w3.org/2000/svg",id:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"cn",className:shouldDisplayByLang("cn")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(266.9 141.5)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2601"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(227.1 141.5)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2602"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(190.3 141.5)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2603"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(147.8 141.5)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2604"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(116.8 133.2)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2605"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(107.3 149.4)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2606"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(112.8 175.5)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2607"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(112.8 217.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2608"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(112.8 258.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2609"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(112.8 299.1)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2610"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(71 65)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2616"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(29 105.2)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2615"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(121.9 48.6)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2617"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(161.1 48.6)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2618"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(195.1 48.6)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2619"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(221 48.6)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2620"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(12.7 156)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2614"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(12.7 194.1)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2613"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(12.7 226.9)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2612"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(12.7 253.5)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2611"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(194.2 217.5)","font-size":"10",fill:"#58595b","font-family":"Termina-Bold, Termina Bold"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{"font-weight":"700"},"6"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{x:"5.1",y:"0","font-family":"STHeitiTC-Medium, STHeitiTC Medium"},"\u697C"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"ru",className:shouldDisplayByLang("ru")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(266.9 141.5)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2601"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(227.1 141.5)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2602"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(190.3 141.5)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2603"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(147.7 141.5)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2604"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(116.8 133.2)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2605"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(107.2 149.5)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2606"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(112.7 175.5)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2607"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(112.7 217.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2608"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(112.7 258.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2609"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(112.7 299.1)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2610"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(71 65.1)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2616"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(29 105.2)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2615"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(121.8 48.7)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2617"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(161 48.7)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2618"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(195 48.7)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2619"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(220.9 48.7)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2620"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(12.6 156.1)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2614"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(12.6 194.1)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2613"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(12.6 226.9)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2612"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(12.6 253.5)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2611"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(186.4 217.5)","font-size":"11",fill:"#58595b","font-family":"Helvetica-Bold, Helvetica","font-weight":"700"},"6-\u0419 \u042D\u0422\u0410\u0416")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"en",className:shouldDisplayByLang("en")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(266.9 141.5)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2601"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(227.1 141.5)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2602"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(190.3 141.5)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2603"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(147.7 141.5)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2604"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(116.8 133.2)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2605"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(107.2 149.5)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2606"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(112.7 175.5)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2607"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(112.7 217.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2608"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(112.7 258.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2609"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(112.7 299.1)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2610"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(71 65.1)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2616"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(29 105.2)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2615"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(121.8 48.7)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2617"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(161 48.7)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2618"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(195.1 48.7)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2619"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(221 48.7)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2620"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(12.6 156.1)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2614"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(12.6 194.1)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2613"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(12.6 226.9)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2612"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(12.6 253.5)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2611"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(183.1 217.5)","font-size":"10",fill:"#58595b","font-family":"Termina-Bold, Termina Bold","font-weight":"700"},"6th Floor"))));});

/***/ }),
/* 968 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/6.e7c34759.png";

/***/ }),
/* 969 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__7_png__ = __webpack_require__(970);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__7_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__7_png__);
// import _ from 'lodash'
// import MultiLineText from './MultiLineText';
/* unused harmony default export */ var _unused_webpack_default_export = (function(_ref){var currentLang=_ref.currentLang,selectedType=_ref.selectedType;var shouldDisplayByLang=function shouldDisplayByLang(selectLang){return currentLang===selectLang?"display":"display-none";};var shouldDisplayByType=function shouldDisplayByType(type){return selectedType===type||selectedType==="all"?"opacity-in":"opacity-out";};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 329.4 363.4",className:"site-plan-svg"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"map"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("image",{xlinkHref:__WEBPACK_IMPORTED_MODULE_1__7_png___default.a,height:"100%",width:"100%"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{xmlns:"http://www.w3.org/2000/svg",id:"floorplan"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"studio",className:shouldDisplayByType("studio")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1A_2706","data-name":"1A_2706",points:"72.6 133.2 99.7 133.2 99.7 148 94.5 148 94.5 159.4 72.6 159.4 72.6 133.2",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1A_2705","data-name":"1A_2705",points:"109 97.7 133.6 97.7 133.6 124.7 119.5 124.7 119.5 119.6 108.8 119.6 109 97.7",fill:"#231f20"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"one-bedroom",className:shouldDisplayByType("one-bedroom")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1Cx_2718","data-name":"1Cx_2718",points:"212.9 54 227.9 54 227.9 58.4 239.2 58.4 239.2 90.5 212.8 90.5 212.9 54",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1Cx_2717","data-name":"1Cx_2717",points:"186.7 54 201.6 54 201.6 58.5 212.7 58.5 212.7 90.5 186.7 90.5 186.7 54",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1Cx_2712","data-name":"1Cx_2712",points:"33.6 211.8 65.5 211.8 65.5 237.8 29.3 237.8 29.3 223.1 33.6 223.1 33.6 211.8",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_1Cx_2711","data-name":"1Cx_2711",points:"65.5 264.2 29.2 264.2 29.2 249.3 33.6 249.3 33.6 237.9 65.5 237.9 65.5 264.2",fill:"#231f20"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"two-bedroom",className:shouldDisplayByType("two-bedroom")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_2Ax2_2710","data-name":"2Ax2_2710",points:"72.5 277.8 94.5 277.8 94.5 289.6 99.7 289.6 99.7 317.3 72.6 317.3 72.5 277.8",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_2Bx1_2709","data-name":"2Bx1_2709",points:"72.6 238 99.8 238 99.8 250.4 104.5 250.4 104.5 277.8 72.5 277.8 72.6 238",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_2Cx2_2708","data-name":"2Cx2_2708",points:"72.6 198.7 104.5 198.7 104.6 211.1 109.3 211.1 109.3 238 72.6 238 72.6 198.7",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"_2B1_2707","data-name":"2B1_2707",x:"72.6",y:"159.4",width:"27.1",height:"39.13",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_2Cx2_2704","data-name":"2Cx2_2704",points:"134.4 97.7 173.1 97.7 173.1 129.6 161.2 129.6 161.2 134.4 133.8 134.4 133.8 97.7 134.4 97.7",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_2Bx1_2703","data-name":"2Bx1_2703",points:"212.9 97.7 213 124.6 200.5 124.6 200.5 129.6 173.1 129.6 173.1 97.7 212.9 97.7",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_2Bx2_2702","data-name":"2Bx2_2702",points:"252.2 97.7 252.2 124.8 239.8 124.8 239.8 129.6 212.9 129.6 212.9 97.7 252.2 97.7",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_2C1_2701","data-name":"2C1_2701",points:"291 97.7 290.8 129.6 252.2 129.6 252.2 97.7 291 97.7",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_2Cx1_2716","data-name":"2Cx1_2716",points:"147.4 53.9 174.3 53.9 174.3 58.6 186.6 58.6 186.6 90.5 147.4 90.5 147.4 53.9",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_2Bx2_2715","data-name":"2Bx2_2715",points:"108.3 58.5 135.1 58.5 135.1 63.4 147.3 63.4 147.3 90.5 108.1 90.5 108.3 58.5",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_2C1_2714","data-name":"2C1_2714",points:"33.6 133.9 65.5 133.9 65.5 172.5 33.6 172.5 33.6 133.9",fill:"#231f20"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_2Cx2_2713","data-name":"2Cx2_2713",points:"28.8 184.9 33.6 184.9 33.6 172.5 65.5 172.5 65.5 211.8 28.8 211.8 28.8 184.9",fill:"#231f20"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{xmlns:"http://www.w3.org/2000/svg",id:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"cn",className:shouldDisplayByLang("cn")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(266.7 141.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2701"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(227 141.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2702"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(188.9 141.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2703"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(147.6 141.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2704"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(118.3 133.5)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2705"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(105.3 149.7)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2706"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(114.3 175.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2707"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(114.3 218.1)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2708"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(114.3 259.1)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2709"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(114.3 299.4)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2710"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(123.4 48.9)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2715"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(162.6 48.9)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2716"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(194.1 48.9)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2717"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(220 48.9)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2718"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(14.2 156.3)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2714"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(14.2 194.4)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2713"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(14.2 227.2)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2712"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(14.2 253.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2711"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(189 214.9)","font-size":"10",fill:"#58595b","font-family":"Termina-Bold, Termina Bold"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{"font-weight":"700"},"7"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{x:"5.1",y:"0","font-family":"STHeitiTC-Medium, STHeitiTC Medium"},"\u697C"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"ru",className:shouldDisplayByLang("ru")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(266.7 141.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2701"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(227 141.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2702"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(188.9 141.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2703"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(147.6 141.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2704"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(118.3 133.5)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2705"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(105.3 149.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2706"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(114.3 175.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2707"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(114.3 218.1)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2708"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(114.3 259.1)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2709"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(114.3 299.4)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2710"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(123.4 49)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2715"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(162.6 49)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2716"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(194.1 49)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2717"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(220 49)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2718"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(14.2 156.3)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2714"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(14.2 194.4)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2713"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(14.2 227.2)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2712"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(14.2 253.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2711"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(181.2 214.9)","font-size":"11",fill:"#58595b","font-family":"Helvetica-Bold, Helvetica","font-weight":"700"},"7-\u0419 \u042D\u0422\u0410\u0416")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"en",className:shouldDisplayByLang("en")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(266.7 141.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2701"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(227 141.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2702"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(188.9 141.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2703"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(147.6 141.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2704"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(118.3 133.5)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2705"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(105.3 149.7)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2706"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(114.3 175.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2707"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(114.3 218.1)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2708"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(114.3 259.1)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2709"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(114.3 299.4)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2710"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(123.4 48.9)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2715"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(162.6 48.9)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2716"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(194.1 48.9)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2717"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(220 48.9)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2718"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(14.2 156.3)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2714"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(14.2 194.4)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2713"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(14.2 227.2)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2712"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(14.2 253.8)","font-size":"5.88",fill:"#808285","font-family":"Helvetica, Helvetica"},"2711"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(177.9 214.9)","font-size":"10",fill:"#58595b","font-family":"Termina-Bold, Termina Bold","font-weight":"700"},"7th Floor"))));});

/***/ }),
/* 970 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/7.1196bd2c.png";

/***/ }),
/* 971 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__8_png__ = __webpack_require__(972);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__8_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__8_png__);
// import _ from 'lodash'
// import MultiLineText from './MultiLineText';
/* unused harmony default export */ var _unused_webpack_default_export = (function(_ref){var currentLang=_ref.currentLang,selectedType=_ref.selectedType;var shouldDisplayByLang=function shouldDisplayByLang(selectLang){return currentLang===selectLang?"display":"display-none";};var shouldDisplayByType=function shouldDisplayByType(type){return selectedType===type||selectedType==="all"?"display":"display-none";};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 270.4 363.4",className:"site-plan-svg"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"map"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("image",{xlinkHref:__WEBPACK_IMPORTED_MODULE_1__8_png___default.a,height:"100%",width:"100%"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"cn",className:shouldDisplayByLang("cn")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(125 155)","font-size":"10",fill:"#58595b","font-family":"STHeitiTC-Medium, Heiti TC","font-weight":"500"},"\u5929\u53F0")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"ru",className:shouldDisplayByLang("ru")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(125 155)","font-size":"11",fill:"#58595b","font-family":"Helvetica-Bold, Helvetica","font-weight":"700"},"\u041A\u0420\u042B\u0428\u0410")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"en",className:shouldDisplayByLang("en")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(125 155)","font-size":"9.6",fill:"#58595b","font-family":"Termina-Bold, Termina","font-weight":"700"},"Roof top Floor"))));});

/***/ }),
/* 972 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/8.e1683934.png";

/***/ }),
/* 973 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__1_png__ = __webpack_require__(974);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__1_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__1_png__);
// import _ from 'lodash'
// import MultiLineText from './MultiLineText';
/* unused harmony default export */ var _unused_webpack_default_export = (function(_ref){var currentLang=_ref.currentLang,selectedType=_ref.selectedType;var shouldDisplayByLang=function shouldDisplayByLang(selectLang){return currentLang===selectLang?"display":"display-none";};var shouldDisplayByType=function shouldDisplayByType(type){return selectedType===type||selectedType==="all"?"opacity-in":"opacity-out";};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 330 360",className:"site-plan-svg"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"map"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("image",{xlinkHref:__WEBPACK_IMPORTED_MODULE_1__1_png___default.a,height:"100%",width:"100%"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"floorplan"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"two-bedroom",className:shouldDisplayByType("two-bedroom")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3101","data-name":"3101",points:"195.2 68.7 223.8 41 254.1 71.3 226.4 99.9 195.2 68.7"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3102","data-name":"3102",points:"167.4 97.3 195.2 68.7 226.4 99.9 198.6 127.7 167.4 97.3"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3103","data-name":"3103",points:"138 125.9 167.4 98.2 198.6 127.7 168.3 157.1 138 125.9"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3104","data-name":"3104",points:"112 203.1 142.3 172.7 170 199.6 139.7 230.8 112 203.1"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3105","data-name":"3105",points:"167.4 258.5 139.7 230.8 170 199.6 196.9 227.3 167.4 258.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3106","data-name":"3106",points:"195.2 286.3 167.4 258.5 196.9 227.3 226.4 255.9 195.2 286.3"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3107","data-name":"3107",points:"222.9 314 195.2 286.3 226.4 256.8 254.1 284.5 222.9 314"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"one-bedroom",className:shouldDisplayByType("one-bedroom")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3111","data-name":"3111",points:"103.3 249 125.8 227.3 143.2 244.7 118 271.5 106.8 260.3 110.2 256.8 103.3 249"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3110","data-name":"3110",points:"162.2 263.7 143.2 283.7 125.3 263.7 143.2 244.7 162.2 263.7"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3108","data-name":"3108",points:"158.8 304.5 181.3 281.9 198.6 301 174.4 327 163.1 315.7 167.4 312.3 158.8 304.5"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"studio",className:shouldDisplayByType("studio")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3112","data-name":"3112",points:"91.2 223 106.8 208.3 125 227.3 106.8 246.4 95.5 235.1 99.8 230.8 91.2 223"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3109","data-name":"3109",points:"151.8 290.6 155.3 286.3 147.5 279.3 162.2 264.6 181.3 281.9 162.2 301 151.8 290.6"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"en",className:shouldDisplayByLang("en")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(218.3 170.7)","font-size":"10",fill:"#58595b","font-family":"Termina-Bold, Termina Bold","font-weight":"700"},"1st ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{x:"14.5",y:"0","letter-spacing":"-0.02em"},"F"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{x:"19.2",y:"0"},"loor")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(243.5 90.6)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3101"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(213.4 120.8)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3102"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(184.9 149.3)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3103"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(155.2 180.6)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3104"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(181.9 207.3)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3105"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(210.9 236.3)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3106"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(239.2 264.6)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3107"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(152.4 325.6)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3108",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{x:"-11.8",y:"7.1"},"Handicap")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(133.5 306.6)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3109"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(115.3 288.5)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3110"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(96.3 269.8)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3111",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{x:"-11.8",y:"7.1"},"Handicap")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(77.2 250.3)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3112")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"cn",className:shouldDisplayByLang("cn")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(217.8 170.7)","font-size":"10",fill:"#58595b","font-family":"Termina-Bold, Termina Bold"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{"font-weight":"700"},"1"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{x:"5.1",y:"0","font-family":"STHeitiTC-Medium, STHeitiTC Medium"},"\u697C")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(243.5 90.6)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3101"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(213.4 120.8)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3102"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(184.9 149.3)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3103"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(155.2 180.6)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3104"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(181.9 207.3)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3105"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(210.9 236.3)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3106"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(239.2 264.6)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3107"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(152.4 325.6)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3108",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{"font-size":"5.39",fill:"#a6a8ab","font-family":"STHeitiTC-Medium, STHeitiTC Medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{x:"-13.9",y:"6.5"},"\u65E0\u969C\u788D\u8BBE\u65BD"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(133.5 306.6)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3109"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(115.3 288.5)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3110"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(96.3 269.8)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3111",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{"font-size":"5.39",fill:"#a6a8ab","font-family":"STHeitiTC-Medium, STHeitiTC Medium"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{x:"-13.9",y:"6.5"},"\u65E0\u969C\u788D\u8BBE\u65BD"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(77.2 250.3)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3112")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"ru",className:shouldDisplayByLang("ru")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(217.9 171)","font-size":"11",fill:"#58595b","font-family":"Helvetica-Bold, Helvetica","font-weight":"700"},"1-\u0419 \u042D\u0422\u0410\u0416"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(243.5 90.6)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3101"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(213.4 120.8)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3102"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(184.9 149.3)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3103"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(155.2 180.6)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3104"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(181.9 207.3)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3105"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(210.9 236.3)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3106"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(239.2 264.6)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3107"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(152.4 325.6)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3108",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{"font-size":"5"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{x:"-4.4",y:"4"},"\u0434\u043B\u044F \u043B\u044E\u0434\u0435\u0439 \u0441"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{x:"-8.2",y:"8"},"\u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u043D\u044B\u043C\u0438"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{x:"-8.2",y:"12"},"\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u044F\u043C\u0438"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(133.5 306.6)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3109"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(115.3 288.5)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3110"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(96.3 269.8)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3111",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{"font-size":"5"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{x:"-4.4",y:"4"},"\u0434\u043B\u044F \u043B\u044E\u0434\u0435\u0439 \u0441"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{x:"-8.2",y:"8"},"\u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u043D\u044B\u043C\u0438"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{x:"-8.2",y:"12"},"\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u044F\u043C\u0438"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(77.2 250.3)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3112"))));});

/***/ }),
/* 974 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/1.911a4e4f.png";

/***/ }),
/* 975 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__2_png__ = __webpack_require__(976);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__2_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__2_png__);
// import _ from 'lodash'
// import MultiLineText from './MultiLineText';
/* unused harmony default export */ var _unused_webpack_default_export = (function(_ref){var currentLang=_ref.currentLang,selectedType=_ref.selectedType;var shouldDisplayByLang=function shouldDisplayByLang(selectLang){return currentLang===selectLang?"display":"display-none";};var shouldDisplayByType=function shouldDisplayByType(type){return selectedType===type||selectedType==="all"?"opacity-in":"opacity-out";};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 330 360",className:"site-plan-svg"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"map"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("image",{xlinkHref:__WEBPACK_IMPORTED_MODULE_1__2_png___default.a,height:"100%",width:"100%"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"floorplan"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"studio",className:shouldDisplayByType("studio")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3201","data-name":"3201",points:"204.5 59.5 223.5 40.5 242.5 59.5 231.5 70.5 227.5 67.5 220.5 74.5 204.5 59.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3204","data-name":"3204",points:"147.5 114.5 166.5 96.5 186.5 114.5 176.5 125.5 172.5 122.5 164.5 129.5 147.5 114.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3208","data-name":"3208",points:"110.5 200.5 130.5 182.5 140.5 192.5 137.5 195.5 145.5 204.5 129.5 219.5 110.5 200.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3210","data-name":"3210",points:"166.5 258.5 186.5 238.5 196.5 248.5 193.5 252.5 201.5 260.5 186.5 276.5 166.5 258.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3214","data-name":"3214",points:"143.5 281.5 162.5 262.5 180.5 281.5 165.5 296.5 157.5 288.5 154.5 291.5 143.5 281.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3217","data-name":"3217",points:"87.5 225.5 107.5 207.5 124.5 224.5 108.5 239.5 101.5 232.5 97.5 236.5 87.5 225.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3219","data-name":"3219",points:"91.5 130.5 99.5 122.5 95.5 118.5 105.5 109.5 124.5 128.5 106.5 147.5 91.5 130.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3222","data-name":"3222",points:"151.5 63.5 161.5 53.5 180.5 72.5 162.5 91.5 147.5 75.5 155.5 68.5 151.5 63.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3223","data-name":"3223",points:"169.5 44.5 180.5 34.5 199.5 53.5 180.5 72.5 165 57 173.5 49.5 169.5 44.5"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"one-bedroom",className:shouldDisplayByType("one-bedroom")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3202","data-name":"3202",points:"184.5 78.5 204.5 59.5 223.5 78.5 204.5 96.5 184.5 78.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3203","data-name":"3203",points:"197.5 109.5 194.5 106.5 186.5 114.5 166.5 96.5 184.5 77.5 208.5 99.5 197.5 109.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3205","data-name":"3205",points:"129.5 133.5 147.5 114.5 170.5 136.5 152.5 155.5 129.5 133.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3206","data-name":"3206",points:"110.5 151.5 129.5 133.5 150 153.1 130.5 170.5 110.5 151.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3208-2","data-name":"3208",points:"152.5 197.5 171.5 216.5 147.5 237.5 129.5 219.5 152.5 197.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3209","data-name":"3209",points:"177.5 228.5 186.5 238.5 166.5 257.5 147.5 237.5 168.1 219.5 177.5 228.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3211","data-name":"3211",points:"204.5 257.5 223.5 276.5 204.5 295.5 186.5 276.5 204.5 257.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3212","data-name":"3212",points:"226.5 271.5 237.5 282.5 233.5 286.5 241.5 293.5 223.5 313.5 204.5 295.5 226.5 271.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3213","data-name":"3213",points:"180.5 318.5 171.5 310.5 168.5 313.5 158.5 303.5 180.5 281.5 198.5 299.5 180.5 318.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3215","data-name":"3215",points:"121.5 266.5 143.5 243.5 161.5 262.5 138.5 285.5 121.5 266.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3216","data-name":"3216",points:"124.5 223.5 143.5 243.5 124.5 263.4 117.5 255.5 113.5 257.5 102.5 247.5 124.5 223.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3218","data-name":"3218",points:"79.5 190.5 102.5 190.5 102.5 202.5 107.5 207.5 87.5 225.5 79.5 217.5 73.5 217.5 73.5 200.5 78.5 200.5 78.5 190.5 79.5 190.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3220","data-name":"3220",points:"102.5 105.5 110.5 97.5 107.5 94.5 118.5 84.5 143.5 109.5 124.5 128.5 102.5 105.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3221","data-name":"3221",points:"143.5 72.5 161.5 91.5 143.5 109.5 124.5 90.5 143.5 72.5"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"en",className:shouldDisplayByLang("en")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(218.4 170.7)","font-size":"10",fill:"#58595b","font-family":"Termina-Bold, Termina Bold","font-weight":"700"},"2nd ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{x:"18.4",y:"0","letter-spacing":"-0.02em"},"F"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{x:"23.1",y:"0"},"loor")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(241 75.8)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3201"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(222.5 94.3)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3202"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(204.4 112.5)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3203"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(184 132.8)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3204"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(165.9 151)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3205"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(147.3 169.6)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3206"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(147.7 186.5)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3207"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(166.9 205.7)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3208"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(185.7 224.5)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3209"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(204 242.8)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3210"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(222.5 261.3)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3211"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(241.2 280)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3212"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(152.5 325.3)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3213"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(134.1 306.9)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3214"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(115.9 288.7)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3215"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(97.6 270.4)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3216"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(78 250.8)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3217"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(57.8 215.6)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3218"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(76.2 107.8)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3219"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(93.9 90.2)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3220"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(111.9 72.2)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3221"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(129.7 54.3)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3222"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(148.7 35.3)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3223")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"cn",className:shouldDisplayByLang("cn")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(218.4 170.7)","font-size":"10",fill:"#58595b","font-family":"Termina-Bold, Termina Bold"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{"font-weight":"700"},"2"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{x:"5.1",y:"0","font-family":"STHeitiTC-Medium, STHeitiTC Medium"},"\u697C")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(241 75.8)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3201"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(222.5 94.3)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3202"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(204.4 112.5)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3203"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(184 132.8)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3204"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(165.9 151)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3205"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(147.3 169.6)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3206"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(147.7 186.5)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3207"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(166.9 205.7)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3208"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(185.7 224.5)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3209"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(204 242.8)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3210"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(222.5 261.3)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3211"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(241.2 280)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3212"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(152.5 325.3)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3213"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(134.1 306.9)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3214"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(115.9 288.7)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3215"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(97.6 270.4)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3216"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(78 250.8)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3217"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(57.8 215.6)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3218"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(76.2 107.8)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3219"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(93.9 90.2)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3220"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(111.9 72.2)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3221"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(129.7 54.3)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3222"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(148.7 35.3)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3223")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"ru",className:shouldDisplayByLang("ru")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(218.3 171)","font-size":"11",fill:"#58595b","font-family":"Helvetica-Bold, Helvetica","font-weight":"700"},"2-\u0419 \u042D\u0422\u0410\u0416"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(241 75.8)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3201"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(222.5 94.3)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3202"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(204.4 112.5)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3203"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(184 132.8)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3204"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(165.9 151)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3205"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(147.3 169.6)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3206"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(147.7 186.5)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3207"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(166.9 205.7)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3208"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(185.7 224.5)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3209"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(204 242.8)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3210"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(222.5 261.3)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3211"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(241.2 280)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3212"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(152.5 325.3)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3213"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(134.1 306.9)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3214"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(115.9 288.7)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3215"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(97.6 270.4)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3216"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(78 250.8)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3217"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(57.8 215.6)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3218"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(76.2 107.8)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3219"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(93.9 90.2)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3220"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(111.9 72.2)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3221"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(129.7 54.3)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3222"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(148.7 35.3)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3223"))));});

/***/ }),
/* 976 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/2.eed2d4a6.png";

/***/ }),
/* 977 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__3_png__ = __webpack_require__(978);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__3_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__3_png__);
// import _ from 'lodash'
// import MultiLineText from './MultiLineText';
/* unused harmony default export */ var _unused_webpack_default_export = (function(_ref){var currentLang=_ref.currentLang,selectedType=_ref.selectedType;var shouldDisplayByLang=function shouldDisplayByLang(selectLang){return currentLang===selectLang?"display":"display-none";};var shouldDisplayByType=function shouldDisplayByType(type){return selectedType===type||selectedType==="all"?"opacity-in":"opacity-out";};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 330 360",className:"site-plan-svg"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"map"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("image",{xlinkHref:__WEBPACK_IMPORTED_MODULE_1__3_png___default.a,height:"100%",width:"100%"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"floorplan"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"two-bedroom",className:shouldDisplayByType("two-bedroom")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3301","data-name":"3301",points:"195.5 67.5 223.5 39.5 242.5 58.5 233.5 67.5 236.5 70.5 217.5 89.5 195.5 67.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3302","data-name":"3302",points:"167.5 95.5 195.5 67.5 217.5 89.5 208.5 99.5 212.5 102.5 193.5 121.5 167.5 95.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3309","data-name":"3309",points:"167.5 257.5 190.5 234.5 217.5 261.5 195.5 284.5 167.5 257.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3310","data-name":"3310",points:"226.5 270.5 244.5 289.5 223.5 312.5 195.5 284.5 213.6 265.6 222.5 274.5 226.5 270.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3313","data-name":"3313",points:"134.5 234.5 161.5 261.5 139.5 284.5 120.5 265.5 123.5 262.5 114.5 252.5 134.5 234.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3314","data-name":"3314",points:"87.5 224.5 106.5 206.5 134.5 234.5 114.5 252.5 87.5 224.5"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"one-bedroom",className:shouldDisplayByType("one-bedroom")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3304","data-name":"3304",points:"130.5 131.5 149.5 113.5 171.5 137.5 163.5 144.5 167.5 147.5 156.5 158.5 130.5 131.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3305","data-name":"3305",points:"110.5 150.5 130.5 131.5 150.3 152.1 141.5 159.5 144.5 162.5 134.5 173.5 110.5 150.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3307","data-name":"3307",points:"152.5 196.5 161.5 204.5 164.5 201.5 174.5 211.5 148.5 238.5 130.5 219.5 152.5 196.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3308","data-name":"3308",points:"179.5 223.5 190.5 234.5 167.5 257.5 148.5 238.5 168.7 217.5 176.5 226.5 179.5 223.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3312","data-name":"3312",points:"161.5 299.5 143.1 280.8 161.5 261.5 179.5 280.5 161.5 299.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3315","data-name":"3315",points:"79.5 189.5 101.5 189.5 101.5 201.5 106.5 206.5 87.5 224.5 79.5 217.5 73.5 217.5 73.5 200.5 79.5 200.5 79.5 189.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3316","data-name":"3316",points:"73.5 135.5 78.5 135.5 87.5 127.5 106.5 145.5 101.5 150.5 101.5 162.5 78.5 162.5 78.5 152.5 73.5 152.5 73.5 135.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3318","data-name":"3318",points:"103.5 105.5 114.5 94.5 117.5 97.5 125.5 89.5 143.5 108.5 125.5 127.5 103.5 105.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3319","data-name":"3319",points:"121.5 85.5 139.5 67.5 162.5 89.5 143.5 108.5 121.5 85.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3321","data-name":"3321",points:"161.5 51.5 179.5 33.5 199.5 51.5 180.5 70.5 161.5 51.5"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"studio",className:shouldDisplayByType("studio")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3320","data-name":"3320",points:"152.5 60.5 156.5 64.5 166 56 180.5 70.5 162.5 89.5 143.5 70.5 152.5 60.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3317","data-name":"3317",points:"97.5 116.5 100.5 119.5 109.3 111.3 125.5 127.5 106.5 144.5 87.5 127.5 97.5 116.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3306","data-name":"3306",points:"125.5 185.5 134.5 193.5 137.5 189.5 148.5 199.5 130.5 219.5 110.5 200.5 125.5 185.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3311","data-name":"3311",points:"199.5 299.5 180.5 318.5 169.5 307.5 174.5 303.5 165 295.8 179.5 280.5 199.5 299.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3303","data-name":"3303",points:"174.5 118.5 179.5 123.5 169.5 133.5 150.5 113.5 167.5 94.5 183.3 111.3 174.5 118.5"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{xmlns:"http://www.w3.org/2000/svg",id:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"en",className:shouldDisplayByLang("en")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(218.5 170.8)","font-size":"10",fill:"#58595b","font-family":"Termina-Bold, Termina Bold","font-weight":"700"},"3",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{x:"5.1",y:"0","letter-spacing":"-0.01em"},"r"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{x:"8.3",y:"0"},"d "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{x:"16.1",y:"0","letter-spacing":"-0.02em"},"F"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{x:"20.8",y:"0"},"loor")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(239.5 82.6)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3301"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(74.7 109.8)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3317"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(93.8 90.7)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3318"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(112 72.6)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3319"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(130 54.6)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3320"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(149.6 35)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3321"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(211 111.1)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3302"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(187.7 134.3)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3303"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(169 153.1)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3304"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(152.6 169.5)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3305"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(152.6 186.2)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3306"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(169.5 203.1)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3307"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(187.6 221.2)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3308"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(210.7 244.3)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3309"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(238 271.6)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3310"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(111.6 282.9)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3313"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(84.4 255.7)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3314"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(57.3 215.9)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3315"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(53.3 144.9)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3316"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(151.7 323)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3311"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(135 306.3)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3312")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"cn",className:shouldDisplayByLang("cn")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(217.8 170.7)","font-size":"10",fill:"#58595b","font-family":"Termina-Bold, Termina Bold"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{"font-weight":"700"},"3"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{x:"5.1",y:"0","font-family":"STHeitiTC-Medium, STHeitiTC Medium"},"\u697C")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(239.5 82.6)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3301"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(74.7 109.8)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3317"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(93.8 90.7)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3318"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(112 72.6)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3319"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(130 54.6)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3320"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(149.6 35)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3321"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(211 111.1)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3302"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(187.7 134.3)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3303"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(169 153.1)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3304"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(152.6 169.5)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3305"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(152.6 186.2)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3306"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(169.5 203.1)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3307"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(187.6 221.2)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3308"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(210.7 244.3)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3309"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(238 271.6)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3310"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(111.6 282.9)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3313"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(84.4 255.7)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3314"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(57.3 215.9)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3315"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(53.3 144.9)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3316"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(151.7 323)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3311"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(135 306.3)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3312")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"ru",className:shouldDisplayByLang("ru")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(217.3 171.3)","font-size":"11",fill:"#58595b","font-family":"Helvetica-Bold, Helvetica","font-weight":"700"},"3-\u0419 \u042D\u0422\u0410\u0416"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(239.5 82.6)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3301"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(74.7 109.8)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3317"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(93.8 90.7)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3318"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(112 72.6)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3319"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(130 54.6)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3320"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(149.6 35)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3321"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(211 111.1)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3302"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(187.7 134.3)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3303"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(169 153.1)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3304"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(152.6 169.5)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3305"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(152.6 186.2)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3306"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(169.5 203.1)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3307"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(187.6 221.2)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3308"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(210.7 244.3)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3309"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(238 271.6)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3310"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(111.6 282.9)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3313"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(84.4 255.7)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3314"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(57.3 215.9)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3315"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(53.3 144.9)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3316"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(151.7 323)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3311"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(135 306.3)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3312"))));});

/***/ }),
/* 978 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/3.e5dc2584.png";

/***/ }),
/* 979 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__4_png__ = __webpack_require__(980);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__4_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__4_png__);
// import _ from 'lodash'
// import MultiLineText from './MultiLineText';
/* unused harmony default export */ var _unused_webpack_default_export = (function(_ref){var currentLang=_ref.currentLang,selectedType=_ref.selectedType;var shouldDisplayByLang=function shouldDisplayByLang(selectLang){return currentLang===selectLang?'display':'display-none';};var shouldDisplayByType=function shouldDisplayByType(type){return selectedType===type||selectedType==='all'?'opacity-in':'opacity-out';};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',{xmlns:'http://www.w3.org/2000/svg',viewBox:'0 0 330 360',className:'site-plan-svg'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'map'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('image',{xlinkHref:__WEBPACK_IMPORTED_MODULE_1__4_png___default.a,height:'100%',width:'100%'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'floorplan'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'two-bedroom',className:shouldDisplayByType("two-bedroom")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'_3401','data-name':'3401',points:'194.5 67.5 222.5 40.5 241.5 59.5 222.5 78.5 217.5 74.5 209.5 82.5 194.5 67.5'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'_3402','data-name':'3402',points:'167.5 94.5 194.5 67.5 217.5 90.5 198.5 109.5 194.5 106.5 185.5 114.5 167.5 94.5'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'_3409','data-name':'3409',points:'190.5 235.5 216.5 261.5 195.5 285.5 167.5 257.5 190.5 235.5'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'_3410','data-name':'3410',points:'232.5 284.5 229.5 287.5 238.5 296.5 223.5 312.5 195.5 285.5 213.2 265.3 232.5 284.5'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'_3413','data-name':'3413',points:'114.5 252.5 134.5 234.5 161.5 261.5 145.5 276.5 137.5 268.5 133.5 272.5 114.5 252.5'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'_3414','data-name':'3414',points:'86.5 224.5 106.5 206.5 134.5 234.5 114.5 252.5 86.5 224.5'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'_3417','data-name':'3417',points:'92.5 114.5 111.5 95.5 133.5 118.5 106.5 145.5 87.5 126.5 95.5 118.5 92.5 114.5'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'_3418','data-name':'3418',points:'137.5 68.5 161.5 90.5 133.5 118.5 110.5 95.5 137.5 68.5'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'one-bedroom',className:shouldDisplayByType("one-bedroom")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'_3404','data-name':'3404',points:'129.5 133.5 147.5 114.5 170.5 135.5 159.5 146.5 156.5 143.5 149.5 150.5 129.5 133.5'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'_3405','data-name':'3405',points:'110.5 151.5 129.5 132.5 153.5 155.5 134.5 173.5 110.5 151.5'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'_3407','data-name':'3407',points:'152.5 197.5 162.5 207.5 159.5 210.5 167.5 219.5 148.5 239.5 129.5 219.5 152.5 197.5'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'_3408','data-name':'3408',points:'170.5 215.5 190.5 235.5 167.5 257.5 148.5 239.5 170.5 215.5'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'_3411','data-name':'3411',points:'161.5 298.5 180.5 280.5 199.5 298.5 180.5 318.5 161.5 298.5'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'_3412','data-name':'3412',points:'141.5 280.5 161.5 260.5 180.5 280.5 161.5 299.5 141.5 280.5'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'_3415','data-name':'3415',points:'78.5 190.5 100.5 190.5 100.5 200.5 106.5 206.5 86.5 224.5 78.5 216.5 73.5 216.5 73.5 199.5 78.5 199.5 78.5 190.5'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'_3416','data-name':'3416',points:'73.5 135.5 78.5 135.5 87.5 126.5 106.5 145.5 100.5 150.5 100.5 162.5 77.5 162.5 77.5 152.5 73.5 152.5 73.5 135.5'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'_3419','data-name':'3419',points:'148.5 60.5 158.5 50.5 180.5 71.5 161.5 90.5 141.6 72.2 151.5 63.5 148.5 60.5'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'_3420','data-name':'3420',points:'179.5 33.5 199.5 52.5 180.5 70.5 161 52 179.5 33.5'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'studio',className:shouldDisplayByType("studio")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'_3403','data-name':'3403',points:'175.5 124.5 172.5 120.5 163.6 129.2 148.5 114.5 167.5 95.5 185.5 114.5 175.5 124.5'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('polygon',{id:'_3406','data-name':'3406',points:'110.5 200.5 129.5 181.5 141.5 192.5 137.5 197.5 145.3 204.4 129.5 219.5 110.5 200.5'}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'en',className:shouldDisplayByLang("en")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(217.5 170.8)','font-size':'10',fill:'#58595b','font-family':'Termina-Bold, Termina Bold','font-weight':'700'},'4th ',__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tspan',{x:'16.1',y:'0','letter-spacing':'-0.02em'},'F'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tspan',{x:'20.8',y:'0'},'loor')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(240.8 81.3)','font-size':'5.88',fill:'#808184','font-family':'Helvetica, Helvetica'},'3401'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(149.1 34.3)','font-size':'5.88',fill:'#808184','font-family':'Helvetica, Helvetica'},'3420'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(131.1 52.3)','font-size':'5.88',fill:'#808184','font-family':'Helvetica, Helvetica'},'3419'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(108.5 74.9)','font-size':'5.88',fill:'#808184','font-family':'Helvetica, Helvetica'},'3418'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(82.3 101.1)','font-size':'5.88',fill:'#808184','font-family':'Helvetica, Helvetica'},'3417'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(214 108.1)','font-size':'5.88',fill:'#808184','font-family':'Helvetica, Helvetica'},'3402'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(189.1 132.9)','font-size':'5.88',fill:'#808184','font-family':'Helvetica, Helvetica'},'3403'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(171.1 150.9)','font-size':'5.88',fill:'#808184','font-family':'Helvetica, Helvetica'},'3404'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(152.8 169.3)','font-size':'5.88',fill:'#808184','font-family':'Helvetica, Helvetica'},'3405'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(152.8 185.9)','font-size':'5.88',fill:'#808184','font-family':'Helvetica, Helvetica'},'3406'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(170.1 203.3)','font-size':'5.88',fill:'#808184','font-family':'Helvetica, Helvetica'},'3407'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(189.5 222.6)','font-size':'5.88',fill:'#808184','font-family':'Helvetica, Helvetica'},'3408'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(212.5 245.6)','font-size':'5.88',fill:'#808184','font-family':'Helvetica, Helvetica'},'3409'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(240 273.1)','font-size':'5.88',fill:'#808184','font-family':'Helvetica, Helvetica'},'3410'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(155.3 321.4)','font-size':'5.88',fill:'#808184','font-family':'Helvetica, Helvetica'},'3411'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(136.5 302.6)','font-size':'5.88',fill:'#808184','font-family':'Helvetica, Helvetica'},'3412'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(115.3 281.4)','font-size':'5.88',fill:'#808184','font-family':'Helvetica, Helvetica'},'3413'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(86.5 252.6)','font-size':'5.88',fill:'#808184','font-family':'Helvetica, Helvetica'},'3414'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(57.8 215.6)','font-size':'5.88',fill:'#808184','font-family':'Helvetica, Helvetica'},'3415'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(52.8 144.6)','font-size':'5.88',fill:'#808184','font-family':'Helvetica, Helvetica'},'3416')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'cn',className:shouldDisplayByLang("cn")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(218.1 171.7)','font-size':'10',fill:'#58595b','font-family':'Termina-Bold, Termina Bold'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tspan',{'font-weight':'700'},'4'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('tspan',{x:'5.1',y:'0','font-family':'STHeitiTC-Medium, STHeitiTC Medium'},'\u697C')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(240.8 81.3)','font-size':'5.88',fill:'#808184','font-family':'Helvetica, Helvetica'},'3401'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(149.1 34.3)','font-size':'5.88',fill:'#808184','font-family':'Helvetica, Helvetica'},'3420'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(131.1 52.3)','font-size':'5.88',fill:'#808184','font-family':'Helvetica, Helvetica'},'3419'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(108.5 74.9)','font-size':'5.88',fill:'#808184','font-family':'Helvetica, Helvetica'},'3418'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(82.3 101.1)','font-size':'5.88',fill:'#808184','font-family':'Helvetica, Helvetica'},'3417'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(214 108.1)','font-size':'5.88',fill:'#808184','font-family':'Helvetica, Helvetica'},'3402'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(189.1 132.9)','font-size':'5.88',fill:'#808184','font-family':'Helvetica, Helvetica'},'3403'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(171.1 150.9)','font-size':'5.88',fill:'#808184','font-family':'Helvetica, Helvetica'},'3404'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(152.8 169.3)','font-size':'5.88',fill:'#808184','font-family':'Helvetica, Helvetica'},'3405'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(152.8 185.9)','font-size':'5.88',fill:'#808184','font-family':'Helvetica, Helvetica'},'3406'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(170.1 203.3)','font-size':'5.88',fill:'#808184','font-family':'Helvetica, Helvetica'},'3407'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(189.5 222.6)','font-size':'5.88',fill:'#808184','font-family':'Helvetica, Helvetica'},'3408'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(212.5 245.6)','font-size':'5.88',fill:'#808184','font-family':'Helvetica, Helvetica'},'3409'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(240 273.1)','font-size':'5.88',fill:'#808184','font-family':'Helvetica, Helvetica'},'3410'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(155.3 321.4)','font-size':'5.88',fill:'#808184','font-family':'Helvetica, Helvetica'},'3411'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(136.5 302.6)','font-size':'5.88',fill:'#808184','font-family':'Helvetica, Helvetica'},'3412'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(115.3 281.4)','font-size':'5.88',fill:'#808184','font-family':'Helvetica, Helvetica'},'3413'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(86.5 252.6)','font-size':'5.88',fill:'#808184','font-family':'Helvetica, Helvetica'},'3414'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(57.8 215.6)','font-size':'5.88',fill:'#808184','font-family':'Helvetica, Helvetica'},'3415'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(52.8 144.6)','font-size':'5.88',fill:'#808184','font-family':'Helvetica, Helvetica'},'3416')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'ru',className:shouldDisplayByLang("ru")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(217.3 172.3)','font-size':'11',fill:'#58595b','font-family':'Helvetica-Bold, Helvetica','font-weight':'700'},'4-\u0419 \u042D\u0422\u0410\u0416'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(240.8 81.3)','font-size':'5.88',fill:'#808184','font-family':'Helvetica, Helvetica'},'3401'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(149.1 34.3)','font-size':'5.88',fill:'#808184','font-family':'Helvetica, Helvetica'},'3420'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(131.1 52.3)','font-size':'5.88',fill:'#808184','font-family':'Helvetica, Helvetica'},'3419'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(108.5 74.9)','font-size':'5.88',fill:'#808184','font-family':'Helvetica, Helvetica'},'3418'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(82.3 101.1)','font-size':'5.88',fill:'#808184','font-family':'Helvetica, Helvetica'},'3417'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(214 108.1)','font-size':'5.88',fill:'#808184','font-family':'Helvetica, Helvetica'},'3402'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(189.1 132.9)','font-size':'5.88',fill:'#808184','font-family':'Helvetica, Helvetica'},'3403'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(171.1 150.9)','font-size':'5.88',fill:'#808184','font-family':'Helvetica, Helvetica'},'3404'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(152.8 169.3)','font-size':'5.88',fill:'#808184','font-family':'Helvetica, Helvetica'},'3405'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(152.8 185.9)','font-size':'5.88',fill:'#808184','font-family':'Helvetica, Helvetica'},'3406'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(170.1 203.3)','font-size':'5.88',fill:'#808184','font-family':'Helvetica, Helvetica'},'3407'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(189.5 222.6)','font-size':'5.88',fill:'#808184','font-family':'Helvetica, Helvetica'},'3408'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(212.5 245.6)','font-size':'5.88',fill:'#808184','font-family':'Helvetica, Helvetica'},'3409'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(240 273.1)','font-size':'5.88',fill:'#808184','font-family':'Helvetica, Helvetica'},'3410'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(155.3 321.4)','font-size':'5.88',fill:'#808184','font-family':'Helvetica, Helvetica'},'3411'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(136.5 302.6)','font-size':'5.88',fill:'#808184','font-family':'Helvetica, Helvetica'},'3412'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(115.3 281.4)','font-size':'5.88',fill:'#808184','font-family':'Helvetica, Helvetica'},'3413'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(86.5 252.6)','font-size':'5.88',fill:'#808184','font-family':'Helvetica, Helvetica'},'3414'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(57.8 215.6)','font-size':'5.88',fill:'#808184','font-family':'Helvetica, Helvetica'},'3415'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('text',{transform:'translate(52.8 144.6)','font-size':'5.88',fill:'#808184','font-family':'Helvetica, Helvetica'},'3416'))));});

/***/ }),
/* 980 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/4.aa25062d.png";

/***/ }),
/* 981 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__5_png__ = __webpack_require__(982);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__5_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__5_png__);
// import _ from 'lodash'
// import MultiLineText from './MultiLineText';
/* unused harmony default export */ var _unused_webpack_default_export = (function(_ref){var currentLang=_ref.currentLang,selectedType=_ref.selectedType;var shouldDisplayByLang=function shouldDisplayByLang(selectLang){return currentLang===selectLang?"display":"display-none";};var shouldDisplayByType=function shouldDisplayByType(type){return selectedType===type||selectedType==="all"?"opacity-in":"opacity-out";};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 330 360",className:"site-plan-svg"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"map"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("image",{xlinkHref:__WEBPACK_IMPORTED_MODULE_1__5_png___default.a,height:"100%",width:"100%"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"floorplan"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"two-bedroom",className:shouldDisplayByType("two-bedroom")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3501","data-name":"3501",points:"193.5 68.5 223.5 39.5 241.5 57.5 213.5 85.5 193.5 68.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3502","data-name":"3502",points:"166.5 95.5 193.5 68.5 209.4 82 201.5 90.5 205.5 95.5 186.5 114.5 166.5 95.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3503","data-name":"3503",points:"139.5 122.5 166.5 95.5 189.5 117.5 181.5 125.5 184.5 128.5 165.5 148.5 139.5 122.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3504","data-name":"3504",points:"110.5 150.5 139.5 122.5 158.5 141.5 149.5 150.5 152.5 153.5 134.5 172.5 110.5 150.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3505","data-name":"3505",points:"158.5 209.5 139.5 228.5 110.5 200.5 129.5 181.5 158.5 209.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3506","data-name":"3506",points:"170.5 214.5 189.5 233.5 166.5 256.5 139.5 228.5 158.5 209.5 166.5 218.5 170.5 214.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3507","data-name":"3507",points:"220.5 258.5 194.5 284.5 166.5 256.5 189.5 233.5 198.5 242.5 202.5 239.5 220.5 258.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3508","data-name":"3508",points:"226.5 269.5 244.5 289.5 222.5 312.5 193.5 284.5 214 265 223.5 273.5 226.5 269.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3511","data-name":"3511",points:"114.5 252.5 132.5 233.5 161.5 261.5 146.5 276.5 128.5 259.5 125.5 262.5 114.5 252.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3512","data-name":"3512",points:"84.5 228.5 106.5 206.5 132.5 233.5 110.5 255.5 84.5 228.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3515","data-name":"3515",points:"87.5 125.5 105.5 106.5 108.5 110.5 117.5 101.5 134.5 117.5 106.5 145.5 87.5 125.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3516","data-name":"3516",points:"108.5 91.5 126.5 72.5 130.5 75.5 139.5 68.5 161.5 88.5 134.5 117.5 108.5 91.5"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"one-bedroom",className:shouldDisplayByType("one-bedroom")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3518","data-name":"3518",points:"154.5 45.5 164.5 34.5 168.5 37.5 175.5 30.5 198.5 52.5 180.5 70.5 154.5 45.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3517","data-name":"3517",points:"145.5 59.5 157.2 48.1 180.5 70.5 161.5 88.5 138.5 68.5 145.5 59.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3514","data-name":"3514",points:"73.5 135.5 78.5 135.5 87.5 125.5 106.5 145.5 101.5 150.5 100.5 162.5 77.5 162.5 77.5 151.5 73.5 151.5 73.5 135.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3513","data-name":"3513",points:"77.5 189.5 100.5 189.5 100.5 200.5 106.5 206.5 87.5 224.5 77.5 216.5 73.5 216.5 73.5 199.5 77.5 199.5 77.5 189.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3510","data-name":"3510",points:"180.5 280.5 154.5 305.5 144.5 295.5 147.5 291.5 138.5 284.5 161.5 261.5 180.5 280.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3509","data-name":"3509",points:"199.5 299.5 180.5 318.5 160.7 299.5 180.5 280.5 199.5 299.5"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"en",className:shouldDisplayByLang("en")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(217.3 171.6)","font-size":"10",fill:"#58595b","font-family":"Termina-Bold, Termina Bold","font-weight":"700"},"5th ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{x:"16.1",y:"0","letter-spacing":"-0.02em"},"F"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{x:"20.8",y:"0"},"loor")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(237.5 84.5)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3501"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(209.1 112.8)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3502"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(181 141)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3503"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(153.3 168.7)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3504"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(153.3 187.3)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3505"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(179.1 213.2)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3506"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(207.6 241.7)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3507"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(234.8 268.8)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3508"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(131.5 303.2)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3510"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(108.8 280.5)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3511"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(81.3 253)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3512"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(149.3 321)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3509"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(57.6 209.6)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3513"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(57.6 145.6)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3514"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(106.9 75.6)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3516"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(81.4 101.1)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3515"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(130.7 51.8)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3517"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(150.6 31.9)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3518")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"cn",className:shouldDisplayByLang("cn")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(217.4 171.6)","font-size":"10",fill:"#58595b","font-family":"Termina-Bold, Termina Bold"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{"font-weight":"700"},"5"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{x:"5.1",y:"0","font-family":"STHeitiTC-Medium, STHeitiTC Medium"},"\u697C")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(237.5 84.5)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3501"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(209.1 112.8)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3502"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(181 141)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3503"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(153.3 168.7)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3504"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(153.3 187.3)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3505"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(179.1 213.2)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3506"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(207.6 241.7)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3507"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(234.8 268.8)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3508"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(131.5 303.2)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3510"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(108.8 280.5)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3511"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(81.3 253)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3512"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(149.3 321)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3509"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(57.6 209.6)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3513"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(57.6 145.6)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3514"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(106.9 75.6)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3516"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(81.4 101.1)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3515"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(130.7 51.8)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3517"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(150.6 31.9)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3518")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"ru",className:shouldDisplayByLang("ru")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(217.1 172.1)","font-size":"11",fill:"#58595b","font-family":"Helvetica-Bold, Helvetica","font-weight":"700"},"5-\u0419 \u042D\u0422\u0410\u0416"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(237.5 84.5)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3501"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(209.1 112.8)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3502"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(181 141)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3503"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(153.3 168.7)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3504"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(153.3 187.3)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3505"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(179.1 213.2)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3506"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(207.6 241.7)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3507"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(234.8 268.8)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3508"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(131.5 303.2)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3510"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(108.8 280.5)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3511"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(81.3 253)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3512"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(149.3 321)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3509"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(57.6 209.6)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3513"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(57.6 145.6)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3514"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(106.9 75.6)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3516"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(81.4 101.1)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3515"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(130.7 51.8)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3517"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(150.6 31.9)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3518"))));});

/***/ }),
/* 982 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/5.afb914dd.png";

/***/ }),
/* 983 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__6_png__ = __webpack_require__(984);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__6_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__6_png__);
// import _ from 'lodash'
// import MultiLineText from './MultiLineText';
/* unused harmony default export */ var _unused_webpack_default_export = (function(_ref){var currentLang=_ref.currentLang,selectedType=_ref.selectedType;var shouldDisplayByLang=function shouldDisplayByLang(selectLang){return currentLang===selectLang?"display":"display-none";};var shouldDisplayByType=function shouldDisplayByType(type){return selectedType===type||selectedType==="all"?"opacity-in":"opacity-out";};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 330 360",className:"site-plan-svg"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"map"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("image",{xlinkHref:__WEBPACK_IMPORTED_MODULE_1__6_png___default.a,height:"100%",width:"100%"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"floorplan"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"two-bedroom",className:shouldDisplayByType("two-bedroom")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3601","data-name":"3601",points:"202.5 58.5 222.5 38.5 244.5 61.5 226.5 80.5 223.5 77.5 214.5 86.5 193.5 67.5 202.5 58.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3602","data-name":"3602",points:"166.5 94.5 193.5 67.5 214.5 86.5 185.5 113.5 166.5 94.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3603","data-name":"3603",points:"138.5 122.5 166.5 94.5 190.5 117.5 170.5 136.5 166.5 132.5 157.5 141.5 138.5 122.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3604","data-name":"3604",points:"112.5 149.5 138.5 122.5 161.5 145.5 133.5 172.5 112.5 149.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3605","data-name":"3605",points:"133.5 178.5 152.5 196.5 149.5 200.5 158.5 209.5 138.5 228.5 110.5 199.5 133.5 178.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("rect",{id:"_3606","data-name":"3606",x:"147.7",y:"211.2",width:"32.5",height:"39.6",transform:"translate(-115.3 183.6) rotate(-45)"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3607","data-name":"3607",points:"208.5 252.5 205.5 256.5 214.5 264.5 195.5 284.5 166.5 256.5 189.5 233.5 208.5 252.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3608","data-name":"3608",points:"217.5 261.5 244.5 289.5 222.5 311.5 195.5 284.5 217.5 261.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3611","data-name":"3611",points:"112.5 256.5 134.5 235.5 161.5 261.5 142.5 280.5 134.5 271.5 130.5 275.5 112.5 256.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3612","data-name":"3612",points:"80.5 230.5 106.5 205.5 134.5 235.5 112.5 256.5 102.5 246.5 99.5 250.5 80.5 230.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3615","data-name":"3615",points:"114.5 98.5 134.5 117.5 106.5 145.5 86.5 125.5 114.5 98.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3616","data-name":"3616",points:"120.5 86.5 138.5 67.5 161.5 90.5 134.5 117.5 114.5 98.5 123.5 90.5 120.5 86.5"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"one-bedroom",className:shouldDisplayByType("one-bedroom")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3618","data-name":"3618",points:"166.5 40.5 177.5 30.5 198.5 52.5 180.5 71.5 160.5 50.5 168.5 43.5 166.5 40.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3617","data-name":"3617",points:"143.5 55.5 154.5 45.5 179.5 71.5 161.5 90.5 138.5 67.5 147.5 59.5 143.5 55.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3614","data-name":"3614",points:"73.5 134.5 78.5 134.5 86.5 125.5 107.5 145.5 101.5 150.5 101.5 161.5 78.5 161.5 78.5 152.5 73.5 152.5 73.5 134.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3613","data-name":"3613",points:"77.5 189.5 101.5 189.5 101.5 200.5 107.5 205.5 86.5 224.5 77.5 215.5 73.5 215.5 73.5 198.5 77.5 198.5 77.5 189.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3610","data-name":"3610",points:"179.5 280.5 161.5 298.5 154.5 289.5 150.5 293.5 140.5 282.5 161.5 261.5 179.5 280.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3609","data-name":"3609",points:"199.5 298.5 177.5 320.5 168.5 311.5 165.5 314.5 154.5 304.5 179.5 280.5 199.5 298.5"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"en",className:shouldDisplayByLang("en")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(193 182.6)","font-size":"10",fill:"#58595b","font-family":"Termina-Bold, Termina Bold","font-weight":"700"},"6th ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{x:"16.1",y:"0","letter-spacing":"-0.02em"},"F"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{x:"20.8",y:"0"},"loor")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(233.8 81.8)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3601"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(205.4 110.2)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3602"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(177.1 138.6)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3603"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(149.9 165.7)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3604"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(149.9 188.5)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3605"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(177.4 216)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3606"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(205.2 243.7)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3607"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(232.3 270.8)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3608"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(149.3 321.3)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3609"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(130.6 302.6)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3610"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(107.4 279.5)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3611"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(79.1 251.1)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3612"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(57.8 210.6)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3613"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(57.8 146.6)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3614"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(132.1 52.1)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3617"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(110.9 73.2)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3616"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(81.6 102.6)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3615"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(150.2 34)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3618")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"cn",className:shouldDisplayByLang("cn")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(192.8 182.6)","font-size":"10",fill:"#58595b","font-family":"Termina-Bold, Termina Bold"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{"font-weight":"700"},"6"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{x:"5.1",y:"0","font-family":"STHeitiTC-Medium, STHeitiTC Medium"},"\u697C")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(233.8 81.8)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3601"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(205.4 110.2)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3602"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(177.1 138.6)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3603"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(149.9 165.7)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3604"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(149.9 188.5)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3605"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(177.4 216)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3606"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(205.2 243.7)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3607"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(232.3 270.8)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3608"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(149.3 321.3)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3609"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(130.6 302.6)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3610"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(107.4 279.5)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3611"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(79.1 251.1)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3612"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(57.8 210.6)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3613"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(57.8 146.6)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3614"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(132.1 52.1)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3617"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(110.9 73.2)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3616"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(81.6 102.6)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3615"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(150.2 34)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3618")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"ru",className:shouldDisplayByLang("ru")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(192.8 183.1)","font-size":"11",fill:"#58595b","font-family":"Helvetica-Bold, Helvetica","font-weight":"700"},"6-\u0419 \u042D\u0422\u0410\u0416"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(233.8 81.8)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3601"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(205.4 110.2)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3602"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(177.1 138.6)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3603"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(149.9 165.7)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3604"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(149.9 188.5)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3605"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(177.4 216)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3606"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(205.2 243.7)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3607"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(232.3 270.8)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3608"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(149.3 321.3)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3609"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(130.6 302.6)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3610"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(107.4 279.5)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3611"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(79.1 251.1)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3612"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(57.8 210.6)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3613"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(57.8 146.6)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3614"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(132.1 52.1)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3617"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(110.9 73.2)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3616"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(81.6 102.6)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3615"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(150.2 34)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3618"))));});

/***/ }),
/* 984 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/6.f82ec88d.png";

/***/ }),
/* 985 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__7_png__ = __webpack_require__(986);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__7_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__7_png__);
// import _ from 'lodash'
// import MultiLineText from './MultiLineText';
/* unused harmony default export */ var _unused_webpack_default_export = (function(_ref){var currentLang=_ref.currentLang,selectedType=_ref.selectedType;var shouldDisplayByLang=function shouldDisplayByLang(selectLang){return currentLang===selectLang?"display":"display-none";};var shouldDisplayByType=function shouldDisplayByType(type){return selectedType===type||selectedType==="all"?"opacity-in":"opacity-out";};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 330 360",className:"site-plan-svg"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"map"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("image",{xlinkHref:__WEBPACK_IMPORTED_MODULE_1__7_png___default.a,height:"100%",width:"100%"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"floorplan"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"one-bedroom",className:shouldDisplayByType("one-bedroom")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3701","data-name":"3701",points:"195 66 223 38 239 54 230 63 233 66 215 85 195 66"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3702","data-name":"3702",points:"166.5 93.5 195.5 66.5 218.5 88.5 189.5 116.5 166.5 93.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3703","data-name":"3703",points:"138.5 121.5 166.5 93.5 182.7 109.7 173.5 119.5 177.5 123.5 159.5 140.5 138.5 121.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3704","data-name":"3704",points:"110.5 150.5 138.5 121.5 162.5 144.5 153.5 153.5 156.5 156.5 136.5 176.5 110.5 150.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3705","data-name":"3705",points:"110.5 199.5 134.5 176.5 160.5 204.5 138.5 227.5 110.5 199.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3706","data-name":"3706",points:"173.5 209.5 192.5 229.5 166.5 255.5 138.5 227.5 160.5 204.5 170.5 214.5 173.5 209.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3707","data-name":"3707",points:"195.5 245.5 213.5 263.5 195.5 283.5 166.5 255.5 182.7 239.3 190.5 248.5 195.5 245.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3708","data-name":"3708",points:"217.5 261.5 225.5 269.5 228.5 265.5 248.5 285.5 224.5 311.5 194.5 283.5 217.5 261.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3711","data-name":"3711",points:"119.5 248.5 135.5 232.5 162.5 261.5 141.5 280.5 123.5 261.5 127.5 256.5 119.5 248.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3712","data-name":"3712",points:"86.5 222.5 105.5 204.5 135.5 232.5 110.5 256.5 92.5 236.5 96.5 232.5 86.5 222.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3713","data-name":"3713",points:"80.5 118.5 98.5 99.5 102.5 103.5 112.5 93.5 135.5 116.5 105.5 145.5 80.5 118.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3714","data-name":"3714",points:"133.5 78.5 138.5 82.5 146.5 74.5 160.5 89.5 135.5 116.5 116 95.5 133.5 78.5"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"two-bedroom",className:shouldDisplayByType("two-bedroom")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3716","data-name":"3716",points:"157.5 47.5 168.5 38.5 171.5 41.5 180.5 32.5 198.5 51.5 180.5 69.5 157.5 47.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3715","data-name":"3715",points:"140.5 66.5 150.5 56.5 153.5 59.5 161.2 51 180.5 69.5 160.5 89.5 140.5 66.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3710","data-name":"3710",points:"157.5 301.5 147.5 290.5 150.5 288.5 142.5 280.5 162.5 261.5 180.5 280.5 157.5 301.5"}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("polygon",{id:"_3709","data-name":"3709",points:"198.5 298.5 178.5 321.5 165.5 310.5 170.5 306.5 161.5 297.8 180.5 280.5 198.5 298.5"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"en",className:shouldDisplayByLang("en")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(194.3 183.7)","font-size":"10",fill:"#58595b","font-family":"Termina-Bold, Termina Bold","font-weight":"700"},"7th ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{x:"16.1",y:"0","letter-spacing":"-0.02em"},"F"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{x:"20.8",y:"0"},"loor")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(238.6 85)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3701"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(209.4 114.3)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3702"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(181.6 142)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3703"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(153.6 170)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3704"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(153.6 186.5)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3705"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(181 213.9)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3706"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(208.8 241.6)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3707"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(237.5 270.4)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3708"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(152.8 318.1)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3709"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(134.9 300.3)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3710"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(111.6 277)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3711"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(84.1 249.5)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3712"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(81.4 102.5)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3713"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(107.9 76)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3714"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(130.4 53.5)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3715"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(149.1 34.8)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3716")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"cn",className:shouldDisplayByLang("cn")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(194.4 183.3)","font-size":"10",fill:"#58595b","font-family":"Termina-Bold, Termina Bold"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{"font-weight":"700"},"7"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tspan",{x:"5.1",y:"0","font-family":"STHeitiTC-Medium, STHeitiTC Medium"},"\u697C")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(238.6 85)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3701"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(209.4 114.3)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3702"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(181.6 142)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3703"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(153.6 170)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3704"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(153.6 186.5)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3705"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(181 213.9)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3706"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(208.8 241.6)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3707"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(237.5 270.4)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3708"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(152.8 318.1)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3709"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(134.9 300.3)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3710"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(111.6 277)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3711"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(84.1 249.5)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3712"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(81.4 102.5)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3713"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(107.9 76)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3714"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(130.4 53.5)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3715"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(149.1 34.8)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3716")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"ru",className:shouldDisplayByLang("ru")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(194.1 184.2)","font-size":"11",fill:"#58595b","font-family":"Helvetica-Bold, Helvetica","font-weight":"700"},"7-\u0419 \u042D\u0422\u0410\u0416"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(238.6 85)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3701"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(209.4 114.3)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3702"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(181.6 142)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3703"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(153.6 170)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3704"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(153.6 186.5)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3705"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(181 213.9)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3706"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(208.8 241.6)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3707"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(237.5 270.4)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3708"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(152.8 318.1)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3709"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(134.9 300.3)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3710"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(111.6 277)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3711"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(84.1 249.5)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3712"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(81.4 102.5)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3713"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(107.9 76)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3714"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(130.4 53.5)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3715"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(149.1 34.8)","font-size":"5.88",fill:"#808184","font-family":"Helvetica, Helvetica"},"3716"))));});

/***/ }),
/* 986 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/7.320eb2ef.png";

/***/ }),
/* 987 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__8_png__ = __webpack_require__(988);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__8_png___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1__8_png__);
// import _ from 'lodash'
// import MultiLineText from './MultiLineText';
/* unused harmony default export */ var _unused_webpack_default_export = (function(_ref){var currentLang=_ref.currentLang,selectedType=_ref.selectedType;var shouldDisplayByLang=function shouldDisplayByLang(selectLang){return currentLang===selectLang?"display":"display-none";};var shouldDisplayByType=function shouldDisplayByType(type){return selectedType===type||selectedType==="all"?"display":"display-none";};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 330 360",className:"site-plan-svg"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"map"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("image",{xlinkHref:__WEBPACK_IMPORTED_MODULE_1__8_png___default.a,height:"100%",width:"100%"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"en",className:shouldDisplayByLang("en")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(193.9 183.3)","font-size":"9.6",fill:"#58595b","font-family":"Termina-Bold, Termina Bold","font-weight":"700"},"Roofop Floor")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"cn",className:shouldDisplayByLang("cn")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(193.2 183.3)","font-size":"10",fill:"#58595b","font-family":"STHeitiTC-Medium, STHeitiTC Medium"},"\u5929\u53F0")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"ru",className:shouldDisplayByLang("ru")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("text",{transform:"translate(193.9 184.2)","font-size":"11",fill:"#58595b","font-family":"Helvetica-Bold, Helvetica","font-weight":"700"},"\u041A\u0420\u042B\u0428\u0410"))));});

/***/ }),
/* 988 */
/***/ (function(module, exports) {

module.exports = "data:image/png;base64,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"

/***/ }),
/* 989 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(2);
// import _ from 'lodash'
// import MultiLineText from './MultiLineText';
/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var currentLang=_ref.currentLang,handleClick=_ref.handleClick;var shouldDisplayByLang=function shouldDisplayByLang(selectLang){return currentLang===selectLang?"display":"display-none";};return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{xmlns:"http://www.w3.org/2000/svg"// viewBox="0 0 258.4 258.4"
,className:"allfloor-of-unitplan"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"text"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"cn",className:shouldDisplayByLang("cn")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("image",{xlinkHref:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* assetsPath */])("phuket-skypark")+"/images/siteplan/cn.png",height:"100%",width:"100%"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"ru",className:shouldDisplayByLang("ru")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("image",{xlinkHref:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* assetsPath */])("phuket-skypark")+"/images/siteplan/ru.png",height:"100%",width:"100%"})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"en",className:shouldDisplayByLang("en")},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("image",{xlinkHref:Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* assetsPath */])("phuket-skypark")+"/images/siteplan/en.png",height:"100%",width:"100%"}))));});

/***/ }),
/* 990 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_styled_components__ = __webpack_require__(27);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _templateObject=_taggedTemplateLiteral(["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-transform: uppercase;\n  font-size: 30px;\n"],["\n  width: 100%;\n  height: 100%;\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  text-transform: uppercase;\n  font-size: 30px;\n"]);function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _taggedTemplateLiteral(strings,raw){return Object.freeze(Object.defineProperties(strings,{raw:{value:Object.freeze(raw)}}));}var Div=__WEBPACK_IMPORTED_MODULE_1_styled_components__["b" /* default */].div(_templateObject);var ComingSoon=function(_Component){_inherits(ComingSoon,_Component);function ComingSoon(){_classCallCheck(this,ComingSoon);return _possibleConstructorReturn(this,(ComingSoon.__proto__||Object.getPrototypeOf(ComingSoon)).apply(this,arguments));}_createClass(ComingSoon,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(Div,null,"Coming Soon");}}]);return ComingSoon;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (ComingSoon);

/***/ }),
/* 991 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(2);
var landingPage=[{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])("phuket-skypark")+"/images/residence/landing-page/1.jpg"},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])("phuket-skypark")+"/images/residence/landing-page/2.jpg"},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])("phuket-skypark")+"/images/residence/landing-page/3.jpg"},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])("phuket-skypark")+"/images/residence/landing-page/4.jpg"}];var type=[{name:{en:"Studio",ru:"Студия",cn:"一卧开间"},thumbnail:[{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])("phuket-skypark")+"/images/residence/thumbnail/studio/1.jpg"},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])("phuket-skypark")+"/images/residence/thumbnail/studio/1.jpg"}],buttons:[{type:"description",value:0,name:"Description",title:"Description",description:{en:"<p>The intelligently-designed 29 sqm studio apartments offer all the modern conveniences to cater to long-term residents and visiting guests.</p>",cn:"<p>智能设计的29平方米一卧开间可提供所有现代化的便利设施，以满足长住业主和来访客人的需求。</p>",ru:"<p>Умно спроектированные квартиры-студии площадью 29 кв.м предлагают все современные удобства как для постоянных жителей, так и гостей.</p>"},images:[{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])("phuket-skypark")+"/images/residence/description/studio/1.jpg"},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])("phuket-skypark")+"/images/residence/description/studio/2.jpg"},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])("phuket-skypark")+"/images/residence/description/studio/3.jpg"}]},{type:"plan",name:{en:"FLOOR PLAN",ru:"Планировка",cn:"户型图"},value:1,floorPlan:{en:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])("phuket-skypark")+"/images/residence/room-type/en/1a.jpg",ru:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])("phuket-skypark")+"/images/residence/room-type/ru/1a.jpg",cn:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])("phuket-skypark")+"/images/residence/room-type/cn/1a.jpg"},images:[{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])("phuket-skypark")+"/images/residence/residence/floor-plan/villa/ground-floor-(standard)/images/Villa_groundF.jpg"}]}]},{name:{en:"One-bedroom",ru:"Квартира с одной спальней",cn:"一卧开间"},thumbnail:[{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])("phuket-skypark")+"/images/residence/thumbnail/one-bedroom/1.jpg"},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])("phuket-skypark")+"/images/residence/thumbnail/one-bedroom/1.jpg"}],buttons:[{type:"description",value:0,name:"Description",title:"Description",description:{en:"<p>The one-bedroom apartments at Skypark offer between 30 to 39 sqm of calming space to relax and recharge in the comfortable living area and separate master bedroom.</p>",cn:"<p>海天苑的一卧套房为住客提供30至39平方米的安静空间，可在舒适的生活区和独立的主卧室充分放松和休整</p>",ru:"<p>Квартиры с одной спальней в Skypark площадью от 30 до 39 кв.м предлагают пространства для отдыха и перезарядки в уютной гостиной и отдельной главной спальне.</p>"},images:[{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])("phuket-skypark")+"/images/residence/description/one-bedroom/1.jpg"},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])("phuket-skypark")+"/images/residence/description/one-bedroom/2.jpg"},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])("phuket-skypark")+"/images/residence/description/one-bedroom/3.jpg"}]},{type:"plan",name:{en:"FLOOR PLAN",ru:"Планировка",cn:"户型图"},value:1,floorPlan:{en:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])("phuket-skypark")+"/images/residence/room-type/en/1cx.jpg",ru:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])("phuket-skypark")+"/images/residence/room-type/ru/1cx.jpg",cn:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])("phuket-skypark")+"/images/residence/room-type/cn/1cx.jpg"},images:[{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])("phuket-skypark")+"/images/residence/residence/floor-plan/villa/ground-floor-(standard)/images/Villa_groundF.jpg"}],image360:[],imageVirtual:[]}]},{name:{en:"Two-bedroom",ru:"Квартира с двумя спальнями",cn:"二卧室套房"},thumbnail:[{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])("phuket-skypark")+"/images/residence/thumbnail/two-bedroom/1.jpg"},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])("phuket-skypark")+"/images/residence/thumbnail/two-bedroom/1.jpg"}],buttons:[{type:"description",value:0,name:"Description",title:"Description",description:{en:"<p>The spacious homes at Skypark range from 40 to 60 sqm and feature two separate bedrooms that can also be opened up to form one flowing space with the living room to suit moments of live, work, and rest.</p>",cn:"<p>海天苑的宽敞二卧室套房面积从40平方米到60平方米不等，配有两个独立的卧室，也可以与客厅打通，形成一个流动空间，以适应生活、工作和休息的需要。</p>",ru:"<p>Просторные квартиры в Skypark варьируются от 40 до 60 кв.м и имеют две отдельные спальни и гостиную, для различных моментов жизни, работы и отдыха.</p>"},images:[{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])("phuket-skypark")+"/images/residence/description/two-bedroom/1.jpg"},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])("phuket-skypark")+"/images/residence/description/two-bedroom/2.jpg"},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])("phuket-skypark")+"/images/residence/description/two-bedroom/3.jpg"}]},{type:"plan",name:{en:"FLOOR PLAN",ru:"Планировка",cn:"户型图"},value:5,floorPlan:{en:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])("phuket-skypark")+"/images/residence/room-type/en/2b1.jpg",ru:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])("phuket-skypark")+"/images/residence/room-type/ru/2b1.jpg",cn:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])("phuket-skypark")+"/images/residence/room-type/cn/2b1.jpg"},images:[{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])("phuket-skypark")+"/images/residence/residence/floor-plan/villa/ground-floor-(standard)/images/Villa_groundF.jpg"}],image360:[],imageVirtual:[]}]}];/* harmony default export */ __webpack_exports__["a"] = ({landingPage:landingPage,type:type});

/***/ }),
/* 992 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(2);
var landingPage=[{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+'/images/destination/landing-page/1.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+'/images/destination/landing-page/2.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+'/images/destination/landing-page/3.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+'/images/destination/landing-page/4.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+'/images/destination/landing-page/5.jpg'}];var map=[{value:"country",name:"Country Map",image:{en:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+'/images/destination/country-map/map-country_en.png',cn:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+'/images/destination/country-map/map-country_cn.png',ru:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+'/images/destination/country-map/map-country_ru.png'}},{value:"city",name:"City Map",images:[{name:"Airport",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])()+'/images/icon/map-icon-01.png',image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+'/images/destination/city-map/airport.png'},{name:"Beaches",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])()+'/images/icon/map-icon-02.png',image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+'/images/destination/city-map/beach.png'},{name:"Islands",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])()+'/images/icon/map-icon-03.png',image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+'/images/destination/city-map/island.png'},{name:"Schools",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])()+'/images/icon/map-icon-05.png',image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+'/images/destination/city-map/school.png'},{name:"Tourist Attractions",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])()+'/images/icon/map-icon-06.png',image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+'/images/destination/city-map/tourist-attraction.png'}]},{value:"project",name:"Project Map",images:[{name:"Hotels & Resorts",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])()+'/images/icon/project-icon-01.png',svg:null},{name:"Restaurants",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])()+'/images/icon/project-icon-02.png',svg:null},{name:"Spas",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])()+'/images/icon/project-icon-03.png',svg:null},{name:"Galleries & Shopping",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])()+'/images/icon/project-icon-04.png',svg:null},{name:"Shuttle Bus",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])()+'/images/icon/project-icon-05.png',svg:null},{name:"Shuttle Boat",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])()+'/images/icon/project-icon-06.png',svg:null}]}];var content={title:"Destination",description:{en:"<p>Surrounded by the turquoise waters of the Andaman Sea and fringed by golden shores, Phuket is an island that compels travelers to visit from around the world.<br><br>Reaching Phuket is easy with direct flights from main cities around the world.The island is also linked to Thailand’s mainland by road.<br><br>Laguna Phuket itself is located in a prime west coast area of Phuket with proximity to an abundance of facilities. Local shopping malls, international schools and world-class hospitals are all close by, while Phuket’s international airport can be reached by car in just 25 minutes.<p>",cn:"<p>乐古浪普吉岛被金色海岸紧紧包围，四周萦绕着绿松石般的海水，这座岛屿吸引着世界各地的游客纷至沓来。<br><br>普吉岛的交通十分便捷，从世界主要城市搭乘直飞航班即可抵达。这里与泰国主岛相连，通过汽车或船只都可轻松到达。<br><br>乐古浪普吉岛位于普吉岛的西海岸，现代设施齐全。购物中心，国际学校，世界级医院随手可得，驱车25分钟即可到达普吉岛国际机场。<p>",ru:"<p>Остров Пхукет, окруженный лазурными водами Андаманского моря, омывающими золотистые песчаные пляжи, манит к себе путешественников со всего мира.<br><br>Добраться до острова очень просто: вылететь прямым рейсом можно из крупных городов разных стран. Из материковой части Таиланда сюда можно доехать на автомобиле по шоссейной дороге.<br><br>Курортный комплекс Laguna Phuket расположен на элитном западном побережье Пхукета. В непосредственной близости находится вся необходимая инфраструктура: торговые галереи, международные школы, больницы мирового уровня. До международного аэропорта Пхукета 25 минут езды на автомобиле.<p>"}};/* harmony default export */ __webpack_exports__["a"] = ({landingPage:landingPage,map:map,content:content});

/***/ }),
/* 993 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(2);
/* harmony default export */ __webpack_exports__["a"] = ({title:"The Santuary Club",description:{en:"Experience ultimate lifestyle within worldwide network under the Banyan Group. Membership is exclusively offered to the owners of Laguna, Banyan Tree, Angsana and Cassia properties only.",cn:"体验悦榕集团全球网络内的终极生活方式。仅向乐古浪、悦榕庄、悦椿和悦梿物业的业主提供会员权益。",ru:"Наслаждайтесь роскошным стилем жизни, пользуясь глобальной сетью компании Banyan Group. Членство предлагается только владельцам собственности в рамках проектов Laguna, Banyan Tree, Angsana и Cassia."},image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])("phuket-skypark")+"/images/the-sanctuary-club/image.jpg"});

/***/ }),
/* 994 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Gallery; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Gallery=function(_Component){_inherits(Gallery,_Component);function Gallery(){_classCallCheck(this,Gallery);return _possibleConstructorReturn(this,(Gallery.__proto__||Object.getPrototypeOf(Gallery)).apply(this,arguments));}_createClass(Gallery,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common__["e" /* Gallery */],this.props);}}]);return Gallery;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 995 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Concept; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Concept=function(_Component){_inherits(Concept,_Component);function Concept(){_classCallCheck(this,Concept);return _possibleConstructorReturn(this,(Concept.__proto__||Object.getPrototypeOf(Concept)).apply(this,arguments));}_createClass(Concept,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common__["a" /* Concept */],this.props);}}]);return Concept;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 996 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Faq; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Faq=function(_Component){_inherits(Faq,_Component);function Faq(){_classCallCheck(this,Faq);return _possibleConstructorReturn(this,(Faq.__proto__||Object.getPrototypeOf(Faq)).apply(this,arguments));}_createClass(Faq,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common__["d" /* Faq */],this.props);}}]);return Faq;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 997 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Destination; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(4);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components_Bubble__ = __webpack_require__(368);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Destination=function(_Component){_inherits(Destination,_Component);function Destination(){_classCallCheck(this,Destination);return _possibleConstructorReturn(this,(Destination.__proto__||Object.getPrototypeOf(Destination)).apply(this,arguments));}_createClass(Destination,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common__["b" /* Destination */],Object.assign({},this.props,{project:"skypark",projectMapChildren:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{transform:"translate(1350, 860)"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("g",{id:"skypark-bubble-masterplan"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components_Bubble__["a" /* default */],null)))}));}}]);return Destination;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 998 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TheSanctuaryclub; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TheSanctuaryclub=function(_Component){_inherits(TheSanctuaryclub,_Component);function TheSanctuaryclub(){_classCallCheck(this,TheSanctuaryclub);return _possibleConstructorReturn(this,(TheSanctuaryclub.__proto__||Object.getPrototypeOf(TheSanctuaryclub)).apply(this,arguments));}_createClass(TheSanctuaryclub,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common__["g" /* TheSanctuaryclub */],this.props);}}]);return TheSanctuaryclub;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 999 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Siteplan; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_findIndex__ = __webpack_require__(100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_findIndex___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_findIndex__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_find__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hoc__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__components_icons_ArrowRight__ = __webpack_require__(103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_icons_ArrowLeft__ = __webpack_require__(102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__components_popup__ = __webpack_require__(1000);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Siteplan=(_dec=Object(__WEBPACK_IMPORTED_MODULE_6__hoc__["a" /* multiLanguage */])(),_dec(_class=function(_Component){_inherits(Siteplan,_Component);function Siteplan(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Siteplan);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Siteplan.__proto__||Object.getPrototypeOf(Siteplan)).call.apply(_ref,[this].concat(args))),_this),_this.state={openModal:false,selectedType:"all",pageModal:"1st",selectedSubTab:"all",pageModalSiteplan:"",pageModalData:null,popupHover:"",width:window.innerWidth},_this.hover=function(){var allEl=document.querySelectorAll("#floorplan path, #floorplan polygon, #floorplan rect");for(var i=0;i<allEl.length;i+=1){allEl[i].addEventListener("mouseover",_this.handleUnitHover);}},_this.unhover=function(){var allEl=document.querySelectorAll("#floorplan path, #floorplan polygon, #floorplan rect");for(var i=0;i<allEl.length;i+=1){allEl[i].addEventListener("mouseout",_this.handleUnitUnHover);}},_this.handleUnitUnHover=function(e){_this.setState({popupHover:""});},_this.handleUnitHover=function(e){var currentHoverType=e.target.parentElement.id;_this.setState({popupHover:currentHoverType});},_this.componentDidMount=function(){window.addEventListener("resize",_this.updateDimensions);_this.updateDimensions();},_this.updateDimensions=function(){var width=_this.state.width;_this.setState({width:window.innerWidth});},_this.componentWillUnmount=function(){window.removeEventListener("resize",_this.updateDimensions);},_this.handleCloseModal=function(){_this.setState({openModal:false,selectedType:"all",pageModal:"1st",pageModalSiteplan:"",pageModalData:null});},_this.handleClickForOpenModal=function(pageModal){var dataSitePlan=_this.props.dataSitePlan;var findPageModalData=__WEBPACK_IMPORTED_MODULE_3_lodash_find___default()(dataSitePlan,function(_ref2){var value=_ref2.value;return value===pageModal;});_this.setState({openModal:true,selectedType:"all",pageModal:pageModal,pageModalData:findPageModalData||{}});},_this.handleSliderRight=function(){var dataSitePlan=_this.props.dataSitePlan;var pageModal=_this.state.pageModal;var sliderCurrentIndex=__WEBPACK_IMPORTED_MODULE_2_lodash_findIndex___default()(dataSitePlan,function(_ref3){var value=_ref3.value;return value===pageModal;});var lastDataSitePlanIndex=dataSitePlan.length-1;var sliderNextIndex=sliderCurrentIndex===lastDataSitePlanIndex?0:sliderCurrentIndex+1;var nextModal=__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(dataSitePlan,[sliderNextIndex]);var nextPageModal=__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(nextModal,"value");_this.setState({pageModal:nextPageModal,pageModalData:nextModal||{}});},_this.handleSliderLeft=function(){var dataSitePlan=_this.props.dataSitePlan;var pageModal=_this.state.pageModal;var sliderCurrentIndex=__WEBPACK_IMPORTED_MODULE_2_lodash_findIndex___default()(dataSitePlan,function(_ref4){var value=_ref4.value;return value===pageModal;});var lastDataSitePlanIndex=dataSitePlan.length-1;var sliderNextIndex=sliderCurrentIndex===0?lastDataSitePlanIndex:sliderCurrentIndex-1;var nextModal=__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(dataSitePlan,[sliderNextIndex]);var nextPageModal=__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(nextModal,"value");_this.setState({pageModal:nextPageModal,pageModalData:nextModal||{}});},_this.handleChangeType=function(selectedType){_this.setState({selectedType:selectedType});},_this.handleChangeSubTab=function(selectedSubTab){_this.setState({selectedSubTab:selectedSubTab});},_this.handleBlock=function(valueBlock){var pageModal=_this.state.pageModal;var dataSitePlan=_this.props.dataSitePlan;var findPageModalData=__WEBPACK_IMPORTED_MODULE_3_lodash_find___default()(dataSitePlan,function(_ref5){var value=_ref5.value;return value===pageModal;});_this.setState({pageModalData:findPageModalData||{},selectedSubTab:valueBlock});},_this.renderPopup=function(){var _this$props=_this.props,descriptions=_this$props.descriptions,t=_this$props.t;var popupHover=_this.state.popupHover;var mapHoverData=__WEBPACK_IMPORTED_MODULE_0_lodash_map___default()(descriptions,function(item){var getTypePopup=__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item,"value");var getDataPopup=__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(item,"title");var activePopup=getTypePopup===popupHover?"active":"";return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__components_popup__["a" /* default */],{title:getTypePopup,data:t(getDataPopup),active:activePopup,onclick:_this.handleUnitHover});});return mapHoverData;},_this.renderAllFloor=function(){var _this$state=_this.state,selectedSubTab=_this$state.selectedSubTab,selectedType=_this$state.selectedType,pageModalData=_this$state.pageModalData,width=_this$state.width;var _this$props2=_this.props,subTabs=_this$props2.subTabs,currentLanguage=_this$props2.currentLanguage,t=_this$props2.t;var CurrentBlocks=function CurrentBlocks(){return null;};var showImg=__WEBPACK_IMPORTED_MODULE_3_lodash_find___default()(subTabs,function(_ref6){var value=_ref6.value;return value===selectedSubTab;});var mapElement=__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(pageModalData,"floorPlan."+selectedSubTab,null);if(mapElement){CurrentBlocks=mapElement;}else{if(showImg){CurrentBlocks=showImg.img;}}return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react__["Fragment"],null,_this.renderPopup(),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(CurrentBlocks,{currentLang:currentLanguage,selectedSubTab:selectedSubTab,selectedType:selectedType,handleClick:function handleClick(selectedModal){_this.handleClickForOpenModal(selectedModal);}}),selectedSubTab!=="all"&&__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",{className:"siteplan-button-group-subtabs"},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components__["c" /* ButtonGroup */],{value:selectedType,items:pageModalData.buttons,onChange:function onChange(value){_this.setState({selectedType:value,popupHover:value});setTimeout(function(){_this.setState({popupHover:""});},10000);},direction:width<992?"horizontal":"vertical",renderItem:function renderItem(_ref7){var value=_ref7.value,title=_ref7.title,active=_ref7.active,onClick=_ref7.onClick;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components__["b" /* Button */],{key:value,type:"secondary",active:active,activeStyle:{backgroundColor:"#00a9a5"},hoverStyle:{backgroundColor:"#00a9a5"},defaultStyle:{padding:"12px 17px",marginRight:"2px",fontWeight:"bold",fontSize:"13px",letterSpacing:"1px"},onClick:onClick},t(title));}})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",{className:"button-slider"},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("button",{onClick:_this.handleSliderLeft,className:"button-scroll-to-section left"},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_icons_ArrowLeft__["a" /* default */],{width:40,height:40,fill:"#04a8a6"})),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("button",{onClick:_this.handleSliderRight,className:"button-scroll-to-section right"},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__components_icons_ArrowRight__["a" /* default */],{width:40,height:40,fill:"#04a8a6"})))));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Siteplan,[{key:"componentDidUpdate",value:function componentDidUpdate(){this.hover();this.unhover();}},{key:"render",value:function render(){var _this2=this;var _props=this.props,t=_props.t,currentLanguage=_props.currentLanguage,page=_props.page,subTabs=_props.subTabs;var _state=this.state,pageModalData=_state.pageModalData,selectedSubTab=_state.selectedSubTab;// loop สร้าง siteplan ตาม floor และเมื่อคลิก floor ให้โชว์ popup 3 menu คลิก menu ไหนให้ filter โชว์แค่อันนั้น
// const CurrentBuildingPlan = _.get(pageModalData, `floorPlan.${currentLanguage}`);
var CurrentBuildingPlan=function CurrentBuildingPlan(){return null;};if(pageModalData){CurrentBuildingPlan=pageModalData.floorPlan[selectedSubTab];}// var MyComponent = Components[type + "Component"];
// return React.createElement(MyComponent, {});
return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",{className:"section-siteplan "+page+" site-plan-has-menu"},this.renderAllFloor(),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",{className:"siteplan-container-buttongroup"},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components__["c" /* ButtonGroup */],{value:selectedSubTab,items:subTabs,direction:"horizontal",renderItem:function renderItem(_ref8){var value=_ref8.value,title=_ref8.title,showModal=_ref8.showModal,active=_ref8.active,onClick=_ref8.onClick;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components__["b" /* Button */],{key:value,type:"secondary",active:active,activeStyle:{backgroundColor:"#00a9a5"},hoverStyle:{backgroundColor:"#00a9a5"},defaultStyle:{padding:"12px 17px",marginRight:"2px",fontWeight:"bold",fontSize:"13px",letterSpacing:"1px"},onClick:function onClick(){if(showModal===true){_this2.handleClickForOpenModalSiteplan(value);}else{_this2.handleBlock(value);}}},t(title)));}})));}}]);return Siteplan;}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]))||_class);

/***/ }),
/* 1000 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components_icons_Close__ = __webpack_require__(101);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var popup=function(_Component){_inherits(popup,_Component);function popup(){_classCallCheck(this,popup);return _possibleConstructorReturn(this,(popup.__proto__||Object.getPrototypeOf(popup)).apply(this,arguments));}_createClass(popup,[{key:"render",value:function render(){var _props=this.props,data=_props.data,title=_props.title,active=_props.active,onclick=_props.onclick;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"popup "+active},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,title),data,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"button-close-popup"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{onClick:onclick,className:"button-scroll-to-section close"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components_icons_Close__["a" /* default */],{width:20,height:20,fill:"#04a8a6"}))));}}]);return popup;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (popup);

/***/ }),
/* 1001 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Masterplan; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_includes__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_filter__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_reject__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_reject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_reject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_animejs__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_animejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_animejs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__containers_ProjectMap_PhuketMasterplan__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_ProjectMap_common_logos__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__hoc__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__utils_navigation__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils_detector__ = __webpack_require__(56);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_scroll__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_react_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_react_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__components_Bubble__ = __webpack_require__(368);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import styled, { keyframes } from "styled-components";
// Filter LVR logo
var logos=__WEBPACK_IMPORTED_MODULE_3_lodash_reject___default()(__WEBPACK_IMPORTED_MODULE_7__containers_ProjectMap_common_logos__["a" /* default */],function(logo){return logo.key==="phuket-skypark";});// const bounce = keyframes`
//   0% {
//     transform: scale(0);
//   }
//   20% {
//     transform: scale(1);
//   }
//   40% {
//     transform: scale(0.7);
//   }
//   60% {
//     transform: scale(1);
//   }
//   100% {
//     transform: scale(1);
//   }
// `;
// const AnimatedBubble = styled.g`
//   cursor: pointer;
//   animation-name: ${bounce};
//   animation-duration: 3s;
//   animation-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);
//   animation-iteration-count: infinite;
// `;
var filterTexts=function filterTexts(texts){return __WEBPACK_IMPORTED_MODULE_2_lodash_filter___default()(texts,function(text,i){var excludeList=__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(text,"options.excludes",[]);if(__WEBPACK_IMPORTED_MODULE_0_lodash_includes___default()(excludeList,"lpark2/masterplan")||__WEBPACK_IMPORTED_MODULE_0_lodash_includes___default()(excludeList,"masterplan"))return false;return true;});};var fixIETransform=function fixIETransform(id){return function(anim){var g=document.getElementById(id);if(g){var transform=getComputedStyle(g).getPropertyValue("transform");g.setAttribute("transform",transform);}};};var Masterplan=(_dec=Object(__WEBPACK_IMPORTED_MODULE_8__hoc__["a" /* multiLanguage */])(),_dec(_class=function(_Component){_inherits(Masterplan,_Component);function Masterplan(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Masterplan);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Masterplan.__proto__||Object.getPrototypeOf(Masterplan)).call.apply(_ref,[this].concat(args))),_this),_this.handleClickBubble=function(){// go to master plan
var headerHeight=Object(__WEBPACK_IMPORTED_MODULE_9__utils_navigation__["a" /* getHeaderHeight */])();__WEBPACK_IMPORTED_MODULE_11_react_scroll__["scroller"].scrollTo("siteplan",{duration:1500,smooth:true,offset:-headerHeight});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Masterplan,[{key:"componentDidMount",value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_5_animejs___default()({targets:"#skypark-bubble",scale:[{value:0,duration:0,elasticity:0},{value:1,duration:2000,elasticity:400}],loop:true,update:__WEBPACK_IMPORTED_MODULE_10__utils_detector__["a" /* isIE */]?fixIETransform("skypark-bubble"):null});}},{key:"render",value:function render(){var _props=this.props,t=_props.t,currentLanguage=_props.currentLanguage;// console.log('filterTexts >>> ', filterTexts);
return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",{className:"section-masterplan"},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__containers_ProjectMap_PhuketMasterplan__["a" /* default */],{activeLanguage:currentLanguage,filterTexts:filterTexts},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("g",{transform:"translate(560, 460)"},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("g",{id:"skypark-bubble",onClick:this.handleClickBubble},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__components_Bubble__["a" /* default */],null)))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",{className:"masterplan-name skypark"},t("Master Plan")));}}]);return Masterplan;}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]))||_class);

/***/ }),
/* 1002 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Residences; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Residences=function(_Component){_inherits(Residences,_Component);function Residences(){_classCallCheck(this,Residences);return _possibleConstructorReturn(this,(Residences.__proto__||Object.getPrototypeOf(Residences)).apply(this,arguments));}_createClass(Residences,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common__["f" /* Residences */],this.props);}}]);return Residences;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 1003 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Ebrochure; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Ebrochure=function(_Component){_inherits(Ebrochure,_Component);function Ebrochure(){_classCallCheck(this,Ebrochure);return _possibleConstructorReturn(this,(Ebrochure.__proto__||Object.getPrototypeOf(Ebrochure)).apply(this,arguments));}_createClass(Ebrochure,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common__["c" /* Ebrochure */],this.props);}}]);return Ebrochure;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 1004 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "category", function() { return category; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faqs", function() { return faqs; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var category=[{id:1,name:"Legal",displayOn:["en","cn","ru"]},{id:2,name:"Construction",displayOn:["en","cn","ru"]},{id:3,name:"Estate and property management",displayOn:["en","cn","ru"]},{id:4,name:"Owner benefits",displayOn:["en","cn","ru"]},{id:5,name:"Financing",displayOn:["en","cn","ru"]}];var faqs=[{categoryId:1,question:{en:"What types of ownership are available?",ru:"Какая форма собственности предоставляется?",cn:"产权有哪些类型？"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"A.")," Condominiums are available on a freehold basis for both Thai and non-Thai buyers. However, according to current Thai law, non-Thais may only purchase up to 49% of the condominium\u2019s saleable area on a freehold basis. Otherwise, they may purchase any remaining units on a renewable leasehold basis (currently for a maximum period of 30 years as permitted by law).")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"O.")," \u041F\u043E\u043B\u043D\u043E\u0435 \u043F\u0440\u0430\u0432\u043E \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438 (freehold) \u043D\u0430 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u044C \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u043E \u0434\u043B\u044F \u043F\u043E\u043A\u0443\u043F\u0430\u0442\u0435\u043B\u0435\u0439, \u043A\u0430\u043A \u044F\u0432\u043B\u044F\u044E\u0449\u0438\u0445\u0441\u044F, \u0442\u0430\u043A \u0438 \u043D\u0435 \u044F\u0432\u043B\u044F\u044E\u0449\u0438\u0445\u0441\u044F \u0433\u0440\u0430\u0436\u0434\u0430\u043D\u0430\u043C\u0438 \u0422\u0430\u0438\u043B\u0430\u043D\u0434\u0430. \u041E\u0434\u043D\u0430\u043A\u043E, \u0441\u043E\u0433\u043B\u0430\u0441\u043D\u043E \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0449\u0435\u043C\u0443 \u0442\u0430\u0439\u0441\u043A\u043E\u043C\u0443 \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0443, \u043B\u0438\u0446\u0430, \u043D\u0435 \u044F\u0432\u043B\u044F\u044E\u0449\u0438\u0435\u0441\u044F \u0433\u0440\u0430\u0436\u0434\u0430\u043D\u0430\u043C\u0438 \u0422\u0430\u0438\u043B\u0430\u043D\u0434\u0430, \u043C\u043E\u0433\u0443\u0442 \u043F\u0440\u0438\u043E\u0431\u0440\u0435\u0441\u0442\u0438 \u0442\u043E\u043B\u044C\u043A\u043E \u0434\u043E 49% \u0432\u044B\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u043D\u043E\u0439 \u043D\u0430 \u043F\u0440\u043E\u0434\u0430\u0436\u0443 \u043F\u043B\u043E\u0449\u0430\u0434\u0438 \u0441 \u043F\u043E\u043B\u043D\u044B\u043C \u043F\u0440\u0430\u0432\u043E\u043C \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438. \u041F\u0440\u0438 \u044D\u0442\u043E\u043C \u043E\u0441\u0442\u0430\u0432\u0448\u0430\u044F\u0441\u044F \u0447\u0430\u0441\u0442\u044C \u043F\u043B\u043E\u0449\u0430\u0434\u0438 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u043F\u0440\u0438\u043E\u0431\u0440\u0435\u0442\u0435\u043D\u0430 \u043D\u0430 \u043E\u0441\u043D\u043E\u0432\u0435 \u0434\u043E\u043B\u0433\u043E\u0441\u0440\u043E\u0447\u043D\u043E\u0439 \u0430\u0440\u0435\u043D\u0434\u044B (leasehold) \u0441 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u044C\u044E \u043F\u0440\u043E\u0434\u043B\u0435\u043D\u0438\u044F, \u043D\u0430 \u0434\u0430\u043D\u043D\u044B\u0439 \u043C\u043E\u043C\u0435\u043D\u0442 \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u044B\u0439 \u0441\u0440\u043E\u043A, \u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u043D\u044B\u0439 \u0437\u0430\u043A\u043E\u043D\u043E\u043C, \u0441\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 30 \u043B\u0435\u0442.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u7B54.")," ","\u6CF0\u56FD\u56FD\u7C4D\u4E0E\u975E\u6CF0\u56FD\u56FD\u7C4D\u4E70\u5BB6\u90FD\u53EF\u4EE5\u6301\u6709\u516C\u5BD3\u3002\u7136\u800C\uFF0C\u6839\u636E\u76EE\u524D\u7684\u6CF0\u56FD\u6CD5\u5F8B\uFF0C\u975E\u6CF0\u56FD\u56FD\u7C4D\u4E70\u5BB6\u53EF\u6301\u6709\u4E00\u4E2A\u516C\u5BD3\u9879\u76EE\u7684\u6C38\u4E45\u4E1A\u6743\u4E0D\u5F97\u8D85\u8FC7\u53EF\u9500\u552E\u9762\u79EF\u768449%\u3002\u9664\u6B64\u4EE5\u5916\uFF0C\u4ED6\u4EEC\u53EF\u4EE5\u7528\u8D2D\u4E70\u53EF\u7EED\u79DF\u79DF\u8D41\u4EA7\u6743\u7684\u5F62\u5F0F\u62E5\u6709\u5269\u4F59\u989D\u5EA6\u7684\u5355\u4F4D\uFF08\u76EE\u524D\u6CD5\u5F8B\u89C4\u5B9A\u6700\u957F\u7684\u79DF\u8D41\u671F\u9650\u4E3A\uFF09\u3002"))}},{categoryId:1,question:{en:"What are the costs associated with the lease / freehold registration?",ru:"Какова стоимость регистрации долгосрочной аренды (лизхолда)?",cn:"租赁登记的相关费用有哪些？"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Lease registration fees and stamp duty (currently 1.1% of the lease premium) is payable to the Land Department upon registration of the lease. The cost of lease renewals will be borne by the lessee according to the contracts."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Freehold registration fees (currently 2.0% of the appraisal price) is payable to the Land Department upon transfer and registration of title. The appraisal price is assessed by the Thailand\u2019s Treasury Department which is generally below market value. Other applicable taxes upon transfer and registration of freehold title are:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Corporate Income Withholding Tax")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"(currently 1.0% of the selling price or appraisal price, whichever is higher)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Specific Business Tax")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"(currently 3.3% of the selling price or appraisal price, whichever is higher)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"The burden between seller and buyer for the above costs will be specified in the relevant agreements."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"Note: Applicable rates stated are current and may be subject to change.")))),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0421\u0431\u043E\u0440 \u0437\u0430 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044E \u0434\u043E\u043B\u0433\u043E\u0441\u0440\u043E\u0447\u043D\u043E\u0439 \u0430\u0440\u0435\u043D\u0434\u044B \u0438 \u0433\u043E\u0441\u0443\u0434\u0430\u0440\u0441\u0442\u0432\u0435\u043D\u043D\u0430\u044F \u043F\u043E\u0448\u043B\u0438\u043D\u0430 (\u0432 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0435 \u0432\u0440\u0435\u043C\u044F \u0441\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 1,1% \u043E\u0442 \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u0438) \u0432\u044B\u043F\u043B\u0430\u0447\u0438\u0432\u0430\u044E\u0442\u0441\u044F \u0417\u0435\u043C\u0435\u043B\u044C\u043D\u043E\u043C\u0443 \u0434\u0435\u043F\u0430\u0440\u0442\u0430\u043C\u0435\u043D\u0442\u0443 \u043F\u0440\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438. \u041F\u0440\u043E\u0434\u043B\u0435\u043D\u0438\u0435 \u0434\u043E\u043B\u0433\u043E\u0441\u0440\u043E\u0447\u043D\u043E\u0439 \u0430\u0440\u0435\u043D\u0434\u044B \u043E\u043F\u043B\u0430\u0447\u0438\u0432\u0430\u0435\u0442\u0441\u044F \u0430\u0440\u0435\u043D\u0434\u0430\u0442\u043E\u0440\u043E\u043C \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u043C\u0438 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430. \u0420\u0430\u0441\u0445\u043E\u0434\u044B \u043D\u0430 \u043F\u0440\u043E\u0434\u043B\u0435\u043D\u0438\u0435 \u0430\u0440\u0435\u043D\u0434\u044B \u043D\u0435\u0441\u0435\u0442 \u0430\u0440\u0435\u043D\u0434\u0430\u0442\u043E\u0440."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041F\u043B\u0430\u0442\u0430 \u0437\u0430 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044E \u043F\u043E\u043B\u043D\u043E\u0433\u043E \u043F\u0440\u0430\u0432\u0430 \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438 (\u0432 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u0439 \u043C\u043E\u043C\u0435\u043D\u0442 2,0% \u043E\u0442 \u043E\u0446\u0435\u043D\u043E\u0447\u043D\u043E\u0439 \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u0438) \u0432\u044B\u043F\u043B\u0430\u0447\u0438\u0432\u0430\u0435\u0442\u0441\u044F \u0417\u0435\u043C\u0435\u043B\u044C\u043D\u043E\u043C\u0443 \u0414\u0435\u043F\u0430\u0440\u0442\u0430\u043C\u0435\u043D\u0442\u0443 \u043F\u043E\u0441\u043B\u0435 \u043F\u0435\u0440\u0435\u0434\u0430\u0447\u0438 \u0438 \u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u044F \u043F\u0440\u0430\u0432\u0430\u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438. \u041E\u0446\u0435\u043D\u043E\u0447\u043D\u0430\u044F \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C \u0440\u0430\u0441\u0441\u0447\u0438\u0442\u044B\u0432\u0430\u0435\u0442\u0441\u044F \u043F\u043E \u0433\u043E\u0441\u0443\u0434\u0430\u0440\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0439 \u0441\u0442\u0430\u0432\u043A\u0435 \u043D\u0430\u043B\u043E\u0433\u043E\u043E \u043B\u043E\u0436\u0435\u043D\u0438\u044F, \u0440\u0430\u0437\u043C\u0435\u0440 \u043A\u043E\u0442\u043E\u0440\u043E\u0439 \u043E\u0431\u044B\u0447\u043D\u043E \u043D\u0438\u0436\u0435 \u0440\u044B\u043D\u043E\u0447\u043D\u043E\u0439 \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u0438. \u0414\u0440\u0443\u0433\u0438\u0435 \u0432\u0437\u0438\u043C\u0430\u0435\u043C\u044B\u0435 \u043D\u0430\u043B\u043E\u0433\u0438 \u043F\u0440\u0438 \u043F\u0435\u0440\u0435\u0434\u0430\u0447\u0435 \u0438 \u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u0438 \u043F\u043E\u043B\u043D\u043E\u0433\u043E \u043F\u0440\u0430\u0432\u0430 \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u0432\u043A\u043B\u044E\u0447\u0430\u044E\u0442:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u041D\u0430\u043B\u043E\u0433 \u043D\u0430 \u0434\u043E\u0445\u043E\u0434\u044B \u044E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u0438\u0445 \u043B\u0438\u0446")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"(\u043D\u0430 \u0441\u0435\u0433\u043E\u0434\u043D\u044F\u0448\u043D\u0438\u0439 \u0434\u0435\u043D\u044C 1,0% \u043E\u0442 \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u0438 \u043F\u0440\u043E\u0434\u0430\u0436\u0438 \u0438\u043B\u0438 \u043E\u0446\u0435\u043D\u043E\u0447\u043D\u043E\u0439 \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u0438, \u0432 \u0437\u0430\u0432\u0438\u0441\u0438\u043C\u043E\u0441\u0442\u0438 \u043E\u0442 \u0442\u043E\u0433\u043E, \u043A\u0430\u043A\u0430\u044F \u0438\u0437 \u043D\u0438\u0445 \u0432\u044B\u0448\u0435)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u0421\u043F\u0435\u0446\u0438\u0430\u043B\u044C\u043D\u044B\u0439 \u043D\u0430\u043B\u043E\u0433 \u043D\u0430 \u043F\u0440\u0438\u0431\u044B\u043B\u044C")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"(\u043D\u0430 \u0441\u0435\u0433\u043E\u0434\u043D\u044F\u0448\u043D\u0438\u0439 \u0434\u0435\u043D\u044C 3,3% \u043E\u0442 \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u0438 \u043F\u0440\u043E\u0434\u0430\u0436\u0438 \u0438\u043B\u0438 \u043E\u0446\u0435\u043D\u043E\u0447\u043D\u043E\u0439 \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u0438, \u0432 \u0437\u0430\u0432\u0438\u0441\u0438\u043C\u043E\u0441\u0442\u0438 \u043E\u0442 \u0442\u043E\u0433\u043E, \u043A\u0430\u043A\u0430\u044F \u0438\u0437 \u043D\u0438\u0445 \u0432\u044B\u0448\u0435).")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041E\u0431\u044F\u0437\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u0430 \u0438 \u043F\u043E\u043A\u0443\u043F\u0430\u0442\u0435\u043B\u044F \u0432 \u043E\u0442\u043D\u043E\u0448\u0435\u043D\u0438\u0438 \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0445 \u0432\u044B\u0448\u0435 \u0440\u0430\u0441\u0445\u043E\u0434\u043E\u0432 \u043E\u043F\u0438\u0441\u044B\u0432\u0430\u044E\u0442\u0441\u044F \u0432 \u0441\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u0438 \u043E \u043A\u0443\u043F\u043B\u0435-\u043F\u0440\u043E\u0434\u0430\u0436\u0438 / \u0438\u043B\u0438 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0435 \u043E \u0434\u043E\u043B\u0433\u043E\u0441\u0440\u043E\u0447\u043D\u043E\u0439 \u0430\u0440\u0435\u043D\u0434\u0435."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"\u041F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0435: \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0435 \u0441\u0442\u0430\u0432\u043A\u0438 \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u044B \u043D\u0430 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0438\u0439 \u043C\u043E\u043C\u0435\u043D\u0442 \u0438 \u043C\u043E\u0433\u0443\u0442 \u0431\u044B\u0442\u044C \u043F\u0435\u0440\u0435\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u044B.")))),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u79DF\u8D41\u767B\u8BB0\u8D39\u548C\u5370\u82B1\u7A0E\uFF08\u76EE\u524D\u4E3A\u79DF\u8D41\u8D39\u76841.1%\uFF09\u5E94\u5728\u79DF\u8D41\u767B\u8BB0\u7ED3\u675F\u540E\u5411\u571F\u5730\u7BA1\u7406\u90E8\u95E8\u7F34\u7EB3\u3002\u7EED\u79DF\u8D39\u7528\u6309\u5408\u540C\u89C4\u5B9A\u7531\u627F\u79DF\u4EBA\u627F\u62C5\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u8F6C\u8BA9\u4E0E\u767B\u8BB0\u6240\u6709\u6743\u65F6\uFF0C\u9700\u5411\u5730\u653F\u5C40\u652F\u4ED8\u6C38\u4E45\u4EA7\u6743\u767B\u8BB0\u8D39\uFF08\u76EE\u524D\u4E3A\u8BC4\u4F30\u4EF7\u76842.0\uFF05\uFF09\u3002\u8BC4\u4F30\u4EF7\u683C\u7531\u6CF0\u56FD\u8D22\u653F\u90E8\u8BC4\u4F30\uFF0C\u4E00\u822C\u6765\u8BF4\u76F8\u5BF9\u4F4E\u4E8E\u5E02\u573A\u4EF7\u503C\u3002\u5176\u4ED6\u8F6C\u8BA9\u4E0E\u767B\u8BB0\u6C38\u4E45\u4E1A\u6743\u7684\u9002\u7528\u7A0E\u989D\u4E3A\uFF1A"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u4F01\u4E1A\u6240\u5F97\u7A0E")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\uFF08\u4E3A\u76EE\u524D\u9500\u552E\u4EF7\u683C\u6216\u8BC4\u4F30\u4EF7\u683C\u76841.0\uFF05\uFF0C\u4EE5\u8F83\u9AD8\u8005\u4E3A\u51C6\uFF09"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u7279\u5B9A\u5546\u4E1A\u7A0E")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\uFF08\u4E3A\u76EE\u524D\u9500\u552E\u4EF7\u683C\u6216\u8BC4\u4F30\u4EF7\u683C\u76843.3\uFF05\uFF0C\u4EE5\u8F83\u9AD8\u8005\u4E3A\u51C6\uFF09")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u6709\u5173\u5356\u65B9\u548C\u4E70\u65B9\u4E4B\u95F4\u7684\u4E0A\u8FF0\u8D39\u7528\u8D1F\u62C5\uFF0C\u5C06\u5728\u6709\u5173\u534F\u8BAE\u4E2D\u6709\u6240\u89C4\u5B9A\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"\u6CE8\uFF1A\u6240\u5217\u7684\u9002\u7528\u8D39\u7387\u4E3A\u6700\u65B0\u4EF7\u683C\uFF0C\u53EF\u80FD\u4F1A\u6709\u53D8\u52A8\u3002"))))}},{categoryId:1,question:{en:"Is a leasehold condominium transferable?",ru:"Может ли передаваться право на недвижимость, приобретенную на правах долгосрочной аренды?",cn:"问.租赁公寓可否转让？"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"A.")," Yes. Leasehold condominiums may be transferred subject to the terms and conditions of the lease agreement. Generally, a small fee is payable. In addition, the new owner must agree to be bound by the terms and conditions contained in the original lease agreement.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"O.")," \u0414\u0430, \u043F\u0440\u0430\u0432\u043E \u043D\u0430 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u044C, \u043F\u0440\u0438\u043E\u0431\u0440\u0435\u0442\u0435\u043D\u043D\u0443\u044E \u043D\u0430 \u043F\u0440\u0430\u0432\u0430\u0445 \u0434\u043E\u043B\u0433\u043E\u0441\u0440\u043E\u0447\u043D\u043E\u0439 \u0430\u0440\u0435\u043D\u0434\u044B, \u043C\u043E\u0436\u0435\u0442 \u043F\u0435\u0440\u0435\u0434\u0430\u0432\u0430\u0442\u044C\u0441\u044F \u0441\u043E\u0433\u043B\u0430\u0441\u043D\u043E \u043F\u043E\u043B\u043E\u0436\u0435\u043D\u0438\u044F\u043C \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430 \u0430\u0440\u0435\u043D\u0434\u044B. \u041E\u0431\u044B\u0447\u043D\u043E \u0437\u0430 \u044D\u0442\u043E \u0432\u0437\u0438\u043C\u0430\u0435\u0442\u0441\u044F \u043D\u0435\u0431\u043E\u043B\u044C\u0448\u0430\u044F \u043F\u043B\u0430\u0442\u0430. \u0422\u0430\u043A\u0436\u0435 \u043D\u043E\u0432\u044B\u0439 \u0432\u043B\u0430\u0434\u0435\u043B\u0435\u0446 \u0434\u043E\u043B\u0436\u0435\u043D \u043F\u0440\u0438\u043D\u044F\u0442\u044C \u0443\u0441\u043B\u043E\u0432\u0438\u044F, \u043F\u0440\u043E\u043F\u0438\u0441\u0430\u043D\u043D\u044B\u0435 \u0432 \u0438\u0437\u043D\u0430\u0447\u0430\u043B\u044C\u043D\u043E\u043C \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0435 \u0430\u0440\u0435\u043D\u0434\u044B.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u7B54.")," ","\u53EF\u4EE5\u7684\u3002\u79DF\u8D41\u516C\u5BD3\u53EF\u6839\u636E\u79DF\u8D41\u534F\u8BAE\u7684\u6761\u6B3E\u4E0E\u6761\u4EF6\u8FDB\u884C\u8F6C\u8BA9\u3002\u901A\u5E38\u9700\u652F\u4ED8\u5C11\u989D\u8D39\u7528\u3002\u6B64\u5916\uFF0C\u65B0\u4E1A\u4E3B\u5FC5\u987B\u540C\u610F\u9075\u5B88\u539F\u79DF\u8D41\u534F\u8BAE\u4E2D\u6240\u542B\u7684\u6761\u6B3E\u4E0E\u6761\u4EF6\u3002"))}},{categoryId:1,question:{en:"Is leasehold ownership secure?",ru:"Защищено ли право долгосрочной аренды?",cn:"租赁所有权安全吗？"},displayOn:["en","ru","cn"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"A.")," Leasehold ownership is a common method of ownership for foreign buyers. Once the lease is registered at the Land Department, the lessee\u2019s rights over the condominium unit will be officially recognized.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"O.")," \u0412\u043B\u0430\u0434\u0435\u043D\u0438\u0435 \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u044C\u044E \u043D\u0430 \u043F\u0440\u0430\u0432\u0430\u0445 \u0434\u043E\u043B\u0433\u043E\u0441\u0440\u043E\u0447\u043D\u043E\u0439 \u0430\u0440\u0435\u043D\u0434\u044B \u2013 \u0434\u043E\u0432\u043E\u043B\u044C\u043D\u043E \u0440\u0430\u0441\u043F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u043D\u044B\u0439 \u0432\u0438\u0434 \u0432\u043B\u0430\u0434\u0435\u043D\u0438\u044F \u0434\u043B\u044F \u0438\u043D\u043E\u0441\u0442\u0440\u0430\u043D\u043D\u044B\u0445 \u043F\u043E\u043A\u0443\u043F\u0430\u0442\u0435\u043B\u0435\u0439. \u041F\u043E\u0441\u043B\u0435 \u043E\u0444\u043E\u0440\u043C\u043B\u0435\u043D\u0438\u044F \u043F\u0440\u0430\u0432\u0430 \u0434\u043E\u043B\u0433\u043E\u0441\u0440\u043E\u0447\u043D\u043E\u0439 \u0430\u0440\u0435\u043D\u0434\u044B \u0432 \u0417\u0435\u043C\u0435\u043B\u044C\u043D\u043E\u043C \u0414\u0435\u043F\u0430\u0440\u0442\u0430\u043C\u0435\u043D\u0442\u0435 \u043F\u0440\u0430\u0432\u043E \u0430\u0440\u0435\u043D\u0434\u0430\u0442\u043E\u0440\u0430 \u043D\u0430 \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u044C \u043F\u0440\u0438\u0437\u043D\u0430\u0435\u0442\u0441\u044F \u043E\u0444\u0438\u0446\u0438\u0430\u043B\u044C\u043D\u043E.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u7B54.")," ","\u201C\u79DF\u8D41\u4EA7\u6743\u201D\u662F\u4E00\u79CD\u5E38\u89C1\u4E8E\u5916\u56FD\u4E70\u5BB6\u6301\u6709\u672C\u56FD\u7269\u4E1A\u7684\u65B9\u5F0F\u3002\u4E00\u65E6\u79DF\u8D41\u4EA7\u6743\u8BC1\u5728\u5730\u653F\u5C40\u767B\u8BB0\u4E4B\u540E\uFF0C\u4E1A\u4E3B\u5BF9\u516C\u5BD3\u62E5\u6709\u7684\u6743\u5229\u4FBF\u83B7\u5F97\u5B98\u65B9\u8BA4\u53EF\u3002"))}},{categoryId:1,question:{en:"When will the registration and transfer of the condominiums take place?",ru:"Когда произойдет оформление и передача прав собственности?",cn:"公寓何时可进行登记和转让？"},displayOn:["en","ru","cn"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"A.")," Approximately 180 days after full payment has been received and construction of all buildings in the Project are completed and condominium license is obtained. We will notify the owner of any documents and fees required for registration. Owners may opt to accept the hand-over of their purchased/leased unit and move in before registration and transfer of condominium unit ownership, upon the occupancy permit of the building being granted (terms and conditions apply).")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"O.")," \u041F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0441\u043F\u0443\u0441\u0442\u044F 90 \u0434\u043D\u0435\u0439 \u043F\u043E\u0441\u043B\u0435 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u043F\u043E\u043B\u043D\u043E\u0439 \u043E\u043F\u043B\u0430\u0442\u044B \u0438 \u043E\u043A\u043E\u043D\u0447\u0430\u043D\u0438\u044F \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430. \u041C\u044B \u0443\u0432\u0435\u0434\u043E\u043C\u0438\u043C \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0430 \u043E \u0442\u043E\u043C, \u043A\u0430\u043A\u0438\u0435 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u044B \u0438 \u043F\u043E\u0448\u043B\u0438\u043D\u044B \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u044B \u0434\u043B\u044F \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438. \u0412\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u044B \u043C\u043E\u0433\u0443\u0442 \u043D\u0430\u0447\u0430\u0442\u044C \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u044C\u0441\u044F \u0441\u0432\u043E\u0435\u0439 \u043A\u0432\u0430\u0440\u0442\u0438\u0440\u043E\u0439 \u0438 \u0432\u044C\u0435\u0445\u0430\u0442\u044C \u0434\u043E \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0438\u043F\u0435\u0440\u0435\u0434\u0430\u0447\u0438 \u043F\u0440\u0430\u0432\u0430 \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u043D\u0430 \u043A\u0432\u0430\u0440\u0442\u0438\u0440\u0443 \u0432 \u043A\u043E\u043D\u0434\u043E\u043C\u0438\u043D\u0438\u0443\u043C\u0435 \u043F\u0440\u0438 \u043D\u0430\u043B\u0438\u0447\u0438\u0438 \u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u0438\u044F \u043D\u0430 \u043F\u0440\u043E\u0436\u0438\u0432\u0430\u043D\u0438\u0435 \u0432 \u044D\u0442\u043E\u043C \u0437\u0434\u0430\u043D\u0438\u0438 (\u043F\u0440\u0438\u043C\u0435\u043D\u044F\u044E\u0442\u0441\u044F \u0443\u0441\u043B\u043E\u0432\u0438\u044F).")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u7B54.")," ","\u6536\u5230\u5168\u989D\u4ED8\u6B3E\u540E\u7EA690\u5929\uFF0C\u4E14\u9879\u76EE\u4E2D\u6240\u6709\u5EFA\u7B51\u7684\u65BD\u5DE5\u5B8C\u6210\u540E\u3002\u6211\u4EEC\u5C06\u4F1A\u77E5\u4F1A\u4E1A\u4E3B\u767B\u8BB0\u6240\u9700\u7684\u6240\u6709\u6587\u4EF6\u548C\u8D39\u7528\u3002\u4E00\u65E6\u9879\u76EE\u83B7\u5F97\u5EFA\u7B51\u7269\u7684\u5165\u4F4F\u8BB8\u53EF\u8BC1\uFF0C\u4E1A\u4E3B\u53EF\u9009\u62E9\u63A5\u53D7\u5176\u8D2D\u4E70/\u79DF\u8D41\u5355\u4F4D\u7684\u79FB\u4EA4\uFF0C\u5E76\u5728\u516C\u5BD3\u5355\u4F4D\u6240\u6709\u6743\u767B\u8BB0\u53CA\u8F6C\u79FB\u624B\u7EED\u5B8C\u6210\u524D\u5165\u4F4F\uFF08\u9700\u6EE1\u610F\u4E00\u5B9A\u6761\u4EF6\u53CA\u6761\u6B3E\uFF09\u3002"))}},{categoryId:1,question:{en:"Should I appoint a lawyer to review the agreements?",ru:"Требуется ли проверка соглашений юристом?",cn:"我应指定律师审核协议吗？"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"A.")," Our agreements have been used for a number of years and have been reviewed by major international law firms. We have our own in-house legal team which will assist to clarify any questions you may have concerning the agreements. However, should you wish to obtain specific advice regarding the structuring of your investment, we recommend you consult with a professional legal and/or financial adviser.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"O.")," \u041D\u0430\u0448\u0438 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430 \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u044E\u0442\u0441\u044F \u0443\u0436\u0435 \u043D\u0435\u0441\u043A\u043E\u043B\u044C\u043A\u043E \u043B\u0435\u0442 \u0438 \u043F\u0440\u043E\u0448\u043B\u0438 \u043F\u0440\u043E\u0432\u0435\u0440\u043A\u0443 \u043A\u0440\u0443\u043F\u043D\u0435\u0439\u0448\u0438\u043C\u0438 \u043C\u0435\u0436\u0434\u0443\u043D\u0430\u0440\u043E\u0434\u043D\u044B\u043C\u0438 \u044E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u0438\u043C\u0438 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u044F\u043C\u0438. \u0421\u043F\u0435\u0446\u0438\u0430\u043B\u0438\u0441\u0442\u044B \u043D\u0430\u0448\u0435\u0433\u043E \u044E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u043E\u0433\u043E \u043E\u0442\u0434\u0435\u043B\u0430 \u043E\u0442\u0432\u0435\u0442\u044F\u0442 \u043D\u0430 \u0432\u0441\u0435 \u0441\u0432\u044F\u0437\u0430\u043D\u043D\u044B\u0435 \u0441 \u0441\u043E\u0433\u043B\u0430\u0448\u0435\u043D\u0438\u044F\u043C\u0438 \u0432\u043E\u043F\u0440\u043E\u0441\u044B, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u043C\u043E\u0433\u0443\u0442 \u0443 \u0432\u0430\u0441 \u0432\u043E\u0437\u043D\u0438\u043A\u043D\u0443\u0442\u044C. \u0412 \u0442\u043E \u0436\u0435 \u0432\u0440\u0435\u043C\u044F, \u0435\u0441\u043B\u0438 \u0432\u044B \u0445\u043E\u0442\u0438\u0442\u0435 \u043F\u043E\u043B\u0443\u0447\u0438\u0442\u044C \u043A\u043E\u043D\u043A\u0440\u0435\u0442\u043D\u044B\u0435 \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0430\u0446\u0438\u0438 \u043E\u0442\u043D\u043E\u0441\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u0438\u0437\u0430\u0446\u0438\u0438 \u0441\u0432\u043E\u0438\u0445 \u0438\u043D\u0432\u0435\u0441\u0442\u0438\u0446\u0438\u0439, \u043C\u044B \u0441\u043E\u0432\u0435\u0442\u0443\u0435\u043C \u0432\u0430\u043C \u043E\u0431\u0440\u0430\u0442\u0438\u0442\u044C\u0441\u044F \u043A \u043F\u0440\u043E\u0444\u0435\u0441\u0441\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u043E\u043C\u0443 \u044E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u043E\u043C\u0443 \u0438/\u0438\u043B\u0438 \u0444\u0438\u043D\u0430\u043D\u0441\u043E\u0432\u043E\u043C\u0443 \u043A\u043E\u043D\u0441\u0443\u043B\u044C\u0442\u0430\u043D\u0442\u0443.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u7B54.")," ","\u6211\u4EEC\u7684\u534F\u8BAE\u6587\u672C\u5DF2\u4F7F\u7528\u591A\u5E74\uFF0C\u4E14\u5DF2\u901A\u8FC7\u591A\u5BB6\u5927\u578B\u56FD\u9645\u5F8B\u5E08\u4E8B\u52A1\u6240\u7684\u5BA1\u6838\u3002\u6211\u4EEC\u62E5\u6709\u81EA\u5DF1\u7684\u5185\u90E8\u6CD5\u5F8B\u56E2\u961F\uFF0C\u4ED6\u4EEC\u4F1A\u5E2E\u52A9\u89E3\u91CA\u60A8\u5BF9\u534F\u8BAE\u53EF\u80FD\u5B58\u5728\u7684\u4EFB\u4F55\u95EE\u9898\u3002\u4F46\u662F\uFF0C\u5982\u679C\u60A8\u5E0C\u671B\u83B7\u5F97\u6709\u5173\u6295\u8D44\u7ED3\u6784\u7684\u5177\u4F53\u5EFA\u8BAE\uFF0C\u6211\u4EEC\u5EFA\u8BAE\u60A8\u54A8\u8BE2\u4E13\u4E1A\u6CD5\u5F8B\u548C/\u6216\u8D22\u52A1\u987E\u95EE\u3002"))}},{categoryId:1,question:{en:"What types of visas are available for foreigners to stay in Thailand?",ru:"Какие типы виз позволяют иностранцу находиться в Таиланде?",cn:"外籍人士将能获得何种泰国居留签证？"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"A.")," There are various forms of visas available to foreigners who wish to enter Thailand for study, business, investment, retirement and other purposes ranging from 90 days to 10 years multiple entry which include."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Long-Term Resident (LTR) visa offering 10 year renewable visas for four categories of foreign nationals: wealthy global citizens, wealthy pensioners, work-from-Thailand professionals, and highly-skilled professionals - subject to meeting qualification."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Retirement visa for people aged 50 years or over and meet financial requirements"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Education visa when enrolled at registered education institution within Thailand"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Business visa when operating a business"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Marriage visa for foreigners married to a Thai"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Thailand Elite Visa - a government led program offering memberships including 5 to 20 year visas")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Please consult with an immigration specialist or Thai Embassy / Consulate for more information.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"O.")," \u0414\u043B\u044F \u0433\u0440\u0430\u0436\u0434\u0430\u043D \u0434\u0440\u0443\u0433\u0438\u0445 \u0441\u0442\u0440\u0430\u043D, \u0436\u0435\u043B\u0430\u044E\u0449\u0438\u0445 \u0432\u044A\u0435\u0445\u0430\u0442\u044C \u0432 \u0422\u0430\u0438\u043B\u0430\u043D\u0434 \u0432 \u0443\u0447\u0435\u0431\u043D\u044B\u0445, \u0434\u0435\u043B\u043E\u0432\u044B\u0445 \u0438\u043B\u0438 \u0438\u043D\u0432\u0435\u0441\u0442\u0438\u0446\u0438\u043E\u043D\u043D\u044B\u0445 \u0446\u0435\u043B\u044F\u0445, \u0441 \u0446\u0435\u043B\u044C\u044E \u0432\u044B\u0445\u043E\u0434\u0430 \u043D\u0430 \u043F\u0435\u043D\u0441\u0438\u044E \u0438 \u0432 \u0434\u0440\u0443\u0433\u0438\u0445 \u0446\u0435\u043B\u044F\u0445, \u043F\u0440\u0435\u0434\u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u044B \u0440\u0430\u0437\u043D\u044B\u0435 \u0444\u043E\u0440\u043C\u044B \u0432\u0438\u0437, \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u043E\u0442 90 \u0434\u043D\u0435\u0439 \u0434\u043E 1 \u0433\u043E\u0434\u0430 \u0438 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u044E\u0449\u0438\u0435 \u043F\u0440\u0430\u0432\u043E \u043C\u043D\u043E\u0433\u043E\u043A\u0440\u0430\u0442\u043D\u043E\u0433\u043E \u0432\u044A\u0435\u0437\u0434\u0430 \u0432 \u0441\u0442\u0440\u0430\u043D\u0443, \u0432\u043A\u043B\u044E\u0447\u0430\u044F:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u041E\u0431\u0440\u0430\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u043D\u0443\u044E \u0432\u0438\u0437\u0443 \u2014 \u043F\u0440\u0438 \u0437\u0430\u0447\u0438\u0441\u043B\u0435\u043D\u0438\u0438 \u0432 \u0437\u0430\u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0435 \u043E\u0431\u0440\u0430\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044C\u043D\u043E\u0435 \u0443\u0447\u0440\u0435\u0436\u0434\u0435\u043D\u0438\u0435 \u0432 \u0422\u0430\u0438\u043B\u0430\u043D\u0434\u0435;"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u0411\u0438\u0437\u043D\u0435\u0441-\u0432\u0438\u0437\u0443 \u2014 \u0434\u043B\u044F \u0443\u043F\u0440\u0430\u0432\u043B\u044F\u044E\u0449\u0438\u0445 \u0438\u043B\u0438 \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u043E\u0432 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0439;"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u041F\u0435\u043D\u0441\u0438\u043E\u043D\u043D\u0443\u044E \u0432\u0438\u0437\u0443 \u2014 \u0434\u043B\u044F \u043B\u0438\u0446 \u0432 \u0432\u043E\u0437\u0440\u0430\u0441\u0442\u0435 50 \u043B\u0435\u0442 \u0438 \u0441\u0442\u0430\u0440\u0448\u0435, \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0445 \u0444\u0438\u043D\u0430\u043D\u0441\u043E\u0432\u044B\u043C \u0442\u0440\u0435\u0431\u043E\u0432\u0430\u043D\u0438\u044F\u043C;"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u0412\u0438\u0437\u0443 \u0434\u043B\u044F \u0437\u0430\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u044F \u0431\u0440\u0430\u043A\u0430 \u2014 \u0434\u043B\u044F \u0433\u0440\u0430\u0436\u0434\u0430\u043D \u0434\u0440\u0443\u0433\u0438\u0445 \u0441\u0442\u0440\u0430\u043D, \u0432\u0441\u0442\u0443\u043F\u0430\u044E\u0449\u0438\u0445 \u0432 \u0431\u0440\u0430\u043A \u0441 \u0433\u0440\u0430\u0436\u0434\u0430\u043D\u0438\u043D\u043E\u043C/\u0433\u0440\u0430\u0436\u0434\u0430\u043D\u043A\u043E\u0439 \u0422\u0430\u0438\u043B\u0430\u043D\u0434\u0430;"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u0412\u0438\u0437\u0443 \xAB\u042D\u043B\u0438\u0442\u0430 \u0422\u0430\u0438\u043B\u0430\u043D\u0434\u0430\xBB \u2014 \u0432\u044B\u0434\u0430\u0435\u0442\u0441\u044F \u0441\u0440\u043E\u043A\u043E\u043C \u043D\u0430 5 \u043B\u0435\u0442 \u0432 \u0440\u0430\u043C\u043A\u0430\u0445 \u0433\u043E\u0441\u0443\u0434\u0430\u0440\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0439 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B, \u043A\u043E\u0442\u043E\u0440\u0430\u044F \u0442\u0430\u043A\u0436\u0435 \u043F\u0440\u0435\u0434\u0443\u0441\u043C\u0430\u0442\u0440\u0438\u0432\u0430\u0435\u0442 \u0434\u0440\u0443\u0433\u0438\u0435 \u043F\u0440\u0438\u0432\u0438\u043B\u0435\u0433\u0438\u0438.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0417\u0430 \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0439 \u0438\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u0435\u0439 \u043E\u0431\u0440\u0430\u0449\u0430\u0439\u0442\u0435\u0441\u044C \u043A \u0438\u043C\u043C\u0438\u0433\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u043C\u0443 \u0441\u043F\u0435\u0446\u0438\u0430\u043B\u0438\u0441\u0442\u0443 \u043F\u043E\u0441\u043E\u043B\u044C\u0441\u0442\u0432\u0430")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u7B54.")," ","\u5BF9\u4E8E\u5E0C\u671B\u524D\u5F80\u6CF0\u56FD\u5B66\u4E60\u3001\u51FA\u5DEE\u3001\u6295\u8D44\u3001\u4EAB\u53D7\u9000\u4F11\u751F\u6D3B\u6216\u56E0\u5176\u4ED6\u76EE\u7684\u524D\u5F80\u6CF0\u56FD\u7684\u5916\u7C4D\u4EBA\u58EB\uFF0C\u5F53\u5C40\u63D0\u4F9B\u591A\u79CD\u5F62\u5F0F\u4E14\u671F\u9650\u4ECB\u4E8E 90 \u5929\u81F3 10\u5E74\u7684\u591A\u6B21\u5165\u5883\u7B7E\u8BC1\uFF0C\u5176\u4E2D\u5305\u62EC\uFF1A"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u957F\u671F\u5C45\u6C11(LTR)\u7B7E\u8BC1\u4E3A\u56DB\u7C7B\u5916\u56FD\u4EBA\u63D0\u4F9B 10 \u5E74\u53EF\u7EED\u7B7E\u7B7E\u8BC1\uFF1A\u5BCC\u6709\u7684\u5168\u7403\u516C\u6C11\u3001\u5BCC\u6709\u7684\u517B\u8001\u91D1\u9886\u53D6\u8005\u3001\u5728\u6CF0\u56FD\u5DE5\u4F5C\u7684\u4E13\u4E1A\u4EBA\u58EB\u548C\u9AD8\u6280\u80FD\u4E13\u4E1A\u4EBA\u58EB - \u987B\u7B26\u5408\u7533\u8BF7\u8D44\u683C"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u9000\u4F11\u7B7E\u8BC1\uFF0C\u9002\u7528\u4E8E\u5E74\u6EE1 50 \u5C81\u4E14\u7B26\u5408\u8D22\u52A1\u8981\u6C42\u7684\u4EBA\u58EB"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u6559\u80B2\u7B7E\u8BC1\uFF0C\u9002\u7528\u4E8E\u5C31\u8BFB\u4E8E\u6CF0\u56FD\u6CE8\u518C\u6559\u80B2\u673A\u6784\u7684\u4EBA\u58EB"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u5546\u52A1\u7B7E\u8BC1\uFF0C\u9002\u7528\u4E8E\u7ECF\u8425\u516C\u53F8\u7684\u4EBA\u58EB"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u7ED3\u5A5A\u7B7E\u8BC1\uFF0C\u9002\u7528\u4E8E\u4E0E\u6CF0\u56FD\u4EBA\u7ED3\u5A5A\u7684\u5916\u7C4D\u4EBA\u58EB"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u6CF0\u56FD\u7CBE\u82F1\u7B7E\u8BC1\uFF0C\u4E00\u9879\u7531\u653F\u5E9C\u5F15\u5BFC\u7684\u8BA1\u5212\uFF0C\u63D0\u4F9B\u5305\u62EC 5 \u5E74\u81F320\u5E74\u7B7E\u8BC1\u7684\u4F1A\u7C4D")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u5982\u9700\u4E86\u89E3\u66F4\u591A\u4FE1\u606F\uFF0C\u8BF7\u54A8\u8BE2\u79FB\u6C11\u4E13\u5BB6\u6216\u6CF0\u56FD\u5927\u4F7F\u9986/\u9886\u4E8B\u9986"))}},{categoryId:2,displayOn:["en","ru","cn"],question:{en:"Types and number of units for sale?",ru:"Тип недвижимости и количество квартир в проекте?",cn:"出售单位的房型有哪些，数量是多少？"},answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"A.")," The development includes three (3) low-rise condominium buildings comprising a total of approximately 400 units with each building containing approximately 130 units. Studio, one and two bedroom configurations are available ranging in size from 29 \u2013 60 square metres.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"O.")," \u041F\u0440\u043E\u0435\u043A\u0442 \u0432\u043A\u043B\u044E\u0447\u0430\u0435\u0442 \u0432 \u0441\u0435\u0431\u044F \u0442\u0440\u0438 (3) \u043C\u0430\u043B\u043E\u044D\u0442\u0430\u0436\u043D\u044B\u0445 \u0437\u0434\u0430\u043D\u0438\u044F \u043A\u043E\u043D\u0434\u043E\u043C\u0438\u043D\u0438\u0443\u043C\u0430, \u0432\u043A\u043B\u044E\u0447\u0430\u044E\u0449\u0438\u0435 \u0432 \u043E\u0431\u0449\u0435\u0439 \u0441\u043B\u043E\u0436\u043D\u043E\u0441\u0442\u0438 \u043E\u043A\u043E\u043B\u043E 400 \u043A\u0432\u0430\u0440\u0442\u0438\u0440, \u0432 \u043A\u0430\u0436\u0434\u043E\u043C \u0437\u0434\u0430\u043D\u0438\u0438 \u043F\u0440\u0438\u043C\u0435\u0440\u043D\u043E 140 \u043A\u0432\u0430\u0440\u0442\u0438\u0440. \u0421\u0442\u0443\u0434\u0438\u044F, \u043A\u043E\u043D\u0444\u0438\u0433\u0443\u0440\u0430\u0446\u0438\u0438 \u0441 \u043E\u0434\u043D\u043E\u0439 \u0438 \u0434\u0432\u0443\u043C\u044F \u0441\u043F\u0430\u043B\u044C\u043D\u044F\u043C\u0438 \u043F\u043B\u043E\u0449\u0430\u0434\u044C\u044E 28 \u2013 60 \u043A\u0432.\u043C.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u7B54.")," ","\u5F00\u53D1\u9879\u76EE\u5305\u62EC\u4E09\uFF083\uFF09\u680B\u4F4E\u5C42\u516C\u5BD3\u697C\uFF0C\u5171\u7EA6400\u5957\uFF0C\u6BCF\u680B\u697C\u7EA6130\u5957\u3002\u4E00\u5BA4\u5355\u95F4\u516C\u5BD3\u3001\u4E00\u5367\u5957\u623F\u548C\u4E24\u5367\u5957\u623F\u914D\u7F6E\u53EF\u9009\uFF0C\u9762\u79EF\u4ECE29\u81F360\u5E73\u65B9\u7C73\u4E0D\u7B49\u3002"))}},{categoryId:2,question:{en:"How long does construction take?",ru:"Сколько времени занимает строительство?",cn:"施工需要多长时间？"},displayOn:["en","ru","cn"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"A.")," Construction can only commence once the relevant government environmental and building approvals are obtained and is estimated to take approximately 20-24 months for each building to complete from the commencement date.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"O.")," \u0421\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E \u043C\u043E\u0436\u0435\u0442 \u043D\u0430\u0447\u0430\u0442\u044C\u0441\u044F \u0442\u043E\u043B\u044C\u043A\u043E \u043F\u043E\u0441\u043B\u0435 \u0442\u043E\u0433\u043E, \u043A\u0430\u043A \u0431\u0443\u0434\u0443\u0442 \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u044B \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0435 \u043F\u0440\u0430\u0432\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u0435 \u044D\u043A\u043E\u043B\u043E\u0433\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u0438 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0435 \u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u0438\u044F \u0438 \u0441\u043E\u0433\u043B\u0430\u0441\u043E\u0432\u0430\u043D\u0438\u044F. \u041A\u0430\u043A \u043F\u0440\u0430\u0432\u0438\u043B\u043E, \u0441 \u043C\u043E\u043C\u0435\u043D\u0442\u0430 \u043D\u0430\u0447\u0430\u043B\u0430 \u0434\u043E \u043C\u043E\u043C\u0435\u043D\u0442\u0430 \u043E\u043A\u043E\u043D\u0447\u0430\u043D\u0438\u044F \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0445 \u0440\u0430\u0431\u043E\u0442 \u0438 \u0431\u043B\u0430\u0433\u043E\u0443\u0441\u0442\u0440\u043E\u0439\u0441\u0442\u0432\u0430 \u0442\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u0438 \u043F\u0440\u043E\u0445\u043E\u0434\u0438\u0442 \u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E 24 \u043C\u0435\u0441\u044F\u0446\u0430.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u7B54.")," ","\u83B7\u5F97\u653F\u5E9C\u76F8\u5173\u7684\u73AF\u5883\u4E0E\u5EFA\u7B51\u7269\u5BA1\u6279\u540E\uFF0C\u5EFA\u7B51\u5DE5\u7A0B\u5373\u53EF\u5F00\u59CB\u65BD\u5DE5\uFF0C\u4F30\u8BA1\u4ECE\u751F\u6548\u65E5\u671F\u7B97\u8D77\u3001\u9700\u8981\u5927\u7EA620-24\u4E2A\u6708\u624D\u80FD\u5B8C\u6210\u3002"))}},{categoryId:2,question:{en:"Is a warranty period offered?",ru:"Предусмотрен ли гарантийный период?",cn:"是否提供保修期？"},displayOn:["en","ru","cn"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"A.")," Yes. A five (5) year building structure warranty is offered from the date of completion of construction. Warranties on any other component parts of the building will be subject to a two (2) year warranty.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"O.")," \u0414\u0430, \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u0433\u0430\u0440\u0430\u043D\u0442\u0438\u044F \u043D\u0430 \u043A\u043E\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0438\u044E \u0437\u0434\u0430\u043D\u0438\u044F \u0441\u0440\u043E\u043A\u043E\u043C \u043D\u0430 \u043F\u044F\u0442\u044C (5) \u043B\u0435\u0442 \u0441 \u043C\u043E\u043C\u0435\u043D\u0442\u0430 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430. \u0413\u0430\u0440\u0430\u043D\u0442\u0438\u044F \u043D\u0430 \u043B\u044E\u0431\u044B\u0435 \u0434\u0440\u0443\u0433\u0438\u0435 \u0441\u043E\u0441\u0442\u0430\u0432\u043D\u044B\u0435 \u0447\u0430\u0441\u0442\u0438 \u0437\u0434\u0430\u043D\u0438\u044F \u0441\u043E\u0441\u0442\u0430\u0432\u0438\u0442 \u0434\u0432\u0430 (2) \u0433\u043E\u0434\u0430."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"*\u041C\u043E\u0433\u0443\u0442 \u0431\u044B\u0442\u044C \u0432\u043D\u0435\u0441\u0435\u043D\u044B \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u043E\u043C \u0438 \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E\u043C.")))),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u7B54.")," ","\u662F\u3002\u4ECE\u5EFA\u6210\u65BD\u5DE5\u4E4B\u65E5\u8D77\uFF0C\u63D0\u4F9B\u4E94\uFF085\uFF09\u5E74\u7684\u5EFA\u7B51\u7ED3\u6784\u4FDD\u4FEE\u3002\u5EFA\u7B51\u7684\u5176\u4ED6\u90E8\u5206\u5C06\u6709\u4E8C\uFF082\uFF09\u5E74\u7684 \u4FDD\u4FEE\u671F\u3002"))}},{categoryId:2,question:{en:"What is included in the property?",ru:"Что влючено в покупку недвижимости?",cn:"该物业包括什么?"},displayOn:["en","ru","cn"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"A.")," Fixed furnishings (wardrobes, kitchen cabinets and built-in appliances) is included. Loose furniture, artworks and amenities are not included but are available to purchase separately.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"O.")," \u0412\u0441\u0442\u0440\u043E\u0435\u043D\u043D\u044B\u0439 \u0432\u0430\u0440\u0438\u0430\u043D\u0442 \u0432\u043A\u043B\u044E\u0447\u0430\u0435\u0442 \u0432 \u0441\u0435\u0431\u044F \u0432\u0441\u0442\u0440\u043E\u0435\u043D\u043D\u0443\u044E \u043C\u0435\u0431\u0435\u043B\u044C (\u0448\u043A\u0430\u0444\u044B, \u043A\u0443\u0445\u043E\u043D\u043D\u044B\u0435 \u0448\u043A\u0430\u0444\u044B \u0438 \u0432\u0441\u0442\u0440\u043E\u0435\u043D\u043D\u0443\u044E \u043A\u0443\u0445\u043E\u043D\u043D\u0443\u044E \u0442\u0435\u0445\u043D\u0438\u043A\u0443, \u043A\u043E\u043D\u0434\u0438\u0446\u0438\u043E\u043D\u0435\u0440 \u0438 \u0442. \u043F.). \u041C\u0435\u0431\u0435\u043B\u044C, \u043F\u0440\u043E\u0438\u0437\u0432\u0435\u0434\u0435\u043D\u0438\u044F \u0438\u0441\u043A\u0443\u0441\u0441\u0442\u0432\u0430 \u0438 \u0443\u0434\u043E\u0431\u0441\u0442\u0432\u0430 \u043D\u0435 \u0432\u043A\u043B\u044E\u0447\u0435\u043D\u044B \u0432 \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C, \u043D\u043E \u0438\u0445 \u043C\u043E\u0436\u043D\u043E \u043F\u0440\u0438\u043E\u0431\u0440\u0435\u0441\u0442\u0438 \u043E\u0442\u0434\u0435\u043B\u044C\u043D\u043E.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u7B54.")," \u5305\u542B\u56FA\u5B9A\u5BB6\u5177(\u8863\u67DC, \u6A71\u67DC\u548C\u5D4C\u5165\u5F0F\u5BB6\u5177)\u3002\u53EF\u79FB\u52A8\u7684\u5BB6\u5177\uFF0C\u827A\u672F\u88C5\u9970\u548C\u5176\u4ED6\u8BBE\u65BD\u4E0D\u5305\u542B\u5728\u5185\uFF0C\u4F46\u53EF\u5355\u72EC\u8D2D\u4E70\u3002"))}},{categoryId:2,question:{en:"Is customization of the units allowed?",ru:"Допускается ли изменение планировки в соответствии с индивидуальными требованиями?",cn:"是否允许量身定制该物业单位？"},displayOn:["en","ru","cn"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"A.")," No. The building must be built in accordance with building code and permits as issued by the relevant authorities so no changes to the external areas or structural items are permitted.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"O.")," \u0417\u0434\u0430\u043D\u0438\u044F \u0434\u043E\u043B\u0436\u043D\u044B \u0431\u044B\u0442\u044C \u043F\u043E\u0441\u0442\u0440\u043E\u0435\u043D\u044B \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441\u043E \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u043C\u0438 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430\u0446\u0438\u044F\u043C\u0438 \u0438 \u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u0438\u044F\u043C\u0438, \u0432\u044B\u0434\u0430\u043D\u043D\u044B\u043C\u0438 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u043C\u0438 \u0433\u043E\u0441\u0443\u0434\u0430\u0440\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u043C\u0438 \u043E\u0440\u0433\u0430\u043D\u0430\u043C\u0438, \u043F\u043E\u044D\u0442\u043E\u043C\u0443 \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u0432\u043D\u0435\u0448\u043D\u0438\u0445 \u0437\u043E\u043D \u0438\u043B\u0438 \u044D\u043B\u0435\u043C\u0435\u043D\u0442\u043E\u0432 \u043A\u043E\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0438\u0438 \u043D\u0435\u0434\u043E\u043F\u0443\u0441\u0442\u0438\u043C\u044B. \u0418\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F \u0432\u043D\u0443\u0442\u0440\u0435\u043D\u043D\u0435\u0433\u043E \u0434\u0438\u0437\u0430\u0439\u043D\u0430 \u043C\u043E\u0433\u0443\u0442 \u0431\u044B\u0442\u044C \u0440\u0430\u0437\u0440\u0435\u0448\u0435\u043D\u044B \u043F\u043E\u0441\u043B\u0435 \u043E\u0444\u0438\u0446\u0438\u0430\u043B\u044C\u043D\u043E\u0439 \u043F\u0440\u0438\u0435\u043C\u043A\u0438 - \u043F\u0435\u0440\u0435\u0434\u0430\u0447\u0438 \u043A\u0432\u0430\u0440\u0442\u0438\u0440\u044B \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0443 (\u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u043E\u0434\u043E\u0431\u0440\u0435\u043D\u0438\u0435 \u0437\u0430\u0441\u0442\u0440\u043E\u0439\u0449\u0438\u043A\u0430).")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u7B54.")," ","\u4E0D\u5141\u8BB8\uFF0C\u5EFA\u7B51\u7269\u5FC5\u987B\u6309\u7167\u6709\u5173\u90E8\u95E8\u6240\u9881\u53D1\u7684\u5EFA\u7B51\u89C4\u8303\u4E0E\u8BB8\u53EF\u8BC1\u8FDB\u884C\u5EFA\u9020\uFF0C\u4E0D\u5141\u8BB8\u53D8\u66F4\u5176\u5916\u90E8\u533A\u57DF\u6216\u7ED3\u6784"))}},{categoryId:3,question:{en:"What infrastructure and common facilities are provided and who will manage these?",ru:"Какая предоставляется инфраструктура и объекты общего назначения и кто будет управлять?",cn:"项目包含哪些基础设施和公共设施？这些设施由谁负责管理？"},displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"A.")," The infrastructure and common facilities includes roads and drainage, lighting, landscape areas, swimming pools, deck areas and water and electricity supplies. Services shall include 24 hours on-site security, garbage collection, cleaning and maintenance of infrastructure and common facilities or any other services as required for the common use or benefit of owners. In addition, owners will be entitled to access certain amenities including the shuttle bus service. The condominium manager shall be Laguna (or its designated manager).")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"O.")," \u0418\u043D\u0444\u0440\u0430\u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u0430 \u0438 \u043E\u0431\u044A\u0435\u043A\u0442\u044B \u043E\u0431\u0449\u0435\u0433\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0432\u043A\u043B\u044E\u0447\u0430\u044E\u0442 \u0432 \u0441\u0435\u0431\u044F \u0434\u043E\u0440\u043E\u0433\u0438, \u043A\u0430\u043D\u0430\u043B\u0438\u0437\u0430\u0446\u0438\u044E, \u043E\u0441\u0432\u0435\u0449\u0435\u043D\u0438\u0435, \u043B\u0430\u043D\u0434\u0448\u0430\u0444\u0442\u043D\u044B\u0435 \u0437\u043E\u043D\u044B, \u0431\u0430\u0441\u0441\u0435\u0439\u043D\u044B, \u043F\u043B\u043E\u0449\u0430\u0434\u043A\u0438, \u0432\u043E\u0434\u043E\u0441\u043D\u0430\u0431\u0436\u0435\u043D\u0438\u0435 \u0438 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u0441\u043D\u0430\u0431\u0436\u0435\u043D\u0438\u0435. \u0423\u0441\u043B\u0443\u0433\u0438 \u0434\u043E\u043B\u0436\u043D\u044B \u0432\u043A\u043B\u044E\u0447\u0430\u0442\u044C 24-\u0447\u0430\u0441\u043E\u0432\u0443\u044E \u043E\u0445\u0440\u0430\u043D\u0443, \u0441\u0431\u043E\u0440 \u043C\u0443\u0441\u043E\u0440\u0430, \u0443\u0431\u043E\u0440\u043A\u0443 \u0438 \u043E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u043D\u0438\u0435 \u0438\u043D\u0444\u0440\u0430\u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u044B \u0438 \u043C\u0435\u0441\u0442 \u043E\u0431\u0449\u0435\u0433\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F, \u0430 \u0442\u0430\u043A\u0436\u0435 \u043B\u044E\u0431\u044B\u0435 \u0434\u0440\u0443\u0433\u0438\u0435 \u0443\u0441\u043B\u0443\u0433\u0438, \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u044B\u0435 \u0434\u043B\u044F \u043E\u0431\u0449\u0435\u0433\u043E \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u044F \u0438\u043B\u0438 \u0442\u0440\u0435\u0431\u0443\u0435\u043C\u044B\u0435 \u0432 \u0438\u043D\u0442\u0435\u0440\u0435\u0441\u0430\u0445 \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0435\u0432. \u041A\u0440\u043E\u043C\u0435 \u0442\u043E\u0433\u043E, \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u044B \u0431\u0443\u0434\u0443\u0442 \u0438\u043C\u0435\u0442\u044C \u043F\u0440\u0430\u0432\u043E \u0434\u043E\u0441\u0442\u0443\u043F\u0430 \u043A \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u044B\u043C \u0443\u0434\u043E\u0431\u0441\u0442\u0432\u0430\u043C \u043A\u0443\u0440\u043E\u0440\u0442\u0430, \u0432\u043A\u043B\u044E\u0447\u0430\u044F \u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u044B\u0439 \u0442\u0440\u0430\u043D\u0441\u043F\u043E\u0440\u0442 \u0432\u043D\u0443\u0442\u0440\u0438 \u043A\u0443\u0440\u043E\u0440\u0442\u0430. \u0423\u043F\u0440\u0430\u0432\u043B\u044F\u044E\u0449\u0438\u043C \u043A\u043E\u043D\u0434\u043E\u043C\u0438\u043D\u0438\u0443\u043C\u043E\u043C \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F Laguna (\u0438\u043B\u0438 \u043D\u0430\u0437\u043D\u0430\u0447\u0435\u043D\u043D\u044B\u0439 \u0435\u044E \u043C\u0435\u043D\u0435\u0434\u0436\u0435\u0440).")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u7B54.")," ","\u57FA\u7840\u8BBE\u65BD\u4E0E\u516C\u5171\u8BBE\u65BD\u5305\u62EC\uFF1A\u9053\u8DEF\u548C\u6392\u6C34\u3001\u7167\u660E\u3001\u666F\u89C2\u533A\u3001\u6E38\u6CF3\u6C60\u3001\u7532\u677F\u533A\u4E0E\u6C34\u7535\u4F9B\u5E94\u3002\u670D\u52A1\u5305\u62EC\uFF1A24\u5C0F\u65F6\u73B0\u573A\u4FDD\u5B89\u3001\u5783\u573E\u6536\u96C6\u3001\u6E05\u6D01\u6253\u626B\uFF0C\u4EE5\u53CA\u57FA\u7840\u8BBE\u65BD\u548C\u5171\u540C\u8BBE\u65BD\u7684\u7EF4\u62A4\uFF0C\u6216\u5176\u4ED6\u4EFB\u4F55\u4E1A\u4E3B\u53EF\u4EE5\u5171\u540C\u4F7F\u7528\u6216\u6536\u76CA\u7684\u670D\u52A1\u3002\u6B64\u5916\uFF0C\u4E1A\u4E3B\u5C06\u6709\u6743\u4F7F\u7528\u4E00\u4E9B\u8BBE\u65BD\uFF0C\u5305\u62EC\u7A7F\u68AD\u5DF4\u58EB\u670D\u52A1\u3002\u516C\u5BD3\u7ECF\u7406\u5C06\u7531\u4E50\u53E4\u6D6A\u623F\uFF08\u6216\u5176\u6307\u6D3E\u4E4B\u7ECF\u7406\uFF09\u62C5\u4EFB\u3002"))}},{categoryId:3,question:{en:"What are the estimated fees payable for the infrastructure, common facilities and services provided?",ru:"Каковы сборы за обслуживание инфраструктуры проекта, общественной территории и за другие предоставляемые услуги?",cn:"基础设施、公共设施和相关服务预计费用是多少？"},displayOn:["en","ru","cn"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"A.")," The fees for the cost of maintenance for the infrastructure, common facilities, services provided (\u201Ccommon area fee\u201D) and maintenance fees towards other services and facilities supplied to the condominium \u201Cnon-common area fees\u2019 in aggregate shall be Baht 60 per square metre per month for the initial year and may be subject to change based upon the actual expenses incurred from time to time. The annual fees are determined by the total expenses incurred and proportionately divided amongst the sellable area of the units in the condominium."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"In addition, a fund shall be established for the cost of major repairs, replacement and/or improvement for the infrastructure and common facilities (\u201Cspecial fund\u201D). Contributions will be made on a regular basis so that the fund is built up over time. The rate shall be Baht 100 per square metre per year for the initial year and may be subject to change. If the fund balance is not sufficient for the cost of major repairs, owners may be required to pay an additional amount as requested by the manager from time to time."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"The cost of water and electricity supplied to individual properties shall be based upon metered consumption.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"O.")," \u0421\u0431\u043E\u0440 \u0437\u0430 \u043E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u043D\u0438\u0435 \u043E\u0431\u0449\u0435\u0439 \u0442\u0435\u0440\u0440\u0438\u0442\u043E\u0440\u0438\u0438 \u0441\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 60 \u0431\u0430\u0442\u043E\u0432 \u0437\u0430 \u043A\u0432\u0430\u0434\u0440\u0430\u0442\u043D\u044B\u0439 \u043C\u0435\u0442\u0440 \u0432 \u0433\u043E\u0434 \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 \u043F\u0435\u0440\u0432\u043E\u0433\u043E \u0433\u043E\u0434\u0430 \u0438 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D \u0441\u043E\u0433\u043B\u0430\u0441\u043D\u043E \u0444\u0430\u043A\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u043C \u0440\u0430\u0441\u0445\u043E\u0434\u0430\u043C. \u0413\u043E\u0434\u043E\u0432\u0430\u044F \u043F\u043B\u0430\u0442\u0430 \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u044F\u0435\u0442\u0441\u044F \u043E\u0431\u0449\u0438\u043C \u043E\u0431\u044A\u0435\u043C\u043E\u043C \u0440\u0430\u0441\u0445\u043E\u0434\u043E\u0432 \u0438 \u043F\u0440\u043E\u043F\u043E\u0440\u0446\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u043E \u0440\u0430\u0437\u0434\u0435\u043B\u044F\u0435\u0442\u0441\u044F \u043C\u0435\u0436\u0434\u0443 \u0432\u0441\u0435\u043C\u0438 \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0430\u043C\u0438."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041A\u0440\u043E\u043C\u0435 \u0442\u043E\u0433\u043E, \u0434\u043B\u044F \u043A\u0430\u0436\u0434\u043E\u0433\u043E \u043F\u0440\u043E\u0435\u043A\u0442\u0430 \u0441\u043E\u0437\u0434\u0430\u0435\u0442\u0441\u044F \u0430\u043C\u043E\u0440\u0442\u0438\u0437\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u0444\u043E\u043D\u0434. \u0426\u0435\u043B\u044C \u0430\u043C\u043E\u0440\u0442\u0438\u0437\u0430\u0446\u0438\u043E\u043D\u043D\u043E\u0433\u043E \u0444\u043E\u043D\u0434\u0430 - \u043D\u0430\u043A\u043E\u043F\u043B\u0435\u043D\u0438\u0435 \u0441\u0440\u0435\u0434\u0441\u0442\u0432 \u043D\u0430 \u043A\u0430\u043F\u0438\u0442\u0430\u043B\u044C\u043D\u044B\u0439 \u0440\u0435\u043C\u043E\u043D\u0442 \u0438\u043D\u0444\u0440\u0430\u0441\u0442\u0440\u0443\u043A\u0442\u0443\u0440\u044B \u0438/\u0438\u043B\u0438 \u0443\u043B\u0443\u0447\u0448\u0435\u043D\u0438\u044F, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u0431\u0443\u0434\u0435\u0442 \u0440\u0435\u0448\u0435\u043D\u043E \u0441\u0434\u0435\u043B\u0430\u0442\u044C \u0432 \u0431\u0443\u0434\u0443\u0449\u0435\u043C. \u0420\u0430\u0437\u043C\u0435\u0440 \u0432\u0437\u043D\u043E\u0441\u043E\u0432 \u0441\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 100 \u0431\u0430\u0442\u043E\u0432 \u0437\u0430 \u043A\u0432\u0430\u0434\u0440\u0430\u0442\u043D\u044B\u0439 \u043C\u0435\u0442\u0440 \u0432 \u0433\u043E\u0434 \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 \u043F\u0435\u0440\u0432\u043E\u0433\u043E \u0433\u043E\u0434\u0430 \u0438 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u043F\u0435\u0440\u0435\u0441\u043C\u043E\u0442\u0440\u0435\u043D. \u0415\u0441\u043B\u0438 \u043E\u0441\u0442\u0430\u0442\u043A\u0430 \u0441\u0440\u0435\u0434\u0441\u0442\u0432 \u0444\u043E\u043D\u0434\u0430 \u0431\u0443\u0434\u0435\u0442 \u043D\u0435\u0434\u043E\u0441\u0442\u0430\u0442\u043E\u0447\u043D\u043E \u0434\u043B\u044F \u043F\u043E\u043A\u0440\u044B\u0442\u0438\u044F \u0440\u0430\u0441\u0445\u043E\u0434\u043E\u0432 \u043D\u0430 \u043C\u0430\u0441\u0448\u0442\u0430\u0431\u043D\u044B\u0435 \u0440\u0435\u043C\u043E\u043D\u0442\u043D\u044B\u0435 \u0440\u0430\u0431\u043E\u0442\u044B, \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0430\u043C \u043C\u043E\u0436\u0435\u0442 \u043F\u043E\u0442\u0440\u0435\u0431\u043E\u0432\u0430\u0442\u044C\u0441\u044F \u0432\u043D\u0435\u0441\u0442\u0438 \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u0443\u044E \u0441\u0443\u043C\u043C\u0443 \u043F\u043E \u0442\u0440\u0435\u0431\u043E\u0432\u0430\u043D\u0438\u044E \u0443\u043F\u0440\u0430\u0432\u043B\u044F\u044E\u0449\u0435\u0433\u043E."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041F\u043B\u0430\u0442\u0430 \u0437\u0430 \u0432\u043E\u0434\u043E- \u0438 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u0441\u043D\u0430\u0431\u0436\u0435\u043D\u0438\u0435 \u043E\u0442\u0434\u0435\u043B\u044C\u043D\u044B\u0445 \u043A\u0432\u0430\u0440\u0442\u0438\u0440 \u0434\u043E\u043B\u0436\u043D\u0430 \u0432\u0437\u0438\u043C\u0430\u0442\u044C\u0441\u044F \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u043F\u043E\u043A\u0430\u0437\u0430\u043D\u0438\u044F\u043C\u0438 \u0441\u0447\u0435\u0442\u0447\u0438\u043A\u043E\u0432.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u7B54.")," ","\u7B2C\u4E00\u5E74\u4E3A\u57FA\u7840\u8BBE\u65BD\u3001\u5171\u540C\u8BBE\u65BD\u3001\u63D0\u4F9B\u670D\u52A1(\u201C\u516C\u5171\u533A\u57DF\u670D\u52A1\u8D39\u201D)\u7684\u7269\u4E1A\u7EF4\u62A4\u6210\u672C\uFF0C \u52A0\u4E0A\u5411\u516C\u5BD3\u5176\u4ED6\u201C\u975E\u516C\u5171\u533A\u57DF\u8D39\u201D\u63D0\u4F9B\u7684\u670D\u52A1\u4E0E\u8BBE\u65BD\u4E4B\u7EF4\u62A4\u8D39\u7528\uFF0C\u521D\u59CB\u5408\u8BA1\u6BCF\u5E73\u65B9\u7C73\u6BCF\u5E74 60\u6CF0\u94E2\uFF0C\u53EF\u80FD\u4F1A\u6839\u636E\u4E0D\u540C\u65F6\u671F\u9700\u8981\u7684\u5B9E\u9645\u8D39\u7528\u800C\u6709\u6240\u53D8\u66F4\u3002\u5E74\u8D39\u7531\u6240\u53D1\u751F\u7684\u8D39\u7528\u603B\u989D\u51B3 \u5B9A\uFF0C\u5E76\u6309\u9500\u552E\u9762\u79EF\u6309\u6BD4\u4F8B\u5206\u914D\u7ED9\u4E2A\u5355\u4F4D\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u53E6\u5916\uFF0C\u8FD8\u5E94\u4E3A\u57FA\u7840\u8BBE\u65BD\u4E0E\u5171\u540C\u8BBE\u65BD\u7684\u4E3B\u8981\u7EF4\u4FEE\u3001\u4EE5\u53CA\u5176\u66F4\u6362\u548C/\u6216\u6539\u9020\u8D39\u7528\u8BBE\u7ACB\u57FA\u91D1 (\u201C\u7279\u522B\u57FA\u91D1\u201D)\u3002\u8BE5\u57FA\u91D1\u8981\u6C42\u4E1A\u4E3B\u5B9A\u671F\u652F\u4ED8\u4ECE\u800C\u4E0D\u65AD\u79EF\u6512\u3002\u521D\u59CB\u5E74\u5EA6\u8D39\u7528\u5E94\u4E3A\u6BCF\u5E73\u65B9\u7C73 100\u6CF0\u94E2\uFF0C\u53EF\u80FD\u4F1A\u6709\u6240\u53D8\u52A8\u3002\u5982\u679C\u57FA\u91D1\u7684\u4F59\u989D\u4E0D\u8DB3\u4EE5\u8FDB\u884C\u5927\u4FEE\u7F2E\u65F6\uFF0C\u5219\u4E1A\u4E3B\u53EF\u80FD\u9700\u8981\u6839\u636E \u7BA1\u7406\u65B9\u7684\u8981\u6C42\u3001\u4E0D\u65F6\u652F\u4ED8\u989D\u5916\u7684\u7EF4\u4FEE\u8D39\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u4F9B\u5E94\u7ED9\u5404\u516C\u5BD3\u7684\u6C34\u7535\u8D39\u7528\uFF0C\u5E94\u4EE5\u8BA1\u91CF\u6D88\u8D39\u4E3A\u51C6\u3002"))}},{categoryId:3,question:{en:"What property management services are provided?",ru:"Какие предоставляются услуги по управлению собственностью?",cn:"所提供的物业管理服务有哪些？"},displayOn:["en","ru","cn"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"A.")," Laguna will provide a full range of property services to individual owners including, pest control, routine and preventative maintenance, general repairs, housekeeping and other reasonable requests. Rates vary according to the frequency and scope of service. In addition, Laguna provides owners with the ability to generate a rental income from their property with short-term* and long-term rentals (see below).")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"O.")," \u0423\u043F\u0440\u0430\u0432\u043B\u044F\u044E\u0449\u0430\u044F \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u044F Laguna \u0438/\u0438\u043B\u0438 \u0441\u043E\u0442\u0440\u0443\u0434\u043D\u0438\u043A\u0438 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0441\u0430 Skypark Phuket \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u044F\u0442 \u043F\u043E\u043B\u043D\u044B\u0439 \u0441\u043F\u0435\u043A\u0442\u0440 \u0443\u0441\u043B\u0443\u0433, \u0432\u043A\u043B\u044E\u0447\u0430\u044F \u0431\u043E\u0440\u044C\u0431\u0443 \u0441 \u0432\u0440\u0435\u0434\u0438\u0442\u0435\u043B\u044F\u043C\u0438, \u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u043E\u0435 \u0438 \u043F\u0440\u043E\u0444\u0438\u043B\u0430\u043A\u0442\u0438\u0447\u0435\u0441\u043A\u043E\u0435 \u043E\u0431\u0441\u043B\u0443\u0436\u0438\u0432\u0430\u043D\u0438\u0435, \u043E\u0431\u0449\u0438\u0435 \u0440\u0435\u043C\u043E\u043D\u0442\u043D\u044B\u0435 \u0440\u0430\u0431\u043E\u0442\u044B, \u0443\u0431\u043E\u0440\u043A\u0443 \u0438 \u0434\u0440\u0443\u0433\u0438\u0435 \u0432\u0438\u0434\u044B \u0440\u0430\u0431\u043E\u0442 \u043F\u043E \u043F\u0440\u043E\u0441\u044C\u0431\u0435 \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0430. \u0421\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C \u0443\u0441\u043B\u0443\u0433 \u0437\u0430\u0432\u0438\u0441\u0438\u0442 \u043E\u0442 \u0447\u0430\u0441\u0442\u043E\u0442\u044B \u043C\u0430\u0441\u0448\u0442\u0430\u0431\u0430 \u0438\u0445 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0438\u044F. \u0411\u043E\u043B\u0435\u0435 \u0442\u043E\u0433\u043E, \u043E\u0442\u0434\u0435\u043B \u043F\u043E \u0430\u0440\u0435\u043D\u0434\u0435 \xABLaguna Rentals\xBB \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0430\u043C \u043A\u0432\u0430\u0440\u0442\u0438\u0440, \u043D\u0435 \u0432\u0445\u043E\u0434\u044F\u0449\u0438\u0445 \u0432 \u0441\u043E\u0441\u0442\u0430\u0432 \u043E\u0442\u0435\u043B\u044F, \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u044C \u043F\u043E\u043B\u0443\u0447\u0430\u0442\u044C \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u0434\u043E\u0445\u043E\u0434 \u043E\u0442 \u0441\u0434\u0430\u0447\u0438 \u0438\u0445 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u0438 \u0432 \u0434\u043E\u043B\u0433\u043E\u0441\u0440\u043E\u0447\u043D\u0443\u044E \u0438 \u043A\u0440\u0430\u0442\u043A\u043E\u0441\u0440\u043E\u0447\u043D\u0443\u044E \u0430\u0440\u0435\u043D\u0434\u0443* (\u0441\u043C. \u043D\u0438\u0436\u0435).")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u7B54.")," ","\u4E50\u53E4\u6D6A\u5C06\u4E3A\u4E2A\u4F53\u4E1A\u4E3B\u63D0\u4F9B\u5168\u65B9\u4F4D\u7684\u7269\u4E1A\u7BA1\u7406\u670D\u52A1\uFF0C\u5305\u62EC\u866B\u5BB3\u9632\u6CBB\u3001\u5E38\u89C4\u4E0E\u9884\u9632\u6027\u7EF4\u62A4\u3001\u4E00\u822C\u7EF4\u4FEE\u3001\u5BB6\u653F\u670D\u52A1\uFF0C\u4EE5\u53CA\u5176\u4ED6\u5408\u7406\u8981\u6C42\u3002\u6536\u8D39\u89C6\u670D\u52A1\u7684\u9891\u7387\u4E0E\u8303\u56F4\u800C\u5F02\u3002\u6B64\u5916\uFF0C\u901A\u8FC7\u4E50\u53E4\u6D6A\u56E2\u961F\u53EF\u8BA9\u4E1A\u4E3B\u5728\u4F4F\u5B85\u7A7A\u7F6E\u65F6\u4EE5\u77ED\u671F*\u548C\u957F\u671F\u51FA\u79DF\uFF08\u89C1\u4E0B\u6587\uFF09\u7684\u65B9\u5F0F\u83B7\u53D6\u79DF\u91D1\u6536\u76CA\u3002"))}},{categoryId:3,question:{en:"Can I rent my unit out on my own?",ru:"Могу ли я самостоятельно сдать в аренду свою квартиру?",cn:"我是否可以自行租赁我的单位？"},displayOn:["en","ru","cn"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"A.")," Yes, owners may rent out their property on a long-term basis (6 months or more) directly or through external agents."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"For short-term* rentals less than 6 months, these must be conducted exclusively through Laguna Rentals who provides owners with the ability to generate a rental income from their property when not in residence with short-term and long-term rentals."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"* Terms and conditions apply"))),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"O.")," \u0414\u0430. \u0412 \u0441\u043B\u0443\u0447\u0430\u0435 \u0441\u0434\u0430\u0447\u0438 \u0432 \u0430\u0440\u0435\u043D\u0434\u0443 \u043D\u0430 \u0434\u043B\u0438\u0442\u0435\u043B\u044C\u043D\u044B\u0439 \u0441\u0440\u043E\u043A (6 \u043C\u0435\u0441\u044F\u0446\u0435\u0432 \u0438 \u0431\u043E\u043B\u0435\u0435) \u043D\u0435\u0442 \u043D\u0438\u043A\u0430\u043A\u0438\u0445 \u043E\u0433\u0440\u0430\u043D\u0438\u0447\u0435\u043D\u0438\u0439, \u0441\u0434\u0430\u0447\u0430 \u0432 \u0430\u0440\u0435\u043D\u0434\u0443 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u043F\u0440\u043E\u0438\u0437\u0432\u0435\u0434\u0435\u043D\u0430 \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0435\u043C \u0438\u043B\u0438 \u0441\u0442\u043E\u0440\u043E\u043D\u043D\u0438\u043C \u0430\u0433\u0435\u043D\u0442\u043E\u043C."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0412 \u0441\u043B\u0443\u0447\u0430\u0435 \u043A\u0440\u0430\u0442\u043A\u043E\u0441\u0440\u043E\u0447\u043D\u043E\u0439* \u0430\u0440\u0435\u043D\u0434\u044B \u043E\u0442 1 \u0434\u043E 6 \u043C\u0435\u0441\u044F\u0446\u0435\u0432, \u0432\u0441\u0435 \u043E\u043F\u0435\u0440\u0430\u0446\u0438\u0438 \u0434\u043E\u043B\u0436\u043D\u044B \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0442\u044C\u0441\u044F \u0447\u0435\u0440\u0435\u0437 \u043E\u0442\u0434\u0435\u043B \u043F\u043E \u0430\u0440\u0435\u043D\u0434\u0435 Laguna Rentals, \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u044E\u0449\u0438\u0439 \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0430\u043C \u0436\u0438\u043B\u043E\u0439 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u0438, \u043D\u0435 \u044F\u0432\u043B\u044F\u044E\u0449\u0438\u0445\u0441\u044F \u0447\u0430\u0441\u0442\u044C\u044E \u043E\u0442\u0435\u043B\u044F, \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u044C \u043F\u043E\u043B\u0443\u0447\u0435\u043D\u0438\u044F \u0434\u043E\u043F\u043E\u043B\u043D\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0433\u043E \u0434\u043E\u0445\u043E\u0434\u0430 \u0441 \u0430\u0440\u0435\u043D\u0434\u044B \u0438\u0445 \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438, \u0435\u0441\u043B\u0438 \u0442\u0435 \u043D\u0435 \u043F\u0440\u043E\u0436\u0438\u0432\u0430\u044E\u0442 \u0442\u0430\u043C \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 \u043A\u043E\u0440\u043E\u0442\u043A\u043E\u0433\u043E \u0438\u043B\u0438 \u0434\u043B\u0438\u0442\u0435\u043B\u044C\u043D\u043E\u0433\u043E \u043F\u0435\u0440\u0438\u043E\u0434\u0430."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0421\u0434\u0430\u0447\u0430 \u0432 \u0430\u0440\u0435\u043D\u0434\u0443 \u043D\u0430 \u043A\u043E\u0440\u043E\u0442\u043A\u0438\u0439* \u0441\u0440\u043E\u043A \u043C\u0435\u043D\u0435\u0435 30 \u0434\u043D\u0435\u0439 \u0434\u043E\u043B\u0436\u043D\u0430 \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0442\u044C\u0441\u044F \u0438\u0441\u043A\u043B\u044E\u0447\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0443 \u0430\u0440\u0435\u043D\u0434\u044B Skypark Phuket (\u0432\u043B\u0430\u0434\u0435\u044E\u0449\u0430\u044F \u0433\u043E\u0441\u0442\u0438\u043D\u0438\u0447\u043D\u043E\u0439 \u043B\u0438\u0446\u0435\u043D\u0437\u0438\u0435\u0439). \u0412 \u043A\u0432\u0430\u0440\u0442\u0438\u0440\u0430\u0445, \u0443\u043F\u0440\u0430\u0432\u043B\u044F\u0435\u043C\u044B\u0445 \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u0433\u043E\u0441\u0442\u0438\u043D\u0438\u0447\u043D\u043E\u0439 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u043E\u0439 \u0441\u0434\u0430\u0447\u0438 \u0432 \u0430\u0440\u0435\u043D\u0434\u0443, \u0434\u043E\u043B\u0436\u0435\u043D \u043F\u0440\u0438\u0441\u0443\u0442\u0441\u0442\u0432\u043E\u0432\u0430\u0442\u044C \u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u044B\u0439 \u043D\u0430\u0431\u043E\u0440 \u043C\u0435\u0431\u0435\u043B\u0438."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"* \u041F\u0440\u0438\u043C\u0435\u043D\u044F\u044E\u0442\u0441\u044F \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u044B\u0435 \u043F\u0440\u0430\u0432\u0438\u043B\u0430 \u0438 \u0443\u0441\u043B\u043E\u0432\u0438\u044F."))),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u7B54.")," ","\u7B54.\u662F\u7684\uFF0C\u4E1A\u4E3B\u53EF\u4EE5\u76F4\u63A5\u6216\u901A\u8FC7\u5916\u90E8\u4E2D\u4ECB\u957F\u671F\uFF086\u4E2A\u6708\u6216\u66F4\u957F\u65F6\u95F4\uFF09\u51FA\u79DF\u5176\u623F\u4EA7\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u5BF9\u4E8E\u4F4E\u4E8E6\u4E2A\u6708\u7684\u77ED\u671F*\u79DF\u8D41\uFF0C\u4E1A\u4E3B\u5C31\u5FC5\u987B\u901A\u8FC7\u4E50\u53E4\u6D6A\u79DF\u8D41\uFF08Laguna Rentals\uFF09\u6765\u8FDB\u884C\u3002\u8FD9\u4F7F\u4E1A\u4E3B\u80FD\u591F\u5728\u4E0D\u5C45\u4F4F\u671F\u95F4\uFF0C\u901A\u8FC7\u77ED\u671F\u548C\u957F\u671F\u79DF\u8D41\u4ECE\u5176\u623F\u4EA7\u4E2D\u83B7\u5F97\u79DF\u91D1\u6536\u5165\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"* \u9700\u53D7\u4E00\u5B9A\u6761\u6B3E\u4E0E\u6761\u4EF6\u7EA6\u675F\u3002")))}},{categoryId:3,question:{en:"What are the taxes levied on rental income that an owner will be subject to?",ru:"Какие налоги должен будет выплачивать владелец с дохода от сдачи в аренду?",cn:"业主需要缴纳哪些租金收入税？"},displayOn:["en","ru","cn"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"A.")," Owners may be required to file an income tax return in Thailand based upon rental income earned and pay the applicable tax. Rental distributions made to owners may be subject to withholding tax under the Thai Revenue Code with rates ranging from 5 \u2013 15%, subject to owners tax structure status."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"Note: applicable tax rates are current at the date of issue of this FAQ and may be subject to changes. The unit owner shall be responsible for any income and any other taxes, duties and fees of whatever nature which may be levied by relevant authorities on the unit in connection with the rental."))),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"O.")," \u0414\u043E\u0445\u043E\u0434\u044B \u0441 \u0430\u0440\u0435\u043D\u0434\u044B, \u043F\u043E\u043B\u0443\u0447\u0430\u0435\u043C\u044B\u0435 \u0437\u0430\u0440\u0443\u0431\u0435\u0436\u043D\u044B\u043C\u0438 \u0433\u0440\u0430\u0436\u0434\u0430\u043D\u0430\u043C\u0438, \u043E\u0431\u043B\u0430\u0433\u0430\u044E\u0442\u0441\u044F \u043D\u0430\u043B\u043E\u0433\u043E\u043C \u0432 15%. \u0414\u043E\u0445\u043E\u0434\u044B \u0441 \u0430\u0440\u0435\u043D\u0434\u044B, \u043F\u043E\u043B\u0443\u0447\u0430\u0435\u043C\u044B\u0435 \u0433\u0440\u0430\u0436\u0434\u0430\u043D\u0430\u043C\u0438 \u0422\u0430\u0438\u043B\u0430\u043D\u0434\u0430, \u043E\u0431\u043B\u0430\u0433\u0430\u044E\u0442\u0441\u044F \u043D\u0430\u043B\u043E\u0433\u043E\u043C \u0432 5%."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"\u041F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0435: \u043F\u0440\u0438\u0432\u0435\u0434\u0435\u043D\u043D\u044B\u0435 \u043D\u0430\u043B\u043E\u0433\u043E\u0432\u044B\u0435 \u0441\u0442\u0430\u0432\u043A\u0438 \u044F\u0432\u043B\u044F\u044E\u0442\u0441\u044F \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u043C\u0438 \u043D\u0430 \u043C\u043E\u043C\u0435\u043D\u0442 \u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0446\u0438\u0438 \u0434\u0430\u043D\u043D\u043E\u0433\u043E \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0441 \u0447\u0430\u0441\u0442\u043E \u0437\u0430\u0434\u0430\u0432\u0430\u0435\u043C\u044B\u043C\u0438 \u0432\u043E\u043F\u0440\u043E\u0441\u0430\u043C\u0438 \u0438 \u043C\u043E\u0433\u0443\u0442 \u0431\u044B\u0442\u044C \u043F\u0435\u0440\u0435\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u044B. \u0412\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u044B \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u043D\u0435\u0441\u0443\u0442 \u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u044C \u0437\u0430 \u043F\u043E\u043B\u0443\u0447\u0430\u0435\u043C\u044B\u0435 \u0434\u043E\u0445\u043E\u0434\u044B \u0438 \u0443\u043F\u043B\u0430\u0442\u0443 \u0440\u0430\u0437\u043D\u043E\u043E\u0431\u0440\u0430\u0437\u043D\u044B\u0445 \u043D\u0430\u043B\u043E\u0433\u043E\u0432, \u043F\u043E\u0448\u043B\u0438\u043D \u0438 \u0441\u0431\u043E\u0440\u043E\u0432, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u043C\u043E\u0433\u0443\u0442 \u0432\u0437\u0438\u043C\u0430\u0442\u044C\u0441\u044F \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u043C\u0438 \u0433\u043E\u0441\u0443\u0434\u0430\u0440\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u043C\u0438 \u043E\u0440\u0433\u0430\u043D\u0430\u043C\u0438 \u0432 \u0441\u0432\u044F\u0437\u0438 \u0441\u043E \u0441\u0434\u0430\u0447\u0435\u0439 \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u0432 \u0430\u0440\u0435\u043D\u0434\u0443."))),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u7B54.")," ","\u4E1A\u4E3B\u9700\u8981\u6839\u636E\u6240\u8D5A\u53D6\u7684\u79DF\u91D1\u6536\u5165\u5728\u6CF0\u56FD\u63D0\u4EA4\u6240\u5F97\u7A0E\u7533\u62A5\u8868\u5E76\u652F\u4ED8\u9002\u7528\u7684\u7A0E\u6B3E\u3002\u6839\u636E\u6CF0\u56FD\u7A0E \u6CD5\uFF0C\u5411\u4E1A\u4E3B\u5206\u914D\u7684\u79DF\u91D1\u9700\u8981\u7F34\u7EB3 5% \u81F3 15% \u7684\u7A0E\u8D39\uFF0C\u5177\u4F53\u53D6\u51B3\u4E8E\u4E1A\u4E3B\u7684\u7A0E\u6536\u7ED3\u6784\u72B6\u51B5\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"\u5907\u6CE8\uFF1A\u9002\u7528\u7684\u7A0E\u7387\u662F\u672C\u5E38\u89C1\u95EE\u9898\u89E3\u7B54\u53D1\u5E03\u4E4B\u65E5\u7684\u73B0\u884C\u7A0E\u7387\uFF0C\u53EF\u80FD\u4F1A\u6709\u6240\u53D8\u5316\u3002\u623F\u5C4B\u6301\u6709\u8005\u5E94\u5BF9\u6709\u5173 \u5F53\u5C40\u53EF\u80FD\u5BF9\u5355\u4F4D\u5F81\u6536\u7684\u4E0E\u79DF\u91D1\u6709\u5173\u7684\u4EFB\u4F55\u6536\u5165\u548C\u4EFB\u4F55\u5176\u4ED6\u7A0E\u6536\u3001\u5173\u7A0E\u548C\u8D39\u7528\u8D1F\u8D23\u3002")))}},{categoryId:4,question:{en:"What privileges will I receive as an owner?",ru:" Какие привилегии я получу как владелец?",cn:"作为业主，我能享受何特权？"},displayOn:["en","ru","cn"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Owners will receive membership to the Banyan Group\u2019s signature property owners\u2019 program, the Sanctuary Club*, which entitles owners to discounts and privileges at the Group\u2019s resorts, spas and galleries worldwide including:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"30% discount on best available rates for hotel accommodation"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"30% discount on golf green fees"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"25% discount on food and beverage"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"20% discount on a-la-carte spa menu"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"15% discount on gallery merchandise"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"15% discount on in-house tours"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"15% discount on laundry"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"10% discount airport transfers"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Priority wait-list on reservations"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Early check-in / late check-out")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"* Terms and conditions apply."))),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0412\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u044B \u0441\u0442\u0430\u043D\u0443\u0442 \u0447\u043B\u0435\u043D\u0430\u043C\u0438 \u043E\u0441\u043E\u0431\u043E\u0439 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438 Banyan Group - Sanctuary Club*, \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u044E\u0449\u0435\u0439 \u0441\u043A\u0438\u0434\u043A\u0438 \u0438 \u043F\u0440\u0438\u0432\u0438\u043B\u0435\u0433\u0438\u0438 \u043D\u0430 \u043A\u0443\u0440\u043E\u0440\u0442\u0430\u0445 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438, \u0432 \u0441\u043F\u0430-\u0446\u0435\u043D\u0442\u0440\u0430\u0445 \u0438 \u0433\u0430\u043B\u0435\u0440\u0435\u044F\u0445 \u043F\u043E \u0432\u0441\u0435\u043C\u0443 \u043C\u0438\u0440\u0443, \u0432\u043A\u043B\u044E\u0447\u0430\u044F:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u0441\u043A\u0438\u0434\u043A\u0430 30% \u043E\u0442 \u043B\u0443\u0447\u0448\u0438\u0445 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B\u0445 \u0446\u0435\u043D \u043D\u0430 \u043F\u0440\u043E\u0436\u0438\u0432\u0430\u043D\u0438\u0435 \u0432 \u043E\u0442\u0435\u043B\u044F\u0445;"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u0441\u043A\u0438\u0434\u043A\u0430 25% \u043D\u0430 \u0435\u0434\u0443 \u0438 \u043D\u0430\u043F\u0438\u0442\u043A\u0438;"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u0441\u043A\u0438\u0434\u043A\u0430 30% \u043E\u0442 \u043D\u0430 \u0433\u043E\u043B\u044C\u0444;"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u0441\u043A\u0438\u0434\u043A\u0430 20% \u043D\u0430 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0441 \u0441\u043F\u0430-\u043F\u0440\u043E\u0446\u0435\u0434\u0443\u0440 \xE0 la carte;"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u0441\u043A\u0438\u0434\u043A\u0430 15% \u043D\u0430 \u043F\u043E\u043A\u0443\u043F\u043A\u0438 \u0432 \u0442\u043E\u0440\u0433\u043E\u0432\u043E\u0439 \u0433\u0430\u043B\u0435\u0440\u0435\u0435;"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u0441\u043A\u0438\u0434\u043A\u0430 15% \u043E\u0442 \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u0438 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0443\u0435\u043C\u044B\u0445 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0435\u0439 \u044D\u043A\u0441\u043A\u0443\u0440\u0441\u0438\u0439;"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u0441\u043A\u0438\u0434\u043A\u0430 15% \u043D\u0430 \u0443\u0441\u043B\u0443\u0433\u0438 \u043F\u0440\u0430\u0447\u0435\u0447\u043D\u043E\u0439;"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u0441\u043A\u0438\u0434\u043A\u0430 10% \u043E\u0442 \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u0438 \u0442\u0440\u0430\u043D\u0441\u0444\u0435\u0440\u0430 \u043E\u0442/\u0434\u043E \u0430\u044D\u0440\u043E\u043F\u043E\u0440\u0442\u0430 \u0438\u043B\u0438 \u043F\u0430\u0440\u043E\u043C\u043D\u043E\u0433\u043E \u0442\u0435\u0440\u043C\u0438\u043D\u0430\u043B\u0430;"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u043F\u0440\u0438\u043E\u0440\u0438\u0442\u0435\u0442 \u0432 \u043B\u0438\u0441\u0442\u0435 \u043E\u0436\u0438\u0434\u0430\u043D\u0438\u0439 \u043F\u0440\u0438 \u0431\u0440\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F\u0445;"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u0440\u0430\u043D\u043D\u0438\u0439 \u0437\u0430\u0435\u0437\u0434 / \u043F\u043E\u0437\u0434\u043D\u0438\u0439 \u0432\u044B\u0435\u0437\u0434")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0412\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0430\u043C, \u0443\u0447\u0430\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u043C \u0432 \u0433\u043E\u0441\u0442\u0438\u043D\u0438\u0447\u043D\u043E\u0439 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0435 \u043F\u043E \u0441\u0434\u0430\u0447\u0435 \u0436\u0438\u043B\u044C\u044F \u0432 \u0430\u0440\u0435\u043D\u0434\u0443, \u0431\u0443\u0434\u0435\u0442 \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0430 \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u044C \u043E\u0431\u043C\u0435\u043D\u044F\u0442\u044C \u0447\u0430\u0441\u0442\u044C \u0441\u0432\u043E\u0438\u0445 \u0433\u043E\u0434\u043E\u0432\u044B\u0445 \u043F\u0440\u0430\u0432 \u043D\u0430 \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u044C \u043D\u0430 \u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u043E\u0435 \u043F\u0440\u0435\u0431\u044B\u0432\u0430\u043D\u0438\u0435 \u0432 \u0443\u0447\u0430\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0445 \u0432 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0435 \u043E\u0431\u043C\u0435\u043D\u0430*, \u043D\u0430\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F\u0445 \u043F\u043E \u0432\u0441\u0435\u043C\u0443 \u043C\u0438\u0440\u0443."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"* \u041F\u0440\u0438\u043C\u0435\u043D\u044F\u044E\u0442\u0441\u044F \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u043D\u044B\u0435 \u043F\u0440\u0430\u0432\u0438\u043B\u0430 \u0438 \u0443\u0441\u043B\u043E\u0432\u0438\u044F."))),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u4E1A\u4E3B\u5C06\u6210\u4E3A\u60A6\u6995\u96C6\u56E2\u4E13\u5C5E\u7684\u201C\u6995\u6E90\u4F1A\u4FF1\u4E50\u90E8\u201D\u4F1A\u5458\uFF0C\u83B7\u5F97\u5168\u7403\u96C6\u56E2\u54C1\u724C\u65D7\u4E0B\u7684\u5EA6\u5047\u6751, Spa \u548C\u827A\u54C1\u9601\u7684\u6298\u6263\u548C\u7279\u6743:\uFF0C\u5305\u62EC\uFF1A"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u9152\u5E97\u4F4F\u5BBF\u6700\u4F18\u623F\u4EF7\u518D\u6253 7 \u6298"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u98DF\u7269\u548C\u996E\u6599 7.5 \u6298"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u9AD8\u5C14\u592B\u679C\u5CAD\u8D39 7 \u6298"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u5355\u70B9\u6C34\u7597\u62A4\u7406 8 \u6298"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u827A\u5ECA\u4F5C\u54C1 8.5 \u6298"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u9152\u5E97\u5185\u5BFC\u89C8 8.5 \u6298"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u6D17\u8863\u623F 8.5 \u6298"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u673A\u573A\u548C\u8F6E\u6E21\u7801\u5934\u63A5\u9001 9 \u6298"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u9884\u5B9A\u7B49\u5019\u540D\u5355\u6392\u961F\u4F18\u5148\u6743"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u63D0\u524D\u5165\u4F4F/\u5EF6\u8FDF")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"* \u9700\u53D7\u4E00\u5B9A\u6761\u6B3E\u4E0E\u6761\u4EF6\u7EA6\u675F")))}},{categoryId:5,question:{en:"What are the terms of payment?",ru:"Каковы условия оплаты?",cn:"付款方式是什么？"},displayOn:["en","ru","cn"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"A.")," There are 2 options available:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Option 1: 100% Payment upon purchase / during construction"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"100% payment upon purchase for already completed properties. Progressive payments for properties under construction are as per the table below."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Construction Payment Term"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"th-col2"},"Of Selling Price"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"st")," Payment upon signing contract"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"nd")," Payment when construction is 25% complete",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"rd")," Payment when construction is 50% complete",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"th")," Payment when construction is 75% complete",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"3")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"th")," Payment upon completion of construction"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{textAlign:"center"}},"Total"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"100%")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Notes:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",{className:"notes"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"1. Concrete structure substantially completed")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"2. Roof, brickwork and rendering substantially completed")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"3. Electrical conduits, pipework and plastering substantially completed"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Option 2: 50% payment upon purchase / during construction with 50% deferred payment over 1, 3 or 5 years"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"50% payment upon purchase for already completed properties. Progressive payments for properties under construction (50% during construction / 50% post construction) as per the table below."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Deferred Payment Plan"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"th-col2"},"Of Selling Price"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"st")," Payment upon signing contract"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"nd")," Payment when construction is 25% complete",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"10%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"rd")," Payment when construction is 50% complete",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"10%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"th")," Payment when construction is 75% complete",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"3")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"10%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"Post construction payments",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"4")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"50%")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Financing Options"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"th-col2"},"Interest Rate",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"(per annum)"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1 Year (4 quarterly installments)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"3%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3 Year (12 quarterly installments)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"5%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5 Year (20 quarterly installments)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"7%")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Notes:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",{className:"notes"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"1. Concrete structure substantially completed")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"2. Roof, brickwork and rendering substantially completed")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"3. Electrical conduits, pipework and plastering substantially completed")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"4. See table below"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"table-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"tr-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Price")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Reservation Deposit")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Construction Completion",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Payment 50% (Minus Deposit)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Remaining Post Finance 50%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:"3",className:"td-group-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Quarterly Installment"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"tr-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"1 Year (3%)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"3 Year (5%)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"5 Year (7%)"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"509,410"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"180,517"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"119,382")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,150,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,250,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"573,086"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"203,081"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"134,305")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"636,763"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"225,646"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"149,228")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,650,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,750,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"700,439"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"248,210"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"164,151")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"6,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"764,115"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"270,775"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"179,074")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"6,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3,150,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3,250,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"827,791"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"293,340"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"193,996")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"7,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"891,468"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"315,904"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"208,919")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"7,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3,650,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3,750,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"955,144"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"338,469"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"223,842")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"8,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,018,820"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"361,033"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"238,765")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"8,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4,150,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4,250,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,082,496"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"383,598"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"253,688")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"9,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,146,173"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"406,162"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"268,611")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"9,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4,650,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4,750,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,209,849"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"428,727"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"283,533")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"10,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,273,525"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"451,292"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"298,456")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"10,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5,150,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5,250,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,337,201"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"473,856"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"313,379")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"11,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,400,878"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"496,421"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"328,302")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"11,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5,650,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5,750,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,464,554"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"518,985"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"343,225")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"12,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"6,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,528,230"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"541,550"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"358,147")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Notes:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",{className:"notes"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"1. All amounts are stated in Thai Baht (THB).")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"2. The above table sets out the estimated payments required under the respective payment plans for selling prices between THB 4,000,000 \u2013 12,000,000.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"3. The estimated payments are indicative only and the developer / seller does not accept any responsibility or liability whatsoever for any inaccuracies or omissions.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"4. Payment terms are subject to change without notice.")))),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"O.")," \u0421\u0443\u0449\u0435\u0441\u0442\u0432\u0443\u044E\u0442 \u0434\u0432\u0430 \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0430:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u0412\u0430\u0440\u0438\u0430\u043D\u0442 1: 100%-\u043D\u0430\u044F \u043E\u043F\u043B\u0430\u0442\u0430 \u0432 \u043C\u043E\u043C\u0435\u043D\u0442 \u043F\u043E\u043A\u0443\u043F\u043A\u0438 / \u0432 \u043F\u0435\u0440\u0438\u043E\u0434 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"100%-\u043E\u043F\u043B\u0430\u0442\u0430 \u043F\u0440\u0438 \u043F\u043E\u043A\u0443\u043F\u043A\u0435 \u0443\u0436\u0435 \u0433\u043E\u0442\u043E\u0432\u043E\u0433\u043E \u043E\u0431\u044A\u0435\u043A\u0442\u0430. \u041F\u0440\u043E\u0433\u0440\u0435\u0441\u0441\u0438\u0432\u043D\u044B\u0435 \u043F\u043B\u0430\u0442\u0435\u0436\u0438 \u0434\u043B\u044F \u0441\u0442\u0440\u043E\u044F\u0449\u0438\u0445\u0441\u044F \u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432 \u0441\u043C. \u0432 \u0442\u0430\u0431\u043B\u0438\u0446\u0435 \u043D\u0438\u0436\u0435."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"\u0421\u0440\u043E\u043A \u043F\u043B\u0430\u0442\u0435\u0436\u0430 \u043D\u0430 \u043C\u043E\u043C\u0435\u043D\u0442 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"th-col2"},"% \u043E\u0442 \u0446\u0435\u043D\u044B \u043F\u0440\u043E\u0434\u0430\u0436\u0438"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1-\u044B\u0439 \u043F\u043B\u0430\u0442\u0435\u0436 \u043F\u0440\u0438 \u0437\u0430\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0438 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2-\u043E\u0439 \u043F\u043B\u0430\u0442\u0435\u0436 \u043F\u0440\u0438 25 %-\u043D\u043E\u0439 \u0433\u043E\u0442\u043E\u0432\u043D\u043E\u0441\u0442\u0438 \u043E\u0431\u044A\u0435\u043A\u0442\u0430",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"3")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3-\u0438\u0439 \u043F\u043B\u0430\u0442\u0435\u0436 \u043F\u0440\u0438 50 %-\u043D\u043E\u0439 \u0433\u043E\u0442\u043E\u0432\u043D\u043E\u0441\u0442\u0438 \u043E\u0431\u044A\u0435\u043A\u0442\u0430",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"4")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4-\u044B\u0439 \u043F\u043B\u0430\u0442\u0435\u0436 \u043F\u0440\u0438 75 %-\u043D\u043E\u0439 \u0433\u043E\u0442\u043E\u0432\u043D\u043E\u0441\u0442\u0438 \u043E\u0431\u044A\u0435\u043A\u0442\u0430",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"5")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5-\u044B\u0439 \u043F\u043B\u0430\u0442\u0435\u0436 \u043F\u043E \u043E\u043A\u043E\u043D\u0447\u0430\u043D\u0438\u0438 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{textAlign:"center"}},"\u0412\u0441\u0435\u0433\u043E"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"100%")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u041F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u044F:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",{className:"notes"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"1. \u041F\u043B\u043E\u0449\u0430\u0434\u0438 \u0438 \u0440\u0430\u0437\u043C\u0435\u0440\u044B \u0443\u043A\u0430\u0437\u0430\u043D\u044B \u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0438 \u043C\u043E\u0433\u0443\u0442 \u0438\u0437\u043C\u0435\u043D\u044F\u0442\u044C\u0441\u044F \u043F\u043E \u0438\u0442\u043E\u0433\u0430\u043C \u0444\u0438\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0438\u0437\u043C\u0435\u0440\u0435\u043D\u0438\u0439.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{margin:0}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"2. \u0411\u0410\u0417\u041E\u0412\u042B\u0419 \u0432\u0430\u0440\u0438\u0430\u043D\u0442: \u0432\u0441\u0442\u0440\u043E\u0435\u043D\u043D\u044B\u0435 \u0431\u044B\u0442\u043E\u0432\u044B\u0435 \u043F\u0440\u0438\u0431\u043E\u0440\u044B, \u0441\u0430\u043D\u0442\u0435\u0445\u043D\u0438\u043A\u0430 \u0438 \u0442\u0435\u0445\u043D\u0438\u043A\u0430 \u041D\u0415 \u0432\u043A\u043B\u044E\u0447\u0435\u043D\u044B \u043F\u0440\u0438 \u043F\u043E\u043A\u0443\u043F\u043A\u0435 \u043E\u0431\u044C\u0435\u043A\u0442\u0430 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u0438. \u0412\u0430\u0440\u0438\u0430\u043D\u0442 \u0421\u041E \u0412\u0421\u0422\u0420\u041E\u0415\u041D\u041D\u041E\u0419 \u041C\u0415\u0411\u0415\u041B\u042C\u042E: \u0432\u0441\u0442\u0440\u043E\u0435\u043D\u043D\u044B\u0435 \u0431\u044B\u0442\u043E\u0432\u044B\u0435 \u043F\u0440\u0438\u0431\u043E\u0440\u044B, \u0441\u0430\u043D\u0442\u0435\u0445\u043D\u0438\u043A\u0430 \u0438 \u0442\u0435\u0445\u043D\u0438\u043A\u0430 \u0432\u043A\u043B\u044E\u0447\u0435\u043D\u044B \u043F\u0440\u0438 \u043F\u043E\u043A\u0443\u043F\u043A\u0435 \u043E\u0431\u044C\u0435\u043A\u0442\u0430 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u0438.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{margin:0}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u041C\u0415\u0411\u041B\u0418\u0420\u041E\u0412\u0410\u041D\u041D\u042B\u0419 \u0432\u0430\u0440\u0438\u0430\u043D\u0442: \u0432\u0441\u0442\u0440\u043E\u0435\u043D\u043D\u0430\u044F \u043C\u0435\u0431\u0435\u043B\u044C, \u0441\u0430\u043D\u0442\u0435\u0445\u043D\u0438\u043A\u0430, \u0442\u0435\u0445\u043D\u0438\u043A\u0430 \u0438 \u043D\u0435\u0432\u0441\u0442\u0440\u043E\u0435\u043D\u043D\u0430\u044F \u043C\u0435\u0431\u0435\u043B\u044C \u0432\u043A\u043B\u044E\u0447\u0435\u043D\u044B \u043F\u0440\u0438 \u043F\u043E\u043A\u0443\u043F\u043A\u0435 \u043E\u0431\u044C\u0435\u043A\u0442\u0430 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u0438."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"3. \u0411\u0435\u0442\u043E\u043D\u043D\u0430\u044F \u043A\u043E\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0438\u044F \u0432 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u043C \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0430.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"4. \u041A\u0440\u044B\u0448\u0430, \u0443\u043A\u043B\u0430\u0434\u043A\u0430 \u043A\u0438\u0440\u043F\u0438\u0447\u0430 \u0438 \u043D\u0430\u0440\u0443\u0436\u043D\u0430\u044F \u043E\u0442\u0434\u0435\u043B\u043A\u0430 \u0432 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u043C \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u044B.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"5. \u042D\u043B\u0435\u043A\u0442\u0440\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u043F\u0440\u043E\u0432\u043E\u0434\u043A\u0430, \u0443\u043A\u043B\u0430\u0434\u043A\u0430 \u0432\u043E\u0434\u043E\u043F\u0440\u043E\u0432\u043E\u0434\u043D\u044B\u0445 \u0442\u0440\u0443\u0431 \u0438 \u0432\u043D\u0443\u0442\u0440\u0435\u043D\u043D\u044F\u044F \u043E\u0442\u0434\u0435\u043B\u043A\u0430 \u0432 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u043C \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u044B.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"6. \u041F\u0440\u043E\u0446\u0435\u043D\u0442\u044B \u043F\u043E \u0440\u0430\u0441\u0441\u0440\u043E\u0447\u043A\u0435 \u0431\u0443\u0434\u0443\u0442 \u043D\u0430\u0447\u0438\u0441\u043B\u0435\u043D\u044B \u043D\u0430 \u043E\u0442\u043B\u043E\u0436\u0435\u043D\u043D\u044B\u0435 \u043F\u043B\u0430\u0442\u0435\u0436\u0438 \u043F\u043E \u043E\u043A\u043E\u043D\u0447\u0430\u043D\u0438\u0438 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430, \u043A\u0430\u043A \u0443\u043A\u0430\u0437\u0430\u043D\u043E \u0432 \u0442\u0430\u0431\u043B\u0438\u0446\u0435 \xAB\u0412\u0430\u0440\u0438\u0430\u043D\u0442\u044B \u0444\u0438\u043D\u0430\u043D\u0441\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F\xBB"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u0412\u0430\u0440\u0438\u0430\u043D\u0442 2: \u041E\u043F\u043B\u0430\u0442\u0430 50% \u043F\u0440\u0438 \u043F\u043E\u043A\u0443\u043F\u043A\u0435 \u0443\u0436\u0435 \u0433\u043E\u0442\u043E\u0432\u043E\u0439 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u0438. \u041F\u0440\u043E\u0433\u0440\u0435\u0441\u0441\u0438\u0432\u043D\u044B\u0435 \u043F\u043B\u0430\u0442\u0435\u0436\u0438 \u0437\u0430 \u043E\u0431\u044A\u0435\u043A\u0442\u044B \u043D\u0435\u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043D\u043E\u0433\u043E \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 (50% \u0432\u043E \u0432\u0440\u0435\u043C\u044F \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 / 50% \u043F\u043E\u0441\u043B\u0435 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430) \u0441\u043E\u0433\u043B\u0430\u0441\u043D\u043E \u0442\u0430\u0431\u043B\u0438\u0446\u0435 \u043D\u0438\u0436\u0435."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"\u041F\u0440\u043E\u0433\u0440\u0435\u0441\u0441\u0438\u0432\u043D\u044B\u0435 \u043F\u043B\u0430\u0442\u0435\u0436\u0438 \u0434\u043B\u044F \u0441\u0442\u0440\u043E\u044F\u0449\u0438\u0445\u0441\u044F \u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432 (50% \u0432 \u043F\u0435\u0440\u0438\u043E\u0434 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 / 50% \u043F\u043E \u043E\u043A\u043E\u043D\u0447\u0430\u043D\u0438\u0438 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430) \u0441\u043C. \u0432 \u0442\u0430\u0431\u043B\u0438\u0446\u0435 \u043D\u0438\u0436\u0435."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"\u0413\u0440\u0430\u0444\u0438\u043A \u043E\u0442\u043B\u043E\u0436\u0435\u043D\u043D\u044B\u0445 \u043F\u043B\u0430\u0442\u0435\u0436\u0435\u0439"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"th-col2"},"% \u043E\u0442 \u0446\u0435\u043D\u044B \u043F\u0440\u043E\u0434\u0430\u0436\u0438"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1-\u0439 \u043F\u043B\u0430\u0442\u0435\u0436 \u043F\u0440\u0438 \u0437\u0430\u043A\u043B\u044E\u0447\u0435\u043D\u0438\u0438 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2-\u0439 \u043F\u043B\u0430\u0442\u0435\u0436 \u043F\u0440\u0438 25%-\u043D\u043E\u0439 \u0433\u043E\u0442\u043E\u0432\u043D\u043E\u0441\u0442\u0438 \u043E\u0431\u044A\u0435\u043A\u0442\u0430",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"3")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"10%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3-\u0439 \u043F\u043B\u0430\u0442\u0435\u0436 \u043F\u0440\u0438 50%-\u043D\u043E\u0439 \u0433\u043E\u0442\u043E\u0432\u043D\u043E\u0441\u0442\u0438 \u043E\u0431\u044A\u0435\u043A\u0442\u0430",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"4")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"10%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4-\u0439 \u043F\u043B\u0430\u0442\u0435\u0436 \u043F\u0440\u0438 75%-\u043D\u043E\u0439 \u0433\u043E\u0442\u043E\u0432\u043D\u043E\u0441\u0442\u0438 \u043E\u0431\u044A\u0435\u043A\u0442\u0430",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"5")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"10%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u041F\u043B\u0430\u0442\u0435\u0436\u0438 \u043F\u043E \u043E\u043A\u043E\u043D\u0447\u0430\u043D\u0438\u0438 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"6")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"50%")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u041F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u044F:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",{className:"notes"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"1. \u041F\u043B\u043E\u0449\u0430\u0434\u0438 \u0438 \u0440\u0430\u0437\u043C\u0435\u0440\u044B \u0443\u043A\u0430\u0437\u0430\u043D\u044B \u043F\u0440\u0438\u0431\u043B\u0438\u0437\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0438 \u043C\u043E\u0433\u0443\u0442 \u0438\u0437\u043C\u0435\u043D\u044F\u0442\u044C\u0441\u044F \u043F\u043E \u0438\u0442\u043E\u0433\u0430\u043C \u0444\u0438\u043D\u0430\u043B\u044C\u043D\u044B\u0445 \u0438\u0437\u043C\u0435\u0440\u0435\u043D\u0438\u0439.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{margin:0}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"2. \u0411\u0410\u0417\u041E\u0412\u042B\u0419 \u0432\u0430\u0440\u0438\u0430\u043D\u0442: \u0432\u0441\u0442\u0440\u043E\u0435\u043D\u043D\u044B\u0435 \u0431\u044B\u0442\u043E\u0432\u044B\u0435 \u043F\u0440\u0438\u0431\u043E\u0440\u044B, \u0441\u0430\u043D\u0442\u0435\u0445\u043D\u0438\u043A\u0430 \u0438 \u0442\u0435\u0445\u043D\u0438\u043A\u0430 \u041D\u0415 \u0432\u043A\u043B\u044E\u0447\u0435\u043D\u044B \u043F\u0440\u0438 \u043F\u043E\u043A\u0443\u043F\u043A\u0435 \u043E\u0431\u044C\u0435\u043A\u0442\u0430 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u0438. \u0412\u0430\u0440\u0438\u0430\u043D\u0442 \u0421\u041E \u0412\u0421\u0422\u0420\u041E\u0415\u041D\u041D\u041E\u0419 \u041C\u0415\u0411\u0415\u041B\u042C\u042E: \u0432\u0441\u0442\u0440\u043E\u0435\u043D\u043D\u044B\u0435 \u0431\u044B\u0442\u043E\u0432\u044B\u0435 \u043F\u0440\u0438\u0431\u043E\u0440\u044B, \u0441\u0430\u043D\u0442\u0435\u0445\u043D\u0438\u043A\u0430 \u0438 \u0442\u0435\u0445\u043D\u0438\u043A\u0430 \u0432\u043A\u043B\u044E\u0447\u0435\u043D\u044B \u043F\u0440\u0438 \u043F\u043E\u043A\u0443\u043F\u043A\u0435 \u043E\u0431\u044C\u0435\u043A\u0442\u0430 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u0438.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{margin:0}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u041C\u0415\u0411\u041B\u0418\u0420\u041E\u0412\u0410\u041D\u041D\u042B\u0419 \u0432\u0430\u0440\u0438\u0430\u043D\u0442: \u0432\u0441\u0442\u0440\u043E\u0435\u043D\u043D\u0430\u044F \u043C\u0435\u0431\u0435\u043B\u044C, \u0441\u0430\u043D\u0442\u0435\u0445\u043D\u0438\u043A\u0430, \u0442\u0435\u0445\u043D\u0438\u043A\u0430 \u0438 \u043D\u0435\u0432\u0441\u0442\u0440\u043E\u0435\u043D\u043D\u0430\u044F \u043C\u0435\u0431\u0435\u043B\u044C \u0432\u043A\u043B\u044E\u0447\u0435\u043D\u044B \u043F\u0440\u0438 \u043F\u043E\u043A\u0443\u043F\u043A\u0435 \u043E\u0431\u044C\u0435\u043A\u0442\u0430 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u0438."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"3. \u0411\u0435\u0442\u043E\u043D\u043D\u0430\u044F \u043A\u043E\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0438\u044F \u0432 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u043C \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0430.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"4. \u041A\u0440\u044B\u0448\u0430, \u0443\u043A\u043B\u0430\u0434\u043A\u0430 \u043A\u0438\u0440\u043F\u0438\u0447\u0430 \u0438 \u043D\u0430\u0440\u0443\u0436\u043D\u0430\u044F \u043E\u0442\u0434\u0435\u043B\u043A\u0430 \u0432 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u043C \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u044B.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"5. \u042D\u043B\u0435\u043A\u0442\u0440\u0438\u0447\u0435\u0441\u043A\u0430\u044F \u043F\u0440\u043E\u0432\u043E\u0434\u043A\u0430, \u0443\u043A\u043B\u0430\u0434\u043A\u0430 \u0432\u043E\u0434\u043E\u043F\u0440\u043E\u0432\u043E\u0434\u043D\u044B\u0445 \u0442\u0440\u0443\u0431 \u0438 \u0432\u043D\u0443\u0442\u0440\u0435\u043D\u043D\u044F\u044F \u043E\u0442\u0434\u0435\u043B\u043A\u0430 \u0432 \u043E\u0441\u043D\u043E\u0432\u043D\u043E\u043C \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u044B.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"6. \u041F\u0440\u043E\u0446\u0435\u043D\u0442\u044B \u043F\u043E \u0440\u0430\u0441\u0441\u0440\u043E\u0447\u043A\u0435 \u0431\u0443\u0434\u0443\u0442 \u043D\u0430\u0447\u0438\u0441\u043B\u0435\u043D\u044B \u043D\u0430 \u043E\u0442\u043B\u043E\u0436\u0435\u043D\u043D\u044B\u0435 \u043F\u043B\u0430\u0442\u0435\u0436\u0438 \u043F\u043E \u043E\u043A\u043E\u043D\u0447\u0430\u043D\u0438\u0438 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430, \u043A\u0430\u043A \u0443\u043A\u0430\u0437\u0430\u043D\u043E \u0432 \u0442\u0430\u0431\u043B\u0438\u0446\u0435 \xAB\u0412\u0430\u0440\u0438\u0430\u043D\u0442\u044B \u0444\u0438\u043D\u0430\u043D\u0441\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F\xBB"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"\u0420\u0430\u0441\u0441\u0440\u043E\u0447\u043A\u0430"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"th-col2"},"\u041F\u0440\u043E\u0446\u0435\u043D\u0442\u043D\u0430\u044F \u0441\u0442\u0430\u0432\u043A\u0430",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"(\u0432 \u0433\u043E\u0434)"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1 \u0433\u043E\u0434 (4 \u0435\u0436\u0435\u043A\u0432\u0430\u0440\u0442\u0430\u043B\u044C\u043D\u044B\u0445 \u043F\u043B\u0430\u0442\u0435\u0436\u0430)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"3%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3 \u0433\u043E\u0434\u0430 (12 \u0435\u0436\u0435\u043A\u0432\u0430\u0440\u0442\u0430\u043B\u044C\u043D\u044B\u0445 \u043F\u043B\u0430\u0442\u0435\u0436\u0435\u0439)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"5%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5 \u043B\u0435\u0442 (20 \u0435\u0436\u0435\u043A\u0432\u0430\u0440\u0442\u0430\u043B\u044C\u043D\u044B\u0445 \u043F\u043B\u0430\u0442\u0435\u0436\u0435\u0439)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"7%")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"table-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"tr-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u0426\u0435\u043D\u0430")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u0420\u0435\u0437\u0435\u0440\u0432\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u0434\u0435\u043F\u043E\u0437\u0438\u0442")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u041F\u043B\u0430\u0442\u0435\u0436 \u043F\u043E \u043E\u043A\u043E\u043D\u0447\u0430\u043D\u0438\u0438 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 50%",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"(\u043C\u0438\u043D\u0443\u0441 \u0434\u0435\u043F\u043E\u0437\u0438\u0442)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u0420\u0430\u0441\u0441\u0440\u043E\u0447\u043A\u0430 \u043F\u043E\u0441\u043B\u0435 \u043E\u043A\u043E\u043D\u0447\u0430\u043D\u0438\u044F \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 50%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:"3",className:"td-group-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u0415\u0436\u0435\u043A\u0432\u0430\u0440\u0442\u0430\u043B\u044C\u043D\u044B\u0439 \u043F\u043B\u0430\u0442\u0435\u0436"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"tr-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"1 Year (3%)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"3 Year (5%)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"5 Year (7%)"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"509,410"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"180,517"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"119,382")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,150,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,250,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"573,086"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"203,081"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"134,305")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"636,763"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"225,646"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"149,228")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,650,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,750,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"700,439"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"248,210"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"164,151")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"6,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"764,115"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"270,775"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"179,074")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"6,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3,150,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3,250,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"827,791"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"293,340"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"193,996")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"7,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"891,468"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"315,904"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"208,919")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"7,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3,650,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3,750,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"955,144"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"338,469"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"223,842")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"8,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,018,820"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"361,033"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"238,765")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"8,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4,150,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4,250,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,082,496"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"383,598"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"253,688")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"9,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,146,173"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"406,162"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"268,611")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"9,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4,650,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4,750,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,209,849"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"428,727"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"283,533")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"10,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,273,525"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"451,292"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"298,456")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"10,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5,150,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5,250,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,337,201"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"473,856"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"313,379")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"11,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,400,878"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"496,421"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"328,302")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"11,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5,650,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5,750,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,464,554"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"518,985"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"343,225")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"12,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"6,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,528,230"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"541,550"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"358,147"))))),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u7B54.")," \u63D0\u4F9B 2 \u79CD\u9009\u62E9\uFF1A"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u9009\u62E9 1\uFF1A\u8D2D\u4E70/\u65BD\u5DE5\u671F\u95F4\u5168\u989D\u4ED8\u6B3E"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"\u5BF9\u4E8E\u5DF2\u5EFA\u6210\u7269\u4E1A\uFF0C\u4F9D\u636E\u8D2D\u4E70\u4EF7\u683C 100%\u4ED8\u6B3E\u3002\u5BF9\u4E8E\u5728\u5EFA\u7269\u4E1A\uFF0C\u4F9D\u636E\u4E0B\u8868\u6309\u8FDB\u5EA6\u5206\u671F\u4ED8\u6B3E\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"\u65BD\u5DE5\u4ED8\u6B3E\u6761\u6B3E"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"th-col2"},"\u4ED8\u6B3E\u6BD4\u4F8B"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u7B7E\u7F72\u5408\u540C\u65F6\u8FDB\u884C\u9996\u4ED8"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u5DE5\u7A0B\u5B8C\u6210 25% 1 \u65F6\u8FDB\u884C\u7B2C 2 \u6B21\u4ED8\u6B3E"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u5DE5\u7A0B\u5B8C\u6210 50% 2 \u65F6\u8FDB\u884C\u7B2C 3 \u6B21\u4ED8\u6B3E"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u5DE5\u7A0B\u5B8C\u6210 75% 3 \u65F6\u8FDB\u884C\u7B2C 4 \u6B21\u4ED8\u6B3E"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u7AE3\u5DE5\u65F6\u8FDB\u884C\u7B2C 5 \u6B21\u4ED8\u6B3E"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{textAlign:"center"}},"\u5408\u8BA1"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"100%")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u6CE8\u91CA\uFF1A"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",{className:"notes"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"1. \u6DF7\u51DD\u571F\u6846\u67B6\u5927\u4F53\u5B8C\u6210 "))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"2. \u5C4B\u9876\u3001\u7816\u780C\u548C\u62B9\u7070\u4F5C\u4E1A\u5927\u4F53\u5B8C\u6210 "))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"3. \u7535\u8DEF\uFF0C\u7BA1\u9053\u4F5C\u4E1A\u548C\u62B9\u7070\u5927\u4F53\u5B8C\u6210")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u9009\u62E9 2\uFF1A\u8D2D\u4E70\u65F6/\u65BD\u5DE5\u671F\u95F4\u4ED8\u6B3E 50%\uFF0C\u5269\u4F59\u7684 50% \u5EF6\u671F\u6B3E\u9879\u5728 1 \u5E74\u30013 \u5E74\u6216 5 \u5E74\u5185\u652F\u4ED8"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"\u8D2D\u4E70\u5DF2\u7AE3\u5DE5\u7269\u4E1A\u65F6\u652F\u4ED8 50% \u7684\u6B3E\u9879\u3002\u6309\u4E0B\u8868\u4E3A\u5C1A\u5728\u65BD\u5DE5\u7684\u9879\u76EE\u5206\u671F\u4ED8\u6B3E\uFF08\u65BD\u5DE5\u671F\u95F4\u4ED8\u6B3E 50%/\u7AE3\u5DE5\u540E\u4ED8\u6B3E 50%\uFF09\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"\u5EF6\u671F\u4ED8\u6B3E\u8BA1\u5212"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"th-col2"},"\u4ED8\u6B3E\u6BD4\u4F8B"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u7B7E\u7F72\u5408\u540C\u65F6\u8FDB\u884C\u7B2C 1 \u6B21\u4ED8\u6B3E"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u5DE5\u7A0B\u5B8C\u6210 25% \u65F6\u8FDB\u884C\u7B2C2\u6B21\u4ED8\u6B3E"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"10%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u5DE5\u7A0B\u5B8C\u6210 50% \u65F6\u8FDB\u884C\u7B2C3\u6B21\u4ED8\u6B3E"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"10%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u5DE5\u7A0B\u5B8C\u6210 75% \u65F6\u8FDB\u884C\u7B2C4\u6B21\u4ED8\u6B3E"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"10%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u7AE3\u5DE5\u540E\u4ED8\u6B3E"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"50%")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"\u5EF6\u671F\u4ED8\u6B3E\u9009\u62E9"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"th-col2"},"\u5229\u7387\uFF08\u6BCF\u5E74\uFF09"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1 \u5E74\uFF084\u4E2A\u5B63\u5EA6\u5206\u671F\u4ED8\u6B3E\uFF09"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"3%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3 \u5E74\uFF0812\u4E2A\u5B63\u5EA6\u671F\u4ED8\u6B3E\uFF09"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"5%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5 \u5E74\uFF0820\u4E2A\u5B63\u5EA6\u5206\u671F\u4ED8\u6B3E\uFF09"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"7%")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"\u6CE8\u91CA\uFF1A")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",{className:"notes"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"1. \u6DF7\u51DD\u571F\u67B6\u6784\u5927\u4F53\u5B8C\u6210"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"2. \u5C4B\u9876,\u7816\u780C\u548C\u62B9\u7070\u4F5C\u4E1A\u5927\u4F53\u5B8C\u6210"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"3. \u7535\u8DEF\uFF0C\u7BA1\u9053\u548C\u62B9\u7070\u4F5C\u4E1A\u5927\u4F53\u5B8C\u6210"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"4. \u53C2\u89C1\u4E0B\u8868")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"table-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"tr-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u4EF7\u683C")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u9884\u5B9A\u91D1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u7AE3\u5DE5\u65F6\u4ED8\u6B3E 50%",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"\uFF08\u51CF\u53BB\u5B9A\u91D1\uFF09")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u4E4B\u540E\u4EE5\u5EF6\u671F\u4ED8\u6B3E\u5F62\u5F0F\u652F\u4ED8\u5269\u4F59\u7684 50% \u6B3E\u9879")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:"3",className:"td-group-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u6309\u6708\u4ED8\u6B3E"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"tr-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"1\u5E74(3%)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"3\u5E74(5%)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"5\u5E74(7%)"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"509,410"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"180,517"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"119,382")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,150,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,250,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"573,086"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"203,081"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"134,305")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"636,763"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"225,646"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"149,228")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,650,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,750,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"700,439"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"248,210"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"164,151")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"6,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"764,115"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"270,775"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"179,074")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"6,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3,150,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3,250,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"827,791"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"293,340"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"193,996")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"7,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"891,468"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"315,904"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"208,919")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"7,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3,650,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3,750,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"955,144"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"338,469"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"223,842")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"8,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,018,820"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"361,033"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"238,765")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"8,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4,150,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4,250,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,082,496"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"383,598"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"253,688")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"9,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,146,173"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"406,162"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"268,611")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"9,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4,650,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4,750,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,209,849"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"428,727"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"283,533")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"10,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,273,525"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"451,292"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"298,456")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"10,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5,150,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5,250,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,337,201"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"473,856"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"313,379")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"11,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,400,878"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"496,421"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"328,302")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"11,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5,650,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5,750,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,464,554"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"518,985"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"343,225")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"12,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"6,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,528,230"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"541,550"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"358,147")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"\u5907\u6CE8: ")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",{className:"notes"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"1. \u6240\u6709\u793A\u4F8B\u91D1\u989D\u4E3A\u6CF0\u94E2."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"2. \u4EE5\u4E0A\u8868\u683C\u4E3A\u9884\u8BA1\u4ED8\u6B3E\u91D1\u989D\uFF0C\u5B9E\u9645\u6839\u636E\u7269\u4E1A\u9500\u552E\u91D1\u989D\uFF084,000,000 \u2013 12,000,000\u6CF0\u94E2\uFF09\u7684\u5404\u81EA\u4ED8\u6B3E\u65B9\u6848\u800C\u5B9A\u3002"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"3. \u9884\u8BA1\u4ED8\u6B3E\u91D1\u989D\u4EC5\u4E3A\u53C2\u8003\uFF0C\u5F00\u53D1\u5546\u6216\u9500\u552E\u5458\u5BF9\u5176\u4E2D\u7684\u975E\u51C6\u786E\u548C\u9057\u6F0F\u90E8\u5206\u4E0D\u627F\u62C5\u4EFB\u4F55\u8D23\u4EFB\u6216\u4E49\u52A1\u3002"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"4. \u652F\u4ED8\u6761\u6B3E\u82E5\u6709\u66F4\u6539\uFF0C\u6055\u4E0D\u901A\u77E5\u3002")))))}}];

/***/ }),
/* 1005 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* unused harmony export default */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_skrollr__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_skrollr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_skrollr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_scroll__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_helmet__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hoc__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_language__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_location__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_phuket_dusit_deluxe_pool_villa__ = __webpack_require__(1006);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Gallery__ = __webpack_require__(1018);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Concept__ = __webpack_require__(1019);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Faq__ = __webpack_require__(1020);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Destination__ = __webpack_require__(1021);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__TheSanctuaryclub__ = __webpack_require__(1022);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Siteplan__ = __webpack_require__(1023);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Masterplan__ = __webpack_require__(1025);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18__Residences__ = __webpack_require__(1027);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19__Ebrochure__ = __webpack_require__(1028);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var page="phuket-dusit-deluxe-pool-villa";var sections=[{key:"gallery",label:"Gallery"},{key:"concept",label:"Concept"},{key:"masterplan",label:"Master Plan"},{key:"siteplan",label:"Site Plan"},{key:"residences",label:"Residences"},{key:"destination",label:"Destination"},{key:"sanctuary-club",label:"The Santuary Club"},{key:"faq",label:"FAQ",hideOnMobile:true},{key:"e-brochure",label:"E-Brochure",hideOnMobile:true}];var mapStateToProps=function mapStateToProps(state){return Object.assign({},state);};var actionToProps={switchLanguage:__WEBPACK_IMPORTED_MODULE_7__actions_language__["a" /* switchLanguage */],switchLocation:__WEBPACK_IMPORTED_MODULE_8__actions_location__["a" /* switchLocation */],initAppPhuketDusitDeluxePoolVilla:__WEBPACK_IMPORTED_MODULE_9__actions_phuket_dusit_deluxe_pool_villa__["a" /* initAppPhuketDusitDeluxePoolVilla */]};var PhuketDusitDeluxePoolVilla=(_dec=Object(__WEBPACK_IMPORTED_MODULE_6__hoc__["b" /* withRedux */])(mapStateToProps,actionToProps),_dec(_class=function(_Component){_inherits(PhuketDusitDeluxePoolVilla,_Component);function PhuketDusitDeluxePoolVilla(props){_classCallCheck(this,PhuketDusitDeluxePoolVilla);var _this=_possibleConstructorReturn(this,(PhuketDusitDeluxePoolVilla.__proto__||Object.getPrototypeOf(PhuketDusitDeluxePoolVilla)).call(this,props));_this.handleWheel=function(evt){if(evt.deltaY>0){var atBottomOfSection=_this.headerRef.current.atBottomOfSection();if(atBottomOfSection){evt.preventDefault();evt.stopPropagation();evt.returnValue=false;// console.log('evt', evt.deltaY);
_this.headerRef.current.handleScrollDown();}}if(evt.deltaY<0){var atTopOfSection=_this.headerRef.current.atTopOfSection();if(atTopOfSection){evt.preventDefault();evt.stopPropagation();evt.returnValue=false;// console.log('evt', evt.deltaY);
_this.headerRef.current.handleScrollUp();}}};_this.setLanguage=function(language){_this.props.actions.switchLanguage(language);};_this.setLocation=function(location){_this.props.actions.switchLocation(location);};_this.fetchData=function(){_this.props.actions.initAppPhuketDusitDeluxePoolVilla();};_this.renderSectionWithId=function(component,id){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_scroll__["Element"],{name:id},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("section",{id:id},component));};_this.headerRef=__WEBPACK_IMPORTED_MODULE_1_react___default.a.createRef();return _this;}_createClass(PhuketDusitDeluxePoolVilla,[{key:"componentDidMount",value:function componentDidMount(){this.setLanguage(this.props.match.params.language);this.setLocation(this.props.route.key);this.fetchData();}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps){var currentLanguage=prevProps.match.params.language;var nextLanguage=this.props.match.params.language;if(currentLanguage!==nextLanguage){this.setLanguage(nextLanguage);}}},{key:"render",value:function render(){var pageData=__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(this.props,page+".data");var isMobile=__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(this.props,"device.isMobile");var currentLanguage=__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(this.props,"language.currentActive");console.log("pageData-Dusit",{page:page,pageData:pageData});return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_skrollr__["ParallaxProvider"],{init:{smoothScrollingDuration:100,smoothScrolling:true,forceHeight:false}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_helmet__["Helmet"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("title",null,"Dusit Laguna Resort Villas Phuket")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["f" /* Header */],{mainLogo:Object(__WEBPACK_IMPORTED_MODULE_10__utils__["a" /* assetsPath */])()+"/images/logo-laguna-property.svg",subLogo:Object(__WEBPACK_IMPORTED_MODULE_10__utils__["a" /* assetsPath */])(page)+"/images/logo/logo.png",language:currentLanguage,projectSections:sections,wrappedComponentRef:this.headerRef}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"main-content "+page+"-page",DISABLE_onWheel:this.handleWheel},this.renderSectionWithId(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Gallery__["a" /* default */],Object.assign({},__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"gallery"),{page:page})),"gallery"),this.renderSectionWithId(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Concept__["a" /* default */],{imageSlider:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"concept.imageSlider"),content:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"concept.content"),page:page}),"concept"),this.renderSectionWithId(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Masterplan__["a" /* default */],{map:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"masterPlan.maps"),page:page}),"masterplan"),this.renderSectionWithId(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Siteplan__["a" /* default */],{map:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"sitePlan.maps"),dataSitePlan:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"sitePlan.type"),page:page}),"siteplan"),this.renderSectionWithId(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18__Residences__["a" /* default */],{landingPage:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"residence.landingPage"),type:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"residence.type"),page:page}),"residences"),this.renderSectionWithId(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Destination__["a" /* default */],{isMobile:isMobile,imageSlider:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"destination.landingPage"),title:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"destination.content.title"),description:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"destination.content.description"),mapData:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"destination.map"),page:page}),"destination"),this.renderSectionWithId(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__TheSanctuaryclub__["a" /* default */],{description:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"sanctuaryClub.description"),image:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"sanctuaryClub.image"),title:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"sanctuaryClub.title"),page:page}),"sanctuary-club"),this.renderSectionWithId(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Faq__["a" /* default */],Object.assign({},__webpack_require__(1029),{page:page})),"faq"),this.renderSectionWithId(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_19__Ebrochure__["a" /* default */],{location:"phuket",project:"dusit-deluxe-pool-villa",page:page}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["d" /* Footer */],null)),"e-brochure"))));}}]);return PhuketDusitDeluxePoolVilla;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class);

/***/ }),
/* 1006 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return initAppPhuketDusitDeluxePoolVilla; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_reduce__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_reduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_reduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_actionType__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_phuket_dusit_deluxe_pool_villa__ = __webpack_require__(1007);
var _this=this;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var initAppPhuketDusitDeluxePoolVilla=function initAppPhuketDusitDeluxePoolVilla(){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch){var listApi,apiResult,mapData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:listApi=[];_context.t0=listApi;_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_3__services_phuket_dusit_deluxe_pool_villa__["c" /* fetchGalleryApi */])();case 4:_context.t1=_context.sent;_context.t2={key:"gallery",data:_context.t1};_context.t0.push.call(_context.t0,_context.t2);_context.t3=listApi;_context.next=10;return Object(__WEBPACK_IMPORTED_MODULE_3__services_phuket_dusit_deluxe_pool_villa__["a" /* fetchConceptApi */])();case 10:_context.t4=_context.sent;_context.t5={key:"concept",data:_context.t4};_context.t3.push.call(_context.t3,_context.t5);_context.t6=listApi;_context.next=16;return Object(__WEBPACK_IMPORTED_MODULE_3__services_phuket_dusit_deluxe_pool_villa__["d" /* fetchMasterPlanApi */])();case 16:_context.t7=_context.sent;_context.t8={key:"masterPlan",data:_context.t7};_context.t6.push.call(_context.t6,_context.t8);_context.t9=listApi;_context.next=22;return Object(__WEBPACK_IMPORTED_MODULE_3__services_phuket_dusit_deluxe_pool_villa__["g" /* fetchSitePlanApi */])();case 22:_context.t10=_context.sent;_context.t11={key:"sitePlan",data:_context.t10};_context.t9.push.call(_context.t9,_context.t11);_context.t12=listApi;_context.next=28;return Object(__WEBPACK_IMPORTED_MODULE_3__services_phuket_dusit_deluxe_pool_villa__["e" /* fetchResidenceApi */])();case 28:_context.t13=_context.sent;_context.t14={key:"residence",data:_context.t13};_context.t12.push.call(_context.t12,_context.t14);_context.t15=listApi;_context.next=34;return Object(__WEBPACK_IMPORTED_MODULE_3__services_phuket_dusit_deluxe_pool_villa__["b" /* fetchDestinationApi */])();case 34:_context.t16=_context.sent;_context.t17={key:"destination",data:_context.t16};_context.t15.push.call(_context.t15,_context.t17);_context.t18=listApi;_context.next=40;return Object(__WEBPACK_IMPORTED_MODULE_3__services_phuket_dusit_deluxe_pool_villa__["f" /* fetchSanctuaryClubApi */])();case 40:_context.t19=_context.sent;_context.t20={key:"sanctuaryClub",data:_context.t19};_context.t18.push.call(_context.t18,_context.t20);_context.prev=43;_context.next=46;return Promise.all(listApi);case 46:apiResult=_context.sent;mapData=__WEBPACK_IMPORTED_MODULE_1_lodash_reduce___default()(apiResult,function(result,value,index){var key=value.key,data=value.data;return Object.assign({},result,_defineProperty({},key,data));},{});dispatch({type:__WEBPACK_IMPORTED_MODULE_2__actions_actionType__["e" /* RECEIVE_PHUKET_DUSIT_DELUXE_POOL_VILLA */],data:mapData});_context.next=54;break;case 51:_context.prev=51;_context.t21=_context["catch"](43);console.error("initAppPhuketReceivePhuketDusitDeluxePoolVilla err",_context.t21);case 54:case"end":return _context.stop();}}},_callee,_this,[[43,51]]);}));return function(_x){return _ref.apply(this,arguments);};}();};

/***/ }),
/* 1007 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchGalleryApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchConceptApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchMasterPlanApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "g", function() { return fetchSitePlanApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fetchResidenceApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchDestinationApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "f", function() { return fetchSanctuaryClubApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_PhuketDusitDeluxePoolVilla_gallery__ = __webpack_require__(1008);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_PhuketDusitDeluxePoolVilla_concept__ = __webpack_require__(1012);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_PhuketDusitDeluxePoolVilla_masterplan__ = __webpack_require__(1013);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_PhuketDusitDeluxePoolVilla_sitePlan__ = __webpack_require__(1014);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__data_PhuketDusitDeluxePoolVilla_residence__ = __webpack_require__(1015);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__data_PhuketDusitDeluxePoolVilla_destination__ = __webpack_require__(1016);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__data_PhuketDusitDeluxePoolVilla_sanctuaryClub__ = __webpack_require__(1017);
var fetchGalleryApi=function fetchGalleryApi(){return Promise.resolve(__WEBPACK_IMPORTED_MODULE_0__data_PhuketDusitDeluxePoolVilla_gallery__["a" /* default */]);};var fetchConceptApi=function fetchConceptApi(){return Promise.resolve(__WEBPACK_IMPORTED_MODULE_1__data_PhuketDusitDeluxePoolVilla_concept__["a" /* default */]);};var fetchMasterPlanApi=function fetchMasterPlanApi(){return Promise.resolve(__WEBPACK_IMPORTED_MODULE_2__data_PhuketDusitDeluxePoolVilla_masterplan__["a" /* default */]);};var fetchSitePlanApi=function fetchSitePlanApi(){return Promise.resolve(__WEBPACK_IMPORTED_MODULE_3__data_PhuketDusitDeluxePoolVilla_sitePlan__["a" /* default */]);};var fetchResidenceApi=function fetchResidenceApi(){return Promise.resolve(__WEBPACK_IMPORTED_MODULE_4__data_PhuketDusitDeluxePoolVilla_residence__["a" /* default */]);};var fetchDestinationApi=function fetchDestinationApi(){return Promise.resolve(__WEBPACK_IMPORTED_MODULE_5__data_PhuketDusitDeluxePoolVilla_destination__["a" /* default */]);};var fetchSanctuaryClubApi=function fetchSanctuaryClubApi(){return Promise.resolve(__WEBPACK_IMPORTED_MODULE_6__data_PhuketDusitDeluxePoolVilla_sanctuaryClub__["a" /* default */]);};

/***/ }),
/* 1008 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_find__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_range__ = __webpack_require__(1009);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_range___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_range__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(2);
function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}var heroShotImg1=Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+"/images/gallery/hero-shot/1_new.jpg";var heroShotImg2=Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+"/images/gallery/hero-shot/7.jpg";var heroShotImg3=Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+"/images/gallery/hero-shot/8.jpg";var heroShotImg4=Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+"/images/gallery/hero-shot/2.jpg";var heroShotImg5=Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+"/images/gallery/hero-shot/3.jpg";var heroShotImg6=Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+"/images/gallery/hero-shot/4.jpg";var heroShotImg7=Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+"/images/gallery/hero-shot/5.jpg";var heroShotImg8=Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+"/images/gallery/hero-shot/6.jpg";var generateGallery=function generateGallery(_ref){var _ref$imagePath=_ref.imagePath,imagePath=_ref$imagePath===undefined?'':_ref$imagePath,_ref$amount=_ref.amount,amount=_ref$amount===undefined?0:_ref$amount,_ref$name=_ref.name,name=_ref$name===undefined?'':_ref$name,_ref$categoryId=_ref.categoryId,categoryId=_ref$categoryId===undefined?0:_ref$categoryId;return __WEBPACK_IMPORTED_MODULE_2_lodash_map___default()(__WEBPACK_IMPORTED_MODULE_1_lodash_range___default()(amount),function(value,index){var numberOrder=index+1;var newName=name!==''?name+" - "+numberOrder:'';return{categoryId:categoryId,name:newName,image:Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+"/images/gallery/"+imagePath+"/"+numberOrder+".jpg"};});};var residencesAerialData=[{categoryId:2,name:"Aerial - 1",image:Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+"/images/gallery/images/residences-aerial/1.jpg"},{categoryId:2,name:"Aerial - 2",image:Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+"/images/gallery/images/residences-aerial/2.jpg"},{categoryId:2,name:"Aerial - 3",image:Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+"/images/gallery/images/residences-aerial/3.jpg"}];// generateGallery({ imagePath: 'images/residences-aerial', amount: 2, categoryId: 2 });
// const residencesExteriorData = generateGallery({ imagePath: 'images/residences-exterior', amount: 8, categoryId: 3 });
var residencesExteriorData=[{categoryId:3,name:"Exterior - 1",image:Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+"/images/gallery/images/residences-exterior/1.jpg"},{categoryId:3,name:"Exterior - 2",image:Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+"/images/gallery/images/residences-exterior/2.jpg"},{categoryId:3,name:"Exterior - 3",image:Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+"/images/gallery/images/residences-exterior/3.jpg"},{categoryId:3,name:"Exterior - 4",image:Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+"/images/gallery/images/residences-exterior/4.jpg"},{categoryId:3,name:"Exterior - 5",image:Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+"/images/gallery/images/residences-exterior/5.jpg"},{categoryId:3,name:"Exterior - 6",image:Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+"/images/gallery/images/residences-exterior/6.jpg"},{categoryId:3,name:"Exterior - 7",image:Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+"/images/gallery/images/residences-exterior/7.jpg"},{categoryId:3,name:"Exterior - 8",image:Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+"/images/gallery/images/residences-exterior/8.jpg"}];var residencesInteriorData=generateGallery({imagePath:'images/residences-interior',amount:9,categoryId:4});var residencesCommonAreaData=generateGallery({imagePath:'images/residences-common-area',amount:10,categoryId:5});var residencesLifestyleData=generateGallery({imagePath:'images/residences-lifestyle',amount:8,categoryId:6});var destinationLifestyleData=generateGallery({imagePath:'images/destination-lifestyle',amount:16,categoryId:7});var heroShot=[{image:heroShotImg1},{image:heroShotImg2},{image:heroShotImg3},{image:heroShotImg4},{image:heroShotImg5},{image:heroShotImg6},{image:heroShotImg7},{image:heroShotImg8}];var categories=[{id:1,name:"All Images"},{id:2,name:"Residences – Aerial"},{id:3,name:"Residences – Exterior"},{id:4,name:"Residences – Interior"},{id:5,name:"Residences – Common Area"},{id:6,name:"Residences – Lifestyle"},{id:7,name:"Destination Lifestyle"}];var images=[].concat(residencesAerialData,residencesExteriorData,_toConsumableArray(residencesInteriorData),_toConsumableArray(residencesCommonAreaData),_toConsumableArray(residencesLifestyleData),_toConsumableArray(destinationLifestyleData));var video=null;var image360=Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+"/360/Dusit-Aerial/Dusit-Aerial2018.html";/* harmony default export */ __webpack_exports__["a"] = ({heroShot:heroShot,categories:categories,images:__WEBPACK_IMPORTED_MODULE_2_lodash_map___default()(images,function(image){return Object.assign({},image,{category:__WEBPACK_IMPORTED_MODULE_0_lodash_find___default()(categories,{id:image.categoryId})});}),video:video,image360:image360,view360:[{id:'aerial',src:Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+"/360/Dusit-Aerial/Dusit-Aerial2018.html"},{id:'interior',src:Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+"/360/interior/DS-Living.html"}]});

/***/ }),
/* 1009 */
/***/ (function(module, exports, __webpack_require__) {

var createRange = __webpack_require__(1010);

/**
 * Creates an array of numbers (positive and/or negative) progressing from
 * `start` up to, but not including, `end`. A step of `-1` is used if a negative
 * `start` is specified without an `end` or `step`. If `end` is not specified,
 * it's set to `start` with `start` then set to `0`.
 *
 * **Note:** JavaScript follows the IEEE-754 standard for resolving
 * floating-point values which can produce unexpected results.
 *
 * @static
 * @since 0.1.0
 * @memberOf _
 * @category Util
 * @param {number} [start=0] The start of the range.
 * @param {number} end The end of the range.
 * @param {number} [step=1] The value to increment or decrement by.
 * @returns {Array} Returns the range of numbers.
 * @see _.inRange, _.rangeRight
 * @example
 *
 * _.range(4);
 * // => [0, 1, 2, 3]
 *
 * _.range(-4);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 5);
 * // => [1, 2, 3, 4]
 *
 * _.range(0, 20, 5);
 * // => [0, 5, 10, 15]
 *
 * _.range(0, -4, -1);
 * // => [0, -1, -2, -3]
 *
 * _.range(1, 4, 0);
 * // => [1, 1, 1]
 *
 * _.range(0);
 * // => []
 */
var range = createRange();

module.exports = range;


/***/ }),
/* 1010 */
/***/ (function(module, exports, __webpack_require__) {

var baseRange = __webpack_require__(1011),
    isIterateeCall = __webpack_require__(124),
    toFinite = __webpack_require__(254);

/**
 * Creates a `_.range` or `_.rangeRight` function.
 *
 * @private
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Function} Returns the new range function.
 */
function createRange(fromRight) {
  return function(start, end, step) {
    if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
      end = step = undefined;
    }
    // Ensure the sign of `-0` is preserved.
    start = toFinite(start);
    if (end === undefined) {
      end = start;
      start = 0;
    } else {
      end = toFinite(end);
    }
    step = step === undefined ? (start < end ? 1 : -1) : toFinite(step);
    return baseRange(start, end, step, fromRight);
  };
}

module.exports = createRange;


/***/ }),
/* 1011 */
/***/ (function(module, exports) {

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil,
    nativeMax = Math.max;

/**
 * The base implementation of `_.range` and `_.rangeRight` which doesn't
 * coerce arguments.
 *
 * @private
 * @param {number} start The start of the range.
 * @param {number} end The end of the range.
 * @param {number} step The value to increment or decrement by.
 * @param {boolean} [fromRight] Specify iterating from right to left.
 * @returns {Array} Returns the range of numbers.
 */
function baseRange(start, end, step, fromRight) {
  var index = -1,
      length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
      result = Array(length);

  while (length--) {
    result[fromRight ? length : ++index] = start;
    start += step;
  }
  return result;
}

module.exports = baseRange;


/***/ }),
/* 1012 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(2);
var img1=Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/concept/1_new.jpg';var img2=Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/concept/2_new.jpg';var img3=Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/concept/3_new.jpg';var img4=Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/concept/4_new.jpg';var img5=Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/concept/5_new.jpg';var img6=Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/concept/6_new.jpg';var img7=Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/concept/7_new.jpg';var imageSlider=[{image:img1,backgroundPosition:'left center'},{image:img2,backgroundPosition:'75% center'},{image:img3},{image:img4,backgroundPosition:'40% center'},{image:img5,backgroundPosition:'60% center'},{image:img6,backgroundPosition:'10% center'},{image:img7,backgroundPosition:'10% center'}];var content={en:'<p> Set by a tranquil lagoon a few meters from the beach and within delightful gardens, Dusit Laguna Resort Villas Phuket are designed to complement the resort lifestyle of Dusit Thani Laguna Phuket. Each 3-story villa offers spectacular views of the crystal-clear waters of the Andaman Sea or the sparkling lakes that define Laguna Phuket.</p><p> The newest phase of this lush island development comprises just 22, 2 and 3-bedroom villas with rooftop pools, set apart from the remainder of the resort yet within easy reach of the facilities and amenities.</p><p> These villas offer rooftop dining and entertaining areas, a rooftop swimming pool and views of the tranquil lagoon and Bang Tao Beach beyond.</p><h2>2-Bedroom Villas</h2> <p> Our 2-bedroom villas provide 334 sqm. of light and airy space spread over 3-stories. The ground floor has a kitchen, dining and living area which opens out onto a terrace with lush greenery surrounding it.</p><p> The first floor contains the two bedrooms, each with their own en-suite and decks. The second floor will quickly become your favourite area to spend time entertaining and lounging. It offers a dining area with a separate, second kitchen, a powder room, an outdoor shower and a 26 sqm. pool and sundeck that looks out over the lagoon and Bang Tao Beach.</p><h2>3-Bedroom Villas</h2><p> Our 3-bedroom, 552 sqm. villas offer an additional bedroom on the ground floor with its own en-suite and outdoor patio. The ground floor also contains the kitchen, dining and living area and a powder room.</p><p> The first floor contains the master bedroom with a spacious en-suite and wrap-around deck and the third bedroom, also with its own en-suite and private deck.</p><p> The second floor contains a luxurious 45 sqm swimming pool and sundeck facing the lagoon and Bang Tao Beach, a separate second kitchen for preparing meals to feature while you entertain guests on the spacious party deck and a powder room.</p><h2>Providing Returns on Your Investment</h2><p> Dusit Laguna Resort Villas Phuket is integrated into a proven rental programme that allows owners to maximise their returns by having their apartment professionally managed by Dusit Thani Laguna Phuket.</p><p> Buyers receive a significant share of the room revenues generated from their apartment and also enjoy complimentary use of up to 60 days per year, adding a lifestyle return on the overall investment.</p><p> Come and visit us to find out how easy it is to own one these spacious, waterfront villas on the sunset coast of Phuket. Contact Dusit Laguna Resort Villas Phuket today. </p>',cn:"<p>普吉岛乐古浪都喜度假别墅坐落在宁静的环礁湖旁，距离海滩仅有数米之遥，位于宜人的花园内，旨在为普吉岛乐古浪都喜天丽酒店的度假生活方式锦上添花。每栋三层别墅均可欣赏到安达曼海晶莹剔透的海面或波光粼粼的湖泊，这片壮丽景色独属于普吉岛乐古浪。这处青翠的岛屿开发地的最新阶段包括22个两居室和三居室别墅，与度假村的其余部分隔开，但依旧可享受度假村的便利设施。<br /> <br />普吉岛乐古浪都喜度假别墅已融入一个经过验证的租赁计划，业主可通过普吉岛乐古浪都喜天丽酒店的专业管理来将自己的投资回报最大化。买家可以获得一定份额的别墅客房收入，还可享受每年至多60天的免费入住，从而为整体投资增添了一个优秀的生活方式回报。</p>",ru:"<p>Расположенные среди роскошной зелени тихой лагуны всего в нескольких метрах от пляжа виллы Dusit Laguna Resort Villas Phuket дополняют роскошную курортную жизнь комплекса Dusit Thani Laguna Phuket. Из каждой трехэтажной виллы открывается великолепный вид на кристально чистые воды Андаманского моря или живописные озера, которыми знаменит курорт Laguna Phuket. Утопающий в зелени острова новый проект состоит из 22 вилл с двумя и тремя спальнями. Комплекс находится на некотором удалении от остальных зданий курорта, но это не препятствует быстрому доступу ко всем удобствам. <br /></br />На виллы Dusit Laguna Resort Villas Phuket распространяется зарекомендовавшая себя программа аренды, позволяющая владельцам максимизировать свои доходы за счет профессионального управления недвижимостью, осуществляемого комплексом Dusit Thani Laguna Phuket. Помимо доли дохода, получаемого с аренды недвижимости, владельцы также могут наслаждаться возможностью проживания в течение 60 дней в год, что является значительным преимуществом.</p>"};/* harmony default export */ __webpack_exports__["a"] = ({imageSlider:imageSlider,content:content});

/***/ }),
/* 1013 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(2);
var maps=Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+"/images/master-plan/image.jpg";/* harmony default export */ __webpack_exports__["a"] = ({maps:maps});

/***/ }),
/* 1014 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(2);
var baseAssetUrl=Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])("phuket-laguna-park-2");var maps=baseAssetUrl+"/images/site-plan/image.jpg";var type=[{value:"all",title:{en:"ALL",ru:"ВСЕ",cn:"全部户型"}},{value:"two-bedroom",title:{en:"2 BEDROOM",ru:"2 СПАЛЬНИ",cn:"2间卧室"}},{value:"three-bedroom",title:{en:"3 BEDROOM",ru:"3 СПАЛЬНИ",cn:"3间卧室"}}];/* harmony default export */ __webpack_exports__["a"] = ({maps:maps,type:type});

/***/ }),
/* 1015 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(2);
var landingPage=[{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/landing-page/1.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/landing-page/2.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/landing-page/3.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/landing-page/4.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/landing-page/5.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/landing-page/6.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/landing-page/7.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/landing-page/8.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/landing-page/9.jpg'}];var type=[{name:{en:'2 BEDROOM',ru:'2 СПАЛЬНИ',cn:'2间卧室'},// buttonImages: {
//   default: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/landing-page/2.jpg`,
//   hover: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/landing-page/5.jpg`
// },
thumbnail:[{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/landing-page/2.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/landing-page/5.jpg'}],buttons:[{type:"description",value:0,name:"Description",title:"2 Bedroom",description:{en:"<p>Spread out over three storeys, the two bedroom villas measure 334 sqm of well defined spaces anchored by a kitchen, dining area, and living room which opens out to a terrace. Making up the heart of the home on the second floor are the two bedrooms, each with ensuite bathrooms and private balcony. Crowning the villas is the entertainment level on the rooftop, 26 sqm pool and sun deck on one end, plus a party deck on the other,<br />fully equipped with a pantry and a BBQ area.</p>",cn:"<p>Spread out over three storeys, the two bedroom villas measure 334 sqm of well defined spaces anchored by a kitchen, dining area, and living room which opens out to a terrace. Making up the heart of the home on the second floor are the two bedrooms, each with ensuite bathrooms and private balcony. Crowning the villas is the entertainment level on the rooftop, 26 sqm pool and sun deck on one end, plus a party deck on the other,<br />fully equipped with a pantry and a BBQ area.</p>",ru:"<p>Spread out over three storeys, the two bedroom villas measure 334 sqm of well defined spaces anchored by a kitchen, dining area, and living room which opens out to a terrace. Making up the heart of the home on the second floor are the two bedrooms, each with ensuite bathrooms and private balcony. Crowning the villas is the entertainment level on the rooftop, 26 sqm pool and sun deck on one end, plus a party deck on the other,<br />fully equipped with a pantry and a BBQ area.</p>"},images:[{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/two-bedroom/description/1.jpg',backgroundPosition:'0% center'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/two-bedroom/description/2.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/two-bedroom/description/3.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/two-bedroom/description/4.jpg'}]},{type:"plan",name:"GROUND FLOOR",value:1,floorPlan:{en:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/two-bedroom/ground-floor/floor-plan/image_en.png',ru:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/two-bedroom/ground-floor/floor-plan/image_ru.png',cn:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/two-bedroom/ground-floor/floor-plan/image_cn.png'},images:[{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/two-bedroom/description/1.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/two-bedroom/description/2.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/two-bedroom/description/3.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/two-bedroom/description/4.jpg'}],image360:[{x:940,y:435,currentIndex:2},{x:930,y:780,currentIndex:3}],imageVirtual:[{x:990,y:380,path:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/360/residence-two-bedroom/DS-Living.html'},{x:990,y:820,path:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/360/residence-two-bedroom/DS-Dining.html'}]},{type:"plan",name:"1 st Floor",value:2,floorPlan:{en:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/two-bedroom/first-floor/floor-plan/image_en.png',ru:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/two-bedroom/first-floor/floor-plan/image_ru.png',cn:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/two-bedroom/first-floor/floor-plan/image_cn.png'},images:[{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/two-bedroom/description/1.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/two-bedroom/description/2.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/two-bedroom/description/3.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/two-bedroom/description/4.jpg'}],image360:[{x:926,y:266,path:'/assets/images/residences/two-bedroom/description/2.jpg'}],imageVirtual:[{x:970,y:175,path:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/360/residence-two-bedroom/DS-MB.html'},{x:970,y:820,path:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/360/residence-two-bedroom/DS-BR2.html'}]},{type:"plan",name:"2 nd Floor",value:3,floorPlan:{en:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/two-bedroom/second-floor/floor-plan/image_en.png',ru:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/two-bedroom/second-floor/floor-plan/image_ru.png',cn:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/two-bedroom/second-floor/floor-plan/image_cn.png'},images:[{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/two-bedroom/description/1.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/two-bedroom/description/2.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/two-bedroom/description/3.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/two-bedroom/description/4.jpg'}],image360:[],imageVirtual:[{x:980,y:330,path:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/360/residence-two-bedroom/DS-Pool.html'},{x:895,y:1020,path:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/360/residence-two-bedroom/DS-PD.html'}]}]},{name:{en:'3 BEDROOM',ru:'3 СПАЛЬНИ',cn:'3间卧室'},// buttonImages: {
//   default: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/landing-page/7.jpg`,
//   hover: `${assetsPath('phuket-dusit-deluxe-pool-villa')}/images/residences/landing-page/9.jpg`
// },
thumbnail:[{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/landing-page/7.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/landing-page/9.jpg'}],buttons:[{type:"description",value:0,name:"Description",title:"3 Bedroom",description:{en:"<p>Similar in layout to the two-bedroom villas, the 552 sqm three-bedroom villa features added space and an extra bedroom on the ground floor complete with a private outdoor patio. The dining area looks out over the open plan living room naturally lit by the garden courtyard. Both bedrooms on the second floor come with ensuite bathrooms and private terraces; the master bedroom also includes a large walk-in closet, a wraparound balcony, and a large bathroom. Up on the rooftop, a lush vertical garden near the BBQ and dining area emphasizes the beauty of the villas’ natural surroundings, while a 45 sqm private pool and large sun deck make up the focal point for al fresco dinners and parties.</p>",cn:"<p>Similar in layout to the two-bedroom villas, the 552 sqm three-bedroom villa features added space and an extra bedroom on the ground floor complete with a private outdoor patio. The dining area looks out over the open plan living room naturally lit by the garden courtyard. Both bedrooms on the second floor come with ensuite bathrooms and private terraces; the master bedroom also includes a large walk-in closet, a wraparound balcony, and a large bathroom. Up on the rooftop, a lush vertical garden near the BBQ and dining area emphasizes the beauty of the villas’ natural surroundings, while a 45 sqm private pool and large sun deck make up the focal point for al fresco dinners and parties.</p>",ru:"<p>Similar in layout to the two-bedroom villas, the 552 sqm three-bedroom villa features added space and an extra bedroom on the ground floor complete with a private outdoor patio. The dining area looks out over the open plan living room naturally lit by the garden courtyard. Both bedrooms on the second floor come with ensuite bathrooms and private terraces; the master bedroom also includes a large walk-in closet, a wraparound balcony, and a large bathroom. Up on the rooftop, a lush vertical garden near the BBQ and dining area emphasizes the beauty of the villas’ natural surroundings, while a 45 sqm private pool and large sun deck make up the focal point for al fresco dinners and parties.</p>"},images:[{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/three-bedroom/description/1.jpg',backgroundPosition:'bottom center'}]},{type:"plan",name:"GROUND FLOOR",value:1,floorPlan:{en:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/three-bedroom/ground-floor/floor-plan/image_en.png',ru:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/three-bedroom/ground-floor/floor-plan/image_ru.png',cn:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/three-bedroom/ground-floor/floor-plan/image_cn.png'},images:[{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/three-bedroom/ground-floor/images/1.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/three-bedroom/ground-floor/images/2.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/three-bedroom/ground-floor/images/3.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/three-bedroom/ground-floor/images/4.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/three-bedroom/ground-floor/images/5.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/three-bedroom/ground-floor/images/6.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/three-bedroom/ground-floor/images/7.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/three-bedroom/ground-floor/images/8.jpg'}],image360:[],imageVirtual:[]},{type:"plan",name:"1 st Floor",value:2,floorPlan:{en:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/three-bedroom/first-floor/floor-plan/image_en.png',ru:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/three-bedroom/first-floor/floor-plan/image_ru.png',cn:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/three-bedroom/first-floor/floor-plan/image_cn.png'},images:[{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/three-bedroom/first-floor/images/1.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/three-bedroom/first-floor/images/2.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/three-bedroom/first-floor/images/3.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/three-bedroom/first-floor/images/4.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/three-bedroom/first-floor/images/5.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/three-bedroom/first-floor/images/6.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/three-bedroom/first-floor/images/7.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/three-bedroom/first-floor/images/8.jpg'}],image360:[],imageVirtual:[]},{type:"plan",name:"2 nd Floor",value:3,floorPlan:{en:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/three-bedroom/second-floor/floor-plan/image_en.png',ru:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/three-bedroom/second-floor/floor-plan/image_ru.png',cn:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/three-bedroom/second-floor/floor-plan/image_cn.png'},images:[{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/three-bedroom/second-floor/images/1.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/residences/three-bedroom/second-floor/images/2.jpg'}],image360:[],imageVirtual:[]}]}];/* harmony default export */ __webpack_exports__["a"] = ({landingPage:landingPage,type:type});

/***/ }),
/* 1016 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(2);
var landingPage=[{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/destination/landing-page/1.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/destination/landing-page/2.jpg'// backgroundPosition: 'right'
},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/destination/landing-page/3.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/destination/landing-page/4.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/destination/landing-page/5.jpg'},{image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/destination/landing-page/6.jpg'}];var map=[{value:"country",name:"Country Map",image:{en:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+'/images/destination/country-map/map-country_en.png',cn:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+'/images/destination/country-map/map-country_cn.png',ru:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+'/images/destination/country-map/map-country_ru.png'}},{value:"city",name:"City Map",images:[{name:"Airport",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/icon/map-icon-01.png',image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/destination/city-map/airport.png'},{name:"Beaches",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/icon/map-icon-02.png',image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/destination/city-map/beach.png'},{name:"Islands",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/icon/map-icon-03.png',image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/destination/city-map/island.png'},{name:"Schools",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/icon/map-icon-05.png',image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/destination/city-map/school.png'},{name:"Tourist Attractions",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/icon/map-icon-06.png',image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/destination/city-map/tourist-attraction.png'}]},{value:"project",name:"Project Map",images:[{name:"Hotels & Resorts",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/icon/project-icon-01.png',svg:null},{name:"Restaurants",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/icon/project-icon-02.png',svg:null},{name:"Spas",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/icon/project-icon-03.png',svg:null},{name:"Galleries & Shopping",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/icon/project-icon-04.png',svg:null},{name:"Shuttle Bus",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/icon/project-icon-05.png',svg:null},{name:"Shuttle Boat",icon:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-dusit-deluxe-pool-villa')+'/images/icon/project-icon-06.png',svg:null}]}];var content={title:"Destination",description:{en:"<p>Surrounded by the turquoise waters of the Andaman Sea and fringed by golden shores, Phuket is an island that compels travelers to visit from around the world.<br><br>Reaching Phuket is easy with direct flights from main cities around the world.The island is also linked to Thailand’s mainland by road.<br><br>Laguna Phuket itself is located in a prime west coast area of Phuket with proximity to an abundance of facilities. Local shopping malls, international schools and world-class hospitals are all close by, while Phuket’s international airport can be reached by car in just 25 minutes.<p>",cn:"<p>乐古浪普吉岛被金色海岸紧紧包围，四周萦绕着绿松石般的海水，这座岛屿吸引着世界各地的游客纷至沓来。<br><br>普吉岛的交通十分便捷，从世界主要城市搭乘直飞航班即可抵达。这里与泰国主岛相连，通过汽车或船只都可轻松到达。<br><br>乐古浪普吉岛位于普吉岛的西海岸，现代设施齐全。购物中心，国际学校，世界级医院随手可得，驱车25分钟即可到达普吉岛国际机场。<p>",ru:"<p>Остров Пхукет, окруженный лазурными водами Андаманского моря, омывающими золотистые песчаные пляжи, манит к себе путешественников со всего мира.<br><br>Добраться до острова очень просто: вылететь прямым рейсом можно из крупных городов разных стран. Из материковой части Таиланда сюда можно доехать на автомобиле по шоссейной дороге.<br><br>Курортный комплекс Laguna Phuket расположен на элитном западном побережье Пхукета. В непосредственной близости находится вся необходимая инфраструктура: торговые галереи, международные школы, больницы мирового уровня. До международного аэропорта Пхукета 25 минут езды на автомобиле.<p>"}};/* harmony default export */ __webpack_exports__["a"] = ({landingPage:landingPage,map:map,content:content});

/***/ }),
/* 1017 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(2);
/* harmony default export */ __webpack_exports__["a"] = ({title:"The Santuary Club",description:{en:"Experience ultimate lifestyle within worldwide network under the Banyan Tree Group. Membership is exclusively offered to the owners of Laguna, Banyan Tree, Angsana and Cassia properties only.",cn:"体验悦榕集团全球网络内的精华生活方式。仅向乐古浪、悦榕庄、悦椿和悦梿物业的业主提供会员权益。",ru:"Наслаждайтесь роскошным стилем жизни, пользуясь глобальной сетью группы Banyan Tree Group. Членство предлагается только владельцам собственности в рамках проектов Laguna, Banyan Tree, Angsana и Cassia."},image:Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])("phuket-dusit-deluxe-pool-villa")+"/images/the-sanctuary-club/image.jpg"});

/***/ }),
/* 1018 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Gallery; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Gallery=function(_Component){_inherits(Gallery,_Component);function Gallery(){_classCallCheck(this,Gallery);return _possibleConstructorReturn(this,(Gallery.__proto__||Object.getPrototypeOf(Gallery)).apply(this,arguments));}_createClass(Gallery,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common__["e" /* Gallery */],this.props);}}]);return Gallery;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 1019 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Concept; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Concept=function(_Component){_inherits(Concept,_Component);function Concept(){_classCallCheck(this,Concept);return _possibleConstructorReturn(this,(Concept.__proto__||Object.getPrototypeOf(Concept)).apply(this,arguments));}_createClass(Concept,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common__["a" /* Concept */],this.props);}}]);return Concept;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 1020 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Faq; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Faq=function(_Component){_inherits(Faq,_Component);function Faq(){_classCallCheck(this,Faq);return _possibleConstructorReturn(this,(Faq.__proto__||Object.getPrototypeOf(Faq)).apply(this,arguments));}_createClass(Faq,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common__["d" /* Faq */],this.props);}}]);return Faq;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 1021 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Destination; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Destination=function(_Component){_inherits(Destination,_Component);function Destination(){_classCallCheck(this,Destination);return _possibleConstructorReturn(this,(Destination.__proto__||Object.getPrototypeOf(Destination)).apply(this,arguments));}_createClass(Destination,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common__["b" /* Destination */],this.props);}}]);return Destination;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 1022 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return TheSanctuaryclub; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var TheSanctuaryclub=function(_Component){_inherits(TheSanctuaryclub,_Component);function TheSanctuaryclub(){_classCallCheck(this,TheSanctuaryclub);return _possibleConstructorReturn(this,(TheSanctuaryclub.__proto__||Object.getPrototypeOf(TheSanctuaryclub)).apply(this,arguments));}_createClass(TheSanctuaryclub,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common__["g" /* TheSanctuaryclub */],this.props);}}]);return TheSanctuaryclub;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 1023 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Siteplan; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hoc__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_PhuketDusitDeluxePoolVilla_sitePlan_svg__ = __webpack_require__(1024);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Siteplan=(_dec=Object(__WEBPACK_IMPORTED_MODULE_2__hoc__["a" /* multiLanguage */])(),_dec(_class=function(_Component){_inherits(Siteplan,_Component);function Siteplan(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Siteplan);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Siteplan.__proto__||Object.getPrototypeOf(Siteplan)).call.apply(_ref,[this].concat(args))),_this),_this.state={type:"all"},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Siteplan,[{key:"render",value:function render(){var _this2=this;var _props=this.props,t=_props.t,dataSitePlan=_props.dataSitePlan,currentLanguage=_props.currentLanguage,page=_props.page;var type=this.state.type;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"section-siteplan "+page+" site-plan-has-menu"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__data_PhuketDusitDeluxePoolVilla_sitePlan_svg__["a" /* default */],{currentLang:currentLanguage,selectedType:type,width:2500,height:1100}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"siteplan-container-buttongroup"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components__["c" /* ButtonGroup */],{value:type,items:dataSitePlan,onChange:function onChange(value){return _this2.setState({type:value});},direction:"horizontal",renderItem:function renderItem(_ref2){var value=_ref2.value,title=_ref2.title,active=_ref2.active,onClick=_ref2.onClick;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components__["b" /* Button */],{key:value,type:"secondary",active:active,activeStyle:{backgroundColor:"#00a9a5"},hoverStyle:{backgroundColor:"#00a9a5"},defaultStyle:{marginRight:"1px",textTransform:"uppercase"},onClick:onClick},t(title));}})));}}]);return Siteplan;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class);

/***/ }),
/* 1024 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(2);
// import MultiLineText from './MultiLineText';
var baseAssetUrl=Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* assetsPath */])("phuket-dusit-deluxe-pool-villa");/* harmony default export */ __webpack_exports__["a"] = (function(_ref){var currentLang=_ref.currentLang,selectedType=_ref.selectedType,width=_ref.width,height=_ref.height;var map=baseAssetUrl+"/images/site-plan/"+currentLang+"/map.jpg";var twoBed=baseAssetUrl+"/images/site-plan/two-bedroom.png";var threeBed=baseAssetUrl+"/images/site-plan/three-bedroom.png";// console.log('selectedType', selectedType);
return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("svg",{id:"Layer_1","data-name":"Layer 1",viewBox:"0 0 "+width+" "+height,className:"site-plan-svg"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("image",{xlinkHref:map,x:0,y:0,width:width,height:height}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("image",{xlinkHref:twoBed,x:0,y:0,width:width,height:height,className:""+(selectedType==="two-bedroom"||selectedType==="all"?"flim-out":"flim-in")}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("image",{xlinkHref:threeBed,x:0,y:0,width:width,height:height,className:""+(selectedType==="three-bedroom"||selectedType==="all"?"flim-out":"flim-in")}));});

/***/ }),
/* 1025 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Masterplan; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_includes__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_filter__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_reject__ = __webpack_require__(87);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_reject___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_reject__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_animejs__ = __webpack_require__(33);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_animejs___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_animejs__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_scroll__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_react_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_react_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__containers_ProjectMap_PhuketMasterplan__ = __webpack_require__(88);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__containers_ProjectMap_common_logos__ = __webpack_require__(66);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__components_svg_LagunaDusitDeluxePoolVillaBubble__ = __webpack_require__(1026);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__hoc__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__utils_navigation__ = __webpack_require__(65);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__utils_detector__ = __webpack_require__(56);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import styled, { keyframes } from "styled-components";
// Filter LVR logo
var logos=__WEBPACK_IMPORTED_MODULE_3_lodash_reject___default()(__WEBPACK_IMPORTED_MODULE_8__containers_ProjectMap_common_logos__["a" /* default */],function(logo){return logo.key==="dusit-deluxe-pool-villa";});// const bounce = keyframes`
//   0% {
//     transform: scale(0);
//   }
//   20% {
//     transform: scale(1);
//   }
//   40% {
//     transform: scale(0.7);
//   }
//   60% {
//     transform: scale(1);
//   }
//   100% {
//     transform: scale(1);
//   }
// `;
// const AnimatedBubble = styled.g`
//   cursor: pointer;
//   animation-name: ${bounce};
//   animation-duration: 3s;
//   animation-timing-function: cubic-bezier(0.25, 0.46, 0.45, 0.94);
//   animation-iteration-count: infinite;
// `;
var filterTexts=function filterTexts(texts){return __WEBPACK_IMPORTED_MODULE_2_lodash_filter___default()(texts,function(text,i){var excludeList=__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(text,"options.excludes",[]);if(__WEBPACK_IMPORTED_MODULE_0_lodash_includes___default()(excludeList,"lvr/masterplan")||__WEBPACK_IMPORTED_MODULE_0_lodash_includes___default()(excludeList,"masterplan"))return false;return true;});};var fixIETransform=function fixIETransform(id){return function(anim){var g=document.getElementById(id);if(g){var transform=getComputedStyle(g).getPropertyValue("transform");g.setAttribute("transform",transform);}};};var Masterplan=(_dec=Object(__WEBPACK_IMPORTED_MODULE_10__hoc__["a" /* multiLanguage */])(),_dec(_class=function(_Component){_inherits(Masterplan,_Component);function Masterplan(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Masterplan);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Masterplan.__proto__||Object.getPrototypeOf(Masterplan)).call.apply(_ref,[this].concat(args))),_this),_this.handleClickBubble=function(){// go to master plan
var headerHeight=Object(__WEBPACK_IMPORTED_MODULE_11__utils_navigation__["a" /* getHeaderHeight */])();__WEBPACK_IMPORTED_MODULE_6_react_scroll__["scroller"].scrollTo("siteplan",{duration:1500,smooth:true,offset:-headerHeight});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Masterplan,[{key:"componentDidMount",value:function componentDidMount(){__WEBPACK_IMPORTED_MODULE_5_animejs___default()({targets:"#lvr-bubble",scale:[{value:0,duration:0,elasticity:0},{value:1,duration:2000,elasticity:400}],loop:true,update:__WEBPACK_IMPORTED_MODULE_12__utils_detector__["a" /* isIE */]?fixIETransform("lvr-bubble"):null});}},{key:"render",value:function render(){var _props=this.props,t=_props.t,currentLanguage=_props.currentLanguage;return __WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",{className:"section-masterplan"},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__containers_ProjectMap_PhuketMasterplan__["a" /* default */],{activeLanguage:currentLanguage,filterTexts:filterTexts},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("g",{transform:"translate(300, 100)"},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("g",{id:"lvr-bubble",onClick:this.handleClickBubble},__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__components_svg_LagunaDusitDeluxePoolVillaBubble__["a" /* default */],{x:0,width:160,height:163})))),__WEBPACK_IMPORTED_MODULE_4_react___default.a.createElement("div",{className:"masterplan-name"},t("Master Plan")));}}]);return Masterplan;}(__WEBPACK_IMPORTED_MODULE_4_react__["Component"]))||_class);

/***/ }),
/* 1026 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var cls1={fill:'#002b49',stroke:'#fff',strokeMiterlimit:10};//{ fill: '#002b49', stroke: '#fff', strokeMiterlimit: 10 };
var cls2={fill:'#fff'};/* harmony default export */ __webpack_exports__["a"] = (function(props){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('svg',Object.assign({xmlns:'http://www.w3.org/2000/svg',viewBox:'0 0 72.5 78'},props),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title',null,'Asset 1'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Layer_2','data-name':'Layer 2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('g',{id:'Layer_1-2','data-name':'Layer 1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{style:cls1,d:'M.65,33a35.76,35.76,0,0,0,51.27,35.4l10.51,8.17L58.15,64.5A35.75,35.75,0,1,0,.65,33Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{style:cls2,d:'M17.45,22.83a1.59,1.59,0,0,0,1.42,1.31c1.92.29,3.81-.71,5.7-.32a4.43,4.43,0,0,1,3.5,3.64c.45,2.5-.14,5.21-2.58,6.41-1.61.79-3.09-.38-4.81-.13-.41.06-.76.38-1.21.36,1.14-2.18,1.11-4.93.92-7.08,0-.46,1.61-.39,2.5-.37a16.08,16.08,0,0,0-.1,5.43c0,.41.68.91,1.07.72,2.51-1.19,2.64-5.84,0-6.77-2-.71-4.32,1.38-6.32-.84a2.22,2.22,0,0,1-.09-2.84,3.3,3.3,0,0,0,0,.48'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{style:cls2,d:'M31.14,24.24c2.35,2.15-.14,5.06.25,7.65a1.14,1.14,0,0,0,1,1,1.22,1.22,0,0,0,1.36-1,15.83,15.83,0,0,0,0-5.63H36a33.16,33.16,0,0,0,0,7.65c-.73-.1-1.08-.88-2-.32-1.45.92-3.21,1.12-4.21-.14-1.95-2.46.31-5.07,1.07-7.61a2.88,2.88,0,0,0-.14-2c.13.13.26.27.41.4'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{style:cls2,d:'M43.67,26.36a1.26,1.26,0,0,1-.88,1.31c-.68.22-1.44-.1-2.18,0-.54.11-1,.69-.75,1.11.61,1.06,2.42.35,3.52,1.18a2.41,2.41,0,0,1-.21,3.85c-1.58,1.17-3.16-.3-4.8-.45a1.4,1.4,0,0,0-1.2.71c.45-1.85,2.46-1.82,3.95-1.89.56,0,.58-.29.65-.54a.92.92,0,0,0-.6-1.14c-1.08-.42-2.41,0-3.33-.74A1.74,1.74,0,0,1,37.33,28c.74-2.34,3-2.15,5-1.51.54.17,1.09-.44,1.27-.84,0,.13,0,.57,0,.71'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{style:cls2,d:'M45.43,26.32a42.53,42.53,0,0,1,.06,7.23c0,.25,1.59.17,2.44.16.16,0,.08-.17.08-.17a44.73,44.73,0,0,1-.25-7.15c0-.61-1.4-.35-1.86-.33-.08,0-.23,0-.31.05s-.23,0-.16.2m2-2.86a.73.73,0,0,1,.34,1.12,1.47,1.47,0,0,1-1.92.23.77.77,0,0,1-.37-.75c.12-.71,1.17-1,1.95-.61'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{style:cls2,d:'M52,24.25A1.93,1.93,0,0,0,52.69,26a2.38,2.38,0,0,0,1.3.25c-.29.13-.86.26-1.11.4a.87.87,0,0,0-.49.69c-.06,1.51-.37,3.56,0,4.88a1,1,0,0,0,1.64.48c.78-.67,1.05-.84,1.61-.84a2.79,2.79,0,0,0-1.18,1.4,2.16,2.16,0,0,1-2.61,1.19c-3.09-.61-1.77-5.48-2.22-7.5a1.13,1.13,0,0,0-.53-.7C51.24,26,51.67,24.71,52,23.3c0,.2,0,.9,0,1'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{style:cls2,d:'M6.63,41.29V40.13q0-.83,0-1.1a1.17,1.17,0,0,0-.07-.43.23.23,0,0,0-.18-.09v-.09h.85v.09q-.22,0-.22.28,0,.08,0,.6t0,.75q0,.23,0,.7t0,.64h.92a.71.71,0,0,0,.39-.09.69.69,0,0,0,.22-.29l.07,0-.12.55a7.63,7.63,0,0,0-1,0h-1v-.08Q6.63,41.56,6.63,41.29Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{style:cls2,d:'M11,40.72H9.72l-.15.4a.74.74,0,0,0,0,.25q0,.11.2.18v.09H9v-.09a.47.47,0,0,0,.23-.14,1.45,1.45,0,0,0,.12-.24l1.12-2.81h.08l1,2.81a.74.74,0,0,0,.13.25.59.59,0,0,0,.23.14v.09h-.83v-.09q.16-.11.16-.16a.67.67,0,0,0-.05-.2ZM10.41,39l-.61,1.51H11Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{style:cls2,d:'M15.58,40.79v.74a4,4,0,0,0-.54.09,2.78,2.78,0,0,1-.56.08,2.12,2.12,0,0,1-1.35-.42,1.67,1.67,0,0,1-.06-2.48,1.82,1.82,0,0,1,1.26-.44,3.14,3.14,0,0,1,.88.12l.14-.06V39h-.08q-.15-.46-.9-.46a1.31,1.31,0,0,0-1,.39,1.38,1.38,0,0,0-.38,1,1.68,1.68,0,0,0,.43,1.2,1.54,1.54,0,0,0,1.17.45A1.23,1.23,0,0,0,15,41.5q.25-.09.25-.24V40.8a.24.24,0,0,0,0-.16.32.32,0,0,0-.18,0V40.5l.39,0,.39,0v.09A.17.17,0,0,0,15.58,40.79Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{style:cls2,d:'M18.9,41V38.78q0-.28-.23-.28v-.09h.83v.09q-.2,0-.2.28v2.5a.24.24,0,0,0,.27.28v.09h-.69v0a.18.18,0,0,0,0-.12v-.23a2.07,2.07,0,0,1-1.1.44,1.13,1.13,0,0,1-.83-.31,1.19,1.19,0,0,1-.32-.87V38.78q0-.28-.24-.28v-.09h.86v.09q-.22,0-.22.28V40.5a.92.92,0,0,0,.3.75.85.85,0,0,0,.58.21,1.57,1.57,0,0,0,.58-.11A.87.87,0,0,0,18.9,41Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{style:cls2,d:'M20.54,41.2V38.42h.1l.43.49,2,2.05V39.44a2.59,2.59,0,0,0-.06-.75.37.37,0,0,0-.29-.18v-.09h.85v.09a.48.48,0,0,0-.25.12.39.39,0,0,0-.06.24v2.78h-.1l-2.38-2.45v1.76a1.14,1.14,0,0,0,.06.46.38.38,0,0,0,.27.15v.09h-.85v-.09a.46.46,0,0,0,.23-.12A.39.39,0,0,0,20.54,41.2Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{style:cls2,d:'M26.09,40.72H24.8l-.15.4a.74.74,0,0,0,0,.25q0,.11.2.18v.09h-.73v-.09a.47.47,0,0,0,.23-.14,1.45,1.45,0,0,0,.12-.24l1.12-2.81h.08l1,2.81a.74.74,0,0,0,.13.25.59.59,0,0,0,.23.14v.09h-.83v-.09q.16-.11.16-.16a.67.67,0,0,0-.05-.2ZM25.49,39l-.61,1.51H26Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{style:cls2,d:'M29.35,41.28V40q0-.22,0-.61t0-.55a.54.54,0,0,0-.05-.27.22.22,0,0,0-.2-.09v-.08h.86a1.55,1.55,0,0,1,.85.21.84.84,0,0,1,.38.75.74.74,0,0,1-.24.54,1.17,1.17,0,0,1-.54.3l1,1.19a.64.64,0,0,0,.29.19v.09H31v-.09l0,0a.14.14,0,0,0,0-.07l-.79-1a.69.69,0,0,0-.48-.26v1.05q0,.28.22.28v.09h-.8v-.09Q29.35,41.56,29.35,41.28Zm.37-1.93v.73l.21,0a.87.87,0,0,0,.61-.21.72.72,0,0,0,.23-.56.76.76,0,0,0-.81-.81h-.17s-.05.06-.05.14,0,.19,0,.34S29.72,39.29,29.72,39.35Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{style:cls2,d:'M34.2,38.36v.56h-.08q-.07-.33-.61-.33h-.72a7,7,0,0,0,0,.85v.47h.81a.56.56,0,0,0,.27-.05.29.29,0,0,0,.12-.18H34Q34,40,34,40v.31H34a.29.29,0,0,0-.12-.18.56.56,0,0,0-.27-.05h-.81v1.4h1a.51.51,0,0,0,.51-.32h.07l-.07.5a3.77,3.77,0,0,0-.61,0H32.12v-.06a.3.3,0,0,0,.2-.07.3.3,0,0,0,.06-.21V40q0-.76,0-1a1,1,0,0,0-.07-.39.2.2,0,0,0-.18-.07v-.09H34a.16.16,0,0,0,.16-.07Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{style:cls2,d:'M36.88,38.95H36.8a.57.57,0,0,0-.29-.33.88.88,0,0,0-.43-.11.84.84,0,0,0-.51.15.55.55,0,0,0-.23.47.68.68,0,0,0,.43.63l.78.33a.77.77,0,0,1,.43.7.86.86,0,0,1-.29.68,1.07,1.07,0,0,1-.72.23,3.08,3.08,0,0,1-.85-.13l0-.48h.08a.6.6,0,0,0,.32.36,1,1,0,0,0,.47.11.76.76,0,0,0,.48-.14.52.52,0,0,0,.2-.44.64.64,0,0,0-.43-.6l-.78-.31a.8.8,0,0,1-.43-.75.84.84,0,0,1,.34-.72,1.31,1.31,0,0,1,.79-.22l.36,0,.36,0Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{style:cls2,d:'M37.8,40a1.63,1.63,0,1,1,.48,1.19A1.62,1.62,0,0,1,37.8,40Zm.44,0a1.8,1.8,0,0,0,.29,1.08,1.21,1.21,0,0,0,1.88,0,2.15,2.15,0,0,0,0-2.16,1.21,1.21,0,0,0-1.88,0A1.8,1.8,0,0,0,38.24,40Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{style:cls2,d:'M42.2,41.28V40q0-.22,0-.61t0-.55a.54.54,0,0,0-.05-.27.22.22,0,0,0-.2-.09v-.08h.86a1.55,1.55,0,0,1,.85.21.84.84,0,0,1,.38.75.74.74,0,0,1-.24.54,1.18,1.18,0,0,1-.54.3l1,1.19a.64.64,0,0,0,.29.19v.09h-.72v-.09l0,0a.13.13,0,0,0,0-.07l-.79-1a.69.69,0,0,0-.48-.26v1.05q0,.28.22.28v.09H42v-.09Q42.2,41.56,42.2,41.28Zm.37-1.93v.73l.21,0a.87.87,0,0,0,.61-.21.72.72,0,0,0,.23-.56.76.76,0,0,0-.81-.81h-.17s-.05.06-.05.14,0,.19,0,.34S42.57,39.29,42.57,39.35Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{style:cls2,d:'M46.13,38.63h-.65a.57.57,0,0,0-.32.07A.5.5,0,0,0,45,39h-.08l0-.59h0a.78.78,0,0,0,.27.06h2.27a.78.78,0,0,0,.27-.06h0l0,.59h-.08a.5.5,0,0,0-.16-.25.57.57,0,0,0-.32-.07h-.65v2.65a.22.22,0,0,0,.06.18.66.66,0,0,0,.25.1v.09h-1v-.09a.67.67,0,0,0,.26-.1.22.22,0,0,0,.06-.18Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{style:cls2,d:'M51.33,41.7H51.2l-1.19-3a.56.56,0,0,0-.09-.17.26.26,0,0,0-.14,0v-.09h.86v.09q-.17,0-.17.08a.76.76,0,0,0,.05.18l.83,2.34.84-2.1a.82.82,0,0,0,.06-.3.2.2,0,0,0,0-.15.32.32,0,0,0-.16-.06v-.09h.81v.09a.3.3,0,0,0-.18.08.59.59,0,0,0-.1.18Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{style:cls2,d:'M54.38,38.42v.09q-.23,0-.23.28l0,2.5a.33.33,0,0,0,.06.2.18.18,0,0,0,.15.08v.09h-.76v-.09a.17.17,0,0,0,.15-.08.34.34,0,0,0,.06-.19l0-2.5q0-.28-.23-.28v-.09h.85Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{style:cls2,d:'M55.49,41.29V40.13q0-.83,0-1.1a1.17,1.17,0,0,0-.07-.43.23.23,0,0,0-.18-.09v-.09h.85v.09q-.22,0-.22.28,0,.08,0,.6t0,.75q0,.23,0,.7t0,.64h.92a.71.71,0,0,0,.39-.09.69.69,0,0,0,.22-.29l.07,0-.12.55a7.63,7.63,0,0,0-1,0h-1v-.08Q55.49,41.56,55.49,41.29Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{style:cls2,d:'M58.31,41.29V40.13q0-.83,0-1.1a1.17,1.17,0,0,0-.07-.43.23.23,0,0,0-.18-.09v-.09h.85v.09q-.22,0-.22.28,0,.08,0,.6t0,.75q0,.23,0,.7t0,.64h.92a.71.71,0,0,0,.39-.09.69.69,0,0,0,.22-.29l.07,0-.12.55a7.63,7.63,0,0,0-1,0h-1v-.08Q58.31,41.56,58.31,41.29Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{style:cls2,d:'M62.69,40.72H61.4l-.15.4a.74.74,0,0,0,0,.25q0,.11.2.18v.09h-.73v-.09a.47.47,0,0,0,.23-.14,1.46,1.46,0,0,0,.12-.24l1.12-2.81h.08l1,2.81a.74.74,0,0,0,.13.25.59.59,0,0,0,.23.14v.09h-.83v-.09q.16-.11.16-.16a.68.68,0,0,0-.05-.2ZM62.09,39l-.61,1.51h1.16Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{style:cls2,d:'M66.07,38.95H66a.57.57,0,0,0-.29-.33.88.88,0,0,0-.43-.11.84.84,0,0,0-.51.15.55.55,0,0,0-.23.47.68.68,0,0,0,.43.63l.78.33a.77.77,0,0,1,.43.7.86.86,0,0,1-.29.68,1.07,1.07,0,0,1-.72.23,3.08,3.08,0,0,1-.85-.13l0-.48h.08a.6.6,0,0,0,.32.36,1,1,0,0,0,.47.11.76.76,0,0,0,.48-.14.52.52,0,0,0,.2-.44.64.64,0,0,0-.43-.6l-.78-.31a.8.8,0,0,1-.43-.75.84.84,0,0,1,.34-.72,1.31,1.31,0,0,1,.79-.22l.36,0,.36,0Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('rect',{style:cls2,x:'16.12',y:'43.58',width:'39.94',height:'0.09'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{style:cls2,d:'M27.63,48.11V45.9q0-.25-.2-.25v-.08h.94a1,1,0,0,1,.62.18.75.75,0,0,1,.3.64.72.72,0,0,1-.3.6,1,1,0,0,1-.65.21l-.38,0v.93q0,.25.19.25v.08h-.71v-.08Q27.63,48.36,27.63,48.11ZM28,46.41v.54a.12.12,0,0,0,0,.11.56.56,0,0,0,.28,0q.64,0,.64-.72t-.68-.71a.25.25,0,0,0-.24.12.65.65,0,0,0,0,.29Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{style:cls2,d:'M32.35,47H30.46v1.09q0,.25.16.25v.08H30v-.08a.13.13,0,0,0,.11-.07.32.32,0,0,0,0-.17V46.28a1.87,1.87,0,0,0,0-.43q-.05-.21-.17-.2v-.08h.71v.08q-.19,0-.2.25v1h1.89v-1q0-.25-.19-.25v-.08h.71v.08q-.12,0-.17.2a1.83,1.83,0,0,0,0,.43v1.84a.32.32,0,0,0,0,.17.14.14,0,0,0,.12.07v.08H32.2v-.08q.15,0,.15-.25Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{style:cls2,d:'M35.83,47.88v-2q0-.25-.21-.25v-.08h.74v.08q-.18,0-.18.25v2.22a.21.21,0,0,0,.24.25v.08h-.62v0a.16.16,0,0,0,0-.11v-.2a1.84,1.84,0,0,1-1,.39,1,1,0,0,1-.74-.28,1.06,1.06,0,0,1-.28-.77V45.9q0-.25-.21-.25v-.08h.76v.08q-.2,0-.2.25v1.53a.82.82,0,0,0,.27.67.76.76,0,0,0,.51.18,1.39,1.39,0,0,0,.51-.1A.77.77,0,0,0,35.83,47.88Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{style:cls2,d:'M37.35,48.11V46.2q0-.52-.19-.55v-.08h.7v.08q-.18,0-.18.25v1l.78-.69a1.85,1.85,0,0,0,.25-.27.38.38,0,0,0,.09-.15q0-.08-.11-.09v-.08h.76v.08a.85.85,0,0,0-.3.09,1.1,1.1,0,0,0-.19.15l-1,.93L39.26,48l.24.21a1,1,0,0,0,.28.14v.08l-.42,0h-.42v-.08a.1.1,0,0,0,.06-.08q0-.08-.16-.22L37.67,47v1.14q0,.25.17.25v.08h-.67v-.08Q37.35,48.36,37.35,48.11Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{style:cls2,d:'M42.07,45.52V46H42q-.07-.29-.54-.29h-.64a6.21,6.21,0,0,0,0,.76v.41h.72a.5.5,0,0,0,.24,0,.26.26,0,0,0,.11-.16h.07q0,.26,0,.28v.28h-.07a.26.26,0,0,0-.11-.16.5.5,0,0,0-.24,0h-.72v1.24h.85a.46.46,0,0,0,.45-.28h.07l-.06.44a3.36,3.36,0,0,0-.55,0H40.23v-.06a.27.27,0,0,0,.18-.06.27.27,0,0,0,0-.18V47q0-.68,0-.9a.85.85,0,0,0-.06-.35.18.18,0,0,0-.16-.06v-.08h1.63a.14.14,0,0,0,.14-.07Z'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('path',{style:cls2,d:'M43.76,45.76h-.57a.51.51,0,0,0-.29.06.45.45,0,0,0-.15.23h-.07l0-.52h0a.69.69,0,0,0,.24,0h2a.69.69,0,0,0,.24,0h0l0,.52h-.07a.45.45,0,0,0-.15-.23.51.51,0,0,0-.29-.06h-.57v2.36a.2.2,0,0,0,.06.16.59.59,0,0,0,.22.09v.08h-.89v-.08a.6.6,0,0,0,.23-.09.2.2,0,0,0,.06-.16Z'}))));});

/***/ }),
/* 1027 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Residences; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Residences=function(_Component){_inherits(Residences,_Component);function Residences(){_classCallCheck(this,Residences);return _possibleConstructorReturn(this,(Residences.__proto__||Object.getPrototypeOf(Residences)).apply(this,arguments));}_createClass(Residences,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common__["f" /* Residences */],this.props);}}]);return Residences;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 1028 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Ebrochure; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Ebrochure=function(_Component){_inherits(Ebrochure,_Component);function Ebrochure(){_classCallCheck(this,Ebrochure);return _possibleConstructorReturn(this,(Ebrochure.__proto__||Object.getPrototypeOf(Ebrochure)).apply(this,arguments));}_createClass(Ebrochure,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common__["c" /* Ebrochure */],this.props);}}]);return Ebrochure;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 1029 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "category", function() { return category; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faqs", function() { return faqs; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var category=[{id:1,name:"Legal",displayOn:["en","cn","ru"]},{id:2,name:"Construction",displayOn:["en","cn","ru"]},{id:3,name:"Rental Program",displayOn:["en","cn","ru"]},{id:4,name:"Property Management",displayOn:["en","cn","ru"]},{id:5,name:"Privileges",displayOn:["en","cn","ru"]},// { id: 6, name: "Infrastructure & Common Areas", displayOn: ["en", "cn", "ru"] },
{id:7,name:"Financing",displayOn:["en","cn","ru"]}];var faqs=[{categoryId:1,question:"What types of ownership are available?",displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"A.")," As these villas are an integral part of the exclusive Dusit Laguna Resort Villas Phuket, land is offered on a leasehold basis only. Leases are registered with the Government (currently for a maximum period of 30 years as permitted by law) and are renewable. However, the buildings are sold as freehold.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"O.")," \u0412\u0438\u043B\u043B\u044B \u044F\u0432\u043B\u044F\u044E\u0442\u0441\u044F \u0447\u0430\u0441\u0442\u044C\u044E \u044D\u043A\u0441\u043A\u043B\u044E\u0437\u0438\u0432\u043D\u043E\u0433\u043E \u043F\u0440\u043E\u0435\u043A\u0442\u0430 Dusit Laguna Resort Villas Phuket, \u0437\u0435\u043C\u043B\u044F \u043F\u043E\u0434 \u0441\u0442\u0440\u043E\u0435\u043D\u0438\u0435\u043C \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u0432\u043E \u0432\u043B\u0430\u0434\u0435\u043D\u0438\u0435 \u043D\u0430 \u043F\u0440\u0430\u0432\u0430\u0445 \u0434\u043E\u043B\u0433\u043E\u0441\u0440\u043E\u0447\u043D\u043E\u0439 \u0430\u0440\u0435\u043D\u0434\u044B. \u041D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u0430 \u0433\u043E\u0441\u0443\u0434\u0430\u0440\u0441\u0442\u0432\u0435\u043D\u043D\u0430\u044F \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F \u0430\u0440\u0435\u043D\u0434\u043D\u044B\u0445 \u043F\u0440\u0430\u0432 (\u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u043C \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E\u043C \u043C\u0430\u043A\u0441\u0438\u043C\u0430\u043B\u044C\u043D\u044B\u0439 \u0441\u0440\u043E\u043A \u0434\u0435\u0439\u0441\u0442\u0432\u0438\u044F \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0441\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 30 \u043B\u0435\u0442), \u0441 \u043F\u043E\u0441\u043B\u0435\u0434\u0443\u044E\u0449\u0438\u043C \u043F\u0440\u043E\u0434\u043B\u0435\u043D\u0438\u0435\u043C \u043D\u0430 \u043D\u043E\u0432\u044B\u0439 \u0441\u0440\u043E\u043A. \u041E\u0434\u043D\u0430\u043A\u043E \u0437\u0434\u0430\u043D\u0438\u044F \u043F\u0440\u043E\u0434\u0430\u044E\u0442\u0441\u044F \u0432 \u043F\u043E\u043B\u043D\u0443\u044E \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u044C.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u7B54.")," ","\u7531\u4E8E\u8FD9\u4E9B\u522B\u5885\u662F\u666E\u5409\u5C9B\u4E50\u53E4\u6D6A\u90FD\u559C\u5EA6\u5047\u6751\u522B\u5885\u7684\u7EC4\u6210\u90E8\u5206\uFF0C\u56E0\u6B64\u571F\u5730\u4EC5\u4EE5\u79DF\u8D41\u65B9\u5F0F\u63D0\u4F9B\u3002\u79DF\u7EA6\u987B\u5411\u653F\u5E9C\u767B\u8BB0(\u76EE\u524D\u6CD5\u5F8B\u5141\u8BB8\u7684\u6700\u957F\u671F\u9650\u4E3A30 \u5E74)\uFF0C\u5E76\u53EF\u7EED\u671F\u3002\u7136\u800C\uFF0C\u571F\u5730\u4E4B\u4E0A\u7684\u5EFA\u7B51\u7269\u4EE5\u6C38\u4E45\u4EA7\u6743\u65B9\u5F0F\u51FA\u552E\u3002"))}},{categoryId:1,question:"What are the costs associated with the lease / freehold registration?",displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"A.")," These are outlined below:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Leasehold land title"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Lease registration fees and stamp duty (currently 1.1% of the lease premium) is payable to the Land Department upon registration of the lease.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Freehold building title"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Freehold registration fees (currently 2.0% of the appraisal price of building) is payable to the Land Department upon transfer and registration of title of the building. The appraisal price is calculated relative to the government\u2019s tax assessment value which is generally well below market value. Other applicable taxes upon transfer and registration of freehold building title are:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"white-circle"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Corporate Income Tax")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"(Currently 1.0% of the selling price or appraisal price, whichever is higher)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"white-circle"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Special Business Tax")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"(Currently 3.3% of the selling price or appraisal price, whichever is higher)")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"The burden between the seller and the purchaser for the above costs will be specified in the Lease and/or Sale & Purchase Agreements."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"Note: Those certain applicable tax rates rely upon the relevant Thai tax laws at the date of issue of this Q&A. Changes in law or circumstances may occur after the issue date.")))),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"O.")," \u0418\u043D\u0444\u043E\u0440\u043C\u0430\u0446\u0438\u044F \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u0435\u043D\u0430 \u043D\u0438\u0436\u0435:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F \u043F\u0440\u0430\u0432 \u0430\u0440\u0435\u043D\u0434\u044B \u043D\u0430 \u0437\u0435\u043C\u043B\u044E"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041F\u0440\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430 \u0430\u0440\u0435\u043D\u0434\u044B \u0432 \u0417\u0435\u043C\u0435\u043B\u044C\u043D\u043E\u043C \u0434\u0435\u043F\u0430\u0440\u0442\u0430\u043C\u0435\u043D\u0442\u0435 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u043E\u043F\u043B\u0430\u0442\u0438\u0442\u044C \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0435 \u0441\u0431\u043E\u0440\u044B \u0438 \u043F\u043E\u0448\u043B\u0438\u043D\u044B (\u0432 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0435 \u0432\u0440\u0435\u043C\u044F 1,1% \u043E\u0442 \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u0438 \u0430\u0440\u0435\u043D\u0434\u044B \u0437\u0435\u043C\u043B\u0438).")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u0420\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u044F \u043F\u0440\u0430\u0432 \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041F\u0440\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430 \u0430\u0440\u0435\u043D\u0434\u044B \u0432 \u0417\u0435\u043C\u0435\u043B\u044C\u043D\u043E\u043C \u0434\u0435\u043F\u0430\u0440\u0442\u0430\u043C\u0435\u043D\u0442\u0435 \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u043E\u043F\u043B\u0430\u0442\u0438\u0442\u044C \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0435 \u0441\u0431\u043E\u0440\u044B \u0438 \u043F\u043E\u0448\u043B\u0438\u043D\u044B (\u0432 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0435 \u0432\u0440\u0435\u043C\u044F 1,1% \u043E\u0442 \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u0438 \u0430\u0440\u0435\u043D\u0434\u044B \u0437\u0435\u043C\u043B\u0438)."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"white-circle"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u041A\u043E\u0440\u043F\u043E\u0440\u0430\u0442\u0438\u0432\u043D\u044B\u0439 \u043D\u0430\u043B\u043E\u0433 \u043D\u0430 \u043F\u0440\u0438\u0431\u044B\u043B\u044C")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"(\u0432 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0435 \u0432\u0440\u0435\u043C\u044F 1,0% \u043E\u0442 \u043F\u0440\u043E\u0434\u0430\u0436\u043D\u043E\u0439 \u0438\u043B\u0438 \u043E\u0446\u0435\u043D\u043E\u0447\u043D\u043E\u0439 \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u0438, \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u0442\u0441\u044F \u0441\u0430\u043C\u0430\u044F \u0432\u044B\u0441\u043E\u043A\u0430\u044F \u0441\u0442\u0430\u0432\u043A\u0430)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",{className:"white-circle"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u0421\u043F\u0435\u0446\u0438\u0430\u043B\u044C\u043D\u044B\u0439 \u043F\u0440\u0435\u0434\u043F\u0440\u0438\u043D\u0438\u043C\u0430\u0442\u0435\u043B\u044C\u0441\u043A\u0438\u0439 \u043D\u0430\u043B\u043E\u0433")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"(\u0432 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0435 \u0432\u0440\u0435\u043C\u044F 3,3% \u043E\u0442 \u043F\u0440\u043E\u0434\u0430\u0436\u043D\u043E\u0439 \u0438\u043B\u0438 \u043E\u0446\u0435\u043D\u043E\u0447\u043D\u043E\u0439 \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u0438, \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u0435\u0442\u0441\u044F \u0441\u0430\u043C\u0430\u044F \u0432\u044B\u0441\u043E\u043A\u0430\u044F \u0441\u0442\u0430\u0432\u043A\u0430)")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0420\u0430\u0441\u043F\u0440\u0435\u0434\u0435\u043B\u0435\u043D\u0438\u0435 \u0432\u044B\u0448\u0435\u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0445 \u0438\u0437\u0434\u0435\u0440\u0436\u0435\u043A \u043C\u0435\u0436\u0434\u0443 \u043F\u0440\u043E\u0434\u0430\u0432\u0446\u043E\u043C \u0438 \u043F\u043E\u043A\u0443\u043F\u0430\u0442\u0435\u043B\u0435\u043C \u043E\u043F\u0440\u0435\u0434\u0435\u043B\u044F\u0435\u0442\u0441\u044F \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430\u043C\u0438 \u0430\u0440\u0435\u043D\u0434\u044B \u0438/\u0438\u043B\u0438 \u043A\u0443\u043F\u043B\u0438-\u043F\u0440\u043E\u0434\u0430\u0436\u0438."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"\u041F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0435: \u0414\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0435 \u043D\u0430\u043B\u043E\u0433\u043E\u0432\u044B\u0435 \u0441\u0442\u0430\u0432\u043A\u0438 \u043F\u0440\u0438\u0432\u0435\u0434\u0435\u043D\u044B \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u043C \u0437\u0430\u043A\u043E\u043D\u043E\u0434\u0430\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E\u043C \u0422\u0430\u0438\u043B\u0430\u043D\u0434\u0430 \u043D\u0430 \u043C\u043E\u043C\u0435\u043D\u0442 \u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0446\u0438\u0438 \u043D\u0430\u0441\u0442\u043E\u044F\u0449\u0435\u0433\u043E \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430, \u043D\u043E \u043C\u043E\u0433\u0443\u0442 \u0431\u044B\u0442\u044C \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u044B \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u043C \u0432\u043B\u0430\u0441\u0442\u044F\u043C \u0422\u0430\u0438\u043B\u0430\u043D\u0434\u0430.")))),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u7B54.")," \u8FD9\u4E9B\u60C5\u51B5\u6982\u8FF0\u5982\u4E0B\uFF1A"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null," \u571F\u5730\u79DF\u8D41\u6743"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u79DF\u8D41\u767B\u8BB0\u8D39\u53CA\u5370\u82B1\u7A0E(\u73B0\u4E3A\u79DF\u8D41\u4EF7\u76841.1%)\u987B\u5728\u79DF\u8D41\u767B\u8BB0\u540E\u7F34\u4EA4\u571F\u5730\u7BA1\u7406\u90E8\u95E8\u3002")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null," \u5EFA\u7B51\u6C38\u4E45\u4EA7\u6743"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u6C38\u4E45\u4EA7\u6743\u767B\u8BB0\u8D39\uFF08\u73B0\u4E3A\u5EFA\u7B51\u7269\u8BC4\u4F30\u4EF7\u683C\u76842.0%\uFF09\u987B\u5728\u8F6C\u8BA9\u548C\u767B\u8BB0\u5EFA\u7B51\u7269\u4EA7\u6743\u65F6\u5411\u571F\u5730\u7BA1\u7406\u90E8\u95E8\u7F34\u4ED8\u3002\u8BC4\u4F30\u4EF7\u683C\u662F\u76F8\u5BF9\u4E8E\u653F\u5E9C\u7684\u5F81\u7A0E\u4F30\u503C\u6765\u8BA1\u7B97\u7684\uFF0C\u4E00\u822C\u8FDC\u4F4E\u4E8E\u5E02\u573A\u4EF7\u503C\u3002\u8F6C\u8BA9\u53CA\u767B\u8BB0\u6C38\u4E45\u4EA7\u6743\u65F6\u9002\u7528\u7684\u5176\u4ED6\u7A0E\u9879\u5305\u62EC\uFF1A"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u4F01\u4E1A\u6240\u5F97\u7A0E")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"(\u73B0\u4E3A\u552E\u4EF7\u6216\u8BC4\u4F30\u4EF7\u76841.0%\uFF0C\u4EE5\u8F83\u9AD8\u8005\u4E3A\u51C6)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u7279\u5B9A\u8425\u4E1A\u7A0E")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"(\u73B0\u4E3A\u552E\u4EF7\u6216\u8BC4\u4F30\u4EF7\u76843.3%\uFF0C\u4EE5\u8F83\u9AD8\u8005\u4E3A\u51C6)")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u5356\u65B9\u548C\u4E70\u65B9\u4E4B\u95F4\u5BF9\u4E0A\u8FF0\u8D39\u7528\u7684\u8D1F\u62C5\u65B9\u5F0F\u5C06\u5728\u79DF\u8D41\u548C/\u6216\u4E70\u5356\u534F\u8BAE\u4E2D\u660E\u786E\u89C4\u5B9A\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"\u6CE8\u610F\uFF1A \u8FD9\u4E9B\u7279\u5B9A\u7684\u9002\u7528\u7A0E\u7387\u53D6\u51B3\u4E8E\u672C\u5E38\u89C1\u95EE\u9898\u53D1\u5E03\u65E5\u671F\u7684\u76F8\u5173\u6CF0\u56FD\u7A0E\u6CD5\u3002\u672C\u95EE\u7B54\u5185\u5BB9\u53D1\u5E03\u540E\uFF0C\u6CD5\u5F8B\u6216\u60C5\u51B5\u6709\u53EF\u80FD\u53D8\u5316\u53EF\u80FD\u3002"))))}},{categoryId:1,question:"Is leasehold land transferable?",displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"A.")," Leasehold land may be transferred subject to the terms and conditions of the agreements. Generally, an assignment fee is payable. In addition, the assignee must agree to be bound by the terms and conditions contained in the original lease agreement.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"O.")," \u041F\u0435\u0440\u0435\u0434\u0430\u0447\u0430 \u043F\u0440\u0430\u0432 \u043F\u0440\u0438 \u0432\u043B\u0430\u0434\u0435\u043D\u0438\u0438 \u0437\u0435\u043C\u043B\u0435\u0439 \u043D\u0430 \u043F\u0440\u0430\u0432\u0430\u0445 \u0430\u0440\u0435\u043D\u0434\u044B \u043C\u043E\u0436\u0435\u0442 \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0442\u044C\u0441\u044F \u0432 \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0438\u0438 \u0441 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u043C\u0438 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430 \u0430\u0440\u0435\u043D\u0434\u044B. \u041E\u0431\u044B\u0447\u043D\u043E \u0437\u0430 \u043F\u0435\u0440\u0435\u0434\u0430\u0447\u0443 \u043F\u0440\u0430\u0432 \u0432\u0437\u0438\u043C\u0430\u0435\u0442\u0441\u044F \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0430\u044F \u043F\u043B\u0430\u0442\u0430. \u041A\u0440\u043E\u043C\u0435 \u0442\u043E\u0433\u043E, \u043F\u0440\u0430\u0432\u043E\u043F\u0440\u0435\u0435\u043C\u043D\u0438\u043A \u0434\u043E\u043B\u0436\u0435\u043D \u043F\u043E\u0434\u0442\u0432\u0435\u0440\u0434\u0438\u0442\u044C \u0441\u043E\u0433\u043B\u0430\u0441\u0438\u0435 \u0441 \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u043C\u0438 \u043F\u0435\u0440\u0432\u043E\u043D\u0430\u0447\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430 \u0430\u0440\u0435\u043D\u0434\u044B.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u7B54.")," ","\u79DF\u8D41\u571F\u5730\u53EF\u6839\u636E\u53CC\u65B9\u534F\u8BAE\u7684\u6761\u6B3E\u548C\u6761\u4EF6\u8FDB\u884C\u8F6C\u8BA9\u3002\u4E00\u822C\u800C\u8A00\uFF0C\u9700\u8981\u652F\u4ED8\u8F6C\u8BA9\u8D39\u3002\u6B64\u5916\uFF0C\u53D7\u8BA9\u4EBA\u5FC5\u987B\u540C\u610F\u53D7\u539F\u59CB\u79DF\u8D41\u534F\u8BAE\u6240\u8F7D\u6761\u6B3E\u548C\u6761\u4EF6\u7684\u7EA6\u675F\u3002"))}},{categoryId:1,question:"Can leasehold be upgraded to freehold title?",displayOn:["en","ru","cn"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"A.")," As these villas are an integral part of the exclusive Dusit Laguna Resort Villas Phuket, the option to purchase the land on a freehold basis is not available.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"O.")," \u0422\u0430\u043A \u043A\u0430\u043A \u0434\u0430\u043D\u043D\u044B\u0435 \u0432\u0438\u043B\u043B\u044B \u044F\u0432\u043B\u044F\u044E\u0442\u0441\u044F \u0447\u0430\u0441\u0442\u044C\u044E \u044D\u043A\u0441\u043A\u043B\u044E\u0437\u0438\u0432\u043D\u043E\u0433\u043E \u043F\u0440\u043E\u0435\u043A\u0442\u0430 Dusit Laguna Resort Villas Phuket, \u043F\u0440\u0438\u043E\u0431\u0440\u0435\u0442\u0435\u043D\u0438\u0435 \u043F\u0440\u0430\u0432 \u043D\u0430 \u043F\u043E\u043B\u043D\u043E\u0435 \u0431\u0435\u0441\u0441\u0440\u043E\u0447\u043D\u043E\u0435 \u0432\u043B\u0430\u0434\u0435\u043D\u0438\u0435 \u0437\u0435\u043C\u0435\u043B\u044C\u043D\u044B\u043C \u0443\u0447\u0430\u0441\u0442\u043A\u043E\u043C \u043D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u7B54.")," ","\u7531\u4E8E\u8FD9\u4E9B\u522B\u5885\u662F\u666E\u5409\u5C9B\u4E50\u53E4\u6D6A\u90FD\u559C\u5EA6\u5047\u6751\u522B\u5885\u7684\u7EC4\u6210\u90E8\u5206\uFF0C\u56E0\u6B64\u65E0\u6CD5\u9009\u62E9\u4EE5\u6C38\u4E45\u4EA7\u6743\u65B9\u5F0F\u8D2D\u4E70\u571F\u5730\u3002"))}},{categoryId:1,question:"Is leasehold land ownership secure?",displayOn:["en","ru","cn"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"A.")," Leasehold ownership is a common method of ownership for foreign buyers. Once the lease is registered at the Land Department, the right of use to the land will be vested with the lessee.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"O.")," \u0412\u043B\u0430\u0434\u0435\u043D\u0438\u0435 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u044C\u044E \u043D\u0430 \u043F\u0440\u0430\u0432\u0430\u0445 \u0430\u0440\u0435\u043D\u0434\u044B \u2014 \u0448\u0438\u0440\u043E\u043A\u043E \u0440\u0430\u0441\u043F\u0440\u043E\u0441\u0442\u0440\u0430\u043D\u0435\u043D\u043D\u0430\u044F \u0444\u043E\u0440\u043C\u0430 \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u0434\u043B\u044F \u0438\u043D\u043E\u0441\u0442\u0440\u0430\u043D\u043D\u044B\u0445 \u043F\u043E\u043A\u0443\u043F\u0430\u0442\u0435\u043B\u0435\u0439. \u041F\u0440\u0430\u0432\u0430 \u0430\u0440\u0435\u043D\u0434\u0430\u0442\u043E\u0440\u0430 \u043E\u0444\u0438\u0446\u0438\u0430\u043B\u044C\u043D\u043E \u043F\u0440\u0438\u0437\u043D\u0430\u044E\u0442\u0441\u044F \u0441\u0440\u0430\u0437\u0443 \u0436\u0435 \u043F\u043E\u0441\u043B\u0435 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430 \u0430\u0440\u0435\u043D\u0434\u044B \u0432 \u0417\u0435\u043C\u0435\u043B\u044C\u043D\u043E\u043C \u0434\u0435\u043F\u0430\u0440\u0442\u0430\u043C\u0435\u043D\u0442\u0435.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u7B54.")," ","\u79DF\u8D41\u6240\u6709\u6743\u662F\u5916\u7C4D\u4E70\u53D7\u4EBA\u83B7\u53D6\u6240\u6709\u6743\u7684\u5E38\u89C1\u65B9\u6CD5\u3002\u4E00\u65E6\u79DF\u7EA6\u5728\u571F\u5730\u7BA1\u7406\u90E8\u95E8\u767B\u8BB0\u540E\uFF0C\u571F\u5730\u7684\u4F7F\u7528\u6743\u5C06\u8D4B\u4E88\u627F\u79DF\u4EBA\u3002"))}},{categoryId:1,question:"Should I appoint a lawyer to review the agreements?",displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"A.")," Our agreements have been used for a number of years and have been reviewed by major international law firms. We have our own in-house legal team which will assist to clarify any questions you may have concerning the agreements. However, should you wish to obtain specific advice regarding the structuring of your investment, we recommend you consult with a professional legal and/or financial adviser.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"O.")," \u041D\u0430\u0448\u0438 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u044B \u0438\u0441\u043F\u043E\u043B\u044C\u0437\u0443\u044E\u0442\u0441\u044F \u043C\u043D\u043E\u0433\u043E \u043B\u0435\u0442 \u0438 \u0431\u044B\u043B\u0438 \u043F\u0440\u043E\u0432\u0435\u0440\u0435\u043D\u044B \u043B\u0443\u0447\u0448\u0438\u043C\u0438 \u043C\u0435\u0436\u0434\u0443\u043D\u0430\u0440\u043E\u0434\u043D\u044B\u043C\u0438 \u044E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u0438\u043C\u0438 \u0444\u0438\u0440\u043C\u0430\u043C\u0438. \u0423 \u043D\u0430\u0441 \u0442\u0430\u043A\u0436\u0435 \u0435\u0441\u0442\u044C \u0441\u0432\u043E\u044F \u043A\u043E\u043C\u0430\u043D\u0434\u0430 \u044E\u0440\u0438\u0441\u0442\u043E\u0432, \u0433\u043E\u0442\u043E\u0432\u0430\u044F \u043F\u0440\u043E\u044F\u0441\u043D\u0438\u0442\u044C \u043B\u044E\u0431\u044B\u0435 \u0432\u043E\u043F\u0440\u043E\u0441\u044B, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u043C\u043E\u0433\u0443\u0442 \u0432\u043E\u0437\u043D\u0438\u043A\u043D\u0443\u0442\u044C \u0443 \u0432\u0430\u0441 \u0432 \u0441\u0432\u044F\u0437\u0438 \u0441 \u0434\u043E\u0433\u043E\u0432\u043E\u0440\u0430\u043C\u0438. \u0422\u0435\u043C \u043D\u0435 \u043C\u0435\u043D\u0435\u0435, \u0435\u0441\u043B\u0438 \u0432\u0430\u043C \u043F\u043E\u043D\u0430\u0434\u043E\u0431\u0438\u0442\u0441\u044F \u043A\u043E\u043D\u0441\u0443\u043B\u044C\u0442\u0430\u0446\u0438\u044F \u043F\u043E \u043A\u0430\u043A\u0438\u043C-\u043B\u0438\u0431\u043E \u043A\u043E\u043D\u043A\u0440\u0435\u0442\u043D\u044B\u043C \u0432\u043E\u043F\u0440\u043E\u0441\u0430\u043C, \u043A\u0430\u0441\u0430\u044E\u0449\u0438\u043C\u0441\u044F \u043F\u043B\u0430\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F \u0432\u0430\u0448\u0438\u0445 \u0438\u043D\u0432\u0435\u0441\u0442\u0438\u0446\u0438\u0439, \u043C\u044B \u0440\u0435\u043A\u043E\u043C\u0435\u043D\u0434\u0443\u0435\u043C \u043E\u0431\u0440\u0430\u0442\u0438\u0442\u044C\u0441\u044F \u043A \u043F\u0440\u043E\u0444\u0435\u0441\u0441\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u043E\u043C\u0443 \u044E\u0440\u0438\u0434\u0438\u0447\u0435\u0441\u043A\u043E\u043C\u0443 \u0438/\u0438\u043B\u0438 \u0444\u0438\u043D\u0430\u043D\u0441\u043E\u0432\u043E\u043C\u0443 \u043A\u043E\u043D\u0441\u0443\u043B\u044C\u0442\u0430\u043D\u0442\u0443.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u7B54.")," ","\u6211\u4EEC\u7684\u534F\u8BAE\u5DF2\u7ECF\u4F7F\u7528\u591A\u5E74\uFF0C\u5E76\u5DF2\u7ECF\u8FC7\u5404\u5927\u56FD\u9645\u5F8B\u5E08\u4E8B\u52A1\u6240\u7684\u5BA1\u6838\u3002\u6211\u4EEC\u62E5\u6709\u81EA\u5DF1\u7684\u5185\u90E8\u6CD5\u5F8B\u56E2\u961F\uFF0C\u5C06\u4E3A\u60A8\u6F84\u6E05\u4E0E\u534F\u8BAE\u6709\u5173\u7684\u4EFB\u4F55\u95EE\u9898\u3002\u4E0D\u8FC7\uFF0C\u5982\u679C\u60A8\u5E0C\u671B\u83B7\u5F97\u6709\u5173\u6295\u8D44\u7ED3\u6784\u7684\u5177\u4F53\u5EFA\u8BAE\uFF0C\u6211\u4EEC\u5EFA\u8BAE\u60A8\u54A8\u8BE2\u4E13\u4E1A\u7684\u6CD5\u5F8B\u548C/\u6216\u8D22\u52A1\u987E\u95EE\u3002/\u6216\u8D22\u52A1\u987E\u95EE\u3002"))}},{categoryId:1,question:"When will be the lease / house transfer registration take place?",displayOn:["en","ru","cn"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"A.")," Within 90 days after full payments of the Rental and Purchase Price of the land and buildings have been made, we will notify the lessee / buyer of any required documents and fees which will be incurred upon registration.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"O.")," \u0412 \u0442\u0435\u0447\u0435\u043D\u0438\u0438 90 \u0434\u043D\u0435\u0439 \u043F\u043E\u0441\u043B\u0435 \u043E\u043F\u043B\u0430\u0442\u044B \u043F\u043E\u043B\u043D\u043E\u0439 \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u0438 \u0438 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u043E\u0431\u044A\u0435\u043A\u0442\u0430 \u043C\u044B \u0441\u043E\u043E\u0431\u0449\u0438\u043C \u043F\u043E\u043A\u0443\u043F\u0430\u0442\u0435\u043B\u044E \u0441\u043F\u0438\u0441\u043E\u043A \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u044B\u0445 \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u043E\u0432 \u0438 \u0441\u0431\u043E\u0440\u043E\u0432, \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u044B\u0445 \u043F\u0440\u0438 \u0440\u0435\u0433\u0438\u0441\u0442\u0440\u0430\u0446\u0438\u0438.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u7B54.")," \u5728\u571F\u5730\u53CA\u5EFA\u7B51\u7269\u7684\u79DF\u91D1\u53CA\u8D2D\u4E70\u4EF7\u6B3E\u5168\u989D\u652F\u4ED8\u540E90 \u5929\u5185\uFF0C\u6211\u4EEC\u4F1A\u901A\u77E5\u627F\u79DF\u4EBA/\u4E70\u53D7\u4EBA\u5728\u6CE8\u518C\u65F6\u9700\u8981\u63D0\u4EA4\u7684\u4EFB\u4F55\u6587\u4EF6\u53CA\u9700\u8981\u652F\u4ED8\u7684\u4EFB\u4F55\u8D39\u7528\u3002"))}},{categoryId:2,question:"Types and number of properties for sale?",displayOn:["en","ru","cn"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"A.")," There are twenty-two (22) luxury two and three bedroom pool villas planned at the Dusit Laguna Resort Phuket.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"O.")," \u0412 \u0440\u0430\u043C\u043A\u0430\u0445 \u043F\u0440\u043E\u0435\u043A\u0442\u0430 Dusit Laguna Resort Phuket \u043F\u043B\u0430\u043D\u0438\u0440\u0443\u0435\u0442\u0441\u044F \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E \u0434\u0432\u0430\u0434\u0446\u0430\u0442\u0438 \u0434\u0432\u0443\u0445 (22) \u0440\u043E\u0441\u043A\u043E\u0448\u043D\u044B\u0445 \u0432\u0438\u043B\u043B \u0441 \u0431\u0430\u0441\u0441\u0435\u0439\u043D\u0430\u043C\u0438, \u0432\u043A\u043B\u044E\u0447\u0430\u044E\u0449\u0438\u0445 \u0432 \u0441\u0435\u0431\u044F \u0434\u0432\u0435 \u0438\u043B\u0438 \u0442\u0440\u0438 \u0441\u043F\u0430\u043B\u044C\u043D\u0438.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u7B54.")," \u666E\u5409\u5C9B\u90FD\u559C\u4E50\u53E4\u6D6A\u5EA6\u5047\u6751\u8BA1\u5212\u6709\u4E8C\u5341\u4E8C\uFF0822\uFF09 \u95F4\u8C6A\u534E\u4E24\u5367\u5BA4\u548C\u4E09\u5367\u5BA4\u6CF3\u6C60\u522B\u5885\u3002"))}},{categoryId:2,question:"How long does construction take?",displayOn:["en","ru","cn"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"A.")," Construction can only commence once the relevant government approvals are obtained and is estimated to take approximately 18-24 months to complete from the commencement date.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"O.")," \u0412 \u0440\u0430\u043C\u043A\u0430\u0445 \u043F\u0440\u043E\u0435\u043A\u0442\u0430 Dusit Laguna Resort Phuket \u043F\u043B\u0430\u043D\u0438\u0440\u0443\u0435\u0442\u0441\u044F \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E \u0434\u0432\u0430\u0434\u0446\u0430\u0442\u0438 \u0434\u0432\u0443\u0445 (22) \u0440\u043E\u0441\u043A\u043E\u0448\u043D\u044B\u0445 \u0432\u0438\u043B\u043B \u0441 \u0431\u0430\u0441\u0441\u0435\u0439\u043D\u0430\u043C\u0438, \u0432\u043A\u043B\u044E\u0447\u0430\u044E\u0449\u0438\u0445 \u0432 \u0441\u0435\u0431\u044F \u0434\u0432\u0435 \u0438\u043B\u0438 \u0442\u0440\u0438 \u0441\u043F\u0430\u043B\u044C\u043D\u0438.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u7B54.")," ","\u53EA\u6709\u5728\u83B7\u5F97\u6709\u5173\u653F\u5E9C\u6279\u51C6\u540E\u624D\u80FD\u5F00\u59CB\u65BD\u5DE5\uFF0C\u4F30\u8BA1\u4ECE\u65BD\u5DE5\u65E5\u671F\u8D77\u5927\u7EA6\u9700\u8981 18 \u81F3 24 \u4E2A\u6708\u624D\u80FD\u5B8C\u6210\u3002"))}},{categoryId:2,question:"What is the warranty period offered?",displayOn:["en","ru","cn"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"A.")," A one year warranty is offered on the building and equipment from the date of handover and completion of construction.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"O.")," \u041F\u0440\u0435\u0434\u043B\u0430\u0433\u0430\u0435\u0442\u0441\u044F \u0433\u0430\u0440\u0430\u043D\u0442\u0438\u044F \u043D\u0430 \u0437\u0434\u0430\u043D\u0438\u044F \u0438 \u043E\u0431\u043E\u0440\u0443\u0434\u043E\u0432\u0430\u043D\u0438\u0435 \u0441\u0440\u043E\u043A\u043E\u043C \u043D\u0430 \u043E\u0434\u0438\u043D \u0433\u043E\u0434 \u0441 \u043C\u043E\u043C\u0435\u043D\u0442\u0430 \u0441\u0434\u0430\u0447\u0438 \u043F\u0440\u043E\u0435\u043A\u0442\u0430 \u0438 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u044F \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u7B54.")," ","\u4ECE\u79FB\u4EA4\u548C\u65BD\u5DE5\u5B8C\u6210\u4E4B\u65E5\u8D77\uFF0C\u5BF9\u5EFA\u7B51\u7269\u548C\u8BBE\u5907\u63D0\u4F9B\u4E3A\u671F\u4E00\u5E74\u7684\u4FDD\u4FEE\u3002"))}},{categoryId:2,question:"What is included in the property?",displayOn:["en","ru","cn"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"A.")," Fixed furnishings (wardrobes, kitchen cabinets and built-in appliances) and loose furniture (including amenities and artworks) is included.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"O.")," \u0412\u0441\u0442\u0440\u043E\u0435\u043D\u043D\u0430\u044F \u043C\u0435\u0431\u0435\u043B\u044C (\u0448\u043A\u0430\u0444\u044B, \u043A\u0443\u0445\u043E\u043D\u043D\u0430\u044F \u043C\u0435\u0431\u0435\u043B\u044C \u0438 \u0432\u0441\u0442\u0440\u0430\u0438\u0432\u0430\u0435\u043C\u0430\u044F \u0442\u0435\u0445\u043D\u0438\u043A\u0430) \u0438 \u0434\u0432\u0438\u0436\u0438\u043C\u0430\u044F \u043C\u0435\u0431\u0435\u043B\u044C (\u0432 \u0442\u043E\u043C \u0447\u0438\u0441\u043B\u0435 \u0443\u0434\u043E\u0431\u0441\u0442\u0432\u0430 \u0438 \u0434\u0435\u043A\u043E\u0440).")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u7B54.")," ","\u56FA\u5B9A\u5BB6\u5177\uFF08\u8863\u67DC\uFF0C\u6A71\u67DC\u548C\u5185\u5D4C\u7535\u5668\uFF09\u548C\u6D3B\u52A8\u5BB6\u5177\uFF08\u542B\u8BBE\u65BD\u8BBE\u5907\u548C\u827A\u672F\u54C1\uFF09\u5305\u62EC\u5728\u5185\u3002"))}},{categoryId:2,question:"Is customization of the units allowed?",displayOn:["en","ru","cn"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"A.")," As the villas will be managed as part of the resort, a standard configuration and furniture and amenities package is required.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"O.")," \u0423\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0432\u0438\u043B\u043B\u0430\u043C\u0438 \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u0432 \u0440\u0430\u043C\u043A\u0430\u0445 \u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u044F \u043A\u0443\u0440\u043E\u0440\u0442\u043E\u043C, \u0442. \u0435. \u0442\u0440\u0435\u0431\u0443\u0435\u0442\u0441\u044F \u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u044B\u0439 \u043D\u0430\u0431\u043E\u0440 \u043C\u0435\u0431\u0435\u043B\u0438 \u0438 \u0443\u0434\u043E\u0431\u0441\u0442\u0432.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u7B54.")," ","\u7531\u4E8E\u522B\u5885\u5C06\u4F5C\u4E3A\u5EA6\u5047\u6751\u7684\u4E00\u90E8\u5206\u8FDB\u884C\u7BA1\u7406\uFF0C\u56E0\u6B64\u9700\u8981\u91C7\u7528\u6807\u51C6\u914D\u7F6E\u4EE5\u53CA\u5BB6\u5177\u548C\u8BBE\u65BD\u5957\u88C5\u3002"))}},{categoryId:3,question:"Is there a rental program available?",displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"A."),"Yes, these luxury villas will be professionally and exclusively managed by Dusit Laguna Phuket offering a unique investment opportunity."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"In addition, owners shall be entitled to 60 days complimentary use of their villa (room only, does not include breakfast or personal expenses) per year (terms and conditions apply).")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"O."),"\u0414\u0430, \u043F\u0440\u043E\u0444\u0435\u0441\u0441\u0438\u043E\u043D\u0430\u043B\u044C\u043D\u043E\u0435 \u044D\u043A\u0441\u043A\u043B\u044E\u0437\u0438\u0432\u043D\u043E\u0435 \u0443\u043F\u0440\u0430\u0432\u043B\u0435\u043D\u0438\u0435 \u0431\u0443\u0434\u0435\u0442 \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0442\u044C\u0441\u044F \u043E\u0442\u0435\u043B\u0435\u043C Dusit Laguna Phuket, \u0447\u0442\u043E \u043F\u0440\u0435\u0434\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 \u0441\u043E\u0431\u043E\u0439 \u0443\u043D\u0438\u043A\u0430\u043B\u044C\u043D\u0443\u044E \u0438\u043D\u0432\u0435\u0441\u0442\u0438\u0446\u0438\u043E\u043D\u043D\u0443\u044E \u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E\u0441\u0442\u044C."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0411\u043E\u043B\u0435\u0435 \u0442\u043E\u0433\u043E, \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u044B \u043F\u043E\u043B\u0443\u0447\u0430\u044E\u0442 \u043F\u0440\u0430\u0432\u043E \u043D\u0430 60 \u0434\u043D\u0435\u0439 \u043F\u0440\u043E\u0436\u0438\u0432\u0430\u043D\u0438\u044F (\u0442\u043E\u043B\u044C\u043A\u043E \u043F\u0440\u043E\u0436\u0438\u0432\u0430\u043D\u0438\u0435, \u0437\u0430\u0432\u0442\u0440\u0430\u043A \u0438\u043B\u0438 \u043B\u0438\u0447\u043D\u044B\u0435 \u0440\u0430\u0441\u0445\u043E\u0434\u044B \u043D\u0435 \u043F\u0440\u0435\u0434\u0443\u0441\u043C\u0430\u0442\u0440\u0438\u0432\u0430\u044E\u0442\u0441\u044F) \u043D\u0430 \u0441\u0432\u043E\u0435\u0439 \u0432\u0438\u043B\u043B\u0435 \u0435\u0436\u0435\u0433\u043E\u0434\u043D\u043E (\u0441\u043E\u0433\u043B\u0430\u0441\u043D\u043E \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u043C \u0443\u0441\u043B\u043E\u0432\u0438\u044F\u043C).")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u7B54.")," \u662F\u7684\uFF0C\u8FD9\u4E9B\u8C6A\u534E\u522B\u5885\u5C06\u7531\u666E\u5409\u5C9B\u4E50\u53E4\u6D6A\u90FD\u559C\u9152\u5E97\u7684\u4E13\u4E1A\u4EBA\u58EB\u72EC\u5BB6\u7BA1\u7406\uFF0C\u4E3A\u60A8\u63D0\u4F9B\u72EC\u7279\u7684\u6295\u8D44\u673A\u4F1A\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u6B64\u5916\uFF0C\u4E1A\u4E3B\u4EAB\u6709\u6743\u5229\u53EF\u6BCF\u5E7460 \u5929\u514D\u8D39\u4F7F\u7528\u6240\u8D2D\u522B\u5885\uFF08\u4EC5\u9650\u4F4F\u5BBF\uFF0C\u4E0D\u5305\u62EC\u65E9\u9910\u6216\u4E2A\u4EBA\u6D88\u8D39\uFF09\uFF08\u53D7\u6761\u6B3E\u548C\u6761\u4EF6\u7EA6\u675F\uFF09\u3002"))}},{categoryId:3,question:"How does the rental program work?",displayOn:["en","ru","cn"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"A.")," The rental returns paid to owners will be calculated based upon a 33% share of net room revenue (the balance being retained by to cover operating expenses of the rental program). In addition, a reserve fund (3% of room revenue) will be deducted and held for future refurbishment costs. An example of how the return returns are determined is set out below:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"Day Available"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"365"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"Days Sold"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"250")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"Occupancy %"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"68%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"Average Daily Rate (Baht)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"20,000")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"Net Room Revenue (Baht)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5,000,000")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"Revenue Share to Owner @ 33% (Baht)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,650,000")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"Less Reserve Fund Contribution @ 3% of Revenue"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"(150,000)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"Revenue Share to Owner \u2013 Before Withholding Tax"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,500,000")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"Note: The operation of the rental program is at the discretion of the manager and may be subject to change. The above example is indicative only of how the rental returns will be determined and may not reflect the actual returns achieved."))),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"O.")," \u0414\u043E\u0445\u043E\u0434 \u0441 \u0430\u0440\u0435\u043D\u0434\u044B, \u043F\u043E\u043B\u0443\u0447\u0430\u0435\u043C\u044B\u0439 \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u0438\u043A\u043E\u043C, \u0441\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 33% \u043E\u0442 \u0447\u0438\u0441\u0442\u043E\u0433\u043E \u0434\u043E\u0445\u043E\u0434\u0430 \u0441 \u0430\u0440\u0435\u043D\u0434\u044B \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u0438 (\u043E\u0441\u0442\u0430\u0442\u043E\u043A \u043F\u0440\u0438\u0447\u0438\u0442\u0430\u0435\u0442\u0441\u044F \u0443\u043F\u0440\u0430\u0432\u043B\u044F\u044E\u0449\u0435\u0439 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438 \u0434\u043B\u044F \u043F\u043E\u043A\u0440\u044B\u0442\u0438\u044F \u044D\u043A\u0441\u043F\u043B\u0443\u0430\u0442\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0445 \u0440\u0430\u0441\u0445\u043E\u0434\u043E\u0432, \u0441\u043E\u043F\u0440\u044F\u0436\u0435\u043D\u043D\u044B\u0445 \u0441 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u043E\u0439 \u0441\u0434\u0430\u0447\u0438 \u0432 \u0430\u0440\u0435\u043D\u0434\u0443). \u041A\u0440\u043E\u043C\u0435 \u0442\u043E\u0433\u043E, \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u044B\u0439 \u0444\u043E\u043D\u0434 (3 % \u043E\u0442 \u043E\u0431\u0449\u0435\u0433\u043E \u0434\u043E\u0445\u043E\u0434\u0430) \u0431\u0443\u0434\u0435\u0442 \u0432\u044B\u0447\u0438\u0442\u0430\u0442\u044C\u0441\u044F \u0432 \u0441\u0447\u0435\u0442 \u0431\u0443\u0434\u0443\u0449\u0438\u0445 \u0440\u0435\u043C\u043E\u043D\u0442\u043D\u044B\u0445 \u0440\u0430\u0431\u043E\u0442."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041F\u0440\u0438\u043C\u0435\u0440 \u0440\u0430\u0441\u0447\u0435\u0442\u0430 \u0434\u043E\u0445\u043E\u0434\u043E\u0432 \u043F\u0440\u0438\u0432\u0435\u0434\u0435\u043D \u043D\u0438\u0436\u0435:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u0414\u043E\u0441\u0442\u0443\u043F\u043D\u043E \u0434\u043D\u0435\u0439"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"365"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u041F\u0440\u043E\u0434\u0430\u043D\u043E \u0434\u043D\u0435\u0439"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"250")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u041F\u0440\u043E\u0434\u0430\u043D\u043E \u0434\u043D\u0435\u0439"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"68%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u0421\u0440\u0435\u0434\u043D\u044F\u044F \u0441\u0442\u043E\u0438\u043C\u043E\u0441\u0442\u044C \u0432 \u0441\u0443\u0442\u043A\u0438 (\u0431\u0430\u0442\u044B)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"20,000")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u0427\u0438\u0441\u0442\u044B\u0439 \u0434\u043E\u0445\u043E\u0434 \u0441 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u0438 (\u0431\u0430\u0442\u044B)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5,000,000")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u0414\u043E\u043B\u044F \u0434\u043E\u0445\u043E\u0434\u0430, \u043F\u043E\u043B\u0443\u0447\u0430\u0435\u043C\u0430\u044F \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0435\u043C @ 33% (\u0431\u0430\u0442\u044B)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,650,000")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u041E\u0442\u0447\u0438\u0441\u043B\u0435\u043D\u0438\u044F \u0432 \u0440\u0435\u0437\u0435\u0440\u0432\u043D\u044B\u0439 \u0444\u043E\u043D\u0434 @ 3% \u0441 \u0434\u043E\u0445\u043E\u0434\u0430"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"(150,000)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u0414\u043E\u043B\u044F \u0434\u043E\u0445\u043E\u0434\u0430, \u043F\u043E\u043B\u0443\u0447\u0430\u0435\u043C\u0430\u044F \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0435\u043C \u2013 \u0434\u043E \u0443\u043F\u043B\u0430\u0442\u044B \u043D\u0430\u043B\u043E\u0433\u043E\u0432 (\u0434\u043E \u0432\u044B\u0447\u0435\u0442\u0430 \u043D\u0430\u043B\u043E\u0433\u043E\u0432)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,500,000")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"\u041F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0435: \u041F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0430 \u0430\u0440\u0435\u043D\u0434\u044B \u0440\u0435\u0430\u043B\u0438\u0437\u0443\u0435\u0442\u0441\u044F \u043F\u043E \u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u0438\u044E \u0443\u043F\u0440\u0430\u0432\u043B\u044F\u044E\u0449\u0435\u0439 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438 \u0438 \u043C\u043E\u0436\u0435\u0442 \u043F\u043E\u0434\u0432\u0435\u0440\u0433\u0430\u0442\u044C\u0441\u044F \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F\u043C. \u041F\u0440\u0438\u043C\u0435\u0440 \u0432\u044B\u0448\u0435 \u043F\u0440\u0438\u0432\u0435\u0434\u0435\u043D \u0432 \u0438\u043B\u043B\u044E\u0441\u0442\u0440\u0430\u0442\u0438\u0432\u043D\u044B\u0445 \u0446\u0435\u043B\u044F\u0445 \u0434\u043B\u044F \u0434\u0435\u043C\u043E\u043D\u0441\u0442\u0440\u0430\u0446\u0438\u0438 \u0442\u043E\u0433\u043E, \u043A\u0430\u043A \u0440\u0430\u0441\u0441\u0447\u0438\u0442\u044B\u0432\u0430\u044E\u0442\u0441\u044F \u0434\u043E\u0445\u043E\u0434\u044B \u043E\u0442 \u0441\u0434\u0430\u0447\u0438 \u0432 \u0430\u0440\u0435\u043D\u0434\u0443, \u0438 \u043C\u043E\u0436\u0435\u0442 \u043D\u0435 \u043E\u0442\u0440\u0430\u0436\u0430\u0442\u044C \u0440\u0435\u0430\u043B\u044C\u043D\u0443\u044E \u043F\u0440\u0438\u0431\u044B\u043B\u044C"))),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u7B54.")," ","\u79DF\u8D41\u56DE\u62A5\u4E3A\u623F\u95F4\u51C0\u6536\u76CA33%\uFF08\u5176\u4F59\u6536\u5165\u5C06\u88AB\u4FDD\u7559\u7528\u4E8E\u79DF\u8D41\u8BA1\u5212\u7684\u8FD0\u8425\u8D39\u7528\uFF09\u3002\u6B64\u5916\uFF0C\u5C06\u6263\u9664\u9884\u7559\u8D44\u91D1\uFF08\u5360\u623F\u95F4\u6536\u5165\u76843%\uFF09\uFF0C\u4EE5\u652F\u4ED8\u672A\u6765\u7684\u7FFB\u65B0\u8D39\u7528"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u4EE5\u4E0B\u662F\u5982\u4F55\u786E\u5B9A\u6536\u76CA\u56DE\u62A5\u7684\u793A\u4F8B\uFF1A "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u53EF\u7528\u5929\u6570"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"365"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u552E\u51FA\u5929\u6570"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"250")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u5165\u4F4F\u7387%"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"68%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u5E73\u5747\u6BCF\u65E5\u623F\u4EF7\uFF08\u6CF0\u94E2\uFF09"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"20,000")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u623F\u95F4\u51C0\u6536\u5165\uFF08\u6CF0\u94E2\uFF09"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5,000,000")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u4E1A\u4E3B\u6240\u5F97\u6536\u76CA\u4EFD\u989D@ 33% (\u6CF0\u94E2)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,650,000")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u51CF\u53BB\u9884\u7559\u8D44\u91D1@ \u6536\u5165\u76843%"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"(150,000)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u4E1A\u4E3B\u6240\u5F97\u6536\u76CA\u4EFD\u989D\u2014\u9884\u6263\u7A0E\u524D"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,500,000")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"\u6CE8\u610F\uFF1A\u79DF\u8D41\u8BA1\u5212\u7684\u8FD0\u4F5C\u7531\u7BA1\u7406\u65B9\u81EA\u884C\u51B3\u5B9A\uFF0C\u5E76\u53EF\u80FD\u6709\u6240\u53D8\u66F4\u3002\u4EE5\u4E0A\u4F8B\u5B50\u4EC5\u8BF4\u660E\u5982\u4F55\u786E\u5B9A\u79DF\u91D1\u56DE\u62A5\uFF0C\u5E76\u4E0D\u4EE3\u8868\u5B9E\u9645\u83B7\u5F97\u7684\u56DE\u62A5"," ")))}},{categoryId:3,question:"How is my rental return paid?",displayOn:["en","ru","cn"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"A.")," Owners will be paid rental returns direct to their nominated bank on a quarterly basis.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"O.")," \u0412\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u044B \u0431\u0443\u0434\u0443\u0442 \u043F\u043E\u043B\u0443\u0447\u0430\u0442\u044C \u0434\u043E\u0445\u043E\u0434\u044B \u043E\u0442 \u0441\u0434\u0430\u0447\u0438 \u0432 \u0430\u0440\u0435\u043D\u0434\u0443 \u043F\u043E\u0441\u0440\u0435\u0434\u0441\u0442\u0432\u043E\u043C \u0435\u0436\u0435\u043A\u0432\u0430\u0440\u0442\u0430\u043B\u044C\u043D\u043E\u0433\u043E \u043F\u0440\u044F\u043C\u043E\u0433\u043E \u043F\u0435\u0440\u0435\u0447\u0438\u0441\u043B\u0435\u043D\u0438\u044F \u0434\u0435\u043D\u0435\u0436\u043D\u044B\u0445 \u0441\u0440\u0435\u0434\u0441\u0442\u0432 \u043D\u0430 \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0439 \u0438\u043C\u0438 \u0431\u0430\u043D\u043A\u043E\u0432\u0441\u043A\u0438\u0439 \u0441\u0447\u0435\u0442.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u7B54.")," \u79DF\u91D1\u56DE\u62A5\u5C06\u6309\u5B63\u5EA6\u76F4\u63A5\u8F6C\u8D26\u81F3\u4E1A\u4E3B\u6307\u5B9A\u7684\u94F6\u884C\u8D26\u6237\u3002"))}},{categoryId:3,question:"What are the taxes levied on the rental program that an owner will be subject to?",displayOn:["en","ru","cn"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"A.")," Rental distributions made to non-resident (foreign) owners are subject to 15% withholding tax. Rental earned by Thai tax residents are subject to 5% withholding tax."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"Note: applicable tax rates are current at the date of issue of this FAQ and may be subject to changes. The villa owner shall be responsible for any income and any other taxes, duties and fees of whatever nature which may be levied by relevant authorities on the villa in connection with the rental."))),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"O.")," \u0414\u043E\u0445\u043E\u0434 \u0441 \u0430\u0440\u0435\u043D\u0434\u044B, \u043F\u043E\u043B\u0443\u0447\u0430\u0435\u043C\u044B\u0439 \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u0438\u043A\u0430\u043C\u0438, \u043D\u0435 \u043F\u0440\u043E\u0436\u0438\u0432\u0430\u044E\u0449\u0438\u043C\u0438 \u0432 \u0441\u0442\u0440\u0430\u043D\u0435 \u043D\u0430 \u043F\u043E\u0441\u0442\u043E\u044F\u043D\u043D\u043E\u0439 \u043E\u0441\u043D\u043E\u0432\u0435 (\u0438\u043D\u043E\u0441\u0442\u0440\u0430\u043D\u043D\u044B\u0435 \u0433\u0440\u0430\u0436\u0434\u0430\u043D\u0435), \u043E\u0431\u043B\u0430\u0433\u0430\u0435\u0442\u0441\u044F \u043D\u0430\u043B\u043E\u0433\u043E\u043C \u0432 \u0440\u0430\u0437\u043C\u0435\u0440\u0435 15%. \u0414\u043E\u0445\u043E\u0434 \u0441 \u0430\u0440\u0435\u043D\u0434\u044B, \u043F\u043E\u043B\u0443\u0447\u0430\u0435\u043C\u044B\u0439 \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u0438\u043A\u0430\u043C\u0438, \u043F\u0440\u043E\u0436\u0438\u0432\u0430\u044E\u0449\u0438\u043C\u0438 \u0432 \u0441\u0442\u0440\u0430\u043D\u0435 \u043D\u0430 \u043F\u043E\u0441\u0442\u043E\u044F\u043D\u043D\u043E\u0439 \u043E\u0441\u043D\u043E\u0432\u0435, \u043E\u0431\u043B\u0430\u0433\u0430\u0435\u0442\u0441\u044F \u043D\u0430\u043B\u043E\u0433\u043E\u043C \u0432 \u0440\u0430\u0437\u043C\u0435\u0440\u0435 5%."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"\u041F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u0435: \u0443\u043A\u0430\u0437\u0430\u043D\u043D\u044B\u0435 \u043D\u0430\u043B\u043E\u0433\u043E\u0432\u044B\u0435 \u0441\u0442\u0430\u0432\u043A\u0438 \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0442 \u043D\u0430 \u043C\u043E\u043C\u0435\u043D\u0442 \u043F\u0443\u0431\u043B\u0438\u043A\u0430\u0446\u0438\u0438 \u0434\u0430\u043D\u043D\u043E\u0433\u043E \u0434\u043E\u043A\u0443\u043C\u0435\u043D\u0442\u0430 \u0438 \u043C\u043E\u0433\u0443\u0442 \u0431\u044B\u0442\u044C \u043F\u043E\u0434\u0432\u0435\u0440\u0436\u0435\u043D\u044B \u0438\u0437\u043C\u0435\u043D\u0435\u043D\u0438\u044F\u043C. \u0412\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u044B \u0432\u0438\u043B\u043B \u043D\u0435\u0441\u0443\u0442 \u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u044C \u0437\u0430 \u043F\u043E\u043B\u0443\u0447\u0430\u0435\u043C\u044B\u0435 \u0434\u043E\u0445\u043E\u0434\u044B \u0438 \u0443\u043F\u043B\u0430\u0442\u0443 \u0440\u0430\u0437\u043D\u043E\u043E\u0431\u0440\u0430\u0437\u043D\u044B\u0445 \u043D\u0430\u043B\u043E\u0433\u043E\u0432, \u043F\u043E\u0448\u043B\u0438\u043D \u0438 \u0441\u0431\u043E\u0440\u043E\u0432, \u043A\u043E\u0442\u043E\u0440\u044B\u0435 \u043C\u043E\u0433\u0443\u0442 \u0432\u0437\u0438\u043C\u0430\u0442\u044C\u0441\u044F \u0441\u043E\u043E\u0442\u0432\u0435\u0442\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u043C\u0438 \u0433\u043E\u0441\u0443\u0434\u0430\u0440\u0441\u0442\u0432\u0435\u043D\u043D\u044B\u043C\u0438 \u043E\u0440\u0433\u0430\u043D\u0430\u043C\u0438 \u0432 \u0441\u0432\u044F\u0437\u0438 \u0441\u043E \u0441\u0434\u0430\u0447\u0435\u0439 \u0441\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u043E\u0441\u0442\u0438 \u0432 \u0430\u0440\u0435\u043D\u0434\u0443."))),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u7B54.")," \u5411\u975E\u5C45\u6C11(\u5916\u7C4D) \u4E1A\u4E3B\u53D1\u653E\u79DF\u91D1\uFF0C\u9700\u7F34\u7EB315% \u7684\u9884\u6263\u7A0E\u3002\u6CF0\u56FD\u7EB3\u7A0E\u5C45\u6C11\u83B7\u5F97\u7684\u79DF\u91D1\u9700\u7F34\u7EB35% \u7684\u9884\u6263\u7A0E\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"\u6CE8\u610F\uFF1A\u6B64\u7A0E\u6536\u7387\u4EC5\u4EE5\u5E38\u89C1\u95EE\u9898\u89E3\u7B54\uFF08FAQ\uFF09\u53D1\u5E03\u65E5\u7684\u76F8\u5173\u6CF0\u56FD\u7A0E\u52A1\u6CD5\u4E3A\u6807\u51C6\uFF0C\u82E5\u66F4\u6539\u8BF7\u9075\u5FAA\u3002\u522B\u5885\u4E1A\u4E3B\u5E94\u8D1F\u8D23\u652F\u4ED8\u6709\u5173\u5F53\u5C40\u53EF\u80FD\u5BF9\u522B\u5885\u5F81\u6536\u7684\u4EFB\u4F55\u6240\u5F97\u7A0E\u548C\u4EFB\u4F55\u5176\u4ED6\u6027\u8D28\u7684\u7A0E\u6B3E\u3001\u5173\u7A0E\u548C\u8D39\u7528\u3002")))}},{categoryId:3,question:"Can I rent my villa out on my own?",displayOn:["en","ru","cn"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"A.")," No. All rentals must be conducted exclusively through the manager.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"O.")," \u041D\u0435\u0442. \u0421\u0434\u0430\u0447\u0430 \u0432 \u0430\u0440\u0435\u043D\u0434\u0443 \u043E\u0441\u0443\u0449\u0435\u0441\u0442\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u0438\u0441\u043A\u043B\u044E\u0447\u0438\u0442\u0435\u043B\u044C\u043D\u043E \u0447\u0435\u0440\u0435\u0437 \u0443\u043F\u0440\u0430\u0432\u043B\u044F\u044E\u0449\u0443\u044E \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u044E")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u7B54.")," \u4E0D\u53EF\u4EE5\u3002\u6240\u6709\u79DF\u8D41\u4E8B\u52A1\u5FC5\u987B\u7531\u7BA1\u7406\u65B9\u4E13\u95E8\u5904\u7406\u3002"))}},{categoryId:3,question:"Can I choose my own furniture?",displayOn:["en","ru","cn"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"A standard hotel furniture package will be required for all villas.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0414\u043B\u044F \u0432\u0441\u0435\u0445 \u0432\u0438\u043B\u043B \u0442\u0440\u0435\u0431\u0443\u0435\u0442\u0441\u044F \u0441\u0442\u0430\u043D\u0434\u0430\u0440\u0442\u043D\u044B\u0439 \u043A\u043E\u043C\u043F\u043B\u0435\u043A\u0442 \u043C\u0435\u0431\u0435\u043B\u0438.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u6211\u53EF\u4EE5\u9009\u62E9\u81EA\u5DF1\u7684\u5BB6\u5177\u5417\uFF1F"))}},{categoryId:3,question:"Can I stay at any time?",displayOn:["en","ru","cn"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"A.")," This is subject to the terms and conditions imposed under the rental option selected (eg blackout dates shall apply during peak demand periods where a guaranteed rental is payable). All reservations by owners for their stays are subject to availability.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"O.")," \u042D\u0442\u043E \u0437\u0430\u0432\u0438\u0441\u0438\u0442 \u043E\u0442 \u0443\u0441\u043B\u043E\u0432\u0438\u0439 \u0432\u044B\u0431\u0440\u0430\u043D\u043D\u043E\u0433\u043E \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0430 \u0430\u0440\u0435\u043D\u0434\u044B (\u043D\u0430\u043F\u0440\u0438\u043C\u0435\u0440, \u0432 \u0441\u043B\u0443\u0447\u0430\u0435 \u0432\u044B\u0431\u043E\u0440\u0430 \u0433\u0430\u0440\u0430\u043D\u0442\u0438\u0440\u043E\u0432\u0430\u043D\u043D\u043E\u0433\u043E \u0432\u043E\u0437\u0432\u0440\u0430\u0442\u0430 \u0434\u043E\u0445\u043E\u0434\u0430 \u0441 \u0430\u0440\u0435\u043D\u0434\u044B, \u043F\u0440\u0435\u0431\u044B\u0432\u0430\u043D\u0438\u0435 \u043C\u043E\u0436\u0435\u0442 \u0431\u044B\u0442\u044C \u043D\u0435\u0432\u043E\u0437\u043C\u043E\u0436\u043D\u043E \u0432 \u0442\u0435\u0447\u0435\u043D\u0438\u0435 \u043F\u0435\u0440\u0438\u043E\u0434\u043E\u0432 \u043F\u043E\u0432\u044B\u0448\u0435\u043D\u043D\u043E\u0433\u043E \u0441\u043F\u0440\u043E\u0441\u0430). \u0411\u0440\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0435 \u0432\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0430\u043C\u0438 \u0437\u0430\u0432\u0438\u0441\u0438\u0442 \u043E\u0442 \u043D\u0430\u043B\u0438\u0447\u0438\u044F \u0441\u0432\u043E\u0431\u043E\u0434\u043D\u044B\u0445 \u0434\u0430\u0442.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u7B54.")," ","\u8FD9\u53D7\u6240\u9009\u79DF\u8D41\u65B9\u6848\u89C4\u5B9A\u7684\u6761\u6B3E\u548C\u6761\u4EF6\u7684\u7EA6\u675F\uFF08\u4F8B\u5982\uFF0C\u5728\u652F\u4ED8\u56FA\u5B9A\u79DF\u91D1\u671F\u95F4\u7684\u9AD8\u5CF0\u671F\uFF0C\u53EF\u80FD\u6709\u4E0D\u63A5\u53D7\u5165\u4F4F\u7684\u65E5\u671F\uFF09\u3002\u6240\u6709\u4E1A\u4E3B\u9884\u8BA2\u5747\u9700\u89C6\u9152\u5E97\u5BA2\u623F\u7387\u60C5\u51B5\u800C\u5B9A\u3002"))}},{categoryId:3,question:"How much advance notice is required for my stay?",displayOn:["en","ru","cn"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"A.")," Owners should provide as much notice as possible as villas may be pre-booked with third party guests, particularly for stays during high season periods.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"O.")," \u0412\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u0430\u043C \u043D\u0435\u043E\u0431\u0445\u043E\u0434\u0438\u043C\u043E \u0441\u043E\u043E\u0431\u0449\u0430\u0442\u044C \u043E \u0441\u0432\u043E\u0435\u043C \u043F\u0440\u0435\u0431\u044B\u0432\u0430\u043D\u0438\u0438 \u043A\u0430\u043A \u043C\u043E\u0436\u043D\u043E \u0440\u0430\u043D\u044C\u0448\u0435, \u0442\u0430\u043A \u043A\u0430\u043A \u0430\u043F\u0430\u0440\u0442\u0430\u043C\u0435\u043D\u0442\u044B \u043C\u043E\u0433\u0443\u0442 \u0431\u044B\u0442\u044C \u0437\u0430\u0431\u0440\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u044B \u0434\u0440\u0443\u0433\u0438\u043C\u0438 \u0433\u043E\u0441\u0442\u044F\u043C\u0438, \u043E\u0441\u043E\u0431\u0435\u043D\u043D\u043E \u0432 \u0432\u044B\u0441\u043E\u043A\u0438\u0439 \u0441\u0435\u0437\u043E\u043D.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u7B54.")," ","\u4E1A\u4E3B\u5E94\u5C3D\u65E9\u53D1\u51FA\u901A\u77E5\uFF0C\u56E0\u4E3A\u7B2C\u4E09\u65B9\u5BA2\u6237\u53EF\u80FD\u4F1A\u63D0\u524D\u9884\u8BA2\u5165\u4F4F\u516C\u5BD3\uFF0C\u65FA\u5B63\u5C24\u5176\u5982\u6B64\u3002"))}},{categoryId:3,question:"Can my friends use my owner’s entitlement?",displayOn:["en","cn"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"A.")," Yes, subject to terms and conditions of the rental agreement (e.g. owners\u2019 guests may be required to be pre-registered with the manager).")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u7B54.")," ","\u662F\u7684\uFF0C\u53D7\u79DF\u8D41\u534F\u8BAE\u7684\u6761\u6B3E\u548C\u6761\u4EF6\u7EA6\u675F\uFF08\u4F8B\u5982\uFF0C\u4E1A\u4E3B\u7684\u5BA2\u4EBA\u53EF\u80FD\u9700\u8981\u5728\u7BA1\u7406\u65B9\u9884\u5148\u767B\u8BB0\uFF09\u3002"))}},{categoryId:3,question:"What utilities do I have to pay?",displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"These costs will be covered by the revenue share retained by the manager.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u042D\u0442\u0438 \u0440\u0430\u0441\u0445\u043E\u0434\u044B \u0431\u0443\u0434\u0443\u0442 \u043F\u043E\u043A\u0440\u044B\u0432\u0430\u0442\u044C\u0441\u044F \u0437\u0430 \u0441\u0447\u0435\u0442 \u0434\u043E\u043B\u0438 \u0434\u043E\u0445\u043E\u0434\u043E\u0432, \u043F\u0440\u0438\u0447\u0438\u0442\u0430\u044E\u0449\u0435\u0439\u0441\u044F \u0443\u043F\u0440\u0430\u0432\u043B\u044F\u044E\u0449\u0435\u0439 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0438.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u8FD9\u4E9B\u8D39\u7528\u5C06\u7531\u7BA1\u7406\u65B9\u7559\u5B58\u7684\u6536\u5165\u4EFD\u989D\u652F\u4ED8\u3002"))}},{categoryId:4,question:"What types of property management services are offered and what is the approximate cost?",displayOn:["en","ru","cn"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"A.")," Dusit Laguna Phuket will provide a full range of services (including housekeeping, pool cleaning, pest control, routine and preventative maintenance, etc) and these are included as part of the rental program.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"O.")," Dusit Laguna Phuket \u043F\u0440\u0435\u0434\u043E\u0441\u0442\u0430\u0432\u043B\u044F\u0435\u0442 \u043F\u043E\u043B\u043D\u044B\u0439 \u0441\u043F\u0435\u043A\u0442\u0440 \u0443\u0441\u043B\u0443\u0433 (\u0432 \u0442\u043E\u043C \u0447\u0438\u0441\u043B\u0435 \u0443\u0431\u043E\u0440\u043A\u0443 \u0432\u0438\u043B\u043B, \u0447\u0438\u0441\u0442\u043A\u0443 \u0431\u0430\u0441\u0441\u0435\u0439\u043D\u0430, \u0443\u043D\u0438\u0447\u0442\u043E\u0436\u0435\u043D\u0438\u0435 \u0432\u0440\u0435\u0434\u0438\u0442\u0435\u043B\u0435\u0439, \u043F\u043B\u0430\u043D\u043E\u0432\u044B\u0435 \u0438 \u043F\u0440\u043E\u0444\u0438\u043B\u0430\u043A\u0442\u0438\u0447\u0435\u0441\u043A\u0438\u0435 \u0440\u0430\u0431\u043E\u0442\u044B \u0438 \u0442. \u0434.). \u042D\u0442\u043E \u044F\u0432\u043B\u044F\u0435\u0442\u0441\u044F \u0447\u0430\u0441\u0442\u044C\u044E \u0430\u0440\u0435\u043D\u0434\u043D\u043E\u0439 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u044B.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u7B54.")," ","\u666E\u5409\u5C9B\u4E50\u53E4\u6D6A\u90FD\u559C\u9152\u5E97\u63D0\u4F9B\u5168\u65B9\u4F4D\u7684\u670D\u52A1\uFF08\u5305\u62EC\u5BB6\u653F\u670D\u52A1\u3001\u6CF3\u6C60\u6E05\u6D01\u3001\u866B\u5BB3\u9632\u6CBB\u3001\u65E5\u5E38\u7EF4\u62A4\u548C\u9884\u9632\u6027\u7EF4\u62A4\u7B49\uFF09\uFF0C\u8FD9\u4E9B\u90FD\u5305\u542B\u5728\u79DF\u8D41\u8BA1\u5212\u4E2D\u3002"," "))}},{categoryId:5,question:"What privileges will I receive as an owner of a Laguna Phuket property?",displayOn:["en","ru","cn"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Owners will receive membership to the exclusive \u2018Sanctuary Club\u2019 which entitles owners to discounts and privileges at Banyan Tree, Angsana, Cassia, Dhawa and Laguna resorts, spas and galleries worldwide including:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"30% discount on best available rates for hotel accommodation"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"25% discount on food and beverage"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"30% discount on golf green fees"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"20% discount on a-la-carte spa menu"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"15% discount on gallery merchandise"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"15% discount on in-house tours"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"15% discount on laundry"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"10% discount airport and ferry terminal transfers"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Priority wait-list on reservations"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"Early check-in / late check-out")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Owners participating in the rental program, deposit 15 days of the annual use entitlement to exchange for free stays at participating properties within the global network."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Terms and conditions apply.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0421\u043E\u0431\u0441\u0442\u0432\u0435\u043D\u043D\u0438\u043A\u0438 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u0438 \u0441\u0442\u0430\u043D\u043E\u0432\u044F\u0442\u0441\u044F \u0443\u0447\u0430\u0441\u0442\u043D\u0438\u043A\u0430\u043C\u0438 \u044D\u043A\u0441\u043A\u043B\u044E\u0437\u0438\u0432\u043D\u043E\u0433\u043E \u043A\u043B\u0443\u0431\u0430 Banyan Tree Sanctuary Club, \u0447\u0442\u043E \u0434\u0430\u0435\u0442 \u0438\u043C \u043F\u0440\u0430\u0432\u043E \u043D\u0430 \u0441\u043A\u0438\u0434\u043A\u0438 \u0438 \u043F\u0440\u0438\u0432\u0438\u043B\u0435\u0433\u0438\u0438 \u043D\u0430 \u0432\u0441\u0435\u0445 \u043A\u0443\u0440\u043E\u0440\u0442\u0430\u0445, \u0432 \u0441\u043F\u0430-\u0446\u0435\u043D\u0442\u0440\u0430\u0445 \u0438 \u0442\u043E\u0440\u0433\u043E\u0432\u044B\u0445 \u0433\u0430\u043B\u0435\u0440\u0435\u044F\u0445 Banyan Tree, Angsana, Cassia, Dhawa \u0438 Laguna \u043F\u043E \u0432\u0441\u0435\u043C\u0443 \u043C\u0438\u0440\u0443, \u0432 \u0442\u043E\u043C \u0447\u0438\u0441\u043B\u0435:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u0421\u043A\u0438\u0434\u043A\u0430 30 % \u043D\u0430 \u0441\u0430\u043C\u044B\u0435 \u043D\u0438\u0437\u043A\u0438\u0435 \u0434\u043E\u0441\u0442\u0443\u043F\u043D\u044B\u0435 \u0446\u0435\u043D\u044B \u043D\u0430 \u043F\u0440\u043E\u0436\u0438\u0432\u0430\u043D\u0438\u0435 \u0432 \u043E\u0442\u0435\u043B\u044F\u0445"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u0421\u043A\u0438\u0434\u043A\u0430 25 % \u043D\u0430 \u0435\u0434\u0443 \u0438 \u043D\u0430\u043F\u0438\u0442\u043A\u0438"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u0421\u043A\u0438\u0434\u043A\u0430 30 % \u043D\u0430 \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u043D\u0438\u0435 \u043F\u043E\u043B\u0435\u043C \u0434\u043B\u044F \u0433\u043E\u043B\u044C\u0444\u0430"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u0421\u043A\u0438\u0434\u043A\u0430 20 % \u043D\u0430 \u0441\u043F\u0430-\u043F\u0440\u043E\u0446\u0435\u0434\u0443\u0440\u044B"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u0421\u043A\u0438\u0434\u043A\u0430 15 % \u043D\u0430 \u043F\u043E\u043A\u0443\u043F\u043A\u0438 \u0432 \u0442\u043E\u0440\u0433\u043E\u0432\u044B\u0445 \u0433\u0430\u043B\u0435\u0440\u0435\u044F\u0445"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u0421\u043A\u0438\u0434\u043A\u0430 15 % \u043D\u0430 \u043E\u0440\u0433\u0430\u043D\u0438\u0437\u0443\u0435\u043C\u044B\u0435 \u043A\u043E\u043C\u043F\u0430\u043D\u0438\u0435\u0439 \u044D\u043A\u0441\u043A\u0443\u0440\u0441\u0438\u0439"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u0421\u043A\u0438\u0434\u043A\u0430 15 % \u043D\u0430 \u0443\u0441\u043B\u0443\u0433\u0438 \u043F\u0440\u0430\u0447\u0435\u0447\u043D\u043E\u0439"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u0421\u043A\u0438\u0434\u043A\u0430 10 % \u043D\u0430 \u0442\u0440\u0430\u043D\u0441\u0444\u0435\u0440 \u043E\u0442/\u0434\u043E \u0430\u044D\u0440\u043E\u043F\u043E\u0440\u0442\u0430 \u0438 \u043F\u0430\u0440\u043E\u043C\u043D\u043E\u0433\u043E \u0442\u0435\u0440\u043C\u0438\u043D\u0430\u043B\u0430"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u041F\u0440\u0438\u043E\u0440\u0438\u0442\u0435\u0442 \u0432 \u0441\u043F\u0438\u0441\u043A\u0435 \u043E\u0436\u0438\u0434\u0430\u043D\u0438\u044F \u043F\u0440\u0438 \u0431\u0440\u043E\u043D\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u0438"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u0420\u0430\u043D\u043D\u0438\u0439 \u0437\u0430\u0435\u0437\u0434/\u043F\u043E\u0437\u0434\u043D\u0438\u0439 \u0432\u044B\u0435\u0437\u0434")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u0412\u043B\u0430\u0434\u0435\u043B\u044C\u0446\u044B, \u0443\u0447\u0430\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0435 \u0432 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0435 \u0441\u0434\u0430\u0447\u0438 \u0432 \u0430\u0440\u0435\u043D\u0434\u0443, \u043C\u043E\u0433\u0443\u0442 \u043E\u0431\u043C\u0435\u043D\u044F\u0442\u044C 15 \u0434\u043D\u0435\u0439 \u0441\u0432\u043E\u0435\u0433\u043E \u0435\u0436\u0435\u0433\u043E\u0434\u043D\u043E\u0433\u043E \u043F\u0440\u043E\u0436\u0438\u0432\u0430\u043D\u0438\u044F \u043D\u0430 \u0431\u0435\u0441\u043F\u043B\u0430\u0442\u043D\u043E\u0435 \u043F\u0440\u043E\u0436\u0438\u0432\u0430\u043D\u0438\u0435 \u043D\u0430 \u043A\u0443\u0440\u043E\u0440\u0442\u0430\u0445 \u0433\u043B\u043E\u0431\u0430\u043B\u044C\u043D\u043E\u0439 \u0441\u0435\u0442\u0438, \u0443\u0447\u0430\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0445 \u0432 \u043F\u0440\u043E\u0433\u0440\u0430\u043C\u043C\u0435."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041F\u0440\u0438\u043C\u0435\u043D\u044F\u044E\u0442\u0441\u044F \u0434\u0435\u0439\u0441\u0442\u0432\u0443\u044E\u0449\u0438\u0435 \u0443\u0441\u043B\u043E\u0432\u0438\u044F.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u7B54. \u4E1A\u4E3B\u5C06\u83B7\u5F97\u72EC\u5BB6\u7684\u201C\u6995\u6E90\u4F1A\u201D \u4F1A\u5458\u8D44\u683C\uFF0C\u8BE5\u4FF1\u4E50\u90E8\u5141\u8BB8\u4E1A\u4E3B\u5728\u5168\u7403\u5404\u5730\u7684\u60A6\u6995\u5E84\u3001\u60A6\u693F\u3001\u60A6\u68BF\u3001\u60A6\u82D1\u53CA\u4E50\u53E4\u6D6A\u5EA6\u5047\u6751\u54C1\u724C\u65D7\u4E0B\u7684\u5EA6\u5047\u6751\u3001\u6C34\u7597\u4E2D\u5FC3\u548C\u827A\u54C1\u9601\u4EAB\u53D7\u7279\u6743\u548C\u6298\u6263\uFF0C\u5176\u4E2D\u5305\u62EC\uFF1A"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u9152\u5E97\u4F4F\u5BBF\u6700\u4F18\u4EF7\u683C7\u6298"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u9910\u996E7.5\u6298"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u9AD8\u5C14\u592B\u573A\u5730\u8D397\u6298"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u6C34\u7597\u4E2D\u5FC3\u6309\u6469\u65B9\u5F0F\u968F\u5FC3\u90098\u6298"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u96F6\u552E\u827A\u54C1\u5E97\u5546\u54C18.5\u6298"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u9152\u5E97\u63D0\u4F9B\u65C5\u884C8.5\u6298"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u6D17\u8863\u670D\u52A18.5\u6298"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u673A\u573A\u53CA\u6E21\u8239\u7801\u5934\u63A5\u90019\u6298"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u4F18\u5148\u9884\u8BA2"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"\u63D0\u65E9\u5165\u4F4F/\u5EF6\u8FDF\u9000\u623F")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u53C2\u4E0E\u79DF\u8D41\u8BA1\u5212\u7684\u4E1A\u4E3B\uFF0C\u53EF\u4EE5\u7528\u81EA\u5DF1\u540D\u4E0B\u623F\u4EA7\u6BCF\u5E74\u514D\u8D39\u4F7F\u7528\u5929\u6570\u4E2D\u768415 \u5929\uFF0C\u4EA4\u6362\u60A6\u6995\u5168\u7403\u7F51\u7EDC\u5185\u5176\u4ED6\u53C2\u4E0E\u7269\u4E1A\u7684\u514D\u8D39\u4F4F\u5BBF\u3002"," "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"\u53D7\u6761\u6B3E\u548C\u6761\u4EF6\u7EA6\u675F\u3002")))}},{categoryId:5,question:"Will the property come with a golf membership?",displayOn:["en","ru","cn"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"A regular golf membership is included with the property. This is transferrable upon resale of the property.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"A regular golf membership is included with the property. This is transferrable upon resale of the property.")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u7B54. \u4E1A\u4E3B\u53EF\u83B7\u5F97\u666E\u5409\u5C9B\u4E50\u53E4\u6D6A\u9AD8\u5C14\u592B\u4FF1\u4E50\u90E8\u7684\u666E\u901A\u9AD8\u5C14\u592B\u4F1A\u5458\u8D44\u683C\u3002\u4F1A\u7C4D\u4F1A\u968F\u7740\u623F\u4EA7\u7684\u8F6C\u8BA9\u800C\u8F6C\u8BA9"))}},{categoryId:7,question:"What are the terms of payment?",displayOn:["en","ru","cn"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"There are 2 options available:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Option 1: 100% Payment upon purchase / during construction"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"100% payment upon purchase for already completed properties. Progressive payments for properties under construction are as per the table below."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Construction Payment Term"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"th-col2"},"Of Selling Price"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"st")," Payment upon signing contact"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"nd")," Payment when construction is 25% complete",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"rd")," Payment when construction is 50% complete",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"th")," Payment when construction is 75% complete",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"3")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"th")," Payment upon completion of construction"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{textAlign:"center"}},"Total"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"100%")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Notes:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",{className:"notes"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Concrete structure substantially completed")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Roof, brickwork and rendering substantially completed")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Electrical conduits, and pipe work and plastering substantially completed"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Option 2: 50% payment upon purchase / during construction with 50% deferred payment over 1, 3 or 5 years"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"50% payment upon purchase for already completed properties. Progressive payments for properties under construction (50% during construction / 50% post construction) as per the table below."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Deferred Payment Plan"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"th-col2"},"Of Selling Price"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"st")," Payment upon signing contract"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"nd")," Payment when construction is 50% complete",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"10%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"rd")," Payment when construction is 75% complete",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"10%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"th")," Payment upon completion of construction",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"3")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"10%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"Post construction payments",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"4")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"50%")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"Financing Options"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"th-col2"},"Interest Rate",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"(per annum)"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1 Year (12 monthly installments)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"3%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3 Year (36 monthly installments)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"5%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5 Year (60 monthly installments)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"7%")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Notes:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",{className:"notes"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Concrete structure substantially completed")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Roof, brickwork and rendering substantially completed")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Electrical conduits and pipe work substantially completed")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"See table below"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"table-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"tr-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Price")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Reservation Deposit")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Construction Completion ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Payment 50% (Minus Deposit)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Remaining Post Finance 50%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:"3",className:"td-group-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Monthly Installment"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"tr-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"1 Year (3%)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"3 Year (5%)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"5 Year (7%)"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"45,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"22,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"22,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,905,608"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"674,345"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"445,527")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"50,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"24,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"25,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,117,342"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"749,272"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"495,030")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"55,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"27,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"27,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,329,077"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"824,200"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"544,533")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Notes:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",{className:"notes"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"All amounts are stated in Thai Baht (THB).")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"The above table sets out the estimated payments required under the respective payment plans for selling prices between THB 45,000,000 \u2013 55,000,000.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"The estimated payments are indicative only and the developer / seller does not accept any responsibility or liability whatsoever for any inaccuracies or omissions.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"Payment terms are subject to change without notice."))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{"class":"pull-right"},"Updated: 19 April 2019")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u041F\u0440\u0435\u0434\u0443\u0441\u043C\u043E\u0442\u0440\u0435\u043D\u043E 2 \u0432\u0430\u0440\u0438\u0430\u043D\u0442\u0430:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u0412\u0430\u0440\u0438\u0430\u043D\u0442 1: 100% \u043E\u043F\u043B\u0430\u0442\u0430 \u043F\u0440\u0438 \u043F\u043E\u043A\u0443\u043F\u043A\u0435/\u0432\u043E \u0432\u0440\u0435\u043C\u044F \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"100% \u043E\u043F\u043B\u0430\u0442\u0430 \u043F\u0440\u0438 \u043F\u043E\u043A\u0443\u043F\u043A\u0435 \u0443\u0436\u0435 \u0441\u0434\u0430\u043D\u043D\u043E\u0439 \u0432 \u044D\u043A\u0441\u043F\u043B\u0443\u0430\u0442\u0430\u0446\u0438\u044E \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u0438. \u041F\u0440\u043E\u0433\u0440\u0435\u0441\u0441\u0438\u0432\u043D\u044B\u0435 \u043F\u043B\u0430\u0442\u0435\u0436\u0438 \u0434\u043B\u044F \u0441\u0442\u0440\u043E\u044F\u0449\u0438\u0445\u0441\u044F \u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432, \u0441\u043E\u0433\u043B\u0430\u0441\u043D\u043E \u0442\u0430\u0431\u043B\u0438\u0446\u0435 \u043D\u0438\u0436\u0435."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"\u0421\u0440\u043E\u043A\u0438 \u043F\u043B\u0430\u0442\u0435\u0436\u0435\u0439 \u0432\u043E \u0432\u0440\u0435\u043C\u044F \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"th-col2"},"\u041E\u0442 \u0446\u0435\u043D\u044B \u043F\u0440\u043E\u0434\u0430\u0436\u0438"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1-\u044B\u0439 \u043F\u043B\u0430\u0442\u0435\u0436: \u043F\u0440\u0438 \u043F\u043E\u0434\u043F\u0438\u0441\u0430\u043D\u0438\u0438 \u043A\u043E\u043D\u0442\u0440\u0430\u043A\u0442\u0430"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2-\u043E\u0439 \u043F\u043B\u0430\u0442\u0435\u0436: \u043F\u0440\u0438 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0438 \u043F\u0440\u043E\u0435\u043A\u0442\u0430 \u0437\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u043D\u0430 25%",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3-\u0438\u0439 \u043F\u043B\u0430\u0442\u0435\u0436: \u043F\u0440\u0438 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0438 \u043F\u0440\u043E\u0435\u043A\u0442\u0430 \u0437\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u043D\u0430 50%",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4-\u044B\u0439 \u043F\u043B\u0430\u0442\u0435\u0436: \u043F\u0440\u0438 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0438 \u043F\u0440\u043E\u0435\u043A\u0442\u0430 \u0437\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u043D\u0430 75%",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"3")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5-\u044B\u0439 \u043F\u043B\u0430\u0442\u0435\u0436: \u043F\u043E \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u0438 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{textAlign:"center"}},"\u0412\u0441\u0435\u0433\u043E"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"100%")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u041F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u044F:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",{className:"notes"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u041F\u0440\u0430\u043A\u0442\u0438\u0447\u0435\u0441\u043A\u0438 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E \u0432\u043E\u0437\u0432\u0435\u0434\u0435\u043D\u0438\u0435 \u0431\u0435\u0442\u043E\u043D\u043D\u044B\u0445 \u043A\u043E\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0438\u0439")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E \u043A\u0440\u044B\u0448\u0438, \u043A\u0438\u0440\u043F\u0438\u0447\u043D\u0430\u044F \u043A\u043B\u0430\u0434\u043A\u0430 \u0438 \u043E\u0431\u043B\u0438\u0446\u043E\u0432\u043A\u0430 \u0437\u0434\u0430\u043D\u0438\u044F \u0432 \u0446\u0435\u043B\u043E\u043C")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u041F\u0440\u0430\u043A\u0442\u0438\u0447\u0435\u0441\u043A\u0438 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0430 \u043F\u0440\u043E\u043A\u043B\u0430\u0434\u043A\u0430 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u0441\u0435\u0442\u0435\u0439, \u043F\u0440\u043E\u043A\u043B\u0430\u0434\u043A\u0430 \u0442\u0440\u0443\u0431\u043E\u043F\u0440\u043E\u0432\u043E\u0434\u043E\u0432 \u0438 \u0448\u0442\u0443\u043A\u0430\u0442\u0443\u0440\u043D\u044B\u0435 \u0440\u0430\u0431\u043E\u0442\u044B"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u0412\u0430\u0440\u0438\u0430\u043D\u0442 2: 50% \u043E\u043F\u043B\u0430\u0442\u0430 \u043F\u0440\u0438 \u043F\u043E\u043A\u0443\u043F\u043A\u0435/\u0432\u043E \u0432\u0440\u0435\u043C\u044F \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 \u0441 50% \u0440\u0430\u0441\u0441\u0440\u043E\u0447\u043A\u043E\u0439 \u043F\u043B\u0430\u0442\u0435\u0436\u0430 \u043D\u0430 1, 3 \u0438\u043B\u0438 5 \u043B\u0435\u0442"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"50% \u043E\u043F\u043B\u0430\u0442\u0430 \u043F\u0440\u0438 \u043F\u043E\u043A\u0443\u043F\u043A\u0435 \u0443\u0436\u0435 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043D\u043E\u0439 \u043D\u0435\u0434\u0432\u0438\u0436\u0438\u043C\u043E\u0441\u0442\u0438. \u041F\u043E\u0441\u0442\u0435\u043F\u0435\u043D\u043D\u0430\u044F \u043E\u043F\u043B\u0430\u0442\u0430 \u0441\u0442\u0440\u043E\u044F\u0449\u0438\u0445\u0441\u044F \u043E\u0431\u044A\u0435\u043A\u0442\u043E\u0432 (50% \u0432\u043E \u0432\u0440\u0435\u043C\u044F \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430/50% \u043F\u043E \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u0438 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430), \u0441\u043E\u0433\u043B\u0430\u0441\u043D\u043E \u043F\u0440\u0438\u0432\u0435\u0434\u0435\u043D\u043D\u043E\u0439 \u043D\u0438\u0436\u0435 \u0442\u0430\u0431\u043B\u0438\u0446\u0435."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"\u041F\u043B\u0430\u043D \u0440\u0430\u0441\u0441\u0440\u043E\u0447\u043A\u0438 \u043F\u043B\u0430\u0442\u0435\u0436\u0435\u0439"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"th-col2"},"\u041E\u0442 \u0446\u0435\u043D\u044B \u043F\u0440\u043E\u0434\u0430\u0436\u0438"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1-\u044B\u0439 \u043F\u043B\u0430\u0442\u0435\u0436: \u043F\u0440\u0438 \u043F\u043E\u0434\u043F\u0438\u0441\u0430\u043D\u0438\u0438 \u043A\u043E\u043D\u0442\u0440\u0430\u043A\u0442\u0430"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2-\u043E\u0439 \u043F\u043B\u0430\u0442\u0435\u0436: \u043F\u0440\u0438 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0438 \u043F\u0440\u043E\u0435\u043A\u0442\u0430 \u0437\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u043D\u0430 50%",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"10%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3-\u0438\u0439 \u043F\u043B\u0430\u0442\u0435\u0436: \u043F\u0440\u0438 \u0432\u044B\u043F\u043E\u043B\u043D\u0435\u043D\u0438\u0438 \u043F\u0440\u043E\u0435\u043A\u0442\u0430 \u0437\u0430\u0441\u0442\u0440\u043E\u0439\u043A\u0438 \u043D\u0430 75%",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"10%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"4-\u044B\u0439 \u043F\u043B\u0430\u0442\u0435\u0436: \u043F\u043E \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u0438 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u04303",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"3")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"10%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u041F\u043B\u0430\u0442\u0435\u0436\u0438 \u043F\u043E \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0438\u0438 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u04304",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"4")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"50%")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"\u0412\u0430\u0440\u0438\u0430\u043D\u0442\u044B \u0444\u0438\u043D\u0430\u043D\u0441\u0438\u0440\u043E\u0432\u0430\u043D\u0438\u044F"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"th-col2"},"\u041F\u0440\u043E\u0446\u0435\u043D\u0442\u043D\u0430\u044F \u0441\u0442\u0430\u0432\u043A\u0430",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"(\u0433\u043E\u0434\u043E\u0432\u044B\u0435)"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1 \u0433\u043E\u0434 (12 \u0435\u0436\u0435\u043C\u0435\u0441\u044F\u0447\u043D\u044B\u0445 \u0432\u044B\u043F\u043B\u0430\u0442)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"3%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3 \u0433\u043E\u0434 (36 \u0435\u0436\u0435\u043C\u0435\u0441\u044F\u0447\u043D\u044B\u0445 \u0432\u044B\u043F\u043B\u0430\u0442)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"5%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5 \u043B\u0435\u0442 (60 \u0435\u0436\u0435\u043C\u0435\u0441\u044F\u0447\u043D\u044B\u0445 \u0432\u044B\u043F\u043B\u0430\u0442)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"7%")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u041F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u044F:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",{className:"notes"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u041F\u0440\u0430\u043A\u0442\u0438\u0447\u0435\u0441\u043A\u0438 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E \u0432\u043E\u0437\u0432\u0435\u0434\u0435\u043D\u0438\u0435 \u0431\u0435\u0442\u043E\u043D\u043D\u044B\u0445 \u043A\u043E\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0438\u0439")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E \u043A\u0440\u044B\u0448\u0438, \u043A\u0438\u0440\u043F\u0438\u0447\u043D\u0430\u044F \u043A\u043B\u0430\u0434\u043A\u0430 \u0438 \u043E\u0431\u043B\u0438\u0446\u043E\u0432\u043A\u0430 \u0437\u0434\u0430\u043D\u0438\u044F \u0432 \u0446\u0435\u043B\u043E\u043C")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u041F\u0440\u0430\u043A\u0442\u0438\u0447\u0435\u0441\u043A\u0438 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0430 \u043F\u0440\u043E\u043A\u043B\u0430\u0434\u043A\u0430 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u0441\u0435\u0442\u0435\u0439, \u043F\u0440\u043E\u043A\u043B\u0430\u0434\u043A\u0430 \u0442\u0440\u0443\u0431\u043E\u043F\u0440\u043E\u0432\u043E\u0434\u043E\u0432 \u0438 \u0448\u0442\u0443\u043A\u0430\u0442\u0443\u0440\u043D\u044B\u0435 \u0440\u0430\u0431\u043E\u0442\u044B")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u0421\u043C. \u0442\u0430\u0431\u043B\u0438\u0446\u0443 \u043D\u0438\u0436\u0435"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"table-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"tr-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u0426\u0435\u043D\u0430")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u0420\u0435\u0437\u0435\u0440\u0432\u0430\u0446\u0438\u043E\u043D\u043D\u044B\u0439 \u0434\u0435\u043F\u043E\u0437\u0438\u0442")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u041F\u043B\u0430\u0442\u0435\u0436 \u043F\u043E \u043E\u043A\u043E\u043D\u0447\u0430\u043D\u0438\u0438 \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u0430 - 50%",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"(\u0441 \u0432\u044B\u0447\u0435\u0442\u043E\u043C \u0434\u0435\u043F\u043E\u0437\u0438\u0442\u0430)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u041E\u0441\u0442\u0430\u0432\u0448\u0430\u044F\u0441\u044F \u0441\u0443\u043C\u043C\u0430 \u043F\u043B\u0430\u0442\u0435\u0436\u0430 - 50%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:"3",className:"td-group-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u0415\u0436\u0435\u043C\u0435\u0441\u044F\u0447\u043D\u044B\u0435 \u0432\u0437\u043D\u043E\u0441\u044B"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"tr-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"1 \u0433\u043E\u0434 (3%)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"3 \u0433\u043E\u0434\u0430 (5%)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"5 \u0433\u043E\u0434\u0430 (7%)"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"45,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"22,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"22,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,905,608"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"674,345"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"445,527")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"50,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"24,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"25,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,117,342"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"749,272"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"495,030")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"55,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"27,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"27,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,329,077"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"824,200"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"544,533")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u041F\u0440\u0438\u043C\u0435\u0447\u0430\u043D\u0438\u044F:"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",{className:"notes"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u041F\u0440\u0430\u043A\u0442\u0438\u0447\u0435\u0441\u043A\u0438 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E \u0432\u043E\u0437\u0432\u0435\u0434\u0435\u043D\u0438\u0435 \u0431\u0435\u0442\u043E\u043D\u043D\u044B\u0445 \u043A\u043E\u043D\u0441\u0442\u0440\u0443\u043A\u0446\u0438\u0439")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u0417\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u043E \u0441\u0442\u0440\u043E\u0438\u0442\u0435\u043B\u044C\u0441\u0442\u0432\u043E \u043A\u0440\u044B\u0448\u0438, \u043A\u0438\u0440\u043F\u0438\u0447\u043D\u0430\u044F \u043A\u043B\u0430\u0434\u043A\u0430 \u0438 \u043E\u0431\u043B\u0438\u0446\u043E\u0432\u043A\u0430 \u0437\u0434\u0430\u043D\u0438\u044F \u0432 \u0446\u0435\u043B\u043E\u043C")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u041F\u0440\u0430\u043A\u0442\u0438\u0447\u0435\u0441\u043A\u0438 \u0437\u0430\u0432\u0435\u0440\u0448\u0435\u043D\u0430 \u043F\u0440\u043E\u043A\u043B\u0430\u0434\u043A\u0430 \u044D\u043B\u0435\u043A\u0442\u0440\u043E\u0441\u0435\u0442\u0435\u0439, \u043F\u0440\u043E\u043A\u043B\u0430\u0434\u043A\u0430 \u0442\u0440\u0443\u0431\u043E\u043F\u0440\u043E\u0432\u043E\u0434\u043E\u0432 \u0438 \u0448\u0442\u0443\u043A\u0430\u0442\u0443\u0440\u043D\u044B\u0435 \u0440\u0430\u0431\u043E\u0442\u044B")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u0421\u043C. \u0442\u0430\u0431\u043B\u0438\u0446\u0443 \u043D\u0438\u0436\u0435"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{"class":"pull-right"},"\u041F\u043E\u0441\u043B\u0435\u0434\u043D\u044F\u044F \u0432\u0435\u0440\u0441\u0438\u044F: 19 \u0430\u043F\u0440\u0435\u043B\u044C 2019")),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"\u7B54. \u6211\u4EEC\u63D0\u4F9B\u4E24\u79CD\u4ED8\u6B3E\u65B9\u6848\u4F9B\u9009\u62E9\uFF1A"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u65B9\u68481: \u8D2D\u4E70\u65F6\u523B/\u65BD\u5DE5\u671F\u95F4\u4ED8\u6B3E100%"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"\u5BF9\u4E8E\u5DF2\u5EFA\u6210\u623F\u4EA7\uFF0C\u4F9D\u636E\u8D2D\u4E70\u4EF7\u683C100%\u4ED8\u6B3E\u3002\u5BF9\u4E8E\u5728\u5EFA\u623F\u4EA7\uFF0C\u4F9D\u636E\u4E0B\u8868\u6309\u8FDB\u5EA6\u5206\u671F\u4ED8\u6B3E\u3002"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"\u65BD\u5DE5\u4ED8\u6B3E\u6761\u6B3E"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"th-col2"},"\u5360\u9500\u552E\u4EF7\u683C"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u7B7E\u8BA2\u5408\u540C\u65F6\u7B2C1\u7B14\u4ED8\u6B3E"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u65BD\u5DE5\u5B8C\u621025\uFF05\u65F6\u7B2C2\u7B14\u4ED8\u6B3E",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u65BD\u5DE5\u5B8C\u621050\uFF05\u65F6\u7B2C3\u7B14\u4ED8\u6B3E",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u65BD\u5DE5\u5B8C\u621075\uFF05\u65F6\u7B2C4\u7B14\u4ED8\u6B3E",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"3")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,">\u65BD\u5DE5\u5B8C\u6210\u65F6\u7B2C5\u7B14\u4ED8\u6B3E"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{textAlign:"center"}},"\u603B\u8BA1"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"100%")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u6CE8\u610F\uFF1A"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",{className:"notes"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"\u6DF7\u51DD\u571F\u7ED3\u6784\u57FA\u672C\u5B8C\u5DE5"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"\u5C4B\u9876\u3001\u7816\u780C\u548C\u7C89\u5237\u5DE5\u7A0B\u57FA\u672C\u5B8C\u5DE5"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"\u7535\u7F06\u3001\u7BA1\u9053\u548C\u6CE5\u6C34\u5DE5\u7A0B\u57FA\u672C\u5B8C\u5DE5")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u65B9\u68482: \u8D2D\u4E70\u65F6\u523B/\u65BD\u5DE5\u671F\u95F4\u4ED8\u6B3E50%\uFF0C\u5269\u4F5950%\u52061\u5E74\uFF0C3\u5E74\u62165\u5E74\u5EF6\u671F\u4ED8\u6B3E"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"\u5BF9\u4E8E\u5DF2\u5EFA\u6210\u623F\u4EA7\uFF0C\u4F9D\u636E\u8D2D\u4E70\u4EF7\u683C50%\u4ED8\u6B3E\u3002\u5BF9\u4E8E\u5728\u5EFA\u623F\u4EA7(\u65BD\u5DE5\u671F\u95F4\u4ED8\u6B3E50%\uFF0C\u5269\u4F5950%\u65BD\u5DE5\u5B8C\u6210\u4EE5\u540E\u4ED8\u6B3E) \u4F9D\u636E\u4E0B\u8868\u6309\u8FDB\u5EA6\u5206\u671F\u4ED8\u6B3E\u3002"," "),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"\u5EF6\u671F\u4ED8\u6B3E\u8BA1\u5212"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"th-col2"},"\u5360\u9500\u552E\u4EF7\u683C"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u7B7E\u8BA2\u5408\u540C\u65F6\u7B2C1\u7B14\u4ED8\u6B3E"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"20%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u65BD\u5DE5\u5B8C\u621050\uFF05\u65F6\u7B2C2\u7B14\u4ED8\u6B3E",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"10%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u65BD\u5DE5\u5B8C\u621075\uFF05\u65F6\u7B2C3\u7B14\u4ED8\u6B3E",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"2")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"10%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u65BD\u5DE5\u5B8C\u6210\u65F6\u7B2C4\u7B14\u4ED8\u6B3E",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"3")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"10%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"\u65BD\u5DE5\u5B8C\u6210\u4EE5\u540E\u4ED8\u6B3E",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"4")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"50%")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("thead",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",null,"\u4ED8\u6B3E\u65B9\u6848"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("th",{className:"th-col2"},"\u5229\u7387",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"(\u6BCF\u5E74)"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1 \u5E74(12 \u4E2A\u6708\u5206\u671F\u4ED8\u6B3E)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"3%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"3 \u5E74(36 \u4E2A\u6708\u5206\u671F\u4ED8\u6B3E)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"5%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"5 \u5E74(60 \u4E2A\u6708\u5206\u671F\u4ED8\u6B3E)"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-col2"},"7%")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"\u6CE8\u610F\uFF1A")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",{className:"notes"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"\u6DF7\u51DD\u571F\u7ED3\u6784\u57FA\u672C\u5B8C\u5DE5"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"\u5C4B\u9876\u3001\u7816\u780C\u548C\u7C89\u5237\u5DE5\u7A0B\u57FA\u672C\u5B8C\u5DE5"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"\u7535\u7F06\u3001\u7BA1\u9053\u548C\u6CE5\u6C34\u5DE5\u7A0B\u57FA\u672C\u5B8C\u5DE5"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"\u53C2\u89C1\u4E0B\u8868")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{className:"table-center"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"tr-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u4EF7\u683C")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u5B9A\u91D1")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u65BD\u5DE5\u7ED3\u675F\u540E\u652F\u4ED850% ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"(\u6263\u9664\u5B9A\u91D1)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{rowSpan:"2",className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u5269\u4F59\u5F85\u8FD8\u6B3E\u987950%")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{colSpan:"3",className:"td-group-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"\u6BCF\u6708\u5206\u671F\u4ED8\u6B3E"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",{className:"tr-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"1\u5E74(3%)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{className:"td-title"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"3\u5E74(5%)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"5\u5E74(7%)"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"45,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"22,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"22,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"1,905,608"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"674,345"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"445,527")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"50,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"24,900,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"25,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,117,342"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"749,272"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"495,030")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"55,000,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"100,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"27,400,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"27,500,000"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"2,329,077"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"824,200"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",null,"544,533")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,"\u6CE8\u610F\uFF1A"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",{className:"notes"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"\u6240\u6709\u91D1\u989D\u5747\u4EE5\u6CF0\u94E2(THB) \u8868\u793A\u3002"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"\u4E0A\u8868\u5217\u51FA\u4E86\u5F53\u552E\u4EF7\u4E3A45,000,000 \u81F355,000,000 \u6CF0\u94E2\u65F6\uFF0C\u5404\u4E2A\u4ED8\u6B3E\u65B9\u6848\u7684\u4F30\u8BA1\u4ED8\u6B3E\u989D"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"\u4F30\u8BA1\u4ED8\u6B3E\u989D\u4EC5\u4F9B\u53C2\u8003\uFF0C\u5F00\u53D1\u5546/\u51FA\u5356\u65B9\u4E0D\u627F\u62C5\u4EFB\u4F55\u4E0D\u51C6\u786E\u6216\u9057\u6F0F\u7684\u4EFB\u4F55\u8D23\u4EFB\u6216\u6CD5\u5F8B\u8D23\u4EFB\u3002"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("em",null,"\u4ED8\u6B3E\u6761\u6B3E\u5982\u6709\u66F4\u6539\uFF0C\u6055\u4E0D\u53E6\u884C\u901A\u77E5\u3002")))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{"class":"pull-right"},"\u66F4\u65B0\u4E8E\uFF1A21 December 2018"))}}];

/***/ }),
/* 1030 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_capitalize__ = __webpack_require__(1031);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_capitalize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_capitalize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_join__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_lodash_join___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_lodash_join__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_forEach__ = __webpack_require__(316);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_lodash_forEach___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_lodash_forEach__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_replace__ = __webpack_require__(164);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_lodash_replace___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_lodash_replace__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_find__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isEmpty__ = __webpack_require__(51);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6_lodash_isEmpty___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_6_lodash_isEmpty__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isArray__ = __webpack_require__(13);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7_lodash_isArray___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_7_lodash_isArray__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_sortBy__ = __webpack_require__(1034);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8_lodash_sortBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_8_lodash_sortBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_map__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_9_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_includes__ = __webpack_require__(42);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10_lodash_includes___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_10_lodash_includes__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_filter__ = __webpack_require__(32);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11_lodash_filter___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_11_lodash_filter__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_get__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_12_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_reduce__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13_lodash_reduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_13_lodash_reduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_uniqBy__ = __webpack_require__(1039);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14_lodash_uniqBy___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_14_lodash_uniqBy__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_memoize__ = __webpack_require__(245);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15_lodash_memoize___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_15_lodash_memoize__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_16_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_skrollr__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17_react_skrollr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_17_react_skrollr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_helmet__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_18_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_18_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_19_react_router__ = __webpack_require__(1045);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_20_react_final_form__ = __webpack_require__(1046);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_21_final_form__ = __webpack_require__(369);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_recaptcha_google__ = __webpack_require__(1047);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_22_react_recaptcha_google___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_22_react_recaptcha_google__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react_scroll__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_23_react_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_23_react_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_24__hoc__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_25__actions_language__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_26__actions_location__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_27__actions_preview_trip__ = __webpack_require__(1066);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_28__utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_29__services_email__ = __webpack_require__(1073);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_30__components__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _objectWithoutProperties(obj,keys){var target={};for(var i in obj){if(keys.indexOf(i)>=0)continue;if(!Object.prototype.hasOwnProperty.call(obj,i))continue;target[i]=obj[i];}return target;}var isDev="production"==="development";var PAGE_KEY="preview-trip";var emailSubject="LP web – Complimentary preview trip offer";var emailTo=isDev?["mondit.thum@gmail.com"]:["Sherry.Jia@banyantree.com","sinniont@lagunaproperty.com","stefanoc@lagunaphuket.com"];var emailCC=isDev?[]:["info@lagunaproperty.com"];var Error=function Error(_ref){var name=_ref.name,rest=_objectWithoutProperties(_ref,["name"]);return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_react_final_form__["a" /* Field */],{name:name,subscription:{touched:true,error:true},render:function render(_ref2){var _ref2$meta=_ref2.meta,touched=_ref2$meta.touched,error=_ref2$meta.error;return touched&&error?__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"form-error"},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("span",{className:"field-error"},error)):null;}});};var assetPath=function assetPath(path){return Object(__WEBPACK_IMPORTED_MODULE_28__utils__["a" /* assetsPath */])(PAGE_KEY)+"/"+path;};// const toNumberFormat = (number, decimals, decPoint, thousandsSep) => {
//   number = (number + '')
//     .replace(/[^0-9+\-Ee.]/g, '');
//   var n = !isFinite(+number) ? 0 : +number,
//     prec = !isFinite(+decimals) ? 0 : Math.abs(decimals),
//     sep = (typeof thousandsSep === 'undefined') ? ',' : thousandsSep,
//     dec = (typeof decPoint === 'undefined') ? '.' : decPoint,
//     s = '',
//     toFixedFix = function(n, prec) {
//       var k = Math.pow(10, prec);
//       return '' + (Math.round(n * k) / k)
//         .toFixed(prec);
//     };
//   // Fix for IE parseFloat(0.55).toFixed(0) = 0;
//   s = (prec ? toFixedFix(n, prec) : '' + Math.round(n))
//     .split('.');
//   if (s[0].length > 3) {
//     s[0] = s[0].replace(/\B(?=(?:\d{3})+(?!\d))/g, sep);
//   }
//   if ((s[1] || '')
//     .length < prec) {
//     s[1] = s[1] || '';
//     s[1] += new Array(prec - s[1].length + 1)
//       .join('0');
//   }
//   return s.join(dec);
// }
var pickCurrencies=["THB","AUD","CNY","EUR","HKD","SGD","GBP","USD"];var getCurrencies=__WEBPACK_IMPORTED_MODULE_15_lodash_memoize___default()(function(countries){return __WEBPACK_IMPORTED_MODULE_14_lodash_uniqBy___default()(__WEBPACK_IMPORTED_MODULE_13_lodash_reduce___default()(countries,function(acc,country){return[].concat(_toConsumableArray(acc),_toConsumableArray(country.currencies));},[]),"code");});var mapStateToProps=function mapStateToProps(state){var countries=__WEBPACK_IMPORTED_MODULE_12_lodash_get___default()(state,PAGE_KEY+".data.countries",[]);var uniqCurrencies=getCurrencies(countries);var currencies=__WEBPACK_IMPORTED_MODULE_11_lodash_filter___default()(uniqCurrencies,function(currency){return __WEBPACK_IMPORTED_MODULE_10_lodash_includes___default()(pickCurrencies,currency.code);});console.log('currencies',currencies);return{isMobile:state.device.isMobile,languages:state.language.languages,dictionary:__WEBPACK_IMPORTED_MODULE_12_lodash_get___default()(state,PAGE_KEY+".data.dictionary",{}),option:__WEBPACK_IMPORTED_MODULE_12_lodash_get___default()(state,PAGE_KEY+".data.option",{}),projects:__WEBPACK_IMPORTED_MODULE_12_lodash_get___default()(state,PAGE_KEY+".data.project",[]),countryNameOptions:__WEBPACK_IMPORTED_MODULE_9_lodash_map___default()(countries,function(country){return{label:country.name||"",value:country.name||""};}),currencyOptions:__WEBPACK_IMPORTED_MODULE_8_lodash_sortBy___default()(__WEBPACK_IMPORTED_MODULE_9_lodash_map___default()(currencies,function(currency){return{label:currency.code==='USD'?'United States dollar':currency.name,// label: currency.symbol
//   ? `${currency.name} - ${currency.symbol}`
//   : currency.name,
value:currency.code||""};}),"label"),nationalityOptions:__WEBPACK_IMPORTED_MODULE_9_lodash_map___default()(__WEBPACK_IMPORTED_MODULE_12_lodash_get___default()(state,PAGE_KEY+".data.option.nationalityOptions",[]),function(nationality){return{label:__WEBPACK_IMPORTED_MODULE_12_lodash_get___default()(nationality,"nationality",""),value:__WEBPACK_IMPORTED_MODULE_12_lodash_get___default()(nationality,"nationality","")};}),exchangeCurrencyRates:__WEBPACK_IMPORTED_MODULE_12_lodash_get___default()(state,PAGE_KEY+".data.exchangeCurrencyRates.rates",[])};};var actionToProps={switchLanguage:__WEBPACK_IMPORTED_MODULE_25__actions_language__["a" /* switchLanguage */],switchLocation:__WEBPACK_IMPORTED_MODULE_26__actions_location__["a" /* switchLocation */],initAppPreviewTrip:__WEBPACK_IMPORTED_MODULE_27__actions_preview_trip__["a" /* initAppPreviewTrip */]};var PreviewTrip=function(_Component){_inherits(PreviewTrip,_Component);function PreviewTrip(props){var _this2=this;_classCallCheck(this,PreviewTrip);var _this=_possibleConstructorReturn(this,(PreviewTrip.__proto__||Object.getPrototypeOf(PreviewTrip)).call(this,props));_this.requiredFields=["title","firstName","lastName","nationality","email","mobilePhone",// 'landPhone',
"city","country","currency","budget","projects","question1","question2"];_this.componentWillUnmount=function(){window.removeEventListener("scroll",_this.handleScrollPage);};_this.getContent=function(key){var _this$props=_this.props,t=_this$props.t,dictionary=_this$props.dictionary;var content=dictionary[key];if(!content){console.warn(key+" could not be found in dictionary",dictionary);return"";}if(__WEBPACK_IMPORTED_MODULE_7_lodash_isArray___default()(content)){return content;}return t(content);};_this.updateDimensions=function(){var width=window.innerWidth;var offset=-90;if(width>768)offset=-152;if(width>1200)offset=-86;if(_this.state.offset!==offset)_this.setState({offset:offset});};_this.setLanguage=function(language){_this.props.actions.switchLanguage(language);};_this.fetchData=function(){_this.props.actions.initAppPreviewTrip();};_this.convertCurrencyRate=function(_ref3){var value=_ref3.value,from=_ref3.from,to=_ref3.to;var exchangeCurrencyRates=_this.props.exchangeCurrencyRates;var fromRate=__WEBPACK_IMPORTED_MODULE_12_lodash_get___default()(exchangeCurrencyRates,from,0);var toRate=__WEBPACK_IMPORTED_MODULE_12_lodash_get___default()(exchangeCurrencyRates,to,0);if(fromRate===0||toRate===0){// console.warn(`Cannot convert from ${from} to ${to} because cannot find one of them in exchangeCurrencyRates`)
return 0;}return Math.round(value/fromRate*toRate);};_this.getBudgetOptions=function(values){var currency=values.currency;var _this$props2=_this.props,option=_this$props2.option,t=_this$props2.t;var options=!__WEBPACK_IMPORTED_MODULE_6_lodash_isEmpty___default()(currency)?__WEBPACK_IMPORTED_MODULE_12_lodash_get___default()(option,"budgetRateOptions."+currency,[]):__WEBPACK_IMPORTED_MODULE_12_lodash_get___default()(option,"budgetRateOptions.THB",[]);return __WEBPACK_IMPORTED_MODULE_9_lodash_map___default()(options,function(_option){return{label:t(_option),value:t(_option)};});// const { t } = this.props
// const { t, exchangeCurrencyRates } = this.props
// console.log('getBudgetOptions', values, exchangeCurrencyRates)
// return [
//   {
//     label: t({
//       en: "Less than 10 million Baht",
//       ru: "Менее 10 млн бат",
//       cn: "Less than 10 million Baht"
//     }),
//     value: "Less than 10 million Baht"
//   },
//   {
//     label: t({
//       en: "Between 10 to 20 million Baht",
//       ru: "От 10 до 20 млн бат",
//       cn: "Between 10 to 20 million Baht"
//     }),
//     value: "Between 10 to 20 million Baht"
//   },
//   {
//     label: t({
//       en: "Between 20 to 40 million Baht",
//       ru: "От 20 до 40 млн бат",
//       cn: "Between 20 to 40 million Baht"
//     }),
//     value: "Between 20 to 40 million Baht"
//   },
//   {
//     label: t({
//       en: "More than 40 million Baht",
//       ru: "Более 40 млн бат",
//       cn: "More than 40 million Baht"
//     }),
//     value: "More than 40 million Baht"
//   }
// ]
// return [
//   {
//     label: `Less than ${toNumberFormat(this.convertCurrencyRate({ value: 10000000, from: 'THB', to: currency }))} ${currency}`,
//     value: `Less than ${toNumberFormat(this.convertCurrencyRate({ value: 10000000, from: 'THB', to: currency }))} ${currency}`,
//   },
//   {
//     label: `Between ${toNumberFormat(this.convertCurrencyRate({ value: 10000000, from: 'THB', to: currency }))} to ${toNumberFormat(this.convertCurrencyRate({ value: 20000000, from: 'THB', to: currency }))} ${currency}`,
//     value: `Between ${toNumberFormat(this.convertCurrencyRate({ value: 10000000, from: 'THB', to: currency }))} to ${toNumberFormat(this.convertCurrencyRate({ value: 20000000, from: 'THB', to: currency }))} ${currency}`,
//   },
//   {
//     label: `Between ${toNumberFormat(this.convertCurrencyRate({ value: 20000000, from: 'THB', to: currency }))} to ${toNumberFormat(this.convertCurrencyRate({ value: 40000000, from: 'THB', to: currency }))} ${currency}`,
//     value: `Between ${toNumberFormat(this.convertCurrencyRate({ value: 20000000, from: 'THB', to: currency }))} to ${toNumberFormat(this.convertCurrencyRate({ value: 40000000, from: 'THB', to: currency }))} ${currency}`,
//   },
//   {
//     label: `More than ${toNumberFormat(this.convertCurrencyRate({ value: 40000000, from: 'THB', to: currency }))} ${currency}`,
//     value: `More than ${toNumberFormat(this.convertCurrencyRate({ value: 40000000, from: 'THB', to: currency }))} ${currency}`,
//   },
// ]
};_this.getLanguageIcon=function(){var _this$props3=_this.props,languages=_this$props3.languages,currentLanguage=_this$props3.currentLanguage;var targetLanguage=__WEBPACK_IMPORTED_MODULE_5_lodash_find___default()(languages,function(language){return language.key===currentLanguage;});return targetLanguage&&targetLanguage.icon||"";};_this.handleScrollPage=function(){var small=_this.state.small;var pageYOffset=window.pageYOffset||document.documentElement.scrollTop;_this.lastScrollY=pageYOffset;if(_this.lastScrollY>30&&small===false){_this.setState({small:true});}else if(_this.lastScrollY<=30&&small===true){_this.setState({small:false});}};_this.handleSwitchLanguage=function(nextLanguage){var _this$props4=_this.props,currentLanguage=_this$props4.currentLanguage,location=_this$props4.location;var pathname=location.pathname;var nextUrl=__WEBPACK_IMPORTED_MODULE_4_lodash_replace___default()(pathname,"/"+currentLanguage+"/","/"+nextLanguage+"/");_this.props.history.push(nextUrl);};_this.handleVerifyReCaptchaCallback=function(reCaptchaToken){console.log("handleVerifyReCaptchaCallback",reCaptchaToken);_this.setState({reCaptchaToken:reCaptchaToken});};_this.handleValidate=function(values){// console.log('validate', values);
var errors={};__WEBPACK_IMPORTED_MODULE_3_lodash_forEach___default()(_this.requiredFields,function(fieldName){if(fieldName==="email"){var emailRegex=/(?:[a-z0-9!#$%&'*+/=?^_`{|}~-]+(?:\.[a-z0-9!#$%&'*+/=?^_`{|}~-]+)*|"(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21\x23-\x5b\x5d-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])*")@(?:(?:[a-z0-9](?:[a-z0-9-]*[a-z0-9])?\.)+[a-z0-9](?:[a-z0-9-]*[a-z0-9])?|\[(?:(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?)\.){3}(?:25[0-5]|2[0-4][0-9]|[01]?[0-9][0-9]?|[a-z0-9-]*[a-z0-9]:(?:[\x01-\x08\x0b\x0c\x0e-\x1f\x21-\x5a\x53-\x7f]|\\[\x01-\x09\x0b\x0c\x0e-\x7f])+)\])/gi;if(emailRegex.test(values.email)===false){errors[fieldName]="email format is wrong.";}}if(__WEBPACK_IMPORTED_MODULE_6_lodash_isEmpty___default()(values[fieldName])){errors[fieldName]=_this.getContent('fieldRequired');}});return errors;};_this.handleSubmit=function(){var _ref4=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(values,form){var reCaptchaToken;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:reCaptchaToken=_this.state.reCaptchaToken;console.log("handleSubmit",reCaptchaToken,values,form);if(!__WEBPACK_IMPORTED_MODULE_6_lodash_isEmpty___default()(reCaptchaToken)){_context.next=4;break;}return _context.abrupt("return",_defineProperty({},__WEBPACK_IMPORTED_MODULE_21_final_form__["a" /* FORM_ERROR */],"Please check Recaptcha."));case 4:_context.prev=4;_context.next=7;return Object(__WEBPACK_IMPORTED_MODULE_29__services_email__["a" /* sendEmailOnlyService */])({subject:emailSubject,to:emailTo,cc:emailCC,reCaptchaToken:reCaptchaToken,data:{Title:__WEBPACK_IMPORTED_MODULE_12_lodash_get___default()(values,"title",""),"First Name":__WEBPACK_IMPORTED_MODULE_12_lodash_get___default()(values,"firstName",""),"Last Name":__WEBPACK_IMPORTED_MODULE_12_lodash_get___default()(values,"lastName",""),Nationality:__WEBPACK_IMPORTED_MODULE_12_lodash_get___default()(values,"nationality",""),Email:__WEBPACK_IMPORTED_MODULE_12_lodash_get___default()(values,"email",""),"Mobile Phone":__WEBPACK_IMPORTED_MODULE_12_lodash_get___default()(values,"mobilePhone",""),"Land Phone":__WEBPACK_IMPORTED_MODULE_12_lodash_get___default()(values,"landPhone",""),City:__WEBPACK_IMPORTED_MODULE_12_lodash_get___default()(values,"city",""),Country:__WEBPACK_IMPORTED_MODULE_12_lodash_get___default()(values,"country",""),Currency:__WEBPACK_IMPORTED_MODULE_12_lodash_get___default()(values,"currency",""),Budget:__WEBPACK_IMPORTED_MODULE_12_lodash_get___default()(values,"budget",""),Project:__WEBPACK_IMPORTED_MODULE_2_lodash_join___default()(__WEBPACK_IMPORTED_MODULE_12_lodash_get___default()(values,"projects",[]),", "),"Do you already have investment(s) in Thailand?":__WEBPACK_IMPORTED_MODULE_1_lodash_capitalize___default()(__WEBPACK_IMPORTED_MODULE_12_lodash_get___default()(values,"question1","")),"Do you already have investment(s) with Laguna Properties or its subsidiaries?":__WEBPACK_IMPORTED_MODULE_1_lodash_capitalize___default()(__WEBPACK_IMPORTED_MODULE_12_lodash_get___default()(values,"question2",""))}});case 7:_this.setState({submitted:true});window.scrollTo(0,0);_context.next=14;break;case 11:_context.prev=11;_context.t0=_context["catch"](4);console.error(_context.t0);case 14:case"end":return _context.stop();}}},_callee,_this2,[[4,11]]);}));return function(_x,_x2){return _ref4.apply(this,arguments);};}();_this.handleGoBackToFormPage=function(){_this.setState({submitted:false});};_this.toggleShowLanguageSelection=function(){_this.setState({showLanguageSelection:!_this.state.showLanguageSelection});};_this.renderLanguageOption=function(_ref6){var name=_ref6.name,key=_ref6.key,icon=_ref6.icon,rest=_objectWithoutProperties(_ref6,["name","key","icon"]);return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("li",{key:key},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("a",{onClick:_this.handleSwitchLanguage.bind(_this,key)},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("img",{alt:"",src:icon}),name));};_this.renderCheckboxField=function(_ref7){var name=_ref7.name,label=_ref7.label,options=_ref7.options,required=_ref7.required;return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"form-field"},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("h4",{className:"field-label",style:{display:label?'block':'none'}},label," ",required&&__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("span",null,"*")),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_9_lodash_map___default()(options,function(_ref8){var label=_ref8.label,value=_ref8.value;return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("label",{style:{display:'flex',flexDirection:'row',alignItems:'center'}},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_react_final_form__["a" /* Field */],{name:name,component:"input",type:"checkbox",value:value})," ",__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("svg",{className:"checkmark",viewBox:"0 0 24 24"},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("path",{className:"checkmark-path",fill:"none",stroke:"white",d:"M1.73,12.91 8.1,19.28 22.79,4.59"})))),label);})));};_this.renderRadioField=function(_ref9){var name=_ref9.name,label=_ref9.label,options=_ref9.options,required=_ref9.required;return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"form-container"},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"form-field"},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("h4",{className:"field-label"},label," ",required&&__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("span",{className:"icon-required"},"*")),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_9_lodash_map___default()(options,function(_ref10){var label=_ref10.label,value=_ref10.value;return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("label",null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_react_final_form__["a" /* Field */],{name:name,component:"input",type:"radio",value:value}),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("span",null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("span",null)),label);}))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(Error,{name:name}));};_this.renderTextField=function(_ref11){var name=_ref11.name,_ref11$type=_ref11.type,type=_ref11$type===undefined?"text":_ref11$type,placeholder=_ref11.placeholder,label=_ref11.label,required=_ref11.required;return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"form-container"},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(Error,{name:name}),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"form-field"},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("h4",{className:"field-label",style:{opacity:!label?0:1}},label," ",required&&__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("span",{className:"icon-required"},"*")),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_react_final_form__["a" /* Field */],{name:name,component:"input",type:type,placeholder:placeholder})));};_this.renderSelectField=function(_ref12){var name=_ref12.name,label=_ref12.label,options=_ref12.options,placeholder=_ref12.placeholder,required=_ref12.required;return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"form-container"},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(Error,{name:name}),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"form-field"},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("h4",{className:"field-label"},label," ",required&&__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("span",{className:"icon-required"},"*")),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_react_final_form__["a" /* Field */],{name:name,component:"select"},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("option",{value:""},placeholder),__WEBPACK_IMPORTED_MODULE_9_lodash_map___default()(options,function(_ref13){var optionLabel=_ref13.label,optionValue=_ref13.value;return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("option",{value:optionValue},optionLabel);}))));};_this.renderForm=function(){var readyToLoadCaptcha=_this.state.readyToLoadCaptcha;var _this$props5=_this.props,projects=_this$props5.projects,option=_this$props5.option,t=_this$props5.t,nationalityOptions=_this$props5.nationalityOptions,countryNameOptions=_this$props5.countryNameOptions,currencyOptions=_this$props5.currencyOptions;return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("section",{id:"welcome"},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("h1",null,_this.getContent("welcomeHeading")),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"sub-heading"},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("h4",null,_this.getContent("welcomeSubHeading")))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("form",null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_20_react_final_form__["b" /* Form */],{onSubmit:_this.handleSubmit,initialValues:{},validate:_this.handleValidate,render:function render(_ref14){var submitError=_ref14.submitError,handleSubmit=_ref14.handleSubmit,form=_ref14.form,submitting=_ref14.submitting,pristine=_ref14.pristine,values=_ref14.values;return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("section",{id:"basic-information"},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("h2",null,_this.getContent("basicInformation")),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("hr",null),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"col-md-4"},_this.renderSelectField({name:"title",placeholder:"Choose...",label:_this.getContent("title"),options:__WEBPACK_IMPORTED_MODULE_9_lodash_map___default()(__WEBPACK_IMPORTED_MODULE_12_lodash_get___default()(option,"titleOptions",[]),function(_ref15){var label=_ref15.label,value=_ref15.value;return{label:t(label),value:value};}),required:true})),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"col-md-4"},_this.renderTextField({name:"firstName",placeholder:_this.getContent("firstName"),label:_this.getContent("name"),required:true})),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"col-md-4"},_this.renderTextField({name:"lastName",placeholder:_this.getContent("lastName"),required:true}))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"col-md-6"},_this.renderSelectField({name:"nationality",placeholder:"Choose your nationality...",label:_this.getContent("nationality"),options:nationalityOptions,required:true})),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"col-md-6"},_this.renderTextField({name:"email",label:_this.getContent("email"),placeholder:"Example: Name@company.com",required:true}))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"col-md-6"},_this.renderTextField({name:"mobilePhone",label:_this.getContent("phone"),placeholder:_this.getContent("mobilePhone"),type:"tel",required:true})),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"col-md-6"},_this.renderTextField({name:"landPhone",placeholder:_this.getContent("landPhone"),type:"tel",required:true}))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"col-md-6"},_this.renderTextField({name:"city",label:_this.getContent("location"),placeholder:_this.getContent("city"),required:true})),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"col-md-6"},_this.renderSelectField({name:"country",label:_this.getContent("country"),placeholder:_this.getContent("country"),options:countryNameOptions,required:true})))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("section",{id:"investment-options"},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("h2",null,_this.getContent("investmentOptions")),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("hr",null),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"col-md-6"},_this.renderSelectField({name:"currency",placeholder:"Choose your currency...",label:_this.getContent("selectCurrency"),options:currencyOptions,required:true})),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"col-md-6"},_this.renderSelectField({name:"budget",placeholder:"Choose your investment budget...",label:_this.getContent("selectBudget"),options:_this.getBudgetOptions(values),required:true})))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("section",{id:"project-selection"},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"row"},projects.map(function(_ref16){var key=_ref16.key,_ref16$theme=_ref16.theme,theme=_ref16$theme===undefined?"":_ref16$theme,value=_ref16.value,logo=_ref16.logo,thumbnail=_ref16.thumbnail,list=_ref16.list;return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"column col-lg-6 col-md-12",key:key},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"project-card "+key},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"logo image-wrapper"},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("img",{src:assetPath(logo)})),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"thumbnail image-wrapper"},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("img",{src:assetPath(thumbnail)})),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("ul",null,list.map(function(item){return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("li",{key:t(item)},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("h2",null,t(item)));}))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"action "+theme},_this.renderCheckboxField({name:"projects",options:[{label:_this.getContent("interested"),value:value}]}))));}))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("section",{id:"almost-there"},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("h2",null,_this.getContent("almostThere")),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("hr",null),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"col-sm-12"},_this.renderRadioField({name:"question1",label:_this.getContent("question1"),options:[{label:_this.getContent("yes"),value:"yes"},{label:_this.getContent("no"),value:"no"}],required:true})),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"col-sm-12"},_this.renderRadioField({name:"question2",label:_this.getContent("question2"),options:[{label:_this.getContent("yes"),value:"yes"},{label:_this.getContent("no"),value:"no"}],required:true}))),readyToLoadCaptcha&&__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_22_react_recaptcha_google__["ReCaptcha"],{ref:function ref(el){return _this.captchaDemo=el;},size:"normal","data-theme":"dark",render:"explicit",sitekey:"6LcABWUUAAAAADKAjhB-QnE0hEQb39ZR9Aknbjy7",onloadCallback:_this.onLoadRecaptcha,verifyCallback:_this.handleVerifyReCaptchaCallback}),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("br",null),submitError&&__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"error"},submitError),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("button",{className:"button",type:"submit",disabled:submitting,onClick:handleSubmit},_this.getContent("submit")));}})));};_this.renderThankyou=function(){var currentLanguage=_this.props.currentLanguage;return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("section",{id:"thankyou"},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("h2",{className:"content"},_this.getContent("thankyou")),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("a",{href:"https://lagunaproperty.com/"+currentLanguage},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("button",{className:"button"},_this.getContent("viewFullSite"))));};_this.headerRef=__WEBPACK_IMPORTED_MODULE_16_react___default.a.createRef();_this.captchaDemo=__WEBPACK_IMPORTED_MODULE_16_react___default.a.createRef();_this.state={showLanguageSelection:false,small:false,readyToLoadCaptcha:false,reCaptchaToken:"",submitted:false};return _this;}_createClass(PreviewTrip,[{key:"componentDidMount",value:function componentDidMount(){var _this3=this;this.setLanguage(this.props.match.params.language);this.fetchData();Object(__WEBPACK_IMPORTED_MODULE_22_react_recaptcha_google__["loadReCaptcha"])();window.addEventListener("scroll",this.handleScrollPage);setTimeout(function(){_this3.setState({readyToLoadCaptcha:true});},1500);}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps){var currentLanguage=prevProps.match.params.language;var nextLanguage=this.props.match.params.language;if(currentLanguage!==nextLanguage){this.setLanguage(nextLanguage);}}},{key:"scrollToTop",value:function scrollToTop(){__WEBPACK_IMPORTED_MODULE_23_react_scroll__["animateScroll"].scrollToTop();}},{key:"onLoadRecaptcha",value:function onLoadRecaptcha(){if(this.captchaDemo){this.captchaDemo.reset();// this.captchaDemo.execute();
}}},{key:"render",value:function render(){var _state=this.state,small=_state.small,submitted=_state.submitted,showLanguageSelection=_state.showLanguageSelection;var _props=this.props,languages=_props.languages,currentLanguage=_props.currentLanguage;return __WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_18_react_helmet__["Helmet"],null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("title",null,"Laguna Preview Trip")),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("header",{className:"header "+PAGE_KEY+" "+(small?"small":""),ref:this.headerRef},submitted&&__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"top-action "+PAGE_KEY},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{onClick:this.handleGoBackToFormPage,className:"nav"},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"arrow-left"}),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("h4",null,this.getContent('backToPrevious')))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("img",{src:assetPath("logo-banyantree-group.png"),alt:""}),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"language "+(showLanguageSelection?"open":""),onClick:this.toggleShowLanguageSelection},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("img",{className:"current-lang",alt:"",src:this.getLanguageIcon()}),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("img",{src:"data:image/svg+xml;base64,PHN2ZyBmaWxsPSdibGFjaycgaGVpZ2h0PScyNCcgdmlld0JveD0nMCAwIDI0IDI0JyB3aWR0aD0nMjQnIHhtbG5zPSdodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2Zyc+PHBhdGggZD0nTTcgMTBsNSA1IDUtNXonLz48cGF0aCBkPSdNMCAwaDI0djI0SDB6JyBmaWxsPSdub25lJy8+PC9zdmc+",alt:""}),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("ul",{className:"list"},languages.map(this.renderLanguageOption)))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"main-content "+PAGE_KEY},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"container"},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"widget"},submitted?this.renderThankyou():this.renderForm()))),!submitted&&__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{className:"bottom-action "+PAGE_KEY},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{onClick:this.scrollToTop,className:"navigation"},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("div",{"class":"arrow-up"}),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("h4",null,"Back To Top"))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("footer",{className:"footer "+PAGE_KEY},__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("h4",null,"\xA9 2019 BANYAN TREE GROUP"),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("a",{target:"_blank",href:"https://lagunaproperty.com/"+currentLanguage+"/privacy-policy"},this.getContent("privacy"))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement("a",{target:"_blank",href:"https://lagunaproperty.com/"+currentLanguage+"/terms"},this.getContent("term"))))),__WEBPACK_IMPORTED_MODULE_16_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_30__components__["n" /* PrivacyPolicy */],{text:this.getContent('cookiePrivacy'),linkText:this.getContent('cookiePrivacyLink'),buttonText:this.getContent('accept'),href:"http://lagunaproperty.com/"+currentLanguage+"/privacy-policy"}));}}]);return PreviewTrip;}(__WEBPACK_IMPORTED_MODULE_16_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (Object(__WEBPACK_IMPORTED_MODULE_24__hoc__["a" /* multiLanguage */])()(Object(__WEBPACK_IMPORTED_MODULE_24__hoc__["b" /* withRedux */])(mapStateToProps,actionToProps)(Object(__WEBPACK_IMPORTED_MODULE_19_react_router__["a" /* withRouter */])(PreviewTrip))));

/***/ }),
/* 1031 */
/***/ (function(module, exports, __webpack_require__) {

var toString = __webpack_require__(74),
    upperFirst = __webpack_require__(1032);

/**
 * Converts the first character of `string` to upper case and the remaining
 * to lower case.
 *
 * @static
 * @memberOf _
 * @since 3.0.0
 * @category String
 * @param {string} [string=''] The string to capitalize.
 * @returns {string} Returns the capitalized string.
 * @example
 *
 * _.capitalize('FRED');
 * // => 'Fred'
 */
function capitalize(string) {
  return upperFirst(toString(string).toLowerCase());
}

module.exports = capitalize;


/***/ }),
/* 1032 */
/***/ (function(module, exports, __webpack_require__) {

var createCaseFirst = __webpack_require__(1033);

/**
 * Converts the first character of `string` to upper case.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to convert.
 * @returns {string} Returns the converted string.
 * @example
 *
 * _.upperFirst('fred');
 * // => 'Fred'
 *
 * _.upperFirst('FRED');
 * // => 'FRED'
 */
var upperFirst = createCaseFirst('toUpperCase');

module.exports = upperFirst;


/***/ }),
/* 1033 */
/***/ (function(module, exports, __webpack_require__) {

var castSlice = __webpack_require__(162),
    hasUnicode = __webpack_require__(99),
    stringToArray = __webpack_require__(163),
    toString = __webpack_require__(74);

/**
 * Creates a function like `_.lowerFirst`.
 *
 * @private
 * @param {string} methodName The name of the `String` case method to use.
 * @returns {Function} Returns the new case function.
 */
function createCaseFirst(methodName) {
  return function(string) {
    string = toString(string);

    var strSymbols = hasUnicode(string)
      ? stringToArray(string)
      : undefined;

    var chr = strSymbols
      ? strSymbols[0]
      : string.charAt(0);

    var trailing = strSymbols
      ? castSlice(strSymbols, 1).join('')
      : string.slice(1);

    return chr[methodName]() + trailing;
  };
}

module.exports = createCaseFirst;


/***/ }),
/* 1034 */
/***/ (function(module, exports, __webpack_require__) {

var baseFlatten = __webpack_require__(264),
    baseOrderBy = __webpack_require__(1035),
    baseRest = __webpack_require__(329),
    isIterateeCall = __webpack_require__(124);

/**
 * Creates an array of elements, sorted in ascending order by the results of
 * running each element in a collection thru each iteratee. This method
 * performs a stable sort, that is, it preserves the original sort order of
 * equal elements. The iteratees are invoked with one argument: (value).
 *
 * @static
 * @memberOf _
 * @since 0.1.0
 * @category Collection
 * @param {Array|Object} collection The collection to iterate over.
 * @param {...(Function|Function[])} [iteratees=[_.identity]]
 *  The iteratees to sort by.
 * @returns {Array} Returns the new sorted array.
 * @example
 *
 * var users = [
 *   { 'user': 'fred',   'age': 48 },
 *   { 'user': 'barney', 'age': 36 },
 *   { 'user': 'fred',   'age': 30 },
 *   { 'user': 'barney', 'age': 34 }
 * ];
 *
 * _.sortBy(users, [function(o) { return o.user; }]);
 * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
 *
 * _.sortBy(users, ['user', 'age']);
 * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
 */
var sortBy = baseRest(function(collection, iteratees) {
  if (collection == null) {
    return [];
  }
  var length = iteratees.length;
  if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
    iteratees = [];
  } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
    iteratees = [iteratees[0]];
  }
  return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
});

module.exports = sortBy;


/***/ }),
/* 1035 */
/***/ (function(module, exports, __webpack_require__) {

var arrayMap = __webpack_require__(69),
    baseGet = __webpack_require__(96),
    baseIteratee = __webpack_require__(36),
    baseMap = __webpack_require__(249),
    baseSortBy = __webpack_require__(1036),
    baseUnary = __webpack_require__(95),
    compareMultiple = __webpack_require__(1037),
    identity = __webpack_require__(98),
    isArray = __webpack_require__(13);

/**
 * The base implementation of `_.orderBy` without param guards.
 *
 * @private
 * @param {Array|Object} collection The collection to iterate over.
 * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
 * @param {string[]} orders The sort orders of `iteratees`.
 * @returns {Array} Returns the new sorted array.
 */
function baseOrderBy(collection, iteratees, orders) {
  if (iteratees.length) {
    iteratees = arrayMap(iteratees, function(iteratee) {
      if (isArray(iteratee)) {
        return function(value) {
          return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
        }
      }
      return iteratee;
    });
  } else {
    iteratees = [identity];
  }

  var index = -1;
  iteratees = arrayMap(iteratees, baseUnary(baseIteratee));

  var result = baseMap(collection, function(value, key, collection) {
    var criteria = arrayMap(iteratees, function(iteratee) {
      return iteratee(value);
    });
    return { 'criteria': criteria, 'index': ++index, 'value': value };
  });

  return baseSortBy(result, function(object, other) {
    return compareMultiple(object, other, orders);
  });
}

module.exports = baseOrderBy;


/***/ }),
/* 1036 */
/***/ (function(module, exports) {

/**
 * The base implementation of `_.sortBy` which uses `comparer` to define the
 * sort order of `array` and replaces criteria objects with their corresponding
 * values.
 *
 * @private
 * @param {Array} array The array to sort.
 * @param {Function} comparer The function to define sort order.
 * @returns {Array} Returns `array`.
 */
function baseSortBy(array, comparer) {
  var length = array.length;

  array.sort(comparer);
  while (length--) {
    array[length] = array[length].value;
  }
  return array;
}

module.exports = baseSortBy;


/***/ }),
/* 1037 */
/***/ (function(module, exports, __webpack_require__) {

var compareAscending = __webpack_require__(1038);

/**
 * Used by `_.orderBy` to compare multiple properties of a value to another
 * and stable sort them.
 *
 * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
 * specify an order of "desc" for descending or "asc" for ascending sort order
 * of corresponding values.
 *
 * @private
 * @param {Object} object The object to compare.
 * @param {Object} other The other object to compare.
 * @param {boolean[]|string[]} orders The order to sort by for each property.
 * @returns {number} Returns the sort order indicator for `object`.
 */
function compareMultiple(object, other, orders) {
  var index = -1,
      objCriteria = object.criteria,
      othCriteria = other.criteria,
      length = objCriteria.length,
      ordersLength = orders.length;

  while (++index < length) {
    var result = compareAscending(objCriteria[index], othCriteria[index]);
    if (result) {
      if (index >= ordersLength) {
        return result;
      }
      var order = orders[index];
      return result * (order == 'desc' ? -1 : 1);
    }
  }
  // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
  // that causes it, under certain circumstances, to provide the same value for
  // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
  // for more details.
  //
  // This also ensures a stable sort in V8 and other engines.
  // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
  return object.index - other.index;
}

module.exports = compareMultiple;


/***/ }),
/* 1038 */
/***/ (function(module, exports, __webpack_require__) {

var isSymbol = __webpack_require__(97);

/**
 * Compares values to sort them in ascending order.
 *
 * @private
 * @param {*} value The value to compare.
 * @param {*} other The other value to compare.
 * @returns {number} Returns the sort order indicator for `value`.
 */
function compareAscending(value, other) {
  if (value !== other) {
    var valIsDefined = value !== undefined,
        valIsNull = value === null,
        valIsReflexive = value === value,
        valIsSymbol = isSymbol(value);

    var othIsDefined = other !== undefined,
        othIsNull = other === null,
        othIsReflexive = other === other,
        othIsSymbol = isSymbol(other);

    if ((!othIsNull && !othIsSymbol && !valIsSymbol && value > other) ||
        (valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol) ||
        (valIsNull && othIsDefined && othIsReflexive) ||
        (!valIsDefined && othIsReflexive) ||
        !valIsReflexive) {
      return 1;
    }
    if ((!valIsNull && !valIsSymbol && !othIsSymbol && value < other) ||
        (othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol) ||
        (othIsNull && valIsDefined && valIsReflexive) ||
        (!othIsDefined && valIsReflexive) ||
        !othIsReflexive) {
      return -1;
    }
  }
  return 0;
}

module.exports = compareAscending;


/***/ }),
/* 1039 */
/***/ (function(module, exports, __webpack_require__) {

var baseIteratee = __webpack_require__(36),
    baseUniq = __webpack_require__(1040);

/**
 * This method is like `_.uniq` except that it accepts `iteratee` which is
 * invoked for each element in `array` to generate the criterion by which
 * uniqueness is computed. The order of result values is determined by the
 * order they occur in the array. The iteratee is invoked with one argument:
 * (value).
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category Array
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 * @example
 *
 * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
 * // => [2.1, 1.2]
 *
 * // The `_.property` iteratee shorthand.
 * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
 * // => [{ 'x': 1 }, { 'x': 2 }]
 */
function uniqBy(array, iteratee) {
  return (array && array.length) ? baseUniq(array, baseIteratee(iteratee, 2)) : [];
}

module.exports = uniqBy;


/***/ }),
/* 1040 */
/***/ (function(module, exports, __webpack_require__) {

var SetCache = __webpack_require__(234),
    arrayIncludes = __webpack_require__(1041),
    arrayIncludesWith = __webpack_require__(1042),
    cacheHas = __webpack_require__(235),
    createSet = __webpack_require__(1043),
    setToArray = __webpack_require__(152);

/** Used as the size to enable large array optimizations. */
var LARGE_ARRAY_SIZE = 200;

/**
 * The base implementation of `_.uniqBy` without support for iteratee shorthands.
 *
 * @private
 * @param {Array} array The array to inspect.
 * @param {Function} [iteratee] The iteratee invoked per element.
 * @param {Function} [comparator] The comparator invoked per element.
 * @returns {Array} Returns the new duplicate free array.
 */
function baseUniq(array, iteratee, comparator) {
  var index = -1,
      includes = arrayIncludes,
      length = array.length,
      isCommon = true,
      result = [],
      seen = result;

  if (comparator) {
    isCommon = false;
    includes = arrayIncludesWith;
  }
  else if (length >= LARGE_ARRAY_SIZE) {
    var set = iteratee ? null : createSet(array);
    if (set) {
      return setToArray(set);
    }
    isCommon = false;
    includes = cacheHas;
    seen = new SetCache;
  }
  else {
    seen = iteratee ? [] : result;
  }
  outer:
  while (++index < length) {
    var value = array[index],
        computed = iteratee ? iteratee(value) : value;

    value = (comparator || value !== 0) ? value : 0;
    if (isCommon && computed === computed) {
      var seenIndex = seen.length;
      while (seenIndex--) {
        if (seen[seenIndex] === computed) {
          continue outer;
        }
      }
      if (iteratee) {
        seen.push(computed);
      }
      result.push(value);
    }
    else if (!includes(seen, computed, comparator)) {
      if (seen !== result) {
        seen.push(computed);
      }
      result.push(value);
    }
  }
  return result;
}

module.exports = baseUniq;


/***/ }),
/* 1041 */
/***/ (function(module, exports, __webpack_require__) {

var baseIndexOf = __webpack_require__(257);

/**
 * A specialized version of `_.includes` for arrays without support for
 * specifying an index to search from.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludes(array, value) {
  var length = array == null ? 0 : array.length;
  return !!length && baseIndexOf(array, value, 0) > -1;
}

module.exports = arrayIncludes;


/***/ }),
/* 1042 */
/***/ (function(module, exports) {

/**
 * This function is like `arrayIncludes` except that it accepts a comparator.
 *
 * @private
 * @param {Array} [array] The array to inspect.
 * @param {*} target The value to search for.
 * @param {Function} comparator The comparator invoked per element.
 * @returns {boolean} Returns `true` if `target` is found, else `false`.
 */
function arrayIncludesWith(array, value, comparator) {
  var index = -1,
      length = array == null ? 0 : array.length;

  while (++index < length) {
    if (comparator(value, array[index])) {
      return true;
    }
  }
  return false;
}

module.exports = arrayIncludesWith;


/***/ }),
/* 1043 */
/***/ (function(module, exports, __webpack_require__) {

var Set = __webpack_require__(242),
    noop = __webpack_require__(1044),
    setToArray = __webpack_require__(152);

/** Used as references for various `Number` constants. */
var INFINITY = 1 / 0;

/**
 * Creates a set object of `values`.
 *
 * @private
 * @param {Array} values The values to add to the set.
 * @returns {Object} Returns the new set.
 */
var createSet = !(Set && (1 / setToArray(new Set([,-0]))[1]) == INFINITY) ? noop : function(values) {
  return new Set(values);
};

module.exports = createSet;


/***/ }),
/* 1044 */
/***/ (function(module, exports) {

/**
 * This method returns `undefined`.
 *
 * @static
 * @memberOf _
 * @since 2.3.0
 * @category Util
 * @example
 *
 * _.times(2, _.noop);
 * // => [undefined, undefined]
 */
function noop() {
  // No operation performed.
}

module.exports = noop;


/***/ }),
/* 1045 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__MemoryRouter__ = __webpack_require__(221);
/* unused harmony reexport MemoryRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__Prompt__ = __webpack_require__(223);
/* unused harmony reexport Prompt */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__Redirect__ = __webpack_require__(224);
/* unused harmony reexport Redirect */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__Route__ = __webpack_require__(144);
/* unused harmony reexport Route */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Router__ = __webpack_require__(112);
/* unused harmony reexport Router */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__StaticRouter__ = __webpack_require__(225);
/* unused harmony reexport StaticRouter */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Switch__ = __webpack_require__(226);
/* unused harmony reexport Switch */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__generatePath__ = __webpack_require__(146);
/* unused harmony reexport generatePath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__matchPath__ = __webpack_require__(113);
/* unused harmony reexport matchPath */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__withRouter__ = __webpack_require__(227);
/* harmony reexport (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return __WEBPACK_IMPORTED_MODULE_9__withRouter__["a"]; });





















/***/ }),
/* 1046 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Field$1; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return ReactFinalForm; });
/* unused harmony export version */
/* unused harmony export FormSpy */
/* unused harmony export withReactFinalForm */
/* unused harmony export ReactFinalFormContext */
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__ = __webpack_require__(67);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__ = __webpack_require__(90);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__ = __webpack_require__(141);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_final_form__ = __webpack_require__(369);






//      
function diffSubscription (a, b, keys) {
  if (a) {
    if (b) {
      // $FlowFixMe
      return keys.some(function (key) {
        return a[key] !== b[key];
      });
    } else {
      return true;
    }
  } else {
    return !!b;
  }
}

// children render function, or component prop

function renderComponent(props, name) {
  var render = props.render,
      children = props.children,
      component = props.component,
      rest = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["render", "children", "component"]);

  if (component) {
    return Object(__WEBPACK_IMPORTED_MODULE_3_react__["createElement"])(component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      children: children,
      render: render
    }));
  }

  if (render) {
    return render(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, {
      children: children
    })); // inject children back in
  }

  if (typeof children !== 'function') {
    // istanbul ignore next
    if (false) {
      console.error("Warning: Must specify either a render prop, a render function as children, or a component prop to " + name);
    }

    return null; // warning will alert developer to their mistake
  }

  return children(rest);
}

//      
var isReactNative = typeof window !== 'undefined' && window.navigator && window.navigator.product && window.navigator.product === 'ReactNative';

//      
var getSelectedValues = function getSelectedValues(options) {
  var result = [];

  if (options) {
    for (var index = 0; index < options.length; index++) {
      var option = options[index];

      if (option.selected) {
        result.push(option.value);
      }
    }
  }

  return result;
};

var getValue = function getValue(event, currentValue, valueProp, isReactNative) {
  if (!isReactNative && event.nativeEvent && event.nativeEvent.text !== undefined) {
    return event.nativeEvent.text;
  }

  if (isReactNative && event.nativeEvent) {
    return event.nativeEvent.text;
  }

  var detypedEvent = event;
  var _detypedEvent$target = detypedEvent.target,
      type = _detypedEvent$target.type,
      value = _detypedEvent$target.value,
      checked = _detypedEvent$target.checked;

  switch (type) {
    case 'checkbox':
      if (valueProp !== undefined) {
        // we are maintaining an array, not just a boolean
        if (checked) {
          // add value to current array value
          return Array.isArray(currentValue) ? currentValue.concat(valueProp) : [valueProp];
        } else {
          // remove value from current array value
          if (!Array.isArray(currentValue)) {
            return currentValue;
          }

          var index = currentValue.indexOf(valueProp);

          if (index < 0) {
            return currentValue;
          } else {
            return currentValue.slice(0, index).concat(currentValue.slice(index + 1));
          }
        }
      } else {
        // it's just a boolean
        return !!checked;
      }

    case 'select-multiple':
      return getSelectedValues(event.target.options);

    default:
      return value;
  }
};

var ReactFinalFormContext = Object(__WEBPACK_IMPORTED_MODULE_3_react__["createContext"])(null);
var getDisplayName = function getDisplayName(Component) {
  var displayName = Component.displayName || Component.name || 'Component';
  return "ReactFinalForm(" + displayName + ")";
};
var withReactFinalForm = function withReactFinalForm(Component$1) {
  var _class, _temp;

  return _temp = _class =
  /*#__PURE__*/
  function (_React$Component) {
    Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(_class, _React$Component);

    function _class() {
      return _React$Component.apply(this, arguments) || this;
    }

    var _proto = _class.prototype;

    _proto.render = function render() {
      var _this = this;

      return Object(__WEBPACK_IMPORTED_MODULE_3_react__["createElement"])(ReactFinalFormContext.Consumer, {
        children: function children(reactFinalForm) {
          return Object(__WEBPACK_IMPORTED_MODULE_3_react__["createElement"])(Component$1, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
            reactFinalForm: reactFinalForm
          }, _this.props));
        }
      });
    };

    return _class;
  }(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]), _class.displayName = getDisplayName(Component$1), _temp;
};

var all = __WEBPACK_IMPORTED_MODULE_4_final_form__["d" /* fieldSubscriptionItems */].reduce(function (result, key) {
  result[key] = true;
  return result;
}, {});

var Field =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(Field, _React$Component);

  function Field(_props) {
    var _this;

    _this = _React$Component.call(this, _props) || this;

    _this.subscribe = function (_ref, listener) {
      var defaultValue = _ref.defaultValue,
          initialValue = _ref.initialValue,
          isEqual = _ref.isEqual,
          name = _ref.name,
          subscription = _ref.subscription,
          validateFields = _ref.validateFields;
      _this.unsubscribe = _this.props.reactFinalForm.registerField(name, listener, subscription || all, {
        defaultValue: defaultValue,
        getValidator: function getValidator() {
          return _this.props.validate;
        },
        initialValue: initialValue,
        isEqual: isEqual,
        validateFields: validateFields
      });
    };

    _this.notify = function (state) {
      return _this.setState({
        state: state
      });
    };

    _this.handlers = {
      onBlur: function onBlur(event) {
        var state = _this.state.state; // this is to appease the Flow gods
        // istanbul ignore next

        if (state) {
          var _this$props = _this.props,
              format = _this$props.format,
              formatOnBlur = _this$props.formatOnBlur;
          state.blur();

          if (format && formatOnBlur) {
            state.change(format(state.value, state.name));
          }
        }
      },
      onChange: function onChange(event) {
        var _this$props2 = _this.props,
            parse = _this$props2.parse,
            _value = _this$props2.value; // istanbul ignore next

        if (false) {
          var targetType = event.target.type;
          var props = _this.props;
          var unknown = ~['checkbox', 'radio', 'select-multiple'].indexOf(targetType) && !props.type;
          var type = targetType === 'select-multiple' ? 'select' : targetType;

          var _ref2 = targetType === 'select-multiple' ? _this.state.state || {} : props,
              _value2 = _ref2.value;

          if (unknown) {
            console.error("Warning: You must pass `type=\"" + type + "\"` prop to your Field(" + props.name + ") component.\n" + ("Without it we don't know how to unpack your `value` prop - " + (Array.isArray(_value2) ? "[" + _value2 + "]" : "\"" + _value2 + "\"") + "."));
          }
        }

        var value = event && event.target ? getValue(event, _this.state.state && _this.state.state.value, _value, isReactNative) : event;
        _this.state.state && _this.state.state.change(parse ? parse(value, _this.props.name) : value);
      },
      onFocus: function onFocus(event) {
        _this.state.state && _this.state.state.focus();
      }
    };
    var initialState; // istanbul ignore next

    if (false) {
      console.error('Warning: Field must be used inside of a ReactFinalForm component');
    }

    if (_this.props.reactFinalForm) {
      // avoid error, warning will alert developer to their mistake
      _this.subscribe(_props, function (state) {
        if (initialState) {
          _this.notify(state);
        } else {
          initialState = state;
        }
      });
    }

    _this.state = {
      state: initialState
    };
    return _this;
  }

  var _proto = Field.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this$props3 = this.props,
        name = _this$props3.name,
        subscription = _this$props3.subscription;

    if (prevProps.name !== name || diffSubscription(prevProps.subscription, subscription, __WEBPACK_IMPORTED_MODULE_4_final_form__["d" /* fieldSubscriptionItems */])) {
      if (this.props.reactFinalForm) {
        // avoid error, warning will alert developer to their mistake
        this.unsubscribe();
        this.subscribe(this.props, this.notify);
      }
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.unsubscribe();
  };

  _proto.render = function render() {
    var _this$props4 = this.props,
        allowNull = _this$props4.allowNull,
        component = _this$props4.component,
        children = _this$props4.children,
        format = _this$props4.format,
        formatOnBlur = _this$props4.formatOnBlur,
        parse = _this$props4.parse,
        isEqual = _this$props4.isEqual,
        name = _this$props4.name,
        subscription = _this$props4.subscription,
        validate = _this$props4.validate,
        validateFields = _this$props4.validateFields,
        reactFinalForm = _this$props4.reactFinalForm,
        _value = _this$props4.value,
        rest = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props4, ["allowNull", "component", "children", "format", "formatOnBlur", "parse", "isEqual", "name", "subscription", "validate", "validateFields", "reactFinalForm", "value"]);

    var _ref3 = this.state.state || {},
        blur = _ref3.blur,
        change = _ref3.change,
        focus = _ref3.focus,
        value = _ref3.value,
        ignoreName = _ref3.name,
        otherState = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_ref3, ["blur", "change", "focus", "value", "name"]);

    var meta = {
      // this is to appease the Flow gods
      active: otherState.active,
      data: otherState.data,
      dirty: otherState.dirty,
      dirtySinceLastSubmit: otherState.dirtySinceLastSubmit,
      error: otherState.error,
      initial: otherState.initial,
      invalid: otherState.invalid,
      modified: otherState.modified,
      pristine: otherState.pristine,
      submitError: otherState.submitError,
      submitFailed: otherState.submitFailed,
      submitSucceeded: otherState.submitSucceeded,
      submitting: otherState.submitting,
      touched: otherState.touched,
      valid: otherState.valid,
      visited: otherState.visited
    };

    if (formatOnBlur) {
      value = Field.defaultProps.format(value, name);
    } else if (format) {
      value = format(value, name);
    }

    if (value === null && !allowNull) {
      value = '';
    }

    var input = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
      name: name,
      value: value
    }, this.handlers);

    if (rest.type === 'checkbox') {
      if (_value === undefined) {
        input.checked = !!value;
      } else {
        input.checked = !!(Array.isArray(value) && ~value.indexOf(_value));
        input.value = _value;
      }
    } else if (rest.type === 'radio') {
      input.checked = value === _value;
      input.value = _value;
    } else if (component === 'select' && rest.multiple) {
      input.value = input.value || [];
    }

    if (typeof children === 'function') {
      return children(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({
        input: input,
        meta: meta
      }, rest));
    }

    if (typeof component === 'string') {
      // ignore meta, combine input with any other props
      return Object(__WEBPACK_IMPORTED_MODULE_3_react__["createElement"])(component, Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, input, {
        children: children
      }, rest));
    }

    var renderProps = {
      input: input,
      meta: meta // assign to force Flow check

    };
    return renderComponent(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, renderProps, {
      children: children,
      component: component
    }, rest), "Field(" + name + ")");
  };

  return Field;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

Field.defaultProps = {
  format: function format(value, name) {
    return value === undefined ? '' : value;
  },
  parse: function parse(value, name) {
    return value === '' ? undefined : value;
  }
};
var Field$1 = withReactFinalForm(Field);

//      
var shallowEqual = function shallowEqual(a, b) {
  if (a === b) {
    return true;
  }

  if (typeof a !== 'object' || !a || typeof b !== 'object' || !b) {
    return false;
  }

  var keysA = Object.keys(a);
  var keysB = Object.keys(b);

  if (keysA.length !== keysB.length) {
    return false;
  }

  var bHasOwnProperty = Object.prototype.hasOwnProperty.bind(b);

  for (var idx = 0; idx < keysA.length; idx++) {
    var key = keysA[idx];

    if (!bHasOwnProperty(key) || a[key] !== b[key]) {
      return false;
    }
  }

  return true;
};

//      
var isSyntheticEvent = function isSyntheticEvent(candidate) {
  return !!(candidate && typeof candidate.stopPropagation === 'function');
};

var version = '4.1.0';
var versions = {
  'final-form': __WEBPACK_IMPORTED_MODULE_4_final_form__["f" /* version */],
  'react-final-form': version
};
var all$1 = __WEBPACK_IMPORTED_MODULE_4_final_form__["e" /* formSubscriptionItems */].reduce(function (result, key) {
  result[key] = true;
  return result;
}, {});

var ReactFinalForm =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(ReactFinalForm, _React$Component);

  function ReactFinalForm(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.notify = function (state) {
      if (_this.mounted) {
        _this.setState({
          state: state
        });
      }

      _this.mounted = true;
    };

    _this.handleSubmit = function (event) {
      if (event) {
        // sometimes not true, e.g. React Native
        if (typeof event.preventDefault === 'function') {
          event.preventDefault();
        }

        if (typeof event.stopPropagation === 'function') {
          // prevent any outer forms from receiving the event too
          event.stopPropagation();
        }
      }

      return _this.form.submit();
    };

    var children = props.children,
        component = props.component,
        render = props.render,
        subscription = props.subscription,
        decorators = props.decorators,
        rest = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(props, ["children", "component", "render", "subscription", "decorators"]);

    var config = rest;
    _this.mounted = false;

    try {
      _this.form = Object(__WEBPACK_IMPORTED_MODULE_4_final_form__["c" /* createForm */])(config);
    } catch (e) {
      // istanbul ignore next
      if (false) {
        console.error("Warning: " + e.message);
      }
    }

    _this.unsubscriptions = [];

    if (_this.form) {
      // set initial state
      var initialState = {};

      _this.form.subscribe(function (state) {
        initialState = state;
      }, subscription || all$1)();

      _this.state = {
        state: initialState
      };
    }

    if (decorators) {
      decorators.forEach(function (decorator) {
        _this.unsubscriptions.push(decorator(_this.form));
      });
    }

    return _this;
  }

  var _proto = ReactFinalForm.prototype;

  _proto.componentWillMount = function componentWillMount() {
    if (this.form) {
      this.form.pauseValidation();
    }
  };

  _proto.componentDidMount = function componentDidMount() {
    if (this.form) {
      this.unsubscriptions.push(this.form.subscribe(this.notify, this.props.subscription || all$1));
      this.form.resumeValidation();
    }
  };

  _proto.componentWillUpdate = function componentWillUpdate() {
    // istanbul ignore next
    if (this.form) {
      this.resumeValidation = this.resumeValidation || !this.form.isValidationPaused();
      this.form.pauseValidation();
    }
  };

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var _this2 = this;

    // istanbul ignore next
    if (this.form && this.resumeValidation) {
      this.form.resumeValidation();
    }

    if (this.props.initialValues && !(this.props.initialValuesEqual || shallowEqual)(prevProps.initialValues, this.props.initialValues)) {
      this.form.initialize(this.props.initialValues);
    }

    __WEBPACK_IMPORTED_MODULE_4_final_form__["b" /* configOptions */].forEach(function (key) {
      if (key === 'initialValues' || prevProps[key] === _this2.props[key]) {
        return;
      }

      _this2.form.setConfig(key, _this2.props[key]);
    }); // istanbul ignore next

    if (false) {
      if (!shallowEqual(prevProps.decorators, this.props.decorators)) {
        console.error('Warning: Form decorators should not change from one render to the next as new values will be ignored');
      }

      if (!shallowEqual(prevProps.subscription, this.props.subscription)) {
        console.error('Warning: Form subscription should not change from one render to the next as new values will be ignored');
      }
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.unsubscriptions.forEach(function (unsubscribe) {
      return unsubscribe();
    });
  };

  _proto.render = function render() {
    var _this3 = this;

    // remove config props
    var _this$props = this.props,
        debug = _this$props.debug,
        initialValues = _this$props.initialValues,
        mutators = _this$props.mutators,
        onSubmit = _this$props.onSubmit,
        subscription = _this$props.subscription,
        validate = _this$props.validate,
        validateOnBlur = _this$props.validateOnBlur,
        props = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["debug", "initialValues", "mutators", "onSubmit", "subscription", "validate", "validateOnBlur"]);

    var renderProps = Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, this.state ? this.state.state : {}, {
      batch: this.form && function (fn) {
        // istanbul ignore next
        if (false) {
          console.error("Warning: As of React Final Form v3.3.0, props.batch() is deprecated and will be removed in the next major version of React Final Form. Use: props.form.batch() instead. Check your ReactFinalForm render prop.");
        }

        return _this3.form.batch(fn);
      },
      blur: this.form && function (name) {
        // istanbul ignore next
        if (false) {
          console.error("Warning: As of React Final Form v3.3.0, props.blur() is deprecated and will be removed in the next major version of React Final Form. Use: props.form.blur() instead. Check your ReactFinalForm render prop.");
        }

        return _this3.form.blur(name);
      },
      change: this.form && function (name, value) {
        // istanbul ignore next
        if (false) {
          console.error("Warning: As of React Final Form v3.3.0, props.change() is deprecated and will be removed in the next major version of React Final Form. Use: props.form.change() instead. Check your ReactFinalForm render prop.");
        }

        return _this3.form.change(name, value);
      },
      focus: this.form && function (name) {
        // istanbul ignore next
        if (false) {
          console.error("Warning: As of React Final Form v3.3.0, props.focus() is deprecated and will be removed in the next major version of React Final Form. Use: props.form.focus() instead. Check your ReactFinalForm render prop.");
        }

        return _this3.form.focus(name);
      },
      form: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, this.form, {
        reset: function reset(eventOrValues) {
          if (isSyntheticEvent(eventOrValues)) {
            // it's a React SyntheticEvent, call reset with no arguments
            _this3.form.reset();
          } else {
            _this3.form.reset(eventOrValues);
          }
        }
      }),
      handleSubmit: this.handleSubmit,
      initialize: this.form && function (values) {
        // istanbul ignore next
        if (false) {
          console.error("Warning: As of React Final Form v3.3.0, props.initialize() is deprecated and will be removed in the next major version of React Final Form. Use: props.form.initialize() instead. Check your ReactFinalForm render prop.");
        }

        return _this3.form.initialize(values);
      },
      mutators: this.form && Object.keys(this.form.mutators).reduce(function (result, key) {
        result[key] = function () {
          var _this3$form$mutators;

          (_this3$form$mutators = _this3.form.mutators)[key].apply(_this3$form$mutators, arguments); // istanbul ignore next


          if (false) {
            console.error("Warning: As of React Final Form v3.3.0, props.mutators is deprecated and will be removed in the next major version of React Final Form. Use: props.form.mutators instead. Check your ReactFinalForm render prop.");
          }
        };

        return result;
      }, {}),
      reset: this.form && function (values) {
        // istanbul ignore next
        if (false) {
          console.error("Warning: As of React Final Form v3.3.0, props.reset() is deprecated and will be removed in the next major version of React Final Form. Use: props.form.reset() instead. Check your ReactFinalForm render prop.");
        }

        return _this3.form.reset(values);
      }
    });

    return Object(__WEBPACK_IMPORTED_MODULE_3_react__["createElement"])(ReactFinalFormContext.Provider, {
      value: this.form
    }, renderComponent(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, props, renderProps, {
      __versions: versions
    }), 'ReactFinalForm'));
  };

  return ReactFinalForm;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

var FormSpy =
/*#__PURE__*/
function (_React$Component) {
  Object(__WEBPACK_IMPORTED_MODULE_2__babel_runtime_helpers_esm_inheritsLoose__["a" /* default */])(FormSpy, _React$Component);

  function FormSpy(props) {
    var _this;

    _this = _React$Component.call(this, props) || this;

    _this.subscribe = function (_ref, listener) {
      var subscription = _ref.subscription;
      _this.unsubscribe = _this.props.reactFinalForm.subscribe(listener, subscription || all$1);
    };

    _this.notify = function (state) {
      _this.setState({
        state: state
      });

      if (_this.props.onChange) {
        _this.props.onChange(state);
      }
    };

    var initialState; // istanbul ignore next

    if (false) {
      console.error('Warning: FormSpy must be used inside of a ReactFinalForm component');
    }

    if (_this.props.reactFinalForm) {
      // avoid error, warning will alert developer to their mistake
      _this.subscribe(props, function (state) {
        if (initialState) {
          _this.notify(state);
        } else {
          initialState = state;

          if (props.onChange) {
            props.onChange(state);
          }
        }
      });
    }

    if (initialState) {
      _this.state = {
        state: initialState
      };
    }

    return _this;
  }

  var _proto = FormSpy.prototype;

  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
    var subscription = this.props.subscription;

    if (diffSubscription(prevProps.subscription, subscription, __WEBPACK_IMPORTED_MODULE_4_final_form__["e" /* formSubscriptionItems */])) {
      if (this.props.reactFinalForm) {
        // avoid error, warning will alert developer to their mistake
        this.unsubscribe();
        this.subscribe(this.props, this.notify);
      }
    }
  };

  _proto.componentWillUnmount = function componentWillUnmount() {
    this.unsubscribe();
  };

  _proto.render = function render() {
    var _this$props = this.props,
        onChange = _this$props.onChange,
        reactFinalForm = _this$props.reactFinalForm,
        rest = Object(__WEBPACK_IMPORTED_MODULE_1__babel_runtime_helpers_esm_objectWithoutPropertiesLoose__["a" /* default */])(_this$props, ["onChange", "reactFinalForm"]);

    var renderProps = {
      batch: reactFinalForm && function (fn) {
        // istanbul ignore next
        if (false) {
          console.error("Warning: As of React Final Form v3.3.0, props.batch() is deprecated and will be removed in the next major version of React Final Form. Use: props.form.batch() instead. Check your FormSpy render prop.");
        }

        return reactFinalForm.batch(fn);
      },
      blur: reactFinalForm && function (name) {
        // istanbul ignore next
        if (false) {
          console.error("Warning: As of React Final Form v3.3.0, props.blur() is deprecated and will be removed in the next major version of React Final Form. Use: props.form.blur() instead. Check your FormSpy render prop.");
        }

        return reactFinalForm.blur(name);
      },
      change: reactFinalForm && function (name, value) {
        // istanbul ignore next
        if (false) {
          console.error("Warning: As of React Final Form v3.3.0, props.change() is deprecated and will be removed in the next major version of React Final Form. Use: props.form.change() instead. Check your FormSpy render prop.");
        }

        return reactFinalForm.change(name, value);
      },
      focus: reactFinalForm && function (name) {
        // istanbul ignore next
        if (false) {
          console.error("Warning: As of React Final Form v3.3.0, props.focus() is deprecated and will be removed in the next major version of React Final Form. Use: props.form.focus() instead. Check your FormSpy render prop.");
        }

        return reactFinalForm.focus(name);
      },
      form: Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, reactFinalForm, {
        reset: function reset(eventOrValues) {
          if (isSyntheticEvent(eventOrValues)) {
            // it's a React SyntheticEvent, call reset with no arguments
            reactFinalForm.reset();
          } else {
            reactFinalForm.reset(eventOrValues);
          }
        }
      }),
      initialize: reactFinalForm && function (values) {
        // istanbul ignore next
        if (false) {
          console.error("Warning: As of React Final Form v3.3.0, props.initialize() is deprecated and will be removed in the next major version of React Final Form. Use: props.form.initialize() instead. Check your FormSpy render prop.");
        }

        return reactFinalForm.initialize(values);
      },
      mutators: reactFinalForm && Object.keys(reactFinalForm.mutators).reduce(function (result, key) {
        result[key] = function () {
          var _reactFinalForm$mutat;

          (_reactFinalForm$mutat = reactFinalForm.mutators)[key].apply(_reactFinalForm$mutat, arguments); // istanbul ignore next


          if (false) {
            console.error("Warning: As of React Final Form v3.3.0, props.mutators is deprecated and will be removed in the next major version of React Final Form. Use: props.form.mutators instead. Check your FormSpy render prop.");
          }
        };

        return result;
      }, {}),
      reset: reactFinalForm && function (values) {
        // istanbul ignore next
        if (false) {
          console.error("Warning: As of React Final Form v3.3.0, props.reset() is deprecated and will be removed in the next major version of React Final Form. Use: props.form.reset() instead. Check your FormSpy render prop.");
        }

        return reactFinalForm.reset(values);
      }
    };
    return onChange ? null : renderComponent(Object(__WEBPACK_IMPORTED_MODULE_0__babel_runtime_helpers_esm_extends__["a" /* default */])({}, rest, this.state ? this.state.state : {}, renderProps), 'FormSpy');
  };

  return FormSpy;
}(__WEBPACK_IMPORTED_MODULE_3_react__["Component"]);

var FormSpy$1 = withReactFinalForm(FormSpy);

//




/***/ }),
/* 1047 */
/***/ (function(module, exports, __webpack_require__) {

module.exports =
/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId]) {
/******/ 			return installedModules[moduleId].exports;
/******/ 		}
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			i: moduleId,
/******/ 			l: false,
/******/ 			exports: {}
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.l = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// identity function for calling harmony imports with the correct context
/******/ 	__webpack_require__.i = function(value) { return value; };
/******/
/******/ 	// define getter function for harmony exports
/******/ 	__webpack_require__.d = function(exports, name, getter) {
/******/ 		if(!__webpack_require__.o(exports, name)) {
/******/ 			Object.defineProperty(exports, name, {
/******/ 				configurable: false,
/******/ 				enumerable: true,
/******/ 				get: getter
/******/ 			});
/******/ 		}
/******/ 	};
/******/
/******/ 	// getDefaultExport function for compatibility with non-harmony modules
/******/ 	__webpack_require__.n = function(module) {
/******/ 		var getter = module && module.__esModule ?
/******/ 			function getDefault() { return module['default']; } :
/******/ 			function getModuleExports() { return module; };
/******/ 		__webpack_require__.d(getter, 'a', getter);
/******/ 		return getter;
/******/ 	};
/******/
/******/ 	// Object.prototype.hasOwnProperty.call
/******/ 	__webpack_require__.o = function(object, property) { return Object.prototype.hasOwnProperty.call(object, property); };
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(__webpack_require__.s = 8);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ (function(module, exports) {

// shim for using process in browser
var process = module.exports = {};

// cached from whatever global is present so that test runners that stub it
// don't break things.  But we need to wrap it in a try catch in case it is
// wrapped in strict mode code which doesn't define any globals.  It's inside a
// function because try/catches deoptimize in certain engines.

var cachedSetTimeout;
var cachedClearTimeout;

function defaultSetTimout() {
    throw new Error('setTimeout has not been defined');
}
function defaultClearTimeout () {
    throw new Error('clearTimeout has not been defined');
}
(function () {
    try {
        if (typeof setTimeout === 'function') {
            cachedSetTimeout = setTimeout;
        } else {
            cachedSetTimeout = defaultSetTimout;
        }
    } catch (e) {
        cachedSetTimeout = defaultSetTimout;
    }
    try {
        if (typeof clearTimeout === 'function') {
            cachedClearTimeout = clearTimeout;
        } else {
            cachedClearTimeout = defaultClearTimeout;
        }
    } catch (e) {
        cachedClearTimeout = defaultClearTimeout;
    }
} ())
function runTimeout(fun) {
    if (cachedSetTimeout === setTimeout) {
        //normal enviroments in sane situations
        return setTimeout(fun, 0);
    }
    // if setTimeout wasn't available but was latter defined
    if ((cachedSetTimeout === defaultSetTimout || !cachedSetTimeout) && setTimeout) {
        cachedSetTimeout = setTimeout;
        return setTimeout(fun, 0);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedSetTimeout(fun, 0);
    } catch(e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't trust the global object when called normally
            return cachedSetTimeout.call(null, fun, 0);
        } catch(e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error
            return cachedSetTimeout.call(this, fun, 0);
        }
    }


}
function runClearTimeout(marker) {
    if (cachedClearTimeout === clearTimeout) {
        //normal enviroments in sane situations
        return clearTimeout(marker);
    }
    // if clearTimeout wasn't available but was latter defined
    if ((cachedClearTimeout === defaultClearTimeout || !cachedClearTimeout) && clearTimeout) {
        cachedClearTimeout = clearTimeout;
        return clearTimeout(marker);
    }
    try {
        // when when somebody has screwed with setTimeout but no I.E. maddness
        return cachedClearTimeout(marker);
    } catch (e){
        try {
            // When we are in I.E. but the script has been evaled so I.E. doesn't  trust the global object when called normally
            return cachedClearTimeout.call(null, marker);
        } catch (e){
            // same as above but when it's a version of I.E. that must have the global object for 'this', hopfully our context correct otherwise it will throw a global error.
            // Some versions of I.E. have different rules for clearTimeout vs setTimeout
            return cachedClearTimeout.call(this, marker);
        }
    }



}
var queue = [];
var draining = false;
var currentQueue;
var queueIndex = -1;

function cleanUpNextTick() {
    if (!draining || !currentQueue) {
        return;
    }
    draining = false;
    if (currentQueue.length) {
        queue = currentQueue.concat(queue);
    } else {
        queueIndex = -1;
    }
    if (queue.length) {
        drainQueue();
    }
}

function drainQueue() {
    if (draining) {
        return;
    }
    var timeout = runTimeout(cleanUpNextTick);
    draining = true;

    var len = queue.length;
    while(len) {
        currentQueue = queue;
        queue = [];
        while (++queueIndex < len) {
            if (currentQueue) {
                currentQueue[queueIndex].run();
            }
        }
        queueIndex = -1;
        len = queue.length;
    }
    currentQueue = null;
    draining = false;
    runClearTimeout(timeout);
}

process.nextTick = function (fun) {
    var args = new Array(arguments.length - 1);
    if (arguments.length > 1) {
        for (var i = 1; i < arguments.length; i++) {
            args[i - 1] = arguments[i];
        }
    }
    queue.push(new Item(fun, args));
    if (queue.length === 1 && !draining) {
        runTimeout(drainQueue);
    }
};

// v8 likes predictible objects
function Item(fun, array) {
    this.fun = fun;
    this.array = array;
}
Item.prototype.run = function () {
    this.fun.apply(null, this.array);
};
process.title = 'browser';
process.browser = true;
process.env = {};
process.argv = [];
process.version = ''; // empty string to avoid regexp issues
process.versions = {};

function noop() {}

process.on = noop;
process.addListener = noop;
process.once = noop;
process.off = noop;
process.removeListener = noop;
process.removeAllListeners = noop;
process.emit = noop;
process.prependListener = noop;
process.prependOnceListener = noop;

process.listeners = function (name) { return [] }

process.binding = function (name) {
    throw new Error('process.binding is not supported');
};

process.cwd = function () { return '/' };
process.chdir = function (dir) {
    throw new Error('process.chdir is not supported');
};
process.umask = function() { return 0; };


/***/ }),
/* 1 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */

function makeEmptyFunction(arg) {
  return function () {
    return arg;
  };
}

/**
 * This function accepts and discards inputs; it has no side effects. This is
 * primarily useful idiomatically for overridable function endpoints which
 * always need to be callable, since JS lacks a null-call idiom ala Cocoa.
 */
var emptyFunction = function emptyFunction() {};

emptyFunction.thatReturns = makeEmptyFunction;
emptyFunction.thatReturnsFalse = makeEmptyFunction(false);
emptyFunction.thatReturnsTrue = makeEmptyFunction(true);
emptyFunction.thatReturnsNull = makeEmptyFunction(null);
emptyFunction.thatReturnsThis = function () {
  return this;
};
emptyFunction.thatReturnsArgument = function (arg) {
  return arg;
};

module.exports = emptyFunction;

/***/ }),
/* 2 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments
 * to provide information about what broke and what you were
 * expecting.
 *
 * The invariant message will be stripped in production, but the invariant
 * will remain to ensure logic does not differ in production.
 */

var validateFormat = function validateFormat(format) {};

if (process.env.NODE_ENV !== 'production') {
  validateFormat = function validateFormat(format) {
    if (format === undefined) {
      throw new Error('invariant requires an error message argument');
    }
  };
}

function invariant(condition, format, a, b, c, d, e, f) {
  validateFormat(format);

  if (!condition) {
    var error;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      var args = [a, b, c, d, e, f];
      var argIndex = 0;
      error = new Error(format.replace(/%s/g, function () {
        return args[argIndex++];
      }));
      error.name = 'Invariant Violation';
    }

    error.framesToPop = 1; // we don't care about invariant's own frame
    throw error;
  }
}

module.exports = invariant;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 3 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

module.exports = ReactPropTypesSecret;


/***/ }),
/* 4 */
/***/ (function(module, exports) {

module.exports = __webpack_require__(1048);

/***/ }),
/* 5 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyFunction = __webpack_require__(1);

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var warning = emptyFunction;

if (process.env.NODE_ENV !== 'production') {
  var printWarning = function printWarning(format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function warning(condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }

    if (format.indexOf('Failed Composite propType: ') === 0) {
      return; // Ignore CompositeComponent proptype check.
    }

    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = warning;
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 6 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(13);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var propTypes = {
    className: _propTypes2.default.string,
    onloadCallbackName: _propTypes2.default.string,
    elementID: _propTypes2.default.string,
    onloadCallback: _propTypes2.default.func,
    verifyCallback: _propTypes2.default.func,
    expiredCallback: _propTypes2.default.func,
    render: _propTypes2.default.string,
    sitekey: _propTypes2.default.string,
    theme: _propTypes2.default.string,
    type: _propTypes2.default.string,
    verifyCallbackName: _propTypes2.default.string,
    expiredCallbackName: _propTypes2.default.string,
    size: _propTypes2.default.string,
    tabindex: _propTypes2.default.string,
    hl: _propTypes2.default.string,
    badge: _propTypes2.default.string
};

var defaultProps = {
    elementID: 'g-recaptcha',
    onloadCallback: undefined,
    onloadCallbackName: 'onloadCallback',
    verifyCallback: undefined,
    verifyCallbackName: 'verifyCallback',
    expiredCallback: undefined,
    expiredCallbackName: 'expiredCallback',
    render: 'onload',
    theme: 'light',
    type: 'image',
    size: 'normal',
    tabindex: '0',
    hl: 'en',
    badge: 'bottomright'
};

var isReady = function isReady() {
    return typeof window !== 'undefined' && typeof window.grecaptcha !== 'undefined';
};

var readyCheck = void 0;

var ReCaptcha = function (_Component) {
    _inherits(ReCaptcha, _Component);

    function ReCaptcha(props) {
        _classCallCheck(this, ReCaptcha);

        var _this = _possibleConstructorReturn(this, (ReCaptcha.__proto__ || Object.getPrototypeOf(ReCaptcha)).call(this, props));

        _this._renderGrecaptcha = _this._renderGrecaptcha.bind(_this);
        _this.reset = _this.reset.bind(_this);
        _this.execute = _this.execute.bind(_this);
        _this.state = {
            ready: isReady(),
            widget: null
        };

        if (!_this.state.ready) {
            readyCheck = setInterval(_this._updateReadyState.bind(_this), 1000);
        }
        return _this;
    }

    _createClass(ReCaptcha, [{
        key: 'componentDidMount',
        value: function componentDidMount() {
            if (!!this.state.ready) {
                this._renderGrecaptcha();
            }
        }
    }, {
        key: 'componentDidUpdate',
        value: function componentDidUpdate(prevProps, prevState) {
            var _props = this.props,
                render = _props.render,
                onloadCallback = _props.onloadCallback;


            if (render === 'explicit' && onloadCallback && this.state.ready && !prevState.ready) {
                this._renderGrecaptcha();
            }
        }
    }, {
        key: 'componentWillUnmount',
        value: function componentWillUnmount() {
            clearInterval(readyCheck);
        }
    }, {
        key: 'reset',
        value: function reset() {
            var _state = this.state,
                ready = _state.ready,
                widget = _state.widget;

            if (ready && widget !== null) {
                grecaptcha.reset(widget);
            }
        }
    }, {
        key: 'execute',
        value: function execute() {
            var _state2 = this.state,
                ready = _state2.ready,
                widget = _state2.widget;

            if (ready && widget !== null) {
                grecaptcha.execute(widget);
            }
        }
    }, {
        key: '_updateReadyState',
        value: function _updateReadyState() {
            if (isReady()) {
                this.setState({
                    ready: true
                });

                clearInterval(readyCheck);
            }
        }
    }, {
        key: '_renderGrecaptcha',
        value: function _renderGrecaptcha() {
            this.state.widget = grecaptcha.render(this.props.elementID, {
                sitekey: this.props.sitekey,
                callback: this.props.verifyCallback ? this.props.verifyCallback : undefined,
                theme: this.props.theme,
                type: this.props.type,
                size: this.props.size,
                tabindex: this.props.tabindex,
                hl: this.props.hl,
                badge: this.props.badge,
                'expired-callback': this.props.expiredCallback ? this.props.expiredCallback : undefined
            });

            if (this.props.onloadCallback) {
                this.props.onloadCallback();
            }
        }
    }, {
        key: 'render',
        value: function render() {
            if (this.props.render === 'explicit' && this.props.onloadCallback) {
                return _react2.default.createElement('div', { id: this.props.elementID,
                    'data-onloadcallbackname': this.props.onloadCallbackName,
                    'data-verifycallbackname': this.props.verifyCallbackName
                });
            } else {

                return _react2.default.createElement('div', { id: this.props.elementID,
                    className: 'g-recaptcha',
                    'data-sitekey': this.props.sitekey,
                    'data-theme': this.props.theme,
                    'data-type': this.props.type,
                    'data-size': this.props.size,
                    'data-badge': this.props.badge,
                    'data-tabindex': this.props.tabindex
                });
            }
        }
    }]);

    return ReCaptcha;
}(_react.Component);

ReCaptcha.propTypes = propTypes;
ReCaptcha.defaultProps = defaultProps;

exports.default = ReCaptcha;

/***/ }),
/* 7 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var loadReCaptcha = function loadReCaptcha() {
    var script = document.createElement("script");
    script.async = true;
    script.defer = true;
    script.src = "https://www.google.com/recaptcha/api.js";
    document.body.appendChild(script);
};

exports.default = loadReCaptcha;

/***/ }),
/* 8 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _react = __webpack_require__(4);

var _react2 = _interopRequireDefault(_react);

var _ReCaptcha = __webpack_require__(6);

var _ReCaptcha2 = _interopRequireDefault(_ReCaptcha);

var _loadReCaptcha = __webpack_require__(7);

var _loadReCaptcha2 = _interopRequireDefault(_loadReCaptcha);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

module.exports = {
  ReCaptcha: _ReCaptcha2.default,
  loadReCaptcha: _loadReCaptcha2.default
};

/***/ }),
/* 9 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*
object-assign
(c) Sindre Sorhus
@license MIT
*/


/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

module.exports = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};


/***/ }),
/* 10 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



if (process.env.NODE_ENV !== 'production') {
  var invariant = __webpack_require__(2);
  var warning = __webpack_require__(5);
  var ReactPropTypesSecret = __webpack_require__(3);
  var loggedTypeFailures = {};
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (typeSpecs.hasOwnProperty(typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          invariant(typeof typeSpecs[typeSpecName] === 'function', '%s: %s type `%s` is invalid; it must be a function, usually from ' + 'the `prop-types` package, but received `%s`.', componentName || 'React class', location, typeSpecName, typeof typeSpecs[typeSpecName]);
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        warning(!error || error instanceof Error, '%s: type specification of %s `%s` is invalid; the type checker ' + 'function must return `null` or an `Error` but returned a %s. ' + 'You may have forgotten to pass an argument to the type checker ' + 'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' + 'shape all require an argument).', componentName || 'React class', location, typeSpecName, typeof error);
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          warning(false, 'Failed %s type: %s%s', location, error.message, stack != null ? stack : '');
        }
      }
    }
  }
}

module.exports = checkPropTypes;

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 11 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(1);
var invariant = __webpack_require__(2);
var ReactPropTypesSecret = __webpack_require__(3);

module.exports = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret) {
      // It is still safe when called from React.
      return;
    }
    invariant(
      false,
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
  };
  shim.isRequired = shim;
  function getShim() {
    return shim;
  };
  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim
  };

  ReactPropTypes.checkPropTypes = emptyFunction;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 12 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var emptyFunction = __webpack_require__(1);
var invariant = __webpack_require__(2);
var warning = __webpack_require__(5);
var assign = __webpack_require__(9);

var ReactPropTypesSecret = __webpack_require__(3);
var checkPropTypes = __webpack_require__(10);

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message) {
    this.message = message;
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          invariant(
            false,
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            warning(
              false,
              'You are manually calling a React.PropTypes validation ' +
              'function for the `%s` prop on `%s`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.',
              propFullName,
              componentName
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunction.thatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOf, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues);
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + propValue + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (propValue.hasOwnProperty(key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? warning(false, 'Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunction.thatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        warning(
          false,
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received %s at index %s.',
          getPostfixForTypeWarning(checker),
          i
        );
        return emptyFunction.thatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        if (checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret) == null) {
          return null;
        }
      }

      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (!checker) {
          continue;
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from
      // props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' +  JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ }),
/* 13 */
/***/ (function(module, exports, __webpack_require__) {

/* WEBPACK VAR INJECTION */(function(process) {/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var REACT_ELEMENT_TYPE = (typeof Symbol === 'function' &&
    Symbol.for &&
    Symbol.for('react.element')) ||
    0xeac7;

  var isValidElement = function(object) {
    return typeof object === 'object' &&
      object !== null &&
      object.$$typeof === REACT_ELEMENT_TYPE;
  };

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = __webpack_require__(12)(isValidElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = __webpack_require__(11)();
}

/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(0)))

/***/ })
/******/ ]);

/***/ }),
/* 1048 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


module.exports = __webpack_require__(1049);


/***/ }),
/* 1049 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _assign = __webpack_require__(47);

var ReactBaseClasses = __webpack_require__(370);
var ReactChildren = __webpack_require__(1052);
var ReactDOMFactories = __webpack_require__(1057);
var ReactElement = __webpack_require__(89);
var ReactPropTypes = __webpack_require__(1058);
var ReactVersion = __webpack_require__(1063);

var createReactClass = __webpack_require__(1064);
var onlyChild = __webpack_require__(1065);

var createElement = ReactElement.createElement;
var createFactory = ReactElement.createFactory;
var cloneElement = ReactElement.cloneElement;

if (false) {
  var lowPriorityWarning = require('./lowPriorityWarning');
  var canDefineProperty = require('./canDefineProperty');
  var ReactElementValidator = require('./ReactElementValidator');
  var didWarnPropTypesDeprecated = false;
  createElement = ReactElementValidator.createElement;
  createFactory = ReactElementValidator.createFactory;
  cloneElement = ReactElementValidator.cloneElement;
}

var __spread = _assign;
var createMixin = function (mixin) {
  return mixin;
};

if (false) {
  var warnedForSpread = false;
  var warnedForCreateMixin = false;
  __spread = function () {
    lowPriorityWarning(warnedForSpread, 'React.__spread is deprecated and should not be used. Use ' + 'Object.assign directly or another helper function with similar ' + 'semantics. You may be seeing this warning due to your compiler. ' + 'See https://fb.me/react-spread-deprecation for more details.');
    warnedForSpread = true;
    return _assign.apply(null, arguments);
  };

  createMixin = function (mixin) {
    lowPriorityWarning(warnedForCreateMixin, 'React.createMixin is deprecated and should not be used. ' + 'In React v16.0, it will be removed. ' + 'You can use this mixin directly instead. ' + 'See https://fb.me/createmixin-was-never-implemented for more info.');
    warnedForCreateMixin = true;
    return mixin;
  };
}

var React = {
  // Modern

  Children: {
    map: ReactChildren.map,
    forEach: ReactChildren.forEach,
    count: ReactChildren.count,
    toArray: ReactChildren.toArray,
    only: onlyChild
  },

  Component: ReactBaseClasses.Component,
  PureComponent: ReactBaseClasses.PureComponent,

  createElement: createElement,
  cloneElement: cloneElement,
  isValidElement: ReactElement.isValidElement,

  // Classic

  PropTypes: ReactPropTypes,
  createClass: createReactClass,
  createFactory: createFactory,
  createMixin: createMixin,

  // This looks DOM specific but these are actually isomorphic helpers
  // since they are just generating DOM strings.
  DOM: ReactDOMFactories,

  version: ReactVersion,

  // Deprecated hook for JSX spread, don't use this for anything.
  __spread: __spread
};

if (false) {
  var warnedForCreateClass = false;
  if (canDefineProperty) {
    Object.defineProperty(React, 'PropTypes', {
      get: function () {
        lowPriorityWarning(didWarnPropTypesDeprecated, 'Accessing PropTypes via the main React package is deprecated,' + ' and will be removed in  React v16.0.' + ' Use the latest available v15.* prop-types package from npm instead.' + ' For info on usage, compatibility, migration and more, see ' + 'https://fb.me/prop-types-docs');
        didWarnPropTypesDeprecated = true;
        return ReactPropTypes;
      }
    });

    Object.defineProperty(React, 'createClass', {
      get: function () {
        lowPriorityWarning(warnedForCreateClass, 'Accessing createClass via the main React package is deprecated,' + ' and will be removed in React v16.0.' + " Use a plain JavaScript class instead. If you're not yet " + 'ready to migrate, create-react-class v15.* is available ' + 'on npm as a temporary, drop-in replacement. ' + 'For more info see https://fb.me/react-create-class');
        warnedForCreateClass = true;
        return createReactClass;
      }
    });
  }

  // React.DOM factories are deprecated. Wrap these methods so that
  // invocations of the React.DOM namespace and alert users to switch
  // to the `react-dom-factories` package.
  React.DOM = {};
  var warnedForFactories = false;
  Object.keys(ReactDOMFactories).forEach(function (factory) {
    React.DOM[factory] = function () {
      if (!warnedForFactories) {
        lowPriorityWarning(false, 'Accessing factories like React.DOM.%s has been deprecated ' + 'and will be removed in v16.0+. Use the ' + 'react-dom-factories package instead. ' + ' Version 1.0 provides a drop-in replacement.' + ' For more info, see https://fb.me/react-dom-factories', factory);
        warnedForFactories = true;
      }
      return ReactDOMFactories[factory].apply(ReactDOMFactories, arguments);
    };
  });
}

module.exports = React;

/***/ }),
/* 1050 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var emptyObject = {};

if (false) {
  Object.freeze(emptyObject);
}

module.exports = emptyObject;

/***/ }),
/* 1051 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



/**
 * Forked from fbjs/warning:
 * https://github.com/facebook/fbjs/blob/e66ba20ad5be433eb54423f2b097d829324d9de6/packages/fbjs/src/__forks__/warning.js
 *
 * Only change is we use console.warn instead of console.error,
 * and do nothing when 'console' is not supported.
 * This really simplifies the code.
 * ---
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var lowPriorityWarning = function () {};

if (false) {
  var printWarning = function (format) {
    for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    var argIndex = 0;
    var message = 'Warning: ' + format.replace(/%s/g, function () {
      return args[argIndex++];
    });
    if (typeof console !== 'undefined') {
      console.warn(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  lowPriorityWarning = function (condition, format) {
    if (format === undefined) {
      throw new Error('`warning(condition, format, ...args)` requires a warning ' + 'message argument');
    }
    if (!condition) {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      printWarning.apply(undefined, [format].concat(args));
    }
  };
}

module.exports = lowPriorityWarning;

/***/ }),
/* 1052 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var PooledClass = __webpack_require__(1053);
var ReactElement = __webpack_require__(89);

var emptyFunction = __webpack_require__(372);
var traverseAllChildren = __webpack_require__(1054);

var twoArgumentPooler = PooledClass.twoArgumentPooler;
var fourArgumentPooler = PooledClass.fourArgumentPooler;

var userProvidedKeyEscapeRegex = /\/+/g;
function escapeUserProvidedKey(text) {
  return ('' + text).replace(userProvidedKeyEscapeRegex, '$&/');
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * traversal. Allows avoiding binding callbacks.
 *
 * @constructor ForEachBookKeeping
 * @param {!function} forEachFunction Function to perform traversal with.
 * @param {?*} forEachContext Context to perform context with.
 */
function ForEachBookKeeping(forEachFunction, forEachContext) {
  this.func = forEachFunction;
  this.context = forEachContext;
  this.count = 0;
}
ForEachBookKeeping.prototype.destructor = function () {
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(ForEachBookKeeping, twoArgumentPooler);

function forEachSingleChild(bookKeeping, child, name) {
  var func = bookKeeping.func,
      context = bookKeeping.context;

  func.call(context, child, bookKeeping.count++);
}

/**
 * Iterates through children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.foreach
 *
 * The provided forEachFunc(child, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} forEachFunc
 * @param {*} forEachContext Context for forEachContext.
 */
function forEachChildren(children, forEachFunc, forEachContext) {
  if (children == null) {
    return children;
  }
  var traverseContext = ForEachBookKeeping.getPooled(forEachFunc, forEachContext);
  traverseAllChildren(children, forEachSingleChild, traverseContext);
  ForEachBookKeeping.release(traverseContext);
}

/**
 * PooledClass representing the bookkeeping associated with performing a child
 * mapping. Allows avoiding binding callbacks.
 *
 * @constructor MapBookKeeping
 * @param {!*} mapResult Object containing the ordered map of results.
 * @param {!function} mapFunction Function to perform mapping with.
 * @param {?*} mapContext Context to perform mapping with.
 */
function MapBookKeeping(mapResult, keyPrefix, mapFunction, mapContext) {
  this.result = mapResult;
  this.keyPrefix = keyPrefix;
  this.func = mapFunction;
  this.context = mapContext;
  this.count = 0;
}
MapBookKeeping.prototype.destructor = function () {
  this.result = null;
  this.keyPrefix = null;
  this.func = null;
  this.context = null;
  this.count = 0;
};
PooledClass.addPoolingTo(MapBookKeeping, fourArgumentPooler);

function mapSingleChildIntoContext(bookKeeping, child, childKey) {
  var result = bookKeeping.result,
      keyPrefix = bookKeeping.keyPrefix,
      func = bookKeeping.func,
      context = bookKeeping.context;


  var mappedChild = func.call(context, child, bookKeeping.count++);
  if (Array.isArray(mappedChild)) {
    mapIntoWithKeyPrefixInternal(mappedChild, result, childKey, emptyFunction.thatReturnsArgument);
  } else if (mappedChild != null) {
    if (ReactElement.isValidElement(mappedChild)) {
      mappedChild = ReactElement.cloneAndReplaceKey(mappedChild,
      // Keep both the (mapped) and old keys if they differ, just as
      // traverseAllChildren used to do for objects as children
      keyPrefix + (mappedChild.key && (!child || child.key !== mappedChild.key) ? escapeUserProvidedKey(mappedChild.key) + '/' : '') + childKey);
    }
    result.push(mappedChild);
  }
}

function mapIntoWithKeyPrefixInternal(children, array, prefix, func, context) {
  var escapedPrefix = '';
  if (prefix != null) {
    escapedPrefix = escapeUserProvidedKey(prefix) + '/';
  }
  var traverseContext = MapBookKeeping.getPooled(array, escapedPrefix, func, context);
  traverseAllChildren(children, mapSingleChildIntoContext, traverseContext);
  MapBookKeeping.release(traverseContext);
}

/**
 * Maps children that are typically specified as `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.map
 *
 * The provided mapFunction(child, key, index) will be called for each
 * leaf child.
 *
 * @param {?*} children Children tree container.
 * @param {function(*, int)} func The map function.
 * @param {*} context Context for mapFunction.
 * @return {object} Object containing the ordered map of results.
 */
function mapChildren(children, func, context) {
  if (children == null) {
    return children;
  }
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, func, context);
  return result;
}

function forEachSingleChildDummy(traverseContext, child, name) {
  return null;
}

/**
 * Count the number of children that are typically specified as
 * `props.children`.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.count
 *
 * @param {?*} children Children tree container.
 * @return {number} The number of children.
 */
function countChildren(children, context) {
  return traverseAllChildren(children, forEachSingleChildDummy, null);
}

/**
 * Flatten a children object (typically specified as `props.children`) and
 * return an array with appropriately re-keyed children.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.toarray
 */
function toArray(children) {
  var result = [];
  mapIntoWithKeyPrefixInternal(children, result, null, emptyFunction.thatReturnsArgument);
  return result;
}

var ReactChildren = {
  forEach: forEachChildren,
  map: mapChildren,
  mapIntoWithKeyPrefixInternal: mapIntoWithKeyPrefixInternal,
  count: countChildren,
  toArray: toArray
};

module.exports = ReactChildren;

/***/ }),
/* 1053 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



var _prodInvariant = __webpack_require__(139);

var invariant = __webpack_require__(140);

/**
 * Static poolers. Several custom versions for each potential number of
 * arguments. A completely generic pooler is easy to implement, but would
 * require accessing the `arguments` object. In each of these, `this` refers to
 * the Class itself, not an instance. If any others are needed, simply add them
 * here, or in their own files.
 */
var oneArgumentPooler = function (copyFieldsFrom) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, copyFieldsFrom);
    return instance;
  } else {
    return new Klass(copyFieldsFrom);
  }
};

var twoArgumentPooler = function (a1, a2) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2);
    return instance;
  } else {
    return new Klass(a1, a2);
  }
};

var threeArgumentPooler = function (a1, a2, a3) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3);
    return instance;
  } else {
    return new Klass(a1, a2, a3);
  }
};

var fourArgumentPooler = function (a1, a2, a3, a4) {
  var Klass = this;
  if (Klass.instancePool.length) {
    var instance = Klass.instancePool.pop();
    Klass.call(instance, a1, a2, a3, a4);
    return instance;
  } else {
    return new Klass(a1, a2, a3, a4);
  }
};

var standardReleaser = function (instance) {
  var Klass = this;
  !(instance instanceof Klass) ?  false ? invariant(false, 'Trying to release an instance into a pool of a different type.') : _prodInvariant('25') : void 0;
  instance.destructor();
  if (Klass.instancePool.length < Klass.poolSize) {
    Klass.instancePool.push(instance);
  }
};

var DEFAULT_POOL_SIZE = 10;
var DEFAULT_POOLER = oneArgumentPooler;

/**
 * Augments `CopyConstructor` to be a poolable class, augmenting only the class
 * itself (statically) not adding any prototypical fields. Any CopyConstructor
 * you give this may have a `poolSize` property, and will look for a
 * prototypical `destructor` on instances.
 *
 * @param {Function} CopyConstructor Constructor that can be used to reset.
 * @param {Function} pooler Customizable pooler.
 */
var addPoolingTo = function (CopyConstructor, pooler) {
  // Casting as any so that flow ignores the actual implementation and trusts
  // it to match the type we declared
  var NewKlass = CopyConstructor;
  NewKlass.instancePool = [];
  NewKlass.getPooled = pooler || DEFAULT_POOLER;
  if (!NewKlass.poolSize) {
    NewKlass.poolSize = DEFAULT_POOL_SIZE;
  }
  NewKlass.release = standardReleaser;
  return NewKlass;
};

var PooledClass = {
  addPoolingTo: addPoolingTo,
  oneArgumentPooler: oneArgumentPooler,
  twoArgumentPooler: twoArgumentPooler,
  threeArgumentPooler: threeArgumentPooler,
  fourArgumentPooler: fourArgumentPooler
};

module.exports = PooledClass;

/***/ }),
/* 1054 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _prodInvariant = __webpack_require__(139);

var ReactCurrentOwner = __webpack_require__(374);
var REACT_ELEMENT_TYPE = __webpack_require__(375);

var getIteratorFn = __webpack_require__(1055);
var invariant = __webpack_require__(140);
var KeyEscapeUtils = __webpack_require__(1056);
var warning = __webpack_require__(211);

var SEPARATOR = '.';
var SUBSEPARATOR = ':';

/**
 * This is inlined from ReactElement since this file is shared between
 * isomorphic and renderers. We could extract this to a
 *
 */

/**
 * TODO: Test that a single child and an array with one item have the same key
 * pattern.
 */

var didWarnAboutMaps = false;

/**
 * Generate a key string that identifies a component within a set.
 *
 * @param {*} component A component that could contain a manual key.
 * @param {number} index Index that is used if a manual key is not provided.
 * @return {string}
 */
function getComponentKey(component, index) {
  // Do some typechecking here since we call this blindly. We want to ensure
  // that we don't block potential future ES APIs.
  if (component && typeof component === 'object' && component.key != null) {
    // Explicit key
    return KeyEscapeUtils.escape(component.key);
  }
  // Implicit key determined by the index in the set
  return index.toString(36);
}

/**
 * @param {?*} children Children tree container.
 * @param {!string} nameSoFar Name of the key path so far.
 * @param {!function} callback Callback to invoke with each child found.
 * @param {?*} traverseContext Used to pass information throughout the traversal
 * process.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildrenImpl(children, nameSoFar, callback, traverseContext) {
  var type = typeof children;

  if (type === 'undefined' || type === 'boolean') {
    // All of the above are perceived as null.
    children = null;
  }

  if (children === null || type === 'string' || type === 'number' ||
  // The following is inlined from ReactElement. This means we can optimize
  // some checks. React Fiber also inlines this logic for similar purposes.
  type === 'object' && children.$$typeof === REACT_ELEMENT_TYPE) {
    callback(traverseContext, children,
    // If it's the only child, treat the name as if it was wrapped in an array
    // so that it's consistent if the number of children grows.
    nameSoFar === '' ? SEPARATOR + getComponentKey(children, 0) : nameSoFar);
    return 1;
  }

  var child;
  var nextName;
  var subtreeCount = 0; // Count of children found in the current subtree.
  var nextNamePrefix = nameSoFar === '' ? SEPARATOR : nameSoFar + SUBSEPARATOR;

  if (Array.isArray(children)) {
    for (var i = 0; i < children.length; i++) {
      child = children[i];
      nextName = nextNamePrefix + getComponentKey(child, i);
      subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
    }
  } else {
    var iteratorFn = getIteratorFn(children);
    if (iteratorFn) {
      var iterator = iteratorFn.call(children);
      var step;
      if (iteratorFn !== children.entries) {
        var ii = 0;
        while (!(step = iterator.next()).done) {
          child = step.value;
          nextName = nextNamePrefix + getComponentKey(child, ii++);
          subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
        }
      } else {
        if (false) {
          var mapsAsChildrenAddendum = '';
          if (ReactCurrentOwner.current) {
            var mapsAsChildrenOwnerName = ReactCurrentOwner.current.getName();
            if (mapsAsChildrenOwnerName) {
              mapsAsChildrenAddendum = ' Check the render method of `' + mapsAsChildrenOwnerName + '`.';
            }
          }
          process.env.NODE_ENV !== 'production' ? warning(didWarnAboutMaps, 'Using Maps as children is not yet fully supported. It is an ' + 'experimental feature that might be removed. Convert it to a ' + 'sequence / iterable of keyed ReactElements instead.%s', mapsAsChildrenAddendum) : void 0;
          didWarnAboutMaps = true;
        }
        // Iterator will provide entry [k,v] tuples rather than values.
        while (!(step = iterator.next()).done) {
          var entry = step.value;
          if (entry) {
            child = entry[1];
            nextName = nextNamePrefix + KeyEscapeUtils.escape(entry[0]) + SUBSEPARATOR + getComponentKey(child, 0);
            subtreeCount += traverseAllChildrenImpl(child, nextName, callback, traverseContext);
          }
        }
      }
    } else if (type === 'object') {
      var addendum = '';
      if (false) {
        addendum = ' If you meant to render a collection of children, use an array ' + 'instead or wrap the object using createFragment(object) from the ' + 'React add-ons.';
        if (children._isReactElement) {
          addendum = " It looks like you're using an element created by a different " + 'version of React. Make sure to use only one copy of React.';
        }
        if (ReactCurrentOwner.current) {
          var name = ReactCurrentOwner.current.getName();
          if (name) {
            addendum += ' Check the render method of `' + name + '`.';
          }
        }
      }
      var childrenString = String(children);
       true ?  false ? invariant(false, 'Objects are not valid as a React child (found: %s).%s', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : _prodInvariant('31', childrenString === '[object Object]' ? 'object with keys {' + Object.keys(children).join(', ') + '}' : childrenString, addendum) : void 0;
    }
  }

  return subtreeCount;
}

/**
 * Traverses children that are typically specified as `props.children`, but
 * might also be specified through attributes:
 *
 * - `traverseAllChildren(this.props.children, ...)`
 * - `traverseAllChildren(this.props.leftPanelChildren, ...)`
 *
 * The `traverseContext` is an optional argument that is passed through the
 * entire traversal. It can be used to store accumulations or anything else that
 * the callback might find relevant.
 *
 * @param {?*} children Children tree object.
 * @param {!function} callback To invoke upon traversing each child.
 * @param {?*} traverseContext Context for traversal.
 * @return {!number} The number of children in this subtree.
 */
function traverseAllChildren(children, callback, traverseContext) {
  if (children == null) {
    return 0;
  }

  return traverseAllChildrenImpl(children, '', callback, traverseContext);
}

module.exports = traverseAllChildren;

/***/ }),
/* 1055 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/* global Symbol */

var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

/**
 * Returns the iterator method function contained on the iterable object.
 *
 * Be sure to invoke the function with the iterable as context:
 *
 *     var iteratorFn = getIteratorFn(myIterable);
 *     if (iteratorFn) {
 *       var iterator = iteratorFn.call(myIterable);
 *       ...
 *     }
 *
 * @param {?object} maybeIterable
 * @return {?function}
 */
function getIteratorFn(maybeIterable) {
  var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
  if (typeof iteratorFn === 'function') {
    return iteratorFn;
  }
}

module.exports = getIteratorFn;

/***/ }),
/* 1056 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 * 
 */



/**
 * Escape and wrap key so it is safe to use as a reactid
 *
 * @param {string} key to be escaped.
 * @return {string} the escaped key.
 */

function escape(key) {
  var escapeRegex = /[=:]/g;
  var escaperLookup = {
    '=': '=0',
    ':': '=2'
  };
  var escapedString = ('' + key).replace(escapeRegex, function (match) {
    return escaperLookup[match];
  });

  return '$' + escapedString;
}

/**
 * Unescape and unwrap key for human-readable display
 *
 * @param {string} key to unescape.
 * @return {string} the unescaped key.
 */
function unescape(key) {
  var unescapeRegex = /(=0|=2)/g;
  var unescaperLookup = {
    '=0': '=',
    '=2': ':'
  };
  var keySubstring = key[0] === '.' && key[1] === '$' ? key.substring(2) : key.substring(1);

  return ('' + keySubstring).replace(unescapeRegex, function (match) {
    return unescaperLookup[match];
  });
}

var KeyEscapeUtils = {
  escape: escape,
  unescape: unescape
};

module.exports = KeyEscapeUtils;

/***/ }),
/* 1057 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var ReactElement = __webpack_require__(89);

/**
 * Create a factory that creates HTML tag elements.
 *
 * @private
 */
var createDOMFactory = ReactElement.createFactory;
if (false) {
  var ReactElementValidator = require('./ReactElementValidator');
  createDOMFactory = ReactElementValidator.createFactory;
}

/**
 * Creates a mapping from supported HTML tags to `ReactDOMComponent` classes.
 *
 * @public
 */
var ReactDOMFactories = {
  a: createDOMFactory('a'),
  abbr: createDOMFactory('abbr'),
  address: createDOMFactory('address'),
  area: createDOMFactory('area'),
  article: createDOMFactory('article'),
  aside: createDOMFactory('aside'),
  audio: createDOMFactory('audio'),
  b: createDOMFactory('b'),
  base: createDOMFactory('base'),
  bdi: createDOMFactory('bdi'),
  bdo: createDOMFactory('bdo'),
  big: createDOMFactory('big'),
  blockquote: createDOMFactory('blockquote'),
  body: createDOMFactory('body'),
  br: createDOMFactory('br'),
  button: createDOMFactory('button'),
  canvas: createDOMFactory('canvas'),
  caption: createDOMFactory('caption'),
  cite: createDOMFactory('cite'),
  code: createDOMFactory('code'),
  col: createDOMFactory('col'),
  colgroup: createDOMFactory('colgroup'),
  data: createDOMFactory('data'),
  datalist: createDOMFactory('datalist'),
  dd: createDOMFactory('dd'),
  del: createDOMFactory('del'),
  details: createDOMFactory('details'),
  dfn: createDOMFactory('dfn'),
  dialog: createDOMFactory('dialog'),
  div: createDOMFactory('div'),
  dl: createDOMFactory('dl'),
  dt: createDOMFactory('dt'),
  em: createDOMFactory('em'),
  embed: createDOMFactory('embed'),
  fieldset: createDOMFactory('fieldset'),
  figcaption: createDOMFactory('figcaption'),
  figure: createDOMFactory('figure'),
  footer: createDOMFactory('footer'),
  form: createDOMFactory('form'),
  h1: createDOMFactory('h1'),
  h2: createDOMFactory('h2'),
  h3: createDOMFactory('h3'),
  h4: createDOMFactory('h4'),
  h5: createDOMFactory('h5'),
  h6: createDOMFactory('h6'),
  head: createDOMFactory('head'),
  header: createDOMFactory('header'),
  hgroup: createDOMFactory('hgroup'),
  hr: createDOMFactory('hr'),
  html: createDOMFactory('html'),
  i: createDOMFactory('i'),
  iframe: createDOMFactory('iframe'),
  img: createDOMFactory('img'),
  input: createDOMFactory('input'),
  ins: createDOMFactory('ins'),
  kbd: createDOMFactory('kbd'),
  keygen: createDOMFactory('keygen'),
  label: createDOMFactory('label'),
  legend: createDOMFactory('legend'),
  li: createDOMFactory('li'),
  link: createDOMFactory('link'),
  main: createDOMFactory('main'),
  map: createDOMFactory('map'),
  mark: createDOMFactory('mark'),
  menu: createDOMFactory('menu'),
  menuitem: createDOMFactory('menuitem'),
  meta: createDOMFactory('meta'),
  meter: createDOMFactory('meter'),
  nav: createDOMFactory('nav'),
  noscript: createDOMFactory('noscript'),
  object: createDOMFactory('object'),
  ol: createDOMFactory('ol'),
  optgroup: createDOMFactory('optgroup'),
  option: createDOMFactory('option'),
  output: createDOMFactory('output'),
  p: createDOMFactory('p'),
  param: createDOMFactory('param'),
  picture: createDOMFactory('picture'),
  pre: createDOMFactory('pre'),
  progress: createDOMFactory('progress'),
  q: createDOMFactory('q'),
  rp: createDOMFactory('rp'),
  rt: createDOMFactory('rt'),
  ruby: createDOMFactory('ruby'),
  s: createDOMFactory('s'),
  samp: createDOMFactory('samp'),
  script: createDOMFactory('script'),
  section: createDOMFactory('section'),
  select: createDOMFactory('select'),
  small: createDOMFactory('small'),
  source: createDOMFactory('source'),
  span: createDOMFactory('span'),
  strong: createDOMFactory('strong'),
  style: createDOMFactory('style'),
  sub: createDOMFactory('sub'),
  summary: createDOMFactory('summary'),
  sup: createDOMFactory('sup'),
  table: createDOMFactory('table'),
  tbody: createDOMFactory('tbody'),
  td: createDOMFactory('td'),
  textarea: createDOMFactory('textarea'),
  tfoot: createDOMFactory('tfoot'),
  th: createDOMFactory('th'),
  thead: createDOMFactory('thead'),
  time: createDOMFactory('time'),
  title: createDOMFactory('title'),
  tr: createDOMFactory('tr'),
  track: createDOMFactory('track'),
  u: createDOMFactory('u'),
  ul: createDOMFactory('ul'),
  'var': createDOMFactory('var'),
  video: createDOMFactory('video'),
  wbr: createDOMFactory('wbr'),

  // SVG
  circle: createDOMFactory('circle'),
  clipPath: createDOMFactory('clipPath'),
  defs: createDOMFactory('defs'),
  ellipse: createDOMFactory('ellipse'),
  g: createDOMFactory('g'),
  image: createDOMFactory('image'),
  line: createDOMFactory('line'),
  linearGradient: createDOMFactory('linearGradient'),
  mask: createDOMFactory('mask'),
  path: createDOMFactory('path'),
  pattern: createDOMFactory('pattern'),
  polygon: createDOMFactory('polygon'),
  polyline: createDOMFactory('polyline'),
  radialGradient: createDOMFactory('radialGradient'),
  rect: createDOMFactory('rect'),
  stop: createDOMFactory('stop'),
  svg: createDOMFactory('svg'),
  text: createDOMFactory('text'),
  tspan: createDOMFactory('tspan')
};

module.exports = ReactDOMFactories;

/***/ }),
/* 1058 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__(89),
    isValidElement = _require.isValidElement;

var factory = __webpack_require__(1059);

module.exports = factory(isValidElement);

/***/ }),
/* 1059 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



// React 15.5 references this module, and assumes PropTypes are still callable in production.
// Therefore we re-export development-only version with all the PropTypes checks here.
// However if one is migrating to the `prop-types` npm library, they will go through the
// `index.js` entry point, and it will branch depending on the environment.
var factory = __webpack_require__(1060);
module.exports = function(isValidElement) {
  // It is still allowed in 15.5.
  var throwOnDirectAccess = false;
  return factory(isValidElement, throwOnDirectAccess);
};


/***/ }),
/* 1060 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var ReactIs = __webpack_require__(50);
var assign = __webpack_require__(47);

var ReactPropTypesSecret = __webpack_require__(214);
var has = __webpack_require__(1061);
var checkPropTypes = __webpack_require__(1062);

var printWarning = function() {};

if (false) {
  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

module.exports = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data: {};
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (false) {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (false) {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError(
          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
          {expectedType: expectedType}
        );
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!ReactIs.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (false) {
        if (arguments.length > 1) {
          printWarning(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
       false ? printWarning('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError(
      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
    );
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from props.
      var allKeys = assign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};


/***/ }),
/* 1061 */
/***/ (function(module, exports) {

module.exports = Function.call.bind(Object.prototype.hasOwnProperty);


/***/ }),
/* 1062 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */



var printWarning = function() {};

if (false) {
  var ReactPropTypesSecret = require('./lib/ReactPropTypesSecret');
  var loggedTypeFailures = {};
  var has = require('./lib/has');

  printWarning = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) { /**/ }
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes(typeSpecs, values, location, componentName, getStack) {
  if (false) {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes.resetWarningCache = function() {
  if (false) {
    loggedTypeFailures = {};
  }
}

module.exports = checkPropTypes;


/***/ }),
/* 1063 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



module.exports = '15.7.0';


/***/ }),
/* 1064 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */



var _require = __webpack_require__(370),
    Component = _require.Component;

var _require2 = __webpack_require__(89),
    isValidElement = _require2.isValidElement;

var ReactNoopUpdateQueue = __webpack_require__(371);
var factory = __webpack_require__(299);

module.exports = factory(Component, isValidElement, ReactNoopUpdateQueue);

/***/ }),
/* 1065 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 *
 */


var _prodInvariant = __webpack_require__(139);

var ReactElement = __webpack_require__(89);

var invariant = __webpack_require__(140);

/**
 * Returns the first child in a collection of children and verifies that there
 * is only one child in the collection.
 *
 * See https://facebook.github.io/react/docs/top-level-api.html#react.children.only
 *
 * The current implementation of this function assumes that a single child gets
 * passed without a wrapper, but the purpose of this helper function is to
 * abstract away the particular structure of children.
 *
 * @param {?object} children Child collection structure.
 * @return {ReactElement} The first and only `ReactElement` contained in the
 * structure.
 */
function onlyChild(children) {
  !ReactElement.isValidElement(children) ?  false ? invariant(false, 'React.Children.only expected to receive a single React element child.') : _prodInvariant('143') : void 0;
  return children;
}

module.exports = onlyChild;

/***/ }),
/* 1066 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return initAppPreviewTrip; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_reduce__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_reduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_reduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_actionType__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_preview_trip__ = __webpack_require__(1067);
var _this=this;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var initAppPreviewTrip=function initAppPreviewTrip(){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch){var listApi,apiResult,mapData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:listApi=[];_context.t0=listApi;_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_3__services_preview_trip__["c" /* fetchDictionaryApi */])();case 4:_context.t1=_context.sent;_context.t2={key:"dictionary",data:_context.t1};_context.t0.push.call(_context.t0,_context.t2);_context.t3=listApi;_context.next=10;return Object(__WEBPACK_IMPORTED_MODULE_3__services_preview_trip__["d" /* fetchOptionApi */])();case 10:_context.t4=_context.sent;_context.t5={key:"option",data:_context.t4};_context.t3.push.call(_context.t3,_context.t5);_context.t6=listApi;_context.next=16;return Object(__WEBPACK_IMPORTED_MODULE_3__services_preview_trip__["e" /* fetchProjectApi */])();case 16:_context.t7=_context.sent;_context.t8={key:"project",data:_context.t7};_context.t6.push.call(_context.t6,_context.t8);_context.t9=listApi;_context.next=22;return Object(__WEBPACK_IMPORTED_MODULE_3__services_preview_trip__["a" /* fetchCountriesApi */])();case 22:_context.t10=_context.sent;_context.t11={key:"countries",data:_context.t10};_context.t9.push.call(_context.t9,_context.t11);_context.t12=listApi;_context.next=28;return Object(__WEBPACK_IMPORTED_MODULE_3__services_preview_trip__["b" /* fetchCurrencyApi */])();case 28:_context.t13=_context.sent;_context.t14={key:"exchangeCurrencyRates",data:_context.t13};_context.t12.push.call(_context.t12,_context.t14);_context.prev=31;_context.next=34;return Promise.all(listApi);case 34:apiResult=_context.sent;mapData=__WEBPACK_IMPORTED_MODULE_1_lodash_reduce___default()(apiResult,function(result,value,index){var key=value.key,data=value.data;return Object.assign({},result,_defineProperty({},key,data));},{});dispatch({type:__WEBPACK_IMPORTED_MODULE_2__actions_actionType__["i" /* RECEIVE_PREVIEW_TRIP */],data:mapData});_context.next=42;break;case 39:_context.prev=39;_context.t15=_context["catch"](31);console.error("initAppPreviewTrip err",_context.t15);case 42:case"end":return _context.stop();}}},_callee,_this,[[31,39]]);}));return function(_x){return _ref.apply(this,arguments);};}();};

/***/ }),
/* 1067 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchDictionaryApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return fetchOptionApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "e", function() { return fetchProjectApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchCountriesApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchCurrencyApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_PreviewTrip__ = __webpack_require__(1069);
var dictionary=__WEBPACK_IMPORTED_MODULE_1__data_PreviewTrip__["a" /* default */].dictionary,option=__WEBPACK_IMPORTED_MODULE_1__data_PreviewTrip__["a" /* default */].option,project=__WEBPACK_IMPORTED_MODULE_1__data_PreviewTrip__["a" /* default */].project;var fetchDictionaryApi=function fetchDictionaryApi(){return Promise.resolve(dictionary);};var fetchOptionApi=function fetchOptionApi(){return Promise.resolve(option);};var fetchProjectApi=function fetchProjectApi(){return Promise.resolve(project);};var fetchCountriesApi=function fetchCountriesApi(){return __WEBPACK_IMPORTED_MODULE_0_isomorphic_fetch___default()('https://restcountries.eu/rest/v2/all?fields=name;currencies').then(function(response){return response.json();}).then(function(response){// console.log('fetchCountries', response)
return response;});};var fetchCurrencyApi=function fetchCurrencyApi(){return{};// return fetch('https://us-central1-forviz-2017.cloudfunctions.net/partners/exchange-currency-rates/latest')
// .then(response => response.json())
// .then(response => {
//   return response.result
// })
};

/***/ }),
/* 1068 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* WEBPACK VAR INJECTION */(function(global) {/* harmony export (immutable) */ __webpack_exports__["Headers"] = Headers;
/* harmony export (immutable) */ __webpack_exports__["Request"] = Request;
/* harmony export (immutable) */ __webpack_exports__["Response"] = Response;
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "DOMException", function() { return DOMException; });
/* harmony export (immutable) */ __webpack_exports__["fetch"] = fetch;
/* eslint-disable no-prototype-builtins */
var g =
  (typeof globalThis !== 'undefined' && globalThis) ||
  (typeof self !== 'undefined' && self) ||
  // eslint-disable-next-line no-undef
  (typeof global !== 'undefined' && global) ||
  {}

var support = {
  searchParams: 'URLSearchParams' in g,
  iterable: 'Symbol' in g && 'iterator' in Symbol,
  blob:
    'FileReader' in g &&
    'Blob' in g &&
    (function() {
      try {
        new Blob()
        return true
      } catch (e) {
        return false
      }
    })(),
  formData: 'FormData' in g,
  arrayBuffer: 'ArrayBuffer' in g
}

function isDataView(obj) {
  return obj && DataView.prototype.isPrototypeOf(obj)
}

if (support.arrayBuffer) {
  var viewClasses = [
    '[object Int8Array]',
    '[object Uint8Array]',
    '[object Uint8ClampedArray]',
    '[object Int16Array]',
    '[object Uint16Array]',
    '[object Int32Array]',
    '[object Uint32Array]',
    '[object Float32Array]',
    '[object Float64Array]'
  ]

  var isArrayBufferView =
    ArrayBuffer.isView ||
    function(obj) {
      return obj && viewClasses.indexOf(Object.prototype.toString.call(obj)) > -1
    }
}

function normalizeName(name) {
  if (typeof name !== 'string') {
    name = String(name)
  }
  if (/[^a-z0-9\-#$%&'*+.^_`|~!]/i.test(name) || name === '') {
    throw new TypeError('Invalid character in header field name: "' + name + '"')
  }
  return name.toLowerCase()
}

function normalizeValue(value) {
  if (typeof value !== 'string') {
    value = String(value)
  }
  return value
}

// Build a destructive iterator for the value list
function iteratorFor(items) {
  var iterator = {
    next: function() {
      var value = items.shift()
      return {done: value === undefined, value: value}
    }
  }

  if (support.iterable) {
    iterator[Symbol.iterator] = function() {
      return iterator
    }
  }

  return iterator
}

function Headers(headers) {
  this.map = {}

  if (headers instanceof Headers) {
    headers.forEach(function(value, name) {
      this.append(name, value)
    }, this)
  } else if (Array.isArray(headers)) {
    headers.forEach(function(header) {
      if (header.length != 2) {
        throw new TypeError('Headers constructor: expected name/value pair to be length 2, found' + header.length)
      }
      this.append(header[0], header[1])
    }, this)
  } else if (headers) {
    Object.getOwnPropertyNames(headers).forEach(function(name) {
      this.append(name, headers[name])
    }, this)
  }
}

Headers.prototype.append = function(name, value) {
  name = normalizeName(name)
  value = normalizeValue(value)
  var oldValue = this.map[name]
  this.map[name] = oldValue ? oldValue + ', ' + value : value
}

Headers.prototype['delete'] = function(name) {
  delete this.map[normalizeName(name)]
}

Headers.prototype.get = function(name) {
  name = normalizeName(name)
  return this.has(name) ? this.map[name] : null
}

Headers.prototype.has = function(name) {
  return this.map.hasOwnProperty(normalizeName(name))
}

Headers.prototype.set = function(name, value) {
  this.map[normalizeName(name)] = normalizeValue(value)
}

Headers.prototype.forEach = function(callback, thisArg) {
  for (var name in this.map) {
    if (this.map.hasOwnProperty(name)) {
      callback.call(thisArg, this.map[name], name, this)
    }
  }
}

Headers.prototype.keys = function() {
  var items = []
  this.forEach(function(value, name) {
    items.push(name)
  })
  return iteratorFor(items)
}

Headers.prototype.values = function() {
  var items = []
  this.forEach(function(value) {
    items.push(value)
  })
  return iteratorFor(items)
}

Headers.prototype.entries = function() {
  var items = []
  this.forEach(function(value, name) {
    items.push([name, value])
  })
  return iteratorFor(items)
}

if (support.iterable) {
  Headers.prototype[Symbol.iterator] = Headers.prototype.entries
}

function consumed(body) {
  if (body._noBody) return
  if (body.bodyUsed) {
    return Promise.reject(new TypeError('Already read'))
  }
  body.bodyUsed = true
}

function fileReaderReady(reader) {
  return new Promise(function(resolve, reject) {
    reader.onload = function() {
      resolve(reader.result)
    }
    reader.onerror = function() {
      reject(reader.error)
    }
  })
}

function readBlobAsArrayBuffer(blob) {
  var reader = new FileReader()
  var promise = fileReaderReady(reader)
  reader.readAsArrayBuffer(blob)
  return promise
}

function readBlobAsText(blob) {
  var reader = new FileReader()
  var promise = fileReaderReady(reader)
  var match = /charset=([A-Za-z0-9_-]+)/.exec(blob.type)
  var encoding = match ? match[1] : 'utf-8'
  reader.readAsText(blob, encoding)
  return promise
}

function readArrayBufferAsText(buf) {
  var view = new Uint8Array(buf)
  var chars = new Array(view.length)

  for (var i = 0; i < view.length; i++) {
    chars[i] = String.fromCharCode(view[i])
  }
  return chars.join('')
}

function bufferClone(buf) {
  if (buf.slice) {
    return buf.slice(0)
  } else {
    var view = new Uint8Array(buf.byteLength)
    view.set(new Uint8Array(buf))
    return view.buffer
  }
}

function Body() {
  this.bodyUsed = false

  this._initBody = function(body) {
    /*
      fetch-mock wraps the Response object in an ES6 Proxy to
      provide useful test harness features such as flush. However, on
      ES5 browsers without fetch or Proxy support pollyfills must be used;
      the proxy-pollyfill is unable to proxy an attribute unless it exists
      on the object before the Proxy is created. This change ensures
      Response.bodyUsed exists on the instance, while maintaining the
      semantic of setting Request.bodyUsed in the constructor before
      _initBody is called.
    */
    // eslint-disable-next-line no-self-assign
    this.bodyUsed = this.bodyUsed
    this._bodyInit = body
    if (!body) {
      this._noBody = true;
      this._bodyText = ''
    } else if (typeof body === 'string') {
      this._bodyText = body
    } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
      this._bodyBlob = body
    } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
      this._bodyFormData = body
    } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
      this._bodyText = body.toString()
    } else if (support.arrayBuffer && support.blob && isDataView(body)) {
      this._bodyArrayBuffer = bufferClone(body.buffer)
      // IE 10-11 can't handle a DataView body.
      this._bodyInit = new Blob([this._bodyArrayBuffer])
    } else if (support.arrayBuffer && (ArrayBuffer.prototype.isPrototypeOf(body) || isArrayBufferView(body))) {
      this._bodyArrayBuffer = bufferClone(body)
    } else {
      this._bodyText = body = Object.prototype.toString.call(body)
    }

    if (!this.headers.get('content-type')) {
      if (typeof body === 'string') {
        this.headers.set('content-type', 'text/plain;charset=UTF-8')
      } else if (this._bodyBlob && this._bodyBlob.type) {
        this.headers.set('content-type', this._bodyBlob.type)
      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
        this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
      }
    }
  }

  if (support.blob) {
    this.blob = function() {
      var rejected = consumed(this)
      if (rejected) {
        return rejected
      }

      if (this._bodyBlob) {
        return Promise.resolve(this._bodyBlob)
      } else if (this._bodyArrayBuffer) {
        return Promise.resolve(new Blob([this._bodyArrayBuffer]))
      } else if (this._bodyFormData) {
        throw new Error('could not read FormData body as blob')
      } else {
        return Promise.resolve(new Blob([this._bodyText]))
      }
    }
  }

  this.arrayBuffer = function() {
    if (this._bodyArrayBuffer) {
      var isConsumed = consumed(this)
      if (isConsumed) {
        return isConsumed
      } else if (ArrayBuffer.isView(this._bodyArrayBuffer)) {
        return Promise.resolve(
          this._bodyArrayBuffer.buffer.slice(
            this._bodyArrayBuffer.byteOffset,
            this._bodyArrayBuffer.byteOffset + this._bodyArrayBuffer.byteLength
          )
        )
      } else {
        return Promise.resolve(this._bodyArrayBuffer)
      }
    } else if (support.blob) {
      return this.blob().then(readBlobAsArrayBuffer)
    } else {
      throw new Error('could not read as ArrayBuffer')
    }
  }

  this.text = function() {
    var rejected = consumed(this)
    if (rejected) {
      return rejected
    }

    if (this._bodyBlob) {
      return readBlobAsText(this._bodyBlob)
    } else if (this._bodyArrayBuffer) {
      return Promise.resolve(readArrayBufferAsText(this._bodyArrayBuffer))
    } else if (this._bodyFormData) {
      throw new Error('could not read FormData body as text')
    } else {
      return Promise.resolve(this._bodyText)
    }
  }

  if (support.formData) {
    this.formData = function() {
      return this.text().then(decode)
    }
  }

  this.json = function() {
    return this.text().then(JSON.parse)
  }

  return this
}

// HTTP methods whose capitalization should be normalized
var methods = ['CONNECT', 'DELETE', 'GET', 'HEAD', 'OPTIONS', 'PATCH', 'POST', 'PUT', 'TRACE']

function normalizeMethod(method) {
  var upcased = method.toUpperCase()
  return methods.indexOf(upcased) > -1 ? upcased : method
}

function Request(input, options) {
  if (!(this instanceof Request)) {
    throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
  }

  options = options || {}
  var body = options.body

  if (input instanceof Request) {
    if (input.bodyUsed) {
      throw new TypeError('Already read')
    }
    this.url = input.url
    this.credentials = input.credentials
    if (!options.headers) {
      this.headers = new Headers(input.headers)
    }
    this.method = input.method
    this.mode = input.mode
    this.signal = input.signal
    if (!body && input._bodyInit != null) {
      body = input._bodyInit
      input.bodyUsed = true
    }
  } else {
    this.url = String(input)
  }

  this.credentials = options.credentials || this.credentials || 'same-origin'
  if (options.headers || !this.headers) {
    this.headers = new Headers(options.headers)
  }
  this.method = normalizeMethod(options.method || this.method || 'GET')
  this.mode = options.mode || this.mode || null
  this.signal = options.signal || this.signal || (function () {
    if ('AbortController' in g) {
      var ctrl = new AbortController();
      return ctrl.signal;
    }
  }());
  this.referrer = null

  if ((this.method === 'GET' || this.method === 'HEAD') && body) {
    throw new TypeError('Body not allowed for GET or HEAD requests')
  }
  this._initBody(body)

  if (this.method === 'GET' || this.method === 'HEAD') {
    if (options.cache === 'no-store' || options.cache === 'no-cache') {
      // Search for a '_' parameter in the query string
      var reParamSearch = /([?&])_=[^&]*/
      if (reParamSearch.test(this.url)) {
        // If it already exists then set the value with the current time
        this.url = this.url.replace(reParamSearch, '$1_=' + new Date().getTime())
      } else {
        // Otherwise add a new '_' parameter to the end with the current time
        var reQueryString = /\?/
        this.url += (reQueryString.test(this.url) ? '&' : '?') + '_=' + new Date().getTime()
      }
    }
  }
}

Request.prototype.clone = function() {
  return new Request(this, {body: this._bodyInit})
}

function decode(body) {
  var form = new FormData()
  body
    .trim()
    .split('&')
    .forEach(function(bytes) {
      if (bytes) {
        var split = bytes.split('=')
        var name = split.shift().replace(/\+/g, ' ')
        var value = split.join('=').replace(/\+/g, ' ')
        form.append(decodeURIComponent(name), decodeURIComponent(value))
      }
    })
  return form
}

function parseHeaders(rawHeaders) {
  var headers = new Headers()
  // Replace instances of \r\n and \n followed by at least one space or horizontal tab with a space
  // https://tools.ietf.org/html/rfc7230#section-3.2
  var preProcessedHeaders = rawHeaders.replace(/\r?\n[\t ]+/g, ' ')
  // Avoiding split via regex to work around a common IE11 bug with the core-js 3.6.0 regex polyfill
  // https://github.com/github/fetch/issues/748
  // https://github.com/zloirock/core-js/issues/751
  preProcessedHeaders
    .split('\r')
    .map(function(header) {
      return header.indexOf('\n') === 0 ? header.substr(1, header.length) : header
    })
    .forEach(function(line) {
      var parts = line.split(':')
      var key = parts.shift().trim()
      if (key) {
        var value = parts.join(':').trim()
        try {
          headers.append(key, value)
        } catch (error) {
          console.warn('Response ' + error.message)
        }
      }
    })
  return headers
}

Body.call(Request.prototype)

function Response(bodyInit, options) {
  if (!(this instanceof Response)) {
    throw new TypeError('Please use the "new" operator, this DOM object constructor cannot be called as a function.')
  }
  if (!options) {
    options = {}
  }

  this.type = 'default'
  this.status = options.status === undefined ? 200 : options.status
  if (this.status < 200 || this.status > 599) {
    throw new RangeError("Failed to construct 'Response': The status provided (0) is outside the range [200, 599].")
  }
  this.ok = this.status >= 200 && this.status < 300
  this.statusText = options.statusText === undefined ? '' : '' + options.statusText
  this.headers = new Headers(options.headers)
  this.url = options.url || ''
  this._initBody(bodyInit)
}

Body.call(Response.prototype)

Response.prototype.clone = function() {
  return new Response(this._bodyInit, {
    status: this.status,
    statusText: this.statusText,
    headers: new Headers(this.headers),
    url: this.url
  })
}

Response.error = function() {
  var response = new Response(null, {status: 200, statusText: ''})
  response.ok = false
  response.status = 0
  response.type = 'error'
  return response
}

var redirectStatuses = [301, 302, 303, 307, 308]

Response.redirect = function(url, status) {
  if (redirectStatuses.indexOf(status) === -1) {
    throw new RangeError('Invalid status code')
  }

  return new Response(null, {status: status, headers: {location: url}})
}

var DOMException = g.DOMException
try {
  new DOMException()
} catch (err) {
  DOMException = function(message, name) {
    this.message = message
    this.name = name
    var error = Error(message)
    this.stack = error.stack
  }
  DOMException.prototype = Object.create(Error.prototype)
  DOMException.prototype.constructor = DOMException
}

function fetch(input, init) {
  return new Promise(function(resolve, reject) {
    var request = new Request(input, init)

    if (request.signal && request.signal.aborted) {
      return reject(new DOMException('Aborted', 'AbortError'))
    }

    var xhr = new XMLHttpRequest()

    function abortXhr() {
      xhr.abort()
    }

    xhr.onload = function() {
      var options = {
        statusText: xhr.statusText,
        headers: parseHeaders(xhr.getAllResponseHeaders() || '')
      }
      // This check if specifically for when a user fetches a file locally from the file system
      // Only if the status is out of a normal range
      if (request.url.indexOf('file://') === 0 && (xhr.status < 200 || xhr.status > 599)) {
        options.status = 200;
      } else {
        options.status = xhr.status;
      }
      options.url = 'responseURL' in xhr ? xhr.responseURL : options.headers.get('X-Request-URL')
      var body = 'response' in xhr ? xhr.response : xhr.responseText
      setTimeout(function() {
        resolve(new Response(body, options))
      }, 0)
    }

    xhr.onerror = function() {
      setTimeout(function() {
        reject(new TypeError('Network request failed'))
      }, 0)
    }

    xhr.ontimeout = function() {
      setTimeout(function() {
        reject(new TypeError('Network request timed out'))
      }, 0)
    }

    xhr.onabort = function() {
      setTimeout(function() {
        reject(new DOMException('Aborted', 'AbortError'))
      }, 0)
    }

    function fixUrl(url) {
      try {
        return url === '' && g.location.href ? g.location.href : url
      } catch (e) {
        return url
      }
    }

    xhr.open(request.method, fixUrl(request.url), true)

    if (request.credentials === 'include') {
      xhr.withCredentials = true
    } else if (request.credentials === 'omit') {
      xhr.withCredentials = false
    }

    if ('responseType' in xhr) {
      if (support.blob) {
        xhr.responseType = 'blob'
      } else if (
        support.arrayBuffer
      ) {
        xhr.responseType = 'arraybuffer'
      }
    }

    if (init && typeof init.headers === 'object' && !(init.headers instanceof Headers || (g.Headers && init.headers instanceof g.Headers))) {
      var names = [];
      Object.getOwnPropertyNames(init.headers).forEach(function(name) {
        names.push(normalizeName(name))
        xhr.setRequestHeader(name, normalizeValue(init.headers[name]))
      })
      request.headers.forEach(function(value, name) {
        if (names.indexOf(name) === -1) {
          xhr.setRequestHeader(name, value)
        }
      })
    } else {
      request.headers.forEach(function(value, name) {
        xhr.setRequestHeader(name, value)
      })
    }

    if (request.signal) {
      request.signal.addEventListener('abort', abortXhr)

      xhr.onreadystatechange = function() {
        // DONE (success or failure)
        if (xhr.readyState === 4) {
          request.signal.removeEventListener('abort', abortXhr)
        }
      }
    }

    xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
  })
}

fetch.polyfill = true

if (!g.fetch) {
  g.fetch = fetch
  g.Headers = Headers
  g.Request = Request
  g.Response = Response
}

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(29)))

/***/ }),
/* 1069 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__dictionary__ = __webpack_require__(1070);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__option__ = __webpack_require__(1071);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__project__ = __webpack_require__(1072);
/* harmony default export */ __webpack_exports__["a"] = ({dictionary:__WEBPACK_IMPORTED_MODULE_0__dictionary__["a" /* default */],option:__WEBPACK_IMPORTED_MODULE_1__option__["a" /* default */],project:__WEBPACK_IMPORTED_MODULE_2__project__["a" /* default */]});

/***/ }),
/* 1070 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var dictionary={welcomeHeading:{en:'Exclusive Preview Trip Offer',ru:'Эксклюзивная поездка для предварительного просмотра',cn:'独家看房游'},welcomeSubHeading:{en:'Thank you for your interest in our properties. To find out if you are eligible for a complimentary preview trip to Phuket, please fill in the information below and our Sales Team will get back to you shortly. Please note that fields marked with an asterisk (*) are mandatory.',ru:'Спасибо за ваш интерес к нашей недвижимости. Чтобы узнать, сможете ли Вы оформить бесплатную  поездку на Пхукет для предварительного просмотра, просьба, заполнить форму приведенную ниже. Наш отдел продаж свяжется с вами в ближайшее время. Обратите внимание, что поля, отмеченные звездочкой (*), являются обязательными для заполнения.',cn:'感谢您关注我们的项目。欲享独家看房游，请填写以下详细信息，我们的销售团队将尽快与您联系。请注意，标有星号（*）为必填栏。'},basicInformation:{en:'Basic Information',ru:'Общая информация',cn:'基本信息'},title:{en:'Title',ru:'Обращение',cn:'称谓'},name:{en:'Name',ru:'имя',cn:'名'},firstName:{en:'First Name',ru:'Имя',cn:'名'},lastName:{en:'Last Name',ru:'Фамилия',cn:'姓'},email:{en:'Email',ru:'эл почта',cn:'电邮'},phone:{en:'Phone',ru:'телефон',cn:'电话'},mobilePhone:{en:'Mobile Phone',ru:'Номер тел (моб)',cn:'电话'},landPhone:{en:'Land Phone',ru:'телефон',cn:'电话'},city:{en:'City',ru:'Город',cn:'城市'},country:{en:'Country',ru:'Страна',cn:'国家'},nationality:{en:'Nationality',ru:'Национальность',cn:'国籍'},location:{en:'Location',ru:'места',cn:'居住地'},investmentOptions:{en:'Investment Options',ru:'Инвестиционная опция',cn:'投资选项'},selectCurrency:{en:'Please select your currency',ru:'Выберите валюту',cn:'请选择币种'},selectBudget:{en:'Please select your current investment budget',ru:'Выберите текущий инвестиционный бюджет',cn:'请选择您现有投资预算'},interested:{en:'I am interested!',ru:'Я заинтересован!',cn:'我很感兴趣'},almostThere:{en:'Almost there; just a couple more questions',ru:'Почти готово; еще пара вопросов',cn:'快到了，还有几个问题'},question1:{en:'Do you already have investment(s) in Thailand or Indonesia?',ru:'Совершали ли  Вы инвестирование в Таиланде?',cn:'您是否已在泰国投资房产？'},question2:{en:'Do you already have investment(s) with Banyan Tree Group properties or its subsidiaries?',ru:'Инвестировали ли Вы в недвижимость Лагуны или ее дочерние компании до этого момента?',cn:'您是否已购入乐古浪及其相关公司房产？'},yes:{en:'Yes',ru:'Да',cn:'是'},no:{en:'No',ru:'Нет',cn:'否'},submit:{en:'Submit',ru:'Отправить',cn:'提交'},goBack:{en:'Back to our full site',ru:'Вернуться на сайт',cn:'返回乐古浪房产网站'},thankyou:{en:'Thank you for submitting your inquiry regarding our complimentary preview trip offer. Our Sales Team will contact you shortly to discuss about your investment opportunities.',ru:'Спасибо за отправку вашего запроса относительно специального бесплатного предложения тура предварительного просмотра. Наш отдел продаж свяжется с Вами в ближайшее время, чтобы обсудить инвестиционные возможности.',cn:'感谢您提交独家免费看房游的申请,我们的销售团队将尽快联系您。'},term:{en:'Term of use',ru:'ПОЛИТИКА КОНФИДЕНЦИАЛЬНОСТИ',cn:'隐私保护政策'},viewFullSite:{en:'VIEW FULL SITE',ru:'Посмотреть Полный Сайт',cn:'阅读完整内容'},privacy:{en:'Privacy Policy',ru:'ПОЛЬЗОВАТЕЛЬСКОЕ СОГЛАШЕНИЕ',cn:'使用条款'},cookiePrivacy:{en:'We use cookies on this site to improve your user experience. By continuing to use this site, you are agreeing to our',ru:'используем файлы cookie на этом сайте, чтобы улучшить ваш пользовательский интерфейс. Продолжая использовать этот сайт, вы соглашаетесь с нашей',cn:'我们在此网站使用了cookies来改善你的用户体验。继续访问网站，表示您同意我们的'},cookiePrivacyLink:{en:'Privacy Policy',ru:'Политикой Конфиденциальности',cn:'隐私政策。'},accept:{en:'I ACCEPT',ru:'ПРИНИМАЮ',cn:'同意'},backToPrevious:{en:'Back to previous page',ru:'Назад к предыдущей странице',cn:'回到上一页'},fieldRequired:{en:'This field is required.',ru:'Эта строка должна быть заполнена.',cn:'此处为必填项'}};/* harmony default export */ __webpack_exports__["a"] = (dictionary);

/***/ }),
/* 1071 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var options={titleOptions:[{label:{en:"Mr.",ru:"Мистер",cn:"先生"},value:"Mr."},{label:{en:"Mrs.",ru:"Миссис",cn:"女士"},value:"Mrs."},{label:{en:"Ms.",ru:"Мис",cn:"小姐"},value:"Ms."},{label:{en:"Dr.",ru:"Доктор",cn:"博士"},value:"Dr."},{label:{en:"Prof.",ru:"Профессор",cn:"教授"},value:"Prof."}],budgetOptions:[{label:{en:"Less than MIN million Baht",ru:"Менее MIN млн бат",cn:"Less than MIN million Baht"},value:"Less than MIN million Baht"},{label:{en:"Between MIN to MAX million Baht",ru:"От MIN до MAX млн бат",cn:"Between MIN to MAX million Baht"},value:"Between MIN to MAX million Baht"},{label:{en:"Between MIN to MAX million Baht",ru:"От MIN до MAX млн бат",cn:"Between MIN to MAX million Baht"},value:"Between MIN to MAX million Baht"},{label:{en:"More than MIN million Baht",ru:"Более MIN млн бат",cn:"More than MIN million Baht"},value:"More than MIN million Baht"}],budgetRateOptions:{THB:[{en:'< 10,000,000 THB',cn:'< 1000万泰铢',ru:'< 10,000,000 THB'// ru: '< 10 млн бат'
},{en:'10,000,000 – 20,000,000 THB',cn:'1000 – 2000 万泰铢之间',ru:'10,000,000 – 20,000,000 THB'// ru: '10 - 20 млн бат'
},{en:'20,000,000 – 40,000,000 THB',cn:'2000 – 4000 万泰铢之间',ru:'20,000,000 – 40,000,000 THB'// ru: '20 - 40 млн бат'
},{en:'> 40,000,000 THB',cn:'> 4000 万泰铢',ru:'> 40,000,000 THB'// ru: '> 40 млн бат'
}],AUD:[{en:'< 420,000 AUD',cn:'< 42 万 澳元',ru:'< 420,000 AUD'},{en:'420,000 - 840,000 AUD',cn:'42 - 84 万 澳元之间',ru:'420,000 - 840,000 AUD'},{en:'840,000 - 1,680,000 AUD',cn:'84 -168 万 澳元之间',ru:'840,000 - 1,680,000 AUD'},{en:'> 1,680,000 AUD',cn:'> 168 万 澳元',ru:'> 1,680,000 AUD'}],CNY:[{en:'< 2,000,000 CNY',cn:'< 200 万  元',ru:'< 2,000,000 CNY'},{en:'2,000,000 – 4,250,000 CNY',cn:'200 - 425 万 元之间',ru:'2,000,000 – 4,250,000 CNY'},{en:'4,250,000 – 8,500,000 CNY',cn:'425 - 850 万 元之间',ru:'4,250,000 – 8,500,000 CNY'},{en:'> 8,500,000 CNY',cn:'> 850 万 元',ru:'> 8,500,000 CNY'}],EUR:[{en:'< 270,000 EUR',cn:'< 27 万 欧元',ru:'< 270,000 EUR'},{en:'270,000 – 540,000 EUR',cn:'27 - 54 万欧元之间',ru:'270,000 – 540,000 EUR'},{en:'540,000 – 1,080,000 EUR',cn:'54 - 108 万 欧元之间',ru:'540,000 – 1,080,000 EUR'},{en:'> 1,080,000 EUR',cn:'> 108 万欧元',ru:'> 1,080,000 EUR'}],HKD:[{en:'< 2,400,000 HKD',cn:'< 240 万 港币',ru:'< 2,400,000 HKD'},{en:'2,400,000 – 4,800,000 HKD',cn:'240 - 480 万 港币之间',ru:'2,400,000 – 4,800,000 HKD'},{en:'4,800,000 – 9,500,000 HKD',cn:'480 - 950 万港币之间',ru:'4,800,000 – 9,500,000 HKD'},{en:'> 9,500,000 HKD',cn:'> 950 万港币',ru:'> 9,500,000 HKD'}],SGD:[{en:'< 420,000 SGD',cn:'< 42 万新币',ru:'< 420,000 SGD'},{en:'420,000 – 840,000 SGD',cn:'42 - 84 万新币之间',ru:'420,000 – 840,000 SGD'},{en:'840,000 – 1,670,000 SGD',cn:'84 - 167 万新币之间',ru:'840,000 – 1,670,000 SGD'},{en:'> 1,670,000 SGD',cn:'> 167 万新币',ru:'> 1,670,000 SGD'}],GBP:[{en:'< 240,000 GBP',cn:'< 24 万英镑',ru:'< 240,000 GBP'},{en:'240,000 – 480,000 GBP',cn:'24 - 48 万英镑之间',ru:'240,000 – 480,000 GBP'},{en:'480,000 – 960,000 GBP',cn:'48 - 96 万英镑之间',ru:'480,000 – 960,000 GBP'},{en:'> 960,000 GBP',cn:'> 96 万英镑',ru:'> 960,000 GBP'}],USD:[{en:'< 310,000 USD',cn:'< 31 万美元',ru:'< 310,000 USD'},{en:'310,000 – 620,000 USD',cn:'31 - 62 万美元之间',ru:'310,000 – 620,000 USD'},{en:'620,000 – 1,200,000 USD',cn:'62 - 120 万美元之间',ru:'620,000 – 1,200,000 USD'},{en:'> 1,200,000 USD',cn:'> 120 万美元',ru:'> 1,200,000 USD'}]},nationalityOptions:[{num_code:"4",alpha_2_code:"AF",alpha_3_code:"AFG",en_short_name:"Afghanistan",nationality:"Afghan"},{num_code:"248",alpha_2_code:"AX",alpha_3_code:"ALA",en_short_name:"Åland Islands",nationality:"Åland Island"},{num_code:"8",alpha_2_code:"AL",alpha_3_code:"ALB",en_short_name:"Albania",nationality:"Albanian"},{num_code:"12",alpha_2_code:"DZ",alpha_3_code:"DZA",en_short_name:"Algeria",nationality:"Algerian"},{num_code:"16",alpha_2_code:"AS",alpha_3_code:"ASM",en_short_name:"American Samoa",nationality:"American Samoan"},{num_code:"20",alpha_2_code:"AD",alpha_3_code:"AND",en_short_name:"Andorra",nationality:"Andorran"},{num_code:"24",alpha_2_code:"AO",alpha_3_code:"AGO",en_short_name:"Angola",nationality:"Angolan"},{num_code:"660",alpha_2_code:"AI",alpha_3_code:"AIA",en_short_name:"Anguilla",nationality:"Anguillan"},{num_code:"10",alpha_2_code:"AQ",alpha_3_code:"ATA",en_short_name:"Antarctica",nationality:"Antarctic"},{num_code:"28",alpha_2_code:"AG",alpha_3_code:"ATG",en_short_name:"Antigua and Barbuda",nationality:"Antiguan or Barbudan"},{num_code:"32",alpha_2_code:"AR",alpha_3_code:"ARG",en_short_name:"Argentina",nationality:"Argentine"},{num_code:"51",alpha_2_code:"AM",alpha_3_code:"ARM",en_short_name:"Armenia",nationality:"Armenian"},{num_code:"533",alpha_2_code:"AW",alpha_3_code:"ABW",en_short_name:"Aruba",nationality:"Aruban"},{num_code:"36",alpha_2_code:"AU",alpha_3_code:"AUS",en_short_name:"Australia",nationality:"Australian"},{num_code:"40",alpha_2_code:"AT",alpha_3_code:"AUT",en_short_name:"Austria",nationality:"Austrian"},{num_code:"31",alpha_2_code:"AZ",alpha_3_code:"AZE",en_short_name:"Azerbaijan",nationality:"Azerbaijani, Azeri"},{num_code:"44",alpha_2_code:"BS",alpha_3_code:"BHS",en_short_name:"Bahamas",nationality:"Bahamian"},{num_code:"48",alpha_2_code:"BH",alpha_3_code:"BHR",en_short_name:"Bahrain",nationality:"Bahraini"},{num_code:"50",alpha_2_code:"BD",alpha_3_code:"BGD",en_short_name:"Bangladesh",nationality:"Bangladeshi"},{num_code:"52",alpha_2_code:"BB",alpha_3_code:"BRB",en_short_name:"Barbados",nationality:"Barbadian"},{num_code:"112",alpha_2_code:"BY",alpha_3_code:"BLR",en_short_name:"Belarus",nationality:"Belarusian"},{num_code:"56",alpha_2_code:"BE",alpha_3_code:"BEL",en_short_name:"Belgium",nationality:"Belgian"},{num_code:"84",alpha_2_code:"BZ",alpha_3_code:"BLZ",en_short_name:"Belize",nationality:"Belizean"},{num_code:"204",alpha_2_code:"BJ",alpha_3_code:"BEN",en_short_name:"Benin",nationality:"Beninese, Beninois"},{num_code:"60",alpha_2_code:"BM",alpha_3_code:"BMU",en_short_name:"Bermuda",nationality:"Bermudian, Bermudan"},{num_code:"64",alpha_2_code:"BT",alpha_3_code:"BTN",en_short_name:"Bhutan",nationality:"Bhutanese"},{num_code:"68",alpha_2_code:"BO",alpha_3_code:"BOL",en_short_name:"Bolivia (Plurinational State of)",nationality:"Bolivian"},{num_code:"535",alpha_2_code:"BQ",alpha_3_code:"BES",en_short_name:"Bonaire, Sint Eustatius and Saba",nationality:"Bonaire"},{num_code:"70",alpha_2_code:"BA",alpha_3_code:"BIH",en_short_name:"Bosnia and Herzegovina",nationality:"Bosnian or Herzegovinian"},{num_code:"72",alpha_2_code:"BW",alpha_3_code:"BWA",en_short_name:"Botswana",nationality:"Motswana, Botswanan"},{num_code:"74",alpha_2_code:"BV",alpha_3_code:"BVT",en_short_name:"Bouvet Island",nationality:"Bouvet Island"},{num_code:"76",alpha_2_code:"BR",alpha_3_code:"BRA",en_short_name:"Brazil",nationality:"Brazilian"},{num_code:"86",alpha_2_code:"IO",alpha_3_code:"IOT",en_short_name:"British Indian Ocean Territory",nationality:"BIOT"},{num_code:"96",alpha_2_code:"BN",alpha_3_code:"BRN",en_short_name:"Brunei Darussalam",nationality:"Bruneian"},{num_code:"100",alpha_2_code:"BG",alpha_3_code:"BGR",en_short_name:"Bulgaria",nationality:"Bulgarian"},{num_code:"854",alpha_2_code:"BF",alpha_3_code:"BFA",en_short_name:"Burkina Faso",nationality:"Burkinabé"},{num_code:"108",alpha_2_code:"BI",alpha_3_code:"BDI",en_short_name:"Burundi",nationality:"Burundian"},{num_code:"132",alpha_2_code:"CV",alpha_3_code:"CPV",en_short_name:"Cabo Verde",nationality:"Cabo Verdean"},{num_code:"116",alpha_2_code:"KH",alpha_3_code:"KHM",en_short_name:"Cambodia",nationality:"Cambodian"},{num_code:"120",alpha_2_code:"CM",alpha_3_code:"CMR",en_short_name:"Cameroon",nationality:"Cameroonian"},{num_code:"124",alpha_2_code:"CA",alpha_3_code:"CAN",en_short_name:"Canada",nationality:"Canadian"},{num_code:"136",alpha_2_code:"KY",alpha_3_code:"CYM",en_short_name:"Cayman Islands",nationality:"Caymanian"},{num_code:"140",alpha_2_code:"CF",alpha_3_code:"CAF",en_short_name:"Central African Republic",nationality:"Central African"},{num_code:"148",alpha_2_code:"TD",alpha_3_code:"TCD",en_short_name:"Chad",nationality:"Chadian"},{num_code:"152",alpha_2_code:"CL",alpha_3_code:"CHL",en_short_name:"Chile",nationality:"Chilean"},{num_code:"156",alpha_2_code:"CN",alpha_3_code:"CHN",en_short_name:"China",nationality:"Chinese"},{num_code:"162",alpha_2_code:"CX",alpha_3_code:"CXR",en_short_name:"Christmas Island",nationality:"Christmas Island"},{num_code:"166",alpha_2_code:"CC",alpha_3_code:"CCK",en_short_name:"Cocos (Keeling) Islands",nationality:"Cocos Island"},{num_code:"170",alpha_2_code:"CO",alpha_3_code:"COL",en_short_name:"Colombia",nationality:"Colombian"},{num_code:"174",alpha_2_code:"KM",alpha_3_code:"COM",en_short_name:"Comoros",nationality:"Comoran, Comorian"},{num_code:"178",alpha_2_code:"CG",alpha_3_code:"COG",en_short_name:"Congo (Republic of the)",nationality:"Congolese"},{num_code:"180",alpha_2_code:"CD",alpha_3_code:"COD",en_short_name:"Congo (Democratic Republic of the)",nationality:"Congolese"},{num_code:"184",alpha_2_code:"CK",alpha_3_code:"COK",en_short_name:"Cook Islands",nationality:"Cook Island"},{num_code:"188",alpha_2_code:"CR",alpha_3_code:"CRI",en_short_name:"Costa Rica",nationality:"Costa Rican"},{num_code:"384",alpha_2_code:"CI",alpha_3_code:"CIV",en_short_name:"Côte d'Ivoire",nationality:"Ivorian"},{num_code:"191",alpha_2_code:"HR",alpha_3_code:"HRV",en_short_name:"Croatia",nationality:"Croatian"},{num_code:"192",alpha_2_code:"CU",alpha_3_code:"CUB",en_short_name:"Cuba",nationality:"Cuban"},{num_code:"531",alpha_2_code:"CW",alpha_3_code:"CUW",en_short_name:"Curaçao",nationality:"Curaçaoan"},{num_code:"196",alpha_2_code:"CY",alpha_3_code:"CYP",en_short_name:"Cyprus",nationality:"Cypriot"},{num_code:"203",alpha_2_code:"CZ",alpha_3_code:"CZE",en_short_name:"Czech Republic",nationality:"Czech"},{num_code:"208",alpha_2_code:"DK",alpha_3_code:"DNK",en_short_name:"Denmark",nationality:"Danish"},{num_code:"262",alpha_2_code:"DJ",alpha_3_code:"DJI",en_short_name:"Djibouti",nationality:"Djiboutian"},{num_code:"212",alpha_2_code:"DM",alpha_3_code:"DMA",en_short_name:"Dominica",nationality:"Dominican"},{num_code:"214",alpha_2_code:"DO",alpha_3_code:"DOM",en_short_name:"Dominican Republic",nationality:"Dominican"},{num_code:"218",alpha_2_code:"EC",alpha_3_code:"ECU",en_short_name:"Ecuador",nationality:"Ecuadorian"},{num_code:"818",alpha_2_code:"EG",alpha_3_code:"EGY",en_short_name:"Egypt",nationality:"Egyptian"},{num_code:"222",alpha_2_code:"SV",alpha_3_code:"SLV",en_short_name:"El Salvador",nationality:"Salvadoran"},{num_code:"226",alpha_2_code:"GQ",alpha_3_code:"GNQ",en_short_name:"Equatorial Guinea",nationality:"Equatorial Guinean, Equatoguinean"},{num_code:"232",alpha_2_code:"ER",alpha_3_code:"ERI",en_short_name:"Eritrea",nationality:"Eritrean"},{num_code:"233",alpha_2_code:"EE",alpha_3_code:"EST",en_short_name:"Estonia",nationality:"Estonian"},{num_code:"231",alpha_2_code:"ET",alpha_3_code:"ETH",en_short_name:"Ethiopia",nationality:"Ethiopian"},{num_code:"238",alpha_2_code:"FK",alpha_3_code:"FLK",en_short_name:"Falkland Islands (Malvinas)",nationality:"Falkland Island"},{num_code:"234",alpha_2_code:"FO",alpha_3_code:"FRO",en_short_name:"Faroe Islands",nationality:"Faroese"},{num_code:"242",alpha_2_code:"FJ",alpha_3_code:"FJI",en_short_name:"Fiji",nationality:"Fijian"},{num_code:"246",alpha_2_code:"FI",alpha_3_code:"FIN",en_short_name:"Finland",nationality:"Finnish"},{num_code:"250",alpha_2_code:"FR",alpha_3_code:"FRA",en_short_name:"France",nationality:"French"},{num_code:"254",alpha_2_code:"GF",alpha_3_code:"GUF",en_short_name:"French Guiana",nationality:"French Guianese"},{num_code:"258",alpha_2_code:"PF",alpha_3_code:"PYF",en_short_name:"French Polynesia",nationality:"French Polynesian"},{num_code:"260",alpha_2_code:"TF",alpha_3_code:"ATF",en_short_name:"French Southern Territories",nationality:"French Southern Territories"},{num_code:"266",alpha_2_code:"GA",alpha_3_code:"GAB",en_short_name:"Gabon",nationality:"Gabonese"},{num_code:"270",alpha_2_code:"GM",alpha_3_code:"GMB",en_short_name:"Gambia",nationality:"Gambian"},{num_code:"268",alpha_2_code:"GE",alpha_3_code:"GEO",en_short_name:"Georgia",nationality:"Georgian"},{num_code:"276",alpha_2_code:"DE",alpha_3_code:"DEU",en_short_name:"Germany",nationality:"German"},{num_code:"288",alpha_2_code:"GH",alpha_3_code:"GHA",en_short_name:"Ghana",nationality:"Ghanaian"},{num_code:"292",alpha_2_code:"GI",alpha_3_code:"GIB",en_short_name:"Gibraltar",nationality:"Gibraltar"},{num_code:"300",alpha_2_code:"GR",alpha_3_code:"GRC",en_short_name:"Greece",nationality:"Greek, Hellenic"},{num_code:"304",alpha_2_code:"GL",alpha_3_code:"GRL",en_short_name:"Greenland",nationality:"Greenlandic"},{num_code:"308",alpha_2_code:"GD",alpha_3_code:"GRD",en_short_name:"Grenada",nationality:"Grenadian"},{num_code:"312",alpha_2_code:"GP",alpha_3_code:"GLP",en_short_name:"Guadeloupe",nationality:"Guadeloupe"},{num_code:"316",alpha_2_code:"GU",alpha_3_code:"GUM",en_short_name:"Guam",nationality:"Guamanian, Guambat"},{num_code:"320",alpha_2_code:"GT",alpha_3_code:"GTM",en_short_name:"Guatemala",nationality:"Guatemalan"},{num_code:"831",alpha_2_code:"GG",alpha_3_code:"GGY",en_short_name:"Guernsey",nationality:"Channel Island"},{num_code:"324",alpha_2_code:"GN",alpha_3_code:"GIN",en_short_name:"Guinea",nationality:"Guinean"},{num_code:"624",alpha_2_code:"GW",alpha_3_code:"GNB",en_short_name:"Guinea-Bissau",nationality:"Bissau-Guinean"},{num_code:"328",alpha_2_code:"GY",alpha_3_code:"GUY",en_short_name:"Guyana",nationality:"Guyanese"},{num_code:"332",alpha_2_code:"HT",alpha_3_code:"HTI",en_short_name:"Haiti",nationality:"Haitian"},{num_code:"334",alpha_2_code:"HM",alpha_3_code:"HMD",en_short_name:"Heard Island and McDonald Islands",nationality:"Heard Island or McDonald Islands"},{num_code:"336",alpha_2_code:"VA",alpha_3_code:"VAT",en_short_name:"Vatican City State",nationality:"Vatican"},{num_code:"340",alpha_2_code:"HN",alpha_3_code:"HND",en_short_name:"Honduras",nationality:"Honduran"},{num_code:"344",alpha_2_code:"HK",alpha_3_code:"HKG",en_short_name:"Hong Kong",nationality:"Hong Kong, Hong Kongese"},{num_code:"348",alpha_2_code:"HU",alpha_3_code:"HUN",en_short_name:"Hungary",nationality:"Hungarian, Magyar"},{num_code:"352",alpha_2_code:"IS",alpha_3_code:"ISL",en_short_name:"Iceland",nationality:"Icelandic"},{num_code:"356",alpha_2_code:"IN",alpha_3_code:"IND",en_short_name:"India",nationality:"Indian"},{num_code:"360",alpha_2_code:"ID",alpha_3_code:"IDN",en_short_name:"Indonesia",nationality:"Indonesian"},{num_code:"364",alpha_2_code:"IR",alpha_3_code:"IRN",en_short_name:"Iran",nationality:"Iranian, Persian"},{num_code:"368",alpha_2_code:"IQ",alpha_3_code:"IRQ",en_short_name:"Iraq",nationality:"Iraqi"},{num_code:"372",alpha_2_code:"IE",alpha_3_code:"IRL",en_short_name:"Ireland",nationality:"Irish"},{num_code:"833",alpha_2_code:"IM",alpha_3_code:"IMN",en_short_name:"Isle of Man",nationality:"Manx"},{num_code:"376",alpha_2_code:"IL",alpha_3_code:"ISR",en_short_name:"Israel",nationality:"Israeli"},{num_code:"380",alpha_2_code:"IT",alpha_3_code:"ITA",en_short_name:"Italy",nationality:"Italian"},{num_code:"388",alpha_2_code:"JM",alpha_3_code:"JAM",en_short_name:"Jamaica",nationality:"Jamaican"},{num_code:"392",alpha_2_code:"JP",alpha_3_code:"JPN",en_short_name:"Japan",nationality:"Japanese"},{num_code:"832",alpha_2_code:"JE",alpha_3_code:"JEY",en_short_name:"Jersey",nationality:"Channel Island"},{num_code:"400",alpha_2_code:"JO",alpha_3_code:"JOR",en_short_name:"Jordan",nationality:"Jordanian"},{num_code:"398",alpha_2_code:"KZ",alpha_3_code:"KAZ",en_short_name:"Kazakhstan",nationality:"Kazakhstani, Kazakh"},{num_code:"404",alpha_2_code:"KE",alpha_3_code:"KEN",en_short_name:"Kenya",nationality:"Kenyan"},{num_code:"296",alpha_2_code:"KI",alpha_3_code:"KIR",en_short_name:"Kiribati",nationality:"I-Kiribati"},{num_code:"408",alpha_2_code:"KP",alpha_3_code:"PRK",en_short_name:"Korea (Democratic People's Republic of)",nationality:"North Korean"},{num_code:"410",alpha_2_code:"KR",alpha_3_code:"KOR",en_short_name:"Korea (Republic of)",nationality:"South Korean"},{num_code:"414",alpha_2_code:"KW",alpha_3_code:"KWT",en_short_name:"Kuwait",nationality:"Kuwaiti"},{num_code:"417",alpha_2_code:"KG",alpha_3_code:"KGZ",en_short_name:"Kyrgyzstan",nationality:"Kyrgyzstani, Kyrgyz, Kirgiz, Kirghiz"},{num_code:"418",alpha_2_code:"LA",alpha_3_code:"LAO",en_short_name:"Lao People's Democratic Republic",nationality:"Lao, Laotian"},{num_code:"428",alpha_2_code:"LV",alpha_3_code:"LVA",en_short_name:"Latvia",nationality:"Latvian"},{num_code:"422",alpha_2_code:"LB",alpha_3_code:"LBN",en_short_name:"Lebanon",nationality:"Lebanese"},{num_code:"426",alpha_2_code:"LS",alpha_3_code:"LSO",en_short_name:"Lesotho",nationality:"Basotho"},{num_code:"430",alpha_2_code:"LR",alpha_3_code:"LBR",en_short_name:"Liberia",nationality:"Liberian"},{num_code:"434",alpha_2_code:"LY",alpha_3_code:"LBY",en_short_name:"Libya",nationality:"Libyan"},{num_code:"438",alpha_2_code:"LI",alpha_3_code:"LIE",en_short_name:"Liechtenstein",nationality:"Liechtenstein"},{num_code:"440",alpha_2_code:"LT",alpha_3_code:"LTU",en_short_name:"Lithuania",nationality:"Lithuanian"},{num_code:"442",alpha_2_code:"LU",alpha_3_code:"LUX",en_short_name:"Luxembourg",nationality:"Luxembourg, Luxembourgish"},{num_code:"446",alpha_2_code:"MO",alpha_3_code:"MAC",en_short_name:"Macao",nationality:"Macanese, Chinese"},{num_code:"807",alpha_2_code:"MK",alpha_3_code:"MKD",en_short_name:"Macedonia (the former Yugoslav Republic of)",nationality:"Macedonian"},{num_code:"450",alpha_2_code:"MG",alpha_3_code:"MDG",en_short_name:"Madagascar",nationality:"Malagasy"},{num_code:"454",alpha_2_code:"MW",alpha_3_code:"MWI",en_short_name:"Malawi",nationality:"Malawian"},{num_code:"458",alpha_2_code:"MY",alpha_3_code:"MYS",en_short_name:"Malaysia",nationality:"Malaysian"},{num_code:"462",alpha_2_code:"MV",alpha_3_code:"MDV",en_short_name:"Maldives",nationality:"Maldivian"},{num_code:"466",alpha_2_code:"ML",alpha_3_code:"MLI",en_short_name:"Mali",nationality:"Malian, Malinese"},{num_code:"470",alpha_2_code:"MT",alpha_3_code:"MLT",en_short_name:"Malta",nationality:"Maltese"},{num_code:"584",alpha_2_code:"MH",alpha_3_code:"MHL",en_short_name:"Marshall Islands",nationality:"Marshallese"},{num_code:"474",alpha_2_code:"MQ",alpha_3_code:"MTQ",en_short_name:"Martinique",nationality:"Martiniquais, Martinican"},{num_code:"478",alpha_2_code:"MR",alpha_3_code:"MRT",en_short_name:"Mauritania",nationality:"Mauritanian"},{num_code:"480",alpha_2_code:"MU",alpha_3_code:"MUS",en_short_name:"Mauritius",nationality:"Mauritian"},{num_code:"175",alpha_2_code:"YT",alpha_3_code:"MYT",en_short_name:"Mayotte",nationality:"Mahoran"},{num_code:"484",alpha_2_code:"MX",alpha_3_code:"MEX",en_short_name:"Mexico",nationality:"Mexican"},{num_code:"583",alpha_2_code:"FM",alpha_3_code:"FSM",en_short_name:"Micronesia (Federated States of)",nationality:"Micronesian"},{num_code:"498",alpha_2_code:"MD",alpha_3_code:"MDA",en_short_name:"Moldova (Republic of)",nationality:"Moldovan"},{num_code:"492",alpha_2_code:"MC",alpha_3_code:"MCO",en_short_name:"Monaco",nationality:"Monégasque, Monacan"},{num_code:"496",alpha_2_code:"MN",alpha_3_code:"MNG",en_short_name:"Mongolia",nationality:"Mongolian"},{num_code:"499",alpha_2_code:"ME",alpha_3_code:"MNE",en_short_name:"Montenegro",nationality:"Montenegrin"},{num_code:"500",alpha_2_code:"MS",alpha_3_code:"MSR",en_short_name:"Montserrat",nationality:"Montserratian"},{num_code:"504",alpha_2_code:"MA",alpha_3_code:"MAR",en_short_name:"Morocco",nationality:"Moroccan"},{num_code:"508",alpha_2_code:"MZ",alpha_3_code:"MOZ",en_short_name:"Mozambique",nationality:"Mozambican"},{num_code:"104",alpha_2_code:"MM",alpha_3_code:"MMR",en_short_name:"Myanmar",nationality:"Burmese"},{num_code:"516",alpha_2_code:"NA",alpha_3_code:"NAM",en_short_name:"Namibia",nationality:"Namibian"},{num_code:"520",alpha_2_code:"NR",alpha_3_code:"NRU",en_short_name:"Nauru",nationality:"Nauruan"},{num_code:"524",alpha_2_code:"NP",alpha_3_code:"NPL",en_short_name:"Nepal",nationality:"Nepali, Nepalese"},{num_code:"528",alpha_2_code:"NL",alpha_3_code:"NLD",en_short_name:"Netherlands",nationality:"Dutch, Netherlandic"},{num_code:"540",alpha_2_code:"NC",alpha_3_code:"NCL",en_short_name:"New Caledonia",nationality:"New Caledonian"},{num_code:"554",alpha_2_code:"NZ",alpha_3_code:"NZL",en_short_name:"New Zealand",nationality:"New Zealand, NZ"},{num_code:"558",alpha_2_code:"NI",alpha_3_code:"NIC",en_short_name:"Nicaragua",nationality:"Nicaraguan"},{num_code:"562",alpha_2_code:"NE",alpha_3_code:"NER",en_short_name:"Niger",nationality:"Nigerien"},{num_code:"566",alpha_2_code:"NG",alpha_3_code:"NGA",en_short_name:"Nigeria",nationality:"Nigerian"},{num_code:"570",alpha_2_code:"NU",alpha_3_code:"NIU",en_short_name:"Niue",nationality:"Niuean"},{num_code:"574",alpha_2_code:"NF",alpha_3_code:"NFK",en_short_name:"Norfolk Island",nationality:"Norfolk Island"},{num_code:"580",alpha_2_code:"MP",alpha_3_code:"MNP",en_short_name:"Northern Mariana Islands",nationality:"Northern Marianan"},{num_code:"578",alpha_2_code:"NO",alpha_3_code:"NOR",en_short_name:"Norway",nationality:"Norwegian"},{num_code:"512",alpha_2_code:"OM",alpha_3_code:"OMN",en_short_name:"Oman",nationality:"Omani"},{num_code:"586",alpha_2_code:"PK",alpha_3_code:"PAK",en_short_name:"Pakistan",nationality:"Pakistani"},{num_code:"585",alpha_2_code:"PW",alpha_3_code:"PLW",en_short_name:"Palau",nationality:"Palauan"},{num_code:"275",alpha_2_code:"PS",alpha_3_code:"PSE",en_short_name:"Palestine, State of",nationality:"Palestinian"},{num_code:"591",alpha_2_code:"PA",alpha_3_code:"PAN",en_short_name:"Panama",nationality:"Panamanian"},{num_code:"598",alpha_2_code:"PG",alpha_3_code:"PNG",en_short_name:"Papua New Guinea",nationality:"Papua New Guinean, Papuan"},{num_code:"600",alpha_2_code:"PY",alpha_3_code:"PRY",en_short_name:"Paraguay",nationality:"Paraguayan"},{num_code:"604",alpha_2_code:"PE",alpha_3_code:"PER",en_short_name:"Peru",nationality:"Peruvian"},{num_code:"608",alpha_2_code:"PH",alpha_3_code:"PHL",en_short_name:"Philippines",nationality:"Philippine, Filipino"},{num_code:"612",alpha_2_code:"PN",alpha_3_code:"PCN",en_short_name:"Pitcairn",nationality:"Pitcairn Island"},{num_code:"616",alpha_2_code:"PL",alpha_3_code:"POL",en_short_name:"Poland",nationality:"Polish"},{num_code:"620",alpha_2_code:"PT",alpha_3_code:"PRT",en_short_name:"Portugal",nationality:"Portuguese"},{num_code:"630",alpha_2_code:"PR",alpha_3_code:"PRI",en_short_name:"Puerto Rico",nationality:"Puerto Rican"},{num_code:"634",alpha_2_code:"QA",alpha_3_code:"QAT",en_short_name:"Qatar",nationality:"Qatari"},{num_code:"638",alpha_2_code:"RE",alpha_3_code:"REU",en_short_name:"Réunion",nationality:"Réunionese, Réunionnais"},{num_code:"642",alpha_2_code:"RO",alpha_3_code:"ROU",en_short_name:"Romania",nationality:"Romanian"},{num_code:"643",alpha_2_code:"RU",alpha_3_code:"RUS",en_short_name:"Russian Federation",nationality:"Russian"},{num_code:"646",alpha_2_code:"RW",alpha_3_code:"RWA",en_short_name:"Rwanda",nationality:"Rwandan"},{num_code:"652",alpha_2_code:"BL",alpha_3_code:"BLM",en_short_name:"Saint Barthélemy",nationality:"Barthélemois"},{num_code:"654",alpha_2_code:"SH",alpha_3_code:"SHN",en_short_name:"Saint Helena, Ascension and Tristan da Cunha",nationality:"Saint Helenian"},{num_code:"659",alpha_2_code:"KN",alpha_3_code:"KNA",en_short_name:"Saint Kitts and Nevis",nationality:"Kittitian or Nevisian"},{num_code:"662",alpha_2_code:"LC",alpha_3_code:"LCA",en_short_name:"Saint Lucia",nationality:"Saint Lucian"},{num_code:"663",alpha_2_code:"MF",alpha_3_code:"MAF",en_short_name:"Saint Martin (French part)",nationality:"Saint-Martinoise"},{num_code:"666",alpha_2_code:"PM",alpha_3_code:"SPM",en_short_name:"Saint Pierre and Miquelon",nationality:"Saint-Pierrais or Miquelonnais"},{num_code:"670",alpha_2_code:"VC",alpha_3_code:"VCT",en_short_name:"Saint Vincent and the Grenadines",nationality:"Saint Vincentian, Vincentian"},{num_code:"882",alpha_2_code:"WS",alpha_3_code:"WSM",en_short_name:"Samoa",nationality:"Samoan"},{num_code:"674",alpha_2_code:"SM",alpha_3_code:"SMR",en_short_name:"San Marino",nationality:"Sammarinese"},{num_code:"678",alpha_2_code:"ST",alpha_3_code:"STP",en_short_name:"Sao Tome and Principe",nationality:"São Toméan"},{num_code:"682",alpha_2_code:"SA",alpha_3_code:"SAU",en_short_name:"Saudi Arabia",nationality:"Saudi, Saudi Arabian"},{num_code:"686",alpha_2_code:"SN",alpha_3_code:"SEN",en_short_name:"Senegal",nationality:"Senegalese"},{num_code:"688",alpha_2_code:"RS",alpha_3_code:"SRB",en_short_name:"Serbia",nationality:"Serbian"},{num_code:"690",alpha_2_code:"SC",alpha_3_code:"SYC",en_short_name:"Seychelles",nationality:"Seychellois"},{num_code:"694",alpha_2_code:"SL",alpha_3_code:"SLE",en_short_name:"Sierra Leone",nationality:"Sierra Leonean"},{num_code:"702",alpha_2_code:"SG",alpha_3_code:"SGP",en_short_name:"Singapore",nationality:"Singaporean"},{num_code:"534",alpha_2_code:"SX",alpha_3_code:"SXM",en_short_name:"Sint Maarten (Dutch part)",nationality:"Sint Maarten"},{num_code:"703",alpha_2_code:"SK",alpha_3_code:"SVK",en_short_name:"Slovakia",nationality:"Slovak"},{num_code:"705",alpha_2_code:"SI",alpha_3_code:"SVN",en_short_name:"Slovenia",nationality:"Slovenian, Slovene"},{num_code:"90",alpha_2_code:"SB",alpha_3_code:"SLB",en_short_name:"Solomon Islands",nationality:"Solomon Island"},{num_code:"706",alpha_2_code:"SO",alpha_3_code:"SOM",en_short_name:"Somalia",nationality:"Somali, Somalian"},{num_code:"710",alpha_2_code:"ZA",alpha_3_code:"ZAF",en_short_name:"South Africa",nationality:"South African"},{num_code:"239",alpha_2_code:"GS",alpha_3_code:"SGS",en_short_name:"South Georgia and the South Sandwich Islands",nationality:"South Georgia or South Sandwich Islands"},{num_code:"728",alpha_2_code:"SS",alpha_3_code:"SSD",en_short_name:"South Sudan",nationality:"South Sudanese"},{num_code:"724",alpha_2_code:"ES",alpha_3_code:"ESP",en_short_name:"Spain",nationality:"Spanish"},{num_code:"144",alpha_2_code:"LK",alpha_3_code:"LKA",en_short_name:"Sri Lanka",nationality:"Sri Lankan"},{num_code:"729",alpha_2_code:"SD",alpha_3_code:"SDN",en_short_name:"Sudan",nationality:"Sudanese"},{num_code:"740",alpha_2_code:"SR",alpha_3_code:"SUR",en_short_name:"Suriname",nationality:"Surinamese"},{num_code:"744",alpha_2_code:"SJ",alpha_3_code:"SJM",en_short_name:"Svalbard and Jan Mayen",nationality:"Svalbard"},{num_code:"748",alpha_2_code:"SZ",alpha_3_code:"SWZ",en_short_name:"Swaziland",nationality:"Swazi"},{num_code:"752",alpha_2_code:"SE",alpha_3_code:"SWE",en_short_name:"Sweden",nationality:"Swedish"},{num_code:"756",alpha_2_code:"CH",alpha_3_code:"CHE",en_short_name:"Switzerland",nationality:"Swiss"},{num_code:"760",alpha_2_code:"SY",alpha_3_code:"SYR",en_short_name:"Syrian Arab Republic",nationality:"Syrian"},{num_code:"158",alpha_2_code:"TW",alpha_3_code:"TWN",en_short_name:"Taiwan, Province of China",nationality:"Chinese, Taiwanese"},{num_code:"762",alpha_2_code:"TJ",alpha_3_code:"TJK",en_short_name:"Tajikistan",nationality:"Tajikistani"},{num_code:"834",alpha_2_code:"TZ",alpha_3_code:"TZA",en_short_name:"Tanzania, United Republic of",nationality:"Tanzanian"},{num_code:"764",alpha_2_code:"TH",alpha_3_code:"THA",en_short_name:"Thailand",nationality:"Thai"},{num_code:"626",alpha_2_code:"TL",alpha_3_code:"TLS",en_short_name:"Timor-Leste",nationality:"Timorese"},{num_code:"768",alpha_2_code:"TG",alpha_3_code:"TGO",en_short_name:"Togo",nationality:"Togolese"},{num_code:"772",alpha_2_code:"TK",alpha_3_code:"TKL",en_short_name:"Tokelau",nationality:"Tokelauan"},{num_code:"776",alpha_2_code:"TO",alpha_3_code:"TON",en_short_name:"Tonga",nationality:"Tongan"},{num_code:"780",alpha_2_code:"TT",alpha_3_code:"TTO",en_short_name:"Trinidad and Tobago",nationality:"Trinidadian or Tobagonian"},{num_code:"788",alpha_2_code:"TN",alpha_3_code:"TUN",en_short_name:"Tunisia",nationality:"Tunisian"},{num_code:"792",alpha_2_code:"TR",alpha_3_code:"TUR",en_short_name:"Turkey",nationality:"Turkish"},{num_code:"795",alpha_2_code:"TM",alpha_3_code:"TKM",en_short_name:"Turkmenistan",nationality:"Turkmen"},{num_code:"796",alpha_2_code:"TC",alpha_3_code:"TCA",en_short_name:"Turks and Caicos Islands",nationality:"Turks and Caicos Island"},{num_code:"798",alpha_2_code:"TV",alpha_3_code:"TUV",en_short_name:"Tuvalu",nationality:"Tuvaluan"},{num_code:"800",alpha_2_code:"UG",alpha_3_code:"UGA",en_short_name:"Uganda",nationality:"Ugandan"},{num_code:"804",alpha_2_code:"UA",alpha_3_code:"UKR",en_short_name:"Ukraine",nationality:"Ukrainian"},{num_code:"784",alpha_2_code:"AE",alpha_3_code:"ARE",en_short_name:"United Arab Emirates",nationality:"Emirati, Emirian, Emiri"},{num_code:"826",alpha_2_code:"GB",alpha_3_code:"GBR",en_short_name:"United Kingdom of Great Britain and Northern Ireland",nationality:"British, UK"},{num_code:"581",alpha_2_code:"UM",alpha_3_code:"UMI",en_short_name:"United States Minor Outlying Islands",nationality:"American"},{num_code:"840",alpha_2_code:"US",alpha_3_code:"USA",en_short_name:"United States of America",nationality:"American"},{num_code:"858",alpha_2_code:"UY",alpha_3_code:"URY",en_short_name:"Uruguay",nationality:"Uruguayan"},{num_code:"860",alpha_2_code:"UZ",alpha_3_code:"UZB",en_short_name:"Uzbekistan",nationality:"Uzbekistani, Uzbek"},{num_code:"548",alpha_2_code:"VU",alpha_3_code:"VUT",en_short_name:"Vanuatu",nationality:"Ni-Vanuatu, Vanuatuan"},{num_code:"862",alpha_2_code:"VE",alpha_3_code:"VEN",en_short_name:"Venezuela (Bolivarian Republic of)",nationality:"Venezuelan"},{num_code:"704",alpha_2_code:"VN",alpha_3_code:"VNM",en_short_name:"Vietnam",nationality:"Vietnamese"},{num_code:"92",alpha_2_code:"VG",alpha_3_code:"VGB",en_short_name:"Virgin Islands (British)",nationality:"British Virgin Island"},{num_code:"850",alpha_2_code:"VI",alpha_3_code:"VIR",en_short_name:"Virgin Islands (U.S.)",nationality:"U.S. Virgin Island"},{num_code:"876",alpha_2_code:"WF",alpha_3_code:"WLF",en_short_name:"Wallis and Futuna",nationality:"Wallis and Futuna, Wallisian or Futunan"},{num_code:"732",alpha_2_code:"EH",alpha_3_code:"ESH",en_short_name:"Western Sahara",nationality:"Sahrawi, Sahrawian, Sahraouian"},{num_code:"887",alpha_2_code:"YE",alpha_3_code:"YEM",en_short_name:"Yemen",nationality:"Yemeni"},{num_code:"894",alpha_2_code:"ZM",alpha_3_code:"ZMB",en_short_name:"Zambia",nationality:"Zambian"},{num_code:"716",alpha_2_code:"ZW",alpha_3_code:"ZWE",en_short_name:"Zimbabwe",nationality:"Zimbabwean"}],countryOptions:[],currencyOptions:[]};/* harmony default export */ __webpack_exports__["a"] = (options);

/***/ }),
/* 1072 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var projects=[{key:'dhawa',theme:'dhawa',value:'Dhawa Phuket',logo:'dhawa_180x120.png',thumbnail:'thumb-dhawa.jpg',list:[{en:'1-2 bedroom stylish apartments with lagoon views in Laguna Phuket',ru:'1 и 2-спальные стильные апартаменты с видами на озеро в Laguna Phuket',cn:'普吉岛乐古浪一卧室和二卧室时尚湖景公寓'},{en:'Managed by new hotel brand under Banyan Tree Group',ru:'Под управлением нового отельного бренда группы компаний Banyan Tree',cn:'由悦榕旗下最新酒店品牌运营'},{en:'Affordable investment opportunity',ru:'Доступные инвестиционные возможности',cn:'经济实惠的投资机遇'}]},{key:'cassia-phuket',theme:'cassia',value:'Cassia Phuket',logo:'cassia_phuket_new_180x120.png',thumbnail:'cassia_phuket_thumb_2.jpg',list:[{en:'1-2 bed seaview apartments in the heart of Laguna Phuket',ru:'1-2 спальные апартаменты с видом на море, расположенные в самом сердце Laguna Phuket',cn:'1卧至2卧海景公寓，位于普吉岛乐古浪核心位置'},{en:'A lifestyle investment with 5% guaranteed returns for 3 years',ru:'5% гарантированного дохода в течение 3 лет + возможность наслаждаться отдыхом',cn:'生活方式投资，前3年5％的年回报率'},{en:'Construction completed',ru:'Строительство завершено',cn:'项目竣工'}]},{key:'cassia-bintan',theme:'cassia',value:'Cassia Residences Bintan',logo:'cassia_bintan_180x120.png',thumbnail:'cassia_bintan_thumb_2.jpg',list:[{en:'Affordable holiday homes, beachfront 1-2 bedroom apartments',ru:'Доступные 1-2 спальные апартаменты на берегу моря',cn:'价格亲民的假日公寓, 一至二卧海景公寓'},{en:'The newest property in the Laguna Bintan integrated complex',ru:'Новый проект недвижимости в интегрированном комплексе Laguna Bintan',cn:'民丹岛乐古浪综合体最新物业'},{en:'Investment returns with lifestyle benefits*',ru:'Возврат инвестиций + преимущества проживания*',cn:'投资回报及生活方式福利兼得*'},{en:'*Terms and conditions apply',ru:'*Применяются условия и положения',cn:'*需满足一定条款和规则'}]},{key:'cassia-residences-phuket',theme:'cassia',value:'Cassia Residences Phuket',logo:'cassia_phuket_180x120.png',thumbnail:'thumb-cassia.jpg',list:[{en:'1-3 bedroom apartments in the heart of Laguna Phuket',ru:'1-3 спальные квартиры в самом сердце Laguna Phuket',cn:'位于普吉岛乐古浪核心区域的一卧至三卧公寓'},{en:'Stunning water views adjacent to Cassia Phuket Hotel',ru:'Потрясающие виды на озеро рядом с отелем Cassia Phuket',cn:'绝美水景，毗邻普吉岛悦梿酒店'},{en:'Resort lifestyle with an array of multiple shopping, dining, and leisure facilities',ru:'Курортный образ жизни с удобным доступом к магазинам, ресторанам и местам для отдыха',cn:'紧邻餐饮与购物中心'}]},{key:'park2',theme:'laguna-park',value:'Laguna Park 2 Phuket',logo:'laguna_park2_180x120.png',thumbnail:'thumb-park2.jpg',list:[{en:'A choice of Standard and Deluxe homes',ru:'Дома Стандартного и Делюкс типов на выбор',cn:'可选标准及豪华风格'},{en:'Spacious living area in a gated environment',ru:'Просторные жилые дома в закрытом комплексе',cn:'全天候安保社区里的宽敞居住环境'},{en:'Complimentary membership to Laguna Golf Phuket*',ru:'Членство в гольф-клубе Laguna Golf Phuket в качестве подарка*',cn:'普吉岛乐古浪高尔夫球场免费会员*'}]},{key:'angsana-oceanview',theme:'angsana',value:'Angsana Oceanview Residences',logo:'angsana_ocean_180x120.png',thumbnail:'thumb-angsana.jpg',list:[{en:'2 bedroom apartments, all with private pools',ru:'2-спальные апартаменты с собственным бассейном',cn:'双卧室含私人泳池公寓'},{en:'Duplex penthouses with entertaining deck and pool on upper floor',ru:'Двухуровневые пентхаусы с террасой и бассейном на крыше',cn:'複式单位带休憩甲板区及天台泳池'},{en:'All apartments feature lagoon and seaviews',ru:'Шикарный вид на озеро и море из каждых апартаментов',cn:'所有公寓以观湖和面海为特色'}]},{key:'laguna-village',theme:'laguna',value:'Laguna Village Residences',logo:'laguna_village_180x120.png',thumbnail:'thumb-laguna-village.jpg',list:[{en:'Luxurious 4-bedroom residences with private swimming pool',ru:'4х спальные резиденции класса люкс с собственнм бассейном',cn:'豪华四卧私人泳池别墅'},{en:'Perfectly positioned around tranquil lagoon',ru:'Виллы, идеально расположенные вокруг уединенного озера',cn:'泻湖环绕，景致怡人'},{en:'Discount and privileges within Laguna Phuket and Banyan Tree worldwide network*',ru:'Скидки и привилегии в сети Banyan Tree по всему миру*',cn:'尊享普吉岛乐古浪内特权和折扣*'},{en:'*Terms and conditions apply',ru:'*Применяются условия и положения',cn:'*需满足一定条款和规则'}]},{key:'dusit',theme:'dusit',value:'Dusit Laguna Resort Villas Phuket',logo:'dusit_180x120.png',thumbnail:'thumb-dusit.jpg',list:[{en:'2-3 bedroom, 3-storey elegant waterfront villas with rooftop pool',ru:'Элегантные 3-этажные виллы с 2-3-мя спальнями и собственным бассейном',cn:'两居及三居室三层湖景别墅，所有单位均设屋顶私人泳池'},{en:'Providing rental returns on investment',ru:'Возможность оправдать инвестиции за счет дохода с арендыВозможность оправдать инвестиции за счет дохода с аренды',cn:'在此投资可享受租金回报'},{en:'Professionally managed by Dusit Thani Laguna Phuket',ru:'Профессиональное управление Dusit Thani Laguna Phuket',cn:'由 普吉岛乐古浪都喜天丽酒店专业管理'}]},{key:'angsana-beachfront',theme:'angsana',value:'Angsana Beachfront Residences',logo:'angsana_beachfront_180x120.png',thumbnail:'thumb-angsana-beachfront.jpg',list:[{en:'2-3 bedroom condominiums on Bang Tao beach',ru:'Квартиры с 2-3мя спальнями на пляже Банг Тао',cn:'邦涛海滩二至三卧公寓'},{en:'Every unit features private pool and outdoor deck area',ru:'Все апартаменты оснащены собственным бассейном и открытой террасой',cn:'每套海滨住宅均设有私人泳池与户外活动区'},{en:'Managed by Angsana Laguna Phuket Resort',ru:'Под управлением «Angsana Laguna Phuket Resort»',cn:'普吉岛乐古浪悦椿度假村负责管理'}]},{key:'banyantree',theme:'banyantree',value:'Banyan Tree Grand Residences',logo:'logo-banyantree.png',thumbnail:'thumb-banyantree.jpg',list:[{en:'Elegant 3 and 5 bedroom waterfront pool villas',ru:'Элегантные 3 и 5-спальные виллы с собственным бассейноми видом на озером',cn:'典雅三卧或五卧水景泳池别墅'},{en:'Located Next to The Internationally Renowned Banyan Tree Phuket',ru:'Расположены вблизи всемирно известного отеля Banyan Tree Phuket',cn:'紧邻国际著名度假村-悦榕庄'},{en:'Contemporary residences with traditional Thai influence',ru:'Современные виллы с чертами традиционной тайской архитектуры',cn:'当代住宅融合传统泰式风情'}]}];/* harmony default export */ __webpack_exports__["a"] = (projects);

/***/ }),
/* 1073 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return sendEmailOnlyService; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_join__ = __webpack_require__(167);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_join___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_join__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch__ = __webpack_require__(376);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch__);
var serviceHost="https://api.lagunaproperty.com";// const emailSubject = "LP web – Complimentary preview trip offer";
// const to = ['mondit.thum@gmail.com', 'napat@forviz.co.th ']
// const cc = ['hlex.pon@gmail.com']
// const to = [
//   "Sherry.Jia@banyantree.com",
//   "sinniont@lagunaproperty.com",
//   "stefanoc@lagunaphuket.com"
// ];
// const cc = ["info@lagunaproperty.com"];
var sendEmailOnlyService=function sendEmailOnlyService(_ref){var subject=_ref.subject,to=_ref.to,cc=_ref.cc,reCaptchaToken=_ref.reCaptchaToken,data=_ref.data;return __WEBPACK_IMPORTED_MODULE_1_isomorphic_fetch___default()(serviceHost+"/email/send",{method:"POST",headers:{"content-type":"application/json"},body:JSON.stringify({"g-recaptcha-response":reCaptchaToken,data:data,emailSetting:{subject:subject,to:__WEBPACK_IMPORTED_MODULE_0_lodash_join___default()(to,","),cc:__WEBPACK_IMPORTED_MODULE_0_lodash_join___default()(cc,",")}})});};

/***/ }),
/* 1074 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Home; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_skrollr__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_skrollr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_skrollr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_scroll__ = __webpack_require__(23);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_scroll___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_scroll__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_helmet__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__hoc__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__actions_language__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__actions_location__ = __webpack_require__(55);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__actions_home__ = __webpack_require__(1075);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Gallery__ = __webpack_require__(1080);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Welcome__ = __webpack_require__(1081);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Promotion__ = __webpack_require__(1082);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var page="home";var mapStateToProps=function mapStateToProps(state){return Object.assign({},state);};var actionToProps={switchLanguage:__WEBPACK_IMPORTED_MODULE_7__actions_language__["a" /* switchLanguage */],switchLocation:__WEBPACK_IMPORTED_MODULE_8__actions_location__["a" /* switchLocation */],initHome:__WEBPACK_IMPORTED_MODULE_9__actions_home__["a" /* initHome */]};var Home=(_dec=Object(__WEBPACK_IMPORTED_MODULE_6__hoc__["b" /* withRedux */])(mapStateToProps,actionToProps),_dec(_class=function(_Component){_inherits(Home,_Component);function Home(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Home);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Home.__proto__||Object.getPrototypeOf(Home)).call.apply(_ref,[this].concat(args))),_this),_this.setLanguage=function(language){_this.props.actions.switchLanguage(language);},_this.fetchData=function(){_this.props.actions.initHome();},_this.renderSectionWithId=function(component,id){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_scroll__["Element"],{name:id},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("section",{id:id},component));},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Home,[{key:"componentDidMount",value:function componentDidMount(){this.setLanguage(this.props.match.params.language);this.fetchData();}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps){var currentLanguage=prevProps.match.params.language;var nextLanguage=this.props.match.params.language;if(currentLanguage!==nextLanguage){this.setLanguage(nextLanguage);}}},{key:"render",value:function render(){var pageData=__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(this.props,page+".data");var isMobile=__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(this.props,"device.isMobile");var currentLanguage=__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(this.props,"language.currentActive");return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_skrollr__["ParallaxProvider"],{init:{smoothScrollingDuration:500,smoothScrolling:true,forceHeight:false}},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5_react_helmet__["Helmet"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("title",null,"Laguna")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["f" /* Header */],{mainLogo:Object(__WEBPACK_IMPORTED_MODULE_10__utils__["a" /* assetsPath */])()+"/images/logo-laguna-property.svg",hasSubHeader:false,language:currentLanguage}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("video",{autoPlay:true,muted:true,loop:true,id:"myVideo"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("source",{src:"https://lagunaproperty.com/vdo/21486733-5.mp4",type:"video/mp4"})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"main-content laguna-village-residences-page"},this.renderSectionWithId(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Gallery__["a" /* default */],Object.assign({isRenderTitle:true},__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"gallery"),{page:page})),"Gallery"),this.renderSectionWithId(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Welcome__["a" /* default */],{title:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"concept.title"),subContent:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"concept.subContent"),content:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"concept.content"),button:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"concept.button"),page:page}),"Welcome"),this.renderSectionWithId(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Promotion__["a" /* default */],{title:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"promotion.title"),content:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"promotion.content"),button:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(pageData,"promotion.button"),page:page}),"Promotion"),this.renderSectionWithId(__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["d" /* Footer */],null))))));}}]);return Home;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class);

/***/ }),
/* 1075 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return initHome; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__ = __webpack_require__(37);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_reduce__ = __webpack_require__(45);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_reduce___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_reduce__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__actions_actionType__ = __webpack_require__(18);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__services_home__ = __webpack_require__(1076);
var _this=this;function _defineProperty(obj,key,value){if(key in obj){Object.defineProperty(obj,key,{value:value,enumerable:true,configurable:true,writable:true});}else{obj[key]=value;}return obj;}function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value;}catch(error){reject(error);return;}if(info.done){resolve(value);}else{return Promise.resolve(value).then(function(value){step("next",value);},function(err){step("throw",err);});}}return step("next");});};}var initHome=function initHome(){return function(){var _ref=_asyncToGenerator(/*#__PURE__*/__WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.mark(function _callee(dispatch){var listApi,apiResult,mapData;return __WEBPACK_IMPORTED_MODULE_0_babel_runtime_regenerator___default.a.wrap(function _callee$(_context){while(1){switch(_context.prev=_context.next){case 0:listApi=[];_context.t0=listApi;_context.next=4;return Object(__WEBPACK_IMPORTED_MODULE_3__services_home__["b" /* fetchGalleryApi */])();case 4:_context.t1=_context.sent;_context.t2={key:"gallery",data:_context.t1};_context.t0.push.call(_context.t0,_context.t2);_context.t3=listApi;_context.next=10;return Object(__WEBPACK_IMPORTED_MODULE_3__services_home__["a" /* fetchConceptApi */])();case 10:_context.t4=_context.sent;_context.t5={key:"concept",data:_context.t4};_context.t3.push.call(_context.t3,_context.t5);_context.t6=listApi;_context.next=16;return Object(__WEBPACK_IMPORTED_MODULE_3__services_home__["c" /* fetchPromotionApi */])();case 16:_context.t7=_context.sent;_context.t8={key:"promotion",data:_context.t7};_context.t6.push.call(_context.t6,_context.t8);_context.prev=19;_context.next=22;return Promise.all(listApi);case 22:apiResult=_context.sent;mapData=__WEBPACK_IMPORTED_MODULE_1_lodash_reduce___default()(apiResult,function(result,value,index){var key=value.key,data=value.data;return Object.assign({},result,_defineProperty({},key,data));},{});dispatch({type:__WEBPACK_IMPORTED_MODULE_2__actions_actionType__["b" /* RECEIVE_HOME */],data:mapData});_context.next=30;break;case 27:_context.prev=27;_context.t9=_context["catch"](19);console.error("initHome err",_context.t9);case 30:case"end":return _context.stop();}}},_callee,_this,[[19,27]]);}));return function(_x){return _ref.apply(this,arguments);};}();};

/***/ }),
/* 1076 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return fetchGalleryApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return fetchConceptApi; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return fetchPromotionApi; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__data_Home_gallery__ = __webpack_require__(1077);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__data_Home_concept__ = __webpack_require__(1078);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_Home_promotion__ = __webpack_require__(1079);
var fetchGalleryApi=function fetchGalleryApi(){return Promise.resolve(__WEBPACK_IMPORTED_MODULE_0__data_Home_gallery__["a" /* default */]);};var fetchConceptApi=function fetchConceptApi(){return Promise.resolve(__WEBPACK_IMPORTED_MODULE_1__data_Home_concept__["a" /* default */]);};var fetchPromotionApi=function fetchPromotionApi(){return Promise.resolve(__WEBPACK_IMPORTED_MODULE_2__data_Home_promotion__["a" /* default */]);};

/***/ }),
/* 1077 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(2);
var heroShotImg1=Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+"/images/gallery/hero-shot/1.jpg";var heroShotImg2=Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+"/images/gallery/hero-shot/2.jpg";var heroShotImg3=Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+"/images/gallery/hero-shot/3.jpg";var heroShotImg4=Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+"/images/gallery/hero-shot/4.jpg";var heroShotImg5=Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+"/images/gallery/hero-shot/Townhome5.jpg";var heroShotImg6=Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+"/images/gallery/hero-shot/Townhome6.jpg";var heroShot=[{image:heroShotImg1,title:{en:"title en 1",cn:"title cn 1",ru:"title ru 1"},subTitle:{en:"sub title en",cn:"sub title cn",ru:"sub title ru"},position:'left'},{image:heroShotImg2,title:{en:"title en 2",cn:"title cn 2",ru:"title ru 2"},subTitle:{en:"sub title en",cn:"sub title cn",ru:"sub title ru"},position:'right'},{image:heroShotImg3,title:{en:"title en 3",cn:"title cn 3",ru:"title ru 3"},subTitle:{en:"sub title en",cn:"sub title cn",ru:"sub title ru"},position:'left'},{image:heroShotImg4,title:{en:"title en 4",cn:"title cn 4",ru:"title ru 4"},subTitle:{en:"sub title en",cn:"sub title cn",ru:"sub title ru"},position:'right'},{image:heroShotImg5,title:{en:"title en 5",cn:"title cn 5",ru:"title ru 5"},subTitle:{en:"sub title en",cn:"sub title cn",ru:"sub title ru"},position:'left'},{image:heroShotImg6,title:{en:"title en 6",cn:"title cn 6",ru:"title ru 6"},subTitle:{en:"sub title en",cn:"sub title cn",ru:"sub title ru"},position:'right'}];/* harmony default export */ __webpack_exports__["a"] = ({heroShot:heroShot});

/***/ }),
/* 1078 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(2);
var video=Object(__WEBPACK_IMPORTED_MODULE_0__utils__["a" /* assetsPath */])('phuket-laguna-park-2')+"/images/concept/1.jpg";var title={en:["welcome","to","laguna"],cn:["欢迎来到拉古浪物业"],ru:["Добро пожаловать в","Laguna Property"]};var subContent={en:["Whether for a primary or holiday residence, Laguna Property offers an appealing and incomparable lifestyle benefits."],cn:["无论长期居住还是短期度假，拉古狼物业都能给您带来无与伦比的卓越生活享受。"],ru:["Независимо от того, что вы ищете, - основное место проживания или место для отпуска - Laguna Property предлагает несравненно привлекательные преимущества."]};var content={en:["Perfectly situated to take advantage of Laguna resort's diverse choice of attractions and amenities, homeowners can enjoy discounts and privileged access to spas, restaurants, recreation and leisure facilities, and the World’s Championship in-resort golf course."],cn:["坐拥优越的地理位置，拉古浪度假村拥有众多优美景点和便利设施。居住在此的业主可享受到折扣优惠，优先享受Spa, 餐饮和各类休闲娱乐设施以及世界顶级的高尔夫球场。"],ru:["Благодаря идеальному расположению по отношению к разнообразным возможностям и удобствам курорта Laguna, владельцы могут наслаждаться скидками и привилегированным доступом к спа-центрам, ресторанам, местам для отдыха и развлечений, а также к полю для игры в гольф, соответствующему стандартам мировых чемпионатов."]};var button={en:"Learn more >",cn:"了解更多 >",ru:"Подробнее >"};/* harmony default export */ __webpack_exports__["a"] = ({title:title,subContent:subContent,content:content,button:button,video:video});

/***/ }),
/* 1079 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0__utils__ = __webpack_require__(2);
var title={en:"Latest News/Promotions",cn:"最新消息 / 优惠促销",ru:"Последние новости / Акции"};var content=[{image:"https://lagunaproperty.com/uploads/media/media/0001/04/43493e4794561a40c82be14f9b4a2f1328932146.jpeg",text:{en:"<p>Banyan Tree Group Nurtures Growing  Residential Community With Launch Of Laguna Park Phase Two</p>",cn:"",ru:""},date:{en:"September 7, 2018",cn:"September 7, 2018",ru:"September 7, 2018"}},{image:"https://lagunaproperty.com/uploads/media/media/0001/04/43493e4794561a40c82be14f9b4a2f1328932146.jpeg",text:{en:"<p>Banyan Tree Group Nurtures Growing  Residential Community With Launch Of Laguna Park Phase Two</p>",cn:"",ru:""},date:{en:"September 7, 2018",cn:"September 7, 2018",ru:"September 7, 2018"}}];var button={en:"Learn more >",cn:"了解更多 >",ru:"Подробнее >"};/* harmony default export */ __webpack_exports__["a"] = ({title:title,content:content,button:button});

/***/ }),
/* 1080 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Gallery; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Gallery=function(_Component){_inherits(Gallery,_Component);function Gallery(){_classCallCheck(this,Gallery);return _possibleConstructorReturn(this,(Gallery.__proto__||Object.getPrototypeOf(Gallery)).apply(this,arguments));}_createClass(Gallery,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common__["e" /* Gallery */],this.props);}}]);return Gallery;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 1081 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Welcome; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components_Button__ = __webpack_require__(76);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hoc__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_class2,_temp2;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import { assetsPath } from "../../utils";
var Welcome=(_dec=Object(__WEBPACK_IMPORTED_MODULE_4__hoc__["a" /* multiLanguage */])(),_dec(_class=(_temp2=_class2=function(_Component){_inherits(Welcome,_Component);function Welcome(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Welcome);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Welcome.__proto__||Object.getPrototypeOf(Welcome)).call.apply(_ref,[this].concat(args))),_this),_this.handleClickReadMe=function(){console.log('handle click read me >>>> ');},_this.renderTitle=function(data){return __WEBPACK_IMPORTED_MODULE_0_lodash_map___default()(data,function(item){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h1",null,item);});},_this.renderSubTitle=function(data){return __WEBPACK_IMPORTED_MODULE_0_lodash_map___default()(data,function(item){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h2",null,item);});},_this.renderDetail=function(data){return __WEBPACK_IMPORTED_MODULE_0_lodash_map___default()(data,function(item){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h3",null,item);});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Welcome,[{key:"render",value:function render(){var _props=this.props,page=_props.page,t=_props.t,title=_props.title,subContent=_props.subContent,content=_props.content,button=_props.button;// console.log('page welcome >>>> ', page);
// button={_.get(pageData, "button")}
return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"section-welcome"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"content-welcome"},this.renderTitle(t(title)),this.renderSubTitle(t(subContent)),this.renderDetail(t(content)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components_Button__["a" /* default */],{type:"primary",hoverStyle:{backgroundColor:"#ffffff",color:"#04a8a6"},defaultStyle:{padding:"10px 50px",margin:"15px",backgroundColor:"#04a8a6",color:"#ffffff",border:"none"},onClick:this.handleClickReadMe},t(button))));}}]);return Welcome;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]),_class2.propTypes={t:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired},_temp2))||_class);

/***/ }),
/* 1082 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Welcome; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hoc__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class,_class2,_temp2;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}// import { assetsPath } from "../../utils";
var Welcome=(_dec=Object(__WEBPACK_IMPORTED_MODULE_3__hoc__["a" /* multiLanguage */])(),_dec(_class=(_temp2=_class2=function(_Component){_inherits(Welcome,_Component);function Welcome(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Welcome);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Welcome.__proto__||Object.getPrototypeOf(Welcome)).call.apply(_ref,[this].concat(args))),_this),_this.renderItem=function(){var _this$props=_this.props,content=_this$props.content,t=_this$props.t;return __WEBPACK_IMPORTED_MODULE_0_lodash_map___default()(content,function(item){console.log('item >>> ',item);return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"item"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("img",{style:{height:225},src:item.image,alt:""}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h2",{dangerouslySetInnerHTML:{__html:t(item.text)}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h3",{dangerouslySetInnerHTML:{__html:t(item.date)}}));});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Welcome,[{key:"render",value:function render(){var _props=this.props,page=_props.page,t=_props.t,title=_props.title,content=_props.content,button=_props.button;// console.log('page welcome >>>> ', page);
// button={_.get(pageData, "button")}
return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"section-home-promotion"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"content-home-promotion"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h1",{dangerouslySetInnerHTML:{__html:t(title)}}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"line"}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"item-container"},this.renderItem()),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("a",{href:"https://lagunaproperty.com/en/news/"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h3",{dangerouslySetInnerHTML:{__html:t(button)}}))));}}]);return Welcome;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]),_class2.propTypes={t:__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func.isRequired},_temp2))||_class);

/***/ }),
/* 1083 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_object_fit_images__ = __webpack_require__(1084);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_object_fit_images___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4_object_fit_images__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=function(_Component){_inherits(index,_Component);function index(){var _ref;var _temp,_this,_ret;_classCallCheck(this,index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=index.__proto__||Object.getPrototypeOf(index)).call.apply(_ref,[this].concat(args))),_this),_this.state={news:[],featuredNews:{}},_this.componentDidMount=function(){fetch('/en/news/json/').then(function(response){if(response.ok){return response.json();}else{throw new Error('Something went wrong ...');}}).then(function(data){_this.setState({news:data.news,featuredNews:data.featuredNews[0]});});__WEBPACK_IMPORTED_MODULE_4_object_fit_images___default()();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(index,[{key:'render',value:function render(){var _state=this.state,news=_state.news,featuredNews=_state.featuredNews;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'news-container'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'feature-news-image-anchor'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'feature-news-media1 zoomable',style:{backgroundImage:'url('+featuredNews.media+')'}}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'feature-news-article-box'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["m" /* NewsArticleSummary */],{title:featuredNews.title,dateString:__WEBPACK_IMPORTED_MODULE_5_moment___default()(__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(featuredNews.createdAt,'date')).format('MMMM D ,YYYY'),excerpt:featuredNews.excerpt,to:'/en/news/'+featuredNews.id+'/'+featuredNews.slug}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'related-news-column'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'row'},__WEBPACK_IMPORTED_MODULE_0_lodash_map___default()(news,function(perNew){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'col-xl-4'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["l" /* NewsArticleCard */],{media:perNew.media2,title:perNew.title,dateString:__WEBPACK_IMPORTED_MODULE_5_moment___default()(__WEBPACK_IMPORTED_MODULE_1_lodash_get___default()(perNew.createdAt,'date')).format('MMMM D ,YYYY'),to:'/en/news/'+perNew.id+'/'+perNew.slug,excerpt:perNew.excerpt}));}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["d" /* Footer */],null)));}}]);return index;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (index);

/***/ }),
/* 1084 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/*! npm.im/object-fit-images 3.2.4 */


var OFI = 'bfred-it:object-fit-images';
var propRegex = /(object-fit|object-position)\s*:\s*([-.\w\s%]+)/g;
var testImg = typeof Image === 'undefined' ? {style: {'object-position': 1}} : new Image();
var supportsObjectFit = 'object-fit' in testImg.style;
var supportsObjectPosition = 'object-position' in testImg.style;
var supportsOFI = 'background-size' in testImg.style;
var supportsCurrentSrc = typeof testImg.currentSrc === 'string';
var nativeGetAttribute = testImg.getAttribute;
var nativeSetAttribute = testImg.setAttribute;
var autoModeEnabled = false;

function createPlaceholder(w, h) {
	return ("data:image/svg+xml,%3Csvg xmlns='http://www.w3.org/2000/svg' width='" + w + "' height='" + h + "'%3E%3C/svg%3E");
}

function polyfillCurrentSrc(el) {
	if (el.srcset && !supportsCurrentSrc && window.picturefill) {
		var pf = window.picturefill._;
		// parse srcset with picturefill where currentSrc isn't available
		if (!el[pf.ns] || !el[pf.ns].evaled) {
			// force synchronous srcset parsing
			pf.fillImg(el, {reselect: true});
		}

		if (!el[pf.ns].curSrc) {
			// force picturefill to parse srcset
			el[pf.ns].supported = false;
			pf.fillImg(el, {reselect: true});
		}

		// retrieve parsed currentSrc, if any
		el.currentSrc = el[pf.ns].curSrc || el.src;
	}
}

function getStyle(el) {
	var style = getComputedStyle(el).fontFamily;
	var parsed;
	var props = {};
	while ((parsed = propRegex.exec(style)) !== null) {
		props[parsed[1]] = parsed[2];
	}
	return props;
}

function setPlaceholder(img, width, height) {
	// Default: fill width, no height
	var placeholder = createPlaceholder(width || 1, height || 0);

	// Only set placeholder if it's different
	if (nativeGetAttribute.call(img, 'src') !== placeholder) {
		nativeSetAttribute.call(img, 'src', placeholder);
	}
}

function onImageReady(img, callback) {
	// naturalWidth is only available when the image headers are loaded,
	// this loop will poll it every 100ms.
	if (img.naturalWidth) {
		callback(img);
	} else {
		setTimeout(onImageReady, 100, img, callback);
	}
}

function fixOne(el) {
	var style = getStyle(el);
	var ofi = el[OFI];
	style['object-fit'] = style['object-fit'] || 'fill'; // default value

	// Avoid running where unnecessary, unless OFI had already done its deed
	if (!ofi.img) {
		// fill is the default behavior so no action is necessary
		if (style['object-fit'] === 'fill') {
			return;
		}

		// Where object-fit is supported and object-position isn't (Safari < 10)
		if (
			!ofi.skipTest && // unless user wants to apply regardless of browser support
			supportsObjectFit && // if browser already supports object-fit
			!style['object-position'] // unless object-position is used
		) {
			return;
		}
	}

	// keep a clone in memory while resetting the original to a blank
	if (!ofi.img) {
		ofi.img = new Image(el.width, el.height);
		ofi.img.srcset = nativeGetAttribute.call(el, "data-ofi-srcset") || el.srcset;
		ofi.img.src = nativeGetAttribute.call(el, "data-ofi-src") || el.src;

		// preserve for any future cloneNode calls
		// https://github.com/bfred-it/object-fit-images/issues/53
		nativeSetAttribute.call(el, "data-ofi-src", el.src);
		if (el.srcset) {
			nativeSetAttribute.call(el, "data-ofi-srcset", el.srcset);
		}

		setPlaceholder(el, el.naturalWidth || el.width, el.naturalHeight || el.height);

		// remove srcset because it overrides src
		if (el.srcset) {
			el.srcset = '';
		}
		try {
			keepSrcUsable(el);
		} catch (err) {
			if (window.console) {
				console.warn('https://bit.ly/ofi-old-browser');
			}
		}
	}

	polyfillCurrentSrc(ofi.img);

	el.style.backgroundImage = "url(\"" + ((ofi.img.currentSrc || ofi.img.src).replace(/"/g, '\\"')) + "\")";
	el.style.backgroundPosition = style['object-position'] || 'center';
	el.style.backgroundRepeat = 'no-repeat';
	el.style.backgroundOrigin = 'content-box';

	if (/scale-down/.test(style['object-fit'])) {
		onImageReady(ofi.img, function () {
			if (ofi.img.naturalWidth > el.width || ofi.img.naturalHeight > el.height) {
				el.style.backgroundSize = 'contain';
			} else {
				el.style.backgroundSize = 'auto';
			}
		});
	} else {
		el.style.backgroundSize = style['object-fit'].replace('none', 'auto').replace('fill', '100% 100%');
	}

	onImageReady(ofi.img, function (img) {
		setPlaceholder(el, img.naturalWidth, img.naturalHeight);
	});
}

function keepSrcUsable(el) {
	var descriptors = {
		get: function get(prop) {
			return el[OFI].img[prop ? prop : 'src'];
		},
		set: function set(value, prop) {
			el[OFI].img[prop ? prop : 'src'] = value;
			nativeSetAttribute.call(el, ("data-ofi-" + prop), value); // preserve for any future cloneNode
			fixOne(el);
			return value;
		}
	};
	Object.defineProperty(el, 'src', descriptors);
	Object.defineProperty(el, 'currentSrc', {
		get: function () { return descriptors.get('currentSrc'); }
	});
	Object.defineProperty(el, 'srcset', {
		get: function () { return descriptors.get('srcset'); },
		set: function (ss) { return descriptors.set(ss, 'srcset'); }
	});
}

function hijackAttributes() {
	function getOfiImageMaybe(el, name) {
		return el[OFI] && el[OFI].img && (name === 'src' || name === 'srcset') ? el[OFI].img : el;
	}
	if (!supportsObjectPosition) {
		HTMLImageElement.prototype.getAttribute = function (name) {
			return nativeGetAttribute.call(getOfiImageMaybe(this, name), name);
		};

		HTMLImageElement.prototype.setAttribute = function (name, value) {
			return nativeSetAttribute.call(getOfiImageMaybe(this, name), name, String(value));
		};
	}
}

function fix(imgs, opts) {
	var startAutoMode = !autoModeEnabled && !imgs;
	opts = opts || {};
	imgs = imgs || 'img';

	if ((supportsObjectPosition && !opts.skipTest) || !supportsOFI) {
		return false;
	}

	// use imgs as a selector or just select all images
	if (imgs === 'img') {
		imgs = document.getElementsByTagName('img');
	} else if (typeof imgs === 'string') {
		imgs = document.querySelectorAll(imgs);
	} else if (!('length' in imgs)) {
		imgs = [imgs];
	}

	// apply fix to all
	for (var i = 0; i < imgs.length; i++) {
		imgs[i][OFI] = imgs[i][OFI] || {
			skipTest: opts.skipTest
		};
		fixOne(imgs[i]);
	}

	if (startAutoMode) {
		document.body.addEventListener('load', function (e) {
			if (e.target.tagName === 'IMG') {
				fix(e.target, {
					skipTest: opts.skipTest
				});
			}
		}, true);
		autoModeEnabled = true;
		imgs = 'img'; // reset to a generic selector for watchMQ
	}

	// if requested, watch media queries for object-fit change
	if (opts.watchMQ) {
		window.addEventListener('resize', fix.bind(null, imgs, {
			skipTest: opts.skipTest
		}));
	}
}

fix.supportsObjectFit = supportsObjectFit;
fix.supportsObjectPosition = supportsObjectPosition;

hijackAttributes();

module.exports = fix;


/***/ }),
/* 1085 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_last__ = __webpack_require__(166);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_last___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_last__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_router_dom__ = __webpack_require__(39);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment__ = __webpack_require__(187);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5_moment___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5_moment__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var NewsDetail=function(_Component){_inherits(NewsDetail,_Component);function NewsDetail(){var _ref;var _temp,_this,_ret;_classCallCheck(this,NewsDetail);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=NewsDetail.__proto__||Object.getPrototypeOf(NewsDetail)).call.apply(_ref,[this].concat(args))),_this),_this.state={news:[],featuredNews:{}},_this.componentDidMount=function(){fetch('/en/news/json/'+_this.props.match.params.newsId).then(function(response){if(response.ok){return response.json();}else{throw new Error('Something went wrong ...');}}).then(function(data){_this.setState({news:data.data,featuredNews:data.featuredNews});});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(NewsDetail,[{key:'render',value:function render(){var news=this.state.news;var currentLatestNews=__WEBPACK_IMPORTED_MODULE_1_lodash_last___default()(this.state.news);return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'news-container'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'container'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'news-detail-container'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_router_dom__["b" /* Link */],{to:'/en/news',className:'back-to-main'},' < Back to news')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'news-detail-img-wrapper'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('img',{alt:'head-img',src:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(news,'media')})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'article-title'},__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(news,'title')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'article-date'},__WEBPACK_IMPORTED_MODULE_5_moment___default()(__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(news,'createdAt.date')).format('MMMM D ,YYYY')),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(news,'content')}})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h2',{className:'news-detail-latest-header'},'LATEST NEWS'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'related-news-column'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["l" /* NewsArticleCard */],{media:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(currentLatestNews,'media'),title:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(currentLatestNews,'title'),dateString:__WEBPACK_IMPORTED_MODULE_5_moment___default()(__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(currentLatestNews,'createdAt.date')).format('MMMM D ,YYYY'),to:'/en/news/'+__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(currentLatestNews,'id')+'/'+__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(currentLatestNews,'slug'),excerpt:__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(currentLatestNews,'excerpt')})),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["d" /* Footer */],null)));}}]);return NewsDetail;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (NewsDetail);

/***/ }),
/* 1086 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return SanctuaryClub; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_skrollr__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_skrollr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_skrollr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hoc__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_language__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Section1__ = __webpack_require__(1087);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__About__ = __webpack_require__(1088);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Privileges__ = __webpack_require__(1090);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_9__Section4__ = __webpack_require__(1095);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_10__Section5__ = __webpack_require__(1096);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_11__Section6__ = __webpack_require__(1097);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_12__Community__ = __webpack_require__(1098);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_13__Exchange__ = __webpack_require__(1099);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_14__Locations__ = __webpack_require__(1103);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_15__Service__ = __webpack_require__(1112);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_16__Faq__ = __webpack_require__(1113);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_17__Ebrochure__ = __webpack_require__(1114);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var mapStateToProps=function mapStateToProps(state){return Object.assign({},state);};var actionToProps={switchLanguage:__WEBPACK_IMPORTED_MODULE_4__actions_language__["a" /* switchLanguage */]};var SanctuaryClub=(_dec=Object(__WEBPACK_IMPORTED_MODULE_3__hoc__["b" /* withRedux */])(mapStateToProps,actionToProps),_dec(_class=function(_Component){_inherits(SanctuaryClub,_Component);function SanctuaryClub(props){_classCallCheck(this,SanctuaryClub);var _this=_possibleConstructorReturn(this,(SanctuaryClub.__proto__||Object.getPrototypeOf(SanctuaryClub)).call(this,props));_this.setLanguage=function(language){_this.props.actions.switchLanguage(language);};_this.headerRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();return _this;}_createClass(SanctuaryClub,[{key:'componentDidMount',value:function componentDidMount(){this.setLanguage(this.props.match.params.language);}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var currentLanguage=prevProps.match.params.language;var nextLanguage=this.props.match.params.language;if(currentLanguage!==nextLanguage){this.setLanguage(nextLanguage);}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_skrollr__["ParallaxProvider"],{init:{smoothScrollingDuration:0,smoothScrolling:true,forceHeight:false}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_helmet__["Helmet"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title',null,'Laguna')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Section1__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__About__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Privileges__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_9__Section4__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_10__Section5__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_11__Section6__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_12__Community__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_13__Exchange__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_14__Locations__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_15__Service__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_16__Faq__["a" /* default */],__webpack_require__(1115)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_17__Ebrochure__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components__["d" /* Footer */],null))));}}]);return SanctuaryClub;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class);

/***/ }),
/* 1087 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_skrollr__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_skrollr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_skrollr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hoc__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var lagunaImgBackground="https://lagunaproperty.com/images/LAGUNA_IMAGE_BACKGROUND.jpg";var lagunaImgBuilding="https://lagunaproperty.com/images/LAGUNA_IMAGE_BUILDING.jpg";var section1=(_dec=Object(__WEBPACK_IMPORTED_MODULE_2__hoc__["a" /* multiLanguage */])(),_dec(_class=function(_Component){_inherits(section1,_Component);function section1(){_classCallCheck(this,section1);return _possibleConstructorReturn(this,(section1.__proto__||Object.getPrototypeOf(section1)).apply(this,arguments));}_createClass(section1,[{key:"render",value:function render(){var t=this.props.t;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"section1"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"parallax-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_skrollr__["Parallax"],{data:{"data-0-start":"transform: translateY(0px) scale(1);","data-top-bottom":"transform: translateY(10px) scale(1.3);"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"bg-background",style:{backgroundImage:"url("+lagunaImgBackground+")"}})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_skrollr__["Parallax"],{data:{"data-0-start":"transform: translateY(0px);","data-top-bottom":"transform: translateY(100px);"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"bg-building",src:lagunaImgBuilding,alt:"img-bg"}))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"section-name"},t("The Santuary Club")));}}]);return section1;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class);/* harmony default export */ __webpack_exports__["a"] = (section1);

/***/ }),
/* 1088 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return About; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hoc__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__data_SanctuaryClub_about__ = __webpack_require__(1089);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var logoImg='https://lagunaproperty.com/images/sanc-logo.png';var About=(_dec=Object(__WEBPACK_IMPORTED_MODULE_1__hoc__["a" /* multiLanguage */])(),_dec(_class=function(_Component){_inherits(About,_Component);function About(){_classCallCheck(this,About);return _possibleConstructorReturn(this,(About.__proto__||Object.getPrototypeOf(About)).apply(this,arguments));}_createClass(About,[{key:'render',value:function render(){var t=this.props.t;var content=__WEBPACK_IMPORTED_MODULE_2__data_SanctuaryClub_about__["a" /* default */].content;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section2-about'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section2-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{className:'section2-logo',src:logoImg,alt:'logo'}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section2-text'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,t("About The club")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{dangerouslySetInnerHTML:{__html:t(content.description)}}))));}}]);return About;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class);

/***/ }),
/* 1089 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var content={title:"About The club",description:{en:"<p><strong>The Group’s signature homeowners programme</strong><br><br><strong>The Santuary Club</strong> offers members a chance to enjoy a luxury lifestyle and explore a range of new destinations and experiences worldwide</p>",cn:"<p><strong>该会所针对集团会员业主开放，</strong> 提供奢华生活体验，<br>带领会员去往新目的地，提供国际化的全新体验</p>",ru:"<p><strong>Sanctuary Club,</strong><br><br>эксклюзивная программа для собственников, предоставляет ее участникам возможность наслаждаться роскошью и открывать для себя новые места и впечатления по всему миру.</p>"}};/* harmony default export */ __webpack_exports__["a"] = ({content:content});

/***/ }),
/* 1090 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Privileges; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hoc__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_SanctuaryClub_privileges__ = __webpack_require__(1091);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_ImagePlus__ = __webpack_require__(1092);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Privileges=(_dec=Object(__WEBPACK_IMPORTED_MODULE_2__hoc__["a" /* multiLanguage */])(),_dec(_class=function(_Component){_inherits(Privileges,_Component);function Privileges(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Privileges);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Privileges.__proto__||Object.getPrototypeOf(Privileges)).call.apply(_ref,[this].concat(args))),_this),_this.renderImage=function(){var allimage=__WEBPACK_IMPORTED_MODULE_3__data_SanctuaryClub_privileges__["a" /* default */].imageContent;var t=_this.props.t;return __WEBPACK_IMPORTED_MODULE_0_lodash_map___default()(allimage,function(item){return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components_ImagePlus__["a" /* default */],{src:item.thumbnail,title:t(item.title)});});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Privileges,[{key:'render',value:function render(){var content=__WEBPACK_IMPORTED_MODULE_3__data_SanctuaryClub_privileges__["a" /* default */].content;var t=this.props.t;return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'section3-privileges'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'content'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'title'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h2',null,t(content.title)),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('p',{dangerouslySetInnerHTML:{__html:t(content.description)}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'sub-title'},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('h3',{dangerouslySetInnerHTML:{__html:t(content.subTitle)}})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement('div',{className:'bg-image'},this.renderImage())));}}]);return Privileges;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class);

/***/ }),
/* 1091 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
var content={title:"Exclusive Privileges",description:{en:"Sanctuary Club members receive preferential treatment across the Banyan Group network of heritage hideaways, urban pied-à-terres and tropical getaways",ru:"Участники программы Sanctuary Club предлагается привилегированное обслуживание на исторических и тропических направлениях, а также в городских резиденциях в рамках всемирной сети комплексов корпорации Banyan Group .",cn:"榕源会的会员将享受到悦榕集团旗下传统私密之旅、现代都市之旅以及热带度假之旅的专属特权。"},subTitle:{en:"Discount privileges at worldwide resorts",ru:"СКИДКИ В КУРОРТНЫХ КОМПЛЕКСАХ ПО ВСЕМУ МИРУ",cn:"在世界各地度假村的折扣"}};var imageContent=[{id:1,title:{en:["Hotel accommodation *"],cn:["酒店住宿*"],ru:["Размещение в гостинице*"]},small:{en:["* Best available rate at time of booking, terms & conditions apply"],cn:["*预订时，享有最优折扣, 适用条款与条件"],ru:["* Лучшая доступная цена на момент бронирования, действуют правила и условия"]},thumbnail:"https://d3vqeivyse4uh3.cloudfront.net/www/lagunaproperty/images/hotel-ex.jpg",image:[{id:1,caption:{en:["Angsana Lăng Cô, Vietnam"],cn:["Angsana Lăng Cô, Vietnam"],ru:["Angsana Lăng Cô, Vietnam"]},url:"https://lagunaproperty.com/privilege/hotel/1.1%20Angsana%20Lang%20Co,%20Vietnam.jpg"},{id:2,caption:{en:["Angsana Ihuru, Maldives"],cn:["Angsana Ihuru, Maldives"],ru:["Angsana Ihuru, Maldives"]},url:"https://lagunaproperty.com/privilege/hotel/1.2 Angsana Ihuru, Maldives.jpg"},{id:3,caption:{en:["Banyan Tree Phuket, Thailand"],cn:["Banyan Tree Phuket, Thailand"],ru:["Banyan Tree Phuket, Thailand"]},url:"https://lagunaproperty.com/privilege/hotel/2.1 Banyan Tree Phuket, Thailand.jpg"},{id:4,caption:{en:["Banyan Tree Lijiang, China"],cn:["Banyan Tree Lijiang, China"],ru:["Banyan Tree Lijiang, China"]},url:"https://lagunaproperty.com/privilege/hotel/2.2 Banyan Tree Lijiang, China.jpg"},{id:5,caption:{en:["Banyan Tree Mayakoba, Mexico"],cn:["Banyan Tree Mayakoba, Mexico"],ru:["Banyan Tree Mayakoba, Mexico"]},url:"https://lagunaproperty.com/privilege/hotel/2.3 Banyan Tree Mayakoba, Mexico.jpg"},{id:7,caption:{en:["Cassia Phuket, Thailand"],cn:["Cassia Phuket, Thailand"],ru:["Cassia Phuket, Thailand"]},url:"https://lagunaproperty.com/privilege/hotel/3.1 Cassia Phuket, Thailand.jpg"},{id:8,caption:{en:["Cassia Bintan, Indonesia"],cn:["Cassia Bintan, Indonesia"],ru:["Cassia Bintan, Indonesia"]},url:"https://lagunaproperty.com/privilege/hotel/3.3 Cassia Bintan, Indonesia.jpg"},{id:9,caption:{en:["Dhawa Cayo Santa Maria, Cuba"],cn:["Dhawa Cayo Santa Maria, Cuba"],ru:["Dhawa Cayo Santa Maria, Cuba"]},url:"https://lagunaproperty.com/privilege/hotel/4. Dhawa Cayo Santa Maria, Cuba.jpg"},{id:10,caption:{en:["Dusit Thani Pool Villas, Thailand"],cn:["Dusit Thani Pool Villas, Thailand"],ru:["Dusit Thani Pool Villas, Thailand"]},url:"https://lagunaproperty.com/privilege/hotel/5. Dusit Thani Pool Villas, Thailand.jpg"}]},{id:2,title:{en:["Spa"],cn:["水疗中心"],ru:["Спа-центры"]},small:{en:[""],cn:[""],ru:[""]},thumbnail:"https://lagunaproperty.com/privilege/spa/1. Banyan Tree Spa.jpg",image:[{id:1,caption:{en:["Angsana Spa Bintan, Indonesia"],cn:["Angsana Spa Bintan, Indonesia"],ru:["Angsana Spa Bintan, Indonesia"]},url:"https://lagunaproperty.com/privilege/spa2/1. Angsana Spa Bintan, Indonesia.jpg"},{id:2,caption:{en:["Angsana Spa Hotel Nikko Shanghai, China"],cn:["Angsana Spa Hotel Nikko Shanghai, China"],ru:["Angsana Spa Hotel Nikko Shanghai, China"]},url:"https://lagunaproperty.com/privilege/spa2/2. Angsana Spa Hotel Nikko Shanghai, China.jpg"},{id:3,caption:{en:["Angsana Spa Laguna Phuket, Thailand"],cn:["Angsana Spa Laguna Phuket, Thailand"],ru:["Angsana Spa Laguna Phuket, Thailand"]},url:"https://lagunaproperty.com/privilege/spa2/3. Angsana Spa Laguna Phuket, Thailand.jpg"},{id:4,caption:{en:["Banyan Tree Spa Phuket, Thailand"],cn:["Banyan Tree Spa Phuket, Thailand"],ru:["Banyan Tree Spa Phuket, Thailand"]},url:"https://lagunaproperty.com/privilege/spa2/4. Banyan Tree Spa Phuket, Thailand.jpg"},{id:5,caption:{en:["Banyan Tree Spa Lăng Cô, Vietnam"],cn:["Banyan Tree Spa Lăng Cô, Vietnam"],ru:["Banyan Tree Spa Lăng Cô, Vietnam"]},url:"https://lagunaproperty.com/privilege/spa2/5. Banyan Tree Spa Lang Co, Vietnam.jpg"},{id:6,caption:{en:["Banyan Tree Spa Bintan, Indonesia"],cn:["Banyan Tree Spa Bintan, Indonesia"],ru:["Banyan Tree Spa Bintan, Indonesia"]},url:"https://lagunaproperty.com/privilege/spa2/6. Banyan Tree Spa Bintan, Indonesia.jpg"},{id:7,caption:{en:["Banyan Tree Spa Marina Bay Sand, Singapore"],cn:["Banyan Tree Spa Marina Bay Sand, Singapore"],ru:["Banyan Tree Spa Marina Bay Sand, Singapore"]},url:"https://lagunaproperty.com/privilege/spa2/7.Banyan Tree Spa Marina Bay Sand.jpg"},{id:8,caption:{en:["Chill Chill Laguna Phuket, Thailand"],cn:["Chill Chill Laguna Phuket, Thailand"],ru:["Chill Chill Laguna Phuket, Thailand"]},url:"https://lagunaproperty.com/privilege/spa2/8. Chill Chill Laguna Phuket, Thailand.jpg"},{id:9,caption:{en:["Chill Chill Laguna Phuket, Thailand"],cn:["Chill Chill Laguna Phuket, Thailand"],ru:["Chill Chill Laguna Phuket, Thailand"]},url:"https://lagunaproperty.com/privilege/spa2/9. Chill Chill Laguna Phuket, Thailand.jpg"}]},{id:3,title:{en:["Restaurants"],cn:["餐厅"],ru:["Рестораны"]},small:{en:[""],cn:[""],ru:[""]},thumbnail:"https://lagunaproperty.com/privilege/restaurant2/1. Angsana Lang Co, Vietnam.jpg",image:[{id:1,caption:{en:["Angsana Lăng Cô, Vietnam"],cn:["Angsana Lăng Cô, Vietnam"],ru:["Angsana Lăng Cô, Vietnam"]},url:"https://lagunaproperty.com/privilege/restaurant2/1. Angsana Lang Co, Vietnam.jpg"},{id:2,caption:{en:["Angsana Morocco, Morocco"],cn:["Angsana Morocco, Morocco"],ru:["Angsana Morocco, Morocco"]},url:"https://lagunaproperty.com/privilege/restaurant2/2. Angsana Morocco, Morocco.JPG"},{id:3,caption:{en:["Angsana Hangzhou, China"],cn:["Angsana Hangzhou, China"],ru:["Angsana Hangzhou, China"]},url:"https://lagunaproperty.com/privilege/restaurant2/3. Angsana Hangzhou, China.jpg"},{id:4,caption:{en:["Angsana Laguna Phuket, Thailand"],cn:["Angsana Laguna Phuket, Thailand"],ru:["Angsana Laguna Phuket, Thailand"]},url:"https://lagunaproperty.com/privilege/restaurant/7.jpg"},{id:5,caption:{en:["Banyan Tree Samui, Thailand"],cn:["Banyan Tree Samui, Thailand"],ru:["Banyan Tree Samui, Thailand"]},url:"https://lagunaproperty.com/privilege/restaurant2/5. Banyan Tree Samui, Thailand.jpg"},{id:6,caption:{en:["Banyan Tree Ungasan Bali, Indonesia"],cn:["Banyan Tree Ungasan Bali, Indonesia"],ru:["Banyan Tree Ungasan Bali, Indonesia"]},url:"https://lagunaproperty.com/privilege/restaurant/3.jpg"},{id:7,caption:{en:["Banyan Tree  Mayakoba, Mexico"],cn:["Banyan Tree  Mayakoba, Mexico"],ru:["Banyan Tree  Mayakoba, Mexico"]},url:"https://lagunaproperty.com/privilege/restaurant/4.jpg"},{id:8,caption:{en:["Banyan Tree Phuket, Thailand"],cn:["Banyan Tree Phuket, Thailand"],ru:["Banyan Tree Phuket, Thailand"]},url:"https://lagunaproperty.com/privilege/restaurant/6.jpg"},{id:9,caption:{en:["Banyan Tree Macau, China"],cn:["Banyan Tree Macau, China"],ru:["Banyan Tree Macau, China"]},url:"https://lagunaproperty.com/privilege/restaurant2/10. Banyan Tree Macau, China.jpg"},{id:10,caption:{en:["Banyan Tree Shanghai on the Bund, China"],cn:["Banyan Tree Shanghai on the Bund, China"],ru:["Banyan Tree Shanghai on the Bund, China"]},url:"https://lagunaproperty.com/privilege/restaurant/8.jpg"},{id:11,caption:{en:["Banyan Tree Bangkok, Thailand"],cn:["Banyan Tree Bangkok, Thailand"],ru:["Banyan Tree Bangkok, Thailand"]},url:"https://lagunaproperty.com/privilege/restaurant/2.jpg"}]},{id:4,title:{en:["Gallery merchandise"],cn:["悦榕阁及悦椿阁 精品店"],ru:["Торговые Галереи"]},small:{en:[""],cn:[""],ru:[""]},thumbnail:"https://lagunaproperty.com/images/laguna-privillage05.jpg",image:[{id:1,caption:{en:[""],cn:[""],ru:[""]},url:"https://lagunaproperty.com/privilege/merchandise/1.jpg"},{id:2,caption:{en:[""],cn:[""],ru:[""]},url:"https://lagunaproperty.com/privilege/merchandise/2.jpg"},{id:3,caption:{en:[""],cn:[""],ru:[""]},url:"https://lagunaproperty.com/privilege/merchandise/3.jpg"},{id:4,caption:{en:[""],cn:[""],ru:[""]},url:"https://lagunaproperty.com/privilege/merchandise/4.jpg"},{id:5,caption:{en:[""],cn:[""],ru:[""]},url:"https://lagunaproperty.com/privilege/merchandise/5.JPG"},{id:6,caption:{en:[""],cn:[""],ru:[""]},url:"https://lagunaproperty.com/privilege/merchandise/6.jpg"},{id:7,caption:{en:[""],cn:[""],ru:[""]},url:"https://lagunaproperty.com/privilege/merchandise/7.JPG"},{id:8,caption:{en:[""],cn:[""],ru:[""]},url:"https://lagunaproperty.com/privilege/merchandise/8.JPG"},{id:9,caption:{en:[""],cn:[""],ru:[""]},url:"https://lagunaproperty.com/privilege/merchandise/9.JPG"},{id:10,caption:{en:[""],cn:[""],ru:[""]},url:"https://lagunaproperty.com/privilege/merchandise/10.JPG"},{id:11,caption:{en:[""],cn:[""],ru:[""]},url:"https://lagunaproperty.com/privilege/merchandise/11.jpg"},{id:12,caption:{en:[""],cn:[""],ru:[""]},url:"https://lagunaproperty.com/privilege/merchandise/12.jpg"}]},{id:5,title:{en:["Airport and ferry transfers**"],cn:["机场和渡轮码头的接送**"],ru:["Трансфер до/из аэропорта и паромных переправ**"]},small:{en:["**Selected destinations only"],cn:["**仅限于可选的旅居地"],ru:["**Только избранные направления"]},thumbnail:"https://lagunaproperty.com/images/ex-air.jpg",image:[{id:1,caption:{en:[""],cn:[""],ru:[""]},url:"https://lagunaproperty.com/privilege/airport/1.jpg"},{id:2,caption:{en:[""],cn:[""],ru:[""]},url:"https://lagunaproperty.com/privilege/airport/2.jpg"},{id:3,caption:{en:[""],cn:[""],ru:[""]},url:"https://lagunaproperty.com/privilege/airport/3.jpg"}]},{id:6,title:{en:["Golf (Phuket, Bintan & Lăng Cô)"],cn:["高尔夫（普吉岛、民丹岛、兰珂）"],ru:["Гольф (Пхукет, Бинтан, Ланг Ко)"]},small:{en:[""],cn:[""],ru:[""]},thumbnail:"https://lagunaproperty.com/privilege/golf/1. Laguna Golf Phuket.jpg",image:[{id:1,caption:{en:["Laguna Golf Phuket, Thailand"],cn:["Laguna Golf Phuket, Thailand"],ru:["Laguna Golf Phuket, Thailand"]},url:"https://lagunaproperty.com/privilege/golf/2. Laguna Golf Phuket.jpg"},{id:2,caption:{en:["Laguna Golf Phuket, Thailand"],cn:["Laguna Golf Phuket, Thailand"],ru:["Laguna Golf Phuket, Thailand"]},url:"https://lagunaproperty.com/privilege/golf/3. Laguna Golf Phuket.jpg"},{id:3,caption:{en:["Laguna Golf Phuket, Thailand"],cn:["Laguna Golf Phuket, Thailand"],ru:["Laguna Golf Phuket, Thailand"]},url:"https://lagunaproperty.com/privilege/airport/3.jpg"},{id:4,caption:{en:["Laguna Golf Bintan, Indonesia"],cn:["Laguna Golf Bintan, Indonesia"],ru:["Laguna Golf Bintan, Indonesia"]},url:"https://lagunaproperty.com/privilege/golf/4. Laguna Golf Bintan.jpg"},{id:5,caption:{en:["Laguna Golf Bintan, Indonesia"],cn:["Laguna Golf Bintan, Indonesia"],ru:["Laguna Golf Bintan, Indonesia"]},url:"https://lagunaproperty.com/privilege/golf/5. Laguna Golf Bintan.JPG"},{id:5,caption:{en:["Laguna Golf Bintan, Indonesia"],cn:["Laguna Golf Bintan, Indonesia"],ru:["Laguna Golf Bintan, Indonesia"]},url:"https://lagunaproperty.com/privilege/golf/6. Laguna Golf Bintan.JPG"},{id:6,caption:{en:["Laguna Golf Lăng Cô, Vietnam"],cn:["Laguna Golf Lăng Cô, Vietnam"],ru:["Laguna Golf Lăng Cô, Vietnam"]},url:"https://lagunaproperty.com/privilege/golf/7. Laguna Golf Lang Co.jpg"},{id:7,caption:{en:["Laguna Golf Lăng Cô, Vietnam"],cn:["Laguna Golf Lăng Cô, Vietnam"],ru:["Laguna Golf Lăng Cô, Vietnam"]},url:"https://lagunaproperty.com/privilege/golf/8. Laguna Golf Lang Co.jpg"}]},{id:7,title:{en:["In-house tours"],cn:["内部参观"],ru:["Внутренние экскурсионные туры"]},small:{en:[""],cn:[""],ru:[""]},thumbnail:"https://lagunaproperty.com/privilege/tour/7.JPG",image:[{id:1,caption:{en:[""],cn:[""],ru:[""]},url:"https://lagunaproperty.com/privilege/tour/MMB_7495.JPG"},{id:2,caption:{en:[""],cn:[""],ru:[""]},url:"https://lagunaproperty.com/privilege/tour/2.jpg"},{id:3,caption:{en:[""],cn:[""],ru:[""]},url:"https://lagunaproperty.com/privilege/tour/MMB_7201.JPG"},{id:4,caption:{en:[""],cn:[""],ru:[""]},url:"https://lagunaproperty.com/privilege/tour/5.jpg"},{id:5,caption:{en:[""],cn:[""],ru:[""]},url:"https://lagunaproperty.com/privilege/tour/6.jpg"},{id:5,caption:{en:[""],cn:[""],ru:[""]},url:"https://lagunaproperty.com/privilege/tour/MMB_8553.JPG"}]}];/* harmony default export */ __webpack_exports__["a"] = ({content:content,imageContent:imageContent});

/***/ }),
/* 1092 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return ImagePlus; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_icons_lib_io_android_add__ = __webpack_require__(1093);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_icons_lib_io_android_add___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_icons_lib_io_android_add__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__Image__ = __webpack_require__(230);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _class,_temp2;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var noImageAvailable=Object(__WEBPACK_IMPORTED_MODULE_3__utils__["a" /* assetsPath */])("phuket-laguna-village-residences")+"/images/No_Image_Available.jpg";var ImagePlus=(_temp2=_class=function(_PureComponent){_inherits(ImagePlus,_PureComponent);function ImagePlus(){var _ref;var _temp,_this,_ret;_classCallCheck(this,ImagePlus);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=ImagePlus.__proto__||Object.getPrototypeOf(ImagePlus)).call.apply(_ref,[this].concat(args))),_this),_this.renderTitle=function(title){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",{style:{paddingLeft:0,paddingTop:10}},title);},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(ImagePlus,[{key:"render",value:function render(){var _props=this.props,alt=_props.alt,src=_props.src,title=_props.title;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"image-plus-container marginLeft"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"image-plus-content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__Image__["a" /* default */],{className:"image-plus-item",src:src,alt:alt}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"plus-arrow"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_icons_lib_io_android_add___default.a,{className:"icon-name"}))),this.renderTitle(title));}}]);return ImagePlus;}(__WEBPACK_IMPORTED_MODULE_0_react__["PureComponent"]),_class.propTypes={src:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string,alt:__WEBPACK_IMPORTED_MODULE_1_prop_types___default.a.string},_class.defaultProps={src:noImageAvailable,alt:"Laguna"},_temp2);

/***/ }),
/* 1093 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = __webpack_require__(1094);

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoAndroidAdd = function IoAndroidAdd(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm32.5 21.6h-10.9v10.9h-3.2v-10.9h-10.9v-3.2h10.9v-10.9h3.2v10.9h10.9v3.2z' })
        )
    );
};

exports.default = IoAndroidAdd;
module.exports = exports['default'];

/***/ }),
/* 1094 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = __webpack_require__(0);

var _react2 = _interopRequireDefault(_react);

var _propTypes = __webpack_require__(1);

var _propTypes2 = _interopRequireDefault(_propTypes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }

var IconBase = function IconBase(_ref, _ref2) {
  var children = _ref.children;
  var color = _ref.color;
  var size = _ref.size;
  var style = _ref.style;
  var width = _ref.width;
  var height = _ref.height;

  var props = _objectWithoutProperties(_ref, ['children', 'color', 'size', 'style', 'width', 'height']);

  var _ref2$reactIconBase = _ref2.reactIconBase;
  var reactIconBase = _ref2$reactIconBase === undefined ? {} : _ref2$reactIconBase;

  var computedSize = size || reactIconBase.size || '1em';
  return _react2.default.createElement('svg', _extends({
    children: children,
    fill: 'currentColor',
    preserveAspectRatio: 'xMidYMid meet',
    height: height || computedSize,
    width: width || computedSize
  }, reactIconBase, props, {
    style: _extends({
      verticalAlign: 'middle',
      color: color || reactIconBase.color
    }, reactIconBase.style || {}, style)
  }));
};

IconBase.propTypes = {
  color: _propTypes2.default.string,
  size: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  width: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  height: _propTypes2.default.oneOfType([_propTypes2.default.string, _propTypes2.default.number]),
  style: _propTypes2.default.object
};

IconBase.contextTypes = {
  reactIconBase: _propTypes2.default.shape(IconBase.propTypes)
};

exports.default = IconBase;
module.exports = exports['default'];

/***/ }),
/* 1095 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hoc__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var bgImg='https://lagunaproperty.com/images/47249213-H1-ANVNLC_FH_0612_AN_Two_Bedroom_Loft_8615.jpg';var Section4=(_dec=Object(__WEBPACK_IMPORTED_MODULE_2__hoc__["a" /* multiLanguage */])(),_dec(_class=function(_Component){_inherits(Section4,_Component);function Section4(){_classCallCheck(this,Section4);return _possibleConstructorReturn(this,(Section4.__proto__||Object.getPrototypeOf(Section4)).apply(this,arguments));}_createClass(Section4,[{key:'render',value:function render(){var t=this.props.t;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section4'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components__["e" /* GradientPage */],{image:bgImg},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text',dangerouslySetInnerHTML:{__html:t('Priority wait list on reservations')}})));}}]);return Section4;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class);/* harmony default export */ __webpack_exports__["a"] = (Section4);

/***/ }),
/* 1096 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Section5; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var image='https://lagunaproperty.com/images/03-sanctuary-club_41.jpg';var Section5=function(_Component){_inherits(Section5,_Component);function Section5(){_classCallCheck(this,Section5);return _possibleConstructorReturn(this,(Section5.__proto__||Object.getPrototypeOf(Section5)).apply(this,arguments));}_createClass(Section5,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"section5"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",null,"Early check-in / late check-out*"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"*Subject to availability on day of arrival / departure")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:image,alt:"img"}));}}]);return Section5;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 1097 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Section6; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_skrollr__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_skrollr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_skrollr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hoc__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var imageSlider=[{image:'https://lagunaproperty.com/images/invi1.jpg'},{image:'https://lagunaproperty.com/images/invi2.jpg'},{image:'https://lagunaproperty.com/images/invi3.jpg'},{image:'https://lagunaproperty.com/images/invi4.jpg'},{image:'https://lagunaproperty.com/images/invi5.jpg'},{image:'https://lagunaproperty.com/images/invi6.jpg'}];var Section6=(_dec=Object(__WEBPACK_IMPORTED_MODULE_2__hoc__["a" /* multiLanguage */])(),_dec(_class=function(_Component){_inherits(Section6,_Component);function Section6(){_classCallCheck(this,Section6);return _possibleConstructorReturn(this,(Section6.__proto__||Object.getPrototypeOf(Section6)).apply(this,arguments));}_createClass(Section6,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section6'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{'class':'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h3',null,'Invitations to join Xperential Guest Programme'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Pre-opening, trial stays at new resorts')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'image-slider-block'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'parallax-container'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_skrollr__["Parallax"],{data:{'data-86-bottom-top':'transform: translateY(-100px); filter: blur(300px) saturate(2);','data-250-top':'transform: translateY(0px); filter: blur(0px) saturate(1);'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["p" /* Slider */],{type:'type-background',sliderRef:this.sliderRef,items:imageSlider,settings:{arrows:false},uiRenderer:function uiRenderer(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'img-background',style:{backgroundImage:'url('+item.image+')',backgroundPosition:item.backgroundPosition}});}})))));}}]);return Section6;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class);

/***/ }),
/* 1098 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Community; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map__ = __webpack_require__(8);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_map___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_map__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_size__ = __webpack_require__(110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_size___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_size__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hoc__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var imageSlider=[{image:"https://lagunaproperty.com/images/com/Laguna.JPG"},{image:"https://lagunaproperty.com/images/com/Cassia.JPG"},{image:"https://lagunaproperty.com/images/com/Angsana.jpg"},{image:"https://lagunaproperty.com/images/com/Dhawa.jpg"},{image:"https://lagunaproperty.com/images/kim.jpg"}];var logoImage=[{image:"https://lagunaproperty.com/images/x1.png"},{image:"https://lagunaproperty.com/images/x2.png"},{image:"https://lagunaproperty.com/images/x3.png"},{image:"https://lagunaproperty.com/images/x4.png"},{image:"https://lagunaproperty.com/images/x5.png"}];var Community=(_dec=Object(__WEBPACK_IMPORTED_MODULE_3__hoc__["a" /* multiLanguage */])(),_dec(_class=function(_Component){_inherits(Community,_Component);function Community(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Community);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Community.__proto__||Object.getPrototypeOf(Community)).call.apply(_ref,[this].concat(args))),_this),_this.state={logoAcive:0},_this.countlogoAcive=function(){setInterval(function(){var logoAcive=_this.state.logoAcive;var nextLogoAcive=logoAcive===__WEBPACK_IMPORTED_MODULE_1_lodash_size___default()(logoImage)-1?0:logoAcive+1;_this.setState({logoAcive:nextLogoAcive});},5000);},_this.componentDidMount=function(){_this.countlogoAcive();},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Community,[{key:"render",value:function render(){var logoAcive=this.state.logoAcive;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{className:"section7-community"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{className:"bg-left"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{className:"container-content"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("h2",null,"Banyan Group Community"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("p",null,"Invitation to Banyan Tree organized events worldwide"),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{"class":"logo-group"},__WEBPACK_IMPORTED_MODULE_0_lodash_map___default()(logoImage,function(logo,key){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{"class":"logo-img "+(logoAcive===key?"logo-active":"")},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("img",{alt:"",src:logo.image}));})))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{className:"container-slider"},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4__components__["p" /* Slider */],{type:"type-background",sliderRef:this.sliderRef,items:imageSlider,settings:{arrows:false},uiRenderer:function uiRenderer(item,index){return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement("div",{className:"img-background",style:{backgroundImage:"url("+item.image+")",backgroundPosition:item.backgroundPosition}});}})));}}]);return Community;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]))||_class);

/***/ }),
/* 1099 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Exchange; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hoc__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_SanctuaryClub_exchange__ = __webpack_require__(1100);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_images_icons_arrowLeft_svg__ = __webpack_require__(1101);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__components_images_icons_arrowLeft_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_4__components_images_icons_arrowLeft_svg__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_images_icons_arrowRight_svg__ = __webpack_require__(1102);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components_images_icons_arrowRight_svg___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_5__components_images_icons_arrowRight_svg__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var createArrowButton=function createArrowButton(direction){return function(props){var className=props.className,style=props.style,onClick=props.onClick;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("button",{className:className,style:style,onClick:onClick},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{className:"arrow-button-image",src:direction==="left"?__WEBPACK_IMPORTED_MODULE_4__components_images_icons_arrowLeft_svg___default.a:__WEBPACK_IMPORTED_MODULE_5__components_images_icons_arrowRight_svg___default.a,alt:""}));};};var NextButton=createArrowButton("right");var PrevButton=createArrowButton("left");var Exchange=(_dec=Object(__WEBPACK_IMPORTED_MODULE_1__hoc__["a" /* multiLanguage */])(),_dec(_class=function(_Component){_inherits(Exchange,_Component);function Exchange(){_classCallCheck(this,Exchange);return _possibleConstructorReturn(this,(Exchange.__proto__||Object.getPrototypeOf(Exchange)).apply(this,arguments));}_createClass(Exchange,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"section8-exchange",style:{backgroundImage:"url("+__WEBPACK_IMPORTED_MODULE_3__data_SanctuaryClub_exchange__["a" /* bgImage */]+")"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"block-content"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h2",null,"The Exchange Programme"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Owners whose properties are managed under a hotel branded rental scheme are allowed to exchange part of their annual entitlement for a complimentary stay at any destination within The Santuary Club network"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h3",null,"The Exchange Process"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container-slider"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["p" /* Slider */],{type:"type-background",sliderRef:this.sliderRef,items:__WEBPACK_IMPORTED_MODULE_3__data_SanctuaryClub_exchange__["b" /* gifImage */],settings:{arrows:true,dots:true,fade:false,nextArrow:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(NextButton,null),prevArrow:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(PrevButton,null)},uiRenderer:function uiRenderer(item,index){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"container-content-img"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"img-background",style:{backgroundImage:"url("+item.image+")",backgroundPosition:item.backgroundPosition}}),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,item.text));}}))));}}]);return Exchange;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class);

/***/ }),
/* 1100 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return gifImage; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bgImage; });
var bgImage='https://d3vqeivyse4uh3.cloudfront.net/www/lagunaproperty/images/03-sanctuary-club_49.jpg';var gifImage=[{image:'https://lagunaproperty.com/images/exchange-1.gif',text:'An owner deposits 15 annual entitlement days into the exchange pool'},{image:'https://lagunaproperty.com/images/exchange-2.gif',text:'The days are attributed a monetary value'},{image:'https://lagunaproperty.com/images/exchange-3.gif',text:'The monetary value can then be used to redeem stays at participating properties at the best available rate at time of booking'},{image:'https://lagunaproperty.com/images/exchange-4.gif',text:'Booking can be requested via the centralised multilingual team'},{image:'https://lagunaproperty.com/images/exchange-5.gif',text:'A confirmation of your reservation will be sent to you along with value redeemed and your remaining balance'},{image:'https://lagunaproperty.com/images/exchange-6.gif',text:'Enjoy your stays at participating properties'}];

/***/ }),
/* 1101 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/arrowLeft.9653a2c4.svg";

/***/ }),
/* 1102 */
/***/ (function(module, exports, __webpack_require__) {

module.exports = __webpack_require__.p + "static/media/arrowRight.db8bff37.svg";

/***/ }),
/* 1103 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Locations; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_padStart__ = __webpack_require__(1104);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_padStart___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_padStart__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_find__ = __webpack_require__(22);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_lodash_find___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_lodash_find__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_countup__ = __webpack_require__(1107);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_countup___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_countup__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4_react_waypoint__ = __webpack_require__(1109);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__hoc__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__data_SanctuaryClub_locations__ = __webpack_require__(1111);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Locations=(_dec=Object(__WEBPACK_IMPORTED_MODULE_5__hoc__["a" /* multiLanguage */])(),_dec(_class=function(_Component){_inherits(Locations,_Component);function Locations(){var _ref;var _temp,_this,_ret;_classCallCheck(this,Locations);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=Locations.__proto__||Object.getPrototypeOf(Locations)).call.apply(_ref,[this].concat(args))),_this),_this.state={isAppear:false,page:'all'},_this.onEnter=function(){_this.setState({isAppear:true});},_this.onLeave=function(){_this.setState({isAppear:false});},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(Locations,[{key:'render',value:function render(){var _this2=this;var _state=this.state,page=_state.page,isAppear=_state.isAppear;var t=this.props.t;var displayData=__WEBPACK_IMPORTED_MODULE_1_lodash_find___default()(__WEBPACK_IMPORTED_MODULE_7__data_SanctuaryClub_locations__["a" /* mapData */],['value',page]);return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'section9-locations'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components__["a" /* BackgroundImage */],{image:displayData.image,size:'contain'}),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'run-number'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('h2',null,'Number of locations'),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('span',{className:'count'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_4_react_waypoint__["a" /* default */],{onEnter:this.onEnter,onLeave:this.onLeave}),isAppear&&__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3_react_countup___default.a,{start:0,end:displayData.count,prefix:'0',duration:3,formattingFn:function formattingFn(value){return __WEBPACK_IMPORTED_MODULE_0_lodash_padStart___default()(value,2,0);}}))),__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement('div',{className:'networks-button-group'},__WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components__["c" /* ButtonGroup */],{value:page,items:__WEBPACK_IMPORTED_MODULE_7__data_SanctuaryClub_locations__["a" /* mapData */],onChange:function onChange(value){return _this2.setState({page:value});},direction:'horizontal',renderItem:function renderItem(_ref2){var value=_ref2.value,name=_ref2.name,active=_ref2.active,onClick=_ref2.onClick;return __WEBPACK_IMPORTED_MODULE_2_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__components__["b" /* Button */],{key:value,type:'secondary',active:active,activeStyle:{backgroundColor:'#00a9a5'},hoverStyle:{backgroundColor:'#00a9a5'},defaultStyle:{padding:'10px 15px',marginRight:'1px',fontWeight:'bold',fontSize:'13px',letterSpacing:'1px'},onClick:onClick},t(name));}})));}}]);return Locations;}(__WEBPACK_IMPORTED_MODULE_2_react__["Component"]))||_class);

/***/ }),
/* 1104 */
/***/ (function(module, exports, __webpack_require__) {

var createPadding = __webpack_require__(1105),
    stringSize = __webpack_require__(193),
    toInteger = __webpack_require__(165),
    toString = __webpack_require__(74);

/**
 * Pads `string` on the left side if it's shorter than `length`. Padding
 * characters are truncated if they exceed `length`.
 *
 * @static
 * @memberOf _
 * @since 4.0.0
 * @category String
 * @param {string} [string=''] The string to pad.
 * @param {number} [length=0] The padding length.
 * @param {string} [chars=' '] The string used as padding.
 * @returns {string} Returns the padded string.
 * @example
 *
 * _.padStart('abc', 6);
 * // => '   abc'
 *
 * _.padStart('abc', 6, '_-');
 * // => '_-_abc'
 *
 * _.padStart('abc', 3);
 * // => 'abc'
 */
function padStart(string, length, chars) {
  string = toString(string);
  length = toInteger(length);

  var strLength = length ? stringSize(string) : 0;
  return (length && strLength < length)
    ? (createPadding(length - strLength, chars) + string)
    : string;
}

module.exports = padStart;


/***/ }),
/* 1105 */
/***/ (function(module, exports, __webpack_require__) {

var baseRepeat = __webpack_require__(1106),
    baseToString = __webpack_require__(159),
    castSlice = __webpack_require__(162),
    hasUnicode = __webpack_require__(99),
    stringSize = __webpack_require__(193),
    stringToArray = __webpack_require__(163);

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeCeil = Math.ceil;

/**
 * Creates the padding for `string` based on `length`. The `chars` string
 * is truncated if the number of characters exceeds `length`.
 *
 * @private
 * @param {number} length The padding length.
 * @param {string} [chars=' '] The string used as padding.
 * @returns {string} Returns the padding for `string`.
 */
function createPadding(length, chars) {
  chars = chars === undefined ? ' ' : baseToString(chars);

  var charsLength = chars.length;
  if (charsLength < 2) {
    return charsLength ? baseRepeat(chars, length) : chars;
  }
  var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
  return hasUnicode(chars)
    ? castSlice(stringToArray(result), 0, length).join('')
    : result.slice(0, length);
}

module.exports = createPadding;


/***/ }),
/* 1106 */
/***/ (function(module, exports) {

/** Used as references for various `Number` constants. */
var MAX_SAFE_INTEGER = 9007199254740991;

/* Built-in method references for those with the same name as other `lodash` methods. */
var nativeFloor = Math.floor;

/**
 * The base implementation of `_.repeat` which doesn't coerce arguments.
 *
 * @private
 * @param {string} string The string to repeat.
 * @param {number} n The number of times to repeat the string.
 * @returns {string} Returns the repeated string.
 */
function baseRepeat(string, n) {
  var result = '';
  if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
    return result;
  }
  // Leverage the exponentiation by squaring algorithm for a faster repeat.
  // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
  do {
    if (n % 2) {
      result += string;
    }
    n = nativeFloor(n / 2);
    if (n) {
      string += string;
    }
  } while (n);

  return result;
}

module.exports = baseRepeat;


/***/ }),
/* 1107 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, '__esModule', { value: true });

var PropTypes = __webpack_require__(1);
var React = __webpack_require__(0);
var warning = __webpack_require__(21);
var CountUp$1 = __webpack_require__(1108);

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var PropTypes__default = /*#__PURE__*/_interopDefaultLegacy(PropTypes);
var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var warning__default = /*#__PURE__*/_interopDefaultLegacy(warning);
var CountUp__default = /*#__PURE__*/_interopDefaultLegacy(CountUp$1);

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);

    if (enumerableOnly) {
      symbols = symbols.filter(function (sym) {
        return Object.getOwnPropertyDescriptor(object, sym).enumerable;
      });
    }

    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread2(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties(Constructor, staticProps);
  return Constructor;
}

function _defineProperty(obj, key, value) {
  if (key in obj) {
    Object.defineProperty(obj, key, {
      value: value,
      enumerable: true,
      configurable: true,
      writable: true
    });
  } else {
    obj[key] = value;
  }

  return obj;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized(self);
}

function _createSuper(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn(this, result);
  };
}

function _slicedToArray(arr, i) {
  return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest();
}

function _arrayWithHoles(arr) {
  if (Array.isArray(arr)) return arr;
}

function _iterableToArrayLimit(arr, i) {
  var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];

  if (_i == null) return;
  var _arr = [];
  var _n = true;
  var _d = false;

  var _s, _e;

  try {
    for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) {
      _arr.push(_s.value);

      if (i && _arr.length === i) break;
    }
  } catch (err) {
    _d = true;
    _e = err;
  } finally {
    try {
      if (!_n && _i["return"] != null) _i["return"]();
    } finally {
      if (_d) throw _e;
    }
  }

  return _arr;
}

function _unsupportedIterableToArray(o, minLen) {
  if (!o) return;
  if (typeof o === "string") return _arrayLikeToArray(o, minLen);
  var n = Object.prototype.toString.call(o).slice(8, -1);
  if (n === "Object" && o.constructor) n = o.constructor.name;
  if (n === "Map" || n === "Set") return Array.from(o);
  if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen);
}

function _arrayLikeToArray(arr, len) {
  if (len == null || len > arr.length) len = arr.length;

  for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i];

  return arr2;
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

var createCountUpInstance = function createCountUpInstance(el, props) {
  var decimal = props.decimal,
      decimals = props.decimals,
      duration = props.duration,
      easingFn = props.easingFn,
      end = props.end,
      formattingFn = props.formattingFn,
      prefix = props.prefix,
      separator = props.separator,
      start = props.start,
      suffix = props.suffix,
      useEasing = props.useEasing;
  return new CountUp__default['default'](el, start, end, decimals, duration, {
    decimal: decimal,
    easingFn: easingFn,
    formattingFn: formattingFn,
    separator: separator,
    prefix: prefix,
    suffix: suffix,
    useEasing: useEasing,
    useGrouping: !!separator
  });
};

var CountUp = /*#__PURE__*/function (_Component) {
  _inherits(CountUp, _Component);

  var _super = _createSuper(CountUp);

  function CountUp() {
    var _this;

    _classCallCheck(this, CountUp);

    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    _this = _super.call.apply(_super, [this].concat(args));

    _defineProperty(_assertThisInitialized(_this), "checkProps", function (updatedProps) {
      var _this$props = _this.props,
          start = _this$props.start,
          suffix = _this$props.suffix,
          prefix = _this$props.prefix,
          redraw = _this$props.redraw,
          duration = _this$props.duration,
          separator = _this$props.separator,
          decimals = _this$props.decimals,
          decimal = _this$props.decimal,
          className = _this$props.className;
      var hasPropsChanged = duration !== updatedProps.duration || start !== updatedProps.start || suffix !== updatedProps.suffix || prefix !== updatedProps.prefix || separator !== updatedProps.separator || decimals !== updatedProps.decimals || decimal !== updatedProps.decimal || className !== updatedProps.className;
      return hasPropsChanged || redraw;
    });

    _defineProperty(_assertThisInitialized(_this), "createInstance", function () {
      if (typeof _this.props.children === 'function') {
        // Warn when user didn't use containerRef at all
        warning__default['default'](_this.containerRef.current && (_this.containerRef.current instanceof HTMLElement || _this.containerRef.current instanceof SVGTextElement || _this.containerRef.current instanceof SVGTSpanElement), "Couldn't find attached element to hook the CountUp instance into! Try to attach \"containerRef\" from the render prop to a an HTMLElement, eg. <span ref={containerRef} />.");
      }

      return createCountUpInstance(_this.containerRef.current, _this.props);
    });

    _defineProperty(_assertThisInitialized(_this), "pauseResume", function () {
      var _assertThisInitialize = _assertThisInitialized(_this),
          reset = _assertThisInitialize.reset,
          start = _assertThisInitialize.restart,
          update = _assertThisInitialize.update;

      var onPauseResume = _this.props.onPauseResume;

      _this.instance.pauseResume();

      onPauseResume({
        reset: reset,
        start: start,
        update: update
      });
    });

    _defineProperty(_assertThisInitialized(_this), "reset", function () {
      var _assertThisInitialize2 = _assertThisInitialized(_this),
          pauseResume = _assertThisInitialize2.pauseResume,
          start = _assertThisInitialize2.restart,
          update = _assertThisInitialize2.update;

      var onReset = _this.props.onReset;

      _this.instance.reset();

      onReset({
        pauseResume: pauseResume,
        start: start,
        update: update
      });
    });

    _defineProperty(_assertThisInitialized(_this), "restart", function () {
      _this.reset();

      _this.start();
    });

    _defineProperty(_assertThisInitialized(_this), "start", function () {
      var _assertThisInitialize3 = _assertThisInitialized(_this),
          pauseResume = _assertThisInitialize3.pauseResume,
          reset = _assertThisInitialize3.reset,
          start = _assertThisInitialize3.restart,
          update = _assertThisInitialize3.update;

      var _this$props2 = _this.props,
          delay = _this$props2.delay,
          onEnd = _this$props2.onEnd,
          onStart = _this$props2.onStart;

      var run = function run() {
        return _this.instance.start(function () {
          return onEnd({
            pauseResume: pauseResume,
            reset: reset,
            start: start,
            update: update
          });
        });
      }; // Delay start if delay prop is properly set


      if (delay > 0) {
        _this.timeoutId = setTimeout(run, delay * 1000);
      } else {
        run();
      }

      onStart({
        pauseResume: pauseResume,
        reset: reset,
        update: update
      });
    });

    _defineProperty(_assertThisInitialized(_this), "update", function (newEnd) {
      var _assertThisInitialize4 = _assertThisInitialized(_this),
          pauseResume = _assertThisInitialize4.pauseResume,
          reset = _assertThisInitialize4.reset,
          start = _assertThisInitialize4.restart;

      var onUpdate = _this.props.onUpdate;

      _this.instance.update(newEnd);

      onUpdate({
        pauseResume: pauseResume,
        reset: reset,
        start: start
      });
    });

    _defineProperty(_assertThisInitialized(_this), "containerRef", /*#__PURE__*/React__default['default'].createRef());

    return _this;
  }

  _createClass(CountUp, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var _this$props3 = this.props,
          children = _this$props3.children,
          delay = _this$props3.delay;
      this.instance = this.createInstance(); // Don't invoke start if component is used as a render prop

      if (typeof children === 'function' && delay !== 0) return; // Otherwise just start immediately

      this.start();
    }
  }, {
    key: "shouldComponentUpdate",
    value: function shouldComponentUpdate(nextProps) {
      var end = this.props.end;
      return this.checkProps(nextProps) || end !== nextProps.end;
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps) {
      // If duration, suffix, prefix, separator or start has changed
      // there's no way to update the values.
      // So we need to re-create the CountUp instance in order to
      // restart it.
      var _this$props4 = this.props,
          end = _this$props4.end,
          preserveValue = _this$props4.preserveValue;

      if (this.checkProps(prevProps)) {
        this.instance.reset();
        this.instance = this.createInstance();
        this.start();
      } // Only end value has changed, so reset and and re-animate with the updated
      // end value.


      if (end !== prevProps.end) {
        if (!preserveValue) {
          this.instance.reset();
        }

        this.instance.update(end);
      }
    }
  }, {
    key: "componentWillUnmount",
    value: function componentWillUnmount() {
      if (this.timeoutId) {
        clearTimeout(this.timeoutId);
      }

      this.instance.reset();
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props5 = this.props,
          children = _this$props5.children,
          className = _this$props5.className,
          style = _this$props5.style;
      var containerRef = this.containerRef,
          pauseResume = this.pauseResume,
          reset = this.reset,
          restart = this.restart,
          update = this.update;

      if (typeof children === 'function') {
        return children({
          countUpRef: containerRef,
          pauseResume: pauseResume,
          reset: reset,
          start: restart,
          update: update
        });
      }

      return /*#__PURE__*/React__default['default'].createElement("span", {
        className: className,
        ref: containerRef,
        style: style
      });
    }
  }]);

  return CountUp;
}(React.Component);

_defineProperty(CountUp, "propTypes", {
  decimal: PropTypes__default['default'].string,
  decimals: PropTypes__default['default'].number,
  delay: PropTypes__default['default'].number,
  easingFn: PropTypes__default['default'].func,
  end: PropTypes__default['default'].number.isRequired,
  formattingFn: PropTypes__default['default'].func,
  onEnd: PropTypes__default['default'].func,
  onStart: PropTypes__default['default'].func,
  prefix: PropTypes__default['default'].string,
  redraw: PropTypes__default['default'].bool,
  separator: PropTypes__default['default'].string,
  start: PropTypes__default['default'].number,
  startOnMount: PropTypes__default['default'].bool,
  suffix: PropTypes__default['default'].string,
  style: PropTypes__default['default'].object,
  useEasing: PropTypes__default['default'].bool,
  preserveValue: PropTypes__default['default'].bool
});

_defineProperty(CountUp, "defaultProps", {
  decimal: '.',
  decimals: 0,
  delay: null,
  duration: null,
  easingFn: null,
  formattingFn: null,
  onEnd: function onEnd() {},
  onPauseResume: function onPauseResume() {},
  onReset: function onReset() {},
  onStart: function onStart() {},
  onUpdate: function onUpdate() {},
  prefix: '',
  redraw: false,
  separator: '',
  start: 0,
  startOnMount: true,
  suffix: '',
  style: undefined,
  useEasing: true,
  preserveValue: false
});

// and just sets the innerHTML of the element.

var MOCK_ELEMENT = {
  innerHTML: null
};

var useCountUp = function useCountUp(props) {
  var _props = _objectSpread2(_objectSpread2({}, CountUp.defaultProps), props);

  var start = _props.start,
      formattingFn = _props.formattingFn;

  var _useState = React.useState(typeof formattingFn === 'function' ? formattingFn(start) : start),
      _useState2 = _slicedToArray(_useState, 2),
      count = _useState2[0],
      setCount = _useState2[1];

  var countUpRef = React.useRef(null);
  var timerRef = React.useRef(null);

  var createInstance = function createInstance() {
    var countUp = createCountUpInstance(MOCK_ELEMENT, _props);
    var formattingFnRef = countUp.options.formattingFn;

    countUp.options.formattingFn = function () {
      var result = formattingFnRef.apply(void 0, arguments);
      setCount(result);
    };

    return countUp;
  };

  var getCountUp = function getCountUp() {
    var countUp = countUpRef.current;

    if (countUp !== null) {
      return countUp;
    }

    var newCountUp = createInstance();
    countUpRef.current = newCountUp;
    return newCountUp;
  };

  var reset = function reset() {
    var onReset = _props.onReset;
    getCountUp().reset();
    onReset({
      pauseResume: pauseResume,
      start: restart,
      update: update
    });
  };

  var restart = function restart() {
    var onStart = _props.onStart,
        onEnd = _props.onEnd;
    getCountUp().reset();
    getCountUp().start(function () {
      onEnd({
        pauseResume: pauseResume,
        reset: reset,
        start: restart,
        update: update
      });
    });
    onStart({
      pauseResume: pauseResume,
      reset: reset,
      update: update
    });
  };

  var pauseResume = function pauseResume() {
    var onPauseResume = _props.onPauseResume;
    getCountUp().pauseResume();
    onPauseResume({
      reset: reset,
      start: restart,
      update: update
    });
  };

  var update = function update(newEnd) {
    var onUpdate = _props.onUpdate;
    getCountUp().update(newEnd);
    onUpdate({
      pauseResume: pauseResume,
      reset: reset,
      start: restart
    });
  };

  React.useEffect(function () {
    var delay = _props.delay,
        onStart = _props.onStart,
        onEnd = _props.onEnd,
        startOnMount = _props.startOnMount;

    if (startOnMount) {
      timerRef.current = setTimeout(function () {
        onStart({
          pauseResume: pauseResume,
          reset: reset,
          update: update
        });
        getCountUp().start(function () {
          clearTimeout(timerRef.current);
          onEnd({
            pauseResume: pauseResume,
            reset: reset,
            start: restart,
            update: update
          });
        });
      }, delay * 1000);
    }

    return function () {
      clearTimeout(timerRef.current);
      reset();
    };
  }, []);
  return {
    countUp: count,
    start: restart,
    pauseResume: pauseResume,
    reset: reset,
    update: update
  };
};

exports.default = CountUp;
exports.useCountUp = useCountUp;


/***/ }),
/* 1108 */
/***/ (function(module, exports, __webpack_require__) {

var __WEBPACK_AMD_DEFINE_FACTORY__, __WEBPACK_AMD_DEFINE_RESULT__;!function(a,n){ true?!(__WEBPACK_AMD_DEFINE_FACTORY__ = (n),
				__WEBPACK_AMD_DEFINE_RESULT__ = (typeof __WEBPACK_AMD_DEFINE_FACTORY__ === 'function' ?
				(__WEBPACK_AMD_DEFINE_FACTORY__.call(exports, __webpack_require__, exports, module)) :
				__WEBPACK_AMD_DEFINE_FACTORY__),
				__WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__)):"object"==typeof exports?module.exports=n(require,exports,module):a.CountUp=n()}(this,function(a,n,t){var e=function(a,n,t,e,i,r){function o(a){var n,t,e,i,r,o,s=a<0;if(a=Math.abs(a).toFixed(l.decimals),a+="",n=a.split("."),t=n[0],e=n.length>1?l.options.decimal+n[1]:"",l.options.useGrouping){for(i="",r=0,o=t.length;r<o;++r)0!==r&&r%3===0&&(i=l.options.separator+i),i=t[o-r-1]+i;t=i}return l.options.numerals.length&&(t=t.replace(/[0-9]/g,function(a){return l.options.numerals[+a]}),e=e.replace(/[0-9]/g,function(a){return l.options.numerals[+a]})),(s?"-":"")+l.options.prefix+t+e+l.options.suffix}function s(a,n,t,e){return t*(-Math.pow(2,-10*a/e)+1)*1024/1023+n}function u(a){return"number"==typeof a&&!isNaN(a)}var l=this;if(l.version=function(){return"1.9.3"},l.options={useEasing:!0,useGrouping:!0,separator:",",decimal:".",easingFn:s,formattingFn:o,prefix:"",suffix:"",numerals:[]},r&&"object"==typeof r)for(var m in l.options)r.hasOwnProperty(m)&&null!==r[m]&&(l.options[m]=r[m]);""===l.options.separator?l.options.useGrouping=!1:l.options.separator=""+l.options.separator;for(var d=0,c=["webkit","moz","ms","o"],f=0;f<c.length&&!window.requestAnimationFrame;++f)window.requestAnimationFrame=window[c[f]+"RequestAnimationFrame"],window.cancelAnimationFrame=window[c[f]+"CancelAnimationFrame"]||window[c[f]+"CancelRequestAnimationFrame"];window.requestAnimationFrame||(window.requestAnimationFrame=function(a,n){var t=(new Date).getTime(),e=Math.max(0,16-(t-d)),i=window.setTimeout(function(){a(t+e)},e);return d=t+e,i}),window.cancelAnimationFrame||(window.cancelAnimationFrame=function(a){clearTimeout(a)}),l.initialize=function(){return!!l.initialized||(l.error="",l.d="string"==typeof a?document.getElementById(a):a,l.d?(l.startVal=Number(n),l.endVal=Number(t),u(l.startVal)&&u(l.endVal)?(l.decimals=Math.max(0,e||0),l.dec=Math.pow(10,l.decimals),l.duration=1e3*Number(i)||2e3,l.countDown=l.startVal>l.endVal,l.frameVal=l.startVal,l.initialized=!0,!0):(l.error="[CountUp] startVal ("+n+") or endVal ("+t+") is not a number",!1)):(l.error="[CountUp] target is null or undefined",!1))},l.printValue=function(a){var n=l.options.formattingFn(a);"INPUT"===l.d.tagName?this.d.value=n:"text"===l.d.tagName||"tspan"===l.d.tagName?this.d.textContent=n:this.d.innerHTML=n},l.count=function(a){l.startTime||(l.startTime=a),l.timestamp=a;var n=a-l.startTime;l.remaining=l.duration-n,l.options.useEasing?l.countDown?l.frameVal=l.startVal-l.options.easingFn(n,0,l.startVal-l.endVal,l.duration):l.frameVal=l.options.easingFn(n,l.startVal,l.endVal-l.startVal,l.duration):l.countDown?l.frameVal=l.startVal-(l.startVal-l.endVal)*(n/l.duration):l.frameVal=l.startVal+(l.endVal-l.startVal)*(n/l.duration),l.countDown?l.frameVal=l.frameVal<l.endVal?l.endVal:l.frameVal:l.frameVal=l.frameVal>l.endVal?l.endVal:l.frameVal,l.frameVal=Math.round(l.frameVal*l.dec)/l.dec,l.printValue(l.frameVal),n<l.duration?l.rAF=requestAnimationFrame(l.count):l.callback&&l.callback()},l.start=function(a){l.initialize()&&(l.callback=a,l.rAF=requestAnimationFrame(l.count))},l.pauseResume=function(){l.paused?(l.paused=!1,delete l.startTime,l.duration=l.remaining,l.startVal=l.frameVal,requestAnimationFrame(l.count)):(l.paused=!0,cancelAnimationFrame(l.rAF))},l.reset=function(){l.paused=!1,delete l.startTime,l.initialized=!1,l.initialize()&&(cancelAnimationFrame(l.rAF),l.printValue(l.startVal))},l.update=function(a){if(l.initialize()){if(a=Number(a),!u(a))return void(l.error="[CountUp] update() - new endVal is not a number: "+a);l.error="",a!==l.frameVal&&(cancelAnimationFrame(l.rAF),l.paused=!1,delete l.startTime,l.startVal=l.frameVal,l.endVal=a,l.countDown=l.startVal>l.endVal,l.rAF=requestAnimationFrame(l.count))}},l.initialize()&&l.printValue(l.startVal)};return e});

/***/ }),
/* 1109 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function(global) {/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_consolidated_events__ = __webpack_require__(1110);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types__ = __webpack_require__(1);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_prop_types___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_prop_types__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_is__ = __webpack_require__(50);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3_react_is___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_3_react_is__);





/**
 * Attempts to parse the offset provided as a prop as a percentage. For
 * instance, if the component has been provided with the string "20%" as
 * a value of one of the offset props. If the value matches, then it returns
 * a numeric version of the prop. For instance, "20%" would become `0.2`.
 * If `str` isn't a percentage, then `undefined` will be returned.
 *
 * @param {string} str The value of an offset prop to be converted to a
 *   number.
 * @return {number|undefined} The numeric version of `str`. Undefined if `str`
 *   was not a percentage.
 */
function parseOffsetAsPercentage(str) {
  if (str.slice(-1) === '%') {
    return parseFloat(str.slice(0, -1)) / 100;
  }
}

/**
 * Attempts to parse the offset provided as a prop as a pixel value. If
 * parsing fails, then `undefined` is returned. Three examples of values that
 * will be successfully parsed are:
 * `20`
 * "20px"
 * "20"
 *
 * @param {string|number} str A string of the form "{number}" or "{number}px",
 *   or just a number.
 * @return {number|undefined} The numeric version of `str`. Undefined if `str`
 *   was neither a number nor string ending in "px".
 */
function parseOffsetAsPixels(str) {
  if (!isNaN(parseFloat(str)) && isFinite(str)) {
    return parseFloat(str);
  } else if (str.slice(-2) === 'px') {
    return parseFloat(str.slice(0, -2));
  }
}

/**
 * @param {string|number} offset
 * @param {number} contextHeight
 * @return {number} A number representing `offset` converted into pixels.
 */
function computeOffsetPixels(offset, contextHeight) {
  var pixelOffset = parseOffsetAsPixels(offset);

  if (typeof pixelOffset === 'number') {
    return pixelOffset;
  }

  var percentOffset = parseOffsetAsPercentage(offset);
  if (typeof percentOffset === 'number') {
    return percentOffset * contextHeight;
  }
}

var constants = {
  above: 'above',
  inside: 'inside',
  below: 'below',
  invisible: 'invisible'
};

function debugLog() {
  if (false) {
    console.log(arguments); // eslint-disable-line no-console
  }
}

var errorMessage = '<Waypoint> expected to receive a single React element child.\n\n' + 'See https://goo.gl/LrBNgw for more info.';

/**
 * Raise an error if more that one child was provided to "children"
 *
 * @param {?React.element} children
 * @return {undefined}
 */
function ensureChildrenIsValid(children) {
  if (children) {
    try {
      __WEBPACK_IMPORTED_MODULE_0_react___default.a.Children.only(children);
    } catch (e) {
      throw new Error(errorMessage);
    }
  }
}

/**
 * When an element's type is a string, it represents a DOM node with that tag name
 * https://facebook.github.io/react/blog/2015/12/18/react-components-elements-and-instances.html#dom-elements
 *
 * @param {React.element} Component
 * @return {bool} Whether the component is a DOM Element
 */
function isDOMElement(Component) {
  return typeof Component.type === 'string';
}

var errorMessage$1 = '<Waypoint> needs a DOM element to compute boundaries. The child you passed is neither a ' + 'DOM element (e.g. <div>) nor does it use the innerRef prop.\n\n' + 'See https://goo.gl/LrBNgw for more info.';

/**
 * Raise an error if "children" is not a DOM Element and there is no ref provided to Waypoint
 *
 * @param {?React.element} children
 * @param {?HTMLElement} ref
 * @return {undefined}
 */
function ensureRefIsProvidedByChild(children, ref) {
  if (children && !isDOMElement(children) && !ref) {
    throw new Error(errorMessage$1);
  }
}

/**
 * @param {object} bounds An object with bounds data for the waypoint and
 *   scrollable parent
 * @return {string} The current position of the waypoint in relation to the
 *   visible portion of the scrollable parent. One of `constants.above`,
 *   `constants.below`, or `constants.inside`.
 */
function getCurrentPosition(bounds) {
  if (bounds.viewportBottom - bounds.viewportTop === 0) {
    return constants.invisible;
  }

  // top is within the viewport
  if (bounds.viewportTop <= bounds.waypointTop && bounds.waypointTop <= bounds.viewportBottom) {
    return constants.inside;
  }

  // bottom is within the viewport
  if (bounds.viewportTop <= bounds.waypointBottom && bounds.waypointBottom <= bounds.viewportBottom) {
    return constants.inside;
  }

  // top is above the viewport and bottom is below the viewport
  if (bounds.waypointTop <= bounds.viewportTop && bounds.viewportBottom <= bounds.waypointBottom) {
    return constants.inside;
  }

  if (bounds.viewportBottom < bounds.waypointTop) {
    return constants.below;
  }

  if (bounds.waypointTop < bounds.viewportTop) {
    return constants.above;
  }

  return constants.invisible;
}

var timeout = void 0;
var timeoutQueue = [];

function onNextTick(cb) {
  timeoutQueue.push(cb);

  if (!timeout) {
    timeout = setTimeout(function () {
      timeout = null;

      // Drain the timeoutQueue
      var item = void 0;
      // eslint-disable-next-line no-cond-assign
      while (item = timeoutQueue.shift()) {
        item();
      }
    }, 0);
  }

  var isSubscribed = true;

  return function () {
    function unsubscribe() {
      if (!isSubscribed) {
        return;
      }

      isSubscribed = false;

      var index = timeoutQueue.indexOf(cb);
      if (index === -1) {
        return;
      }

      timeoutQueue.splice(index, 1);

      if (!timeoutQueue.length && timeout) {
        clearTimeout(timeout);
        timeout = null;
      }
    }

    return unsubscribe;
  }();
}

function resolveScrollableAncestorProp(scrollableAncestor) {
  // When Waypoint is rendered on the server, `window` is not available.
  // To make Waypoint easier to work with, we allow this to be specified in
  // string form and safely convert to `window` here.
  if (scrollableAncestor === 'window') {
    return global.window;
  }

  return scrollableAncestor;
}

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

var defaultProps = {
  topOffset: '0px',
  bottomOffset: '0px',
  horizontal: false,
  onEnter: function () {
    function onEnter() {}

    return onEnter;
  }(),
  onLeave: function () {
    function onLeave() {}

    return onLeave;
  }(),
  onPositionChange: function () {
    function onPositionChange() {}

    return onPositionChange;
  }(),

  fireOnRapidScroll: true
};

// React.PureComponent was added in React 15.3.0
var BaseClass = typeof __WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent !== 'undefined' ? __WEBPACK_IMPORTED_MODULE_0_react___default.a.PureComponent : __WEBPACK_IMPORTED_MODULE_0_react___default.a.Component;

// Calls a function when you scroll to the element.

var Waypoint = function (_BaseClass) {
  _inherits(Waypoint, _BaseClass);

  function Waypoint(props) {
    _classCallCheck(this, Waypoint);

    var _this = _possibleConstructorReturn(this, (Waypoint.__proto__ || Object.getPrototypeOf(Waypoint)).call(this, props));

    _this.refElement = function (e) {
      return _this._ref = e;
    };
    return _this;
  }

  _createClass(Waypoint, [{
    key: 'componentWillMount',
    value: function () {
      function componentWillMount() {
        ensureChildrenIsValid(this.props.children);
      }

      return componentWillMount;
    }()
  }, {
    key: 'componentDidMount',
    value: function () {
      function componentDidMount() {
        var _this2 = this;

        if (!Waypoint.getWindow()) {
          return;
        }

        // this._ref may occasionally not be set at this time. To help ensure that
        // this works smoothly and to avoid layout thrashing, we want to delay the
        // initial execution until the next tick.
        this.cancelOnNextTick = onNextTick(function () {
          _this2.cancelOnNextTick = null;

          // Berofe doing anything, we want to check that this._ref is avaliable in Waypoint
          ensureRefIsProvidedByChild(_this2.props.children, _this2._ref);

          _this2._handleScroll = _this2._handleScroll.bind(_this2);
          _this2.scrollableAncestor = _this2._findScrollableAncestor();

          if (false) {
            debugLog('scrollableAncestor', _this2.scrollableAncestor);
          }

          _this2.scrollEventListenerUnsubscribe = Object(__WEBPACK_IMPORTED_MODULE_1_consolidated_events__["a" /* addEventListener */])(_this2.scrollableAncestor, 'scroll', _this2._handleScroll, { passive: true });

          _this2.resizeEventListenerUnsubscribe = Object(__WEBPACK_IMPORTED_MODULE_1_consolidated_events__["a" /* addEventListener */])(window, 'resize', _this2._handleScroll, { passive: true });

          _this2._handleScroll(null);
        });
      }

      return componentDidMount;
    }()
  }, {
    key: 'componentWillReceiveProps',
    value: function () {
      function componentWillReceiveProps(newProps) {
        ensureChildrenIsValid(newProps.children);
      }

      return componentWillReceiveProps;
    }()
  }, {
    key: 'componentDidUpdate',
    value: function () {
      function componentDidUpdate() {
        var _this3 = this;

        if (!Waypoint.getWindow()) {
          return;
        }

        if (!this.scrollableAncestor) {
          // The Waypoint has not yet initialized.
          return;
        }

        // The element may have moved, so we need to recompute its position on the
        // page. This happens via handleScroll in a way that forces layout to be
        // computed.
        //
        // We want this to be deferred to avoid forcing layout during render, which
        // causes layout thrashing. And, if we already have this work enqueued, we
        // can just wait for that to happen instead of enqueueing again.
        if (this.cancelOnNextTick) {
          return;
        }

        this.cancelOnNextTick = onNextTick(function () {
          _this3.cancelOnNextTick = null;
          _this3._handleScroll(null);
        });
      }

      return componentDidUpdate;
    }()
  }, {
    key: 'componentWillUnmount',
    value: function () {
      function componentWillUnmount() {
        if (!Waypoint.getWindow()) {
          return;
        }

        if (this.scrollEventListenerUnsubscribe) {
          this.scrollEventListenerUnsubscribe();
        }
        if (this.resizeEventListenerUnsubscribe) {
          this.resizeEventListenerUnsubscribe();
        }

        if (this.cancelOnNextTick) {
          this.cancelOnNextTick();
        }
      }

      return componentWillUnmount;
    }()

    /**
     * Traverses up the DOM to find an ancestor container which has an overflow
     * style that allows for scrolling.
     *
     * @return {Object} the closest ancestor element with an overflow style that
     *   allows for scrolling. If none is found, the `window` object is returned
     *   as a fallback.
     */

  }, {
    key: '_findScrollableAncestor',
    value: function () {
      function _findScrollableAncestor() {
        var _props = this.props,
            horizontal = _props.horizontal,
            scrollableAncestor = _props.scrollableAncestor;


        if (scrollableAncestor) {
          return resolveScrollableAncestorProp(scrollableAncestor);
        }

        var node = this._ref;

        while (node.parentNode) {
          node = node.parentNode;

          if (node === document.body) {
            // We've reached all the way to the root node.
            return window;
          }

          var style = window.getComputedStyle(node);
          var overflowDirec = horizontal ? style.getPropertyValue('overflow-x') : style.getPropertyValue('overflow-y');
          var overflow = overflowDirec || style.getPropertyValue('overflow');

          if (overflow === 'auto' || overflow === 'scroll') {
            return node;
          }
        }

        // A scrollable ancestor element was not found, which means that we need to
        // do stuff on window.
        return window;
      }

      return _findScrollableAncestor;
    }()

    /**
     * @param {Object} event the native scroll event coming from the scrollable
     *   ancestor, or resize event coming from the window. Will be undefined if
     *   called by a React lifecyle method
     */

  }, {
    key: '_handleScroll',
    value: function () {
      function _handleScroll(event) {
        if (!this._ref) {
          // There's a chance we end up here after the component has been unmounted.
          return;
        }

        var bounds = this._getBounds();
        var currentPosition = getCurrentPosition(bounds);
        var previousPosition = this._previousPosition;

        if (false) {
          debugLog('currentPosition', currentPosition);
          debugLog('previousPosition', previousPosition);
        }

        // Save previous position as early as possible to prevent cycles
        this._previousPosition = currentPosition;

        if (previousPosition === currentPosition) {
          // No change since last trigger
          return;
        }

        var callbackArg = {
          currentPosition: currentPosition,
          previousPosition: previousPosition,
          event: event,
          waypointTop: bounds.waypointTop,
          waypointBottom: bounds.waypointBottom,
          viewportTop: bounds.viewportTop,
          viewportBottom: bounds.viewportBottom
        };
        this.props.onPositionChange.call(this, callbackArg);

        if (currentPosition === constants.inside) {
          this.props.onEnter.call(this, callbackArg);
        } else if (previousPosition === constants.inside) {
          this.props.onLeave.call(this, callbackArg);
        }

        var isRapidScrollDown = previousPosition === constants.below && currentPosition === constants.above;
        var isRapidScrollUp = previousPosition === constants.above && currentPosition === constants.below;

        if (this.props.fireOnRapidScroll && (isRapidScrollDown || isRapidScrollUp)) {
          // If the scroll event isn't fired often enough to occur while the
          // waypoint was visible, we trigger both callbacks anyway.
          this.props.onEnter.call(this, {
            currentPosition: constants.inside,
            previousPosition: previousPosition,
            event: event,
            waypointTop: bounds.waypointTop,
            waypointBottom: bounds.waypointBottom,
            viewportTop: bounds.viewportTop,
            viewportBottom: bounds.viewportBottom
          });
          this.props.onLeave.call(this, {
            currentPosition: currentPosition,
            previousPosition: constants.inside,
            event: event,
            waypointTop: bounds.waypointTop,
            waypointBottom: bounds.waypointBottom,
            viewportTop: bounds.viewportTop,
            viewportBottom: bounds.viewportBottom
          });
        }
      }

      return _handleScroll;
    }()
  }, {
    key: '_getBounds',
    value: function () {
      function _getBounds() {
        var horizontal = this.props.horizontal;

        var _ref$getBoundingClien = this._ref.getBoundingClientRect(),
            left = _ref$getBoundingClien.left,
            top = _ref$getBoundingClien.top,
            right = _ref$getBoundingClien.right,
            bottom = _ref$getBoundingClien.bottom;

        var waypointTop = horizontal ? left : top;
        var waypointBottom = horizontal ? right : bottom;

        var contextHeight = void 0;
        var contextScrollTop = void 0;
        if (this.scrollableAncestor === window) {
          contextHeight = horizontal ? window.innerWidth : window.innerHeight;
          contextScrollTop = 0;
        } else {
          contextHeight = horizontal ? this.scrollableAncestor.offsetWidth : this.scrollableAncestor.offsetHeight;
          contextScrollTop = horizontal ? this.scrollableAncestor.getBoundingClientRect().left : this.scrollableAncestor.getBoundingClientRect().top;
        }

        if (false) {
          debugLog('waypoint top', waypointTop);
          debugLog('waypoint bottom', waypointBottom);
          debugLog('scrollableAncestor height', contextHeight);
          debugLog('scrollableAncestor scrollTop', contextScrollTop);
        }

        var _props2 = this.props,
            bottomOffset = _props2.bottomOffset,
            topOffset = _props2.topOffset;

        var topOffsetPx = computeOffsetPixels(topOffset, contextHeight);
        var bottomOffsetPx = computeOffsetPixels(bottomOffset, contextHeight);
        var contextBottom = contextScrollTop + contextHeight;

        return {
          waypointTop: waypointTop,
          waypointBottom: waypointBottom,
          viewportTop: contextScrollTop + topOffsetPx,
          viewportBottom: contextBottom - bottomOffsetPx
        };
      }

      return _getBounds;
    }()

    /**
     * @return {Object}
     */

  }, {
    key: 'render',
    value: function () {
      function render() {
        var _this4 = this;

        var children = this.props.children;


        if (!children) {
          // We need an element that we can locate in the DOM to determine where it is
          // rendered relative to the top of its context.
          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('span', { ref: this.refElement, style: { fontSize: 0 } });
        }

        if (isDOMElement(children) || Object(__WEBPACK_IMPORTED_MODULE_3_react_is__["isForwardRef"])(children.type)) {
          var ref = function () {
            function ref(node) {
              _this4.refElement(node);
              if (children.ref) {
                if (typeof children.ref === 'function') {
                  children.ref(node);
                } else {
                  children.ref.current = node;
                }
              }
            }

            return ref;
          }();

          return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(children, { ref: ref });
        }

        return __WEBPACK_IMPORTED_MODULE_0_react___default.a.cloneElement(children, { innerRef: this.refElement });
      }

      return render;
    }()
  }]);

  return Waypoint;
}(BaseClass);


Waypoint.propTypes = {
  children: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.node,
  debug: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  onEnter: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  onLeave: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  onPositionChange: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.func,
  fireOnRapidScroll: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,
  scrollableAncestor: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.any,
  horizontal: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.bool,

  // `topOffset` can either be a number, in which case its a distance from the
  // top of the container in pixels, or a string value. Valid string values are
  // of the form "20px", which is parsed as pixels, or "20%", which is parsed
  // as a percentage of the height of the containing element.
  // For instance, if you pass "-20%", and the containing element is 100px tall,
  // then the waypoint will be triggered when it has been scrolled 20px beyond
  // the top of the containing element.
  topOffset: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number]),

  // `bottomOffset` is like `topOffset`, but for the bottom of the container.
  bottomOffset: __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.oneOfType([__WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.string, __WEBPACK_IMPORTED_MODULE_2_prop_types___default.a.number])
};

Waypoint.above = constants.above;
Waypoint.below = constants.below;
Waypoint.inside = constants.inside;
Waypoint.invisible = constants.invisible;
Waypoint.getWindow = function () {
  if (typeof window !== 'undefined') {
    return window;
  }
};
Waypoint.defaultProps = defaultProps;
Waypoint.displayName = 'Waypoint';

/* harmony default export */ __webpack_exports__["a"] = (Waypoint);

/* WEBPACK VAR INJECTION */}.call(__webpack_exports__, __webpack_require__(29)))

/***/ }),
/* 1110 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return addEventListener; });
var CAN_USE_DOM = !!(typeof window !== 'undefined' && window.document && window.document.createElement);

// Adapted from Modernizr
// https://github.com/Modernizr/Modernizr/blob/acb3f0d9/feature-detects/dom/passiveeventlisteners.js#L26-L37
function testPassiveEventListeners() {
  if (!CAN_USE_DOM) {
    return false;
  }

  if (!window.addEventListener || !window.removeEventListener || !Object.defineProperty) {
    return false;
  }

  var supportsPassiveOption = false;
  try {
    var opts = Object.defineProperty({}, 'passive', {
      // eslint-disable-next-line getter-return
      get: function () {
        function get() {
          supportsPassiveOption = true;
        }

        return get;
      }()
    });
    var noop = function noop() {};
    window.addEventListener('testPassiveEventSupport', noop, opts);
    window.removeEventListener('testPassiveEventSupport', noop, opts);
  } catch (e) {
    // do nothing
  }

  return supportsPassiveOption;
}

var memoized = void 0;

function canUsePassiveEventListeners() {
  if (memoized === undefined) {
    memoized = testPassiveEventListeners();
  }
  return memoized;
}

function normalizeEventOptions(eventOptions) {
  if (!eventOptions) {
    return undefined;
  }

  if (!canUsePassiveEventListeners()) {
    // If the browser does not support the passive option, then it is expecting
    // a boolean for the options argument to specify whether it should use
    // capture or not. In more modern browsers, this is passed via the `capture`
    // option, so let's just hoist that value up.
    return !!eventOptions.capture;
  }

  return eventOptions;
}

/* eslint-disable no-bitwise */

/**
 * Generate a unique key for any set of event options
 */
function eventOptionsKey(normalizedEventOptions) {
  if (!normalizedEventOptions) {
    return 0;
  }

  // If the browser does not support passive event listeners, the normalized
  // event options will be a boolean.
  if (normalizedEventOptions === true) {
    return 100;
  }

  // At this point, the browser supports passive event listeners, so we expect
  // the event options to be an object with possible properties of capture,
  // passive, and once.
  //
  // We want to consistently return the same value, regardless of the order of
  // these properties, so let's use binary maths to assign each property to a
  // bit, and then add those together (with an offset to account for the
  // booleans at the beginning of this function).
  var capture = normalizedEventOptions.capture << 0;
  var passive = normalizedEventOptions.passive << 1;
  var once = normalizedEventOptions.once << 2;
  return capture + passive + once;
}

function ensureCanMutateNextEventHandlers(eventHandlers) {
  if (eventHandlers.handlers === eventHandlers.nextHandlers) {
    // eslint-disable-next-line no-param-reassign
    eventHandlers.nextHandlers = eventHandlers.handlers.slice();
  }
}

function TargetEventHandlers(target) {
  this.target = target;
  this.events = {};
}

TargetEventHandlers.prototype.getEventHandlers = function () {
  function getEventHandlers(eventName, options) {
    var key = String(eventName) + ' ' + String(eventOptionsKey(options));

    if (!this.events[key]) {
      this.events[key] = {
        handlers: [],
        handleEvent: undefined
      };
      this.events[key].nextHandlers = this.events[key].handlers;
    }

    return this.events[key];
  }

  return getEventHandlers;
}();

TargetEventHandlers.prototype.handleEvent = function () {
  function handleEvent(eventName, options, event) {
    var eventHandlers = this.getEventHandlers(eventName, options);
    eventHandlers.handlers = eventHandlers.nextHandlers;
    eventHandlers.handlers.forEach(function (handler) {
      if (handler) {
        // We need to check for presence here because a handler function may
        // cause later handlers to get removed. This can happen if you for
        // instance have a waypoint that unmounts another waypoint as part of an
        // onEnter/onLeave handler.
        handler(event);
      }
    });
  }

  return handleEvent;
}();

TargetEventHandlers.prototype.add = function () {
  function add(eventName, listener, options) {
    var _this = this;

    // options has already been normalized at this point.
    var eventHandlers = this.getEventHandlers(eventName, options);

    ensureCanMutateNextEventHandlers(eventHandlers);

    if (eventHandlers.nextHandlers.length === 0) {
      eventHandlers.handleEvent = this.handleEvent.bind(this, eventName, options);

      this.target.addEventListener(eventName, eventHandlers.handleEvent, options);
    }

    eventHandlers.nextHandlers.push(listener);

    var isSubscribed = true;
    var unsubscribe = function () {
      function unsubscribe() {
        if (!isSubscribed) {
          return;
        }

        isSubscribed = false;

        ensureCanMutateNextEventHandlers(eventHandlers);
        var index = eventHandlers.nextHandlers.indexOf(listener);
        eventHandlers.nextHandlers.splice(index, 1);

        if (eventHandlers.nextHandlers.length === 0) {
          // All event handlers have been removed, so we want to remove the event
          // listener from the target node.

          if (_this.target) {
            // There can be a race condition where the target may no longer exist
            // when this function is called, e.g. when a React component is
            // unmounting. Guarding against this prevents the following error:
            //
            //   Cannot read property 'removeEventListener' of undefined
            _this.target.removeEventListener(eventName, eventHandlers.handleEvent, options);
          }

          eventHandlers.handleEvent = undefined;
        }
      }

      return unsubscribe;
    }();
    return unsubscribe;
  }

  return add;
}();

var EVENT_HANDLERS_KEY = '__consolidated_events_handlers__';

// eslint-disable-next-line import/prefer-default-export
function addEventListener(target, eventName, listener, options) {
  if (!target[EVENT_HANDLERS_KEY]) {
    // eslint-disable-next-line no-param-reassign
    target[EVENT_HANDLERS_KEY] = new TargetEventHandlers(target);
  }
  var normalizedEventOptions = normalizeEventOptions(options);
  return target[EVENT_HANDLERS_KEY].add(eventName, listener, normalizedEventOptions);
}




/***/ }),
/* 1111 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return mapData; });
var REACT_APP_CLOUDFRONT="https://d3vqeivyse4uh3.cloudfront.net/www/lagunaproperty";var MAP_PATH=REACT_APP_CLOUDFRONT+'/network-map';var mapData=[{value:'all',name:'All networks',count:47,image:MAP_PATH+'/map-all.png'},{value:'angsana',name:'Angsana',count:15,image:MAP_PATH+'/map-angsana.png'},{value:'banyan Tree',name:'Banyan Tree',count:27,image:MAP_PATH+'/map-banyantree.png'},{value:'cassia',name:'Cassia',count:2,image:MAP_PATH+'/map-cassia.png'},{value:'dhawa',name:'Dhawa',count:2,image:MAP_PATH+'/map-dhawa.png'},{value:'laguna',name:'Laguna',count:1,image:MAP_PATH+'/map-laguna.png'}];

/***/ }),
/* 1112 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Service; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__hoc__ = __webpack_require__(3);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var bgImg='https://lagunaproperty.com/images/03-sanctuary-club_63.jpg';var contentData={en:'<h2>The services team</h2><p>A centralised multilingual team at Sanctuary Club handles all owner enquiries, accommodation reservations and requests.<br/><br/>In addition to assisting members, the team of well-trained staff maintains owner preferences to ensure a perfectly smooth and customized booking service and a memorable stay.</p>',cn:'',ru:''};var Service=(_dec=Object(__WEBPACK_IMPORTED_MODULE_2__hoc__["a" /* multiLanguage */])(),_dec(_class=function(_Component){_inherits(Service,_Component);function Service(){_classCallCheck(this,Service);return _possibleConstructorReturn(this,(Service.__proto__||Object.getPrototypeOf(Service)).apply(this,arguments));}_createClass(Service,[{key:'render',value:function render(){var t=this.props.t;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'section10-service'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__components__["e" /* GradientPage */],{image:bgImg},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'text',dangerouslySetInnerHTML:{__html:t(contentData)}})));}}]);return Service;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class);

/***/ }),
/* 1113 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Faq; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Faq=function(_Component){_inherits(Faq,_Component);function Faq(){_classCallCheck(this,Faq);return _possibleConstructorReturn(this,(Faq.__proto__||Object.getPrototypeOf(Faq)).apply(this,arguments));}_createClass(Faq,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common__["d" /* Faq */],this.props);}}]);return Faq;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 1114 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Ebrochure; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__common__ = __webpack_require__(4);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Ebrochure=function(_Component){_inherits(Ebrochure,_Component);function Ebrochure(){_classCallCheck(this,Ebrochure);return _possibleConstructorReturn(this,(Ebrochure.__proto__||Object.getPrototypeOf(Ebrochure)).apply(this,arguments));}_createClass(Ebrochure,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1__common__["c" /* Ebrochure */],this.props);}}]);return Ebrochure;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 1115 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
Object.defineProperty(__webpack_exports__, "__esModule", { value: true });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "faqs", function() { return faqs; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "category", function() { return category; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var imageLogo={faqlogo1:"https://lagunaproperty.com/images/faqlogo1.png",faqlogo2:"https://lagunaproperty.com/images/faqlogo2.png",faqlogo3:"https://lagunaproperty.com/images/faqlogo3.png",faqlogo4:"https://lagunaproperty.com/images/faqlogo4.png",faqlogo5:"https://lagunaproperty.com/images/faqlogo5.png"};var category=[{id:1,name:"Sanctuary Club",displayOn:["en","cn","ru"]},{id:2,name:"Exchange Programme",displayOn:["en","cn","ru"]},{id:3,name:"Terms and Conditions",displayOn:["en","cn","ru"]}];var faqs=[{categoryId:1,question:"How do I enroll?",displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Enrollment into The Santuary Club is complimentary for Banyan Tree, Angsana, Cassia and Laguna Property owners who have their property managed under a hotel /anded rental scheme.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null)}},{categoryId:1,question:"What are the benefits of The Santuary Club?",displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Participating owners can exchange part of their annual entitlement for a complimentary stay at any destination within the network. In addition, discounts and special privileges are offered to owners with the standard discounts (1) and privileges are listed below (terms and conditions apply):"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"- 30% discount on best available rates for hotel accommodation"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"(2)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"- 30% discount on golf green fees ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"(3)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"- 25% discount on food and beverage",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"(4)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"- 20% discount on a-la-carte spa menu",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"- 15% discount on gallery merchandise",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"(5)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"- 15% discount on in-house tours ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"(6)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"- 15% discount on laundry",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"- 10% discount on airport and ferry terminal transfers"," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"(7)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"- Priority wait-list on reservations",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"- Early check-in / late check-out ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"(8)")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"- Invitations to Xperential Guest Program (i.e. pre-opening / trial stays at new resorts)",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ol",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"(1)")," Higher discounts may apply at certain times and locations and may be subject to change without notice")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"(2)")," Best available rate at time of booking")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"(3)")," Phuket, Bintan and L\u0103ng C\xF4 only")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"(4)")," Offers cannot be combined. Discounts may not apply to festive and special occasions.")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"(5)")," Not applicable to consignment items")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"(6)")," Selected destinations only")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"(7)")," Selected destinations only")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("small",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("sup",null,"(8)")," Subject to availability on day of arrival / departure"))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Kindly present your Sanctuary Club card to avail the discounts and privileges.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null)}},{categoryId:1,question:"Can I receive discounts at Banyan Tree, Angsana, and Laguna Resorts even if I am not staying there and would like to visit the hotel for any meals?",displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Yes, you can receive discounts at all Banyan Tree, Angsana, and Laguna Resorts even if you are not staying in the resort, as long as you present your card prior to payment."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{cellpadding:"5",style:{verticalAlign:"top",margin:0,borderColor:"transparent",backgroundColor:"#ffffff",width:"100%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{verticalAlign:"top",borderColor:"transparent"},width:"150"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:imageLogo.faqlogo1,width:"120",alt:""})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{verticalAlign:"top",borderColor:"transparent"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"China"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Anji",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Chongqing Beibei",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Huangshan",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Hangzhou",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Jiuzhaigou",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Lijiang",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Macau",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Ringha",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Sanya",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Tengchong",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Tianjin Riverside",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Yangshuo",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{verticalAlign:"top",borderColor:"transparent"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Thailand"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Bangkok",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Phuket Double Pool Villas",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Phuket Resort",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Phuket Spa Sanctuary",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Samui",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Indonesia")," ",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Bintan",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Ungasan, Bali",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{verticalAlign:"top",borderColor:"transparent"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Korea"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Club & Spa Seoul",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Maldives"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Vabbinfaru",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Morocco"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Tamouda Bay",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{verticalAlign:"top",borderColor:"transparent"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Mexico"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Cabo Marqu\xE9s",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Mayakoba",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Seychelles"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Seychelles",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Vietnam"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"L\u0103ng C\xF4",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{cellpadding:"5",style:{verticalAlign:"top",margin:0,borderColor:"transparent",backgroundColor:"#ffffff",width:"100%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{verticalAlign:"top",borderColor:"transparent"},width:"150"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:imageLogo.faqlogo2,width:"120",alt:""})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{verticalAlign:"top",borderColor:"transparent"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"China"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Hangzhou",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Tengchong-Hot",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Spring Village",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Xian Lintong",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Xishuanbanna",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Zhuhai Phoenix Bay",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Maldives"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Ihuru",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Velavaru",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Malaysia"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Kuala Lumper",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Pavilion Hotel Kula Lumper",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Mauritius"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Balaclava",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Vietnam"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"L\u0103ng C\xF4",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null)),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{verticalAlign:"top",borderColor:"transparent"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Indonesia"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Bintan",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"India"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Bangalore",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Laos"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Maison Souvannaphoum",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Morocco"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Riads Collection Morocco",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Seychelles"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Thailand"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Laguna Phuket",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Angsana Villas Resort Phuket",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{cellpadding:"5",style:{verticalAlign:"top",margin:0,borderColor:"transparent",backgroundColor:"#ffffff",width:"100%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{verticalAlign:"top",borderColor:"transparent"},width:"150"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:imageLogo.faqlogo3,width:"120",alt:""})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{verticalAlign:"top",borderColor:"transparent"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Thailand"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Phuket",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Indonesia"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Bintan",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{cellpadding:"5",style:{verticalAlign:"top",margin:0,borderColor:"transparent",backgroundColor:"#ffffff",width:"100%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{verticalAlign:"top",borderColor:"transparent"},width:"150"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:imageLogo.faqlogo4,width:"120",alt:""})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{verticalAlign:"top",borderColor:"transparent"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Cuba"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Cayo Santa Maria",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null))))),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("table",{cellpadding:"5",style:{verticalAlign:"top",margin:0,borderColor:"transparent",backgroundColor:"#ffffff",width:"100%"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tbody",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("tr",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{verticalAlign:"top",borderColor:"transparent"},width:"150"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("img",{src:imageLogo.faqlogo5,width:"120",alt:""})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("td",{style:{verticalAlign:"top",borderColor:"transparent"}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Thailand"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Dusit Thani Pool Villas Phuket",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Laguna Holiday Club Phuket Resort",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null)))))),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null)}},{categoryId:2,question:"How does the exchange programme work?",displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Participating owners can exchange part of their annual entitlement for a complimentary stay at any destination within the network."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"An owner deposits 15 days of his annual entitlement into the exchange pool. These days then are attributed a monetary value based on the actual average daily rate for the past year."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"The monetary value deposited can then be used to redeem for rooms and villas at participating properties at the best available rate at time of booking."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"The owner services team administers the exchange programme including participating properties, making reservations, recording redemptions, and the availability of days remaining of each participating property.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null)}},{categoryId:2,question:"How is the value of my days deposited calculated?",displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"The actual average daily rate for the past year is used to value your deposited days into the exchange programme. This is considered the most appropriate basis as it represents the market demand for a particular property on a year-round basis."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"For example, if the average achieved daily rate for your property is USD 500, then 15 days of your annual entitlement deposited would equate to USD 7,500 (i.e. USD 500 x 15 days) which would be available for redemption at participating properties within the network."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"For newly opened properties, the budgeted average daily rate will be used for that calendar year.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null)}},{categoryId:2,question:"How do I make a reservation?",displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Bookings can be requested via the centralized owner services team."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"The owner services team will check the availability and the best available rate of the property requested."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"A confirmation of your reservation will then be sent to you along with the value redeemed and your remaining balance for redemption."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Reservation requests operate on a first come, first served basis.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null)}},{categoryId:2,question:"Does my room reservation made under the Exchange Program include breakfast?",displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"No, your room reservation made under the Exchange Program does not include breakfast. It is for room only.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null)}},{categoryId:2,question:"How is value redeemed?",displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Your value can be redeemed at participating properties based upon best available rate (BAR) at the time of booking."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"For example, say you have USD 7,500 and would like to stay 5 days at a participating property in the network, which has a best available rate of USD 600 per day for the period you would like to stay. Your stay would cost USD 3,000 (i.e. USD 600 x 5 days) and you would have a balance of USD 4,500 remaining for redemption.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null)}},{categoryId:2,question:"Are there blackout dates?",displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Blackout dates may apply and may vary between each location subject to your rental agreement.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null)}},{categoryId:2,question:"Where can I stay?",displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"You may stay at any property participating in the exchange programme, subject to availability, and providing you have sufficient value for redemption.",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Once all days are utilised in a particular property (redeemed nights equal deposited nights), the property is no longer available for exchange."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("strong",null,"Current participating properties")),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("ul",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"- Banyan Tree \u2013 Bangkok, Bintan, Cabo Marqu\xE9s, Lang Co, Huangshan, Lijiang, Mayakoba, Phuket Double Pool Villas & Phuket Resort and Ungasan"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"- Angsana \u2013 Bintan, Lang Co, Laguna Phuket and Villas Resort Phuket"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"- Cassia \u2013 Phuket"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("li",null,"- Laguna Phuket \u2013 Dusit Thani Pool Villas"))),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null)}},{categoryId:2,question:"Is there a limit to the number of days I can book per exchange stay?",displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Yes, you may book up to a maximum of five (5) days only for each stay.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null)}},{categoryId:2,question:"Can I roll over my unused value to the following year?",displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"No. The value of days deposited into the exchange programme will expire at the end of each year just as owners shall forfeit their entitlement to any unused days during the calendar year.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null)}},{categoryId:2,question:"Can I book more than one property for a stay?",displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"No, multiple properties cannot be booked at one time for a stay under the exchange programme. However, you may book additional properties if making a normal paid reservation and use your Sanctuary Club membership to receive a discount from the best available rate.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null)}},{categoryId:2,question:"Can my friends use my owners’ entitlement for an exchange?",displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Yes, subject to the terms and conditions stipulated in your rental agreement and compliance with the hotel policy on the maximum number of occupants for the property booked."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Your guests are also required to be pre-registered with the owner services team who will include their names on the reservation.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null)}},{categoryId:2,question:"Can I choose to opt out of the exchange programme after I have enrolled?",displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Once you have enrolled in the exchange program, you must continue throughout the entire calendar year in 2017. However, you may choose to opt out for the following year in 2018 by informing us prior to the commencement of the exchange programme in 2018.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null)}},{categoryId:3,question:"Terms & Conditions",displayOn:["en","cn","ru"],answer:{en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"1. Enrollment into The Santuary Club shall be automatic for all property owners who have their property managed under a hotel branded rental scheme operated by the Banyan Tree Group or its affiliates. There is no cost to enrol."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"2. Discounts and privileges may change from time to time and are subject to the discretion of the Banyan Tree Group."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"3. All participating owners shall deposit 15 days of owners use time into the exchange program. This shall be a fixed amount."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"4.The deposited owners use time will be made at the beginning of each year (a pro-rata amount will apply for owners who purchased property during the year)."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"5. The deposited owners use time shall be converted to value based upon the achieved daily rate (USD equivalent) of the property for the preceding year. For example, if the achieved daily rate were USD 500, 15 days would equate to USD 7,500. Where the property is a new property, the budgeted average daily rate shall be used for the first year."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"6. Unused value cannot be carried forward or borrowed and cannot be topped up by cash. They are valid only for the current year."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"7. Booking requests should be made via the owner services team who will then co-ordinate the booking with the hotel."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"8. Reservations are on a first come, first served basis."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"9. Reservations are subject to availability."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"10. No booking of multiple properties is allowed. That is, only one property may be booked per exchange."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"11. Owners may book an exchange for family and friends but must pre-register the guests staying during the exchange with the owner services team."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"12. If a booking is confirmed and subsequently cancelled (or there is a no show), the value of the booking may be forfeited in accordance with the hotel\u2019s cancellation policy."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"13. No fees shall be charged to owners for exchanges. However, we reserve the right to introduce fees in the future."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"14. Black-out dates may apply for each location and may vary between locations and are subject to the terms and condition set out in the rental scheme agreements."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"15. Banyan Tree Group reserves the right to change the terms and conditions.")),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",null)}}];

/***/ }),
/* 1116 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return index; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_helmet__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_skrollr__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_skrollr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_skrollr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__hoc__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__actions_language__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__Section1__ = __webpack_require__(1117);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__Mission__ = __webpack_require__(1118);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_8__Developer__ = __webpack_require__(1119);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var mapStateToProps=function mapStateToProps(state){return Object.assign({},state);};var actionToProps={switchLanguage:__WEBPACK_IMPORTED_MODULE_4__actions_language__["a" /* switchLanguage */]};var index=(_dec=Object(__WEBPACK_IMPORTED_MODULE_3__hoc__["b" /* withRedux */])(mapStateToProps,actionToProps),_dec(_class=function(_Component){_inherits(index,_Component);function index(props){_classCallCheck(this,index);var _this=_possibleConstructorReturn(this,(index.__proto__||Object.getPrototypeOf(index)).call(this,props));_this.setLanguage=function(language){_this.props.actions.switchLanguage(language);};_this.headerRef=__WEBPACK_IMPORTED_MODULE_0_react___default.a.createRef();return _this;}_createClass(index,[{key:'componentDidMount',value:function componentDidMount(){this.setLanguage(this.props.match.params.language);}},{key:'componentDidUpdate',value:function componentDidUpdate(prevProps){var currentLanguage=prevProps.match.params.language;var nextLanguage=this.props.match.params.language;if(currentLanguage!==nextLanguage){this.setLanguage(nextLanguage);}}},{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_skrollr__["ParallaxProvider"],{init:{smoothScrollingDuration:0,smoothScrolling:true,forceHeight:false}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_helmet__["Helmet"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('title',null,'Laguna')),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_6__Section1__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_7__Mission__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_8__Developer__["a" /* default */],null),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_0_react__["Fragment"],null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_5__components__["d" /* Footer */],null))));}}]);return index;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class);

/***/ }),
/* 1117 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Section1; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_skrollr__ = __webpack_require__(20);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react_skrollr___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react_skrollr__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(6);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var img1='https://lagunaproperty.com/images/ab1.jpg';var img2='https://lagunaproperty.com/images/ab2.jpg';var Section1=function(_Component){_inherits(Section1,_Component);function Section1(){_classCallCheck(this,Section1);return _possibleConstructorReturn(this,(Section1.__proto__||Object.getPrototypeOf(Section1)).apply(this,arguments));}_createClass(Section1,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'aboutus-section1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'background-img1'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["a" /* BackgroundImage */],{image:img1,position:'fixed'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_1_react_skrollr__["Parallax"],{data:{'data-0-start':'opacity: 0;','data-top-bottom':'opacity: 1;'}},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'background-img2'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["a" /* BackgroundImage */],{image:img2}))));}}]);return Section1;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 1118 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Mission; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var videoBg='https://lagunaproperty.com/vdo/Cassia_Timelapse.mp4';var Mission=function(_Component){_inherits(Mission,_Component);function Mission(){_classCallCheck(this,Mission);return _possibleConstructorReturn(this,(Mission.__proto__||Object.getPrototypeOf(Mission)).apply(this,arguments));}_createClass(Mission,[{key:'render',value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'aboutus-page-mission'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('video',{className:'vdo-bg',autoPlay:true,muted:true,loop:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('source',{src:videoBg,type:'video/mp4'})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'content'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Our mission'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('strong',null,'Laguna Property is the property development arm of Laguna Resorts & Hotels'),', a publicly listed company that traces its history back to the early 1980s, with the land acquisition and resort development of what is now Laguna Phuket, at the time Asia\'s first integrated resort complex.'))));}}]);return Mission;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);

/***/ }),
/* 1119 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return Developer; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__hoc__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2__components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__data_AboutUs_developer__ = __webpack_require__(1120);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Developer=(_dec=Object(__WEBPACK_IMPORTED_MODULE_1__hoc__["a" /* multiLanguage */])(),_dec(_class=function(_Component){_inherits(Developer,_Component);function Developer(){_classCallCheck(this,Developer);return _possibleConstructorReturn(this,(Developer.__proto__||Object.getPrototypeOf(Developer)).apply(this,arguments));}_createClass(Developer,[{key:'render',value:function render(){var t=this.props.t;return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'aboutus-page-developer'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2__components__["e" /* GradientPage */],{image:__WEBPACK_IMPORTED_MODULE_3__data_AboutUs_developer__["a" /* bgImg */],themeWhite:true},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'logo-img'},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('img',{src:__WEBPACK_IMPORTED_MODULE_3__data_AboutUs_developer__["c" /* logoImg */],alt:''})),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',{className:'container-content'},t(__WEBPACK_IMPORTED_MODULE_3__data_AboutUs_developer__["b" /* data */]))));}}]);return Developer;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]))||_class);

/***/ }),
/* 1120 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return data; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return bgImg; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return logoImg; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1__utils__ = __webpack_require__(2);
var bgImg='https://lagunaproperty.com/images/2008_photo.jpg';var logoImg=Object(__WEBPACK_IMPORTED_MODULE_1__utils__["a" /* assetsPath */])()+'/images/logo-laguna-property.svg';var data={en:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null,__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('h2',null,'Developer'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'The company has since established itself as the largest and most established property developer in Phuket (Thailand), Bintan (Indonesia) and L\u0103ng C\xF4 (Vietnam).'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'With over 1,200 properties, Laguna Property offers a wide range of residential and investment properties, condos, townhouses, villas, and residences.'),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('p',null,'Laguna Resorts & Hotels PLC. listed on the Stock Exchange of Thailand in 1993 and has gained a strong reputation as a responsible developer whose interests combine hotels and real estate with an emphasis on quality and environmental protection, having received numerous environmental and tourism awards.')),ru:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null),cn:__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement('div',null)};

/***/ }),
/* 1121 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return _default; });
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get__ = __webpack_require__(7);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_lodash_get___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_lodash_get__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_1_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_1_react__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet__ = __webpack_require__(34);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_2_react_helmet___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_2_react_helmet__);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_3__components__ = __webpack_require__(6);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_4__hoc__ = __webpack_require__(3);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_5__actions_language__ = __webpack_require__(38);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_6__utils__ = __webpack_require__(2);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_7__options__ = __webpack_require__(1122);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _dec,_class;function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var Select=__WEBPACK_IMPORTED_MODULE_3__components__["h" /* InputField */].Select,Input=__WEBPACK_IMPORTED_MODULE_3__components__["h" /* InputField */].Input;var mapStateToProps=function mapStateToProps(state){return Object.assign({},state);};var actionToProps={switchLanguage:__WEBPACK_IMPORTED_MODULE_5__actions_language__["a" /* switchLanguage */]};var _default=(_dec=Object(__WEBPACK_IMPORTED_MODULE_4__hoc__["b" /* withRedux */])(mapStateToProps,actionToProps),_dec(_class=function(_Component){_inherits(_default,_Component);function _default(){var _ref;var _temp,_this,_ret;_classCallCheck(this,_default);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=_default.__proto__||Object.getPrototypeOf(_default)).call.apply(_ref,[this].concat(args))),_this),_this.setLanguage=function(language){_this.props.actions.switchLanguage(language);},_this.handleSubmit=function(){console.log('handleSubmit');},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(_default,[{key:"componentDidMount",value:function componentDidMount(){this.setLanguage(this.props.match.params.language);}},{key:"componentDidUpdate",value:function componentDidUpdate(prevProps){var currentLanguage=prevProps.match.params.language;var nextLanguage=this.props.match.params.language;if(currentLanguage!==nextLanguage){this.setLanguage(nextLanguage);}}},{key:"render",value:function render(){var currentLanguage=__WEBPACK_IMPORTED_MODULE_0_lodash_get___default()(this.props,"language.currentActive");return __WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_2_react_helmet__["Helmet"],null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("title",null,"Laguna")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["f" /* Header */],{mainLogo:Object(__WEBPACK_IMPORTED_MODULE_6__utils__["a" /* assetsPath */])()+"/images/logo-laguna-property.svg",hasSubHeader:false,language:currentLanguage}),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"main-content contact-us"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-xl-4 col-lg-12 order-xl-1 order-lg-2"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"address"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("ul",{className:"address-list"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h3",null,"THE LAGUNA LIFESTYLE HUB - PHUKET"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,"390/1 Moo 1 Srisoonthorn Road, Cherngtalay ",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("br",null),"Thalang, Phuket 83110 Thailand"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("strong",null,"Property Sales/Resales"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h4",null,"T: +66 (0)76 362 333"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h4",null,"F: +66 (0)76 362 335"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h4",null,"E: info@lagunaproperty.com")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("strong",null,"Rentals"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h4",null,"T: +66 (0)76 362 333 ext. 203"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h4",null,"F: +66 (0)76 362 335"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h4",null,"E: rentals@lagunaproperty.com")),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("small",null,"We will contact you within 48 hours of your inquiry submission"))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("li",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h3",null,"OWNER SERVICES"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,"Canal Village 28-29, 390/1 Moo 1, Srisoonthorn Road,",__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("br",null),"Cherngtalay, Thalang, Phuket 83110 Thailand"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("p",null,__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h4",null,"T. +66 (0)76 362 330 Ext. 2401-3"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h4",null,"F. +66 (0)76 362 342"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h4",null,"E. sanctuary.club@banyantree.com")))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"col-xl-8 col-lg-12 order-xl-2 order-lg-1"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"enquiry"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("h2",null,"ENQUIRY"),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("form",{className:"input-field-form"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-xl-6 col-lg-12"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Select,{options:__WEBPACK_IMPORTED_MODULE_7__options__["c" /* locationOptions */]}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-lg-6 col-md-12"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Select,{options:__WEBPACK_IMPORTED_MODULE_7__options__["d" /* titleOptions */]}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-lg-6"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Input,{placeholder:"First name *",required:true})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-lg-6"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Input,{placeholder:"Last name *",required:true}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-lg-6 col-md-12"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Input,{placeholder:"Email *",required:true})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-lg-6 col-md-12"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Select,{options:__WEBPACK_IMPORTED_MODULE_7__options__["b" /* interestOptions */]}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-lg-6 col-md-12"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Input,{placeholder:"Phone number",required:true})),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-lg-6 col-md-12"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Input,{placeholder:"Message",required:true}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"row"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{"class":"col-lg-6 col-md-12"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(Select,{options:__WEBPACK_IMPORTED_MODULE_7__options__["a" /* countryOptions */]}))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("br",null),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement("div",{className:"action"},__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["b" /* Button */],{onClick:this.handleSubmit},"SEND"))))))),__WEBPACK_IMPORTED_MODULE_1_react___default.a.createElement(__WEBPACK_IMPORTED_MODULE_3__components__["d" /* Footer */],null));}}]);return _default;}(__WEBPACK_IMPORTED_MODULE_1_react__["Component"]))||_class);

/***/ }),
/* 1122 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "c", function() { return locationOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "d", function() { return titleOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "b", function() { return interestOptions; });
/* harmony export (binding) */ __webpack_require__.d(__webpack_exports__, "a", function() { return countryOptions; });
var locationOptions=[{label:'Locations',value:0},{label:'Phuket',value:1},{label:'Bintan',value:2}];var titleOptions=[{label:'Title *',value:0},{label:'Mr.',value:1},{label:'Ms.',value:2},{label:'Mrs.',value:3}];var interestOptions=[{label:'Interest',value:0},{label:'Laguna Park',value:1},{label:'Laguna Park 2',value:2},{label:'Laguna Village Residences',value:3},{label:'Resales',value:4},{label:'Rentals',value:5},{label:'Others',value:6}];var countryOptions=[{"label":"Country of Residence *","value":0},{"label":"Afghanistan","value":"AF"},{"label":"Åland Islands","value":"AX"},{"label":"Albania","value":"AL"},{"label":"Algeria","value":"DZ"},{"label":"American Samoa","value":"AS"},{"label":"Andorra","value":"AD"},{"label":"Angola","value":"AO"},{"label":"Anguilla","value":"AI"},{"label":"Antarctica","value":"AQ"},{"label":"Antigua and Barbuda","value":"AG"},{"label":"Argentina","value":"AR"},{"label":"Armenia","value":"AM"},{"label":"Aruba","value":"AW"},{"label":"Australia","value":"AU"},{"label":"Austria","value":"AT"},{"label":"Azerbaijan","value":"AZ"},{"label":"Bahamas","value":"BS"},{"label":"Bahrain","value":"BH"},{"label":"Bangladesh","value":"BD"},{"label":"Barbados","value":"BB"},{"label":"Belarus","value":"BY"},{"label":"Belgium","value":"BE"},{"label":"Belize","value":"BZ"},{"label":"Benin","value":"BJ"},{"label":"Bermuda","value":"BM"},{"label":"Bhutan","value":"BT"},{"label":"Bolivia (Plurinational State of)","value":"BO"},{"label":"Bonaire, Sint Eustatius and Saba","value":"BQ"},{"label":"Bosnia and Herzegovina","value":"BA"},{"label":"Botswana","value":"BW"},{"label":"Bouvet Island","value":"BV"},{"label":"Brazil","value":"BR"},{"label":"British Indian Ocean Territory","value":"IO"},{"label":"United States Minor Outlying Islands","value":"UM"},{"label":"Virgin Islands (British)","value":"VG"},{"label":"Virgin Islands (U.S.)","value":"VI"},{"label":"Brunei Darussalam","value":"BN"},{"label":"Bulgaria","value":"BG"},{"label":"Burkina Faso","value":"BF"},{"label":"Burundi","value":"BI"},{"label":"Cambodia","value":"KH"},{"label":"Cameroon","value":"CM"},{"label":"Canada","value":"CA"},{"label":"Cabo Verde","value":"CV"},{"label":"Cayman Islands","value":"KY"},{"label":"Central African Republic","value":"CF"},{"label":"Chad","value":"TD"},{"label":"Chile","value":"CL"},{"label":"China","value":"CN"},{"label":"Christmas Island","value":"CX"},{"label":"Cocos (Keeling) Islands","value":"CC"},{"label":"Colombia","value":"CO"},{"label":"Comoros","value":"KM"},{"label":"Congo","value":"CG"},{"label":"Congo (Democratic Republic of the)","value":"CD"},{"label":"Cook Islands","value":"CK"},{"label":"Costa Rica","value":"CR"},{"label":"Croatia","value":"HR"},{"label":"Cuba","value":"CU"},{"label":"Curaçao","value":"CW"},{"label":"Cyprus","value":"CY"},{"label":"Czech Republic","value":"CZ"},{"label":"Denmark","value":"DK"},{"label":"Djibouti","value":"DJ"},{"label":"Dominica","value":"DM"},{"label":"Dominican Republic","value":"DO"},{"label":"Ecuador","value":"EC"},{"label":"Egypt","value":"EG"},{"label":"El Salvador","value":"SV"},{"label":"Equatorial Guinea","value":"GQ"},{"label":"Eritrea","value":"ER"},{"label":"Estonia","value":"EE"},{"label":"Ethiopia","value":"ET"},{"label":"Falkland Islands (Malvinas)","value":"FK"},{"label":"Faroe Islands","value":"FO"},{"label":"Fiji","value":"FJ"},{"label":"Finland","value":"FI"},{"label":"France","value":"FR"},{"label":"French Guiana","value":"GF"},{"label":"French Polynesia","value":"PF"},{"label":"French Southern Territories","value":"TF"},{"label":"Gabon","value":"GA"},{"label":"Gambia","value":"GM"},{"label":"Georgia","value":"GE"},{"label":"Germany","value":"DE"},{"label":"Ghana","value":"GH"},{"label":"Gibraltar","value":"GI"},{"label":"Greece","value":"GR"},{"label":"Greenland","value":"GL"},{"label":"Grenada","value":"GD"},{"label":"Guadeloupe","value":"GP"},{"label":"Guam","value":"GU"},{"label":"Guatemala","value":"GT"},{"label":"Guernsey","value":"GG"},{"label":"Guinea","value":"GN"},{"label":"Guinea-Bissau","value":"GW"},{"label":"Guyana","value":"GY"},{"label":"Haiti","value":"HT"},{"label":"Heard Island and McDonald Islands","value":"HM"},{"label":"Holy See","value":"VA"},{"label":"Honduras","value":"HN"},{"label":"Hong Kong","value":"HK"},{"label":"Hungary","value":"HU"},{"label":"Iceland","value":"IS"},{"label":"India","value":"IN"},{"label":"Indonesia","value":"ID"},{"label":"Côte d'Ivoire","value":"CI"},{"label":"Iran (Islamic Republic of)","value":"IR"},{"label":"Iraq","value":"IQ"},{"label":"Ireland","value":"IE"},{"label":"Isle of Man","value":"IM"},{"label":"Israel","value":"IL"},{"label":"Italy","value":"IT"},{"label":"Jamaica","value":"JM"},{"label":"Japan","value":"JP"},{"label":"Jersey","value":"JE"},{"label":"Jordan","value":"JO"},{"label":"Kazakhstan","value":"KZ"},{"label":"Kenya","value":"KE"},{"label":"Kiribati","value":"KI"},{"label":"Kuwait","value":"KW"},{"label":"Kyrgyzstan","value":"KG"},{"label":"Lao People's Democratic Republic","value":"LA"},{"label":"Latvia","value":"LV"},{"label":"Lebanon","value":"LB"},{"label":"Lesotho","value":"LS"},{"label":"Liberia","value":"LR"},{"label":"Libya","value":"LY"},{"label":"Liechtenstein","value":"LI"},{"label":"Lithuania","value":"LT"},{"label":"Luxembourg","value":"LU"},{"label":"Macao","value":"MO"},{"label":"Macedonia (the former Yugoslav Republic of)","value":"MK"},{"label":"Madagascar","value":"MG"},{"label":"Malawi","value":"MW"},{"label":"Malaysia","value":"MY"},{"label":"Maldives","value":"MV"},{"label":"Mali","value":"ML"},{"label":"Malta","value":"MT"},{"label":"Marshall Islands","value":"MH"},{"label":"Martinique","value":"MQ"},{"label":"Mauritania","value":"MR"},{"label":"Mauritius","value":"MU"},{"label":"Mayotte","value":"YT"},{"label":"Mexico","value":"MX"},{"label":"Micronesia (Federated States of)","value":"FM"},{"label":"Moldova (Republic of)","value":"MD"},{"label":"Monaco","value":"MC"},{"label":"Mongolia","value":"MN"},{"label":"Montenegro","value":"ME"},{"label":"Montserrat","value":"MS"},{"label":"Morocco","value":"MA"},{"label":"Mozambique","value":"MZ"},{"label":"Myanmar","value":"MM"},{"label":"Namibia","value":"NA"},{"label":"Nauru","value":"NR"},{"label":"Nepal","value":"NP"},{"label":"Netherlands","value":"NL"},{"label":"New Caledonia","value":"NC"},{"label":"New Zealand","value":"NZ"},{"label":"Nicaragua","value":"NI"},{"label":"Niger","value":"NE"},{"label":"Nigeria","value":"NG"},{"label":"Niue","value":"NU"},{"label":"Norfolk Island","value":"NF"},{"label":"Korea (Democratic People's Republic of)","value":"KP"},{"label":"Northern Mariana Islands","value":"MP"},{"label":"Norway","value":"NO"},{"label":"Oman","value":"OM"},{"label":"Pakistan","value":"PK"},{"label":"Palau","value":"PW"},{"label":"Palestine, State of","value":"PS"},{"label":"Panama","value":"PA"},{"label":"Papua New Guinea","value":"PG"},{"label":"Paraguay","value":"PY"},{"label":"Peru","value":"PE"},{"label":"Philippines","value":"PH"},{"label":"Pitcairn","value":"PN"},{"label":"Poland","value":"PL"},{"label":"Portugal","value":"PT"},{"label":"Puerto Rico","value":"PR"},{"label":"Qatar","value":"QA"},{"label":"Republic of Kosovo","value":"XK"},{"label":"Réunion","value":"RE"},{"label":"Romania","value":"RO"},{"label":"Russian Federation","value":"RU"},{"label":"Rwanda","value":"RW"},{"label":"Saint Barthélemy","value":"BL"},{"label":"Saint Helena, Ascension and Tristan da Cunha","value":"SH"},{"label":"Saint Kitts and Nevis","value":"KN"},{"label":"Saint Lucia","value":"LC"},{"label":"Saint Martin (French part)","value":"MF"},{"label":"Saint Pierre and Miquelon","value":"PM"},{"label":"Saint Vincent and the Grenadines","value":"VC"},{"label":"Samoa","value":"WS"},{"label":"San Marino","value":"SM"},{"label":"Sao Tome and Principe","value":"ST"},{"label":"Saudi Arabia","value":"SA"},{"label":"Senegal","value":"SN"},{"label":"Serbia","value":"RS"},{"label":"Seychelles","value":"SC"},{"label":"Sierra Leone","value":"SL"},{"label":"Singapore","value":"SG"},{"label":"Sint Maarten (Dutch part)","value":"SX"},{"label":"Slovakia","value":"SK"},{"label":"Slovenia","value":"SI"},{"label":"Solomon Islands","value":"SB"},{"label":"Somalia","value":"SO"},{"label":"South Africa","value":"ZA"},{"label":"South Georgia and the South Sandwich Islands","value":"GS"},{"label":"Korea (Republic of)","value":"KR"},{"label":"South Sudan","value":"SS"},{"label":"Spain","value":"ES"},{"label":"Sri Lanka","value":"LK"},{"label":"Sudan","value":"SD"},{"label":"Surilabel","value":"SR"},{"label":"Svalbard and Jan Mayen","value":"SJ"},{"label":"Swaziland","value":"SZ"},{"label":"Sweden","value":"SE"},{"label":"Switzerland","value":"CH"},{"label":"Syrian Arab Republic","value":"SY"},{"label":"Taiwan","value":"TW"},{"label":"Tajikistan","value":"TJ"},{"label":"Tanzania, United Republic of","value":"TZ"},{"label":"Thailand","value":"TH"},{"label":"Timor-Leste","value":"TL"},{"label":"Togo","value":"TG"},{"label":"Tokelau","value":"TK"},{"label":"Tonga","value":"TO"},{"label":"Trinidad and Tobago","value":"TT"},{"label":"Tunisia","value":"TN"},{"label":"Turkey","value":"TR"},{"label":"Turkmenistan","value":"TM"},{"label":"Turks and Caicos Islands","value":"TC"},{"label":"Tuvalu","value":"TV"},{"label":"Uganda","value":"UG"},{"label":"Ukraine","value":"UA"},{"label":"United Arab Emirates","value":"AE"},{"label":"United Kingdom of Great Britain and Northern Ireland","value":"GB"},{"label":"United States of America","value":"US"},{"label":"Uruguay","value":"UY"},{"label":"Uzbekistan","value":"UZ"},{"label":"Vanuatu","value":"VU"},{"label":"Venezuela (Bolivarian Republic of)","value":"VE"},{"label":"Viet Nam","value":"VN"},{"label":"Wallis and Futuna","value":"WF"},{"label":"Western Sahara","value":"EH"},{"label":"Yemen","value":"YE"},{"label":"Zambia","value":"ZM"},{"label":"Zimbabwe","value":"ZW"}];

/***/ }),
/* 1123 */
/***/ (function(module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react__ = __webpack_require__(0);
/* harmony import */ var __WEBPACK_IMPORTED_MODULE_0_react___default = __webpack_require__.n(__WEBPACK_IMPORTED_MODULE_0_react__);
var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}var index=function(_Component){_inherits(index,_Component);function index(){var _ref;var _temp,_this,_ret;_classCallCheck(this,index);for(var _len=arguments.length,args=Array(_len),_key=0;_key<_len;_key++){args[_key]=arguments[_key];}return _ret=(_temp=(_this=_possibleConstructorReturn(this,(_ref=index.__proto__||Object.getPrototypeOf(index)).call.apply(_ref,[this].concat(args))),_this),_this.state={},_this.componentDidMount=function(){},_temp),_possibleConstructorReturn(_this,_ret);}_createClass(index,[{key:"render",value:function render(){return __WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("div",{className:"notfound-container"},__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("h1",null,"404"),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("p",null,"Sorry, the page you have requested does not exist.",__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("br",null),"Please check you have entered the correct URL."),__WEBPACK_IMPORTED_MODULE_0_react___default.a.createElement("a",{href:"/"},"BACK TO HOMEPAGE"));}}]);return index;}(__WEBPACK_IMPORTED_MODULE_0_react__["Component"]);/* harmony default export */ __webpack_exports__["a"] = (index);

/***/ }),
/* 1124 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })
/******/ ]);


// WEBPACK FOOTER //
// static/js/main.70a52369.js